/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		3: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = "text/javascript";
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "" + ({"0":"home","1":"infringements-dashboard","2":"publish-article"}[chunkId]||chunkId) + "." + {"0":"cd2d516a8e1d9fd20193","1":"afa051283d999fdfe3b0","2":"63d17e94b1d72c2f7c88"}[chunkId] + ".bundle.js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/v1.2.16/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 377);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(7);
var core = __webpack_require__(33);
var hide = __webpack_require__(21);
var redefine = __webpack_require__(22);
var ctx = __webpack_require__(34);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(582);
module.exports = angular;


/***/ }),
/* 2 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function() {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		var result = [];
		for(var i = 0; i < this.length; i++) {
			var item = this[i];
			if(item[2]) {
				result.push("@media " + item[2] + "{" + item[1] + "}");
			} else {
				result.push(item[1]);
			}
		}
		return result.join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};


/***/ }),
/* 3 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
var stylesInDom = {},
	memoize = function(fn) {
		var memo;
		return function () {
			if (typeof memo === "undefined") memo = fn.apply(this, arguments);
			return memo;
		};
	},
	isOldIE = memoize(function() {
		return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
	}),
	getHeadElement = memoize(function () {
		return document.head || document.getElementsByTagName("head")[0];
	}),
	singletonElement = null,
	singletonCounter = 0;

module.exports = function(list, options) {
	if(typeof DEBUG !== "undefined" && DEBUG) {
		if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};
	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (typeof options.singleton === "undefined") options.singleton = isOldIE();

	var styles = listToStyles(list);
	addStylesToDom(styles, options);

	return function update(newList) {
		var mayRemove = [];
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			domStyle.refs--;
			mayRemove.push(domStyle);
		}
		if(newList) {
			var newStyles = listToStyles(newList);
			addStylesToDom(newStyles, options);
		}
		for(var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];
			if(domStyle.refs === 0) {
				for(var j = 0; j < domStyle.parts.length; j++)
					domStyle.parts[j]();
				delete stylesInDom[domStyle.id];
			}
		}
	};
}

function addStylesToDom(styles, options) {
	for(var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];
		if(domStyle) {
			domStyle.refs++;
			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}
			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];
			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}
			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles(list) {
	var styles = [];
	var newStyles = {};
	for(var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};
		if(!newStyles[id])
			styles.push(newStyles[id] = {id: id, parts: [part]});
		else
			newStyles[id].parts.push(part);
	}
	return styles;
}

function createStyleElement() {
	var styleElement = document.createElement("style");
	var head = getHeadElement();
	styleElement.type = "text/css";
	head.appendChild(styleElement);
	return styleElement;
}

function createLinkElement() {
	var linkElement = document.createElement("link");
	var head = getHeadElement();
	linkElement.rel = "stylesheet";
	head.appendChild(linkElement);
	return linkElement;
}

function addStyle(obj, options) {
	var styleElement, update, remove;

	if (options.singleton) {
		var styleIndex = singletonCounter++;
		styleElement = singletonElement || (singletonElement = createStyleElement());
		update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
		remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
	} else if(obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function") {
		styleElement = createLinkElement();
		update = updateLink.bind(null, styleElement);
		remove = function() {
			styleElement.parentNode.removeChild(styleElement);
			if(styleElement.href)
				URL.revokeObjectURL(styleElement.href);
		};
	} else {
		styleElement = createStyleElement();
		update = applyToTag.bind(null, styleElement);
		remove = function() {
			styleElement.parentNode.removeChild(styleElement);
		};
	}

	update(obj);

	return function updateStyle(newObj) {
		if(newObj) {
			if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
				return;
			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;
		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag(styleElement, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (styleElement.styleSheet) {
		styleElement.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = styleElement.childNodes;
		if (childNodes[index]) styleElement.removeChild(childNodes[index]);
		if (childNodes.length) {
			styleElement.insertBefore(cssNode, childNodes[index]);
		} else {
			styleElement.appendChild(cssNode);
		}
	}
}

function applyToTag(styleElement, obj) {
	var css = obj.css;
	var media = obj.media;
	var sourceMap = obj.sourceMap;

	if(media) {
		styleElement.setAttribute("media", media)
	}

	if(styleElement.styleSheet) {
		styleElement.styleSheet.cssText = css;
	} else {
		while(styleElement.firstChild) {
			styleElement.removeChild(styleElement.firstChild);
		}
		styleElement.appendChild(document.createTextNode(css));
	}
}

function updateLink(linkElement, obj) {
	var css = obj.css;
	var media = obj.media;
	var sourceMap = obj.sourceMap;

	if(sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = linkElement.href;

	linkElement.href = URL.createObjectURL(blob);

	if(oldSrc)
		URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(616);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(11);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 7 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Random utility functions used in the UI-Router code
 *
 * These functions are exported, but are subject to change without notice.
 *
 * @preferred
 * @module common
 */ /** for typedoc */

var predicates_1 = __webpack_require__(13);
var hof_1 = __webpack_require__(14);
var coreservices_1 = __webpack_require__(20);
var w = typeof window === 'undefined' ? {} : window;
var angular = w.angular || {};
exports.fromJson = angular.fromJson || JSON.parse.bind(JSON);
exports.toJson = angular.toJson || JSON.stringify.bind(JSON);
exports.copy = angular.copy || _copy;
exports.forEach = angular.forEach || _forEach;
exports.extend = angular.extend || _extend;
exports.equals = angular.equals || _equals;
exports.identity = function (x) { return x; };
exports.noop = function () { return undefined; };
/**
 * Builds proxy functions on the `to` object which pass through to the `from` object.
 *
 * For each key in `fnNames`, creates a proxy function on the `to` object.
 * The proxy function calls the real function on the `from` object.
 *
 *
 * #### Example:
 * This example creates an new class instance whose functions are prebound to the new'd object.
 * ```js
 * class Foo {
 *   constructor(data) {
 *     // Binds all functions from Foo.prototype to 'this',
 *     // then copies them to 'this'
 *     bindFunctions(Foo.prototype, this, this);
 *     this.data = data;
 *   }
 *
 *   log() {
 *     console.log(this.data);
 *   }
 * }
 *
 * let myFoo = new Foo([1,2,3]);
 * var logit = myFoo.log;
 * logit(); // logs [1, 2, 3] from the myFoo 'this' instance
 * ```
 *
 * #### Example:
 * This example creates a bound version of a service function, and copies it to another object
 * ```
 *
 * var SomeService = {
 *   this.data = [3, 4, 5];
 *   this.log = function() {
 *     console.log(this.data);
 *   }
 * }
 *
 * // Constructor fn
 * function OtherThing() {
 *   // Binds all functions from SomeService to SomeService,
 *   // then copies them to 'this'
 *   bindFunctions(SomeService, this, SomeService);
 * }
 *
 * let myOtherThing = new OtherThing();
 * myOtherThing.log(); // logs [3, 4, 5] from SomeService's 'this'
 * ```
 *
 * @param source A function that returns the source object which contains the original functions to be bound
 * @param target A function that returns the target object which will receive the bound functions
 * @param bind A function that returns the object which the functions will be bound to
 * @param fnNames The function names which will be bound (Defaults to all the functions found on the 'from' object)
 * @param latebind If true, the binding of the function is delayed until the first time it's invoked
 */
function createProxyFunctions(source, target, bind, fnNames, latebind) {
    if (latebind === void 0) { latebind = false; }
    var bindFunction = function (fnName) {
        return source()[fnName].bind(bind());
    };
    var makeLateRebindFn = function (fnName) { return function lateRebindFunction() {
        target[fnName] = bindFunction(fnName);
        return target[fnName].apply(null, arguments);
    }; };
    fnNames = fnNames || Object.keys(source());
    return fnNames.reduce(function (acc, name) {
        acc[name] = latebind ? makeLateRebindFn(name) : bindFunction(name);
        return acc;
    }, target);
}
exports.createProxyFunctions = createProxyFunctions;
/**
 * prototypal inheritance helper.
 * Creates a new object which has `parent` object as its prototype, and then copies the properties from `extra` onto it
 */
exports.inherit = function (parent, extra) {
    return exports.extend(new (exports.extend(function () { }, { prototype: parent }))(), extra);
};
/**
 * Given an arguments object, converts the arguments at index idx and above to an array.
 * This is similar to es6 rest parameters.
 *
 * Optionally, the argument at index idx may itself already be an array.
 *
 * For example,
 * given either:
 *        arguments = [ obj, "foo", "bar" ]
 * or:
 *        arguments = [ obj, ["foo", "bar"] ]
 * then:
 *        restArgs(arguments, 1) == ["foo", "bar"]
 *
 * This allows functions like pick() to be implemented such that it allows either a bunch
 * of string arguments (like es6 rest parameters), or a single array of strings:
 *
 * given:
 *        var obj = { foo: 1, bar: 2, baz: 3 };
 * then:
 *        pick(obj, "foo", "bar");   // returns { foo: 1, bar: 2 }
 *        pick(obj, ["foo", "bar"]); // returns { foo: 1, bar: 2 }
 */
var restArgs = function (args, idx) {
    if (idx === void 0) { idx = 0; }
    return Array.prototype.concat.apply(Array.prototype, Array.prototype.slice.call(args, idx));
};
/** Given an array, returns true if the object is found in the array, (using indexOf) */
exports.inArray = hof_1.curry(_inArray);
function _inArray(array, obj) {
    return array.indexOf(obj) !== -1;
}
exports._inArray = _inArray;
/**
 * Given an array, and an item, if the item is found in the array, it removes it (in-place).
 * The same array is returned
 */
exports.removeFrom = hof_1.curry(_removeFrom);
function _removeFrom(array, obj) {
    var idx = array.indexOf(obj);
    if (idx >= 0)
        array.splice(idx, 1);
    return array;
}
exports._removeFrom = _removeFrom;
/** pushes a values to an array and returns the value */
exports.pushTo = hof_1.curry(_pushTo);
function _pushTo(arr, val) {
    return (arr.push(val), val);
}
exports._pushTo = _pushTo;
/** Given an array of (deregistration) functions, calls all functions and removes each one from the source array */
exports.deregAll = function (functions) {
    return functions.slice().forEach(function (fn) {
        typeof fn === 'function' && fn();
        exports.removeFrom(functions, fn);
    });
};
/**
 * Applies a set of defaults to an options object.  The options object is filtered
 * to only those properties of the objects in the defaultsList.
 * Earlier objects in the defaultsList take precedence when applying defaults.
 */
function defaults(opts) {
    if (opts === void 0) { opts = {}; }
    var defaultsList = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        defaultsList[_i - 1] = arguments[_i];
    }
    var defaults = merge.apply(null, [{}].concat(defaultsList));
    return exports.extend({}, defaults, pick(opts || {}, Object.keys(defaults)));
}
exports.defaults = defaults;
/**
 * Merges properties from the list of objects to the destination object.
 * If a property already exists in the destination object, then it is not overwritten.
 */
function merge(dst) {
    var objs = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        objs[_i - 1] = arguments[_i];
    }
    exports.forEach(objs, function (obj) {
        exports.forEach(obj, function (value, key) {
            if (!dst.hasOwnProperty(key))
                dst[key] = value;
        });
    });
    return dst;
}
exports.merge = merge;
/** Reduce function that merges each element of the list into a single object, using extend */
exports.mergeR = function (memo, item) { return exports.extend(memo, item); };
/**
 * Finds the common ancestor path between two states.
 *
 * @param {Object} first The first state.
 * @param {Object} second The second state.
 * @return {Array} Returns an array of state names in descending order, not including the root.
 */
function ancestors(first, second) {
    var path = [];
    for (var n in first.path) {
        if (first.path[n] !== second.path[n])
            break;
        path.push(first.path[n]);
    }
    return path;
}
exports.ancestors = ancestors;
function pickOmitImpl(predicate, obj) {
    var keys = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        keys[_i - 2] = arguments[_i];
    }
    var objCopy = {};
    for (var key in obj) {
        if (predicate(keys, key))
            objCopy[key] = obj[key];
    }
    return objCopy;
}
/** Return a copy of the object only containing the whitelisted properties. */
function pick(obj) {
    return pickOmitImpl.apply(null, [exports.inArray].concat(restArgs(arguments)));
}
exports.pick = pick;
/** Return a copy of the object omitting the blacklisted properties. */
function omit(obj) {
    var notInArray = function (array, item) { return !exports.inArray(array, item); };
    return pickOmitImpl.apply(null, [notInArray].concat(restArgs(arguments)));
}
exports.omit = omit;
/**
 * Maps an array, or object to a property (by name)
 */
function pluck(collection, propName) {
    return map(collection, hof_1.prop(propName));
}
exports.pluck = pluck;
/** Filters an Array or an Object's properties based on a predicate */
function filter(collection, callback) {
    var arr = predicates_1.isArray(collection), result = arr ? [] : {};
    var accept = arr ? function (x) { return result.push(x); } : function (x, key) { return result[key] = x; };
    exports.forEach(collection, function (item, i) {
        if (callback(item, i))
            accept(item, i);
    });
    return result;
}
exports.filter = filter;
/** Finds an object from an array, or a property of an object, that matches a predicate */
function find(collection, callback) {
    var result;
    exports.forEach(collection, function (item, i) {
        if (result)
            return;
        if (callback(item, i))
            result = item;
    });
    return result;
}
exports.find = find;
/** Given an object, returns a new object, where each property is transformed by the callback function */
exports.mapObj = map;
/** Maps an array or object properties using a callback function */
function map(collection, callback) {
    var result = predicates_1.isArray(collection) ? [] : {};
    exports.forEach(collection, function (item, i) { return result[i] = callback(item, i); });
    return result;
}
exports.map = map;
/**
 * Given an object, return its enumerable property values
 *
 * @example
 * ```
 *
 * let foo = { a: 1, b: 2, c: 3 }
 * let vals = values(foo); // [ 1, 2, 3 ]
 * ```
 */
exports.values = function (obj) {
    return Object.keys(obj).map(function (key) { return obj[key]; });
};
/**
 * Reduce function that returns true if all of the values are truthy.
 *
 * @example
 * ```
 *
 * let vals = [ 1, true, {}, "hello world"];
 * vals.reduce(allTrueR, true); // true
 *
 * vals.push(0);
 * vals.reduce(allTrueR, true); // false
 * ```
 */
exports.allTrueR = function (memo, elem) { return memo && elem; };
/**
 * Reduce function that returns true if any of the values are truthy.
 *
 *  * @example
 * ```
 *
 * let vals = [ 0, null, undefined ];
 * vals.reduce(anyTrueR, true); // false
 *
 * vals.push("hello world");
 * vals.reduce(anyTrueR, true); // true
 * ```
 */
exports.anyTrueR = function (memo, elem) { return memo || elem; };
/**
 * Reduce function which un-nests a single level of arrays
 * @example
 * ```
 *
 * let input = [ [ "a", "b" ], [ "c", "d" ], [ [ "double", "nested" ] ] ];
 * input.reduce(unnestR, []) // [ "a", "b", "c", "d", [ "double, "nested" ] ]
 * ```
 */
exports.unnestR = function (memo, elem) { return memo.concat(elem); };
/**
 * Reduce function which recursively un-nests all arrays
 *
 * @example
 * ```
 *
 * let input = [ [ "a", "b" ], [ "c", "d" ], [ [ "double", "nested" ] ] ];
 * input.reduce(unnestR, []) // [ "a", "b", "c", "d", "double, "nested" ]
 * ```
 */
exports.flattenR = function (memo, elem) {
    return predicates_1.isArray(elem) ? memo.concat(elem.reduce(exports.flattenR, [])) : pushR(memo, elem);
};
/**
 * Reduce function that pushes an object to an array, then returns the array.
 * Mostly just for [[flattenR]] and [[uniqR]]
 */
function pushR(arr, obj) {
    arr.push(obj);
    return arr;
}
exports.pushR = pushR;
/** Reduce function that filters out duplicates */
exports.uniqR = function (acc, token) {
    return exports.inArray(acc, token) ? acc : pushR(acc, token);
};
/**
 * Return a new array with a single level of arrays unnested.
 *
 * @example
 * ```
 *
 * let input = [ [ "a", "b" ], [ "c", "d" ], [ [ "double", "nested" ] ] ];
 * unnest(input) // [ "a", "b", "c", "d", [ "double, "nested" ] ]
 * ```
 */
exports.unnest = function (arr) { return arr.reduce(exports.unnestR, []); };
/**
 * Return a completely flattened version of an array.
 *
 * @example
 * ```
 *
 * let input = [ [ "a", "b" ], [ "c", "d" ], [ [ "double", "nested" ] ] ];
 * flatten(input) // [ "a", "b", "c", "d", "double, "nested" ]
 * ```
 */
exports.flatten = function (arr) { return arr.reduce(exports.flattenR, []); };
/**
 * Given a .filter Predicate, builds a .filter Predicate which throws an error if any elements do not pass.
 * @example
 * ```
 *
 * let isNumber = (obj) => typeof(obj) === 'number';
 * let allNumbers = [ 1, 2, 3, 4, 5 ];
 * allNumbers.filter(assertPredicate(isNumber)); //OK
 *
 * let oneString = [ 1, 2, 3, 4, "5" ];
 * oneString.filter(assertPredicate(isNumber, "Not all numbers")); // throws Error(""Not all numbers"");
 * ```
 */
exports.assertPredicate = assertFn;
/**
 * Given a .map function, builds a .map function which throws an error if any mapped elements do not pass a truthyness test.
 * @example
 * ```
 *
 * var data = { foo: 1, bar: 2 };
 *
 * let keys = [ 'foo', 'bar' ]
 * let values = keys.map(assertMap(key => data[key], "Key not found"));
 * // values is [1, 2]
 *
 * let keys = [ 'foo', 'bar', 'baz' ]
 * let values = keys.map(assertMap(key => data[key], "Key not found"));
 * // throws Error("Key not found")
 * ```
 */
exports.assertMap = assertFn;
function assertFn(predicateOrMap, errMsg) {
    if (errMsg === void 0) { errMsg = "assert failure"; }
    return function (obj) {
        var result = predicateOrMap(obj);
        if (!result) {
            throw new Error(predicates_1.isFunction(errMsg) ? errMsg(obj) : errMsg);
        }
        return result;
    };
}
exports.assertFn = assertFn;
/**
 * Like _.pairs: Given an object, returns an array of key/value pairs
 *
 * @example
 * ```
 *
 * pairs({ foo: "FOO", bar: "BAR }) // [ [ "foo", "FOO" ], [ "bar": "BAR" ] ]
 * ```
 */
exports.pairs = function (obj) {
    return Object.keys(obj).map(function (key) { return [key, obj[key]]; });
};
/**
 * Given two or more parallel arrays, returns an array of tuples where
 * each tuple is composed of [ a[i], b[i], ... z[i] ]
 *
 * @example
 * ```
 *
 * let foo = [ 0, 2, 4, 6 ];
 * let bar = [ 1, 3, 5, 7 ];
 * let baz = [ 10, 30, 50, 70 ];
 * arrayTuples(foo, bar);       // [ [0, 1], [2, 3], [4, 5], [6, 7] ]
 * arrayTuples(foo, bar, baz);  // [ [0, 1, 10], [2, 3, 30], [4, 5, 50], [6, 7, 70] ]
 * ```
 */
function arrayTuples() {
    var arrayArgs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        arrayArgs[_i] = arguments[_i];
    }
    if (arrayArgs.length === 0)
        return [];
    var length = arrayArgs.reduce(function (min, arr) { return Math.min(arr.length, min); }, 9007199254740991); // aka 2^53 − 1 aka Number.MAX_SAFE_INTEGER
    return Array.apply(null, Array(length)).map(function (ignored, idx) { return arrayArgs.map(function (arr) { return arr[idx]; }); });
}
exports.arrayTuples = arrayTuples;
/**
 * Reduce function which builds an object from an array of [key, value] pairs.
 *
 * Each iteration sets the key/val pair on the memo object, then returns the memo for the next iteration.
 *
 * Each keyValueTuple should be an array with values [ key: string, value: any ]
 *
 * @example
 * ```
 *
 * var pairs = [ ["fookey", "fooval"], ["barkey", "barval"] ]
 *
 * var pairsToObj = pairs.reduce((memo, pair) => applyPairs(memo, pair), {})
 * // pairsToObj == { fookey: "fooval", barkey: "barval" }
 *
 * // Or, more simply:
 * var pairsToObj = pairs.reduce(applyPairs, {})
 * // pairsToObj == { fookey: "fooval", barkey: "barval" }
 * ```
 */
function applyPairs(memo, keyValTuple) {
    var key, value;
    if (predicates_1.isArray(keyValTuple))
        key = keyValTuple[0], value = keyValTuple[1];
    if (!predicates_1.isString(key))
        throw new Error("invalid parameters to applyPairs");
    memo[key] = value;
    return memo;
}
exports.applyPairs = applyPairs;
/** Get the last element of an array */
function tail(arr) {
    return arr.length && arr[arr.length - 1] || undefined;
}
exports.tail = tail;
/**
 * shallow copy from src to dest
 *
 * note: This is a shallow copy, while angular.copy is a deep copy.
 * ui-router uses `copy` only to make copies of state parameters.
 */
function _copy(src, dest) {
    if (dest)
        Object.keys(dest).forEach(function (key) { return delete dest[key]; });
    if (!dest)
        dest = {};
    return exports.extend(dest, src);
}
/** Naive forEach implementation works with Objects or Arrays */
function _forEach(obj, cb, _this) {
    if (predicates_1.isArray(obj))
        return obj.forEach(cb, _this);
    Object.keys(obj).forEach(function (key) { return cb(obj[key], key); });
}
function _copyProps(to, from) {
    Object.keys(from).forEach(function (key) { return to[key] = from[key]; });
    return to;
}
function _extend(toObj) {
    return restArgs(arguments, 1).filter(exports.identity).reduce(_copyProps, toObj);
}
function _equals(o1, o2) {
    if (o1 === o2)
        return true;
    if (o1 === null || o2 === null)
        return false;
    if (o1 !== o1 && o2 !== o2)
        return true; // NaN === NaN
    var t1 = typeof o1, t2 = typeof o2;
    if (t1 !== t2 || t1 !== 'object')
        return false;
    var tup = [o1, o2];
    if (hof_1.all(predicates_1.isArray)(tup))
        return _arraysEq(o1, o2);
    if (hof_1.all(predicates_1.isDate)(tup))
        return o1.getTime() === o2.getTime();
    if (hof_1.all(predicates_1.isRegExp)(tup))
        return o1.toString() === o2.toString();
    if (hof_1.all(predicates_1.isFunction)(tup))
        return true; // meh
    var predicates = [predicates_1.isFunction, predicates_1.isArray, predicates_1.isDate, predicates_1.isRegExp];
    if (predicates.map(hof_1.any).reduce(function (b, fn) { return b || !!fn(tup); }, false))
        return false;
    var key, keys = {};
    for (key in o1) {
        if (!_equals(o1[key], o2[key]))
            return false;
        keys[key] = true;
    }
    for (key in o2) {
        if (!keys[key])
            return false;
    }
    return true;
}
function _arraysEq(a1, a2) {
    if (a1.length !== a2.length)
        return false;
    return arrayTuples(a1, a2).reduce(function (b, t) { return b && _equals(t[0], t[1]); }, true);
}
/**
 * Create a sort function
 *
 * Creates a sort function which sorts by a numeric property.
 *
 * The `propFn` should return the property as a number which can be sorted.
 *
 * #### Example:
 * This example returns the `priority` prop.
 * ```js
 * var sortfn = sortBy(obj => obj.priority)
 * // equivalent to:
 * var longhandSortFn = (a, b) => a.priority - b.priority;
 * ```
 *
 * #### Example:
 * This example uses [[prop]]
 * ```js
 * var sortfn = sortBy(prop('priority'))
 * ```
 *
 * The `checkFn` can be used to exclude objects from sorting.
 *
 * #### Example:
 * This example only sorts objects with type === 'FOO'
 * ```js
 * var sortfn = sortBy(prop('priority'), propEq('type', 'FOO'))
 * ```
 *
 * @param propFn a function that returns the property (as a number)
 * @param checkFn a predicate
 *
 * @return a sort function like: `(a, b) => (checkFn(a) && checkFn(b)) ? propFn(a) - propFn(b) : 0`
 */
exports.sortBy = function (propFn, checkFn) {
    if (checkFn === void 0) { checkFn = hof_1.val(true); }
    return function (a, b) {
        return (checkFn(a) && checkFn(b)) ? propFn(a) - propFn(b) : 0;
    };
};
/**
 * Composes a list of sort functions
 *
 * Creates a sort function composed of multiple sort functions.
 * Each sort function is invoked in series.
 * The first sort function to return non-zero "wins".
 *
 * @param sortFns list of sort functions
 */
exports.composeSort = function () {
    var sortFns = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sortFns[_i] = arguments[_i];
    }
    return function (a, b) {
        return sortFns.reduce(function (prev, fn) { return prev || fn(a, b); }, 0);
    };
};
// issue #2676
exports.silenceUncaughtInPromise = function (promise) {
    return promise.catch(function (e) { return 0; }) && promise;
};
exports.silentRejection = function (error) {
    return exports.silenceUncaughtInPromise(coreservices_1.services.$q.reject(error));
};
//# sourceMappingURL=common.js.map

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.3.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2018-01-20T17:24Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var document = window.document;

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var concat = arr.concat;

var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

      // Support: Chrome <=57, Firefox <=52
      // In some browsers, typeof returns "function" for HTML <object> elements
      // (i.e., `typeof document.createElement( "object" ) === "function"`).
      // We don't want to classify *any* DOM node as a function.
      return typeof obj === "function" && typeof obj.nodeType !== "number";
  };


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};




	var preservedScriptAttributes = {
		type: true,
		src: true,
		noModule: true
	};

	function DOMEval( code, doc, node ) {
		doc = doc || document;

		var i,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {
				if ( node[ i ] ) {
					script[ i ] = node[ i ];
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.3.1",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				src = target[ name ];
				copy = options[ name ];

				// Prevent never-ending loop
				if ( target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {

					if ( copyIsArray ) {
						copyIsArray = false;
						clone = src && Array.isArray( src ) ? src : [];

					} else {
						clone = src && jQuery.isPlainObject( src ) ? src : {};
					}

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {

		/* eslint-disable no-unused-vars */
		// See https://github.com/eslint/eslint/issues/6125
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a global context
	globalEval: function( code ) {
		DOMEval( code );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// Support: Android <=4.0 only
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
function( i, name ) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.3
 * https://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2016-08-08
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),

	rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	disabledAncestor = addCombinator(
		function( elem ) {
			return elem.disabled === true && ("form" in elem || "label" in elem);
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {

		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {

				// ID selector
				if ( (m = match[1]) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( (elem = context.getElementById( m )) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && (elem = newContext.getElementById( m )) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( (m = match[3]) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!compilerCache[ selector + " " ] &&
				(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {

				if ( nodeType !== 1 ) {
					newContext = context;
					newSelector = selector;

				// qSA looks outside Element context, which is not what we want
				// Thanks to Andrew Dupont for this workaround technique
				// Support: IE <=8
				// Exclude object elements
				} else if ( context.nodeName.toLowerCase() !== "object" ) {

					// Capture the context ID, setting it first if necessary
					if ( (nid = context.getAttribute( "id" )) ) {
						nid = nid.replace( rcssescape, fcssescape );
					} else {
						context.setAttribute( "id", (nid = expando) );
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[i] = "#" + nid + " " + toSelector( groups[i] );
					}
					newSelector = groups.join( "," );

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;
				}

				if ( newSelector ) {
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement("fieldset");

	try {
		return !!fn( el );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}
		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
						disabledAncestor( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	// documentElement is verified for cases where it doesn't yet exist
	// (such as loading iframes in IE - #4833)
	var documentElement = elem && (elem.ownerDocument || elem).documentElement;
	return documentElement ? documentElement.nodeName !== "HTML" : false;
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9-11, Edge
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	if ( preferredDoc !== document &&
		(subWindow = document.defaultView) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( el ) {
		el.className = "i";
		return !el.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( el ) {
		el.appendChild( document.createComment("") );
		return !el.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	});

	// ID filter and find
	if ( support.getById ) {
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode("id");
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( (elem = elems[i++]) ) {
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( el ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement("input");
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll(":enabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll(":disabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( el ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === document ? -1 :
				b === document ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	// Make sure that attribute selectors are quoted
	expr = expr.replace( rattributeQuotes, "='$1']" );

	if ( support.matchesSelector && documentIsHTML &&
		!compilerCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return (sel + "").replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || (node[ expando ] = {});

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								(outerCache[ node.uniqueID ] = {});

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {
							// Use previously-cached element index if available
							if ( useCache ) {
								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || (node[ expando ] = {});

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] || (node[ expando ] = {});

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												(outerCache[ node.uniqueID ] = {});

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( (oldCache = uniqueCache[ key ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context === document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					if ( !context && elem.ownerDocument !== document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context || document, xml) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( el ) {
	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( el ) {
	return el.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

return Sizzle;

})( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;



function nodeName( elem, name ) {

  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

};
var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
        if ( nodeName( elem, "iframe" ) ) {
            return elem.contentDocument;
        }

        // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
        // Treat the template element as a regular one in browsers that
        // don't support it.
        if ( nodeName( elem, "template" ) ) {
            elem = elem.content || elem;
        }

        return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the master Deferred
			master = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						master.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( master.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return master.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
		}

		return master.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
					value :
					value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (#9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			jQuery.contains( elem.ownerDocument, elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};

var swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};




function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]+)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// Support: IE <=9 only
	option: [ 1, "<select multiple='multiple'>", "</select>" ],

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

// Support: IE <=9 only
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, contains, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		contains = jQuery.contains( elem.ownerDocument, elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( contains ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
} )();
var documentElement = document.documentElement;



var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 only
// See #13393 for more info
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = {};
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		// Make a writable jQuery.Event from the native event object
		var event = jQuery.event.fix( nativeEvent );

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),
			handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// Triggered event must either 1) have no namespace, or 2) have namespace(s)
				// a subset or equal to those in the bound event (both can have no namespace).
				if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
							return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
							return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		focus: {

			// Fire native event if possible so blur/focus sequence is correct
			trigger: function() {
				if ( this !== safeActiveElement() && this.focus ) {
					this.focus();
					return false;
				}
			},
			delegateType: "focusin"
		},
		blur: {
			trigger: function() {
				if ( this === safeActiveElement() && this.blur ) {
					this.blur();
					return false;
				}
			},
			delegateType: "focusout"
		},
		click: {

			// For checkbox, fire native event so checked state will be right
			trigger: function() {
				if ( this.type === "checkbox" && this.click && nodeName( this, "input" ) ) {
					this.click();
					return false;
				}
			},

			// For cross-browser consistency, don't fire native .click() on links
			_default: function( event ) {
				return nodeName( event.target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (#504, #13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,

	which: function( event ) {
		var button = event.button;

		// Add which for key events
		if ( event.which == null && rkeyEvent.test( event.type ) ) {
			return event.charCode != null ? event.charCode : event.keyCode;
		}

		// Add which for click: 1 === left; 2 === middle; 3 === right
		if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
			if ( button & 1 ) {
				return 1;
			}

			if ( button & 2 ) {
				return 3;
			}

			if ( button & 4 ) {
				return 2;
			}

			return 0;
		}

		return event.which;
	}
}, jQuery.event.addProp );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	/* eslint-disable max-len */

	// See https://github.com/eslint/eslint/issues/3229
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,

	/* eslint-enable */

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.access( src );
		pdataCur = dataPriv.set( dest, pdataOld );
		events = pdataOld.events;

		if ( events ) {
			delete pdataCur.handle;
			pdataCur.events = {};

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = concat.apply( [], args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl ) {
								jQuery._evalUrl( node.src );
							}
						} else {
							DOMEval( node.textContent.replace( rcleanScript, "" ), doc, node );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html.replace( rxhtmlTag, "<$1></$2>" );
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = jQuery.contains( elem.ownerDocument, elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		div.style.position = "absolute";
		scrollboxSizeVal = div.offsetWidth === 36 || "absolute";

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, #12537)
	//   .css('--customProperty) (#3144)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rcustomProp = /^--/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	},

	cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style;

// Return a css property mapped to a potentially vendor prefixed property
function vendorPropName( name ) {

	// Shortcut for names that are not vendor prefixed
	if ( name in emptyStyle ) {
		return name;
	}

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a property mapped along what jQuery.cssProps suggests or to
// a vendor prefixed property.
function finalPropName( name ) {
	var ret = jQuery.cssProps[ name ];
	if ( !ret ) {
		ret = jQuery.cssProps[ name ] = vendorPropName( name ) || name;
	}
	return ret;
}

function setPositiveNumber( elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		if ( box === "margin" ) {
			delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5
		) );
	}

	return delta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),
		val = curCSS( elem, dimension, styles ),
		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox;

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}

	// Check for style in case a browser which returns unreliable values
	// for getComputedStyle silently falls back to the reliable elem.style
	valueIsBorderBox = valueIsBorderBox &&
		( support.boxSizingReliable() || val === elem.style[ dimension ] );

	// Fall back to offsetWidth/offsetHeight when value is "auto"
	// This happens for inline elements with no explicit setting (gh-3571)
	// Support: Android <=4.1 - 4.3 only
	// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
	if ( val === "auto" ||
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) {

		val = elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ];

		// offsetWidth/offsetHeight provide border-box values
		valueIsBorderBox = true;
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			if ( type === "number" ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, dimension, extra );
						} ) :
						getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),
				isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra && boxModelAdjustment(
					elem,
					dimension,
					extra,
					isBorderBox,
					styles
				);

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && support.scrollboxSize() === styles.position ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
				) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 &&
				( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
					jQuery.cssHooks[ tween.prop ] ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

			/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( isValidValue ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = classesToArray( value );

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
						"" :
						dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


support.focusin = "onfocusin" in window;


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = Date.now();

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} )
		.filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} )
		.map( function( i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );
	originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
							}
						}
						match = responseHeaders[ key.toLowerCase() ];
					}
					return match == null ? null : match;
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );


jQuery._evalUrl = function( url ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,
		"throws": true
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain requests
	if ( s.crossDomain ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" ).prop( {
					charset: s.scriptCharset,
					src: s.url
				} ).on(
					"load error",
					callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					}
				);

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




// Attach a bunch of functions for handling common AJAX events
jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
} );

jQuery.fn.extend( {
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	}
} );

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
		return jQuery;
	}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( !noGlobal ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );


/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(89)('wks');
var uid = __webpack_require__(53);
var Symbol = __webpack_require__(7).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/** Predicates
 *
 * These predicates return true/false based on the input.
 * Although these functions are exported, they are subject to change without notice.
 *
 * @module common_predicates
 */ /** */
var hof_1 = __webpack_require__(14);
var toStr = Object.prototype.toString;
var tis = function (t) { return function (x) { return typeof (x) === t; }; };
exports.isUndefined = tis('undefined');
exports.isDefined = hof_1.not(exports.isUndefined);
exports.isNull = function (o) { return o === null; };
exports.isNullOrUndefined = hof_1.or(exports.isNull, exports.isUndefined);
exports.isFunction = tis('function');
exports.isNumber = tis('number');
exports.isString = tis('string');
exports.isObject = function (x) { return x !== null && typeof x === 'object'; };
exports.isArray = Array.isArray;
exports.isDate = (function (x) { return toStr.call(x) === '[object Date]'; });
exports.isRegExp = (function (x) { return toStr.call(x) === '[object RegExp]'; });
/**
 * Predicate which checks if a value is injectable
 *
 * A value is "injectable" if it is a function, or if it is an ng1 array-notation-style array
 * where all the elements in the array are Strings, except the last one, which is a Function
 */
function isInjectable(val) {
    if (exports.isArray(val) && val.length) {
        var head = val.slice(0, -1), tail = val.slice(-1);
        return !(head.filter(hof_1.not(exports.isString)).length || tail.filter(hof_1.not(exports.isFunction)).length);
    }
    return exports.isFunction(val);
}
exports.isInjectable = isInjectable;
/**
 * Predicate which checks if a value looks like a Promise
 *
 * It is probably a Promise if it's an object, and it has a `then` property which is a Function
 */
exports.isPromise = hof_1.and(exports.isObject, hof_1.pipe(hof_1.prop('then'), exports.isFunction));
//# sourceMappingURL=predicates.js.map

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Higher order functions
 *
 * These utility functions are exported, but are subject to change without notice.
 *
 * @module common_hof
 */ /** */

/**
 * Returns a new function for [Partial Application](https://en.wikipedia.org/wiki/Partial_application) of the original function.
 *
 * Given a function with N parameters, returns a new function that supports partial application.
 * The new function accepts anywhere from 1 to N parameters.  When that function is called with M parameters,
 * where M is less than N, it returns a new function that accepts the remaining parameters.  It continues to
 * accept more parameters until all N parameters have been supplied.
 *
 *
 * This contrived example uses a partially applied function as an predicate, which returns true
 * if an object is found in both arrays.
 * @example
 * ```
 * // returns true if an object is in both of the two arrays
 * function inBoth(array1, array2, object) {
 *   return array1.indexOf(object) !== -1 &&
 *          array2.indexOf(object) !== 1;
 * }
 * let obj1, obj2, obj3, obj4, obj5, obj6, obj7
 * let foos = [obj1, obj3]
 * let bars = [obj3, obj4, obj5]
 *
 * // A curried "copy" of inBoth
 * let curriedInBoth = curry(inBoth);
 * // Partially apply both the array1 and array2
 * let inFoosAndBars = curriedInBoth(foos, bars);
 *
 * // Supply the final argument; since all arguments are
 * // supplied, the original inBoth function is then called.
 * let obj1InBoth = inFoosAndBars(obj1); // false
 *
 * // Use the inFoosAndBars as a predicate.
 * // Filter, on each iteration, supplies the final argument
 * let allObjs = [ obj1, obj2, obj3, obj4, obj5, obj6, obj7 ];
 * let foundInBoth = allObjs.filter(inFoosAndBars); // [ obj3 ]
 *
 * ```
 *
 * Stolen from: http://stackoverflow.com/questions/4394747/javascript-curry-function
 *
 * @param fn
 * @returns {*|function(): (*|any)}
 */
function curry(fn) {
    var initial_args = [].slice.apply(arguments, [1]);
    var func_args_length = fn.length;
    function curried(args) {
        if (args.length >= func_args_length)
            return fn.apply(null, args);
        return function () {
            return curried(args.concat([].slice.apply(arguments)));
        };
    }
    return curried(initial_args);
}
exports.curry = curry;
/**
 * Given a varargs list of functions, returns a function that composes the argument functions, right-to-left
 * given: f(x), g(x), h(x)
 * let composed = compose(f,g,h)
 * then, composed is: f(g(h(x)))
 */
function compose() {
    var args = arguments;
    var start = args.length - 1;
    return function () {
        var i = start, result = args[start].apply(this, arguments);
        while (i--)
            result = args[i].call(this, result);
        return result;
    };
}
exports.compose = compose;
/**
 * Given a varargs list of functions, returns a function that is composes the argument functions, left-to-right
 * given: f(x), g(x), h(x)
 * let piped = pipe(f,g,h);
 * then, piped is: h(g(f(x)))
 */
function pipe() {
    var funcs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        funcs[_i] = arguments[_i];
    }
    return compose.apply(null, [].slice.call(arguments).reverse());
}
exports.pipe = pipe;
/**
 * Given a property name, returns a function that returns that property from an object
 * let obj = { foo: 1, name: "blarg" };
 * let getName = prop("name");
 * getName(obj) === "blarg"
 */
exports.prop = function (name) {
    return function (obj) { return obj && obj[name]; };
};
/**
 * Given a property name and a value, returns a function that returns a boolean based on whether
 * the passed object has a property that matches the value
 * let obj = { foo: 1, name: "blarg" };
 * let getName = propEq("name", "blarg");
 * getName(obj) === true
 */
exports.propEq = curry(function (name, val, obj) { return obj && obj[name] === val; });
/**
 * Given a dotted property name, returns a function that returns a nested property from an object, or undefined
 * let obj = { id: 1, nestedObj: { foo: 1, name: "blarg" }, };
 * let getName = prop("nestedObj.name");
 * getName(obj) === "blarg"
 * let propNotFound = prop("this.property.doesnt.exist");
 * propNotFound(obj) === undefined
 */
exports.parse = function (name) {
    return pipe.apply(null, name.split(".").map(exports.prop));
};
/**
 * Given a function that returns a truthy or falsey value, returns a
 * function that returns the opposite (falsey or truthy) value given the same inputs
 */
exports.not = function (fn) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return !fn.apply(null, args);
    };
};
/**
 * Given two functions that return truthy or falsey values, returns a function that returns truthy
 * if both functions return truthy for the given arguments
 */
function and(fn1, fn2) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return fn1.apply(null, args) && fn2.apply(null, args);
    };
}
exports.and = and;
/**
 * Given two functions that return truthy or falsey values, returns a function that returns truthy
 * if at least one of the functions returns truthy for the given arguments
 */
function or(fn1, fn2) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return fn1.apply(null, args) || fn2.apply(null, args);
    };
}
exports.or = or;
/**
 * Check if all the elements of an array match a predicate function
 *
 * @param fn1 a predicate function `fn1`
 * @returns a function which takes an array and returns true if `fn1` is true for all elements of the array
 */
exports.all = function (fn1) {
    return function (arr) { return arr.reduce(function (b, x) { return b && !!fn1(x); }, true); };
};
exports.any = function (fn1) {
    return function (arr) { return arr.reduce(function (b, x) { return b || !!fn1(x); }, false); };
};
/** Given a class, returns a Predicate function that returns true if the object is of that class */
exports.is = function (ctor) {
    return function (obj) {
        return (obj != null && obj.constructor === ctor || obj instanceof ctor);
    };
};
/** Given a value, returns a Predicate function that returns true if another value is === equal to the original value */
exports.eq = function (val) { return function (other) {
    return val === other;
}; };
/** Given a value, returns a function which returns the value */
exports.val = function (v) { return function () { return v; }; };
function invoke(fnName, args) {
    return function (obj) {
        return obj[fnName].apply(obj, args);
    };
}
exports.invoke = invoke;
/**
 * Sorta like Pattern Matching (a functional programming conditional construct)
 *
 * See http://c2.com/cgi/wiki?PatternMatching
 *
 * This is a conditional construct which allows a series of predicates and output functions
 * to be checked and then applied.  Each predicate receives the input.  If the predicate
 * returns truthy, then its matching output function (mapping function) is provided with
 * the input and, then the result is returned.
 *
 * Each combination (2-tuple) of predicate + output function should be placed in an array
 * of size 2: [ predicate, mapFn ]
 *
 * These 2-tuples should be put in an outer array.
 *
 * @example
 * ```
 *
 * // Here's a 2-tuple where the first element is the isString predicate
 * // and the second element is a function that returns a description of the input
 * let firstTuple = [ angular.isString, (input) => `Heres your string ${input}` ];
 *
 * // Second tuple: predicate "isNumber", mapfn returns a description
 * let secondTuple = [ angular.isNumber, (input) => `(${input}) That's a number!` ];
 *
 * let third = [ (input) => input === null,  (input) => `Oh, null...` ];
 *
 * let fourth = [ (input) => input === undefined,  (input) => `notdefined` ];
 *
 * let descriptionOf = pattern([ firstTuple, secondTuple, third, fourth ]);
 *
 * console.log(descriptionOf(undefined)); // 'notdefined'
 * console.log(descriptionOf(55)); // '(55) That's a number!'
 * console.log(descriptionOf("foo")); // 'Here's your string foo'
 * ```
 *
 * @param struct A 2D array.  Each element of the array should be an array, a 2-tuple,
 * with a Predicate and a mapping/output function
 * @returns {function(any): *}
 */
function pattern(struct) {
    return function (x) {
        for (var i = 0; i < struct.length; i++) {
            if (struct[i][0](x))
                return struct[i][1](x);
        }
    };
}
exports.pattern = pattern;
//# sourceMappingURL=hof.js.map

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(10)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(6);
var IE8_DOM_DEFINE = __webpack_require__(184);
var toPrimitive = __webpack_require__(37);
var dP = Object.defineProperty;

exports.f = __webpack_require__(15) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(39);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(38);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.notImplemented = function (fnname) { return function () {
    throw new Error(fnname + "(): No coreservices implementation for UI-Router is loaded.");
}; };
var services = {
    $q: undefined,
    $injector: undefined,
};
exports.services = services;
//# sourceMappingURL=coreservices.js.map

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(16);
var createDesc = __webpack_require__(52);
module.exports = __webpack_require__(15) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(7);
var hide = __webpack_require__(21);
var has = __webpack_require__(26);
var SRC = __webpack_require__(53)('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(33).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var fails = __webpack_require__(10);
var defined = __webpack_require__(38);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 24 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.6' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 25 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 26 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(75);
var defined = __webpack_require__(38);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(76);
var createDesc = __webpack_require__(52);
var toIObject = __webpack_require__(27);
var toPrimitive = __webpack_require__(37);
var has = __webpack_require__(26);
var IE8_DOM_DEFINE = __webpack_require__(184);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(15) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(26);
var toObject = __webpack_require__(18);
var IE_PROTO = __webpack_require__(121)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @coreapi
 * @module common
 */ /** */

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(__webpack_require__(583));
__export(__webpack_require__(589));
__export(__webpack_require__(590));
__export(__webpack_require__(591));
__export(__webpack_require__(592));
__export(__webpack_require__(593));
__export(__webpack_require__(594));
__export(__webpack_require__(595));
__export(__webpack_require__(233));
__export(__webpack_require__(220));
__export(__webpack_require__(596));
//# sourceMappingURL=index.js.map

/***/ }),
/* 31 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(177)('wks');
var uid = __webpack_require__(167);
var Symbol = __webpack_require__(25).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 33 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.6' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(19);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 35 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(10);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(11);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 38 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 39 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(0);
var core = __webpack_require__(33);
var fails = __webpack_require__(10);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(34);
var IObject = __webpack_require__(75);
var toObject = __webpack_require__(18);
var toLength = __webpack_require__(17);
var asc = __webpack_require__(138);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "11e57e492ee0311540967cc7a1e6e3e2.png";

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(15)) {
  var LIBRARY = __webpack_require__(46);
  var global = __webpack_require__(7);
  var fails = __webpack_require__(10);
  var $export = __webpack_require__(0);
  var $typed = __webpack_require__(100);
  var $buffer = __webpack_require__(144);
  var ctx = __webpack_require__(34);
  var anInstance = __webpack_require__(59);
  var propertyDesc = __webpack_require__(52);
  var hide = __webpack_require__(21);
  var redefineAll = __webpack_require__(61);
  var toInteger = __webpack_require__(39);
  var toLength = __webpack_require__(17);
  var toIndex = __webpack_require__(210);
  var toAbsoluteIndex = __webpack_require__(55);
  var toPrimitive = __webpack_require__(37);
  var has = __webpack_require__(26);
  var classof = __webpack_require__(77);
  var isObject = __webpack_require__(11);
  var toObject = __webpack_require__(18);
  var isArrayIter = __webpack_require__(135);
  var create = __webpack_require__(56);
  var getPrototypeOf = __webpack_require__(29);
  var gOPN = __webpack_require__(57).f;
  var getIterFn = __webpack_require__(137);
  var uid = __webpack_require__(53);
  var wks = __webpack_require__(12);
  var createArrayMethod = __webpack_require__(41);
  var createArrayIncludes = __webpack_require__(90);
  var speciesConstructor = __webpack_require__(97);
  var ArrayIterators = __webpack_require__(140);
  var Iterators = __webpack_require__(67);
  var $iterDetect = __webpack_require__(94);
  var setSpecies = __webpack_require__(58);
  var arrayFill = __webpack_require__(139);
  var arrayCopyWithin = __webpack_require__(200);
  var $DP = __webpack_require__(16);
  var $GOPD = __webpack_require__(28);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var Map = __webpack_require__(205);
var $export = __webpack_require__(0);
var shared = __webpack_require__(89)('metadata');
var store = shared.store || (shared.store = new (__webpack_require__(208))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(53)('meta');
var isObject = __webpack_require__(11);
var has = __webpack_require__(26);
var setDesc = __webpack_require__(16).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(10)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(12)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(21)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Functions that manipulate strings
 *
 * Although these functions are exported, they are subject to change without notice.
 *
 * @module common_strings
 */ /** */

var predicates_1 = __webpack_require__(13);
var rejectFactory_1 = __webpack_require__(78);
var common_1 = __webpack_require__(8);
var hof_1 = __webpack_require__(14);
var transition_1 = __webpack_require__(146);
var resolvable_1 = __webpack_require__(81);
/**
 * Returns a string shortened to a maximum length
 *
 * If the string is already less than the `max` length, return the string.
 * Else return the string, shortened to `max - 3` and append three dots ("...").
 *
 * @param max the maximum length of the string to return
 * @param str the input string
 */
function maxLength(max, str) {
    if (str.length <= max)
        return str;
    return str.substr(0, max - 3) + "...";
}
exports.maxLength = maxLength;
/**
 * Returns a string, with spaces added to the end, up to a desired str length
 *
 * If the string is already longer than the desired length, return the string.
 * Else returns the string, with extra spaces on the end, such that it reaches `length` characters.
 *
 * @param length the desired length of the string to return
 * @param str the input string
 */
function padString(length, str) {
    while (str.length < length)
        str += " ";
    return str;
}
exports.padString = padString;
function kebobString(camelCase) {
    return camelCase
        .replace(/^([A-Z])/, function ($1) { return $1.toLowerCase(); }) // replace first char
        .replace(/([A-Z])/g, function ($1) { return "-" + $1.toLowerCase(); }); // replace rest
}
exports.kebobString = kebobString;
function _toJson(obj) {
    return JSON.stringify(obj);
}
function _fromJson(json) {
    return predicates_1.isString(json) ? JSON.parse(json) : json;
}
function promiseToString(p) {
    return "Promise(" + JSON.stringify(p) + ")";
}
function functionToString(fn) {
    var fnStr = fnToString(fn);
    var namedFunctionMatch = fnStr.match(/^(function [^ ]+\([^)]*\))/);
    var toStr = namedFunctionMatch ? namedFunctionMatch[1] : fnStr;
    var fnName = fn['name'] || "";
    if (fnName && toStr.match(/function \(/)) {
        return 'function ' + fnName + toStr.substr(9);
    }
    return toStr;
}
exports.functionToString = functionToString;
function fnToString(fn) {
    var _fn = predicates_1.isArray(fn) ? fn.slice(-1)[0] : fn;
    return _fn && _fn.toString() || "undefined";
}
exports.fnToString = fnToString;
var stringifyPatternFn = null;
var stringifyPattern = function (value) {
    var isTransitionRejectionPromise = rejectFactory_1.Rejection.isTransitionRejectionPromise;
    stringifyPatternFn = stringifyPatternFn || hof_1.pattern([
        [hof_1.not(predicates_1.isDefined), hof_1.val("undefined")],
        [predicates_1.isNull, hof_1.val("null")],
        [predicates_1.isPromise, hof_1.val("[Promise]")],
        [isTransitionRejectionPromise, function (x) { return x._transitionRejection.toString(); }],
        [hof_1.is(rejectFactory_1.Rejection), hof_1.invoke("toString")],
        [hof_1.is(transition_1.Transition), hof_1.invoke("toString")],
        [hof_1.is(resolvable_1.Resolvable), hof_1.invoke("toString")],
        [predicates_1.isInjectable, functionToString],
        [hof_1.val(true), common_1.identity]
    ]);
    return stringifyPatternFn(value);
};
function stringify(o) {
    var seen = [];
    function format(val) {
        if (predicates_1.isObject(val)) {
            if (seen.indexOf(val) !== -1)
                return '[circular ref]';
            seen.push(val);
        }
        return stringifyPattern(val);
    }
    return JSON.stringify(o, function (key, val) { return format(val); }).replace(/\\"/g, '"');
}
exports.stringify = stringify;
/** Returns a function that splits a string on a character or substring */
exports.beforeAfterSubstr = function (char) { return function (str) {
    if (!str)
        return ["", ""];
    var idx = str.indexOf(char);
    if (idx === -1)
        return [str, ""];
    return [str.substr(0, idx), str.substr(idx + 1)];
}; };
/**
 * Splits on a delimiter, but returns the delimiters in the array
 *
 * #### Example:
 * ```js
 * var splitOnSlashes = splitOnDelim('/');
 * splitOnSlashes("/foo"); // ["/", "foo"]
 * splitOnSlashes("/foo/"); // ["/", "foo", "/"]
 * ```
 */
function splitOnDelim(delim) {
    var re = new RegExp("(" + delim + ")", "g");
    return function (str) {
        return str.split(re).filter(common_1.identity);
    };
}
exports.splitOnDelim = splitOnDelim;
;
/**
 * Reduce fn that joins neighboring strings
 *
 * Given an array of strings, returns a new array
 * where all neighboring strings have been joined.
 *
 * #### Example:
 * ```js
 * let arr = ["foo", "bar", 1, "baz", "", "qux" ];
 * arr.reduce(joinNeighborsR, []) // ["foobar", 1, "bazqux" ]
 * ```
 */
function joinNeighborsR(acc, x) {
    if (predicates_1.isString(common_1.tail(acc)) && predicates_1.isString(x))
        return acc.slice(0, -1).concat(common_1.tail(acc) + x);
    return common_1.pushR(acc, x);
}
exports.joinNeighborsR = joinNeighborsR;
;
//# sourceMappingURL=strings.js.map

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(611), __esModule: true };

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(25);
var core = __webpack_require__(24);
var ctx = __webpack_require__(84);
var hide = __webpack_require__(64);
var has = __webpack_require__(86);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(74);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 52 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 53 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(186);
var enumBugKeys = __webpack_require__(122);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(39);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(6);
var dPs = __webpack_require__(187);
var enumBugKeys = __webpack_require__(122);
var IE_PROTO = __webpack_require__(121)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(119)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(123).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(186);
var hiddenKeys = __webpack_require__(122).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(7);
var dP = __webpack_require__(16);
var DESCRIPTORS = __webpack_require__(15);
var SPECIES = __webpack_require__(12)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 59 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(34);
var call = __webpack_require__(198);
var isArrayIter = __webpack_require__(135);
var anObject = __webpack_require__(6);
var toLength = __webpack_require__(17);
var getIterFn = __webpack_require__(137);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(22);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @coreapi
 * @module state
 */ /** for typedoc */

var common_1 = __webpack_require__(8);
var predicates_1 = __webpack_require__(13);
/**
 * Encapsulate the target (destination) state/params/options of a [[Transition]].
 *
 * This class is frequently used to redirect a transition to a new destination.
 *
 * See:
 *
 * - [[HookResult]]
 * - [[TransitionHookFn]]
 * - [[TransitionService.onStart]]
 *
 * To create a `TargetState`, use [[StateService.target]].
 *
 * ---
 *
 * This class wraps:
 *
 * 1) an identifier for a state
 * 2) a set of parameters
 * 3) and transition options
 * 4) the registered state object (the [[StateDeclaration]])
 *
 * Many UI-Router APIs such as [[StateService.go]] take a [[StateOrName]] argument which can
 * either be a *state object* (a [[StateDeclaration]] or [[State]]) or a *state name* (a string).
 * The `TargetState` class normalizes those options.
 *
 * A `TargetState` may be valid (the state being targeted exists in the registry)
 * or invalid (the state being targeted is not registered).
 */
var TargetState = (function () {
    /**
     * The TargetState constructor
     *
     * Note: Do not construct a `TargetState` manually.
     * To create a `TargetState`, use the [[StateService.target]] factory method.
     *
     * @param _identifier An identifier for a state.
     *    Either a fully-qualified state name, or the object used to define the state.
     * @param _definition The internal state representation, if exists.
     * @param _params Parameters for the target state
     * @param _options Transition options.
     *
     * @internalapi
     */
    function TargetState(_identifier, _definition, _params, _options) {
        if (_options === void 0) { _options = {}; }
        this._identifier = _identifier;
        this._definition = _definition;
        this._options = _options;
        this._params = _params || {};
    }
    /** The name of the state this object targets */
    TargetState.prototype.name = function () {
        return this._definition && this._definition.name || this._identifier;
    };
    /** The identifier used when creating this TargetState */
    TargetState.prototype.identifier = function () {
        return this._identifier;
    };
    /** The target parameter values */
    TargetState.prototype.params = function () {
        return this._params;
    };
    /** The internal state object (if it was found) */
    TargetState.prototype.$state = function () {
        return this._definition;
    };
    /** The internal state declaration (if it was found) */
    TargetState.prototype.state = function () {
        return this._definition && this._definition.self;
    };
    /** The target options */
    TargetState.prototype.options = function () {
        return this._options;
    };
    /** True if the target state was found */
    TargetState.prototype.exists = function () {
        return !!(this._definition && this._definition.self);
    };
    /** True if the object is valid */
    TargetState.prototype.valid = function () {
        return !this.error();
    };
    /** If the object is invalid, returns the reason why */
    TargetState.prototype.error = function () {
        var base = this.options().relative;
        if (!this._definition && !!base) {
            var stateName = base.name ? base.name : base;
            return "Could not resolve '" + this.name() + "' from state '" + stateName + "'";
        }
        if (!this._definition)
            return "No such state '" + this.name() + "'";
        if (!this._definition.self)
            return "State '" + this.name() + "' has an invalid definition";
    };
    TargetState.prototype.toString = function () {
        return "'" + this.name() + "'" + common_1.toJson(this.params());
    };
    return TargetState;
}());
/** Returns true if the object has a state property that might be a state or state name */
TargetState.isDef = function (obj) {
    return obj && obj.state && (predicates_1.isString(obj.state) || predicates_1.isString(obj.state.name));
};
exports.TargetState = TargetState;
//# sourceMappingURL=targetState.js.map

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(85)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(72);
var createDesc = __webpack_require__(163);
module.exports = __webpack_require__(63) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(16).f;
var has = __webpack_require__(26);
var TAG = __webpack_require__(12)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var defined = __webpack_require__(38);
var fails = __webpack_require__(10);
var spaces = __webpack_require__(125);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 67 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(11);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * UI-Router Transition Tracing
 *
 * Enable transition tracing to print transition information to the console,
 * in order to help debug your application.
 * Tracing logs detailed information about each Transition to your console.
 *
 * To enable tracing, import the [[Trace]] singleton and enable one or more categories.
 *
 * ### ES6
 * ```js
 * import {trace} from "ui-router-ng2"; // or "angular-ui-router"
 * trace.enable(1, 5); // TRANSITION and VIEWCONFIG
 * ```
 *
 * ### CJS
 * ```js
 * let trace = require("angular-ui-router").trace; // or "ui-router-ng2"
 * trace.enable("TRANSITION", "VIEWCONFIG");
 * ```
 *
 * ### Globals
 * ```js
 * let trace = window["angular-ui-router"].trace; // or "ui-router-ng2"
 * trace.enable(); // Trace everything (very verbose)
 * ```
 *
 * ### Angular 1:
 * ```js
 * app.run($trace => $trace.enable());
 * ```
 *
 * @coreapi
 * @module trace
 */ /** for typedoc */
var hof_1 = __webpack_require__(14);
var predicates_1 = __webpack_require__(13);
var strings_1 = __webpack_require__(48);
/** @hidden */
function uiViewString(viewData) {
    if (!viewData)
        return 'ui-view (defunct)';
    return "[ui-view#" + viewData.id + " tag " +
        ("in template from '" + (viewData.creationContext && viewData.creationContext.name || '(root)') + "' state]: ") +
        ("fqn: '" + viewData.fqn + "', ") +
        ("name: '" + viewData.name + "@" + viewData.creationContext + "')");
}
/** @hidden */
var viewConfigString = function (viewConfig) {
    return "[ViewConfig#" + viewConfig.$id + " from '" + (viewConfig.viewDecl.$context.name || '(root)') + "' state]: target ui-view: '" + viewConfig.viewDecl.$uiViewName + "@" + viewConfig.viewDecl.$uiViewContextAnchor + "'";
};
/** @hidden */
function normalizedCat(input) {
    return predicates_1.isNumber(input) ? Category[input] : Category[Category[input]];
}
/**
 * Trace categories Enum
 *
 * Enable or disable a category using [[Trace.enable]] or [[Trace.disable]]
 *
 * `trace.enable(Category.TRANSITION)`
 *
 * These can also be provided using a matching string, or position ordinal
 *
 * `trace.enable("TRANSITION")`
 *
 * `trace.enable(1)`
 */
var Category;
(function (Category) {
    Category[Category["RESOLVE"] = 0] = "RESOLVE";
    Category[Category["TRANSITION"] = 1] = "TRANSITION";
    Category[Category["HOOK"] = 2] = "HOOK";
    Category[Category["UIVIEW"] = 3] = "UIVIEW";
    Category[Category["VIEWCONFIG"] = 4] = "VIEWCONFIG";
})(Category = exports.Category || (exports.Category = {}));
/**
 * Prints UI-Router Transition trace information to the console.
 */
var Trace = (function () {
    /** @hidden */
    function Trace() {
        /** @hidden */
        this._enabled = {};
        this.approximateDigests = 0;
    }
    /** @hidden */
    Trace.prototype._set = function (enabled, categories) {
        var _this = this;
        if (!categories.length) {
            categories = Object.keys(Category)
                .map(function (k) { return parseInt(k, 10); })
                .filter(function (k) { return !isNaN(k); })
                .map(function (key) { return Category[key]; });
        }
        categories.map(normalizedCat).forEach(function (category) { return _this._enabled[category] = enabled; });
    };
    /**
     * Enables a trace [[Category]]
     *
     * ```js
     * trace.enable("TRANSITION");
     * ```
     *
     * @param categories categories to enable. If `categories` is omitted, all categories are enabled.
     *        Also takes strings (category name) or ordinal (category position)
     */
    Trace.prototype.enable = function () {
        var categories = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            categories[_i] = arguments[_i];
        }
        this._set(true, categories);
    };
    /**
     * Disables a trace [[Category]]
     *
     * ```js
     * trace.disable("VIEWCONFIG");
     * ```
     *
     * @param categories categories to disable. If `categories` is omitted, all categories are disabled.
     *        Also takes strings (category name) or ordinal (category position)
     */
    Trace.prototype.disable = function () {
        var categories = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            categories[_i] = arguments[_i];
        }
        this._set(false, categories);
    };
    /**
     * Retrieves the enabled stateus of a [[Category]]
     *
     * ```js
     * trace.enabled("VIEWCONFIG"); // true or false
     * ```
     *
     * @returns boolean true if the category is enabled
     */
    Trace.prototype.enabled = function (category) {
        return !!this._enabled[normalizedCat(category)];
    };
    /** @internalapi called by ui-router code */
    Trace.prototype.traceTransitionStart = function (trans) {
        if (!this.enabled(Category.TRANSITION))
            return;
        var tid = trans.$id, digest = this.approximateDigests, transitionStr = strings_1.stringify(trans);
        console.log("Transition #" + tid + " r" + trans.router.$id + ": Started  -> " + transitionStr);
    };
    /** @internalapi called by ui-router code */
    Trace.prototype.traceTransitionIgnored = function (trans) {
        if (!this.enabled(Category.TRANSITION))
            return;
        var tid = trans && trans.$id, digest = this.approximateDigests, transitionStr = strings_1.stringify(trans);
        console.log("Transition #" + tid + " r" + trans.router.$id + ": Ignored  <> " + transitionStr);
    };
    /** @internalapi called by ui-router code */
    Trace.prototype.traceHookInvocation = function (step, trans, options) {
        if (!this.enabled(Category.HOOK))
            return;
        var tid = hof_1.parse("transition.$id")(options), digest = this.approximateDigests, event = hof_1.parse("traceData.hookType")(options) || "internal", context = hof_1.parse("traceData.context.state.name")(options) || hof_1.parse("traceData.context")(options) || "unknown", name = strings_1.functionToString(step.registeredHook.callback);
        console.log("Transition #" + tid + " r" + trans.router.$id + ":   Hook -> " + event + " context: " + context + ", " + strings_1.maxLength(200, name));
    };
    /** @internalapi called by ui-router code */
    Trace.prototype.traceHookResult = function (hookResult, trans, transitionOptions) {
        if (!this.enabled(Category.HOOK))
            return;
        var tid = hof_1.parse("transition.$id")(transitionOptions), digest = this.approximateDigests, hookResultStr = strings_1.stringify(hookResult);
        console.log("Transition #" + tid + " r" + trans.router.$id + ":   <- Hook returned: " + strings_1.maxLength(200, hookResultStr));
    };
    /** @internalapi called by ui-router code */
    Trace.prototype.traceResolvePath = function (path, when, trans) {
        if (!this.enabled(Category.RESOLVE))
            return;
        var tid = trans && trans.$id, digest = this.approximateDigests, pathStr = path && path.toString();
        console.log("Transition #" + tid + " r" + trans.router.$id + ":         Resolving " + pathStr + " (" + when + ")");
    };
    /** @internalapi called by ui-router code */
    Trace.prototype.traceResolvableResolved = function (resolvable, trans) {
        if (!this.enabled(Category.RESOLVE))
            return;
        var tid = trans && trans.$id, digest = this.approximateDigests, resolvableStr = resolvable && resolvable.toString(), result = strings_1.stringify(resolvable.data);
        console.log("Transition #" + tid + " r" + trans.router.$id + ":               <- Resolved  " + resolvableStr + " to: " + strings_1.maxLength(200, result));
    };
    /** @internalapi called by ui-router code */
    Trace.prototype.traceError = function (reason, trans) {
        if (!this.enabled(Category.TRANSITION))
            return;
        var tid = trans && trans.$id, digest = this.approximateDigests, transitionStr = strings_1.stringify(trans);
        console.log("Transition #" + tid + " r" + trans.router.$id + ": <- Rejected " + transitionStr + ", reason: " + reason);
    };
    /** @internalapi called by ui-router code */
    Trace.prototype.traceSuccess = function (finalState, trans) {
        if (!this.enabled(Category.TRANSITION))
            return;
        var tid = trans && trans.$id, digest = this.approximateDigests, state = finalState.name, transitionStr = strings_1.stringify(trans);
        console.log("Transition #" + tid + " r" + trans.router.$id + ": <- Success  " + transitionStr + ", final state: " + state);
    };
    /** @internalapi called by ui-router code */
    Trace.prototype.traceUIViewEvent = function (event, viewData, extra) {
        if (extra === void 0) { extra = ""; }
        if (!this.enabled(Category.UIVIEW))
            return;
        console.log("ui-view: " + strings_1.padString(30, event) + " " + uiViewString(viewData) + extra);
    };
    /** @internalapi called by ui-router code */
    Trace.prototype.traceUIViewConfigUpdated = function (viewData, context) {
        if (!this.enabled(Category.UIVIEW))
            return;
        this.traceUIViewEvent("Updating", viewData, " with ViewConfig from context='" + context + "'");
    };
    /** @internalapi called by ui-router code */
    Trace.prototype.traceUIViewFill = function (viewData, html) {
        if (!this.enabled(Category.UIVIEW))
            return;
        this.traceUIViewEvent("Fill", viewData, " with: " + strings_1.maxLength(200, html));
    };
    /** @internalapi called by ui-router code */
    Trace.prototype.traceViewServiceEvent = function (event, viewConfig) {
        if (!this.enabled(Category.VIEWCONFIG))
            return;
        console.log("VIEWCONFIG: " + event + " " + viewConfigString(viewConfig));
    };
    /** @internalapi called by ui-router code */
    Trace.prototype.traceViewServiceUIViewEvent = function (event, viewData) {
        if (!this.enabled(Category.VIEWCONFIG))
            return;
        console.log("VIEWCONFIG: " + event + " " + uiViewString(viewData));
    };
    return Trace;
}());
exports.Trace = Trace;
/**
 * The [[Trace]] singleton
 *
 * #### Example:
 * ```js
 * import {trace} from "angular-ui-router";
 * trace.enable(1, 5);
 * ```
 */
var trace = new Trace();
exports.trace = trace;
//# sourceMappingURL=trace.js.map

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @internalapi
 * @module params
 */ /** for typedoc */
var common_1 = __webpack_require__(8);
var hof_1 = __webpack_require__(14);
var predicates_1 = __webpack_require__(13);
var coreservices_1 = __webpack_require__(20);
var paramType_1 = __webpack_require__(148);
var hasOwn = Object.prototype.hasOwnProperty;
var isShorthand = function (cfg) {
    return ["value", "type", "squash", "array", "dynamic"].filter(hasOwn.bind(cfg || {})).length === 0;
};
var DefType;
(function (DefType) {
    DefType[DefType["PATH"] = 0] = "PATH";
    DefType[DefType["SEARCH"] = 1] = "SEARCH";
    DefType[DefType["CONFIG"] = 2] = "CONFIG";
})(DefType = exports.DefType || (exports.DefType = {}));
function unwrapShorthand(cfg) {
    cfg = isShorthand(cfg) && { value: cfg } || cfg;
    return common_1.extend(cfg, {
        $$fn: predicates_1.isInjectable(cfg.value) ? cfg.value : function () { return cfg.value; }
    });
}
function getType(cfg, urlType, location, id, paramTypes) {
    if (cfg.type && urlType && urlType.name !== 'string')
        throw new Error("Param '" + id + "' has two type configurations.");
    if (cfg.type && urlType && urlType.name === 'string' && paramTypes.type(cfg.type))
        return paramTypes.type(cfg.type);
    if (urlType)
        return urlType;
    if (!cfg.type) {
        var type = location === DefType.CONFIG ? "any" :
            location === DefType.PATH ? "path" :
                location === DefType.SEARCH ? "query" : "string";
        return paramTypes.type(type);
    }
    return cfg.type instanceof paramType_1.ParamType ? cfg.type : paramTypes.type(cfg.type);
}
/**
 * returns false, true, or the squash value to indicate the "default parameter url squash policy".
 */
function getSquashPolicy(config, isOptional, defaultPolicy) {
    var squash = config.squash;
    if (!isOptional || squash === false)
        return false;
    if (!predicates_1.isDefined(squash) || squash == null)
        return defaultPolicy;
    if (squash === true || predicates_1.isString(squash))
        return squash;
    throw new Error("Invalid squash policy: '" + squash + "'. Valid policies: false, true, or arbitrary string");
}
function getReplace(config, arrayMode, isOptional, squash) {
    var replace, configuredKeys, defaultPolicy = [
        { from: "", to: (isOptional || arrayMode ? undefined : "") },
        { from: null, to: (isOptional || arrayMode ? undefined : "") }
    ];
    replace = predicates_1.isArray(config.replace) ? config.replace : [];
    if (predicates_1.isString(squash))
        replace.push({ from: squash, to: undefined });
    configuredKeys = common_1.map(replace, hof_1.prop("from"));
    return common_1.filter(defaultPolicy, function (item) { return configuredKeys.indexOf(item.from) === -1; }).concat(replace);
}
var Param = (function () {
    function Param(id, type, config, location, urlMatcherFactory) {
        config = unwrapShorthand(config);
        type = getType(config, type, location, id, urlMatcherFactory.paramTypes);
        var arrayMode = getArrayMode();
        type = arrayMode ? type.$asArray(arrayMode, location === DefType.SEARCH) : type;
        var isOptional = config.value !== undefined || location === DefType.SEARCH;
        var dynamic = predicates_1.isDefined(config.dynamic) ? !!config.dynamic : !!type.dynamic;
        var raw = predicates_1.isDefined(config.raw) ? !!config.raw : !!type.raw;
        var squash = getSquashPolicy(config, isOptional, urlMatcherFactory.defaultSquashPolicy());
        var replace = getReplace(config, arrayMode, isOptional, squash);
        var inherit = predicates_1.isDefined(config.inherit) ? !!config.inherit : !!type.inherit;
        // array config: param name (param[]) overrides default settings.  explicit config overrides param name.
        function getArrayMode() {
            var arrayDefaults = { array: (location === DefType.SEARCH ? "auto" : false) };
            var arrayParamNomenclature = id.match(/\[\]$/) ? { array: true } : {};
            return common_1.extend(arrayDefaults, arrayParamNomenclature, config).array;
        }
        common_1.extend(this, { id: id, type: type, location: location, isOptional: isOptional, dynamic: dynamic, raw: raw, squash: squash, replace: replace, inherit: inherit, array: arrayMode, config: config, });
    }
    Param.prototype.isDefaultValue = function (value) {
        return this.isOptional && this.type.equals(this.value(), value);
    };
    /**
     * [Internal] Gets the decoded representation of a value if the value is defined, otherwise, returns the
     * default value, which may be the result of an injectable function.
     */
    Param.prototype.value = function (value) {
        var _this = this;
        /**
         * [Internal] Get the default value of a parameter, which may be an injectable function.
         */
        var $$getDefaultValue = function () {
            if (!coreservices_1.services.$injector)
                throw new Error("Injectable functions cannot be called at configuration time");
            var defaultValue = coreservices_1.services.$injector.invoke(_this.config.$$fn);
            if (defaultValue !== null && defaultValue !== undefined && !_this.type.is(defaultValue))
                throw new Error("Default value (" + defaultValue + ") for parameter '" + _this.id + "' is not an instance of ParamType (" + _this.type.name + ")");
            return defaultValue;
        };
        var $replace = function (val) {
            var replacement = common_1.map(common_1.filter(_this.replace, hof_1.propEq('from', val)), hof_1.prop("to"));
            return replacement.length ? replacement[0] : val;
        };
        value = $replace(value);
        return !predicates_1.isDefined(value) ? $$getDefaultValue() : this.type.$normalize(value);
    };
    Param.prototype.isSearch = function () {
        return this.location === DefType.SEARCH;
    };
    Param.prototype.validates = function (value) {
        // There was no parameter value, but the param is optional
        if ((!predicates_1.isDefined(value) || value === null) && this.isOptional)
            return true;
        // The value was not of the correct ParamType, and could not be decoded to the correct ParamType
        var normalized = this.type.$normalize(value);
        if (!this.type.is(normalized))
            return false;
        // The value was of the correct type, but when encoded, did not match the ParamType's regexp
        var encoded = this.type.encode(normalized);
        return !(predicates_1.isString(encoded) && !this.type.pattern.exec(encoded));
    };
    Param.prototype.toString = function () {
        return "{Param:" + this.id + " " + this.type + " squash: '" + this.squash + "' optional: " + this.isOptional + "}";
    };
    Param.values = function (params, values) {
        if (values === void 0) { values = {}; }
        return params.map(function (param) { return [param.id, param.value(values[param.id])]; }).reduce(common_1.applyPairs, {});
    };
    /**
     * Finds [[Param]] objects which have different param values
     *
     * Filters a list of [[Param]] objects to only those whose parameter values differ in two param value objects
     *
     * @param params: The list of Param objects to filter
     * @param values1: The first set of parameter values
     * @param values2: the second set of parameter values
     *
     * @returns any Param objects whose values were different between values1 and values2
     */
    Param.changed = function (params, values1, values2) {
        if (values1 === void 0) { values1 = {}; }
        if (values2 === void 0) { values2 = {}; }
        return params.filter(function (param) { return !param.type.equals(values1[param.id], values2[param.id]); });
    };
    /**
     * Checks if two param value objects are equal (for a set of [[Param]] objects)
     *
     * @param params The list of [[Param]] objects to check
     * @param values1 The first set of param values
     * @param values2 The second set of param values
     *
     * @returns true if the param values in values1 and values2 are equal
     */
    Param.equals = function (params, values1, values2) {
        if (values1 === void 0) { values1 = {}; }
        if (values2 === void 0) { values2 = {}; }
        return Param.changed(params, values1, values2).length === 0;
    };
    /** Returns true if a the parameter values are valid, according to the Param definitions */
    Param.validates = function (params, values) {
        if (values === void 0) { values = {}; }
        return params.map(function (param) { return param.validates(values[param.id]); }).reduce(common_1.allTrueR, true);
    };
    return Param;
}());
exports.Param = Param;
//# sourceMappingURL=param.js.map

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ng_from_import = __webpack_require__(1);
var ng_from_global = angular;
exports.ng = (ng_from_import && ng_from_import.module) ? ng_from_import : ng_from_global;
//# sourceMappingURL=angular.js.map

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(51);
var IE8_DOM_DEFINE = __webpack_require__(360);
var toPrimitive = __webpack_require__(352);
var dP = Object.defineProperty;

exports.f = __webpack_require__(63) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Main entry point for angular 1.x build
 * @module ng1
 */ /** */

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
var core = __webpack_require__(30);
exports.core = core;
__export(__webpack_require__(30));
__export(__webpack_require__(151));
__export(__webpack_require__(152));
__export(__webpack_require__(236));
__webpack_require__(601);
__webpack_require__(602);
__webpack_require__(603);
__webpack_require__(604);
__webpack_require__(605);
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = "ui.router";
//# sourceMappingURL=index.js.map

/***/ }),
/* 74 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(35);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 76 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(35);
var TAG = __webpack_require__(12)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @coreapi
 * @module transition
 */ /** for typedoc */

var common_1 = __webpack_require__(8);
var strings_1 = __webpack_require__(48);
var RejectType;
(function (RejectType) {
    RejectType[RejectType["SUPERSEDED"] = 2] = "SUPERSEDED";
    RejectType[RejectType["ABORTED"] = 3] = "ABORTED";
    RejectType[RejectType["INVALID"] = 4] = "INVALID";
    RejectType[RejectType["IGNORED"] = 5] = "IGNORED";
    RejectType[RejectType["ERROR"] = 6] = "ERROR";
})(RejectType = exports.RejectType || (exports.RejectType = {}));
var Rejection = (function () {
    function Rejection(type, message, detail) {
        this.type = type;
        this.message = message;
        this.detail = detail;
    }
    Rejection.prototype.toString = function () {
        var detailString = function (d) {
            return d && d.toString !== Object.prototype.toString ? d.toString() : strings_1.stringify(d);
        };
        var type = this.type, message = this.message, detail = detailString(this.detail);
        return "TransitionRejection(type: " + type + ", message: " + message + ", detail: " + detail + ")";
    };
    Rejection.prototype.toPromise = function () {
        return common_1.extend(common_1.silentRejection(this), { _transitionRejection: this });
    };
    /** Returns true if the obj is a rejected promise created from the `asPromise` factory */
    Rejection.isTransitionRejectionPromise = function (obj) {
        return obj && (typeof obj.then === 'function') && obj._transitionRejection instanceof Rejection;
    };
    /** Returns a TransitionRejection due to transition superseded */
    Rejection.superseded = function (detail, options) {
        var message = "The transition has been superseded by a different transition";
        var rejection = new Rejection(RejectType.SUPERSEDED, message, detail);
        if (options && options.redirected) {
            rejection.redirected = true;
        }
        return rejection;
    };
    /** Returns a TransitionRejection due to redirected transition */
    Rejection.redirected = function (detail) {
        return Rejection.superseded(detail, { redirected: true });
    };
    /** Returns a TransitionRejection due to invalid transition */
    Rejection.invalid = function (detail) {
        var message = "This transition is invalid";
        return new Rejection(RejectType.INVALID, message, detail);
    };
    /** Returns a TransitionRejection due to ignored transition */
    Rejection.ignored = function (detail) {
        var message = "The transition was ignored";
        return new Rejection(RejectType.IGNORED, message, detail);
    };
    /** Returns a TransitionRejection due to aborted transition */
    Rejection.aborted = function (detail) {
        // TODO think about how to encapsulate an Error() object
        var message = "The transition has been aborted";
        return new Rejection(RejectType.ABORTED, message, detail);
    };
    /** Returns a TransitionRejection due to aborted transition */
    Rejection.errored = function (detail) {
        // TODO think about how to encapsulate an Error() object
        var message = "The transition errored";
        return new Rejection(RejectType.ERROR, message, detail);
    };
    return Rejection;
}());
exports.Rejection = Rejection;
//# sourceMappingURL=rejectFactory.js.map

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TransitionHookPhase;
(function (TransitionHookPhase) {
    TransitionHookPhase[TransitionHookPhase["CREATE"] = 0] = "CREATE";
    TransitionHookPhase[TransitionHookPhase["BEFORE"] = 1] = "BEFORE";
    TransitionHookPhase[TransitionHookPhase["ASYNC"] = 2] = "ASYNC";
    TransitionHookPhase[TransitionHookPhase["SUCCESS"] = 3] = "SUCCESS";
    TransitionHookPhase[TransitionHookPhase["ERROR"] = 4] = "ERROR";
})(TransitionHookPhase = exports.TransitionHookPhase || (exports.TransitionHookPhase = {}));
var TransitionHookScope;
(function (TransitionHookScope) {
    TransitionHookScope[TransitionHookScope["TRANSITION"] = 0] = "TRANSITION";
    TransitionHookScope[TransitionHookScope["STATE"] = 1] = "STATE";
})(TransitionHookScope = exports.TransitionHookScope || (exports.TransitionHookScope = {}));
//# sourceMappingURL=interface.js.map

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var common_1 = __webpack_require__(8);
var strings_1 = __webpack_require__(48);
var predicates_1 = __webpack_require__(13);
var hof_1 = __webpack_require__(14);
var trace_1 = __webpack_require__(69);
var coreservices_1 = __webpack_require__(20);
var rejectFactory_1 = __webpack_require__(78);
var targetState_1 = __webpack_require__(62);
var defaultOptions = {
    current: common_1.noop,
    transition: null,
    traceData: {},
    bind: null
};
/** @hidden */
var TransitionHook = (function () {
    function TransitionHook(transition, stateContext, registeredHook, options) {
        var _this = this;
        this.transition = transition;
        this.stateContext = stateContext;
        this.registeredHook = registeredHook;
        this.options = options;
        this.stateService = function () { return _this.transition.router.stateService; };
        this.rejectIfSuperseded = function () {
            return _this.registeredHook.eventType.rejectIfSuperseded && _this.options.current() !== _this.options.transition;
        };
        this.options = common_1.defaults(options, defaultOptions);
    }
    TransitionHook.prototype.invokeHook = function () {
        var hook = this.registeredHook;
        if (hook._deregistered)
            return;
        var options = this.options;
        trace_1.trace.traceHookInvocation(this, this.transition, options);
        if (this.rejectIfSuperseded()) {
            return rejectFactory_1.Rejection.superseded(options.current()).toPromise();
        }
        var cb = hook.callback;
        var bind = this.options.bind;
        var trans = this.transition;
        var state = this.stateContext;
        var errorHandler = hook.eventType.getErrorHandler(this);
        var resultHandler = hook.eventType.getResultHandler(this);
        resultHandler = resultHandler || common_1.identity;
        if (!errorHandler) {
            return resultHandler(cb.call(bind, trans, state));
        }
        try {
            return resultHandler(cb.call(bind, trans, state));
        }
        catch (error) {
            return errorHandler(error);
        }
    };
    /**
     * This method handles the return value of a Transition Hook.
     *
     * A hook can return false (cancel), a TargetState (redirect),
     * or a promise (which may later resolve to false or a redirect)
     *
     * This also handles "transition superseded" -- when a new transition
     * was started while the hook was still running
     */
    TransitionHook.prototype.handleHookResult = function (result) {
        // This transition is no longer current.
        // Another transition started while this hook was still running.
        if (this.rejectIfSuperseded()) {
            // Abort this transition
            return rejectFactory_1.Rejection.superseded(this.options.current()).toPromise();
        }
        // Hook returned a promise
        if (predicates_1.isPromise(result)) {
            // Wait for the promise, then reprocess the resolved value
            return result.then(this.handleHookResult.bind(this));
        }
        trace_1.trace.traceHookResult(result, this.transition, this.options);
        // Hook returned false
        if (result === false) {
            // Abort this Transition
            return rejectFactory_1.Rejection.aborted("Hook aborted transition").toPromise();
        }
        var isTargetState = hof_1.is(targetState_1.TargetState);
        // hook returned a TargetState
        if (isTargetState(result)) {
            // Halt the current Transition and start a redirected Transition (to the TargetState).
            return rejectFactory_1.Rejection.redirected(result).toPromise();
        }
    };
    TransitionHook.prototype.toString = function () {
        var _a = this, options = _a.options, registeredHook = _a.registeredHook;
        var event = hof_1.parse("traceData.hookType")(options) || "internal", context = hof_1.parse("traceData.context.state.name")(options) || hof_1.parse("traceData.context")(options) || "unknown", name = strings_1.fnToString(registeredHook.callback);
        return event + " context: " + context + ", " + strings_1.maxLength(200, name);
    };
    /**
     * Run all TransitionHooks, ignoring their return value.
     */
    TransitionHook.runAllHooks = function (hooks) {
        hooks.forEach(function (hook) { return hook.invokeHook(); });
    };
    /**
     * Given an array of TransitionHooks, runs each one synchronously and sequentially.
     * Should any hook return a Rejection synchronously, the remaining hooks will not run.
     *
     * Returns a promise chain composed of any promises returned from each hook.invokeStep() call
     */
    TransitionHook.runOnBeforeHooks = function (hooks) {
        var results = [];
        for (var _i = 0, hooks_1 = hooks; _i < hooks_1.length; _i++) {
            var hook = hooks_1[_i];
            var hookResult = hook.invokeHook();
            if (rejectFactory_1.Rejection.isTransitionRejectionPromise(hookResult)) {
                // Break on first thrown error or false/TargetState
                return hookResult;
            }
            results.push(hookResult);
        }
        return results
            .filter(predicates_1.isPromise)
            .reduce(function (chain, promise) { return chain.then(hof_1.val(promise)); }, coreservices_1.services.$q.when());
    };
    return TransitionHook;
}());
TransitionHook.HANDLE_RESULT = function (hook) {
    return function (result) {
        return hook.handleHookResult(result);
    };
};
TransitionHook.IGNORE_RESULT = function (hook) {
    return function (result) { return undefined; };
};
TransitionHook.LOG_ERROR = function (hook) {
    return function (error) {
        return (hook.stateService().defaultErrorHandler()(error), undefined);
    };
};
TransitionHook.REJECT_ERROR = function (hook) {
    return function (error) {
        return rejectFactory_1.Rejection.errored(error).toPromise();
    };
};
TransitionHook.THROW_ERROR = function (hook) {
    return undefined;
};
exports.TransitionHook = TransitionHook;
//# sourceMappingURL=transitionHook.js.map

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @coreapi
 * @module resolve
 */ /** for typedoc */
var common_1 = __webpack_require__(8);
var coreservices_1 = __webpack_require__(20);
var trace_1 = __webpack_require__(69);
var strings_1 = __webpack_require__(48);
var predicates_1 = __webpack_require__(13);
// TODO: explicitly make this user configurable
exports.defaultResolvePolicy = {
    when: "LAZY",
    async: "WAIT"
};
/**
 * The basic building block for the resolve system.
 *
 * Resolvables encapsulate a state's resolve's resolveFn, the resolveFn's declared dependencies, the wrapped (.promise),
 * and the unwrapped-when-complete (.data) result of the resolveFn.
 *
 * Resolvable.get() either retrieves the Resolvable's existing promise, or else invokes resolve() (which invokes the
 * resolveFn) and returns the resulting promise.
 *
 * Resolvable.get() and Resolvable.resolve() both execute within a context path, which is passed as the first
 * parameter to those fns.
 */
var Resolvable = (function () {
    function Resolvable(arg1, resolveFn, deps, policy, data) {
        this.resolved = false;
        this.promise = undefined;
        if (arg1 instanceof Resolvable) {
            common_1.extend(this, arg1);
        }
        else if (predicates_1.isFunction(resolveFn)) {
            if (arg1 == null || arg1 == undefined)
                throw new Error("new Resolvable(): token argument is required");
            if (!predicates_1.isFunction(resolveFn))
                throw new Error("new Resolvable(): resolveFn argument must be a function");
            this.token = arg1;
            this.policy = policy;
            this.resolveFn = resolveFn;
            this.deps = deps || [];
            this.data = data;
            this.resolved = data !== undefined;
            this.promise = this.resolved ? coreservices_1.services.$q.when(this.data) : undefined;
        }
        else if (predicates_1.isObject(arg1) && arg1.token && predicates_1.isFunction(arg1.resolveFn)) {
            var literal = arg1;
            return new Resolvable(literal.token, literal.resolveFn, literal.deps, literal.policy, literal.data);
        }
    }
    Resolvable.prototype.getPolicy = function (state) {
        var thisPolicy = this.policy || {};
        var statePolicy = state && state.resolvePolicy || {};
        return {
            when: thisPolicy.when || statePolicy.when || exports.defaultResolvePolicy.when,
            async: thisPolicy.async || statePolicy.async || exports.defaultResolvePolicy.async,
        };
    };
    /**
     * Asynchronously resolve this Resolvable's data
     *
     * Given a ResolveContext that this Resolvable is found in:
     * Wait for this Resolvable's dependencies, then invoke this Resolvable's function
     * and update the Resolvable's state
     */
    Resolvable.prototype.resolve = function (resolveContext, trans) {
        var _this = this;
        var $q = coreservices_1.services.$q;
        // Gets all dependencies from ResolveContext and wait for them to be resolved
        var getResolvableDependencies = function () {
            return $q.all(resolveContext.getDependencies(_this).map(function (r) {
                return r.get(resolveContext, trans);
            }));
        };
        // Invokes the resolve function passing the resolved dependencies as arguments
        var invokeResolveFn = function (resolvedDeps) {
            return _this.resolveFn.apply(null, resolvedDeps);
        };
        /**
         * For RXWAIT policy:
         *
         * Given an observable returned from a resolve function:
         * - enables .cache() mode (this allows multicast subscribers)
         * - then calls toPromise() (this triggers subscribe() and thus fetches)
         * - Waits for the promise, then return the cached observable (not the first emitted value).
         */
        var waitForRx = function (observable$) {
            var cached = observable$.cache(1);
            return cached.take(1).toPromise().then(function () { return cached; });
        };
        // If the resolve policy is RXWAIT, wait for the observable to emit something. otherwise pass through.
        var node = resolveContext.findNode(this);
        var state = node && node.state;
        var maybeWaitForRx = this.getPolicy(state).async === "RXWAIT" ? waitForRx : common_1.identity;
        // After the final value has been resolved, update the state of the Resolvable
        var applyResolvedValue = function (resolvedValue) {
            _this.data = resolvedValue;
            _this.resolved = true;
            trace_1.trace.traceResolvableResolved(_this, trans);
            return _this.data;
        };
        // Sets the promise property first, then getsResolvableDependencies in the context of the promise chain. Always waits one tick.
        return this.promise = $q.when()
            .then(getResolvableDependencies)
            .then(invokeResolveFn)
            .then(maybeWaitForRx)
            .then(applyResolvedValue);
    };
    /**
     * Gets a promise for this Resolvable's data.
     *
     * Fetches the data and returns a promise.
     * Returns the existing promise if it has already been fetched once.
     */
    Resolvable.prototype.get = function (resolveContext, trans) {
        return this.promise || this.resolve(resolveContext, trans);
    };
    Resolvable.prototype.toString = function () {
        return "Resolvable(token: " + strings_1.stringify(this.token) + ", requires: [" + this.deps.map(strings_1.stringify) + "])";
    };
    Resolvable.prototype.clone = function () {
        return new Resolvable(this);
    };
    return Resolvable;
}());
Resolvable.fromData = function (token, data) {
    return new Resolvable(token, function () { return data; }, null, null, data);
};
exports.Resolvable = Resolvable;
//# sourceMappingURL=resolvable.js.map

/***/ }),
/* 82 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(748), __esModule: true };

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(87);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 85 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 86 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 88 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(33);
var global = __webpack_require__(7);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(46) ? 'pure' : 'global',
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(27);
var toLength = __webpack_require__(17);
var toAbsoluteIndex = __webpack_require__(55);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 91 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(35);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(11);
var cof = __webpack_require__(35);
var MATCH = __webpack_require__(12)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(12)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(6);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var hide = __webpack_require__(21);
var redefine = __webpack_require__(22);
var fails = __webpack_require__(10);
var defined = __webpack_require__(38);
var wks = __webpack_require__(12);

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);
  var fns = exec(defined, SYMBOL, ''[KEY]);
  var strfn = fns[0];
  var rxfn = fns[1];
  if (fails(function () {
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  })) {
    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(6);
var aFunction = __webpack_require__(19);
var SPECIES = __webpack_require__(12)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(7);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(7);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(22);
var redefineAll = __webpack_require__(61);
var meta = __webpack_require__(45);
var forOf = __webpack_require__(60);
var anInstance = __webpack_require__(59);
var isObject = __webpack_require__(11);
var fails = __webpack_require__(10);
var $iterDetect = __webpack_require__(94);
var setToStringTag = __webpack_require__(65);
var inheritIfRequired = __webpack_require__(126);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(7);
var hide = __webpack_require__(21);
var uid = __webpack_require__(53);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(46) || !__webpack_require__(10)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__(7)[K];
});


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(0);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(0);
var aFunction = __webpack_require__(19);
var ctx = __webpack_require__(34);
var forOf = __webpack_require__(60);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @coreapi
 * @module core
 */
/**
 * Matches state names using glob-like pattern strings.
 *
 * Globs can be used in specific APIs including:
 *
 * - [[StateService.is]]
 * - [[StateService.includes]]
 * - The first argument to Hook Registration functions like [[TransitionService.onStart]]
 *    - [[HookMatchCriteria]] and [[HookMatchCriterion]]
 *
 * A `Glob` string is a pattern which matches state names.
 * Nested state names are split into segments (separated by a dot) when processing.
 * The state named `foo.bar.baz` is split into three segments ['foo', 'bar', 'baz']
 *
 * Globs work according to the following rules:
 *
 * ### Exact match:
 *
 * The glob `'A.B'` matches the state named exactly `'A.B'`.
 *
 * | Glob        |Matches states named|Does not match state named|
 * |:------------|:--------------------|:---------------------|
 * | `'A'`       | `'A'`               | `'B'` , `'A.C'`      |
 * | `'A.B'`     | `'A.B'`             | `'A'` , `'A.B.C'`    |
 * | `'foo'`     | `'foo'`             | `'FOO'` , `'foo.bar'`|
 *
 * ### Single star (`*`)
 *
 * A single star (`*`) is a wildcard that matches exactly one segment.
 *
 * | Glob        |Matches states named  |Does not match state named |
 * |:------------|:---------------------|:--------------------------|
 * | `'*'`       | `'A'` , `'Z'`        | `'A.B'` , `'Z.Y.X'`       |
 * | `'A.*'`     | `'A.B'` , `'A.C'`    | `'A'` , `'A.B.C'`         |
 * | `'A.*.*'`   | `'A.B.C'` , `'A.X.Y'`| `'A'`, `'A.B'` , `'Z.Y.X'`|
 *
 * ### Double star (`**`)
 *
 * A double star (`'**'`) is a wildcard that matches *zero or more segments*
 *
 * | Glob        |Matches states named                           |Does not match state named         |
 * |:------------|:----------------------------------------------|:----------------------------------|
 * | `'**'`      | `'A'` , `'A.B'`, `'Z.Y.X'`                    | (matches all states)              |
 * | `'A.**'`    | `'A'` , `'A.B'` , `'A.C.X'`                   | `'Z.Y.X'`                         |
 * | `'**.X'`    | `'X'` , `'A.X'` , `'Z.Y.X'`                   | `'A'` , `'A.login.Z'`             |
 * | `'A.**.X'`  | `'A.X'` , `'A.B.X'` , `'A.B.C.X'`             | `'A'` , `'A.B.C'`                 |
 *
 */
var Glob = (function () {
    function Glob(text) {
        this.text = text;
        this.glob = text.split('.');
        var regexpString = this.text.split('.')
            .map(function (seg) {
            if (seg === '**')
                return '(?:|(?:\\.[^.]*)*)';
            if (seg === '*')
                return '\\.[^.]*';
            return '\\.' + seg;
        }).join('');
        this.regexp = new RegExp("^" + regexpString + "$");
    }
    Glob.prototype.matches = function (name) {
        return this.regexp.test('.' + name);
    };
    /** @deprecated whats the point? */
    Glob.is = function (text) {
        return text.indexOf('*') > -1;
    };
    /** @deprecated whats the point? */
    Glob.fromString = function (text) {
        if (!this.is(text))
            return null;
        return new Glob(text);
    };
    return Glob;
}());
exports.Glob = Glob;
//# sourceMappingURL=glob.js.map

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/** @module path */ /** for typedoc */
var common_1 = __webpack_require__(8);
var hof_1 = __webpack_require__(14);
var param_1 = __webpack_require__(70);
/**
 * A node in a [[TreeChanges]] path
 *
 * For a [[TreeChanges]] path, this class holds the stateful information for a single node in the path.
 * Each PathNode corresponds to a state being entered, exited, or retained.
 * The stateful information includes parameter values and resolve data.
 */
var PathNode = (function () {
    function PathNode(stateOrPath) {
        if (stateOrPath instanceof PathNode) {
            var node = stateOrPath;
            this.state = node.state;
            this.paramSchema = node.paramSchema.slice();
            this.paramValues = common_1.extend({}, node.paramValues);
            this.resolvables = node.resolvables.slice();
            this.views = node.views && node.views.slice();
        }
        else {
            var state = stateOrPath;
            this.state = state;
            this.paramSchema = state.parameters({ inherit: false });
            this.paramValues = {};
            this.resolvables = state.resolvables.map(function (res) { return res.clone(); });
        }
    }
    /** Sets [[paramValues]] for the node, from the values of an object hash */
    PathNode.prototype.applyRawParams = function (params) {
        var getParamVal = function (paramDef) { return [paramDef.id, paramDef.value(params[paramDef.id])]; };
        this.paramValues = this.paramSchema.reduce(function (memo, pDef) { return common_1.applyPairs(memo, getParamVal(pDef)); }, {});
        return this;
    };
    /** Gets a specific [[Param]] metadata that belongs to the node */
    PathNode.prototype.parameter = function (name) {
        return common_1.find(this.paramSchema, hof_1.propEq("id", name));
    };
    /**
     * @returns true if the state and parameter values for another PathNode are
     * equal to the state and param values for this PathNode
     */
    PathNode.prototype.equals = function (node, keys) {
        var _this = this;
        if (keys === void 0) { keys = this.paramSchema.map(function (p) { return p.id; }); }
        var paramValsEq = function (key) {
            return _this.parameter(key).type.equals(_this.paramValues[key], node.paramValues[key]);
        };
        return this.state === node.state && keys.map(paramValsEq).reduce(common_1.allTrueR, true);
    };
    /** Returns a clone of the PathNode */
    PathNode.clone = function (node) {
        return new PathNode(node);
    };
    /**
     * Returns a new path which is a subpath of the first path which matched the second path.
     *
     * The new path starts from root and contains any nodes that match the nodes in the second path.
     * Nodes are compared using their state property and parameter values.
     *
     * @param pathA the first path
     * @param pathB the second path
     * @param ignoreDynamicParams don't compare dynamic parameter values
     */
    PathNode.matching = function (pathA, pathB, ignoreDynamicParams) {
        if (ignoreDynamicParams === void 0) { ignoreDynamicParams = true; }
        var matching = [];
        for (var i = 0; i < pathA.length && i < pathB.length; i++) {
            var a = pathA[i], b = pathB[i];
            if (a.state !== b.state)
                break;
            var changedParams = param_1.Param.changed(a.paramSchema, a.paramValues, b.paramValues)
                .filter(function (param) { return !(ignoreDynamicParams && param.dynamic); });
            if (changedParams.length)
                break;
            matching.push(a);
        }
        return matching;
    };
    return PathNode;
}());
exports.PathNode = PathNode;
//# sourceMappingURL=node.js.map

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @module path */ /** for typedoc */

var common_1 = __webpack_require__(8);
var hof_1 = __webpack_require__(14);
var targetState_1 = __webpack_require__(62);
var node_1 = __webpack_require__(105);
/**
 * This class contains functions which convert TargetStates, Nodes and paths from one type to another.
 */
var PathFactory = (function () {
    function PathFactory() {
    }
    /** Given a PathNode[], create an TargetState */
    PathFactory.makeTargetState = function (path) {
        var state = common_1.tail(path).state;
        return new targetState_1.TargetState(state, state, path.map(hof_1.prop("paramValues")).reduce(common_1.mergeR, {}));
    };
    PathFactory.buildPath = function (targetState) {
        var toParams = targetState.params();
        return targetState.$state().path.map(function (state) { return new node_1.PathNode(state).applyRawParams(toParams); });
    };
    /** Given a fromPath: PathNode[] and a TargetState, builds a toPath: PathNode[] */
    PathFactory.buildToPath = function (fromPath, targetState) {
        var toPath = PathFactory.buildPath(targetState);
        if (targetState.options().inherit) {
            return PathFactory.inheritParams(fromPath, toPath, Object.keys(targetState.params()));
        }
        return toPath;
    };
    /**
     * Creates ViewConfig objects and adds to nodes.
     *
     * On each [[PathNode]], creates ViewConfig objects from the views: property of the node's state
     */
    PathFactory.applyViewConfigs = function ($view, path, states) {
        // Only apply the viewConfigs to the nodes for the given states
        path.filter(function (node) { return common_1.inArray(states, node.state); }).forEach(function (node) {
            var viewDecls = common_1.values(node.state.views || {});
            var subPath = PathFactory.subPath(path, function (n) { return n === node; });
            var viewConfigs = viewDecls.map(function (view) { return $view.createViewConfig(subPath, view); });
            node.views = viewConfigs.reduce(common_1.unnestR, []);
        });
    };
    /**
     * Given a fromPath and a toPath, returns a new to path which inherits parameters from the fromPath
     *
     * For a parameter in a node to be inherited from the from path:
     * - The toPath's node must have a matching node in the fromPath (by state).
     * - The parameter name must not be found in the toKeys parameter array.
     *
     * Note: the keys provided in toKeys are intended to be those param keys explicitly specified by some
     * caller, for instance, $state.transitionTo(..., toParams).  If a key was found in toParams,
     * it is not inherited from the fromPath.
     */
    PathFactory.inheritParams = function (fromPath, toPath, toKeys) {
        if (toKeys === void 0) { toKeys = []; }
        function nodeParamVals(path, state) {
            var node = common_1.find(path, hof_1.propEq('state', state));
            return common_1.extend({}, node && node.paramValues);
        }
        var noInherit = fromPath.map(function (node) { return node.paramSchema; })
            .reduce(common_1.unnestR, [])
            .filter(function (param) { return !param.inherit; })
            .map(hof_1.prop('id'));
        /**
         * Given an [[PathNode]] "toNode", return a new [[PathNode]] with param values inherited from the
         * matching node in fromPath.  Only inherit keys that aren't found in "toKeys" from the node in "fromPath""
         */
        function makeInheritedParamsNode(toNode) {
            // All param values for the node (may include default key/vals, when key was not found in toParams)
            var toParamVals = common_1.extend({}, toNode && toNode.paramValues);
            // limited to only those keys found in toParams
            var incomingParamVals = common_1.pick(toParamVals, toKeys);
            toParamVals = common_1.omit(toParamVals, toKeys);
            var fromParamVals = common_1.omit(nodeParamVals(fromPath, toNode.state) || {}, noInherit);
            // extend toParamVals with any fromParamVals, then override any of those those with incomingParamVals
            var ownParamVals = common_1.extend(toParamVals, fromParamVals, incomingParamVals);
            return new node_1.PathNode(toNode.state).applyRawParams(ownParamVals);
        }
        // The param keys specified by the incoming toParams
        return toPath.map(makeInheritedParamsNode);
    };
    /**
     * Computes the tree changes (entering, exiting) between a fromPath and toPath.
     */
    PathFactory.treeChanges = function (fromPath, toPath, reloadState) {
        var keep = 0, max = Math.min(fromPath.length, toPath.length);
        var staticParams = function (state) {
            return state.parameters({ inherit: false }).filter(hof_1.not(hof_1.prop('dynamic'))).map(hof_1.prop('id'));
        };
        var nodesMatch = function (node1, node2) {
            return node1.equals(node2, staticParams(node1.state));
        };
        while (keep < max && fromPath[keep].state !== reloadState && nodesMatch(fromPath[keep], toPath[keep])) {
            keep++;
        }
        /** Given a retained node, return a new node which uses the to node's param values */
        function applyToParams(retainedNode, idx) {
            var cloned = node_1.PathNode.clone(retainedNode);
            cloned.paramValues = toPath[idx].paramValues;
            return cloned;
        }
        var from, retained, exiting, entering, to;
        from = fromPath;
        retained = from.slice(0, keep);
        exiting = from.slice(keep);
        // Create a new retained path (with shallow copies of nodes) which have the params of the toPath mapped
        var retainedWithToParams = retained.map(applyToParams);
        entering = toPath.slice(keep);
        to = (retainedWithToParams).concat(entering);
        return { from: from, to: to, retained: retained, exiting: exiting, entering: entering };
    };
    /**
     * Return a subpath of a path, which stops at the first matching node
     *
     * Given an array of nodes, returns a subset of the array starting from the first node,
     * stopping when the first node matches the predicate.
     *
     * @param path a path of [[PathNode]]s
     * @param predicate a [[Predicate]] fn that matches [[PathNode]]s
     * @returns a subpath up to the matching node, or undefined if no match is found
     */
    PathFactory.subPath = function (path, predicate) {
        var node = common_1.find(path, predicate);
        var elementIdx = path.indexOf(node);
        return elementIdx === -1 ? undefined : path.slice(0, elementIdx + 1);
    };
    return PathFactory;
}());
/** Gets the raw parameter values from a path */
PathFactory.paramValues = function (path) { return path.reduce(function (acc, node) { return common_1.extend(acc, node.paramValues); }, {}); };
exports.PathFactory = PathFactory;
//# sourceMappingURL=pathFactory.js.map

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/** @module resolve */
/** for typedoc */
var common_1 = __webpack_require__(8);
var hof_1 = __webpack_require__(14);
var trace_1 = __webpack_require__(69);
var coreservices_1 = __webpack_require__(20);
var interface_1 = __webpack_require__(219);
var resolvable_1 = __webpack_require__(81);
var pathFactory_1 = __webpack_require__(106);
var strings_1 = __webpack_require__(48);
var when = interface_1.resolvePolicies.when;
var ALL_WHENS = [when.EAGER, when.LAZY];
var EAGER_WHENS = [when.EAGER];
exports.NATIVE_INJECTOR_TOKEN = "Native Injector";
/**
 * Encapsulates Depenency Injection for a path of nodes
 *
 * UI-Router states are organized as a tree.
 * A nested state has a path of ancestors to the root of the tree.
 * When a state is being activated, each element in the path is wrapped as a [[PathNode]].
 * A `PathNode` is a stateful object that holds things like parameters and resolvables for the state being activated.
 *
 * The ResolveContext closes over the [[PathNode]]s, and provides DI for the last node in the path.
 */
var ResolveContext = (function () {
    function ResolveContext(_path) {
        this._path = _path;
    }
    /** Gets all the tokens found in the resolve context, de-duplicated */
    ResolveContext.prototype.getTokens = function () {
        return this._path.reduce(function (acc, node) { return acc.concat(node.resolvables.map(function (r) { return r.token; })); }, []).reduce(common_1.uniqR, []);
    };
    /**
     * Gets the Resolvable that matches the token
     *
     * Gets the last Resolvable that matches the token in this context, or undefined.
     * Throws an error if it doesn't exist in the ResolveContext
     */
    ResolveContext.prototype.getResolvable = function (token) {
        var matching = this._path.map(function (node) { return node.resolvables; })
            .reduce(common_1.unnestR, [])
            .filter(function (r) { return r.token === token; });
        return common_1.tail(matching);
    };
    /** Returns the [[ResolvePolicy]] for the given [[Resolvable]] */
    ResolveContext.prototype.getPolicy = function (resolvable) {
        var node = this.findNode(resolvable);
        return resolvable.getPolicy(node.state);
    };
    /**
     * Returns a ResolveContext that includes a portion of this one
     *
     * Given a state, this method creates a new ResolveContext from this one.
     * The new context starts at the first node (root) and stops at the node for the `state` parameter.
     *
     * #### Why
     *
     * When a transition is created, the nodes in the "To Path" are injected from a ResolveContext.
     * A ResolveContext closes over a path of [[PathNode]]s and processes the resolvables.
     * The "To State" can inject values from its own resolvables, as well as those from all its ancestor state's (node's).
     * This method is used to create a narrower context when injecting ancestor nodes.
     *
     * @example
     * `let ABCD = new ResolveContext([A, B, C, D]);`
     *
     * Given a path `[A, B, C, D]`, where `A`, `B`, `C` and `D` are nodes for states `a`, `b`, `c`, `d`:
     * When injecting `D`, `D` should have access to all resolvables from `A`, `B`, `C`, `D`.
     * However, `B` should only be able to access resolvables from `A`, `B`.
     *
     * When resolving for the `B` node, first take the full "To Path" Context `[A,B,C,D]` and limit to the subpath `[A,B]`.
     * `let AB = ABCD.subcontext(a)`
     */
    ResolveContext.prototype.subContext = function (state) {
        return new ResolveContext(pathFactory_1.PathFactory.subPath(this._path, function (node) { return node.state === state; }));
    };
    /**
     * Adds Resolvables to the node that matches the state
     *
     * This adds a [[Resolvable]] (generally one created on the fly; not declared on a [[StateDeclaration.resolve]] block).
     * The resolvable is added to the node matching the `state` parameter.
     *
     * These new resolvables are not automatically fetched.
     * The calling code should either fetch them, fetch something that depends on them,
     * or rely on [[resolvePath]] being called when some state is being entered.
     *
     * Note: each resolvable's [[ResolvePolicy]] is merged with the state's policy, and the global default.
     *
     * @param newResolvables the new Resolvables
     * @param state Used to find the node to put the resolvable on
     */
    ResolveContext.prototype.addResolvables = function (newResolvables, state) {
        var node = common_1.find(this._path, hof_1.propEq('state', state));
        var keys = newResolvables.map(function (r) { return r.token; });
        node.resolvables = node.resolvables.filter(function (r) { return keys.indexOf(r.token) === -1; }).concat(newResolvables);
    };
    /**
     * Returns a promise for an array of resolved path Element promises
     *
     * @param when
     * @param trans
     * @returns {Promise<any>|any}
     */
    ResolveContext.prototype.resolvePath = function (when, trans) {
        var _this = this;
        if (when === void 0) { when = "LAZY"; }
        // This option determines which 'when' policy Resolvables we are about to fetch.
        var whenOption = common_1.inArray(ALL_WHENS, when) ? when : "LAZY";
        // If the caller specified EAGER, only the EAGER Resolvables are fetched.
        // if the caller specified LAZY, both EAGER and LAZY Resolvables are fetched.`
        var matchedWhens = whenOption === interface_1.resolvePolicies.when.EAGER ? EAGER_WHENS : ALL_WHENS;
        // get the subpath to the state argument, if provided
        trace_1.trace.traceResolvePath(this._path, when, trans);
        var matchesPolicy = function (acceptedVals, whenOrAsync) {
            return function (resolvable) {
                return common_1.inArray(acceptedVals, _this.getPolicy(resolvable)[whenOrAsync]);
            };
        };
        // Trigger all the (matching) Resolvables in the path
        // Reduce all the "WAIT" Resolvables into an array
        var promises = this._path.reduce(function (acc, node) {
            var nodeResolvables = node.resolvables.filter(matchesPolicy(matchedWhens, 'when'));
            var nowait = nodeResolvables.filter(matchesPolicy(['NOWAIT'], 'async'));
            var wait = nodeResolvables.filter(hof_1.not(matchesPolicy(['NOWAIT'], 'async')));
            // For the matching Resolvables, start their async fetch process.
            var subContext = _this.subContext(node.state);
            var getResult = function (r) { return r.get(subContext, trans)
                .then(function (value) { return ({ token: r.token, value: value }); }); };
            nowait.forEach(getResult);
            return acc.concat(wait.map(getResult));
        }, []);
        // Wait for all the "WAIT" resolvables
        return coreservices_1.services.$q.all(promises);
    };
    ResolveContext.prototype.injector = function () {
        return this._injector || (this._injector = new UIInjectorImpl(this));
    };
    ResolveContext.prototype.findNode = function (resolvable) {
        return common_1.find(this._path, function (node) { return common_1.inArray(node.resolvables, resolvable); });
    };
    /**
     * Gets the async dependencies of a Resolvable
     *
     * Given a Resolvable, returns its dependencies as a Resolvable[]
     */
    ResolveContext.prototype.getDependencies = function (resolvable) {
        var _this = this;
        var node = this.findNode(resolvable);
        // Find which other resolvables are "visible" to the `resolvable` argument
        // subpath stopping at resolvable's node, or the whole path (if the resolvable isn't in the path)
        var subPath = pathFactory_1.PathFactory.subPath(this._path, function (x) { return x === node; }) || this._path;
        var availableResolvables = subPath
            .reduce(function (acc, node) { return acc.concat(node.resolvables); }, []) //all of subpath's resolvables
            .filter(function (res) { return res !== resolvable; }); // filter out the `resolvable` argument
        var getDependency = function (token) {
            var matching = availableResolvables.filter(function (r) { return r.token === token; });
            if (matching.length)
                return common_1.tail(matching);
            var fromInjector = _this.injector().getNative(token);
            if (!fromInjector) {
                throw new Error("Could not find Dependency Injection token: " + strings_1.stringify(token));
            }
            return new resolvable_1.Resolvable(token, function () { return fromInjector; }, [], fromInjector);
        };
        return resolvable.deps.map(getDependency);
    };
    return ResolveContext;
}());
exports.ResolveContext = ResolveContext;
var UIInjectorImpl = (function () {
    function UIInjectorImpl(context) {
        this.context = context;
        this.native = this.get(exports.NATIVE_INJECTOR_TOKEN) || coreservices_1.services.$injector;
    }
    UIInjectorImpl.prototype.get = function (token) {
        var resolvable = this.context.getResolvable(token);
        if (resolvable) {
            if (this.context.getPolicy(resolvable).async === 'NOWAIT') {
                return resolvable.get(this.context);
            }
            if (!resolvable.resolved) {
                throw new Error("Resolvable async .get() not complete:" + strings_1.stringify(resolvable.token));
            }
            return resolvable.data;
        }
        return this.native && this.native.get(token);
    };
    UIInjectorImpl.prototype.getAsync = function (token) {
        var resolvable = this.context.getResolvable(token);
        if (resolvable)
            return resolvable.get(this.context);
        return coreservices_1.services.$q.when(this.native.get(token));
    };
    UIInjectorImpl.prototype.getNative = function (token) {
        return this.native && this.native.get(token);
    };
    return UIInjectorImpl;
}());
//# sourceMappingURL=resolveContext.js.map

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @coreapi
 * @module url
 */ /** for typedoc */
var common_1 = __webpack_require__(8);
var hof_1 = __webpack_require__(14);
var predicates_1 = __webpack_require__(13);
var param_1 = __webpack_require__(70);
var strings_1 = __webpack_require__(48);
/** @hidden */
function quoteRegExp(string, param) {
    var surroundPattern = ['', ''], result = string.replace(/[\\\[\]\^$*+?.()|{}]/g, "\\$&");
    if (!param)
        return result;
    switch (param.squash) {
        case false:
            surroundPattern = ['(', ')' + (param.isOptional ? '?' : '')];
            break;
        case true:
            result = result.replace(/\/$/, '');
            surroundPattern = ['(?:\/(', ')|\/)?'];
            break;
        default:
            surroundPattern = ["(" + param.squash + "|", ')?'];
            break;
    }
    return result + surroundPattern[0] + param.type.pattern.source + surroundPattern[1];
}
/** @hidden */
var memoizeTo = function (obj, prop, fn) {
    return obj[prop] = obj[prop] || fn();
};
/**
 * Matches URLs against patterns.
 *
 * Matches URLs against patterns and extracts named parameters from the path or the search
 * part of the URL.
 *
 * A URL pattern consists of a path pattern, optionally followed by '?' and a list of search (query)
 * parameters. Multiple search parameter names are separated by '&'. Search parameters
 * do not influence whether or not a URL is matched, but their values are passed through into
 * the matched parameters returned by [[UrlMatcher.exec]].
 *
 * - *Path parameters* are defined using curly brace placeholders (`/somepath/{param}`)
 * or colon placeholders (`/somePath/:param`).
 *
 * - *A parameter RegExp* may be defined for a param after a colon
 * (`/somePath/{param:[a-zA-Z0-9]+}`) in a curly brace placeholder.
 * The regexp must match for the url to be matched.
 * Should the regexp itself contain curly braces, they must be in matched pairs or escaped with a backslash.
 *
 * Note: a RegExp parameter will encode its value using either [[ParamTypes.path]] or [[ParamTypes.query]].
 *
 * - *Custom parameter types* may also be specified after a colon (`/somePath/{param:int}`) in curly brace parameters.
 *   See [[UrlMatcherFactory.type]] for more information.
 *
 * - *Catch-all parameters* are defined using an asterisk placeholder (`/somepath/*catchallparam`).
 *   A catch-all * parameter value will contain the remainder of the URL.
 *
 * ---
 *
 * Parameter names may contain only word characters (latin letters, digits, and underscore) and
 * must be unique within the pattern (across both path and search parameters).
 * A path parameter matches any number of characters other than '/'. For catch-all
 * placeholders the path parameter matches any number of characters.
 *
 * Examples:
 *
 * * `'/hello/'` - Matches only if the path is exactly '/hello/'. There is no special treatment for
 *   trailing slashes, and patterns have to match the entire path, not just a prefix.
 * * `'/user/:id'` - Matches '/user/bob' or '/user/1234!!!' or even '/user/' but not '/user' or
 *   '/user/bob/details'. The second path segment will be captured as the parameter 'id'.
 * * `'/user/{id}'` - Same as the previous example, but using curly brace syntax.
 * * `'/user/{id:[^/]*}'` - Same as the previous example.
 * * `'/user/{id:[0-9a-fA-F]{1,8}}'` - Similar to the previous example, but only matches if the id
 *   parameter consists of 1 to 8 hex digits.
 * * `'/files/{path:.*}'` - Matches any URL starting with '/files/' and captures the rest of the
 *   path into the parameter 'path'.
 * * `'/files/*path'` - ditto.
 * * `'/calendar/{start:date}'` - Matches "/calendar/2014-11-12" (because the pattern defined
 *   in the built-in  `date` ParamType matches `2014-11-12`) and provides a Date object in $stateParams.start
 *
 */
var UrlMatcher = (function () {
    /**
     * @param pattern The pattern to compile into a matcher.
     * @param paramTypes The [[ParamTypes]] registry
     * @param config  A configuration object
     * - `caseInsensitive` - `true` if URL matching should be case insensitive, otherwise `false`, the default value (for backward compatibility) is `false`.
     * - `strict` - `false` if matching against a URL with a trailing slash should be treated as equivalent to a URL without a trailing slash, the default value is `true`.
     */
    function UrlMatcher(pattern, paramTypes, paramFactory, config) {
        var _this = this;
        this.config = config;
        /** @hidden */
        this._cache = { path: [this], parent: null, pattern: null };
        /** @hidden */
        this._children = [];
        /** @hidden */
        this._params = [];
        /** @hidden */
        this._segments = [];
        /** @hidden */
        this._compiled = [];
        this.pattern = pattern;
        this.config = common_1.defaults(this.config, {
            params: {},
            strict: true,
            caseInsensitive: false,
            paramMap: common_1.identity
        });
        // Find all placeholders and create a compiled pattern, using either classic or curly syntax:
        //   '*' name
        //   ':' name
        //   '{' name '}'
        //   '{' name ':' regexp '}'
        // The regular expression is somewhat complicated due to the need to allow curly braces
        // inside the regular expression. The placeholder regexp breaks down as follows:
        //    ([:*])([\w\[\]]+)              - classic placeholder ($1 / $2) (search version has - for snake-case)
        //    \{([\w\[\]]+)(?:\:\s*( ... ))?\}  - curly brace placeholder ($3) with optional regexp/type ... ($4) (search version has - for snake-case
        //    (?: ... | ... | ... )+         - the regexp consists of any number of atoms, an atom being either
        //    [^{}\\]+                       - anything other than curly braces or backslash
        //    \\.                            - a backslash escape
        //    \{(?:[^{}\\]+|\\.)*\}          - a matched set of curly braces containing other atoms
        var placeholder = /([:*])([\w\[\]]+)|\{([\w\[\]]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g, searchPlaceholder = /([:]?)([\w\[\].-]+)|\{([\w\[\].-]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g, last = 0, m, patterns = [];
        var checkParamErrors = function (id) {
            if (!UrlMatcher.nameValidator.test(id))
                throw new Error("Invalid parameter name '" + id + "' in pattern '" + pattern + "'");
            if (common_1.find(_this._params, hof_1.propEq('id', id)))
                throw new Error("Duplicate parameter name '" + id + "' in pattern '" + pattern + "'");
        };
        // Split into static segments separated by path parameter placeholders.
        // The number of segments is always 1 more than the number of parameters.
        var matchDetails = function (m, isSearch) {
            // IE[78] returns '' for unmatched groups instead of null
            var id = m[2] || m[3];
            var regexp = isSearch ? m[4] : m[4] || (m[1] === '*' ? '.*' : null);
            var makeRegexpType = function (regexp) { return common_1.inherit(paramTypes.type(isSearch ? "query" : "path"), {
                pattern: new RegExp(regexp, _this.config.caseInsensitive ? 'i' : undefined)
            }); };
            return {
                id: id,
                regexp: regexp,
                cfg: _this.config.params[id],
                segment: pattern.substring(last, m.index),
                type: !regexp ? null : paramTypes.type(regexp) || makeRegexpType(regexp)
            };
        };
        var p, segment;
        while ((m = placeholder.exec(pattern))) {
            p = matchDetails(m, false);
            if (p.segment.indexOf('?') >= 0)
                break; // we're into the search part
            checkParamErrors(p.id);
            this._params.push(paramFactory.fromPath(p.id, p.type, this.config.paramMap(p.cfg, false)));
            this._segments.push(p.segment);
            patterns.push([p.segment, common_1.tail(this._params)]);
            last = placeholder.lastIndex;
        }
        segment = pattern.substring(last);
        // Find any search parameter names and remove them from the last segment
        var i = segment.indexOf('?');
        if (i >= 0) {
            var search = segment.substring(i);
            segment = segment.substring(0, i);
            if (search.length > 0) {
                last = 0;
                while ((m = searchPlaceholder.exec(search))) {
                    p = matchDetails(m, true);
                    checkParamErrors(p.id);
                    this._params.push(paramFactory.fromSearch(p.id, p.type, this.config.paramMap(p.cfg, true)));
                    last = placeholder.lastIndex;
                }
            }
        }
        this._segments.push(segment);
        this._compiled = patterns.map(function (pattern) { return quoteRegExp.apply(null, pattern); }).concat(quoteRegExp(segment));
    }
    /**
     * Creates a new concatenated UrlMatcher
     *
     * Builds a new UrlMatcher by appending another UrlMatcher to this one.
     *
     * @param url A `UrlMatcher` instance to append as a child of the current `UrlMatcher`.
     */
    UrlMatcher.prototype.append = function (url) {
        this._children.push(url);
        url._cache = {
            path: this._cache.path.concat(url),
            parent: this,
            pattern: null,
        };
        return url;
    };
    /** @hidden */
    UrlMatcher.prototype.isRoot = function () {
        return this._cache.path[0] === this;
    };
    /** Returns the input pattern string */
    UrlMatcher.prototype.toString = function () {
        return this.pattern;
    };
    /**
     * Tests the specified url/path against this matcher.
     *
     * Tests if the given url matches this matcher's pattern, and returns an object containing the captured
     * parameter values.  Returns null if the path does not match.
     *
     * The returned object contains the values
     * of any search parameters that are mentioned in the pattern, but their value may be null if
     * they are not present in `search`. This means that search parameters are always treated
     * as optional.
     *
     * #### Example:
     * ```js
     * new UrlMatcher('/user/{id}?q&r').exec('/user/bob', {
     *   x: '1', q: 'hello'
     * });
     * // returns { id: 'bob', q: 'hello', r: null }
     * ```
     *
     * @param path    The URL path to match, e.g. `$location.path()`.
     * @param search  URL search parameters, e.g. `$location.search()`.
     * @param hash    URL hash e.g. `$location.hash()`.
     * @param options
     *
     * @returns The captured parameter values.
     */
    UrlMatcher.prototype.exec = function (path, search, hash, options) {
        var _this = this;
        if (search === void 0) { search = {}; }
        if (options === void 0) { options = {}; }
        var match = memoizeTo(this._cache, 'pattern', function () {
            return new RegExp([
                '^',
                common_1.unnest(_this._cache.path.map(hof_1.prop('_compiled'))).join(''),
                _this.config.strict === false ? '\/?' : '',
                '$'
            ].join(''), _this.config.caseInsensitive ? 'i' : undefined);
        }).exec(path);
        if (!match)
            return null;
        //options = defaults(options, { isolate: false });
        var allParams = this.parameters(), pathParams = allParams.filter(function (param) { return !param.isSearch(); }), searchParams = allParams.filter(function (param) { return param.isSearch(); }), nPathSegments = this._cache.path.map(function (urlm) { return urlm._segments.length - 1; }).reduce(function (a, x) { return a + x; }), values = {};
        if (nPathSegments !== match.length - 1)
            throw new Error("Unbalanced capture group in route '" + this.pattern + "'");
        function decodePathArray(string) {
            var reverseString = function (str) { return str.split("").reverse().join(""); };
            var unquoteDashes = function (str) { return str.replace(/\\-/g, "-"); };
            var split = reverseString(string).split(/-(?!\\)/);
            var allReversed = common_1.map(split, reverseString);
            return common_1.map(allReversed, unquoteDashes).reverse();
        }
        for (var i = 0; i < nPathSegments; i++) {
            var param = pathParams[i];
            var value = match[i + 1];
            // if the param value matches a pre-replace pair, replace the value before decoding.
            for (var j = 0; j < param.replace.length; j++) {
                if (param.replace[j].from === value)
                    value = param.replace[j].to;
            }
            if (value && param.array === true)
                value = decodePathArray(value);
            if (predicates_1.isDefined(value))
                value = param.type.decode(value);
            values[param.id] = param.value(value);
        }
        searchParams.forEach(function (param) {
            var value = search[param.id];
            for (var j = 0; j < param.replace.length; j++) {
                if (param.replace[j].from === value)
                    value = param.replace[j].to;
            }
            if (predicates_1.isDefined(value))
                value = param.type.decode(value);
            values[param.id] = param.value(value);
        });
        if (hash)
            values["#"] = hash;
        return values;
    };
    /**
     * @hidden
     * Returns all the [[Param]] objects of all path and search parameters of this pattern in order of appearance.
     *
     * @returns {Array.<Param>}  An array of [[Param]] objects. Must be treated as read-only. If the
     *    pattern has no parameters, an empty array is returned.
     */
    UrlMatcher.prototype.parameters = function (opts) {
        if (opts === void 0) { opts = {}; }
        if (opts.inherit === false)
            return this._params;
        return common_1.unnest(this._cache.path.map(hof_1.prop('_params')));
    };
    /**
     * @hidden
     * Returns a single parameter from this UrlMatcher by id
     *
     * @param id
     * @param opts
     * @returns {T|Param|any|boolean|UrlMatcher|null}
     */
    UrlMatcher.prototype.parameter = function (id, opts) {
        if (opts === void 0) { opts = {}; }
        var parent = this._cache.parent;
        return (common_1.find(this._params, hof_1.propEq('id', id)) ||
            (opts.inherit !== false && parent && parent.parameter(id, opts)) ||
            null);
    };
    /**
     * Validates the input parameter values against this UrlMatcher
     *
     * Checks an object hash of parameters to validate their correctness according to the parameter
     * types of this `UrlMatcher`.
     *
     * @param params The object hash of parameters to validate.
     * @returns Returns `true` if `params` validates, otherwise `false`.
     */
    UrlMatcher.prototype.validates = function (params) {
        var _this = this;
        var validParamVal = function (param, val) {
            return !param || param.validates(val);
        };
        return common_1.pairs(params || {}).map(function (_a) {
            var key = _a[0], val = _a[1];
            return validParamVal(_this.parameter(key), val);
        }).reduce(common_1.allTrueR, true);
    };
    /**
     * Given a set of parameter values, creates a URL from this UrlMatcher.
     *
     * Creates a URL that matches this pattern by substituting the specified values
     * for the path and search parameters.
     *
     * #### Example:
     * ```js
     * new UrlMatcher('/user/{id}?q').format({ id:'bob', q:'yes' });
     * // returns '/user/bob?q=yes'
     * ```
     *
     * @param values  the values to substitute for the parameters in this pattern.
     * @returns the formatted URL (path and optionally search part).
     */
    UrlMatcher.prototype.format = function (values) {
        if (values === void 0) { values = {}; }
        if (!this.validates(values))
            return null;
        // Build the full path of UrlMatchers (including all parent UrlMatchers)
        var urlMatchers = this._cache.path;
        // Extract all the static segments and Params into an ordered array
        var pathSegmentsAndParams = urlMatchers.map(UrlMatcher.pathSegmentsAndParams).reduce(common_1.unnestR, []);
        // Extract the query params into a separate array
        var queryParams = urlMatchers.map(UrlMatcher.queryParams).reduce(common_1.unnestR, []);
        /**
         * Given a Param,
         * Applies the parameter value, then returns details about it
         */
        function getDetails(param) {
            // Normalize to typed value
            var value = param.value(values[param.id]);
            var isDefaultValue = param.isDefaultValue(value);
            // Check if we're in squash mode for the parameter
            var squash = isDefaultValue ? param.squash : false;
            // Allow the Parameter's Type to encode the value
            var encoded = param.type.encode(value);
            return { param: param, value: value, isDefaultValue: isDefaultValue, squash: squash, encoded: encoded };
        }
        // Build up the path-portion from the list of static segments and parameters
        var pathString = pathSegmentsAndParams.reduce(function (acc, x) {
            // The element is a static segment (a raw string); just append it
            if (predicates_1.isString(x))
                return acc + x;
            // Otherwise, it's a Param.  Fetch details about the parameter value
            var _a = getDetails(x), squash = _a.squash, encoded = _a.encoded, param = _a.param;
            // If squash is === true, try to remove a slash from the path
            if (squash === true)
                return (acc.match(/\/$/)) ? acc.slice(0, -1) : acc;
            // If squash is a string, use the string for the param value
            if (predicates_1.isString(squash))
                return acc + squash;
            if (squash !== false)
                return acc; // ?
            if (encoded == null)
                return acc;
            // If this parameter value is an array, encode the value using encodeDashes
            if (predicates_1.isArray(encoded))
                return acc + common_1.map(encoded, UrlMatcher.encodeDashes).join("-");
            // If the parameter type is "raw", then do not encodeURIComponent
            if (param.raw)
                return acc + encoded;
            // Encode the value
            return acc + encodeURIComponent(encoded);
        }, "");
        // Build the query string by applying parameter values (array or regular)
        // then mapping to key=value, then flattening and joining using "&"
        var queryString = queryParams.map(function (param) {
            var _a = getDetails(param), squash = _a.squash, encoded = _a.encoded, isDefaultValue = _a.isDefaultValue;
            if (encoded == null || (isDefaultValue && squash !== false))
                return;
            if (!predicates_1.isArray(encoded))
                encoded = [encoded];
            if (encoded.length === 0)
                return;
            if (!param.raw)
                encoded = common_1.map(encoded, encodeURIComponent);
            return encoded.map(function (val) { return param.id + "=" + val; });
        }).filter(common_1.identity).reduce(common_1.unnestR, []).join("&");
        // Concat the pathstring with the queryString (if exists) and the hashString (if exists)
        return pathString + (queryString ? "?" + queryString : "") + (values["#"] ? "#" + values["#"] : "");
    };
    /** @hidden */
    UrlMatcher.encodeDashes = function (str) {
        return encodeURIComponent(str).replace(/-/g, function (c) { return "%5C%" + c.charCodeAt(0).toString(16).toUpperCase(); });
    };
    /** @hidden Given a matcher, return an array with the matcher's path segments and path params, in order */
    UrlMatcher.pathSegmentsAndParams = function (matcher) {
        var staticSegments = matcher._segments;
        var pathParams = matcher._params.filter(function (p) { return p.location === param_1.DefType.PATH; });
        return common_1.arrayTuples(staticSegments, pathParams.concat(undefined))
            .reduce(common_1.unnestR, [])
            .filter(function (x) { return x !== "" && predicates_1.isDefined(x); });
    };
    /** @hidden Given a matcher, return an array with the matcher's query params */
    UrlMatcher.queryParams = function (matcher) {
        return matcher._params.filter(function (p) { return p.location === param_1.DefType.SEARCH; });
    };
    /**
     * Compare two UrlMatchers
     *
     * This comparison function converts a UrlMatcher into static and dynamic path segments.
     * Each static path segment is a static string between a path separator (slash character).
     * Each dynamic segment is a path parameter.
     *
     * The comparison function sorts static segments before dynamic ones.
     */
    UrlMatcher.compare = function (a, b) {
        var splitOnSlash = strings_1.splitOnDelim('/');
        /**
         * Turn a UrlMatcher and all its parent matchers into an array
         * of slash literals '/', string literals, and Param objects
         *
         * This example matcher matches strings like "/foo/:param/tail":
         * var matcher = $umf.compile("/foo").append($umf.compile("/:param")).append($umf.compile("/")).append($umf.compile("tail"));
         * var result = segments(matcher); // [ '/', 'foo', '/', Param, '/', 'tail' ]
         *
         */
        var segments = function (matcher) {
            return matcher._cache.path.map(UrlMatcher.pathSegmentsAndParams)
                .reduce(common_1.unnestR, [])
                .reduce(strings_1.joinNeighborsR, [])
                .map(function (x) { return predicates_1.isString(x) ? splitOnSlash(x) : x; })
                .reduce(common_1.unnestR, []);
        };
        var aSegments = segments(a), bSegments = segments(b);
        // console.table( { aSegments, bSegments });
        // Sort slashes first, then static strings, the Params
        var weight = hof_1.pattern([
            [hof_1.eq("/"), hof_1.val(1)],
            [predicates_1.isString, hof_1.val(2)],
            [hof_1.is(param_1.Param), hof_1.val(3)]
        ]);
        var pairs = common_1.arrayTuples(aSegments.map(weight), bSegments.map(weight));
        // console.table(pairs);
        return pairs.reduce(function (cmp, weightPair) { return cmp !== 0 ? cmp : weightPair[0] - weightPair[1]; }, 0);
    };
    return UrlMatcher;
}());
/** @hidden */
UrlMatcher.nameValidator = /^\w+([-.]+\w+)*(?:\[\])?$/;
exports.UrlMatcher = UrlMatcher;
//# sourceMappingURL=urlMatcher.js.map

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var stringify = __webpack_require__(344);

var _window =
  typeof window !== 'undefined'
    ? window
    : typeof global !== 'undefined'
      ? global
      : typeof self !== 'undefined'
        ? self
        : {};

function isObject(what) {
  return typeof what === 'object' && what !== null;
}

// Yanked from https://git.io/vS8DV re-used under CC0
// with some tiny modifications
function isError(value) {
  switch (Object.prototype.toString.call(value)) {
    case '[object Error]':
      return true;
    case '[object Exception]':
      return true;
    case '[object DOMException]':
      return true;
    default:
      return value instanceof Error;
  }
}

function isErrorEvent(value) {
  return Object.prototype.toString.call(value) === '[object ErrorEvent]';
}

function isDOMError(value) {
  return Object.prototype.toString.call(value) === '[object DOMError]';
}

function isDOMException(value) {
  return Object.prototype.toString.call(value) === '[object DOMException]';
}

function isUndefined(what) {
  return what === void 0;
}

function isFunction(what) {
  return typeof what === 'function';
}

function isPlainObject(what) {
  return Object.prototype.toString.call(what) === '[object Object]';
}

function isString(what) {
  return Object.prototype.toString.call(what) === '[object String]';
}

function isArray(what) {
  return Object.prototype.toString.call(what) === '[object Array]';
}

function isEmptyObject(what) {
  if (!isPlainObject(what)) return false;

  for (var _ in what) {
    if (what.hasOwnProperty(_)) {
      return false;
    }
  }
  return true;
}

function supportsErrorEvent() {
  try {
    new ErrorEvent(''); // eslint-disable-line no-new
    return true;
  } catch (e) {
    return false;
  }
}

function supportsDOMError() {
  try {
    new DOMError(''); // eslint-disable-line no-new
    return true;
  } catch (e) {
    return false;
  }
}

function supportsDOMException() {
  try {
    new DOMException(''); // eslint-disable-line no-new
    return true;
  } catch (e) {
    return false;
  }
}

function supportsFetch() {
  if (!('fetch' in _window)) return false;

  try {
    new Headers(); // eslint-disable-line no-new
    new Request(''); // eslint-disable-line no-new
    new Response(); // eslint-disable-line no-new
    return true;
  } catch (e) {
    return false;
  }
}

// Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
// https://caniuse.com/#feat=referrer-policy
// It doesn't. And it throw exception instead of ignoring this parameter...
// REF: https://github.com/getsentry/raven-js/issues/1233
function supportsReferrerPolicy() {
  if (!supportsFetch()) return false;

  try {
    // eslint-disable-next-line no-new
    new Request('pickleRick', {
      referrerPolicy: 'origin'
    });
    return true;
  } catch (e) {
    return false;
  }
}

function supportsPromiseRejectionEvent() {
  return typeof PromiseRejectionEvent === 'function';
}

function wrappedCallback(callback) {
  function dataCallback(data, original) {
    var normalizedData = callback(data) || data;
    if (original) {
      return original(normalizedData) || normalizedData;
    }
    return normalizedData;
  }

  return dataCallback;
}

function each(obj, callback) {
  var i, j;

  if (isUndefined(obj.length)) {
    for (i in obj) {
      if (hasKey(obj, i)) {
        callback.call(null, i, obj[i]);
      }
    }
  } else {
    j = obj.length;
    if (j) {
      for (i = 0; i < j; i++) {
        callback.call(null, i, obj[i]);
      }
    }
  }
}

function objectMerge(obj1, obj2) {
  if (!obj2) {
    return obj1;
  }
  each(obj2, function(key, value) {
    obj1[key] = value;
  });
  return obj1;
}

/**
 * This function is only used for react-native.
 * react-native freezes object that have already been sent over the
 * js bridge. We need this function in order to check if the object is frozen.
 * So it's ok that objectFrozen returns false if Object.isFrozen is not
 * supported because it's not relevant for other "platforms". See related issue:
 * https://github.com/getsentry/react-native-sentry/issues/57
 */
function objectFrozen(obj) {
  if (!Object.isFrozen) {
    return false;
  }
  return Object.isFrozen(obj);
}

function truncate(str, max) {
  if (typeof max !== 'number') {
    throw new Error('2nd argument to `truncate` function should be a number');
  }
  if (typeof str !== 'string' || max === 0) {
    return str;
  }
  return str.length <= max ? str : str.substr(0, max) + '\u2026';
}

/**
 * hasKey, a better form of hasOwnProperty
 * Example: hasKey(MainHostObject, property) === true/false
 *
 * @param {Object} host object to check property
 * @param {string} key to check
 */
function hasKey(object, key) {
  return Object.prototype.hasOwnProperty.call(object, key);
}

function joinRegExp(patterns) {
  // Combine an array of regular expressions and strings into one large regexp
  // Be mad.
  var sources = [],
    i = 0,
    len = patterns.length,
    pattern;

  for (; i < len; i++) {
    pattern = patterns[i];
    if (isString(pattern)) {
      // If it's a string, we need to escape it
      // Taken from: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
      sources.push(pattern.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1'));
    } else if (pattern && pattern.source) {
      // If it's a regexp already, we want to extract the source
      sources.push(pattern.source);
    }
    // Intentionally skip other cases
  }
  return new RegExp(sources.join('|'), 'i');
}

function urlencode(o) {
  var pairs = [];
  each(o, function(key, value) {
    pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
  });
  return pairs.join('&');
}

// borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
// intentionally using regex and not <a/> href parsing trick because React Native and other
// environments where DOM might not be available
function parseUrl(url) {
  if (typeof url !== 'string') return {};
  var match = url.match(/^(([^:\/?#]+):)?(\/\/([^\/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);

  // coerce to undefined values to empty string so we don't get 'undefined'
  var query = match[6] || '';
  var fragment = match[8] || '';
  return {
    protocol: match[2],
    host: match[4],
    path: match[5],
    relative: match[5] + query + fragment // everything minus origin
  };
}
function uuid4() {
  var crypto = _window.crypto || _window.msCrypto;

  if (!isUndefined(crypto) && crypto.getRandomValues) {
    // Use window.crypto API if available
    // eslint-disable-next-line no-undef
    var arr = new Uint16Array(8);
    crypto.getRandomValues(arr);

    // set 4 in byte 7
    arr[3] = (arr[3] & 0xfff) | 0x4000;
    // set 2 most significant bits of byte 9 to '10'
    arr[4] = (arr[4] & 0x3fff) | 0x8000;

    var pad = function(num) {
      var v = num.toString(16);
      while (v.length < 4) {
        v = '0' + v;
      }
      return v;
    };

    return (
      pad(arr[0]) +
      pad(arr[1]) +
      pad(arr[2]) +
      pad(arr[3]) +
      pad(arr[4]) +
      pad(arr[5]) +
      pad(arr[6]) +
      pad(arr[7])
    );
  } else {
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = (Math.random() * 16) | 0,
        v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }
}

/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @param elem
 * @returns {string}
 */
function htmlTreeAsString(elem) {
  /* eslint no-extra-parens:0*/
  var MAX_TRAVERSE_HEIGHT = 5,
    MAX_OUTPUT_LEN = 80,
    out = [],
    height = 0,
    len = 0,
    separator = ' > ',
    sepLength = separator.length,
    nextStr;

  while (elem && height++ < MAX_TRAVERSE_HEIGHT) {
    nextStr = htmlElementAsString(elem);
    // bail out if
    // - nextStr is the 'html' element
    // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
    //   (ignore this limit if we are on the first iteration)
    if (
      nextStr === 'html' ||
      (height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN)
    ) {
      break;
    }

    out.push(nextStr);

    len += nextStr.length;
    elem = elem.parentNode;
  }

  return out.reverse().join(separator);
}

/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @param HTMLElement
 * @returns {string}
 */
function htmlElementAsString(elem) {
  var out = [],
    className,
    classes,
    key,
    attr,
    i;

  if (!elem || !elem.tagName) {
    return '';
  }

  out.push(elem.tagName.toLowerCase());
  if (elem.id) {
    out.push('#' + elem.id);
  }

  className = elem.className;
  if (className && isString(className)) {
    classes = className.split(/\s+/);
    for (i = 0; i < classes.length; i++) {
      out.push('.' + classes[i]);
    }
  }
  var attrWhitelist = ['type', 'name', 'title', 'alt'];
  for (i = 0; i < attrWhitelist.length; i++) {
    key = attrWhitelist[i];
    attr = elem.getAttribute(key);
    if (attr) {
      out.push('[' + key + '="' + attr + '"]');
    }
  }
  return out.join('');
}

/**
 * Returns true if either a OR b is truthy, but not both
 */
function isOnlyOneTruthy(a, b) {
  return !!(!!a ^ !!b);
}

/**
 * Returns true if both parameters are undefined
 */
function isBothUndefined(a, b) {
  return isUndefined(a) && isUndefined(b);
}

/**
 * Returns true if the two input exception interfaces have the same content
 */
function isSameException(ex1, ex2) {
  if (isOnlyOneTruthy(ex1, ex2)) return false;

  ex1 = ex1.values[0];
  ex2 = ex2.values[0];

  if (ex1.type !== ex2.type || ex1.value !== ex2.value) return false;

  // in case both stacktraces are undefined, we can't decide so default to false
  if (isBothUndefined(ex1.stacktrace, ex2.stacktrace)) return false;

  return isSameStacktrace(ex1.stacktrace, ex2.stacktrace);
}

/**
 * Returns true if the two input stack trace interfaces have the same content
 */
function isSameStacktrace(stack1, stack2) {
  if (isOnlyOneTruthy(stack1, stack2)) return false;

  var frames1 = stack1.frames;
  var frames2 = stack2.frames;

  // Exit early if stacktrace is malformed
  if (frames1 === undefined || frames2 === undefined) return false;

  // Exit early if frame count differs
  if (frames1.length !== frames2.length) return false;

  // Iterate through every frame; bail out if anything differs
  var a, b;
  for (var i = 0; i < frames1.length; i++) {
    a = frames1[i];
    b = frames2[i];
    if (
      a.filename !== b.filename ||
      a.lineno !== b.lineno ||
      a.colno !== b.colno ||
      a['function'] !== b['function']
    )
      return false;
  }
  return true;
}

/**
 * Polyfill a method
 * @param obj object e.g. `document`
 * @param name method name present on object e.g. `addEventListener`
 * @param replacement replacement function
 * @param track {optional} record instrumentation to an array
 */
function fill(obj, name, replacement, track) {
  if (obj == null) return;
  var orig = obj[name];
  obj[name] = replacement(orig);
  obj[name].__raven__ = true;
  obj[name].__orig__ = orig;
  if (track) {
    track.push([obj, name, orig]);
  }
}

/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns {string}
 */
function safeJoin(input, delimiter) {
  if (!isArray(input)) return '';

  var output = [];

  for (var i = 0; i < input.length; i++) {
    try {
      output.push(String(input[i]));
    } catch (e) {
      output.push('[value cannot be serialized]');
    }
  }

  return output.join(delimiter);
}

// Default Node.js REPL depth
var MAX_SERIALIZE_EXCEPTION_DEPTH = 3;
// 50kB, as 100kB is max payload size, so half sounds reasonable
var MAX_SERIALIZE_EXCEPTION_SIZE = 50 * 1024;
var MAX_SERIALIZE_KEYS_LENGTH = 40;

function utf8Length(value) {
  return ~-encodeURI(value).split(/%..|./).length;
}

function jsonSize(value) {
  return utf8Length(JSON.stringify(value));
}

function serializeValue(value) {
  if (typeof value === 'string') {
    var maxLength = 40;
    return truncate(value, maxLength);
  } else if (
    typeof value === 'number' ||
    typeof value === 'boolean' ||
    typeof value === 'undefined'
  ) {
    return value;
  }

  var type = Object.prototype.toString.call(value);

  // Node.js REPL notation
  if (type === '[object Object]') return '[Object]';
  if (type === '[object Array]') return '[Array]';
  if (type === '[object Function]')
    return value.name ? '[Function: ' + value.name + ']' : '[Function]';

  return value;
}

function serializeObject(value, depth) {
  if (depth === 0) return serializeValue(value);

  if (isPlainObject(value)) {
    return Object.keys(value).reduce(function(acc, key) {
      acc[key] = serializeObject(value[key], depth - 1);
      return acc;
    }, {});
  } else if (Array.isArray(value)) {
    return value.map(function(val) {
      return serializeObject(val, depth - 1);
    });
  }

  return serializeValue(value);
}

function serializeException(ex, depth, maxSize) {
  if (!isPlainObject(ex)) return ex;

  depth = typeof depth !== 'number' ? MAX_SERIALIZE_EXCEPTION_DEPTH : depth;
  maxSize = typeof depth !== 'number' ? MAX_SERIALIZE_EXCEPTION_SIZE : maxSize;

  var serialized = serializeObject(ex, depth);

  if (jsonSize(stringify(serialized)) > maxSize) {
    return serializeException(ex, depth - 1);
  }

  return serialized;
}

function serializeKeysForMessage(keys, maxLength) {
  if (typeof keys === 'number' || typeof keys === 'string') return keys.toString();
  if (!Array.isArray(keys)) return '';

  keys = keys.filter(function(key) {
    return typeof key === 'string';
  });
  if (keys.length === 0) return '[object has no keys]';

  maxLength = typeof maxLength !== 'number' ? MAX_SERIALIZE_KEYS_LENGTH : maxLength;
  if (keys[0].length >= maxLength) return keys[0];

  for (var usedKeys = keys.length; usedKeys > 0; usedKeys--) {
    var serialized = keys.slice(0, usedKeys).join(', ');
    if (serialized.length > maxLength) continue;
    if (usedKeys === keys.length) return serialized;
    return serialized + '\u2026';
  }

  return '';
}

function sanitize(input, sanitizeKeys) {
  if (!isArray(sanitizeKeys) || (isArray(sanitizeKeys) && sanitizeKeys.length === 0))
    return input;

  var sanitizeRegExp = joinRegExp(sanitizeKeys);
  var sanitizeMask = '********';
  var safeInput;

  try {
    safeInput = JSON.parse(stringify(input));
  } catch (o_O) {
    return input;
  }

  function sanitizeWorker(workerInput) {
    if (isArray(workerInput)) {
      return workerInput.map(function(val) {
        return sanitizeWorker(val);
      });
    }

    if (isPlainObject(workerInput)) {
      return Object.keys(workerInput).reduce(function(acc, k) {
        if (sanitizeRegExp.test(k)) {
          acc[k] = sanitizeMask;
        } else {
          acc[k] = sanitizeWorker(workerInput[k]);
        }
        return acc;
      }, {});
    }

    return workerInput;
  }

  return sanitizeWorker(safeInput);
}

module.exports = {
  isObject: isObject,
  isError: isError,
  isErrorEvent: isErrorEvent,
  isDOMError: isDOMError,
  isDOMException: isDOMException,
  isUndefined: isUndefined,
  isFunction: isFunction,
  isPlainObject: isPlainObject,
  isString: isString,
  isArray: isArray,
  isEmptyObject: isEmptyObject,
  supportsErrorEvent: supportsErrorEvent,
  supportsDOMError: supportsDOMError,
  supportsDOMException: supportsDOMException,
  supportsFetch: supportsFetch,
  supportsReferrerPolicy: supportsReferrerPolicy,
  supportsPromiseRejectionEvent: supportsPromiseRejectionEvent,
  wrappedCallback: wrappedCallback,
  each: each,
  objectMerge: objectMerge,
  truncate: truncate,
  objectFrozen: objectFrozen,
  hasKey: hasKey,
  joinRegExp: joinRegExp,
  urlencode: urlencode,
  uuid4: uuid4,
  htmlTreeAsString: htmlTreeAsString,
  htmlElementAsString: htmlElementAsString,
  isSameException: isSameException,
  isSameStacktrace: isSameStacktrace,
  parseUrl: parseUrl,
  fill: fill,
  safeJoin: safeJoin,
  serializeException: serializeException,
  serializeKeysForMessage: serializeKeysForMessage,
  sanitize: sanitize
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),
/* 110 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE3LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4iICJodHRwOi8vd3d3LnczLm9yZy9HcmFwaGljcy9TVkcvMS4xL0RURC9zdmcxMS5kdGQiPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IuWbvuWxgl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIKCSB3aWR0aD0iMTY0cHgiIGhlaWdodD0iMTY0cHgiIHZpZXdCb3g9IjAgMCAxNjQgMTY0IiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAxNjQgMTY0IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPGNpcmNsZSBmaWxsPSIjRjJGMkYxIiBjeD0iODIuMjgiIGN5PSI4MS43MiIgcj0iODEuNzIiLz4KPHJlY3QgeD0iNDEuNTc4IiB5PSIzMi4xNjQiIGZpbGw9IiNERURFREUiIHdpZHRoPSI4MS4yODIiIGhlaWdodD0iOTkuMjM0Ii8+Cjxwb2x5Z29uIGZpbGw9IiNGRkZGRkYiIHBvaW50cz0iMTE2LjgxOSwxMDEuMjM1IDExNi44MTksMzkuNTQgNDcuNjIsMzkuNTQgNDcuNjIsMTI0LjAyMiA5NC4wMzIsMTI0LjAyMiAiLz4KPHBvbHlnb24gZmlsbD0iI0YyRjJGMSIgcG9pbnRzPSI5NC4xOTEsMTAxLjIzNSAxMTYuOTc4LDEwMS4yMzUgOTQuMTkxLDEyNC4wMjIgIi8+CjxyZWN0IHg9IjU0LjE1OSIgeT0iNTEuNDg1IiBmaWxsPSIjRjJGMkYxIiB3aWR0aD0iNTYuMTIiIGhlaWdodD0iNS40ODUiLz4KPHJlY3QgeD0iNTQuMTU5IiB5PSI2NS40NDciIGZpbGw9IiNGMkYyRjEiIHdpZHRoPSI1Ni4xMiIgaGVpZ2h0PSI1LjQ4NSIvPgo8cmVjdCB4PSI1NC4xNTkiIHk9Ijc5LjAzOCIgZmlsbD0iI0YyRjJGMSIgd2lkdGg9IjU2LjEyIiBoZWlnaHQ9IjUuNDg1Ii8+CjxyZWN0IHg9IjU0LjE1OSIgeT0iOTMuMzcyIiBmaWxsPSIjRjJGMkYxIiB3aWR0aD0iMjguNjM4IiBoZWlnaHQ9IjUuNDg1Ii8+Cjwvc3ZnPgo="

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9991e860302d59c297dbb44b4ae7addd.gif";

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _fancyboxPlus = __webpack_require__(730);

var _fancyboxPlus2 = _interopRequireDefault(_fancyboxPlus);

var _fancyboxable = __webpack_require__(731);

var _fancyboxable2 = _interopRequireDefault(_fancyboxable);

var _fancybox = __webpack_require__(732);

var _fancybox2 = _interopRequireDefault(_fancybox);

__webpack_require__(734);

__webpack_require__(735);

__webpack_require__(739);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fancyboxModule = _angular2.default.module('fancyboxPlus', []).service('fancyboxService', _fancyboxPlus2.default).directive('fancyboxable', _fancyboxable2.default).directive('fancybox', _fancybox2.default).name; /**
                                                                                                                                                                                                                        * Created by ganlu on 27/12/2016.
                                                                                                                                                                                                                        */
exports.default = fancyboxModule;

/***/ }),
/* 113 */
/***/ (function(module, exports) {

/*global angular */

(function (angular) {
    "use strict";

    // -- MODULE DECLARATION
    angular.module("ngFilesizeFilter", [])

    // FILTER
    .filter("filesize", function () {

        /**
         * An array of units, starting at bytes and ending with yottabytes.
         */
        var units = ["B", "kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

        return function(bytes, precision) {

            // validate 'bytes'
            if (isNaN(parseFloat(bytes))) {
                return "-";
            }
            if (bytes < 1) {
                return "0 B";
            }

            // validate 'precision'
            if (isNaN(precision)) {
                precision = 1;
            }

            var unitIndex = Math.floor(Math.log(bytes) / Math.log(1000)),
                value = bytes / Math.pow(1000, unitIndex);

            return value.toFixed(precision) + " " + units[unitIndex];

        };

    });

})(angular);


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(176);
var defined = __webpack_require__(154);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(361);
var enumBugKeys = __webpack_require__(178);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 116 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(154);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(72).f;
var has = __webpack_require__(86);
var TAG = __webpack_require__(32)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(11);
var document = __webpack_require__(7).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(7);
var core = __webpack_require__(33);
var LIBRARY = __webpack_require__(46);
var wksExt = __webpack_require__(185);
var defineProperty = __webpack_require__(16).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(89)('keys');
var uid = __webpack_require__(53);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 122 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(7).document;
module.exports = document && document.documentElement;


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(11);
var anObject = __webpack_require__(6);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(34)(Function.call, __webpack_require__(28).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 125 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(11);
var setPrototypeOf = __webpack_require__(124).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(39);
var defined = __webpack_require__(38);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 128 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 129 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(39);
var defined = __webpack_require__(38);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(46);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(22);
var hide = __webpack_require__(21);
var Iterators = __webpack_require__(67);
var $iterCreate = __webpack_require__(132);
var setToStringTag = __webpack_require__(65);
var getPrototypeOf = __webpack_require__(29);
var ITERATOR = __webpack_require__(12)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(56);
var descriptor = __webpack_require__(52);
var setToStringTag = __webpack_require__(65);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(21)(IteratorPrototype, __webpack_require__(12)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(93);
var defined = __webpack_require__(38);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(12)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(67);
var ITERATOR = __webpack_require__(12)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(16);
var createDesc = __webpack_require__(52);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(77);
var ITERATOR = __webpack_require__(12)('iterator');
var Iterators = __webpack_require__(67);
module.exports = __webpack_require__(33).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(471);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(18);
var toAbsoluteIndex = __webpack_require__(55);
var toLength = __webpack_require__(17);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(47);
var step = __webpack_require__(201);
var Iterators = __webpack_require__(67);
var toIObject = __webpack_require__(27);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(131)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(34);
var invoke = __webpack_require__(191);
var html = __webpack_require__(123);
var cel = __webpack_require__(119);
var global = __webpack_require__(7);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(35)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(7);
var macrotask = __webpack_require__(141).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(35)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(19);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(7);
var DESCRIPTORS = __webpack_require__(15);
var LIBRARY = __webpack_require__(46);
var $typed = __webpack_require__(100);
var hide = __webpack_require__(21);
var redefineAll = __webpack_require__(61);
var fails = __webpack_require__(10);
var anInstance = __webpack_require__(59);
var toInteger = __webpack_require__(39);
var toLength = __webpack_require__(17);
var toIndex = __webpack_require__(210);
var gOPN = __webpack_require__(57).f;
var dP = __webpack_require__(16).f;
var arrayFill = __webpack_require__(139);
var setToStringTag = __webpack_require__(65);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @module common
 */ /** for typedoc */

var Queue = (function () {
    function Queue(_items, _limit) {
        if (_items === void 0) { _items = []; }
        if (_limit === void 0) { _limit = null; }
        this._items = _items;
        this._limit = _limit;
    }
    Queue.prototype.enqueue = function (item) {
        var items = this._items;
        items.push(item);
        if (this._limit && items.length > this._limit)
            items.shift();
        return item;
    };
    Queue.prototype.dequeue = function () {
        if (this.size())
            return this._items.splice(0, 1)[0];
    };
    Queue.prototype.clear = function () {
        var current = this._items;
        this._items = [];
        return current;
    };
    Queue.prototype.size = function () {
        return this._items.length;
    };
    Queue.prototype.remove = function (item) {
        var idx = this._items.indexOf(item);
        return idx > -1 && this._items.splice(idx, 1)[0];
    };
    Queue.prototype.peekTail = function () {
        return this._items[this._items.length - 1];
    };
    Queue.prototype.peekHead = function () {
        if (this.size())
            return this._items[0];
    };
    return Queue;
}());
exports.Queue = Queue;
//# sourceMappingURL=queue.js.map

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var trace_1 = __webpack_require__(69);
var coreservices_1 = __webpack_require__(20);
var common_1 = __webpack_require__(8);
var predicates_1 = __webpack_require__(13);
var hof_1 = __webpack_require__(14);
var interface_1 = __webpack_require__(79);
var transitionHook_1 = __webpack_require__(80);
var hookRegistry_1 = __webpack_require__(147);
var hookBuilder_1 = __webpack_require__(218);
var node_1 = __webpack_require__(105);
var pathFactory_1 = __webpack_require__(106);
var targetState_1 = __webpack_require__(62);
var param_1 = __webpack_require__(70);
var resolvable_1 = __webpack_require__(81);
var rejectFactory_1 = __webpack_require__(78);
var resolveContext_1 = __webpack_require__(107);
var router_1 = __webpack_require__(220);
/** @hidden */
var stateSelf = hof_1.prop("self");
/**
 * Represents a transition between two states.
 *
 * When navigating to a state, we are transitioning **from** the current state **to** the new state.
 *
 * This object contains all contextual information about the to/from states, parameters, resolves.
 * It has information about all states being entered and exited as a result of the transition.
 */
var Transition = (function () {
    /**
     * Creates a new Transition object.
     *
     * If the target state is not valid, an error is thrown.
     *
     * @internalapi
     *
     * @param fromPath The path of [[PathNode]]s from which the transition is leaving.  The last node in the `fromPath`
     *        encapsulates the "from state".
     * @param targetState The target state and parameters being transitioned to (also, the transition options)
     * @param router The [[UIRouter]] instance
     */
    function Transition(fromPath, targetState, router) {
        var _this = this;
        /** @hidden */
        this._deferred = coreservices_1.services.$q.defer();
        /**
         * This promise is resolved or rejected based on the outcome of the Transition.
         *
         * When the transition is successful, the promise is resolved
         * When the transition is unsuccessful, the promise is rejected with the [[TransitionRejection]] or javascript error
         */
        this.promise = this._deferred.promise;
        /** @hidden Holds the hook registration functions such as those passed to Transition.onStart() */
        this._registeredHooks = {};
        /**
         * Checks if this transition is currently active/running.
         */
        this.isActive = function () { return _this === _this._options.current(); };
        this.router = router;
        this._targetState = targetState;
        if (!targetState.valid()) {
            throw new Error(targetState.error());
        }
        // current() is assumed to come from targetState.options, but provide a naive implementation otherwise.
        this._options = common_1.extend({ current: hof_1.val(this) }, targetState.options());
        this.$id = router.transitionService._transitionCount++;
        var toPath = pathFactory_1.PathFactory.buildToPath(fromPath, targetState);
        this._treeChanges = pathFactory_1.PathFactory.treeChanges(fromPath, toPath, this._options.reloadState);
        this.createTransitionHookRegFns();
        var onCreateHooks = this.hookBuilder().buildHooksForPhase(interface_1.TransitionHookPhase.CREATE);
        transitionHook_1.TransitionHook.runAllHooks(onCreateHooks);
        this.applyViewConfigs(router);
        this.applyRootResolvables(router);
    }
    /** @hidden */
    Transition.prototype.onBefore = function (criteria, callback, options) { return; };
    /** @inheritdoc */
    Transition.prototype.onStart = function (criteria, callback, options) { return; };
    /** @inheritdoc */
    Transition.prototype.onExit = function (criteria, callback, options) { return; };
    /** @inheritdoc */
    Transition.prototype.onRetain = function (criteria, callback, options) { return; };
    /** @inheritdoc */
    Transition.prototype.onEnter = function (criteria, callback, options) { return; };
    /** @inheritdoc */
    Transition.prototype.onFinish = function (criteria, callback, options) { return; };
    /** @inheritdoc */
    Transition.prototype.onSuccess = function (criteria, callback, options) { return; };
    /** @inheritdoc */
    Transition.prototype.onError = function (criteria, callback, options) { return; };
    /** @hidden
     * Creates the transition-level hook registration functions
     * (which can then be used to register hooks)
     */
    Transition.prototype.createTransitionHookRegFns = function () {
        var _this = this;
        this.router.transitionService._pluginapi._getEvents()
            .filter(function (type) { return type.hookPhase !== interface_1.TransitionHookPhase.CREATE; })
            .forEach(function (type) { return hookRegistry_1.makeEvent(_this, _this.router.transitionService, type); });
    };
    /** @internalapi */
    Transition.prototype.getHooks = function (hookName) {
        return this._registeredHooks[hookName];
    };
    Transition.prototype.applyViewConfigs = function (router) {
        var enteringStates = this._treeChanges.entering.map(function (node) { return node.state; });
        pathFactory_1.PathFactory.applyViewConfigs(router.transitionService.$view, this._treeChanges.to, enteringStates);
    };
    Transition.prototype.applyRootResolvables = function (router) {
        var _this = this;
        var rootResolvables = [
            new resolvable_1.Resolvable(router_1.UIRouter, function () { return router; }, [], undefined, router),
            new resolvable_1.Resolvable(Transition, function () { return _this; }, [], undefined, this),
            new resolvable_1.Resolvable('$transition$', function () { return _this; }, [], undefined, this),
            new resolvable_1.Resolvable('$stateParams', function () { return _this.params(); }, [], undefined, this.params())
        ];
        var rootNode = this._treeChanges.to[0];
        var context = new resolveContext_1.ResolveContext(this._treeChanges.to);
        context.addResolvables(rootResolvables, rootNode.state);
    };
    /**
     * @internalapi
     *
     * @returns the internal from [State] object
     */
    Transition.prototype.$from = function () {
        return common_1.tail(this._treeChanges.from).state;
    };
    /**
     * @internalapi
     *
     * @returns the internal to [State] object
     */
    Transition.prototype.$to = function () {
        return common_1.tail(this._treeChanges.to).state;
    };
    /**
     * Returns the "from state"
     *
     * Returns the state that the transition is coming *from*.
     *
     * @returns The state declaration object for the Transition's ("from state").
     */
    Transition.prototype.from = function () {
        return this.$from().self;
    };
    /**
     * Returns the "to state"
     *
     * Returns the state that the transition is  going *from*.
     *
     * @returns The state declaration object for the Transition's target state ("to state").
     */
    Transition.prototype.to = function () {
        return this.$to().self;
    };
    /**
     * Gets the Target State
     *
     * A transition's [[TargetState]] encapsulates the [[to]] state, the [[params]], and the [[options]] as a single object.
     *
     * @returns the [[TargetState]] of this Transition
     */
    Transition.prototype.targetState = function () {
        return this._targetState;
    };
    /**
     * Determines whether two transitions are equivalent.
     */
    Transition.prototype.is = function (compare) {
        if (compare instanceof Transition) {
            // TODO: Also compare parameters
            return this.is({ to: compare.$to().name, from: compare.$from().name });
        }
        return !((compare.to && !hookRegistry_1.matchState(this.$to(), compare.to)) ||
            (compare.from && !hookRegistry_1.matchState(this.$from(), compare.from)));
    };
    Transition.prototype.params = function (pathname) {
        if (pathname === void 0) { pathname = "to"; }
        return Object.freeze(this._treeChanges[pathname].map(hof_1.prop("paramValues")).reduce(common_1.mergeR, {}));
    };
    /**
     * Creates a [[UIInjector]] Dependency Injector
     *
     * Returns a Dependency Injector for the Transition's target state (to state).
     * The injector provides resolve values which the target state has access to.
     *
     * The `UIInjector` can also provide values from the native root/global injector (ng1/ng2).
     *
     * #### Example:
     * ```js
     * .onEnter({ entering: 'myState' }, trans => {
     *   var myResolveValue = trans.injector().get('myResolve');
     *   // Inject a global service from the global/native injector (if it exists)
     *   var MyService = trans.injector().get('MyService');
     * })
     * ```
     *
     * In some cases (such as `onBefore`), you may need access to some resolve data but it has not yet been fetched.
     * You can use [[UIInjector.getAsync]] to get a promise for the data.
     * #### Example:
     * ```js
     * .onBefore({}, trans => {
     *   return trans.injector().getAsync('myResolve').then(myResolveValue =>
     *     return myResolveValue !== 'ABORT';
     *   });
     * });
     * ```
     *
     * If a `state` is provided, the injector that is returned will be limited to resolve values that the provided state has access to.
     * This can be useful if both a parent state `foo` and a child state `foo.bar` have both defined a resolve such as `data`.
     * #### Example:
     * ```js
     * .onEnter({ to: 'foo.bar' }, trans => {
     *   // returns result of `foo` state's `data` resolve
     *   // even though `foo.bar` also has a `data` resolve
     *   var fooData = trans.injector('foo').get('data');
     * });
     * ```
     *
     * If you need resolve data from the exiting states, pass `'from'` as `pathName`.
     * The resolve data from the `from` path will be returned.
     * #### Example:
     * ```js
     * .onExit({ exiting: 'foo.bar' }, trans => {
     *   // Gets the resolve value of `data` from the exiting state.
     *   var fooData = trans.injector(null, 'foo.bar').get('data');
     * });
     * ```
     *
     *
     * @param state Limits the resolves provided to only the resolves the provided state has access to.
     * @param pathName Default: `'to'`: Chooses the path for which to create the injector. Use this to access resolves for `exiting` states.
     *
     * @returns a [[UIInjector]]
     */
    Transition.prototype.injector = function (state, pathName) {
        if (pathName === void 0) { pathName = "to"; }
        var path = this._treeChanges[pathName];
        if (state)
            path = pathFactory_1.PathFactory.subPath(path, function (node) { return node.state === state || node.state.name === state; });
        return new resolveContext_1.ResolveContext(path).injector();
    };
    /**
     * Gets all available resolve tokens (keys)
     *
     * This method can be used in conjunction with [[injector]] to inspect the resolve values
     * available to the Transition.
     *
     * This returns all the tokens defined on [[StateDeclaration.resolve]] blocks, for the states
     * in the Transition's [[TreeChanges.to]] path.
     *
     * #### Example:
     * This example logs all resolve values
     * ```js
     * let tokens = trans.getResolveTokens();
     * tokens.forEach(token => console.log(token + " = " + trans.injector().get(token)));
     * ```
     *
     * #### Example:
     * This example creates promises for each resolve value.
     * This triggers fetches of resolves (if any have not yet been fetched).
     * When all promises have all settled, it logs the resolve values.
     * ```js
     * let tokens = trans.getResolveTokens();
     * let promise = tokens.map(token => trans.injector().getAsync(token));
     * Promise.all(promises).then(values => console.log("Resolved values: " + values));
     * ```
     *
     * Note: Angular 1 users whould use `$q.all()`
     *
     * @param pathname resolve context's path name (e.g., `to` or `from`)
     *
     * @returns an array of resolve tokens (keys)
     */
    Transition.prototype.getResolveTokens = function (pathname) {
        if (pathname === void 0) { pathname = "to"; }
        return new resolveContext_1.ResolveContext(this._treeChanges[pathname]).getTokens();
    };
    /**
     * Dynamically adds a new [[Resolvable]] (i.e., [[StateDeclaration.resolve]]) to this transition.
     *
     * @param resolvable a [[ResolvableLiteral]] object (or a [[Resolvable]])
     * @param state the state in the "to path" which should receive the new resolve (otherwise, the root state)
     */
    Transition.prototype.addResolvable = function (resolvable, state) {
        if (state === void 0) { state = ""; }
        resolvable = hof_1.is(resolvable_1.Resolvable)(resolvable) ? resolvable : new resolvable_1.Resolvable(resolvable);
        var stateName = (typeof state === "string") ? state : state.name;
        var topath = this._treeChanges.to;
        var targetNode = common_1.find(topath, function (node) { return node.state.name === stateName; });
        var resolveContext = new resolveContext_1.ResolveContext(topath);
        resolveContext.addResolvables([resolvable], targetNode.state);
    };
    /**
     * Gets the transition from which this transition was redirected.
     *
     * If the current transition is a redirect, this method returns the transition that was redirected.
     *
     * #### Example:
     * ```js
     * let transitionA = $state.go('A').transition
     * transitionA.onStart({}, () => $state.target('B'));
     * $transitions.onSuccess({ to: 'B' }, (trans) => {
     *   trans.to().name === 'B'; // true
     *   trans.redirectedFrom() === transitionA; // true
     * });
     * ```
     *
     * @returns The previous Transition, or null if this Transition is not the result of a redirection
     */
    Transition.prototype.redirectedFrom = function () {
        return this._options.redirectedFrom || null;
    };
    /**
     * Gets the original transition in a redirect chain
     *
     * A transition might belong to a long chain of multiple redirects.
     * This method walks the [[redirectedFrom]] chain back to the original (first) transition in the chain.
     *
     * #### Example:
     * ```js
     * // states
     * registry.register({ name: 'A', redirectTo: 'B' });
     * registry.register({ name: 'B', redirectTo: 'C' });
     * registry.register({ name: 'C', redirectTo: 'D' });
     * registry.register({ name: 'D' });
     *
     * let transitionA = $state.go('A').transition
     *
     * $transitions.onSuccess({ to: 'D' }, (trans) => {
     *   trans.to().name === 'D'; // true
     *   trans.redirectedFrom().to().name === 'C'; // true
     *   trans.originalTransition() === transitionA; // true
     *   trans.originalTransition().to().name === 'A'; // true
     * });
     * ```
     *
     * @returns The original Transition that started a redirect chain
     */
    Transition.prototype.originalTransition = function () {
        var rf = this.redirectedFrom();
        return (rf && rf.originalTransition()) || this;
    };
    /**
     * Get the transition options
     *
     * @returns the options for this Transition.
     */
    Transition.prototype.options = function () {
        return this._options;
    };
    /**
     * Gets the states being entered.
     *
     * @returns an array of states that will be entered during this transition.
     */
    Transition.prototype.entering = function () {
        return common_1.map(this._treeChanges.entering, hof_1.prop('state')).map(stateSelf);
    };
    /**
     * Gets the states being exited.
     *
     * @returns an array of states that will be exited during this transition.
     */
    Transition.prototype.exiting = function () {
        return common_1.map(this._treeChanges.exiting, hof_1.prop('state')).map(stateSelf).reverse();
    };
    /**
     * Gets the states being retained.
     *
     * @returns an array of states that are already entered from a previous Transition, that will not be
     *    exited during this Transition
     */
    Transition.prototype.retained = function () {
        return common_1.map(this._treeChanges.retained, hof_1.prop('state')).map(stateSelf);
    };
    /**
     * Get the [[ViewConfig]]s associated with this Transition
     *
     * Each state can define one or more views (template/controller), which are encapsulated as `ViewConfig` objects.
     * This method fetches the `ViewConfigs` for a given path in the Transition (e.g., "to" or "entering").
     *
     * @param pathname the name of the path to fetch views for:
     *   (`'to'`, `'from'`, `'entering'`, `'exiting'`, `'retained'`)
     * @param state If provided, only returns the `ViewConfig`s for a single state in the path
     *
     * @returns a list of ViewConfig objects for the given path.
     */
    Transition.prototype.views = function (pathname, state) {
        if (pathname === void 0) { pathname = "entering"; }
        var path = this._treeChanges[pathname];
        path = !state ? path : path.filter(hof_1.propEq('state', state));
        return path.map(hof_1.prop("views")).filter(common_1.identity).reduce(common_1.unnestR, []);
    };
    Transition.prototype.treeChanges = function (pathname) {
        return pathname ? this._treeChanges[pathname] : this._treeChanges;
    };
    /**
     * Creates a new transition that is a redirection of the current one.
     *
     * This transition can be returned from a [[TransitionService]] hook to
     * redirect a transition to a new state and/or set of parameters.
     *
     * @internalapi
     *
     * @returns Returns a new [[Transition]] instance.
     */
    Transition.prototype.redirect = function (targetState) {
        var redirects = 1, trans = this;
        while ((trans = trans.redirectedFrom()) != null) {
            if (++redirects > 20)
                throw new Error("Too many consecutive Transition redirects (20+)");
        }
        var redirectOpts = { redirectedFrom: this, source: "redirect" };
        // If the original transition was caused by URL sync, then use { location: 'replace' }
        // on the new transition (unless  the target state explicitly specifies location)
        if (this.options().source === 'url') {
            redirectOpts.location = 'replace';
        }
        var newOptions = common_1.extend({}, this.options(), targetState.options(), redirectOpts);
        targetState = new targetState_1.TargetState(targetState.identifier(), targetState.$state(), targetState.params(), newOptions);
        var newTransition = this.router.transitionService.create(this._treeChanges.from, targetState);
        var originalEnteringNodes = this._treeChanges.entering;
        var redirectEnteringNodes = newTransition._treeChanges.entering;
        // --- Re-use resolve data from original transition ---
        // When redirecting from a parent state to a child state where the parent parameter values haven't changed
        // (because of the redirect), the resolves fetched by the original transition are still valid in the
        // redirected transition.
        //
        // This allows you to define a redirect on a parent state which depends on an async resolve value.
        // You can wait for the resolve, then redirect to a child state based on the result.
        // The redirected transition does not have to re-fetch the resolve.
        // ---------------------------------------------------------
        var nodeIsReloading = function (reloadState) { return function (node) {
            return reloadState && node.state.includes[reloadState.name];
        }; };
        // Find any "entering" nodes in the redirect path that match the original path and aren't being reloaded
        var matchingEnteringNodes = node_1.PathNode.matching(redirectEnteringNodes, originalEnteringNodes)
            .filter(hof_1.not(nodeIsReloading(targetState.options().reloadState)));
        // Use the existing (possibly pre-resolved) resolvables for the matching entering nodes.
        matchingEnteringNodes.forEach(function (node, idx) {
            node.resolvables = originalEnteringNodes[idx].resolvables;
        });
        return newTransition;
    };
    /** @hidden If a transition doesn't exit/enter any states, returns any [[Param]] whose value changed */
    Transition.prototype._changedParams = function () {
        var tc = this._treeChanges;
        /** Return undefined if it's not a "dynamic" transition, for the following reasons */
        // If user explicitly wants a reload
        if (this._options.reload)
            return undefined;
        // If any states are exiting or entering
        if (tc.exiting.length || tc.entering.length)
            return undefined;
        // If to/from path lengths differ
        if (tc.to.length !== tc.from.length)
            return undefined;
        // If the to/from paths are different
        var pathsDiffer = common_1.arrayTuples(tc.to, tc.from)
            .map(function (tuple) { return tuple[0].state !== tuple[1].state; })
            .reduce(common_1.anyTrueR, false);
        if (pathsDiffer)
            return undefined;
        // Find any parameter values that differ
        var nodeSchemas = tc.to.map(function (node) { return node.paramSchema; });
        var _a = [tc.to, tc.from].map(function (path) { return path.map(function (x) { return x.paramValues; }); }), toValues = _a[0], fromValues = _a[1];
        var tuples = common_1.arrayTuples(nodeSchemas, toValues, fromValues);
        return tuples.map(function (_a) {
            var schema = _a[0], toVals = _a[1], fromVals = _a[2];
            return param_1.Param.changed(schema, toVals, fromVals);
        }).reduce(common_1.unnestR, []);
    };
    /**
     * Returns true if the transition is dynamic.
     *
     * A transition is dynamic if no states are entered nor exited, but at least one dynamic parameter has changed.
     *
     * @returns true if the Transition is dynamic
     */
    Transition.prototype.dynamic = function () {
        var changes = this._changedParams();
        return !changes ? false : changes.map(function (x) { return x.dynamic; }).reduce(common_1.anyTrueR, false);
    };
    /**
     * Returns true if the transition is ignored.
     *
     * A transition is ignored if no states are entered nor exited, and no parameter values have changed.
     *
     * @returns true if the Transition is ignored.
     */
    Transition.prototype.ignored = function () {
        var changes = this._changedParams();
        return !changes ? false : changes.length === 0;
    };
    /**
     * @hidden
     */
    Transition.prototype.hookBuilder = function () {
        return new hookBuilder_1.HookBuilder(this);
    };
    /**
     * Runs the transition
     *
     * This method is generally called from the [[StateService.transitionTo]]
     *
     * @internalapi
     *
     * @returns a promise for a successful transition.
     */
    Transition.prototype.run = function () {
        var _this = this;
        var runAllHooks = transitionHook_1.TransitionHook.runAllHooks;
        var hookBuilder = this.hookBuilder();
        var globals = this.router.globals;
        globals.transitionHistory.enqueue(this);
        var onBeforeHooks = hookBuilder.buildHooksForPhase(interface_1.TransitionHookPhase.BEFORE);
        var syncResult = transitionHook_1.TransitionHook.runOnBeforeHooks(onBeforeHooks);
        if (rejectFactory_1.Rejection.isTransitionRejectionPromise(syncResult)) {
            syncResult.catch(function () { return 0; }); // issue #2676
            var rejectReason = syncResult._transitionRejection;
            this._deferred.reject(rejectReason);
            return this.promise;
        }
        if (!this.valid()) {
            var error = new Error(this.error());
            this._deferred.reject(error);
            return this.promise;
        }
        if (this.ignored()) {
            trace_1.trace.traceTransitionIgnored(this);
            this._deferred.reject(rejectFactory_1.Rejection.ignored());
            return this.promise;
        }
        // When the chain is complete, then resolve or reject the deferred
        var transitionSuccess = function () {
            trace_1.trace.traceSuccess(_this.$to(), _this);
            _this.success = true;
            _this._deferred.resolve(_this.to());
            var onSuccessHooks = hookBuilder.buildHooksForPhase(interface_1.TransitionHookPhase.SUCCESS);
            runAllHooks(onSuccessHooks);
        };
        var transitionError = function (reason) {
            trace_1.trace.traceError(reason, _this);
            _this.success = false;
            _this._deferred.reject(reason);
            _this._error = reason;
            var onErrorHooks = hookBuilder.buildHooksForPhase(interface_1.TransitionHookPhase.ERROR);
            runAllHooks(onErrorHooks);
        };
        trace_1.trace.traceTransitionStart(this);
        // Chain the next hook off the previous
        var appendHookToChain = function (prev, nextHook) {
            return prev.then(function () { return nextHook.invokeHook(); });
        };
        // Run the hooks, then resolve or reject the overall deferred in the .then() handler
        var asyncHooks = hookBuilder.buildHooksForPhase(interface_1.TransitionHookPhase.ASYNC);
        asyncHooks.reduce(appendHookToChain, syncResult)
            .then(transitionSuccess, transitionError);
        return this.promise;
    };
    /**
     * Checks if the Transition is valid
     *
     * @returns true if the Transition is valid
     */
    Transition.prototype.valid = function () {
        return !this.error() || this.success !== undefined;
    };
    /**
     * The Transition error reason.
     *
     * If the transition is invalid (and could not be run), returns the reason the transition is invalid.
     * If the transition was valid and ran, but was not successful, returns the reason the transition failed.
     *
     * @returns an error message explaining why the transition is invalid, or the reason the transition failed.
     */
    Transition.prototype.error = function () {
        var state = this.$to();
        if (state.self.abstract)
            return "Cannot transition to abstract state '" + state.name + "'";
        if (!param_1.Param.validates(state.parameters(), this.params()))
            return "Param values not valid for state '" + state.name + "'";
        if (this.success === false)
            return this._error;
    };
    /**
     * A string representation of the Transition
     *
     * @returns A string representation of the Transition
     */
    Transition.prototype.toString = function () {
        var fromStateOrName = this.from();
        var toStateOrName = this.to();
        var avoidEmptyHash = function (params) {
            return (params["#"] !== null && params["#"] !== undefined) ? params : common_1.omit(params, "#");
        };
        // (X) means the to state is invalid.
        var id = this.$id, from = predicates_1.isObject(fromStateOrName) ? fromStateOrName.name : fromStateOrName, fromParams = common_1.toJson(avoidEmptyHash(this._treeChanges.from.map(hof_1.prop('paramValues')).reduce(common_1.mergeR, {}))), toValid = this.valid() ? "" : "(X) ", to = predicates_1.isObject(toStateOrName) ? toStateOrName.name : toStateOrName, toParams = common_1.toJson(avoidEmptyHash(this.params()));
        return "Transition#" + id + "( '" + from + "'" + fromParams + " -> " + toValid + "'" + to + "'" + toParams + " )";
    };
    return Transition;
}());
/** @hidden */
Transition.diToken = Transition;
exports.Transition = Transition;
//# sourceMappingURL=transition.js.map

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @coreapi
 * @module transition
 */ /** for typedoc */
var common_1 = __webpack_require__(8);
var predicates_1 = __webpack_require__(13);
var interface_1 = __webpack_require__(79); // has or is using
var glob_1 = __webpack_require__(104);
/**
 * Determines if the given state matches the matchCriteria
 *
 * @hidden
 *
 * @param state a State Object to test against
 * @param criterion
 * - If a string, matchState uses the string as a glob-matcher against the state name
 * - If an array (of strings), matchState uses each string in the array as a glob-matchers against the state name
 *   and returns a positive match if any of the globs match.
 * - If a function, matchState calls the function with the state and returns true if the function's result is truthy.
 * @returns {boolean}
 */
function matchState(state, criterion) {
    var toMatch = predicates_1.isString(criterion) ? [criterion] : criterion;
    function matchGlobs(_state) {
        var globStrings = toMatch;
        for (var i = 0; i < globStrings.length; i++) {
            var glob = new glob_1.Glob(globStrings[i]);
            if ((glob && glob.matches(_state.name)) || (!glob && globStrings[i] === _state.name)) {
                return true;
            }
        }
        return false;
    }
    var matchFn = (predicates_1.isFunction(toMatch) ? toMatch : matchGlobs);
    return !!matchFn(state);
}
exports.matchState = matchState;
/**
 * @hidden
 * The registration data for a registered transition hook
 */
var RegisteredHook = (function () {
    function RegisteredHook(tranSvc, eventType, callback, matchCriteria, options) {
        if (options === void 0) { options = {}; }
        this.tranSvc = tranSvc;
        this.eventType = eventType;
        this.callback = callback;
        this.matchCriteria = matchCriteria;
        this.priority = options.priority || 0;
        this.bind = options.bind || null;
        this._deregistered = false;
    }
    /**
     * Given an array of PathNodes, and a HookMatchCriteria, returns an array containing
     * the PathNodes that the criteria matches, or null if there were no matching nodes.
     *
     * Returning null is significant to distinguish between the default
     * "match-all criterion value" of `true` compared to a () => true,
     * when the nodes is an empty array.
     *
     * This is useful to allow a transition match criteria of `entering: true`
     * to still match a transition, even when `entering === []`.  Contrast that
     * with `entering: (state) => true` which only matches when a state is actually
     * being entered.
     */
    RegisteredHook.prototype._matchingNodes = function (nodes, criterion) {
        if (criterion === true)
            return nodes;
        var matching = nodes.filter(function (node) { return matchState(node.state, criterion); });
        return matching.length ? matching : null;
    };
    /**
     * Returns an object which has all the criteria match paths as keys and `true` as values, i.e.:
     *
     * { to: true, from: true, entering: true, exiting: true, retained: true }
     */
    RegisteredHook.prototype._getDefaultMatchCriteria = function () {
        return common_1.map(this.tranSvc._pluginapi._getPathTypes(), function () { return true; });
    };
    /**
     * Create a IMatchingNodes object from the TransitionHookTypes that basically looks like this:
     *
     * let matches: IMatchingNodes = {
     *   to:       _matchingNodes([tail(treeChanges.to)],   mc.to),
     *   from:     _matchingNodes([tail(treeChanges.from)], mc.from),
     *   exiting:  _matchingNodes(treeChanges.exiting,      mc.exiting),
     *   retained: _matchingNodes(treeChanges.retained,     mc.retained),
     *   entering: _matchingNodes(treeChanges.entering,     mc.entering),
     * };
     */
    RegisteredHook.prototype._getMatchingNodes = function (treeChanges) {
        var _this = this;
        var criteria = common_1.extend(this._getDefaultMatchCriteria(), this.matchCriteria);
        var paths = common_1.values(this.tranSvc._pluginapi._getPathTypes());
        return paths.reduce(function (mn, pathtype) {
            // STATE scope criteria matches against every node in the path.
            // TRANSITION scope criteria matches against only the last node in the path
            var isStateHook = pathtype.scope === interface_1.TransitionHookScope.STATE;
            var path = treeChanges[pathtype.name] || [];
            var nodes = isStateHook ? path : [common_1.tail(path)];
            mn[pathtype.name] = _this._matchingNodes(nodes, criteria[pathtype.name]);
            return mn;
        }, {});
    };
    /**
     * Determines if this hook's [[matchCriteria]] match the given [[TreeChanges]]
     *
     * @returns an IMatchingNodes object, or null. If an IMatchingNodes object is returned, its values
     * are the matching [[PathNode]]s for each [[HookMatchCriterion]] (to, from, exiting, retained, entering)
     */
    RegisteredHook.prototype.matches = function (treeChanges) {
        var matches = this._getMatchingNodes(treeChanges);
        // Check if all the criteria matched the TreeChanges object
        var allMatched = common_1.values(matches).every(common_1.identity);
        return allMatched ? matches : null;
    };
    return RegisteredHook;
}());
exports.RegisteredHook = RegisteredHook;
/** @hidden Return a registration function of the requested type. */
function makeEvent(registry, transitionService, eventType) {
    // Create the object which holds the registered transition hooks.
    var _registeredHooks = registry._registeredHooks = (registry._registeredHooks || {});
    var hooks = _registeredHooks[eventType.name] = [];
    // Create hook registration function on the IHookRegistry for the event
    registry[eventType.name] = hookRegistrationFn;
    function hookRegistrationFn(matchObject, callback, options) {
        if (options === void 0) { options = {}; }
        var registeredHook = new RegisteredHook(transitionService, eventType, callback, matchObject, options);
        hooks.push(registeredHook);
        return function deregisterEventHook() {
            registeredHook._deregistered = true;
            common_1.removeFrom(hooks)(registeredHook);
        };
    }
    return hookRegistrationFn;
}
exports.makeEvent = makeEvent;
//# sourceMappingURL=hookRegistry.js.map

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/** @module params */ /** for typedoc */
var common_1 = __webpack_require__(8);
var predicates_1 = __webpack_require__(13);
/**
 * An internal class which implements [[ParamTypeDefinition]].
 *
 * A [[ParamTypeDefinition]] is a plain javascript object used to register custom parameter types.
 * When a param type definition is registered, an instance of this class is created internally.
 *
 * This class has naive implementations for all the [[ParamTypeDefinition]] methods.
 *
 * Used by [[UrlMatcher]] when matching or formatting URLs, or comparing and validating parameter values.
 *
 * #### Example:
 * ```js
 * var paramTypeDef = {
 *   decode: function(val) { return parseInt(val, 10); },
 *   encode: function(val) { return val && val.toString(); },
 *   equals: function(a, b) { return this.is(a) && a === b; },
 *   is: function(val) { return angular.isNumber(val) && isFinite(val) && val % 1 === 0; },
 *   pattern: /\d+/
 * }
 *
 * var paramType = new ParamType(paramTypeDef);
 * ```
 * @internalapi
 */
var ParamType = (function () {
    /**
     * @param def  A configuration object which contains the custom type definition.  The object's
     *        properties will override the default methods and/or pattern in `ParamType`'s public interface.
     * @returns a new ParamType object
     */
    function ParamType(def) {
        /** @inheritdoc */
        this.pattern = /.*/;
        /** @inheritdoc */
        this.inherit = true;
        common_1.extend(this, def);
    }
    // consider these four methods to be "abstract methods" that should be overridden
    /** @inheritdoc */
    ParamType.prototype.is = function (val, key) { return true; };
    /** @inheritdoc */
    ParamType.prototype.encode = function (val, key) { return val; };
    /** @inheritdoc */
    ParamType.prototype.decode = function (val, key) { return val; };
    /** @inheritdoc */
    ParamType.prototype.equals = function (a, b) { return a == b; };
    ParamType.prototype.$subPattern = function () {
        var sub = this.pattern.toString();
        return sub.substr(1, sub.length - 2);
    };
    ParamType.prototype.toString = function () {
        return "{ParamType:" + this.name + "}";
    };
    /** Given an encoded string, or a decoded object, returns a decoded object */
    ParamType.prototype.$normalize = function (val) {
        return this.is(val) ? val : this.decode(val);
    };
    /**
     * Wraps an existing custom ParamType as an array of ParamType, depending on 'mode'.
     * e.g.:
     * - urlmatcher pattern "/path?{queryParam[]:int}"
     * - url: "/path?queryParam=1&queryParam=2
     * - $stateParams.queryParam will be [1, 2]
     * if `mode` is "auto", then
     * - url: "/path?queryParam=1 will create $stateParams.queryParam: 1
     * - url: "/path?queryParam=1&queryParam=2 will create $stateParams.queryParam: [1, 2]
     */
    ParamType.prototype.$asArray = function (mode, isSearch) {
        if (!mode)
            return this;
        if (mode === "auto" && !isSearch)
            throw new Error("'auto' array mode is for query parameters only");
        return new ArrayType(this, mode);
    };
    return ParamType;
}());
exports.ParamType = ParamType;
/**
 * Wraps up a `ParamType` object to handle array values.
 * @internalapi
 */
function ArrayType(type, mode) {
    var _this = this;
    // Wrap non-array value as array
    function arrayWrap(val) {
        return predicates_1.isArray(val) ? val : (predicates_1.isDefined(val) ? [val] : []);
    }
    // Unwrap array value for "auto" mode. Return undefined for empty array.
    function arrayUnwrap(val) {
        switch (val.length) {
            case 0: return undefined;
            case 1: return mode === "auto" ? val[0] : val;
            default: return val;
        }
    }
    // Wraps type (.is/.encode/.decode) functions to operate on each value of an array
    function arrayHandler(callback, allTruthyMode) {
        return function handleArray(val) {
            if (predicates_1.isArray(val) && val.length === 0)
                return val;
            var arr = arrayWrap(val);
            var result = common_1.map(arr, callback);
            return (allTruthyMode === true) ? common_1.filter(result, function (x) { return !x; }).length === 0 : arrayUnwrap(result);
        };
    }
    // Wraps type (.equals) functions to operate on each value of an array
    function arrayEqualsHandler(callback) {
        return function handleArray(val1, val2) {
            var left = arrayWrap(val1), right = arrayWrap(val2);
            if (left.length !== right.length)
                return false;
            for (var i = 0; i < left.length; i++) {
                if (!callback(left[i], right[i]))
                    return false;
            }
            return true;
        };
    }
    ['encode', 'decode', 'equals', '$normalize'].forEach(function (name) {
        var paramTypeFn = type[name].bind(type);
        var wrapperFn = name === 'equals' ? arrayEqualsHandler : arrayHandler;
        _this[name] = wrapperFn(paramTypeFn);
    });
    common_1.extend(this, {
        dynamic: type.dynamic,
        name: type.name,
        pattern: type.pattern,
        inherit: type.inherit,
        is: arrayHandler(type.is.bind(type), true),
        $arrayMode: mode
    });
}
//# sourceMappingURL=paramType.js.map

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @coreapi
 * @module state
 */ /** for typedoc */

var common_1 = __webpack_require__(8);
var hof_1 = __webpack_require__(14);
/**
 * Internal representation of a UI-Router state.
 *
 * Instances of this class are created when a [[StateDeclaration]] is registered with the [[StateRegistry]].
 *
 * A registered [[StateDeclaration]] is augmented with a getter ([[StateDeclaration.$$state]]) which returns the corresponding [[State]] object.
 *
 * This class prototypally inherits from the corresponding [[StateDeclaration]].
 * Each of its own properties (i.e., `hasOwnProperty`) are built using builders from the [[StateBuilder]].
 */
var State = (function () {
    function State(config) {
        common_1.extend(this, config);
        // Object.freeze(this);
    }
    /**
     * Returns true if the provided parameter is the same state.
     *
     * Compares the identity of the state against the passed value, which is either an object
     * reference to the actual `State` instance, the original definition object passed to
     * `$stateProvider.state()`, or the fully-qualified name.
     *
     * @param ref Can be one of (a) a `State` instance, (b) an object that was passed
     *        into `$stateProvider.state()`, (c) the fully-qualified name of a state as a string.
     * @returns Returns `true` if `ref` matches the current `State` instance.
     */
    State.prototype.is = function (ref) {
        return this === ref || this.self === ref || this.fqn() === ref;
    };
    /**
     * @deprecated this does not properly handle dot notation
     * @returns Returns a dot-separated name of the state.
     */
    State.prototype.fqn = function () {
        if (!this.parent || !(this.parent instanceof this.constructor))
            return this.name;
        var name = this.parent.fqn();
        return name ? name + "." + this.name : this.name;
    };
    /**
     * Returns the root node of this state's tree.
     *
     * @returns The root of this state's tree.
     */
    State.prototype.root = function () {
        return this.parent && this.parent.root() || this;
    };
    /**
     * Gets the state's `Param`eters
     *
     * Gets [[Param]] information that is owned by the state.
     * If `opts.inherit` is true, it also includes the ancestor states' [[Param]] information.
     * If `opts.matchingKeys` exists, returns only `Param`s whose `id` is a key on the `matchingKeys` object
     *
     * @param opts options
     */
    State.prototype.parameters = function (opts) {
        opts = common_1.defaults(opts, { inherit: true, matchingKeys: null });
        var inherited = opts.inherit && this.parent && this.parent.parameters() || [];
        return inherited.concat(common_1.values(this.params))
            .filter(function (param) { return !opts.matchingKeys || opts.matchingKeys.hasOwnProperty(param.id); });
    };
    /**
     * Returns a single [[Param]] that is owned by the state
     *
     * If `opts.inherit` is true, it also searches the ancestor states` [[Param]] information.
     * @param id the name of the [[Param]] to return
     * @param opts options
     */
    State.prototype.parameter = function (id, opts) {
        if (opts === void 0) { opts = {}; }
        return (this.url && this.url.parameter(id, opts) ||
            common_1.find(common_1.values(this.params), hof_1.propEq('id', id)) ||
            opts.inherit && this.parent && this.parent.parameter(id));
    };
    State.prototype.toString = function () {
        return this.fqn();
    };
    return State;
}());
exports.State = State;
//# sourceMappingURL=stateObject.js.map

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @coreapi
 * @module transition
 */ /** for typedoc */
var interface_1 = __webpack_require__(79);
var transition_1 = __webpack_require__(146);
var hookRegistry_1 = __webpack_require__(147);
var resolve_1 = __webpack_require__(584);
var views_1 = __webpack_require__(585);
var url_1 = __webpack_require__(586);
var redirectTo_1 = __webpack_require__(587);
var onEnterExitRetain_1 = __webpack_require__(588);
var lazyLoad_1 = __webpack_require__(225);
var transitionEventType_1 = __webpack_require__(226);
var transitionHook_1 = __webpack_require__(80);
var predicates_1 = __webpack_require__(13);
var common_1 = __webpack_require__(8);
var hof_1 = __webpack_require__(14);
/**
 * The default [[Transition]] options.
 *
 * Include this object when applying custom defaults:
 * let reloadOpts = { reload: true, notify: true }
 * let options = defaults(theirOpts, customDefaults, defaultOptions);
 */
exports.defaultTransOpts = {
    location: true,
    relative: null,
    inherit: false,
    notify: true,
    reload: false,
    custom: {},
    current: function () { return null; },
    source: "unknown"
};
/**
 * This class provides services related to Transitions.
 *
 * - Most importantly, it allows global Transition Hooks to be registered.
 * - It allows the default transition error handler to be set.
 * - It also has a factory function for creating new [[Transition]] objects, (used internally by the [[StateService]]).
 *
 * At bootstrap, [[UIRouter]] creates a single instance (singleton) of this class.
 */
var TransitionService = (function () {
    /** @hidden */
    function TransitionService(_router) {
        this._router = _router;
        /** @hidden */
        this._transitionCount = 0;
        /** @hidden The transition hook types, such as `onEnter`, `onStart`, etc */
        this._eventTypes = [];
        /** @hidden The registered transition hooks */
        this._registeredHooks = {};
        /** @hidden The  paths on a criteria object */
        this._criteriaPaths = {};
        this.$view = _router.viewService;
        this._deregisterHookFns = {};
        this._pluginapi = common_1.createProxyFunctions(hof_1.val(this), {}, hof_1.val(this), [
            '_definePathType',
            '_defineEvent',
            '_getPathTypes',
            '_getEvents',
            'getHooks',
        ]);
        this._defineDefaultPaths();
        this._defineDefaultEvents();
        this._registerDefaultTransitionHooks();
    }
    /**
     * Registers a [[TransitionHookFn]], called *while a transition is being constructed*.
     *
     * Registers a transition lifecycle hook, which is invoked during transition construction.
     *
     * This low level hook should only be used by plugins.
     * This can be a useful time for plugins to add resolves or mutate the transition as needed.
     * The Sticky States plugin uses this hook to modify the treechanges.
     *
     * ### Lifecycle
     *
     * `onCreate` hooks are invoked *while a transition is being constructed*.
     *
     * ### Return value
     *
     * The hook's return value is ignored
     *
     * @internalapi
     * @param criteria defines which Transitions the Hook should be invoked for.
     * @param callback the hook function which will be invoked.
     * @param options the registration options
     * @returns a function which deregisters the hook.
     */
    TransitionService.prototype.onCreate = function (criteria, callback, options) { return; };
    /** @inheritdoc */
    TransitionService.prototype.onBefore = function (criteria, callback, options) { return; };
    /** @inheritdoc */
    TransitionService.prototype.onStart = function (criteria, callback, options) { return; };
    /** @inheritdoc */
    TransitionService.prototype.onExit = function (criteria, callback, options) { return; };
    /** @inheritdoc */
    TransitionService.prototype.onRetain = function (criteria, callback, options) { return; };
    /** @inheritdoc */
    TransitionService.prototype.onEnter = function (criteria, callback, options) { return; };
    /** @inheritdoc */
    TransitionService.prototype.onFinish = function (criteria, callback, options) { return; };
    /** @inheritdoc */
    TransitionService.prototype.onSuccess = function (criteria, callback, options) { return; };
    /** @inheritdoc */
    TransitionService.prototype.onError = function (criteria, callback, options) { return; };
    /** @internalapi */
    TransitionService.prototype.dispose = function (router) {
        delete router.globals.transition;
        common_1.values(this._registeredHooks).forEach(function (hooksArray) { return hooksArray.forEach(function (hook) {
            hook._deregistered = true;
            common_1.removeFrom(hooksArray, hook);
        }); });
    };
    /**
     * Creates a new [[Transition]] object
     *
     * This is a factory function for creating new Transition objects.
     * It is used internally by the [[StateService]] and should generally not be called by application code.
     *
     * @param fromPath the path to the current state (the from state)
     * @param targetState the target state (destination)
     * @returns a Transition
     */
    TransitionService.prototype.create = function (fromPath, targetState) {
        return new transition_1.Transition(fromPath, targetState, this._router);
    };
    /** @hidden */
    TransitionService.prototype._defineDefaultEvents = function () {
        var Phase = interface_1.TransitionHookPhase;
        var TH = transitionHook_1.TransitionHook;
        var paths = this._criteriaPaths;
        this._defineEvent("onCreate", Phase.CREATE, 0, paths.to, false, TH.IGNORE_RESULT, TH.THROW_ERROR, false);
        this._defineEvent("onBefore", Phase.BEFORE, 0, paths.to, false, TH.HANDLE_RESULT);
        this._defineEvent("onStart", Phase.ASYNC, 0, paths.to);
        this._defineEvent("onExit", Phase.ASYNC, 100, paths.exiting, true);
        this._defineEvent("onRetain", Phase.ASYNC, 200, paths.retained);
        this._defineEvent("onEnter", Phase.ASYNC, 300, paths.entering);
        this._defineEvent("onFinish", Phase.ASYNC, 400, paths.to);
        this._defineEvent("onSuccess", Phase.SUCCESS, 0, paths.to, false, TH.IGNORE_RESULT, TH.LOG_ERROR, false);
        this._defineEvent("onError", Phase.ERROR, 0, paths.to, false, TH.IGNORE_RESULT, TH.LOG_ERROR, false);
    };
    /** @hidden */
    TransitionService.prototype._defineDefaultPaths = function () {
        var STATE = interface_1.TransitionHookScope.STATE, TRANSITION = interface_1.TransitionHookScope.TRANSITION;
        this._definePathType("to", TRANSITION);
        this._definePathType("from", TRANSITION);
        this._definePathType("exiting", STATE);
        this._definePathType("retained", STATE);
        this._definePathType("entering", STATE);
    };
    /**
     * Defines a transition hook type and returns a transition hook registration
     * function (which can then be used to register hooks of this type).
     * @internalapi
     */
    TransitionService.prototype._defineEvent = function (name, hookPhase, hookOrder, criteriaMatchPath, reverseSort, getResultHandler, getErrorHandler, rejectIfSuperseded) {
        if (reverseSort === void 0) { reverseSort = false; }
        if (getResultHandler === void 0) { getResultHandler = transitionHook_1.TransitionHook.HANDLE_RESULT; }
        if (getErrorHandler === void 0) { getErrorHandler = transitionHook_1.TransitionHook.REJECT_ERROR; }
        if (rejectIfSuperseded === void 0) { rejectIfSuperseded = true; }
        var eventType = new transitionEventType_1.TransitionEventType(name, hookPhase, hookOrder, criteriaMatchPath, reverseSort, getResultHandler, getErrorHandler, rejectIfSuperseded);
        this._eventTypes.push(eventType);
        hookRegistry_1.makeEvent(this, this, eventType);
    };
    ;
    /**
     * @hidden
     * Returns the known event types, such as `onBefore`
     * If a phase argument is provided, returns only events for the given phase.
     */
    TransitionService.prototype._getEvents = function (phase) {
        var transitionHookTypes = predicates_1.isDefined(phase) ?
            this._eventTypes.filter(function (type) { return type.hookPhase === phase; }) :
            this._eventTypes.slice();
        return transitionHookTypes.sort(function (l, r) {
            var cmpByPhase = l.hookPhase - r.hookPhase;
            return cmpByPhase === 0 ? l.hookOrder - r.hookOrder : cmpByPhase;
        });
    };
    /**
     * Adds a Path to be used as a criterion against a TreeChanges path
     *
     * For example: the `exiting` path in [[HookMatchCriteria]] is a STATE scoped path.
     * It was defined by calling `defineTreeChangesCriterion('exiting', TransitionHookScope.STATE)`
     * Each state in the exiting path is checked against the criteria and returned as part of the match.
     *
     * Another example: the `to` path in [[HookMatchCriteria]] is a TRANSITION scoped path.
     * It was defined by calling `defineTreeChangesCriterion('to', TransitionHookScope.TRANSITION)`
     * Only the tail of the `to` path is checked against the criteria and returned as part of the match.
     *
     * @internalapi
     */
    TransitionService.prototype._definePathType = function (name, hookScope) {
        this._criteriaPaths[name] = { name: name, scope: hookScope };
    };
    /**
     * Gets a Path definition used as a criterion against a TreeChanges path
     *
     * @internalapi
     */
    TransitionService.prototype._getPathTypes = function () {
        return this._criteriaPaths;
    };
    /** @hidden */
    TransitionService.prototype.getHooks = function (hookName) {
        return this._registeredHooks[hookName];
    };
    /** @hidden */
    TransitionService.prototype._registerDefaultTransitionHooks = function () {
        var fns = this._deregisterHookFns;
        // Wire up redirectTo hook
        fns.redirectTo = redirectTo_1.registerRedirectToHook(this);
        // Wire up onExit/Retain/Enter state hooks
        fns.onExit = onEnterExitRetain_1.registerOnExitHook(this);
        fns.onRetain = onEnterExitRetain_1.registerOnRetainHook(this);
        fns.onEnter = onEnterExitRetain_1.registerOnEnterHook(this);
        // Wire up Resolve hooks
        fns.eagerResolve = resolve_1.registerEagerResolvePath(this);
        fns.lazyResolve = resolve_1.registerLazyResolveState(this);
        // Wire up the View management hooks
        fns.loadViews = views_1.registerLoadEnteringViews(this);
        fns.activateViews = views_1.registerActivateViews(this);
        // After globals.current is updated at priority: 10000
        fns.updateUrl = url_1.registerUpdateUrl(this);
        // Lazy load state trees
        fns.lazyLoad = lazyLoad_1.registerLazyLoadHook(this);
    };
    return TransitionService;
}());
exports.TransitionService = TransitionService;
//# sourceMappingURL=transitionService.js.map

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * # UI-Router for Angular 1
 *
 * - Provides an implementation for the [[CoreServices]] API, based on angular 1 services.
 * - Also registers some services with the angular 1 injector.
 * - Creates and bootstraps a new [[UIRouter]] object.  Ties it to the the angular 1 lifecycle.
 *
 * @module ng1
 * @preferred
 */
/** for typedoc */
var angular_1 = __webpack_require__(71);
var ui_router_core_1 = __webpack_require__(30);
var views_1 = __webpack_require__(152);
var templateFactory_1 = __webpack_require__(597);
var stateProvider_1 = __webpack_require__(236);
var onEnterExitRetain_1 = __webpack_require__(598);
var locationServices_1 = __webpack_require__(599);
var urlRouterProvider_1 = __webpack_require__(600);
angular_1.ng.module("ui.router.angular1", []);
var mod_init = angular_1.ng.module('ui.router.init', []);
var mod_util = angular_1.ng.module('ui.router.util', ['ng', 'ui.router.init']);
var mod_rtr = angular_1.ng.module('ui.router.router', ['ui.router.util']);
var mod_state = angular_1.ng.module('ui.router.state', ['ui.router.router', 'ui.router.util', 'ui.router.angular1']);
var mod_main = angular_1.ng.module('ui.router', ['ui.router.init', 'ui.router.state', 'ui.router.angular1']);
var mod_cmpt = angular_1.ng.module('ui.router.compat', ['ui.router']);
var router = null;
$uiRouter.$inject = ['$locationProvider'];
/** This angular 1 provider instantiates a Router and exposes its services via the angular injector */
function $uiRouter($locationProvider) {
    // Create a new instance of the Router when the $uiRouterProvider is initialized
    router = this.router = new ui_router_core_1.UIRouter();
    router.stateProvider = new stateProvider_1.StateProvider(router.stateRegistry, router.stateService);
    // Apply ng1 specific StateBuilder code for `views`, `resolve`, and `onExit/Retain/Enter` properties
    router.stateRegistry.decorator("views", views_1.ng1ViewsBuilder);
    router.stateRegistry.decorator("onExit", onEnterExitRetain_1.getStateHookBuilder("onExit"));
    router.stateRegistry.decorator("onRetain", onEnterExitRetain_1.getStateHookBuilder("onRetain"));
    router.stateRegistry.decorator("onEnter", onEnterExitRetain_1.getStateHookBuilder("onEnter"));
    router.viewService._pluginapi._viewConfigFactory('ng1', views_1.getNg1ViewConfigFactory());
    var ng1LocationService = router.locationService = router.locationConfig = new locationServices_1.Ng1LocationServices($locationProvider);
    locationServices_1.Ng1LocationServices.monkeyPatchPathParameterType(router);
    // backwards compat: also expose router instance as $uiRouterProvider.router
    router['router'] = router;
    router['$get'] = $get;
    $get.$inject = ['$location', '$browser', '$sniffer', '$rootScope', '$http', '$templateCache'];
    function $get($location, $browser, $sniffer, $rootScope, $http, $templateCache) {
        ng1LocationService._runtimeServices($rootScope, $location, $sniffer, $browser);
        delete router['router'];
        delete router['$get'];
        return router;
    }
    return router;
}
var getProviderFor = function (serviceName) { return ['$uiRouterProvider', function ($urp) {
        var service = $urp.router[serviceName];
        service["$get"] = function () { return service; };
        return service;
    }]; };
// This effectively calls $get() on `$uiRouterProvider` to trigger init (when ng enters runtime)
runBlock.$inject = ['$injector', '$q', '$uiRouter'];
function runBlock($injector, $q, $uiRouter) {
    ui_router_core_1.services.$injector = $injector;
    ui_router_core_1.services.$q = $q;
    // The $injector is now available.
    // Find any resolvables that had dependency annotation deferred
    $uiRouter.stateRegistry.get()
        .map(function (x) { return x.$$state().resolvables; })
        .reduce(ui_router_core_1.unnestR, [])
        .filter(function (x) { return x.deps === "deferred"; })
        .forEach(function (resolvable) { return resolvable.deps = $injector.annotate(resolvable.resolveFn); });
}
// $urlRouter service and $urlRouterProvider
var getUrlRouterProvider = function (router) {
    return router.urlRouterProvider = new urlRouterProvider_1.UrlRouterProvider(router);
};
// $state service and $stateProvider
// $urlRouter service and $urlRouterProvider
var getStateProvider = function () {
    return ui_router_core_1.extend(router.stateProvider, { $get: function () { return router.stateService; } });
};
watchDigests.$inject = ['$rootScope'];
function watchDigests($rootScope) {
    $rootScope.$watch(function () { ui_router_core_1.trace.approximateDigests++; });
}
exports.watchDigests = watchDigests;
mod_init.provider("$uiRouter", $uiRouter);
mod_rtr.provider('$urlRouter', ['$uiRouterProvider', getUrlRouterProvider]);
mod_util.provider('$urlService', getProviderFor('urlService'));
mod_util.provider('$urlMatcherFactory', ['$uiRouterProvider', function () { return router.urlMatcherFactory; }]);
mod_util.provider('$templateFactory', function () { return new templateFactory_1.TemplateFactory(); });
mod_state.provider('$stateRegistry', getProviderFor('stateRegistry'));
mod_state.provider('$uiRouterGlobals', getProviderFor('globals'));
mod_state.provider('$transitions', getProviderFor('transitionService'));
mod_state.provider('$state', ['$uiRouterProvider', getStateProvider]);
mod_state.factory('$stateParams', ['$uiRouter', function ($uiRouter) { return $uiRouter.globals.params; }]);
mod_main.factory('$view', function () { return router.viewService; });
mod_main.service("$trace", function () { return ui_router_core_1.trace; });
mod_main.run(watchDigests);
mod_util.run(['$urlMatcherFactory', function ($urlMatcherFactory) { }]);
mod_state.run(['$state', function ($state) { }]);
mod_rtr.run(['$urlRouter', function ($urlRouter) { }]);
mod_init.run(runBlock);
/** @hidden TODO: find a place to move this */
exports.getLocals = function (ctx) {
    var tokens = ctx.getTokens().filter(ui_router_core_1.isString);
    var tuples = tokens.map(function (key) {
        var resolvable = ctx.getResolvable(key);
        var waitPolicy = ctx.getPolicy(resolvable).async;
        return [key, waitPolicy === 'NOWAIT' ? resolvable.promise : resolvable.data];
    });
    return tuples.reduce(ui_router_core_1.applyPairs, {});
};
//# sourceMappingURL=services.js.map

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ui_router_core_1 = __webpack_require__(30);
function getNg1ViewConfigFactory() {
    var templateFactory = null;
    return function (path, view) {
        templateFactory = templateFactory || ui_router_core_1.services.$injector.get("$templateFactory");
        return [new Ng1ViewConfig(path, view, templateFactory)];
    };
}
exports.getNg1ViewConfigFactory = getNg1ViewConfigFactory;
var hasAnyKey = function (keys, obj) {
    return keys.reduce(function (acc, key) { return acc || ui_router_core_1.isDefined(obj[key]); }, false);
};
/**
 * This is a [[StateBuilder.builder]] function for angular1 `views`.
 *
 * When the [[StateBuilder]] builds a [[State]] object from a raw [[StateDeclaration]], this builder
 * handles the `views` property with logic specific to angular-ui-router (ng1).
 *
 * If no `views: {}` property exists on the [[StateDeclaration]], then it creates the `views` object
 * and applies the state-level configuration to a view named `$default`.
 */
function ng1ViewsBuilder(state) {
    // Do not process root state
    if (!state.parent)
        return {};
    var tplKeys = ['templateProvider', 'templateUrl', 'template', 'notify', 'async'], ctrlKeys = ['controller', 'controllerProvider', 'controllerAs', 'resolveAs'], compKeys = ['component', 'bindings', 'componentProvider'], nonCompKeys = tplKeys.concat(ctrlKeys), allKeys = compKeys.concat(nonCompKeys);
    var views = {}, viewsObject = state.views || { "$default": ui_router_core_1.pick(state, allKeys) };
    ui_router_core_1.forEach(viewsObject, function (config, name) {
        // Account for views: { "": { template... } }
        name = name || "$default";
        // Account for views: { header: "headerComponent" }
        if (ui_router_core_1.isString(config))
            config = { component: config };
        if (hasAnyKey(compKeys, config) && hasAnyKey(nonCompKeys, config)) {
            throw new Error("Cannot combine: " + compKeys.join("|") + " with: " + nonCompKeys.join("|") + " in stateview: '" + name + "@" + state.name + "'");
        }
        config.resolveAs = config.resolveAs || '$resolve';
        config.$type = "ng1";
        config.$context = state;
        config.$name = name;
        var normalized = ui_router_core_1.ViewService.normalizeUIViewTarget(config.$context, config.$name);
        config.$uiViewName = normalized.uiViewName;
        config.$uiViewContextAnchor = normalized.uiViewContextAnchor;
        views[name] = config;
    });
    return views;
}
exports.ng1ViewsBuilder = ng1ViewsBuilder;
var id = 0;
var Ng1ViewConfig = (function () {
    function Ng1ViewConfig(path, viewDecl, factory) {
        var _this = this;
        this.path = path;
        this.viewDecl = viewDecl;
        this.factory = factory;
        this.$id = id++;
        this.loaded = false;
        this.getTemplate = function (uiView, context) {
            return _this.component ? _this.factory.makeComponentTemplate(uiView, context, _this.component, _this.viewDecl.bindings) : _this.template;
        };
    }
    Ng1ViewConfig.prototype.load = function () {
        var _this = this;
        var $q = ui_router_core_1.services.$q;
        var context = new ui_router_core_1.ResolveContext(this.path);
        var params = this.path.reduce(function (acc, node) { return ui_router_core_1.extend(acc, node.paramValues); }, {});
        var promises = {
            template: $q.when(this.factory.fromConfig(this.viewDecl, params, context)),
            controller: $q.when(this.getController(context))
        };
        return $q.all(promises).then(function (results) {
            ui_router_core_1.trace.traceViewServiceEvent("Loaded", _this);
            _this.controller = results.controller;
            ui_router_core_1.extend(_this, results.template); // Either { template: "tpl" } or { component: "cmpName" }
            return _this;
        });
    };
    /**
     * Gets the controller for a view configuration.
     *
     * @returns {Function|Promise.<Function>} Returns a controller, or a promise that resolves to a controller.
     */
    Ng1ViewConfig.prototype.getController = function (context) {
        var provider = this.viewDecl.controllerProvider;
        if (!ui_router_core_1.isInjectable(provider))
            return this.viewDecl.controller;
        var deps = ui_router_core_1.services.$injector.annotate(provider);
        var providerFn = ui_router_core_1.isArray(provider) ? ui_router_core_1.tail(provider) : provider;
        var resolvable = new ui_router_core_1.Resolvable("", providerFn, deps);
        return resolvable.get(context);
    };
    return Ng1ViewConfig;
}());
exports.Ng1ViewConfig = Ng1ViewConfig;
//# sourceMappingURL=views.js.map

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(74);
var document = __webpack_require__(25).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 154 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 155 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(177)('keys');
var uid = __webpack_require__(167);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 157 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAABICAYAAAA3Qp8tAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAG1JREFUeNq0jzEOgDAMA90WChMDUsXKp3kcTwFRQp0hUR9AhpPtJo0CEQG2UkIEIMRAqAUR+0xVNpt7eLNPjES171U9ptzexGXZa5nbYM2KpA/QE1pNtAutLtI67Y5/0G87UsNOrMRMgKifAAMA8xojdBZ1K0cAAAAASUVORK5CYII="

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4324b88de7489d294890282768ad3698.png";

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(87);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 160 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 161 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj4KPHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgMzAgMzAiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8cGF0aCBmaWxsPSIjNDA5ODNEIiBkPSJNMjcuMDc3LDYuNTk1Yy0zLjY2MiwxLjY1LTcuMDQ0LDMuMTctMTAuNDIyLDQuNjk4Yy0xLjQ2OSwwLjY2NC0yLjkzOCwxLjMyOS00LjM5LDIuMDMKCWMtMC41NTIsMC4yNjctMC45OTcsMC4yMjctMS40OC0wLjE0N2MtMC45NTMtMC43NC0xLjkxNi0xLjQ2Ny0yLjkxNC0yLjE0MmMtMC4yNDQtMC4xNjUtMC42MzUtMC4xMDctMC45NTgtMC4xNTEKCWMtMC4wMTgsMC4zMzYtMC4xNTQsMC43MjUtMC4wMzQsMWMwLjg0NywxLjk0MSwxLjczLDMuODY2LDIuNjM2LDUuNzhjMC40MTQsMC44NzUsMS4xMDgsMS4wNjMsMi4wNTYsMC41MTgKCWMyLjI0My0xLjI5MSw0LjQ1Ni0yLjYzNCw2LjY4Ni0zLjk0OWMzLjA5LTEuODIyLDYuMTkyLTMuNjI0LDkuMjY5LTUuNDY4YzAuNjQ0LTAuMzg2LDAuOTEyLTAuMjAyLDEuMjA4LDAuNDE0CgljMS40NjksMy4wNSwxLjQ4Myw2LjgzMy0wLjE5OCw5Ljc5OWMtMS44NTMsMy4yNy01LjE0MSw1LjU1NC04LjcwMyw2LjUxMmMtMy4wNzIsMC44MjYtNi4xOTMsMC44OTQtOS4yNzYsMC4wODQKCWMtMS4wOTYtMC4yODgtMi4xMDEsMC4yODktMi45ODEsMC44ODdjLTAuMzcxLDAuMjUyLTEuODQ5LDEuNDcyLTIuMjE1LDEuMTQ2Yy0wLjQwMi0wLjM1OCwwLjI2OC0yLjE2OSwwLjMwOC0yLjcwNwoJYzAuMDcxLTAuOTc4LTAuNDAyLTEuNzc1LTEuMTQtMi4zNzRjLTIuNDg0LTIuMDE3LTQuMDk2LTQuNjA5LTQuMjgtNy45MzNDMC4wMTIsMTAuMywyLjUyMyw2LjMsNi4wNzgsNC4xNDIKCUMxMC4yNzUsMS41OTQsMTUuNjUzLDAuOCwyMC4zLDIuNDcxYzEuMzUsMC40ODYsMi43NzcsMS4xMTUsMy45OSwxLjg5MkMyNS4yMjQsNC45NjEsMjYuMDM3LDUuNzUzLDI3LjA3Nyw2LjU5NXoiLz4KPC9zdmc+Cg=="

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0c96c7884296dd1044cfc6535ce6d61a.gif";

/***/ }),
/* 163 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 164 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

/*
 angular-file-upload v2.3.4
 https://github.com/nervgh/angular-file-upload
*/

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports["angular-file-upload"]=t():e["angular-file-upload"]=t()}(this,function(){return function(e){function t(n){if(o[n])return o[n].exports;var r=o[n]={exports:{},id:n,loaded:!1};return e[n].call(r.exports,r,r.exports,t),r.loaded=!0,r.exports}var o={};return t.m=e,t.c=o,t.p="",t(0)}([function(e,t,o){"use strict";function n(e){return e&&e.__esModule?e:{"default":e}}var r=o(1),i=n(r),s=o(2),a=n(s),l=o(3),u=n(l),p=o(4),c=n(p),f=o(5),d=n(f),h=o(6),y=n(h),m=o(7),_=n(m),v=o(8),g=n(v),F=o(9),b=n(F),O=o(10),C=n(O),I=o(11),U=n(I),w=o(12),A=n(w);angular.module(i["default"].name,[]).value("fileUploaderOptions",a["default"]).factory("FileUploader",u["default"]).factory("FileLikeObject",c["default"]).factory("FileItem",d["default"]).factory("FileDirective",y["default"]).factory("FileSelect",_["default"]).factory("FileDrop",g["default"]).factory("FileOver",b["default"]).directive("nvFileSelect",C["default"]).directive("nvFileDrop",U["default"]).directive("nvFileOver",A["default"]).run(["FileUploader","FileLikeObject","FileItem","FileDirective","FileSelect","FileDrop","FileOver",function(e,t,o,n,r,i,s){e.FileLikeObject=t,e.FileItem=o,e.FileDirective=n,e.FileSelect=r,e.FileDrop=i,e.FileOver=s}])},function(e,t){e.exports={name:"angularFileUpload"}},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t["default"]={url:"/",alias:"file",headers:{},queue:[],progress:0,autoUpload:!1,removeAfterUpload:!1,method:"POST",filters:[],formData:[],queueLimit:Number.MAX_VALUE,withCredentials:!1,disableMultipart:!1}},function(e,t,o){"use strict";function n(e){return e&&e.__esModule?e:{"default":e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t,o,n,i,s,a){var m=n.File,_=n.FormData,v=function(){function n(t){r(this,n);var o=l(e);u(this,o,t,{isUploading:!1,_nextIndex:0,_failFilterIndex:-1,_directives:{select:[],drop:[],over:[]}}),this.filters.unshift({name:"queueLimit",fn:this._queueLimitFilter}),this.filters.unshift({name:"folder",fn:this._folderFilter})}return n.prototype.addToQueue=function(e,t,o){var n=this,r=this.isArrayLikeObject(e)?e:[e],i=this._getFilters(o),l=this.queue.length,u=[];p(r,function(e){var o=new s(e);if(n._isValidFile(o,i,t)){var r=new a(n,e,t);u.push(r),n.queue.push(r),n._onAfterAddingFile(r)}else{var l=i[n._failFilterIndex];n._onWhenAddingFileFailed(o,l,t)}}),this.queue.length!==l&&(this._onAfterAddingAll(u),this.progress=this._getTotalProgress()),this._render(),this.autoUpload&&this.uploadAll()},n.prototype.removeFromQueue=function(e){var t=this.getIndexOfItem(e),o=this.queue[t];o.isUploading&&o.cancel(),this.queue.splice(t,1),o._destroy(),this.progress=this._getTotalProgress()},n.prototype.clearQueue=function(){for(;this.queue.length;)this.queue[0].remove();this.progress=0},n.prototype.uploadItem=function(e){var t=this.getIndexOfItem(e),o=this.queue[t],n=this.isHTML5?"_xhrTransport":"_iframeTransport";o._prepareToUploading(),this.isUploading||(this._onBeforeUploadItem(o),o.isCancel||(o.isUploading=!0,this.isUploading=!0,this[n](o),this._render()))},n.prototype.cancelItem=function(e){var t=this,o=this.getIndexOfItem(e),n=this.queue[o],r=this.isHTML5?"_xhr":"_form";n&&(n.isCancel=!0,n.isUploading?n[r].abort():!function(){var e=[void 0,0,{}],o=function(){t._onCancelItem.apply(t,[n].concat(e)),t._onCompleteItem.apply(t,[n].concat(e))};i(o)}())},n.prototype.uploadAll=function(){var e=this.getNotUploadedItems().filter(function(e){return!e.isUploading});e.length&&(p(e,function(e){return e._prepareToUploading()}),e[0].upload())},n.prototype.cancelAll=function(){var e=this.getNotUploadedItems();p(e,function(e){return e.cancel()})},n.prototype.isFile=function(e){return this.constructor.isFile(e)},n.prototype.isFileLikeObject=function(e){return this.constructor.isFileLikeObject(e)},n.prototype.isArrayLikeObject=function(e){return this.constructor.isArrayLikeObject(e)},n.prototype.getIndexOfItem=function(e){return f(e)?e:this.queue.indexOf(e)},n.prototype.getNotUploadedItems=function(){return this.queue.filter(function(e){return!e.isUploaded})},n.prototype.getReadyItems=function(){return this.queue.filter(function(e){return e.isReady&&!e.isUploading}).sort(function(e,t){return e.index-t.index})},n.prototype.destroy=function(){var e=this;p(this._directives,function(t){p(e._directives[t],function(e){e.destroy()})})},n.prototype.onAfterAddingAll=function(e){},n.prototype.onAfterAddingFile=function(e){},n.prototype.onWhenAddingFileFailed=function(e,t,o){},n.prototype.onBeforeUploadItem=function(e){},n.prototype.onProgressItem=function(e,t){},n.prototype.onProgressAll=function(e){},n.prototype.onSuccessItem=function(e,t,o,n){},n.prototype.onErrorItem=function(e,t,o,n){},n.prototype.onCancelItem=function(e,t,o,n){},n.prototype.onCompleteItem=function(e,t,o,n){},n.prototype.onCompleteAll=function(){},n.prototype._getTotalProgress=function(e){if(this.removeAfterUpload)return e||0;var t=this.getNotUploadedItems().length,o=t?this.queue.length-t:this.queue.length,n=100/this.queue.length,r=(e||0)*n/100;return Math.round(o*n+r)},n.prototype._getFilters=function(e){if(!e)return this.filters;if(h(e))return e;var t=e.match(/[^\s,]+/g);return this.filters.filter(function(e){return-1!==t.indexOf(e.name)})},n.prototype._render=function(){t.$$phase||t.$apply()},n.prototype._folderFilter=function(e){return!(!e.size&&!e.type)},n.prototype._queueLimitFilter=function(){return this.queue.length<this.queueLimit},n.prototype._isValidFile=function(e,t,o){var n=this;return this._failFilterIndex=-1,t.length?t.every(function(t){return n._failFilterIndex++,t.fn.call(n,e,o)}):!0},n.prototype._isSuccessCode=function(e){return e>=200&&300>e||304===e},n.prototype._transformResponse=function(e,t){var n=this._headersGetter(t);return p(o.defaults.transformResponse,function(t){e=t(e,n)}),e},n.prototype._parseHeaders=function(e){var t,o,n,r={};return e?(p(e.split("\n"),function(e){n=e.indexOf(":"),t=e.slice(0,n).trim().toLowerCase(),o=e.slice(n+1).trim(),t&&(r[t]=r[t]?r[t]+", "+o:o)}),r):r},n.prototype._headersGetter=function(e){return function(t){return t?e[t.toLowerCase()]||null:e}},n.prototype._xhrTransport=function(e){var t,o=this,n=e._xhr=new XMLHttpRequest;if(e.disableMultipart?t=e._file:(t=new _,p(e.formData,function(e){p(e,function(e,o){t.append(o,e)})}),t.append(e.alias,e._file,e.file.name)),"number"!=typeof e._file.size)throw new TypeError("The file specified is no longer valid");n.upload.onprogress=function(t){var n=Math.round(t.lengthComputable?100*t.loaded/t.total:0);o._onProgressItem(e,n)},n.onload=function(){var t=o._parseHeaders(n.getAllResponseHeaders()),r=o._transformResponse(n.response,t),i=o._isSuccessCode(n.status)?"Success":"Error",s="_on"+i+"Item";o[s](e,r,n.status,t),o._onCompleteItem(e,r,n.status,t)},n.onerror=function(){var t=o._parseHeaders(n.getAllResponseHeaders()),r=o._transformResponse(n.response,t);o._onErrorItem(e,r,n.status,t),o._onCompleteItem(e,r,n.status,t)},n.onabort=function(){var t=o._parseHeaders(n.getAllResponseHeaders()),r=o._transformResponse(n.response,t);o._onCancelItem(e,r,n.status,t),o._onCompleteItem(e,r,n.status,t)},n.open(e.method,e.url,!0),n.withCredentials=e.withCredentials,p(e.headers,function(e,t){n.setRequestHeader(t,e)}),n.send(t)},n.prototype._iframeTransport=function(e){var t=this,o=y('<form style="display: none;" />'),n=y('<iframe name="iframeTransport'+Date.now()+'">'),r=e._input;e._form&&e._form.replaceWith(r),e._form=o,r.prop("name",e.alias),p(e.formData,function(e){p(e,function(e,t){var n=y('<input type="hidden" name="'+t+'" />');n.val(e),o.append(n)})}),o.prop({action:e.url,method:"POST",target:n.prop("name"),enctype:"multipart/form-data",encoding:"multipart/form-data"}),n.bind("load",function(){var o="",r=200;try{o=n[0].contentDocument.body.innerHTML}catch(i){r=500}var s={response:o,status:r,dummy:!0},a={},l=t._transformResponse(s.response,a);t._onSuccessItem(e,l,s.status,a),t._onCompleteItem(e,l,s.status,a)}),o.abort=function(){var i,s={status:0,dummy:!0},a={};n.unbind("load").prop("src","javascript:false;"),o.replaceWith(r),t._onCancelItem(e,i,s.status,a),t._onCompleteItem(e,i,s.status,a)},r.after(o),o.append(r).append(n),o[0].submit()},n.prototype._onWhenAddingFileFailed=function(e,t,o){this.onWhenAddingFileFailed(e,t,o)},n.prototype._onAfterAddingFile=function(e){this.onAfterAddingFile(e)},n.prototype._onAfterAddingAll=function(e){this.onAfterAddingAll(e)},n.prototype._onBeforeUploadItem=function(e){e._onBeforeUpload(),this.onBeforeUploadItem(e)},n.prototype._onProgressItem=function(e,t){var o=this._getTotalProgress(t);this.progress=o,e._onProgress(t),this.onProgressItem(e,t),this.onProgressAll(o),this._render()},n.prototype._onSuccessItem=function(e,t,o,n){e._onSuccess(t,o,n),this.onSuccessItem(e,t,o,n)},n.prototype._onErrorItem=function(e,t,o,n){e._onError(t,o,n),this.onErrorItem(e,t,o,n)},n.prototype._onCancelItem=function(e,t,o,n){e._onCancel(t,o,n),this.onCancelItem(e,t,o,n)},n.prototype._onCompleteItem=function(e,t,o,n){e._onComplete(t,o,n),this.onCompleteItem(e,t,o,n);var r=this.getReadyItems()[0];return this.isUploading=!1,d(r)?void r.upload():(this.onCompleteAll(),this.progress=this._getTotalProgress(),void this._render())},n.isFile=function(e){return m&&e instanceof m},n.isFileLikeObject=function(e){return e instanceof s},n.isArrayLikeObject=function(e){return c(e)&&"length"in e},n.inherit=function(e,t){e.prototype=Object.create(t.prototype),e.prototype.constructor=e,e.super_=t},n}();return v.prototype.isHTML5=!(!m||!_),v.isHTML5=v.prototype.isHTML5,v}Object.defineProperty(t,"__esModule",{value:!0}),t["default"]=i;var s=o(1),a=(n(s),angular),l=a.copy,u=a.extend,p=a.forEach,c=a.isObject,f=a.isNumber,d=a.isDefined,h=a.isArray,y=a.element;i.$inject=["fileUploaderOptions","$rootScope","$http","$window","$timeout","FileLikeObject","FileItem"]},function(e,t,o){"use strict";function n(e){return e&&e.__esModule?e:{"default":e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(){return function(){function e(t){r(this,e);var o=u(t),n=o?t.value:t,i=p(n)?"FakePath":"Object",s="_createFrom"+i;this[s](n)}return e.prototype._createFromFakePath=function(e){this.lastModifiedDate=null,this.size=null,this.type="like/"+e.slice(e.lastIndexOf(".")+1).toLowerCase(),this.name=e.slice(e.lastIndexOf("/")+e.lastIndexOf("\\")+2)},e.prototype._createFromObject=function(e){this.lastModifiedDate=l(e.lastModifiedDate),this.size=e.size,this.type=e.type,this.name=e.name},e}()}Object.defineProperty(t,"__esModule",{value:!0}),t["default"]=i;var s=o(1),a=(n(s),angular),l=a.copy,u=a.isElement,p=a.isString},function(e,t,o){"use strict";function n(e){return e&&e.__esModule?e:{"default":e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){return function(){function o(e,n,i){r(this,o);var s=c(n),a=s?p(n):null,f=s?null:n;u(this,{url:e.url,alias:e.alias,headers:l(e.headers),formData:l(e.formData),removeAfterUpload:e.removeAfterUpload,withCredentials:e.withCredentials,disableMultipart:e.disableMultipart,method:e.method},i,{uploader:e,file:new t(n),isReady:!1,isUploading:!1,isUploaded:!1,isSuccess:!1,isCancel:!1,isError:!1,progress:0,index:null,_file:f,_input:a}),a&&this._replaceNode(a)}return o.prototype.upload=function(){try{this.uploader.uploadItem(this)}catch(e){this.uploader._onCompleteItem(this,"",0,[]),this.uploader._onErrorItem(this,"",0,[])}},o.prototype.cancel=function(){this.uploader.cancelItem(this)},o.prototype.remove=function(){this.uploader.removeFromQueue(this)},o.prototype.onBeforeUpload=function(){},o.prototype.onProgress=function(e){},o.prototype.onSuccess=function(e,t,o){},o.prototype.onError=function(e,t,o){},o.prototype.onCancel=function(e,t,o){},o.prototype.onComplete=function(e,t,o){},o.prototype._onBeforeUpload=function(){this.isReady=!0,this.isUploading=!1,this.isUploaded=!1,this.isSuccess=!1,this.isCancel=!1,this.isError=!1,this.progress=0,this.onBeforeUpload()},o.prototype._onProgress=function(e){this.progress=e,this.onProgress(e)},o.prototype._onSuccess=function(e,t,o){this.isReady=!1,this.isUploading=!1,this.isUploaded=!0,this.isSuccess=!0,this.isCancel=!1,this.isError=!1,this.progress=100,this.index=null,this.onSuccess(e,t,o)},o.prototype._onError=function(e,t,o){this.isReady=!1,this.isUploading=!1,this.isUploaded=!0,this.isSuccess=!1,this.isCancel=!1,this.isError=!0,this.progress=0,this.index=null,this.onError(e,t,o)},o.prototype._onCancel=function(e,t,o){this.isReady=!1,this.isUploading=!1,this.isUploaded=!1,this.isSuccess=!1,this.isCancel=!0,this.isError=!1,this.progress=0,this.index=null,this.onCancel(e,t,o)},o.prototype._onComplete=function(e,t,o){this.onComplete(e,t,o),this.removeAfterUpload&&this.remove()},o.prototype._destroy=function(){this._input&&this._input.remove(),this._form&&this._form.remove(),delete this._form,delete this._input},o.prototype._prepareToUploading=function(){this.index=this.index||++this.uploader._nextIndex,this.isReady=!0},o.prototype._replaceNode=function(t){var o=e(t.clone())(t.scope());o.prop("value",null),t.css("display","none"),t.after(o)},o}()}Object.defineProperty(t,"__esModule",{value:!0}),t["default"]=i;var s=o(1),a=(n(s),angular),l=a.copy,u=a.extend,p=a.element,c=a.isElement;i.$inject=["$compile","FileLikeObject"]},function(e,t,o){"use strict";function n(e){return e&&e.__esModule?e:{"default":e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(){var e=function(){function e(t){r(this,e),l(this,t),this.uploader._directives[this.prop].push(this),this._saveLinks(),this.bind()}return e.prototype.bind=function(){for(var e in this.events){var t=this.events[e];this.element.bind(e,this[t])}},e.prototype.unbind=function(){for(var e in this.events)this.element.unbind(e,this.events[e])},e.prototype.destroy=function(){var e=this.uploader._directives[this.prop].indexOf(this);this.uploader._directives[this.prop].splice(e,1),this.unbind()},e.prototype._saveLinks=function(){for(var e in this.events){var t=this.events[e];this[t]=this[t].bind(this)}},e}();return e.prototype.events={},e}Object.defineProperty(t,"__esModule",{value:!0}),t["default"]=i;var s=o(1),a=(n(s),angular),l=a.extend},function(e,t,o){"use strict";function n(e){return e&&e.__esModule?e:{"default":e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function s(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function a(e,t){return function(t){function o(e){r(this,o);var n=p(e,{events:{$destroy:"destroy",change:"onChange"},prop:"select"}),s=i(this,t.call(this,n));return s.uploader.isHTML5||s.element.removeAttr("multiple"),s.element.prop("value",null),s}return s(o,t),o.prototype.getOptions=function(){},o.prototype.getFilters=function(){},o.prototype.isEmptyAfterSelection=function(){return!!this.element.attr("multiple")},o.prototype.onChange=function(){var t=this.uploader.isHTML5?this.element[0].files:this.element[0],o=this.getOptions(),n=this.getFilters();this.uploader.isHTML5||this.destroy(),this.uploader.addToQueue(t,o,n),this.isEmptyAfterSelection()&&(this.element.prop("value",null),this.element.replaceWith(e(this.element.clone())(this.scope)))},o}(t)}Object.defineProperty(t,"__esModule",{value:!0}),t["default"]=a;var l=o(1),u=(n(l),angular),p=u.extend;a.$inject=["$compile","FileDirective"]},function(e,t,o){"use strict";function n(e){return e&&e.__esModule?e:{"default":e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function s(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function a(e){return function(e){function t(o){r(this,t);var n=p(o,{events:{$destroy:"destroy",drop:"onDrop",dragover:"onDragOver",dragleave:"onDragLeave"},prop:"drop"});return i(this,e.call(this,n))}return s(t,e),t.prototype.getOptions=function(){},t.prototype.getFilters=function(){},t.prototype.onDrop=function(e){var t=this._getTransfer(e);if(t){var o=this.getOptions(),n=this.getFilters();this._preventAndStop(e),c(this.uploader._directives.over,this._removeOverClass,this),this.uploader.addToQueue(t.files,o,n)}},t.prototype.onDragOver=function(e){var t=this._getTransfer(e);this._haveFiles(t.types)&&(t.dropEffect="copy",this._preventAndStop(e),c(this.uploader._directives.over,this._addOverClass,this))},t.prototype.onDragLeave=function(e){e.currentTarget!==this.element[0]&&(this._preventAndStop(e),c(this.uploader._directives.over,this._removeOverClass,this))},t.prototype._getTransfer=function(e){return e.dataTransfer?e.dataTransfer:e.originalEvent.dataTransfer},t.prototype._preventAndStop=function(e){e.preventDefault(),e.stopPropagation()},t.prototype._haveFiles=function(e){return e?e.indexOf?-1!==e.indexOf("Files"):e.contains?e.contains("Files"):!1:!1},t.prototype._addOverClass=function(e){e.addOverClass()},t.prototype._removeOverClass=function(e){e.removeOverClass()},t}(e)}Object.defineProperty(t,"__esModule",{value:!0}),t["default"]=a;var l=o(1),u=(n(l),angular),p=u.extend,c=u.forEach;a.$inject=["FileDirective"]},function(e,t,o){"use strict";function n(e){return e&&e.__esModule?e:{"default":e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function s(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function a(e){return function(e){function t(o){r(this,t);var n=p(o,{events:{$destroy:"destroy"},prop:"over",overClass:"nv-file-over"});return i(this,e.call(this,n))}return s(t,e),t.prototype.addOverClass=function(){this.element.addClass(this.getOverClass())},t.prototype.removeOverClass=function(){this.element.removeClass(this.getOverClass())},t.prototype.getOverClass=function(){return this.overClass},t}(e)}Object.defineProperty(t,"__esModule",{value:!0}),t["default"]=a;var l=o(1),u=(n(l),angular),p=u.extend;a.$inject=["FileDirective"]},function(e,t,o){"use strict";function n(e){return e&&e.__esModule?e:{"default":e}}function r(e,t,o){return{link:function(n,r,i){var s=n.$eval(i.uploader);if(!(s instanceof t))throw new TypeError('"Uploader" must be an instance of FileUploader');var a=new o({uploader:s,element:r,scope:n});a.getOptions=e(i.options).bind(a,n),a.getFilters=function(){return i.filters}}}}Object.defineProperty(t,"__esModule",{value:!0}),t["default"]=r;var i=o(1);n(i);r.$inject=["$parse","FileUploader","FileSelect"]},function(e,t,o){"use strict";function n(e){return e&&e.__esModule?e:{"default":e}}function r(e,t,o){return{link:function(n,r,i){var s=n.$eval(i.uploader);if(!(s instanceof t))throw new TypeError('"Uploader" must be an instance of FileUploader');if(s.isHTML5){var a=new o({uploader:s,element:r});a.getOptions=e(i.options).bind(a,n),a.getFilters=function(){return i.filters}}}}}Object.defineProperty(t,"__esModule",{value:!0}),t["default"]=r;var i=o(1);n(i);r.$inject=["$parse","FileUploader","FileDrop"]},function(e,t,o){"use strict";function n(e){return e&&e.__esModule?e:{"default":e}}function r(e,t){return{link:function(o,n,r){var i=o.$eval(r.uploader);if(!(i instanceof e))throw new TypeError('"Uploader" must be an instance of FileUploader');var s=new t({uploader:i,element:n});s.getOverClass=function(){return r.overClass||s.overClass}}}}Object.defineProperty(t,"__esModule",{value:!0}),t["default"]=r;var i=o(1);n(i);r.$inject=["FileUploader","FileOver"]}])});
//# sourceMappingURL=angular-file-upload.min.js.map

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(155);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 167 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 168 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 169 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDEzLjAuMiwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMTQ5NDgpICAtLT4KPCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjAvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvVFIvMjAwMS9SRUMtU1ZHLTIwMDEwOTA0L0RURC9zdmcxMC5kdGQiPgo8c3ZnIHZlcnNpb249IjEuMCIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHdpZHRoPSI2NHB4IiBoZWlnaHQ9IjY0cHgiIHZpZXdCb3g9IjUgLTMgNjQgNjQiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMTEgLTcgNjQgNjQiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8Zz4KCTxjaXJjbGUgZmlsbD0iI0ZGRkZGRiIgY3g9IjM3LjU2NCIgY3k9IjI4LjI4OCIgcj0iMjkuMDEzIi8+Cgk8Zz4KCQk8cGF0aCBkPSJNMzcuNDQzLTMuNWM4Ljk1MSwwLDE2LjUzMSwzLjEwNSwyMi43NDIsOS4zMTVDNjYuMzkzLDExLjk4Nyw2OS41LDE5LjU0OCw2OS41LDI4LjVjMCw4Ljk1NC0zLjA0OSwxNi40NTctOS4xNDUsMjIuNTE0CgkJCUM1My45MTgsNTcuMzM4LDQ2LjI3OSw2MC41LDM3LjQ0Myw2MC41Yy04LjY0OSwwLTE2LjE1My0zLjE0My0yMi41MTQtOS40M0M4LjY0NCw0NC43ODYsNS41LDM3LjI2NCw1LjUsMjguNTAxCgkJCWMwLTguNzIzLDMuMTQ0LTE2LjI4NSw5LjQyOS0yMi42ODVDMjEuMTM4LTAuMzk1LDI4LjY0My0zLjUsMzcuNDQzLTMuNXogTTM3LjU1NywyLjI3MmMtNy4yNzYsMC0xMy40MjgsMi41NzItMTguNDU3LDcuNzE1CgkJCWMtNS4yMiw1LjI5Ni03LjgyOSwxMS40NjctNy44MjksMTguNTEzYzAsNy4xMjUsMi41OSwxMy4yNTcsNy43NywxOC40YzUuMTgxLDUuMTgyLDExLjM1Miw3Ljc3MSwxOC41MTQsNy43NzEKCQkJYzcuMTIzLDAsMTMuMzM0LTIuNjA4LDE4LjYyOS03LjgyOGM1LjAyOS00Ljg3Niw3LjU0My0xMC45ODksNy41NDMtMTguMzQzYzAtNy4zMTMtMi41NTMtMTMuNDg1LTcuNjU2LTE4LjUxMwoJCQlDNTEuMDA0LDQuODQyLDQ0LjgzMiwyLjI3MiwzNy41NTcsMi4yNzJ6IE00OS42MTUsMjAuOTU2djUuNDg2SDI2LjM1OHYtNS40ODZINDkuNjE1eiBNNDkuNjE1LDMxLjI0M3Y1LjQ4M0gyNi4zNTh2LTUuNDgzSDQ5LjYxNQoJCQl6Ii8+Cgk8L2c+CjwvZz4KPC9zdmc+Cg=="

/***/ }),
/* 170 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 171 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE3LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4iICJodHRwOi8vd3d3LnczLm9yZy9HcmFwaGljcy9TVkcvMS4xL0RURC9zdmcxMS5kdGQiPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IuWbvuWxgl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIKCSB3aWR0aD0iNDhweCIgaGVpZ2h0PSI1N3B4IiB2aWV3Qm94PSIwIDAgNDggNTciIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDQ4IDU3IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPGc+Cgk8cGF0aCBmaWxsPSIjRkZGRkZGIiBkPSJNMi41NjIsNDIuODczVjEwLjMyMWg2LjM3M2M1LjUyOCwwLDExLjE5NC0yLjI5NywxNC45NzYtNS45MTNjMy43ODIsMy42MTYsOS40NDgsNS45MTMsMTQuOTc2LDUuOTEzaDYuMzcyCgkJdjMyLjU1MkwyMy45MTEsNTMuOTdMMi41NjIsNDIuODczeiIvPgoJPHBhdGggZD0iTTIzLjkxMSw3LjcxOGM0LjExMiwzLjE5Myw5LjUzMiw1LjEwMywxNC45NzYsNS4xMDNoMy44NzJ2MjguNTM0bC0xOC44NDgsOS43OTdMNS4wNjMsNDEuMzU1VjEyLjgyMWgzLjg3MgoJCUMxNC4zNzksMTIuODIxLDE5Ljc5OSwxMC45MTEsMjMuOTExLDcuNzE4IE0yMy45MTEsMC42MjVjLTMuMTIyLDQuMzUyLTkuMjExLDcuMTk2LTE0Ljk3Niw3LjE5NkgwLjA2M3YzNi41NzFsMjMuODQ4LDEyLjM5NgoJCWwyMy44NDgtMTIuMzk2VjcuODIxaC04Ljg3MkMzMy4xMjIsNy44MjEsMjcuMDMzLDQuOTc2LDIzLjkxMSwwLjYyNUwyMy45MTEsMC42MjV6Ii8+CjwvZz4KPHJlY3QgeD0iMTIuNjI1IiB5PSIyNS4xOSIgZmlsbD0iIzA0MDAwMCIgd2lkdGg9IjIyLjU3MiIgaGVpZ2h0PSI1Ii8+CjxyZWN0IHg9IjEzLjY3NiIgeT0iMTguNzM1IiB0cmFuc2Zvcm09Im1hdHJpeCgwLjUxOTYgMC44NTQ0IC0wLjg1NDQgMC41MTk2IDI3LjYxMjMgLTcuMTY2NCkiIGZpbGw9IiMwNDAwMDAiIHdpZHRoPSIxMy4wMDYiIGhlaWdodD0iNC40NzQiLz4KPHJlY3QgeD0iMjEuMTk4IiB5PSIxOC43MzUiIHRyYW5zZm9ybT0ibWF0cml4KC0wLjUxOTYgMC44NTQ0IC0wLjg1NDQgLTAuNTE5NiA2MC4wMTMgOC4yMDA5KSIgZmlsbD0iIzA0MDAwMCIgd2lkdGg9IjEzLjAwNiIgaGVpZ2h0PSI0LjQ3NCIvPgo8cmVjdCB4PSIyMS40MTEiIHk9IjI1Ljg5MyIgZmlsbD0iIzA0MDAwMCIgd2lkdGg9IjUiIGhlaWdodD0iMTguNjA3Ii8+CjxyZWN0IHg9IjEyLjYyNSIgeT0iMzMuNTA2IiBmaWxsPSIjMDQwMDAwIiB3aWR0aD0iMjIuNTcyIiBoZWlnaHQ9IjUiLz4KPC9zdmc+Cg=="

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(49);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _mediaAccount = __webpack_require__(741);

var _mediaAccount2 = _interopRequireDefault(_mediaAccount);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mediaAccountModule = _angular2.default.module('media-account', []).service('mediaAccount', _mediaAccount2.default).name;

exports.default = mediaAccountModule;

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(742), __esModule: true };

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(762);
module.exports = 'LocalStorageModule';


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(88);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(24);
var global = __webpack_require__(25);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(116) ? 'pure' : 'global',
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 178 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 179 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 180 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _publishToMedia = __webpack_require__(763);

var _publishToMedia2 = _interopRequireDefault(_publishToMedia);

var _mediaAccount = __webpack_require__(173);

var _mediaAccount2 = _interopRequireDefault(_mediaAccount);

__webpack_require__(165);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var publishToMediaModule = _angular2.default.module('publishToMedia', [_mediaAccount2.default, 'angularFileUpload']).component('publishToMedia', _publishToMedia2.default).name;

exports.default = publishToMediaModule;

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(116);
var $export = __webpack_require__(50);
var redefine = __webpack_require__(369);
var hide = __webpack_require__(64);
var Iterators = __webpack_require__(82);
var $iterCreate = __webpack_require__(771);
var setToStringTag = __webpack_require__(118);
var getPrototypeOf = __webpack_require__(773);
var ITERATOR = __webpack_require__(32)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(88);
var TAG = __webpack_require__(32)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(15) && !__webpack_require__(10)(function () {
  return Object.defineProperty(__webpack_require__(119)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(12);


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(26);
var toIObject = __webpack_require__(27);
var arrayIndexOf = __webpack_require__(90)(false);
var IE_PROTO = __webpack_require__(121)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(16);
var anObject = __webpack_require__(6);
var getKeys = __webpack_require__(54);

module.exports = __webpack_require__(15) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(27);
var gOPN = __webpack_require__(57).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(54);
var gOPS = __webpack_require__(91);
var pIE = __webpack_require__(76);
var toObject = __webpack_require__(18);
var IObject = __webpack_require__(75);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(10)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(19);
var isObject = __webpack_require__(11);
var invoke = __webpack_require__(191);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 191 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(7).parseInt;
var $trim = __webpack_require__(66).trim;
var ws = __webpack_require__(125);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(7).parseFloat;
var $trim = __webpack_require__(66).trim;

module.exports = 1 / $parseFloat(__webpack_require__(125) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(35);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(11);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 196 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(128);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(6);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(19);
var toObject = __webpack_require__(18);
var IObject = __webpack_require__(75);
var toLength = __webpack_require__(17);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(18);
var toAbsoluteIndex = __webpack_require__(55);
var toLength = __webpack_require__(17);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 201 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(15) && /./g.flags != 'g') __webpack_require__(16).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(95)
});


/***/ }),
/* 203 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(6);
var isObject = __webpack_require__(11);
var newPromiseCapability = __webpack_require__(143);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(206);
var validate = __webpack_require__(68);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(99)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(16).f;
var create = __webpack_require__(56);
var redefineAll = __webpack_require__(61);
var ctx = __webpack_require__(34);
var anInstance = __webpack_require__(59);
var forOf = __webpack_require__(60);
var $iterDefine = __webpack_require__(131);
var step = __webpack_require__(201);
var setSpecies = __webpack_require__(58);
var DESCRIPTORS = __webpack_require__(15);
var fastKey = __webpack_require__(45).fastKey;
var validate = __webpack_require__(68);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(206);
var validate = __webpack_require__(68);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(99)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var each = __webpack_require__(41)(0);
var redefine = __webpack_require__(22);
var meta = __webpack_require__(45);
var assign = __webpack_require__(189);
var weak = __webpack_require__(209);
var isObject = __webpack_require__(11);
var fails = __webpack_require__(10);
var validate = __webpack_require__(68);
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var tmp = {};
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(99)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (fails(function () { return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7; })) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(61);
var getWeak = __webpack_require__(45).getWeak;
var anObject = __webpack_require__(6);
var isObject = __webpack_require__(11);
var anInstance = __webpack_require__(59);
var forOf = __webpack_require__(60);
var createArrayMethod = __webpack_require__(41);
var $has = __webpack_require__(26);
var validate = __webpack_require__(68);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(39);
var toLength = __webpack_require__(17);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(57);
var gOPS = __webpack_require__(91);
var anObject = __webpack_require__(6);
var Reflect = __webpack_require__(7).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(92);
var isObject = __webpack_require__(11);
var toLength = __webpack_require__(17);
var ctx = __webpack_require__(34);
var IS_CONCAT_SPREADABLE = __webpack_require__(12)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(17);
var repeat = __webpack_require__(127);
var defined = __webpack_require__(38);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__(54);
var toIObject = __webpack_require__(27);
var isEnum = __webpack_require__(76).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) if (isEnum.call(O, key = keys[i++])) {
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(77);
var from = __webpack_require__(216);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(60);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 217 */
/***/ (function(module, exports) {

// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @coreapi
 * @module transition
 */ /** for typedoc */

var common_1 = __webpack_require__(8);
var predicates_1 = __webpack_require__(13);
var interface_1 = __webpack_require__(79);
var transitionHook_1 = __webpack_require__(80);
/**
 * This class returns applicable TransitionHooks for a specific Transition instance.
 *
 * Hooks ([[RegisteredHook]]) may be registered globally, e.g., $transitions.onEnter(...), or locally, e.g.
 * myTransition.onEnter(...).  The HookBuilder finds matching RegisteredHooks (where the match criteria is
 * determined by the type of hook)
 *
 * The HookBuilder also converts RegisteredHooks objects to TransitionHook objects, which are used to run a Transition.
 *
 * The HookBuilder constructor is given the $transitions service and a Transition instance.  Thus, a HookBuilder
 * instance may only be used for one specific Transition object. (side note: the _treeChanges accessor is private
 * in the Transition class, so we must also provide the Transition's _treeChanges)
 *
 */
var HookBuilder = (function () {
    function HookBuilder(transition) {
        this.transition = transition;
        this.treeChanges = transition.treeChanges();
        this.transitionOptions = transition.options();
        this.toState = common_1.tail(this.treeChanges.to).state;
        this.fromState = common_1.tail(this.treeChanges.from).state;
        this.$transitions = transition.router.transitionService;
        this.baseHookOptions = {
            transition: transition,
            current: transition.options().current
        };
    }
    HookBuilder.prototype.buildHooksForPhase = function (phase) {
        var _this = this;
        return this.$transitions._pluginapi._getEvents(phase)
            .map(function (type) { return _this.buildHooks(type); })
            .reduce(common_1.unnestR, [])
            .filter(common_1.identity);
    };
    /**
     * Returns an array of newly built TransitionHook objects.
     *
     * - Finds all RegisteredHooks registered for the given `hookType` which matched the transition's [[TreeChanges]].
     * - Finds [[PathNode]] (or `PathNode[]`) to use as the TransitionHook context(s)
     * - For each of the [[PathNode]]s, creates a TransitionHook
     *
     * @param hookType the type of the hook registration function, e.g., 'onEnter', 'onFinish'.
     */
    HookBuilder.prototype.buildHooks = function (hookType) {
        var _this = this;
        // Find all the matching registered hooks for a given hook type
        var matchingHooks = this.getMatchingHooks(hookType, this.treeChanges);
        if (!matchingHooks)
            return [];
        var makeTransitionHooks = function (hook) {
            // Fetch the Nodes that caused this hook to match.
            var matches = hook.matches(_this.treeChanges);
            // Select the PathNode[] that will be used as TransitionHook context objects
            var matchingNodes = matches[hookType.criteriaMatchPath.name];
            // Return an array of HookTuples
            return matchingNodes.map(function (node) {
                var _options = common_1.extend({
                    bind: hook.bind,
                    traceData: { hookType: hookType.name, context: node }
                }, _this.baseHookOptions);
                var state = hookType.criteriaMatchPath.scope === interface_1.TransitionHookScope.STATE ? node.state : null;
                var transitionHook = new transitionHook_1.TransitionHook(_this.transition, state, hook, _options);
                return { hook: hook, node: node, transitionHook: transitionHook };
            });
        };
        return matchingHooks.map(makeTransitionHooks)
            .reduce(common_1.unnestR, [])
            .sort(tupleSort(hookType.reverseSort))
            .map(function (tuple) { return tuple.transitionHook; });
    };
    /**
     * Finds all RegisteredHooks from:
     * - The Transition object instance hook registry
     * - The TransitionService ($transitions) global hook registry
     *
     * which matched:
     * - the eventType
     * - the matchCriteria (to, from, exiting, retained, entering)
     *
     * @returns an array of matched [[RegisteredHook]]s
     */
    HookBuilder.prototype.getMatchingHooks = function (hookType, treeChanges) {
        var isCreate = hookType.hookPhase === interface_1.TransitionHookPhase.CREATE;
        // Instance and Global hook registries
        var registries = isCreate ? [this.$transitions] : [this.transition, this.$transitions];
        return registries.map(function (reg) { return reg.getHooks(hookType.name); }) // Get named hooks from registries
            .filter(common_1.assertPredicate(predicates_1.isArray, "broken event named: " + hookType.name)) // Sanity check
            .reduce(common_1.unnestR, []) // Un-nest RegisteredHook[][] to RegisteredHook[] array
            .filter(function (hook) { return hook.matches(treeChanges); }); // Only those satisfying matchCriteria
    };
    return HookBuilder;
}());
exports.HookBuilder = HookBuilder;
/**
 * A factory for a sort function for HookTuples.
 *
 * The sort function first compares the PathNode depth (how deep in the state tree a node is), then compares
 * the EventHook priority.
 *
 * @param reverseDepthSort a boolean, when true, reverses the sort order for the node depth
 * @returns a tuple sort function
 */
function tupleSort(reverseDepthSort) {
    if (reverseDepthSort === void 0) { reverseDepthSort = false; }
    return function nodeDepthThenPriority(l, r) {
        var factor = reverseDepthSort ? -1 : 1;
        var depthDelta = (l.node.state.path.length - r.node.state.path.length) * factor;
        return depthDelta !== 0 ? depthDelta : r.hook.priority - l.hook.priority;
    };
}
//# sourceMappingURL=hookBuilder.js.map

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/** @internalapi */
exports.resolvePolicies = {
    when: {
        LAZY: "LAZY",
        EAGER: "EAGER"
    },
    async: {
        WAIT: "WAIT",
        NOWAIT: "NOWAIT",
        RXWAIT: "RXWAIT"
    }
};
//# sourceMappingURL=interface.js.map

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @coreapi
 * @module core
 */ /** */
var urlMatcherFactory_1 = __webpack_require__(221);
var urlRouter_1 = __webpack_require__(223);
var transitionService_1 = __webpack_require__(150);
var view_1 = __webpack_require__(227);
var stateRegistry_1 = __webpack_require__(228);
var stateService_1 = __webpack_require__(232);
var globals_1 = __webpack_require__(233);
var common_1 = __webpack_require__(8);
var predicates_1 = __webpack_require__(13);
var urlService_1 = __webpack_require__(235);
/** @hidden */
var _routerInstance = 0;
/**
 * The master class used to instantiate an instance of UI-Router.
 *
 * UI-Router (for a specific framework) will create an instance of this class during bootstrap.
 * This class instantiates and wires the UI-Router services together.
 *
 * After a new instance of the UIRouter class is created, it should be configured for your app.
 * For instance, app states should be registered with the [[stateRegistry]].
 *
 * Tell UI-Router to monitor the URL by calling `uiRouter.urlRouter.listen()` ([[UrlRouter.listen]])
 */
var UIRouter = (function () {
    function UIRouter(locationService, locationConfig) {
        if (locationService === void 0) { locationService = urlService_1.UrlService.locationServiceStub; }
        if (locationConfig === void 0) { locationConfig = urlService_1.UrlService.locationConfigStub; }
        this.locationService = locationService;
        this.locationConfig = locationConfig;
        /** @hidden */
        this.$id = _routerInstance++;
        this.viewService = new view_1.ViewService();
        this.transitionService = new transitionService_1.TransitionService(this);
        this.globals = new globals_1.Globals(this.transitionService);
        this.urlMatcherFactory = new urlMatcherFactory_1.UrlMatcherFactory();
        this.urlRouter = new urlRouter_1.UrlRouter(this);
        this.stateRegistry = new stateRegistry_1.StateRegistry(this);
        this.stateService = new stateService_1.StateService(this);
        this.urlService = new urlService_1.UrlService(this);
        this._disposables = [];
        /** @hidden */
        this._plugins = {};
        this.viewService._pluginapi._rootViewContext(this.stateRegistry.root());
        this.globals.$current = this.stateRegistry.root();
        this.globals.current = this.globals.$current.self;
        this.disposable(this.transitionService);
        this.disposable(this.urlRouter);
        this.disposable(this.stateRegistry);
        this.disposable(locationService);
        this.disposable(locationConfig);
    }
    /** Registers an object to be notified when the router is disposed */
    UIRouter.prototype.disposable = function (disposable) {
        this._disposables.push(disposable);
    };
    /**
     * Disposes this router instance
     *
     * When called, clears resources retained by the router by calling `dispose(this)` on all
     * registered [[disposable]] objects.
     *
     * Or, if a `disposable` object is provided, calls `dispose(this)` on that object only.
     *
     * @param disposable (optional) the disposable to dispose
     */
    UIRouter.prototype.dispose = function (disposable) {
        var _this = this;
        if (disposable && predicates_1.isFunction(disposable.dispose)) {
            disposable.dispose(this);
            return undefined;
        }
        this._disposables.slice().forEach(function (d) {
            try {
                typeof d.dispose === 'function' && d.dispose(_this);
                common_1.removeFrom(_this._disposables, d);
            }
            catch (ignored) { }
        });
    };
    /** Allow javascript factory function */
    UIRouter.prototype.plugin = function (plugin, options) {
        if (options === void 0) { options = {}; }
        var pluginInstance = new plugin(this, options);
        if (!pluginInstance.name)
            throw new Error("Required property `name` missing on plugin: " + pluginInstance);
        this._disposables.push(pluginInstance);
        return this._plugins[pluginInstance.name] = pluginInstance;
    };
    UIRouter.prototype.getPlugin = function (pluginName) {
        return pluginName ? this._plugins[pluginName] : common_1.values(this._plugins);
    };
    return UIRouter;
}());
exports.UIRouter = UIRouter;
//# sourceMappingURL=router.js.map

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @internalapi
 * @module url
 */ /** for typedoc */
var common_1 = __webpack_require__(8);
var predicates_1 = __webpack_require__(13);
var urlMatcher_1 = __webpack_require__(108);
var param_1 = __webpack_require__(70);
var paramTypes_1 = __webpack_require__(222);
/**
 * Factory for [[UrlMatcher]] instances.
 *
 * The factory is available to ng1 services as
 * `$urlMatcherFactor` or ng1 providers as `$urlMatcherFactoryProvider`.
 */
var UrlMatcherFactory = (function () {
    function UrlMatcherFactory() {
        var _this = this;
        /** @hidden */ this.paramTypes = new paramTypes_1.ParamTypes();
        /** @hidden */ this._isCaseInsensitive = false;
        /** @hidden */ this._isStrictMode = true;
        /** @hidden */ this._defaultSquashPolicy = false;
        /** @hidden */
        this._getConfig = function (config) {
            return common_1.extend({ strict: _this._isStrictMode, caseInsensitive: _this._isCaseInsensitive }, config);
        };
        /** @internalapi Creates a new [[Param]] for a given location (DefType) */
        this.paramFactory = {
            /** Creates a new [[Param]] from a CONFIG block */
            fromConfig: function (id, type, config) {
                return new param_1.Param(id, type, config, param_1.DefType.CONFIG, _this);
            },
            /** Creates a new [[Param]] from a url PATH */
            fromPath: function (id, type, config) {
                return new param_1.Param(id, type, config, param_1.DefType.PATH, _this);
            },
            /** Creates a new [[Param]] from a url SEARCH */
            fromSearch: function (id, type, config) {
                return new param_1.Param(id, type, config, param_1.DefType.SEARCH, _this);
            },
        };
        common_1.extend(this, { UrlMatcher: urlMatcher_1.UrlMatcher, Param: param_1.Param });
    }
    /** @inheritdoc */
    UrlMatcherFactory.prototype.caseInsensitive = function (value) {
        return this._isCaseInsensitive = predicates_1.isDefined(value) ? value : this._isCaseInsensitive;
    };
    /** @inheritdoc */
    UrlMatcherFactory.prototype.strictMode = function (value) {
        return this._isStrictMode = predicates_1.isDefined(value) ? value : this._isStrictMode;
    };
    /** @inheritdoc */
    UrlMatcherFactory.prototype.defaultSquashPolicy = function (value) {
        if (predicates_1.isDefined(value) && value !== true && value !== false && !predicates_1.isString(value))
            throw new Error("Invalid squash policy: " + value + ". Valid policies: false, true, arbitrary-string");
        return this._defaultSquashPolicy = predicates_1.isDefined(value) ? value : this._defaultSquashPolicy;
    };
    /**
     * Creates a [[UrlMatcher]] for the specified pattern.
     *
     * @param pattern  The URL pattern.
     * @param config  The config object hash.
     * @returns The UrlMatcher.
     */
    UrlMatcherFactory.prototype.compile = function (pattern, config) {
        return new urlMatcher_1.UrlMatcher(pattern, this.paramTypes, this.paramFactory, this._getConfig(config));
    };
    /**
     * Returns true if the specified object is a [[UrlMatcher]], or false otherwise.
     *
     * @param object  The object to perform the type check against.
     * @returns `true` if the object matches the `UrlMatcher` interface, by
     *          implementing all the same methods.
     */
    UrlMatcherFactory.prototype.isMatcher = function (object) {
        // TODO: typeof?
        if (!predicates_1.isObject(object))
            return false;
        var result = true;
        common_1.forEach(urlMatcher_1.UrlMatcher.prototype, function (val, name) {
            if (predicates_1.isFunction(val))
                result = result && (predicates_1.isDefined(object[name]) && predicates_1.isFunction(object[name]));
        });
        return result;
    };
    ;
    /**
     * Creates and registers a custom [[ParamType]] object
     *
     * A [[ParamType]] can be used to generate URLs with typed parameters.
     *
     * @param name  The type name.
     * @param definition The type definition. See [[ParamTypeDefinition]] for information on the values accepted.
     * @param definitionFn A function that is injected before the app runtime starts.
     *        The result of this function should be a [[ParamTypeDefinition]].
     *        The result is merged into the existing `definition`.
     *        See [[ParamType]] for information on the values accepted.
     *
     * @returns - if a type was registered: the [[UrlMatcherFactory]]
     *   - if only the `name` parameter was specified: the currently registered [[ParamType]] object, or undefined
     *
     * Note: Register custom types *before using them* in a state definition.
     *
     * See [[ParamTypeDefinition]] for examples
     */
    UrlMatcherFactory.prototype.type = function (name, definition, definitionFn) {
        var type = this.paramTypes.type(name, definition, definitionFn);
        return !predicates_1.isDefined(definition) ? type : this;
    };
    ;
    /** @hidden */
    UrlMatcherFactory.prototype.$get = function () {
        this.paramTypes.enqueue = false;
        this.paramTypes._flushTypeQueue();
        return this;
    };
    ;
    /** @internalapi */
    UrlMatcherFactory.prototype.dispose = function () {
        this.paramTypes.dispose();
    };
    return UrlMatcherFactory;
}());
exports.UrlMatcherFactory = UrlMatcherFactory;
//# sourceMappingURL=urlMatcherFactory.js.map

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @coreapi
 * @module params
 */ /** for typedoc */
var common_1 = __webpack_require__(8);
var predicates_1 = __webpack_require__(13);
var hof_1 = __webpack_require__(14);
var coreservices_1 = __webpack_require__(20);
var paramType_1 = __webpack_require__(148);
/**
 * A registry for parameter types.
 *
 * This registry manages the built-in (and custom) parameter types.
 *
 * The built-in parameter types are:
 *
 * - [[string]]
 * - [[path]]
 * - [[query]]
 * - [[hash]]
 * - [[int]]
 * - [[bool]]
 * - [[date]]
 * - [[json]]
 * - [[any]]
 */
var ParamTypes = (function () {
    /** @internalapi */
    function ParamTypes() {
        /** @hidden */
        this.enqueue = true;
        /** @hidden */
        this.typeQueue = [];
        /** @internalapi */
        this.defaultTypes = common_1.pick(ParamTypes.prototype, "hash", "string", "query", "path", "int", "bool", "date", "json", "any");
        // Register default types. Store them in the prototype of this.types.
        var makeType = function (definition, name) {
            return new paramType_1.ParamType(common_1.extend({ name: name }, definition));
        };
        this.types = common_1.inherit(common_1.map(this.defaultTypes, makeType), {});
    }
    /** @internalapi */
    ParamTypes.prototype.dispose = function () {
        this.types = {};
    };
    /**
     * Registers a parameter type
     *
     * End users should call [[UrlMatcherFactory.type]], which delegates to this method.
     */
    ParamTypes.prototype.type = function (name, definition, definitionFn) {
        if (!predicates_1.isDefined(definition))
            return this.types[name];
        if (this.types.hasOwnProperty(name))
            throw new Error("A type named '" + name + "' has already been defined.");
        this.types[name] = new paramType_1.ParamType(common_1.extend({ name: name }, definition));
        if (definitionFn) {
            this.typeQueue.push({ name: name, def: definitionFn });
            if (!this.enqueue)
                this._flushTypeQueue();
        }
        return this;
    };
    /** @internalapi */
    ParamTypes.prototype._flushTypeQueue = function () {
        while (this.typeQueue.length) {
            var type = this.typeQueue.shift();
            if (type.pattern)
                throw new Error("You cannot override a type's .pattern at runtime.");
            common_1.extend(this.types[type.name], coreservices_1.services.$injector.invoke(type.def));
        }
    };
    return ParamTypes;
}());
exports.ParamTypes = ParamTypes;
/** @hidden */
function initDefaultTypes() {
    var makeDefaultType = function (def) {
        var valToString = function (val) {
            return val != null ? val.toString() : val;
        };
        var defaultTypeBase = {
            encode: valToString,
            decode: valToString,
            is: hof_1.is(String),
            pattern: /.*/,
            equals: function (a, b) { return a == b; },
        };
        return common_1.extend({}, defaultTypeBase, def);
    };
    // Default Parameter Type Definitions
    common_1.extend(ParamTypes.prototype, {
        string: makeDefaultType({}),
        path: makeDefaultType({
            pattern: /[^/]*/,
        }),
        query: makeDefaultType({}),
        hash: makeDefaultType({
            inherit: false,
        }),
        int: makeDefaultType({
            decode: function (val) { return parseInt(val, 10); },
            is: function (val) {
                return !predicates_1.isNullOrUndefined(val) && this.decode(val.toString()) === val;
            },
            pattern: /-?\d+/,
        }),
        bool: makeDefaultType({
            encode: function (val) { return val && 1 || 0; },
            decode: function (val) { return parseInt(val, 10) !== 0; },
            is: hof_1.is(Boolean),
            pattern: /0|1/
        }),
        date: makeDefaultType({
            encode: function (val) {
                return !this.is(val) ? undefined : [
                    val.getFullYear(),
                    ('0' + (val.getMonth() + 1)).slice(-2),
                    ('0' + val.getDate()).slice(-2)
                ].join("-");
            },
            decode: function (val) {
                if (this.is(val))
                    return val;
                var match = this.capture.exec(val);
                return match ? new Date(match[1], match[2] - 1, match[3]) : undefined;
            },
            is: function (val) { return val instanceof Date && !isNaN(val.valueOf()); },
            equals: function (l, r) {
                return ['getFullYear', 'getMonth', 'getDate']
                    .reduce(function (acc, fn) { return acc && l[fn]() === r[fn](); }, true);
            },
            pattern: /[0-9]{4}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[1-2][0-9]|3[0-1])/,
            capture: /([0-9]{4})-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])/
        }),
        json: makeDefaultType({
            encode: common_1.toJson,
            decode: common_1.fromJson,
            is: hof_1.is(Object),
            equals: common_1.equals,
            pattern: /[^/]*/
        }),
        // does not encode/decode
        any: makeDefaultType({
            encode: common_1.identity,
            decode: common_1.identity,
            is: function () { return true; },
            equals: common_1.equals,
        }),
    });
}
initDefaultTypes();
//# sourceMappingURL=paramTypes.js.map

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @internalapi
 * @module url
 */
/** for typedoc */
var common_1 = __webpack_require__(8);
var predicates_1 = __webpack_require__(13);
var urlMatcher_1 = __webpack_require__(108);
var hof_1 = __webpack_require__(14);
var urlRule_1 = __webpack_require__(224);
var targetState_1 = __webpack_require__(62);
/** @hidden */
function appendBasePath(url, isHtml5, absolute, baseHref) {
    if (baseHref === '/')
        return url;
    if (isHtml5)
        return baseHref.slice(0, -1) + url;
    if (absolute)
        return baseHref.slice(1) + url;
    return url;
}
/** @hidden */
var getMatcher = hof_1.prop("urlMatcher");
/**
 * Default rule priority sorting function.
 *
 * Sorts rules by:
 *
 * - Explicit priority (set rule priority using [[UrlService.when]])
 * - Rule type (STATE: 4, URLMATCHER: 4, REGEXP: 3, RAW: 2, OTHER: 1)
 * - `UrlMatcher` specificity ([[UrlMatcher.compare]]): works for STATE and URLMATCHER types to pick the most specific rule.
 * - Registration order (for rule types other than STATE and URLMATCHER)
 *
 * @coreapi
 */
var defaultRuleSortFn;
defaultRuleSortFn = common_1.composeSort(common_1.sortBy(hof_1.pipe(hof_1.prop("priority"), function (x) { return -x; })), common_1.sortBy(hof_1.pipe(hof_1.prop("type"), function (type) { return ({ "STATE": 4, "URLMATCHER": 4, "REGEXP": 3, "RAW": 2, "OTHER": 1 })[type]; })), function (a, b) { return (getMatcher(a) && getMatcher(b)) ? urlMatcher_1.UrlMatcher.compare(getMatcher(a), getMatcher(b)) : 0; }, common_1.sortBy(hof_1.prop("$id"), common_1.inArray(["REGEXP", "RAW", "OTHER"])));
/**
 * Updates URL and responds to URL changes
 *
 * This class updates the URL when the state changes.
 * It also responds to changes in the URL.
 */
var UrlRouter = (function () {
    /** @hidden */
    function UrlRouter(router) {
        /** @hidden */ this._sortFn = defaultRuleSortFn;
        /** @hidden */ this._rules = [];
        /** @hidden */ this.interceptDeferred = false;
        /** @hidden */ this._id = 0;
        this._router = router;
        this.urlRuleFactory = new urlRule_1.UrlRuleFactory(router);
        common_1.createProxyFunctions(hof_1.val(UrlRouter.prototype), this, hof_1.val(this));
    }
    /** @internalapi */
    UrlRouter.prototype.dispose = function () {
        this.listen(false);
        this._rules = [];
        delete this._otherwiseFn;
    };
    /** @inheritdoc */
    UrlRouter.prototype.sort = function (compareFn) {
        this._rules.sort(this._sortFn = compareFn || this._sortFn);
    };
    /**
     * Given a URL, check all rules and return the best [[MatchResult]]
     * @param url
     * @returns {MatchResult}
     */
    UrlRouter.prototype.match = function (url) {
        var _this = this;
        url = common_1.extend({ path: '', search: {}, hash: '' }, url);
        var rules = this.rules();
        if (this._otherwiseFn)
            rules.push(this._otherwiseFn);
        // Checks a single rule. Returns { rule: rule, match: match, weight: weight } if it matched, or undefined
        var checkRule = function (rule) {
            var match = rule.match(url, _this._router);
            return match && { match: match, rule: rule, weight: rule.matchPriority(match) };
        };
        // The rules are pre-sorted.
        // - Find the first matching rule.
        // - Find any other matching rule that sorted *exactly the same*, according to `.sort()`.
        // - Choose the rule with the highest match weight.
        var best;
        for (var i = 0; i < rules.length; i++) {
            // Stop when there is a 'best' rule and the next rule sorts differently than it.
            if (best && this._sortFn(rules[i], best.rule) !== 0)
                break;
            var current = checkRule(rules[i]);
            // Pick the best MatchResult
            best = (!best || current && current.weight > best.weight) ? current : best;
        }
        return best;
    };
    /** @inheritdoc */
    UrlRouter.prototype.sync = function (evt) {
        if (evt && evt.defaultPrevented)
            return;
        var router = this._router, $url = router.urlService, $state = router.stateService;
        var url = {
            path: $url.path(), search: $url.search(), hash: $url.hash()
        };
        var best = this.match(url);
        var applyResult = hof_1.pattern([
            [predicates_1.isString, function (newurl) { return $url.url(newurl); }],
            [targetState_1.TargetState.isDef, function (def) { return $state.go(def.state, def.params, def.options); }],
            [hof_1.is(targetState_1.TargetState), function (target) { return $state.go(target.state(), target.params(), target.options()); }],
        ]);
        applyResult(best && best.rule.handler(best.match, url, router));
    };
    /** @inheritdoc */
    UrlRouter.prototype.listen = function (enabled) {
        var _this = this;
        if (enabled === false) {
            this._stopFn && this._stopFn();
            delete this._stopFn;
        }
        else {
            return this._stopFn = this._stopFn || this._router.urlService.onChange(function (evt) { return _this.sync(evt); });
        }
    };
    /**
     * Internal API.
     * @internalapi
     */
    UrlRouter.prototype.update = function (read) {
        var $url = this._router.locationService;
        if (read) {
            this.location = $url.path();
            return;
        }
        if ($url.path() === this.location)
            return;
        $url.url(this.location, true);
    };
    /**
     * Internal API.
     *
     * Pushes a new location to the browser history.
     *
     * @internalapi
     * @param urlMatcher
     * @param params
     * @param options
     */
    UrlRouter.prototype.push = function (urlMatcher, params, options) {
        var replace = options && !!options.replace;
        this._router.urlService.url(urlMatcher.format(params || {}), replace);
    };
    /**
     * Builds and returns a URL with interpolated parameters
     *
     * #### Example:
     * ```js
     * matcher = $umf.compile("/about/:person");
     * params = { person: "bob" };
     * $bob = $urlRouter.href(matcher, params);
     * // $bob == "/about/bob";
     * ```
     *
     * @param urlMatcher The [[UrlMatcher]] object which is used as the template of the URL to generate.
     * @param params An object of parameter values to fill the matcher's required parameters.
     * @param options Options object. The options are:
     *
     * - **`absolute`** - {boolean=false},  If true will generate an absolute url, e.g. "http://www.example.com/fullurl".
     *
     * @returns Returns the fully compiled URL, or `null` if `params` fail validation against `urlMatcher`
     */
    UrlRouter.prototype.href = function (urlMatcher, params, options) {
        if (!urlMatcher.validates(params))
            return null;
        var url = urlMatcher.format(params);
        options = options || { absolute: false };
        var cfg = this._router.urlService.config;
        var isHtml5 = cfg.html5Mode();
        if (!isHtml5 && url !== null) {
            url = "#" + cfg.hashPrefix() + url;
        }
        url = appendBasePath(url, isHtml5, options.absolute, cfg.baseHref());
        if (!options.absolute || !url) {
            return url;
        }
        var slash = (!isHtml5 && url ? '/' : ''), port = cfg.port();
        port = (port === 80 || port === 443 ? '' : ':' + port);
        return [cfg.protocol(), '://', cfg.host(), port, slash, url].join('');
    };
    /**
     * Manually adds a URL Rule.
     *
     * Usually, a url rule is added using [[StateDeclaration.url]] or [[when]].
     * This api can be used directly for more control (to register [[RawUrlRule]], for example).
     * Rules can be created using [[UrlRouter.ruleFactory]], or create manually as simple objects.
     *
     * @return a function that deregisters the rule
     */
    UrlRouter.prototype.rule = function (rule) {
        var _this = this;
        if (!urlRule_1.UrlRuleFactory.isUrlRule(rule))
            throw new Error("invalid rule");
        rule.$id = this._id++;
        rule.priority = rule.priority || 0;
        this._rules.push(rule);
        this.sort();
        return function () { return _this.removeRule(rule); };
    };
    /** @inheritdoc */
    UrlRouter.prototype.removeRule = function (rule) {
        common_1.removeFrom(this._rules, rule);
        this.sort();
    };
    /** @inheritdoc */
    UrlRouter.prototype.rules = function () { return this._rules.slice(); };
    /** @inheritdoc */
    UrlRouter.prototype.otherwise = function (handler) {
        if (!predicates_1.isFunction(handler) && !predicates_1.isString(handler) && !hof_1.is(targetState_1.TargetState)(handler) && !targetState_1.TargetState.isDef(handler)) {
            throw new Error("'redirectTo' must be a string, function, TargetState, or have a state: 'newtarget' property");
        }
        var handlerFn = predicates_1.isFunction(handler) ? handler : hof_1.val(handler);
        this._otherwiseFn = this.urlRuleFactory.create(hof_1.val(true), handlerFn);
        this.sort();
    };
    ;
    /** @inheritdoc */
    UrlRouter.prototype.when = function (matcher, handler, options) {
        var rule = this.urlRuleFactory.create(matcher, handler);
        if (predicates_1.isDefined(options && options.priority))
            rule.priority = options.priority;
        this.rule(rule);
        return rule;
    };
    ;
    /** @inheritdoc */
    UrlRouter.prototype.deferIntercept = function (defer) {
        if (defer === undefined)
            defer = true;
        this.interceptDeferred = defer;
    };
    ;
    return UrlRouter;
}());
exports.UrlRouter = UrlRouter;
//# sourceMappingURL=urlRouter.js.map

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @coreapi
 * @module url
 */ /** */
var urlMatcher_1 = __webpack_require__(108);
var predicates_1 = __webpack_require__(13);
var common_1 = __webpack_require__(8);
var hof_1 = __webpack_require__(14);
var stateObject_1 = __webpack_require__(149);
/**
 * Creates a [[UrlRule]]
 *
 * Creates a [[UrlRule]] from a:
 *
 * - `string`
 * - [[UrlMatcher]]
 * - `RegExp`
 * - [[State]]
 * @internalapi
 */
var UrlRuleFactory = (function () {
    function UrlRuleFactory(router) {
        this.router = router;
    }
    UrlRuleFactory.prototype.compile = function (str) {
        return this.router.urlMatcherFactory.compile(str);
    };
    UrlRuleFactory.prototype.create = function (what, handler) {
        var _this = this;
        var makeRule = hof_1.pattern([
            [predicates_1.isString, function (_what) { return makeRule(_this.compile(_what)); }],
            [hof_1.is(urlMatcher_1.UrlMatcher), function (_what) { return _this.fromUrlMatcher(_what, handler); }],
            [hof_1.is(stateObject_1.State), function (_what) { return _this.fromState(_what, _this.router); }],
            [hof_1.is(RegExp), function (_what) { return _this.fromRegExp(_what, handler); }],
            [predicates_1.isFunction, function (_what) { return new BaseUrlRule(_what, handler); }],
        ]);
        var rule = makeRule(what);
        if (!rule)
            throw new Error("invalid 'what' in when()");
        return rule;
    };
    /**
     * A UrlRule which matches based on a UrlMatcher
     *
     * The `handler` may be either a `string`, a [[UrlRuleHandlerFn]] or another [[UrlMatcher]]
     *
     * ## Handler as a function
     *
     * If `handler` is a function, the function is invoked with:
     *
     * - matched parameter values ([[RawParams]] from [[UrlMatcher.exec]])
     * - url: the current Url ([[UrlParts]])
     * - router: the router object ([[UIRouter]])
     *
     * #### Example:
     * ```js
     * var urlMatcher = $umf.compile("/foo/:fooId/:barId");
     * var rule = factory.fromUrlMatcher(urlMatcher, match => "/home/" + match.fooId + "/" + match.barId);
     * var match = rule.match('/foo/123/456'); // results in { fooId: '123', barId: '456' }
     * var result = rule.handler(match); // '/home/123/456'
     * ```
     *
     * ## Handler as UrlMatcher
     *
     * If `handler` is a UrlMatcher, the handler matcher is used to create the new url.
     * The `handler` UrlMatcher is formatted using the matched param from the first matcher.
     * The url is replaced with the result.
     *
     * #### Example:
     * ```js
     * var urlMatcher = $umf.compile("/foo/:fooId/:barId");
     * var handler = $umf.compile("/home/:fooId/:barId");
     * var rule = factory.fromUrlMatcher(urlMatcher, handler);
     * var match = rule.match('/foo/123/456'); // results in { fooId: '123', barId: '456' }
     * var result = rule.handler(match); // '/home/123/456'
     * ```
     */
    UrlRuleFactory.prototype.fromUrlMatcher = function (urlMatcher, handler) {
        var _handler = handler;
        if (predicates_1.isString(handler))
            handler = this.router.urlMatcherFactory.compile(handler);
        if (hof_1.is(urlMatcher_1.UrlMatcher)(handler))
            _handler = function (match) { return handler.format(match); };
        function match(url) {
            var match = urlMatcher.exec(url.path, url.search, url.hash);
            return urlMatcher.validates(match) && match;
        }
        // Prioritize URLs, lowest to highest:
        // - Some optional URL parameters, but none matched
        // - No optional parameters in URL
        // - Some optional parameters, some matched
        // - Some optional parameters, all matched
        function matchPriority(params) {
            var optional = urlMatcher.parameters().filter(function (param) { return param.isOptional; });
            if (!optional.length)
                return 0.000001;
            var matched = optional.filter(function (param) { return params[param.id]; });
            return matched.length / optional.length;
        }
        var details = { urlMatcher: urlMatcher, matchPriority: matchPriority, type: "URLMATCHER" };
        return common_1.extend(new BaseUrlRule(match, _handler), details);
    };
    /**
     * A UrlRule which matches a state by its url
     *
     * #### Example:
     * ```js
     * var rule = factory.fromState($state.get('foo'), router);
     * var match = rule.match('/foo/123/456'); // results in { fooId: '123', barId: '456' }
     * var result = rule.handler(match);
     * // Starts a transition to 'foo' with params: { fooId: '123', barId: '456' }
     * ```
     */
    UrlRuleFactory.prototype.fromState = function (state, router) {
        /**
         * Handles match by transitioning to matched state
         *
         * First checks if the router should start a new transition.
         * A new transition is not required if the current state's URL
         * and the new URL are already identical
         */
        var handler = function (match) {
            var $state = router.stateService;
            var globals = router.globals;
            if ($state.href(state, match) !== $state.href(globals.current, globals.params)) {
                $state.transitionTo(state, match, { inherit: true, source: "url" });
            }
        };
        var details = { state: state, type: "STATE" };
        return common_1.extend(this.fromUrlMatcher(state.url, handler), details);
    };
    /**
     * A UrlRule which matches based on a regular expression
     *
     * The `handler` may be either a [[UrlRuleHandlerFn]] or a string.
     *
     * ## Handler as a function
     *
     * If `handler` is a function, the function is invoked with:
     *
     * - regexp match array (from `regexp`)
     * - url: the current Url ([[UrlParts]])
     * - router: the router object ([[UIRouter]])
     *
     * #### Example:
     * ```js
     * var rule = factory.fromRegExp(/^\/foo\/(bar|baz)$/, match => "/home/" + match[1])
     * var match = rule.match('/foo/bar'); // results in [ '/foo/bar', 'bar' ]
     * var result = rule.handler(match); // '/home/bar'
     * ```
     *
     * ## Handler as string
     *
     * If `handler` is a string, the url is *replaced by the string* when the Rule is invoked.
     * The string is first interpolated using `string.replace()` style pattern.
     *
     * #### Example:
     * ```js
     * var rule = factory.fromRegExp(/^\/foo\/(bar|baz)$/, "/home/$1")
     * var match = rule.match('/foo/bar'); // results in [ '/foo/bar', 'bar' ]
     * var result = rule.handler(match); // '/home/bar'
     * ```
     */
    UrlRuleFactory.prototype.fromRegExp = function (regexp, handler) {
        if (regexp.global || regexp.sticky)
            throw new Error("Rule RegExp must not be global or sticky");
        /**
         * If handler is a string, the url will be replaced by the string.
         * If the string has any String.replace() style variables in it (like `$2`),
         * they will be replaced by the captures from [[match]]
         */
        var redirectUrlTo = function (match) {
            // Interpolates matched values into $1 $2, etc using a String.replace()-style pattern
            return handler.replace(/\$(\$|\d{1,2})/, function (m, what) {
                return match[what === '$' ? 0 : Number(what)];
            });
        };
        var _handler = predicates_1.isString(handler) ? redirectUrlTo : handler;
        var match = function (url) {
            return regexp.exec(url.path);
        };
        var details = { regexp: regexp, type: "REGEXP" };
        return common_1.extend(new BaseUrlRule(match, _handler), details);
    };
    return UrlRuleFactory;
}());
UrlRuleFactory.isUrlRule = function (obj) {
    return obj && ['type', 'match', 'handler'].every(function (key) { return predicates_1.isDefined(obj[key]); });
};
exports.UrlRuleFactory = UrlRuleFactory;
/**
 * A base rule which calls `match`
 *
 * The value from the `match` function is passed through to the `handler`.
 * @internalapi
 */
var BaseUrlRule = (function () {
    function BaseUrlRule(match, handler) {
        var _this = this;
        this.match = match;
        this.type = "RAW";
        this.matchPriority = function (match) { return 0 - _this.$id; };
        this.handler = handler || common_1.identity;
    }
    return BaseUrlRule;
}());
exports.BaseUrlRule = BaseUrlRule;
//# sourceMappingURL=urlRule.js.map

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var coreservices_1 = __webpack_require__(20);
/**
 * A [[TransitionHookFn]] that performs lazy loading
 *
 * When entering a state "abc" which has a `lazyLoad` function defined:
 * - Invoke the `lazyLoad` function (unless it is already in process)
 *   - Flag the hook function as "in process"
 *   - The function should return a promise (that resolves when lazy loading is complete)
 * - Wait for the promise to settle
 *   - If the promise resolves to a [[LazyLoadResult]], then register those states
 *   - Flag the hook function as "not in process"
 * - If the hook was successful
 *   - Remove the `lazyLoad` function from the state declaration
 * - If all the hooks were successful
 *   - Retry the transition (by returning a TargetState)
 *
 * ```
 * .state('abc', {
 *   component: 'fooComponent',
 *   lazyLoad: () => System.import('./fooComponent')
 *   });
 * ```
 *
 * See [[StateDeclaration.lazyLoad]]
 */
var lazyLoadHook = function (transition) {
    var router = transition.router;
    function retryTransition() {
        if (transition.originalTransition().options().source !== 'url') {
            // The original transition was not triggered via url sync
            // The lazy state should be loaded now, so re-try the original transition
            var orig = transition.targetState();
            return router.stateService.target(orig.identifier(), orig.params(), orig.options());
        }
        // The original transition was triggered via url sync
        // Run the URL rules and find the best match
        var $url = router.urlService;
        var result = $url.match($url.parts());
        var rule = result && result.rule;
        // If the best match is a state, redirect the transition (instead
        // of calling sync() which supersedes the current transition)
        if (rule && rule.type === "STATE") {
            var state = rule.state;
            var params = result.match;
            return router.stateService.target(state, params, transition.options());
        }
        // No matching state found, so let .sync() choose the best non-state match/otherwise
        router.urlRouter.sync();
    }
    var promises = transition.entering()
        .filter(function (state) { return !!state.lazyLoad; })
        .map(function (state) { return lazyLoadState(transition, state); });
    return coreservices_1.services.$q.all(promises).then(retryTransition);
};
exports.registerLazyLoadHook = function (transitionService) {
    return transitionService.onBefore({ entering: function (state) { return !!state.lazyLoad; } }, lazyLoadHook);
};
/**
 * Invokes a state's lazy load function
 *
 * @param transition a Transition context
 * @param state the state to lazy load
 * @returns A promise for the lazy load result
 */
function lazyLoadState(transition, state) {
    var lazyLoadFn = state.lazyLoad;
    // Store/get the lazy load promise on/from the hookfn so it doesn't get re-invoked
    var promise = lazyLoadFn['_promise'];
    if (!promise) {
        var success = function (result) {
            delete state.lazyLoad;
            delete state.$$state().lazyLoad;
            delete lazyLoadFn['_promise'];
            return result;
        };
        var error = function (err) {
            delete lazyLoadFn['_promise'];
            return coreservices_1.services.$q.reject(err);
        };
        promise = lazyLoadFn['_promise'] =
            coreservices_1.services.$q.when(lazyLoadFn(transition, state))
                .then(updateStateRegistry)
                .then(success, error);
    }
    /** Register any lazy loaded state definitions */
    function updateStateRegistry(result) {
        if (result && Array.isArray(result.states)) {
            result.states.forEach(function (state) { return transition.router.stateRegistry.register(state); });
        }
        return result;
    }
    return promise;
}
exports.lazyLoadState = lazyLoadState;
//# sourceMappingURL=lazyLoad.js.map

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var transitionHook_1 = __webpack_require__(80);
/**
 * This class defines a type of hook, such as `onBefore` or `onEnter`.
 * Plugins can define custom hook types, such as sticky states does for `onInactive`.
 *
 * @interalapi
 */
var TransitionEventType = (function () {
    function TransitionEventType(name, hookPhase, hookOrder, criteriaMatchPath, reverseSort, getResultHandler, getErrorHandler, rejectIfSuperseded) {
        if (reverseSort === void 0) { reverseSort = false; }
        if (getResultHandler === void 0) { getResultHandler = transitionHook_1.TransitionHook.HANDLE_RESULT; }
        if (getErrorHandler === void 0) { getErrorHandler = transitionHook_1.TransitionHook.REJECT_ERROR; }
        if (rejectIfSuperseded === void 0) { rejectIfSuperseded = true; }
        this.name = name;
        this.hookPhase = hookPhase;
        this.hookOrder = hookOrder;
        this.criteriaMatchPath = criteriaMatchPath;
        this.reverseSort = reverseSort;
        this.getResultHandler = getResultHandler;
        this.getErrorHandler = getErrorHandler;
        this.rejectIfSuperseded = rejectIfSuperseded;
    }
    return TransitionEventType;
}());
exports.TransitionEventType = TransitionEventType;
//# sourceMappingURL=transitionEventType.js.map

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @coreapi
 * @module view
 */ /** for typedoc */
var common_1 = __webpack_require__(8);
var hof_1 = __webpack_require__(14);
var predicates_1 = __webpack_require__(13);
var trace_1 = __webpack_require__(69);
/**
 * The View service
 *
 * This service pairs existing `ui-view` components (which live in the DOM)
 * with view configs (from the state declaration objects: [[StateDeclaration.views]]).
 *
 * - After a successful Transition, the views from the newly entered states are activated via [[activateViewConfig]].
 *   The views from exited states are deactivated via [[deactivateViewConfig]].
 *   (See: the [[registerActivateViews]] Transition Hook)
 *
 * - As `ui-view` components pop in and out of existence, they register themselves using [[registerUIView]].
 *
 * - When the [[sync]] function is called, the registered `ui-view`(s) ([[UIViewConfig]]
 * are configured with the matching `ViewConfig`(s)  ([[ActiveUIView]]).
 *
 */
var ViewService = (function () {
    function ViewService() {
        var _this = this;
        this._uiViews = [];
        this._viewConfigs = [];
        this._viewConfigFactories = {};
        this._pluginapi = {
            _rootViewContext: this._rootViewContext.bind(this),
            _viewConfigFactory: this._viewConfigFactory.bind(this),
            _registeredUIViews: function () { return _this._uiViews; },
            _activeViewConfigs: function () { return _this._viewConfigs; },
        };
    }
    ViewService.prototype._rootViewContext = function (context) {
        return this._rootContext = context || this._rootContext;
    };
    ;
    ViewService.prototype._viewConfigFactory = function (viewType, factory) {
        this._viewConfigFactories[viewType] = factory;
    };
    ViewService.prototype.createViewConfig = function (path, decl) {
        var cfgFactory = this._viewConfigFactories[decl.$type];
        if (!cfgFactory)
            throw new Error("ViewService: No view config factory registered for type " + decl.$type);
        var cfgs = cfgFactory(path, decl);
        return predicates_1.isArray(cfgs) ? cfgs : [cfgs];
    };
    /**
     * Deactivates a ViewConfig.
     *
     * This function deactivates a `ViewConfig`.
     * After calling [[sync]], it will un-pair from any `ui-view` with which it is currently paired.
     *
     * @param viewConfig The ViewConfig view to deregister.
     */
    ViewService.prototype.deactivateViewConfig = function (viewConfig) {
        trace_1.trace.traceViewServiceEvent("<- Removing", viewConfig);
        common_1.removeFrom(this._viewConfigs, viewConfig);
    };
    ViewService.prototype.activateViewConfig = function (viewConfig) {
        trace_1.trace.traceViewServiceEvent("-> Registering", viewConfig);
        this._viewConfigs.push(viewConfig);
    };
    ViewService.prototype.sync = function () {
        var _this = this;
        var uiViewsByFqn = this._uiViews.map(function (uiv) { return [uiv.fqn, uiv]; }).reduce(common_1.applyPairs, {});
        /**
         * Given a ui-view and a ViewConfig, determines if they "match".
         *
         * A ui-view has a fully qualified name (fqn) and a context object.  The fqn is built from its overall location in
         * the DOM, describing its nesting relationship to any parent ui-view tags it is nested inside of.
         *
         * A ViewConfig has a target ui-view name and a context anchor.  The ui-view name can be a simple name, or
         * can be a segmented ui-view path, describing a portion of a ui-view fqn.
         *
         * In order for a ui-view to match ViewConfig, ui-view's $type must match the ViewConfig's $type
         *
         * If the ViewConfig's target ui-view name is a simple name (no dots), then a ui-view matches if:
         * - the ui-view's name matches the ViewConfig's target name
         * - the ui-view's context matches the ViewConfig's anchor
         *
         * If the ViewConfig's target ui-view name is a segmented name (with dots), then a ui-view matches if:
         * - There exists a parent ui-view where:
         *    - the parent ui-view's name matches the first segment (index 0) of the ViewConfig's target name
         *    - the parent ui-view's context matches the ViewConfig's anchor
         * - And the remaining segments (index 1..n) of the ViewConfig's target name match the tail of the ui-view's fqn
         *
         * Example:
         *
         * DOM:
         * <div ui-view>                        <!-- created in the root context (name: "") -->
         *   <div ui-view="foo">                <!-- created in the context named: "A"      -->
         *     <div ui-view>                    <!-- created in the context named: "A.B"    -->
         *       <div ui-view="bar">            <!-- created in the context named: "A.B.C"  -->
         *       </div>
         *     </div>
         *   </div>
         * </div>
         *
         * uiViews: [
         *  { fqn: "$default",                  creationContext: { name: "" } },
         *  { fqn: "$default.foo",              creationContext: { name: "A" } },
         *  { fqn: "$default.foo.$default",     creationContext: { name: "A.B" } }
         *  { fqn: "$default.foo.$default.bar", creationContext: { name: "A.B.C" } }
         * ]
         *
         * These four view configs all match the ui-view with the fqn: "$default.foo.$default.bar":
         *
         * - ViewConfig1: { uiViewName: "bar",                       uiViewContextAnchor: "A.B.C" }
         * - ViewConfig2: { uiViewName: "$default.bar",              uiViewContextAnchor: "A.B" }
         * - ViewConfig3: { uiViewName: "foo.$default.bar",          uiViewContextAnchor: "A" }
         * - ViewConfig4: { uiViewName: "$default.foo.$default.bar", uiViewContextAnchor: "" }
         *
         * Using ViewConfig3 as an example, it matches the ui-view with fqn "$default.foo.$default.bar" because:
         * - The ViewConfig's segmented target name is: [ "foo", "$default", "bar" ]
         * - There exists a parent ui-view (which has fqn: "$default.foo") where:
         *    - the parent ui-view's name "foo" matches the first segment "foo" of the ViewConfig's target name
         *    - the parent ui-view's context "A" matches the ViewConfig's anchor context "A"
         * - And the remaining segments [ "$default", "bar" ].join("."_ of the ViewConfig's target name match
         *   the tail of the ui-view's fqn "default.bar"
         */
        var matches = function (uiView) { return function (viewConfig) {
            // Don't supply an ng1 ui-view with an ng2 ViewConfig, etc
            if (uiView.$type !== viewConfig.viewDecl.$type)
                return false;
            // Split names apart from both viewConfig and uiView into segments
            var vc = viewConfig.viewDecl;
            var vcSegments = vc.$uiViewName.split(".");
            var uivSegments = uiView.fqn.split(".");
            // Check if the tails of the segment arrays match. ex, these arrays' tails match:
            // vc: ["foo", "bar"], uiv fqn: ["$default", "foo", "bar"]
            if (!common_1.equals(vcSegments, uivSegments.slice(0 - vcSegments.length)))
                return false;
            // Now check if the fqn ending at the first segment of the viewConfig matches the context:
            // ["$default", "foo"].join(".") == "$default.foo", does the ui-view $default.foo context match?
            var negOffset = (1 - vcSegments.length) || undefined;
            var fqnToFirstSegment = uivSegments.slice(0, negOffset).join(".");
            var uiViewContext = uiViewsByFqn[fqnToFirstSegment].creationContext;
            return vc.$uiViewContextAnchor === (uiViewContext && uiViewContext.name);
        }; };
        // Return the number of dots in the fully qualified name
        function uiViewDepth(uiView) {
            return uiView.fqn.split(".").length;
        }
        // Return the ViewConfig's context's depth in the context tree.
        function viewConfigDepth(config) {
            var context = config.viewDecl.$context, count = 0;
            while (++count && context.parent)
                context = context.parent;
            return count;
        }
        // Given a depth function, returns a compare function which can return either ascending or descending order
        var depthCompare = hof_1.curry(function (depthFn, posNeg, left, right) { return posNeg * (depthFn(left) - depthFn(right)); });
        var matchingConfigPair = function (uiView) {
            var matchingConfigs = _this._viewConfigs.filter(matches(uiView));
            if (matchingConfigs.length > 1) {
                // This is OK.  Child states can target a ui-view that the parent state also targets (the child wins)
                // Sort by depth and return the match from the deepest child
                // console.log(`Multiple matching view configs for ${uiView.fqn}`, matchingConfigs);
                matchingConfigs.sort(depthCompare(viewConfigDepth, -1)); // descending
            }
            return [uiView, matchingConfigs[0]];
        };
        var configureUIView = function (_a) {
            var uiView = _a[0], viewConfig = _a[1];
            // If a parent ui-view is reconfigured, it could destroy child ui-views.
            // Before configuring a child ui-view, make sure it's still in the active uiViews array.
            if (_this._uiViews.indexOf(uiView) !== -1)
                uiView.configUpdated(viewConfig);
        };
        this._uiViews.sort(depthCompare(uiViewDepth, 1)).map(matchingConfigPair).forEach(configureUIView);
    };
    ;
    /**
     * Registers a `ui-view` component
     *
     * When a `ui-view` component is created, it uses this method to register itself.
     * After registration the [[sync]] method is used to ensure all `ui-view` are configured with the proper [[ViewConfig]].
     *
     * Note: the `ui-view` component uses the `ViewConfig` to determine what view should be loaded inside the `ui-view`,
     * and what the view's state context is.
     *
     * Note: There is no corresponding `deregisterUIView`.
     *       A `ui-view` should hang on to the return value of `registerUIView` and invoke it to deregister itself.
     *
     * @param uiView The metadata for a UIView
     * @return a de-registration function used when the view is destroyed.
     */
    ViewService.prototype.registerUIView = function (uiView) {
        trace_1.trace.traceViewServiceUIViewEvent("-> Registering", uiView);
        var uiViews = this._uiViews;
        var fqnMatches = function (uiv) { return uiv.fqn === uiView.fqn; };
        if (uiViews.filter(fqnMatches).length)
            trace_1.trace.traceViewServiceUIViewEvent("!!!! duplicate uiView named:", uiView);
        uiViews.push(uiView);
        this.sync();
        return function () {
            var idx = uiViews.indexOf(uiView);
            if (idx === -1) {
                trace_1.trace.traceViewServiceUIViewEvent("Tried removing non-registered uiView", uiView);
                return;
            }
            trace_1.trace.traceViewServiceUIViewEvent("<- Deregistering", uiView);
            common_1.removeFrom(uiViews)(uiView);
        };
    };
    ;
    /**
     * Returns the list of views currently available on the page, by fully-qualified name.
     *
     * @return {Array} Returns an array of fully-qualified view names.
     */
    ViewService.prototype.available = function () {
        return this._uiViews.map(hof_1.prop("fqn"));
    };
    /**
     * Returns the list of views on the page containing loaded content.
     *
     * @return {Array} Returns an array of fully-qualified view names.
     */
    ViewService.prototype.active = function () {
        return this._uiViews.filter(hof_1.prop("$config")).map(hof_1.prop("name"));
    };
    /**
     * Normalizes a view's name from a state.views configuration block.
     *
     * @param context the context object (state declaration) that the view belongs to
     * @param rawViewName the name of the view, as declared in the [[StateDeclaration.views]]
     *
     * @returns the normalized uiViewName and uiViewContextAnchor that the view targets
     */
    ViewService.normalizeUIViewTarget = function (context, rawViewName) {
        if (rawViewName === void 0) { rawViewName = ""; }
        // TODO: Validate incoming view name with a regexp to allow:
        // ex: "view.name@foo.bar" , "^.^.view.name" , "view.name@^.^" , "" ,
        // "@" , "$default@^" , "!$default.$default" , "!foo.bar"
        var viewAtContext = rawViewName.split("@");
        var uiViewName = viewAtContext[0] || "$default"; // default to unnamed view
        var uiViewContextAnchor = predicates_1.isString(viewAtContext[1]) ? viewAtContext[1] : "^"; // default to parent context
        // Handle relative view-name sugar syntax.
        // Matches rawViewName "^.^.^.foo.bar" into array: ["^.^.^.foo.bar", "^.^.^", "foo.bar"],
        var relativeViewNameSugar = /^(\^(?:\.\^)*)\.(.*$)/.exec(uiViewName);
        if (relativeViewNameSugar) {
            // Clobbers existing contextAnchor (rawViewName validation will fix this)
            uiViewContextAnchor = relativeViewNameSugar[1]; // set anchor to "^.^.^"
            uiViewName = relativeViewNameSugar[2]; // set view-name to "foo.bar"
        }
        if (uiViewName.charAt(0) === '!') {
            uiViewName = uiViewName.substr(1);
            uiViewContextAnchor = ""; // target absolutely from root
        }
        // handle parent relative targeting "^.^.^"
        var relativeMatch = /^(\^(?:\.\^)*)$/;
        if (relativeMatch.exec(uiViewContextAnchor)) {
            var anchor = uiViewContextAnchor.split(".").reduce((function (anchor, x) { return anchor.parent; }), context);
            uiViewContextAnchor = anchor.name;
        }
        return { uiViewName: uiViewName, uiViewContextAnchor: uiViewContextAnchor };
    };
    return ViewService;
}());
exports.ViewService = ViewService;
//# sourceMappingURL=view.js.map

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @coreapi
 * @module state
 */ /** for typedoc */

var stateMatcher_1 = __webpack_require__(229);
var stateBuilder_1 = __webpack_require__(230);
var stateQueueManager_1 = __webpack_require__(231);
var common_1 = __webpack_require__(8);
var hof_1 = __webpack_require__(14);
var StateRegistry = (function () {
    /** @internalapi */
    function StateRegistry(_router) {
        this._router = _router;
        this.states = {};
        this.listeners = [];
        this.matcher = new stateMatcher_1.StateMatcher(this.states);
        this.builder = new stateBuilder_1.StateBuilder(this.matcher, _router.urlMatcherFactory);
        this.stateQueue = new stateQueueManager_1.StateQueueManager(this, _router.urlRouter, this.states, this.builder, this.listeners);
        this._registerRoot();
    }
    /** @internalapi */
    StateRegistry.prototype._registerRoot = function () {
        var rootStateDef = {
            name: '',
            url: '^',
            views: null,
            params: {
                '#': { value: null, type: 'hash', dynamic: true }
            },
            abstract: true
        };
        var _root = this._root = this.stateQueue.register(rootStateDef);
        _root.navigable = null;
    };
    /** @internalapi */
    StateRegistry.prototype.dispose = function () {
        var _this = this;
        this.stateQueue.dispose();
        this.listeners = [];
        this.get().forEach(function (state) { return _this.get(state) && _this.deregister(state); });
    };
    /**
     * Listen for a State Registry events
     *
     * Adds a callback that is invoked when states are registered or deregistered with the StateRegistry.
     *
     * #### Example:
     * ```js
     * let allStates = registry.get();
     *
     * // Later, invoke deregisterFn() to remove the listener
     * let deregisterFn = registry.onStatesChanged((event, states) => {
     *   switch(event) {
     *     case: 'registered':
     *       states.forEach(state => allStates.push(state));
     *       break;
     *     case: 'deregistered':
     *       states.forEach(state => {
     *         let idx = allStates.indexOf(state);
     *         if (idx !== -1) allStates.splice(idx, 1);
     *       });
     *       break;
     *   }
     * });
     * ```
     *
     * @param listener a callback function invoked when the registered states changes.
     *        The function receives two parameters, `event` and `state`.
     *        See [[StateRegistryListener]]
     * @return a function that deregisters the listener
     */
    StateRegistry.prototype.onStatesChanged = function (listener) {
        this.listeners.push(listener);
        return function deregisterListener() {
            common_1.removeFrom(this.listeners)(listener);
        }.bind(this);
    };
    /**
     * Gets the implicit root state
     *
     * Gets the root of the state tree.
     * The root state is implicitly created by UI-Router.
     * Note: this returns the internal [[State]] representation, not a [[StateDeclaration]]
     *
     * @return the root [[State]]
     */
    StateRegistry.prototype.root = function () {
        return this._root;
    };
    /**
     * Adds a state to the registry
     *
     * Registers a [[StateDeclaration]] or queues it for registration.
     *
     * Note: a state will be queued if the state's parent isn't yet registered.
     * It will also be queued if the queue is not yet in [[StateQueueManager.autoFlush]] mode.
     *
     * @param stateDefinition the definition of the state to register.
     * @returns the internal [[State]] object.
     *          If the state was successfully registered, then the object is fully built (See: [[StateBuilder]]).
     *          If the state was only queued, then the object is not fully built.
     */
    StateRegistry.prototype.register = function (stateDefinition) {
        return this.stateQueue.register(stateDefinition);
    };
    /** @hidden */
    StateRegistry.prototype._deregisterTree = function (state) {
        var _this = this;
        var all = this.get().map(function (s) { return s.$$state(); });
        var getChildren = function (states) {
            var children = all.filter(function (s) { return states.indexOf(s.parent) !== -1; });
            return children.length === 0 ? children : children.concat(getChildren(children));
        };
        var children = getChildren([state]);
        var deregistered = [state].concat(children).reverse();
        deregistered.forEach(function (state) {
            var $ur = _this._router.urlRouter;
            // Remove URL rule
            $ur.rules().filter(hof_1.propEq("state", state)).forEach($ur.removeRule.bind($ur));
            // Remove state from registry
            delete _this.states[state.name];
        });
        return deregistered;
    };
    /**
     * Removes a state from the registry
     *
     * This removes a state from the registry.
     * If the state has children, they are are also removed from the registry.
     *
     * @param stateOrName the state's name or object representation
     * @returns {State[]} a list of removed states
     */
    StateRegistry.prototype.deregister = function (stateOrName) {
        var _state = this.get(stateOrName);
        if (!_state)
            throw new Error("Can't deregister state; not found: " + stateOrName);
        var deregisteredStates = this._deregisterTree(_state.$$state());
        this.listeners.forEach(function (listener) { return listener("deregistered", deregisteredStates.map(function (s) { return s.self; })); });
        return deregisteredStates;
    };
    StateRegistry.prototype.get = function (stateOrName, base) {
        var _this = this;
        if (arguments.length === 0)
            return Object.keys(this.states).map(function (name) { return _this.states[name].self; });
        var found = this.matcher.find(stateOrName, base);
        return found && found.self || null;
    };
    StateRegistry.prototype.decorator = function (name, func) {
        return this.builder.builder(name, func);
    };
    return StateRegistry;
}());
exports.StateRegistry = StateRegistry;
//# sourceMappingURL=stateRegistry.js.map

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/** @module state */ /** for typedoc */
var predicates_1 = __webpack_require__(13);
var glob_1 = __webpack_require__(104);
var common_1 = __webpack_require__(8);
var StateMatcher = (function () {
    function StateMatcher(_states) {
        this._states = _states;
    }
    StateMatcher.prototype.isRelative = function (stateName) {
        stateName = stateName || "";
        return stateName.indexOf(".") === 0 || stateName.indexOf("^") === 0;
    };
    StateMatcher.prototype.find = function (stateOrName, base) {
        if (!stateOrName && stateOrName !== "")
            return undefined;
        var isStr = predicates_1.isString(stateOrName);
        var name = isStr ? stateOrName : stateOrName.name;
        if (this.isRelative(name))
            name = this.resolvePath(name, base);
        var state = this._states[name];
        if (state && (isStr || (!isStr && (state === stateOrName || state.self === stateOrName)))) {
            return state;
        }
        else if (isStr) {
            var matches = common_1.values(this._states)
                .filter(function (state) { return new glob_1.Glob(state.name).matches(name); });
            if (matches.length > 1) {
                console.log("stateMatcher.find: Found multiple matches for " + name + " using glob: ", matches.map(function (match) { return match.name; }));
            }
            return matches[0];
        }
        return undefined;
    };
    StateMatcher.prototype.resolvePath = function (name, base) {
        if (!base)
            throw new Error("No reference point given for path '" + name + "'");
        var baseState = this.find(base);
        var splitName = name.split("."), i = 0, pathLength = splitName.length, current = baseState;
        for (; i < pathLength; i++) {
            if (splitName[i] === "" && i === 0) {
                current = baseState;
                continue;
            }
            if (splitName[i] === "^") {
                if (!current.parent)
                    throw new Error("Path '" + name + "' not valid for state '" + baseState.name + "'");
                current = current.parent;
                continue;
            }
            break;
        }
        var relName = splitName.slice(i).join(".");
        return current.name + (current.name && relName ? "." : "") + relName;
    };
    return StateMatcher;
}());
exports.StateMatcher = StateMatcher;
//# sourceMappingURL=stateMatcher.js.map

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/** @module state */ /** for typedoc */
var common_1 = __webpack_require__(8);
var predicates_1 = __webpack_require__(13);
var strings_1 = __webpack_require__(48);
var hof_1 = __webpack_require__(14);
var resolvable_1 = __webpack_require__(81);
var coreservices_1 = __webpack_require__(20);
var parseUrl = function (url) {
    if (!predicates_1.isString(url))
        return false;
    var root = url.charAt(0) === '^';
    return { val: root ? url.substring(1) : url, root: root };
};
function nameBuilder(state) {
    return state.name;
}
function selfBuilder(state) {
    state.self.$$state = function () { return state; };
    return state.self;
}
function dataBuilder(state) {
    if (state.parent && state.parent.data) {
        state.data = state.self.data = common_1.inherit(state.parent.data, state.data);
    }
    return state.data;
}
var getUrlBuilder = function ($urlMatcherFactoryProvider, root) {
    return function urlBuilder(state) {
        var stateDec = state;
        // For future states, i.e., states whose name ends with `.**`,
        // match anything that starts with the url prefix
        if (stateDec && stateDec.url && stateDec.name && stateDec.name.match(/\.\*\*$/)) {
            stateDec.url += "{remainder:any}"; // match any path (.*)
        }
        var parsed = parseUrl(stateDec.url), parent = state.parent;
        var url = !parsed ? stateDec.url : $urlMatcherFactoryProvider.compile(parsed.val, {
            params: state.params || {},
            paramMap: function (paramConfig, isSearch) {
                if (stateDec.reloadOnSearch === false && isSearch)
                    paramConfig = common_1.extend(paramConfig || {}, { dynamic: true });
                return paramConfig;
            }
        });
        if (!url)
            return null;
        if (!$urlMatcherFactoryProvider.isMatcher(url))
            throw new Error("Invalid url '" + url + "' in state '" + state + "'");
        return (parsed && parsed.root) ? url : ((parent && parent.navigable) || root()).url.append(url);
    };
};
var getNavigableBuilder = function (isRoot) {
    return function navigableBuilder(state) {
        return !isRoot(state) && state.url ? state : (state.parent ? state.parent.navigable : null);
    };
};
var getParamsBuilder = function (paramFactory) {
    return function paramsBuilder(state) {
        var makeConfigParam = function (config, id) { return paramFactory.fromConfig(id, null, config); };
        var urlParams = (state.url && state.url.parameters({ inherit: false })) || [];
        var nonUrlParams = common_1.values(common_1.mapObj(common_1.omit(state.params || {}, urlParams.map(hof_1.prop('id'))), makeConfigParam));
        return urlParams.concat(nonUrlParams).map(function (p) { return [p.id, p]; }).reduce(common_1.applyPairs, {});
    };
};
function pathBuilder(state) {
    return state.parent ? state.parent.path.concat(state) : [state];
}
function includesBuilder(state) {
    var includes = state.parent ? common_1.extend({}, state.parent.includes) : {};
    includes[state.name] = true;
    return includes;
}
/**
 * This is a [[StateBuilder.builder]] function for the `resolve:` block on a [[StateDeclaration]].
 *
 * When the [[StateBuilder]] builds a [[State]] object from a raw [[StateDeclaration]], this builder
 * validates the `resolve` property and converts it to a [[Resolvable]] array.
 *
 * resolve: input value can be:
 *
 * {
 *   // analyzed but not injected
 *   myFooResolve: function() { return "myFooData"; },
 *
 *   // function.toString() parsed, "DependencyName" dep as string (not min-safe)
 *   myBarResolve: function(DependencyName) { return DependencyName.fetchSomethingAsPromise() },
 *
 *   // Array split; "DependencyName" dep as string
 *   myBazResolve: [ "DependencyName", function(dep) { return dep.fetchSomethingAsPromise() },
 *
 *   // Array split; DependencyType dep as token (compared using ===)
 *   myQuxResolve: [ DependencyType, function(dep) { return dep.fetchSometingAsPromise() },
 *
 *   // val.$inject used as deps
 *   // where:
 *   //     corgeResolve.$inject = ["DependencyName"];
 *   //     function corgeResolve(dep) { dep.fetchSometingAsPromise() }
 *   // then "DependencyName" dep as string
 *   myCorgeResolve: corgeResolve,
 *
 *  // inject service by name
 *  // When a string is found, desugar creating a resolve that injects the named service
 *   myGraultResolve: "SomeService"
 * }
 *
 * or:
 *
 * [
 *   new Resolvable("myFooResolve", function() { return "myFooData" }),
 *   new Resolvable("myBarResolve", function(dep) { return dep.fetchSomethingAsPromise() }, [ "DependencyName" ]),
 *   { provide: "myBazResolve", useFactory: function(dep) { dep.fetchSomethingAsPromise() }, deps: [ "DependencyName" ] }
 * ]
 */
function resolvablesBuilder(state) {
    /** convert resolve: {} and resolvePolicy: {} objects to an array of tuples */
    var objects2Tuples = function (resolveObj, resolvePolicies) {
        return Object.keys(resolveObj || {}).map(function (token) { return ({ token: token, val: resolveObj[token], deps: undefined, policy: resolvePolicies[token] }); });
    };
    /** fetch DI annotations from a function or ng1-style array */
    var annotate = function (fn) {
        var $injector = coreservices_1.services.$injector;
        // ng1 doesn't have an $injector until runtime.
        // If the $injector doesn't exist, use "deferred" literal as a
        // marker indicating they should be annotated when runtime starts
        return fn['$inject'] || ($injector && $injector.annotate(fn, $injector.strictDi)) || "deferred";
    };
    /** true if the object has both `token` and `resolveFn`, and is probably a [[ResolveLiteral]] */
    var isResolveLiteral = function (obj) { return !!(obj.token && obj.resolveFn); };
    /** true if the object looks like a provide literal, or a ng2 Provider */
    var isLikeNg2Provider = function (obj) { return !!((obj.provide || obj.token) && (obj.useValue || obj.useFactory || obj.useExisting || obj.useClass)); };
    /** true if the object looks like a tuple from obj2Tuples */
    var isTupleFromObj = function (obj) { return !!(obj && obj.val && (predicates_1.isString(obj.val) || predicates_1.isArray(obj.val) || predicates_1.isFunction(obj.val))); };
    /** extracts the token from a Provider or provide literal */
    var token = function (p) { return p.provide || p.token; };
    /** Given a literal resolve or provider object, returns a Resolvable */
    var literal2Resolvable = hof_1.pattern([
        [hof_1.prop('resolveFn'), function (p) { return new resolvable_1.Resolvable(token(p), p.resolveFn, p.deps, p.policy); }],
        [hof_1.prop('useFactory'), function (p) { return new resolvable_1.Resolvable(token(p), p.useFactory, (p.deps || p.dependencies), p.policy); }],
        [hof_1.prop('useClass'), function (p) { return new resolvable_1.Resolvable(token(p), function () { return new p.useClass(); }, [], p.policy); }],
        [hof_1.prop('useValue'), function (p) { return new resolvable_1.Resolvable(token(p), function () { return p.useValue; }, [], p.policy, p.useValue); }],
        [hof_1.prop('useExisting'), function (p) { return new resolvable_1.Resolvable(token(p), common_1.identity, [p.useExisting], p.policy); }],
    ]);
    var tuple2Resolvable = hof_1.pattern([
        [hof_1.pipe(hof_1.prop("val"), predicates_1.isString), function (tuple) { return new resolvable_1.Resolvable(tuple.token, common_1.identity, [tuple.val], tuple.policy); }],
        [hof_1.pipe(hof_1.prop("val"), predicates_1.isArray), function (tuple) { return new resolvable_1.Resolvable(tuple.token, common_1.tail(tuple.val), tuple.val.slice(0, -1), tuple.policy); }],
        [hof_1.pipe(hof_1.prop("val"), predicates_1.isFunction), function (tuple) { return new resolvable_1.Resolvable(tuple.token, tuple.val, annotate(tuple.val), tuple.policy); }],
    ]);
    var item2Resolvable = hof_1.pattern([
        [hof_1.is(resolvable_1.Resolvable), function (r) { return r; }],
        [isResolveLiteral, literal2Resolvable],
        [isLikeNg2Provider, literal2Resolvable],
        [isTupleFromObj, tuple2Resolvable],
        [hof_1.val(true), function (obj) { throw new Error("Invalid resolve value: " + strings_1.stringify(obj)); }]
    ]);
    // If resolveBlock is already an array, use it as-is.
    // Otherwise, assume it's an object and convert to an Array of tuples
    var decl = state.resolve;
    var items = predicates_1.isArray(decl) ? decl : objects2Tuples(decl, state.resolvePolicy || {});
    return items.map(item2Resolvable);
}
exports.resolvablesBuilder = resolvablesBuilder;
/**
 * @internalapi A internal global service
 *
 * StateBuilder is a factory for the internal [[State]] objects.
 *
 * When you register a state with the [[StateRegistry]], you register a plain old javascript object which
 * conforms to the [[StateDeclaration]] interface.  This factory takes that object and builds the corresponding
 * [[State]] object, which has an API and is used internally.
 *
 * Custom properties or API may be added to the internal [[State]] object by registering a decorator function
 * using the [[builder]] method.
 */
var StateBuilder = (function () {
    function StateBuilder(matcher, urlMatcherFactory) {
        this.matcher = matcher;
        var self = this;
        var root = function () { return matcher.find(""); };
        var isRoot = function (state) { return state.name === ""; };
        function parentBuilder(state) {
            if (isRoot(state))
                return null;
            return matcher.find(self.parentName(state)) || root();
        }
        this.builders = {
            name: [nameBuilder],
            self: [selfBuilder],
            parent: [parentBuilder],
            data: [dataBuilder],
            // Build a URLMatcher if necessary, either via a relative or absolute URL
            url: [getUrlBuilder(urlMatcherFactory, root)],
            // Keep track of the closest ancestor state that has a URL (i.e. is navigable)
            navigable: [getNavigableBuilder(isRoot)],
            params: [getParamsBuilder(urlMatcherFactory.paramFactory)],
            // Each framework-specific ui-router implementation should define its own `views` builder
            // e.g., src/ng1/statebuilders/views.ts
            views: [],
            // Keep a full path from the root down to this state as this is needed for state activation.
            path: [pathBuilder],
            // Speed up $state.includes() as it's used a lot
            includes: [includesBuilder],
            resolvables: [resolvablesBuilder]
        };
    }
    /**
     * Registers a [[BuilderFunction]] for a specific [[State]] property (e.g., `parent`, `url`, or `path`).
     * More than one BuilderFunction can be registered for a given property.
     *
     * The BuilderFunction(s) will be used to define the property on any subsequently built [[State]] objects.
     *
     * @param name The name of the State property being registered for.
     * @param fn The BuilderFunction which will be used to build the State property
     * @returns a function which deregisters the BuilderFunction
     */
    StateBuilder.prototype.builder = function (name, fn) {
        var builders = this.builders;
        var array = builders[name] || [];
        // Backwards compat: if only one builder exists, return it, else return whole arary.
        if (predicates_1.isString(name) && !predicates_1.isDefined(fn))
            return array.length > 1 ? array : array[0];
        if (!predicates_1.isString(name) || !predicates_1.isFunction(fn))
            return;
        builders[name] = array;
        builders[name].push(fn);
        return function () { return builders[name].splice(builders[name].indexOf(fn, 1)) && null; };
    };
    /**
     * Builds all of the properties on an essentially blank State object, returning a State object which has all its
     * properties and API built.
     *
     * @param state an uninitialized State object
     * @returns the built State object
     */
    StateBuilder.prototype.build = function (state) {
        var _a = this, matcher = _a.matcher, builders = _a.builders;
        var parent = this.parentName(state);
        if (parent && !matcher.find(parent))
            return null;
        for (var key in builders) {
            if (!builders.hasOwnProperty(key))
                continue;
            var chain = builders[key].reduce(function (parentFn, step) { return function (_state) { return step(_state, parentFn); }; }, common_1.noop);
            state[key] = chain(state);
        }
        return state;
    };
    StateBuilder.prototype.parentName = function (state) {
        var name = state.name || "";
        var segments = name.split('.');
        if (segments.length > 1) {
            if (state.parent) {
                throw new Error("States that specify the 'parent:' property should not have a '.' in their name (" + name + ")");
            }
            var lastSegment = segments.pop();
            if (lastSegment === '**')
                segments.pop();
            return segments.join(".");
        }
        if (!state.parent)
            return "";
        return predicates_1.isString(state.parent) ? state.parent : state.parent.name;
    };
    StateBuilder.prototype.name = function (state) {
        var name = state.name;
        if (name.indexOf('.') !== -1 || !state.parent)
            return name;
        var parentName = predicates_1.isString(state.parent) ? state.parent : state.parent.name;
        return parentName ? parentName + "." + name : name;
    };
    return StateBuilder;
}());
exports.StateBuilder = StateBuilder;
//# sourceMappingURL=stateBuilder.js.map

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/** @module state */ /** for typedoc */
var common_1 = __webpack_require__(8);
var predicates_1 = __webpack_require__(13);
var stateObject_1 = __webpack_require__(149);
/** @internalapi */
var StateQueueManager = (function () {
    function StateQueueManager($registry, $urlRouter, states, builder, listeners) {
        this.$registry = $registry;
        this.$urlRouter = $urlRouter;
        this.states = states;
        this.builder = builder;
        this.listeners = listeners;
        this.queue = [];
    }
    /** @internalapi */
    StateQueueManager.prototype.dispose = function () {
        this.queue = [];
    };
    StateQueueManager.prototype.register = function (config) {
        var _a = this, states = _a.states, queue = _a.queue;
        // Wrap a new object around the state so we can store our private details easily.
        // @TODO: state = new State(extend({}, config, { ... }))
        var state = common_1.inherit(new stateObject_1.State(), common_1.extend({}, config, {
            self: config,
            resolve: config.resolve || [],
            toString: function () { return config.name; }
        }));
        if (!predicates_1.isString(state.name))
            throw new Error("State must have a valid name");
        if (states.hasOwnProperty(state.name) || common_1.pluck(queue, 'name').indexOf(state.name) !== -1)
            throw new Error("State '" + state.name + "' is already defined");
        queue.push(state);
        this.flush();
        return state;
    };
    StateQueueManager.prototype.flush = function () {
        var _a = this, queue = _a.queue, states = _a.states, builder = _a.builder;
        var registered = [], // states that got registered
        orphans = [], // states that don't yet have a parent registered
        previousQueueLength = {}; // keep track of how long the queue when an orphan was first encountered
        while (queue.length > 0) {
            var state = queue.shift();
            var result = builder.build(state);
            var orphanIdx = orphans.indexOf(state);
            if (result) {
                var existingState = this.$registry.get(state.name);
                if (existingState && existingState.name === state.name) {
                    throw new Error("State '" + state.name + "' is already defined");
                }
                if (existingState && existingState.name === state.name + ".**") {
                    // Remove future state of the same name
                    this.$registry.deregister(existingState);
                }
                states[state.name] = state;
                this.attachRoute(state);
                if (orphanIdx >= 0)
                    orphans.splice(orphanIdx, 1);
                registered.push(state);
                continue;
            }
            var prev = previousQueueLength[state.name];
            previousQueueLength[state.name] = queue.length;
            if (orphanIdx >= 0 && prev === queue.length) {
                // Wait until two consecutive iterations where no additional states were dequeued successfully.
                // throw new Error(`Cannot register orphaned state '${state.name}'`);
                queue.push(state);
                return states;
            }
            else if (orphanIdx < 0) {
                orphans.push(state);
            }
            queue.push(state);
        }
        if (registered.length) {
            this.listeners.forEach(function (listener) { return listener("registered", registered.map(function (s) { return s.self; })); });
        }
        return states;
    };
    StateQueueManager.prototype.attachRoute = function (state) {
        if (state.abstract || !state.url)
            return;
        this.$urlRouter.rule(this.$urlRouter.urlRuleFactory.create(state));
    };
    return StateQueueManager;
}());
exports.StateQueueManager = StateQueueManager;
//# sourceMappingURL=stateQueueManager.js.map

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @coreapi
 * @module state
 */ /** */
var common_1 = __webpack_require__(8);
var predicates_1 = __webpack_require__(13);
var queue_1 = __webpack_require__(145);
var coreservices_1 = __webpack_require__(20);
var pathFactory_1 = __webpack_require__(106);
var node_1 = __webpack_require__(105);
var transitionService_1 = __webpack_require__(150);
var rejectFactory_1 = __webpack_require__(78);
var targetState_1 = __webpack_require__(62);
var param_1 = __webpack_require__(70);
var glob_1 = __webpack_require__(104);
var resolveContext_1 = __webpack_require__(107);
var lazyLoad_1 = __webpack_require__(225);
var hof_1 = __webpack_require__(14);
/**
 * Provides state related service functions
 *
 * This class provides services related to ui-router states.
 * An instance of this class is located on the global [[UIRouter]] object.
 */
var StateService = (function () {
    /** @internalapi */
    function StateService(router) {
        this.router = router;
        /** @internalapi */
        this.invalidCallbacks = [];
        /** @hidden */
        this._defaultErrorHandler = function $defaultErrorHandler($error$) {
            if ($error$ instanceof Error && $error$.stack) {
                console.error($error$);
                console.error($error$.stack);
            }
            else if ($error$ instanceof rejectFactory_1.Rejection) {
                console.error($error$.toString());
                if ($error$.detail && $error$.detail.stack)
                    console.error($error$.detail.stack);
            }
            else {
                console.error($error$);
            }
        };
        var getters = ['current', '$current', 'params', 'transition'];
        var boundFns = Object.keys(StateService.prototype).filter(hof_1.not(common_1.inArray(getters)));
        common_1.createProxyFunctions(hof_1.val(StateService.prototype), this, hof_1.val(this), boundFns);
    }
    Object.defineProperty(StateService.prototype, "transition", {
        /**
         * The [[Transition]] currently in progress (or null)
         *
         * This is a passthrough through to [[UIRouterGlobals.transition]]
         */
        get: function () { return this.router.globals.transition; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StateService.prototype, "params", {
        /**
         * The latest successful state parameters
         *
         * This is a passthrough through to [[UIRouterGlobals.params]]
         */
        get: function () { return this.router.globals.params; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StateService.prototype, "current", {
        /**
         * The current [[StateDeclaration]]
         *
         * This is a passthrough through to [[UIRouterGlobals.current]]
         */
        get: function () { return this.router.globals.current; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StateService.prototype, "$current", {
        /**
         * The current [[State]]
         *
         * This is a passthrough through to [[UIRouterGlobals.$current]]
         */
        get: function () { return this.router.globals.$current; },
        enumerable: true,
        configurable: true
    });
    /** @internalapi */
    StateService.prototype.dispose = function () {
        this.defaultErrorHandler(common_1.noop);
        this.invalidCallbacks = [];
    };
    /**
     * Handler for when [[transitionTo]] is called with an invalid state.
     *
     * Invokes the [[onInvalid]] callbacks, in natural order.
     * Each callback's return value is checked in sequence until one of them returns an instance of TargetState.
     * The results of the callbacks are wrapped in $q.when(), so the callbacks may return promises.
     *
     * If a callback returns an TargetState, then it is used as arguments to $state.transitionTo() and the result returned.
     *
     * @internalapi
     */
    StateService.prototype._handleInvalidTargetState = function (fromPath, toState) {
        var _this = this;
        var fromState = pathFactory_1.PathFactory.makeTargetState(fromPath);
        var globals = this.router.globals;
        var latestThing = function () { return globals.transitionHistory.peekTail(); };
        var latest = latestThing();
        var callbackQueue = new queue_1.Queue(this.invalidCallbacks.slice());
        var injector = new resolveContext_1.ResolveContext(fromPath).injector();
        var checkForRedirect = function (result) {
            if (!(result instanceof targetState_1.TargetState)) {
                return;
            }
            var target = result;
            // Recreate the TargetState, in case the state is now defined.
            target = _this.target(target.identifier(), target.params(), target.options());
            if (!target.valid())
                return rejectFactory_1.Rejection.invalid(target.error()).toPromise();
            if (latestThing() !== latest)
                return rejectFactory_1.Rejection.superseded().toPromise();
            return _this.transitionTo(target.identifier(), target.params(), target.options());
        };
        function invokeNextCallback() {
            var nextCallback = callbackQueue.dequeue();
            if (nextCallback === undefined)
                return rejectFactory_1.Rejection.invalid(toState.error()).toPromise();
            var callbackResult = coreservices_1.services.$q.when(nextCallback(toState, fromState, injector));
            return callbackResult.then(checkForRedirect).then(function (result) { return result || invokeNextCallback(); });
        }
        return invokeNextCallback();
    };
    /**
     * Registers an Invalid State handler
     *
     * Registers a [[OnInvalidCallback]] function to be invoked when [[StateService.transitionTo]]
     * has been called with an invalid state reference parameter
     *
     * Example:
     * ```js
     * stateService.onInvalid(function(to, from, injector) {
     *   if (to.name() === 'foo') {
     *     let lazyLoader = injector.get('LazyLoadService');
     *     return lazyLoader.load('foo')
     *         .then(() => stateService.target('foo'));
     *   }
     * });
     * ```
     *
     * @param {function} callback invoked when the toState is invalid
     *   This function receives the (invalid) toState, the fromState, and an injector.
     *   The function may optionally return a [[TargetState]] or a Promise for a TargetState.
     *   If one is returned, it is treated as a redirect.
     *
     * @returns a function which deregisters the callback
     */
    StateService.prototype.onInvalid = function (callback) {
        this.invalidCallbacks.push(callback);
        return function deregisterListener() {
            common_1.removeFrom(this.invalidCallbacks)(callback);
        }.bind(this);
    };
    /**
     * Reloads the current state
     *
     * A method that force reloads the current state, or a partial state hierarchy.
     * All resolves are re-resolved, and components reinstantiated.
     *
     * #### Example:
     * ```js
     * let app angular.module('app', ['ui.router']);
     *
     * app.controller('ctrl', function ($scope, $state) {
     *   $scope.reload = function(){
     *     $state.reload();
     *   }
     * });
     * ```
     *
     * Note: `reload()` is just an alias for:
     *
     * ```js
     * $state.transitionTo($state.current, $state.params, {
     *   reload: true, inherit: false
     * });
     * ```
     *
     * @param reloadState A state name or a state object.
     *    If present, this state and all its children will be reloaded, but ancestors will not reload.
     *
     * #### Example:
     * ```js
     * //assuming app application consists of 3 states: 'contacts', 'contacts.detail', 'contacts.detail.item'
     * //and current state is 'contacts.detail.item'
     * let app angular.module('app', ['ui.router']);
     *
     * app.controller('ctrl', function ($scope, $state) {
     *   $scope.reload = function(){
     *     //will reload 'contact.detail' and nested 'contact.detail.item' states
     *     $state.reload('contact.detail');
     *   }
     * });
     * ```
     *
     * @returns A promise representing the state of the new transition. See [[StateService.go]]
     */
    StateService.prototype.reload = function (reloadState) {
        return this.transitionTo(this.current, this.params, {
            reload: predicates_1.isDefined(reloadState) ? reloadState : true,
            inherit: false,
            notify: false
        });
    };
    ;
    /**
     * Transition to a different state or parameters
     *
     * Convenience method for transitioning to a new state.
     *
     * `$state.go` calls `$state.transitionTo` internally but automatically sets options to
     * `{ location: true, inherit: true, relative: $state.$current, notify: true }`.
     * This allows you to easily use an absolute or relative to path and specify
     * only the parameters you'd like to update (while letting unspecified parameters
     * inherit from the currently active ancestor states).
     *
     * #### Example:
     * ```js
     * let app = angular.module('app', ['ui.router']);
     *
     * app.controller('ctrl', function ($scope, $state) {
     *   $scope.changeState = function () {
     *     $state.go('contact.detail');
     *   };
     * });
     * ```
     *
     *
     * @param to Absolute state name, state object, or relative state path. Some examples:
     *
     * - `$state.go('contact.detail')` - will go to the `contact.detail` state
     * - `$state.go('^')` - will go to a parent state
     * - `$state.go('^.sibling')` - will go to a sibling state
     * - `$state.go('.child.grandchild')` - will go to grandchild state
     *
     * @param params A map of the parameters that will be sent to the state, will populate $stateParams.
     *
     *    Any parameters that are not specified will be inherited from currently defined parameters (because of `inherit: true`).
     *    This allows, for example, going to a sibling state that shares parameters specified in a parent state.
     *
     *    Parameter inheritance only works between common ancestor states, I.e.
     *    transitioning to a sibling will get you the parameters for all parents, transitioning to a child
     *    will get you all current parameters, etc.
     *
     * @param options Transition options
     *
     * @returns {promise} A promise representing the state of the new transition.
     *
     * - Possible success values:
     *    - $state.current
     *
     * - Possible rejection reasons:
     *   - transition superseded - when a newer transition has been started after this one
     *   - transition aborted - when the transition is cancelled by a Transition Hook returning `false`
     *   - transition failed - when a transition hook errors
     *   - resolve error - when a resolve has errored or rejected
     *
     */
    StateService.prototype.go = function (to, params, options) {
        var defautGoOpts = { relative: this.$current, inherit: true };
        var transOpts = common_1.defaults(options, defautGoOpts, transitionService_1.defaultTransOpts);
        return this.transitionTo(to, params, transOpts);
    };
    ;
    /**
     * Creates a [[TargetState]]
     *
     * This is a factory method for creating a TargetState
     *
     * This may be returned from a Transition Hook to redirect a transition, for example.
     */
    StateService.prototype.target = function (identifier, params, options) {
        if (options === void 0) { options = {}; }
        // If we're reloading, find the state object to reload from
        if (predicates_1.isObject(options.reload) && !options.reload.name)
            throw new Error('Invalid reload state object');
        var reg = this.router.stateRegistry;
        options.reloadState = options.reload === true ? reg.root() : reg.matcher.find(options.reload, options.relative);
        if (options.reload && !options.reloadState)
            throw new Error("No such reload state '" + (predicates_1.isString(options.reload) ? options.reload : options.reload.name) + "'");
        var stateDefinition = reg.matcher.find(identifier, options.relative);
        return new targetState_1.TargetState(identifier, stateDefinition, params, options);
    };
    ;
    StateService.prototype.getCurrentPath = function () {
        var _this = this;
        var globals = this.router.globals;
        var latestSuccess = globals.successfulTransitions.peekTail();
        var rootPath = function () { return [new node_1.PathNode(_this.router.stateRegistry.root())]; };
        return latestSuccess ? latestSuccess.treeChanges().to : rootPath();
    };
    /**
     * Low-level method for transitioning to a new state.
     *
     * The [[go]] method (which uses `transitionTo` internally) is recommended in most situations.
     *
     * #### Example:
     * ```js
     * let app = angular.module('app', ['ui.router']);
     *
     * app.controller('ctrl', function ($scope, $state) {
     *   $scope.changeState = function () {
     *     $state.transitionTo('contact.detail');
     *   };
     * });
     * ```
     *
     * @param to State name or state object.
     * @param toParams A map of the parameters that will be sent to the state,
     *      will populate $stateParams.
     * @param options Transition options
     *
     * @returns A promise representing the state of the new transition. See [[go]]
     */
    StateService.prototype.transitionTo = function (to, toParams, options) {
        var _this = this;
        if (toParams === void 0) { toParams = {}; }
        if (options === void 0) { options = {}; }
        var router = this.router;
        var globals = router.globals;
        var transHistory = globals.transitionHistory;
        options = common_1.defaults(options, transitionService_1.defaultTransOpts);
        options = common_1.extend(options, { current: transHistory.peekTail.bind(transHistory) });
        var ref = this.target(to, toParams, options);
        var currentPath = this.getCurrentPath();
        if (!ref.exists())
            return this._handleInvalidTargetState(currentPath, ref);
        if (!ref.valid())
            return common_1.silentRejection(ref.error());
        /**
         * Special handling for Ignored, Aborted, and Redirected transitions
         *
         * The semantics for the transition.run() promise and the StateService.transitionTo()
         * promise differ. For instance, the run() promise may be rejected because it was
         * IGNORED, but the transitionTo() promise is resolved because from the user perspective
         * no error occurred.  Likewise, the transition.run() promise may be rejected because of
         * a Redirect, but the transitionTo() promise is chained to the new Transition's promise.
         */
        var rejectedTransitionHandler = function (transition) { return function (error) {
            if (error instanceof rejectFactory_1.Rejection) {
                if (error.type === rejectFactory_1.RejectType.IGNORED) {
                    // Consider ignored `Transition.run()` as a successful `transitionTo`
                    router.urlRouter.update();
                    return coreservices_1.services.$q.when(globals.current);
                }
                var detail = error.detail;
                if (error.type === rejectFactory_1.RejectType.SUPERSEDED && error.redirected && detail instanceof targetState_1.TargetState) {
                    // If `Transition.run()` was redirected, allow the `transitionTo()` promise to resolve successfully
                    // by returning the promise for the new (redirect) `Transition.run()`.
                    var redirect = transition.redirect(detail);
                    return redirect.run().catch(rejectedTransitionHandler(redirect));
                }
                if (error.type === rejectFactory_1.RejectType.ABORTED) {
                    router.urlRouter.update();
                }
            }
            var errorHandler = _this.defaultErrorHandler();
            errorHandler(error);
            return coreservices_1.services.$q.reject(error);
        }; };
        var transition = this.router.transitionService.create(currentPath, ref);
        var transitionToPromise = transition.run().catch(rejectedTransitionHandler(transition));
        common_1.silenceUncaughtInPromise(transitionToPromise); // issue #2676
        // Return a promise for the transition, which also has the transition object on it.
        return common_1.extend(transitionToPromise, { transition: transition });
    };
    ;
    /**
     * Checks if the current state *is* the provided state
     *
     * Similar to [[includes]] but only checks for the full state name.
     * If params is supplied then it will be tested for strict equality against the current
     * active params object, so all params must match with none missing and no extras.
     *
     * #### Example:
     * ```js
     * $state.$current.name = 'contacts.details.item';
     *
     * // absolute name
     * $state.is('contact.details.item'); // returns true
     * $state.is(contactDetailItemStateObject); // returns true
     * ```
     *
     * // relative name (. and ^), typically from a template
     * // E.g. from the 'contacts.details' template
     * ```html
     * <div ng-class="{highlighted: $state.is('.item')}">Item</div>
     * ```
     *
     * @param stateOrName The state name (absolute or relative) or state object you'd like to check.
     * @param params A param object, e.g. `{sectionId: section.id}`, that you'd like
     * to test against the current active state.
     * @param options An options object. The options are:
     *   - `relative`: If `stateOrName` is a relative state name and `options.relative` is set, .is will
     *     test relative to `options.relative` state (or name).
     *
     * @returns Returns true if it is the state.
     */
    StateService.prototype.is = function (stateOrName, params, options) {
        options = common_1.defaults(options, { relative: this.$current });
        var state = this.router.stateRegistry.matcher.find(stateOrName, options.relative);
        if (!predicates_1.isDefined(state))
            return undefined;
        if (this.$current !== state)
            return false;
        if (!params)
            return true;
        var schema = state.parameters({ inherit: true, matchingKeys: params });
        return param_1.Param.equals(schema, param_1.Param.values(schema, params), this.params);
    };
    ;
    /**
     * Checks if the current state *includes* the provided state
     *
     * A method to determine if the current active state is equal to or is the child of the
     * state stateName. If any params are passed then they will be tested for a match as well.
     * Not all the parameters need to be passed, just the ones you'd like to test for equality.
     *
     * #### Example when `$state.$current.name === 'contacts.details.item'`
     * ```js
     * // Using partial names
     * $state.includes("contacts"); // returns true
     * $state.includes("contacts.details"); // returns true
     * $state.includes("contacts.details.item"); // returns true
     * $state.includes("contacts.list"); // returns false
     * $state.includes("about"); // returns false
     * ```
     *
     * #### Glob Examples when `* $state.$current.name === 'contacts.details.item.url'`:
     * ```js
     * $state.includes("*.details.*.*"); // returns true
     * $state.includes("*.details.**"); // returns true
     * $state.includes("**.item.**"); // returns true
     * $state.includes("*.details.item.url"); // returns true
     * $state.includes("*.details.*.url"); // returns true
     * $state.includes("*.details.*"); // returns false
     * $state.includes("item.**"); // returns false
     * ```
     *
     * @param stateOrName A partial name, relative name, glob pattern,
     *   or state object to be searched for within the current state name.
     * @param params A param object, e.g. `{sectionId: section.id}`,
     *   that you'd like to test against the current active state.
     * @param options An options object. The options are:
     *   - `relative`: If `stateOrName` is a relative state name and `options.relative` is set, .is will
     *     test relative to `options.relative` state (or name).
     *
     * @returns {boolean} Returns true if it does include the state
     */
    StateService.prototype.includes = function (stateOrName, params, options) {
        options = common_1.defaults(options, { relative: this.$current });
        var glob = predicates_1.isString(stateOrName) && glob_1.Glob.fromString(stateOrName);
        if (glob) {
            if (!glob.matches(this.$current.name))
                return false;
            stateOrName = this.$current.name;
        }
        var state = this.router.stateRegistry.matcher.find(stateOrName, options.relative), include = this.$current.includes;
        if (!predicates_1.isDefined(state))
            return undefined;
        if (!predicates_1.isDefined(include[state.name]))
            return false;
        if (!params)
            return true;
        var schema = state.parameters({ inherit: true, matchingKeys: params });
        return param_1.Param.equals(schema, param_1.Param.values(schema, params), this.params);
    };
    ;
    /**
     * Generates a URL for a state and parameters
     *
     * Returns the url for the given state populated with the given params.
     *
     * #### Example:
     * ```js
     * expect($state.href("about.person", { person: "bob" })).toEqual("/about/bob");
     * ```
     *
     * @param stateOrName The state name or state object you'd like to generate a url from.
     * @param params An object of parameter values to fill the state's required parameters.
     * @param options Options object. The options are:
     *
     * - **`lossy`** - {boolean=true} -  If true, and if there is no url associated with the state provided in the
     *    first parameter, then the constructed href url will be built from the first navigable ancestor (aka
     *    ancestor with a valid url).
     * - **`inherit`** - {boolean=true}, If `true` will inherit url parameters from current url.
     * - **`relative`** - {object=$state.$current}, When transitioning with relative path (e.g '^'),
     *    defines which state to be relative from.
     * - **`absolute`** - {boolean=false},  If true will generate an absolute url, e.g. "http://www.example.com/fullurl".
     *
     * @returns {string} compiled state url
     */
    StateService.prototype.href = function (stateOrName, params, options) {
        var defaultHrefOpts = {
            lossy: true,
            inherit: true,
            absolute: false,
            relative: this.$current
        };
        options = common_1.defaults(options, defaultHrefOpts);
        params = params || {};
        var state = this.router.stateRegistry.matcher.find(stateOrName, options.relative);
        if (!predicates_1.isDefined(state))
            return null;
        if (options.inherit)
            params = this.params.$inherit(params, this.$current, state);
        var nav = (state && options.lossy) ? state.navigable : state;
        if (!nav || nav.url === undefined || nav.url === null) {
            return null;
        }
        return this.router.urlRouter.href(nav.url, param_1.Param.values(state.parameters(), params), {
            absolute: options.absolute
        });
    };
    ;
    /**
     * Sets or gets the default [[transitionTo]] error handler.
     *
     * The error handler is called when a [[Transition]] is rejected or when any error occurred during the Transition.
     * This includes errors caused by resolves and transition hooks.
     *
     * Note:
     * This handler does not receive certain Transition rejections.
     * Redirected and Ignored Transitions are not considered to be errors by [[StateService.transitionTo]].
     *
     * The built-in default error handler logs the error to the console.
     *
     * You can provide your own custom handler.
     *
     * #### Example:
     * ```js
     * stateService.defaultErrorHandler(function() {
     *   // Do not log transitionTo errors
     * });
     * ```
     *
     * @param handler a global error handler function
     * @returns the current global error handler
     */
    StateService.prototype.defaultErrorHandler = function (handler) {
        return this._defaultErrorHandler = handler || this._defaultErrorHandler;
    };
    StateService.prototype.get = function (stateOrName, base) {
        var reg = this.router.stateRegistry;
        if (arguments.length === 0)
            return reg.get();
        return reg.get(stateOrName, base || this.$current);
    };
    /**
     * Lazy loads a state
     *
     * Explicitly runs a state's [[StateDeclaration.lazyLoad]] function.
     *
     * @param stateOrName the state that should be lazy loaded
     * @param transition the optional Transition context to use (if the lazyLoad function requires an injector, etc)
     * Note: If no transition is provided, a noop transition is created using the from the current state to the current state.
     * This noop transition is not actually run.
     *
     * @returns a promise to lazy load
     */
    StateService.prototype.lazyLoad = function (stateOrName, transition) {
        var state = this.get(stateOrName);
        if (!state || !state.lazyLoad)
            throw new Error("Can not lazy load " + stateOrName);
        var currentPath = this.getCurrentPath();
        var target = pathFactory_1.PathFactory.makeTargetState(currentPath);
        transition = transition || this.router.transitionService.create(currentPath, target);
        return lazyLoad_1.lazyLoadState(transition, state);
    };
    return StateService;
}());
exports.StateService = StateService;
//# sourceMappingURL=stateService.js.map

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @coreapi
 * @module core
 */ /** */
var stateParams_1 = __webpack_require__(234);
var queue_1 = __webpack_require__(145);
var common_1 = __webpack_require__(8);
/**
 * Global mutable state
 */
var Globals = (function () {
    function Globals(transitionService) {
        var _this = this;
        this.params = new stateParams_1.StateParams();
        this.transitionHistory = new queue_1.Queue([], 1);
        this.successfulTransitions = new queue_1.Queue([], 1);
        var beforeNewTransition = function ($transition$) {
            _this.transition = $transition$;
            _this.transitionHistory.enqueue($transition$);
            var updateGlobalState = function () {
                _this.successfulTransitions.enqueue($transition$);
                _this.$current = $transition$.$to();
                _this.current = _this.$current.self;
                common_1.copy($transition$.params(), _this.params);
            };
            $transition$.onSuccess({}, updateGlobalState, { priority: 10000 });
            var clearCurrentTransition = function () { if (_this.transition === $transition$)
                _this.transition = null; };
            $transition$.promise.then(clearCurrentTransition, clearCurrentTransition);
        };
        transitionService.onBefore({}, beforeNewTransition);
    }
    return Globals;
}());
exports.Globals = Globals;
//# sourceMappingURL=globals.js.map

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/** @module params */ /** for typedoc */
var common_1 = __webpack_require__(8);
var StateParams = (function () {
    function StateParams(params) {
        if (params === void 0) { params = {}; }
        common_1.extend(this, params);
    }
    /**
     * Merges a set of parameters with all parameters inherited between the common parents of the
     * current state and a given destination state.
     *
     * @param {Object} newParams The set of parameters which will be composited with inherited params.
     * @param {Object} $current Internal definition of object representing the current state.
     * @param {Object} $to Internal definition of object representing state to transition to.
     */
    StateParams.prototype.$inherit = function (newParams, $current, $to) {
        var parents = common_1.ancestors($current, $to), parentParams, inherited = {}, inheritList = [];
        for (var i in parents) {
            if (!parents[i] || !parents[i].params)
                continue;
            parentParams = Object.keys(parents[i].params);
            if (!parentParams.length)
                continue;
            for (var j in parentParams) {
                if (inheritList.indexOf(parentParams[j]) >= 0)
                    continue;
                inheritList.push(parentParams[j]);
                inherited[parentParams[j]] = this[parentParams[j]];
            }
        }
        return common_1.extend({}, inherited, newParams);
    };
    ;
    return StateParams;
}());
exports.StateParams = StateParams;
//# sourceMappingURL=stateParams.js.map

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @coreapi
 * @module url
 */ /** */

var coreservices_1 = __webpack_require__(20);
var common_1 = __webpack_require__(8);
/** @hidden */
var makeStub = function (keys) {
    return keys.reduce(function (acc, key) { return (acc[key] = coreservices_1.notImplemented(key), acc); }, { dispose: common_1.noop });
};
/** @hidden */ var locationServicesFns = ["url", "path", "search", "hash", "onChange"];
/** @hidden */ var locationConfigFns = ["port", "protocol", "host", "baseHref", "html5Mode", "hashPrefix"];
/** @hidden */ var umfFns = ["type", "caseInsensitive", "strictMode", "defaultSquashPolicy"];
/** @hidden */ var rulesFns = ["sort", "when", "otherwise", "rules", "rule", "removeRule"];
/** @hidden */ var syncFns = ["deferIntercept", "listen", "sync", "match"];
/**
 * API for URL management
 */
var UrlService = (function () {
    /** @hidden */
    function UrlService(router, lateBind) {
        if (lateBind === void 0) { lateBind = true; }
        this.router = router;
        this.rules = {};
        this.config = {};
        // proxy function calls from UrlService to the LocationService/LocationConfig
        var locationServices = function () { return router.locationService; };
        common_1.createProxyFunctions(locationServices, this, locationServices, locationServicesFns, lateBind);
        var locationConfig = function () { return router.locationConfig; };
        common_1.createProxyFunctions(locationConfig, this.config, locationConfig, locationConfigFns, lateBind);
        var umf = function () { return router.urlMatcherFactory; };
        common_1.createProxyFunctions(umf, this.config, umf, umfFns);
        var urlRouter = function () { return router.urlRouter; };
        common_1.createProxyFunctions(urlRouter, this.rules, urlRouter, rulesFns);
        common_1.createProxyFunctions(urlRouter, this, urlRouter, syncFns);
    }
    UrlService.prototype.url = function (newurl, replace, state) { return; };
    ;
    /** @inheritdoc */
    UrlService.prototype.path = function () { return; };
    ;
    /** @inheritdoc */
    UrlService.prototype.search = function () { return; };
    ;
    /** @inheritdoc */
    UrlService.prototype.hash = function () { return; };
    ;
    /** @inheritdoc */
    UrlService.prototype.onChange = function (callback) { return; };
    ;
    /**
     * Returns the current URL parts
     *
     * This method returns the current URL components as a [[UrlParts]] object.
     *
     * @returns the current url parts
     */
    UrlService.prototype.parts = function () {
        return { path: this.path(), search: this.search(), hash: this.hash() };
    };
    UrlService.prototype.dispose = function () { };
    /** @inheritdoc */
    UrlService.prototype.sync = function (evt) { return; };
    /** @inheritdoc */
    UrlService.prototype.listen = function (enabled) { return; };
    ;
    /** @inheritdoc */
    UrlService.prototype.deferIntercept = function (defer) { return; };
    /** @inheritdoc */
    UrlService.prototype.match = function (urlParts) { return; };
    return UrlService;
}());
/** @hidden */
UrlService.locationServiceStub = makeStub(locationServicesFns);
/** @hidden */
UrlService.locationConfigStub = makeStub(locationConfigFns);
exports.UrlService = UrlService;
//# sourceMappingURL=urlService.js.map

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/** @module ng1 */ /** for typedoc */
var ui_router_core_1 = __webpack_require__(30);
/**
 * @ngdoc object
 * @name ui.router.state.$stateProvider
 *
 * @requires ui.router.router.$urlRouterProvider
 * @requires ui.router.util.$urlMatcherFactoryProvider
 *
 * @description
 * The new `$stateProvider` works similar to Angular's v1 router, but it focuses purely
 * on state.
 *
 * A state corresponds to a "place" in the application in terms of the overall UI and
 * navigation. A state describes (via the controller / template / view properties) what
 * the UI looks like and does at that place.
 *
 * States often have things in common, and the primary way of factoring out these
 * commonalities in this model is via the state hierarchy, i.e. parent/child states aka
 * nested states.
 *
 * The `$stateProvider` provides interfaces to declare these states for your app.
 */
var StateProvider = (function () {
    function StateProvider(stateRegistry, stateService) {
        this.stateRegistry = stateRegistry;
        this.stateService = stateService;
        ui_router_core_1.createProxyFunctions(ui_router_core_1.val(StateProvider.prototype), this, ui_router_core_1.val(this));
    }
    /**
     * @ngdoc function
     * @name ui.router.state.$stateProvider#decorator
     * @methodOf ui.router.state.$stateProvider
     *
     * @description
     * Allows you to extend (carefully) or override (at your own peril) the
     * `stateBuilder` object used internally by `$stateProvider`. This can be used
     * to add custom functionality to ui-router, for example inferring templateUrl
     * based on the state name.
     *
     * When passing only a name, it returns the current (original or decorated) builder
     * function that matches `name`.
     *
     * The builder functions that can be decorated are listed below. Though not all
     * necessarily have a good use case for decoration, that is up to you to decide.
     *
     * In addition, users can attach custom decorators, which will generate new
     * properties within the state's internal definition. There is currently no clear
     * use-case for this beyond accessing internal states (i.e. $state.$current),
     * however, expect this to become increasingly relevant as we introduce additional
     * meta-programming features.
     *
     * **Warning**: Decorators should not be interdependent because the order of
     * execution of the builder functions in non-deterministic. Builder functions
     * should only be dependent on the state definition object and super function.
     *
     *
     * Existing builder functions and current return values:
     *
     * - **parent** `{object}` - returns the parent state object.
     * - **data** `{object}` - returns state data, including any inherited data that is not
     *   overridden by own values (if any).
     * - **url** `{object}` - returns a {@link ui.router.util.type:UrlMatcher UrlMatcher}
     *   or `null`.
     * - **navigable** `{object}` - returns closest ancestor state that has a URL (aka is
     *   navigable).
     * - **params** `{object}` - returns an array of state params that are ensured to
     *   be a super-set of parent's params.
     * - **views** `{object}` - returns a views object where each key is an absolute view
     *   name (i.e. "viewName@stateName") and each value is the config object
     *   (template, controller) for the view. Even when you don't use the views object
     *   explicitly on a state config, one is still created for you internally.
     *   So by decorating this builder function you have access to decorating template
     *   and controller properties.
     * - **ownParams** `{object}` - returns an array of params that belong to the state,
     *   not including any params defined by ancestor states.
     * - **path** `{string}` - returns the full path from the root down to this state.
     *   Needed for state activation.
     * - **includes** `{object}` - returns an object that includes every state that
     *   would pass a `$state.includes()` test.
     *
     * @example
     * <pre>
     * // Override the internal 'views' builder with a function that takes the state
     * // definition, and a reference to the internal function being overridden:
     * $stateProvider.decorator('views', function (state, parent) {
     *   let result = {},
     *       views = parent(state);
     *
     *   angular.forEach(views, function (config, name) {
     *     let autoName = (state.name + '.' + name).replace('.', '/');
     *     config.templateUrl = config.templateUrl || '/partials/' + autoName + '.html';
     *     result[name] = config;
     *   });
     *   return result;
     * });
     *
     * $stateProvider.state('home', {
     *   views: {
     *     'contact.list': { controller: 'ListController' },
     *     'contact.item': { controller: 'ItemController' }
     *   }
     * });
     *
     * // ...
     *
     * $state.go('home');
     * // Auto-populates list and item views with /partials/home/contact/list.html,
     * // and /partials/home/contact/item.html, respectively.
     * </pre>
     *
     * @param {string} name The name of the builder function to decorate.
     * @param {object} func A function that is responsible for decorating the original
     * builder function. The function receives two parameters:
     *
     *   - `{object}` - state - The state config object.
     *   - `{object}` - super - The original builder function.
     *
     * @return {object} $stateProvider - $stateProvider instance
     */
    StateProvider.prototype.decorator = function (name, func) {
        return this.stateRegistry.decorator(name, func) || this;
    };
    StateProvider.prototype.state = function (name, definition) {
        if (ui_router_core_1.isObject(name)) {
            definition = name;
        }
        else {
            definition.name = name;
        }
        this.stateRegistry.register(definition);
        return this;
    };
    /**
     * Registers an invalid state handler
     *
     * This is a passthrough to [[StateService.onInvalid]] for ng1.
     */
    StateProvider.prototype.onInvalid = function (callback) {
        return this.stateService.onInvalid(callback);
    };
    return StateProvider;
}());
exports.StateProvider = StateProvider;
//# sourceMappingURL=stateProvider.js.map

/***/ }),
/* 237 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(680);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(238);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 240 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAABCAYAAACsXeyTAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAFJJREFUeNpMjF0OgCAMg4eAegLC/U9HOIEJutnGPtjkS/fTLUWEUb21BMuAvtmnojqLQ875qR2putsBH97AwQKPWD+YuZRx9a471jHmZG+vAAMAMUgY/0A1OZkAAAAASUVORK5CYII="

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "20e30f2668b629d0856d52e2c74f286e.png";

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(25).document;
module.exports = document && document.documentElement;


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4ddabf5cea4b727b67dfec527ac3fab6.png";

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8c7197699758498d7c68d7e9aecdb124.png";

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f8ae906da09db498462cf99a20cf89a2.png";

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4a7a2c4e753bd2de770c7d1b290a1eff.png";

/***/ }),
/* 247 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 248 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "45701e5c38ce0140870031fcd5543ed4.png";

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a2390c461595b860c97d54977f95eddc.png";

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9ff8ce367bcddeffb21e32b81e5972bb.png";

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "51ef399006f1f4f52306cb155b1239bd.png";

/***/ }),
/* 253 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALQAAABCCAYAAAD+Bvw2AAAACXBIWXMAAAsTAAALEwEAmpwYAAAF8mlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxNDAgNzkuMTYwNDUxLCAyMDE3LzA1LzA2LTAxOjA4OjIxICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOnhtcE1NPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvbW0vIiB4bWxuczpzdFJlZj0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL3NUeXBlL1Jlc291cmNlUmVmIyIgeG1sbnM6c3RFdnQ9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZUV2ZW50IyIgeG1sbnM6ZGM9Imh0dHA6Ly9wdXJsLm9yZy9kYy9lbGVtZW50cy8xLjEvIiB4bWxuczpwaG90b3Nob3A9Imh0dHA6Ly9ucy5hZG9iZS5jb20vcGhvdG9zaG9wLzEuMC8iIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTggKE1hY2ludG9zaCkiIHhtcDpDcmVhdGVEYXRlPSIyMDE5LTA3LTI0VDE2OjI0OjM2KzA4OjAwIiB4bXA6TW9kaWZ5RGF0ZT0iMjAxOS0wNy0yNFQxNzozMTo1NCswODowMCIgeG1wOk1ldGFkYXRhRGF0ZT0iMjAxOS0wNy0yNFQxNzozMTo1NCswODowMCIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpmMzM2ZjVlNi1lMGIyLTQ3M2ItODAxMi0wZmIyZTA5NThkMjQiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NkYzNTQ5MTZBNjEwMTFFOThGRkREODM1MzY0ODdFRjkiIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo2RjM1NDkxNkE2MTAxMUU5OEZGREQ4MzUzNjQ4N0VGOSIgZGM6Zm9ybWF0PSJpbWFnZS9wbmciIHBob3Rvc2hvcDpDb2xvck1vZGU9IjMiIHBob3Rvc2hvcDpJQ0NQcm9maWxlPSJzUkdCIElFQzYxOTY2LTIuMSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjZGMzU0OTEzQTYxMDExRTk4RkZERDgzNTM2NDg3RUY5IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjZGMzU0OTE0QTYxMDExRTk4RkZERDgzNTM2NDg3RUY5Ii8+IDx4bXBNTTpIaXN0b3J5PiA8cmRmOlNlcT4gPHJkZjpsaSBzdEV2dDphY3Rpb249InNhdmVkIiBzdEV2dDppbnN0YW5jZUlEPSJ4bXAuaWlkOmYzMzZmNWU2LWUwYjItNDczYi04MDEyLTBmYjJlMDk1OGQyNCIgc3RFdnQ6d2hlbj0iMjAxOS0wNy0yNFQxNzozMTo1NCswODowMCIgc3RFdnQ6c29mdHdhcmVBZ2VudD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTggKE1hY2ludG9zaCkiIHN0RXZ0OmNoYW5nZWQ9Ii8iLz4gPC9yZGY6U2VxPiA8L3htcE1NOkhpc3Rvcnk+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+6xLpGAAAICNJREFUeJztnXmYnEW1/z+nMz37QCYLAbIZcslGWLyyKCCLoCAouF1RAWVzBQE3BERQQe8FUdBcUURALiiyXARxQyK7uCAimIWQuJBcSMi+zZJkpr+/P069PTXv9DadmST6m+/z9NPd9dZyqurUqVOnTtVrkhjCEP5VkNneBAxhCAOJIYYewr8Uako9nD59er8yi9UXM6so3o6MUnUAMpJOBM4xsxcl/QB4Ati0jcrPQ1LBuMXaOR13sPujFG3Js6QOpXho/vz5ZcsqydBDKNzQAeOAe6JGPx14F/C/25C8IaQwpHJUgFiaRJ8VwJclbQlML+AfA1VmpdJ5CL0xxNAVoAhzdQCXAMcDjwEnA08PYnlDqABDKsfW48HwGRBsR2Z+A/A2M5sk6XLgD9uLkK3BPwNDtwKHAL8AurczLRVhB5GwGeBDwGnAT4Grgc4C8RqAWcCZkFevJgAHA23bgM4BxXZROVK6aJ4BCoWb2ZfN7H7gA9uD1n8WSEp/ZprZt4GDzOxynEkLoQWYCvwGWBvCpuGMXhW254DeIXXoqFNaJB0bFl1TizB8yU81MLNzgUeBySFoV1xXvho4lzCzFRqQ2xOputdG5rzZwItJvJTFZjnweuBQM5sdwrrNbEI17V3EIrTNsKOrHMOAXPg9v5i9dRBwlpntLelB4JeSjgfGA0nh64HvbwtC+oPYGiNpt/C9HjiHEvbxiAn/LfxvwKX2nwad6AHGDimhIS9t2swsC6ymt813sDEn0DAJ+CgwwcwsmTmAKekE4dnhwI3A7tuK0DSi2eIjQQDcb2YLCsWJ0ALMlrRf9OypwaZ1MLAjMnRdIjEk5QIDbZTUDgV1xZKfKvGNpKx4GjWzbqAdyMa0JDCzL5jZiZJe3or69xfNwJuA1yYBkk6QdJiZbZF0dwXtcKKZHWVm6yV9X9L7gEXVELO9d4EHk6FnAd/pZ5qL8O3j03DJeIeZ7WpmE4C5wOEDSmERSPo9cHf4nQQ/ChxjZkslbS6QbBJwBPCwmf3btqAzYKaZPQD8FrgduA24D2f0q4B7y6RvkHRp+H0OvuN5ezWEbG9mhsHToc+XdA7wf7je2aumhVQHMztX0leCNLw5iRfpzVOCTjsN+Nsg0R3jvWb2sKRxwJ+BOwEkTQbmRlvip+MD7TXh+Ylm9g5JD5nZRcAfB5nOZyWdbmZfk/SemKkkLUxHLuAv8QlgT0mPALdWu6jbEZgZBoeh9zezawAkvRi2hPNIKp5qgN3MLJnmc2b2MPAdSd3APUkkM8tKmsS2Yegu4Lp48EkaH3424GbE/wSWBIk+Jjz7IK6S3CDpAGB/+jl993Ot0IEvUB80s09IOg0YibfRL9ORCzDep8xsQ1AzqsKOwsww8Az9OTM7P5KqTXjnd0BJb7x1wLeB3YDr6emIo4AtkrLh/2xcJdkmSNMr6fPh7w3AMuDnwNm4BeH1QL2Z3RLqf2GQ5hOpUh/tJ14CPg38Gvi5mf1J0itl0lwmaYSZXQEsrabQHYmZYWAZ+ojQMPFKe6ykUcCSMmnbgY/F0134vhj4oZm14hLzQ2bWL/fMahs8ZQKbAFwOvD88/puZHU2PM1Krmc2QNDfUfZik+vCsq5qy+2vRieo5KaS9I6K/UJLpZnaxpFWSvp7Op5QbZ4EydxiUZOhyBEc67kQit8mIGZYBq6ohzLwV95L0Y+Bmtu02bAbX1WcABwKnSxqVdKyki+lh5pnAWyXV4rttmNl0SYkKsn6wiY0Ybpik9wAvEBa1AbXA5lTccwPNFwBrBpvGCtGIu+XW4hs+y/ubwUBJ6JuBEekBIOkmM2uP/oNbLzYCtxbLLMSrNbMmoF1S2zbehZsFfCyiJU+XmT1vZvdKaga+RZDagb7XhnhvMbMa4ClJz/e38K2o66vM7PWSzgj/DwXOAx4JtCb1GYEveldJ+lFc7naQulOAd+DC6xBz5ygCbXeZ2X8R7XKWw9aa7XYxs0eBI4tMk42RrXaCmT0EXCfp7HI2YzObFuy5j0FfxqrUBl3l9u2aiI6YJiR9DthsZiOAUyI7dTfwZ0m7AhcEGi42s47+ll9p/Qp8kg2d58zsFDN7HJ9BHk61xVlmtrOk/zaz9m0sLBIcCtwr6Rl8cT3dzO6S9B/AqZJeMrOP4INxz0oz3VqGvhE4rNCD0EiJzlkH3CfpSDNbaWafKZPvGZIeMPcn2CPu6P5gK6TNJcB/AH9L6dI/Jlhd5FvKaxNmMrOfSvoCvqPZipv6ZlfDmFUOQszssJD+HuBWSfcABwHzkvaQlJV0AiAzu30r26kSZHCPyQSvAWab2eNm9kYz+56ksbg16LO4qnRb+P8j4FWSvoGrIRUV1m+Exvu4pLdA70VMpGeCSwrMbJak/UL4FZIeLyIVMsCPzexGYIykekkHFZLglaKadCHN3cCRBA80SRvorYYcb2bDgCdDsqnAj4HXAZjZ5dUw5dZA0szwPUHSX83sPcD6VL6vx91xlwDJlngN7o23c3/Kq7BOb5b0K9yC9VXcLj9S0vm4Beg84OVAd5z9Fkln4QaDN0uq6IBrVTq0pClmdkFcsRB+B+5HOz5ItKvxKe+DSTxJxwA/Af5eIN9rgbeFAbJM0nDcNLZV+t1WSKCTcVMcwFWSlkXPVkh6A26afEzStIjO+Wb2k2oLrZTemFElvdrMjg1/X8HPN24pkOyQQOMwc7v1EcDBZtYlaTXuEHYn3u6/GwBa3wHsL2kksMzMTgB+EcpLxx0FXIGrGT8yszZJK81sgnwBWxZWiqBCp74l1ZjbOPfulZFvCX8W+C/cOWeFmSVTyZMpHXsL8A5JP42ymAgsNN88eauZTQOOBY6Oyj7MzNZKeq6SyvUXqUFzIPD78HuZueVibYE094UpPKnferl33qDby6P2nC7pAdwjcKOZ/UbSsQWS7Gxmc8MUHwuipeY7jatxW/aM0BZfAz5dauYow9DDcHt9p/maqC01CF+D7ya/EsIPkfQE8CywX6Dhd2Z2EHDw/Pnzf1uuTfqtcpjZDTEzB0JWSzrGzHIETzMzW4Qz7m8l/SRUINbjvk7vGWK0mZmkjwI/k3SepAeSBgvTzz2SfoeP+kGFmX0z+n1+zMxRp3xD0gkpNeshM3tiG6oa48IA7zKzTmCppEsoPPueKWlsvCaRtD4wzNeAm81sL3p2Yj+F+3ZUS+ChZjYKeElS3uwayp1iZr/Hfczzi9pAmyLh8vfwvLVQAWmUZOgCuuuxwGnpDjCz04G/EDzlAlqi/N9rZtemsn8c74Tk/zBJL5vZd4D/NLNx5nbsd0paB1xgZj8DGszs1YPFLCH+pfhiCnxBdUcIfw2+Op+M290/Hkv1MHNdkM5zMCHpbmCVmd0C1AP/jeup6Q2dk3FnpSQdAGZWD/wQmB7CDwdiCX4d7nhVDY4L34V2IafjEnynJMDM9g80LI8Wxy+FZ6MqKbA/OvR44Mo4IHTmVYm+KOmgSFqtjqK2A58AFgOnAE+Z2f9Jeju+kALfHhduJTg+hF2Le429CEyU79gh6YV+0N1fHGJmX4g6/KIQfgDucZeVtIoe340Ej+B1e6m/BW6Fjv9J3KZ/hNwC02Z+7Cqd5ztxy0Eh1Eo61Mx+ituEnwlq3ZjQly9KqmpbHFc3wdWKND4cvq/EdfjjgJMC3TdFdVgBYGavBv6nXIGVMvQw4GxJ+xSQeHeGApFvNiS/HwNy0dQGcI2ZXS+pXdLXzGxvehh6CzBc0tujQbEZOAn4vZklPsZrJT3J4OCiUE8LNNwD3B9oP8DMGsLvMRGN4NaCN0sqdAg1jlcVUrp9EvZFfCa51sz2kTTVzJ6UlF4IHmFuGiPVF/PNNzHqA317BD36KSCTxDU/jtZRBdmNwKhQ1koz21fS+yQ9jS+k3yzpwUjdyTOWmS2P6puU3edQRSFUqkN/UdJ50GeD44dm9uck3Mw2RQ2WLZSR3FH/GOAMem9tpkdKLjTmvcBmSXND3ouAv1ZCdD/VjUMkfSVZMIU6XEGP6+tNuPddG77Q+RI92/1PUPhE9WBhpqRLA40fk3RHWH+kd9T2AG6XW4vyMPdsPAJ4IWmj8H0eLslHh7w3UP11BrsAib7+Fkl3mlvG7jCzm/CF4KOS3i3paHoEG7gV7CPh98uBtopUjooYWtIe9Jivks5uN7NLgO5o4ZZ3bDez2oihGkNY8n+BmQ2XdFSkKy3EfRASKZKRlJwnXAUcZ2bfBz4/CLpzNlItEpwv6ZloAHfinnVHAa+TdJmkOVH89+AOTB+iwk2AahGmX3D/lloASV309snI4gcsdk0Ckik8LBqXyy0K8bP8b/MdzqcVboaq4jNB0sjwe3/cYrQfvmgF98K8ABcGqyUdIemXZnZrmOm/bWYnmu92IqmxkrYpx9A7A+8ys7cUmPbOIaxAIwbKRoyUSIuz8PNp34vi7i+p28zyDuVhqlwOvGRms8xsC713mBbjK+4+Pr7F0I9p/nD8VHdSj6cJx7AChgGtIb/f445JWXp2SU8zs9vDAL9e0klx5w4UQtvtLTePfgW3RmzGfZpX4GcvE+TMrS0bYilsZjea2cbw+xp6ri7IxwGQ9LCkk83PdfZ7g8jMpoS8ksXpWrk7a0N4vhOwk5mdgevtfzXfhHk/8L3AF/8r6atyt4KmStqoHEM/CNwlv04gDn8Ed0gi1XH5i2AkLQzhZ5vZDPwikyuAGZIOxLeGe20+mNkiM9sstxQ8bmZvqqQSxaREJQiN+4lU8I3R852BB4D5wIlRnCzu5IOZfTGWdma2qcqZohx2A24ws4ag5O9tZjcDj0sajatCCbpxCd3rMIR6N8wiSYsDzXG0TlylKnk2soyEnhSK2mxmT5nZcWb2nJl1AKcCz4RsRuCOakdFWX9Q0o3mO7GnmlmGCtd75RhaBSrbbWYFje3mh0iT37uEn+1RlM+FRccpuGlppyT/kN/X5SdS3iXpuwSGKUhYj5pTpgplcaak46J8XrLg4xBwPd7YY/CGTxaEZmbjw7rhcuD5pAMTVWQApfM+ZnadpN/IXQH2kHQR8JykG4F3AzVm9mg8kCR9QNK+iVoX6Dk4yTSEn2dh1y75mNk6fCFeUliUkdDjQpxaSb+QVCdpBD4T3ibpjZKuCsLr/fR1sz1L0pWhjkaRNVkaJRnazHaLp6uAeZKejiofM2QuSj4zhF8hd+RJGqIx5Ps+XErfBzSH/Bbj089J5ovNemB4qgP6K31Lfcbg/gX5+JI+Q+9p+MWoDVpwRyuAT4UO+jt+5ClZhdcCn5Rv9VYkVcrQeLCkR3G320nAnWZ2IS6BP2pmc/DdvRdJuVma2SNmtjZV3ObUDLaHpEzcz5JGmtkBpdq5TB8YQXeX7yyvxYXCdHok8yrcGemrhTIIuNDMzgp0VbTeK7ex0hwI74wqcHmR6FMkzYiYbl5I8wv8IsCbzew+wjY40BKk8QlAvCv3btyB5iacSZKRXkl9+otz1HsHaiG+GxnHuVjSQ+CnwSUtlvROMzsTP0/YieuuCyMmPBMfrA/gTk7fpUIJk8J+uNVhOID5TmwbPoDagT9K2j+U+fcQFkvSp4A/RkKg08y+lWQedNZZRHwQ+q9G0lVEwqQQSqgbtQoHIqJ+ewFv35JID2jC5ltKVSqKchLkrWY2FXgOZ7yRwF1x4VHlLsJNNUmj7B7Fe1rSGYGmWWZ2cJI+hJ1uZq+EhsjgmxNJnKJqRzkkg6sIpkj6ZKoOPyPcMBSFd5tZ0p6XmNlUSdfhvtBXho6TpB9KOjNKNw7flk7ymg9cU4zOImg0v8YhiZMxs9PD7zZ8MXtw+P+zwPAx7buqx0ca4CFJ94U4V0n6TKxWJGnD7yPwvjq1CtWpFtgpEm5bc2pnZMhnQBj6N/QcK/pjumLR/yYzOyLVKC3h9yRcdVgPXGlm74skd6uZvTb8vzDJzMxyESOchku35/DFyoZKKlaAxjSONrPGiOZu/BBuOl0r7m4Jbn68D/c/mA282swSW/QjZvYkgcESxoiYK9k1K4giA+9JSZ/ETVgJ4yUDrMnMfiI3bW42s18XSP8G87OOSRmJP8Ubg2oVl71Gfhi5OUp/Cr5wv4v+IQs0R22wNcfnGgJ9Fd08O1BHsA7Dt8ZjbAKQ9AMze138wMwWyT3UsmFR8G5JM8IzEp0ukt6nS/orsE5+wuFuvNGy+LbqX3G9t0+lS0jog+I/8u30hwrEe5uZ1QdabgsD9Sb1bPMni8EcvhnwByCJHw+MRdWoTeanyE/Ft4cXSboG+EZon+Qgbo6U2hDwB3OzW1MISzYnDgt5J3HXA0cCh0mK1T8k3YIv3vOWnwrQZGa7Rv+nFqhXpWuhxlCnQpf79MFAMXST3L82JvI44LLQISuB35rZOkmdZvZz85V1F/BFM5uFL6Q+nOhecWXDKJ8cwv7dzM6Mnm/CHYjeS4/Deq+0BWDmZ+9iSfpn+m7xNuHG/yRRCz6TrMJ3T0nShHxG47PRFvM7+RIaVgE3l+rAEszeYWZvlPQOM3sa3xC52sxqojRziK5KiMIXyQ9hnGlufvxmqOs+qRnkd/iFNa8AXzCz+HxoA76H8CLRDFYGy+VWqg+F+n/AzK6mwEHnIvXOAnWSNhKcpiyyoJXCQDH0LwJD7Bcx4zhcalwfPqWwGtdPb8NVjKNx/bEL6JLUGJillz4dyqnDp/7F/aBXcuepSVGnPhSrTAEn4ae/8+WZ2crwtzPUdefwfwzwK3w7+ZRA64XAKDO7QNI/+kFfGu30di46T9IsM6sLNF2G321SCI+ET4IMbs9O6rkW97bD3LvxfIITUGoATqFyht4EfNjMnpUf2P0TBW4/LTGId8evNltuZuMTVauSggeKodvCVHhLROTt9P/G/eeBC0Mn1eEOSzl82pmET//HS2oMEn4mrrveRf8daN6DL3qX48x3bzpC3KGRDvtZfPpNtvOfwBnkefMbn06IaHkA+l6FtjUI7XsD7kS1r5ndKeneAnGKpZekc/EFfLeZLcHXJwluxa1Sp8X5SZpbBbnXmdl1VaR7SdKXwsK1JYRVdE9iyRMr06ZNS1syPFGBBgsqx7fwI1dXSJpNj8klny5eKBXLL7WYSkuKBnwVncP19nkh34KMU6xz02UXaYcsbm56Fb5z2QYcKymxj+6ES+bJ8lM21xYsrHj+Zekskf6bwBoz+1JaepXrs/RALYA6/Cqzk3H16bNBt+7XwKxmzRDTaGbjwqJ4oZl9u5L3FA4kQyfhGSCXZuL491YydN9KFFlgSKKpqYlMJsPGjRtL1qVYGWb2XklvAj6Pq1T3R2n/JOlYM1uRprkQLcXCs9ksjY29fW+6urpob28vRV+GyD03RXPReqbzKsN0R8lPtDxV4QKuKB39Rby+SfLaXi/ezJWLkHRiJpOhq6uL7u7uAds4yWQyZLO+HqutrWXBggV0dXUxbdo0Nm3aVE1Zt9NzvezOkjYFdQjg33F79opq6W1ubmblypUsWtT7+rtsNsuee+5Jd3c3uVyOLVv6nHct284DgEKmQGpqashkMuRyfUkwszzN2wMVM3QyYurr6+nsrNz1VxKNjY1kMhkksWnTJpqamli1ahWbN2+mpaWF1tZWuru7kcTGjRurqgh4Q5sZa9asoa6ujsWLF7Nhg5utX3jhBWbOnJlv8I0bN1bT6PPwHcCDQt3up8hN9y0tLWzevJnOzk6am5sLDqLa2lqWLVvGkiVL+kjZTZs28eyzz9La2sqYMWOor6+nvb2dTKb35m4ulyObzVJfX58Pi+Pkcrn8rltbWxvd3dW9SEwSNTU1NDc3s2HDBl5++WXWrl3bJ15DQwMzZ85k48aN+T6tra2loaHwO4i6u7tpa2sbMIFWkcqRFJbJZFi9ejVjx46lo6OjV+MUUxMaGxtZsmQJW7ZsoaamhhEjRrBq1SrWrFmTl9Q777wzW7ZsIZPJMH78eLq6uqirq8t3THt7O8OGDaO2tpZcLkdHRwdmRk1NDXV1dXR2dpLL5WhqamLu3Ll0dBReHzY0NNDY2EhXVxdjx47NM3dMb58G6jul30LPBTqXmr9hqg+WLl1KS0sL48aNY8GCBQUHT01NDatXr65IpZo6dSrDhw/PM5Ek6urqaG5uZsWKFSxfXv4auHHjxgHO5A0NDX2YqLOzk66uroL9mM1m6erqYsWKFWVpbmpqYtq0aXR1ddHc3MzSpUtZtarwFYfZbJZJkybR0dFBV1fPMchBUTkShsvlctTV1fHCCy/Q1tbGypUrGTNmDKNHj843RFxBSWQyGZqbm1m4cGGvkZxujC1btrBy5cr8/87OTvbaay/mzp2br+DkyZPzDVlbW8vkyZPJZDIsXbqU1atXM378eFpbW0syM0BHR0f+eXt7O1OnTqW2tpaurq78IBo2bFifdEn9Qkc3RY08Ol3v2tpaJLFu3TrWrVvH8uXL2by5oj2BopDEggULaGhoYOLEiUiioaGBxYsX09bWxubNmyvapOjo6GCvvfaira2NOXPm9EkzceJEWlpa8rp7UudECCxatKgX0xVDW1sbixYtIpvNsmHDhrL0rVu3jtGjRzNmjB/TTFTDalBSQh988MGsWbOGhQsXksvl+hCVzWYZO3Ysw4cPp66ujo0bN+ZViqamJubNm1dwWipLVEoqFvoPhc1q/S2npaWFvffem1wux8svv9xHVzUzRo0axaZNeTPqMfjBznXApblc7tGamhoaGxupqalh06ZNzJkzp5DOOyDoz2K5WPpi6TKZDNOnTyebzdLR0ZFfj2zYsIElS5ZUxMxbg5qaGnbffXdaW1upr68nl8vlVcNKJXRJhm5tbWX9+vVldc36+nrq6uoYNWoUEydOZNGiRaxcuZL29vaS6XYUNDY2UldXx5o1awo+Hz58OFOmTOljKUn01/b2dpYtW0ZNTQ1tbW2DxszbAplMhhkzZtDS4ubfOXPm5Nch2wp1dXV5hp4wYQINDQ10dnbyl7/8pWzakgzdX0XdzMhms1s9xe6IaG1tZezYsb0WxA0NDeRyOebPn7/dVvWDATNj2LBhSKp66h8oZDIZMpkMI0eOZNmyZWXjDyhD//+G+vr6vP49hMFHJSrWEEMP4Z8GlTD0tnrxZhN+Fe1uUdgh9FwVBX544P30XA1Vh9+uMzGKsz+9D6ruhL+NKnGLbAp57BLFORJ4e/R/TMg39vsthjH4rUPxiWPDb/bcNwq7GN/yj3Ei7ujzmfDdnxMro/CF523hc1yReB/BzYg34ld9FcIB+An9kQWenYwvcivFePyQwk34O1xem3p+ZKAptp6No3f7Dy6Cw03BzwAig999F5+uno1fW5BU/p24k0zijGK4W+MXojR34o4/yT7xG3GHpqSzGnAX0g9EaZ7ELRLJdHMW7m5ZyabSfrgH3W6p8OdwJgH3JJxN37uVH8MvT/kIviFzQ0RDKYwL+d+NnyP8PH0ZogF3ppqH3xVyNl6n7+JXLsQ4H/fBODcVvm8Iv7YCmgD2xtv6Ftxx6Ur8DbYxZoU8T4nCjmGAXrNcilfzPLuNGBrgy/i1COAS73n8qNWBIex6+r535TP0XCg+DD9guRqXBFD4Tanfp+eExUjcdfEVwovZw7NvVEjzvsD9RJe1BPwBZ7LTQz1GF0j7BH51A7iEXUVfZksji78+4toy8T6NX4C4UxQ2ChcQJ6Xifgr3Q36A3oPuy7jraLm3KYD311/oLVwK4X/wO00ewgcAOEOXvQa3ElTC0NvyXd/J/cXgPhBP4hI4ucd4L8Ll5hF+hU/7tfiphzkhLJmCX40f5YpxN/72KvBziYvwSxbfEMJ2D7RUAlHYZ2I9LqFPwjuskC9HBz5Yj8OZ6hOUd6edgXv2XVYm3rH4tB+f1VuJM1JahRiDH6N6BXeZBXean4q7ZFZyZvMAvC2uKhNvOH492o+iuJ1sG78ToDrnpMPwRi9lbB0Wns+m57Vuz+C36OyJqwrP4hejnIhPszX4Fbsx5uFnCPfBr7FdiEvHs/GOaqC38zr0SPRx+CHSh3EJ9RZ8wNRSucTI4R1ZSFV4A95xLxZ4Bn6j0X6BxvFU5hs+HG+jcnbPDH7raBob6MugWZzx78Kl8fW4SjYvfA6tgK5RuNpWrg7CVcavAB/HB9c/6Ot2egA+eEvV0/B6PkLh20sLohqGfhU+FZfyUMriEuo3UdgGXFJ+NORxJT6NnYwfc1pGX8K34BL5DLxRv4cPkvPwOx3W0Pdo/GrcgegSnEFm4Qx9Kj5V/4n+vZevjsIS5gr8rolL8VuG0mjG72q+FT+c8Cx+9rHUax5W4WrECEpfy9tBuN4hhVH0fdWHcJXo14Hm4/HF9em4pK9Eei7D69BEgZMnqbKSNdCn8T6+ktR1Y/j90/tS+lCG4YLx6QroiyjYdjo0uN65Gp/yk4XdA3jFzimS5mi8o5+k5667e/ABVexy8ffiTBtL4p/hHXNqgfjDKDy434ff8FSfCk906Cl4B59WIO3D+IIMXHdtp0f3T1BDb706E9Ldm4qXtsicijNJ/FqQE3C148BU3K/j6wBwQZDDr68Fl6LfpC+y9J6VavEB+YNUvPQFivcS3ocYcA3e5mm1sCrsaItCcMkjwp3SAV8PYa8rmMKnbNFbtbgwhL25SJpJ4Xl8Du+6ENbnBHKgJ14cjcE7fRnhzVcp/AO/SxpcjxbhsscIv8UXbj/AT71cQW8z6Qj84sfDU+mm4Hd4PINfl3Av4bBpClfjg/Zr+HvS/07PIjTGjfSoYbvgTJ/QeilutYhxBG6hSasuB+EzzK9D2Q/S99Ugj9F7Yb8TPssWU8v6hR2RocE7ML7yYJcQVspOezB+13GCVrzhCzvZOg4lvFohYFdcdy+Et9Fbl9wJvyHqnUXiH0jvOhyOL3Rj7BPSn0Vf8xY47afRu14JGkO6m3EpOqEIHYfjFpHLKX4h+BRclweXuuPpue53In0H+Hhcxy502+cIXMp/Gx/oaevPvkSHigOmkboyolpUwtAldwqHMIR/NmxLs90QhjDoGGLoIfxL4f8BCMOnOZg5mzsAAAAASUVORK5CYII="

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3695dcc53cd82711d12bedfc73ef5d50.png";

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6a78a6d30b43da9c0093e1ba4f62871d.png";

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9866dc8211a3261ecfef7978370b14b4.png";

/***/ }),
/* 257 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 258 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 259 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 260 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,iVBORw0KGgoAAAANSUhEUgAAALQAAABCCAYAAAD+Bvw2AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA4JpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQwIDc5LjE2MDQ1MSwgMjAxNy8wNS8wNi0wMTowODoyMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpCQjI2RDc1OTNFRDcxMUU4OTdGM0NFQzJBM0RFQjlEQSIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpDQzA4MDhDNDFBNTUxMUU5OTlFQjlDRkQwNDA4MkRERiIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpDQzA4MDhDMzFBNTUxMUU5OTlFQjlDRkQwNDA4MkRERiIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ0MgMjAxOCAoTWFjaW50b3NoKSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjVjNjI5NzQyLWU1MmQtNDMzZi1iOTkxLWJhNzQwNTUyZjc3MSIgc3RSZWY6ZG9jdW1lbnRJRD0iYWRvYmU6ZG9jaWQ6cGhvdG9zaG9wOmY0ZTI0ODcyLTFkY2ItMjQ0My05YjQ1LWM0NzI3MzdlMWNhYiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PpC8GWYAAA5ySURBVHja7F3LdeO4EkX3mcXMkm89b0OHQIdAhUCFIIUghSCGIIUghiCGIIZgbuatm8uZXQ/hd0u+KgMgKcuyWwbO4bEl8QvcqrpVKBS//fz508QW272077ELYouAji22COjYYouAji22COjYIqBji+0u2m+3uMi3b98G9/nr99+z/k9nt//+808Xh+b+2i1CxJ9JQx/67anffgDco1q/b3rpBftjF/22mnhM2m+557e83+z9Pw2dF/vm1+o8nO/Yb9t+K9RvR2wb+i7BfR74e5+ywXPt9bnp/E/4PftIEP32CQW57TV0M2H/FYCx67dm4rXsQNqBXfR/l/11axokK1xVv9WwHHyMBU+FY7Q1SbANWRl7zaI/j91v159n7QFTAmGv+n3KwPmsYGfYWsc9pY7vU/neCmp//tZz7gznKHDP9n6XjnOZiWP3JQB9SUsBtHIEkLjVGKQUAKsVCFYYTP29wXE79duUxtq5hmZzacpEgArBm3tAk9D/u4n3Ys9vNawV0J3nd2mNA8yd+vs1AG0H7RIJtmbUDnp/bDWwaznEvwEKq+06mE8xob5zV/IbjhFNaFij+7Sr635gUQSAJ8vQfz/X++PZMwJt4bFEQr06erZMgT3z0AvZz9IV4wA1A3o9YdxWEID6LgGNDks8plw7iIY0oQWh5bs1ANBeyKntebegKbMJ970nmjFWC9n73kDrVY7fRAArAHwDsNSqHxak/WYBhSCgbdHHCQlpgc8tfScWSIRW6EwbEJbR4GSL0/+/HqBLvzTlSNGRPp6Z0IC7zLQ9djnAizu6Vk70oiVznF9gIhsaXNH2iWPgmVLsoXkr4sQFLI5oO6E21kGz1mMuCoDA7KQa0OB8PeHcQpW4rzo5B+7j1fceYMq+pXUiPfz8+fmtg4j75fG1CqQNWMG74NBrNq8Ah3Tu2mG6DMx8CMyGwCDnzMm0t+q8xch79QGfz7dSvLgkbduS9RCTvyTA5LTfju5dLNU8oBlLpfV3ZI1ypRxyByCncP0M99KRUPxQ/WTHz2n9bpHXeS9O4bvzeI/wMD3YO6I1tcN6FACu0K+UwPxIPH2D70pQF7EQO75/K6REMWSfjAC2I9pSi8A7wBiiTqf/lbLJXYLv8x1u0b5/MTDbwTkiXppcU0gU9QhFVTjEZojbzgBmC5Ij9n2EgzbDPgvP/aceWtQ6nMwUApOOfK4sYKkKDy1bxLDd9cB18ISytvjcUJiunXj6boQWC7VKhfuO5Oy1ELgt6FFFWviZQ4OfZqTl154IR0rg0k7xlIkkCWW+EgDyBVyA3iJW3X0lQCc+LfmW2T/mb+ChW8U1G+KAxZWepSANnAfurYO2FYqSEJhXAM2DJ9SXgHcfHcKaKQDrzyWDDcJQ4/sGkZFcUSixIjO6potbNxBK/pzgOvOvBOhVIPy0eofrtfD+0wvCSIlPQ8MspxjIMgRoErIFjpkBTKmEMT1gtr8/QbMvAbTSAehW0R+Jn+9IKE6zicKHRfOrGcCcaFAomjQnpSGc3vaFnVHc+GZA7w3QnY5WkLZ0/bbwmNCprQaYCgWIsYB2UZQ9RS2SATCnPPik+SSk1XmsU0YU4OQ8Ojh0Svy1gjPJv/H9LVS8vwGoreNXeWYM5Tk2ON8cAH4VwYLyWMFBXN4roNeQ6qnc9cFcJwuvEg06wilMhgCNGLAdWDtB0gwlG5H2ygjEOwknUtSjAzBX1G9zRV24PWL/hbIQa+LUR/VMlVCKKf0KIVjh3L64ckP0SwRneQWF9LkAfekUaGhmUGsypS30REdLWvpoxgX6GWSn0BlpzKn0pcQzVR6OLRMfDLI61Ac4roSwHIjXpwD7hqIpHCaUyZwpoN5CCOoApdqgj3KyMAsTnhCLUY4R4GtVJwrXXSpT7mpzHC9abUeREolWPE6NaWsgK16bsMa+oG3wfBI6k4QmiYrMwMVZS9tjbGLSbsS1RUAkG7FV/ZjStYTnizYv48TKBRx5ovksfDFTmqreQkBKmO8f0Dy1A8zpwPVE4HICsaR1lm/Jd6DZ1BnRDEkzEDB36hlLSmJagfPy1Psrx5oA/6BCpTl+n6n7akYklUVA++KmylQPUpQRTtzCnGfxVcJVyeEqzHneiDMiIqBR+5RmRJYgmXN7rbNpfMoaZOqwhsNaE5d2+Q0Slkvpfq5JM6tbAuDeAH2tiRLmi5UKPQmgO3LmKuyrZ+xcTumKIi5LOIqpA2xnM4HwDYQLH5HwVFMuyIzi66ckroDfkgj/Rubh1qhpdc+9fOr2GQE9NZKRkDmcpA3IgWw8EYxa0wCA6JH3ByiX4KcdNGLr0FYNUmB1WKzw0BXODDTKic3NS+x66QiLzgaA2Smne0w67VDq6sevBbULF997Gwmu/JIZQqx3u+o6Nqy3u+RePr0mwzrK9II+Tt46BrfA2rdbrMQds+o7tvtvX23Vd2yxRUDHFlsEdGwR0LHFFgEdW2wR0LHFFgEdW2wR0LHdX/uwqW8qcfWc4hlKzkHyjZ3qXQ/sJ8vy60DG2NT7tJlkdsq3GpMqqtfmefaRYjCdcUyvYx+biyFlv9aXLm7A2sUa5zkrpkj3UY99vonXTt+QCntRu9lMIa29a5HTsJcB6z8/BgZ+a14WodoO9yajA9D2mHLMWjZkr3mT5x21K9bmJSutMq+ToSS5vYGQNiPOWwYqj0papr3ew4g6ebrxKu8dPp+KLUJRcD2RuSNf+5WAot8aqsK0pWtIn8gK9lOV1ltg7ZYaWpYI2Q54MCqRBQNTUKessL9e3WwzzR7HaiwqpO4a7C328a064ZyHFvnDArKV8a94kZUgThCqhaeh52hwLcmjbkYAV1ZyL0gYeOnbBppzZs7TZ5ee5K4DynjVaixtv4kwnkrtUp9kBOxnYblXytF4FlYy6GtsMhC8mQCYpaYa141IaGBZo7KgbFBRaR4AtF40+orWIOnnVJJrgtClDG46riYrJmsWO1U5qUYO+Iqu29L6xo5Wfct3Umw992lmRz9wbbrCnNe04z5ZkhbXJSTuCtBTOGB5hRKsGwhHiS3hQcOAcmXPtUfzye+7d+qXBGY/NS9lvyoCz5rowfMSMNKMbx2PDOfPUUY3BOqW8r/Zgpw9C2XdpR+gLD9VPnQ3FfyqShJX95F1bbV5qcKZKYrA5ta3li6fqm0HtPDeuMtpifUolAb0Aey5mqevOLmqdccWQGrltdQvssJ8MSAo2cjVQMVXA3TiGOzgCmwAN4G3X5O5namoyakmBQ8MBnjh0b7GdW1avDoUrQg+G93rcz0NOvYnCUtJwHsi871zRD4SaEufxRB6pVe887NwmV4uMRwqtBjqj5TuuSTKUXwJQAOgqep4Xmu3VdogJwfF58BlSpucvHNV703v73unSzEA1MwRgfkMb+8qwaFPlf8dgsGCP7a0QE0Lh1c+QaZ+/pDFDh8B6Na1PEhpJwvYjEpV/SSNUg1oCTGtIhRzaMdEtI+qvlkFojJDAzxnTWteCjC2ZuL6RseKj1sIB9d5Ti6JGauSwCkppg+hHLecKex0JwaW7Ui4ShdurFyd7ihnK8CX8FlCoUAN1ipwPpfmtkL26Jq4sffWb/8x/6/7sXWV7XU89wqUK1UgTqT0LZXAHdNk32QETerIOj6R5vbx9gPRP23JnrW9bOYG1fo/WkMnNFAFOjFDgZO1BgathE5D4FOURAuFaApxgOyglOa8ALgLtPbeZsQ1JcqQqijJ2T0QWNi5y7CqWt45kvrCfwq0mWPfMWZ8QREM6e+tr9+oVINQvZQsI5dAW9JEikwe2T6VmdQl9pe4+eLeAe0bGF04kTU5T6x0gVBeQRr55KCYl9i18NsNIg0Jh8Qc2rl0xMpbpUH3DquQm5eJDW2dWo8Zbjz9UmphI6oUCiGuiUMLuHWl0gVdr/T0v/geD9oqEuBlWr2kEgo1FEFG49bcM6Cfl/BDw8lUbEtmmCcVFkPamTTn3LzUdePBONWkw4wXh+IaB21oPFGKRjlViQOYWWAA5foS8z4MCLqrDMLswj5/dr5VQUkRsiQEOKpd3ZJTKLVA1g6wdwC15KEsbwmu7x+glduRv1fmPLbsm23aGM+r3hzhJ9bwb5m9WnmEzA7gPsB3rYP6OFT8xbyt0moC0HK0gd9WoKv7j6EGOZ7rBzj0Hn1wBK8+0iuhD9Q/2a2dw88E6LOOxqB3A87gApp20AGBVuFQ3OHC2htSrNyV0bfDbwdXad0Rptf3Komh++Ew2hHan6e+udRYTvf6TOtG1NToiO/PoAwSWNcZFIX+LNeu7hnQIT7FHa3NeuHxwNsxBQ7hrAjn5Rf3HKe8QJ7eTtUYR7INnq0mUO8nCk024Pz6hKBQVGUZiN4IzatIcA4f/dL5XxHQQ85MTnw6h2PRkXawHviGw04O0+2LAgiYH6FB+G2qB5jNfIRQiEcfqqe8Vs7qUQujqwoRRQiaUPV8l09CWtRSrwcc7ysW2RGvrVU/FBHQ4zSb5BbsAo6dQegnAwBlqnitBuQ4pePp5Txcy1lXk88xoKF3u+zhzQeLg+MaS0VDxJkqEH04eHwBM9WJous9DLxGQl4Menq9Mmgcg3o/EIu+ZOw3U6zgrxLlyCUUFnCyZuY8z1hWaezUO6/HvmPvpFH1AgKquHmkc4VSKOUNqu2YUCSiOKnwV/q+cuSVNPTW2MdLZuuGNDqB2ZWfvTYv73opSfh4cobnENjRS9Sk1qvP5qXu9Ew55e/SbrJi5X9//LHSXJc424JCdK0P+JRYH3odgmh2qUwfTEPlJUiuLDN6L+DOl/NAU9/LsVQB1e85JTW99tuiqJB5NuQ4Y6LkTPhowcW1puCbP//++/0dxI+sPiqzgag8mowYpGzkYGZXAsUCNCFUebN4y3sV33LsSCv1adrdVB+NLbZ7jHLEFlsEdGyxRUDHFgEdW2wR0LHFFgEdW2zv1/4VYAA1uGKCm+CuXgAAAABJRU5ErkJggg=="

/***/ }),
/* 261 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 262 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 263 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 264 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "776b22d00f21309c40f5243e58e3ac92.png";

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9f7b6f0efa7a08335fc1547204e8456f.png";

/***/ }),
/* 267 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALQAAABCCAYAAAD+Bvw2AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyhpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQwIDc5LjE2MDQ1MSwgMjAxNy8wNS8wNi0wMTowODoyMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTggKE1hY2ludG9zaCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MEZFMUQ2OUZBNjBFMTFFOThGRkREODM1MzY0ODdFRjkiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MEZFMUQ2QTBBNjBFMTFFOThGRkREODM1MzY0ODdFRjkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDowRkUxRDY5REE2MEUxMUU5OEZGREQ4MzUzNjQ4N0VGOSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDowRkUxRDY5RUE2MEUxMUU5OEZGREQ4MzUzNjQ4N0VGOSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PgYSZT8AAB48SURBVHja7N0JtLVT/QfwB29JZChlKEOGDEWFJk1CIg1CNIoGoWklUpqUylSIUitpJEKFoiiNUiqiiUZSaaCBSmnyfz+7//eu3dNzzj3n3HPvOzh7rbPOvec8z3728P3Nv98+S9x6661Nj3bt/NfyzWLa/vWvfzVLLbVUU89/iSWWGLk//fz1r39t7njHO/7Pd//+97+bJZdcsvO+v/3tb83tb3/7//n+lltuKZ8Z5x3ucIe+z677/8c//tHc7na3axbjdtP815q9vlyiD6Bv7fPd2BoQzcVz8qyf//znzU033VQAADR//vOfm4c97GEFFF/5ylfK9/PmzSvX3ulOd2oe/ehHF+D/+Mc/bj7xiU80yy67bPOHP/yh2WeffZoVVlhhqu/PfvazzRVXXNG88IUvbJZeeuny2d///vfmq1/9avPIRz6yOfvss5t73/vezXrrrVfmG+I59dRTm4c+9KHNmmv+Z49+/etfN+eff36z0korNcsss0xz8803N7/5zW+apzzlKc3vfve78gz/X3fddeU+Y91qq62aP/3pT80vf/nL5tvf/nZ57mabbVbGt8Yaa8zp+s72s/5/3XpynnnTUMIiz6HbXPfiiy8uoFl99dULWG688cbmnve8Z3P3u9+9+cIXvlCA/dvf/rb8//vf/76A8YYbbmi+//3vl75+8pOfNPe4xz2ab3zjG8397ne/0uc555xTNhJgjz322OaBD3xgIRLAvPDCCwuX/d73vtf86Ec/ah7xiEeU7z0LUf3whz9sll9++fIdgBoPIttiiy2aH/zgB81GG23U/OpXv2p+8YtfNKuttloB9VVXXVX6NAbjC3e+5JJLyrwQ7Be/+MVmt912W+T3roNAbup3z5ILetCzTdH6r59BJAOD9+WWW6755z//WQCg4XRUBtwSlwU+XBKnJvZxTeC7y13uUvp0LaBTGVZdddUCNGDFwakSf/nLXwroP/jBDzY77rhj86hHPaoAWLvsssua+9///s3GG29cnksyeOl/7bXXLoR10UUXlWvXWWedMmbPv9vd7tZsueWWhWDWXXfdKfXCvfe6172KNDE3xIUgces2Uft/JurVbOzluMazZLMYta6Nyv9ZbJxv2223LWDAeTfddNPCBf0dIO6+++4FyMT7Nddc06y44ooFMAAGJJ/73OfKO0ADPTWCuAdqIH7wgx9ciCBg22uvvco4SAfg1Hx/7rnnNt/61reaj3/84+W5wIrAjJVq47mAj0NHj7766qundGz9//GPfyz/r7XWWkUVwemBn4qUMbSB1ibyuQDaKKrKKASy5MIwoXFRdddGtf8nsq+88sqy6QCMu9I/cemVV165qB/E9oYbblg4JYBpG2ywwRR3xCldG46PqwLY9ddfX9SY2vAERN/pj0T42c9+Vr572tOeVogLtycR6Mh0XmP57ne/W0B83/vetxAWrm6c7vU/jv74xz++efjDH95st912UwTi+3B4BBjuPFNjd1yY6HXfOKX0vEXBWBgnBeOmgAw8z3jGMwpw/I9z0lMBLCAHGlwS2OnVu+yySzG2qAk//elPC3h5Nui8OD3uyQjD7REFQALj+uuvX4w3z4zxhwMbi+e6LgYmQkE8OCspQj8mCXx+6aWXFoK6613v2jk3zwyR+Rv4Z0OtG6S/rj0bdhyj4Kafl+PG+d8tPxcW7Vx7Onq58XgO4hWgAgChFw6LU+OwdevnIqs9GZr7/V+7CuPqw8Vj2HVJnVpt6rdWODLiDMHg2nMBorlkhPM/Y/CsMHZAzxaIR13QYe6rr22DZbq/26BrA7fr+i5dvtfnGVsXiHv10U8Fm819WxDgnw7Q8xYU9fVaiFEXaJj76muH/XuU/4eZb829+322IDxG063LwtDmLaoG4aRN2mLvtpu0SZsAeg5E9MIomieAnrSRwFz7gSfAngB6kW6ALNL4ne98Z7IYE0Av+o1PeNdddy0vWXcLwsi+rak8E0DPYnvve99bEoZEEd///vcvUEkxAfSk9eR4g3ymiQIedthhzX777VdC53PRPvOZzzR77LFHkQqf/vSnb3Ou1wmgRzDyBuWAD3jAA0p+s4So5FXMdpMEJc+E3v7lL395okNPWn9AS0SS8vnGN76xVK2oROnVpKlKJ33nO9/Z3PnOd56TMcpFkQstB0WS022tzVvYATRuPbAXlx1UFz3yyCObj3zkI6UAQEKRHGfZb7Lg2k0ikkw7udKbbLLJ/8xrnHNKf5/85CfLmORmKyqY6ZzHqZrNhU4/Vg4to4xln0qJcRgz466umElf7pVyuvfeexeOK/cYaJU+9WqqVWS9SRONYTgbc0p/J510UgHTy172sqnKmtkGczwppFFNXPW4ZmMvZ51DG+yrXvWqUpak/k1Orjxeet1jH/vYqeLRQRvO9qEPfaiUKilfkqc8jqZSRCqoerxhORivBbCo/3v5y19e7jXOrj5UjfB0vO1tb2u22Wab5tBDD22e+cxnNs9+9rPLfMYNqte97nXNtddeW/T1rHU7U2+2vCikwqtf/eqi8iBe73LHqT9SbOWKn3HGGaWoQZlaOxW3bmolqXXPe97zOrMe5wzQuFW4tBxiye3e6XMPechDihgcpunnlFNOKZXR9EEA3GGHHabKmEZpn/rUp5pXvOIVRV0Arv3337/83UsN6LWQyqwe9KAHNRdccEEpDKivkSfNEDz66KPL5ypZ6NrWQTXKS1/60mIwPvGJT2we85jHjOXYAUSjlEs1jfaa17ymvCOkuVA35JOTzIxglefWjZRGZEralIe9733vK3upKgiw1UWquqnHpw/3qL5R6vac5zynVN4PSph986GbEaq+USnQrLLKKqXQU/UGTvbkJz956IW1OLiZxQASC6R6A9UT4z4bhHvUc1T1gdMjPq401SKHHHJIqQ7pWjCfqUz52Mc+VhaZoQfM2hFHHNF8+MMfLnqyTTMe4CahjJkBaZzWwHcATXL5G1entqgMH1ZydTXPVyWuttBz1RpiLogKqGe7ma+9onbYI8/HhF7/+teXKh0cGscFfEyOS9Papv7S3toX60fKIEwFFzC00047NS94wQuKrTL/npvm79Hc5UMbvEEEDLgflaMfmHsdxJKKEf1QXZRCOUIAZ0vFdj+q9bnrLKAF05fFQ/n0S7V3uIl6PmdudEkQfdiMo446qjzrvPPOK5KClFBEqx/lWm9+85un5qwChdj3MmabqB/vav3M1ctmIqyZNno6IrL2J5xwQimsxeXMFzPhC0/t4WyqHXU1DiaghC0lZ+ox7WHAai0AVX1k7C19APGJJ55Y9ixHSVBVGLgAPR1THDugLWLbALPh/cR4r1OFAAK1m7yG89CnY72P0qhBFjuiGfjodF0nHqWp/SMVcGilTc7aQAA2EFEYH25rE1IbiAvjQji/jaBWeCa7wrU2OscOzKR9/etfL8SmHX744QUEXgiXagUsr3zlK8t4ZrJu0zV7ZS0BsL2v1se6eYUJKXHDnKiidZP7Qn0KI3Kv/6loGN90huXAgCZCOOyV/PcLEtQbFGptb5oB4Vz0V1T7/Oc/v+hV/Vw/IQIibdDGKBOl41KjVoS4siB0Wwt1/PHH99WXbRQDx7kbODJVCDiISG4y7zgQvRDXtvCKbw888MDm6U9/+lCgHcaAEzw54IADyqa/6EUv+i/XIM6HM1tj4wNq4H7Sk540Y1de170IyF6SZr5HwD477bTTih3EblBwnLUA9jaj06hNwO5ae011pWcP6h0aGNBO/gE8XMXmeohXm7uaRO3KsbldOiJu8rWvfa3c/6UvfalsyFOf+tT/9inO/65dVIoDUhOcPGSy+Z66AHg21wYSXTgXPZkhwhgjmi1UFsYGRyT2cull86gZNgch4nYHHXRQ4bRUCFzJ/8LONgkXYswIQfdrCMq9gIBQhvFKuNexY/Rz6sS+++5bPpcEZc15YXhSXPPud7+7uBgRtTnTt2cC5tgV1lq/adY935NKvEn2yhwRFPvB+vdrmEbWIXtpPWForF4OHQKMDcSpWe30SAP3YJOgbvBM4FbhzDb9mGOOKUCPyECBJsqAAVr30EH1TeerAWZCuU+jGngWPRhX973nf/Ob3yxgMwaAkxCES0XXRvldIej6HI1+fmsqB6KhA9qcRP74loGY7mpNiFWcEnHSt3FR880ZGbEr/G/z3GuM+nNoDb0zZ370ajgXjkdqUsEYfhpXFyOMBAFaz7Xu+vZsz7XO9mzrrbcemVPrh/r3kpe8ZMq+8U4qIUzf49AO5rEXsGO+5mp9okJiToxiBrfxwAEiyDENrrOf0x1WORKgUZZXjB7gwCHpQDECPfzyyy8vmx4Am4hzLIAvXgmg9L/kmfRrk+io9QK7P6dw5nPWNM/EWWed9V/jY2EjEhzD2Kga3Gpd1vggKZXtjbYRuDDJ4pCYAMhJRd6576yHewDquc99brHYA+CuSm59Ikgb6Vr+V1ILR+3VEOCLX/ziMlc6uc1nRLkP0Vpb+/OBD3xgimsal3WMBOVHp1+PwqlzvT4FmBzaE+JmV+DG5kUyPuEJTyhMBTCtAbedMdZ2BuK3fm94wxsKfvRrzGF8mMgwKtvAgEZxHgJkXgweA+bGahsH3HZRPVCl64C6bTx+9KMfLQDUF2OJZd4+EiDnWUwXTo1EyKsX560jV4NsHLABaCxxHAigjJka493axENivAjTu020VvVRBOFeXkDWjq5l3Xo1OjFpBLTASwI4mBEXBJRsfiSR50VyMW55QzwDpwY6qt6oDVcNp9dCVABtXZzrx9ecxk/u8wDa3O074qL6SSuIwUgC+Lutho4N0NmYWuzkkMO277gGiwWuLd/6umyizY+rqw2qOujRb2xtv/MooXd6N68BO4E6IPrFK2KBjRGRUA9yEilwA4fv3Wuj/M//Cmw2ixfE3BCucerHdbgrQCGYbCIVjGHZpQZYQzqwMDuJBiiy6eyBa3E7AIkUDTHxd3snsQSSxAkQAM4uTB71JXbOTPJMjKGWRkBZN3vi+/Rd21+MbCe3mqc1Mw8Ap9YOoxbNG0Xc9Ou8ywXXK+WynlhOBO333F5cul6kXBM9FFfg7xwk7ZOBJXQfvbxWfeI7BjygxpEdy+saBMAwY6gRmYJIuK/vvRIxNY5RGinHuKNm4LQCFHJKGNOO9zUWBOJZ73jHO6bATMfm4XnWs55VXJMaKUhPp5YhOIEhXJ7UoaKNM6oYg5FtlHzwGPHGh5OnIXISG+i9f/7zny92ks9jMM9aLsegB58M0kf+ThBluharF/jagZBwZxzRgvFfMtZ4OeRR4Jz9iIMh+bjHPa4sJh8ptYB+SGePnxlYGGLHHXdcGctb3/rW8ix2Az0aIQA23RKQjTNq2tvf/vbCdXiJBtXf9cFQBgpg4DkBZo0R6aUx1OmwmEKMaZ4PtkXdL4DQuYl5LjbckJrAwGP4CjMjAvPvFR/ox8xiwCcKylB2kDx9PQZjpJvvSSifIUZqhzVmTCJi7lR7x3YZNDA0bxju3A4jzzRzrV7ouOima3HNHXzwwUVtsQkWEcch7vVh0wCZyGN0UB+48N7znveU+/sdYcXo01c4cpebyaLjajguN9mZZ55ZAEzNoDYxcsLhEUUMHaDDdaYDdNYGgQivE8OIGHjp0HWz+dyRooPmlNA6FcK8ERydHvflE9cQNgMNp+erl0hE8jDo9YPb+4zrj41U5860VRJ9IwzvDNuoPN65VpP5R0okwBMPBhWL+qOJ/uLOCUjZS+OwF/R8khMxT6d+DAxoA2iL4a7NBqZ4Ebzc0+WGcl3bYBqE46Ncm4VrAVXC6oIIuGEc9k6vF1qmK3q+RQoY8xzXttUcfU3nNrPx7uWlkRsdvTHWPO4mYIPjELunn356GVs4fq+GSyEKHB5nInrjugJGnCqgIhFIHQaiZxpzXJxxXeKM9H5gNf8AOl4roBZboMqQdlQQ93nh2sCNWAAfIGsgAysOithyRrW1TmSXikGSAaJcl3bEGDOSaHaf+9ynzDP9mzs1EePJT4PwiCGwQZjowIC2KCYal4oFIU5wAd/FV41TBegWGpXx1YYLRBwK1PgunL9Lh46o7mqA7FV7V3K/exhXDDygExRJkCMiOQZngD5suDlGp03EaWwOA43P3SbKD0nz+yu4s+f1yzgUUn/LW95S5mLDbajQOaMtqkU2VRUMr0KO0LV+9Q8QJSc9AOfhaKs1bAGGoWfyBbsWYcRANzdgJd0ATVQyDTe21+YTd2X2Ud/ASzUKmKM/13aY9YIB3iKShqFrrRiqGIF3Y4KfQTM1BwZ0jpSNJyKpoiYc0FnQcKlarPu8vg7XiFsrwNd/CKO2mmMZ91NzAvwsqvtwCqKVzmrB/A6KJJcYGJEM8c8O00LcNgB4BZL0R2J4tza4I0AwGKk+uLN7akOo3eiv8r+BZ/PNNy+RPj7vdqTV2iGQcLTkPwNijugVHwAmgKEnsw9qcZ139/B8cL8lyYk0yXeAZczGRd81Z/1xxQpphyHgyBiZdY+rtdfa1jYYdQbB4fb6pmJkfJ5H5Rkm7XhgQNehbADzYAYUzlQ3AQ/uLgkyyZHlgJcDUjc5EMDguvTX5pYRfzWgBz2BU1901fyaVCKcSUqK3p6o1TAt6Y6CJ7iT+b7rXe8qm4pjAoZnMSZxNwTseYDf5pR18z2iA1Jittcxvp7NU+EaIhsYzYuKwNizZjwtJFjm22vtAnKGoBeJS3p6p18zSnFKa2VvqU84pv0EQOkAiIkOzHUZWyJSo5cjIPMwB2oYFcca4vwx6r0UhsyKH9rgEqzwdy8/b/TYcF7U1+WHpgOiZOFS7zhSW3f1nH6/8dfPeCXyiF8BHRuNW9Ft6b9d/uthGo6BazEy83NwGvAAu7kBOt+qyKT5u47dwGibjljq4EqXEQQwfMp19JAezMthvZO34XP3+o2X/M7LdK7LWpWz/qQbPR1QSSbEw1jUFCcIVQvSiAhKxiKNAuhev3eTdyqHPfI8+0IK5NcKrBupkqqisQPag20iasLxJCZ1PWxQVx7KJG4MmvEmCb2dwtllKHbF9eORiJFZE4GF5okIt0q0cyYZZ8YQtSJ5u8QtvReX5i4DIGoGr4aN86xRXGHTjY+oZtwBrz3KjyEZozWW/ccLw+ga9tnmSMp4de2zvcOxzStGXx0T6MqMrPc0Epl6xC6hDmZ/rCvDftgxDwxo7jGDB+oUh3aBYhCAuIeq0lZXegVMsgBEW4yR+KMDZB4Ci0B1yc9LiKoRY4AlE44RlJ9zqwM6wzbPIqEYgwIS9DwqBi+CMVA7UlaVAlpjpB6Ms5188skF0EAs8EJNEChBxPRi38kP4XEZFhiDEJo9CJi79j7R4OkIlK2g9tLeIES6M/uHWjUs4xkql6Me/Ex80YPe03YVEsW4HZcdgqp/JRWXjMXvem4lhijDjJi3uDweCDKuRX3EwBumrg+3BxBcEajp53RJG4zYZbwh/te+9rVTv3mC+9SeinE0TIZrEPFSrcw1HgH+XWOgl3O7LYhWc2jrjdi79p4koZ4Zr70CavvMJTpsAtXYK1bGUVKUZlL58R4LQhelw0lY8RybFQ7bVlfisrI4+dk2BMFNRVdLLnXKswYBtAACwNITo/pwz9UuPP1RPxhWom+kgbHjzl1FDPGaDJMimcbPy4hE4II8GA6Ac/8xTKl0UksR+0xUrGHU0lpFrKUfaWqeXQUg4ebx5ye5SWyBG09ueeo4p41WjntStaeiDpyM0kwSF4z/Msk93Ea4MxUEkLvKpyxuQALINhUY6f9xLUafm258CIK3gnFpUzzPe1JocRfcN782q3+cBvBjEHdVqiMQqgHRSqKMkjbgeQgn9Yta3F1clbwqWbfZrv5O8Gg6qZy/k+rAeyJDM/kn5mdvraGiZpFCPu0Y33PKoXkt2mHtUfTUuO1qf3UvQ7EX92m7u1KlUidFxTXYr7HegU/ugUa12X777cvic93x0HgWd5sNzZECuGVcdrW9QBSL+lELEGuCB3TfQVU2/fIwMKaoPKSDtUqFEEKTjWc/eCrMESev3XgzbfRec8A989POvdyEiSgG8L7DmKhL3Lc+FxrnJiR14s61hrxGmEnUtzkFdM2hbRYwM+RGabVR6MXDwvCRDB4QDiMBcG2+1YSf89PCXETJ0e1Se0Tkcs5FAMUtxnuS8+N8lkodqZrAZIMBDHepz5lLcg4gABw1hTeCR6TOL+7VEKXoIf+3OVBrSKFIHXPhwqODxo0J7MCjeGAcxyZo8mQAUN4MbkvlqdOMaywE0J7tGvMnQewl/Z+kijcFp7cWwJwqGJHRfj78WdWh6+JYfwPMKC1h1ISpUSh/suhZqocH4Wa5zqLLkUAU1AZ9WryuYs00/l3jqEO41A2pmz5rnwCUAArg7LnnnmWT6rKy6PsMR43hCHw2GRcaBNDGhDMn6anNDY2XHk/FSgDJ2okCUuNCeDNtvCdeAlhvetObyp6kuAKR1vWaca3GGPdOhWCwYgB1kxdtzQTf3GMtBwHz2AFtkMkRJn5xEovLGh+loeoYhqleIeprcI3iQwbgqDMA12+xAB5owtUBgitQlLSXkQecXGk2pFcFimvojvKZEYUxDWoYkhhAY7PrhKQUNuDaWft6b8x1HKc0tdW8nXfeuaTGksTGhAtjOnU+SwoQzBGn9rfc7FzTlrRSFqw5W6nLDz5nHJp+yU/M6U4ECb7wM45iHBJF9Er3mhgRPdMz4bjcLBDACd/yDvQ7Z423AqczFyLU730LAvUi0rpwoZcaE46FWPVPX0xQYpCWcwKJeyLZ3zGezQWYjTnnC+Z3w6kIyfcYh4FYG3f84CKK1hbHbqc6ACfVAYPg6mQI14DvGo8w/tBjGvdRYDYdd67FzSguo37Xj9v91C+8LkWTBY4r0/eAhcEXsTmTcbhfzgWpxiPCwASMYQ3nZA0CLnAP61ef7ZZ1wsFxZ0xlkGKOXt7cZi5/Gpn7qA3mUQIwcwXm6Ji9Gu8BlUeCFTHpaIL4Umc6jpRv8aAkb2XYFuDWUqYLzHN1RnS/Qy9Jua7g3DjbIneC/7g3Zbr+gJiuTT2QU51E83E1qoBnEMej2hoLYt36PacrKWmunj+vmbS+LUcYcNul4mMc3C6cjHFJh1YixYe7IE7bX5za2HXoxaUFWAwdjn2W/KQtFK2vDj0B9BCG6YR7LvyAnvwK1hB65wTMC3+bAHoWLPxRrx+1gmbSFkOjkPEmY43bUNiVc587TO6GYAg/rRBzPAk+F7Z1hoYQsoCN7DlnYbhX7oWDGLnpZHv1c+3J2aBrC2LwwQsqcV2qk/N/gh4CMoJO8jykfnq+7zwjh7OoeFHi1OXeYpzKz+BKFDE1ZzkPMvk8R3hbyJvbzjUy1YzFXOVI+zzV4QIgjgnjA+dhkWC12HPo+nyNhfGVxlkvdzanGgkscLNJxgFy4Wf5CxL8k0opLA2A7pU3AMg2NmF2jTGoslkSUNd6aCpVHE4DMJ6dqhjJRipKhOl97pgAWWSidwGwJnIHeF4ISYRPSNjY62dqAMnFJ4ImsUck0v/6FHGULIUY1OT5Tq6EWj3AdUSY+SEgRO8sDHnhoq8h1roae2Hf88Va5ZDWiVsJp+JMPBJCrylaxRGlOQKdsCuOjKv5TqUzQMoYc53kIEDHDXF11czA39ah87ezSYBHXZxoHwmgf8fZArO/jUlEENGIkLkmCULAlJ+t0I80UwnuopNdOj33nqR9CfyS39V26kuARt8kBWLA4UmWnPCU35chBYzVc0TuMII6TD2T490WSx263w/4zJbOiiPl9J5aPOPGuBHwAk04kc1N4o4EKKqAbDGbi6viktQIIlziPlWkVwosMOUgQv07jAVHl7gk8aiWIsaZ3w5JUUJ+sLJurkV4XS1VO5J3nK+nAkfLafc5Zcj8VckAsVC9NXCsWLLz+L5lHhpLDpDpFwAZV6R3kTUKeyXbzwaoAdIZEYpC6Ys2CmcCDC+bB0yASYd1jb+pFPRcXA3XpHrQKX0nE47+iQMiAEcW1MUBmY/fLJGorjhVghEp4Hmiijg8sQ/YnuXgRD+K4xmKV3Fs0iU/wybZCEDNJedu1+sIfDllCEAFexATkLvX+FxDDXKdJnAj3VSSV33AJZCzH1TbpBaz3z4Nmqq7oF2c/fzQty4K4qfOxQDiFBXgcDgskNl8G43LEudJRaW/AhNDKnV3rnMPADLsXO8+ujUVItlq7U2kA/sOYPITEPqSe01K0HNxS4aqz3MoYQCWgwqNn/rQBSJjAFyqVPJlYi/ktCM6ss8kAJE09Umt8tKpQPr1Gd1aMhOVYxx73e8QzDEzyiVGAfS1zW08sDJpC2UTWFmz15f/J8AANs/eNuaSF1MAAAAASUVORK5CYII="

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b9084e864474deed1f253d8726740032.png";

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "593dbee4c400d29b503d1e82980939d0.png";

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1643e189871f3b3f5605880b607e2715.png";

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "dec845c80873c3cdcbde65df66792060.png";

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "97fc2bb1e4bf6327494ab48fbb0fe43e.png";

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7745950a0bccc270efc0dab9542dee49.png";

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ce4244ddeda488941626d32f10b7c40e.png";

/***/ }),
/* 275 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "330faf0f676f455dcb70e30811095986.png";

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "efef392757f81a74cc0be1432f0a752d.png";

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f55c3f2a62fdb6e4ceeb0032f4afc37e.png";

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "5f4e16e9ef6aa18c55fa50faf4810577.png";

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "15cdae11d8f9fa7dbd6e0b1f2ab93fe1.png";

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3830463124082e645a64a01018f4ff25.png";

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ad59a1f08e3fdd5ccc7dbed1e323244d.png";

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "afb6ff5dbd1de25b9a6483c15a0e37a5.png";

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c30c1395f5bfa52794b108c6bf133701.png";

/***/ }),
/* 285 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 286 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "49b46280a9dace7df276061eea2a61e5.png";

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "699b5e4d436ed32f5ca6e2971c9aaf17.png";

/***/ }),
/* 289 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 290 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 291 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a86ae8598d0dc384b34a24fbf2157f12.png";

/***/ }),
/* 293 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4f82ea102ab496e53e6148d65423a8b4.png";

/***/ }),
/* 295 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 296 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6cf6010233adeaa060196e754e464cac.png";

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "83239c64d8465cf22350b1555bd17884.png";

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d8983140f8623af0d6a739386c9d01e9.png";

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "80000fe3f70b3059a202c0c3926ea953.png";

/***/ }),
/* 301 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "098cbc10a31f1efe53ede4629778685b.jpg";

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8875bbbf4710928fcb9a3a1ed24351ed.png";

/***/ }),
/* 304 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 305 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 306 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 307 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 308 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 309 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,iVBORw0KGgoAAAANSUhEUgAAALQAAABCCAYAAAD+Bvw2AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA2xpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQwIDc5LjE2MDQ1MSwgMjAxNy8wNS8wNi0wMTowODoyMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpCQjI2RDc1OTNFRDcxMUU4OTdGM0NFQzJBM0RFQjlEQSIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpCQTY2NkJDQzFENDUxMUU5OTlFQjlDRkQwNDA4MkRERiIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpCQTY2NkJDQjFENDUxMUU5OTlFQjlDRkQwNDA4MkRERiIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ0MgMjAxOCAoTWFjaW50b3NoKSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjQ2NzJCOTg4MUEyQTExRTk5OUVCOUNGRDA0MDgyRERGIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjQ2NzJCOTg5MUEyQTExRTk5OUVCOUNGRDA0MDgyRERGIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+RBFgYAAAEZBJREFUeNrsXQmQVcUV/SyyCIioCAioSCmRoIKJYqISS5OgYNzXGDWlEXcRNUrcCFiuAZeoiCRaYkxCBKKgFiiKAi4pteIIyiIQlUUUAWEEYRhgcs7Meabp9O33x8pQ/Ni3quv28t77/bpv375bv1+vqqqqkCDB/wvUT0OQIBF0ggSJoBMkSASdIEEi6ASJoBMkSASdIEEi6AQJEkEnSJAIOkEi6AQJEkEnSJAIOkGCRNAJEiSCTvBtgoZ18dDevXsX6tWrV51nvHWWBzRA6om67wN/D/UtgL9A+T3kZyP/PtInSJuyG7z7twA3lpvXZOUsb9V17dp1i2eGnu/e776L/3t+m1/vv4N7ndO+C8qbkV1ZTHx6qD/We1jvFHqWP16hcfZ/z7rPH7/QGAwbNqw0CNonFr1McxTPQToDiQTdFPWLgd9DWofUGOWmuI7lD5E2WkSZ5d0BihFUbFJiC8XF2e/5z4m15f2u7m2AdCXyjVE1BOnLvIUWG+8QQeYtwtC9oTE0mFR03i3mUFIcOjAwJwAPBe6s+tEo3wNchuIG554mwM0zUShEJFldjDsVOxGhZ2XtFrcK9csl6lC7xbUFXNgD0LY98l8hDbIIIUZkoffziTf2HiECrA2Rx+b/mzKWbUqGdgagP4pPkZhR3ox0AdKZKL8JvMG9Hmk90vKMyGOE7BJQHofNq8ue5U+az3l9Ig0RsLVAfMJ3CGYN0F26pGPommII0h8jpz+c4/bFimvWWMeI2B8ff2xCi76kCNoZoJOQ7nUGZzDa/pjDsaKD5xOZL3r43MQawABhFbPTRCfbWgwWx3L6MBj1E5AW+mKUNU6x3/d2oZtRPx/Zh5F2EXGfhrSn0ReTuI0FE5PruyGdhbaGefO6TRO0Xr4tsiOcCZkJfJs/SaHBiYkWFleJKUshjm5xbH8C/WvzCN+S9a2t2XneEqSyPL0kpIh5z+ngEXZD4CbA/VC/AJh6y98oBhr9CC2K4DuFRBqvXz9AegLZyajfaWscyK5Ls93VeInWzqAMxwtttDhuHjeNbY2WCGEpcDGlzyK4WD/9hWL9TqCf2wG1UPkxpBORH2wpvTmcnhakB1A/D/hZ4Ja6h6aESUgUbSjSjQa+CWmUJT5Y72DtqCGCFzyOPPtzBNp2teZxm1cKATshnet0eiXSWEv2cuqrX5xNqi/jBCF1kmXEvZec53VkuyDfGvkq55mVKD+NVBlaAPXr149aCGqq61VZ4lBIabNElBhBoHw70jnIzwHuBNxBVo6hyH8Z240C8ml9pC5SrPsi/xfgE2UWPQZlcu7G4tKERkj7oXw8lVG0L0CeO8THMTNf4LfbI98N+PnAQqsAGog6Ltw5JWvlQKcPBmrtvPQMKnuh7d0hhO8gvext+S+irg/wWOADvd9YLZn87sDzyKnG+ooJoXnz5tUEvXnzZot7XwF8CaqeR/5Kn7BDiqJPwJZS6HDlSl33FncyjpVz/3gSdUhBtWRn5Tehrdz5qaNQ31K2/1ORLqQ4grrPgWeI0JuhTFHnZOS7I78OmON5Y8wM6PS1OfBELgxgPn9kQOz7u7Mof8SFBDy5rgi7rjh0D4/IFsRMYaq/kcRDjgG8C/Cj4sINgQcB/xiX0mLyOsp3oPyRbLe0a98rmf3XsmE/l3F5tx8k4s6dOxc2btxoKSY7SUHbkZwfaQzyrxZjkoqVvUkeJcXsJMmyFahvBXwa8NEy3f0K+dWSfWmjH2spYM7v7IX88U7dL+vVXDhDO1hWT076c+BNzqI5FukZmhCBbwB+DfUTLceMkx8AvJ+e81PgkYYotxvyt2nXpmg1uaREDnT2ux7BrLS2bg0GufNZwE8CPwN8hC6Zjfw6XPMs8jeISK9DetW5l162NpqooSHNnEBi7t69e2HTpk0xD9qVKO7oEMktUtR2R/oM6UG0vR+yPsRkfo/TtkO5F/sKfB7S0+rDAUBHo74fFThvAXHHeCgkAjl9b0VurN8pk6z8E3J/7769gS+ViXAZPbPyCbjX9EWaGFLOvV2qW/ZoDrFBDr9AGs7NEff8BvieUhQ5WuXZPT3gFldFmVLlK4TH6D5ylEPQ/hKJ2Rno7YB/B0xmNCRmdenRo8cWxOxxVBLT2UgDvPojlLJ7jkJbD+CvYkqapZwq30CYvzcQ+c9022G+uOIQa6eQbG4RG5VDPeLwgGLK/vdw+vShxJ5rkPbXNeNj4pPquMgPV9MEtC1EPcWLx6S7dAY+WXoRuTLn9oOYXL4tc2h/tbaKeNy6Ap8uTZz20muozKBuOvBUKjvA1+reId79tKd2A55AUcTilBZnFhyM66ZJfIm6iIH30SQ+b3naLCVR5dZSxFjkFrzCuWdKoSa+xR/LCm7lIcL1cDtdw+un6Lq2eR4/5PtT3AAew3mQrjM59n7ZAnR+8yHkF8vze6I3Dg8iXVaXRLw1ZOhPPeLYwxjUetrW2Y9jkFbLszVbHIyexYvEQamkTXN+YwekYXruXdb236ZNm2qZORJ7cBxSY8tF7CtmKFdasSKWrdhpo6ixI8p3In+z84zWktlDHHGIFnrUFEnzn6rmUo9Q/ZyIuW0pEvvxjJ69Hm2jYs4Vbw7ncixkiZqKRJPgAcCnyBS5UYRM60qLghOjUpeOlboi6NneQHSRgrPeeyHGL3Cr+gOrZBefhTaWyzUZG4BvzQbbmRh6vf7MyUP9a5aLOMTNPIL4E9DlaNshZFVwrntRcuwUw8Vvutadfhyl4nKvb3drYfnPHSFOnmtGcywcVKhPw3XjJBYUFGJQXwo2n0FRjrLthmIWZuBd+wA/gipabB7QYmDbLC5A57pTZRYcIZFuc8wrvC3L0LM8wt1dMvAr3uSvzeTWiEb9qLGl/wv5qwNK1xbXLVu2rNC2bdv/kp+dgZ2rHaGnMakzxGmmF+MhNWzEWXU74Qrv1g6B+15A/uKQAmoQdUbQu6GdO+StEid47f0oH+lYn1YA0SS5J3AzLlIyjJic7owHbdm0ZtCq9DHyn1n2fIYFA3WWq5160YpSjbabCbRWg5UBTUqvhExOedFZPte07rMcGWVlZdVytG97doBxDj0DNl8qoVRsVsdc6yFbscG1OR7z3EUqWBVYFAfJITLRcuR4Y1Sp4u2yDF3ntPVTFGPWz4u8Z1KPGBUTB5zfvl9mR1pKdlayODl1jWORH+7ZyOuMS9dVcBKN9VO9gTnJI/Bau6pDDo68iDTWNWjQoFqOjjg/1nmvQHZ+rcxXq61FFDOjGTJ7Q5kg1zrPayKRzL+PivTpebZtB/5JhRPperQ18hZUi3o1Rn7LwznJiqcRbikrDAPLLkCiCDGcMjNSrwjXbcvdAO23OAuuTkWOugxOGutxV8pz51ur2SdS6yRFiLitAXLvmTVrVjVhGyGcu/u0R6uHXLeHFmriLCbJhkp7anuJKCSgZqFFEiJ+WTJGeuIDOd6+RlzJolAQl6HcrtcWX5DFZ4xzPUWEJ5V/H9ff4fTtOaRBlv5By4yU8eloO5P6jOzimah0aMSCtQZ4V2CKdY/wkEfJxkOj41RKlngTNTAz9FtKlEEIZgyDW+dsdU1qqraUO5cvXx4MgZTtdIbTh/qyvtCZ8wI9XEi9KXdSaUX7bFz/D3rhpO3/nrEYRcT7Uv6s8PreMLTTUDZF3WNGSKgpuytfJSfGRt37Mu33yjP25RI9Z7hEwXJrTKlkkiiBf6udJPMZVMdZMzYkEjvNkFjufoztOU/yfWkSNDperq3JJcB2vqcoFqQfm0wrjFMEu7+8h1/XU35eunRpMPgcQI9ZX1xHE9ZXcjZQ9hunmJHs2STiFYX/RMgVJE9ejvQ26o7LieM4COk+r9uMfJsb2KVWSJEeQscEUseQTdkKpqdnU8phQUrcnfqNhjJ5cme4lC7w2FzorGcXhQQsduZmB4lF21u7Iu75glYqzQkVmLMV2tC1pAja4YL3uVxaL8qA72t9ZS4WyB/i4r544ok3dO/uGSL4efPmWQcCFst0trfiExgPMoeEjTRNjh4GSvUWUfuLiHEgY1B1SCg8ldxZZrRO7vsVauKTSbgzvXfkpD8BfJN2iJ4hxdNSoAFraB/WPbQDN3XaFiB/RezwrhdrXR5gINuJUx9IDm5YOdZmYQ/i6IzXeRr17wKfUVIcWsCosesDHJky3Cl+gHrIBhxS/nyxIXBggFyzpX8/2yoqKvKOFvHU+Vqnb1S2fqT4C0aoLdOxstAENkLbI671yPkNmq72pdHF7zvSKqSP8kIEipU/XdNmSAGn+RDlg32ZPXZoNuDGX6FQVFo5BhgcngQ9NfA82sN/WIoEzZd4HGict4JZYPD30cWIHjHXbUiB5JZGpd4n/Kw8f/78r2OiYwcOIsRCh84g/x4uYL3vZo8A9tBpnZWKOvOfeQajCa1QUYpEqHvDeucIIc40ZGyKCTv7u2BIQY/Y2ClCMNZ5GS0ZkYMQozO9wetbWUkStDrfL/MeOgPC085PUSnxubR1aiLk+QvU87mHoerzkNztcumQaBCyYxtnD4foGBOtCe9QLKHIgro75bJ3358OoA7+OKiN9mHGOzSNLCwGQ7WPneULmfV0KDm04GdkjqKQ0ybm8fTaaflhfMtQX6lX+pnCgt04GYYODJKHtmQcKz7RrZSDYppcs1k9rRHjUKYnboRPxJYIYrmzVT5cysqC2OnrRYsWFTp27FiUU8eadMB4pUJE0WUcy4UKO53o/xZjIID4oZ1ezr1VCgXIfpv6wFPUCzJ7bk7gUAb0ppYr8IoExLHpIgfXGt3fXtx2aY5Mbi2k1cZ3U6iLTBABM3jsVelTXPyzSy2WIzSxfIk+hZo4252dF+eJioekGPVnYLvlRMg7Ga72QXJll1uESVxeXr7FyZWYLbuYLyhFYkYYdMXjTjdnYade3xnEw8B3KpQ9pFgy3vsBrw+MgKs0rAmWqPYOcBe5q3m0iockeFqEXr7dZOeme30KcN9YaGpsJzC8te11moUnWRbFwgS2eYK2goMAb0lWHE9nhjcR54qDDHSdArX5UArFACkb/a1+uOX169cXGjVqZH6ZKfRbof5YdRIzBqttoeUm5+kbOijksGGw1T6Sw+urnad3+lsiQszLB/jUmYMsOIxM5BTn2pHWucG875lYug4wA8b6hAi+5OzQllcvO02BehLuG4HAm73o0ZK56WQ5SApFBIUz9HI0rrlJAfOPx8xRWX7JkiXRL//4MmEeJw/kuUjplJjIUE7rFLcwowo/VPkDXMvA+KsYZwF8PkUE62R6LWJdyPl5vIvixReFmkhHnpwZ75s/Y581iHFpByqt3bHkou1CROgRFLnVkXSjIn9VYFIoT/YSt5pEDZ82YeBPFHjTVI4GnrDgYVA6NJroXp4/XGXJ3G7f1qxZE+UYeUHpkbhoKnhnS/x5j6GaJMhiOL7ze9OVogQc+2xC6AM5dEEj/VViEL14Ff5zi/k2YEwUi7xTrvi4zYscESLn9sejP4wluDVzSHiDwaP9F1POcxSoSh29ahL4rXuRHs4bLN96YTlwYsHuxnnB7NpG2m5fkgy50tqq84gj77Nmse/4WQuPsnyh5jBudEfNi42OLfrYjlZywUnFvoAGZYq+sHMm8m/GtnERcQtZR9ytm67rSzMD/zfpW96XPmMfYwwQPBXbE6QQLrQ+D5bHvUKiROwrTNZisH4/8kmEoNgVEi3yFHXrpFDJfQosdsTfWPGj5d49SEeU3hUnsSaFYYkMHLpMsQHDi/1aaLG7TGzirMjAkC099j2S2nwK1+KiIfHOitGOKKYxvScoQkTMmcGxKuUzhUHuYikJ3kC8jfLbhZqQR8ZU7MWgJuBmCnBZxQOZhZpA+Xfkjq41F86+oGQdIg2JHVbf/XuNMMzamLyiloUY4ddGli3266IRJpQn2hSKsW3/T+lua6yaBAm2FqT/WEmQCDpBgkTQCRIkgk6QIBF0gkTQCRIkgk6QIBF0ggSJoBMkSASdIBF0ggSJoBMkSASdIEEi6AQJEkEn+FbBvwUYAECuh8+KURS6AAAAAElFTkSuQmCC"

/***/ }),
/* 310 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 311 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 312 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 313 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 314 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 315 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 316 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 317 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4d4a631271de21b4eba2caab3832b2c5.png";

/***/ }),
/* 319 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 320 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 321 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "202b53350f0356edfc5ca8c9bc31bc86.png";

/***/ }),
/* 323 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 324 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 325 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 326 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 327 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 328 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9aebee36cd6e0abd2f8ee2c92132c078.png";

/***/ }),
/* 330 */
/***/ (function(module, exports) {

module.exports = "<div class=\"signature\">\n    <form class=\"form-horizontal\">\n        <div class=\"form-group\">\n            <label class=\"control-label\">{{'home-evidences-text056' | translate}}</label>\n            <div class=\"control-group\">\n                <input type=\"text\" class=\"form-control\" disabled ng-model=\"$ctrl.packageUploader.queue[0].file.name\">\n                <div class=\"btn btn-primary file-upload-btn input-group-btn\">\n                    {{$ctrl.packageUploader.queue.length === 0 ? 'home-evidences-text050' : 'home-evidences-text053' | translate}}\n                    <input type=\"file\" class=\"file-input\" nv-file-select uploader=\"$ctrl.packageUploader\"/>\n                </div>\n            </div>\n            <div class=\"help-block block-error\">\n                <!-- <p>{{'home-evidences-text054' | translate}}</p> -->\n                <p>{{'home-evidences-text0551' | translate}}</p>\n            </div>\n        </div>\n        <!-- <div class=\"form-group\">\n            <label class=\"control-label\">{{'home-evidences-text057' | translate}}</label>\n            <div class=\"control-group\">\n                <input type=\"text\" class=\"form-control\" disabled ng-model=\"$ctrl.uploader.queue[0].file.name\">\n                <div class=\"btn btn-primary file-upload-btn input-group-btn\">\n                    {{$ctrl.uploader.queue.length === 0 ? 'home-evidences-text050' : 'home-evidences-text053' | translate}}\n                    <input type=\"file\" class=\"file-input\" nv-file-select uploader=\"$ctrl.uploader\"/>\n                </div>\n            </div>\n            <div class=\"block-info\">\n                <div class=\"sep\"></div>\n                {{'home-evidences-text060' | translate}}<br>\n                <span>{{'home-evidences-text061' | translate}}</span>\n            </div>\n        </div> -->\n        <div class=\"form-group form-action\">\n            <div class=\"btn btn-primary\" ng-click=\"$ctrl.submitFile()\">{{'home-evidences-text062' | translate}}</div>\n        </div>\n    </form>\n</div>\n";

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * [js-sha256]{@link https://github.com/emn178/js-sha256}
 *
 * @version 0.9.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2014-2017
 * @license MIT
 */
/*jslint bitwise: true */
(function () {
  'use strict';

  var ERROR = 'input is invalid type';
  var WINDOW = typeof window === 'object';
  var root = WINDOW ? window : {};
  if (root.JS_SHA256_NO_WINDOW) {
    WINDOW = false;
  }
  var WEB_WORKER = !WINDOW && typeof self === 'object';
  var NODE_JS = !root.JS_SHA256_NO_NODE_JS && typeof process === 'object' && process.versions && process.versions.node;
  if (NODE_JS) {
    root = global;
  } else if (WEB_WORKER) {
    root = self;
  }
  var COMMON_JS = !root.JS_SHA256_NO_COMMON_JS && typeof module === 'object' && module.exports;
  var AMD = "function" === 'function' && __webpack_require__(332);
  var ARRAY_BUFFER = !root.JS_SHA256_NO_ARRAY_BUFFER && typeof ArrayBuffer !== 'undefined';
  var HEX_CHARS = '0123456789abcdef'.split('');
  var EXTRA = [-2147483648, 8388608, 32768, 128];
  var SHIFT = [24, 16, 8, 0];
  var K = [
    0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5, 0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
    0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3, 0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
    0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc, 0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
    0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7, 0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
    0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13, 0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
    0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3, 0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
    0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5, 0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
    0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208, 0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2
  ];
  var OUTPUT_TYPES = ['hex', 'array', 'digest', 'arrayBuffer'];

  var blocks = [];

  if (root.JS_SHA256_NO_NODE_JS || !Array.isArray) {
    Array.isArray = function (obj) {
      return Object.prototype.toString.call(obj) === '[object Array]';
    };
  }

  if (ARRAY_BUFFER && (root.JS_SHA256_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) {
    ArrayBuffer.isView = function (obj) {
      return typeof obj === 'object' && obj.buffer && obj.buffer.constructor === ArrayBuffer;
    };
  }

  var createOutputMethod = function (outputType, is224) {
    return function (message) {
      return new Sha256(is224, true).update(message)[outputType]();
    };
  };

  var createMethod = function (is224) {
    var method = createOutputMethod('hex', is224);
    if (NODE_JS) {
      method = nodeWrap(method, is224);
    }
    method.create = function () {
      return new Sha256(is224);
    };
    method.update = function (message) {
      return method.create().update(message);
    };
    for (var i = 0; i < OUTPUT_TYPES.length; ++i) {
      var type = OUTPUT_TYPES[i];
      method[type] = createOutputMethod(type, is224);
    }
    return method;
  };

  var nodeWrap = function (method, is224) {
    var crypto = eval("require('crypto')");
    var Buffer = eval("require('buffer').Buffer");
    var algorithm = is224 ? 'sha224' : 'sha256';
    var nodeMethod = function (message) {
      if (typeof message === 'string') {
        return crypto.createHash(algorithm).update(message, 'utf8').digest('hex');
      } else {
        if (message === null || message === undefined) {
          throw new Error(ERROR);
        } else if (message.constructor === ArrayBuffer) {
          message = new Uint8Array(message);
        }
      }
      if (Array.isArray(message) || ArrayBuffer.isView(message) ||
        message.constructor === Buffer) {
        return crypto.createHash(algorithm).update(new Buffer(message)).digest('hex');
      } else {
        return method(message);
      }
    };
    return nodeMethod;
  };

  var createHmacOutputMethod = function (outputType, is224) {
    return function (key, message) {
      return new HmacSha256(key, is224, true).update(message)[outputType]();
    };
  };

  var createHmacMethod = function (is224) {
    var method = createHmacOutputMethod('hex', is224);
    method.create = function (key) {
      return new HmacSha256(key, is224);
    };
    method.update = function (key, message) {
      return method.create(key).update(message);
    };
    for (var i = 0; i < OUTPUT_TYPES.length; ++i) {
      var type = OUTPUT_TYPES[i];
      method[type] = createHmacOutputMethod(type, is224);
    }
    return method;
  };

  function Sha256(is224, sharedMemory) {
    if (sharedMemory) {
      blocks[0] = blocks[16] = blocks[1] = blocks[2] = blocks[3] =
        blocks[4] = blocks[5] = blocks[6] = blocks[7] =
        blocks[8] = blocks[9] = blocks[10] = blocks[11] =
        blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
      this.blocks = blocks;
    } else {
      this.blocks = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    }

    if (is224) {
      this.h0 = 0xc1059ed8;
      this.h1 = 0x367cd507;
      this.h2 = 0x3070dd17;
      this.h3 = 0xf70e5939;
      this.h4 = 0xffc00b31;
      this.h5 = 0x68581511;
      this.h6 = 0x64f98fa7;
      this.h7 = 0xbefa4fa4;
    } else { // 256
      this.h0 = 0x6a09e667;
      this.h1 = 0xbb67ae85;
      this.h2 = 0x3c6ef372;
      this.h3 = 0xa54ff53a;
      this.h4 = 0x510e527f;
      this.h5 = 0x9b05688c;
      this.h6 = 0x1f83d9ab;
      this.h7 = 0x5be0cd19;
    }

    this.block = this.start = this.bytes = this.hBytes = 0;
    this.finalized = this.hashed = false;
    this.first = true;
    this.is224 = is224;
  }

  Sha256.prototype.update = function (message) {
    if (this.finalized) {
      return;
    }
    var notString, type = typeof message;
    if (type !== 'string') {
      if (type === 'object') {
        if (message === null) {
          throw new Error(ERROR);
        } else if (ARRAY_BUFFER && message.constructor === ArrayBuffer) {
          message = new Uint8Array(message);
        } else if (!Array.isArray(message)) {
          if (!ARRAY_BUFFER || !ArrayBuffer.isView(message)) {
            throw new Error(ERROR);
          }
        }
      } else {
        throw new Error(ERROR);
      }
      notString = true;
    }
    var code, index = 0, i, length = message.length, blocks = this.blocks;

    while (index < length) {
      if (this.hashed) {
        this.hashed = false;
        blocks[0] = this.block;
        blocks[16] = blocks[1] = blocks[2] = blocks[3] =
          blocks[4] = blocks[5] = blocks[6] = blocks[7] =
          blocks[8] = blocks[9] = blocks[10] = blocks[11] =
          blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
      }

      if (notString) {
        for (i = this.start; index < length && i < 64; ++index) {
          blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
        }
      } else {
        for (i = this.start; index < length && i < 64; ++index) {
          code = message.charCodeAt(index);
          if (code < 0x80) {
            blocks[i >> 2] |= code << SHIFT[i++ & 3];
          } else if (code < 0x800) {
            blocks[i >> 2] |= (0xc0 | (code >> 6)) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | (code & 0x3f)) << SHIFT[i++ & 3];
          } else if (code < 0xd800 || code >= 0xe000) {
            blocks[i >> 2] |= (0xe0 | (code >> 12)) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | ((code >> 6) & 0x3f)) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | (code & 0x3f)) << SHIFT[i++ & 3];
          } else {
            code = 0x10000 + (((code & 0x3ff) << 10) | (message.charCodeAt(++index) & 0x3ff));
            blocks[i >> 2] |= (0xf0 | (code >> 18)) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | ((code >> 12) & 0x3f)) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | ((code >> 6) & 0x3f)) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | (code & 0x3f)) << SHIFT[i++ & 3];
          }
        }
      }

      this.lastByteIndex = i;
      this.bytes += i - this.start;
      if (i >= 64) {
        this.block = blocks[16];
        this.start = i - 64;
        this.hash();
        this.hashed = true;
      } else {
        this.start = i;
      }
    }
    if (this.bytes > 4294967295) {
      this.hBytes += this.bytes / 4294967296 << 0;
      this.bytes = this.bytes % 4294967296;
    }
    return this;
  };

  Sha256.prototype.finalize = function () {
    if (this.finalized) {
      return;
    }
    this.finalized = true;
    var blocks = this.blocks, i = this.lastByteIndex;
    blocks[16] = this.block;
    blocks[i >> 2] |= EXTRA[i & 3];
    this.block = blocks[16];
    if (i >= 56) {
      if (!this.hashed) {
        this.hash();
      }
      blocks[0] = this.block;
      blocks[16] = blocks[1] = blocks[2] = blocks[3] =
        blocks[4] = blocks[5] = blocks[6] = blocks[7] =
        blocks[8] = blocks[9] = blocks[10] = blocks[11] =
        blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
    }
    blocks[14] = this.hBytes << 3 | this.bytes >>> 29;
    blocks[15] = this.bytes << 3;
    this.hash();
  };

  Sha256.prototype.hash = function () {
    var a = this.h0, b = this.h1, c = this.h2, d = this.h3, e = this.h4, f = this.h5, g = this.h6,
      h = this.h7, blocks = this.blocks, j, s0, s1, maj, t1, t2, ch, ab, da, cd, bc;

    for (j = 16; j < 64; ++j) {
      // rightrotate
      t1 = blocks[j - 15];
      s0 = ((t1 >>> 7) | (t1 << 25)) ^ ((t1 >>> 18) | (t1 << 14)) ^ (t1 >>> 3);
      t1 = blocks[j - 2];
      s1 = ((t1 >>> 17) | (t1 << 15)) ^ ((t1 >>> 19) | (t1 << 13)) ^ (t1 >>> 10);
      blocks[j] = blocks[j - 16] + s0 + blocks[j - 7] + s1 << 0;
    }

    bc = b & c;
    for (j = 0; j < 64; j += 4) {
      if (this.first) {
        if (this.is224) {
          ab = 300032;
          t1 = blocks[0] - 1413257819;
          h = t1 - 150054599 << 0;
          d = t1 + 24177077 << 0;
        } else {
          ab = 704751109;
          t1 = blocks[0] - 210244248;
          h = t1 - 1521486534 << 0;
          d = t1 + 143694565 << 0;
        }
        this.first = false;
      } else {
        s0 = ((a >>> 2) | (a << 30)) ^ ((a >>> 13) | (a << 19)) ^ ((a >>> 22) | (a << 10));
        s1 = ((e >>> 6) | (e << 26)) ^ ((e >>> 11) | (e << 21)) ^ ((e >>> 25) | (e << 7));
        ab = a & b;
        maj = ab ^ (a & c) ^ bc;
        ch = (e & f) ^ (~e & g);
        t1 = h + s1 + ch + K[j] + blocks[j];
        t2 = s0 + maj;
        h = d + t1 << 0;
        d = t1 + t2 << 0;
      }
      s0 = ((d >>> 2) | (d << 30)) ^ ((d >>> 13) | (d << 19)) ^ ((d >>> 22) | (d << 10));
      s1 = ((h >>> 6) | (h << 26)) ^ ((h >>> 11) | (h << 21)) ^ ((h >>> 25) | (h << 7));
      da = d & a;
      maj = da ^ (d & b) ^ ab;
      ch = (h & e) ^ (~h & f);
      t1 = g + s1 + ch + K[j + 1] + blocks[j + 1];
      t2 = s0 + maj;
      g = c + t1 << 0;
      c = t1 + t2 << 0;
      s0 = ((c >>> 2) | (c << 30)) ^ ((c >>> 13) | (c << 19)) ^ ((c >>> 22) | (c << 10));
      s1 = ((g >>> 6) | (g << 26)) ^ ((g >>> 11) | (g << 21)) ^ ((g >>> 25) | (g << 7));
      cd = c & d;
      maj = cd ^ (c & a) ^ da;
      ch = (g & h) ^ (~g & e);
      t1 = f + s1 + ch + K[j + 2] + blocks[j + 2];
      t2 = s0 + maj;
      f = b + t1 << 0;
      b = t1 + t2 << 0;
      s0 = ((b >>> 2) | (b << 30)) ^ ((b >>> 13) | (b << 19)) ^ ((b >>> 22) | (b << 10));
      s1 = ((f >>> 6) | (f << 26)) ^ ((f >>> 11) | (f << 21)) ^ ((f >>> 25) | (f << 7));
      bc = b & c;
      maj = bc ^ (b & d) ^ cd;
      ch = (f & g) ^ (~f & h);
      t1 = e + s1 + ch + K[j + 3] + blocks[j + 3];
      t2 = s0 + maj;
      e = a + t1 << 0;
      a = t1 + t2 << 0;
    }

    this.h0 = this.h0 + a << 0;
    this.h1 = this.h1 + b << 0;
    this.h2 = this.h2 + c << 0;
    this.h3 = this.h3 + d << 0;
    this.h4 = this.h4 + e << 0;
    this.h5 = this.h5 + f << 0;
    this.h6 = this.h6 + g << 0;
    this.h7 = this.h7 + h << 0;
  };

  Sha256.prototype.hex = function () {
    this.finalize();

    var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3, h4 = this.h4, h5 = this.h5,
      h6 = this.h6, h7 = this.h7;

    var hex = HEX_CHARS[(h0 >> 28) & 0x0F] + HEX_CHARS[(h0 >> 24) & 0x0F] +
      HEX_CHARS[(h0 >> 20) & 0x0F] + HEX_CHARS[(h0 >> 16) & 0x0F] +
      HEX_CHARS[(h0 >> 12) & 0x0F] + HEX_CHARS[(h0 >> 8) & 0x0F] +
      HEX_CHARS[(h0 >> 4) & 0x0F] + HEX_CHARS[h0 & 0x0F] +
      HEX_CHARS[(h1 >> 28) & 0x0F] + HEX_CHARS[(h1 >> 24) & 0x0F] +
      HEX_CHARS[(h1 >> 20) & 0x0F] + HEX_CHARS[(h1 >> 16) & 0x0F] +
      HEX_CHARS[(h1 >> 12) & 0x0F] + HEX_CHARS[(h1 >> 8) & 0x0F] +
      HEX_CHARS[(h1 >> 4) & 0x0F] + HEX_CHARS[h1 & 0x0F] +
      HEX_CHARS[(h2 >> 28) & 0x0F] + HEX_CHARS[(h2 >> 24) & 0x0F] +
      HEX_CHARS[(h2 >> 20) & 0x0F] + HEX_CHARS[(h2 >> 16) & 0x0F] +
      HEX_CHARS[(h2 >> 12) & 0x0F] + HEX_CHARS[(h2 >> 8) & 0x0F] +
      HEX_CHARS[(h2 >> 4) & 0x0F] + HEX_CHARS[h2 & 0x0F] +
      HEX_CHARS[(h3 >> 28) & 0x0F] + HEX_CHARS[(h3 >> 24) & 0x0F] +
      HEX_CHARS[(h3 >> 20) & 0x0F] + HEX_CHARS[(h3 >> 16) & 0x0F] +
      HEX_CHARS[(h3 >> 12) & 0x0F] + HEX_CHARS[(h3 >> 8) & 0x0F] +
      HEX_CHARS[(h3 >> 4) & 0x0F] + HEX_CHARS[h3 & 0x0F] +
      HEX_CHARS[(h4 >> 28) & 0x0F] + HEX_CHARS[(h4 >> 24) & 0x0F] +
      HEX_CHARS[(h4 >> 20) & 0x0F] + HEX_CHARS[(h4 >> 16) & 0x0F] +
      HEX_CHARS[(h4 >> 12) & 0x0F] + HEX_CHARS[(h4 >> 8) & 0x0F] +
      HEX_CHARS[(h4 >> 4) & 0x0F] + HEX_CHARS[h4 & 0x0F] +
      HEX_CHARS[(h5 >> 28) & 0x0F] + HEX_CHARS[(h5 >> 24) & 0x0F] +
      HEX_CHARS[(h5 >> 20) & 0x0F] + HEX_CHARS[(h5 >> 16) & 0x0F] +
      HEX_CHARS[(h5 >> 12) & 0x0F] + HEX_CHARS[(h5 >> 8) & 0x0F] +
      HEX_CHARS[(h5 >> 4) & 0x0F] + HEX_CHARS[h5 & 0x0F] +
      HEX_CHARS[(h6 >> 28) & 0x0F] + HEX_CHARS[(h6 >> 24) & 0x0F] +
      HEX_CHARS[(h6 >> 20) & 0x0F] + HEX_CHARS[(h6 >> 16) & 0x0F] +
      HEX_CHARS[(h6 >> 12) & 0x0F] + HEX_CHARS[(h6 >> 8) & 0x0F] +
      HEX_CHARS[(h6 >> 4) & 0x0F] + HEX_CHARS[h6 & 0x0F];
    if (!this.is224) {
      hex += HEX_CHARS[(h7 >> 28) & 0x0F] + HEX_CHARS[(h7 >> 24) & 0x0F] +
        HEX_CHARS[(h7 >> 20) & 0x0F] + HEX_CHARS[(h7 >> 16) & 0x0F] +
        HEX_CHARS[(h7 >> 12) & 0x0F] + HEX_CHARS[(h7 >> 8) & 0x0F] +
        HEX_CHARS[(h7 >> 4) & 0x0F] + HEX_CHARS[h7 & 0x0F];
    }
    return hex;
  };

  Sha256.prototype.toString = Sha256.prototype.hex;

  Sha256.prototype.digest = function () {
    this.finalize();

    var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3, h4 = this.h4, h5 = this.h5,
      h6 = this.h6, h7 = this.h7;

    var arr = [
      (h0 >> 24) & 0xFF, (h0 >> 16) & 0xFF, (h0 >> 8) & 0xFF, h0 & 0xFF,
      (h1 >> 24) & 0xFF, (h1 >> 16) & 0xFF, (h1 >> 8) & 0xFF, h1 & 0xFF,
      (h2 >> 24) & 0xFF, (h2 >> 16) & 0xFF, (h2 >> 8) & 0xFF, h2 & 0xFF,
      (h3 >> 24) & 0xFF, (h3 >> 16) & 0xFF, (h3 >> 8) & 0xFF, h3 & 0xFF,
      (h4 >> 24) & 0xFF, (h4 >> 16) & 0xFF, (h4 >> 8) & 0xFF, h4 & 0xFF,
      (h5 >> 24) & 0xFF, (h5 >> 16) & 0xFF, (h5 >> 8) & 0xFF, h5 & 0xFF,
      (h6 >> 24) & 0xFF, (h6 >> 16) & 0xFF, (h6 >> 8) & 0xFF, h6 & 0xFF
    ];
    if (!this.is224) {
      arr.push((h7 >> 24) & 0xFF, (h7 >> 16) & 0xFF, (h7 >> 8) & 0xFF, h7 & 0xFF);
    }
    return arr;
  };

  Sha256.prototype.array = Sha256.prototype.digest;

  Sha256.prototype.arrayBuffer = function () {
    this.finalize();

    var buffer = new ArrayBuffer(this.is224 ? 28 : 32);
    var dataView = new DataView(buffer);
    dataView.setUint32(0, this.h0);
    dataView.setUint32(4, this.h1);
    dataView.setUint32(8, this.h2);
    dataView.setUint32(12, this.h3);
    dataView.setUint32(16, this.h4);
    dataView.setUint32(20, this.h5);
    dataView.setUint32(24, this.h6);
    if (!this.is224) {
      dataView.setUint32(28, this.h7);
    }
    return buffer;
  };

  function HmacSha256(key, is224, sharedMemory) {
    var i, type = typeof key;
    if (type === 'string') {
      var bytes = [], length = key.length, index = 0, code;
      for (i = 0; i < length; ++i) {
        code = key.charCodeAt(i);
        if (code < 0x80) {
          bytes[index++] = code;
        } else if (code < 0x800) {
          bytes[index++] = (0xc0 | (code >> 6));
          bytes[index++] = (0x80 | (code & 0x3f));
        } else if (code < 0xd800 || code >= 0xe000) {
          bytes[index++] = (0xe0 | (code >> 12));
          bytes[index++] = (0x80 | ((code >> 6) & 0x3f));
          bytes[index++] = (0x80 | (code & 0x3f));
        } else {
          code = 0x10000 + (((code & 0x3ff) << 10) | (key.charCodeAt(++i) & 0x3ff));
          bytes[index++] = (0xf0 | (code >> 18));
          bytes[index++] = (0x80 | ((code >> 12) & 0x3f));
          bytes[index++] = (0x80 | ((code >> 6) & 0x3f));
          bytes[index++] = (0x80 | (code & 0x3f));
        }
      }
      key = bytes;
    } else {
      if (type === 'object') {
        if (key === null) {
          throw new Error(ERROR);
        } else if (ARRAY_BUFFER && key.constructor === ArrayBuffer) {
          key = new Uint8Array(key);
        } else if (!Array.isArray(key)) {
          if (!ARRAY_BUFFER || !ArrayBuffer.isView(key)) {
            throw new Error(ERROR);
          }
        }
      } else {
        throw new Error(ERROR);
      }
    }

    if (key.length > 64) {
      key = (new Sha256(is224, true)).update(key).array();
    }

    var oKeyPad = [], iKeyPad = [];
    for (i = 0; i < 64; ++i) {
      var b = key[i] || 0;
      oKeyPad[i] = 0x5c ^ b;
      iKeyPad[i] = 0x36 ^ b;
    }

    Sha256.call(this, is224, sharedMemory);

    this.update(iKeyPad);
    this.oKeyPad = oKeyPad;
    this.inner = true;
    this.sharedMemory = sharedMemory;
  }
  HmacSha256.prototype = new Sha256();

  HmacSha256.prototype.finalize = function () {
    Sha256.prototype.finalize.call(this);
    if (this.inner) {
      this.inner = false;
      var innerHash = this.array();
      Sha256.call(this, this.is224, this.sharedMemory);
      this.update(this.oKeyPad);
      this.update(innerHash);
      Sha256.prototype.finalize.call(this);
    }
  };

  var exports = createMethod();
  exports.sha256 = exports;
  exports.sha224 = createMethod(true);
  exports.sha256.hmac = createHmacMethod();
  exports.sha224.hmac = createHmacMethod(true);

  if (COMMON_JS) {
    module.exports = exports;
  } else {
    root.sha256 = exports.sha256;
    root.sha224 = exports.sha224;
    if (AMD) {
      !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
        return exports;
      }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    }
  }
})();

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(180), __webpack_require__(31)))

/***/ }),
/* 332 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*
 * [js-sha512]{@link https://github.com/emn178/js-sha512}
 *
 * @version 0.8.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2014-2018
 * @license MIT
 */
/*jslint bitwise: true */
(function () {
  'use strict';

  var INPUT_ERROR = 'input is invalid type';
  var FINALIZE_ERROR = 'finalize already called';
  var WINDOW = typeof window === 'object';
  var root = WINDOW ? window : {};
  if (root.JS_SHA512_NO_WINDOW) {
    WINDOW = false;
  }
  var WEB_WORKER = !WINDOW && typeof self === 'object';
  var NODE_JS = !root.JS_SHA512_NO_NODE_JS && typeof process === 'object' && process.versions && process.versions.node;
  if (NODE_JS) {
    root = global;
  } else if (WEB_WORKER) {
    root = self;
  }
  var COMMON_JS = !root.JS_SHA512_NO_COMMON_JS && typeof module === 'object' && module.exports;
  var AMD = "function" === 'function' && __webpack_require__(332);
  var ARRAY_BUFFER = !root.JS_SHA512_NO_ARRAY_BUFFER && typeof ArrayBuffer !== 'undefined';
  var HEX_CHARS = '0123456789abcdef'.split('');
  var EXTRA = [-2147483648, 8388608, 32768, 128];
  var SHIFT = [24, 16, 8, 0];
  var K = [
    0x428A2F98, 0xD728AE22, 0x71374491, 0x23EF65CD,
    0xB5C0FBCF, 0xEC4D3B2F, 0xE9B5DBA5, 0x8189DBBC,
    0x3956C25B, 0xF348B538, 0x59F111F1, 0xB605D019,
    0x923F82A4, 0xAF194F9B, 0xAB1C5ED5, 0xDA6D8118,
    0xD807AA98, 0xA3030242, 0x12835B01, 0x45706FBE,
    0x243185BE, 0x4EE4B28C, 0x550C7DC3, 0xD5FFB4E2,
    0x72BE5D74, 0xF27B896F, 0x80DEB1FE, 0x3B1696B1,
    0x9BDC06A7, 0x25C71235, 0xC19BF174, 0xCF692694,
    0xE49B69C1, 0x9EF14AD2, 0xEFBE4786, 0x384F25E3,
    0x0FC19DC6, 0x8B8CD5B5, 0x240CA1CC, 0x77AC9C65,
    0x2DE92C6F, 0x592B0275, 0x4A7484AA, 0x6EA6E483,
    0x5CB0A9DC, 0xBD41FBD4, 0x76F988DA, 0x831153B5,
    0x983E5152, 0xEE66DFAB, 0xA831C66D, 0x2DB43210,
    0xB00327C8, 0x98FB213F, 0xBF597FC7, 0xBEEF0EE4,
    0xC6E00BF3, 0x3DA88FC2, 0xD5A79147, 0x930AA725,
    0x06CA6351, 0xE003826F, 0x14292967, 0x0A0E6E70,
    0x27B70A85, 0x46D22FFC, 0x2E1B2138, 0x5C26C926,
    0x4D2C6DFC, 0x5AC42AED, 0x53380D13, 0x9D95B3DF,
    0x650A7354, 0x8BAF63DE, 0x766A0ABB, 0x3C77B2A8,
    0x81C2C92E, 0x47EDAEE6, 0x92722C85, 0x1482353B,
    0xA2BFE8A1, 0x4CF10364, 0xA81A664B, 0xBC423001,
    0xC24B8B70, 0xD0F89791, 0xC76C51A3, 0x0654BE30,
    0xD192E819, 0xD6EF5218, 0xD6990624, 0x5565A910,
    0xF40E3585, 0x5771202A, 0x106AA070, 0x32BBD1B8,
    0x19A4C116, 0xB8D2D0C8, 0x1E376C08, 0x5141AB53,
    0x2748774C, 0xDF8EEB99, 0x34B0BCB5, 0xE19B48A8,
    0x391C0CB3, 0xC5C95A63, 0x4ED8AA4A, 0xE3418ACB,
    0x5B9CCA4F, 0x7763E373, 0x682E6FF3, 0xD6B2B8A3,
    0x748F82EE, 0x5DEFB2FC, 0x78A5636F, 0x43172F60,
    0x84C87814, 0xA1F0AB72, 0x8CC70208, 0x1A6439EC,
    0x90BEFFFA, 0x23631E28, 0xA4506CEB, 0xDE82BDE9,
    0xBEF9A3F7, 0xB2C67915, 0xC67178F2, 0xE372532B,
    0xCA273ECE, 0xEA26619C, 0xD186B8C7, 0x21C0C207,
    0xEADA7DD6, 0xCDE0EB1E, 0xF57D4F7F, 0xEE6ED178,
    0x06F067AA, 0x72176FBA, 0x0A637DC5, 0xA2C898A6,
    0x113F9804, 0xBEF90DAE, 0x1B710B35, 0x131C471B,
    0x28DB77F5, 0x23047D84, 0x32CAAB7B, 0x40C72493,
    0x3C9EBE0A, 0x15C9BEBC, 0x431D67C4, 0x9C100D4C,
    0x4CC5D4BE, 0xCB3E42B6, 0x597F299C, 0xFC657E2A,
    0x5FCB6FAB, 0x3AD6FAEC, 0x6C44198C, 0x4A475817
  ];

  var OUTPUT_TYPES = ['hex', 'array', 'digest', 'arrayBuffer'];

  var blocks = [];

  if (root.JS_SHA512_NO_NODE_JS || !Array.isArray) {
    Array.isArray = function (obj) {
      return Object.prototype.toString.call(obj) === '[object Array]';
    };
  }

  if (ARRAY_BUFFER && (root.JS_SHA512_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) {
    ArrayBuffer.isView = function (obj) {
      return typeof obj === 'object' && obj.buffer && obj.buffer.constructor === ArrayBuffer;
    };
  }

  var createOutputMethod = function (outputType, bits) {
    return function (message) {
      return new Sha512(bits, true).update(message)[outputType]();
    };
  };

  var createMethod = function (bits) {
    var method = createOutputMethod('hex', bits);
    method.create = function () {
      return new Sha512(bits);
    };
    method.update = function (message) {
      return method.create().update(message);
    };
    for (var i = 0; i < OUTPUT_TYPES.length; ++i) {
      var type = OUTPUT_TYPES[i];
      method[type] = createOutputMethod(type, bits);
    }
    return method;
  };

  var createHmacOutputMethod = function (outputType, bits) {
    return function (key, message) {
      return new HmacSha512(key, bits, true).update(message)[outputType]();
    };
  };

  var createHmacMethod = function (bits) {
    var method = createHmacOutputMethod('hex', bits);
    method.create = function (key) {
      return new HmacSha512(key, bits);
    };
    method.update = function (key, message) {
      return method.create(key).update(message);
    };
    for (var i = 0; i < OUTPUT_TYPES.length; ++i) {
      var type = OUTPUT_TYPES[i];
      method[type] = createHmacOutputMethod(type, bits);
    }
    return method;
  };

  function Sha512(bits, sharedMemory) {
    if (sharedMemory) {
      blocks[0] = blocks[1] = blocks[2] = blocks[3] = blocks[4] =
      blocks[5] = blocks[6] = blocks[7] = blocks[8] =
      blocks[9] = blocks[10] = blocks[11] = blocks[12] =
      blocks[13] = blocks[14] = blocks[15] = blocks[16] =
      blocks[17] = blocks[18] = blocks[19] = blocks[20] =
      blocks[21] = blocks[22] = blocks[23] = blocks[24] =
      blocks[25] = blocks[26] = blocks[27] = blocks[28] =
      blocks[29] = blocks[30] = blocks[31] = blocks[32] = 0;
      this.blocks = blocks;
    } else {
      this.blocks = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    }

    if (bits == 384) {
      this.h0h = 0xCBBB9D5D;
      this.h0l = 0xC1059ED8;
      this.h1h = 0x629A292A;
      this.h1l = 0x367CD507;
      this.h2h = 0x9159015A;
      this.h2l = 0x3070DD17;
      this.h3h = 0x152FECD8;
      this.h3l = 0xF70E5939;
      this.h4h = 0x67332667;
      this.h4l = 0xFFC00B31;
      this.h5h = 0x8EB44A87;
      this.h5l = 0x68581511;
      this.h6h = 0xDB0C2E0D;
      this.h6l = 0x64F98FA7;
      this.h7h = 0x47B5481D;
      this.h7l = 0xBEFA4FA4;
    } else if (bits == 256) {
      this.h0h = 0x22312194;
      this.h0l = 0xFC2BF72C;
      this.h1h = 0x9F555FA3;
      this.h1l = 0xC84C64C2;
      this.h2h = 0x2393B86B;
      this.h2l = 0x6F53B151;
      this.h3h = 0x96387719;
      this.h3l = 0x5940EABD;
      this.h4h = 0x96283EE2;
      this.h4l = 0xA88EFFE3;
      this.h5h = 0xBE5E1E25;
      this.h5l = 0x53863992;
      this.h6h = 0x2B0199FC;
      this.h6l = 0x2C85B8AA;
      this.h7h = 0x0EB72DDC;
      this.h7l = 0x81C52CA2;
    } else if (bits == 224) {
      this.h0h = 0x8C3D37C8;
      this.h0l = 0x19544DA2;
      this.h1h = 0x73E19966;
      this.h1l = 0x89DCD4D6;
      this.h2h = 0x1DFAB7AE;
      this.h2l = 0x32FF9C82;
      this.h3h = 0x679DD514;
      this.h3l = 0x582F9FCF;
      this.h4h = 0x0F6D2B69;
      this.h4l = 0x7BD44DA8;
      this.h5h = 0x77E36F73;
      this.h5l = 0x04C48942;
      this.h6h = 0x3F9D85A8;
      this.h6l = 0x6A1D36C8;
      this.h7h = 0x1112E6AD;
      this.h7l = 0x91D692A1;
    } else { // 512
      this.h0h = 0x6A09E667;
      this.h0l = 0xF3BCC908;
      this.h1h = 0xBB67AE85;
      this.h1l = 0x84CAA73B;
      this.h2h = 0x3C6EF372;
      this.h2l = 0xFE94F82B;
      this.h3h = 0xA54FF53A;
      this.h3l = 0x5F1D36F1;
      this.h4h = 0x510E527F;
      this.h4l = 0xADE682D1;
      this.h5h = 0x9B05688C;
      this.h5l = 0x2B3E6C1F;
      this.h6h = 0x1F83D9AB;
      this.h6l = 0xFB41BD6B;
      this.h7h = 0x5BE0CD19;
      this.h7l = 0x137E2179;
    }
    this.bits = bits;

    this.block = this.start = this.bytes = this.hBytes = 0;
    this.finalized = this.hashed = false;
  }

  Sha512.prototype.update = function (message) {
    if (this.finalized) {
      throw new Error(FINALIZE_ERROR);
    }
    var notString, type = typeof message;
    if (type !== 'string') {
      if (type === 'object') {
        if (message === null) {
          throw new Error(INPUT_ERROR);
        } else if (ARRAY_BUFFER && message.constructor === ArrayBuffer) {
          message = new Uint8Array(message);
        } else if (!Array.isArray(message)) {
          if (!ARRAY_BUFFER || !ArrayBuffer.isView(message)) {
            throw new Error(INPUT_ERROR);
          }
        }
      } else {
        throw new Error(INPUT_ERROR);
      }
      notString = true;
    }
    var code, index = 0, i, length = message.length, blocks = this.blocks;

    while (index < length) {
      if (this.hashed) {
        this.hashed = false;
        blocks[0] = this.block;
        blocks[1] = blocks[2] = blocks[3] = blocks[4] =
        blocks[5] = blocks[6] = blocks[7] = blocks[8] =
        blocks[9] = blocks[10] = blocks[11] = blocks[12] =
        blocks[13] = blocks[14] = blocks[15] = blocks[16] =
        blocks[17] = blocks[18] = blocks[19] = blocks[20] =
        blocks[21] = blocks[22] = blocks[23] = blocks[24] =
        blocks[25] = blocks[26] = blocks[27] = blocks[28] =
        blocks[29] = blocks[30] = blocks[31] = blocks[32] = 0;
      }

      if(notString) {
        for (i = this.start; index < length && i < 128; ++index) {
          blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
        }
      } else {
        for (i = this.start; index < length && i < 128; ++index) {
          code = message.charCodeAt(index);
          if (code < 0x80) {
            blocks[i >> 2] |= code << SHIFT[i++ & 3];
          } else if (code < 0x800) {
            blocks[i >> 2] |= (0xc0 | (code >> 6)) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | (code & 0x3f)) << SHIFT[i++ & 3];
          } else if (code < 0xd800 || code >= 0xe000) {
            blocks[i >> 2] |= (0xe0 | (code >> 12)) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | ((code >> 6) & 0x3f)) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | (code & 0x3f)) << SHIFT[i++ & 3];
          } else {
            code = 0x10000 + (((code & 0x3ff) << 10) | (message.charCodeAt(++index) & 0x3ff));
            blocks[i >> 2] |= (0xf0 | (code >> 18)) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | ((code >> 12) & 0x3f)) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | ((code >> 6) & 0x3f)) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | (code & 0x3f)) << SHIFT[i++ & 3];
          }
        }
      }

      this.lastByteIndex = i;
      this.bytes += i - this.start;
      if (i >= 128) {
        this.block = blocks[32];
        this.start = i - 128;
        this.hash();
        this.hashed = true;
      } else {
        this.start = i;
      }
    }
    if (this.bytes > 4294967295) {
      this.hBytes += this.bytes / 4294967296 << 0;
      this.bytes = this.bytes % 4294967296;
    }
    return this;
  };

  Sha512.prototype.finalize = function () {
    if (this.finalized) {
      return;
    }
    this.finalized = true;
    var blocks = this.blocks, i = this.lastByteIndex;
    blocks[32] = this.block;
    blocks[i >> 2] |= EXTRA[i & 3];
    this.block = blocks[32];
    if (i >= 112) {
      if (!this.hashed) {
        this.hash();
      }
      blocks[0] = this.block;
      blocks[1] = blocks[2] = blocks[3] = blocks[4] =
      blocks[5] = blocks[6] = blocks[7] = blocks[8] =
      blocks[9] = blocks[10] = blocks[11] = blocks[12] =
      blocks[13] = blocks[14] = blocks[15] = blocks[16] =
      blocks[17] = blocks[18] = blocks[19] = blocks[20] =
      blocks[21] = blocks[22] = blocks[23] = blocks[24] =
      blocks[25] = blocks[26] = blocks[27] = blocks[28] =
      blocks[29] = blocks[30] = blocks[31] = blocks[32] = 0;
    }
    blocks[30] = this.hBytes << 3 | this.bytes >>> 29;
    blocks[31] = this.bytes << 3;
    this.hash();
  };

  Sha512.prototype.hash = function () {
    var h0h = this.h0h, h0l = this.h0l, h1h = this.h1h, h1l = this.h1l,
      h2h = this.h2h, h2l = this.h2l, h3h = this.h3h, h3l = this.h3l,
      h4h = this.h4h, h4l = this.h4l, h5h = this.h5h, h5l = this.h5l,
      h6h = this.h6h, h6l = this.h6l, h7h = this.h7h, h7l = this.h7l,
      blocks = this.blocks, j, s0h, s0l, s1h, s1l, c1, c2, c3, c4,
      abh, abl, dah, dal, cdh, cdl, bch, bcl,
      majh, majl, t1h, t1l, t2h, t2l, chh, chl;

    for (j = 32; j < 160; j += 2) {
      t1h = blocks[j - 30];
      t1l = blocks[j - 29];
      s0h = ((t1h >>> 1) | (t1l << 31)) ^ ((t1h >>> 8) | (t1l << 24)) ^ (t1h >>> 7);
      s0l = ((t1l >>> 1) | (t1h << 31)) ^ ((t1l >>> 8) | (t1h << 24)) ^ ((t1l >>> 7) | t1h << 25);

      t1h = blocks[j - 4];
      t1l = blocks[j - 3];
      s1h = ((t1h >>> 19) | (t1l << 13)) ^ ((t1l >>> 29) | (t1h << 3)) ^ (t1h >>> 6);
      s1l = ((t1l >>> 19) | (t1h << 13)) ^ ((t1h >>> 29) | (t1l << 3)) ^ ((t1l >>> 6) | t1h << 26);

      t1h = blocks[j - 32];
      t1l = blocks[j - 31];
      t2h = blocks[j - 14];
      t2l = blocks[j - 13];

      c1 = (t2l & 0xFFFF) + (t1l & 0xFFFF) + (s0l & 0xFFFF) + (s1l & 0xFFFF);
      c2 = (t2l >>> 16) + (t1l >>> 16) + (s0l >>> 16) + (s1l >>> 16) + (c1 >>> 16);
      c3 = (t2h & 0xFFFF) + (t1h & 0xFFFF) + (s0h & 0xFFFF) + (s1h & 0xFFFF) + (c2 >>> 16);
      c4 = (t2h >>> 16) + (t1h >>> 16) + (s0h >>> 16) + (s1h >>> 16) + (c3 >>> 16);

      blocks[j] = (c4 << 16) | (c3 & 0xFFFF);
      blocks[j + 1] = (c2 << 16) | (c1 & 0xFFFF);
    }

    var ah = h0h, al = h0l, bh = h1h, bl = h1l, ch = h2h, cl = h2l, dh = h3h, dl = h3l, eh = h4h, el = h4l, fh = h5h, fl = h5l, gh = h6h, gl = h6l, hh = h7h, hl = h7l;
    bch = bh & ch;
    bcl = bl & cl;
    for (j = 0; j < 160; j += 8) {
      s0h = ((ah >>> 28) | (al << 4)) ^ ((al >>> 2) | (ah << 30)) ^ ((al >>> 7) | (ah << 25));
      s0l = ((al >>> 28) | (ah << 4)) ^ ((ah >>> 2) | (al << 30)) ^ ((ah >>> 7) | (al << 25));

      s1h = ((eh >>> 14) | (el << 18)) ^ ((eh >>> 18) | (el << 14)) ^ ((el >>> 9) | (eh << 23));
      s1l = ((el >>> 14) | (eh << 18)) ^ ((el >>> 18) | (eh << 14)) ^ ((eh >>> 9) | (el << 23));

      abh = ah & bh;
      abl = al & bl;
      majh = abh ^ (ah & ch) ^ bch;
      majl = abl ^ (al & cl) ^ bcl;

      chh = (eh & fh) ^ (~eh & gh);
      chl = (el & fl) ^ (~el & gl);

      t1h = blocks[j];
      t1l = blocks[j + 1];
      t2h = K[j];
      t2l = K[j + 1];

      c1 = (t2l & 0xFFFF) + (t1l & 0xFFFF) + (chl & 0xFFFF) + (s1l & 0xFFFF) + (hl & 0xFFFF);
      c2 = (t2l >>> 16) + (t1l >>> 16) + (chl >>> 16) + (s1l >>> 16) + (hl >>> 16) + (c1 >>> 16);
      c3 = (t2h & 0xFFFF) + (t1h & 0xFFFF) + (chh & 0xFFFF) + (s1h & 0xFFFF) + (hh & 0xFFFF) + (c2 >>> 16);
      c4 = (t2h >>> 16) + (t1h >>> 16) + (chh >>> 16) + (s1h >>> 16) + (hh >>> 16) + (c3 >>> 16);

      t1h = (c4 << 16) | (c3 & 0xFFFF);
      t1l = (c2 << 16) | (c1 & 0xFFFF);

      c1 = (majl & 0xFFFF) + (s0l & 0xFFFF);
      c2 = (majl >>> 16) + (s0l >>> 16) + (c1 >>> 16);
      c3 = (majh & 0xFFFF) + (s0h & 0xFFFF) + (c2 >>> 16);
      c4 = (majh >>> 16) + (s0h >>> 16) + (c3 >>> 16);

      t2h = (c4 << 16) | (c3 & 0xFFFF);
      t2l = (c2 << 16) | (c1 & 0xFFFF);

      c1 = (dl & 0xFFFF) + (t1l & 0xFFFF);
      c2 = (dl >>> 16) + (t1l >>> 16) + (c1 >>> 16);
      c3 = (dh & 0xFFFF) + (t1h & 0xFFFF) + (c2 >>> 16);
      c4 = (dh >>> 16) + (t1h >>> 16) + (c3 >>> 16);

      hh = (c4 << 16) | (c3 & 0xFFFF);
      hl = (c2 << 16) | (c1 & 0xFFFF);

      c1 = (t2l & 0xFFFF) + (t1l & 0xFFFF);
      c2 = (t2l >>> 16) + (t1l >>> 16) + (c1 >>> 16);
      c3 = (t2h & 0xFFFF) + (t1h & 0xFFFF) + (c2 >>> 16);
      c4 = (t2h >>> 16) + (t1h >>> 16) + (c3 >>> 16);

      dh = (c4 << 16) | (c3 & 0xFFFF);
      dl = (c2 << 16) | (c1 & 0xFFFF);

      s0h = ((dh >>> 28) | (dl << 4)) ^ ((dl >>> 2) | (dh << 30)) ^ ((dl >>> 7) | (dh << 25));
      s0l = ((dl >>> 28) | (dh << 4)) ^ ((dh >>> 2) | (dl << 30)) ^ ((dh >>> 7) | (dl << 25));

      s1h = ((hh >>> 14) | (hl << 18)) ^ ((hh >>> 18) | (hl << 14)) ^ ((hl >>> 9) | (hh << 23));
      s1l = ((hl >>> 14) | (hh << 18)) ^ ((hl >>> 18) | (hh << 14)) ^ ((hh >>> 9) | (hl << 23));

      dah = dh & ah;
      dal = dl & al;
      majh = dah ^ (dh & bh) ^ abh;
      majl = dal ^ (dl & bl) ^ abl;

      chh = (hh & eh) ^ (~hh & fh);
      chl = (hl & el) ^ (~hl & fl);

      t1h = blocks[j + 2];
      t1l = blocks[j + 3];
      t2h = K[j + 2];
      t2l = K[j + 3];

      c1 = (t2l & 0xFFFF) + (t1l & 0xFFFF) + (chl & 0xFFFF) + (s1l & 0xFFFF) + (gl & 0xFFFF);
      c2 = (t2l >>> 16) + (t1l >>> 16) + (chl >>> 16) + (s1l >>> 16) + (gl >>> 16) + (c1 >>> 16);
      c3 = (t2h & 0xFFFF) + (t1h & 0xFFFF) + (chh & 0xFFFF) + (s1h & 0xFFFF) + (gh & 0xFFFF) + (c2 >>> 16);
      c4 = (t2h >>> 16) + (t1h >>> 16) + (chh >>> 16) + (s1h >>> 16) + (gh >>> 16) + (c3 >>> 16);

      t1h = (c4 << 16) | (c3 & 0xFFFF);
      t1l = (c2 << 16) | (c1 & 0xFFFF);

      c1 = (majl & 0xFFFF) + (s0l & 0xFFFF);
      c2 = (majl >>> 16) + (s0l >>> 16) + (c1 >>> 16);
      c3 = (majh & 0xFFFF) + (s0h & 0xFFFF) + (c2 >>> 16);
      c4 = (majh >>> 16) + (s0h >>> 16) + (c3 >>> 16);

      t2h = (c4 << 16) | (c3 & 0xFFFF);
      t2l = (c2 << 16) | (c1 & 0xFFFF);

      c1 = (cl & 0xFFFF) + (t1l & 0xFFFF);
      c2 = (cl >>> 16) + (t1l >>> 16) + (c1 >>> 16);
      c3 = (ch & 0xFFFF) + (t1h & 0xFFFF) + (c2 >>> 16);
      c4 = (ch >>> 16) + (t1h >>> 16) + (c3 >>> 16);

      gh = (c4 << 16) | (c3 & 0xFFFF);
      gl = (c2 << 16) | (c1 & 0xFFFF);

      c1 = (t2l & 0xFFFF) + (t1l & 0xFFFF);
      c2 = (t2l >>> 16) + (t1l >>> 16) + (c1 >>> 16);
      c3 = (t2h & 0xFFFF) + (t1h & 0xFFFF) + (c2 >>> 16);
      c4 = (t2h >>> 16) + (t1h >>> 16) + (c3 >>> 16);

      ch = (c4 << 16) | (c3 & 0xFFFF);
      cl = (c2 << 16) | (c1 & 0xFFFF);

      s0h = ((ch >>> 28) | (cl << 4)) ^ ((cl >>> 2) | (ch << 30)) ^ ((cl >>> 7) | (ch << 25));
      s0l = ((cl >>> 28) | (ch << 4)) ^ ((ch >>> 2) | (cl << 30)) ^ ((ch >>> 7) | (cl << 25));

      s1h = ((gh >>> 14) | (gl << 18)) ^ ((gh >>> 18) | (gl << 14)) ^ ((gl >>> 9) | (gh << 23));
      s1l = ((gl >>> 14) | (gh << 18)) ^ ((gl >>> 18) | (gh << 14)) ^ ((gh >>> 9) | (gl << 23));

      cdh = ch & dh;
      cdl = cl & dl;
      majh = cdh ^ (ch & ah) ^ dah;
      majl = cdl ^ (cl & al) ^ dal;

      chh = (gh & hh) ^ (~gh & eh);
      chl = (gl & hl) ^ (~gl & el);

      t1h = blocks[j + 4];
      t1l = blocks[j + 5];
      t2h = K[j + 4];
      t2l = K[j + 5];

      c1 = (t2l & 0xFFFF) + (t1l & 0xFFFF) + (chl & 0xFFFF) + (s1l & 0xFFFF) + (fl & 0xFFFF);
      c2 = (t2l >>> 16) + (t1l >>> 16) + (chl >>> 16) + (s1l >>> 16) + (fl >>> 16) + (c1 >>> 16);
      c3 = (t2h & 0xFFFF) + (t1h & 0xFFFF) + (chh & 0xFFFF) + (s1h & 0xFFFF) + (fh & 0xFFFF) + (c2 >>> 16);
      c4 = (t2h >>> 16) + (t1h >>> 16) + (chh >>> 16) + (s1h >>> 16) + (fh >>> 16) + (c3 >>> 16);

      t1h = (c4 << 16) | (c3 & 0xFFFF);
      t1l = (c2 << 16) | (c1 & 0xFFFF);

      c1 = (majl & 0xFFFF) + (s0l & 0xFFFF);
      c2 = (majl >>> 16) + (s0l >>> 16) + (c1 >>> 16);
      c3 = (majh & 0xFFFF) + (s0h & 0xFFFF) + (c2 >>> 16);
      c4 = (majh >>> 16) + (s0h >>> 16) + (c3 >>> 16);

      t2h = (c4 << 16) | (c3 & 0xFFFF);
      t2l = (c2 << 16) | (c1 & 0xFFFF);

      c1 = (bl & 0xFFFF) + (t1l & 0xFFFF);
      c2 = (bl >>> 16) + (t1l >>> 16) + (c1 >>> 16);
      c3 = (bh & 0xFFFF) + (t1h & 0xFFFF) + (c2 >>> 16);
      c4 = (bh >>> 16) + (t1h >>> 16) + (c3 >>> 16);

      fh = (c4 << 16) | (c3 & 0xFFFF);
      fl = (c2 << 16) | (c1 & 0xFFFF);

      c1 = (t2l & 0xFFFF) + (t1l & 0xFFFF);
      c2 = (t2l >>> 16) + (t1l >>> 16) + (c1 >>> 16);
      c3 = (t2h & 0xFFFF) + (t1h & 0xFFFF) + (c2 >>> 16);
      c4 = (t2h >>> 16) + (t1h >>> 16) + (c3 >>> 16);

      bh = (c4 << 16) | (c3 & 0xFFFF);
      bl = (c2 << 16) | (c1 & 0xFFFF);

      s0h = ((bh >>> 28) | (bl << 4)) ^ ((bl >>> 2) | (bh << 30)) ^ ((bl >>> 7) | (bh << 25));
      s0l = ((bl >>> 28) | (bh << 4)) ^ ((bh >>> 2) | (bl << 30)) ^ ((bh >>> 7) | (bl << 25));

      s1h = ((fh >>> 14) | (fl << 18)) ^ ((fh >>> 18) | (fl << 14)) ^ ((fl >>> 9) | (fh << 23));
      s1l = ((fl >>> 14) | (fh << 18)) ^ ((fl >>> 18) | (fh << 14)) ^ ((fh >>> 9) | (fl << 23));

      bch = bh & ch;
      bcl = bl & cl;
      majh = bch ^ (bh & dh) ^ cdh;
      majl = bcl ^ (bl & dl) ^ cdl;

      chh = (fh & gh) ^ (~fh & hh);
      chl = (fl & gl) ^ (~fl & hl);

      t1h = blocks[j + 6];
      t1l = blocks[j + 7];
      t2h = K[j + 6];
      t2l = K[j + 7];

      c1 = (t2l & 0xFFFF) + (t1l & 0xFFFF) + (chl & 0xFFFF) + (s1l & 0xFFFF) + (el & 0xFFFF);
      c2 = (t2l >>> 16) + (t1l >>> 16) + (chl >>> 16) + (s1l >>> 16) + (el >>> 16) + (c1 >>> 16);
      c3 = (t2h & 0xFFFF) + (t1h & 0xFFFF) + (chh & 0xFFFF) + (s1h & 0xFFFF) + (eh & 0xFFFF) + (c2 >>> 16);
      c4 = (t2h >>> 16) + (t1h >>> 16) + (chh >>> 16) + (s1h >>> 16) + (eh >>> 16) + (c3 >>> 16);

      t1h = (c4 << 16) | (c3 & 0xFFFF);
      t1l = (c2 << 16) | (c1 & 0xFFFF);

      c1 = (majl & 0xFFFF) + (s0l & 0xFFFF);
      c2 = (majl >>> 16) + (s0l >>> 16) + (c1 >>> 16);
      c3 = (majh & 0xFFFF) + (s0h & 0xFFFF) + (c2 >>> 16);
      c4 = (majh >>> 16) + (s0h >>> 16) + (c3 >>> 16);

      t2h = (c4 << 16) | (c3 & 0xFFFF);
      t2l = (c2 << 16) | (c1 & 0xFFFF);

      c1 = (al & 0xFFFF) + (t1l & 0xFFFF);
      c2 = (al >>> 16) + (t1l >>> 16) + (c1 >>> 16);
      c3 = (ah & 0xFFFF) + (t1h & 0xFFFF) + (c2 >>> 16);
      c4 = (ah >>> 16) + (t1h >>> 16) + (c3 >>> 16);

      eh = (c4 << 16) | (c3 & 0xFFFF);
      el = (c2 << 16) | (c1 & 0xFFFF);

      c1 = (t2l & 0xFFFF) + (t1l & 0xFFFF);
      c2 = (t2l >>> 16) + (t1l >>> 16) + (c1 >>> 16);
      c3 = (t2h & 0xFFFF) + (t1h & 0xFFFF) + (c2 >>> 16);
      c4 = (t2h >>> 16) + (t1h >>> 16) + (c3 >>> 16);

      ah = (c4 << 16) | (c3 & 0xFFFF);
      al = (c2 << 16) | (c1 & 0xFFFF);
    }

    c1 = (h0l & 0xFFFF) + (al & 0xFFFF);
    c2 = (h0l >>> 16) + (al >>> 16) + (c1 >>> 16);
    c3 = (h0h & 0xFFFF) + (ah & 0xFFFF) + (c2 >>> 16);
    c4 = (h0h >>> 16) + (ah >>> 16) + (c3 >>> 16);

    this.h0h = (c4 << 16) | (c3 & 0xFFFF);
    this.h0l = (c2 << 16) | (c1 & 0xFFFF);

    c1 = (h1l & 0xFFFF) + (bl & 0xFFFF);
    c2 = (h1l >>> 16) + (bl >>> 16) + (c1 >>> 16);
    c3 = (h1h & 0xFFFF) + (bh & 0xFFFF) + (c2 >>> 16);
    c4 = (h1h >>> 16) + (bh >>> 16) + (c3 >>> 16);

    this.h1h = (c4 << 16) | (c3 & 0xFFFF);
    this.h1l = (c2 << 16) | (c1 & 0xFFFF);

    c1 = (h2l & 0xFFFF) + (cl & 0xFFFF);
    c2 = (h2l >>> 16) + (cl >>> 16) + (c1 >>> 16);
    c3 = (h2h & 0xFFFF) + (ch & 0xFFFF) + (c2 >>> 16);
    c4 = (h2h >>> 16) + (ch >>> 16) + (c3 >>> 16);

    this.h2h = (c4 << 16) | (c3 & 0xFFFF);
    this.h2l = (c2 << 16) | (c1 & 0xFFFF);

    c1 = (h3l & 0xFFFF) + (dl & 0xFFFF);
    c2 = (h3l >>> 16) + (dl >>> 16) + (c1 >>> 16);
    c3 = (h3h & 0xFFFF) + (dh & 0xFFFF) + (c2 >>> 16);
    c4 = (h3h >>> 16) + (dh >>> 16) + (c3 >>> 16);

    this.h3h = (c4 << 16) | (c3 & 0xFFFF);
    this.h3l = (c2 << 16) | (c1 & 0xFFFF);

    c1 = (h4l & 0xFFFF) + (el & 0xFFFF);
    c2 = (h4l >>> 16) + (el >>> 16) + (c1 >>> 16);
    c3 = (h4h & 0xFFFF) + (eh & 0xFFFF) + (c2 >>> 16);
    c4 = (h4h >>> 16) + (eh >>> 16) + (c3 >>> 16);

    this.h4h = (c4 << 16) | (c3 & 0xFFFF);
    this.h4l = (c2 << 16) | (c1 & 0xFFFF);

    c1 = (h5l & 0xFFFF) + (fl & 0xFFFF);
    c2 = (h5l >>> 16) + (fl >>> 16) + (c1 >>> 16);
    c3 = (h5h & 0xFFFF) + (fh & 0xFFFF) + (c2 >>> 16);
    c4 = (h5h >>> 16) + (fh >>> 16) + (c3 >>> 16);

    this.h5h = (c4 << 16) | (c3 & 0xFFFF);
    this.h5l = (c2 << 16) | (c1 & 0xFFFF);

    c1 = (h6l & 0xFFFF) + (gl & 0xFFFF);
    c2 = (h6l >>> 16) + (gl >>> 16) + (c1 >>> 16);
    c3 = (h6h & 0xFFFF) + (gh & 0xFFFF) + (c2 >>> 16);
    c4 = (h6h >>> 16) + (gh >>> 16) + (c3 >>> 16);

    this.h6h = (c4 << 16) | (c3 & 0xFFFF);
    this.h6l = (c2 << 16) | (c1 & 0xFFFF);

    c1 = (h7l & 0xFFFF) + (hl & 0xFFFF);
    c2 = (h7l >>> 16) + (hl >>> 16) + (c1 >>> 16);
    c3 = (h7h & 0xFFFF) + (hh & 0xFFFF) + (c2 >>> 16);
    c4 = (h7h >>> 16) + (hh >>> 16) + (c3 >>> 16);

    this.h7h = (c4 << 16) | (c3 & 0xFFFF);
    this.h7l = (c2 << 16) | (c1 & 0xFFFF);
  };

  Sha512.prototype.hex = function () {
    this.finalize();

    var h0h = this.h0h, h0l = this.h0l, h1h = this.h1h, h1l = this.h1l,
      h2h = this.h2h, h2l = this.h2l, h3h = this.h3h, h3l = this.h3l,
      h4h = this.h4h, h4l = this.h4l, h5h = this.h5h, h5l = this.h5l,
      h6h = this.h6h, h6l = this.h6l, h7h = this.h7h, h7l = this.h7l,
      bits = this.bits;

    var hex = HEX_CHARS[(h0h >> 28) & 0x0F] + HEX_CHARS[(h0h >> 24) & 0x0F] +
      HEX_CHARS[(h0h >> 20) & 0x0F] + HEX_CHARS[(h0h >> 16) & 0x0F] +
      HEX_CHARS[(h0h >> 12) & 0x0F] + HEX_CHARS[(h0h >> 8) & 0x0F] +
      HEX_CHARS[(h0h >> 4) & 0x0F] + HEX_CHARS[h0h & 0x0F] +
      HEX_CHARS[(h0l >> 28) & 0x0F] + HEX_CHARS[(h0l >> 24) & 0x0F] +
      HEX_CHARS[(h0l >> 20) & 0x0F] + HEX_CHARS[(h0l >> 16) & 0x0F] +
      HEX_CHARS[(h0l >> 12) & 0x0F] + HEX_CHARS[(h0l >> 8) & 0x0F] +
      HEX_CHARS[(h0l >> 4) & 0x0F] + HEX_CHARS[h0l & 0x0F] +
      HEX_CHARS[(h1h >> 28) & 0x0F] + HEX_CHARS[(h1h >> 24) & 0x0F] +
      HEX_CHARS[(h1h >> 20) & 0x0F] + HEX_CHARS[(h1h >> 16) & 0x0F] +
      HEX_CHARS[(h1h >> 12) & 0x0F] + HEX_CHARS[(h1h >> 8) & 0x0F] +
      HEX_CHARS[(h1h >> 4) & 0x0F] + HEX_CHARS[h1h & 0x0F] +
      HEX_CHARS[(h1l >> 28) & 0x0F] + HEX_CHARS[(h1l >> 24) & 0x0F] +
      HEX_CHARS[(h1l >> 20) & 0x0F] + HEX_CHARS[(h1l >> 16) & 0x0F] +
      HEX_CHARS[(h1l >> 12) & 0x0F] + HEX_CHARS[(h1l >> 8) & 0x0F] +
      HEX_CHARS[(h1l >> 4) & 0x0F] + HEX_CHARS[h1l & 0x0F] +
      HEX_CHARS[(h2h >> 28) & 0x0F] + HEX_CHARS[(h2h >> 24) & 0x0F] +
      HEX_CHARS[(h2h >> 20) & 0x0F] + HEX_CHARS[(h2h >> 16) & 0x0F] +
      HEX_CHARS[(h2h >> 12) & 0x0F] + HEX_CHARS[(h2h >> 8) & 0x0F] +
      HEX_CHARS[(h2h >> 4) & 0x0F] + HEX_CHARS[h2h & 0x0F] +
      HEX_CHARS[(h2l >> 28) & 0x0F] + HEX_CHARS[(h2l >> 24) & 0x0F] +
      HEX_CHARS[(h2l >> 20) & 0x0F] + HEX_CHARS[(h2l >> 16) & 0x0F] +
      HEX_CHARS[(h2l >> 12) & 0x0F] + HEX_CHARS[(h2l >> 8) & 0x0F] +
      HEX_CHARS[(h2l >> 4) & 0x0F] + HEX_CHARS[h2l & 0x0F] +
      HEX_CHARS[(h3h >> 28) & 0x0F] + HEX_CHARS[(h3h >> 24) & 0x0F] +
      HEX_CHARS[(h3h >> 20) & 0x0F] + HEX_CHARS[(h3h >> 16) & 0x0F] +
      HEX_CHARS[(h3h >> 12) & 0x0F] + HEX_CHARS[(h3h >> 8) & 0x0F] +
      HEX_CHARS[(h3h >> 4) & 0x0F] + HEX_CHARS[h3h & 0x0F];
    if (bits >= 256) {
      hex += HEX_CHARS[(h3l >> 28) & 0x0F] + HEX_CHARS[(h3l >> 24) & 0x0F] +
        HEX_CHARS[(h3l >> 20) & 0x0F] + HEX_CHARS[(h3l >> 16) & 0x0F] +
        HEX_CHARS[(h3l >> 12) & 0x0F] + HEX_CHARS[(h3l >> 8) & 0x0F] +
        HEX_CHARS[(h3l >> 4) & 0x0F] + HEX_CHARS[h3l & 0x0F];
    }
    if (bits >= 384) {
      hex += HEX_CHARS[(h4h >> 28) & 0x0F] + HEX_CHARS[(h4h >> 24) & 0x0F] +
        HEX_CHARS[(h4h >> 20) & 0x0F] + HEX_CHARS[(h4h >> 16) & 0x0F] +
        HEX_CHARS[(h4h >> 12) & 0x0F] + HEX_CHARS[(h4h >> 8) & 0x0F] +
        HEX_CHARS[(h4h >> 4) & 0x0F] + HEX_CHARS[h4h & 0x0F] +
        HEX_CHARS[(h4l >> 28) & 0x0F] + HEX_CHARS[(h4l >> 24) & 0x0F] +
        HEX_CHARS[(h4l >> 20) & 0x0F] + HEX_CHARS[(h4l >> 16) & 0x0F] +
        HEX_CHARS[(h4l >> 12) & 0x0F] + HEX_CHARS[(h4l >> 8) & 0x0F] +
        HEX_CHARS[(h4l >> 4) & 0x0F] + HEX_CHARS[h4l & 0x0F] +
        HEX_CHARS[(h5h >> 28) & 0x0F] + HEX_CHARS[(h5h >> 24) & 0x0F] +
        HEX_CHARS[(h5h >> 20) & 0x0F] + HEX_CHARS[(h5h >> 16) & 0x0F] +
        HEX_CHARS[(h5h >> 12) & 0x0F] + HEX_CHARS[(h5h >> 8) & 0x0F] +
        HEX_CHARS[(h5h >> 4) & 0x0F] + HEX_CHARS[h5h & 0x0F] +
        HEX_CHARS[(h5l >> 28) & 0x0F] + HEX_CHARS[(h5l >> 24) & 0x0F] +
        HEX_CHARS[(h5l >> 20) & 0x0F] + HEX_CHARS[(h5l >> 16) & 0x0F] +
        HEX_CHARS[(h5l >> 12) & 0x0F] + HEX_CHARS[(h5l >> 8) & 0x0F] +
        HEX_CHARS[(h5l >> 4) & 0x0F] + HEX_CHARS[h5l & 0x0F];
    }
    if (bits == 512) {
      hex += HEX_CHARS[(h6h >> 28) & 0x0F] + HEX_CHARS[(h6h >> 24) & 0x0F] +
        HEX_CHARS[(h6h >> 20) & 0x0F] + HEX_CHARS[(h6h >> 16) & 0x0F] +
        HEX_CHARS[(h6h >> 12) & 0x0F] + HEX_CHARS[(h6h >> 8) & 0x0F] +
        HEX_CHARS[(h6h >> 4) & 0x0F] + HEX_CHARS[h6h & 0x0F] +
        HEX_CHARS[(h6l >> 28) & 0x0F] + HEX_CHARS[(h6l >> 24) & 0x0F] +
        HEX_CHARS[(h6l >> 20) & 0x0F] + HEX_CHARS[(h6l >> 16) & 0x0F] +
        HEX_CHARS[(h6l >> 12) & 0x0F] + HEX_CHARS[(h6l >> 8) & 0x0F] +
        HEX_CHARS[(h6l >> 4) & 0x0F] + HEX_CHARS[h6l & 0x0F] +
        HEX_CHARS[(h7h >> 28) & 0x0F] + HEX_CHARS[(h7h >> 24) & 0x0F] +
        HEX_CHARS[(h7h >> 20) & 0x0F] + HEX_CHARS[(h7h >> 16) & 0x0F] +
        HEX_CHARS[(h7h >> 12) & 0x0F] + HEX_CHARS[(h7h >> 8) & 0x0F] +
        HEX_CHARS[(h7h >> 4) & 0x0F] + HEX_CHARS[h7h & 0x0F] +
        HEX_CHARS[(h7l >> 28) & 0x0F] + HEX_CHARS[(h7l >> 24) & 0x0F] +
        HEX_CHARS[(h7l >> 20) & 0x0F] + HEX_CHARS[(h7l >> 16) & 0x0F] +
        HEX_CHARS[(h7l >> 12) & 0x0F] + HEX_CHARS[(h7l >> 8) & 0x0F] +
        HEX_CHARS[(h7l >> 4) & 0x0F] + HEX_CHARS[h7l & 0x0F];
    }
    return hex;
  };

  Sha512.prototype.toString = Sha512.prototype.hex;

  Sha512.prototype.digest = function () {
    this.finalize();

    var h0h = this.h0h, h0l = this.h0l, h1h = this.h1h, h1l = this.h1l,
      h2h = this.h2h, h2l = this.h2l, h3h = this.h3h, h3l = this.h3l,
      h4h = this.h4h, h4l = this.h4l, h5h = this.h5h, h5l = this.h5l,
      h6h = this.h6h, h6l = this.h6l, h7h = this.h7h, h7l = this.h7l,
      bits = this.bits;

    var arr = [
      (h0h >> 24) & 0xFF, (h0h >> 16) & 0xFF, (h0h >> 8) & 0xFF, h0h & 0xFF,
      (h0l >> 24) & 0xFF, (h0l >> 16) & 0xFF, (h0l >> 8) & 0xFF, h0l & 0xFF,
      (h1h >> 24) & 0xFF, (h1h >> 16) & 0xFF, (h1h >> 8) & 0xFF, h1h & 0xFF,
      (h1l >> 24) & 0xFF, (h1l >> 16) & 0xFF, (h1l >> 8) & 0xFF, h1l & 0xFF,
      (h2h >> 24) & 0xFF, (h2h >> 16) & 0xFF, (h2h >> 8) & 0xFF, h2h & 0xFF,
      (h2l >> 24) & 0xFF, (h2l >> 16) & 0xFF, (h2l >> 8) & 0xFF, h2l & 0xFF,
      (h3h >> 24) & 0xFF, (h3h >> 16) & 0xFF, (h3h >> 8) & 0xFF, h3h & 0xFF
    ];

    if (bits >= 256) {
      arr.push((h3l >> 24) & 0xFF, (h3l >> 16) & 0xFF, (h3l >> 8) & 0xFF, h3l & 0xFF);
    }
    if (bits >= 384) {
      arr.push(
        (h4h >> 24) & 0xFF, (h4h >> 16) & 0xFF, (h4h >> 8) & 0xFF, h4h & 0xFF,
        (h4l >> 24) & 0xFF, (h4l >> 16) & 0xFF, (h4l >> 8) & 0xFF, h4l & 0xFF,
        (h5h >> 24) & 0xFF, (h5h >> 16) & 0xFF, (h5h >> 8) & 0xFF, h5h & 0xFF,
        (h5l >> 24) & 0xFF, (h5l >> 16) & 0xFF, (h5l >> 8) & 0xFF, h5l & 0xFF
      );
    }
    if (bits == 512) {
      arr.push(
        (h6h >> 24) & 0xFF, (h6h >> 16) & 0xFF, (h6h >> 8) & 0xFF, h6h & 0xFF,
        (h6l >> 24) & 0xFF, (h6l >> 16) & 0xFF, (h6l >> 8) & 0xFF, h6l & 0xFF,
        (h7h >> 24) & 0xFF, (h7h >> 16) & 0xFF, (h7h >> 8) & 0xFF, h7h & 0xFF,
        (h7l >> 24) & 0xFF, (h7l >> 16) & 0xFF, (h7l >> 8) & 0xFF, h7l & 0xFF
      );
    }
    return arr;
  };

  Sha512.prototype.array = Sha512.prototype.digest;

  Sha512.prototype.arrayBuffer = function () {
    this.finalize();

    var bits = this.bits;
    var buffer = new ArrayBuffer(bits / 8);
    var dataView = new DataView(buffer);
    dataView.setUint32(0, this.h0h);
    dataView.setUint32(4, this.h0l);
    dataView.setUint32(8, this.h1h);
    dataView.setUint32(12, this.h1l);
    dataView.setUint32(16, this.h2h);
    dataView.setUint32(20, this.h2l);
    dataView.setUint32(24, this.h3h);

    if (bits >= 256) {
      dataView.setUint32(28, this.h3l);
    }
    if (bits >= 384) {
      dataView.setUint32(32, this.h4h);
      dataView.setUint32(36, this.h4l);
      dataView.setUint32(40, this.h5h);
      dataView.setUint32(44, this.h5l);
    }
    if (bits == 512) {
      dataView.setUint32(48, this.h6h);
      dataView.setUint32(52, this.h6l);
      dataView.setUint32(56, this.h7h);
      dataView.setUint32(60, this.h7l);
    }
    return buffer;
  };

  Sha512.prototype.clone = function () {
    var hash = new Sha512(this.bits, false);
    this.copyTo(hash);
    return hash;
  };

  Sha512.prototype.copyTo = function (hash) {
    var i = 0, attrs = [
      'h0h', 'h0l', 'h1h', 'h1l', 'h2h', 'h2l', 'h3h', 'h3l', 'h4h', 'h4l', 'h5h', 'h5l', 'h6h', 'h6l', 'h7h', 'h7l',
      'start', 'bytes', 'hBytes', 'finalized', 'hashed', 'lastByteIndex'
    ];
    for (i = 0; i < attrs.length; ++i) {
      hash[attrs[i]] = this[attrs[i]];
    }
    for (i = 0; i < this.blocks.length; ++i) {
      hash.blocks[i] = this.blocks[i];
    }
  };

  function HmacSha512(key, bits, sharedMemory) {
    var notString, type = typeof key;
    if (type !== 'string') {
      if (type === 'object') {
        if (key === null) {
          throw new Error(INPUT_ERROR);
        } else if (ARRAY_BUFFER && key.constructor === ArrayBuffer) {
          key = new Uint8Array(key);
        } else if (!Array.isArray(key)) {
          if (!ARRAY_BUFFER || !ArrayBuffer.isView(key)) {
            throw new Error(INPUT_ERROR);
          }
        }
      } else {
        throw new Error(INPUT_ERROR);
      }
      notString = true;
    }
    var length = key.length;
    if (!notString) {
      var bytes = [], length = key.length, index = 0, code;
      for (var i = 0; i < length; ++i) {
        code = key.charCodeAt(i);
        if (code < 0x80) {
          bytes[index++] = code;
        } else if (code < 0x800) {
          bytes[index++] = (0xc0 | (code >> 6));
          bytes[index++] = (0x80 | (code & 0x3f));
        } else if (code < 0xd800 || code >= 0xe000) {
          bytes[index++] = (0xe0 | (code >> 12));
          bytes[index++] = (0x80 | ((code >> 6) & 0x3f));
          bytes[index++] = (0x80 | (code & 0x3f));
        } else {
          code = 0x10000 + (((code & 0x3ff) << 10) | (key.charCodeAt(++i) & 0x3ff));
          bytes[index++] = (0xf0 | (code >> 18));
          bytes[index++] = (0x80 | ((code >> 12) & 0x3f));
          bytes[index++] = (0x80 | ((code >> 6) & 0x3f));
          bytes[index++] = (0x80 | (code & 0x3f));
        }
      }
      key = bytes;
    }

    if (key.length > 128) {
      key = (new Sha512(bits, true)).update(key).array();
    }

    var oKeyPad = [], iKeyPad = [];
    for (var i = 0; i < 128; ++i) {
      var b = key[i] || 0;
      oKeyPad[i] = 0x5c ^ b;
      iKeyPad[i] = 0x36 ^ b;
    }

    Sha512.call(this, bits, sharedMemory);

    this.update(iKeyPad);
    this.oKeyPad = oKeyPad;
    this.inner = true;
    this.sharedMemory = sharedMemory;
  }
  HmacSha512.prototype = new Sha512();

  HmacSha512.prototype.finalize = function () {
    Sha512.prototype.finalize.call(this);
    if (this.inner) {
      this.inner = false;
      var innerHash = this.array();
      Sha512.call(this, this.bits, this.sharedMemory);
      this.update(this.oKeyPad);
      this.update(innerHash);
      Sha512.prototype.finalize.call(this);
    }
  };

  HmacSha512.prototype.clone = function () {
    var hash = new HmacSha512([], this.bits, false);
    this.copyTo(hash);
    hash.inner = this.inner;
    for (var i = 0; i < this.oKeyPad.length; ++i) {
      hash.oKeyPad[i] = this.oKeyPad[i];
    }
    return hash;
  };

  var exports = createMethod(512);
  exports.sha512 = exports;
  exports.sha384 = createMethod(384);
  exports.sha512_256 = createMethod(256);
  exports.sha512_224 = createMethod(224);
  exports.sha512.hmac = createHmacMethod(512);
  exports.sha384.hmac = createHmacMethod(384);
  exports.sha512_256.hmac = createHmacMethod(256);
  exports.sha512_224.hmac = createHmacMethod(224);

  if (COMMON_JS) {
    module.exports = exports;
  } else {
    root.sha512 = exports.sha512;
    root.sha384 = exports.sha384;
    root.sha512_256 = exports.sha512_256;
    root.sha512_224 = exports.sha512_224;
    if (AMD) {
      !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
        return exports;
      }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    }
  }
})();

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(180), __webpack_require__(31)))

/***/ }),
/* 334 */
/***/ (function(module, exports) {

module.exports = "<div class=\"signature\">\n    <form class=\"form-horizontal\">\n        <div class=\"form-group\">\n            <label class=\"control-label\">{{'home-evidences-text056' | translate}}</label>\n            <div class=\"control-group\">\n                <input type=\"text\" class=\"form-control\" disabled ng-model=\"$ctrl.uploader.queue[0].file.name\">\n                <div class=\"btn btn-primary file-upload-btn input-group-btn\">\n                    {{$ctrl.packageUploader.queue.length === 0 ? 'home-evidences-text050' : 'home-evidences-text053' | translate}}\n                    <input type=\"file\" class=\"file-input\" nv-file-select uploader=\"$ctrl.uploader\"/>\n                </div>\n            </div>\n            <div class=\"help-block block-error\">\n                <p>{{\"home-evidences-text0551\" | translate}}</p>\n            </div>\n        </div>\n        \n        <div class=\"form-group form-action\">\n            <div class=\"btn btn-primary\" ng-click=\"$ctrl.submitFile()\">{{'home-evidences-text062' | translate}}</div>\n        </div>\n    </form>\n</div>\n";

/***/ }),
/* 335 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAjCAQAAAC00HvSAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAHdElNRQfgCwITHwDUc1sPAAAAtElEQVRIx+3WvQ2CQBjG8T/G0lxYwrjC1YY4gNN4oQenYQDDAI6AcQkC9liQ86Uh5D4KYniqa/jd+z5QkAzEyC6K8p/MHsDAkTsZyunZjpob79IynHiSOo+guHJG87JLFR7ImJRCuskCarn8ukGV3oo5yDTB2Zj5jG8Ks45p4i4F9gM0k7NkaenY00zvcy98XRVvzBLTBQgfYeoA5iFMTuuJtOTCNGgqekeip0LTACTbj8lsvmL6G9BE8AhnAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDE2LTExLTAyVDE5OjMxOjAwKzA4OjAwlKNVfAAAACV0RVh0ZGF0ZTptb2RpZnkAMjAxNi0xMS0wMlQxOTozMTowMCswODowMOX+7cAAAAAZdEVYdFNvZnR3YXJlAEFkb2JlIEltYWdlUmVhZHlxyWU8AAAAAElFTkSuQmCC"

/***/ }),
/* 336 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(51);
var aFunction = __webpack_require__(87);
var SPECIES = __webpack_require__(32)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(84);
var invoke = __webpack_require__(1210);
var html = __webpack_require__(242);
var cel = __webpack_require__(153);
var global = __webpack_require__(25);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(88)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 339 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(51);
var isObject = __webpack_require__(74);
var newPromiseCapability = __webpack_require__(159);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "214c08125fa19a3bedc6cfd85d090540.eot";

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.11';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });

        return result;
      }

      if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });

        return result;
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        if (isObject(srcValue)) {
          stack || (stack = new Stack);
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      var index = -1;
      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array == null ? 0 : array.length,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(array);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      var sourceURL = '//# sourceURL=' +
        ('sourceURL' in options
          ? options.sourceURL
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = (lodashFunc.name + ''),
            names = realNames[key] || (realNames[key] = []);

        names.push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31), __webpack_require__(376)(module)))

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _config = __webpack_require__(1234);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by lency on 9/20/16.
 */
var appConfigModule = _angular2.default.module('app.config', []).provider('AppConfig', function AppConfigProvider() {

    var config = _config2.default;

    this.$get = function AppConfigFactory() {
        return config;
    };

    this.getConf = function (key) {
        return config[key];
    };
}).name;

exports.default = appConfigModule;

// 测试

/***/ }),
/* 344 */
/***/ (function(module, exports) {

/*
 json-stringify-safe
 Like JSON.stringify, but doesn't throw on circular references.

 Originally forked from https://github.com/isaacs/json-stringify-safe
 version 5.0.1 on 3/8/2017 and modified to handle Errors serialization
 and IE8 compatibility. Tests for this are in test/vendor.

 ISC license: https://github.com/isaacs/json-stringify-safe/blob/master/LICENSE
*/

exports = module.exports = stringify;
exports.getSerialize = serializer;

function indexOf(haystack, needle) {
  for (var i = 0; i < haystack.length; ++i) {
    if (haystack[i] === needle) return i;
  }
  return -1;
}

function stringify(obj, replacer, spaces, cycleReplacer) {
  return JSON.stringify(obj, serializer(replacer, cycleReplacer), spaces);
}

// https://github.com/ftlabs/js-abbreviate/blob/fa709e5f139e7770a71827b1893f22418097fbda/index.js#L95-L106
function stringifyError(value) {
  var err = {
    // These properties are implemented as magical getters and don't show up in for in
    stack: value.stack,
    message: value.message,
    name: value.name
  };

  for (var i in value) {
    if (Object.prototype.hasOwnProperty.call(value, i)) {
      err[i] = value[i];
    }
  }

  return err;
}

function serializer(replacer, cycleReplacer) {
  var stack = [];
  var keys = [];

  if (cycleReplacer == null) {
    cycleReplacer = function(key, value) {
      if (stack[0] === value) {
        return '[Circular ~]';
      }
      return '[Circular ~.' + keys.slice(0, indexOf(stack, value)).join('.') + ']';
    };
  }

  return function(key, value) {
    if (stack.length > 0) {
      var thisPos = indexOf(stack, this);
      ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
      ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);

      if (~indexOf(stack, value)) {
        value = cycleReplacer.call(this, key, value);
      }
    } else {
      stack.push(value);
    }

    return replacer == null
      ? value instanceof Error ? stringifyError(value) : value
      : replacer.call(this, key, value);
  };
}


/***/ }),
/* 345 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj4KPHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgMzAgMzAiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8Zz4KCTxwYXRoIGZpbGw9IiMyNUE2MzkiIGQ9Ik0zMCwyNC44NzVDMzAsMjcuNzA2LDI3LjcwNiwzMCwyNC44NzUsMzBINS4xMjVDMi4yOTQsMzAsMCwyNy43MDYsMCwyNC44NzVWNS4xMjVDMCwyLjI5NCwyLjI5NCwwLDUuMTI1LDAKCQloMTkuNzUxQzI3LjcwNiwwLDMwLDIuMjk0LDMwLDUuMTI1VjI0Ljg3NXoiLz4KCTxwYXRoIGZpbGw9IiNGRkZGRkYiIGQ9Ik0xOS45OTcsMTAuODg1Yy0wLjk4LDAuMTUyLTEuOTU2LDAuMjA2LTIuODc1LDAuNDY0Yy0yLjg0NiwwLjgwMS00Ljc4MSwyLjU4Mi01LjM5NCw1LjU0MQoJCWMtMC4xNzksMC44NjUtMC4wMjgsMS43OTctMC4wMjgsMi43NGMtMC45MDcsMC4wODgtMS44NDMtMC4wMzMtMi43NDctMC4zMjhjLTAuNDU4LTAuMTQ5LTAuODEyLTAuMS0xLjIwOCwwLjE3MQoJCWMtMC42NTMsMC40NDgtMS4zNDQsMC44NC0yLjAyMywxLjI1MWMtMC4wOTQsMC4wNTctMC4yMDYsMC4wODMtMC4zODIsMC4xNTJjMC0wLjE5OC0wLjAzMi0wLjM1MiwwLjAwNi0wLjQ4NQoJCWMwLjE3My0wLjYxLDAuMzE4LTEuMjM0LDAuNTY2LTEuODEzYzAuMjAxLTAuNDY3LDAuMDQ4LTAuNjkyLTAuMzEzLTAuOTU2Yy0xLjMxNy0wLjk2NS0yLjE4Mi0yLjI1Ni0yLjU2Mi0zLjg0CgkJQzIuMzI3LDEwLjgyMSwzLjQ4Myw3Ljk3Myw2LjA4OSw2LjE3YzMuNTYtMi40NjQsOC42My0yLjEyNywxMS43NzksMC43ODFjMS4wOTYsMS4wMTIsMS43NTYsMi4yNywyLjEwMSwzLjcwNgoJCWMwLjAxNywwLjA3LDAuMDI1LDAuMTQyLDAuMDMxLDAuMjE0QzIwLjAwMiwxMC44OTYsMTkuOTg2LDEwLjkyNCwxOS45OTcsMTAuODg1eiBNOS4yNzIsOS42NjZjMC4wMDMtMC42NTUtMC40NTEtMS4xMTktMS4xLTEuMTI3CgkJQzcuNDgyLDguNTMxLDYuOTg4LDguOTk1LDYuOTk3LDkuNjQ0YzAuMDA4LDAuNjE3LDAuNTM4LDEuMTExLDEuMTk4LDEuMTE0QzguODMyLDEwLjc2MSw5LjI2OSwxMC4zMTgsOS4yNzIsOS42NjZ6IE0xNi4wNCw5LjY5CgkJYzAuMDA1LTAuNjgzLTAuNDItMS4xNDctMS4wNTctMS4xNTNjLTAuNzA1LTAuMDA3LTEuMTQzLDAuNDE2LTEuMTQ2LDEuMTA2Yy0wLjAwMiwwLjY1OSwwLjQ0OSwxLjEzMiwxLjA4NywxLjE0MQoJCUMxNS41ODksMTAuNzkzLDE2LjAzNSwxMC4zNTYsMTYuMDQsOS42OXoiLz4KCTxwYXRoIGZpbGw9IiNGRkZGRkYiIGQ9Ik0yNS40NzgsMjUuNDc2Yy0wLjE5MS0wLjA4Mi0wLjM5My0wLjE0NS0wLjU3MS0wLjI1Yy0wLjQ2LTAuMjctMC45Mi0wLjU0My0xLjM1OC0wLjg0NwoJCWMtMC4yNy0wLjE4Ny0wLjUwNS0wLjE3NS0wLjgwNy0wLjA4M2MtMy4wMjYsMC45Mi01LjgyNywwLjQ3OC04LjIxNi0xLjYzYy0yLjUwOC0yLjIxNC0yLjU0Ny01Ljk3My0wLjE5OS04LjM5NAoJCWMyLjk3LTMuMDYzLDguNTc1LTMuMDE2LDExLjQ4MSwwLjA5NmMyLjM4NiwyLjU1NiwyLjEzLDYuMzg4LTAuNTkxLDguNTgxYy0wLjI3NiwwLjIyMi0wLjM0OSwwLjQxNS0wLjIwOCwwLjcyOQoJCWMwLjE1OSwwLjM1NSwwLjI5OSwwLjcxOSwwLjQzMSwxLjA4NmMwLjA3LDAuMTk1LDAuMTA3LDAuNDAyLDAuMTU5LDAuNjA0QzI1LjU1OCwyNS40MDMsMjUuNTE4LDI1LjQ0LDI1LjQ3OCwyNS40NzZ6CgkJIE0yMi43NDgsMTYuODk3YzAuNTk2LDAuMDEsMC45ODYtMC4zNTcsMS4wMDctMC45NDhjMC4wMjItMC41ODYtMC4zOTgtMS4wMjUtMC45ODItMS4wMjhjLTAuNjA4LTAuMDAzLTEuMDgzLDAuNDM2LTEuMDgxLDAuOTk5CgkJQzIxLjY5NCwxNi40NjcsMjIuMTQ4LDE2Ljg4NywyMi43NDgsMTYuODk3eiBNMTcuMzg0LDE0LjkyMmMtMC42MDItMC4wMDgtMS4wMjUsMC4zODYtMS4wNDMsMC45NzEKCQljLTAuMDE4LDAuNTY4LDAuNDE3LDEuMDM4LDAuOTc3LDEuMDU1YzAuNTY0LDAuMDE3LDEuMDAzLTAuNDIyLDEuMDA5LTEuMDFDMTguMzMzLDE1LjM1NCwxNy45MzgsMTQuOTI5LDE3LjM4NCwxNC45MjJ6Ii8+CjwvZz4KPC9zdmc+Cg=="

/***/ }),
/* 346 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj4KPHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgMzAgMzAiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8cGF0aCBmaWxsPSIjNDY5NUM5IiBkPSJNMzAsMjQuODc1QzMwLDI3LjcwNiwyNy43MDYsMzAsMjQuODc1LDMwSDUuMTI1QzIuMjk0LDMwLDAsMjcuNzA2LDAsMjQuODc1VjUuMTI1QzAsMi4yOTQsMi4yOTQsMCw1LjEyNSwwCgloMTkuNzUxQzI3LjcwNiwwLDMwLDIuMjk0LDMwLDUuMTI1VjI0Ljg3NXoiLz4KPHBhdGggZmlsbD0iI0ZGRkZGRiIgZD0iTTI5Ljk4MywyMC45NDJjMCwwLTYuODktMi4zNDMtMTAuMzQ5LTMuNTE5YzEuMTItMS45OTUsMi4wMTYtNC4wNjIsMi42NTktNi4yODNjLTAuMTMsMC0wLjIwNiwwLTAuMjgzLDAKCWMtMS44MDMsMC0zLjYwNywwLTUuNDEsMGMtMC4yNTQsMC0wLjI1Ni0wLjAwMi0wLjI1Ni0wLjI0M2MtMC4wMDEtMC41MzEtMC4wMDEtMS4wNjMsMC0xLjU5NGMwLTAuMjk2LDAuMDAxLTAuMjk3LDAuMjk4LTAuMjk3CgljMi4yMDksMCw0LjQxOSwwLDYuNjI4LDBjMC4wNzIsMCwwLjE0My0wLjAwMywwLjIxNS0wLjAwMWMwLjA5NywwLjAwMywwLjE0Mi0wLjAzOSwwLjE0Mi0wLjEzOGMtMC4wMDItMC4yMzMtMC4wMDItMC40NjYsMC0wLjY5OQoJYzAuMDAxLTAuMTE2LTAuMDYtMC4xNi0wLjE2Ny0wLjE2Yy0wLjA3MiwwLTAuMTQzLTAuMDAyLTAuMjE1LTAuMDAyYy0yLjIyMSwwLTQuNDQzLDAtNi42NjQsMGMtMC4yMzYsMC0wLjIzNy0wLjAwMS0wLjIzNy0wLjIzNgoJYzAtMS4wMjctMC4wMDQtMi4wNTQsMC4wMDMtMy4wODFjMC4wMDEtMC4xNzYtMC4wNjMtMC4yMjctMC4yMjktMC4yMjZjLTAuOTQzLDAuMDA0LTEuODg3LDAuMDAxLTIuODMsMC4wMDEKCWMtMC4yNjIsMC0wLjI3NSwwLjAxMy0wLjI3NSwwLjI3MmMtMC4wMDEsMS4wMDksMCwyLjAxOC0wLjAwMSwzLjAyN2MwLDAuMjQyLTAuMDAyLDAuMjQyLTAuMjQ5LDAuMjQyYy0yLjIyNywwLTQuNDU1LDAtNi42ODIsMAoJYy0wLjA0OCwwLTAuMDk2LDAuMDAzLTAuMTQzLDBDNS43OSw3Ljk5OCw1LjcxNyw4LjA1OCw1LjcyNCw4LjIxNWMwLjAwNywwLjE2MSwwLjAwMSwwLjMyMiwwLDAuNDg0CglDNS43MjMsOS4wMDUsNS43MjMsOS4wMDUsNi4wMjIsOS4wMDVjMi4yNDUsMCw0LjQ5LDAsNi43MzYsMGMwLjI0OSwwLDAuMjU0LDAuMDA1LDAuMjU0LDAuMjQ4YzAuMDAxLDAuNTAyLDAuMDA1LDEuMDAzLTAuMDAxLDEuNTA1CgljLTAuMDA0LDAuNDA1LDAuMDgyLDAuMzgyLTAuMzgyLDAuMzgyYy0xLjkxNywwLTMuODM0LDAuMDAxLTUuNzUtMC4wMDZjLTAuMTY5LTAuMDAxLTAuMjIsMC4wNTctMC4yMTMsMC4yMTcKCWMwLjAxLDAuMjAzLDAuMDAyLDAuNDA2LDAuMDAyLDAuNjA5YzAsMC4zNDIsMCwwLjM0MiwwLjM0NSwwLjM0MmMzLjcwOCwwLDcuNDE2LDAsMTEuMTI1LDBjMC4zODUsMCwwLjM3OC0wLjAxLDAuMzE5LDAuMzQzCgljLTAuMDEsMC4wNTktMC4wMTYsMC4xMTgtMC4wMjUsMC4xNzdjLTAuMjA3LDEuMzU5LTAuNzkxLDIuNTU3LTEuNTY0LDMuNjc1Yy0wLjA3MSwwLjEwMy0wLjE0NSwwLjEyMS0wLjI1NiwwLjA5CgljLTAuMzc0LTAuMTA0LTAuNzQ4LTAuMjA2LTEuMTI0LTAuMzAzYy0yLjI5LTAuNTg3LTQuNTgxLTEuMTctNi45NTktMS4yODFjLTEuMjg5LTAuMDYtMi41NTUsMC4wNS0zLjc2NCwwLjUzNAoJYy0wLjgyNSwwLjMzLTEuNTgyLDAuNzc3LTIuMTM1LDEuNDljLTAuODE2LDEuMDUyLTEuMDU1LDIuMjcxLTAuODQ1LDMuNTU3YzAuMzg1LDIuMzUxLDEuODA2LDMuODA3LDQuMDU4LDQuNDc1CgljMS4wOTcsMC4zMjUsMi4yMjEsMC4zNDIsMy4zNTQsMC4yMjJjMS41OTYtMC4xNjksMy4wOTQtMC42Myw0LjQ4Mi0xLjQ0MmMxLjYwNS0wLjkzOSwyLjkyOC0yLjE5Miw0LjA3Ny0zLjY0MQoJYzAuMTY3LTAuMjExLDAuMTY2LTAuMjEyLDAuNDA3LTAuMTA4YzIuMTQzLDAuOTI0LDQuMjg3LDEuODQ3LDYuNDMsMi43NzFjMS43MjEsMC43NDIsMy40NDMsMS40ODMsNS4xNjMsMi4yMjkKCUMyOS44NDYsMjUuMTI5LDMwLDI1LjI2OCwzMCwyNS4yNjhMMjkuOTgzLDIwLjk0MnogTTE0LjM0MiwxOS44ODljLTEuMTU2LDEuMjUxLTIuNDc0LDIuMjgxLTQuMDcyLDIuOTE0CgljLTEuNzgyLDAuNzA2LTMuNTc0LDAuNzE5LTUuMzYzLDAuMDNjLTAuOTIyLTAuMzU1LTEuNjAzLTAuOTc5LTEuOTIxLTEuOTI1Yy0wLjM2OS0xLjA5Ny0wLjA3NS0yLjA4NiwwLjYxNy0yLjk2OQoJYzAuNjQtMC44MTYsMS41MDktMS4yNjMsMi41MDgtMS40NzljMS4xOTEtMC4yNTgsMi4zNzUtMC4xNTksMy41NTIsMC4wOTVjMS45NDMsMC40MiwzLjczOCwxLjIyMyw1LjQ4MiwyLjE1NAoJYzAuMDMxLDAuMDE2LDAuMDU4LDAuMDQsMC4xMjcsMC4wODhDMTQuOTUyLDE5LjE3NCwxNC42NjEsMTkuNTQ0LDE0LjM0MiwxOS44ODl6Ii8+Cjwvc3ZnPgo="

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(84);
var call = __webpack_require__(371);
var isArrayIter = __webpack_require__(372);
var anObject = __webpack_require__(51);
var toLength = __webpack_require__(166);
var getIterFn = __webpack_require__(373);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 348 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 349 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 350 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(770)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(182)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(74);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 353 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {/**
 * oclazyload - Load modules on demand (lazy load) with angularJS
 * @version v1.0.9
 * @link https://github.com/ocombe/ocLazyLoad
 * @license MIT
 * @author Olivier Combe <olivier.combe@gmail.com>
 */
(function (angular, window) {
    'use strict';

    var regModules = ['ng', 'oc.lazyLoad'],
        regInvokes = {},
        regConfigs = [],
        modulesToLoad = [],
        // modules to load from angular.module or other sources
    realModules = [],
        // real modules called from angular.module
    recordDeclarations = [],
        broadcast = angular.noop,
        runBlocks = {},
        justLoaded = [];

    var ocLazyLoad = angular.module('oc.lazyLoad', ['ng']);

    ocLazyLoad.provider('$ocLazyLoad', ["$controllerProvider", "$provide", "$compileProvider", "$filterProvider", "$injector", "$animateProvider", function ($controllerProvider, $provide, $compileProvider, $filterProvider, $injector, $animateProvider) {
        var modules = {},
            providers = {
            $controllerProvider: $controllerProvider,
            $compileProvider: $compileProvider,
            $filterProvider: $filterProvider,
            $provide: $provide, // other things (constant, decorator, provider, factory, service)
            $injector: $injector,
            $animateProvider: $animateProvider
        },
            debug = false,
            events = false,
            moduleCache = [],
            modulePromises = {};

        moduleCache.push = function (value) {
            if (this.indexOf(value) === -1) {
                Array.prototype.push.apply(this, arguments);
            }
        };

        this.config = function (config) {
            // If we want to define modules configs
            if (angular.isDefined(config.modules)) {
                if (angular.isArray(config.modules)) {
                    angular.forEach(config.modules, function (moduleConfig) {
                        modules[moduleConfig.name] = moduleConfig;
                    });
                } else {
                    modules[config.modules.name] = config.modules;
                }
            }

            if (angular.isDefined(config.debug)) {
                debug = config.debug;
            }

            if (angular.isDefined(config.events)) {
                events = config.events;
            }
        };

        /**
         * Get the list of existing registered modules
         * @param element
         */
        this._init = function _init(element) {
            // this is probably useless now because we override angular.bootstrap
            if (modulesToLoad.length === 0) {
                var elements = [element],
                    names = ['ng:app', 'ng-app', 'x-ng-app', 'data-ng-app'],
                    NG_APP_CLASS_REGEXP = /\sng[:\-]app(:\s*([\w\d_]+);?)?\s/,
                    append = function append(elm) {
                    return elm && elements.push(elm);
                };

                angular.forEach(names, function (name) {
                    names[name] = true;
                    append(document.getElementById(name));
                    name = name.replace(':', '\\:');
                    if (typeof element[0] !== 'undefined' && element[0].querySelectorAll) {
                        angular.forEach(element[0].querySelectorAll('.' + name), append);
                        angular.forEach(element[0].querySelectorAll('.' + name + '\\:'), append);
                        angular.forEach(element[0].querySelectorAll('[' + name + ']'), append);
                    }
                });

                angular.forEach(elements, function (elm) {
                    if (modulesToLoad.length === 0) {
                        var className = ' ' + element.className + ' ';
                        var match = NG_APP_CLASS_REGEXP.exec(className);
                        if (match) {
                            modulesToLoad.push((match[2] || '').replace(/\s+/g, ','));
                        } else {
                            angular.forEach(elm.attributes, function (attr) {
                                if (modulesToLoad.length === 0 && names[attr.name]) {
                                    modulesToLoad.push(attr.value);
                                }
                            });
                        }
                    }
                });
            }

            if (modulesToLoad.length === 0 && !((window.jasmine || window.mocha) && angular.isDefined(angular.mock))) {
                console.error('No module found during bootstrap, unable to init ocLazyLoad. You should always use the ng-app directive or angular.boostrap when you use ocLazyLoad.');
            }

            var addReg = function addReg(moduleName) {
                if (regModules.indexOf(moduleName) === -1) {
                    // register existing modules
                    regModules.push(moduleName);
                    var mainModule = angular.module(moduleName);

                    // register existing components (directives, services, ...)
                    _invokeQueue(null, mainModule._invokeQueue, moduleName);
                    _invokeQueue(null, mainModule._configBlocks, moduleName); // angular 1.3+

                    angular.forEach(mainModule.requires, addReg);
                }
            };

            angular.forEach(modulesToLoad, function (moduleName) {
                addReg(moduleName);
            });

            modulesToLoad = []; // reset for next bootstrap
            recordDeclarations.pop(); // wait for the next lazy load
        };

        /**
         * Like JSON.stringify but that doesn't throw on circular references
         * @param obj
         */
        var stringify = function stringify(obj) {
            try {
                return JSON.stringify(obj);
            } catch (e) {
                var cache = [];
                return JSON.stringify(obj, function (key, value) {
                    if (angular.isObject(value) && value !== null) {
                        if (cache.indexOf(value) !== -1) {
                            // Circular reference found, discard key
                            return;
                        }
                        // Store value in our collection
                        cache.push(value);
                    }
                    return value;
                });
            }
        };

        var hashCode = function hashCode(str) {
            var hash = 0,
                i,
                chr,
                len;
            if (str.length == 0) {
                return hash;
            }
            for (i = 0, len = str.length; i < len; i++) {
                chr = str.charCodeAt(i);
                hash = (hash << 5) - hash + chr;
                hash |= 0; // Convert to 32bit integer
            }
            return hash;
        };

        function _register(providers, registerModules, params) {
            if (registerModules) {
                var k,
                    moduleName,
                    moduleFn,
                    tempRunBlocks = [];
                for (k = registerModules.length - 1; k >= 0; k--) {
                    moduleName = registerModules[k];
                    if (!angular.isString(moduleName)) {
                        moduleName = getModuleName(moduleName);
                    }
                    if (!moduleName || justLoaded.indexOf(moduleName) !== -1 || modules[moduleName] && realModules.indexOf(moduleName) === -1) {
                        continue;
                    }
                    // new if not registered
                    var newModule = regModules.indexOf(moduleName) === -1;
                    moduleFn = ngModuleFct(moduleName);
                    if (newModule) {
                        regModules.push(moduleName);
                        _register(providers, moduleFn.requires, params);
                    }
                    if (moduleFn._runBlocks.length > 0) {
                        // new run blocks detected! Replace the old ones (if existing)
                        runBlocks[moduleName] = [];
                        while (moduleFn._runBlocks.length > 0) {
                            runBlocks[moduleName].push(moduleFn._runBlocks.shift());
                        }
                    }
                    if (angular.isDefined(runBlocks[moduleName]) && (newModule || params.rerun)) {
                        tempRunBlocks = tempRunBlocks.concat(runBlocks[moduleName]);
                    }
                    _invokeQueue(providers, moduleFn._invokeQueue, moduleName, params.reconfig);
                    _invokeQueue(providers, moduleFn._configBlocks, moduleName, params.reconfig); // angular 1.3+
                    broadcast(newModule ? 'ocLazyLoad.moduleLoaded' : 'ocLazyLoad.moduleReloaded', moduleName);
                    registerModules.pop();
                    justLoaded.push(moduleName);
                }
                // execute the run blocks at the end
                var instanceInjector = providers.getInstanceInjector();
                angular.forEach(tempRunBlocks, function (fn) {
                    instanceInjector.invoke(fn);
                });
            }
        }

        function _registerInvokeList(args, moduleName) {
            var invokeList = args[2][0],
                type = args[1],
                newInvoke = false;
            if (angular.isUndefined(regInvokes[moduleName])) {
                regInvokes[moduleName] = {};
            }
            if (angular.isUndefined(regInvokes[moduleName][type])) {
                regInvokes[moduleName][type] = {};
            }
            var onInvoke = function onInvoke(invokeName, invoke) {
                if (!regInvokes[moduleName][type].hasOwnProperty(invokeName)) {
                    regInvokes[moduleName][type][invokeName] = [];
                }
                if (checkHashes(invoke, regInvokes[moduleName][type][invokeName])) {
                    newInvoke = true;
                    regInvokes[moduleName][type][invokeName].push(invoke);
                    broadcast('ocLazyLoad.componentLoaded', [moduleName, type, invokeName]);
                }
            };

            function checkHashes(potentialNew, invokes) {
                var isNew = true,
                    newHash;
                if (invokes.length) {
                    newHash = signature(potentialNew);
                    angular.forEach(invokes, function (invoke) {
                        isNew = isNew && signature(invoke) !== newHash;
                    });
                }
                return isNew;
            }

            function signature(data) {
                if (angular.isArray(data)) {
                    // arrays are objects, we need to test for it first
                    return hashCode(data.toString());
                } else if (angular.isObject(data)) {
                    // constants & values for example
                    return hashCode(stringify(data));
                } else {
                    if (angular.isDefined(data) && data !== null) {
                        return hashCode(data.toString());
                    } else {
                        // null & undefined constants
                        return data;
                    }
                }
            }

            if (angular.isString(invokeList)) {
                onInvoke(invokeList, args[2][1]);
            } else if (angular.isObject(invokeList)) {
                angular.forEach(invokeList, function (invoke, key) {
                    if (angular.isString(invoke)) {
                        // decorators for example
                        onInvoke(invoke, invokeList[1]);
                    } else {
                        // components registered as object lists {"componentName": function() {}}
                        onInvoke(key, invoke);
                    }
                });
            } else {
                return false;
            }
            return newInvoke;
        }

        function _invokeQueue(providers, queue, moduleName, reconfig) {
            if (!queue) {
                return;
            }

            var i, len, args, provider;
            for (i = 0, len = queue.length; i < len; i++) {
                args = queue[i];
                if (angular.isArray(args)) {
                    if (providers !== null) {
                        if (providers.hasOwnProperty(args[0])) {
                            provider = providers[args[0]];
                        } else {
                            throw new Error('unsupported provider ' + args[0]);
                        }
                    }
                    var isNew = _registerInvokeList(args, moduleName);
                    if (args[1] !== 'invoke') {
                        if (isNew && angular.isDefined(provider)) {
                            provider[args[1]].apply(provider, args[2]);
                        }
                    } else {
                        // config block
                        var callInvoke = function callInvoke(fct) {
                            var invoked = regConfigs.indexOf(moduleName + '-' + fct);
                            if (invoked === -1 || reconfig) {
                                if (invoked === -1) {
                                    regConfigs.push(moduleName + '-' + fct);
                                }
                                if (angular.isDefined(provider)) {
                                    provider[args[1]].apply(provider, args[2]);
                                }
                            }
                        };
                        if (angular.isFunction(args[2][0])) {
                            callInvoke(args[2][0]);
                        } else if (angular.isArray(args[2][0])) {
                            for (var j = 0, jlen = args[2][0].length; j < jlen; j++) {
                                if (angular.isFunction(args[2][0][j])) {
                                    callInvoke(args[2][0][j]);
                                }
                            }
                        }
                    }
                }
            }
        }

        function getModuleName(module) {
            var moduleName = null;
            if (angular.isString(module)) {
                moduleName = module;
            } else if (angular.isObject(module) && module.hasOwnProperty('name') && angular.isString(module.name)) {
                moduleName = module.name;
            }
            return moduleName;
        }

        function moduleExists(moduleName) {
            if (!angular.isString(moduleName)) {
                return false;
            }
            try {
                return ngModuleFct(moduleName);
            } catch (e) {
                if (/No module/.test(e) || e.message.indexOf('$injector:nomod') > -1) {
                    return false;
                }
            }
        }

        this.$get = ["$log", "$rootElement", "$rootScope", "$cacheFactory", "$q", function ($log, $rootElement, $rootScope, $cacheFactory, $q) {
            var instanceInjector,
                filesCache = $cacheFactory('ocLazyLoad');

            if (!debug) {
                $log = {};
                $log['error'] = angular.noop;
                $log['warn'] = angular.noop;
                $log['info'] = angular.noop;
            }

            // Make this lazy because when $get() is called the instance injector hasn't been assigned to the rootElement yet
            providers.getInstanceInjector = function () {
                return instanceInjector ? instanceInjector : instanceInjector = $rootElement.data('$injector') || angular.injector();
            };

            broadcast = function broadcast(eventName, params) {
                if (events) {
                    $rootScope.$broadcast(eventName, params);
                }
                if (debug) {
                    $log.info(eventName, params);
                }
            };

            function reject(e) {
                var deferred = $q.defer();
                $log.error(e.message);
                deferred.reject(e);
                return deferred.promise;
            }

            return {
                _broadcast: broadcast,

                _$log: $log,

                /**
                 * Returns the files cache used by the loaders to store the files currently loading
                 * @returns {*}
                 */
                _getFilesCache: function getFilesCache() {
                    return filesCache;
                },

                /**
                 * Let the service know that it should monitor angular.module because files are loading
                 * @param watch boolean
                 */
                toggleWatch: function toggleWatch(watch) {
                    if (watch) {
                        recordDeclarations.push(true);
                    } else {
                        recordDeclarations.pop();
                    }
                },

                /**
                 * Let you get a module config object
                 * @param moduleName String the name of the module
                 * @returns {*}
                 */
                getModuleConfig: function getModuleConfig(moduleName) {
                    if (!angular.isString(moduleName)) {
                        throw new Error('You need to give the name of the module to get');
                    }
                    if (!modules[moduleName]) {
                        return null;
                    }
                    return angular.copy(modules[moduleName]);
                },

                /**
                 * Let you define a module config object
                 * @param moduleConfig Object the module config object
                 * @returns {*}
                 */
                setModuleConfig: function setModuleConfig(moduleConfig) {
                    if (!angular.isObject(moduleConfig)) {
                        throw new Error('You need to give the module config object to set');
                    }
                    modules[moduleConfig.name] = moduleConfig;
                    return moduleConfig;
                },

                /**
                 * Returns the list of loaded modules
                 * @returns {string[]}
                 */
                getModules: function getModules() {
                    return regModules;
                },

                /**
                 * Let you check if a module has been loaded into Angular or not
                 * @param modulesNames String/Object a module name, or a list of module names
                 * @returns {boolean}
                 */
                isLoaded: function isLoaded(modulesNames) {
                    var moduleLoaded = function moduleLoaded(module) {
                        var isLoaded = regModules.indexOf(module) > -1;
                        if (!isLoaded) {
                            isLoaded = !!moduleExists(module);
                        }
                        return isLoaded;
                    };
                    if (angular.isString(modulesNames)) {
                        modulesNames = [modulesNames];
                    }
                    if (angular.isArray(modulesNames)) {
                        var i, len;
                        for (i = 0, len = modulesNames.length; i < len; i++) {
                            if (!moduleLoaded(modulesNames[i])) {
                                return false;
                            }
                        }
                        return true;
                    } else {
                        throw new Error('You need to define the module(s) name(s)');
                    }
                },

                /**
                 * Given a module, return its name
                 * @param module
                 * @returns {String}
                 */
                _getModuleName: getModuleName,

                /**
                 * Returns a module if it exists
                 * @param moduleName
                 * @returns {module}
                 */
                _getModule: function getModule(moduleName) {
                    try {
                        return ngModuleFct(moduleName);
                    } catch (e) {
                        // this error message really suxx
                        if (/No module/.test(e) || e.message.indexOf('$injector:nomod') > -1) {
                            e.message = 'The module "' + stringify(moduleName) + '" that you are trying to load does not exist. ' + e.message;
                        }
                        throw e;
                    }
                },

                /**
                 * Check if a module exists and returns it if it does
                 * @param moduleName
                 * @returns {boolean}
                 */
                moduleExists: moduleExists,

                /**
                 * Load the dependencies, and might try to load new files depending on the config
                 * @param moduleName (String or Array of Strings)
                 * @param localParams
                 * @returns {*}
                 * @private
                 */
                _loadDependencies: function _loadDependencies(moduleName, localParams) {
                    var loadedModule,
                        requires,
                        diff,
                        promisesList = [],
                        self = this;

                    moduleName = self._getModuleName(moduleName);

                    if (moduleName === null) {
                        return $q.when();
                    } else {
                        try {
                            loadedModule = self._getModule(moduleName);
                        } catch (e) {
                            return reject(e);
                        }
                        // get unloaded requires
                        requires = self.getRequires(loadedModule);
                    }

                    angular.forEach(requires, function (requireEntry) {
                        // If no configuration is provided, try and find one from a previous load.
                        // If there isn't one, bail and let the normal flow run
                        if (angular.isString(requireEntry)) {
                            var config = self.getModuleConfig(requireEntry);
                            if (config === null) {
                                moduleCache.push(requireEntry); // We don't know about this module, but something else might, so push it anyway.
                                return;
                            }
                            requireEntry = config;
                            // ignore the name because it's probably not a real module name
                            config.name = undefined;
                        }

                        // Check if this dependency has been loaded previously
                        if (self.moduleExists(requireEntry.name)) {
                            // compare against the already loaded module to see if the new definition adds any new files
                            diff = requireEntry.files.filter(function (n) {
                                return self.getModuleConfig(requireEntry.name).files.indexOf(n) < 0;
                            });

                            // If the module was redefined, advise via the console
                            if (diff.length !== 0) {
                                self._$log.warn('Module "', moduleName, '" attempted to redefine configuration for dependency. "', requireEntry.name, '"\n Additional Files Loaded:', diff);
                            }

                            // Push everything to the file loader, it will weed out the duplicates.
                            if (angular.isDefined(self.filesLoader)) {
                                // if a files loader is defined
                                promisesList.push(self.filesLoader(requireEntry, localParams).then(function () {
                                    return self._loadDependencies(requireEntry);
                                }));
                            } else {
                                return reject(new Error('Error: New dependencies need to be loaded from external files (' + requireEntry.files + '), but no loader has been defined.'));
                            }
                            return;
                        } else if (angular.isArray(requireEntry)) {
                            var files = [];
                            angular.forEach(requireEntry, function (entry) {
                                // let's check if the entry is a file name or a config name
                                var config = self.getModuleConfig(entry);
                                if (config === null) {
                                    files.push(entry);
                                } else if (config.files) {
                                    files = files.concat(config.files);
                                }
                            });
                            if (files.length > 0) {
                                requireEntry = {
                                    files: files
                                };
                            }
                        } else if (angular.isObject(requireEntry)) {
                            if (requireEntry.hasOwnProperty('name') && requireEntry['name']) {
                                // The dependency doesn't exist in the module cache and is a new configuration, so store and push it.
                                self.setModuleConfig(requireEntry);
                                moduleCache.push(requireEntry['name']);
                            }
                        }

                        // Check if the dependency has any files that need to be loaded. If there are, push a new promise to the promise list.
                        if (angular.isDefined(requireEntry.files) && requireEntry.files.length !== 0) {
                            if (angular.isDefined(self.filesLoader)) {
                                // if a files loader is defined
                                promisesList.push(self.filesLoader(requireEntry, localParams).then(function () {
                                    return self._loadDependencies(requireEntry);
                                }));
                            } else {
                                return reject(new Error('Error: the module "' + requireEntry.name + '" is defined in external files (' + requireEntry.files + '), but no loader has been defined.'));
                            }
                        }
                    });

                    // Create a wrapper promise to watch the promise list and resolve it once everything is done.
                    return $q.all(promisesList);
                },

                /**
                 * Inject new modules into Angular
                 * @param moduleName
                 * @param localParams
                 * @param real
                 */
                inject: function inject(moduleName) {
                    var localParams = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
                    var real = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];

                    var self = this,
                        deferred = $q.defer();
                    if (angular.isDefined(moduleName) && moduleName !== null) {
                        if (angular.isArray(moduleName)) {
                            var promisesList = [];
                            angular.forEach(moduleName, function (module) {
                                promisesList.push(self.inject(module, localParams, real));
                            });
                            return $q.all(promisesList);
                        } else {
                            self._addToLoadList(self._getModuleName(moduleName), true, real);
                        }
                    }
                    if (modulesToLoad.length > 0) {
                        var res = modulesToLoad.slice(); // clean copy
                        var loadNext = function loadNext(moduleName) {
                            moduleCache.push(moduleName);
                            modulePromises[moduleName] = deferred.promise;
                            self._loadDependencies(moduleName, localParams).then(function success() {
                                try {
                                    justLoaded = [];
                                    _register(providers, moduleCache, localParams);
                                } catch (e) {
                                    self._$log.error(e.message);
                                    deferred.reject(e);
                                    return;
                                }

                                if (modulesToLoad.length > 0) {
                                    loadNext(modulesToLoad.shift()); // load the next in list
                                } else {
                                        deferred.resolve(res); // everything has been loaded, resolve
                                    }
                            }, function error(err) {
                                deferred.reject(err);
                            });
                        };

                        // load the first in list
                        loadNext(modulesToLoad.shift());
                    } else if (localParams && localParams.name && modulePromises[localParams.name]) {
                        return modulePromises[localParams.name];
                    } else {
                        deferred.resolve();
                    }
                    return deferred.promise;
                },

                /**
                 * Get the list of required modules/services/... for this module
                 * @param module
                 * @returns {Array}
                 */
                getRequires: function getRequires(module) {
                    var requires = [];
                    angular.forEach(module.requires, function (requireModule) {
                        if (regModules.indexOf(requireModule) === -1) {
                            requires.push(requireModule);
                        }
                    });
                    return requires;
                },

                /**
                 * Invoke the new modules & component by their providers
                 * @param providers
                 * @param queue
                 * @param moduleName
                 * @param reconfig
                 * @private
                 */
                _invokeQueue: _invokeQueue,

                /**
                 * Check if a module has been invoked and registers it if not
                 * @param args
                 * @param moduleName
                 * @returns {boolean} is new
                 */
                _registerInvokeList: _registerInvokeList,

                /**
                 * Register a new module and loads it, executing the run/config blocks if needed
                 * @param providers
                 * @param registerModules
                 * @param params
                 * @private
                 */
                _register: _register,

                /**
                 * Add a module name to the list of modules that will be loaded in the next inject
                 * @param name
                 * @param force
                 * @private
                 */
                _addToLoadList: _addToLoadList,

                /**
                 * Unregister modules (you shouldn't have to use this)
                 * @param modules
                 */
                _unregister: function _unregister(modules) {
                    if (angular.isDefined(modules)) {
                        if (angular.isArray(modules)) {
                            angular.forEach(modules, function (module) {
                                regInvokes[module] = undefined;
                            });
                        }
                    }
                }
            };
        }];

        // Let's get the list of loaded modules & components
        this._init(angular.element(window.document));
    }]);

    var bootstrapFct = angular.bootstrap;
    angular.bootstrap = function (element, modules, config) {
        // we use slice to make a clean copy
        angular.forEach(modules.slice(), function (module) {
            _addToLoadList(module, true, true);
        });
        return bootstrapFct(element, modules, config);
    };

    var _addToLoadList = function _addToLoadList(name, force, real) {
        if ((recordDeclarations.length > 0 || force) && angular.isString(name) && modulesToLoad.indexOf(name) === -1) {
            modulesToLoad.push(name);
            if (real) {
                realModules.push(name);
            }
        }
    };

    var ngModuleFct = angular.module;
    angular.module = function (name, requires, configFn) {
        _addToLoadList(name, false, true);
        return ngModuleFct(name, requires, configFn);
    };

    // CommonJS package manager support:
    if (typeof module !== 'undefined' && typeof exports !== 'undefined' && module.exports === exports) {
        module.exports = 'oc.lazyLoad';
    }
})(angular, window);
(function (angular) {
    'use strict';

    angular.module('oc.lazyLoad').directive('ocLazyLoad', ["$ocLazyLoad", "$compile", "$animate", "$parse", "$timeout", function ($ocLazyLoad, $compile, $animate, $parse, $timeout) {
        return {
            restrict: 'A',
            terminal: true,
            priority: 1000,
            compile: function compile(element, attrs) {
                // we store the content and remove it before compilation
                var content = element[0].innerHTML;
                element.html('');

                return function ($scope, $element, $attr) {
                    var model = $parse($attr.ocLazyLoad);
                    $scope.$watch(function () {
                        return model($scope) || $attr.ocLazyLoad; // it can be a module name (string), an object, an array, or a scope reference to any of this
                    }, function (moduleName) {
                        if (angular.isDefined(moduleName)) {
                            $ocLazyLoad.load(moduleName).then(function () {
                                // Attach element contents to DOM and then compile them.
                                // This prevents an issue where IE invalidates saved element objects (HTMLCollections)
                                // of the compiled contents when attaching to the parent DOM.
                                $animate.enter(content, $element);
                                // get the new content & compile it
                                $compile($element.contents())($scope);
                            });
                        }
                    }, true);
                };
            }
        };
    }]);
})(angular);
(function (angular) {
    'use strict';

    angular.module('oc.lazyLoad').config(["$provide", function ($provide) {
        $provide.decorator('$ocLazyLoad', ["$delegate", "$q", "$window", "$interval", function ($delegate, $q, $window, $interval) {
            var uaCssChecked = false,
                useCssLoadPatch = false,
                anchor = $window.document.getElementsByTagName('head')[0] || $window.document.getElementsByTagName('body')[0];

            /**
             * Load a js/css file
             * @param type
             * @param path
             * @param params
             * @returns promise
             */
            $delegate.buildElement = function buildElement(type, path, params) {
                var deferred = $q.defer(),
                    el,
                    loaded,
                    filesCache = $delegate._getFilesCache(),
                    cacheBuster = function cacheBuster(url) {
                    var dc = new Date().getTime();
                    if (url.indexOf('?') >= 0) {
                        if (url.substring(0, url.length - 1) === '&') {
                            return url + '_dc=' + dc;
                        }
                        return url + '&_dc=' + dc;
                    } else {
                        return url + '?_dc=' + dc;
                    }
                };

                // Store the promise early so the file load can be detected by other parallel lazy loads
                // (ie: multiple routes on one page) a 'true' value isn't sufficient
                // as it causes false positive load results.
                if (angular.isUndefined(filesCache.get(path))) {
                    filesCache.put(path, deferred.promise);
                }

                // Switch in case more content types are added later
                switch (type) {
                    case 'css':
                        el = $window.document.createElement('link');
                        el.type = 'text/css';
                        el.rel = 'stylesheet';
                        el.href = params.cache === false ? cacheBuster(path) : path;
                        break;
                    case 'js':
                        el = $window.document.createElement('script');
                        el.src = params.cache === false ? cacheBuster(path) : path;
                        break;
                    default:
                        filesCache.remove(path);
                        deferred.reject(new Error('Requested type "' + type + '" is not known. Could not inject "' + path + '"'));
                        break;
                }
                el.onload = el['onreadystatechange'] = function (e) {
                    if (el['readyState'] && !/^c|loade/.test(el['readyState']) || loaded) return;
                    el.onload = el['onreadystatechange'] = null;
                    loaded = 1;
                    $delegate._broadcast('ocLazyLoad.fileLoaded', path);
                    deferred.resolve();
                };
                el.onerror = function () {
                    filesCache.remove(path);
                    deferred.reject(new Error('Unable to load ' + path));
                };
                el.async = params.serie ? 0 : 1;

                var insertBeforeElem = anchor.lastChild;
                if (params.insertBefore) {
                    var element = angular.element(angular.isDefined(__webpack_provided_window_dot_jQuery) ? params.insertBefore : document.querySelector(params.insertBefore));
                    if (element && element.length > 0) {
                        insertBeforeElem = element[0];
                    }
                }
                insertBeforeElem.parentNode.insertBefore(el, insertBeforeElem);

                /*
                 The event load or readystatechange doesn't fire in:
                 - iOS < 6       (default mobile browser)
                 - Android < 4.4 (default mobile browser)
                 - Safari < 6    (desktop browser)
                 */
                if (type == 'css') {
                    if (!uaCssChecked) {
                        var ua = $window.navigator.userAgent.toLowerCase();

                        // iOS < 6
                        if (/iP(hone|od|ad)/.test($window.navigator.platform)) {
                            var v = $window.navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
                            var iOSVersion = parseFloat([parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)].join('.'));
                            useCssLoadPatch = iOSVersion < 6;
                        } else if (ua.indexOf("android") > -1) {
                            // Android < 4.4
                            var androidVersion = parseFloat(ua.slice(ua.indexOf("android") + 8));
                            useCssLoadPatch = androidVersion < 4.4;
                        } else if (ua.indexOf('safari') > -1) {
                            var versionMatch = ua.match(/version\/([\.\d]+)/i);
                            useCssLoadPatch = versionMatch && versionMatch[1] && parseFloat(versionMatch[1]) < 6;
                        }
                    }

                    if (useCssLoadPatch) {
                        var tries = 1000; // * 20 = 20000 miliseconds
                        var interval = $interval(function () {
                            try {
                                el.sheet.cssRules;
                                $interval.cancel(interval);
                                el.onload();
                            } catch (e) {
                                if (--tries <= 0) {
                                    el.onerror();
                                }
                            }
                        }, 20);
                    }
                }

                return deferred.promise;
            };

            return $delegate;
        }]);
    }]);
})(angular);
(function (angular) {
    'use strict';

    angular.module('oc.lazyLoad').config(["$provide", function ($provide) {
        $provide.decorator('$ocLazyLoad', ["$delegate", "$q", function ($delegate, $q) {
            /**
             * The function that loads new files
             * @param config
             * @param params
             * @returns {*}
             */
            $delegate.filesLoader = function filesLoader(config) {
                var params = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

                var cssFiles = [],
                    templatesFiles = [],
                    jsFiles = [],
                    promises = [],
                    cachePromise = null,
                    filesCache = $delegate._getFilesCache();

                $delegate.toggleWatch(true); // start watching angular.module calls

                angular.extend(params, config);

                var pushFile = function pushFile(path) {
                    var file_type = null,
                        m;
                    if (angular.isObject(path)) {
                        file_type = path.type;
                        path = path.path;
                    }
                    cachePromise = filesCache.get(path);
                    if (angular.isUndefined(cachePromise) || params.cache === false) {

                        // always check for requirejs syntax just in case
                        if ((m = /^(css|less|html|htm|js)?(?=!)/.exec(path)) !== null) {
                            // Detect file type using preceding type declaration (ala requireJS)
                            file_type = m[1];
                            path = path.substr(m[1].length + 1, path.length); // Strip the type from the path
                        }

                        if (!file_type) {
                            if ((m = /[.](css|less|html|htm|js)?((\?|#).*)?$/.exec(path)) !== null) {
                                // Detect file type via file extension
                                file_type = m[1];
                            } else if (!$delegate.jsLoader.hasOwnProperty('ocLazyLoadLoader') && $delegate.jsLoader.hasOwnProperty('requirejs')) {
                                // requirejs
                                file_type = 'js';
                            } else {
                                $delegate._$log.error('File type could not be determined. ' + path);
                                return;
                            }
                        }

                        if ((file_type === 'css' || file_type === 'less') && cssFiles.indexOf(path) === -1) {
                            cssFiles.push(path);
                        } else if ((file_type === 'html' || file_type === 'htm') && templatesFiles.indexOf(path) === -1) {
                            templatesFiles.push(path);
                        } else if (file_type === 'js' || jsFiles.indexOf(path) === -1) {
                            jsFiles.push(path);
                        } else {
                            $delegate._$log.error('File type is not valid. ' + path);
                        }
                    } else if (cachePromise) {
                        promises.push(cachePromise);
                    }
                };

                if (params.serie) {
                    pushFile(params.files.shift());
                } else {
                    angular.forEach(params.files, function (path) {
                        pushFile(path);
                    });
                }

                if (cssFiles.length > 0) {
                    var cssDeferred = $q.defer();
                    $delegate.cssLoader(cssFiles, function (err) {
                        if (angular.isDefined(err) && $delegate.cssLoader.hasOwnProperty('ocLazyLoadLoader')) {
                            $delegate._$log.error(err);
                            cssDeferred.reject(err);
                        } else {
                            cssDeferred.resolve();
                        }
                    }, params);
                    promises.push(cssDeferred.promise);
                }

                if (templatesFiles.length > 0) {
                    var templatesDeferred = $q.defer();
                    $delegate.templatesLoader(templatesFiles, function (err) {
                        if (angular.isDefined(err) && $delegate.templatesLoader.hasOwnProperty('ocLazyLoadLoader')) {
                            $delegate._$log.error(err);
                            templatesDeferred.reject(err);
                        } else {
                            templatesDeferred.resolve();
                        }
                    }, params);
                    promises.push(templatesDeferred.promise);
                }

                if (jsFiles.length > 0) {
                    var jsDeferred = $q.defer();
                    $delegate.jsLoader(jsFiles, function (err) {
                        if (angular.isDefined(err) && ($delegate.jsLoader.hasOwnProperty("ocLazyLoadLoader") || $delegate.jsLoader.hasOwnProperty("requirejs"))) {
                            $delegate._$log.error(err);
                            jsDeferred.reject(err);
                        } else {
                            jsDeferred.resolve();
                        }
                    }, params);
                    promises.push(jsDeferred.promise);
                }

                if (promises.length === 0) {
                    var deferred = $q.defer(),
                        err = "Error: no file to load has been found, if you're trying to load an existing module you should use the 'inject' method instead of 'load'.";
                    $delegate._$log.error(err);
                    deferred.reject(err);
                    return deferred.promise;
                } else if (params.serie && params.files.length > 0) {
                    return $q.all(promises).then(function () {
                        return $delegate.filesLoader(config, params);
                    });
                } else {
                    return $q.all(promises)['finally'](function (res) {
                        $delegate.toggleWatch(false); // stop watching angular.module calls
                        return res;
                    });
                }
            };

            /**
             * Load a module or a list of modules into Angular
             * @param module Mixed the name of a predefined module config object, or a module config object, or an array of either
             * @param params Object optional parameters
             * @returns promise
             */
            $delegate.load = function (originalModule) {
                var originalParams = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

                var self = this,
                    config = null,
                    deferredList = [],
                    deferred = $q.defer(),
                    errText;

                // clean copy
                var module = angular.copy(originalModule);
                var params = angular.copy(originalParams);

                // If module is an array, break it down
                if (angular.isArray(module)) {
                    // Resubmit each entry as a single module
                    angular.forEach(module, function (m) {
                        deferredList.push(self.load(m, params));
                    });

                    // Resolve the promise once everything has loaded
                    $q.all(deferredList).then(function (res) {
                        deferred.resolve(res);
                    }, function (err) {
                        deferred.reject(err);
                    });

                    return deferred.promise;
                }

                // Get or Set a configuration depending on what was passed in
                if (angular.isString(module)) {
                    config = self.getModuleConfig(module);
                    if (!config) {
                        config = {
                            files: [module]
                        };
                    }
                } else if (angular.isObject(module)) {
                    // case {type: 'js', path: lazyLoadUrl + 'testModule.fakejs'}
                    if (angular.isDefined(module.path) && angular.isDefined(module.type)) {
                        config = {
                            files: [module]
                        };
                    } else {
                        config = self.setModuleConfig(module);
                    }
                }

                if (config === null) {
                    var moduleName = self._getModuleName(module);
                    errText = 'Module "' + (moduleName || 'unknown') + '" is not configured, cannot load.';
                    $delegate._$log.error(errText);
                    deferred.reject(new Error(errText));
                    return deferred.promise;
                } else {
                    // deprecated
                    if (angular.isDefined(config.template)) {
                        if (angular.isUndefined(config.files)) {
                            config.files = [];
                        }
                        if (angular.isString(config.template)) {
                            config.files.push(config.template);
                        } else if (angular.isArray(config.template)) {
                            config.files.concat(config.template);
                        }
                    }
                }

                var localParams = angular.extend({}, params, config);

                // if someone used an external loader and called the load function with just the module name
                if (angular.isUndefined(config.files) && angular.isDefined(config.name) && $delegate.moduleExists(config.name)) {
                    return $delegate.inject(config.name, localParams, true);
                }

                $delegate.filesLoader(config, localParams).then(function () {
                    $delegate.inject(null, localParams).then(function (res) {
                        deferred.resolve(res);
                    }, function (err) {
                        deferred.reject(err);
                    });
                }, function (err) {
                    deferred.reject(err);
                });

                return deferred.promise;
            };

            // return the patched service
            return $delegate;
        }]);
    }]);
})(angular);
(function (angular) {
    'use strict';

    angular.module('oc.lazyLoad').config(["$provide", function ($provide) {
        $provide.decorator('$ocLazyLoad', ["$delegate", "$q", function ($delegate, $q) {
            /**
             * cssLoader function
             * @type Function
             * @param paths array list of css files to load
             * @param callback to call when everything is loaded. We use a callback and not a promise
             * @param params object config parameters
             * because the user can overwrite cssLoader and it will probably not use promises :(
             */
            $delegate.cssLoader = function (paths, callback, params) {
                var promises = [];
                angular.forEach(paths, function (path) {
                    promises.push($delegate.buildElement('css', path, params));
                });
                $q.all(promises).then(function () {
                    callback();
                }, function (err) {
                    callback(err);
                });
            };
            $delegate.cssLoader.ocLazyLoadLoader = true;

            return $delegate;
        }]);
    }]);
})(angular);
(function (angular) {
    'use strict';

    angular.module('oc.lazyLoad').config(["$provide", function ($provide) {
        $provide.decorator('$ocLazyLoad', ["$delegate", "$q", function ($delegate, $q) {
            /**
             * jsLoader function
             * @type Function
             * @param paths array list of js files to load
             * @param callback to call when everything is loaded. We use a callback and not a promise
             * @param params object config parameters
             * because the user can overwrite jsLoader and it will probably not use promises :(
             */
            $delegate.jsLoader = function (paths, callback, params) {
                var promises = [];
                angular.forEach(paths, function (path) {
                    promises.push($delegate.buildElement('js', path, params));
                });
                $q.all(promises).then(function () {
                    callback();
                }, function (err) {
                    callback(err);
                });
            };
            $delegate.jsLoader.ocLazyLoadLoader = true;

            return $delegate;
        }]);
    }]);
})(angular);
(function (angular) {
    'use strict';

    angular.module('oc.lazyLoad').config(["$provide", function ($provide) {
        $provide.decorator('$ocLazyLoad', ["$delegate", "$templateCache", "$q", "$http", function ($delegate, $templateCache, $q, $http) {
            /**
             * templatesLoader function
             * @type Function
             * @param paths array list of css files to load
             * @param callback to call when everything is loaded. We use a callback and not a promise
             * @param params object config parameters for $http
             * because the user can overwrite templatesLoader and it will probably not use promises :(
             */
            $delegate.templatesLoader = function (paths, callback, params) {
                var promises = [],
                    filesCache = $delegate._getFilesCache();

                angular.forEach(paths, function (url) {
                    var deferred = $q.defer();
                    promises.push(deferred.promise);
                    $http.get(url, params).success(function (data) {
                        if (angular.isString(data) && data.length > 0) {
                            angular.forEach(angular.element(data), function (node) {
                                if (node.nodeName === 'SCRIPT' && node.type === 'text/ng-template') {
                                    $templateCache.put(node.id, node.innerHTML);
                                }
                            });
                        }
                        if (angular.isUndefined(filesCache.get(url))) {
                            filesCache.put(url, true);
                        }
                        deferred.resolve();
                    }).error(function (err) {
                        deferred.reject(new Error('Unable to load template file "' + url + '": ' + err));
                    });
                });
                return $q.all(promises).then(function () {
                    callback();
                }, function (err) {
                    callback(err);
                });
            };
            $delegate.templatesLoader.ocLazyLoadLoader = true;

            return $delegate;
        }]);
    }]);
})(angular);
// Array.indexOf polyfill for IE8
if (!Array.prototype.indexOf) {
    Array.prototype.indexOf = function (searchElement, fromIndex) {
        var k;

        // 1. Let O be the result of calling ToObject passing
        //    the this value as the argument.
        if (this == null) {
            throw new TypeError('"this" is null or not defined');
        }

        var O = Object(this);

        // 2. Let lenValue be the result of calling the Get
        //    internal method of O with the argument "length".
        // 3. Let len be ToUint32(lenValue).
        var len = O.length >>> 0;

        // 4. If len is 0, return -1.
        if (len === 0) {
            return -1;
        }

        // 5. If argument fromIndex was passed let n be
        //    ToInteger(fromIndex); else let n be 0.
        var n = +fromIndex || 0;

        if (Math.abs(n) === Infinity) {
            n = 0;
        }

        // 6. If n >= len, return -1.
        if (n >= len) {
            return -1;
        }

        // 7. If n >= 0, then Let k be n.
        // 8. Else, n<0, Let k be len - abs(n).
        //    If k is less than 0, then let k be 0.
        k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

        // 9. Repeat, while k < len
        while (k < len) {
            // a. Let Pk be ToString(k).
            //   This is implicit for LHS operands of the in operator
            // b. Let kPresent be the result of calling the
            //    HasProperty internal method of O with argument Pk.
            //   This step can be combined with c
            // c. If kPresent is true, then
            //    i.  Let elementK be the result of calling the Get
            //        internal method of O with the argument ToString(k).
            //   ii.  Let same be the result of applying the
            //        Strict Equality Comparison Algorithm to
            //        searchElement and elementK.
            //  iii.  If same is true, return k.
            if (k in O && O[k] === searchElement) {
                return k;
            }
            k++;
        }
        return -1;
    };
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),
/* 355 */
/***/ (function(module, exports) {



/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(51);
var dPs = __webpack_require__(772);
var enumBugKeys = __webpack_require__(178);
var IE_PROTO = __webpack_require__(156)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(153)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(242).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(774);
var global = __webpack_require__(25);
var hide = __webpack_require__(64);
var Iterators = __webpack_require__(82);
var TO_STRING_TAG = __webpack_require__(32)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(64);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 359 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(63) && !__webpack_require__(85)(function () {
  return Object.defineProperty(__webpack_require__(153)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(86);
var toIObject = __webpack_require__(114);
var arrayIndexOf = __webpack_require__(614)(false);
var IE_PROTO = __webpack_require__(156)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 362 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAABEVBMVEX///81sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHg1sHj///9pMqPAAAAAWXRSTlMAAAsOeMj2/tybMSLf+2/F7cDuQTl/8YIC9bpx8L+866p8h2MHExF5LDespy00cFn0+vlHoPwP8lNfRVvmCQWmYszRztNN0OGFa7A4BmlQG/cMaFivQGo1A38UN7UAAAABYktHRACIBR1IAAAAB3RJTUUH4QEMCTAbPIgwHwAAAN1JREFUKM+90Ws7AkEcBfCOaKPbtpRy66JEQtRGodal0kWEcL7/F7HtDM32usd5eX7PXP4zHs+/BE6WoEaCd3nFR82/ujYHgSBFQmE3RKhH7dqIUltXYYOMIU5uJpLcUmGb3NmdrthLpTMqZOUJ+n4OyB/MoCD6+CGOivaOxnFJwomAU5yFyudk2XdRkbeqTnuzlr/kVZ1sXPPmVkCzZUMQFnl3Tz48km05eUzrpLp44l96EvoDYIjnGYyURwReXn97Y+wCvGmiN9/hBoy6DnxgHtCcfFpfpf43FvrhP4lwNj/+5HqSAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDE3LTAxLTEyVDA5OjQ4OjI3KzA4OjAwrukndQAAACV0RVh0ZGF0ZTptb2RpZnkAMjAxNy0wMS0xMlQwOTo0ODoyNyswODowMN+0n8kAAAAZdEVYdFNvZnR3YXJlAEFkb2JlIEltYWdlUmVhZHlxyWU8AAAAAElFTkSuQmCC"

/***/ }),
/* 363 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3NpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQwIDc5LjE2MDQ1MSwgMjAxNy8wNS8wNi0wMTowODoyMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDplMTg3ZGFjNC0yYjk3LTRjMDYtYjJiNy03YmIxYWVkY2I4YjUiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NERFNUIzNzA5RERFMTFFODgwNjJGRkQwNDU5NkMwRUQiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NERFNUIzNkY5RERFMTFFODgwNjJGRkQwNDU5NkMwRUQiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChNYWNpbnRvc2gpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6ZTE4N2RhYzQtMmI5Ny00YzA2LWIyYjctN2JiMWFlZGNiOGI1IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOmUxODdkYWM0LTJiOTctNGMwNi1iMmI3LTdiYjFhZWRjYjhiNSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Pkn01NAAAAHDSURBVHja5JVPKMNhGMc3zSI2h5WSWrKbpOSA7WDkXzkQLk5OLstlojg5KOUkkhxXFHc5SJKyclBiLkqUP7nIsuRPzHzeelZva/vZb2snb3163vf9Pe/zfd6/P2sikbAUshRZClz+gUA4HC7LR8CauskEdGICMAANUArK6RoOYNXn853mJEDwWsw+1BiM+YZJRJZyWaJ1Cf4MhynfotJng0WSaTclwIBWjFeay2Tox8Y03xXogDc1c5jJRsCm1Vu0ehBBJeDU+sYlASWwA+dmBSq1egX4U3zVZm1CH7P7lFm7MD+0o9kIxAwSUd/aCHRB0GaYot2VnCFtJbAL8/hEMm3ynoHArAQfoX4EvXJ8k8UO/XCCT4/RMQ1hRlOCx8Els70BBwxDOYTEp1uWeAMewUNC7+mO6Ziss17ucH6RDB3Sp07QhOazANNSr4LOtPeAQF+YS9nQM3jSfDyaa5Pc8mRphHqt7U63ybqzF7FjWTa79N+beIIeMr5FBo9eNeYKSv5wVSfKTYKvpp5rBqisgrJ8mYo6EIFkcNP/AwauYQbhNoPLNj5bhs91lstVrPSgDj4gInYOhhCJ5yXwv/7JvwIMAJkYkjAcMTsFAAAAAElFTkSuQmCC"

/***/ }),
/* 364 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAABYlBMVEX////kWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVjkWVj///9z0GMiAAAAdHRSTlMAANHmpDVFm/2IAQaAiZnfniyH/jRYyPNkTr77bQvooBK0pR/DTJzjINeXNsfBUx38yT8c4fSsotMDxrViKgoEGkn2uSFdS8DkJx7NhMK8WzHw9XxR77biR15+mC1w2iIl0mYUozl/8iMRGC5ZEHrg9+mUCeUXxYoAAAABYktHRACIBR1IAAAAB3RJTUUH4QEMCTAbPIgwHwAAAQNJREFUKM9jYKAmYEQGTMwsrEAKU4KNnZmDkwuLBCMjN08JL6YEH7+AIKOQsAhcgktUTFwCSEtKSUvLyMrJwyQUFEtKSpTAepRVhFXV1KESGppA8RItbT4dXT1GfQNDIxWIhLEJSLzEFESYMTKaW0Cda2lVYmBtY2tn7+DI5+Qs4cII84dria4tI6Obu4ezJ6OXd4mwD0zC18+ekdFfGGgO0IyAkpJAmESQNpBlERxSUhLKyKhfUhIGkwiPALJ82SJLSqIYGaNLAmNgErFx8YyMCVLiiUlcySklHqlwyxnT0gUkMzKzsnPMgwI5cxkREozKec75BdKFKkWSxdAwo2q8kg4ABrAvGmefG4AAAAAldEVYdGRhdGU6Y3JlYXRlADIwMTctMDEtMTJUMDk6NDg6MjcrMDg6MDCu6Sd1AAAAJXRFWHRkYXRlOm1vZGlmeQAyMDE3LTAxLTEyVDA5OjQ4OjI3KzA4OjAw37SfyQAAABl0RVh0U29mdHdhcmUAQWRvYmUgSW1hZ2VSZWFkeXHJZTwAAAAASUVORK5CYII="

/***/ }),
/* 365 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 366 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 367 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = __webpack_require__(73);

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _user = __webpack_require__(745);

var _user2 = _interopRequireDefault(_user);

var _form = __webpack_require__(751);

var _form2 = _interopRequireDefault(_form);

var _formLogin = __webpack_require__(752);

var _formLogin2 = _interopRequireDefault(_formLogin);

var _formRegister = __webpack_require__(753);

var _formRegister2 = _interopRequireDefault(_formRegister);

var _formForget = __webpack_require__(754);

var _formForget2 = _interopRequireDefault(_formForget);

var _formReset = __webpack_require__(755);

var _formReset2 = _interopRequireDefault(_formReset);

var _confirm = __webpack_require__(756);

var _confirm2 = _interopRequireDefault(_confirm);

var _find = __webpack_require__(759);

var _find2 = _interopRequireDefault(_find);

var _inputGroup = __webpack_require__(760);

var _inputGroup2 = _interopRequireDefault(_inputGroup);

var _pwdMask = __webpack_require__(761);

var _pwdMask2 = _interopRequireDefault(_pwdMask);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userModule = _angular2.default.module('user', [_angularUiRouter2.default]).component('user', _user2.default).directive('ybInputGroup', _inputGroup2.default).directive('pwdMask', _pwdMask2.default).name;

var states = [{
    name: 'user',
    abstract: true,
    url: '?s&return',
    component: 'user'
}, {
    name: 'user.form',
    template: _form2.default
}, {
    name: 'user.form.login',
    url: '/login',
    template: _formLogin2.default,
    title: 'face-user-text001'
}, {
    name: 'user.form.register',
    url: '/register',
    template: _formRegister2.default,
    title: 'face-user-text002'
}, {
    name: 'user.form.forget',
    url: '/forget',
    template: _formForget2.default,
    title: 'face-user-text003'
}, {
    name: 'user.form.reset',
    url: '/password/reset',
    template: _formReset2.default,
    title: 'face-user-text004'
}, {
    name: 'user.confirm',
    url: '/register/confirm',
    template: _confirm2.default,
    title: 'face-user-text005'
}, {
    name: 'user.find',
    url: '/forget/find',
    template: _find2.default,
    title: 'face-user-text006'
}];

exports.default = { name: userModule, states: states };

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(64);


/***/ }),
/* 370 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(51);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(82);
var ITERATOR = __webpack_require__(32)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(183);
var ITERATOR = __webpack_require__(32)('iterator');
var Iterators = __webpack_require__(82);
module.exports = __webpack_require__(24).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(25);
var core = __webpack_require__(24);
var dP = __webpack_require__(72);
var DESCRIPTORS = __webpack_require__(63);
var SPECIES = __webpack_require__(32)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(32)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 376 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(378);
__webpack_require__(379);
module.exports = __webpack_require__(581);


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"2025_4_5_10_57"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["yuanben@sentry"]={id:"2025_4_5_10_57"};
      
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(380);

__webpack_require__(577);

__webpack_require__(578);

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(381);
__webpack_require__(383);
__webpack_require__(384);
__webpack_require__(385);
__webpack_require__(386);
__webpack_require__(387);
__webpack_require__(388);
__webpack_require__(389);
__webpack_require__(390);
__webpack_require__(391);
__webpack_require__(392);
__webpack_require__(393);
__webpack_require__(394);
__webpack_require__(395);
__webpack_require__(396);
__webpack_require__(397);
__webpack_require__(399);
__webpack_require__(400);
__webpack_require__(401);
__webpack_require__(402);
__webpack_require__(403);
__webpack_require__(404);
__webpack_require__(405);
__webpack_require__(406);
__webpack_require__(407);
__webpack_require__(408);
__webpack_require__(409);
__webpack_require__(410);
__webpack_require__(411);
__webpack_require__(412);
__webpack_require__(413);
__webpack_require__(414);
__webpack_require__(415);
__webpack_require__(416);
__webpack_require__(417);
__webpack_require__(418);
__webpack_require__(419);
__webpack_require__(420);
__webpack_require__(421);
__webpack_require__(422);
__webpack_require__(423);
__webpack_require__(424);
__webpack_require__(425);
__webpack_require__(426);
__webpack_require__(427);
__webpack_require__(428);
__webpack_require__(429);
__webpack_require__(430);
__webpack_require__(431);
__webpack_require__(432);
__webpack_require__(433);
__webpack_require__(434);
__webpack_require__(435);
__webpack_require__(436);
__webpack_require__(437);
__webpack_require__(438);
__webpack_require__(439);
__webpack_require__(440);
__webpack_require__(441);
__webpack_require__(442);
__webpack_require__(443);
__webpack_require__(444);
__webpack_require__(445);
__webpack_require__(446);
__webpack_require__(447);
__webpack_require__(448);
__webpack_require__(449);
__webpack_require__(450);
__webpack_require__(451);
__webpack_require__(452);
__webpack_require__(453);
__webpack_require__(454);
__webpack_require__(455);
__webpack_require__(456);
__webpack_require__(457);
__webpack_require__(458);
__webpack_require__(459);
__webpack_require__(461);
__webpack_require__(462);
__webpack_require__(464);
__webpack_require__(465);
__webpack_require__(466);
__webpack_require__(467);
__webpack_require__(468);
__webpack_require__(469);
__webpack_require__(470);
__webpack_require__(472);
__webpack_require__(473);
__webpack_require__(474);
__webpack_require__(475);
__webpack_require__(476);
__webpack_require__(477);
__webpack_require__(478);
__webpack_require__(479);
__webpack_require__(480);
__webpack_require__(481);
__webpack_require__(482);
__webpack_require__(483);
__webpack_require__(484);
__webpack_require__(140);
__webpack_require__(485);
__webpack_require__(486);
__webpack_require__(202);
__webpack_require__(487);
__webpack_require__(488);
__webpack_require__(489);
__webpack_require__(490);
__webpack_require__(491);
__webpack_require__(205);
__webpack_require__(207);
__webpack_require__(208);
__webpack_require__(492);
__webpack_require__(493);
__webpack_require__(494);
__webpack_require__(495);
__webpack_require__(496);
__webpack_require__(497);
__webpack_require__(498);
__webpack_require__(499);
__webpack_require__(500);
__webpack_require__(501);
__webpack_require__(502);
__webpack_require__(503);
__webpack_require__(504);
__webpack_require__(505);
__webpack_require__(506);
__webpack_require__(507);
__webpack_require__(508);
__webpack_require__(509);
__webpack_require__(510);
__webpack_require__(511);
__webpack_require__(512);
__webpack_require__(513);
__webpack_require__(514);
__webpack_require__(515);
__webpack_require__(516);
__webpack_require__(517);
__webpack_require__(518);
__webpack_require__(519);
__webpack_require__(520);
__webpack_require__(521);
__webpack_require__(522);
__webpack_require__(523);
__webpack_require__(524);
__webpack_require__(525);
__webpack_require__(526);
__webpack_require__(527);
__webpack_require__(528);
__webpack_require__(529);
__webpack_require__(530);
__webpack_require__(531);
__webpack_require__(532);
__webpack_require__(533);
__webpack_require__(534);
__webpack_require__(535);
__webpack_require__(536);
__webpack_require__(537);
__webpack_require__(538);
__webpack_require__(539);
__webpack_require__(540);
__webpack_require__(541);
__webpack_require__(542);
__webpack_require__(543);
__webpack_require__(544);
__webpack_require__(545);
__webpack_require__(546);
__webpack_require__(547);
__webpack_require__(548);
__webpack_require__(549);
__webpack_require__(550);
__webpack_require__(551);
__webpack_require__(552);
__webpack_require__(553);
__webpack_require__(554);
__webpack_require__(555);
__webpack_require__(556);
__webpack_require__(557);
__webpack_require__(558);
__webpack_require__(559);
__webpack_require__(560);
__webpack_require__(561);
__webpack_require__(562);
__webpack_require__(563);
__webpack_require__(564);
__webpack_require__(565);
__webpack_require__(566);
__webpack_require__(567);
__webpack_require__(568);
__webpack_require__(569);
__webpack_require__(570);
__webpack_require__(571);
__webpack_require__(572);
__webpack_require__(573);
__webpack_require__(574);
__webpack_require__(575);
__webpack_require__(576);
module.exports = __webpack_require__(33);


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(7);
var has = __webpack_require__(26);
var DESCRIPTORS = __webpack_require__(15);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(22);
var META = __webpack_require__(45).KEY;
var $fails = __webpack_require__(10);
var shared = __webpack_require__(89);
var setToStringTag = __webpack_require__(65);
var uid = __webpack_require__(53);
var wks = __webpack_require__(12);
var wksExt = __webpack_require__(185);
var wksDefine = __webpack_require__(120);
var enumKeys = __webpack_require__(382);
var isArray = __webpack_require__(92);
var anObject = __webpack_require__(6);
var isObject = __webpack_require__(11);
var toIObject = __webpack_require__(27);
var toPrimitive = __webpack_require__(37);
var createDesc = __webpack_require__(52);
var _create = __webpack_require__(56);
var gOPNExt = __webpack_require__(188);
var $GOPD = __webpack_require__(28);
var $DP = __webpack_require__(16);
var $keys = __webpack_require__(54);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(57).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(76).f = $propertyIsEnumerable;
  __webpack_require__(91).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(46)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(21)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(54);
var gOPS = __webpack_require__(91);
var pIE = __webpack_require__(76);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(56) });


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(15), 'Object', { defineProperty: __webpack_require__(16).f });


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(15), 'Object', { defineProperties: __webpack_require__(187) });


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(27);
var $getOwnPropertyDescriptor = __webpack_require__(28).f;

__webpack_require__(40)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(18);
var $getPrototypeOf = __webpack_require__(29);

__webpack_require__(40)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(18);
var $keys = __webpack_require__(54);

__webpack_require__(40)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(40)('getOwnPropertyNames', function () {
  return __webpack_require__(188).f;
});


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(11);
var meta = __webpack_require__(45).onFreeze;

__webpack_require__(40)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(11);
var meta = __webpack_require__(45).onFreeze;

__webpack_require__(40)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(11);
var meta = __webpack_require__(45).onFreeze;

__webpack_require__(40)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(11);

__webpack_require__(40)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(11);

__webpack_require__(40)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(11);

__webpack_require__(40)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(0);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(189) });


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(0);
$export($export.S, 'Object', { is: __webpack_require__(398) });


/***/ }),
/* 398 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(0);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(124).set });


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(77);
var test = {};
test[__webpack_require__(12)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(22)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(0);

$export($export.P, 'Function', { bind: __webpack_require__(190) });


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(16).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(15) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(11);
var getPrototypeOf = __webpack_require__(29);
var HAS_INSTANCE = __webpack_require__(12)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(16).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseInt = __webpack_require__(192);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseFloat = __webpack_require__(193);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(7);
var has = __webpack_require__(26);
var cof = __webpack_require__(35);
var inheritIfRequired = __webpack_require__(126);
var toPrimitive = __webpack_require__(37);
var fails = __webpack_require__(10);
var gOPN = __webpack_require__(57).f;
var gOPD = __webpack_require__(28).f;
var dP = __webpack_require__(16).f;
var $trim = __webpack_require__(66).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(56)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(15) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(22)(global, NUMBER, $Number);
}


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toInteger = __webpack_require__(39);
var aNumberValue = __webpack_require__(194);
var repeat = __webpack_require__(127);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(10)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $fails = __webpack_require__(10);
var aNumberValue = __webpack_require__(194);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(0);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(0);
var _isFinite = __webpack_require__(7).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(0);

$export($export.S, 'Number', { isInteger: __webpack_require__(195) });


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(0);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(0);
var isInteger = __webpack_require__(195);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(0);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(0);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseFloat = __webpack_require__(193);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseInt = __webpack_require__(192);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(0);
var log1p = __webpack_require__(196);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(0);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(0);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(0);
var sign = __webpack_require__(128);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(0);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(0);
var $expm1 = __webpack_require__(129);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { fround: __webpack_require__(197) });


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(0);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(0);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(10)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { log1p: __webpack_require__(196) });


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { sign: __webpack_require__(128) });


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(0);
var expm1 = __webpack_require__(129);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(10)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(0);
var expm1 = __webpack_require__(129);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var toAbsoluteIndex = __webpack_require__(55);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var toIObject = __webpack_require__(27);
var toLength = __webpack_require__(17);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(66)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(130)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(131)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $at = __webpack_require__(130)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(0);
var toLength = __webpack_require__(17);
var context = __webpack_require__(133);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(134)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(0);
var context = __webpack_require__(133);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(134)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(127)
});


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(0);
var toLength = __webpack_require__(17);
var context = __webpack_require__(133);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(134)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(23)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(23)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(23)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(23)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(23)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(23)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(23)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(23)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(23)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(23)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(23)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(23)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(23)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(0);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(18);
var toPrimitive = __webpack_require__(37);

$export($export.P + $export.F * __webpack_require__(10)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(0);
var toISOString = __webpack_require__(460);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(10);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(22)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(12)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(21)(proto, TO_PRIMITIVE, __webpack_require__(463));


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(6);
var toPrimitive = __webpack_require__(37);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(0);

$export($export.S, 'Array', { isArray: __webpack_require__(92) });


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(34);
var $export = __webpack_require__(0);
var toObject = __webpack_require__(18);
var call = __webpack_require__(198);
var isArrayIter = __webpack_require__(135);
var toLength = __webpack_require__(17);
var createProperty = __webpack_require__(136);
var getIterFn = __webpack_require__(137);

$export($export.S + $export.F * !__webpack_require__(94)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var createProperty = __webpack_require__(136);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(10)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(0);
var toIObject = __webpack_require__(27);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(75) != Object || !__webpack_require__(36)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var html = __webpack_require__(123);
var cof = __webpack_require__(35);
var toAbsoluteIndex = __webpack_require__(55);
var toLength = __webpack_require__(17);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(10)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var aFunction = __webpack_require__(19);
var toObject = __webpack_require__(18);
var fails = __webpack_require__(10);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(36)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $forEach = __webpack_require__(41)(0);
var STRICT = __webpack_require__(36)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(11);
var isArray = __webpack_require__(92);
var SPECIES = __webpack_require__(12)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $map = __webpack_require__(41)(1);

$export($export.P + $export.F * !__webpack_require__(36)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $filter = __webpack_require__(41)(2);

$export($export.P + $export.F * !__webpack_require__(36)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $some = __webpack_require__(41)(3);

$export($export.P + $export.F * !__webpack_require__(36)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $every = __webpack_require__(41)(4);

$export($export.P + $export.F * !__webpack_require__(36)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $reduce = __webpack_require__(199);

$export($export.P + $export.F * !__webpack_require__(36)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $reduce = __webpack_require__(199);

$export($export.P + $export.F * !__webpack_require__(36)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $indexOf = __webpack_require__(90)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(36)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toIObject = __webpack_require__(27);
var toInteger = __webpack_require__(39);
var toLength = __webpack_require__(17);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(36)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(0);

$export($export.P, 'Array', { copyWithin: __webpack_require__(200) });

__webpack_require__(47)('copyWithin');


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(0);

$export($export.P, 'Array', { fill: __webpack_require__(139) });

__webpack_require__(47)('fill');


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(0);
var $find = __webpack_require__(41)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(47)(KEY);


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(0);
var $find = __webpack_require__(41)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(47)(KEY);


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(58)('Array');


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(7);
var inheritIfRequired = __webpack_require__(126);
var dP = __webpack_require__(16).f;
var gOPN = __webpack_require__(57).f;
var isRegExp = __webpack_require__(93);
var $flags = __webpack_require__(95);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(15) && (!CORRECT_NEW || __webpack_require__(10)(function () {
  re2[__webpack_require__(12)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(22)(global, 'RegExp', $RegExp);
}

__webpack_require__(58)('RegExp');


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(202);
var anObject = __webpack_require__(6);
var $flags = __webpack_require__(95);
var DESCRIPTORS = __webpack_require__(15);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(22)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(10)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

// @@match logic
__webpack_require__(96)('match', 1, function (defined, MATCH, $match) {
  // 21.1.3.11 String.prototype.match(regexp)
  return [function match(regexp) {
    'use strict';
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[MATCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
  }, $match];
});


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

// @@replace logic
__webpack_require__(96)('replace', 2, function (defined, REPLACE, $replace) {
  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
  return [function replace(searchValue, replaceValue) {
    'use strict';
    var O = defined(this);
    var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
    return fn !== undefined
      ? fn.call(searchValue, O, replaceValue)
      : $replace.call(String(O), searchValue, replaceValue);
  }, $replace];
});


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

// @@search logic
__webpack_require__(96)('search', 1, function (defined, SEARCH, $search) {
  // 21.1.3.15 String.prototype.search(regexp)
  return [function search(regexp) {
    'use strict';
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[SEARCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
  }, $search];
});


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

// @@split logic
__webpack_require__(96)('split', 2, function (defined, SPLIT, $split) {
  'use strict';
  var isRegExp = __webpack_require__(93);
  var _split = $split;
  var $push = [].push;
  var $SPLIT = 'split';
  var LENGTH = 'length';
  var LAST_INDEX = 'lastIndex';
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
    // based on es5-shim implementation, need to rework it
    $split = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return _split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var separator2, match, lastIndex, lastLength, i;
      // Doesn't need flags gy, but they don't hurt
      if (!NPCG) separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
      while (match = separatorCopy.exec(string)) {
        // `separatorCopy.lastIndex` is not reliable cross-browser
        lastIndex = match.index + match[0][LENGTH];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
          // eslint-disable-next-line no-loop-func
          if (!NPCG && match[LENGTH] > 1) match[0].replace(separator2, function () {
            for (i = 1; i < arguments[LENGTH] - 2; i++) if (arguments[i] === undefined) match[i] = undefined;
          });
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    $split = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
    };
  }
  // 21.1.3.17 String.prototype.split(separator, limit)
  return [function split(separator, limit) {
    var O = defined(this);
    var fn = separator == undefined ? undefined : separator[SPLIT];
    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
  }, $split];
});


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(46);
var global = __webpack_require__(7);
var ctx = __webpack_require__(34);
var classof = __webpack_require__(77);
var $export = __webpack_require__(0);
var isObject = __webpack_require__(11);
var aFunction = __webpack_require__(19);
var anInstance = __webpack_require__(59);
var forOf = __webpack_require__(60);
var speciesConstructor = __webpack_require__(97);
var task = __webpack_require__(141).set;
var microtask = __webpack_require__(142)();
var newPromiseCapabilityModule = __webpack_require__(143);
var perform = __webpack_require__(203);
var userAgent = __webpack_require__(98);
var promiseResolve = __webpack_require__(204);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(12)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(61)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(65)($Promise, PROMISE);
__webpack_require__(58)(PROMISE);
Wrapper = __webpack_require__(33)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(94)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(209);
var validate = __webpack_require__(68);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(99)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $typed = __webpack_require__(100);
var buffer = __webpack_require__(144);
var anObject = __webpack_require__(6);
var toAbsoluteIndex = __webpack_require__(55);
var toLength = __webpack_require__(17);
var isObject = __webpack_require__(11);
var ArrayBuffer = __webpack_require__(7).ArrayBuffer;
var speciesConstructor = __webpack_require__(97);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(10)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var final = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < final) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(58)(ARRAY_BUFFER);


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
$export($export.G + $export.W + $export.F * !__webpack_require__(100).ABV, {
  DataView: __webpack_require__(144).DataView
});


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(43)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(43)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(43)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(43)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(43)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(43)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(43)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(43)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(43)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(0);
var aFunction = __webpack_require__(19);
var anObject = __webpack_require__(6);
var rApply = (__webpack_require__(7).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(10)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(0);
var create = __webpack_require__(56);
var aFunction = __webpack_require__(19);
var anObject = __webpack_require__(6);
var isObject = __webpack_require__(11);
var fails = __webpack_require__(10);
var bind = __webpack_require__(190);
var rConstruct = (__webpack_require__(7).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(16);
var $export = __webpack_require__(0);
var anObject = __webpack_require__(6);
var toPrimitive = __webpack_require__(37);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(10)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(0);
var gOPD = __webpack_require__(28).f;
var anObject = __webpack_require__(6);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(6);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(132)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(28);
var getPrototypeOf = __webpack_require__(29);
var has = __webpack_require__(26);
var $export = __webpack_require__(0);
var isObject = __webpack_require__(11);
var anObject = __webpack_require__(6);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(28);
var $export = __webpack_require__(0);
var anObject = __webpack_require__(6);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(0);
var getProto = __webpack_require__(29);
var anObject = __webpack_require__(6);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(0);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(6);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(0);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(211) });


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(6);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(16);
var gOPD = __webpack_require__(28);
var getPrototypeOf = __webpack_require__(29);
var has = __webpack_require__(26);
var $export = __webpack_require__(0);
var createDesc = __webpack_require__(52);
var anObject = __webpack_require__(6);
var isObject = __webpack_require__(11);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(0);
var setProto = __webpack_require__(124);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(0);
var $includes = __webpack_require__(90)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(47)('includes');


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(0);
var flattenIntoArray = __webpack_require__(212);
var toObject = __webpack_require__(18);
var toLength = __webpack_require__(17);
var aFunction = __webpack_require__(19);
var arraySpeciesCreate = __webpack_require__(138);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(47)('flatMap');


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__(0);
var flattenIntoArray = __webpack_require__(212);
var toObject = __webpack_require__(18);
var toLength = __webpack_require__(17);
var toInteger = __webpack_require__(39);
var arraySpeciesCreate = __webpack_require__(138);

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__(47)('flatten');


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(0);
var $at = __webpack_require__(130)(true);

$export($export.P, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(0);
var $pad = __webpack_require__(213);
var userAgent = __webpack_require__(98);

// https://github.com/zloirock/core-js/issues/280
$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(0);
var $pad = __webpack_require__(213);
var userAgent = __webpack_require__(98);

// https://github.com/zloirock/core-js/issues/280
$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(66)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(66)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export = __webpack_require__(0);
var defined = __webpack_require__(38);
var toLength = __webpack_require__(17);
var isRegExp = __webpack_require__(93);
var getFlags = __webpack_require__(95);
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__(132)($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(120)('asyncIterator');


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(120)('observable');


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(0);
var ownKeys = __webpack_require__(211);
var toIObject = __webpack_require__(27);
var gOPD = __webpack_require__(28);
var createProperty = __webpack_require__(136);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(0);
var $values = __webpack_require__(214)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(0);
var $entries = __webpack_require__(214)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(18);
var aFunction = __webpack_require__(19);
var $defineProperty = __webpack_require__(16);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(15) && $export($export.P + __webpack_require__(101), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(18);
var aFunction = __webpack_require__(19);
var $defineProperty = __webpack_require__(16);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(15) && $export($export.P + __webpack_require__(101), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(18);
var toPrimitive = __webpack_require__(37);
var getPrototypeOf = __webpack_require__(29);
var getOwnPropertyDescriptor = __webpack_require__(28).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(15) && $export($export.P + __webpack_require__(101), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(18);
var toPrimitive = __webpack_require__(37);
var getPrototypeOf = __webpack_require__(29);
var getOwnPropertyDescriptor = __webpack_require__(28).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(15) && $export($export.P + __webpack_require__(101), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(0);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(215)('Map') });


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(0);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(215)('Set') });


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(102)('Map');


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(102)('Set');


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(102)('WeakMap');


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
__webpack_require__(102)('WeakSet');


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(103)('Map');


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(103)('Set');


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(103)('WeakMap');


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
__webpack_require__(103)('WeakSet');


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(0);

$export($export.G, { global: __webpack_require__(7) });


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(0);

$export($export.S, 'System', { global: __webpack_require__(7) });


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(0);
var cof = __webpack_require__(35);

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var scale = __webpack_require__(217);
var fround = __webpack_require__(197);

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { scale: __webpack_require__(217) });


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

// http://jfbastien.github.io/papers/Math.signbit.html
var $export = __webpack_require__(0);

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(0);
var core = __webpack_require__(33);
var global = __webpack_require__(7);
var speciesConstructor = __webpack_require__(97);
var promiseResolve = __webpack_require__(204);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(0);
var newPromiseCapability = __webpack_require__(143);
var perform = __webpack_require__(203);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(44);
var anObject = __webpack_require__(6);
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(44);
var anObject = __webpack_require__(6);
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(44);
var anObject = __webpack_require__(6);
var getPrototypeOf = __webpack_require__(29);
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(207);
var from = __webpack_require__(216);
var metadata = __webpack_require__(44);
var anObject = __webpack_require__(6);
var getPrototypeOf = __webpack_require__(29);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(44);
var anObject = __webpack_require__(6);
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(44);
var anObject = __webpack_require__(6);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(44);
var anObject = __webpack_require__(6);
var getPrototypeOf = __webpack_require__(29);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(44);
var anObject = __webpack_require__(6);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

var $metadata = __webpack_require__(44);
var anObject = __webpack_require__(6);
var aFunction = __webpack_require__(19);
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__(0);
var microtask = __webpack_require__(142)();
var process = __webpack_require__(7).process;
var isNode = __webpack_require__(35)(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export = __webpack_require__(0);
var global = __webpack_require__(7);
var core = __webpack_require__(33);
var microtask = __webpack_require__(142)();
var OBSERVABLE = __webpack_require__(12)('observable');
var aFunction = __webpack_require__(19);
var anObject = __webpack_require__(6);
var anInstance = __webpack_require__(59);
var redefineAll = __webpack_require__(61);
var hide = __webpack_require__(21);
var forOf = __webpack_require__(60);
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

__webpack_require__(58)('Observable');


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(7);
var $export = __webpack_require__(0);
var userAgent = __webpack_require__(98);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $task = __webpack_require__(141);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(140);
var getKeys = __webpack_require__(54);
var redefine = __webpack_require__(22);
var global = __webpack_require__(7);
var hide = __webpack_require__(21);
var Iterators = __webpack_require__(67);
var wks = __webpack_require__(12);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(579);
module.exports = __webpack_require__(33).RegExp.escape;


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(0);
var $re = __webpack_require__(580)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 580 */
/***/ (function(module, exports) {

module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = __webpack_require__(73);

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _common = __webpack_require__(606);

var _common2 = _interopRequireDefault(_common);

var _components = __webpack_require__(728);

var _components2 = _interopRequireDefault(_components);

var _services = __webpack_require__(1196);

var _services2 = _interopRequireDefault(_services);

var _app = __webpack_require__(1219);

var _app2 = _interopRequireDefault(_app);

var _app3 = __webpack_require__(1231);

var _app4 = _interopRequireDefault(_app3);

var _app5 = __webpack_require__(343);

var _app6 = _interopRequireDefault(_app5);

__webpack_require__(1235);

__webpack_require__(1237);

__webpack_require__(1238);

var _fastclick = __webpack_require__(1240);

var _fastclick2 = _interopRequireDefault(_fastclick);

var _angularTranslate = __webpack_require__(1241);

var _angularTranslate2 = _interopRequireDefault(_angularTranslate);

var _angularLocale_zhCN = __webpack_require__(1242);

var _angularLocale_zhCN2 = _interopRequireDefault(_angularLocale_zhCN);

__webpack_require__(1243);

var _modal = __webpack_require__(1245);

var _modal2 = _interopRequireDefault(_modal);

var _downlistModal = __webpack_require__(1257);

var _downlistModal2 = _interopRequireDefault(_downlistModal);

var _ravenJs = __webpack_require__(1263);

var _ravenJs2 = _interopRequireDefault(_ravenJs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import * as Sentry from "@sentry/browser";
// import { Integrations } from "@sentry/tracing";


_fastclick2.default.attach(document.body);

// Sentry.init({
//    dsn: 'https://4e13139cfb154100a312b8d12834c0d6@sentry.yuanben.org/6',
//    integrations: [
//      new Integrations.BrowserTracing(),
//    ],
//    release:process.env.RELEASE,
//    environment: process.env.ENVIRONMENT,
//    tracesSampleRate: 1.0,
//  });
_ravenJs2.default.config("https://4e13139cfb154100a312b8d12834c0d6@sentry.yuanben.org/6", { release: "2025_4_5_10_57",
    environment: "production" }).addPlugin(__webpack_require__(1269), _angular2.default).install();
_angular2.default.module('app', [_angularUiRouter2.default, _common2.default, _components2.default, _services2.default, _app4.default, _app6.default, "angulartics", "angulartics.baidu", "angulartics.google.analytics", _angularTranslate2.default, 'ngSanitize', _modal2.default, _downlistModal2.default, "ngRaven"]).config(['$locationProvider', function ($locationProvider) {
    "ngInject";

    $locationProvider.html5Mode(true).hashPrefix('!');
}]).config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
    "ngInject";

    $stateProvider.state('app', {
        abstract: true,
        resolve: {
            appUser: ['userLogin', function appUser(userLogin) {
                return userLogin.getUser().catch(function (err) {
                    console.log("请求超时");
                });
            }]
        }
    });

    $urlRouterProvider.otherwise('/');
}]).config(['$analyticsProvider', function ($analyticsProvider) {
    "ngInject";

    $analyticsProvider.withAutoBase(true);
}]).config(['$translateProvider', '$provide', function ($translateProvider, $provide) {
    "ngInject";

    $translateProvider.translations('zh-CN', __webpack_require__(1270));
    $translateProvider.translations('en', __webpack_require__(1271));
    $translateProvider.useSanitizeValueStrategy('escaped');
    var lang = window.localStorage.yuanben_lang || window.navigator.language;
    if (['cn', 'zh', 'zh-CN', 'zh-HK', 'zh-TW'].indexOf(lang) != -1) {
        lang = 'zh-CN';
        $provide.value("$locale", _angularLocale_zhCN2.default);
    } else {
        lang = 'en';
    };
    window.localStorage.yuanben_lang = lang;
    $translateProvider.preferredLanguage(lang);
}]).config(['$httpProvider', function ($httpProvider) {
    "ngInject";

    $httpProvider.defaults.headers.common.locale = window.localStorage.yuanben_lang;
}]).component('app', _app2.default);

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {/**
 * @license AngularJS v1.5.8
 * (c) 2010-2016 Google, Inc. http://angularjs.org
 * License: MIT
 */
(function(window) {'use strict';

/**
 * @description
 *
 * This object provides a utility for producing rich Error messages within
 * Angular. It can be called as follows:
 *
 * var exampleMinErr = minErr('example');
 * throw exampleMinErr('one', 'This {0} is {1}', foo, bar);
 *
 * The above creates an instance of minErr in the example namespace. The
 * resulting error will have a namespaced error code of example.one.  The
 * resulting error will replace {0} with the value of foo, and {1} with the
 * value of bar. The object is not restricted in the number of arguments it can
 * take.
 *
 * If fewer arguments are specified than necessary for interpolation, the extra
 * interpolation markers will be preserved in the final string.
 *
 * Since data will be parsed statically during a build step, some restrictions
 * are applied with respect to how minErr instances are created and called.
 * Instances should have names of the form namespaceMinErr for a minErr created
 * using minErr('namespace') . Error codes, namespaces and template strings
 * should all be static strings, not variables or general expressions.
 *
 * @param {string} module The namespace to use for the new minErr instance.
 * @param {function} ErrorConstructor Custom error constructor to be instantiated when returning
 *   error from returned function, for cases when a particular type of error is useful.
 * @returns {function(code:string, template:string, ...templateArgs): Error} minErr instance
 */

function minErr(module, ErrorConstructor) {
  ErrorConstructor = ErrorConstructor || Error;
  return function() {
    var SKIP_INDEXES = 2;

    var templateArgs = arguments,
      code = templateArgs[0],
      message = '[' + (module ? module + ':' : '') + code + '] ',
      template = templateArgs[1],
      paramPrefix, i;

    message += template.replace(/\{\d+\}/g, function(match) {
      var index = +match.slice(1, -1),
        shiftedIndex = index + SKIP_INDEXES;

      if (shiftedIndex < templateArgs.length) {
        return toDebugString(templateArgs[shiftedIndex]);
      }

      return match;
    });

    message += '\nhttp://errors.angularjs.org/1.5.8/' +
      (module ? module + '/' : '') + code;

    for (i = SKIP_INDEXES, paramPrefix = '?'; i < templateArgs.length; i++, paramPrefix = '&') {
      message += paramPrefix + 'p' + (i - SKIP_INDEXES) + '=' +
        encodeURIComponent(toDebugString(templateArgs[i]));
    }

    return new ErrorConstructor(message);
  };
}

/* We need to tell jshint what variables are being exported */
/* global angular: true,
  msie: true,
  jqLite: true,
  jQuery: true,
  slice: true,
  splice: true,
  push: true,
  toString: true,
  ngMinErr: true,
  angularModule: true,
  uid: true,
  REGEX_STRING_REGEXP: true,
  VALIDITY_STATE_PROPERTY: true,

  lowercase: true,
  uppercase: true,
  manualLowercase: true,
  manualUppercase: true,
  nodeName_: true,
  isArrayLike: true,
  forEach: true,
  forEachSorted: true,
  reverseParams: true,
  nextUid: true,
  setHashKey: true,
  extend: true,
  toInt: true,
  inherit: true,
  merge: true,
  noop: true,
  identity: true,
  valueFn: true,
  isUndefined: true,
  isDefined: true,
  isObject: true,
  isBlankObject: true,
  isString: true,
  isNumber: true,
  isDate: true,
  isArray: true,
  isFunction: true,
  isRegExp: true,
  isWindow: true,
  isScope: true,
  isFile: true,
  isFormData: true,
  isBlob: true,
  isBoolean: true,
  isPromiseLike: true,
  trim: true,
  escapeForRegexp: true,
  isElement: true,
  makeMap: true,
  includes: true,
  arrayRemove: true,
  copy: true,
  equals: true,
  csp: true,
  jq: true,
  concat: true,
  sliceArgs: true,
  bind: true,
  toJsonReplacer: true,
  toJson: true,
  fromJson: true,
  convertTimezoneToLocal: true,
  timezoneToOffset: true,
  startingTag: true,
  tryDecodeURIComponent: true,
  parseKeyValue: true,
  toKeyValue: true,
  encodeUriSegment: true,
  encodeUriQuery: true,
  angularInit: true,
  bootstrap: true,
  getTestability: true,
  snake_case: true,
  bindJQuery: true,
  assertArg: true,
  assertArgFn: true,
  assertNotHasOwnProperty: true,
  getter: true,
  getBlockNodes: true,
  hasOwnProperty: true,
  createMap: true,

  NODE_TYPE_ELEMENT: true,
  NODE_TYPE_ATTRIBUTE: true,
  NODE_TYPE_TEXT: true,
  NODE_TYPE_COMMENT: true,
  NODE_TYPE_DOCUMENT: true,
  NODE_TYPE_DOCUMENT_FRAGMENT: true,
*/

////////////////////////////////////

/**
 * @ngdoc module
 * @name ng
 * @module ng
 * @installation
 * @description
 *
 * # ng (core module)
 * The ng module is loaded by default when an AngularJS application is started. The module itself
 * contains the essential components for an AngularJS application to function. The table below
 * lists a high level breakdown of each of the services/factories, filters, directives and testing
 * components available within this core module.
 *
 * <div doc-module-components="ng"></div>
 */

var REGEX_STRING_REGEXP = /^\/(.+)\/([a-z]*)$/;

// The name of a form control's ValidityState property.
// This is used so that it's possible for internal tests to create mock ValidityStates.
var VALIDITY_STATE_PROPERTY = 'validity';

var hasOwnProperty = Object.prototype.hasOwnProperty;

var lowercase = function(string) {return isString(string) ? string.toLowerCase() : string;};
var uppercase = function(string) {return isString(string) ? string.toUpperCase() : string;};


var manualLowercase = function(s) {
  /* jshint bitwise: false */
  return isString(s)
      ? s.replace(/[A-Z]/g, function(ch) {return String.fromCharCode(ch.charCodeAt(0) | 32);})
      : s;
};
var manualUppercase = function(s) {
  /* jshint bitwise: false */
  return isString(s)
      ? s.replace(/[a-z]/g, function(ch) {return String.fromCharCode(ch.charCodeAt(0) & ~32);})
      : s;
};


// String#toLowerCase and String#toUpperCase don't produce correct results in browsers with Turkish
// locale, for this reason we need to detect this case and redefine lowercase/uppercase methods
// with correct but slower alternatives. See https://github.com/angular/angular.js/issues/11387
if ('i' !== 'I'.toLowerCase()) {
  lowercase = manualLowercase;
  uppercase = manualUppercase;
}


var
    msie,             // holds major version number for IE, or NaN if UA is not IE.
    jqLite,           // delay binding since jQuery could be loaded after us.
    jQuery,           // delay binding
    slice             = [].slice,
    splice            = [].splice,
    push              = [].push,
    toString          = Object.prototype.toString,
    getPrototypeOf    = Object.getPrototypeOf,
    ngMinErr          = minErr('ng'),

    /** @name angular */
    angular           = window.angular || (window.angular = {}),
    angularModule,
    uid               = 0;

/**
 * documentMode is an IE-only property
 * http://msdn.microsoft.com/en-us/library/ie/cc196988(v=vs.85).aspx
 */
msie = window.document.documentMode;


/**
 * @private
 * @param {*} obj
 * @return {boolean} Returns true if `obj` is an array or array-like object (NodeList, Arguments,
 *                   String ...)
 */
function isArrayLike(obj) {

  // `null`, `undefined` and `window` are not array-like
  if (obj == null || isWindow(obj)) return false;

  // arrays, strings and jQuery/jqLite objects are array like
  // * jqLite is either the jQuery or jqLite constructor function
  // * we have to check the existence of jqLite first as this method is called
  //   via the forEach method when constructing the jqLite object in the first place
  if (isArray(obj) || isString(obj) || (jqLite && obj instanceof jqLite)) return true;

  // Support: iOS 8.2 (not reproducible in simulator)
  // "length" in obj used to prevent JIT error (gh-11508)
  var length = "length" in Object(obj) && obj.length;

  // NodeList objects (with `item` method) and
  // other objects with suitable length characteristics are array-like
  return isNumber(length) &&
    (length >= 0 && ((length - 1) in obj || obj instanceof Array) || typeof obj.item == 'function');

}

/**
 * @ngdoc function
 * @name angular.forEach
 * @module ng
 * @kind function
 *
 * @description
 * Invokes the `iterator` function once for each item in `obj` collection, which can be either an
 * object or an array. The `iterator` function is invoked with `iterator(value, key, obj)`, where `value`
 * is the value of an object property or an array element, `key` is the object property key or
 * array element index and obj is the `obj` itself. Specifying a `context` for the function is optional.
 *
 * It is worth noting that `.forEach` does not iterate over inherited properties because it filters
 * using the `hasOwnProperty` method.
 *
 * Unlike ES262's
 * [Array.prototype.forEach](http://www.ecma-international.org/ecma-262/5.1/#sec-15.4.4.18),
 * providing 'undefined' or 'null' values for `obj` will not throw a TypeError, but rather just
 * return the value provided.
 *
   ```js
     var values = {name: 'misko', gender: 'male'};
     var log = [];
     angular.forEach(values, function(value, key) {
       this.push(key + ': ' + value);
     }, log);
     expect(log).toEqual(['name: misko', 'gender: male']);
   ```
 *
 * @param {Object|Array} obj Object to iterate over.
 * @param {Function} iterator Iterator function.
 * @param {Object=} context Object to become context (`this`) for the iterator function.
 * @returns {Object|Array} Reference to `obj`.
 */

function forEach(obj, iterator, context) {
  var key, length;
  if (obj) {
    if (isFunction(obj)) {
      for (key in obj) {
        // Need to check if hasOwnProperty exists,
        // as on IE8 the result of querySelectorAll is an object without a hasOwnProperty function
        if (key != 'prototype' && key != 'length' && key != 'name' && (!obj.hasOwnProperty || obj.hasOwnProperty(key))) {
          iterator.call(context, obj[key], key, obj);
        }
      }
    } else if (isArray(obj) || isArrayLike(obj)) {
      var isPrimitive = typeof obj !== 'object';
      for (key = 0, length = obj.length; key < length; key++) {
        if (isPrimitive || key in obj) {
          iterator.call(context, obj[key], key, obj);
        }
      }
    } else if (obj.forEach && obj.forEach !== forEach) {
        obj.forEach(iterator, context, obj);
    } else if (isBlankObject(obj)) {
      // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
      for (key in obj) {
        iterator.call(context, obj[key], key, obj);
      }
    } else if (typeof obj.hasOwnProperty === 'function') {
      // Slow path for objects inheriting Object.prototype, hasOwnProperty check needed
      for (key in obj) {
        if (obj.hasOwnProperty(key)) {
          iterator.call(context, obj[key], key, obj);
        }
      }
    } else {
      // Slow path for objects which do not have a method `hasOwnProperty`
      for (key in obj) {
        if (hasOwnProperty.call(obj, key)) {
          iterator.call(context, obj[key], key, obj);
        }
      }
    }
  }
  return obj;
}

function forEachSorted(obj, iterator, context) {
  var keys = Object.keys(obj).sort();
  for (var i = 0; i < keys.length; i++) {
    iterator.call(context, obj[keys[i]], keys[i]);
  }
  return keys;
}


/**
 * when using forEach the params are value, key, but it is often useful to have key, value.
 * @param {function(string, *)} iteratorFn
 * @returns {function(*, string)}
 */
function reverseParams(iteratorFn) {
  return function(value, key) {iteratorFn(key, value);};
}

/**
 * A consistent way of creating unique IDs in angular.
 *
 * Using simple numbers allows us to generate 28.6 million unique ids per second for 10 years before
 * we hit number precision issues in JavaScript.
 *
 * Math.pow(2,53) / 60 / 60 / 24 / 365 / 10 = 28.6M
 *
 * @returns {number} an unique alpha-numeric string
 */
function nextUid() {
  return ++uid;
}


/**
 * Set or clear the hashkey for an object.
 * @param obj object
 * @param h the hashkey (!truthy to delete the hashkey)
 */
function setHashKey(obj, h) {
  if (h) {
    obj.$$hashKey = h;
  } else {
    delete obj.$$hashKey;
  }
}


function baseExtend(dst, objs, deep) {
  var h = dst.$$hashKey;

  for (var i = 0, ii = objs.length; i < ii; ++i) {
    var obj = objs[i];
    if (!isObject(obj) && !isFunction(obj)) continue;
    var keys = Object.keys(obj);
    for (var j = 0, jj = keys.length; j < jj; j++) {
      var key = keys[j];
      var src = obj[key];

      if (deep && isObject(src)) {
        if (isDate(src)) {
          dst[key] = new Date(src.valueOf());
        } else if (isRegExp(src)) {
          dst[key] = new RegExp(src);
        } else if (src.nodeName) {
          dst[key] = src.cloneNode(true);
        } else if (isElement(src)) {
          dst[key] = src.clone();
        } else {
          if (!isObject(dst[key])) dst[key] = isArray(src) ? [] : {};
          baseExtend(dst[key], [src], true);
        }
      } else {
        dst[key] = src;
      }
    }
  }

  setHashKey(dst, h);
  return dst;
}

/**
 * @ngdoc function
 * @name angular.extend
 * @module ng
 * @kind function
 *
 * @description
 * Extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
 * to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
 * by passing an empty object as the target: `var object = angular.extend({}, object1, object2)`.
 *
 * **Note:** Keep in mind that `angular.extend` does not support recursive merge (deep copy). Use
 * {@link angular.merge} for this.
 *
 * @param {Object} dst Destination object.
 * @param {...Object} src Source object(s).
 * @returns {Object} Reference to `dst`.
 */
function extend(dst) {
  return baseExtend(dst, slice.call(arguments, 1), false);
}


/**
* @ngdoc function
* @name angular.merge
* @module ng
* @kind function
*
* @description
* Deeply extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
* to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
* by passing an empty object as the target: `var object = angular.merge({}, object1, object2)`.
*
* Unlike {@link angular.extend extend()}, `merge()` recursively descends into object properties of source
* objects, performing a deep copy.
*
* @param {Object} dst Destination object.
* @param {...Object} src Source object(s).
* @returns {Object} Reference to `dst`.
*/
function merge(dst) {
  return baseExtend(dst, slice.call(arguments, 1), true);
}



function toInt(str) {
  return parseInt(str, 10);
}


function inherit(parent, extra) {
  return extend(Object.create(parent), extra);
}

/**
 * @ngdoc function
 * @name angular.noop
 * @module ng
 * @kind function
 *
 * @description
 * A function that performs no operations. This function can be useful when writing code in the
 * functional style.
   ```js
     function foo(callback) {
       var result = calculateResult();
       (callback || angular.noop)(result);
     }
   ```
 */
function noop() {}
noop.$inject = [];


/**
 * @ngdoc function
 * @name angular.identity
 * @module ng
 * @kind function
 *
 * @description
 * A function that returns its first argument. This function is useful when writing code in the
 * functional style.
 *
   ```js
   function transformer(transformationFn, value) {
     return (transformationFn || angular.identity)(value);
   };

   // E.g.
   function getResult(fn, input) {
     return (fn || angular.identity)(input);
   };

   getResult(function(n) { return n * 2; }, 21);   // returns 42
   getResult(null, 21);                            // returns 21
   getResult(undefined, 21);                       // returns 21
   ```
 *
 * @param {*} value to be returned.
 * @returns {*} the value passed in.
 */
function identity($) {return $;}
identity.$inject = [];


function valueFn(value) {return function valueRef() {return value;};}

function hasCustomToString(obj) {
  return isFunction(obj.toString) && obj.toString !== toString;
}


/**
 * @ngdoc function
 * @name angular.isUndefined
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is undefined.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is undefined.
 */
function isUndefined(value) {return typeof value === 'undefined';}


/**
 * @ngdoc function
 * @name angular.isDefined
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is defined.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is defined.
 */
function isDefined(value) {return typeof value !== 'undefined';}


/**
 * @ngdoc function
 * @name angular.isObject
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is an `Object`. Unlike `typeof` in JavaScript, `null`s are not
 * considered to be objects. Note that JavaScript arrays are objects.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is an `Object` but not `null`.
 */
function isObject(value) {
  // http://jsperf.com/isobject4
  return value !== null && typeof value === 'object';
}


/**
 * Determine if a value is an object with a null prototype
 *
 * @returns {boolean} True if `value` is an `Object` with a null prototype
 */
function isBlankObject(value) {
  return value !== null && typeof value === 'object' && !getPrototypeOf(value);
}


/**
 * @ngdoc function
 * @name angular.isString
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is a `String`.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a `String`.
 */
function isString(value) {return typeof value === 'string';}


/**
 * @ngdoc function
 * @name angular.isNumber
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is a `Number`.
 *
 * This includes the "special" numbers `NaN`, `+Infinity` and `-Infinity`.
 *
 * If you wish to exclude these then you can use the native
 * [`isFinite'](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/isFinite)
 * method.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a `Number`.
 */
function isNumber(value) {return typeof value === 'number';}


/**
 * @ngdoc function
 * @name angular.isDate
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a value is a date.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a `Date`.
 */
function isDate(value) {
  return toString.call(value) === '[object Date]';
}


/**
 * @ngdoc function
 * @name angular.isArray
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is an `Array`.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is an `Array`.
 */
var isArray = Array.isArray;

/**
 * @ngdoc function
 * @name angular.isFunction
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is a `Function`.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a `Function`.
 */
function isFunction(value) {return typeof value === 'function';}


/**
 * Determines if a value is a regular expression object.
 *
 * @private
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a `RegExp`.
 */
function isRegExp(value) {
  return toString.call(value) === '[object RegExp]';
}


/**
 * Checks if `obj` is a window object.
 *
 * @private
 * @param {*} obj Object to check
 * @returns {boolean} True if `obj` is a window obj.
 */
function isWindow(obj) {
  return obj && obj.window === obj;
}


function isScope(obj) {
  return obj && obj.$evalAsync && obj.$watch;
}


function isFile(obj) {
  return toString.call(obj) === '[object File]';
}


function isFormData(obj) {
  return toString.call(obj) === '[object FormData]';
}


function isBlob(obj) {
  return toString.call(obj) === '[object Blob]';
}


function isBoolean(value) {
  return typeof value === 'boolean';
}


function isPromiseLike(obj) {
  return obj && isFunction(obj.then);
}


var TYPED_ARRAY_REGEXP = /^\[object (?:Uint8|Uint8Clamped|Uint16|Uint32|Int8|Int16|Int32|Float32|Float64)Array\]$/;
function isTypedArray(value) {
  return value && isNumber(value.length) && TYPED_ARRAY_REGEXP.test(toString.call(value));
}

function isArrayBuffer(obj) {
  return toString.call(obj) === '[object ArrayBuffer]';
}


var trim = function(value) {
  return isString(value) ? value.trim() : value;
};

// Copied from:
// http://docs.closure-library.googlecode.com/git/local_closure_goog_string_string.js.source.html#line1021
// Prereq: s is a string.
var escapeForRegexp = function(s) {
  return s.replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g, '\\$1').
           replace(/\x08/g, '\\x08');
};


/**
 * @ngdoc function
 * @name angular.isElement
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is a DOM element (or wrapped jQuery element).
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a DOM element (or wrapped jQuery element).
 */
function isElement(node) {
  return !!(node &&
    (node.nodeName  // We are a direct element.
    || (node.prop && node.attr && node.find)));  // We have an on and find method part of jQuery API.
}

/**
 * @param str 'key1,key2,...'
 * @returns {object} in the form of {key1:true, key2:true, ...}
 */
function makeMap(str) {
  var obj = {}, items = str.split(','), i;
  for (i = 0; i < items.length; i++) {
    obj[items[i]] = true;
  }
  return obj;
}


function nodeName_(element) {
  return lowercase(element.nodeName || (element[0] && element[0].nodeName));
}

function includes(array, obj) {
  return Array.prototype.indexOf.call(array, obj) != -1;
}

function arrayRemove(array, value) {
  var index = array.indexOf(value);
  if (index >= 0) {
    array.splice(index, 1);
  }
  return index;
}

/**
 * @ngdoc function
 * @name angular.copy
 * @module ng
 * @kind function
 *
 * @description
 * Creates a deep copy of `source`, which should be an object or an array.
 *
 * * If no destination is supplied, a copy of the object or array is created.
 * * If a destination is provided, all of its elements (for arrays) or properties (for objects)
 *   are deleted and then all elements/properties from the source are copied to it.
 * * If `source` is not an object or array (inc. `null` and `undefined`), `source` is returned.
 * * If `source` is identical to `destination` an exception will be thrown.
 *
 * <br />
 * <div class="alert alert-warning">
 *   Only enumerable properties are taken into account. Non-enumerable properties (both on `source`
 *   and on `destination`) will be ignored.
 * </div>
 *
 * @param {*} source The source that will be used to make a copy.
 *                   Can be any type, including primitives, `null`, and `undefined`.
 * @param {(Object|Array)=} destination Destination into which the source is copied. If
 *     provided, must be of the same type as `source`.
 * @returns {*} The copy or updated `destination`, if `destination` was specified.
 *
 * @example
  <example module="copyExample">
    <file name="index.html">
      <div ng-controller="ExampleController">
        <form novalidate class="simple-form">
          <label>Name: <input type="text" ng-model="user.name" /></label><br />
          <label>Age:  <input type="number" ng-model="user.age" /></label><br />
          Gender: <label><input type="radio" ng-model="user.gender" value="male" />male</label>
                  <label><input type="radio" ng-model="user.gender" value="female" />female</label><br />
          <button ng-click="reset()">RESET</button>
          <button ng-click="update(user)">SAVE</button>
        </form>
        <pre>form = {{user | json}}</pre>
        <pre>master = {{master | json}}</pre>
      </div>
    </file>
    <file name="script.js">
      // Module: copyExample
      angular.
        module('copyExample', []).
        controller('ExampleController', ['$scope', function($scope) {
          $scope.master = {};

          $scope.reset = function() {
            // Example with 1 argument
            $scope.user = angular.copy($scope.master);
          };

          $scope.update = function(user) {
            // Example with 2 arguments
            angular.copy(user, $scope.master);
          };

          $scope.reset();
        }]);
    </file>
  </example>
 */
function copy(source, destination) {
  var stackSource = [];
  var stackDest = [];

  if (destination) {
    if (isTypedArray(destination) || isArrayBuffer(destination)) {
      throw ngMinErr('cpta', "Can't copy! TypedArray destination cannot be mutated.");
    }
    if (source === destination) {
      throw ngMinErr('cpi', "Can't copy! Source and destination are identical.");
    }

    // Empty the destination object
    if (isArray(destination)) {
      destination.length = 0;
    } else {
      forEach(destination, function(value, key) {
        if (key !== '$$hashKey') {
          delete destination[key];
        }
      });
    }

    stackSource.push(source);
    stackDest.push(destination);
    return copyRecurse(source, destination);
  }

  return copyElement(source);

  function copyRecurse(source, destination) {
    var h = destination.$$hashKey;
    var key;
    if (isArray(source)) {
      for (var i = 0, ii = source.length; i < ii; i++) {
        destination.push(copyElement(source[i]));
      }
    } else if (isBlankObject(source)) {
      // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
      for (key in source) {
        destination[key] = copyElement(source[key]);
      }
    } else if (source && typeof source.hasOwnProperty === 'function') {
      // Slow path, which must rely on hasOwnProperty
      for (key in source) {
        if (source.hasOwnProperty(key)) {
          destination[key] = copyElement(source[key]);
        }
      }
    } else {
      // Slowest path --- hasOwnProperty can't be called as a method
      for (key in source) {
        if (hasOwnProperty.call(source, key)) {
          destination[key] = copyElement(source[key]);
        }
      }
    }
    setHashKey(destination, h);
    return destination;
  }

  function copyElement(source) {
    // Simple values
    if (!isObject(source)) {
      return source;
    }

    // Already copied values
    var index = stackSource.indexOf(source);
    if (index !== -1) {
      return stackDest[index];
    }

    if (isWindow(source) || isScope(source)) {
      throw ngMinErr('cpws',
        "Can't copy! Making copies of Window or Scope instances is not supported.");
    }

    var needsRecurse = false;
    var destination = copyType(source);

    if (destination === undefined) {
      destination = isArray(source) ? [] : Object.create(getPrototypeOf(source));
      needsRecurse = true;
    }

    stackSource.push(source);
    stackDest.push(destination);

    return needsRecurse
      ? copyRecurse(source, destination)
      : destination;
  }

  function copyType(source) {
    switch (toString.call(source)) {
      case '[object Int8Array]':
      case '[object Int16Array]':
      case '[object Int32Array]':
      case '[object Float32Array]':
      case '[object Float64Array]':
      case '[object Uint8Array]':
      case '[object Uint8ClampedArray]':
      case '[object Uint16Array]':
      case '[object Uint32Array]':
        return new source.constructor(copyElement(source.buffer), source.byteOffset, source.length);

      case '[object ArrayBuffer]':
        //Support: IE10
        if (!source.slice) {
          var copied = new ArrayBuffer(source.byteLength);
          new Uint8Array(copied).set(new Uint8Array(source));
          return copied;
        }
        return source.slice(0);

      case '[object Boolean]':
      case '[object Number]':
      case '[object String]':
      case '[object Date]':
        return new source.constructor(source.valueOf());

      case '[object RegExp]':
        var re = new RegExp(source.source, source.toString().match(/[^\/]*$/)[0]);
        re.lastIndex = source.lastIndex;
        return re;

      case '[object Blob]':
        return new source.constructor([source], {type: source.type});
    }

    if (isFunction(source.cloneNode)) {
      return source.cloneNode(true);
    }
  }
}


/**
 * @ngdoc function
 * @name angular.equals
 * @module ng
 * @kind function
 *
 * @description
 * Determines if two objects or two values are equivalent. Supports value types, regular
 * expressions, arrays and objects.
 *
 * Two objects or values are considered equivalent if at least one of the following is true:
 *
 * * Both objects or values pass `===` comparison.
 * * Both objects or values are of the same type and all of their properties are equal by
 *   comparing them with `angular.equals`.
 * * Both values are NaN. (In JavaScript, NaN == NaN => false. But we consider two NaN as equal)
 * * Both values represent the same regular expression (In JavaScript,
 *   /abc/ == /abc/ => false. But we consider two regular expressions as equal when their textual
 *   representation matches).
 *
 * During a property comparison, properties of `function` type and properties with names
 * that begin with `$` are ignored.
 *
 * Scope and DOMWindow objects are being compared only by identify (`===`).
 *
 * @param {*} o1 Object or value to compare.
 * @param {*} o2 Object or value to compare.
 * @returns {boolean} True if arguments are equal.
 *
 * @example
   <example module="equalsExample" name="equalsExample">
     <file name="index.html">
      <div ng-controller="ExampleController">
        <form novalidate>
          <h3>User 1</h3>
          Name: <input type="text" ng-model="user1.name">
          Age: <input type="number" ng-model="user1.age">

          <h3>User 2</h3>
          Name: <input type="text" ng-model="user2.name">
          Age: <input type="number" ng-model="user2.age">

          <div>
            <br/>
            <input type="button" value="Compare" ng-click="compare()">
          </div>
          User 1: <pre>{{user1 | json}}</pre>
          User 2: <pre>{{user2 | json}}</pre>
          Equal: <pre>{{result}}</pre>
        </form>
      </div>
    </file>
    <file name="script.js">
        angular.module('equalsExample', []).controller('ExampleController', ['$scope', function($scope) {
          $scope.user1 = {};
          $scope.user2 = {};
          $scope.result;
          $scope.compare = function() {
            $scope.result = angular.equals($scope.user1, $scope.user2);
          };
        }]);
    </file>
  </example>
 */
function equals(o1, o2) {
  if (o1 === o2) return true;
  if (o1 === null || o2 === null) return false;
  if (o1 !== o1 && o2 !== o2) return true; // NaN === NaN
  var t1 = typeof o1, t2 = typeof o2, length, key, keySet;
  if (t1 == t2 && t1 == 'object') {
    if (isArray(o1)) {
      if (!isArray(o2)) return false;
      if ((length = o1.length) == o2.length) {
        for (key = 0; key < length; key++) {
          if (!equals(o1[key], o2[key])) return false;
        }
        return true;
      }
    } else if (isDate(o1)) {
      if (!isDate(o2)) return false;
      return equals(o1.getTime(), o2.getTime());
    } else if (isRegExp(o1)) {
      if (!isRegExp(o2)) return false;
      return o1.toString() == o2.toString();
    } else {
      if (isScope(o1) || isScope(o2) || isWindow(o1) || isWindow(o2) ||
        isArray(o2) || isDate(o2) || isRegExp(o2)) return false;
      keySet = createMap();
      for (key in o1) {
        if (key.charAt(0) === '$' || isFunction(o1[key])) continue;
        if (!equals(o1[key], o2[key])) return false;
        keySet[key] = true;
      }
      for (key in o2) {
        if (!(key in keySet) &&
            key.charAt(0) !== '$' &&
            isDefined(o2[key]) &&
            !isFunction(o2[key])) return false;
      }
      return true;
    }
  }
  return false;
}

var csp = function() {
  if (!isDefined(csp.rules)) {


    var ngCspElement = (window.document.querySelector('[ng-csp]') ||
                    window.document.querySelector('[data-ng-csp]'));

    if (ngCspElement) {
      var ngCspAttribute = ngCspElement.getAttribute('ng-csp') ||
                    ngCspElement.getAttribute('data-ng-csp');
      csp.rules = {
        noUnsafeEval: !ngCspAttribute || (ngCspAttribute.indexOf('no-unsafe-eval') !== -1),
        noInlineStyle: !ngCspAttribute || (ngCspAttribute.indexOf('no-inline-style') !== -1)
      };
    } else {
      csp.rules = {
        noUnsafeEval: noUnsafeEval(),
        noInlineStyle: false
      };
    }
  }

  return csp.rules;

  function noUnsafeEval() {
    try {
      /* jshint -W031, -W054 */
      new Function('');
      /* jshint +W031, +W054 */
      return false;
    } catch (e) {
      return true;
    }
  }
};

/**
 * @ngdoc directive
 * @module ng
 * @name ngJq
 *
 * @element ANY
 * @param {string=} ngJq the name of the library available under `window`
 * to be used for angular.element
 * @description
 * Use this directive to force the angular.element library.  This should be
 * used to force either jqLite by leaving ng-jq blank or setting the name of
 * the jquery variable under window (eg. jQuery).
 *
 * Since angular looks for this directive when it is loaded (doesn't wait for the
 * DOMContentLoaded event), it must be placed on an element that comes before the script
 * which loads angular. Also, only the first instance of `ng-jq` will be used and all
 * others ignored.
 *
 * @example
 * This example shows how to force jqLite using the `ngJq` directive to the `html` tag.
 ```html
 <!doctype html>
 <html ng-app ng-jq>
 ...
 ...
 </html>
 ```
 * @example
 * This example shows how to use a jQuery based library of a different name.
 * The library name must be available at the top most 'window'.
 ```html
 <!doctype html>
 <html ng-app ng-jq="jQueryLib">
 ...
 ...
 </html>
 ```
 */
var jq = function() {
  if (isDefined(jq.name_)) return jq.name_;
  var el;
  var i, ii = ngAttrPrefixes.length, prefix, name;
  for (i = 0; i < ii; ++i) {
    prefix = ngAttrPrefixes[i];
    if (el = window.document.querySelector('[' + prefix.replace(':', '\\:') + 'jq]')) {
      name = el.getAttribute(prefix + 'jq');
      break;
    }
  }

  return (jq.name_ = name);
};

function concat(array1, array2, index) {
  return array1.concat(slice.call(array2, index));
}

function sliceArgs(args, startIndex) {
  return slice.call(args, startIndex || 0);
}


/* jshint -W101 */
/**
 * @ngdoc function
 * @name angular.bind
 * @module ng
 * @kind function
 *
 * @description
 * Returns a function which calls function `fn` bound to `self` (`self` becomes the `this` for
 * `fn`). You can supply optional `args` that are prebound to the function. This feature is also
 * known as [partial application](http://en.wikipedia.org/wiki/Partial_application), as
 * distinguished from [function currying](http://en.wikipedia.org/wiki/Currying#Contrast_with_partial_function_application).
 *
 * @param {Object} self Context which `fn` should be evaluated in.
 * @param {function()} fn Function to be bound.
 * @param {...*} args Optional arguments to be prebound to the `fn` function call.
 * @returns {function()} Function that wraps the `fn` with all the specified bindings.
 */
/* jshint +W101 */
function bind(self, fn) {
  var curryArgs = arguments.length > 2 ? sliceArgs(arguments, 2) : [];
  if (isFunction(fn) && !(fn instanceof RegExp)) {
    return curryArgs.length
      ? function() {
          return arguments.length
            ? fn.apply(self, concat(curryArgs, arguments, 0))
            : fn.apply(self, curryArgs);
        }
      : function() {
          return arguments.length
            ? fn.apply(self, arguments)
            : fn.call(self);
        };
  } else {
    // In IE, native methods are not functions so they cannot be bound (note: they don't need to be).
    return fn;
  }
}


function toJsonReplacer(key, value) {
  var val = value;

  if (typeof key === 'string' && key.charAt(0) === '$' && key.charAt(1) === '$') {
    val = undefined;
  } else if (isWindow(value)) {
    val = '$WINDOW';
  } else if (value &&  window.document === value) {
    val = '$DOCUMENT';
  } else if (isScope(value)) {
    val = '$SCOPE';
  }

  return val;
}


/**
 * @ngdoc function
 * @name angular.toJson
 * @module ng
 * @kind function
 *
 * @description
 * Serializes input into a JSON-formatted string. Properties with leading $$ characters will be
 * stripped since angular uses this notation internally.
 *
 * @param {Object|Array|Date|string|number} obj Input to be serialized into JSON.
 * @param {boolean|number} [pretty=2] If set to true, the JSON output will contain newlines and whitespace.
 *    If set to an integer, the JSON output will contain that many spaces per indentation.
 * @returns {string|undefined} JSON-ified string representing `obj`.
 * @knownIssue
 *
 * The Safari browser throws a `RangeError` instead of returning `null` when it tries to stringify a `Date`
 * object with an invalid date value. The only reliable way to prevent this is to monkeypatch the
 * `Date.prototype.toJSON` method as follows:
 *
 * ```
 * var _DatetoJSON = Date.prototype.toJSON;
 * Date.prototype.toJSON = function() {
 *   try {
 *     return _DatetoJSON.call(this);
 *   } catch(e) {
 *     if (e instanceof RangeError) {
 *       return null;
 *     }
 *     throw e;
 *   }
 * };
 * ```
 *
 * See https://github.com/angular/angular.js/pull/14221 for more information.
 */
function toJson(obj, pretty) {
  if (isUndefined(obj)) return undefined;
  if (!isNumber(pretty)) {
    pretty = pretty ? 2 : null;
  }
  return JSON.stringify(obj, toJsonReplacer, pretty);
}


/**
 * @ngdoc function
 * @name angular.fromJson
 * @module ng
 * @kind function
 *
 * @description
 * Deserializes a JSON string.
 *
 * @param {string} json JSON string to deserialize.
 * @returns {Object|Array|string|number} Deserialized JSON string.
 */
function fromJson(json) {
  return isString(json)
      ? JSON.parse(json)
      : json;
}


var ALL_COLONS = /:/g;
function timezoneToOffset(timezone, fallback) {
  // IE/Edge do not "understand" colon (`:`) in timezone
  timezone = timezone.replace(ALL_COLONS, '');
  var requestedTimezoneOffset = Date.parse('Jan 01, 1970 00:00:00 ' + timezone) / 60000;
  return isNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;
}


function addDateMinutes(date, minutes) {
  date = new Date(date.getTime());
  date.setMinutes(date.getMinutes() + minutes);
  return date;
}


function convertTimezoneToLocal(date, timezone, reverse) {
  reverse = reverse ? -1 : 1;
  var dateTimezoneOffset = date.getTimezoneOffset();
  var timezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
  return addDateMinutes(date, reverse * (timezoneOffset - dateTimezoneOffset));
}


/**
 * @returns {string} Returns the string representation of the element.
 */
function startingTag(element) {
  element = jqLite(element).clone();
  try {
    // turns out IE does not let you set .html() on elements which
    // are not allowed to have children. So we just ignore it.
    element.empty();
  } catch (e) {}
  var elemHtml = jqLite('<div>').append(element).html();
  try {
    return element[0].nodeType === NODE_TYPE_TEXT ? lowercase(elemHtml) :
        elemHtml.
          match(/^(<[^>]+>)/)[1].
          replace(/^<([\w\-]+)/, function(match, nodeName) {return '<' + lowercase(nodeName);});
  } catch (e) {
    return lowercase(elemHtml);
  }

}


/////////////////////////////////////////////////

/**
 * Tries to decode the URI component without throwing an exception.
 *
 * @private
 * @param str value potential URI component to check.
 * @returns {boolean} True if `value` can be decoded
 * with the decodeURIComponent function.
 */
function tryDecodeURIComponent(value) {
  try {
    return decodeURIComponent(value);
  } catch (e) {
    // Ignore any invalid uri component.
  }
}


/**
 * Parses an escaped url query string into key-value pairs.
 * @returns {Object.<string,boolean|Array>}
 */
function parseKeyValue(/**string*/keyValue) {
  var obj = {};
  forEach((keyValue || "").split('&'), function(keyValue) {
    var splitPoint, key, val;
    if (keyValue) {
      key = keyValue = keyValue.replace(/\+/g,'%20');
      splitPoint = keyValue.indexOf('=');
      if (splitPoint !== -1) {
        key = keyValue.substring(0, splitPoint);
        val = keyValue.substring(splitPoint + 1);
      }
      key = tryDecodeURIComponent(key);
      if (isDefined(key)) {
        val = isDefined(val) ? tryDecodeURIComponent(val) : true;
        if (!hasOwnProperty.call(obj, key)) {
          obj[key] = val;
        } else if (isArray(obj[key])) {
          obj[key].push(val);
        } else {
          obj[key] = [obj[key],val];
        }
      }
    }
  });
  return obj;
}

function toKeyValue(obj) {
  var parts = [];
  forEach(obj, function(value, key) {
    if (isArray(value)) {
      forEach(value, function(arrayValue) {
        parts.push(encodeUriQuery(key, true) +
                   (arrayValue === true ? '' : '=' + encodeUriQuery(arrayValue, true)));
      });
    } else {
    parts.push(encodeUriQuery(key, true) +
               (value === true ? '' : '=' + encodeUriQuery(value, true)));
    }
  });
  return parts.length ? parts.join('&') : '';
}


/**
 * We need our custom method because encodeURIComponent is too aggressive and doesn't follow
 * http://www.ietf.org/rfc/rfc3986.txt with regards to the character set (pchar) allowed in path
 * segments:
 *    segment       = *pchar
 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
 *    pct-encoded   = "%" HEXDIG HEXDIG
 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
 *                     / "*" / "+" / "," / ";" / "="
 */
function encodeUriSegment(val) {
  return encodeUriQuery(val, true).
             replace(/%26/gi, '&').
             replace(/%3D/gi, '=').
             replace(/%2B/gi, '+');
}


/**
 * This method is intended for encoding *key* or *value* parts of query component. We need a custom
 * method because encodeURIComponent is too aggressive and encodes stuff that doesn't have to be
 * encoded per http://tools.ietf.org/html/rfc3986:
 *    query       = *( pchar / "/" / "?" )
 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
 *    pct-encoded   = "%" HEXDIG HEXDIG
 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
 *                     / "*" / "+" / "," / ";" / "="
 */
function encodeUriQuery(val, pctEncodeSpaces) {
  return encodeURIComponent(val).
             replace(/%40/gi, '@').
             replace(/%3A/gi, ':').
             replace(/%24/g, '$').
             replace(/%2C/gi, ',').
             replace(/%3B/gi, ';').
             replace(/%20/g, (pctEncodeSpaces ? '%20' : '+'));
}

var ngAttrPrefixes = ['ng-', 'data-ng-', 'ng:', 'x-ng-'];

function getNgAttribute(element, ngAttr) {
  var attr, i, ii = ngAttrPrefixes.length;
  for (i = 0; i < ii; ++i) {
    attr = ngAttrPrefixes[i] + ngAttr;
    if (isString(attr = element.getAttribute(attr))) {
      return attr;
    }
  }
  return null;
}

/**
 * @ngdoc directive
 * @name ngApp
 * @module ng
 *
 * @element ANY
 * @param {angular.Module} ngApp an optional application
 *   {@link angular.module module} name to load.
 * @param {boolean=} ngStrictDi if this attribute is present on the app element, the injector will be
 *   created in "strict-di" mode. This means that the application will fail to invoke functions which
 *   do not use explicit function annotation (and are thus unsuitable for minification), as described
 *   in {@link guide/di the Dependency Injection guide}, and useful debugging info will assist in
 *   tracking down the root of these bugs.
 *
 * @description
 *
 * Use this directive to **auto-bootstrap** an AngularJS application. The `ngApp` directive
 * designates the **root element** of the application and is typically placed near the root element
 * of the page - e.g. on the `<body>` or `<html>` tags.
 *
 * There are a few things to keep in mind when using `ngApp`:
 * - only one AngularJS application can be auto-bootstrapped per HTML document. The first `ngApp`
 *   found in the document will be used to define the root element to auto-bootstrap as an
 *   application. To run multiple applications in an HTML document you must manually bootstrap them using
 *   {@link angular.bootstrap} instead.
 * - AngularJS applications cannot be nested within each other.
 * - Do not use a directive that uses {@link ng.$compile#transclusion transclusion} on the same element as `ngApp`.
 *   This includes directives such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and
 *   {@link ngRoute.ngView `ngView`}.
 *   Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
 *   causing animations to stop working and making the injector inaccessible from outside the app.
 *
 * You can specify an **AngularJS module** to be used as the root module for the application.  This
 * module will be loaded into the {@link auto.$injector} when the application is bootstrapped. It
 * should contain the application code needed or have dependencies on other modules that will
 * contain the code. See {@link angular.module} for more information.
 *
 * In the example below if the `ngApp` directive were not placed on the `html` element then the
 * document would not be compiled, the `AppController` would not be instantiated and the `{{ a+b }}`
 * would not be resolved to `3`.
 *
 * `ngApp` is the easiest, and most common way to bootstrap an application.
 *
 <example module="ngAppDemo">
   <file name="index.html">
   <div ng-controller="ngAppDemoController">
     I can add: {{a}} + {{b}} =  {{ a+b }}
   </div>
   </file>
   <file name="script.js">
   angular.module('ngAppDemo', []).controller('ngAppDemoController', function($scope) {
     $scope.a = 1;
     $scope.b = 2;
   });
   </file>
 </example>
 *
 * Using `ngStrictDi`, you would see something like this:
 *
 <example ng-app-included="true">
   <file name="index.html">
   <div ng-app="ngAppStrictDemo" ng-strict-di>
       <div ng-controller="GoodController1">
           I can add: {{a}} + {{b}} =  {{ a+b }}

           <p>This renders because the controller does not fail to
              instantiate, by using explicit annotation style (see
              script.js for details)
           </p>
       </div>

       <div ng-controller="GoodController2">
           Name: <input ng-model="name"><br />
           Hello, {{name}}!

           <p>This renders because the controller does not fail to
              instantiate, by using explicit annotation style
              (see script.js for details)
           </p>
       </div>

       <div ng-controller="BadController">
           I can add: {{a}} + {{b}} =  {{ a+b }}

           <p>The controller could not be instantiated, due to relying
              on automatic function annotations (which are disabled in
              strict mode). As such, the content of this section is not
              interpolated, and there should be an error in your web console.
           </p>
       </div>
   </div>
   </file>
   <file name="script.js">
   angular.module('ngAppStrictDemo', [])
     // BadController will fail to instantiate, due to relying on automatic function annotation,
     // rather than an explicit annotation
     .controller('BadController', function($scope) {
       $scope.a = 1;
       $scope.b = 2;
     })
     // Unlike BadController, GoodController1 and GoodController2 will not fail to be instantiated,
     // due to using explicit annotations using the array style and $inject property, respectively.
     .controller('GoodController1', ['$scope', function($scope) {
       $scope.a = 1;
       $scope.b = 2;
     }])
     .controller('GoodController2', GoodController2);
     function GoodController2($scope) {
       $scope.name = "World";
     }
     GoodController2.$inject = ['$scope'];
   </file>
   <file name="style.css">
   div[ng-controller] {
       margin-bottom: 1em;
       -webkit-border-radius: 4px;
       border-radius: 4px;
       border: 1px solid;
       padding: .5em;
   }
   div[ng-controller^=Good] {
       border-color: #d6e9c6;
       background-color: #dff0d8;
       color: #3c763d;
   }
   div[ng-controller^=Bad] {
       border-color: #ebccd1;
       background-color: #f2dede;
       color: #a94442;
       margin-bottom: 0;
   }
   </file>
 </example>
 */
function angularInit(element, bootstrap) {
  var appElement,
      module,
      config = {};

  // The element `element` has priority over any other element.
  forEach(ngAttrPrefixes, function(prefix) {
    var name = prefix + 'app';

    if (!appElement && element.hasAttribute && element.hasAttribute(name)) {
      appElement = element;
      module = element.getAttribute(name);
    }
  });
  forEach(ngAttrPrefixes, function(prefix) {
    var name = prefix + 'app';
    var candidate;

    if (!appElement && (candidate = element.querySelector('[' + name.replace(':', '\\:') + ']'))) {
      appElement = candidate;
      module = candidate.getAttribute(name);
    }
  });
  if (appElement) {
    config.strictDi = getNgAttribute(appElement, "strict-di") !== null;
    bootstrap(appElement, module ? [module] : [], config);
  }
}

/**
 * @ngdoc function
 * @name angular.bootstrap
 * @module ng
 * @description
 * Use this function to manually start up angular application.
 *
 * For more information, see the {@link guide/bootstrap Bootstrap guide}.
 *
 * Angular will detect if it has been loaded into the browser more than once and only allow the
 * first loaded script to be bootstrapped and will report a warning to the browser console for
 * each of the subsequent scripts. This prevents strange results in applications, where otherwise
 * multiple instances of Angular try to work on the DOM.
 *
 * <div class="alert alert-warning">
 * **Note:** Protractor based end-to-end tests cannot use this function to bootstrap manually.
 * They must use {@link ng.directive:ngApp ngApp}.
 * </div>
 *
 * <div class="alert alert-warning">
 * **Note:** Do not bootstrap the app on an element with a directive that uses {@link ng.$compile#transclusion transclusion},
 * such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and {@link ngRoute.ngView `ngView`}.
 * Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
 * causing animations to stop working and making the injector inaccessible from outside the app.
 * </div>
 *
 * ```html
 * <!doctype html>
 * <html>
 * <body>
 * <div ng-controller="WelcomeController">
 *   {{greeting}}
 * </div>
 *
 * <script src="angular.js"></script>
 * <script>
 *   var app = angular.module('demo', [])
 *   .controller('WelcomeController', function($scope) {
 *       $scope.greeting = 'Welcome!';
 *   });
 *   angular.bootstrap(document, ['demo']);
 * </script>
 * </body>
 * </html>
 * ```
 *
 * @param {DOMElement} element DOM element which is the root of angular application.
 * @param {Array<String|Function|Array>=} modules an array of modules to load into the application.
 *     Each item in the array should be the name of a predefined module or a (DI annotated)
 *     function that will be invoked by the injector as a `config` block.
 *     See: {@link angular.module modules}
 * @param {Object=} config an object for defining configuration options for the application. The
 *     following keys are supported:
 *
 * * `strictDi` - disable automatic function annotation for the application. This is meant to
 *   assist in finding bugs which break minified code. Defaults to `false`.
 *
 * @returns {auto.$injector} Returns the newly created injector for this app.
 */
function bootstrap(element, modules, config) {
  if (!isObject(config)) config = {};
  var defaultConfig = {
    strictDi: false
  };
  config = extend(defaultConfig, config);
  var doBootstrap = function() {
    element = jqLite(element);

    if (element.injector()) {
      var tag = (element[0] === window.document) ? 'document' : startingTag(element);
      // Encode angle brackets to prevent input from being sanitized to empty string #8683.
      throw ngMinErr(
          'btstrpd',
          "App already bootstrapped with this element '{0}'",
          tag.replace(/</,'&lt;').replace(/>/,'&gt;'));
    }

    modules = modules || [];
    modules.unshift(['$provide', function($provide) {
      $provide.value('$rootElement', element);
    }]);

    if (config.debugInfoEnabled) {
      // Pushing so that this overrides `debugInfoEnabled` setting defined in user's `modules`.
      modules.push(['$compileProvider', function($compileProvider) {
        $compileProvider.debugInfoEnabled(true);
      }]);
    }

    modules.unshift('ng');
    var injector = createInjector(modules, config.strictDi);
    injector.invoke(['$rootScope', '$rootElement', '$compile', '$injector',
       function bootstrapApply(scope, element, compile, injector) {
        scope.$apply(function() {
          element.data('$injector', injector);
          compile(element)(scope);
        });
      }]
    );
    return injector;
  };

  var NG_ENABLE_DEBUG_INFO = /^NG_ENABLE_DEBUG_INFO!/;
  var NG_DEFER_BOOTSTRAP = /^NG_DEFER_BOOTSTRAP!/;

  if (window && NG_ENABLE_DEBUG_INFO.test(window.name)) {
    config.debugInfoEnabled = true;
    window.name = window.name.replace(NG_ENABLE_DEBUG_INFO, '');
  }

  if (window && !NG_DEFER_BOOTSTRAP.test(window.name)) {
    return doBootstrap();
  }

  window.name = window.name.replace(NG_DEFER_BOOTSTRAP, '');
  angular.resumeBootstrap = function(extraModules) {
    forEach(extraModules, function(module) {
      modules.push(module);
    });
    return doBootstrap();
  };

  if (isFunction(angular.resumeDeferredBootstrap)) {
    angular.resumeDeferredBootstrap();
  }
}

/**
 * @ngdoc function
 * @name angular.reloadWithDebugInfo
 * @module ng
 * @description
 * Use this function to reload the current application with debug information turned on.
 * This takes precedence over a call to `$compileProvider.debugInfoEnabled(false)`.
 *
 * See {@link ng.$compileProvider#debugInfoEnabled} for more.
 */
function reloadWithDebugInfo() {
  window.name = 'NG_ENABLE_DEBUG_INFO!' + window.name;
  window.location.reload();
}

/**
 * @name angular.getTestability
 * @module ng
 * @description
 * Get the testability service for the instance of Angular on the given
 * element.
 * @param {DOMElement} element DOM element which is the root of angular application.
 */
function getTestability(rootElement) {
  var injector = angular.element(rootElement).injector();
  if (!injector) {
    throw ngMinErr('test',
      'no injector found for element argument to getTestability');
  }
  return injector.get('$$testability');
}

var SNAKE_CASE_REGEXP = /[A-Z]/g;
function snake_case(name, separator) {
  separator = separator || '_';
  return name.replace(SNAKE_CASE_REGEXP, function(letter, pos) {
    return (pos ? separator : '') + letter.toLowerCase();
  });
}

var bindJQueryFired = false;
function bindJQuery() {
  var originalCleanData;

  if (bindJQueryFired) {
    return;
  }

  // bind to jQuery if present;
  var jqName = jq();
  jQuery = isUndefined(jqName) ? __webpack_provided_window_dot_jQuery :   // use jQuery (if present)
           !jqName             ? undefined     :   // use jqLite
                                 window[jqName];   // use jQuery specified by `ngJq`

  // Use jQuery if it exists with proper functionality, otherwise default to us.
  // Angular 1.2+ requires jQuery 1.7+ for on()/off() support.
  // Angular 1.3+ technically requires at least jQuery 2.1+ but it may work with older
  // versions. It will not work for sure with jQuery <1.7, though.
  if (jQuery && jQuery.fn.on) {
    jqLite = jQuery;
    extend(jQuery.fn, {
      scope: JQLitePrototype.scope,
      isolateScope: JQLitePrototype.isolateScope,
      controller: JQLitePrototype.controller,
      injector: JQLitePrototype.injector,
      inheritedData: JQLitePrototype.inheritedData
    });

    // All nodes removed from the DOM via various jQuery APIs like .remove()
    // are passed through jQuery.cleanData. Monkey-patch this method to fire
    // the $destroy event on all removed nodes.
    originalCleanData = jQuery.cleanData;
    jQuery.cleanData = function(elems) {
      var events;
      for (var i = 0, elem; (elem = elems[i]) != null; i++) {
        events = jQuery._data(elem, "events");
        if (events && events.$destroy) {
          jQuery(elem).triggerHandler('$destroy');
        }
      }
      originalCleanData(elems);
    };
  } else {
    jqLite = JQLite;
  }

  angular.element = jqLite;

  // Prevent double-proxying.
  bindJQueryFired = true;
}

/**
 * throw error if the argument is falsy.
 */
function assertArg(arg, name, reason) {
  if (!arg) {
    throw ngMinErr('areq', "Argument '{0}' is {1}", (name || '?'), (reason || "required"));
  }
  return arg;
}

function assertArgFn(arg, name, acceptArrayAnnotation) {
  if (acceptArrayAnnotation && isArray(arg)) {
      arg = arg[arg.length - 1];
  }

  assertArg(isFunction(arg), name, 'not a function, got ' +
      (arg && typeof arg === 'object' ? arg.constructor.name || 'Object' : typeof arg));
  return arg;
}

/**
 * throw error if the name given is hasOwnProperty
 * @param  {String} name    the name to test
 * @param  {String} context the context in which the name is used, such as module or directive
 */
function assertNotHasOwnProperty(name, context) {
  if (name === 'hasOwnProperty') {
    throw ngMinErr('badname', "hasOwnProperty is not a valid {0} name", context);
  }
}

/**
 * Return the value accessible from the object by path. Any undefined traversals are ignored
 * @param {Object} obj starting object
 * @param {String} path path to traverse
 * @param {boolean} [bindFnToScope=true]
 * @returns {Object} value as accessible by path
 */
//TODO(misko): this function needs to be removed
function getter(obj, path, bindFnToScope) {
  if (!path) return obj;
  var keys = path.split('.');
  var key;
  var lastInstance = obj;
  var len = keys.length;

  for (var i = 0; i < len; i++) {
    key = keys[i];
    if (obj) {
      obj = (lastInstance = obj)[key];
    }
  }
  if (!bindFnToScope && isFunction(obj)) {
    return bind(lastInstance, obj);
  }
  return obj;
}

/**
 * Return the DOM siblings between the first and last node in the given array.
 * @param {Array} array like object
 * @returns {Array} the inputted object or a jqLite collection containing the nodes
 */
function getBlockNodes(nodes) {
  // TODO(perf): update `nodes` instead of creating a new object?
  var node = nodes[0];
  var endNode = nodes[nodes.length - 1];
  var blockNodes;

  for (var i = 1; node !== endNode && (node = node.nextSibling); i++) {
    if (blockNodes || nodes[i] !== node) {
      if (!blockNodes) {
        blockNodes = jqLite(slice.call(nodes, 0, i));
      }
      blockNodes.push(node);
    }
  }

  return blockNodes || nodes;
}


/**
 * Creates a new object without a prototype. This object is useful for lookup without having to
 * guard against prototypically inherited properties via hasOwnProperty.
 *
 * Related micro-benchmarks:
 * - http://jsperf.com/object-create2
 * - http://jsperf.com/proto-map-lookup/2
 * - http://jsperf.com/for-in-vs-object-keys2
 *
 * @returns {Object}
 */
function createMap() {
  return Object.create(null);
}

var NODE_TYPE_ELEMENT = 1;
var NODE_TYPE_ATTRIBUTE = 2;
var NODE_TYPE_TEXT = 3;
var NODE_TYPE_COMMENT = 8;
var NODE_TYPE_DOCUMENT = 9;
var NODE_TYPE_DOCUMENT_FRAGMENT = 11;

/**
 * @ngdoc type
 * @name angular.Module
 * @module ng
 * @description
 *
 * Interface for configuring angular {@link angular.module modules}.
 */

function setupModuleLoader(window) {

  var $injectorMinErr = minErr('$injector');
  var ngMinErr = minErr('ng');

  function ensure(obj, name, factory) {
    return obj[name] || (obj[name] = factory());
  }

  var angular = ensure(window, 'angular', Object);

  // We need to expose `angular.$$minErr` to modules such as `ngResource` that reference it during bootstrap
  angular.$$minErr = angular.$$minErr || minErr;

  return ensure(angular, 'module', function() {
    /** @type {Object.<string, angular.Module>} */
    var modules = {};

    /**
     * @ngdoc function
     * @name angular.module
     * @module ng
     * @description
     *
     * The `angular.module` is a global place for creating, registering and retrieving Angular
     * modules.
     * All modules (angular core or 3rd party) that should be available to an application must be
     * registered using this mechanism.
     *
     * Passing one argument retrieves an existing {@link angular.Module},
     * whereas passing more than one argument creates a new {@link angular.Module}
     *
     *
     * # Module
     *
     * A module is a collection of services, directives, controllers, filters, and configuration information.
     * `angular.module` is used to configure the {@link auto.$injector $injector}.
     *
     * ```js
     * // Create a new module
     * var myModule = angular.module('myModule', []);
     *
     * // register a new service
     * myModule.value('appName', 'MyCoolApp');
     *
     * // configure existing services inside initialization blocks.
     * myModule.config(['$locationProvider', function($locationProvider) {
     *   // Configure existing providers
     *   $locationProvider.hashPrefix('!');
     * }]);
     * ```
     *
     * Then you can create an injector and load your modules like this:
     *
     * ```js
     * var injector = angular.injector(['ng', 'myModule'])
     * ```
     *
     * However it's more likely that you'll just use
     * {@link ng.directive:ngApp ngApp} or
     * {@link angular.bootstrap} to simplify this process for you.
     *
     * @param {!string} name The name of the module to create or retrieve.
     * @param {!Array.<string>=} requires If specified then new module is being created. If
     *        unspecified then the module is being retrieved for further configuration.
     * @param {Function=} configFn Optional configuration function for the module. Same as
     *        {@link angular.Module#config Module#config()}.
     * @returns {angular.Module} new module with the {@link angular.Module} api.
     */
    return function module(name, requires, configFn) {
      var assertNotHasOwnProperty = function(name, context) {
        if (name === 'hasOwnProperty') {
          throw ngMinErr('badname', 'hasOwnProperty is not a valid {0} name', context);
        }
      };

      assertNotHasOwnProperty(name, 'module');
      if (requires && modules.hasOwnProperty(name)) {
        modules[name] = null;
      }
      return ensure(modules, name, function() {
        if (!requires) {
          throw $injectorMinErr('nomod', "Module '{0}' is not available! You either misspelled " +
             "the module name or forgot to load it. If registering a module ensure that you " +
             "specify the dependencies as the second argument.", name);
        }

        /** @type {!Array.<Array.<*>>} */
        var invokeQueue = [];

        /** @type {!Array.<Function>} */
        var configBlocks = [];

        /** @type {!Array.<Function>} */
        var runBlocks = [];

        var config = invokeLater('$injector', 'invoke', 'push', configBlocks);

        /** @type {angular.Module} */
        var moduleInstance = {
          // Private state
          _invokeQueue: invokeQueue,
          _configBlocks: configBlocks,
          _runBlocks: runBlocks,

          /**
           * @ngdoc property
           * @name angular.Module#requires
           * @module ng
           *
           * @description
           * Holds the list of modules which the injector will load before the current module is
           * loaded.
           */
          requires: requires,

          /**
           * @ngdoc property
           * @name angular.Module#name
           * @module ng
           *
           * @description
           * Name of the module.
           */
          name: name,


          /**
           * @ngdoc method
           * @name angular.Module#provider
           * @module ng
           * @param {string} name service name
           * @param {Function} providerType Construction function for creating new instance of the
           *                                service.
           * @description
           * See {@link auto.$provide#provider $provide.provider()}.
           */
          provider: invokeLaterAndSetModuleName('$provide', 'provider'),

          /**
           * @ngdoc method
           * @name angular.Module#factory
           * @module ng
           * @param {string} name service name
           * @param {Function} providerFunction Function for creating new instance of the service.
           * @description
           * See {@link auto.$provide#factory $provide.factory()}.
           */
          factory: invokeLaterAndSetModuleName('$provide', 'factory'),

          /**
           * @ngdoc method
           * @name angular.Module#service
           * @module ng
           * @param {string} name service name
           * @param {Function} constructor A constructor function that will be instantiated.
           * @description
           * See {@link auto.$provide#service $provide.service()}.
           */
          service: invokeLaterAndSetModuleName('$provide', 'service'),

          /**
           * @ngdoc method
           * @name angular.Module#value
           * @module ng
           * @param {string} name service name
           * @param {*} object Service instance object.
           * @description
           * See {@link auto.$provide#value $provide.value()}.
           */
          value: invokeLater('$provide', 'value'),

          /**
           * @ngdoc method
           * @name angular.Module#constant
           * @module ng
           * @param {string} name constant name
           * @param {*} object Constant value.
           * @description
           * Because the constants are fixed, they get applied before other provide methods.
           * See {@link auto.$provide#constant $provide.constant()}.
           */
          constant: invokeLater('$provide', 'constant', 'unshift'),

           /**
           * @ngdoc method
           * @name angular.Module#decorator
           * @module ng
           * @param {string} name The name of the service to decorate.
           * @param {Function} decorFn This function will be invoked when the service needs to be
           *                           instantiated and should return the decorated service instance.
           * @description
           * See {@link auto.$provide#decorator $provide.decorator()}.
           */
          decorator: invokeLaterAndSetModuleName('$provide', 'decorator'),

          /**
           * @ngdoc method
           * @name angular.Module#animation
           * @module ng
           * @param {string} name animation name
           * @param {Function} animationFactory Factory function for creating new instance of an
           *                                    animation.
           * @description
           *
           * **NOTE**: animations take effect only if the **ngAnimate** module is loaded.
           *
           *
           * Defines an animation hook that can be later used with
           * {@link $animate $animate} service and directives that use this service.
           *
           * ```js
           * module.animation('.animation-name', function($inject1, $inject2) {
           *   return {
           *     eventName : function(element, done) {
           *       //code to run the animation
           *       //once complete, then run done()
           *       return function cancellationFunction(element) {
           *         //code to cancel the animation
           *       }
           *     }
           *   }
           * })
           * ```
           *
           * See {@link ng.$animateProvider#register $animateProvider.register()} and
           * {@link ngAnimate ngAnimate module} for more information.
           */
          animation: invokeLaterAndSetModuleName('$animateProvider', 'register'),

          /**
           * @ngdoc method
           * @name angular.Module#filter
           * @module ng
           * @param {string} name Filter name - this must be a valid angular expression identifier
           * @param {Function} filterFactory Factory function for creating new instance of filter.
           * @description
           * See {@link ng.$filterProvider#register $filterProvider.register()}.
           *
           * <div class="alert alert-warning">
           * **Note:** Filter names must be valid angular {@link expression} identifiers, such as `uppercase` or `orderBy`.
           * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
           * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
           * (`myapp_subsection_filterx`).
           * </div>
           */
          filter: invokeLaterAndSetModuleName('$filterProvider', 'register'),

          /**
           * @ngdoc method
           * @name angular.Module#controller
           * @module ng
           * @param {string|Object} name Controller name, or an object map of controllers where the
           *    keys are the names and the values are the constructors.
           * @param {Function} constructor Controller constructor function.
           * @description
           * See {@link ng.$controllerProvider#register $controllerProvider.register()}.
           */
          controller: invokeLaterAndSetModuleName('$controllerProvider', 'register'),

          /**
           * @ngdoc method
           * @name angular.Module#directive
           * @module ng
           * @param {string|Object} name Directive name, or an object map of directives where the
           *    keys are the names and the values are the factories.
           * @param {Function} directiveFactory Factory function for creating new instance of
           * directives.
           * @description
           * See {@link ng.$compileProvider#directive $compileProvider.directive()}.
           */
          directive: invokeLaterAndSetModuleName('$compileProvider', 'directive'),

          /**
           * @ngdoc method
           * @name angular.Module#component
           * @module ng
           * @param {string} name Name of the component in camel-case (i.e. myComp which will match as my-comp)
           * @param {Object} options Component definition object (a simplified
           *    {@link ng.$compile#directive-definition-object directive definition object})
           *
           * @description
           * See {@link ng.$compileProvider#component $compileProvider.component()}.
           */
          component: invokeLaterAndSetModuleName('$compileProvider', 'component'),

          /**
           * @ngdoc method
           * @name angular.Module#config
           * @module ng
           * @param {Function} configFn Execute this function on module load. Useful for service
           *    configuration.
           * @description
           * Use this method to register work which needs to be performed on module loading.
           * For more about how to configure services, see
           * {@link providers#provider-recipe Provider Recipe}.
           */
          config: config,

          /**
           * @ngdoc method
           * @name angular.Module#run
           * @module ng
           * @param {Function} initializationFn Execute this function after injector creation.
           *    Useful for application initialization.
           * @description
           * Use this method to register work which should be performed when the injector is done
           * loading all modules.
           */
          run: function(block) {
            runBlocks.push(block);
            return this;
          }
        };

        if (configFn) {
          config(configFn);
        }

        return moduleInstance;

        /**
         * @param {string} provider
         * @param {string} method
         * @param {String=} insertMethod
         * @returns {angular.Module}
         */
        function invokeLater(provider, method, insertMethod, queue) {
          if (!queue) queue = invokeQueue;
          return function() {
            queue[insertMethod || 'push']([provider, method, arguments]);
            return moduleInstance;
          };
        }

        /**
         * @param {string} provider
         * @param {string} method
         * @returns {angular.Module}
         */
        function invokeLaterAndSetModuleName(provider, method) {
          return function(recipeName, factoryFunction) {
            if (factoryFunction && isFunction(factoryFunction)) factoryFunction.$$moduleName = name;
            invokeQueue.push([provider, method, arguments]);
            return moduleInstance;
          };
        }
      });
    };
  });

}

/* global shallowCopy: true */

/**
 * Creates a shallow copy of an object, an array or a primitive.
 *
 * Assumes that there are no proto properties for objects.
 */
function shallowCopy(src, dst) {
  if (isArray(src)) {
    dst = dst || [];

    for (var i = 0, ii = src.length; i < ii; i++) {
      dst[i] = src[i];
    }
  } else if (isObject(src)) {
    dst = dst || {};

    for (var key in src) {
      if (!(key.charAt(0) === '$' && key.charAt(1) === '$')) {
        dst[key] = src[key];
      }
    }
  }

  return dst || src;
}

/* global toDebugString: true */

function serializeObject(obj) {
  var seen = [];

  return JSON.stringify(obj, function(key, val) {
    val = toJsonReplacer(key, val);
    if (isObject(val)) {

      if (seen.indexOf(val) >= 0) return '...';

      seen.push(val);
    }
    return val;
  });
}

function toDebugString(obj) {
  if (typeof obj === 'function') {
    return obj.toString().replace(/ \{[\s\S]*$/, '');
  } else if (isUndefined(obj)) {
    return 'undefined';
  } else if (typeof obj !== 'string') {
    return serializeObject(obj);
  }
  return obj;
}

/* global angularModule: true,
  version: true,

  $CompileProvider,

  htmlAnchorDirective,
  inputDirective,
  inputDirective,
  formDirective,
  scriptDirective,
  selectDirective,
  styleDirective,
  optionDirective,
  ngBindDirective,
  ngBindHtmlDirective,
  ngBindTemplateDirective,
  ngClassDirective,
  ngClassEvenDirective,
  ngClassOddDirective,
  ngCloakDirective,
  ngControllerDirective,
  ngFormDirective,
  ngHideDirective,
  ngIfDirective,
  ngIncludeDirective,
  ngIncludeFillContentDirective,
  ngInitDirective,
  ngNonBindableDirective,
  ngPluralizeDirective,
  ngRepeatDirective,
  ngShowDirective,
  ngStyleDirective,
  ngSwitchDirective,
  ngSwitchWhenDirective,
  ngSwitchDefaultDirective,
  ngOptionsDirective,
  ngTranscludeDirective,
  ngModelDirective,
  ngListDirective,
  ngChangeDirective,
  patternDirective,
  patternDirective,
  requiredDirective,
  requiredDirective,
  minlengthDirective,
  minlengthDirective,
  maxlengthDirective,
  maxlengthDirective,
  ngValueDirective,
  ngModelOptionsDirective,
  ngAttributeAliasDirectives,
  ngEventDirectives,

  $AnchorScrollProvider,
  $AnimateProvider,
  $CoreAnimateCssProvider,
  $$CoreAnimateJsProvider,
  $$CoreAnimateQueueProvider,
  $$AnimateRunnerFactoryProvider,
  $$AnimateAsyncRunFactoryProvider,
  $BrowserProvider,
  $CacheFactoryProvider,
  $ControllerProvider,
  $DateProvider,
  $DocumentProvider,
  $ExceptionHandlerProvider,
  $FilterProvider,
  $$ForceReflowProvider,
  $InterpolateProvider,
  $IntervalProvider,
  $$HashMapProvider,
  $HttpProvider,
  $HttpParamSerializerProvider,
  $HttpParamSerializerJQLikeProvider,
  $HttpBackendProvider,
  $xhrFactoryProvider,
  $jsonpCallbacksProvider,
  $LocationProvider,
  $LogProvider,
  $ParseProvider,
  $RootScopeProvider,
  $QProvider,
  $$QProvider,
  $$SanitizeUriProvider,
  $SceProvider,
  $SceDelegateProvider,
  $SnifferProvider,
  $TemplateCacheProvider,
  $TemplateRequestProvider,
  $$TestabilityProvider,
  $TimeoutProvider,
  $$RAFProvider,
  $WindowProvider,
  $$jqLiteProvider,
  $$CookieReaderProvider
*/


/**
 * @ngdoc object
 * @name angular.version
 * @module ng
 * @description
 * An object that contains information about the current AngularJS version.
 *
 * This object has the following properties:
 *
 * - `full` – `{string}` – Full version string, such as "0.9.18".
 * - `major` – `{number}` – Major version number, such as "0".
 * - `minor` – `{number}` – Minor version number, such as "9".
 * - `dot` – `{number}` – Dot version number, such as "18".
 * - `codeName` – `{string}` – Code name of the release, such as "jiggling-armfat".
 */
var version = {
  full: '1.5.8',    // all of these placeholder strings will be replaced by grunt's
  major: 1,    // package task
  minor: 5,
  dot: 8,
  codeName: 'arbitrary-fallbacks'
};


function publishExternalAPI(angular) {
  extend(angular, {
    'bootstrap': bootstrap,
    'copy': copy,
    'extend': extend,
    'merge': merge,
    'equals': equals,
    'element': jqLite,
    'forEach': forEach,
    'injector': createInjector,
    'noop': noop,
    'bind': bind,
    'toJson': toJson,
    'fromJson': fromJson,
    'identity': identity,
    'isUndefined': isUndefined,
    'isDefined': isDefined,
    'isString': isString,
    'isFunction': isFunction,
    'isObject': isObject,
    'isNumber': isNumber,
    'isElement': isElement,
    'isArray': isArray,
    'version': version,
    'isDate': isDate,
    'lowercase': lowercase,
    'uppercase': uppercase,
    'callbacks': {$$counter: 0},
    'getTestability': getTestability,
    '$$minErr': minErr,
    '$$csp': csp,
    'reloadWithDebugInfo': reloadWithDebugInfo
  });

  angularModule = setupModuleLoader(window);

  angularModule('ng', ['ngLocale'], ['$provide',
    function ngModule($provide) {
      // $$sanitizeUriProvider needs to be before $compileProvider as it is used by it.
      $provide.provider({
        $$sanitizeUri: $$SanitizeUriProvider
      });
      $provide.provider('$compile', $CompileProvider).
        directive({
            a: htmlAnchorDirective,
            input: inputDirective,
            textarea: inputDirective,
            form: formDirective,
            script: scriptDirective,
            select: selectDirective,
            style: styleDirective,
            option: optionDirective,
            ngBind: ngBindDirective,
            ngBindHtml: ngBindHtmlDirective,
            ngBindTemplate: ngBindTemplateDirective,
            ngClass: ngClassDirective,
            ngClassEven: ngClassEvenDirective,
            ngClassOdd: ngClassOddDirective,
            ngCloak: ngCloakDirective,
            ngController: ngControllerDirective,
            ngForm: ngFormDirective,
            ngHide: ngHideDirective,
            ngIf: ngIfDirective,
            ngInclude: ngIncludeDirective,
            ngInit: ngInitDirective,
            ngNonBindable: ngNonBindableDirective,
            ngPluralize: ngPluralizeDirective,
            ngRepeat: ngRepeatDirective,
            ngShow: ngShowDirective,
            ngStyle: ngStyleDirective,
            ngSwitch: ngSwitchDirective,
            ngSwitchWhen: ngSwitchWhenDirective,
            ngSwitchDefault: ngSwitchDefaultDirective,
            ngOptions: ngOptionsDirective,
            ngTransclude: ngTranscludeDirective,
            ngModel: ngModelDirective,
            ngList: ngListDirective,
            ngChange: ngChangeDirective,
            pattern: patternDirective,
            ngPattern: patternDirective,
            required: requiredDirective,
            ngRequired: requiredDirective,
            minlength: minlengthDirective,
            ngMinlength: minlengthDirective,
            maxlength: maxlengthDirective,
            ngMaxlength: maxlengthDirective,
            ngValue: ngValueDirective,
            ngModelOptions: ngModelOptionsDirective
        }).
        directive({
          ngInclude: ngIncludeFillContentDirective
        }).
        directive(ngAttributeAliasDirectives).
        directive(ngEventDirectives);
      $provide.provider({
        $anchorScroll: $AnchorScrollProvider,
        $animate: $AnimateProvider,
        $animateCss: $CoreAnimateCssProvider,
        $$animateJs: $$CoreAnimateJsProvider,
        $$animateQueue: $$CoreAnimateQueueProvider,
        $$AnimateRunner: $$AnimateRunnerFactoryProvider,
        $$animateAsyncRun: $$AnimateAsyncRunFactoryProvider,
        $browser: $BrowserProvider,
        $cacheFactory: $CacheFactoryProvider,
        $controller: $ControllerProvider,
        $document: $DocumentProvider,
        $exceptionHandler: $ExceptionHandlerProvider,
        $filter: $FilterProvider,
        $$forceReflow: $$ForceReflowProvider,
        $interpolate: $InterpolateProvider,
        $interval: $IntervalProvider,
        $http: $HttpProvider,
        $httpParamSerializer: $HttpParamSerializerProvider,
        $httpParamSerializerJQLike: $HttpParamSerializerJQLikeProvider,
        $httpBackend: $HttpBackendProvider,
        $xhrFactory: $xhrFactoryProvider,
        $jsonpCallbacks: $jsonpCallbacksProvider,
        $location: $LocationProvider,
        $log: $LogProvider,
        $parse: $ParseProvider,
        $rootScope: $RootScopeProvider,
        $q: $QProvider,
        $$q: $$QProvider,
        $sce: $SceProvider,
        $sceDelegate: $SceDelegateProvider,
        $sniffer: $SnifferProvider,
        $templateCache: $TemplateCacheProvider,
        $templateRequest: $TemplateRequestProvider,
        $$testability: $$TestabilityProvider,
        $timeout: $TimeoutProvider,
        $window: $WindowProvider,
        $$rAF: $$RAFProvider,
        $$jqLite: $$jqLiteProvider,
        $$HashMap: $$HashMapProvider,
        $$cookieReader: $$CookieReaderProvider
      });
    }
  ]);
}

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *     Any commits to this file should be reviewed with security in mind.  *
 *   Changes to this file can potentially create security vulnerabilities. *
 *          An approval from 2 Core members with history of modifying      *
 *                         this file is required.                          *
 *                                                                         *
 *  Does the change somehow allow for arbitrary javascript to be executed? *
 *    Or allows for someone to change the prototype of built-in objects?   *
 *     Or gives undesired access to variables likes document or window?    *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

/* global JQLitePrototype: true,
  addEventListenerFn: true,
  removeEventListenerFn: true,
  BOOLEAN_ATTR: true,
  ALIASED_ATTR: true,
*/

//////////////////////////////////
//JQLite
//////////////////////////////////

/**
 * @ngdoc function
 * @name angular.element
 * @module ng
 * @kind function
 *
 * @description
 * Wraps a raw DOM element or HTML string as a [jQuery](http://jquery.com) element.
 *
 * If jQuery is available, `angular.element` is an alias for the
 * [jQuery](http://api.jquery.com/jQuery/) function. If jQuery is not available, `angular.element`
 * delegates to Angular's built-in subset of jQuery, called "jQuery lite" or **jqLite**.
 *
 * jqLite is a tiny, API-compatible subset of jQuery that allows
 * Angular to manipulate the DOM in a cross-browser compatible way. jqLite implements only the most
 * commonly needed functionality with the goal of having a very small footprint.
 *
 * To use `jQuery`, simply ensure it is loaded before the `angular.js` file. You can also use the
 * {@link ngJq `ngJq`} directive to specify that jqlite should be used over jQuery, or to use a
 * specific version of jQuery if multiple versions exist on the page.
 *
 * <div class="alert alert-info">**Note:** All element references in Angular are always wrapped with jQuery or
 * jqLite (such as the element argument in a directive's compile / link function). They are never raw DOM references.</div>
 *
 * <div class="alert alert-warning">**Note:** Keep in mind that this function will not find elements
 * by tag name / CSS selector. For lookups by tag name, try instead `angular.element(document).find(...)`
 * or `$document.find()`, or use the standard DOM APIs, e.g. `document.querySelectorAll()`.</div>
 *
 * ## Angular's jqLite
 * jqLite provides only the following jQuery methods:
 *
 * - [`addClass()`](http://api.jquery.com/addClass/) - Does not support a function as first argument
 * - [`after()`](http://api.jquery.com/after/)
 * - [`append()`](http://api.jquery.com/append/)
 * - [`attr()`](http://api.jquery.com/attr/) - Does not support functions as parameters
 * - [`bind()`](http://api.jquery.com/bind/) - Does not support namespaces, selectors or eventData
 * - [`children()`](http://api.jquery.com/children/) - Does not support selectors
 * - [`clone()`](http://api.jquery.com/clone/)
 * - [`contents()`](http://api.jquery.com/contents/)
 * - [`css()`](http://api.jquery.com/css/) - Only retrieves inline-styles, does not call `getComputedStyle()`.
 *   As a setter, does not convert numbers to strings or append 'px', and also does not have automatic property prefixing.
 * - [`data()`](http://api.jquery.com/data/)
 * - [`detach()`](http://api.jquery.com/detach/)
 * - [`empty()`](http://api.jquery.com/empty/)
 * - [`eq()`](http://api.jquery.com/eq/)
 * - [`find()`](http://api.jquery.com/find/) - Limited to lookups by tag name
 * - [`hasClass()`](http://api.jquery.com/hasClass/)
 * - [`html()`](http://api.jquery.com/html/)
 * - [`next()`](http://api.jquery.com/next/) - Does not support selectors
 * - [`on()`](http://api.jquery.com/on/) - Does not support namespaces, selectors or eventData
 * - [`off()`](http://api.jquery.com/off/) - Does not support namespaces, selectors or event object as parameter
 * - [`one()`](http://api.jquery.com/one/) - Does not support namespaces or selectors
 * - [`parent()`](http://api.jquery.com/parent/) - Does not support selectors
 * - [`prepend()`](http://api.jquery.com/prepend/)
 * - [`prop()`](http://api.jquery.com/prop/)
 * - [`ready()`](http://api.jquery.com/ready/)
 * - [`remove()`](http://api.jquery.com/remove/)
 * - [`removeAttr()`](http://api.jquery.com/removeAttr/)
 * - [`removeClass()`](http://api.jquery.com/removeClass/) - Does not support a function as first argument
 * - [`removeData()`](http://api.jquery.com/removeData/)
 * - [`replaceWith()`](http://api.jquery.com/replaceWith/)
 * - [`text()`](http://api.jquery.com/text/)
 * - [`toggleClass()`](http://api.jquery.com/toggleClass/) - Does not support a function as first argument
 * - [`triggerHandler()`](http://api.jquery.com/triggerHandler/) - Passes a dummy event object to handlers
 * - [`unbind()`](http://api.jquery.com/unbind/) - Does not support namespaces or event object as parameter
 * - [`val()`](http://api.jquery.com/val/)
 * - [`wrap()`](http://api.jquery.com/wrap/)
 *
 * ## jQuery/jqLite Extras
 * Angular also provides the following additional methods and events to both jQuery and jqLite:
 *
 * ### Events
 * - `$destroy` - AngularJS intercepts all jqLite/jQuery's DOM destruction apis and fires this event
 *    on all DOM nodes being removed.  This can be used to clean up any 3rd party bindings to the DOM
 *    element before it is removed.
 *
 * ### Methods
 * - `controller(name)` - retrieves the controller of the current element or its parent. By default
 *   retrieves controller associated with the `ngController` directive. If `name` is provided as
 *   camelCase directive name, then the controller for this directive will be retrieved (e.g.
 *   `'ngModel'`).
 * - `injector()` - retrieves the injector of the current element or its parent.
 * - `scope()` - retrieves the {@link ng.$rootScope.Scope scope} of the current
 *   element or its parent. Requires {@link guide/production#disabling-debug-data Debug Data} to
 *   be enabled.
 * - `isolateScope()` - retrieves an isolate {@link ng.$rootScope.Scope scope} if one is attached directly to the
 *   current element. This getter should be used only on elements that contain a directive which starts a new isolate
 *   scope. Calling `scope()` on this element always returns the original non-isolate scope.
 *   Requires {@link guide/production#disabling-debug-data Debug Data} to be enabled.
 * - `inheritedData()` - same as `data()`, but walks up the DOM until a value is found or the top
 *   parent element is reached.
 *
 * @knownIssue You cannot spy on `angular.element` if you are using Jasmine version 1.x. See
 * https://github.com/angular/angular.js/issues/14251 for more information.
 *
 * @param {string|DOMElement} element HTML string or DOMElement to be wrapped into jQuery.
 * @returns {Object} jQuery object.
 */

JQLite.expando = 'ng339';

var jqCache = JQLite.cache = {},
    jqId = 1,
    addEventListenerFn = function(element, type, fn) {
      element.addEventListener(type, fn, false);
    },
    removeEventListenerFn = function(element, type, fn) {
      element.removeEventListener(type, fn, false);
    };

/*
 * !!! This is an undocumented "private" function !!!
 */
JQLite._data = function(node) {
  //jQuery always returns an object on cache miss
  return this.cache[node[this.expando]] || {};
};

function jqNextId() { return ++jqId; }


var SPECIAL_CHARS_REGEXP = /([\:\-\_]+(.))/g;
var MOZ_HACK_REGEXP = /^moz([A-Z])/;
var MOUSE_EVENT_MAP= { mouseleave: "mouseout", mouseenter: "mouseover"};
var jqLiteMinErr = minErr('jqLite');

/**
 * Converts snake_case to camelCase.
 * Also there is special case for Moz prefix starting with upper case letter.
 * @param name Name to normalize
 */
function camelCase(name) {
  return name.
    replace(SPECIAL_CHARS_REGEXP, function(_, separator, letter, offset) {
      return offset ? letter.toUpperCase() : letter;
    }).
    replace(MOZ_HACK_REGEXP, 'Moz$1');
}

var SINGLE_TAG_REGEXP = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/;
var HTML_REGEXP = /<|&#?\w+;/;
var TAG_NAME_REGEXP = /<([\w:-]+)/;
var XHTML_TAG_REGEXP = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi;

var wrapMap = {
  'option': [1, '<select multiple="multiple">', '</select>'],

  'thead': [1, '<table>', '</table>'],
  'col': [2, '<table><colgroup>', '</colgroup></table>'],
  'tr': [2, '<table><tbody>', '</tbody></table>'],
  'td': [3, '<table><tbody><tr>', '</tr></tbody></table>'],
  '_default': [0, "", ""]
};

wrapMap.optgroup = wrapMap.option;
wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;


function jqLiteIsTextNode(html) {
  return !HTML_REGEXP.test(html);
}

function jqLiteAcceptsData(node) {
  // The window object can accept data but has no nodeType
  // Otherwise we are only interested in elements (1) and documents (9)
  var nodeType = node.nodeType;
  return nodeType === NODE_TYPE_ELEMENT || !nodeType || nodeType === NODE_TYPE_DOCUMENT;
}

function jqLiteHasData(node) {
  for (var key in jqCache[node.ng339]) {
    return true;
  }
  return false;
}

function jqLiteCleanData(nodes) {
  for (var i = 0, ii = nodes.length; i < ii; i++) {
    jqLiteRemoveData(nodes[i]);
  }
}

function jqLiteBuildFragment(html, context) {
  var tmp, tag, wrap,
      fragment = context.createDocumentFragment(),
      nodes = [], i;

  if (jqLiteIsTextNode(html)) {
    // Convert non-html into a text node
    nodes.push(context.createTextNode(html));
  } else {
    // Convert html into DOM nodes
    tmp = fragment.appendChild(context.createElement("div"));
    tag = (TAG_NAME_REGEXP.exec(html) || ["", ""])[1].toLowerCase();
    wrap = wrapMap[tag] || wrapMap._default;
    tmp.innerHTML = wrap[1] + html.replace(XHTML_TAG_REGEXP, "<$1></$2>") + wrap[2];

    // Descend through wrappers to the right content
    i = wrap[0];
    while (i--) {
      tmp = tmp.lastChild;
    }

    nodes = concat(nodes, tmp.childNodes);

    tmp = fragment.firstChild;
    tmp.textContent = "";
  }

  // Remove wrapper from fragment
  fragment.textContent = "";
  fragment.innerHTML = ""; // Clear inner HTML
  forEach(nodes, function(node) {
    fragment.appendChild(node);
  });

  return fragment;
}

function jqLiteParseHTML(html, context) {
  context = context || window.document;
  var parsed;

  if ((parsed = SINGLE_TAG_REGEXP.exec(html))) {
    return [context.createElement(parsed[1])];
  }

  if ((parsed = jqLiteBuildFragment(html, context))) {
    return parsed.childNodes;
  }

  return [];
}

function jqLiteWrapNode(node, wrapper) {
  var parent = node.parentNode;

  if (parent) {
    parent.replaceChild(wrapper, node);
  }

  wrapper.appendChild(node);
}


// IE9-11 has no method "contains" in SVG element and in Node.prototype. Bug #10259.
var jqLiteContains = window.Node.prototype.contains || function(arg) {
  // jshint bitwise: false
  return !!(this.compareDocumentPosition(arg) & 16);
  // jshint bitwise: true
};

/////////////////////////////////////////////
function JQLite(element) {
  if (element instanceof JQLite) {
    return element;
  }

  var argIsString;

  if (isString(element)) {
    element = trim(element);
    argIsString = true;
  }
  if (!(this instanceof JQLite)) {
    if (argIsString && element.charAt(0) != '<') {
      throw jqLiteMinErr('nosel', 'Looking up elements via selectors is not supported by jqLite! See: http://docs.angularjs.org/api/angular.element');
    }
    return new JQLite(element);
  }

  if (argIsString) {
    jqLiteAddNodes(this, jqLiteParseHTML(element));
  } else {
    jqLiteAddNodes(this, element);
  }
}

function jqLiteClone(element) {
  return element.cloneNode(true);
}

function jqLiteDealoc(element, onlyDescendants) {
  if (!onlyDescendants) jqLiteRemoveData(element);

  if (element.querySelectorAll) {
    var descendants = element.querySelectorAll('*');
    for (var i = 0, l = descendants.length; i < l; i++) {
      jqLiteRemoveData(descendants[i]);
    }
  }
}

function jqLiteOff(element, type, fn, unsupported) {
  if (isDefined(unsupported)) throw jqLiteMinErr('offargs', 'jqLite#off() does not support the `selector` argument');

  var expandoStore = jqLiteExpandoStore(element);
  var events = expandoStore && expandoStore.events;
  var handle = expandoStore && expandoStore.handle;

  if (!handle) return; //no listeners registered

  if (!type) {
    for (type in events) {
      if (type !== '$destroy') {
        removeEventListenerFn(element, type, handle);
      }
      delete events[type];
    }
  } else {

    var removeHandler = function(type) {
      var listenerFns = events[type];
      if (isDefined(fn)) {
        arrayRemove(listenerFns || [], fn);
      }
      if (!(isDefined(fn) && listenerFns && listenerFns.length > 0)) {
        removeEventListenerFn(element, type, handle);
        delete events[type];
      }
    };

    forEach(type.split(' '), function(type) {
      removeHandler(type);
      if (MOUSE_EVENT_MAP[type]) {
        removeHandler(MOUSE_EVENT_MAP[type]);
      }
    });
  }
}

function jqLiteRemoveData(element, name) {
  var expandoId = element.ng339;
  var expandoStore = expandoId && jqCache[expandoId];

  if (expandoStore) {
    if (name) {
      delete expandoStore.data[name];
      return;
    }

    if (expandoStore.handle) {
      if (expandoStore.events.$destroy) {
        expandoStore.handle({}, '$destroy');
      }
      jqLiteOff(element);
    }
    delete jqCache[expandoId];
    element.ng339 = undefined; // don't delete DOM expandos. IE and Chrome don't like it
  }
}


function jqLiteExpandoStore(element, createIfNecessary) {
  var expandoId = element.ng339,
      expandoStore = expandoId && jqCache[expandoId];

  if (createIfNecessary && !expandoStore) {
    element.ng339 = expandoId = jqNextId();
    expandoStore = jqCache[expandoId] = {events: {}, data: {}, handle: undefined};
  }

  return expandoStore;
}


function jqLiteData(element, key, value) {
  if (jqLiteAcceptsData(element)) {

    var isSimpleSetter = isDefined(value);
    var isSimpleGetter = !isSimpleSetter && key && !isObject(key);
    var massGetter = !key;
    var expandoStore = jqLiteExpandoStore(element, !isSimpleGetter);
    var data = expandoStore && expandoStore.data;

    if (isSimpleSetter) { // data('key', value)
      data[key] = value;
    } else {
      if (massGetter) {  // data()
        return data;
      } else {
        if (isSimpleGetter) { // data('key')
          // don't force creation of expandoStore if it doesn't exist yet
          return data && data[key];
        } else { // mass-setter: data({key1: val1, key2: val2})
          extend(data, key);
        }
      }
    }
  }
}

function jqLiteHasClass(element, selector) {
  if (!element.getAttribute) return false;
  return ((" " + (element.getAttribute('class') || '') + " ").replace(/[\n\t]/g, " ").
      indexOf(" " + selector + " ") > -1);
}

function jqLiteRemoveClass(element, cssClasses) {
  if (cssClasses && element.setAttribute) {
    forEach(cssClasses.split(' '), function(cssClass) {
      element.setAttribute('class', trim(
          (" " + (element.getAttribute('class') || '') + " ")
          .replace(/[\n\t]/g, " ")
          .replace(" " + trim(cssClass) + " ", " "))
      );
    });
  }
}

function jqLiteAddClass(element, cssClasses) {
  if (cssClasses && element.setAttribute) {
    var existingClasses = (' ' + (element.getAttribute('class') || '') + ' ')
                            .replace(/[\n\t]/g, " ");

    forEach(cssClasses.split(' '), function(cssClass) {
      cssClass = trim(cssClass);
      if (existingClasses.indexOf(' ' + cssClass + ' ') === -1) {
        existingClasses += cssClass + ' ';
      }
    });

    element.setAttribute('class', trim(existingClasses));
  }
}


function jqLiteAddNodes(root, elements) {
  // THIS CODE IS VERY HOT. Don't make changes without benchmarking.

  if (elements) {

    // if a Node (the most common case)
    if (elements.nodeType) {
      root[root.length++] = elements;
    } else {
      var length = elements.length;

      // if an Array or NodeList and not a Window
      if (typeof length === 'number' && elements.window !== elements) {
        if (length) {
          for (var i = 0; i < length; i++) {
            root[root.length++] = elements[i];
          }
        }
      } else {
        root[root.length++] = elements;
      }
    }
  }
}


function jqLiteController(element, name) {
  return jqLiteInheritedData(element, '$' + (name || 'ngController') + 'Controller');
}

function jqLiteInheritedData(element, name, value) {
  // if element is the document object work with the html element instead
  // this makes $(document).scope() possible
  if (element.nodeType == NODE_TYPE_DOCUMENT) {
    element = element.documentElement;
  }
  var names = isArray(name) ? name : [name];

  while (element) {
    for (var i = 0, ii = names.length; i < ii; i++) {
      if (isDefined(value = jqLite.data(element, names[i]))) return value;
    }

    // If dealing with a document fragment node with a host element, and no parent, use the host
    // element as the parent. This enables directives within a Shadow DOM or polyfilled Shadow DOM
    // to lookup parent controllers.
    element = element.parentNode || (element.nodeType === NODE_TYPE_DOCUMENT_FRAGMENT && element.host);
  }
}

function jqLiteEmpty(element) {
  jqLiteDealoc(element, true);
  while (element.firstChild) {
    element.removeChild(element.firstChild);
  }
}

function jqLiteRemove(element, keepData) {
  if (!keepData) jqLiteDealoc(element);
  var parent = element.parentNode;
  if (parent) parent.removeChild(element);
}


function jqLiteDocumentLoaded(action, win) {
  win = win || window;
  if (win.document.readyState === 'complete') {
    // Force the action to be run async for consistent behavior
    // from the action's point of view
    // i.e. it will definitely not be in a $apply
    win.setTimeout(action);
  } else {
    // No need to unbind this handler as load is only ever called once
    jqLite(win).on('load', action);
  }
}

//////////////////////////////////////////
// Functions which are declared directly.
//////////////////////////////////////////
var JQLitePrototype = JQLite.prototype = {
  ready: function(fn) {
    var fired = false;

    function trigger() {
      if (fired) return;
      fired = true;
      fn();
    }

    // check if document is already loaded
    if (window.document.readyState === 'complete') {
      window.setTimeout(trigger);
    } else {
      this.on('DOMContentLoaded', trigger); // works for modern browsers and IE9
      // we can not use jqLite since we are not done loading and jQuery could be loaded later.
      // jshint -W064
      JQLite(window).on('load', trigger); // fallback to window.onload for others
      // jshint +W064
    }
  },
  toString: function() {
    var value = [];
    forEach(this, function(e) { value.push('' + e);});
    return '[' + value.join(', ') + ']';
  },

  eq: function(index) {
      return (index >= 0) ? jqLite(this[index]) : jqLite(this[this.length + index]);
  },

  length: 0,
  push: push,
  sort: [].sort,
  splice: [].splice
};

//////////////////////////////////////////
// Functions iterating getter/setters.
// these functions return self on setter and
// value on get.
//////////////////////////////////////////
var BOOLEAN_ATTR = {};
forEach('multiple,selected,checked,disabled,readOnly,required,open'.split(','), function(value) {
  BOOLEAN_ATTR[lowercase(value)] = value;
});
var BOOLEAN_ELEMENTS = {};
forEach('input,select,option,textarea,button,form,details'.split(','), function(value) {
  BOOLEAN_ELEMENTS[value] = true;
});
var ALIASED_ATTR = {
  'ngMinlength': 'minlength',
  'ngMaxlength': 'maxlength',
  'ngMin': 'min',
  'ngMax': 'max',
  'ngPattern': 'pattern'
};

function getBooleanAttrName(element, name) {
  // check dom last since we will most likely fail on name
  var booleanAttr = BOOLEAN_ATTR[name.toLowerCase()];

  // booleanAttr is here twice to minimize DOM access
  return booleanAttr && BOOLEAN_ELEMENTS[nodeName_(element)] && booleanAttr;
}

function getAliasedAttrName(name) {
  return ALIASED_ATTR[name];
}

forEach({
  data: jqLiteData,
  removeData: jqLiteRemoveData,
  hasData: jqLiteHasData,
  cleanData: jqLiteCleanData
}, function(fn, name) {
  JQLite[name] = fn;
});

forEach({
  data: jqLiteData,
  inheritedData: jqLiteInheritedData,

  scope: function(element) {
    // Can't use jqLiteData here directly so we stay compatible with jQuery!
    return jqLite.data(element, '$scope') || jqLiteInheritedData(element.parentNode || element, ['$isolateScope', '$scope']);
  },

  isolateScope: function(element) {
    // Can't use jqLiteData here directly so we stay compatible with jQuery!
    return jqLite.data(element, '$isolateScope') || jqLite.data(element, '$isolateScopeNoTemplate');
  },

  controller: jqLiteController,

  injector: function(element) {
    return jqLiteInheritedData(element, '$injector');
  },

  removeAttr: function(element, name) {
    element.removeAttribute(name);
  },

  hasClass: jqLiteHasClass,

  css: function(element, name, value) {
    name = camelCase(name);

    if (isDefined(value)) {
      element.style[name] = value;
    } else {
      return element.style[name];
    }
  },

  attr: function(element, name, value) {
    var nodeType = element.nodeType;
    if (nodeType === NODE_TYPE_TEXT || nodeType === NODE_TYPE_ATTRIBUTE || nodeType === NODE_TYPE_COMMENT) {
      return;
    }
    var lowercasedName = lowercase(name);
    if (BOOLEAN_ATTR[lowercasedName]) {
      if (isDefined(value)) {
        if (!!value) {
          element[name] = true;
          element.setAttribute(name, lowercasedName);
        } else {
          element[name] = false;
          element.removeAttribute(lowercasedName);
        }
      } else {
        return (element[name] ||
                 (element.attributes.getNamedItem(name) || noop).specified)
               ? lowercasedName
               : undefined;
      }
    } else if (isDefined(value)) {
      element.setAttribute(name, value);
    } else if (element.getAttribute) {
      // the extra argument "2" is to get the right thing for a.href in IE, see jQuery code
      // some elements (e.g. Document) don't have get attribute, so return undefined
      var ret = element.getAttribute(name, 2);
      // normalize non-existing attributes to undefined (as jQuery)
      return ret === null ? undefined : ret;
    }
  },

  prop: function(element, name, value) {
    if (isDefined(value)) {
      element[name] = value;
    } else {
      return element[name];
    }
  },

  text: (function() {
    getText.$dv = '';
    return getText;

    function getText(element, value) {
      if (isUndefined(value)) {
        var nodeType = element.nodeType;
        return (nodeType === NODE_TYPE_ELEMENT || nodeType === NODE_TYPE_TEXT) ? element.textContent : '';
      }
      element.textContent = value;
    }
  })(),

  val: function(element, value) {
    if (isUndefined(value)) {
      if (element.multiple && nodeName_(element) === 'select') {
        var result = [];
        forEach(element.options, function(option) {
          if (option.selected) {
            result.push(option.value || option.text);
          }
        });
        return result.length === 0 ? null : result;
      }
      return element.value;
    }
    element.value = value;
  },

  html: function(element, value) {
    if (isUndefined(value)) {
      return element.innerHTML;
    }
    jqLiteDealoc(element, true);
    element.innerHTML = value;
  },

  empty: jqLiteEmpty
}, function(fn, name) {
  /**
   * Properties: writes return selection, reads return first value
   */
  JQLite.prototype[name] = function(arg1, arg2) {
    var i, key;
    var nodeCount = this.length;

    // jqLiteHasClass has only two arguments, but is a getter-only fn, so we need to special-case it
    // in a way that survives minification.
    // jqLiteEmpty takes no arguments but is a setter.
    if (fn !== jqLiteEmpty &&
        (isUndefined((fn.length == 2 && (fn !== jqLiteHasClass && fn !== jqLiteController)) ? arg1 : arg2))) {
      if (isObject(arg1)) {

        // we are a write, but the object properties are the key/values
        for (i = 0; i < nodeCount; i++) {
          if (fn === jqLiteData) {
            // data() takes the whole object in jQuery
            fn(this[i], arg1);
          } else {
            for (key in arg1) {
              fn(this[i], key, arg1[key]);
            }
          }
        }
        // return self for chaining
        return this;
      } else {
        // we are a read, so read the first child.
        // TODO: do we still need this?
        var value = fn.$dv;
        // Only if we have $dv do we iterate over all, otherwise it is just the first element.
        var jj = (isUndefined(value)) ? Math.min(nodeCount, 1) : nodeCount;
        for (var j = 0; j < jj; j++) {
          var nodeValue = fn(this[j], arg1, arg2);
          value = value ? value + nodeValue : nodeValue;
        }
        return value;
      }
    } else {
      // we are a write, so apply to all children
      for (i = 0; i < nodeCount; i++) {
        fn(this[i], arg1, arg2);
      }
      // return self for chaining
      return this;
    }
  };
});

function createEventHandler(element, events) {
  var eventHandler = function(event, type) {
    // jQuery specific api
    event.isDefaultPrevented = function() {
      return event.defaultPrevented;
    };

    var eventFns = events[type || event.type];
    var eventFnsLength = eventFns ? eventFns.length : 0;

    if (!eventFnsLength) return;

    if (isUndefined(event.immediatePropagationStopped)) {
      var originalStopImmediatePropagation = event.stopImmediatePropagation;
      event.stopImmediatePropagation = function() {
        event.immediatePropagationStopped = true;

        if (event.stopPropagation) {
          event.stopPropagation();
        }

        if (originalStopImmediatePropagation) {
          originalStopImmediatePropagation.call(event);
        }
      };
    }

    event.isImmediatePropagationStopped = function() {
      return event.immediatePropagationStopped === true;
    };

    // Some events have special handlers that wrap the real handler
    var handlerWrapper = eventFns.specialHandlerWrapper || defaultHandlerWrapper;

    // Copy event handlers in case event handlers array is modified during execution.
    if ((eventFnsLength > 1)) {
      eventFns = shallowCopy(eventFns);
    }

    for (var i = 0; i < eventFnsLength; i++) {
      if (!event.isImmediatePropagationStopped()) {
        handlerWrapper(element, event, eventFns[i]);
      }
    }
  };

  // TODO: this is a hack for angularMocks/clearDataCache that makes it possible to deregister all
  //       events on `element`
  eventHandler.elem = element;
  return eventHandler;
}

function defaultHandlerWrapper(element, event, handler) {
  handler.call(element, event);
}

function specialMouseHandlerWrapper(target, event, handler) {
  // Refer to jQuery's implementation of mouseenter & mouseleave
  // Read about mouseenter and mouseleave:
  // http://www.quirksmode.org/js/events_mouse.html#link8
  var related = event.relatedTarget;
  // For mousenter/leave call the handler if related is outside the target.
  // NB: No relatedTarget if the mouse left/entered the browser window
  if (!related || (related !== target && !jqLiteContains.call(target, related))) {
    handler.call(target, event);
  }
}

//////////////////////////////////////////
// Functions iterating traversal.
// These functions chain results into a single
// selector.
//////////////////////////////////////////
forEach({
  removeData: jqLiteRemoveData,

  on: function jqLiteOn(element, type, fn, unsupported) {
    if (isDefined(unsupported)) throw jqLiteMinErr('onargs', 'jqLite#on() does not support the `selector` or `eventData` parameters');

    // Do not add event handlers to non-elements because they will not be cleaned up.
    if (!jqLiteAcceptsData(element)) {
      return;
    }

    var expandoStore = jqLiteExpandoStore(element, true);
    var events = expandoStore.events;
    var handle = expandoStore.handle;

    if (!handle) {
      handle = expandoStore.handle = createEventHandler(element, events);
    }

    // http://jsperf.com/string-indexof-vs-split
    var types = type.indexOf(' ') >= 0 ? type.split(' ') : [type];
    var i = types.length;

    var addHandler = function(type, specialHandlerWrapper, noEventListener) {
      var eventFns = events[type];

      if (!eventFns) {
        eventFns = events[type] = [];
        eventFns.specialHandlerWrapper = specialHandlerWrapper;
        if (type !== '$destroy' && !noEventListener) {
          addEventListenerFn(element, type, handle);
        }
      }

      eventFns.push(fn);
    };

    while (i--) {
      type = types[i];
      if (MOUSE_EVENT_MAP[type]) {
        addHandler(MOUSE_EVENT_MAP[type], specialMouseHandlerWrapper);
        addHandler(type, undefined, true);
      } else {
        addHandler(type);
      }
    }
  },

  off: jqLiteOff,

  one: function(element, type, fn) {
    element = jqLite(element);

    //add the listener twice so that when it is called
    //you can remove the original function and still be
    //able to call element.off(ev, fn) normally
    element.on(type, function onFn() {
      element.off(type, fn);
      element.off(type, onFn);
    });
    element.on(type, fn);
  },

  replaceWith: function(element, replaceNode) {
    var index, parent = element.parentNode;
    jqLiteDealoc(element);
    forEach(new JQLite(replaceNode), function(node) {
      if (index) {
        parent.insertBefore(node, index.nextSibling);
      } else {
        parent.replaceChild(node, element);
      }
      index = node;
    });
  },

  children: function(element) {
    var children = [];
    forEach(element.childNodes, function(element) {
      if (element.nodeType === NODE_TYPE_ELEMENT) {
        children.push(element);
      }
    });
    return children;
  },

  contents: function(element) {
    return element.contentDocument || element.childNodes || [];
  },

  append: function(element, node) {
    var nodeType = element.nodeType;
    if (nodeType !== NODE_TYPE_ELEMENT && nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT) return;

    node = new JQLite(node);

    for (var i = 0, ii = node.length; i < ii; i++) {
      var child = node[i];
      element.appendChild(child);
    }
  },

  prepend: function(element, node) {
    if (element.nodeType === NODE_TYPE_ELEMENT) {
      var index = element.firstChild;
      forEach(new JQLite(node), function(child) {
        element.insertBefore(child, index);
      });
    }
  },

  wrap: function(element, wrapNode) {
    jqLiteWrapNode(element, jqLite(wrapNode).eq(0).clone()[0]);
  },

  remove: jqLiteRemove,

  detach: function(element) {
    jqLiteRemove(element, true);
  },

  after: function(element, newElement) {
    var index = element, parent = element.parentNode;
    newElement = new JQLite(newElement);

    for (var i = 0, ii = newElement.length; i < ii; i++) {
      var node = newElement[i];
      parent.insertBefore(node, index.nextSibling);
      index = node;
    }
  },

  addClass: jqLiteAddClass,
  removeClass: jqLiteRemoveClass,

  toggleClass: function(element, selector, condition) {
    if (selector) {
      forEach(selector.split(' '), function(className) {
        var classCondition = condition;
        if (isUndefined(classCondition)) {
          classCondition = !jqLiteHasClass(element, className);
        }
        (classCondition ? jqLiteAddClass : jqLiteRemoveClass)(element, className);
      });
    }
  },

  parent: function(element) {
    var parent = element.parentNode;
    return parent && parent.nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT ? parent : null;
  },

  next: function(element) {
    return element.nextElementSibling;
  },

  find: function(element, selector) {
    if (element.getElementsByTagName) {
      return element.getElementsByTagName(selector);
    } else {
      return [];
    }
  },

  clone: jqLiteClone,

  triggerHandler: function(element, event, extraParameters) {

    var dummyEvent, eventFnsCopy, handlerArgs;
    var eventName = event.type || event;
    var expandoStore = jqLiteExpandoStore(element);
    var events = expandoStore && expandoStore.events;
    var eventFns = events && events[eventName];

    if (eventFns) {
      // Create a dummy event to pass to the handlers
      dummyEvent = {
        preventDefault: function() { this.defaultPrevented = true; },
        isDefaultPrevented: function() { return this.defaultPrevented === true; },
        stopImmediatePropagation: function() { this.immediatePropagationStopped = true; },
        isImmediatePropagationStopped: function() { return this.immediatePropagationStopped === true; },
        stopPropagation: noop,
        type: eventName,
        target: element
      };

      // If a custom event was provided then extend our dummy event with it
      if (event.type) {
        dummyEvent = extend(dummyEvent, event);
      }

      // Copy event handlers in case event handlers array is modified during execution.
      eventFnsCopy = shallowCopy(eventFns);
      handlerArgs = extraParameters ? [dummyEvent].concat(extraParameters) : [dummyEvent];

      forEach(eventFnsCopy, function(fn) {
        if (!dummyEvent.isImmediatePropagationStopped()) {
          fn.apply(element, handlerArgs);
        }
      });
    }
  }
}, function(fn, name) {
  /**
   * chaining functions
   */
  JQLite.prototype[name] = function(arg1, arg2, arg3) {
    var value;

    for (var i = 0, ii = this.length; i < ii; i++) {
      if (isUndefined(value)) {
        value = fn(this[i], arg1, arg2, arg3);
        if (isDefined(value)) {
          // any function which returns a value needs to be wrapped
          value = jqLite(value);
        }
      } else {
        jqLiteAddNodes(value, fn(this[i], arg1, arg2, arg3));
      }
    }
    return isDefined(value) ? value : this;
  };

  // bind legacy bind/unbind to on/off
  JQLite.prototype.bind = JQLite.prototype.on;
  JQLite.prototype.unbind = JQLite.prototype.off;
});


// Provider for private $$jqLite service
function $$jqLiteProvider() {
  this.$get = function $$jqLite() {
    return extend(JQLite, {
      hasClass: function(node, classes) {
        if (node.attr) node = node[0];
        return jqLiteHasClass(node, classes);
      },
      addClass: function(node, classes) {
        if (node.attr) node = node[0];
        return jqLiteAddClass(node, classes);
      },
      removeClass: function(node, classes) {
        if (node.attr) node = node[0];
        return jqLiteRemoveClass(node, classes);
      }
    });
  };
}

/**
 * Computes a hash of an 'obj'.
 * Hash of a:
 *  string is string
 *  number is number as string
 *  object is either result of calling $$hashKey function on the object or uniquely generated id,
 *         that is also assigned to the $$hashKey property of the object.
 *
 * @param obj
 * @returns {string} hash string such that the same input will have the same hash string.
 *         The resulting string key is in 'type:hashKey' format.
 */
function hashKey(obj, nextUidFn) {
  var key = obj && obj.$$hashKey;

  if (key) {
    if (typeof key === 'function') {
      key = obj.$$hashKey();
    }
    return key;
  }

  var objType = typeof obj;
  if (objType == 'function' || (objType == 'object' && obj !== null)) {
    key = obj.$$hashKey = objType + ':' + (nextUidFn || nextUid)();
  } else {
    key = objType + ':' + obj;
  }

  return key;
}

/**
 * HashMap which can use objects as keys
 */
function HashMap(array, isolatedUid) {
  if (isolatedUid) {
    var uid = 0;
    this.nextUid = function() {
      return ++uid;
    };
  }
  forEach(array, this.put, this);
}
HashMap.prototype = {
  /**
   * Store key value pair
   * @param key key to store can be any type
   * @param value value to store can be any type
   */
  put: function(key, value) {
    this[hashKey(key, this.nextUid)] = value;
  },

  /**
   * @param key
   * @returns {Object} the value for the key
   */
  get: function(key) {
    return this[hashKey(key, this.nextUid)];
  },

  /**
   * Remove the key/value pair
   * @param key
   */
  remove: function(key) {
    var value = this[key = hashKey(key, this.nextUid)];
    delete this[key];
    return value;
  }
};

var $$HashMapProvider = [function() {
  this.$get = [function() {
    return HashMap;
  }];
}];

/**
 * @ngdoc function
 * @module ng
 * @name angular.injector
 * @kind function
 *
 * @description
 * Creates an injector object that can be used for retrieving services as well as for
 * dependency injection (see {@link guide/di dependency injection}).
 *
 * @param {Array.<string|Function>} modules A list of module functions or their aliases. See
 *     {@link angular.module}. The `ng` module must be explicitly added.
 * @param {boolean=} [strictDi=false] Whether the injector should be in strict mode, which
 *     disallows argument name annotation inference.
 * @returns {injector} Injector object. See {@link auto.$injector $injector}.
 *
 * @example
 * Typical usage
 * ```js
 *   // create an injector
 *   var $injector = angular.injector(['ng']);
 *
 *   // use the injector to kick off your application
 *   // use the type inference to auto inject arguments, or use implicit injection
 *   $injector.invoke(function($rootScope, $compile, $document) {
 *     $compile($document)($rootScope);
 *     $rootScope.$digest();
 *   });
 * ```
 *
 * Sometimes you want to get access to the injector of a currently running Angular app
 * from outside Angular. Perhaps, you want to inject and compile some markup after the
 * application has been bootstrapped. You can do this using the extra `injector()` added
 * to JQuery/jqLite elements. See {@link angular.element}.
 *
 * *This is fairly rare but could be the case if a third party library is injecting the
 * markup.*
 *
 * In the following example a new block of HTML containing a `ng-controller`
 * directive is added to the end of the document body by JQuery. We then compile and link
 * it into the current AngularJS scope.
 *
 * ```js
 * var $div = $('<div ng-controller="MyCtrl">{{content.label}}</div>');
 * $(document.body).append($div);
 *
 * angular.element(document).injector().invoke(function($compile) {
 *   var scope = angular.element($div).scope();
 *   $compile($div)(scope);
 * });
 * ```
 */


/**
 * @ngdoc module
 * @name auto
 * @installation
 * @description
 *
 * Implicit module which gets automatically added to each {@link auto.$injector $injector}.
 */

var ARROW_ARG = /^([^\(]+?)=>/;
var FN_ARGS = /^[^\(]*\(\s*([^\)]*)\)/m;
var FN_ARG_SPLIT = /,/;
var FN_ARG = /^\s*(_?)(\S+?)\1\s*$/;
var STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;
var $injectorMinErr = minErr('$injector');

function stringifyFn(fn) {
  // Support: Chrome 50-51 only
  // Creating a new string by adding `' '` at the end, to hack around some bug in Chrome v50/51
  // (See https://github.com/angular/angular.js/issues/14487.)
  // TODO (gkalpak): Remove workaround when Chrome v52 is released
  return Function.prototype.toString.call(fn) + ' ';
}

function extractArgs(fn) {
  var fnText = stringifyFn(fn).replace(STRIP_COMMENTS, ''),
      args = fnText.match(ARROW_ARG) || fnText.match(FN_ARGS);
  return args;
}

function anonFn(fn) {
  // For anonymous functions, showing at the very least the function signature can help in
  // debugging.
  var args = extractArgs(fn);
  if (args) {
    return 'function(' + (args[1] || '').replace(/[\s\r\n]+/, ' ') + ')';
  }
  return 'fn';
}

function annotate(fn, strictDi, name) {
  var $inject,
      argDecl,
      last;

  if (typeof fn === 'function') {
    if (!($inject = fn.$inject)) {
      $inject = [];
      if (fn.length) {
        if (strictDi) {
          if (!isString(name) || !name) {
            name = fn.name || anonFn(fn);
          }
          throw $injectorMinErr('strictdi',
            '{0} is not using explicit annotation and cannot be invoked in strict mode', name);
        }
        argDecl = extractArgs(fn);
        forEach(argDecl[1].split(FN_ARG_SPLIT), function(arg) {
          arg.replace(FN_ARG, function(all, underscore, name) {
            $inject.push(name);
          });
        });
      }
      fn.$inject = $inject;
    }
  } else if (isArray(fn)) {
    last = fn.length - 1;
    assertArgFn(fn[last], 'fn');
    $inject = fn.slice(0, last);
  } else {
    assertArgFn(fn, 'fn', true);
  }
  return $inject;
}

///////////////////////////////////////

/**
 * @ngdoc service
 * @name $injector
 *
 * @description
 *
 * `$injector` is used to retrieve object instances as defined by
 * {@link auto.$provide provider}, instantiate types, invoke methods,
 * and load modules.
 *
 * The following always holds true:
 *
 * ```js
 *   var $injector = angular.injector();
 *   expect($injector.get('$injector')).toBe($injector);
 *   expect($injector.invoke(function($injector) {
 *     return $injector;
 *   })).toBe($injector);
 * ```
 *
 * # Injection Function Annotation
 *
 * JavaScript does not have annotations, and annotations are needed for dependency injection. The
 * following are all valid ways of annotating function with injection arguments and are equivalent.
 *
 * ```js
 *   // inferred (only works if code not minified/obfuscated)
 *   $injector.invoke(function(serviceA){});
 *
 *   // annotated
 *   function explicit(serviceA) {};
 *   explicit.$inject = ['serviceA'];
 *   $injector.invoke(explicit);
 *
 *   // inline
 *   $injector.invoke(['serviceA', function(serviceA){}]);
 * ```
 *
 * ## Inference
 *
 * In JavaScript calling `toString()` on a function returns the function definition. The definition
 * can then be parsed and the function arguments can be extracted. This method of discovering
 * annotations is disallowed when the injector is in strict mode.
 * *NOTE:* This does not work with minification, and obfuscation tools since these tools change the
 * argument names.
 *
 * ## `$inject` Annotation
 * By adding an `$inject` property onto a function the injection parameters can be specified.
 *
 * ## Inline
 * As an array of injection names, where the last item in the array is the function to call.
 */

/**
 * @ngdoc method
 * @name $injector#get
 *
 * @description
 * Return an instance of the service.
 *
 * @param {string} name The name of the instance to retrieve.
 * @param {string=} caller An optional string to provide the origin of the function call for error messages.
 * @return {*} The instance.
 */

/**
 * @ngdoc method
 * @name $injector#invoke
 *
 * @description
 * Invoke the method and supply the method arguments from the `$injector`.
 *
 * @param {Function|Array.<string|Function>} fn The injectable function to invoke. Function parameters are
 *   injected according to the {@link guide/di $inject Annotation} rules.
 * @param {Object=} self The `this` for the invoked method.
 * @param {Object=} locals Optional object. If preset then any argument names are read from this
 *                         object first, before the `$injector` is consulted.
 * @returns {*} the value returned by the invoked `fn` function.
 */

/**
 * @ngdoc method
 * @name $injector#has
 *
 * @description
 * Allows the user to query if the particular service exists.
 *
 * @param {string} name Name of the service to query.
 * @returns {boolean} `true` if injector has given service.
 */

/**
 * @ngdoc method
 * @name $injector#instantiate
 * @description
 * Create a new instance of JS type. The method takes a constructor function, invokes the new
 * operator, and supplies all of the arguments to the constructor function as specified by the
 * constructor annotation.
 *
 * @param {Function} Type Annotated constructor function.
 * @param {Object=} locals Optional object. If preset then any argument names are read from this
 * object first, before the `$injector` is consulted.
 * @returns {Object} new instance of `Type`.
 */

/**
 * @ngdoc method
 * @name $injector#annotate
 *
 * @description
 * Returns an array of service names which the function is requesting for injection. This API is
 * used by the injector to determine which services need to be injected into the function when the
 * function is invoked. There are three ways in which the function can be annotated with the needed
 * dependencies.
 *
 * # Argument names
 *
 * The simplest form is to extract the dependencies from the arguments of the function. This is done
 * by converting the function into a string using `toString()` method and extracting the argument
 * names.
 * ```js
 *   // Given
 *   function MyController($scope, $route) {
 *     // ...
 *   }
 *
 *   // Then
 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
 * ```
 *
 * You can disallow this method by using strict injection mode.
 *
 * This method does not work with code minification / obfuscation. For this reason the following
 * annotation strategies are supported.
 *
 * # The `$inject` property
 *
 * If a function has an `$inject` property and its value is an array of strings, then the strings
 * represent names of services to be injected into the function.
 * ```js
 *   // Given
 *   var MyController = function(obfuscatedScope, obfuscatedRoute) {
 *     // ...
 *   }
 *   // Define function dependencies
 *   MyController['$inject'] = ['$scope', '$route'];
 *
 *   // Then
 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
 * ```
 *
 * # The array notation
 *
 * It is often desirable to inline Injected functions and that's when setting the `$inject` property
 * is very inconvenient. In these situations using the array notation to specify the dependencies in
 * a way that survives minification is a better choice:
 *
 * ```js
 *   // We wish to write this (not minification / obfuscation safe)
 *   injector.invoke(function($compile, $rootScope) {
 *     // ...
 *   });
 *
 *   // We are forced to write break inlining
 *   var tmpFn = function(obfuscatedCompile, obfuscatedRootScope) {
 *     // ...
 *   };
 *   tmpFn.$inject = ['$compile', '$rootScope'];
 *   injector.invoke(tmpFn);
 *
 *   // To better support inline function the inline annotation is supported
 *   injector.invoke(['$compile', '$rootScope', function(obfCompile, obfRootScope) {
 *     // ...
 *   }]);
 *
 *   // Therefore
 *   expect(injector.annotate(
 *      ['$compile', '$rootScope', function(obfus_$compile, obfus_$rootScope) {}])
 *    ).toEqual(['$compile', '$rootScope']);
 * ```
 *
 * @param {Function|Array.<string|Function>} fn Function for which dependent service names need to
 * be retrieved as described above.
 *
 * @param {boolean=} [strictDi=false] Disallow argument name annotation inference.
 *
 * @returns {Array.<string>} The names of the services which the function requires.
 */




/**
 * @ngdoc service
 * @name $provide
 *
 * @description
 *
 * The {@link auto.$provide $provide} service has a number of methods for registering components
 * with the {@link auto.$injector $injector}. Many of these functions are also exposed on
 * {@link angular.Module}.
 *
 * An Angular **service** is a singleton object created by a **service factory**.  These **service
 * factories** are functions which, in turn, are created by a **service provider**.
 * The **service providers** are constructor functions. When instantiated they must contain a
 * property called `$get`, which holds the **service factory** function.
 *
 * When you request a service, the {@link auto.$injector $injector} is responsible for finding the
 * correct **service provider**, instantiating it and then calling its `$get` **service factory**
 * function to get the instance of the **service**.
 *
 * Often services have no configuration options and there is no need to add methods to the service
 * provider.  The provider will be no more than a constructor function with a `$get` property. For
 * these cases the {@link auto.$provide $provide} service has additional helper methods to register
 * services without specifying a provider.
 *
 * * {@link auto.$provide#provider provider(name, provider)} - registers a **service provider** with the
 *     {@link auto.$injector $injector}
 * * {@link auto.$provide#constant constant(name, obj)} - registers a value/object that can be accessed by
 *     providers and services.
 * * {@link auto.$provide#value value(name, obj)} - registers a value/object that can only be accessed by
 *     services, not providers.
 * * {@link auto.$provide#factory factory(name, fn)} - registers a service **factory function**
 *     that will be wrapped in a **service provider** object, whose `$get` property will contain the
 *     given factory function.
 * * {@link auto.$provide#service service(name, Fn)} - registers a **constructor function**
 *     that will be wrapped in a **service provider** object, whose `$get` property will instantiate
 *      a new object using the given constructor function.
 * * {@link auto.$provide#decorator decorator(name, decorFn)} - registers a **decorator function** that
 *      will be able to modify or replace the implementation of another service.
 *
 * See the individual methods for more information and examples.
 */

/**
 * @ngdoc method
 * @name $provide#provider
 * @description
 *
 * Register a **provider function** with the {@link auto.$injector $injector}. Provider functions
 * are constructor functions, whose instances are responsible for "providing" a factory for a
 * service.
 *
 * Service provider names start with the name of the service they provide followed by `Provider`.
 * For example, the {@link ng.$log $log} service has a provider called
 * {@link ng.$logProvider $logProvider}.
 *
 * Service provider objects can have additional methods which allow configuration of the provider
 * and its service. Importantly, you can configure what kind of service is created by the `$get`
 * method, or how that service will act. For example, the {@link ng.$logProvider $logProvider} has a
 * method {@link ng.$logProvider#debugEnabled debugEnabled}
 * which lets you specify whether the {@link ng.$log $log} service will log debug messages to the
 * console or not.
 *
 * @param {string} name The name of the instance. NOTE: the provider will be available under `name +
                        'Provider'` key.
 * @param {(Object|function())} provider If the provider is:
 *
 *   - `Object`: then it should have a `$get` method. The `$get` method will be invoked using
 *     {@link auto.$injector#invoke $injector.invoke()} when an instance needs to be created.
 *   - `Constructor`: a new instance of the provider will be created using
 *     {@link auto.$injector#instantiate $injector.instantiate()}, then treated as `object`.
 *
 * @returns {Object} registered provider instance

 * @example
 *
 * The following example shows how to create a simple event tracking service and register it using
 * {@link auto.$provide#provider $provide.provider()}.
 *
 * ```js
 *  // Define the eventTracker provider
 *  function EventTrackerProvider() {
 *    var trackingUrl = '/track';
 *
 *    // A provider method for configuring where the tracked events should been saved
 *    this.setTrackingUrl = function(url) {
 *      trackingUrl = url;
 *    };
 *
 *    // The service factory function
 *    this.$get = ['$http', function($http) {
 *      var trackedEvents = {};
 *      return {
 *        // Call this to track an event
 *        event: function(event) {
 *          var count = trackedEvents[event] || 0;
 *          count += 1;
 *          trackedEvents[event] = count;
 *          return count;
 *        },
 *        // Call this to save the tracked events to the trackingUrl
 *        save: function() {
 *          $http.post(trackingUrl, trackedEvents);
 *        }
 *      };
 *    }];
 *  }
 *
 *  describe('eventTracker', function() {
 *    var postSpy;
 *
 *    beforeEach(module(function($provide) {
 *      // Register the eventTracker provider
 *      $provide.provider('eventTracker', EventTrackerProvider);
 *    }));
 *
 *    beforeEach(module(function(eventTrackerProvider) {
 *      // Configure eventTracker provider
 *      eventTrackerProvider.setTrackingUrl('/custom-track');
 *    }));
 *
 *    it('tracks events', inject(function(eventTracker) {
 *      expect(eventTracker.event('login')).toEqual(1);
 *      expect(eventTracker.event('login')).toEqual(2);
 *    }));
 *
 *    it('saves to the tracking url', inject(function(eventTracker, $http) {
 *      postSpy = spyOn($http, 'post');
 *      eventTracker.event('login');
 *      eventTracker.save();
 *      expect(postSpy).toHaveBeenCalled();
 *      expect(postSpy.mostRecentCall.args[0]).not.toEqual('/track');
 *      expect(postSpy.mostRecentCall.args[0]).toEqual('/custom-track');
 *      expect(postSpy.mostRecentCall.args[1]).toEqual({ 'login': 1 });
 *    }));
 *  });
 * ```
 */

/**
 * @ngdoc method
 * @name $provide#factory
 * @description
 *
 * Register a **service factory**, which will be called to return the service instance.
 * This is short for registering a service where its provider consists of only a `$get` property,
 * which is the given service factory function.
 * You should use {@link auto.$provide#factory $provide.factory(getFn)} if you do not need to
 * configure your service in a provider.
 *
 * @param {string} name The name of the instance.
 * @param {Function|Array.<string|Function>} $getFn The injectable $getFn for the instance creation.
 *                      Internally this is a short hand for `$provide.provider(name, {$get: $getFn})`.
 * @returns {Object} registered provider instance
 *
 * @example
 * Here is an example of registering a service
 * ```js
 *   $provide.factory('ping', ['$http', function($http) {
 *     return function ping() {
 *       return $http.send('/ping');
 *     };
 *   }]);
 * ```
 * You would then inject and use this service like this:
 * ```js
 *   someModule.controller('Ctrl', ['ping', function(ping) {
 *     ping();
 *   }]);
 * ```
 */


/**
 * @ngdoc method
 * @name $provide#service
 * @description
 *
 * Register a **service constructor**, which will be invoked with `new` to create the service
 * instance.
 * This is short for registering a service where its provider's `$get` property is a factory
 * function that returns an instance instantiated by the injector from the service constructor
 * function.
 *
 * Internally it looks a bit like this:
 *
 * ```
 * {
 *   $get: function() {
 *     return $injector.instantiate(constructor);
 *   }
 * }
 * ```
 *
 *
 * You should use {@link auto.$provide#service $provide.service(class)} if you define your service
 * as a type/class.
 *
 * @param {string} name The name of the instance.
 * @param {Function|Array.<string|Function>} constructor An injectable class (constructor function)
 *     that will be instantiated.
 * @returns {Object} registered provider instance
 *
 * @example
 * Here is an example of registering a service using
 * {@link auto.$provide#service $provide.service(class)}.
 * ```js
 *   var Ping = function($http) {
 *     this.$http = $http;
 *   };
 *
 *   Ping.$inject = ['$http'];
 *
 *   Ping.prototype.send = function() {
 *     return this.$http.get('/ping');
 *   };
 *   $provide.service('ping', Ping);
 * ```
 * You would then inject and use this service like this:
 * ```js
 *   someModule.controller('Ctrl', ['ping', function(ping) {
 *     ping.send();
 *   }]);
 * ```
 */


/**
 * @ngdoc method
 * @name $provide#value
 * @description
 *
 * Register a **value service** with the {@link auto.$injector $injector}, such as a string, a
 * number, an array, an object or a function. This is short for registering a service where its
 * provider's `$get` property is a factory function that takes no arguments and returns the **value
 * service**. That also means it is not possible to inject other services into a value service.
 *
 * Value services are similar to constant services, except that they cannot be injected into a
 * module configuration function (see {@link angular.Module#config}) but they can be overridden by
 * an Angular {@link auto.$provide#decorator decorator}.
 *
 * @param {string} name The name of the instance.
 * @param {*} value The value.
 * @returns {Object} registered provider instance
 *
 * @example
 * Here are some examples of creating value services.
 * ```js
 *   $provide.value('ADMIN_USER', 'admin');
 *
 *   $provide.value('RoleLookup', { admin: 0, writer: 1, reader: 2 });
 *
 *   $provide.value('halfOf', function(value) {
 *     return value / 2;
 *   });
 * ```
 */


/**
 * @ngdoc method
 * @name $provide#constant
 * @description
 *
 * Register a **constant service** with the {@link auto.$injector $injector}, such as a string,
 * a number, an array, an object or a function. Like the {@link auto.$provide#value value}, it is not
 * possible to inject other services into a constant.
 *
 * But unlike {@link auto.$provide#value value}, a constant can be
 * injected into a module configuration function (see {@link angular.Module#config}) and it cannot
 * be overridden by an Angular {@link auto.$provide#decorator decorator}.
 *
 * @param {string} name The name of the constant.
 * @param {*} value The constant value.
 * @returns {Object} registered instance
 *
 * @example
 * Here a some examples of creating constants:
 * ```js
 *   $provide.constant('SHARD_HEIGHT', 306);
 *
 *   $provide.constant('MY_COLOURS', ['red', 'blue', 'grey']);
 *
 *   $provide.constant('double', function(value) {
 *     return value * 2;
 *   });
 * ```
 */


/**
 * @ngdoc method
 * @name $provide#decorator
 * @description
 *
 * Register a **decorator function** with the {@link auto.$injector $injector}. A decorator function
 * intercepts the creation of a service, allowing it to override or modify the behavior of the
 * service. The return value of the decorator function may be the original service, or a new service
 * that replaces (or wraps and delegates to) the original service.
 *
 * You can find out more about using decorators in the {@link guide/decorators} guide.
 *
 * @param {string} name The name of the service to decorate.
 * @param {Function|Array.<string|Function>} decorator This function will be invoked when the service needs to be
 *    provided and should return the decorated service instance. The function is called using
 *    the {@link auto.$injector#invoke injector.invoke} method and is therefore fully injectable.
 *    Local injection arguments:
 *
 *    * `$delegate` - The original service instance, which can be replaced, monkey patched, configured,
 *      decorated or delegated to.
 *
 * @example
 * Here we decorate the {@link ng.$log $log} service to convert warnings to errors by intercepting
 * calls to {@link ng.$log#error $log.warn()}.
 * ```js
 *   $provide.decorator('$log', ['$delegate', function($delegate) {
 *     $delegate.warn = $delegate.error;
 *     return $delegate;
 *   }]);
 * ```
 */


function createInjector(modulesToLoad, strictDi) {
  strictDi = (strictDi === true);
  var INSTANTIATING = {},
      providerSuffix = 'Provider',
      path = [],
      loadedModules = new HashMap([], true),
      providerCache = {
        $provide: {
            provider: supportObject(provider),
            factory: supportObject(factory),
            service: supportObject(service),
            value: supportObject(value),
            constant: supportObject(constant),
            decorator: decorator
          }
      },
      providerInjector = (providerCache.$injector =
          createInternalInjector(providerCache, function(serviceName, caller) {
            if (angular.isString(caller)) {
              path.push(caller);
            }
            throw $injectorMinErr('unpr', "Unknown provider: {0}", path.join(' <- '));
          })),
      instanceCache = {},
      protoInstanceInjector =
          createInternalInjector(instanceCache, function(serviceName, caller) {
            var provider = providerInjector.get(serviceName + providerSuffix, caller);
            return instanceInjector.invoke(
                provider.$get, provider, undefined, serviceName);
          }),
      instanceInjector = protoInstanceInjector;

  providerCache['$injector' + providerSuffix] = { $get: valueFn(protoInstanceInjector) };
  var runBlocks = loadModules(modulesToLoad);
  instanceInjector = protoInstanceInjector.get('$injector');
  instanceInjector.strictDi = strictDi;
  forEach(runBlocks, function(fn) { if (fn) instanceInjector.invoke(fn); });

  return instanceInjector;

  ////////////////////////////////////
  // $provider
  ////////////////////////////////////

  function supportObject(delegate) {
    return function(key, value) {
      if (isObject(key)) {
        forEach(key, reverseParams(delegate));
      } else {
        return delegate(key, value);
      }
    };
  }

  function provider(name, provider_) {
    assertNotHasOwnProperty(name, 'service');
    if (isFunction(provider_) || isArray(provider_)) {
      provider_ = providerInjector.instantiate(provider_);
    }
    if (!provider_.$get) {
      throw $injectorMinErr('pget', "Provider '{0}' must define $get factory method.", name);
    }
    return providerCache[name + providerSuffix] = provider_;
  }

  function enforceReturnValue(name, factory) {
    return function enforcedReturnValue() {
      var result = instanceInjector.invoke(factory, this);
      if (isUndefined(result)) {
        throw $injectorMinErr('undef', "Provider '{0}' must return a value from $get factory method.", name);
      }
      return result;
    };
  }

  function factory(name, factoryFn, enforce) {
    return provider(name, {
      $get: enforce !== false ? enforceReturnValue(name, factoryFn) : factoryFn
    });
  }

  function service(name, constructor) {
    return factory(name, ['$injector', function($injector) {
      return $injector.instantiate(constructor);
    }]);
  }

  function value(name, val) { return factory(name, valueFn(val), false); }

  function constant(name, value) {
    assertNotHasOwnProperty(name, 'constant');
    providerCache[name] = value;
    instanceCache[name] = value;
  }

  function decorator(serviceName, decorFn) {
    var origProvider = providerInjector.get(serviceName + providerSuffix),
        orig$get = origProvider.$get;

    origProvider.$get = function() {
      var origInstance = instanceInjector.invoke(orig$get, origProvider);
      return instanceInjector.invoke(decorFn, null, {$delegate: origInstance});
    };
  }

  ////////////////////////////////////
  // Module Loading
  ////////////////////////////////////
  function loadModules(modulesToLoad) {
    assertArg(isUndefined(modulesToLoad) || isArray(modulesToLoad), 'modulesToLoad', 'not an array');
    var runBlocks = [], moduleFn;
    forEach(modulesToLoad, function(module) {
      if (loadedModules.get(module)) return;
      loadedModules.put(module, true);

      function runInvokeQueue(queue) {
        var i, ii;
        for (i = 0, ii = queue.length; i < ii; i++) {
          var invokeArgs = queue[i],
              provider = providerInjector.get(invokeArgs[0]);

          provider[invokeArgs[1]].apply(provider, invokeArgs[2]);
        }
      }

      try {
        if (isString(module)) {
          moduleFn = angularModule(module);
          runBlocks = runBlocks.concat(loadModules(moduleFn.requires)).concat(moduleFn._runBlocks);
          runInvokeQueue(moduleFn._invokeQueue);
          runInvokeQueue(moduleFn._configBlocks);
        } else if (isFunction(module)) {
            runBlocks.push(providerInjector.invoke(module));
        } else if (isArray(module)) {
            runBlocks.push(providerInjector.invoke(module));
        } else {
          assertArgFn(module, 'module');
        }
      } catch (e) {
        if (isArray(module)) {
          module = module[module.length - 1];
        }
        if (e.message && e.stack && e.stack.indexOf(e.message) == -1) {
          // Safari & FF's stack traces don't contain error.message content
          // unlike those of Chrome and IE
          // So if stack doesn't contain message, we create a new string that contains both.
          // Since error.stack is read-only in Safari, I'm overriding e and not e.stack here.
          /* jshint -W022 */
          e = e.message + '\n' + e.stack;
        }
        throw $injectorMinErr('modulerr', "Failed to instantiate module {0} due to:\n{1}",
                  module, e.stack || e.message || e);
      }
    });
    return runBlocks;
  }

  ////////////////////////////////////
  // internal Injector
  ////////////////////////////////////

  function createInternalInjector(cache, factory) {

    function getService(serviceName, caller) {
      if (cache.hasOwnProperty(serviceName)) {
        if (cache[serviceName] === INSTANTIATING) {
          throw $injectorMinErr('cdep', 'Circular dependency found: {0}',
                    serviceName + ' <- ' + path.join(' <- '));
        }
        return cache[serviceName];
      } else {
        try {
          path.unshift(serviceName);
          cache[serviceName] = INSTANTIATING;
          return cache[serviceName] = factory(serviceName, caller);
        } catch (err) {
          if (cache[serviceName] === INSTANTIATING) {
            delete cache[serviceName];
          }
          throw err;
        } finally {
          path.shift();
        }
      }
    }


    function injectionArgs(fn, locals, serviceName) {
      var args = [],
          $inject = createInjector.$$annotate(fn, strictDi, serviceName);

      for (var i = 0, length = $inject.length; i < length; i++) {
        var key = $inject[i];
        if (typeof key !== 'string') {
          throw $injectorMinErr('itkn',
                  'Incorrect injection token! Expected service name as string, got {0}', key);
        }
        args.push(locals && locals.hasOwnProperty(key) ? locals[key] :
                                                         getService(key, serviceName));
      }
      return args;
    }

    function isClass(func) {
      // IE 9-11 do not support classes and IE9 leaks with the code below.
      if (msie <= 11) {
        return false;
      }
      // Support: Edge 12-13 only
      // See: https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/6156135/
      return typeof func === 'function'
        && /^(?:class\b|constructor\()/.test(stringifyFn(func));
    }

    function invoke(fn, self, locals, serviceName) {
      if (typeof locals === 'string') {
        serviceName = locals;
        locals = null;
      }

      var args = injectionArgs(fn, locals, serviceName);
      if (isArray(fn)) {
        fn = fn[fn.length - 1];
      }

      if (!isClass(fn)) {
        // http://jsperf.com/angularjs-invoke-apply-vs-switch
        // #5388
        return fn.apply(self, args);
      } else {
        args.unshift(null);
        return new (Function.prototype.bind.apply(fn, args))();
      }
    }


    function instantiate(Type, locals, serviceName) {
      // Check if Type is annotated and use just the given function at n-1 as parameter
      // e.g. someModule.factory('greeter', ['$window', function(renamed$window) {}]);
      var ctor = (isArray(Type) ? Type[Type.length - 1] : Type);
      var args = injectionArgs(Type, locals, serviceName);
      // Empty object at position 0 is ignored for invocation with `new`, but required.
      args.unshift(null);
      return new (Function.prototype.bind.apply(ctor, args))();
    }


    return {
      invoke: invoke,
      instantiate: instantiate,
      get: getService,
      annotate: createInjector.$$annotate,
      has: function(name) {
        return providerCache.hasOwnProperty(name + providerSuffix) || cache.hasOwnProperty(name);
      }
    };
  }
}

createInjector.$$annotate = annotate;

/**
 * @ngdoc provider
 * @name $anchorScrollProvider
 *
 * @description
 * Use `$anchorScrollProvider` to disable automatic scrolling whenever
 * {@link ng.$location#hash $location.hash()} changes.
 */
function $AnchorScrollProvider() {

  var autoScrollingEnabled = true;

  /**
   * @ngdoc method
   * @name $anchorScrollProvider#disableAutoScrolling
   *
   * @description
   * By default, {@link ng.$anchorScroll $anchorScroll()} will automatically detect changes to
   * {@link ng.$location#hash $location.hash()} and scroll to the element matching the new hash.<br />
   * Use this method to disable automatic scrolling.
   *
   * If automatic scrolling is disabled, one must explicitly call
   * {@link ng.$anchorScroll $anchorScroll()} in order to scroll to the element related to the
   * current hash.
   */
  this.disableAutoScrolling = function() {
    autoScrollingEnabled = false;
  };

  /**
   * @ngdoc service
   * @name $anchorScroll
   * @kind function
   * @requires $window
   * @requires $location
   * @requires $rootScope
   *
   * @description
   * When called, it scrolls to the element related to the specified `hash` or (if omitted) to the
   * current value of {@link ng.$location#hash $location.hash()}, according to the rules specified
   * in the
   * [HTML5 spec](http://www.w3.org/html/wg/drafts/html/master/browsers.html#an-indicated-part-of-the-document).
   *
   * It also watches the {@link ng.$location#hash $location.hash()} and automatically scrolls to
   * match any anchor whenever it changes. This can be disabled by calling
   * {@link ng.$anchorScrollProvider#disableAutoScrolling $anchorScrollProvider.disableAutoScrolling()}.
   *
   * Additionally, you can use its {@link ng.$anchorScroll#yOffset yOffset} property to specify a
   * vertical scroll-offset (either fixed or dynamic).
   *
   * @param {string=} hash The hash specifying the element to scroll to. If omitted, the value of
   *                       {@link ng.$location#hash $location.hash()} will be used.
   *
   * @property {(number|function|jqLite)} yOffset
   * If set, specifies a vertical scroll-offset. This is often useful when there are fixed
   * positioned elements at the top of the page, such as navbars, headers etc.
   *
   * `yOffset` can be specified in various ways:
   * - **number**: A fixed number of pixels to be used as offset.<br /><br />
   * - **function**: A getter function called everytime `$anchorScroll()` is executed. Must return
   *   a number representing the offset (in pixels).<br /><br />
   * - **jqLite**: A jqLite/jQuery element to be used for specifying the offset. The distance from
   *   the top of the page to the element's bottom will be used as offset.<br />
   *   **Note**: The element will be taken into account only as long as its `position` is set to
   *   `fixed`. This option is useful, when dealing with responsive navbars/headers that adjust
   *   their height and/or positioning according to the viewport's size.
   *
   * <br />
   * <div class="alert alert-warning">
   * In order for `yOffset` to work properly, scrolling should take place on the document's root and
   * not some child element.
   * </div>
   *
   * @example
     <example module="anchorScrollExample">
       <file name="index.html">
         <div id="scrollArea" ng-controller="ScrollController">
           <a ng-click="gotoBottom()">Go to bottom</a>
           <a id="bottom"></a> You're at the bottom!
         </div>
       </file>
       <file name="script.js">
         angular.module('anchorScrollExample', [])
           .controller('ScrollController', ['$scope', '$location', '$anchorScroll',
             function ($scope, $location, $anchorScroll) {
               $scope.gotoBottom = function() {
                 // set the location.hash to the id of
                 // the element you wish to scroll to.
                 $location.hash('bottom');

                 // call $anchorScroll()
                 $anchorScroll();
               };
             }]);
       </file>
       <file name="style.css">
         #scrollArea {
           height: 280px;
           overflow: auto;
         }

         #bottom {
           display: block;
           margin-top: 2000px;
         }
       </file>
     </example>
   *
   * <hr />
   * The example below illustrates the use of a vertical scroll-offset (specified as a fixed value).
   * See {@link ng.$anchorScroll#yOffset $anchorScroll.yOffset} for more details.
   *
   * @example
     <example module="anchorScrollOffsetExample">
       <file name="index.html">
         <div class="fixed-header" ng-controller="headerCtrl">
           <a href="" ng-click="gotoAnchor(x)" ng-repeat="x in [1,2,3,4,5]">
             Go to anchor {{x}}
           </a>
         </div>
         <div id="anchor{{x}}" class="anchor" ng-repeat="x in [1,2,3,4,5]">
           Anchor {{x}} of 5
         </div>
       </file>
       <file name="script.js">
         angular.module('anchorScrollOffsetExample', [])
           .run(['$anchorScroll', function($anchorScroll) {
             $anchorScroll.yOffset = 50;   // always scroll by 50 extra pixels
           }])
           .controller('headerCtrl', ['$anchorScroll', '$location', '$scope',
             function ($anchorScroll, $location, $scope) {
               $scope.gotoAnchor = function(x) {
                 var newHash = 'anchor' + x;
                 if ($location.hash() !== newHash) {
                   // set the $location.hash to `newHash` and
                   // $anchorScroll will automatically scroll to it
                   $location.hash('anchor' + x);
                 } else {
                   // call $anchorScroll() explicitly,
                   // since $location.hash hasn't changed
                   $anchorScroll();
                 }
               };
             }
           ]);
       </file>
       <file name="style.css">
         body {
           padding-top: 50px;
         }

         .anchor {
           border: 2px dashed DarkOrchid;
           padding: 10px 10px 200px 10px;
         }

         .fixed-header {
           background-color: rgba(0, 0, 0, 0.2);
           height: 50px;
           position: fixed;
           top: 0; left: 0; right: 0;
         }

         .fixed-header > a {
           display: inline-block;
           margin: 5px 15px;
         }
       </file>
     </example>
   */
  this.$get = ['$window', '$location', '$rootScope', function($window, $location, $rootScope) {
    var document = $window.document;

    // Helper function to get first anchor from a NodeList
    // (using `Array#some()` instead of `angular#forEach()` since it's more performant
    //  and working in all supported browsers.)
    function getFirstAnchor(list) {
      var result = null;
      Array.prototype.some.call(list, function(element) {
        if (nodeName_(element) === 'a') {
          result = element;
          return true;
        }
      });
      return result;
    }

    function getYOffset() {

      var offset = scroll.yOffset;

      if (isFunction(offset)) {
        offset = offset();
      } else if (isElement(offset)) {
        var elem = offset[0];
        var style = $window.getComputedStyle(elem);
        if (style.position !== 'fixed') {
          offset = 0;
        } else {
          offset = elem.getBoundingClientRect().bottom;
        }
      } else if (!isNumber(offset)) {
        offset = 0;
      }

      return offset;
    }

    function scrollTo(elem) {
      if (elem) {
        elem.scrollIntoView();

        var offset = getYOffset();

        if (offset) {
          // `offset` is the number of pixels we should scroll UP in order to align `elem` properly.
          // This is true ONLY if the call to `elem.scrollIntoView()` initially aligns `elem` at the
          // top of the viewport.
          //
          // IF the number of pixels from the top of `elem` to the end of the page's content is less
          // than the height of the viewport, then `elem.scrollIntoView()` will align the `elem` some
          // way down the page.
          //
          // This is often the case for elements near the bottom of the page.
          //
          // In such cases we do not need to scroll the whole `offset` up, just the difference between
          // the top of the element and the offset, which is enough to align the top of `elem` at the
          // desired position.
          var elemTop = elem.getBoundingClientRect().top;
          $window.scrollBy(0, elemTop - offset);
        }
      } else {
        $window.scrollTo(0, 0);
      }
    }

    function scroll(hash) {
      hash = isString(hash) ? hash : $location.hash();
      var elm;

      // empty hash, scroll to the top of the page
      if (!hash) scrollTo(null);

      // element with given id
      else if ((elm = document.getElementById(hash))) scrollTo(elm);

      // first anchor with given name :-D
      else if ((elm = getFirstAnchor(document.getElementsByName(hash)))) scrollTo(elm);

      // no element and hash == 'top', scroll to the top of the page
      else if (hash === 'top') scrollTo(null);
    }

    // does not scroll when user clicks on anchor link that is currently on
    // (no url change, no $location.hash() change), browser native does scroll
    if (autoScrollingEnabled) {
      $rootScope.$watch(function autoScrollWatch() {return $location.hash();},
        function autoScrollWatchAction(newVal, oldVal) {
          // skip the initial scroll if $location.hash is empty
          if (newVal === oldVal && newVal === '') return;

          jqLiteDocumentLoaded(function() {
            $rootScope.$evalAsync(scroll);
          });
        });
    }

    return scroll;
  }];
}

var $animateMinErr = minErr('$animate');
var ELEMENT_NODE = 1;
var NG_ANIMATE_CLASSNAME = 'ng-animate';

function mergeClasses(a,b) {
  if (!a && !b) return '';
  if (!a) return b;
  if (!b) return a;
  if (isArray(a)) a = a.join(' ');
  if (isArray(b)) b = b.join(' ');
  return a + ' ' + b;
}

function extractElementNode(element) {
  for (var i = 0; i < element.length; i++) {
    var elm = element[i];
    if (elm.nodeType === ELEMENT_NODE) {
      return elm;
    }
  }
}

function splitClasses(classes) {
  if (isString(classes)) {
    classes = classes.split(' ');
  }

  // Use createMap() to prevent class assumptions involving property names in
  // Object.prototype
  var obj = createMap();
  forEach(classes, function(klass) {
    // sometimes the split leaves empty string values
    // incase extra spaces were applied to the options
    if (klass.length) {
      obj[klass] = true;
    }
  });
  return obj;
}

// if any other type of options value besides an Object value is
// passed into the $animate.method() animation then this helper code
// will be run which will ignore it. While this patch is not the
// greatest solution to this, a lot of existing plugins depend on
// $animate to either call the callback (< 1.2) or return a promise
// that can be changed. This helper function ensures that the options
// are wiped clean incase a callback function is provided.
function prepareAnimateOptions(options) {
  return isObject(options)
      ? options
      : {};
}

var $$CoreAnimateJsProvider = function() {
  this.$get = noop;
};

// this is prefixed with Core since it conflicts with
// the animateQueueProvider defined in ngAnimate/animateQueue.js
var $$CoreAnimateQueueProvider = function() {
  var postDigestQueue = new HashMap();
  var postDigestElements = [];

  this.$get = ['$$AnimateRunner', '$rootScope',
       function($$AnimateRunner,   $rootScope) {
    return {
      enabled: noop,
      on: noop,
      off: noop,
      pin: noop,

      push: function(element, event, options, domOperation) {
        domOperation        && domOperation();

        options = options || {};
        options.from        && element.css(options.from);
        options.to          && element.css(options.to);

        if (options.addClass || options.removeClass) {
          addRemoveClassesPostDigest(element, options.addClass, options.removeClass);
        }

        var runner = new $$AnimateRunner(); // jshint ignore:line

        // since there are no animations to run the runner needs to be
        // notified that the animation call is complete.
        runner.complete();
        return runner;
      }
    };


    function updateData(data, classes, value) {
      var changed = false;
      if (classes) {
        classes = isString(classes) ? classes.split(' ') :
                  isArray(classes) ? classes : [];
        forEach(classes, function(className) {
          if (className) {
            changed = true;
            data[className] = value;
          }
        });
      }
      return changed;
    }

    function handleCSSClassChanges() {
      forEach(postDigestElements, function(element) {
        var data = postDigestQueue.get(element);
        if (data) {
          var existing = splitClasses(element.attr('class'));
          var toAdd = '';
          var toRemove = '';
          forEach(data, function(status, className) {
            var hasClass = !!existing[className];
            if (status !== hasClass) {
              if (status) {
                toAdd += (toAdd.length ? ' ' : '') + className;
              } else {
                toRemove += (toRemove.length ? ' ' : '') + className;
              }
            }
          });

          forEach(element, function(elm) {
            toAdd    && jqLiteAddClass(elm, toAdd);
            toRemove && jqLiteRemoveClass(elm, toRemove);
          });
          postDigestQueue.remove(element);
        }
      });
      postDigestElements.length = 0;
    }


    function addRemoveClassesPostDigest(element, add, remove) {
      var data = postDigestQueue.get(element) || {};

      var classesAdded = updateData(data, add, true);
      var classesRemoved = updateData(data, remove, false);

      if (classesAdded || classesRemoved) {

        postDigestQueue.put(element, data);
        postDigestElements.push(element);

        if (postDigestElements.length === 1) {
          $rootScope.$$postDigest(handleCSSClassChanges);
        }
      }
    }
  }];
};

/**
 * @ngdoc provider
 * @name $animateProvider
 *
 * @description
 * Default implementation of $animate that doesn't perform any animations, instead just
 * synchronously performs DOM updates and resolves the returned runner promise.
 *
 * In order to enable animations the `ngAnimate` module has to be loaded.
 *
 * To see the functional implementation check out `src/ngAnimate/animate.js`.
 */
var $AnimateProvider = ['$provide', function($provide) {
  var provider = this;

  this.$$registeredAnimations = Object.create(null);

   /**
   * @ngdoc method
   * @name $animateProvider#register
   *
   * @description
   * Registers a new injectable animation factory function. The factory function produces the
   * animation object which contains callback functions for each event that is expected to be
   * animated.
   *
   *   * `eventFn`: `function(element, ... , doneFunction, options)`
   *   The element to animate, the `doneFunction` and the options fed into the animation. Depending
   *   on the type of animation additional arguments will be injected into the animation function. The
   *   list below explains the function signatures for the different animation methods:
   *
   *   - setClass: function(element, addedClasses, removedClasses, doneFunction, options)
   *   - addClass: function(element, addedClasses, doneFunction, options)
   *   - removeClass: function(element, removedClasses, doneFunction, options)
   *   - enter, leave, move: function(element, doneFunction, options)
   *   - animate: function(element, fromStyles, toStyles, doneFunction, options)
   *
   *   Make sure to trigger the `doneFunction` once the animation is fully complete.
   *
   * ```js
   *   return {
   *     //enter, leave, move signature
   *     eventFn : function(element, done, options) {
   *       //code to run the animation
   *       //once complete, then run done()
   *       return function endFunction(wasCancelled) {
   *         //code to cancel the animation
   *       }
   *     }
   *   }
   * ```
   *
   * @param {string} name The name of the animation (this is what the class-based CSS value will be compared to).
   * @param {Function} factory The factory function that will be executed to return the animation
   *                           object.
   */
  this.register = function(name, factory) {
    if (name && name.charAt(0) !== '.') {
      throw $animateMinErr('notcsel', "Expecting class selector starting with '.' got '{0}'.", name);
    }

    var key = name + '-animation';
    provider.$$registeredAnimations[name.substr(1)] = key;
    $provide.factory(key, factory);
  };

  /**
   * @ngdoc method
   * @name $animateProvider#classNameFilter
   *
   * @description
   * Sets and/or returns the CSS class regular expression that is checked when performing
   * an animation. Upon bootstrap the classNameFilter value is not set at all and will
   * therefore enable $animate to attempt to perform an animation on any element that is triggered.
   * When setting the `classNameFilter` value, animations will only be performed on elements
   * that successfully match the filter expression. This in turn can boost performance
   * for low-powered devices as well as applications containing a lot of structural operations.
   * @param {RegExp=} expression The className expression which will be checked against all animations
   * @return {RegExp} The current CSS className expression value. If null then there is no expression value
   */
  this.classNameFilter = function(expression) {
    if (arguments.length === 1) {
      this.$$classNameFilter = (expression instanceof RegExp) ? expression : null;
      if (this.$$classNameFilter) {
        var reservedRegex = new RegExp("(\\s+|\\/)" + NG_ANIMATE_CLASSNAME + "(\\s+|\\/)");
        if (reservedRegex.test(this.$$classNameFilter.toString())) {
          throw $animateMinErr('nongcls','$animateProvider.classNameFilter(regex) prohibits accepting a regex value which matches/contains the "{0}" CSS class.', NG_ANIMATE_CLASSNAME);

        }
      }
    }
    return this.$$classNameFilter;
  };

  this.$get = ['$$animateQueue', function($$animateQueue) {
    function domInsert(element, parentElement, afterElement) {
      // if for some reason the previous element was removed
      // from the dom sometime before this code runs then let's
      // just stick to using the parent element as the anchor
      if (afterElement) {
        var afterNode = extractElementNode(afterElement);
        if (afterNode && !afterNode.parentNode && !afterNode.previousElementSibling) {
          afterElement = null;
        }
      }
      afterElement ? afterElement.after(element) : parentElement.prepend(element);
    }

    /**
     * @ngdoc service
     * @name $animate
     * @description The $animate service exposes a series of DOM utility methods that provide support
     * for animation hooks. The default behavior is the application of DOM operations, however,
     * when an animation is detected (and animations are enabled), $animate will do the heavy lifting
     * to ensure that animation runs with the triggered DOM operation.
     *
     * By default $animate doesn't trigger any animations. This is because the `ngAnimate` module isn't
     * included and only when it is active then the animation hooks that `$animate` triggers will be
     * functional. Once active then all structural `ng-` directives will trigger animations as they perform
     * their DOM-related operations (enter, leave and move). Other directives such as `ngClass`,
     * `ngShow`, `ngHide` and `ngMessages` also provide support for animations.
     *
     * It is recommended that the`$animate` service is always used when executing DOM-related procedures within directives.
     *
     * To learn more about enabling animation support, click here to visit the
     * {@link ngAnimate ngAnimate module page}.
     */
    return {
      // we don't call it directly since non-existant arguments may
      // be interpreted as null within the sub enabled function

      /**
       *
       * @ngdoc method
       * @name $animate#on
       * @kind function
       * @description Sets up an event listener to fire whenever the animation event (enter, leave, move, etc...)
       *    has fired on the given element or among any of its children. Once the listener is fired, the provided callback
       *    is fired with the following params:
       *
       * ```js
       * $animate.on('enter', container,
       *    function callback(element, phase) {
       *      // cool we detected an enter animation within the container
       *    }
       * );
       * ```
       *
       * @param {string} event the animation event that will be captured (e.g. enter, leave, move, addClass, removeClass, etc...)
       * @param {DOMElement} container the container element that will capture each of the animation events that are fired on itself
       *     as well as among its children
       * @param {Function} callback the callback function that will be fired when the listener is triggered
       *
       * The arguments present in the callback function are:
       * * `element` - The captured DOM element that the animation was fired on.
       * * `phase` - The phase of the animation. The two possible phases are **start** (when the animation starts) and **close** (when it ends).
       */
      on: $$animateQueue.on,

      /**
       *
       * @ngdoc method
       * @name $animate#off
       * @kind function
       * @description Deregisters an event listener based on the event which has been associated with the provided element. This method
       * can be used in three different ways depending on the arguments:
       *
       * ```js
       * // remove all the animation event listeners listening for `enter`
       * $animate.off('enter');
       *
       * // remove listeners for all animation events from the container element
       * $animate.off(container);
       *
       * // remove all the animation event listeners listening for `enter` on the given element and its children
       * $animate.off('enter', container);
       *
       * // remove the event listener function provided by `callback` that is set
       * // to listen for `enter` on the given `container` as well as its children
       * $animate.off('enter', container, callback);
       * ```
       *
       * @param {string|DOMElement} event|container the animation event (e.g. enter, leave, move,
       * addClass, removeClass, etc...), or the container element. If it is the element, all other
       * arguments are ignored.
       * @param {DOMElement=} container the container element the event listener was placed on
       * @param {Function=} callback the callback function that was registered as the listener
       */
      off: $$animateQueue.off,

      /**
       * @ngdoc method
       * @name $animate#pin
       * @kind function
       * @description Associates the provided element with a host parent element to allow the element to be animated even if it exists
       *    outside of the DOM structure of the Angular application. By doing so, any animation triggered via `$animate` can be issued on the
       *    element despite being outside the realm of the application or within another application. Say for example if the application
       *    was bootstrapped on an element that is somewhere inside of the `<body>` tag, but we wanted to allow for an element to be situated
       *    as a direct child of `document.body`, then this can be achieved by pinning the element via `$animate.pin(element)`. Keep in mind
       *    that calling `$animate.pin(element, parentElement)` will not actually insert into the DOM anywhere; it will just create the association.
       *
       *    Note that this feature is only active when the `ngAnimate` module is used.
       *
       * @param {DOMElement} element the external element that will be pinned
       * @param {DOMElement} parentElement the host parent element that will be associated with the external element
       */
      pin: $$animateQueue.pin,

      /**
       *
       * @ngdoc method
       * @name $animate#enabled
       * @kind function
       * @description Used to get and set whether animations are enabled or not on the entire application or on an element and its children. This
       * function can be called in four ways:
       *
       * ```js
       * // returns true or false
       * $animate.enabled();
       *
       * // changes the enabled state for all animations
       * $animate.enabled(false);
       * $animate.enabled(true);
       *
       * // returns true or false if animations are enabled for an element
       * $animate.enabled(element);
       *
       * // changes the enabled state for an element and its children
       * $animate.enabled(element, true);
       * $animate.enabled(element, false);
       * ```
       *
       * @param {DOMElement=} element the element that will be considered for checking/setting the enabled state
       * @param {boolean=} enabled whether or not the animations will be enabled for the element
       *
       * @return {boolean} whether or not animations are enabled
       */
      enabled: $$animateQueue.enabled,

      /**
       * @ngdoc method
       * @name $animate#cancel
       * @kind function
       * @description Cancels the provided animation.
       *
       * @param {Promise} animationPromise The animation promise that is returned when an animation is started.
       */
      cancel: function(runner) {
        runner.end && runner.end();
      },

      /**
       *
       * @ngdoc method
       * @name $animate#enter
       * @kind function
       * @description Inserts the element into the DOM either after the `after` element (if provided) or
       *   as the first child within the `parent` element and then triggers an animation.
       *   A promise is returned that will be resolved during the next digest once the animation
       *   has completed.
       *
       * @param {DOMElement} element the element which will be inserted into the DOM
       * @param {DOMElement} parent the parent element which will append the element as
       *   a child (so long as the after element is not present)
       * @param {DOMElement=} after the sibling element after which the element will be appended
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Promise} the animation callback promise
       */
      enter: function(element, parent, after, options) {
        parent = parent && jqLite(parent);
        after = after && jqLite(after);
        parent = parent || after.parent();
        domInsert(element, parent, after);
        return $$animateQueue.push(element, 'enter', prepareAnimateOptions(options));
      },

      /**
       *
       * @ngdoc method
       * @name $animate#move
       * @kind function
       * @description Inserts (moves) the element into its new position in the DOM either after
       *   the `after` element (if provided) or as the first child within the `parent` element
       *   and then triggers an animation. A promise is returned that will be resolved
       *   during the next digest once the animation has completed.
       *
       * @param {DOMElement} element the element which will be moved into the new DOM position
       * @param {DOMElement} parent the parent element which will append the element as
       *   a child (so long as the after element is not present)
       * @param {DOMElement=} after the sibling element after which the element will be appended
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Promise} the animation callback promise
       */
      move: function(element, parent, after, options) {
        parent = parent && jqLite(parent);
        after = after && jqLite(after);
        parent = parent || after.parent();
        domInsert(element, parent, after);
        return $$animateQueue.push(element, 'move', prepareAnimateOptions(options));
      },

      /**
       * @ngdoc method
       * @name $animate#leave
       * @kind function
       * @description Triggers an animation and then removes the element from the DOM.
       * When the function is called a promise is returned that will be resolved during the next
       * digest once the animation has completed.
       *
       * @param {DOMElement} element the element which will be removed from the DOM
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Promise} the animation callback promise
       */
      leave: function(element, options) {
        return $$animateQueue.push(element, 'leave', prepareAnimateOptions(options), function() {
          element.remove();
        });
      },

      /**
       * @ngdoc method
       * @name $animate#addClass
       * @kind function
       *
       * @description Triggers an addClass animation surrounding the addition of the provided CSS class(es). Upon
       *   execution, the addClass operation will only be handled after the next digest and it will not trigger an
       *   animation if element already contains the CSS class or if the class is removed at a later step.
       *   Note that class-based animations are treated differently compared to structural animations
       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
       *   depending if CSS or JavaScript animations are used.
       *
       * @param {DOMElement} element the element which the CSS classes will be applied to
       * @param {string} className the CSS class(es) that will be added (multiple classes are separated via spaces)
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Promise} the animation callback promise
       */
      addClass: function(element, className, options) {
        options = prepareAnimateOptions(options);
        options.addClass = mergeClasses(options.addclass, className);
        return $$animateQueue.push(element, 'addClass', options);
      },

      /**
       * @ngdoc method
       * @name $animate#removeClass
       * @kind function
       *
       * @description Triggers a removeClass animation surrounding the removal of the provided CSS class(es). Upon
       *   execution, the removeClass operation will only be handled after the next digest and it will not trigger an
       *   animation if element does not contain the CSS class or if the class is added at a later step.
       *   Note that class-based animations are treated differently compared to structural animations
       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
       *   depending if CSS or JavaScript animations are used.
       *
       * @param {DOMElement} element the element which the CSS classes will be applied to
       * @param {string} className the CSS class(es) that will be removed (multiple classes are separated via spaces)
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Promise} the animation callback promise
       */
      removeClass: function(element, className, options) {
        options = prepareAnimateOptions(options);
        options.removeClass = mergeClasses(options.removeClass, className);
        return $$animateQueue.push(element, 'removeClass', options);
      },

      /**
       * @ngdoc method
       * @name $animate#setClass
       * @kind function
       *
       * @description Performs both the addition and removal of a CSS classes on an element and (during the process)
       *    triggers an animation surrounding the class addition/removal. Much like `$animate.addClass` and
       *    `$animate.removeClass`, `setClass` will only evaluate the classes being added/removed once a digest has
       *    passed. Note that class-based animations are treated differently compared to structural animations
       *    (like enter, move and leave) since the CSS classes may be added/removed at different points
       *    depending if CSS or JavaScript animations are used.
       *
       * @param {DOMElement} element the element which the CSS classes will be applied to
       * @param {string} add the CSS class(es) that will be added (multiple classes are separated via spaces)
       * @param {string} remove the CSS class(es) that will be removed (multiple classes are separated via spaces)
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Promise} the animation callback promise
       */
      setClass: function(element, add, remove, options) {
        options = prepareAnimateOptions(options);
        options.addClass = mergeClasses(options.addClass, add);
        options.removeClass = mergeClasses(options.removeClass, remove);
        return $$animateQueue.push(element, 'setClass', options);
      },

      /**
       * @ngdoc method
       * @name $animate#animate
       * @kind function
       *
       * @description Performs an inline animation on the element which applies the provided to and from CSS styles to the element.
       * If any detected CSS transition, keyframe or JavaScript matches the provided className value, then the animation will take
       * on the provided styles. For example, if a transition animation is set for the given classNamem, then the provided `from` and
       * `to` styles will be applied alongside the given transition. If the CSS style provided in `from` does not have a corresponding
       * style in `to`, the style in `from` is applied immediately, and no animation is run.
       * If a JavaScript animation is detected then the provided styles will be given in as function parameters into the `animate`
       * method (or as part of the `options` parameter):
       *
       * ```js
       * ngModule.animation('.my-inline-animation', function() {
       *   return {
       *     animate : function(element, from, to, done, options) {
       *       //animation
       *       done();
       *     }
       *   }
       * });
       * ```
       *
       * @param {DOMElement} element the element which the CSS styles will be applied to
       * @param {object} from the from (starting) CSS styles that will be applied to the element and across the animation.
       * @param {object} to the to (destination) CSS styles that will be applied to the element and across the animation.
       * @param {string=} className an optional CSS class that will be applied to the element for the duration of the animation. If
       *    this value is left as empty then a CSS class of `ng-inline-animate` will be applied to the element.
       *    (Note that if no animation is detected then this value will not be applied to the element.)
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Promise} the animation callback promise
       */
      animate: function(element, from, to, className, options) {
        options = prepareAnimateOptions(options);
        options.from = options.from ? extend(options.from, from) : from;
        options.to   = options.to   ? extend(options.to, to)     : to;

        className = className || 'ng-inline-animate';
        options.tempClasses = mergeClasses(options.tempClasses, className);
        return $$animateQueue.push(element, 'animate', options);
      }
    };
  }];
}];

var $$AnimateAsyncRunFactoryProvider = function() {
  this.$get = ['$$rAF', function($$rAF) {
    var waitQueue = [];

    function waitForTick(fn) {
      waitQueue.push(fn);
      if (waitQueue.length > 1) return;
      $$rAF(function() {
        for (var i = 0; i < waitQueue.length; i++) {
          waitQueue[i]();
        }
        waitQueue = [];
      });
    }

    return function() {
      var passed = false;
      waitForTick(function() {
        passed = true;
      });
      return function(callback) {
        passed ? callback() : waitForTick(callback);
      };
    };
  }];
};

var $$AnimateRunnerFactoryProvider = function() {
  this.$get = ['$q', '$sniffer', '$$animateAsyncRun', '$document', '$timeout',
       function($q,   $sniffer,   $$animateAsyncRun,   $document,   $timeout) {

    var INITIAL_STATE = 0;
    var DONE_PENDING_STATE = 1;
    var DONE_COMPLETE_STATE = 2;

    AnimateRunner.chain = function(chain, callback) {
      var index = 0;

      next();
      function next() {
        if (index === chain.length) {
          callback(true);
          return;
        }

        chain[index](function(response) {
          if (response === false) {
            callback(false);
            return;
          }
          index++;
          next();
        });
      }
    };

    AnimateRunner.all = function(runners, callback) {
      var count = 0;
      var status = true;
      forEach(runners, function(runner) {
        runner.done(onProgress);
      });

      function onProgress(response) {
        status = status && response;
        if (++count === runners.length) {
          callback(status);
        }
      }
    };

    function AnimateRunner(host) {
      this.setHost(host);

      var rafTick = $$animateAsyncRun();
      var timeoutTick = function(fn) {
        $timeout(fn, 0, false);
      };

      this._doneCallbacks = [];
      this._tick = function(fn) {
        var doc = $document[0];

        // the document may not be ready or attached
        // to the module for some internal tests
        if (doc && doc.hidden) {
          timeoutTick(fn);
        } else {
          rafTick(fn);
        }
      };
      this._state = 0;
    }

    AnimateRunner.prototype = {
      setHost: function(host) {
        this.host = host || {};
      },

      done: function(fn) {
        if (this._state === DONE_COMPLETE_STATE) {
          fn();
        } else {
          this._doneCallbacks.push(fn);
        }
      },

      progress: noop,

      getPromise: function() {
        if (!this.promise) {
          var self = this;
          this.promise = $q(function(resolve, reject) {
            self.done(function(status) {
              status === false ? reject() : resolve();
            });
          });
        }
        return this.promise;
      },

      then: function(resolveHandler, rejectHandler) {
        return this.getPromise().then(resolveHandler, rejectHandler);
      },

      'catch': function(handler) {
        return this.getPromise()['catch'](handler);
      },

      'finally': function(handler) {
        return this.getPromise()['finally'](handler);
      },

      pause: function() {
        if (this.host.pause) {
          this.host.pause();
        }
      },

      resume: function() {
        if (this.host.resume) {
          this.host.resume();
        }
      },

      end: function() {
        if (this.host.end) {
          this.host.end();
        }
        this._resolve(true);
      },

      cancel: function() {
        if (this.host.cancel) {
          this.host.cancel();
        }
        this._resolve(false);
      },

      complete: function(response) {
        var self = this;
        if (self._state === INITIAL_STATE) {
          self._state = DONE_PENDING_STATE;
          self._tick(function() {
            self._resolve(response);
          });
        }
      },

      _resolve: function(response) {
        if (this._state !== DONE_COMPLETE_STATE) {
          forEach(this._doneCallbacks, function(fn) {
            fn(response);
          });
          this._doneCallbacks.length = 0;
          this._state = DONE_COMPLETE_STATE;
        }
      }
    };

    return AnimateRunner;
  }];
};

/**
 * @ngdoc service
 * @name $animateCss
 * @kind object
 *
 * @description
 * This is the core version of `$animateCss`. By default, only when the `ngAnimate` is included,
 * then the `$animateCss` service will actually perform animations.
 *
 * Click here {@link ngAnimate.$animateCss to read the documentation for $animateCss}.
 */
var $CoreAnimateCssProvider = function() {
  this.$get = ['$$rAF', '$q', '$$AnimateRunner', function($$rAF, $q, $$AnimateRunner) {

    return function(element, initialOptions) {
      // all of the animation functions should create
      // a copy of the options data, however, if a
      // parent service has already created a copy then
      // we should stick to using that
      var options = initialOptions || {};
      if (!options.$$prepared) {
        options = copy(options);
      }

      // there is no point in applying the styles since
      // there is no animation that goes on at all in
      // this version of $animateCss.
      if (options.cleanupStyles) {
        options.from = options.to = null;
      }

      if (options.from) {
        element.css(options.from);
        options.from = null;
      }

      /* jshint newcap: false */
      var closed, runner = new $$AnimateRunner();
      return {
        start: run,
        end: run
      };

      function run() {
        $$rAF(function() {
          applyAnimationContents();
          if (!closed) {
            runner.complete();
          }
          closed = true;
        });
        return runner;
      }

      function applyAnimationContents() {
        if (options.addClass) {
          element.addClass(options.addClass);
          options.addClass = null;
        }
        if (options.removeClass) {
          element.removeClass(options.removeClass);
          options.removeClass = null;
        }
        if (options.to) {
          element.css(options.to);
          options.to = null;
        }
      }
    };
  }];
};

/* global stripHash: true */

/**
 * ! This is a private undocumented service !
 *
 * @name $browser
 * @requires $log
 * @description
 * This object has two goals:
 *
 * - hide all the global state in the browser caused by the window object
 * - abstract away all the browser specific features and inconsistencies
 *
 * For tests we provide {@link ngMock.$browser mock implementation} of the `$browser`
 * service, which can be used for convenient testing of the application without the interaction with
 * the real browser apis.
 */
/**
 * @param {object} window The global window object.
 * @param {object} document jQuery wrapped document.
 * @param {object} $log window.console or an object with the same interface.
 * @param {object} $sniffer $sniffer service
 */
function Browser(window, document, $log, $sniffer) {
  var self = this,
      location = window.location,
      history = window.history,
      setTimeout = window.setTimeout,
      clearTimeout = window.clearTimeout,
      pendingDeferIds = {};

  self.isMock = false;

  var outstandingRequestCount = 0;
  var outstandingRequestCallbacks = [];

  // TODO(vojta): remove this temporary api
  self.$$completeOutstandingRequest = completeOutstandingRequest;
  self.$$incOutstandingRequestCount = function() { outstandingRequestCount++; };

  /**
   * Executes the `fn` function(supports currying) and decrements the `outstandingRequestCallbacks`
   * counter. If the counter reaches 0, all the `outstandingRequestCallbacks` are executed.
   */
  function completeOutstandingRequest(fn) {
    try {
      fn.apply(null, sliceArgs(arguments, 1));
    } finally {
      outstandingRequestCount--;
      if (outstandingRequestCount === 0) {
        while (outstandingRequestCallbacks.length) {
          try {
            outstandingRequestCallbacks.pop()();
          } catch (e) {
            $log.error(e);
          }
        }
      }
    }
  }

  function getHash(url) {
    var index = url.indexOf('#');
    return index === -1 ? '' : url.substr(index);
  }

  /**
   * @private
   * Note: this method is used only by scenario runner
   * TODO(vojta): prefix this method with $$ ?
   * @param {function()} callback Function that will be called when no outstanding request
   */
  self.notifyWhenNoOutstandingRequests = function(callback) {
    if (outstandingRequestCount === 0) {
      callback();
    } else {
      outstandingRequestCallbacks.push(callback);
    }
  };

  //////////////////////////////////////////////////////////////
  // URL API
  //////////////////////////////////////////////////////////////

  var cachedState, lastHistoryState,
      lastBrowserUrl = location.href,
      baseElement = document.find('base'),
      pendingLocation = null,
      getCurrentState = !$sniffer.history ? noop : function getCurrentState() {
        try {
          return history.state;
        } catch (e) {
          // MSIE can reportedly throw when there is no state (UNCONFIRMED).
        }
      };

  cacheState();
  lastHistoryState = cachedState;

  /**
   * @name $browser#url
   *
   * @description
   * GETTER:
   * Without any argument, this method just returns current value of location.href.
   *
   * SETTER:
   * With at least one argument, this method sets url to new value.
   * If html5 history api supported, pushState/replaceState is used, otherwise
   * location.href/location.replace is used.
   * Returns its own instance to allow chaining
   *
   * NOTE: this api is intended for use only by the $location service. Please use the
   * {@link ng.$location $location service} to change url.
   *
   * @param {string} url New url (when used as setter)
   * @param {boolean=} replace Should new url replace current history record?
   * @param {object=} state object to use with pushState/replaceState
   */
  self.url = function(url, replace, state) {
    // In modern browsers `history.state` is `null` by default; treating it separately
    // from `undefined` would cause `$browser.url('/foo')` to change `history.state`
    // to undefined via `pushState`. Instead, let's change `undefined` to `null` here.
    if (isUndefined(state)) {
      state = null;
    }

    // Android Browser BFCache causes location, history reference to become stale.
    if (location !== window.location) location = window.location;
    if (history !== window.history) history = window.history;

    // setter
    if (url) {
      var sameState = lastHistoryState === state;

      // Don't change anything if previous and current URLs and states match. This also prevents
      // IE<10 from getting into redirect loop when in LocationHashbangInHtml5Url mode.
      // See https://github.com/angular/angular.js/commit/ffb2701
      if (lastBrowserUrl === url && (!$sniffer.history || sameState)) {
        return self;
      }
      var sameBase = lastBrowserUrl && stripHash(lastBrowserUrl) === stripHash(url);
      lastBrowserUrl = url;
      lastHistoryState = state;
      // Don't use history API if only the hash changed
      // due to a bug in IE10/IE11 which leads
      // to not firing a `hashchange` nor `popstate` event
      // in some cases (see #9143).
      if ($sniffer.history && (!sameBase || !sameState)) {
        history[replace ? 'replaceState' : 'pushState'](state, '', url);
        cacheState();
        // Do the assignment again so that those two variables are referentially identical.
        lastHistoryState = cachedState;
      } else {
        if (!sameBase) {
          pendingLocation = url;
        }
        if (replace) {
          location.replace(url);
        } else if (!sameBase) {
          location.href = url;
        } else {
          location.hash = getHash(url);
        }
        if (location.href !== url) {
          pendingLocation = url;
        }
      }
      if (pendingLocation) {
        pendingLocation = url;
      }
      return self;
    // getter
    } else {
      // - pendingLocation is needed as browsers don't allow to read out
      //   the new location.href if a reload happened or if there is a bug like in iOS 9 (see
      //   https://openradar.appspot.com/22186109).
      // - the replacement is a workaround for https://bugzilla.mozilla.org/show_bug.cgi?id=407172
      return pendingLocation || location.href.replace(/%27/g,"'");
    }
  };

  /**
   * @name $browser#state
   *
   * @description
   * This method is a getter.
   *
   * Return history.state or null if history.state is undefined.
   *
   * @returns {object} state
   */
  self.state = function() {
    return cachedState;
  };

  var urlChangeListeners = [],
      urlChangeInit = false;

  function cacheStateAndFireUrlChange() {
    pendingLocation = null;
    cacheState();
    fireUrlChange();
  }

  // This variable should be used *only* inside the cacheState function.
  var lastCachedState = null;
  function cacheState() {
    // This should be the only place in $browser where `history.state` is read.
    cachedState = getCurrentState();
    cachedState = isUndefined(cachedState) ? null : cachedState;

    // Prevent callbacks fo fire twice if both hashchange & popstate were fired.
    if (equals(cachedState, lastCachedState)) {
      cachedState = lastCachedState;
    }
    lastCachedState = cachedState;
  }

  function fireUrlChange() {
    if (lastBrowserUrl === self.url() && lastHistoryState === cachedState) {
      return;
    }

    lastBrowserUrl = self.url();
    lastHistoryState = cachedState;
    forEach(urlChangeListeners, function(listener) {
      listener(self.url(), cachedState);
    });
  }

  /**
   * @name $browser#onUrlChange
   *
   * @description
   * Register callback function that will be called, when url changes.
   *
   * It's only called when the url is changed from outside of angular:
   * - user types different url into address bar
   * - user clicks on history (forward/back) button
   * - user clicks on a link
   *
   * It's not called when url is changed by $browser.url() method
   *
   * The listener gets called with new url as parameter.
   *
   * NOTE: this api is intended for use only by the $location service. Please use the
   * {@link ng.$location $location service} to monitor url changes in angular apps.
   *
   * @param {function(string)} listener Listener function to be called when url changes.
   * @return {function(string)} Returns the registered listener fn - handy if the fn is anonymous.
   */
  self.onUrlChange = function(callback) {
    // TODO(vojta): refactor to use node's syntax for events
    if (!urlChangeInit) {
      // We listen on both (hashchange/popstate) when available, as some browsers (e.g. Opera)
      // don't fire popstate when user change the address bar and don't fire hashchange when url
      // changed by push/replaceState

      // html5 history api - popstate event
      if ($sniffer.history) jqLite(window).on('popstate', cacheStateAndFireUrlChange);
      // hashchange event
      jqLite(window).on('hashchange', cacheStateAndFireUrlChange);

      urlChangeInit = true;
    }

    urlChangeListeners.push(callback);
    return callback;
  };

  /**
   * @private
   * Remove popstate and hashchange handler from window.
   *
   * NOTE: this api is intended for use only by $rootScope.
   */
  self.$$applicationDestroyed = function() {
    jqLite(window).off('hashchange popstate', cacheStateAndFireUrlChange);
  };

  /**
   * Checks whether the url has changed outside of Angular.
   * Needs to be exported to be able to check for changes that have been done in sync,
   * as hashchange/popstate events fire in async.
   */
  self.$$checkUrlChange = fireUrlChange;

  //////////////////////////////////////////////////////////////
  // Misc API
  //////////////////////////////////////////////////////////////

  /**
   * @name $browser#baseHref
   *
   * @description
   * Returns current <base href>
   * (always relative - without domain)
   *
   * @returns {string} The current base href
   */
  self.baseHref = function() {
    var href = baseElement.attr('href');
    return href ? href.replace(/^(https?\:)?\/\/[^\/]*/, '') : '';
  };

  /**
   * @name $browser#defer
   * @param {function()} fn A function, who's execution should be deferred.
   * @param {number=} [delay=0] of milliseconds to defer the function execution.
   * @returns {*} DeferId that can be used to cancel the task via `$browser.defer.cancel()`.
   *
   * @description
   * Executes a fn asynchronously via `setTimeout(fn, delay)`.
   *
   * Unlike when calling `setTimeout` directly, in test this function is mocked and instead of using
   * `setTimeout` in tests, the fns are queued in an array, which can be programmatically flushed
   * via `$browser.defer.flush()`.
   *
   */
  self.defer = function(fn, delay) {
    var timeoutId;
    outstandingRequestCount++;
    timeoutId = setTimeout(function() {
      delete pendingDeferIds[timeoutId];
      completeOutstandingRequest(fn);
    }, delay || 0);
    pendingDeferIds[timeoutId] = true;
    return timeoutId;
  };


  /**
   * @name $browser#defer.cancel
   *
   * @description
   * Cancels a deferred task identified with `deferId`.
   *
   * @param {*} deferId Token returned by the `$browser.defer` function.
   * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
   *                    canceled.
   */
  self.defer.cancel = function(deferId) {
    if (pendingDeferIds[deferId]) {
      delete pendingDeferIds[deferId];
      clearTimeout(deferId);
      completeOutstandingRequest(noop);
      return true;
    }
    return false;
  };

}

function $BrowserProvider() {
  this.$get = ['$window', '$log', '$sniffer', '$document',
      function($window, $log, $sniffer, $document) {
        return new Browser($window, $document, $log, $sniffer);
      }];
}

/**
 * @ngdoc service
 * @name $cacheFactory
 *
 * @description
 * Factory that constructs {@link $cacheFactory.Cache Cache} objects and gives access to
 * them.
 *
 * ```js
 *
 *  var cache = $cacheFactory('cacheId');
 *  expect($cacheFactory.get('cacheId')).toBe(cache);
 *  expect($cacheFactory.get('noSuchCacheId')).not.toBeDefined();
 *
 *  cache.put("key", "value");
 *  cache.put("another key", "another value");
 *
 *  // We've specified no options on creation
 *  expect(cache.info()).toEqual({id: 'cacheId', size: 2});
 *
 * ```
 *
 *
 * @param {string} cacheId Name or id of the newly created cache.
 * @param {object=} options Options object that specifies the cache behavior. Properties:
 *
 *   - `{number=}` `capacity` — turns the cache into LRU cache.
 *
 * @returns {object} Newly created cache object with the following set of methods:
 *
 * - `{object}` `info()` — Returns id, size, and options of cache.
 * - `{{*}}` `put({string} key, {*} value)` — Puts a new key-value pair into the cache and returns
 *   it.
 * - `{{*}}` `get({string} key)` — Returns cached value for `key` or undefined for cache miss.
 * - `{void}` `remove({string} key)` — Removes a key-value pair from the cache.
 * - `{void}` `removeAll()` — Removes all cached values.
 * - `{void}` `destroy()` — Removes references to this cache from $cacheFactory.
 *
 * @example
   <example module="cacheExampleApp">
     <file name="index.html">
       <div ng-controller="CacheController">
         <input ng-model="newCacheKey" placeholder="Key">
         <input ng-model="newCacheValue" placeholder="Value">
         <button ng-click="put(newCacheKey, newCacheValue)">Cache</button>

         <p ng-if="keys.length">Cached Values</p>
         <div ng-repeat="key in keys">
           <span ng-bind="key"></span>
           <span>: </span>
           <b ng-bind="cache.get(key)"></b>
         </div>

         <p>Cache Info</p>
         <div ng-repeat="(key, value) in cache.info()">
           <span ng-bind="key"></span>
           <span>: </span>
           <b ng-bind="value"></b>
         </div>
       </div>
     </file>
     <file name="script.js">
       angular.module('cacheExampleApp', []).
         controller('CacheController', ['$scope', '$cacheFactory', function($scope, $cacheFactory) {
           $scope.keys = [];
           $scope.cache = $cacheFactory('cacheId');
           $scope.put = function(key, value) {
             if (angular.isUndefined($scope.cache.get(key))) {
               $scope.keys.push(key);
             }
             $scope.cache.put(key, angular.isUndefined(value) ? null : value);
           };
         }]);
     </file>
     <file name="style.css">
       p {
         margin: 10px 0 3px;
       }
     </file>
   </example>
 */
function $CacheFactoryProvider() {

  this.$get = function() {
    var caches = {};

    function cacheFactory(cacheId, options) {
      if (cacheId in caches) {
        throw minErr('$cacheFactory')('iid', "CacheId '{0}' is already taken!", cacheId);
      }

      var size = 0,
          stats = extend({}, options, {id: cacheId}),
          data = createMap(),
          capacity = (options && options.capacity) || Number.MAX_VALUE,
          lruHash = createMap(),
          freshEnd = null,
          staleEnd = null;

      /**
       * @ngdoc type
       * @name $cacheFactory.Cache
       *
       * @description
       * A cache object used to store and retrieve data, primarily used by
       * {@link $http $http} and the {@link ng.directive:script script} directive to cache
       * templates and other data.
       *
       * ```js
       *  angular.module('superCache')
       *    .factory('superCache', ['$cacheFactory', function($cacheFactory) {
       *      return $cacheFactory('super-cache');
       *    }]);
       * ```
       *
       * Example test:
       *
       * ```js
       *  it('should behave like a cache', inject(function(superCache) {
       *    superCache.put('key', 'value');
       *    superCache.put('another key', 'another value');
       *
       *    expect(superCache.info()).toEqual({
       *      id: 'super-cache',
       *      size: 2
       *    });
       *
       *    superCache.remove('another key');
       *    expect(superCache.get('another key')).toBeUndefined();
       *
       *    superCache.removeAll();
       *    expect(superCache.info()).toEqual({
       *      id: 'super-cache',
       *      size: 0
       *    });
       *  }));
       * ```
       */
      return caches[cacheId] = {

        /**
         * @ngdoc method
         * @name $cacheFactory.Cache#put
         * @kind function
         *
         * @description
         * Inserts a named entry into the {@link $cacheFactory.Cache Cache} object to be
         * retrieved later, and incrementing the size of the cache if the key was not already
         * present in the cache. If behaving like an LRU cache, it will also remove stale
         * entries from the set.
         *
         * It will not insert undefined values into the cache.
         *
         * @param {string} key the key under which the cached data is stored.
         * @param {*} value the value to store alongside the key. If it is undefined, the key
         *    will not be stored.
         * @returns {*} the value stored.
         */
        put: function(key, value) {
          if (isUndefined(value)) return;
          if (capacity < Number.MAX_VALUE) {
            var lruEntry = lruHash[key] || (lruHash[key] = {key: key});

            refresh(lruEntry);
          }

          if (!(key in data)) size++;
          data[key] = value;

          if (size > capacity) {
            this.remove(staleEnd.key);
          }

          return value;
        },

        /**
         * @ngdoc method
         * @name $cacheFactory.Cache#get
         * @kind function
         *
         * @description
         * Retrieves named data stored in the {@link $cacheFactory.Cache Cache} object.
         *
         * @param {string} key the key of the data to be retrieved
         * @returns {*} the value stored.
         */
        get: function(key) {
          if (capacity < Number.MAX_VALUE) {
            var lruEntry = lruHash[key];

            if (!lruEntry) return;

            refresh(lruEntry);
          }

          return data[key];
        },


        /**
         * @ngdoc method
         * @name $cacheFactory.Cache#remove
         * @kind function
         *
         * @description
         * Removes an entry from the {@link $cacheFactory.Cache Cache} object.
         *
         * @param {string} key the key of the entry to be removed
         */
        remove: function(key) {
          if (capacity < Number.MAX_VALUE) {
            var lruEntry = lruHash[key];

            if (!lruEntry) return;

            if (lruEntry == freshEnd) freshEnd = lruEntry.p;
            if (lruEntry == staleEnd) staleEnd = lruEntry.n;
            link(lruEntry.n,lruEntry.p);

            delete lruHash[key];
          }

          if (!(key in data)) return;

          delete data[key];
          size--;
        },


        /**
         * @ngdoc method
         * @name $cacheFactory.Cache#removeAll
         * @kind function
         *
         * @description
         * Clears the cache object of any entries.
         */
        removeAll: function() {
          data = createMap();
          size = 0;
          lruHash = createMap();
          freshEnd = staleEnd = null;
        },


        /**
         * @ngdoc method
         * @name $cacheFactory.Cache#destroy
         * @kind function
         *
         * @description
         * Destroys the {@link $cacheFactory.Cache Cache} object entirely,
         * removing it from the {@link $cacheFactory $cacheFactory} set.
         */
        destroy: function() {
          data = null;
          stats = null;
          lruHash = null;
          delete caches[cacheId];
        },


        /**
         * @ngdoc method
         * @name $cacheFactory.Cache#info
         * @kind function
         *
         * @description
         * Retrieve information regarding a particular {@link $cacheFactory.Cache Cache}.
         *
         * @returns {object} an object with the following properties:
         *   <ul>
         *     <li>**id**: the id of the cache instance</li>
         *     <li>**size**: the number of entries kept in the cache instance</li>
         *     <li>**...**: any additional properties from the options object when creating the
         *       cache.</li>
         *   </ul>
         */
        info: function() {
          return extend({}, stats, {size: size});
        }
      };


      /**
       * makes the `entry` the freshEnd of the LRU linked list
       */
      function refresh(entry) {
        if (entry != freshEnd) {
          if (!staleEnd) {
            staleEnd = entry;
          } else if (staleEnd == entry) {
            staleEnd = entry.n;
          }

          link(entry.n, entry.p);
          link(entry, freshEnd);
          freshEnd = entry;
          freshEnd.n = null;
        }
      }


      /**
       * bidirectionally links two entries of the LRU linked list
       */
      function link(nextEntry, prevEntry) {
        if (nextEntry != prevEntry) {
          if (nextEntry) nextEntry.p = prevEntry; //p stands for previous, 'prev' didn't minify
          if (prevEntry) prevEntry.n = nextEntry; //n stands for next, 'next' didn't minify
        }
      }
    }


  /**
   * @ngdoc method
   * @name $cacheFactory#info
   *
   * @description
   * Get information about all the caches that have been created
   *
   * @returns {Object} - key-value map of `cacheId` to the result of calling `cache#info`
   */
    cacheFactory.info = function() {
      var info = {};
      forEach(caches, function(cache, cacheId) {
        info[cacheId] = cache.info();
      });
      return info;
    };


  /**
   * @ngdoc method
   * @name $cacheFactory#get
   *
   * @description
   * Get access to a cache object by the `cacheId` used when it was created.
   *
   * @param {string} cacheId Name or id of a cache to access.
   * @returns {object} Cache object identified by the cacheId or undefined if no such cache.
   */
    cacheFactory.get = function(cacheId) {
      return caches[cacheId];
    };


    return cacheFactory;
  };
}

/**
 * @ngdoc service
 * @name $templateCache
 *
 * @description
 * The first time a template is used, it is loaded in the template cache for quick retrieval. You
 * can load templates directly into the cache in a `script` tag, or by consuming the
 * `$templateCache` service directly.
 *
 * Adding via the `script` tag:
 *
 * ```html
 *   <script type="text/ng-template" id="templateId.html">
 *     <p>This is the content of the template</p>
 *   </script>
 * ```
 *
 * **Note:** the `script` tag containing the template does not need to be included in the `head` of
 * the document, but it must be a descendent of the {@link ng.$rootElement $rootElement} (IE,
 * element with ng-app attribute), otherwise the template will be ignored.
 *
 * Adding via the `$templateCache` service:
 *
 * ```js
 * var myApp = angular.module('myApp', []);
 * myApp.run(function($templateCache) {
 *   $templateCache.put('templateId.html', 'This is the content of the template');
 * });
 * ```
 *
 * To retrieve the template later, simply use it in your HTML:
 * ```html
 * <div ng-include=" 'templateId.html' "></div>
 * ```
 *
 * or get it via Javascript:
 * ```js
 * $templateCache.get('templateId.html')
 * ```
 *
 * See {@link ng.$cacheFactory $cacheFactory}.
 *
 */
function $TemplateCacheProvider() {
  this.$get = ['$cacheFactory', function($cacheFactory) {
    return $cacheFactory('templates');
  }];
}

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *     Any commits to this file should be reviewed with security in mind.  *
 *   Changes to this file can potentially create security vulnerabilities. *
 *          An approval from 2 Core members with history of modifying      *
 *                         this file is required.                          *
 *                                                                         *
 *  Does the change somehow allow for arbitrary javascript to be executed? *
 *    Or allows for someone to change the prototype of built-in objects?   *
 *     Or gives undesired access to variables likes document or window?    *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

/* ! VARIABLE/FUNCTION NAMING CONVENTIONS THAT APPLY TO THIS FILE!
 *
 * DOM-related variables:
 *
 * - "node" - DOM Node
 * - "element" - DOM Element or Node
 * - "$node" or "$element" - jqLite-wrapped node or element
 *
 *
 * Compiler related stuff:
 *
 * - "linkFn" - linking fn of a single directive
 * - "nodeLinkFn" - function that aggregates all linking fns for a particular node
 * - "childLinkFn" -  function that aggregates all linking fns for child nodes of a particular node
 * - "compositeLinkFn" - function that aggregates all linking fns for a compilation root (nodeList)
 */


/**
 * @ngdoc service
 * @name $compile
 * @kind function
 *
 * @description
 * Compiles an HTML string or DOM into a template and produces a template function, which
 * can then be used to link {@link ng.$rootScope.Scope `scope`} and the template together.
 *
 * The compilation is a process of walking the DOM tree and matching DOM elements to
 * {@link ng.$compileProvider#directive directives}.
 *
 * <div class="alert alert-warning">
 * **Note:** This document is an in-depth reference of all directive options.
 * For a gentle introduction to directives with examples of common use cases,
 * see the {@link guide/directive directive guide}.
 * </div>
 *
 * ## Comprehensive Directive API
 *
 * There are many different options for a directive.
 *
 * The difference resides in the return value of the factory function.
 * You can either return a {@link $compile#directive-definition-object Directive Definition Object (see below)}
 * that defines the directive properties, or just the `postLink` function (all other properties will have
 * the default values).
 *
 * <div class="alert alert-success">
 * **Best Practice:** It's recommended to use the "directive definition object" form.
 * </div>
 *
 * Here's an example directive declared with a Directive Definition Object:
 *
 * ```js
 *   var myModule = angular.module(...);
 *
 *   myModule.directive('directiveName', function factory(injectables) {
 *     var directiveDefinitionObject = {
 *       priority: 0,
 *       template: '<div></div>', // or // function(tElement, tAttrs) { ... },
 *       // or
 *       // templateUrl: 'directive.html', // or // function(tElement, tAttrs) { ... },
 *       transclude: false,
 *       restrict: 'A',
 *       templateNamespace: 'html',
 *       scope: false,
 *       controller: function($scope, $element, $attrs, $transclude, otherInjectables) { ... },
 *       controllerAs: 'stringIdentifier',
 *       bindToController: false,
 *       require: 'siblingDirectiveName', // or // ['^parentDirectiveName', '?optionalDirectiveName', '?^optionalParent'],
 *       compile: function compile(tElement, tAttrs, transclude) {
 *         return {
 *           pre: function preLink(scope, iElement, iAttrs, controller) { ... },
 *           post: function postLink(scope, iElement, iAttrs, controller) { ... }
 *         }
 *         // or
 *         // return function postLink( ... ) { ... }
 *       },
 *       // or
 *       // link: {
 *       //  pre: function preLink(scope, iElement, iAttrs, controller) { ... },
 *       //  post: function postLink(scope, iElement, iAttrs, controller) { ... }
 *       // }
 *       // or
 *       // link: function postLink( ... ) { ... }
 *     };
 *     return directiveDefinitionObject;
 *   });
 * ```
 *
 * <div class="alert alert-warning">
 * **Note:** Any unspecified options will use the default value. You can see the default values below.
 * </div>
 *
 * Therefore the above can be simplified as:
 *
 * ```js
 *   var myModule = angular.module(...);
 *
 *   myModule.directive('directiveName', function factory(injectables) {
 *     var directiveDefinitionObject = {
 *       link: function postLink(scope, iElement, iAttrs) { ... }
 *     };
 *     return directiveDefinitionObject;
 *     // or
 *     // return function postLink(scope, iElement, iAttrs) { ... }
 *   });
 * ```
 *
 * ### Life-cycle hooks
 * Directive controllers can provide the following methods that are called by Angular at points in the life-cycle of the
 * directive:
 * * `$onInit()` - Called on each controller after all the controllers on an element have been constructed and
 *   had their bindings initialized (and before the pre &amp; post linking functions for the directives on
 *   this element). This is a good place to put initialization code for your controller.
 * * `$onChanges(changesObj)` - Called whenever one-way (`<`) or interpolation (`@`) bindings are updated. The
 *   `changesObj` is a hash whose keys are the names of the bound properties that have changed, and the values are an
 *   object of the form `{ currentValue, previousValue, isFirstChange() }`. Use this hook to trigger updates within a
 *   component such as cloning the bound value to prevent accidental mutation of the outer value.
 * * `$doCheck()` - Called on each turn of the digest cycle. Provides an opportunity to detect and act on
 *   changes. Any actions that you wish to take in response to the changes that you detect must be
 *   invoked from this hook; implementing this has no effect on when `$onChanges` is called. For example, this hook
 *   could be useful if you wish to perform a deep equality check, or to check a Date object, changes to which would not
 *   be detected by Angular's change detector and thus not trigger `$onChanges`. This hook is invoked with no arguments;
 *   if detecting changes, you must store the previous value(s) for comparison to the current values.
 * * `$onDestroy()` - Called on a controller when its containing scope is destroyed. Use this hook for releasing
 *   external resources, watches and event handlers. Note that components have their `$onDestroy()` hooks called in
 *   the same order as the `$scope.$broadcast` events are triggered, which is top down. This means that parent
 *   components will have their `$onDestroy()` hook called before child components.
 * * `$postLink()` - Called after this controller's element and its children have been linked. Similar to the post-link
 *   function this hook can be used to set up DOM event handlers and do direct DOM manipulation.
 *   Note that child elements that contain `templateUrl` directives will not have been compiled and linked since
 *   they are waiting for their template to load asynchronously and their own compilation and linking has been
 *   suspended until that occurs.
 *
 * #### Comparison with Angular 2 life-cycle hooks
 * Angular 2 also uses life-cycle hooks for its components. While the Angular 1 life-cycle hooks are similar there are
 * some differences that you should be aware of, especially when it comes to moving your code from Angular 1 to Angular 2:
 *
 * * Angular 1 hooks are prefixed with `$`, such as `$onInit`. Angular 2 hooks are prefixed with `ng`, such as `ngOnInit`.
 * * Angular 1 hooks can be defined on the controller prototype or added to the controller inside its constructor.
 *   In Angular 2 you can only define hooks on the prototype of the Component class.
 * * Due to the differences in change-detection, you may get many more calls to `$doCheck` in Angular 1 than you would to
 *   `ngDoCheck` in Angular 2
 * * Changes to the model inside `$doCheck` will trigger new turns of the digest loop, which will cause the changes to be
 *   propagated throughout the application.
 *   Angular 2 does not allow the `ngDoCheck` hook to trigger a change outside of the component. It will either throw an
 *   error or do nothing depending upon the state of `enableProdMode()`.
 *
 * #### Life-cycle hook examples
 *
 * This example shows how you can check for mutations to a Date object even though the identity of the object
 * has not changed.
 *
 * <example name="doCheckDateExample" module="do-check-module">
 *   <file name="app.js">
 *     angular.module('do-check-module', [])
 *       .component('app', {
 *         template:
 *           'Month: <input ng-model="$ctrl.month" ng-change="$ctrl.updateDate()">' +
 *           'Date: {{ $ctrl.date }}' +
 *           '<test date="$ctrl.date"></test>',
 *         controller: function() {
 *           this.date = new Date();
 *           this.month = this.date.getMonth();
 *           this.updateDate = function() {
 *             this.date.setMonth(this.month);
 *           };
 *         }
 *       })
 *       .component('test', {
 *         bindings: { date: '<' },
 *         template:
 *           '<pre>{{ $ctrl.log | json }}</pre>',
 *         controller: function() {
 *           var previousValue;
 *           this.log = [];
 *           this.$doCheck = function() {
 *             var currentValue = this.date && this.date.valueOf();
 *             if (previousValue !== currentValue) {
 *               this.log.push('doCheck: date mutated: ' + this.date);
 *               previousValue = currentValue;
 *             }
 *           };
 *         }
 *       });
 *   </file>
 *   <file name="index.html">
 *     <app></app>
 *   </file>
 * </example>
 *
 * This example show how you might use `$doCheck` to trigger changes in your component's inputs even if the
 * actual identity of the component doesn't change. (Be aware that cloning and deep equality checks on large
 * arrays or objects can have a negative impact on your application performance)
 *
 * <example name="doCheckArrayExample" module="do-check-module">
 *   <file name="index.html">
 *     <div ng-init="items = []">
 *       <button ng-click="items.push(items.length)">Add Item</button>
 *       <button ng-click="items = []">Reset Items</button>
 *       <pre>{{ items }}</pre>
 *       <test items="items"></test>
 *     </div>
 *   </file>
 *   <file name="app.js">
 *      angular.module('do-check-module', [])
 *        .component('test', {
 *          bindings: { items: '<' },
 *          template:
 *            '<pre>{{ $ctrl.log | json }}</pre>',
 *          controller: function() {
 *            this.log = [];
 *
 *            this.$doCheck = function() {
 *              if (this.items_ref !== this.items) {
 *                this.log.push('doCheck: items changed');
 *                this.items_ref = this.items;
 *              }
 *              if (!angular.equals(this.items_clone, this.items)) {
 *                this.log.push('doCheck: items mutated');
 *                this.items_clone = angular.copy(this.items);
 *              }
 *            };
 *          }
 *        });
 *   </file>
 * </example>
 *
 *
 * ### Directive Definition Object
 *
 * The directive definition object provides instructions to the {@link ng.$compile
 * compiler}. The attributes are:
 *
 * #### `multiElement`
 * When this property is set to true, the HTML compiler will collect DOM nodes between
 * nodes with the attributes `directive-name-start` and `directive-name-end`, and group them
 * together as the directive elements. It is recommended that this feature be used on directives
 * which are not strictly behavioral (such as {@link ngClick}), and which
 * do not manipulate or replace child nodes (such as {@link ngInclude}).
 *
 * #### `priority`
 * When there are multiple directives defined on a single DOM element, sometimes it
 * is necessary to specify the order in which the directives are applied. The `priority` is used
 * to sort the directives before their `compile` functions get called. Priority is defined as a
 * number. Directives with greater numerical `priority` are compiled first. Pre-link functions
 * are also run in priority order, but post-link functions are run in reverse order. The order
 * of directives with the same priority is undefined. The default priority is `0`.
 *
 * #### `terminal`
 * If set to true then the current `priority` will be the last set of directives
 * which will execute (any directives at the current priority will still execute
 * as the order of execution on same `priority` is undefined). Note that expressions
 * and other directives used in the directive's template will also be excluded from execution.
 *
 * #### `scope`
 * The scope property can be `true`, an object or a falsy value:
 *
 * * **falsy:** No scope will be created for the directive. The directive will use its parent's scope.
 *
 * * **`true`:** A new child scope that prototypically inherits from its parent will be created for
 * the directive's element. If multiple directives on the same element request a new scope,
 * only one new scope is created. The new scope rule does not apply for the root of the template
 * since the root of the template always gets a new scope.
 *
 * * **`{...}` (an object hash):** A new "isolate" scope is created for the directive's element. The
 * 'isolate' scope differs from normal scope in that it does not prototypically inherit from its parent
 * scope. This is useful when creating reusable components, which should not accidentally read or modify
 * data in the parent scope.
 *
 * The 'isolate' scope object hash defines a set of local scope properties derived from attributes on the
 * directive's element. These local properties are useful for aliasing values for templates. The keys in
 * the object hash map to the name of the property on the isolate scope; the values define how the property
 * is bound to the parent scope, via matching attributes on the directive's element:
 *
 * * `@` or `@attr` - bind a local scope property to the value of DOM attribute. The result is
 *   always a string since DOM attributes are strings. If no `attr` name is specified then the
 *   attribute name is assumed to be the same as the local name. Given `<my-component
 *   my-attr="hello {{name}}">` and the isolate scope definition `scope: { localName:'@myAttr' }`,
 *   the directive's scope property `localName` will reflect the interpolated value of `hello
 *   {{name}}`. As the `name` attribute changes so will the `localName` property on the directive's
 *   scope. The `name` is read from the parent scope (not the directive's scope).
 *
 * * `=` or `=attr` - set up a bidirectional binding between a local scope property and an expression
 *   passed via the attribute `attr`. The expression is evaluated in the context of the parent scope.
 *   If no `attr` name is specified then the attribute name is assumed to be the same as the local
 *   name. Given `<my-component my-attr="parentModel">` and the isolate scope definition `scope: {
 *   localModel: '=myAttr' }`, the property `localModel` on the directive's scope will reflect the
 *   value of `parentModel` on the parent scope. Changes to `parentModel` will be reflected in
 *   `localModel` and vice versa. Optional attributes should be marked as such with a question mark:
 *   `=?` or `=?attr`. If the binding expression is non-assignable, or if the attribute isn't
 *   optional and doesn't exist, an exception ({@link error/$compile/nonassign `$compile:nonassign`})
 *   will be thrown upon discovering changes to the local value, since it will be impossible to sync
 *   them back to the parent scope. By default, the {@link ng.$rootScope.Scope#$watch `$watch`}
 *   method is used for tracking changes, and the equality check is based on object identity.
 *   However, if an object literal or an array literal is passed as the binding expression, the
 *   equality check is done by value (using the {@link angular.equals} function). It's also possible
 *   to watch the evaluated value shallowly with {@link ng.$rootScope.Scope#$watchCollection
 *   `$watchCollection`}: use `=*` or `=*attr` (`=*?` or `=*?attr` if the attribute is optional).
 *
  * * `<` or `<attr` - set up a one-way (one-directional) binding between a local scope property and an
 *   expression passed via the attribute `attr`. The expression is evaluated in the context of the
 *   parent scope. If no `attr` name is specified then the attribute name is assumed to be the same as the
 *   local name. You can also make the binding optional by adding `?`: `<?` or `<?attr`.
 *
 *   For example, given `<my-component my-attr="parentModel">` and directive definition of
 *   `scope: { localModel:'<myAttr' }`, then the isolated scope property `localModel` will reflect the
 *   value of `parentModel` on the parent scope. Any changes to `parentModel` will be reflected
 *   in `localModel`, but changes in `localModel` will not reflect in `parentModel`. There are however
 *   two caveats:
 *     1. one-way binding does not copy the value from the parent to the isolate scope, it simply
 *     sets the same value. That means if your bound value is an object, changes to its properties
 *     in the isolated scope will be reflected in the parent scope (because both reference the same object).
 *     2. one-way binding watches changes to the **identity** of the parent value. That means the
 *     {@link ng.$rootScope.Scope#$watch `$watch`} on the parent value only fires if the reference
 *     to the value has changed. In most cases, this should not be of concern, but can be important
 *     to know if you one-way bind to an object, and then replace that object in the isolated scope.
 *     If you now change a property of the object in your parent scope, the change will not be
 *     propagated to the isolated scope, because the identity of the object on the parent scope
 *     has not changed. Instead you must assign a new object.
 *
 *   One-way binding is useful if you do not plan to propagate changes to your isolated scope bindings
 *   back to the parent. However, it does not make this completely impossible.
 *
 * * `&` or `&attr` - provides a way to execute an expression in the context of the parent scope. If
 *   no `attr` name is specified then the attribute name is assumed to be the same as the local name.
 *   Given `<my-component my-attr="count = count + value">` and the isolate scope definition `scope: {
 *   localFn:'&myAttr' }`, the isolate scope property `localFn` will point to a function wrapper for
 *   the `count = count + value` expression. Often it's desirable to pass data from the isolated scope
 *   via an expression to the parent scope. This can be done by passing a map of local variable names
 *   and values into the expression wrapper fn. For example, if the expression is `increment(amount)`
 *   then we can specify the amount value by calling the `localFn` as `localFn({amount: 22})`.
 *
 * In general it's possible to apply more than one directive to one element, but there might be limitations
 * depending on the type of scope required by the directives. The following points will help explain these limitations.
 * For simplicity only two directives are taken into account, but it is also applicable for several directives:
 *
 * * **no scope** + **no scope** => Two directives which don't require their own scope will use their parent's scope
 * * **child scope** + **no scope** =>  Both directives will share one single child scope
 * * **child scope** + **child scope** =>  Both directives will share one single child scope
 * * **isolated scope** + **no scope** =>  The isolated directive will use it's own created isolated scope. The other directive will use
 * its parent's scope
 * * **isolated scope** + **child scope** =>  **Won't work!** Only one scope can be related to one element. Therefore these directives cannot
 * be applied to the same element.
 * * **isolated scope** + **isolated scope**  =>  **Won't work!** Only one scope can be related to one element. Therefore these directives
 * cannot be applied to the same element.
 *
 *
 * #### `bindToController`
 * This property is used to bind scope properties directly to the controller. It can be either
 * `true` or an object hash with the same format as the `scope` property. Additionally, a controller
 * alias must be set, either by using `controllerAs: 'myAlias'` or by specifying the alias in the controller
 * definition: `controller: 'myCtrl as myAlias'`.
 *
 * When an isolate scope is used for a directive (see above), `bindToController: true` will
 * allow a component to have its properties bound to the controller, rather than to scope.
 *
 * After the controller is instantiated, the initial values of the isolate scope bindings will be bound to the controller
 * properties. You can access these bindings once they have been initialized by providing a controller method called
 * `$onInit`, which is called after all the controllers on an element have been constructed and had their bindings
 * initialized.
 *
 * <div class="alert alert-warning">
 * **Deprecation warning:** although bindings for non-ES6 class controllers are currently
 * bound to `this` before the controller constructor is called, this use is now deprecated. Please place initialization
 * code that relies upon bindings inside a `$onInit` method on the controller, instead.
 * </div>
 *
 * It is also possible to set `bindToController` to an object hash with the same format as the `scope` property.
 * This will set up the scope bindings to the controller directly. Note that `scope` can still be used
 * to define which kind of scope is created. By default, no scope is created. Use `scope: {}` to create an isolate
 * scope (useful for component directives).
 *
 * If both `bindToController` and `scope` are defined and have object hashes, `bindToController` overrides `scope`.
 *
 *
 * #### `controller`
 * Controller constructor function. The controller is instantiated before the
 * pre-linking phase and can be accessed by other directives (see
 * `require` attribute). This allows the directives to communicate with each other and augment
 * each other's behavior. The controller is injectable (and supports bracket notation) with the following locals:
 *
 * * `$scope` - Current scope associated with the element
 * * `$element` - Current element
 * * `$attrs` - Current attributes object for the element
 * * `$transclude` - A transclude linking function pre-bound to the correct transclusion scope:
 *   `function([scope], cloneLinkingFn, futureParentElement, slotName)`:
 *    * `scope`: (optional) override the scope.
 *    * `cloneLinkingFn`: (optional) argument to create clones of the original transcluded content.
 *    * `futureParentElement` (optional):
 *        * defines the parent to which the `cloneLinkingFn` will add the cloned elements.
 *        * default: `$element.parent()` resp. `$element` for `transclude:'element'` resp. `transclude:true`.
 *        * only needed for transcludes that are allowed to contain non html elements (e.g. SVG elements)
 *          and when the `cloneLinkinFn` is passed,
 *          as those elements need to created and cloned in a special way when they are defined outside their
 *          usual containers (e.g. like `<svg>`).
 *        * See also the `directive.templateNamespace` property.
 *    * `slotName`: (optional) the name of the slot to transclude. If falsy (e.g. `null`, `undefined` or `''`)
 *      then the default translusion is provided.
 *    The `$transclude` function also has a method on it, `$transclude.isSlotFilled(slotName)`, which returns
 *    `true` if the specified slot contains content (i.e. one or more DOM nodes).
 *
 * #### `require`
 * Require another directive and inject its controller as the fourth argument to the linking function. The
 * `require` property can be a string, an array or an object:
 * * a **string** containing the name of the directive to pass to the linking function
 * * an **array** containing the names of directives to pass to the linking function. The argument passed to the
 * linking function will be an array of controllers in the same order as the names in the `require` property
 * * an **object** whose property values are the names of the directives to pass to the linking function. The argument
 * passed to the linking function will also be an object with matching keys, whose values will hold the corresponding
 * controllers.
 *
 * If the `require` property is an object and `bindToController` is truthy, then the required controllers are
 * bound to the controller using the keys of the `require` property. This binding occurs after all the controllers
 * have been constructed but before `$onInit` is called.
 * If the name of the required controller is the same as the local name (the key), the name can be
 * omitted. For example, `{parentDir: '^^'}` is equivalent to `{parentDir: '^^parentDir'}`.
 * See the {@link $compileProvider#component} helper for an example of how this can be used.
 * If no such required directive(s) can be found, or if the directive does not have a controller, then an error is
 * raised (unless no link function is specified and the required controllers are not being bound to the directive
 * controller, in which case error checking is skipped). The name can be prefixed with:
 *
 * * (no prefix) - Locate the required controller on the current element. Throw an error if not found.
 * * `?` - Attempt to locate the required controller or pass `null` to the `link` fn if not found.
 * * `^` - Locate the required controller by searching the element and its parents. Throw an error if not found.
 * * `^^` - Locate the required controller by searching the element's parents. Throw an error if not found.
 * * `?^` - Attempt to locate the required controller by searching the element and its parents or pass
 *   `null` to the `link` fn if not found.
 * * `?^^` - Attempt to locate the required controller by searching the element's parents, or pass
 *   `null` to the `link` fn if not found.
 *
 *
 * #### `controllerAs`
 * Identifier name for a reference to the controller in the directive's scope.
 * This allows the controller to be referenced from the directive template. This is especially
 * useful when a directive is used as component, i.e. with an `isolate` scope. It's also possible
 * to use it in a directive without an `isolate` / `new` scope, but you need to be aware that the
 * `controllerAs` reference might overwrite a property that already exists on the parent scope.
 *
 *
 * #### `restrict`
 * String of subset of `EACM` which restricts the directive to a specific directive
 * declaration style. If omitted, the defaults (elements and attributes) are used.
 *
 * * `E` - Element name (default): `<my-directive></my-directive>`
 * * `A` - Attribute (default): `<div my-directive="exp"></div>`
 * * `C` - Class: `<div class="my-directive: exp;"></div>`
 * * `M` - Comment: `<!-- directive: my-directive exp -->`
 *
 *
 * #### `templateNamespace`
 * String representing the document type used by the markup in the template.
 * AngularJS needs this information as those elements need to be created and cloned
 * in a special way when they are defined outside their usual containers like `<svg>` and `<math>`.
 *
 * * `html` - All root nodes in the template are HTML. Root nodes may also be
 *   top-level elements such as `<svg>` or `<math>`.
 * * `svg` - The root nodes in the template are SVG elements (excluding `<math>`).
 * * `math` - The root nodes in the template are MathML elements (excluding `<svg>`).
 *
 * If no `templateNamespace` is specified, then the namespace is considered to be `html`.
 *
 * #### `template`
 * HTML markup that may:
 * * Replace the contents of the directive's element (default).
 * * Replace the directive's element itself (if `replace` is true - DEPRECATED).
 * * Wrap the contents of the directive's element (if `transclude` is true).
 *
 * Value may be:
 *
 * * A string. For example `<div red-on-hover>{{delete_str}}</div>`.
 * * A function which takes two arguments `tElement` and `tAttrs` (described in the `compile`
 *   function api below) and returns a string value.
 *
 *
 * #### `templateUrl`
 * This is similar to `template` but the template is loaded from the specified URL, asynchronously.
 *
 * Because template loading is asynchronous the compiler will suspend compilation of directives on that element
 * for later when the template has been resolved.  In the meantime it will continue to compile and link
 * sibling and parent elements as though this element had not contained any directives.
 *
 * The compiler does not suspend the entire compilation to wait for templates to be loaded because this
 * would result in the whole app "stalling" until all templates are loaded asynchronously - even in the
 * case when only one deeply nested directive has `templateUrl`.
 *
 * Template loading is asynchronous even if the template has been preloaded into the {@link $templateCache}
 *
 * You can specify `templateUrl` as a string representing the URL or as a function which takes two
 * arguments `tElement` and `tAttrs` (described in the `compile` function api below) and returns
 * a string value representing the url.  In either case, the template URL is passed through {@link
 * $sce#getTrustedResourceUrl $sce.getTrustedResourceUrl}.
 *
 *
 * #### `replace` ([*DEPRECATED*!], will be removed in next major release - i.e. v2.0)
 * specify what the template should replace. Defaults to `false`.
 *
 * * `true` - the template will replace the directive's element.
 * * `false` - the template will replace the contents of the directive's element.
 *
 * The replacement process migrates all of the attributes / classes from the old element to the new
 * one. See the {@link guide/directive#template-expanding-directive
 * Directives Guide} for an example.
 *
 * There are very few scenarios where element replacement is required for the application function,
 * the main one being reusable custom components that are used within SVG contexts
 * (because SVG doesn't work with custom elements in the DOM tree).
 *
 * #### `transclude`
 * Extract the contents of the element where the directive appears and make it available to the directive.
 * The contents are compiled and provided to the directive as a **transclusion function**. See the
 * {@link $compile#transclusion Transclusion} section below.
 *
 *
 * #### `compile`
 *
 * ```js
 *   function compile(tElement, tAttrs, transclude) { ... }
 * ```
 *
 * The compile function deals with transforming the template DOM. Since most directives do not do
 * template transformation, it is not used often. The compile function takes the following arguments:
 *
 *   * `tElement` - template element - The element where the directive has been declared. It is
 *     safe to do template transformation on the element and child elements only.
 *
 *   * `tAttrs` - template attributes - Normalized list of attributes declared on this element shared
 *     between all directive compile functions.
 *
 *   * `transclude` -  [*DEPRECATED*!] A transclude linking function: `function(scope, cloneLinkingFn)`
 *
 * <div class="alert alert-warning">
 * **Note:** The template instance and the link instance may be different objects if the template has
 * been cloned. For this reason it is **not** safe to do anything other than DOM transformations that
 * apply to all cloned DOM nodes within the compile function. Specifically, DOM listener registration
 * should be done in a linking function rather than in a compile function.
 * </div>

 * <div class="alert alert-warning">
 * **Note:** The compile function cannot handle directives that recursively use themselves in their
 * own templates or compile functions. Compiling these directives results in an infinite loop and
 * stack overflow errors.
 *
 * This can be avoided by manually using $compile in the postLink function to imperatively compile
 * a directive's template instead of relying on automatic template compilation via `template` or
 * `templateUrl` declaration or manual compilation inside the compile function.
 * </div>
 *
 * <div class="alert alert-danger">
 * **Note:** The `transclude` function that is passed to the compile function is deprecated, as it
 *   e.g. does not know about the right outer scope. Please use the transclude function that is passed
 *   to the link function instead.
 * </div>

 * A compile function can have a return value which can be either a function or an object.
 *
 * * returning a (post-link) function - is equivalent to registering the linking function via the
 *   `link` property of the config object when the compile function is empty.
 *
 * * returning an object with function(s) registered via `pre` and `post` properties - allows you to
 *   control when a linking function should be called during the linking phase. See info about
 *   pre-linking and post-linking functions below.
 *
 *
 * #### `link`
 * This property is used only if the `compile` property is not defined.
 *
 * ```js
 *   function link(scope, iElement, iAttrs, controller, transcludeFn) { ... }
 * ```
 *
 * The link function is responsible for registering DOM listeners as well as updating the DOM. It is
 * executed after the template has been cloned. This is where most of the directive logic will be
 * put.
 *
 *   * `scope` - {@link ng.$rootScope.Scope Scope} - The scope to be used by the
 *     directive for registering {@link ng.$rootScope.Scope#$watch watches}.
 *
 *   * `iElement` - instance element - The element where the directive is to be used. It is safe to
 *     manipulate the children of the element only in `postLink` function since the children have
 *     already been linked.
 *
 *   * `iAttrs` - instance attributes - Normalized list of attributes declared on this element shared
 *     between all directive linking functions.
 *
 *   * `controller` - the directive's required controller instance(s) - Instances are shared
 *     among all directives, which allows the directives to use the controllers as a communication
 *     channel. The exact value depends on the directive's `require` property:
 *       * no controller(s) required: the directive's own controller, or `undefined` if it doesn't have one
 *       * `string`: the controller instance
 *       * `array`: array of controller instances
 *
 *     If a required controller cannot be found, and it is optional, the instance is `null`,
 *     otherwise the {@link error:$compile:ctreq Missing Required Controller} error is thrown.
 *
 *     Note that you can also require the directive's own controller - it will be made available like
 *     any other controller.
 *
 *   * `transcludeFn` - A transclude linking function pre-bound to the correct transclusion scope.
 *     This is the same as the `$transclude` parameter of directive controllers,
 *     see {@link ng.$compile#-controller- the controller section for details}.
 *     `function([scope], cloneLinkingFn, futureParentElement)`.
 *
 * #### Pre-linking function
 *
 * Executed before the child elements are linked. Not safe to do DOM transformation since the
 * compiler linking function will fail to locate the correct elements for linking.
 *
 * #### Post-linking function
 *
 * Executed after the child elements are linked.
 *
 * Note that child elements that contain `templateUrl` directives will not have been compiled
 * and linked since they are waiting for their template to load asynchronously and their own
 * compilation and linking has been suspended until that occurs.
 *
 * It is safe to do DOM transformation in the post-linking function on elements that are not waiting
 * for their async templates to be resolved.
 *
 *
 * ### Transclusion
 *
 * Transclusion is the process of extracting a collection of DOM elements from one part of the DOM and
 * copying them to another part of the DOM, while maintaining their connection to the original AngularJS
 * scope from where they were taken.
 *
 * Transclusion is used (often with {@link ngTransclude}) to insert the
 * original contents of a directive's element into a specified place in the template of the directive.
 * The benefit of transclusion, over simply moving the DOM elements manually, is that the transcluded
 * content has access to the properties on the scope from which it was taken, even if the directive
 * has isolated scope.
 * See the {@link guide/directive#creating-a-directive-that-wraps-other-elements Directives Guide}.
 *
 * This makes it possible for the widget to have private state for its template, while the transcluded
 * content has access to its originating scope.
 *
 * <div class="alert alert-warning">
 * **Note:** When testing an element transclude directive you must not place the directive at the root of the
 * DOM fragment that is being compiled. See {@link guide/unit-testing#testing-transclusion-directives
 * Testing Transclusion Directives}.
 * </div>
 *
 * There are three kinds of transclusion depending upon whether you want to transclude just the contents of the
 * directive's element, the entire element or multiple parts of the element contents:
 *
 * * `true` - transclude the content (i.e. the child nodes) of the directive's element.
 * * `'element'` - transclude the whole of the directive's element including any directives on this
 *   element that defined at a lower priority than this directive. When used, the `template`
 *   property is ignored.
 * * **`{...}` (an object hash):** - map elements of the content onto transclusion "slots" in the template.
 *
 * **Mult-slot transclusion** is declared by providing an object for the `transclude` property.
 *
 * This object is a map where the keys are the name of the slot to fill and the value is an element selector
 * used to match the HTML to the slot. The element selector should be in normalized form (e.g. `myElement`)
 * and will match the standard element variants (e.g. `my-element`, `my:element`, `data-my-element`, etc).
 *
 * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
 *
 * If the element selector is prefixed with a `?` then that slot is optional.
 *
 * For example, the transclude object `{ slotA: '?myCustomElement' }` maps `<my-custom-element>` elements to
 * the `slotA` slot, which can be accessed via the `$transclude` function or via the {@link ngTransclude} directive.
 *
 * Slots that are not marked as optional (`?`) will trigger a compile time error if there are no matching elements
 * in the transclude content. If you wish to know if an optional slot was filled with content, then you can call
 * `$transclude.isSlotFilled(slotName)` on the transclude function passed to the directive's link function and
 * injectable into the directive's controller.
 *
 *
 * #### Transclusion Functions
 *
 * When a directive requests transclusion, the compiler extracts its contents and provides a **transclusion
 * function** to the directive's `link` function and `controller`. This transclusion function is a special
 * **linking function** that will return the compiled contents linked to a new transclusion scope.
 *
 * <div class="alert alert-info">
 * If you are just using {@link ngTransclude} then you don't need to worry about this function, since
 * ngTransclude will deal with it for us.
 * </div>
 *
 * If you want to manually control the insertion and removal of the transcluded content in your directive
 * then you must use this transclude function. When you call a transclude function it returns a a jqLite/JQuery
 * object that contains the compiled DOM, which is linked to the correct transclusion scope.
 *
 * When you call a transclusion function you can pass in a **clone attach function**. This function accepts
 * two parameters, `function(clone, scope) { ... }`, where the `clone` is a fresh compiled copy of your transcluded
 * content and the `scope` is the newly created transclusion scope, to which the clone is bound.
 *
 * <div class="alert alert-info">
 * **Best Practice**: Always provide a `cloneFn` (clone attach function) when you call a transclude function
 * since you then get a fresh clone of the original DOM and also have access to the new transclusion scope.
 * </div>
 *
 * It is normal practice to attach your transcluded content (`clone`) to the DOM inside your **clone
 * attach function**:
 *
 * ```js
 * var transcludedContent, transclusionScope;
 *
 * $transclude(function(clone, scope) {
 *   element.append(clone);
 *   transcludedContent = clone;
 *   transclusionScope = scope;
 * });
 * ```
 *
 * Later, if you want to remove the transcluded content from your DOM then you should also destroy the
 * associated transclusion scope:
 *
 * ```js
 * transcludedContent.remove();
 * transclusionScope.$destroy();
 * ```
 *
 * <div class="alert alert-info">
 * **Best Practice**: if you intend to add and remove transcluded content manually in your directive
 * (by calling the transclude function to get the DOM and calling `element.remove()` to remove it),
 * then you are also responsible for calling `$destroy` on the transclusion scope.
 * </div>
 *
 * The built-in DOM manipulation directives, such as {@link ngIf}, {@link ngSwitch} and {@link ngRepeat}
 * automatically destroy their transcluded clones as necessary so you do not need to worry about this if
 * you are simply using {@link ngTransclude} to inject the transclusion into your directive.
 *
 *
 * #### Transclusion Scopes
 *
 * When you call a transclude function it returns a DOM fragment that is pre-bound to a **transclusion
 * scope**. This scope is special, in that it is a child of the directive's scope (and so gets destroyed
 * when the directive's scope gets destroyed) but it inherits the properties of the scope from which it
 * was taken.
 *
 * For example consider a directive that uses transclusion and isolated scope. The DOM hierarchy might look
 * like this:
 *
 * ```html
 * <div ng-app>
 *   <div isolate>
 *     <div transclusion>
 *     </div>
 *   </div>
 * </div>
 * ```
 *
 * The `$parent` scope hierarchy will look like this:
 *
   ```
   - $rootScope
     - isolate
       - transclusion
   ```
 *
 * but the scopes will inherit prototypically from different scopes to their `$parent`.
 *
   ```
   - $rootScope
     - transclusion
   - isolate
   ```
 *
 *
 * ### Attributes
 *
 * The {@link ng.$compile.directive.Attributes Attributes} object - passed as a parameter in the
 * `link()` or `compile()` functions. It has a variety of uses.
 *
 * * *Accessing normalized attribute names:* Directives like 'ngBind' can be expressed in many ways:
 *   'ng:bind', `data-ng-bind`, or 'x-ng-bind'. The attributes object allows for normalized access
 *   to the attributes.
 *
 * * *Directive inter-communication:* All directives share the same instance of the attributes
 *   object which allows the directives to use the attributes object as inter directive
 *   communication.
 *
 * * *Supports interpolation:* Interpolation attributes are assigned to the attribute object
 *   allowing other directives to read the interpolated value.
 *
 * * *Observing interpolated attributes:* Use `$observe` to observe the value changes of attributes
 *   that contain interpolation (e.g. `src="{{bar}}"`). Not only is this very efficient but it's also
 *   the only way to easily get the actual value because during the linking phase the interpolation
 *   hasn't been evaluated yet and so the value is at this time set to `undefined`.
 *
 * ```js
 * function linkingFn(scope, elm, attrs, ctrl) {
 *   // get the attribute value
 *   console.log(attrs.ngModel);
 *
 *   // change the attribute
 *   attrs.$set('ngModel', 'new value');
 *
 *   // observe changes to interpolated attribute
 *   attrs.$observe('ngModel', function(value) {
 *     console.log('ngModel has changed value to ' + value);
 *   });
 * }
 * ```
 *
 * ## Example
 *
 * <div class="alert alert-warning">
 * **Note**: Typically directives are registered with `module.directive`. The example below is
 * to illustrate how `$compile` works.
 * </div>
 *
 <example module="compileExample">
   <file name="index.html">
    <script>
      angular.module('compileExample', [], function($compileProvider) {
        // configure new 'compile' directive by passing a directive
        // factory function. The factory function injects the '$compile'
        $compileProvider.directive('compile', function($compile) {
          // directive factory creates a link function
          return function(scope, element, attrs) {
            scope.$watch(
              function(scope) {
                 // watch the 'compile' expression for changes
                return scope.$eval(attrs.compile);
              },
              function(value) {
                // when the 'compile' expression changes
                // assign it into the current DOM
                element.html(value);

                // compile the new DOM and link it to the current
                // scope.
                // NOTE: we only compile .childNodes so that
                // we don't get into infinite loop compiling ourselves
                $compile(element.contents())(scope);
              }
            );
          };
        });
      })
      .controller('GreeterController', ['$scope', function($scope) {
        $scope.name = 'Angular';
        $scope.html = 'Hello {{name}}';
      }]);
    </script>
    <div ng-controller="GreeterController">
      <input ng-model="name"> <br/>
      <textarea ng-model="html"></textarea> <br/>
      <div compile="html"></div>
    </div>
   </file>
   <file name="protractor.js" type="protractor">
     it('should auto compile', function() {
       var textarea = $('textarea');
       var output = $('div[compile]');
       // The initial state reads 'Hello Angular'.
       expect(output.getText()).toBe('Hello Angular');
       textarea.clear();
       textarea.sendKeys('{{name}}!');
       expect(output.getText()).toBe('Angular!');
     });
   </file>
 </example>

 *
 *
 * @param {string|DOMElement} element Element or HTML string to compile into a template function.
 * @param {function(angular.Scope, cloneAttachFn=)} transclude function available to directives - DEPRECATED.
 *
 * <div class="alert alert-danger">
 * **Note:** Passing a `transclude` function to the $compile function is deprecated, as it
 *   e.g. will not use the right outer scope. Please pass the transclude function as a
 *   `parentBoundTranscludeFn` to the link function instead.
 * </div>
 *
 * @param {number} maxPriority only apply directives lower than given priority (Only effects the
 *                 root element(s), not their children)
 * @returns {function(scope, cloneAttachFn=, options=)} a link function which is used to bind template
 * (a DOM element/tree) to a scope. Where:
 *
 *  * `scope` - A {@link ng.$rootScope.Scope Scope} to bind to.
 *  * `cloneAttachFn` - If `cloneAttachFn` is provided, then the link function will clone the
 *  `template` and call the `cloneAttachFn` function allowing the caller to attach the
 *  cloned elements to the DOM document at the appropriate place. The `cloneAttachFn` is
 *  called as: <br/> `cloneAttachFn(clonedElement, scope)` where:
 *
 *      * `clonedElement` - is a clone of the original `element` passed into the compiler.
 *      * `scope` - is the current scope with which the linking function is working with.
 *
 *  * `options` - An optional object hash with linking options. If `options` is provided, then the following
 *  keys may be used to control linking behavior:
 *
 *      * `parentBoundTranscludeFn` - the transclude function made available to
 *        directives; if given, it will be passed through to the link functions of
 *        directives found in `element` during compilation.
 *      * `transcludeControllers` - an object hash with keys that map controller names
 *        to a hash with the key `instance`, which maps to the controller instance;
 *        if given, it will make the controllers available to directives on the compileNode:
 *        ```
 *        {
 *          parent: {
 *            instance: parentControllerInstance
 *          }
 *        }
 *        ```
 *      * `futureParentElement` - defines the parent to which the `cloneAttachFn` will add
 *        the cloned elements; only needed for transcludes that are allowed to contain non html
 *        elements (e.g. SVG elements). See also the directive.controller property.
 *
 * Calling the linking function returns the element of the template. It is either the original
 * element passed in, or the clone of the element if the `cloneAttachFn` is provided.
 *
 * After linking the view is not updated until after a call to $digest which typically is done by
 * Angular automatically.
 *
 * If you need access to the bound view, there are two ways to do it:
 *
 * - If you are not asking the linking function to clone the template, create the DOM element(s)
 *   before you send them to the compiler and keep this reference around.
 *   ```js
 *     var element = $compile('<p>{{total}}</p>')(scope);
 *   ```
 *
 * - if on the other hand, you need the element to be cloned, the view reference from the original
 *   example would not point to the clone, but rather to the original template that was cloned. In
 *   this case, you can access the clone via the cloneAttachFn:
 *   ```js
 *     var templateElement = angular.element('<p>{{total}}</p>'),
 *         scope = ....;
 *
 *     var clonedElement = $compile(templateElement)(scope, function(clonedElement, scope) {
 *       //attach the clone to DOM document at the right place
 *     });
 *
 *     //now we have reference to the cloned DOM via `clonedElement`
 *   ```
 *
 *
 * For information on how the compiler works, see the
 * {@link guide/compiler Angular HTML Compiler} section of the Developer Guide.
 */

var $compileMinErr = minErr('$compile');

function UNINITIALIZED_VALUE() {}
var _UNINITIALIZED_VALUE = new UNINITIALIZED_VALUE();

/**
 * @ngdoc provider
 * @name $compileProvider
 *
 * @description
 */
$CompileProvider.$inject = ['$provide', '$$sanitizeUriProvider'];
function $CompileProvider($provide, $$sanitizeUriProvider) {
  var hasDirectives = {},
      Suffix = 'Directive',
      COMMENT_DIRECTIVE_REGEXP = /^\s*directive\:\s*([\w\-]+)\s+(.*)$/,
      CLASS_DIRECTIVE_REGEXP = /(([\w\-]+)(?:\:([^;]+))?;?)/,
      ALL_OR_NOTHING_ATTRS = makeMap('ngSrc,ngSrcset,src,srcset'),
      REQUIRE_PREFIX_REGEXP = /^(?:(\^\^?)?(\?)?(\^\^?)?)?/;

  // Ref: http://developers.whatwg.org/webappapis.html#event-handler-idl-attributes
  // The assumption is that future DOM event attribute names will begin with
  // 'on' and be composed of only English letters.
  var EVENT_HANDLER_ATTR_REGEXP = /^(on[a-z]+|formaction)$/;
  var bindingCache = createMap();

  function parseIsolateBindings(scope, directiveName, isController) {
    var LOCAL_REGEXP = /^\s*([@&<]|=(\*?))(\??)\s*(\w*)\s*$/;

    var bindings = createMap();

    forEach(scope, function(definition, scopeName) {
      if (definition in bindingCache) {
        bindings[scopeName] = bindingCache[definition];
        return;
      }
      var match = definition.match(LOCAL_REGEXP);

      if (!match) {
        throw $compileMinErr('iscp',
            "Invalid {3} for directive '{0}'." +
            " Definition: {... {1}: '{2}' ...}",
            directiveName, scopeName, definition,
            (isController ? "controller bindings definition" :
            "isolate scope definition"));
      }

      bindings[scopeName] = {
        mode: match[1][0],
        collection: match[2] === '*',
        optional: match[3] === '?',
        attrName: match[4] || scopeName
      };
      if (match[4]) {
        bindingCache[definition] = bindings[scopeName];
      }
    });

    return bindings;
  }

  function parseDirectiveBindings(directive, directiveName) {
    var bindings = {
      isolateScope: null,
      bindToController: null
    };
    if (isObject(directive.scope)) {
      if (directive.bindToController === true) {
        bindings.bindToController = parseIsolateBindings(directive.scope,
                                                         directiveName, true);
        bindings.isolateScope = {};
      } else {
        bindings.isolateScope = parseIsolateBindings(directive.scope,
                                                     directiveName, false);
      }
    }
    if (isObject(directive.bindToController)) {
      bindings.bindToController =
          parseIsolateBindings(directive.bindToController, directiveName, true);
    }
    if (isObject(bindings.bindToController)) {
      var controller = directive.controller;
      var controllerAs = directive.controllerAs;
      if (!controller) {
        // There is no controller, there may or may not be a controllerAs property
        throw $compileMinErr('noctrl',
              "Cannot bind to controller without directive '{0}'s controller.",
              directiveName);
      } else if (!identifierForController(controller, controllerAs)) {
        // There is a controller, but no identifier or controllerAs property
        throw $compileMinErr('noident',
              "Cannot bind to controller without identifier for directive '{0}'.",
              directiveName);
      }
    }
    return bindings;
  }

  function assertValidDirectiveName(name) {
    var letter = name.charAt(0);
    if (!letter || letter !== lowercase(letter)) {
      throw $compileMinErr('baddir', "Directive/Component name '{0}' is invalid. The first character must be a lowercase letter", name);
    }
    if (name !== name.trim()) {
      throw $compileMinErr('baddir',
            "Directive/Component name '{0}' is invalid. The name should not contain leading or trailing whitespaces",
            name);
    }
  }

  function getDirectiveRequire(directive) {
    var require = directive.require || (directive.controller && directive.name);

    if (!isArray(require) && isObject(require)) {
      forEach(require, function(value, key) {
        var match = value.match(REQUIRE_PREFIX_REGEXP);
        var name = value.substring(match[0].length);
        if (!name) require[key] = match[0] + key;
      });
    }

    return require;
  }

  /**
   * @ngdoc method
   * @name $compileProvider#directive
   * @kind function
   *
   * @description
   * Register a new directive with the compiler.
   *
   * @param {string|Object} name Name of the directive in camel-case (i.e. <code>ngBind</code> which
   *    will match as <code>ng-bind</code>), or an object map of directives where the keys are the
   *    names and the values are the factories.
   * @param {Function|Array} directiveFactory An injectable directive factory function. See the
   *    {@link guide/directive directive guide} and the {@link $compile compile API} for more info.
   * @returns {ng.$compileProvider} Self for chaining.
   */
  this.directive = function registerDirective(name, directiveFactory) {
    assertNotHasOwnProperty(name, 'directive');
    if (isString(name)) {
      assertValidDirectiveName(name);
      assertArg(directiveFactory, 'directiveFactory');
      if (!hasDirectives.hasOwnProperty(name)) {
        hasDirectives[name] = [];
        $provide.factory(name + Suffix, ['$injector', '$exceptionHandler',
          function($injector, $exceptionHandler) {
            var directives = [];
            forEach(hasDirectives[name], function(directiveFactory, index) {
              try {
                var directive = $injector.invoke(directiveFactory);
                if (isFunction(directive)) {
                  directive = { compile: valueFn(directive) };
                } else if (!directive.compile && directive.link) {
                  directive.compile = valueFn(directive.link);
                }
                directive.priority = directive.priority || 0;
                directive.index = index;
                directive.name = directive.name || name;
                directive.require = getDirectiveRequire(directive);
                directive.restrict = directive.restrict || 'EA';
                directive.$$moduleName = directiveFactory.$$moduleName;
                directives.push(directive);
              } catch (e) {
                $exceptionHandler(e);
              }
            });
            return directives;
          }]);
      }
      hasDirectives[name].push(directiveFactory);
    } else {
      forEach(name, reverseParams(registerDirective));
    }
    return this;
  };

  /**
   * @ngdoc method
   * @name $compileProvider#component
   * @module ng
   * @param {string} name Name of the component in camelCase (i.e. `myComp` which will match `<my-comp>`)
   * @param {Object} options Component definition object (a simplified
   *    {@link ng.$compile#directive-definition-object directive definition object}),
   *    with the following properties (all optional):
   *
   *    - `controller` – `{(string|function()=}` – controller constructor function that should be
   *      associated with newly created scope or the name of a {@link ng.$compile#-controller-
   *      registered controller} if passed as a string. An empty `noop` function by default.
   *    - `controllerAs` – `{string=}` – identifier name for to reference the controller in the component's scope.
   *      If present, the controller will be published to scope under the `controllerAs` name.
   *      If not present, this will default to be `$ctrl`.
   *    - `template` – `{string=|function()=}` – html template as a string or a function that
   *      returns an html template as a string which should be used as the contents of this component.
   *      Empty string by default.
   *
   *      If `template` is a function, then it is {@link auto.$injector#invoke injected} with
   *      the following locals:
   *
   *      - `$element` - Current element
   *      - `$attrs` - Current attributes object for the element
   *
   *    - `templateUrl` – `{string=|function()=}` – path or function that returns a path to an html
   *      template that should be used  as the contents of this component.
   *
   *      If `templateUrl` is a function, then it is {@link auto.$injector#invoke injected} with
   *      the following locals:
   *
   *      - `$element` - Current element
   *      - `$attrs` - Current attributes object for the element
   *
   *    - `bindings` – `{object=}` – defines bindings between DOM attributes and component properties.
   *      Component properties are always bound to the component controller and not to the scope.
   *      See {@link ng.$compile#-bindtocontroller- `bindToController`}.
   *    - `transclude` – `{boolean=}` – whether {@link $compile#transclusion content transclusion} is enabled.
   *      Disabled by default.
   *    - `require` - `{Object<string, string>=}` - requires the controllers of other directives and binds them to
   *      this component's controller. The object keys specify the property names under which the required
   *      controllers (object values) will be bound. See {@link ng.$compile#-require- `require`}.
   *    - `$...` – additional properties to attach to the directive factory function and the controller
   *      constructor function. (This is used by the component router to annotate)
   *
   * @returns {ng.$compileProvider} the compile provider itself, for chaining of function calls.
   * @description
   * Register a **component definition** with the compiler. This is a shorthand for registering a special
   * type of directive, which represents a self-contained UI component in your application. Such components
   * are always isolated (i.e. `scope: {}`) and are always restricted to elements (i.e. `restrict: 'E'`).
   *
   * Component definitions are very simple and do not require as much configuration as defining general
   * directives. Component definitions usually consist only of a template and a controller backing it.
   *
   * In order to make the definition easier, components enforce best practices like use of `controllerAs`,
   * `bindToController`. They always have **isolate scope** and are restricted to elements.
   *
   * Here are a few examples of how you would usually define components:
   *
   * ```js
   *   var myMod = angular.module(...);
   *   myMod.component('myComp', {
   *     template: '<div>My name is {{$ctrl.name}}</div>',
   *     controller: function() {
   *       this.name = 'shahar';
   *     }
   *   });
   *
   *   myMod.component('myComp', {
   *     template: '<div>My name is {{$ctrl.name}}</div>',
   *     bindings: {name: '@'}
   *   });
   *
   *   myMod.component('myComp', {
   *     templateUrl: 'views/my-comp.html',
   *     controller: 'MyCtrl',
   *     controllerAs: 'ctrl',
   *     bindings: {name: '@'}
   *   });
   *
   * ```
   * For more examples, and an in-depth guide, see the {@link guide/component component guide}.
   *
   * <br />
   * See also {@link ng.$compileProvider#directive $compileProvider.directive()}.
   */
  this.component = function registerComponent(name, options) {
    var controller = options.controller || function() {};

    function factory($injector) {
      function makeInjectable(fn) {
        if (isFunction(fn) || isArray(fn)) {
          return function(tElement, tAttrs) {
            return $injector.invoke(fn, this, {$element: tElement, $attrs: tAttrs});
          };
        } else {
          return fn;
        }
      }

      var template = (!options.template && !options.templateUrl ? '' : options.template);
      var ddo = {
        controller: controller,
        controllerAs: identifierForController(options.controller) || options.controllerAs || '$ctrl',
        template: makeInjectable(template),
        templateUrl: makeInjectable(options.templateUrl),
        transclude: options.transclude,
        scope: {},
        bindToController: options.bindings || {},
        restrict: 'E',
        require: options.require
      };

      // Copy annotations (starting with $) over to the DDO
      forEach(options, function(val, key) {
        if (key.charAt(0) === '$') ddo[key] = val;
      });

      return ddo;
    }

    // TODO(pete) remove the following `forEach` before we release 1.6.0
    // The component-router@0.2.0 looks for the annotations on the controller constructor
    // Nothing in Angular looks for annotations on the factory function but we can't remove
    // it from 1.5.x yet.

    // Copy any annotation properties (starting with $) over to the factory and controller constructor functions
    // These could be used by libraries such as the new component router
    forEach(options, function(val, key) {
      if (key.charAt(0) === '$') {
        factory[key] = val;
        // Don't try to copy over annotations to named controller
        if (isFunction(controller)) controller[key] = val;
      }
    });

    factory.$inject = ['$injector'];

    return this.directive(name, factory);
  };


  /**
   * @ngdoc method
   * @name $compileProvider#aHrefSanitizationWhitelist
   * @kind function
   *
   * @description
   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
   * urls during a[href] sanitization.
   *
   * The sanitization is a security measure aimed at preventing XSS attacks via html links.
   *
   * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
   * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationWhitelist`
   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
   *
   * @param {RegExp=} regexp New regexp to whitelist urls with.
   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
   *    chaining otherwise.
   */
  this.aHrefSanitizationWhitelist = function(regexp) {
    if (isDefined(regexp)) {
      $$sanitizeUriProvider.aHrefSanitizationWhitelist(regexp);
      return this;
    } else {
      return $$sanitizeUriProvider.aHrefSanitizationWhitelist();
    }
  };


  /**
   * @ngdoc method
   * @name $compileProvider#imgSrcSanitizationWhitelist
   * @kind function
   *
   * @description
   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
   * urls during img[src] sanitization.
   *
   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
   *
   * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
   * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationWhitelist`
   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
   *
   * @param {RegExp=} regexp New regexp to whitelist urls with.
   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
   *    chaining otherwise.
   */
  this.imgSrcSanitizationWhitelist = function(regexp) {
    if (isDefined(regexp)) {
      $$sanitizeUriProvider.imgSrcSanitizationWhitelist(regexp);
      return this;
    } else {
      return $$sanitizeUriProvider.imgSrcSanitizationWhitelist();
    }
  };

  /**
   * @ngdoc method
   * @name  $compileProvider#debugInfoEnabled
   *
   * @param {boolean=} enabled update the debugInfoEnabled state if provided, otherwise just return the
   * current debugInfoEnabled state
   * @returns {*} current value if used as getter or itself (chaining) if used as setter
   *
   * @kind function
   *
   * @description
   * Call this method to enable/disable various debug runtime information in the compiler such as adding
   * binding information and a reference to the current scope on to DOM elements.
   * If enabled, the compiler will add the following to DOM elements that have been bound to the scope
   * * `ng-binding` CSS class
   * * `$binding` data property containing an array of the binding expressions
   *
   * You may want to disable this in production for a significant performance boost. See
   * {@link guide/production#disabling-debug-data Disabling Debug Data} for more.
   *
   * The default value is true.
   */
  var debugInfoEnabled = true;
  this.debugInfoEnabled = function(enabled) {
    if (isDefined(enabled)) {
      debugInfoEnabled = enabled;
      return this;
    }
    return debugInfoEnabled;
  };


  var TTL = 10;
  /**
   * @ngdoc method
   * @name $compileProvider#onChangesTtl
   * @description
   *
   * Sets the number of times `$onChanges` hooks can trigger new changes before giving up and
   * assuming that the model is unstable.
   *
   * The current default is 10 iterations.
   *
   * In complex applications it's possible that dependencies between `$onChanges` hooks and bindings will result
   * in several iterations of calls to these hooks. However if an application needs more than the default 10
   * iterations to stabilize then you should investigate what is causing the model to continuously change during
   * the `$onChanges` hook execution.
   *
   * Increasing the TTL could have performance implications, so you should not change it without proper justification.
   *
   * @param {number} limit The number of `$onChanges` hook iterations.
   * @returns {number|object} the current limit (or `this` if called as a setter for chaining)
   */
  this.onChangesTtl = function(value) {
    if (arguments.length) {
      TTL = value;
      return this;
    }
    return TTL;
  };

  this.$get = [
            '$injector', '$interpolate', '$exceptionHandler', '$templateRequest', '$parse',
            '$controller', '$rootScope', '$sce', '$animate', '$$sanitizeUri',
    function($injector,   $interpolate,   $exceptionHandler,   $templateRequest,   $parse,
             $controller,   $rootScope,   $sce,   $animate,   $$sanitizeUri) {

    var SIMPLE_ATTR_NAME = /^\w/;
    var specialAttrHolder = window.document.createElement('div');



    var onChangesTtl = TTL;
    // The onChanges hooks should all be run together in a single digest
    // When changes occur, the call to trigger their hooks will be added to this queue
    var onChangesQueue;

    // This function is called in a $$postDigest to trigger all the onChanges hooks in a single digest
    function flushOnChangesQueue() {
      try {
        if (!(--onChangesTtl)) {
          // We have hit the TTL limit so reset everything
          onChangesQueue = undefined;
          throw $compileMinErr('infchng', '{0} $onChanges() iterations reached. Aborting!\n', TTL);
        }
        // We must run this hook in an apply since the $$postDigest runs outside apply
        $rootScope.$apply(function() {
          var errors = [];
          for (var i = 0, ii = onChangesQueue.length; i < ii; ++i) {
            try {
              onChangesQueue[i]();
            } catch (e) {
              errors.push(e);
            }
          }
          // Reset the queue to trigger a new schedule next time there is a change
          onChangesQueue = undefined;
          if (errors.length) {
            throw errors;
          }
        });
      } finally {
        onChangesTtl++;
      }
    }


    function Attributes(element, attributesToCopy) {
      if (attributesToCopy) {
        var keys = Object.keys(attributesToCopy);
        var i, l, key;

        for (i = 0, l = keys.length; i < l; i++) {
          key = keys[i];
          this[key] = attributesToCopy[key];
        }
      } else {
        this.$attr = {};
      }

      this.$$element = element;
    }

    Attributes.prototype = {
      /**
       * @ngdoc method
       * @name $compile.directive.Attributes#$normalize
       * @kind function
       *
       * @description
       * Converts an attribute name (e.g. dash/colon/underscore-delimited string, optionally prefixed with `x-` or
       * `data-`) to its normalized, camelCase form.
       *
       * Also there is special case for Moz prefix starting with upper case letter.
       *
       * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
       *
       * @param {string} name Name to normalize
       */
      $normalize: directiveNormalize,


      /**
       * @ngdoc method
       * @name $compile.directive.Attributes#$addClass
       * @kind function
       *
       * @description
       * Adds the CSS class value specified by the classVal parameter to the element. If animations
       * are enabled then an animation will be triggered for the class addition.
       *
       * @param {string} classVal The className value that will be added to the element
       */
      $addClass: function(classVal) {
        if (classVal && classVal.length > 0) {
          $animate.addClass(this.$$element, classVal);
        }
      },

      /**
       * @ngdoc method
       * @name $compile.directive.Attributes#$removeClass
       * @kind function
       *
       * @description
       * Removes the CSS class value specified by the classVal parameter from the element. If
       * animations are enabled then an animation will be triggered for the class removal.
       *
       * @param {string} classVal The className value that will be removed from the element
       */
      $removeClass: function(classVal) {
        if (classVal && classVal.length > 0) {
          $animate.removeClass(this.$$element, classVal);
        }
      },

      /**
       * @ngdoc method
       * @name $compile.directive.Attributes#$updateClass
       * @kind function
       *
       * @description
       * Adds and removes the appropriate CSS class values to the element based on the difference
       * between the new and old CSS class values (specified as newClasses and oldClasses).
       *
       * @param {string} newClasses The current CSS className value
       * @param {string} oldClasses The former CSS className value
       */
      $updateClass: function(newClasses, oldClasses) {
        var toAdd = tokenDifference(newClasses, oldClasses);
        if (toAdd && toAdd.length) {
          $animate.addClass(this.$$element, toAdd);
        }

        var toRemove = tokenDifference(oldClasses, newClasses);
        if (toRemove && toRemove.length) {
          $animate.removeClass(this.$$element, toRemove);
        }
      },

      /**
       * Set a normalized attribute on the element in a way such that all directives
       * can share the attribute. This function properly handles boolean attributes.
       * @param {string} key Normalized key. (ie ngAttribute)
       * @param {string|boolean} value The value to set. If `null` attribute will be deleted.
       * @param {boolean=} writeAttr If false, does not write the value to DOM element attribute.
       *     Defaults to true.
       * @param {string=} attrName Optional none normalized name. Defaults to key.
       */
      $set: function(key, value, writeAttr, attrName) {
        // TODO: decide whether or not to throw an error if "class"
        //is set through this function since it may cause $updateClass to
        //become unstable.

        var node = this.$$element[0],
            booleanKey = getBooleanAttrName(node, key),
            aliasedKey = getAliasedAttrName(key),
            observer = key,
            nodeName;

        if (booleanKey) {
          this.$$element.prop(key, value);
          attrName = booleanKey;
        } else if (aliasedKey) {
          this[aliasedKey] = value;
          observer = aliasedKey;
        }

        this[key] = value;

        // translate normalized key to actual key
        if (attrName) {
          this.$attr[key] = attrName;
        } else {
          attrName = this.$attr[key];
          if (!attrName) {
            this.$attr[key] = attrName = snake_case(key, '-');
          }
        }

        nodeName = nodeName_(this.$$element);

        if ((nodeName === 'a' && (key === 'href' || key === 'xlinkHref')) ||
            (nodeName === 'img' && key === 'src')) {
          // sanitize a[href] and img[src] values
          this[key] = value = $$sanitizeUri(value, key === 'src');
        } else if (nodeName === 'img' && key === 'srcset' && isDefined(value)) {
          // sanitize img[srcset] values
          var result = "";

          // first check if there are spaces because it's not the same pattern
          var trimmedSrcset = trim(value);
          //                (   999x   ,|   999w   ,|   ,|,   )
          var srcPattern = /(\s+\d+x\s*,|\s+\d+w\s*,|\s+,|,\s+)/;
          var pattern = /\s/.test(trimmedSrcset) ? srcPattern : /(,)/;

          // split srcset into tuple of uri and descriptor except for the last item
          var rawUris = trimmedSrcset.split(pattern);

          // for each tuples
          var nbrUrisWith2parts = Math.floor(rawUris.length / 2);
          for (var i = 0; i < nbrUrisWith2parts; i++) {
            var innerIdx = i * 2;
            // sanitize the uri
            result += $$sanitizeUri(trim(rawUris[innerIdx]), true);
            // add the descriptor
            result += (" " + trim(rawUris[innerIdx + 1]));
          }

          // split the last item into uri and descriptor
          var lastTuple = trim(rawUris[i * 2]).split(/\s/);

          // sanitize the last uri
          result += $$sanitizeUri(trim(lastTuple[0]), true);

          // and add the last descriptor if any
          if (lastTuple.length === 2) {
            result += (" " + trim(lastTuple[1]));
          }
          this[key] = value = result;
        }

        if (writeAttr !== false) {
          if (value === null || isUndefined(value)) {
            this.$$element.removeAttr(attrName);
          } else {
            if (SIMPLE_ATTR_NAME.test(attrName)) {
              this.$$element.attr(attrName, value);
            } else {
              setSpecialAttr(this.$$element[0], attrName, value);
            }
          }
        }

        // fire observers
        var $$observers = this.$$observers;
        $$observers && forEach($$observers[observer], function(fn) {
          try {
            fn(value);
          } catch (e) {
            $exceptionHandler(e);
          }
        });
      },


      /**
       * @ngdoc method
       * @name $compile.directive.Attributes#$observe
       * @kind function
       *
       * @description
       * Observes an interpolated attribute.
       *
       * The observer function will be invoked once during the next `$digest` following
       * compilation. The observer is then invoked whenever the interpolated value
       * changes.
       *
       * @param {string} key Normalized key. (ie ngAttribute) .
       * @param {function(interpolatedValue)} fn Function that will be called whenever
                the interpolated value of the attribute changes.
       *        See the {@link guide/interpolation#how-text-and-attribute-bindings-work Interpolation
       *        guide} for more info.
       * @returns {function()} Returns a deregistration function for this observer.
       */
      $observe: function(key, fn) {
        var attrs = this,
            $$observers = (attrs.$$observers || (attrs.$$observers = createMap())),
            listeners = ($$observers[key] || ($$observers[key] = []));

        listeners.push(fn);
        $rootScope.$evalAsync(function() {
          if (!listeners.$$inter && attrs.hasOwnProperty(key) && !isUndefined(attrs[key])) {
            // no one registered attribute interpolation function, so lets call it manually
            fn(attrs[key]);
          }
        });

        return function() {
          arrayRemove(listeners, fn);
        };
      }
    };

    function setSpecialAttr(element, attrName, value) {
      // Attributes names that do not start with letters (such as `(click)`) cannot be set using `setAttribute`
      // so we have to jump through some hoops to get such an attribute
      // https://github.com/angular/angular.js/pull/13318
      specialAttrHolder.innerHTML = "<span " + attrName + ">";
      var attributes = specialAttrHolder.firstChild.attributes;
      var attribute = attributes[0];
      // We have to remove the attribute from its container element before we can add it to the destination element
      attributes.removeNamedItem(attribute.name);
      attribute.value = value;
      element.attributes.setNamedItem(attribute);
    }

    function safeAddClass($element, className) {
      try {
        $element.addClass(className);
      } catch (e) {
        // ignore, since it means that we are trying to set class on
        // SVG element, where class name is read-only.
      }
    }


    var startSymbol = $interpolate.startSymbol(),
        endSymbol = $interpolate.endSymbol(),
        denormalizeTemplate = (startSymbol == '{{' && endSymbol  == '}}')
            ? identity
            : function denormalizeTemplate(template) {
              return template.replace(/\{\{/g, startSymbol).replace(/}}/g, endSymbol);
        },
        NG_ATTR_BINDING = /^ngAttr[A-Z]/;
    var MULTI_ELEMENT_DIR_RE = /^(.+)Start$/;

    compile.$$addBindingInfo = debugInfoEnabled ? function $$addBindingInfo($element, binding) {
      var bindings = $element.data('$binding') || [];

      if (isArray(binding)) {
        bindings = bindings.concat(binding);
      } else {
        bindings.push(binding);
      }

      $element.data('$binding', bindings);
    } : noop;

    compile.$$addBindingClass = debugInfoEnabled ? function $$addBindingClass($element) {
      safeAddClass($element, 'ng-binding');
    } : noop;

    compile.$$addScopeInfo = debugInfoEnabled ? function $$addScopeInfo($element, scope, isolated, noTemplate) {
      var dataName = isolated ? (noTemplate ? '$isolateScopeNoTemplate' : '$isolateScope') : '$scope';
      $element.data(dataName, scope);
    } : noop;

    compile.$$addScopeClass = debugInfoEnabled ? function $$addScopeClass($element, isolated) {
      safeAddClass($element, isolated ? 'ng-isolate-scope' : 'ng-scope');
    } : noop;

    compile.$$createComment = function(directiveName, comment) {
      var content = '';
      if (debugInfoEnabled) {
        content = ' ' + (directiveName || '') + ': ';
        if (comment) content += comment + ' ';
      }
      return window.document.createComment(content);
    };

    return compile;

    //================================

    function compile($compileNodes, transcludeFn, maxPriority, ignoreDirective,
                        previousCompileContext) {
      if (!($compileNodes instanceof jqLite)) {
        // jquery always rewraps, whereas we need to preserve the original selector so that we can
        // modify it.
        $compileNodes = jqLite($compileNodes);
      }

      var NOT_EMPTY = /\S+/;

      // We can not compile top level text elements since text nodes can be merged and we will
      // not be able to attach scope data to them, so we will wrap them in <span>
      for (var i = 0, len = $compileNodes.length; i < len; i++) {
        var domNode = $compileNodes[i];

        if (domNode.nodeType === NODE_TYPE_TEXT && domNode.nodeValue.match(NOT_EMPTY) /* non-empty */) {
          jqLiteWrapNode(domNode, $compileNodes[i] = window.document.createElement('span'));
        }
      }

      var compositeLinkFn =
              compileNodes($compileNodes, transcludeFn, $compileNodes,
                           maxPriority, ignoreDirective, previousCompileContext);
      compile.$$addScopeClass($compileNodes);
      var namespace = null;
      return function publicLinkFn(scope, cloneConnectFn, options) {
        assertArg(scope, 'scope');

        if (previousCompileContext && previousCompileContext.needsNewScope) {
          // A parent directive did a replace and a directive on this element asked
          // for transclusion, which caused us to lose a layer of element on which
          // we could hold the new transclusion scope, so we will create it manually
          // here.
          scope = scope.$parent.$new();
        }

        options = options || {};
        var parentBoundTranscludeFn = options.parentBoundTranscludeFn,
          transcludeControllers = options.transcludeControllers,
          futureParentElement = options.futureParentElement;

        // When `parentBoundTranscludeFn` is passed, it is a
        // `controllersBoundTransclude` function (it was previously passed
        // as `transclude` to directive.link) so we must unwrap it to get
        // its `boundTranscludeFn`
        if (parentBoundTranscludeFn && parentBoundTranscludeFn.$$boundTransclude) {
          parentBoundTranscludeFn = parentBoundTranscludeFn.$$boundTransclude;
        }

        if (!namespace) {
          namespace = detectNamespaceForChildElements(futureParentElement);
        }
        var $linkNode;
        if (namespace !== 'html') {
          // When using a directive with replace:true and templateUrl the $compileNodes
          // (or a child element inside of them)
          // might change, so we need to recreate the namespace adapted compileNodes
          // for call to the link function.
          // Note: This will already clone the nodes...
          $linkNode = jqLite(
            wrapTemplate(namespace, jqLite('<div>').append($compileNodes).html())
          );
        } else if (cloneConnectFn) {
          // important!!: we must call our jqLite.clone() since the jQuery one is trying to be smart
          // and sometimes changes the structure of the DOM.
          $linkNode = JQLitePrototype.clone.call($compileNodes);
        } else {
          $linkNode = $compileNodes;
        }

        if (transcludeControllers) {
          for (var controllerName in transcludeControllers) {
            $linkNode.data('$' + controllerName + 'Controller', transcludeControllers[controllerName].instance);
          }
        }

        compile.$$addScopeInfo($linkNode, scope);

        if (cloneConnectFn) cloneConnectFn($linkNode, scope);
        if (compositeLinkFn) compositeLinkFn(scope, $linkNode, $linkNode, parentBoundTranscludeFn);
        return $linkNode;
      };
    }

    function detectNamespaceForChildElements(parentElement) {
      // TODO: Make this detect MathML as well...
      var node = parentElement && parentElement[0];
      if (!node) {
        return 'html';
      } else {
        return nodeName_(node) !== 'foreignobject' && toString.call(node).match(/SVG/) ? 'svg' : 'html';
      }
    }

    /**
     * Compile function matches each node in nodeList against the directives. Once all directives
     * for a particular node are collected their compile functions are executed. The compile
     * functions return values - the linking functions - are combined into a composite linking
     * function, which is the a linking function for the node.
     *
     * @param {NodeList} nodeList an array of nodes or NodeList to compile
     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
     *        scope argument is auto-generated to the new child of the transcluded parent scope.
     * @param {DOMElement=} $rootElement If the nodeList is the root of the compilation tree then
     *        the rootElement must be set the jqLite collection of the compile root. This is
     *        needed so that the jqLite collection items can be replaced with widgets.
     * @param {number=} maxPriority Max directive priority.
     * @returns {Function} A composite linking function of all of the matched directives or null.
     */
    function compileNodes(nodeList, transcludeFn, $rootElement, maxPriority, ignoreDirective,
                            previousCompileContext) {
      var linkFns = [],
          attrs, directives, nodeLinkFn, childNodes, childLinkFn, linkFnFound, nodeLinkFnFound;

      for (var i = 0; i < nodeList.length; i++) {
        attrs = new Attributes();

        // we must always refer to nodeList[i] since the nodes can be replaced underneath us.
        directives = collectDirectives(nodeList[i], [], attrs, i === 0 ? maxPriority : undefined,
                                        ignoreDirective);

        nodeLinkFn = (directives.length)
            ? applyDirectivesToNode(directives, nodeList[i], attrs, transcludeFn, $rootElement,
                                      null, [], [], previousCompileContext)
            : null;

        if (nodeLinkFn && nodeLinkFn.scope) {
          compile.$$addScopeClass(attrs.$$element);
        }

        childLinkFn = (nodeLinkFn && nodeLinkFn.terminal ||
                      !(childNodes = nodeList[i].childNodes) ||
                      !childNodes.length)
            ? null
            : compileNodes(childNodes,
                 nodeLinkFn ? (
                  (nodeLinkFn.transcludeOnThisElement || !nodeLinkFn.templateOnThisElement)
                     && nodeLinkFn.transclude) : transcludeFn);

        if (nodeLinkFn || childLinkFn) {
          linkFns.push(i, nodeLinkFn, childLinkFn);
          linkFnFound = true;
          nodeLinkFnFound = nodeLinkFnFound || nodeLinkFn;
        }

        //use the previous context only for the first element in the virtual group
        previousCompileContext = null;
      }

      // return a linking function if we have found anything, null otherwise
      return linkFnFound ? compositeLinkFn : null;

      function compositeLinkFn(scope, nodeList, $rootElement, parentBoundTranscludeFn) {
        var nodeLinkFn, childLinkFn, node, childScope, i, ii, idx, childBoundTranscludeFn;
        var stableNodeList;


        if (nodeLinkFnFound) {
          // copy nodeList so that if a nodeLinkFn removes or adds an element at this DOM level our
          // offsets don't get screwed up
          var nodeListLength = nodeList.length;
          stableNodeList = new Array(nodeListLength);

          // create a sparse array by only copying the elements which have a linkFn
          for (i = 0; i < linkFns.length; i+=3) {
            idx = linkFns[i];
            stableNodeList[idx] = nodeList[idx];
          }
        } else {
          stableNodeList = nodeList;
        }

        for (i = 0, ii = linkFns.length; i < ii;) {
          node = stableNodeList[linkFns[i++]];
          nodeLinkFn = linkFns[i++];
          childLinkFn = linkFns[i++];

          if (nodeLinkFn) {
            if (nodeLinkFn.scope) {
              childScope = scope.$new();
              compile.$$addScopeInfo(jqLite(node), childScope);
            } else {
              childScope = scope;
            }

            if (nodeLinkFn.transcludeOnThisElement) {
              childBoundTranscludeFn = createBoundTranscludeFn(
                  scope, nodeLinkFn.transclude, parentBoundTranscludeFn);

            } else if (!nodeLinkFn.templateOnThisElement && parentBoundTranscludeFn) {
              childBoundTranscludeFn = parentBoundTranscludeFn;

            } else if (!parentBoundTranscludeFn && transcludeFn) {
              childBoundTranscludeFn = createBoundTranscludeFn(scope, transcludeFn);

            } else {
              childBoundTranscludeFn = null;
            }

            nodeLinkFn(childLinkFn, childScope, node, $rootElement, childBoundTranscludeFn);

          } else if (childLinkFn) {
            childLinkFn(scope, node.childNodes, undefined, parentBoundTranscludeFn);
          }
        }
      }
    }

    function createBoundTranscludeFn(scope, transcludeFn, previousBoundTranscludeFn) {
      function boundTranscludeFn(transcludedScope, cloneFn, controllers, futureParentElement, containingScope) {

        if (!transcludedScope) {
          transcludedScope = scope.$new(false, containingScope);
          transcludedScope.$$transcluded = true;
        }

        return transcludeFn(transcludedScope, cloneFn, {
          parentBoundTranscludeFn: previousBoundTranscludeFn,
          transcludeControllers: controllers,
          futureParentElement: futureParentElement
        });
      }

      // We need  to attach the transclusion slots onto the `boundTranscludeFn`
      // so that they are available inside the `controllersBoundTransclude` function
      var boundSlots = boundTranscludeFn.$$slots = createMap();
      for (var slotName in transcludeFn.$$slots) {
        if (transcludeFn.$$slots[slotName]) {
          boundSlots[slotName] = createBoundTranscludeFn(scope, transcludeFn.$$slots[slotName], previousBoundTranscludeFn);
        } else {
          boundSlots[slotName] = null;
        }
      }

      return boundTranscludeFn;
    }

    /**
     * Looks for directives on the given node and adds them to the directive collection which is
     * sorted.
     *
     * @param node Node to search.
     * @param directives An array to which the directives are added to. This array is sorted before
     *        the function returns.
     * @param attrs The shared attrs object which is used to populate the normalized attributes.
     * @param {number=} maxPriority Max directive priority.
     */
    function collectDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
      var nodeType = node.nodeType,
          attrsMap = attrs.$attr,
          match,
          className;

      switch (nodeType) {
        case NODE_TYPE_ELEMENT: /* Element */
          // use the node name: <directive>
          addDirective(directives,
              directiveNormalize(nodeName_(node)), 'E', maxPriority, ignoreDirective);

          // iterate over the attributes
          for (var attr, name, nName, ngAttrName, value, isNgAttr, nAttrs = node.attributes,
                   j = 0, jj = nAttrs && nAttrs.length; j < jj; j++) {
            var attrStartName = false;
            var attrEndName = false;

            attr = nAttrs[j];
            name = attr.name;
            value = trim(attr.value);

            // support ngAttr attribute binding
            ngAttrName = directiveNormalize(name);
            if (isNgAttr = NG_ATTR_BINDING.test(ngAttrName)) {
              name = name.replace(PREFIX_REGEXP, '')
                .substr(8).replace(/_(.)/g, function(match, letter) {
                  return letter.toUpperCase();
                });
            }

            var multiElementMatch = ngAttrName.match(MULTI_ELEMENT_DIR_RE);
            if (multiElementMatch && directiveIsMultiElement(multiElementMatch[1])) {
              attrStartName = name;
              attrEndName = name.substr(0, name.length - 5) + 'end';
              name = name.substr(0, name.length - 6);
            }

            nName = directiveNormalize(name.toLowerCase());
            attrsMap[nName] = name;
            if (isNgAttr || !attrs.hasOwnProperty(nName)) {
                attrs[nName] = value;
                if (getBooleanAttrName(node, nName)) {
                  attrs[nName] = true; // presence means true
                }
            }
            addAttrInterpolateDirective(node, directives, value, nName, isNgAttr);
            addDirective(directives, nName, 'A', maxPriority, ignoreDirective, attrStartName,
                          attrEndName);
          }

          // use class as directive
          className = node.className;
          if (isObject(className)) {
              // Maybe SVGAnimatedString
              className = className.animVal;
          }
          if (isString(className) && className !== '') {
            while (match = CLASS_DIRECTIVE_REGEXP.exec(className)) {
              nName = directiveNormalize(match[2]);
              if (addDirective(directives, nName, 'C', maxPriority, ignoreDirective)) {
                attrs[nName] = trim(match[3]);
              }
              className = className.substr(match.index + match[0].length);
            }
          }
          break;
        case NODE_TYPE_TEXT: /* Text Node */
          if (msie === 11) {
            // Workaround for #11781
            while (node.parentNode && node.nextSibling && node.nextSibling.nodeType === NODE_TYPE_TEXT) {
              node.nodeValue = node.nodeValue + node.nextSibling.nodeValue;
              node.parentNode.removeChild(node.nextSibling);
            }
          }
          addTextInterpolateDirective(directives, node.nodeValue);
          break;
        case NODE_TYPE_COMMENT: /* Comment */
          collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective);
          break;
      }

      directives.sort(byPriority);
      return directives;
    }

    function collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
      // function created because of performance, try/catch disables
      // the optimization of the whole function #14848
      try {
        var match = COMMENT_DIRECTIVE_REGEXP.exec(node.nodeValue);
        if (match) {
          var nName = directiveNormalize(match[1]);
          if (addDirective(directives, nName, 'M', maxPriority, ignoreDirective)) {
            attrs[nName] = trim(match[2]);
          }
        }
      } catch (e) {
        // turns out that under some circumstances IE9 throws errors when one attempts to read
        // comment's node value.
        // Just ignore it and continue. (Can't seem to reproduce in test case.)
      }
    }

    /**
     * Given a node with an directive-start it collects all of the siblings until it finds
     * directive-end.
     * @param node
     * @param attrStart
     * @param attrEnd
     * @returns {*}
     */
    function groupScan(node, attrStart, attrEnd) {
      var nodes = [];
      var depth = 0;
      if (attrStart && node.hasAttribute && node.hasAttribute(attrStart)) {
        do {
          if (!node) {
            throw $compileMinErr('uterdir',
                      "Unterminated attribute, found '{0}' but no matching '{1}' found.",
                      attrStart, attrEnd);
          }
          if (node.nodeType == NODE_TYPE_ELEMENT) {
            if (node.hasAttribute(attrStart)) depth++;
            if (node.hasAttribute(attrEnd)) depth--;
          }
          nodes.push(node);
          node = node.nextSibling;
        } while (depth > 0);
      } else {
        nodes.push(node);
      }

      return jqLite(nodes);
    }

    /**
     * Wrapper for linking function which converts normal linking function into a grouped
     * linking function.
     * @param linkFn
     * @param attrStart
     * @param attrEnd
     * @returns {Function}
     */
    function groupElementsLinkFnWrapper(linkFn, attrStart, attrEnd) {
      return function groupedElementsLink(scope, element, attrs, controllers, transcludeFn) {
        element = groupScan(element[0], attrStart, attrEnd);
        return linkFn(scope, element, attrs, controllers, transcludeFn);
      };
    }

    /**
     * A function generator that is used to support both eager and lazy compilation
     * linking function.
     * @param eager
     * @param $compileNodes
     * @param transcludeFn
     * @param maxPriority
     * @param ignoreDirective
     * @param previousCompileContext
     * @returns {Function}
     */
    function compilationGenerator(eager, $compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext) {
      var compiled;

      if (eager) {
        return compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);
      }
      return function lazyCompilation() {
        if (!compiled) {
          compiled = compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);

          // Null out all of these references in order to make them eligible for garbage collection
          // since this is a potentially long lived closure
          $compileNodes = transcludeFn = previousCompileContext = null;
        }
        return compiled.apply(this, arguments);
      };
    }

    /**
     * Once the directives have been collected, their compile functions are executed. This method
     * is responsible for inlining directive templates as well as terminating the application
     * of the directives if the terminal directive has been reached.
     *
     * @param {Array} directives Array of collected directives to execute their compile function.
     *        this needs to be pre-sorted by priority order.
     * @param {Node} compileNode The raw DOM node to apply the compile functions to
     * @param {Object} templateAttrs The shared attribute function
     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
     *                                                  scope argument is auto-generated to the new
     *                                                  child of the transcluded parent scope.
     * @param {JQLite} jqCollection If we are working on the root of the compile tree then this
     *                              argument has the root jqLite array so that we can replace nodes
     *                              on it.
     * @param {Object=} originalReplaceDirective An optional directive that will be ignored when
     *                                           compiling the transclusion.
     * @param {Array.<Function>} preLinkFns
     * @param {Array.<Function>} postLinkFns
     * @param {Object} previousCompileContext Context used for previous compilation of the current
     *                                        node
     * @returns {Function} linkFn
     */
    function applyDirectivesToNode(directives, compileNode, templateAttrs, transcludeFn,
                                   jqCollection, originalReplaceDirective, preLinkFns, postLinkFns,
                                   previousCompileContext) {
      previousCompileContext = previousCompileContext || {};

      var terminalPriority = -Number.MAX_VALUE,
          newScopeDirective = previousCompileContext.newScopeDirective,
          controllerDirectives = previousCompileContext.controllerDirectives,
          newIsolateScopeDirective = previousCompileContext.newIsolateScopeDirective,
          templateDirective = previousCompileContext.templateDirective,
          nonTlbTranscludeDirective = previousCompileContext.nonTlbTranscludeDirective,
          hasTranscludeDirective = false,
          hasTemplate = false,
          hasElementTranscludeDirective = previousCompileContext.hasElementTranscludeDirective,
          $compileNode = templateAttrs.$$element = jqLite(compileNode),
          directive,
          directiveName,
          $template,
          replaceDirective = originalReplaceDirective,
          childTranscludeFn = transcludeFn,
          linkFn,
          didScanForMultipleTransclusion = false,
          mightHaveMultipleTransclusionError = false,
          directiveValue;

      // executes all directives on the current element
      for (var i = 0, ii = directives.length; i < ii; i++) {
        directive = directives[i];
        var attrStart = directive.$$start;
        var attrEnd = directive.$$end;

        // collect multiblock sections
        if (attrStart) {
          $compileNode = groupScan(compileNode, attrStart, attrEnd);
        }
        $template = undefined;

        if (terminalPriority > directive.priority) {
          break; // prevent further processing of directives
        }

        if (directiveValue = directive.scope) {

          // skip the check for directives with async templates, we'll check the derived sync
          // directive when the template arrives
          if (!directive.templateUrl) {
            if (isObject(directiveValue)) {
              // This directive is trying to add an isolated scope.
              // Check that there is no scope of any kind already
              assertNoDuplicate('new/isolated scope', newIsolateScopeDirective || newScopeDirective,
                                directive, $compileNode);
              newIsolateScopeDirective = directive;
            } else {
              // This directive is trying to add a child scope.
              // Check that there is no isolated scope already
              assertNoDuplicate('new/isolated scope', newIsolateScopeDirective, directive,
                                $compileNode);
            }
          }

          newScopeDirective = newScopeDirective || directive;
        }

        directiveName = directive.name;

        // If we encounter a condition that can result in transclusion on the directive,
        // then scan ahead in the remaining directives for others that may cause a multiple
        // transclusion error to be thrown during the compilation process.  If a matching directive
        // is found, then we know that when we encounter a transcluded directive, we need to eagerly
        // compile the `transclude` function rather than doing it lazily in order to throw
        // exceptions at the correct time
        if (!didScanForMultipleTransclusion && ((directive.replace && (directive.templateUrl || directive.template))
            || (directive.transclude && !directive.$$tlb))) {
                var candidateDirective;

                for (var scanningIndex = i + 1; candidateDirective = directives[scanningIndex++];) {
                    if ((candidateDirective.transclude && !candidateDirective.$$tlb)
                        || (candidateDirective.replace && (candidateDirective.templateUrl || candidateDirective.template))) {
                        mightHaveMultipleTransclusionError = true;
                        break;
                    }
                }

                didScanForMultipleTransclusion = true;
        }

        if (!directive.templateUrl && directive.controller) {
          directiveValue = directive.controller;
          controllerDirectives = controllerDirectives || createMap();
          assertNoDuplicate("'" + directiveName + "' controller",
              controllerDirectives[directiveName], directive, $compileNode);
          controllerDirectives[directiveName] = directive;
        }

        if (directiveValue = directive.transclude) {
          hasTranscludeDirective = true;

          // Special case ngIf and ngRepeat so that we don't complain about duplicate transclusion.
          // This option should only be used by directives that know how to safely handle element transclusion,
          // where the transcluded nodes are added or replaced after linking.
          if (!directive.$$tlb) {
            assertNoDuplicate('transclusion', nonTlbTranscludeDirective, directive, $compileNode);
            nonTlbTranscludeDirective = directive;
          }

          if (directiveValue == 'element') {
            hasElementTranscludeDirective = true;
            terminalPriority = directive.priority;
            $template = $compileNode;
            $compileNode = templateAttrs.$$element =
                jqLite(compile.$$createComment(directiveName, templateAttrs[directiveName]));
            compileNode = $compileNode[0];
            replaceWith(jqCollection, sliceArgs($template), compileNode);

            // Support: Chrome < 50
            // https://github.com/angular/angular.js/issues/14041

            // In the versions of V8 prior to Chrome 50, the document fragment that is created
            // in the `replaceWith` function is improperly garbage collected despite still
            // being referenced by the `parentNode` property of all of the child nodes.  By adding
            // a reference to the fragment via a different property, we can avoid that incorrect
            // behavior.
            // TODO: remove this line after Chrome 50 has been released
            $template[0].$$parentNode = $template[0].parentNode;

            childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, terminalPriority,
                                        replaceDirective && replaceDirective.name, {
                                          // Don't pass in:
                                          // - controllerDirectives - otherwise we'll create duplicates controllers
                                          // - newIsolateScopeDirective or templateDirective - combining templates with
                                          //   element transclusion doesn't make sense.
                                          //
                                          // We need only nonTlbTranscludeDirective so that we prevent putting transclusion
                                          // on the same element more than once.
                                          nonTlbTranscludeDirective: nonTlbTranscludeDirective
                                        });
          } else {

            var slots = createMap();

            $template = jqLite(jqLiteClone(compileNode)).contents();

            if (isObject(directiveValue)) {

              // We have transclusion slots,
              // collect them up, compile them and store their transclusion functions
              $template = [];

              var slotMap = createMap();
              var filledSlots = createMap();

              // Parse the element selectors
              forEach(directiveValue, function(elementSelector, slotName) {
                // If an element selector starts with a ? then it is optional
                var optional = (elementSelector.charAt(0) === '?');
                elementSelector = optional ? elementSelector.substring(1) : elementSelector;

                slotMap[elementSelector] = slotName;

                // We explicitly assign `null` since this implies that a slot was defined but not filled.
                // Later when calling boundTransclusion functions with a slot name we only error if the
                // slot is `undefined`
                slots[slotName] = null;

                // filledSlots contains `true` for all slots that are either optional or have been
                // filled. This is used to check that we have not missed any required slots
                filledSlots[slotName] = optional;
              });

              // Add the matching elements into their slot
              forEach($compileNode.contents(), function(node) {
                var slotName = slotMap[directiveNormalize(nodeName_(node))];
                if (slotName) {
                  filledSlots[slotName] = true;
                  slots[slotName] = slots[slotName] || [];
                  slots[slotName].push(node);
                } else {
                  $template.push(node);
                }
              });

              // Check for required slots that were not filled
              forEach(filledSlots, function(filled, slotName) {
                if (!filled) {
                  throw $compileMinErr('reqslot', 'Required transclusion slot `{0}` was not filled.', slotName);
                }
              });

              for (var slotName in slots) {
                if (slots[slotName]) {
                  // Only define a transclusion function if the slot was filled
                  slots[slotName] = compilationGenerator(mightHaveMultipleTransclusionError, slots[slotName], transcludeFn);
                }
              }
            }

            $compileNode.empty(); // clear contents
            childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, undefined,
                undefined, { needsNewScope: directive.$$isolateScope || directive.$$newScope});
            childTranscludeFn.$$slots = slots;
          }
        }

        if (directive.template) {
          hasTemplate = true;
          assertNoDuplicate('template', templateDirective, directive, $compileNode);
          templateDirective = directive;

          directiveValue = (isFunction(directive.template))
              ? directive.template($compileNode, templateAttrs)
              : directive.template;

          directiveValue = denormalizeTemplate(directiveValue);

          if (directive.replace) {
            replaceDirective = directive;
            if (jqLiteIsTextNode(directiveValue)) {
              $template = [];
            } else {
              $template = removeComments(wrapTemplate(directive.templateNamespace, trim(directiveValue)));
            }
            compileNode = $template[0];

            if ($template.length != 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
              throw $compileMinErr('tplrt',
                  "Template for directive '{0}' must have exactly one root element. {1}",
                  directiveName, '');
            }

            replaceWith(jqCollection, $compileNode, compileNode);

            var newTemplateAttrs = {$attr: {}};

            // combine directives from the original node and from the template:
            // - take the array of directives for this element
            // - split it into two parts, those that already applied (processed) and those that weren't (unprocessed)
            // - collect directives from the template and sort them by priority
            // - combine directives as: processed + template + unprocessed
            var templateDirectives = collectDirectives(compileNode, [], newTemplateAttrs);
            var unprocessedDirectives = directives.splice(i + 1, directives.length - (i + 1));

            if (newIsolateScopeDirective || newScopeDirective) {
              // The original directive caused the current element to be replaced but this element
              // also needs to have a new scope, so we need to tell the template directives
              // that they would need to get their scope from further up, if they require transclusion
              markDirectiveScope(templateDirectives, newIsolateScopeDirective, newScopeDirective);
            }
            directives = directives.concat(templateDirectives).concat(unprocessedDirectives);
            mergeTemplateAttributes(templateAttrs, newTemplateAttrs);

            ii = directives.length;
          } else {
            $compileNode.html(directiveValue);
          }
        }

        if (directive.templateUrl) {
          hasTemplate = true;
          assertNoDuplicate('template', templateDirective, directive, $compileNode);
          templateDirective = directive;

          if (directive.replace) {
            replaceDirective = directive;
          }

          /* jshint -W021 */
          nodeLinkFn = compileTemplateUrl(directives.splice(i, directives.length - i), $compileNode,
          /* jshint +W021 */
              templateAttrs, jqCollection, hasTranscludeDirective && childTranscludeFn, preLinkFns, postLinkFns, {
                controllerDirectives: controllerDirectives,
                newScopeDirective: (newScopeDirective !== directive) && newScopeDirective,
                newIsolateScopeDirective: newIsolateScopeDirective,
                templateDirective: templateDirective,
                nonTlbTranscludeDirective: nonTlbTranscludeDirective
              });
          ii = directives.length;
        } else if (directive.compile) {
          try {
            linkFn = directive.compile($compileNode, templateAttrs, childTranscludeFn);
            var context = directive.$$originalDirective || directive;
            if (isFunction(linkFn)) {
              addLinkFns(null, bind(context, linkFn), attrStart, attrEnd);
            } else if (linkFn) {
              addLinkFns(bind(context, linkFn.pre), bind(context, linkFn.post), attrStart, attrEnd);
            }
          } catch (e) {
            $exceptionHandler(e, startingTag($compileNode));
          }
        }

        if (directive.terminal) {
          nodeLinkFn.terminal = true;
          terminalPriority = Math.max(terminalPriority, directive.priority);
        }

      }

      nodeLinkFn.scope = newScopeDirective && newScopeDirective.scope === true;
      nodeLinkFn.transcludeOnThisElement = hasTranscludeDirective;
      nodeLinkFn.templateOnThisElement = hasTemplate;
      nodeLinkFn.transclude = childTranscludeFn;

      previousCompileContext.hasElementTranscludeDirective = hasElementTranscludeDirective;

      // might be normal or delayed nodeLinkFn depending on if templateUrl is present
      return nodeLinkFn;

      ////////////////////

      function addLinkFns(pre, post, attrStart, attrEnd) {
        if (pre) {
          if (attrStart) pre = groupElementsLinkFnWrapper(pre, attrStart, attrEnd);
          pre.require = directive.require;
          pre.directiveName = directiveName;
          if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
            pre = cloneAndAnnotateFn(pre, {isolateScope: true});
          }
          preLinkFns.push(pre);
        }
        if (post) {
          if (attrStart) post = groupElementsLinkFnWrapper(post, attrStart, attrEnd);
          post.require = directive.require;
          post.directiveName = directiveName;
          if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
            post = cloneAndAnnotateFn(post, {isolateScope: true});
          }
          postLinkFns.push(post);
        }
      }

      function nodeLinkFn(childLinkFn, scope, linkNode, $rootElement, boundTranscludeFn) {
        var i, ii, linkFn, isolateScope, controllerScope, elementControllers, transcludeFn, $element,
            attrs, scopeBindingInfo;

        if (compileNode === linkNode) {
          attrs = templateAttrs;
          $element = templateAttrs.$$element;
        } else {
          $element = jqLite(linkNode);
          attrs = new Attributes($element, templateAttrs);
        }

        controllerScope = scope;
        if (newIsolateScopeDirective) {
          isolateScope = scope.$new(true);
        } else if (newScopeDirective) {
          controllerScope = scope.$parent;
        }

        if (boundTranscludeFn) {
          // track `boundTranscludeFn` so it can be unwrapped if `transcludeFn`
          // is later passed as `parentBoundTranscludeFn` to `publicLinkFn`
          transcludeFn = controllersBoundTransclude;
          transcludeFn.$$boundTransclude = boundTranscludeFn;
          // expose the slots on the `$transclude` function
          transcludeFn.isSlotFilled = function(slotName) {
            return !!boundTranscludeFn.$$slots[slotName];
          };
        }

        if (controllerDirectives) {
          elementControllers = setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective);
        }

        if (newIsolateScopeDirective) {
          // Initialize isolate scope bindings for new isolate scope directive.
          compile.$$addScopeInfo($element, isolateScope, true, !(templateDirective && (templateDirective === newIsolateScopeDirective ||
              templateDirective === newIsolateScopeDirective.$$originalDirective)));
          compile.$$addScopeClass($element, true);
          isolateScope.$$isolateBindings =
              newIsolateScopeDirective.$$isolateBindings;
          scopeBindingInfo = initializeDirectiveBindings(scope, attrs, isolateScope,
                                        isolateScope.$$isolateBindings,
                                        newIsolateScopeDirective);
          if (scopeBindingInfo.removeWatches) {
            isolateScope.$on('$destroy', scopeBindingInfo.removeWatches);
          }
        }

        // Initialize bindToController bindings
        for (var name in elementControllers) {
          var controllerDirective = controllerDirectives[name];
          var controller = elementControllers[name];
          var bindings = controllerDirective.$$bindings.bindToController;

          if (controller.identifier && bindings) {
            controller.bindingInfo =
              initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
          } else {
            controller.bindingInfo = {};
          }

          var controllerResult = controller();
          if (controllerResult !== controller.instance) {
            // If the controller constructor has a return value, overwrite the instance
            // from setupControllers
            controller.instance = controllerResult;
            $element.data('$' + controllerDirective.name + 'Controller', controllerResult);
            controller.bindingInfo.removeWatches && controller.bindingInfo.removeWatches();
            controller.bindingInfo =
              initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
          }
        }

        // Bind the required controllers to the controller, if `require` is an object and `bindToController` is truthy
        forEach(controllerDirectives, function(controllerDirective, name) {
          var require = controllerDirective.require;
          if (controllerDirective.bindToController && !isArray(require) && isObject(require)) {
            extend(elementControllers[name].instance, getControllers(name, require, $element, elementControllers));
          }
        });

        // Handle the init and destroy lifecycle hooks on all controllers that have them
        forEach(elementControllers, function(controller) {
          var controllerInstance = controller.instance;
          if (isFunction(controllerInstance.$onChanges)) {
            try {
              controllerInstance.$onChanges(controller.bindingInfo.initialChanges);
            } catch (e) {
              $exceptionHandler(e);
            }
          }
          if (isFunction(controllerInstance.$onInit)) {
            try {
              controllerInstance.$onInit();
            } catch (e) {
              $exceptionHandler(e);
            }
          }
          if (isFunction(controllerInstance.$doCheck)) {
            controllerScope.$watch(function() { controllerInstance.$doCheck(); });
            controllerInstance.$doCheck();
          }
          if (isFunction(controllerInstance.$onDestroy)) {
            controllerScope.$on('$destroy', function callOnDestroyHook() {
              controllerInstance.$onDestroy();
            });
          }
        });

        // PRELINKING
        for (i = 0, ii = preLinkFns.length; i < ii; i++) {
          linkFn = preLinkFns[i];
          invokeLinkFn(linkFn,
              linkFn.isolateScope ? isolateScope : scope,
              $element,
              attrs,
              linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
              transcludeFn
          );
        }

        // RECURSION
        // We only pass the isolate scope, if the isolate directive has a template,
        // otherwise the child elements do not belong to the isolate directive.
        var scopeToChild = scope;
        if (newIsolateScopeDirective && (newIsolateScopeDirective.template || newIsolateScopeDirective.templateUrl === null)) {
          scopeToChild = isolateScope;
        }
        childLinkFn && childLinkFn(scopeToChild, linkNode.childNodes, undefined, boundTranscludeFn);

        // POSTLINKING
        for (i = postLinkFns.length - 1; i >= 0; i--) {
          linkFn = postLinkFns[i];
          invokeLinkFn(linkFn,
              linkFn.isolateScope ? isolateScope : scope,
              $element,
              attrs,
              linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
              transcludeFn
          );
        }

        // Trigger $postLink lifecycle hooks
        forEach(elementControllers, function(controller) {
          var controllerInstance = controller.instance;
          if (isFunction(controllerInstance.$postLink)) {
            controllerInstance.$postLink();
          }
        });

        // This is the function that is injected as `$transclude`.
        // Note: all arguments are optional!
        function controllersBoundTransclude(scope, cloneAttachFn, futureParentElement, slotName) {
          var transcludeControllers;
          // No scope passed in:
          if (!isScope(scope)) {
            slotName = futureParentElement;
            futureParentElement = cloneAttachFn;
            cloneAttachFn = scope;
            scope = undefined;
          }

          if (hasElementTranscludeDirective) {
            transcludeControllers = elementControllers;
          }
          if (!futureParentElement) {
            futureParentElement = hasElementTranscludeDirective ? $element.parent() : $element;
          }
          if (slotName) {
            // slotTranscludeFn can be one of three things:
            //  * a transclude function - a filled slot
            //  * `null` - an optional slot that was not filled
            //  * `undefined` - a slot that was not declared (i.e. invalid)
            var slotTranscludeFn = boundTranscludeFn.$$slots[slotName];
            if (slotTranscludeFn) {
              return slotTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
            } else if (isUndefined(slotTranscludeFn)) {
              throw $compileMinErr('noslot',
               'No parent directive that requires a transclusion with slot name "{0}". ' +
               'Element: {1}',
               slotName, startingTag($element));
            }
          } else {
            return boundTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
          }
        }
      }
    }

    function getControllers(directiveName, require, $element, elementControllers) {
      var value;

      if (isString(require)) {
        var match = require.match(REQUIRE_PREFIX_REGEXP);
        var name = require.substring(match[0].length);
        var inheritType = match[1] || match[3];
        var optional = match[2] === '?';

        //If only parents then start at the parent element
        if (inheritType === '^^') {
          $element = $element.parent();
        //Otherwise attempt getting the controller from elementControllers in case
        //the element is transcluded (and has no data) and to avoid .data if possible
        } else {
          value = elementControllers && elementControllers[name];
          value = value && value.instance;
        }

        if (!value) {
          var dataName = '$' + name + 'Controller';
          value = inheritType ? $element.inheritedData(dataName) : $element.data(dataName);
        }

        if (!value && !optional) {
          throw $compileMinErr('ctreq',
              "Controller '{0}', required by directive '{1}', can't be found!",
              name, directiveName);
        }
      } else if (isArray(require)) {
        value = [];
        for (var i = 0, ii = require.length; i < ii; i++) {
          value[i] = getControllers(directiveName, require[i], $element, elementControllers);
        }
      } else if (isObject(require)) {
        value = {};
        forEach(require, function(controller, property) {
          value[property] = getControllers(directiveName, controller, $element, elementControllers);
        });
      }

      return value || null;
    }

    function setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective) {
      var elementControllers = createMap();
      for (var controllerKey in controllerDirectives) {
        var directive = controllerDirectives[controllerKey];
        var locals = {
          $scope: directive === newIsolateScopeDirective || directive.$$isolateScope ? isolateScope : scope,
          $element: $element,
          $attrs: attrs,
          $transclude: transcludeFn
        };

        var controller = directive.controller;
        if (controller == '@') {
          controller = attrs[directive.name];
        }

        var controllerInstance = $controller(controller, locals, true, directive.controllerAs);

        // For directives with element transclusion the element is a comment.
        // In this case .data will not attach any data.
        // Instead, we save the controllers for the element in a local hash and attach to .data
        // later, once we have the actual element.
        elementControllers[directive.name] = controllerInstance;
        $element.data('$' + directive.name + 'Controller', controllerInstance.instance);
      }
      return elementControllers;
    }

    // Depending upon the context in which a directive finds itself it might need to have a new isolated
    // or child scope created. For instance:
    // * if the directive has been pulled into a template because another directive with a higher priority
    // asked for element transclusion
    // * if the directive itself asks for transclusion but it is at the root of a template and the original
    // element was replaced. See https://github.com/angular/angular.js/issues/12936
    function markDirectiveScope(directives, isolateScope, newScope) {
      for (var j = 0, jj = directives.length; j < jj; j++) {
        directives[j] = inherit(directives[j], {$$isolateScope: isolateScope, $$newScope: newScope});
      }
    }

    /**
     * looks up the directive and decorates it with exception handling and proper parameters. We
     * call this the boundDirective.
     *
     * @param {string} name name of the directive to look up.
     * @param {string} location The directive must be found in specific format.
     *   String containing any of theses characters:
     *
     *   * `E`: element name
     *   * `A': attribute
     *   * `C`: class
     *   * `M`: comment
     * @returns {boolean} true if directive was added.
     */
    function addDirective(tDirectives, name, location, maxPriority, ignoreDirective, startAttrName,
                          endAttrName) {
      if (name === ignoreDirective) return null;
      var match = null;
      if (hasDirectives.hasOwnProperty(name)) {
        for (var directive, directives = $injector.get(name + Suffix),
            i = 0, ii = directives.length; i < ii; i++) {
          try {
            directive = directives[i];
            if ((isUndefined(maxPriority) || maxPriority > directive.priority) &&
                 directive.restrict.indexOf(location) != -1) {
              if (startAttrName) {
                directive = inherit(directive, {$$start: startAttrName, $$end: endAttrName});
              }
              if (!directive.$$bindings) {
                var bindings = directive.$$bindings =
                    parseDirectiveBindings(directive, directive.name);
                if (isObject(bindings.isolateScope)) {
                  directive.$$isolateBindings = bindings.isolateScope;
                }
              }
              tDirectives.push(directive);
              match = directive;
            }
          } catch (e) { $exceptionHandler(e); }
        }
      }
      return match;
    }


    /**
     * looks up the directive and returns true if it is a multi-element directive,
     * and therefore requires DOM nodes between -start and -end markers to be grouped
     * together.
     *
     * @param {string} name name of the directive to look up.
     * @returns true if directive was registered as multi-element.
     */
    function directiveIsMultiElement(name) {
      if (hasDirectives.hasOwnProperty(name)) {
        for (var directive, directives = $injector.get(name + Suffix),
            i = 0, ii = directives.length; i < ii; i++) {
          directive = directives[i];
          if (directive.multiElement) {
            return true;
          }
        }
      }
      return false;
    }

    /**
     * When the element is replaced with HTML template then the new attributes
     * on the template need to be merged with the existing attributes in the DOM.
     * The desired effect is to have both of the attributes present.
     *
     * @param {object} dst destination attributes (original DOM)
     * @param {object} src source attributes (from the directive template)
     */
    function mergeTemplateAttributes(dst, src) {
      var srcAttr = src.$attr,
          dstAttr = dst.$attr,
          $element = dst.$$element;

      // reapply the old attributes to the new element
      forEach(dst, function(value, key) {
        if (key.charAt(0) != '$') {
          if (src[key] && src[key] !== value) {
            value += (key === 'style' ? ';' : ' ') + src[key];
          }
          dst.$set(key, value, true, srcAttr[key]);
        }
      });

      // copy the new attributes on the old attrs object
      forEach(src, function(value, key) {
        // Check if we already set this attribute in the loop above.
        // `dst` will never contain hasOwnProperty as DOM parser won't let it.
        // You will get an "InvalidCharacterError: DOM Exception 5" error if you
        // have an attribute like "has-own-property" or "data-has-own-property", etc.
        if (!dst.hasOwnProperty(key) && key.charAt(0) !== '$') {
          dst[key] = value;

          if (key !== 'class' && key !== 'style') {
            dstAttr[key] = srcAttr[key];
          }
        }
      });
    }


    function compileTemplateUrl(directives, $compileNode, tAttrs,
        $rootElement, childTranscludeFn, preLinkFns, postLinkFns, previousCompileContext) {
      var linkQueue = [],
          afterTemplateNodeLinkFn,
          afterTemplateChildLinkFn,
          beforeTemplateCompileNode = $compileNode[0],
          origAsyncDirective = directives.shift(),
          derivedSyncDirective = inherit(origAsyncDirective, {
            templateUrl: null, transclude: null, replace: null, $$originalDirective: origAsyncDirective
          }),
          templateUrl = (isFunction(origAsyncDirective.templateUrl))
              ? origAsyncDirective.templateUrl($compileNode, tAttrs)
              : origAsyncDirective.templateUrl,
          templateNamespace = origAsyncDirective.templateNamespace;

      $compileNode.empty();

      $templateRequest(templateUrl)
        .then(function(content) {
          var compileNode, tempTemplateAttrs, $template, childBoundTranscludeFn;

          content = denormalizeTemplate(content);

          if (origAsyncDirective.replace) {
            if (jqLiteIsTextNode(content)) {
              $template = [];
            } else {
              $template = removeComments(wrapTemplate(templateNamespace, trim(content)));
            }
            compileNode = $template[0];

            if ($template.length != 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
              throw $compileMinErr('tplrt',
                  "Template for directive '{0}' must have exactly one root element. {1}",
                  origAsyncDirective.name, templateUrl);
            }

            tempTemplateAttrs = {$attr: {}};
            replaceWith($rootElement, $compileNode, compileNode);
            var templateDirectives = collectDirectives(compileNode, [], tempTemplateAttrs);

            if (isObject(origAsyncDirective.scope)) {
              // the original directive that caused the template to be loaded async required
              // an isolate scope
              markDirectiveScope(templateDirectives, true);
            }
            directives = templateDirectives.concat(directives);
            mergeTemplateAttributes(tAttrs, tempTemplateAttrs);
          } else {
            compileNode = beforeTemplateCompileNode;
            $compileNode.html(content);
          }

          directives.unshift(derivedSyncDirective);

          afterTemplateNodeLinkFn = applyDirectivesToNode(directives, compileNode, tAttrs,
              childTranscludeFn, $compileNode, origAsyncDirective, preLinkFns, postLinkFns,
              previousCompileContext);
          forEach($rootElement, function(node, i) {
            if (node == compileNode) {
              $rootElement[i] = $compileNode[0];
            }
          });
          afterTemplateChildLinkFn = compileNodes($compileNode[0].childNodes, childTranscludeFn);

          while (linkQueue.length) {
            var scope = linkQueue.shift(),
                beforeTemplateLinkNode = linkQueue.shift(),
                linkRootElement = linkQueue.shift(),
                boundTranscludeFn = linkQueue.shift(),
                linkNode = $compileNode[0];

            if (scope.$$destroyed) continue;

            if (beforeTemplateLinkNode !== beforeTemplateCompileNode) {
              var oldClasses = beforeTemplateLinkNode.className;

              if (!(previousCompileContext.hasElementTranscludeDirective &&
                  origAsyncDirective.replace)) {
                // it was cloned therefore we have to clone as well.
                linkNode = jqLiteClone(compileNode);
              }
              replaceWith(linkRootElement, jqLite(beforeTemplateLinkNode), linkNode);

              // Copy in CSS classes from original node
              safeAddClass(jqLite(linkNode), oldClasses);
            }
            if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
              childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
            } else {
              childBoundTranscludeFn = boundTranscludeFn;
            }
            afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, linkNode, $rootElement,
              childBoundTranscludeFn);
          }
          linkQueue = null;
        });

      return function delayedNodeLinkFn(ignoreChildLinkFn, scope, node, rootElement, boundTranscludeFn) {
        var childBoundTranscludeFn = boundTranscludeFn;
        if (scope.$$destroyed) return;
        if (linkQueue) {
          linkQueue.push(scope,
                         node,
                         rootElement,
                         childBoundTranscludeFn);
        } else {
          if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
            childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
          }
          afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, node, rootElement, childBoundTranscludeFn);
        }
      };
    }


    /**
     * Sorting function for bound directives.
     */
    function byPriority(a, b) {
      var diff = b.priority - a.priority;
      if (diff !== 0) return diff;
      if (a.name !== b.name) return (a.name < b.name) ? -1 : 1;
      return a.index - b.index;
    }

    function assertNoDuplicate(what, previousDirective, directive, element) {

      function wrapModuleNameIfDefined(moduleName) {
        return moduleName ?
          (' (module: ' + moduleName + ')') :
          '';
      }

      if (previousDirective) {
        throw $compileMinErr('multidir', 'Multiple directives [{0}{1}, {2}{3}] asking for {4} on: {5}',
            previousDirective.name, wrapModuleNameIfDefined(previousDirective.$$moduleName),
            directive.name, wrapModuleNameIfDefined(directive.$$moduleName), what, startingTag(element));
      }
    }


    function addTextInterpolateDirective(directives, text) {
      var interpolateFn = $interpolate(text, true);
      if (interpolateFn) {
        directives.push({
          priority: 0,
          compile: function textInterpolateCompileFn(templateNode) {
            var templateNodeParent = templateNode.parent(),
                hasCompileParent = !!templateNodeParent.length;

            // When transcluding a template that has bindings in the root
            // we don't have a parent and thus need to add the class during linking fn.
            if (hasCompileParent) compile.$$addBindingClass(templateNodeParent);

            return function textInterpolateLinkFn(scope, node) {
              var parent = node.parent();
              if (!hasCompileParent) compile.$$addBindingClass(parent);
              compile.$$addBindingInfo(parent, interpolateFn.expressions);
              scope.$watch(interpolateFn, function interpolateFnWatchAction(value) {
                node[0].nodeValue = value;
              });
            };
          }
        });
      }
    }


    function wrapTemplate(type, template) {
      type = lowercase(type || 'html');
      switch (type) {
      case 'svg':
      case 'math':
        var wrapper = window.document.createElement('div');
        wrapper.innerHTML = '<' + type + '>' + template + '</' + type + '>';
        return wrapper.childNodes[0].childNodes;
      default:
        return template;
      }
    }


    function getTrustedContext(node, attrNormalizedName) {
      if (attrNormalizedName == "srcdoc") {
        return $sce.HTML;
      }
      var tag = nodeName_(node);
      // maction[xlink:href] can source SVG.  It's not limited to <maction>.
      if (attrNormalizedName == "xlinkHref" ||
          (tag == "form" && attrNormalizedName == "action") ||
          (tag != "img" && (attrNormalizedName == "src" ||
                            attrNormalizedName == "ngSrc"))) {
        return $sce.RESOURCE_URL;
      }
    }


    function addAttrInterpolateDirective(node, directives, value, name, allOrNothing) {
      var trustedContext = getTrustedContext(node, name);
      allOrNothing = ALL_OR_NOTHING_ATTRS[name] || allOrNothing;

      var interpolateFn = $interpolate(value, true, trustedContext, allOrNothing);

      // no interpolation found -> ignore
      if (!interpolateFn) return;


      if (name === "multiple" && nodeName_(node) === "select") {
        throw $compileMinErr("selmulti",
            "Binding to the 'multiple' attribute is not supported. Element: {0}",
            startingTag(node));
      }

      directives.push({
        priority: 100,
        compile: function() {
            return {
              pre: function attrInterpolatePreLinkFn(scope, element, attr) {
                var $$observers = (attr.$$observers || (attr.$$observers = createMap()));

                if (EVENT_HANDLER_ATTR_REGEXP.test(name)) {
                  throw $compileMinErr('nodomevents',
                      "Interpolations for HTML DOM event attributes are disallowed.  Please use the " +
                          "ng- versions (such as ng-click instead of onclick) instead.");
                }

                // If the attribute has changed since last $interpolate()ed
                var newValue = attr[name];
                if (newValue !== value) {
                  // we need to interpolate again since the attribute value has been updated
                  // (e.g. by another directive's compile function)
                  // ensure unset/empty values make interpolateFn falsy
                  interpolateFn = newValue && $interpolate(newValue, true, trustedContext, allOrNothing);
                  value = newValue;
                }

                // if attribute was updated so that there is no interpolation going on we don't want to
                // register any observers
                if (!interpolateFn) return;

                // initialize attr object so that it's ready in case we need the value for isolate
                // scope initialization, otherwise the value would not be available from isolate
                // directive's linking fn during linking phase
                attr[name] = interpolateFn(scope);

                ($$observers[name] || ($$observers[name] = [])).$$inter = true;
                (attr.$$observers && attr.$$observers[name].$$scope || scope).
                  $watch(interpolateFn, function interpolateFnWatchAction(newValue, oldValue) {
                    //special case for class attribute addition + removal
                    //so that class changes can tap into the animation
                    //hooks provided by the $animate service. Be sure to
                    //skip animations when the first digest occurs (when
                    //both the new and the old values are the same) since
                    //the CSS classes are the non-interpolated values
                    if (name === 'class' && newValue != oldValue) {
                      attr.$updateClass(newValue, oldValue);
                    } else {
                      attr.$set(name, newValue);
                    }
                  });
              }
            };
          }
      });
    }


    /**
     * This is a special jqLite.replaceWith, which can replace items which
     * have no parents, provided that the containing jqLite collection is provided.
     *
     * @param {JqLite=} $rootElement The root of the compile tree. Used so that we can replace nodes
     *                               in the root of the tree.
     * @param {JqLite} elementsToRemove The jqLite element which we are going to replace. We keep
     *                                  the shell, but replace its DOM node reference.
     * @param {Node} newNode The new DOM node.
     */
    function replaceWith($rootElement, elementsToRemove, newNode) {
      var firstElementToRemove = elementsToRemove[0],
          removeCount = elementsToRemove.length,
          parent = firstElementToRemove.parentNode,
          i, ii;

      if ($rootElement) {
        for (i = 0, ii = $rootElement.length; i < ii; i++) {
          if ($rootElement[i] == firstElementToRemove) {
            $rootElement[i++] = newNode;
            for (var j = i, j2 = j + removeCount - 1,
                     jj = $rootElement.length;
                 j < jj; j++, j2++) {
              if (j2 < jj) {
                $rootElement[j] = $rootElement[j2];
              } else {
                delete $rootElement[j];
              }
            }
            $rootElement.length -= removeCount - 1;

            // If the replaced element is also the jQuery .context then replace it
            // .context is a deprecated jQuery api, so we should set it only when jQuery set it
            // http://api.jquery.com/context/
            if ($rootElement.context === firstElementToRemove) {
              $rootElement.context = newNode;
            }
            break;
          }
        }
      }

      if (parent) {
        parent.replaceChild(newNode, firstElementToRemove);
      }

      // Append all the `elementsToRemove` to a fragment. This will...
      // - remove them from the DOM
      // - allow them to still be traversed with .nextSibling
      // - allow a single fragment.qSA to fetch all elements being removed
      var fragment = window.document.createDocumentFragment();
      for (i = 0; i < removeCount; i++) {
        fragment.appendChild(elementsToRemove[i]);
      }

      if (jqLite.hasData(firstElementToRemove)) {
        // Copy over user data (that includes Angular's $scope etc.). Don't copy private
        // data here because there's no public interface in jQuery to do that and copying over
        // event listeners (which is the main use of private data) wouldn't work anyway.
        jqLite.data(newNode, jqLite.data(firstElementToRemove));

        // Remove $destroy event listeners from `firstElementToRemove`
        jqLite(firstElementToRemove).off('$destroy');
      }

      // Cleanup any data/listeners on the elements and children.
      // This includes invoking the $destroy event on any elements with listeners.
      jqLite.cleanData(fragment.querySelectorAll('*'));

      // Update the jqLite collection to only contain the `newNode`
      for (i = 1; i < removeCount; i++) {
        delete elementsToRemove[i];
      }
      elementsToRemove[0] = newNode;
      elementsToRemove.length = 1;
    }


    function cloneAndAnnotateFn(fn, annotation) {
      return extend(function() { return fn.apply(null, arguments); }, fn, annotation);
    }


    function invokeLinkFn(linkFn, scope, $element, attrs, controllers, transcludeFn) {
      try {
        linkFn(scope, $element, attrs, controllers, transcludeFn);
      } catch (e) {
        $exceptionHandler(e, startingTag($element));
      }
    }


    // Set up $watches for isolate scope and controller bindings. This process
    // only occurs for isolate scopes and new scopes with controllerAs.
    function initializeDirectiveBindings(scope, attrs, destination, bindings, directive) {
      var removeWatchCollection = [];
      var initialChanges = {};
      var changes;
      forEach(bindings, function initializeBinding(definition, scopeName) {
        var attrName = definition.attrName,
        optional = definition.optional,
        mode = definition.mode, // @, =, <, or &
        lastValue,
        parentGet, parentSet, compare, removeWatch;

        switch (mode) {

          case '@':
            if (!optional && !hasOwnProperty.call(attrs, attrName)) {
              destination[scopeName] = attrs[attrName] = void 0;
            }
            attrs.$observe(attrName, function(value) {
              if (isString(value) || isBoolean(value)) {
                var oldValue = destination[scopeName];
                recordChanges(scopeName, value, oldValue);
                destination[scopeName] = value;
              }
            });
            attrs.$$observers[attrName].$$scope = scope;
            lastValue = attrs[attrName];
            if (isString(lastValue)) {
              // If the attribute has been provided then we trigger an interpolation to ensure
              // the value is there for use in the link fn
              destination[scopeName] = $interpolate(lastValue)(scope);
            } else if (isBoolean(lastValue)) {
              // If the attributes is one of the BOOLEAN_ATTR then Angular will have converted
              // the value to boolean rather than a string, so we special case this situation
              destination[scopeName] = lastValue;
            }
            initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);
            break;

          case '=':
            if (!hasOwnProperty.call(attrs, attrName)) {
              if (optional) break;
              attrs[attrName] = void 0;
            }
            if (optional && !attrs[attrName]) break;

            parentGet = $parse(attrs[attrName]);
            if (parentGet.literal) {
              compare = equals;
            } else {
              compare = function simpleCompare(a, b) { return a === b || (a !== a && b !== b); };
            }
            parentSet = parentGet.assign || function() {
              // reset the change, or we will throw this exception on every $digest
              lastValue = destination[scopeName] = parentGet(scope);
              throw $compileMinErr('nonassign',
                  "Expression '{0}' in attribute '{1}' used with directive '{2}' is non-assignable!",
                  attrs[attrName], attrName, directive.name);
            };
            lastValue = destination[scopeName] = parentGet(scope);
            var parentValueWatch = function parentValueWatch(parentValue) {
              if (!compare(parentValue, destination[scopeName])) {
                // we are out of sync and need to copy
                if (!compare(parentValue, lastValue)) {
                  // parent changed and it has precedence
                  destination[scopeName] = parentValue;
                } else {
                  // if the parent can be assigned then do so
                  parentSet(scope, parentValue = destination[scopeName]);
                }
              }
              return lastValue = parentValue;
            };
            parentValueWatch.$stateful = true;
            if (definition.collection) {
              removeWatch = scope.$watchCollection(attrs[attrName], parentValueWatch);
            } else {
              removeWatch = scope.$watch($parse(attrs[attrName], parentValueWatch), null, parentGet.literal);
            }
            removeWatchCollection.push(removeWatch);
            break;

          case '<':
            if (!hasOwnProperty.call(attrs, attrName)) {
              if (optional) break;
              attrs[attrName] = void 0;
            }
            if (optional && !attrs[attrName]) break;

            parentGet = $parse(attrs[attrName]);

            var initialValue = destination[scopeName] = parentGet(scope);
            initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);

            removeWatch = scope.$watch(parentGet, function parentValueWatchAction(newValue, oldValue) {
              if (oldValue === newValue) {
                if (oldValue === initialValue) return;
                oldValue = initialValue;
              }
              recordChanges(scopeName, newValue, oldValue);
              destination[scopeName] = newValue;
            }, parentGet.literal);

            removeWatchCollection.push(removeWatch);
            break;

          case '&':
            // Don't assign Object.prototype method to scope
            parentGet = attrs.hasOwnProperty(attrName) ? $parse(attrs[attrName]) : noop;

            // Don't assign noop to destination if expression is not valid
            if (parentGet === noop && optional) break;

            destination[scopeName] = function(locals) {
              return parentGet(scope, locals);
            };
            break;
        }
      });

      function recordChanges(key, currentValue, previousValue) {
        if (isFunction(destination.$onChanges) && currentValue !== previousValue) {
          // If we have not already scheduled the top level onChangesQueue handler then do so now
          if (!onChangesQueue) {
            scope.$$postDigest(flushOnChangesQueue);
            onChangesQueue = [];
          }
          // If we have not already queued a trigger of onChanges for this controller then do so now
          if (!changes) {
            changes = {};
            onChangesQueue.push(triggerOnChangesHook);
          }
          // If the has been a change on this property already then we need to reuse the previous value
          if (changes[key]) {
            previousValue = changes[key].previousValue;
          }
          // Store this change
          changes[key] = new SimpleChange(previousValue, currentValue);
        }
      }

      function triggerOnChangesHook() {
        destination.$onChanges(changes);
        // Now clear the changes so that we schedule onChanges when more changes arrive
        changes = undefined;
      }

      return {
        initialChanges: initialChanges,
        removeWatches: removeWatchCollection.length && function removeWatches() {
          for (var i = 0, ii = removeWatchCollection.length; i < ii; ++i) {
            removeWatchCollection[i]();
          }
        }
      };
    }
  }];
}

function SimpleChange(previous, current) {
  this.previousValue = previous;
  this.currentValue = current;
}
SimpleChange.prototype.isFirstChange = function() { return this.previousValue === _UNINITIALIZED_VALUE; };


var PREFIX_REGEXP = /^((?:x|data)[\:\-_])/i;
/**
 * Converts all accepted directives format into proper directive name.
 * @param name Name to normalize
 */
function directiveNormalize(name) {
  return camelCase(name.replace(PREFIX_REGEXP, ''));
}

/**
 * @ngdoc type
 * @name $compile.directive.Attributes
 *
 * @description
 * A shared object between directive compile / linking functions which contains normalized DOM
 * element attributes. The values reflect current binding state `{{ }}`. The normalization is
 * needed since all of these are treated as equivalent in Angular:
 *
 * ```
 *    <span ng:bind="a" ng-bind="a" data-ng-bind="a" x-ng-bind="a">
 * ```
 */

/**
 * @ngdoc property
 * @name $compile.directive.Attributes#$attr
 *
 * @description
 * A map of DOM element attribute names to the normalized name. This is
 * needed to do reverse lookup from normalized name back to actual name.
 */


/**
 * @ngdoc method
 * @name $compile.directive.Attributes#$set
 * @kind function
 *
 * @description
 * Set DOM element attribute value.
 *
 *
 * @param {string} name Normalized element attribute name of the property to modify. The name is
 *          reverse-translated using the {@link ng.$compile.directive.Attributes#$attr $attr}
 *          property to the original name.
 * @param {string} value Value to set the attribute to. The value can be an interpolated string.
 */



/**
 * Closure compiler type information
 */

function nodesetLinkingFn(
  /* angular.Scope */ scope,
  /* NodeList */ nodeList,
  /* Element */ rootElement,
  /* function(Function) */ boundTranscludeFn
) {}

function directiveLinkingFn(
  /* nodesetLinkingFn */ nodesetLinkingFn,
  /* angular.Scope */ scope,
  /* Node */ node,
  /* Element */ rootElement,
  /* function(Function) */ boundTranscludeFn
) {}

function tokenDifference(str1, str2) {
  var values = '',
      tokens1 = str1.split(/\s+/),
      tokens2 = str2.split(/\s+/);

  outer:
  for (var i = 0; i < tokens1.length; i++) {
    var token = tokens1[i];
    for (var j = 0; j < tokens2.length; j++) {
      if (token == tokens2[j]) continue outer;
    }
    values += (values.length > 0 ? ' ' : '') + token;
  }
  return values;
}

function removeComments(jqNodes) {
  jqNodes = jqLite(jqNodes);
  var i = jqNodes.length;

  if (i <= 1) {
    return jqNodes;
  }

  while (i--) {
    var node = jqNodes[i];
    if (node.nodeType === NODE_TYPE_COMMENT) {
      splice.call(jqNodes, i, 1);
    }
  }
  return jqNodes;
}

var $controllerMinErr = minErr('$controller');


var CNTRL_REG = /^(\S+)(\s+as\s+([\w$]+))?$/;
function identifierForController(controller, ident) {
  if (ident && isString(ident)) return ident;
  if (isString(controller)) {
    var match = CNTRL_REG.exec(controller);
    if (match) return match[3];
  }
}


/**
 * @ngdoc provider
 * @name $controllerProvider
 * @description
 * The {@link ng.$controller $controller service} is used by Angular to create new
 * controllers.
 *
 * This provider allows controller registration via the
 * {@link ng.$controllerProvider#register register} method.
 */
function $ControllerProvider() {
  var controllers = {},
      globals = false;

  /**
   * @ngdoc method
   * @name $controllerProvider#has
   * @param {string} name Controller name to check.
   */
  this.has = function(name) {
    return controllers.hasOwnProperty(name);
  };

  /**
   * @ngdoc method
   * @name $controllerProvider#register
   * @param {string|Object} name Controller name, or an object map of controllers where the keys are
   *    the names and the values are the constructors.
   * @param {Function|Array} constructor Controller constructor fn (optionally decorated with DI
   *    annotations in the array notation).
   */
  this.register = function(name, constructor) {
    assertNotHasOwnProperty(name, 'controller');
    if (isObject(name)) {
      extend(controllers, name);
    } else {
      controllers[name] = constructor;
    }
  };

  /**
   * @ngdoc method
   * @name $controllerProvider#allowGlobals
   * @description If called, allows `$controller` to find controller constructors on `window`
   */
  this.allowGlobals = function() {
    globals = true;
  };


  this.$get = ['$injector', '$window', function($injector, $window) {

    /**
     * @ngdoc service
     * @name $controller
     * @requires $injector
     *
     * @param {Function|string} constructor If called with a function then it's considered to be the
     *    controller constructor function. Otherwise it's considered to be a string which is used
     *    to retrieve the controller constructor using the following steps:
     *
     *    * check if a controller with given name is registered via `$controllerProvider`
     *    * check if evaluating the string on the current scope returns a constructor
     *    * if $controllerProvider#allowGlobals, check `window[constructor]` on the global
     *      `window` object (not recommended)
     *
     *    The string can use the `controller as property` syntax, where the controller instance is published
     *    as the specified property on the `scope`; the `scope` must be injected into `locals` param for this
     *    to work correctly.
     *
     * @param {Object} locals Injection locals for Controller.
     * @return {Object} Instance of given controller.
     *
     * @description
     * `$controller` service is responsible for instantiating controllers.
     *
     * It's just a simple call to {@link auto.$injector $injector}, but extracted into
     * a service, so that one can override this service with [BC version](https://gist.github.com/1649788).
     */
    return function $controller(expression, locals, later, ident) {
      // PRIVATE API:
      //   param `later` --- indicates that the controller's constructor is invoked at a later time.
      //                     If true, $controller will allocate the object with the correct
      //                     prototype chain, but will not invoke the controller until a returned
      //                     callback is invoked.
      //   param `ident` --- An optional label which overrides the label parsed from the controller
      //                     expression, if any.
      var instance, match, constructor, identifier;
      later = later === true;
      if (ident && isString(ident)) {
        identifier = ident;
      }

      if (isString(expression)) {
        match = expression.match(CNTRL_REG);
        if (!match) {
          throw $controllerMinErr('ctrlfmt',
            "Badly formed controller string '{0}'. " +
            "Must match `__name__ as __id__` or `__name__`.", expression);
        }
        constructor = match[1],
        identifier = identifier || match[3];
        expression = controllers.hasOwnProperty(constructor)
            ? controllers[constructor]
            : getter(locals.$scope, constructor, true) ||
                (globals ? getter($window, constructor, true) : undefined);

        assertArgFn(expression, constructor, true);
      }

      if (later) {
        // Instantiate controller later:
        // This machinery is used to create an instance of the object before calling the
        // controller's constructor itself.
        //
        // This allows properties to be added to the controller before the constructor is
        // invoked. Primarily, this is used for isolate scope bindings in $compile.
        //
        // This feature is not intended for use by applications, and is thus not documented
        // publicly.
        // Object creation: http://jsperf.com/create-constructor/2
        var controllerPrototype = (isArray(expression) ?
          expression[expression.length - 1] : expression).prototype;
        instance = Object.create(controllerPrototype || null);

        if (identifier) {
          addIdentifier(locals, identifier, instance, constructor || expression.name);
        }

        var instantiate;
        return instantiate = extend(function $controllerInit() {
          var result = $injector.invoke(expression, instance, locals, constructor);
          if (result !== instance && (isObject(result) || isFunction(result))) {
            instance = result;
            if (identifier) {
              // If result changed, re-assign controllerAs value to scope.
              addIdentifier(locals, identifier, instance, constructor || expression.name);
            }
          }
          return instance;
        }, {
          instance: instance,
          identifier: identifier
        });
      }

      instance = $injector.instantiate(expression, locals, constructor);

      if (identifier) {
        addIdentifier(locals, identifier, instance, constructor || expression.name);
      }

      return instance;
    };

    function addIdentifier(locals, identifier, instance, name) {
      if (!(locals && isObject(locals.$scope))) {
        throw minErr('$controller')('noscp',
          "Cannot export controller '{0}' as '{1}'! No $scope object provided via `locals`.",
          name, identifier);
      }

      locals.$scope[identifier] = instance;
    }
  }];
}

/**
 * @ngdoc service
 * @name $document
 * @requires $window
 *
 * @description
 * A {@link angular.element jQuery or jqLite} wrapper for the browser's `window.document` object.
 *
 * @example
   <example module="documentExample">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <p>$document title: <b ng-bind="title"></b></p>
         <p>window.document title: <b ng-bind="windowTitle"></b></p>
       </div>
     </file>
     <file name="script.js">
       angular.module('documentExample', [])
         .controller('ExampleController', ['$scope', '$document', function($scope, $document) {
           $scope.title = $document[0].title;
           $scope.windowTitle = angular.element(window.document)[0].title;
         }]);
     </file>
   </example>
 */
function $DocumentProvider() {
  this.$get = ['$window', function(window) {
    return jqLite(window.document);
  }];
}

/**
 * @ngdoc service
 * @name $exceptionHandler
 * @requires ng.$log
 *
 * @description
 * Any uncaught exception in angular expressions is delegated to this service.
 * The default implementation simply delegates to `$log.error` which logs it into
 * the browser console.
 *
 * In unit tests, if `angular-mocks.js` is loaded, this service is overridden by
 * {@link ngMock.$exceptionHandler mock $exceptionHandler} which aids in testing.
 *
 * ## Example:
 *
 * The example below will overwrite the default `$exceptionHandler` in order to (a) log uncaught
 * errors to the backend for later inspection by the developers and (b) to use `$log.warn()` instead
 * of `$log.error()`.
 *
 * ```js
 *   angular.
 *     module('exceptionOverwrite', []).
 *     factory('$exceptionHandler', ['$log', 'logErrorsToBackend', function($log, logErrorsToBackend) {
 *       return function myExceptionHandler(exception, cause) {
 *         logErrorsToBackend(exception, cause);
 *         $log.warn(exception, cause);
 *       };
 *     }]);
 * ```
 *
 * <hr />
 * Note, that code executed in event-listeners (even those registered using jqLite's `on`/`bind`
 * methods) does not delegate exceptions to the {@link ng.$exceptionHandler $exceptionHandler}
 * (unless executed during a digest).
 *
 * If you wish, you can manually delegate exceptions, e.g.
 * `try { ... } catch(e) { $exceptionHandler(e); }`
 *
 * @param {Error} exception Exception associated with the error.
 * @param {string=} cause Optional information about the context in which
 *       the error was thrown.
 *
 */
function $ExceptionHandlerProvider() {
  this.$get = ['$log', function($log) {
    return function(exception, cause) {
      $log.error.apply($log, arguments);
    };
  }];
}

var $$ForceReflowProvider = function() {
  this.$get = ['$document', function($document) {
    return function(domNode) {
      //the line below will force the browser to perform a repaint so
      //that all the animated elements within the animation frame will
      //be properly updated and drawn on screen. This is required to
      //ensure that the preparation animation is properly flushed so that
      //the active state picks up from there. DO NOT REMOVE THIS LINE.
      //DO NOT OPTIMIZE THIS LINE. THE MINIFIER WILL REMOVE IT OTHERWISE WHICH
      //WILL RESULT IN AN UNPREDICTABLE BUG THAT IS VERY HARD TO TRACK DOWN AND
      //WILL TAKE YEARS AWAY FROM YOUR LIFE.
      if (domNode) {
        if (!domNode.nodeType && domNode instanceof jqLite) {
          domNode = domNode[0];
        }
      } else {
        domNode = $document[0].body;
      }
      return domNode.offsetWidth + 1;
    };
  }];
};

var APPLICATION_JSON = 'application/json';
var CONTENT_TYPE_APPLICATION_JSON = {'Content-Type': APPLICATION_JSON + ';charset=utf-8'};
var JSON_START = /^\[|^\{(?!\{)/;
var JSON_ENDS = {
  '[': /]$/,
  '{': /}$/
};
var JSON_PROTECTION_PREFIX = /^\)\]\}',?\n/;
var $httpMinErr = minErr('$http');
var $httpMinErrLegacyFn = function(method) {
  return function() {
    throw $httpMinErr('legacy', 'The method `{0}` on the promise returned from `$http` has been disabled.', method);
  };
};

function serializeValue(v) {
  if (isObject(v)) {
    return isDate(v) ? v.toISOString() : toJson(v);
  }
  return v;
}


function $HttpParamSerializerProvider() {
  /**
   * @ngdoc service
   * @name $httpParamSerializer
   * @description
   *
   * Default {@link $http `$http`} params serializer that converts objects to strings
   * according to the following rules:
   *
   * * `{'foo': 'bar'}` results in `foo=bar`
   * * `{'foo': Date.now()}` results in `foo=2015-04-01T09%3A50%3A49.262Z` (`toISOString()` and encoded representation of a Date object)
   * * `{'foo': ['bar', 'baz']}` results in `foo=bar&foo=baz` (repeated key for each array element)
   * * `{'foo': {'bar':'baz'}}` results in `foo=%7B%22bar%22%3A%22baz%22%7D` (stringified and encoded representation of an object)
   *
   * Note that serializer will sort the request parameters alphabetically.
   * */

  this.$get = function() {
    return function ngParamSerializer(params) {
      if (!params) return '';
      var parts = [];
      forEachSorted(params, function(value, key) {
        if (value === null || isUndefined(value)) return;
        if (isArray(value)) {
          forEach(value, function(v) {
            parts.push(encodeUriQuery(key)  + '=' + encodeUriQuery(serializeValue(v)));
          });
        } else {
          parts.push(encodeUriQuery(key) + '=' + encodeUriQuery(serializeValue(value)));
        }
      });

      return parts.join('&');
    };
  };
}

function $HttpParamSerializerJQLikeProvider() {
  /**
   * @ngdoc service
   * @name $httpParamSerializerJQLike
   * @description
   *
   * Alternative {@link $http `$http`} params serializer that follows
   * jQuery's [`param()`](http://api.jquery.com/jquery.param/) method logic.
   * The serializer will also sort the params alphabetically.
   *
   * To use it for serializing `$http` request parameters, set it as the `paramSerializer` property:
   *
   * ```js
   * $http({
   *   url: myUrl,
   *   method: 'GET',
   *   params: myParams,
   *   paramSerializer: '$httpParamSerializerJQLike'
   * });
   * ```
   *
   * It is also possible to set it as the default `paramSerializer` in the
   * {@link $httpProvider#defaults `$httpProvider`}.
   *
   * Additionally, you can inject the serializer and use it explicitly, for example to serialize
   * form data for submission:
   *
   * ```js
   * .controller(function($http, $httpParamSerializerJQLike) {
   *   //...
   *
   *   $http({
   *     url: myUrl,
   *     method: 'POST',
   *     data: $httpParamSerializerJQLike(myData),
   *     headers: {
   *       'Content-Type': 'application/x-www-form-urlencoded'
   *     }
   *   });
   *
   * });
   * ```
   *
   * */
  this.$get = function() {
    return function jQueryLikeParamSerializer(params) {
      if (!params) return '';
      var parts = [];
      serialize(params, '', true);
      return parts.join('&');

      function serialize(toSerialize, prefix, topLevel) {
        if (toSerialize === null || isUndefined(toSerialize)) return;
        if (isArray(toSerialize)) {
          forEach(toSerialize, function(value, index) {
            serialize(value, prefix + '[' + (isObject(value) ? index : '') + ']');
          });
        } else if (isObject(toSerialize) && !isDate(toSerialize)) {
          forEachSorted(toSerialize, function(value, key) {
            serialize(value, prefix +
                (topLevel ? '' : '[') +
                key +
                (topLevel ? '' : ']'));
          });
        } else {
          parts.push(encodeUriQuery(prefix) + '=' + encodeUriQuery(serializeValue(toSerialize)));
        }
      }
    };
  };
}

function defaultHttpResponseTransform(data, headers) {
  if (isString(data)) {
    // Strip json vulnerability protection prefix and trim whitespace
    var tempData = data.replace(JSON_PROTECTION_PREFIX, '').trim();

    if (tempData) {
      var contentType = headers('Content-Type');
      if ((contentType && (contentType.indexOf(APPLICATION_JSON) === 0)) || isJsonLike(tempData)) {
        data = fromJson(tempData);
      }
    }
  }

  return data;
}

function isJsonLike(str) {
    var jsonStart = str.match(JSON_START);
    return jsonStart && JSON_ENDS[jsonStart[0]].test(str);
}

/**
 * Parse headers into key value object
 *
 * @param {string} headers Raw headers as a string
 * @returns {Object} Parsed headers as key value object
 */
function parseHeaders(headers) {
  var parsed = createMap(), i;

  function fillInParsed(key, val) {
    if (key) {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  }

  if (isString(headers)) {
    forEach(headers.split('\n'), function(line) {
      i = line.indexOf(':');
      fillInParsed(lowercase(trim(line.substr(0, i))), trim(line.substr(i + 1)));
    });
  } else if (isObject(headers)) {
    forEach(headers, function(headerVal, headerKey) {
      fillInParsed(lowercase(headerKey), trim(headerVal));
    });
  }

  return parsed;
}


/**
 * Returns a function that provides access to parsed headers.
 *
 * Headers are lazy parsed when first requested.
 * @see parseHeaders
 *
 * @param {(string|Object)} headers Headers to provide access to.
 * @returns {function(string=)} Returns a getter function which if called with:
 *
 *   - if called with single an argument returns a single header value or null
 *   - if called with no arguments returns an object containing all headers.
 */
function headersGetter(headers) {
  var headersObj;

  return function(name) {
    if (!headersObj) headersObj =  parseHeaders(headers);

    if (name) {
      var value = headersObj[lowercase(name)];
      if (value === void 0) {
        value = null;
      }
      return value;
    }

    return headersObj;
  };
}


/**
 * Chain all given functions
 *
 * This function is used for both request and response transforming
 *
 * @param {*} data Data to transform.
 * @param {function(string=)} headers HTTP headers getter fn.
 * @param {number} status HTTP status code of the response.
 * @param {(Function|Array.<Function>)} fns Function or an array of functions.
 * @returns {*} Transformed data.
 */
function transformData(data, headers, status, fns) {
  if (isFunction(fns)) {
    return fns(data, headers, status);
  }

  forEach(fns, function(fn) {
    data = fn(data, headers, status);
  });

  return data;
}


function isSuccess(status) {
  return 200 <= status && status < 300;
}


/**
 * @ngdoc provider
 * @name $httpProvider
 * @description
 * Use `$httpProvider` to change the default behavior of the {@link ng.$http $http} service.
 * */
function $HttpProvider() {
  /**
   * @ngdoc property
   * @name $httpProvider#defaults
   * @description
   *
   * Object containing default values for all {@link ng.$http $http} requests.
   *
   * - **`defaults.cache`** - {boolean|Object} - A boolean value or object created with
   * {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of HTTP responses
   * by default. See {@link $http#caching $http Caching} for more information.
   *
   * - **`defaults.xsrfCookieName`** - {string} - Name of cookie containing the XSRF token.
   * Defaults value is `'XSRF-TOKEN'`.
   *
   * - **`defaults.xsrfHeaderName`** - {string} - Name of HTTP header to populate with the
   * XSRF token. Defaults value is `'X-XSRF-TOKEN'`.
   *
   * - **`defaults.headers`** - {Object} - Default headers for all $http requests.
   * Refer to {@link ng.$http#setting-http-headers $http} for documentation on
   * setting default headers.
   *     - **`defaults.headers.common`**
   *     - **`defaults.headers.post`**
   *     - **`defaults.headers.put`**
   *     - **`defaults.headers.patch`**
   *
   *
   * - **`defaults.paramSerializer`** - `{string|function(Object<string,string>):string}` - A function
   *  used to the prepare string representation of request parameters (specified as an object).
   *  If specified as string, it is interpreted as a function registered with the {@link auto.$injector $injector}.
   *  Defaults to {@link ng.$httpParamSerializer $httpParamSerializer}.
   *
   **/
  var defaults = this.defaults = {
    // transform incoming response data
    transformResponse: [defaultHttpResponseTransform],

    // transform outgoing request data
    transformRequest: [function(d) {
      return isObject(d) && !isFile(d) && !isBlob(d) && !isFormData(d) ? toJson(d) : d;
    }],

    // default headers
    headers: {
      common: {
        'Accept': 'application/json, text/plain, */*'
      },
      post:   shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
      put:    shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
      patch:  shallowCopy(CONTENT_TYPE_APPLICATION_JSON)
    },

    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',

    paramSerializer: '$httpParamSerializer'
  };

  var useApplyAsync = false;
  /**
   * @ngdoc method
   * @name $httpProvider#useApplyAsync
   * @description
   *
   * Configure $http service to combine processing of multiple http responses received at around
   * the same time via {@link ng.$rootScope.Scope#$applyAsync $rootScope.$applyAsync}. This can result in
   * significant performance improvement for bigger applications that make many HTTP requests
   * concurrently (common during application bootstrap).
   *
   * Defaults to false. If no value is specified, returns the current configured value.
   *
   * @param {boolean=} value If true, when requests are loaded, they will schedule a deferred
   *    "apply" on the next tick, giving time for subsequent requests in a roughly ~10ms window
   *    to load and share the same digest cycle.
   *
   * @returns {boolean|Object} If a value is specified, returns the $httpProvider for chaining.
   *    otherwise, returns the current configured value.
   **/
  this.useApplyAsync = function(value) {
    if (isDefined(value)) {
      useApplyAsync = !!value;
      return this;
    }
    return useApplyAsync;
  };

  var useLegacyPromise = true;
  /**
   * @ngdoc method
   * @name $httpProvider#useLegacyPromiseExtensions
   * @description
   *
   * Configure `$http` service to return promises without the shorthand methods `success` and `error`.
   * This should be used to make sure that applications work without these methods.
   *
   * Defaults to true. If no value is specified, returns the current configured value.
   *
   * @param {boolean=} value If true, `$http` will return a promise with the deprecated legacy `success` and `error` methods.
   *
   * @returns {boolean|Object} If a value is specified, returns the $httpProvider for chaining.
   *    otherwise, returns the current configured value.
   **/
  this.useLegacyPromiseExtensions = function(value) {
    if (isDefined(value)) {
      useLegacyPromise = !!value;
      return this;
    }
    return useLegacyPromise;
  };

  /**
   * @ngdoc property
   * @name $httpProvider#interceptors
   * @description
   *
   * Array containing service factories for all synchronous or asynchronous {@link ng.$http $http}
   * pre-processing of request or postprocessing of responses.
   *
   * These service factories are ordered by request, i.e. they are applied in the same order as the
   * array, on request, but reverse order, on response.
   *
   * {@link ng.$http#interceptors Interceptors detailed info}
   **/
  var interceptorFactories = this.interceptors = [];

  this.$get = ['$httpBackend', '$$cookieReader', '$cacheFactory', '$rootScope', '$q', '$injector',
      function($httpBackend, $$cookieReader, $cacheFactory, $rootScope, $q, $injector) {

    var defaultCache = $cacheFactory('$http');

    /**
     * Make sure that default param serializer is exposed as a function
     */
    defaults.paramSerializer = isString(defaults.paramSerializer) ?
      $injector.get(defaults.paramSerializer) : defaults.paramSerializer;

    /**
     * Interceptors stored in reverse order. Inner interceptors before outer interceptors.
     * The reversal is needed so that we can build up the interception chain around the
     * server request.
     */
    var reversedInterceptors = [];

    forEach(interceptorFactories, function(interceptorFactory) {
      reversedInterceptors.unshift(isString(interceptorFactory)
          ? $injector.get(interceptorFactory) : $injector.invoke(interceptorFactory));
    });

    /**
     * @ngdoc service
     * @kind function
     * @name $http
     * @requires ng.$httpBackend
     * @requires $cacheFactory
     * @requires $rootScope
     * @requires $q
     * @requires $injector
     *
     * @description
     * The `$http` service is a core Angular service that facilitates communication with the remote
     * HTTP servers via the browser's [XMLHttpRequest](https://developer.mozilla.org/en/xmlhttprequest)
     * object or via [JSONP](http://en.wikipedia.org/wiki/JSONP).
     *
     * For unit testing applications that use `$http` service, see
     * {@link ngMock.$httpBackend $httpBackend mock}.
     *
     * For a higher level of abstraction, please check out the {@link ngResource.$resource
     * $resource} service.
     *
     * The $http API is based on the {@link ng.$q deferred/promise APIs} exposed by
     * the $q service. While for simple usage patterns this doesn't matter much, for advanced usage
     * it is important to familiarize yourself with these APIs and the guarantees they provide.
     *
     *
     * ## General usage
     * The `$http` service is a function which takes a single argument — a {@link $http#usage configuration object} —
     * that is used to generate an HTTP request and returns  a {@link ng.$q promise}.
     *
     * ```js
     *   // Simple GET request example:
     *   $http({
     *     method: 'GET',
     *     url: '/someUrl'
     *   }).then(function successCallback(response) {
     *       // this callback will be called asynchronously
     *       // when the response is available
     *     }, function errorCallback(response) {
     *       // called asynchronously if an error occurs
     *       // or server returns response with an error status.
     *     });
     * ```
     *
     * The response object has these properties:
     *
     *   - **data** – `{string|Object}` – The response body transformed with the transform
     *     functions.
     *   - **status** – `{number}` – HTTP status code of the response.
     *   - **headers** – `{function([headerName])}` – Header getter function.
     *   - **config** – `{Object}` – The configuration object that was used to generate the request.
     *   - **statusText** – `{string}` – HTTP status text of the response.
     *
     * A response status code between 200 and 299 is considered a success status and will result in
     * the success callback being called. Any response status code outside of that range is
     * considered an error status and will result in the error callback being called.
     * Also, status codes less than -1 are normalized to zero. -1 usually means the request was
     * aborted, e.g. using a `config.timeout`.
     * Note that if the response is a redirect, XMLHttpRequest will transparently follow it, meaning
     * that the outcome (success or error) will be determined by the final response status code.
     *
     *
     * ## Shortcut methods
     *
     * Shortcut methods are also available. All shortcut methods require passing in the URL, and
     * request data must be passed in for POST/PUT requests. An optional config can be passed as the
     * last argument.
     *
     * ```js
     *   $http.get('/someUrl', config).then(successCallback, errorCallback);
     *   $http.post('/someUrl', data, config).then(successCallback, errorCallback);
     * ```
     *
     * Complete list of shortcut methods:
     *
     * - {@link ng.$http#get $http.get}
     * - {@link ng.$http#head $http.head}
     * - {@link ng.$http#post $http.post}
     * - {@link ng.$http#put $http.put}
     * - {@link ng.$http#delete $http.delete}
     * - {@link ng.$http#jsonp $http.jsonp}
     * - {@link ng.$http#patch $http.patch}
     *
     *
     * ## Writing Unit Tests that use $http
     * When unit testing (using {@link ngMock ngMock}), it is necessary to call
     * {@link ngMock.$httpBackend#flush $httpBackend.flush()} to flush each pending
     * request using trained responses.
     *
     * ```
     * $httpBackend.expectGET(...);
     * $http.get(...);
     * $httpBackend.flush();
     * ```
     *
     * ## Deprecation Notice
     * <div class="alert alert-danger">
     *   The `$http` legacy promise methods `success` and `error` have been deprecated.
     *   Use the standard `then` method instead.
     *   If {@link $httpProvider#useLegacyPromiseExtensions `$httpProvider.useLegacyPromiseExtensions`} is set to
     *   `false` then these methods will throw {@link $http:legacy `$http/legacy`} error.
     * </div>
     *
     * ## Setting HTTP Headers
     *
     * The $http service will automatically add certain HTTP headers to all requests. These defaults
     * can be fully configured by accessing the `$httpProvider.defaults.headers` configuration
     * object, which currently contains this default configuration:
     *
     * - `$httpProvider.defaults.headers.common` (headers that are common for all requests):
     *   - `Accept: application/json, text/plain, * / *`
     * - `$httpProvider.defaults.headers.post`: (header defaults for POST requests)
     *   - `Content-Type: application/json`
     * - `$httpProvider.defaults.headers.put` (header defaults for PUT requests)
     *   - `Content-Type: application/json`
     *
     * To add or overwrite these defaults, simply add or remove a property from these configuration
     * objects. To add headers for an HTTP method other than POST or PUT, simply add a new object
     * with the lowercased HTTP method name as the key, e.g.
     * `$httpProvider.defaults.headers.get = { 'My-Header' : 'value' }`.
     *
     * The defaults can also be set at runtime via the `$http.defaults` object in the same
     * fashion. For example:
     *
     * ```
     * module.run(function($http) {
     *   $http.defaults.headers.common.Authorization = 'Basic YmVlcDpib29w';
     * });
     * ```
     *
     * In addition, you can supply a `headers` property in the config object passed when
     * calling `$http(config)`, which overrides the defaults without changing them globally.
     *
     * To explicitly remove a header automatically added via $httpProvider.defaults.headers on a per request basis,
     * Use the `headers` property, setting the desired header to `undefined`. For example:
     *
     * ```js
     * var req = {
     *  method: 'POST',
     *  url: 'http://example.com',
     *  headers: {
     *    'Content-Type': undefined
     *  },
     *  data: { test: 'test' }
     * }
     *
     * $http(req).then(function(){...}, function(){...});
     * ```
     *
     * ## Transforming Requests and Responses
     *
     * Both requests and responses can be transformed using transformation functions: `transformRequest`
     * and `transformResponse`. These properties can be a single function that returns
     * the transformed value (`function(data, headersGetter, status)`) or an array of such transformation functions,
     * which allows you to `push` or `unshift` a new transformation function into the transformation chain.
     *
     * <div class="alert alert-warning">
     * **Note:** Angular does not make a copy of the `data` parameter before it is passed into the `transformRequest` pipeline.
     * That means changes to the properties of `data` are not local to the transform function (since Javascript passes objects by reference).
     * For example, when calling `$http.get(url, $scope.myObject)`, modifications to the object's properties in a transformRequest
     * function will be reflected on the scope and in any templates where the object is data-bound.
     * To prevent this, transform functions should have no side-effects.
     * If you need to modify properties, it is recommended to make a copy of the data, or create new object to return.
     * </div>
     *
     * ### Default Transformations
     *
     * The `$httpProvider` provider and `$http` service expose `defaults.transformRequest` and
     * `defaults.transformResponse` properties. If a request does not provide its own transformations
     * then these will be applied.
     *
     * You can augment or replace the default transformations by modifying these properties by adding to or
     * replacing the array.
     *
     * Angular provides the following default transformations:
     *
     * Request transformations (`$httpProvider.defaults.transformRequest` and `$http.defaults.transformRequest`):
     *
     * - If the `data` property of the request configuration object contains an object, serialize it
     *   into JSON format.
     *
     * Response transformations (`$httpProvider.defaults.transformResponse` and `$http.defaults.transformResponse`):
     *
     *  - If XSRF prefix is detected, strip it (see Security Considerations section below).
     *  - If JSON response is detected, deserialize it using a JSON parser.
     *
     *
     * ### Overriding the Default Transformations Per Request
     *
     * If you wish to override the request/response transformations only for a single request then provide
     * `transformRequest` and/or `transformResponse` properties on the configuration object passed
     * into `$http`.
     *
     * Note that if you provide these properties on the config object the default transformations will be
     * overwritten. If you wish to augment the default transformations then you must include them in your
     * local transformation array.
     *
     * The following code demonstrates adding a new response transformation to be run after the default response
     * transformations have been run.
     *
     * ```js
     * function appendTransform(defaults, transform) {
     *
     *   // We can't guarantee that the default transformation is an array
     *   defaults = angular.isArray(defaults) ? defaults : [defaults];
     *
     *   // Append the new transformation to the defaults
     *   return defaults.concat(transform);
     * }
     *
     * $http({
     *   url: '...',
     *   method: 'GET',
     *   transformResponse: appendTransform($http.defaults.transformResponse, function(value) {
     *     return doTransform(value);
     *   })
     * });
     * ```
     *
     *
     * ## Caching
     *
     * {@link ng.$http `$http`} responses are not cached by default. To enable caching, you must
     * set the config.cache value or the default cache value to TRUE or to a cache object (created
     * with {@link ng.$cacheFactory `$cacheFactory`}). If defined, the value of config.cache takes
     * precedence over the default cache value.
     *
     * In order to:
     *   * cache all responses - set the default cache value to TRUE or to a cache object
     *   * cache a specific response - set config.cache value to TRUE or to a cache object
     *
     * If caching is enabled, but neither the default cache nor config.cache are set to a cache object,
     * then the default `$cacheFactory("$http")` object is used.
     *
     * The default cache value can be set by updating the
     * {@link ng.$http#defaults `$http.defaults.cache`} property or the
     * {@link $httpProvider#defaults `$httpProvider.defaults.cache`} property.
     *
     * When caching is enabled, {@link ng.$http `$http`} stores the response from the server using
     * the relevant cache object. The next time the same request is made, the response is returned
     * from the cache without sending a request to the server.
     *
     * Take note that:
     *
     *   * Only GET and JSONP requests are cached.
     *   * The cache key is the request URL including search parameters; headers are not considered.
     *   * Cached responses are returned asynchronously, in the same way as responses from the server.
     *   * If multiple identical requests are made using the same cache, which is not yet populated,
     *     one request will be made to the server and remaining requests will return the same response.
     *   * A cache-control header on the response does not affect if or how responses are cached.
     *
     *
     * ## Interceptors
     *
     * Before you start creating interceptors, be sure to understand the
     * {@link ng.$q $q and deferred/promise APIs}.
     *
     * For purposes of global error handling, authentication, or any kind of synchronous or
     * asynchronous pre-processing of request or postprocessing of responses, it is desirable to be
     * able to intercept requests before they are handed to the server and
     * responses before they are handed over to the application code that
     * initiated these requests. The interceptors leverage the {@link ng.$q
     * promise APIs} to fulfill this need for both synchronous and asynchronous pre-processing.
     *
     * The interceptors are service factories that are registered with the `$httpProvider` by
     * adding them to the `$httpProvider.interceptors` array. The factory is called and
     * injected with dependencies (if specified) and returns the interceptor.
     *
     * There are two kinds of interceptors (and two kinds of rejection interceptors):
     *
     *   * `request`: interceptors get called with a http {@link $http#usage config} object. The function is free to
     *     modify the `config` object or create a new one. The function needs to return the `config`
     *     object directly, or a promise containing the `config` or a new `config` object.
     *   * `requestError`: interceptor gets called when a previous interceptor threw an error or
     *     resolved with a rejection.
     *   * `response`: interceptors get called with http `response` object. The function is free to
     *     modify the `response` object or create a new one. The function needs to return the `response`
     *     object directly, or as a promise containing the `response` or a new `response` object.
     *   * `responseError`: interceptor gets called when a previous interceptor threw an error or
     *     resolved with a rejection.
     *
     *
     * ```js
     *   // register the interceptor as a service
     *   $provide.factory('myHttpInterceptor', function($q, dependency1, dependency2) {
     *     return {
     *       // optional method
     *       'request': function(config) {
     *         // do something on success
     *         return config;
     *       },
     *
     *       // optional method
     *      'requestError': function(rejection) {
     *         // do something on error
     *         if (canRecover(rejection)) {
     *           return responseOrNewPromise
     *         }
     *         return $q.reject(rejection);
     *       },
     *
     *
     *
     *       // optional method
     *       'response': function(response) {
     *         // do something on success
     *         return response;
     *       },
     *
     *       // optional method
     *      'responseError': function(rejection) {
     *         // do something on error
     *         if (canRecover(rejection)) {
     *           return responseOrNewPromise
     *         }
     *         return $q.reject(rejection);
     *       }
     *     };
     *   });
     *
     *   $httpProvider.interceptors.push('myHttpInterceptor');
     *
     *
     *   // alternatively, register the interceptor via an anonymous factory
     *   $httpProvider.interceptors.push(function($q, dependency1, dependency2) {
     *     return {
     *      'request': function(config) {
     *          // same as above
     *       },
     *
     *       'response': function(response) {
     *          // same as above
     *       }
     *     };
     *   });
     * ```
     *
     * ## Security Considerations
     *
     * When designing web applications, consider security threats from:
     *
     * - [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
     * - [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery)
     *
     * Both server and the client must cooperate in order to eliminate these threats. Angular comes
     * pre-configured with strategies that address these issues, but for this to work backend server
     * cooperation is required.
     *
     * ### JSON Vulnerability Protection
     *
     * A [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
     * allows third party website to turn your JSON resource URL into
     * [JSONP](http://en.wikipedia.org/wiki/JSONP) request under some conditions. To
     * counter this your server can prefix all JSON requests with following string `")]}',\n"`.
     * Angular will automatically strip the prefix before processing it as JSON.
     *
     * For example if your server needs to return:
     * ```js
     * ['one','two']
     * ```
     *
     * which is vulnerable to attack, your server can return:
     * ```js
     * )]}',
     * ['one','two']
     * ```
     *
     * Angular will strip the prefix, before processing the JSON.
     *
     *
     * ### Cross Site Request Forgery (XSRF) Protection
     *
     * [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery) is an attack technique by
     * which the attacker can trick an authenticated user into unknowingly executing actions on your
     * website. Angular provides a mechanism to counter XSRF. When performing XHR requests, the
     * $http service reads a token from a cookie (by default, `XSRF-TOKEN`) and sets it as an HTTP
     * header (`X-XSRF-TOKEN`). Since only JavaScript that runs on your domain could read the
     * cookie, your server can be assured that the XHR came from JavaScript running on your domain.
     * The header will not be set for cross-domain requests.
     *
     * To take advantage of this, your server needs to set a token in a JavaScript readable session
     * cookie called `XSRF-TOKEN` on the first HTTP GET request. On subsequent XHR requests the
     * server can verify that the cookie matches `X-XSRF-TOKEN` HTTP header, and therefore be sure
     * that only JavaScript running on your domain could have sent the request. The token must be
     * unique for each user and must be verifiable by the server (to prevent the JavaScript from
     * making up its own tokens). We recommend that the token is a digest of your site's
     * authentication cookie with a [salt](https://en.wikipedia.org/wiki/Salt_(cryptography&#41;)
     * for added security.
     *
     * The name of the headers can be specified using the xsrfHeaderName and xsrfCookieName
     * properties of either $httpProvider.defaults at config-time, $http.defaults at run-time,
     * or the per-request config object.
     *
     * In order to prevent collisions in environments where multiple Angular apps share the
     * same domain or subdomain, we recommend that each application uses unique cookie name.
     *
     * @param {object} config Object describing the request to be made and how it should be
     *    processed. The object has following properties:
     *
     *    - **method** – `{string}` – HTTP method (e.g. 'GET', 'POST', etc)
     *    - **url** – `{string}` – Absolute or relative URL of the resource that is being requested.
     *    - **params** – `{Object.<string|Object>}` – Map of strings or objects which will be serialized
     *      with the `paramSerializer` and appended as GET parameters.
     *    - **data** – `{string|Object}` – Data to be sent as the request message data.
     *    - **headers** – `{Object}` – Map of strings or functions which return strings representing
     *      HTTP headers to send to the server. If the return value of a function is null, the
     *      header will not be sent. Functions accept a config object as an argument.
     *    - **eventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest object.
     *      To bind events to the XMLHttpRequest upload object, use `uploadEventHandlers`.
     *      The handler will be called in the context of a `$apply` block.
     *    - **uploadEventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest upload
     *      object. To bind events to the XMLHttpRequest object, use `eventHandlers`.
     *      The handler will be called in the context of a `$apply` block.
     *    - **xsrfHeaderName** – `{string}` – Name of HTTP header to populate with the XSRF token.
     *    - **xsrfCookieName** – `{string}` – Name of cookie containing the XSRF token.
     *    - **transformRequest** –
     *      `{function(data, headersGetter)|Array.<function(data, headersGetter)>}` –
     *      transform function or an array of such functions. The transform function takes the http
     *      request body and headers and returns its transformed (typically serialized) version.
     *      See {@link ng.$http#overriding-the-default-transformations-per-request
     *      Overriding the Default Transformations}
     *    - **transformResponse** –
     *      `{function(data, headersGetter, status)|Array.<function(data, headersGetter, status)>}` –
     *      transform function or an array of such functions. The transform function takes the http
     *      response body, headers and status and returns its transformed (typically deserialized) version.
     *      See {@link ng.$http#overriding-the-default-transformations-per-request
     *      Overriding the Default Transformations}
     *    - **paramSerializer** - `{string|function(Object<string,string>):string}` - A function used to
     *      prepare the string representation of request parameters (specified as an object).
     *      If specified as string, it is interpreted as function registered with the
     *      {@link $injector $injector}, which means you can create your own serializer
     *      by registering it as a {@link auto.$provide#service service}.
     *      The default serializer is the {@link $httpParamSerializer $httpParamSerializer};
     *      alternatively, you can use the {@link $httpParamSerializerJQLike $httpParamSerializerJQLike}
     *    - **cache** – `{boolean|Object}` – A boolean value or object created with
     *      {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of the HTTP response.
     *      See {@link $http#caching $http Caching} for more information.
     *    - **timeout** – `{number|Promise}` – timeout in milliseconds, or {@link ng.$q promise}
     *      that should abort the request when resolved.
     *    - **withCredentials** - `{boolean}` - whether to set the `withCredentials` flag on the
     *      XHR object. See [requests with credentials](https://developer.mozilla.org/docs/Web/HTTP/Access_control_CORS#Requests_with_credentials)
     *      for more information.
     *    - **responseType** - `{string}` - see
     *      [XMLHttpRequest.responseType](https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest#xmlhttprequest-responsetype).
     *
     * @returns {HttpPromise} Returns a {@link ng.$q `Promise}` that will be resolved to a response object
     *                        when the request succeeds or fails.
     *
     *
     * @property {Array.<Object>} pendingRequests Array of config objects for currently pending
     *   requests. This is primarily meant to be used for debugging purposes.
     *
     *
     * @example
<example module="httpExample">
<file name="index.html">
  <div ng-controller="FetchController">
    <select ng-model="method" aria-label="Request method">
      <option>GET</option>
      <option>JSONP</option>
    </select>
    <input type="text" ng-model="url" size="80" aria-label="URL" />
    <button id="fetchbtn" ng-click="fetch()">fetch</button><br>
    <button id="samplegetbtn" ng-click="updateModel('GET', 'http-hello.html')">Sample GET</button>
    <button id="samplejsonpbtn"
      ng-click="updateModel('JSONP',
                    'https://angularjs.org/greet.php?callback=JSON_CALLBACK&name=Super%20Hero')">
      Sample JSONP
    </button>
    <button id="invalidjsonpbtn"
      ng-click="updateModel('JSONP', 'https://angularjs.org/doesntexist&callback=JSON_CALLBACK')">
        Invalid JSONP
      </button>
    <pre>http status code: {{status}}</pre>
    <pre>http response data: {{data}}</pre>
  </div>
</file>
<file name="script.js">
  angular.module('httpExample', [])
    .controller('FetchController', ['$scope', '$http', '$templateCache',
      function($scope, $http, $templateCache) {
        $scope.method = 'GET';
        $scope.url = 'http-hello.html';

        $scope.fetch = function() {
          $scope.code = null;
          $scope.response = null;

          $http({method: $scope.method, url: $scope.url, cache: $templateCache}).
            then(function(response) {
              $scope.status = response.status;
              $scope.data = response.data;
            }, function(response) {
              $scope.data = response.data || "Request failed";
              $scope.status = response.status;
          });
        };

        $scope.updateModel = function(method, url) {
          $scope.method = method;
          $scope.url = url;
        };
      }]);
</file>
<file name="http-hello.html">
  Hello, $http!
</file>
<file name="protractor.js" type="protractor">
  var status = element(by.binding('status'));
  var data = element(by.binding('data'));
  var fetchBtn = element(by.id('fetchbtn'));
  var sampleGetBtn = element(by.id('samplegetbtn'));
  var sampleJsonpBtn = element(by.id('samplejsonpbtn'));
  var invalidJsonpBtn = element(by.id('invalidjsonpbtn'));

  it('should make an xhr GET request', function() {
    sampleGetBtn.click();
    fetchBtn.click();
    expect(status.getText()).toMatch('200');
    expect(data.getText()).toMatch(/Hello, \$http!/);
  });

// Commented out due to flakes. See https://github.com/angular/angular.js/issues/9185
// it('should make a JSONP request to angularjs.org', function() {
//   sampleJsonpBtn.click();
//   fetchBtn.click();
//   expect(status.getText()).toMatch('200');
//   expect(data.getText()).toMatch(/Super Hero!/);
// });

  it('should make JSONP request to invalid URL and invoke the error handler',
      function() {
    invalidJsonpBtn.click();
    fetchBtn.click();
    expect(status.getText()).toMatch('0');
    expect(data.getText()).toMatch('Request failed');
  });
</file>
</example>
     */
    function $http(requestConfig) {

      if (!isObject(requestConfig)) {
        throw minErr('$http')('badreq', 'Http request configuration must be an object.  Received: {0}', requestConfig);
      }

      if (!isString(requestConfig.url)) {
        throw minErr('$http')('badreq', 'Http request configuration url must be a string.  Received: {0}', requestConfig.url);
      }

      var config = extend({
        method: 'get',
        transformRequest: defaults.transformRequest,
        transformResponse: defaults.transformResponse,
        paramSerializer: defaults.paramSerializer
      }, requestConfig);

      config.headers = mergeHeaders(requestConfig);
      config.method = uppercase(config.method);
      config.paramSerializer = isString(config.paramSerializer) ?
          $injector.get(config.paramSerializer) : config.paramSerializer;

      var requestInterceptors = [];
      var responseInterceptors = [];
      var promise = $q.when(config);

      // apply interceptors
      forEach(reversedInterceptors, function(interceptor) {
        if (interceptor.request || interceptor.requestError) {
          requestInterceptors.unshift(interceptor.request, interceptor.requestError);
        }
        if (interceptor.response || interceptor.responseError) {
          responseInterceptors.push(interceptor.response, interceptor.responseError);
        }
      });

      promise = chainInterceptors(promise, requestInterceptors);
      promise = promise.then(serverRequest);
      promise = chainInterceptors(promise, responseInterceptors);

      if (useLegacyPromise) {
        promise.success = function(fn) {
          assertArgFn(fn, 'fn');

          promise.then(function(response) {
            fn(response.data, response.status, response.headers, config);
          });
          return promise;
        };

        promise.error = function(fn) {
          assertArgFn(fn, 'fn');

          promise.then(null, function(response) {
            fn(response.data, response.status, response.headers, config);
          });
          return promise;
        };
      } else {
        promise.success = $httpMinErrLegacyFn('success');
        promise.error = $httpMinErrLegacyFn('error');
      }

      return promise;


      function chainInterceptors(promise, interceptors) {
        for (var i = 0, ii = interceptors.length; i < ii;) {
          var thenFn = interceptors[i++];
          var rejectFn = interceptors[i++];

          promise = promise.then(thenFn, rejectFn);
        }

        interceptors.length = 0;

        return promise;
      }

      function executeHeaderFns(headers, config) {
        var headerContent, processedHeaders = {};

        forEach(headers, function(headerFn, header) {
          if (isFunction(headerFn)) {
            headerContent = headerFn(config);
            if (headerContent != null) {
              processedHeaders[header] = headerContent;
            }
          } else {
            processedHeaders[header] = headerFn;
          }
        });

        return processedHeaders;
      }

      function mergeHeaders(config) {
        var defHeaders = defaults.headers,
            reqHeaders = extend({}, config.headers),
            defHeaderName, lowercaseDefHeaderName, reqHeaderName;

        defHeaders = extend({}, defHeaders.common, defHeaders[lowercase(config.method)]);

        // using for-in instead of forEach to avoid unnecessary iteration after header has been found
        defaultHeadersIteration:
        for (defHeaderName in defHeaders) {
          lowercaseDefHeaderName = lowercase(defHeaderName);

          for (reqHeaderName in reqHeaders) {
            if (lowercase(reqHeaderName) === lowercaseDefHeaderName) {
              continue defaultHeadersIteration;
            }
          }

          reqHeaders[defHeaderName] = defHeaders[defHeaderName];
        }

        // execute if header value is a function for merged headers
        return executeHeaderFns(reqHeaders, shallowCopy(config));
      }

      function serverRequest(config) {
        var headers = config.headers;
        var reqData = transformData(config.data, headersGetter(headers), undefined, config.transformRequest);

        // strip content-type if data is undefined
        if (isUndefined(reqData)) {
          forEach(headers, function(value, header) {
            if (lowercase(header) === 'content-type') {
              delete headers[header];
            }
          });
        }

        if (isUndefined(config.withCredentials) && !isUndefined(defaults.withCredentials)) {
          config.withCredentials = defaults.withCredentials;
        }

        // send request
        return sendReq(config, reqData).then(transformResponse, transformResponse);
      }

      function transformResponse(response) {
        // make a copy since the response must be cacheable
        var resp = extend({}, response);
        resp.data = transformData(response.data, response.headers, response.status,
                                  config.transformResponse);
        return (isSuccess(response.status))
          ? resp
          : $q.reject(resp);
      }
    }

    $http.pendingRequests = [];

    /**
     * @ngdoc method
     * @name $http#get
     *
     * @description
     * Shortcut method to perform `GET` request.
     *
     * @param {string} url Relative or absolute URL specifying the destination of the request
     * @param {Object=} config Optional configuration object
     * @returns {HttpPromise} Future object
     */

    /**
     * @ngdoc method
     * @name $http#delete
     *
     * @description
     * Shortcut method to perform `DELETE` request.
     *
     * @param {string} url Relative or absolute URL specifying the destination of the request
     * @param {Object=} config Optional configuration object
     * @returns {HttpPromise} Future object
     */

    /**
     * @ngdoc method
     * @name $http#head
     *
     * @description
     * Shortcut method to perform `HEAD` request.
     *
     * @param {string} url Relative or absolute URL specifying the destination of the request
     * @param {Object=} config Optional configuration object
     * @returns {HttpPromise} Future object
     */

    /**
     * @ngdoc method
     * @name $http#jsonp
     *
     * @description
     * Shortcut method to perform `JSONP` request.
     * If you would like to customise where and how the callbacks are stored then try overriding
     * or decorating the {@link $jsonpCallbacks} service.
     *
     * @param {string} url Relative or absolute URL specifying the destination of the request.
     *                     The name of the callback should be the string `JSON_CALLBACK`.
     * @param {Object=} config Optional configuration object
     * @returns {HttpPromise} Future object
     */
    createShortMethods('get', 'delete', 'head', 'jsonp');

    /**
     * @ngdoc method
     * @name $http#post
     *
     * @description
     * Shortcut method to perform `POST` request.
     *
     * @param {string} url Relative or absolute URL specifying the destination of the request
     * @param {*} data Request content
     * @param {Object=} config Optional configuration object
     * @returns {HttpPromise} Future object
     */

    /**
     * @ngdoc method
     * @name $http#put
     *
     * @description
     * Shortcut method to perform `PUT` request.
     *
     * @param {string} url Relative or absolute URL specifying the destination of the request
     * @param {*} data Request content
     * @param {Object=} config Optional configuration object
     * @returns {HttpPromise} Future object
     */

     /**
      * @ngdoc method
      * @name $http#patch
      *
      * @description
      * Shortcut method to perform `PATCH` request.
      *
      * @param {string} url Relative or absolute URL specifying the destination of the request
      * @param {*} data Request content
      * @param {Object=} config Optional configuration object
      * @returns {HttpPromise} Future object
      */
    createShortMethodsWithData('post', 'put', 'patch');

        /**
         * @ngdoc property
         * @name $http#defaults
         *
         * @description
         * Runtime equivalent of the `$httpProvider.defaults` property. Allows configuration of
         * default headers, withCredentials as well as request and response transformations.
         *
         * See "Setting HTTP Headers" and "Transforming Requests and Responses" sections above.
         */
    $http.defaults = defaults;


    return $http;


    function createShortMethods(names) {
      forEach(arguments, function(name) {
        $http[name] = function(url, config) {
          return $http(extend({}, config || {}, {
            method: name,
            url: url
          }));
        };
      });
    }


    function createShortMethodsWithData(name) {
      forEach(arguments, function(name) {
        $http[name] = function(url, data, config) {
          return $http(extend({}, config || {}, {
            method: name,
            url: url,
            data: data
          }));
        };
      });
    }


    /**
     * Makes the request.
     *
     * !!! ACCESSES CLOSURE VARS:
     * $httpBackend, defaults, $log, $rootScope, defaultCache, $http.pendingRequests
     */
    function sendReq(config, reqData) {
      var deferred = $q.defer(),
          promise = deferred.promise,
          cache,
          cachedResp,
          reqHeaders = config.headers,
          url = buildUrl(config.url, config.paramSerializer(config.params));

      $http.pendingRequests.push(config);
      promise.then(removePendingReq, removePendingReq);


      if ((config.cache || defaults.cache) && config.cache !== false &&
          (config.method === 'GET' || config.method === 'JSONP')) {
        cache = isObject(config.cache) ? config.cache
              : isObject(defaults.cache) ? defaults.cache
              : defaultCache;
      }

      if (cache) {
        cachedResp = cache.get(url);
        if (isDefined(cachedResp)) {
          if (isPromiseLike(cachedResp)) {
            // cached request has already been sent, but there is no response yet
            cachedResp.then(resolvePromiseWithResult, resolvePromiseWithResult);
          } else {
            // serving from cache
            if (isArray(cachedResp)) {
              resolvePromise(cachedResp[1], cachedResp[0], shallowCopy(cachedResp[2]), cachedResp[3]);
            } else {
              resolvePromise(cachedResp, 200, {}, 'OK');
            }
          }
        } else {
          // put the promise for the non-transformed response into cache as a placeholder
          cache.put(url, promise);
        }
      }


      // if we won't have the response in cache, set the xsrf headers and
      // send the request to the backend
      if (isUndefined(cachedResp)) {
        var xsrfValue = urlIsSameOrigin(config.url)
            ? $$cookieReader()[config.xsrfCookieName || defaults.xsrfCookieName]
            : undefined;
        if (xsrfValue) {
          reqHeaders[(config.xsrfHeaderName || defaults.xsrfHeaderName)] = xsrfValue;
        }

        $httpBackend(config.method, url, reqData, done, reqHeaders, config.timeout,
            config.withCredentials, config.responseType,
            createApplyHandlers(config.eventHandlers),
            createApplyHandlers(config.uploadEventHandlers));
      }

      return promise;

      function createApplyHandlers(eventHandlers) {
        if (eventHandlers) {
          var applyHandlers = {};
          forEach(eventHandlers, function(eventHandler, key) {
            applyHandlers[key] = function(event) {
              if (useApplyAsync) {
                $rootScope.$applyAsync(callEventHandler);
              } else if ($rootScope.$$phase) {
                callEventHandler();
              } else {
                $rootScope.$apply(callEventHandler);
              }

              function callEventHandler() {
                eventHandler(event);
              }
            };
          });
          return applyHandlers;
        }
      }


      /**
       * Callback registered to $httpBackend():
       *  - caches the response if desired
       *  - resolves the raw $http promise
       *  - calls $apply
       */
      function done(status, response, headersString, statusText) {
        if (cache) {
          if (isSuccess(status)) {
            cache.put(url, [status, response, parseHeaders(headersString), statusText]);
          } else {
            // remove promise from the cache
            cache.remove(url);
          }
        }

        function resolveHttpPromise() {
          resolvePromise(response, status, headersString, statusText);
        }

        if (useApplyAsync) {
          $rootScope.$applyAsync(resolveHttpPromise);
        } else {
          resolveHttpPromise();
          if (!$rootScope.$$phase) $rootScope.$apply();
        }
      }


      /**
       * Resolves the raw $http promise.
       */
      function resolvePromise(response, status, headers, statusText) {
        //status: HTTP response status code, 0, -1 (aborted by timeout / promise)
        status = status >= -1 ? status : 0;

        (isSuccess(status) ? deferred.resolve : deferred.reject)({
          data: response,
          status: status,
          headers: headersGetter(headers),
          config: config,
          statusText: statusText
        });
      }

      function resolvePromiseWithResult(result) {
        resolvePromise(result.data, result.status, shallowCopy(result.headers()), result.statusText);
      }

      function removePendingReq() {
        var idx = $http.pendingRequests.indexOf(config);
        if (idx !== -1) $http.pendingRequests.splice(idx, 1);
      }
    }


    function buildUrl(url, serializedParams) {
      if (serializedParams.length > 0) {
        url += ((url.indexOf('?') == -1) ? '?' : '&') + serializedParams;
      }
      return url;
    }
  }];
}

/**
 * @ngdoc service
 * @name $xhrFactory
 *
 * @description
 * Factory function used to create XMLHttpRequest objects.
 *
 * Replace or decorate this service to create your own custom XMLHttpRequest objects.
 *
 * ```
 * angular.module('myApp', [])
 * .factory('$xhrFactory', function() {
 *   return function createXhr(method, url) {
 *     return new window.XMLHttpRequest({mozSystem: true});
 *   };
 * });
 * ```
 *
 * @param {string} method HTTP method of the request (GET, POST, PUT, ..)
 * @param {string} url URL of the request.
 */
function $xhrFactoryProvider() {
  this.$get = function() {
    return function createXhr() {
      return new window.XMLHttpRequest();
    };
  };
}

/**
 * @ngdoc service
 * @name $httpBackend
 * @requires $jsonpCallbacks
 * @requires $document
 * @requires $xhrFactory
 *
 * @description
 * HTTP backend used by the {@link ng.$http service} that delegates to
 * XMLHttpRequest object or JSONP and deals with browser incompatibilities.
 *
 * You should never need to use this service directly, instead use the higher-level abstractions:
 * {@link ng.$http $http} or {@link ngResource.$resource $resource}.
 *
 * During testing this implementation is swapped with {@link ngMock.$httpBackend mock
 * $httpBackend} which can be trained with responses.
 */
function $HttpBackendProvider() {
  this.$get = ['$browser', '$jsonpCallbacks', '$document', '$xhrFactory', function($browser, $jsonpCallbacks, $document, $xhrFactory) {
    return createHttpBackend($browser, $xhrFactory, $browser.defer, $jsonpCallbacks, $document[0]);
  }];
}

function createHttpBackend($browser, createXhr, $browserDefer, callbacks, rawDocument) {
  // TODO(vojta): fix the signature
  return function(method, url, post, callback, headers, timeout, withCredentials, responseType, eventHandlers, uploadEventHandlers) {
    $browser.$$incOutstandingRequestCount();
    url = url || $browser.url();

    if (lowercase(method) === 'jsonp') {
      var callbackPath = callbacks.createCallback(url);
      var jsonpDone = jsonpReq(url, callbackPath, function(status, text) {
        // jsonpReq only ever sets status to 200 (OK), 404 (ERROR) or -1 (WAITING)
        var response = (status === 200) && callbacks.getResponse(callbackPath);
        completeRequest(callback, status, response, "", text);
        callbacks.removeCallback(callbackPath);
      });
    } else {

      var xhr = createXhr(method, url);

      xhr.open(method, url, true);
      forEach(headers, function(value, key) {
        if (isDefined(value)) {
            xhr.setRequestHeader(key, value);
        }
      });

      xhr.onload = function requestLoaded() {
        var statusText = xhr.statusText || '';

        // responseText is the old-school way of retrieving response (supported by IE9)
        // response/responseType properties were introduced in XHR Level2 spec (supported by IE10)
        var response = ('response' in xhr) ? xhr.response : xhr.responseText;

        // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
        var status = xhr.status === 1223 ? 204 : xhr.status;

        // fix status code when it is 0 (0 status is undocumented).
        // Occurs when accessing file resources or on Android 4.1 stock browser
        // while retrieving files from application cache.
        if (status === 0) {
          status = response ? 200 : urlResolve(url).protocol == 'file' ? 404 : 0;
        }

        completeRequest(callback,
            status,
            response,
            xhr.getAllResponseHeaders(),
            statusText);
      };

      var requestError = function() {
        // The response is always empty
        // See https://xhr.spec.whatwg.org/#request-error-steps and https://fetch.spec.whatwg.org/#concept-network-error
        completeRequest(callback, -1, null, null, '');
      };

      xhr.onerror = requestError;
      xhr.onabort = requestError;

      forEach(eventHandlers, function(value, key) {
          xhr.addEventListener(key, value);
      });

      forEach(uploadEventHandlers, function(value, key) {
        xhr.upload.addEventListener(key, value);
      });

      if (withCredentials) {
        xhr.withCredentials = true;
      }

      if (responseType) {
        try {
          xhr.responseType = responseType;
        } catch (e) {
          // WebKit added support for the json responseType value on 09/03/2013
          // https://bugs.webkit.org/show_bug.cgi?id=73648. Versions of Safari prior to 7 are
          // known to throw when setting the value "json" as the response type. Other older
          // browsers implementing the responseType
          //
          // The json response type can be ignored if not supported, because JSON payloads are
          // parsed on the client-side regardless.
          if (responseType !== 'json') {
            throw e;
          }
        }
      }

      xhr.send(isUndefined(post) ? null : post);
    }

    if (timeout > 0) {
      var timeoutId = $browserDefer(timeoutRequest, timeout);
    } else if (isPromiseLike(timeout)) {
      timeout.then(timeoutRequest);
    }


    function timeoutRequest() {
      jsonpDone && jsonpDone();
      xhr && xhr.abort();
    }

    function completeRequest(callback, status, response, headersString, statusText) {
      // cancel timeout and subsequent timeout promise resolution
      if (isDefined(timeoutId)) {
        $browserDefer.cancel(timeoutId);
      }
      jsonpDone = xhr = null;

      callback(status, response, headersString, statusText);
      $browser.$$completeOutstandingRequest(noop);
    }
  };

  function jsonpReq(url, callbackPath, done) {
    url = url.replace('JSON_CALLBACK', callbackPath);
    // we can't use jQuery/jqLite here because jQuery does crazy stuff with script elements, e.g.:
    // - fetches local scripts via XHR and evals them
    // - adds and immediately removes script elements from the document
    var script = rawDocument.createElement('script'), callback = null;
    script.type = "text/javascript";
    script.src = url;
    script.async = true;

    callback = function(event) {
      removeEventListenerFn(script, "load", callback);
      removeEventListenerFn(script, "error", callback);
      rawDocument.body.removeChild(script);
      script = null;
      var status = -1;
      var text = "unknown";

      if (event) {
        if (event.type === "load" && !callbacks.wasCalled(callbackPath)) {
          event = { type: "error" };
        }
        text = event.type;
        status = event.type === "error" ? 404 : 200;
      }

      if (done) {
        done(status, text);
      }
    };

    addEventListenerFn(script, "load", callback);
    addEventListenerFn(script, "error", callback);
    rawDocument.body.appendChild(script);
    return callback;
  }
}

var $interpolateMinErr = angular.$interpolateMinErr = minErr('$interpolate');
$interpolateMinErr.throwNoconcat = function(text) {
  throw $interpolateMinErr('noconcat',
      "Error while interpolating: {0}\nStrict Contextual Escaping disallows " +
      "interpolations that concatenate multiple expressions when a trusted value is " +
      "required.  See http://docs.angularjs.org/api/ng.$sce", text);
};

$interpolateMinErr.interr = function(text, err) {
  return $interpolateMinErr('interr', "Can't interpolate: {0}\n{1}", text, err.toString());
};

/**
 * @ngdoc provider
 * @name $interpolateProvider
 *
 * @description
 *
 * Used for configuring the interpolation markup. Defaults to `{{` and `}}`.
 *
 * <div class="alert alert-danger">
 * This feature is sometimes used to mix different markup languages, e.g. to wrap an Angular
 * template within a Python Jinja template (or any other template language). Mixing templating
 * languages is **very dangerous**. The embedding template language will not safely escape Angular
 * expressions, so any user-controlled values in the template will cause Cross Site Scripting (XSS)
 * security bugs!
 * </div>
 *
 * @example
<example name="custom-interpolation-markup" module="customInterpolationApp">
<file name="index.html">
<script>
  var customInterpolationApp = angular.module('customInterpolationApp', []);

  customInterpolationApp.config(function($interpolateProvider) {
    $interpolateProvider.startSymbol('//');
    $interpolateProvider.endSymbol('//');
  });


  customInterpolationApp.controller('DemoController', function() {
      this.label = "This binding is brought you by // interpolation symbols.";
  });
</script>
<div ng-controller="DemoController as demo">
    //demo.label//
</div>
</file>
<file name="protractor.js" type="protractor">
  it('should interpolate binding with custom symbols', function() {
    expect(element(by.binding('demo.label')).getText()).toBe('This binding is brought you by // interpolation symbols.');
  });
</file>
</example>
 */
function $InterpolateProvider() {
  var startSymbol = '{{';
  var endSymbol = '}}';

  /**
   * @ngdoc method
   * @name $interpolateProvider#startSymbol
   * @description
   * Symbol to denote start of expression in the interpolated string. Defaults to `{{`.
   *
   * @param {string=} value new value to set the starting symbol to.
   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
   */
  this.startSymbol = function(value) {
    if (value) {
      startSymbol = value;
      return this;
    } else {
      return startSymbol;
    }
  };

  /**
   * @ngdoc method
   * @name $interpolateProvider#endSymbol
   * @description
   * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
   *
   * @param {string=} value new value to set the ending symbol to.
   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
   */
  this.endSymbol = function(value) {
    if (value) {
      endSymbol = value;
      return this;
    } else {
      return endSymbol;
    }
  };


  this.$get = ['$parse', '$exceptionHandler', '$sce', function($parse, $exceptionHandler, $sce) {
    var startSymbolLength = startSymbol.length,
        endSymbolLength = endSymbol.length,
        escapedStartRegexp = new RegExp(startSymbol.replace(/./g, escape), 'g'),
        escapedEndRegexp = new RegExp(endSymbol.replace(/./g, escape), 'g');

    function escape(ch) {
      return '\\\\\\' + ch;
    }

    function unescapeText(text) {
      return text.replace(escapedStartRegexp, startSymbol).
        replace(escapedEndRegexp, endSymbol);
    }

    function stringify(value) {
      if (value == null) { // null || undefined
        return '';
      }
      switch (typeof value) {
        case 'string':
          break;
        case 'number':
          value = '' + value;
          break;
        default:
          value = toJson(value);
      }

      return value;
    }

    //TODO: this is the same as the constantWatchDelegate in parse.js
    function constantWatchDelegate(scope, listener, objectEquality, constantInterp) {
      var unwatch;
      return unwatch = scope.$watch(function constantInterpolateWatch(scope) {
        unwatch();
        return constantInterp(scope);
      }, listener, objectEquality);
    }

    /**
     * @ngdoc service
     * @name $interpolate
     * @kind function
     *
     * @requires $parse
     * @requires $sce
     *
     * @description
     *
     * Compiles a string with markup into an interpolation function. This service is used by the
     * HTML {@link ng.$compile $compile} service for data binding. See
     * {@link ng.$interpolateProvider $interpolateProvider} for configuring the
     * interpolation markup.
     *
     *
     * ```js
     *   var $interpolate = ...; // injected
     *   var exp = $interpolate('Hello {{name | uppercase}}!');
     *   expect(exp({name:'Angular'})).toEqual('Hello ANGULAR!');
     * ```
     *
     * `$interpolate` takes an optional fourth argument, `allOrNothing`. If `allOrNothing` is
     * `true`, the interpolation function will return `undefined` unless all embedded expressions
     * evaluate to a value other than `undefined`.
     *
     * ```js
     *   var $interpolate = ...; // injected
     *   var context = {greeting: 'Hello', name: undefined };
     *
     *   // default "forgiving" mode
     *   var exp = $interpolate('{{greeting}} {{name}}!');
     *   expect(exp(context)).toEqual('Hello !');
     *
     *   // "allOrNothing" mode
     *   exp = $interpolate('{{greeting}} {{name}}!', false, null, true);
     *   expect(exp(context)).toBeUndefined();
     *   context.name = 'Angular';
     *   expect(exp(context)).toEqual('Hello Angular!');
     * ```
     *
     * `allOrNothing` is useful for interpolating URLs. `ngSrc` and `ngSrcset` use this behavior.
     *
     * #### Escaped Interpolation
     * $interpolate provides a mechanism for escaping interpolation markers. Start and end markers
     * can be escaped by preceding each of their characters with a REVERSE SOLIDUS U+005C (backslash).
     * It will be rendered as a regular start/end marker, and will not be interpreted as an expression
     * or binding.
     *
     * This enables web-servers to prevent script injection attacks and defacing attacks, to some
     * degree, while also enabling code examples to work without relying on the
     * {@link ng.directive:ngNonBindable ngNonBindable} directive.
     *
     * **For security purposes, it is strongly encouraged that web servers escape user-supplied data,
     * replacing angle brackets (&lt;, &gt;) with &amp;lt; and &amp;gt; respectively, and replacing all
     * interpolation start/end markers with their escaped counterparts.**
     *
     * Escaped interpolation markers are only replaced with the actual interpolation markers in rendered
     * output when the $interpolate service processes the text. So, for HTML elements interpolated
     * by {@link ng.$compile $compile}, or otherwise interpolated with the `mustHaveExpression` parameter
     * set to `true`, the interpolated text must contain an unescaped interpolation expression. As such,
     * this is typically useful only when user-data is used in rendering a template from the server, or
     * when otherwise untrusted data is used by a directive.
     *
     * <example>
     *  <file name="index.html">
     *    <div ng-init="username='A user'">
     *      <p ng-init="apptitle='Escaping demo'">{{apptitle}}: \{\{ username = "defaced value"; \}\}
     *        </p>
     *      <p><strong>{{username}}</strong> attempts to inject code which will deface the
     *        application, but fails to accomplish their task, because the server has correctly
     *        escaped the interpolation start/end markers with REVERSE SOLIDUS U+005C (backslash)
     *        characters.</p>
     *      <p>Instead, the result of the attempted script injection is visible, and can be removed
     *        from the database by an administrator.</p>
     *    </div>
     *  </file>
     * </example>
     *
     * @knownIssue
     * It is currently not possible for an interpolated expression to contain the interpolation end
     * symbol. For example, `{{ '}}' }}` will be incorrectly interpreted as `{{ ' }}` + `' }}`, i.e.
     * an interpolated expression consisting of a single-quote (`'`) and the `' }}` string.
     *
     * @knownIssue
     * All directives and components must use the standard `{{` `}}` interpolation symbols
     * in their templates. If you change the application interpolation symbols the {@link $compile}
     * service will attempt to denormalize the standard symbols to the custom symbols.
     * The denormalization process is not clever enough to know not to replace instances of the standard
     * symbols where they would not normally be treated as interpolation symbols. For example in the following
     * code snippet the closing braces of the literal object will get incorrectly denormalized:
     *
     * ```
     * <div data-context='{"context":{"id":3,"type":"page"}}">
     * ```
     *
     * The workaround is to ensure that such instances are separated by whitespace:
     * ```
     * <div data-context='{"context":{"id":3,"type":"page"} }">
     * ```
     *
     * See https://github.com/angular/angular.js/pull/14610#issuecomment-219401099 for more information.
     *
     * @param {string} text The text with markup to interpolate.
     * @param {boolean=} mustHaveExpression if set to true then the interpolation string must have
     *    embedded expression in order to return an interpolation function. Strings with no
     *    embedded expression will return null for the interpolation function.
     * @param {string=} trustedContext when provided, the returned function passes the interpolated
     *    result through {@link ng.$sce#getTrusted $sce.getTrusted(interpolatedResult,
     *    trustedContext)} before returning it.  Refer to the {@link ng.$sce $sce} service that
     *    provides Strict Contextual Escaping for details.
     * @param {boolean=} allOrNothing if `true`, then the returned function returns undefined
     *    unless all embedded expressions evaluate to a value other than `undefined`.
     * @returns {function(context)} an interpolation function which is used to compute the
     *    interpolated string. The function has these parameters:
     *
     * - `context`: evaluation context for all expressions embedded in the interpolated text
     */
    function $interpolate(text, mustHaveExpression, trustedContext, allOrNothing) {
      // Provide a quick exit and simplified result function for text with no interpolation
      if (!text.length || text.indexOf(startSymbol) === -1) {
        var constantInterp;
        if (!mustHaveExpression) {
          var unescapedText = unescapeText(text);
          constantInterp = valueFn(unescapedText);
          constantInterp.exp = text;
          constantInterp.expressions = [];
          constantInterp.$$watchDelegate = constantWatchDelegate;
        }
        return constantInterp;
      }

      allOrNothing = !!allOrNothing;
      var startIndex,
          endIndex,
          index = 0,
          expressions = [],
          parseFns = [],
          textLength = text.length,
          exp,
          concat = [],
          expressionPositions = [];

      while (index < textLength) {
        if (((startIndex = text.indexOf(startSymbol, index)) != -1) &&
             ((endIndex = text.indexOf(endSymbol, startIndex + startSymbolLength)) != -1)) {
          if (index !== startIndex) {
            concat.push(unescapeText(text.substring(index, startIndex)));
          }
          exp = text.substring(startIndex + startSymbolLength, endIndex);
          expressions.push(exp);
          parseFns.push($parse(exp, parseStringifyInterceptor));
          index = endIndex + endSymbolLength;
          expressionPositions.push(concat.length);
          concat.push('');
        } else {
          // we did not find an interpolation, so we have to add the remainder to the separators array
          if (index !== textLength) {
            concat.push(unescapeText(text.substring(index)));
          }
          break;
        }
      }

      // Concatenating expressions makes it hard to reason about whether some combination of
      // concatenated values are unsafe to use and could easily lead to XSS.  By requiring that a
      // single expression be used for iframe[src], object[src], etc., we ensure that the value
      // that's used is assigned or constructed by some JS code somewhere that is more testable or
      // make it obvious that you bound the value to some user controlled value.  This helps reduce
      // the load when auditing for XSS issues.
      if (trustedContext && concat.length > 1) {
          $interpolateMinErr.throwNoconcat(text);
      }

      if (!mustHaveExpression || expressions.length) {
        var compute = function(values) {
          for (var i = 0, ii = expressions.length; i < ii; i++) {
            if (allOrNothing && isUndefined(values[i])) return;
            concat[expressionPositions[i]] = values[i];
          }
          return concat.join('');
        };

        var getValue = function(value) {
          return trustedContext ?
            $sce.getTrusted(trustedContext, value) :
            $sce.valueOf(value);
        };

        return extend(function interpolationFn(context) {
            var i = 0;
            var ii = expressions.length;
            var values = new Array(ii);

            try {
              for (; i < ii; i++) {
                values[i] = parseFns[i](context);
              }

              return compute(values);
            } catch (err) {
              $exceptionHandler($interpolateMinErr.interr(text, err));
            }

          }, {
          // all of these properties are undocumented for now
          exp: text, //just for compatibility with regular watchers created via $watch
          expressions: expressions,
          $$watchDelegate: function(scope, listener) {
            var lastValue;
            return scope.$watchGroup(parseFns, function interpolateFnWatcher(values, oldValues) {
              var currValue = compute(values);
              if (isFunction(listener)) {
                listener.call(this, currValue, values !== oldValues ? lastValue : currValue, scope);
              }
              lastValue = currValue;
            });
          }
        });
      }

      function parseStringifyInterceptor(value) {
        try {
          value = getValue(value);
          return allOrNothing && !isDefined(value) ? value : stringify(value);
        } catch (err) {
          $exceptionHandler($interpolateMinErr.interr(text, err));
        }
      }
    }


    /**
     * @ngdoc method
     * @name $interpolate#startSymbol
     * @description
     * Symbol to denote the start of expression in the interpolated string. Defaults to `{{`.
     *
     * Use {@link ng.$interpolateProvider#startSymbol `$interpolateProvider.startSymbol`} to change
     * the symbol.
     *
     * @returns {string} start symbol.
     */
    $interpolate.startSymbol = function() {
      return startSymbol;
    };


    /**
     * @ngdoc method
     * @name $interpolate#endSymbol
     * @description
     * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
     *
     * Use {@link ng.$interpolateProvider#endSymbol `$interpolateProvider.endSymbol`} to change
     * the symbol.
     *
     * @returns {string} end symbol.
     */
    $interpolate.endSymbol = function() {
      return endSymbol;
    };

    return $interpolate;
  }];
}

function $IntervalProvider() {
  this.$get = ['$rootScope', '$window', '$q', '$$q', '$browser',
       function($rootScope,   $window,   $q,   $$q,   $browser) {
    var intervals = {};


     /**
      * @ngdoc service
      * @name $interval
      *
      * @description
      * Angular's wrapper for `window.setInterval`. The `fn` function is executed every `delay`
      * milliseconds.
      *
      * The return value of registering an interval function is a promise. This promise will be
      * notified upon each tick of the interval, and will be resolved after `count` iterations, or
      * run indefinitely if `count` is not defined. The value of the notification will be the
      * number of iterations that have run.
      * To cancel an interval, call `$interval.cancel(promise)`.
      *
      * In tests you can use {@link ngMock.$interval#flush `$interval.flush(millis)`} to
      * move forward by `millis` milliseconds and trigger any functions scheduled to run in that
      * time.
      *
      * <div class="alert alert-warning">
      * **Note**: Intervals created by this service must be explicitly destroyed when you are finished
      * with them.  In particular they are not automatically destroyed when a controller's scope or a
      * directive's element are destroyed.
      * You should take this into consideration and make sure to always cancel the interval at the
      * appropriate moment.  See the example below for more details on how and when to do this.
      * </div>
      *
      * @param {function()} fn A function that should be called repeatedly.
      * @param {number} delay Number of milliseconds between each function call.
      * @param {number=} [count=0] Number of times to repeat. If not set, or 0, will repeat
      *   indefinitely.
      * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
      *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
      * @param {...*=} Pass additional parameters to the executed function.
      * @returns {promise} A promise which will be notified on each iteration.
      *
      * @example
      * <example module="intervalExample">
      * <file name="index.html">
      *   <script>
      *     angular.module('intervalExample', [])
      *       .controller('ExampleController', ['$scope', '$interval',
      *         function($scope, $interval) {
      *           $scope.format = 'M/d/yy h:mm:ss a';
      *           $scope.blood_1 = 100;
      *           $scope.blood_2 = 120;
      *
      *           var stop;
      *           $scope.fight = function() {
      *             // Don't start a new fight if we are already fighting
      *             if ( angular.isDefined(stop) ) return;
      *
      *             stop = $interval(function() {
      *               if ($scope.blood_1 > 0 && $scope.blood_2 > 0) {
      *                 $scope.blood_1 = $scope.blood_1 - 3;
      *                 $scope.blood_2 = $scope.blood_2 - 4;
      *               } else {
      *                 $scope.stopFight();
      *               }
      *             }, 100);
      *           };
      *
      *           $scope.stopFight = function() {
      *             if (angular.isDefined(stop)) {
      *               $interval.cancel(stop);
      *               stop = undefined;
      *             }
      *           };
      *
      *           $scope.resetFight = function() {
      *             $scope.blood_1 = 100;
      *             $scope.blood_2 = 120;
      *           };
      *
      *           $scope.$on('$destroy', function() {
      *             // Make sure that the interval is destroyed too
      *             $scope.stopFight();
      *           });
      *         }])
      *       // Register the 'myCurrentTime' directive factory method.
      *       // We inject $interval and dateFilter service since the factory method is DI.
      *       .directive('myCurrentTime', ['$interval', 'dateFilter',
      *         function($interval, dateFilter) {
      *           // return the directive link function. (compile function not needed)
      *           return function(scope, element, attrs) {
      *             var format,  // date format
      *                 stopTime; // so that we can cancel the time updates
      *
      *             // used to update the UI
      *             function updateTime() {
      *               element.text(dateFilter(new Date(), format));
      *             }
      *
      *             // watch the expression, and update the UI on change.
      *             scope.$watch(attrs.myCurrentTime, function(value) {
      *               format = value;
      *               updateTime();
      *             });
      *
      *             stopTime = $interval(updateTime, 1000);
      *
      *             // listen on DOM destroy (removal) event, and cancel the next UI update
      *             // to prevent updating time after the DOM element was removed.
      *             element.on('$destroy', function() {
      *               $interval.cancel(stopTime);
      *             });
      *           }
      *         }]);
      *   </script>
      *
      *   <div>
      *     <div ng-controller="ExampleController">
      *       <label>Date format: <input ng-model="format"></label> <hr/>
      *       Current time is: <span my-current-time="format"></span>
      *       <hr/>
      *       Blood 1 : <font color='red'>{{blood_1}}</font>
      *       Blood 2 : <font color='red'>{{blood_2}}</font>
      *       <button type="button" data-ng-click="fight()">Fight</button>
      *       <button type="button" data-ng-click="stopFight()">StopFight</button>
      *       <button type="button" data-ng-click="resetFight()">resetFight</button>
      *     </div>
      *   </div>
      *
      * </file>
      * </example>
      */
    function interval(fn, delay, count, invokeApply) {
      var hasParams = arguments.length > 4,
          args = hasParams ? sliceArgs(arguments, 4) : [],
          setInterval = $window.setInterval,
          clearInterval = $window.clearInterval,
          iteration = 0,
          skipApply = (isDefined(invokeApply) && !invokeApply),
          deferred = (skipApply ? $$q : $q).defer(),
          promise = deferred.promise;

      count = isDefined(count) ? count : 0;

      promise.$$intervalId = setInterval(function tick() {
        if (skipApply) {
          $browser.defer(callback);
        } else {
          $rootScope.$evalAsync(callback);
        }
        deferred.notify(iteration++);

        if (count > 0 && iteration >= count) {
          deferred.resolve(iteration);
          clearInterval(promise.$$intervalId);
          delete intervals[promise.$$intervalId];
        }

        if (!skipApply) $rootScope.$apply();

      }, delay);

      intervals[promise.$$intervalId] = deferred;

      return promise;

      function callback() {
        if (!hasParams) {
          fn(iteration);
        } else {
          fn.apply(null, args);
        }
      }
    }


     /**
      * @ngdoc method
      * @name $interval#cancel
      *
      * @description
      * Cancels a task associated with the `promise`.
      *
      * @param {Promise=} promise returned by the `$interval` function.
      * @returns {boolean} Returns `true` if the task was successfully canceled.
      */
    interval.cancel = function(promise) {
      if (promise && promise.$$intervalId in intervals) {
        intervals[promise.$$intervalId].reject('canceled');
        $window.clearInterval(promise.$$intervalId);
        delete intervals[promise.$$intervalId];
        return true;
      }
      return false;
    };

    return interval;
  }];
}

/**
 * @ngdoc service
 * @name $jsonpCallbacks
 * @requires $window
 * @description
 * This service handles the lifecycle of callbacks to handle JSONP requests.
 * Override this service if you wish to customise where the callbacks are stored and
 * how they vary compared to the requested url.
 */
var $jsonpCallbacksProvider = function() {
  this.$get = ['$window', function($window) {
    var callbacks = $window.angular.callbacks;
    var callbackMap = {};

    function createCallback(callbackId) {
      var callback = function(data) {
        callback.data = data;
        callback.called = true;
      };
      callback.id = callbackId;
      return callback;
    }

    return {
      /**
       * @ngdoc method
       * @name $jsonpCallbacks#createCallback
       * @param {string} url the url of the JSONP request
       * @returns {string} the callback path to send to the server as part of the JSONP request
       * @description
       * {@link $httpBackend} calls this method to create a callback and get hold of the path to the callback
       * to pass to the server, which will be used to call the callback with its payload in the JSONP response.
       */
      createCallback: function(url) {
        var callbackId = '_' + (callbacks.$$counter++).toString(36);
        var callbackPath = 'angular.callbacks.' + callbackId;
        var callback = createCallback(callbackId);
        callbackMap[callbackPath] = callbacks[callbackId] = callback;
        return callbackPath;
      },
      /**
       * @ngdoc method
       * @name $jsonpCallbacks#wasCalled
       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
       * @returns {boolean} whether the callback has been called, as a result of the JSONP response
       * @description
       * {@link $httpBackend} calls this method to find out whether the JSONP response actually called the
       * callback that was passed in the request.
       */
      wasCalled: function(callbackPath) {
        return callbackMap[callbackPath].called;
      },
      /**
       * @ngdoc method
       * @name $jsonpCallbacks#getResponse
       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
       * @returns {*} the data received from the response via the registered callback
       * @description
       * {@link $httpBackend} calls this method to get hold of the data that was provided to the callback
       * in the JSONP response.
       */
      getResponse: function(callbackPath) {
        return callbackMap[callbackPath].data;
      },
      /**
       * @ngdoc method
       * @name $jsonpCallbacks#removeCallback
       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
       * @description
       * {@link $httpBackend} calls this method to remove the callback after the JSONP request has
       * completed or timed-out.
       */
      removeCallback: function(callbackPath) {
        var callback = callbackMap[callbackPath];
        delete callbacks[callback.id];
        delete callbackMap[callbackPath];
      }
    };
  }];
};

/**
 * @ngdoc service
 * @name $locale
 *
 * @description
 * $locale service provides localization rules for various Angular components. As of right now the
 * only public api is:
 *
 * * `id` – `{string}` – locale id formatted as `languageId-countryId` (e.g. `en-us`)
 */

var PATH_MATCH = /^([^\?#]*)(\?([^#]*))?(#(.*))?$/,
    DEFAULT_PORTS = {'http': 80, 'https': 443, 'ftp': 21};
var $locationMinErr = minErr('$location');


/**
 * Encode path using encodeUriSegment, ignoring forward slashes
 *
 * @param {string} path Path to encode
 * @returns {string}
 */
function encodePath(path) {
  var segments = path.split('/'),
      i = segments.length;

  while (i--) {
    segments[i] = encodeUriSegment(segments[i]);
  }

  return segments.join('/');
}

function parseAbsoluteUrl(absoluteUrl, locationObj) {
  var parsedUrl = urlResolve(absoluteUrl);

  locationObj.$$protocol = parsedUrl.protocol;
  locationObj.$$host = parsedUrl.hostname;
  locationObj.$$port = toInt(parsedUrl.port) || DEFAULT_PORTS[parsedUrl.protocol] || null;
}


function parseAppUrl(relativeUrl, locationObj) {
  var prefixed = (relativeUrl.charAt(0) !== '/');
  if (prefixed) {
    relativeUrl = '/' + relativeUrl;
  }
  var match = urlResolve(relativeUrl);
  locationObj.$$path = decodeURIComponent(prefixed && match.pathname.charAt(0) === '/' ?
      match.pathname.substring(1) : match.pathname);
  locationObj.$$search = parseKeyValue(match.search);
  locationObj.$$hash = decodeURIComponent(match.hash);

  // make sure path starts with '/';
  if (locationObj.$$path && locationObj.$$path.charAt(0) != '/') {
    locationObj.$$path = '/' + locationObj.$$path;
  }
}

function startsWith(haystack, needle) {
  return haystack.lastIndexOf(needle, 0) === 0;
}

/**
 *
 * @param {string} base
 * @param {string} url
 * @returns {string} returns text from `url` after `base` or `undefined` if it does not begin with
 *                   the expected string.
 */
function stripBaseUrl(base, url) {
  if (startsWith(url, base)) {
    return url.substr(base.length);
  }
}


function stripHash(url) {
  var index = url.indexOf('#');
  return index == -1 ? url : url.substr(0, index);
}

function trimEmptyHash(url) {
  return url.replace(/(#.+)|#$/, '$1');
}


function stripFile(url) {
  return url.substr(0, stripHash(url).lastIndexOf('/') + 1);
}

/* return the server only (scheme://host:port) */
function serverBase(url) {
  return url.substring(0, url.indexOf('/', url.indexOf('//') + 2));
}


/**
 * LocationHtml5Url represents an url
 * This object is exposed as $location service when HTML5 mode is enabled and supported
 *
 * @constructor
 * @param {string} appBase application base URL
 * @param {string} appBaseNoFile application base URL stripped of any filename
 * @param {string} basePrefix url path prefix
 */
function LocationHtml5Url(appBase, appBaseNoFile, basePrefix) {
  this.$$html5 = true;
  basePrefix = basePrefix || '';
  parseAbsoluteUrl(appBase, this);


  /**
   * Parse given html5 (regular) url string into properties
   * @param {string} url HTML5 url
   * @private
   */
  this.$$parse = function(url) {
    var pathUrl = stripBaseUrl(appBaseNoFile, url);
    if (!isString(pathUrl)) {
      throw $locationMinErr('ipthprfx', 'Invalid url "{0}", missing path prefix "{1}".', url,
          appBaseNoFile);
    }

    parseAppUrl(pathUrl, this);

    if (!this.$$path) {
      this.$$path = '/';
    }

    this.$$compose();
  };

  /**
   * Compose url and update `absUrl` property
   * @private
   */
  this.$$compose = function() {
    var search = toKeyValue(this.$$search),
        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';

    this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
    this.$$absUrl = appBaseNoFile + this.$$url.substr(1); // first char is always '/'
  };

  this.$$parseLinkUrl = function(url, relHref) {
    if (relHref && relHref[0] === '#') {
      // special case for links to hash fragments:
      // keep the old url and only replace the hash fragment
      this.hash(relHref.slice(1));
      return true;
    }
    var appUrl, prevAppUrl;
    var rewrittenUrl;

    if (isDefined(appUrl = stripBaseUrl(appBase, url))) {
      prevAppUrl = appUrl;
      if (isDefined(appUrl = stripBaseUrl(basePrefix, appUrl))) {
        rewrittenUrl = appBaseNoFile + (stripBaseUrl('/', appUrl) || appUrl);
      } else {
        rewrittenUrl = appBase + prevAppUrl;
      }
    } else if (isDefined(appUrl = stripBaseUrl(appBaseNoFile, url))) {
      rewrittenUrl = appBaseNoFile + appUrl;
    } else if (appBaseNoFile == url + '/') {
      rewrittenUrl = appBaseNoFile;
    }
    if (rewrittenUrl) {
      this.$$parse(rewrittenUrl);
    }
    return !!rewrittenUrl;
  };
}


/**
 * LocationHashbangUrl represents url
 * This object is exposed as $location service when developer doesn't opt into html5 mode.
 * It also serves as the base class for html5 mode fallback on legacy browsers.
 *
 * @constructor
 * @param {string} appBase application base URL
 * @param {string} appBaseNoFile application base URL stripped of any filename
 * @param {string} hashPrefix hashbang prefix
 */
function LocationHashbangUrl(appBase, appBaseNoFile, hashPrefix) {

  parseAbsoluteUrl(appBase, this);


  /**
   * Parse given hashbang url into properties
   * @param {string} url Hashbang url
   * @private
   */
  this.$$parse = function(url) {
    var withoutBaseUrl = stripBaseUrl(appBase, url) || stripBaseUrl(appBaseNoFile, url);
    var withoutHashUrl;

    if (!isUndefined(withoutBaseUrl) && withoutBaseUrl.charAt(0) === '#') {

      // The rest of the url starts with a hash so we have
      // got either a hashbang path or a plain hash fragment
      withoutHashUrl = stripBaseUrl(hashPrefix, withoutBaseUrl);
      if (isUndefined(withoutHashUrl)) {
        // There was no hashbang prefix so we just have a hash fragment
        withoutHashUrl = withoutBaseUrl;
      }

    } else {
      // There was no hashbang path nor hash fragment:
      // If we are in HTML5 mode we use what is left as the path;
      // Otherwise we ignore what is left
      if (this.$$html5) {
        withoutHashUrl = withoutBaseUrl;
      } else {
        withoutHashUrl = '';
        if (isUndefined(withoutBaseUrl)) {
          appBase = url;
          this.replace();
        }
      }
    }

    parseAppUrl(withoutHashUrl, this);

    this.$$path = removeWindowsDriveName(this.$$path, withoutHashUrl, appBase);

    this.$$compose();

    /*
     * In Windows, on an anchor node on documents loaded from
     * the filesystem, the browser will return a pathname
     * prefixed with the drive name ('/C:/path') when a
     * pathname without a drive is set:
     *  * a.setAttribute('href', '/foo')
     *   * a.pathname === '/C:/foo' //true
     *
     * Inside of Angular, we're always using pathnames that
     * do not include drive names for routing.
     */
    function removeWindowsDriveName(path, url, base) {
      /*
      Matches paths for file protocol on windows,
      such as /C:/foo/bar, and captures only /foo/bar.
      */
      var windowsFilePathExp = /^\/[A-Z]:(\/.*)/;

      var firstPathSegmentMatch;

      //Get the relative path from the input URL.
      if (startsWith(url, base)) {
        url = url.replace(base, '');
      }

      // The input URL intentionally contains a first path segment that ends with a colon.
      if (windowsFilePathExp.exec(url)) {
        return path;
      }

      firstPathSegmentMatch = windowsFilePathExp.exec(path);
      return firstPathSegmentMatch ? firstPathSegmentMatch[1] : path;
    }
  };

  /**
   * Compose hashbang url and update `absUrl` property
   * @private
   */
  this.$$compose = function() {
    var search = toKeyValue(this.$$search),
        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';

    this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
    this.$$absUrl = appBase + (this.$$url ? hashPrefix + this.$$url : '');
  };

  this.$$parseLinkUrl = function(url, relHref) {
    if (stripHash(appBase) == stripHash(url)) {
      this.$$parse(url);
      return true;
    }
    return false;
  };
}


/**
 * LocationHashbangUrl represents url
 * This object is exposed as $location service when html5 history api is enabled but the browser
 * does not support it.
 *
 * @constructor
 * @param {string} appBase application base URL
 * @param {string} appBaseNoFile application base URL stripped of any filename
 * @param {string} hashPrefix hashbang prefix
 */
function LocationHashbangInHtml5Url(appBase, appBaseNoFile, hashPrefix) {
  this.$$html5 = true;
  LocationHashbangUrl.apply(this, arguments);

  this.$$parseLinkUrl = function(url, relHref) {
    if (relHref && relHref[0] === '#') {
      // special case for links to hash fragments:
      // keep the old url and only replace the hash fragment
      this.hash(relHref.slice(1));
      return true;
    }

    var rewrittenUrl;
    var appUrl;

    if (appBase == stripHash(url)) {
      rewrittenUrl = url;
    } else if ((appUrl = stripBaseUrl(appBaseNoFile, url))) {
      rewrittenUrl = appBase + hashPrefix + appUrl;
    } else if (appBaseNoFile === url + '/') {
      rewrittenUrl = appBaseNoFile;
    }
    if (rewrittenUrl) {
      this.$$parse(rewrittenUrl);
    }
    return !!rewrittenUrl;
  };

  this.$$compose = function() {
    var search = toKeyValue(this.$$search),
        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';

    this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
    // include hashPrefix in $$absUrl when $$url is empty so IE9 does not reload page because of removal of '#'
    this.$$absUrl = appBase + hashPrefix + this.$$url;
  };

}


var locationPrototype = {

  /**
   * Ensure absolute url is initialized.
   * @private
   */
  $$absUrl:'',

  /**
   * Are we in html5 mode?
   * @private
   */
  $$html5: false,

  /**
   * Has any change been replacing?
   * @private
   */
  $$replace: false,

  /**
   * @ngdoc method
   * @name $location#absUrl
   *
   * @description
   * This method is getter only.
   *
   * Return full url representation with all segments encoded according to rules specified in
   * [RFC 3986](http://www.ietf.org/rfc/rfc3986.txt).
   *
   *
   * ```js
   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
   * var absUrl = $location.absUrl();
   * // => "http://example.com/#/some/path?foo=bar&baz=xoxo"
   * ```
   *
   * @return {string} full url
   */
  absUrl: locationGetter('$$absUrl'),

  /**
   * @ngdoc method
   * @name $location#url
   *
   * @description
   * This method is getter / setter.
   *
   * Return url (e.g. `/path?a=b#hash`) when called without any parameter.
   *
   * Change path, search and hash, when called with parameter and return `$location`.
   *
   *
   * ```js
   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
   * var url = $location.url();
   * // => "/some/path?foo=bar&baz=xoxo"
   * ```
   *
   * @param {string=} url New url without base prefix (e.g. `/path?a=b#hash`)
   * @return {string} url
   */
  url: function(url) {
    if (isUndefined(url)) {
      return this.$$url;
    }

    var match = PATH_MATCH.exec(url);
    if (match[1] || url === '') this.path(decodeURIComponent(match[1]));
    if (match[2] || match[1] || url === '') this.search(match[3] || '');
    this.hash(match[5] || '');

    return this;
  },

  /**
   * @ngdoc method
   * @name $location#protocol
   *
   * @description
   * This method is getter only.
   *
   * Return protocol of current url.
   *
   *
   * ```js
   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
   * var protocol = $location.protocol();
   * // => "http"
   * ```
   *
   * @return {string} protocol of current url
   */
  protocol: locationGetter('$$protocol'),

  /**
   * @ngdoc method
   * @name $location#host
   *
   * @description
   * This method is getter only.
   *
   * Return host of current url.
   *
   * Note: compared to the non-angular version `location.host` which returns `hostname:port`, this returns the `hostname` portion only.
   *
   *
   * ```js
   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
   * var host = $location.host();
   * // => "example.com"
   *
   * // given url http://user:password@example.com:8080/#/some/path?foo=bar&baz=xoxo
   * host = $location.host();
   * // => "example.com"
   * host = location.host;
   * // => "example.com:8080"
   * ```
   *
   * @return {string} host of current url.
   */
  host: locationGetter('$$host'),

  /**
   * @ngdoc method
   * @name $location#port
   *
   * @description
   * This method is getter only.
   *
   * Return port of current url.
   *
   *
   * ```js
   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
   * var port = $location.port();
   * // => 80
   * ```
   *
   * @return {Number} port
   */
  port: locationGetter('$$port'),

  /**
   * @ngdoc method
   * @name $location#path
   *
   * @description
   * This method is getter / setter.
   *
   * Return path of current url when called without any parameter.
   *
   * Change path when called with parameter and return `$location`.
   *
   * Note: Path should always begin with forward slash (/), this method will add the forward slash
   * if it is missing.
   *
   *
   * ```js
   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
   * var path = $location.path();
   * // => "/some/path"
   * ```
   *
   * @param {(string|number)=} path New path
   * @return {(string|object)} path if called with no parameters, or `$location` if called with a parameter
   */
  path: locationGetterSetter('$$path', function(path) {
    path = path !== null ? path.toString() : '';
    return path.charAt(0) == '/' ? path : '/' + path;
  }),

  /**
   * @ngdoc method
   * @name $location#search
   *
   * @description
   * This method is getter / setter.
   *
   * Return search part (as object) of current url when called without any parameter.
   *
   * Change search part when called with parameter and return `$location`.
   *
   *
   * ```js
   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
   * var searchObject = $location.search();
   * // => {foo: 'bar', baz: 'xoxo'}
   *
   * // set foo to 'yipee'
   * $location.search('foo', 'yipee');
   * // $location.search() => {foo: 'yipee', baz: 'xoxo'}
   * ```
   *
   * @param {string|Object.<string>|Object.<Array.<string>>} search New search params - string or
   * hash object.
   *
   * When called with a single argument the method acts as a setter, setting the `search` component
   * of `$location` to the specified value.
   *
   * If the argument is a hash object containing an array of values, these values will be encoded
   * as duplicate search parameters in the url.
   *
   * @param {(string|Number|Array<string>|boolean)=} paramValue If `search` is a string or number, then `paramValue`
   * will override only a single search property.
   *
   * If `paramValue` is an array, it will override the property of the `search` component of
   * `$location` specified via the first argument.
   *
   * If `paramValue` is `null`, the property specified via the first argument will be deleted.
   *
   * If `paramValue` is `true`, the property specified via the first argument will be added with no
   * value nor trailing equal sign.
   *
   * @return {Object} If called with no arguments returns the parsed `search` object. If called with
   * one or more arguments returns `$location` object itself.
   */
  search: function(search, paramValue) {
    switch (arguments.length) {
      case 0:
        return this.$$search;
      case 1:
        if (isString(search) || isNumber(search)) {
          search = search.toString();
          this.$$search = parseKeyValue(search);
        } else if (isObject(search)) {
          search = copy(search, {});
          // remove object undefined or null properties
          forEach(search, function(value, key) {
            if (value == null) delete search[key];
          });

          this.$$search = search;
        } else {
          throw $locationMinErr('isrcharg',
              'The first argument of the `$location#search()` call must be a string or an object.');
        }
        break;
      default:
        if (isUndefined(paramValue) || paramValue === null) {
          delete this.$$search[search];
        } else {
          this.$$search[search] = paramValue;
        }
    }

    this.$$compose();
    return this;
  },

  /**
   * @ngdoc method
   * @name $location#hash
   *
   * @description
   * This method is getter / setter.
   *
   * Returns the hash fragment when called without any parameters.
   *
   * Changes the hash fragment when called with a parameter and returns `$location`.
   *
   *
   * ```js
   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo#hashValue
   * var hash = $location.hash();
   * // => "hashValue"
   * ```
   *
   * @param {(string|number)=} hash New hash fragment
   * @return {string} hash
   */
  hash: locationGetterSetter('$$hash', function(hash) {
    return hash !== null ? hash.toString() : '';
  }),

  /**
   * @ngdoc method
   * @name $location#replace
   *
   * @description
   * If called, all changes to $location during the current `$digest` will replace the current history
   * record, instead of adding a new one.
   */
  replace: function() {
    this.$$replace = true;
    return this;
  }
};

forEach([LocationHashbangInHtml5Url, LocationHashbangUrl, LocationHtml5Url], function(Location) {
  Location.prototype = Object.create(locationPrototype);

  /**
   * @ngdoc method
   * @name $location#state
   *
   * @description
   * This method is getter / setter.
   *
   * Return the history state object when called without any parameter.
   *
   * Change the history state object when called with one parameter and return `$location`.
   * The state object is later passed to `pushState` or `replaceState`.
   *
   * NOTE: This method is supported only in HTML5 mode and only in browsers supporting
   * the HTML5 History API (i.e. methods `pushState` and `replaceState`). If you need to support
   * older browsers (like IE9 or Android < 4.0), don't use this method.
   *
   * @param {object=} state State object for pushState or replaceState
   * @return {object} state
   */
  Location.prototype.state = function(state) {
    if (!arguments.length) {
      return this.$$state;
    }

    if (Location !== LocationHtml5Url || !this.$$html5) {
      throw $locationMinErr('nostate', 'History API state support is available only ' +
        'in HTML5 mode and only in browsers supporting HTML5 History API');
    }
    // The user might modify `stateObject` after invoking `$location.state(stateObject)`
    // but we're changing the $$state reference to $browser.state() during the $digest
    // so the modification window is narrow.
    this.$$state = isUndefined(state) ? null : state;

    return this;
  };
});


function locationGetter(property) {
  return function() {
    return this[property];
  };
}


function locationGetterSetter(property, preprocess) {
  return function(value) {
    if (isUndefined(value)) {
      return this[property];
    }

    this[property] = preprocess(value);
    this.$$compose();

    return this;
  };
}


/**
 * @ngdoc service
 * @name $location
 *
 * @requires $rootElement
 *
 * @description
 * The $location service parses the URL in the browser address bar (based on the
 * [window.location](https://developer.mozilla.org/en/window.location)) and makes the URL
 * available to your application. Changes to the URL in the address bar are reflected into
 * $location service and changes to $location are reflected into the browser address bar.
 *
 * **The $location service:**
 *
 * - Exposes the current URL in the browser address bar, so you can
 *   - Watch and observe the URL.
 *   - Change the URL.
 * - Synchronizes the URL with the browser when the user
 *   - Changes the address bar.
 *   - Clicks the back or forward button (or clicks a History link).
 *   - Clicks on a link.
 * - Represents the URL object as a set of methods (protocol, host, port, path, search, hash).
 *
 * For more information see {@link guide/$location Developer Guide: Using $location}
 */

/**
 * @ngdoc provider
 * @name $locationProvider
 * @description
 * Use the `$locationProvider` to configure how the application deep linking paths are stored.
 */
function $LocationProvider() {
  var hashPrefix = '',
      html5Mode = {
        enabled: false,
        requireBase: true,
        rewriteLinks: true
      };

  /**
   * @ngdoc method
   * @name $locationProvider#hashPrefix
   * @description
   * @param {string=} prefix Prefix for hash part (containing path and search)
   * @returns {*} current value if used as getter or itself (chaining) if used as setter
   */
  this.hashPrefix = function(prefix) {
    if (isDefined(prefix)) {
      hashPrefix = prefix;
      return this;
    } else {
      return hashPrefix;
    }
  };

  /**
   * @ngdoc method
   * @name $locationProvider#html5Mode
   * @description
   * @param {(boolean|Object)=} mode If boolean, sets `html5Mode.enabled` to value.
   *   If object, sets `enabled`, `requireBase` and `rewriteLinks` to respective values. Supported
   *   properties:
   *   - **enabled** – `{boolean}` – (default: false) If true, will rely on `history.pushState` to
   *     change urls where supported. Will fall back to hash-prefixed paths in browsers that do not
   *     support `pushState`.
   *   - **requireBase** - `{boolean}` - (default: `true`) When html5Mode is enabled, specifies
   *     whether or not a <base> tag is required to be present. If `enabled` and `requireBase` are
   *     true, and a base tag is not present, an error will be thrown when `$location` is injected.
   *     See the {@link guide/$location $location guide for more information}
   *   - **rewriteLinks** - `{boolean}` - (default: `true`) When html5Mode is enabled,
   *     enables/disables url rewriting for relative links.
   *
   * @returns {Object} html5Mode object if used as getter or itself (chaining) if used as setter
   */
  this.html5Mode = function(mode) {
    if (isBoolean(mode)) {
      html5Mode.enabled = mode;
      return this;
    } else if (isObject(mode)) {

      if (isBoolean(mode.enabled)) {
        html5Mode.enabled = mode.enabled;
      }

      if (isBoolean(mode.requireBase)) {
        html5Mode.requireBase = mode.requireBase;
      }

      if (isBoolean(mode.rewriteLinks)) {
        html5Mode.rewriteLinks = mode.rewriteLinks;
      }

      return this;
    } else {
      return html5Mode;
    }
  };

  /**
   * @ngdoc event
   * @name $location#$locationChangeStart
   * @eventType broadcast on root scope
   * @description
   * Broadcasted before a URL will change.
   *
   * This change can be prevented by calling
   * `preventDefault` method of the event. See {@link ng.$rootScope.Scope#$on} for more
   * details about event object. Upon successful change
   * {@link ng.$location#$locationChangeSuccess $locationChangeSuccess} is fired.
   *
   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
   * the browser supports the HTML5 History API.
   *
   * @param {Object} angularEvent Synthetic event object.
   * @param {string} newUrl New URL
   * @param {string=} oldUrl URL that was before it was changed.
   * @param {string=} newState New history state object
   * @param {string=} oldState History state object that was before it was changed.
   */

  /**
   * @ngdoc event
   * @name $location#$locationChangeSuccess
   * @eventType broadcast on root scope
   * @description
   * Broadcasted after a URL was changed.
   *
   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
   * the browser supports the HTML5 History API.
   *
   * @param {Object} angularEvent Synthetic event object.
   * @param {string} newUrl New URL
   * @param {string=} oldUrl URL that was before it was changed.
   * @param {string=} newState New history state object
   * @param {string=} oldState History state object that was before it was changed.
   */

  this.$get = ['$rootScope', '$browser', '$sniffer', '$rootElement', '$window',
      function($rootScope, $browser, $sniffer, $rootElement, $window) {
    var $location,
        LocationMode,
        baseHref = $browser.baseHref(), // if base[href] is undefined, it defaults to ''
        initialUrl = $browser.url(),
        appBase;

    if (html5Mode.enabled) {
      if (!baseHref && html5Mode.requireBase) {
        throw $locationMinErr('nobase',
          "$location in HTML5 mode requires a <base> tag to be present!");
      }
      appBase = serverBase(initialUrl) + (baseHref || '/');
      LocationMode = $sniffer.history ? LocationHtml5Url : LocationHashbangInHtml5Url;
    } else {
      appBase = stripHash(initialUrl);
      LocationMode = LocationHashbangUrl;
    }
    var appBaseNoFile = stripFile(appBase);

    $location = new LocationMode(appBase, appBaseNoFile, '#' + hashPrefix);
    $location.$$parseLinkUrl(initialUrl, initialUrl);

    $location.$$state = $browser.state();

    var IGNORE_URI_REGEXP = /^\s*(javascript|mailto):/i;

    function setBrowserUrlWithFallback(url, replace, state) {
      var oldUrl = $location.url();
      var oldState = $location.$$state;
      try {
        $browser.url(url, replace, state);

        // Make sure $location.state() returns referentially identical (not just deeply equal)
        // state object; this makes possible quick checking if the state changed in the digest
        // loop. Checking deep equality would be too expensive.
        $location.$$state = $browser.state();
      } catch (e) {
        // Restore old values if pushState fails
        $location.url(oldUrl);
        $location.$$state = oldState;

        throw e;
      }
    }

    $rootElement.on('click', function(event) {
      // TODO(vojta): rewrite link when opening in new tab/window (in legacy browser)
      // currently we open nice url link and redirect then

      if (!html5Mode.rewriteLinks || event.ctrlKey || event.metaKey || event.shiftKey || event.which == 2 || event.button == 2) return;

      var elm = jqLite(event.target);

      // traverse the DOM up to find first A tag
      while (nodeName_(elm[0]) !== 'a') {
        // ignore rewriting if no A tag (reached root element, or no parent - removed from document)
        if (elm[0] === $rootElement[0] || !(elm = elm.parent())[0]) return;
      }

      var absHref = elm.prop('href');
      // get the actual href attribute - see
      // http://msdn.microsoft.com/en-us/library/ie/dd347148(v=vs.85).aspx
      var relHref = elm.attr('href') || elm.attr('xlink:href');

      if (isObject(absHref) && absHref.toString() === '[object SVGAnimatedString]') {
        // SVGAnimatedString.animVal should be identical to SVGAnimatedString.baseVal, unless during
        // an animation.
        absHref = urlResolve(absHref.animVal).href;
      }

      // Ignore when url is started with javascript: or mailto:
      if (IGNORE_URI_REGEXP.test(absHref)) return;

      if (absHref && !elm.attr('target') && !event.isDefaultPrevented()) {
        if ($location.$$parseLinkUrl(absHref, relHref)) {
          // We do a preventDefault for all urls that are part of the angular application,
          // in html5mode and also without, so that we are able to abort navigation without
          // getting double entries in the location history.
          event.preventDefault();
          // update location manually
          if ($location.absUrl() != $browser.url()) {
            $rootScope.$apply();
            // hack to work around FF6 bug 684208 when scenario runner clicks on links
            $window.angular['ff-684208-preventDefault'] = true;
          }
        }
      }
    });


    // rewrite hashbang url <> html5 url
    if (trimEmptyHash($location.absUrl()) != trimEmptyHash(initialUrl)) {
      $browser.url($location.absUrl(), true);
    }

    var initializing = true;

    // update $location when $browser url changes
    $browser.onUrlChange(function(newUrl, newState) {

      if (isUndefined(stripBaseUrl(appBaseNoFile, newUrl))) {
        // If we are navigating outside of the app then force a reload
        $window.location.href = newUrl;
        return;
      }

      $rootScope.$evalAsync(function() {
        var oldUrl = $location.absUrl();
        var oldState = $location.$$state;
        var defaultPrevented;
        newUrl = trimEmptyHash(newUrl);
        $location.$$parse(newUrl);
        $location.$$state = newState;

        defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
            newState, oldState).defaultPrevented;

        // if the location was changed by a `$locationChangeStart` handler then stop
        // processing this location change
        if ($location.absUrl() !== newUrl) return;

        if (defaultPrevented) {
          $location.$$parse(oldUrl);
          $location.$$state = oldState;
          setBrowserUrlWithFallback(oldUrl, false, oldState);
        } else {
          initializing = false;
          afterLocationChange(oldUrl, oldState);
        }
      });
      if (!$rootScope.$$phase) $rootScope.$digest();
    });

    // update browser
    $rootScope.$watch(function $locationWatch() {
      var oldUrl = trimEmptyHash($browser.url());
      var newUrl = trimEmptyHash($location.absUrl());
      var oldState = $browser.state();
      var currentReplace = $location.$$replace;
      var urlOrStateChanged = oldUrl !== newUrl ||
        ($location.$$html5 && $sniffer.history && oldState !== $location.$$state);

      if (initializing || urlOrStateChanged) {
        initializing = false;

        $rootScope.$evalAsync(function() {
          var newUrl = $location.absUrl();
          var defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
              $location.$$state, oldState).defaultPrevented;

          // if the location was changed by a `$locationChangeStart` handler then stop
          // processing this location change
          if ($location.absUrl() !== newUrl) return;

          if (defaultPrevented) {
            $location.$$parse(oldUrl);
            $location.$$state = oldState;
          } else {
            if (urlOrStateChanged) {
              setBrowserUrlWithFallback(newUrl, currentReplace,
                                        oldState === $location.$$state ? null : $location.$$state);
            }
            afterLocationChange(oldUrl, oldState);
          }
        });
      }

      $location.$$replace = false;

      // we don't need to return anything because $evalAsync will make the digest loop dirty when
      // there is a change
    });

    return $location;

    function afterLocationChange(oldUrl, oldState) {
      $rootScope.$broadcast('$locationChangeSuccess', $location.absUrl(), oldUrl,
        $location.$$state, oldState);
    }
}];
}

/**
 * @ngdoc service
 * @name $log
 * @requires $window
 *
 * @description
 * Simple service for logging. Default implementation safely writes the message
 * into the browser's console (if present).
 *
 * The main purpose of this service is to simplify debugging and troubleshooting.
 *
 * The default is to log `debug` messages. You can use
 * {@link ng.$logProvider ng.$logProvider#debugEnabled} to change this.
 *
 * @example
   <example module="logExample">
     <file name="script.js">
       angular.module('logExample', [])
         .controller('LogController', ['$scope', '$log', function($scope, $log) {
           $scope.$log = $log;
           $scope.message = 'Hello World!';
         }]);
     </file>
     <file name="index.html">
       <div ng-controller="LogController">
         <p>Reload this page with open console, enter text and hit the log button...</p>
         <label>Message:
         <input type="text" ng-model="message" /></label>
         <button ng-click="$log.log(message)">log</button>
         <button ng-click="$log.warn(message)">warn</button>
         <button ng-click="$log.info(message)">info</button>
         <button ng-click="$log.error(message)">error</button>
         <button ng-click="$log.debug(message)">debug</button>
       </div>
     </file>
   </example>
 */

/**
 * @ngdoc provider
 * @name $logProvider
 * @description
 * Use the `$logProvider` to configure how the application logs messages
 */
function $LogProvider() {
  var debug = true,
      self = this;

  /**
   * @ngdoc method
   * @name $logProvider#debugEnabled
   * @description
   * @param {boolean=} flag enable or disable debug level messages
   * @returns {*} current value if used as getter or itself (chaining) if used as setter
   */
  this.debugEnabled = function(flag) {
    if (isDefined(flag)) {
      debug = flag;
    return this;
    } else {
      return debug;
    }
  };

  this.$get = ['$window', function($window) {
    return {
      /**
       * @ngdoc method
       * @name $log#log
       *
       * @description
       * Write a log message
       */
      log: consoleLog('log'),

      /**
       * @ngdoc method
       * @name $log#info
       *
       * @description
       * Write an information message
       */
      info: consoleLog('info'),

      /**
       * @ngdoc method
       * @name $log#warn
       *
       * @description
       * Write a warning message
       */
      warn: consoleLog('warn'),

      /**
       * @ngdoc method
       * @name $log#error
       *
       * @description
       * Write an error message
       */
      error: consoleLog('error'),

      /**
       * @ngdoc method
       * @name $log#debug
       *
       * @description
       * Write a debug message
       */
      debug: (function() {
        var fn = consoleLog('debug');

        return function() {
          if (debug) {
            fn.apply(self, arguments);
          }
        };
      }())
    };

    function formatError(arg) {
      if (arg instanceof Error) {
        if (arg.stack) {
          arg = (arg.message && arg.stack.indexOf(arg.message) === -1)
              ? 'Error: ' + arg.message + '\n' + arg.stack
              : arg.stack;
        } else if (arg.sourceURL) {
          arg = arg.message + '\n' + arg.sourceURL + ':' + arg.line;
        }
      }
      return arg;
    }

    function consoleLog(type) {
      var console = $window.console || {},
          logFn = console[type] || console.log || noop,
          hasApply = false;

      // Note: reading logFn.apply throws an error in IE11 in IE8 document mode.
      // The reason behind this is that console.log has type "object" in IE8...
      try {
        hasApply = !!logFn.apply;
      } catch (e) {}

      if (hasApply) {
        return function() {
          var args = [];
          forEach(arguments, function(arg) {
            args.push(formatError(arg));
          });
          return logFn.apply(console, args);
        };
      }

      // we are IE which either doesn't have window.console => this is noop and we do nothing,
      // or we are IE where console.log doesn't have apply so we log at least first 2 args
      return function(arg1, arg2) {
        logFn(arg1, arg2 == null ? '' : arg2);
      };
    }
  }];
}

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *     Any commits to this file should be reviewed with security in mind.  *
 *   Changes to this file can potentially create security vulnerabilities. *
 *          An approval from 2 Core members with history of modifying      *
 *                         this file is required.                          *
 *                                                                         *
 *  Does the change somehow allow for arbitrary javascript to be executed? *
 *    Or allows for someone to change the prototype of built-in objects?   *
 *     Or gives undesired access to variables likes document or window?    *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

var $parseMinErr = minErr('$parse');

// Sandboxing Angular Expressions
// ------------------------------
// Angular expressions are generally considered safe because these expressions only have direct
// access to `$scope` and locals. However, one can obtain the ability to execute arbitrary JS code by
// obtaining a reference to native JS functions such as the Function constructor.
//
// As an example, consider the following Angular expression:
//
//   {}.toString.constructor('alert("evil JS code")')
//
// This sandboxing technique is not perfect and doesn't aim to be. The goal is to prevent exploits
// against the expression language, but not to prevent exploits that were enabled by exposing
// sensitive JavaScript or browser APIs on Scope. Exposing such objects on a Scope is never a good
// practice and therefore we are not even trying to protect against interaction with an object
// explicitly exposed in this way.
//
// In general, it is not possible to access a Window object from an angular expression unless a
// window or some DOM object that has a reference to window is published onto a Scope.
// Similarly we prevent invocations of function known to be dangerous, as well as assignments to
// native objects.
//
// See https://docs.angularjs.org/guide/security


function ensureSafeMemberName(name, fullExpression) {
  if (name === "__defineGetter__" || name === "__defineSetter__"
      || name === "__lookupGetter__" || name === "__lookupSetter__"
      || name === "__proto__") {
    throw $parseMinErr('isecfld',
        'Attempting to access a disallowed field in Angular expressions! '
        + 'Expression: {0}', fullExpression);
  }
  return name;
}

function getStringValue(name) {
  // Property names must be strings. This means that non-string objects cannot be used
  // as keys in an object. Any non-string object, including a number, is typecasted
  // into a string via the toString method.
  // -- MDN, https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Operators/Property_accessors#Property_names
  //
  // So, to ensure that we are checking the same `name` that JavaScript would use, we cast it
  // to a string. It's not always possible. If `name` is an object and its `toString` method is
  // 'broken' (doesn't return a string, isn't a function, etc.), an error will be thrown:
  //
  // TypeError: Cannot convert object to primitive value
  //
  // For performance reasons, we don't catch this error here and allow it to propagate up the call
  // stack. Note that you'll get the same error in JavaScript if you try to access a property using
  // such a 'broken' object as a key.
  return name + '';
}

function ensureSafeObject(obj, fullExpression) {
  // nifty check if obj is Function that is fast and works across iframes and other contexts
  if (obj) {
    if (obj.constructor === obj) {
      throw $parseMinErr('isecfn',
          'Referencing Function in Angular expressions is disallowed! Expression: {0}',
          fullExpression);
    } else if (// isWindow(obj)
        obj.window === obj) {
      throw $parseMinErr('isecwindow',
          'Referencing the Window in Angular expressions is disallowed! Expression: {0}',
          fullExpression);
    } else if (// isElement(obj)
        obj.children && (obj.nodeName || (obj.prop && obj.attr && obj.find))) {
      throw $parseMinErr('isecdom',
          'Referencing DOM nodes in Angular expressions is disallowed! Expression: {0}',
          fullExpression);
    } else if (// block Object so that we can't get hold of dangerous Object.* methods
        obj === Object) {
      throw $parseMinErr('isecobj',
          'Referencing Object in Angular expressions is disallowed! Expression: {0}',
          fullExpression);
    }
  }
  return obj;
}

var CALL = Function.prototype.call;
var APPLY = Function.prototype.apply;
var BIND = Function.prototype.bind;

function ensureSafeFunction(obj, fullExpression) {
  if (obj) {
    if (obj.constructor === obj) {
      throw $parseMinErr('isecfn',
        'Referencing Function in Angular expressions is disallowed! Expression: {0}',
        fullExpression);
    } else if (obj === CALL || obj === APPLY || obj === BIND) {
      throw $parseMinErr('isecff',
        'Referencing call, apply or bind in Angular expressions is disallowed! Expression: {0}',
        fullExpression);
    }
  }
}

function ensureSafeAssignContext(obj, fullExpression) {
  if (obj) {
    if (obj === (0).constructor || obj === (false).constructor || obj === ''.constructor ||
        obj === {}.constructor || obj === [].constructor || obj === Function.constructor) {
      throw $parseMinErr('isecaf',
        'Assigning to a constructor is disallowed! Expression: {0}', fullExpression);
    }
  }
}

var OPERATORS = createMap();
forEach('+ - * / % === !== == != < > <= >= && || ! = |'.split(' '), function(operator) { OPERATORS[operator] = true; });
var ESCAPE = {"n":"\n", "f":"\f", "r":"\r", "t":"\t", "v":"\v", "'":"'", '"':'"'};


/////////////////////////////////////////


/**
 * @constructor
 */
var Lexer = function(options) {
  this.options = options;
};

Lexer.prototype = {
  constructor: Lexer,

  lex: function(text) {
    this.text = text;
    this.index = 0;
    this.tokens = [];

    while (this.index < this.text.length) {
      var ch = this.text.charAt(this.index);
      if (ch === '"' || ch === "'") {
        this.readString(ch);
      } else if (this.isNumber(ch) || ch === '.' && this.isNumber(this.peek())) {
        this.readNumber();
      } else if (this.isIdentifierStart(this.peekMultichar())) {
        this.readIdent();
      } else if (this.is(ch, '(){}[].,;:?')) {
        this.tokens.push({index: this.index, text: ch});
        this.index++;
      } else if (this.isWhitespace(ch)) {
        this.index++;
      } else {
        var ch2 = ch + this.peek();
        var ch3 = ch2 + this.peek(2);
        var op1 = OPERATORS[ch];
        var op2 = OPERATORS[ch2];
        var op3 = OPERATORS[ch3];
        if (op1 || op2 || op3) {
          var token = op3 ? ch3 : (op2 ? ch2 : ch);
          this.tokens.push({index: this.index, text: token, operator: true});
          this.index += token.length;
        } else {
          this.throwError('Unexpected next character ', this.index, this.index + 1);
        }
      }
    }
    return this.tokens;
  },

  is: function(ch, chars) {
    return chars.indexOf(ch) !== -1;
  },

  peek: function(i) {
    var num = i || 1;
    return (this.index + num < this.text.length) ? this.text.charAt(this.index + num) : false;
  },

  isNumber: function(ch) {
    return ('0' <= ch && ch <= '9') && typeof ch === "string";
  },

  isWhitespace: function(ch) {
    // IE treats non-breaking space as \u00A0
    return (ch === ' ' || ch === '\r' || ch === '\t' ||
            ch === '\n' || ch === '\v' || ch === '\u00A0');
  },

  isIdentifierStart: function(ch) {
    return this.options.isIdentifierStart ?
        this.options.isIdentifierStart(ch, this.codePointAt(ch)) :
        this.isValidIdentifierStart(ch);
  },

  isValidIdentifierStart: function(ch) {
    return ('a' <= ch && ch <= 'z' ||
            'A' <= ch && ch <= 'Z' ||
            '_' === ch || ch === '$');
  },

  isIdentifierContinue: function(ch) {
    return this.options.isIdentifierContinue ?
        this.options.isIdentifierContinue(ch, this.codePointAt(ch)) :
        this.isValidIdentifierContinue(ch);
  },

  isValidIdentifierContinue: function(ch, cp) {
    return this.isValidIdentifierStart(ch, cp) || this.isNumber(ch);
  },

  codePointAt: function(ch) {
    if (ch.length === 1) return ch.charCodeAt(0);
    /*jshint bitwise: false*/
    return (ch.charCodeAt(0) << 10) + ch.charCodeAt(1) - 0x35FDC00;
    /*jshint bitwise: true*/
  },

  peekMultichar: function() {
    var ch = this.text.charAt(this.index);
    var peek = this.peek();
    if (!peek) {
      return ch;
    }
    var cp1 = ch.charCodeAt(0);
    var cp2 = peek.charCodeAt(0);
    if (cp1 >= 0xD800 && cp1 <= 0xDBFF && cp2 >= 0xDC00 && cp2 <= 0xDFFF) {
      return ch + peek;
    }
    return ch;
  },

  isExpOperator: function(ch) {
    return (ch === '-' || ch === '+' || this.isNumber(ch));
  },

  throwError: function(error, start, end) {
    end = end || this.index;
    var colStr = (isDefined(start)
            ? 's ' + start +  '-' + this.index + ' [' + this.text.substring(start, end) + ']'
            : ' ' + end);
    throw $parseMinErr('lexerr', 'Lexer Error: {0} at column{1} in expression [{2}].',
        error, colStr, this.text);
  },

  readNumber: function() {
    var number = '';
    var start = this.index;
    while (this.index < this.text.length) {
      var ch = lowercase(this.text.charAt(this.index));
      if (ch == '.' || this.isNumber(ch)) {
        number += ch;
      } else {
        var peekCh = this.peek();
        if (ch == 'e' && this.isExpOperator(peekCh)) {
          number += ch;
        } else if (this.isExpOperator(ch) &&
            peekCh && this.isNumber(peekCh) &&
            number.charAt(number.length - 1) == 'e') {
          number += ch;
        } else if (this.isExpOperator(ch) &&
            (!peekCh || !this.isNumber(peekCh)) &&
            number.charAt(number.length - 1) == 'e') {
          this.throwError('Invalid exponent');
        } else {
          break;
        }
      }
      this.index++;
    }
    this.tokens.push({
      index: start,
      text: number,
      constant: true,
      value: Number(number)
    });
  },

  readIdent: function() {
    var start = this.index;
    this.index += this.peekMultichar().length;
    while (this.index < this.text.length) {
      var ch = this.peekMultichar();
      if (!this.isIdentifierContinue(ch)) {
        break;
      }
      this.index += ch.length;
    }
    this.tokens.push({
      index: start,
      text: this.text.slice(start, this.index),
      identifier: true
    });
  },

  readString: function(quote) {
    var start = this.index;
    this.index++;
    var string = '';
    var rawString = quote;
    var escape = false;
    while (this.index < this.text.length) {
      var ch = this.text.charAt(this.index);
      rawString += ch;
      if (escape) {
        if (ch === 'u') {
          var hex = this.text.substring(this.index + 1, this.index + 5);
          if (!hex.match(/[\da-f]{4}/i)) {
            this.throwError('Invalid unicode escape [\\u' + hex + ']');
          }
          this.index += 4;
          string += String.fromCharCode(parseInt(hex, 16));
        } else {
          var rep = ESCAPE[ch];
          string = string + (rep || ch);
        }
        escape = false;
      } else if (ch === '\\') {
        escape = true;
      } else if (ch === quote) {
        this.index++;
        this.tokens.push({
          index: start,
          text: rawString,
          constant: true,
          value: string
        });
        return;
      } else {
        string += ch;
      }
      this.index++;
    }
    this.throwError('Unterminated quote', start);
  }
};

var AST = function(lexer, options) {
  this.lexer = lexer;
  this.options = options;
};

AST.Program = 'Program';
AST.ExpressionStatement = 'ExpressionStatement';
AST.AssignmentExpression = 'AssignmentExpression';
AST.ConditionalExpression = 'ConditionalExpression';
AST.LogicalExpression = 'LogicalExpression';
AST.BinaryExpression = 'BinaryExpression';
AST.UnaryExpression = 'UnaryExpression';
AST.CallExpression = 'CallExpression';
AST.MemberExpression = 'MemberExpression';
AST.Identifier = 'Identifier';
AST.Literal = 'Literal';
AST.ArrayExpression = 'ArrayExpression';
AST.Property = 'Property';
AST.ObjectExpression = 'ObjectExpression';
AST.ThisExpression = 'ThisExpression';
AST.LocalsExpression = 'LocalsExpression';

// Internal use only
AST.NGValueParameter = 'NGValueParameter';

AST.prototype = {
  ast: function(text) {
    this.text = text;
    this.tokens = this.lexer.lex(text);

    var value = this.program();

    if (this.tokens.length !== 0) {
      this.throwError('is an unexpected token', this.tokens[0]);
    }

    return value;
  },

  program: function() {
    var body = [];
    while (true) {
      if (this.tokens.length > 0 && !this.peek('}', ')', ';', ']'))
        body.push(this.expressionStatement());
      if (!this.expect(';')) {
        return { type: AST.Program, body: body};
      }
    }
  },

  expressionStatement: function() {
    return { type: AST.ExpressionStatement, expression: this.filterChain() };
  },

  filterChain: function() {
    var left = this.expression();
    var token;
    while ((token = this.expect('|'))) {
      left = this.filter(left);
    }
    return left;
  },

  expression: function() {
    return this.assignment();
  },

  assignment: function() {
    var result = this.ternary();
    if (this.expect('=')) {
      result = { type: AST.AssignmentExpression, left: result, right: this.assignment(), operator: '='};
    }
    return result;
  },

  ternary: function() {
    var test = this.logicalOR();
    var alternate;
    var consequent;
    if (this.expect('?')) {
      alternate = this.expression();
      if (this.consume(':')) {
        consequent = this.expression();
        return { type: AST.ConditionalExpression, test: test, alternate: alternate, consequent: consequent};
      }
    }
    return test;
  },

  logicalOR: function() {
    var left = this.logicalAND();
    while (this.expect('||')) {
      left = { type: AST.LogicalExpression, operator: '||', left: left, right: this.logicalAND() };
    }
    return left;
  },

  logicalAND: function() {
    var left = this.equality();
    while (this.expect('&&')) {
      left = { type: AST.LogicalExpression, operator: '&&', left: left, right: this.equality()};
    }
    return left;
  },

  equality: function() {
    var left = this.relational();
    var token;
    while ((token = this.expect('==','!=','===','!=='))) {
      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.relational() };
    }
    return left;
  },

  relational: function() {
    var left = this.additive();
    var token;
    while ((token = this.expect('<', '>', '<=', '>='))) {
      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.additive() };
    }
    return left;
  },

  additive: function() {
    var left = this.multiplicative();
    var token;
    while ((token = this.expect('+','-'))) {
      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.multiplicative() };
    }
    return left;
  },

  multiplicative: function() {
    var left = this.unary();
    var token;
    while ((token = this.expect('*','/','%'))) {
      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.unary() };
    }
    return left;
  },

  unary: function() {
    var token;
    if ((token = this.expect('+', '-', '!'))) {
      return { type: AST.UnaryExpression, operator: token.text, prefix: true, argument: this.unary() };
    } else {
      return this.primary();
    }
  },

  primary: function() {
    var primary;
    if (this.expect('(')) {
      primary = this.filterChain();
      this.consume(')');
    } else if (this.expect('[')) {
      primary = this.arrayDeclaration();
    } else if (this.expect('{')) {
      primary = this.object();
    } else if (this.selfReferential.hasOwnProperty(this.peek().text)) {
      primary = copy(this.selfReferential[this.consume().text]);
    } else if (this.options.literals.hasOwnProperty(this.peek().text)) {
      primary = { type: AST.Literal, value: this.options.literals[this.consume().text]};
    } else if (this.peek().identifier) {
      primary = this.identifier();
    } else if (this.peek().constant) {
      primary = this.constant();
    } else {
      this.throwError('not a primary expression', this.peek());
    }

    var next;
    while ((next = this.expect('(', '[', '.'))) {
      if (next.text === '(') {
        primary = {type: AST.CallExpression, callee: primary, arguments: this.parseArguments() };
        this.consume(')');
      } else if (next.text === '[') {
        primary = { type: AST.MemberExpression, object: primary, property: this.expression(), computed: true };
        this.consume(']');
      } else if (next.text === '.') {
        primary = { type: AST.MemberExpression, object: primary, property: this.identifier(), computed: false };
      } else {
        this.throwError('IMPOSSIBLE');
      }
    }
    return primary;
  },

  filter: function(baseExpression) {
    var args = [baseExpression];
    var result = {type: AST.CallExpression, callee: this.identifier(), arguments: args, filter: true};

    while (this.expect(':')) {
      args.push(this.expression());
    }

    return result;
  },

  parseArguments: function() {
    var args = [];
    if (this.peekToken().text !== ')') {
      do {
        args.push(this.filterChain());
      } while (this.expect(','));
    }
    return args;
  },

  identifier: function() {
    var token = this.consume();
    if (!token.identifier) {
      this.throwError('is not a valid identifier', token);
    }
    return { type: AST.Identifier, name: token.text };
  },

  constant: function() {
    // TODO check that it is a constant
    return { type: AST.Literal, value: this.consume().value };
  },

  arrayDeclaration: function() {
    var elements = [];
    if (this.peekToken().text !== ']') {
      do {
        if (this.peek(']')) {
          // Support trailing commas per ES5.1.
          break;
        }
        elements.push(this.expression());
      } while (this.expect(','));
    }
    this.consume(']');

    return { type: AST.ArrayExpression, elements: elements };
  },

  object: function() {
    var properties = [], property;
    if (this.peekToken().text !== '}') {
      do {
        if (this.peek('}')) {
          // Support trailing commas per ES5.1.
          break;
        }
        property = {type: AST.Property, kind: 'init'};
        if (this.peek().constant) {
          property.key = this.constant();
          property.computed = false;
          this.consume(':');
          property.value = this.expression();
        } else if (this.peek().identifier) {
          property.key = this.identifier();
          property.computed = false;
          if (this.peek(':')) {
            this.consume(':');
            property.value = this.expression();
          } else {
            property.value = property.key;
          }
        } else if (this.peek('[')) {
          this.consume('[');
          property.key = this.expression();
          this.consume(']');
          property.computed = true;
          this.consume(':');
          property.value = this.expression();
        } else {
          this.throwError("invalid key", this.peek());
        }
        properties.push(property);
      } while (this.expect(','));
    }
    this.consume('}');

    return {type: AST.ObjectExpression, properties: properties };
  },

  throwError: function(msg, token) {
    throw $parseMinErr('syntax',
        'Syntax Error: Token \'{0}\' {1} at column {2} of the expression [{3}] starting at [{4}].',
          token.text, msg, (token.index + 1), this.text, this.text.substring(token.index));
  },

  consume: function(e1) {
    if (this.tokens.length === 0) {
      throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
    }

    var token = this.expect(e1);
    if (!token) {
      this.throwError('is unexpected, expecting [' + e1 + ']', this.peek());
    }
    return token;
  },

  peekToken: function() {
    if (this.tokens.length === 0) {
      throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
    }
    return this.tokens[0];
  },

  peek: function(e1, e2, e3, e4) {
    return this.peekAhead(0, e1, e2, e3, e4);
  },

  peekAhead: function(i, e1, e2, e3, e4) {
    if (this.tokens.length > i) {
      var token = this.tokens[i];
      var t = token.text;
      if (t === e1 || t === e2 || t === e3 || t === e4 ||
          (!e1 && !e2 && !e3 && !e4)) {
        return token;
      }
    }
    return false;
  },

  expect: function(e1, e2, e3, e4) {
    var token = this.peek(e1, e2, e3, e4);
    if (token) {
      this.tokens.shift();
      return token;
    }
    return false;
  },

  selfReferential: {
    'this': {type: AST.ThisExpression },
    '$locals': {type: AST.LocalsExpression }
  }
};

function ifDefined(v, d) {
  return typeof v !== 'undefined' ? v : d;
}

function plusFn(l, r) {
  if (typeof l === 'undefined') return r;
  if (typeof r === 'undefined') return l;
  return l + r;
}

function isStateless($filter, filterName) {
  var fn = $filter(filterName);
  return !fn.$stateful;
}

function findConstantAndWatchExpressions(ast, $filter) {
  var allConstants;
  var argsToWatch;
  switch (ast.type) {
  case AST.Program:
    allConstants = true;
    forEach(ast.body, function(expr) {
      findConstantAndWatchExpressions(expr.expression, $filter);
      allConstants = allConstants && expr.expression.constant;
    });
    ast.constant = allConstants;
    break;
  case AST.Literal:
    ast.constant = true;
    ast.toWatch = [];
    break;
  case AST.UnaryExpression:
    findConstantAndWatchExpressions(ast.argument, $filter);
    ast.constant = ast.argument.constant;
    ast.toWatch = ast.argument.toWatch;
    break;
  case AST.BinaryExpression:
    findConstantAndWatchExpressions(ast.left, $filter);
    findConstantAndWatchExpressions(ast.right, $filter);
    ast.constant = ast.left.constant && ast.right.constant;
    ast.toWatch = ast.left.toWatch.concat(ast.right.toWatch);
    break;
  case AST.LogicalExpression:
    findConstantAndWatchExpressions(ast.left, $filter);
    findConstantAndWatchExpressions(ast.right, $filter);
    ast.constant = ast.left.constant && ast.right.constant;
    ast.toWatch = ast.constant ? [] : [ast];
    break;
  case AST.ConditionalExpression:
    findConstantAndWatchExpressions(ast.test, $filter);
    findConstantAndWatchExpressions(ast.alternate, $filter);
    findConstantAndWatchExpressions(ast.consequent, $filter);
    ast.constant = ast.test.constant && ast.alternate.constant && ast.consequent.constant;
    ast.toWatch = ast.constant ? [] : [ast];
    break;
  case AST.Identifier:
    ast.constant = false;
    ast.toWatch = [ast];
    break;
  case AST.MemberExpression:
    findConstantAndWatchExpressions(ast.object, $filter);
    if (ast.computed) {
      findConstantAndWatchExpressions(ast.property, $filter);
    }
    ast.constant = ast.object.constant && (!ast.computed || ast.property.constant);
    ast.toWatch = [ast];
    break;
  case AST.CallExpression:
    allConstants = ast.filter ? isStateless($filter, ast.callee.name) : false;
    argsToWatch = [];
    forEach(ast.arguments, function(expr) {
      findConstantAndWatchExpressions(expr, $filter);
      allConstants = allConstants && expr.constant;
      if (!expr.constant) {
        argsToWatch.push.apply(argsToWatch, expr.toWatch);
      }
    });
    ast.constant = allConstants;
    ast.toWatch = ast.filter && isStateless($filter, ast.callee.name) ? argsToWatch : [ast];
    break;
  case AST.AssignmentExpression:
    findConstantAndWatchExpressions(ast.left, $filter);
    findConstantAndWatchExpressions(ast.right, $filter);
    ast.constant = ast.left.constant && ast.right.constant;
    ast.toWatch = [ast];
    break;
  case AST.ArrayExpression:
    allConstants = true;
    argsToWatch = [];
    forEach(ast.elements, function(expr) {
      findConstantAndWatchExpressions(expr, $filter);
      allConstants = allConstants && expr.constant;
      if (!expr.constant) {
        argsToWatch.push.apply(argsToWatch, expr.toWatch);
      }
    });
    ast.constant = allConstants;
    ast.toWatch = argsToWatch;
    break;
  case AST.ObjectExpression:
    allConstants = true;
    argsToWatch = [];
    forEach(ast.properties, function(property) {
      findConstantAndWatchExpressions(property.value, $filter);
      allConstants = allConstants && property.value.constant && !property.computed;
      if (!property.value.constant) {
        argsToWatch.push.apply(argsToWatch, property.value.toWatch);
      }
    });
    ast.constant = allConstants;
    ast.toWatch = argsToWatch;
    break;
  case AST.ThisExpression:
    ast.constant = false;
    ast.toWatch = [];
    break;
  case AST.LocalsExpression:
    ast.constant = false;
    ast.toWatch = [];
    break;
  }
}

function getInputs(body) {
  if (body.length != 1) return;
  var lastExpression = body[0].expression;
  var candidate = lastExpression.toWatch;
  if (candidate.length !== 1) return candidate;
  return candidate[0] !== lastExpression ? candidate : undefined;
}

function isAssignable(ast) {
  return ast.type === AST.Identifier || ast.type === AST.MemberExpression;
}

function assignableAST(ast) {
  if (ast.body.length === 1 && isAssignable(ast.body[0].expression)) {
    return {type: AST.AssignmentExpression, left: ast.body[0].expression, right: {type: AST.NGValueParameter}, operator: '='};
  }
}

function isLiteral(ast) {
  return ast.body.length === 0 ||
      ast.body.length === 1 && (
      ast.body[0].expression.type === AST.Literal ||
      ast.body[0].expression.type === AST.ArrayExpression ||
      ast.body[0].expression.type === AST.ObjectExpression);
}

function isConstant(ast) {
  return ast.constant;
}

function ASTCompiler(astBuilder, $filter) {
  this.astBuilder = astBuilder;
  this.$filter = $filter;
}

ASTCompiler.prototype = {
  compile: function(expression, expensiveChecks) {
    var self = this;
    var ast = this.astBuilder.ast(expression);
    this.state = {
      nextId: 0,
      filters: {},
      expensiveChecks: expensiveChecks,
      fn: {vars: [], body: [], own: {}},
      assign: {vars: [], body: [], own: {}},
      inputs: []
    };
    findConstantAndWatchExpressions(ast, self.$filter);
    var extra = '';
    var assignable;
    this.stage = 'assign';
    if ((assignable = assignableAST(ast))) {
      this.state.computing = 'assign';
      var result = this.nextId();
      this.recurse(assignable, result);
      this.return_(result);
      extra = 'fn.assign=' + this.generateFunction('assign', 's,v,l');
    }
    var toWatch = getInputs(ast.body);
    self.stage = 'inputs';
    forEach(toWatch, function(watch, key) {
      var fnKey = 'fn' + key;
      self.state[fnKey] = {vars: [], body: [], own: {}};
      self.state.computing = fnKey;
      var intoId = self.nextId();
      self.recurse(watch, intoId);
      self.return_(intoId);
      self.state.inputs.push(fnKey);
      watch.watchId = key;
    });
    this.state.computing = 'fn';
    this.stage = 'main';
    this.recurse(ast);
    var fnString =
      // The build and minification steps remove the string "use strict" from the code, but this is done using a regex.
      // This is a workaround for this until we do a better job at only removing the prefix only when we should.
      '"' + this.USE + ' ' + this.STRICT + '";\n' +
      this.filterPrefix() +
      'var fn=' + this.generateFunction('fn', 's,l,a,i') +
      extra +
      this.watchFns() +
      'return fn;';

    /* jshint -W054 */
    var fn = (new Function('$filter',
        'ensureSafeMemberName',
        'ensureSafeObject',
        'ensureSafeFunction',
        'getStringValue',
        'ensureSafeAssignContext',
        'ifDefined',
        'plus',
        'text',
        fnString))(
          this.$filter,
          ensureSafeMemberName,
          ensureSafeObject,
          ensureSafeFunction,
          getStringValue,
          ensureSafeAssignContext,
          ifDefined,
          plusFn,
          expression);
    /* jshint +W054 */
    this.state = this.stage = undefined;
    fn.literal = isLiteral(ast);
    fn.constant = isConstant(ast);
    return fn;
  },

  USE: 'use',

  STRICT: 'strict',

  watchFns: function() {
    var result = [];
    var fns = this.state.inputs;
    var self = this;
    forEach(fns, function(name) {
      result.push('var ' + name + '=' + self.generateFunction(name, 's'));
    });
    if (fns.length) {
      result.push('fn.inputs=[' + fns.join(',') + '];');
    }
    return result.join('');
  },

  generateFunction: function(name, params) {
    return 'function(' + params + '){' +
        this.varsPrefix(name) +
        this.body(name) +
        '};';
  },

  filterPrefix: function() {
    var parts = [];
    var self = this;
    forEach(this.state.filters, function(id, filter) {
      parts.push(id + '=$filter(' + self.escape(filter) + ')');
    });
    if (parts.length) return 'var ' + parts.join(',') + ';';
    return '';
  },

  varsPrefix: function(section) {
    return this.state[section].vars.length ? 'var ' + this.state[section].vars.join(',') + ';' : '';
  },

  body: function(section) {
    return this.state[section].body.join('');
  },

  recurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
    var left, right, self = this, args, expression, computed;
    recursionFn = recursionFn || noop;
    if (!skipWatchIdCheck && isDefined(ast.watchId)) {
      intoId = intoId || this.nextId();
      this.if_('i',
        this.lazyAssign(intoId, this.computedMember('i', ast.watchId)),
        this.lazyRecurse(ast, intoId, nameId, recursionFn, create, true)
      );
      return;
    }
    switch (ast.type) {
    case AST.Program:
      forEach(ast.body, function(expression, pos) {
        self.recurse(expression.expression, undefined, undefined, function(expr) { right = expr; });
        if (pos !== ast.body.length - 1) {
          self.current().body.push(right, ';');
        } else {
          self.return_(right);
        }
      });
      break;
    case AST.Literal:
      expression = this.escape(ast.value);
      this.assign(intoId, expression);
      recursionFn(expression);
      break;
    case AST.UnaryExpression:
      this.recurse(ast.argument, undefined, undefined, function(expr) { right = expr; });
      expression = ast.operator + '(' + this.ifDefined(right, 0) + ')';
      this.assign(intoId, expression);
      recursionFn(expression);
      break;
    case AST.BinaryExpression:
      this.recurse(ast.left, undefined, undefined, function(expr) { left = expr; });
      this.recurse(ast.right, undefined, undefined, function(expr) { right = expr; });
      if (ast.operator === '+') {
        expression = this.plus(left, right);
      } else if (ast.operator === '-') {
        expression = this.ifDefined(left, 0) + ast.operator + this.ifDefined(right, 0);
      } else {
        expression = '(' + left + ')' + ast.operator + '(' + right + ')';
      }
      this.assign(intoId, expression);
      recursionFn(expression);
      break;
    case AST.LogicalExpression:
      intoId = intoId || this.nextId();
      self.recurse(ast.left, intoId);
      self.if_(ast.operator === '&&' ? intoId : self.not(intoId), self.lazyRecurse(ast.right, intoId));
      recursionFn(intoId);
      break;
    case AST.ConditionalExpression:
      intoId = intoId || this.nextId();
      self.recurse(ast.test, intoId);
      self.if_(intoId, self.lazyRecurse(ast.alternate, intoId), self.lazyRecurse(ast.consequent, intoId));
      recursionFn(intoId);
      break;
    case AST.Identifier:
      intoId = intoId || this.nextId();
      if (nameId) {
        nameId.context = self.stage === 'inputs' ? 's' : this.assign(this.nextId(), this.getHasOwnProperty('l', ast.name) + '?l:s');
        nameId.computed = false;
        nameId.name = ast.name;
      }
      ensureSafeMemberName(ast.name);
      self.if_(self.stage === 'inputs' || self.not(self.getHasOwnProperty('l', ast.name)),
        function() {
          self.if_(self.stage === 'inputs' || 's', function() {
            if (create && create !== 1) {
              self.if_(
                self.not(self.nonComputedMember('s', ast.name)),
                self.lazyAssign(self.nonComputedMember('s', ast.name), '{}'));
            }
            self.assign(intoId, self.nonComputedMember('s', ast.name));
          });
        }, intoId && self.lazyAssign(intoId, self.nonComputedMember('l', ast.name))
        );
      if (self.state.expensiveChecks || isPossiblyDangerousMemberName(ast.name)) {
        self.addEnsureSafeObject(intoId);
      }
      recursionFn(intoId);
      break;
    case AST.MemberExpression:
      left = nameId && (nameId.context = this.nextId()) || this.nextId();
      intoId = intoId || this.nextId();
      self.recurse(ast.object, left, undefined, function() {
        self.if_(self.notNull(left), function() {
          if (create && create !== 1) {
            self.addEnsureSafeAssignContext(left);
          }
          if (ast.computed) {
            right = self.nextId();
            self.recurse(ast.property, right);
            self.getStringValue(right);
            self.addEnsureSafeMemberName(right);
            if (create && create !== 1) {
              self.if_(self.not(self.computedMember(left, right)), self.lazyAssign(self.computedMember(left, right), '{}'));
            }
            expression = self.ensureSafeObject(self.computedMember(left, right));
            self.assign(intoId, expression);
            if (nameId) {
              nameId.computed = true;
              nameId.name = right;
            }
          } else {
            ensureSafeMemberName(ast.property.name);
            if (create && create !== 1) {
              self.if_(self.not(self.nonComputedMember(left, ast.property.name)), self.lazyAssign(self.nonComputedMember(left, ast.property.name), '{}'));
            }
            expression = self.nonComputedMember(left, ast.property.name);
            if (self.state.expensiveChecks || isPossiblyDangerousMemberName(ast.property.name)) {
              expression = self.ensureSafeObject(expression);
            }
            self.assign(intoId, expression);
            if (nameId) {
              nameId.computed = false;
              nameId.name = ast.property.name;
            }
          }
        }, function() {
          self.assign(intoId, 'undefined');
        });
        recursionFn(intoId);
      }, !!create);
      break;
    case AST.CallExpression:
      intoId = intoId || this.nextId();
      if (ast.filter) {
        right = self.filter(ast.callee.name);
        args = [];
        forEach(ast.arguments, function(expr) {
          var argument = self.nextId();
          self.recurse(expr, argument);
          args.push(argument);
        });
        expression = right + '(' + args.join(',') + ')';
        self.assign(intoId, expression);
        recursionFn(intoId);
      } else {
        right = self.nextId();
        left = {};
        args = [];
        self.recurse(ast.callee, right, left, function() {
          self.if_(self.notNull(right), function() {
            self.addEnsureSafeFunction(right);
            forEach(ast.arguments, function(expr) {
              self.recurse(expr, self.nextId(), undefined, function(argument) {
                args.push(self.ensureSafeObject(argument));
              });
            });
            if (left.name) {
              if (!self.state.expensiveChecks) {
                self.addEnsureSafeObject(left.context);
              }
              expression = self.member(left.context, left.name, left.computed) + '(' + args.join(',') + ')';
            } else {
              expression = right + '(' + args.join(',') + ')';
            }
            expression = self.ensureSafeObject(expression);
            self.assign(intoId, expression);
          }, function() {
            self.assign(intoId, 'undefined');
          });
          recursionFn(intoId);
        });
      }
      break;
    case AST.AssignmentExpression:
      right = this.nextId();
      left = {};
      if (!isAssignable(ast.left)) {
        throw $parseMinErr('lval', 'Trying to assign a value to a non l-value');
      }
      this.recurse(ast.left, undefined, left, function() {
        self.if_(self.notNull(left.context), function() {
          self.recurse(ast.right, right);
          self.addEnsureSafeObject(self.member(left.context, left.name, left.computed));
          self.addEnsureSafeAssignContext(left.context);
          expression = self.member(left.context, left.name, left.computed) + ast.operator + right;
          self.assign(intoId, expression);
          recursionFn(intoId || expression);
        });
      }, 1);
      break;
    case AST.ArrayExpression:
      args = [];
      forEach(ast.elements, function(expr) {
        self.recurse(expr, self.nextId(), undefined, function(argument) {
          args.push(argument);
        });
      });
      expression = '[' + args.join(',') + ']';
      this.assign(intoId, expression);
      recursionFn(expression);
      break;
    case AST.ObjectExpression:
      args = [];
      computed = false;
      forEach(ast.properties, function(property) {
        if (property.computed) {
          computed = true;
        }
      });
      if (computed) {
        intoId = intoId || this.nextId();
        this.assign(intoId, '{}');
        forEach(ast.properties, function(property) {
          if (property.computed) {
            left = self.nextId();
            self.recurse(property.key, left);
          } else {
            left = property.key.type === AST.Identifier ?
                       property.key.name :
                       ('' + property.key.value);
          }
          right = self.nextId();
          self.recurse(property.value, right);
          self.assign(self.member(intoId, left, property.computed), right);
        });
      } else {
        forEach(ast.properties, function(property) {
          self.recurse(property.value, ast.constant ? undefined : self.nextId(), undefined, function(expr) {
            args.push(self.escape(
                property.key.type === AST.Identifier ? property.key.name :
                  ('' + property.key.value)) +
                ':' + expr);
          });
        });
        expression = '{' + args.join(',') + '}';
        this.assign(intoId, expression);
      }
      recursionFn(intoId || expression);
      break;
    case AST.ThisExpression:
      this.assign(intoId, 's');
      recursionFn('s');
      break;
    case AST.LocalsExpression:
      this.assign(intoId, 'l');
      recursionFn('l');
      break;
    case AST.NGValueParameter:
      this.assign(intoId, 'v');
      recursionFn('v');
      break;
    }
  },

  getHasOwnProperty: function(element, property) {
    var key = element + '.' + property;
    var own = this.current().own;
    if (!own.hasOwnProperty(key)) {
      own[key] = this.nextId(false, element + '&&(' + this.escape(property) + ' in ' + element + ')');
    }
    return own[key];
  },

  assign: function(id, value) {
    if (!id) return;
    this.current().body.push(id, '=', value, ';');
    return id;
  },

  filter: function(filterName) {
    if (!this.state.filters.hasOwnProperty(filterName)) {
      this.state.filters[filterName] = this.nextId(true);
    }
    return this.state.filters[filterName];
  },

  ifDefined: function(id, defaultValue) {
    return 'ifDefined(' + id + ',' + this.escape(defaultValue) + ')';
  },

  plus: function(left, right) {
    return 'plus(' + left + ',' + right + ')';
  },

  return_: function(id) {
    this.current().body.push('return ', id, ';');
  },

  if_: function(test, alternate, consequent) {
    if (test === true) {
      alternate();
    } else {
      var body = this.current().body;
      body.push('if(', test, '){');
      alternate();
      body.push('}');
      if (consequent) {
        body.push('else{');
        consequent();
        body.push('}');
      }
    }
  },

  not: function(expression) {
    return '!(' + expression + ')';
  },

  notNull: function(expression) {
    return expression + '!=null';
  },

  nonComputedMember: function(left, right) {
    var SAFE_IDENTIFIER = /[$_a-zA-Z][$_a-zA-Z0-9]*/;
    var UNSAFE_CHARACTERS = /[^$_a-zA-Z0-9]/g;
    if (SAFE_IDENTIFIER.test(right)) {
      return left + '.' + right;
    } else {
      return left  + '["' + right.replace(UNSAFE_CHARACTERS, this.stringEscapeFn) + '"]';
    }
  },

  computedMember: function(left, right) {
    return left + '[' + right + ']';
  },

  member: function(left, right, computed) {
    if (computed) return this.computedMember(left, right);
    return this.nonComputedMember(left, right);
  },

  addEnsureSafeObject: function(item) {
    this.current().body.push(this.ensureSafeObject(item), ';');
  },

  addEnsureSafeMemberName: function(item) {
    this.current().body.push(this.ensureSafeMemberName(item), ';');
  },

  addEnsureSafeFunction: function(item) {
    this.current().body.push(this.ensureSafeFunction(item), ';');
  },

  addEnsureSafeAssignContext: function(item) {
    this.current().body.push(this.ensureSafeAssignContext(item), ';');
  },

  ensureSafeObject: function(item) {
    return 'ensureSafeObject(' + item + ',text)';
  },

  ensureSafeMemberName: function(item) {
    return 'ensureSafeMemberName(' + item + ',text)';
  },

  ensureSafeFunction: function(item) {
    return 'ensureSafeFunction(' + item + ',text)';
  },

  getStringValue: function(item) {
    this.assign(item, 'getStringValue(' + item + ')');
  },

  ensureSafeAssignContext: function(item) {
    return 'ensureSafeAssignContext(' + item + ',text)';
  },

  lazyRecurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
    var self = this;
    return function() {
      self.recurse(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck);
    };
  },

  lazyAssign: function(id, value) {
    var self = this;
    return function() {
      self.assign(id, value);
    };
  },

  stringEscapeRegex: /[^ a-zA-Z0-9]/g,

  stringEscapeFn: function(c) {
    return '\\u' + ('0000' + c.charCodeAt(0).toString(16)).slice(-4);
  },

  escape: function(value) {
    if (isString(value)) return "'" + value.replace(this.stringEscapeRegex, this.stringEscapeFn) + "'";
    if (isNumber(value)) return value.toString();
    if (value === true) return 'true';
    if (value === false) return 'false';
    if (value === null) return 'null';
    if (typeof value === 'undefined') return 'undefined';

    throw $parseMinErr('esc', 'IMPOSSIBLE');
  },

  nextId: function(skip, init) {
    var id = 'v' + (this.state.nextId++);
    if (!skip) {
      this.current().vars.push(id + (init ? '=' + init : ''));
    }
    return id;
  },

  current: function() {
    return this.state[this.state.computing];
  }
};


function ASTInterpreter(astBuilder, $filter) {
  this.astBuilder = astBuilder;
  this.$filter = $filter;
}

ASTInterpreter.prototype = {
  compile: function(expression, expensiveChecks) {
    var self = this;
    var ast = this.astBuilder.ast(expression);
    this.expression = expression;
    this.expensiveChecks = expensiveChecks;
    findConstantAndWatchExpressions(ast, self.$filter);
    var assignable;
    var assign;
    if ((assignable = assignableAST(ast))) {
      assign = this.recurse(assignable);
    }
    var toWatch = getInputs(ast.body);
    var inputs;
    if (toWatch) {
      inputs = [];
      forEach(toWatch, function(watch, key) {
        var input = self.recurse(watch);
        watch.input = input;
        inputs.push(input);
        watch.watchId = key;
      });
    }
    var expressions = [];
    forEach(ast.body, function(expression) {
      expressions.push(self.recurse(expression.expression));
    });
    var fn = ast.body.length === 0 ? noop :
             ast.body.length === 1 ? expressions[0] :
             function(scope, locals) {
               var lastValue;
               forEach(expressions, function(exp) {
                 lastValue = exp(scope, locals);
               });
               return lastValue;
             };
    if (assign) {
      fn.assign = function(scope, value, locals) {
        return assign(scope, locals, value);
      };
    }
    if (inputs) {
      fn.inputs = inputs;
    }
    fn.literal = isLiteral(ast);
    fn.constant = isConstant(ast);
    return fn;
  },

  recurse: function(ast, context, create) {
    var left, right, self = this, args, expression;
    if (ast.input) {
      return this.inputs(ast.input, ast.watchId);
    }
    switch (ast.type) {
    case AST.Literal:
      return this.value(ast.value, context);
    case AST.UnaryExpression:
      right = this.recurse(ast.argument);
      return this['unary' + ast.operator](right, context);
    case AST.BinaryExpression:
      left = this.recurse(ast.left);
      right = this.recurse(ast.right);
      return this['binary' + ast.operator](left, right, context);
    case AST.LogicalExpression:
      left = this.recurse(ast.left);
      right = this.recurse(ast.right);
      return this['binary' + ast.operator](left, right, context);
    case AST.ConditionalExpression:
      return this['ternary?:'](
        this.recurse(ast.test),
        this.recurse(ast.alternate),
        this.recurse(ast.consequent),
        context
      );
    case AST.Identifier:
      ensureSafeMemberName(ast.name, self.expression);
      return self.identifier(ast.name,
                             self.expensiveChecks || isPossiblyDangerousMemberName(ast.name),
                             context, create, self.expression);
    case AST.MemberExpression:
      left = this.recurse(ast.object, false, !!create);
      if (!ast.computed) {
        ensureSafeMemberName(ast.property.name, self.expression);
        right = ast.property.name;
      }
      if (ast.computed) right = this.recurse(ast.property);
      return ast.computed ?
        this.computedMember(left, right, context, create, self.expression) :
        this.nonComputedMember(left, right, self.expensiveChecks, context, create, self.expression);
    case AST.CallExpression:
      args = [];
      forEach(ast.arguments, function(expr) {
        args.push(self.recurse(expr));
      });
      if (ast.filter) right = this.$filter(ast.callee.name);
      if (!ast.filter) right = this.recurse(ast.callee, true);
      return ast.filter ?
        function(scope, locals, assign, inputs) {
          var values = [];
          for (var i = 0; i < args.length; ++i) {
            values.push(args[i](scope, locals, assign, inputs));
          }
          var value = right.apply(undefined, values, inputs);
          return context ? {context: undefined, name: undefined, value: value} : value;
        } :
        function(scope, locals, assign, inputs) {
          var rhs = right(scope, locals, assign, inputs);
          var value;
          if (rhs.value != null) {
            ensureSafeObject(rhs.context, self.expression);
            ensureSafeFunction(rhs.value, self.expression);
            var values = [];
            for (var i = 0; i < args.length; ++i) {
              values.push(ensureSafeObject(args[i](scope, locals, assign, inputs), self.expression));
            }
            value = ensureSafeObject(rhs.value.apply(rhs.context, values), self.expression);
          }
          return context ? {value: value} : value;
        };
    case AST.AssignmentExpression:
      left = this.recurse(ast.left, true, 1);
      right = this.recurse(ast.right);
      return function(scope, locals, assign, inputs) {
        var lhs = left(scope, locals, assign, inputs);
        var rhs = right(scope, locals, assign, inputs);
        ensureSafeObject(lhs.value, self.expression);
        ensureSafeAssignContext(lhs.context);
        lhs.context[lhs.name] = rhs;
        return context ? {value: rhs} : rhs;
      };
    case AST.ArrayExpression:
      args = [];
      forEach(ast.elements, function(expr) {
        args.push(self.recurse(expr));
      });
      return function(scope, locals, assign, inputs) {
        var value = [];
        for (var i = 0; i < args.length; ++i) {
          value.push(args[i](scope, locals, assign, inputs));
        }
        return context ? {value: value} : value;
      };
    case AST.ObjectExpression:
      args = [];
      forEach(ast.properties, function(property) {
        if (property.computed) {
          args.push({key: self.recurse(property.key),
                     computed: true,
                     value: self.recurse(property.value)
          });
        } else {
          args.push({key: property.key.type === AST.Identifier ?
                          property.key.name :
                          ('' + property.key.value),
                     computed: false,
                     value: self.recurse(property.value)
          });
        }
      });
      return function(scope, locals, assign, inputs) {
        var value = {};
        for (var i = 0; i < args.length; ++i) {
          if (args[i].computed) {
            value[args[i].key(scope, locals, assign, inputs)] = args[i].value(scope, locals, assign, inputs);
          } else {
            value[args[i].key] = args[i].value(scope, locals, assign, inputs);
          }
        }
        return context ? {value: value} : value;
      };
    case AST.ThisExpression:
      return function(scope) {
        return context ? {value: scope} : scope;
      };
    case AST.LocalsExpression:
      return function(scope, locals) {
        return context ? {value: locals} : locals;
      };
    case AST.NGValueParameter:
      return function(scope, locals, assign) {
        return context ? {value: assign} : assign;
      };
    }
  },

  'unary+': function(argument, context) {
    return function(scope, locals, assign, inputs) {
      var arg = argument(scope, locals, assign, inputs);
      if (isDefined(arg)) {
        arg = +arg;
      } else {
        arg = 0;
      }
      return context ? {value: arg} : arg;
    };
  },
  'unary-': function(argument, context) {
    return function(scope, locals, assign, inputs) {
      var arg = argument(scope, locals, assign, inputs);
      if (isDefined(arg)) {
        arg = -arg;
      } else {
        arg = 0;
      }
      return context ? {value: arg} : arg;
    };
  },
  'unary!': function(argument, context) {
    return function(scope, locals, assign, inputs) {
      var arg = !argument(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary+': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var lhs = left(scope, locals, assign, inputs);
      var rhs = right(scope, locals, assign, inputs);
      var arg = plusFn(lhs, rhs);
      return context ? {value: arg} : arg;
    };
  },
  'binary-': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var lhs = left(scope, locals, assign, inputs);
      var rhs = right(scope, locals, assign, inputs);
      var arg = (isDefined(lhs) ? lhs : 0) - (isDefined(rhs) ? rhs : 0);
      return context ? {value: arg} : arg;
    };
  },
  'binary*': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) * right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary/': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) / right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary%': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) % right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary===': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) === right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary!==': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) !== right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary==': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) == right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary!=': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) != right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary<': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) < right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary>': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) > right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary<=': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) <= right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary>=': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) >= right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary&&': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) && right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary||': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) || right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'ternary?:': function(test, alternate, consequent, context) {
    return function(scope, locals, assign, inputs) {
      var arg = test(scope, locals, assign, inputs) ? alternate(scope, locals, assign, inputs) : consequent(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  value: function(value, context) {
    return function() { return context ? {context: undefined, name: undefined, value: value} : value; };
  },
  identifier: function(name, expensiveChecks, context, create, expression) {
    return function(scope, locals, assign, inputs) {
      var base = locals && (name in locals) ? locals : scope;
      if (create && create !== 1 && base && !(base[name])) {
        base[name] = {};
      }
      var value = base ? base[name] : undefined;
      if (expensiveChecks) {
        ensureSafeObject(value, expression);
      }
      if (context) {
        return {context: base, name: name, value: value};
      } else {
        return value;
      }
    };
  },
  computedMember: function(left, right, context, create, expression) {
    return function(scope, locals, assign, inputs) {
      var lhs = left(scope, locals, assign, inputs);
      var rhs;
      var value;
      if (lhs != null) {
        rhs = right(scope, locals, assign, inputs);
        rhs = getStringValue(rhs);
        ensureSafeMemberName(rhs, expression);
        if (create && create !== 1) {
          ensureSafeAssignContext(lhs);
          if (lhs && !(lhs[rhs])) {
            lhs[rhs] = {};
          }
        }
        value = lhs[rhs];
        ensureSafeObject(value, expression);
      }
      if (context) {
        return {context: lhs, name: rhs, value: value};
      } else {
        return value;
      }
    };
  },
  nonComputedMember: function(left, right, expensiveChecks, context, create, expression) {
    return function(scope, locals, assign, inputs) {
      var lhs = left(scope, locals, assign, inputs);
      if (create && create !== 1) {
        ensureSafeAssignContext(lhs);
        if (lhs && !(lhs[right])) {
          lhs[right] = {};
        }
      }
      var value = lhs != null ? lhs[right] : undefined;
      if (expensiveChecks || isPossiblyDangerousMemberName(right)) {
        ensureSafeObject(value, expression);
      }
      if (context) {
        return {context: lhs, name: right, value: value};
      } else {
        return value;
      }
    };
  },
  inputs: function(input, watchId) {
    return function(scope, value, locals, inputs) {
      if (inputs) return inputs[watchId];
      return input(scope, value, locals);
    };
  }
};

/**
 * @constructor
 */
var Parser = function(lexer, $filter, options) {
  this.lexer = lexer;
  this.$filter = $filter;
  this.options = options;
  this.ast = new AST(lexer, options);
  this.astCompiler = options.csp ? new ASTInterpreter(this.ast, $filter) :
                                   new ASTCompiler(this.ast, $filter);
};

Parser.prototype = {
  constructor: Parser,

  parse: function(text) {
    return this.astCompiler.compile(text, this.options.expensiveChecks);
  }
};

function isPossiblyDangerousMemberName(name) {
  return name == 'constructor';
}

var objectValueOf = Object.prototype.valueOf;

function getValueOf(value) {
  return isFunction(value.valueOf) ? value.valueOf() : objectValueOf.call(value);
}

///////////////////////////////////

/**
 * @ngdoc service
 * @name $parse
 * @kind function
 *
 * @description
 *
 * Converts Angular {@link guide/expression expression} into a function.
 *
 * ```js
 *   var getter = $parse('user.name');
 *   var setter = getter.assign;
 *   var context = {user:{name:'angular'}};
 *   var locals = {user:{name:'local'}};
 *
 *   expect(getter(context)).toEqual('angular');
 *   setter(context, 'newValue');
 *   expect(context.user.name).toEqual('newValue');
 *   expect(getter(context, locals)).toEqual('local');
 * ```
 *
 *
 * @param {string} expression String expression to compile.
 * @returns {function(context, locals)} a function which represents the compiled expression:
 *
 *    * `context` – `{object}` – an object against which any expressions embedded in the strings
 *      are evaluated against (typically a scope object).
 *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
 *      `context`.
 *
 *    The returned function also has the following properties:
 *      * `literal` – `{boolean}` – whether the expression's top-level node is a JavaScript
 *        literal.
 *      * `constant` – `{boolean}` – whether the expression is made entirely of JavaScript
 *        constant literals.
 *      * `assign` – `{?function(context, value)}` – if the expression is assignable, this will be
 *        set to a function to change its value on the given context.
 *
 */


/**
 * @ngdoc provider
 * @name $parseProvider
 *
 * @description
 * `$parseProvider` can be used for configuring the default behavior of the {@link ng.$parse $parse}
 *  service.
 */
function $ParseProvider() {
  var cacheDefault = createMap();
  var cacheExpensive = createMap();
  var literals = {
    'true': true,
    'false': false,
    'null': null,
    'undefined': undefined
  };
  var identStart, identContinue;

  /**
   * @ngdoc method
   * @name $parseProvider#addLiteral
   * @description
   *
   * Configure $parse service to add literal values that will be present as literal at expressions.
   *
   * @param {string} literalName Token for the literal value. The literal name value must be a valid literal name.
   * @param {*} literalValue Value for this literal. All literal values must be primitives or `undefined`.
   *
   **/
  this.addLiteral = function(literalName, literalValue) {
    literals[literalName] = literalValue;
  };

 /**
  * @ngdoc method
  * @name $parseProvider#setIdentifierFns
  * @description
  *
  * Allows defining the set of characters that are allowed in Angular expressions. The function
  * `identifierStart` will get called to know if a given character is a valid character to be the
  * first character for an identifier. The function `identifierContinue` will get called to know if
  * a given character is a valid character to be a follow-up identifier character. The functions
  * `identifierStart` and `identifierContinue` will receive as arguments the single character to be
  * identifier and the character code point. These arguments will be `string` and `numeric`. Keep in
  * mind that the `string` parameter can be two characters long depending on the character
  * representation. It is expected for the function to return `true` or `false`, whether that
  * character is allowed or not.
  *
  * Since this function will be called extensivelly, keep the implementation of these functions fast,
  * as the performance of these functions have a direct impact on the expressions parsing speed.
  *
  * @param {function=} identifierStart The function that will decide whether the given character is
  *   a valid identifier start character.
  * @param {function=} identifierContinue The function that will decide whether the given character is
  *   a valid identifier continue character.
  */
  this.setIdentifierFns = function(identifierStart, identifierContinue) {
    identStart = identifierStart;
    identContinue = identifierContinue;
    return this;
  };

  this.$get = ['$filter', function($filter) {
    var noUnsafeEval = csp().noUnsafeEval;
    var $parseOptions = {
          csp: noUnsafeEval,
          expensiveChecks: false,
          literals: copy(literals),
          isIdentifierStart: isFunction(identStart) && identStart,
          isIdentifierContinue: isFunction(identContinue) && identContinue
        },
        $parseOptionsExpensive = {
          csp: noUnsafeEval,
          expensiveChecks: true,
          literals: copy(literals),
          isIdentifierStart: isFunction(identStart) && identStart,
          isIdentifierContinue: isFunction(identContinue) && identContinue
        };
    var runningChecksEnabled = false;

    $parse.$$runningExpensiveChecks = function() {
      return runningChecksEnabled;
    };

    return $parse;

    function $parse(exp, interceptorFn, expensiveChecks) {
      var parsedExpression, oneTime, cacheKey;

      expensiveChecks = expensiveChecks || runningChecksEnabled;

      switch (typeof exp) {
        case 'string':
          exp = exp.trim();
          cacheKey = exp;

          var cache = (expensiveChecks ? cacheExpensive : cacheDefault);
          parsedExpression = cache[cacheKey];

          if (!parsedExpression) {
            if (exp.charAt(0) === ':' && exp.charAt(1) === ':') {
              oneTime = true;
              exp = exp.substring(2);
            }
            var parseOptions = expensiveChecks ? $parseOptionsExpensive : $parseOptions;
            var lexer = new Lexer(parseOptions);
            var parser = new Parser(lexer, $filter, parseOptions);
            parsedExpression = parser.parse(exp);
            if (parsedExpression.constant) {
              parsedExpression.$$watchDelegate = constantWatchDelegate;
            } else if (oneTime) {
              parsedExpression.$$watchDelegate = parsedExpression.literal ?
                  oneTimeLiteralWatchDelegate : oneTimeWatchDelegate;
            } else if (parsedExpression.inputs) {
              parsedExpression.$$watchDelegate = inputsWatchDelegate;
            }
            if (expensiveChecks) {
              parsedExpression = expensiveChecksInterceptor(parsedExpression);
            }
            cache[cacheKey] = parsedExpression;
          }
          return addInterceptor(parsedExpression, interceptorFn);

        case 'function':
          return addInterceptor(exp, interceptorFn);

        default:
          return addInterceptor(noop, interceptorFn);
      }
    }

    function expensiveChecksInterceptor(fn) {
      if (!fn) return fn;
      expensiveCheckFn.$$watchDelegate = fn.$$watchDelegate;
      expensiveCheckFn.assign = expensiveChecksInterceptor(fn.assign);
      expensiveCheckFn.constant = fn.constant;
      expensiveCheckFn.literal = fn.literal;
      for (var i = 0; fn.inputs && i < fn.inputs.length; ++i) {
        fn.inputs[i] = expensiveChecksInterceptor(fn.inputs[i]);
      }
      expensiveCheckFn.inputs = fn.inputs;

      return expensiveCheckFn;

      function expensiveCheckFn(scope, locals, assign, inputs) {
        var expensiveCheckOldValue = runningChecksEnabled;
        runningChecksEnabled = true;
        try {
          return fn(scope, locals, assign, inputs);
        } finally {
          runningChecksEnabled = expensiveCheckOldValue;
        }
      }
    }

    function expressionInputDirtyCheck(newValue, oldValueOfValue) {

      if (newValue == null || oldValueOfValue == null) { // null/undefined
        return newValue === oldValueOfValue;
      }

      if (typeof newValue === 'object') {

        // attempt to convert the value to a primitive type
        // TODO(docs): add a note to docs that by implementing valueOf even objects and arrays can
        //             be cheaply dirty-checked
        newValue = getValueOf(newValue);

        if (typeof newValue === 'object') {
          // objects/arrays are not supported - deep-watching them would be too expensive
          return false;
        }

        // fall-through to the primitive equality check
      }

      //Primitive or NaN
      return newValue === oldValueOfValue || (newValue !== newValue && oldValueOfValue !== oldValueOfValue);
    }

    function inputsWatchDelegate(scope, listener, objectEquality, parsedExpression, prettyPrintExpression) {
      var inputExpressions = parsedExpression.inputs;
      var lastResult;

      if (inputExpressions.length === 1) {
        var oldInputValueOf = expressionInputDirtyCheck; // init to something unique so that equals check fails
        inputExpressions = inputExpressions[0];
        return scope.$watch(function expressionInputWatch(scope) {
          var newInputValue = inputExpressions(scope);
          if (!expressionInputDirtyCheck(newInputValue, oldInputValueOf)) {
            lastResult = parsedExpression(scope, undefined, undefined, [newInputValue]);
            oldInputValueOf = newInputValue && getValueOf(newInputValue);
          }
          return lastResult;
        }, listener, objectEquality, prettyPrintExpression);
      }

      var oldInputValueOfValues = [];
      var oldInputValues = [];
      for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
        oldInputValueOfValues[i] = expressionInputDirtyCheck; // init to something unique so that equals check fails
        oldInputValues[i] = null;
      }

      return scope.$watch(function expressionInputsWatch(scope) {
        var changed = false;

        for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
          var newInputValue = inputExpressions[i](scope);
          if (changed || (changed = !expressionInputDirtyCheck(newInputValue, oldInputValueOfValues[i]))) {
            oldInputValues[i] = newInputValue;
            oldInputValueOfValues[i] = newInputValue && getValueOf(newInputValue);
          }
        }

        if (changed) {
          lastResult = parsedExpression(scope, undefined, undefined, oldInputValues);
        }

        return lastResult;
      }, listener, objectEquality, prettyPrintExpression);
    }

    function oneTimeWatchDelegate(scope, listener, objectEquality, parsedExpression) {
      var unwatch, lastValue;
      return unwatch = scope.$watch(function oneTimeWatch(scope) {
        return parsedExpression(scope);
      }, function oneTimeListener(value, old, scope) {
        lastValue = value;
        if (isFunction(listener)) {
          listener.apply(this, arguments);
        }
        if (isDefined(value)) {
          scope.$$postDigest(function() {
            if (isDefined(lastValue)) {
              unwatch();
            }
          });
        }
      }, objectEquality);
    }

    function oneTimeLiteralWatchDelegate(scope, listener, objectEquality, parsedExpression) {
      var unwatch, lastValue;
      return unwatch = scope.$watch(function oneTimeWatch(scope) {
        return parsedExpression(scope);
      }, function oneTimeListener(value, old, scope) {
        lastValue = value;
        if (isFunction(listener)) {
          listener.call(this, value, old, scope);
        }
        if (isAllDefined(value)) {
          scope.$$postDigest(function() {
            if (isAllDefined(lastValue)) unwatch();
          });
        }
      }, objectEquality);

      function isAllDefined(value) {
        var allDefined = true;
        forEach(value, function(val) {
          if (!isDefined(val)) allDefined = false;
        });
        return allDefined;
      }
    }

    function constantWatchDelegate(scope, listener, objectEquality, parsedExpression) {
      var unwatch;
      return unwatch = scope.$watch(function constantWatch(scope) {
        unwatch();
        return parsedExpression(scope);
      }, listener, objectEquality);
    }

    function addInterceptor(parsedExpression, interceptorFn) {
      if (!interceptorFn) return parsedExpression;
      var watchDelegate = parsedExpression.$$watchDelegate;
      var useInputs = false;

      var regularWatch =
          watchDelegate !== oneTimeLiteralWatchDelegate &&
          watchDelegate !== oneTimeWatchDelegate;

      var fn = regularWatch ? function regularInterceptedExpression(scope, locals, assign, inputs) {
        var value = useInputs && inputs ? inputs[0] : parsedExpression(scope, locals, assign, inputs);
        return interceptorFn(value, scope, locals);
      } : function oneTimeInterceptedExpression(scope, locals, assign, inputs) {
        var value = parsedExpression(scope, locals, assign, inputs);
        var result = interceptorFn(value, scope, locals);
        // we only return the interceptor's result if the
        // initial value is defined (for bind-once)
        return isDefined(value) ? result : value;
      };

      // Propagate $$watchDelegates other then inputsWatchDelegate
      if (parsedExpression.$$watchDelegate &&
          parsedExpression.$$watchDelegate !== inputsWatchDelegate) {
        fn.$$watchDelegate = parsedExpression.$$watchDelegate;
      } else if (!interceptorFn.$stateful) {
        // If there is an interceptor, but no watchDelegate then treat the interceptor like
        // we treat filters - it is assumed to be a pure function unless flagged with $stateful
        fn.$$watchDelegate = inputsWatchDelegate;
        useInputs = !parsedExpression.inputs;
        fn.inputs = parsedExpression.inputs ? parsedExpression.inputs : [parsedExpression];
      }

      return fn;
    }
  }];
}

/**
 * @ngdoc service
 * @name $q
 * @requires $rootScope
 *
 * @description
 * A service that helps you run functions asynchronously, and use their return values (or exceptions)
 * when they are done processing.
 *
 * This is an implementation of promises/deferred objects inspired by
 * [Kris Kowal's Q](https://github.com/kriskowal/q).
 *
 * $q can be used in two fashions --- one which is more similar to Kris Kowal's Q or jQuery's Deferred
 * implementations, and the other which resembles ES6 (ES2015) promises to some degree.
 *
 * # $q constructor
 *
 * The streamlined ES6 style promise is essentially just using $q as a constructor which takes a `resolver`
 * function as the first argument. This is similar to the native Promise implementation from ES6,
 * see [MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
 *
 * While the constructor-style use is supported, not all of the supporting methods from ES6 promises are
 * available yet.
 *
 * It can be used like so:
 *
 * ```js
 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
 *   // are available in the current lexical scope (they could have been injected or passed in).
 *
 *   function asyncGreet(name) {
 *     // perform some asynchronous operation, resolve or reject the promise when appropriate.
 *     return $q(function(resolve, reject) {
 *       setTimeout(function() {
 *         if (okToGreet(name)) {
 *           resolve('Hello, ' + name + '!');
 *         } else {
 *           reject('Greeting ' + name + ' is not allowed.');
 *         }
 *       }, 1000);
 *     });
 *   }
 *
 *   var promise = asyncGreet('Robin Hood');
 *   promise.then(function(greeting) {
 *     alert('Success: ' + greeting);
 *   }, function(reason) {
 *     alert('Failed: ' + reason);
 *   });
 * ```
 *
 * Note: progress/notify callbacks are not currently supported via the ES6-style interface.
 *
 * Note: unlike ES6 behavior, an exception thrown in the constructor function will NOT implicitly reject the promise.
 *
 * However, the more traditional CommonJS-style usage is still available, and documented below.
 *
 * [The CommonJS Promise proposal](http://wiki.commonjs.org/wiki/Promises) describes a promise as an
 * interface for interacting with an object that represents the result of an action that is
 * performed asynchronously, and may or may not be finished at any given point in time.
 *
 * From the perspective of dealing with error handling, deferred and promise APIs are to
 * asynchronous programming what `try`, `catch` and `throw` keywords are to synchronous programming.
 *
 * ```js
 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
 *   // are available in the current lexical scope (they could have been injected or passed in).
 *
 *   function asyncGreet(name) {
 *     var deferred = $q.defer();
 *
 *     setTimeout(function() {
 *       deferred.notify('About to greet ' + name + '.');
 *
 *       if (okToGreet(name)) {
 *         deferred.resolve('Hello, ' + name + '!');
 *       } else {
 *         deferred.reject('Greeting ' + name + ' is not allowed.');
 *       }
 *     }, 1000);
 *
 *     return deferred.promise;
 *   }
 *
 *   var promise = asyncGreet('Robin Hood');
 *   promise.then(function(greeting) {
 *     alert('Success: ' + greeting);
 *   }, function(reason) {
 *     alert('Failed: ' + reason);
 *   }, function(update) {
 *     alert('Got notification: ' + update);
 *   });
 * ```
 *
 * At first it might not be obvious why this extra complexity is worth the trouble. The payoff
 * comes in the way of guarantees that promise and deferred APIs make, see
 * https://github.com/kriskowal/uncommonjs/blob/master/promises/specification.md.
 *
 * Additionally the promise api allows for composition that is very hard to do with the
 * traditional callback ([CPS](http://en.wikipedia.org/wiki/Continuation-passing_style)) approach.
 * For more on this please see the [Q documentation](https://github.com/kriskowal/q) especially the
 * section on serial or parallel joining of promises.
 *
 * # The Deferred API
 *
 * A new instance of deferred is constructed by calling `$q.defer()`.
 *
 * The purpose of the deferred object is to expose the associated Promise instance as well as APIs
 * that can be used for signaling the successful or unsuccessful completion, as well as the status
 * of the task.
 *
 * **Methods**
 *
 * - `resolve(value)` – resolves the derived promise with the `value`. If the value is a rejection
 *   constructed via `$q.reject`, the promise will be rejected instead.
 * - `reject(reason)` – rejects the derived promise with the `reason`. This is equivalent to
 *   resolving it with a rejection constructed via `$q.reject`.
 * - `notify(value)` - provides updates on the status of the promise's execution. This may be called
 *   multiple times before the promise is either resolved or rejected.
 *
 * **Properties**
 *
 * - promise – `{Promise}` – promise object associated with this deferred.
 *
 *
 * # The Promise API
 *
 * A new promise instance is created when a deferred instance is created and can be retrieved by
 * calling `deferred.promise`.
 *
 * The purpose of the promise object is to allow for interested parties to get access to the result
 * of the deferred task when it completes.
 *
 * **Methods**
 *
 * - `then(successCallback, [errorCallback], [notifyCallback])` – regardless of when the promise was or
 *   will be resolved or rejected, `then` calls one of the success or error callbacks asynchronously
 *   as soon as the result is available. The callbacks are called with a single argument: the result
 *   or rejection reason. Additionally, the notify callback may be called zero or more times to
 *   provide a progress indication, before the promise is resolved or rejected.
 *
 *   This method *returns a new promise* which is resolved or rejected via the return value of the
 *   `successCallback`, `errorCallback` (unless that value is a promise, in which case it is resolved
 *   with the value which is resolved in that promise using
 *   [promise chaining](http://www.html5rocks.com/en/tutorials/es6/promises/#toc-promises-queues)).
 *   It also notifies via the return value of the `notifyCallback` method. The promise cannot be
 *   resolved or rejected from the notifyCallback method. The errorCallback and notifyCallback
 *   arguments are optional.
 *
 * - `catch(errorCallback)` – shorthand for `promise.then(null, errorCallback)`
 *
 * - `finally(callback, notifyCallback)` – allows you to observe either the fulfillment or rejection of a promise,
 *   but to do so without modifying the final value. This is useful to release resources or do some
 *   clean-up that needs to be done whether the promise was rejected or resolved. See the [full
 *   specification](https://github.com/kriskowal/q/wiki/API-Reference#promisefinallycallback) for
 *   more information.
 *
 * # Chaining promises
 *
 * Because calling the `then` method of a promise returns a new derived promise, it is easily
 * possible to create a chain of promises:
 *
 * ```js
 *   promiseB = promiseA.then(function(result) {
 *     return result + 1;
 *   });
 *
 *   // promiseB will be resolved immediately after promiseA is resolved and its value
 *   // will be the result of promiseA incremented by 1
 * ```
 *
 * It is possible to create chains of any length and since a promise can be resolved with another
 * promise (which will defer its resolution further), it is possible to pause/defer resolution of
 * the promises at any point in the chain. This makes it possible to implement powerful APIs like
 * $http's response interceptors.
 *
 *
 * # Differences between Kris Kowal's Q and $q
 *
 *  There are two main differences:
 *
 * - $q is integrated with the {@link ng.$rootScope.Scope} Scope model observation
 *   mechanism in angular, which means faster propagation of resolution or rejection into your
 *   models and avoiding unnecessary browser repaints, which would result in flickering UI.
 * - Q has many more features than $q, but that comes at a cost of bytes. $q is tiny, but contains
 *   all the important functionality needed for common async tasks.
 *
 * # Testing
 *
 *  ```js
 *    it('should simulate promise', inject(function($q, $rootScope) {
 *      var deferred = $q.defer();
 *      var promise = deferred.promise;
 *      var resolvedValue;
 *
 *      promise.then(function(value) { resolvedValue = value; });
 *      expect(resolvedValue).toBeUndefined();
 *
 *      // Simulate resolving of promise
 *      deferred.resolve(123);
 *      // Note that the 'then' function does not get called synchronously.
 *      // This is because we want the promise API to always be async, whether or not
 *      // it got called synchronously or asynchronously.
 *      expect(resolvedValue).toBeUndefined();
 *
 *      // Propagate promise resolution to 'then' functions using $apply().
 *      $rootScope.$apply();
 *      expect(resolvedValue).toEqual(123);
 *    }));
 *  ```
 *
 * @param {function(function, function)} resolver Function which is responsible for resolving or
 *   rejecting the newly created promise. The first parameter is a function which resolves the
 *   promise, the second parameter is a function which rejects the promise.
 *
 * @returns {Promise} The newly created promise.
 */
function $QProvider() {

  this.$get = ['$rootScope', '$exceptionHandler', function($rootScope, $exceptionHandler) {
    return qFactory(function(callback) {
      $rootScope.$evalAsync(callback);
    }, $exceptionHandler);
  }];
}

function $$QProvider() {
  this.$get = ['$browser', '$exceptionHandler', function($browser, $exceptionHandler) {
    return qFactory(function(callback) {
      $browser.defer(callback);
    }, $exceptionHandler);
  }];
}

/**
 * Constructs a promise manager.
 *
 * @param {function(function)} nextTick Function for executing functions in the next turn.
 * @param {function(...*)} exceptionHandler Function into which unexpected exceptions are passed for
 *     debugging purposes.
 * @returns {object} Promise manager.
 */
function qFactory(nextTick, exceptionHandler) {
  var $qMinErr = minErr('$q', TypeError);

  /**
   * @ngdoc method
   * @name ng.$q#defer
   * @kind function
   *
   * @description
   * Creates a `Deferred` object which represents a task which will finish in the future.
   *
   * @returns {Deferred} Returns a new instance of deferred.
   */
  var defer = function() {
    var d = new Deferred();
    //Necessary to support unbound execution :/
    d.resolve = simpleBind(d, d.resolve);
    d.reject = simpleBind(d, d.reject);
    d.notify = simpleBind(d, d.notify);
    return d;
  };

  function Promise() {
    this.$$state = { status: 0 };
  }

  extend(Promise.prototype, {
    then: function(onFulfilled, onRejected, progressBack) {
      if (isUndefined(onFulfilled) && isUndefined(onRejected) && isUndefined(progressBack)) {
        return this;
      }
      var result = new Deferred();

      this.$$state.pending = this.$$state.pending || [];
      this.$$state.pending.push([result, onFulfilled, onRejected, progressBack]);
      if (this.$$state.status > 0) scheduleProcessQueue(this.$$state);

      return result.promise;
    },

    "catch": function(callback) {
      return this.then(null, callback);
    },

    "finally": function(callback, progressBack) {
      return this.then(function(value) {
        return handleCallback(value, true, callback);
      }, function(error) {
        return handleCallback(error, false, callback);
      }, progressBack);
    }
  });

  //Faster, more basic than angular.bind http://jsperf.com/angular-bind-vs-custom-vs-native
  function simpleBind(context, fn) {
    return function(value) {
      fn.call(context, value);
    };
  }

  function processQueue(state) {
    var fn, deferred, pending;

    pending = state.pending;
    state.processScheduled = false;
    state.pending = undefined;
    for (var i = 0, ii = pending.length; i < ii; ++i) {
      deferred = pending[i][0];
      fn = pending[i][state.status];
      try {
        if (isFunction(fn)) {
          deferred.resolve(fn(state.value));
        } else if (state.status === 1) {
          deferred.resolve(state.value);
        } else {
          deferred.reject(state.value);
        }
      } catch (e) {
        deferred.reject(e);
        exceptionHandler(e);
      }
    }
  }

  function scheduleProcessQueue(state) {
    if (state.processScheduled || !state.pending) return;
    state.processScheduled = true;
    nextTick(function() { processQueue(state); });
  }

  function Deferred() {
    this.promise = new Promise();
  }

  extend(Deferred.prototype, {
    resolve: function(val) {
      if (this.promise.$$state.status) return;
      if (val === this.promise) {
        this.$$reject($qMinErr(
          'qcycle',
          "Expected promise to be resolved with value other than itself '{0}'",
          val));
      } else {
        this.$$resolve(val);
      }

    },

    $$resolve: function(val) {
      var then;
      var that = this;
      var done = false;
      try {
        if ((isObject(val) || isFunction(val))) then = val && val.then;
        if (isFunction(then)) {
          this.promise.$$state.status = -1;
          then.call(val, resolvePromise, rejectPromise, simpleBind(this, this.notify));
        } else {
          this.promise.$$state.value = val;
          this.promise.$$state.status = 1;
          scheduleProcessQueue(this.promise.$$state);
        }
      } catch (e) {
        rejectPromise(e);
        exceptionHandler(e);
      }

      function resolvePromise(val) {
        if (done) return;
        done = true;
        that.$$resolve(val);
      }
      function rejectPromise(val) {
        if (done) return;
        done = true;
        that.$$reject(val);
      }
    },

    reject: function(reason) {
      if (this.promise.$$state.status) return;
      this.$$reject(reason);
    },

    $$reject: function(reason) {
      this.promise.$$state.value = reason;
      this.promise.$$state.status = 2;
      scheduleProcessQueue(this.promise.$$state);
    },

    notify: function(progress) {
      var callbacks = this.promise.$$state.pending;

      if ((this.promise.$$state.status <= 0) && callbacks && callbacks.length) {
        nextTick(function() {
          var callback, result;
          for (var i = 0, ii = callbacks.length; i < ii; i++) {
            result = callbacks[i][0];
            callback = callbacks[i][3];
            try {
              result.notify(isFunction(callback) ? callback(progress) : progress);
            } catch (e) {
              exceptionHandler(e);
            }
          }
        });
      }
    }
  });

  /**
   * @ngdoc method
   * @name $q#reject
   * @kind function
   *
   * @description
   * Creates a promise that is resolved as rejected with the specified `reason`. This api should be
   * used to forward rejection in a chain of promises. If you are dealing with the last promise in
   * a promise chain, you don't need to worry about it.
   *
   * When comparing deferreds/promises to the familiar behavior of try/catch/throw, think of
   * `reject` as the `throw` keyword in JavaScript. This also means that if you "catch" an error via
   * a promise error callback and you want to forward the error to the promise derived from the
   * current promise, you have to "rethrow" the error by returning a rejection constructed via
   * `reject`.
   *
   * ```js
   *   promiseB = promiseA.then(function(result) {
   *     // success: do something and resolve promiseB
   *     //          with the old or a new result
   *     return result;
   *   }, function(reason) {
   *     // error: handle the error if possible and
   *     //        resolve promiseB with newPromiseOrValue,
   *     //        otherwise forward the rejection to promiseB
   *     if (canHandle(reason)) {
   *      // handle the error and recover
   *      return newPromiseOrValue;
   *     }
   *     return $q.reject(reason);
   *   });
   * ```
   *
   * @param {*} reason Constant, message, exception or an object representing the rejection reason.
   * @returns {Promise} Returns a promise that was already resolved as rejected with the `reason`.
   */
  var reject = function(reason) {
    var result = new Deferred();
    result.reject(reason);
    return result.promise;
  };

  var makePromise = function makePromise(value, resolved) {
    var result = new Deferred();
    if (resolved) {
      result.resolve(value);
    } else {
      result.reject(value);
    }
    return result.promise;
  };

  var handleCallback = function handleCallback(value, isResolved, callback) {
    var callbackOutput = null;
    try {
      if (isFunction(callback)) callbackOutput = callback();
    } catch (e) {
      return makePromise(e, false);
    }
    if (isPromiseLike(callbackOutput)) {
      return callbackOutput.then(function() {
        return makePromise(value, isResolved);
      }, function(error) {
        return makePromise(error, false);
      });
    } else {
      return makePromise(value, isResolved);
    }
  };

  /**
   * @ngdoc method
   * @name $q#when
   * @kind function
   *
   * @description
   * Wraps an object that might be a value or a (3rd party) then-able promise into a $q promise.
   * This is useful when you are dealing with an object that might or might not be a promise, or if
   * the promise comes from a source that can't be trusted.
   *
   * @param {*} value Value or a promise
   * @param {Function=} successCallback
   * @param {Function=} errorCallback
   * @param {Function=} progressCallback
   * @returns {Promise} Returns a promise of the passed value or promise
   */


  var when = function(value, callback, errback, progressBack) {
    var result = new Deferred();
    result.resolve(value);
    return result.promise.then(callback, errback, progressBack);
  };

  /**
   * @ngdoc method
   * @name $q#resolve
   * @kind function
   *
   * @description
   * Alias of {@link ng.$q#when when} to maintain naming consistency with ES6.
   *
   * @param {*} value Value or a promise
   * @param {Function=} successCallback
   * @param {Function=} errorCallback
   * @param {Function=} progressCallback
   * @returns {Promise} Returns a promise of the passed value or promise
   */
  var resolve = when;

  /**
   * @ngdoc method
   * @name $q#all
   * @kind function
   *
   * @description
   * Combines multiple promises into a single promise that is resolved when all of the input
   * promises are resolved.
   *
   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
   * @returns {Promise} Returns a single promise that will be resolved with an array/hash of values,
   *   each value corresponding to the promise at the same index/key in the `promises` array/hash.
   *   If any of the promises is resolved with a rejection, this resulting promise will be rejected
   *   with the same rejection value.
   */

  function all(promises) {
    var deferred = new Deferred(),
        counter = 0,
        results = isArray(promises) ? [] : {};

    forEach(promises, function(promise, key) {
      counter++;
      when(promise).then(function(value) {
        if (results.hasOwnProperty(key)) return;
        results[key] = value;
        if (!(--counter)) deferred.resolve(results);
      }, function(reason) {
        if (results.hasOwnProperty(key)) return;
        deferred.reject(reason);
      });
    });

    if (counter === 0) {
      deferred.resolve(results);
    }

    return deferred.promise;
  }

  /**
   * @ngdoc method
   * @name $q#race
   * @kind function
   *
   * @description
   * Returns a promise that resolves or rejects as soon as one of those promises
   * resolves or rejects, with the value or reason from that promise.
   *
   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
   * @returns {Promise} a promise that resolves or rejects as soon as one of the `promises`
   * resolves or rejects, with the value or reason from that promise.
   */

  function race(promises) {
    var deferred = defer();

    forEach(promises, function(promise) {
      when(promise).then(deferred.resolve, deferred.reject);
    });

    return deferred.promise;
  }

  var $Q = function Q(resolver) {
    if (!isFunction(resolver)) {
      throw $qMinErr('norslvr', "Expected resolverFn, got '{0}'", resolver);
    }

    var deferred = new Deferred();

    function resolveFn(value) {
      deferred.resolve(value);
    }

    function rejectFn(reason) {
      deferred.reject(reason);
    }

    resolver(resolveFn, rejectFn);

    return deferred.promise;
  };

  // Let's make the instanceof operator work for promises, so that
  // `new $q(fn) instanceof $q` would evaluate to true.
  $Q.prototype = Promise.prototype;

  $Q.defer = defer;
  $Q.reject = reject;
  $Q.when = when;
  $Q.resolve = resolve;
  $Q.all = all;
  $Q.race = race;

  return $Q;
}

function $$RAFProvider() { //rAF
  this.$get = ['$window', '$timeout', function($window, $timeout) {
    var requestAnimationFrame = $window.requestAnimationFrame ||
                                $window.webkitRequestAnimationFrame;

    var cancelAnimationFrame = $window.cancelAnimationFrame ||
                               $window.webkitCancelAnimationFrame ||
                               $window.webkitCancelRequestAnimationFrame;

    var rafSupported = !!requestAnimationFrame;
    var raf = rafSupported
      ? function(fn) {
          var id = requestAnimationFrame(fn);
          return function() {
            cancelAnimationFrame(id);
          };
        }
      : function(fn) {
          var timer = $timeout(fn, 16.66, false); // 1000 / 60 = 16.666
          return function() {
            $timeout.cancel(timer);
          };
        };

    raf.supported = rafSupported;

    return raf;
  }];
}

/**
 * DESIGN NOTES
 *
 * The design decisions behind the scope are heavily favored for speed and memory consumption.
 *
 * The typical use of scope is to watch the expressions, which most of the time return the same
 * value as last time so we optimize the operation.
 *
 * Closures construction is expensive in terms of speed as well as memory:
 *   - No closures, instead use prototypical inheritance for API
 *   - Internal state needs to be stored on scope directly, which means that private state is
 *     exposed as $$____ properties
 *
 * Loop operations are optimized by using while(count--) { ... }
 *   - This means that in order to keep the same order of execution as addition we have to add
 *     items to the array at the beginning (unshift) instead of at the end (push)
 *
 * Child scopes are created and removed often
 *   - Using an array would be slow since inserts in the middle are expensive; so we use linked lists
 *
 * There are fewer watches than observers. This is why you don't want the observer to be implemented
 * in the same way as watch. Watch requires return of the initialization function which is expensive
 * to construct.
 */


/**
 * @ngdoc provider
 * @name $rootScopeProvider
 * @description
 *
 * Provider for the $rootScope service.
 */

/**
 * @ngdoc method
 * @name $rootScopeProvider#digestTtl
 * @description
 *
 * Sets the number of `$digest` iterations the scope should attempt to execute before giving up and
 * assuming that the model is unstable.
 *
 * The current default is 10 iterations.
 *
 * In complex applications it's possible that the dependencies between `$watch`s will result in
 * several digest iterations. However if an application needs more than the default 10 digest
 * iterations for its model to stabilize then you should investigate what is causing the model to
 * continuously change during the digest.
 *
 * Increasing the TTL could have performance implications, so you should not change it without
 * proper justification.
 *
 * @param {number} limit The number of digest iterations.
 */


/**
 * @ngdoc service
 * @name $rootScope
 * @description
 *
 * Every application has a single root {@link ng.$rootScope.Scope scope}.
 * All other scopes are descendant scopes of the root scope. Scopes provide separation
 * between the model and the view, via a mechanism for watching the model for changes.
 * They also provide event emission/broadcast and subscription facility. See the
 * {@link guide/scope developer guide on scopes}.
 */
function $RootScopeProvider() {
  var TTL = 10;
  var $rootScopeMinErr = minErr('$rootScope');
  var lastDirtyWatch = null;
  var applyAsyncId = null;

  this.digestTtl = function(value) {
    if (arguments.length) {
      TTL = value;
    }
    return TTL;
  };

  function createChildScopeClass(parent) {
    function ChildScope() {
      this.$$watchers = this.$$nextSibling =
          this.$$childHead = this.$$childTail = null;
      this.$$listeners = {};
      this.$$listenerCount = {};
      this.$$watchersCount = 0;
      this.$id = nextUid();
      this.$$ChildScope = null;
    }
    ChildScope.prototype = parent;
    return ChildScope;
  }

  this.$get = ['$exceptionHandler', '$parse', '$browser',
      function($exceptionHandler, $parse, $browser) {

    function destroyChildScope($event) {
        $event.currentScope.$$destroyed = true;
    }

    function cleanUpScope($scope) {

      if (msie === 9) {
        // There is a memory leak in IE9 if all child scopes are not disconnected
        // completely when a scope is destroyed. So this code will recurse up through
        // all this scopes children
        //
        // See issue https://github.com/angular/angular.js/issues/10706
        $scope.$$childHead && cleanUpScope($scope.$$childHead);
        $scope.$$nextSibling && cleanUpScope($scope.$$nextSibling);
      }

      // The code below works around IE9 and V8's memory leaks
      //
      // See:
      // - https://code.google.com/p/v8/issues/detail?id=2073#c26
      // - https://github.com/angular/angular.js/issues/6794#issuecomment-38648909
      // - https://github.com/angular/angular.js/issues/1313#issuecomment-10378451

      $scope.$parent = $scope.$$nextSibling = $scope.$$prevSibling = $scope.$$childHead =
          $scope.$$childTail = $scope.$root = $scope.$$watchers = null;
    }

    /**
     * @ngdoc type
     * @name $rootScope.Scope
     *
     * @description
     * A root scope can be retrieved using the {@link ng.$rootScope $rootScope} key from the
     * {@link auto.$injector $injector}. Child scopes are created using the
     * {@link ng.$rootScope.Scope#$new $new()} method. (Most scopes are created automatically when
     * compiled HTML template is executed.) See also the {@link guide/scope Scopes guide} for
     * an in-depth introduction and usage examples.
     *
     *
     * # Inheritance
     * A scope can inherit from a parent scope, as in this example:
     * ```js
         var parent = $rootScope;
         var child = parent.$new();

         parent.salutation = "Hello";
         expect(child.salutation).toEqual('Hello');

         child.salutation = "Welcome";
         expect(child.salutation).toEqual('Welcome');
         expect(parent.salutation).toEqual('Hello');
     * ```
     *
     * When interacting with `Scope` in tests, additional helper methods are available on the
     * instances of `Scope` type. See {@link ngMock.$rootScope.Scope ngMock Scope} for additional
     * details.
     *
     *
     * @param {Object.<string, function()>=} providers Map of service factory which need to be
     *                                       provided for the current scope. Defaults to {@link ng}.
     * @param {Object.<string, *>=} instanceCache Provides pre-instantiated services which should
     *                              append/override services provided by `providers`. This is handy
     *                              when unit-testing and having the need to override a default
     *                              service.
     * @returns {Object} Newly created scope.
     *
     */
    function Scope() {
      this.$id = nextUid();
      this.$$phase = this.$parent = this.$$watchers =
                     this.$$nextSibling = this.$$prevSibling =
                     this.$$childHead = this.$$childTail = null;
      this.$root = this;
      this.$$destroyed = false;
      this.$$listeners = {};
      this.$$listenerCount = {};
      this.$$watchersCount = 0;
      this.$$isolateBindings = null;
    }

    /**
     * @ngdoc property
     * @name $rootScope.Scope#$id
     *
     * @description
     * Unique scope ID (monotonically increasing) useful for debugging.
     */

     /**
      * @ngdoc property
      * @name $rootScope.Scope#$parent
      *
      * @description
      * Reference to the parent scope.
      */

      /**
       * @ngdoc property
       * @name $rootScope.Scope#$root
       *
       * @description
       * Reference to the root scope.
       */

    Scope.prototype = {
      constructor: Scope,
      /**
       * @ngdoc method
       * @name $rootScope.Scope#$new
       * @kind function
       *
       * @description
       * Creates a new child {@link ng.$rootScope.Scope scope}.
       *
       * The parent scope will propagate the {@link ng.$rootScope.Scope#$digest $digest()} event.
       * The scope can be removed from the scope hierarchy using {@link ng.$rootScope.Scope#$destroy $destroy()}.
       *
       * {@link ng.$rootScope.Scope#$destroy $destroy()} must be called on a scope when it is
       * desired for the scope and its child scopes to be permanently detached from the parent and
       * thus stop participating in model change detection and listener notification by invoking.
       *
       * @param {boolean} isolate If true, then the scope does not prototypically inherit from the
       *         parent scope. The scope is isolated, as it can not see parent scope properties.
       *         When creating widgets, it is useful for the widget to not accidentally read parent
       *         state.
       *
       * @param {Scope} [parent=this] The {@link ng.$rootScope.Scope `Scope`} that will be the `$parent`
       *                              of the newly created scope. Defaults to `this` scope if not provided.
       *                              This is used when creating a transclude scope to correctly place it
       *                              in the scope hierarchy while maintaining the correct prototypical
       *                              inheritance.
       *
       * @returns {Object} The newly created child scope.
       *
       */
      $new: function(isolate, parent) {
        var child;

        parent = parent || this;

        if (isolate) {
          child = new Scope();
          child.$root = this.$root;
        } else {
          // Only create a child scope class if somebody asks for one,
          // but cache it to allow the VM to optimize lookups.
          if (!this.$$ChildScope) {
            this.$$ChildScope = createChildScopeClass(this);
          }
          child = new this.$$ChildScope();
        }
        child.$parent = parent;
        child.$$prevSibling = parent.$$childTail;
        if (parent.$$childHead) {
          parent.$$childTail.$$nextSibling = child;
          parent.$$childTail = child;
        } else {
          parent.$$childHead = parent.$$childTail = child;
        }

        // When the new scope is not isolated or we inherit from `this`, and
        // the parent scope is destroyed, the property `$$destroyed` is inherited
        // prototypically. In all other cases, this property needs to be set
        // when the parent scope is destroyed.
        // The listener needs to be added after the parent is set
        if (isolate || parent != this) child.$on('$destroy', destroyChildScope);

        return child;
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$watch
       * @kind function
       *
       * @description
       * Registers a `listener` callback to be executed whenever the `watchExpression` changes.
       *
       * - The `watchExpression` is called on every call to {@link ng.$rootScope.Scope#$digest
       *   $digest()} and should return the value that will be watched. (`watchExpression` should not change
       *   its value when executed multiple times with the same input because it may be executed multiple
       *   times by {@link ng.$rootScope.Scope#$digest $digest()}. That is, `watchExpression` should be
       *   [idempotent](http://en.wikipedia.org/wiki/Idempotence).
       * - The `listener` is called only when the value from the current `watchExpression` and the
       *   previous call to `watchExpression` are not equal (with the exception of the initial run,
       *   see below). Inequality is determined according to reference inequality,
       *   [strict comparison](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Comparison_Operators)
       *    via the `!==` Javascript operator, unless `objectEquality == true`
       *   (see next point)
       * - When `objectEquality == true`, inequality of the `watchExpression` is determined
       *   according to the {@link angular.equals} function. To save the value of the object for
       *   later comparison, the {@link angular.copy} function is used. This therefore means that
       *   watching complex objects will have adverse memory and performance implications.
       * - The watch `listener` may change the model, which may trigger other `listener`s to fire.
       *   This is achieved by rerunning the watchers until no changes are detected. The rerun
       *   iteration limit is 10 to prevent an infinite loop deadlock.
       *
       *
       * If you want to be notified whenever {@link ng.$rootScope.Scope#$digest $digest} is called,
       * you can register a `watchExpression` function with no `listener`. (Be prepared for
       * multiple calls to your `watchExpression` because it will execute multiple times in a
       * single {@link ng.$rootScope.Scope#$digest $digest} cycle if a change is detected.)
       *
       * After a watcher is registered with the scope, the `listener` fn is called asynchronously
       * (via {@link ng.$rootScope.Scope#$evalAsync $evalAsync}) to initialize the
       * watcher. In rare cases, this is undesirable because the listener is called when the result
       * of `watchExpression` didn't change. To detect this scenario within the `listener` fn, you
       * can compare the `newVal` and `oldVal`. If these two values are identical (`===`) then the
       * listener was called due to initialization.
       *
       *
       *
       * # Example
       * ```js
           // let's assume that scope was dependency injected as the $rootScope
           var scope = $rootScope;
           scope.name = 'misko';
           scope.counter = 0;

           expect(scope.counter).toEqual(0);
           scope.$watch('name', function(newValue, oldValue) {
             scope.counter = scope.counter + 1;
           });
           expect(scope.counter).toEqual(0);

           scope.$digest();
           // the listener is always called during the first $digest loop after it was registered
           expect(scope.counter).toEqual(1);

           scope.$digest();
           // but now it will not be called unless the value changes
           expect(scope.counter).toEqual(1);

           scope.name = 'adam';
           scope.$digest();
           expect(scope.counter).toEqual(2);



           // Using a function as a watchExpression
           var food;
           scope.foodCounter = 0;
           expect(scope.foodCounter).toEqual(0);
           scope.$watch(
             // This function returns the value being watched. It is called for each turn of the $digest loop
             function() { return food; },
             // This is the change listener, called when the value returned from the above function changes
             function(newValue, oldValue) {
               if ( newValue !== oldValue ) {
                 // Only increment the counter if the value changed
                 scope.foodCounter = scope.foodCounter + 1;
               }
             }
           );
           // No digest has been run so the counter will be zero
           expect(scope.foodCounter).toEqual(0);

           // Run the digest but since food has not changed count will still be zero
           scope.$digest();
           expect(scope.foodCounter).toEqual(0);

           // Update food and run digest.  Now the counter will increment
           food = 'cheeseburger';
           scope.$digest();
           expect(scope.foodCounter).toEqual(1);

       * ```
       *
       *
       *
       * @param {(function()|string)} watchExpression Expression that is evaluated on each
       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. A change in the return value triggers
       *    a call to the `listener`.
       *
       *    - `string`: Evaluated as {@link guide/expression expression}
       *    - `function(scope)`: called with current `scope` as a parameter.
       * @param {function(newVal, oldVal, scope)} listener Callback called whenever the value
       *    of `watchExpression` changes.
       *
       *    - `newVal` contains the current value of the `watchExpression`
       *    - `oldVal` contains the previous value of the `watchExpression`
       *    - `scope` refers to the current scope
       * @param {boolean=} [objectEquality=false] Compare for object equality using {@link angular.equals} instead of
       *     comparing for reference equality.
       * @returns {function()} Returns a deregistration function for this listener.
       */
      $watch: function(watchExp, listener, objectEquality, prettyPrintExpression) {
        var get = $parse(watchExp);

        if (get.$$watchDelegate) {
          return get.$$watchDelegate(this, listener, objectEquality, get, watchExp);
        }
        var scope = this,
            array = scope.$$watchers,
            watcher = {
              fn: listener,
              last: initWatchVal,
              get: get,
              exp: prettyPrintExpression || watchExp,
              eq: !!objectEquality
            };

        lastDirtyWatch = null;

        if (!isFunction(listener)) {
          watcher.fn = noop;
        }

        if (!array) {
          array = scope.$$watchers = [];
        }
        // we use unshift since we use a while loop in $digest for speed.
        // the while loop reads in reverse order.
        array.unshift(watcher);
        incrementWatchersCount(this, 1);

        return function deregisterWatch() {
          if (arrayRemove(array, watcher) >= 0) {
            incrementWatchersCount(scope, -1);
          }
          lastDirtyWatch = null;
        };
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$watchGroup
       * @kind function
       *
       * @description
       * A variant of {@link ng.$rootScope.Scope#$watch $watch()} where it watches an array of `watchExpressions`.
       * If any one expression in the collection changes the `listener` is executed.
       *
       * - The items in the `watchExpressions` array are observed via standard $watch operation and are examined on every
       *   call to $digest() to see if any items changes.
       * - The `listener` is called whenever any expression in the `watchExpressions` array changes.
       *
       * @param {Array.<string|Function(scope)>} watchExpressions Array of expressions that will be individually
       * watched using {@link ng.$rootScope.Scope#$watch $watch()}
       *
       * @param {function(newValues, oldValues, scope)} listener Callback called whenever the return value of any
       *    expression in `watchExpressions` changes
       *    The `newValues` array contains the current values of the `watchExpressions`, with the indexes matching
       *    those of `watchExpression`
       *    and the `oldValues` array contains the previous values of the `watchExpressions`, with the indexes matching
       *    those of `watchExpression`
       *    The `scope` refers to the current scope.
       * @returns {function()} Returns a de-registration function for all listeners.
       */
      $watchGroup: function(watchExpressions, listener) {
        var oldValues = new Array(watchExpressions.length);
        var newValues = new Array(watchExpressions.length);
        var deregisterFns = [];
        var self = this;
        var changeReactionScheduled = false;
        var firstRun = true;

        if (!watchExpressions.length) {
          // No expressions means we call the listener ASAP
          var shouldCall = true;
          self.$evalAsync(function() {
            if (shouldCall) listener(newValues, newValues, self);
          });
          return function deregisterWatchGroup() {
            shouldCall = false;
          };
        }

        if (watchExpressions.length === 1) {
          // Special case size of one
          return this.$watch(watchExpressions[0], function watchGroupAction(value, oldValue, scope) {
            newValues[0] = value;
            oldValues[0] = oldValue;
            listener(newValues, (value === oldValue) ? newValues : oldValues, scope);
          });
        }

        forEach(watchExpressions, function(expr, i) {
          var unwatchFn = self.$watch(expr, function watchGroupSubAction(value, oldValue) {
            newValues[i] = value;
            oldValues[i] = oldValue;
            if (!changeReactionScheduled) {
              changeReactionScheduled = true;
              self.$evalAsync(watchGroupAction);
            }
          });
          deregisterFns.push(unwatchFn);
        });

        function watchGroupAction() {
          changeReactionScheduled = false;

          if (firstRun) {
            firstRun = false;
            listener(newValues, newValues, self);
          } else {
            listener(newValues, oldValues, self);
          }
        }

        return function deregisterWatchGroup() {
          while (deregisterFns.length) {
            deregisterFns.shift()();
          }
        };
      },


      /**
       * @ngdoc method
       * @name $rootScope.Scope#$watchCollection
       * @kind function
       *
       * @description
       * Shallow watches the properties of an object and fires whenever any of the properties change
       * (for arrays, this implies watching the array items; for object maps, this implies watching
       * the properties). If a change is detected, the `listener` callback is fired.
       *
       * - The `obj` collection is observed via standard $watch operation and is examined on every
       *   call to $digest() to see if any items have been added, removed, or moved.
       * - The `listener` is called whenever anything within the `obj` has changed. Examples include
       *   adding, removing, and moving items belonging to an object or array.
       *
       *
       * # Example
       * ```js
          $scope.names = ['igor', 'matias', 'misko', 'james'];
          $scope.dataCount = 4;

          $scope.$watchCollection('names', function(newNames, oldNames) {
            $scope.dataCount = newNames.length;
          });

          expect($scope.dataCount).toEqual(4);
          $scope.$digest();

          //still at 4 ... no changes
          expect($scope.dataCount).toEqual(4);

          $scope.names.pop();
          $scope.$digest();

          //now there's been a change
          expect($scope.dataCount).toEqual(3);
       * ```
       *
       *
       * @param {string|function(scope)} obj Evaluated as {@link guide/expression expression}. The
       *    expression value should evaluate to an object or an array which is observed on each
       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. Any shallow change within the
       *    collection will trigger a call to the `listener`.
       *
       * @param {function(newCollection, oldCollection, scope)} listener a callback function called
       *    when a change is detected.
       *    - The `newCollection` object is the newly modified data obtained from the `obj` expression
       *    - The `oldCollection` object is a copy of the former collection data.
       *      Due to performance considerations, the`oldCollection` value is computed only if the
       *      `listener` function declares two or more arguments.
       *    - The `scope` argument refers to the current scope.
       *
       * @returns {function()} Returns a de-registration function for this listener. When the
       *    de-registration function is executed, the internal watch operation is terminated.
       */
      $watchCollection: function(obj, listener) {
        $watchCollectionInterceptor.$stateful = true;

        var self = this;
        // the current value, updated on each dirty-check run
        var newValue;
        // a shallow copy of the newValue from the last dirty-check run,
        // updated to match newValue during dirty-check run
        var oldValue;
        // a shallow copy of the newValue from when the last change happened
        var veryOldValue;
        // only track veryOldValue if the listener is asking for it
        var trackVeryOldValue = (listener.length > 1);
        var changeDetected = 0;
        var changeDetector = $parse(obj, $watchCollectionInterceptor);
        var internalArray = [];
        var internalObject = {};
        var initRun = true;
        var oldLength = 0;

        function $watchCollectionInterceptor(_value) {
          newValue = _value;
          var newLength, key, bothNaN, newItem, oldItem;

          // If the new value is undefined, then return undefined as the watch may be a one-time watch
          if (isUndefined(newValue)) return;

          if (!isObject(newValue)) { // if primitive
            if (oldValue !== newValue) {
              oldValue = newValue;
              changeDetected++;
            }
          } else if (isArrayLike(newValue)) {
            if (oldValue !== internalArray) {
              // we are transitioning from something which was not an array into array.
              oldValue = internalArray;
              oldLength = oldValue.length = 0;
              changeDetected++;
            }

            newLength = newValue.length;

            if (oldLength !== newLength) {
              // if lengths do not match we need to trigger change notification
              changeDetected++;
              oldValue.length = oldLength = newLength;
            }
            // copy the items to oldValue and look for changes.
            for (var i = 0; i < newLength; i++) {
              oldItem = oldValue[i];
              newItem = newValue[i];

              bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
              if (!bothNaN && (oldItem !== newItem)) {
                changeDetected++;
                oldValue[i] = newItem;
              }
            }
          } else {
            if (oldValue !== internalObject) {
              // we are transitioning from something which was not an object into object.
              oldValue = internalObject = {};
              oldLength = 0;
              changeDetected++;
            }
            // copy the items to oldValue and look for changes.
            newLength = 0;
            for (key in newValue) {
              if (hasOwnProperty.call(newValue, key)) {
                newLength++;
                newItem = newValue[key];
                oldItem = oldValue[key];

                if (key in oldValue) {
                  bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
                  if (!bothNaN && (oldItem !== newItem)) {
                    changeDetected++;
                    oldValue[key] = newItem;
                  }
                } else {
                  oldLength++;
                  oldValue[key] = newItem;
                  changeDetected++;
                }
              }
            }
            if (oldLength > newLength) {
              // we used to have more keys, need to find them and destroy them.
              changeDetected++;
              for (key in oldValue) {
                if (!hasOwnProperty.call(newValue, key)) {
                  oldLength--;
                  delete oldValue[key];
                }
              }
            }
          }
          return changeDetected;
        }

        function $watchCollectionAction() {
          if (initRun) {
            initRun = false;
            listener(newValue, newValue, self);
          } else {
            listener(newValue, veryOldValue, self);
          }

          // make a copy for the next time a collection is changed
          if (trackVeryOldValue) {
            if (!isObject(newValue)) {
              //primitive
              veryOldValue = newValue;
            } else if (isArrayLike(newValue)) {
              veryOldValue = new Array(newValue.length);
              for (var i = 0; i < newValue.length; i++) {
                veryOldValue[i] = newValue[i];
              }
            } else { // if object
              veryOldValue = {};
              for (var key in newValue) {
                if (hasOwnProperty.call(newValue, key)) {
                  veryOldValue[key] = newValue[key];
                }
              }
            }
          }
        }

        return this.$watch(changeDetector, $watchCollectionAction);
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$digest
       * @kind function
       *
       * @description
       * Processes all of the {@link ng.$rootScope.Scope#$watch watchers} of the current scope and
       * its children. Because a {@link ng.$rootScope.Scope#$watch watcher}'s listener can change
       * the model, the `$digest()` keeps calling the {@link ng.$rootScope.Scope#$watch watchers}
       * until no more listeners are firing. This means that it is possible to get into an infinite
       * loop. This function will throw `'Maximum iteration limit exceeded.'` if the number of
       * iterations exceeds 10.
       *
       * Usually, you don't call `$digest()` directly in
       * {@link ng.directive:ngController controllers} or in
       * {@link ng.$compileProvider#directive directives}.
       * Instead, you should call {@link ng.$rootScope.Scope#$apply $apply()} (typically from within
       * a {@link ng.$compileProvider#directive directive}), which will force a `$digest()`.
       *
       * If you want to be notified whenever `$digest()` is called,
       * you can register a `watchExpression` function with
       * {@link ng.$rootScope.Scope#$watch $watch()} with no `listener`.
       *
       * In unit tests, you may need to call `$digest()` to simulate the scope life cycle.
       *
       * # Example
       * ```js
           var scope = ...;
           scope.name = 'misko';
           scope.counter = 0;

           expect(scope.counter).toEqual(0);
           scope.$watch('name', function(newValue, oldValue) {
             scope.counter = scope.counter + 1;
           });
           expect(scope.counter).toEqual(0);

           scope.$digest();
           // the listener is always called during the first $digest loop after it was registered
           expect(scope.counter).toEqual(1);

           scope.$digest();
           // but now it will not be called unless the value changes
           expect(scope.counter).toEqual(1);

           scope.name = 'adam';
           scope.$digest();
           expect(scope.counter).toEqual(2);
       * ```
       *
       */
      $digest: function() {
        var watch, value, last, fn, get,
            watchers,
            length,
            dirty, ttl = TTL,
            next, current, target = this,
            watchLog = [],
            logIdx, asyncTask;

        beginPhase('$digest');
        // Check for changes to browser url that happened in sync before the call to $digest
        $browser.$$checkUrlChange();

        if (this === $rootScope && applyAsyncId !== null) {
          // If this is the root scope, and $applyAsync has scheduled a deferred $apply(), then
          // cancel the scheduled $apply and flush the queue of expressions to be evaluated.
          $browser.defer.cancel(applyAsyncId);
          flushApplyAsync();
        }

        lastDirtyWatch = null;

        do { // "while dirty" loop
          dirty = false;
          current = target;

          // It's safe for asyncQueuePosition to be a local variable here because this loop can't
          // be reentered recursively. Calling $digest from a function passed to $applyAsync would
          // lead to a '$digest already in progress' error.
          for (var asyncQueuePosition = 0; asyncQueuePosition < asyncQueue.length; asyncQueuePosition++) {
            try {
              asyncTask = asyncQueue[asyncQueuePosition];
              asyncTask.scope.$eval(asyncTask.expression, asyncTask.locals);
            } catch (e) {
              $exceptionHandler(e);
            }
            lastDirtyWatch = null;
          }
          asyncQueue.length = 0;

          traverseScopesLoop:
          do { // "traverse the scopes" loop
            if ((watchers = current.$$watchers)) {
              // process our watches
              length = watchers.length;
              while (length--) {
                try {
                  watch = watchers[length];
                  // Most common watches are on primitives, in which case we can short
                  // circuit it with === operator, only when === fails do we use .equals
                  if (watch) {
                    get = watch.get;
                    if ((value = get(current)) !== (last = watch.last) &&
                        !(watch.eq
                            ? equals(value, last)
                            : (typeof value === 'number' && typeof last === 'number'
                               && isNaN(value) && isNaN(last)))) {
                      dirty = true;
                      lastDirtyWatch = watch;
                      watch.last = watch.eq ? copy(value, null) : value;
                      fn = watch.fn;
                      fn(value, ((last === initWatchVal) ? value : last), current);
                      if (ttl < 5) {
                        logIdx = 4 - ttl;
                        if (!watchLog[logIdx]) watchLog[logIdx] = [];
                        watchLog[logIdx].push({
                          msg: isFunction(watch.exp) ? 'fn: ' + (watch.exp.name || watch.exp.toString()) : watch.exp,
                          newVal: value,
                          oldVal: last
                        });
                      }
                    } else if (watch === lastDirtyWatch) {
                      // If the most recently dirty watcher is now clean, short circuit since the remaining watchers
                      // have already been tested.
                      dirty = false;
                      break traverseScopesLoop;
                    }
                  }
                } catch (e) {
                  $exceptionHandler(e);
                }
              }
            }

            // Insanity Warning: scope depth-first traversal
            // yes, this code is a bit crazy, but it works and we have tests to prove it!
            // this piece should be kept in sync with the traversal in $broadcast
            if (!(next = ((current.$$watchersCount && current.$$childHead) ||
                (current !== target && current.$$nextSibling)))) {
              while (current !== target && !(next = current.$$nextSibling)) {
                current = current.$parent;
              }
            }
          } while ((current = next));

          // `break traverseScopesLoop;` takes us to here

          if ((dirty || asyncQueue.length) && !(ttl--)) {
            clearPhase();
            throw $rootScopeMinErr('infdig',
                '{0} $digest() iterations reached. Aborting!\n' +
                'Watchers fired in the last 5 iterations: {1}',
                TTL, watchLog);
          }

        } while (dirty || asyncQueue.length);

        clearPhase();

        // postDigestQueuePosition isn't local here because this loop can be reentered recursively.
        while (postDigestQueuePosition < postDigestQueue.length) {
          try {
            postDigestQueue[postDigestQueuePosition++]();
          } catch (e) {
            $exceptionHandler(e);
          }
        }
        postDigestQueue.length = postDigestQueuePosition = 0;
      },


      /**
       * @ngdoc event
       * @name $rootScope.Scope#$destroy
       * @eventType broadcast on scope being destroyed
       *
       * @description
       * Broadcasted when a scope and its children are being destroyed.
       *
       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
       * clean up DOM bindings before an element is removed from the DOM.
       */

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$destroy
       * @kind function
       *
       * @description
       * Removes the current scope (and all of its children) from the parent scope. Removal implies
       * that calls to {@link ng.$rootScope.Scope#$digest $digest()} will no longer
       * propagate to the current scope and its children. Removal also implies that the current
       * scope is eligible for garbage collection.
       *
       * The `$destroy()` is usually used by directives such as
       * {@link ng.directive:ngRepeat ngRepeat} for managing the
       * unrolling of the loop.
       *
       * Just before a scope is destroyed, a `$destroy` event is broadcasted on this scope.
       * Application code can register a `$destroy` event handler that will give it a chance to
       * perform any necessary cleanup.
       *
       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
       * clean up DOM bindings before an element is removed from the DOM.
       */
      $destroy: function() {
        // We can't destroy a scope that has been already destroyed.
        if (this.$$destroyed) return;
        var parent = this.$parent;

        this.$broadcast('$destroy');
        this.$$destroyed = true;

        if (this === $rootScope) {
          //Remove handlers attached to window when $rootScope is removed
          $browser.$$applicationDestroyed();
        }

        incrementWatchersCount(this, -this.$$watchersCount);
        for (var eventName in this.$$listenerCount) {
          decrementListenerCount(this, this.$$listenerCount[eventName], eventName);
        }

        // sever all the references to parent scopes (after this cleanup, the current scope should
        // not be retained by any of our references and should be eligible for garbage collection)
        if (parent && parent.$$childHead == this) parent.$$childHead = this.$$nextSibling;
        if (parent && parent.$$childTail == this) parent.$$childTail = this.$$prevSibling;
        if (this.$$prevSibling) this.$$prevSibling.$$nextSibling = this.$$nextSibling;
        if (this.$$nextSibling) this.$$nextSibling.$$prevSibling = this.$$prevSibling;

        // Disable listeners, watchers and apply/digest methods
        this.$destroy = this.$digest = this.$apply = this.$evalAsync = this.$applyAsync = noop;
        this.$on = this.$watch = this.$watchGroup = function() { return noop; };
        this.$$listeners = {};

        // Disconnect the next sibling to prevent `cleanUpScope` destroying those too
        this.$$nextSibling = null;
        cleanUpScope(this);
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$eval
       * @kind function
       *
       * @description
       * Executes the `expression` on the current scope and returns the result. Any exceptions in
       * the expression are propagated (uncaught). This is useful when evaluating Angular
       * expressions.
       *
       * # Example
       * ```js
           var scope = ng.$rootScope.Scope();
           scope.a = 1;
           scope.b = 2;

           expect(scope.$eval('a+b')).toEqual(3);
           expect(scope.$eval(function(scope){ return scope.a + scope.b; })).toEqual(3);
       * ```
       *
       * @param {(string|function())=} expression An angular expression to be executed.
       *
       *    - `string`: execute using the rules as defined in  {@link guide/expression expression}.
       *    - `function(scope)`: execute the function with the current `scope` parameter.
       *
       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
       * @returns {*} The result of evaluating the expression.
       */
      $eval: function(expr, locals) {
        return $parse(expr)(this, locals);
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$evalAsync
       * @kind function
       *
       * @description
       * Executes the expression on the current scope at a later point in time.
       *
       * The `$evalAsync` makes no guarantees as to when the `expression` will be executed, only
       * that:
       *
       *   - it will execute after the function that scheduled the evaluation (preferably before DOM
       *     rendering).
       *   - at least one {@link ng.$rootScope.Scope#$digest $digest cycle} will be performed after
       *     `expression` execution.
       *
       * Any exceptions from the execution of the expression are forwarded to the
       * {@link ng.$exceptionHandler $exceptionHandler} service.
       *
       * __Note:__ if this function is called outside of a `$digest` cycle, a new `$digest` cycle
       * will be scheduled. However, it is encouraged to always call code that changes the model
       * from within an `$apply` call. That includes code evaluated via `$evalAsync`.
       *
       * @param {(string|function())=} expression An angular expression to be executed.
       *
       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
       *    - `function(scope)`: execute the function with the current `scope` parameter.
       *
       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
       */
      $evalAsync: function(expr, locals) {
        // if we are outside of an $digest loop and this is the first time we are scheduling async
        // task also schedule async auto-flush
        if (!$rootScope.$$phase && !asyncQueue.length) {
          $browser.defer(function() {
            if (asyncQueue.length) {
              $rootScope.$digest();
            }
          });
        }

        asyncQueue.push({scope: this, expression: $parse(expr), locals: locals});
      },

      $$postDigest: function(fn) {
        postDigestQueue.push(fn);
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$apply
       * @kind function
       *
       * @description
       * `$apply()` is used to execute an expression in angular from outside of the angular
       * framework. (For example from browser DOM events, setTimeout, XHR or third party libraries).
       * Because we are calling into the angular framework we need to perform proper scope life
       * cycle of {@link ng.$exceptionHandler exception handling},
       * {@link ng.$rootScope.Scope#$digest executing watches}.
       *
       * ## Life cycle
       *
       * # Pseudo-Code of `$apply()`
       * ```js
           function $apply(expr) {
             try {
               return $eval(expr);
             } catch (e) {
               $exceptionHandler(e);
             } finally {
               $root.$digest();
             }
           }
       * ```
       *
       *
       * Scope's `$apply()` method transitions through the following stages:
       *
       * 1. The {@link guide/expression expression} is executed using the
       *    {@link ng.$rootScope.Scope#$eval $eval()} method.
       * 2. Any exceptions from the execution of the expression are forwarded to the
       *    {@link ng.$exceptionHandler $exceptionHandler} service.
       * 3. The {@link ng.$rootScope.Scope#$watch watch} listeners are fired immediately after the
       *    expression was executed using the {@link ng.$rootScope.Scope#$digest $digest()} method.
       *
       *
       * @param {(string|function())=} exp An angular expression to be executed.
       *
       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
       *    - `function(scope)`: execute the function with current `scope` parameter.
       *
       * @returns {*} The result of evaluating the expression.
       */
      $apply: function(expr) {
        try {
          beginPhase('$apply');
          try {
            return this.$eval(expr);
          } finally {
            clearPhase();
          }
        } catch (e) {
          $exceptionHandler(e);
        } finally {
          try {
            $rootScope.$digest();
          } catch (e) {
            $exceptionHandler(e);
            throw e;
          }
        }
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$applyAsync
       * @kind function
       *
       * @description
       * Schedule the invocation of $apply to occur at a later time. The actual time difference
       * varies across browsers, but is typically around ~10 milliseconds.
       *
       * This can be used to queue up multiple expressions which need to be evaluated in the same
       * digest.
       *
       * @param {(string|function())=} exp An angular expression to be executed.
       *
       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
       *    - `function(scope)`: execute the function with current `scope` parameter.
       */
      $applyAsync: function(expr) {
        var scope = this;
        expr && applyAsyncQueue.push($applyAsyncExpression);
        expr = $parse(expr);
        scheduleApplyAsync();

        function $applyAsyncExpression() {
          scope.$eval(expr);
        }
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$on
       * @kind function
       *
       * @description
       * Listens on events of a given type. See {@link ng.$rootScope.Scope#$emit $emit} for
       * discussion of event life cycle.
       *
       * The event listener function format is: `function(event, args...)`. The `event` object
       * passed into the listener has the following attributes:
       *
       *   - `targetScope` - `{Scope}`: the scope on which the event was `$emit`-ed or
       *     `$broadcast`-ed.
       *   - `currentScope` - `{Scope}`: the scope that is currently handling the event. Once the
       *     event propagates through the scope hierarchy, this property is set to null.
       *   - `name` - `{string}`: name of the event.
       *   - `stopPropagation` - `{function=}`: calling `stopPropagation` function will cancel
       *     further event propagation (available only for events that were `$emit`-ed).
       *   - `preventDefault` - `{function}`: calling `preventDefault` sets `defaultPrevented` flag
       *     to true.
       *   - `defaultPrevented` - `{boolean}`: true if `preventDefault` was called.
       *
       * @param {string} name Event name to listen on.
       * @param {function(event, ...args)} listener Function to call when the event is emitted.
       * @returns {function()} Returns a deregistration function for this listener.
       */
      $on: function(name, listener) {
        var namedListeners = this.$$listeners[name];
        if (!namedListeners) {
          this.$$listeners[name] = namedListeners = [];
        }
        namedListeners.push(listener);

        var current = this;
        do {
          if (!current.$$listenerCount[name]) {
            current.$$listenerCount[name] = 0;
          }
          current.$$listenerCount[name]++;
        } while ((current = current.$parent));

        var self = this;
        return function() {
          var indexOfListener = namedListeners.indexOf(listener);
          if (indexOfListener !== -1) {
            namedListeners[indexOfListener] = null;
            decrementListenerCount(self, 1, name);
          }
        };
      },


      /**
       * @ngdoc method
       * @name $rootScope.Scope#$emit
       * @kind function
       *
       * @description
       * Dispatches an event `name` upwards through the scope hierarchy notifying the
       * registered {@link ng.$rootScope.Scope#$on} listeners.
       *
       * The event life cycle starts at the scope on which `$emit` was called. All
       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
       * notified. Afterwards, the event traverses upwards toward the root scope and calls all
       * registered listeners along the way. The event will stop propagating if one of the listeners
       * cancels it.
       *
       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
       *
       * @param {string} name Event name to emit.
       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
       * @return {Object} Event object (see {@link ng.$rootScope.Scope#$on}).
       */
      $emit: function(name, args) {
        var empty = [],
            namedListeners,
            scope = this,
            stopPropagation = false,
            event = {
              name: name,
              targetScope: scope,
              stopPropagation: function() {stopPropagation = true;},
              preventDefault: function() {
                event.defaultPrevented = true;
              },
              defaultPrevented: false
            },
            listenerArgs = concat([event], arguments, 1),
            i, length;

        do {
          namedListeners = scope.$$listeners[name] || empty;
          event.currentScope = scope;
          for (i = 0, length = namedListeners.length; i < length; i++) {

            // if listeners were deregistered, defragment the array
            if (!namedListeners[i]) {
              namedListeners.splice(i, 1);
              i--;
              length--;
              continue;
            }
            try {
              //allow all listeners attached to the current scope to run
              namedListeners[i].apply(null, listenerArgs);
            } catch (e) {
              $exceptionHandler(e);
            }
          }
          //if any listener on the current scope stops propagation, prevent bubbling
          if (stopPropagation) {
            event.currentScope = null;
            return event;
          }
          //traverse upwards
          scope = scope.$parent;
        } while (scope);

        event.currentScope = null;

        return event;
      },


      /**
       * @ngdoc method
       * @name $rootScope.Scope#$broadcast
       * @kind function
       *
       * @description
       * Dispatches an event `name` downwards to all child scopes (and their children) notifying the
       * registered {@link ng.$rootScope.Scope#$on} listeners.
       *
       * The event life cycle starts at the scope on which `$broadcast` was called. All
       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
       * notified. Afterwards, the event propagates to all direct and indirect scopes of the current
       * scope and calls all registered listeners along the way. The event cannot be canceled.
       *
       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
       *
       * @param {string} name Event name to broadcast.
       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
       * @return {Object} Event object, see {@link ng.$rootScope.Scope#$on}
       */
      $broadcast: function(name, args) {
        var target = this,
            current = target,
            next = target,
            event = {
              name: name,
              targetScope: target,
              preventDefault: function() {
                event.defaultPrevented = true;
              },
              defaultPrevented: false
            };

        if (!target.$$listenerCount[name]) return event;

        var listenerArgs = concat([event], arguments, 1),
            listeners, i, length;

        //down while you can, then up and next sibling or up and next sibling until back at root
        while ((current = next)) {
          event.currentScope = current;
          listeners = current.$$listeners[name] || [];
          for (i = 0, length = listeners.length; i < length; i++) {
            // if listeners were deregistered, defragment the array
            if (!listeners[i]) {
              listeners.splice(i, 1);
              i--;
              length--;
              continue;
            }

            try {
              listeners[i].apply(null, listenerArgs);
            } catch (e) {
              $exceptionHandler(e);
            }
          }

          // Insanity Warning: scope depth-first traversal
          // yes, this code is a bit crazy, but it works and we have tests to prove it!
          // this piece should be kept in sync with the traversal in $digest
          // (though it differs due to having the extra check for $$listenerCount)
          if (!(next = ((current.$$listenerCount[name] && current.$$childHead) ||
              (current !== target && current.$$nextSibling)))) {
            while (current !== target && !(next = current.$$nextSibling)) {
              current = current.$parent;
            }
          }
        }

        event.currentScope = null;
        return event;
      }
    };

    var $rootScope = new Scope();

    //The internal queues. Expose them on the $rootScope for debugging/testing purposes.
    var asyncQueue = $rootScope.$$asyncQueue = [];
    var postDigestQueue = $rootScope.$$postDigestQueue = [];
    var applyAsyncQueue = $rootScope.$$applyAsyncQueue = [];

    var postDigestQueuePosition = 0;

    return $rootScope;


    function beginPhase(phase) {
      if ($rootScope.$$phase) {
        throw $rootScopeMinErr('inprog', '{0} already in progress', $rootScope.$$phase);
      }

      $rootScope.$$phase = phase;
    }

    function clearPhase() {
      $rootScope.$$phase = null;
    }

    function incrementWatchersCount(current, count) {
      do {
        current.$$watchersCount += count;
      } while ((current = current.$parent));
    }

    function decrementListenerCount(current, count, name) {
      do {
        current.$$listenerCount[name] -= count;

        if (current.$$listenerCount[name] === 0) {
          delete current.$$listenerCount[name];
        }
      } while ((current = current.$parent));
    }

    /**
     * function used as an initial value for watchers.
     * because it's unique we can easily tell it apart from other values
     */
    function initWatchVal() {}

    function flushApplyAsync() {
      while (applyAsyncQueue.length) {
        try {
          applyAsyncQueue.shift()();
        } catch (e) {
          $exceptionHandler(e);
        }
      }
      applyAsyncId = null;
    }

    function scheduleApplyAsync() {
      if (applyAsyncId === null) {
        applyAsyncId = $browser.defer(function() {
          $rootScope.$apply(flushApplyAsync);
        });
      }
    }
  }];
}

/**
 * @ngdoc service
 * @name $rootElement
 *
 * @description
 * The root element of Angular application. This is either the element where {@link
 * ng.directive:ngApp ngApp} was declared or the element passed into
 * {@link angular.bootstrap}. The element represents the root element of application. It is also the
 * location where the application's {@link auto.$injector $injector} service gets
 * published, and can be retrieved using `$rootElement.injector()`.
 */


// the implementation is in angular.bootstrap

/**
 * @description
 * Private service to sanitize uris for links and images. Used by $compile and $sanitize.
 */
function $$SanitizeUriProvider() {
  var aHrefSanitizationWhitelist = /^\s*(https?|ftp|mailto|tel|file):/,
    imgSrcSanitizationWhitelist = /^\s*((https?|ftp|file|blob):|data:image\/)/;

  /**
   * @description
   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
   * urls during a[href] sanitization.
   *
   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
   *
   * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
   * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationWhitelist`
   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
   *
   * @param {RegExp=} regexp New regexp to whitelist urls with.
   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
   *    chaining otherwise.
   */
  this.aHrefSanitizationWhitelist = function(regexp) {
    if (isDefined(regexp)) {
      aHrefSanitizationWhitelist = regexp;
      return this;
    }
    return aHrefSanitizationWhitelist;
  };


  /**
   * @description
   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
   * urls during img[src] sanitization.
   *
   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
   *
   * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
   * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationWhitelist`
   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
   *
   * @param {RegExp=} regexp New regexp to whitelist urls with.
   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
   *    chaining otherwise.
   */
  this.imgSrcSanitizationWhitelist = function(regexp) {
    if (isDefined(regexp)) {
      imgSrcSanitizationWhitelist = regexp;
      return this;
    }
    return imgSrcSanitizationWhitelist;
  };

  this.$get = function() {
    return function sanitizeUri(uri, isImage) {
      var regex = isImage ? imgSrcSanitizationWhitelist : aHrefSanitizationWhitelist;
      var normalizedVal;
      normalizedVal = urlResolve(uri).href;
      if (normalizedVal !== '' && !normalizedVal.match(regex)) {
        return 'unsafe:' + normalizedVal;
      }
      return uri;
    };
  };
}

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *     Any commits to this file should be reviewed with security in mind.  *
 *   Changes to this file can potentially create security vulnerabilities. *
 *          An approval from 2 Core members with history of modifying      *
 *                         this file is required.                          *
 *                                                                         *
 *  Does the change somehow allow for arbitrary javascript to be executed? *
 *    Or allows for someone to change the prototype of built-in objects?   *
 *     Or gives undesired access to variables likes document or window?    *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

var $sceMinErr = minErr('$sce');

var SCE_CONTEXTS = {
  HTML: 'html',
  CSS: 'css',
  URL: 'url',
  // RESOURCE_URL is a subtype of URL used in contexts where a privileged resource is sourced from a
  // url.  (e.g. ng-include, script src, templateUrl)
  RESOURCE_URL: 'resourceUrl',
  JS: 'js'
};

// Helper functions follow.

function adjustMatcher(matcher) {
  if (matcher === 'self') {
    return matcher;
  } else if (isString(matcher)) {
    // Strings match exactly except for 2 wildcards - '*' and '**'.
    // '*' matches any character except those from the set ':/.?&'.
    // '**' matches any character (like .* in a RegExp).
    // More than 2 *'s raises an error as it's ill defined.
    if (matcher.indexOf('***') > -1) {
      throw $sceMinErr('iwcard',
          'Illegal sequence *** in string matcher.  String: {0}', matcher);
    }
    matcher = escapeForRegexp(matcher).
                  replace('\\*\\*', '.*').
                  replace('\\*', '[^:/.?&;]*');
    return new RegExp('^' + matcher + '$');
  } else if (isRegExp(matcher)) {
    // The only other type of matcher allowed is a Regexp.
    // Match entire URL / disallow partial matches.
    // Flags are reset (i.e. no global, ignoreCase or multiline)
    return new RegExp('^' + matcher.source + '$');
  } else {
    throw $sceMinErr('imatcher',
        'Matchers may only be "self", string patterns or RegExp objects');
  }
}


function adjustMatchers(matchers) {
  var adjustedMatchers = [];
  if (isDefined(matchers)) {
    forEach(matchers, function(matcher) {
      adjustedMatchers.push(adjustMatcher(matcher));
    });
  }
  return adjustedMatchers;
}


/**
 * @ngdoc service
 * @name $sceDelegate
 * @kind function
 *
 * @description
 *
 * `$sceDelegate` is a service that is used by the `$sce` service to provide {@link ng.$sce Strict
 * Contextual Escaping (SCE)} services to AngularJS.
 *
 * Typically, you would configure or override the {@link ng.$sceDelegate $sceDelegate} instead of
 * the `$sce` service to customize the way Strict Contextual Escaping works in AngularJS.  This is
 * because, while the `$sce` provides numerous shorthand methods, etc., you really only need to
 * override 3 core functions (`trustAs`, `getTrusted` and `valueOf`) to replace the way things
 * work because `$sce` delegates to `$sceDelegate` for these operations.
 *
 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} to configure this service.
 *
 * The default instance of `$sceDelegate` should work out of the box with little pain.  While you
 * can override it completely to change the behavior of `$sce`, the common case would
 * involve configuring the {@link ng.$sceDelegateProvider $sceDelegateProvider} instead by setting
 * your own whitelists and blacklists for trusting URLs used for loading AngularJS resources such as
 * templates.  Refer {@link ng.$sceDelegateProvider#resourceUrlWhitelist
 * $sceDelegateProvider.resourceUrlWhitelist} and {@link
 * ng.$sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider.resourceUrlBlacklist}
 */

/**
 * @ngdoc provider
 * @name $sceDelegateProvider
 * @description
 *
 * The `$sceDelegateProvider` provider allows developers to configure the {@link ng.$sceDelegate
 * $sceDelegate} service.  This allows one to get/set the whitelists and blacklists used to ensure
 * that the URLs used for sourcing Angular templates are safe.  Refer {@link
 * ng.$sceDelegateProvider#resourceUrlWhitelist $sceDelegateProvider.resourceUrlWhitelist} and
 * {@link ng.$sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider.resourceUrlBlacklist}
 *
 * For the general details about this service in Angular, read the main page for {@link ng.$sce
 * Strict Contextual Escaping (SCE)}.
 *
 * **Example**:  Consider the following case. <a name="example"></a>
 *
 * - your app is hosted at url `http://myapp.example.com/`
 * - but some of your templates are hosted on other domains you control such as
 *   `http://srv01.assets.example.com/`,  `http://srv02.assets.example.com/`, etc.
 * - and you have an open redirect at `http://myapp.example.com/clickThru?...`.
 *
 * Here is what a secure configuration for this scenario might look like:
 *
 * ```
 *  angular.module('myApp', []).config(function($sceDelegateProvider) {
 *    $sceDelegateProvider.resourceUrlWhitelist([
 *      // Allow same origin resource loads.
 *      'self',
 *      // Allow loading from our assets domain.  Notice the difference between * and **.
 *      'http://srv*.assets.example.com/**'
 *    ]);
 *
 *    // The blacklist overrides the whitelist so the open redirect here is blocked.
 *    $sceDelegateProvider.resourceUrlBlacklist([
 *      'http://myapp.example.com/clickThru**'
 *    ]);
 *  });
 * ```
 */

function $SceDelegateProvider() {
  this.SCE_CONTEXTS = SCE_CONTEXTS;

  // Resource URLs can also be trusted by policy.
  var resourceUrlWhitelist = ['self'],
      resourceUrlBlacklist = [];

  /**
   * @ngdoc method
   * @name $sceDelegateProvider#resourceUrlWhitelist
   * @kind function
   *
   * @param {Array=} whitelist When provided, replaces the resourceUrlWhitelist with the value
   *    provided.  This must be an array or null.  A snapshot of this array is used so further
   *    changes to the array are ignored.
   *
   *    Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
   *    allowed in this array.
   *
   *    <div class="alert alert-warning">
   *    **Note:** an empty whitelist array will block all URLs!
   *    </div>
   *
   * @return {Array} the currently set whitelist array.
   *
   * The **default value** when no whitelist has been explicitly set is `['self']` allowing only
   * same origin resource requests.
   *
   * @description
   * Sets/Gets the whitelist of trusted resource URLs.
   */
  this.resourceUrlWhitelist = function(value) {
    if (arguments.length) {
      resourceUrlWhitelist = adjustMatchers(value);
    }
    return resourceUrlWhitelist;
  };

  /**
   * @ngdoc method
   * @name $sceDelegateProvider#resourceUrlBlacklist
   * @kind function
   *
   * @param {Array=} blacklist When provided, replaces the resourceUrlBlacklist with the value
   *    provided.  This must be an array or null.  A snapshot of this array is used so further
   *    changes to the array are ignored.
   *
   *    Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
   *    allowed in this array.
   *
   *    The typical usage for the blacklist is to **block
   *    [open redirects](http://cwe.mitre.org/data/definitions/601.html)** served by your domain as
   *    these would otherwise be trusted but actually return content from the redirected domain.
   *
   *    Finally, **the blacklist overrides the whitelist** and has the final say.
   *
   * @return {Array} the currently set blacklist array.
   *
   * The **default value** when no whitelist has been explicitly set is the empty array (i.e. there
   * is no blacklist.)
   *
   * @description
   * Sets/Gets the blacklist of trusted resource URLs.
   */

  this.resourceUrlBlacklist = function(value) {
    if (arguments.length) {
      resourceUrlBlacklist = adjustMatchers(value);
    }
    return resourceUrlBlacklist;
  };

  this.$get = ['$injector', function($injector) {

    var htmlSanitizer = function htmlSanitizer(html) {
      throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
    };

    if ($injector.has('$sanitize')) {
      htmlSanitizer = $injector.get('$sanitize');
    }


    function matchUrl(matcher, parsedUrl) {
      if (matcher === 'self') {
        return urlIsSameOrigin(parsedUrl);
      } else {
        // definitely a regex.  See adjustMatchers()
        return !!matcher.exec(parsedUrl.href);
      }
    }

    function isResourceUrlAllowedByPolicy(url) {
      var parsedUrl = urlResolve(url.toString());
      var i, n, allowed = false;
      // Ensure that at least one item from the whitelist allows this url.
      for (i = 0, n = resourceUrlWhitelist.length; i < n; i++) {
        if (matchUrl(resourceUrlWhitelist[i], parsedUrl)) {
          allowed = true;
          break;
        }
      }
      if (allowed) {
        // Ensure that no item from the blacklist blocked this url.
        for (i = 0, n = resourceUrlBlacklist.length; i < n; i++) {
          if (matchUrl(resourceUrlBlacklist[i], parsedUrl)) {
            allowed = false;
            break;
          }
        }
      }
      return allowed;
    }

    function generateHolderType(Base) {
      var holderType = function TrustedValueHolderType(trustedValue) {
        this.$$unwrapTrustedValue = function() {
          return trustedValue;
        };
      };
      if (Base) {
        holderType.prototype = new Base();
      }
      holderType.prototype.valueOf = function sceValueOf() {
        return this.$$unwrapTrustedValue();
      };
      holderType.prototype.toString = function sceToString() {
        return this.$$unwrapTrustedValue().toString();
      };
      return holderType;
    }

    var trustedValueHolderBase = generateHolderType(),
        byType = {};

    byType[SCE_CONTEXTS.HTML] = generateHolderType(trustedValueHolderBase);
    byType[SCE_CONTEXTS.CSS] = generateHolderType(trustedValueHolderBase);
    byType[SCE_CONTEXTS.URL] = generateHolderType(trustedValueHolderBase);
    byType[SCE_CONTEXTS.JS] = generateHolderType(trustedValueHolderBase);
    byType[SCE_CONTEXTS.RESOURCE_URL] = generateHolderType(byType[SCE_CONTEXTS.URL]);

    /**
     * @ngdoc method
     * @name $sceDelegate#trustAs
     *
     * @description
     * Returns an object that is trusted by angular for use in specified strict
     * contextual escaping contexts (such as ng-bind-html, ng-include, any src
     * attribute interpolation, any dom event binding attribute interpolation
     * such as for onclick,  etc.) that uses the provided value.
     * See {@link ng.$sce $sce} for enabling strict contextual escaping.
     *
     * @param {string} type The kind of context in which this value is safe for use.  e.g. url,
     *   resourceUrl, html, js and css.
     * @param {*} value The value that that should be considered trusted/safe.
     * @returns {*} A value that can be used to stand in for the provided `value` in places
     * where Angular expects a $sce.trustAs() return value.
     */
    function trustAs(type, trustedValue) {
      var Constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
      if (!Constructor) {
        throw $sceMinErr('icontext',
            'Attempted to trust a value in invalid context. Context: {0}; Value: {1}',
            type, trustedValue);
      }
      if (trustedValue === null || isUndefined(trustedValue) || trustedValue === '') {
        return trustedValue;
      }
      // All the current contexts in SCE_CONTEXTS happen to be strings.  In order to avoid trusting
      // mutable objects, we ensure here that the value passed in is actually a string.
      if (typeof trustedValue !== 'string') {
        throw $sceMinErr('itype',
            'Attempted to trust a non-string value in a content requiring a string: Context: {0}',
            type);
      }
      return new Constructor(trustedValue);
    }

    /**
     * @ngdoc method
     * @name $sceDelegate#valueOf
     *
     * @description
     * If the passed parameter had been returned by a prior call to {@link ng.$sceDelegate#trustAs
     * `$sceDelegate.trustAs`}, returns the value that had been passed to {@link
     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}.
     *
     * If the passed parameter is not a value that had been returned by {@link
     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}, returns it as-is.
     *
     * @param {*} value The result of a prior {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}
     *      call or anything else.
     * @returns {*} The `value` that was originally provided to {@link ng.$sceDelegate#trustAs
     *     `$sceDelegate.trustAs`} if `value` is the result of such a call.  Otherwise, returns
     *     `value` unchanged.
     */
    function valueOf(maybeTrusted) {
      if (maybeTrusted instanceof trustedValueHolderBase) {
        return maybeTrusted.$$unwrapTrustedValue();
      } else {
        return maybeTrusted;
      }
    }

    /**
     * @ngdoc method
     * @name $sceDelegate#getTrusted
     *
     * @description
     * Takes the result of a {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`} call and
     * returns the originally supplied value if the queried context type is a supertype of the
     * created type.  If this condition isn't satisfied, throws an exception.
     *
     * <div class="alert alert-danger">
     * Disabling auto-escaping is extremely dangerous, it usually creates a Cross Site Scripting
     * (XSS) vulnerability in your application.
     * </div>
     *
     * @param {string} type The kind of context in which this value is to be used.
     * @param {*} maybeTrusted The result of a prior {@link ng.$sceDelegate#trustAs
     *     `$sceDelegate.trustAs`} call.
     * @returns {*} The value the was originally provided to {@link ng.$sceDelegate#trustAs
     *     `$sceDelegate.trustAs`} if valid in this context.  Otherwise, throws an exception.
     */
    function getTrusted(type, maybeTrusted) {
      if (maybeTrusted === null || isUndefined(maybeTrusted) || maybeTrusted === '') {
        return maybeTrusted;
      }
      var constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
      if (constructor && maybeTrusted instanceof constructor) {
        return maybeTrusted.$$unwrapTrustedValue();
      }
      // If we get here, then we may only take one of two actions.
      // 1. sanitize the value for the requested type, or
      // 2. throw an exception.
      if (type === SCE_CONTEXTS.RESOURCE_URL) {
        if (isResourceUrlAllowedByPolicy(maybeTrusted)) {
          return maybeTrusted;
        } else {
          throw $sceMinErr('insecurl',
              'Blocked loading resource from url not allowed by $sceDelegate policy.  URL: {0}',
              maybeTrusted.toString());
        }
      } else if (type === SCE_CONTEXTS.HTML) {
        return htmlSanitizer(maybeTrusted);
      }
      throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
    }

    return { trustAs: trustAs,
             getTrusted: getTrusted,
             valueOf: valueOf };
  }];
}


/**
 * @ngdoc provider
 * @name $sceProvider
 * @description
 *
 * The $sceProvider provider allows developers to configure the {@link ng.$sce $sce} service.
 * -   enable/disable Strict Contextual Escaping (SCE) in a module
 * -   override the default implementation with a custom delegate
 *
 * Read more about {@link ng.$sce Strict Contextual Escaping (SCE)}.
 */

/* jshint maxlen: false*/

/**
 * @ngdoc service
 * @name $sce
 * @kind function
 *
 * @description
 *
 * `$sce` is a service that provides Strict Contextual Escaping services to AngularJS.
 *
 * # Strict Contextual Escaping
 *
 * Strict Contextual Escaping (SCE) is a mode in which AngularJS requires bindings in certain
 * contexts to result in a value that is marked as safe to use for that context.  One example of
 * such a context is binding arbitrary html controlled by the user via `ng-bind-html`.  We refer
 * to these contexts as privileged or SCE contexts.
 *
 * As of version 1.2, Angular ships with SCE enabled by default.
 *
 * Note:  When enabled (the default), IE<11 in quirks mode is not supported.  In this mode, IE<11 allow
 * one to execute arbitrary javascript by the use of the expression() syntax.  Refer
 * <http://blogs.msdn.com/b/ie/archive/2008/10/16/ending-expressions.aspx> to learn more about them.
 * You can ensure your document is in standards mode and not quirks mode by adding `<!doctype html>`
 * to the top of your HTML document.
 *
 * SCE assists in writing code in a way that (a) is secure by default and (b) makes auditing for
 * security vulnerabilities such as XSS, clickjacking, etc. a lot easier.
 *
 * Here's an example of a binding in a privileged context:
 *
 * ```
 * <input ng-model="userHtml" aria-label="User input">
 * <div ng-bind-html="userHtml"></div>
 * ```
 *
 * Notice that `ng-bind-html` is bound to `userHtml` controlled by the user.  With SCE
 * disabled, this application allows the user to render arbitrary HTML into the DIV.
 * In a more realistic example, one may be rendering user comments, blog articles, etc. via
 * bindings.  (HTML is just one example of a context where rendering user controlled input creates
 * security vulnerabilities.)
 *
 * For the case of HTML, you might use a library, either on the client side, or on the server side,
 * to sanitize unsafe HTML before binding to the value and rendering it in the document.
 *
 * How would you ensure that every place that used these types of bindings was bound to a value that
 * was sanitized by your library (or returned as safe for rendering by your server?)  How can you
 * ensure that you didn't accidentally delete the line that sanitized the value, or renamed some
 * properties/fields and forgot to update the binding to the sanitized value?
 *
 * To be secure by default, you want to ensure that any such bindings are disallowed unless you can
 * determine that something explicitly says it's safe to use a value for binding in that
 * context.  You can then audit your code (a simple grep would do) to ensure that this is only done
 * for those values that you can easily tell are safe - because they were received from your server,
 * sanitized by your library, etc.  You can organize your codebase to help with this - perhaps
 * allowing only the files in a specific directory to do this.  Ensuring that the internal API
 * exposed by that code doesn't markup arbitrary values as safe then becomes a more manageable task.
 *
 * In the case of AngularJS' SCE service, one uses {@link ng.$sce#trustAs $sce.trustAs}
 * (and shorthand methods such as {@link ng.$sce#trustAsHtml $sce.trustAsHtml}, etc.) to
 * obtain values that will be accepted by SCE / privileged contexts.
 *
 *
 * ## How does it work?
 *
 * In privileged contexts, directives and code will bind to the result of {@link ng.$sce#getTrusted
 * $sce.getTrusted(context, value)} rather than to the value directly.  Directives use {@link
 * ng.$sce#parseAs $sce.parseAs} rather than `$parse` to watch attribute bindings, which performs the
 * {@link ng.$sce#getTrusted $sce.getTrusted} behind the scenes on non-constant literals.
 *
 * As an example, {@link ng.directive:ngBindHtml ngBindHtml} uses {@link
 * ng.$sce#parseAsHtml $sce.parseAsHtml(binding expression)}.  Here's the actual code (slightly
 * simplified):
 *
 * ```
 * var ngBindHtmlDirective = ['$sce', function($sce) {
 *   return function(scope, element, attr) {
 *     scope.$watch($sce.parseAsHtml(attr.ngBindHtml), function(value) {
 *       element.html(value || '');
 *     });
 *   };
 * }];
 * ```
 *
 * ## Impact on loading templates
 *
 * This applies both to the {@link ng.directive:ngInclude `ng-include`} directive as well as
 * `templateUrl`'s specified by {@link guide/directive directives}.
 *
 * By default, Angular only loads templates from the same domain and protocol as the application
 * document.  This is done by calling {@link ng.$sce#getTrustedResourceUrl
 * $sce.getTrustedResourceUrl} on the template URL.  To load templates from other domains and/or
 * protocols, you may either {@link ng.$sceDelegateProvider#resourceUrlWhitelist whitelist
 * them} or {@link ng.$sce#trustAsResourceUrl wrap it} into a trusted value.
 *
 * *Please note*:
 * The browser's
 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
 * policy apply in addition to this and may further restrict whether the template is successfully
 * loaded.  This means that without the right CORS policy, loading templates from a different domain
 * won't work on all browsers.  Also, loading templates from `file://` URL does not work on some
 * browsers.
 *
 * ## This feels like too much overhead
 *
 * It's important to remember that SCE only applies to interpolation expressions.
 *
 * If your expressions are constant literals, they're automatically trusted and you don't need to
 * call `$sce.trustAs` on them (remember to include the `ngSanitize` module) (e.g.
 * `<div ng-bind-html="'<b>implicitly trusted</b>'"></div>`) just works.
 *
 * Additionally, `a[href]` and `img[src]` automatically sanitize their URLs and do not pass them
 * through {@link ng.$sce#getTrusted $sce.getTrusted}.  SCE doesn't play a role here.
 *
 * The included {@link ng.$sceDelegate $sceDelegate} comes with sane defaults to allow you to load
 * templates in `ng-include` from your application's domain without having to even know about SCE.
 * It blocks loading templates from other domains or loading templates over http from an https
 * served document.  You can change these by setting your own custom {@link
 * ng.$sceDelegateProvider#resourceUrlWhitelist whitelists} and {@link
 * ng.$sceDelegateProvider#resourceUrlBlacklist blacklists} for matching such URLs.
 *
 * This significantly reduces the overhead.  It is far easier to pay the small overhead and have an
 * application that's secure and can be audited to verify that with much more ease than bolting
 * security onto an application later.
 *
 * <a name="contexts"></a>
 * ## What trusted context types are supported?
 *
 * | Context             | Notes          |
 * |---------------------|----------------|
 * | `$sce.HTML`         | For HTML that's safe to source into the application.  The {@link ng.directive:ngBindHtml ngBindHtml} directive uses this context for bindings. If an unsafe value is encountered and the {@link ngSanitize $sanitize} module is present this will sanitize the value instead of throwing an error. |
 * | `$sce.CSS`          | For CSS that's safe to source into the application.  Currently unused.  Feel free to use it in your own directives. |
 * | `$sce.URL`          | For URLs that are safe to follow as links.  Currently unused (`<a href=` and `<img src=` sanitize their urls and don't constitute an SCE context. |
 * | `$sce.RESOURCE_URL` | For URLs that are not only safe to follow as links, but whose contents are also safe to include in your application.  Examples include `ng-include`, `src` / `ngSrc` bindings for tags other than `IMG` (e.g. `IFRAME`, `OBJECT`, etc.)  <br><br>Note that `$sce.RESOURCE_URL` makes a stronger statement about the URL than `$sce.URL` does and therefore contexts requiring values trusted for `$sce.RESOURCE_URL` can be used anywhere that values trusted for `$sce.URL` are required. |
 * | `$sce.JS`           | For JavaScript that is safe to execute in your application's context.  Currently unused.  Feel free to use it in your own directives. |
 *
 * ## Format of items in {@link ng.$sceDelegateProvider#resourceUrlWhitelist resourceUrlWhitelist}/{@link ng.$sceDelegateProvider#resourceUrlBlacklist Blacklist} <a name="resourceUrlPatternItem"></a>
 *
 *  Each element in these arrays must be one of the following:
 *
 *  - **'self'**
 *    - The special **string**, `'self'`, can be used to match against all URLs of the **same
 *      domain** as the application document using the **same protocol**.
 *  - **String** (except the special value `'self'`)
 *    - The string is matched against the full *normalized / absolute URL* of the resource
 *      being tested (substring matches are not good enough.)
 *    - There are exactly **two wildcard sequences** - `*` and `**`.  All other characters
 *      match themselves.
 *    - `*`: matches zero or more occurrences of any character other than one of the following 6
 *      characters: '`:`', '`/`', '`.`', '`?`', '`&`' and '`;`'.  It's a useful wildcard for use
 *      in a whitelist.
 *    - `**`: matches zero or more occurrences of *any* character.  As such, it's not
 *      appropriate for use in a scheme, domain, etc. as it would match too much.  (e.g.
 *      http://**.example.com/ would match http://evil.com/?ignore=.example.com/ and that might
 *      not have been the intention.)  Its usage at the very end of the path is ok.  (e.g.
 *      http://foo.example.com/templates/**).
 *  - **RegExp** (*see caveat below*)
 *    - *Caveat*:  While regular expressions are powerful and offer great flexibility,  their syntax
 *      (and all the inevitable escaping) makes them *harder to maintain*.  It's easy to
 *      accidentally introduce a bug when one updates a complex expression (imho, all regexes should
 *      have good test coverage).  For instance, the use of `.` in the regex is correct only in a
 *      small number of cases.  A `.` character in the regex used when matching the scheme or a
 *      subdomain could be matched against a `:` or literal `.` that was likely not intended.   It
 *      is highly recommended to use the string patterns and only fall back to regular expressions
 *      as a last resort.
 *    - The regular expression must be an instance of RegExp (i.e. not a string.)  It is
 *      matched against the **entire** *normalized / absolute URL* of the resource being tested
 *      (even when the RegExp did not have the `^` and `$` codes.)  In addition, any flags
 *      present on the RegExp (such as multiline, global, ignoreCase) are ignored.
 *    - If you are generating your JavaScript from some other templating engine (not
 *      recommended, e.g. in issue [#4006](https://github.com/angular/angular.js/issues/4006)),
 *      remember to escape your regular expression (and be aware that you might need more than
 *      one level of escaping depending on your templating engine and the way you interpolated
 *      the value.)  Do make use of your platform's escaping mechanism as it might be good
 *      enough before coding your own.  E.g. Ruby has
 *      [Regexp.escape(str)](http://www.ruby-doc.org/core-2.0.0/Regexp.html#method-c-escape)
 *      and Python has [re.escape](http://docs.python.org/library/re.html#re.escape).
 *      Javascript lacks a similar built in function for escaping.  Take a look at Google
 *      Closure library's [goog.string.regExpEscape(s)](
 *      http://docs.closure-library.googlecode.com/git/closure_goog_string_string.js.source.html#line962).
 *
 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} for an example.
 *
 * ## Show me an example using SCE.
 *
 * <example module="mySceApp" deps="angular-sanitize.js">
 * <file name="index.html">
 *   <div ng-controller="AppController as myCtrl">
 *     <i ng-bind-html="myCtrl.explicitlyTrustedHtml" id="explicitlyTrustedHtml"></i><br><br>
 *     <b>User comments</b><br>
 *     By default, HTML that isn't explicitly trusted (e.g. Alice's comment) is sanitized when
 *     $sanitize is available.  If $sanitize isn't available, this results in an error instead of an
 *     exploit.
 *     <div class="well">
 *       <div ng-repeat="userComment in myCtrl.userComments">
 *         <b>{{userComment.name}}</b>:
 *         <span ng-bind-html="userComment.htmlComment" class="htmlComment"></span>
 *         <br>
 *       </div>
 *     </div>
 *   </div>
 * </file>
 *
 * <file name="script.js">
 *   angular.module('mySceApp', ['ngSanitize'])
 *     .controller('AppController', ['$http', '$templateCache', '$sce',
 *       function($http, $templateCache, $sce) {
 *         var self = this;
 *         $http.get("test_data.json", {cache: $templateCache}).success(function(userComments) {
 *           self.userComments = userComments;
 *         });
 *         self.explicitlyTrustedHtml = $sce.trustAsHtml(
 *             '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
 *             'sanitization.&quot;">Hover over this text.</span>');
 *       }]);
 * </file>
 *
 * <file name="test_data.json">
 * [
 *   { "name": "Alice",
 *     "htmlComment":
 *         "<span onmouseover='this.textContent=\"PWN3D!\"'>Is <i>anyone</i> reading this?</span>"
 *   },
 *   { "name": "Bob",
 *     "htmlComment": "<i>Yes!</i>  Am I the only other one?"
 *   }
 * ]
 * </file>
 *
 * <file name="protractor.js" type="protractor">
 *   describe('SCE doc demo', function() {
 *     it('should sanitize untrusted values', function() {
 *       expect(element.all(by.css('.htmlComment')).first().getInnerHtml())
 *           .toBe('<span>Is <i>anyone</i> reading this?</span>');
 *     });
 *
 *     it('should NOT sanitize explicitly trusted values', function() {
 *       expect(element(by.id('explicitlyTrustedHtml')).getInnerHtml()).toBe(
 *           '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
 *           'sanitization.&quot;">Hover over this text.</span>');
 *     });
 *   });
 * </file>
 * </example>
 *
 *
 *
 * ## Can I disable SCE completely?
 *
 * Yes, you can.  However, this is strongly discouraged.  SCE gives you a lot of security benefits
 * for little coding overhead.  It will be much harder to take an SCE disabled application and
 * either secure it on your own or enable SCE at a later stage.  It might make sense to disable SCE
 * for cases where you have a lot of existing code that was written before SCE was introduced and
 * you're migrating them a module at a time.
 *
 * That said, here's how you can completely disable SCE:
 *
 * ```
 * angular.module('myAppWithSceDisabledmyApp', []).config(function($sceProvider) {
 *   // Completely disable SCE.  For demonstration purposes only!
 *   // Do not use in new projects.
 *   $sceProvider.enabled(false);
 * });
 * ```
 *
 */
/* jshint maxlen: 100 */

function $SceProvider() {
  var enabled = true;

  /**
   * @ngdoc method
   * @name $sceProvider#enabled
   * @kind function
   *
   * @param {boolean=} value If provided, then enables/disables SCE.
   * @return {boolean} true if SCE is enabled, false otherwise.
   *
   * @description
   * Enables/disables SCE and returns the current value.
   */
  this.enabled = function(value) {
    if (arguments.length) {
      enabled = !!value;
    }
    return enabled;
  };


  /* Design notes on the default implementation for SCE.
   *
   * The API contract for the SCE delegate
   * -------------------------------------
   * The SCE delegate object must provide the following 3 methods:
   *
   * - trustAs(contextEnum, value)
   *     This method is used to tell the SCE service that the provided value is OK to use in the
   *     contexts specified by contextEnum.  It must return an object that will be accepted by
   *     getTrusted() for a compatible contextEnum and return this value.
   *
   * - valueOf(value)
   *     For values that were not produced by trustAs(), return them as is.  For values that were
   *     produced by trustAs(), return the corresponding input value to trustAs.  Basically, if
   *     trustAs is wrapping the given values into some type, this operation unwraps it when given
   *     such a value.
   *
   * - getTrusted(contextEnum, value)
   *     This function should return the a value that is safe to use in the context specified by
   *     contextEnum or throw and exception otherwise.
   *
   * NOTE: This contract deliberately does NOT state that values returned by trustAs() must be
   * opaque or wrapped in some holder object.  That happens to be an implementation detail.  For
   * instance, an implementation could maintain a registry of all trusted objects by context.  In
   * such a case, trustAs() would return the same object that was passed in.  getTrusted() would
   * return the same object passed in if it was found in the registry under a compatible context or
   * throw an exception otherwise.  An implementation might only wrap values some of the time based
   * on some criteria.  getTrusted() might return a value and not throw an exception for special
   * constants or objects even if not wrapped.  All such implementations fulfill this contract.
   *
   *
   * A note on the inheritance model for SCE contexts
   * ------------------------------------------------
   * I've used inheritance and made RESOURCE_URL wrapped types a subtype of URL wrapped types.  This
   * is purely an implementation details.
   *
   * The contract is simply this:
   *
   *     getTrusted($sce.RESOURCE_URL, value) succeeding implies that getTrusted($sce.URL, value)
   *     will also succeed.
   *
   * Inheritance happens to capture this in a natural way.  In some future, we
   * may not use inheritance anymore.  That is OK because no code outside of
   * sce.js and sceSpecs.js would need to be aware of this detail.
   */

  this.$get = ['$parse', '$sceDelegate', function(
                $parse,   $sceDelegate) {
    // Prereq: Ensure that we're not running in IE<11 quirks mode.  In that mode, IE < 11 allow
    // the "expression(javascript expression)" syntax which is insecure.
    if (enabled && msie < 8) {
      throw $sceMinErr('iequirks',
        'Strict Contextual Escaping does not support Internet Explorer version < 11 in quirks ' +
        'mode.  You can fix this by adding the text <!doctype html> to the top of your HTML ' +
        'document.  See http://docs.angularjs.org/api/ng.$sce for more information.');
    }

    var sce = shallowCopy(SCE_CONTEXTS);

    /**
     * @ngdoc method
     * @name $sce#isEnabled
     * @kind function
     *
     * @return {Boolean} true if SCE is enabled, false otherwise.  If you want to set the value, you
     * have to do it at module config time on {@link ng.$sceProvider $sceProvider}.
     *
     * @description
     * Returns a boolean indicating if SCE is enabled.
     */
    sce.isEnabled = function() {
      return enabled;
    };
    sce.trustAs = $sceDelegate.trustAs;
    sce.getTrusted = $sceDelegate.getTrusted;
    sce.valueOf = $sceDelegate.valueOf;

    if (!enabled) {
      sce.trustAs = sce.getTrusted = function(type, value) { return value; };
      sce.valueOf = identity;
    }

    /**
     * @ngdoc method
     * @name $sce#parseAs
     *
     * @description
     * Converts Angular {@link guide/expression expression} into a function.  This is like {@link
     * ng.$parse $parse} and is identical when the expression is a literal constant.  Otherwise, it
     * wraps the expression in a call to {@link ng.$sce#getTrusted $sce.getTrusted(*type*,
     * *result*)}
     *
     * @param {string} type The kind of SCE context in which this result will be used.
     * @param {string} expression String expression to compile.
     * @returns {function(context, locals)} a function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
     *      are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
     *      `context`.
     */
    sce.parseAs = function sceParseAs(type, expr) {
      var parsed = $parse(expr);
      if (parsed.literal && parsed.constant) {
        return parsed;
      } else {
        return $parse(expr, function(value) {
          return sce.getTrusted(type, value);
        });
      }
    };

    /**
     * @ngdoc method
     * @name $sce#trustAs
     *
     * @description
     * Delegates to {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}.  As such,
     * returns an object that is trusted by angular for use in specified strict contextual
     * escaping contexts (such as ng-bind-html, ng-include, any src attribute
     * interpolation, any dom event binding attribute interpolation such as for onclick,  etc.)
     * that uses the provided value.  See * {@link ng.$sce $sce} for enabling strict contextual
     * escaping.
     *
     * @param {string} type The kind of context in which this value is safe for use.  e.g. url,
     *   resourceUrl, html, js and css.
     * @param {*} value The value that that should be considered trusted/safe.
     * @returns {*} A value that can be used to stand in for the provided `value` in places
     * where Angular expects a $sce.trustAs() return value.
     */

    /**
     * @ngdoc method
     * @name $sce#trustAsHtml
     *
     * @description
     * Shorthand method.  `$sce.trustAsHtml(value)` →
     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.HTML, value)`}
     *
     * @param {*} value The value to trustAs.
     * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedHtml
     *     $sce.getTrustedHtml(value)} to obtain the original value.  (privileged directives
     *     only accept expressions that are either literal constants or are the
     *     return value of {@link ng.$sce#trustAs $sce.trustAs}.)
     */

    /**
     * @ngdoc method
     * @name $sce#trustAsUrl
     *
     * @description
     * Shorthand method.  `$sce.trustAsUrl(value)` →
     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.URL, value)`}
     *
     * @param {*} value The value to trustAs.
     * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedUrl
     *     $sce.getTrustedUrl(value)} to obtain the original value.  (privileged directives
     *     only accept expressions that are either literal constants or are the
     *     return value of {@link ng.$sce#trustAs $sce.trustAs}.)
     */

    /**
     * @ngdoc method
     * @name $sce#trustAsResourceUrl
     *
     * @description
     * Shorthand method.  `$sce.trustAsResourceUrl(value)` →
     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.RESOURCE_URL, value)`}
     *
     * @param {*} value The value to trustAs.
     * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedResourceUrl
     *     $sce.getTrustedResourceUrl(value)} to obtain the original value.  (privileged directives
     *     only accept expressions that are either literal constants or are the return
     *     value of {@link ng.$sce#trustAs $sce.trustAs}.)
     */

    /**
     * @ngdoc method
     * @name $sce#trustAsJs
     *
     * @description
     * Shorthand method.  `$sce.trustAsJs(value)` →
     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.JS, value)`}
     *
     * @param {*} value The value to trustAs.
     * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedJs
     *     $sce.getTrustedJs(value)} to obtain the original value.  (privileged directives
     *     only accept expressions that are either literal constants or are the
     *     return value of {@link ng.$sce#trustAs $sce.trustAs}.)
     */

    /**
     * @ngdoc method
     * @name $sce#getTrusted
     *
     * @description
     * Delegates to {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted`}.  As such,
     * takes the result of a {@link ng.$sce#trustAs `$sce.trustAs`}() call and returns the
     * originally supplied value if the queried context type is a supertype of the created type.
     * If this condition isn't satisfied, throws an exception.
     *
     * @param {string} type The kind of context in which this value is to be used.
     * @param {*} maybeTrusted The result of a prior {@link ng.$sce#trustAs `$sce.trustAs`}
     *                         call.
     * @returns {*} The value the was originally provided to
     *              {@link ng.$sce#trustAs `$sce.trustAs`} if valid in this context.
     *              Otherwise, throws an exception.
     */

    /**
     * @ngdoc method
     * @name $sce#getTrustedHtml
     *
     * @description
     * Shorthand method.  `$sce.getTrustedHtml(value)` →
     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.HTML, value)`}
     *
     * @param {*} value The value to pass to `$sce.getTrusted`.
     * @returns {*} The return value of `$sce.getTrusted($sce.HTML, value)`
     */

    /**
     * @ngdoc method
     * @name $sce#getTrustedCss
     *
     * @description
     * Shorthand method.  `$sce.getTrustedCss(value)` →
     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.CSS, value)`}
     *
     * @param {*} value The value to pass to `$sce.getTrusted`.
     * @returns {*} The return value of `$sce.getTrusted($sce.CSS, value)`
     */

    /**
     * @ngdoc method
     * @name $sce#getTrustedUrl
     *
     * @description
     * Shorthand method.  `$sce.getTrustedUrl(value)` →
     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.URL, value)`}
     *
     * @param {*} value The value to pass to `$sce.getTrusted`.
     * @returns {*} The return value of `$sce.getTrusted($sce.URL, value)`
     */

    /**
     * @ngdoc method
     * @name $sce#getTrustedResourceUrl
     *
     * @description
     * Shorthand method.  `$sce.getTrustedResourceUrl(value)` →
     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.RESOURCE_URL, value)`}
     *
     * @param {*} value The value to pass to `$sceDelegate.getTrusted`.
     * @returns {*} The return value of `$sce.getTrusted($sce.RESOURCE_URL, value)`
     */

    /**
     * @ngdoc method
     * @name $sce#getTrustedJs
     *
     * @description
     * Shorthand method.  `$sce.getTrustedJs(value)` →
     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.JS, value)`}
     *
     * @param {*} value The value to pass to `$sce.getTrusted`.
     * @returns {*} The return value of `$sce.getTrusted($sce.JS, value)`
     */

    /**
     * @ngdoc method
     * @name $sce#parseAsHtml
     *
     * @description
     * Shorthand method.  `$sce.parseAsHtml(expression string)` →
     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.HTML, value)`}
     *
     * @param {string} expression String expression to compile.
     * @returns {function(context, locals)} a function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
     *      are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
     *      `context`.
     */

    /**
     * @ngdoc method
     * @name $sce#parseAsCss
     *
     * @description
     * Shorthand method.  `$sce.parseAsCss(value)` →
     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.CSS, value)`}
     *
     * @param {string} expression String expression to compile.
     * @returns {function(context, locals)} a function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
     *      are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
     *      `context`.
     */

    /**
     * @ngdoc method
     * @name $sce#parseAsUrl
     *
     * @description
     * Shorthand method.  `$sce.parseAsUrl(value)` →
     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.URL, value)`}
     *
     * @param {string} expression String expression to compile.
     * @returns {function(context, locals)} a function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
     *      are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
     *      `context`.
     */

    /**
     * @ngdoc method
     * @name $sce#parseAsResourceUrl
     *
     * @description
     * Shorthand method.  `$sce.parseAsResourceUrl(value)` →
     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.RESOURCE_URL, value)`}
     *
     * @param {string} expression String expression to compile.
     * @returns {function(context, locals)} a function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
     *      are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
     *      `context`.
     */

    /**
     * @ngdoc method
     * @name $sce#parseAsJs
     *
     * @description
     * Shorthand method.  `$sce.parseAsJs(value)` →
     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.JS, value)`}
     *
     * @param {string} expression String expression to compile.
     * @returns {function(context, locals)} a function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
     *      are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
     *      `context`.
     */

    // Shorthand delegations.
    var parse = sce.parseAs,
        getTrusted = sce.getTrusted,
        trustAs = sce.trustAs;

    forEach(SCE_CONTEXTS, function(enumValue, name) {
      var lName = lowercase(name);
      sce[camelCase("parse_as_" + lName)] = function(expr) {
        return parse(enumValue, expr);
      };
      sce[camelCase("get_trusted_" + lName)] = function(value) {
        return getTrusted(enumValue, value);
      };
      sce[camelCase("trust_as_" + lName)] = function(value) {
        return trustAs(enumValue, value);
      };
    });

    return sce;
  }];
}

/**
 * !!! This is an undocumented "private" service !!!
 *
 * @name $sniffer
 * @requires $window
 * @requires $document
 *
 * @property {boolean} history Does the browser support html5 history api ?
 * @property {boolean} transitions Does the browser support CSS transition events ?
 * @property {boolean} animations Does the browser support CSS animation events ?
 *
 * @description
 * This is very simple implementation of testing browser's features.
 */
function $SnifferProvider() {
  this.$get = ['$window', '$document', function($window, $document) {
    var eventSupport = {},
        // Chrome Packaged Apps are not allowed to access `history.pushState`. They can be detected by
        // the presence of `chrome.app.runtime` (see https://developer.chrome.com/apps/api_index)
        isChromePackagedApp = $window.chrome && $window.chrome.app && $window.chrome.app.runtime,
        hasHistoryPushState = !isChromePackagedApp && $window.history && $window.history.pushState,
        android =
          toInt((/android (\d+)/.exec(lowercase(($window.navigator || {}).userAgent)) || [])[1]),
        boxee = /Boxee/i.test(($window.navigator || {}).userAgent),
        document = $document[0] || {},
        vendorPrefix,
        vendorRegex = /^(Moz|webkit|ms)(?=[A-Z])/,
        bodyStyle = document.body && document.body.style,
        transitions = false,
        animations = false,
        match;

    if (bodyStyle) {
      for (var prop in bodyStyle) {
        if (match = vendorRegex.exec(prop)) {
          vendorPrefix = match[0];
          vendorPrefix = vendorPrefix[0].toUpperCase() + vendorPrefix.substr(1);
          break;
        }
      }

      if (!vendorPrefix) {
        vendorPrefix = ('WebkitOpacity' in bodyStyle) && 'webkit';
      }

      transitions = !!(('transition' in bodyStyle) || (vendorPrefix + 'Transition' in bodyStyle));
      animations  = !!(('animation' in bodyStyle) || (vendorPrefix + 'Animation' in bodyStyle));

      if (android && (!transitions ||  !animations)) {
        transitions = isString(bodyStyle.webkitTransition);
        animations = isString(bodyStyle.webkitAnimation);
      }
    }


    return {
      // Android has history.pushState, but it does not update location correctly
      // so let's not use the history API at all.
      // http://code.google.com/p/android/issues/detail?id=17471
      // https://github.com/angular/angular.js/issues/904

      // older webkit browser (533.9) on Boxee box has exactly the same problem as Android has
      // so let's not use the history API also
      // We are purposefully using `!(android < 4)` to cover the case when `android` is undefined
      // jshint -W018
      history: !!(hasHistoryPushState && !(android < 4) && !boxee),
      // jshint +W018
      hasEvent: function(event) {
        // IE9 implements 'input' event it's so fubared that we rather pretend that it doesn't have
        // it. In particular the event is not fired when backspace or delete key are pressed or
        // when cut operation is performed.
        // IE10+ implements 'input' event but it erroneously fires under various situations,
        // e.g. when placeholder changes, or a form is focused.
        if (event === 'input' && msie <= 11) return false;

        if (isUndefined(eventSupport[event])) {
          var divElm = document.createElement('div');
          eventSupport[event] = 'on' + event in divElm;
        }

        return eventSupport[event];
      },
      csp: csp(),
      vendorPrefix: vendorPrefix,
      transitions: transitions,
      animations: animations,
      android: android
    };
  }];
}

var $templateRequestMinErr = minErr('$compile');

/**
 * @ngdoc provider
 * @name $templateRequestProvider
 * @description
 * Used to configure the options passed to the {@link $http} service when making a template request.
 *
 * For example, it can be used for specifying the "Accept" header that is sent to the server, when
 * requesting a template.
 */
function $TemplateRequestProvider() {

  var httpOptions;

  /**
   * @ngdoc method
   * @name $templateRequestProvider#httpOptions
   * @description
   * The options to be passed to the {@link $http} service when making the request.
   * You can use this to override options such as the "Accept" header for template requests.
   *
   * The {@link $templateRequest} will set the `cache` and the `transformResponse` properties of the
   * options if not overridden here.
   *
   * @param {string=} value new value for the {@link $http} options.
   * @returns {string|self} Returns the {@link $http} options when used as getter and self if used as setter.
   */
  this.httpOptions = function(val) {
    if (val) {
      httpOptions = val;
      return this;
    }
    return httpOptions;
  };

  /**
   * @ngdoc service
   * @name $templateRequest
   *
   * @description
   * The `$templateRequest` service runs security checks then downloads the provided template using
   * `$http` and, upon success, stores the contents inside of `$templateCache`. If the HTTP request
   * fails or the response data of the HTTP request is empty, a `$compile` error will be thrown (the
   * exception can be thwarted by setting the 2nd parameter of the function to true). Note that the
   * contents of `$templateCache` are trusted, so the call to `$sce.getTrustedUrl(tpl)` is omitted
   * when `tpl` is of type string and `$templateCache` has the matching entry.
   *
   * If you want to pass custom options to the `$http` service, such as setting the Accept header you
   * can configure this via {@link $templateRequestProvider#httpOptions}.
   *
   * @param {string|TrustedResourceUrl} tpl The HTTP request template URL
   * @param {boolean=} ignoreRequestError Whether or not to ignore the exception when the request fails or the template is empty
   *
   * @return {Promise} a promise for the HTTP response data of the given URL.
   *
   * @property {number} totalPendingRequests total amount of pending template requests being downloaded.
   */
  this.$get = ['$templateCache', '$http', '$q', '$sce', function($templateCache, $http, $q, $sce) {

    function handleRequestFn(tpl, ignoreRequestError) {
      handleRequestFn.totalPendingRequests++;

      // We consider the template cache holds only trusted templates, so
      // there's no need to go through whitelisting again for keys that already
      // are included in there. This also makes Angular accept any script
      // directive, no matter its name. However, we still need to unwrap trusted
      // types.
      if (!isString(tpl) || isUndefined($templateCache.get(tpl))) {
        tpl = $sce.getTrustedResourceUrl(tpl);
      }

      var transformResponse = $http.defaults && $http.defaults.transformResponse;

      if (isArray(transformResponse)) {
        transformResponse = transformResponse.filter(function(transformer) {
          return transformer !== defaultHttpResponseTransform;
        });
      } else if (transformResponse === defaultHttpResponseTransform) {
        transformResponse = null;
      }

      return $http.get(tpl, extend({
          cache: $templateCache,
          transformResponse: transformResponse
        }, httpOptions))
        ['finally'](function() {
          handleRequestFn.totalPendingRequests--;
        })
        .then(function(response) {
          $templateCache.put(tpl, response.data);
          return response.data;
        }, handleError);

      function handleError(resp) {
        if (!ignoreRequestError) {
          throw $templateRequestMinErr('tpload', 'Failed to load template: {0} (HTTP status: {1} {2})',
            tpl, resp.status, resp.statusText);
        }
        return $q.reject(resp);
      }
    }

    handleRequestFn.totalPendingRequests = 0;

    return handleRequestFn;
  }];
}

function $$TestabilityProvider() {
  this.$get = ['$rootScope', '$browser', '$location',
       function($rootScope,   $browser,   $location) {

    /**
     * @name $testability
     *
     * @description
     * The private $$testability service provides a collection of methods for use when debugging
     * or by automated test and debugging tools.
     */
    var testability = {};

    /**
     * @name $$testability#findBindings
     *
     * @description
     * Returns an array of elements that are bound (via ng-bind or {{}})
     * to expressions matching the input.
     *
     * @param {Element} element The element root to search from.
     * @param {string} expression The binding expression to match.
     * @param {boolean} opt_exactMatch If true, only returns exact matches
     *     for the expression. Filters and whitespace are ignored.
     */
    testability.findBindings = function(element, expression, opt_exactMatch) {
      var bindings = element.getElementsByClassName('ng-binding');
      var matches = [];
      forEach(bindings, function(binding) {
        var dataBinding = angular.element(binding).data('$binding');
        if (dataBinding) {
          forEach(dataBinding, function(bindingName) {
            if (opt_exactMatch) {
              var matcher = new RegExp('(^|\\s)' + escapeForRegexp(expression) + '(\\s|\\||$)');
              if (matcher.test(bindingName)) {
                matches.push(binding);
              }
            } else {
              if (bindingName.indexOf(expression) != -1) {
                matches.push(binding);
              }
            }
          });
        }
      });
      return matches;
    };

    /**
     * @name $$testability#findModels
     *
     * @description
     * Returns an array of elements that are two-way found via ng-model to
     * expressions matching the input.
     *
     * @param {Element} element The element root to search from.
     * @param {string} expression The model expression to match.
     * @param {boolean} opt_exactMatch If true, only returns exact matches
     *     for the expression.
     */
    testability.findModels = function(element, expression, opt_exactMatch) {
      var prefixes = ['ng-', 'data-ng-', 'ng\\:'];
      for (var p = 0; p < prefixes.length; ++p) {
        var attributeEquals = opt_exactMatch ? '=' : '*=';
        var selector = '[' + prefixes[p] + 'model' + attributeEquals + '"' + expression + '"]';
        var elements = element.querySelectorAll(selector);
        if (elements.length) {
          return elements;
        }
      }
    };

    /**
     * @name $$testability#getLocation
     *
     * @description
     * Shortcut for getting the location in a browser agnostic way. Returns
     *     the path, search, and hash. (e.g. /path?a=b#hash)
     */
    testability.getLocation = function() {
      return $location.url();
    };

    /**
     * @name $$testability#setLocation
     *
     * @description
     * Shortcut for navigating to a location without doing a full page reload.
     *
     * @param {string} url The location url (path, search and hash,
     *     e.g. /path?a=b#hash) to go to.
     */
    testability.setLocation = function(url) {
      if (url !== $location.url()) {
        $location.url(url);
        $rootScope.$digest();
      }
    };

    /**
     * @name $$testability#whenStable
     *
     * @description
     * Calls the callback when $timeout and $http requests are completed.
     *
     * @param {function} callback
     */
    testability.whenStable = function(callback) {
      $browser.notifyWhenNoOutstandingRequests(callback);
    };

    return testability;
  }];
}

function $TimeoutProvider() {
  this.$get = ['$rootScope', '$browser', '$q', '$$q', '$exceptionHandler',
       function($rootScope,   $browser,   $q,   $$q,   $exceptionHandler) {

    var deferreds = {};


     /**
      * @ngdoc service
      * @name $timeout
      *
      * @description
      * Angular's wrapper for `window.setTimeout`. The `fn` function is wrapped into a try/catch
      * block and delegates any exceptions to
      * {@link ng.$exceptionHandler $exceptionHandler} service.
      *
      * The return value of calling `$timeout` is a promise, which will be resolved when
      * the delay has passed and the timeout function, if provided, is executed.
      *
      * To cancel a timeout request, call `$timeout.cancel(promise)`.
      *
      * In tests you can use {@link ngMock.$timeout `$timeout.flush()`} to
      * synchronously flush the queue of deferred functions.
      *
      * If you only want a promise that will be resolved after some specified delay
      * then you can call `$timeout` without the `fn` function.
      *
      * @param {function()=} fn A function, whose execution should be delayed.
      * @param {number=} [delay=0] Delay in milliseconds.
      * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
      *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
      * @param {...*=} Pass additional parameters to the executed function.
      * @returns {Promise} Promise that will be resolved when the timeout is reached. The promise
      *   will be resolved with the return value of the `fn` function.
      *
      */
    function timeout(fn, delay, invokeApply) {
      if (!isFunction(fn)) {
        invokeApply = delay;
        delay = fn;
        fn = noop;
      }

      var args = sliceArgs(arguments, 3),
          skipApply = (isDefined(invokeApply) && !invokeApply),
          deferred = (skipApply ? $$q : $q).defer(),
          promise = deferred.promise,
          timeoutId;

      timeoutId = $browser.defer(function() {
        try {
          deferred.resolve(fn.apply(null, args));
        } catch (e) {
          deferred.reject(e);
          $exceptionHandler(e);
        }
        finally {
          delete deferreds[promise.$$timeoutId];
        }

        if (!skipApply) $rootScope.$apply();
      }, delay);

      promise.$$timeoutId = timeoutId;
      deferreds[timeoutId] = deferred;

      return promise;
    }


     /**
      * @ngdoc method
      * @name $timeout#cancel
      *
      * @description
      * Cancels a task associated with the `promise`. As a result of this, the promise will be
      * resolved with a rejection.
      *
      * @param {Promise=} promise Promise returned by the `$timeout` function.
      * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
      *   canceled.
      */
    timeout.cancel = function(promise) {
      if (promise && promise.$$timeoutId in deferreds) {
        deferreds[promise.$$timeoutId].reject('canceled');
        delete deferreds[promise.$$timeoutId];
        return $browser.defer.cancel(promise.$$timeoutId);
      }
      return false;
    };

    return timeout;
  }];
}

// NOTE:  The usage of window and document instead of $window and $document here is
// deliberate.  This service depends on the specific behavior of anchor nodes created by the
// browser (resolving and parsing URLs) that is unlikely to be provided by mock objects and
// cause us to break tests.  In addition, when the browser resolves a URL for XHR, it
// doesn't know about mocked locations and resolves URLs to the real document - which is
// exactly the behavior needed here.  There is little value is mocking these out for this
// service.
var urlParsingNode = window.document.createElement("a");
var originUrl = urlResolve(window.location.href);


/**
 *
 * Implementation Notes for non-IE browsers
 * ----------------------------------------
 * Assigning a URL to the href property of an anchor DOM node, even one attached to the DOM,
 * results both in the normalizing and parsing of the URL.  Normalizing means that a relative
 * URL will be resolved into an absolute URL in the context of the application document.
 * Parsing means that the anchor node's host, hostname, protocol, port, pathname and related
 * properties are all populated to reflect the normalized URL.  This approach has wide
 * compatibility - Safari 1+, Mozilla 1+, Opera 7+,e etc.  See
 * http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
 *
 * Implementation Notes for IE
 * ---------------------------
 * IE <= 10 normalizes the URL when assigned to the anchor node similar to the other
 * browsers.  However, the parsed components will not be set if the URL assigned did not specify
 * them.  (e.g. if you assign a.href = "foo", then a.protocol, a.host, etc. will be empty.)  We
 * work around that by performing the parsing in a 2nd step by taking a previously normalized
 * URL (e.g. by assigning to a.href) and assigning it a.href again.  This correctly populates the
 * properties such as protocol, hostname, port, etc.
 *
 * References:
 *   http://developer.mozilla.org/en-US/docs/Web/API/HTMLAnchorElement
 *   http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
 *   http://url.spec.whatwg.org/#urlutils
 *   https://github.com/angular/angular.js/pull/2902
 *   http://james.padolsey.com/javascript/parsing-urls-with-the-dom/
 *
 * @kind function
 * @param {string} url The URL to be parsed.
 * @description Normalizes and parses a URL.
 * @returns {object} Returns the normalized URL as a dictionary.
 *
 *   | member name   | Description    |
 *   |---------------|----------------|
 *   | href          | A normalized version of the provided URL if it was not an absolute URL |
 *   | protocol      | The protocol including the trailing colon                              |
 *   | host          | The host and port (if the port is non-default) of the normalizedUrl    |
 *   | search        | The search params, minus the question mark                             |
 *   | hash          | The hash string, minus the hash symbol
 *   | hostname      | The hostname
 *   | port          | The port, without ":"
 *   | pathname      | The pathname, beginning with "/"
 *
 */
function urlResolve(url) {
  var href = url;

  if (msie) {
    // Normalize before parse.  Refer Implementation Notes on why this is
    // done in two steps on IE.
    urlParsingNode.setAttribute("href", href);
    href = urlParsingNode.href;
  }

  urlParsingNode.setAttribute('href', href);

  // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
  return {
    href: urlParsingNode.href,
    protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
    host: urlParsingNode.host,
    search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
    hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
    hostname: urlParsingNode.hostname,
    port: urlParsingNode.port,
    pathname: (urlParsingNode.pathname.charAt(0) === '/')
      ? urlParsingNode.pathname
      : '/' + urlParsingNode.pathname
  };
}

/**
 * Parse a request URL and determine whether this is a same-origin request as the application document.
 *
 * @param {string|object} requestUrl The url of the request as a string that will be resolved
 * or a parsed URL object.
 * @returns {boolean} Whether the request is for the same origin as the application document.
 */
function urlIsSameOrigin(requestUrl) {
  var parsed = (isString(requestUrl)) ? urlResolve(requestUrl) : requestUrl;
  return (parsed.protocol === originUrl.protocol &&
          parsed.host === originUrl.host);
}

/**
 * @ngdoc service
 * @name $window
 *
 * @description
 * A reference to the browser's `window` object. While `window`
 * is globally available in JavaScript, it causes testability problems, because
 * it is a global variable. In angular we always refer to it through the
 * `$window` service, so it may be overridden, removed or mocked for testing.
 *
 * Expressions, like the one defined for the `ngClick` directive in the example
 * below, are evaluated with respect to the current scope.  Therefore, there is
 * no risk of inadvertently coding in a dependency on a global value in such an
 * expression.
 *
 * @example
   <example module="windowExample">
     <file name="index.html">
       <script>
         angular.module('windowExample', [])
           .controller('ExampleController', ['$scope', '$window', function($scope, $window) {
             $scope.greeting = 'Hello, World!';
             $scope.doGreeting = function(greeting) {
               $window.alert(greeting);
             };
           }]);
       </script>
       <div ng-controller="ExampleController">
         <input type="text" ng-model="greeting" aria-label="greeting" />
         <button ng-click="doGreeting(greeting)">ALERT</button>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
      it('should display the greeting in the input box', function() {
       element(by.model('greeting')).sendKeys('Hello, E2E Tests');
       // If we click the button it will block the test runner
       // element(':button').click();
      });
     </file>
   </example>
 */
function $WindowProvider() {
  this.$get = valueFn(window);
}

/**
 * @name $$cookieReader
 * @requires $document
 *
 * @description
 * This is a private service for reading cookies used by $http and ngCookies
 *
 * @return {Object} a key/value map of the current cookies
 */
function $$CookieReader($document) {
  var rawDocument = $document[0] || {};
  var lastCookies = {};
  var lastCookieString = '';

  function safeDecodeURIComponent(str) {
    try {
      return decodeURIComponent(str);
    } catch (e) {
      return str;
    }
  }

  return function() {
    var cookieArray, cookie, i, index, name;
    var currentCookieString = rawDocument.cookie || '';

    if (currentCookieString !== lastCookieString) {
      lastCookieString = currentCookieString;
      cookieArray = lastCookieString.split('; ');
      lastCookies = {};

      for (i = 0; i < cookieArray.length; i++) {
        cookie = cookieArray[i];
        index = cookie.indexOf('=');
        if (index > 0) { //ignore nameless cookies
          name = safeDecodeURIComponent(cookie.substring(0, index));
          // the first value that is seen for a cookie is the most
          // specific one.  values for the same cookie name that
          // follow are for less specific paths.
          if (isUndefined(lastCookies[name])) {
            lastCookies[name] = safeDecodeURIComponent(cookie.substring(index + 1));
          }
        }
      }
    }
    return lastCookies;
  };
}

$$CookieReader.$inject = ['$document'];

function $$CookieReaderProvider() {
  this.$get = $$CookieReader;
}

/* global currencyFilter: true,
 dateFilter: true,
 filterFilter: true,
 jsonFilter: true,
 limitToFilter: true,
 lowercaseFilter: true,
 numberFilter: true,
 orderByFilter: true,
 uppercaseFilter: true,
 */

/**
 * @ngdoc provider
 * @name $filterProvider
 * @description
 *
 * Filters are just functions which transform input to an output. However filters need to be
 * Dependency Injected. To achieve this a filter definition consists of a factory function which is
 * annotated with dependencies and is responsible for creating a filter function.
 *
 * <div class="alert alert-warning">
 * **Note:** Filter names must be valid angular {@link expression} identifiers, such as `uppercase` or `orderBy`.
 * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
 * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
 * (`myapp_subsection_filterx`).
 * </div>
 *
 * ```js
 *   // Filter registration
 *   function MyModule($provide, $filterProvider) {
 *     // create a service to demonstrate injection (not always needed)
 *     $provide.value('greet', function(name){
 *       return 'Hello ' + name + '!';
 *     });
 *
 *     // register a filter factory which uses the
 *     // greet service to demonstrate DI.
 *     $filterProvider.register('greet', function(greet){
 *       // return the filter function which uses the greet service
 *       // to generate salutation
 *       return function(text) {
 *         // filters need to be forgiving so check input validity
 *         return text && greet(text) || text;
 *       };
 *     });
 *   }
 * ```
 *
 * The filter function is registered with the `$injector` under the filter name suffix with
 * `Filter`.
 *
 * ```js
 *   it('should be the same instance', inject(
 *     function($filterProvider) {
 *       $filterProvider.register('reverse', function(){
 *         return ...;
 *       });
 *     },
 *     function($filter, reverseFilter) {
 *       expect($filter('reverse')).toBe(reverseFilter);
 *     });
 * ```
 *
 *
 * For more information about how angular filters work, and how to create your own filters, see
 * {@link guide/filter Filters} in the Angular Developer Guide.
 */

/**
 * @ngdoc service
 * @name $filter
 * @kind function
 * @description
 * Filters are used for formatting data displayed to the user.
 *
 * The general syntax in templates is as follows:
 *
 *         {{ expression [| filter_name[:parameter_value] ... ] }}
 *
 * @param {String} name Name of the filter function to retrieve
 * @return {Function} the filter function
 * @example
   <example name="$filter" module="filterExample">
     <file name="index.html">
       <div ng-controller="MainCtrl">
        <h3>{{ originalText }}</h3>
        <h3>{{ filteredText }}</h3>
       </div>
     </file>

     <file name="script.js">
      angular.module('filterExample', [])
      .controller('MainCtrl', function($scope, $filter) {
        $scope.originalText = 'hello';
        $scope.filteredText = $filter('uppercase')($scope.originalText);
      });
     </file>
   </example>
  */
$FilterProvider.$inject = ['$provide'];
function $FilterProvider($provide) {
  var suffix = 'Filter';

  /**
   * @ngdoc method
   * @name $filterProvider#register
   * @param {string|Object} name Name of the filter function, or an object map of filters where
   *    the keys are the filter names and the values are the filter factories.
   *
   *    <div class="alert alert-warning">
   *    **Note:** Filter names must be valid angular {@link expression} identifiers, such as `uppercase` or `orderBy`.
   *    Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
   *    your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
   *    (`myapp_subsection_filterx`).
   *    </div>
    * @param {Function} factory If the first argument was a string, a factory function for the filter to be registered.
   * @returns {Object} Registered filter instance, or if a map of filters was provided then a map
   *    of the registered filter instances.
   */
  function register(name, factory) {
    if (isObject(name)) {
      var filters = {};
      forEach(name, function(filter, key) {
        filters[key] = register(key, filter);
      });
      return filters;
    } else {
      return $provide.factory(name + suffix, factory);
    }
  }
  this.register = register;

  this.$get = ['$injector', function($injector) {
    return function(name) {
      return $injector.get(name + suffix);
    };
  }];

  ////////////////////////////////////////

  /* global
    currencyFilter: false,
    dateFilter: false,
    filterFilter: false,
    jsonFilter: false,
    limitToFilter: false,
    lowercaseFilter: false,
    numberFilter: false,
    orderByFilter: false,
    uppercaseFilter: false,
  */

  register('currency', currencyFilter);
  register('date', dateFilter);
  register('filter', filterFilter);
  register('json', jsonFilter);
  register('limitTo', limitToFilter);
  register('lowercase', lowercaseFilter);
  register('number', numberFilter);
  register('orderBy', orderByFilter);
  register('uppercase', uppercaseFilter);
}

/**
 * @ngdoc filter
 * @name filter
 * @kind function
 *
 * @description
 * Selects a subset of items from `array` and returns it as a new array.
 *
 * @param {Array} array The source array.
 * @param {string|Object|function()} expression The predicate to be used for selecting items from
 *   `array`.
 *
 *   Can be one of:
 *
 *   - `string`: The string is used for matching against the contents of the `array`. All strings or
 *     objects with string properties in `array` that match this string will be returned. This also
 *     applies to nested object properties.
 *     The predicate can be negated by prefixing the string with `!`.
 *
 *   - `Object`: A pattern object can be used to filter specific properties on objects contained
 *     by `array`. For example `{name:"M", phone:"1"}` predicate will return an array of items
 *     which have property `name` containing "M" and property `phone` containing "1". A special
 *     property name (`$` by default) can be used (e.g. as in `{$: "text"}`) to accept a match
 *     against any property of the object or its nested object properties. That's equivalent to the
 *     simple substring match with a `string` as described above. The special property name can be
 *     overwritten, using the `anyPropertyKey` parameter.
 *     The predicate can be negated by prefixing the string with `!`.
 *     For example `{name: "!M"}` predicate will return an array of items which have property `name`
 *     not containing "M".
 *
 *     Note that a named property will match properties on the same level only, while the special
 *     `$` property will match properties on the same level or deeper. E.g. an array item like
 *     `{name: {first: 'John', last: 'Doe'}}` will **not** be matched by `{name: 'John'}`, but
 *     **will** be matched by `{$: 'John'}`.
 *
 *   - `function(value, index, array)`: A predicate function can be used to write arbitrary filters.
 *     The function is called for each element of the array, with the element, its index, and
 *     the entire array itself as arguments.
 *
 *     The final result is an array of those elements that the predicate returned true for.
 *
 * @param {function(actual, expected)|true|undefined} comparator Comparator which is used in
 *     determining if the expected value (from the filter expression) and actual value (from
 *     the object in the array) should be considered a match.
 *
 *   Can be one of:
 *
 *   - `function(actual, expected)`:
 *     The function will be given the object value and the predicate value to compare and
 *     should return true if both values should be considered equal.
 *
 *   - `true`: A shorthand for `function(actual, expected) { return angular.equals(actual, expected)}`.
 *     This is essentially strict comparison of expected and actual.
 *
 *   - `false|undefined`: A short hand for a function which will look for a substring match in case
 *     insensitive way.
 *
 *     Primitive values are converted to strings. Objects are not compared against primitives,
 *     unless they have a custom `toString` method (e.g. `Date` objects).
 *
 * @param {string=} anyPropertyKey The special property name that matches against any property.
 *     By default `$`.
 *
 * @example
   <example>
     <file name="index.html">
       <div ng-init="friends = [{name:'John', phone:'555-1276'},
                                {name:'Mary', phone:'800-BIG-MARY'},
                                {name:'Mike', phone:'555-4321'},
                                {name:'Adam', phone:'555-5678'},
                                {name:'Julie', phone:'555-8765'},
                                {name:'Juliette', phone:'555-5678'}]"></div>

       <label>Search: <input ng-model="searchText"></label>
       <table id="searchTextResults">
         <tr><th>Name</th><th>Phone</th></tr>
         <tr ng-repeat="friend in friends | filter:searchText">
           <td>{{friend.name}}</td>
           <td>{{friend.phone}}</td>
         </tr>
       </table>
       <hr>
       <label>Any: <input ng-model="search.$"></label> <br>
       <label>Name only <input ng-model="search.name"></label><br>
       <label>Phone only <input ng-model="search.phone"></label><br>
       <label>Equality <input type="checkbox" ng-model="strict"></label><br>
       <table id="searchObjResults">
         <tr><th>Name</th><th>Phone</th></tr>
         <tr ng-repeat="friendObj in friends | filter:search:strict">
           <td>{{friendObj.name}}</td>
           <td>{{friendObj.phone}}</td>
         </tr>
       </table>
     </file>
     <file name="protractor.js" type="protractor">
       var expectFriendNames = function(expectedNames, key) {
         element.all(by.repeater(key + ' in friends').column(key + '.name')).then(function(arr) {
           arr.forEach(function(wd, i) {
             expect(wd.getText()).toMatch(expectedNames[i]);
           });
         });
       };

       it('should search across all fields when filtering with a string', function() {
         var searchText = element(by.model('searchText'));
         searchText.clear();
         searchText.sendKeys('m');
         expectFriendNames(['Mary', 'Mike', 'Adam'], 'friend');

         searchText.clear();
         searchText.sendKeys('76');
         expectFriendNames(['John', 'Julie'], 'friend');
       });

       it('should search in specific fields when filtering with a predicate object', function() {
         var searchAny = element(by.model('search.$'));
         searchAny.clear();
         searchAny.sendKeys('i');
         expectFriendNames(['Mary', 'Mike', 'Julie', 'Juliette'], 'friendObj');
       });
       it('should use a equal comparison when comparator is true', function() {
         var searchName = element(by.model('search.name'));
         var strict = element(by.model('strict'));
         searchName.clear();
         searchName.sendKeys('Julie');
         strict.click();
         expectFriendNames(['Julie'], 'friendObj');
       });
     </file>
   </example>
 */

function filterFilter() {
  return function(array, expression, comparator, anyPropertyKey) {
    if (!isArrayLike(array)) {
      if (array == null) {
        return array;
      } else {
        throw minErr('filter')('notarray', 'Expected array but received: {0}', array);
      }
    }

    anyPropertyKey = anyPropertyKey || '$';
    var expressionType = getTypeForFilter(expression);
    var predicateFn;
    var matchAgainstAnyProp;

    switch (expressionType) {
      case 'function':
        predicateFn = expression;
        break;
      case 'boolean':
      case 'null':
      case 'number':
      case 'string':
        matchAgainstAnyProp = true;
        //jshint -W086
      case 'object':
        //jshint +W086
        predicateFn = createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp);
        break;
      default:
        return array;
    }

    return Array.prototype.filter.call(array, predicateFn);
  };
}

// Helper functions for `filterFilter`
function createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp) {
  var shouldMatchPrimitives = isObject(expression) && (anyPropertyKey in expression);
  var predicateFn;

  if (comparator === true) {
    comparator = equals;
  } else if (!isFunction(comparator)) {
    comparator = function(actual, expected) {
      if (isUndefined(actual)) {
        // No substring matching against `undefined`
        return false;
      }
      if ((actual === null) || (expected === null)) {
        // No substring matching against `null`; only match against `null`
        return actual === expected;
      }
      if (isObject(expected) || (isObject(actual) && !hasCustomToString(actual))) {
        // Should not compare primitives against objects, unless they have custom `toString` method
        return false;
      }

      actual = lowercase('' + actual);
      expected = lowercase('' + expected);
      return actual.indexOf(expected) !== -1;
    };
  }

  predicateFn = function(item) {
    if (shouldMatchPrimitives && !isObject(item)) {
      return deepCompare(item, expression[anyPropertyKey], comparator, anyPropertyKey, false);
    }
    return deepCompare(item, expression, comparator, anyPropertyKey, matchAgainstAnyProp);
  };

  return predicateFn;
}

function deepCompare(actual, expected, comparator, anyPropertyKey, matchAgainstAnyProp, dontMatchWholeObject) {
  var actualType = getTypeForFilter(actual);
  var expectedType = getTypeForFilter(expected);

  if ((expectedType === 'string') && (expected.charAt(0) === '!')) {
    return !deepCompare(actual, expected.substring(1), comparator, anyPropertyKey, matchAgainstAnyProp);
  } else if (isArray(actual)) {
    // In case `actual` is an array, consider it a match
    // if ANY of it's items matches `expected`
    return actual.some(function(item) {
      return deepCompare(item, expected, comparator, anyPropertyKey, matchAgainstAnyProp);
    });
  }

  switch (actualType) {
    case 'object':
      var key;
      if (matchAgainstAnyProp) {
        for (key in actual) {
          if ((key.charAt(0) !== '$') && deepCompare(actual[key], expected, comparator, anyPropertyKey, true)) {
            return true;
          }
        }
        return dontMatchWholeObject ? false : deepCompare(actual, expected, comparator, anyPropertyKey, false);
      } else if (expectedType === 'object') {
        for (key in expected) {
          var expectedVal = expected[key];
          if (isFunction(expectedVal) || isUndefined(expectedVal)) {
            continue;
          }

          var matchAnyProperty = key === anyPropertyKey;
          var actualVal = matchAnyProperty ? actual : actual[key];
          if (!deepCompare(actualVal, expectedVal, comparator, anyPropertyKey, matchAnyProperty, matchAnyProperty)) {
            return false;
          }
        }
        return true;
      } else {
        return comparator(actual, expected);
      }
      break;
    case 'function':
      return false;
    default:
      return comparator(actual, expected);
  }
}

// Used for easily differentiating between `null` and actual `object`
function getTypeForFilter(val) {
  return (val === null) ? 'null' : typeof val;
}

var MAX_DIGITS = 22;
var DECIMAL_SEP = '.';
var ZERO_CHAR = '0';

/**
 * @ngdoc filter
 * @name currency
 * @kind function
 *
 * @description
 * Formats a number as a currency (ie $1,234.56). When no currency symbol is provided, default
 * symbol for current locale is used.
 *
 * @param {number} amount Input to filter.
 * @param {string=} symbol Currency symbol or identifier to be displayed.
 * @param {number=} fractionSize Number of decimal places to round the amount to, defaults to default max fraction size for current locale
 * @returns {string} Formatted number.
 *
 *
 * @example
   <example module="currencyExample">
     <file name="index.html">
       <script>
         angular.module('currencyExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.amount = 1234.56;
           }]);
       </script>
       <div ng-controller="ExampleController">
         <input type="number" ng-model="amount" aria-label="amount"> <br>
         default currency symbol ($): <span id="currency-default">{{amount | currency}}</span><br>
         custom currency identifier (USD$): <span id="currency-custom">{{amount | currency:"USD$"}}</span>
         no fractions (0): <span id="currency-no-fractions">{{amount | currency:"USD$":0}}</span>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should init with 1234.56', function() {
         expect(element(by.id('currency-default')).getText()).toBe('$1,234.56');
         expect(element(by.id('currency-custom')).getText()).toBe('USD$1,234.56');
         expect(element(by.id('currency-no-fractions')).getText()).toBe('USD$1,235');
       });
       it('should update', function() {
         if (browser.params.browser == 'safari') {
           // Safari does not understand the minus key. See
           // https://github.com/angular/protractor/issues/481
           return;
         }
         element(by.model('amount')).clear();
         element(by.model('amount')).sendKeys('-1234');
         expect(element(by.id('currency-default')).getText()).toBe('-$1,234.00');
         expect(element(by.id('currency-custom')).getText()).toBe('-USD$1,234.00');
         expect(element(by.id('currency-no-fractions')).getText()).toBe('-USD$1,234');
       });
     </file>
   </example>
 */
currencyFilter.$inject = ['$locale'];
function currencyFilter($locale) {
  var formats = $locale.NUMBER_FORMATS;
  return function(amount, currencySymbol, fractionSize) {
    if (isUndefined(currencySymbol)) {
      currencySymbol = formats.CURRENCY_SYM;
    }

    if (isUndefined(fractionSize)) {
      fractionSize = formats.PATTERNS[1].maxFrac;
    }

    // if null or undefined pass it through
    return (amount == null)
        ? amount
        : formatNumber(amount, formats.PATTERNS[1], formats.GROUP_SEP, formats.DECIMAL_SEP, fractionSize).
            replace(/\u00A4/g, currencySymbol);
  };
}

/**
 * @ngdoc filter
 * @name number
 * @kind function
 *
 * @description
 * Formats a number as text.
 *
 * If the input is null or undefined, it will just be returned.
 * If the input is infinite (Infinity or -Infinity), the Infinity symbol '∞' or '-∞' is returned, respectively.
 * If the input is not a number an empty string is returned.
 *
 *
 * @param {number|string} number Number to format.
 * @param {(number|string)=} fractionSize Number of decimal places to round the number to.
 * If this is not provided then the fraction size is computed from the current locale's number
 * formatting pattern. In the case of the default locale, it will be 3.
 * @returns {string} Number rounded to `fractionSize` appropriately formatted based on the current
 *                   locale (e.g., in the en_US locale it will have "." as the decimal separator and
 *                   include "," group separators after each third digit).
 *
 * @example
   <example module="numberFilterExample">
     <file name="index.html">
       <script>
         angular.module('numberFilterExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.val = 1234.56789;
           }]);
       </script>
       <div ng-controller="ExampleController">
         <label>Enter number: <input ng-model='val'></label><br>
         Default formatting: <span id='number-default'>{{val | number}}</span><br>
         No fractions: <span>{{val | number:0}}</span><br>
         Negative number: <span>{{-val | number:4}}</span>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should format numbers', function() {
         expect(element(by.id('number-default')).getText()).toBe('1,234.568');
         expect(element(by.binding('val | number:0')).getText()).toBe('1,235');
         expect(element(by.binding('-val | number:4')).getText()).toBe('-1,234.5679');
       });

       it('should update', function() {
         element(by.model('val')).clear();
         element(by.model('val')).sendKeys('3374.333');
         expect(element(by.id('number-default')).getText()).toBe('3,374.333');
         expect(element(by.binding('val | number:0')).getText()).toBe('3,374');
         expect(element(by.binding('-val | number:4')).getText()).toBe('-3,374.3330');
      });
     </file>
   </example>
 */
numberFilter.$inject = ['$locale'];
function numberFilter($locale) {
  var formats = $locale.NUMBER_FORMATS;
  return function(number, fractionSize) {

    // if null or undefined pass it through
    return (number == null)
        ? number
        : formatNumber(number, formats.PATTERNS[0], formats.GROUP_SEP, formats.DECIMAL_SEP,
                       fractionSize);
  };
}

/**
 * Parse a number (as a string) into three components that can be used
 * for formatting the number.
 *
 * (Significant bits of this parse algorithm came from https://github.com/MikeMcl/big.js/)
 *
 * @param  {string} numStr The number to parse
 * @return {object} An object describing this number, containing the following keys:
 *  - d : an array of digits containing leading zeros as necessary
 *  - i : the number of the digits in `d` that are to the left of the decimal point
 *  - e : the exponent for numbers that would need more than `MAX_DIGITS` digits in `d`
 *
 */
function parse(numStr) {
  var exponent = 0, digits, numberOfIntegerDigits;
  var i, j, zeros;

  // Decimal point?
  if ((numberOfIntegerDigits = numStr.indexOf(DECIMAL_SEP)) > -1) {
    numStr = numStr.replace(DECIMAL_SEP, '');
  }

  // Exponential form?
  if ((i = numStr.search(/e/i)) > 0) {
    // Work out the exponent.
    if (numberOfIntegerDigits < 0) numberOfIntegerDigits = i;
    numberOfIntegerDigits += +numStr.slice(i + 1);
    numStr = numStr.substring(0, i);
  } else if (numberOfIntegerDigits < 0) {
    // There was no decimal point or exponent so it is an integer.
    numberOfIntegerDigits = numStr.length;
  }

  // Count the number of leading zeros.
  for (i = 0; numStr.charAt(i) == ZERO_CHAR; i++) {/* jshint noempty: false */}

  if (i == (zeros = numStr.length)) {
    // The digits are all zero.
    digits = [0];
    numberOfIntegerDigits = 1;
  } else {
    // Count the number of trailing zeros
    zeros--;
    while (numStr.charAt(zeros) == ZERO_CHAR) zeros--;

    // Trailing zeros are insignificant so ignore them
    numberOfIntegerDigits -= i;
    digits = [];
    // Convert string to array of digits without leading/trailing zeros.
    for (j = 0; i <= zeros; i++, j++) {
      digits[j] = +numStr.charAt(i);
    }
  }

  // If the number overflows the maximum allowed digits then use an exponent.
  if (numberOfIntegerDigits > MAX_DIGITS) {
    digits = digits.splice(0, MAX_DIGITS - 1);
    exponent = numberOfIntegerDigits - 1;
    numberOfIntegerDigits = 1;
  }

  return { d: digits, e: exponent, i: numberOfIntegerDigits };
}

/**
 * Round the parsed number to the specified number of decimal places
 * This function changed the parsedNumber in-place
 */
function roundNumber(parsedNumber, fractionSize, minFrac, maxFrac) {
    var digits = parsedNumber.d;
    var fractionLen = digits.length - parsedNumber.i;

    // determine fractionSize if it is not specified; `+fractionSize` converts it to a number
    fractionSize = (isUndefined(fractionSize)) ? Math.min(Math.max(minFrac, fractionLen), maxFrac) : +fractionSize;

    // The index of the digit to where rounding is to occur
    var roundAt = fractionSize + parsedNumber.i;
    var digit = digits[roundAt];

    if (roundAt > 0) {
      // Drop fractional digits beyond `roundAt`
      digits.splice(Math.max(parsedNumber.i, roundAt));

      // Set non-fractional digits beyond `roundAt` to 0
      for (var j = roundAt; j < digits.length; j++) {
        digits[j] = 0;
      }
    } else {
      // We rounded to zero so reset the parsedNumber
      fractionLen = Math.max(0, fractionLen);
      parsedNumber.i = 1;
      digits.length = Math.max(1, roundAt = fractionSize + 1);
      digits[0] = 0;
      for (var i = 1; i < roundAt; i++) digits[i] = 0;
    }

    if (digit >= 5) {
      if (roundAt - 1 < 0) {
        for (var k = 0; k > roundAt; k--) {
          digits.unshift(0);
          parsedNumber.i++;
        }
        digits.unshift(1);
        parsedNumber.i++;
      } else {
        digits[roundAt - 1]++;
      }
    }

    // Pad out with zeros to get the required fraction length
    for (; fractionLen < Math.max(0, fractionSize); fractionLen++) digits.push(0);


    // Do any carrying, e.g. a digit was rounded up to 10
    var carry = digits.reduceRight(function(carry, d, i, digits) {
      d = d + carry;
      digits[i] = d % 10;
      return Math.floor(d / 10);
    }, 0);
    if (carry) {
      digits.unshift(carry);
      parsedNumber.i++;
    }
}

/**
 * Format a number into a string
 * @param  {number} number       The number to format
 * @param  {{
 *           minFrac, // the minimum number of digits required in the fraction part of the number
 *           maxFrac, // the maximum number of digits required in the fraction part of the number
 *           gSize,   // number of digits in each group of separated digits
 *           lgSize,  // number of digits in the last group of digits before the decimal separator
 *           negPre,  // the string to go in front of a negative number (e.g. `-` or `(`))
 *           posPre,  // the string to go in front of a positive number
 *           negSuf,  // the string to go after a negative number (e.g. `)`)
 *           posSuf   // the string to go after a positive number
 *         }} pattern
 * @param  {string} groupSep     The string to separate groups of number (e.g. `,`)
 * @param  {string} decimalSep   The string to act as the decimal separator (e.g. `.`)
 * @param  {[type]} fractionSize The size of the fractional part of the number
 * @return {string}              The number formatted as a string
 */
function formatNumber(number, pattern, groupSep, decimalSep, fractionSize) {

  if (!(isString(number) || isNumber(number)) || isNaN(number)) return '';

  var isInfinity = !isFinite(number);
  var isZero = false;
  var numStr = Math.abs(number) + '',
      formattedText = '',
      parsedNumber;

  if (isInfinity) {
    formattedText = '\u221e';
  } else {
    parsedNumber = parse(numStr);

    roundNumber(parsedNumber, fractionSize, pattern.minFrac, pattern.maxFrac);

    var digits = parsedNumber.d;
    var integerLen = parsedNumber.i;
    var exponent = parsedNumber.e;
    var decimals = [];
    isZero = digits.reduce(function(isZero, d) { return isZero && !d; }, true);

    // pad zeros for small numbers
    while (integerLen < 0) {
      digits.unshift(0);
      integerLen++;
    }

    // extract decimals digits
    if (integerLen > 0) {
      decimals = digits.splice(integerLen, digits.length);
    } else {
      decimals = digits;
      digits = [0];
    }

    // format the integer digits with grouping separators
    var groups = [];
    if (digits.length >= pattern.lgSize) {
      groups.unshift(digits.splice(-pattern.lgSize, digits.length).join(''));
    }
    while (digits.length > pattern.gSize) {
      groups.unshift(digits.splice(-pattern.gSize, digits.length).join(''));
    }
    if (digits.length) {
      groups.unshift(digits.join(''));
    }
    formattedText = groups.join(groupSep);

    // append the decimal digits
    if (decimals.length) {
      formattedText += decimalSep + decimals.join('');
    }

    if (exponent) {
      formattedText += 'e+' + exponent;
    }
  }
  if (number < 0 && !isZero) {
    return pattern.negPre + formattedText + pattern.negSuf;
  } else {
    return pattern.posPre + formattedText + pattern.posSuf;
  }
}

function padNumber(num, digits, trim, negWrap) {
  var neg = '';
  if (num < 0 || (negWrap && num <= 0)) {
    if (negWrap) {
      num = -num + 1;
    } else {
      num = -num;
      neg = '-';
    }
  }
  num = '' + num;
  while (num.length < digits) num = ZERO_CHAR + num;
  if (trim) {
    num = num.substr(num.length - digits);
  }
  return neg + num;
}


function dateGetter(name, size, offset, trim, negWrap) {
  offset = offset || 0;
  return function(date) {
    var value = date['get' + name]();
    if (offset > 0 || value > -offset) {
      value += offset;
    }
    if (value === 0 && offset == -12) value = 12;
    return padNumber(value, size, trim, negWrap);
  };
}

function dateStrGetter(name, shortForm, standAlone) {
  return function(date, formats) {
    var value = date['get' + name]();
    var propPrefix = (standAlone ? 'STANDALONE' : '') + (shortForm ? 'SHORT' : '');
    var get = uppercase(propPrefix + name);

    return formats[get][value];
  };
}

function timeZoneGetter(date, formats, offset) {
  var zone = -1 * offset;
  var paddedZone = (zone >= 0) ? "+" : "";

  paddedZone += padNumber(Math[zone > 0 ? 'floor' : 'ceil'](zone / 60), 2) +
                padNumber(Math.abs(zone % 60), 2);

  return paddedZone;
}

function getFirstThursdayOfYear(year) {
    // 0 = index of January
    var dayOfWeekOnFirst = (new Date(year, 0, 1)).getDay();
    // 4 = index of Thursday (+1 to account for 1st = 5)
    // 11 = index of *next* Thursday (+1 account for 1st = 12)
    return new Date(year, 0, ((dayOfWeekOnFirst <= 4) ? 5 : 12) - dayOfWeekOnFirst);
}

function getThursdayThisWeek(datetime) {
    return new Date(datetime.getFullYear(), datetime.getMonth(),
      // 4 = index of Thursday
      datetime.getDate() + (4 - datetime.getDay()));
}

function weekGetter(size) {
   return function(date) {
      var firstThurs = getFirstThursdayOfYear(date.getFullYear()),
         thisThurs = getThursdayThisWeek(date);

      var diff = +thisThurs - +firstThurs,
         result = 1 + Math.round(diff / 6.048e8); // 6.048e8 ms per week

      return padNumber(result, size);
   };
}

function ampmGetter(date, formats) {
  return date.getHours() < 12 ? formats.AMPMS[0] : formats.AMPMS[1];
}

function eraGetter(date, formats) {
  return date.getFullYear() <= 0 ? formats.ERAS[0] : formats.ERAS[1];
}

function longEraGetter(date, formats) {
  return date.getFullYear() <= 0 ? formats.ERANAMES[0] : formats.ERANAMES[1];
}

var DATE_FORMATS = {
  yyyy: dateGetter('FullYear', 4, 0, false, true),
    yy: dateGetter('FullYear', 2, 0, true, true),
     y: dateGetter('FullYear', 1, 0, false, true),
  MMMM: dateStrGetter('Month'),
   MMM: dateStrGetter('Month', true),
    MM: dateGetter('Month', 2, 1),
     M: dateGetter('Month', 1, 1),
  LLLL: dateStrGetter('Month', false, true),
    dd: dateGetter('Date', 2),
     d: dateGetter('Date', 1),
    HH: dateGetter('Hours', 2),
     H: dateGetter('Hours', 1),
    hh: dateGetter('Hours', 2, -12),
     h: dateGetter('Hours', 1, -12),
    mm: dateGetter('Minutes', 2),
     m: dateGetter('Minutes', 1),
    ss: dateGetter('Seconds', 2),
     s: dateGetter('Seconds', 1),
     // while ISO 8601 requires fractions to be prefixed with `.` or `,`
     // we can be just safely rely on using `sss` since we currently don't support single or two digit fractions
   sss: dateGetter('Milliseconds', 3),
  EEEE: dateStrGetter('Day'),
   EEE: dateStrGetter('Day', true),
     a: ampmGetter,
     Z: timeZoneGetter,
    ww: weekGetter(2),
     w: weekGetter(1),
     G: eraGetter,
     GG: eraGetter,
     GGG: eraGetter,
     GGGG: longEraGetter
};

var DATE_FORMATS_SPLIT = /((?:[^yMLdHhmsaZEwG']+)|(?:'(?:[^']|'')*')|(?:E+|y+|M+|L+|d+|H+|h+|m+|s+|a|Z|G+|w+))(.*)/,
    NUMBER_STRING = /^\-?\d+$/;

/**
 * @ngdoc filter
 * @name date
 * @kind function
 *
 * @description
 *   Formats `date` to a string based on the requested `format`.
 *
 *   `format` string can be composed of the following elements:
 *
 *   * `'yyyy'`: 4 digit representation of year (e.g. AD 1 => 0001, AD 2010 => 2010)
 *   * `'yy'`: 2 digit representation of year, padded (00-99). (e.g. AD 2001 => 01, AD 2010 => 10)
 *   * `'y'`: 1 digit representation of year, e.g. (AD 1 => 1, AD 199 => 199)
 *   * `'MMMM'`: Month in year (January-December)
 *   * `'MMM'`: Month in year (Jan-Dec)
 *   * `'MM'`: Month in year, padded (01-12)
 *   * `'M'`: Month in year (1-12)
 *   * `'LLLL'`: Stand-alone month in year (January-December)
 *   * `'dd'`: Day in month, padded (01-31)
 *   * `'d'`: Day in month (1-31)
 *   * `'EEEE'`: Day in Week,(Sunday-Saturday)
 *   * `'EEE'`: Day in Week, (Sun-Sat)
 *   * `'HH'`: Hour in day, padded (00-23)
 *   * `'H'`: Hour in day (0-23)
 *   * `'hh'`: Hour in AM/PM, padded (01-12)
 *   * `'h'`: Hour in AM/PM, (1-12)
 *   * `'mm'`: Minute in hour, padded (00-59)
 *   * `'m'`: Minute in hour (0-59)
 *   * `'ss'`: Second in minute, padded (00-59)
 *   * `'s'`: Second in minute (0-59)
 *   * `'sss'`: Millisecond in second, padded (000-999)
 *   * `'a'`: AM/PM marker
 *   * `'Z'`: 4 digit (+sign) representation of the timezone offset (-1200-+1200)
 *   * `'ww'`: Week of year, padded (00-53). Week 01 is the week with the first Thursday of the year
 *   * `'w'`: Week of year (0-53). Week 1 is the week with the first Thursday of the year
 *   * `'G'`, `'GG'`, `'GGG'`: The abbreviated form of the era string (e.g. 'AD')
 *   * `'GGGG'`: The long form of the era string (e.g. 'Anno Domini')
 *
 *   `format` string can also be one of the following predefined
 *   {@link guide/i18n localizable formats}:
 *
 *   * `'medium'`: equivalent to `'MMM d, y h:mm:ss a'` for en_US locale
 *     (e.g. Sep 3, 2010 12:05:08 PM)
 *   * `'short'`: equivalent to `'M/d/yy h:mm a'` for en_US  locale (e.g. 9/3/10 12:05 PM)
 *   * `'fullDate'`: equivalent to `'EEEE, MMMM d, y'` for en_US  locale
 *     (e.g. Friday, September 3, 2010)
 *   * `'longDate'`: equivalent to `'MMMM d, y'` for en_US  locale (e.g. September 3, 2010)
 *   * `'mediumDate'`: equivalent to `'MMM d, y'` for en_US  locale (e.g. Sep 3, 2010)
 *   * `'shortDate'`: equivalent to `'M/d/yy'` for en_US locale (e.g. 9/3/10)
 *   * `'mediumTime'`: equivalent to `'h:mm:ss a'` for en_US locale (e.g. 12:05:08 PM)
 *   * `'shortTime'`: equivalent to `'h:mm a'` for en_US locale (e.g. 12:05 PM)
 *
 *   `format` string can contain literal values. These need to be escaped by surrounding with single quotes (e.g.
 *   `"h 'in the morning'"`). In order to output a single quote, escape it - i.e., two single quotes in a sequence
 *   (e.g. `"h 'o''clock'"`).
 *
 * @param {(Date|number|string)} date Date to format either as Date object, milliseconds (string or
 *    number) or various ISO 8601 datetime string formats (e.g. yyyy-MM-ddTHH:mm:ss.sssZ and its
 *    shorter versions like yyyy-MM-ddTHH:mmZ, yyyy-MM-dd or yyyyMMddTHHmmssZ). If no timezone is
 *    specified in the string input, the time is considered to be in the local timezone.
 * @param {string=} format Formatting rules (see Description). If not specified,
 *    `mediumDate` is used.
 * @param {string=} timezone Timezone to be used for formatting. It understands UTC/GMT and the
 *    continental US time zone abbreviations, but for general use, use a time zone offset, for
 *    example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
 *    If not specified, the timezone of the browser will be used.
 * @returns {string} Formatted string or the input if input is not recognized as date/millis.
 *
 * @example
   <example>
     <file name="index.html">
       <span ng-non-bindable>{{1288323623006 | date:'medium'}}</span>:
           <span>{{1288323623006 | date:'medium'}}</span><br>
       <span ng-non-bindable>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span>:
          <span>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span><br>
       <span ng-non-bindable>{{1288323623006 | date:'MM/dd/yyyy @ h:mma'}}</span>:
          <span>{{'1288323623006' | date:'MM/dd/yyyy @ h:mma'}}</span><br>
       <span ng-non-bindable>{{1288323623006 | date:"MM/dd/yyyy 'at' h:mma"}}</span>:
          <span>{{'1288323623006' | date:"MM/dd/yyyy 'at' h:mma"}}</span><br>
     </file>
     <file name="protractor.js" type="protractor">
       it('should format date', function() {
         expect(element(by.binding("1288323623006 | date:'medium'")).getText()).
            toMatch(/Oct 2\d, 2010 \d{1,2}:\d{2}:\d{2} (AM|PM)/);
         expect(element(by.binding("1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'")).getText()).
            toMatch(/2010\-10\-2\d \d{2}:\d{2}:\d{2} (\-|\+)?\d{4}/);
         expect(element(by.binding("'1288323623006' | date:'MM/dd/yyyy @ h:mma'")).getText()).
            toMatch(/10\/2\d\/2010 @ \d{1,2}:\d{2}(AM|PM)/);
         expect(element(by.binding("'1288323623006' | date:\"MM/dd/yyyy 'at' h:mma\"")).getText()).
            toMatch(/10\/2\d\/2010 at \d{1,2}:\d{2}(AM|PM)/);
       });
     </file>
   </example>
 */
dateFilter.$inject = ['$locale'];
function dateFilter($locale) {


  var R_ISO8601_STR = /^(\d{4})-?(\d\d)-?(\d\d)(?:T(\d\d)(?::?(\d\d)(?::?(\d\d)(?:\.(\d+))?)?)?(Z|([+-])(\d\d):?(\d\d))?)?$/;
                     // 1        2       3         4          5          6          7          8  9     10      11
  function jsonStringToDate(string) {
    var match;
    if (match = string.match(R_ISO8601_STR)) {
      var date = new Date(0),
          tzHour = 0,
          tzMin  = 0,
          dateSetter = match[8] ? date.setUTCFullYear : date.setFullYear,
          timeSetter = match[8] ? date.setUTCHours : date.setHours;

      if (match[9]) {
        tzHour = toInt(match[9] + match[10]);
        tzMin = toInt(match[9] + match[11]);
      }
      dateSetter.call(date, toInt(match[1]), toInt(match[2]) - 1, toInt(match[3]));
      var h = toInt(match[4] || 0) - tzHour;
      var m = toInt(match[5] || 0) - tzMin;
      var s = toInt(match[6] || 0);
      var ms = Math.round(parseFloat('0.' + (match[7] || 0)) * 1000);
      timeSetter.call(date, h, m, s, ms);
      return date;
    }
    return string;
  }


  return function(date, format, timezone) {
    var text = '',
        parts = [],
        fn, match;

    format = format || 'mediumDate';
    format = $locale.DATETIME_FORMATS[format] || format;
    if (isString(date)) {
      date = NUMBER_STRING.test(date) ? toInt(date) : jsonStringToDate(date);
    }

    if (isNumber(date)) {
      date = new Date(date);
    }

    if (!isDate(date) || !isFinite(date.getTime())) {
      return date;
    }

    while (format) {
      match = DATE_FORMATS_SPLIT.exec(format);
      if (match) {
        parts = concat(parts, match, 1);
        format = parts.pop();
      } else {
        parts.push(format);
        format = null;
      }
    }

    var dateTimezoneOffset = date.getTimezoneOffset();
    if (timezone) {
      dateTimezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
      date = convertTimezoneToLocal(date, timezone, true);
    }
    forEach(parts, function(value) {
      fn = DATE_FORMATS[value];
      text += fn ? fn(date, $locale.DATETIME_FORMATS, dateTimezoneOffset)
                 : value === "''" ? "'" : value.replace(/(^'|'$)/g, '').replace(/''/g, "'");
    });

    return text;
  };
}


/**
 * @ngdoc filter
 * @name json
 * @kind function
 *
 * @description
 *   Allows you to convert a JavaScript object into JSON string.
 *
 *   This filter is mostly useful for debugging. When using the double curly {{value}} notation
 *   the binding is automatically converted to JSON.
 *
 * @param {*} object Any JavaScript object (including arrays and primitive types) to filter.
 * @param {number=} spacing The number of spaces to use per indentation, defaults to 2.
 * @returns {string} JSON string.
 *
 *
 * @example
   <example>
     <file name="index.html">
       <pre id="default-spacing">{{ {'name':'value'} | json }}</pre>
       <pre id="custom-spacing">{{ {'name':'value'} | json:4 }}</pre>
     </file>
     <file name="protractor.js" type="protractor">
       it('should jsonify filtered objects', function() {
         expect(element(by.id('default-spacing')).getText()).toMatch(/\{\n  "name": ?"value"\n}/);
         expect(element(by.id('custom-spacing')).getText()).toMatch(/\{\n    "name": ?"value"\n}/);
       });
     </file>
   </example>
 *
 */
function jsonFilter() {
  return function(object, spacing) {
    if (isUndefined(spacing)) {
        spacing = 2;
    }
    return toJson(object, spacing);
  };
}


/**
 * @ngdoc filter
 * @name lowercase
 * @kind function
 * @description
 * Converts string to lowercase.
 * @see angular.lowercase
 */
var lowercaseFilter = valueFn(lowercase);


/**
 * @ngdoc filter
 * @name uppercase
 * @kind function
 * @description
 * Converts string to uppercase.
 * @see angular.uppercase
 */
var uppercaseFilter = valueFn(uppercase);

/**
 * @ngdoc filter
 * @name limitTo
 * @kind function
 *
 * @description
 * Creates a new array or string containing only a specified number of elements. The elements are
 * taken from either the beginning or the end of the source array, string or number, as specified by
 * the value and sign (positive or negative) of `limit`. Other array-like objects are also supported
 * (e.g. array subclasses, NodeLists, jqLite/jQuery collections etc). If a number is used as input,
 * it is converted to a string.
 *
 * @param {Array|ArrayLike|string|number} input - Array/array-like, string or number to be limited.
 * @param {string|number} limit - The length of the returned array or string. If the `limit` number
 *     is positive, `limit` number of items from the beginning of the source array/string are copied.
 *     If the number is negative, `limit` number  of items from the end of the source array/string
 *     are copied. The `limit` will be trimmed if it exceeds `array.length`. If `limit` is undefined,
 *     the input will be returned unchanged.
 * @param {(string|number)=} begin - Index at which to begin limitation. As a negative index,
 *     `begin` indicates an offset from the end of `input`. Defaults to `0`.
 * @returns {Array|string} A new sub-array or substring of length `limit` or less if the input had
 *     less than `limit` elements.
 *
 * @example
   <example module="limitToExample">
     <file name="index.html">
       <script>
         angular.module('limitToExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.numbers = [1,2,3,4,5,6,7,8,9];
             $scope.letters = "abcdefghi";
             $scope.longNumber = 2345432342;
             $scope.numLimit = 3;
             $scope.letterLimit = 3;
             $scope.longNumberLimit = 3;
           }]);
       </script>
       <div ng-controller="ExampleController">
         <label>
            Limit {{numbers}} to:
            <input type="number" step="1" ng-model="numLimit">
         </label>
         <p>Output numbers: {{ numbers | limitTo:numLimit }}</p>
         <label>
            Limit {{letters}} to:
            <input type="number" step="1" ng-model="letterLimit">
         </label>
         <p>Output letters: {{ letters | limitTo:letterLimit }}</p>
         <label>
            Limit {{longNumber}} to:
            <input type="number" step="1" ng-model="longNumberLimit">
         </label>
         <p>Output long number: {{ longNumber | limitTo:longNumberLimit }}</p>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
       var numLimitInput = element(by.model('numLimit'));
       var letterLimitInput = element(by.model('letterLimit'));
       var longNumberLimitInput = element(by.model('longNumberLimit'));
       var limitedNumbers = element(by.binding('numbers | limitTo:numLimit'));
       var limitedLetters = element(by.binding('letters | limitTo:letterLimit'));
       var limitedLongNumber = element(by.binding('longNumber | limitTo:longNumberLimit'));

       it('should limit the number array to first three items', function() {
         expect(numLimitInput.getAttribute('value')).toBe('3');
         expect(letterLimitInput.getAttribute('value')).toBe('3');
         expect(longNumberLimitInput.getAttribute('value')).toBe('3');
         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3]');
         expect(limitedLetters.getText()).toEqual('Output letters: abc');
         expect(limitedLongNumber.getText()).toEqual('Output long number: 234');
       });

       // There is a bug in safari and protractor that doesn't like the minus key
       // it('should update the output when -3 is entered', function() {
       //   numLimitInput.clear();
       //   numLimitInput.sendKeys('-3');
       //   letterLimitInput.clear();
       //   letterLimitInput.sendKeys('-3');
       //   longNumberLimitInput.clear();
       //   longNumberLimitInput.sendKeys('-3');
       //   expect(limitedNumbers.getText()).toEqual('Output numbers: [7,8,9]');
       //   expect(limitedLetters.getText()).toEqual('Output letters: ghi');
       //   expect(limitedLongNumber.getText()).toEqual('Output long number: 342');
       // });

       it('should not exceed the maximum size of input array', function() {
         numLimitInput.clear();
         numLimitInput.sendKeys('100');
         letterLimitInput.clear();
         letterLimitInput.sendKeys('100');
         longNumberLimitInput.clear();
         longNumberLimitInput.sendKeys('100');
         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3,4,5,6,7,8,9]');
         expect(limitedLetters.getText()).toEqual('Output letters: abcdefghi');
         expect(limitedLongNumber.getText()).toEqual('Output long number: 2345432342');
       });
     </file>
   </example>
*/
function limitToFilter() {
  return function(input, limit, begin) {
    if (Math.abs(Number(limit)) === Infinity) {
      limit = Number(limit);
    } else {
      limit = toInt(limit);
    }
    if (isNaN(limit)) return input;

    if (isNumber(input)) input = input.toString();
    if (!isArrayLike(input)) return input;

    begin = (!begin || isNaN(begin)) ? 0 : toInt(begin);
    begin = (begin < 0) ? Math.max(0, input.length + begin) : begin;

    if (limit >= 0) {
      return sliceFn(input, begin, begin + limit);
    } else {
      if (begin === 0) {
        return sliceFn(input, limit, input.length);
      } else {
        return sliceFn(input, Math.max(0, begin + limit), begin);
      }
    }
  };
}

function sliceFn(input, begin, end) {
  if (isString(input)) return input.slice(begin, end);

  return slice.call(input, begin, end);
}

/**
 * @ngdoc filter
 * @name orderBy
 * @kind function
 *
 * @description
 * Returns an array containing the items from the specified `collection`, ordered by a `comparator`
 * function based on the values computed using the `expression` predicate.
 *
 * For example, `[{id: 'foo'}, {id: 'bar'}] | orderBy:'id'` would result in
 * `[{id: 'bar'}, {id: 'foo'}]`.
 *
 * The `collection` can be an Array or array-like object (e.g. NodeList, jQuery object, TypedArray,
 * String, etc).
 *
 * The `expression` can be a single predicate, or a list of predicates each serving as a tie-breaker
 * for the preceeding one. The `expression` is evaluated against each item and the output is used
 * for comparing with other items.
 *
 * You can change the sorting order by setting `reverse` to `true`. By default, items are sorted in
 * ascending order.
 *
 * The comparison is done using the `comparator` function. If none is specified, a default, built-in
 * comparator is used (see below for details - in a nutshell, it compares numbers numerically and
 * strings alphabetically).
 *
 * ### Under the hood
 *
 * Ordering the specified `collection` happens in two phases:
 *
 * 1. All items are passed through the predicate (or predicates), and the returned values are saved
 *    along with their type (`string`, `number` etc). For example, an item `{label: 'foo'}`, passed
 *    through a predicate that extracts the value of the `label` property, would be transformed to:
 *    ```
 *    {
 *      value: 'foo',
 *      type: 'string',
 *      index: ...
 *    }
 *    ```
 * 2. The comparator function is used to sort the items, based on the derived values, types and
 *    indices.
 *
 * If you use a custom comparator, it will be called with pairs of objects of the form
 * `{value: ..., type: '...', index: ...}` and is expected to return `0` if the objects are equal
 * (as far as the comparator is concerned), `-1` if the 1st one should be ranked higher than the
 * second, or `1` otherwise.
 *
 * In order to ensure that the sorting will be deterministic across platforms, if none of the
 * specified predicates can distinguish between two items, `orderBy` will automatically introduce a
 * dummy predicate that returns the item's index as `value`.
 * (If you are using a custom comparator, make sure it can handle this predicate as well.)
 *
 * Finally, in an attempt to simplify things, if a predicate returns an object as the extracted
 * value for an item, `orderBy` will try to convert that object to a primitive value, before passing
 * it to the comparator. The following rules govern the conversion:
 *
 * 1. If the object has a `valueOf()` method that returns a primitive, its return value will be
 *    used instead.<br />
 *    (If the object has a `valueOf()` method that returns another object, then the returned object
 *    will be used in subsequent steps.)
 * 2. If the object has a custom `toString()` method (i.e. not the one inherited from `Object`) that
 *    returns a primitive, its return value will be used instead.<br />
 *    (If the object has a `toString()` method that returns another object, then the returned object
 *    will be used in subsequent steps.)
 * 3. No conversion; the object itself is used.
 *
 * ### The default comparator
 *
 * The default, built-in comparator should be sufficient for most usecases. In short, it compares
 * numbers numerically, strings alphabetically (and case-insensitively), for objects falls back to
 * using their index in the original collection, and sorts values of different types by type.
 *
 * More specifically, it follows these steps to determine the relative order of items:
 *
 * 1. If the compared values are of different types, compare the types themselves alphabetically.
 * 2. If both values are of type `string`, compare them alphabetically in a case- and
 *    locale-insensitive way.
 * 3. If both values are objects, compare their indices instead.
 * 4. Otherwise, return:
 *    -  `0`, if the values are equal (by strict equality comparison, i.e. using `===`).
 *    - `-1`, if the 1st value is "less than" the 2nd value (compared using the `<` operator).
 *    -  `1`, otherwise.
 *
 * **Note:** If you notice numbers not being sorted as expected, make sure they are actually being
 *           saved as numbers and not strings.
 *
 * @param {Array|ArrayLike} collection - The collection (array or array-like object) to sort.
 * @param {(Function|string|Array.<Function|string>)=} expression - A predicate (or list of
 *    predicates) to be used by the comparator to determine the order of elements.
 *
 *    Can be one of:
 *
 *    - `Function`: A getter function. This function will be called with each item as argument and
 *      the return value will be used for sorting.
 *    - `string`: An Angular expression. This expression will be evaluated against each item and the
 *      result will be used for sorting. For example, use `'label'` to sort by a property called
 *      `label` or `'label.substring(0, 3)'` to sort by the first 3 characters of the `label`
 *      property.<br />
 *      (The result of a constant expression is interpreted as a property name to be used for
 *      comparison. For example, use `'"special name"'` (note the extra pair of quotes) to sort by a
 *      property called `special name`.)<br />
 *      An expression can be optionally prefixed with `+` or `-` to control the sorting direction,
 *      ascending or descending. For example, `'+label'` or `'-label'`. If no property is provided,
 *      (e.g. `'+'` or `'-'`), the collection element itself is used in comparisons.
 *    - `Array`: An array of function and/or string predicates. If a predicate cannot determine the
 *      relative order of two items, the next predicate is used as a tie-breaker.
 *
 * **Note:** If the predicate is missing or empty then it defaults to `'+'`.
 *
 * @param {boolean=} reverse - If `true`, reverse the sorting order.
 * @param {(Function)=} comparator - The comparator function used to determine the relative order of
 *    value pairs. If omitted, the built-in comparator will be used.
 *
 * @returns {Array} - The sorted array.
 *
 *
 * @example
 * ### Ordering a table with `ngRepeat`
 *
 * The example below demonstrates a simple {@link ngRepeat ngRepeat}, where the data is sorted by
 * age in descending order (expression is set to `'-age'`). The `comparator` is not set, which means
 * it defaults to the built-in comparator.
 *
   <example name="orderBy-static" module="orderByExample1">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <table class="friends">
           <tr>
             <th>Name</th>
             <th>Phone Number</th>
             <th>Age</th>
           </tr>
           <tr ng-repeat="friend in friends | orderBy:'-age'">
             <td>{{friend.name}}</td>
             <td>{{friend.phone}}</td>
             <td>{{friend.age}}</td>
           </tr>
         </table>
       </div>
     </file>
     <file name="script.js">
       angular.module('orderByExample1', [])
         .controller('ExampleController', ['$scope', function($scope) {
           $scope.friends = [
             {name: 'John',   phone: '555-1212',  age: 10},
             {name: 'Mary',   phone: '555-9876',  age: 19},
             {name: 'Mike',   phone: '555-4321',  age: 21},
             {name: 'Adam',   phone: '555-5678',  age: 35},
             {name: 'Julie',  phone: '555-8765',  age: 29}
           ];
         }]);
     </file>
     <file name="style.css">
       .friends {
         border-collapse: collapse;
       }

       .friends th {
         border-bottom: 1px solid;
       }
       .friends td, .friends th {
         border-left: 1px solid;
         padding: 5px 10px;
       }
       .friends td:first-child, .friends th:first-child {
         border-left: none;
       }
     </file>
     <file name="protractor.js" type="protractor">
       // Element locators
       var names = element.all(by.repeater('friends').column('friend.name'));

       it('should sort friends by age in reverse order', function() {
         expect(names.get(0).getText()).toBe('Adam');
         expect(names.get(1).getText()).toBe('Julie');
         expect(names.get(2).getText()).toBe('Mike');
         expect(names.get(3).getText()).toBe('Mary');
         expect(names.get(4).getText()).toBe('John');
       });
     </file>
   </example>
 * <hr />
 *
 * @example
 * ### Changing parameters dynamically
 *
 * All parameters can be changed dynamically. The next example shows how you can make the columns of
 * a table sortable, by binding the `expression` and `reverse` parameters to scope properties.
 *
   <example name="orderBy-dynamic" module="orderByExample2">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
         <hr/>
         <button ng-click="propertyName = null; reverse = false">Set to unsorted</button>
         <hr/>
         <table class="friends">
           <tr>
             <th>
               <button ng-click="sortBy('name')">Name</button>
               <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
             </th>
             <th>
               <button ng-click="sortBy('phone')">Phone Number</button>
               <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
             </th>
             <th>
               <button ng-click="sortBy('age')">Age</button>
               <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
             </th>
           </tr>
           <tr ng-repeat="friend in friends | orderBy:propertyName:reverse">
             <td>{{friend.name}}</td>
             <td>{{friend.phone}}</td>
             <td>{{friend.age}}</td>
           </tr>
         </table>
       </div>
     </file>
     <file name="script.js">
       angular.module('orderByExample2', [])
         .controller('ExampleController', ['$scope', function($scope) {
           var friends = [
             {name: 'John',   phone: '555-1212',  age: 10},
             {name: 'Mary',   phone: '555-9876',  age: 19},
             {name: 'Mike',   phone: '555-4321',  age: 21},
             {name: 'Adam',   phone: '555-5678',  age: 35},
             {name: 'Julie',  phone: '555-8765',  age: 29}
           ];

           $scope.propertyName = 'age';
           $scope.reverse = true;
           $scope.friends = friends;

           $scope.sortBy = function(propertyName) {
             $scope.reverse = ($scope.propertyName === propertyName) ? !$scope.reverse : false;
             $scope.propertyName = propertyName;
           };
         }]);
     </file>
     <file name="style.css">
       .friends {
         border-collapse: collapse;
       }

       .friends th {
         border-bottom: 1px solid;
       }
       .friends td, .friends th {
         border-left: 1px solid;
         padding: 5px 10px;
       }
       .friends td:first-child, .friends th:first-child {
         border-left: none;
       }

       .sortorder:after {
         content: '\25b2';   // BLACK UP-POINTING TRIANGLE
       }
       .sortorder.reverse:after {
         content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
       }
     </file>
     <file name="protractor.js" type="protractor">
       // Element locators
       var unsortButton = element(by.partialButtonText('unsorted'));
       var nameHeader = element(by.partialButtonText('Name'));
       var phoneHeader = element(by.partialButtonText('Phone'));
       var ageHeader = element(by.partialButtonText('Age'));
       var firstName = element(by.repeater('friends').column('friend.name').row(0));
       var lastName = element(by.repeater('friends').column('friend.name').row(4));

       it('should sort friends by some property, when clicking on the column header', function() {
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');

         phoneHeader.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Mary');

         nameHeader.click();
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('Mike');

         ageHeader.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Adam');
       });

       it('should sort friends in reverse order, when clicking on the same column', function() {
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');

         ageHeader.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Adam');

         ageHeader.click();
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');
       });

       it('should restore the original order, when clicking "Set to unsorted"', function() {
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');

         unsortButton.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Julie');
       });
     </file>
   </example>
 * <hr />
 *
 * @example
 * ### Using `orderBy` inside a controller
 *
 * It is also possible to call the `orderBy` filter manually, by injecting `orderByFilter`, and
 * calling it with the desired parameters. (Alternatively, you could inject the `$filter` factory
 * and retrieve the `orderBy` filter with `$filter('orderBy')`.)
 *
   <example name="orderBy-call-manually" module="orderByExample3">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
         <hr/>
         <button ng-click="sortBy(null)">Set to unsorted</button>
         <hr/>
         <table class="friends">
           <tr>
             <th>
               <button ng-click="sortBy('name')">Name</button>
               <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
             </th>
             <th>
               <button ng-click="sortBy('phone')">Phone Number</button>
               <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
             </th>
             <th>
               <button ng-click="sortBy('age')">Age</button>
               <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
             </th>
           </tr>
           <tr ng-repeat="friend in friends">
             <td>{{friend.name}}</td>
             <td>{{friend.phone}}</td>
             <td>{{friend.age}}</td>
           </tr>
         </table>
       </div>
     </file>
     <file name="script.js">
       angular.module('orderByExample3', [])
         .controller('ExampleController', ['$scope', 'orderByFilter', function($scope, orderBy) {
           var friends = [
             {name: 'John',   phone: '555-1212',  age: 10},
             {name: 'Mary',   phone: '555-9876',  age: 19},
             {name: 'Mike',   phone: '555-4321',  age: 21},
             {name: 'Adam',   phone: '555-5678',  age: 35},
             {name: 'Julie',  phone: '555-8765',  age: 29}
           ];

           $scope.propertyName = 'age';
           $scope.reverse = true;
           $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);

           $scope.sortBy = function(propertyName) {
             $scope.reverse = (propertyName !== null && $scope.propertyName === propertyName)
                 ? !$scope.reverse : false;
             $scope.propertyName = propertyName;
             $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);
           };
         }]);
     </file>
     <file name="style.css">
       .friends {
         border-collapse: collapse;
       }

       .friends th {
         border-bottom: 1px solid;
       }
       .friends td, .friends th {
         border-left: 1px solid;
         padding: 5px 10px;
       }
       .friends td:first-child, .friends th:first-child {
         border-left: none;
       }

       .sortorder:after {
         content: '\25b2';   // BLACK UP-POINTING TRIANGLE
       }
       .sortorder.reverse:after {
         content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
       }
     </file>
     <file name="protractor.js" type="protractor">
       // Element locators
       var unsortButton = element(by.partialButtonText('unsorted'));
       var nameHeader = element(by.partialButtonText('Name'));
       var phoneHeader = element(by.partialButtonText('Phone'));
       var ageHeader = element(by.partialButtonText('Age'));
       var firstName = element(by.repeater('friends').column('friend.name').row(0));
       var lastName = element(by.repeater('friends').column('friend.name').row(4));

       it('should sort friends by some property, when clicking on the column header', function() {
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');

         phoneHeader.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Mary');

         nameHeader.click();
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('Mike');

         ageHeader.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Adam');
       });

       it('should sort friends in reverse order, when clicking on the same column', function() {
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');

         ageHeader.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Adam');

         ageHeader.click();
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');
       });

       it('should restore the original order, when clicking "Set to unsorted"', function() {
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');

         unsortButton.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Julie');
       });
     </file>
   </example>
 * <hr />
 *
 * @example
 * ### Using a custom comparator
 *
 * If you have very specific requirements about the way items are sorted, you can pass your own
 * comparator function. For example, you might need to compare some strings in a locale-sensitive
 * way. (When specifying a custom comparator, you also need to pass a value for the `reverse`
 * argument - passing `false` retains the default sorting order, i.e. ascending.)
 *
   <example name="orderBy-custom-comparator" module="orderByExample4">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <div class="friends-container custom-comparator">
           <h3>Locale-sensitive Comparator</h3>
           <table class="friends">
             <tr>
               <th>Name</th>
               <th>Favorite Letter</th>
             </tr>
             <tr ng-repeat="friend in friends | orderBy:'favoriteLetter':false:localeSensitiveComparator">
               <td>{{friend.name}}</td>
               <td>{{friend.favoriteLetter}}</td>
             </tr>
           </table>
         </div>
         <div class="friends-container default-comparator">
           <h3>Default Comparator</h3>
           <table class="friends">
             <tr>
               <th>Name</th>
               <th>Favorite Letter</th>
             </tr>
             <tr ng-repeat="friend in friends | orderBy:'favoriteLetter'">
               <td>{{friend.name}}</td>
               <td>{{friend.favoriteLetter}}</td>
             </tr>
           </table>
         </div>
       </div>
     </file>
     <file name="script.js">
       angular.module('orderByExample4', [])
         .controller('ExampleController', ['$scope', function($scope) {
           $scope.friends = [
             {name: 'John',   favoriteLetter: 'Ä'},
             {name: 'Mary',   favoriteLetter: 'Ü'},
             {name: 'Mike',   favoriteLetter: 'Ö'},
             {name: 'Adam',   favoriteLetter: 'H'},
             {name: 'Julie',  favoriteLetter: 'Z'}
           ];

           $scope.localeSensitiveComparator = function(v1, v2) {
             // If we don't get strings, just compare by index
             if (v1.type !== 'string' || v2.type !== 'string') {
               return (v1.index < v2.index) ? -1 : 1;
             }

             // Compare strings alphabetically, taking locale into account
             return v1.value.localeCompare(v2.value);
           };
         }]);
     </file>
     <file name="style.css">
       .friends-container {
         display: inline-block;
         margin: 0 30px;
       }

       .friends {
         border-collapse: collapse;
       }

       .friends th {
         border-bottom: 1px solid;
       }
       .friends td, .friends th {
         border-left: 1px solid;
         padding: 5px 10px;
       }
       .friends td:first-child, .friends th:first-child {
         border-left: none;
       }
     </file>
     <file name="protractor.js" type="protractor">
       // Element locators
       var container = element(by.css('.custom-comparator'));
       var names = container.all(by.repeater('friends').column('friend.name'));

       it('should sort friends by favorite letter (in correct alphabetical order)', function() {
         expect(names.get(0).getText()).toBe('John');
         expect(names.get(1).getText()).toBe('Adam');
         expect(names.get(2).getText()).toBe('Mike');
         expect(names.get(3).getText()).toBe('Mary');
         expect(names.get(4).getText()).toBe('Julie');
       });
     </file>
   </example>
 *
 */
orderByFilter.$inject = ['$parse'];
function orderByFilter($parse) {
  return function(array, sortPredicate, reverseOrder, compareFn) {

    if (array == null) return array;
    if (!isArrayLike(array)) {
      throw minErr('orderBy')('notarray', 'Expected array but received: {0}', array);
    }

    if (!isArray(sortPredicate)) { sortPredicate = [sortPredicate]; }
    if (sortPredicate.length === 0) { sortPredicate = ['+']; }

    var predicates = processPredicates(sortPredicate);

    var descending = reverseOrder ? -1 : 1;

    // Define the `compare()` function. Use a default comparator if none is specified.
    var compare = isFunction(compareFn) ? compareFn : defaultCompare;

    // The next three lines are a version of a Swartzian Transform idiom from Perl
    // (sometimes called the Decorate-Sort-Undecorate idiom)
    // See https://en.wikipedia.org/wiki/Schwartzian_transform
    var compareValues = Array.prototype.map.call(array, getComparisonObject);
    compareValues.sort(doComparison);
    array = compareValues.map(function(item) { return item.value; });

    return array;

    function getComparisonObject(value, index) {
      // NOTE: We are adding an extra `tieBreaker` value based on the element's index.
      // This will be used to keep the sort stable when none of the input predicates can
      // distinguish between two elements.
      return {
        value: value,
        tieBreaker: {value: index, type: 'number', index: index},
        predicateValues: predicates.map(function(predicate) {
          return getPredicateValue(predicate.get(value), index);
        })
      };
    }

    function doComparison(v1, v2) {
      for (var i = 0, ii = predicates.length; i < ii; i++) {
        var result = compare(v1.predicateValues[i], v2.predicateValues[i]);
        if (result) {
          return result * predicates[i].descending * descending;
        }
      }

      return compare(v1.tieBreaker, v2.tieBreaker) * descending;
    }
  };

  function processPredicates(sortPredicates) {
    return sortPredicates.map(function(predicate) {
      var descending = 1, get = identity;

      if (isFunction(predicate)) {
        get = predicate;
      } else if (isString(predicate)) {
        if ((predicate.charAt(0) == '+' || predicate.charAt(0) == '-')) {
          descending = predicate.charAt(0) == '-' ? -1 : 1;
          predicate = predicate.substring(1);
        }
        if (predicate !== '') {
          get = $parse(predicate);
          if (get.constant) {
            var key = get();
            get = function(value) { return value[key]; };
          }
        }
      }
      return {get: get, descending: descending};
    });
  }

  function isPrimitive(value) {
    switch (typeof value) {
      case 'number': /* falls through */
      case 'boolean': /* falls through */
      case 'string':
        return true;
      default:
        return false;
    }
  }

  function objectValue(value) {
    // If `valueOf` is a valid function use that
    if (isFunction(value.valueOf)) {
      value = value.valueOf();
      if (isPrimitive(value)) return value;
    }
    // If `toString` is a valid function and not the one from `Object.prototype` use that
    if (hasCustomToString(value)) {
      value = value.toString();
      if (isPrimitive(value)) return value;
    }

    return value;
  }

  function getPredicateValue(value, index) {
    var type = typeof value;
    if (value === null) {
      type = 'string';
      value = 'null';
    } else if (type === 'object') {
      value = objectValue(value);
    }
    return {value: value, type: type, index: index};
  }

  function defaultCompare(v1, v2) {
    var result = 0;
    var type1 = v1.type;
    var type2 = v2.type;

    if (type1 === type2) {
      var value1 = v1.value;
      var value2 = v2.value;

      if (type1 === 'string') {
        // Compare strings case-insensitively
        value1 = value1.toLowerCase();
        value2 = value2.toLowerCase();
      } else if (type1 === 'object') {
        // For basic objects, use the position of the object
        // in the collection instead of the value
        if (isObject(value1)) value1 = v1.index;
        if (isObject(value2)) value2 = v2.index;
      }

      if (value1 !== value2) {
        result = value1 < value2 ? -1 : 1;
      }
    } else {
      result = type1 < type2 ? -1 : 1;
    }

    return result;
  }
}

function ngDirective(directive) {
  if (isFunction(directive)) {
    directive = {
      link: directive
    };
  }
  directive.restrict = directive.restrict || 'AC';
  return valueFn(directive);
}

/**
 * @ngdoc directive
 * @name a
 * @restrict E
 *
 * @description
 * Modifies the default behavior of the html A tag so that the default action is prevented when
 * the href attribute is empty.
 *
 * This change permits the easy creation of action links with the `ngClick` directive
 * without changing the location or causing page reloads, e.g.:
 * `<a href="" ng-click="list.addItem()">Add Item</a>`
 */
var htmlAnchorDirective = valueFn({
  restrict: 'E',
  compile: function(element, attr) {
    if (!attr.href && !attr.xlinkHref) {
      return function(scope, element) {
        // If the linked element is not an anchor tag anymore, do nothing
        if (element[0].nodeName.toLowerCase() !== 'a') return;

        // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
        var href = toString.call(element.prop('href')) === '[object SVGAnimatedString]' ?
                   'xlink:href' : 'href';
        element.on('click', function(event) {
          // if we have no href url, then don't navigate anywhere.
          if (!element.attr(href)) {
            event.preventDefault();
          }
        });
      };
    }
  }
});

/**
 * @ngdoc directive
 * @name ngHref
 * @restrict A
 * @priority 99
 *
 * @description
 * Using Angular markup like `{{hash}}` in an href attribute will
 * make the link go to the wrong URL if the user clicks it before
 * Angular has a chance to replace the `{{hash}}` markup with its
 * value. Until Angular replaces the markup the link will be broken
 * and will most likely return a 404 error. The `ngHref` directive
 * solves this problem.
 *
 * The wrong way to write it:
 * ```html
 * <a href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
 * ```
 *
 * The correct way to write it:
 * ```html
 * <a ng-href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
 * ```
 *
 * @element A
 * @param {template} ngHref any string which can contain `{{}}` markup.
 *
 * @example
 * This example shows various combinations of `href`, `ng-href` and `ng-click` attributes
 * in links and their different behaviors:
    <example>
      <file name="index.html">
        <input ng-model="value" /><br />
        <a id="link-1" href ng-click="value = 1">link 1</a> (link, don't reload)<br />
        <a id="link-2" href="" ng-click="value = 2">link 2</a> (link, don't reload)<br />
        <a id="link-3" ng-href="/{{'123'}}">link 3</a> (link, reload!)<br />
        <a id="link-4" href="" name="xx" ng-click="value = 4">anchor</a> (link, don't reload)<br />
        <a id="link-5" name="xxx" ng-click="value = 5">anchor</a> (no link)<br />
        <a id="link-6" ng-href="{{value}}">link</a> (link, change location)
      </file>
      <file name="protractor.js" type="protractor">
        it('should execute ng-click but not reload when href without value', function() {
          element(by.id('link-1')).click();
          expect(element(by.model('value')).getAttribute('value')).toEqual('1');
          expect(element(by.id('link-1')).getAttribute('href')).toBe('');
        });

        it('should execute ng-click but not reload when href empty string', function() {
          element(by.id('link-2')).click();
          expect(element(by.model('value')).getAttribute('value')).toEqual('2');
          expect(element(by.id('link-2')).getAttribute('href')).toBe('');
        });

        it('should execute ng-click and change url when ng-href specified', function() {
          expect(element(by.id('link-3')).getAttribute('href')).toMatch(/\/123$/);

          element(by.id('link-3')).click();

          // At this point, we navigate away from an Angular page, so we need
          // to use browser.driver to get the base webdriver.

          browser.wait(function() {
            return browser.driver.getCurrentUrl().then(function(url) {
              return url.match(/\/123$/);
            });
          }, 5000, 'page should navigate to /123');
        });

        it('should execute ng-click but not reload when href empty string and name specified', function() {
          element(by.id('link-4')).click();
          expect(element(by.model('value')).getAttribute('value')).toEqual('4');
          expect(element(by.id('link-4')).getAttribute('href')).toBe('');
        });

        it('should execute ng-click but not reload when no href but name specified', function() {
          element(by.id('link-5')).click();
          expect(element(by.model('value')).getAttribute('value')).toEqual('5');
          expect(element(by.id('link-5')).getAttribute('href')).toBe(null);
        });

        it('should only change url when only ng-href', function() {
          element(by.model('value')).clear();
          element(by.model('value')).sendKeys('6');
          expect(element(by.id('link-6')).getAttribute('href')).toMatch(/\/6$/);

          element(by.id('link-6')).click();

          // At this point, we navigate away from an Angular page, so we need
          // to use browser.driver to get the base webdriver.
          browser.wait(function() {
            return browser.driver.getCurrentUrl().then(function(url) {
              return url.match(/\/6$/);
            });
          }, 5000, 'page should navigate to /6');
        });
      </file>
    </example>
 */

/**
 * @ngdoc directive
 * @name ngSrc
 * @restrict A
 * @priority 99
 *
 * @description
 * Using Angular markup like `{{hash}}` in a `src` attribute doesn't
 * work right: The browser will fetch from the URL with the literal
 * text `{{hash}}` until Angular replaces the expression inside
 * `{{hash}}`. The `ngSrc` directive solves this problem.
 *
 * The buggy way to write it:
 * ```html
 * <img src="http://www.gravatar.com/avatar/{{hash}}" alt="Description"/>
 * ```
 *
 * The correct way to write it:
 * ```html
 * <img ng-src="http://www.gravatar.com/avatar/{{hash}}" alt="Description" />
 * ```
 *
 * @element IMG
 * @param {template} ngSrc any string which can contain `{{}}` markup.
 */

/**
 * @ngdoc directive
 * @name ngSrcset
 * @restrict A
 * @priority 99
 *
 * @description
 * Using Angular markup like `{{hash}}` in a `srcset` attribute doesn't
 * work right: The browser will fetch from the URL with the literal
 * text `{{hash}}` until Angular replaces the expression inside
 * `{{hash}}`. The `ngSrcset` directive solves this problem.
 *
 * The buggy way to write it:
 * ```html
 * <img srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description"/>
 * ```
 *
 * The correct way to write it:
 * ```html
 * <img ng-srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description" />
 * ```
 *
 * @element IMG
 * @param {template} ngSrcset any string which can contain `{{}}` markup.
 */

/**
 * @ngdoc directive
 * @name ngDisabled
 * @restrict A
 * @priority 100
 *
 * @description
 *
 * This directive sets the `disabled` attribute on the element if the
 * {@link guide/expression expression} inside `ngDisabled` evaluates to truthy.
 *
 * A special directive is necessary because we cannot use interpolation inside the `disabled`
 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
 *
 * @example
    <example>
      <file name="index.html">
        <label>Click me to toggle: <input type="checkbox" ng-model="checked"></label><br/>
        <button ng-model="button" ng-disabled="checked">Button</button>
      </file>
      <file name="protractor.js" type="protractor">
        it('should toggle button', function() {
          expect(element(by.css('button')).getAttribute('disabled')).toBeFalsy();
          element(by.model('checked')).click();
          expect(element(by.css('button')).getAttribute('disabled')).toBeTruthy();
        });
      </file>
    </example>
 *
 * @element INPUT
 * @param {expression} ngDisabled If the {@link guide/expression expression} is truthy,
 *     then the `disabled` attribute will be set on the element
 */


/**
 * @ngdoc directive
 * @name ngChecked
 * @restrict A
 * @priority 100
 *
 * @description
 * Sets the `checked` attribute on the element, if the expression inside `ngChecked` is truthy.
 *
 * Note that this directive should not be used together with {@link ngModel `ngModel`},
 * as this can lead to unexpected behavior.
 *
 * A special directive is necessary because we cannot use interpolation inside the `checked`
 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
 *
 * @example
    <example>
      <file name="index.html">
        <label>Check me to check both: <input type="checkbox" ng-model="master"></label><br/>
        <input id="checkSlave" type="checkbox" ng-checked="master" aria-label="Slave input">
      </file>
      <file name="protractor.js" type="protractor">
        it('should check both checkBoxes', function() {
          expect(element(by.id('checkSlave')).getAttribute('checked')).toBeFalsy();
          element(by.model('master')).click();
          expect(element(by.id('checkSlave')).getAttribute('checked')).toBeTruthy();
        });
      </file>
    </example>
 *
 * @element INPUT
 * @param {expression} ngChecked If the {@link guide/expression expression} is truthy,
 *     then the `checked` attribute will be set on the element
 */


/**
 * @ngdoc directive
 * @name ngReadonly
 * @restrict A
 * @priority 100
 *
 * @description
 *
 * Sets the `readonly` attribute on the element, if the expression inside `ngReadonly` is truthy.
 * Note that `readonly` applies only to `input` elements with specific types. [See the input docs on
 * MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-readonly) for more information.
 *
 * A special directive is necessary because we cannot use interpolation inside the `readonly`
 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
 *
 * @example
    <example>
      <file name="index.html">
        <label>Check me to make text readonly: <input type="checkbox" ng-model="checked"></label><br/>
        <input type="text" ng-readonly="checked" value="I'm Angular" aria-label="Readonly field" />
      </file>
      <file name="protractor.js" type="protractor">
        it('should toggle readonly attr', function() {
          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeFalsy();
          element(by.model('checked')).click();
          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeTruthy();
        });
      </file>
    </example>
 *
 * @element INPUT
 * @param {expression} ngReadonly If the {@link guide/expression expression} is truthy,
 *     then special attribute "readonly" will be set on the element
 */


/**
 * @ngdoc directive
 * @name ngSelected
 * @restrict A
 * @priority 100
 *
 * @description
 *
 * Sets the `selected` attribute on the element, if the expression inside `ngSelected` is truthy.
 *
 * A special directive is necessary because we cannot use interpolation inside the `selected`
 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
 *
 * <div class="alert alert-warning">
 *   **Note:** `ngSelected` does not interact with the `select` and `ngModel` directives, it only
 *   sets the `selected` attribute on the element. If you are using `ngModel` on the select, you
 *   should not use `ngSelected` on the options, as `ngModel` will set the select value and
 *   selected options.
 * </div>
 *
 * @example
    <example>
      <file name="index.html">
        <label>Check me to select: <input type="checkbox" ng-model="selected"></label><br/>
        <select aria-label="ngSelected demo">
          <option>Hello!</option>
          <option id="greet" ng-selected="selected">Greetings!</option>
        </select>
      </file>
      <file name="protractor.js" type="protractor">
        it('should select Greetings!', function() {
          expect(element(by.id('greet')).getAttribute('selected')).toBeFalsy();
          element(by.model('selected')).click();
          expect(element(by.id('greet')).getAttribute('selected')).toBeTruthy();
        });
      </file>
    </example>
 *
 * @element OPTION
 * @param {expression} ngSelected If the {@link guide/expression expression} is truthy,
 *     then special attribute "selected" will be set on the element
 */

/**
 * @ngdoc directive
 * @name ngOpen
 * @restrict A
 * @priority 100
 *
 * @description
 *
 * Sets the `open` attribute on the element, if the expression inside `ngOpen` is truthy.
 *
 * A special directive is necessary because we cannot use interpolation inside the `open`
 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
 *
 * ## A note about browser compatibility
 *
 * Edge, Firefox, and Internet Explorer do not support the `details` element, it is
 * recommended to use {@link ng.ngShow} and {@link ng.ngHide} instead.
 *
 * @example
     <example>
       <file name="index.html">
         <label>Check me check multiple: <input type="checkbox" ng-model="open"></label><br/>
         <details id="details" ng-open="open">
            <summary>Show/Hide me</summary>
         </details>
       </file>
       <file name="protractor.js" type="protractor">
         it('should toggle open', function() {
           expect(element(by.id('details')).getAttribute('open')).toBeFalsy();
           element(by.model('open')).click();
           expect(element(by.id('details')).getAttribute('open')).toBeTruthy();
         });
       </file>
     </example>
 *
 * @element DETAILS
 * @param {expression} ngOpen If the {@link guide/expression expression} is truthy,
 *     then special attribute "open" will be set on the element
 */

var ngAttributeAliasDirectives = {};

// boolean attrs are evaluated
forEach(BOOLEAN_ATTR, function(propName, attrName) {
  // binding to multiple is not supported
  if (propName == "multiple") return;

  function defaultLinkFn(scope, element, attr) {
    scope.$watch(attr[normalized], function ngBooleanAttrWatchAction(value) {
      attr.$set(attrName, !!value);
    });
  }

  var normalized = directiveNormalize('ng-' + attrName);
  var linkFn = defaultLinkFn;

  if (propName === 'checked') {
    linkFn = function(scope, element, attr) {
      // ensuring ngChecked doesn't interfere with ngModel when both are set on the same input
      if (attr.ngModel !== attr[normalized]) {
        defaultLinkFn(scope, element, attr);
      }
    };
  }

  ngAttributeAliasDirectives[normalized] = function() {
    return {
      restrict: 'A',
      priority: 100,
      link: linkFn
    };
  };
});

// aliased input attrs are evaluated
forEach(ALIASED_ATTR, function(htmlAttr, ngAttr) {
  ngAttributeAliasDirectives[ngAttr] = function() {
    return {
      priority: 100,
      link: function(scope, element, attr) {
        //special case ngPattern when a literal regular expression value
        //is used as the expression (this way we don't have to watch anything).
        if (ngAttr === "ngPattern" && attr.ngPattern.charAt(0) == "/") {
          var match = attr.ngPattern.match(REGEX_STRING_REGEXP);
          if (match) {
            attr.$set("ngPattern", new RegExp(match[1], match[2]));
            return;
          }
        }

        scope.$watch(attr[ngAttr], function ngAttrAliasWatchAction(value) {
          attr.$set(ngAttr, value);
        });
      }
    };
  };
});

// ng-src, ng-srcset, ng-href are interpolated
forEach(['src', 'srcset', 'href'], function(attrName) {
  var normalized = directiveNormalize('ng-' + attrName);
  ngAttributeAliasDirectives[normalized] = function() {
    return {
      priority: 99, // it needs to run after the attributes are interpolated
      link: function(scope, element, attr) {
        var propName = attrName,
            name = attrName;

        if (attrName === 'href' &&
            toString.call(element.prop('href')) === '[object SVGAnimatedString]') {
          name = 'xlinkHref';
          attr.$attr[name] = 'xlink:href';
          propName = null;
        }

        attr.$observe(normalized, function(value) {
          if (!value) {
            if (attrName === 'href') {
              attr.$set(name, null);
            }
            return;
          }

          attr.$set(name, value);

          // on IE, if "ng:src" directive declaration is used and "src" attribute doesn't exist
          // then calling element.setAttribute('src', 'foo') doesn't do anything, so we need
          // to set the property as well to achieve the desired effect.
          // we use attr[attrName] value since $set can sanitize the url.
          if (msie && propName) element.prop(propName, attr[name]);
        });
      }
    };
  };
});

/* global -nullFormCtrl, -SUBMITTED_CLASS, addSetValidityMethod: true
 */
var nullFormCtrl = {
  $addControl: noop,
  $$renameControl: nullFormRenameControl,
  $removeControl: noop,
  $setValidity: noop,
  $setDirty: noop,
  $setPristine: noop,
  $setSubmitted: noop
},
SUBMITTED_CLASS = 'ng-submitted';

function nullFormRenameControl(control, name) {
  control.$name = name;
}

/**
 * @ngdoc type
 * @name form.FormController
 *
 * @property {boolean} $pristine True if user has not interacted with the form yet.
 * @property {boolean} $dirty True if user has already interacted with the form.
 * @property {boolean} $valid True if all of the containing forms and controls are valid.
 * @property {boolean} $invalid True if at least one containing control or form is invalid.
 * @property {boolean} $pending True if at least one containing control or form is pending.
 * @property {boolean} $submitted True if user has submitted the form even if its invalid.
 *
 * @property {Object} $error Is an object hash, containing references to controls or
 *  forms with failing validators, where:
 *
 *  - keys are validation tokens (error names),
 *  - values are arrays of controls or forms that have a failing validator for given error name.
 *
 *  Built-in validation tokens:
 *
 *  - `email`
 *  - `max`
 *  - `maxlength`
 *  - `min`
 *  - `minlength`
 *  - `number`
 *  - `pattern`
 *  - `required`
 *  - `url`
 *  - `date`
 *  - `datetimelocal`
 *  - `time`
 *  - `week`
 *  - `month`
 *
 * @description
 * `FormController` keeps track of all its controls and nested forms as well as the state of them,
 * such as being valid/invalid or dirty/pristine.
 *
 * Each {@link ng.directive:form form} directive creates an instance
 * of `FormController`.
 *
 */
//asks for $scope to fool the BC controller module
FormController.$inject = ['$element', '$attrs', '$scope', '$animate', '$interpolate'];
function FormController(element, attrs, $scope, $animate, $interpolate) {
  var form = this,
      controls = [];

  // init state
  form.$error = {};
  form.$$success = {};
  form.$pending = undefined;
  form.$name = $interpolate(attrs.name || attrs.ngForm || '')($scope);
  form.$dirty = false;
  form.$pristine = true;
  form.$valid = true;
  form.$invalid = false;
  form.$submitted = false;
  form.$$parentForm = nullFormCtrl;

  /**
   * @ngdoc method
   * @name form.FormController#$rollbackViewValue
   *
   * @description
   * Rollback all form controls pending updates to the `$modelValue`.
   *
   * Updates may be pending by a debounced event or because the input is waiting for a some future
   * event defined in `ng-model-options`. This method is typically needed by the reset button of
   * a form that uses `ng-model-options` to pend updates.
   */
  form.$rollbackViewValue = function() {
    forEach(controls, function(control) {
      control.$rollbackViewValue();
    });
  };

  /**
   * @ngdoc method
   * @name form.FormController#$commitViewValue
   *
   * @description
   * Commit all form controls pending updates to the `$modelValue`.
   *
   * Updates may be pending by a debounced event or because the input is waiting for a some future
   * event defined in `ng-model-options`. This method is rarely needed as `NgModelController`
   * usually handles calling this in response to input events.
   */
  form.$commitViewValue = function() {
    forEach(controls, function(control) {
      control.$commitViewValue();
    });
  };

  /**
   * @ngdoc method
   * @name form.FormController#$addControl
   * @param {object} control control object, either a {@link form.FormController} or an
   * {@link ngModel.NgModelController}
   *
   * @description
   * Register a control with the form. Input elements using ngModelController do this automatically
   * when they are linked.
   *
   * Note that the current state of the control will not be reflected on the new parent form. This
   * is not an issue with normal use, as freshly compiled and linked controls are in a `$pristine`
   * state.
   *
   * However, if the method is used programmatically, for example by adding dynamically created controls,
   * or controls that have been previously removed without destroying their corresponding DOM element,
   * it's the developers responsibility to make sure the current state propagates to the parent form.
   *
   * For example, if an input control is added that is already `$dirty` and has `$error` properties,
   * calling `$setDirty()` and `$validate()` afterwards will propagate the state to the parent form.
   */
  form.$addControl = function(control) {
    // Breaking change - before, inputs whose name was "hasOwnProperty" were quietly ignored
    // and not added to the scope.  Now we throw an error.
    assertNotHasOwnProperty(control.$name, 'input');
    controls.push(control);

    if (control.$name) {
      form[control.$name] = control;
    }

    control.$$parentForm = form;
  };

  // Private API: rename a form control
  form.$$renameControl = function(control, newName) {
    var oldName = control.$name;

    if (form[oldName] === control) {
      delete form[oldName];
    }
    form[newName] = control;
    control.$name = newName;
  };

  /**
   * @ngdoc method
   * @name form.FormController#$removeControl
   * @param {object} control control object, either a {@link form.FormController} or an
   * {@link ngModel.NgModelController}
   *
   * @description
   * Deregister a control from the form.
   *
   * Input elements using ngModelController do this automatically when they are destroyed.
   *
   * Note that only the removed control's validation state (`$errors`etc.) will be removed from the
   * form. `$dirty`, `$submitted` states will not be changed, because the expected behavior can be
   * different from case to case. For example, removing the only `$dirty` control from a form may or
   * may not mean that the form is still `$dirty`.
   */
  form.$removeControl = function(control) {
    if (control.$name && form[control.$name] === control) {
      delete form[control.$name];
    }
    forEach(form.$pending, function(value, name) {
      form.$setValidity(name, null, control);
    });
    forEach(form.$error, function(value, name) {
      form.$setValidity(name, null, control);
    });
    forEach(form.$$success, function(value, name) {
      form.$setValidity(name, null, control);
    });

    arrayRemove(controls, control);
    control.$$parentForm = nullFormCtrl;
  };


  /**
   * @ngdoc method
   * @name form.FormController#$setValidity
   *
   * @description
   * Sets the validity of a form control.
   *
   * This method will also propagate to parent forms.
   */
  addSetValidityMethod({
    ctrl: this,
    $element: element,
    set: function(object, property, controller) {
      var list = object[property];
      if (!list) {
        object[property] = [controller];
      } else {
        var index = list.indexOf(controller);
        if (index === -1) {
          list.push(controller);
        }
      }
    },
    unset: function(object, property, controller) {
      var list = object[property];
      if (!list) {
        return;
      }
      arrayRemove(list, controller);
      if (list.length === 0) {
        delete object[property];
      }
    },
    $animate: $animate
  });

  /**
   * @ngdoc method
   * @name form.FormController#$setDirty
   *
   * @description
   * Sets the form to a dirty state.
   *
   * This method can be called to add the 'ng-dirty' class and set the form to a dirty
   * state (ng-dirty class). This method will also propagate to parent forms.
   */
  form.$setDirty = function() {
    $animate.removeClass(element, PRISTINE_CLASS);
    $animate.addClass(element, DIRTY_CLASS);
    form.$dirty = true;
    form.$pristine = false;
    form.$$parentForm.$setDirty();
  };

  /**
   * @ngdoc method
   * @name form.FormController#$setPristine
   *
   * @description
   * Sets the form to its pristine state.
   *
   * This method can be called to remove the 'ng-dirty' class and set the form to its pristine
   * state (ng-pristine class). This method will also propagate to all the controls contained
   * in this form.
   *
   * Setting a form back to a pristine state is often useful when we want to 'reuse' a form after
   * saving or resetting it.
   */
  form.$setPristine = function() {
    $animate.setClass(element, PRISTINE_CLASS, DIRTY_CLASS + ' ' + SUBMITTED_CLASS);
    form.$dirty = false;
    form.$pristine = true;
    form.$submitted = false;
    forEach(controls, function(control) {
      control.$setPristine();
    });
  };

  /**
   * @ngdoc method
   * @name form.FormController#$setUntouched
   *
   * @description
   * Sets the form to its untouched state.
   *
   * This method can be called to remove the 'ng-touched' class and set the form controls to their
   * untouched state (ng-untouched class).
   *
   * Setting a form controls back to their untouched state is often useful when setting the form
   * back to its pristine state.
   */
  form.$setUntouched = function() {
    forEach(controls, function(control) {
      control.$setUntouched();
    });
  };

  /**
   * @ngdoc method
   * @name form.FormController#$setSubmitted
   *
   * @description
   * Sets the form to its submitted state.
   */
  form.$setSubmitted = function() {
    $animate.addClass(element, SUBMITTED_CLASS);
    form.$submitted = true;
    form.$$parentForm.$setSubmitted();
  };
}

/**
 * @ngdoc directive
 * @name ngForm
 * @restrict EAC
 *
 * @description
 * Nestable alias of {@link ng.directive:form `form`} directive. HTML
 * does not allow nesting of form elements. It is useful to nest forms, for example if the validity of a
 * sub-group of controls needs to be determined.
 *
 * Note: the purpose of `ngForm` is to group controls,
 * but not to be a replacement for the `<form>` tag with all of its capabilities
 * (e.g. posting to the server, ...).
 *
 * @param {string=} ngForm|name Name of the form. If specified, the form controller will be published into
 *                       related scope, under this name.
 *
 */

 /**
 * @ngdoc directive
 * @name form
 * @restrict E
 *
 * @description
 * Directive that instantiates
 * {@link form.FormController FormController}.
 *
 * If the `name` attribute is specified, the form controller is published onto the current scope under
 * this name.
 *
 * # Alias: {@link ng.directive:ngForm `ngForm`}
 *
 * In Angular, forms can be nested. This means that the outer form is valid when all of the child
 * forms are valid as well. However, browsers do not allow nesting of `<form>` elements, so
 * Angular provides the {@link ng.directive:ngForm `ngForm`} directive, which behaves identically to
 * `form` but can be nested. Nested forms can be useful, for example, if the validity of a sub-group
 * of controls needs to be determined.
 *
 * # CSS classes
 *  - `ng-valid` is set if the form is valid.
 *  - `ng-invalid` is set if the form is invalid.
 *  - `ng-pending` is set if the form is pending.
 *  - `ng-pristine` is set if the form is pristine.
 *  - `ng-dirty` is set if the form is dirty.
 *  - `ng-submitted` is set if the form was submitted.
 *
 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
 *
 *
 * # Submitting a form and preventing the default action
 *
 * Since the role of forms in client-side Angular applications is different than in classical
 * roundtrip apps, it is desirable for the browser not to translate the form submission into a full
 * page reload that sends the data to the server. Instead some javascript logic should be triggered
 * to handle the form submission in an application-specific way.
 *
 * For this reason, Angular prevents the default action (form submission to the server) unless the
 * `<form>` element has an `action` attribute specified.
 *
 * You can use one of the following two ways to specify what javascript method should be called when
 * a form is submitted:
 *
 * - {@link ng.directive:ngSubmit ngSubmit} directive on the form element
 * - {@link ng.directive:ngClick ngClick} directive on the first
  *  button or input field of type submit (input[type=submit])
 *
 * To prevent double execution of the handler, use only one of the {@link ng.directive:ngSubmit ngSubmit}
 * or {@link ng.directive:ngClick ngClick} directives.
 * This is because of the following form submission rules in the HTML specification:
 *
 * - If a form has only one input field then hitting enter in this field triggers form submit
 * (`ngSubmit`)
 * - if a form has 2+ input fields and no buttons or input[type=submit] then hitting enter
 * doesn't trigger submit
 * - if a form has one or more input fields and one or more buttons or input[type=submit] then
 * hitting enter in any of the input fields will trigger the click handler on the *first* button or
 * input[type=submit] (`ngClick`) *and* a submit handler on the enclosing form (`ngSubmit`)
 *
 * Any pending `ngModelOptions` changes will take place immediately when an enclosing form is
 * submitted. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
 * to have access to the updated model.
 *
 * ## Animation Hooks
 *
 * Animations in ngForm are triggered when any of the associated CSS classes are added and removed.
 * These classes are: `.ng-pristine`, `.ng-dirty`, `.ng-invalid` and `.ng-valid` as well as any
 * other validations that are performed within the form. Animations in ngForm are similar to how
 * they work in ngClass and animations can be hooked into using CSS transitions, keyframes as well
 * as JS animations.
 *
 * The following example shows a simple way to utilize CSS transitions to style a form element
 * that has been rendered as invalid after it has been validated:
 *
 * <pre>
 * //be sure to include ngAnimate as a module to hook into more
 * //advanced animations
 * .my-form {
 *   transition:0.5s linear all;
 *   background: white;
 * }
 * .my-form.ng-invalid {
 *   background: red;
 *   color:white;
 * }
 * </pre>
 *
 * @example
    <example deps="angular-animate.js" animations="true" fixBase="true" module="formExample">
      <file name="index.html">
       <script>
         angular.module('formExample', [])
           .controller('FormController', ['$scope', function($scope) {
             $scope.userType = 'guest';
           }]);
       </script>
       <style>
        .my-form {
          transition:all linear 0.5s;
          background: transparent;
        }
        .my-form.ng-invalid {
          background: red;
        }
       </style>
       <form name="myForm" ng-controller="FormController" class="my-form">
         userType: <input name="input" ng-model="userType" required>
         <span class="error" ng-show="myForm.input.$error.required">Required!</span><br>
         <code>userType = {{userType}}</code><br>
         <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br>
         <code>myForm.input.$error = {{myForm.input.$error}}</code><br>
         <code>myForm.$valid = {{myForm.$valid}}</code><br>
         <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br>
        </form>
      </file>
      <file name="protractor.js" type="protractor">
        it('should initialize to model', function() {
          var userType = element(by.binding('userType'));
          var valid = element(by.binding('myForm.input.$valid'));

          expect(userType.getText()).toContain('guest');
          expect(valid.getText()).toContain('true');
        });

        it('should be invalid if empty', function() {
          var userType = element(by.binding('userType'));
          var valid = element(by.binding('myForm.input.$valid'));
          var userInput = element(by.model('userType'));

          userInput.clear();
          userInput.sendKeys('');

          expect(userType.getText()).toEqual('userType =');
          expect(valid.getText()).toContain('false');
        });
      </file>
    </example>
 *
 * @param {string=} name Name of the form. If specified, the form controller will be published into
 *                       related scope, under this name.
 */
var formDirectiveFactory = function(isNgForm) {
  return ['$timeout', '$parse', function($timeout, $parse) {
    var formDirective = {
      name: 'form',
      restrict: isNgForm ? 'EAC' : 'E',
      require: ['form', '^^?form'], //first is the form's own ctrl, second is an optional parent form
      controller: FormController,
      compile: function ngFormCompile(formElement, attr) {
        // Setup initial state of the control
        formElement.addClass(PRISTINE_CLASS).addClass(VALID_CLASS);

        var nameAttr = attr.name ? 'name' : (isNgForm && attr.ngForm ? 'ngForm' : false);

        return {
          pre: function ngFormPreLink(scope, formElement, attr, ctrls) {
            var controller = ctrls[0];

            // if `action` attr is not present on the form, prevent the default action (submission)
            if (!('action' in attr)) {
              // we can't use jq events because if a form is destroyed during submission the default
              // action is not prevented. see #1238
              //
              // IE 9 is not affected because it doesn't fire a submit event and try to do a full
              // page reload if the form was destroyed by submission of the form via a click handler
              // on a button in the form. Looks like an IE9 specific bug.
              var handleFormSubmission = function(event) {
                scope.$apply(function() {
                  controller.$commitViewValue();
                  controller.$setSubmitted();
                });

                event.preventDefault();
              };

              addEventListenerFn(formElement[0], 'submit', handleFormSubmission);

              // unregister the preventDefault listener so that we don't not leak memory but in a
              // way that will achieve the prevention of the default action.
              formElement.on('$destroy', function() {
                $timeout(function() {
                  removeEventListenerFn(formElement[0], 'submit', handleFormSubmission);
                }, 0, false);
              });
            }

            var parentFormCtrl = ctrls[1] || controller.$$parentForm;
            parentFormCtrl.$addControl(controller);

            var setter = nameAttr ? getSetter(controller.$name) : noop;

            if (nameAttr) {
              setter(scope, controller);
              attr.$observe(nameAttr, function(newValue) {
                if (controller.$name === newValue) return;
                setter(scope, undefined);
                controller.$$parentForm.$$renameControl(controller, newValue);
                setter = getSetter(controller.$name);
                setter(scope, controller);
              });
            }
            formElement.on('$destroy', function() {
              controller.$$parentForm.$removeControl(controller);
              setter(scope, undefined);
              extend(controller, nullFormCtrl); //stop propagating child destruction handlers upwards
            });
          }
        };
      }
    };

    return formDirective;

    function getSetter(expression) {
      if (expression === '') {
        //create an assignable expression, so forms with an empty name can be renamed later
        return $parse('this[""]').assign;
      }
      return $parse(expression).assign || noop;
    }
  }];
};

var formDirective = formDirectiveFactory();
var ngFormDirective = formDirectiveFactory(true);

/* global VALID_CLASS: false,
  INVALID_CLASS: false,
  PRISTINE_CLASS: false,
  DIRTY_CLASS: false,
  UNTOUCHED_CLASS: false,
  TOUCHED_CLASS: false,
  ngModelMinErr: false,
*/

// Regex code was initially obtained from SO prior to modification: https://stackoverflow.com/questions/3143070/javascript-regex-iso-datetime#answer-3143231
var ISO_DATE_REGEXP = /^\d{4,}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+(?:[+-][0-2]\d:[0-5]\d|Z)$/;
// See valid URLs in RFC3987 (http://tools.ietf.org/html/rfc3987)
// Note: We are being more lenient, because browsers are too.
//   1. Scheme
//   2. Slashes
//   3. Username
//   4. Password
//   5. Hostname
//   6. Port
//   7. Path
//   8. Query
//   9. Fragment
//                 1111111111111111 222   333333    44444        555555555555555555555555    666     77777777     8888888     999
var URL_REGEXP = /^[a-z][a-z\d.+-]*:\/*(?:[^:@]+(?::[^@]+)?@)?(?:[^\s:/?#]+|\[[a-f\d:]+\])(?::\d+)?(?:\/[^?#]*)?(?:\?[^#]*)?(?:#.*)?$/i;
/* jshint maxlen:220 */
var EMAIL_REGEXP = /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+\/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+\/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/;
/* jshint maxlen:200 */
var NUMBER_REGEXP = /^\s*(\-|\+)?(\d+|(\d*(\.\d*)))([eE][+-]?\d+)?\s*$/;
var DATE_REGEXP = /^(\d{4,})-(\d{2})-(\d{2})$/;
var DATETIMELOCAL_REGEXP = /^(\d{4,})-(\d\d)-(\d\d)T(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
var WEEK_REGEXP = /^(\d{4,})-W(\d\d)$/;
var MONTH_REGEXP = /^(\d{4,})-(\d\d)$/;
var TIME_REGEXP = /^(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;

var PARTIAL_VALIDATION_EVENTS = 'keydown wheel mousedown';
var PARTIAL_VALIDATION_TYPES = createMap();
forEach('date,datetime-local,month,time,week'.split(','), function(type) {
  PARTIAL_VALIDATION_TYPES[type] = true;
});

var inputType = {

  /**
   * @ngdoc input
   * @name input[text]
   *
   * @description
   * Standard HTML text input with angular data binding, inherited by most of the `input` elements.
   *
   *
   * @param {string} ngModel Assignable angular expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} required Adds `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
   *    minlength.
   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
   *    any length.
   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
   *    that contains the regular expression body that will be converted to a regular expression
   *    as in the ngPattern directive.
   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
   *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
   *    If the expression evaluates to a RegExp object, then this is used directly.
   *    If the expression evaluates to a string, then it will be converted to a RegExp
   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
   *    `new RegExp('^abc$')`.<br />
   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
   *    start at the index of the last search's match, thus not taking the whole input value into
   *    account.
   * @param {string=} ngChange Angular expression to be executed when input changes due to user
   *    interaction with the input element.
   * @param {boolean=} [ngTrim=true] If set to false Angular will not automatically trim the input.
   *    This parameter is ignored for input[type=password] controls, which will never trim the
   *    input.
   *
   * @example
      <example name="text-input-directive" module="textInputExample">
        <file name="index.html">
         <script>
           angular.module('textInputExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.example = {
                 text: 'guest',
                 word: /^\s*\w*\s*$/
               };
             }]);
         </script>
         <form name="myForm" ng-controller="ExampleController">
           <label>Single word:
             <input type="text" name="input" ng-model="example.text"
                    ng-pattern="example.word" required ng-trim="false">
           </label>
           <div role="alert">
             <span class="error" ng-show="myForm.input.$error.required">
               Required!</span>
             <span class="error" ng-show="myForm.input.$error.pattern">
               Single word only!</span>
           </div>
           <code>text = {{example.text}}</code><br/>
           <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br/>
           <code>myForm.input.$error = {{myForm.input.$error}}</code><br/>
           <code>myForm.$valid = {{myForm.$valid}}</code><br/>
           <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br/>
          </form>
        </file>
        <file name="protractor.js" type="protractor">
          var text = element(by.binding('example.text'));
          var valid = element(by.binding('myForm.input.$valid'));
          var input = element(by.model('example.text'));

          it('should initialize to model', function() {
            expect(text.getText()).toContain('guest');
            expect(valid.getText()).toContain('true');
          });

          it('should be invalid if empty', function() {
            input.clear();
            input.sendKeys('');

            expect(text.getText()).toEqual('text =');
            expect(valid.getText()).toContain('false');
          });

          it('should be invalid if multi word', function() {
            input.clear();
            input.sendKeys('hello world');

            expect(valid.getText()).toContain('false');
          });
        </file>
      </example>
   */
  'text': textInputType,

    /**
     * @ngdoc input
     * @name input[date]
     *
     * @description
     * Input with date validation and transformation. In browsers that do not yet support
     * the HTML5 date input, a text element will be used. In that case, text must be entered in a valid ISO-8601
     * date format (yyyy-MM-dd), for example: `2009-01-06`. Since many
     * modern browsers do not yet support this input type, it is important to provide cues to users on the
     * expected input format via a placeholder or label.
     *
     * The model must always be a Date object, otherwise Angular will throw an error.
     * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
     *
     * The timezone to be used to read/write the `Date` instance in the model can be defined using
     * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
     *
     * @param {string} ngModel Assignable angular expression to data-bind to.
     * @param {string=} name Property name of the form under which the control is published.
     * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`. This must be a
     *   valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
     *   (e.g. `min="{{minDate | date:'yyyy-MM-dd'}}"`). Note that `min` will also add native HTML5
     *   constraint validation.
     * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`. This must be
     *   a valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
     *   (e.g. `max="{{maxDate | date:'yyyy-MM-dd'}}"`). Note that `max` will also add native HTML5
     *   constraint validation.
     * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO date string
     *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
     * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO date string
     *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
     * @param {string=} required Sets `required` validation error key if the value is not entered.
     * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
     *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
     *    `required` when you want to data-bind to the `required` attribute.
     * @param {string=} ngChange Angular expression to be executed when input changes due to user
     *    interaction with the input element.
     *
     * @example
     <example name="date-input-directive" module="dateInputExample">
     <file name="index.html">
       <script>
          angular.module('dateInputExample', [])
            .controller('DateController', ['$scope', function($scope) {
              $scope.example = {
                value: new Date(2013, 9, 22)
              };
            }]);
       </script>
       <form name="myForm" ng-controller="DateController as dateCtrl">
          <label for="exampleInput">Pick a date in 2013:</label>
          <input type="date" id="exampleInput" name="input" ng-model="example.value"
              placeholder="yyyy-MM-dd" min="2013-01-01" max="2013-12-31" required />
          <div role="alert">
            <span class="error" ng-show="myForm.input.$error.required">
                Required!</span>
            <span class="error" ng-show="myForm.input.$error.date">
                Not a valid date!</span>
           </div>
           <tt>value = {{example.value | date: "yyyy-MM-dd"}}</tt><br/>
           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
       </form>
     </file>
     <file name="protractor.js" type="protractor">
        var value = element(by.binding('example.value | date: "yyyy-MM-dd"'));
        var valid = element(by.binding('myForm.input.$valid'));
        var input = element(by.model('example.value'));

        // currently protractor/webdriver does not support
        // sending keys to all known HTML5 input controls
        // for various browsers (see https://github.com/angular/protractor/issues/562).
        function setInput(val) {
          // set the value of the element and force validation.
          var scr = "var ipt = document.getElementById('exampleInput'); " +
          "ipt.value = '" + val + "';" +
          "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
          browser.executeScript(scr);
        }

        it('should initialize to model', function() {
          expect(value.getText()).toContain('2013-10-22');
          expect(valid.getText()).toContain('myForm.input.$valid = true');
        });

        it('should be invalid if empty', function() {
          setInput('');
          expect(value.getText()).toEqual('value =');
          expect(valid.getText()).toContain('myForm.input.$valid = false');
        });

        it('should be invalid if over max', function() {
          setInput('2015-01-01');
          expect(value.getText()).toContain('');
          expect(valid.getText()).toContain('myForm.input.$valid = false');
        });
     </file>
     </example>
     */
  'date': createDateInputType('date', DATE_REGEXP,
         createDateParser(DATE_REGEXP, ['yyyy', 'MM', 'dd']),
         'yyyy-MM-dd'),

   /**
    * @ngdoc input
    * @name input[datetime-local]
    *
    * @description
    * Input with datetime validation and transformation. In browsers that do not yet support
    * the HTML5 date input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
    * local datetime format (yyyy-MM-ddTHH:mm:ss), for example: `2010-12-28T14:57:00`.
    *
    * The model must always be a Date object, otherwise Angular will throw an error.
    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
    *
    * The timezone to be used to read/write the `Date` instance in the model can be defined using
    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
    *
    * @param {string} ngModel Assignable angular expression to data-bind to.
    * @param {string=} name Property name of the form under which the control is published.
    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
    *   inside this attribute (e.g. `min="{{minDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
    *   Note that `min` will also add native HTML5 constraint validation.
    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
    *   inside this attribute (e.g. `max="{{maxDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
    *   Note that `max` will also add native HTML5 constraint validation.
    * @param {(date|string)=} ngMin Sets the `min` validation error key to the Date / ISO datetime string
    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
    * @param {(date|string)=} ngMax Sets the `max` validation error key to the Date / ISO datetime string
    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
    * @param {string=} required Sets `required` validation error key if the value is not entered.
    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
    *    `required` when you want to data-bind to the `required` attribute.
    * @param {string=} ngChange Angular expression to be executed when input changes due to user
    *    interaction with the input element.
    *
    * @example
    <example name="datetimelocal-input-directive" module="dateExample">
    <file name="index.html">
      <script>
        angular.module('dateExample', [])
          .controller('DateController', ['$scope', function($scope) {
            $scope.example = {
              value: new Date(2010, 11, 28, 14, 57)
            };
          }]);
      </script>
      <form name="myForm" ng-controller="DateController as dateCtrl">
        <label for="exampleInput">Pick a date between in 2013:</label>
        <input type="datetime-local" id="exampleInput" name="input" ng-model="example.value"
            placeholder="yyyy-MM-ddTHH:mm:ss" min="2001-01-01T00:00:00" max="2013-12-31T00:00:00" required />
        <div role="alert">
          <span class="error" ng-show="myForm.input.$error.required">
              Required!</span>
          <span class="error" ng-show="myForm.input.$error.datetimelocal">
              Not a valid date!</span>
        </div>
        <tt>value = {{example.value | date: "yyyy-MM-ddTHH:mm:ss"}}</tt><br/>
        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
      </form>
    </file>
    <file name="protractor.js" type="protractor">
      var value = element(by.binding('example.value | date: "yyyy-MM-ddTHH:mm:ss"'));
      var valid = element(by.binding('myForm.input.$valid'));
      var input = element(by.model('example.value'));

      // currently protractor/webdriver does not support
      // sending keys to all known HTML5 input controls
      // for various browsers (https://github.com/angular/protractor/issues/562).
      function setInput(val) {
        // set the value of the element and force validation.
        var scr = "var ipt = document.getElementById('exampleInput'); " +
        "ipt.value = '" + val + "';" +
        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
        browser.executeScript(scr);
      }

      it('should initialize to model', function() {
        expect(value.getText()).toContain('2010-12-28T14:57:00');
        expect(valid.getText()).toContain('myForm.input.$valid = true');
      });

      it('should be invalid if empty', function() {
        setInput('');
        expect(value.getText()).toEqual('value =');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });

      it('should be invalid if over max', function() {
        setInput('2015-01-01T23:59:00');
        expect(value.getText()).toContain('');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });
    </file>
    </example>
    */
  'datetime-local': createDateInputType('datetimelocal', DATETIMELOCAL_REGEXP,
      createDateParser(DATETIMELOCAL_REGEXP, ['yyyy', 'MM', 'dd', 'HH', 'mm', 'ss', 'sss']),
      'yyyy-MM-ddTHH:mm:ss.sss'),

  /**
   * @ngdoc input
   * @name input[time]
   *
   * @description
   * Input with time validation and transformation. In browsers that do not yet support
   * the HTML5 time input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
   * local time format (HH:mm:ss), for example: `14:57:00`. Model must be a Date object. This binding will always output a
   * Date object to the model of January 1, 1970, or local date `new Date(1970, 0, 1, HH, mm, ss)`.
   *
   * The model must always be a Date object, otherwise Angular will throw an error.
   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
   *
   * The timezone to be used to read/write the `Date` instance in the model can be defined using
   * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
   *
   * @param {string} ngModel Assignable angular expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
   *   attribute (e.g. `min="{{minTime | date:'HH:mm:ss'}}"`). Note that `min` will also add
   *   native HTML5 constraint validation.
   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
   *   attribute (e.g. `max="{{maxTime | date:'HH:mm:ss'}}"`). Note that `max` will also add
   *   native HTML5 constraint validation.
   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO time string the
   *   `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO time string the
   *   `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {string=} ngChange Angular expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
   <example name="time-input-directive" module="timeExample">
   <file name="index.html">
     <script>
      angular.module('timeExample', [])
        .controller('DateController', ['$scope', function($scope) {
          $scope.example = {
            value: new Date(1970, 0, 1, 14, 57, 0)
          };
        }]);
     </script>
     <form name="myForm" ng-controller="DateController as dateCtrl">
        <label for="exampleInput">Pick a time between 8am and 5pm:</label>
        <input type="time" id="exampleInput" name="input" ng-model="example.value"
            placeholder="HH:mm:ss" min="08:00:00" max="17:00:00" required />
        <div role="alert">
          <span class="error" ng-show="myForm.input.$error.required">
              Required!</span>
          <span class="error" ng-show="myForm.input.$error.time">
              Not a valid date!</span>
        </div>
        <tt>value = {{example.value | date: "HH:mm:ss"}}</tt><br/>
        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
     </form>
   </file>
   <file name="protractor.js" type="protractor">
      var value = element(by.binding('example.value | date: "HH:mm:ss"'));
      var valid = element(by.binding('myForm.input.$valid'));
      var input = element(by.model('example.value'));

      // currently protractor/webdriver does not support
      // sending keys to all known HTML5 input controls
      // for various browsers (https://github.com/angular/protractor/issues/562).
      function setInput(val) {
        // set the value of the element and force validation.
        var scr = "var ipt = document.getElementById('exampleInput'); " +
        "ipt.value = '" + val + "';" +
        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
        browser.executeScript(scr);
      }

      it('should initialize to model', function() {
        expect(value.getText()).toContain('14:57:00');
        expect(valid.getText()).toContain('myForm.input.$valid = true');
      });

      it('should be invalid if empty', function() {
        setInput('');
        expect(value.getText()).toEqual('value =');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });

      it('should be invalid if over max', function() {
        setInput('23:59:00');
        expect(value.getText()).toContain('');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });
   </file>
   </example>
   */
  'time': createDateInputType('time', TIME_REGEXP,
      createDateParser(TIME_REGEXP, ['HH', 'mm', 'ss', 'sss']),
     'HH:mm:ss.sss'),

   /**
    * @ngdoc input
    * @name input[week]
    *
    * @description
    * Input with week-of-the-year validation and transformation to Date. In browsers that do not yet support
    * the HTML5 week input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
    * week format (yyyy-W##), for example: `2013-W02`.
    *
    * The model must always be a Date object, otherwise Angular will throw an error.
    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
    *
    * The timezone to be used to read/write the `Date` instance in the model can be defined using
    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
    *
    * @param {string} ngModel Assignable angular expression to data-bind to.
    * @param {string=} name Property name of the form under which the control is published.
    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
    *   attribute (e.g. `min="{{minWeek | date:'yyyy-Www'}}"`). Note that `min` will also add
    *   native HTML5 constraint validation.
    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
    *   attribute (e.g. `max="{{maxWeek | date:'yyyy-Www'}}"`). Note that `max` will also add
    *   native HTML5 constraint validation.
    * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
    * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
    * @param {string=} required Sets `required` validation error key if the value is not entered.
    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
    *    `required` when you want to data-bind to the `required` attribute.
    * @param {string=} ngChange Angular expression to be executed when input changes due to user
    *    interaction with the input element.
    *
    * @example
    <example name="week-input-directive" module="weekExample">
    <file name="index.html">
      <script>
      angular.module('weekExample', [])
        .controller('DateController', ['$scope', function($scope) {
          $scope.example = {
            value: new Date(2013, 0, 3)
          };
        }]);
      </script>
      <form name="myForm" ng-controller="DateController as dateCtrl">
        <label>Pick a date between in 2013:
          <input id="exampleInput" type="week" name="input" ng-model="example.value"
                 placeholder="YYYY-W##" min="2012-W32"
                 max="2013-W52" required />
        </label>
        <div role="alert">
          <span class="error" ng-show="myForm.input.$error.required">
              Required!</span>
          <span class="error" ng-show="myForm.input.$error.week">
              Not a valid date!</span>
        </div>
        <tt>value = {{example.value | date: "yyyy-Www"}}</tt><br/>
        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
      </form>
    </file>
    <file name="protractor.js" type="protractor">
      var value = element(by.binding('example.value | date: "yyyy-Www"'));
      var valid = element(by.binding('myForm.input.$valid'));
      var input = element(by.model('example.value'));

      // currently protractor/webdriver does not support
      // sending keys to all known HTML5 input controls
      // for various browsers (https://github.com/angular/protractor/issues/562).
      function setInput(val) {
        // set the value of the element and force validation.
        var scr = "var ipt = document.getElementById('exampleInput'); " +
        "ipt.value = '" + val + "';" +
        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
        browser.executeScript(scr);
      }

      it('should initialize to model', function() {
        expect(value.getText()).toContain('2013-W01');
        expect(valid.getText()).toContain('myForm.input.$valid = true');
      });

      it('should be invalid if empty', function() {
        setInput('');
        expect(value.getText()).toEqual('value =');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });

      it('should be invalid if over max', function() {
        setInput('2015-W01');
        expect(value.getText()).toContain('');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });
    </file>
    </example>
    */
  'week': createDateInputType('week', WEEK_REGEXP, weekParser, 'yyyy-Www'),

  /**
   * @ngdoc input
   * @name input[month]
   *
   * @description
   * Input with month validation and transformation. In browsers that do not yet support
   * the HTML5 month input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
   * month format (yyyy-MM), for example: `2009-01`.
   *
   * The model must always be a Date object, otherwise Angular will throw an error.
   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
   * If the model is not set to the first of the month, the next view to model update will set it
   * to the first of the month.
   *
   * The timezone to be used to read/write the `Date` instance in the model can be defined using
   * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
   *
   * @param {string} ngModel Assignable angular expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
   *   attribute (e.g. `min="{{minMonth | date:'yyyy-MM'}}"`). Note that `min` will also add
   *   native HTML5 constraint validation.
   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
   *   attribute (e.g. `max="{{maxMonth | date:'yyyy-MM'}}"`). Note that `max` will also add
   *   native HTML5 constraint validation.
   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
   *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
   *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.

   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {string=} ngChange Angular expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
   <example name="month-input-directive" module="monthExample">
   <file name="index.html">
     <script>
      angular.module('monthExample', [])
        .controller('DateController', ['$scope', function($scope) {
          $scope.example = {
            value: new Date(2013, 9, 1)
          };
        }]);
     </script>
     <form name="myForm" ng-controller="DateController as dateCtrl">
       <label for="exampleInput">Pick a month in 2013:</label>
       <input id="exampleInput" type="month" name="input" ng-model="example.value"
          placeholder="yyyy-MM" min="2013-01" max="2013-12" required />
       <div role="alert">
         <span class="error" ng-show="myForm.input.$error.required">
            Required!</span>
         <span class="error" ng-show="myForm.input.$error.month">
            Not a valid month!</span>
       </div>
       <tt>value = {{example.value | date: "yyyy-MM"}}</tt><br/>
       <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
       <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
       <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
       <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
     </form>
   </file>
   <file name="protractor.js" type="protractor">
      var value = element(by.binding('example.value | date: "yyyy-MM"'));
      var valid = element(by.binding('myForm.input.$valid'));
      var input = element(by.model('example.value'));

      // currently protractor/webdriver does not support
      // sending keys to all known HTML5 input controls
      // for various browsers (https://github.com/angular/protractor/issues/562).
      function setInput(val) {
        // set the value of the element and force validation.
        var scr = "var ipt = document.getElementById('exampleInput'); " +
        "ipt.value = '" + val + "';" +
        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
        browser.executeScript(scr);
      }

      it('should initialize to model', function() {
        expect(value.getText()).toContain('2013-10');
        expect(valid.getText()).toContain('myForm.input.$valid = true');
      });

      it('should be invalid if empty', function() {
        setInput('');
        expect(value.getText()).toEqual('value =');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });

      it('should be invalid if over max', function() {
        setInput('2015-01');
        expect(value.getText()).toContain('');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });
   </file>
   </example>
   */
  'month': createDateInputType('month', MONTH_REGEXP,
     createDateParser(MONTH_REGEXP, ['yyyy', 'MM']),
     'yyyy-MM'),

  /**
   * @ngdoc input
   * @name input[number]
   *
   * @description
   * Text input with number validation and transformation. Sets the `number` validation
   * error if not a valid number.
   *
   * <div class="alert alert-warning">
   * The model must always be of type `number` otherwise Angular will throw an error.
   * Be aware that a string containing a number is not enough. See the {@link ngModel:numfmt}
   * error docs for more information and an example of how to convert your model if necessary.
   * </div>
   *
   * ## Issues with HTML5 constraint validation
   *
   * In browsers that follow the
   * [HTML5 specification](https://html.spec.whatwg.org/multipage/forms.html#number-state-%28type=number%29),
   * `input[number]` does not work as expected with {@link ngModelOptions `ngModelOptions.allowInvalid`}.
   * If a non-number is entered in the input, the browser will report the value as an empty string,
   * which means the view / model values in `ngModel` and subsequently the scope value
   * will also be an empty string.
   *
   *
   * @param {string} ngModel Assignable angular expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
   *    minlength.
   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
   *    any length.
   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
   *    that contains the regular expression body that will be converted to a regular expression
   *    as in the ngPattern directive.
   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
   *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
   *    If the expression evaluates to a RegExp object, then this is used directly.
   *    If the expression evaluates to a string, then it will be converted to a RegExp
   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
   *    `new RegExp('^abc$')`.<br />
   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
   *    start at the index of the last search's match, thus not taking the whole input value into
   *    account.
   * @param {string=} ngChange Angular expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
      <example name="number-input-directive" module="numberExample">
        <file name="index.html">
         <script>
           angular.module('numberExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.example = {
                 value: 12
               };
             }]);
         </script>
         <form name="myForm" ng-controller="ExampleController">
           <label>Number:
             <input type="number" name="input" ng-model="example.value"
                    min="0" max="99" required>
          </label>
           <div role="alert">
             <span class="error" ng-show="myForm.input.$error.required">
               Required!</span>
             <span class="error" ng-show="myForm.input.$error.number">
               Not valid number!</span>
           </div>
           <tt>value = {{example.value}}</tt><br/>
           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
          </form>
        </file>
        <file name="protractor.js" type="protractor">
          var value = element(by.binding('example.value'));
          var valid = element(by.binding('myForm.input.$valid'));
          var input = element(by.model('example.value'));

          it('should initialize to model', function() {
            expect(value.getText()).toContain('12');
            expect(valid.getText()).toContain('true');
          });

          it('should be invalid if empty', function() {
            input.clear();
            input.sendKeys('');
            expect(value.getText()).toEqual('value =');
            expect(valid.getText()).toContain('false');
          });

          it('should be invalid if over max', function() {
            input.clear();
            input.sendKeys('123');
            expect(value.getText()).toEqual('value =');
            expect(valid.getText()).toContain('false');
          });
        </file>
      </example>
   */
  'number': numberInputType,


  /**
   * @ngdoc input
   * @name input[url]
   *
   * @description
   * Text input with URL validation. Sets the `url` validation error key if the content is not a
   * valid URL.
   *
   * <div class="alert alert-warning">
   * **Note:** `input[url]` uses a regex to validate urls that is derived from the regex
   * used in Chromium. If you need stricter validation, you can use `ng-pattern` or modify
   * the built-in validators (see the {@link guide/forms Forms guide})
   * </div>
   *
   * @param {string} ngModel Assignable angular expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
   *    minlength.
   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
   *    any length.
   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
   *    that contains the regular expression body that will be converted to a regular expression
   *    as in the ngPattern directive.
   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
   *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
   *    If the expression evaluates to a RegExp object, then this is used directly.
   *    If the expression evaluates to a string, then it will be converted to a RegExp
   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
   *    `new RegExp('^abc$')`.<br />
   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
   *    start at the index of the last search's match, thus not taking the whole input value into
   *    account.
   * @param {string=} ngChange Angular expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
      <example name="url-input-directive" module="urlExample">
        <file name="index.html">
         <script>
           angular.module('urlExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.url = {
                 text: 'http://google.com'
               };
             }]);
         </script>
         <form name="myForm" ng-controller="ExampleController">
           <label>URL:
             <input type="url" name="input" ng-model="url.text" required>
           <label>
           <div role="alert">
             <span class="error" ng-show="myForm.input.$error.required">
               Required!</span>
             <span class="error" ng-show="myForm.input.$error.url">
               Not valid url!</span>
           </div>
           <tt>text = {{url.text}}</tt><br/>
           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
           <tt>myForm.$error.url = {{!!myForm.$error.url}}</tt><br/>
          </form>
        </file>
        <file name="protractor.js" type="protractor">
          var text = element(by.binding('url.text'));
          var valid = element(by.binding('myForm.input.$valid'));
          var input = element(by.model('url.text'));

          it('should initialize to model', function() {
            expect(text.getText()).toContain('http://google.com');
            expect(valid.getText()).toContain('true');
          });

          it('should be invalid if empty', function() {
            input.clear();
            input.sendKeys('');

            expect(text.getText()).toEqual('text =');
            expect(valid.getText()).toContain('false');
          });

          it('should be invalid if not url', function() {
            input.clear();
            input.sendKeys('box');

            expect(valid.getText()).toContain('false');
          });
        </file>
      </example>
   */
  'url': urlInputType,


  /**
   * @ngdoc input
   * @name input[email]
   *
   * @description
   * Text input with email validation. Sets the `email` validation error key if not a valid email
   * address.
   *
   * <div class="alert alert-warning">
   * **Note:** `input[email]` uses a regex to validate email addresses that is derived from the regex
   * used in Chromium. If you need stricter validation (e.g. requiring a top-level domain), you can
   * use `ng-pattern` or modify the built-in validators (see the {@link guide/forms Forms guide})
   * </div>
   *
   * @param {string} ngModel Assignable angular expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
   *    minlength.
   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
   *    any length.
   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
   *    that contains the regular expression body that will be converted to a regular expression
   *    as in the ngPattern directive.
   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
   *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
   *    If the expression evaluates to a RegExp object, then this is used directly.
   *    If the expression evaluates to a string, then it will be converted to a RegExp
   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
   *    `new RegExp('^abc$')`.<br />
   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
   *    start at the index of the last search's match, thus not taking the whole input value into
   *    account.
   * @param {string=} ngChange Angular expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
      <example name="email-input-directive" module="emailExample">
        <file name="index.html">
         <script>
           angular.module('emailExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.email = {
                 text: 'me@example.com'
               };
             }]);
         </script>
           <form name="myForm" ng-controller="ExampleController">
             <label>Email:
               <input type="email" name="input" ng-model="email.text" required>
             </label>
             <div role="alert">
               <span class="error" ng-show="myForm.input.$error.required">
                 Required!</span>
               <span class="error" ng-show="myForm.input.$error.email">
                 Not valid email!</span>
             </div>
             <tt>text = {{email.text}}</tt><br/>
             <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
             <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
             <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
             <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
             <tt>myForm.$error.email = {{!!myForm.$error.email}}</tt><br/>
           </form>
         </file>
        <file name="protractor.js" type="protractor">
          var text = element(by.binding('email.text'));
          var valid = element(by.binding('myForm.input.$valid'));
          var input = element(by.model('email.text'));

          it('should initialize to model', function() {
            expect(text.getText()).toContain('me@example.com');
            expect(valid.getText()).toContain('true');
          });

          it('should be invalid if empty', function() {
            input.clear();
            input.sendKeys('');
            expect(text.getText()).toEqual('text =');
            expect(valid.getText()).toContain('false');
          });

          it('should be invalid if not email', function() {
            input.clear();
            input.sendKeys('xxx');

            expect(valid.getText()).toContain('false');
          });
        </file>
      </example>
   */
  'email': emailInputType,


  /**
   * @ngdoc input
   * @name input[radio]
   *
   * @description
   * HTML radio button.
   *
   * @param {string} ngModel Assignable angular expression to data-bind to.
   * @param {string} value The value to which the `ngModel` expression should be set when selected.
   *    Note that `value` only supports `string` values, i.e. the scope model needs to be a string,
   *    too. Use `ngValue` if you need complex models (`number`, `object`, ...).
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} ngChange Angular expression to be executed when input changes due to user
   *    interaction with the input element.
   * @param {string} ngValue Angular expression to which `ngModel` will be be set when the radio
   *    is selected. Should be used instead of the `value` attribute if you need
   *    a non-string `ngModel` (`boolean`, `array`, ...).
   *
   * @example
      <example name="radio-input-directive" module="radioExample">
        <file name="index.html">
         <script>
           angular.module('radioExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.color = {
                 name: 'blue'
               };
               $scope.specialValue = {
                 "id": "12345",
                 "value": "green"
               };
             }]);
         </script>
         <form name="myForm" ng-controller="ExampleController">
           <label>
             <input type="radio" ng-model="color.name" value="red">
             Red
           </label><br/>
           <label>
             <input type="radio" ng-model="color.name" ng-value="specialValue">
             Green
           </label><br/>
           <label>
             <input type="radio" ng-model="color.name" value="blue">
             Blue
           </label><br/>
           <tt>color = {{color.name | json}}</tt><br/>
          </form>
          Note that `ng-value="specialValue"` sets radio item's value to be the value of `$scope.specialValue`.
        </file>
        <file name="protractor.js" type="protractor">
          it('should change state', function() {
            var color = element(by.binding('color.name'));

            expect(color.getText()).toContain('blue');

            element.all(by.model('color.name')).get(0).click();

            expect(color.getText()).toContain('red');
          });
        </file>
      </example>
   */
  'radio': radioInputType,


  /**
   * @ngdoc input
   * @name input[checkbox]
   *
   * @description
   * HTML checkbox.
   *
   * @param {string} ngModel Assignable angular expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {expression=} ngTrueValue The value to which the expression should be set when selected.
   * @param {expression=} ngFalseValue The value to which the expression should be set when not selected.
   * @param {string=} ngChange Angular expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
      <example name="checkbox-input-directive" module="checkboxExample">
        <file name="index.html">
         <script>
           angular.module('checkboxExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.checkboxModel = {
                value1 : true,
                value2 : 'YES'
              };
             }]);
         </script>
         <form name="myForm" ng-controller="ExampleController">
           <label>Value1:
             <input type="checkbox" ng-model="checkboxModel.value1">
           </label><br/>
           <label>Value2:
             <input type="checkbox" ng-model="checkboxModel.value2"
                    ng-true-value="'YES'" ng-false-value="'NO'">
            </label><br/>
           <tt>value1 = {{checkboxModel.value1}}</tt><br/>
           <tt>value2 = {{checkboxModel.value2}}</tt><br/>
          </form>
        </file>
        <file name="protractor.js" type="protractor">
          it('should change state', function() {
            var value1 = element(by.binding('checkboxModel.value1'));
            var value2 = element(by.binding('checkboxModel.value2'));

            expect(value1.getText()).toContain('true');
            expect(value2.getText()).toContain('YES');

            element(by.model('checkboxModel.value1')).click();
            element(by.model('checkboxModel.value2')).click();

            expect(value1.getText()).toContain('false');
            expect(value2.getText()).toContain('NO');
          });
        </file>
      </example>
   */
  'checkbox': checkboxInputType,

  'hidden': noop,
  'button': noop,
  'submit': noop,
  'reset': noop,
  'file': noop
};

function stringBasedInputType(ctrl) {
  ctrl.$formatters.push(function(value) {
    return ctrl.$isEmpty(value) ? value : value.toString();
  });
}

function textInputType(scope, element, attr, ctrl, $sniffer, $browser) {
  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
  stringBasedInputType(ctrl);
}

function baseInputType(scope, element, attr, ctrl, $sniffer, $browser) {
  var type = lowercase(element[0].type);

  // In composition mode, users are still inputing intermediate text buffer,
  // hold the listener until composition is done.
  // More about composition events: https://developer.mozilla.org/en-US/docs/Web/API/CompositionEvent
  if (!$sniffer.android) {
    var composing = false;

    element.on('compositionstart', function() {
      composing = true;
    });

    element.on('compositionend', function() {
      composing = false;
      listener();
    });
  }

  var timeout;

  var listener = function(ev) {
    if (timeout) {
      $browser.defer.cancel(timeout);
      timeout = null;
    }
    if (composing) return;
    var value = element.val(),
        event = ev && ev.type;

    // By default we will trim the value
    // If the attribute ng-trim exists we will avoid trimming
    // If input type is 'password', the value is never trimmed
    if (type !== 'password' && (!attr.ngTrim || attr.ngTrim !== 'false')) {
      value = trim(value);
    }

    // If a control is suffering from bad input (due to native validators), browsers discard its
    // value, so it may be necessary to revalidate (by calling $setViewValue again) even if the
    // control's value is the same empty value twice in a row.
    if (ctrl.$viewValue !== value || (value === '' && ctrl.$$hasNativeValidators)) {
      ctrl.$setViewValue(value, event);
    }
  };

  // if the browser does support "input" event, we are fine - except on IE9 which doesn't fire the
  // input event on backspace, delete or cut
  if ($sniffer.hasEvent('input')) {
    element.on('input', listener);
  } else {
    var deferListener = function(ev, input, origValue) {
      if (!timeout) {
        timeout = $browser.defer(function() {
          timeout = null;
          if (!input || input.value !== origValue) {
            listener(ev);
          }
        });
      }
    };

    element.on('keydown', function(event) {
      var key = event.keyCode;

      // ignore
      //    command            modifiers                   arrows
      if (key === 91 || (15 < key && key < 19) || (37 <= key && key <= 40)) return;

      deferListener(event, this, this.value);
    });

    // if user modifies input value using context menu in IE, we need "paste" and "cut" events to catch it
    if ($sniffer.hasEvent('paste')) {
      element.on('paste cut', deferListener);
    }
  }

  // if user paste into input using mouse on older browser
  // or form autocomplete on newer browser, we need "change" event to catch it
  element.on('change', listener);

  // Some native input types (date-family) have the ability to change validity without
  // firing any input/change events.
  // For these event types, when native validators are present and the browser supports the type,
  // check for validity changes on various DOM events.
  if (PARTIAL_VALIDATION_TYPES[type] && ctrl.$$hasNativeValidators && type === attr.type) {
    element.on(PARTIAL_VALIDATION_EVENTS, function(ev) {
      if (!timeout) {
        var validity = this[VALIDITY_STATE_PROPERTY];
        var origBadInput = validity.badInput;
        var origTypeMismatch = validity.typeMismatch;
        timeout = $browser.defer(function() {
          timeout = null;
          if (validity.badInput !== origBadInput || validity.typeMismatch !== origTypeMismatch) {
            listener(ev);
          }
        });
      }
    });
  }

  ctrl.$render = function() {
    // Workaround for Firefox validation #12102.
    var value = ctrl.$isEmpty(ctrl.$viewValue) ? '' : ctrl.$viewValue;
    if (element.val() !== value) {
      element.val(value);
    }
  };
}

function weekParser(isoWeek, existingDate) {
  if (isDate(isoWeek)) {
    return isoWeek;
  }

  if (isString(isoWeek)) {
    WEEK_REGEXP.lastIndex = 0;
    var parts = WEEK_REGEXP.exec(isoWeek);
    if (parts) {
      var year = +parts[1],
          week = +parts[2],
          hours = 0,
          minutes = 0,
          seconds = 0,
          milliseconds = 0,
          firstThurs = getFirstThursdayOfYear(year),
          addDays = (week - 1) * 7;

      if (existingDate) {
        hours = existingDate.getHours();
        minutes = existingDate.getMinutes();
        seconds = existingDate.getSeconds();
        milliseconds = existingDate.getMilliseconds();
      }

      return new Date(year, 0, firstThurs.getDate() + addDays, hours, minutes, seconds, milliseconds);
    }
  }

  return NaN;
}

function createDateParser(regexp, mapping) {
  return function(iso, date) {
    var parts, map;

    if (isDate(iso)) {
      return iso;
    }

    if (isString(iso)) {
      // When a date is JSON'ified to wraps itself inside of an extra
      // set of double quotes. This makes the date parsing code unable
      // to match the date string and parse it as a date.
      if (iso.charAt(0) == '"' && iso.charAt(iso.length - 1) == '"') {
        iso = iso.substring(1, iso.length - 1);
      }
      if (ISO_DATE_REGEXP.test(iso)) {
        return new Date(iso);
      }
      regexp.lastIndex = 0;
      parts = regexp.exec(iso);

      if (parts) {
        parts.shift();
        if (date) {
          map = {
            yyyy: date.getFullYear(),
            MM: date.getMonth() + 1,
            dd: date.getDate(),
            HH: date.getHours(),
            mm: date.getMinutes(),
            ss: date.getSeconds(),
            sss: date.getMilliseconds() / 1000
          };
        } else {
          map = { yyyy: 1970, MM: 1, dd: 1, HH: 0, mm: 0, ss: 0, sss: 0 };
        }

        forEach(parts, function(part, index) {
          if (index < mapping.length) {
            map[mapping[index]] = +part;
          }
        });
        return new Date(map.yyyy, map.MM - 1, map.dd, map.HH, map.mm, map.ss || 0, map.sss * 1000 || 0);
      }
    }

    return NaN;
  };
}

function createDateInputType(type, regexp, parseDate, format) {
  return function dynamicDateInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter) {
    badInputChecker(scope, element, attr, ctrl);
    baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
    var timezone = ctrl && ctrl.$options && ctrl.$options.timezone;
    var previousDate;

    ctrl.$$parserName = type;
    ctrl.$parsers.push(function(value) {
      if (ctrl.$isEmpty(value)) return null;
      if (regexp.test(value)) {
        // Note: We cannot read ctrl.$modelValue, as there might be a different
        // parser/formatter in the processing chain so that the model
        // contains some different data format!
        var parsedDate = parseDate(value, previousDate);
        if (timezone) {
          parsedDate = convertTimezoneToLocal(parsedDate, timezone);
        }
        return parsedDate;
      }
      return undefined;
    });

    ctrl.$formatters.push(function(value) {
      if (value && !isDate(value)) {
        throw ngModelMinErr('datefmt', 'Expected `{0}` to be a date', value);
      }
      if (isValidDate(value)) {
        previousDate = value;
        if (previousDate && timezone) {
          previousDate = convertTimezoneToLocal(previousDate, timezone, true);
        }
        return $filter('date')(value, format, timezone);
      } else {
        previousDate = null;
        return '';
      }
    });

    if (isDefined(attr.min) || attr.ngMin) {
      var minVal;
      ctrl.$validators.min = function(value) {
        return !isValidDate(value) || isUndefined(minVal) || parseDate(value) >= minVal;
      };
      attr.$observe('min', function(val) {
        minVal = parseObservedDateValue(val);
        ctrl.$validate();
      });
    }

    if (isDefined(attr.max) || attr.ngMax) {
      var maxVal;
      ctrl.$validators.max = function(value) {
        return !isValidDate(value) || isUndefined(maxVal) || parseDate(value) <= maxVal;
      };
      attr.$observe('max', function(val) {
        maxVal = parseObservedDateValue(val);
        ctrl.$validate();
      });
    }

    function isValidDate(value) {
      // Invalid Date: getTime() returns NaN
      return value && !(value.getTime && value.getTime() !== value.getTime());
    }

    function parseObservedDateValue(val) {
      return isDefined(val) && !isDate(val) ? parseDate(val) || undefined : val;
    }
  };
}

function badInputChecker(scope, element, attr, ctrl) {
  var node = element[0];
  var nativeValidation = ctrl.$$hasNativeValidators = isObject(node.validity);
  if (nativeValidation) {
    ctrl.$parsers.push(function(value) {
      var validity = element.prop(VALIDITY_STATE_PROPERTY) || {};
      return validity.badInput || validity.typeMismatch ? undefined : value;
    });
  }
}

function numberInputType(scope, element, attr, ctrl, $sniffer, $browser) {
  badInputChecker(scope, element, attr, ctrl);
  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);

  ctrl.$$parserName = 'number';
  ctrl.$parsers.push(function(value) {
    if (ctrl.$isEmpty(value))      return null;
    if (NUMBER_REGEXP.test(value)) return parseFloat(value);
    return undefined;
  });

  ctrl.$formatters.push(function(value) {
    if (!ctrl.$isEmpty(value)) {
      if (!isNumber(value)) {
        throw ngModelMinErr('numfmt', 'Expected `{0}` to be a number', value);
      }
      value = value.toString();
    }
    return value;
  });

  if (isDefined(attr.min) || attr.ngMin) {
    var minVal;
    ctrl.$validators.min = function(value) {
      return ctrl.$isEmpty(value) || isUndefined(minVal) || value >= minVal;
    };

    attr.$observe('min', function(val) {
      if (isDefined(val) && !isNumber(val)) {
        val = parseFloat(val);
      }
      minVal = isNumber(val) && !isNaN(val) ? val : undefined;
      // TODO(matsko): implement validateLater to reduce number of validations
      ctrl.$validate();
    });
  }

  if (isDefined(attr.max) || attr.ngMax) {
    var maxVal;
    ctrl.$validators.max = function(value) {
      return ctrl.$isEmpty(value) || isUndefined(maxVal) || value <= maxVal;
    };

    attr.$observe('max', function(val) {
      if (isDefined(val) && !isNumber(val)) {
        val = parseFloat(val);
      }
      maxVal = isNumber(val) && !isNaN(val) ? val : undefined;
      // TODO(matsko): implement validateLater to reduce number of validations
      ctrl.$validate();
    });
  }
}

function urlInputType(scope, element, attr, ctrl, $sniffer, $browser) {
  // Note: no badInputChecker here by purpose as `url` is only a validation
  // in browsers, i.e. we can always read out input.value even if it is not valid!
  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
  stringBasedInputType(ctrl);

  ctrl.$$parserName = 'url';
  ctrl.$validators.url = function(modelValue, viewValue) {
    var value = modelValue || viewValue;
    return ctrl.$isEmpty(value) || URL_REGEXP.test(value);
  };
}

function emailInputType(scope, element, attr, ctrl, $sniffer, $browser) {
  // Note: no badInputChecker here by purpose as `url` is only a validation
  // in browsers, i.e. we can always read out input.value even if it is not valid!
  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
  stringBasedInputType(ctrl);

  ctrl.$$parserName = 'email';
  ctrl.$validators.email = function(modelValue, viewValue) {
    var value = modelValue || viewValue;
    return ctrl.$isEmpty(value) || EMAIL_REGEXP.test(value);
  };
}

function radioInputType(scope, element, attr, ctrl) {
  // make the name unique, if not defined
  if (isUndefined(attr.name)) {
    element.attr('name', nextUid());
  }

  var listener = function(ev) {
    if (element[0].checked) {
      ctrl.$setViewValue(attr.value, ev && ev.type);
    }
  };

  element.on('click', listener);

  ctrl.$render = function() {
    var value = attr.value;
    element[0].checked = (value == ctrl.$viewValue);
  };

  attr.$observe('value', ctrl.$render);
}

function parseConstantExpr($parse, context, name, expression, fallback) {
  var parseFn;
  if (isDefined(expression)) {
    parseFn = $parse(expression);
    if (!parseFn.constant) {
      throw ngModelMinErr('constexpr', 'Expected constant expression for `{0}`, but saw ' +
                                   '`{1}`.', name, expression);
    }
    return parseFn(context);
  }
  return fallback;
}

function checkboxInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
  var trueValue = parseConstantExpr($parse, scope, 'ngTrueValue', attr.ngTrueValue, true);
  var falseValue = parseConstantExpr($parse, scope, 'ngFalseValue', attr.ngFalseValue, false);

  var listener = function(ev) {
    ctrl.$setViewValue(element[0].checked, ev && ev.type);
  };

  element.on('click', listener);

  ctrl.$render = function() {
    element[0].checked = ctrl.$viewValue;
  };

  // Override the standard `$isEmpty` because the $viewValue of an empty checkbox is always set to `false`
  // This is because of the parser below, which compares the `$modelValue` with `trueValue` to convert
  // it to a boolean.
  ctrl.$isEmpty = function(value) {
    return value === false;
  };

  ctrl.$formatters.push(function(value) {
    return equals(value, trueValue);
  });

  ctrl.$parsers.push(function(value) {
    return value ? trueValue : falseValue;
  });
}


/**
 * @ngdoc directive
 * @name textarea
 * @restrict E
 *
 * @description
 * HTML textarea element control with angular data-binding. The data-binding and validation
 * properties of this element are exactly the same as those of the
 * {@link ng.directive:input input element}.
 *
 * @param {string} ngModel Assignable angular expression to data-bind to.
 * @param {string=} name Property name of the form under which the control is published.
 * @param {string=} required Sets `required` validation error key if the value is not entered.
 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
 *    `required` when you want to data-bind to the `required` attribute.
 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
 *    minlength.
 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
 *    length.
 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
 *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
 *    If the expression evaluates to a RegExp object, then this is used directly.
 *    If the expression evaluates to a string, then it will be converted to a RegExp
 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
 *    `new RegExp('^abc$')`.<br />
 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
 *    start at the index of the last search's match, thus not taking the whole input value into
 *    account.
 * @param {string=} ngChange Angular expression to be executed when input changes due to user
 *    interaction with the input element.
 * @param {boolean=} [ngTrim=true] If set to false Angular will not automatically trim the input.
 */


/**
 * @ngdoc directive
 * @name input
 * @restrict E
 *
 * @description
 * HTML input element control. When used together with {@link ngModel `ngModel`}, it provides data-binding,
 * input state control, and validation.
 * Input control follows HTML5 input types and polyfills the HTML5 validation behavior for older browsers.
 *
 * <div class="alert alert-warning">
 * **Note:** Not every feature offered is available for all input types.
 * Specifically, data binding and event handling via `ng-model` is unsupported for `input[file]`.
 * </div>
 *
 * @param {string} ngModel Assignable angular expression to data-bind to.
 * @param {string=} name Property name of the form under which the control is published.
 * @param {string=} required Sets `required` validation error key if the value is not entered.
 * @param {boolean=} ngRequired Sets `required` attribute if set to true
 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
 *    minlength.
 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
 *    length.
 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
 *    value does not match a RegExp found by evaluating the Angular expression given in the attribute value.
 *    If the expression evaluates to a RegExp object, then this is used directly.
 *    If the expression evaluates to a string, then it will be converted to a RegExp
 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
 *    `new RegExp('^abc$')`.<br />
 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
 *    start at the index of the last search's match, thus not taking the whole input value into
 *    account.
 * @param {string=} ngChange Angular expression to be executed when input changes due to user
 *    interaction with the input element.
 * @param {boolean=} [ngTrim=true] If set to false Angular will not automatically trim the input.
 *    This parameter is ignored for input[type=password] controls, which will never trim the
 *    input.
 *
 * @example
    <example name="input-directive" module="inputExample">
      <file name="index.html">
       <script>
          angular.module('inputExample', [])
            .controller('ExampleController', ['$scope', function($scope) {
              $scope.user = {name: 'guest', last: 'visitor'};
            }]);
       </script>
       <div ng-controller="ExampleController">
         <form name="myForm">
           <label>
              User name:
              <input type="text" name="userName" ng-model="user.name" required>
           </label>
           <div role="alert">
             <span class="error" ng-show="myForm.userName.$error.required">
              Required!</span>
           </div>
           <label>
              Last name:
              <input type="text" name="lastName" ng-model="user.last"
              ng-minlength="3" ng-maxlength="10">
           </label>
           <div role="alert">
             <span class="error" ng-show="myForm.lastName.$error.minlength">
               Too short!</span>
             <span class="error" ng-show="myForm.lastName.$error.maxlength">
               Too long!</span>
           </div>
         </form>
         <hr>
         <tt>user = {{user}}</tt><br/>
         <tt>myForm.userName.$valid = {{myForm.userName.$valid}}</tt><br/>
         <tt>myForm.userName.$error = {{myForm.userName.$error}}</tt><br/>
         <tt>myForm.lastName.$valid = {{myForm.lastName.$valid}}</tt><br/>
         <tt>myForm.lastName.$error = {{myForm.lastName.$error}}</tt><br/>
         <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
         <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
         <tt>myForm.$error.minlength = {{!!myForm.$error.minlength}}</tt><br/>
         <tt>myForm.$error.maxlength = {{!!myForm.$error.maxlength}}</tt><br/>
       </div>
      </file>
      <file name="protractor.js" type="protractor">
        var user = element(by.exactBinding('user'));
        var userNameValid = element(by.binding('myForm.userName.$valid'));
        var lastNameValid = element(by.binding('myForm.lastName.$valid'));
        var lastNameError = element(by.binding('myForm.lastName.$error'));
        var formValid = element(by.binding('myForm.$valid'));
        var userNameInput = element(by.model('user.name'));
        var userLastInput = element(by.model('user.last'));

        it('should initialize to model', function() {
          expect(user.getText()).toContain('{"name":"guest","last":"visitor"}');
          expect(userNameValid.getText()).toContain('true');
          expect(formValid.getText()).toContain('true');
        });

        it('should be invalid if empty when required', function() {
          userNameInput.clear();
          userNameInput.sendKeys('');

          expect(user.getText()).toContain('{"last":"visitor"}');
          expect(userNameValid.getText()).toContain('false');
          expect(formValid.getText()).toContain('false');
        });

        it('should be valid if empty when min length is set', function() {
          userLastInput.clear();
          userLastInput.sendKeys('');

          expect(user.getText()).toContain('{"name":"guest","last":""}');
          expect(lastNameValid.getText()).toContain('true');
          expect(formValid.getText()).toContain('true');
        });

        it('should be invalid if less than required min length', function() {
          userLastInput.clear();
          userLastInput.sendKeys('xx');

          expect(user.getText()).toContain('{"name":"guest"}');
          expect(lastNameValid.getText()).toContain('false');
          expect(lastNameError.getText()).toContain('minlength');
          expect(formValid.getText()).toContain('false');
        });

        it('should be invalid if longer than max length', function() {
          userLastInput.clear();
          userLastInput.sendKeys('some ridiculously long name');

          expect(user.getText()).toContain('{"name":"guest"}');
          expect(lastNameValid.getText()).toContain('false');
          expect(lastNameError.getText()).toContain('maxlength');
          expect(formValid.getText()).toContain('false');
        });
      </file>
    </example>
 */
var inputDirective = ['$browser', '$sniffer', '$filter', '$parse',
    function($browser, $sniffer, $filter, $parse) {
  return {
    restrict: 'E',
    require: ['?ngModel'],
    link: {
      pre: function(scope, element, attr, ctrls) {
        if (ctrls[0]) {
          (inputType[lowercase(attr.type)] || inputType.text)(scope, element, attr, ctrls[0], $sniffer,
                                                              $browser, $filter, $parse);
        }
      }
    }
  };
}];



var CONSTANT_VALUE_REGEXP = /^(true|false|\d+)$/;
/**
 * @ngdoc directive
 * @name ngValue
 *
 * @description
 * Binds the given expression to the value of `<option>` or {@link input[radio] `input[radio]`},
 * so that when the element is selected, the {@link ngModel `ngModel`} of that element is set to
 * the bound value.
 *
 * `ngValue` is useful when dynamically generating lists of radio buttons using
 * {@link ngRepeat `ngRepeat`}, as shown below.
 *
 * Likewise, `ngValue` can be used to generate `<option>` elements for
 * the {@link select `select`} element. In that case however, only strings are supported
 * for the `value `attribute, so the resulting `ngModel` will always be a string.
 * Support for `select` models with non-string values is available via `ngOptions`.
 *
 * @element input
 * @param {string=} ngValue angular expression, whose value will be bound to the `value` attribute
 *   of the `input` element
 *
 * @example
    <example name="ngValue-directive" module="valueExample">
      <file name="index.html">
       <script>
          angular.module('valueExample', [])
            .controller('ExampleController', ['$scope', function($scope) {
              $scope.names = ['pizza', 'unicorns', 'robots'];
              $scope.my = { favorite: 'unicorns' };
            }]);
       </script>
        <form ng-controller="ExampleController">
          <h2>Which is your favorite?</h2>
            <label ng-repeat="name in names" for="{{name}}">
              {{name}}
              <input type="radio"
                     ng-model="my.favorite"
                     ng-value="name"
                     id="{{name}}"
                     name="favorite">
            </label>
          <div>You chose {{my.favorite}}</div>
        </form>
      </file>
      <file name="protractor.js" type="protractor">
        var favorite = element(by.binding('my.favorite'));

        it('should initialize to model', function() {
          expect(favorite.getText()).toContain('unicorns');
        });
        it('should bind the values to the inputs', function() {
          element.all(by.model('my.favorite')).get(0).click();
          expect(favorite.getText()).toContain('pizza');
        });
      </file>
    </example>
 */
var ngValueDirective = function() {
  return {
    restrict: 'A',
    priority: 100,
    compile: function(tpl, tplAttr) {
      if (CONSTANT_VALUE_REGEXP.test(tplAttr.ngValue)) {
        return function ngValueConstantLink(scope, elm, attr) {
          attr.$set('value', scope.$eval(attr.ngValue));
        };
      } else {
        return function ngValueLink(scope, elm, attr) {
          scope.$watch(attr.ngValue, function valueWatchAction(value) {
            attr.$set('value', value);
          });
        };
      }
    }
  };
};

/**
 * @ngdoc directive
 * @name ngBind
 * @restrict AC
 *
 * @description
 * The `ngBind` attribute tells Angular to replace the text content of the specified HTML element
 * with the value of a given expression, and to update the text content when the value of that
 * expression changes.
 *
 * Typically, you don't use `ngBind` directly, but instead you use the double curly markup like
 * `{{ expression }}` which is similar but less verbose.
 *
 * It is preferable to use `ngBind` instead of `{{ expression }}` if a template is momentarily
 * displayed by the browser in its raw state before Angular compiles it. Since `ngBind` is an
 * element attribute, it makes the bindings invisible to the user while the page is loading.
 *
 * An alternative solution to this problem would be using the
 * {@link ng.directive:ngCloak ngCloak} directive.
 *
 *
 * @element ANY
 * @param {expression} ngBind {@link guide/expression Expression} to evaluate.
 *
 * @example
 * Enter a name in the Live Preview text box; the greeting below the text box changes instantly.
   <example module="bindExample">
     <file name="index.html">
       <script>
         angular.module('bindExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.name = 'Whirled';
           }]);
       </script>
       <div ng-controller="ExampleController">
         <label>Enter name: <input type="text" ng-model="name"></label><br>
         Hello <span ng-bind="name"></span>!
       </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-bind', function() {
         var nameInput = element(by.model('name'));

         expect(element(by.binding('name')).getText()).toBe('Whirled');
         nameInput.clear();
         nameInput.sendKeys('world');
         expect(element(by.binding('name')).getText()).toBe('world');
       });
     </file>
   </example>
 */
var ngBindDirective = ['$compile', function($compile) {
  return {
    restrict: 'AC',
    compile: function ngBindCompile(templateElement) {
      $compile.$$addBindingClass(templateElement);
      return function ngBindLink(scope, element, attr) {
        $compile.$$addBindingInfo(element, attr.ngBind);
        element = element[0];
        scope.$watch(attr.ngBind, function ngBindWatchAction(value) {
          element.textContent = isUndefined(value) ? '' : value;
        });
      };
    }
  };
}];


/**
 * @ngdoc directive
 * @name ngBindTemplate
 *
 * @description
 * The `ngBindTemplate` directive specifies that the element
 * text content should be replaced with the interpolation of the template
 * in the `ngBindTemplate` attribute.
 * Unlike `ngBind`, the `ngBindTemplate` can contain multiple `{{` `}}`
 * expressions. This directive is needed since some HTML elements
 * (such as TITLE and OPTION) cannot contain SPAN elements.
 *
 * @element ANY
 * @param {string} ngBindTemplate template of form
 *   <tt>{{</tt> <tt>expression</tt> <tt>}}</tt> to eval.
 *
 * @example
 * Try it here: enter text in text box and watch the greeting change.
   <example module="bindExample">
     <file name="index.html">
       <script>
         angular.module('bindExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.salutation = 'Hello';
             $scope.name = 'World';
           }]);
       </script>
       <div ng-controller="ExampleController">
        <label>Salutation: <input type="text" ng-model="salutation"></label><br>
        <label>Name: <input type="text" ng-model="name"></label><br>
        <pre ng-bind-template="{{salutation}} {{name}}!"></pre>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-bind', function() {
         var salutationElem = element(by.binding('salutation'));
         var salutationInput = element(by.model('salutation'));
         var nameInput = element(by.model('name'));

         expect(salutationElem.getText()).toBe('Hello World!');

         salutationInput.clear();
         salutationInput.sendKeys('Greetings');
         nameInput.clear();
         nameInput.sendKeys('user');

         expect(salutationElem.getText()).toBe('Greetings user!');
       });
     </file>
   </example>
 */
var ngBindTemplateDirective = ['$interpolate', '$compile', function($interpolate, $compile) {
  return {
    compile: function ngBindTemplateCompile(templateElement) {
      $compile.$$addBindingClass(templateElement);
      return function ngBindTemplateLink(scope, element, attr) {
        var interpolateFn = $interpolate(element.attr(attr.$attr.ngBindTemplate));
        $compile.$$addBindingInfo(element, interpolateFn.expressions);
        element = element[0];
        attr.$observe('ngBindTemplate', function(value) {
          element.textContent = isUndefined(value) ? '' : value;
        });
      };
    }
  };
}];


/**
 * @ngdoc directive
 * @name ngBindHtml
 *
 * @description
 * Evaluates the expression and inserts the resulting HTML into the element in a secure way. By default,
 * the resulting HTML content will be sanitized using the {@link ngSanitize.$sanitize $sanitize} service.
 * To utilize this functionality, ensure that `$sanitize` is available, for example, by including {@link
 * ngSanitize} in your module's dependencies (not in core Angular). In order to use {@link ngSanitize}
 * in your module's dependencies, you need to include "angular-sanitize.js" in your application.
 *
 * You may also bypass sanitization for values you know are safe. To do so, bind to
 * an explicitly trusted value via {@link ng.$sce#trustAsHtml $sce.trustAsHtml}.  See the example
 * under {@link ng.$sce#show-me-an-example-using-sce- Strict Contextual Escaping (SCE)}.
 *
 * Note: If a `$sanitize` service is unavailable and the bound value isn't explicitly trusted, you
 * will have an exception (instead of an exploit.)
 *
 * @element ANY
 * @param {expression} ngBindHtml {@link guide/expression Expression} to evaluate.
 *
 * @example

   <example module="bindHtmlExample" deps="angular-sanitize.js">
     <file name="index.html">
       <div ng-controller="ExampleController">
        <p ng-bind-html="myHTML"></p>
       </div>
     </file>

     <file name="script.js">
       angular.module('bindHtmlExample', ['ngSanitize'])
         .controller('ExampleController', ['$scope', function($scope) {
           $scope.myHTML =
              'I am an <code>HTML</code>string with ' +
              '<a href="#">links!</a> and other <em>stuff</em>';
         }]);
     </file>

     <file name="protractor.js" type="protractor">
       it('should check ng-bind-html', function() {
         expect(element(by.binding('myHTML')).getText()).toBe(
             'I am an HTMLstring with links! and other stuff');
       });
     </file>
   </example>
 */
var ngBindHtmlDirective = ['$sce', '$parse', '$compile', function($sce, $parse, $compile) {
  return {
    restrict: 'A',
    compile: function ngBindHtmlCompile(tElement, tAttrs) {
      var ngBindHtmlGetter = $parse(tAttrs.ngBindHtml);
      var ngBindHtmlWatch = $parse(tAttrs.ngBindHtml, function sceValueOf(val) {
        // Unwrap the value to compare the actual inner safe value, not the wrapper object.
        return $sce.valueOf(val);
      });
      $compile.$$addBindingClass(tElement);

      return function ngBindHtmlLink(scope, element, attr) {
        $compile.$$addBindingInfo(element, attr.ngBindHtml);

        scope.$watch(ngBindHtmlWatch, function ngBindHtmlWatchAction() {
          // The watched value is the unwrapped value. To avoid re-escaping, use the direct getter.
          var value = ngBindHtmlGetter(scope);
          element.html($sce.getTrustedHtml(value) || '');
        });
      };
    }
  };
}];

/**
 * @ngdoc directive
 * @name ngChange
 *
 * @description
 * Evaluate the given expression when the user changes the input.
 * The expression is evaluated immediately, unlike the JavaScript onchange event
 * which only triggers at the end of a change (usually, when the user leaves the
 * form element or presses the return key).
 *
 * The `ngChange` expression is only evaluated when a change in the input value causes
 * a new value to be committed to the model.
 *
 * It will not be evaluated:
 * * if the value returned from the `$parsers` transformation pipeline has not changed
 * * if the input has continued to be invalid since the model will stay `null`
 * * if the model is changed programmatically and not by a change to the input value
 *
 *
 * Note, this directive requires `ngModel` to be present.
 *
 * @element input
 * @param {expression} ngChange {@link guide/expression Expression} to evaluate upon change
 * in input value.
 *
 * @example
 * <example name="ngChange-directive" module="changeExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('changeExample', [])
 *         .controller('ExampleController', ['$scope', function($scope) {
 *           $scope.counter = 0;
 *           $scope.change = function() {
 *             $scope.counter++;
 *           };
 *         }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <input type="checkbox" ng-model="confirmed" ng-change="change()" id="ng-change-example1" />
 *       <input type="checkbox" ng-model="confirmed" id="ng-change-example2" />
 *       <label for="ng-change-example2">Confirmed</label><br />
 *       <tt>debug = {{confirmed}}</tt><br/>
 *       <tt>counter = {{counter}}</tt><br/>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     var counter = element(by.binding('counter'));
 *     var debug = element(by.binding('confirmed'));
 *
 *     it('should evaluate the expression if changing from view', function() {
 *       expect(counter.getText()).toContain('0');
 *
 *       element(by.id('ng-change-example1')).click();
 *
 *       expect(counter.getText()).toContain('1');
 *       expect(debug.getText()).toContain('true');
 *     });
 *
 *     it('should not evaluate the expression if changing from model', function() {
 *       element(by.id('ng-change-example2')).click();

 *       expect(counter.getText()).toContain('0');
 *       expect(debug.getText()).toContain('true');
 *     });
 *   </file>
 * </example>
 */
var ngChangeDirective = valueFn({
  restrict: 'A',
  require: 'ngModel',
  link: function(scope, element, attr, ctrl) {
    ctrl.$viewChangeListeners.push(function() {
      scope.$eval(attr.ngChange);
    });
  }
});

function classDirective(name, selector) {
  name = 'ngClass' + name;
  return ['$animate', function($animate) {
    return {
      restrict: 'AC',
      link: function(scope, element, attr) {
        var oldVal;

        scope.$watch(attr[name], ngClassWatchAction, true);

        attr.$observe('class', function(value) {
          ngClassWatchAction(scope.$eval(attr[name]));
        });


        if (name !== 'ngClass') {
          scope.$watch('$index', function($index, old$index) {
            // jshint bitwise: false
            var mod = $index & 1;
            if (mod !== (old$index & 1)) {
              var classes = arrayClasses(scope.$eval(attr[name]));
              mod === selector ?
                addClasses(classes) :
                removeClasses(classes);
            }
          });
        }

        function addClasses(classes) {
          var newClasses = digestClassCounts(classes, 1);
          attr.$addClass(newClasses);
        }

        function removeClasses(classes) {
          var newClasses = digestClassCounts(classes, -1);
          attr.$removeClass(newClasses);
        }

        function digestClassCounts(classes, count) {
          // Use createMap() to prevent class assumptions involving property
          // names in Object.prototype
          var classCounts = element.data('$classCounts') || createMap();
          var classesToUpdate = [];
          forEach(classes, function(className) {
            if (count > 0 || classCounts[className]) {
              classCounts[className] = (classCounts[className] || 0) + count;
              if (classCounts[className] === +(count > 0)) {
                classesToUpdate.push(className);
              }
            }
          });
          element.data('$classCounts', classCounts);
          return classesToUpdate.join(' ');
        }

        function updateClasses(oldClasses, newClasses) {
          var toAdd = arrayDifference(newClasses, oldClasses);
          var toRemove = arrayDifference(oldClasses, newClasses);
          toAdd = digestClassCounts(toAdd, 1);
          toRemove = digestClassCounts(toRemove, -1);
          if (toAdd && toAdd.length) {
            $animate.addClass(element, toAdd);
          }
          if (toRemove && toRemove.length) {
            $animate.removeClass(element, toRemove);
          }
        }

        function ngClassWatchAction(newVal) {
          // jshint bitwise: false
          if (selector === true || (scope.$index & 1) === selector) {
          // jshint bitwise: true
            var newClasses = arrayClasses(newVal || []);
            if (!oldVal) {
              addClasses(newClasses);
            } else if (!equals(newVal,oldVal)) {
              var oldClasses = arrayClasses(oldVal);
              updateClasses(oldClasses, newClasses);
            }
          }
          if (isArray(newVal)) {
            oldVal = newVal.map(function(v) { return shallowCopy(v); });
          } else {
            oldVal = shallowCopy(newVal);
          }
        }
      }
    };

    function arrayDifference(tokens1, tokens2) {
      var values = [];

      outer:
      for (var i = 0; i < tokens1.length; i++) {
        var token = tokens1[i];
        for (var j = 0; j < tokens2.length; j++) {
          if (token == tokens2[j]) continue outer;
        }
        values.push(token);
      }
      return values;
    }

    function arrayClasses(classVal) {
      var classes = [];
      if (isArray(classVal)) {
        forEach(classVal, function(v) {
          classes = classes.concat(arrayClasses(v));
        });
        return classes;
      } else if (isString(classVal)) {
        return classVal.split(' ');
      } else if (isObject(classVal)) {
        forEach(classVal, function(v, k) {
          if (v) {
            classes = classes.concat(k.split(' '));
          }
        });
        return classes;
      }
      return classVal;
    }
  }];
}

/**
 * @ngdoc directive
 * @name ngClass
 * @restrict AC
 *
 * @description
 * The `ngClass` directive allows you to dynamically set CSS classes on an HTML element by databinding
 * an expression that represents all classes to be added.
 *
 * The directive operates in three different ways, depending on which of three types the expression
 * evaluates to:
 *
 * 1. If the expression evaluates to a string, the string should be one or more space-delimited class
 * names.
 *
 * 2. If the expression evaluates to an object, then for each key-value pair of the
 * object with a truthy value the corresponding key is used as a class name.
 *
 * 3. If the expression evaluates to an array, each element of the array should either be a string as in
 * type 1 or an object as in type 2. This means that you can mix strings and objects together in an array
 * to give you more control over what CSS classes appear. See the code below for an example of this.
 *
 *
 * The directive won't add duplicate classes if a particular class was already set.
 *
 * When the expression changes, the previously added classes are removed and only then are the
 * new classes added.
 *
 * @knownIssue
 * You should not use {@link guide/interpolation interpolation} in the value of the `class`
 * attribute, when using the `ngClass` directive on the same element.
 * See {@link guide/interpolation#known-issues here} for more info.
 *
 * @animations
 * | Animation                        | Occurs                              |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
 * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
 *
 * @element ANY
 * @param {expression} ngClass {@link guide/expression Expression} to eval. The result
 *   of the evaluation can be a string representing space delimited class
 *   names, an array, or a map of class names to boolean values. In the case of a map, the
 *   names of the properties whose values are truthy will be added as css classes to the
 *   element.
 *
 * @example Example that demonstrates basic bindings via ngClass directive.
   <example>
     <file name="index.html">
       <p ng-class="{strike: deleted, bold: important, 'has-error': error}">Map Syntax Example</p>
       <label>
          <input type="checkbox" ng-model="deleted">
          deleted (apply "strike" class)
       </label><br>
       <label>
          <input type="checkbox" ng-model="important">
          important (apply "bold" class)
       </label><br>
       <label>
          <input type="checkbox" ng-model="error">
          error (apply "has-error" class)
       </label>
       <hr>
       <p ng-class="style">Using String Syntax</p>
       <input type="text" ng-model="style"
              placeholder="Type: bold strike red" aria-label="Type: bold strike red">
       <hr>
       <p ng-class="[style1, style2, style3]">Using Array Syntax</p>
       <input ng-model="style1"
              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red"><br>
       <input ng-model="style2"
              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 2"><br>
       <input ng-model="style3"
              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 3"><br>
       <hr>
       <p ng-class="[style4, {orange: warning}]">Using Array and Map Syntax</p>
       <input ng-model="style4" placeholder="Type: bold, strike" aria-label="Type: bold, strike"><br>
       <label><input type="checkbox" ng-model="warning"> warning (apply "orange" class)</label>
     </file>
     <file name="style.css">
       .strike {
           text-decoration: line-through;
       }
       .bold {
           font-weight: bold;
       }
       .red {
           color: red;
       }
       .has-error {
           color: red;
           background-color: yellow;
       }
       .orange {
           color: orange;
       }
     </file>
     <file name="protractor.js" type="protractor">
       var ps = element.all(by.css('p'));

       it('should let you toggle the class', function() {

         expect(ps.first().getAttribute('class')).not.toMatch(/bold/);
         expect(ps.first().getAttribute('class')).not.toMatch(/has-error/);

         element(by.model('important')).click();
         expect(ps.first().getAttribute('class')).toMatch(/bold/);

         element(by.model('error')).click();
         expect(ps.first().getAttribute('class')).toMatch(/has-error/);
       });

       it('should let you toggle string example', function() {
         expect(ps.get(1).getAttribute('class')).toBe('');
         element(by.model('style')).clear();
         element(by.model('style')).sendKeys('red');
         expect(ps.get(1).getAttribute('class')).toBe('red');
       });

       it('array example should have 3 classes', function() {
         expect(ps.get(2).getAttribute('class')).toBe('');
         element(by.model('style1')).sendKeys('bold');
         element(by.model('style2')).sendKeys('strike');
         element(by.model('style3')).sendKeys('red');
         expect(ps.get(2).getAttribute('class')).toBe('bold strike red');
       });

       it('array with map example should have 2 classes', function() {
         expect(ps.last().getAttribute('class')).toBe('');
         element(by.model('style4')).sendKeys('bold');
         element(by.model('warning')).click();
         expect(ps.last().getAttribute('class')).toBe('bold orange');
       });
     </file>
   </example>

   ## Animations

   The example below demonstrates how to perform animations using ngClass.

   <example module="ngAnimate" deps="angular-animate.js" animations="true">
     <file name="index.html">
      <input id="setbtn" type="button" value="set" ng-click="myVar='my-class'">
      <input id="clearbtn" type="button" value="clear" ng-click="myVar=''">
      <br>
      <span class="base-class" ng-class="myVar">Sample Text</span>
     </file>
     <file name="style.css">
       .base-class {
         transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
       }

       .base-class.my-class {
         color: red;
         font-size:3em;
       }
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-class', function() {
         expect(element(by.css('.base-class')).getAttribute('class')).not.
           toMatch(/my-class/);

         element(by.id('setbtn')).click();

         expect(element(by.css('.base-class')).getAttribute('class')).
           toMatch(/my-class/);

         element(by.id('clearbtn')).click();

         expect(element(by.css('.base-class')).getAttribute('class')).not.
           toMatch(/my-class/);
       });
     </file>
   </example>


   ## ngClass and pre-existing CSS3 Transitions/Animations
   The ngClass directive still supports CSS3 Transitions/Animations even if they do not follow the ngAnimate CSS naming structure.
   Upon animation ngAnimate will apply supplementary CSS classes to track the start and end of an animation, but this will not hinder
   any pre-existing CSS transitions already on the element. To get an idea of what happens during a class-based animation, be sure
   to view the step by step details of {@link $animate#addClass $animate.addClass} and
   {@link $animate#removeClass $animate.removeClass}.
 */
var ngClassDirective = classDirective('', true);

/**
 * @ngdoc directive
 * @name ngClassOdd
 * @restrict AC
 *
 * @description
 * The `ngClassOdd` and `ngClassEven` directives work exactly as
 * {@link ng.directive:ngClass ngClass}, except they work in
 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
 *
 * This directive can be applied only within the scope of an
 * {@link ng.directive:ngRepeat ngRepeat}.
 *
 * @element ANY
 * @param {expression} ngClassOdd {@link guide/expression Expression} to eval. The result
 *   of the evaluation can be a string representing space delimited class names or an array.
 *
 * @example
   <example>
     <file name="index.html">
        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
          <li ng-repeat="name in names">
           <span ng-class-odd="'odd'" ng-class-even="'even'">
             {{name}}
           </span>
          </li>
        </ol>
     </file>
     <file name="style.css">
       .odd {
         color: red;
       }
       .even {
         color: blue;
       }
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-class-odd and ng-class-even', function() {
         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
           toMatch(/odd/);
         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
           toMatch(/even/);
       });
     </file>
   </example>
 */
var ngClassOddDirective = classDirective('Odd', 0);

/**
 * @ngdoc directive
 * @name ngClassEven
 * @restrict AC
 *
 * @description
 * The `ngClassOdd` and `ngClassEven` directives work exactly as
 * {@link ng.directive:ngClass ngClass}, except they work in
 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
 *
 * This directive can be applied only within the scope of an
 * {@link ng.directive:ngRepeat ngRepeat}.
 *
 * @element ANY
 * @param {expression} ngClassEven {@link guide/expression Expression} to eval. The
 *   result of the evaluation can be a string representing space delimited class names or an array.
 *
 * @example
   <example>
     <file name="index.html">
        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
          <li ng-repeat="name in names">
           <span ng-class-odd="'odd'" ng-class-even="'even'">
             {{name}} &nbsp; &nbsp; &nbsp;
           </span>
          </li>
        </ol>
     </file>
     <file name="style.css">
       .odd {
         color: red;
       }
       .even {
         color: blue;
       }
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-class-odd and ng-class-even', function() {
         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
           toMatch(/odd/);
         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
           toMatch(/even/);
       });
     </file>
   </example>
 */
var ngClassEvenDirective = classDirective('Even', 1);

/**
 * @ngdoc directive
 * @name ngCloak
 * @restrict AC
 *
 * @description
 * The `ngCloak` directive is used to prevent the Angular html template from being briefly
 * displayed by the browser in its raw (uncompiled) form while your application is loading. Use this
 * directive to avoid the undesirable flicker effect caused by the html template display.
 *
 * The directive can be applied to the `<body>` element, but the preferred usage is to apply
 * multiple `ngCloak` directives to small portions of the page to permit progressive rendering
 * of the browser view.
 *
 * `ngCloak` works in cooperation with the following css rule embedded within `angular.js` and
 * `angular.min.js`.
 * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
 *
 * ```css
 * [ng\:cloak], [ng-cloak], [data-ng-cloak], [x-ng-cloak], .ng-cloak, .x-ng-cloak {
 *   display: none !important;
 * }
 * ```
 *
 * When this css rule is loaded by the browser, all html elements (including their children) that
 * are tagged with the `ngCloak` directive are hidden. When Angular encounters this directive
 * during the compilation of the template it deletes the `ngCloak` element attribute, making
 * the compiled element visible.
 *
 * For the best result, the `angular.js` script must be loaded in the head section of the html
 * document; alternatively, the css rule above must be included in the external stylesheet of the
 * application.
 *
 * @element ANY
 *
 * @example
   <example>
     <file name="index.html">
        <div id="template1" ng-cloak>{{ 'hello' }}</div>
        <div id="template2" class="ng-cloak">{{ 'world' }}</div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should remove the template directive and css class', function() {
         expect($('#template1').getAttribute('ng-cloak')).
           toBeNull();
         expect($('#template2').getAttribute('ng-cloak')).
           toBeNull();
       });
     </file>
   </example>
 *
 */
var ngCloakDirective = ngDirective({
  compile: function(element, attr) {
    attr.$set('ngCloak', undefined);
    element.removeClass('ng-cloak');
  }
});

/**
 * @ngdoc directive
 * @name ngController
 *
 * @description
 * The `ngController` directive attaches a controller class to the view. This is a key aspect of how angular
 * supports the principles behind the Model-View-Controller design pattern.
 *
 * MVC components in angular:
 *
 * * Model — Models are the properties of a scope; scopes are attached to the DOM where scope properties
 *   are accessed through bindings.
 * * View — The template (HTML with data bindings) that is rendered into the View.
 * * Controller — The `ngController` directive specifies a Controller class; the class contains business
 *   logic behind the application to decorate the scope with functions and values
 *
 * Note that you can also attach controllers to the DOM by declaring it in a route definition
 * via the {@link ngRoute.$route $route} service. A common mistake is to declare the controller
 * again using `ng-controller` in the template itself.  This will cause the controller to be attached
 * and executed twice.
 *
 * @element ANY
 * @scope
 * @priority 500
 * @param {expression} ngController Name of a constructor function registered with the current
 * {@link ng.$controllerProvider $controllerProvider} or an {@link guide/expression expression}
 * that on the current scope evaluates to a constructor function.
 *
 * The controller instance can be published into a scope property by specifying
 * `ng-controller="as propertyName"`.
 *
 * If the current `$controllerProvider` is configured to use globals (via
 * {@link ng.$controllerProvider#allowGlobals `$controllerProvider.allowGlobals()` }), this may
 * also be the name of a globally accessible constructor function (not recommended).
 *
 * @example
 * Here is a simple form for editing user contact information. Adding, removing, clearing, and
 * greeting are methods declared on the controller (see source tab). These methods can
 * easily be called from the angular markup. Any changes to the data are automatically reflected
 * in the View without the need for a manual update.
 *
 * Two different declaration styles are included below:
 *
 * * one binds methods and properties directly onto the controller using `this`:
 * `ng-controller="SettingsController1 as settings"`
 * * one injects `$scope` into the controller:
 * `ng-controller="SettingsController2"`
 *
 * The second option is more common in the Angular community, and is generally used in boilerplates
 * and in this guide. However, there are advantages to binding properties directly to the controller
 * and avoiding scope.
 *
 * * Using `controller as` makes it obvious which controller you are accessing in the template when
 * multiple controllers apply to an element.
 * * If you are writing your controllers as classes you have easier access to the properties and
 * methods, which will appear on the scope, from inside the controller code.
 * * Since there is always a `.` in the bindings, you don't have to worry about prototypal
 * inheritance masking primitives.
 *
 * This example demonstrates the `controller as` syntax.
 *
 * <example name="ngControllerAs" module="controllerAsExample">
 *   <file name="index.html">
 *    <div id="ctrl-as-exmpl" ng-controller="SettingsController1 as settings">
 *      <label>Name: <input type="text" ng-model="settings.name"/></label>
 *      <button ng-click="settings.greet()">greet</button><br/>
 *      Contact:
 *      <ul>
 *        <li ng-repeat="contact in settings.contacts">
 *          <select ng-model="contact.type" aria-label="Contact method" id="select_{{$index}}">
 *             <option>phone</option>
 *             <option>email</option>
 *          </select>
 *          <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
 *          <button ng-click="settings.clearContact(contact)">clear</button>
 *          <button ng-click="settings.removeContact(contact)" aria-label="Remove">X</button>
 *        </li>
 *        <li><button ng-click="settings.addContact()">add</button></li>
 *     </ul>
 *    </div>
 *   </file>
 *   <file name="app.js">
 *    angular.module('controllerAsExample', [])
 *      .controller('SettingsController1', SettingsController1);
 *
 *    function SettingsController1() {
 *      this.name = "John Smith";
 *      this.contacts = [
 *        {type: 'phone', value: '408 555 1212'},
 *        {type: 'email', value: 'john.smith@example.org'} ];
 *    }
 *
 *    SettingsController1.prototype.greet = function() {
 *      alert(this.name);
 *    };
 *
 *    SettingsController1.prototype.addContact = function() {
 *      this.contacts.push({type: 'email', value: 'yourname@example.org'});
 *    };
 *
 *    SettingsController1.prototype.removeContact = function(contactToRemove) {
 *     var index = this.contacts.indexOf(contactToRemove);
 *      this.contacts.splice(index, 1);
 *    };
 *
 *    SettingsController1.prototype.clearContact = function(contact) {
 *      contact.type = 'phone';
 *      contact.value = '';
 *    };
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     it('should check controller as', function() {
 *       var container = element(by.id('ctrl-as-exmpl'));
 *         expect(container.element(by.model('settings.name'))
 *           .getAttribute('value')).toBe('John Smith');
 *
 *       var firstRepeat =
 *           container.element(by.repeater('contact in settings.contacts').row(0));
 *       var secondRepeat =
 *           container.element(by.repeater('contact in settings.contacts').row(1));
 *
 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
 *           .toBe('408 555 1212');
 *
 *       expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
 *           .toBe('john.smith@example.org');
 *
 *       firstRepeat.element(by.buttonText('clear')).click();
 *
 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
 *           .toBe('');
 *
 *       container.element(by.buttonText('add')).click();
 *
 *       expect(container.element(by.repeater('contact in settings.contacts').row(2))
 *           .element(by.model('contact.value'))
 *           .getAttribute('value'))
 *           .toBe('yourname@example.org');
 *     });
 *   </file>
 * </example>
 *
 * This example demonstrates the "attach to `$scope`" style of controller.
 *
 * <example name="ngController" module="controllerExample">
 *  <file name="index.html">
 *   <div id="ctrl-exmpl" ng-controller="SettingsController2">
 *     <label>Name: <input type="text" ng-model="name"/></label>
 *     <button ng-click="greet()">greet</button><br/>
 *     Contact:
 *     <ul>
 *       <li ng-repeat="contact in contacts">
 *         <select ng-model="contact.type" id="select_{{$index}}">
 *            <option>phone</option>
 *            <option>email</option>
 *         </select>
 *         <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
 *         <button ng-click="clearContact(contact)">clear</button>
 *         <button ng-click="removeContact(contact)">X</button>
 *       </li>
 *       <li>[ <button ng-click="addContact()">add</button> ]</li>
 *    </ul>
 *   </div>
 *  </file>
 *  <file name="app.js">
 *   angular.module('controllerExample', [])
 *     .controller('SettingsController2', ['$scope', SettingsController2]);
 *
 *   function SettingsController2($scope) {
 *     $scope.name = "John Smith";
 *     $scope.contacts = [
 *       {type:'phone', value:'408 555 1212'},
 *       {type:'email', value:'john.smith@example.org'} ];
 *
 *     $scope.greet = function() {
 *       alert($scope.name);
 *     };
 *
 *     $scope.addContact = function() {
 *       $scope.contacts.push({type:'email', value:'yourname@example.org'});
 *     };
 *
 *     $scope.removeContact = function(contactToRemove) {
 *       var index = $scope.contacts.indexOf(contactToRemove);
 *       $scope.contacts.splice(index, 1);
 *     };
 *
 *     $scope.clearContact = function(contact) {
 *       contact.type = 'phone';
 *       contact.value = '';
 *     };
 *   }
 *  </file>
 *  <file name="protractor.js" type="protractor">
 *    it('should check controller', function() {
 *      var container = element(by.id('ctrl-exmpl'));
 *
 *      expect(container.element(by.model('name'))
 *          .getAttribute('value')).toBe('John Smith');
 *
 *      var firstRepeat =
 *          container.element(by.repeater('contact in contacts').row(0));
 *      var secondRepeat =
 *          container.element(by.repeater('contact in contacts').row(1));
 *
 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
 *          .toBe('408 555 1212');
 *      expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
 *          .toBe('john.smith@example.org');
 *
 *      firstRepeat.element(by.buttonText('clear')).click();
 *
 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
 *          .toBe('');
 *
 *      container.element(by.buttonText('add')).click();
 *
 *      expect(container.element(by.repeater('contact in contacts').row(2))
 *          .element(by.model('contact.value'))
 *          .getAttribute('value'))
 *          .toBe('yourname@example.org');
 *    });
 *  </file>
 *</example>

 */
var ngControllerDirective = [function() {
  return {
    restrict: 'A',
    scope: true,
    controller: '@',
    priority: 500
  };
}];

/**
 * @ngdoc directive
 * @name ngCsp
 *
 * @element html
 * @description
 *
 * Angular has some features that can break certain
 * [CSP (Content Security Policy)](https://developer.mozilla.org/en/Security/CSP) rules.
 *
 * If you intend to implement these rules then you must tell Angular not to use these features.
 *
 * This is necessary when developing things like Google Chrome Extensions or Universal Windows Apps.
 *
 *
 * The following rules affect Angular:
 *
 * * `unsafe-eval`: this rule forbids apps to use `eval` or `Function(string)` generated functions
 * (among other things). Angular makes use of this in the {@link $parse} service to provide a 30%
 * increase in the speed of evaluating Angular expressions.
 *
 * * `unsafe-inline`: this rule forbids apps from inject custom styles into the document. Angular
 * makes use of this to include some CSS rules (e.g. {@link ngCloak} and {@link ngHide}).
 * To make these directives work when a CSP rule is blocking inline styles, you must link to the
 * `angular-csp.css` in your HTML manually.
 *
 * If you do not provide `ngCsp` then Angular tries to autodetect if CSP is blocking unsafe-eval
 * and automatically deactivates this feature in the {@link $parse} service. This autodetection,
 * however, triggers a CSP error to be logged in the console:
 *
 * ```
 * Refused to evaluate a string as JavaScript because 'unsafe-eval' is not an allowed source of
 * script in the following Content Security Policy directive: "default-src 'self'". Note that
 * 'script-src' was not explicitly set, so 'default-src' is used as a fallback.
 * ```
 *
 * This error is harmless but annoying. To prevent the error from showing up, put the `ngCsp`
 * directive on an element of the HTML document that appears before the `<script>` tag that loads
 * the `angular.js` file.
 *
 * *Note: This directive is only available in the `ng-csp` and `data-ng-csp` attribute form.*
 *
 * You can specify which of the CSP related Angular features should be deactivated by providing
 * a value for the `ng-csp` attribute. The options are as follows:
 *
 * * no-inline-style: this stops Angular from injecting CSS styles into the DOM
 *
 * * no-unsafe-eval: this stops Angular from optimizing $parse with unsafe eval of strings
 *
 * You can use these values in the following combinations:
 *
 *
 * * No declaration means that Angular will assume that you can do inline styles, but it will do
 * a runtime check for unsafe-eval. E.g. `<body>`. This is backwardly compatible with previous versions
 * of Angular.
 *
 * * A simple `ng-csp` (or `data-ng-csp`) attribute will tell Angular to deactivate both inline
 * styles and unsafe eval. E.g. `<body ng-csp>`. This is backwardly compatible with previous versions
 * of Angular.
 *
 * * Specifying only `no-unsafe-eval` tells Angular that we must not use eval, but that we can inject
 * inline styles. E.g. `<body ng-csp="no-unsafe-eval">`.
 *
 * * Specifying only `no-inline-style` tells Angular that we must not inject styles, but that we can
 * run eval - no automatic check for unsafe eval will occur. E.g. `<body ng-csp="no-inline-style">`
 *
 * * Specifying both `no-unsafe-eval` and `no-inline-style` tells Angular that we must not inject
 * styles nor use eval, which is the same as an empty: ng-csp.
 * E.g.`<body ng-csp="no-inline-style;no-unsafe-eval">`
 *
 * @example
 * This example shows how to apply the `ngCsp` directive to the `html` tag.
   ```html
     <!doctype html>
     <html ng-app ng-csp>
     ...
     ...
     </html>
   ```
  * @example
      // Note: the suffix `.csp` in the example name triggers
      // csp mode in our http server!
      <example name="example.csp" module="cspExample" ng-csp="true">
        <file name="index.html">
          <div ng-controller="MainController as ctrl">
            <div>
              <button ng-click="ctrl.inc()" id="inc">Increment</button>
              <span id="counter">
                {{ctrl.counter}}
              </span>
            </div>

            <div>
              <button ng-click="ctrl.evil()" id="evil">Evil</button>
              <span id="evilError">
                {{ctrl.evilError}}
              </span>
            </div>
          </div>
        </file>
        <file name="script.js">
           angular.module('cspExample', [])
             .controller('MainController', function() {
                this.counter = 0;
                this.inc = function() {
                  this.counter++;
                };
                this.evil = function() {
                  // jshint evil:true
                  try {
                    eval('1+2');
                  } catch (e) {
                    this.evilError = e.message;
                  }
                };
              });
        </file>
        <file name="protractor.js" type="protractor">
          var util, webdriver;

          var incBtn = element(by.id('inc'));
          var counter = element(by.id('counter'));
          var evilBtn = element(by.id('evil'));
          var evilError = element(by.id('evilError'));

          function getAndClearSevereErrors() {
            return browser.manage().logs().get('browser').then(function(browserLog) {
              return browserLog.filter(function(logEntry) {
                return logEntry.level.value > webdriver.logging.Level.WARNING.value;
              });
            });
          }

          function clearErrors() {
            getAndClearSevereErrors();
          }

          function expectNoErrors() {
            getAndClearSevereErrors().then(function(filteredLog) {
              expect(filteredLog.length).toEqual(0);
              if (filteredLog.length) {
                console.log('browser console errors: ' + util.inspect(filteredLog));
              }
            });
          }

          function expectError(regex) {
            getAndClearSevereErrors().then(function(filteredLog) {
              var found = false;
              filteredLog.forEach(function(log) {
                if (log.message.match(regex)) {
                  found = true;
                }
              });
              if (!found) {
                throw new Error('expected an error that matches ' + regex);
              }
            });
          }

          beforeEach(function() {
            util = require('util');
            webdriver = require('protractor/node_modules/selenium-webdriver');
          });

          // For now, we only test on Chrome,
          // as Safari does not load the page with Protractor's injected scripts,
          // and Firefox webdriver always disables content security policy (#6358)
          if (browser.params.browser !== 'chrome') {
            return;
          }

          it('should not report errors when the page is loaded', function() {
            // clear errors so we are not dependent on previous tests
            clearErrors();
            // Need to reload the page as the page is already loaded when
            // we come here
            browser.driver.getCurrentUrl().then(function(url) {
              browser.get(url);
            });
            expectNoErrors();
          });

          it('should evaluate expressions', function() {
            expect(counter.getText()).toEqual('0');
            incBtn.click();
            expect(counter.getText()).toEqual('1');
            expectNoErrors();
          });

          it('should throw and report an error when using "eval"', function() {
            evilBtn.click();
            expect(evilError.getText()).toMatch(/Content Security Policy/);
            expectError(/Content Security Policy/);
          });
        </file>
      </example>
  */

// ngCsp is not implemented as a proper directive any more, because we need it be processed while we
// bootstrap the system (before $parse is instantiated), for this reason we just have
// the csp() fn that looks for the `ng-csp` attribute anywhere in the current doc

/**
 * @ngdoc directive
 * @name ngClick
 *
 * @description
 * The ngClick directive allows you to specify custom behavior when
 * an element is clicked.
 *
 * @element ANY
 * @priority 0
 * @param {expression} ngClick {@link guide/expression Expression} to evaluate upon
 * click. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example>
     <file name="index.html">
      <button ng-click="count = count + 1" ng-init="count=0">
        Increment
      </button>
      <span>
        count: {{count}}
      </span>
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-click', function() {
         expect(element(by.binding('count')).getText()).toMatch('0');
         element(by.css('button')).click();
         expect(element(by.binding('count')).getText()).toMatch('1');
       });
     </file>
   </example>
 */
/*
 * A collection of directives that allows creation of custom event handlers that are defined as
 * angular expressions and are compiled and executed within the current scope.
 */
var ngEventDirectives = {};

// For events that might fire synchronously during DOM manipulation
// we need to execute their event handlers asynchronously using $evalAsync,
// so that they are not executed in an inconsistent state.
var forceAsyncEvents = {
  'blur': true,
  'focus': true
};
forEach(
  'click dblclick mousedown mouseup mouseover mouseout mousemove mouseenter mouseleave keydown keyup keypress submit focus blur copy cut paste'.split(' '),
  function(eventName) {
    var directiveName = directiveNormalize('ng-' + eventName);
    ngEventDirectives[directiveName] = ['$parse', '$rootScope', function($parse, $rootScope) {
      return {
        restrict: 'A',
        compile: function($element, attr) {
          // We expose the powerful $event object on the scope that provides access to the Window,
          // etc. that isn't protected by the fast paths in $parse.  We explicitly request better
          // checks at the cost of speed since event handler expressions are not executed as
          // frequently as regular change detection.
          var fn = $parse(attr[directiveName], /* interceptorFn */ null, /* expensiveChecks */ true);
          return function ngEventHandler(scope, element) {
            element.on(eventName, function(event) {
              var callback = function() {
                fn(scope, {$event:event});
              };
              if (forceAsyncEvents[eventName] && $rootScope.$$phase) {
                scope.$evalAsync(callback);
              } else {
                scope.$apply(callback);
              }
            });
          };
        }
      };
    }];
  }
);

/**
 * @ngdoc directive
 * @name ngDblclick
 *
 * @description
 * The `ngDblclick` directive allows you to specify custom behavior on a dblclick event.
 *
 * @element ANY
 * @priority 0
 * @param {expression} ngDblclick {@link guide/expression Expression} to evaluate upon
 * a dblclick. (The Event object is available as `$event`)
 *
 * @example
   <example>
     <file name="index.html">
      <button ng-dblclick="count = count + 1" ng-init="count=0">
        Increment (on double click)
      </button>
      count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngMousedown
 *
 * @description
 * The ngMousedown directive allows you to specify custom behavior on mousedown event.
 *
 * @element ANY
 * @priority 0
 * @param {expression} ngMousedown {@link guide/expression Expression} to evaluate upon
 * mousedown. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example>
     <file name="index.html">
      <button ng-mousedown="count = count + 1" ng-init="count=0">
        Increment (on mouse down)
      </button>
      count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngMouseup
 *
 * @description
 * Specify custom behavior on mouseup event.
 *
 * @element ANY
 * @priority 0
 * @param {expression} ngMouseup {@link guide/expression Expression} to evaluate upon
 * mouseup. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example>
     <file name="index.html">
      <button ng-mouseup="count = count + 1" ng-init="count=0">
        Increment (on mouse up)
      </button>
      count: {{count}}
     </file>
   </example>
 */

/**
 * @ngdoc directive
 * @name ngMouseover
 *
 * @description
 * Specify custom behavior on mouseover event.
 *
 * @element ANY
 * @priority 0
 * @param {expression} ngMouseover {@link guide/expression Expression} to evaluate upon
 * mouseover. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example>
     <file name="index.html">
      <button ng-mouseover="count = count + 1" ng-init="count=0">
        Increment (when mouse is over)
      </button>
      count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngMouseenter
 *
 * @description
 * Specify custom behavior on mouseenter event.
 *
 * @element ANY
 * @priority 0
 * @param {expression} ngMouseenter {@link guide/expression Expression} to evaluate upon
 * mouseenter. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example>
     <file name="index.html">
      <button ng-mouseenter="count = count + 1" ng-init="count=0">
        Increment (when mouse enters)
      </button>
      count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngMouseleave
 *
 * @description
 * Specify custom behavior on mouseleave event.
 *
 * @element ANY
 * @priority 0
 * @param {expression} ngMouseleave {@link guide/expression Expression} to evaluate upon
 * mouseleave. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example>
     <file name="index.html">
      <button ng-mouseleave="count = count + 1" ng-init="count=0">
        Increment (when mouse leaves)
      </button>
      count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngMousemove
 *
 * @description
 * Specify custom behavior on mousemove event.
 *
 * @element ANY
 * @priority 0
 * @param {expression} ngMousemove {@link guide/expression Expression} to evaluate upon
 * mousemove. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example>
     <file name="index.html">
      <button ng-mousemove="count = count + 1" ng-init="count=0">
        Increment (when mouse moves)
      </button>
      count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngKeydown
 *
 * @description
 * Specify custom behavior on keydown event.
 *
 * @element ANY
 * @priority 0
 * @param {expression} ngKeydown {@link guide/expression Expression} to evaluate upon
 * keydown. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
 *
 * @example
   <example>
     <file name="index.html">
      <input ng-keydown="count = count + 1" ng-init="count=0">
      key down count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngKeyup
 *
 * @description
 * Specify custom behavior on keyup event.
 *
 * @element ANY
 * @priority 0
 * @param {expression} ngKeyup {@link guide/expression Expression} to evaluate upon
 * keyup. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
 *
 * @example
   <example>
     <file name="index.html">
       <p>Typing in the input box below updates the key count</p>
       <input ng-keyup="count = count + 1" ng-init="count=0"> key up count: {{count}}

       <p>Typing in the input box below updates the keycode</p>
       <input ng-keyup="event=$event">
       <p>event keyCode: {{ event.keyCode }}</p>
       <p>event altKey: {{ event.altKey }}</p>
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngKeypress
 *
 * @description
 * Specify custom behavior on keypress event.
 *
 * @element ANY
 * @param {expression} ngKeypress {@link guide/expression Expression} to evaluate upon
 * keypress. ({@link guide/expression#-event- Event object is available as `$event`}
 * and can be interrogated for keyCode, altKey, etc.)
 *
 * @example
   <example>
     <file name="index.html">
      <input ng-keypress="count = count + 1" ng-init="count=0">
      key press count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngSubmit
 *
 * @description
 * Enables binding angular expressions to onsubmit events.
 *
 * Additionally it prevents the default action (which for form means sending the request to the
 * server and reloading the current page), but only if the form does not contain `action`,
 * `data-action`, or `x-action` attributes.
 *
 * <div class="alert alert-warning">
 * **Warning:** Be careful not to cause "double-submission" by using both the `ngClick` and
 * `ngSubmit` handlers together. See the
 * {@link form#submitting-a-form-and-preventing-the-default-action `form` directive documentation}
 * for a detailed discussion of when `ngSubmit` may be triggered.
 * </div>
 *
 * @element form
 * @priority 0
 * @param {expression} ngSubmit {@link guide/expression Expression} to eval.
 * ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example module="submitExample">
     <file name="index.html">
      <script>
        angular.module('submitExample', [])
          .controller('ExampleController', ['$scope', function($scope) {
            $scope.list = [];
            $scope.text = 'hello';
            $scope.submit = function() {
              if ($scope.text) {
                $scope.list.push(this.text);
                $scope.text = '';
              }
            };
          }]);
      </script>
      <form ng-submit="submit()" ng-controller="ExampleController">
        Enter text and hit enter:
        <input type="text" ng-model="text" name="text" />
        <input type="submit" id="submit" value="Submit" />
        <pre>list={{list}}</pre>
      </form>
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-submit', function() {
         expect(element(by.binding('list')).getText()).toBe('list=[]');
         element(by.css('#submit')).click();
         expect(element(by.binding('list')).getText()).toContain('hello');
         expect(element(by.model('text')).getAttribute('value')).toBe('');
       });
       it('should ignore empty strings', function() {
         expect(element(by.binding('list')).getText()).toBe('list=[]');
         element(by.css('#submit')).click();
         element(by.css('#submit')).click();
         expect(element(by.binding('list')).getText()).toContain('hello');
        });
     </file>
   </example>
 */

/**
 * @ngdoc directive
 * @name ngFocus
 *
 * @description
 * Specify custom behavior on focus event.
 *
 * Note: As the `focus` event is executed synchronously when calling `input.focus()`
 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
 * during an `$apply` to ensure a consistent state.
 *
 * @element window, input, select, textarea, a
 * @priority 0
 * @param {expression} ngFocus {@link guide/expression Expression} to evaluate upon
 * focus. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
 * See {@link ng.directive:ngClick ngClick}
 */

/**
 * @ngdoc directive
 * @name ngBlur
 *
 * @description
 * Specify custom behavior on blur event.
 *
 * A [blur event](https://developer.mozilla.org/en-US/docs/Web/Events/blur) fires when
 * an element has lost focus.
 *
 * Note: As the `blur` event is executed synchronously also during DOM manipulations
 * (e.g. removing a focussed input),
 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
 * during an `$apply` to ensure a consistent state.
 *
 * @element window, input, select, textarea, a
 * @priority 0
 * @param {expression} ngBlur {@link guide/expression Expression} to evaluate upon
 * blur. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
 * See {@link ng.directive:ngClick ngClick}
 */

/**
 * @ngdoc directive
 * @name ngCopy
 *
 * @description
 * Specify custom behavior on copy event.
 *
 * @element window, input, select, textarea, a
 * @priority 0
 * @param {expression} ngCopy {@link guide/expression Expression} to evaluate upon
 * copy. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example>
     <file name="index.html">
      <input ng-copy="copied=true" ng-init="copied=false; value='copy me'" ng-model="value">
      copied: {{copied}}
     </file>
   </example>
 */

/**
 * @ngdoc directive
 * @name ngCut
 *
 * @description
 * Specify custom behavior on cut event.
 *
 * @element window, input, select, textarea, a
 * @priority 0
 * @param {expression} ngCut {@link guide/expression Expression} to evaluate upon
 * cut. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example>
     <file name="index.html">
      <input ng-cut="cut=true" ng-init="cut=false; value='cut me'" ng-model="value">
      cut: {{cut}}
     </file>
   </example>
 */

/**
 * @ngdoc directive
 * @name ngPaste
 *
 * @description
 * Specify custom behavior on paste event.
 *
 * @element window, input, select, textarea, a
 * @priority 0
 * @param {expression} ngPaste {@link guide/expression Expression} to evaluate upon
 * paste. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example>
     <file name="index.html">
      <input ng-paste="paste=true" ng-init="paste=false" placeholder='paste here'>
      pasted: {{paste}}
     </file>
   </example>
 */

/**
 * @ngdoc directive
 * @name ngIf
 * @restrict A
 * @multiElement
 *
 * @description
 * The `ngIf` directive removes or recreates a portion of the DOM tree based on an
 * {expression}. If the expression assigned to `ngIf` evaluates to a false
 * value then the element is removed from the DOM, otherwise a clone of the
 * element is reinserted into the DOM.
 *
 * `ngIf` differs from `ngShow` and `ngHide` in that `ngIf` completely removes and recreates the
 * element in the DOM rather than changing its visibility via the `display` css property.  A common
 * case when this difference is significant is when using css selectors that rely on an element's
 * position within the DOM, such as the `:first-child` or `:last-child` pseudo-classes.
 *
 * Note that when an element is removed using `ngIf` its scope is destroyed and a new scope
 * is created when the element is restored.  The scope created within `ngIf` inherits from
 * its parent scope using
 * [prototypal inheritance](https://github.com/angular/angular.js/wiki/Understanding-Scopes#javascript-prototypal-inheritance).
 * An important implication of this is if `ngModel` is used within `ngIf` to bind to
 * a javascript primitive defined in the parent scope. In this case any modifications made to the
 * variable within the child scope will override (hide) the value in the parent scope.
 *
 * Also, `ngIf` recreates elements using their compiled state. An example of this behavior
 * is if an element's class attribute is directly modified after it's compiled, using something like
 * jQuery's `.addClass()` method, and the element is later removed. When `ngIf` recreates the element
 * the added class will be lost because the original compiled state is used to regenerate the element.
 *
 * Additionally, you can provide animations via the `ngAnimate` module to animate the `enter`
 * and `leave` effects.
 *
 * @animations
 * | Animation                        | Occurs                               |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#enter enter}  | just after the `ngIf` contents change and a new DOM element is created and injected into the `ngIf` container |
 * | {@link ng.$animate#leave leave}  | just before the `ngIf` contents are removed from the DOM |
 *
 * @element ANY
 * @scope
 * @priority 600
 * @param {expression} ngIf If the {@link guide/expression expression} is falsy then
 *     the element is removed from the DOM tree. If it is truthy a copy of the compiled
 *     element is added to the DOM tree.
 *
 * @example
  <example module="ngAnimate" deps="angular-animate.js" animations="true">
    <file name="index.html">
      <label>Click me: <input type="checkbox" ng-model="checked" ng-init="checked=true" /></label><br/>
      Show when checked:
      <span ng-if="checked" class="animate-if">
        This is removed when the checkbox is unchecked.
      </span>
    </file>
    <file name="animations.css">
      .animate-if {
        background:white;
        border:1px solid black;
        padding:10px;
      }

      .animate-if.ng-enter, .animate-if.ng-leave {
        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
      }

      .animate-if.ng-enter,
      .animate-if.ng-leave.ng-leave-active {
        opacity:0;
      }

      .animate-if.ng-leave,
      .animate-if.ng-enter.ng-enter-active {
        opacity:1;
      }
    </file>
  </example>
 */
var ngIfDirective = ['$animate', '$compile', function($animate, $compile) {
  return {
    multiElement: true,
    transclude: 'element',
    priority: 600,
    terminal: true,
    restrict: 'A',
    $$tlb: true,
    link: function($scope, $element, $attr, ctrl, $transclude) {
        var block, childScope, previousElements;
        $scope.$watch($attr.ngIf, function ngIfWatchAction(value) {

          if (value) {
            if (!childScope) {
              $transclude(function(clone, newScope) {
                childScope = newScope;
                clone[clone.length++] = $compile.$$createComment('end ngIf', $attr.ngIf);
                // Note: We only need the first/last node of the cloned nodes.
                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
                // by a directive with templateUrl when its template arrives.
                block = {
                  clone: clone
                };
                $animate.enter(clone, $element.parent(), $element);
              });
            }
          } else {
            if (previousElements) {
              previousElements.remove();
              previousElements = null;
            }
            if (childScope) {
              childScope.$destroy();
              childScope = null;
            }
            if (block) {
              previousElements = getBlockNodes(block.clone);
              $animate.leave(previousElements).then(function() {
                previousElements = null;
              });
              block = null;
            }
          }
        });
    }
  };
}];

/**
 * @ngdoc directive
 * @name ngInclude
 * @restrict ECA
 *
 * @description
 * Fetches, compiles and includes an external HTML fragment.
 *
 * By default, the template URL is restricted to the same domain and protocol as the
 * application document. This is done by calling {@link $sce#getTrustedResourceUrl
 * $sce.getTrustedResourceUrl} on it. To load templates from other domains or protocols
 * you may either {@link ng.$sceDelegateProvider#resourceUrlWhitelist whitelist them} or
 * {@link $sce#trustAsResourceUrl wrap them} as trusted values. Refer to Angular's {@link
 * ng.$sce Strict Contextual Escaping}.
 *
 * In addition, the browser's
 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
 * policy may further restrict whether the template is successfully loaded.
 * For example, `ngInclude` won't work for cross-domain requests on all browsers and for `file://`
 * access on some browsers.
 *
 * @animations
 * | Animation                        | Occurs                              |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#enter enter}  | when the expression changes, on the new include |
 * | {@link ng.$animate#leave leave}  | when the expression changes, on the old include |
 *
 * The enter and leave animation occur concurrently.
 *
 * @scope
 * @priority 400
 *
 * @param {string} ngInclude|src angular expression evaluating to URL. If the source is a string constant,
 *                 make sure you wrap it in **single** quotes, e.g. `src="'myPartialTemplate.html'"`.
 * @param {string=} onload Expression to evaluate when a new partial is loaded.
 *                  <div class="alert alert-warning">
 *                  **Note:** When using onload on SVG elements in IE11, the browser will try to call
 *                  a function with the name on the window element, which will usually throw a
 *                  "function is undefined" error. To fix this, you can instead use `data-onload` or a
 *                  different form that {@link guide/directive#normalization matches} `onload`.
 *                  </div>
   *
 * @param {string=} autoscroll Whether `ngInclude` should call {@link ng.$anchorScroll
 *                  $anchorScroll} to scroll the viewport after the content is loaded.
 *
 *                  - If the attribute is not set, disable scrolling.
 *                  - If the attribute is set without value, enable scrolling.
 *                  - Otherwise enable scrolling only if the expression evaluates to truthy value.
 *
 * @example
  <example module="includeExample" deps="angular-animate.js" animations="true">
    <file name="index.html">
     <div ng-controller="ExampleController">
       <select ng-model="template" ng-options="t.name for t in templates">
        <option value="">(blank)</option>
       </select>
       url of the template: <code>{{template.url}}</code>
       <hr/>
       <div class="slide-animate-container">
         <div class="slide-animate" ng-include="template.url"></div>
       </div>
     </div>
    </file>
    <file name="script.js">
      angular.module('includeExample', ['ngAnimate'])
        .controller('ExampleController', ['$scope', function($scope) {
          $scope.templates =
            [ { name: 'template1.html', url: 'template1.html'},
              { name: 'template2.html', url: 'template2.html'} ];
          $scope.template = $scope.templates[0];
        }]);
     </file>
    <file name="template1.html">
      Content of template1.html
    </file>
    <file name="template2.html">
      Content of template2.html
    </file>
    <file name="animations.css">
      .slide-animate-container {
        position:relative;
        background:white;
        border:1px solid black;
        height:40px;
        overflow:hidden;
      }

      .slide-animate {
        padding:10px;
      }

      .slide-animate.ng-enter, .slide-animate.ng-leave {
        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;

        position:absolute;
        top:0;
        left:0;
        right:0;
        bottom:0;
        display:block;
        padding:10px;
      }

      .slide-animate.ng-enter {
        top:-50px;
      }
      .slide-animate.ng-enter.ng-enter-active {
        top:0;
      }

      .slide-animate.ng-leave {
        top:0;
      }
      .slide-animate.ng-leave.ng-leave-active {
        top:50px;
      }
    </file>
    <file name="protractor.js" type="protractor">
      var templateSelect = element(by.model('template'));
      var includeElem = element(by.css('[ng-include]'));

      it('should load template1.html', function() {
        expect(includeElem.getText()).toMatch(/Content of template1.html/);
      });

      it('should load template2.html', function() {
        if (browser.params.browser == 'firefox') {
          // Firefox can't handle using selects
          // See https://github.com/angular/protractor/issues/480
          return;
        }
        templateSelect.click();
        templateSelect.all(by.css('option')).get(2).click();
        expect(includeElem.getText()).toMatch(/Content of template2.html/);
      });

      it('should change to blank', function() {
        if (browser.params.browser == 'firefox') {
          // Firefox can't handle using selects
          return;
        }
        templateSelect.click();
        templateSelect.all(by.css('option')).get(0).click();
        expect(includeElem.isPresent()).toBe(false);
      });
    </file>
  </example>
 */


/**
 * @ngdoc event
 * @name ngInclude#$includeContentRequested
 * @eventType emit on the scope ngInclude was declared in
 * @description
 * Emitted every time the ngInclude content is requested.
 *
 * @param {Object} angularEvent Synthetic event object.
 * @param {String} src URL of content to load.
 */


/**
 * @ngdoc event
 * @name ngInclude#$includeContentLoaded
 * @eventType emit on the current ngInclude scope
 * @description
 * Emitted every time the ngInclude content is reloaded.
 *
 * @param {Object} angularEvent Synthetic event object.
 * @param {String} src URL of content to load.
 */


/**
 * @ngdoc event
 * @name ngInclude#$includeContentError
 * @eventType emit on the scope ngInclude was declared in
 * @description
 * Emitted when a template HTTP request yields an erroneous response (status < 200 || status > 299)
 *
 * @param {Object} angularEvent Synthetic event object.
 * @param {String} src URL of content to load.
 */
var ngIncludeDirective = ['$templateRequest', '$anchorScroll', '$animate',
                  function($templateRequest,   $anchorScroll,   $animate) {
  return {
    restrict: 'ECA',
    priority: 400,
    terminal: true,
    transclude: 'element',
    controller: angular.noop,
    compile: function(element, attr) {
      var srcExp = attr.ngInclude || attr.src,
          onloadExp = attr.onload || '',
          autoScrollExp = attr.autoscroll;

      return function(scope, $element, $attr, ctrl, $transclude) {
        var changeCounter = 0,
            currentScope,
            previousElement,
            currentElement;

        var cleanupLastIncludeContent = function() {
          if (previousElement) {
            previousElement.remove();
            previousElement = null;
          }
          if (currentScope) {
            currentScope.$destroy();
            currentScope = null;
          }
          if (currentElement) {
            $animate.leave(currentElement).then(function() {
              previousElement = null;
            });
            previousElement = currentElement;
            currentElement = null;
          }
        };

        scope.$watch(srcExp, function ngIncludeWatchAction(src) {
          var afterAnimation = function() {
            if (isDefined(autoScrollExp) && (!autoScrollExp || scope.$eval(autoScrollExp))) {
              $anchorScroll();
            }
          };
          var thisChangeId = ++changeCounter;

          if (src) {
            //set the 2nd param to true to ignore the template request error so that the inner
            //contents and scope can be cleaned up.
            $templateRequest(src, true).then(function(response) {
              if (scope.$$destroyed) return;

              if (thisChangeId !== changeCounter) return;
              var newScope = scope.$new();
              ctrl.template = response;

              // Note: This will also link all children of ng-include that were contained in the original
              // html. If that content contains controllers, ... they could pollute/change the scope.
              // However, using ng-include on an element with additional content does not make sense...
              // Note: We can't remove them in the cloneAttchFn of $transclude as that
              // function is called before linking the content, which would apply child
              // directives to non existing elements.
              var clone = $transclude(newScope, function(clone) {
                cleanupLastIncludeContent();
                $animate.enter(clone, null, $element).then(afterAnimation);
              });

              currentScope = newScope;
              currentElement = clone;

              currentScope.$emit('$includeContentLoaded', src);
              scope.$eval(onloadExp);
            }, function() {
              if (scope.$$destroyed) return;

              if (thisChangeId === changeCounter) {
                cleanupLastIncludeContent();
                scope.$emit('$includeContentError', src);
              }
            });
            scope.$emit('$includeContentRequested', src);
          } else {
            cleanupLastIncludeContent();
            ctrl.template = null;
          }
        });
      };
    }
  };
}];

// This directive is called during the $transclude call of the first `ngInclude` directive.
// It will replace and compile the content of the element with the loaded template.
// We need this directive so that the element content is already filled when
// the link function of another directive on the same element as ngInclude
// is called.
var ngIncludeFillContentDirective = ['$compile',
  function($compile) {
    return {
      restrict: 'ECA',
      priority: -400,
      require: 'ngInclude',
      link: function(scope, $element, $attr, ctrl) {
        if (toString.call($element[0]).match(/SVG/)) {
          // WebKit: https://bugs.webkit.org/show_bug.cgi?id=135698 --- SVG elements do not
          // support innerHTML, so detect this here and try to generate the contents
          // specially.
          $element.empty();
          $compile(jqLiteBuildFragment(ctrl.template, window.document).childNodes)(scope,
              function namespaceAdaptedClone(clone) {
            $element.append(clone);
          }, {futureParentElement: $element});
          return;
        }

        $element.html(ctrl.template);
        $compile($element.contents())(scope);
      }
    };
  }];

/**
 * @ngdoc directive
 * @name ngInit
 * @restrict AC
 *
 * @description
 * The `ngInit` directive allows you to evaluate an expression in the
 * current scope.
 *
 * <div class="alert alert-danger">
 * This directive can be abused to add unnecessary amounts of logic into your templates.
 * There are only a few appropriate uses of `ngInit`, such as for aliasing special properties of
 * {@link ng.directive:ngRepeat `ngRepeat`}, as seen in the demo below; and for injecting data via
 * server side scripting. Besides these few cases, you should use {@link guide/controller controllers}
 * rather than `ngInit` to initialize values on a scope.
 * </div>
 *
 * <div class="alert alert-warning">
 * **Note**: If you have assignment in `ngInit` along with a {@link ng.$filter `filter`}, make
 * sure you have parentheses to ensure correct operator precedence:
 * <pre class="prettyprint">
 * `<div ng-init="test1 = ($index | toString)"></div>`
 * </pre>
 * </div>
 *
 * @priority 450
 *
 * @element ANY
 * @param {expression} ngInit {@link guide/expression Expression} to eval.
 *
 * @example
   <example module="initExample">
     <file name="index.html">
   <script>
     angular.module('initExample', [])
       .controller('ExampleController', ['$scope', function($scope) {
         $scope.list = [['a', 'b'], ['c', 'd']];
       }]);
   </script>
   <div ng-controller="ExampleController">
     <div ng-repeat="innerList in list" ng-init="outerIndex = $index">
       <div ng-repeat="value in innerList" ng-init="innerIndex = $index">
          <span class="example-init">list[ {{outerIndex}} ][ {{innerIndex}} ] = {{value}};</span>
       </div>
     </div>
   </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should alias index positions', function() {
         var elements = element.all(by.css('.example-init'));
         expect(elements.get(0).getText()).toBe('list[ 0 ][ 0 ] = a;');
         expect(elements.get(1).getText()).toBe('list[ 0 ][ 1 ] = b;');
         expect(elements.get(2).getText()).toBe('list[ 1 ][ 0 ] = c;');
         expect(elements.get(3).getText()).toBe('list[ 1 ][ 1 ] = d;');
       });
     </file>
   </example>
 */
var ngInitDirective = ngDirective({
  priority: 450,
  compile: function() {
    return {
      pre: function(scope, element, attrs) {
        scope.$eval(attrs.ngInit);
      }
    };
  }
});

/**
 * @ngdoc directive
 * @name ngList
 *
 * @description
 * Text input that converts between a delimited string and an array of strings. The default
 * delimiter is a comma followed by a space - equivalent to `ng-list=", "`. You can specify a custom
 * delimiter as the value of the `ngList` attribute - for example, `ng-list=" | "`.
 *
 * The behaviour of the directive is affected by the use of the `ngTrim` attribute.
 * * If `ngTrim` is set to `"false"` then whitespace around both the separator and each
 *   list item is respected. This implies that the user of the directive is responsible for
 *   dealing with whitespace but also allows you to use whitespace as a delimiter, such as a
 *   tab or newline character.
 * * Otherwise whitespace around the delimiter is ignored when splitting (although it is respected
 *   when joining the list items back together) and whitespace around each list item is stripped
 *   before it is added to the model.
 *
 * ### Example with Validation
 *
 * <example name="ngList-directive" module="listExample">
 *   <file name="app.js">
 *      angular.module('listExample', [])
 *        .controller('ExampleController', ['$scope', function($scope) {
 *          $scope.names = ['morpheus', 'neo', 'trinity'];
 *        }]);
 *   </file>
 *   <file name="index.html">
 *    <form name="myForm" ng-controller="ExampleController">
 *      <label>List: <input name="namesInput" ng-model="names" ng-list required></label>
 *      <span role="alert">
 *        <span class="error" ng-show="myForm.namesInput.$error.required">
 *        Required!</span>
 *      </span>
 *      <br>
 *      <tt>names = {{names}}</tt><br/>
 *      <tt>myForm.namesInput.$valid = {{myForm.namesInput.$valid}}</tt><br/>
 *      <tt>myForm.namesInput.$error = {{myForm.namesInput.$error}}</tt><br/>
 *      <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
 *      <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
 *     </form>
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     var listInput = element(by.model('names'));
 *     var names = element(by.exactBinding('names'));
 *     var valid = element(by.binding('myForm.namesInput.$valid'));
 *     var error = element(by.css('span.error'));
 *
 *     it('should initialize to model', function() {
 *       expect(names.getText()).toContain('["morpheus","neo","trinity"]');
 *       expect(valid.getText()).toContain('true');
 *       expect(error.getCssValue('display')).toBe('none');
 *     });
 *
 *     it('should be invalid if empty', function() {
 *       listInput.clear();
 *       listInput.sendKeys('');
 *
 *       expect(names.getText()).toContain('');
 *       expect(valid.getText()).toContain('false');
 *       expect(error.getCssValue('display')).not.toBe('none');
 *     });
 *   </file>
 * </example>
 *
 * ### Example - splitting on newline
 * <example name="ngList-directive-newlines">
 *   <file name="index.html">
 *    <textarea ng-model="list" ng-list="&#10;" ng-trim="false"></textarea>
 *    <pre>{{ list | json }}</pre>
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     it("should split the text by newlines", function() {
 *       var listInput = element(by.model('list'));
 *       var output = element(by.binding('list | json'));
 *       listInput.sendKeys('abc\ndef\nghi');
 *       expect(output.getText()).toContain('[\n  "abc",\n  "def",\n  "ghi"\n]');
 *     });
 *   </file>
 * </example>
 *
 * @element input
 * @param {string=} ngList optional delimiter that should be used to split the value.
 */
var ngListDirective = function() {
  return {
    restrict: 'A',
    priority: 100,
    require: 'ngModel',
    link: function(scope, element, attr, ctrl) {
      // We want to control whitespace trimming so we use this convoluted approach
      // to access the ngList attribute, which doesn't pre-trim the attribute
      var ngList = element.attr(attr.$attr.ngList) || ', ';
      var trimValues = attr.ngTrim !== 'false';
      var separator = trimValues ? trim(ngList) : ngList;

      var parse = function(viewValue) {
        // If the viewValue is invalid (say required but empty) it will be `undefined`
        if (isUndefined(viewValue)) return;

        var list = [];

        if (viewValue) {
          forEach(viewValue.split(separator), function(value) {
            if (value) list.push(trimValues ? trim(value) : value);
          });
        }

        return list;
      };

      ctrl.$parsers.push(parse);
      ctrl.$formatters.push(function(value) {
        if (isArray(value)) {
          return value.join(ngList);
        }

        return undefined;
      });

      // Override the standard $isEmpty because an empty array means the input is empty.
      ctrl.$isEmpty = function(value) {
        return !value || !value.length;
      };
    }
  };
};

/* global VALID_CLASS: true,
  INVALID_CLASS: true,
  PRISTINE_CLASS: true,
  DIRTY_CLASS: true,
  UNTOUCHED_CLASS: true,
  TOUCHED_CLASS: true,
*/

var VALID_CLASS = 'ng-valid',
    INVALID_CLASS = 'ng-invalid',
    PRISTINE_CLASS = 'ng-pristine',
    DIRTY_CLASS = 'ng-dirty',
    UNTOUCHED_CLASS = 'ng-untouched',
    TOUCHED_CLASS = 'ng-touched',
    PENDING_CLASS = 'ng-pending',
    EMPTY_CLASS = 'ng-empty',
    NOT_EMPTY_CLASS = 'ng-not-empty';

var ngModelMinErr = minErr('ngModel');

/**
 * @ngdoc type
 * @name ngModel.NgModelController
 *
 * @property {*} $viewValue The actual value from the control's view. For `input` elements, this is a
 * String. See {@link ngModel.NgModelController#$setViewValue} for information about when the $viewValue
 * is set.
 * @property {*} $modelValue The value in the model that the control is bound to.
 * @property {Array.<Function>} $parsers Array of functions to execute, as a pipeline, whenever
       the control reads value from the DOM. The functions are called in array order, each passing
       its return value through to the next. The last return value is forwarded to the
       {@link ngModel.NgModelController#$validators `$validators`} collection.

Parsers are used to sanitize / convert the {@link ngModel.NgModelController#$viewValue
`$viewValue`}.

Returning `undefined` from a parser means a parse error occurred. In that case,
no {@link ngModel.NgModelController#$validators `$validators`} will run and the `ngModel`
will be set to `undefined` unless {@link ngModelOptions `ngModelOptions.allowInvalid`}
is set to `true`. The parse error is stored in `ngModel.$error.parse`.

 *
 * @property {Array.<Function>} $formatters Array of functions to execute, as a pipeline, whenever
       the model value changes. The functions are called in reverse array order, each passing the value through to the
       next. The last return value is used as the actual DOM value.
       Used to format / convert values for display in the control.
 * ```js
 * function formatter(value) {
 *   if (value) {
 *     return value.toUpperCase();
 *   }
 * }
 * ngModel.$formatters.push(formatter);
 * ```
 *
 * @property {Object.<string, function>} $validators A collection of validators that are applied
 *      whenever the model value changes. The key value within the object refers to the name of the
 *      validator while the function refers to the validation operation. The validation operation is
 *      provided with the model value as an argument and must return a true or false value depending
 *      on the response of that validation.
 *
 * ```js
 * ngModel.$validators.validCharacters = function(modelValue, viewValue) {
 *   var value = modelValue || viewValue;
 *   return /[0-9]+/.test(value) &&
 *          /[a-z]+/.test(value) &&
 *          /[A-Z]+/.test(value) &&
 *          /\W+/.test(value);
 * };
 * ```
 *
 * @property {Object.<string, function>} $asyncValidators A collection of validations that are expected to
 *      perform an asynchronous validation (e.g. a HTTP request). The validation function that is provided
 *      is expected to return a promise when it is run during the model validation process. Once the promise
 *      is delivered then the validation status will be set to true when fulfilled and false when rejected.
 *      When the asynchronous validators are triggered, each of the validators will run in parallel and the model
 *      value will only be updated once all validators have been fulfilled. As long as an asynchronous validator
 *      is unfulfilled, its key will be added to the controllers `$pending` property. Also, all asynchronous validators
 *      will only run once all synchronous validators have passed.
 *
 * Please note that if $http is used then it is important that the server returns a success HTTP response code
 * in order to fulfill the validation and a status level of `4xx` in order to reject the validation.
 *
 * ```js
 * ngModel.$asyncValidators.uniqueUsername = function(modelValue, viewValue) {
 *   var value = modelValue || viewValue;
 *
 *   // Lookup user by username
 *   return $http.get('/api/users/' + value).
 *      then(function resolved() {
 *        //username exists, this means validation fails
 *        return $q.reject('exists');
 *      }, function rejected() {
 *        //username does not exist, therefore this validation passes
 *        return true;
 *      });
 * };
 * ```
 *
 * @property {Array.<Function>} $viewChangeListeners Array of functions to execute whenever the
 *     view value has changed. It is called with no arguments, and its return value is ignored.
 *     This can be used in place of additional $watches against the model value.
 *
 * @property {Object} $error An object hash with all failing validator ids as keys.
 * @property {Object} $pending An object hash with all pending validator ids as keys.
 *
 * @property {boolean} $untouched True if control has not lost focus yet.
 * @property {boolean} $touched True if control has lost focus.
 * @property {boolean} $pristine True if user has not interacted with the control yet.
 * @property {boolean} $dirty True if user has already interacted with the control.
 * @property {boolean} $valid True if there is no error.
 * @property {boolean} $invalid True if at least one error on the control.
 * @property {string} $name The name attribute of the control.
 *
 * @description
 *
 * `NgModelController` provides API for the {@link ngModel `ngModel`} directive.
 * The controller contains services for data-binding, validation, CSS updates, and value formatting
 * and parsing. It purposefully does not contain any logic which deals with DOM rendering or
 * listening to DOM events.
 * Such DOM related logic should be provided by other directives which make use of
 * `NgModelController` for data-binding to control elements.
 * Angular provides this DOM logic for most {@link input `input`} elements.
 * At the end of this page you can find a {@link ngModel.NgModelController#custom-control-example
 * custom control example} that uses `ngModelController` to bind to `contenteditable` elements.
 *
 * @example
 * ### Custom Control Example
 * This example shows how to use `NgModelController` with a custom control to achieve
 * data-binding. Notice how different directives (`contenteditable`, `ng-model`, and `required`)
 * collaborate together to achieve the desired result.
 *
 * `contenteditable` is an HTML5 attribute, which tells the browser to let the element
 * contents be edited in place by the user.
 *
 * We are using the {@link ng.service:$sce $sce} service here and include the {@link ngSanitize $sanitize}
 * module to automatically remove "bad" content like inline event listener (e.g. `<span onclick="...">`).
 * However, as we are using `$sce` the model can still decide to provide unsafe content if it marks
 * that content using the `$sce` service.
 *
 * <example name="NgModelController" module="customControl" deps="angular-sanitize.js">
    <file name="style.css">
      [contenteditable] {
        border: 1px solid black;
        background-color: white;
        min-height: 20px;
      }

      .ng-invalid {
        border: 1px solid red;
      }

    </file>
    <file name="script.js">
      angular.module('customControl', ['ngSanitize']).
        directive('contenteditable', ['$sce', function($sce) {
          return {
            restrict: 'A', // only activate on element attribute
            require: '?ngModel', // get a hold of NgModelController
            link: function(scope, element, attrs, ngModel) {
              if (!ngModel) return; // do nothing if no ng-model

              // Specify how UI should be updated
              ngModel.$render = function() {
                element.html($sce.getTrustedHtml(ngModel.$viewValue || ''));
              };

              // Listen for change events to enable binding
              element.on('blur keyup change', function() {
                scope.$evalAsync(read);
              });
              read(); // initialize

              // Write data to the model
              function read() {
                var html = element.html();
                // When we clear the content editable the browser leaves a <br> behind
                // If strip-br attribute is provided then we strip this out
                if ( attrs.stripBr && html == '<br>' ) {
                  html = '';
                }
                ngModel.$setViewValue(html);
              }
            }
          };
        }]);
    </file>
    <file name="index.html">
      <form name="myForm">
       <div contenteditable
            name="myWidget" ng-model="userContent"
            strip-br="true"
            required>Change me!</div>
        <span ng-show="myForm.myWidget.$error.required">Required!</span>
       <hr>
       <textarea ng-model="userContent" aria-label="Dynamic textarea"></textarea>
      </form>
    </file>
    <file name="protractor.js" type="protractor">
    it('should data-bind and become invalid', function() {
      if (browser.params.browser == 'safari' || browser.params.browser == 'firefox') {
        // SafariDriver can't handle contenteditable
        // and Firefox driver can't clear contenteditables very well
        return;
      }
      var contentEditable = element(by.css('[contenteditable]'));
      var content = 'Change me!';

      expect(contentEditable.getText()).toEqual(content);

      contentEditable.clear();
      contentEditable.sendKeys(protractor.Key.BACK_SPACE);
      expect(contentEditable.getText()).toEqual('');
      expect(contentEditable.getAttribute('class')).toMatch(/ng-invalid-required/);
    });
    </file>
 * </example>
 *
 *
 */
var NgModelController = ['$scope', '$exceptionHandler', '$attrs', '$element', '$parse', '$animate', '$timeout', '$rootScope', '$q', '$interpolate',
    function($scope, $exceptionHandler, $attr, $element, $parse, $animate, $timeout, $rootScope, $q, $interpolate) {
  this.$viewValue = Number.NaN;
  this.$modelValue = Number.NaN;
  this.$$rawModelValue = undefined; // stores the parsed modelValue / model set from scope regardless of validity.
  this.$validators = {};
  this.$asyncValidators = {};
  this.$parsers = [];
  this.$formatters = [];
  this.$viewChangeListeners = [];
  this.$untouched = true;
  this.$touched = false;
  this.$pristine = true;
  this.$dirty = false;
  this.$valid = true;
  this.$invalid = false;
  this.$error = {}; // keep invalid keys here
  this.$$success = {}; // keep valid keys here
  this.$pending = undefined; // keep pending keys here
  this.$name = $interpolate($attr.name || '', false)($scope);
  this.$$parentForm = nullFormCtrl;

  var parsedNgModel = $parse($attr.ngModel),
      parsedNgModelAssign = parsedNgModel.assign,
      ngModelGet = parsedNgModel,
      ngModelSet = parsedNgModelAssign,
      pendingDebounce = null,
      parserValid,
      ctrl = this;

  this.$$setOptions = function(options) {
    ctrl.$options = options;
    if (options && options.getterSetter) {
      var invokeModelGetter = $parse($attr.ngModel + '()'),
          invokeModelSetter = $parse($attr.ngModel + '($$$p)');

      ngModelGet = function($scope) {
        var modelValue = parsedNgModel($scope);
        if (isFunction(modelValue)) {
          modelValue = invokeModelGetter($scope);
        }
        return modelValue;
      };
      ngModelSet = function($scope, newValue) {
        if (isFunction(parsedNgModel($scope))) {
          invokeModelSetter($scope, {$$$p: newValue});
        } else {
          parsedNgModelAssign($scope, newValue);
        }
      };
    } else if (!parsedNgModel.assign) {
      throw ngModelMinErr('nonassign', "Expression '{0}' is non-assignable. Element: {1}",
          $attr.ngModel, startingTag($element));
    }
  };

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$render
   *
   * @description
   * Called when the view needs to be updated. It is expected that the user of the ng-model
   * directive will implement this method.
   *
   * The `$render()` method is invoked in the following situations:
   *
   * * `$rollbackViewValue()` is called.  If we are rolling back the view value to the last
   *   committed value then `$render()` is called to update the input control.
   * * The value referenced by `ng-model` is changed programmatically and both the `$modelValue` and
   *   the `$viewValue` are different from last time.
   *
   * Since `ng-model` does not do a deep watch, `$render()` is only invoked if the values of
   * `$modelValue` and `$viewValue` are actually different from their previous values. If `$modelValue`
   * or `$viewValue` are objects (rather than a string or number) then `$render()` will not be
   * invoked if you only change a property on the objects.
   */
  this.$render = noop;

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$isEmpty
   *
   * @description
   * This is called when we need to determine if the value of an input is empty.
   *
   * For instance, the required directive does this to work out if the input has data or not.
   *
   * The default `$isEmpty` function checks whether the value is `undefined`, `''`, `null` or `NaN`.
   *
   * You can override this for input directives whose concept of being empty is different from the
   * default. The `checkboxInputType` directive does this because in its case a value of `false`
   * implies empty.
   *
   * @param {*} value The value of the input to check for emptiness.
   * @returns {boolean} True if `value` is "empty".
   */
  this.$isEmpty = function(value) {
    return isUndefined(value) || value === '' || value === null || value !== value;
  };

  this.$$updateEmptyClasses = function(value) {
    if (ctrl.$isEmpty(value)) {
      $animate.removeClass($element, NOT_EMPTY_CLASS);
      $animate.addClass($element, EMPTY_CLASS);
    } else {
      $animate.removeClass($element, EMPTY_CLASS);
      $animate.addClass($element, NOT_EMPTY_CLASS);
    }
  };


  var currentValidationRunId = 0;

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setValidity
   *
   * @description
   * Change the validity state, and notify the form.
   *
   * This method can be called within $parsers/$formatters or a custom validation implementation.
   * However, in most cases it should be sufficient to use the `ngModel.$validators` and
   * `ngModel.$asyncValidators` collections which will call `$setValidity` automatically.
   *
   * @param {string} validationErrorKey Name of the validator. The `validationErrorKey` will be assigned
   *        to either `$error[validationErrorKey]` or `$pending[validationErrorKey]`
   *        (for unfulfilled `$asyncValidators`), so that it is available for data-binding.
   *        The `validationErrorKey` should be in camelCase and will get converted into dash-case
   *        for class name. Example: `myError` will result in `ng-valid-my-error` and `ng-invalid-my-error`
   *        class and can be bound to as  `{{someForm.someControl.$error.myError}}` .
   * @param {boolean} isValid Whether the current state is valid (true), invalid (false), pending (undefined),
   *                          or skipped (null). Pending is used for unfulfilled `$asyncValidators`.
   *                          Skipped is used by Angular when validators do not run because of parse errors and
   *                          when `$asyncValidators` do not run because any of the `$validators` failed.
   */
  addSetValidityMethod({
    ctrl: this,
    $element: $element,
    set: function(object, property) {
      object[property] = true;
    },
    unset: function(object, property) {
      delete object[property];
    },
    $animate: $animate
  });

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setPristine
   *
   * @description
   * Sets the control to its pristine state.
   *
   * This method can be called to remove the `ng-dirty` class and set the control to its pristine
   * state (`ng-pristine` class). A model is considered to be pristine when the control
   * has not been changed from when first compiled.
   */
  this.$setPristine = function() {
    ctrl.$dirty = false;
    ctrl.$pristine = true;
    $animate.removeClass($element, DIRTY_CLASS);
    $animate.addClass($element, PRISTINE_CLASS);
  };

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setDirty
   *
   * @description
   * Sets the control to its dirty state.
   *
   * This method can be called to remove the `ng-pristine` class and set the control to its dirty
   * state (`ng-dirty` class). A model is considered to be dirty when the control has been changed
   * from when first compiled.
   */
  this.$setDirty = function() {
    ctrl.$dirty = true;
    ctrl.$pristine = false;
    $animate.removeClass($element, PRISTINE_CLASS);
    $animate.addClass($element, DIRTY_CLASS);
    ctrl.$$parentForm.$setDirty();
  };

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setUntouched
   *
   * @description
   * Sets the control to its untouched state.
   *
   * This method can be called to remove the `ng-touched` class and set the control to its
   * untouched state (`ng-untouched` class). Upon compilation, a model is set as untouched
   * by default, however this function can be used to restore that state if the model has
   * already been touched by the user.
   */
  this.$setUntouched = function() {
    ctrl.$touched = false;
    ctrl.$untouched = true;
    $animate.setClass($element, UNTOUCHED_CLASS, TOUCHED_CLASS);
  };

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setTouched
   *
   * @description
   * Sets the control to its touched state.
   *
   * This method can be called to remove the `ng-untouched` class and set the control to its
   * touched state (`ng-touched` class). A model is considered to be touched when the user has
   * first focused the control element and then shifted focus away from the control (blur event).
   */
  this.$setTouched = function() {
    ctrl.$touched = true;
    ctrl.$untouched = false;
    $animate.setClass($element, TOUCHED_CLASS, UNTOUCHED_CLASS);
  };

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$rollbackViewValue
   *
   * @description
   * Cancel an update and reset the input element's value to prevent an update to the `$modelValue`,
   * which may be caused by a pending debounced event or because the input is waiting for a some
   * future event.
   *
   * If you have an input that uses `ng-model-options` to set up debounced updates or updates that
   * depend on special events such as blur, you can have a situation where there is a period when
   * the `$viewValue` is out of sync with the ngModel's `$modelValue`.
   *
   * In this case, you can use `$rollbackViewValue()` to manually cancel the debounced / future update
   * and reset the input to the last committed view value.
   *
   * It is also possible that you run into difficulties if you try to update the ngModel's `$modelValue`
   * programmatically before these debounced/future events have resolved/occurred, because Angular's
   * dirty checking mechanism is not able to tell whether the model has actually changed or not.
   *
   * The `$rollbackViewValue()` method should be called before programmatically changing the model of an
   * input which may have such events pending. This is important in order to make sure that the
   * input field will be updated with the new model value and any pending operations are cancelled.
   *
   * <example name="ng-model-cancel-update" module="cancel-update-example">
   *   <file name="app.js">
   *     angular.module('cancel-update-example', [])
   *
   *     .controller('CancelUpdateController', ['$scope', function($scope) {
   *       $scope.model = {};
   *
   *       $scope.setEmpty = function(e, value, rollback) {
   *         if (e.keyCode == 27) {
   *           e.preventDefault();
   *           if (rollback) {
   *             $scope.myForm[value].$rollbackViewValue();
   *           }
   *           $scope.model[value] = '';
   *         }
   *       };
   *     }]);
   *   </file>
   *   <file name="index.html">
   *     <div ng-controller="CancelUpdateController">
   *        <p>Both of these inputs are only updated if they are blurred. Hitting escape should
   *        empty them. Follow these steps and observe the difference:</p>
   *       <ol>
   *         <li>Type something in the input. You will see that the model is not yet updated</li>
   *         <li>Press the Escape key.
   *           <ol>
   *             <li> In the first example, nothing happens, because the model is already '', and no
   *             update is detected. If you blur the input, the model will be set to the current view.
   *             </li>
   *             <li> In the second example, the pending update is cancelled, and the input is set back
   *             to the last committed view value (''). Blurring the input does nothing.
   *             </li>
   *           </ol>
   *         </li>
   *       </ol>
   *
   *       <form name="myForm" ng-model-options="{ updateOn: 'blur' }">
   *         <div>
   *        <p id="inputDescription1">Without $rollbackViewValue():</p>
   *         <input name="value1" aria-describedby="inputDescription1" ng-model="model.value1"
   *                ng-keydown="setEmpty($event, 'value1')">
   *         value1: "{{ model.value1 }}"
   *         </div>
   *
   *         <div>
   *        <p id="inputDescription2">With $rollbackViewValue():</p>
   *         <input name="value2" aria-describedby="inputDescription2" ng-model="model.value2"
   *                ng-keydown="setEmpty($event, 'value2', true)">
   *         value2: "{{ model.value2 }}"
   *         </div>
   *       </form>
   *     </div>
   *   </file>
       <file name="style.css">
          div {
            display: table-cell;
          }
          div:nth-child(1) {
            padding-right: 30px;
          }

        </file>
   * </example>
   */
  this.$rollbackViewValue = function() {
    $timeout.cancel(pendingDebounce);
    ctrl.$viewValue = ctrl.$$lastCommittedViewValue;
    ctrl.$render();
  };

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$validate
   *
   * @description
   * Runs each of the registered validators (first synchronous validators and then
   * asynchronous validators).
   * If the validity changes to invalid, the model will be set to `undefined`,
   * unless {@link ngModelOptions `ngModelOptions.allowInvalid`} is `true`.
   * If the validity changes to valid, it will set the model to the last available valid
   * `$modelValue`, i.e. either the last parsed value or the last value set from the scope.
   */
  this.$validate = function() {
    // ignore $validate before model is initialized
    if (isNumber(ctrl.$modelValue) && isNaN(ctrl.$modelValue)) {
      return;
    }

    var viewValue = ctrl.$$lastCommittedViewValue;
    // Note: we use the $$rawModelValue as $modelValue might have been
    // set to undefined during a view -> model update that found validation
    // errors. We can't parse the view here, since that could change
    // the model although neither viewValue nor the model on the scope changed
    var modelValue = ctrl.$$rawModelValue;

    var prevValid = ctrl.$valid;
    var prevModelValue = ctrl.$modelValue;

    var allowInvalid = ctrl.$options && ctrl.$options.allowInvalid;

    ctrl.$$runValidators(modelValue, viewValue, function(allValid) {
      // If there was no change in validity, don't update the model
      // This prevents changing an invalid modelValue to undefined
      if (!allowInvalid && prevValid !== allValid) {
        // Note: Don't check ctrl.$valid here, as we could have
        // external validators (e.g. calculated on the server),
        // that just call $setValidity and need the model value
        // to calculate their validity.
        ctrl.$modelValue = allValid ? modelValue : undefined;

        if (ctrl.$modelValue !== prevModelValue) {
          ctrl.$$writeModelToScope();
        }
      }
    });

  };

  this.$$runValidators = function(modelValue, viewValue, doneCallback) {
    currentValidationRunId++;
    var localValidationRunId = currentValidationRunId;

    // check parser error
    if (!processParseErrors()) {
      validationDone(false);
      return;
    }
    if (!processSyncValidators()) {
      validationDone(false);
      return;
    }
    processAsyncValidators();

    function processParseErrors() {
      var errorKey = ctrl.$$parserName || 'parse';
      if (isUndefined(parserValid)) {
        setValidity(errorKey, null);
      } else {
        if (!parserValid) {
          forEach(ctrl.$validators, function(v, name) {
            setValidity(name, null);
          });
          forEach(ctrl.$asyncValidators, function(v, name) {
            setValidity(name, null);
          });
        }
        // Set the parse error last, to prevent unsetting it, should a $validators key == parserName
        setValidity(errorKey, parserValid);
        return parserValid;
      }
      return true;
    }

    function processSyncValidators() {
      var syncValidatorsValid = true;
      forEach(ctrl.$validators, function(validator, name) {
        var result = validator(modelValue, viewValue);
        syncValidatorsValid = syncValidatorsValid && result;
        setValidity(name, result);
      });
      if (!syncValidatorsValid) {
        forEach(ctrl.$asyncValidators, function(v, name) {
          setValidity(name, null);
        });
        return false;
      }
      return true;
    }

    function processAsyncValidators() {
      var validatorPromises = [];
      var allValid = true;
      forEach(ctrl.$asyncValidators, function(validator, name) {
        var promise = validator(modelValue, viewValue);
        if (!isPromiseLike(promise)) {
          throw ngModelMinErr('nopromise',
            "Expected asynchronous validator to return a promise but got '{0}' instead.", promise);
        }
        setValidity(name, undefined);
        validatorPromises.push(promise.then(function() {
          setValidity(name, true);
        }, function() {
          allValid = false;
          setValidity(name, false);
        }));
      });
      if (!validatorPromises.length) {
        validationDone(true);
      } else {
        $q.all(validatorPromises).then(function() {
          validationDone(allValid);
        }, noop);
      }
    }

    function setValidity(name, isValid) {
      if (localValidationRunId === currentValidationRunId) {
        ctrl.$setValidity(name, isValid);
      }
    }

    function validationDone(allValid) {
      if (localValidationRunId === currentValidationRunId) {

        doneCallback(allValid);
      }
    }
  };

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$commitViewValue
   *
   * @description
   * Commit a pending update to the `$modelValue`.
   *
   * Updates may be pending by a debounced event or because the input is waiting for a some future
   * event defined in `ng-model-options`. this method is rarely needed as `NgModelController`
   * usually handles calling this in response to input events.
   */
  this.$commitViewValue = function() {
    var viewValue = ctrl.$viewValue;

    $timeout.cancel(pendingDebounce);

    // If the view value has not changed then we should just exit, except in the case where there is
    // a native validator on the element. In this case the validation state may have changed even though
    // the viewValue has stayed empty.
    if (ctrl.$$lastCommittedViewValue === viewValue && (viewValue !== '' || !ctrl.$$hasNativeValidators)) {
      return;
    }
    ctrl.$$updateEmptyClasses(viewValue);
    ctrl.$$lastCommittedViewValue = viewValue;

    // change to dirty
    if (ctrl.$pristine) {
      this.$setDirty();
    }
    this.$$parseAndValidate();
  };

  this.$$parseAndValidate = function() {
    var viewValue = ctrl.$$lastCommittedViewValue;
    var modelValue = viewValue;
    parserValid = isUndefined(modelValue) ? undefined : true;

    if (parserValid) {
      for (var i = 0; i < ctrl.$parsers.length; i++) {
        modelValue = ctrl.$parsers[i](modelValue);
        if (isUndefined(modelValue)) {
          parserValid = false;
          break;
        }
      }
    }
    if (isNumber(ctrl.$modelValue) && isNaN(ctrl.$modelValue)) {
      // ctrl.$modelValue has not been touched yet...
      ctrl.$modelValue = ngModelGet($scope);
    }
    var prevModelValue = ctrl.$modelValue;
    var allowInvalid = ctrl.$options && ctrl.$options.allowInvalid;
    ctrl.$$rawModelValue = modelValue;

    if (allowInvalid) {
      ctrl.$modelValue = modelValue;
      writeToModelIfNeeded();
    }

    // Pass the $$lastCommittedViewValue here, because the cached viewValue might be out of date.
    // This can happen if e.g. $setViewValue is called from inside a parser
    ctrl.$$runValidators(modelValue, ctrl.$$lastCommittedViewValue, function(allValid) {
      if (!allowInvalid) {
        // Note: Don't check ctrl.$valid here, as we could have
        // external validators (e.g. calculated on the server),
        // that just call $setValidity and need the model value
        // to calculate their validity.
        ctrl.$modelValue = allValid ? modelValue : undefined;
        writeToModelIfNeeded();
      }
    });

    function writeToModelIfNeeded() {
      if (ctrl.$modelValue !== prevModelValue) {
        ctrl.$$writeModelToScope();
      }
    }
  };

  this.$$writeModelToScope = function() {
    ngModelSet($scope, ctrl.$modelValue);
    forEach(ctrl.$viewChangeListeners, function(listener) {
      try {
        listener();
      } catch (e) {
        $exceptionHandler(e);
      }
    });
  };

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setViewValue
   *
   * @description
   * Update the view value.
   *
   * This method should be called when a control wants to change the view value; typically,
   * this is done from within a DOM event handler. For example, the {@link ng.directive:input input}
   * directive calls it when the value of the input changes and {@link ng.directive:select select}
   * calls it when an option is selected.
   *
   * When `$setViewValue` is called, the new `value` will be staged for committing through the `$parsers`
   * and `$validators` pipelines. If there are no special {@link ngModelOptions} specified then the staged
   * value sent directly for processing, finally to be applied to `$modelValue` and then the
   * **expression** specified in the `ng-model` attribute. Lastly, all the registered change listeners,
   * in the `$viewChangeListeners` list, are called.
   *
   * In case the {@link ng.directive:ngModelOptions ngModelOptions} directive is used with `updateOn`
   * and the `default` trigger is not listed, all those actions will remain pending until one of the
   * `updateOn` events is triggered on the DOM element.
   * All these actions will be debounced if the {@link ng.directive:ngModelOptions ngModelOptions}
   * directive is used with a custom debounce for this particular event.
   * Note that a `$digest` is only triggered once the `updateOn` events are fired, or if `debounce`
   * is specified, once the timer runs out.
   *
   * When used with standard inputs, the view value will always be a string (which is in some cases
   * parsed into another type, such as a `Date` object for `input[date]`.)
   * However, custom controls might also pass objects to this method. In this case, we should make
   * a copy of the object before passing it to `$setViewValue`. This is because `ngModel` does not
   * perform a deep watch of objects, it only looks for a change of identity. If you only change
   * the property of the object then ngModel will not realize that the object has changed and
   * will not invoke the `$parsers` and `$validators` pipelines. For this reason, you should
   * not change properties of the copy once it has been passed to `$setViewValue`.
   * Otherwise you may cause the model value on the scope to change incorrectly.
   *
   * <div class="alert alert-info">
   * In any case, the value passed to the method should always reflect the current value
   * of the control. For example, if you are calling `$setViewValue` for an input element,
   * you should pass the input DOM value. Otherwise, the control and the scope model become
   * out of sync. It's also important to note that `$setViewValue` does not call `$render` or change
   * the control's DOM value in any way. If we want to change the control's DOM value
   * programmatically, we should update the `ngModel` scope expression. Its new value will be
   * picked up by the model controller, which will run it through the `$formatters`, `$render` it
   * to update the DOM, and finally call `$validate` on it.
   * </div>
   *
   * @param {*} value value from the view.
   * @param {string} trigger Event that triggered the update.
   */
  this.$setViewValue = function(value, trigger) {
    ctrl.$viewValue = value;
    if (!ctrl.$options || ctrl.$options.updateOnDefault) {
      ctrl.$$debounceViewValueCommit(trigger);
    }
  };

  this.$$debounceViewValueCommit = function(trigger) {
    var debounceDelay = 0,
        options = ctrl.$options,
        debounce;

    if (options && isDefined(options.debounce)) {
      debounce = options.debounce;
      if (isNumber(debounce)) {
        debounceDelay = debounce;
      } else if (isNumber(debounce[trigger])) {
        debounceDelay = debounce[trigger];
      } else if (isNumber(debounce['default'])) {
        debounceDelay = debounce['default'];
      }
    }

    $timeout.cancel(pendingDebounce);
    if (debounceDelay) {
      pendingDebounce = $timeout(function() {
        ctrl.$commitViewValue();
      }, debounceDelay);
    } else if ($rootScope.$$phase) {
      ctrl.$commitViewValue();
    } else {
      $scope.$apply(function() {
        ctrl.$commitViewValue();
      });
    }
  };

  // model -> value
  // Note: we cannot use a normal scope.$watch as we want to detect the following:
  // 1. scope value is 'a'
  // 2. user enters 'b'
  // 3. ng-change kicks in and reverts scope value to 'a'
  //    -> scope value did not change since the last digest as
  //       ng-change executes in apply phase
  // 4. view should be changed back to 'a'
  $scope.$watch(function ngModelWatch() {
    var modelValue = ngModelGet($scope);

    // if scope model value and ngModel value are out of sync
    // TODO(perf): why not move this to the action fn?
    if (modelValue !== ctrl.$modelValue &&
       // checks for NaN is needed to allow setting the model to NaN when there's an asyncValidator
       (ctrl.$modelValue === ctrl.$modelValue || modelValue === modelValue)
    ) {
      ctrl.$modelValue = ctrl.$$rawModelValue = modelValue;
      parserValid = undefined;

      var formatters = ctrl.$formatters,
          idx = formatters.length;

      var viewValue = modelValue;
      while (idx--) {
        viewValue = formatters[idx](viewValue);
      }
      if (ctrl.$viewValue !== viewValue) {
        ctrl.$$updateEmptyClasses(viewValue);
        ctrl.$viewValue = ctrl.$$lastCommittedViewValue = viewValue;
        ctrl.$render();

        ctrl.$$runValidators(modelValue, viewValue, noop);
      }
    }

    return modelValue;
  });
}];


/**
 * @ngdoc directive
 * @name ngModel
 *
 * @element input
 * @priority 1
 *
 * @description
 * The `ngModel` directive binds an `input`,`select`, `textarea` (or custom form control) to a
 * property on the scope using {@link ngModel.NgModelController NgModelController},
 * which is created and exposed by this directive.
 *
 * `ngModel` is responsible for:
 *
 * - Binding the view into the model, which other directives such as `input`, `textarea` or `select`
 *   require.
 * - Providing validation behavior (i.e. required, number, email, url).
 * - Keeping the state of the control (valid/invalid, dirty/pristine, touched/untouched, validation errors).
 * - Setting related css classes on the element (`ng-valid`, `ng-invalid`, `ng-dirty`, `ng-pristine`, `ng-touched`,
 *   `ng-untouched`, `ng-empty`, `ng-not-empty`) including animations.
 * - Registering the control with its parent {@link ng.directive:form form}.
 *
 * Note: `ngModel` will try to bind to the property given by evaluating the expression on the
 * current scope. If the property doesn't already exist on this scope, it will be created
 * implicitly and added to the scope.
 *
 * For best practices on using `ngModel`, see:
 *
 *  - [Understanding Scopes](https://github.com/angular/angular.js/wiki/Understanding-Scopes)
 *
 * For basic examples, how to use `ngModel`, see:
 *
 *  - {@link ng.directive:input input}
 *    - {@link input[text] text}
 *    - {@link input[checkbox] checkbox}
 *    - {@link input[radio] radio}
 *    - {@link input[number] number}
 *    - {@link input[email] email}
 *    - {@link input[url] url}
 *    - {@link input[date] date}
 *    - {@link input[datetime-local] datetime-local}
 *    - {@link input[time] time}
 *    - {@link input[month] month}
 *    - {@link input[week] week}
 *  - {@link ng.directive:select select}
 *  - {@link ng.directive:textarea textarea}
 *
 * # Complex Models (objects or collections)
 *
 * By default, `ngModel` watches the model by reference, not value. This is important to know when
 * binding inputs to models that are objects (e.g. `Date`) or collections (e.g. arrays). If only properties of the
 * object or collection change, `ngModel` will not be notified and so the input will not be  re-rendered.
 *
 * The model must be assigned an entirely new object or collection before a re-rendering will occur.
 *
 * Some directives have options that will cause them to use a custom `$watchCollection` on the model expression
 * - for example, `ngOptions` will do so when a `track by` clause is included in the comprehension expression or
 * if the select is given the `multiple` attribute.
 *
 * The `$watchCollection()` method only does a shallow comparison, meaning that changing properties deeper than the
 * first level of the object (or only changing the properties of an item in the collection if it's an array) will still
 * not trigger a re-rendering of the model.
 *
 * # CSS classes
 * The following CSS classes are added and removed on the associated input/select/textarea element
 * depending on the validity of the model.
 *
 *  - `ng-valid`: the model is valid
 *  - `ng-invalid`: the model is invalid
 *  - `ng-valid-[key]`: for each valid key added by `$setValidity`
 *  - `ng-invalid-[key]`: for each invalid key added by `$setValidity`
 *  - `ng-pristine`: the control hasn't been interacted with yet
 *  - `ng-dirty`: the control has been interacted with
 *  - `ng-touched`: the control has been blurred
 *  - `ng-untouched`: the control hasn't been blurred
 *  - `ng-pending`: any `$asyncValidators` are unfulfilled
 *  - `ng-empty`: the view does not contain a value or the value is deemed "empty", as defined
 *     by the {@link ngModel.NgModelController#$isEmpty} method
 *  - `ng-not-empty`: the view contains a non-empty value
 *
 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
 *
 * ## Animation Hooks
 *
 * Animations within models are triggered when any of the associated CSS classes are added and removed
 * on the input element which is attached to the model. These classes include: `.ng-pristine`, `.ng-dirty`,
 * `.ng-invalid` and `.ng-valid` as well as any other validations that are performed on the model itself.
 * The animations that are triggered within ngModel are similar to how they work in ngClass and
 * animations can be hooked into using CSS transitions, keyframes as well as JS animations.
 *
 * The following example shows a simple way to utilize CSS transitions to style an input element
 * that has been rendered as invalid after it has been validated:
 *
 * <pre>
 * //be sure to include ngAnimate as a module to hook into more
 * //advanced animations
 * .my-input {
 *   transition:0.5s linear all;
 *   background: white;
 * }
 * .my-input.ng-invalid {
 *   background: red;
 *   color:white;
 * }
 * </pre>
 *
 * @example
 * <example deps="angular-animate.js" animations="true" fixBase="true" module="inputExample">
     <file name="index.html">
       <script>
        angular.module('inputExample', [])
          .controller('ExampleController', ['$scope', function($scope) {
            $scope.val = '1';
          }]);
       </script>
       <style>
         .my-input {
           transition:all linear 0.5s;
           background: transparent;
         }
         .my-input.ng-invalid {
           color:white;
           background: red;
         }
       </style>
       <p id="inputDescription">
        Update input to see transitions when valid/invalid.
        Integer is a valid value.
       </p>
       <form name="testForm" ng-controller="ExampleController">
         <input ng-model="val" ng-pattern="/^\d+$/" name="anim" class="my-input"
                aria-describedby="inputDescription" />
       </form>
     </file>
 * </example>
 *
 * ## Binding to a getter/setter
 *
 * Sometimes it's helpful to bind `ngModel` to a getter/setter function.  A getter/setter is a
 * function that returns a representation of the model when called with zero arguments, and sets
 * the internal state of a model when called with an argument. It's sometimes useful to use this
 * for models that have an internal representation that's different from what the model exposes
 * to the view.
 *
 * <div class="alert alert-success">
 * **Best Practice:** It's best to keep getters fast because Angular is likely to call them more
 * frequently than other parts of your code.
 * </div>
 *
 * You use this behavior by adding `ng-model-options="{ getterSetter: true }"` to an element that
 * has `ng-model` attached to it. You can also add `ng-model-options="{ getterSetter: true }"` to
 * a `<form>`, which will enable this behavior for all `<input>`s within it. See
 * {@link ng.directive:ngModelOptions `ngModelOptions`} for more.
 *
 * The following example shows how to use `ngModel` with a getter/setter:
 *
 * @example
 * <example name="ngModel-getter-setter" module="getterSetterExample">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <form name="userForm">
           <label>Name:
             <input type="text" name="userName"
                    ng-model="user.name"
                    ng-model-options="{ getterSetter: true }" />
           </label>
         </form>
         <pre>user.name = <span ng-bind="user.name()"></span></pre>
       </div>
     </file>
     <file name="app.js">
       angular.module('getterSetterExample', [])
         .controller('ExampleController', ['$scope', function($scope) {
           var _name = 'Brian';
           $scope.user = {
             name: function(newName) {
              // Note that newName can be undefined for two reasons:
              // 1. Because it is called as a getter and thus called with no arguments
              // 2. Because the property should actually be set to undefined. This happens e.g. if the
              //    input is invalid
              return arguments.length ? (_name = newName) : _name;
             }
           };
         }]);
     </file>
 * </example>
 */
var ngModelDirective = ['$rootScope', function($rootScope) {
  return {
    restrict: 'A',
    require: ['ngModel', '^?form', '^?ngModelOptions'],
    controller: NgModelController,
    // Prelink needs to run before any input directive
    // so that we can set the NgModelOptions in NgModelController
    // before anyone else uses it.
    priority: 1,
    compile: function ngModelCompile(element) {
      // Setup initial state of the control
      element.addClass(PRISTINE_CLASS).addClass(UNTOUCHED_CLASS).addClass(VALID_CLASS);

      return {
        pre: function ngModelPreLink(scope, element, attr, ctrls) {
          var modelCtrl = ctrls[0],
              formCtrl = ctrls[1] || modelCtrl.$$parentForm;

          modelCtrl.$$setOptions(ctrls[2] && ctrls[2].$options);

          // notify others, especially parent forms
          formCtrl.$addControl(modelCtrl);

          attr.$observe('name', function(newValue) {
            if (modelCtrl.$name !== newValue) {
              modelCtrl.$$parentForm.$$renameControl(modelCtrl, newValue);
            }
          });

          scope.$on('$destroy', function() {
            modelCtrl.$$parentForm.$removeControl(modelCtrl);
          });
        },
        post: function ngModelPostLink(scope, element, attr, ctrls) {
          var modelCtrl = ctrls[0];
          if (modelCtrl.$options && modelCtrl.$options.updateOn) {
            element.on(modelCtrl.$options.updateOn, function(ev) {
              modelCtrl.$$debounceViewValueCommit(ev && ev.type);
            });
          }

          element.on('blur', function() {
            if (modelCtrl.$touched) return;

            if ($rootScope.$$phase) {
              scope.$evalAsync(modelCtrl.$setTouched);
            } else {
              scope.$apply(modelCtrl.$setTouched);
            }
          });
        }
      };
    }
  };
}];

var DEFAULT_REGEXP = /(\s+|^)default(\s+|$)/;

/**
 * @ngdoc directive
 * @name ngModelOptions
 *
 * @description
 * Allows tuning how model updates are done. Using `ngModelOptions` you can specify a custom list of
 * events that will trigger a model update and/or a debouncing delay so that the actual update only
 * takes place when a timer expires; this timer will be reset after another change takes place.
 *
 * Given the nature of `ngModelOptions`, the value displayed inside input fields in the view might
 * be different from the value in the actual model. This means that if you update the model you
 * should also invoke {@link ngModel.NgModelController `$rollbackViewValue`} on the relevant input field in
 * order to make sure it is synchronized with the model and that any debounced action is canceled.
 *
 * The easiest way to reference the control's {@link ngModel.NgModelController `$rollbackViewValue`}
 * method is by making sure the input is placed inside a form that has a `name` attribute. This is
 * important because `form` controllers are published to the related scope under the name in their
 * `name` attribute.
 *
 * Any pending changes will take place immediately when an enclosing form is submitted via the
 * `submit` event. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
 * to have access to the updated model.
 *
 * `ngModelOptions` has an effect on the element it's declared on and its descendants.
 *
 * @param {Object} ngModelOptions options to apply to the current model. Valid keys are:
 *   - `updateOn`: string specifying which event should the input be bound to. You can set several
 *     events using an space delimited list. There is a special event called `default` that
 *     matches the default events belonging of the control.
 *   - `debounce`: integer value which contains the debounce model update value in milliseconds. A
 *     value of 0 triggers an immediate update. If an object is supplied instead, you can specify a
 *     custom value for each event. For example:
 *     `ng-model-options="{ updateOn: 'default blur', debounce: { 'default': 500, 'blur': 0 } }"`
 *   - `allowInvalid`: boolean value which indicates that the model can be set with values that did
 *     not validate correctly instead of the default behavior of setting the model to undefined.
 *   - `getterSetter`: boolean value which determines whether or not to treat functions bound to
       `ngModel` as getters/setters.
 *   - `timezone`: Defines the timezone to be used to read/write the `Date` instance in the model for
 *     `<input type="date">`, `<input type="time">`, ... . It understands UTC/GMT and the
 *     continental US time zone abbreviations, but for general use, use a time zone offset, for
 *     example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
 *     If not specified, the timezone of the browser will be used.
 *
 * @example

  The following example shows how to override immediate updates. Changes on the inputs within the
  form will update the model only when the control loses focus (blur event). If `escape` key is
  pressed while the input field is focused, the value is reset to the value in the current model.

  <example name="ngModelOptions-directive-blur" module="optionsExample">
    <file name="index.html">
      <div ng-controller="ExampleController">
        <form name="userForm">
          <label>Name:
            <input type="text" name="userName"
                   ng-model="user.name"
                   ng-model-options="{ updateOn: 'blur' }"
                   ng-keyup="cancel($event)" />
          </label><br />
          <label>Other data:
            <input type="text" ng-model="user.data" />
          </label><br />
        </form>
        <pre>user.name = <span ng-bind="user.name"></span></pre>
        <pre>user.data = <span ng-bind="user.data"></span></pre>
      </div>
    </file>
    <file name="app.js">
      angular.module('optionsExample', [])
        .controller('ExampleController', ['$scope', function($scope) {
          $scope.user = { name: 'John', data: '' };

          $scope.cancel = function(e) {
            if (e.keyCode == 27) {
              $scope.userForm.userName.$rollbackViewValue();
            }
          };
        }]);
    </file>
    <file name="protractor.js" type="protractor">
      var model = element(by.binding('user.name'));
      var input = element(by.model('user.name'));
      var other = element(by.model('user.data'));

      it('should allow custom events', function() {
        input.sendKeys(' Doe');
        input.click();
        expect(model.getText()).toEqual('John');
        other.click();
        expect(model.getText()).toEqual('John Doe');
      });

      it('should $rollbackViewValue when model changes', function() {
        input.sendKeys(' Doe');
        expect(input.getAttribute('value')).toEqual('John Doe');
        input.sendKeys(protractor.Key.ESCAPE);
        expect(input.getAttribute('value')).toEqual('John');
        other.click();
        expect(model.getText()).toEqual('John');
      });
    </file>
  </example>

  This one shows how to debounce model changes. Model will be updated only 1 sec after last change.
  If the `Clear` button is pressed, any debounced action is canceled and the value becomes empty.

  <example name="ngModelOptions-directive-debounce" module="optionsExample">
    <file name="index.html">
      <div ng-controller="ExampleController">
        <form name="userForm">
          <label>Name:
            <input type="text" name="userName"
                   ng-model="user.name"
                   ng-model-options="{ debounce: 1000 }" />
          </label>
          <button ng-click="userForm.userName.$rollbackViewValue(); user.name=''">Clear</button>
          <br />
        </form>
        <pre>user.name = <span ng-bind="user.name"></span></pre>
      </div>
    </file>
    <file name="app.js">
      angular.module('optionsExample', [])
        .controller('ExampleController', ['$scope', function($scope) {
          $scope.user = { name: 'Igor' };
        }]);
    </file>
  </example>

  This one shows how to bind to getter/setters:

  <example name="ngModelOptions-directive-getter-setter" module="getterSetterExample">
    <file name="index.html">
      <div ng-controller="ExampleController">
        <form name="userForm">
          <label>Name:
            <input type="text" name="userName"
                   ng-model="user.name"
                   ng-model-options="{ getterSetter: true }" />
          </label>
        </form>
        <pre>user.name = <span ng-bind="user.name()"></span></pre>
      </div>
    </file>
    <file name="app.js">
      angular.module('getterSetterExample', [])
        .controller('ExampleController', ['$scope', function($scope) {
          var _name = 'Brian';
          $scope.user = {
            name: function(newName) {
              // Note that newName can be undefined for two reasons:
              // 1. Because it is called as a getter and thus called with no arguments
              // 2. Because the property should actually be set to undefined. This happens e.g. if the
              //    input is invalid
              return arguments.length ? (_name = newName) : _name;
            }
          };
        }]);
    </file>
  </example>
 */
var ngModelOptionsDirective = function() {
  return {
    restrict: 'A',
    controller: ['$scope', '$attrs', function($scope, $attrs) {
      var that = this;
      this.$options = copy($scope.$eval($attrs.ngModelOptions));
      // Allow adding/overriding bound events
      if (isDefined(this.$options.updateOn)) {
        this.$options.updateOnDefault = false;
        // extract "default" pseudo-event from list of events that can trigger a model update
        this.$options.updateOn = trim(this.$options.updateOn.replace(DEFAULT_REGEXP, function() {
          that.$options.updateOnDefault = true;
          return ' ';
        }));
      } else {
        this.$options.updateOnDefault = true;
      }
    }]
  };
};



// helper methods
function addSetValidityMethod(context) {
  var ctrl = context.ctrl,
      $element = context.$element,
      classCache = {},
      set = context.set,
      unset = context.unset,
      $animate = context.$animate;

  classCache[INVALID_CLASS] = !(classCache[VALID_CLASS] = $element.hasClass(VALID_CLASS));

  ctrl.$setValidity = setValidity;

  function setValidity(validationErrorKey, state, controller) {
    if (isUndefined(state)) {
      createAndSet('$pending', validationErrorKey, controller);
    } else {
      unsetAndCleanup('$pending', validationErrorKey, controller);
    }
    if (!isBoolean(state)) {
      unset(ctrl.$error, validationErrorKey, controller);
      unset(ctrl.$$success, validationErrorKey, controller);
    } else {
      if (state) {
        unset(ctrl.$error, validationErrorKey, controller);
        set(ctrl.$$success, validationErrorKey, controller);
      } else {
        set(ctrl.$error, validationErrorKey, controller);
        unset(ctrl.$$success, validationErrorKey, controller);
      }
    }
    if (ctrl.$pending) {
      cachedToggleClass(PENDING_CLASS, true);
      ctrl.$valid = ctrl.$invalid = undefined;
      toggleValidationCss('', null);
    } else {
      cachedToggleClass(PENDING_CLASS, false);
      ctrl.$valid = isObjectEmpty(ctrl.$error);
      ctrl.$invalid = !ctrl.$valid;
      toggleValidationCss('', ctrl.$valid);
    }

    // re-read the state as the set/unset methods could have
    // combined state in ctrl.$error[validationError] (used for forms),
    // where setting/unsetting only increments/decrements the value,
    // and does not replace it.
    var combinedState;
    if (ctrl.$pending && ctrl.$pending[validationErrorKey]) {
      combinedState = undefined;
    } else if (ctrl.$error[validationErrorKey]) {
      combinedState = false;
    } else if (ctrl.$$success[validationErrorKey]) {
      combinedState = true;
    } else {
      combinedState = null;
    }

    toggleValidationCss(validationErrorKey, combinedState);
    ctrl.$$parentForm.$setValidity(validationErrorKey, combinedState, ctrl);
  }

  function createAndSet(name, value, controller) {
    if (!ctrl[name]) {
      ctrl[name] = {};
    }
    set(ctrl[name], value, controller);
  }

  function unsetAndCleanup(name, value, controller) {
    if (ctrl[name]) {
      unset(ctrl[name], value, controller);
    }
    if (isObjectEmpty(ctrl[name])) {
      ctrl[name] = undefined;
    }
  }

  function cachedToggleClass(className, switchValue) {
    if (switchValue && !classCache[className]) {
      $animate.addClass($element, className);
      classCache[className] = true;
    } else if (!switchValue && classCache[className]) {
      $animate.removeClass($element, className);
      classCache[className] = false;
    }
  }

  function toggleValidationCss(validationErrorKey, isValid) {
    validationErrorKey = validationErrorKey ? '-' + snake_case(validationErrorKey, '-') : '';

    cachedToggleClass(VALID_CLASS + validationErrorKey, isValid === true);
    cachedToggleClass(INVALID_CLASS + validationErrorKey, isValid === false);
  }
}

function isObjectEmpty(obj) {
  if (obj) {
    for (var prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        return false;
      }
    }
  }
  return true;
}

/**
 * @ngdoc directive
 * @name ngNonBindable
 * @restrict AC
 * @priority 1000
 *
 * @description
 * The `ngNonBindable` directive tells Angular not to compile or bind the contents of the current
 * DOM element. This is useful if the element contains what appears to be Angular directives and
 * bindings but which should be ignored by Angular. This could be the case if you have a site that
 * displays snippets of code, for instance.
 *
 * @element ANY
 *
 * @example
 * In this example there are two locations where a simple interpolation binding (`{{}}`) is present,
 * but the one wrapped in `ngNonBindable` is left alone.
 *
 * @example
    <example>
      <file name="index.html">
        <div>Normal: {{1 + 2}}</div>
        <div ng-non-bindable>Ignored: {{1 + 2}}</div>
      </file>
      <file name="protractor.js" type="protractor">
       it('should check ng-non-bindable', function() {
         expect(element(by.binding('1 + 2')).getText()).toContain('3');
         expect(element.all(by.css('div')).last().getText()).toMatch(/1 \+ 2/);
       });
      </file>
    </example>
 */
var ngNonBindableDirective = ngDirective({ terminal: true, priority: 1000 });

/* global jqLiteRemove */

var ngOptionsMinErr = minErr('ngOptions');

/**
 * @ngdoc directive
 * @name ngOptions
 * @restrict A
 *
 * @description
 *
 * The `ngOptions` attribute can be used to dynamically generate a list of `<option>`
 * elements for the `<select>` element using the array or object obtained by evaluating the
 * `ngOptions` comprehension expression.
 *
 * In many cases, `ngRepeat` can be used on `<option>` elements instead of `ngOptions` to achieve a
 * similar result. However, `ngOptions` provides some benefits such as reducing memory and
 * increasing speed by not creating a new scope for each repeated instance, as well as providing
 * more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
 * comprehension expression. `ngOptions` should be used when the `<select>` model needs to be bound
 *  to a non-string value. This is because an option element can only be bound to string values at
 * present.
 *
 * When an item in the `<select>` menu is selected, the array element or object property
 * represented by the selected option will be bound to the model identified by the `ngModel`
 * directive.
 *
 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
 * option. See example below for demonstration.
 *
 * ## Complex Models (objects or collections)
 *
 * By default, `ngModel` watches the model by reference, not value. This is important to know when
 * binding the select to a model that is an object or a collection.
 *
 * One issue occurs if you want to preselect an option. For example, if you set
 * the model to an object that is equal to an object in your collection, `ngOptions` won't be able to set the selection,
 * because the objects are not identical. So by default, you should always reference the item in your collection
 * for preselections, e.g.: `$scope.selected = $scope.collection[3]`.
 *
 * Another solution is to use a `track by` clause, because then `ngOptions` will track the identity
 * of the item not by reference, but by the result of the `track by` expression. For example, if your
 * collection items have an id property, you would `track by item.id`.
 *
 * A different issue with objects or collections is that ngModel won't detect if an object property or
 * a collection item changes. For that reason, `ngOptions` additionally watches the model using
 * `$watchCollection`, when the expression contains a `track by` clause or the the select has the `multiple` attribute.
 * This allows ngOptions to trigger a re-rendering of the options even if the actual object/collection
 * has not changed identity, but only a property on the object or an item in the collection changes.
 *
 * Note that `$watchCollection` does a shallow comparison of the properties of the object (or the items in the collection
 * if the model is an array). This means that changing a property deeper than the first level inside the
 * object/collection will not trigger a re-rendering.
 *
 * ## `select` **`as`**
 *
 * Using `select` **`as`** will bind the result of the `select` expression to the model, but
 * the value of the `<select>` and `<option>` html elements will be either the index (for array data sources)
 * or property name (for object data sources) of the value within the collection. If a **`track by`** expression
 * is used, the result of that expression will be set as the value of the `option` and `select` elements.
 *
 *
 * ### `select` **`as`** and **`track by`**
 *
 * <div class="alert alert-warning">
 * Be careful when using `select` **`as`** and **`track by`** in the same expression.
 * </div>
 *
 * Given this array of items on the $scope:
 *
 * ```js
 * $scope.items = [{
 *   id: 1,
 *   label: 'aLabel',
 *   subItem: { name: 'aSubItem' }
 * }, {
 *   id: 2,
 *   label: 'bLabel',
 *   subItem: { name: 'bSubItem' }
 * }];
 * ```
 *
 * This will work:
 *
 * ```html
 * <select ng-options="item as item.label for item in items track by item.id" ng-model="selected"></select>
 * ```
 * ```js
 * $scope.selected = $scope.items[0];
 * ```
 *
 * but this will not work:
 *
 * ```html
 * <select ng-options="item.subItem as item.label for item in items track by item.id" ng-model="selected"></select>
 * ```
 * ```js
 * $scope.selected = $scope.items[0].subItem;
 * ```
 *
 * In both examples, the **`track by`** expression is applied successfully to each `item` in the
 * `items` array. Because the selected option has been set programmatically in the controller, the
 * **`track by`** expression is also applied to the `ngModel` value. In the first example, the
 * `ngModel` value is `items[0]` and the **`track by`** expression evaluates to `items[0].id` with
 * no issue. In the second example, the `ngModel` value is `items[0].subItem` and the **`track by`**
 * expression evaluates to `items[0].subItem.id` (which is undefined). As a result, the model value
 * is not matched against any `<option>` and the `<select>` appears as having no selected value.
 *
 *
 * @param {string} ngModel Assignable angular expression to data-bind to.
 * @param {string=} name Property name of the form under which the control is published.
 * @param {string=} required The control is considered valid only if value is entered.
 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
 *    `required` when you want to data-bind to the `required` attribute.
 * @param {comprehension_expression=} ngOptions in one of the following forms:
 *
 *   * for array data sources:
 *     * `label` **`for`** `value` **`in`** `array`
 *     * `select` **`as`** `label` **`for`** `value` **`in`** `array`
 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array`
 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array`
 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
 *     * `label` **`for`** `value` **`in`** `array` | orderBy:`orderexpr` **`track by`** `trackexpr`
 *        (for including a filter with `track by`)
 *   * for object data sources:
 *     * `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
 *     * `select` **`as`** `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
 *     * `label` **`group by`** `group` **`for (`**`key`**`,`** `value`**`) in`** `object`
 *     * `label` **`disable when`** `disable` **`for (`**`key`**`,`** `value`**`) in`** `object`
 *     * `select` **`as`** `label` **`group by`** `group`
 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
 *     * `select` **`as`** `label` **`disable when`** `disable`
 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
 *
 * Where:
 *
 *   * `array` / `object`: an expression which evaluates to an array / object to iterate over.
 *   * `value`: local variable which will refer to each item in the `array` or each property value
 *      of `object` during iteration.
 *   * `key`: local variable which will refer to a property name in `object` during iteration.
 *   * `label`: The result of this expression will be the label for `<option>` element. The
 *     `expression` will most likely refer to the `value` variable (e.g. `value.propertyName`).
 *   * `select`: The result of this expression will be bound to the model of the parent `<select>`
 *      element. If not specified, `select` expression will default to `value`.
 *   * `group`: The result of this expression will be used to group options using the `<optgroup>`
 *      DOM element.
 *   * `disable`: The result of this expression will be used to disable the rendered `<option>`
 *      element. Return `true` to disable.
 *   * `trackexpr`: Used when working with an array of objects. The result of this expression will be
 *      used to identify the objects in the array. The `trackexpr` will most likely refer to the
 *     `value` variable (e.g. `value.propertyName`). With this the selection is preserved
 *      even when the options are recreated (e.g. reloaded from the server).
 *
 * @example
    <example module="selectExample">
      <file name="index.html">
        <script>
        angular.module('selectExample', [])
          .controller('ExampleController', ['$scope', function($scope) {
            $scope.colors = [
              {name:'black', shade:'dark'},
              {name:'white', shade:'light', notAnOption: true},
              {name:'red', shade:'dark'},
              {name:'blue', shade:'dark', notAnOption: true},
              {name:'yellow', shade:'light', notAnOption: false}
            ];
            $scope.myColor = $scope.colors[2]; // red
          }]);
        </script>
        <div ng-controller="ExampleController">
          <ul>
            <li ng-repeat="color in colors">
              <label>Name: <input ng-model="color.name"></label>
              <label><input type="checkbox" ng-model="color.notAnOption"> Disabled?</label>
              <button ng-click="colors.splice($index, 1)" aria-label="Remove">X</button>
            </li>
            <li>
              <button ng-click="colors.push({})">add</button>
            </li>
          </ul>
          <hr/>
          <label>Color (null not allowed):
            <select ng-model="myColor" ng-options="color.name for color in colors"></select>
          </label><br/>
          <label>Color (null allowed):
          <span  class="nullable">
            <select ng-model="myColor" ng-options="color.name for color in colors">
              <option value="">-- choose color --</option>
            </select>
          </span></label><br/>

          <label>Color grouped by shade:
            <select ng-model="myColor" ng-options="color.name group by color.shade for color in colors">
            </select>
          </label><br/>

          <label>Color grouped by shade, with some disabled:
            <select ng-model="myColor"
                  ng-options="color.name group by color.shade disable when color.notAnOption for color in colors">
            </select>
          </label><br/>



          Select <button ng-click="myColor = { name:'not in list', shade: 'other' }">bogus</button>.
          <br/>
          <hr/>
          Currently selected: {{ {selected_color:myColor} }}
          <div style="border:solid 1px black; height:20px"
               ng-style="{'background-color':myColor.name}">
          </div>
        </div>
      </file>
      <file name="protractor.js" type="protractor">
         it('should check ng-options', function() {
           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('red');
           element.all(by.model('myColor')).first().click();
           element.all(by.css('select[ng-model="myColor"] option')).first().click();
           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('black');
           element(by.css('.nullable select[ng-model="myColor"]')).click();
           element.all(by.css('.nullable select[ng-model="myColor"] option')).first().click();
           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('null');
         });
      </file>
    </example>
 */

// jshint maxlen: false
//                     //00001111111111000000000002222222222000000000000000000000333333333300000000000000000000000004444444444400000000000005555555555555550000000006666666666666660000000777777777777777000000000000000888888888800000000000000000009999999999
var NG_OPTIONS_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+group\s+by\s+([\s\S]+?))?(?:\s+disable\s+when\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w]*)|(?:\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)))\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?$/;
                        // 1: value expression (valueFn)
                        // 2: label expression (displayFn)
                        // 3: group by expression (groupByFn)
                        // 4: disable when expression (disableWhenFn)
                        // 5: array item variable name
                        // 6: object item key variable name
                        // 7: object item value variable name
                        // 8: collection expression
                        // 9: track by expression
// jshint maxlen: 100


var ngOptionsDirective = ['$compile', '$document', '$parse', function($compile, $document, $parse) {

  function parseOptionsExpression(optionsExp, selectElement, scope) {

    var match = optionsExp.match(NG_OPTIONS_REGEXP);
    if (!(match)) {
      throw ngOptionsMinErr('iexp',
        "Expected expression in form of " +
        "'_select_ (as _label_)? for (_key_,)?_value_ in _collection_'" +
        " but got '{0}'. Element: {1}",
        optionsExp, startingTag(selectElement));
    }

    // Extract the parts from the ngOptions expression

    // The variable name for the value of the item in the collection
    var valueName = match[5] || match[7];
    // The variable name for the key of the item in the collection
    var keyName = match[6];

    // An expression that generates the viewValue for an option if there is a label expression
    var selectAs = / as /.test(match[0]) && match[1];
    // An expression that is used to track the id of each object in the options collection
    var trackBy = match[9];
    // An expression that generates the viewValue for an option if there is no label expression
    var valueFn = $parse(match[2] ? match[1] : valueName);
    var selectAsFn = selectAs && $parse(selectAs);
    var viewValueFn = selectAsFn || valueFn;
    var trackByFn = trackBy && $parse(trackBy);

    // Get the value by which we are going to track the option
    // if we have a trackFn then use that (passing scope and locals)
    // otherwise just hash the given viewValue
    var getTrackByValueFn = trackBy ?
                              function(value, locals) { return trackByFn(scope, locals); } :
                              function getHashOfValue(value) { return hashKey(value); };
    var getTrackByValue = function(value, key) {
      return getTrackByValueFn(value, getLocals(value, key));
    };

    var displayFn = $parse(match[2] || match[1]);
    var groupByFn = $parse(match[3] || '');
    var disableWhenFn = $parse(match[4] || '');
    var valuesFn = $parse(match[8]);

    var locals = {};
    var getLocals = keyName ? function(value, key) {
      locals[keyName] = key;
      locals[valueName] = value;
      return locals;
    } : function(value) {
      locals[valueName] = value;
      return locals;
    };


    function Option(selectValue, viewValue, label, group, disabled) {
      this.selectValue = selectValue;
      this.viewValue = viewValue;
      this.label = label;
      this.group = group;
      this.disabled = disabled;
    }

    function getOptionValuesKeys(optionValues) {
      var optionValuesKeys;

      if (!keyName && isArrayLike(optionValues)) {
        optionValuesKeys = optionValues;
      } else {
        // if object, extract keys, in enumeration order, unsorted
        optionValuesKeys = [];
        for (var itemKey in optionValues) {
          if (optionValues.hasOwnProperty(itemKey) && itemKey.charAt(0) !== '$') {
            optionValuesKeys.push(itemKey);
          }
        }
      }
      return optionValuesKeys;
    }

    return {
      trackBy: trackBy,
      getTrackByValue: getTrackByValue,
      getWatchables: $parse(valuesFn, function(optionValues) {
        // Create a collection of things that we would like to watch (watchedArray)
        // so that they can all be watched using a single $watchCollection
        // that only runs the handler once if anything changes
        var watchedArray = [];
        optionValues = optionValues || [];

        var optionValuesKeys = getOptionValuesKeys(optionValues);
        var optionValuesLength = optionValuesKeys.length;
        for (var index = 0; index < optionValuesLength; index++) {
          var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
          var value = optionValues[key];

          var locals = getLocals(value, key);
          var selectValue = getTrackByValueFn(value, locals);
          watchedArray.push(selectValue);

          // Only need to watch the displayFn if there is a specific label expression
          if (match[2] || match[1]) {
            var label = displayFn(scope, locals);
            watchedArray.push(label);
          }

          // Only need to watch the disableWhenFn if there is a specific disable expression
          if (match[4]) {
            var disableWhen = disableWhenFn(scope, locals);
            watchedArray.push(disableWhen);
          }
        }
        return watchedArray;
      }),

      getOptions: function() {

        var optionItems = [];
        var selectValueMap = {};

        // The option values were already computed in the `getWatchables` fn,
        // which must have been called to trigger `getOptions`
        var optionValues = valuesFn(scope) || [];
        var optionValuesKeys = getOptionValuesKeys(optionValues);
        var optionValuesLength = optionValuesKeys.length;

        for (var index = 0; index < optionValuesLength; index++) {
          var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
          var value = optionValues[key];
          var locals = getLocals(value, key);
          var viewValue = viewValueFn(scope, locals);
          var selectValue = getTrackByValueFn(viewValue, locals);
          var label = displayFn(scope, locals);
          var group = groupByFn(scope, locals);
          var disabled = disableWhenFn(scope, locals);
          var optionItem = new Option(selectValue, viewValue, label, group, disabled);

          optionItems.push(optionItem);
          selectValueMap[selectValue] = optionItem;
        }

        return {
          items: optionItems,
          selectValueMap: selectValueMap,
          getOptionFromViewValue: function(value) {
            return selectValueMap[getTrackByValue(value)];
          },
          getViewValueFromOption: function(option) {
            // If the viewValue could be an object that may be mutated by the application,
            // we need to make a copy and not return the reference to the value on the option.
            return trackBy ? angular.copy(option.viewValue) : option.viewValue;
          }
        };
      }
    };
  }


  // we can't just jqLite('<option>') since jqLite is not smart enough
  // to create it in <select> and IE barfs otherwise.
  var optionTemplate = window.document.createElement('option'),
      optGroupTemplate = window.document.createElement('optgroup');

    function ngOptionsPostLink(scope, selectElement, attr, ctrls) {

      var selectCtrl = ctrls[0];
      var ngModelCtrl = ctrls[1];
      var multiple = attr.multiple;

      // The emptyOption allows the application developer to provide their own custom "empty"
      // option when the viewValue does not match any of the option values.
      var emptyOption;
      for (var i = 0, children = selectElement.children(), ii = children.length; i < ii; i++) {
        if (children[i].value === '') {
          emptyOption = children.eq(i);
          break;
        }
      }

      var providedEmptyOption = !!emptyOption;

      var unknownOption = jqLite(optionTemplate.cloneNode(false));
      unknownOption.val('?');

      var options;
      var ngOptions = parseOptionsExpression(attr.ngOptions, selectElement, scope);
      // This stores the newly created options before they are appended to the select.
      // Since the contents are removed from the fragment when it is appended,
      // we only need to create it once.
      var listFragment = $document[0].createDocumentFragment();

      var renderEmptyOption = function() {
        if (!providedEmptyOption) {
          selectElement.prepend(emptyOption);
        }
        selectElement.val('');
        emptyOption.prop('selected', true); // needed for IE
        emptyOption.attr('selected', true);
      };

      var removeEmptyOption = function() {
        if (!providedEmptyOption) {
          emptyOption.remove();
        }
      };


      var renderUnknownOption = function() {
        selectElement.prepend(unknownOption);
        selectElement.val('?');
        unknownOption.prop('selected', true); // needed for IE
        unknownOption.attr('selected', true);
      };

      var removeUnknownOption = function() {
        unknownOption.remove();
      };

      // Update the controller methods for multiple selectable options
      if (!multiple) {

        selectCtrl.writeValue = function writeNgOptionsValue(value) {
          var option = options.getOptionFromViewValue(value);

          if (option) {
            // Don't update the option when it is already selected.
            // For example, the browser will select the first option by default. In that case,
            // most properties are set automatically - except the `selected` attribute, which we
            // set always

            if (selectElement[0].value !== option.selectValue) {
              removeUnknownOption();
              removeEmptyOption();

              selectElement[0].value = option.selectValue;
              option.element.selected = true;
            }

            option.element.setAttribute('selected', 'selected');
          } else {
            if (value === null || providedEmptyOption) {
              removeUnknownOption();
              renderEmptyOption();
            } else {
              removeEmptyOption();
              renderUnknownOption();
            }
          }
        };

        selectCtrl.readValue = function readNgOptionsValue() {

          var selectedOption = options.selectValueMap[selectElement.val()];

          if (selectedOption && !selectedOption.disabled) {
            removeEmptyOption();
            removeUnknownOption();
            return options.getViewValueFromOption(selectedOption);
          }
          return null;
        };

        // If we are using `track by` then we must watch the tracked value on the model
        // since ngModel only watches for object identity change
        if (ngOptions.trackBy) {
          scope.$watch(
            function() { return ngOptions.getTrackByValue(ngModelCtrl.$viewValue); },
            function() { ngModelCtrl.$render(); }
          );
        }

      } else {

        ngModelCtrl.$isEmpty = function(value) {
          return !value || value.length === 0;
        };


        selectCtrl.writeValue = function writeNgOptionsMultiple(value) {
          options.items.forEach(function(option) {
            option.element.selected = false;
          });

          if (value) {
            value.forEach(function(item) {
              var option = options.getOptionFromViewValue(item);
              if (option) option.element.selected = true;
            });
          }
        };


        selectCtrl.readValue = function readNgOptionsMultiple() {
          var selectedValues = selectElement.val() || [],
              selections = [];

          forEach(selectedValues, function(value) {
            var option = options.selectValueMap[value];
            if (option && !option.disabled) selections.push(options.getViewValueFromOption(option));
          });

          return selections;
        };

        // If we are using `track by` then we must watch these tracked values on the model
        // since ngModel only watches for object identity change
        if (ngOptions.trackBy) {

          scope.$watchCollection(function() {
            if (isArray(ngModelCtrl.$viewValue)) {
              return ngModelCtrl.$viewValue.map(function(value) {
                return ngOptions.getTrackByValue(value);
              });
            }
          }, function() {
            ngModelCtrl.$render();
          });

        }
      }


      if (providedEmptyOption) {

        // we need to remove it before calling selectElement.empty() because otherwise IE will
        // remove the label from the element. wtf?
        emptyOption.remove();

        // compile the element since there might be bindings in it
        $compile(emptyOption)(scope);

        // remove the class, which is added automatically because we recompile the element and it
        // becomes the compilation root
        emptyOption.removeClass('ng-scope');
      } else {
        emptyOption = jqLite(optionTemplate.cloneNode(false));
      }

      selectElement.empty();

      // We need to do this here to ensure that the options object is defined
      // when we first hit it in writeNgOptionsValue
      updateOptions();

      // We will re-render the option elements if the option values or labels change
      scope.$watchCollection(ngOptions.getWatchables, updateOptions);

      // ------------------------------------------------------------------ //

      function addOptionElement(option, parent) {
        var optionElement = optionTemplate.cloneNode(false);
        parent.appendChild(optionElement);
        updateOptionElement(option, optionElement);
      }


      function updateOptionElement(option, element) {
        option.element = element;
        element.disabled = option.disabled;
        // NOTE: The label must be set before the value, otherwise IE10/11/EDGE create unresponsive
        // selects in certain circumstances when multiple selects are next to each other and display
        // the option list in listbox style, i.e. the select is [multiple], or specifies a [size].
        // See https://github.com/angular/angular.js/issues/11314 for more info.
        // This is unfortunately untestable with unit / e2e tests
        if (option.label !== element.label) {
          element.label = option.label;
          element.textContent = option.label;
        }
        if (option.value !== element.value) element.value = option.selectValue;
      }

      function updateOptions() {
        var previousValue = options && selectCtrl.readValue();

        // We must remove all current options, but cannot simply set innerHTML = null
        // since the providedEmptyOption might have an ngIf on it that inserts comments which we
        // must preserve.
        // Instead, iterate over the current option elements and remove them or their optgroup
        // parents
        if (options) {

          for (var i = options.items.length - 1; i >= 0; i--) {
            var option = options.items[i];
            if (isDefined(option.group)) {
              jqLiteRemove(option.element.parentNode);
            } else {
              jqLiteRemove(option.element);
            }
          }
        }

        options = ngOptions.getOptions();

        var groupElementMap = {};

        // Ensure that the empty option is always there if it was explicitly provided
        if (providedEmptyOption) {
          selectElement.prepend(emptyOption);
        }

        options.items.forEach(function addOption(option) {
          var groupElement;

          if (isDefined(option.group)) {

            // This option is to live in a group
            // See if we have already created this group
            groupElement = groupElementMap[option.group];

            if (!groupElement) {

              groupElement = optGroupTemplate.cloneNode(false);
              listFragment.appendChild(groupElement);

              // Update the label on the group element
              // "null" is special cased because of Safari
              groupElement.label = option.group === null ? 'null' : option.group;

              // Store it for use later
              groupElementMap[option.group] = groupElement;
            }

            addOptionElement(option, groupElement);

          } else {

            // This option is not in a group
            addOptionElement(option, listFragment);
          }
        });

        selectElement[0].appendChild(listFragment);

        ngModelCtrl.$render();

        // Check to see if the value has changed due to the update to the options
        if (!ngModelCtrl.$isEmpty(previousValue)) {
          var nextValue = selectCtrl.readValue();
          var isNotPrimitive = ngOptions.trackBy || multiple;
          if (isNotPrimitive ? !equals(previousValue, nextValue) : previousValue !== nextValue) {
            ngModelCtrl.$setViewValue(nextValue);
            ngModelCtrl.$render();
          }
        }

      }
  }

  return {
    restrict: 'A',
    terminal: true,
    require: ['select', 'ngModel'],
    link: {
      pre: function ngOptionsPreLink(scope, selectElement, attr, ctrls) {
        // Deactivate the SelectController.register method to prevent
        // option directives from accidentally registering themselves
        // (and unwanted $destroy handlers etc.)
        ctrls[0].registerOption = noop;
      },
      post: ngOptionsPostLink
    }
  };
}];

/**
 * @ngdoc directive
 * @name ngPluralize
 * @restrict EA
 *
 * @description
 * `ngPluralize` is a directive that displays messages according to en-US localization rules.
 * These rules are bundled with angular.js, but can be overridden
 * (see {@link guide/i18n Angular i18n} dev guide). You configure ngPluralize directive
 * by specifying the mappings between
 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
 * and the strings to be displayed.
 *
 * # Plural categories and explicit number rules
 * There are two
 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
 * in Angular's default en-US locale: "one" and "other".
 *
 * While a plural category may match many numbers (for example, in en-US locale, "other" can match
 * any number that is not 1), an explicit number rule can only match one number. For example, the
 * explicit number rule for "3" matches the number 3. There are examples of plural categories
 * and explicit number rules throughout the rest of this documentation.
 *
 * # Configuring ngPluralize
 * You configure ngPluralize by providing 2 attributes: `count` and `when`.
 * You can also provide an optional attribute, `offset`.
 *
 * The value of the `count` attribute can be either a string or an {@link guide/expression
 * Angular expression}; these are evaluated on the current scope for its bound value.
 *
 * The `when` attribute specifies the mappings between plural categories and the actual
 * string to be displayed. The value of the attribute should be a JSON object.
 *
 * The following example shows how to configure ngPluralize:
 *
 * ```html
 * <ng-pluralize count="personCount"
                 when="{'0': 'Nobody is viewing.',
 *                      'one': '1 person is viewing.',
 *                      'other': '{} people are viewing.'}">
 * </ng-pluralize>
 *```
 *
 * In the example, `"0: Nobody is viewing."` is an explicit number rule. If you did not
 * specify this rule, 0 would be matched to the "other" category and "0 people are viewing"
 * would be shown instead of "Nobody is viewing". You can specify an explicit number rule for
 * other numbers, for example 12, so that instead of showing "12 people are viewing", you can
 * show "a dozen people are viewing".
 *
 * You can use a set of closed braces (`{}`) as a placeholder for the number that you want substituted
 * into pluralized strings. In the previous example, Angular will replace `{}` with
 * <span ng-non-bindable>`{{personCount}}`</span>. The closed braces `{}` is a placeholder
 * for <span ng-non-bindable>{{numberExpression}}</span>.
 *
 * If no rule is defined for a category, then an empty string is displayed and a warning is generated.
 * Note that some locales define more categories than `one` and `other`. For example, fr-fr defines `few` and `many`.
 *
 * # Configuring ngPluralize with offset
 * The `offset` attribute allows further customization of pluralized text, which can result in
 * a better user experience. For example, instead of the message "4 people are viewing this document",
 * you might display "John, Kate and 2 others are viewing this document".
 * The offset attribute allows you to offset a number by any desired value.
 * Let's take a look at an example:
 *
 * ```html
 * <ng-pluralize count="personCount" offset=2
 *               when="{'0': 'Nobody is viewing.',
 *                      '1': '{{person1}} is viewing.',
 *                      '2': '{{person1}} and {{person2}} are viewing.',
 *                      'one': '{{person1}}, {{person2}} and one other person are viewing.',
 *                      'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
 * </ng-pluralize>
 * ```
 *
 * Notice that we are still using two plural categories(one, other), but we added
 * three explicit number rules 0, 1 and 2.
 * When one person, perhaps John, views the document, "John is viewing" will be shown.
 * When three people view the document, no explicit number rule is found, so
 * an offset of 2 is taken off 3, and Angular uses 1 to decide the plural category.
 * In this case, plural category 'one' is matched and "John, Mary and one other person are viewing"
 * is shown.
 *
 * Note that when you specify offsets, you must provide explicit number rules for
 * numbers from 0 up to and including the offset. If you use an offset of 3, for example,
 * you must provide explicit number rules for 0, 1, 2 and 3. You must also provide plural strings for
 * plural categories "one" and "other".
 *
 * @param {string|expression} count The variable to be bound to.
 * @param {string} when The mapping between plural category to its corresponding strings.
 * @param {number=} offset Offset to deduct from the total number.
 *
 * @example
    <example module="pluralizeExample">
      <file name="index.html">
        <script>
          angular.module('pluralizeExample', [])
            .controller('ExampleController', ['$scope', function($scope) {
              $scope.person1 = 'Igor';
              $scope.person2 = 'Misko';
              $scope.personCount = 1;
            }]);
        </script>
        <div ng-controller="ExampleController">
          <label>Person 1:<input type="text" ng-model="person1" value="Igor" /></label><br/>
          <label>Person 2:<input type="text" ng-model="person2" value="Misko" /></label><br/>
          <label>Number of People:<input type="text" ng-model="personCount" value="1" /></label><br/>

          <!--- Example with simple pluralization rules for en locale --->
          Without Offset:
          <ng-pluralize count="personCount"
                        when="{'0': 'Nobody is viewing.',
                               'one': '1 person is viewing.',
                               'other': '{} people are viewing.'}">
          </ng-pluralize><br>

          <!--- Example with offset --->
          With Offset(2):
          <ng-pluralize count="personCount" offset=2
                        when="{'0': 'Nobody is viewing.',
                               '1': '{{person1}} is viewing.',
                               '2': '{{person1}} and {{person2}} are viewing.',
                               'one': '{{person1}}, {{person2}} and one other person are viewing.',
                               'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
          </ng-pluralize>
        </div>
      </file>
      <file name="protractor.js" type="protractor">
        it('should show correct pluralized string', function() {
          var withoutOffset = element.all(by.css('ng-pluralize')).get(0);
          var withOffset = element.all(by.css('ng-pluralize')).get(1);
          var countInput = element(by.model('personCount'));

          expect(withoutOffset.getText()).toEqual('1 person is viewing.');
          expect(withOffset.getText()).toEqual('Igor is viewing.');

          countInput.clear();
          countInput.sendKeys('0');

          expect(withoutOffset.getText()).toEqual('Nobody is viewing.');
          expect(withOffset.getText()).toEqual('Nobody is viewing.');

          countInput.clear();
          countInput.sendKeys('2');

          expect(withoutOffset.getText()).toEqual('2 people are viewing.');
          expect(withOffset.getText()).toEqual('Igor and Misko are viewing.');

          countInput.clear();
          countInput.sendKeys('3');

          expect(withoutOffset.getText()).toEqual('3 people are viewing.');
          expect(withOffset.getText()).toEqual('Igor, Misko and one other person are viewing.');

          countInput.clear();
          countInput.sendKeys('4');

          expect(withoutOffset.getText()).toEqual('4 people are viewing.');
          expect(withOffset.getText()).toEqual('Igor, Misko and 2 other people are viewing.');
        });
        it('should show data-bound names', function() {
          var withOffset = element.all(by.css('ng-pluralize')).get(1);
          var personCount = element(by.model('personCount'));
          var person1 = element(by.model('person1'));
          var person2 = element(by.model('person2'));
          personCount.clear();
          personCount.sendKeys('4');
          person1.clear();
          person1.sendKeys('Di');
          person2.clear();
          person2.sendKeys('Vojta');
          expect(withOffset.getText()).toEqual('Di, Vojta and 2 other people are viewing.');
        });
      </file>
    </example>
 */
var ngPluralizeDirective = ['$locale', '$interpolate', '$log', function($locale, $interpolate, $log) {
  var BRACE = /{}/g,
      IS_WHEN = /^when(Minus)?(.+)$/;

  return {
    link: function(scope, element, attr) {
      var numberExp = attr.count,
          whenExp = attr.$attr.when && element.attr(attr.$attr.when), // we have {{}} in attrs
          offset = attr.offset || 0,
          whens = scope.$eval(whenExp) || {},
          whensExpFns = {},
          startSymbol = $interpolate.startSymbol(),
          endSymbol = $interpolate.endSymbol(),
          braceReplacement = startSymbol + numberExp + '-' + offset + endSymbol,
          watchRemover = angular.noop,
          lastCount;

      forEach(attr, function(expression, attributeName) {
        var tmpMatch = IS_WHEN.exec(attributeName);
        if (tmpMatch) {
          var whenKey = (tmpMatch[1] ? '-' : '') + lowercase(tmpMatch[2]);
          whens[whenKey] = element.attr(attr.$attr[attributeName]);
        }
      });
      forEach(whens, function(expression, key) {
        whensExpFns[key] = $interpolate(expression.replace(BRACE, braceReplacement));

      });

      scope.$watch(numberExp, function ngPluralizeWatchAction(newVal) {
        var count = parseFloat(newVal);
        var countIsNaN = isNaN(count);

        if (!countIsNaN && !(count in whens)) {
          // If an explicit number rule such as 1, 2, 3... is defined, just use it.
          // Otherwise, check it against pluralization rules in $locale service.
          count = $locale.pluralCat(count - offset);
        }

        // If both `count` and `lastCount` are NaN, we don't need to re-register a watch.
        // In JS `NaN !== NaN`, so we have to explicitly check.
        if ((count !== lastCount) && !(countIsNaN && isNumber(lastCount) && isNaN(lastCount))) {
          watchRemover();
          var whenExpFn = whensExpFns[count];
          if (isUndefined(whenExpFn)) {
            if (newVal != null) {
              $log.debug("ngPluralize: no rule defined for '" + count + "' in " + whenExp);
            }
            watchRemover = noop;
            updateElementText();
          } else {
            watchRemover = scope.$watch(whenExpFn, updateElementText);
          }
          lastCount = count;
        }
      });

      function updateElementText(newText) {
        element.text(newText || '');
      }
    }
  };
}];

/**
 * @ngdoc directive
 * @name ngRepeat
 * @multiElement
 *
 * @description
 * The `ngRepeat` directive instantiates a template once per item from a collection. Each template
 * instance gets its own scope, where the given loop variable is set to the current collection item,
 * and `$index` is set to the item index or key.
 *
 * Special properties are exposed on the local scope of each template instance, including:
 *
 * | Variable  | Type            | Details                                                                     |
 * |-----------|-----------------|-----------------------------------------------------------------------------|
 * | `$index`  | {@type number}  | iterator offset of the repeated element (0..length-1)                       |
 * | `$first`  | {@type boolean} | true if the repeated element is first in the iterator.                      |
 * | `$middle` | {@type boolean} | true if the repeated element is between the first and last in the iterator. |
 * | `$last`   | {@type boolean} | true if the repeated element is last in the iterator.                       |
 * | `$even`   | {@type boolean} | true if the iterator position `$index` is even (otherwise false).           |
 * | `$odd`    | {@type boolean} | true if the iterator position `$index` is odd (otherwise false).            |
 *
 * <div class="alert alert-info">
 *   Creating aliases for these properties is possible with {@link ng.directive:ngInit `ngInit`}.
 *   This may be useful when, for instance, nesting ngRepeats.
 * </div>
 *
 *
 * # Iterating over object properties
 *
 * It is possible to get `ngRepeat` to iterate over the properties of an object using the following
 * syntax:
 *
 * ```js
 * <div ng-repeat="(key, value) in myObj"> ... </div>
 * ```
 *
 * However, there are a limitations compared to array iteration:
 *
 * - The JavaScript specification does not define the order of keys
 *   returned for an object, so Angular relies on the order returned by the browser
 *   when running `for key in myObj`. Browsers generally follow the strategy of providing
 *   keys in the order in which they were defined, although there are exceptions when keys are deleted
 *   and reinstated. See the
 *   [MDN page on `delete` for more info](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/delete#Cross-browser_notes).
 *
 * - `ngRepeat` will silently *ignore* object keys starting with `$`, because
 *   it's a prefix used by Angular for public (`$`) and private (`$$`) properties.
 *
 * - The built-in filters {@link ng.orderBy orderBy} and {@link ng.filter filter} do not work with
 *   objects, and will throw an error if used with one.
 *
 * If you are hitting any of these limitations, the recommended workaround is to convert your object into an array
 * that is sorted into the order that you prefer before providing it to `ngRepeat`. You could
 * do this with a filter such as [toArrayFilter](http://ngmodules.org/modules/angular-toArrayFilter)
 * or implement a `$watch` on the object yourself.
 *
 *
 * # Tracking and Duplicates
 *
 * `ngRepeat` uses {@link $rootScope.Scope#$watchCollection $watchCollection} to detect changes in
 * the collection. When a change happens, ngRepeat then makes the corresponding changes to the DOM:
 *
 * * When an item is added, a new instance of the template is added to the DOM.
 * * When an item is removed, its template instance is removed from the DOM.
 * * When items are reordered, their respective templates are reordered in the DOM.
 *
 * To minimize creation of DOM elements, `ngRepeat` uses a function
 * to "keep track" of all items in the collection and their corresponding DOM elements.
 * For example, if an item is added to the collection, ngRepeat will know that all other items
 * already have DOM elements, and will not re-render them.
 *
 * The default tracking function (which tracks items by their identity) does not allow
 * duplicate items in arrays. This is because when there are duplicates, it is not possible
 * to maintain a one-to-one mapping between collection items and DOM elements.
 *
 * If you do need to repeat duplicate items, you can substitute the default tracking behavior
 * with your own using the `track by` expression.
 *
 * For example, you may track items by the index of each item in the collection, using the
 * special scope property `$index`:
 * ```html
 *    <div ng-repeat="n in [42, 42, 43, 43] track by $index">
 *      {{n}}
 *    </div>
 * ```
 *
 * You may also use arbitrary expressions in `track by`, including references to custom functions
 * on the scope:
 * ```html
 *    <div ng-repeat="n in [42, 42, 43, 43] track by myTrackingFunction(n)">
 *      {{n}}
 *    </div>
 * ```
 *
 * <div class="alert alert-success">
 * If you are working with objects that have an identifier property, you should track
 * by the identifier instead of the whole object. Should you reload your data later, `ngRepeat`
 * will not have to rebuild the DOM elements for items it has already rendered, even if the
 * JavaScript objects in the collection have been substituted for new ones. For large collections,
 * this significantly improves rendering performance. If you don't have a unique identifier,
 * `track by $index` can also provide a performance boost.
 * </div>
 * ```html
 *    <div ng-repeat="model in collection track by model.id">
 *      {{model.name}}
 *    </div>
 * ```
 *
 * When no `track by` expression is provided, it is equivalent to tracking by the built-in
 * `$id` function, which tracks items by their identity:
 * ```html
 *    <div ng-repeat="obj in collection track by $id(obj)">
 *      {{obj.prop}}
 *    </div>
 * ```
 *
 * <div class="alert alert-warning">
 * **Note:** `track by` must always be the last expression:
 * </div>
 * ```
 * <div ng-repeat="model in collection | orderBy: 'id' as filtered_result track by model.id">
 *     {{model.name}}
 * </div>
 * ```
 *
 * # Special repeat start and end points
 * To repeat a series of elements instead of just one parent element, ngRepeat (as well as other ng directives) supports extending
 * the range of the repeater by defining explicit start and end points by using **ng-repeat-start** and **ng-repeat-end** respectively.
 * The **ng-repeat-start** directive works the same as **ng-repeat**, but will repeat all the HTML code (including the tag it's defined on)
 * up to and including the ending HTML tag where **ng-repeat-end** is placed.
 *
 * The example below makes use of this feature:
 * ```html
 *   <header ng-repeat-start="item in items">
 *     Header {{ item }}
 *   </header>
 *   <div class="body">
 *     Body {{ item }}
 *   </div>
 *   <footer ng-repeat-end>
 *     Footer {{ item }}
 *   </footer>
 * ```
 *
 * And with an input of {@type ['A','B']} for the items variable in the example above, the output will evaluate to:
 * ```html
 *   <header>
 *     Header A
 *   </header>
 *   <div class="body">
 *     Body A
 *   </div>
 *   <footer>
 *     Footer A
 *   </footer>
 *   <header>
 *     Header B
 *   </header>
 *   <div class="body">
 *     Body B
 *   </div>
 *   <footer>
 *     Footer B
 *   </footer>
 * ```
 *
 * The custom start and end points for ngRepeat also support all other HTML directive syntax flavors provided in AngularJS (such
 * as **data-ng-repeat-start**, **x-ng-repeat-start** and **ng:repeat-start**).
 *
 * @animations
 * | Animation                        | Occurs                              |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#enter enter} | when a new item is added to the list or when an item is revealed after a filter |
 * | {@link ng.$animate#leave leave} | when an item is removed from the list or when an item is filtered out |
 * | {@link ng.$animate#move move } | when an adjacent item is filtered out causing a reorder or when the item contents are reordered |
 *
 * See the example below for defining CSS animations with ngRepeat.
 *
 * @element ANY
 * @scope
 * @priority 1000
 * @param {repeat_expression} ngRepeat The expression indicating how to enumerate a collection. These
 *   formats are currently supported:
 *
 *   * `variable in expression` – where variable is the user defined loop variable and `expression`
 *     is a scope expression giving the collection to enumerate.
 *
 *     For example: `album in artist.albums`.
 *
 *   * `(key, value) in expression` – where `key` and `value` can be any user defined identifiers,
 *     and `expression` is the scope expression giving the collection to enumerate.
 *
 *     For example: `(name, age) in {'adam':10, 'amalie':12}`.
 *
 *   * `variable in expression track by tracking_expression` – You can also provide an optional tracking expression
 *     which can be used to associate the objects in the collection with the DOM elements. If no tracking expression
 *     is specified, ng-repeat associates elements by identity. It is an error to have
 *     more than one tracking expression value resolve to the same key. (This would mean that two distinct objects are
 *     mapped to the same DOM element, which is not possible.)
 *
 *     Note that the tracking expression must come last, after any filters, and the alias expression.
 *
 *     For example: `item in items` is equivalent to `item in items track by $id(item)`. This implies that the DOM elements
 *     will be associated by item identity in the array.
 *
 *     For example: `item in items track by $id(item)`. A built in `$id()` function can be used to assign a unique
 *     `$$hashKey` property to each item in the array. This property is then used as a key to associated DOM elements
 *     with the corresponding item in the array by identity. Moving the same object in array would move the DOM
 *     element in the same way in the DOM.
 *
 *     For example: `item in items track by item.id` is a typical pattern when the items come from the database. In this
 *     case the object identity does not matter. Two objects are considered equivalent as long as their `id`
 *     property is same.
 *
 *     For example: `item in items | filter:searchText track by item.id` is a pattern that might be used to apply a filter
 *     to items in conjunction with a tracking expression.
 *
 *   * `variable in expression as alias_expression` – You can also provide an optional alias expression which will then store the
 *     intermediate results of the repeater after the filters have been applied. Typically this is used to render a special message
 *     when a filter is active on the repeater, but the filtered result set is empty.
 *
 *     For example: `item in items | filter:x as results` will store the fragment of the repeated items as `results`, but only after
 *     the items have been processed through the filter.
 *
 *     Please note that `as [variable name] is not an operator but rather a part of ngRepeat micro-syntax so it can be used only at the end
 *     (and not as operator, inside an expression).
 *
 *     For example: `item in items | filter : x | orderBy : order | limitTo : limit as results` .
 *
 * @example
 * This example uses `ngRepeat` to display a list of people. A filter is used to restrict the displayed
 * results by name. New (entering) and removed (leaving) items are animated.
  <example module="ngRepeat" name="ngRepeat" deps="angular-animate.js" animations="true">
    <file name="index.html">
      <div ng-controller="repeatController">
        I have {{friends.length}} friends. They are:
        <input type="search" ng-model="q" placeholder="filter friends..." aria-label="filter friends" />
        <ul class="example-animate-container">
          <li class="animate-repeat" ng-repeat="friend in friends | filter:q as results">
            [{{$index + 1}}] {{friend.name}} who is {{friend.age}} years old.
          </li>
          <li class="animate-repeat" ng-if="results.length == 0">
            <strong>No results found...</strong>
          </li>
        </ul>
      </div>
    </file>
    <file name="script.js">
      angular.module('ngRepeat', ['ngAnimate']).controller('repeatController', function($scope) {
        $scope.friends = [
          {name:'John', age:25, gender:'boy'},
          {name:'Jessie', age:30, gender:'girl'},
          {name:'Johanna', age:28, gender:'girl'},
          {name:'Joy', age:15, gender:'girl'},
          {name:'Mary', age:28, gender:'girl'},
          {name:'Peter', age:95, gender:'boy'},
          {name:'Sebastian', age:50, gender:'boy'},
          {name:'Erika', age:27, gender:'girl'},
          {name:'Patrick', age:40, gender:'boy'},
          {name:'Samantha', age:60, gender:'girl'}
        ];
      });
    </file>
    <file name="animations.css">
      .example-animate-container {
        background:white;
        border:1px solid black;
        list-style:none;
        margin:0;
        padding:0 10px;
      }

      .animate-repeat {
        line-height:30px;
        list-style:none;
        box-sizing:border-box;
      }

      .animate-repeat.ng-move,
      .animate-repeat.ng-enter,
      .animate-repeat.ng-leave {
        transition:all linear 0.5s;
      }

      .animate-repeat.ng-leave.ng-leave-active,
      .animate-repeat.ng-move,
      .animate-repeat.ng-enter {
        opacity:0;
        max-height:0;
      }

      .animate-repeat.ng-leave,
      .animate-repeat.ng-move.ng-move-active,
      .animate-repeat.ng-enter.ng-enter-active {
        opacity:1;
        max-height:30px;
      }
    </file>
    <file name="protractor.js" type="protractor">
      var friends = element.all(by.repeater('friend in friends'));

      it('should render initial data set', function() {
        expect(friends.count()).toBe(10);
        expect(friends.get(0).getText()).toEqual('[1] John who is 25 years old.');
        expect(friends.get(1).getText()).toEqual('[2] Jessie who is 30 years old.');
        expect(friends.last().getText()).toEqual('[10] Samantha who is 60 years old.');
        expect(element(by.binding('friends.length')).getText())
            .toMatch("I have 10 friends. They are:");
      });

       it('should update repeater when filter predicate changes', function() {
         expect(friends.count()).toBe(10);

         element(by.model('q')).sendKeys('ma');

         expect(friends.count()).toBe(2);
         expect(friends.get(0).getText()).toEqual('[1] Mary who is 28 years old.');
         expect(friends.last().getText()).toEqual('[2] Samantha who is 60 years old.');
       });
      </file>
    </example>
 */
var ngRepeatDirective = ['$parse', '$animate', '$compile', function($parse, $animate, $compile) {
  var NG_REMOVED = '$$NG_REMOVED';
  var ngRepeatMinErr = minErr('ngRepeat');

  var updateScope = function(scope, index, valueIdentifier, value, keyIdentifier, key, arrayLength) {
    // TODO(perf): generate setters to shave off ~40ms or 1-1.5%
    scope[valueIdentifier] = value;
    if (keyIdentifier) scope[keyIdentifier] = key;
    scope.$index = index;
    scope.$first = (index === 0);
    scope.$last = (index === (arrayLength - 1));
    scope.$middle = !(scope.$first || scope.$last);
    // jshint bitwise: false
    scope.$odd = !(scope.$even = (index&1) === 0);
    // jshint bitwise: true
  };

  var getBlockStart = function(block) {
    return block.clone[0];
  };

  var getBlockEnd = function(block) {
    return block.clone[block.clone.length - 1];
  };


  return {
    restrict: 'A',
    multiElement: true,
    transclude: 'element',
    priority: 1000,
    terminal: true,
    $$tlb: true,
    compile: function ngRepeatCompile($element, $attr) {
      var expression = $attr.ngRepeat;
      var ngRepeatEndComment = $compile.$$createComment('end ngRepeat', expression);

      var match = expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);

      if (!match) {
        throw ngRepeatMinErr('iexp', "Expected expression in form of '_item_ in _collection_[ track by _id_]' but got '{0}'.",
            expression);
      }

      var lhs = match[1];
      var rhs = match[2];
      var aliasAs = match[3];
      var trackByExp = match[4];

      match = lhs.match(/^(?:(\s*[\$\w]+)|\(\s*([\$\w]+)\s*,\s*([\$\w]+)\s*\))$/);

      if (!match) {
        throw ngRepeatMinErr('iidexp', "'_item_' in '_item_ in _collection_' should be an identifier or '(_key_, _value_)' expression, but got '{0}'.",
            lhs);
      }
      var valueIdentifier = match[3] || match[1];
      var keyIdentifier = match[2];

      if (aliasAs && (!/^[$a-zA-Z_][$a-zA-Z0-9_]*$/.test(aliasAs) ||
          /^(null|undefined|this|\$index|\$first|\$middle|\$last|\$even|\$odd|\$parent|\$root|\$id)$/.test(aliasAs))) {
        throw ngRepeatMinErr('badident', "alias '{0}' is invalid --- must be a valid JS identifier which is not a reserved name.",
          aliasAs);
      }

      var trackByExpGetter, trackByIdExpFn, trackByIdArrayFn, trackByIdObjFn;
      var hashFnLocals = {$id: hashKey};

      if (trackByExp) {
        trackByExpGetter = $parse(trackByExp);
      } else {
        trackByIdArrayFn = function(key, value) {
          return hashKey(value);
        };
        trackByIdObjFn = function(key) {
          return key;
        };
      }

      return function ngRepeatLink($scope, $element, $attr, ctrl, $transclude) {

        if (trackByExpGetter) {
          trackByIdExpFn = function(key, value, index) {
            // assign key, value, and $index to the locals so that they can be used in hash functions
            if (keyIdentifier) hashFnLocals[keyIdentifier] = key;
            hashFnLocals[valueIdentifier] = value;
            hashFnLocals.$index = index;
            return trackByExpGetter($scope, hashFnLocals);
          };
        }

        // Store a list of elements from previous run. This is a hash where key is the item from the
        // iterator, and the value is objects with following properties.
        //   - scope: bound scope
        //   - element: previous element.
        //   - index: position
        //
        // We are using no-proto object so that we don't need to guard against inherited props via
        // hasOwnProperty.
        var lastBlockMap = createMap();

        //watch props
        $scope.$watchCollection(rhs, function ngRepeatAction(collection) {
          var index, length,
              previousNode = $element[0],     // node that cloned nodes should be inserted after
                                              // initialized to the comment node anchor
              nextNode,
              // Same as lastBlockMap but it has the current state. It will become the
              // lastBlockMap on the next iteration.
              nextBlockMap = createMap(),
              collectionLength,
              key, value, // key/value of iteration
              trackById,
              trackByIdFn,
              collectionKeys,
              block,       // last object information {scope, element, id}
              nextBlockOrder,
              elementsToRemove;

          if (aliasAs) {
            $scope[aliasAs] = collection;
          }

          if (isArrayLike(collection)) {
            collectionKeys = collection;
            trackByIdFn = trackByIdExpFn || trackByIdArrayFn;
          } else {
            trackByIdFn = trackByIdExpFn || trackByIdObjFn;
            // if object, extract keys, in enumeration order, unsorted
            collectionKeys = [];
            for (var itemKey in collection) {
              if (hasOwnProperty.call(collection, itemKey) && itemKey.charAt(0) !== '$') {
                collectionKeys.push(itemKey);
              }
            }
          }

          collectionLength = collectionKeys.length;
          nextBlockOrder = new Array(collectionLength);

          // locate existing items
          for (index = 0; index < collectionLength; index++) {
            key = (collection === collectionKeys) ? index : collectionKeys[index];
            value = collection[key];
            trackById = trackByIdFn(key, value, index);
            if (lastBlockMap[trackById]) {
              // found previously seen block
              block = lastBlockMap[trackById];
              delete lastBlockMap[trackById];
              nextBlockMap[trackById] = block;
              nextBlockOrder[index] = block;
            } else if (nextBlockMap[trackById]) {
              // if collision detected. restore lastBlockMap and throw an error
              forEach(nextBlockOrder, function(block) {
                if (block && block.scope) lastBlockMap[block.id] = block;
              });
              throw ngRepeatMinErr('dupes',
                  "Duplicates in a repeater are not allowed. Use 'track by' expression to specify unique keys. Repeater: {0}, Duplicate key: {1}, Duplicate value: {2}",
                  expression, trackById, value);
            } else {
              // new never before seen block
              nextBlockOrder[index] = {id: trackById, scope: undefined, clone: undefined};
              nextBlockMap[trackById] = true;
            }
          }

          // remove leftover items
          for (var blockKey in lastBlockMap) {
            block = lastBlockMap[blockKey];
            elementsToRemove = getBlockNodes(block.clone);
            $animate.leave(elementsToRemove);
            if (elementsToRemove[0].parentNode) {
              // if the element was not removed yet because of pending animation, mark it as deleted
              // so that we can ignore it later
              for (index = 0, length = elementsToRemove.length; index < length; index++) {
                elementsToRemove[index][NG_REMOVED] = true;
              }
            }
            block.scope.$destroy();
          }

          // we are not using forEach for perf reasons (trying to avoid #call)
          for (index = 0; index < collectionLength; index++) {
            key = (collection === collectionKeys) ? index : collectionKeys[index];
            value = collection[key];
            block = nextBlockOrder[index];

            if (block.scope) {
              // if we have already seen this object, then we need to reuse the
              // associated scope/element

              nextNode = previousNode;

              // skip nodes that are already pending removal via leave animation
              do {
                nextNode = nextNode.nextSibling;
              } while (nextNode && nextNode[NG_REMOVED]);

              if (getBlockStart(block) != nextNode) {
                // existing item which got moved
                $animate.move(getBlockNodes(block.clone), null, previousNode);
              }
              previousNode = getBlockEnd(block);
              updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
            } else {
              // new item which we don't know about
              $transclude(function ngRepeatTransclude(clone, scope) {
                block.scope = scope;
                // http://jsperf.com/clone-vs-createcomment
                var endNode = ngRepeatEndComment.cloneNode(false);
                clone[clone.length++] = endNode;

                $animate.enter(clone, null, previousNode);
                previousNode = endNode;
                // Note: We only need the first/last node of the cloned nodes.
                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
                // by a directive with templateUrl when its template arrives.
                block.clone = clone;
                nextBlockMap[block.id] = block;
                updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
              });
            }
          }
          lastBlockMap = nextBlockMap;
        });
      };
    }
  };
}];

var NG_HIDE_CLASS = 'ng-hide';
var NG_HIDE_IN_PROGRESS_CLASS = 'ng-hide-animate';
/**
 * @ngdoc directive
 * @name ngShow
 * @multiElement
 *
 * @description
 * The `ngShow` directive shows or hides the given HTML element based on the expression
 * provided to the `ngShow` attribute. The element is shown or hidden by removing or adding
 * the `.ng-hide` CSS class onto the element. The `.ng-hide` CSS class is predefined
 * in AngularJS and sets the display style to none (using an !important flag).
 * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
 *
 * ```html
 * <!-- when $scope.myValue is truthy (element is visible) -->
 * <div ng-show="myValue"></div>
 *
 * <!-- when $scope.myValue is falsy (element is hidden) -->
 * <div ng-show="myValue" class="ng-hide"></div>
 * ```
 *
 * When the `ngShow` expression evaluates to a falsy value then the `.ng-hide` CSS class is added to the class
 * attribute on the element causing it to become hidden. When truthy, the `.ng-hide` CSS class is removed
 * from the element causing the element not to appear hidden.
 *
 * ## Why is !important used?
 *
 * You may be wondering why !important is used for the `.ng-hide` CSS class. This is because the `.ng-hide` selector
 * can be easily overridden by heavier selectors. For example, something as simple
 * as changing the display style on a HTML list item would make hidden elements appear visible.
 * This also becomes a bigger issue when dealing with CSS frameworks.
 *
 * By using !important, the show and hide behavior will work as expected despite any clash between CSS selector
 * specificity (when !important isn't used with any conflicting styles). If a developer chooses to override the
 * styling to change how to hide an element then it is just a matter of using !important in their own CSS code.
 *
 * ### Overriding `.ng-hide`
 *
 * By default, the `.ng-hide` class will style the element with `display: none!important`. If you wish to change
 * the hide behavior with ngShow/ngHide then this can be achieved by restating the styles for the `.ng-hide`
 * class CSS. Note that the selector that needs to be used is actually `.ng-hide:not(.ng-hide-animate)` to cope
 * with extra animation classes that can be added.
 *
 * ```css
 * .ng-hide:not(.ng-hide-animate) {
 *   /&#42; this is just another form of hiding an element &#42;/
 *   display: block!important;
 *   position: absolute;
 *   top: -9999px;
 *   left: -9999px;
 * }
 * ```
 *
 * By default you don't need to override in CSS anything and the animations will work around the display style.
 *
 * ## A note about animations with `ngShow`
 *
 * Animations in ngShow/ngHide work with the show and hide events that are triggered when the directive expression
 * is true and false. This system works like the animation system present with ngClass except that
 * you must also include the !important flag to override the display property
 * so that you can perform an animation when the element is hidden during the time of the animation.
 *
 * ```css
 * //
 * //a working example can be found at the bottom of this page
 * //
 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
 *   /&#42; this is required as of 1.3x to properly
 *      apply all styling in a show/hide animation &#42;/
 *   transition: 0s linear all;
 * }
 *
 * .my-element.ng-hide-add-active,
 * .my-element.ng-hide-remove-active {
 *   /&#42; the transition is defined in the active class &#42;/
 *   transition: 1s linear all;
 * }
 *
 * .my-element.ng-hide-add { ... }
 * .my-element.ng-hide-add.ng-hide-add-active { ... }
 * .my-element.ng-hide-remove { ... }
 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
 * ```
 *
 * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display
 * property to block during animation states--ngAnimate will handle the style toggling automatically for you.
 *
 * @animations
 * | Animation                        | Occurs                              |
 * |----------------------------------|-------------------------------------|
 * | {@link $animate#addClass addClass} `.ng-hide`  | after the `ngShow` expression evaluates to a non truthy value and just before the contents are set to hidden |
 * | {@link $animate#removeClass removeClass}  `.ng-hide`  | after the `ngShow` expression evaluates to a truthy value and just before contents are set to visible |
 *
 * @element ANY
 * @param {expression} ngShow If the {@link guide/expression expression} is truthy
 *     then the element is shown or hidden respectively.
 *
 * @example
  <example module="ngAnimate" deps="angular-animate.js" animations="true">
    <file name="index.html">
      Click me: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br/>
      <div>
        Show:
        <div class="check-element animate-show" ng-show="checked">
          <span class="glyphicon glyphicon-thumbs-up"></span> I show up when your checkbox is checked.
        </div>
      </div>
      <div>
        Hide:
        <div class="check-element animate-show" ng-hide="checked">
          <span class="glyphicon glyphicon-thumbs-down"></span> I hide when your checkbox is checked.
        </div>
      </div>
    </file>
    <file name="glyphicons.css">
      @import url(../../components/bootstrap-3.1.1/css/bootstrap.css);
    </file>
    <file name="animations.css">
      .animate-show {
        line-height: 20px;
        opacity: 1;
        padding: 10px;
        border: 1px solid black;
        background: white;
      }

      .animate-show.ng-hide-add, .animate-show.ng-hide-remove {
        transition: all linear 0.5s;
      }

      .animate-show.ng-hide {
        line-height: 0;
        opacity: 0;
        padding: 0 10px;
      }

      .check-element {
        padding: 10px;
        border: 1px solid black;
        background: white;
      }
    </file>
    <file name="protractor.js" type="protractor">
      var thumbsUp = element(by.css('span.glyphicon-thumbs-up'));
      var thumbsDown = element(by.css('span.glyphicon-thumbs-down'));

      it('should check ng-show / ng-hide', function() {
        expect(thumbsUp.isDisplayed()).toBeFalsy();
        expect(thumbsDown.isDisplayed()).toBeTruthy();

        element(by.model('checked')).click();

        expect(thumbsUp.isDisplayed()).toBeTruthy();
        expect(thumbsDown.isDisplayed()).toBeFalsy();
      });
    </file>
  </example>
 */
var ngShowDirective = ['$animate', function($animate) {
  return {
    restrict: 'A',
    multiElement: true,
    link: function(scope, element, attr) {
      scope.$watch(attr.ngShow, function ngShowWatchAction(value) {
        // we're adding a temporary, animation-specific class for ng-hide since this way
        // we can control when the element is actually displayed on screen without having
        // to have a global/greedy CSS selector that breaks when other animations are run.
        // Read: https://github.com/angular/angular.js/issues/9103#issuecomment-58335845
        $animate[value ? 'removeClass' : 'addClass'](element, NG_HIDE_CLASS, {
          tempClasses: NG_HIDE_IN_PROGRESS_CLASS
        });
      });
    }
  };
}];


/**
 * @ngdoc directive
 * @name ngHide
 * @multiElement
 *
 * @description
 * The `ngHide` directive shows or hides the given HTML element based on the expression
 * provided to the `ngHide` attribute. The element is shown or hidden by removing or adding
 * the `ng-hide` CSS class onto the element. The `.ng-hide` CSS class is predefined
 * in AngularJS and sets the display style to none (using an !important flag).
 * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
 *
 * ```html
 * <!-- when $scope.myValue is truthy (element is hidden) -->
 * <div ng-hide="myValue" class="ng-hide"></div>
 *
 * <!-- when $scope.myValue is falsy (element is visible) -->
 * <div ng-hide="myValue"></div>
 * ```
 *
 * When the `ngHide` expression evaluates to a truthy value then the `.ng-hide` CSS class is added to the class
 * attribute on the element causing it to become hidden. When falsy, the `.ng-hide` CSS class is removed
 * from the element causing the element not to appear hidden.
 *
 * ## Why is !important used?
 *
 * You may be wondering why !important is used for the `.ng-hide` CSS class. This is because the `.ng-hide` selector
 * can be easily overridden by heavier selectors. For example, something as simple
 * as changing the display style on a HTML list item would make hidden elements appear visible.
 * This also becomes a bigger issue when dealing with CSS frameworks.
 *
 * By using !important, the show and hide behavior will work as expected despite any clash between CSS selector
 * specificity (when !important isn't used with any conflicting styles). If a developer chooses to override the
 * styling to change how to hide an element then it is just a matter of using !important in their own CSS code.
 *
 * ### Overriding `.ng-hide`
 *
 * By default, the `.ng-hide` class will style the element with `display: none!important`. If you wish to change
 * the hide behavior with ngShow/ngHide then this can be achieved by restating the styles for the `.ng-hide`
 * class in CSS:
 *
 * ```css
 * .ng-hide {
 *   /&#42; this is just another form of hiding an element &#42;/
 *   display: block!important;
 *   position: absolute;
 *   top: -9999px;
 *   left: -9999px;
 * }
 * ```
 *
 * By default you don't need to override in CSS anything and the animations will work around the display style.
 *
 * ## A note about animations with `ngHide`
 *
 * Animations in ngShow/ngHide work with the show and hide events that are triggered when the directive expression
 * is true and false. This system works like the animation system present with ngClass, except that the `.ng-hide`
 * CSS class is added and removed for you instead of your own CSS class.
 *
 * ```css
 * //
 * //a working example can be found at the bottom of this page
 * //
 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
 *   transition: 0.5s linear all;
 * }
 *
 * .my-element.ng-hide-add { ... }
 * .my-element.ng-hide-add.ng-hide-add-active { ... }
 * .my-element.ng-hide-remove { ... }
 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
 * ```
 *
 * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display
 * property to block during animation states--ngAnimate will handle the style toggling automatically for you.
 *
 * @animations
 * | Animation                        | Occurs                              |
 * |----------------------------------|-------------------------------------|
 * | {@link $animate#addClass addClass} `.ng-hide`  | after the `ngHide` expression evaluates to a truthy value and just before the contents are set to hidden |
 * | {@link $animate#removeClass removeClass}  `.ng-hide`  | after the `ngHide` expression evaluates to a non truthy value and just before contents are set to visible |
 *
 *
 * @element ANY
 * @param {expression} ngHide If the {@link guide/expression expression} is truthy then
 *     the element is shown or hidden respectively.
 *
 * @example
  <example module="ngAnimate" deps="angular-animate.js" animations="true">
    <file name="index.html">
      Click me: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br/>
      <div>
        Show:
        <div class="check-element animate-hide" ng-show="checked">
          <span class="glyphicon glyphicon-thumbs-up"></span> I show up when your checkbox is checked.
        </div>
      </div>
      <div>
        Hide:
        <div class="check-element animate-hide" ng-hide="checked">
          <span class="glyphicon glyphicon-thumbs-down"></span> I hide when your checkbox is checked.
        </div>
      </div>
    </file>
    <file name="glyphicons.css">
      @import url(../../components/bootstrap-3.1.1/css/bootstrap.css);
    </file>
    <file name="animations.css">
      .animate-hide {
        transition: all linear 0.5s;
        line-height: 20px;
        opacity: 1;
        padding: 10px;
        border: 1px solid black;
        background: white;
      }

      .animate-hide.ng-hide {
        line-height: 0;
        opacity: 0;
        padding: 0 10px;
      }

      .check-element {
        padding: 10px;
        border: 1px solid black;
        background: white;
      }
    </file>
    <file name="protractor.js" type="protractor">
      var thumbsUp = element(by.css('span.glyphicon-thumbs-up'));
      var thumbsDown = element(by.css('span.glyphicon-thumbs-down'));

      it('should check ng-show / ng-hide', function() {
        expect(thumbsUp.isDisplayed()).toBeFalsy();
        expect(thumbsDown.isDisplayed()).toBeTruthy();

        element(by.model('checked')).click();

        expect(thumbsUp.isDisplayed()).toBeTruthy();
        expect(thumbsDown.isDisplayed()).toBeFalsy();
      });
    </file>
  </example>
 */
var ngHideDirective = ['$animate', function($animate) {
  return {
    restrict: 'A',
    multiElement: true,
    link: function(scope, element, attr) {
      scope.$watch(attr.ngHide, function ngHideWatchAction(value) {
        // The comment inside of the ngShowDirective explains why we add and
        // remove a temporary class for the show/hide animation
        $animate[value ? 'addClass' : 'removeClass'](element,NG_HIDE_CLASS, {
          tempClasses: NG_HIDE_IN_PROGRESS_CLASS
        });
      });
    }
  };
}];

/**
 * @ngdoc directive
 * @name ngStyle
 * @restrict AC
 *
 * @description
 * The `ngStyle` directive allows you to set CSS style on an HTML element conditionally.
 *
 * @knownIssue
 * You should not use {@link guide/interpolation interpolation} in the value of the `style`
 * attribute, when using the `ngStyle` directive on the same element.
 * See {@link guide/interpolation#known-issues here} for more info.
 *
 * @element ANY
 * @param {expression} ngStyle
 *
 * {@link guide/expression Expression} which evals to an
 * object whose keys are CSS style names and values are corresponding values for those CSS
 * keys.
 *
 * Since some CSS style names are not valid keys for an object, they must be quoted.
 * See the 'background-color' style in the example below.
 *
 * @example
   <example>
     <file name="index.html">
        <input type="button" value="set color" ng-click="myStyle={color:'red'}">
        <input type="button" value="set background" ng-click="myStyle={'background-color':'blue'}">
        <input type="button" value="clear" ng-click="myStyle={}">
        <br/>
        <span ng-style="myStyle">Sample Text</span>
        <pre>myStyle={{myStyle}}</pre>
     </file>
     <file name="style.css">
       span {
         color: black;
       }
     </file>
     <file name="protractor.js" type="protractor">
       var colorSpan = element(by.css('span'));

       it('should check ng-style', function() {
         expect(colorSpan.getCssValue('color')).toBe('rgba(0, 0, 0, 1)');
         element(by.css('input[value=\'set color\']')).click();
         expect(colorSpan.getCssValue('color')).toBe('rgba(255, 0, 0, 1)');
         element(by.css('input[value=clear]')).click();
         expect(colorSpan.getCssValue('color')).toBe('rgba(0, 0, 0, 1)');
       });
     </file>
   </example>
 */
var ngStyleDirective = ngDirective(function(scope, element, attr) {
  scope.$watch(attr.ngStyle, function ngStyleWatchAction(newStyles, oldStyles) {
    if (oldStyles && (newStyles !== oldStyles)) {
      forEach(oldStyles, function(val, style) { element.css(style, '');});
    }
    if (newStyles) element.css(newStyles);
  }, true);
});

/**
 * @ngdoc directive
 * @name ngSwitch
 * @restrict EA
 *
 * @description
 * The `ngSwitch` directive is used to conditionally swap DOM structure on your template based on a scope expression.
 * Elements within `ngSwitch` but without `ngSwitchWhen` or `ngSwitchDefault` directives will be preserved at the location
 * as specified in the template.
 *
 * The directive itself works similar to ngInclude, however, instead of downloading template code (or loading it
 * from the template cache), `ngSwitch` simply chooses one of the nested elements and makes it visible based on which element
 * matches the value obtained from the evaluated expression. In other words, you define a container element
 * (where you place the directive), place an expression on the **`on="..."` attribute**
 * (or the **`ng-switch="..."` attribute**), define any inner elements inside of the directive and place
 * a when attribute per element. The when attribute is used to inform ngSwitch which element to display when the on
 * expression is evaluated. If a matching expression is not found via a when attribute then an element with the default
 * attribute is displayed.
 *
 * <div class="alert alert-info">
 * Be aware that the attribute values to match against cannot be expressions. They are interpreted
 * as literal string values to match against.
 * For example, **`ng-switch-when="someVal"`** will match against the string `"someVal"` not against the
 * value of the expression `$scope.someVal`.
 * </div>

 * @animations
 * | Animation                        | Occurs                              |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#enter enter}  | after the ngSwitch contents change and the matched child element is placed inside the container |
 * | {@link ng.$animate#leave leave}  | after the ngSwitch contents change and just before the former contents are removed from the DOM |
 *
 * @usage
 *
 * ```
 * <ANY ng-switch="expression">
 *   <ANY ng-switch-when="matchValue1">...</ANY>
 *   <ANY ng-switch-when="matchValue2">...</ANY>
 *   <ANY ng-switch-default>...</ANY>
 * </ANY>
 * ```
 *
 *
 * @scope
 * @priority 1200
 * @param {*} ngSwitch|on expression to match against <code>ng-switch-when</code>.
 * On child elements add:
 *
 * * `ngSwitchWhen`: the case statement to match against. If match then this
 *   case will be displayed. If the same match appears multiple times, all the
 *   elements will be displayed.
 * * `ngSwitchDefault`: the default case when no other case match. If there
 *   are multiple default cases, all of them will be displayed when no other
 *   case match.
 *
 *
 * @example
  <example module="switchExample" deps="angular-animate.js" animations="true">
    <file name="index.html">
      <div ng-controller="ExampleController">
        <select ng-model="selection" ng-options="item for item in items">
        </select>
        <code>selection={{selection}}</code>
        <hr/>
        <div class="animate-switch-container"
          ng-switch on="selection">
            <div class="animate-switch" ng-switch-when="settings">Settings Div</div>
            <div class="animate-switch" ng-switch-when="home">Home Span</div>
            <div class="animate-switch" ng-switch-default>default</div>
        </div>
      </div>
    </file>
    <file name="script.js">
      angular.module('switchExample', ['ngAnimate'])
        .controller('ExampleController', ['$scope', function($scope) {
          $scope.items = ['settings', 'home', 'other'];
          $scope.selection = $scope.items[0];
        }]);
    </file>
    <file name="animations.css">
      .animate-switch-container {
        position:relative;
        background:white;
        border:1px solid black;
        height:40px;
        overflow:hidden;
      }

      .animate-switch {
        padding:10px;
      }

      .animate-switch.ng-animate {
        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;

        position:absolute;
        top:0;
        left:0;
        right:0;
        bottom:0;
      }

      .animate-switch.ng-leave.ng-leave-active,
      .animate-switch.ng-enter {
        top:-50px;
      }
      .animate-switch.ng-leave,
      .animate-switch.ng-enter.ng-enter-active {
        top:0;
      }
    </file>
    <file name="protractor.js" type="protractor">
      var switchElem = element(by.css('[ng-switch]'));
      var select = element(by.model('selection'));

      it('should start in settings', function() {
        expect(switchElem.getText()).toMatch(/Settings Div/);
      });
      it('should change to home', function() {
        select.all(by.css('option')).get(1).click();
        expect(switchElem.getText()).toMatch(/Home Span/);
      });
      it('should select default', function() {
        select.all(by.css('option')).get(2).click();
        expect(switchElem.getText()).toMatch(/default/);
      });
    </file>
  </example>
 */
var ngSwitchDirective = ['$animate', '$compile', function($animate, $compile) {
  return {
    require: 'ngSwitch',

    // asks for $scope to fool the BC controller module
    controller: ['$scope', function ngSwitchController() {
     this.cases = {};
    }],
    link: function(scope, element, attr, ngSwitchController) {
      var watchExpr = attr.ngSwitch || attr.on,
          selectedTranscludes = [],
          selectedElements = [],
          previousLeaveAnimations = [],
          selectedScopes = [];

      var spliceFactory = function(array, index) {
          return function() { array.splice(index, 1); };
      };

      scope.$watch(watchExpr, function ngSwitchWatchAction(value) {
        var i, ii;
        for (i = 0, ii = previousLeaveAnimations.length; i < ii; ++i) {
          $animate.cancel(previousLeaveAnimations[i]);
        }
        previousLeaveAnimations.length = 0;

        for (i = 0, ii = selectedScopes.length; i < ii; ++i) {
          var selected = getBlockNodes(selectedElements[i].clone);
          selectedScopes[i].$destroy();
          var promise = previousLeaveAnimations[i] = $animate.leave(selected);
          promise.then(spliceFactory(previousLeaveAnimations, i));
        }

        selectedElements.length = 0;
        selectedScopes.length = 0;

        if ((selectedTranscludes = ngSwitchController.cases['!' + value] || ngSwitchController.cases['?'])) {
          forEach(selectedTranscludes, function(selectedTransclude) {
            selectedTransclude.transclude(function(caseElement, selectedScope) {
              selectedScopes.push(selectedScope);
              var anchor = selectedTransclude.element;
              caseElement[caseElement.length++] = $compile.$$createComment('end ngSwitchWhen');
              var block = { clone: caseElement };

              selectedElements.push(block);
              $animate.enter(caseElement, anchor.parent(), anchor);
            });
          });
        }
      });
    }
  };
}];

var ngSwitchWhenDirective = ngDirective({
  transclude: 'element',
  priority: 1200,
  require: '^ngSwitch',
  multiElement: true,
  link: function(scope, element, attrs, ctrl, $transclude) {
    ctrl.cases['!' + attrs.ngSwitchWhen] = (ctrl.cases['!' + attrs.ngSwitchWhen] || []);
    ctrl.cases['!' + attrs.ngSwitchWhen].push({ transclude: $transclude, element: element });
  }
});

var ngSwitchDefaultDirective = ngDirective({
  transclude: 'element',
  priority: 1200,
  require: '^ngSwitch',
  multiElement: true,
  link: function(scope, element, attr, ctrl, $transclude) {
    ctrl.cases['?'] = (ctrl.cases['?'] || []);
    ctrl.cases['?'].push({ transclude: $transclude, element: element });
   }
});

/**
 * @ngdoc directive
 * @name ngTransclude
 * @restrict EAC
 *
 * @description
 * Directive that marks the insertion point for the transcluded DOM of the nearest parent directive that uses transclusion.
 *
 * You can specify that you want to insert a named transclusion slot, instead of the default slot, by providing the slot name
 * as the value of the `ng-transclude` or `ng-transclude-slot` attribute.
 *
 * If the transcluded content is not empty (i.e. contains one or more DOM nodes, including whitespace text nodes), any existing
 * content of this element will be removed before the transcluded content is inserted.
 * If the transcluded content is empty, the existing content is left intact. This lets you provide fallback content in the case
 * that no transcluded content is provided.
 *
 * @element ANY
 *
 * @param {string} ngTransclude|ngTranscludeSlot the name of the slot to insert at this point. If this is not provided, is empty
 *                                               or its value is the same as the name of the attribute then the default slot is used.
 *
 * @example
 * ### Basic transclusion
 * This example demonstrates basic transclusion of content into a component directive.
 * <example name="simpleTranscludeExample" module="transcludeExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('transcludeExample', [])
 *        .directive('pane', function(){
 *           return {
 *             restrict: 'E',
 *             transclude: true,
 *             scope: { title:'@' },
 *             template: '<div style="border: 1px solid black;">' +
 *                         '<div style="background-color: gray">{{title}}</div>' +
 *                         '<ng-transclude></ng-transclude>' +
 *                       '</div>'
 *           };
 *       })
 *       .controller('ExampleController', ['$scope', function($scope) {
 *         $scope.title = 'Lorem Ipsum';
 *         $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
 *       }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <input ng-model="title" aria-label="title"> <br/>
 *       <textarea ng-model="text" aria-label="text"></textarea> <br/>
 *       <pane title="{{title}}">{{text}}</pane>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *      it('should have transcluded', function() {
 *        var titleElement = element(by.model('title'));
 *        titleElement.clear();
 *        titleElement.sendKeys('TITLE');
 *        var textElement = element(by.model('text'));
 *        textElement.clear();
 *        textElement.sendKeys('TEXT');
 *        expect(element(by.binding('title')).getText()).toEqual('TITLE');
 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
 *      });
 *   </file>
 * </example>
 *
 * @example
 * ### Transclude fallback content
 * This example shows how to use `NgTransclude` with fallback content, that
 * is displayed if no transcluded content is provided.
 *
 * <example module="transcludeFallbackContentExample">
 * <file name="index.html">
 * <script>
 * angular.module('transcludeFallbackContentExample', [])
 * .directive('myButton', function(){
 *             return {
 *               restrict: 'E',
 *               transclude: true,
 *               scope: true,
 *               template: '<button style="cursor: pointer;">' +
 *                           '<ng-transclude>' +
 *                             '<b style="color: red;">Button1</b>' +
 *                           '</ng-transclude>' +
 *                         '</button>'
 *             };
 *         });
 * </script>
 * <!-- fallback button content -->
 * <my-button id="fallback"></my-button>
 * <!-- modified button content -->
 * <my-button id="modified">
 *   <i style="color: green;">Button2</i>
 * </my-button>
 * </file>
 * <file name="protractor.js" type="protractor">
 * it('should have different transclude element content', function() {
 *          expect(element(by.id('fallback')).getText()).toBe('Button1');
 *          expect(element(by.id('modified')).getText()).toBe('Button2');
 *        });
 * </file>
 * </example>
 *
 * @example
 * ### Multi-slot transclusion
 * This example demonstrates using multi-slot transclusion in a component directive.
 * <example name="multiSlotTranscludeExample" module="multiSlotTranscludeExample">
 *   <file name="index.html">
 *    <style>
 *      .title, .footer {
 *        background-color: gray
 *      }
 *    </style>
 *    <div ng-controller="ExampleController">
 *      <input ng-model="title" aria-label="title"> <br/>
 *      <textarea ng-model="text" aria-label="text"></textarea> <br/>
 *      <pane>
 *        <pane-title><a ng-href="{{link}}">{{title}}</a></pane-title>
 *        <pane-body><p>{{text}}</p></pane-body>
 *      </pane>
 *    </div>
 *   </file>
 *   <file name="app.js">
 *    angular.module('multiSlotTranscludeExample', [])
 *     .directive('pane', function(){
 *        return {
 *          restrict: 'E',
 *          transclude: {
 *            'title': '?paneTitle',
 *            'body': 'paneBody',
 *            'footer': '?paneFooter'
 *          },
 *          template: '<div style="border: 1px solid black;">' +
 *                      '<div class="title" ng-transclude="title">Fallback Title</div>' +
 *                      '<div ng-transclude="body"></div>' +
 *                      '<div class="footer" ng-transclude="footer">Fallback Footer</div>' +
 *                    '</div>'
 *        };
 *    })
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.title = 'Lorem Ipsum';
 *      $scope.link = "https://google.com";
 *      $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
 *    }]);
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *      it('should have transcluded the title and the body', function() {
 *        var titleElement = element(by.model('title'));
 *        titleElement.clear();
 *        titleElement.sendKeys('TITLE');
 *        var textElement = element(by.model('text'));
 *        textElement.clear();
 *        textElement.sendKeys('TEXT');
 *        expect(element(by.css('.title')).getText()).toEqual('TITLE');
 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
 *        expect(element(by.css('.footer')).getText()).toEqual('Fallback Footer');
 *      });
 *   </file>
 * </example>
 */
var ngTranscludeMinErr = minErr('ngTransclude');
var ngTranscludeDirective = ['$compile', function($compile) {
  return {
    restrict: 'EAC',
    terminal: true,
    compile: function ngTranscludeCompile(tElement) {

      // Remove and cache any original content to act as a fallback
      var fallbackLinkFn = $compile(tElement.contents());
      tElement.empty();

      return function ngTranscludePostLink($scope, $element, $attrs, controller, $transclude) {

        if (!$transclude) {
          throw ngTranscludeMinErr('orphan',
          'Illegal use of ngTransclude directive in the template! ' +
          'No parent directive that requires a transclusion found. ' +
          'Element: {0}',
          startingTag($element));
        }


        // If the attribute is of the form: `ng-transclude="ng-transclude"` then treat it like the default
        if ($attrs.ngTransclude === $attrs.$attr.ngTransclude) {
          $attrs.ngTransclude = '';
        }
        var slotName = $attrs.ngTransclude || $attrs.ngTranscludeSlot;

        // If the slot is required and no transclusion content is provided then this call will throw an error
        $transclude(ngTranscludeCloneAttachFn, null, slotName);

        // If the slot is optional and no transclusion content is provided then use the fallback content
        if (slotName && !$transclude.isSlotFilled(slotName)) {
          useFallbackContent();
        }

        function ngTranscludeCloneAttachFn(clone, transcludedScope) {
          if (clone.length) {
            $element.append(clone);
          } else {
            useFallbackContent();
            // There is nothing linked against the transcluded scope since no content was available,
            // so it should be safe to clean up the generated scope.
            transcludedScope.$destroy();
          }
        }

        function useFallbackContent() {
          // Since this is the fallback content rather than the transcluded content,
          // we link against the scope of this directive rather than the transcluded scope
          fallbackLinkFn($scope, function(clone) {
            $element.append(clone);
          });
        }
      };
    }
  };
}];

/**
 * @ngdoc directive
 * @name script
 * @restrict E
 *
 * @description
 * Load the content of a `<script>` element into {@link ng.$templateCache `$templateCache`}, so that the
 * template can be used by {@link ng.directive:ngInclude `ngInclude`},
 * {@link ngRoute.directive:ngView `ngView`}, or {@link guide/directive directives}. The type of the
 * `<script>` element must be specified as `text/ng-template`, and a cache name for the template must be
 * assigned through the element's `id`, which can then be used as a directive's `templateUrl`.
 *
 * @param {string} type Must be set to `'text/ng-template'`.
 * @param {string} id Cache name of the template.
 *
 * @example
  <example>
    <file name="index.html">
      <script type="text/ng-template" id="/tpl.html">
        Content of the template.
      </script>

      <a ng-click="currentTpl='/tpl.html'" id="tpl-link">Load inlined template</a>
      <div id="tpl-content" ng-include src="currentTpl"></div>
    </file>
    <file name="protractor.js" type="protractor">
      it('should load template defined inside script tag', function() {
        element(by.css('#tpl-link')).click();
        expect(element(by.css('#tpl-content')).getText()).toMatch(/Content of the template/);
      });
    </file>
  </example>
 */
var scriptDirective = ['$templateCache', function($templateCache) {
  return {
    restrict: 'E',
    terminal: true,
    compile: function(element, attr) {
      if (attr.type == 'text/ng-template') {
        var templateUrl = attr.id,
            text = element[0].text;

        $templateCache.put(templateUrl, text);
      }
    }
  };
}];

var noopNgModelController = { $setViewValue: noop, $render: noop };

function chromeHack(optionElement) {
  // Workaround for https://code.google.com/p/chromium/issues/detail?id=381459
  // Adding an <option selected="selected"> element to a <select required="required"> should
  // automatically select the new element
  if (optionElement[0].hasAttribute('selected')) {
    optionElement[0].selected = true;
  }
}

/**
 * @ngdoc type
 * @name  select.SelectController
 * @description
 * The controller for the `<select>` directive. This provides support for reading
 * and writing the selected value(s) of the control and also coordinates dynamically
 * added `<option>` elements, perhaps by an `ngRepeat` directive.
 */
var SelectController =
        ['$element', '$scope', function($element, $scope) {

  var self = this,
      optionsMap = new HashMap();

  // If the ngModel doesn't get provided then provide a dummy noop version to prevent errors
  self.ngModelCtrl = noopNgModelController;

  // The "unknown" option is one that is prepended to the list if the viewValue
  // does not match any of the options. When it is rendered the value of the unknown
  // option is '? XXX ?' where XXX is the hashKey of the value that is not known.
  //
  // We can't just jqLite('<option>') since jqLite is not smart enough
  // to create it in <select> and IE barfs otherwise.
  self.unknownOption = jqLite(window.document.createElement('option'));
  self.renderUnknownOption = function(val) {
    var unknownVal = '? ' + hashKey(val) + ' ?';
    self.unknownOption.val(unknownVal);
    $element.prepend(self.unknownOption);
    $element.val(unknownVal);
  };

  $scope.$on('$destroy', function() {
    // disable unknown option so that we don't do work when the whole select is being destroyed
    self.renderUnknownOption = noop;
  });

  self.removeUnknownOption = function() {
    if (self.unknownOption.parent()) self.unknownOption.remove();
  };


  // Read the value of the select control, the implementation of this changes depending
  // upon whether the select can have multiple values and whether ngOptions is at work.
  self.readValue = function readSingleValue() {
    self.removeUnknownOption();
    return $element.val();
  };


  // Write the value to the select control, the implementation of this changes depending
  // upon whether the select can have multiple values and whether ngOptions is at work.
  self.writeValue = function writeSingleValue(value) {
    if (self.hasOption(value)) {
      self.removeUnknownOption();
      $element.val(value);
      if (value === '') self.emptyOption.prop('selected', true); // to make IE9 happy
    } else {
      if (value == null && self.emptyOption) {
        self.removeUnknownOption();
        $element.val('');
      } else {
        self.renderUnknownOption(value);
      }
    }
  };


  // Tell the select control that an option, with the given value, has been added
  self.addOption = function(value, element) {
    // Skip comment nodes, as they only pollute the `optionsMap`
    if (element[0].nodeType === NODE_TYPE_COMMENT) return;

    assertNotHasOwnProperty(value, '"option value"');
    if (value === '') {
      self.emptyOption = element;
    }
    var count = optionsMap.get(value) || 0;
    optionsMap.put(value, count + 1);
    self.ngModelCtrl.$render();
    chromeHack(element);
  };

  // Tell the select control that an option, with the given value, has been removed
  self.removeOption = function(value) {
    var count = optionsMap.get(value);
    if (count) {
      if (count === 1) {
        optionsMap.remove(value);
        if (value === '') {
          self.emptyOption = undefined;
        }
      } else {
        optionsMap.put(value, count - 1);
      }
    }
  };

  // Check whether the select control has an option matching the given value
  self.hasOption = function(value) {
    return !!optionsMap.get(value);
  };


  self.registerOption = function(optionScope, optionElement, optionAttrs, interpolateValueFn, interpolateTextFn) {

    if (interpolateValueFn) {
      // The value attribute is interpolated
      var oldVal;
      optionAttrs.$observe('value', function valueAttributeObserveAction(newVal) {
        if (isDefined(oldVal)) {
          self.removeOption(oldVal);
        }
        oldVal = newVal;
        self.addOption(newVal, optionElement);
      });
    } else if (interpolateTextFn) {
      // The text content is interpolated
      optionScope.$watch(interpolateTextFn, function interpolateWatchAction(newVal, oldVal) {
        optionAttrs.$set('value', newVal);
        if (oldVal !== newVal) {
          self.removeOption(oldVal);
        }
        self.addOption(newVal, optionElement);
      });
    } else {
      // The value attribute is static
      self.addOption(optionAttrs.value, optionElement);
    }

    optionElement.on('$destroy', function() {
      self.removeOption(optionAttrs.value);
      self.ngModelCtrl.$render();
    });
  };
}];

/**
 * @ngdoc directive
 * @name select
 * @restrict E
 *
 * @description
 * HTML `SELECT` element with angular data-binding.
 *
 * The `select` directive is used together with {@link ngModel `ngModel`} to provide data-binding
 * between the scope and the `<select>` control (including setting default values).
 * It also handles dynamic `<option>` elements, which can be added using the {@link ngRepeat `ngRepeat}` or
 * {@link ngOptions `ngOptions`} directives.
 *
 * When an item in the `<select>` menu is selected, the value of the selected option will be bound
 * to the model identified by the `ngModel` directive. With static or repeated options, this is
 * the content of the `value` attribute or the textContent of the `<option>`, if the value attribute is missing.
 * If you want dynamic value attributes, you can use interpolation inside the value attribute.
 *
 * <div class="alert alert-warning">
 * Note that the value of a `select` directive used without `ngOptions` is always a string.
 * When the model needs to be bound to a non-string value, you must either explicitly convert it
 * using a directive (see example below) or use `ngOptions` to specify the set of options.
 * This is because an option element can only be bound to string values at present.
 * </div>
 *
 * If the viewValue of `ngModel` does not match any of the options, then the control
 * will automatically add an "unknown" option, which it then removes when the mismatch is resolved.
 *
 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
 * option. See example below for demonstration.
 *
 * <div class="alert alert-info">
 * In many cases, `ngRepeat` can be used on `<option>` elements instead of {@link ng.directive:ngOptions
 * ngOptions} to achieve a similar result. However, `ngOptions` provides some benefits, such as
 * more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
 * comprehension expression, and additionally in reducing memory and increasing speed by not creating
 * a new scope for each repeated instance.
 * </div>
 *
 *
 * @param {string} ngModel Assignable angular expression to data-bind to.
 * @param {string=} name Property name of the form under which the control is published.
 * @param {string=} multiple Allows multiple options to be selected. The selected values will be
 *     bound to the model as an array.
 * @param {string=} required Sets `required` validation error key if the value is not entered.
 * @param {string=} ngRequired Adds required attribute and required validation constraint to
 * the element when the ngRequired expression evaluates to true. Use ngRequired instead of required
 * when you want to data-bind to the required attribute.
 * @param {string=} ngChange Angular expression to be executed when selected option(s) changes due to user
 *    interaction with the select element.
 * @param {string=} ngOptions sets the options that the select is populated with and defines what is
 * set on the model on selection. See {@link ngOptions `ngOptions`}.
 *
 * @example
 * ### Simple `select` elements with static options
 *
 * <example name="static-select" module="staticSelect">
 * <file name="index.html">
 * <div ng-controller="ExampleController">
 *   <form name="myForm">
 *     <label for="singleSelect"> Single select: </label><br>
 *     <select name="singleSelect" ng-model="data.singleSelect">
 *       <option value="option-1">Option 1</option>
 *       <option value="option-2">Option 2</option>
 *     </select><br>
 *
 *     <label for="singleSelect"> Single select with "not selected" option and dynamic option values: </label><br>
 *     <select name="singleSelect" id="singleSelect" ng-model="data.singleSelect">
 *       <option value="">---Please select---</option> <!-- not selected / blank option -->
 *       <option value="{{data.option1}}">Option 1</option> <!-- interpolation -->
 *       <option value="option-2">Option 2</option>
 *     </select><br>
 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
 *     <tt>singleSelect = {{data.singleSelect}}</tt>
 *
 *     <hr>
 *     <label for="multipleSelect"> Multiple select: </label><br>
 *     <select name="multipleSelect" id="multipleSelect" ng-model="data.multipleSelect" multiple>
 *       <option value="option-1">Option 1</option>
 *       <option value="option-2">Option 2</option>
 *       <option value="option-3">Option 3</option>
 *     </select><br>
 *     <tt>multipleSelect = {{data.multipleSelect}}</tt><br/>
 *   </form>
 * </div>
 * </file>
 * <file name="app.js">
 *  angular.module('staticSelect', [])
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.data = {
 *       singleSelect: null,
 *       multipleSelect: [],
 *       option1: 'option-1',
 *      };
 *
 *      $scope.forceUnknownOption = function() {
 *        $scope.data.singleSelect = 'nonsense';
 *      };
 *   }]);
 * </file>
 *</example>
 *
 * ### Using `ngRepeat` to generate `select` options
 * <example name="ngrepeat-select" module="ngrepeatSelect">
 * <file name="index.html">
 * <div ng-controller="ExampleController">
 *   <form name="myForm">
 *     <label for="repeatSelect"> Repeat select: </label>
 *     <select name="repeatSelect" id="repeatSelect" ng-model="data.repeatSelect">
 *       <option ng-repeat="option in data.availableOptions" value="{{option.id}}">{{option.name}}</option>
 *     </select>
 *   </form>
 *   <hr>
 *   <tt>repeatSelect = {{data.repeatSelect}}</tt><br/>
 * </div>
 * </file>
 * <file name="app.js">
 *  angular.module('ngrepeatSelect', [])
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.data = {
 *       repeatSelect: null,
 *       availableOptions: [
 *         {id: '1', name: 'Option A'},
 *         {id: '2', name: 'Option B'},
 *         {id: '3', name: 'Option C'}
 *       ],
 *      };
 *   }]);
 * </file>
 *</example>
 *
 *
 * ### Using `select` with `ngOptions` and setting a default value
 * See the {@link ngOptions ngOptions documentation} for more `ngOptions` usage examples.
 *
 * <example name="select-with-default-values" module="defaultValueSelect">
 * <file name="index.html">
 * <div ng-controller="ExampleController">
 *   <form name="myForm">
 *     <label for="mySelect">Make a choice:</label>
 *     <select name="mySelect" id="mySelect"
 *       ng-options="option.name for option in data.availableOptions track by option.id"
 *       ng-model="data.selectedOption"></select>
 *   </form>
 *   <hr>
 *   <tt>option = {{data.selectedOption}}</tt><br/>
 * </div>
 * </file>
 * <file name="app.js">
 *  angular.module('defaultValueSelect', [])
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.data = {
 *       availableOptions: [
 *         {id: '1', name: 'Option A'},
 *         {id: '2', name: 'Option B'},
 *         {id: '3', name: 'Option C'}
 *       ],
 *       selectedOption: {id: '3', name: 'Option C'} //This sets the default value of the select in the ui
 *       };
 *   }]);
 * </file>
 *</example>
 *
 *
 * ### Binding `select` to a non-string value via `ngModel` parsing / formatting
 *
 * <example name="select-with-non-string-options" module="nonStringSelect">
 *   <file name="index.html">
 *     <select ng-model="model.id" convert-to-number>
 *       <option value="0">Zero</option>
 *       <option value="1">One</option>
 *       <option value="2">Two</option>
 *     </select>
 *     {{ model }}
 *   </file>
 *   <file name="app.js">
 *     angular.module('nonStringSelect', [])
 *       .run(function($rootScope) {
 *         $rootScope.model = { id: 2 };
 *       })
 *       .directive('convertToNumber', function() {
 *         return {
 *           require: 'ngModel',
 *           link: function(scope, element, attrs, ngModel) {
 *             ngModel.$parsers.push(function(val) {
 *               return parseInt(val, 10);
 *             });
 *             ngModel.$formatters.push(function(val) {
 *               return '' + val;
 *             });
 *           }
 *         };
 *       });
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     it('should initialize to model', function() {
 *       var select = element(by.css('select'));
 *       expect(element(by.model('model.id')).$('option:checked').getText()).toEqual('Two');
 *     });
 *   </file>
 * </example>
 *
 */
var selectDirective = function() {

  return {
    restrict: 'E',
    require: ['select', '?ngModel'],
    controller: SelectController,
    priority: 1,
    link: {
      pre: selectPreLink,
      post: selectPostLink
    }
  };

  function selectPreLink(scope, element, attr, ctrls) {

      // if ngModel is not defined, we don't need to do anything
      var ngModelCtrl = ctrls[1];
      if (!ngModelCtrl) return;

      var selectCtrl = ctrls[0];

      selectCtrl.ngModelCtrl = ngModelCtrl;

      // When the selected item(s) changes we delegate getting the value of the select control
      // to the `readValue` method, which can be changed if the select can have multiple
      // selected values or if the options are being generated by `ngOptions`
      element.on('change', function() {
        scope.$apply(function() {
          ngModelCtrl.$setViewValue(selectCtrl.readValue());
        });
      });

      // If the select allows multiple values then we need to modify how we read and write
      // values from and to the control; also what it means for the value to be empty and
      // we have to add an extra watch since ngModel doesn't work well with arrays - it
      // doesn't trigger rendering if only an item in the array changes.
      if (attr.multiple) {

        // Read value now needs to check each option to see if it is selected
        selectCtrl.readValue = function readMultipleValue() {
          var array = [];
          forEach(element.find('option'), function(option) {
            if (option.selected) {
              array.push(option.value);
            }
          });
          return array;
        };

        // Write value now needs to set the selected property of each matching option
        selectCtrl.writeValue = function writeMultipleValue(value) {
          var items = new HashMap(value);
          forEach(element.find('option'), function(option) {
            option.selected = isDefined(items.get(option.value));
          });
        };

        // we have to do it on each watch since ngModel watches reference, but
        // we need to work of an array, so we need to see if anything was inserted/removed
        var lastView, lastViewRef = NaN;
        scope.$watch(function selectMultipleWatch() {
          if (lastViewRef === ngModelCtrl.$viewValue && !equals(lastView, ngModelCtrl.$viewValue)) {
            lastView = shallowCopy(ngModelCtrl.$viewValue);
            ngModelCtrl.$render();
          }
          lastViewRef = ngModelCtrl.$viewValue;
        });

        // If we are a multiple select then value is now a collection
        // so the meaning of $isEmpty changes
        ngModelCtrl.$isEmpty = function(value) {
          return !value || value.length === 0;
        };

      }
    }

    function selectPostLink(scope, element, attrs, ctrls) {
      // if ngModel is not defined, we don't need to do anything
      var ngModelCtrl = ctrls[1];
      if (!ngModelCtrl) return;

      var selectCtrl = ctrls[0];

      // We delegate rendering to the `writeValue` method, which can be changed
      // if the select can have multiple selected values or if the options are being
      // generated by `ngOptions`.
      // This must be done in the postLink fn to prevent $render to be called before
      // all nodes have been linked correctly.
      ngModelCtrl.$render = function() {
        selectCtrl.writeValue(ngModelCtrl.$viewValue);
      };
    }
};


// The option directive is purely designed to communicate the existence (or lack of)
// of dynamically created (and destroyed) option elements to their containing select
// directive via its controller.
var optionDirective = ['$interpolate', function($interpolate) {
  return {
    restrict: 'E',
    priority: 100,
    compile: function(element, attr) {
      if (isDefined(attr.value)) {
        // If the value attribute is defined, check if it contains an interpolation
        var interpolateValueFn = $interpolate(attr.value, true);
      } else {
        // If the value attribute is not defined then we fall back to the
        // text content of the option element, which may be interpolated
        var interpolateTextFn = $interpolate(element.text(), true);
        if (!interpolateTextFn) {
          attr.$set('value', element.text());
        }
      }

      return function(scope, element, attr) {
        // This is an optimization over using ^^ since we don't want to have to search
        // all the way to the root of the DOM for every single option element
        var selectCtrlName = '$selectController',
            parent = element.parent(),
            selectCtrl = parent.data(selectCtrlName) ||
              parent.parent().data(selectCtrlName); // in case we are in optgroup

        if (selectCtrl) {
          selectCtrl.registerOption(scope, element, attr, interpolateValueFn, interpolateTextFn);
        }
      };
    }
  };
}];

var styleDirective = valueFn({
  restrict: 'E',
  terminal: false
});

/**
 * @ngdoc directive
 * @name ngRequired
 * @restrict A
 *
 * @description
 *
 * ngRequired adds the required {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
 * It is most often used for {@link input `input`} and {@link select `select`} controls, but can also be
 * applied to custom controls.
 *
 * The directive sets the `required` attribute on the element if the Angular expression inside
 * `ngRequired` evaluates to true. A special directive for setting `required` is necessary because we
 * cannot use interpolation inside `required`. See the {@link guide/interpolation interpolation guide}
 * for more info.
 *
 * The validator will set the `required` error key to true if the `required` attribute is set and
 * calling {@link ngModel.NgModelController#$isEmpty `NgModelController.$isEmpty`} with the
 * {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`} returns `true`. For example, the
 * `$isEmpty()` implementation for `input[text]` checks the length of the `$viewValue`. When developing
 * custom controls, `$isEmpty()` can be overwritten to account for a $viewValue that is not string-based.
 *
 * @example
 * <example name="ngRequiredDirective" module="ngRequiredExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('ngRequiredExample', [])
 *         .controller('ExampleController', ['$scope', function($scope) {
 *           $scope.required = true;
 *         }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <form name="form">
 *         <label for="required">Toggle required: </label>
 *         <input type="checkbox" ng-model="required" id="required" />
 *         <br>
 *         <label for="input">This input must be filled if `required` is true: </label>
 *         <input type="text" ng-model="model" id="input" name="input" ng-required="required" /><br>
 *         <hr>
 *         required error set? = <code>{{form.input.$error.required}}</code><br>
 *         model = <code>{{model}}</code>
 *       </form>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
       var required = element(by.binding('form.input.$error.required'));
       var model = element(by.binding('model'));
       var input = element(by.id('input'));

       it('should set the required error', function() {
         expect(required.getText()).toContain('true');

         input.sendKeys('123');
         expect(required.getText()).not.toContain('true');
         expect(model.getText()).toContain('123');
       });
 *   </file>
 * </example>
 */
var requiredDirective = function() {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: function(scope, elm, attr, ctrl) {
      if (!ctrl) return;
      attr.required = true; // force truthy in case we are on non input element

      ctrl.$validators.required = function(modelValue, viewValue) {
        return !attr.required || !ctrl.$isEmpty(viewValue);
      };

      attr.$observe('required', function() {
        ctrl.$validate();
      });
    }
  };
};

/**
 * @ngdoc directive
 * @name ngPattern
 *
 * @description
 *
 * ngPattern adds the pattern {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
 *
 * The validator sets the `pattern` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
 * does not match a RegExp which is obtained by evaluating the Angular expression given in the
 * `ngPattern` attribute value:
 * * If the expression evaluates to a RegExp object, then this is used directly.
 * * If the expression evaluates to a string, then it will be converted to a RegExp after wrapping it
 * in `^` and `$` characters. For instance, `"abc"` will be converted to `new RegExp('^abc$')`.
 *
 * <div class="alert alert-info">
 * **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
 * start at the index of the last search's match, thus not taking the whole input value into
 * account.
 * </div>
 *
 * <div class="alert alert-info">
 * **Note:** This directive is also added when the plain `pattern` attribute is used, with two
 * differences:
 * <ol>
 *   <li>
 *     `ngPattern` does not set the `pattern` attribute and therefore HTML5 constraint validation is
 *     not available.
 *   </li>
 *   <li>
 *     The `ngPattern` attribute must be an expression, while the `pattern` value must be
 *     interpolated.
 *   </li>
 * </ol>
 * </div>
 *
 * @example
 * <example name="ngPatternDirective" module="ngPatternExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('ngPatternExample', [])
 *         .controller('ExampleController', ['$scope', function($scope) {
 *           $scope.regex = '\\d+';
 *         }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <form name="form">
 *         <label for="regex">Set a pattern (regex string): </label>
 *         <input type="text" ng-model="regex" id="regex" />
 *         <br>
 *         <label for="input">This input is restricted by the current pattern: </label>
 *         <input type="text" ng-model="model" id="input" name="input" ng-pattern="regex" /><br>
 *         <hr>
 *         input valid? = <code>{{form.input.$valid}}</code><br>
 *         model = <code>{{model}}</code>
 *       </form>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
       var model = element(by.binding('model'));
       var input = element(by.id('input'));

       it('should validate the input with the default pattern', function() {
         input.sendKeys('aaa');
         expect(model.getText()).not.toContain('aaa');

         input.clear().then(function() {
           input.sendKeys('123');
           expect(model.getText()).toContain('123');
         });
       });
 *   </file>
 * </example>
 */
var patternDirective = function() {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: function(scope, elm, attr, ctrl) {
      if (!ctrl) return;

      var regexp, patternExp = attr.ngPattern || attr.pattern;
      attr.$observe('pattern', function(regex) {
        if (isString(regex) && regex.length > 0) {
          regex = new RegExp('^' + regex + '$');
        }

        if (regex && !regex.test) {
          throw minErr('ngPattern')('noregexp',
            'Expected {0} to be a RegExp but was {1}. Element: {2}', patternExp,
            regex, startingTag(elm));
        }

        regexp = regex || undefined;
        ctrl.$validate();
      });

      ctrl.$validators.pattern = function(modelValue, viewValue) {
        // HTML5 pattern constraint validates the input value, so we validate the viewValue
        return ctrl.$isEmpty(viewValue) || isUndefined(regexp) || regexp.test(viewValue);
      };
    }
  };
};

/**
 * @ngdoc directive
 * @name ngMaxlength
 *
 * @description
 *
 * ngMaxlength adds the maxlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
 *
 * The validator sets the `maxlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
 * is longer than the integer obtained by evaluating the Angular expression given in the
 * `ngMaxlength` attribute value.
 *
 * <div class="alert alert-info">
 * **Note:** This directive is also added when the plain `maxlength` attribute is used, with two
 * differences:
 * <ol>
 *   <li>
 *     `ngMaxlength` does not set the `maxlength` attribute and therefore HTML5 constraint
 *     validation is not available.
 *   </li>
 *   <li>
 *     The `ngMaxlength` attribute must be an expression, while the `maxlength` value must be
 *     interpolated.
 *   </li>
 * </ol>
 * </div>
 *
 * @example
 * <example name="ngMaxlengthDirective" module="ngMaxlengthExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('ngMaxlengthExample', [])
 *         .controller('ExampleController', ['$scope', function($scope) {
 *           $scope.maxlength = 5;
 *         }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <form name="form">
 *         <label for="maxlength">Set a maxlength: </label>
 *         <input type="number" ng-model="maxlength" id="maxlength" />
 *         <br>
 *         <label for="input">This input is restricted by the current maxlength: </label>
 *         <input type="text" ng-model="model" id="input" name="input" ng-maxlength="maxlength" /><br>
 *         <hr>
 *         input valid? = <code>{{form.input.$valid}}</code><br>
 *         model = <code>{{model}}</code>
 *       </form>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
       var model = element(by.binding('model'));
       var input = element(by.id('input'));

       it('should validate the input with the default maxlength', function() {
         input.sendKeys('abcdef');
         expect(model.getText()).not.toContain('abcdef');

         input.clear().then(function() {
           input.sendKeys('abcde');
           expect(model.getText()).toContain('abcde');
         });
       });
 *   </file>
 * </example>
 */
var maxlengthDirective = function() {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: function(scope, elm, attr, ctrl) {
      if (!ctrl) return;

      var maxlength = -1;
      attr.$observe('maxlength', function(value) {
        var intVal = toInt(value);
        maxlength = isNaN(intVal) ? -1 : intVal;
        ctrl.$validate();
      });
      ctrl.$validators.maxlength = function(modelValue, viewValue) {
        return (maxlength < 0) || ctrl.$isEmpty(viewValue) || (viewValue.length <= maxlength);
      };
    }
  };
};

/**
 * @ngdoc directive
 * @name ngMinlength
 *
 * @description
 *
 * ngMinlength adds the minlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
 *
 * The validator sets the `minlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
 * is shorter than the integer obtained by evaluating the Angular expression given in the
 * `ngMinlength` attribute value.
 *
 * <div class="alert alert-info">
 * **Note:** This directive is also added when the plain `minlength` attribute is used, with two
 * differences:
 * <ol>
 *   <li>
 *     `ngMinlength` does not set the `minlength` attribute and therefore HTML5 constraint
 *     validation is not available.
 *   </li>
 *   <li>
 *     The `ngMinlength` value must be an expression, while the `minlength` value must be
 *     interpolated.
 *   </li>
 * </ol>
 * </div>
 *
 * @example
 * <example name="ngMinlengthDirective" module="ngMinlengthExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('ngMinlengthExample', [])
 *         .controller('ExampleController', ['$scope', function($scope) {
 *           $scope.minlength = 3;
 *         }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <form name="form">
 *         <label for="minlength">Set a minlength: </label>
 *         <input type="number" ng-model="minlength" id="minlength" />
 *         <br>
 *         <label for="input">This input is restricted by the current minlength: </label>
 *         <input type="text" ng-model="model" id="input" name="input" ng-minlength="minlength" /><br>
 *         <hr>
 *         input valid? = <code>{{form.input.$valid}}</code><br>
 *         model = <code>{{model}}</code>
 *       </form>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
       var model = element(by.binding('model'));
       var input = element(by.id('input'));

       it('should validate the input with the default minlength', function() {
         input.sendKeys('ab');
         expect(model.getText()).not.toContain('ab');

         input.sendKeys('abc');
         expect(model.getText()).toContain('abc');
       });
 *   </file>
 * </example>
 */
var minlengthDirective = function() {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: function(scope, elm, attr, ctrl) {
      if (!ctrl) return;

      var minlength = 0;
      attr.$observe('minlength', function(value) {
        minlength = toInt(value) || 0;
        ctrl.$validate();
      });
      ctrl.$validators.minlength = function(modelValue, viewValue) {
        return ctrl.$isEmpty(viewValue) || viewValue.length >= minlength;
      };
    }
  };
};

if (window.angular.bootstrap) {
  //AngularJS is already loaded, so we can return here...
  if (window.console) {
    console.log('WARNING: Tried to load angular more than once.');
  }
  return;
}

//try to bind to jquery now so that one can write jqLite(document).ready()
//but we will rebind on bootstrap again.
bindJQuery();

publishExternalAPI(angular);

angular.module("ngLocale", [], ["$provide", function($provide) {
var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
function getDecimals(n) {
  n = n + '';
  var i = n.indexOf('.');
  return (i == -1) ? 0 : n.length - i - 1;
}

function getVF(n, opt_precision) {
  var v = opt_precision;

  if (undefined === v) {
    v = Math.min(getDecimals(n), 3);
  }

  var base = Math.pow(10, v);
  var f = ((n * base) | 0) % base;
  return {v: v, f: f};
}

$provide.value("$locale", {
  "DATETIME_FORMATS": {
    "AMPMS": [
      "AM",
      "PM"
    ],
    "DAY": [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ],
    "ERANAMES": [
      "Before Christ",
      "Anno Domini"
    ],
    "ERAS": [
      "BC",
      "AD"
    ],
    "FIRSTDAYOFWEEK": 6,
    "MONTH": [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    "SHORTDAY": [
      "Sun",
      "Mon",
      "Tue",
      "Wed",
      "Thu",
      "Fri",
      "Sat"
    ],
    "SHORTMONTH": [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    "STANDALONEMONTH": [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    "WEEKENDRANGE": [
      5,
      6
    ],
    "fullDate": "EEEE, MMMM d, y",
    "longDate": "MMMM d, y",
    "medium": "MMM d, y h:mm:ss a",
    "mediumDate": "MMM d, y",
    "mediumTime": "h:mm:ss a",
    "short": "M/d/yy h:mm a",
    "shortDate": "M/d/yy",
    "shortTime": "h:mm a"
  },
  "NUMBER_FORMATS": {
    "CURRENCY_SYM": "$",
    "DECIMAL_SEP": ".",
    "GROUP_SEP": ",",
    "PATTERNS": [
      {
        "gSize": 3,
        "lgSize": 3,
        "maxFrac": 3,
        "minFrac": 0,
        "minInt": 1,
        "negPre": "-",
        "negSuf": "",
        "posPre": "",
        "posSuf": ""
      },
      {
        "gSize": 3,
        "lgSize": 3,
        "maxFrac": 2,
        "minFrac": 2,
        "minInt": 1,
        "negPre": "-\u00a4",
        "negSuf": "",
        "posPre": "\u00a4",
        "posSuf": ""
      }
    ]
  },
  "id": "en-us",
  "localeID": "en_US",
  "pluralCat": function(n, opt_precision) {  var i = n | 0;  var vf = getVF(n, opt_precision);  if (i == 1 && vf.v == 0) {    return PLURAL_CATEGORY.ONE;  }  return PLURAL_CATEGORY.OTHER;}
});
}]);

  jqLite(window.document).ready(function() {
    angularInit(window.document, bootstrap);
  });

})(window);

!window.angular.$$csp().noInlineStyle && window.angular.element(document.head).prepend('<style type="text/css">@charset "UTF-8";[ng\\:cloak],[ng-cloak],[data-ng-cloak],[x-ng-cloak],.ng-cloak,.x-ng-cloak,.ng-hide:not(.ng-hide-animate){display:none !important;}ng\\:form{display:block;}.ng-animate-shim{visibility:hidden;}.ng-anchor{position:absolute;}</style>');
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
/** @module common */ /** for typedoc */
__export(__webpack_require__(8));
__export(__webpack_require__(20));
__export(__webpack_require__(104));
__export(__webpack_require__(14));
__export(__webpack_require__(13));
__export(__webpack_require__(145));
__export(__webpack_require__(48));
__export(__webpack_require__(69));
//# sourceMappingURL=index.js.map

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/** @module hooks */ /** for typedoc */
var common_1 = __webpack_require__(8);
var resolveContext_1 = __webpack_require__(107);
var hof_1 = __webpack_require__(14);
/**
 * A [[TransitionHookFn]] which resolves all EAGER Resolvables in the To Path
 *
 * Registered using `transitionService.onStart({}, eagerResolvePath);`
 *
 * When a Transition starts, this hook resolves all the EAGER Resolvables, which the transition then waits for.
 *
 * See [[StateDeclaration.resolve]]
 */
var eagerResolvePath = function (trans) {
    return new resolveContext_1.ResolveContext(trans.treeChanges().to)
        .resolvePath("EAGER", trans)
        .then(common_1.noop);
};
exports.registerEagerResolvePath = function (transitionService) {
    return transitionService.onStart({}, eagerResolvePath, { priority: 1000 });
};
/**
 * A [[TransitionHookFn]] which resolves all LAZY Resolvables for the state (and all its ancestors) in the To Path
 *
 * Registered using `transitionService.onEnter({ entering: () => true }, lazyResolveState);`
 *
 * When a State is being entered, this hook resolves all the Resolvables for this state, which the transition then waits for.
 *
 * See [[StateDeclaration.resolve]]
 */
var lazyResolveState = function (trans, state) {
    return new resolveContext_1.ResolveContext(trans.treeChanges().to)
        .subContext(state)
        .resolvePath("LAZY", trans)
        .then(common_1.noop);
};
exports.registerLazyResolveState = function (transitionService) {
    return transitionService.onEnter({ entering: hof_1.val(true) }, lazyResolveState, { priority: 1000 });
};
//# sourceMappingURL=resolve.js.map

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/** @module hooks */ /** for typedoc */
var common_1 = __webpack_require__(8);
var coreservices_1 = __webpack_require__(20);
/**
 * A [[TransitionHookFn]] which waits for the views to load
 *
 * Registered using `transitionService.onStart({}, loadEnteringViews);`
 *
 * Allows the views to do async work in [[ViewConfig.load]] before the transition continues.
 * In angular 1, this includes loading the templates.
 */
var loadEnteringViews = function (transition) {
    var $q = coreservices_1.services.$q;
    var enteringViews = transition.views("entering");
    if (!enteringViews.length)
        return;
    return $q.all(enteringViews.map(function (view) { return $q.when(view.load()); })).then(common_1.noop);
};
exports.registerLoadEnteringViews = function (transitionService) {
    return transitionService.onFinish({}, loadEnteringViews);
};
/**
 * A [[TransitionHookFn]] which activates the new views when a transition is successful.
 *
 * Registered using `transitionService.onSuccess({}, activateViews);`
 *
 * After a transition is complete, this hook deactivates the old views from the previous state,
 * and activates the new views from the destination state.
 *
 * See [[ViewService]]
 */
var activateViews = function (transition) {
    var enteringViews = transition.views("entering");
    var exitingViews = transition.views("exiting");
    if (!enteringViews.length && !exitingViews.length)
        return;
    var $view = transition.router.viewService;
    exitingViews.forEach(function (vc) { return $view.deactivateViewConfig(vc); });
    enteringViews.forEach(function (vc) { return $view.activateViewConfig(vc); });
    $view.sync();
};
exports.registerActivateViews = function (transitionService) {
    return transitionService.onSuccess({}, activateViews);
};
//# sourceMappingURL=views.js.map

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * A [[TransitionHookFn]] which updates the URL after a successful transition
 *
 * Registered using `transitionService.onSuccess({}, updateUrl);`
 */
var updateUrl = function (transition) {
    var options = transition.options();
    var $state = transition.router.stateService;
    var $urlRouter = transition.router.urlRouter;
    // Dont update the url in these situations:
    // The transition was triggered by a URL sync (options.source === 'url')
    // The user doesn't want the url to update (options.location === false)
    // The destination state, and all parents have no navigable url
    if (options.source !== 'url' && options.location && $state.$current.navigable) {
        var urlOptions = { replace: options.location === 'replace' };
        $urlRouter.push($state.$current.navigable.url, $state.params, urlOptions);
    }
    $urlRouter.update(true);
};
exports.registerUpdateUrl = function (transitionService) {
    return transitionService.onSuccess({}, updateUrl, { priority: 9999 });
};
//# sourceMappingURL=url.js.map

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/** @module hooks */ /** */
var predicates_1 = __webpack_require__(13);
var coreservices_1 = __webpack_require__(20);
var targetState_1 = __webpack_require__(62);
/**
 * A [[TransitionHookFn]] that redirects to a different state or params
 *
 * Registered using `transitionService.onStart({ to: (state) => !!state.redirectTo }, redirectHook);`
 *
 * See [[StateDeclaration.redirectTo]]
 */
var redirectToHook = function (trans) {
    var redirect = trans.to().redirectTo;
    if (!redirect)
        return;
    var $state = trans.router.stateService;
    function handleResult(result) {
        if (!result)
            return;
        if (result instanceof targetState_1.TargetState)
            return result;
        if (predicates_1.isString(result))
            return $state.target(result, trans.params(), trans.options());
        if (result['state'] || result['params'])
            return $state.target(result['state'] || trans.to(), result['params'] || trans.params(), trans.options());
    }
    if (predicates_1.isFunction(redirect)) {
        return coreservices_1.services.$q.when(redirect(trans)).then(handleResult);
    }
    return handleResult(redirect);
};
exports.registerRedirectToHook = function (transitionService) {
    return transitionService.onStart({ to: function (state) { return !!state.redirectTo; } }, redirectToHook);
};
//# sourceMappingURL=redirectTo.js.map

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * A factory which creates an onEnter, onExit or onRetain transition hook function
 *
 * The returned function invokes the (for instance) state.onEnter hook when the
 * state is being entered.
 *
 * @hidden
 */
function makeEnterExitRetainHook(hookName) {
    return function (transition, state) {
        var hookFn = state[hookName];
        return hookFn(transition, state);
    };
}
/**
 * The [[TransitionStateHookFn]] for onExit
 *
 * When the state is being exited, the state's .onExit function is invoked.
 *
 * Registered using `transitionService.onExit({ exiting: (state) => !!state.onExit }, onExitHook);`
 *
 * See: [[IHookRegistry.onExit]]
 */
var onExitHook = makeEnterExitRetainHook('onExit');
exports.registerOnExitHook = function (transitionService) {
    return transitionService.onExit({ exiting: function (state) { return !!state.onExit; } }, onExitHook);
};
/**
 * The [[TransitionStateHookFn]] for onRetain
 *
 * When the state was already entered, and is not being exited or re-entered, the state's .onRetain function is invoked.
 *
 * Registered using `transitionService.onRetain({ retained: (state) => !!state.onRetain }, onRetainHook);`
 *
 * See: [[IHookRegistry.onRetain]]
 */
var onRetainHook = makeEnterExitRetainHook('onRetain');
exports.registerOnRetainHook = function (transitionService) {
    return transitionService.onRetain({ retained: function (state) { return !!state.onRetain; } }, onRetainHook);
};
/**
 * The [[TransitionStateHookFn]] for onEnter
 *
 * When the state is being entered, the state's .onEnter function is invoked.
 *
 * Registered using `transitionService.onEnter({ entering: (state) => !!state.onEnter }, onEnterHook);`
 *
 * See: [[IHookRegistry.onEnter]]
 */
var onEnterHook = makeEnterExitRetainHook('onEnter');
exports.registerOnEnterHook = function (transitionService) {
    return transitionService.onEnter({ entering: function (state) { return !!state.onEnter; } }, onEnterHook);
};
//# sourceMappingURL=onEnterExitRetain.js.map

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(__webpack_require__(70));
__export(__webpack_require__(222));
__export(__webpack_require__(234));
__export(__webpack_require__(148));
//# sourceMappingURL=index.js.map

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
/** @module path */ /** for typedoc */
__export(__webpack_require__(105));
__export(__webpack_require__(106));
//# sourceMappingURL=index.js.map

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
/** @module resolve */ /** for typedoc */
__export(__webpack_require__(219));
__export(__webpack_require__(81));
__export(__webpack_require__(107));
//# sourceMappingURL=index.js.map

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(__webpack_require__(230));
__export(__webpack_require__(149));
__export(__webpack_require__(229));
__export(__webpack_require__(231));
__export(__webpack_require__(228));
__export(__webpack_require__(232));
__export(__webpack_require__(62));
//# sourceMappingURL=index.js.map

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
/**
 * This module contains APIs related to a Transition.
 *
 * See:
 * - [[TransitionService]]
 * - [[Transition]]
 * - [[HookFn]], [[TransitionHookFn]], [[TransitionStateHookFn]], [[HookMatchCriteria]], [[HookResult]]
 *
 * @coreapi
 * @preferred
 * @module transition
 */ /** for typedoc */
__export(__webpack_require__(79));
__export(__webpack_require__(218));
__export(__webpack_require__(147));
__export(__webpack_require__(78));
__export(__webpack_require__(146));
__export(__webpack_require__(80));
__export(__webpack_require__(226));
__export(__webpack_require__(150));
//# sourceMappingURL=index.js.map

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(__webpack_require__(108));
__export(__webpack_require__(221));
__export(__webpack_require__(223));
__export(__webpack_require__(224));
__export(__webpack_require__(235));
//# sourceMappingURL=index.js.map

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(__webpack_require__(227));
//# sourceMappingURL=index.js.map

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Core classes and interfaces
 *
 * The classes and interfaces that are core to ui-router and do not belong
 * to a more specific subsystem (such as resolve).
 *
 * @coreapi
 * @preferred
 * @module core
 */ /** for typedoc */

var UIRouterPluginBase = (function () {
    function UIRouterPluginBase() {
    }
    UIRouterPluginBase.prototype.dispose = function (router) { };
    return UIRouterPluginBase;
}());
exports.UIRouterPluginBase = UIRouterPluginBase;
//# sourceMappingURL=interface.js.map

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/** @module view */
/** for typedoc */
var angular_1 = __webpack_require__(71);
var ui_router_core_1 = __webpack_require__(30);
/**
 * Service which manages loading of templates from a ViewConfig.
 */
var TemplateFactory = (function () {
    function TemplateFactory() {
        var _this = this;
        /** @hidden */ this._useHttp = angular_1.ng.version.minor < 3;
        /** @hidden */ this.$get = ['$http', '$templateCache', '$injector', function ($http, $templateCache, $injector) {
                _this.$templateRequest = $injector.has && $injector.has('$templateRequest') && $injector.get('$templateRequest');
                _this.$http = $http;
                _this.$templateCache = $templateCache;
                return _this;
            }];
    }
    /** @hidden */
    TemplateFactory.prototype.useHttpService = function (value) {
        this._useHttp = value;
    };
    ;
    /**
     * Creates a template from a configuration object.
     *
     * @param config Configuration object for which to load a template.
     * The following properties are search in the specified order, and the first one
     * that is defined is used to create the template:
     *
     * @param params  Parameters to pass to the template function.
     * @param context The resolve context associated with the template's view
     *
     * @return {string|object}  The template html as a string, or a promise for
     * that string,or `null` if no template is configured.
     */
    TemplateFactory.prototype.fromConfig = function (config, params, context) {
        var defaultTemplate = "<ui-view></ui-view>";
        var asTemplate = function (result) { return ui_router_core_1.services.$q.when(result).then(function (str) { return ({ template: str }); }); };
        var asComponent = function (result) { return ui_router_core_1.services.$q.when(result).then(function (str) { return ({ component: str }); }); };
        return (ui_router_core_1.isDefined(config.template) ? asTemplate(this.fromString(config.template, params)) :
            ui_router_core_1.isDefined(config.templateUrl) ? asTemplate(this.fromUrl(config.templateUrl, params)) :
                ui_router_core_1.isDefined(config.templateProvider) ? asTemplate(this.fromProvider(config.templateProvider, params, context)) :
                    ui_router_core_1.isDefined(config.component) ? asComponent(config.component) :
                        ui_router_core_1.isDefined(config.componentProvider) ? asComponent(this.fromComponentProvider(config.componentProvider, params, context)) :
                            asTemplate(defaultTemplate));
    };
    ;
    /**
     * Creates a template from a string or a function returning a string.
     *
     * @param template html template as a string or function that returns an html template as a string.
     * @param params Parameters to pass to the template function.
     *
     * @return {string|object} The template html as a string, or a promise for that
     * string.
     */
    TemplateFactory.prototype.fromString = function (template, params) {
        return ui_router_core_1.isFunction(template) ? template(params) : template;
    };
    ;
    /**
     * Loads a template from the a URL via `$http` and `$templateCache`.
     *
     * @param {string|Function} url url of the template to load, or a function
     * that returns a url.
     * @param {Object} params Parameters to pass to the url function.
     * @return {string|Promise.<string>} The template html as a string, or a promise
     * for that string.
     */
    TemplateFactory.prototype.fromUrl = function (url, params) {
        if (ui_router_core_1.isFunction(url))
            url = url(params);
        if (url == null)
            return null;
        if (this._useHttp) {
            return this.$http.get(url, { cache: this.$templateCache, headers: { Accept: 'text/html' } })
                .then(function (response) { return response.data; });
        }
        return this.$templateRequest(url);
    };
    ;
    /**
     * Creates a template by invoking an injectable provider function.
     *
     * @param provider Function to invoke via `locals`
     * @param {Function} injectFn a function used to invoke the template provider
     * @return {string|Promise.<string>} The template html as a string, or a promise
     * for that string.
     */
    TemplateFactory.prototype.fromProvider = function (provider, params, context) {
        var deps = ui_router_core_1.services.$injector.annotate(provider);
        var providerFn = ui_router_core_1.isArray(provider) ? ui_router_core_1.tail(provider) : provider;
        var resolvable = new ui_router_core_1.Resolvable("", providerFn, deps);
        return resolvable.get(context);
    };
    ;
    /**
     * Creates a component's template by invoking an injectable provider function.
     *
     * @param provider Function to invoke via `locals`
     * @param {Function} injectFn a function used to invoke the template provider
     * @return {string} The template html as a string: "<component-name input1='::$resolve.foo'></component-name>".
     */
    TemplateFactory.prototype.fromComponentProvider = function (provider, params, context) {
        var deps = ui_router_core_1.services.$injector.annotate(provider);
        var providerFn = ui_router_core_1.isArray(provider) ? ui_router_core_1.tail(provider) : provider;
        var resolvable = new ui_router_core_1.Resolvable("", providerFn, deps);
        return resolvable.get(context);
    };
    ;
    /**
     * Creates a template from a component's name
     *
     * This implements route-to-component.
     * It works by retrieving the component (directive) metadata from the injector.
     * It analyses the component's bindings, then constructs a template that instantiates the component.
     * The template wires input and output bindings to resolves or from the parent component.
     *
     * @param uiView {object} The parent ui-view (for binding outputs to callbacks)
     * @param context The ResolveContext (for binding outputs to callbacks returned from resolves)
     * @param component {string} Component's name in camel case.
     * @param bindings An object defining the component's bindings: {foo: '<'}
     * @return {string} The template as a string: "<component-name input1='::$resolve.foo'></component-name>".
     */
    TemplateFactory.prototype.makeComponentTemplate = function (uiView, context, component, bindings) {
        bindings = bindings || {};
        // Bind once prefix
        var prefix = angular_1.ng.version.minor >= 3 ? "::" : "";
        var attributeTpl = function (input) {
            var name = input.name, type = input.type;
            var attrName = ui_router_core_1.kebobString(name);
            // If the ui-view has an attribute which matches a binding on the routed component
            // then pass that attribute through to the routed component template.
            // Prefer ui-view wired mappings to resolve data, unless the resolve was explicitly bound using `bindings:`
            if (uiView.attr(attrName) && !bindings[name])
                return attrName + "='" + uiView.attr(attrName) + "'";
            var resolveName = bindings[name] || name;
            // Pre-evaluate the expression for "@" bindings by enclosing in {{ }}
            // some-attr="{{ ::$resolve.someResolveName }}"
            if (type === '@')
                return attrName + "='{{" + prefix + "$resolve." + resolveName + "}}'";
            // Wire "&" callbacks to resolves that return a callback function
            // Get the result of the resolve (should be a function) and annotate it to get its arguments.
            // some-attr="$resolve.someResolveResultName(foo, bar)"
            if (type === '&') {
                var res = context.getResolvable(resolveName);
                var fn = res && res.data;
                var args = fn && ui_router_core_1.services.$injector.annotate(fn) || [];
                // account for array style injection, i.e., ['foo', function(foo) {}]
                var arrayIdxStr = ui_router_core_1.isArray(fn) ? "[" + (fn.length - 1) + "]" : '';
                return attrName + "='$resolve." + resolveName + arrayIdxStr + "(" + args.join(",") + ")'";
            }
            // some-attr="::$resolve.someResolveName"
            return attrName + "='" + prefix + "$resolve." + resolveName + "'";
        };
        var attrs = getComponentBindings(component).map(attributeTpl).join(" ");
        var kebobName = ui_router_core_1.kebobString(component);
        return "<" + kebobName + " " + attrs + "></" + kebobName + ">";
    };
    ;
    return TemplateFactory;
}());
exports.TemplateFactory = TemplateFactory;
// Gets all the directive(s)' inputs ('@', '=', and '<') and outputs ('&')
function getComponentBindings(name) {
    var cmpDefs = ui_router_core_1.services.$injector.get(name + "Directive"); // could be multiple
    if (!cmpDefs || !cmpDefs.length)
        throw new Error("Unable to find component named '" + name + "'");
    return cmpDefs.map(getBindings).reduce(ui_router_core_1.unnestR, []);
}
// Given a directive definition, find its object input attributes
// Use different properties, depending on the type of directive (component, bindToController, normal)
var getBindings = function (def) {
    if (ui_router_core_1.isObject(def.bindToController))
        return scopeBindings(def.bindToController);
    return scopeBindings(def.scope);
};
// for ng 1.2 style, process the scope: { input: "=foo" }
// for ng 1.3 through ng 1.5, process the component's bindToController: { input: "=foo" } object
var scopeBindings = function (bindingsObj) { return Object.keys(bindingsObj || {})
    .map(function (key) { return [key, /^([=<@&])[?]?(.*)/.exec(bindingsObj[key])]; })
    .filter(function (tuple) { return ui_router_core_1.isDefined(tuple) && ui_router_core_1.isArray(tuple[1]); })
    .map(function (tuple) { return ({ name: tuple[1][2] || tuple[0], type: tuple[1][1] }); }); };
//# sourceMappingURL=templateFactory.js.map

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/** @module ng1 */ /** */
var ui_router_core_1 = __webpack_require__(30);
var services_1 = __webpack_require__(151);
/**
 * This is a [[StateBuilder.builder]] function for angular1 `onEnter`, `onExit`,
 * `onRetain` callback hooks on a [[Ng1StateDeclaration]].
 *
 * When the [[StateBuilder]] builds a [[State]] object from a raw [[StateDeclaration]], this builder
 * ensures that those hooks are injectable for angular-ui-router (ng1).
 */
exports.getStateHookBuilder = function (hookName) {
    return function stateHookBuilder(state, parentFn) {
        var hook = state[hookName];
        var pathname = hookName === 'onExit' ? 'from' : 'to';
        function decoratedNg1Hook(trans, state) {
            var resolveContext = new ui_router_core_1.ResolveContext(trans.treeChanges(pathname));
            var locals = ui_router_core_1.extend(services_1.getLocals(resolveContext), { $state$: state, $transition$: trans });
            return ui_router_core_1.services.$injector.invoke(hook, this, locals);
        }
        return hook ? decoratedNg1Hook : undefined;
    };
};
//# sourceMappingURL=onEnterExitRetain.js.map

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ui_router_core_1 = __webpack_require__(30);
/**
 * Implements UI-Router LocationServices and LocationConfig using Angular 1's $location service
 */
var Ng1LocationServices = (function () {
    function Ng1LocationServices($locationProvider) {
        // .onChange() registry
        this._urlListeners = [];
        this.$locationProvider = $locationProvider;
        var _lp = ui_router_core_1.val($locationProvider);
        ui_router_core_1.createProxyFunctions(_lp, this, _lp, ['hashPrefix']);
    }
    Ng1LocationServices.prototype.dispose = function () { };
    Ng1LocationServices.prototype.onChange = function (callback) {
        var _this = this;
        this._urlListeners.push(callback);
        return function () { return ui_router_core_1.removeFrom(_this._urlListeners)(callback); };
    };
    Ng1LocationServices.prototype.html5Mode = function () {
        var html5Mode = this.$locationProvider.html5Mode();
        html5Mode = ui_router_core_1.isObject(html5Mode) ? html5Mode.enabled : html5Mode;
        return html5Mode && this.$sniffer.history;
    };
    Ng1LocationServices.prototype.url = function (newUrl, replace, state) {
        if (replace === void 0) { replace = false; }
        if (newUrl)
            this.$location.url(newUrl);
        if (replace)
            this.$location.replace();
        if (state)
            this.$location.state(state);
        return this.$location.url();
    };
    Ng1LocationServices.prototype._runtimeServices = function ($rootScope, $location, $sniffer, $browser) {
        var _this = this;
        this.$location = $location;
        this.$sniffer = $sniffer;
        // Bind $locationChangeSuccess to the listeners registered in LocationService.onChange
        $rootScope.$on("$locationChangeSuccess", function (evt) { return _this._urlListeners.forEach(function (fn) { return fn(evt); }); });
        var _loc = ui_router_core_1.val($location);
        var _browser = ui_router_core_1.val($browser);
        // Bind these LocationService functions to $location
        ui_router_core_1.createProxyFunctions(_loc, this, _loc, ["replace", "path", "search", "hash"]);
        // Bind these LocationConfig functions to $location
        ui_router_core_1.createProxyFunctions(_loc, this, _loc, ['port', 'protocol', 'host']);
        // Bind these LocationConfig functions to $browser
        ui_router_core_1.createProxyFunctions(_browser, this, _browser, ['baseHref']);
    };
    /**
     * Applys ng1-specific path parameter encoding
     *
     * The Angular 1 `$location` service is a bit weird.
     * It doesn't allow slashes to be encoded/decoded bi-directionally.
     *
     * See the writeup at https://github.com/angular-ui/ui-router/issues/2598
     *
     * This code patches the `path` parameter type so it encoded/decodes slashes as ~2F
     *
     * @param router
     */
    Ng1LocationServices.monkeyPatchPathParameterType = function (router) {
        var pathType = router.urlMatcherFactory.type('path');
        pathType.encode = function (val) {
            return val != null ? val.toString().replace(/(~|\/)/g, function (m) { return ({ '~': '~~', '/': '~2F' }[m]); }) : val;
        };
        pathType.decode = function (val) {
            return val != null ? val.toString().replace(/(~~|~2F)/g, function (m) { return ({ '~~': '~', '~2F': '/' }[m]); }) : val;
        };
    };
    return Ng1LocationServices;
}());
exports.Ng1LocationServices = Ng1LocationServices;
//# sourceMappingURL=locationServices.js.map

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/** @module url */ /** */
var ui_router_core_1 = __webpack_require__(30);
var ui_router_core_2 = __webpack_require__(30);
/**
 * Manages rules for client-side URL
 *
 * This class manages the router rules for what to do when the URL changes.
 *
 * ## Deprecation warning
 *
 * Use [[UrlService]]
 *
 * This provider remains for backwards compatibility.
 */
var UrlRouterProvider = (function () {
    /** @hidden */
    function UrlRouterProvider(router) {
        this._router = router;
        this._urlRouter = router.urlRouter;
    }
    /** @hidden */
    UrlRouterProvider.prototype.$get = function () {
        var urlRouter = this._urlRouter;
        urlRouter.update(true);
        if (!urlRouter.interceptDeferred)
            urlRouter.listen();
        return urlRouter;
    };
    /**
     * Registers a url handler function.
     *
     * Registers a low level url handler (a `rule`).
     * A rule detects specific URL patterns and returns a redirect, or performs some action.
     *
     * If a rule returns a string, the URL is replaced with the string, and all rules are fired again.
     *
     * #### Example:
     * ```js
     * var app = angular.module('app', ['ui.router.router']);
     *
     * app.config(function ($urlRouterProvider) {
     *   // Here's an example of how you might allow case insensitive urls
     *   $urlRouterProvider.rule(function ($injector, $location) {
     *     var path = $location.path(),
     *         normalized = path.toLowerCase();
     *
     *     if (path !== normalized) {
     *       return normalized;
     *     }
     *   });
     * });
     * ```
     *
     * @param ruleFn
     * Handler function that takes `$injector` and `$location` services as arguments.
     * You can use them to detect a url and return a different url as a string.
     *
     * @return [[UrlRouterProvider]] (`this`)
     */
    UrlRouterProvider.prototype.rule = function (ruleFn) {
        var _this = this;
        if (!ui_router_core_2.isFunction(ruleFn))
            throw new Error("'rule' must be a function");
        var match = function () {
            return ruleFn(ui_router_core_2.services.$injector, _this._router.locationService);
        };
        var rule = new ui_router_core_1.BaseUrlRule(match, ui_router_core_2.identity);
        this._urlRouter.rule(rule);
        return this;
    };
    ;
    /**
     * Defines the path or behavior to use when no url can be matched.
     *
     * #### Example:
     * ```js
     * var app = angular.module('app', ['ui.router.router']);
     *
     * app.config(function ($urlRouterProvider) {
     *   // if the path doesn't match any of the urls you configured
     *   // otherwise will take care of routing the user to the
     *   // specified url
     *   $urlRouterProvider.otherwise('/index');
     *
     *   // Example of using function rule as param
     *   $urlRouterProvider.otherwise(function ($injector, $location) {
     *     return '/a/valid/url';
     *   });
     * });
     * ```
     *
     * @param rule
     * The url path you want to redirect to or a function rule that returns the url path or performs a `$state.go()`.
     * The function version is passed two params: `$injector` and `$location` services, and should return a url string.
     *
     * @return {object} `$urlRouterProvider` - `$urlRouterProvider` instance
     */
    UrlRouterProvider.prototype.otherwise = function (rule) {
        var _this = this;
        var urlRouter = this._urlRouter;
        if (ui_router_core_2.isString(rule)) {
            urlRouter.otherwise(rule);
        }
        else if (ui_router_core_2.isFunction(rule)) {
            urlRouter.otherwise(function () { return rule(ui_router_core_2.services.$injector, _this._router.locationService); });
        }
        else {
            throw new Error("'rule' must be a string or function");
        }
        return this;
    };
    ;
    /**
     * Registers a handler for a given url matching.
     *
     * If the handler is a string, it is
     * treated as a redirect, and is interpolated according to the syntax of match
     * (i.e. like `String.replace()` for `RegExp`, or like a `UrlMatcher` pattern otherwise).
     *
     * If the handler is a function, it is injectable.
     * It gets invoked if `$location` matches.
     * You have the option of inject the match object as `$match`.
     *
     * The handler can return
     *
     * - **falsy** to indicate that the rule didn't match after all, then `$urlRouter`
     *   will continue trying to find another one that matches.
     * - **string** which is treated as a redirect and passed to `$location.url()`
     * - **void** or any **truthy** value tells `$urlRouter` that the url was handled.
     *
     * @example
     * ```js
     *
     * var app = angular.module('app', ['ui.router.router']);
     *
     * app.config(function ($urlRouterProvider) {
     *   $urlRouterProvider.when($state.url, function ($match, $stateParams) {
     *     if ($state.$current.navigable !== state ||
     *         !equalForKeys($match, $stateParams) {
     *      $state.transitionTo(state, $match, false);
     *     }
     *   });
     * });
     * ```
     *
     * @param what A pattern string to match, compiled as a [[UrlMatcher]].
     * @param handler The path (or function that returns a path) that you want to redirect your user to.
     * @param ruleCallback [optional] A callback that receives the `rule` registered with [[UrlMatcher.rule]]
     *
     * Note: the handler may also invoke arbitrary code, such as `$state.go()`
     */
    UrlRouterProvider.prototype.when = function (what, handler) {
        if (ui_router_core_2.isArray(handler) || ui_router_core_2.isFunction(handler)) {
            handler = UrlRouterProvider.injectableHandler(this._router, handler);
        }
        this._urlRouter.when(what, handler);
        return this;
    };
    ;
    UrlRouterProvider.injectableHandler = function (router, handler) {
        return function (match) {
            return ui_router_core_2.services.$injector.invoke(handler, null, { $match: match, $stateParams: router.globals.params });
        };
    };
    /**
     * Disables monitoring of the URL.
     *
     * Call this method before UI-Router has bootstrapped.
     * It will stop UI-Router from performing the initial url sync.
     *
     * This can be useful to perform some asynchronous initialization before the router starts.
     * Once the initialization is complete, call [[listen]] to tell UI-Router to start watching and synchronizing the URL.
     *
     * #### Example:
     * ```js
     * var app = angular.module('app', ['ui.router']);
     *
     * app.config(function ($urlRouterProvider) {
     *   // Prevent $urlRouter from automatically intercepting URL changes;
     *   $urlRouterProvider.deferIntercept();
     * })
     *
     * app.run(function (MyService, $urlRouter, $http) {
     *   $http.get("/stuff").then(function(resp) {
     *     MyService.doStuff(resp.data);
     *     $urlRouter.listen();
     *     $urlRouter.sync();
     *   });
     * });
     * ```
     *
     * @param defer Indicates whether to defer location change interception.
     *        Passing no parameter is equivalent to `true`.
     */
    UrlRouterProvider.prototype.deferIntercept = function (defer) {
        this._urlRouter.deferIntercept(defer);
    };
    ;
    return UrlRouterProvider;
}());
exports.UrlRouterProvider = UrlRouterProvider;
//# sourceMappingURL=urlRouterProvider.js.map

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * # Angular 1 injectable services
 *
 * This is a list of the objects which can be injected using angular's injector.
 *
 * There are three different kind of injectable objects:
 *
 * ## **Provider** objects
 * #### injectable into a `.config()` block during configtime
 *
 * - [[$uiRouterProvider]]: The UI-Router instance
 * - [[$stateProvider]]: State registration
 * - [[$transitionsProvider]]: Transition hooks
 * - [[$urlServiceProvider]]: All URL related public APIs
 *
 * - [[$uiViewScrollProvider]]: Disable ui-router view scrolling
 * - [[$urlRouterProvider]]: (deprecated) Url matching rules
 * - [[$urlMatcherFactoryProvider]]: (deprecated) Url parsing config
 *
 * ## **Service** objects
 * #### injectable globally during runtime
 *
 * - [[$uiRouter]]: The UI-Router instance
 * - [[$trace]]: Enable transition trace/debug
 * - [[$transitions]]: Transition hooks
 * - [[$state]]: Imperative state related APIs
 * - [[$stateRegistry]]: State registration
 * - [[$urlService]]: All URL related public APIs
 * - [[$uiRouterGlobals]]: Global variables
 * - [[$uiViewScroll]]: Scroll an element into view
 *
 * - [[$stateParams]]: (deprecated) Global state param values
 * - [[$urlRouter]]: (deprecated) URL synchronization
 * - [[$urlMatcherFactory]]: (deprecated) URL parsing config
 *
 * ## **Per-Transition** objects
 *
 * - These kind of objects are injectable into:
 *   - Resolves ([[Ng1StateDeclaration.resolve]]),
 *   - Transition Hooks ([[TransitionService.onStart]], etc),
 *   - Routed Controllers ([[Ng1ViewDeclaration.controller]])
 *
 * #### Different instances are injected based on the [[Transition]]
 *
 * - [[$transition$]]: The current Transition object
 * - [[$stateParams]]: State param values for pending Transition (deprecated)
 * - Any resolve data defined using [[Ng1StateDeclaration.resolve]]
 *
 * @ng1api
 * @preferred
 * @module injectables
 */ /** */

/**
 * The current (or pending) State Parameters
 *
 * An injectable global **Service Object** which holds the state parameters for the latest **SUCCESSFUL** transition.
 *
 * The values are not updated until *after* a `Transition` successfully completes.
 *
 * **Also:** an injectable **Per-Transition Object** object which holds the pending state parameters for the pending `Transition` currently running.
 *
 * ## Deprecation warning:
 *
 * The value injected for `$stateParams` is different depending on where it is injected.
 *
 * - When injected into an angular service, the object injected is the global **Service Object** with the parameter values for the latest successful `Transition`.
 * - When injected into transition hooks, resolves, or view controllers, the object is the **Per-Transition Object** with the parameter values for the running `Transition`.
 *
 * Because of these confusing details, this service is deprecated.
 *
 * @deprecated Instead of using the global `$stateParams` service object,
 * inject [[$uiRouterGlobals]] and use [[UIRouterGlobals.params]]
 *
 * ```js
 * MyService.$inject = ['$uiRouterGlobals'];
 * function MyService($uiRouterGlobals) {
 *   return {
 *     paramValues: function () {
 *       return $uiRouterGlobals.params;
 *     }
 *   }
 * }
 * ```
 *
 * @deprecated Instead of using the per-transition `$stateParams` object,
 * inject the current `Transition` (as [[$transition$]]) and use [[Transition.params]]
 *
 * ```js
 * MyController.$inject = ['$transition$'];
 * function MyController($transition$) {
 *   var username = $transition$.params().username;
 *   // .. do something with username
 * }
 * ```
 *
 * ---
 *
 * This object can be injected into other services.
 *
 * #### Deprecated Example:
 * ```js
 * SomeService.$inject = ['$http', '$stateParams'];
 * function SomeService($http, $stateParams) {
 *   return {
 *     getUser: function() {
 *       return $http.get('/api/users/' + $stateParams.username);
 *     }
 *   }
 * };
 * angular.service('SomeService', SomeService);
 * ```
 */
var $stateParams;
/**
 * Global UI-Router variables
 *
 * The router global state as a **Service Object** (injectable during runtime).
 *
 * This object contains globals such as the current state and current parameter values.
 */
var $uiRouterGlobals;
/**
 * The UI-Router instance
 *
 * The [[UIRouter]] singleton (the router instance) as a **Service Object** (injectable during runtime).
 *
 * This object is the UI-Router singleton instance, created by angular dependency injection during application bootstrap.
 * It has references to the other UI-Router services
 *
 * #### Note: This object is also exposed as [[$uiRouterProvider]] for injection during angular config time.
 */
var $uiRouter;
/**
 * The UI-Router instance
 *
 * The [[UIRouter]] singleton (the router instance) as a **Provider Object** (injectable during config phase).
 *
 * This object is the UI-Router singleton instance, created by angular dependency injection during application bootstrap.
 * It has references to the other UI-Router services
 *
 * #### Note: This object is also exposed as [[$uiRouter]] for injection during runtime.
 */
var $uiRouterProvider;
/**
 * Transition debug/tracing
 *
 * The [[Trace]] singleton as a **Service Object** (injectable during runtime).
 *
 * Enables or disables Transition tracing which can help to debug issues.
 */
var $trace;
/**
 * The Transition Service
 *
 * The [[TransitionService]] singleton as a **Service Object** (injectable during runtime).
 *
 * This angular service exposes the [[TransitionService]] singleton, which is primarily
 * used to register global transition hooks.
 *
 * #### Note: This object is also exposed as [[$transitionsProvider]] for injection during the config phase.
 */
var $transitions;
/**
 * The Transition Service
 *
 * The [[TransitionService]] singleton as a **Provider Object** (injectable during config phase)
 *
 * This angular service exposes the [[TransitionService]] singleton, which is primarily
 * used to register global transition hooks.
 *
 * #### Note: This object is also exposed as [[$transitions]] for injection during runtime.
 */
var $transitionsProvider;
/**
 * The current [[Transition]] object
 *
 * The current [[Transition]] object as a **Per-Transition Object** (injectable into Resolve, Hooks, Controllers)
 *
 * This object returns information about the current transition, including:
 *
 * - To/from states
 * - To/from parameters
 * - Transition options
 * - States being entered, exited, and retained
 * - Resolve data
 * - A Promise for the transition
 * - Any transition failure information
 * - An injector for both Service and Per-Transition Objects
 */
var $transition$;
/**
 * The State Service
 *
 * The [[StateService]] singleton as a **Service Object** (injectable during runtime).
 *
 * This service used to manage and query information on registered states.
 * It exposes state related APIs including:
 *
 * - Start a [[Transition]]
 * - Imperatively lazy load states
 * - Check if a state is currently active
 * - Look up states by name
 * - Build URLs for a state+parameters
 * - Configure the global Transition error handler
 *
 * This angular service exposes the [[StateService]] singleton.
 */
var $state;
/**
 * The State Registry
 *
 * The [[StateRegistry]] singleton as a **Service Object** (injectable during runtime).
 *
 * This service is used to register/deregister states.
 * It has state registration related APIs including:
 *
 * - Register/deregister states
 * - Listen for state registration/deregistration
 * - Get states by name
 * - Add state decorators (to customize the state creation process)
 *
 * #### Note: This object is also exposed as [[$stateRegistryProvider]] for injection during the config phase.
 */
var $stateRegistry;
/**
 * The State Registry
 *
 * The [[StateRegistry]] singleton as a **Provider Object** (injectable during config time).
 *
 * This service is used to register/deregister states.
 * It has state registration related APIs including:
 *
 * - Register/deregister states
 * - Listen for state registration/deregistration
 * - Get states by name
 * - Add state decorators (to customize the state creation process)
 *
 * #### Note: This object is also exposed as [[$stateRegistry]] for injection during runtime.
 */
var $stateRegistryProvider;
/**
 * The View Scroll provider
 *
 * The [[UIViewScrollProvider]] as a **Provider Object** (injectable during config time).
 *
 * This angular service exposes the [[UIViewScrollProvider]] singleton and is
 * used to disable UI-Router's scroll behavior.
 */
var $uiViewScrollProvider;
/**
 * The View Scroll function
 *
 * The View Scroll function as a **Service Object** (injectable during runtime).
 *
 * This is a function that scrolls an element into view.
 * The element is scrolled after a `$timeout` so the DOM has time to refresh.
 *
 * If you prefer to rely on `$anchorScroll` to scroll the view to the anchor,
 * this can be enabled by calling [[UIViewScrollProvider.useAnchorScroll]].
 *
 * Note: this function is used by the [[uiView]] when the `autoscroll` expression evaluates to true.
 */
var $uiViewScroll;
/**
 * The StateProvider
 *
 * An angular1-only [[StateProvider]] as a **Provider Object** (injectable during config time).
 *
 * This angular service exposes the [[StateProvider]] singleton.
 *
 * The `StateProvider` is primarily used to register states or add custom state decorators.
 *
 * ##### Note: This provider is a ng1 vestige.
 * It is a passthrough to [[$stateRegistry]] and [[$state]].
 */
var $stateProvider;
/**
 * The URL Service Provider
 *
 * The [[UrlService]] singleton as a **Provider Object** (injectable during the angular config phase).
 *
 * A service used to configure and interact with the URL.
 * It has URL related APIs including:
 *
 * - add URL rules [[UrlService.rules.when]]
 * - configure behavior when no url matches [[UrlService.rules.otherwise]]
 * - delay initial URL synchronization [[UrlService.deferIntercept]].
 * - get or set the current url: [[UrlService.url]]
 *
 * ##### Note: This service can also be injected during runtime as [[$urlService]].
 */
var $urlServiceProvider;
/**
 * The URL Service
 *
 * The [[UrlService]] singleton as a **Service Object** (injectable during runtime).
 *
 * Note: This service can also be injected during the config phase as [[$urlServiceProvider]].
 *
 * Used to configure the URL.
 * It has URL related APIs including:
 *
 * - register custom Parameter types [[UrlService.rules.when]]
 * - add URL rules [[UrlService.rules.when]]
 * - configure behavior when no url matches [[UrlService.rules.otherwise]]
 * - delay initial URL synchronization [[UrlService.deferIntercept]].
 * - get or set the current url: [[UrlService.url]]
 *
 * ##### Note: This service can also be injected during the config phase as [[$urlServiceProvider]].
 */
var $urlService;
/**
 * The URL Router Provider
 *
 * The [[UrlRouter]] singleton as a **Provider Object** (injectable during config time).
 *
 * #### Note: This object is also exposed as [[$urlRouter]] for injection during runtime.
 *
 * @deprecated This object is now considered internal. Use [[$urlServiceProvider]] instead.
 */
var $urlRouterProvider;
/**
 * The Url Router
 *
 * The [[UrlRouter]] singleton as a **Service Object** (injectable during runtime).
 *
 * #### Note: This object is also exposed as [[$urlRouterProvider]] for injection during angular config time.
 *
 * @deprecated This object is now considered internal. Use [[$urlService]] instead.
 */
var $urlRouter;
/**
 * The URL Matcher Factory
 *
 * The [[UrlMatcherFactory]] singleton as a **Service Object** (injectable during runtime).
 *
 * This service is used to set url mapping options, define custom parameter types, and create [[UrlMatcher]] objects.
 *
 * #### Note: This object is also exposed as [[$urlMatcherFactoryProvider]] for injection during angular config time.
 *
 * @deprecated This object is now considered internal. Use [[$urlService]] instead.
 */
var $urlMatcherFactory;
/**
 * The URL Matcher Factory
 *
 * The [[UrlMatcherFactory]] singleton as a **Provider Object** (injectable during config time).
 *
 * This service is used to set url mapping options, define custom parameter types, and create [[UrlMatcher]] objects.
 *
 * #### Note: This object is also exposed as [[$urlMatcherFactory]] for injection during runtime.
 *
 * @deprecated This object is now considered internal. Use [[$urlService]] instead.
 */
var $urlMatcherFactoryProvider;
//# sourceMappingURL=injectables.js.map

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * These are the UI-Router angular 1 directives.
 *
 * These directives are used in templates to create viewports and navigate to states
 *
 * @ng1api
 * @preferred
 * @module directives
 */ /** for typedoc */
var angular_1 = __webpack_require__(71);
var ui_router_core_1 = __webpack_require__(30);
/** @hidden */
function parseStateRef(ref) {
    var paramsOnly = ref.match(/^\s*({[^}]*})\s*$/), parsed;
    if (paramsOnly)
        ref = '(' + paramsOnly[1] + ')';
    parsed = ref.replace(/\n/g, " ").match(/^\s*([^(]*?)\s*(\((.*)\))?\s*$/);
    if (!parsed || parsed.length !== 4)
        throw new Error("Invalid state ref '" + ref + "'");
    return { state: parsed[1] || null, paramExpr: parsed[3] || null };
}
/** @hidden */
function stateContext(el) {
    var $uiView = el.parent().inheritedData('$uiView');
    var path = ui_router_core_1.parse('$cfg.path')($uiView);
    return path ? ui_router_core_1.tail(path).state.name : undefined;
}
/** @hidden */
function processedDef($state, $element, def) {
    var uiState = def.uiState || $state.current.name;
    var uiStateOpts = ui_router_core_1.extend(defaultOpts($element, $state), def.uiStateOpts || {});
    var href = $state.href(uiState, def.uiStateParams, uiStateOpts);
    return { uiState: uiState, uiStateParams: def.uiStateParams, uiStateOpts: uiStateOpts, href: href };
}
/** @hidden */
function getTypeInfo(el) {
    // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
    var isSvg = Object.prototype.toString.call(el.prop('href')) === '[object SVGAnimatedString]';
    var isForm = el[0].nodeName === "FORM";
    return {
        attr: isForm ? "action" : (isSvg ? 'xlink:href' : 'href'),
        isAnchor: el.prop("tagName").toUpperCase() === "A",
        clickable: !isForm
    };
}
/** @hidden */
function clickHook(el, $state, $timeout, type, getDef) {
    return function (e) {
        var button = e.which || e.button, target = getDef();
        if (!(button > 1 || e.ctrlKey || e.metaKey || e.shiftKey || el.attr('target'))) {
            // HACK: This is to allow ng-clicks to be processed before the transition is initiated:
            var transition = $timeout(function () {
                $state.go(target.uiState, target.uiStateParams, target.uiStateOpts);
            });
            e.preventDefault();
            // if the state has no URL, ignore one preventDefault from the <a> directive.
            var ignorePreventDefaultCount = type.isAnchor && !target.href ? 1 : 0;
            e.preventDefault = function () {
                if (ignorePreventDefaultCount-- <= 0)
                    $timeout.cancel(transition);
            };
        }
    };
}
/** @hidden */
function defaultOpts(el, $state) {
    return {
        relative: stateContext(el) || $state.$current,
        inherit: true,
        source: "sref"
    };
}
/**
 * `ui-sref`: A directive for linking to a state
 *
 * A directive which links to a state (and optionally, parameters).
 * When clicked, this directive activates the linked state with the supplied parameter values.
 *
 * ### Linked State
 * The attribute value of the `ui-sref` is the name of the state to link to.
 *
 * #### Example:
 * This will activate the `home` state when the link is clicked.
 * <a ui-sref="home">Home</a>
 *
 * ### Relative Links
 * You can also use relative state paths within `ui-sref`, just like a relative path passed to `$state.go()` ([[StateService.go]]).
 * You just need to be aware that the path is relative to the state that *created* the link.
 * This allows a state to create a relative `ui-sref` which always targets the same destination.
 *
 * #### Example:
 * Both these links are relative to the parent state, even when a child state is currently active.
 * ```html
 * <a ui-sref=".child1">child 1 state</a>
 * <a ui-sref=".child2">child 2 state</a>
 * ```
 *
 * This link activates the parent class.
 * ```html
 * <a ui-sref="^">Return</a>
 * ```
 *
 * ### hrefs
 * If the linked state has a URL, the directive will automatically generate and
 * update the `href` attribute (using the [[StateService.href]]  method).
 *
 * #### Example:
 * Assuming the `users` state has a url of `/users/`
 * ```html
 * <a ui-sref="users" href="/users/">Users</a>
 * ```
 *
 * ### Parameter Values
 * In addition to the state name, a `ui-sref` can include parameter values which are applied when activating the state.
 * Param values can be provided in the `ui-sref` value after the state name, enclosed by parentheses.
 * The content inside the parentheses is an expression, evaluated to the parameter values.
 *
 * #### Example:
 * This example renders a list of links to users.
 * The state's `userId` parameter value comes from each user's `user.id` property.
 * ```html
 * <li ng-repeat="user in users">
 *   <a ui-sref="users.detail({ userId: user.id })">{{ user.displayName }}</a>
 * </li>
 * ```
 *
 * Note:
 * The parameter values expression is `$watch`ed for updates.
 *
 * ### Transition Options
 * You can specify [[TransitionOptions]] to pass to [[StateService.go]] by using the `ui-sref-opts` attribute.
 * Options are restricted to `location`, `inherit`, and `reload`.
 *
 * #### Example:
 * ```html
 * <a ui-sref="home" ui-sref-opts="{ reload: true }">Home</a>
 * ```
 *
 * ### Highlighting the active link
 * This directive can be used in conjunction with [[uiSrefActive]] to highlight the active link.
 *
 * ### Examples
 * If you have the following template:
 *
 * ```html
 * <a ui-sref="home">Home</a>
 * <a ui-sref="about">About</a>
 * <a ui-sref="{page: 2}">Next page</a>
 *
 * <ul>
 *     <li ng-repeat="contact in contacts">
 *         <a ui-sref="contacts.detail({ id: contact.id })">{{ contact.name }}</a>
 *     </li>
 * </ul>
 * ```
 *
 * Then (assuming the current state is `contacts`) the rendered html including hrefs would be:
 *
 * ```html
 * <a href="#/home" ui-sref="home">Home</a>
 * <a href="#/about" ui-sref="about">About</a>
 * <a href="#/contacts?page=2" ui-sref="{page: 2}">Next page</a>
 *
 * <ul>
 *     <li ng-repeat="contact in contacts">
 *         <a href="#/contacts/1" ui-sref="contacts.detail({ id: contact.id })">Joe</a>
 *     </li>
 *     <li ng-repeat="contact in contacts">
 *         <a href="#/contacts/2" ui-sref="contacts.detail({ id: contact.id })">Alice</a>
 *     </li>
 *     <li ng-repeat="contact in contacts">
 *         <a href="#/contacts/3" ui-sref="contacts.detail({ id: contact.id })">Bob</a>
 *     </li>
 * </ul>
 *
 * <a href="#/home" ui-sref="home" ui-sref-opts="{reload: true}">Home</a>
 * ```
 *
 * ### Notes
 *
 * - You can use `ui-sref` to change **only the parameter values** by omitting the state name and parentheses.
 * #### Example:
 * Sets the `lang` parameter to `en` and remains on the same state.
 *
 * ```html
 * <a ui-sref="{ lang: 'en' }">English</a>
 * ```
 *
 * - A middle-click, right-click, or ctrl-click is handled (natively) by the browser to open the href in a new window, for example.
 *
 * - Unlike the parameter values expression, the state name is not `$watch`ed (for performance reasons).
 * If you need to dynamically update the state being linked to, use the fully dynamic [[uiState]] directive.
 */
var uiSref;
uiSref = ['$uiRouter', '$timeout',
    function $StateRefDirective($uiRouter, $timeout) {
        var $state = $uiRouter.stateService;
        return {
            restrict: 'A',
            require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
            link: function (scope, element, attrs, uiSrefActive) {
                var type = getTypeInfo(element);
                var active = uiSrefActive[1] || uiSrefActive[0];
                var unlinkInfoFn = null;
                var hookFn;
                var rawDef = {};
                var getDef = function () { return processedDef($state, element, rawDef); };
                var ref = parseStateRef(attrs.uiSref);
                rawDef.uiState = ref.state;
                rawDef.uiStateOpts = attrs.uiSrefOpts ? scope.$eval(attrs.uiSrefOpts) : {};
                function update() {
                    var def = getDef();
                    if (unlinkInfoFn)
                        unlinkInfoFn();
                    if (active)
                        unlinkInfoFn = active.$$addStateInfo(def.uiState, def.uiStateParams);
                    if (def.href != null)
                        attrs.$set(type.attr, def.href);
                }
                if (ref.paramExpr) {
                    scope.$watch(ref.paramExpr, function (val) {
                        rawDef.uiStateParams = angular_1.ng.copy(val);
                        update();
                    }, true);
                    rawDef.uiStateParams = angular_1.ng.copy(scope.$eval(ref.paramExpr));
                }
                update();
                scope.$on('$destroy', $uiRouter.stateRegistry.onStatesChanged(update));
                scope.$on('$destroy', $uiRouter.transitionService.onSuccess({}, update));
                if (!type.clickable)
                    return;
                hookFn = clickHook(element, $state, $timeout, type, getDef);
                element[element.on ? 'on' : 'bind']("click", hookFn);
                scope.$on('$destroy', function () {
                    element[element.off ? 'off' : 'unbind']("click", hookFn);
                });
            }
        };
    }];
/**
 * `ui-state`: A fully dynamic directive for linking to a state
 *
 * A directive which links to a state (and optionally, parameters).
 * When clicked, this directive activates the linked state with the supplied parameter values.
 *
 * **This directive is very similar to [[uiSref]], but it `$observe`s and `$watch`es/evaluates all its inputs.**
 *
 * A directive which links to a state (and optionally, parameters).
 * When clicked, this directive activates the linked state with the supplied parameter values.
 *
 * ### Linked State
 * The attribute value of `ui-state` is an expression which is `$watch`ed and evaluated as the state to link to.
 * **This is in contrast with `ui-sref`, which takes a state name as a string literal.**
 *
 * #### Example:
 * Create a list of links.
 * ```html
 * <li ng-repeat="link in navlinks">
 *   <a ui-sref="link.state">{{ link.displayName }}</a>
 * </li>
 *
 * ### Relative Links
 * If the expression evaluates to a relative path, it is processed like [[uiSref]].
 * You just need to be aware that the path is relative to the state that *created* the link.
 * This allows a state to create relative `ui-state` which always targets the same destination.
 *
 * ### hrefs
 * If the linked state has a URL, the directive will automatically generate and
 * update the `href` attribute (using the [[StateService.href]]  method).
 *
 * ### Parameter Values
 * In addition to the state name expression, a `ui-state` can include parameter values which are applied when activating the state.
 * Param values should be provided using the `ui-state-params` attribute.
 * The `ui-state-params` attribute value is `$watch`ed and evaluated as an expression.
 *
 * #### Example:
 * This example renders a list of links with param values.
 * The state's `userId` parameter value comes from each user's `user.id` property.
 * ```html
 * <li ng-repeat="link in navlinks">
 *   <a ui-state="link.state" ui-state-params="link.params">{{ link.displayName }}</a>
 * </li>
 * ```
 *
 * ### Transition Options
 * You can specify [[TransitionOptions]] to pass to [[StateService.go]] by using the `ui-state-opts` attribute.
 * Options are restricted to `location`, `inherit`, and `reload`.
 * The value of the `ui-state-opts` is `$watch`ed and evaluated as an expression.
 *
 * #### Example:
 * ```html
 * <a ui-state="returnto.state" ui-state-opts="{ reload: true }">Home</a>
 * ```
 *
 * ### Highlighting the active link
 * This directive can be used in conjunction with [[uiSrefActive]] to highlight the active link.
 *
 * ### Notes
 *
 * - You can use `ui-params` to change **only the parameter values** by omitting the state name and supplying only `ui-state-params`.
 *   However, it might be simpler to use [[uiSref]] parameter-only links.
 *
 * #### Example:
 * Sets the `lang` parameter to `en` and remains on the same state.
 *
 * ```html
 * <a ui-state="" ui-state-params="{ lang: 'en' }">English</a>
 * ```
 *
 * - A middle-click, right-click, or ctrl-click is handled (natively) by the browser to open the href in a new window, for example.
 * ```
 */
var uiState;
uiState = ['$uiRouter', '$timeout',
    function $StateRefDynamicDirective($uiRouter, $timeout) {
        var $state = $uiRouter.stateService;
        return {
            restrict: 'A',
            require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
            link: function (scope, element, attrs, uiSrefActive) {
                var type = getTypeInfo(element);
                var active = uiSrefActive[1] || uiSrefActive[0];
                var unlinkInfoFn = null;
                var hookFn;
                var rawDef = {};
                var getDef = function () { return processedDef($state, element, rawDef); };
                var inputAttrs = ['uiState', 'uiStateParams', 'uiStateOpts'];
                var watchDeregFns = inputAttrs.reduce(function (acc, attr) { return (acc[attr] = ui_router_core_1.noop, acc); }, {});
                function update() {
                    var def = getDef();
                    if (unlinkInfoFn)
                        unlinkInfoFn();
                    if (active)
                        unlinkInfoFn = active.$$addStateInfo(def.uiState, def.uiStateParams);
                    if (def.href != null)
                        attrs.$set(type.attr, def.href);
                }
                inputAttrs.forEach(function (field) {
                    rawDef[field] = attrs[field] ? scope.$eval(attrs[field]) : null;
                    attrs.$observe(field, function (expr) {
                        watchDeregFns[field]();
                        watchDeregFns[field] = scope.$watch(expr, function (newval) {
                            rawDef[field] = newval;
                            update();
                        }, true);
                    });
                });
                update();
                scope.$on('$destroy', $uiRouter.stateRegistry.onStatesChanged(update));
                scope.$on('$destroy', $uiRouter.transitionService.onSuccess({}, update));
                if (!type.clickable)
                    return;
                hookFn = clickHook(element, $state, $timeout, type, getDef);
                element[element.on ? 'on' : 'bind']("click", hookFn);
                scope.$on('$destroy', function () {
                    element[element.off ? 'off' : 'unbind']("click", hookFn);
                });
            }
        };
    }];
/**
 * `ui-sref-active` and `ui-sref-active-eq`: A directive that adds a CSS class when a `ui-sref` is active
 *
 * A directive working alongside [[uiSref]] and [[uiState]] to add classes to an element when the
 * related directive's state is active (and remove them when it is inactive).
 *
 * The primary use-case is to highlight the active link in navigation menus,
 * distinguishing it from the inactive menu items.
 *
 * ### Linking to a `ui-sref` or `ui-state`
 * `ui-sref-active` can live on the same element as `ui-sref`/`ui-state`, or it can be on a parent element.
 * If a `ui-sref-active` is a parent to more than one `ui-sref`/`ui-state`, it will apply the CSS class when **any of the links are active**.
 *
 * ### Matching
 *
 * The `ui-sref-active` directive applies the CSS class when the `ui-sref`/`ui-state`'s target state **or any child state is active**.
 * This is a "fuzzy match" which uses [[StateService.includes]].
 *
 * The `ui-sref-active-eq` directive applies the CSS class when the `ui-sref`/`ui-state`'s target state is directly active (not when child states are active).
 * This is an "exact match" which uses [[StateService.is]].
 *
 * ### Parameter values
 * If the `ui-sref`/`ui-state` includes parameter values, the current parameter values must match the link's values for the link to be highlighted.
 * This allows a list of links to the same state with different parameters to be rendered, and the correct one highlighted.
 *
 * #### Example:
 * ```html
 * <li ng-repeat="user in users" ui-sref-active="active">
 *   <a ui-sref="user.details({ userId: user.id })">{{ user.lastName }}</a>
 * </li>
 * ```
 *
 * ### Examples
 *
 * Given the following template:
 * @example
 * ```html
 * <ul>
 *   <li ui-sref-active="active" class="item">
 *     <a href ui-sref="app.user({user: 'bilbobaggins'})">@bilbobaggins</a>
 *   </li>
 * </ul>
 * ```
 *
 * When the app state is `app.user` (or any child state),
 * and contains the state parameter "user" with value "bilbobaggins",
 * the resulting HTML will appear as (note the 'active' class):
 *
 * ```html
 * <ul>
 *   <li ui-sref-active="active" class="item active">
 *     <a ui-sref="app.user({user: 'bilbobaggins'})" href="/users/bilbobaggins">@bilbobaggins</a>
 *   </li>
 * </ul>
 * ```
 *
 * ### Glob mode
 *
 * It is possible to pass `ui-sref-active` an expression that evaluates to an object.
 * The objects keys represent active class names and values represent the respective state names/globs.
 * `ui-sref-active` will match if the current active state **includes** any of
 * the specified state names/globs, even the abstract ones.
 *
 * #### Example:
 * Given the following template, with "admin" being an abstract state:
 * ```html
 * <div ui-sref-active="{'active': 'admin.**'}">
 *   <a ui-sref-active="active" ui-sref="admin.roles">Roles</a>
 * </div>
 * ```
 *
 * When the current state is "admin.roles" the "active" class will be applied to both the <div> and <a> elements.
 * It is important to note that the state names/globs passed to `ui-sref-active` override any state provided by a linked `ui-sref`.
 *
 * ### Notes:
 *
 * - The class name is interpolated **once** during the directives link time (any further changes to the
 * interpolated value are ignored).
 *
 * - Multiple classes may be specified in a space-separated format: `ui-sref-active='class1 class2 class3'`
 */
var uiSrefActive;
uiSrefActive = ['$state', '$stateParams', '$interpolate', '$uiRouter',
    function $StateRefActiveDirective($state, $stateParams, $interpolate, $uiRouter) {
        return {
            restrict: "A",
            controller: ['$scope', '$element', '$attrs',
                function ($scope, $element, $attrs) {
                    var states = [], activeEqClass, uiSrefActive;
                    // There probably isn't much point in $observing this
                    // uiSrefActive and uiSrefActiveEq share the same directive object with some
                    // slight difference in logic routing
                    activeEqClass = $interpolate($attrs.uiSrefActiveEq || '', false)($scope);
                    try {
                        uiSrefActive = $scope.$eval($attrs.uiSrefActive);
                    }
                    catch (e) {
                    }
                    uiSrefActive = uiSrefActive || $interpolate($attrs.uiSrefActive || '', false)($scope);
                    if (ui_router_core_1.isObject(uiSrefActive)) {
                        ui_router_core_1.forEach(uiSrefActive, function (stateOrName, activeClass) {
                            if (ui_router_core_1.isString(stateOrName)) {
                                var ref = parseStateRef(stateOrName);
                                addState(ref.state, $scope.$eval(ref.paramExpr), activeClass);
                            }
                        });
                    }
                    // Allow uiSref to communicate with uiSrefActive[Equals]
                    this.$$addStateInfo = function (newState, newParams) {
                        // we already got an explicit state provided by ui-sref-active, so we
                        // shadow the one that comes from ui-sref
                        if (ui_router_core_1.isObject(uiSrefActive) && states.length > 0) {
                            return;
                        }
                        var deregister = addState(newState, newParams, uiSrefActive);
                        update();
                        return deregister;
                    };
                    function updateAfterTransition(trans) {
                        trans.promise.then(update);
                    }
                    $scope.$on('$stateChangeSuccess', update);
                    $scope.$on('$destroy', $uiRouter.transitionService.onStart({}, updateAfterTransition));
                    if ($uiRouter.globals.transition) {
                        updateAfterTransition($uiRouter.globals.transition);
                    }
                    function addState(stateName, stateParams, activeClass) {
                        var state = $state.get(stateName, stateContext($element));
                        var stateInfo = {
                            state: state || { name: stateName },
                            params: stateParams,
                            activeClass: activeClass
                        };
                        states.push(stateInfo);
                        return function removeState() {
                            ui_router_core_1.removeFrom(states)(stateInfo);
                        };
                    }
                    // Update route state
                    function update() {
                        var splitClasses = function (str) {
                            return str.split(/\s/).filter(ui_router_core_1.identity);
                        };
                        var getClasses = function (stateList) {
                            return stateList.map(function (x) { return x.activeClass; }).map(splitClasses).reduce(ui_router_core_1.unnestR, []);
                        };
                        var allClasses = getClasses(states).concat(splitClasses(activeEqClass)).reduce(ui_router_core_1.uniqR, []);
                        var fuzzyClasses = getClasses(states.filter(function (x) { return $state.includes(x.state.name, x.params); }));
                        var exactlyMatchesAny = !!states.filter(function (x) { return $state.is(x.state.name, x.params); }).length;
                        var exactClasses = exactlyMatchesAny ? splitClasses(activeEqClass) : [];
                        var addClasses = fuzzyClasses.concat(exactClasses).reduce(ui_router_core_1.uniqR, []);
                        var removeClasses = allClasses.filter(function (cls) { return !ui_router_core_1.inArray(addClasses, cls); });
                        $scope.$evalAsync(function () {
                            addClasses.forEach(function (className) { return $element.addClass(className); });
                            removeClasses.forEach(function (className) { return $element.removeClass(className); });
                        });
                    }
                    update();
                }]
        };
    }];
angular_1.ng.module('ui.router.state')
    .directive('uiSref', uiSref)
    .directive('uiSrefActive', uiSrefActive)
    .directive('uiSrefActiveEq', uiSrefActive)
    .directive('uiState', uiState);
//# sourceMappingURL=stateDirectives.js.map

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @module state */ /** for typedoc */

var angular_1 = __webpack_require__(71);
/**
 * @ngdoc filter
 * @name ui.router.state.filter:isState
 *
 * @requires ui.router.state.$state
 *
 * @description
 * Translates to {@link ui.router.state.$state#methods_is $state.is("stateName")}.
 */
$IsStateFilter.$inject = ['$state'];
function $IsStateFilter($state) {
    var isFilter = function (state, params, options) {
        return $state.is(state, params, options);
    };
    isFilter.$stateful = true;
    return isFilter;
}
exports.$IsStateFilter = $IsStateFilter;
/**
 * @ngdoc filter
 * @name ui.router.state.filter:includedByState
 *
 * @requires ui.router.state.$state
 *
 * @description
 * Translates to {@link ui.router.state.$state#methods_includes $state.includes('fullOrPartialStateName')}.
 */
$IncludedByStateFilter.$inject = ['$state'];
function $IncludedByStateFilter($state) {
    var includesFilter = function (state, params, options) {
        return $state.includes(state, params, options);
    };
    includesFilter.$stateful = true;
    return includesFilter;
}
exports.$IncludedByStateFilter = $IncludedByStateFilter;
angular_1.ng.module('ui.router.state')
    .filter('isState', $IsStateFilter)
    .filter('includedByState', $IncludedByStateFilter);
//# sourceMappingURL=stateFilters.js.map

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @ng1api
 * @module directives
 */ /** for typedoc */
var angular_1 = __webpack_require__(71);
var angular_2 = __webpack_require__(1);
var ui_router_core_1 = __webpack_require__(30);
var views_1 = __webpack_require__(152);
var services_1 = __webpack_require__(151);
/**
 * `ui-view`: A viewport directive which is filled in by a view from the active state.
 *
 * ### Attributes
 *
 * - `name`: (Optional) A view name.
 *   The name should be unique amongst the other views in the same state.
 *   You can have views of the same name that live in different states.
 *   The ui-view can be targeted in a View using the name ([[Ng1StateDeclaration.views]]).
 *
 * - `autoscroll`: an expression. When it evaluates to true, the `ui-view` will be scrolled into view when it is activated.
 *   Uses [[$uiViewScroll]] to do the scrolling.
 *
 * - `onload`: Expression to evaluate whenever the view updates.
 *
 * A view can be unnamed or named.
 * @example
 * ```html
 *
 * <!-- Unnamed -->
 * <div ui-view></div>
 *
 * <!-- Named -->
 * <div ui-view="viewName"></div>
 *
 * <!-- Named (different style) -->
 * <ui-view name="viewName"></ui-view>
 * ```
 *
 * You can only have one unnamed view within any template (or root html). If you are only using a
 * single view and it is unnamed then you can populate it like so:
 * ```
 *
 * <div ui-view></div>
 * $stateProvider.state("home", {
 *   template: "<h1>HELLO!</h1>"
 * })
 * ```
 *
 * The above is a convenient shortcut equivalent to specifying your view explicitly with the {@link ui.router.state.$stateProvider#views `views`}
 * config property, by name, in this case an empty name:
 * ```js
 *
 * $stateProvider.state("home", {
 *   views: {
 *     "": {
 *       template: "<h1>HELLO!</h1>"
 *     }
 *   }
 * })
 * ```
 *
 * But typically you'll only use the views property if you name your view or have more than one view
 * in the same template. There's not really a compelling reason to name a view if its the only one,
 * but you could if you wanted, like so:
 *
 * ```html
 *
 * <div ui-view="main"></div>
 * ```
 *
 * ```js
 *
 * $stateProvider.state("home", {
 *   views: {
 *     "main": {
 *       template: "<h1>HELLO!</h1>"
 *     }
 *   }
 * })
 * ```
 *
 * Really though, you'll use views to set up multiple views:
 * ```html
 *
 * <div ui-view></div>
 * <div ui-view="chart"></div>
 * <div ui-view="data"></div>
 * ```
 *
 * ```js
 * $stateProvider.state("home", {
 *   views: {
 *     "": {
 *       template: "<h1>HELLO!</h1>"
 *     },
 *     "chart": {
 *       template: "<chart_thing/>"
 *     },
 *     "data": {
 *       template: "<data_thing/>"
 *     }
 *   }
 * })
 * ```
 *
 * Examples for `autoscroll`:
 *
 * ```html
 *
 * <!-- If autoscroll present with no expression,
 *      then scroll ui-view into view -->
 * <ui-view autoscroll/>
 *
 * <!-- If autoscroll present with valid expression,
 *      then scroll ui-view into view if expression evaluates to true -->
 * <ui-view autoscroll='true'/>
 * <ui-view autoscroll='false'/>
 * <ui-view autoscroll='scopeVariable'/>
 * ```
 *
 * Resolve data:
 *
 * The resolved data from the state's `resolve` block is placed on the scope as `$resolve` (this
 * can be customized using [[ViewDeclaration.resolveAs]]).  This can be then accessed from the template.
 *
 * Note that when `controllerAs` is being used, `$resolve` is set on the controller instance *after* the
 * controller is instantiated.  The `$onInit()` hook can be used to perform initialization code which
 * depends on `$resolve` data.
 *
 * #### Example:
 * ```js
 * $stateProvider.state('home', {
 *   template: '<my-component user="$resolve.user"></my-component>',
 *   resolve: {
 *     user: function(UserService) { return UserService.fetchUser(); }
 *   }
 * });
 * ```
 */
var uiView;
uiView = ['$view', '$animate', '$uiViewScroll', '$interpolate', '$q',
    function $ViewDirective($view, $animate, $uiViewScroll, $interpolate, $q) {
        function getRenderer(attrs, scope) {
            return {
                enter: function (element, target, cb) {
                    if (angular_1.ng.version.minor > 2) {
                        $animate.enter(element, null, target).then(cb);
                    }
                    else {
                        $animate.enter(element, null, target, cb);
                    }
                },
                leave: function (element, cb) {
                    if (angular_1.ng.version.minor > 2) {
                        $animate.leave(element).then(cb);
                    }
                    else {
                        $animate.leave(element, cb);
                    }
                }
            };
        }
        function configsEqual(config1, config2) {
            return config1 === config2;
        }
        var rootData = {
            $cfg: { viewDecl: { $context: $view._pluginapi._rootViewContext() } },
            $uiView: {}
        };
        var directive = {
            count: 0,
            restrict: 'ECA',
            terminal: true,
            priority: 400,
            transclude: 'element',
            compile: function (tElement, tAttrs, $transclude) {
                return function (scope, $element, attrs) {
                    var previousEl, currentEl, currentScope, unregister, onloadExp = attrs['onload'] || '', autoScrollExp = attrs['autoscroll'], renderer = getRenderer(attrs, scope), viewConfig = undefined, inherited = $element.inheritedData('$uiView') || rootData, name = $interpolate(attrs['uiView'] || attrs['name'] || '')(scope) || '$default';
                    var activeUIView = {
                        $type: 'ng1',
                        id: directive.count++,
                        name: name,
                        fqn: inherited.$uiView.fqn ? inherited.$uiView.fqn + "." + name : name,
                        config: null,
                        configUpdated: configUpdatedCallback,
                        get creationContext() {
                            return ui_router_core_1.parse('$cfg.viewDecl.$context')(inherited);
                        }
                    };
                    ui_router_core_1.trace.traceUIViewEvent("Linking", activeUIView);
                    function configUpdatedCallback(config) {
                        if (config && !(config instanceof views_1.Ng1ViewConfig))
                            return;
                        if (configsEqual(viewConfig, config))
                            return;
                        ui_router_core_1.trace.traceUIViewConfigUpdated(activeUIView, config && config.viewDecl && config.viewDecl.$context);
                        viewConfig = config;
                        updateView(config);
                    }
                    $element.data('$uiView', { $uiView: activeUIView });
                    updateView();
                    unregister = $view.registerUIView(activeUIView);
                    scope.$on("$destroy", function () {
                        ui_router_core_1.trace.traceUIViewEvent("Destroying/Unregistering", activeUIView);
                        unregister();
                    });
                    function cleanupLastView() {
                        if (previousEl) {
                            ui_router_core_1.trace.traceUIViewEvent("Removing (previous) el", previousEl.data('$uiView'));
                            previousEl.remove();
                            previousEl = null;
                        }
                        if (currentScope) {
                            ui_router_core_1.trace.traceUIViewEvent("Destroying scope", activeUIView);
                            currentScope.$destroy();
                            currentScope = null;
                        }
                        if (currentEl) {
                            var _viewData_1 = currentEl.data('$uiViewAnim');
                            ui_router_core_1.trace.traceUIViewEvent("Animate out", _viewData_1);
                            renderer.leave(currentEl, function () {
                                _viewData_1.$$animLeave.resolve();
                                previousEl = null;
                            });
                            previousEl = currentEl;
                            currentEl = null;
                        }
                    }
                    function updateView(config) {
                        var newScope = scope.$new();
                        var animEnter = $q.defer(), animLeave = $q.defer();
                        var $uiViewData = {
                            $cfg: config,
                            $uiView: activeUIView,
                        };
                        var $uiViewAnim = {
                            $animEnter: animEnter.promise,
                            $animLeave: animLeave.promise,
                            $$animLeave: animLeave
                        };
                        /**
                         * @ngdoc event
                         * @name ui.router.state.directive:ui-view#$viewContentLoading
                         * @eventOf ui.router.state.directive:ui-view
                         * @eventType emits on ui-view directive scope
                         * @description
                         *
                         * Fired once the view **begins loading**, *before* the DOM is rendered.
                         *
                         * @param {Object} event Event object.
                         * @param {string} viewName Name of the view.
                         */
                        newScope.$emit('$viewContentLoading', name);
                        var cloned = $transclude(newScope, function (clone) {
                            clone.data('$uiViewAnim', $uiViewAnim);
                            clone.data('$uiView', $uiViewData);
                            renderer.enter(clone, $element, function onUIViewEnter() {
                                animEnter.resolve();
                                if (currentScope)
                                    currentScope.$emit('$viewContentAnimationEnded');
                                if (ui_router_core_1.isDefined(autoScrollExp) && !autoScrollExp || scope.$eval(autoScrollExp)) {
                                    $uiViewScroll(clone);
                                }
                            });
                            cleanupLastView();
                        });
                        currentEl = cloned;
                        currentScope = newScope;
                        /**
                         * @ngdoc event
                         * @name ui.router.state.directive:ui-view#$viewContentLoaded
                         * @eventOf ui.router.state.directive:ui-view
                         * @eventType emits on ui-view directive scope
                         * @description           *
                         * Fired once the view is **loaded**, *after* the DOM is rendered.
                         *
                         * @param {Object} event Event object.
                         */
                        currentScope.$emit('$viewContentLoaded', config || viewConfig);
                        currentScope.$eval(onloadExp);
                    }
                };
            }
        };
        return directive;
    }];
$ViewDirectiveFill.$inject = ['$compile', '$controller', '$transitions', '$view', '$timeout'];
/** @hidden */
function $ViewDirectiveFill($compile, $controller, $transitions, $view, $timeout) {
    var getControllerAs = ui_router_core_1.parse('viewDecl.controllerAs');
    var getResolveAs = ui_router_core_1.parse('viewDecl.resolveAs');
    return {
        restrict: 'ECA',
        priority: -400,
        compile: function (tElement) {
            var initial = tElement.html();
            tElement.empty();
            return function (scope, $element) {
                var data = $element.data('$uiView');
                if (!data) {
                    $element.html(initial);
                    $compile($element.contents())(scope);
                    return;
                }
                var cfg = data.$cfg || { viewDecl: {}, getTemplate: angular_2.noop };
                var resolveCtx = cfg.path && new ui_router_core_1.ResolveContext(cfg.path);
                $element.html(cfg.getTemplate($element, resolveCtx) || initial);
                ui_router_core_1.trace.traceUIViewFill(data.$uiView, $element.html());
                var link = $compile($element.contents());
                var controller = cfg.controller;
                var controllerAs = getControllerAs(cfg);
                var resolveAs = getResolveAs(cfg);
                var locals = resolveCtx && services_1.getLocals(resolveCtx);
                scope[resolveAs] = locals;
                if (controller) {
                    var controllerInstance = $controller(controller, ui_router_core_1.extend({}, locals, { $scope: scope, $element: $element }));
                    if (controllerAs) {
                        scope[controllerAs] = controllerInstance;
                        scope[controllerAs][resolveAs] = locals;
                    }
                    // TODO: Use $view service as a central point for registering component-level hooks
                    // Then, when a component is created, tell the $view service, so it can invoke hooks
                    // $view.componentLoaded(controllerInstance, { $scope: scope, $element: $element });
                    // scope.$on('$destroy', () => $view.componentUnloaded(controllerInstance, { $scope: scope, $element: $element }));
                    $element.data('$ngControllerController', controllerInstance);
                    $element.children().data('$ngControllerController', controllerInstance);
                    registerControllerCallbacks($transitions, controllerInstance, scope, cfg);
                }
                // Wait for the component to appear in the DOM
                if (ui_router_core_1.isString(cfg.viewDecl.component)) {
                    var cmp_1 = cfg.viewDecl.component;
                    var kebobName_1 = ui_router_core_1.kebobString(cmp_1);
                    var getComponentController = function () {
                        var directiveEl = [].slice.call($element[0].children)
                            .filter(function (el) { return el && el.tagName && el.tagName.toLowerCase() === kebobName_1; });
                        return directiveEl && angular_1.ng.element(directiveEl).data("$" + cmp_1 + "Controller");
                    };
                    var deregisterWatch_1 = scope.$watch(getComponentController, function (ctrlInstance) {
                        if (!ctrlInstance)
                            return;
                        registerControllerCallbacks($transitions, ctrlInstance, scope, cfg);
                        deregisterWatch_1();
                    });
                }
                link(scope);
            };
        }
    };
}
/** @hidden */
var hasComponentImpl = typeof angular_1.ng.module('ui.router')['component'] === 'function';
/** @hidden TODO: move these callbacks to $view and/or `/hooks/components.ts` or something */
function registerControllerCallbacks($transitions, controllerInstance, $scope, cfg) {
    // Call $onInit() ASAP
    if (ui_router_core_1.isFunction(controllerInstance.$onInit) && !(cfg.viewDecl.component && hasComponentImpl))
        controllerInstance.$onInit();
    var viewState = ui_router_core_1.tail(cfg.path).state.self;
    var hookOptions = { bind: controllerInstance };
    // Add component-level hook for onParamsChange
    if (ui_router_core_1.isFunction(controllerInstance.uiOnParamsChanged)) {
        var resolveContext = new ui_router_core_1.ResolveContext(cfg.path);
        var viewCreationTrans_1 = resolveContext.getResolvable('$transition$').data;
        // Fire callback on any successful transition
        var paramsUpdated = function ($transition$) {
            // Exit early if the $transition$ is the same as the view was created within.
            // Exit early if the $transition$ will exit the state the view is for.
            if ($transition$ === viewCreationTrans_1 || $transition$.exiting().indexOf(viewState) !== -1)
                return;
            var toParams = $transition$.params("to");
            var fromParams = $transition$.params("from");
            var toSchema = $transition$.treeChanges().to.map(function (node) { return node.paramSchema; }).reduce(ui_router_core_1.unnestR, []);
            var fromSchema = $transition$.treeChanges().from.map(function (node) { return node.paramSchema; }).reduce(ui_router_core_1.unnestR, []);
            // Find the to params that have different values than the from params
            var changedToParams = toSchema.filter(function (param) {
                var idx = fromSchema.indexOf(param);
                return idx === -1 || !fromSchema[idx].type.equals(toParams[param.id], fromParams[param.id]);
            });
            // Only trigger callback if a to param has changed or is new
            if (changedToParams.length) {
                var changedKeys_1 = changedToParams.map(function (x) { return x.id; });
                // Filter the params to only changed/new to params.  `$transition$.params()` may be used to get all params.
                var newValues = ui_router_core_1.filter(toParams, function (val, key) { return changedKeys_1.indexOf(key) !== -1; });
                controllerInstance.uiOnParamsChanged(newValues, $transition$);
            }
        };
        $scope.$on('$destroy', $transitions.onSuccess({}, paramsUpdated, hookOptions));
    }
    // Add component-level hook for uiCanExit
    if (ui_router_core_1.isFunction(controllerInstance.uiCanExit)) {
        var criteria = { exiting: viewState.name };
        $scope.$on('$destroy', $transitions.onBefore(criteria, controllerInstance.uiCanExit, hookOptions));
    }
}
angular_1.ng.module('ui.router.state').directive('uiView', uiView);
angular_1.ng.module('ui.router.state').directive('uiView', $ViewDirectiveFill);
//# sourceMappingURL=viewDirective.js.map

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/** @module ng1 */ /** */
var angular_1 = __webpack_require__(71);
/** @hidden */
function $ViewScrollProvider() {
    var useAnchorScroll = false;
    this.useAnchorScroll = function () {
        useAnchorScroll = true;
    };
    this.$get = ['$anchorScroll', '$timeout', function ($anchorScroll, $timeout) {
            if (useAnchorScroll) {
                return $anchorScroll;
            }
            return function ($element) {
                return $timeout(function () {
                    $element[0].scrollIntoView();
                }, 0, false);
            };
        }];
}
angular_1.ng.module('ui.router.state').provider('$uiViewScroll', $ViewScrollProvider);
//# sourceMappingURL=viewScroll.js.map

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _navbar = __webpack_require__(607);

var _navbar2 = _interopRequireDefault(_navbar);

var _license = __webpack_require__(622);

var _license2 = _interopRequireDefault(_license);

var _logo = __webpack_require__(633);

var _logo2 = _interopRequireDefault(_logo);

var _ybfooter = __webpack_require__(636);

var _ybfooter2 = _interopRequireDefault(_ybfooter);

var _ybfooter3 = __webpack_require__(645);

var _ybfooter4 = _interopRequireDefault(_ybfooter3);

var _modal = __webpack_require__(651);

var _modal2 = _interopRequireDefault(_modal);

var _navtab = __webpack_require__(656);

var _navtab2 = _interopRequireDefault(_navtab);

var _pager = __webpack_require__(662);

var _pager2 = _interopRequireDefault(_pager);

var _progressbar = __webpack_require__(668);

var _progressbar2 = _interopRequireDefault(_progressbar);

var _form = __webpack_require__(673);

var _form2 = _interopRequireDefault(_form);

var _buttonTab = __webpack_require__(689);

var _buttonTab2 = _interopRequireDefault(_buttonTab);

var _ybInput = __webpack_require__(695);

var _ybInput2 = _interopRequireDefault(_ybInput);

var _ybSelect = __webpack_require__(701);

var _ybSelect2 = _interopRequireDefault(_ybSelect);

var _radioList = __webpack_require__(707);

var _radioList2 = _interopRequireDefault(_radioList);

var _dialogModal = __webpack_require__(713);

var _dialogModal2 = _interopRequireDefault(_dialogModal);

var _language = __webpack_require__(719);

var _language2 = _interopRequireDefault(_language);

var _autoFocus = __webpack_require__(725);

var _autoFocus2 = _interopRequireDefault(_autoFocus);

__webpack_require__(726);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var commonModule = _angular2.default.module('app.common', [_navbar2.default, _license2.default, _logo2.default, _ybfooter2.default, _ybfooter4.default, _modal2.default, _navtab2.default, _pager2.default, _progressbar2.default, _form2.default, _buttonTab2.default, _ybInput2.default, _ybSelect2.default, _radioList2.default, _dialogModal2.default, _language2.default]).directive('autoFocus', _autoFocus2.default).name;

exports.default = commonModule;

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = __webpack_require__(73);

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _navbar = __webpack_require__(608);

var _navbar2 = _interopRequireDefault(_navbar);

var _ybDropDown = __webpack_require__(619);

var _ybDropDown2 = _interopRequireDefault(_ybDropDown);

__webpack_require__(620);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var navbarModule = _angular2.default.module('navbar', [_angularUiRouter2.default]).component('navbar', _navbar2.default).directive('ybDropDown', _ybDropDown2.default).name;

exports.default = navbarModule;

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _navbar = __webpack_require__(609);

var _navbar2 = _interopRequireDefault(_navbar);

var _navbar3 = __webpack_require__(610);

var _navbar4 = _interopRequireDefault(_navbar3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var navbarComponent = {
    restrict: 'E',
    bindings: {
        appUser: '='
    },
    template: _navbar2.default,
    controller: _navbar4.default
};

exports.default = navbarComponent;

/***/ }),
/* 609 */
/***/ (function(module, exports) {

module.exports = "<div class=\"navbar\" ng-class=\"{isLogin:!isGuest()}\">\n    <div class=\"container-lg\">\n\n        <a href=\"/\" class=\"logo\" ng-if=\"isGuest()\">\n            <logo></logo>\n        </a>\n\n        <a ui-sref=\"app.home.dashboard\" class=\"logo\" ng-if=\"!isGuest()\">\n            <logo></logo>\n        </a>\n\n        <div class=\"user-menu anonymous\" ng-if=\"isGuest()\">\n            <a class=\"item\" ui-sref=\"app.face.index.user.form.login\">{{'navbar-text001' | translate}}</a>\n            <span class=\"separator\"></span>\n            <a class=\"item\" ui-sref=\"app.face.index.user.form.register\">{{'navbar-text002' | translate}}</a>\n        </div>\n\n        <div id=\"user-menu-profile\" class=\"user-menu profile\" ng-if=\"!isGuest()\" yb-drop-down>\n            <div class=\"avatar\">\n                <img ng-src=\"{{ user.avatar }}\"/>\n            </div>\n            <div class=\"pseudonym\">{{ user.pseudonym }}</div>\n            <div class=\"dropdown\">\n                <a  ng-if=\"$ctrl.jurisdiction('app.home.profile.account')\" class=\"item\" ui-sref=\"app.home.profile.account\">\n                    <i class=\"ybicon yb-user\"></i>\n                    {{'navbar-text003' | translate}}\n                </a>\n                <a  ng-if=\"$ctrl.jurisdiction('app.home.profile.recharge')\" class=\"item\" ui-sref=\"app.home.profile.recharge\">\n                        <i class=\"ybicon yb-coin\"></i>\n                        {{'navbar-text028' | translate}}\n                    </a>\n                <a  ng-if=\"$ctrl.jurisdiction('app.home.whitelist')\" class=\"item\" ui-sref=\"app.home.whitelist\">\n                    <i class=\"ybicon yb-feedback\"></i>\n                    {{'navbar-text004' | translate}}\n                </a>\n                <a  ng-if=\"$ctrl.jurisdiction('app.home.profile.media')\" class=\"item\" ui-sref=\"app.home.profile.media\">\n                    <i class=\"ybicon yb-media-link\"></i>\n                    {{'navbar-text005' | translate}}\n                </a>\n                <a  ng-if=\"$ctrl.jurisdiction('app.home.profile.collect')\" class=\"item\" ui-sref=\"app.home.profile.collect\">\n                    <i class=\"ybicon yb-star\"></i>\n                    {{'navbar-text006' | translate}}\n                </a>\n                <a  ng-if=\"$ctrl.jurisdiction('app.home.profile.orders')&&$ctrl.permission.role_type !== 1\" class=\"item\" ui-sref=\"app.home.profile.orders\">\n                    <i class=\"ybicon yb-paper\"></i>\n                    {{'navbar-text007' | translate}}\n                </a>\n                <a  ng-if=\"$ctrl.jurisdiction('app.home.profile.manage')&&$ctrl.appUser.type===1&&$ctrl.permission.role_type!=2\" class=\"item\" ui-sref=\"app.home.profile.manage\">\n                    <i class=\"ybicon yb-manage\"></i>{{'navbar-text029' | translate}}\n                </a>\n                <a class=\"item\" ng-click=\"logout()\">\n                    <i class=\"ybicon yb-exit\"></i>\n                    {{'navbar-text008' | translate}}\n                </a>\n            </div>\n        </div>\n\n        <div class=\"actions\" ng-if=\"!isGuest()\">\n            <div ng-if=\"$ctrl.permission.role_type !== 1\" class=\"action message\" id=\"new-message\"  ng-class=\"{'new-message':$ctrl.unread_count}\" yb-drop-down>\n                <i class=\"ybicon yb-message\"></i>\n                <div class=\"tooltip dropdown\">\n                    <div class=\"total\">{{$ctrl.unread_count}}&nbsp;{{'navbar-text009' | translate}}\n                        <div class=\"read-all-btn\" ng-click=\"$ctrl.readAll()\">{{'navbar-text010' | translate}}</div>\n                    </div>\n                    <div class=\"list\" ng-if=\"$ctrl.messages && $ctrl.messages.length\">\n                        <div class=\"list-item clearfix\" ng-class=\"{new:$ctrl.last_query_time<message.created_at}\" ng-repeat=\"message in $ctrl.messages track by message.id\">\n                            <div class=\"heading\" ng-if=\"message.notify.trade_type_name ==='TRADE_NOTIFICATION_TYPE_ARTICLE'\">\n                                {{'navbar-text011' | translate}}<a ui-sref=\"app.page.original.article({id: message.notify.detail.article.yuanben_id})\">{{message.notify.detail.article.title}}</a>\n                                {{'navbar-text012' | translate}}<a ui-sref=\"app.page.author({id: message.notify.detail.order.user.uuid})\">{{message.notify.detail.order.user.pseudonym}}</a>\n                                {{'navbar-text013' | translate}}{{message.notify.detail.reproduction.account_type+'&nbsp;'+message.notify.detail.reproduction.account_name}}\n                            </div>\n                            <div class=\"heading\" ng-if=\"message.notify.trade_type_name ==='TRADE_NOTIFICATION_TYPE_IMAGE'\">\n                                {{'navbar-text0111' | translate}}<a ui-sref=\"app.page.original.image({id: message.notify.detail.image.yuanben_id})\">{{message.notify.detail.image.title}}</a>\n                                {{'navbar-text012' | translate}}<a ui-sref=\"app.page.author({id: message.notify.detail.order.user.uuid})\">{{message.notify.detail.order.user.pseudonym}}</a>\n                                {{'navbar-text014' | translate}}\n                            </div>\n                            <div class=\"heading\" ng-if=\"message.notify_type_name ==='INFRINGEMENT_REPORT'\">\n                              【系统提醒】转载报告已生成，请移步至\"<a href=\"javascript:void(0)\" ng-click=\"$ctrl.openDownload()\">转载报告下载中心</a>\"下载文件。\n                            </div>\n                            <div class=\"date\">{{message.created_at * 1000 | date : 'MM月dd日'}}</div>\n                        </div>\n                    </div>\n                    <div class=\"no-list\" ng-if=\"!$ctrl.messages.length\">\n                        {{'navbar-text015' | translate}}\n                    </div>\n                    <a class=\"all\" ui-sref=\"app.home.messages.transactionReminder\" >{{'navbar-text016' | translate}} &#62</a>\n                </div>\n            </div>\n            <a \n                ng-if=\"$ctrl.jurisdiction('app.home.messages.transactionReminder')\"\n                ui-sref=\"app.home.messages.transactionReminder \" id=\"new-message-iphone\" class=\"action with-iphone-message\" ng-class=\"{'new-message':$ctrl.unread_count}\" name=\"{{'navbar-text017' | translate}}\" ui-sref-active=\"active\">\n                <i class=\"ybicon yb-message\"></i>\n            </a>\n            <a \n                ng-if=\"$ctrl.jurisdiction('app.page.search')\"\n                ui-sref=\"app.page.search\" class=\"action\" title=\"{{'navbar-text018' | translate}}\" ui-sref-active=\"active\">\n                <i class=\"ybicon yb-search\"></i>\n            </a>\n            <a \n                ng-if=\"$ctrl.jurisdiction('app.page.verify.main.tsa.form')\"\n                ui-sref=\"app.page.verify.main.tsa.form\" class=\"action\" title=\"{{'navbar-text019' | translate}}\" ui-sref-active=\"active\">\n                <i class=\"ybicon yb-verify-dna\"></i>\n            </a>\n            <a \n                ng-if=\"$ctrl.jurisdiction('app.face.plugin')\"\n                ui-sref=\"app.face.plugin\" class=\"action\" title=\"{{'navbar-text020' | translate}}\" ui-sref-active=\"active\">\n                <i class=\"ybicon yb-plugin\">{{'navbar-text020' | translate}}</i>\n            </a>\n        </div>\n        <div class=\"main-nav\" ng-if=\"!isGuest()\">\n            <div \n                ng-if=\"$ctrl.jurisdiction('app.home.publish.article.edit')||$ctrl.jurisdiction('app.home.publish.image.upload')\"\n                ng-class=\"{'item':true, 'checked':$state.includes('app.home.publish.article') || $state.includes('app.home.publish.image')}\" yb-drop-down>\n                <span class=\"text\">{{'navbar-text021' | translate}}</span>\n                <div class=\"dropdown\">\n                    <a ui-sref=\"app.home.publish.article.edit\"\n                       ng-class=\"{'item':true, 'active':$state.includes('app.home.publish.article')}\">\n                        <span class=\"text\">{{'navbar-text022' | translate}}</span>\n                    </a>\n                    <a ui-sref=\"app.home.publish.image.upload\"\n                       ng-class=\"{'item':true, 'active':$state.includes('app.home.publish.image')}\">\n                        <span class=\"text\">{{'navbar-text023' | translate}}</span>\n                    </a>\n                </div>\n            </div>\n\n            <a \n                ng-if=\"$ctrl.jurisdiction('app.home.originals.articles')\"\n                ui-sref=\"app.home.originals.articles\"\n                ng-class=\"{'item':true, 'active':$state.includes('app.home.originals')}\">\n                <span class=\"text\">{{'navbar-text024' | translate}}</span>\n            </a>\n            <a \n                ng-if=\"$ctrl.jurisdiction('app.home.reprint')\"\n                class=\"item\" ui-sref=\"app.home.reprint\" ui-sref-active=\"active\">\n                <span class=\"text\">{{'navbar-text025' | translate}}</span>\n            </a>\n            <a \n                ng-if=\"$ctrl.jurisdiction('app.home.infringements.dashboard')\"\n                ui-sref=\"app.home.infringements.dashboard\" ng-class=\"{'item':true, 'active':$state.includes('app.home.infringements')}\">\n                <span class=\"text\">{{'navbar-text026' | translate}}</span>\n            </a>\n            <a \n                ng-if=\"$ctrl.jurisdiction('app.home.evidences.all')\"\n                ui-sref=\"app.home.evidences.all\" ng-class=\"{'item':true, 'active':$state.includes('app.home.evidences')}\">\n                <span class=\"text\">{{'navbar-text027' | translate}}</span>\n            </a>\n            <a \n                ng-if=\"$ctrl.jurisdiction('app.home.profile.orders')&&$ctrl.jurisdiction('app.home.profile.orders')!='admin'&&$ctrl.checkRole()\"\n                class=\"item\" ui-sref=\"app.home.profile.orders\" ng-class=\"{'item':true, 'active':$state.includes('app.home.profile.orders')}\">\n                {{'navbar-text007' | translate}}\n            </a>\n\n        </div>\n    </div>\n    <language class=\"inner-nav-lang\"></language>\n</div>\n";

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = __webpack_require__(49);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavbarController = function () {
    NavbarController.$inject = ["$scope", "$state", "userLogin", "NotificationAPI", "$typeMap", "$uibModal", "Jurisdiction"];

    function NavbarController($scope, $state, userLogin, NotificationAPI, $typeMap, $uibModal, Jurisdiction) {
        "ngInject";

        (0, _classCallCheck3.default)(this, NavbarController);
        this.$uibModal = $uibModal;
        $scope.user = this.appUser;
        this.Jurisdiction = Jurisdiction;
        $scope.logout = function () {
            userLogin.logout().then(function () {
                window.localStorage.removeItem("loginUser");
                $state.go('app.face.index.frontpage');
            });
        };
        this.$state = $state;
        this.typeMap = $typeMap;
        this.permission = JSON.parse(window.localStorage.getItem("loginUser"));
        $scope.isGuest = userLogin.isGuest;
        $scope.$state = $state;
        this.jurisdiction();
        this.NotificationAPI = NotificationAPI;
        if (!$scope.isGuest()) {
            this.loadMessages();
        }
    }

    (0, _createClass3.default)(NavbarController, [{
        key: "loadMessages",
        value: function loadMessages() {
            var self = this;
            this.NotificationAPI.one('top5').get().then(function (res) {
                if (res.status.code == 200) {
                    self.last_query_time = res.data.last_query_time;
                    self.unread_count = res.data.unread_count;
                    self.messages = res.data.notifications;
                } else {
                    self.message.error(res.status.message);
                }
            }, function (err) {
                self.message.error(err.data);
            });
        }
    }, {
        key: "readAll",
        value: function readAll() {
            //全部已读
            var self = this;
            this.NotificationAPI.one().get({ page: 15, page_size: 1 }).then(function (res) {
                if (res.status.code == 200) {
                    self.unread_count = 0;
                    self.last_query_time = +(new Date().getTime() / 1000);
                } else {
                    self.message.error(res.status.message);
                }
            }, function (err) {
                self.message.error(err.data);
            });
        }
    }, {
        key: "openDownload",
        value: function openDownload() {
            this.$uibModal.open({
                animation: true,
                component: 'downlistModal',
                windowClass: 'dd-modal'
            });
        }
    }, {
        key: "jurisdiction",
        value: function jurisdiction(route_name) {

            var params = (0, _assign2.default)(this.permission, { route_name: route_name, checkType: "route" });
            return this.Jurisdiction.checkStatus(params);
        }
    }, {
        key: "checkRole",
        value: function checkRole() {
            //  console.log()
            //  this.permission.role_type === 1
            return this.permission.role_type === 1;
        }
    }]);
    return NavbarController;
}();

exports.default = NavbarController;

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(612);
module.exports = __webpack_require__(24).Object.assign;


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(50);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(613) });


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(115);
var gOPS = __webpack_require__(353);
var pIE = __webpack_require__(348);
var toObject = __webpack_require__(117);
var IObject = __webpack_require__(176);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(85)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(114);
var toLength = __webpack_require__(166);
var toAbsoluteIndex = __webpack_require__(615);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(155);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(617), __esModule: true };

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(618);
var $Object = __webpack_require__(24).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(50);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(63), 'Object', { defineProperty: __webpack_require__(72).f });


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

/**
 * Created by lency on 9/20/16.
 */
exports.default = function () {
    return function (scope, elem, attrs) {

        elem.on('mouseenter.ybdropdown', function (e) {

            e.preventDefault();
            e.stopPropagation();
            var $toggle = $(e.currentTarget);
            $toggle.addClass('active');
        }).on('mouseleave.ybdropdown', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var $toggle = $(e.currentTarget);
            $toggle.removeClass('active');
        });
        var $toggle = void 0;
        elem.on('touchstart', function (e) {
            e.stopPropagation();
            $toggle = $(e.currentTarget);
            $toggle.addClass('active');
            $('body').on('touchstart', function () {
                $toggle.removeClass('active');
            });
        });
    };
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(621);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./navbar.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./navbar.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".navbar {\n  position: relative;\n  height: 70px;\n  background-color: #2b2b2b; }\n  .navbar .container-lg {\n    max-width: 1200px;\n    width: 100%;\n    margin: 0 auto;\n    height: 70px;\n    padding-left: 20px;\n    font-size: 0; }\n  .navbar .content {\n    position: relative;\n    height: 100%; }\n  .navbar .logo {\n    float: left;\n    padding-top: 20px;\n    width: 60px;\n    height: 70px; }\n    .navbar .logo svg {\n      fill: #ffffff; }\n  .navbar .main-nav {\n    float: left;\n    height: 70px;\n    line-height: 70px;\n    padding-left: 8%;\n    width: 49%; }\n    .navbar .main-nav .item {\n      position: relative;\n      font-size: 16px;\n      color: #dddddd;\n      text-decoration: none;\n      display: inline-block;\n      width: 20%;\n      text-align: center;\n      cursor: pointer; }\n      .navbar .main-nav .item:hover, .navbar .main-nav .item.checked, .navbar .main-nav .item.active {\n        background-color: #000;\n        color: #fff; }\n      .navbar .main-nav .item.active .dropdown {\n        display: block; }\n      .navbar .main-nav .item .item {\n        width: 100%;\n        color: #fff;\n        padding-left: 0; }\n  .navbar .actions {\n    float: right;\n    height: 70px;\n    line-height: 70px;\n    padding-right: 1%; }\n    .navbar .actions .action {\n      position: relative;\n      float: left;\n      padding: 0 15px;\n      height: 70px;\n      text-align: center;\n      color: #fff;\n      text-decoration: none;\n      cursor: pointer; }\n      .navbar .actions .action.message {\n        display: block; }\n      .navbar .actions .action.with-iphone-message {\n        display: none; }\n      .navbar .actions .action:hover, .navbar .actions .action.active {\n        background-color: #1b1b1b; }\n      .navbar .actions .action i {\n        width: 20px;\n        height: 20px;\n        font-size: 20px;\n        line-height: 70px; }\n        .navbar .actions .action i.yb-plugin {\n          font-size: 16px; }\n      .navbar .actions .action.active .dropdown {\n        display: block; }\n      .navbar .actions .action.new-message:after {\n        position: absolute;\n        content: '';\n        width: 6px;\n        height: 6px;\n        background: red;\n        border-radius: 100%;\n        top: 23px;\n        right: 25px; }\n  .navbar .user-menu {\n    position: relative;\n    height: 70px;\n    line-height: 70px;\n    float: right;\n    color: #666666; }\n    .navbar .user-menu.anonymous {\n      padding-right: 20px; }\n      .navbar .user-menu.anonymous .item {\n        display: inline-block;\n        vertical-align: top;\n        height: 100%;\n        text-decoration: none;\n        font-size: 16px;\n        color: #dddddd; }\n        .navbar .user-menu.anonymous .item:hover {\n          color: #ffffff; }\n      .navbar .user-menu.anonymous .separator {\n        display: inline-block;\n        margin: 27px 8px 0 8px;\n        width: 1px;\n        height: 16px;\n        background-color: #dddddd; }\n    .navbar .user-menu.profile {\n      width: 140px;\n      cursor: pointer;\n      padding: 0 12px; }\n      .navbar .user-menu.profile .avatar {\n        position: absolute;\n        width: 32px;\n        height: 32px;\n        left: 12px;\n        top: 19px; }\n        .navbar .user-menu.profile .avatar img {\n          display: block;\n          width: 100%;\n          height: 100%; }\n      .navbar .user-menu.profile .pseudonym {\n        position: relative;\n        margin-left: 44px;\n        color: #dddddd;\n        font-size: 14px;\n        overflow: hidden;\n        white-space: nowrap;\n        text-overflow: ellipsis; }\n      .navbar .user-menu.profile:hover, .navbar .user-menu.profile.active {\n        color: #ffffff;\n        background-color: #1b1b1b; }\n        .navbar .user-menu.profile:hover .pseudonym, .navbar .user-menu.profile.active .pseudonym {\n          color: #ffffff; }\n      .navbar .user-menu.profile.active .dropdown {\n        display: block; }\n  .navbar .dropdown {\n    position: absolute;\n    display: none;\n    right: 0;\n    top: 70px;\n    background-color: #2b2b2b;\n    width: 100%;\n    color: #dddddd;\n    z-index: 1030; }\n    .navbar .dropdown .item {\n      display: block;\n      height: 40px;\n      line-height: 40px;\n      padding-left: 16px;\n      font-size: 14px;\n      color: #dddddd;\n      text-decoration: none; }\n      .navbar .dropdown .item .yb-manage {\n        font-size: 22px;\n        vertical-align: middle;\n        margin-left: -2px;\n        margin-right: 1px; }\n      .navbar .dropdown .item:not(:first-child) {\n        border-top: 1px solid #3b3b3b; }\n      .navbar .dropdown .item:hover {\n        color: #ffffff; }\n  .navbar .dropdown.tooltip {\n    width: 410px;\n    background: #fff;\n    color: #666666;\n    font-size: 14px;\n    line-height: 1.4;\n    text-align: left;\n    box-shadow: 0px 3px 10px #ccc;\n    right: -147px; }\n    .navbar .dropdown.tooltip .total {\n      border-bottom: 1px solid #e8eaea;\n      padding: 10px; }\n      .navbar .dropdown.tooltip .total .read-all-btn {\n        position: absolute;\n        right: 10px;\n        top: 6px;\n        color: #fff;\n        background: #00816a;\n        display: inline-block;\n        padding: 5px 12px;\n        cursor: pointer;\n        border-radius: 2px;\n        font-size: 12px; }\n    .navbar .dropdown.tooltip .list .list-item {\n      padding: 10px;\n      border-bottom: 1px solid #e8eaea;\n      cursor: default;\n      font-size: 0; }\n      .navbar .dropdown.tooltip .list .list-item.new {\n        background: #f2f9f7; }\n      .navbar .dropdown.tooltip .list .list-item .heading {\n        float: left;\n        width: 330px;\n        font-size: 14px; }\n        .navbar .dropdown.tooltip .list .list-item .heading a {\n          color: #4477b0;\n          text-decoration: none;\n          margin: 0 5px; }\n      .navbar .dropdown.tooltip .list .list-item .date {\n        float: right;\n        width: 60px;\n        margin-top: 2px;\n        color: #999999;\n        text-align: right;\n        font-size: 12px; }\n    .navbar .dropdown.tooltip .no-list {\n      line-height: 210px;\n      text-align: center;\n      color: #999999;\n      border-bottom: 1px solid #e8eaea; }\n    .navbar .dropdown.tooltip .all {\n      display: block;\n      text-align: center;\n      line-height: 50px;\n      cursor: pointer;\n      color: #00816a;\n      text-decoration: none; }\n      .navbar .dropdown.tooltip .all:hover {\n        text-decoration: underline; }\n      .navbar .dropdown.tooltip .all.disabled {\n        color: #cccccc; }\n    .navbar .dropdown.tooltip:before {\n      content: '';\n      position: absolute;\n      bottom: 100%;\n      left: 225px;\n      border: 10px solid transparent;\n      border-bottom-color: #fff; }\n\n/* Small Devices, Mobile */\n@media only screen and (max-width: 865px) {\n  .navbar {\n    height: 40px; }\n    .navbar.isLogin {\n      height: 80px; }\n    .navbar .container-lg {\n      width: 100%;\n      margin: 0 auto;\n      padding: 0;\n      height: 100%; }\n    .navbar .logo {\n      padding: 10px;\n      height: 40px;\n      margin: 0; }\n    .navbar .main-nav {\n      float: left;\n      position: relative;\n      z-index: 1;\n      width: 100%;\n      height: 40px;\n      line-height: 40px;\n      padding: 0;\n      background: #fff;\n      border-bottom: 1px solid #dadedd; }\n      .navbar .main-nav > .item {\n        position: relative;\n        font-size: 14px;\n        color: #222222;\n        height: 40px; }\n        .navbar .main-nav > .item.active, .navbar .main-nav > .item.checked, .navbar .main-nav > .item:hover {\n          background: none;\n          color: #00816a;\n          font-weight: bold;\n          border-bottom: 2px solid #00816a; }\n        .navbar .main-nav > .item .dropdown {\n          background: #333; }\n    .navbar .user-menu {\n      position: relative;\n      z-index: 2;\n      height: 40px;\n      line-height: 40px;\n      float: right; }\n      .navbar .user-menu.profile {\n        width: 40px;\n        max-width: 140px;\n        padding: 0 5px 0 0; }\n        .navbar .user-menu.profile .avatar {\n          width: 30px;\n          height: 30px;\n          left: 5px;\n          top: 5px; }\n        .navbar .user-menu.profile .pseudonym {\n          margin-left: 40px;\n          font-size: 12px;\n          display: none; }\n      .navbar .user-menu.anonymous .separator {\n        margin-top: 12px; }\n      .navbar .user-menu .dropdown {\n        width: 140px; }\n    .navbar .actions {\n      width: 50%;\n      height: 40px;\n      line-height: 40px;\n      margin-right: 0; }\n      .navbar .actions .action {\n        padding-right: 10px;\n        height: 40px; }\n        .navbar .actions .action.message {\n          display: none; }\n        .navbar .actions .action.with-iphone-message {\n          display: block; }\n          .navbar .actions .action.with-iphone-message.new-message:after {\n            top: 10px;\n            right: 10px; }\n        .navbar .actions .action i {\n          font-size: 16px;\n          line-height: 40px; }\n    .navbar .dropdown {\n      top: 40px;\n      font-weight: normal;\n      color: #dddddd; } }\n", ""]);

// exports


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _license = __webpack_require__(623);

var _license2 = _interopRequireDefault(_license);

var _licenseIcons = __webpack_require__(627);

var _licenseIcons2 = _interopRequireDefault(_licenseIcons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var licenseModule = _angular2.default.module('license', [_licenseIcons2.default]).component('license', _license2.default).name; /**
                                                                                                                                 * Created by lency on 9/22/2016.
                                                                                                                                 */
exports.default = licenseModule;

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _license = __webpack_require__(624);

var _license2 = _interopRequireDefault(_license);

__webpack_require__(625);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by lency on 9/22/2016.
 */
var licenseComponent = {
    restrict: 'E',
    bindings: {
        'license': '=',
        'licenseConfirm': '=',
        'dna': '='
    },
    template: _license2.default
};

exports.default = licenseComponent;

/***/ }),
/* 624 */
/***/ (function(module, exports) {

module.exports = "<div class=\"license\">\n    <license-icons license=\"$ctrl.license\" ng-if=\"!$ctrl.licenseConfirm\"></license-icons>\n    <div class=\"dna\" ng-if=\"$ctrl.dna\">DNA : {{ $ctrl.dna }}</div>\n    <div ng-class=\"{'text': true, 'no-title': $ctrl.licenseConfirm}\">\n        <div class=\"cc\" ng-show=\"$ctrl.license.type=='cc'\">\n            <span class=\"license-sup\" ng-if=\"!$ctrl.licenseConfirm\">\n                {{'license-text030' | translate}}\n            <a class=\"license-link\" href=\"http://creativecommons.org/licenses/by-nc-nd/4.0\"\n               ng-if=\"$ctrl.license.content.commercial=='n' && $ctrl.license.content.adaptation=='n'\" target=\"_blank\">{{'license-text032' | translate}}-{{'license-text033' | translate}}-{{'license-text034' | translate}}\n                {{'license-text031' | translate}}</a>\n            <a class=\"license-link\" href=\"http://creativecommons.org/licenses/by-nc/4.0\"\n               ng-if=\"$ctrl.license.content.commercial=='n' && $ctrl.license.content.adaptation=='y'\" target=\"_blank\">{{'license-text032' | translate}}-{{'license-text033' | translate}}\n                {{'license-text031' | translate}}</a>\n            <a class=\"license-link\" href=\"http://creativecommons.org/licenses/by-nc-sa/4.0\"\n               ng-if=\"$ctrl.license.content.commercial=='n' && $ctrl.license.content.adaptation=='sa'\" target=\"_blank\">{{'license-text032' | translate}}-{{'license-text033' | translate}}-{{'license-text035' | translate}}\n                {{'license-text031' | translate}}</a>\n            <a class=\"license-link\" href=\"http://creativecommons.org/licenses/by-nd/4.0\"\n               ng-if=\"$ctrl.license.content.commercial=='y' && $ctrl.license.content.adaptation=='n'\" target=\"_blank\">{{'license-text032' | translate}}-{{'license-text034' | translate}}\n                {{'license-text031' | translate}}</a>\n            <a class=\"license-link\" href=\"https://creativecommons.org/licenses/by/4.0\"\n               ng-if=\"$ctrl.license.content.commercial=='y' && $ctrl.license.content.adaptation=='y'\" target=\"_blank\">{{'license-text032' | translate}}{{'license-text031' | translate}}</a>\n            <a class=\"license-link\" href=\"http://creativecommons.org/licenses/by-sa/4.0\"\n               ng-if=\"$ctrl.license.content.commercial=='y' && $ctrl.license.content.adaptation=='sa'\" target=\"_blank\">{{'license-text032' | translate}}-{{'license-text035' | translate}}\n                {{'license-text031' | translate}}</a>\n                {{'license-text036' | translate}}</span>\n            <ul class=\"details\">\n                <li ng-if=\"$ctrl.licenseConfirm\">\n                    {{'license-text037' | translate}}\n                    <a class=\"license-link\" href=\"http://creativecommons.org/licenses/by-nc-nd/4.0\"\n                       ng-if=\"$ctrl.license.content.commercial=='n' && $ctrl.license.content.adaptation=='n'\"\n                       target=\"_blank\">{{'license-text032' | translate}}-{{'license-text033' | translate}}-{{'license-text034' | translate}}\n                        {{'license-text031' | translate}}</a>\n                    <a class=\"license-link\" href=\"http://creativecommons.org/licenses/by-nc/4.0\"\n                       ng-if=\"$ctrl.license.content.commercial=='n' && $ctrl.license.content.adaptation=='y'\"\n                       target=\"_blank\">{{'license-text032' | translate}}-{{'license-text033' | translate}}\n                        {{'license-text031' | translate}}</a>\n                    <a class=\"license-link\" href=\"http://creativecommons.org/licenses/by-nc-sa/4.0\"\n                       ng-if=\"$ctrl.license.content.commercial=='n' && $ctrl.license.content.adaptation=='sa'\"\n                       target=\"_blank\">{{'license-text032' | translate}}-{{'license-text033' | translate}}-{{'license-text035' | translate}}\n                        {{'license-text031' | translate}}</a>\n                    <a class=\"license-link\" href=\"http://creativecommons.org/licenses/by-nd/4.0\"\n                       ng-if=\"$ctrl.license.content.commercial=='y' && $ctrl.license.content.adaptation=='n'\"\n                       target=\"_blank\">{{'license-text032' | translate}}-{{'license-text034' | translate}}\n                        {{'license-text031' | translate}}</a>\n                    <a class=\"license-link\" href=\"https://creativecommons.org/licenses/by/4.0\"\n                       ng-if=\"$ctrl.license.content.commercial=='y' && $ctrl.license.content.adaptation=='y'\"\n                       target=\"_blank\">{{'license-text032' | translate}}{{'license-text031' | translate}}</a>\n                    <a class=\"license-link\" href=\"http://creativecommons.org/licenses/by-sa/4.0\"\n                       ng-if=\"$ctrl.license.content.commercial=='y' && $ctrl.license.content.adaptation=='sa'\"\n                       target=\"_blank\">{{'license-text032' | translate}}-{{'license-text035' | translate}}\n                        {{'license-text031' | translate}}</a>\n                    {{'license-text036' | translate}}\n                </li>\n                <li>{{'license-text038' | translate}}</li>\n                <li ng-if=\"$ctrl.license.content.commercial=='n'\">{{'license-text039' | translate}}</li>\n                <li ng-if=\"$ctrl.license.content.commercial=='y'\">{{'license-text040' | translate}}</li>\n                <li ng-if=\"$ctrl.license.content.adaptation=='n'\">{{'license-text041' | translate}}</li>\n                <li ng-if=\"$ctrl.license.content.adaptation=='y'\">{{'license-text042' | translate}}</li>\n                <li ng-if=\"$ctrl.license.content.adaptation=='sa'\">{{'license-text043' | translate}}</li>\n                <li ng-if=\"$ctrl.licenseConfirm\">{{'license-text044' | translate}}</li>\n            </ul>\n        </div>\n        <div class=\"cm\" ng-show=\"$ctrl.license.type=='cm'\">\n            {{'license-text045' | translate}}\n            <ul class=\"details\">\n                <li ng-if=\"$ctrl.license.content.adaptation=='n'\">{{'license-text046' | translate}}</li>\n                <li ng-if=\"$ctrl.license.content.adaptation=='y'\">{{'license-text047' | translate}}</li>\n            </ul>\n        </div>\n        <div class=\"cm\" ng-show=\"$ctrl.license.type=='cmc'\">\n            {{'license-text045' | translate}}\n            <ul class=\"details\">\n                <li ng-if=\"$ctrl.license.content.cm_adaptation=='n'\">{{'license-text046' | translate}}</li>\n                <li ng-if=\"$ctrl.license.content.cm_adaptation=='y'\">{{'license-text047' | translate}}</li>\n            </ul>\n        </div>\n        <div class=\"cc\" ng-show=\"$ctrl.license.type=='cmc'\">\n            <span class=\"license-sup\" ng-if=\"!$ctrl.licenseConfirm\">\n                {{'license-text065' | translate}}\n            <a class=\"license-link\" href=\"http://creativecommons.org/licenses/by-nc-nd/4.0\"\n               ng-if=\"$ctrl.license.content.commercial=='n' && $ctrl.license.content.cc_adaptation=='n'\" target=\"_blank\">{{'license-text032' | translate}}-{{'license-text033' | translate}}-{{'license-text034' | translate}}\n                {{'license-text031' | translate}}</a>\n            <a class=\"license-link\" href=\"http://creativecommons.org/licenses/by-nc/4.0\"\n               ng-if=\"$ctrl.license.content.commercial=='n' && $ctrl.license.content.cc_adaptation=='y'\" target=\"_blank\">{{'license-text032' | translate}}-{{'license-text033' | translate}}\n                {{'license-text031' | translate}}</a>\n            <a class=\"license-link\" href=\"http://creativecommons.org/licenses/by-nc-sa/4.0\"\n               ng-if=\"$ctrl.license.content.commercial=='n' && $ctrl.license.content.cc_adaptation=='sa'\" target=\"_blank\">{{'license-text032' | translate}}-{{'license-text033' | translate}}-{{'license-text035' | translate}}\n                {{'license-text031' | translate}}</a>\n            <a class=\"license-link\" href=\"http://creativecommons.org/licenses/by-nd/4.0\"\n               ng-if=\"$ctrl.license.content.commercial=='y' && $ctrl.license.content.cc_adaptation=='n'\" target=\"_blank\">{{'license-text032' | translate}}-{{'license-text034' | translate}}\n                {{'license-text031' | translate}}</a>\n            <a class=\"license-link\" href=\"https://creativecommons.org/licenses/by/4.0\"\n               ng-if=\"$ctrl.license.content.commercial=='y' && $ctrl.license.content.cc_adaptation=='y'\" target=\"_blank\">{{'license-text032' | translate}}{{'license-text031' | translate}}</a>\n            <a class=\"license-link\" href=\"http://creativecommons.org/licenses/by-sa/4.0\"\n               ng-if=\"$ctrl.license.content.commercial=='y' && $ctrl.license.content.cc_adaptation=='sa'\" target=\"_blank\">{{'license-text032' | translate}}-{{'license-text035' | translate}}\n                {{'license-text031' | translate}}</a>\n                {{'license-text036' | translate}}</span>\n            <ul class=\"details\">\n                <li ng-if=\"$ctrl.licenseConfirm\">\n                    {{'license-text037' | translate}}\n                    <a class=\"license-link\" href=\"http://creativecommons.org/licenses/by-nc-nd/4.0\"\n                       ng-if=\"$ctrl.license.content.commercial=='n' && $ctrl.license.content.cc_adaptation=='n'\"\n                       target=\"_blank\">{{'license-text032' | translate}}-{{'license-text033' | translate}}-{{'license-text034' | translate}}\n                        {{'license-text031' | translate}}</a>\n                    <a class=\"license-link\" href=\"http://creativecommons.org/licenses/by-nc/4.0\"\n                       ng-if=\"$ctrl.license.content.commercial=='n' && $ctrl.license.content.cc_adaptation=='y'\"\n                       target=\"_blank\">{{'license-text032' | translate}}-{{'license-text033' | translate}}\n                        {{'license-text031' | translate}}</a>\n                    <a class=\"license-link\" href=\"http://creativecommons.org/licenses/by-nc-sa/4.0\"\n                       ng-if=\"$ctrl.license.content.commercial=='n' && $ctrl.license.content.cc_adaptation=='sa'\"\n                       target=\"_blank\">{{'license-text032' | translate}}-{{'license-text033' | translate}}-{{'license-text035' | translate}}\n                        {{'license-text031' | translate}}</a>\n                    <a class=\"license-link\" href=\"http://creativecommons.org/licenses/by-nd/4.0\"\n                       ng-if=\"$ctrl.license.content.commercial=='y' && $ctrl.license.content.cc_adaptation=='n'\"\n                       target=\"_blank\">{{'license-text032' | translate}}-{{'license-text034' | translate}}\n                        {{'license-text031' | translate}}</a>\n                    <a class=\"license-link\" href=\"https://creativecommons.org/licenses/by/4.0\"\n                       ng-if=\"$ctrl.license.content.commercial=='y' && $ctrl.license.content.cc_adaptation=='y'\"\n                       target=\"_blank\">{{'license-text032' | translate}}{{'license-text031' | translate}}</a>\n                    <a class=\"license-link\" href=\"http://creativecommons.org/licenses/by-sa/4.0\"\n                       ng-if=\"$ctrl.license.content.commercial=='y' && $ctrl.license.content.cc_adaptation=='sa'\"\n                       target=\"_blank\">{{'license-text032' | translate}}-{{'license-text035' | translate}}\n                        {{'license-text031' | translate}}</a>\n                    {{'license-text036' | translate}}\n                </li>\n                <li>{{'license-text038' | translate}}</li>\n                <li ng-if=\"$ctrl.license.content.commercial=='n'\">{{'license-text039' | translate}}</li>\n                <li ng-if=\"$ctrl.license.content.commercial=='y'\">{{'license-text040' | translate}}</li>\n                <li ng-if=\"$ctrl.license.content.cc_adaptation=='n'\">{{'license-text041' | translate}}</li>\n                <li ng-if=\"$ctrl.license.content.cc_adaptation=='y'\">{{'license-text042' | translate}}</li>\n                <li ng-if=\"$ctrl.license.content.cc_adaptation=='sa'\">{{'license-text043' | translate}}</li>\n                <li ng-if=\"$ctrl.licenseConfirm\">{{'license-text044' | translate}}</li>\n            </ul>\n        </div>\n        <div class=\"cc\" ng-show=\"$ctrl.license.type=='cc0'\">\n            <span ng-if=\"!$ctrl.licenseConfirm\">{{'license-text030' | translate}}\n            <a class=\"license-link\" href=\"https://creativecommons.org/licenses/by/4.0\" target=\"_blank\">{{'license-text032' | translate}}{{'license-text031' | translate}}</a>\n                {{'license-text036' | translate}}</span>\n            <ul class=\"details\">\n                <li>{{'license-text048' | translate}}</li>\n            </ul>\n        </div>\n\n    </div>\n</div>\n";

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(626);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./license.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./license.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".license .dna {\n  color: #666666;\n  font-size: 14px;\n  padding: 10px 0 14px;\n  border-bottom: 1px dashed #e8eaea;\n  font-weight: bold; }\n\n.license .text {\n  margin-top: 16px;\n  color: #999999;\n  font-size: 14px; }\n  .license .text.no-title {\n    margin-top: 0; }\n  .license .text .license-sup {\n    line-height: 1.6; }\n  .license .text .license-link {\n    color: #00816a;\n    text-decoration: underline; }\n  .license .text .details {\n    padding-left: 20px;\n    margin-top: 10px; }\n    .license .text .details li {\n      line-height: 1.6; }\n", ""]);

// exports


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _licenseIcons = __webpack_require__(628);

var _licenseIcons2 = _interopRequireDefault(_licenseIcons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by ganlu on 27/12/2016.
 */
var licenseIconsModule = _angular2.default.module('licenseIcons', []).component('licenseIcons', _licenseIcons2.default).name;

exports.default = licenseIconsModule;

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _licenseIcons = __webpack_require__(629);

var _licenseIcons2 = _interopRequireDefault(_licenseIcons);

__webpack_require__(631);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by ganlu on 27/12/2016.
 */
var licenseIconsComponent = {
    restrict: 'E',
    bindings: {
        'license': '='
    },
    template: _licenseIcons2.default
};

exports.default = licenseIconsComponent;

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<div class=\"icons\">\n    <div class=\"cc\" ng-if=\"$ctrl.license.type=='cc'\">\n        <a href=\"javascript:void(0)\" class=\"cc-icon\" title=\"{{'license-text049' | translate}}\">\n            <img src=\"" + __webpack_require__(168) + "\"/>\n        </a>\n        <a href=\"javascript:void(0)\" title=\"{{'license-text050' | translate}}\">\n            <img src=\"" + __webpack_require__(160) + "\"/>\n        </a>\n        <a href=\"javascript:void(0)\" title=\"{{'license-text051' | translate}}\"\n           ng-show=\"$ctrl.license.content.commercial=='n'\">\n            <img src=\"" + __webpack_require__(164) + "\"/>\n        </a>\n        <a href=\"javascript:void(0)\" title=\"{{'license-text052' | translate}}\" ng-show=\"$ctrl.license.content.adaptation=='n'\">\n            <img src=\"" + __webpack_require__(169) + "\"/>\n        </a>\n        <a href=\"javascript:void(0)\" title=\"{{'license-text053' | translate}}\"\n           ng-show=\"$ctrl.license.content.adaptation=='sa'\">\n            <img src=\"" + __webpack_require__(170) + "\"/>\n        </a>\n    </div>\n    <div class=\"cm\" ng-if=\"$ctrl.license.type=='cm'\">\n        <a href=\"javascript:void(0)\" title=\"{{'license-text054' | translate}}\">\n            <img src=\"" + __webpack_require__(171) + "\"/>\n        </a>\n        <span class=\"price\">{{'license-text055' | translate}}&nbsp;￥{{ $ctrl.license.content.price / 100 }}</span>\n    </div>\n    <div class=\"cm\" ng-if=\"$ctrl.license.type=='cmc'\">\n        <div class=\"cmc\">\n            <a href=\"javascript:void(0)\" title=\"{{'license-text054' | translate}}\">\n                <img src=\"" + __webpack_require__(171) + "\"/>\n            </a>\n            <span class=\"price\">{{'license-text055' | translate}}&nbsp;￥{{ $ctrl.license.content.price / 100 }}&nbsp;{{}}</span>\n            <span class=\"price\">({{$ctrl.license.content.expire | date : 'yyyy年MM月dd日'  }}后本文免费)</span>\n        </div>\n        <div>\n            <a href=\"javascript:void(0)\" class=\"cc-icon\" title=\"{{'license-text049' | translate}}\">\n                <img src=\"" + __webpack_require__(168) + "\"/>\n            </a>\n            <a href=\"javascript:void(0)\" title=\"{{'license-text050' | translate}}\">\n                <img src=\"" + __webpack_require__(160) + "\"/>\n            </a>\n            <a href=\"javascript:void(0)\" title=\"{{'license-text051' | translate}}\"\n               ng-show=\"$ctrl.license.content.commercial=='n'\">\n                <img src=\"" + __webpack_require__(164) + "\"/>\n            </a>\n            <a href=\"javascript:void(0)\" title=\"{{'license-text052' | translate}}\" ng-show=\"$ctrl.license.content.cc_adaptation=='n'\">\n                <img src=\"" + __webpack_require__(169) + "\"/>\n            </a>\n            <a href=\"javascript:void(0)\" title=\"{{'license-text053' | translate}}\"\n               ng-show=\"$ctrl.license.content.cc_adaptation=='sa'\">\n                <img src=\"" + __webpack_require__(170) + "\"/>\n            </a>\n        </div>\n    </div>\n    <div class=\"cc\" ng-if=\"$ctrl.license.type=='cc0'\">\n        <a href=\"javascript:void(0)\"  title=\"{{'license-text056' | translate}}\">\n            <img src=\"" + __webpack_require__(630) + "\"/>\n        </a>\n    </div>\n</div>\n";

/***/ }),
/* 630 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0i5Zu+5bGCXzEiIGRhdGEtbmFtZT0i5Zu+5bGCIDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDE2IDE2Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGwtcnVsZTpldmVub2RkO308L3N0eWxlPjwvZGVmcz48dGl0bGU+Y2MwPC90aXRsZT48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik04LDBBNy44MSw3LjgxLDAsMCwxLDEzLjcsMi4zNGE3LjcsNy43LDAsMCwxLDEuNzEsMi41OEE4LjE0LDguMTQsMCwwLDEsMTYsOGE4LjE2LDguMTYsMCwwLDEtLjU4LDMuMDgsNy4zNCw3LjM0LDAsMCwxLTEuNzEsMi41NCw4LjIzLDguMjMsMCwwLDEtMi42NiwxLjc3QTgsOCwwLDAsMSw4LDE2YTcuNzgsNy43OCwwLDAsMS0zLS42MSw4LDgsMCwwLDEtMi42LTEuNzZBOCw4LDAsMCwxLC42LDExLDgsOCwwLDAsMSwuNjEsNSw4LDgsMCwwLDEsMi4zNywyLjMzLDcuNTYsNy41NiwwLDAsMSw4LDBaTTgsMS40NEE2LjIsNi4yLDAsMCwwLDMuNCwzLjM2LDYuODgsNi44OCwwLDAsMCwyLDUuNTFhNi4zNSw2LjM1LDAsMCwwLDAsNUE2Ljc3LDYuNzcsMCwwLDAsNS41MywxNGE2LjQ5LDYuNDksMCwwLDAsNSwwLDYuOSw2LjksMCwwLDAsMi4xOC0xLjQ0QTYuMTUsNi4xNSwwLDAsMCwxNC41Niw4YTYuNTcsNi41NywwLDAsMC0uNDktMi41MSw2LjQxLDYuNDEsMCwwLDAtMS40MS0yLjExQTYuMzMsNi4zMywwLDAsMCw4LDEuNDRaIi8+PHBhdGggZD0iTTguMSwzLjU5QzYuMTcsMy41OSw1LDUuMyw1LDguMTdzMS4xNiw0LjYyLDMuMDksNC42MiwzLTEuNjgsMy00LjYyUzEwLDMuNTksOC4xLDMuNTlaTTYuMjEsOC4xN2MwLTEsLjE4LTMuMzgsMS44OS0zLjM4YTEuNTEsMS41MSwwLDAsMSwuNTEuMDlMNywxMUE0Ljg3LDQuODcsMCwwLDEsNi4yMSw4LjE3Wk04LjEsMTEuNTlhMS40MSwxLjQxLDAsMCwxLS4xNywwTDkuNSw1Ljc0YTUuNzksNS43OSwwLDAsMSwuNDUsMi40M0M5Ljk1LDkuNDUsOS43MSwxMS41OSw4LjEsMTEuNTlaIi8+PC9zdmc+"

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(632);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./license-icons.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./license-icons.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "license-icons {\n  position: relative;\n  display: block; }\n  license-icons .icons {\n    height: auto;\n    line-height: 24px;\n    margin-top: 18px; }\n    license-icons .icons > div {\n      font-size: 0; }\n    license-icons .icons .cmc {\n      margin-bottom: 5px; }\n    license-icons .icons a {\n      display: inline-block;\n      height: 24px;\n      margin: 0 2px;\n      position: relative; }\n      license-icons .icons a.cc-icon {\n        padding-right: 12px;\n        margin-right: 8px; }\n        license-icons .icons a.cc-icon:after {\n          content: '';\n          width: 2px;\n          height: 60%;\n          background: #666;\n          position: absolute;\n          right: 0;\n          top: 20%; }\n      license-icons .icons a img {\n        width: 24px;\n        height: 24px; }\n    license-icons .icons .price {\n      display: inline-block;\n      height: 24px;\n      line-height: 24px;\n      font-size: 14px;\n      color: #00816a;\n      vertical-align: top; }\n  license-icons.inline {\n    display: inline-block; }\n    license-icons.inline .icons {\n      display: inline-block;\n      vertical-align: middle;\n      margin-top: 0; }\n  license-icons.small .icons {\n    height: 18px;\n    line-height: 16px; }\n    license-icons.small .icons a {\n      height: 16px; }\n      license-icons.small .icons a.cc-icon {\n        padding-right: 6px;\n        margin-right: 4px; }\n        license-icons.small .icons a.cc-icon:after {\n          width: 1px; }\n      license-icons.small .icons a img {\n        width: 16px;\n        height: 16px; }\n    license-icons.small .icons .price {\n      height: 16px;\n      line-height: 16px;\n      font-size: 12px; }\n  license-icons.mini .icons {\n    height: 12px;\n    line-height: 12px; }\n    license-icons.mini .icons a {\n      height: 12px; }\n      license-icons.mini .icons a.cc-icon {\n        padding-right: 6px;\n        margin-right: 4px; }\n        license-icons.mini .icons a.cc-icon:after {\n          width: 1px; }\n      license-icons.mini .icons a img {\n        width: 12px;\n        height: 12px; }\n    license-icons.mini .icons .price {\n      height: 12px;\n      line-height: 12px;\n      font-size: 12px; }\n", ""]);

// exports


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _logo = __webpack_require__(634);

var _logo2 = _interopRequireDefault(_logo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logoModule = _angular2.default.module('logo', []).component('logo', _logo2.default).name;

exports.default = logoModule;

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _logo = __webpack_require__(635);

var _logo2 = _interopRequireDefault(_logo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logoComponent = {
    restrict: 'E',
    bindings: {},
    template: _logo2.default
};

exports.default = logoComponent;

/***/ }),
/* 635 */
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"yuanben-logo\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 121 60\" enable-background=\"new 0 0 121 60\" xml:space=\"preserve\">\n    <g>\n        <rect x=\"0.697\" y=\"3.005\" width=\"56.803\" height=\"4.934\"/>\n        <rect x=\"62.439\" y=\"5.472\" width=\"56.803\" height=\"4.934\"/>\n        <rect y=\"3.005\" width=\"7.409\" height=\"56.743\"/>\n        <rect x=\"87.136\" y=\"0.538\" width=\"7.401\" height=\"59.21\"/>\n        <rect x=\"67.378\" y=\"12.867\" width=\"7.409\" height=\"46.88\"/>\n        <rect x=\"106.893\" y=\"12.761\" width=\"7.409\" height=\"44.631\"/>\n        <rect x=\"13.045\" y=\"12.873\" width=\"41.984\" height=\"4.934\"/>\n        <rect x=\"13.045\" y=\"37.544\" width=\"41.984\" height=\"4.934\"/>\n        <rect x=\"13.045\" y=\"25.208\" width=\"41.984\" height=\"4.934\"/>\n        <rect x=\"69.848\" y=\"37.544\" width=\"39.515\" height=\"4.934\"/>\n        <rect x=\"64.909\" y=\"54.611\" width=\"9.879\" height=\"5.136\"/>\n        <rect x=\"106.893\" y=\"54.813\" width=\"9.879\" height=\"4.934\"/>\n        <rect x=\"47.621\" y=\"12.873\" width=\"7.409\" height=\"27.138\"/>\n        <rect x=\"13.045\" y=\"12.873\" width=\"7.409\" height=\"29.605\"/>\n        <rect x=\"30.333\" y=\"42.478\" width=\"7.409\" height=\"17.27\"/>\n        <rect x=\"13.045\" y=\"44.945\" width=\"7.409\" height=\"14.802\"/>\n        <rect x=\"47.621\" y=\"44.945\" width=\"7.409\" height=\"14.802\"/>\n        <rect x=\"13.045\" y=\"7.939\" width=\"7.409\" height=\"4.934\"/>\n    </g>\n</svg>\n\n";

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _ybfooter = __webpack_require__(637);

var _ybfooter2 = _interopRequireDefault(_ybfooter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by lency on 9/23/2016.
 */
var footerModule = _angular2.default.module('footer', []).component('ybfooter', _ybfooter2.default).name;

exports.default = footerModule;

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ybfooter = __webpack_require__(638);

var _ybfooter2 = _interopRequireDefault(_ybfooter);

__webpack_require__(641);

var _ybfooter3 = __webpack_require__(644);

var _ybfooter4 = _interopRequireDefault(_ybfooter3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var footerComponent = {
    restrict: 'E',
    bindings: {},
    template: _ybfooter2.default,
    controller: _ybfooter4.default
}; /**
    * Created by lency on 9/23/2016.
    */
exports.default = footerComponent;

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<div class=\"ybfooter\">\n    <div class=\"container\">\n        <div class=\"content\">\n            <div class=\"logo\">\n                <logo></logo>\n                <!-- <img src=\"./images/guohui.png\" alt=\"\" class=\"guohui\"> -->\n            </div>\n            <div class=\"links\">\n                <span ng-if=\"$ctrl.$window.localStorage.yuanben_lang=='zh-CN'\">\n                    <a ui-sref=\"app.page.help.copyright\" target=\"_blank\" class=\"link\">{{'footer-text002' | translate}}</a>\n                    <span class=\"separator\">|</span>\n                    <a ui-sref=\"app.page.terms\" target=\"_blank\" class=\"link\">{{'footer-text003' | translate}}</a>\n                    <span class=\"separator\">|</span>\n                </span>\n                <a href=\"mailto:hi@yuanben.org\" target=\"_blank\" class=\"link\">{{'footer-text004' | translate}}</a>\n                <span ng-if=\"$ctrl.$window.localStorage.yuanben_lang=='zh-CN'\">\n                    <span class=\"separator\">|</span>\n                    <a ui-sref=\"app.page.career.intro\" target=\"_blank\" class=\"link\">{{'footer-text005' | translate}}</a>\n                </span>\n            </div>\n            <div class=\"qr-code\">\n                <div class=\"text\">{{'footer-text006' | translate}}</div>\n                <div class=\"image\">\n                    <img src=\"" + __webpack_require__(639) + "\" width=\"100\" height=\"100\" />\n                </div>\n            </div>\n        </div>\n        <div class=\"copyright\">\n            <div class=\"line icp-license\">\n               <!-- 测试地址 -->\n                <a href=\"https://beian.miit.gov.cn\" target=\"_blank\">{{'footer-text007' | translate}}</a>\n                <language class=\"footer-lang\"></language>\n            </div>\n            <div class=\"line\">\n                <span class=\"fold\">&copy; 2016-{{$ctrl.yearNow}} {{'footer-text001' | translate}}</span>\n            </div>\n            <div class=\"line\">\n                <span class=\"fold\">{{'footer-text0011' | translate}}</span>\n            </div>\n            <div class=\"line\">\n               <a target=\"_blank\" href=\"http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010902002951\" style=\"display:inline-block;text-decoration:none;height:20px;line-height:20px;\">\n                  <img src=\"" + __webpack_require__(640) + "\" style=\"float:left;\"/><p style=\"float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;\">沪公网安备 31010902002951号</p></a>\n            </div>\n            <div class=\"line\" style=\"height: 35px;\n            display: flex;\n            justify-content: center;\n            margin-bottom:5px\">\n               <a href=\"https://webcert.cnmstl.net/cert/grade?sn=e1bc5b3a391911ebbcee00163e068ceb\"\n                target=\"_blank\" id=\"jvs-cert\">\n               <div style=\"height:1px;width:92px\"></div>\n               </a><script type=\"text/javascript\"src=\"https://webcert.cnmstl.net/cert/grade/small_h_img.js?sn=e1bc5b3a391911ebbcee00163e068ceb\"></script>\n            </div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "72b1417b3c27e0d66b1eb01970d641f8.jpg";

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d0289dc0a46fc5b15b3363ffa78cf6c7.png";

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(642);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./ybfooter.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./ybfooter.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "ybfooter {\n  display: block;\n  height: auto;\n  line-height: 100%;\n  background-color: #2b2b2b; }\n  ybfooter .ybfooter {\n    position: relative;\n    height: 100%;\n    background: url(" + __webpack_require__(643) + ") no-repeat center bottom; }\n    ybfooter .ybfooter .container {\n      position: relative;\n      height: 100%; }\n      ybfooter .ybfooter .container .content {\n        position: relative;\n        height: 200px; }\n        ybfooter .ybfooter .container .content .logo {\n          position: absolute;\n          width: 150px;\n          left: 82px;\n          top: 94px; }\n          ybfooter .ybfooter .container .content .logo svg {\n            width: 70px;\n            fill: #ffffff; }\n          ybfooter .ybfooter .container .content .logo .guohui {\n            margin-left: 10px;\n            vertical-align: top; }\n        ybfooter .ybfooter .container .content .qr-code {\n          position: absolute;\n          width: 120px;\n          top: 40px;\n          right: 82px;\n          text-align: center; }\n          ybfooter .ybfooter .container .content .qr-code .text {\n            font-size: 14px;\n            color: #cccccc; }\n          ybfooter .ybfooter .container .content .qr-code .image {\n            margin-top: 12px; }\n        ybfooter .ybfooter .container .content .links {\n          position: relative;\n          margin: 0 202px;\n          text-align: center;\n          padding-top: 104px; }\n          ybfooter .ybfooter .container .content .links .link {\n            font-size: 16px;\n            color: #cccccc;\n            text-decoration: none; }\n            ybfooter .ybfooter .container .content .links .link:hover {\n              color: #ffffff; }\n          ybfooter .ybfooter .container .content .links .separator {\n            color: #cccccc;\n            margin: 0 20px; }\n      ybfooter .ybfooter .container .copyright {\n        position: relative;\n        margin: 0 40px;\n        padding: 10px 0;\n        border-top: 1px solid rgba(255, 255, 255, 0.2); }\n        ybfooter .ybfooter .container .copyright .line {\n          margin-top: 6px;\n          font-size: 12px;\n          color: rgba(255, 255, 255, 0.4);\n          text-align: center; }\n          ybfooter .ybfooter .container .copyright .line a {\n            color: rgba(255, 255, 255, 0.4);\n            text-decoration: none; }\n            ybfooter .ybfooter .container .copyright .line a:hover {\n              text-decoration: underline; }\n  @media only screen and (max-width: 991px) and (min-width: 768px) {\n    ybfooter .ybfooter .container .content .links .separator {\n      margin: 0 10px; } }\n  @media only screen and (max-width: 767px) {\n    ybfooter {\n      height: auto; }\n    ybfooter .ybfooter .container .content {\n      height: auto;\n      padding-top: 48px; }\n      ybfooter .ybfooter .container .content .logo {\n        position: relative;\n        left: auto;\n        top: auto;\n        width: auto;\n        padding-top: 28px;\n        text-align: center; }\n      ybfooter .ybfooter .container .content .qr-code {\n        position: relative;\n        width: auto;\n        top: auto;\n        right: auto; }\n      ybfooter .ybfooter .container .content .links {\n        padding-top: 0;\n        margin: 28px 0; }\n        ybfooter .ybfooter .container .content .links .separator {\n          margin: 0 5px; }\n    ybfooter .ybfooter .container .copyright {\n      margin: 25px; }\n      ybfooter .ybfooter .container .copyright .fold {\n        display: block;\n        margin-top: 3px; } }\n", ""]);

// exports


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a355f69e9df90796f3f17994a9511a07.png";

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by ganlu on 18/10/2016.
 */
var FooterController = function FooterController(AppConfig, $window) {
    "ngInject";

    (0, _classCallCheck3.default)(this, FooterController);
    this.AppConfig = AppConfig;
    this.$window = $window;
    this.yearNow = new Date().getFullYear();
};

FooterController.$inject = ["AppConfig", "$window"];
exports.default = FooterController;

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _ybfooter = __webpack_require__(646);

var _ybfooter2 = _interopRequireDefault(_ybfooter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by lency on 9/23/2016.
 */
var footerModule = _angular2.default.module('smallfooter', []).component('ybsmallfooter', _ybfooter2.default).name;

exports.default = footerModule;

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ybfooter = __webpack_require__(647);

var _ybfooter2 = _interopRequireDefault(_ybfooter);

__webpack_require__(648);

var _ybfooter3 = __webpack_require__(650);

var _ybfooter4 = _interopRequireDefault(_ybfooter3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var footerComponent = {
    restrict: 'E',
    bindings: {},
    template: _ybfooter2.default,
    controller: _ybfooter4.default
}; /**
    * Created by lency on 9/23/2016.
    */
exports.default = footerComponent;

/***/ }),
/* 647 */
/***/ (function(module, exports) {

module.exports = "<div class=\"yb-small-footer\">\n    <div class=\"container clearfix\">\n        <div class=\"copyright\">\n            <span class=\"fold\">&copy; {{'footer-text001' | translate}}</span>\n            <!--<language class=\"footer-lang small\"></language>-->\n\n        </div>\n        <div class=\"links\">\n            <span ng-if=\"$ctrl.$window.localStorage.yuanben_lang=='zh-CN'\">\n                <a ui-sref=\"app.page.help.copyright\" target=\"_blank\" class=\"link\">{{'footer-text002' | translate}}</a>\n                <span class=\"separator\">|</span>\n                <a ui-sref=\"app.page.terms\" target=\"_blank\" class=\"link\">{{'footer-text003' | translate}}</a>\n                <span class=\"separator\">|</span>\n            </span>\n            <a href=\"mailto:hi@yuanben.org\" target=\"_blank\" class=\"link\">{{'footer-text004' | translate}}</a>\n            <span ng-if=\"$ctrl.$window.localStorage.yuanben_lang=='zh-CN'\">\n                <span class=\"separator\">|</span>\n                <a ui-sref=\"app.page.career.intro\" target=\"_blank\" class=\"link\">{{'footer-text005' | translate}}</a>\n            </span>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(649);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./ybfooter.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./ybfooter.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "ybsmallfooter {\n  display: block; }\n  ybsmallfooter .yb-small-footer {\n    color: #999999;\n    font-size: 14px;\n    border-top: 1px solid #dadedd;\n    padding: 25px 0; }\n    ybsmallfooter .yb-small-footer .container {\n      position: relative;\n      height: 100%; }\n      ybsmallfooter .yb-small-footer .container .copyright {\n        float: left; }\n      ybsmallfooter .yb-small-footer .container .links {\n        float: right; }\n        ybsmallfooter .yb-small-footer .container .links .link {\n          text-decoration: none;\n          color: #999999; }\n          ybsmallfooter .yb-small-footer .container .links .link:hover {\n            color: #666666; }\n        ybsmallfooter .yb-small-footer .container .links .separator {\n          color: #999999;\n          margin: 0 5px; }\n  @media only screen and (max-width: 1199px) {\n    ybsmallfooter .yb-small-footer .container .links {\n      float: none;\n      text-align: center;\n      margin-top: 12px; }\n      ybsmallfooter .yb-small-footer .container .links .link {\n        text-decoration: none;\n        color: #999999; }\n        ybsmallfooter .yb-small-footer .container .links .link:hover {\n          color: #666666; }\n      ybsmallfooter .yb-small-footer .container .links .separator {\n        color: #999999;\n        margin: 0 5px; }\n    ybsmallfooter .yb-small-footer .container .copyright {\n      float: none;\n      text-align: center; } }\n  @media only screen and (max-width: 767px) {\n    ybsmallfooter .yb-small-footer {\n      padding-bottom: 90px; }\n      ybsmallfooter .yb-small-footer .container .copyright {\n        float: none;\n        text-align: center; }\n        ybsmallfooter .yb-small-footer .container .copyright .fold {\n          display: inline-block;\n          padding: 4px 0; } }\n", ""]);

// exports


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by ganlu on 18/10/2016.
 */
var FooterController = function FooterController(AppConfig, $window) {
    "ngInject";

    (0, _classCallCheck3.default)(this, FooterController);
    this.AppConfig = AppConfig;
    this.$window = $window;
};

FooterController.$inject = ["AppConfig", "$window"];
exports.default = FooterController;

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _modalControl = __webpack_require__(652);

var _modalControl2 = _interopRequireDefault(_modalControl);

var _modal = __webpack_require__(653);

var _modal2 = _interopRequireDefault(_modal);

__webpack_require__(654);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by ganlu on 25/09/2016.
 */
var modalModule = _angular2.default.module('modal', []).directive('modalControl', _modalControl2.default).service('modal', _modal2.default).name;

exports.default = modalModule;

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

/**
 * Created by ganlu on 25/09/2016.
 */
exports.default = function () {
  return function (scope, elem, attrs) {
    elem.on('click.close', '.close', function (e) {
      e.preventDefault();
      e.stopPropagation();
      elem.removeClass('active');
      $('body').removeClass('no-scroll');
      scope.$eval(attrs.onClose) && scope.$eval(attrs.onClose).call(scope.$ctrl);
    });
  };
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by ganlu on 03/11/2016.
 */
var ModalService = function () {
    function ModalService() {
        (0, _classCallCheck3.default)(this, ModalService);
    }

    (0, _createClass3.default)(ModalService, [{
        key: 'open',
        value: function open(id) {
            $('body').addClass('no-scroll');
            $('#' + id).addClass('active');
        }
    }, {
        key: 'close',
        value: function close(id) {
            $('#' + id).removeClass('active');
            $('body').removeClass('no-scroll');
        }
    }]);
    return ModalService;
}();

exports.default = ModalService;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(655);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./modal.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./modal.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".modal-overlay {\n  position: fixed;\n  opacity: 0;\n  width: 100%;\n  height: 100%;\n  left: 0;\n  top: 0;\n  background-color: rgba(0, 0, 0, 0.7);\n  z-index: -1;\n  transition: all .2s ease-in-out;\n  -webkit-transition: all .2s ease-in-out;\n  -moz-transition: all .2s ease-in-out;\n  -ms-transition: all .2s ease-in-out; }\n  .modal-overlay.active {\n    z-index: 99999;\n    opacity: 1; }\n  .modal-overlay .modal {\n    position: absolute;\n    width: 550px;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    -webkit-transform: translate(-50%, -50%);\n    -moz-transform: translate(-50%, -50%);\n    -ms-transform: translate(-50%, -50%);\n    background-color: #ffffff;\n    border-radius: 3px; }\n    .modal-overlay .modal .header {\n      position: relative;\n      height: 44px;\n      line-height: 44px;\n      border-bottom: 1px solid #e8eaea;\n      padding: 0 16px;\n      font-size: 16px;\n      color: #222222; }\n      .modal-overlay .modal .header .close {\n        position: absolute;\n        right: 0;\n        top: 0;\n        width: 36px;\n        height: 36px;\n        text-align: center;\n        cursor: pointer;\n        font-size: 16px;\n        color: #999999; }\n        .modal-overlay .modal .header .close:hover {\n          color: #666666; }\n    .modal-overlay .modal .content {\n      padding: 16px; }\n      .modal-overlay .modal .content .line {\n        font-size: 14px;\n        color: #666666;\n        margin-top: 10px;\n        line-height: 1.6; }\n        .modal-overlay .modal .content .line:first-child {\n          margin-top: 0; }\n    .modal-overlay .modal .modal-footer {\n      height: 54px;\n      border-top: 1px solid #e8eaea;\n      padding: 6px 16px; }\n      .modal-overlay .modal .modal-footer .btn-no {\n        margin-right: 8px; }\n      .modal-overlay .modal .modal-footer .btn {\n        margin-top: 0; }\n  .modal-overlay.title .header {\n    display: block; }\n  .modal-overlay.centered .content {\n    text-align: center; }\n\n@media only screen and (max-width: 767px) {\n  .modal-overlay {\n    opacity: 1;\n    display: none; }\n    .modal-overlay.active {\n      display: block; }\n    .modal-overlay .modal {\n      position: absolute;\n      top: 30px;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      margin: 0 !important;\n      width: auto !important;\n      overflow: auto;\n      transform: translate(0, 0);\n      -webkit-transform: translate(0, 0);\n      -moz-transform: translate(0, 0);\n      -ms-transform: translate(0, 0);\n      border-bottom-left-radius: 0;\n      border-bottom-right-radius: 0; }\n      .modal-overlay .modal .header .title {\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        padding-right: 40px; }\n      .modal-overlay .modal .content {\n        position: absolute !important;\n        top: 44px;\n        left: 0;\n        right: 0;\n        bottom: 54px;\n        overflow: auto; }\n        .modal-overlay .modal .content.no-footer {\n          bottom: 0; }\n      .modal-overlay .modal .modal-footer {\n        position: absolute;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        padding: 6px 12px; } }\n", ""]);

// exports


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _navtab = __webpack_require__(657);

var _navtab2 = _interopRequireDefault(_navtab);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var navtabModule = _angular2.default.module('navtab', []).component('navtab', _navtab2.default).name;

exports.default = navtabModule;

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _navtab = __webpack_require__(658);

var _navtab2 = _interopRequireDefault(_navtab);

var _navtab3 = __webpack_require__(659);

var _navtab4 = _interopRequireDefault(_navtab3);

__webpack_require__(660);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var navtabComponent = {
    restrict: 'E',
    transclude: true,
    bindings: {
        tabs: '='
    },
    template: _navtab2.default,
    controller: _navtab4.default
};

exports.default = navtabComponent;

/***/ }),
/* 658 */
/***/ (function(module, exports) {

module.exports = "<div class=\"navtab\">\n    <div class=\"tabs\">\n        <div ng-click=\"$ctrl.clickTab(tab)\" ng-class=\"{'tab':true,'active': tab.active}\"\n             ng-repeat=\"tab in $ctrl.tabs\">{{ tab.name }}\n        </div>\n    </div>\n    <ng-transclude></ng-transclude>\n</div>\n";

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavtabController = function () {
    function NavtabController() {
        (0, _classCallCheck3.default)(this, NavtabController);
    }

    (0, _createClass3.default)(NavtabController, [{
        key: 'clickTab',
        value: function clickTab(tab) {
            this.tabs.forEach(function (e) {
                e.active = false;
            });
            tab.active = true;
            if (typeof tab.click == 'function') {
                tab.click();
            }
        }
    }]);
    return NavtabController;
}();

exports.default = NavtabController;

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(661);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./navtab.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./navtab.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "navtab .navtab {\n  position: relative;\n  height: 50px;\n  border-bottom: 1px solid #e8eaea; }\n  navtab .navtab .tabs {\n    position: relative;\n    height: 50px; }\n    navtab .navtab .tabs .tab {\n      position: relative;\n      width: auto;\n      margin-top: 10px;\n      height: 40px;\n      line-height: 40px;\n      float: left;\n      font-size: 14px;\n      color: #666666;\n      cursor: pointer;\n      text-align: center;\n      padding: 0 10px; }\n      navtab .navtab .tabs .tab:hover {\n        color: #222222; }\n      navtab .navtab .tabs .tab.active, navtab .navtab .tabs .tab.active:hover {\n        color: #222222;\n        border-bottom: 2px solid #222222; }\n\n@media only screen and (max-width: 767px) {\n  navtab .navtab .tabs {\n    width: auto; }\n  navtab .navtab .tabs .tab {\n    font-size: 14px; } }\n", ""]);

// exports


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _pager = __webpack_require__(663);

var _pager2 = _interopRequireDefault(_pager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pagerModule = _angular2.default.module('pager', []).component('pager', _pager2.default).name;

exports.default = pagerModule;

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _pager = __webpack_require__(664);

var _pager2 = _interopRequireDefault(_pager);

var _pager3 = __webpack_require__(665);

var _pager4 = _interopRequireDefault(_pager3);

__webpack_require__(666);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pagerComponent = {
    restrict: 'E',
    bindings: {
        total: '=',
        current: '=',
        load: '&'
    },
    template: _pager2.default,
    controller: _pager4.default
};

exports.default = pagerComponent;

/***/ }),
/* 664 */
/***/ (function(module, exports) {

module.exports = "<div class=\"pager\">\n    <div class=\"page-total\">{{'pager-text001' | translate}}<span class=\"page-count\">{{$ctrl.total}}</span>{{'pager-text002' | translate}}</div>\n    <div class=\"fr\">\n        <div ng-class=\"{'item':true, 'nav':true, 'disabled': $ctrl.current == 1}\" ng-click=\"$ctrl.prev()\"><i\n            class=\"ybicon yb-last\"></i></div>\n        <div ng-class=\"{'item':true, 'active':page==$ctrl.current}\" ng-click=\"$ctrl.loadPage(page)\"\n             ng-repeat=\"page in $ctrl.pageToShow track by $index\">{{ page }}\n        </div>\n        <div ng-class=\"{'item':true, 'nav':true, 'disabled': $ctrl.current == $ctrl.total}\" ng-click=\"$ctrl.next()\"><i\n            class=\"ybicon yb-next\"></i></div>\n        <form class=\"goto\" ng-submit=\"$ctrl.loadPage($ctrl.gotoPage)\">\n            <div class=\"input-box\">{{'pager-text003' | translate}}<input type=\"number\" id=\"goToPage-number\" ng-model=\"$ctrl.gotoPage\">{{'pager-text004' | translate}}</div>\n            <button type=\"submit\" class=\"goto-btn\" ng-disabled=\" !$ctrl.gotoPage || $ctrl.gotoPage>$ctrl.total || $ctrl.gotoPage<1\" >{{'pager-text005' | translate}}</button>\n        </form>\n    </div>\n\n</div>\n";

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PagerController = function () {
    PagerController.$inject = ['$scope'];

    function PagerController($scope) {

        "ngInject";

        (0, _classCallCheck3.default)(this, PagerController);
        var self = this;
        this.pageToShow = [];
        this.update();

        $scope.$watch(function () {
            return self.current;
        }, function () {
            self.update();
        });
        $scope.$watch(function () {
            return self.total;
        }, function () {
            self.update();
        });
    }

    (0, _createClass3.default)(PagerController, [{
        key: 'prev',
        value: function prev() {
            if (this.current == 1) return;

            this.loadPage(this.current - 1);
        }
    }, {
        key: 'next',
        value: function next() {
            if (this.current == this.total) return;

            this.loadPage(this.current + 1);
        }
    }, {
        key: 'loadPage',
        value: function loadPage(page) {
            if (page === '...') return;
            this.current = page;
            this.load({ page: page });
            $('#goToPage-number').blur();
            $(document).scrollTop(0);
            this.update();
        }
    }, {
        key: 'update',
        value: function update() {

            this.pageToShow = [];
            if (this.current <= 2) {
                for (var i = 1; i <= this.total && i <= 3; i++) {
                    this.pageToShow.push(i);
                }
                if (this.total > 3) {
                    if (this.total == 4) {
                        this.pageToShow = this.pageToShow.concat([this.total]);
                    } else {
                        this.pageToShow = this.pageToShow.concat(['...', this.total]);
                    }
                }
            } else if (this.current >= this.total - 1) {
                for (var i = this.total, c = 0; c < 3 && i > 0; i--, c++) {
                    this.pageToShow.unshift(i);
                }
                if (this.total > 3) {
                    if (this.total == 4) {
                        this.pageToShow = [1].concat(this.pageToShow);
                    } else {
                        this.pageToShow = [1, '...'].concat(this.pageToShow);
                    }
                }
            } else {
                this.pageToShow = [this.current - 1, this.current, +this.current + 1];
                if (this.total > 3) {
                    if (this.total == 5) {
                        this.pageToShow = [1].concat(this.pageToShow).concat([this.total]);
                    } else {
                        if (this.current == 3) {
                            this.pageToShow = [1].concat(this.pageToShow).concat(['...', this.total]);
                        } else if (this.current == this.total - 2) {
                            this.pageToShow = [1, '...'].concat(this.pageToShow).concat([this.total]);
                        } else {
                            this.pageToShow = [1, '...'].concat(this.pageToShow).concat(['...', this.total]);
                        }
                    }
                }
            }
            // if(window.innerWidth<767){
            //
            // }else{
            //     if (this.current <= 3) {
            //         for (var i = 1; i <= this.total && i <= 5; i++) {
            //             this.pageToShow.push(i);
            //         }
            //         this.total>5 && (this.pageToShow=this.pageToShow.concat(['...',this.total]))
            //     } else if (this.current >= this.total - 2) {
            //         for (var i = this.total, c = 0; c < 5 && i > 0; i--, c++) {
            //             this.pageToShow.unshift(i);
            //         }
            //         this.total>5 && (this.pageToShow=[1,'...'].concat(this.pageToShow))
            //     } else {
            //         this.pageToShow = [
            //             this.current - 2,
            //             this.current - 1,
            //             this.current,
            //             +this.current + 1,
            //             +this.current + 2
            //         ];
            //         this.total>5 && (this.pageToShow=[1,'...'].concat(this.pageToShow).concat(['...',this.total]))
            //     }
            // }

        }
    }]);
    return PagerController;
}();

exports.default = PagerController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(667);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./pager.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./pager.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "pager .pager {\n  position: relative;\n  margin-top: 18px;\n  height: 30px;\n  text-align: center;\n  font-size: 0;\n  color: #222222;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none; }\n  pager .pager > div {\n    display: inline-block;\n    font-size: 12px; }\n  pager .pager .page-total {\n    font-size: 12px;\n    color: #999999;\n    float: left;\n    line-height: 30px; }\n  pager .pager .fr {\n    float: right;\n    font-size: 0; }\n  pager .pager .item {\n    position: relative;\n    display: inline-block;\n    min-width: 30px;\n    padding: 0 5px;\n    height: 30px;\n    line-height: 30px;\n    text-align: center;\n    cursor: pointer;\n    border-radius: 2px;\n    margin-left: 10px;\n    font-size: 12px;\n    border: 1px solid #dadedd; }\n    pager .pager .item i {\n      line-height: 30px;\n      font-size: 12px; }\n    pager .pager .item.nav {\n      color: #999999; }\n    pager .pager .item:hover, pager .pager .item.active {\n      color: #ffffff;\n      background-color: #00816a;\n      border-color: #00816a; }\n    pager .pager .item.disabled, pager .pager .item.disabled:hover {\n      cursor: not-allowed;\n      color: #cccccc;\n      background-color: #f5f5f5;\n      border-color: #dadedd; }\n  pager .pager .goto {\n    display: inline-block;\n    margin-left: 16px;\n    font-size: 0; }\n    pager .pager .goto .input-box {\n      display: inline-block;\n      color: #999999;\n      font-size: 12px; }\n      pager .pager .goto .input-box input {\n        width: 30px;\n        height: 30px;\n        line-height: 30px;\n        text-align: center;\n        border-radius: 2px;\n        border: 1px solid #dadedd;\n        margin: 0 2px; }\n        pager .pager .goto .input-box input:focus {\n          border-color: #00816a; }\n        pager .pager .goto .input-box input::-webkit-outer-spin-button, pager .pager .goto .input-box input::-webkit-inner-spin-button {\n          -webkit-appearance: none; }\n        pager .pager .goto .input-box input[type=\"number\"] {\n          -moz-appearance: textfield; }\n    pager .pager .goto .goto-btn {\n      float: right;\n      width: 42px;\n      height: 30px;\n      cursor: pointer;\n      line-height: 24px;\n      text-align: center;\n      border-radius: 2px;\n      margin: 0 0 0 10px;\n      border: 1px solid #dadedd;\n      background: none;\n      color: #999999;\n      font-size: 12px; }\n      pager .pager .goto .goto-btn:hover {\n        color: #00816a;\n        border-color: #00816a; }\n      pager .pager .goto .goto-btn:disabled, pager .pager .goto .goto-btn:disabled:hover {\n        cursor: not-allowed;\n        color: #cccccc;\n        background-color: #f5f5f5; }\n\n/* Small Devices, Mobile */\n@media only screen and (max-width: 767px) {\n  pager .pager .page-total {\n    display: none; }\n  pager .pager .fr {\n    float: none; }\n  pager .pager .item {\n    margin: 0 4px;\n    float: left; }\n  pager .pager .goto {\n    display: none; } }\n", ""]);

// exports


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _progressbar = __webpack_require__(669);

var _progressbar2 = _interopRequireDefault(_progressbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by ganlu on 30/10/2016.
 */
var progressbarModule = _angular2.default.module('progressbar', []).component('progressbar', _progressbar2.default).name;

exports.default = progressbarModule;

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _progressbar = __webpack_require__(670);

var _progressbar2 = _interopRequireDefault(_progressbar);

__webpack_require__(671);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by ganlu on 30/10/2016.
 */
var progressbarComponent = {
    restrict: 'E',
    bindings: {
        text: '=',
        progress: '='
    },
    template: _progressbar2.default
};

exports.default = progressbarComponent;

/***/ }),
/* 670 */
/***/ (function(module, exports) {

module.exports = "<div class=\"bar progress-total\">\n    <div class=\"progress-current\" style=\"width:{{ $ctrl.progress * 100 }}%\"></div>\n</div>\n<div class=\"text\">{{ $ctrl.text }}</div>\n";

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(672);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./progressbar.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./progressbar.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "progressbar {\n  position: relative;\n  display: block;\n  width: 100%;\n  height: 100%; }\n  progressbar .bar {\n    position: absolute;\n    height: 2px;\n    top: 50%;\n    margin-top: -1px;\n    left: 0;\n    right: 70px;\n    background-color: #f5f5f5; }\n    progressbar .bar .progress-current {\n      position: absolute;\n      left: 0;\n      top: 0;\n      height: 100%;\n      background-color: #00816a; }\n  progressbar .text {\n    position: absolute;\n    width: 70px;\n    height: 100%;\n    top: 0;\n    right: 0;\n    font-size: 14px;\n    color: #999999; }\n", ""]);

// exports


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _pwcheck = __webpack_require__(674);

var _pwcheck2 = _interopRequireDefault(_pwcheck);

var _servercheck = __webpack_require__(675);

var _servercheck2 = _interopRequireDefault(_servercheck);

var _pwdStrength = __webpack_require__(676);

var _pwdStrength2 = _interopRequireDefault(_pwdStrength);

var _emailcheck = __webpack_require__(677);

var _emailcheck2 = _interopRequireDefault(_emailcheck);

__webpack_require__(687);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by ganlu on 08/11/2016.
 */
var formModule = _angular2.default.module('forms', []).directive('pwCheck', _pwcheck2.default).directive('serverCheck', _servercheck2.default).directive('pwdStrength', _pwdStrength2.default).directive('emailCheck', _emailcheck2.default).name;

exports.default = formModule;

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

/**
 * Created by ganlu on 08/11/2016.
 */
exports.default = function () {
    return {
        require: 'ngModel',
        link: function link(scope, elem, attrs, ctrl) {
            var firstPassword = '#' + attrs.pwCheck;
            elem.add(firstPassword).on('keyup', function () {
                scope.$apply(function () {
                    var v = elem.val() === $(firstPassword).val();
                    ctrl.$setValidity('pwcheck', v);
                });
            });
        }
    };
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

/**
 * Created by ganlu on 08/11/2016.
 */
exports.default = function () {
    return {
        require: 'ngModel',
        link: function link(scope, elem, attrs, ctrl) {

            elem.on('keyup', function () {
                scope.$apply(function () {
                    ctrl.$setValidity('server', true);
                });
            });
        }
    };
};

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * Created by ganlu on 08/11/2016.
 */
exports.default = ['$compile', '$parse', function ($compile, $parse) {
    'ngInject';

    return {
        require: 'ngModel',
        link: function link(scope, elem, attrs, ctrl) {
            var alert = void 0,
                ttScope = scope.$new(true),
                alertLinkedScope = void 0;
            var model = $parse(attrs['ngModel']);
            var template = '\n                             <div class="password-alert">\n                                <div class="arrow"></div>\n                                <div class="inner">\n                                    <p>{{ \'face-user-text014\' | translate }}</p>\n                                    <div class="demands">\n                                        <div ng-class="{success: len, error: !len}">\n                                            <i class="ybicon" ng-class="{\'yb-succeed\': len, \'yb-close\': !len}"></i>{{ \'face-user-text015\' | translate }}</div>\n                                        <div ng-class="{success: UpAndLower, error: !UpAndLower}">\n                                            <i class="ybicon" ng-class="{\'yb-succeed\': UpAndLower, \'yb-close\': !UpAndLower}"></i>{{ \'face-user-text016\' | translate }}</div>\n                                        <div ng-class="{success: symbol, error: !symbol}">\n                                            <i class="ybicon" ng-class="{\'yb-succeed\': symbol, \'yb-close\': !symbol}"></i>{{ \'face-user-text017\' | translate }}</div>\n                                        <div ng-class="{success: number, error: !number}">\n                                            <i class="ybicon" ng-class="{\'yb-succeed\': number, \'yb-close\': !number}"></i>{{ \'face-user-text018\' | translate }}</div>\n                                    </div>\n                                    <div class="meter">\n                                        <p>{{ \'face-user-text019\' | translate }}: {{levelLocaleName | translate}}</p>\n                                        <div class="progress">\n                                            <div class="bar" ng-class="level" ng-style="{width: score + \'%\'}"></div>\n                                        </div>\n                                        <p class="desc">{{ \'face-user-text023\' | translate }}</p>\n                                    </div>\n                                </div>\n                            </div>';
            var linker = $compile(template);
            function createAlert() {
                if (alert) {
                    return;
                }
                alertLinkedScope = ttScope.$new();
                if (angular.isDefined(model(scope))) {
                    valid(model(scope), alertLinkedScope);
                }
                alert = linker(alertLinkedScope, function (a) {
                    elem.after(a);
                });
            }

            function removeAlert() {
                if (alert) {
                    alert.remove();
                    alert = null;
                }
                if (alertLinkedScope) {
                    alertLinkedScope.$destroy();
                    alertLinkedScope = null;
                }
            }

            function showAlertBind() {
                createAlert();
            }

            function hideAlertBind() {
                removeAlert();
            }

            function valid(value, scope) {
                if (value.length >= 8) {
                    scope.len = true;
                } else {
                    scope.len = false;
                }
                if (/[A-Z]/.test(value) && /[a-z]/.test(value)) {
                    scope.UpAndLower = true;
                } else {
                    scope.UpAndLower = false;
                }
                if (/[`~!@#$^&*()+=|\\\[\]\{\}:;'\,.<>/?]/.test(value)) {
                    scope.symbol = true;
                } else {
                    scope.symbol = false;
                }
                if (/\d/.test(value)) {
                    scope.number = true;
                } else {
                    scope.number = false;
                }
                evaluate(alertLinkedScope);
            }

            function evaluate(linkedScope) {
                var score = 0;
                if (linkedScope.len) {
                    score++;
                }
                if (linkedScope.UpAndLower) {
                    score++;
                }
                if (linkedScope.symbol) {
                    score++;
                }
                if (linkedScope.number) {
                    score++;
                }
                linkedScope.score = 25 * score;
                linkedScope.level = ['', 'low', 'medium', 'medium', 'high'][score];
                linkedScope.levelLocaleName = ['', 'face-user-text020', 'face-user-text021', 'face-user-text021', 'face-user-text022'][score];
                if (score === 4) {
                    ctrl.$setValidity('pwdStrength', true);
                } else {
                    ctrl.$setValidity('pwdStrength', false);
                }
            }

            scope.$watch(model, function (newV, oldV) {
                if (angular.isDefined(newV)) {
                    valid(newV, alertLinkedScope);
                }
            });

            elem.on('focus', showAlertBind);
            elem.on('blur', hideAlertBind);
        }
    };
}];

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _debounce = __webpack_require__(678);

var _debounce2 = _interopRequireDefault(_debounce);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = ['Restangular', function (Restangular) {
    'ngInject';

    return {
        require: 'ngModel',
        link: function link(scope, elem, attrs, ctrl) {
            var debounced = (0, _debounce2.default)(function () {
                var value = elem.val();
                Restangular.one('email/status').get({
                    email: value
                }).then(function (res) {
                    if (res.status.code === 200) {
                        ctrl.$setValidity('emailCheck', false);
                    } else {
                        ctrl.$setValidity('emailCheck', true);
                    }
                });
            }, 500);
            elem.on('input', function () {
                var value = elem.val();
                scope.$apply(function () {
                    ctrl.$setValidity('emailCheck', true);
                });
                if (!!value && !ctrl.$error.email) {
                    debounced();
                } else {
                    debounced.cancel();
                }
            });
        }
    };
}]; /**
     * Created by ganlu on 08/11/2016.
     */

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(237),
    now = __webpack_require__(679),
    toNumber = __webpack_require__(681);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(238);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(237),
    isSymbol = __webpack_require__(682);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(683),
    isObjectLike = __webpack_require__(686);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(239),
    getRawTag = __webpack_require__(684),
    objectToString = __webpack_require__(685);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(239);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 685 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 686 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(688);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./form.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./form.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".btn {\n  display: inline-block;\n  text-align: center;\n  text-decoration: none;\n  line-height: normal;\n  border: 1px solid;\n  padding: 4px 12px;\n  cursor: pointer;\n  border-radius: 3px; }\n\n.btn-primary {\n  color: #ffffff;\n  border-color: #00816a;\n  background-color: #00816a; }\n\n.btn-primary:hover {\n  background-color: #006f59; }\n\n.btn-primary:active {\n  background-color: #005f49; }\n\n.btn-default {\n  color: #222222;\n  border-color: #e3e3e3;\n  background-color: #f5f5f5; }\n\n.btn-text {\n  color: #6e6e6e;\n  font-size: 14px;\n  border: none; }\n\n.btn-default:hover {\n  background-color: #f0f0f0; }\n\n.btn-default:active {\n  background-color: #e9e9e9; }\n\n.btn:disabled {\n  background-color: #cccccc;\n  border-color: #cccccc;\n  color: #999999; }\n\n.btn-sm {\n  font-size: 12px; }\n\n.btn-md {\n  font-size: 14px;\n  padding: 9px 18px; }\n\n.btn-lg {\n  font-size: 16px;\n  padding: 12px 24px; }\n\n.btn-group {\n  position: relative;\n  display: inline-block;\n  vertical-align: middle; }\n  .btn-group > .btn:first-child {\n    margin-left: 0; }\n  .btn-group > .btn:first-child:not(:last-child) {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0; }\n  .btn-group > .btn:last-child:not(:first-child) {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0; }\n  .btn-group .btn-group > .btn.active {\n    z-index: 2; }\n  .btn-group .btn {\n    position: relative;\n    float: left;\n    border: 1px solid transparent; }\n    .btn-group .btn + .btn {\n      margin-left: -1px; }\n\n.btn.active {\n  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125); }\n\n.form .input-group {\n  position: relative;\n  margin-top: 12px;\n  overflow: hidden; }\n  .form .input-group .label {\n    position: absolute;\n    width: 114px;\n    height: 36px;\n    line-height: 36px;\n    font-size: 14px;\n    color: #999999;\n    text-align: right;\n    left: 0;\n    top: 0; }\n  .form .input-group .input {\n    position: relative;\n    margin-left: 132px; }\n    .form .input-group .input input,\n    .form .input-group .input textarea,\n    .form .input-group .input select {\n      display: block;\n      position: relative;\n      width: 270px;\n      margin: 0;\n      padding: 6px;\n      font-size: 14px;\n      color: #222222;\n      border: 1px solid #dadedd;\n      border-radius: 0;\n      background-color: #fff; }\n      .form .input-group .input input:focus,\n      .form .input-group .input textarea:focus,\n      .form .input-group .input select:focus {\n        border-color: #00816a; }\n      .form .input-group .input input.readonly, .form .input-group .input input.readonly:focus,\n      .form .input-group .input textarea.readonly,\n      .form .input-group .input textarea.readonly:focus,\n      .form .input-group .input select.readonly,\n      .form .input-group .input select.readonly:focus {\n        background-color: #f5f5f5;\n        border-color: #dadedd; }\n    .form .input-group .input input,\n    .form .input-group .input select {\n      height: 36px;\n      line-height: 36px; }\n    .form .input-group .input textarea {\n      height: 100px; }\n    .form .input-group .input.captcha input {\n      width: 100px;\n      float: left; }\n    .form .input-group .input.captcha .captcha-image {\n      position: relative;\n      width: 120px;\n      height: 36px;\n      float: left;\n      margin-left: 16px; }\n    .form .input-group .input.captcha .error-message {\n      float: left;\n      height: 36px;\n      line-height: 36px; }\n    .form .input-group .input .error-message {\n      position: relative;\n      height: 18px;\n      line-height: 18px;\n      color: #ff3333;\n      font-size: 14px; }\n    .form .input-group .input .tips {\n      font-size: 12px;\n      color: #999999;\n      margin-top: 3px; }\n  .form .input-group input.ng-touched.ng-invalid,\n  .form .input-group input.ng-touched.ng-invalid:focus,\n  .form .input-group textarea.ng-touched.ng-invalid,\n  .form .input-group textarea.ng-touched.ng-invalid:focus,\n  .form .input-group select.ng-touched.ng-invalid,\n  .form .input-group select.ng-touched.ng-invalid:focus,\n  .form .input-group .ng-submitted input.ng-touched.ng-invalid,\n  .form .input-group input.ng-touched.ng-invalid:focus,\n  .form .input-group textarea.ng-touched.ng-invalid,\n  .form .input-group textarea.ng-touched.ng-invalid:focus,\n  .form .input-group select.ng-touched.ng-invalid,\n  .form .input-group select.ng-touched.ng-invalid:focus {\n    border-color: #ff3333; }\n\n.form.ng-submitted input.ng-invalid,\n.form.ng-submitted input.ng-invalid:focus,\n.form.ng-submitted textarea.ng-invalid,\n.form.ng-submitted textarea.ng-invalid:focus,\n.form.ng-submitted select.ng-invalid,\n.form.ng-submitted select.ng-invalid:focus {\n  border-color: #ff3333; }\n\n.form.horizontal .input input,\n.form.horizontal .input textarea,\n.form.horizontal .input select,\n.form.horizontal .input .error-message {\n  float: left; }\n\n.form.horizontal .input .error-message {\n  margin-left: 6px;\n  height: 36px;\n  line-height: 36px; }\n\n.form-horizontal .form-group {\n  margin-bottom: 7px; }\n\n.form-horizontal .form-inline .form-group {\n  display: inline-block; }\n\n.form-horizontal .control-label {\n  margin-bottom: 0;\n  width: 114px;\n  font-size: 14px;\n  color: #999999;\n  display: inline-block; }\n\n.form-horizontal .control-group {\n  padding: 0 7px;\n  display: table;\n  border-collapse: separate; }\n  .form-horizontal .control-group .form-control {\n    display: table-cell;\n    position: relative;\n    z-index: 2;\n    width: 100%; }\n    .form-horizontal .control-group .form-control:first-child {\n      border-top-right-radius: 0;\n      border-bottom-right-radius: 0;\n      border-right: 0; }\n\n.form-horizontal .input-group {\n  display: table;\n  border-collapse: separate; }\n  .form-horizontal .input-group .form-control {\n    display: table-cell; }\n\n.form-horizontal .input-group-btn {\n  display: table-cell;\n  white-space: nowrap;\n  vertical-align: middle;\n  width: 1%; }\n\n.form-horizontal .help-block {\n  display: block;\n  margin-top: 5px;\n  margin-bottom: 10px;\n  color: #737373;\n  font-size: 14px;\n  line-height: 1.42857143; }\n\n.form-horizontal .has-error .control-label {\n  color: #ff3333; }\n\n.form-horizontal .has-error .help-block {\n  color: #ff3333; }\n\n.form-horizontal .has-error .form-control {\n  border-color: #ff3333; }\n\n.form-horizontal .form-control {\n  padding: 6px 12px;\n  line-height: 1.43;\n  width: 100%;\n  display: block;\n  font-size: 14px;\n  color: #666666;\n  border: 1px solid #dadedd;\n  border-right: 0;\n  background-color: #fff; }\n\n.form-horizontal .radio {\n  display: inline-block;\n  padding: 10px 0 0;\n  margin-top: 0;\n  margin-bottom: 0;\n  font-size: 14px;\n  vertical-align: middle; }\n  .form-horizontal .radio label {\n    min-height: 20px;\n    padding-left: 20px;\n    margin-bottom: 0;\n    font-weight: normal;\n    cursor: pointer; }\n\n.password-alert {\n  position: absolute;\n  top: 110%;\n  padding: 1px;\n  background-color: #fff;\n  z-index: 100;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2); }\n  .password-alert p {\n    margin: 10px 0; }\n  .password-alert .inner {\n    padding: 10px;\n    font-size: 16px; }\n    .password-alert .inner .demands {\n      font-size: 14px;\n      line-height: 1.4; }\n      .password-alert .inner .demands .ybicon {\n        margin-right: 10px; }\n      .password-alert .inner .demands .success {\n        color: #00c853; }\n        .password-alert .inner .demands .success .ybicon {\n          color: #64dd17; }\n      .password-alert .inner .demands .error {\n        color: #ff1744; }\n        .password-alert .inner .demands .error .ybicon {\n          color: #ff5252; }\n    .password-alert .inner .meter {\n      margin-top: 15px; }\n      .password-alert .inner .meter .progress {\n        position: relative;\n        height: 5px;\n        background-color: #d8d8d8; }\n        .password-alert .inner .meter .progress .bar {\n          position: absolute;\n          height: inherit;\n          width: 0;\n          transition: width 0.5s ease-in-out, background 0.25s; }\n        .password-alert .inner .meter .progress .bar.low {\n          background-color: #ff1744; }\n        .password-alert .inner .meter .progress .bar.medium {\n          background-color: #fbc02d; }\n        .password-alert .inner .meter .progress .bar.high {\n          background-color: #1de9b6; }\n      .password-alert .inner .meter .desc {\n        font-size: 12px;\n        color: #999999; }\n  .password-alert .arrow {\n    position: absolute;\n    width: 0;\n    height: 0;\n    border: 11px solid transparent;\n    border-top-width: 0;\n    border-bottom-color: rgba(0, 0, 0, 0.25);\n    top: -11px;\n    left: 50%;\n    margin-left: -11px; }\n    .password-alert .arrow:before {\n      position: absolute;\n      display: block;\n      content: \" \";\n      width: 0;\n      height: 0;\n      border: 10px solid transparent;\n      border-top-width: 0;\n      border-bottom-color: #fff;\n      top: 1px;\n      left: 50%;\n      margin-left: -10px; }\n\n.form-action {\n  text-align: center; }\n  .form-action button + button {\n    margin-left: 10px; }\n\n@media only screen and (max-width: 767px) {\n  .form .label {\n    text-align: left !important;\n    position: relative !important;\n    width: auto !important;\n    height: auto !important; }\n  .form .input-group {\n    margin-top: 6px !important; }\n  .form .input {\n    margin-left: 0 !important; }\n    .form .input input,\n    .form .input textarea {\n      width: 100% !important; }\n    .form .input.captcha input {\n      width: 100px !important; }\n    .form .input .error-message {\n      margin-left: 0 !important;\n      height: 18px !important;\n      line-height: 18px !important; }\n  .form-horizontal .form-group {\n    margin-top: 10px; }\n  .form-horizontal .control-group {\n    float: none;\n    padding-left: 114px; }\n    .form-horizontal .control-group::after {\n      display: block;\n      clear: both;\n      content: \"\"; }\n  .form-horizontal .control-group:not(:nth-child(-n+2)) {\n    margin-top: 5px; }\n  .form-horizontal .radio {\n    display: block;\n    padding-left: 114px; }\n  .form-horizontal .form-action {\n    margin-top: 10px; } }\n", ""]);

// exports


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _buttonTab = __webpack_require__(690);

var _buttonTab2 = _interopRequireDefault(_buttonTab);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var buttonTabModule = _angular2.default.module('buttonTab', []).component('buttonTab', _buttonTab2.default).name;

exports.default = buttonTabModule;

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _buttonTab = __webpack_require__(691);

var _buttonTab2 = _interopRequireDefault(_buttonTab);

var _buttonTab3 = __webpack_require__(692);

var _buttonTab4 = _interopRequireDefault(_buttonTab3);

__webpack_require__(693);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var buttonTabComponent = {
    restrict: 'E',
    transclude: true,
    bindings: {
        tabs: '=',
        onLoaded: '&'
    },
    template: _buttonTab2.default,
    controller: _buttonTab4.default
};

exports.default = buttonTabComponent;

/***/ }),
/* 691 */
/***/ (function(module, exports) {

module.exports = "<div class=\"button-tab\">\n    <div class=\"tabs\">\n        <div ng-click=\"$ctrl.clickTab(tab)\" ng-class=\"{'tab':true,'active':$ctrl.activeTab == tab.name}\"\n             ng-repeat=\"tab in $ctrl.tabs\">{{ tab.name }}\n        </div>\n    </div>\n    <ng-transclude></ng-transclude>\n</div>\n";

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ButtonTabController = function () {
    function ButtonTabController() {
        (0, _classCallCheck3.default)(this, ButtonTabController);

        for (var i = 0, l = this.tabs.length; i < l; i++) {
            if (this.tabs[i].active) {
                this.activeTab = this.tabs[i].name;
                break;
            }
        }

        var self = this;

        var operations = {
            loadTab: function loadTab(name) {
                for (var _i = 0; _i < self.tabs.length; _i++) {
                    if (self.tabs[_i].name === name) {
                        self.clickTab(self.tabs[_i]);
                    }
                }
            }
        };

        this.onLoaded({ operations: operations });
    }

    (0, _createClass3.default)(ButtonTabController, [{
        key: 'clickTab',
        value: function clickTab(tab) {
            this.activeTab = tab.name;

            if (typeof tab.click == 'function') {
                tab.click();
            }
        }
    }]);
    return ButtonTabController;
}();

exports.default = ButtonTabController;

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(694);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./button-tab.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./button-tab.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "button-tab .tabs {\n  position: relative;\n  overflow: auto; }\n  button-tab .tabs .tab {\n    position: relative;\n    padding: 6px 18px;\n    float: left;\n    font-size: 14px;\n    color: #666666;\n    background-color: #ffffff;\n    border-top: 1px solid #e8eaea;\n    border-left: 1px solid #e8eaea;\n    border-bottom: 1px solid #e8eaea;\n    cursor: pointer; }\n    button-tab .tabs .tab:first-child {\n      border-top-left-radius: 3px;\n      border-bottom-left-radius: 3px; }\n    button-tab .tabs .tab:last-child {\n      border-right: 1px solid #e8eaea;\n      border-top-right-radius: 3px;\n      border-bottom-right-radius: 3px; }\n    button-tab .tabs .tab:hover {\n      color: #00816a;\n      background-color: #f5f5f5; }\n    button-tab .tabs .tab.active {\n      color: #00816a;\n      cursor: default; }\n\nbutton-tab.inverse .tabs .tab.active {\n  color: #ffffff;\n  background-color: #00816a; }\n\nbutton-tab.lg .tabs .tab {\n  padding: 8px 18px; }\n", ""]);

// exports


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _ybInput = __webpack_require__(696);

var _ybInput2 = _interopRequireDefault(_ybInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ybInputModule = _angular2.default.module('ybInput', []).component('ybInput', _ybInput2.default).name;

exports.default = ybInputModule;

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ybInput = __webpack_require__(697);

var _ybInput2 = _interopRequireDefault(_ybInput);

var _ybInput3 = __webpack_require__(698);

var _ybInput4 = _interopRequireDefault(_ybInput3);

__webpack_require__(699);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ybInputComponent = {
    restrict: 'E',
    bindings: {
        className: '@',
        type: '@',
        labelText: '@',
        ngValue: '=',
        ngModel: '=',
        change: '&',
        click: '&'
    },
    template: _ybInput2.default,
    controller: _ybInput4.default
};

exports.default = ybInputComponent;

/***/ }),
/* 697 */
/***/ (function(module, exports) {

module.exports = "<div ng-class=\"['yb-input',$ctrl.className,{active:$ctrl.ngValue==$ctrl.ngModel}]\">\n    <label>\n        <input type=\"{{$ctrl.type||'radio'}}\"\n               ng-value=\"$ctrl.ngValue\"\n               ng-model=\"$ctrl.ngModel\"\n               ng-change=\"$ctrl.onChange($event)\"/>\n        {{$ctrl.labelText}}\n    </label>\n</div>\n<!-- radio/checkbox 控件-->\n<!--<yb-input type=\"radio\" class-name=\"radio-control\" ng-model=\"license.content.adaptation\" ng-value=\"'n'\" label-text='否'></yb-input>-->\n<!--<yb-input type=\"checkbox\" class-name=\"checkbox-control checkone\" ng-model=\"evidence.checked\" ng-value=\"'1'\" change=\"$ctrl.checkone()\">-->\n";

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ybInputController = function () {
    ybInputController.$inject = ["$scope"];

    function ybInputController($scope) {
        "ngInject";

        (0, _classCallCheck3.default)(this, ybInputController);
    }

    (0, _createClass3.default)(ybInputController, [{
        key: "onChange",
        value: function onChange() {
            this.change && this.change();
        }
    }]);
    return ybInputController;
}();

exports.default = ybInputController;

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(700);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./yb-input.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./yb-input.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "yb-input .yb-input {\n  display: inline-block;\n  cursor: pointer;\n  font-size: 14px;\n  line-height: 16px;\n  height: 16px;\n  position: relative; }\n  yb-input .yb-input label {\n    cursor: pointer;\n    height: 16px;\n    display: inline-block;\n    position: relative;\n    z-index: 2; }\n    yb-input .yb-input label input {\n      opacity: 0;\n      cursor: pointer; }\n  yb-input .yb-input:before {\n    position: absolute;\n    z-index: 1;\n    content: '';\n    left: 0;\n    top: 0;\n    width: 16px;\n    height: 16px;\n    background-color: #f5f5f5;\n    border: 1px solid #cfcfcf;\n    box-sizing: border-box; }\n  yb-input .yb-input.active:before {\n    background-color: #00816a;\n    border-color: #00816a; }\n  yb-input .yb-input.active:after {\n    position: absolute;\n    z-index: 1;\n    left: 0;\n    top: 0;\n    color: #fff;\n    content: '\\2713';\n    font-size: 12px;\n    width: 16px;\n    text-align: center; }\n  yb-input .yb-input.radio-control {\n    margin-right: 30px; }\n    yb-input .yb-input.radio-control label {\n      padding-left: 5px; }\n    yb-input .yb-input.radio-control:before {\n      border-radius: 100%; }\n  yb-input .yb-input.checkbox-control label {\n    padding-left: 5px;\n    min-width: 16px; }\n", ""]);

// exports


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _ybSelect = __webpack_require__(702);

var _ybSelect2 = _interopRequireDefault(_ybSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ybSelectModule = _angular2.default.module('ybSelect', []).component('ybSelect', _ybSelect2.default).name;

exports.default = ybSelectModule;

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ybSelect = __webpack_require__(703);

var _ybSelect2 = _interopRequireDefault(_ybSelect);

var _ybSelect3 = __webpack_require__(704);

var _ybSelect4 = _interopRequireDefault(_ybSelect3);

__webpack_require__(705);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ybselectComponent = {
    restrict: 'E',
    bindings: {
        items: '=',
        selected: '=',
        change: '&'
    },
    template: _ybSelect2.default,
    controller: _ybSelect4.default
};

exports.default = ybselectComponent;

/***/ }),
/* 703 */
/***/ (function(module, exports) {

module.exports = "<div class=\"yb-select-control\" >\n    <div class=\"select-label\">{{$ctrl.selected.text}}</div>\n    <div class=\"list\">\n        <div class=\"list-item\"\n             ng-click=\"$ctrl.selectItem(item)\"\n             ng-class=\"{active:$ctrl.selected.value==item.value}\"\n             ng-repeat=\"item in $ctrl.items\n\n\">{{item.text}}</div>\n    </div>\n</div>\n";

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ybSelectController = function () {
    ybSelectController.$inject = ["$timeout", "$sce"];

    function ybSelectController($timeout, $sce) {
        "ngInject";

        (0, _classCallCheck3.default)(this, ybSelectController);
        this.$timeout = $timeout;
    }

    (0, _createClass3.default)(ybSelectController, [{
        key: "selectItem",
        value: function selectItem(item) {
            var _this = this;

            this.selected = item;
            this.$timeout(function () {
                _this.change();
            });
        }
    }]);
    return ybSelectController;
}();

exports.default = ybSelectController;

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(706);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./yb-select.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./yb-select.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "yb-select {\n  display: inline-block;\n  font-size: 0; }\n  yb-select .yb-select-control {\n    font-size: 14px;\n    position: relative; }\n    yb-select .yb-select-control .select-label {\n      position: relative;\n      height: 50px;\n      line-height: 50px;\n      color: #666666;\n      text-align: center;\n      padding: 0 40px 0 20px;\n      cursor: pointer; }\n      yb-select .yb-select-control .select-label:after {\n        content: '';\n        position: absolute;\n        right: 15px;\n        top: 23px;\n        border: 5px solid transparent;\n        border-top-color: #666666; }\n    yb-select .yb-select-control .list {\n      position: absolute;\n      background-color: #fff;\n      left: 0;\n      top: 45px;\n      width: 100%;\n      display: none;\n      border: 1px solid #e8eaea;\n      padding: 5px 0; }\n      yb-select .yb-select-control .list:after {\n        content: '';\n        position: absolute;\n        z-index: 1;\n        right: 13px;\n        top: -6px;\n        border: 1px solid #e8eaea;\n        width: 10px;\n        height: 10px;\n        -webkit-transform: rotate(45deg);\n        border-width: 1px 0px 0px 1px;\n        background-color: #fff; }\n      yb-select .yb-select-control .list .list-item {\n        position: relative;\n        z-index: 2;\n        height: 30px;\n        line-height: 30px;\n        text-align: center;\n        cursor: pointer; }\n        yb-select .yb-select-control .list .list-item.active, yb-select .yb-select-control .list .list-item.active:hover {\n          color: #fff;\n          background-color: #00816a; }\n        yb-select .yb-select-control .list .list-item:hover {\n          color: #00816a; }\n    yb-select .yb-select-control:hover .list {\n      display: block; }\n", ""]);

// exports


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _radioList = __webpack_require__(708);

var _radioList2 = _interopRequireDefault(_radioList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var radiolistModule = _angular2.default.module('radiolist', []).component('radioList', _radioList2.default).name;

exports.default = radiolistModule;

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _radioList = __webpack_require__(709);

var _radioList2 = _interopRequireDefault(_radioList);

var _radioList3 = __webpack_require__(710);

var _radioList4 = _interopRequireDefault(_radioList3);

__webpack_require__(711);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var radiolistComponent = {
    restrict: 'E',
    bindings: {
        items: '=',
        selected: '=',
        change: '&'
    },
    template: _radioList2.default,
    controller: _radioList4.default
};

exports.default = radiolistComponent;

/***/ }),
/* 709 */
/***/ (function(module, exports) {

module.exports = "<div class=\"radio-list-control\" >\n        <div class=\"item ybicon\"\n             ng-click=\"$ctrl.selectItem(item)\"\n             ng-class=\"{'active':$ctrl.selected.value==item.value,\n                        'yb-select':$ctrl.selected.value==item.value}\"\n             ng-repeat=\"item in $ctrl.items\">{{item.text}}</div>\n</div>\n";

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ybSelectController = function () {
    ybSelectController.$inject = ["$timeout", "$sce"];

    function ybSelectController($timeout, $sce) {
        "ngInject";

        (0, _classCallCheck3.default)(this, ybSelectController);
        this.$timeout = $timeout;
    }

    (0, _createClass3.default)(ybSelectController, [{
        key: "selectItem",
        value: function selectItem(item) {
            var _this = this;

            this.selected = item;
            this.$timeout(function () {
                _this.change();
            });
        }
    }]);
    return ybSelectController;
}();

exports.default = ybSelectController;

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(712);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./radio-list.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./radio-list.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "radio-list {\n  display: inline-block;\n  font-size: 0; }\n  radio-list .radio-list-control {\n    font-size: 14px;\n    position: relative;\n    display: inline-block; }\n    radio-list .radio-list-control .item {\n      display: inline-block;\n      color: #666666;\n      cursor: pointer;\n      position: relative;\n      padding-left: 20px;\n      margin-right: 12px;\n      line-height: 16px; }\n      radio-list .radio-list-control .item * {\n        box-sizing: border-box; }\n      radio-list .radio-list-control .item:after {\n        position: absolute;\n        z-index: 1;\n        left: 0;\n        top: 0;\n        width: 14px;\n        height: 14px;\n        display: inline-block;\n        content: '';\n        border: 1px solid #e8eaea; }\n      radio-list .radio-list-control .item:before {\n        font-size: 16px;\n        position: absolute;\n        left: 0;\n        top: 0;\n        z-index: 2; }\n      radio-list .radio-list-control .item.active:before {\n        color: #00816a; }\n", ""]);

// exports


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _dialogModal = __webpack_require__(714);

var _dialogModal2 = _interopRequireDefault(_dialogModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dialogModalModule = _angular2.default.module('dialogModal', []).component('dialogModal', _dialogModal2.default).name;

exports.default = dialogModalModule;

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _dialogModal = __webpack_require__(715);

var _dialogModal2 = _interopRequireDefault(_dialogModal);

var _dialogModal3 = __webpack_require__(716);

var _dialogModal4 = _interopRequireDefault(_dialogModal3);

__webpack_require__(717);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var navtabComponent = {
    restrict: 'E',
    bindings: {
        text: '@',
        sure: '&',
        cancel: '&',
        position: '=',
        isActive: '='
    },
    template: _dialogModal2.default,
    controller: _dialogModal4.default
};

exports.default = navtabComponent;

/***/ }),
/* 715 */
/***/ (function(module, exports) {

module.exports = "<div class=\"dialog-modal\" ng-style=\"$ctrl.position\" ng-class=\"{active:$ctrl.isActive}\">\n    <div class=\"content\" ng-bind-html=\"$ctrl.$sce.trustAsHtml($ctrl.text)\"></div>\n    <div class=\"footer clearfix\">\n        <button class=\"btn btn-primary btn-sm pull-left\" ng-click=\"$ctrl.sure();\">{{'modal-text001' | translate}}</button>\n        <button class=\"btn btn-default btn-sm pull-right\" ng-click=\"$ctrl.isActive=false;$event.stopPropagation();\">{{'modal-text002' | translate}}</button>\n    </div>\n</div>\n";

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DialogModalController = function DialogModalController($timeout, $sce) {
    "ngInject";

    var _this = this;

    (0, _classCallCheck3.default)(this, DialogModalController);
    this.$sce = $sce;
    $('body').on('click', function () {
        $timeout(function () {
            _this.isActive = false;
        });
    });
};

DialogModalController.$inject = ['$timeout', '$sce'];
exports.default = DialogModalController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(718);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./dialog-modal.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./dialog-modal.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "dialog-modal .dialog-modal {\n  position: fixed;\n  width: 326px;\n  left: 50%;\n  top: -300px;\n  transform: translate(-50%, 0);\n  border: 1px solid #e8eaea;\n  background: #fff;\n  padding: 30px;\n  z-index: 2;\n  transition: all .2s ease-in-out;\n  box-shadow: 0px 0px 1px #ccc; }\n  dialog-modal .dialog-modal.active {\n    top: 70px; }\n  dialog-modal .dialog-modal .content {\n    color: #222222;\n    margin-bottom: 30px;\n    line-height: 1.5;\n    word-break: break-all;\n    max-height: 170px;\n    overflow: hidden; }\n  dialog-modal .dialog-modal .footer {\n    text-align: center; }\n    dialog-modal .dialog-modal .footer .btn {\n      width: 120px;\n      padding: 0;\n      line-height: 34px;\n      font-size: 14px; }\n\n@media only screen and (max-width: 767px) {\n  dialog-modal .dialog-modal {\n    width: 80%;\n    padding: 20px;\n    z-index: 2; }\n    dialog-modal .dialog-modal.active {\n      top: 80px; }\n    dialog-modal .dialog-modal .content {\n      color: #222222;\n      margin-bottom: 20px;\n      line-height: 1.5;\n      word-break: break-all; }\n    dialog-modal .dialog-modal .footer {\n      text-align: center; }\n      dialog-modal .dialog-modal .footer .btn {\n        width: 45%;\n        padding: 0;\n        line-height: 34px;\n        font-size: 14px; } }\n", ""]);

// exports


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _language = __webpack_require__(720);

var _language2 = _interopRequireDefault(_language);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var languageModule = _angular2.default.module('language', []).component('language', _language2.default).name;

exports.default = languageModule;

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _language = __webpack_require__(721);

var _language2 = _interopRequireDefault(_language);

var _language3 = __webpack_require__(722);

var _language4 = _interopRequireDefault(_language3);

__webpack_require__(723);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var languageComponent = {
    restrict: 'E',
    template: _language2.default,
    controller: _language4.default
};

exports.default = languageComponent;

/***/ }),
/* 721 */
/***/ (function(module, exports) {

module.exports = "<select class=\"language-switch\" ng-model=\"$ctrl.cur_lang\"  ng-change=\"$ctrl.switching($ctrl.cur_lang)\">\n    <option value=\"en\">English</option>\n    <option value=\"zh-CN\">简体中文</option>\n    <option value=\"japanese\">Japanese</option>\n</select>\n";

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
   value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var languageController = function () {
   languageController.$inject = ["$translate"];

   function languageController($translate) {
      "ngInject";

      (0, _classCallCheck3.default)(this, languageController);
      this.$translate = $translate;
      this.cur_lang = window.localStorage.yuanben_lang;
   }

   (0, _createClass3.default)(languageController, [{
      key: "switching",
      value: function switching(lang) {

         if (lang === "japanese") {
            window.location.href = "http://www.genpon.jp";
            return;
         }

         this.$translate.use(lang);
         window.localStorage.yuanben_lang = lang;
         location.reload();
      }
   }]);
   return languageController;
}();

exports.default = languageController;

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(724);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./language.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./language.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".language-switch {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  -ms-appearance: none;\n  padding: 4px 10px;\n  position: absolute;\n  z-index: 2;\n  right: 20px;\n  top: 30px;\n  border: 1px solid rgba(255, 255, 255, 0.7);\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.7);\n  background: none; }\n  .language-switch option {\n    color: #333; }\n\n.inner-nav-lang .language-switch {\n  top: 24px; }\n\n.footer-lang .language-switch {\n  display: inline-block;\n  position: static;\n  color: rgba(255, 255, 255, 0.4);\n  border-color: rgba(255, 255, 255, 0.4);\n  padding: 2px 6px;\n  margin: 0 6px; }\n\n.footer-lang.small .language-switch {\n  color: #999;\n  border-color: #999; }\n\n@media only screen and (max-width: 1400px) {\n  .language-switch {\n    display: none; } }\n", ""]);

// exports


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    return function (scope, element) {
        element[0].focus();
    };
};

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(727);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/index.js!./common.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/index.js!./common.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _home = __webpack_require__(729);

var _home2 = _interopRequireDefault(_home);

var _face = __webpack_require__(776);

var _face2 = _interopRequireDefault(_face);

var _page = __webpack_require__(1003);

var _page2 = _interopRequireDefault(_page);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modules = [_home2.default, _face2.default, _page2.default];

var moduleNames = [];

modules.forEach(function (m) {
    moduleNames.push(m.name);
});

var componentModule = _angular2.default.module('app.components', moduleNames).config(['$stateProvider', function ($stateProvider) {
    "ngInject";

    modules.forEach(function (m) {
        m.states.forEach(function (state) {

            state.name = 'app.' + state.name;

            $stateProvider.state(state);
        });
    });
}]).name;

exports.default = componentModule;

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = __webpack_require__(73);

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

__webpack_require__(354);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var lazyState = {
    name: 'home.**',
    url: '/home'
};

var homeModule = _angular2.default.module('home', [_angularUiRouter2.default, "oc.lazyLoad"]).config(['$stateProvider', '$compileProvider', function ($stateProvider, $compileProvider) {
    "ngInject";

    lazyState.lazyLoad = function (transition) {

        var injector = transition.injector();

        var $q = injector.get('$q');
        var $ocLazyLoad = injector.get('$ocLazyLoad');

        var deferred = $q.defer();

        // Webpack code splitting point
        __webpack_require__.e/* require.ensure */(0).then((function (require) {

            // In babel 6 ".default" must be manually added
            var homeComponent = __webpack_require__(1272).default;

            var modules = [];
            modules.push(__webpack_require__(1273).default);
            modules.push(__webpack_require__(1274).default);
            modules.push(__webpack_require__(1275).default);
            modules.push(__webpack_require__(1276).default);
            modules.push(__webpack_require__(1277).default);
            modules.push(__webpack_require__(1278).default);
            modules.push(__webpack_require__(1279).default);
            modules.push(__webpack_require__(1280).default);
            modules.push(__webpack_require__(1281).default);
            modules.push(__webpack_require__(1282).default);
            modules.push(__webpack_require__(1283).default);

            var moduleStates = [];
            var moduleNames = [];

            modules.forEach(function (dm) {

                moduleNames.push(dm.name);

                dm.states.forEach(function (s) {

                    s.name = 'app.home.' + s.name;
                    moduleStates.push(s);
                });
            });

            $ocLazyLoad.inject(moduleNames).then(function () {
                $compileProvider.component('home', homeComponent);
            }).then(function () {

                moduleStates.unshift({
                    name: 'app.home',
                    url: '/home',
                    component: 'home'
                    // resolve: {
                    //     appUser: (userLogin) => {
                    //         "ngInject";
                    //
                    //         return userLogin.getUserOrPromise();
                    //     }
                    // }
                });

                deferred.resolve({
                    states: moduleStates
                });
            });
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);

        return deferred.promise;
    };
}]).name;

var states = [lazyState];

exports.default = { name: homeModule, states: states };

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

/**
 * Created by ganlu on 27/12/2016.
 */
exports.default = function () {

    //Fancybox-Plus JavaScript API reference:
    // http://igorlino.github.io/fancybox-plus/api.htm

    return {
        fancyboxPlus: fancyboxPlus, //returns the fancyboxplus jquery plugin
        showActivity: showActivity, //Shows loading animation
        hideActivity: hideActivity, //Hides loading animation
        next: next, //Displays the next gallery item
        prev: prev, //Displays the previous gallery item
        pos: pos, //Displays item by index from gallery
        cancel: cancel, //Cancels loading content
        close: close, //Hides FancyBox. Within an iframe use - parent.close();
        resize: resize, //Auto-resizes FancyBox height to match height of content
        center: center, //Centers FancyBox in viewport
        getOptions: getOptions

    };
    ////////////
    function fancyboxPlus() {
        return $.fancyboxPlus;
    }

    function showActivity() {
        fancyboxPlus().showActivity();
    }

    function hideActivity() {
        fancyboxPlus().hideActivity();
    }

    function pos() {
        fancyboxPlus().pos();
    }

    function cancel() {
        fancyboxPlus().cancel();
    }

    function center() {
        fancyboxPlus().center();
    }

    function next() {
        fancyboxPlus().next();
    }

    function prev() {
        fancyboxPlus().prev();
    }

    function close() {
        fancyboxPlus().close();
    }

    function resize() {
        fancyboxPlus().resize();
    }

    function getOptions(titleFormat) {
        var options = {
            transitionIn: 'none',
            transitionOut: 'none',
            padding: 0,
            margin: 100,
            overlayColor: '#000000',
            overlayOpacity: 0.8,
            titlePosition: 'inside',
            autoScale: "true",
            onComplete: function onComplete() {
                $('body').addClass('no-scroll');
            },
            onClosed: function onClosed() {
                $('body').removeClass('no-scroll');
            }
        };

        if (typeof titleFormat == 'function') {
            options['titleFormat'] = titleFormat;
        }
        if (window.innerWidth < 767) {
            options['margin'] = 20;
        }
        return options;
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * Created by ganlu on 27/12/2016.
 */
exports.default = ['$compile', '$rootScope', '$http', '$parse', '$timeout', function ($compile, $rootScope, $http, $parse, $timeout) {

    "ngInject";

    return {
        restrict: 'A',
        link: fancyboxableLink,
        priority: 100
    };

    ////////////////////////////

    function fancyboxableLink($scope, $element, $attributes, controller) {
        var fbp = null;

        $scope.$on('$destroy', function () {
            $element.remove();
        });

        init();

        function init(open) {
            var options = {
                href: $attributes.src ? $attributes.src : $attributes.href,
                onComplete: function onComplete() {
                    _onComplete();
                }
            };

            //generic way that sets all (non-function) parameters of fancybox-plus.
            if ($attributes.fancyboxable && $attributes.fancyboxable.length > 0) {
                var fbpOptionsFunc = $parse($attributes.fancyboxable);
                var fbpOptions = fbpOptionsFunc($scope);
                angular.extend(options, fbpOptions);
            }

            //clean undefined
            for (var key in options) {
                if (options.hasOwnProperty(key)) {
                    if (typeof options[key] === 'undefined') {
                        delete options[key];
                    }
                }
            }

            if (typeof open !== 'undefined') {
                options.open = open;
            }

            //wait for the DOM view to be ready
            $timeout(function () {

                if (!$attributes.ngSrc) {
                    //opens the fancybox using an href.
                    fbp = $($element).fancyboxPlus(options);
                } else {
                    //$element.bind('load', function() {
                    /*$scope.$apply(function () {
                     options.href = $attributes.src ? $attributes.src : $attributes.href;
                     cb = $.colorbox(options);
                     });*/
                    //wait for the DOM view to be ready
                    $timeout(function () {
                        options.href = $attributes.src ? $attributes.src : $attributes.href;
                        fbp = $($element).fancyboxPlus(options);
                    }, 300);
                    //});
                }
            }, 0);
        }

        function _onComplete() {
            $rootScope.$apply(function () {
                var content = $('#fbplus-content');
                $compile(content)($rootScope);
            });
        }
    }
}];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _fancybox = __webpack_require__(733);

var _fancybox2 = _interopRequireDefault(_fancybox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = ['$compile', '$rootScope', '$http', '$parse', '$timeout', 'fancyboxService', function ($compile, $rootScope, $http, $parse, $timeout, fancyboxService) {

    "ngInject";

    var service = {
        restrict: 'E',
        scope: {
            options: '=',
            templateUrl: '&',

            onStart: '&', //Will be called right before attempting to load the content
            onCancel: '&', //Will be called after loading is canceled
            onComplete: '&', //Will be called once the content is displayed
            onCleanup: '&', //Will be called just before closing
            onClosed: '&' //Will be called once FancyBox is closed

        },
        require: 'fancybox',
        link: link,
        controller: _fancybox2.default,
        controllerAs: 'vm'
    };
    return service;

    ////////////////////////////

    function link($scope, $element, $attributes) {
        var fbp = null;

        $scope.$on('$destroy', function () {
            $element.remove();
        });

        init();

        function init() {
            var options = {
                href: $attributes.src,
                boxFor: $attributes.boxFor,
                onOpen: function onOpen() {
                    if ($scope.onOpen && $scope.onOpen()) {
                        $scope.onOpen()();
                    }
                },
                onCancel: function onCancel() {
                    if ($scope.onCancel && $scope.onCancel()) {
                        $scope.onCancel()();
                    }
                },
                onComplete: function onComplete() {
                    _onComplete();
                    if ($scope.onComplete && $scope.onComplete()) {
                        $scope.onComplete()();
                    }
                },
                onCleanup: function onCleanup() {
                    if ($scope.onCleanup && $scope.onCleanup()) {
                        $scope.onCleanup()();
                    }
                },
                onClosed: function onClosed() {
                    if ($scope.onClosed && $scope.onClosed()) {
                        $scope.onClosed()();
                    }
                }
            };

            //generic way that sets all (non-function) parameters of fancybox-plus.
            if ($scope.options) {
                angular.extend(options, $scope.options);
            }

            //clean undefined
            for (var key in options) {
                if (options.hasOwnProperty(key)) {
                    if (typeof options[key] === 'undefined') {
                        delete options[key];
                    }
                }
            }

            //wait for the DOM view to be ready
            $timeout(function () {
                if (options.boxFor) {
                    //opens the element by id boxFor
                    fbp = $(options.boxFor).fancyboxPlus(options);
                } else if (options.href) {
                    //opens the fancybox-plus using an href.
                    fbp = $.fancyboxPlus(options);
                }
            }, 0);
        }

        function _onComplete() {
            $rootScope.$apply(function () {
                var content = $('#fbplus-content');
                $compile(content)($rootScope);
            });
        }
    }
}]; /**
     * Created by ganlu on 27/12/2016.
     */
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by ganlu on 27/12/2016.
 */
var FancyboxController = function FancyboxController() {
  (0, _classCallCheck3.default)(this, FancyboxController);
};

exports.default = FancyboxController;

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/*
 *  <%= pkg.title || pkg.name %> - v<%= pkg.version %>
 *  <%= pkg.description %>
 *  <%= pkg.homepage %>
 *
 *  Made by <%= pkg.author.name %>
 *  Under <%= pkg.license %> License
 */
/*
 * FancyBox Plus - jQuery Plugin
 * Simple and fancy lightbox alternative
 *
 * Examples and documentation at: http://igorlino.github.io/fancybox-plus/
 *
 * Version: 1.3.5 (20.06.2015)
 * Requires: jQuery v1.3+
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 */

;
(function ($) {
    var tmp, loading, overlay, wrap, outer, content, close, title, nav_left, nav_right,

        selectedIndex = 0, selectedOpts = {}, selectedArray = [], currentIndex = 0, currentOpts = {}, currentArray = [],

        ajaxLoader = null, imgPreloader = new Image(), imgRegExp = /\.(jpg|gif|png|bmp|jpeg)(.*)?$/i, swfRegExp = /[^\.]\.(swf)\s*$/i,

        loadingTimer, loadingFrame = 1,

        titleHeight = 0, titleStr = '', start_pos, final_pos, busy = false, fx = $.extend($('<div/>')[0], {prop: 0}),

        isIE6 = navigator.userAgent.match(/msie [6]/i) && !window.XMLHttpRequest,

    /*
     * Private methods
     */

        _abort = function () {
            loading.hide();

            imgPreloader.onerror = imgPreloader.onload = null;

            if (ajaxLoader) {
                ajaxLoader.abort();
            }

            tmp.empty();
        },

        _error = function () {
            if (false === selectedOpts.onError(selectedArray, selectedIndex, selectedOpts)) {
                loading.hide();
                busy = false;
                return;
            }

            selectedOpts.titleShow = false;

            selectedOpts.width = 'auto';
            selectedOpts.height = 'auto';

            tmp.html('<p id="fbplus-error">The requested content cannot be loaded.<br />Please try again later.</p>');

            _process_inline();
        },

        _start = function () {
            var obj = selectedArray[selectedIndex],
                href,
                type,
                title,
                str,
                emb,
                ret;

            _abort();

            selectedOpts = $.extend({}, $.fn.fancyboxPlus.defaults, (typeof $(obj).data('fancyboxPlus') == 'undefined' ? selectedOpts : $(obj).data('fancyboxPlus')));

            ret = selectedOpts.onStart(selectedArray, selectedIndex, selectedOpts);

            if (ret === false) {
                busy = false;
                return;
            } else if (typeof ret == 'object') {
                selectedOpts = $.extend(selectedOpts, ret);
            }

            title = selectedOpts.title || (obj.nodeName ? $(obj).attr('title') : obj.title) || '';

            if (obj.nodeName && !selectedOpts.orig) {
                selectedOpts.orig = $(obj).children("img:first").length ? $(obj).children("img:first") : $(obj);
            }

            if (title === '' && selectedOpts.orig && selectedOpts.titleFromAlt) {
                title = selectedOpts.orig.attr('alt');
            }

            href = selectedOpts.href || (obj.nodeName ? $(obj).attr('href') : obj.href) || null;

            if ((/^(?:javascript)/i).test(href) || href == '#') {
                href = null;
            }

            if (selectedOpts.type) {
                type = selectedOpts.type;

                if (!href) {
                    href = selectedOpts.content;
                }

            } else if (selectedOpts.content) {
                type = 'html';

            } else if (href) {
                if (href.match(imgRegExp)) {
                    type = 'image';

                } else if (href.match(swfRegExp)) {
                    type = 'swf';

                } else if ($(obj).hasClass("iframe")) {
                    type = 'iframe';

                } else if (href.indexOf("#") === 0) {
                    type = 'inline';

                } else {
                    type = 'ajax';
                }
            }

            if (!type) {
                _error();
                return;
            }

            if (type == 'inline') {
                obj = href.substr(href.indexOf("#"));
                type = $(obj).length > 0 ? 'inline' : 'ajax';
            }

            selectedOpts.type = type;
            selectedOpts.href = href;
            selectedOpts.title = title;

            if (selectedOpts.autoDimensions) {
                if (selectedOpts.type == 'html' || selectedOpts.type == 'inline' || selectedOpts.type == 'ajax') {
                    selectedOpts.width = 'auto';
                    selectedOpts.height = 'auto';
                } else {
                    selectedOpts.autoDimensions = false;
                }
            }

            if (selectedOpts.modal) {
                selectedOpts.overlayShow = true;
                selectedOpts.hideOnOverlayClick = false;
                selectedOpts.hideOnContentClick = false;
                selectedOpts.enableEscapeButton = false;
                selectedOpts.showCloseButton = false;
            }

            selectedOpts.padding = parseInt(selectedOpts.padding, 10);
            selectedOpts.margin = parseInt(selectedOpts.margin, 10);

            tmp.css('padding', (selectedOpts.padding + selectedOpts.margin));

            $('.fbplus-inline-tmp').unbind('fbplus-cancel').bind('fbplus-change', function () {
                $(this).replaceWith(content.children());
            });

            switch (type) {
                case 'html' :
                    tmp.html(selectedOpts.content);
                    _process_inline();
                    break;

                case 'inline' :
                    if ($(obj).parent().is('#fbplus-content') === true) {
                        busy = false;
                        return;
                    }

                    $('<div class="fbplus-inline-tmp" />')
                        .hide()
                        .insertBefore($(obj))
                        .bind('fbplus-cleanup', function () {
                            $(this).replaceWith(content.children());
                        }).bind('fbplus-cancel', function () {
                        $(this).replaceWith(tmp.children());
                    });

                    $(obj).appendTo(tmp);

                    _process_inline();
                    break;

                case 'image':
                    busy = false;

                    $.fancyboxPlus.showActivity();

                    imgPreloader = new Image();

                    imgPreloader.onerror = function () {
                        _error();
                    };

                    imgPreloader.onload = function () {
                        busy = true;

                        imgPreloader.onerror = imgPreloader.onload = null;

                        _process_image();
                    };

                    imgPreloader.src = href;
                    break;

                case 'swf':
                    selectedOpts.scrolling = 'no';

                    str = '<object classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000" width="' + selectedOpts.width + '" height="' + selectedOpts.height + '"><param name="movie" value="' + href + '"></param>';
                    emb = '';

                    $.each(selectedOpts.swf, function (name, val) {
                        str += '<param name="' + name + '" value="' + val + '"></param>';
                        emb += ' ' + name + '="' + val + '"';
                    });

                    str += '<embed src="' + href + '" type="application/x-shockwave-flash" width="' + selectedOpts.width + '" height="' + selectedOpts.height + '"' + emb + '></embed></object>';

                    tmp.html(str);

                    _process_inline();
                    break;

                case 'ajax':
                    busy = false;

                    $.fancyboxPlus.showActivity();

                    selectedOpts.ajax.win = selectedOpts.ajax.success;

                    ajaxLoader = $.ajax($.extend({}, selectedOpts.ajax, {
                        url: href,
                        data: selectedOpts.ajax.data || {},
                        error: function (XMLHttpRequest, textStatus, errorThrown) {
                            if (XMLHttpRequest.status > 0) {
                                _error();
                            }
                        },
                        success: function (data, textStatus, XMLHttpRequest) {
                            var o = typeof XMLHttpRequest == 'object' ? XMLHttpRequest : ajaxLoader;
                            if (o.status == 200) {
                                if (typeof selectedOpts.ajax.win == 'function') {
                                    ret = selectedOpts.ajax.win(href, data, textStatus, XMLHttpRequest);

                                    if (ret === false) {
                                        loading.hide();
                                        return;
                                    } else if (typeof ret == 'string' || typeof ret == 'object') {
                                        data = ret;
                                    }
                                }

                                tmp.html(data);
                                _process_inline();
                            }
                        }
                    }));

                    break;

                case 'iframe':
                    _show();
                    break;
            }
        },

        _process_inline = function () {
            var
                w = selectedOpts.width,
                h = selectedOpts.height;

            if (w.toString().indexOf('%') > -1) {
                w = parseInt(($(window).width() - (selectedOpts.margin * 2)) * parseFloat(w) / 100, 10) + 'px';

            } else {
                w = w == 'auto' ? 'auto' : w + 'px';
            }

            if (h.toString().indexOf('%') > -1) {
                h = parseInt(($(window).height() - (selectedOpts.margin * 2)) * parseFloat(h) / 100, 10) + 'px';

            } else {
                h = h == 'auto' ? 'auto' : h + 'px';
            }

            tmp.wrapInner('<div style="width:' + w + ';height:' + h + ';overflow: ' + (selectedOpts.scrolling == 'auto' ? 'auto' : (selectedOpts.scrolling == 'yes' ? 'scroll' : 'hidden')) + ';position:relative;"></div>');

            selectedOpts.width = tmp.width();
            selectedOpts.height = tmp.height();

            _show();
        },

        _process_image = function () {
            selectedOpts.width = imgPreloader.width;
            selectedOpts.height = imgPreloader.height;

            $("<img />").attr({
                'id': 'fbplus-img',
                'src': imgPreloader.src,
                'alt': selectedOpts.title
            }).appendTo(tmp);

            _show();
        },

        _show = function () {
            var pos, equal;

            loading.hide();

            if (wrap.is(":visible") && false === currentOpts.onCleanup(currentArray, currentIndex, currentOpts)) {
                $.event.trigger('fbplus-cancel');

                busy = false;
                return;
            }

            busy = true;

            $(content.add(overlay)).unbind();

            $(window).unbind("resize.fb scroll.fb");
            $(document).unbind('keydown.fb');

            if (wrap.is(":visible") && currentOpts.titlePosition !== 'outside') {
                wrap.css('height', wrap.height());
            }

            currentArray = selectedArray;
            currentIndex = selectedIndex;
            currentOpts = selectedOpts;

            if (currentOpts.overlayShow) {
                overlay.css({
                    'background-color': currentOpts.overlayColor,
                    'opacity': currentOpts.overlayOpacity,
                    'cursor': currentOpts.hideOnOverlayClick ? 'pointer' : 'auto',
                    'height': $(document).height()
                });

                if (!overlay.is(':visible')) {
                    if (isIE6) {
                        $('select:not(#fbplus-tmp select)').filter(function () {
                            return this.style.visibility !== 'hidden';
                        }).css({'visibility': 'hidden'}).one('fbplus-cleanup', function () {
                            this.style.visibility = 'inherit';
                        });
                    }

                    overlay.show();
                }
            } else {
                overlay.hide();
            }

            final_pos = _get_zoom_to();

            _process_title();

            if (wrap.is(":visible")) {
                $(close.add(nav_left).add(nav_right)).hide();

                pos = wrap.position(),

                    start_pos = {
                        top: pos.top,
                        left: pos.left,
                        width: wrap.width(),
                        height: wrap.height()
                    };

                equal = (start_pos.width == final_pos.width && start_pos.height == final_pos.height);

                content.fadeTo(currentOpts.changeFade, 0.3, function () {
                    var finish_resizing = function () {
                        content.html(tmp.contents()).fadeTo(currentOpts.changeFade, 1, _finish);
                    };

                    $.event.trigger('fbplus-change');

                    content
                        .empty()
                        .removeAttr('filter')
                        .css({
                            'border-width': currentOpts.padding,
                            'width': final_pos.width - currentOpts.padding * 2,
                            'height': selectedOpts.autoDimensions ? 'auto' : final_pos.height - titleHeight - currentOpts.padding * 2
                        });

                    if (equal) {
                        finish_resizing();

                    } else {
                        fx.prop = 0;

                        $(fx).animate({prop: 1}, {
                            duration: currentOpts.changeSpeed,
                            easing: currentOpts.easingChange,
                            step: _draw,
                            complete: finish_resizing
                        });
                    }
                });

                return;
            }

            wrap.removeAttr("style");

            content.css('border-width', currentOpts.padding);

            if (currentOpts.transitionIn == 'elastic') {
                start_pos = _get_zoom_from();

                content.html(tmp.contents());

                wrap.show();

                if (currentOpts.opacity) {
                    final_pos.opacity = 0;
                }

                fx.prop = 0;

                $(fx).animate({prop: 1}, {
                    duration: currentOpts.speedIn,
                    easing: currentOpts.easingIn,
                    step: _draw,
                    complete: _finish
                });

                return;
            }

            if (currentOpts.titlePosition == 'inside' && titleHeight > 0) {
                title.show();
            }

            content
                .css({
                    'width': final_pos.width - currentOpts.padding * 2,
                    'height': selectedOpts.autoDimensions ? 'auto' : final_pos.height - titleHeight - currentOpts.padding * 2
                })
                .html(tmp.contents());

            wrap
                .css(final_pos)
                .fadeIn(currentOpts.transitionIn == 'none' ? 0 : currentOpts.speedIn, _finish);
        },

        _format_title = function (title) {
            if (title && title.length) {
                if (currentOpts.titlePosition == 'float') {
                    return '<table id="fbplus-title-float-wrap" cellpadding="0" cellspacing="0"><tr><td id="fbplus-title-float-left"></td><td id="fbplus-title-float-main">' + title + '</td><td id="fbplus-title-float-right"></td></tr></table>';
                }

                return '<div id="fbplus-title-' + currentOpts.titlePosition + '">' + title + '</div>';
            }

            return false;
        },

        _process_title = function () {
            titleStr = currentOpts.title || '';
            titleHeight = 0;

            title
                .empty()
                .removeAttr('style')
                .removeClass();

            if (currentOpts.titleShow === false) {
                title.hide();
                return;
            }

            titleStr = $.isFunction(currentOpts.titleFormat) ? currentOpts.titleFormat(titleStr, currentArray, currentIndex, currentOpts) : _format_title(titleStr);

            if (!titleStr || titleStr === '') {
                title.hide();
                return;
            }

            title
                .addClass('fbplus-title-' + currentOpts.titlePosition)
                .html(titleStr)
                .appendTo('body')
                .show();

            switch (currentOpts.titlePosition) {
                case 'inside':
                    title
                        .css({
                            'width': final_pos.width - (currentOpts.padding * 2),
                            'marginLeft': currentOpts.padding,
                            'marginRight': currentOpts.padding
                        });

                    titleHeight = title.outerHeight(true);

                    title.appendTo(outer);

                    final_pos.height += titleHeight;
                    break;

                case 'over':
                    title
                        .css({
                            'marginLeft': currentOpts.padding,
                            'width': final_pos.width - (currentOpts.padding * 2),
                            'bottom': currentOpts.padding
                        })
                        .appendTo(outer);
                    break;

                case 'float':
                    title
                        .css('left', parseInt((title.width() - final_pos.width - 40) / 2, 10) * -1)
                        .appendTo(wrap);
                    break;

                default:
                    title
                        .css({
                            'width': final_pos.width - (currentOpts.padding * 2),
                            'paddingLeft': currentOpts.padding,
                            'paddingRight': currentOpts.padding
                        })
                        .appendTo(wrap);
                    break;
            }

            title.hide();
        },

        _set_navigation = function () {
            if (currentOpts.enableEscapeButton || currentOpts.enableKeyboardNav) {
                $(document).bind('keydown.fb', function (e) {
                    if (e.keyCode == 27 && currentOpts.enableEscapeButton) {
                        e.preventDefault();
                        $.fancyboxPlus.close();

                    } else if ((e.keyCode == 37 || e.keyCode == 39) && currentOpts.enableKeyboardNav && e.target.tagName !== 'INPUT' && e.target.tagName !== 'TEXTAREA' && e.target.tagName !== 'SELECT') {
                        e.preventDefault();
                        $.fancyboxPlus[e.keyCode == 37 ? 'prev' : 'next']();
                    }
                });
            }

            if (!currentOpts.showNavArrows) {
                nav_left.hide();
                nav_right.hide();
                return;
            }

            if ((currentOpts.cyclic && currentArray.length > 1) || currentIndex !== 0) {
                nav_left.show();
            }

            if ((currentOpts.cyclic && currentArray.length > 1) || currentIndex != (currentArray.length - 1)) {
                nav_right.show();
            }
        },

        _finish = function () {
            if (!$.support.opacity) {
                $('#fancybox-content').css('filter', 0);
                $('#fancybox-wrap').css('filter', 0);
            }

            if (selectedOpts.autoDimensions) {
                content.css('height', 'auto');
            }

            wrap.css('height', 'auto');

            if (titleStr && titleStr.length) {
                title.show();
            }

            if (currentOpts.showCloseButton) {
                close.show();
            }

            _set_navigation();

            if (currentOpts.hideOnContentClick) {
                content.bind('click', $.fancyboxPlus.close);
            }

            if (currentOpts.hideOnOverlayClick) {
                overlay.bind('click', $.fancyboxPlus.close);
            }

            $(window).bind("resize.fb", $.fancyboxPlus.resize);

            if (currentOpts.centerOnScroll) {
                $(window).bind("scroll.fb", $.fancyboxPlus.center);
            }

            if (currentOpts.type == 'iframe') {
                $('<iframe id="fbplus-frame" name="fbplus-frame' + new Date().getTime() + '" frameborder="0" hspace="0" ' +
                    (navigator.userAgent.match(/msie [6]/i) ? 'allowtransparency="true""' : '') + ' scrolling="' + selectedOpts.scrolling + '" src="' + currentOpts.href + '"></iframe>').appendTo(content);
            }

            wrap.show();

            busy = false;

            $.fancyboxPlus.center();

            currentOpts.onComplete(currentArray, currentIndex, currentOpts);

            _preload_images();
        },

        _preload_images = function () {
            var href,
                objNext;

            if ((currentArray.length - 1) > currentIndex) {
                href = currentArray[currentIndex + 1].href;

                if (typeof href !== 'undefined' && href.match(imgRegExp)) {
                    objNext = new Image();
                    objNext.src = href;
                }
            }

            if (currentIndex > 0) {
                href = currentArray[currentIndex - 1].href;

                if (typeof href !== 'undefined' && href.match(imgRegExp)) {
                    objNext = new Image();
                    objNext.src = href;
                }
            }
        },

        _draw = function (pos) {
            var dim = {
                width: parseInt(start_pos.width + (final_pos.width - start_pos.width) * pos, 10),
                height: parseInt(start_pos.height + (final_pos.height - start_pos.height) * pos, 10),

                top: parseInt(start_pos.top + (final_pos.top - start_pos.top) * pos, 10),
                left: parseInt(start_pos.left + (final_pos.left - start_pos.left) * pos, 10)
            };

            if (typeof final_pos.opacity !== 'undefined') {
                dim.opacity = pos < 0.5 ? 0.5 : pos;
            }

            wrap.css(dim);

            content.css({
                'width': dim.width - currentOpts.padding * 2,
                'height': dim.height - (titleHeight * pos) - currentOpts.padding * 2
            });
        },

        _get_viewport = function () {
            return [
                $(window).width() - (currentOpts.margin * 2),
                $(window).height() - (currentOpts.margin * 2),
                $(document).scrollLeft() + currentOpts.margin,
                $(document).scrollTop() + currentOpts.margin
            ];
        },

        _get_zoom_to = function () {
            var view = _get_viewport(),
                to = {},
                resize = currentOpts.autoScale,
                double_padding = currentOpts.padding * 2,
                ratio;

            if (currentOpts.width.toString().indexOf('%') > -1) {
                to.width = parseInt((view[0] * parseFloat(currentOpts.width)) / 100, 10);
            } else {
                to.width = currentOpts.width + double_padding;
            }

            if (currentOpts.height.toString().indexOf('%') > -1) {
                to.height = parseInt((view[1] * parseFloat(currentOpts.height)) / 100, 10);
            } else {
                to.height = currentOpts.height + double_padding;
            }

            if (resize && (to.width > view[0] || to.height > view[1])) {
                if (selectedOpts.type == 'image' || selectedOpts.type == 'swf') {
                    ratio = (currentOpts.width ) / (currentOpts.height );

                    if ((to.width ) > view[0]) {
                        to.width = view[0];
                        to.height = parseInt(((to.width - double_padding) / ratio) + double_padding, 10);
                    }

                    if ((to.height) > view[1]) {
                        to.height = view[1];
                        to.width = parseInt(((to.height - double_padding) * ratio) + double_padding, 10);
                    }

                } else {
                    to.width = Math.min(to.width, view[0]);
                    to.height = Math.min(to.height, view[1]);
                }
            }

            to.top = parseInt(Math.max(view[3] - 20, view[3] + ((view[1] - to.height - 40) * 0.5)), 10);
            to.left = parseInt(Math.max(view[2] - 20, view[2] + ((view[0] - to.width - 40) * 0.5)), 10);

            return to;
        },

        _get_obj_pos = function (obj) {
            var pos = obj.offset();

            pos.top += parseInt(obj.css('paddingTop'), 10) || 0;
            pos.left += parseInt(obj.css('paddingLeft'), 10) || 0;

            pos.top += parseInt(obj.css('border-top-width'), 10) || 0;
            pos.left += parseInt(obj.css('border-left-width'), 10) || 0;

            pos.width = obj.width();
            pos.height = obj.height();

            return pos;
        },

        _get_zoom_from = function () {
            var orig = selectedOpts.orig ? $(selectedOpts.orig) : false,
                from = {},
                pos,
                view;

            if (orig && orig.length) {
                pos = _get_obj_pos(orig);

                from = {
                    width: pos.width + (currentOpts.padding * 2),
                    height: pos.height + (currentOpts.padding * 2),
                    top: pos.top - currentOpts.padding - 20,
                    left: pos.left - currentOpts.padding - 20
                };

            } else {
                view = _get_viewport();

                from = {
                    width: currentOpts.padding * 2,
                    height: currentOpts.padding * 2,
                    top: parseInt(view[3] + view[1] * 0.5, 10),
                    left: parseInt(view[2] + view[0] * 0.5, 10)
                };
            }

            return from;
        },

        _animate_loading = function () {
            if (!loading.is(':visible')) {
                clearInterval(loadingTimer);
                return;
            }

            $('div', loading).css('top', (loadingFrame * -40) + 'px');

            loadingFrame = (loadingFrame + 1) % 12;
        };

    /*
     * Public methods
     */

    $.fn.fancyboxPlus = function (options) {
        if (!$(this).length) {
            return this;
        }

        $(this)
            .data('fancyboxPlus', $.extend({}, options, ($.metadata ? $(this).metadata() : {})))
            .unbind('click.fb')
            .bind('click.fb', function (e) {
                e.preventDefault();

                if (busy) {
                    return;
                }

                busy = true;

                $(this).blur();

                selectedArray = [];
                selectedIndex = 0;

                var rel = $(this).attr('rel') || '';

                if (!rel || rel == '' || rel === 'nofollow') {
                    selectedArray.push(this);

                } else {
                    selectedArray = $("a[rel=" + rel + "], area[rel=" + rel + "]");
                    selectedIndex = selectedArray.index(this);
                }

                _start();

                return;
            });

        return this;
    };

    $.fancyboxPlus = function (obj) {
        var opts;

        if (busy) {
            return;
        }

        busy = true;
        opts = typeof arguments[1] !== 'undefined' ? arguments[1] : {};

        selectedArray = [];
        selectedIndex = parseInt(opts.index, 10) || 0;

        if ($.isArray(obj)) {
            for (var i = 0, j = obj.length; i < j; i++) {
                if (typeof obj[i] == 'object') {
                    $(obj[i]).data('fancyboxPlus', $.extend({}, opts, obj[i]));
                } else {
                    obj[i] = $({}).data('fancyboxPlus', $.extend({content: obj[i]}, opts));
                }
            }

            selectedArray = jQuery.merge(selectedArray, obj);

        } else {
            if (typeof obj == 'object') {
                $(obj).data('fancyboxPlus', $.extend({}, opts, obj));
            } else {
                obj = $({}).data('fancyboxPlus', $.extend({content: obj}, opts));
            }

            selectedArray.push(obj);
        }

        if (selectedIndex > selectedArray.length || selectedIndex < 0) {
            selectedIndex = 0;
        }

        _start();
    };

    $.fancyboxPlus.showActivity = function () {
        clearInterval(loadingTimer);

        loading.show();
        loadingTimer = setInterval(_animate_loading, 66);
    };

    $.fancyboxPlus.hideActivity = function () {
        loading.hide();
    };

    $.fancyboxPlus.next = function () {
        return $.fancyboxPlus.pos(currentIndex + 1);
    };

    $.fancyboxPlus.prev = function () {
        return $.fancyboxPlus.pos(currentIndex - 1);
    };

    $.fancyboxPlus.pos = function (pos) {
        if (busy) {
            return;
        }

        pos = parseInt(pos);

        selectedArray = currentArray;

        if (pos > -1 && pos < currentArray.length) {
            selectedIndex = pos;
            _start();

        } else if (currentOpts.cyclic && currentArray.length > 1) {
            selectedIndex = pos >= currentArray.length ? 0 : currentArray.length - 1;
            _start();
        }

        return;
    };

    $.fancyboxPlus.cancel = function () {
        if (busy) {
            return;
        }

        busy = true;

        $.event.trigger('fbplus-cancel');

        _abort();

        selectedOpts.onCancel(selectedArray, selectedIndex, selectedOpts);

        busy = false;
    };

    // Note: within an iframe use - parent.$.fancyboxPlus.close();
    $.fancyboxPlus.close = function () {
        if (busy || wrap.is(':hidden')) {
            return;
        }

        busy = true;

        if (currentOpts && false === currentOpts.onCleanup(currentArray, currentIndex, currentOpts)) {
            busy = false;
            return;
        }

        _abort();

        $(close.add(nav_left).add(nav_right)).hide();

        $(content.add(overlay)).unbind();

        $(window).unbind("resize.fb scroll.fb");
        $(document).unbind('keydown.fb');

        content.find('iframe').attr('src', isIE6 && /^https/i.test(window.location.href || '') ? 'javascript:void(false)' : 'about:blank');

        if (currentOpts.titlePosition !== 'inside') {
            title.empty();
        }

        wrap.stop();

        function _cleanup() {
            overlay.fadeOut('fast');

            title.empty().hide();
            wrap.hide();

            $.event.trigger('fbplus-cleanup');

            content.empty();

            currentOpts.onClosed(currentArray, currentIndex, currentOpts);

            currentArray = selectedOpts = [];
            currentIndex = selectedIndex = 0;
            currentOpts = selectedOpts = {};

            busy = false;
        }

        if (currentOpts.transitionOut == 'elastic') {
            start_pos = _get_zoom_from();

            var pos = wrap.position();

            final_pos = {
                top: pos.top,
                left: pos.left,
                width: wrap.width(),
                height: wrap.height()
            };

            if (currentOpts.opacity) {
                final_pos.opacity = 1;
            }

            title.empty().hide();

            fx.prop = 1;

            $(fx).animate({prop: 0}, {
                duration: currentOpts.speedOut,
                easing: currentOpts.easingOut,
                step: _draw,
                complete: _cleanup
            });

        } else {
            wrap.fadeOut(currentOpts.transitionOut == 'none' ? 0 : currentOpts.speedOut, _cleanup);
        }
    };

    $.fancyboxPlus.resize = function () {
        if (overlay.is(':visible')) {
            overlay.css('height', $(document).height());
        }

        $.fancyboxPlus.center(true);
    };

    $.fancyboxPlus.center = function () {
        var view, align;

        if (busy) {
            return;
        }

        align = arguments[0] === true ? 1 : 0;
        view = _get_viewport();

        if (!align && (wrap.width() > view[0] || wrap.height() > view[1])) {
            return;
        }

        wrap
            .stop()
            .animate({
                'top': parseInt(Math.max(view[3] - 20, view[3] + ((view[1] - content.height() - 40) * 0.5) - currentOpts.padding)),
                'left': parseInt(Math.max(view[2] - 20, view[2] + ((view[0] - content.width() - 40) * 0.5) - currentOpts.padding))
            }, typeof arguments[0] == 'number' ? arguments[0] : 200);
    };

    $.fancyboxPlus.init = function () {
        if ($("#fbplus-wrap").length) {
            return;
        }

        $('body').append(
            tmp = $('<div id="fbplus-tmp"></div>'),
            loading = $('<div id="fbplus-loading"><div></div></div>'),
            overlay = $('<div id="fbplus-overlay"></div>'),
            wrap = $('<div id="fbplus-wrap"></div>')
        );

        outer = $('<div id="fbplus-outer"></div>')
            .append('<div class="fbplus-bg" id="fbplus-bg-n"></div><div class="fbplus-bg" id="fbplus-bg-ne"></div><div class="fbplus-bg" id="fbplus-bg-e"></div><div class="fbplus-bg" id="fbplus-bg-se"></div><div class="fbplus-bg" id="fbplus-bg-s"></div><div class="fbplus-bg" id="fbplus-bg-sw"></div><div class="fbplus-bg" id="fbplus-bg-w"></div><div class="fbplus-bg" id="fbplus-bg-nw"></div>')
            .appendTo(wrap);

        outer.append(
            content = $('<div id="fbplus-content"></div>'),
            close = $('<a id="fbplus-close"></a>'),
            title = $('<div id="fbplus-title"></div>'),

            nav_left = $('<a href="javascript:;" id="fbplus-left"><span class="fancy-ico" id="fbplus-left-ico"></span></a>'),
            nav_right = $('<a href="javascript:;" id="fbplus-right"><span class="fancy-ico" id="fbplus-right-ico"></span></a>')
        );

        close.click($.fancyboxPlus.close);
        loading.click($.fancyboxPlus.cancel);

        nav_left.click(function (e) {
            e.preventDefault();
            $.fancyboxPlus.prev();
        });

        nav_right.click(function (e) {
            e.preventDefault();
            $.fancyboxPlus.next();
        });

        if ($.fn.mousewheel) {
            wrap.bind('mousewheel.fb', function (e, delta) {
                if (busy) {
                    e.preventDefault();

                } else if ($(e.target).get(0).clientHeight == 0 || $(e.target).get(0).scrollHeight === $(e.target).get(0).clientHeight) {
                    e.preventDefault();
                    $.fancyboxPlus[delta > 0 ? 'prev' : 'next']();
                }
            });
        }

        if (!$.support.opacity) {
            wrap.addClass('fbplus-ie');
        }

        if (isIE6) {
            loading.addClass('fbplus-ie6');
            wrap.addClass('fbplus-ie6');

            $('<iframe id="fbplus-hide-sel-frame" src="' + (/^https/i.test(window.location.href || '') ? 'javascript:void(false)' : 'about:blank' ) + '" scrolling="no" border="0" frameborder="0" tabindex="-1"></iframe>').prependTo(outer);
        }
    };

    $.fn.fancyboxPlus.defaults = {
        padding: 10,
        margin: 40,
        opacity: false,
        modal: false,
        cyclic: false,
        scrolling: 'auto',	// 'auto', 'yes' or 'no'

        width: 560,
        height: 340,

        autoScale: true,
        autoDimensions: true,
        centerOnScroll: false,

        ajax: {},
        swf: {wmode: 'transparent'},

        hideOnOverlayClick: true,
        hideOnContentClick: false,

        overlayShow: true,
        overlayOpacity: 0.7,
        overlayColor: '#777',

        titleShow: true,
        titlePosition: 'float', // 'float', 'outside', 'inside' or 'over'
        titleFormat: null,
        titleFromAlt: false,

        transitionIn: 'fade', // 'elastic', 'fade' or 'none'
        transitionOut: 'fade', // 'elastic', 'fade' or 'none'

        speedIn: 300,
        speedOut: 300,

        changeSpeed: 300,
        changeFade: 'fast',

        easingIn: 'swing',
        easingOut: 'swing',

        showCloseButton: true,
        showNavArrows: true,
        enableEscapeButton: true,
        enableKeyboardNav: true,

        onStart: function () {
        },
        onCancel: function () {
        },
        onComplete: function () {
        },
        onCleanup: function () {
        },
        onClosed: function () {
        },
        onError: function () {
        }
    };

    $(document).ready(function () {
        $.fancyboxPlus.init();
    });

})(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(736);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../css-loader/index.js!./jquery.fancybox-plus.css", function() {
			var newContent = require("!!../../css-loader/index.js!./jquery.fancybox-plus.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "/*\r\n * FancyBox - jQuery Plugin\r\n * Simple and fancy lightbox alternative\r\n *\r\n * Examples and documentation at: http://igorlino.github.io/fancybox-plus/\r\n *\r\n * Version: 1.3.5 (20.06.2015)\r\n * Requires: jQuery v1.3+\r\n *\r\n * Licensed under the MIT license:\r\n *   http://www.opensource.org/licenses/mit-license.php\r\n */\r\n\r\n#fbplus-loading {\r\n    position: fixed;\r\n    top: 50%;\r\n    left: 50%;\r\n    width: 40px;\r\n    height: 40px;\r\n    margin-top: -20px;\r\n    margin-left: -20px;\r\n    cursor: pointer;\r\n    overflow: hidden;\r\n    z-index: 1104;\r\n    display: none;\r\n}\r\n\r\n#fbplus-loading div {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 40px;\r\n    height: 480px;\r\n    background-image: url(" + __webpack_require__(42) + ");\r\n}\r\n\r\n#fbplus-overlay {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    z-index: 1100;\r\n    display: none;\r\n}\r\n\r\n#fbplus-tmp {\r\n    padding: 0;\r\n    margin: 0;\r\n    border: 0;\r\n    overflow: auto;\r\n    display: none;\r\n}\r\n\r\n#fbplus-wrap {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    padding: 20px;\r\n    z-index: 1101;\r\n    outline: none;\r\n    display: none;\r\n}\r\n\r\n#fbplus-outer {\r\n    position: relative;\r\n    width: 100%;\r\n    height: 100%;\r\n    background: #fff;\r\n}\r\n\r\n#fbplus-content {\r\n    width: 0;\r\n    height: 0;\r\n    padding: 0;\r\n    outline: none;\r\n    position: relative;\r\n    overflow: hidden;\r\n    z-index: 1102;\r\n    border: 0px solid #fff;\r\n}\r\n\r\n#fbplus-hide-sel-frame {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background: transparent;\r\n    z-index: 1101;\r\n}\r\n\r\n#fbplus-close {\r\n    position: absolute;\r\n    top: -15px;\r\n    right: -15px;\r\n    width: 30px;\r\n    height: 30px;\r\n    background: transparent url(" + __webpack_require__(42) + ") -40px 0px;\r\n    cursor: pointer;\r\n    z-index: 1103;\r\n    display: none;\r\n}\r\n\r\n#fbplus-error {\r\n    color: #444;\r\n    font: normal 12px/20px Arial;\r\n    padding: 14px;\r\n    margin: 0;\r\n}\r\n\r\n#fbplus-img {\r\n    width: 100%;\r\n    height: 100%;\r\n    padding: 0;\r\n    margin: 0;\r\n    border: none;\r\n    outline: none;\r\n    line-height: 0;\r\n    vertical-align: top;\r\n}\r\n\r\n#fbplus-frame {\r\n    width: 100%;\r\n    height: 100%;\r\n    border: none;\r\n    display: block;\r\n}\r\n\r\n#fbplus-left, #fbplus-right {\r\n    position: absolute;\r\n    bottom: 0px;\r\n    height: 100%;\r\n    width: 35%;\r\n    cursor: pointer;\r\n    outline: none;\r\n    background: transparent url(" + __webpack_require__(737) + ");\r\n    z-index: 1102;\r\n    display: none;\r\n}\r\n\r\n#fbplus-left {\r\n    left: 0px;\r\n}\r\n\r\n#fbplus-right {\r\n    right: 0px;\r\n}\r\n\r\n#fbplus-left-ico, #fbplus-right-ico {\r\n    position: absolute;\r\n    top: 50%;\r\n    left: -9999px;\r\n    width: 30px;\r\n    height: 30px;\r\n    margin-top: -15px;\r\n    cursor: pointer;\r\n    z-index: 1102;\r\n    display: block;\r\n}\r\n\r\n#fbplus-left-ico {\r\n    background-image: url(" + __webpack_require__(42) + ");\r\n    background-position: -40px -30px;\r\n}\r\n\r\n#fbplus-right-ico {\r\n    background-image: url(" + __webpack_require__(42) + ");\r\n    background-position: -40px -60px;\r\n}\r\n\r\n#fbplus-left:hover, #fbplus-right:hover {\r\n    visibility: visible; /* IE6 */\r\n}\r\n\r\n#fbplus-left:hover span {\r\n    left: 20px;\r\n}\r\n\r\n#fbplus-right:hover span {\r\n    left: auto;\r\n    right: 20px;\r\n}\r\n\r\n.fbplus-bg {\r\n    position: absolute;\r\n    padding: 0;\r\n    margin: 0;\r\n    border: 0;\r\n    width: 20px;\r\n    height: 20px;\r\n    z-index: 1001;\r\n}\r\n\r\n#fbplus-bg-n {\r\n    top: -20px;\r\n    left: 0;\r\n    width: 100%;\r\n    background-image: url(" + __webpack_require__(157) + ");\r\n}\r\n\r\n#fbplus-bg-ne {\r\n    top: -20px;\r\n    right: -20px;\r\n    background-image: url(" + __webpack_require__(42) + ");\r\n    background-position: -40px -162px;\r\n}\r\n\r\n#fbplus-bg-e {\r\n    top: 0;\r\n    right: -20px;\r\n    height: 100%;\r\n    background-image: url(" + __webpack_require__(240) + ");\r\n    background-position: -20px 0px;\r\n}\r\n\r\n#fbplus-bg-se {\r\n    bottom: -20px;\r\n    right: -20px;\r\n    background-image: url(" + __webpack_require__(42) + ");\r\n    background-position: -40px -182px;\r\n}\r\n\r\n#fbplus-bg-s {\r\n    bottom: -20px;\r\n    left: 0;\r\n    width: 100%;\r\n    background-image: url(" + __webpack_require__(157) + ");\r\n    background-position: 0px -20px;\r\n}\r\n\r\n#fbplus-bg-sw {\r\n    bottom: -20px;\r\n    left: -20px;\r\n    background-image: url(" + __webpack_require__(42) + ");\r\n    background-position: -40px -142px;\r\n}\r\n\r\n#fbplus-bg-w {\r\n    top: 0;\r\n    left: -20px;\r\n    height: 100%;\r\n    background-image: url(" + __webpack_require__(240) + ");\r\n}\r\n\r\n#fbplus-bg-nw {\r\n    top: -20px;\r\n    left: -20px;\r\n    background-image: url(" + __webpack_require__(42) + ");\r\n    background-position: -40px -122px;\r\n}\r\n\r\n#fbplus-title {\r\n    font-family: Helvetica;\r\n    font-size: 12px;\r\n    z-index: 1102;\r\n}\r\n\r\n.fbplus-title-inside {\r\n    padding-bottom: 10px;\r\n    text-align: center;\r\n    color: #333;\r\n    background: #fff;\r\n    position: relative;\r\n}\r\n\r\n.fbplus-title-outside {\r\n    padding-top: 10px;\r\n    color: #fff;\r\n}\r\n\r\n.fbplus-title-over {\r\n    position: absolute;\r\n    bottom: 0;\r\n    left: 0;\r\n    color: #FFF;\r\n    text-align: left;\r\n}\r\n\r\n#fbplus-title-over {\r\n    padding: 10px;\r\n    background-image: url(" + __webpack_require__(738) + ");\r\n    display: block;\r\n}\r\n\r\n.fbplus-title-float {\r\n    position: absolute;\r\n    left: 0;\r\n    bottom: -20px;\r\n    height: 32px;\r\n}\r\n\r\n#fbplus-title-float-wrap {\r\n    border: none;\r\n    border-collapse: collapse;\r\n    width: auto;\r\n}\r\n\r\n#fbplus-title-float-wrap td {\r\n    border: none;\r\n    white-space: nowrap;\r\n}\r\n\r\n#fbplus-title-float-left {\r\n    padding: 0 0 0 15px;\r\n    background: url(" + __webpack_require__(42) + ") -40px -90px no-repeat;\r\n}\r\n\r\n#fbplus-title-float-main {\r\n    color: #FFF;\r\n    line-height: 29px;\r\n    font-weight: bold;\r\n    padding: 0 0 3px 0;\r\n    background: url(" + __webpack_require__(157) + ") 0px -40px;\r\n}\r\n\r\n#fbplus-title-float-right {\r\n    padding: 0 0 0 15px;\r\n    background: url(" + __webpack_require__(42) + ") -55px -90px no-repeat;\r\n}\r\n\r\n/* IE6 */\r\n\r\n.fbplus-ie6 #fbplus-close {\r\n    background: transparent;\r\n    filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src='../images/fbplus/fbplus_close.png', sizingMethod='scale');\r\n}\r\n\r\n.fbplus-ie6 #fbplus-left-ico {\r\n    background: transparent;\r\n    filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src='../images/fbplus/fbplus_nav_left.png', sizingMethod='scale');\r\n}\r\n\r\n.fbplus-ie6 #fbplus-right-ico {\r\n    background: transparent;\r\n    filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src='../images/fbplus/fbplus_nav_right.png', sizingMethod='scale');\r\n}\r\n\r\n.fbplus-ie6 #fbplus-title-over {\r\n    background: transparent;\r\n    filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src='../images/fbplus/fbplus_title_over.png', sizingMethod='scale');\r\n    zoom: 1;\r\n}\r\n\r\n.fbplus-ie6 #fbplus-title-float-left {\r\n    background: transparent;\r\n    filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src='../images/fbplus/fbplus_title_left.png', sizingMethod='scale');\r\n}\r\n\r\n.fbplus-ie6 #fbplus-title-float-main {\r\n    background: transparent;\r\n    filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src='../images/fbplus/fbplus_title_main.png', sizingMethod='scale');\r\n}\r\n\r\n.fbplus-ie6 #fbplus-title-float-right {\r\n    background: transparent;\r\n    filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src='../images/fbplus/fbplus_title_right.png', sizingMethod='scale');\r\n}\r\n\r\n.fbplus-ie6 #fbplus-bg-w, .fbplus-ie6 #fbplus-bg-e, .fbplus-ie6 #fbplus-left, .fbplus-ie6 #fbplus-right, #fbplus-hide-sel-frame {\r\n    height: expression(this.parentNode.clientHeight + \"px\");\r\n}\r\n\r\n#fbplus-loading.fbplus-ie6 {\r\n    position: absolute;\r\n    margin-top: 0;\r\n    top: expression( (-20 + (document.documentElement.clientHeight ? document.documentElement.clientHeight/2 : document.body.clientHeight/2 ) + ( ignoreMe = document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop )) + 'px');\r\n}\r\n\r\n#fbplus-loading.fbplus-ie6 div {\r\n    background: transparent;\r\n    filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src='../images/fbplus/fbplus_loading.png', sizingMethod='scale');\r\n}\r\n\r\n/* IE6, IE7, IE8 */\r\n\r\n.fbplus-ie .fbplus-bg {\r\n    background: transparent !important;\r\n}\r\n\r\n.fbplus-ie #fbplus-bg-n {\r\n    filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src='../images/fbplus/fbplus_shadow_n.png', sizingMethod='scale');\r\n}\r\n\r\n.fbplus-ie #fbplus-bg-ne {\r\n    filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src='../images/fbplus/fbplus_shadow_ne.png', sizingMethod='scale');\r\n}\r\n\r\n.fbplus-ie #fbplus-bg-e {\r\n    filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src='../images/fbplus/fbplus_shadow_e.png', sizingMethod='scale');\r\n}\r\n\r\n.fbplus-ie #fbplus-bg-se {\r\n    filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src='../images/fbplus/fbplus_shadow_se.png', sizingMethod='scale');\r\n}\r\n\r\n.fbplus-ie #fbplus-bg-s {\r\n    filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src='../images/fbplus/fbplus_shadow_s.png', sizingMethod='scale');\r\n}\r\n\r\n.fbplus-ie #fbplus-bg-sw {\r\n    filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src='../images/fbplus/fbplus_shadow_sw.png', sizingMethod='scale');\r\n}\r\n\r\n.fbplus-ie #fbplus-bg-w {\r\n    filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src='../images/fbplus/fbplus_shadow_w.png', sizingMethod='scale');\r\n}\r\n\r\n.fbplus-ie #fbplus-bg-nw {\r\n    filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src='../images/fbplus/fbplus_shadow_nw.png', sizingMethod='scale');\r\n}\r\n", ""]);

// exports


/***/ }),
/* 737 */
/***/ (function(module, exports) {

module.exports = "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="

/***/ }),
/* 738 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVQI12NgYGBYDAAAqACkxaGYIAAAAABJRU5ErkJggg=="

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(740);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./fancybox-plus.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./fancybox-plus.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "#fbplus-wrap {\n  box-sizing: content-box !important; }\n", ""]);

// exports


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by ganlu on 24/11/2016.
 */
var MediaAccountService = function () {
    MediaAccountService.$inject = ['$http', 'AppConfig', 'message'];

    function MediaAccountService($http, AppConfig, message) {
        "ngInject";

        (0, _classCallCheck3.default)(this, MediaAccountService);
        this.mediaAccounts = {
            'weixin': null,
            'weibo': null,
            'toutiao': null
        };

        this.mediaNames = ['', 'weixin', 'weibo', 'toutiao'];

        this.$http = $http;
        this.AppConfig = AppConfig;
        this.message = message;
    }

    (0, _createClass3.default)(MediaAccountService, [{
        key: 'init',
        value: function init(callback) {
            var _this = this;

            this.$http.get(this.AppConfig.server_url + '/media/list', {
                withCredentials: true
            }).then(function (response) {
                // response.data=[{"id":13,"user_id":12,"account_type":1,"account_id":"wxa64ce89c222e2188","name":"\u54ce\u5440\u539f\u6765\u4f60\u4e5f\u5728\u8fd9\u91cc","params":{"user_name":"gh_bc1c63b9f4a6","alias":"aiyaaaaaaaaaaaaaa","qrcode":"http:\/\/mmbiz.qpic.cn\/mmbiz_jpg\/ibTB0aD5VsBx2KiaOPygbAtvraCr6tQUwhzUppN85El9ckCtDU5jjMTMqlJSvQnBHhqK7pwDz10CoA6keiawCyMdg\/0","head_img":""},"created_at":1503040204,"access_token":"bg4Lj6xmvIWkUDvFJOLdLukB8NCFMemHRtryjQNCn_N5U_8FaQoT2FFgJxxe8EhGiXcU81_x2V5HKUCO3SkZR94jqFDnvXhKVsJLx6IFgl9BaRObq88Yqk88_RpzdlQnJLQaAHDBDI"},{"id":14,"user_id":12,"account_type":3,"account_id":"50022088629","name":"\u624b\u673a\u7528\u623750022088629","params":null,"created_at":null,"access_token":"7b7e3650d2e9721bea3da9be2eb42a310014"}]
                response.data.forEach(function (m) {
                    var mediaName = _this.mediaNames[m.account_type];
                    _this.mediaAccounts[mediaName] = m;
                });

                if (typeof callback == 'function') {
                    callback();
                }
            }, function (response) {
                _this.message.error(response.data);
            });
        }
    }]);
    return MediaAccountService;
}();

exports.default = MediaAccountService;

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(743);
module.exports = __webpack_require__(24).Object.keys;


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(117);
var $keys = __webpack_require__(115);

__webpack_require__(744)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(50);
var core = __webpack_require__(24);
var fails = __webpack_require__(85);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _user = __webpack_require__(746);

var _user2 = _interopRequireDefault(_user);

var _user3 = __webpack_require__(747);

var _user4 = _interopRequireDefault(_user3);

__webpack_require__(749);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userComponent = {
    restrict: 'E',
    bindings: {
        appUser: '=',
        test: '='
    },
    template: _user2.default,
    controller: _user4.default
};

exports.default = userComponent;

/***/ }),
/* 746 */
/***/ (function(module, exports) {

module.exports = "<div class=\"bg\"></div>\n<div class=\"content user\" ui-view></div>\n";

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(83);

var _stringify2 = _interopRequireDefault(_stringify);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserController = function () {
    UserController.$inject = ['$scope', '$http', '$state', '$stateParams', '$translate', 'AppConfig', '$timeout', 'message', '$transitions', 'Restangular', 'crc32'];

    function UserController($scope, $http, $state, $stateParams, $translate, AppConfig, $timeout, message, $transitions, Restangular, crc32) {
        "ngInject";

        (0, _classCallCheck3.default)(this, UserController);
        $scope.errors = {};
        $scope.loading = false;
        $scope.user = this.appUser || {};
        $scope.$state = $state;
        this.$scope = $scope;
        this.$state = $state;
        this.$timeout = $timeout;
        this.$stateParams = $stateParams;
        this.$translate = $translate;

        $scope.captchaUrlBase = AppConfig.server_url + '/captcha';
        $scope.captchaUrl = $scope.captchaUrlBase + '?s=' + Math.random();

        $scope.rememberMe = true;
        $scope.toggleRememberMe = function () {
            $scope.rememberMe = !$scope.rememberMe;
        };

        $scope.agreeTerms = false;
        $scope.toggleAgreeTerms = function () {
            $scope.agreeTerms = !$scope.agreeTerms;
        };

        var self = this;

        $transitions.onEnter({}, function () {
            $scope.errors = {};
        });

        $scope.login = function () {

            if (!validate(['email', 'password'])) {
                return;
            }

            var email = $('#email').val().trim();
            var password = $('#password').val();
            var captcha = $('#captcha').val();
            var remember = $scope.rememberMe ? 1 : 0;

            apiCall('/login', {
                'email': email,
                'password': password,
                'remember': remember,
                'captcha': captcha,
                'crc32': "" + crc32.crc32_str(email + password + remember)
            }, function (user) {
                window.localStorage.setItem("loginUser", (0, _stringify2.default)(user));
                self.updateAppUser(user);
            });
        };

        $scope.register = function () {
            if (!validate(['email', 'pseudonym', 'password'])) {
                return;
            }

            if (!$scope.agreeTerms) {
                self.$translate('face-user-text007').then(function (translation) {
                    message.error(translation);
                });
                return;
            }

            var email = $('#email').val();
            var pseudonym = $('#pseudonym').val();
            var password = $('#password').val();

            apiCall('/register', {
                'email': email,
                'pseudonym': pseudonym,
                'password': password,
                'crc32': "" + crc32.crc32_str(email + pseudonym + password)
            }, function (user) {
                self.updateAppUser(user);
            });
        };

        $scope.forget = function () {
            if (!validate(['email', 'captcha'])) {
                return;
            }

            var email = $('#email').val();
            var captcha = $('#captcha').val();

            apiCall('/password/forget', {
                'email': email,
                'captcha': captcha,
                'crc32': "" + crc32.crc32_str(email)
            }, function () {
                $scope.user = {
                    'email': email
                };

                $state.go('app.face.index.user.find');
            });
        };

        $scope.reset = function () {

            var token = $stateParams.s;

            if (!token) {
                self.$translate('face-user-text008').then(function (translation) {
                    message.error(translation);
                });
                return;
            }

            if (!validate(['password', 'password_confirm'])) {
                return;
            }

            var password = $('#password').val();
            var passwordConfirm = $('#password_confirm').val();

            if (password != passwordConfirm) {
                self.$translate('face-user-text009').then(function (translation) {
                    $scope.errors['password_confirm'] = translation;
                });
                return;
            }

            apiCall('/password/reset', {
                'password': password,
                'token': token,
                'crc32': "" + crc32.crc32_str(password + token)
            }, function () {
                $state.go('app.home.dashboard');
            });
        };

        $scope.resend = function () {
            apiCall('/email/confirmation/resend', {}, function () {
                self.$translate('face-user-text010').then(function (translation) {
                    message.success(translation);
                });
            }, function (response) {
                message.error(response.data);
            });
        };
        $scope.emailCheck = function () {

            if (!validate(['email'])) {
                return;
            }
            var email = $('#email').val();

            apiCall('/password/status', {
                'email': email
            }, function (res) {
                if (res.data && res.data.need_change_password == 1) {
                    self.$translate('face-user-text011').then(function (translation) {
                        $scope.errors['email'] = translation;
                    });
                }
            });

            Restangular.one('email/status').get({
                email: email
            }).then(function (res) {
                if (res.status.code !== 200) {
                    $scope.errors['email'] = res.status.message.email[0];
                }
            });
        };
        $scope.getEmailAddress = function () {
            if ($scope.user) {
                if (/^.*@hotmail|outlook\./.test($scope.user)) {
                    return 'https://outlook.live.com/owa/';
                }
                return 'http://' + $scope.user.email.replace(/^.*@/, 'mail.');
            }
            return '';
        };

        $scope.reloadCaptcha = function () {
            $scope.captchaUrl = $scope.captchaUrlBase + '?s=' + Math.random();
        };

        $scope.searchArticle = function () {
            var text = $('#index-search-input').val();

            if (text !== '') {
                $state.go('app.page.search.article', { q: text });
            }
        };

        $scope.searchImage = function () {
            var text = $('#index-search-input').val();

            if (text !== '') {
                $state.go('app.page.search.image', { q: text });
            }
        };
        $scope.bind = function (name) {
            location.href = AppConfig.server_url + "/media/bind/" + name + '?return=/home/import/weixin';
        };

        function apiCall(endpoint, data, successCallback, errorCallback) {
            $scope.loading = true;

            $http.post(AppConfig.server_url + endpoint, data, {
                withCredentials: true
            }).then(function success(response) {
                $scope.loading = false;
                successCallback(response.data);
            }, function error(response) {

                if (typeof errorCallback == 'function') {
                    errorCallback(response);
                } else {
                    if (response.data) {
                        retrieveErrors(response.data);
                    }
                }

                $scope.reloadCaptcha();

                $scope.loading = false;
            });
        }

        function validate(fields) {
            var hasError = false;
            $scope.errors = {};

            var _loop = function _loop(i, l) {
                var field = fields[i];
                var inputElement = $('#' + field);

                var value = inputElement.val().trim();
                if (value == '') {
                    self.$translate('face-user-text012').then(function (translation) {
                        $scope.errors[field] = inputElement.data('localeName') + ' ' + translation;
                    });
                    hasError = true;
                }
            };

            for (var i = 0, l = fields.length; i < l; i++) {
                _loop(i, l);
            }
            if (self.form && self.form["password"].$error.pwdStrength) {
                self.$translate('face-user-text013').then(function (translation) {
                    $scope.errors['password'] = translation;
                });
                hasError = true;
            }

            if (self.form && self.form["email"] && self.form["email"].$error.email) {
                hasError = true;
            }

            return !hasError;
        }

        function retrieveErrors(data) {
            for (var _field in data) {
                if (data.hasOwnProperty(_field)) {
                    $scope.errors[_field] = data[_field][0];
                }
            }
        }

        this.checkUserStatus();
    }

    (0, _createClass3.default)(UserController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.$timeout(function () {
                if (_this.appUser) {
                    _this.updateAppUser(_this.appUser);
                }
            }, 1000);
        }
    }, {
        key: 'checkUserStatus',
        value: function checkUserStatus() {

            var self = this;
            if (this.$scope.user && this.$scope.user.id) {

                if (this.$state.is('app.face.index.user.form.reset')) {

                    // Password reset takes the first priority
                    return false;
                }

                if (!this.$scope.user.email_verified) {
                    this.$timeout(function () {
                        self.$state.go('app.face.index.user.confirm');
                    });

                    return false;
                }

                return true;
            }

            return false;
        }
    }, {
        key: 'updateAppUser',
        value: function updateAppUser(user) {
            var self = this;
            for (var k in user) {
                if (user.hasOwnProperty(k)) {
                    this.$scope.user[k] = user[k];
                }
            }
            if (this.checkUserStatus()) {

                if (this.$state.is('app.face.index.user.form.login')) {
                    if (this.$stateParams.return) {
                        location.href = this.$stateParams.return;
                    } else {
                        this.$timeout(function () {
                            self.$state.go('app.home.dashboard');
                        });
                    }
                }
            }
        }
    }]);
    return UserController;
}();

exports.default = UserController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(24);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(750);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./user.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./user.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".user .form-container.confirm {\n  width: 520px;\n  padding: 48px 54px;\n  margin: 20px auto; }\n  .user .form-container.confirm.un-email-verifyed .success {\n    font-size: 24px;\n    color: #00816a; }\n  .user .form-container.confirm.un-email-verifyed .description {\n    margin-top: 18px;\n    font-size: 14px;\n    color: #999999; }\n    .user .form-container.confirm.un-email-verifyed .description .row {\n      margin-top: 7px; }\n  .user .form-container.confirm.un-email-verifyed .mailbox {\n    margin-top: 28px;\n    text-align: center; }\n    .user .form-container.confirm.un-email-verifyed .mailbox a {\n      display: inline-block;\n      width: 160px;\n      height: 40px;\n      line-height: 40px;\n      background-color: #00816a;\n      color: #ffffff;\n      text-decoration: none;\n      border-radius: 3px;\n      font-size: 16px; }\n  .user .form-container.confirm.un-email-verifyed .tips {\n    margin-top: 42px;\n    font-size: 12px;\n    color: #999999; }\n    .user .form-container.confirm.un-email-verifyed .tips ul {\n      list-style: none;\n      padding-left: 0; }\n      .user .form-container.confirm.un-email-verifyed .tips ul a {\n        text-decoration: underline;\n        color: #00816a; }\n  .user .form-container.confirm.in-email-verifyed {\n    width: 600px;\n    margin: 0 auto;\n    height: 390px; }\n    .user .form-container.confirm.in-email-verifyed .left-area {\n      width: 50%; }\n      .user .form-container.confirm.in-email-verifyed .left-area .welcome {\n        color: #00816a;\n        font-size: 24px;\n        padding-bottom: 10px; }\n      .user .form-container.confirm.in-email-verifyed .left-area .tip {\n        color: #999999;\n        font-size: 14px;\n        margin: 20px 0; }\n      .user .form-container.confirm.in-email-verifyed .left-area .weixin .weixin-tip {\n        color: #999999;\n        font-size: 16px;\n        margin-bottom: 10px; }\n      .user .form-container.confirm.in-email-verifyed .left-area .weixin .bind-weixin {\n        cursor: pointer; }\n      .user .form-container.confirm.in-email-verifyed .left-area .publish .publish-link {\n        display: block;\n        text-decoration: underline;\n        color: #666666;\n        font-size: 16px;\n        margin-bottom: 12px; }\n        .user .form-container.confirm.in-email-verifyed .left-area .publish .publish-link:hover {\n          color: #00816a; }\n    .user .form-container.confirm.in-email-verifyed .right-area {\n      width: 50%;\n      text-align: right; }\n\n@media only screen and (max-width: 767px) {\n  .user .form-container.confirm {\n    width: auto !important;\n    padding: 18px 28px !important;\n    margin: 0; }\n    .user .form-container.confirm.in-email-verifyed {\n      height: 350px; }\n      .user .form-container.confirm.in-email-verifyed .left-area {\n        width: auto; }\n    .user .form-container.confirm.in-email-verifyed .right-area {\n      display: none; } }\n\nuser .bg {\n  background: url(" + __webpack_require__(241) + ") no-repeat center bottom; }\n\nuser .form-container {\n  position: relative;\n  width: 300px;\n  height: 350px;\n  margin: 0 auto;\n  padding: 16px 14px;\n  background-color: #ffffff;\n  border-radius: 2px;\n  box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.18); }\n\nuser .form-nav {\n  position: relative;\n  text-align: center;\n  color: #cccccc; }\n  user .form-nav .nav-item {\n    font-size: 16px;\n    text-decoration: none;\n    color: #222222;\n    border: 0;\n    padding-bottom: 6px; }\n    user .form-nav .nav-item.active {\n      color: #00816a;\n      border-bottom: 2px solid #00816a; }\n\n@media only screen and (max-width: 767px) {\n  user .form-container {\n    width: auto;\n    margin: 0; } }\n", ""]);

// exports


/***/ }),
/* 751 */
/***/ (function(module, exports) {

module.exports = "<div class=\"form-container\">\n    <div class=\"form-nav\">\n        <a ui-sref=\"app.face.index.user.form.login\" class=\"nav-item\" ui-sref-active=\"active\">{{'face-form-text001' | translate}}</a>\n        &nbsp;&nbsp;|&nbsp;&nbsp;\n        <a ui-sref=\"app.face.index.user.form.register\" class=\"nav-item\" ui-sref-active=\"active\">{{'face-form-text002' | translate}}</a>\n    </div>\n    <div class=\"face-form\" ui-view></div>\n</div>\n";

/***/ }),
/* 752 */
/***/ (function(module, exports) {

module.exports = "<form>\n    <div ng-class=\"{'input-group':true, 'error':errors['email']}\" yb-input-group>\n        <div class=\"input\">\n            <div class=\"icon\"><i class=\"ybicon yb-email\"></i></div>\n            <div class=\"wrapper\">\n                <input id=\"email\" type=\"text\" placeholder=\"{{'face-login-text001' | translate}}\" data-locale-name=\"{{'face-login-text001' | translate}}\" ng-blur=\"emailCheck()\"/>\n            </div>\n        </div>\n        <div class=\"error-message\">{{errors['email']}}</div>\n    </div>\n    <div ng-class=\"{'input-group':true, 'error':errors['password']}\" yb-input-group>\n        <div class=\"input\">\n            <div class=\"icon\"><i class=\"ybicon yb-lock\"></i></div>\n            <div class=\"wrapper\">\n                <input id=\"password\" pwd-mask type=\"password\" placeholder=\"{{'face-login-text002' | translate}}\" data-locale-name=\"{{'face-login-text002' | translate}}\"/>\n            </div>\n        </div>\n        <div class=\"error-message\">{{errors['password']}}</div>\n    </div>\n    <div class=\"captcha\" ng-class=\"{'input-group':true, 'error':errors['captcha']}\" yb-input-group>\n        <div class=\"input\">\n            <div class=\"icon\"><i class=\"ybicon yb-picture\"></i></div>\n            <div class=\"wrapper\">\n                <input id=\"captcha\"  type=\"text\" placeholder=\"验证码\" data-locale-name=\"{{'face-login-text002' | translate}}\"/>\n            </div>\n        </div>\n        <div class=\"captcha-image\">\n            <a href=\"javascript:void(0)\" ng-click=\"reloadCaptcha()\" title=\"{{'page-verify-text012' | translate}}\"><img\n                    ng-src=\"{{ captchaUrl }}\"/></a>\n        </div>\n        <div class=\"error-message\">{{errors['captcha']}}</div>\n    </div>\n    <div class=\"submit-group\">\n        <div class=\"wrapper\">\n            <button type=\"submit\" class=\"btn\" ng-click=\"login()\" ng-disabled=\"loading\">{{ loading &&\n                ('face-login-text003' | translate) || ('face-login-text004' | translate) }}\n            </button>\n        </div>\n        <div class=\"options\">\n            <div class=\"remember pull-left\">\n                <label ng-click=\"toggleRememberMe()\">\n                    <div ng-class=\"{checkbox: true, checked: rememberMe}\">\n                        <span class=\"ybicon yb-box\"></span>\n                        <span class=\"ybicon yb-select\"></span>\n                    </div>\n                    <div class=\"text\">{{'face-login-text005' | translate}}</div>\n                </label>\n            </div>\n            <div class=\"forget pull-right\">\n                <a ui-sref=\"app.face.index.user.form.forget\">{{'face-login-text006' | translate}}</a>\n            </div>\n        </div>\n    </div>\n</form>\n";

/***/ }),
/* 753 */
/***/ (function(module, exports) {

module.exports = "<form name=\"$ctrl.form\" novalidate>\n    <div ng-class=\"{'input-group':true, 'error':errors['email'] || $ctrl.form.email.$error.emailCheck || $ctrl.form.email.$error.email}\" yb-input-group>\n        <div class=\"input\">\n            <div class=\"icon\"><i class=\"ybicon yb-email\"></i></div>\n            <div class=\"wrapper\">\n                <input ng-model=\"email\" name=\"email\" email-check id=\"email\" type=\"email\" placeholder=\"{{'face-register-text001' | translate}}\" data-locale-name=\"{{'face-register-text001' | translate}}\"/>\n            </div>\n        </div>\n        <div class=\"error-message\">\n            <div ng-if=\"$ctrl.form.email.$error.emailCheck\">邮箱已存在</div>\n            <div ng-if=\"$ctrl.form.email.$error.email\">请输入正确的邮箱</div>\n        </div>\n    </div>\n    <div ng-class=\"{'input-group':true, 'error':errors['pseudonym']}\" yb-input-group>\n        <div class=\"input\">\n            <div class=\"icon\"><i class=\"ybicon yb-name\"></i></div>\n            <div class=\"wrapper\">\n                <input id=\"pseudonym\" type=\"text\" placeholder=\"{{'face-register-text002' | translate}}\" data-locale-name=\"{{'face-register-text002' | translate}}\"/>\n            </div>\n        </div>\n        <div class=\"error-message\">{{errors['pseudonym']}}</div>\n    </div>\n    <div ng-class=\"{'input-group':true, 'error':errors['password']}\" yb-input-group>\n        <div class=\"input\">\n            <div class=\"icon\"><i class=\"ybicon yb-lock\"></i></div>\n            <div class=\"wrapper\">\n                <input id=\"password\" pwd-mask name=\"password\" ng-model=\"password\" pwd-strength=\"error\" type=\"password\" placeholder=\"{{'face-register-text003' | translate}}\" data-locale-name=\"{{'face-register-text003' | translate}}\"/>\n            </div>\n        </div>\n        <div class=\"error-message\">{{errors['password']}}</div>\n    </div>\n    <div class=\"submit-group\">\n        <div class=\"wrapper\">\n            <button type=\"submit\" class=\"btn\" ng-click=\"register()\" ng-disabled=\"loading\">{{ loading &&\n                ('face-register-text004' | translate) || ('face-register-text005' | translate )}}\n            </button>\n        </div>\n        <div class=\"options\">\n            <div class=\"remember pull-left\">\n                <label>\n                    <div ng-class=\"{checkbox: true, checked: agreeTerms}\" ng-click=\"toggleAgreeTerms()\">\n                        <span class=\"ybicon yb-box\"></span>\n                        <span class=\"ybicon yb-select\"></span>\n                    </div>\n                    <div class=\"text\">\n                        <span ng-click=\"toggleAgreeTerms()\">{{'face-register-text006' | translate}}</span>\n                        <a ui-sref=\"app.page.terms\" target=\"_blank\" class=\"highlight\">{{'face-register-text007' | translate}}</a>\n                    </div>\n                </label>\n            </div>\n        </div>\n    </div>\n</form>\n";

/***/ }),
/* 754 */
/***/ (function(module, exports) {

module.exports = "<form>\n    <div ng-class=\"{'input-group':true, 'error':errors['email']}\" yb-input-group>\n        <div class=\"input\">\n            <div class=\"icon\"><i class=\"ybicon yb-email\"></i></div>\n            <div class=\"wrapper\">\n                <input id=\"email\" type=\"text\" placeholder=\"{{'face-forget-text001' | translate}}\" data-locale-name=\"{{'face-forget-text001' | translate}}\"/>\n            </div>\n        </div>\n        <div class=\"error-message\">{{errors['email']}}</div>\n    </div>\n    <div ng-class=\"{'input-group':true, 'error':errors['captcha'], 'captcha':true}\" yb-input-group>\n        <div class=\"input\">\n            <div class=\"icon\"><i class=\"ybicon yb-lock\"></i></div>\n            <div class=\"wrapper\">\n                <input id=\"captcha\" type=\"text\" placeholder=\"{{'face-forget-text002' | translate}}\" data-locale-name=\"{{'face-forget-text001' | translate}}\"/>\n            </div>\n        </div>\n        <div class=\"captcha-image\">\n            <a href=\"javascript:void(0)\" ng-click=\"reloadCaptcha()\" title=\"{{'face-forget-text003' | translate}}\"><img ng-src=\"{{ captchaUrl }}\"/></a>\n        </div>\n        <div class=\"error-message\">{{errors['captcha']}}</div>\n    </div>\n    <div class=\"submit-group\">\n        <div class=\"wrapper\">\n            <button type=\"submit\" class=\"btn\" ng-click=\"forget()\" ng-disabled=\"loading\">{{'face-forget-text004' | translate}}\n            </button>\n        </div>\n    </div>\n</form>\n";

/***/ }),
/* 755 */
/***/ (function(module, exports) {

module.exports = "<form name=\"$ctrl.form\" novalidate>\n    <div ng-class=\"{'input-group':true, 'error':errors['password']}\" yb-input-group>\n        <div class=\"input\">\n            <div class=\"icon\"><i class=\"ybicon yb-email\"></i></div>\n            <div class=\"wrapper\">\n                <input id=\"password\" name=\"password\" ng-model=\"password\" pwd-strength pwd-mask type=\"password\" placeholder=\"{{'face-reset-text001' | translate}}\" data-locale-name=\"{{'face-reset-text001' | translate}}\"/>\n            </div>\n        </div>\n        <div class=\"error-message\">{{errors['password']}}</div>\n    </div>\n    <div ng-class=\"{'input-group':true, 'error':errors['password_confirm']}\" yb-input-group>\n        <div class=\"input\">\n            <div class=\"icon\"><i class=\"ybicon yb-lock\"></i></div>\n            <div class=\"wrapper\">\n                <input id=\"password_confirm\" type=\"password\" placeholder=\"{{'face-reset-text002' | translate}}\" data-locale-name=\"{{'face-reset-text002' | translate}}\"/>\n            </div>\n        </div>\n        <div class=\"error-message\">{{errors['password_confirm']}}</div>\n    </div>\n    <div class=\"submit-group\">\n        <div class=\"wrapper\">\n            <button type=\"submit\" class=\"btn\" ng-click=\"reset()\" ng-disabled=\"loading\">{{ loading &&\n                ('face-reset-text003' | translate) || ('face-reset-text004' | translate )}}\n            </button>\n        </div>\n    </div>\n</form>\n";

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<div class=\"form-container confirm un-email-verifyed\" ng-if=\"!user || !user.email_verified\">\n    <div class=\"success\">{{'face-confirm-text001' | translate}}</div>\n    <div class=\"description\">\n        <div class=\"row\">{{'face-confirm-text002' | translate}}：{{ user.email }}</div>\n        <div class=\"row\">{{'face-confirm-text003' | translate}}</div>\n    </div>\n    <div class=\"mailbox\">\n        <a ng-href=\"{{ user && user.email && getEmailAddress() }}\">{{'face-confirm-text004' | translate}}</a>\n    </div>\n    <div class=\"tips\">\n        <div class=\"title\">{{'face-confirm-text005' | translate}}</div>\n        <div class=\"guide\">\n            <ul>\n                <li>1. {{'face-confirm-text006' | translate}}</li>\n                <li>2. {{'face-confirm-text007' | translate}}<a href=\"javascript:void(0)\" ng-click=\"resend()\">{{'face-confirm-text014' | translate}}</a></li>\n            </ul>\n        </div>\n    </div>\n</div>\n<div class=\"form-container confirm in-email-verifyed\" ng-if=\"user && user.email_verified\">\n\n\n    <div class=\"clearfix\">\n        <div class=\"pull-left left-area\">\n            <div class=\"welcome\">{{'face-confirm-text008' | translate}}</div>\n            <div class=\"tip\">{{'face-confirm-text009' | translate}}</div>\n            <div class=\"weixin\">\n                <div class=\"weixin-tip\">{{'face-confirm-text010' | translate}}</div>\n                <img src=\"" + __webpack_require__(757) + "\" class=\"bind-weixin\" ng-click=\"bind('weixin')\"/>\n            </div>\n            <div class=\"tip\">{{'face-confirm-text011' | translate}}</div>\n            <div class=\"publish\">\n                <a ui-sref=\"app.home.publish.article.edit\" class=\"publish-link\">{{'face-confirm-text012' | translate}} >></a>\n                <a ui-sref=\"app.home.publish.image.upload\" class=\"publish-link\">{{'face-confirm-text013' | translate}} >></a>\n            </div>\n        </div>\n        <div class=\"pull-right right-area\">\n            <img src=\"" + __webpack_require__(758) + "\" />\n        </div>\n\n    </div>\n\n</div>\n";

/***/ }),
/* 757 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "976d8a7c2ede2b9c650771d8b3a60ffe.png";

/***/ }),
/* 759 */
/***/ (function(module, exports) {

module.exports = "<div class=\"form-container confirm un-email-verifyed\">\n    <div class=\"success\">{{'face-find-text001' | translate}}</div>\n    <div class=\"description\">\n        <div class=\"row\">{{'face-find-text002' | translate}}：{{ user.email }}</div>\n        <div class=\"row\">{{'face-find-text003' | translate}}</div>\n    </div>\n    <div class=\"mailbox\">\n        <a ng-href=\"{{ getEmailAddress() }}\">{{'face-find-text004' | translate}}</a>\n    </div>\n    <div class=\"tips\">\n        <div class=\"title\">{{'face-find-text005' | translate}}</div>\n        <div class=\"guide\">\n            <ul>\n                <li>1. {{'face-find-text006' | translate}}</li>\n                <li>2. {{'face-find-text007' | translate}}<a ui-sref=\"app.face.index.user.form.forget\">{{'face-find-text008' | translate}}</a>。</li>\n            </ul>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

/**
 * Created by lency on 9/1/16.
 */
exports.default = function () {
    return function (scope, elem) {
        elem.on('focus', 'input', function () {
            elem.addClass('active');
        });

        elem.on('blur', 'input', function () {
            elem.removeClass('active');
        });
    };
};

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * Created by lency on 9/1/16.
 */
exports.default = ['$compile', function ($compile) {
    'ngInject';

    return function (scope, elem) {
        var template = '<i class="ybicon" ng-class="{\'yb-eye_open\': show, \'yb-eye_close\': !show}" ng-click="show = !show">';
        var linkedScope = scope.$new(true);
        var linker = $compile(template);
        linkedScope.show = false;
        var ele = linker(linkedScope, function (a) {
            elem.before(a);
        });
        linkedScope.$watch('show', function (newV) {
            if (newV) {
                elem.attr('type', 'text');
            } else {
                elem.attr('type', 'password');
            }
        });
        function inputHandler() {
            if (linkedScope.show) {
                elem.val(elem.val().replace(/[\u4e00-\u9fa5]/g, ""));
            }
        }
        elem.on('input', inputHandler);
        linkedScope.$on('$destroy', function () {
            ele.remove();
            ele = null;
            elem.off('input', inputHandler);
        });
        scope.$on('$destroy', function () {
            linkedScope.$destroy();
            linkedScope = null;
        });
    };
}];

/***/ }),
/* 762 */
/***/ (function(module, exports) {

/**
 * An Angular module that gives you access to the browsers local storage
 * @version v0.5.0 - 2016-08-29
 * @link https://github.com/grevory/angular-local-storage
 * @author grevory <greg@gregpike.ca>
 * @license MIT License, http://www.opensource.org/licenses/MIT
 */
(function (window, angular) {
var isDefined = angular.isDefined,
  isUndefined = angular.isUndefined,
  isNumber = angular.isNumber,
  isObject = angular.isObject,
  isArray = angular.isArray,
  extend = angular.extend,
  toJson = angular.toJson;

angular
  .module('LocalStorageModule', [])
  .provider('localStorageService', function() {
    // You should set a prefix to avoid overwriting any local storage variables from the rest of your app
    // e.g. localStorageServiceProvider.setPrefix('yourAppName');
    // With provider you can use config as this:
    // myApp.config(function (localStorageServiceProvider) {
    //    localStorageServiceProvider.prefix = 'yourAppName';
    // });
    this.prefix = 'ls';

    // You could change web storage type localstorage or sessionStorage
    this.storageType = 'localStorage';

    // Cookie options (usually in case of fallback)
    // expiry = Number of days before cookies expire // 0 = Does not expire
    // path = The web path the cookie represents
    // secure = Wether the cookies should be secure (i.e only sent on HTTPS requests)
    this.cookie = {
      expiry: 30,
      path: '/',
      secure: false
    };

    // Decides wether we should default to cookies if localstorage is not supported.
    this.defaultToCookie = true;

    // Send signals for each of the following actions?
    this.notify = {
      setItem: true,
      removeItem: false
    };

    // Setter for the prefix
    this.setPrefix = function(prefix) {
      this.prefix = prefix;
      return this;
    };

    // Setter for the storageType
    this.setStorageType = function(storageType) {
      this.storageType = storageType;
      return this;
    };
    // Setter for defaultToCookie value, default is true.
    this.setDefaultToCookie = function (shouldDefault) {
      this.defaultToCookie = !!shouldDefault; // Double-not to make sure it's a bool value.
      return this;
    };
    // Setter for cookie config
    this.setStorageCookie = function(exp, path, secure) {
      this.cookie.expiry = exp;
      this.cookie.path = path;
      this.cookie.secure = secure;
      return this;
    };

    // Setter for cookie domain
    this.setStorageCookieDomain = function(domain) {
      this.cookie.domain = domain;
      return this;
    };

    // Setter for notification config
    // itemSet & itemRemove should be booleans
    this.setNotify = function(itemSet, itemRemove) {
      this.notify = {
        setItem: itemSet,
        removeItem: itemRemove
      };
      return this;
    };

    this.$get = ['$rootScope', '$window', '$document', '$parse','$timeout', function($rootScope, $window, $document, $parse, $timeout) {
      var self = this;
      var prefix = self.prefix;
      var cookie = self.cookie;
      var notify = self.notify;
      var storageType = self.storageType;
      var webStorage;

      // When Angular's $document is not available
      if (!$document) {
        $document = document;
      } else if ($document[0]) {
        $document = $document[0];
      }

      // If there is a prefix set in the config lets use that with an appended period for readability
      if (prefix.substr(-1) !== '.') {
        prefix = !!prefix ? prefix + '.' : '';
      }
      var deriveQualifiedKey = function(key) {
        return prefix + key;
      };

      // Removes prefix from the key.
      var underiveQualifiedKey = function (key) {
        return key.replace(new RegExp('^' + prefix, 'g'), '');
      };

      // Check if the key is within our prefix namespace.
      var isKeyPrefixOurs = function (key) {
        return key.indexOf(prefix) === 0;
      };

      // Checks the browser to see if local storage is supported
      var checkSupport = function () {
        try {
          var supported = (storageType in $window && $window[storageType] !== null);

          // When Safari (OS X or iOS) is in private browsing mode, it appears as though localStorage
          // is available, but trying to call .setItem throws an exception.
          //
          // "QUOTA_EXCEEDED_ERR: DOM Exception 22: An attempt was made to add something to storage
          // that exceeded the quota."
          var key = deriveQualifiedKey('__' + Math.round(Math.random() * 1e7));
          if (supported) {
            webStorage = $window[storageType];
            webStorage.setItem(key, '');
            webStorage.removeItem(key);
          }

          return supported;
        } catch (e) {
          // Only change storageType to cookies if defaulting is enabled.
          if (self.defaultToCookie)
            storageType = 'cookie';
          $rootScope.$broadcast('LocalStorageModule.notification.error', e.message);
          return false;
        }
      };
      var browserSupportsLocalStorage = checkSupport();

      // Directly adds a value to local storage
      // If local storage is not available in the browser use cookies
      // Example use: localStorageService.add('library','angular');
      var addToLocalStorage = function (key, value, type) {
        setStorageType(type);

        // Let's convert undefined values to null to get the value consistent
        if (isUndefined(value)) {
          value = null;
        } else {
          value = toJson(value);
        }

        // If this browser does not support local storage use cookies
        if (!browserSupportsLocalStorage && self.defaultToCookie || self.storageType === 'cookie') {
          if (!browserSupportsLocalStorage) {
            $rootScope.$broadcast('LocalStorageModule.notification.warning', 'LOCAL_STORAGE_NOT_SUPPORTED');
          }

          if (notify.setItem) {
            $rootScope.$broadcast('LocalStorageModule.notification.setitem', {key: key, newvalue: value, storageType: 'cookie'});
          }
          return addToCookies(key, value);
        }

        try {
          if (webStorage) {
            webStorage.setItem(deriveQualifiedKey(key), value);
          }
          if (notify.setItem) {
            $rootScope.$broadcast('LocalStorageModule.notification.setitem', {key: key, newvalue: value, storageType: self.storageType});
          }
        } catch (e) {
          $rootScope.$broadcast('LocalStorageModule.notification.error', e.message);
          return addToCookies(key, value);
        }
        return true;
      };

      // Directly get a value from local storage
      // Example use: localStorageService.get('library'); // returns 'angular'
      var getFromLocalStorage = function (key, type) {
        setStorageType(type);

        if (!browserSupportsLocalStorage && self.defaultToCookie  || self.storageType === 'cookie') {
          if (!browserSupportsLocalStorage) {
            $rootScope.$broadcast('LocalStorageModule.notification.warning', 'LOCAL_STORAGE_NOT_SUPPORTED');
          }

          return getFromCookies(key);
        }

        var item = webStorage ? webStorage.getItem(deriveQualifiedKey(key)) : null;
        // angular.toJson will convert null to 'null', so a proper conversion is needed
        // FIXME not a perfect solution, since a valid 'null' string can't be stored
        if (!item || item === 'null') {
          return null;
        }

        try {
          return JSON.parse(item);
        } catch (e) {
          return item;
        }
      };

      // Remove an item from local storage
      // Example use: localStorageService.remove('library'); // removes the key/value pair of library='angular'
      //
      // This is var-arg removal, check the last argument to see if it is a storageType
      // and set type accordingly before removing.
      //
      var removeFromLocalStorage = function () {
        // can't pop on arguments, so we do this
        var consumed = 0;
        if (arguments.length >= 1 &&
            (arguments[arguments.length - 1] === 'localStorage' ||
             arguments[arguments.length - 1] === 'sessionStorage')) {
          consumed = 1;
          setStorageType(arguments[arguments.length - 1]);
        }

        var i, key;
        for (i = 0; i < arguments.length - consumed; i++) {
          key = arguments[i];
          if (!browserSupportsLocalStorage && self.defaultToCookie || self.storageType === 'cookie') {
            if (!browserSupportsLocalStorage) {
              $rootScope.$broadcast('LocalStorageModule.notification.warning', 'LOCAL_STORAGE_NOT_SUPPORTED');
            }

            if (notify.removeItem) {
              $rootScope.$broadcast('LocalStorageModule.notification.removeitem', {key: key, storageType: 'cookie'});
            }
            removeFromCookies(key);
          }
          else {
            try {
              webStorage.removeItem(deriveQualifiedKey(key));
              if (notify.removeItem) {
                $rootScope.$broadcast('LocalStorageModule.notification.removeitem', {
                  key: key,
                  storageType: self.storageType
                });
              }
            } catch (e) {
              $rootScope.$broadcast('LocalStorageModule.notification.error', e.message);
              removeFromCookies(key);
            }
          }
        }
      };

      // Return array of keys for local storage
      // Example use: var keys = localStorageService.keys()
      var getKeysForLocalStorage = function (type) {
        setStorageType(type);

        if (!browserSupportsLocalStorage) {
          $rootScope.$broadcast('LocalStorageModule.notification.warning', 'LOCAL_STORAGE_NOT_SUPPORTED');
          return [];
        }

        var prefixLength = prefix.length;
        var keys = [];
        for (var key in webStorage) {
          // Only return keys that are for this app
          if (key.substr(0, prefixLength) === prefix) {
            try {
              keys.push(key.substr(prefixLength));
            } catch (e) {
              $rootScope.$broadcast('LocalStorageModule.notification.error', e.Description);
              return [];
            }
          }
        }
        return keys;
      };

      // Remove all data for this app from local storage
      // Also optionally takes a regular expression string and removes the matching key-value pairs
      // Example use: localStorageService.clearAll();
      // Should be used mostly for development purposes
      var clearAllFromLocalStorage = function (regularExpression, type) {
        setStorageType(type);

        // Setting both regular expressions independently
        // Empty strings result in catchall RegExp
        var prefixRegex = !!prefix ? new RegExp('^' + prefix) : new RegExp();
        var testRegex = !!regularExpression ? new RegExp(regularExpression) : new RegExp();

        if (!browserSupportsLocalStorage && self.defaultToCookie  || self.storageType === 'cookie') {
          if (!browserSupportsLocalStorage) {
            $rootScope.$broadcast('LocalStorageModule.notification.warning', 'LOCAL_STORAGE_NOT_SUPPORTED');
          }
          return clearAllFromCookies();
        }
        if (!browserSupportsLocalStorage && !self.defaultToCookie)
          return false;
        var prefixLength = prefix.length;

        for (var key in webStorage) {
          // Only remove items that are for this app and match the regular expression
          if (prefixRegex.test(key) && testRegex.test(key.substr(prefixLength))) {
            try {
              removeFromLocalStorage(key.substr(prefixLength));
            } catch (e) {
              $rootScope.$broadcast('LocalStorageModule.notification.error', e.message);
              return clearAllFromCookies();
            }
          }
        }
        return true;
      };

      // Checks the browser to see if cookies are supported
      var browserSupportsCookies = (function() {
        try {
          return $window.navigator.cookieEnabled ||
          ("cookie" in $document && ($document.cookie.length > 0 ||
            ($document.cookie = "test").indexOf.call($document.cookie, "test") > -1));
          } catch (e) {
            $rootScope.$broadcast('LocalStorageModule.notification.error', e.message);
            return false;
          }
        }());

        // Directly adds a value to cookies
        // Typically used as a fallback if local storage is not available in the browser
        // Example use: localStorageService.cookie.add('library','angular');
        var addToCookies = function (key, value, daysToExpiry, secure) {

          if (isUndefined(value)) {
            return false;
          } else if(isArray(value) || isObject(value)) {
            value = toJson(value);
          }

          if (!browserSupportsCookies) {
            $rootScope.$broadcast('LocalStorageModule.notification.error', 'COOKIES_NOT_SUPPORTED');
            return false;
          }

          try {
            var expiry = '',
            expiryDate = new Date(),
            cookieDomain = '';

            if (value === null) {
              // Mark that the cookie has expired one day ago
              expiryDate.setTime(expiryDate.getTime() + (-1 * 24 * 60 * 60 * 1000));
              expiry = "; expires=" + expiryDate.toGMTString();
              value = '';
            } else if (isNumber(daysToExpiry) && daysToExpiry !== 0) {
              expiryDate.setTime(expiryDate.getTime() + (daysToExpiry * 24 * 60 * 60 * 1000));
              expiry = "; expires=" + expiryDate.toGMTString();
            } else if (cookie.expiry !== 0) {
              expiryDate.setTime(expiryDate.getTime() + (cookie.expiry * 24 * 60 * 60 * 1000));
              expiry = "; expires=" + expiryDate.toGMTString();
            }
            if (!!key) {
              var cookiePath = "; path=" + cookie.path;
              if (cookie.domain) {
                cookieDomain = "; domain=" + cookie.domain;
              }
              /* Providing the secure parameter always takes precedence over config
               * (allows developer to mix and match secure + non-secure) */
              if (typeof secure === 'boolean') {
                  if (secure === true) {
                      /* We've explicitly specified secure,
                       * add the secure attribute to the cookie (after domain) */
                      cookieDomain += "; secure";
                  }
                  // else - secure has been supplied but isn't true - so don't set secure flag, regardless of what config says
              }
              else if (cookie.secure === true) {
                  // secure parameter wasn't specified, get default from config
                  cookieDomain += "; secure";
              }
              $document.cookie = deriveQualifiedKey(key) + "=" + encodeURIComponent(value) + expiry + cookiePath + cookieDomain;
            }
          } catch (e) {
            $rootScope.$broadcast('LocalStorageModule.notification.error', e.message);
            return false;
          }
          return true;
        };

        // Directly get a value from a cookie
        // Example use: localStorageService.cookie.get('library'); // returns 'angular'
        var getFromCookies = function (key) {
          if (!browserSupportsCookies) {
            $rootScope.$broadcast('LocalStorageModule.notification.error', 'COOKIES_NOT_SUPPORTED');
            return false;
          }

          var cookies = $document.cookie && $document.cookie.split(';') || [];
          for(var i=0; i < cookies.length; i++) {
            var thisCookie = cookies[i];
            while (thisCookie.charAt(0) === ' ') {
              thisCookie = thisCookie.substring(1,thisCookie.length);
            }
            if (thisCookie.indexOf(deriveQualifiedKey(key) + '=') === 0) {
              var storedValues = decodeURIComponent(thisCookie.substring(prefix.length + key.length + 1, thisCookie.length));
              try {
                return JSON.parse(storedValues);
              } catch(e) {
                return storedValues;
              }
            }
          }
          return null;
        };

        var removeFromCookies = function (key) {
          addToCookies(key,null);
        };

        var clearAllFromCookies = function () {
          var thisCookie = null;
          var prefixLength = prefix.length;
          var cookies = $document.cookie.split(';');
          for(var i = 0; i < cookies.length; i++) {
            thisCookie = cookies[i];

            while (thisCookie.charAt(0) === ' ') {
              thisCookie = thisCookie.substring(1, thisCookie.length);
            }

            var key = thisCookie.substring(prefixLength, thisCookie.indexOf('='));
            removeFromCookies(key);
          }
        };

        var getStorageType = function() {
          return storageType;
        };

        var setStorageType = function(type) {
          if (type && storageType !== type) {
            storageType = type;
            browserSupportsLocalStorage = checkSupport();
          }
          return browserSupportsLocalStorage;
        };

        // Add a listener on scope variable to save its changes to local storage
        // Return a function which when called cancels binding
        var bindToScope = function(scope, key, def, lsKey, type) {
          lsKey = lsKey || key;
          var value = getFromLocalStorage(lsKey, type);

          if (value === null && isDefined(def)) {
            value = def;
          } else if (isObject(value) && isObject(def)) {
            value = extend(value, def);
          }

          $parse(key).assign(scope, value);

          return scope.$watch(key, function(newVal) {
            addToLocalStorage(lsKey, newVal, type);
          }, isObject(scope[key]));
        };

        // Add listener to local storage, for update callbacks.
        if (browserSupportsLocalStorage) {
            if ($window.addEventListener) {
                $window.addEventListener("storage", handleStorageChangeCallback, false);
                $rootScope.$on('$destroy', function() {
                    $window.removeEventListener("storage", handleStorageChangeCallback);
                });
            } else if($window.attachEvent){
                // attachEvent and detachEvent are proprietary to IE v6-10
                $window.attachEvent("onstorage", handleStorageChangeCallback);
                $rootScope.$on('$destroy', function() {
                    $window.detachEvent("onstorage", handleStorageChangeCallback);
                });
            }
        }

        // Callback handler for storage changed.
        function handleStorageChangeCallback(e) {
            if (!e) { e = $window.event; }
            if (notify.setItem) {
                if (isKeyPrefixOurs(e.key)) {
                    var key = underiveQualifiedKey(e.key);
                    // Use timeout, to avoid using $rootScope.$apply.
                    $timeout(function () {
                        $rootScope.$broadcast('LocalStorageModule.notification.changed', { key: key, newvalue: e.newValue, storageType: self.storageType });
                    });
                }
            }
        }

        // Return localStorageService.length
        // ignore keys that not owned
        var lengthOfLocalStorage = function(type) {
          setStorageType(type);

          var count = 0;
          var storage = $window[storageType];
          for(var i = 0; i < storage.length; i++) {
            if(storage.key(i).indexOf(prefix) === 0 ) {
              count++;
            }
          }
          return count;
        };

        return {
          isSupported: browserSupportsLocalStorage,
          getStorageType: getStorageType,
          setStorageType: setStorageType,
          set: addToLocalStorage,
          add: addToLocalStorage, //DEPRECATED
          get: getFromLocalStorage,
          keys: getKeysForLocalStorage,
          remove: removeFromLocalStorage,
          clearAll: clearAllFromLocalStorage,
          bind: bindToScope,
          deriveKey: deriveQualifiedKey,
          underiveKey: underiveQualifiedKey,
          length: lengthOfLocalStorage,
          defaultToCookie: this.defaultToCookie,
          cookie: {
            isSupported: browserSupportsCookies,
            set: addToCookies,
            add: addToCookies, //DEPRECATED
            get: getFromCookies,
            remove: removeFromCookies,
            clearAll: clearAllFromCookies
          }
        };
      }];
  });
})(window, window.angular);

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _publishToMedia = __webpack_require__(764);

var _publishToMedia2 = _interopRequireDefault(_publishToMedia);

var _publishToMedia3 = __webpack_require__(767);

var _publishToMedia4 = _interopRequireDefault(_publishToMedia3);

__webpack_require__(768);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var publishToMediaComponent = {
    restrict: 'E',
    bindings: {
        'original': '=',
        'originalType': '@'
    },
    template: _publishToMedia2.default,
    controller: _publishToMedia4.default
};

exports.default = publishToMediaComponent;

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<button type=\"button\" class=\"btn btn-md btn-primary\" ng-click=\"$ctrl.show()\">{{'modules-text004' | translate}}</button>\n<div class=\"modal-overlay\" id=\"publish-to-media-modal\" modal-control>\n    <div class=\"modal\">\n        <form name=\"sendForm\" novalidate class=\"form\">\n            <div class=\"header\">\n                <div class=\"title\">{{'modules-text004' | translate}}</div>\n                <div class=\"close\">×</div>\n            </div>\n            <div class=\"content {{ $ctrl.originalType }}\">\n                <div class=\"cover-image\" ng-if=\"$ctrl.originalType == 'article'\">\n                    <div class=\"image\">\n                        <img ng-src=\"{{ $ctrl.formData.cover_image }}?x-oss-process=image/resize,m_fill,w_468,h_150,limit_0\"\n                             ng-if=\"$ctrl.formData.cover_image != ''\"/>\n                        <img src=\"" + __webpack_require__(765) + "\" ng-if=\"$ctrl.formData.cover_image == ''\"/>\n                    </div>\n                    <div class=\"mask\">{{'modules-text005' | translate}}</div>\n                    <div class=\"uploading\" ng-if=\"$ctrl.uploading\">\n                        <img src=\"" + __webpack_require__(111) + "\" width=\"48\" height=\"48\"/>\n                    </div>\n                    <input type=\"file\" class=\"image-field\" name=\"cover_image\" nv-file-select uploader=\"$ctrl.uploader\"/>\n                </div>\n                <div class=\"media-error-message\" ng-if=\"$ctrl.originalType == 'article'\">\n                    <div ng-show=\"sendForm.$submitted\">\n                        <div ng-show=\"$ctrl.coverError\">{{$ctrl.coverError}}</div>\n                    </div>\n                </div>\n                <div class=\"input-group digest\" ng-if=\"$ctrl.originalType == 'article'\">\n                    <div class=\"input\">\n                        <textarea name=\"digest\" ng-model=\"$ctrl.formData.digest\" placeholder=\"{{'modules-text006' | translate}}\"\n                                  required></textarea>\n                        <div class=\"error-message\">\n                            <div ng-show=\"sendForm.$submitted || sendForm.digest.$touched\">\n                                <div ng-show=\"sendForm.digest.$error.required\">{{'modules-text006' | translate}}</div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"input-group digest\" ng-if=\"$ctrl.originalType == 'image'\">\n                    <div class=\"input\">\n                        <textarea name=\"digest\" ng-model=\"$ctrl.formData.digest\" placeholder=\"{{'modules-text007' | translate}}\"\n                                  required></textarea>\n                        <div class=\"error-message\">\n                            <div ng-show=\"sendForm.$submitted || sendForm.digest.$touched\">\n                                <div ng-show=\"sendForm.digest.$error.required\">{{'modules-text007' | translate}}</div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"media-select\">\n                    <div\n                        ng-class=\"{'media-item': true, 'disabled': !$ctrl.mediaAccount.mediaAccounts['weixin'] || !$ctrl.mediaAccount.mediaAccounts['weixin']['access_token'], 'selected': $ctrl.selectedMediaMap['weixin']}\"\n                        ng-click=\"$ctrl.selectMedia('weixin')\">\n                        <div class=\"checkbox\">\n                            <i class=\"ybicon yb-select selected\"></i>\n                            <i class=\"ybicon yb-box not-selected\"></i>\n                        </div>\n                        <div class=\"name\">\n                            <div class=\"logo\">\n                                <img src=\"" + __webpack_require__(345) + "\"\n                                     ng-if=\"$ctrl.mediaAccount.mediaAccounts['weixin']\" width=\"30\" height=\"30\"/>\n                                <img src=\"" + __webpack_require__(349) + "\"\n                                     ng-if=\"!$ctrl.mediaAccount.mediaAccounts['weixin']\" width=\"30\" height=\"30\"/>\n                            </div>\n                            <div class=\"text\" ng-if=\"!$ctrl.mediaAccount.mediaAccounts['weixin']\">{{'modules-text008' | translate}}</div>\n                            <div class=\"text\" ng-if=\"$ctrl.mediaAccount.mediaAccounts['weixin']\">{{\n                                $ctrl.mediaAccount.mediaAccounts['weixin']['name'] }}\n                            </div>\n                        </div>\n                        <div class=\"actions\">\n                            <div ng-class=\"{'option':true, 'selected':$ctrl.mediaOptions['weixin']['send']}\"\n                                 ng-click=\"$ctrl.toggleOption('weixin', 'send');$event.stopPropagation()\"\n                                 ng-if=\"$ctrl.originalType=='article' && $ctrl.vip\">\n                                <div class=\"option-checkbox\">\n                                    <i class=\"ybicon yb-select option-selected\"></i>\n                                    <i class=\"ybicon yb-box option-not-selected\"></i>\n                                </div>\n                                <div class=\"option-name\">{{'modules-text009' | translate}}</div>\n                            </div>\n                            <a href=\"javascript:void(0)\" ng-if=\"!$ctrl.mediaAccount.mediaAccounts['weixin']\"\n                               ng-click=\"$ctrl.gotoBind()\">{{'modules-text010' | translate}}</a>\n                            <a href=\"javascript:void(0)\"\n                               ng-if=\"$ctrl.mediaAccount.mediaAccounts['weixin'] && !$ctrl.mediaAccount.mediaAccounts['weixin']['access_token']\"\n                               ng-click=\"$ctrl.gotoBind()\">{{'modules-text011' | translate}}</a>\n                        </div>\n                    </div>\n                    <div\n                        ng-class=\"{'media-item': true, 'disabled': !$ctrl.mediaAccount.mediaAccounts['weibo'] || !$ctrl.mediaAccount.mediaAccounts['weibo']['access_token'], 'selected': $ctrl.selectedMediaMap['weibo']}\"\n                        ng-click=\"$ctrl.selectMedia('weibo')\" ng-if=\"$ctrl.originalType=='article'\">\n                        <div class=\"checkbox\">\n                            <i class=\"ybicon yb-select selected\"></i>\n                            <i class=\"ybicon yb-box not-selected\"></i>\n                        </div>\n                        <div class=\"name\">\n                            <div class=\"logo\">\n                                <img src=\"" + __webpack_require__(350) + "\"\n                                     ng-if=\"$ctrl.mediaAccount.mediaAccounts['weibo']\" width=\"30\" height=\"30\"/>\n                                <img src=\"" + __webpack_require__(367) + "\"\n                                     ng-if=\"!$ctrl.mediaAccount.mediaAccounts['weibo']\" width=\"30\" height=\"30\"/>\n                            </div>\n                            <div class=\"text\" ng-if=\"!$ctrl.mediaAccount.mediaAccounts['weibo']\">{{'modules-text012' | translate}}</div>\n                            <div class=\"text\" ng-if=\"$ctrl.mediaAccount.mediaAccounts['weibo']\">{{\n                                $ctrl.mediaAccount.mediaAccounts['weibo']['name'] }}\n                            </div>\n                        </div>\n                        <div class=\"actions\">\n                            <a href=\"javascript:void(0)\" ng-if=\"!$ctrl.mediaAccount.mediaAccounts['weibo']\"\n                               ng-click=\"$ctrl.gotoBind()\">{{'modules-text010' | translate}}</a>\n                            <a href=\"javascript:void(0)\"\n                               ng-if=\"$ctrl.mediaAccount.mediaAccounts['weibo'] && !$ctrl.mediaAccount.mediaAccounts['weibo']['access_token']\"\n                               ng-click=\"$ctrl.gotoBind()\">{{'modules-text011' | translate}}</a>\n                        </div>\n                    </div>\n                    <div\n                        ng-class=\"{'media-item': true, 'disabled': !$ctrl.mediaAccount.mediaAccounts['toutiao'] || !$ctrl.mediaAccount.mediaAccounts['toutiao']['access_token'], 'selected': $ctrl.selectedMediaMap['toutiao']}\"\n                        ng-click=\"$ctrl.selectMedia('toutiao')\" ng-if=\"$ctrl.originalType=='article'\">\n                        <div class=\"checkbox\">\n                            <i class=\"ybicon yb-select selected\"></i>\n                            <i class=\"ybicon yb-box not-selected\"></i>\n                        </div>\n                        <div class=\"name\">\n                            <div class=\"logo\">\n                                <img src=\"" + __webpack_require__(179) + "\"\n                                     ng-if=\"$ctrl.mediaAccount.mediaAccounts['toutiao']\" width=\"30\" height=\"30\"/>\n                                <img src=\"" + __webpack_require__(766) + "\"\n                                     ng-if=\"!$ctrl.mediaAccount.mediaAccounts['toutiao']\" width=\"30\" height=\"30\"/>\n                            </div>\n                            <div class=\"text\" ng-if=\"!$ctrl.mediaAccount.mediaAccounts['toutiao']\">{{'modules-text013' | translate}}</div>\n                            <div class=\"text\" ng-if=\"$ctrl.mediaAccount.mediaAccounts['toutiao']\">{{\n                                $ctrl.mediaAccount.mediaAccounts['toutiao']['name'] }}\n                            </div>\n                        </div>\n                        <div class=\"actions\">\n                            <div ng-class=\"{'option':true, 'selected':$ctrl.mediaOptions['toutiao']['send']}\"\n                                 ng-click=\"$ctrl.toggleOption('toutiao', 'send');$event.stopPropagation()\"\n                                 ng-if=\"$ctrl.mediaAccount.mediaAccounts['toutiao']['access_token'] && $ctrl.originalType=='article'\">\n                                <div class=\"option-checkbox\">\n                                    <i class=\"ybicon yb-select option-selected\"></i>\n                                    <i class=\"ybicon yb-box option-not-selected\"></i>\n                                </div>\n                                <div class=\"option-name\">{{'modules-text014' | translate}}</div>\n                            </div>\n                            <a href=\"javascript:void(0)\" ng-if=\"!$ctrl.mediaAccount.mediaAccounts['toutiao']\"\n                               ng-click=\"$ctrl.gotoBind()\">{{'modules-text010' | translate}}</a>\n                            <a href=\"javascript:void(0)\"\n                               ng-if=\"$ctrl.mediaAccount.mediaAccounts['toutiao'] && !$ctrl.mediaAccount.mediaAccounts['toutiao']['access_token']\"\n                               ng-click=\"$ctrl.gotoBind()\">{{'modules-text011' | translate}}</a>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"media-error-message\">\n                    <div ng-if=\"$ctrl.emptyMedia\">{{'modules-text015' | translate}}</div>\n                </div>\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\" ng-click=\"$ctrl.send(sendForm)\" class=\"btn btn-primary btn-md pull-right\"\n                        ng-disabled=\"$ctrl.loading\">{{ $ctrl.loading && ('modules-text016' | translate) || ('modules-text017' | translate) }}\n                </button>\n            </div>\n        </form>\n    </div>\n</div>\n";

/***/ }),
/* 765 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 766 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PublishToMediaController = function () {
    PublishToMediaController.$inject = ['$scope', 'mediaAccount', '$filter', '$state', 'modal', 'FileUploader', 'AppConfig', 'message', '$http', 'ArticleAPI'];

    function PublishToMediaController($scope, mediaAccount, $filter, $state, modal, FileUploader, AppConfig, message, $http, ArticleAPI) {
        "ngInject";

        (0, _classCallCheck3.default)(this, PublishToMediaController);
        var self = this;
        this.mediaAccount = mediaAccount;
        this.$state = $state;
        this.modal = modal;
        this.loading = false;
        this.uploading = false;
        this.message = message;
        this.$http = $http;
        this.AppConfig = AppConfig;
        this.imageUploadPolicy = null;
        this.ArticleAPI = ArticleAPI;
        this.tranlsteFilter = $filter('translate');

        this.selectedMediaMap = {};
        this.selectedMedias = [];
        this.mediaOptions = {
            'weixin': {
                'send': false
            },
            'weibo': {},
            'toutiao': {
                'send': false
            }
        };

        this.formData = {
            id: this.original.id,
            type: this.originalType,
            cover_image: this.extractImage(),
            digest: this.original.outline
        };

        this.emptyMedia = false;
        this.coverError = null;

        mediaAccount.init();
        var currentImageFilename = '';
        this.uploader = new FileUploader({
            autoUpload: true,
            removeAfterUpload: true,

            onSuccessItem: function onSuccessItem(item, response, status, headers) {
                self.formData.cover_image = self.imageUploadPolicy['host'] + '/' + currentImageFilename;
                self.uploading = false;
            },
            onBeforeUploadItem: function onBeforeUploadItem(item) {

                $scope.sendForm.$setSubmitted();
                var size = item.file.size;
                self.coverError = null;
                if (size >= 2 * 1024 * 1024) {
                    self.uploader.cancelItem(item);
                    self.coverError = self.tranlsteFilter('page-original-text059');
                    return;
                }
                var type = item.file.type;
                if (["image/png", "image/jpeg", "image/bmp"].indexOf(type) == -1) {
                    self.uploader.cancelItem(item);
                    self.coverError = self.tranlsteFilter('page-original-text060');
                    return;
                }
                var fileSuffix = self.getSuffix(item.file.name);
                var filename = Date.now() + '_' + Math.floor(Math.random() * 1000);

                currentImageFilename = self.imageUploadPolicy['key'] + filename + fileSuffix;
                item.url = self.imageUploadPolicy['host'];
                item.formData = [{
                    'key': currentImageFilename
                }, {
                    'policy': self.imageUploadPolicy['policy']
                }, {
                    'OSSAccessKeyId': self.imageUploadPolicy['accessid']
                }, {
                    'success_action_status': '200'
                }, {
                    'callback': ''
                }, {
                    'signature': self.imageUploadPolicy['signature']
                }];
                self.uploading = true;
            }
        });
        this.getImageUploadPolicy();
    }

    (0, _createClass3.default)(PublishToMediaController, [{
        key: 'extractImage',
        value: function extractImage() {
            var $content = $('<div>' + this.original.content + '</div>');

            var $images = $content.find('img');

            if ($images.length == 0) {
                return '';
            }

            for (var i = 0, l = $images.length; i < l; i++) {
                var src = $($images[i]).attr('src');

                if (!/\.gif(\?.*)?/.test(src)) {
                    return src;
                }
            }

            return '';
        }
    }, {
        key: 'show',
        value: function show() {
            this.modal.open('publish-to-media-modal');
        }
    }, {
        key: 'send',
        value: function send(sendForm) {
            if (this.selectedMedias.length == 0) {
                this.emptyMedia = true;
            }
            sendForm.$setSubmitted();
            if (!sendForm.$valid) {
                return;
            }

            if (this.originalType == 'article' && this.formData.cover_image == '') {
                this.coverError = this.tranlsteFilter('modules-text018');
                return;
            }
            if (this.selectedMedias.length == 0) {
                return;
            }

            var self = this;
            this.formData.medias = this.selectedMedias;
            this.formData.options = this.mediaOptions;
            this.loading = true;

            this.$http.post(this.AppConfig.server_url + '/media/publish', this.formData, {
                withCredentials: true
            }).then(function () {
                self.loading = false;
                self.modal.close('publish-to-media-modal');
                self.message.success(self.tranlsteFilter('modules-text019'));
            }, function (response) {
                self.loading = false;
                self.modal.close('publish-to-media-modal');
                self.message.error(response.data);
            });
        }
    }, {
        key: 'getImageUploadPolicy',
        value: function getImageUploadPolicy() {

            var self = this;

            this.ArticleAPI.one('image').one('policy').get().then(function (policy) {
                self.imageUploadPolicy = policy;
            }, function (response) {
                self.message.error(response.data);
            });
        }
    }, {
        key: 'getSuffix',
        value: function getSuffix(filename) {
            var pos = filename.lastIndexOf('.');
            if (pos != -1) {
                return filename.substring(pos);
            }
            return '';
        }
    }, {
        key: 'selectMedia',
        value: function selectMedia(name) {
            if (!this.mediaAccount.mediaAccounts[name] || !this.mediaAccount.mediaAccounts[name]['access_token']) return;

            if (this.selectedMediaMap[name]) {
                var idx = this.selectedMedias.indexOf(name);
                this.selectedMedias.splice(idx, 1);
                delete this.selectedMediaMap[name];
            } else {
                this.selectedMedias.push(name);
                this.selectedMediaMap[name] = 1;
            }
        }
    }, {
        key: 'toggleOption',
        value: function toggleOption(media, option) {
            if (!this.selectedMediaMap[media]) return;

            this.mediaOptions[media][option] = !this.mediaOptions[media][option];
        }
    }, {
        key: 'gotoBind',
        value: function gotoBind() {
            this.modal.close('publish-to-media-modal');
            this.$state.go('app.home.profile.media');
        }
    }]);
    return PublishToMediaController;
}();

exports.default = PublishToMediaController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(769);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./publish-to-media.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./publish-to-media.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "publish-to-media {\n  display: inline-block; }\n  publish-to-media .cover-image {\n    position: relative;\n    height: 150px;\n    overflow: hidden; }\n    publish-to-media .cover-image .image {\n      position: relative;\n      width: 100%;\n      height: 100%;\n      background-color: #cfcfcf;\n      overflow: hidden; }\n      publish-to-media .cover-image .image img {\n        width: 100%;\n        height: 100%; }\n    publish-to-media .cover-image .mask {\n      position: absolute;\n      display: none;\n      z-index: 1;\n      top: 0;\n      left: 0;\n      bottom: 0;\n      right: 0;\n      text-align: center;\n      line-height: 150px;\n      background-color: rgba(0, 0, 0, 0.5);\n      color: #ffffff; }\n    publish-to-media .cover-image .uploading {\n      position: absolute;\n      z-index: 1000;\n      top: 0;\n      left: 0;\n      bottom: 0;\n      right: 0;\n      background-color: #ffffff;\n      line-height: 150px;\n      text-align: center; }\n    publish-to-media .cover-image:hover .mask {\n      display: block; }\n    publish-to-media .cover-image:hover .placeholder {\n      display: none; }\n    publish-to-media .cover-image input[type=\"file\"] {\n      position: absolute;\n      display: block;\n      z-index: 2;\n      width: 1000px;\n      height: 1000px;\n      left: -300px;\n      top: -300px;\n      opacity: 0;\n      cursor: pointer; }\n  publish-to-media .media-error-message {\n    position: relative;\n    height: 18px;\n    line-height: 18px;\n    color: #ff3333;\n    font-size: 14px; }\n  publish-to-media .input-group.digest .input {\n    margin-left: 0; }\n    publish-to-media .input-group.digest .input textarea {\n      width: 100%;\n      color: #999999;\n      height: 60px;\n      border: 1px solid #e8eaea; }\n  publish-to-media .content.image .input-group.digest {\n    margin-top: 0; }\n  publish-to-media .media-select {\n    position: relative;\n    border-top: 1px solid #e8eaea; }\n    publish-to-media .media-select .media-item {\n      position: relative;\n      height: 58px;\n      line-height: 58px;\n      padding-bottom: 6px;\n      border-bottom: 1px solid #e8eaea;\n      cursor: pointer; }\n      publish-to-media .media-select .media-item:last-child {\n        border-bottom: 0; }\n      publish-to-media .media-select .media-item .checkbox {\n        position: absolute;\n        width: 24px;\n        height: 58px;\n        left: 0;\n        top: 0;\n        font-size: 18px;\n        text-align: center; }\n        publish-to-media .media-select .media-item .checkbox .not-selected {\n          color: #cccccc; }\n        publish-to-media .media-select .media-item .checkbox .selected {\n          display: none;\n          color: #00816a; }\n      publish-to-media .media-select .media-item .name {\n        position: relative;\n        margin-left: 38px;\n        margin-right: 160px; }\n        publish-to-media .media-select .media-item .name .logo {\n          position: absolute;\n          width: 30px;\n          height: 30px;\n          top: 14px;\n          left: 0; }\n          publish-to-media .media-select .media-item .name .logo img {\n            display: block;\n            width: 100%;\n            height: 100%; }\n        publish-to-media .media-select .media-item .name .text {\n          position: relative;\n          margin-left: 50px;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          white-space: nowrap;\n          font-size: 14px;\n          color: #666666; }\n      publish-to-media .media-select .media-item .actions {\n        position: absolute;\n        width: 144px;\n        height: 58px;\n        top: 0;\n        right: 16px;\n        text-align: right;\n        font-size: 12px; }\n        publish-to-media .media-select .media-item .actions a {\n          text-decoration: none;\n          color: #00816a; }\n          publish-to-media .media-select .media-item .actions a:hover {\n            color: #00816a; }\n        publish-to-media .media-select .media-item .actions .option {\n          position: relative;\n          margin-left: 22px; }\n          publish-to-media .media-select .media-item .actions .option .option-checkbox {\n            position: absolute;\n            width: 20px;\n            height: 58px;\n            text-align: center;\n            font-size: 16px; }\n            publish-to-media .media-select .media-item .actions .option .option-checkbox .option-not-selected {\n              color: #cccccc; }\n            publish-to-media .media-select .media-item .actions .option .option-checkbox .option-selected {\n              display: none;\n              color: #00816a; }\n          publish-to-media .media-select .media-item .actions .option .option-name {\n            position: relative;\n            margin-left: 26px;\n            text-align: left;\n            color: #cccccc; }\n      publish-to-media .media-select .media-item.disabled {\n        cursor: default; }\n        publish-to-media .media-select .media-item.disabled .checkbox .not-selected {\n          color: #dddddd; }\n      publish-to-media .media-select .media-item.selected .checkbox .not-selected {\n        display: none; }\n      publish-to-media .media-select .media-item.selected .checkbox .selected {\n        display: inline; }\n      publish-to-media .media-select .media-item.selected .option .option-checkbox .option-not-selected {\n        color: #999999; }\n      publish-to-media .media-select .media-item.selected .option .option-name {\n        color: #999999; }\n      publish-to-media .media-select .media-item.selected .option:hover .option-name {\n        color: #00816a; }\n      publish-to-media .media-select .media-item.selected .option.selected .option-checkbox .option-not-selected {\n        display: none; }\n      publish-to-media .media-select .media-item.selected .option.selected .option-checkbox .option-selected {\n        display: inline; }\n      publish-to-media .media-select .media-item:hover .name .text {\n        color: #00816a; }\n      publish-to-media .media-select .media-item.disabled:hover .name .text {\n        color: #666666; }\n", ""]);

// exports


/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(155);
var defined = __webpack_require__(154);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(356);
var descriptor = __webpack_require__(163);
var setToStringTag = __webpack_require__(118);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(64)(IteratorPrototype, __webpack_require__(32)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(72);
var anObject = __webpack_require__(51);
var getKeys = __webpack_require__(115);

module.exports = __webpack_require__(63) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(86);
var toObject = __webpack_require__(117);
var IE_PROTO = __webpack_require__(156)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(775);
var step = __webpack_require__(370);
var Iterators = __webpack_require__(82);
var toIObject = __webpack_require__(114);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(182)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 775 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _face = __webpack_require__(777);

var _face2 = _interopRequireDefault(_face);

var _faceHeader = __webpack_require__(782);

var _faceHeader2 = _interopRequireDefault(_faceHeader);

var _index = __webpack_require__(790);

var _index2 = _interopRequireDefault(_index);

var _authors = __webpack_require__(846);

var _authors2 = _interopRequireDefault(_authors);

var _medias = __webpack_require__(859);

var _medias2 = _interopRequireDefault(_medias);

var _consumers = __webpack_require__(888);

var _consumers2 = _interopRequireDefault(_consumers);

var _plugin = __webpack_require__(897);

var _plugin2 = _interopRequireDefault(_plugin);

var _newsCenter = __webpack_require__(920);

var _newsCenter2 = _interopRequireDefault(_newsCenter);

var _dataSmart = __webpack_require__(927);

var _dataSmart2 = _interopRequireDefault(_dataSmart);

var _pricing = __webpack_require__(942);

var _pricing2 = _interopRequireDefault(_pricing);

var _partners = __webpack_require__(951);

var _partners2 = _interopRequireDefault(_partners);

var _solutions = __webpack_require__(967);

var _solutions2 = _interopRequireDefault(_solutions);

var _cooperation = __webpack_require__(985);

var _cooperation2 = _interopRequireDefault(_cooperation);

var _application = __webpack_require__(994);

var _application2 = _interopRequireDefault(_application);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var childModules = [_index2.default, _faceHeader2.default, _authors2.default, _medias2.default, _consumers2.default, _plugin2.default, _newsCenter2.default, _dataSmart2.default, _pricing2.default, _partners2.default, _solutions2.default, _cooperation2.default, _application2.default];

var states = [{
    name: 'face',
    abstract: true,
    component: 'face'
}];

var childModuleNames = [];

childModules.forEach(function (m) {
    childModuleNames.push(m.name);

    m.states.forEach(function (s) {

        s.name = 'face.' + s.name;

        states.push(s);
    });
});

var faceModule = _angular2.default.module('face', childModuleNames).component('face', _face2.default).name;

exports.default = { name: faceModule, states: states };

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _face = __webpack_require__(778);

var _face2 = _interopRequireDefault(_face);

var _face3 = __webpack_require__(779);

var _face4 = _interopRequireDefault(_face3);

__webpack_require__(780);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var faceComponent = {
    restrict: 'E',
    bindings: {
        appUser: '='
    },
    template: _face2.default,
    controller: _face4.default
};

exports.default = faceComponent;

/***/ }),
/* 778 */
/***/ (function(module, exports) {

module.exports = "<div id=\"alert-message\" class=\"alert\"></div>\n<face-header app-user=\"$ctrl.appUser\" ng-class=\"$state.is('app.face.dataSmart') ? 'reverse':''\"></face-header>\n<div ui-view></div>\n<ybfooter></ybfooter>\n<language></language>\n";

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaceController = function FaceController($scope, $transitions, $state) {
    "ngInject";

    (0, _classCallCheck3.default)(this, FaceController);
    console.log("face");
    $scope.$state = $state;
    $transitions.onFinish({}, function () {
        $('body').scrollTop(0);
    });
};

FaceController.$inject = ["$scope", "$transitions", "$state"];
exports.default = FaceController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(781);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./face.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./face.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".face-form {\n  position: absolute;\n  top: 58px;\n  bottom: 14px;\n  right: 28px;\n  left: 28px; }\n  .face-form .input-group {\n    position: relative;\n    margin-top: 12px; }\n    .face-form .input-group .input {\n      position: relative;\n      padding-bottom: 6px;\n      border-bottom: 1px solid #dadedd;\n      height: 30px; }\n      .face-form .input-group .input .icon {\n        position: absolute;\n        width: 30px;\n        height: 30px;\n        left: 0;\n        top: 0;\n        font-size: 16px;\n        line-height: 30px;\n        text-align: center;\n        color: #999999; }\n      .face-form .input-group .input .wrapper {\n        position: relative;\n        margin-left: 36px;\n        outline: none;\n        border: 0;\n        height: 30px; }\n        .face-form .input-group .input .wrapper input {\n          position: relative;\n          display: block;\n          width: 100%;\n          height: 29px;\n          margin: 0;\n          padding: 0;\n          outline: none;\n          border: 0;\n          background: none;\n          color: #222222;\n          font-size: 14px; }\n        .face-form .input-group .input .wrapper [class*=yb-eye] {\n          position: absolute;\n          right: 12px;\n          top: 7px;\n          color: #999;\n          z-index: 10; }\n    .face-form .input-group.captcha .input {\n      width: 50%; }\n    .face-form .input-group.captcha .captcha-image {\n      position: absolute;\n      right: 0;\n      top: 0;\n      width: 120px;\n      height: 36px; }\n    .face-form .input-group .error-message {\n      height: 20px; }\n    .face-form .input-group.active .input {\n      border-color: #00816a; }\n      .face-form .input-group.active .input .icon {\n        color: #00816a; }\n    .face-form .input-group.active.error .input,\n    .face-form .input-group.error .input {\n      border-color: #ff3333; }\n      .face-form .input-group.active.error .input .icon,\n      .face-form .input-group.error .input .icon {\n        color: #ff3333; }\n    .face-form .input-group.error .error-message {\n      font-size: 14px;\n      color: #ff3333;\n      margin-left: 6px; }\n  .face-form .submit-group {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%; }\n    .face-form .submit-group .wrapper {\n      position: relative;\n      height: 46px; }\n      .face-form .submit-group .wrapper .btn {\n        position: relative;\n        display: block;\n        width: 100%;\n        height: 100%;\n        font-size: 18px;\n        border-radius: 3px;\n        background-color: #32d182;\n        border-color: #32d182;\n        color: #ffffff; }\n        .face-form .submit-group .wrapper .btn:hover {\n          background-color: #37d687;\n          border-color: #37d687; }\n        .face-form .submit-group .wrapper .btn:active {\n          background-color: #2cca7b;\n          border-color: #2cca7b; }\n        .face-form .submit-group .wrapper .btn:disabled {\n          background-color: #cfcfcf;\n          border-color: #cfcfcf; }\n    .face-form .submit-group .options {\n      position: relative;\n      margin-top: 12px;\n      font-size: 14px;\n      color: #999999;\n      height: 20px; }\n      .face-form .submit-group .options a {\n        color: #cccccc;\n        text-decoration: none; }\n        .face-form .submit-group .options a:hover {\n          color: #00816a; }\n        .face-form .submit-group .options a.highlight {\n          color: #00816a; }\n          .face-form .submit-group .options a.highlight:hover {\n            text-decoration: underline; }\n      .face-form .submit-group .options label {\n        position: relative;\n        display: block;\n        height: 16px;\n        line-height: 16px;\n        cursor: pointer; }\n        .face-form .submit-group .options label .checkbox {\n          position: absolute;\n          width: 16px;\n          height: 16px;\n          left: 2px;\n          top: 0;\n          font-size: 16px; }\n          .face-form .submit-group .options label .checkbox .yb-select {\n            display: none;\n            color: #32d182; }\n          .face-form .submit-group .options label .checkbox .yb-box {\n            color: #dadedd; }\n          .face-form .submit-group .options label .checkbox.checked .yb-box {\n            display: none; }\n          .face-form .submit-group .options label .checkbox.checked .yb-select {\n            display: inline; }\n        .face-form .submit-group .options label .text {\n          margin-left: 22px; }\n  @media only screen and (max-width: 767px) {\n    .face-form .submit-group .options {\n      font-size: 12px; } }\n\nface {\n  position: relative;\n  display: block;\n  /* Large Devices, Desktops */ }\n  face .headline {\n    position: relative;\n    height: 602px;\n    background: #00816a;\n    background: linear-gradient(180deg, #00816a, #00816a 50%, #1db177); }\n    face .headline .bg {\n      position: absolute;\n      left: 0;\n      right: 0;\n      top: 0;\n      bottom: 0;\n      opacity: 0.7;\n      z-index: 1; }\n    face .headline .content {\n      position: relative;\n      height: 100%;\n      z-index: 2;\n      padding-top: 160px; }\n      face .headline .content > .text {\n        font-size: 36px;\n        color: #ffffff;\n        text-align: center;\n        margin-top: 16px; }\n      face .headline .content > .description {\n        text-align: center;\n        margin-top: 48px;\n        color: #ffffff;\n        font-size: 18px; }\n        face .headline .content > .description .line {\n          margin-top: 10px; }\n      face .headline .content .mobile-logo {\n        display: none;\n        position: relative;\n        width: 100px;\n        margin: 0 auto 38px; }\n        face .headline .content .mobile-logo svg {\n          fill: #ffffff; }\n      face .headline .content .main-btn-wrapper {\n        margin-top: 140px;\n        text-align: center; }\n    face .headline .main-btn {\n      background-color: #32d182;\n      color: #ffffff;\n      padding: 12px 60px;\n      border-radius: 27px;\n      font-size: 16px;\n      text-decoration: none;\n      border: 0;\n      cursor: pointer; }\n      face .headline .main-btn:hover {\n        background-color: #37d687; }\n      face .headline .main-btn:active {\n        background-color: #2cca7b; }\n      face .headline .main-btn:disabled {\n        background-color: #cfcfcf; }\n  @media only screen and (min-width: 1200px) {\n    face .container {\n      width: 1000px; } }\n  @media only screen and (max-width: 991px) {\n    face .headline {\n      height: 540px; }\n      face .headline .content {\n        padding-top: 140px; }\n        face .headline .content > .text {\n          font-size: 30px; }\n        face .headline .content > .description {\n          font-size: 16px; } }\n  @media only screen and (max-width: 767px) {\n    face .headline .content {\n      padding: 100px 16px 0; }\n      face .headline .content.with-mobile-logo {\n        padding-top: 30px; }\n      face .headline .content > .text {\n        font-size: 24px; }\n      face .headline .content > .description {\n        padding: 0 24px;\n        font-size: 14px; }\n      face .headline .content .mobile-logo {\n        display: block; } }\n", ""]);

// exports


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _faceHeader = __webpack_require__(783);

var _faceHeader2 = _interopRequireDefault(_faceHeader);

var _sideNavMaskControl = __webpack_require__(788);

var _sideNavMaskControl2 = _interopRequireDefault(_sideNavMaskControl);

var _sideNavControl = __webpack_require__(789);

var _sideNavControl2 = _interopRequireDefault(_sideNavControl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var faceHeaderModule = _angular2.default.module('faceHeader', []).component('faceHeader', _faceHeader2.default).directive('sideNavMaskControl', _sideNavMaskControl2.default).directive('sideNavControl', _sideNavControl2.default).name;

var states = [];

exports.default = { name: faceHeaderModule, states: states };

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _faceHeader = __webpack_require__(784);

var _faceHeader2 = _interopRequireDefault(_faceHeader);

var _faceHeader3 = __webpack_require__(785);

var _faceHeader4 = _interopRequireDefault(_faceHeader3);

__webpack_require__(786);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var faceHeaderComponent = {
    restrict: 'E',
    bindings: {
        appUser: '='
    },
    template: _faceHeader2.default,
    controller: _faceHeader4.default
};

exports.default = faceHeaderComponent;

/***/ }),
/* 784 */
/***/ (function(module, exports) {

module.exports = "<div class=\"container face-header\">\n    <a class=\"logo\" ui-sref=\"app.face.index.frontpage\">\n        <logo></logo>\n    </a>\n    <div class=\"hamburger\" ng-click=\"$ctrl.showSideNav()\">\n        <span class=\"ybicon yb-hamburger\"></span>\n    </div>\n    <div class=\"links\" ng-if=\"!$state.is('app.face.cooperation')&&!$state.is('app.face.application')\">\n        <div ng-class=\"{link: true, nav: true, active: $state.is('app.face.index.frontpage')}\">\n            <a ui-sref=\"app.face.index.frontpage\" translate=\"face-header-text001\"></a>\n        </div>\n        <div ng-class=\"{link: true, nav: true, active: $state.is('app.face.dataSmart')}\">\n            <a ui-sref=\"app.face.dataSmart\" translate=\"face-data-smart-text001\"></a>\n        </div>\n        <div ng-class=\"{link: true, nav: true, active: $state.is('app.face.solutions')}\">\n            <a ui-sref=\"app.face.solutions\"  translate=\"face-solutions-text01\"></a>\n        </div>\n\n        <div ng-class=\"{link: true, nav: true, active: false}\">\n            <a href=\"https://www.yuanbenlian.com/\" target=\"_blank\" translate=\"face-header-text0011\"></a>\n        </div>\n        <div ng-class=\"{link: true, nav: true, active: $state.is('app.face.partners')}\">\n            <a ui-sref=\"app.face.partners\" translate=\"face-partners-text01\"></a>\n        </div>\n\n\n        <!-- 修改文档编码-->\n        <!--<div ng-class=\"{link: true, nav: true, active: $state.is('app.face.medias')}\">-->\n            <!--<a ui-sref=\"app.face.medias\" translate=\"face-header-text002\"></a>-->\n        <!--</div>-->\n        <!--<div ng-class=\"{link: true, nav: true, active: $state.is('app.face.authors')}\">-->\n            <!--<a ui-sref=\"app.face.authors\" translate=\"face-header-text003\"></a>-->\n        <!--</div>-->\n        <!--<div ng-class=\"{link: true, nav: true, active: $state.is('app.face.consumers')}\">-->\n            <!--<a ui-sref=\"app.face.consumers\" translate=\"face-header-text004\"></a>-->\n        <!--</div>-->\n        <!--<div ng-class=\"{link: true, nav: true, 'coming-soon': true, active: $state.is('app.face.governments')}\">-->\n            <!--<a href=\"javascript:void(0)\" class=\"text\" translate=\"face-header-text005\"></a>-->\n            <!--<span class=\"coming-soon\" translate=\"face-header-text006\"></span>-->\n        <!--</div>-->\n        <div ng-class=\"{link: true, nav: true, active: $state.is('app.face.newsCenter')}\">\n            <a ui-sref=\"app.face.newsCenter\" translate=\"face-header-text013\"></a>\n         </div>\n        <div class=\"tab_box\">\n              <div class=\"link search-link\" title=\"{{'face-header-text007' | translate}}\">\n                  <a ui-sref=\"app.page.search\" target=\"_blank\">\n                      <i class=\"ybicon yb-search\"></i>\n                  </a>\n              </div>\n              <div class=\"link verify-dna\" title=\"{{'face-header-text008' | translate}}\">\n                  <a ui-sref=\"app.page.verify.main.tsa.form\" target=\"_blank\">\n                      <i class=\"ybicon yb-verify-dna\"></i>\n                  </a>\n              </div>\n              <div ng-class=\"{active: $state.is('app.face.plugin'), link: true, 'yb-plugin': true}\" title=\"{{'face-header-text009' | translate}}\">\n                  <a ui-sref=\"app.face.plugin\" target=\"_blank\">\n                      {{'face-header-text009' | translate}}\n                  </a>\n              </div>\n              <div class=\"link user-btn user-login-btn\" ng-if=\"!$ctrl.appUser.id || $ctrl.appUser.email_verified != 1\">\n                  <a ui-sref=\"app.face.index.user.form.login\" translate=\"face-header-text010\"></a>\n              </div>\n              <div class=\"link user-btn\" ng-if=\"!$ctrl.appUser.id || $ctrl.appUser.email_verified != 1\">\n                  <a ui-sref=\"app.face.index.user.form.register\" translate=\"face-header-text011\"></a>\n              </div>\n              <div class=\"link profile\" ng-if=\"$ctrl.appUser.id && $ctrl.appUser.email_verified == 1\">\n                  <a ng-click=\"$ctrl.goInHome('app.home.dashboard')\">\n                              <span class=\"image\">\n                                  <img ng-src=\"{{$ctrl.appUser.avatar}}\"/>\n                              </span>\n                      <span class=\"text\" translate=\"face-header-text012\"></span>\n                  </a>\n              </div>\n        </div>\n    </div>\n</div>\n<div class=\"mobile-side-nav-mask\" side-nav-mask-control></div>\n<div class=\"mobile-side-nav\" side-nav-control>\n    <div class=\"side-nav-logo\">\n        <logo></logo>\n    </div>\n\n    <a ng-class=\"{nav: true, active: $state.is('app.face.index.frontpage')}\" ui-sref=\"app.face.index.frontpage\" translate=\"face-header-text001\">\n   </a>\n   <a ng-class=\"{nav: true, active: $state.is('app.face.dataSmart')}\" ui-sref=\"app.face.dataSmart\" translate=\"face-data-smart-text001\">\n   <a ng-class=\"{nav: true, active: $state.is('app.face.solutions')}\" ui-sref=\"app.face.solutions\" translate=\"face-solutions-text01\">\n      <a ng-class=\"{nav: true, active:false}\" href=\"https://www.yuanbenlian.com/\" target=\"_blank\" translate=\"face-header-text0011\"></a>\n    </a>\n    <a ng-class=\"{nav: true, active: $state.is('app.face.partners')}\" ui-sref=\"app.face.partners\" translate=\"face-partners-text01\">\n    </a>\n    <!--<a ng-class=\"{nav: true, active: $state.is('app.face.medias')}\" ui-sref=\"app.face.medias\" translate=\"face-header-text002\">-->\n    <!--</a>-->\n    <!--<a ng-class=\"{nav: true, active: $state.is('app.face.authors')}\" ui-sref=\"app.face.authors\" translate=\"face-header-text003\">-->\n    <!--</a>-->\n    <!--<a ng-class=\"{nav: true, active: $state.is('app.face.consumers')}\" ui-sref=\"app.face.consumers\" translate=\"face-header-text004\">-->\n    <!--</a>-->\n    <a ng-class=\"{nav: true, active: $state.is('app.face.newsCenter')}\" ui-sref=\"app.face.newsCenter\" translate=\"face-header-text013\">\n    </a>\n    <!--<a ng-class=\"{nav: true, 'coming-soon': true, active: $state.is('app.face.governments')}\" href=\"javascript:void(0)\">-->\n        <!--<span class=\"text\" translate=\"face-header-text005\"></span>-->\n        <!--<span class=\"coming-soon\" translate=\"face-header-text006\"></span>-->\n    <!--</a>-->\n    <div class=\"nav\">\n        <div class=\"btn-group\">\n            <button class=\"btn btn-default\" ng-class=\"{active: $ctrl.cur_lang === 'zh-CN' }\" ng-click=\"$ctrl.switching('zh-CN')\">中</button>\n            <button class=\"btn btn-default\" ng-class=\"{active: $ctrl.cur_lang === 'en' }\" ng-click=\"$ctrl.switching('en')\">en</button>\n        </div>\n    </div>\n</div>\n\n";

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = __webpack_require__(49);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaceHeaderController = function () {
    FaceHeaderController.$inject = ["$scope", "$state", "$translate", "Jurisdiction"];

    function FaceHeaderController($scope, $state, $translate, Jurisdiction) {
        "ngInject";

        (0, _classCallCheck3.default)(this, FaceHeaderController);
        $scope.$state = $state;
        this.$state = $state;
        this.$translate = $translate;
        this.Jurisdiction = Jurisdiction;
        this.cur_lang = window.localStorage.yuanben_lang;
        this.permission = JSON.parse(window.localStorage.getItem("loginUser"));
    }

    (0, _createClass3.default)(FaceHeaderController, [{
        key: "showSideNav",
        value: function showSideNav() {
            // $('body').addClass('no-scroll');
            $('.mobile-side-nav').addClass('active');
            $('.mobile-side-nav-mask').addClass('active');
        }
    }, {
        key: "switching",
        value: function switching(lang) {
            this.$translate.use(lang);
            window.localStorage.yuanben_lang = lang;
            location.reload();
        }
    }, {
        key: "goInHome",
        value: function goInHome(route) {
            var params = (0, _assign2.default)(this.permission, { route_name: route, checkType: "redirect_route" });
            var Identity = this.Jurisdiction.checkStatus(params);
            if (Identity.status || Identity == "admin" || Identity == 2) {
                this.$state.go(route);
            } else {
                this.$state.go(Identity.path);
            }
        }
    }]);
    return FaceHeaderController;
}();

exports.default = FaceHeaderController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(787);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./face-header.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./face-header.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "face-header {\n  position: absolute;\n  padding-top: 18px;\n  height: 66px;\n  top: 0;\n  z-index: 3;\n  left: 50%;\n  transform: translate3d(-50%, 0, 0);\n  -webkit-transform: translate3d(-50%, 0, 0);\n  -moz-transform: translate3d(-50%, 0, 0);\n  -ms-transform: translate3d(-50%, 0, 0);\n  display: block; }\n  face-header.reverse {\n    width: 100%;\n    background-color: #051e47;\n    height: 82px; }\n    @media only screen and (max-width: 991px) {\n      face-header.reverse {\n        height: 60px; } }\n  face-header .container {\n    width: 1300px; }\n  face-header .logo {\n    position: relative;\n    display: block;\n    text-decoration: none;\n    width: 90px; }\n    face-header .logo logo {\n      display: block;\n      padding-top: 6px; }\n      face-header .logo logo svg {\n        height: 32px;\n        fill: #ffffff; }\n  face-header .hamburger {\n    display: none;\n    position: absolute;\n    width: 100px;\n    height: 40px;\n    top: 0;\n    left: 0;\n    padding-top: 12px;\n    padding-left: 16px;\n    color: #ffffff;\n    font-size: 24px; }\n  face-header .links {\n    max-width: 1100px;\n    position: absolute;\n    right: 0;\n    left: 100px;\n    top: 0;\n    height: 48px;\n    font-size: 18px;\n    vertical-align: middle; }\n    face-header .links .tab_box {\n      float: right; }\n    face-header .links .link {\n      position: relative;\n      float: left;\n      margin: 0 15px;\n      height: 48px;\n      line-height: 48px; }\n      face-header .links .link a {\n        color: rgba(255, 255, 255, 0.7);\n        text-decoration: none;\n        cursor: pointer; }\n        face-header .links .link a i {\n          font-size: 20px; }\n      face-header .links .link.verify-dna a,\n      face-header .links .link.active a,\n      face-header .links .link.yb-plugin a,\n      face-header .links .link.search-link a,\n      face-header .links .link:hover a {\n        color: #ffffff; }\n      face-header .links .link.active {\n        border-bottom: 2px solid #ffffff; }\n      face-header .links .link.search-link {\n        margin: 0 15px 0 0;\n        font-size: 22px; }\n      face-header .links .link.verify-dna {\n        margin: 0 15px;\n        font-size: 22px; }\n      face-header .links .link.yb-plugin {\n        margin: 0 15px;\n        font-size: 18px;\n        line-height: 50px; }\n      face-header .links .link.user-btn {\n        margin: 0 6px; }\n        face-header .links .link.user-btn.user-login-btn {\n          margin-left: 20px; }\n        face-header .links .link.user-btn a {\n          font-size: 16px;\n          border: 1px solid rgba(255, 255, 255, 0.7);\n          border-radius: 2px;\n          padding: 2px 10px 4px;\n          color: rgba(255, 255, 255, 0.7); }\n      face-header .links .link.user-btn:hover a {\n        border-color: #ffffff;\n        color: #ffffff; }\n      face-header .links .link.profile {\n        margin-left: 20px;\n        width: 120px; }\n        face-header .links .link.profile a {\n          display: block; }\n          face-header .links .link.profile a .text {\n            display: inline-block;\n            width: 80px;\n            height: 100%; }\n        face-header .links .link.profile:hover {\n          border: 0; }\n          face-header .links .link.profile:hover .text {\n            border-bottom: 1px solid #ffffff; }\n        face-header .links .link.profile .image {\n          position: absolute;\n          width: 36px;\n          height: 36px;\n          left: 4px;\n          top: 6px;\n          border-radius: 18px;\n          overflow: hidden;\n          border: 1px solid rgba(255, 255, 255, 0.6); }\n          face-header .links .link.profile .image img {\n            display: block;\n            width: 36px;\n            height: 36px;\n            position: absolute;\n            left: -1px;\n            top: -1px; }\n        face-header .links .link.profile .text {\n          position: relative;\n          margin-left: 48px; }\n      face-header .links .link .coming-soon {\n        display: none; }\n      face-header .links .link.coming-soon:hover .text {\n        display: none; }\n      face-header .links .link.coming-soon:hover .coming-soon {\n        display: inline;\n        color: #ffffff;\n        cursor: default; }\n  face-header .mobile-side-nav-mask {\n    position: fixed;\n    display: none;\n    width: 100%;\n    height: 1000px;\n    top: 0;\n    left: 0;\n    background-color: rgba(0, 0, 0, 0.7);\n    z-index: 1000000; }\n    face-header .mobile-side-nav-mask.active {\n      display: block; }\n  face-header .mobile-side-nav {\n    position: fixed;\n    display: none;\n    width: 180px;\n    height: 1000px;\n    left: -180px;\n    top: 0;\n    background-color: #ffffff;\n    padding-top: 20px;\n    z-index: 1000001;\n    transition: left .3s ease-in-out; }\n    face-header .mobile-side-nav.active {\n      left: 0; }\n    face-header .mobile-side-nav .side-nav-logo {\n      width: 90px;\n      margin: 0 auto 20px; }\n      face-header .mobile-side-nav .side-nav-logo svg {\n        fill: #222222; }\n    face-header .mobile-side-nav .nav {\n      position: relative;\n      display: block;\n      height: 60px;\n      line-height: 60px;\n      text-align: center;\n      border-top: 1px solid #e8eaea;\n      text-decoration: none;\n      color: #222222; }\n      face-header .mobile-side-nav .nav.active {\n        color: #00816a; }\n      face-header .mobile-side-nav .nav .coming-soon {\n        display: none; }\n      face-header .mobile-side-nav .nav.coming-soon:hover .text {\n        display: none; }\n      face-header .mobile-side-nav .nav.coming-soon:hover .coming-soon {\n        display: inline; }\n  @media only screen and (max-width: 991px) and (min-width: 768px) {\n    face-header face-header .container .links {\n      left: 100px;\n      font-size: 16px; }\n      face-header face-header .container .links .link {\n        margin: 0 8px; } }\n  @media only screen and (max-width: 767px) {\n    face-header .container {\n      width: auto; }\n    face-header {\n      padding-top: 8px;\n      width: 100%; }\n    face-header .hamburger {\n      display: block; }\n    face-header .logo {\n      display: none; }\n    face-header .links {\n      right: 10px; }\n      face-header .links .link {\n        margin: 0 0 0 15px !important; }\n        face-header .links .link.user-btn {\n          margin-left: 15px !important; }\n      face-header .links .link.profile {\n        margin-left: 25px !important;\n        margin-right: 0 !important;\n        width: 46px;\n        overflow: hidden; }\n      face-header .links .link.nav {\n        display: none; }\n      face-header .links .link.user-btn a {\n        font-size: 14px;\n        padding: 2px 6px 2px; }\n    face-header .mobile-side-nav {\n      display: block; } }\n", ""]);

// exports


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

/**
 * Created by ganlu on 24/03/2017.
 */
exports.default = function () {
    return function (scope, elem) {
        elem.on('click touchstart', function (e) {
            elem.removeClass('active');
            $('.mobile-side-nav').removeClass('active');
            $('body').removeClass('no-scroll');
            e.stopPropagation();
        });
    };
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

/**
 * Created by ganlu on 24/03/2017.
 */
exports.default = function () {
    return function (scope, elem) {
        elem.on('click', '.nav', function (e) {

            if ($(e.target).hasClass('coming-soon')) {
                return;
            }

            elem.removeClass('active');
            $('.mobile-side-nav-mask').removeClass('active');
            $('body').removeClass('no-scroll');
        });
    };
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _index = __webpack_require__(791);

var _index2 = _interopRequireDefault(_index);

var _frontpage = __webpack_require__(827);

var _frontpage2 = _interopRequireDefault(_frontpage);

var _user = __webpack_require__(368);

var _user2 = _interopRequireDefault(_user);

var _videoControl = __webpack_require__(845);

var _videoControl2 = _interopRequireDefault(_videoControl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var childModules = [_frontpage2.default, _user2.default];

var states = [{
    name: 'index',
    abstract: true,
    component: 'index'
}];

var childModuleNames = [];

childModules.forEach(function (m) {
    childModuleNames.push(m.name);

    m.states.forEach(function (s) {

        s.name = 'index.' + s.name;

        states.push(s);
    });
});

var indexModule = _angular2.default.module('index', childModuleNames).component('index', _index2.default).directive('videoControl', _videoControl2.default).name;

exports.default = { name: indexModule, states: states };

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _index = __webpack_require__(792);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(820);

var _index4 = _interopRequireDefault(_index3);

__webpack_require__(823);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var indexComponent = {
    restrict: 'E',
    bindings: {
        appUser: '='
    },
    template: _index2.default,
    controller: _index4.default
};

exports.default = indexComponent;

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<div class=\"headline\" ui-view></div>\n<div class=\"section statistics\">\n   <div class=\"container\">\n      <div class=\"item\" ng-repeat=\"item in $ctrl.statistics\">\n         <div class=\"text\">{{item.text | translate}}</div>\n         <div class=\"value\">{{item.value | translate}}<span class=\"sup\"><em>+</em><span\n                  class=\"per\">{{item.per | translate}}</span></span></div>\n      </div>\n   </div>\n</div>\n<div class=\"customers section\">\n   <div class=\"container\">\n      <div class=\"title\" translate=\"face-index-text001\"></div>\n      <div class=\"content\">\n         <a class=\"customer\" ui-sref=\"app.face.medias\">\n            <div class=\"name\" translate=\"face-index-text002\"></div>\n            <div class=\"image\">\n               <img src=\"" + __webpack_require__(793) + "\" />\n            </div>\n            <div class=\"description\" translate=\"face-index-text003\">\n            </div>\n         </a>\n         <a class=\"customer\" ui-sref=\"app.face.authors\">\n            <div class=\"name\" translate=\"face-index-text004\"></div>\n            <div class=\"image\">\n               <img src=\"" + __webpack_require__(794) + "\" />\n            </div>\n            <div class=\"description\" translate=\"face-index-text005\">\n            </div>\n         </a>\n         <a class=\"customer\" ui-sref=\"app.face.consumers\">\n            <div class=\"name\" translate=\"face-index-text006\"></div>\n            <div class=\"image\">\n               <img src=\"" + __webpack_require__(795) + "\" />\n            </div>\n            <div class=\"description\" translate=\"face-index-text007\">\n            </div>\n         </a>\n         <a class=\"customer\" ui-sref=\"app.face.governments\">\n            <div class=\"coming-soon\" translate=\"face-index-text008\">\n            </div>\n            <div class=\"name\" translate=\"face-index-text009\"></div>\n            <div class=\"image\">\n               <img src=\"" + __webpack_require__(796) + "\" />\n            </div>\n            <div class=\"description\" translate=\"face-index-text010\">\n            </div>\n         </a>\n      </div>\n   </div>\n</div>\n<div class=\"section advantage\">\n   <div class=\"container\">\n      <div class=\"title\" translate=\"face-index-text046\"></div>\n   </div>\n   <div class=\"item\">\n      <div class=\"clearfix container right\">\n         <div class=\"image\">\n            <img src=\"" + __webpack_require__(797) + "\" />\n         </div>\n         <div class=\"text\">\n            <div class=\"heading\" translate=\"face-index-text047\"></div>\n            <div class=\"heading\" translate=\"face-index-text048\"></div>\n            <div class=\"description\" translate=\"face-index-text049\">\n            </div>\n         </div>\n      </div>\n   </div>\n   <div class=\"item\">\n      <div class=\"clearfix container left\">\n         <div class=\"image\">\n            <img src=\"" + __webpack_require__(798) + "\" />\n         </div>\n         <div class=\"text\">\n            <div class=\"heading\" translate=\"face-index-text050\">\n            </div>\n            <div class=\"description\" translate=\"face-index-text051\">\n            </div>\n            <div class=\"description\" translate=\"face-index-text052\">\n            </div>\n            <a ui-sref=\"app.page.verify.main.tsa\" target=\"_blank\" class=\"link\" translate=\"face-index-text053\"></a>\n         </div>\n\n\n      </div>\n   </div>\n</div>\n<div class=\"section feature\">\n   <div class=\"container\">\n      <div class=\"title\" translate=\"face-index-text011\"></div>\n   </div>\n\n   <div class=\"item\">\n      <div class=\"clearfix container right\">\n         <div class=\"image\">\n            <img src=\"" + __webpack_require__(799) + "\" />\n         </div>\n         <div class=\"text\">\n            <div class=\"sub-title\" translate=\"face-index-text012\"></div>\n            <div class=\"heading\" translate=\"face-index-text013\"></div>\n            <div class=\"description\" translate=\"face-index-text014\">\n            </div>\n            <div class=\"description\" translate=\"face-index-text015\">\n            </div>\n            <a href=\"https://yuanbenlian.com/\" target=\"_blank\" class=\"yuanbenlian\" translate=\"face-index-text016\"></a>\n         </div>\n      </div>\n   </div>\n   <div class=\"item\">\n      <div class=\"clearfix container left\">\n         <div class=\"image\">\n            <img src=\"" + __webpack_require__(800) + "\" />\n         </div>\n         <div class=\"text\">\n            <div class=\"sub-title\" translate=\"face-index-text017\"></div>\n            <div class=\"heading\" translate=\"face-index-text018\"></div>\n            <div class=\"description\" translate=\"face-index-text019\">\n            </div>\n            <div class=\"description\" translate=\"face-index-text020\">\n            </div>\n         </div>\n\n\n      </div>\n   </div>\n   <div class=\"item\">\n      <div class=\"clearfix container right\">\n         <div class=\"image\">\n            <img src=\"" + __webpack_require__(801) + "\" />\n         </div>\n         <div class=\"text\">\n            <div class=\"sub-title\" translate=\"face-index-text021\"></div>\n            <div class=\"heading\" translate=\"face-index-text022\"></div>\n            <div class=\"description\" translate=\"face-index-text023\">\n            </div>\n            <div class=\"description\">\n               • {{'face-index-text024' | translate}}<br>\n               • {{'face-index-text025' | translate}}<br>\n               • {{'face-index-text026' | translate}}\n            </div>\n         </div>\n\n\n      </div>\n   </div>\n   <div class=\"item\">\n      <div class=\"clearfix container left\">\n         <div class=\"image\">\n            <img src=\"" + __webpack_require__(802) + "\" />\n         </div>\n         <div class=\"text\">\n            <div class=\"sub-title\" translate=\"face-index-text027\"></div>\n            <div class=\"heading\" translate=\"face-index-text028\"></div>\n            <div class=\"description\" translate=\"face-index-text029\">\n            </div>\n            <div class=\"description\" translate=\"face-index-text030\">\n            </div>\n         </div>\n      </div>\n   </div>\n</div>\n\n<div class=\"quickly-understand section\">\n   <div class=\"container\">\n      <div class=\"title\" translate=\"face-index-text031\"></div>\n   </div>\n   <div class=\"video\" video-control>\n      <div class=\"play-btn\">\n         <img src=\"" + __webpack_require__(803) + "\" width=\"94\" height=\"94\" />\n      </div>\n      <video class=\"video-player\" src=\"https://yb-img.oss-cn-shanghai.aliyuncs.com/system/yuanben.mp4\"\n         poster=\"https://yb-img.oss-cn-shanghai.aliyuncs.com/system/poster.jpg\"></video>\n   </div>\n</div>\n<div class=\"highlights section\">\n   <div class=\"container\">\n      <div class=\"title\" translate=\"face-index-text032\"></div>\n      <div class=\"content\">\n         <div class=\"highlight\">\n            <div class=\"image\">\n               <img src=\"" + __webpack_require__(804) + "\" />\n            </div>\n            <div class=\"name\" translate=\"face-index-text033\"></div>\n            <div class=\"description\" translate=\"face-index-text034\">\n            </div>\n         </div>\n         <div class=\"highlight\">\n            <div class=\"image\">\n               <img src=\"" + __webpack_require__(805) + "\" />\n            </div>\n            <div class=\"name\" translate=\"face-index-text035\"></div>\n            <div class=\"description\" translate=\"face-index-text036\">\n            </div>\n         </div>\n         <div class=\"highlight\">\n            <div class=\"image\">\n               <img src=\"" + __webpack_require__(806) + "\" />\n            </div>\n            <div class=\"name\" translate=\"face-index-text037\"></div>\n            <div class=\"description\" translate=\"face-index-text038\">\n            </div>\n         </div>\n         <div class=\"highlight\">\n            <div class=\"image\">\n               <img src=\"" + __webpack_require__(807) + "\" />\n            </div>\n            <div class=\"name\" translate=\"face-index-text039\"></div>\n            <div class=\"description\" translate=\"face-index-text040\">\n            </div>\n         </div>\n      </div>\n   </div>\n</div>\n<div class=\"organizations section\">\n   <div class=\"container\">\n      <div class=\"title\" translate=\"face-index-text041\"></div>\n      <ul class=\"content\" rn-carousel rn-carousel-controls rn-carousel-controls-allow-loop\n\n         rn-carousel-locked=\"$ctrl.carousel.locked\" ng-mouseover=\"$ctrl.carousel.locked = true\"\n         ng-mouseleave=\"$ctrl.carousel.locked = false\">\n         <li >\n               <!-- <a href=\"{{item.href}}\" class=\"organization\" target=\"_blank\"\">\n                  <img src={{item.img_h}} class=\"inactive\" />\n                  <img src={{item.img_c}} class=\"active\" />\n               </a> -->\n               <!-- 人民政协报 -->\n               <a href=\"http://www.rmzxb.com.cn/index.shtml\" class=\"organization\" target=\"_blank\" >\n                  <img src=\"" + __webpack_require__(243) + "\" class=\"inactive\" />\n                  <img src=\"" + __webpack_require__(244) + "\" class=\"active\" />\n               </a>\n               <!-- 中国妇女网 -->\n               <a href=\"http://paper.cnwomen.com.cn\" class=\"organization\" target=\"_blank\" >\n                  <img src=\"" + __webpack_require__(808) + "\" class=\"inactive\" />\n                  <img src=\"" + __webpack_require__(809) + "\" class=\"active\" />\n               </a>\n               <!-- 中国教育报 -->\n               <a href=\"http://www.jyb.cn\" class=\"organization\" target=\"_blank\" >\n                  <img src=\"" + __webpack_require__(245) + "\" class=\"inactive\" />\n                  <img src=\"" + __webpack_require__(246) + "\" class=\"active\" />\n               </a>\n               <!-- 人民邮电报 -->\n               <a href=\"http://paper.cnii.com.cn\" class=\"organization\" target=\"_blank\" >\n                  <img src=\"" + __webpack_require__(810) + "\" class=\"inactive\" />\n                  <img src=\"" + __webpack_require__(811) + "\" class=\"active\" />\n               </a>\n\n\n               <!-- 中国建设报 -->\n               <a href=\"http://www.chinajsb.cn\" class=\"organization\" target=\"_blank\" >\n                  <img src=\"" + __webpack_require__(247) + "\" class=\"inactive\" />\n                  <img src=\"" + __webpack_require__(248) + "\" class=\"active\" />\n               </a>\n               <!-- 中国交通报 -->\n               <a href=\"http://www.zgjtb.com\" class=\"organization\" target=\"_blank\" >\n                  <img src=\"" + __webpack_require__(249) + "\" class=\"inactive\" />\n                  <img src=\"" + __webpack_require__(250) + "\" class=\"active\" />\n               </a>\n               <!-- 中国旅游报 -->\n               <a href=\"http://www.ctnews.com.cn\" class=\"organization\" target=\"_blank\">\n                  <img src=\"" + __webpack_require__(251) + "\" class=\"inactive\" />\n                  <img src=\"" + __webpack_require__(252) + "\" class=\"active\" />\n               </a>\n               <!-- 健康报网 -->\n               <a href=\"http://www.jkb.com.cn\" class=\"organization\" target=\"_blank\">\n                  <img src=\"" + __webpack_require__(253) + "\" class=\"inactive\" />\n                  <img src=\"" + __webpack_require__(254) + "\" class=\"active\" />\n               </a>\n\n\n\n\n               <!-- 金融时报 -->\n               <a href=\"http://www.financialnews.com.cn\" class=\"organization\" target=\"_blank\">\n                  <img src=\"" + __webpack_require__(255) + "\" class=\"inactive\" />\n                  <img src=\"" + __webpack_require__(256) + "\" class=\"active\" />\n               </a>\n               <!-- 中国审计报 -->\n               <a href=\"http://www.zgsjbs.com\" class=\"organization\" target=\"_blank\">\n                  <img src=\"" + __webpack_require__(257) + "\" class=\"inactive\" />\n                  <img src=\"" + __webpack_require__(258) + "\" class=\"active\" />\n               </a>\n               <!-- 中国财经媒体版权保护联盟 -->\n               <a href=\"https://fmcpa.org.cn\" class=\"organization\" target=\"_blank\">\n                  <img src=\"" + __webpack_require__(259) + "\" class=\"inactive\" />\n                  <img src=\"" + __webpack_require__(260) + "\" class=\"active\" />\n               </a>\n               <!-- 中国有色金属报 -->\n               <a href=\"https://www.cnmn.com.cn\" class=\"organization\" target=\"_blank\">\n                  <img src=\"" + __webpack_require__(261) + "\" class=\"inactive\" />\n                  <img src=\"" + __webpack_require__(262) + "\" class=\"active\" />\n               </a>\n\n\n\n\n               <!-- 中国信息报 -->\n               <a href=\"http://www.zgxxb.com.cn\" class=\"organization\" target=\"_blank\">\n                  <img src=\"" + __webpack_require__(812) + "\" class=\"inactive\" />\n                  <img src=\"" + __webpack_require__(813) + "\" class=\"active\" />\n               </a>\n               <!-- 中国冶金报 -->\n               <a href=\"http://www.csteelnews.com/\" class=\"organization\" target=\"_blank\">\n                  <img src=\"" + __webpack_require__(263) + "\" class=\"inactive\" />\n                  <img src=\"" + __webpack_require__(264) + "\" class=\"active\" />\n               </a>\n               <!-- 中国质量报 -->\n               <a href=\"http://www.cqn.com.cn\" class=\"organization\" target=\"_blank\">\n                  <img src=\"" + __webpack_require__(265) + "\" class=\"inactive\" />\n                  <img src=\"" + __webpack_require__(266) + "\" class=\"active\" />\n               </a>\n\n               <!-- 中国黄金报 -->\n               <a href=\"http://www.gold.org.cn\" class=\"organization\" target=\"_blank\">\n                  <img src=\"" + __webpack_require__(267) + "\" class=\"inactive\" />\n                  <img src=\"" + __webpack_require__(268) + "\" class=\"active\" />\n               </a>\n\n\n\n\n               \n\n\n\n\n\n\n`\n         </li>\n         <li >\n               <!-- 中国经营报 -->\n               <a href=\"http://www.cb.com.cn\" class=\"organization\" target=\"_blank\">\n                  <img src=\"" + __webpack_require__(269) + "\" class=\"inactive\" />\n                  <img src=\"" + __webpack_require__(270) + "\" class=\"active\" />\n               </a>\n               <!-- 中国保险报 -->\n               <a href=\"http://www.sinoins.com\" class=\"organization\" target=\"_blank\">\n                  <img src=\"" + __webpack_require__(814) + "\" class=\"inactive\" />\n                  <img src=\"" + __webpack_require__(815) + "\" class=\"active\" />\n               </a>\n               <!-- 中国电力报 -->\n               <a href=\"http://www.cpnn.com.cn\" class=\"organization\" target=\"_blank\">\n                  <img src=\"" + __webpack_require__(271) + "\" class=\"inactive\" />\n                  <img src=\"" + __webpack_require__(272) + "\" class=\"active\" />\n               </a>\n               <!-- <a href=\"{{item.href}}\" class=\"organization\" target=\"_blank\"  \">\n                  <img src=\"{{item.img_h}}\" class=\"inactive\" />\n                  <img src=\"{{item.img_c}}\" class=\"active\" />\n               </a> -->\n               <!-- 中国邮政快递报社 -->\n               <a href=\"http://www.chinapostnews.com.cn/newspaper/epaper/html/2019-07/23/node_2.htm\" class=\"organization\" target=\"_blank\">\n                  <img src=\"" + __webpack_require__(273) + "\" class=\"inactive\" />\n                  <img src=\"" + __webpack_require__(274) + "\" class=\"active\" />\n               </a>\n\n               <!-- 中国中医药报 -->\n               <a href=\"http://www.cntcm.com.cn/index.htm\" class=\"organization\" target=\"_blank\">\n                  <img src=\"" + __webpack_require__(275) + "\" class=\"inactive\" />\n                  <img src=\"" + __webpack_require__(276) + "\" class=\"active\" />\n               </a>\n               <!-- 中国化工报 -->\n               <a href=\"http://www.ccin.com.cn\" class=\"organization\" target=\"_blank\">\n                  <img src=\"" + __webpack_require__(277) + "\" class=\"inactive\" />\n                  <img src=\"" + __webpack_require__(278) + "\" class=\"active\" />\n               </a>\n               <!-- 中国档案报 -->\n               <a href=\"http://www.zgdazxw.com.cn/\" class=\"organization\" target=\"_blank\">\n                  <img src=\"" + __webpack_require__(279) + "\" class=\"inactive\" />\n                  <img src=\"" + __webpack_require__(280) + "\" class=\"active\" />\n               </a>\n               <!-- 中国铁路建筑报 -->\n               <a href=\"http://www.crcn.com.cn/html/2020-07/14/nbs.D110000zgtdjzb_1.htm\" class=\"organization\" target=\"_blank\">\n                  <img src=\"" + __webpack_require__(816) + "\" class=\"inactive\" />\n                  <img src=\"" + __webpack_require__(817) + "\" class=\"active\" />\n               </a>\n\n\n               <!-- 国际金融报 -->\n               <a href=\"http://www.ifnews.com\" class=\"organization\" target=\"_blank\">\n                  <img src=\"" + __webpack_require__(281) + "\" class=\"inactive\" />\n                  <img src=\"" + __webpack_require__(282) + "\" class=\"active\" />\n               </a>\n               <!-- 中国纺织报 -->\n               <a href=\"https://www.ctn1986.com\" class=\"organization\" target=\"_blank\">\n                  <img src=\"" + __webpack_require__(818) + "\" class=\"inactive\" />\n                  <img src=\"" + __webpack_require__(819) + "\" class=\"active\" />\n               </a>\n               <!-- 每日经济新闻 -->\n               <a href=\"http://www.nbd.com.cn\" class=\"organization\" target=\"_blank\">\n                  <img src=\"" + __webpack_require__(283) + "\" class=\"inactive\" />\n                  <img src=\"" + __webpack_require__(284) + "\" class=\"active\" />\n               </a>\n               <!-- 界面新闻 -->\n               <a href=\"https://www.jiemian.com\" class=\"organization\" target=\"_blank\">\n                  <img src=\"" + __webpack_require__(285) + "\" class=\"inactive\" />\n                  <img src=\"" + __webpack_require__(286) + "\" class=\"active\" />\n               </a>\n\n\n\n\n\n               \n               <!-- 第一财经 -->\n               <a href=\"https://www.yicai.com\" class=\"organization\" target=\"_blank\">\n                  <img src=\"" + __webpack_require__(287) + "\" class=\"inactive\" />\n                  <img src=\"" + __webpack_require__(288) + "\" class=\"active\" />\n               </a>\n               <!-- 21世纪经济报道 -->\n               <a href=\"http://epaper.21jingji.com\" class=\"organization\" target=\"_blank\">\n                  <img src=\"" + __webpack_require__(289) + "\" class=\"inactive\" />\n                  <img src=\"" + __webpack_require__(290) + "\" class=\"active\" />\n               </a>\n               <!-- 华夏时报网 -->\n               <a href=\"http://www.chinatimes.net.cn\" class=\"organization\" target=\"_blank\">\n                  <img src=\"" + __webpack_require__(291) + "\" class=\"inactive\" />\n                  <img src=\"" + __webpack_require__(292) + "\" class=\"active\" />\n               </a>\n               <!-- 经济观察报 -->\n               <a href=\"http://www.eeo.com.cn\" class=\"organization\" target=\"_blank\">\n                  <img src=\"" + __webpack_require__(293) + "\" class=\"inactive\" />\n                  <img src=\"" + __webpack_require__(294) + "\" class=\"active\" />\n               </a>\n\n\n\n\n\n\n\n\n\n\n\n\n\n         </li>\n         <li >\n\n            <!-- 北京商报 -->\n            <a href=\"http://www.bbtnews.com.cn\" class=\"organization\" target=\"_blank\">\n               <img src=\"" + __webpack_require__(295) + "\" class=\"inactive\" />\n               <img src=\"" + __webpack_require__(296) + "\" class=\"active\" />\n            </a>\n            <!-- 华东科技 -->\n            <a href=\"http://www.ecst.com.cn\" class=\"organization\" target=\"_blank\">\n               <img src=\"" + __webpack_require__(297) + "\" class=\"inactive\" />\n               <img src=\"" + __webpack_require__(298) + "\" class=\"active\" />\n            </a>\n            <!-- 中国网 -->\n            <a href=\"http://www.china.com.cn\" class=\"organization\" target=\"_blank\">\n               <img src=\"" + __webpack_require__(299) + "\" class=\"inactive\" />\n               <img src=\"" + __webpack_require__(300) + "\" class=\"active\" />\n            </a>\n            <!-- 传媒茶话会 -->\n            <a href=\"javascript: void(0);\" class=\"organization\">\n               <img src=\"" + __webpack_require__(301) + "\" class=\"inactive\" />\n               <img src=\"" + __webpack_require__(302) + "\" class=\"active\" />\n            </a>\n\n\n\n\n            <!-- 快公司FASTCoMPANY -->\n            <a href=\"http://fastcompany.cn/\" class=\"organization\">\n               <img src=\"" + __webpack_require__(303) + "\" class=\"inactive\" />\n               <img src=\"" + __webpack_require__(304) + "\" class=\"active\" />\n            </a>\n            <!-- 杭州互联网法院 -->\n               <a href=\"http://www.netcourt.gov.cn/portal/main/domain/index.htm\" class=\"organization\" target=\"_blank\"  >\n                  <img src=\"" + __webpack_require__(305) + "\" class=\"inactive\" />\n                  <img src=\"" + __webpack_require__(306) + "\" class=\"active\" />\n               </a>\n               <!-- lenovo -->\n               <a href=\"https://www.lenovo.com.cn\" class=\"organization\" target=\"_blank\"  >\n                  <img src=\"" + __webpack_require__(307) + "\" class=\"inactive\" />\n                  <img src=\"" + __webpack_require__(308) + "\" class=\"active\" />\n               </a>\n               <!-- 大唐电信 -->\n               <a href=\"http://www.datang.com\" class=\"organization\" target=\"_blank\"  >\n                  <img src=\"" + __webpack_require__(309) + "\" class=\"inactive\" />\n                  <img src=\"" + __webpack_require__(310) + "\" class=\"active\" />\n               </a>\n\n\n\n\n\n\n               <!-- HAKUHOSO -->\n               <a href=\"https://www.hakuhodo.cn\" class=\"organization\" target=\"_blank\"  >\n                  <img src=\"" + __webpack_require__(311) + "\" class=\"inactive\" />\n                  <img src=\"" + __webpack_require__(312) + "\" class=\"active\" />\n               </a>\n               <!-- 海峡版权交易中心 -->\n               <a href=\"javascript: void(0);\" class=\"organization\" >\n                  <img src=\"" + __webpack_require__(313) + "\" class=\"inactive\" />\n                  <img src=\"" + __webpack_require__(314) + "\" class=\"active\" />\n               </a>\n               <!-- 艺高高 -->\n               <a href=\"http://www.artgogo.com/\" class=\"organization\" target=\"_blank\"  >\n                  <img src=\"" + __webpack_require__(315) + "\" class=\"inactive\" />\n                  <img src=\"" + __webpack_require__(316) + "\" class=\"active\" />\n               </a>\n               <!-- 花瓣美术 -->\n               <a href=\"http://www.meisupic.com/\" class=\"organization\" target=\"_blank\"  >\n                  <img src=\"" + __webpack_require__(317) + "\" class=\"inactive\" />\n                  <img src=\"" + __webpack_require__(318) + "\" class=\"active\" />\n               </a>\n\n\n\n\n               <!-- 卓志供应链 -->\n               <a href=\"http://www.topideal.com.cn\" class=\"organization\" target=\"_blank\"  >\n                  <img src=\"" + __webpack_require__(319) + "\" class=\"inactive\" />\n                  <img src=\"" + __webpack_require__(320) + "\" class=\"active\" />\n               </a>\n               <!-- 达观数据 -->\n               <a href=\"http://www.datagrand.com\" class=\"organization\" target=\"_blank\"  >\n                  <img src=\"" + __webpack_require__(321) + "\" class=\"inactive\" />\n                  <img src=\"" + __webpack_require__(322) + "\" class=\"active\" />\n               </a>\n               <!-- 万云 -->\n               <a href=\"https://www.wancloud.io\" class=\"organization\" target=\"_blank\"  >\n                  <img src=\"" + __webpack_require__(323) + "\" class=\"inactive\" />\n                  <img src=\"" + __webpack_require__(324) + "\" class=\"active\" />\n               </a>\n\n     \n\n       \n         </li>\n\n         <li>\n               <!-- 上海瀚鸿律师事务所 -->\n               <a href=\"http://www.hanhonglaw.com\" class=\"organization\" target=\"_blank\"  >\n                  <img src=\"" + __webpack_require__(325) + "\" class=\"inactive\" />\n                  <img src=\"" + __webpack_require__(326) + "\" class=\"active\" />\n               </a>\n               <!-- 开源中文社区 -->\n               <a href=\"https://linux.cn/\" class=\"organization\" target=\"_blank\"  >\n               <img src=\"" + __webpack_require__(327) + "\" class=\"inactive\" />\n               <img src=\"" + __webpack_require__(328) + "\" class=\"active\" />\n            </a>\n         </li>\n\n\n      </ul>\n   </div>\n</div>\n\n";

/***/ }),
/* 793 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJYAAADICAYAAAAKhRhlAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyNpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChNYWNpbnRvc2gpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkREQ0M2MTgzMDU0OTExRTc5OEMxRkI0NDAwNDA1MzhDIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkREQ0M2MTg0MDU0OTExRTc5OEMxRkI0NDAwNDA1MzhDIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6RERDQzYxODEwNTQ5MTFFNzk4QzFGQjQ0MDA0MDUzOEMiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6RERDQzYxODIwNTQ5MTFFNzk4QzFGQjQ0MDA0MDUzOEMiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5bSsZzAAAUkUlEQVR42uydCZRU5ZXHb1XvNPQKdDf70gQBEZXIoojKkohOHBJAjTmOmjnJCGSVBBMTozk445IxA4ZRQ2ZciCgac2JQI4JAAyKyjCDNEgirbN00Db3vXTX3Vt3XvC6qqutVvffq1Xv3f8499Wp52/f96t77fe9733N5vV4QifSWW4pAZISSta5wz113ObrAFixcqH77FFo22jw0XV3/s888Y5lzfv3NN40HS9QJqodV73WHS0Kh85SKNk71/kG059FcUjQCViwhqgXtn9A2qL6ajdbPbmFQwDJeI9C6qSq+QQXXebQpaCfFawlYWjQHbT/aYbTMIHDdgFbK4K1B+5aAJepKd6CtQPOgFaG9G8RzHeLP3kObhrbc6XAJWF1D9TZDNQPtfbRb0N7hBF6dD+WgDVCV63JO6gUsUSd9laEi3ckh7k7Oqabzd2q4zqDdjHZEVbYvoM0VsESKprhcrndUrb1VvKzkVJ+gfQ3tj2hJKrhOBcAF3A0xV8ASEVTve73epACoQAXXbfibHezBlgtcAlakUKUyNKtC/K4af/MV/O0+XL4HbWlAN4Pj4RKwLmkiteoYqn/hBD2cqvC3tzBclKQ/F5DMOxouAcuv8QjIh/iaxlCtiHC9CoTrq7juUVz+HvivHwpcAlYHVGsRkEyNUCk6jevehNs4Af6L0o8JXAKWAlUPXP7XKKDqgAe3MQ23RV0Oj6P9zOlwORms0RT+GCoa8vJKjNs7zJ6rEpefRJvvZLjcDoZqA4KgDNJ7QaftHuaEvpJbig86FS63g6HK1xkqRaXcFVGLy/8NfM2wC7geQesuYNkDqgUGQKXoM9zHdNxXPfg7UO8MA9dp8F9/rKPv7TAWi+SkocnFWNFrGKqfo/3W4P1tw33N5A7X1/B9E9oqNVwLFi4kuNLwsyN2K2yX1tu/NN5MQVf8B8X5HI+j9cQK3ojn2oehekrrRtbenQvTV16MZv80AHA1L99Om0IbitYjzmVSFemPrXYzRQ67+W5xBmsLQjU4WqgIqMBljYCtB/81x7fxOFbhcXyXw2M8Rdc7+2qBy0pg/Yqh2oq2PU4FmI2VeQdWZh4u/7sWqNRAhfpOA2B0zfGbeBxv4fG8gK//g+/r41QmdBPIRK6fhxItFH4JbS9aBS/HoxD7cfgbgstPA3daxgJUKGkAjFqIyympx+Oaiss74lAudIWBRrz2QruSl3UPhUa1Cv8TLYVDT0JARUBFA5XGdaln/0HqlMXj+4BaqXEom3qulxSup4QJhTTykgbBbQP/QDhLQxUtTDGEyD9QuePxPc9dH3QjxkGTy4jqZR7XE9XXh1YHK1nVjP8RmH9ncKEKqhfDQaUnUFEARv1n2XicT+LxrqdLQeC/A8gsebl+tnJ9jUFr03MHeofCf0MbSWEZ7VOToeqFlfSRCqp58YBKQ4ikhsSj1FolzwU63eyqQZ9yPY3kerNs8p7L/7oMTthPmQwVhZVRKqi88QJKY5LvmwOCxnSx5zKz3Ppx8t6IVox20YrJ+6/R8rig4gXVMqtCFeYYKFw/R56Wrgxwa80sneL6yuP6s1woHMEVSreY/8bEgslWQfW6laHqQpTvvIjnMYLDYr6J+/4N19s8rkdLgUUJIN2p8jC7VbOgWquCikZ/tlsdqhDH4+WKXUHnw10R2SYdUiPXWxLoeP1UD7DoDuFbuYWx0mSorkskqCKA6z60N/i86PqiWZfDVnL93cr1GXewqJNtMRfKD0zsXniRC/+tUFAlqOg87gf//BAT0N40ab/q+lvM9RqTYu3Hms8twFfRdpr5p0crYxeuQJWOdgXa7jDr0V04t3C/TYZJx1rDTXsyT4jfjOREmn5Lc2/RRevlfE5maSfv8z6u18XxAosSTLojhS4RPGLyP/ulIJ8RZI+jXY32eZDv53Bh9YmTN6JjopEN24OU4x7w94Y/wJ8RXHfH4RgfYagf4+OpjEcoXAT+oTH/Af4JMeKt3IBXtX7IYdMHVW5qJuSkdE5f+mTkgtvlgh7J6dC/W34n652eBdn4e1pPEa3fM+3SkKrM5DTIS/WPLk5PSoFx+UPhmtxBkOJOUn5CXnIT2tSAPKsHJ85WSAjPcH3mcP2a7rFG87/vOBg/EjPWBPnawGP8yRW3w/TC0XDTukXQ2N7i++y9yT+FW9Y/AXcPnAjzi6fDsfpzHb/fW30Kdl44Cl/rcy18e/sy32dLv3w/DO9RBNetedT3/qHht0FNayOsLS+FFRPmw+6qE5DuToEh3XvDrC2L4VTDBSUUU95EnZFVYE1RWX2H65cuPZWa6bGU7gWam7rJ4gnxz4OdZ3f0ML8cNTPoCu+e+Qz+efNvO+wXe96CTRUHYXx+se/7VHeyD6qK5loYnOnvz5zYcxhsOLcf7h10Iyw7sh4e2PZ7+ObWpfCXUztgdr9xgaHPyvNmNXG9xtT9EI3HosnIaNa6zWh/SoCW1q3BPvyvg6thXvE0+ODs5/BxRefBBfkY0q7M7t/x/lxzNZxrqkGQamAQgtS/Wx5sqzwCXzSch2no+V47/jH0y8iD0qqTMDLrhM8jtnra0HvthacOvBuqi+YpC5fZn7h+p3F9rzIDrD/wa0GYFpiSjJg5FivYuWRBiNuqajFsPbTrNVhy7b0weV3ndOL6nl+CooycjvdvnNgKK7/YChvPHYAJ6LVGZPWB9eX74GRDJfx4+Aw4VHsWPjl/CNvqXt/vypqq4Ov9roMf4XcXWuph7s6XYF91p6tcfYMc0tVdtGj1Vld1lKGqb1PAovHSzQxWKClZba2JBVUd4lipbyboTMYUujaUH4BfjfrGZaGQwl+gSioO+PKssbmDYcmhD6G6tQGG9SiEiQgbbYs0u/84WH12D5QghKTvDp0Cj185C+ZsWRLYBRGobpw0m6VI6qiZy9CUUDg4gt8c59dBJhbUYm79qUVjjP4P7cuhVnps79uwaeqjUJCe1eUOPj1/GJ686i4EqhE9UZ3vMwp/cwaMh9s2+i+R3tF3rA+2pzEEerxeX+Ogru2yNDTYPQA0S+BME8vL0Dpywn2Fvw8Eiyq71evvV61va4YffvZHeHX8g75Q1tLeBt/AMDaj6OqO39e1NfrCJa13rK4Cdlw42vHdmrJSKMSwWd7kd5g/+3wl/G7sfbB/xjM+V0mty7k7Xw6VTthWRt1M0enfcOKBiYadwMCXtwZ6LOpZL1F1N9CfZw1/bl7C53JDkjsJmttbL2s3AN8dw+OzqIyOof1V8Vjq8lKdX4diKU/V9iL2WFa6mSLuUg2qo3D4dbS/mbn/Nq8nGFQE/08Dji+sCCIFJPWy1WV4KFQVBLUyntRx05SnvK4hsae7kGnGY7pofRVabxP+WERWOedP1LO6U0N56ealArcTzAsmco6VFiS5jkWvdgUWeYWAISrvsVldheDvf9sdoguCelxHRvln3G8LjxUCiFdi3EYiwBFJmA4lGqVBGf+vQ4B1T5R/0h/bGSxKGktiTWG0VGICDE3WqtdBW2fqJPBPhWmfHEuk2VtFGtK0zodhKlhuqUznHYeAJZUqYIkEbMeCFa/KdaK3dJzHMruSnRqCHRkKzapsJ+d1ju1uoEpfsHChYdu3y7Ta4rE0ykiozNi+gOVAqAQue4GljFFps1JlR7C/iI5bcqz4iZ5bQzdcbrOaB1H2GyLvornwaUa97QKWhaQaX3Qc/KMzLRuSwgC2TFqFkksZBliijA51DFiBoyITJWnuIkQKWOKd9Dn2H1RsllahSGR7sJ7rdSPIeUgoNFI0BPcJix3TK2w0h0S4sfo0c/JuAcua6ol2k8WOqURV1uGOLcdOFSE5lkjAEkkojJfeB2vM5amWMtVMdRfHVidgWVd0Qdeqc3t6NRzbZ2g/AWtMGuyoUEhzMHRMtWinjkUWTcz2LNob4rHM1cdd/aCryyROH4gnYGlUpNfdBDwBKxZQbueEuQQ0PkNRwBOwws33RLOrTOXlI2jr2Qi0MiM9oxo8+q2eICrna+VhNsk2hooecHQ9L9OEo0PZvsOfHWTAShi2c0Z60MD30YAWeK703qpw2XmgHz2WjWYRpKG/NN8UXUe8mY0mux3Opjxoe58KtI1oFfHIBQcG8UThZuCLEK4/c3fHWQErNm8FDBAwKNT5uJqN1F0FGdk1aKPY5qtAW4dGj9KlhytdsMh5RRMaaS73V8Vj6VDYcGmW5JIg3xFo6mkj6TG5N/I6lJNdpQJNeUDkHpVHI9iqrVpG4TyYGfOP2jkU0lMelNJdF8HvqwNAo6e6T1Z5NAJtDBtN0UgPtNylAm2zlUCzQnJvFFheCP00Ucp3Ap/AQB2e53XcPyXt9PjZE+CfQ12rKOy9w0bKZ2+mgEaebCzbAhVoHzFoH4MFrv0FAhbgrahB4040sGjQWmuI7+5iCwxbJTq67yEM1Ps6nQ89afRtNhI9S+4mVegcrgJNeZzwTlXYJI/WEG/AAvR90OHZz2aD9dcgnzVyv1IwHdY5J1gGxt6rVxEAWmFAY4BAG8/2MP/JtqtC5yfxBI1l6AMVzMyx6ElSi2P8l1lV1Nm6ko3UNyB0Uv/ZDWy/YNDo4eNKZy0tN4GNZLnkPcGACiXqO3uNjdSPQ+cQDqP5bHTJ6V7wP1dR6Udbz6C1CFjxAWpSlMdPnjPUzgaB/+mnBwyC7XQXdZHF8I1AO6lzuCSv+ndbgqWzN6KugWyN61AImh3iu6Fc8HbtgqEO0vttA5YJoW0vt8IiEV1HCfYYWsqJdqjK47TO3R/xFPXJ9Xd8jhWFqMdc03DkM7OugT5/3gWqrgO61JPLeU0q2i8h9uf9WEXkpV52Alg06mBClOueZw8VUpH0NqfUNKmhomT5St52KagemJmIs79YpfETD7Coz2dDlOt2PIU0WqhUCoRqCtqiRIZKfdwhAJvDDRNqgXrtBpYiD3sILToWAVQ9ucUYTln1Q3sucrV6BkCSq7JuWO9FjX1zhuZvOVrkbmqF5oIe14J17/YJJ2pFrgnzPfWhjeE/0ka41GGrO2jxBIuGclxtwHbJA/0lbNMwKx3OTx6mvKX+pCW0UHnDEOWz77MlnMOC8M94Jjc2mP98s9hIFey9V6C9a7vkPdLwY5NO1HhoLtr3wD/+bCrnk5M4LaDrt4dtBZbWfCZwBj87TbFogpQL5GRPMwN0o0kBxP6AUst2N9BQ4uER/dLlSgKvF8pvHTmaw6qiYgdDE81ohUEMFV2R2GJXsAiqXRFl/ilucLe0Q0t+5iZxQh3qHcU6N/MrXZ9s1OtAZLYZkQJWiZ4bFbBEU/h1g54bTehLOrVXFIAnNcgpYO6V1NgKLo8XvC4XtGdg6uF2dbm9pCZcp80D7enJ4E1OStTEXItomHgRh8CtApYPqkKoGjsgKBwFq/dDysUGaO+WCmUzRkUEFSlvy1Ho9sUFqJxUDHXDeiVisWi9u1sJgzSiVdfxXwkbCiOFqi0rXYJd12GwRO8N22bsUVJ9CxSsPSBQRS5y48oF948ErGAnUdsMhe+V+jwW5Vw1I4sgvbwWoLxW23bqm5UkzQlg0S1sdGmnHvydpQLWZbnR1qM+qHyxvaUNcneeiGl7KVWNTgBLya/oHsg2ASuIqsf0g+SGFl/rzxNDa87d2g4utNqRhU4Aaxq/rjNi4wkNVs6uk1AzqoiGucCZmWMka9LWaJvMyxuM2kFCKnvPacjefUoQiU40FwUNxaZJdHcJWCpllZ4WPKKXMsshDfZrF7BEeknpZlhvZKwVOUvUulGeX1ciYIn0Eo3npzuuL4J/MjkBS6RrfkVh0CNgifTSzUaHQQHLeaKhy5MELJHeoongMtHKwX8voYAl0j0M2vZOaMPVK7073DN4bMIc74Gqclhz1tAprIrNCIO2BysnNQPuHHhNwhzvB8n7jQYLVC1CQyWh0Hmia2GHxGPFoIqmOnju7xsT5niP1Rn+VBWPGWHQ9mBVtTTCm8d3gahDNJqh1IwdSSh0ntYJWCK9dZxNwBLpqhKzdmTrHGtoj57w/Pg5pu7z2X0bzOoyiEa7BSw93LHLBd2T00zdZ7JbgoCEQpF4rKgy1boLMHvjS6buk7o4RDYHq9XTDmcba6SWJRSKBCyRyKmhMCMpBa7ILkjoc9hXVQYtnjYBy0rql5kDS8fNTuhzoMZHIuaJEgpF4rG0qrm9DQ7XViR8y1bAspi+qL8I921ZIe5DQqFIwBKJBCyR5Fg6yiq3f609cxD2V5cJWHaRVW7/+kdNhePAklAoEo+lVReaG+Clw5/G32MleF+agBWgyuZ6+F8LgCWtQpFIwBIJWCLJseykQd3z4NmxM03d59KDm2FD2T8ELDufXIo7CQozskzdJw0uFEkoFInH0i4aNnP/J+YOmylvrBWqwAED/ehyikhCoUjAEokcGgrTkpJhQGauofuoaWmC8ibJqxwFFkH1yvXfMnQfH5zeD0+UrhGSJBSKxGPFKLp1qszgmz2rWmV2GceBRdMYzTJ5GiORhEKRgCUSsEQiu+dY+WmZMLP/aEse26ZzR2x9ucnWYOWldYNvF0+w5LHR1ER2BktCoUg8llbRDMZvnbDmQ5qOG/+kLwHLKNFj5ZYc2AgiCYUiAUskErBEApZIwBKJBCyRgCUSsEQiAUskYIkELJFIwBIJWCIBS2QlDXx5q4Alsh9UpIQfj1X4t33gdbmEKJTL4ynCl90BH+cJWFEo5WKDEHVJqWhjxGOp3PeJByZqWufctBHg8noFJbXHaveU915z4O4QX5c5Dqxo4Gou6GHP1lRrO7ib2/zWorz6P/OkJkHd8IJwqzehlTjdY9F0xsfVHwxYvi21PSP0rMNNfXKg8oYhtvU4SQ0tkH62GtLPoJXVQHJdc6fva0cUdrkN+nNaIYGPJ1iUcQ8McOWXFWanf3NTq61DWXu3VKgf2stnvsrBskg/WwNpZdW+16Y+2RFtxwpwxQOsM2hBHyJYM6poeH1xr5WhVvSk2PqmosvU1j0N6ob18plPGlLKeMMVj5pqCdIk9uniuEGSgXfl4yEx4MKGlbSsRAY0QqQIREbo/wUYAOxj6/9aIvkeAAAAAElFTkSuQmCC"

/***/ }),
/* 794 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 795 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 796 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c70fc80e46dcecf33ca0e128e8fa7065.png";

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "64fad40a726451abad7ccbc87418cc67.png";

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d4e94ba327b96a5b3f2521d43c60309e.png";

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1a70b0cb1533ce8506ae619e48826944.png";

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "def72c599dfc88cc2ebdc92c3c14fd81.png";

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "366e44f15ff99c8d943f824648b60485.png";

/***/ }),
/* 803 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAF4AAABeCAYAAACq0qNuAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyNpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChNYWNpbnRvc2gpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjcxODVGN0I0MDZCOTExRTc5OEMxRkI0NDAwNDA1MzhDIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjcxODVGN0I1MDZCOTExRTc5OEMxRkI0NDAwNDA1MzhDIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NzE4NUY3QjIwNkI5MTFFNzk4QzFGQjQ0MDA0MDUzOEMiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NzE4NUY3QjMwNkI5MTFFNzk4QzFGQjQ0MDA0MDUzOEMiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4dqQKiAAAIa0lEQVR42uydbUxTVxjHT1ugVsQCAQMiCviCGKfMBIKvYHSa6ZiAixhiZkNCCCMZymL8oPGLJsYP+sWYSMiCkzgnwtx8G6DIUIeARgvZiPjCRBRwoJUhItbCnkfPdZW09oXSe07v/Sf/BFuxx999+tznvF4FYVPe4CBwMNgfrAVPAGvA48AqsA/YBDaCB8Gv6c8vwL3g5+BucA99nSkpGAI9DTwVHEaBu6ptw/QCPAY/BLexcCHEBK8GTwfPpsBVbvpcE70At8H36bdFEuBDwLHgWTTSxRRG/h2wHtzlqeCjwHHgKYzeVx6Br4NbPQV8BHgxjXQehJH/B/gBr+CxGlkGnkn41D1wDa2OuACvpCklAexF+NYbcB1NQUMsgw8Ar+EorTiSfs6DDa76B11Zws0Bp9LOjqcJO29zwX20T8AEeEwty8FL3ViLiyEVvV+Np52wYTHBY7d9HTiGSEeYRkNp58skBni88htoF19q8qf9krvODj84C34ChR5EpCtfOuSBZedrd4DHEcJ0cCCRpaGR30JLzzEDr5Yj3SJ87J3fdiTnqxy8SCngyTJri2knhEb+sKvBJ0qsenFUWlrlPXAl+Bm0Vpf1cYXSDtYzezo/tjQRvFpmardWU2ajAo/vf0HezXPKsk/IKtkWW1upZgH4E5mlU/0cnFLsdCbi8ZcXyQyd1iLK0GHwSfQu7XbV19enh4aGqjkH70MZOgQeZ/2jxWpxfHx8XFNTU15qairv4/rRlKXd4JeI3eKgoKBJJSUlWw4fPpzAOfyl9oKPovWo6PICZWdnf3Xr1q1N4eHhvFZWIZSpTfBxrLU8FqTX67ds2rQpnFP4cbbAY6Qzue4lMDAw6MiRI7lFRUVLlEqlgjPwU0ZmkZHg57HcepVK5aXT6VIaGxs3R0ZGajiDP88aeB8xKxlHNBcEef+7zMzMaZxVOD6WwONAmDcv/wutVutfWFj4zfHjx5dzknqQ7UxL4KM5++oSAK7auHHj2ubm5sw5c+ZM4CTqPwAvrE/ns5cSHR1TV1e3NTc3dzrjTZ0qZBWl2Qtcr4nx8/PTHjx4MLusrOwzKP9ZTT0qIcAF8NOIB0ihUCjT0tJWt7S0ZEPp78dw1L8H71HzqFFRUTOuXr2av23btlkMNi9MAI85ZxLxMPn6+vrt27cv6+zZs59rNBolQ03D/V3e2CBcqqEgHihIPYq1a9eugKonJyEhwZ+VZiFzJb0CHq2IiIjIS5cu5e/YsYOVVRLBCN6fSECQbsbv2bMn8+LFi19CGhK7ggtA8FoiHSlWrFixDKqe3MTERDGXIE5E8H5EYgoLC5taUVGxdffu3WINCvoheEku3VCr1ZqdO3d+XV1dnRoQEODuvVrjELyGSFhJSUmLoer5dtWqVe5ciPu2vlURiSskJGTymTNntu7fv3+Bu4YOhA6U5OXj46POz8/PuHbt2obg4OCxZuKtlJF/KOhoxVdWVqaP9ecgeKOM+3/V1dVdh3x/Yow/xojgTTJuIGE0Dh44cODHhQsXnuju7h7rYDRhGTVAJL4auKurq0On0xVDbd/tpo8cQPCvpAz98uXLtSkpKacNBsMbN37sK0w1fVIEPjg4OLB3797ixMTEn90MHdWHEd8rNegdHR3tGRkZxTU1Nc9EasK/CP65hJgPV1VVXVm3bt25/v5+MYsKA6aabikQHxgYeLlr166ilStXnhYZOqoHIx7PZcS9mQpPhd7W1vY3pJZjtbW1LHy73x7H6EU7UBj1HjfvOgwqLy+vXr9+fTlE/BAjzeoWOlCoxx6YWl5s3769cM2aNecZgv6etTAOjQdgfuop0FtbW+9BlB/T6/UslsoPzcG30aEDroeIIbMMnTp16gLk8yqo04cYbKKJsn6/oMkoXAle1dfX15uXl1cAkX6BUehCtBvNIx6FJ09E8gj9zp07t1NTU39qbm5+wXhTW4QfzMfjnT7mSSwNgUpKSs7FxMR8zwF0ZHvPEvjX5leEdfX29j7Pyso6lJ6eXg38hzloMrJ9f3L3yNn1JvLufEWm9ScoLS2t5O7duy85+oI2mf9h5NRfJ8s1vclkenP06NFf58+f/wNn0B+REQdKWJpzbWCx5QaD4alOpzu0efPmK5ykFnNdH/mCpYU8eH46nqXLzDkCjaDk5OST7e3tPE7adBELZ9JbW2VwlYUWvwEVFBSUxsbGFnMK3SpLa0vXsHeFR7iKtpmrp6fnn5ycnOLS0tJOjvt194Weqr3gUb+Td3uj3H4GfENDw42UlJRTnZ2dgxxDx+nEGmtv2hqDjydWjv2QZVeKqbf2pq2VZDfAT2SGDuuJpUrGEfA42HSOyKvNHB0aOEdsPNrCnmFgrCZwXHumzNQuVYLbbf0le8ffcbpqPPG8Z3+4Wnp7O6COTHzgWDJuRNbKfK3y+Y2MwaHOw7QujaLRL8us2wEuc+Re6OhUH05d4bPx8Gwbjcz7rXA1WglxcA2qM3Os2DHASZNIOfLJU3ApuN/RX3R2chsnTfAJAXjImZ9EoXdQ6E4NT49mVQFGPs6q4Jb8AIlBx9HGX4gTD2VxBXihg4U5H88BDpUI9JvgCjLKnTSuWEeD1c4DWutj3vfyUOCDtEd6k4zyqWeuAm9+d2+htf4ED4OOYy8nyUfOgxcTvBAVf9GvIV4A3rdz4n2slqYWl07EjPWDdJOIiJMpLriBVhOOHqQ7UhFEfnS0KOAF8fCwdJx/uO+ODxNjFwhGfiwYT8gT+xwFIy2H9TTS3SYxt9+oaf6fTdx74Cje+B/SCuweMVtWJxXw5hKO2J1KU5ErTwbEmruHphIE3kYYmFFjdcOZN4UvDEdoad8At/5r6LfD2yxdYBQP0JIPVw3j3l0D7dT1EAanLv8TYADYpE5uWFSa5QAAAABJRU5ErkJggg=="

/***/ }),
/* 804 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 805 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 806 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 807 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 808 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 809 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 810 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 811 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 812 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6881709e0da82431c26939e9fdd572d0.png";

/***/ }),
/* 814 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9bde851d3b6f29f9be4232ae05beeb65.png";

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2c70b2007ad5933c9543765b2a055f53.png";

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2c960215f200067a893692882234d108.png";

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ea84ee7c7c576223111a5f022766f935.png";

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e3df8e51ab39d596191ccecedf9f2819.png";

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
   value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IndexController = function IndexController() {
   (0, _classCallCheck3.default)(this, IndexController);

   this.name = 'index';
   this.statistics = [{ text: 'face-index-text042', value: 'face-index-text054', per: 'face-index-text044' }, { text: 'face-index-text043', value: 'face-index-text055', per: 'face-index-text045' }];
   //   this.sort_arr=[
   //                "中国教育报","中国建设报","中国交通报","中国旅游报","健康报网","金融时报","中国审计报","中国财经媒体版权保护联盟","中国有色金属报","中国冶金报","中国质量报","中国黄金报","中国经营报","中国保险报","中国电力报","中国邮政快递报社",
   //                "中国中医药报","中国化工报","国际金融报","每日经济新闻","界面新闻","第一财经","21世纪经济报道","华夏时报","经济观察报","北京商报","华东科技","中国网","传媒茶话会","快公司","杭州互联网法院","lenovo","大唐电信","HAKUHODO","国家海峡版权中心",
   //                "艺高高","花瓣美素","卓志供应链","庄游","达观数据","万云","开云中文社区","上海瀚鸿律师事务所"
   //             ]


   this.lists = {
      page1: [{ id: 44, href: "http://www.rmzxb.com.cn/index.shtml", img_c: __webpack_require__(244), img_h: __webpack_require__(243), name: "人民政协报" }, { id: 8, href: "http://www.jyb.cn", img_c: __webpack_require__(246), img_h: __webpack_require__(245), name: "中国教育报" }, { id: 19, href: "http://www.chinajsb.cn", img_c: __webpack_require__(248), img_h: __webpack_require__(247), name: "中国建设报" }, { id: 1, href: "http://www.zgjtb.com", img_c: __webpack_require__(250), img_h: __webpack_require__(249), name: "中国交通报" }, { id: 2, href: "http://www.ctnews.com.cn", img_c: __webpack_require__(252), img_h: __webpack_require__(251), name: "中国旅游报" }, { id: 5, href: "http://www.jkb.com.cn", img_c: __webpack_require__(254), img_h: __webpack_require__(253), name: "健康报网" }, { id: 3, href: "http://www.financialnews.com.cn", img_c: __webpack_require__(256), img_h: __webpack_require__(255), name: "金融时报" }, { id: 6, href: "http://www.zgsjbs.com", img_c: __webpack_require__(258), img_h: __webpack_require__(257), name: "中国审计报" }, { id: 9, href: "https://fmcpa.org.cn", img_c: __webpack_require__(260), img_h: __webpack_require__(259), name: "中国财经媒体版权保护联盟" }, { id: 16, href: "https://www.cnmn.com.cn", img_c: __webpack_require__(262), img_h: __webpack_require__(261), name: "中国有色金属报" }, { id: 17, href: "http://www.csteelnews.com/", img_c: __webpack_require__(264), img_h: __webpack_require__(263), name: "中国冶金报" }, { id: 13, href: "http://www.cqn.com.cn", img_c: __webpack_require__(266), img_h: __webpack_require__(265), name: "中国质量报" }, { id: 18, href: "http://www.gold.org.cn", img_c: __webpack_require__(268), img_h: __webpack_require__(267), name: "中国黄金报" }, { id: 11, href: "http://www.cb.com.cn", img_c: __webpack_require__(270), img_h: __webpack_require__(269), name: "中国经营报" }, { id: 4, href: "http://www.sinoins.com", img_c: __webpack_require__(821), img_h: __webpack_require__(822), name: "中国保险报" }, { id: 20, href: "http://www.cpnn.com.cn", img_c: __webpack_require__(272), img_h: __webpack_require__(271), name: "中国电力报" }],
      page2: [{ id: 14, href: "http://www.chinapostnews.com.cn/newspaper/epaper/html/2019-07/23/node_2.htm", img_c: __webpack_require__(274), img_h: __webpack_require__(273), name: "中国邮政快递报社" }, { id: 10, href: "http://www.cntcm.com.cn/index.htm", img_c: __webpack_require__(276), img_h: __webpack_require__(275), name: "中国中医药报" }, { id: 15, href: "http://www.ccin.com.cn", img_c: __webpack_require__(278), img_h: __webpack_require__(277), name: "中国化工报" }, { id: 45, href: "http://www.zgdazxw.com.cn/", img_c: __webpack_require__(280), img_h: __webpack_require__(279), name: "中国档案报" }, { id: 12, href: "http://www.ifnews.com", img_c: __webpack_require__(282), img_h: __webpack_require__(281), name: "国际金融报" }, { id: 21, href: "http://www.nbd.com.cn", img_c: __webpack_require__(284), img_h: __webpack_require__(283), name: "每日经济新闻" }, { id: 22, href: "https://www.jiemian.com", img_c: __webpack_require__(286), img_h: __webpack_require__(285), name: "界面新闻" }, { id: 23, href: "https://www.yicai.com", img_c: __webpack_require__(288), img_h: __webpack_require__(287), name: "第一财经" }, { id: 24, href: "http://epaper.21jingji.com", img_c: __webpack_require__(290), img_h: __webpack_require__(289), name: "21世纪经济报道" }, { id: 25, href: "http://www.chinatimes.net.cn", img_c: __webpack_require__(292), img_h: __webpack_require__(291), name: "华夏时报网" }, { id: 26, href: "http://www.eeo.com.cn", img_c: __webpack_require__(294), img_h: __webpack_require__(293), name: "经济观察报" }, { id: 27, href: "http://www.bbtnews.com.cn", img_c: __webpack_require__(296), img_h: __webpack_require__(295), name: "北京商报" }, { id: 28, href: "http://www.ecst.com.cn", img_c: __webpack_require__(298), img_h: __webpack_require__(297), name: "华东科技" }, { id: 29, href: "http://www.china.com.cn", img_c: __webpack_require__(300), img_h: __webpack_require__(299), name: "中国网" }, { id: 30, href: "javascript: void(0);", img_c: __webpack_require__(302), img_h: __webpack_require__(301), name: "传媒茶话会" }, { id: 31, href: "javascript: void(0);", img_c: __webpack_require__(304), img_h: __webpack_require__(303), name: "快公司FASTCoMPANY" }],
      page3: [{ id: 32, href: "http://www.netcourt.gov.cn/portal/main/domain/index.htm", img_c: __webpack_require__(306), img_h: __webpack_require__(305), name: "杭州互联网法院" }, { id: 33, href: "https://www.lenovo.com.cn", img_c: __webpack_require__(308), img_h: __webpack_require__(307), name: "lenovo" }, { id: 34, href: "http://www.datang.com", img_c: __webpack_require__(310), img_h: __webpack_require__(309), name: "大唐电信" }, { id: 35, href: "https://www.hakuhodo.cn", img_c: __webpack_require__(312), img_h: __webpack_require__(311), name: "HAKUHOSO" }, { id: 36, href: "javascript: void(0);", img_c: __webpack_require__(314), img_h: __webpack_require__(313), name: "海峡版权交易中心" }, { id: 7, href: "http://www.artgogo.com/", img_c: __webpack_require__(316), img_h: __webpack_require__(315), name: "艺高高" }, { id: 37, href: "http://www.meisupic.com/", img_c: __webpack_require__(318), img_h: __webpack_require__(317), name: "花瓣美术" }, { id: 38, href: "http://www.topideal.com.cn", img_c: __webpack_require__(320), img_h: __webpack_require__(319), name: "卓志供应链" }, { id: 40, href: "http://www.datagrand.com", img_c: __webpack_require__(322), img_h: __webpack_require__(321), name: "达观数据" }, { id: 41, href: "https://www.wancloud.io", img_c: __webpack_require__(324), img_h: __webpack_require__(323), name: "万云" }, { id: 42, href: "https://linux.cn/", img_c: __webpack_require__(328), img_h: __webpack_require__(327), name: "开源中文社区" }, { id: 43, href: "http://www.hanhonglaw.com", img_c: __webpack_require__(326), img_h: __webpack_require__(325), name: "上海瀚鸿律师事务所" }]
   };
};

exports.default = IndexController;

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "302fa0bff85d4d15804ec1c51ef5d664.png";

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "75c819904e4a9add3af1f27a5e4e111a.png";

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(824);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "index .section {\n  padding-top: 48px; }\n  index .section > .container > .title {\n    font-size: 18px;\n    text-align: center;\n    padding-bottom: 12px; }\n\nindex .statistics {\n  height: 170px;\n  background: url(" + __webpack_require__(825) + ") center bottom no-repeat #fff; }\n  index .statistics .item {\n    width: 50%;\n    display: inline-block;\n    text-align: center; }\n    index .statistics .item:nth-child(2) {\n      border-left: 1px solid #e8eaea; }\n    index .statistics .item .text {\n      color: #222222;\n      font-size: 16px; }\n    index .statistics .item .value {\n      margin-top: 15px;\n      color: #222222;\n      font-size: 20px;\n      font-weight: bold; }\n      index .statistics .item .value .sup {\n        font-size: 14px; }\n        index .statistics .item .value .sup em {\n          font-style: normal;\n          font-weight: bold;\n          font-size: 18px; }\n        index .statistics .item .value .sup .per {\n          font-weight: normal; }\n\nindex .customers {\n  background-color: #ffffff; }\n  index .customers .title {\n    color: #2db49c;\n    border-bottom: 1px solid #2db49c; }\n  index .customers .content {\n    position: relative;\n    padding: 48px;\n    overflow: auto; }\n    index .customers .content .customer {\n      position: relative;\n      display: block;\n      text-decoration: none;\n      width: 25%;\n      float: left;\n      text-align: center;\n      padding-top: 28px;\n      overflow: hidden; }\n      index .customers .content .customer .name {\n        font-size: 18px;\n        color: #222222;\n        font-weight: bold; }\n      index .customers .content .customer .image {\n        padding: 18px 48px; }\n        index .customers .content .customer .image img {\n          width: 100%; }\n      index .customers .content .customer .description {\n        font-size: 14px;\n        color: #666666;\n        margin: 18px 18px;\n        padding: 20px 30px;\n        height: 170px;\n        line-height: 1.7em;\n        border-top: 1px solid #e8eaea; }\n      index .customers .content .customer .coming-soon {\n        position: absolute;\n        display: none;\n        top: 0;\n        left: 0;\n        bottom: 0;\n        right: 0;\n        background-color: rgba(255, 255, 255, 0.6);\n        cursor: default;\n        text-align: center;\n        padding-top: 240px;\n        font-size: 18px;\n        color: #666666; }\n      index .customers .content .customer:hover {\n        box-shadow: 0 0 30px rgba(0, 0, 0, 0.2); }\n        index .customers .content .customer:hover .details {\n          bottom: 0; }\n        index .customers .content .customer:hover .coming-soon {\n          display: block; }\n\nindex .advantage {\n  background: url(" + __webpack_require__(826) + ") no-repeat center center;\n  background-size: cover;\n  color: #fff; }\n  index .advantage .title {\n    border-bottom: 1px solid #2db49c; }\n  index .advantage .item {\n    padding: 30px 0;\n    word-break: normal; }\n    index .advantage .item .container {\n      padding: 0 120px; }\n  index .advantage .image img, index .advantage .text img {\n    max-width: 100%; }\n  index .advantage .left .image {\n    float: left;\n    text-align: left; }\n  index .advantage .left .text {\n    float: right; }\n  index .advantage .right .image {\n    float: right;\n    text-align: right; }\n  index .advantage .right .text {\n    float: left; }\n  index .advantage .text {\n    line-height: 1.6;\n    width: 440px; }\n    index .advantage .text .heading {\n      font-size: 28px;\n      word-break: normal; }\n    index .advantage .text .description {\n      margin-top: 20px;\n      line-height: 2;\n      font-size: 14px;\n      color: #e8eaea; }\n  index .advantage .link {\n    margin-top: 30px;\n    font-size: 14px;\n    display: inline-block;\n    border: 2px solid #fff;\n    color: #fff;\n    line-height: 34px;\n    width: 130px;\n    text-align: center;\n    font-weight: bold;\n    text-decoration: none;\n    border-radius: 18px; }\n    index .advantage .link:hover {\n      background-color: #32d182;\n      color: #fff; }\n\nindex .feature .title {\n  color: #2db49c;\n  border-bottom: 1px solid #2db49c; }\n\nindex .feature .yuanbenlian {\n  margin-top: 30px;\n  font-size: 14px;\n  display: inline-block;\n  border: 2px solid #32d182;\n  color: #32d182;\n  line-height: 34px;\n  width: 130px;\n  text-align: center;\n  font-weight: bold;\n  text-decoration: none;\n  border-radius: 18px; }\n  index .feature .yuanbenlian:hover {\n    background-color: #32d182;\n    color: #fff; }\n\nindex .feature .item {\n  padding: 100px 0;\n  word-break: normal; }\n  index .feature .item:nth-child(odd) {\n    background-color: #fff; }\n\nindex .feature .image, index .feature .text {\n  width: 50%; }\n  index .feature .image img, index .feature .text img {\n    max-width: 100%; }\n\nindex .feature .left .image {\n  float: left;\n  text-align: left; }\n\nindex .feature .left .text {\n  float: right; }\n\nindex .feature .right .image {\n  float: right;\n  text-align: right; }\n\nindex .feature .right .text {\n  float: left; }\n\nindex .feature .text {\n  line-height: 1.6;\n  width: 440px; }\n  index .feature .text .sub-title {\n    font-size: 18px;\n    color: #222222; }\n  index .feature .text .heading {\n    font-size: 28px;\n    color: #222222; }\n  index .feature .text .description {\n    margin-top: 20px;\n    line-height: 2;\n    font-size: 14px;\n    color: #666666; }\n\nindex .quickly-understand {\n  background-color: #2b2b2b;\n  padding-bottom: 68px; }\n  index .quickly-understand .title {\n    color: #ffffff;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.4); }\n  index .quickly-understand .video {\n    position: relative;\n    width: 720px;\n    margin: 48px auto 0;\n    background-color: #ffffff; }\n    index .quickly-understand .video .play-btn {\n      position: absolute;\n      width: 100%;\n      height: 100%;\n      left: 0;\n      top: 0;\n      z-index: 2;\n      cursor: pointer; }\n      index .quickly-understand .video .play-btn img {\n        display: block;\n        position: absolute;\n        width: 94px;\n        height: 94px;\n        top: 50%;\n        margin-top: -47px;\n        left: 50%;\n        margin-left: -47px; }\n      index .quickly-understand .video .play-btn:hover img {\n        opacity: 0.7; }\n    index .quickly-understand .video video {\n      display: block;\n      position: relative;\n      z-index: 1;\n      width: 100%; }\n\nindex .highlights {\n  background-color: #ffffff; }\n  index .highlights .title {\n    color: #00816a;\n    border-bottom: 1px solid #00816a; }\n  index .highlights .content {\n    position: relative;\n    padding: 68px 48px 88px;\n    overflow: auto; }\n    index .highlights .content .highlight {\n      position: relative;\n      width: 25%;\n      float: left;\n      text-align: center; }\n      index .highlights .content .highlight .name {\n        margin-top: 28px;\n        font-size: 16px;\n        color: #222222;\n        font-weight: bold; }\n      index .highlights .content .highlight .description {\n        margin-top: 28px;\n        font-size: 14px;\n        color: #666666;\n        padding: 0 18px;\n        line-height: 1.8em; }\n\nindex .similarity-btn {\n  position: fixed;\n  width: 100px;\n  right: 88px;\n  bottom: 180px;\n  z-index: 999;\n  box-shadow: 0px 6px 10px 0px rgba(0, 0, 0, 0.25); }\n\nindex .organizations .title {\n  color: #666666;\n  border-bottom: 1px solid #dadedd; }\n\nindex .organizations .content {\n  width: 100%;\n  height: 540px;\n  padding: 48px 0; }\n  index .organizations .content .organization {\n    position: relative;\n    display: block;\n    padding: 15px 37px;\n    width: 25%;\n    float: left;\n    text-align: center;\n    margin-bottom: 15px; }\n    index .organizations .content .organization img {\n      width: 100%;\n      height: auto; }\n    index .organizations .content .organization .active {\n      display: none; }\n    index .organizations .content .organization:hover .active {\n      display: inline; }\n    index .organizations .content .organization:hover .inactive {\n      display: none; }\n\nindex .organizations .rn-carousel-control {\n  top: 50%;\n  font-family: 'ybicon';\n  font-size: 36px;\n  line-height: 1;\n  color: #047a62; }\n  index .organizations .rn-carousel-control.rn-carousel-control-prev {\n    left: -36px; }\n    index .organizations .rn-carousel-control.rn-carousel-control-prev:before {\n      content: \"\\E671\"; }\n  index .organizations .rn-carousel-control.rn-carousel-control-next {\n    right: -36px; }\n    index .organizations .rn-carousel-control.rn-carousel-control-next:before {\n      content: \"\\E64A\"; }\n\n@media only screen and (max-width: 991px) {\n  index .customers .content .customer .description {\n    padding: 20px 6px; }\n  index .customers .content .customer .coming-soon {\n    padding-top: 180px; } }\n\n@media only screen and (max-width: 767px) {\n  index .section {\n    padding: 38px 18px; }\n  index .statistics {\n    padding: 38px 0;\n    height: 140px; }\n    index .statistics .item {\n      margin-bottom: 30px; }\n      index .statistics .item .text {\n        font-size: 12px; }\n      index .statistics .item .value {\n        margin-top: 10px;\n        font-size: 14px; }\n        index .statistics .item .value .per {\n          font-size: 12px; }\n  index .customers {\n    padding-bottom: 0; }\n    index .customers .content .customer {\n      width: auto;\n      margin: 0 18px;\n      float: none; }\n  index .advantage .item .container {\n    padding: 0 30px; }\n    index .advantage .item .container .image {\n      float: none;\n      text-align: center; }\n    index .advantage .item .container .text {\n      width: 100%; }\n      index .advantage .item .container .text .heading {\n        font-size: 18px; }\n  index .feature {\n    padding: 38px 0 0 0;\n    background-color: #f5f5f5; }\n    index .feature > .container {\n      padding: 0 18px; }\n    index .feature .yuanbenlian {\n      margin: 20px auto;\n      display: block; }\n    index .feature .item {\n      padding: 80px 18px; }\n    index .feature .image, index .feature .text {\n      float: none !important;\n      width: 100%; }\n      index .feature .image img, index .feature .text img {\n        max-width: 100%;\n        width: 85%; }\n    index .feature .text {\n      line-height: 1.4;\n      width: 100%;\n      padding: 0 30px; }\n      index .feature .text .sub-title {\n        font-size: 18px;\n        color: #222222; }\n      index .feature .text .heading {\n        font-size: 24px;\n        color: #00816a; }\n    index .feature .image {\n      text-align: center !important;\n      margin-bottom: 30px; }\n  index .quickly-understand .video {\n    width: auto;\n    margin-top: 48px; }\n    index .quickly-understand .video .play-btn {\n      display: none; }\n  index .highlights .content {\n    padding: 28px 8px; }\n    index .highlights .content .highlight {\n      width: 100%;\n      padding: 18px 0; }\n      index .highlights .content .highlight:not(:last-child) {\n        border-bottom: 1px solid #e8eaea; }\n      index .highlights .content .highlight .description {\n        height: auto; }\n  index .organizations {\n    padding-bottom: 0; }\n    index .organizations .content {\n      padding: 28px 8px 0;\n      height: 900px; }\n      index .organizations .content .organization {\n        width: 50%;\n        min-height: 92px;\n        margin-bottom: 20px;\n        text-align: center; }\n    index .organizations .rn-carousel-control.rn-carousel-control-prev {\n      left: -20px; }\n    index .organizations .rn-carousel-control.rn-carousel-control-next {\n      right: -20px; } }\n", ""]);

// exports


/***/ }),
/* 825 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8717a319251c58ff6e9bf7ea6ceae987.png";

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _frontpage = __webpack_require__(828);

var _frontpage2 = _interopRequireDefault(_frontpage);

__webpack_require__(840);

__webpack_require__(842);

__webpack_require__(843);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var frontpageModule = _angular2.default.module('frontpage', ['angular-carousel']).component('frontpage', _frontpage2.default).name;

var states = [{
    name: 'frontpage',
    url: '/',
    component: 'frontpage',
    title: ''
}];

exports.default = { name: frontpageModule, states: states };

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _frontpage = __webpack_require__(829);

var _frontpage2 = _interopRequireDefault(_frontpage);

var _frontpage3 = __webpack_require__(832);

var _frontpage4 = _interopRequireDefault(_frontpage3);

__webpack_require__(833);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var frontpageComponent = {
    restrict: 'E',
    bindings: {
        appUser: '='
    },
    template: _frontpage2.default,
    controller: _frontpage4.default
};

exports.default = frontpageComponent;

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<div class=\"headline\">\n    <div class=\"carousel-box\" >\n        <ul class=\"slide-box\" rn-carousel rn-rn-carousel-html-slides=\"slides\" rn-carousel-auto-slide rn-carousel-index=\"carousel.index\">\n            <li class=\"slide bg01\" >\n                <div class=\"content with-mobile-logo\">\n                    <!--<a class=\"mobile-logo\" ui-sref=\"app.face.frontpage.frontpage\">-->\n                        <!--<logo></logo>-->\n                    <!--</a>-->\n                    <div class=\"text\" translate=\"face-frontpage-text001\"></div>\n                    <div class=\"description\">\n                        <div class=\"line\" translate=\"face-frontpage-text0021\"></div>\n                    </div>\n\n                </div>\n            </li>\n            <li class=\"slide bg011\">\n               <div class=\"content with-mobile-logo\">\n                   <!-- <a class=\"mobile-logo\" ui-sref=\"app.face.frontpage.frontpage\">\n                       <logo></logo>\n                   </a> -->\n                   <div class=\"description\">\n                       <div class=\"line\" translate=\"face-frontpage-text0022\"></div>\n                   </div>\n                   <div class=\"text\" translate=\"face-frontpage-text0023\"></div>\n\n               </div>\n           </li>\n            <li class=\"slide bg02\">\n                <div class=\"container\">\n                    <div class=\"right-box\">\n                        <div class=\"heading\" translate=\"face-frontpage-text003\"></div>\n                        <div class=\"summary\" translate=\"face-frontpage-text004\"></div>\n                        <a class=\"extension-download-link\" ui-sref=\"app.face.plugin\" translate=\"face-frontpage-text005\"></a>\n                    </div>\n                    <div class=\"left-box\">\n                        <img src=\"" + __webpack_require__(830) + "\" alt=\"\">\n                    </div>\n                </div>\n\n            </li>\n            <li class=\"slide bg03\">\n                <div class=\"content with-mobile-logo\">\n                    <div class=\"text\"><span class=\"num\">100000+</span>{{\"face-frontpage-text006\" | translate}}</div>\n                    <div class=\"description\">\n                        <div class=\"line\">{{\"face-frontpage-text007\" | translate}}</div>\n                    </div>\n\n                </div>\n            </li>\n            <li class=\"slide bg04\">\n                <div class=\"container\">\n                    <div class=\"left-box\">\n                        <div class=\"heading\">{{\"face-frontpage-text008\" | translate}}</div>\n                        <div class=\"summary\">{{\"face-frontpage-text009\" | translate}}</div>\n                    </div>\n                    <div class=\"right-box\">\n                        <img src=\"" + __webpack_require__(831) + "\" alt=\"\">\n                    </div>\n                </div>\n            </li>\n        </ul>\n        <div class=\"touchbar\" rn-carousel-indicators ng-if=\"slides.length > 1\" slides=\"slides\" rn-carousel-index=\"carousel.index\"></div>\n    </div>\n\n\n    <div class=\"entrances\">\n        <div class=\"container\">\n            <div class=\"entrance\">\n                <a class=\"entrance-btn main-btn\" ui-sref=\"app.face.index.user.form.login\" ng-if=\"!$ctrl.appUser.id\">\n                    <i class=\"ybicon yb-shield\"></i>\n                    <span>{{\"face-frontpage-text010\" | translate}}</span>\n                </a>\n                <a class=\"entrance-btn main-btn\" ui-sref=\"app.home.publish.article.edit\" ng-if=\"$ctrl.appUser.id\">\n                    <i class=\"ybicon yb-shield\"></i>\n                    <span>{{\"face-frontpage-text010\" | translate}}</span>\n                </a>\n            </div>\n            <div class=\"entrance\">\n                <a class=\"entrance-btn main-btn\" ui-sref=\"app.page.search\">\n                    <i class=\"ybicon yb-search\"></i>\n                    <span>{{\"face-frontpage-text011\" | translate}}</span>\n                </a>\n            </div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a57eeed3fa7c9a7c65cdf8b1aa4b9186.png";

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0f6400b6282a7ff2e08aca8088a28873.png";

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FrontpageController = function () {
    FrontpageController.$inject = ["$timeout", "$scope"];

    function FrontpageController($timeout, $scope) {
        "ngInject";

        (0, _classCallCheck3.default)(this, FrontpageController);
        this.$timeout = $timeout;
        this.$scope = $scope;
        this.$onDestroy = function () {
            this.$timeout.cancel(this.$scope.timer);
        };
        $scope.slides = [0, 1, 2, 3, 4];
        $scope.carousel = {
            index: 0
        };
    }

    (0, _createClass3.default)(FrontpageController, [{
        key: "$onInit",
        value: function $onInit() {}
    }]);
    return FrontpageController;
}();

exports.default = FrontpageController;

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(834);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./frontpage.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./frontpage.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "frontpage .headline .carousel-box {\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  position: relative; }\n  frontpage .headline .carousel-box .slide-box {\n    margin: 0;\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    z-index: 1;\n    left: 0;\n    top: 0; }\n    frontpage .headline .carousel-box .slide-box .slide {\n      background-repeat: no-repeat;\n      background-position: center;\n      background-size: auto 100%; }\n      frontpage .headline .carousel-box .slide-box .slide.bg01 {\n        background-image: url(" + __webpack_require__(241) + ");\n        background-size: auto auto; }\n        frontpage .headline .carousel-box .slide-box .slide.bg01 .content {\n          padding-top: 190px; }\n      frontpage .headline .carousel-box .slide-box .slide.bg011 {\n        background-image: url(" + __webpack_require__(329) + ");\n        background-size: auto 602px; }\n        frontpage .headline .carousel-box .slide-box .slide.bg011 .content {\n          padding-top: 190px; }\n          frontpage .headline .carousel-box .slide-box .slide.bg011 .content .description {\n            margin-top: 30px;\n            font-size: 30px;\n            font-weight: 500;\n            letter-spacing: 3px !important; }\n          frontpage .headline .carousel-box .slide-box .slide.bg011 .content .text {\n            font-size: 46px;\n            font-weight: 500;\n            letter-spacing: 4px !important; }\n      frontpage .headline .carousel-box .slide-box .slide.bg02 {\n        display: none;\n        background: url(" + __webpack_require__(835) + ") center bottom no-repeat;\n        background-size: auto auto; }\n        frontpage .headline .carousel-box .slide-box .slide.bg02 .extension-download-link {\n          display: block;\n          margin-top: 20px;\n          font-size: 14px;\n          width: 120px;\n          line-height: 30px;\n          border: 1px solid #fff;\n          color: #fff;\n          text-align: center;\n          text-decoration: none; }\n      frontpage .headline .carousel-box .slide-box .slide.bg03 {\n        display: none;\n        background-image: url(" + __webpack_require__(836) + "); }\n        frontpage .headline .carousel-box .slide-box .slide.bg03 .content {\n          padding-top: 220px; }\n          frontpage .headline .carousel-box .slide-box .slide.bg03 .content .num {\n            color: #ffca28;\n            font-style: italic;\n            padding-right: 10px; }\n      frontpage .headline .carousel-box .slide-box .slide.bg04 {\n        display: none;\n        background-image: url(" + __webpack_require__(837) + "); }\n        frontpage .headline .carousel-box .slide-box .slide.bg04 .container .heading {\n          margin: 18% 0 20px; }\n      frontpage .headline .carousel-box .slide-box .slide .content .description {\n        margin-top: 16px; }\n    frontpage .headline .carousel-box .slide-box .container {\n      padding-top: 120px; }\n      frontpage .headline .carousel-box .slide-box .container .left-box {\n        width: 50%;\n        float: left; }\n      frontpage .headline .carousel-box .slide-box .container .right-box {\n        width: 50%;\n        float: right; }\n      frontpage .headline .carousel-box .slide-box .container .heading {\n        font-size: 36px;\n        font-weight: bold;\n        color: #26ffa0;\n        margin: 8% 0 20px;\n        text-align: left; }\n      frontpage .headline .carousel-box .slide-box .container .summary {\n        font-size: 14px;\n        color: #e5f3ed;\n        line-height: 2;\n        text-align: left; }\n      frontpage .headline .carousel-box .slide-box .container .right-box, frontpage .headline .carousel-box .slide-box .container .left-box {\n        text-align: center; }\n        frontpage .headline .carousel-box .slide-box .container .right-box img, frontpage .headline .carousel-box .slide-box .container .left-box img {\n          max-width: 90%;\n          display: inline-block; }\n  frontpage .headline .carousel-box .touchbar {\n    position: absolute;\n    z-index: 2;\n    left: 0;\n    width: 100%;\n    bottom: 90px;\n    text-align: center;\n    font-size: 0; }\n    frontpage .headline .carousel-box .touchbar .rn-carousel-indicator span {\n      display: inline-block;\n      width: 10px;\n      height: 10px;\n      border-radius: 100%;\n      background: rgba(255, 255, 255, 0.1);\n      margin: 0 5px;\n      cursor: pointer; }\n      frontpage .headline .carousel-box .touchbar .rn-carousel-indicator span.active {\n        background: rgba(255, 255, 255, 0.4); }\n\nfrontpage .headline .entrances {\n  position: absolute;\n  z-index: 2;\n  overflow: auto;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  background: rgba(0, 0, 0, 0.1);\n  padding: 20px 0; }\n  frontpage .headline .entrances .entrance {\n    position: relative;\n    width: 50%;\n    float: left;\n    text-align: center; }\n    frontpage .headline .entrances .entrance:after {\n      content: '';\n      position: absolute;\n      width: 1px;\n      height: 60%;\n      top: 20%;\n      right: 0;\n      background: rgba(255, 255, 255, 0.1); }\n    frontpage .headline .entrances .entrance:last-child:after {\n      display: none; }\n    frontpage .headline .entrances .entrance .entrance-btn {\n      padding: 12px 30px;\n      text-align: center;\n      display: inline-block;\n      font-weight: bold; }\n\n@media only screen and (max-width: 991px) {\n  frontpage .headline .carousel-box .slide-box .slide .container .heading {\n    font-size: 30px; } }\n\n@media only screen and (max-width: 767px) {\n  frontpage .headline .carousel-box .slide-box .slide {\n    background-size: 100% 100%; }\n    frontpage .headline .carousel-box .slide-box .slide.bg01 {\n      background-image: url(" + __webpack_require__(838) + ");\n      background-size: 100% auto;\n      background-position: center bottom; }\n      frontpage .headline .carousel-box .slide-box .slide.bg01 .content {\n        padding-top: 32%; }\n    frontpage .headline .carousel-box .slide-box .slide.bg011 {\n      background-image: url(" + __webpack_require__(329) + ");\n      background-size: auto 100%; }\n      frontpage .headline .carousel-box .slide-box .slide.bg011 .content {\n        padding-top: 190px; }\n        frontpage .headline .carousel-box .slide-box .slide.bg011 .content .description {\n          margin-top: 20px;\n          font-size: 18px; }\n        frontpage .headline .carousel-box .slide-box .slide.bg011 .content .text {\n          font-size: 30px; }\n    frontpage .headline .carousel-box .slide-box .slide.bg02 {\n      background-position: center 75%;\n      background-size: auto 25%; }\n      frontpage .headline .carousel-box .slide-box .slide.bg02 .extension-download-link {\n        margin: 10px auto; }\n    frontpage .headline .carousel-box .slide-box .slide.bg03 {\n      background-image: url(" + __webpack_require__(839) + "); }\n      frontpage .headline .carousel-box .slide-box .slide.bg03 .content {\n        padding-top: 55%; }\n    frontpage .headline .carousel-box .slide-box .slide.bg04 {\n      background: radial-gradient(500px 500px at 50% 30%, #0e6e61, #09524a); }\n      frontpage .headline .carousel-box .slide-box .slide.bg04 .container .heading {\n        margin: 0 0 15px; }\n    frontpage .headline .carousel-box .slide-box .slide .container {\n      padding-top: 32%; }\n      frontpage .headline .carousel-box .slide-box .slide .container .left-box, frontpage .headline .carousel-box .slide-box .slide .container .right-box {\n        width: 80%;\n        float: none;\n        margin: 0 auto 20px;\n        text-align: center; }\n      frontpage .headline .carousel-box .slide-box .slide .container .heading {\n        font-size: 20px;\n        margin: 0 0 15px;\n        text-align: center; }\n      frontpage .headline .carousel-box .slide-box .slide .container .right-box img, frontpage .headline .carousel-box .slide-box .slide .container .left-box img {\n        width: 100%;\n        display: inline-block; }\n    frontpage .headline .carousel-box .slide-box .slide .content .description {\n      margin-top: 16px; }\n  frontpage .headline .carousel-box .touchbar {\n    bottom: 70px; }\n    frontpage .headline .carousel-box .touchbar .item {\n      width: 8px;\n      height: 8px;\n      margin: 0 5px; }\n  frontpage .headline .entrances {\n    padding: 10px 0; }\n    frontpage .headline .entrances .entrance .entrance-btn {\n      padding: 10px 20px; } }\n", ""]);

// exports


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "939e83698b6eaa99cc4fef0c52031c09.png";

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "03a257b2a065b846e898755d1403cedb.png";

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0b45b6b6d8ef77936fb02f7287962ae8.png";

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d27ebf5f23683855c7b2e1b896a81528.png";

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9b6ee50f7ed60b703c4e77237d27e103.png";

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(841);
module.exports = 'ngTouch';


/***/ }),
/* 841 */
/***/ (function(module, exports) {

/**
 * @license AngularJS v1.5.8
 * (c) 2010-2016 Google, Inc. http://angularjs.org
 * License: MIT
 */
(function(window, angular) {'use strict';

/* global ngTouchClickDirectiveFactory: false,
 */

/**
 * @ngdoc module
 * @name ngTouch
 * @description
 *
 * # ngTouch
 *
 * The `ngTouch` module provides touch events and other helpers for touch-enabled devices.
 * The implementation is based on jQuery Mobile touch event handling
 * ([jquerymobile.com](http://jquerymobile.com/)).
 *
 *
 * See {@link ngTouch.$swipe `$swipe`} for usage.
 *
 * <div doc-module-components="ngTouch"></div>
 *
 */

// define ngTouch module
/* global -ngTouch */
var ngTouch = angular.module('ngTouch', []);

ngTouch.provider('$touch', $TouchProvider);

function nodeName_(element) {
  return angular.lowercase(element.nodeName || (element[0] && element[0].nodeName));
}

/**
 * @ngdoc provider
 * @name $touchProvider
 *
 * @description
 * The `$touchProvider` allows enabling / disabling {@link ngTouch.ngClick ngTouch's ngClick directive}.
 */
$TouchProvider.$inject = ['$provide', '$compileProvider'];
function $TouchProvider($provide, $compileProvider) {

  /**
   * @ngdoc method
   * @name  $touchProvider#ngClickOverrideEnabled
   *
   * @param {boolean=} enabled update the ngClickOverrideEnabled state if provided, otherwise just return the
   * current ngClickOverrideEnabled state
   * @returns {*} current value if used as getter or itself (chaining) if used as setter
   *
   * @kind function
   *
   * @description
   * Call this method to enable/disable {@link ngTouch.ngClick ngTouch's ngClick directive}. If enabled,
   * the default ngClick directive will be replaced by a version that eliminates the 300ms delay for
   * click events on browser for touch-devices.
   *
   * The default is `false`.
   *
   */
  var ngClickOverrideEnabled = false;
  var ngClickDirectiveAdded = false;
  this.ngClickOverrideEnabled = function(enabled) {
    if (angular.isDefined(enabled)) {

      if (enabled && !ngClickDirectiveAdded) {
        ngClickDirectiveAdded = true;

        // Use this to identify the correct directive in the delegate
        ngTouchClickDirectiveFactory.$$moduleName = 'ngTouch';
        $compileProvider.directive('ngClick', ngTouchClickDirectiveFactory);

        $provide.decorator('ngClickDirective', ['$delegate', function($delegate) {
          if (ngClickOverrideEnabled) {
            // drop the default ngClick directive
            $delegate.shift();
          } else {
            // drop the ngTouch ngClick directive if the override has been re-disabled (because
            // we cannot de-register added directives)
            var i = $delegate.length - 1;
            while (i >= 0) {
              if ($delegate[i].$$moduleName === 'ngTouch') {
                $delegate.splice(i, 1);
                break;
              }
              i--;
            }
          }

          return $delegate;
        }]);
      }

      ngClickOverrideEnabled = enabled;
      return this;
    }

    return ngClickOverrideEnabled;
  };

  /**
  * @ngdoc service
  * @name $touch
  * @kind object
  *
  * @description
  * Provides the {@link ngTouch.$touch#ngClickOverrideEnabled `ngClickOverrideEnabled`} method.
  *
  */
  this.$get = function() {
    return {
      /**
       * @ngdoc method
       * @name  $touch#ngClickOverrideEnabled
       *
       * @returns {*} current value of `ngClickOverrideEnabled` set in the {@link ngTouch.$touchProvider $touchProvider},
       * i.e. if {@link ngTouch.ngClick ngTouch's ngClick} directive is enabled.
       *
       * @kind function
       */
      ngClickOverrideEnabled: function() {
        return ngClickOverrideEnabled;
      }
    };
  };

}

/* global ngTouch: false */

    /**
     * @ngdoc service
     * @name $swipe
     *
     * @description
     * The `$swipe` service is a service that abstracts the messier details of hold-and-drag swipe
     * behavior, to make implementing swipe-related directives more convenient.
     *
     * Requires the {@link ngTouch `ngTouch`} module to be installed.
     *
     * `$swipe` is used by the `ngSwipeLeft` and `ngSwipeRight` directives in `ngTouch`.
     *
     * # Usage
     * The `$swipe` service is an object with a single method: `bind`. `bind` takes an element
     * which is to be watched for swipes, and an object with four handler functions. See the
     * documentation for `bind` below.
     */

ngTouch.factory('$swipe', [function() {
  // The total distance in any direction before we make the call on swipe vs. scroll.
  var MOVE_BUFFER_RADIUS = 10;

  var POINTER_EVENTS = {
    'mouse': {
      start: 'mousedown',
      move: 'mousemove',
      end: 'mouseup'
    },
    'touch': {
      start: 'touchstart',
      move: 'touchmove',
      end: 'touchend',
      cancel: 'touchcancel'
    },
    'pointer': {
      start: 'pointerdown',
      move: 'pointermove',
      end: 'pointerup',
      cancel: 'pointercancel'
    }
  };

  function getCoordinates(event) {
    var originalEvent = event.originalEvent || event;
    var touches = originalEvent.touches && originalEvent.touches.length ? originalEvent.touches : [originalEvent];
    var e = (originalEvent.changedTouches && originalEvent.changedTouches[0]) || touches[0];

    return {
      x: e.clientX,
      y: e.clientY
    };
  }

  function getEvents(pointerTypes, eventType) {
    var res = [];
    angular.forEach(pointerTypes, function(pointerType) {
      var eventName = POINTER_EVENTS[pointerType][eventType];
      if (eventName) {
        res.push(eventName);
      }
    });
    return res.join(' ');
  }

  return {
    /**
     * @ngdoc method
     * @name $swipe#bind
     *
     * @description
     * The main method of `$swipe`. It takes an element to be watched for swipe motions, and an
     * object containing event handlers.
     * The pointer types that should be used can be specified via the optional
     * third argument, which is an array of strings `'mouse'`, `'touch'` and `'pointer'`. By default,
     * `$swipe` will listen for `mouse`, `touch` and `pointer` events.
     *
     * The four events are `start`, `move`, `end`, and `cancel`. `start`, `move`, and `end`
     * receive as a parameter a coordinates object of the form `{ x: 150, y: 310 }` and the raw
     * `event`. `cancel` receives the raw `event` as its single parameter.
     *
     * `start` is called on either `mousedown`, `touchstart` or `pointerdown`. After this event, `$swipe` is
     * watching for `touchmove`, `mousemove` or `pointermove` events. These events are ignored until the total
     * distance moved in either dimension exceeds a small threshold.
     *
     * Once this threshold is exceeded, either the horizontal or vertical delta is greater.
     * - If the horizontal distance is greater, this is a swipe and `move` and `end` events follow.
     * - If the vertical distance is greater, this is a scroll, and we let the browser take over.
     *   A `cancel` event is sent.
     *
     * `move` is called on `mousemove`, `touchmove` and `pointermove` after the above logic has determined that
     * a swipe is in progress.
     *
     * `end` is called when a swipe is successfully completed with a `touchend`, `mouseup` or `pointerup`.
     *
     * `cancel` is called either on a `touchcancel` or `pointercancel`  from the browser, or when we begin scrolling
     * as described above.
     *
     */
    bind: function(element, eventHandlers, pointerTypes) {
      // Absolute total movement, used to control swipe vs. scroll.
      var totalX, totalY;
      // Coordinates of the start position.
      var startCoords;
      // Last event's position.
      var lastPos;
      // Whether a swipe is active.
      var active = false;

      pointerTypes = pointerTypes || ['mouse', 'touch', 'pointer'];
      element.on(getEvents(pointerTypes, 'start'), function(event) {
        startCoords = getCoordinates(event);
        active = true;
        totalX = 0;
        totalY = 0;
        lastPos = startCoords;
        eventHandlers['start'] && eventHandlers['start'](startCoords, event);
      });
      var events = getEvents(pointerTypes, 'cancel');
      if (events) {
        element.on(events, function(event) {
          active = false;
          eventHandlers['cancel'] && eventHandlers['cancel'](event);
        });
      }

      element.on(getEvents(pointerTypes, 'move'), function(event) {
        if (!active) return;

        // Android will send a touchcancel if it thinks we're starting to scroll.
        // So when the total distance (+ or - or both) exceeds 10px in either direction,
        // we either:
        // - On totalX > totalY, we send preventDefault() and treat this as a swipe.
        // - On totalY > totalX, we let the browser handle it as a scroll.

        if (!startCoords) return;
        var coords = getCoordinates(event);

        totalX += Math.abs(coords.x - lastPos.x);
        totalY += Math.abs(coords.y - lastPos.y);

        lastPos = coords;

        if (totalX < MOVE_BUFFER_RADIUS && totalY < MOVE_BUFFER_RADIUS) {
          return;
        }

        // One of totalX or totalY has exceeded the buffer, so decide on swipe vs. scroll.
        if (totalY > totalX) {
          // Allow native scrolling to take over.
          active = false;
          eventHandlers['cancel'] && eventHandlers['cancel'](event);
          return;
        } else {
          // Prevent the browser from scrolling.
          event.preventDefault();
          eventHandlers['move'] && eventHandlers['move'](coords, event);
        }
      });

      element.on(getEvents(pointerTypes, 'end'), function(event) {
        if (!active) return;
        active = false;
        eventHandlers['end'] && eventHandlers['end'](getCoordinates(event), event);
      });
    }
  };
}]);

/* global ngTouch: false,
  nodeName_: false
*/

/**
 * @ngdoc directive
 * @name ngClick
 * @deprecated
 *
 * @description
 * <div class="alert alert-danger">
 * **DEPRECATION NOTICE**: Beginning with Angular 1.5, this directive is deprecated and by default **disabled**.
 * The directive will receive no further support and might be removed from future releases.
 * If you need the directive, you can enable it with the {@link ngTouch.$touchProvider $touchProvider#ngClickOverrideEnabled}
 * function. We also recommend that you migrate to [FastClick](https://github.com/ftlabs/fastclick).
 * To learn more about the 300ms delay, this [Telerik article](http://developer.telerik.com/featured/300-ms-click-delay-ios-8/)
 * gives a good overview.
 * </div>
 * A more powerful replacement for the default ngClick designed to be used on touchscreen
 * devices. Most mobile browsers wait about 300ms after a tap-and-release before sending
 * the click event. This version handles them immediately, and then prevents the
 * following click event from propagating.
 *
 * Requires the {@link ngTouch `ngTouch`} module to be installed.
 *
 * This directive can fall back to using an ordinary click event, and so works on desktop
 * browsers as well as mobile.
 *
 * This directive also sets the CSS class `ng-click-active` while the element is being held
 * down (by a mouse click or touch) so you can restyle the depressed element if you wish.
 *
 * @element ANY
 * @param {expression} ngClick {@link guide/expression Expression} to evaluate
 * upon tap. (Event object is available as `$event`)
 *
 * @example
    <example module="ngClickExample" deps="angular-touch.js">
      <file name="index.html">
        <button ng-click="count = count + 1" ng-init="count=0">
          Increment
        </button>
        count: {{ count }}
      </file>
      <file name="script.js">
        angular.module('ngClickExample', ['ngTouch']);
      </file>
    </example>
 */

var ngTouchClickDirectiveFactory = ['$parse', '$timeout', '$rootElement',
    function($parse, $timeout, $rootElement) {
  var TAP_DURATION = 750; // Shorter than 750ms is a tap, longer is a taphold or drag.
  var MOVE_TOLERANCE = 12; // 12px seems to work in most mobile browsers.
  var PREVENT_DURATION = 2500; // 2.5 seconds maximum from preventGhostClick call to click
  var CLICKBUSTER_THRESHOLD = 25; // 25 pixels in any dimension is the limit for busting clicks.

  var ACTIVE_CLASS_NAME = 'ng-click-active';
  var lastPreventedTime;
  var touchCoordinates;
  var lastLabelClickCoordinates;


  // TAP EVENTS AND GHOST CLICKS
  //
  // Why tap events?
  // Mobile browsers detect a tap, then wait a moment (usually ~300ms) to see if you're
  // double-tapping, and then fire a click event.
  //
  // This delay sucks and makes mobile apps feel unresponsive.
  // So we detect touchstart, touchcancel and touchend ourselves and determine when
  // the user has tapped on something.
  //
  // What happens when the browser then generates a click event?
  // The browser, of course, also detects the tap and fires a click after a delay. This results in
  // tapping/clicking twice. We do "clickbusting" to prevent it.
  //
  // How does it work?
  // We attach global touchstart and click handlers, that run during the capture (early) phase.
  // So the sequence for a tap is:
  // - global touchstart: Sets an "allowable region" at the point touched.
  // - element's touchstart: Starts a touch
  // (- touchcancel ends the touch, no click follows)
  // - element's touchend: Determines if the tap is valid (didn't move too far away, didn't hold
  //   too long) and fires the user's tap handler. The touchend also calls preventGhostClick().
  // - preventGhostClick() removes the allowable region the global touchstart created.
  // - The browser generates a click event.
  // - The global click handler catches the click, and checks whether it was in an allowable region.
  //     - If preventGhostClick was called, the region will have been removed, the click is busted.
  //     - If the region is still there, the click proceeds normally. Therefore clicks on links and
  //       other elements without ngTap on them work normally.
  //
  // This is an ugly, terrible hack!
  // Yeah, tell me about it. The alternatives are using the slow click events, or making our users
  // deal with the ghost clicks, so I consider this the least of evils. Fortunately Angular
  // encapsulates this ugly logic away from the user.
  //
  // Why not just put click handlers on the element?
  // We do that too, just to be sure. If the tap event caused the DOM to change,
  // it is possible another element is now in that position. To take account for these possibly
  // distinct elements, the handlers are global and care only about coordinates.

  // Checks if the coordinates are close enough to be within the region.
  function hit(x1, y1, x2, y2) {
    return Math.abs(x1 - x2) < CLICKBUSTER_THRESHOLD && Math.abs(y1 - y2) < CLICKBUSTER_THRESHOLD;
  }

  // Checks a list of allowable regions against a click location.
  // Returns true if the click should be allowed.
  // Splices out the allowable region from the list after it has been used.
  function checkAllowableRegions(touchCoordinates, x, y) {
    for (var i = 0; i < touchCoordinates.length; i += 2) {
      if (hit(touchCoordinates[i], touchCoordinates[i + 1], x, y)) {
        touchCoordinates.splice(i, i + 2);
        return true; // allowable region
      }
    }
    return false; // No allowable region; bust it.
  }

  // Global click handler that prevents the click if it's in a bustable zone and preventGhostClick
  // was called recently.
  function onClick(event) {
    if (Date.now() - lastPreventedTime > PREVENT_DURATION) {
      return; // Too old.
    }

    var touches = event.touches && event.touches.length ? event.touches : [event];
    var x = touches[0].clientX;
    var y = touches[0].clientY;
    // Work around desktop Webkit quirk where clicking a label will fire two clicks (on the label
    // and on the input element). Depending on the exact browser, this second click we don't want
    // to bust has either (0,0), negative coordinates, or coordinates equal to triggering label
    // click event
    if (x < 1 && y < 1) {
      return; // offscreen
    }
    if (lastLabelClickCoordinates &&
        lastLabelClickCoordinates[0] === x && lastLabelClickCoordinates[1] === y) {
      return; // input click triggered by label click
    }
    // reset label click coordinates on first subsequent click
    if (lastLabelClickCoordinates) {
      lastLabelClickCoordinates = null;
    }
    // remember label click coordinates to prevent click busting of trigger click event on input
    if (nodeName_(event.target) === 'label') {
      lastLabelClickCoordinates = [x, y];
    }

    // Look for an allowable region containing this click.
    // If we find one, that means it was created by touchstart and not removed by
    // preventGhostClick, so we don't bust it.
    if (checkAllowableRegions(touchCoordinates, x, y)) {
      return;
    }

    // If we didn't find an allowable region, bust the click.
    event.stopPropagation();
    event.preventDefault();

    // Blur focused form elements
    event.target && event.target.blur && event.target.blur();
  }


  // Global touchstart handler that creates an allowable region for a click event.
  // This allowable region can be removed by preventGhostClick if we want to bust it.
  function onTouchStart(event) {
    var touches = event.touches && event.touches.length ? event.touches : [event];
    var x = touches[0].clientX;
    var y = touches[0].clientY;
    touchCoordinates.push(x, y);

    $timeout(function() {
      // Remove the allowable region.
      for (var i = 0; i < touchCoordinates.length; i += 2) {
        if (touchCoordinates[i] == x && touchCoordinates[i + 1] == y) {
          touchCoordinates.splice(i, i + 2);
          return;
        }
      }
    }, PREVENT_DURATION, false);
  }

  // On the first call, attaches some event handlers. Then whenever it gets called, it creates a
  // zone around the touchstart where clicks will get busted.
  function preventGhostClick(x, y) {
    if (!touchCoordinates) {
      $rootElement[0].addEventListener('click', onClick, true);
      $rootElement[0].addEventListener('touchstart', onTouchStart, true);
      touchCoordinates = [];
    }

    lastPreventedTime = Date.now();

    checkAllowableRegions(touchCoordinates, x, y);
  }

  // Actual linking function.
  return function(scope, element, attr) {
    var clickHandler = $parse(attr.ngClick),
        tapping = false,
        tapElement,  // Used to blur the element after a tap.
        startTime,   // Used to check if the tap was held too long.
        touchStartX,
        touchStartY;

    function resetState() {
      tapping = false;
      element.removeClass(ACTIVE_CLASS_NAME);
    }

    element.on('touchstart', function(event) {
      tapping = true;
      tapElement = event.target ? event.target : event.srcElement; // IE uses srcElement.
      // Hack for Safari, which can target text nodes instead of containers.
      if (tapElement.nodeType == 3) {
        tapElement = tapElement.parentNode;
      }

      element.addClass(ACTIVE_CLASS_NAME);

      startTime = Date.now();

      // Use jQuery originalEvent
      var originalEvent = event.originalEvent || event;
      var touches = originalEvent.touches && originalEvent.touches.length ? originalEvent.touches : [originalEvent];
      var e = touches[0];
      touchStartX = e.clientX;
      touchStartY = e.clientY;
    });

    element.on('touchcancel', function(event) {
      resetState();
    });

    element.on('touchend', function(event) {
      var diff = Date.now() - startTime;

      // Use jQuery originalEvent
      var originalEvent = event.originalEvent || event;
      var touches = (originalEvent.changedTouches && originalEvent.changedTouches.length) ?
          originalEvent.changedTouches :
          ((originalEvent.touches && originalEvent.touches.length) ? originalEvent.touches : [originalEvent]);
      var e = touches[0];
      var x = e.clientX;
      var y = e.clientY;
      var dist = Math.sqrt(Math.pow(x - touchStartX, 2) + Math.pow(y - touchStartY, 2));

      if (tapping && diff < TAP_DURATION && dist < MOVE_TOLERANCE) {
        // Call preventGhostClick so the clickbuster will catch the corresponding click.
        preventGhostClick(x, y);

        // Blur the focused element (the button, probably) before firing the callback.
        // This doesn't work perfectly on Android Chrome, but seems to work elsewhere.
        // I couldn't get anything to work reliably on Android Chrome.
        if (tapElement) {
          tapElement.blur();
        }

        if (!angular.isDefined(attr.disabled) || attr.disabled === false) {
          element.triggerHandler('click', [event]);
        }
      }

      resetState();
    });

    // Hack for iOS Safari's benefit. It goes searching for onclick handlers and is liable to click
    // something else nearby.
    element.onclick = function(event) { };

    // Actual click handler.
    // There are three different kinds of clicks, only two of which reach this point.
    // - On desktop browsers without touch events, their clicks will always come here.
    // - On mobile browsers, the simulated "fast" click will call this.
    // - But the browser's follow-up slow click will be "busted" before it reaches this handler.
    // Therefore it's safe to use this directive on both mobile and desktop.
    element.on('click', function(event, touchend) {
      scope.$apply(function() {
        clickHandler(scope, {$event: (touchend || event)});
      });
    });

    element.on('mousedown', function(event) {
      element.addClass(ACTIVE_CLASS_NAME);
    });

    element.on('mousemove mouseup', function(event) {
      element.removeClass(ACTIVE_CLASS_NAME);
    });

  };
}];

/* global ngTouch: false */

/**
 * @ngdoc directive
 * @name ngSwipeLeft
 *
 * @description
 * Specify custom behavior when an element is swiped to the left on a touchscreen device.
 * A leftward swipe is a quick, right-to-left slide of the finger.
 * Though ngSwipeLeft is designed for touch-based devices, it will work with a mouse click and drag
 * too.
 *
 * To disable the mouse click and drag functionality, add `ng-swipe-disable-mouse` to
 * the `ng-swipe-left` or `ng-swipe-right` DOM Element.
 *
 * Requires the {@link ngTouch `ngTouch`} module to be installed.
 *
 * @element ANY
 * @param {expression} ngSwipeLeft {@link guide/expression Expression} to evaluate
 * upon left swipe. (Event object is available as `$event`)
 *
 * @example
    <example module="ngSwipeLeftExample" deps="angular-touch.js">
      <file name="index.html">
        <div ng-show="!showActions" ng-swipe-left="showActions = true">
          Some list content, like an email in the inbox
        </div>
        <div ng-show="showActions" ng-swipe-right="showActions = false">
          <button ng-click="reply()">Reply</button>
          <button ng-click="delete()">Delete</button>
        </div>
      </file>
      <file name="script.js">
        angular.module('ngSwipeLeftExample', ['ngTouch']);
      </file>
    </example>
 */

/**
 * @ngdoc directive
 * @name ngSwipeRight
 *
 * @description
 * Specify custom behavior when an element is swiped to the right on a touchscreen device.
 * A rightward swipe is a quick, left-to-right slide of the finger.
 * Though ngSwipeRight is designed for touch-based devices, it will work with a mouse click and drag
 * too.
 *
 * Requires the {@link ngTouch `ngTouch`} module to be installed.
 *
 * @element ANY
 * @param {expression} ngSwipeRight {@link guide/expression Expression} to evaluate
 * upon right swipe. (Event object is available as `$event`)
 *
 * @example
    <example module="ngSwipeRightExample" deps="angular-touch.js">
      <file name="index.html">
        <div ng-show="!showActions" ng-swipe-left="showActions = true">
          Some list content, like an email in the inbox
        </div>
        <div ng-show="showActions" ng-swipe-right="showActions = false">
          <button ng-click="reply()">Reply</button>
          <button ng-click="delete()">Delete</button>
        </div>
      </file>
      <file name="script.js">
        angular.module('ngSwipeRightExample', ['ngTouch']);
      </file>
    </example>
 */

function makeSwipeDirective(directiveName, direction, eventName) {
  ngTouch.directive(directiveName, ['$parse', '$swipe', function($parse, $swipe) {
    // The maximum vertical delta for a swipe should be less than 75px.
    var MAX_VERTICAL_DISTANCE = 75;
    // Vertical distance should not be more than a fraction of the horizontal distance.
    var MAX_VERTICAL_RATIO = 0.3;
    // At least a 30px lateral motion is necessary for a swipe.
    var MIN_HORIZONTAL_DISTANCE = 30;

    return function(scope, element, attr) {
      var swipeHandler = $parse(attr[directiveName]);

      var startCoords, valid;

      function validSwipe(coords) {
        // Check that it's within the coordinates.
        // Absolute vertical distance must be within tolerances.
        // Horizontal distance, we take the current X - the starting X.
        // This is negative for leftward swipes and positive for rightward swipes.
        // After multiplying by the direction (-1 for left, +1 for right), legal swipes
        // (ie. same direction as the directive wants) will have a positive delta and
        // illegal ones a negative delta.
        // Therefore this delta must be positive, and larger than the minimum.
        if (!startCoords) return false;
        var deltaY = Math.abs(coords.y - startCoords.y);
        var deltaX = (coords.x - startCoords.x) * direction;
        return valid && // Short circuit for already-invalidated swipes.
            deltaY < MAX_VERTICAL_DISTANCE &&
            deltaX > 0 &&
            deltaX > MIN_HORIZONTAL_DISTANCE &&
            deltaY / deltaX < MAX_VERTICAL_RATIO;
      }

      var pointerTypes = ['touch'];
      if (!angular.isDefined(attr['ngSwipeDisableMouse'])) {
        pointerTypes.push('mouse');
      }
      $swipe.bind(element, {
        'start': function(coords, event) {
          startCoords = coords;
          valid = true;
        },
        'cancel': function(event) {
          valid = false;
        },
        'end': function(coords, event) {
          if (validSwipe(coords)) {
            scope.$apply(function() {
              element.triggerHandler(eventName);
              swipeHandler(scope, {$event: event});
            });
          }
        }
      }, pointerTypes);
    };
  }]);
}

// Left is negative X-coordinate, right is positive.
makeSwipeDirective('ngSwipeLeft', -1, 'swipeleft');
makeSwipeDirective('ngSwipeRight', 1, 'swiperight');



})(window, window.angular);


/***/ }),
/* 842 */
/***/ (function(module, exports) {

/**
 * Angular Carousel - Mobile friendly touch carousel for AngularJS
 * @version v1.0.2 - 2017-08-03
 * @link http://revolunet.github.com/angular-carousel
 * @author Julien Bouquillon <julien@revolunet.com>
 * @license MIT License, http://www.opensource.org/licenses/MIT
 */
/*global angular */

/*
Angular touch carousel with CSS GPU accel and slide buffering
http://github.com/revolunet/angular-carousel

*/

angular.module('angular-carousel', [
    'ngTouch',
    'angular-carousel.shifty'
]);

angular.module('angular-carousel')

.directive('rnCarouselAutoSlide', ['$interval', function($interval) {
  return {
    restrict: 'A',
    link: function (scope, element, attrs) {
        var stopAutoPlay = function() {
            if (scope.autoSlider) {
                $interval.cancel(scope.autoSlider);
                scope.autoSlider = null;
            }
        };
        var restartTimer = function() {
            scope.autoSlide();
        };

        scope.$watch('carouselIndex', restartTimer);

        if (attrs.hasOwnProperty('rnCarouselPauseOnHover') && attrs.rnCarouselPauseOnHover !== 'false'){
            element.on('mouseenter', stopAutoPlay);
            element.on('mouseleave', restartTimer);
        }

        scope.$on('$destroy', function(){
            stopAutoPlay();
            element.off('mouseenter', stopAutoPlay);
            element.off('mouseleave', restartTimer);
        });
    }
  };
}]);

angular.module('angular-carousel')

.directive('rnCarouselIndicators', ['$parse', function($parse) {
  return {
    restrict: 'A',
    scope: {
      slides: '=',
      index: '=rnCarouselIndex'
    },
    templateUrl: 'carousel-indicators.html',
    link: function(scope, iElement, iAttributes) {
      var indexModel = $parse(iAttributes.rnCarouselIndex);
      scope.goToSlide = function(index) {
        indexModel.assign(scope.$parent.$parent, index);
      };
    }
  };
}]);

angular.module('angular-carousel').run(['$templateCache', function($templateCache) {
  $templateCache.put('carousel-indicators.html',
      '<div class="rn-carousel-indicator">\n' +
        '<span ng-repeat="slide in slides" ng-class="{active: $index==index}" ng-click="goToSlide($index)">●</span>' +
      '</div>'
  );
}]);

(function() {
    "use strict";

    angular.module('angular-carousel')

    .service('DeviceCapabilities', function() {

        // TODO: merge in a single function

        // detect supported CSS property
        function detectTransformProperty() {
            var transformProperty = 'transform',
                safariPropertyHack = 'webkitTransform';
            if (typeof document.body.style[transformProperty] !== 'undefined') {

                ['webkit', 'moz', 'o', 'ms'].every(function (prefix) {
                    var e = '-' + prefix + '-transform';
                    if (typeof document.body.style[e] !== 'undefined') {
                        transformProperty = e;
                        return false;
                    }
                    return true;
                });
            } else if (typeof document.body.style[safariPropertyHack] !== 'undefined') {
                transformProperty = '-webkit-transform';
            } else {
                transformProperty = undefined;
            }
            return transformProperty;
        }

        //Detect support of translate3d
        function detect3dSupport() {
            var el = document.createElement('p'),
                has3d,
                transforms = {
                    'webkitTransform': '-webkit-transform',
                    'msTransform': '-ms-transform',
                    'transform': 'transform'
                };
            // Add it to the body to get the computed style
            document.body.insertBefore(el, null);
            for (var t in transforms) {
                if (el.style[t] !== undefined) {
                    el.style[t] = 'translate3d(1px,1px,1px)';
                    has3d = window.getComputedStyle(el).getPropertyValue(transforms[t]);
                }
            }
            document.body.removeChild(el);
            return (has3d !== undefined && has3d.length > 0 && has3d !== "none");
        }

        return {
            has3d: detect3dSupport(),
            transformProperty: detectTransformProperty()
        };

    })

    .service('computeCarouselSlideStyle', ["DeviceCapabilities", function(DeviceCapabilities) {
        // compute transition transform properties for a given slide and global offset
        return function(slideIndex, offset, transitionType) {
            var style = {
                    display: 'inline-block'
                },
                opacity,
                absoluteLeft = (slideIndex * 100) + offset,
                slideTransformValue = DeviceCapabilities.has3d ? 'translate3d(' + absoluteLeft + '%, 0, 0)' : 'translate3d(' + absoluteLeft + '%, 0)',
                distance = ((100 - Math.abs(absoluteLeft)) / 100);

            if (!DeviceCapabilities.transformProperty) {
                // fallback to default slide if transformProperty is not available
                style['margin-left'] = absoluteLeft + '%';
            } else {
                if (transitionType == 'fadeAndSlide') {
                    style[DeviceCapabilities.transformProperty] = slideTransformValue;
                    opacity = 0;
                    if (Math.abs(absoluteLeft) < 100) {
                        opacity = 0.3 + distance * 0.7;
                    }
                    style.opacity = opacity;
                } else if (transitionType == 'hexagon') {
                    var transformFrom = 100,
                        degrees = 0,
                        maxDegrees = 60 * (distance - 1);

                    transformFrom = offset < (slideIndex * -100) ? 100 : 0;
                    degrees = offset < (slideIndex * -100) ? maxDegrees : -maxDegrees;
                    style[DeviceCapabilities.transformProperty] = slideTransformValue + ' ' + 'rotateY(' + degrees + 'deg)';
                    style[DeviceCapabilities.transformProperty + '-origin'] = transformFrom + '% 50%';
                } else if (transitionType == 'zoom') {
                    style[DeviceCapabilities.transformProperty] = slideTransformValue;
                    var scale = 1;
                    if (Math.abs(absoluteLeft) < 100) {
                        scale = 1 + ((1 - distance) * 2);
                    }
                    style[DeviceCapabilities.transformProperty] += ' scale(' + scale + ')';
                    style[DeviceCapabilities.transformProperty + '-origin'] = '50% 50%';
                    opacity = 0;
                    if (Math.abs(absoluteLeft) < 100) {
                        opacity = 0.3 + distance * 0.7;
                    }
                    style.opacity = opacity;
                } else {
                    style[DeviceCapabilities.transformProperty] = slideTransformValue;
                }
            }
            return style;
        };
    }])

    .service('createStyleString', function() {
        return function(object) {
            var styles = [];
            angular.forEach(object, function(value, key) {
                styles.push(key + ':' + value);
            });
            return styles.join(';');
        };
    })

    .directive('rnCarousel', ['$swipe', '$window', '$document', '$parse', '$compile', '$timeout', '$interval', 'computeCarouselSlideStyle', 'createStyleString', 'Tweenable',
        function($swipe, $window, $document, $parse, $compile, $timeout, $interval, computeCarouselSlideStyle, createStyleString, Tweenable) {
            // internal ids to allow multiple instances
            var carouselId = 0,
                // in absolute pixels, at which distance the slide stick to the edge on release
                rubberTreshold = 3;

            var requestAnimationFrame = $window.requestAnimationFrame || $window.webkitRequestAnimationFrame || $window.mozRequestAnimationFrame;

            function getItemIndex(collection, target, defaultIndex) {
                var result = defaultIndex;
                collection.every(function(item, index) {
                    if (angular.equals(item, target)) {
                        result = index;
                        return false;
                    }
                    return true;
                });
                return result;
            }

            return {
                restrict: 'A',
                scope: true,
                compile: function(tElement, tAttributes) {
                    // use the compile phase to customize the DOM
                    var firstChild = tElement[0].querySelector('li'),
                        firstChildAttributes = (firstChild) ? firstChild.attributes : [],
                        isRepeatBased = false,
                        isBuffered = false,
                        repeatItem,
                        repeatCollection;

                    // try to find an ngRepeat expression
                    // at this point, the attributes are not yet normalized so we need to try various syntax
                    ['ng-repeat', 'data-ng-repeat', 'ng:repeat', 'x-ng-repeat'].every(function(attr) {
                        var repeatAttribute = firstChildAttributes[attr];
                        if (angular.isDefined(repeatAttribute)) {
                            // ngRepeat regexp extracted from angular 1.2.7 src
                            var exprMatch = repeatAttribute.value.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?\s*$/),
                                trackProperty = exprMatch[3];

                            repeatItem = exprMatch[1];
                            repeatCollection = exprMatch[2];

                            if (repeatItem) {
                                if (angular.isDefined(tAttributes['rnCarouselBuffered'])) {
                                    // update the current ngRepeat expression and add a slice operator if buffered
                                    isBuffered = true;
                                    repeatAttribute.value = repeatItem + ' in ' + repeatCollection + '|carouselSlice:carouselBufferIndex:carouselBufferSize';
                                    if (trackProperty) {
                                        repeatAttribute.value += ' track by ' + trackProperty;
                                    }
                                }
                                isRepeatBased = true;
                                return false;
                            }
                        }
                        return true;
                    });

                    return function(scope, iElement, iAttributes, containerCtrl) {

                        carouselId++;

                        var defaultOptions = {
                            transitionType: iAttributes.rnCarouselTransition || 'slide',
                            transitionEasing: iAttributes.rnCarouselEasing || 'easeTo',
                            transitionDuration: parseInt(iAttributes.rnCarouselDuration, 10) || 300,
                            isSequential: true,
                            autoSlideDuration: 3,
                            bufferSize: 5,
                            /* in container % how much we need to drag to trigger the slide change */
                            moveTreshold: 0.1,
                            defaultIndex: 0
                        };

                        // TODO
                        var options = angular.extend({}, defaultOptions);

                        var pressed,
                            startX,
                            isIndexBound = false,
                            offset = 0,
                            destination,
                            swipeMoved = false,
                            //animOnIndexChange = true,
                            currentSlides = [],
                            elWidth = null,
                            elX = null,
                            animateTransitions = true,
                            intialState = true,
                            animating = false,
                            mouseUpBound = false,
                            locked = false;

                        //rn-swipe-disabled =true will only disable swipe events
                        if(iAttributes.rnSwipeDisabled !== "true") {
                            $swipe.bind(iElement, {
                                start: swipeStart,
                                move: swipeMove,
                                end: swipeEnd,
                                cancel: function(event) {
                                    swipeEnd({}, event);
                                }
                            });
                        }

                        function getSlidesDOM() {
                            var nodes = iElement[0].childNodes;
                            var slides = [];
                            for(var i=0; i<nodes.length ;i++){
                                if(nodes[i].tagName === "LI"){
                                    slides.push(nodes[i]);
                                }
                            }
                            return slides;
                        }

                        function documentMouseUpEvent(event) {
                            // in case we click outside the carousel, trigger a fake swipeEnd
                            swipeMoved = true;
                            swipeEnd({
                                x: event.clientX,
                                y: event.clientY
                            }, event);
                        }

                        function updateSlidesPosition(offset) {
                            // manually apply transformation to carousel childrens
                            // todo : optim : apply only to visible items
                            var x = scope.carouselBufferIndex * 100 + offset;
                            angular.forEach(getSlidesDOM(), function(child, index) {
                                child.style.cssText = createStyleString(computeCarouselSlideStyle(index, x, options.transitionType));
                            });
                        }

                        scope.nextSlide = function(slideOptions) {
                            var index = scope.carouselIndex + 1;
                            if (index > currentSlides.length - 1) {
                                index = 0;
                            }
                            if (!locked) {
                                goToSlide(index, slideOptions);
                            }
                        };

                        scope.prevSlide = function(slideOptions) {
                            var index = scope.carouselIndex - 1;
                            if (index < 0) {
                                index = currentSlides.length - 1;
                            }
                            goToSlide(index, slideOptions);
                        };

                        function goToSlide(index, slideOptions) {
                            //console.log('goToSlide', arguments);
                            // move a to the given slide index
                            if (index === undefined) {
                                index = scope.carouselIndex;
                            }

                            slideOptions = slideOptions || {};
                            if (slideOptions.animate === false || options.transitionType === 'none') {
                                locked = false;
                                offset = index * -100;
                                scope.carouselIndex = index;
                                updateBufferIndex();
                                return;
                            }

                            locked = true;
                            var tweenable = new Tweenable();
                            tweenable.tween({
                                from: {
                                    'x': offset
                                },
                                to: {
                                    'x': index * -100
                                },
                                duration: options.transitionDuration,
                                easing: options.transitionEasing,
                                step: function(state) {
                                    if (isFinite(state.x)) {
                                      updateSlidesPosition(state.x);
                                    }
                                },
                                finish: function() {
                                    scope.$apply(function() {
                                        scope.carouselIndex = index;
                                        offset = index * -100;
                                        updateBufferIndex();
                                        $timeout(function () {
                                          locked = false;
                                        }, 0, false);
                                    });
                                }
                            });
                        }

                        function getContainerWidth() {
                            var rect = iElement[0].getBoundingClientRect();
                            return rect.width ? rect.width : rect.right - rect.left;
                        }

                        function updateContainerWidth() {
                            elWidth = getContainerWidth();
                        }

                        function bindMouseUpEvent() {
                            if (!mouseUpBound) {
                              mouseUpBound = true;
                              $document.bind('mouseup', documentMouseUpEvent);
                            }
                        }

                        function unbindMouseUpEvent() {
                            if (mouseUpBound) {
                              mouseUpBound = false;
                              $document.unbind('mouseup', documentMouseUpEvent);
                            }
                        }

                        function swipeStart(coords, event) {
                            // console.log('swipeStart', coords, event);
                            if (locked || currentSlides.length <= 1) {
                                return;
                            }
                            updateContainerWidth();
                            elX = iElement[0].querySelector('li').getBoundingClientRect().left;
                            pressed = true;
                            startX = coords.x;
                            return false;
                        }

                        function swipeMove(coords, event) {
                            //console.log('swipeMove', coords, event);
                            var x, delta;
                            bindMouseUpEvent();
                            if (pressed) {
                                x = coords.x;
                                delta = startX - x;
                                if (delta > 2 || delta < -2) {
                                    swipeMoved = true;
                                    var moveOffset = offset + (-delta * 100 / elWidth);
                                    updateSlidesPosition(moveOffset);
                                }
                            }
                            return false;
                        }

                        var init = true;
                        scope.carouselIndex = 0;

                        if (!isRepeatBased) {
                            // fake array when no ng-repeat
                            currentSlides = [];
                            angular.forEach(getSlidesDOM(), function(node, index) {
                                currentSlides.push({id: index});
                            });
                            if (iAttributes.rnCarouselHtmlSlides) {
                                var updateParentSlides = function(value) {
                                    slidesModel.assign(scope.$parent, value);
                                };
                                var slidesModel = $parse(iAttributes.rnCarouselHtmlSlides);
                                if (angular.isFunction(slidesModel.assign)) {
                                    /* check if this property is assignable then watch it */
                                    scope.$watch('htmlSlides', function(newValue) {
                                        updateParentSlides(newValue);
                                    });
                                    scope.$parent.$watch(slidesModel, function(newValue, oldValue) {
                                        if (newValue !== undefined && newValue !== null) {
                                            newValue = 0;
                                            updateParentIndex(newValue);
                                        }
                                    });
                                }
                                scope.htmlSlides = currentSlides;
                            }
                        }

                        if (iAttributes.rnCarouselControls!==undefined) {
                            // dont use a directive for this
                            var canloop = ((isRepeatBased ? scope.$eval(repeatCollection.replace('::', '')).length : currentSlides.length) > 1) ? angular.isDefined(tAttributes['rnCarouselControlsAllowLoop']) : false;
                            var nextSlideIndexCompareValue = isRepeatBased ? '(' + repeatCollection.replace('::', '') + ').length - 1' : currentSlides.length - 1;
                            var tpl = '<div class="rn-carousel-controls">\n' +
                                '  <span class="rn-carousel-control rn-carousel-control-prev" ng-click="prevSlide()" ng-if="carouselIndex > 0 || ' + canloop + '"></span>\n' +
                                '  <span class="rn-carousel-control rn-carousel-control-next" ng-click="nextSlide()" ng-if="carouselIndex < ' + nextSlideIndexCompareValue + ' || ' + canloop + '"></span>\n' +
                                '</div>';
                            iElement.parent().append($compile(angular.element(tpl))(scope));
                        }

                        if (iAttributes.rnCarouselAutoSlide!==undefined) {
                            var duration = parseInt(iAttributes.rnCarouselAutoSlide, 10) || options.autoSlideDuration;
                            scope.autoSlide = function() {
                                if (scope.autoSlider) {
                                    $interval.cancel(scope.autoSlider);
                                    scope.autoSlider = null;
                                }
                                scope.autoSlider = $interval(function() {
                                    if (!locked && !pressed) {
                                        scope.nextSlide();
                                    }
                                }, duration * 1000);
                            };
                        }

                        if (iAttributes.rnCarouselDefaultIndex) {
                            var defaultIndexModel = $parse(iAttributes.rnCarouselDefaultIndex);
                            options.defaultIndex = defaultIndexModel(scope.$parent) || 0;
                        }

                        if (iAttributes.rnCarouselIndex) {
                            var updateParentIndex = function(value) {
                                indexModel.assign(scope.$parent, value);
                            };
                            var indexModel = $parse(iAttributes.rnCarouselIndex);
                            if (angular.isFunction(indexModel.assign)) {
                                /* check if this property is assignable then watch it */
                                scope.$watch('carouselIndex', function(newValue) {
                                    updateParentIndex(newValue);
                                });
                                scope.$parent.$watch(indexModel, function(newValue, oldValue) {

                                    if (newValue !== undefined && newValue !== null) {
                                        if (currentSlides && currentSlides.length > 0 && newValue >= currentSlides.length) {
                                            newValue = currentSlides.length - 1;
                                            updateParentIndex(newValue);
                                        } else if (currentSlides && newValue < 0) {
                                            newValue = 0;
                                            updateParentIndex(newValue);
                                        }
                                        if (!locked) {
                                            goToSlide(newValue, {
                                                animate: !init
                                            });
                                        }
                                        init = false;
                                    }
                                });
                                isIndexBound = true;

                                if (options.defaultIndex) {
                                    goToSlide(options.defaultIndex, {
                                        animate: !init
                                    });
                                }
                            } else if (!isNaN(iAttributes.rnCarouselIndex)) {
                                /* if user just set an initial number, set it */
                                goToSlide(parseInt(iAttributes.rnCarouselIndex, 10), {
                                    animate: false
                                });
                            }
                        } else {
                            goToSlide(options.defaultIndex, {
                                animate: !init
                            });
                            init = false;
                        }

                        if (iAttributes.rnCarouselLocked) {
                            scope.$watch(iAttributes.rnCarouselLocked, function(newValue, oldValue) {
                                // only bind swipe when it's not switched off
                                if(newValue === true) {
                                    locked = true;
                                } else {
                                    locked = false;
                                }
                            });
                        }

                        if (isRepeatBased) {
                            // use rn-carousel-deep-watch to fight the Angular $watchCollection weakness : https://github.com/angular/angular.js/issues/2621
                            // optional because it have some performance impacts (deep watch)
                            var deepWatch = (iAttributes.rnCarouselDeepWatch!==undefined);

                            scope[deepWatch?'$watch':'$watchCollection'](repeatCollection, function(newValue, oldValue) {
                                //console.log('repeatCollection', currentSlides);
                                currentSlides = newValue;
                                // if deepWatch ON ,manually compare objects to guess the new position
                                if (!angular.isArray(currentSlides)) {
                                  throw Error('the slides collection must be an Array');
                                }
                                if (deepWatch && angular.isArray(newValue)) {
                                    var activeElement = oldValue[scope.carouselIndex];
                                    var newIndex = getItemIndex(newValue, activeElement, scope.carouselIndex);
                                    goToSlide(newIndex, {animate: false});
                                } else {
                                    goToSlide(scope.carouselIndex, {animate: false});
                                }
                            }, true);
                        }

                        function swipeEnd(coords, event, forceAnimation) {
                            //  console.log('swipeEnd', 'scope.carouselIndex', scope.carouselIndex);
                            // Prevent clicks on buttons inside slider to trigger "swipeEnd" event on touchend/mouseup
                            // console.log(iAttributes.rnCarouselOnInfiniteScroll);
                            if (event && !swipeMoved) {
                                return;
                            }
                            unbindMouseUpEvent();
                            pressed = false;
                            swipeMoved = false;
                            destination = startX - coords.x;
                            if (destination===0) {
                                return;
                            }
                            if (locked) {
                                return;
                            }
                            offset += (-destination * 100 / elWidth);
                            if (options.isSequential) {
                                var minMove = options.moveTreshold * elWidth,
                                    absMove = -destination,
                                    slidesMove = -Math[absMove >= 0 ? 'ceil' : 'floor'](absMove / elWidth),
                                    shouldMove = Math.abs(absMove) > minMove;

                                if (currentSlides && (slidesMove + scope.carouselIndex) >= currentSlides.length) {
                                    slidesMove = currentSlides.length - 1 - scope.carouselIndex;
                                }
                                if ((slidesMove + scope.carouselIndex) < 0) {
                                    slidesMove = -scope.carouselIndex;
                                }
                                var moveOffset = shouldMove ? slidesMove : 0;

                                destination = (scope.carouselIndex + moveOffset);

                                goToSlide(destination);
                                if(iAttributes.rnCarouselOnInfiniteScrollRight!==undefined && slidesMove === 0 && scope.carouselIndex !== 0) {
                                    $parse(iAttributes.rnCarouselOnInfiniteScrollRight)(scope)
                                    goToSlide(0);
                                }
                                if(iAttributes.rnCarouselOnInfiniteScrollLeft!==undefined && slidesMove === 0 && scope.carouselIndex === 0 && moveOffset === 0) {
                                    $parse(iAttributes.rnCarouselOnInfiniteScrollLeft)(scope)
                                    goToSlide(currentSlides.length);
                                }

                            } else {
                                scope.$apply(function() {
                                    scope.carouselIndex = parseInt(-offset / 100, 10);
                                    updateBufferIndex();
                                });

                            }

                        }

                        scope.$on('$destroy', function() {
                            unbindMouseUpEvent();
                        });

                        scope.carouselBufferIndex = 0;
                        scope.carouselBufferSize = options.bufferSize;

                        function updateBufferIndex() {
                            // update and cap te buffer index
                            var bufferIndex = 0;
                            var bufferEdgeSize = (scope.carouselBufferSize - 1) / 2;
                            if (isBuffered) {
                                if (scope.carouselIndex <= bufferEdgeSize) {
                                    // first buffer part
                                    bufferIndex = 0;
                                } else if (currentSlides && currentSlides.length < scope.carouselBufferSize) {
                                    // smaller than buffer
                                    bufferIndex = 0;
                                } else if (currentSlides && scope.carouselIndex > currentSlides.length - scope.carouselBufferSize) {
                                    // last buffer part
                                    bufferIndex = currentSlides.length - scope.carouselBufferSize;
                                } else {
                                    // compute buffer start
                                    bufferIndex = scope.carouselIndex - bufferEdgeSize;
                                }

                                scope.carouselBufferIndex = bufferIndex;
                                $timeout(function() {
                                    updateSlidesPosition(offset);
                                }, 0, false);
                            } else {
                                $timeout(function() {
                                    updateSlidesPosition(offset);
                                }, 0, false);
                            }
                        }

                        function onOrientationChange() {
                            updateContainerWidth();
                            goToSlide();
                        }

                        // handle orientation change
                        var winEl = angular.element($window);
                        winEl.bind('orientationchange', onOrientationChange);
                        winEl.bind('resize', onOrientationChange);

                        scope.$on('$destroy', function() {
                            unbindMouseUpEvent();
                            winEl.unbind('orientationchange', onOrientationChange);
                            winEl.unbind('resize', onOrientationChange);
                        });
                    };
                }
            };
        }
    ]);
})();



angular.module('angular-carousel.shifty', [])

.factory('Tweenable', function() {

    /*! shifty - v1.3.4 - 2014-10-29 - http://jeremyckahn.github.io/shifty */
  ;(function (root) {

  /*!
   * Shifty Core
   * By Jeremy Kahn - jeremyckahn@gmail.com
   */

  var Tweenable = (function () {

    'use strict';

    // Aliases that get defined later in this function
    var formula;

    // CONSTANTS
    var DEFAULT_SCHEDULE_FUNCTION;
    var DEFAULT_EASING = 'linear';
    var DEFAULT_DURATION = 500;
    var UPDATE_TIME = 1000 / 60;

    var _now = Date.now
         ? Date.now
         : function () {return +new Date();};

    var now = typeof SHIFTY_DEBUG_NOW !== 'undefined' ? SHIFTY_DEBUG_NOW : _now;

    if (typeof window !== 'undefined') {
      // requestAnimationFrame() shim by Paul Irish (modified for Shifty)
      // http://paulirish.com/2011/requestanimationframe-for-smart-animating/
      DEFAULT_SCHEDULE_FUNCTION = window.requestAnimationFrame
         || window.webkitRequestAnimationFrame
         || window.oRequestAnimationFrame
         || window.msRequestAnimationFrame
         || (window.mozCancelRequestAnimationFrame
         && window.mozRequestAnimationFrame)
         || setTimeout;
    } else {
      DEFAULT_SCHEDULE_FUNCTION = setTimeout;
    }

    function noop () {
      // NOOP!
    }

    /*!
     * Handy shortcut for doing a for-in loop. This is not a "normal" each
     * function, it is optimized for Shifty.  The iterator function only receives
     * the property name, not the value.
     * @param {Object} obj
     * @param {Function(string)} fn
     */
    function each (obj, fn) {
      var key;
      for (key in obj) {
        if (Object.hasOwnProperty.call(obj, key)) {
          fn(key);
        }
      }
    }

    /*!
     * Perform a shallow copy of Object properties.
     * @param {Object} targetObject The object to copy into
     * @param {Object} srcObject The object to copy from
     * @return {Object} A reference to the augmented `targetObj` Object
     */
    function shallowCopy (targetObj, srcObj) {
      each(srcObj, function (prop) {
        targetObj[prop] = srcObj[prop];
      });

      return targetObj;
    }

    /*!
     * Copies each property from src onto target, but only if the property to
     * copy to target is undefined.
     * @param {Object} target Missing properties in this Object are filled in
     * @param {Object} src
     */
    function defaults (target, src) {
      each(src, function (prop) {
        if (typeof target[prop] === 'undefined') {
          target[prop] = src[prop];
        }
      });
    }

    /*!
     * Calculates the interpolated tween values of an Object for a given
     * timestamp.
     * @param {Number} forPosition The position to compute the state for.
     * @param {Object} currentState Current state properties.
     * @param {Object} originalState: The original state properties the Object is
     * tweening from.
     * @param {Object} targetState: The destination state properties the Object
     * is tweening to.
     * @param {number} duration: The length of the tween in milliseconds.
     * @param {number} timestamp: The UNIX epoch time at which the tween began.
     * @param {Object} easing: This Object's keys must correspond to the keys in
     * targetState.
     */
    function tweenProps (forPosition, currentState, originalState, targetState,
      duration, timestamp, easing) {
      var normalizedPosition = (forPosition - timestamp) / duration;

      var prop;
      for (prop in currentState) {
        if (currentState.hasOwnProperty(prop)) {
          currentState[prop] = tweenProp(originalState[prop],
            targetState[prop], formula[easing[prop]], normalizedPosition);
        }
      }

      return currentState;
    }

    /*!
     * Tweens a single property.
     * @param {number} start The value that the tween started from.
     * @param {number} end The value that the tween should end at.
     * @param {Function} easingFunc The easing curve to apply to the tween.
     * @param {number} position The normalized position (between 0.0 and 1.0) to
     * calculate the midpoint of 'start' and 'end' against.
     * @return {number} The tweened value.
     */
    function tweenProp (start, end, easingFunc, position) {
      return start + (end - start) * easingFunc(position);
    }

    /*!
     * Applies a filter to Tweenable instance.
     * @param {Tweenable} tweenable The `Tweenable` instance to call the filter
     * upon.
     * @param {String} filterName The name of the filter to apply.
     */
    function applyFilter (tweenable, filterName) {
      var filters = Tweenable.prototype.filter;
      var args = tweenable._filterArgs;

      each(filters, function (name) {
        if (typeof filters[name][filterName] !== 'undefined') {
          filters[name][filterName].apply(tweenable, args);
        }
      });
    }

    var timeoutHandler_endTime;
    var timeoutHandler_currentTime;
    var timeoutHandler_isEnded;
    var timeoutHandler_offset;
    /*!
     * Handles the update logic for one step of a tween.
     * @param {Tweenable} tweenable
     * @param {number} timestamp
     * @param {number} duration
     * @param {Object} currentState
     * @param {Object} originalState
     * @param {Object} targetState
     * @param {Object} easing
     * @param {Function(Object, *, number)} step
     * @param {Function(Function,number)}} schedule
     */
    function timeoutHandler (tweenable, timestamp, duration, currentState,
      originalState, targetState, easing, step, schedule) {
      timeoutHandler_endTime = timestamp + duration;
      timeoutHandler_currentTime = Math.min(now(), timeoutHandler_endTime);
      timeoutHandler_isEnded =
        timeoutHandler_currentTime >= timeoutHandler_endTime;

      timeoutHandler_offset = duration - (
          timeoutHandler_endTime - timeoutHandler_currentTime);

      if (tweenable.isPlaying() && !timeoutHandler_isEnded) {
        tweenable._scheduleId = schedule(tweenable._timeoutHandler, UPDATE_TIME);

        applyFilter(tweenable, 'beforeTween');
        tweenProps(timeoutHandler_currentTime, currentState, originalState,
          targetState, duration, timestamp, easing);
        applyFilter(tweenable, 'afterTween');

        step(currentState, tweenable._attachment, timeoutHandler_offset);
      } else if (timeoutHandler_isEnded) {
        step(targetState, tweenable._attachment, timeoutHandler_offset);
        tweenable.stop(true);
      }
    }


    /*!
     * Creates a usable easing Object from either a string or another easing
     * Object.  If `easing` is an Object, then this function clones it and fills
     * in the missing properties with "linear".
     * @param {Object} fromTweenParams
     * @param {Object|string} easing
     */
    function composeEasingObject (fromTweenParams, easing) {
      var composedEasing = {};

      if (typeof easing === 'string') {
        each(fromTweenParams, function (prop) {
          composedEasing[prop] = easing;
        });
      } else {
        each(fromTweenParams, function (prop) {
          if (!composedEasing[prop]) {
            composedEasing[prop] = easing[prop] || DEFAULT_EASING;
          }
        });
      }

      return composedEasing;
    }

    /**
     * Tweenable constructor.
     * @param {Object=} opt_initialState The values that the initial tween should start at if a "from" object is not provided to Tweenable#tween.
     * @param {Object=} opt_config See Tweenable.prototype.setConfig()
     * @constructor
     */
    function Tweenable (opt_initialState, opt_config) {
      this._currentState = opt_initialState || {};
      this._configured = false;
      this._scheduleFunction = DEFAULT_SCHEDULE_FUNCTION;

      // To prevent unnecessary calls to setConfig do not set default configuration here.
      // Only set default configuration immediately before tweening if none has been set.
      if (typeof opt_config !== 'undefined') {
        this.setConfig(opt_config);
      }
    }

    /**
     * Configure and start a tween.
     * @param {Object=} opt_config See Tweenable.prototype.setConfig()
     * @return {Tweenable}
     */
    Tweenable.prototype.tween = function (opt_config) {
      if (this._isTweening) {
        return this;
      }

      // Only set default config if no configuration has been set previously and none is provided now.
      if (opt_config !== undefined || !this._configured) {
        this.setConfig(opt_config);
      }

      this._timestamp = now();
      this._start(this.get(), this._attachment);
      return this.resume();
    };

    /**
     * Sets the tween configuration. `config` may have the following options:
     *
     * - __from__ (_Object=_): Starting position.  If omitted, the current state is used.
     * - __to__ (_Object=_): Ending position.
     * - __duration__ (_number=_): How many milliseconds to animate for.
     * - __start__ (_Function(Object)_): Function to execute when the tween begins.  Receives the state of the tween as the first parameter. Attachment is the second parameter.
     * - __step__ (_Function(Object, *, number)_): Function to execute on every tick.  Receives the state of the tween as the first parameter. Attachment is the second parameter, and the time elapsed since the start of the tween is the third parameter. This function is not called on the final step of the animation, but `finish` is.
     * - __finish__ (_Function(Object, *)_): Function to execute upon tween completion.  Receives the state of the tween as the first parameter. Attachment is the second parameter.
     * - __easing__ (_Object|string=_): Easing curve name(s) to use for the tween.
     * - __attachment__ (_Object|string|any=_): Value that is attached to this instance and passed on to the step/start/finish methods.
     * @param {Object} config
     * @return {Tweenable}
     */
    Tweenable.prototype.setConfig = function (config) {
      config = config || {};
      this._configured = true;

      // Attach something to this Tweenable instance (e.g.: a DOM element, an object, a string, etc.);
      this._attachment = config.attachment;

      // Init the internal state
      this._pausedAtTime = null;
      this._scheduleId = null;
      this._start = config.start || noop;
      this._step = config.step || noop;
      this._finish = config.finish || noop;
      this._duration = config.duration || DEFAULT_DURATION;
      this._currentState = config.from || this.get();
      this._originalState = this.get();
      this._targetState = config.to || this.get();

      // Aliases used below
      var currentState = this._currentState;
      var targetState = this._targetState;

      // Ensure that there is always something to tween to.
      defaults(targetState, currentState);

      this._easing = composeEasingObject(
        currentState, config.easing || DEFAULT_EASING);

      this._filterArgs =
        [currentState, this._originalState, targetState, this._easing];

      applyFilter(this, 'tweenCreated');
      return this;
    };

    /**
     * Gets the current state.
     * @return {Object}
     */
    Tweenable.prototype.get = function () {
      return shallowCopy({}, this._currentState);
    };

    /**
     * Sets the current state.
     * @param {Object} state
     */
    Tweenable.prototype.set = function (state) {
      this._currentState = state;
    };

    /**
     * Pauses a tween.  Paused tweens can be resumed from the point at which they were paused.  This is different than [`stop()`](#stop), as that method causes a tween to start over when it is resumed.
     * @return {Tweenable}
     */
    Tweenable.prototype.pause = function () {
      this._pausedAtTime = now();
      this._isPaused = true;
      return this;
    };

    /**
     * Resumes a paused tween.
     * @return {Tweenable}
     */
    Tweenable.prototype.resume = function () {
      if (this._isPaused) {
        this._timestamp += now() - this._pausedAtTime;
      }

      this._isPaused = false;
      this._isTweening = true;

      var self = this;
      this._timeoutHandler = function () {
        timeoutHandler(self, self._timestamp, self._duration, self._currentState,
          self._originalState, self._targetState, self._easing, self._step,
          self._scheduleFunction);
      };

      this._timeoutHandler();

      return this;
    };

    /**
     * Move the state of the animation to a specific point in the tween's timeline.
     * If the animation is not running, this will cause the `step` handlers to be
     * called.
     * @param {millisecond} millisecond The millisecond of the animation to seek to.
     * @return {Tweenable}
     */
    Tweenable.prototype.seek = function (millisecond) {
      this._timestamp = now() - millisecond;

      if (!this.isPlaying()) {
        this._isTweening = true;
        this._isPaused = false;

        // If the animation is not running, call timeoutHandler to make sure that
        // any step handlers are run.
        timeoutHandler(this, this._timestamp, this._duration, this._currentState,
          this._originalState, this._targetState, this._easing, this._step,
          this._scheduleFunction);

        this._timeoutHandler();
        this.pause();
      }

      return this;
    };

    /**
     * Stops and cancels a tween.
     * @param {boolean=} gotoEnd If false or omitted, the tween just stops at its current state, and the "finish" handler is not invoked.  If true, the tweened object's values are instantly set to the target values, and "finish" is invoked.
     * @return {Tweenable}
     */
    Tweenable.prototype.stop = function (gotoEnd) {
      this._isTweening = false;
      this._isPaused = false;
      this._timeoutHandler = noop;

      (root.cancelAnimationFrame            ||
        root.webkitCancelAnimationFrame     ||
        root.oCancelAnimationFrame          ||
        root.msCancelAnimationFrame         ||
        root.mozCancelRequestAnimationFrame ||
        root.clearTimeout)(this._scheduleId);

      if (gotoEnd) {
        shallowCopy(this._currentState, this._targetState);
        applyFilter(this, 'afterTweenEnd');
        this._finish.call(this, this._currentState, this._attachment);
      }

      return this;
    };

    /**
     * Returns whether or not a tween is running.
     * @return {boolean}
     */
    Tweenable.prototype.isPlaying = function () {
      return this._isTweening && !this._isPaused;
    };

    /**
     * Sets a custom schedule function.
     *
     * If a custom function is not set the default one is used [`requestAnimationFrame`](https://developer.mozilla.org/en-US/docs/Web/API/window.requestAnimationFrame) if available, otherwise [`setTimeout`](https://developer.mozilla.org/en-US/docs/Web/API/Window.setTimeout)).
     *
     * @param {Function(Function,number)} scheduleFunction The function to be called to schedule the next frame to be rendered
     */
    Tweenable.prototype.setScheduleFunction = function (scheduleFunction) {
      this._scheduleFunction = scheduleFunction;
    };

    /**
     * `delete`s all "own" properties.  Call this when the `Tweenable` instance is no longer needed to free memory.
     */
    Tweenable.prototype.dispose = function () {
      var prop;
      for (prop in this) {
        if (this.hasOwnProperty(prop)) {
          delete this[prop];
        }
      }
    };

    /*!
     * Filters are used for transforming the properties of a tween at various
     * points in a Tweenable's life cycle.  See the README for more info on this.
     */
    Tweenable.prototype.filter = {};

    /*!
     * This object contains all of the tweens available to Shifty.  It is extendible - simply attach properties to the Tweenable.prototype.formula Object following the same format at linear.
     *
     * `pos` should be a normalized `number` (between 0 and 1).
     */
    Tweenable.prototype.formula = {
      linear: function (pos) {
        return pos;
      }
    };

    formula = Tweenable.prototype.formula;

    shallowCopy(Tweenable, {
      'now': now
      ,'each': each
      ,'tweenProps': tweenProps
      ,'tweenProp': tweenProp
      ,'applyFilter': applyFilter
      ,'shallowCopy': shallowCopy
      ,'defaults': defaults
      ,'composeEasingObject': composeEasingObject
    });

    root.Tweenable = Tweenable;
    return Tweenable;

  } ());

  /*!
   * All equations are adapted from Thomas Fuchs' [Scripty2](https://github.com/madrobby/scripty2/blob/master/src/effects/transitions/penner.js).
   *
   * Based on Easing Equations (c) 2003 [Robert Penner](http://www.robertpenner.com/), all rights reserved. This work is [subject to terms](http://www.robertpenner.com/easing_terms_of_use.html).
   */

  /*!
   *  TERMS OF USE - EASING EQUATIONS
   *  Open source under the BSD License.
   *  Easing Equations (c) 2003 Robert Penner, all rights reserved.
   */

  ;(function () {

    Tweenable.shallowCopy(Tweenable.prototype.formula, {
      easeInQuad: function (pos) {
        return Math.pow(pos, 2);
      },

      easeOutQuad: function (pos) {
        return -(Math.pow((pos - 1), 2) - 1);
      },

      easeInOutQuad: function (pos) {
        if ((pos /= 0.5) < 1) {return 0.5 * Math.pow(pos,2);}
        return -0.5 * ((pos -= 2) * pos - 2);
      },

      easeInCubic: function (pos) {
        return Math.pow(pos, 3);
      },

      easeOutCubic: function (pos) {
        return (Math.pow((pos - 1), 3) + 1);
      },

      easeInOutCubic: function (pos) {
        if ((pos /= 0.5) < 1) {return 0.5 * Math.pow(pos,3);}
        return 0.5 * (Math.pow((pos - 2),3) + 2);
      },

      easeInQuart: function (pos) {
        return Math.pow(pos, 4);
      },

      easeOutQuart: function (pos) {
        return -(Math.pow((pos - 1), 4) - 1);
      },

      easeInOutQuart: function (pos) {
        if ((pos /= 0.5) < 1) {return 0.5 * Math.pow(pos,4);}
        return -0.5 * ((pos -= 2) * Math.pow(pos,3) - 2);
      },

      easeInQuint: function (pos) {
        return Math.pow(pos, 5);
      },

      easeOutQuint: function (pos) {
        return (Math.pow((pos - 1), 5) + 1);
      },

      easeInOutQuint: function (pos) {
        if ((pos /= 0.5) < 1) {return 0.5 * Math.pow(pos,5);}
        return 0.5 * (Math.pow((pos - 2),5) + 2);
      },

      easeInSine: function (pos) {
        return -Math.cos(pos * (Math.PI / 2)) + 1;
      },

      easeOutSine: function (pos) {
        return Math.sin(pos * (Math.PI / 2));
      },

      easeInOutSine: function (pos) {
        return (-0.5 * (Math.cos(Math.PI * pos) - 1));
      },

      easeInExpo: function (pos) {
        return (pos === 0) ? 0 : Math.pow(2, 10 * (pos - 1));
      },

      easeOutExpo: function (pos) {
        return (pos === 1) ? 1 : -Math.pow(2, -10 * pos) + 1;
      },

      easeInOutExpo: function (pos) {
        if (pos === 0) {return 0;}
        if (pos === 1) {return 1;}
        if ((pos /= 0.5) < 1) {return 0.5 * Math.pow(2,10 * (pos - 1));}
        return 0.5 * (-Math.pow(2, -10 * --pos) + 2);
      },

      easeInCirc: function (pos) {
        return -(Math.sqrt(1 - (pos * pos)) - 1);
      },

      easeOutCirc: function (pos) {
        return Math.sqrt(1 - Math.pow((pos - 1), 2));
      },

      easeInOutCirc: function (pos) {
        if ((pos /= 0.5) < 1) {return -0.5 * (Math.sqrt(1 - pos * pos) - 1);}
        return 0.5 * (Math.sqrt(1 - (pos -= 2) * pos) + 1);
      },

      easeOutBounce: function (pos) {
        if ((pos) < (1 / 2.75)) {
          return (7.5625 * pos * pos);
        } else if (pos < (2 / 2.75)) {
          return (7.5625 * (pos -= (1.5 / 2.75)) * pos + 0.75);
        } else if (pos < (2.5 / 2.75)) {
          return (7.5625 * (pos -= (2.25 / 2.75)) * pos + 0.9375);
        } else {
          return (7.5625 * (pos -= (2.625 / 2.75)) * pos + 0.984375);
        }
      },

      easeInBack: function (pos) {
        var s = 1.70158;
        return (pos) * pos * ((s + 1) * pos - s);
      },

      easeOutBack: function (pos) {
        var s = 1.70158;
        return (pos = pos - 1) * pos * ((s + 1) * pos + s) + 1;
      },

      easeInOutBack: function (pos) {
        var s = 1.70158;
        if ((pos /= 0.5) < 1) {return 0.5 * (pos * pos * (((s *= (1.525)) + 1) * pos - s));}
        return 0.5 * ((pos -= 2) * pos * (((s *= (1.525)) + 1) * pos + s) + 2);
      },

      elastic: function (pos) {
        return -1 * Math.pow(4,-8 * pos) * Math.sin((pos * 6 - 1) * (2 * Math.PI) / 2) + 1;
      },

      swingFromTo: function (pos) {
        var s = 1.70158;
        return ((pos /= 0.5) < 1) ? 0.5 * (pos * pos * (((s *= (1.525)) + 1) * pos - s)) :
            0.5 * ((pos -= 2) * pos * (((s *= (1.525)) + 1) * pos + s) + 2);
      },

      swingFrom: function (pos) {
        var s = 1.70158;
        return pos * pos * ((s + 1) * pos - s);
      },

      swingTo: function (pos) {
        var s = 1.70158;
        return (pos -= 1) * pos * ((s + 1) * pos + s) + 1;
      },

      bounce: function (pos) {
        if (pos < (1 / 2.75)) {
          return (7.5625 * pos * pos);
        } else if (pos < (2 / 2.75)) {
          return (7.5625 * (pos -= (1.5 / 2.75)) * pos + 0.75);
        } else if (pos < (2.5 / 2.75)) {
          return (7.5625 * (pos -= (2.25 / 2.75)) * pos + 0.9375);
        } else {
          return (7.5625 * (pos -= (2.625 / 2.75)) * pos + 0.984375);
        }
      },

      bouncePast: function (pos) {
        if (pos < (1 / 2.75)) {
          return (7.5625 * pos * pos);
        } else if (pos < (2 / 2.75)) {
          return 2 - (7.5625 * (pos -= (1.5 / 2.75)) * pos + 0.75);
        } else if (pos < (2.5 / 2.75)) {
          return 2 - (7.5625 * (pos -= (2.25 / 2.75)) * pos + 0.9375);
        } else {
          return 2 - (7.5625 * (pos -= (2.625 / 2.75)) * pos + 0.984375);
        }
      },

      easeFromTo: function (pos) {
        if ((pos /= 0.5) < 1) {return 0.5 * Math.pow(pos,4);}
        return -0.5 * ((pos -= 2) * Math.pow(pos,3) - 2);
      },

      easeFrom: function (pos) {
        return Math.pow(pos,4);
      },

      easeTo: function (pos) {
        return Math.pow(pos,0.25);
      }
    });

  }());

  /*!
   * The Bezier magic in this file is adapted/copied almost wholesale from
   * [Scripty2](https://github.com/madrobby/scripty2/blob/master/src/effects/transitions/cubic-bezier.js),
   * which was adapted from Apple code (which probably came from
   * [here](http://opensource.apple.com/source/WebCore/WebCore-955.66/platform/graphics/UnitBezier.h)).
   * Special thanks to Apple and Thomas Fuchs for much of this code.
   */

  /*!
   *  Copyright (c) 2006 Apple Computer, Inc. All rights reserved.
   *
   *  Redistribution and use in source and binary forms, with or without
   *  modification, are permitted provided that the following conditions are met:
   *
   *  1. Redistributions of source code must retain the above copyright notice,
   *  this list of conditions and the following disclaimer.
   *
   *  2. Redistributions in binary form must reproduce the above copyright notice,
   *  this list of conditions and the following disclaimer in the documentation
   *  and/or other materials provided with the distribution.
   *
   *  3. Neither the name of the copyright holder(s) nor the names of any
   *  contributors may be used to endorse or promote products derived from
   *  this software without specific prior written permission.
   *
   *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
   *  "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
   *  THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
   *  ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE
   *  FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
   *  (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
   *  LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON
   *  ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
   *  (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
   *  SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
   */
  ;(function () {
    // port of webkit cubic bezier handling by http://www.netzgesta.de/dev/
    function cubicBezierAtTime(t,p1x,p1y,p2x,p2y,duration) {
      var ax = 0,bx = 0,cx = 0,ay = 0,by = 0,cy = 0;
      function sampleCurveX(t) {return ((ax * t + bx) * t + cx) * t;}
      function sampleCurveY(t) {return ((ay * t + by) * t + cy) * t;}
      function sampleCurveDerivativeX(t) {return (3.0 * ax * t + 2.0 * bx) * t + cx;}
      function solveEpsilon(duration) {return 1.0 / (200.0 * duration);}
      function solve(x,epsilon) {return sampleCurveY(solveCurveX(x,epsilon));}
      function fabs(n) {if (n >= 0) {return n;}else {return 0 - n;}}
      function solveCurveX(x,epsilon) {
        var t0,t1,t2,x2,d2,i;
        for (t2 = x, i = 0; i < 8; i++) {x2 = sampleCurveX(t2) - x; if (fabs(x2) < epsilon) {return t2;} d2 = sampleCurveDerivativeX(t2); if (fabs(d2) < 1e-6) {break;} t2 = t2 - x2 / d2;}
        t0 = 0.0; t1 = 1.0; t2 = x; if (t2 < t0) {return t0;} if (t2 > t1) {return t1;}
        while (t0 < t1) {x2 = sampleCurveX(t2); if (fabs(x2 - x) < epsilon) {return t2;} if (x > x2) {t0 = t2;}else {t1 = t2;} t2 = (t1 - t0) * 0.5 + t0;}
        return t2; // Failure.
      }
      cx = 3.0 * p1x; bx = 3.0 * (p2x - p1x) - cx; ax = 1.0 - cx - bx; cy = 3.0 * p1y; by = 3.0 * (p2y - p1y) - cy; ay = 1.0 - cy - by;
      return solve(t, solveEpsilon(duration));
    }
    /*!
     *  getCubicBezierTransition(x1, y1, x2, y2) -> Function
     *
     *  Generates a transition easing function that is compatible
     *  with WebKit's CSS transitions `-webkit-transition-timing-function`
     *  CSS property.
     *
     *  The W3C has more information about
     *  <a href="http://www.w3.org/TR/css3-transitions/#transition-timing-function_tag">
     *  CSS3 transition timing functions</a>.
     *
     *  @param {number} x1
     *  @param {number} y1
     *  @param {number} x2
     *  @param {number} y2
     *  @return {function}
     */
    function getCubicBezierTransition (x1, y1, x2, y2) {
      return function (pos) {
        return cubicBezierAtTime(pos,x1,y1,x2,y2,1);
      };
    }
    // End ported code

    /**
     * Creates a Bezier easing function and attaches it to `Tweenable.prototype.formula`.  This function gives you total control over the easing curve.  Matthew Lein's [Ceaser](http://matthewlein.com/ceaser/) is a useful tool for visualizing the curves you can make with this function.
     *
     * @param {string} name The name of the easing curve.  Overwrites the old easing function on Tweenable.prototype.formula if it exists.
     * @param {number} x1
     * @param {number} y1
     * @param {number} x2
     * @param {number} y2
     * @return {function} The easing function that was attached to Tweenable.prototype.formula.
     */
    Tweenable.setBezierFunction = function (name, x1, y1, x2, y2) {
      var cubicBezierTransition = getCubicBezierTransition(x1, y1, x2, y2);
      cubicBezierTransition.x1 = x1;
      cubicBezierTransition.y1 = y1;
      cubicBezierTransition.x2 = x2;
      cubicBezierTransition.y2 = y2;

      return Tweenable.prototype.formula[name] = cubicBezierTransition;
    };


    /**
     * `delete`s an easing function from `Tweenable.prototype.formula`.  Be careful with this method, as it `delete`s whatever easing formula matches `name` (which means you can delete default Shifty easing functions).
     *
     * @param {string} name The name of the easing function to delete.
     * @return {function}
     */
    Tweenable.unsetBezierFunction = function (name) {
      delete Tweenable.prototype.formula[name];
    };

  })();

  ;(function () {

    function getInterpolatedValues (
      from, current, targetState, position, easing) {
      return Tweenable.tweenProps(
        position, current, from, targetState, 1, 0, easing);
    }

    // Fake a Tweenable and patch some internals.  This approach allows us to
    // skip uneccessary processing and object recreation, cutting down on garbage
    // collection pauses.
    var mockTweenable = new Tweenable();
    mockTweenable._filterArgs = [];

    /**
     * Compute the midpoint of two Objects.  This method effectively calculates a specific frame of animation that [Tweenable#tween](shifty.core.js.html#tween) does many times over the course of a tween.
     *
     * Example:
     *
     *     var interpolatedValues = Tweenable.interpolate({
     *       width: '100px',
     *       opacity: 0,
     *       color: '#fff'
     *     }, {
     *       width: '200px',
     *       opacity: 1,
     *       color: '#000'
     *     }, 0.5);
     *
     *     console.log(interpolatedValues);
     *     // {opacity: 0.5, width: "150px", color: "rgb(127,127,127)"}
     *
     * @param {Object} from The starting values to tween from.
     * @param {Object} targetState The ending values to tween to.
     * @param {number} position The normalized position value (between 0.0 and 1.0) to interpolate the values between `from` and `to` for.  `from` represents 0 and `to` represents `1`.
     * @param {string|Object} easing The easing curve(s) to calculate the midpoint against.  You can reference any easing function attached to `Tweenable.prototype.formula`.  If omitted, this defaults to "linear".
     * @return {Object}
     */
    Tweenable.interpolate = function (from, targetState, position, easing) {
      var current = Tweenable.shallowCopy({}, from);
      var easingObject = Tweenable.composeEasingObject(
        from, easing || 'linear');

      mockTweenable.set({});

      // Alias and reuse the _filterArgs array instead of recreating it.
      var filterArgs = mockTweenable._filterArgs;
      filterArgs.length = 0;
      filterArgs[0] = current;
      filterArgs[1] = from;
      filterArgs[2] = targetState;
      filterArgs[3] = easingObject;

      // Any defined value transformation must be applied
      Tweenable.applyFilter(mockTweenable, 'tweenCreated');
      Tweenable.applyFilter(mockTweenable, 'beforeTween');

      var interpolatedValues = getInterpolatedValues(
        from, current, targetState, position, easingObject);

      // Transform values back into their original format
      Tweenable.applyFilter(mockTweenable, 'afterTween');

      return interpolatedValues;
    };

  }());

  /**
   * Adds string interpolation support to Shifty.
   *
   * The Token extension allows Shifty to tween numbers inside of strings.  Among
   * other things, this allows you to animate CSS properties.  For example, you
   * can do this:
   *
   *     var tweenable = new Tweenable();
   *     tweenable.tween({
   *       from: { transform: 'translateX(45px)'},
   *       to: { transform: 'translateX(90xp)'}
   *     });
   *
   * ` `
   * `translateX(45)` will be tweened to `translateX(90)`.  To demonstrate:
   *
   *     var tweenable = new Tweenable();
   *     tweenable.tween({
   *       from: { transform: 'translateX(45px)'},
   *       to: { transform: 'translateX(90px)'},
   *       step: function (state) {
   *         console.log(state.transform);
   *       }
   *     });
   *
   * ` `
   * The above snippet will log something like this in the console:
   *
   *     translateX(60.3px)
   *     ...
   *     translateX(76.05px)
   *     ...
   *     translateX(90px)
   *
   * ` `
   * Another use for this is animating colors:
   *
   *     var tweenable = new Tweenable();
   *     tweenable.tween({
   *       from: { color: 'rgb(0,255,0)'},
   *       to: { color: 'rgb(255,0,255)'},
   *       step: function (state) {
   *         console.log(state.color);
   *       }
   *     });
   *
   * ` `
   * The above snippet will log something like this:
   *
   *     rgb(84,170,84)
   *     ...
   *     rgb(170,84,170)
   *     ...
   *     rgb(255,0,255)
   *
   * ` `
   * This extension also supports hexadecimal colors, in both long (`#ff00ff`)
   * and short (`#f0f`) forms.  Be aware that hexadecimal input values will be
   * converted into the equivalent RGB output values.  This is done to optimize
   * for performance.
   *
   *     var tweenable = new Tweenable();
   *     tweenable.tween({
   *       from: { color: '#0f0'},
   *       to: { color: '#f0f'},
   *       step: function (state) {
   *         console.log(state.color);
   *       }
   *     });
   *
   * ` `
   * This snippet will generate the same output as the one before it because
   * equivalent values were supplied (just in hexadecimal form rather than RGB):
   *
   *     rgb(84,170,84)
   *     ...
   *     rgb(170,84,170)
   *     ...
   *     rgb(255,0,255)
   *
   * ` `
   * ` `
   * ## Easing support
   *
   * Easing works somewhat differently in the Token extension.  This is because
   * some CSS properties have multiple values in them, and you might need to
   * tween each value along its own easing curve.  A basic example:
   *
   *     var tweenable = new Tweenable();
   *     tweenable.tween({
   *       from: { transform: 'translateX(0px) translateY(0px)'},
   *       to: { transform:   'translateX(100px) translateY(100px)'},
   *       easing: { transform: 'easeInQuad' },
   *       step: function (state) {
   *         console.log(state.transform);
   *       }
   *     });
   *
   * ` `
   * The above snippet create values like this:
   *
   *     translateX(11.560000000000002px) translateY(11.560000000000002px)
   *     ...
   *     translateX(46.24000000000001px) translateY(46.24000000000001px)
   *     ...
   *     translateX(100px) translateY(100px)
   *
   * ` `
   * In this case, the values for `translateX` and `translateY` are always the
   * same for each step of the tween, because they have the same start and end
   * points and both use the same easing curve.  We can also tween `translateX`
   * and `translateY` along independent curves:
   *
   *     var tweenable = new Tweenable();
   *     tweenable.tween({
   *       from: { transform: 'translateX(0px) translateY(0px)'},
   *       to: { transform:   'translateX(100px) translateY(100px)'},
   *       easing: { transform: 'easeInQuad bounce' },
   *       step: function (state) {
   *         console.log(state.transform);
   *       }
   *     });
   *
   * ` `
   * The above snippet create values like this:
   *
   *     translateX(10.89px) translateY(82.355625px)
   *     ...
   *     translateX(44.89000000000001px) translateY(86.73062500000002px)
   *     ...
   *     translateX(100px) translateY(100px)
   *
   * ` `
   * `translateX` and `translateY` are not in sync anymore, because `easeInQuad`
   * was specified for `translateX` and `bounce` for `translateY`.  Mixing and
   * matching easing curves can make for some interesting motion in your
   * animations.
   *
   * The order of the space-separated easing curves correspond the token values
   * they apply to.  If there are more token values than easing curves listed,
   * the last easing curve listed is used.
   */
  function token () {
    // Functionality for this extension runs implicitly if it is loaded.
  } /*!*/

  // token function is defined above only so that dox-foundation sees it as
  // documentation and renders it.  It is never used, and is optimized away at
  // build time.

  ;(function (Tweenable) {

    /*!
     * @typedef {{
     *   formatString: string
     *   chunkNames: Array.<string>
     * }}
     */
    var formatManifest;

    // CONSTANTS

    var R_NUMBER_COMPONENT = /(\d|\-|\.)/;
    var R_FORMAT_CHUNKS = /([^\-0-9\.]+)/g;
    var R_UNFORMATTED_VALUES = /[0-9.\-]+/g;
    var R_RGB = new RegExp(
      'rgb\\(' + R_UNFORMATTED_VALUES.source +
      (/,\s*/.source) + R_UNFORMATTED_VALUES.source +
      (/,\s*/.source) + R_UNFORMATTED_VALUES.source + '\\)', 'g');
    var R_RGB_PREFIX = /^.*\(/;
    var R_HEX = /#([0-9]|[a-f]){3,6}/gi;
    var VALUE_PLACEHOLDER = 'VAL';

    // HELPERS

    var getFormatChunksFrom_accumulator = [];
    /*!
     * @param {Array.number} rawValues
     * @param {string} prefix
     *
     * @return {Array.<string>}
     */
    function getFormatChunksFrom (rawValues, prefix) {
      getFormatChunksFrom_accumulator.length = 0;

      var rawValuesLength = rawValues.length;
      var i;

      for (i = 0; i < rawValuesLength; i++) {
        getFormatChunksFrom_accumulator.push('_' + prefix + '_' + i);
      }

      return getFormatChunksFrom_accumulator;
    }

    /*!
     * @param {string} formattedString
     *
     * @return {string}
     */
    function getFormatStringFrom (formattedString) {
      var chunks = formattedString.match(R_FORMAT_CHUNKS);

      if (!chunks) {
        // chunks will be null if there were no tokens to parse in
        // formattedString (for example, if formattedString is '2').  Coerce
        // chunks to be useful here.
        chunks = ['', ''];

        // If there is only one chunk, assume that the string is a number
        // followed by a token...
        // NOTE: This may be an unwise assumption.
      } else if (chunks.length === 1 ||
          // ...or if the string starts with a number component (".", "-", or a
          // digit)...
          formattedString[0].match(R_NUMBER_COMPONENT)) {
        // ...prepend an empty string here to make sure that the formatted number
        // is properly replaced by VALUE_PLACEHOLDER
        chunks.unshift('');
      }

      return chunks.join(VALUE_PLACEHOLDER);
    }

    /*!
     * Convert all hex color values within a string to an rgb string.
     *
     * @param {Object} stateObject
     *
     * @return {Object} The modified obj
     */
    function sanitizeObjectForHexProps (stateObject) {
      Tweenable.each(stateObject, function (prop) {
        var currentProp = stateObject[prop];

        if (typeof currentProp === 'string' && currentProp.match(R_HEX)) {
          stateObject[prop] = sanitizeHexChunksToRGB(currentProp);
        }
      });
    }

    /*!
     * @param {string} str
     *
     * @return {string}
     */
    function  sanitizeHexChunksToRGB (str) {
      return filterStringChunks(R_HEX, str, convertHexToRGB);
    }

    /*!
     * @param {string} hexString
     *
     * @return {string}
     */
    function convertHexToRGB (hexString) {
      var rgbArr = hexToRGBArray(hexString);
      return 'rgb(' + rgbArr[0] + ',' + rgbArr[1] + ',' + rgbArr[2] + ')';
    }

    var hexToRGBArray_returnArray = [];
    /*!
     * Convert a hexadecimal string to an array with three items, one each for
     * the red, blue, and green decimal values.
     *
     * @param {string} hex A hexadecimal string.
     *
     * @returns {Array.<number>} The converted Array of RGB values if `hex` is a
     * valid string, or an Array of three 0's.
     */
    function hexToRGBArray (hex) {

      hex = hex.replace(/#/, '');

      // If the string is a shorthand three digit hex notation, normalize it to
      // the standard six digit notation
      if (hex.length === 3) {
        hex = hex.split('');
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
      }

      hexToRGBArray_returnArray[0] = hexToDec(hex.substr(0, 2));
      hexToRGBArray_returnArray[1] = hexToDec(hex.substr(2, 2));
      hexToRGBArray_returnArray[2] = hexToDec(hex.substr(4, 2));

      return hexToRGBArray_returnArray;
    }

    /*!
     * Convert a base-16 number to base-10.
     *
     * @param {Number|String} hex The value to convert
     *
     * @returns {Number} The base-10 equivalent of `hex`.
     */
    function hexToDec (hex) {
      return parseInt(hex, 16);
    }

    /*!
     * Runs a filter operation on all chunks of a string that match a RegExp
     *
     * @param {RegExp} pattern
     * @param {string} unfilteredString
     * @param {function(string)} filter
     *
     * @return {string}
     */
    function filterStringChunks (pattern, unfilteredString, filter) {
      var pattenMatches = unfilteredString.match(pattern);
      var filteredString = unfilteredString.replace(pattern, VALUE_PLACEHOLDER);

      if (pattenMatches) {
        var pattenMatchesLength = pattenMatches.length;
        var currentChunk;

        for (var i = 0; i < pattenMatchesLength; i++) {
          currentChunk = pattenMatches.shift();
          filteredString = filteredString.replace(
            VALUE_PLACEHOLDER, filter(currentChunk));
        }
      }

      return filteredString;
    }

    /*!
     * Check for floating point values within rgb strings and rounds them.
     *
     * @param {string} formattedString
     *
     * @return {string}
     */
    function sanitizeRGBChunks (formattedString) {
      return filterStringChunks(R_RGB, formattedString, sanitizeRGBChunk);
    }

    /*!
     * @param {string} rgbChunk
     *
     * @return {string}
     */
    function sanitizeRGBChunk (rgbChunk) {
      var numbers = rgbChunk.match(R_UNFORMATTED_VALUES);
      var numbersLength = numbers.length;
      var sanitizedString = rgbChunk.match(R_RGB_PREFIX)[0];

      for (var i = 0; i < numbersLength; i++) {
        sanitizedString += parseInt(numbers[i], 10) + ',';
      }

      sanitizedString = sanitizedString.slice(0, -1) + ')';

      return sanitizedString;
    }

    /*!
     * @param {Object} stateObject
     *
     * @return {Object} An Object of formatManifests that correspond to
     * the string properties of stateObject
     */
    function getFormatManifests (stateObject) {
      var manifestAccumulator = {};

      Tweenable.each(stateObject, function (prop) {
        var currentProp = stateObject[prop];

        if (typeof currentProp === 'string') {
          var rawValues = getValuesFrom(currentProp);

          manifestAccumulator[prop] = {
            'formatString': getFormatStringFrom(currentProp)
            ,'chunkNames': getFormatChunksFrom(rawValues, prop)
          };
        }
      });

      return manifestAccumulator;
    }

    /*!
     * @param {Object} stateObject
     * @param {Object} formatManifests
     */
    function expandFormattedProperties (stateObject, formatManifests) {
      Tweenable.each(formatManifests, function (prop) {
        var currentProp = stateObject[prop];
        var rawValues = getValuesFrom(currentProp);
        var rawValuesLength = rawValues.length;

        for (var i = 0; i < rawValuesLength; i++) {
          stateObject[formatManifests[prop].chunkNames[i]] = +rawValues[i];
        }

        delete stateObject[prop];
      });
    }

    /*!
     * @param {Object} stateObject
     * @param {Object} formatManifests
     */
    function collapseFormattedProperties (stateObject, formatManifests) {
      Tweenable.each(formatManifests, function (prop) {
        var currentProp = stateObject[prop];
        var formatChunks = extractPropertyChunks(
          stateObject, formatManifests[prop].chunkNames);
        var valuesList = getValuesList(
          formatChunks, formatManifests[prop].chunkNames);
        currentProp = getFormattedValues(
          formatManifests[prop].formatString, valuesList);
        stateObject[prop] = sanitizeRGBChunks(currentProp);
      });
    }

    /*!
     * @param {Object} stateObject
     * @param {Array.<string>} chunkNames
     *
     * @return {Object} The extracted value chunks.
     */
    function extractPropertyChunks (stateObject, chunkNames) {
      var extractedValues = {};
      var currentChunkName, chunkNamesLength = chunkNames.length;

      for (var i = 0; i < chunkNamesLength; i++) {
        currentChunkName = chunkNames[i];
        extractedValues[currentChunkName] = stateObject[currentChunkName];
        delete stateObject[currentChunkName];
      }

      return extractedValues;
    }

    var getValuesList_accumulator = [];
    /*!
     * @param {Object} stateObject
     * @param {Array.<string>} chunkNames
     *
     * @return {Array.<number>}
     */
    function getValuesList (stateObject, chunkNames) {
      getValuesList_accumulator.length = 0;
      var chunkNamesLength = chunkNames.length;

      for (var i = 0; i < chunkNamesLength; i++) {
        getValuesList_accumulator.push(stateObject[chunkNames[i]]);
      }

      return getValuesList_accumulator;
    }

    /*!
     * @param {string} formatString
     * @param {Array.<number>} rawValues
     *
     * @return {string}
     */
    function getFormattedValues (formatString, rawValues) {
      var formattedValueString = formatString;
      var rawValuesLength = rawValues.length;

      for (var i = 0; i < rawValuesLength; i++) {
        formattedValueString = formattedValueString.replace(
          VALUE_PLACEHOLDER, +rawValues[i].toFixed(4));
      }

      return formattedValueString;
    }

    /*!
     * Note: It's the duty of the caller to convert the Array elements of the
     * return value into numbers.  This is a performance optimization.
     *
     * @param {string} formattedString
     *
     * @return {Array.<string>|null}
     */
    function getValuesFrom (formattedString) {
      return formattedString.match(R_UNFORMATTED_VALUES);
    }

    /*!
     * @param {Object} easingObject
     * @param {Object} tokenData
     */
    function expandEasingObject (easingObject, tokenData) {
      Tweenable.each(tokenData, function (prop) {
        var currentProp = tokenData[prop];
        var chunkNames = currentProp.chunkNames;
        var chunkLength = chunkNames.length;
        var easingChunks = easingObject[prop].split(' ');
        var lastEasingChunk = easingChunks[easingChunks.length - 1];

        for (var i = 0; i < chunkLength; i++) {
          easingObject[chunkNames[i]] = easingChunks[i] || lastEasingChunk;
        }

        delete easingObject[prop];
      });
    }

    /*!
     * @param {Object} easingObject
     * @param {Object} tokenData
     */
    function collapseEasingObject (easingObject, tokenData) {
      Tweenable.each(tokenData, function (prop) {
        var currentProp = tokenData[prop];
        var chunkNames = currentProp.chunkNames;
        var chunkLength = chunkNames.length;
        var composedEasingString = '';

        for (var i = 0; i < chunkLength; i++) {
          composedEasingString += ' ' + easingObject[chunkNames[i]];
          delete easingObject[chunkNames[i]];
        }

        easingObject[prop] = composedEasingString.substr(1);
      });
    }

    Tweenable.prototype.filter.token = {
      'tweenCreated': function (currentState, fromState, toState, easingObject) {
        sanitizeObjectForHexProps(currentState);
        sanitizeObjectForHexProps(fromState);
        sanitizeObjectForHexProps(toState);
        this._tokenData = getFormatManifests(currentState);
      },

      'beforeTween': function (currentState, fromState, toState, easingObject) {
        expandEasingObject(easingObject, this._tokenData);
        expandFormattedProperties(currentState, this._tokenData);
        expandFormattedProperties(fromState, this._tokenData);
        expandFormattedProperties(toState, this._tokenData);
      },

      'afterTween': function (currentState, fromState, toState, easingObject) {
        collapseFormattedProperties(currentState, this._tokenData);
        collapseFormattedProperties(fromState, this._tokenData);
        collapseFormattedProperties(toState, this._tokenData);
        collapseEasingObject(easingObject, this._tokenData);
      }
    };

  } (Tweenable));

  }(window));

  return window.Tweenable;
});

(function() {
    "use strict";

    angular.module('angular-carousel')

    .filter('carouselSlice', function() {
        return function(collection, start, size) {
            if (angular.isArray(collection)) {
                return collection.slice(start, start + size);
            } else if (angular.isObject(collection)) {
                // dont try to slice collections :)
                return collection;
            }
        };
    });

})();


/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(844);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../css-loader/index.js!./angular-carousel.min.css", function() {
			var newContent = require("!!../../css-loader/index.js!./angular-carousel.min.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "input[type=range]{width:300px}ul[rn-carousel]{overflow:hidden;padding:0;white-space:nowrap;position:relative;-webkit-perspective:1000px;-ms-perspective:1000px;perspective:1000px;-ms-touch-action:pan-y;touch-action:pan-y}ul[rn-carousel]>li{color:#000;-webkit-backface-visibility:hidden;-ms-backface-visibility:hidden;backface-visibility:hidden;overflow:visible;vertical-align:top;position:absolute;left:0;right:0;white-space:normal;padding:0;margin:0;list-style-type:none;width:100%;height:100%;display:inline-block}ul[rn-carousel-buffered]>li{display:none}ul[rn-carousel-transition=hexagon]{overflow:visible}div.rn-carousel-indicator span{cursor:pointer;color:#666}div.rn-carousel-indicator span.active{color:#fff}.rn-carousel-control{-webkit-transition:opacity .2s ease-out;transition:opacity .2s ease-out;font-size:2rem;position:absolute;top:40%;opacity:.75;cursor:pointer}.rn-carousel-control:hover{opacity:1}.rn-carousel-control.rn-carousel-control-prev{left:.5em}.rn-carousel-control.rn-carousel-control-prev:before{content:\"<\"}.rn-carousel-control.rn-carousel-control-next{right:.5em}.rn-carousel-control.rn-carousel-control-next:before{content:\">\"}", ""]);

// exports


/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

/**
 * Created by ganlu on 27/03/2017.
 */
exports.default = function () {
    return function (scope, elem) {

        var video = elem.find('.video-player')[0];

        elem.on('click', '.play-btn', function () {
            video.play();
            $('.play-btn').css('display', 'none');
        });

        elem.on('mouseover', '.video-player', function () {

            if (!video.hasAttribute('controls')) {
                video.setAttribute('controls', 'controls');
            }
        });

        elem.on('mouseleave', '.video-player', function () {
            if (video.hasAttribute('controls')) {
                video.removeAttribute('controls');
            }
        });
    };
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _authors = __webpack_require__(847);

var _authors2 = _interopRequireDefault(_authors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var authorsModule = _angular2.default.module('authors', []).component('authors', _authors2.default).name;

var states = [{
    name: 'authors',
    url: '/authors',
    component: 'authors',
    title: 'face-authors-title',
    description: 'face-authors-desc'
}];

exports.default = { name: authorsModule, states: states };

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _authors = __webpack_require__(848);

var _authors2 = _interopRequireDefault(_authors);

var _authors3 = __webpack_require__(855);

var _authors4 = _interopRequireDefault(_authors3);

__webpack_require__(856);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var authorsComponent = {
    restrict: 'E',
    bindings: {
        appUser: '='
    },
    template: _authors2.default,
    controller: _authors4.default
};

exports.default = authorsComponent;

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<div class=\"headline\">\n    <div class=\"bg\"></div>\n    <div class=\"content\">\n        <div class=\"text\" translate=\"face-authors-text001\"></div>\n        <div class=\"text\" translate=\"face-authors-text002\"></div>\n        <div class=\"main-btn-wrapper\">\n            <a ui-sref=\"app.face.index.user.form.register\" translate=\"face-authors-text003\" class=\"main-btn\" ng-if=\"!$ctrl.appUser.id\"></a>\n            <a ui-sref=\"app.home.publish.article.edit\" translate=\"face-authors-text003\" class=\"main-btn\" ng-if=\"$ctrl.appUser.id\"></a>\n        </div>\n    </div>\n</div>\n<div class=\"item left\">\n    <div class=\"container\">\n        <div class=\"image\">\n            <img src=\"" + __webpack_require__(849) + "\" />\n        </div>\n        <div class=\"text\">\n            <div class=\"title\">\n                <div class=\"line\" translate=\"face-authors-text005\"></div>\n                <div class=\"line\" translate=\"face-authors-text006\"></div>\n            </div>\n            <div class=\"description\" translate=\"face-authors-text007\">\n            </div>\n        </div>\n    </div>\n</div>\n<div class=\"item right\">\n    <div class=\"container\">\n        <div class=\"image\">\n            <img src=\"" + __webpack_require__(850) + "\" />\n        </div>\n        <div class=\"text\">\n            <div class=\"title\">\n                <div class=\"line\" translate=\"face-authors-text008\"></div>\n                <div class=\"line\" translate=\"face-authors-text009\"></div>\n            </div>\n            <div class=\"description\" translate=\"face-authors-text010\">\n            </div>\n        </div>\n    </div>\n</div>\n<div class=\"item left\">\n    <div class=\"container\">\n        <div class=\"image\">\n            <img src=\"" + __webpack_require__(851) + "\" />\n        </div>\n        <div class=\"text\">\n            <div class=\"title\">\n                <div class=\"line\" translate=\"face-authors-text011\"></div>\n                <div class=\"line\" translate=\"face-authors-text012\"></div>\n            </div>\n            <div class=\"description\" translate=\"face-authors-text013\">\n            </div>\n        </div>\n    </div>\n</div>\n<div class=\"item right\">\n    <div class=\"container\">\n        <div class=\"image\">\n            <img src=\"" + __webpack_require__(852) + "\" />\n        </div>\n        <div class=\"text\">\n            <div class=\"title\">\n                <div class=\"line\" translate=\"face-authors-text014\"></div>\n                <div class=\"line\" translate=\"face-authors-text015\"></div>\n            </div>\n            <div class=\"description\" translate=\"face-authors-text016\">\n            </div>\n        </div>\n    </div>\n</div>\n<div class=\"item left\">\n    <div class=\"container\">\n        <div class=\"image\">\n            <img src=\"" + __webpack_require__(853) + "\" />\n        </div>\n        <div class=\"text\">\n            <div class=\"title\">\n                <div class=\"line\" translate=\"face-authors-text017\"></div>\n                <div class=\"line\" translate=\"face-authors-text018\"></div>\n            </div>\n            <div class=\"description\" translate=\"face-authors-text019\">\n            </div>\n        </div>\n    </div>\n</div>\n<div class=\"item right\">\n    <div class=\"container\">\n        <div class=\"image\">\n            <img src=\"" + __webpack_require__(854) + "\" />\n        </div>\n        <div class=\"text\">\n            <div class=\"title\">\n                <div class=\"line\" translate=\"face-authors-text020\"></div>\n                <div class=\"line\" translate=\"face-authors-text021\"></div>\n            </div>\n            <div class=\"description\" translate=\"face-authors-text022\">\n            </div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fa60fe13776d1d0f7d82916bbd4e5b47.png";

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "230f8e4ac4a5686331f5a1ece18cc7ee.png";

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0e4681b5178cfea1cc77c9987d7fb2f9.png";

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c9f41e7660e038dc93e9a20e2e64872a.png";

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b13a145d24677b73936fc62986aaae23.png";

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6647a4efc24a2e52cc96dc06510955e7.png";

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AuthorsController = function AuthorsController() {
    (0, _classCallCheck3.default)(this, AuthorsController);
};

exports.default = AuthorsController;

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(857);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./authors.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./authors.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "authors .headline .bg {\n  background: url(" + __webpack_require__(858) + ") no-repeat center bottom; }\n\nauthors .item {\n  position: relative;\n  height: 500px; }\n  authors .item .image {\n    padding-top: 70px;\n    width: 50%;\n    text-align: center; }\n  authors .item .text {\n    padding-top: 150px;\n    width: 50%; }\n    authors .item .text .title {\n      font-size: 28px; }\n      authors .item .text .title .line {\n        margin-top: 12px; }\n    authors .item .text .description {\n      margin-top: 28px;\n      font-size: 18px;\n      color: #999999;\n      line-height: 1.8em; }\n  authors .item.left {\n    background-color: #ffffff; }\n    authors .item.left .image {\n      float: left; }\n    authors .item.left .text {\n      float: right;\n      padding-left: 28px; }\n  authors .item.right .image {\n    float: right; }\n  authors .item.right .text {\n    float: left;\n    text-align: right;\n    padding-right: 28px; }\n\n@media only screen and (max-width: 991px) {\n  authors .item .text .title {\n    font-size: 24px; }\n    authors .item .text .title .line {\n      margin-top: 6px; }\n  authors .item .text .description {\n    font-size: 16px; } }\n\n@media only screen and (max-width: 767px) {\n  authors .item {\n    height: auto;\n    padding-bottom: 28px; }\n    authors .item .image,\n    authors .item .text {\n      width: auto;\n      float: none !important;\n      padding: 0 28px;\n      text-align: left !important; }\n      authors .item .image img,\n      authors .item .text img {\n        width: 100%; } }\n", ""]);

// exports


/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "97ccd7225e23bec3322a3b066bff05a1.png";

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _medias = __webpack_require__(860);

var _medias2 = _interopRequireDefault(_medias);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mediasModule = _angular2.default.module('medias', []).component('medias', _medias2.default).name;

var states = [{
    name: 'medias',
    url: '/medias',
    component: 'medias',
    title: 'face-medias-title',
    description: 'face-medias-desc'
}];

exports.default = { name: mediasModule, states: states };

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _medias = __webpack_require__(861);

var _medias2 = _interopRequireDefault(_medias);

var _medias3 = __webpack_require__(883);

var _medias4 = _interopRequireDefault(_medias3);

__webpack_require__(884);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mediasComponent = {
    restrict: 'E',
    bindings: {},
    template: _medias2.default,
    controller: _medias4.default
};

exports.default = mediasComponent;

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<div class=\"headline\">\n    <div class=\"bg\"></div>\n    <div class=\"content\">\n        <div class=\"text\">{{'face-medias-text001' | translate}}</div>\n        <div class=\"description\">{{'face-medias-text002' | translate}}</div>\n        <div class=\"main-btn-wrapper\">\n            <a href=\"mailto:hi@yuanben.org\" class=\"main-btn\">{{'face-medias-text003' | translate}}</a>\n        </div>\n    </div>\n</div>\n<div class=\"customers\">\n    <div class=\"container\">\n        <div class=\"title\">{{'face-medias-text004' | translate}}</div>\n        <div class=\"content\">\n            <div class=\"customer\">\n                <div class=\"image\">\n                    <img src=\"" + __webpack_require__(862) + "\" />\n                </div>\n                <div class=\"text\">{{'face-medias-text005' | translate}}</div>\n            </div>\n            <div class=\"customer\">\n                <div class=\"image\">\n                    <img src=\"" + __webpack_require__(863) + "\" />\n                </div>\n                <div class=\"text\">{{'face-medias-text006' | translate}}</div>\n            </div>\n            <div class=\"customer\">\n                <div class=\"image\">\n                    <img src=\"" + __webpack_require__(864) + "\" />\n                </div>\n                <div class=\"text\">{{'face-medias-text007' | translate}}</div>\n            </div>\n            <div class=\"customer\">\n                <div class=\"image\">\n                    <img src=\"" + __webpack_require__(865) + "\" />\n                </div>\n                <div class=\"text\">{{'face-medias-text008' | translate}}</div>\n            </div>\n        </div>\n    </div>\n</div>\n<div class=\"interfaces section\">\n    <div class=\"container\">\n        <div class=\"title\">{{'face-medias-text009' | translate}}</div>\n        <div class=\"content\">\n            <div class=\"interface\">\n                <div class=\"image\">\n                    <img src=\"" + __webpack_require__(866) + "\" />\n                </div>\n                <div class=\"name\">{{'face-medias-text010' | translate}}</div>\n                <div class=\"description\">\n                    {{'face-medias-text011' | translate}}\n                </div>\n            </div>\n            <div class=\"interface\">\n                <div class=\"image\">\n                    <img src=\"" + __webpack_require__(867) + "\" />\n                </div>\n                <div class=\"name\">{{'face-medias-text012' | translate}}</div>\n                <div class=\"description\">\n                    {{'face-medias-text013' | translate}}\n                </div>\n            </div>\n            <div class=\"interface\">\n                <div class=\"image\">\n                    <img src=\"" + __webpack_require__(868) + "\" />\n                </div>\n                <div class=\"name\">{{'face-medias-text014' | translate}}</div>\n                <div class=\"description\">\n                    {{'face-medias-text058' | translate}}\n                </div>\n            </div>\n        </div>\n        <div class=\"title\">{{'face-medias-text015' | translate}}</div>\n        <div class=\"process-map\">\n            <div class=\"item item01\">\n                <div class=\"heading\">{{'face-medias-text016' | translate}}</div>\n                <img class=\"img\" src=\"" + __webpack_require__(869) + "\" alt=\"\">\n            </div>\n            <div class=\"item item02\">\n                <div class=\"heading\">{{'face-medias-text017' | translate}}</div>\n                <img class=\"img\" src=\"" + __webpack_require__(870) + "\" alt=\"\">\n            </div>\n            <div class=\"item item03\">\n                <div class=\"heading\">{{'face-medias-text018' | translate}}</div>\n                <img class=\"img\" src=\"" + __webpack_require__(871) + "\" alt=\"\">\n            </div>\n            <div class=\"item item04\">\n                <div class=\"heading\">{{'face-medias-text019' | translate}}</div>\n                <img class=\"img\" src=\"" + __webpack_require__(872) + "\" alt=\"\">\n            </div>\n            <div class=\"item item05\">\n                <div class=\"heading\">{{'face-medias-text020' | translate}}</div>\n                <img class=\"img\" src=\"" + __webpack_require__(873) + "\" alt=\"\">\n            </div>\n        </div>\n\n    </div>\n</div>\n\n<div class=\"services\">\n    <div class=\"title\">{{'face-medias-text021' | translate}}</div>\n    <div class=\"service \">\n        <div class=\"container\">\n            <div class=\"service-nav\">\n                <span class=\"service-nav-item active\">{{'face-medias-text022' | translate}}</span>\n                <span class=\"service-nav-separator\">•</span>\n                <span class=\"service-nav-item\">{{'face-medias-text023' | translate}}</span>\n                <span class=\"service-nav-separator\">•</span>\n                <span class=\"service-nav-item\">{{'face-medias-text024' | translate}}</span>\n            </div>\n            <div class=\"service-intro\">\n                <div class=\"line\">\n                    <div class=\"item\">\n                        <div class=\"image\">\n                            <img src=\"" + __webpack_require__(874) + "\" />\n                        </div>\n                        <div class=\"name\">{{'face-medias-text025' | translate}}</div>\n                        <div class=\"description\">\n                            <ul>\n                                <li>{{'face-medias-text026' | translate}}</li>\n                                <li>{{'face-medias-text027' | translate}}</li>\n                                <li>{{'face-medias-text028' | translate}}</li>\n                            </ul>\n                        </div>\n                    </div>\n                    <div class=\"item\">\n                        <div class=\"image\">\n                            <img src=\"" + __webpack_require__(875) + "\" />\n                        </div>\n                        <div class=\"name\">{{'face-medias-text029' | translate}}</div>\n                        <div class=\"description\">\n                            <ul>\n                                <li>{{'face-medias-text030' | translate}}</li>\n                                <li>{{'face-medias-text031' | translate}}</li>\n                                <li>{{'face-medias-text032' | translate}}</li>\n                            </ul>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"line\">\n                    <div class=\"item\">\n                        <div class=\"image\">\n                            <img src=\"" + __webpack_require__(876) + "\" />\n                        </div>\n                        <div class=\"name\">{{'face-medias-text033' | translate}}</div>\n                        <div class=\"description\">\n                            <ul>\n                                <li>{{'face-medias-text034' | translate}}</li>\n                                <li>{{'face-medias-text035' | translate}}</li>\n                                <li>{{'face-medias-text036' | translate}}</li>\n                            </ul>\n                        </div>\n                    </div>\n                    <div class=\"item\">\n                        <div class=\"image\">\n                            <img src=\"" + __webpack_require__(877) + "\" />\n                        </div>\n                        <div class=\"name\">{{'face-medias-text037' | translate}}</div>\n                        <div class=\"description\">\n                            <ul>\n                                <li>{{'face-medias-text038' | translate}}</li>\n                                <li>{{'face-medias-text039' | translate}}</li>\n                                <li>{{'face-medias-text040' | translate}}</li>\n                            </ul>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"service gray\">\n        <div class=\"container\">\n            <div class=\"service-nav\">\n                <span class=\"service-nav-item\">{{'face-medias-text022' | translate}}</span>\n                <span class=\"service-nav-separator\">•</span>\n                <span class=\"service-nav-item active\">{{'face-medias-text023' | translate}}</span>\n                <span class=\"service-nav-separator\">•</span>\n                <span class=\"service-nav-item\">{{'face-medias-text024' | translate}}</span>\n            </div>\n            <div class=\"service-intro\">\n                <div class=\"line\">\n                    <div class=\"item\">\n                        <div class=\"image\">\n                            <img src=\"" + __webpack_require__(878) + "\" />\n                        </div>\n                        <div class=\"name\">{{'face-medias-text041' | translate}}</div>\n                        <div class=\"description\">\n                            <ul>\n                                <li>{{'face-medias-text042' | translate}}</li>\n                                <li>{{'face-medias-text043' | translate}}</li>\n                                <li>{{'face-medias-text044' | translate}}</li>\n                            </ul>\n                        </div>\n                    </div>\n                    <div class=\"item\">\n                        <div class=\"image\">\n                            <img src=\"" + __webpack_require__(879) + "\" />\n                        </div>\n                        <div class=\"name\">{{'face-medias-text045' | translate}}</div>\n                        <div class=\"description\">\n                            <ul>\n                                <li>{{'face-medias-text046' | translate}}</li>\n                                <li>{{'face-medias-text047' | translate}}</li>\n                                <li>{{'face-medias-text048' | translate}}</li>\n                            </ul>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"service\">\n        <div class=\"container\">\n            <div class=\"service-nav\">\n                <span class=\"service-nav-item\">{{'face-medias-text022' | translate}}</span>\n                <span class=\"service-nav-separator\">•</span>\n                <span class=\"service-nav-item\">{{'face-medias-text023' | translate}}</span>\n                <span class=\"service-nav-separator\">•</span>\n                <span class=\"service-nav-item active\">{{'face-medias-text024' | translate}}</span>\n            </div>\n            <div class=\"service-intro\">\n                <div class=\"line\">\n                    <div class=\"item\">\n                        <div class=\"image\">\n                            <img src=\"" + __webpack_require__(880) + "\" />\n                        </div>\n                        <div class=\"name\">{{'face-medias-text049' | translate}}</div>\n                        <div class=\"description\">\n                            <ul>\n                                <li>{{'face-medias-text050' | translate}}</li>\n                                <li>{{'face-medias-text051' | translate}}</li>\n                            </ul>\n                        </div>\n                    </div>\n                    <div class=\"item\">\n                        <div class=\"image\">\n                            <img src=\"" + __webpack_require__(881) + "\" />\n                        </div>\n                        <div class=\"name\">{{'face-medias-text052' | translate}}</div>\n                        <div class=\"description\">\n                            <ul>\n                                <li>{{'face-medias-text053' | translate}}</li>\n                                <li>{{'face-medias-text054' | translate}}</li>\n                            </ul>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"line\">\n                    <div class=\"item\">\n                        <div class=\"image\">\n                            <img src=\"" + __webpack_require__(882) + "\" />\n                        </div>\n                        <div class=\"name\">{{'face-medias-text055' | translate}}</div>\n                        <div class=\"description\">\n                            <ul>\n                                <li>{{'face-medias-text056' | translate}}</li>\n                                <li>{{'face-medias-text057' | translate}}</li>\n                            </ul>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 862 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 863 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 864 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABBCAYAAABy4uKPAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyNpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChNYWNpbnRvc2gpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjZEMDA0NTIzMDFGNjExRTdBQ0VFRTZEMTkxQTg5NEEwIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjZEMDA0NTI0MDFGNjExRTdBQ0VFRTZEMTkxQTg5NEEwIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NkQwMDQ1MjEwMUY2MTFFN0FDRUVFNkQxOTFBODk0QTAiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NkQwMDQ1MjIwMUY2MTFFN0FDRUVFNkQxOTFBODk0QTAiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4QRAcVAAAIR0lEQVR42uxcCWxVRRR9lAoWFCQYChIrIkswYhGUFEQFWSoFAhECFBCNNqlhERVMFFkVEsC6QAT6WUSR0hgxgAGByFLWakCwssleq9IoIqWARLZ6Tv559fH57W//f6997e8kJ9M3f2buzHmz3HtnXqsZpQwej6cGohRgOFDXsC/sAcYkJyfvMlwUIoIo8zkw2mZyGB4FNuIFPOgmgiJLOXoeRzQQuK44A7hhQzvqAYuBLsAsoLdbCKpWSoKWInoOWIqp8LydDUHdrRAdAgqAGNT/W4WaYugAyeypx4V2NwSEHEa0Qy/tmYo4xbg23A1cAr5zqD2bgE5AZ2CRTSOzBaK1euyNF3HEqUX6CcWZEHLNIYK2K+5kY51cK5sJw53cxTor3urgiM4ErgL34c03cWCW1LZlkUbjuIV3A9jIO5U8TgKWADkOkvQicC+wGvjRhvqesrzcHZrG1nAByKaKgZlxvliCQMw9iN7VTnWbEV7hqnS8iSDq9C0EgRzqIF9JJ2E4BuwF/tDW+whwUelOhlpAW2A/cN7m3fqGnwESLXnNlXYO6A+SthQSBHLaavhFqWEjkWF7OA0fcMBNaC7QGrjMjQIc7K2GH8huFvAQsA1IwA+XjDAM4IJr7DfAk8ABIDZC2yDJyQMGhCs5UlbZ9wHigpwMJEGD9PtsZDhjhHkQB7P1OIgEddDD10ZVMHy46EAlqoEeTlbmHufm5tZENBhoI91nZaNGjfYVkf0XxQ0izJ0MQyuvEpPTGBHJ+BR4lboOVRikTy2iyHVTDYh0QeP5kmJoXgB1lJyvt5iDt2yHv4kKYCs/6ZMgfzdkrLHDmreTlGgN9wQZprWKyPoP8u7Q1puOjvwZhCyaS10CmDbuIAiNpUU9ARjqI/u6RoypOdfViCJxPYQUlE9DPA1EHS+F2EBGb1O7/EGhLpCTZfCaNh6V03QZj1no9FWfMswXC3QFhgAPA/RiDsFvPDSYijL/lkB8IM9kTrkShM7cj2iF7B2GzcAUdK5YU0aE7RFmoh6aAlOAp4G3gHik9Ue+7AD1HEc+npR0LCLLErv8QcGQQ7tml8jhLjkUDe4aiJwiOrqdZTU981RnpmQECsOAU37SP0CdK8uFIDS8uUZLQ4D+5nZozPJQ61Ud7VQn694sWcWVOaUpOsrwnp58RHsL6WMDyYt0iBxu1+sMrw+ba013NMY2MwZ1nYQMOsK+1Tq1Ds9tkZ5fTJmLstaD8pPYHeYDD2iBTLCTHEuHz0hN+F2y5jvRkQgHRk937TpU8BLRkdNOTWPVPViyhki2ewlCA2m2pOgxFR3Y4fQuKRmpenxPbXDtCErQYki/yqQy1EEnSSbXo55uJihJ8QK82bNlxY5kLfBpg7sIwtC+QyPIkNVc1uEzxb3UFteNIBqdvDuUjTf6U1mzA5lZsudqGDaezNpJUHvFGYFGGpAEvAHUs5knU/ZjbiTI1GYPFkMOHeJHDe/tEN4D2i+Fz65wQHELuyqMtDS+X4h1mTbRr36I4bCnI/xln58ay1QYjyky04b+mLJbh9Kf/Pz82hkZGbeYGittIj3ah5yGqjuumFE8A/moHiSBqMsl2BC4lY8B6Cn4QkZnnmwzQ9t90P2Jiorya4tlhUgM1X3uHn9bOtIS0foSOK0Mad9N+OaLMk3wWwNt530tyRPlJ6KDzVQtaHedCLYjBQUF1Q3vudj/BKFRbULc5nlU0geoaUmeVUJyzECfzfccIWjPEZ/6eT/ySzbVTzlz1N1u+pxQvm+wffF4PHcZ3jN6Wxdp09/SzJJ2OIh6OG12gpAOFnLoJNtSBDmGFn5zFDNku3EXO+Rni90cZF31gU0gpo+eaW+tKCb/Fh/ZB91IkHnzrCM6VsvS8L+CXSuBVajrJUyXK4bXkziniLxrJNN0q25zHUHoxM+aZuxYP6XRr+wJsX2L0PnJqKsA4M41wSfPeqQfk0zKPqm2uNJYXaZ4tCXtfcvuEmyYApLm8pARnZ8ug9Q8UJzmI3OZm615evU4HeLQmR4aReeks4QaRgBpVDpRJ/3K/YGP8fdOyYqT7FTXEoTG5lrcDnN0Hsb0NJsaTu/haq43qHMVMFoy5ljcLLluHkGm84qKHpXEFEs6TxSW21A/b+Gn+0zhlpJpu5POdoI0pUyn1Si84WSl83h5mNaMUC4k0JUyVvoR6x5pOsok23D7CCIZ1Kpn6HEe3RtK5040Uf6aH0pZLV2qPL5ur9NS1jlPv82QTKNCEKQw3vAe61LGQp6n67ydRGUC/D6MpxBpVvvNJ3Ck7Ta8Z/oxKPMO03Q2v1B1fyJZjgTHzuY5WqjkGd5j4tc0LbohbQR+26U8GxFt1ElEU4E3TTkdeaRzFHkuWEyOjho1sUr6kPVSVoUjyCQJ0eu8pCSFMVZ21gZu0VLyrinfCX8WOPJGamHmIh+vZJKWjHLphsOhTK6/sCPoaIZ2tUR1lDiHdJoj+2RwmkfHdeQV5O1+Xn4yXbMF2sHG2b2dlytBFh1pKAiZrtGQqI4/KxQX8kQMFcNDRhmGMr+Cpw6OAFG8TEmXBu/98GO9GDncTIdXjjwEvCqTKYO1zEO5XeJUh7cazn5/Zt827/F4wu3zpxITZLoro6voKAzmVL9Mgswbo3FVvBQGk4tjJGi9actU8VIYTC42REiBo+cvHutQYrgzIw7ixYknIjk5mdqr+fnPYmQYHMbksO+L9cjPw06Y2/zbhvdbhl5UyJDxBcP7YT813LOVnJf60tiTLKbMWnFy00e9NeSieAWoHqaDiEYyvZNvYvRcuYkgC1H0zvGSAS9D8Ti3ZiUnhZ8z8F4RP5hJ9f3XFf8JMADUptNoCl2VjQAAAABJRU5ErkJggg=="

/***/ }),
/* 865 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 866 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 867 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 868 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3d03f181e0d386956b145ea9e39021d3.png";

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "98c4c3630e768a9d53515d12723357a4.png";

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7d48c2dc79791b2bcc0c000018366afb.png";

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1e36ec69ab9ec8ac78c369b4d6774453.png";

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "949d4cd5820dc158967dd1634d6481be.png";

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "466fa815da02cb3f09b42cbd1d878df4.png";

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3df47986fdbdddf405c67e50220f8aa5.png";

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ceba631eff9ae8078b4cb5e6c224e3d0.png";

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8a659767a2cdcf69a3b9bad7dfc0a26b.png";

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "de0e577317e2e7cfd0beabbbab37cfac.png";

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "92293cf7d1f1c56ead57171e02ed0d22.png";

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d515cdca678ae9c72a84c515bc85b9f5.png";

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "de2cbe13a6be01d469c750a6e9266486.png";

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e3a5aa1224bbf04d9ae45e460167cc12.png";

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MediasController = function MediasController() {
    (0, _classCallCheck3.default)(this, MediasController);
};

exports.default = MediasController;

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(885);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./medias.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./medias.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "medias .headline .bg {\n  background: url(" + __webpack_require__(886) + ") no-repeat center bottom; }\n\nmedias .customers {\n  position: relative;\n  background-color: #ffffff;\n  padding: 48px 0 88px; }\n  medias .customers .title {\n    font-size: 20px;\n    color: #00816a;\n    text-align: center; }\n  medias .customers .content {\n    position: relative;\n    margin-top: 68px;\n    overflow: auto; }\n    medias .customers .content .customer {\n      position: relative;\n      width: 25%;\n      height: 120px;\n      float: left;\n      text-align: center; }\n      medias .customers .content .customer .text {\n        margin-top: 12px;\n        color: #666666;\n        font-size: 16px; }\n\nmedias .interfaces {\n  background-color: #f5f5f5;\n  padding-bottom: 100px; }\n  medias .interfaces .title {\n    font-size: 20px;\n    color: #00816a;\n    text-align: center;\n    padding: 60px 0; }\n  medias .interfaces .content {\n    position: relative;\n    padding: 0 0 88px;\n    overflow: auto; }\n    medias .interfaces .content .interface {\n      position: relative;\n      width: 31.333%;\n      margin: 0 1%;\n      float: left;\n      text-align: center;\n      background: #fff;\n      height: 100%;\n      padding: 20px 0; }\n      medias .interfaces .content .interface:first-child .image {\n        padding-top: 40px; }\n      medias .interfaces .content .interface:after {\n        content: '';\n        width: 30%;\n        height: 5px;\n        left: 35%;\n        top: 0;\n        position: absolute;\n        background: #00816a; }\n      medias .interfaces .content .interface .image {\n        height: 160px; }\n        medias .interfaces .content .interface .image img {\n          max-width: 100%; }\n      medias .interfaces .content .interface .name {\n        margin-top: 28px;\n        font-size: 16px;\n        color: #00816a;\n        font-weight: bold; }\n      medias .interfaces .content .interface .description {\n        height: 210px;\n        text-align: left;\n        margin-top: 28px;\n        font-size: 14px;\n        color: #666666;\n        padding: 0 18px;\n        line-height: 1.8em; }\n  medias .interfaces .process-map {\n    width: 1000px;\n    height: 435px;\n    display: block;\n    font-size: 0;\n    background: url(" + __webpack_require__(887) + ") center no-repeat;\n    position: relative; }\n    medias .interfaces .process-map .item {\n      text-align: center;\n      margin-bottom: 40px;\n      width: 25%;\n      display: inline-block;\n      font-size: 14px;\n      position: absolute; }\n      medias .interfaces .process-map .item .heading {\n        display: inline-block;\n        background: #00816a;\n        color: #fff;\n        line-height: 2;\n        border-radius: 20px;\n        padding: 0 20px;\n        margin-bottom: 20px; }\n      medias .interfaces .process-map .item img {\n        display: block;\n        margin: 0 auto;\n        width: 220px;\n        max-width: 100%; }\n      medias .interfaces .process-map .item.item01 {\n        left: 0;\n        top: 0; }\n      medias .interfaces .process-map .item.item02 {\n        left: 180px;\n        top: 240px; }\n      medias .interfaces .process-map .item.item03 {\n        left: 400px;\n        top: 40px; }\n      medias .interfaces .process-map .item.item04 {\n        left: 560px;\n        top: 220px; }\n      medias .interfaces .process-map .item.item05 {\n        left: 760px;\n        top: 0; }\n\nmedias .services {\n  position: relative;\n  padding-top: 48px;\n  background-color: #ffffff; }\n  medias .services .title {\n    font-size: 20px;\n    color: #00816a;\n    text-align: center; }\n  medias .services .service {\n    position: relative;\n    padding: 58px 0;\n    background-color: #ffffff; }\n    medias .services .service.gray {\n      background-color: #f5f5f5; }\n    medias .services .service .service-nav {\n      position: relative;\n      text-align: center;\n      font-weight: bold; }\n      medias .services .service .service-nav .service-nav-item {\n        color: #cccccc;\n        font-size: 16px; }\n        medias .services .service .service-nav .service-nav-item.active {\n          color: #222222;\n          font-size: 20px; }\n      medias .services .service .service-nav .service-nav-separator {\n        margin: 0 8px;\n        color: #999999;\n        font-size: 14px; }\n    medias .services .service .service-intro {\n      position: relative;\n      margin: 48px 48px 0; }\n      medias .services .service .service-intro .line {\n        position: relative;\n        overflow: auto; }\n        medias .services .service .service-intro .line:not(:first-child) {\n          border-top: 1px solid #e0e0e0; }\n        medias .services .service .service-intro .line .item {\n          position: relative;\n          width: 50%;\n          float: left; }\n          medias .services .service .service-intro .line .item:first-child {\n            border-right: 1px solid #e0e0e0; }\n          medias .services .service .service-intro .line .item .image {\n            margin-top: 28px;\n            text-align: center; }\n          medias .services .service .service-intro .line .item .name {\n            text-align: center;\n            font-size: 18px;\n            font-weight: bold;\n            color: #222222; }\n          medias .services .service .service-intro .line .item .description {\n            margin: 28px 48px;\n            font-size: 14px;\n            color: #666666;\n            line-height: 1.8em; }\n\n@media only screen and (max-width: 991px) {\n  medias .services .service .service-intro .line .item .description {\n    margin: 18px 18px; } }\n\n@media only screen and (max-width: 767px) {\n  medias .customers .content {\n    margin-top: 20px; }\n    medias .customers .content .customer {\n      width: 50%;\n      margin-top: 28px; }\n  medias .services .service .service-nav {\n    font-size: 18px; }\n  medias .services .service .service-intro {\n    margin: 0; }\n    medias .services .service .service-intro .line {\n      margin: 0 18px; }\n      medias .services .service .service-intro .line:not(:first-child) {\n        border-top: 1px solid #dadedd; }\n      medias .services .service .service-intro .line .item {\n        width: auto;\n        float: none;\n        padding-bottom: 28px;\n        border-top: 1px solid #dadedd; }\n        medias .services .service .service-intro .line .item:first-child {\n          border-right: 0;\n          border-top: 0; }\n        medias .services .service .service-intro .line .item .description ul {\n          -webkit-padding-start: 16px; }\n  medias .interfaces {\n    padding-bottom: 60px; }\n    medias .interfaces .title {\n      padding: 48px 0; }\n    medias .interfaces .content {\n      position: relative;\n      padding: 0;\n      overflow: auto; }\n      medias .interfaces .content .interface {\n        position: relative;\n        width: 90%;\n        margin: 0 5%;\n        float: none;\n        padding: 40px 0;\n        margin-bottom: 40px; }\n        medias .interfaces .content .interface:first-child .image {\n          padding-top: 0; }\n        medias .interfaces .content .interface .image {\n          height: auto; }\n        medias .interfaces .content .interface .description {\n          height: auto; }\n    medias .interfaces .process-map {\n      display: block;\n      position: static;\n      height: auto;\n      background: none;\n      width: 100%; }\n      medias .interfaces .process-map .item {\n        position: static;\n        text-align: center;\n        margin-bottom: 40px;\n        width: 100%; }\n        medias .interfaces .process-map .item img {\n          display: block;\n          margin: 0 auto;\n          width: 220px; } }\n", ""]);

// exports


/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6c3152f14a8884e14964ab60d619ff92.png";

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fc30889b6a02efa123cfdda373aa4ec4.png";

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _consumers = __webpack_require__(889);

var _consumers2 = _interopRequireDefault(_consumers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var consumersModule = _angular2.default.module('consumers', []).component('consumers', _consumers2.default).name;

var states = [{
    name: 'consumers',
    url: '/consumers',
    component: 'consumers',
    title: 'face-consumers-title',
    description: 'face-consumers-desc'
}];

exports.default = { name: consumersModule, states: states };

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _consumers = __webpack_require__(890);

var _consumers2 = _interopRequireDefault(_consumers);

var _consumers3 = __webpack_require__(893);

var _consumers4 = _interopRequireDefault(_consumers3);

__webpack_require__(894);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var consumersComponent = {
    restrict: 'E',
    bindings: {},
    template: _consumers2.default,
    controller: _consumers4.default
};

exports.default = consumersComponent;

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<div class=\"headline\">\n    <div class=\"bg\"></div>\n    <div class=\"content\">\n        <div class=\"text\" translate=\"face-consumers-text001\"></div>\n        <div class=\"text\" translate=\"face-consumers-text002\"></div>\n        <div class=\"description\">\n            <div class=\"line\" translate=\"face-consumers-text003\"></div>\n            <div class=\"line\" translate=\"face-consumers-text004\"></div>\n        </div>\n        <div class=\"subscription\">\n            <div ng-class=\"{frame: true, active: $ctrl.frame == 'tags'}\">\n                <div class=\"title\" translate=\"face-consumers-text005\"></div>\n                <div class=\"tags\">\n                    <div ng-repeat=\"tag in $ctrl.tags\" ng-class=\"{tag: true, selected: $ctrl.selected.indexOf(tag) != -1}\" ng-click=\"$ctrl.toggleSelect(tag)\">{{ tag | translate}}</div>\n                </div>\n                <div class=\"custom\">\n                    <input type=\"text\" class=\"custom-input\" placeholder=\"{{'face-consumers-text006' | translate}}\" ng-model=\"$ctrl.otherTags\" />\n                </div>\n                <div class=\"main-btn-wrapper\">\n                    <button type=\"button\" class=\"main-btn\" ng-click=\"$ctrl.next()\"  translate=\"face-consumers-text007\"></button>\n                </div>\n            </div>\n            <div ng-class=\"{frame: true, active: $ctrl.frame == 'info'}\">\n                <div class=\"title\"  translate=\"face-consumers-text008\"></div>\n                <div class=\"face-form\">\n                    <form>\n                        <div ng-class=\"{'input-group':true, 'error':$ctrl.errors['email']}\" yb-input-group>\n                            <div class=\"input\">\n                                <div class=\"icon\"><i class=\"ybicon yb-email\"></i></div>\n                                <div class=\"wrapper\">\n                                    <input id=\"email\" type=\"text\" placeholder=\"{{'face-consumers-text009' | translate}}\" data-name=\"{{'face-consumers-text017' | translate}}\"/>\n                                </div>\n                            </div>\n                            <div class=\"error-message\">{{$ctrl.errors['email']}}</div>\n                        </div>\n                        <div ng-class=\"{'input-group':true, 'error':$ctrl.errors['phone']}\" yb-input-group>\n                            <div class=\"input\">\n                                <div class=\"icon\"><i class=\"ybicon yb-phone\"></i></div>\n                                <div class=\"wrapper\">\n                                    <input id=\"phone\" type=\"text\" placeholder=\"{{'face-consumers-text010' | translate}}\" data-name=\"{{'face-consumers-text018' | translate}}\"/>\n                                </div>\n                            </div>\n                            <div class=\"error-message\">{{$ctrl.errors['phone']}}</div>\n                        </div>\n                        <div ng-class=\"{'input-group':true, 'error':$ctrl.errors['company']}\" yb-input-group>\n                            <div class=\"input\">\n                                <div class=\"icon\"><i class=\"ybicon yb-company\"></i></div>\n                                <div class=\"wrapper\">\n                                    <input id=\"company\" type=\"text\" placeholder=\"{{'face-consumers-text011' | translate}}\" data-name=\"{{'face-consumers-text019' | translate}}\"/>\n                                </div>\n                            </div>\n                            <div class=\"error-message\">{{$ctrl.errors['company']}}</div>\n                        </div>\n                        <div class=\"submit-group\">\n                            <div class=\"wrapper\">\n                                <div class=\"back-button\" ng-click=\"$ctrl.back()\">\n                                    <img src=\"" + __webpack_require__(891) + "\" class=\"normal\" />\n                                    <img src=\"" + __webpack_require__(892) + "\" class=\"hover\" />\n                                </div>\n                                <button type=\"submit\" class=\"main-btn\" ng-click=\"$ctrl.subscribe()\" ng-disabled=\"$ctrl.loading\" translate=\"face-consumers-text012\"></button>\n                            </div>\n                        </div>\n                    </form>\n                </div>\n            </div>\n            <div ng-class=\"{frame: true, active: $ctrl.frame == 'success'}\">\n                <div class=\"title\"  translate=\"face-consumers-text013\"></div>\n                <div class=\"success-message\" translate=\"face-consumers-text014\"></div>\n                <div class=\"done-btn\">\n                    <button type=\"button\" class=\"main-btn\" ng-click=\"$ctrl.done()\" translate=\"face-consumers-text015\"></button>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<div class=\"placeholder\"></div>\n";

/***/ }),
/* 891 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 892 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEUAAAAyCAYAAAAKqhZQAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyNpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChNYWNpbnRvc2gpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjQzOERCQTU0MDE4RDExRTdBQ0VFRTZEMTkxQTg5NEEwIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjQzOERCQTU1MDE4RDExRTdBQ0VFRTZEMTkxQTg5NEEwIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NDM4REJBNTIwMThEMTFFN0FDRUVFNkQxOTFBODk0QTAiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NDM4REJBNTMwMThEMTFFN0FDRUVFNkQxOTFBODk0QTAiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz6nFHoZAAADjklEQVR42uybW0gUURjHP5cVwrwVBBkmWhKptWilYlBaQkQQag+9lGYPQkFBvRQEviQV9dKLGPXSRXo1iwhCCw26EealFI3IKMkg6OIFlhTt/7Xf1Gqr7mVmmjOzf/ihLu6Z8/08Z+bseCZmQ/dp0iFuUAi2gnVgDVgBFoMk0j8/wDj4BN6AXvAYPAU/Q2mow1MbsJhw4wLbwQFQBhLIvCQJLH6T3+uj4Da4Dh6CqXALC2dUVILXoAXsN1nIfEmQ/rRI/6rC+cOHKmUL6AQ3QBZZO1kyYjplWusuZRFoAO1yzlAp3N82cEnq0EVKupzADoMYUjPc70NSR3qkUjzgCcgleyRX6vGEKyVPpksK2SspUtf6UKWsBvdBMtkzXNc9kBGslDjQBJaRvZMKmjf21MUFI+XiQnPORvFIvfNKKQU15KzUYLSUziWFV371Cl92I7lc10OMO5CUarCWnBmu++BsKfz1JDk7JzBaXP5S+NNupsOlZMo59Y+UKrOOXBCfQWfSKqwqplKTEgvKzRJyLm0P3fnabVUp5ZhCsSwl34z7IZqQUx9u0fOxd1aVwh7yWUpJVMiMFLOUbCOPUKiWEE6Oy8i1CQs5q5aQ32sWlrIyKmRGlrOUJVEhM0+22iU5KuRvEt16t1ibupuS3XHUsGrff68Oa46w3sdSJvQcLXVDdzFSKjBSmjBSBlUcKaM8fb7p2SJPGZ46PIV4KimYEZbyUe9WFRfzmaUMGNGywmL6WUqvUa0rKqaPpbQZeQSfmCaVxLSxlBfk28JgoJhBVcSMsQ+XXJKbjT6aImKaOzy1E9qdt0YzjqiJKVuaZ1UpjdrijfMAvCUT7tOyGIsu6rj+Vv5GGym8Deo8OTsXMHWm/KVwrvE12qFCuO6r2g/+UibBETDtMCFc71GMkslAUrRzy2WHSbkCIa3+LwTadXCcfJvnnBCu89jsFwNJ8YK94IvNhQxxnRgl3mCkaJenneC7TYVwXbukTgpWCuclKAbDNhMyLHW9musXFtod2QM2gy6bCOmSenrm+6Vg9tG+B0VyVVL1cj0t/S+SeihSKdrJlzfnlpBvz7tK4ftF26T/3mDeEOre/Efk219brcDqd0D6yRuK20N5YzhPcfDKjx8EyAE7wE25D2GFjEt/uF/Z0s/JUBuJ5P8+/OGpReB/kRTQvw9BxYNEA4ofkT+E9hBUH3hGvgehvJE2/kuAAQBI6gVxYLtr5gAAAABJRU5ErkJggg=="

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConsumersController = function () {
    ConsumersController.$inject = ['message', '$http', 'AppConfig', '$translate', '$filter'];

    function ConsumersController(message, $http, AppConfig, $translate, $filter) {

        "ngInject";

        (0, _classCallCheck3.default)(this, ConsumersController);
        this.message = message;
        this.$http = $http;
        this.AppConfig = AppConfig;
        this.$translate = $translate;
        this.tranlsteFilter = $filter('translate');
        this.tags = ['face-consumers-text022', 'face-consumers-text023', 'face-consumers-text024', 'face-consumers-text025', 'face-consumers-text026', 'face-consumers-text027', 'face-consumers-text028', 'face-consumers-text029', 'face-consumers-text030', 'face-consumers-text031', 'face-consumers-text033', 'face-consumers-text034', 'face-consumers-text035', 'face-consumers-text036', 'face-consumers-text037'];

        this.otherTags = '';

        this.selected = [];

        this.frame = 'tags';

        this.loading = false;
        this.errors = {};
    }

    (0, _createClass3.default)(ConsumersController, [{
        key: 'toggleSelect',
        value: function toggleSelect(tag) {

            var idx = this.selected.indexOf(tag);

            if (idx == -1) {
                this.selected.push(tag);
            } else {
                this.selected.splice(idx, 1);
            }
        }
    }, {
        key: 'next',
        value: function next() {
            var _this = this;

            if (this.selected.length == 0 && this.otherTags == '') {
                this.$translate('face-consumers-text016').then(function (translation) {
                    _this.message.error(translation);
                });
                return;
            }

            this.frame = 'info';
        }
    }, {
        key: 'back',
        value: function back() {
            this.frame = 'tags';
        }
    }, {
        key: 'subscribe',
        value: function subscribe() {
            var _this2 = this;

            this.errors = {};
            var hasError = false;
            var required = ['email', 'phone', 'company'];

            var _loop = function _loop(i) {
                var r = required[i];
                var v = $('#' + r).val();

                if (v === '') {
                    _this2.$translate('face-consumers-text021').then(function (translation) {
                        _this2.errors[r] = translation + $('#' + r).attr('data-name');
                    });
                    hasError = true;
                }
                if (r == 'email') {
                    reg = /^(\w)+(\.\w+)*@(\w)+((\.\w+)+)$/;

                    if (v !== '' && !reg.test(v)) {
                        _this2.$translate('face-consumers-text020').then(function (translation) {
                            _this2.errors[r] = $('#' + r).attr('data-name') + translation;
                        });
                        hasError = true;
                    }
                }
            };

            for (var i = 0; i < required.length; i++) {
                var reg;

                _loop(i);
            }

            if (hasError) return;

            var email = $('#email').val();
            var phone = $('#phone').val();
            var company = $('#company').val();

            this.loading = true;

            var self = this;

            this.$http.post(self.AppConfig.server_url + '/subscribe', {
                'email': email,
                'phone': phone,
                'company': company,
                'tags': self.selected.join(',') + (self.otherTags == '' ? '' : ',' + self.otherTags)
            }, {
                withCredentials: true
            }).then(function () {
                _this2.loading = false;
                self.frame = 'success';
            }, function (response) {
                _this2.loading = false;

                if (response.data) {
                    for (var field in response.data) {
                        if (response.data.hasOwnProperty(field)) {
                            self.errors[field] = response.data[field][0];
                        }
                    }
                }
            });
        }
    }, {
        key: 'done',
        value: function done() {
            this.frame = 'tags';
        }
    }]);
    return ConsumersController;
}();

exports.default = ConsumersController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(895);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./consumers.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./consumers.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "consumers .headline .bg {\n  background: url(" + __webpack_require__(896) + ") no-repeat center bottom; }\n\nconsumers .headline .subscription {\n  position: relative;\n  width: 700px;\n  height: 700px;\n  margin: 100px auto;\n  background-color: #ffffff;\n  border-radius: 3px;\n  padding: 28px 48px; }\n  consumers .headline .subscription .frame {\n    position: relative;\n    width: 100%;\n    height: 100%;\n    display: none; }\n    consumers .headline .subscription .frame.active {\n      display: block; }\n  consumers .headline .subscription .title {\n    text-align: center;\n    font-size: 16px;\n    color: #cccccc; }\n  consumers .headline .subscription .tags {\n    position: relative;\n    overflow: auto; }\n    consumers .headline .subscription .tags .tag {\n      position: relative;\n      float: left;\n      width: 25%;\n      height: 50px;\n      line-height: 50px;\n      border: 1px solid #ffffff;\n      text-align: center;\n      font-size: 18px;\n      color: #00816a;\n      margin-top: 48px;\n      cursor: pointer;\n      border-radius: 3px; }\n      consumers .headline .subscription .tags .tag:hover {\n        border-color: #00816a; }\n      consumers .headline .subscription .tags .tag.selected {\n        background-color: #00816a;\n        color: #ffffff; }\n  consumers .headline .subscription .custom {\n    position: relative;\n    padding: 48px 48px; }\n    consumers .headline .subscription .custom .custom-input {\n      display: block;\n      width: 100%;\n      height: 40px;\n      line-height: 40px;\n      border: 0;\n      margin: 0;\n      padding: 0 10px;\n      border-bottom: 1px solid #00816a; }\n      consumers .headline .subscription .custom .custom-input::-webkit-input-placeholder {\n        color: #999999; }\n      consumers .headline .subscription .custom .custom-input::-moz-placeholder {\n        color: #999999; }\n      consumers .headline .subscription .custom .custom-input:-ms-input-placeholder {\n        color: #999999; }\n      consumers .headline .subscription .custom .custom-input:-moz-placeholder {\n        color: #999999; }\n  consumers .headline .subscription .face-form {\n    top: 48px; }\n    consumers .headline .subscription .face-form .input-group {\n      margin-top: 48px; }\n    consumers .headline .subscription .face-form .submit-group {\n      bottom: 30px;\n      text-align: center; }\n      consumers .headline .subscription .face-form .submit-group .back-button {\n        position: absolute;\n        left: 0;\n        top: -5px;\n        cursor: pointer; }\n        consumers .headline .subscription .face-form .submit-group .back-button .hover {\n          display: none; }\n        consumers .headline .subscription .face-form .submit-group .back-button:hover .normal {\n          display: none; }\n        consumers .headline .subscription .face-form .submit-group .back-button:hover .hover {\n          display: inline; }\n  consumers .headline .subscription .main-btn-wrapper {\n    margin-top: 8px; }\n    consumers .headline .subscription .main-btn-wrapper .main-btn {\n      border: 0; }\n  consumers .headline .subscription .done-btn {\n    position: relative;\n    margin-top: 200px;\n    text-align: center; }\n  consumers .headline .subscription .success-message {\n    font-size: 18px;\n    color: #00816a;\n    margin-top: 100px;\n    text-align: center; }\n\nconsumers .placeholder {\n  height: 620px; }\n\n@media only screen and (max-width: 767px) {\n  consumers .headline .subscription {\n    width: auto;\n    padding: 28px 0; }\n    consumers .headline .subscription .tags {\n      margin: 0 18px; }\n      consumers .headline .subscription .tags .tag {\n        font-size: 16px; }\n        consumers .headline .subscription .tags .tag:hover {\n          border-color: #ffffff; }\n    consumers .headline .subscription .custom {\n      padding: 48px 0;\n      margin: 0 18px;\n      font-size: 14px; }\n    consumers .headline .subscription .face-form {\n      left: 12px;\n      right: 12px; }\n      consumers .headline .subscription .face-form .input-group {\n        margin: 48px 18px; }\n      consumers .headline .subscription .face-form .submit-group .wrapper .back-button {\n        width: 40px;\n        top: 6px; }\n        consumers .headline .subscription .face-form .submit-group .wrapper .back-button img {\n          width: 100%; }\n      consumers .headline .subscription .face-form .submit-group .main-btn {\n        padding: 12px 24px; } }\n", ""]);

// exports


/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0d332f864643f0a3a074981082571d5e.png";

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _plugin = __webpack_require__(898);

var _plugin2 = _interopRequireDefault(_plugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pluginModule = _angular2.default.module('plugin', []).component('plugin', _plugin2.default).name;

var states = [{
    name: 'plugin',
    url: '/plugin',
    component: 'plugin',
    title: 'face-plugin-title'
}];

exports.default = { name: pluginModule, states: states };

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _plugin = __webpack_require__(899);

var _plugin2 = _interopRequireDefault(_plugin);

var _plugin3 = __webpack_require__(916);

var _plugin4 = _interopRequireDefault(_plugin3);

__webpack_require__(917);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pluginComponent = {
    restrict: 'E',
    bindings: {},
    template: _plugin2.default,
    controller: _plugin4.default
};

exports.default = pluginComponent;

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<div class=\"headline\">\n  <div class=\"container\">\n    <div class=\"right-box\">\n      <div class=\"heading\">{{'face-plugin-text001' | translate}}</div>\n      <div class=\"summary\">{{'face-plugin-text002' | translate}}</div>\n    </div>\n    <div class=\"left-box\">\n      <img src=\"" + __webpack_require__(900) + "\" alt=\"\">\n    </div>\n  </div>\n</div>\n<div class=\"download-panel\">\n  <div class=\"container\">\n    <div class=\"browser-sup\">{{'face-plugin-text003' | translate}}</div>\n    <div class=\"browser-list\">\n      <div class=\"item item-chrome\" ng-class=\"{active:$ctrl.browserType=='chrome'}\"\n        ng-click=\"$ctrl.browserType='chrome'\">\n        <img src=\"" + __webpack_require__(901) + "\" alt=\"\">\n        <div>{{'face-plugin-text004' | translate}}</div>\n      </div>\n      <div class=\"item item-liebao\" ng-class=\"{active:$ctrl.browserType=='liebao'}\"\n        ng-click=\"$ctrl.browserType='liebao'\">\n        <img src=\"" + __webpack_require__(902) + "\" alt=\"\">\n        <div>{{'face-plugin-text005' | translate}}</div>\n      </div>\n      <div class=\"item item-360\" ng-class=\"{active:$ctrl.browserType=='360'}\" ng-click=\"$ctrl.browserType='360'\">\n        <img src=\"" + __webpack_require__(903) + "\" alt=\"\">\n        <div>{{'face-plugin-text006' | translate}}</div>\n      </div>\n      <div class=\"item item-qq\" ng-class=\"{active:$ctrl.browserType=='qq'}\" ng-click=\"$ctrl.browserType='qq'\">\n        <img src=\"" + __webpack_require__(904) + "\" alt=\"\">\n        <div>{{'face-plugin-text007' | translate}}</div>\n      </div>\n    </div>\n    <div ng-if=\"$ctrl.browserType!='liebao'\">\n      <a ng-href=\"{{$ctrl.download_url}}\" class=\"download-btn\">{{'face-plugin-text008' | translate}}</a>\n      <div class=\"download-version\">\n        {{$ctrl.version}}\n      </div>\n    </div>\n    <div ng-if=\"$ctrl.browserType=='liebao'\">\n      <a href=\"https://yb-public.oss-cn-shanghai.aliyuncs.com/yuanben-2.2.27.crx\" class=\"download-btn\">{{'face-plugin-text008' | translate}}</a>\n      <div class=\"download-version\">\n         V2.2.27 - 2020.02.24\n      </div>\n    </div>\n    <div class=\"browser-detail\">\n      <div class=\"browser-chrome clearfix\" ng-show=\"$ctrl.browserType=='chrome'\">\n        <div class=\"step step01\">\n          <div class=\"img-wrap\"><img src=\"" + __webpack_require__(158) + "\" alt=\"\"></div>\n          <p class=\"step-sub\">1.{{'face-plugin-text009' | translate}}</p>\n          <p class=\"step-sup\">{{'face-plugin-text010' | translate}}</p>\n        </div>\n        <div class=\"jiantou\"></div>\n        <div class=\"step step02\">\n          <div class=\"img-wrap\"><img src=\"" + __webpack_require__(905) + "\" alt=\"\"></div>\n          <p class=\"step-sub\">2.{{'face-plugin-text011' | translate}}</p>\n          <p class=\"step-sup\">{{'face-plugin-text012' | translate}}</p>\n\n        </div>\n        <div class=\"jiantou\"></div>\n        <div class=\"step step03\">\n          <div class=\"img-wrap\"><img src=\"" + __webpack_require__(906) + "\" alt=\"\"></div>\n          <p class=\"step-sub\">3.{{'face-plugin-text013' | translate}}</p>\n          <p class=\"step-sup\">{{'face-plugin-text035' | translate}}{{'face-plugin-text014' | translate}}</p>\n          <p class=\"step-sup\" style=\"color: #ff3333;\">{{'face-plugin-text036' | translate}}</p>\n        </div>\n      </div>\n      <div class=\"browser-liebao\" ng-show=\"$ctrl.browserType=='liebao'\">\n        <div class=\"step step01\">\n          <p class=\"step-sub\">1.{{'face-plugin-text015' | translate}}</p>\n          <p class=\"step-sup\">{{'face-plugin-text016' | translate}}</p>\n          <br>\n          <p class=\"step-sub\">2.{{'face-plugin-text017' | translate}}</p>\n          <p class=\"step-sup\">{{'face-plugin-text018' | translate}}</p>\n\n        </div>\n        <div class=\"step step02\">\n          <img src=\"" + __webpack_require__(907) + "\" alt=\"\">\n        </div>\n      </div>\n      <div class=\"browser-360 clearfix\" ng-show=\"$ctrl.browserType=='360'\">\n        <div class=\"step step01\">\n          <div class=\"img-wrap\"><img src=\"" + __webpack_require__(158) + "\" alt=\"\"></div>\n          <p class=\"step-sub\">1.{{'face-plugin-text023' | translate}}</p>\n          <p class=\"step-sup\">{{'face-plugin-text024' | translate}}</p>\n        </div>\n        <div class=\"jiantou\"></div>\n        <div class=\"step step02\">\n          <div class=\"img-wrap\"><img src=\"" + __webpack_require__(908) + "\" alt=\"\"></div>\n          <p class=\"step-sub\">2.{{'face-plugin-text019' | translate}}</p>\n          <p class=\"step-sup\">{{'face-plugin-text020' | translate}}</p>\n\n        </div>\n        <div class=\"jiantou\"></div>\n        <div class=\"step step03\">\n          <div class=\"img-wrap\"><img src=\"" + __webpack_require__(909) + "\" alt=\"\"></div>\n          <p class=\"step-sub\">3.{{'face-plugin-text021' | translate}}</p>\n          <p class=\"step-sup\">{{'face-plugin-text022' | translate}}</p>\n        </div>\n      </div>\n      <div class=\"browser-qq clearfix\" ng-show=\"$ctrl.browserType=='qq'\">\n        <div class=\"step step01\">\n          <div class=\"img-wrap\"><img src=\"" + __webpack_require__(158) + "\" alt=\"\"></div>\n          <p class=\"step-sub\">1.{{'face-plugin-text023' | translate}}</p>\n          <p class=\"step-sup\">{{'face-plugin-text024' | translate}}</p>\n        </div>\n        <div class=\"jiantou\"></div>\n        <div class=\"step step02\">\n          <div class=\"img-wrap\"><img src=\"" + __webpack_require__(910) + "\" alt=\"\"></div>\n          <p class=\"step-sub\">2.{{'face-plugin-text025' | translate}}</p>\n          <p class=\"step-sup\">{{'face-plugin-text026' | translate}}</p>\n\n        </div>\n        <div class=\"jiantou\"></div>\n        <div class=\"step step03\">\n          <div class=\"img-wrap\"><img src=\"" + __webpack_require__(911) + "\" alt=\"\"></div>\n          <p class=\"step-sub\">3.{{'face-plugin-text027' | translate}}</p>\n          <p class=\"step-sup\">{{'face-plugin-text028' | translate}}</p>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n<div class=\"useage\">\n  <div class=\"container\">\n    <div class=\"heading\">{{'face-plugin-text029' | translate}}</div>\n    <div class=\"content\">\n      <div class=\"item fl\">\n        <div class=\"title\">1、{{'face-plugin-text030' | translate}}</div>\n        <img src=\"" + __webpack_require__(912) + "\" alt=\"\">\n      </div>\n      <div class=\"item fr\">\n        <div class=\"title\">2、{{'face-plugin-text031' | translate}}</div>\n        <img src=\"" + __webpack_require__(913) + "\" alt=\"\">\n      </div>\n      <div class=\"item fl\">\n        <div class=\"title\">3、{{'face-plugin-text032' | translate}}</div>\n        <div class=\"sub-title\">{{'face-plugin-text033' | translate}}</div>\n        <img src=\"" + __webpack_require__(914) + "\" alt=\"\">\n      </div>\n      <div class=\"item fr\">\n        <div class=\"title\">4、{{'face-plugin-text034' | translate}}</div>\n        <div class=\"sub-title with-iphone\" style=\"opacity: 0\">{{'face-plugin-text033' | translate}}</div>\n        <img src=\"" + __webpack_require__(915) + "\" alt=\"\">\n      </div>\n    </div>\n\n  </div>\n\n</div>";

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4025582f890bec42b5887cbd2916ecc6.png";

/***/ }),
/* 901 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 902 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 903 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 904 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f659bf7756acee0b32aa65fcab097163.png";

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a7aab4db26cc94394b715fdd1a50c5ac.png";

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a2e01fc5d7eb5302729b843d4706b364.png";

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "5f5751693dbcf5547ace4bc9d8ea8c9d.jpg";

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2d225f2de6860ebdd40af7c890b40300.png";

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e46388b6e0fcac18a386ff3553381ee7.png";

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f7c62cc198b72cb0ad67ae3632afb31f.png";

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6d8ddcbcbad2c9c0650c51dc5bc903ff.png";

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "962cccd11ce8d2654c42a826e80de023.png";

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2769dc0d9222d3a1039f2ad83436ad57.png";

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9d45cfdd12175bb0d6fa6ac1322185b4.png";

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pluginController = function pluginController($scope, AppConfig, PluginVersionAPI, dateFilter) {
    "ngInject";

    var _this = this;

    (0, _classCallCheck3.default)(this, pluginController);
    this.version = '-';
    this.download_url = '-';
    this.latest_version = '';
    PluginVersionAPI.one().get({
        plugin_id: AppConfig.plugin_id
    }).then(function (res) {
        console.log(res);
        _this.latest_version = res.data.latest_version;
        _this.version = 'V' + res.data.latest_version + ' - ' + dateFilter(res.data.updated_at * 1000, 'yyyy.MM.dd');
        _this.browserType = 'chrome';
    });

    $scope.$watch('$ctrl.browserType', function (newV, oldV) {
        if (newV === 'chrome') {
            _this.download_url = 'https://yb-public.oss-cn-shanghai.aliyuncs.com/yuanben-' + _this.latest_version + '_0.crx';
        } else {
            _this.download_url = 'https://yb-public.oss-cn-shanghai.aliyuncs.com/yuanben-' + _this.latest_version + '.crx';
        }
    });
}
// download_ext(){
//     $('#install-panel').addClass('active');
//     window.location.href=this.download_url
// }
;

pluginController.$inject = ['$scope', 'AppConfig', 'PluginVersionAPI', 'dateFilter'];
exports.default = pluginController;

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(918);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./plugin.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./plugin.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "plugin .headline {\n  height: 384px;\n  overflow: hidden; }\n  plugin .headline .container {\n    padding-top: 100px; }\n    plugin .headline .container .left-box {\n      width: 50%;\n      float: left; }\n      plugin .headline .container .left-box img {\n        width: 357px; }\n    plugin .headline .container .right-box {\n      width: 50%;\n      float: right; }\n    plugin .headline .container .heading {\n      font-size: 36px;\n      font-weight: bold;\n      margin: 8% 0 20px;\n      text-align: left;\n      color: #3edc76;\n      background: linear-gradient(180deg, #65fbce, #52ff7c);\n      -webkit-background-clip: text;\n      -webkit-text-fill-color: transparent; }\n    plugin .headline .container .summary {\n      font-size: 14px;\n      color: #e5f3ed;\n      line-height: 2;\n      text-align: left; }\n    plugin .headline .container .right-box, plugin .headline .container .left-box {\n      text-align: center; }\n      plugin .headline .container .right-box img, plugin .headline .container .left-box img {\n        max-width: 90%;\n        display: inline-block; }\n\nplugin .download-panel {\n  padding: 40px 0 70px;\n  background: linear-gradient(to top, #f5faf7 0%, #fff 10%); }\n  plugin .download-panel .browser-sup {\n    text-align: center; }\n  plugin .download-panel .download-btn {\n    width: 200px;\n    line-height: 40px;\n    background: #17ce73;\n    color: #fff;\n    text-align: center;\n    display: block;\n    margin: 0 auto;\n    tansition: all .4s;\n    font-size: 18px;\n    text-decoration: none;\n    border: 1px solid #0cb762;\n    cursor: pointer; }\n    plugin .download-panel .download-btn:hover {\n      background: #0cb762; }\n  plugin .download-panel .download-version {\n    text-align: center;\n    font-size: 14px;\n    color: #999999;\n    margin-top: 20px; }\n  plugin .download-panel .browser-list {\n    text-align: center;\n    padding-bottom: 40px;\n    margin: 40px auto;\n    font-size: 0;\n    border-bottom: 1px dashed #ccc; }\n    plugin .download-panel .browser-list .item {\n      width: 120px;\n      display: inline-block;\n      text-align: center;\n      font-size: 14px;\n      padding: 20px 0;\n      margin: 0 10px;\n      cursor: pointer; }\n      plugin .download-panel .browser-list .item > div {\n        margin-top: 5px; }\n      plugin .download-panel .browser-list .item.active {\n        border-radius: 10px;\n        box-shadow: 0 0 20px #ddd; }\n  plugin .download-panel .browser-detail {\n    margin-top: 40px;\n    text-align: center; }\n    plugin .download-panel .browser-detail > div {\n      font-size: 0; }\n    plugin .download-panel .browser-detail .clearfix {\n      margin: 0 auto; }\n      plugin .download-panel .browser-detail .clearfix > div {\n        float: left; }\n    plugin .download-panel .browser-detail .jiantou {\n      width: 34px;\n      height: 34px;\n      display: inline-block;\n      background: url(" + __webpack_require__(919) + ") center no-repeat;\n      position: relative;\n      top: 60px; }\n    plugin .download-panel .browser-detail .step {\n      text-align: left;\n      display: inline-block;\n      width: 240px;\n      margin: 0 0 0 60px;\n      line-height: 1.4; }\n      plugin .download-panel .browser-detail .step .step-sub {\n        font-size: 16px;\n        color: #222222; }\n      plugin .download-panel .browser-detail .step .step-sup {\n        font-size: 14px;\n        color: #666666; }\n\nplugin .img-wrap {\n  width: 192px;\n  border: 1px #d3d3d3 solid; }\n  plugin .img-wrap img {\n    width: 100%; }\n\nplugin .useage {\n  background: #fff;\n  padding: 20px 0 8%; }\n  plugin .useage .container .heading {\n    font-size: 24px;\n    color: #333;\n    line-height: 3;\n    border-bottom: 1px solid #ccc;\n    margin-bottom: 40px; }\n  plugin .useage .container .content {\n    overflow: auto; }\n  plugin .useage .container .item {\n    width: 50%;\n    line-height: 1.5;\n    margin-bottom: 5%; }\n    plugin .useage .container .item.fl {\n      float: left;\n      padding-right: 4%; }\n    plugin .useage .container .item.fr {\n      float: right;\n      padding-left: 4%; }\n    plugin .useage .container .item .title {\n      color: #333;\n      font-size: 16px;\n      margin-bottom: 10px; }\n    plugin .useage .container .item .sub-title {\n      color: #999;\n      font-size: 14px;\n      margin-bottom: 10px; }\n    plugin .useage .container .item img {\n      width: 100%;\n      display: block; }\n\n@media only screen and (max-width: 991px) {\n  plugin .headline .container .heading {\n    font-size: 32px; } }\n\n@media only screen and (max-width: 767px) {\n  plugin .headline .container {\n    padding-top: 30%; }\n    plugin .headline .container .left-box, plugin .headline .container .right-box {\n      width: 80%;\n      float: none;\n      margin: 0 auto 20px;\n      text-align: center; }\n    plugin .headline .container .heading {\n      font-size: 20px;\n      margin: 0 0 15px;\n      text-align: center; }\n    plugin .headline .container .right-box img, plugin .headline .container .left-box img {\n      width: 100%;\n      display: inline-block; }\n  plugin .download-panel .browser-detail .jiantou {\n    display: none; }\n  plugin .download-panel .browser-detail .step {\n    margin: 0 0 20px 0;\n    width: 100%;\n    padding: 0 20px; }\n  plugin .useage {\n    padding: 20px 12px 8%; }\n    plugin .useage .container .heading {\n      margin-bottom: 20px;\n      font-size: 20px; }\n    plugin .useage .container .item {\n      width: auto; }\n      plugin .useage .container .item.fl, plugin .useage .container .item.fr {\n        float: none;\n        padding: 0; }\n      plugin .useage .container .item .sub-title.with-iphone {\n        display: none; } }\n", ""]);

// exports


/***/ }),
/* 919 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _newsCenter = __webpack_require__(921);

var _newsCenter2 = _interopRequireDefault(_newsCenter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var newsCenterModule = _angular2.default.module('newsCenter', []).component('newsCenter', _newsCenter2.default).name;

var states = [{
    name: 'newsCenter',
    url: '/blog',
    component: 'newsCenter',
    title: 'face-news-title',
    description: 'face-news-desc'
}];

exports.default = { name: newsCenterModule, states: states };

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _newsCenter = __webpack_require__(922);

var _newsCenter2 = _interopRequireDefault(_newsCenter);

var _newsCenter3 = __webpack_require__(923);

var _newsCenter4 = _interopRequireDefault(_newsCenter3);

__webpack_require__(924);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var newsCenterComponent = {
    restrict: 'E',
    bindings: {
        appUser: '='
    },
    template: _newsCenter2.default,
    controller: _newsCenter4.default
};

exports.default = newsCenterComponent;

/***/ }),
/* 922 */
/***/ (function(module, exports) {

module.exports = "<div class=\"head-line\">\n    <div class=\"bg\"></div>\n    <div class=\"content\">\n        <div class=\"text\">\n            <h5>{{ 'face-newscenter-text01' | translate }}</h5>\n            <p>{{ 'face-newscenter-text02' | translate }}</p>\n        </div>\n    </div>\n</div>\n<div class=\"main\">\n    <div class=\"main-content\">\n        <ul class=\"news-nav\">\n            <li class=\"nav-tab active\">{{ 'face-newscenter-text03' | translate }}</li>\n        </ul>\n        <div class=\"list\">\n            <a class=\"list-item\" ng-repeat=\"article in $ctrl.articles track by $index\" href=\"javascript:;\" ng-click=\"$ctrl.navigateTo(article)\">\n                <div class=\"left\" ng-if=\"article.main_article_image\">\n                    <img src=\"{{ article.main_article_image + '?x-oss-process=image/resize,m_fill,w_320,h_180,limit_0' }}\" alt=\"\">\n                </div>\n                <div class=\"right\" ng-class=\"[!!article.main_article_image && 'has-left']\">\n                    <div class=\"header\">\n                        <div class=\"title\">{{ article.title }}</div>\n                    </div>\n                    <div class=\"body\">\n                        {{ article.outline }}\n                    </div>\n                    <div class=\"footer\">\n                        <div class=\"source\" ng-if=\"article.source\">{{article.source}}</div>\n                        <div class=\"time\">{{ 'face-newscenter-text04' | translate }}{{ article.published_at * 1000 | date : 'yyyy.MM.dd' }}</div>\n                        <span class=\"read-more\">{{ 'face-newscenter-text05' | translate }}</span>\n                    </div>\n                </div>\n            </a>\n        </div>\n        <div class=\"pagnation\">\n            <button type=\"button\" class=\"btn-prev\" ng-disabled=\"$ctrl.page <= 1\" ng-click=\"$ctrl.goPage('prev')\">\n                <i class=\"ybicon yb-last\"></i>\n            </button>\n            <span class=\"pagination-placeholder\" ng-if=\"$ctrl.minimum > 1\">...</span>\n            <ul class=\"pager\">\n                <li class=\"number\" ng-click=\"$ctrl.goPage(p)\" ng-class=\"{active: p === $ctrl.page}\" ng-repeat=\"p in $ctrl.pageArr\">{{p}}</li>\n            </ul>\n            <span class=\"pagination-placeholder\" ng-if=\"$ctrl.maxmum < $ctrl.page_total\">...</span>\n            <button type=\"button\" class=\"btn-next\" ng-click=\"$ctrl.goPage('next')\" ng-disabled=\"$ctrl.page >= $ctrl.total_page\">\n                <i class=\"ybicon yb-next\"></i>\n            </button>\n            <div class=\"pagnation-jump\">\n                {{ 'face-newscenter-text06' | translate }}\n                <input ng-model=\"$ctrl.number\" type=\"text\" class=\"jump-input\">\n                {{ 'face-newscenter-text07' | translate }}\n                <button ng-click=\"$ctrl.goPage($ctrl.number)\">{{ 'face-newscenter-text08' | translate }}</button>\n            </div>\n        </div>\n    </div>\n</div>\n\n";

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NewsCenterController = function () {
    NewsCenterController.$inject = ['$state', '$filter', 'AnnouncementAPI', 'AnnouncementTagAPI'];

    function NewsCenterController($state, $filter, AnnouncementAPI, AnnouncementTagAPI) {
        "ngInject";

        var _this = this;

        (0, _classCallCheck3.default)(this, NewsCenterController);
        this.tranlsteFilter = $filter('translate');
        this.AnnouncementTagAPI = AnnouncementTagAPI;
        this.AnnouncementAPI = AnnouncementAPI;
        this.$state = $state;
        this.articles = [];
        this.page = 1;
        this.minimum = 1;
        this.canSeeNumber = 3;
        this.page_size = 20;
        this.total_page = 0;
        this.tags = [];
        this.currentTag = -1;
        this.articles.fill({
            thumb: 'http://www.aliued.com/wp-content/uploads/2017/02/C7C970CB-18A4-4261-B2F9-665962E8EEAC.jpg',
            title: '【原本资讯】「原本链」网站开放展示接口文档页面',
            time: '2018.05.18',
            desc: '「原本链」近期在官网上开放了接口的文档。其中展示了：原本链部署文档、API描述文档、sdk接口使用文档、license介绍文档、区块数据介绍、metadata介绍。并且还支持原本链项目PPT的下载。文档的开放展示，使以前对原本链不熟悉的「原本链」近期在官网上开放了接口的文档。其中展示了：原本链部署文档、API描述文档、sdk接口使用文档、license介绍文档、区块数据介绍、metadata介绍。并且还支持原本链项目PPT的下载。文档的开放展示，使以前对原本链不熟悉的「原本链」近期在官网上开放了接口的文档。其中展示了：原本链部署文档、API描述文档、sdk接口使用文档、license介绍文档、区块数据介绍、metadata介绍。并且还支持原本链项目PPT的下载。文档的开放展示，使以前对原本链不熟悉的'
        }, 0, 6);
        this.loadArticles(function () {
            return _this.caculateRange();
        });
    }

    (0, _createClass3.default)(NewsCenterController, [{
        key: 'caculateRange',
        value: function caculateRange() {
            this.maxmum = this.canSeeNumber < this.total_page ? this.minimum + this.canSeeNumber - 1 : this.total_page;
            var arr = [];
            for (var i = this.minimum; i <= this.maxmum; i++) {
                arr.push(i);
            }
            console.log(arr);
            this.pageArr = arr;
        }
    }, {
        key: 'loadTag',
        value: function loadTag() {
            var _this2 = this;

            this.AnnouncementTagAPI.one().get().then(function (res) {
                _this2.tags = res;
                _this2.currentTag = res[0]['id'];
                _this2.loadArticles(function () {
                    if (_this2.total_page < _this2.canSeeNumber) _this2.canSeeNumber = _this2.total_page;
                    _this2.caculateRange();
                });
            });
        }
    }, {
        key: 'loadArticles',
        value: function loadArticles(cb) {
            var _this3 = this;

            this.AnnouncementTagAPI.one().get({
                page: this.page,
                page_size: this.page_size,
                tag_id: this.currentTag
            }).then(function (res) {
                _this3.articles = res.data;
                _this3.total_page = Math.ceil(res.total / 20);
                cb && cb();
            });
        }
    }, {
        key: 'onChangeTag',
        value: function onChangeTag(tagId) {
            if (tagId === this.currentTag) return;
            this.currentTag = tagId;
            this.loadArticles();
        }
    }, {
        key: 'goPage',
        value: function goPage(page) {
            var _this4 = this;

            var intVal = parseInt(page);
            if (intVal !== 0 && !intVal) {
                if (page === 'prev') {
                    this.page--;
                } else if (page === 'next') {
                    this.page++;
                } else {
                    return;
                }
                this.loadArticles(function () {
                    if (_this4.page > _this4.maxmum) {
                        _this4.minimum++;
                    } else if (_this4.page < _this4.minimum) {
                        _this4.minimum--;
                    }
                    _this4.caculateRange();
                });
            } else {
                page = intVal;
                if (page === this.page || page < 1 || page > this.total_page) return;
                this.page = page;
                this.loadArticles(function () {
                    if (_this4.page > _this4.maxmum) {
                        _this4.minimum = _this4.page - _this4.canSeeNumber + 1;
                    } else if (_this4.page < _this4.minimum) {
                        _this4.minimum = _this4.page;
                    }
                    _this4.caculateRange();
                });
            }
            scrollTo(0, 0);
        }
    }, {
        key: 'navigateTo',
        value: function navigateTo(article) {
            if (article.link) {
                window.open(article.link, '_blank');
            } else {
                this.$state.go('app.page.news', { 'id': article.id });
            }
        }
    }]);
    return NewsCenterController;
}();

exports.default = NewsCenterController;

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(925);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./news-center.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./news-center.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "news-center {\n  background-color: #f4f4f4; }\n  news-center .head-line {\n    position: relative;\n    height: 420px;\n    background: linear-gradient(0deg, #00bbad 0%, #021938 100%), linear-gradient(#489f82, #489f82); }\n    news-center .head-line .bg {\n      position: absolute;\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      background: url(" + __webpack_require__(926) + ") no-repeat center top;\n      z-index: 0; }\n    news-center .head-line .content {\n      position: relative;\n      padding-top: 150px;\n      z-index: 2; }\n      news-center .head-line .content .text {\n        width: 700px;\n        margin: 0 auto;\n        color: #d5f1ed; }\n        news-center .head-line .content .text h5 {\n          font-size: 40px;\n          margin: 0; }\n        news-center .head-line .content .text p {\n          font-size: 30px; }\n  news-center .main {\n    position: relative; }\n  news-center .main-content {\n    width: 1000px;\n    padding: 15px 30px;\n    margin: -100px auto 0;\n    min-height: 1000px;\n    background-color: #fff; }\n    news-center .main-content::after {\n      display: block;\n      clear: both;\n      content: \"\"; }\n    news-center .main-content .news-nav {\n      padding: 0;\n      margin: 0;\n      border-bottom: 1px solid #1ca49a;\n      color: #1ca49a;\n      list-style: none; }\n      news-center .main-content .news-nav .nav-tab {\n        padding: 10px 0;\n        margin-right: 15px;\n        display: inline-block;\n        font-size: 20px;\n        cursor: pointer;\n        border-bottom: 2px solid #1ca49a; }\n        news-center .main-content .news-nav .nav-tab.active {\n          font-weight: bold; }\n    news-center .main-content .list {\n      padding: 15px 0; }\n      news-center .main-content .list .list-item {\n        display: block;\n        text-decoration: none;\n        padding: 20px 0 15px;\n        border-bottom: 1px solid #bfbfbf; }\n        news-center .main-content .list .list-item::after {\n          display: block;\n          clear: both;\n          content: \"\"; }\n        news-center .main-content .list .list-item .left {\n          float: left;\n          width: 320px;\n          height: 180px;\n          overflow: hidden;\n          border: 1px solid #c7c7c7; }\n          news-center .main-content .list .list-item .left img {\n            width: 100%;\n            height: auto; }\n        news-center .main-content .list .list-item .right.has-left {\n          margin-left: 342px; }\n        news-center .main-content .list .list-item .header {\n          margin-bottom: 20px; }\n          news-center .main-content .list .list-item .header .title {\n            margin-right: 30px;\n            font-size: 20px;\n            line-height: 1.5;\n            color: #1ca49a;\n            font-weight: bold;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            /*! autoprefixer: off */\n            -webkit-box-orient: vertical;\n            /* autoprefixer: on */\n            display: -webkit-box;\n            -webkit-line-clamp: 2; }\n        news-center .main-content .list .list-item .body {\n          margin-bottom: 20px;\n          line-height: 1.5;\n          height: 95px;\n          color: #999;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          /*! autoprefixer: off */\n          -webkit-box-orient: vertical;\n          /* autoprefixer: on */\n          display: -webkit-box;\n          -webkit-line-clamp: 4; }\n        news-center .main-content .list .list-item .footer::after {\n          display: block;\n          clear: both;\n          content: \"\"; }\n        news-center .main-content .list .list-item .footer .read-more {\n          float: right;\n          color: #999; }\n        news-center .main-content .list .list-item .footer .source {\n          float: left;\n          padding: 3px 15px;\n          margin-right: 10px;\n          background-color: #cfecea;\n          font-size: 14px;\n          color: #1ca49a;\n          border-radius: 12px; }\n        news-center .main-content .list .list-item .footer .time {\n          float: left;\n          padding-top: 3px;\n          font-size: 14px;\n          color: #c7c7c7; }\n    news-center .main-content .pagnation {\n      float: right;\n      color: #a0a0a0; }\n      news-center .main-content .pagnation .btn-prev, news-center .main-content .pagnation .btn-next, news-center .main-content .pagnation .number {\n        margin: 0 4px;\n        display: inline-block;\n        line-height: 30px;\n        font-size: 18px;\n        text-align: center;\n        cursor: pointer; }\n      news-center .main-content .pagnation .btn-prev, news-center .main-content .pagnation .btn-next {\n        margin: 0;\n        padding: 0 15px;\n        background: none;\n        border: none;\n        color: #999; }\n        news-center .main-content .pagnation .btn-prev[disabled], news-center .main-content .pagnation .btn-next[disabled] {\n          color: #eee; }\n      news-center .main-content .pagnation .pager {\n        padding: 0;\n        display: inline-block; }\n        news-center .main-content .pagnation .pager .number {\n          padding: 0 10px;\n          display: inline-block;\n          min-width: 30px;\n          background: #f5f5f5;\n          border-radius: 2px; }\n          news-center .main-content .pagnation .pager .number.active {\n            background-color: #fff;\n            border: 2px solid #1ca49a;\n            line-height: 26px; }\n      news-center .main-content .pagnation .pagination-placeholder {\n        padding: 0 15px;\n        vertical-align: super; }\n      news-center .main-content .pagnation .current {\n        margin: 0 3px;\n        font-weight: bold;\n        color: #000; }\n      news-center .main-content .pagnation .pagnation-jump {\n        margin-left: 10px;\n        display: inline-block; }\n        news-center .main-content .pagnation .pagnation-jump .jump-input {\n          padding: 0 10px;\n          width: 50px;\n          line-height: 28px;\n          border: 1px solid #ccc;\n          border-radius: 2px; }\n        news-center .main-content .pagnation .pagnation-jump button {\n          margin-left: 5px;\n          padding: 0 15px;\n          background-color: #f5f5f5;\n          border: 1px solid #cdcdcd;\n          border-radius: 2px;\n          color: #a0a0a0;\n          line-height: 28px;\n          cursor: pointer; }\n  @media only screen and (max-width: 991px) {\n    news-center .head-line .content .text {\n      padding: 0 15px;\n      width: auto; }\n    news-center .left {\n      height: auto !important; }\n    news-center .main-content {\n      padding: 0 15px;\n      width: 100%; }\n      news-center .main-content .list {\n        padding: 0; }\n      news-center .main-content .list .list-item {\n        padding: 10px 0; }\n        news-center .main-content .list .list-item .left {\n          display: none; }\n        news-center .main-content .list .list-item .right.has-left {\n          margin-left: 0; }\n        news-center .main-content .list .list-item .right .header {\n          margin-bottom: 10px; }\n          news-center .main-content .list .list-item .right .header .title {\n            font-size: 16px; }\n        news-center .main-content .list .list-item .right .body {\n          margin-bottom: 10px;\n          font-size: 14px;\n          line-height: 1.6;\n          height: auto; }\n        news-center .main-content .list .list-item .right .read-more {\n          padding-top: 4px;\n          font-size: 14px; }\n    news-center .pagnation .pagnation-jump {\n      display: none !important; } }\n", ""]);

// exports


/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "43060a9542c894ed52d8da23de932712.png";

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _dataSmart = __webpack_require__(928);

var _dataSmart2 = _interopRequireDefault(_dataSmart);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dataSmartModule = _angular2.default.module('dataSmart', []).component('dSmart', _dataSmart2.default) // 只能叫dSmart 叫dataSmart找不到组件

.name;

var states = [{
  name: 'dataSmart',
  url: '/data-intelligence',
  component: 'dSmart',
  title: 'face-data-smart-text001',
  description: 'face-data-smart-text001'
}];
exports.default = { name: dataSmartModule, states: states };

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _dataSmart = __webpack_require__(929);

var _dataSmart2 = _interopRequireDefault(_dataSmart);

var _dataSmart3 = __webpack_require__(936);

var _dataSmart4 = _interopRequireDefault(_dataSmart3);

__webpack_require__(937);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dataSmartComponent = {
    restrict: 'E',
    bindings: {
        appUser: '='
    },
    template: _dataSmart2.default,
    controller: _dataSmart4.default
};

exports.default = dataSmartComponent;

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<div class=\"head-line\">\n  <div class=\"container clearfix left banner\">\n    <div class=\"text\">\n      <h1>{{ 'face-data-smart-text001' | translate }}</h1>\n      <p>{{ 'face-data-smart-text042' | translate }}</p>\n      <p>{{ 'face-data-smart-text002' | translate }}</p>\n      <a ng-click=\"$ctrl.goApplication()\">{{'face-data-smart-text043' | translate}}</a>\n    </div>\n    <div class=\"image\">\n      <img src=\"" + __webpack_require__(930) + "\" alt=\"\">\n    </div>\n  </div>\n  <div class=\"container clearfix left section section1\">\n    <div class=\"image\">\n      <img src=\"" + __webpack_require__(931) + "\" alt=\"\">\n    </div>\n    <div class=\"outer\">\n      <div class=\"text\">\n        <span class=\"suspend-title\">{{ 'face-data-smart-text003' | translate }}</span>\n        <h5>{{ 'face-data-smart-text004' | translate }}</h5>\n        <p>{{ 'face-data-smart-text005' | translate }}</p>\n        <h5>{{ 'face-data-smart-text006' | translate }}</h5>\n        <p>{{ 'face-data-smart-text007' | translate }}</p>\n        <h5>{{ 'face-data-smart-text008' | translate }}</h5>\n        <p>{{ 'face-data-smart-text009' | translate }}</p>\n        <h5>{{ 'face-data-smart-text010' | translate }}</h5>\n        <p>{{ 'face-data-smart-text011' | translate }}</p>\n      </div>\n    </div>\n  </div>\n</div>\n</div>\n<div class=\"group1\">\n  <div class=\"container clearfix right section section2\">\n    <div class=\"image\">\n      <img src=\"" + __webpack_require__(932) + "\" alt=\"\">\n    </div>\n    <div class=\"outer\">\n      <div class=\"text\">\n        <span class=\"suspend-title\">{{ 'face-data-smart-text012' | translate }}</span>\n        <h5>{{ 'face-data-smart-text013' | translate }}</h5>\n        <p>{{ 'face-data-smart-text014' | translate }}</p>\n        <h5>{{ 'face-data-smart-text015' | translate }}</h5>\n        <p>{{ 'face-data-smart-text016' | translate }}</p>\n        <h5>{{ 'face-data-smart-text017' | translate }}</h5>\n        <p>{{ 'face-data-smart-text018' | translate }}</p>\n        <h5>{{ 'face-data-smart-text019' | translate }}</h5>\n        <p>{{ 'face-data-smart-text020' | translate }}</p>\n      </div>\n    </div>\n  </div>\n  <div class=\"container clearfix left section section3\">\n    <div class=\"image\">\n      <img src=\"" + __webpack_require__(933) + "\" alt=\"\">\n    </div>\n    <div class=\"outer\">\n      <div class=\"text\">\n        <span class=\"suspend-title\">{{ 'face-data-smart-text021' | translate }}</span>\n        <h5>{{ 'face-data-smart-text022' | translate }}</h5>\n        <p>{{ 'face-data-smart-text023' | translate }}</p>\n        <h5>{{ 'face-data-smart-text024' | translate }}</h5>\n        <p>{{ 'face-data-smart-text025' | translate }}</p>\n        <h5>{{ 'face-data-smart-text026' | translate }}</h5>\n        <p>{{ 'face-data-smart-text027' | translate }}</p>\n      </div>\n    </div>\n  </div>\n</div>\n<div class=\"group2\">\n  <div class=\"container clearfix right section section4\">\n    <div class=\"image\">\n      <img src=\"" + __webpack_require__(934) + "\" alt=\"\">\n    </div>\n    <div class=\"outer\">\n      <div class=\"text\">\n        <span class=\"suspend-title\">{{ 'face-data-smart-text028' | translate }}</span>\n        <h5>{{ 'face-data-smart-text029' | translate }}</h5>\n        <p>{{ 'face-data-smart-text030' | translate }}</p>\n        <h5>{{ 'face-data-smart-text031' | translate }}</h5>\n        <p>{{ 'face-data-smart-text032' | translate }}</p>\n        <h5>{{ 'face-data-smart-text033' | translate }}</h5>\n        <p>{{ 'face-data-smart-text034' | translate }}</p>\n      </div>\n    </div>\n  </div>\n  <div class=\"container clearfix left section section5\">\n    <div class=\"image\">\n      <img src=\"" + __webpack_require__(935) + "\" alt=\"\">\n    </div>\n    <div class=\"outer\">\n      <div class=\"text\">\n        <span class=\"suspend-title\">{{ 'face-data-smart-text035' | translate }}</span>\n        <h5>{{ 'face-data-smart-text036' | translate }}</h5>\n        <p>{{ 'face-data-smart-text037' | translate }}</p>\n        <h5>{{ 'face-data-smart-text038' | translate }}</h5>\n        <p>{{ 'face-data-smart-text039' | translate }}</p>\n        <h5>{{ 'face-data-smart-text040' | translate }}</h5>\n        <p>{{ 'face-data-smart-text041' | translate }}</p>\n      </div>\n    </div>\n  </div>\n</div>\n";

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "966ff64f5180c8a8a9459d8d595a0b20.png";

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "29c4ec1e5c6b790e322b308f66765ac9.png";

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1e928f0b218cb8b8424c47546540e2b5.png";

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6a34402d8cbe7a87e9c4f8dc24b1acba.png";

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0c781646be8c3a9bc8034589cf5ba567.png";

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7cf851dc7916c2ea82aa90f9add108c1.png";

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DataSmartController = function () {
    function DataSmartController() {
        (0, _classCallCheck3.default)(this, DataSmartController);
    }

    (0, _createClass3.default)(DataSmartController, [{
        key: 'goApplication',
        value: function goApplication() {
            window.open('/application');
        }
    }]);
    return DataSmartController;
}();

exports.default = DataSmartController;

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(938);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./data-smart.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./data-smart.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "d-smart {\n  display: block;\n  background-color: #edf5f6;\n  color: #383838; }\n  d-smart .head-line {\n    background: url(" + __webpack_require__(939) + ") no-repeat center top; }\n  d-smart .left .image {\n    float: left; }\n  d-smart .left .text {\n    float: right; }\n  d-smart .right .image {\n    float: right; }\n  d-smart .right .text {\n    float: left; }\n  d-smart .banner {\n    padding-top: 140px;\n    margin-bottom: 100px; }\n    d-smart .banner .text {\n      position: relative;\n      top: 70px;\n      color: #28e7c2; }\n      d-smart .banner .text h1 {\n        margin: 0 0 15px;\n        font-size: 50px; }\n      d-smart .banner .text p {\n        margin: 6px 0;\n        font-size: 20px; }\n      d-smart .banner .text a {\n        display: inline-block;\n        margin-top: 35px;\n        padding: 8px 40px;\n        background: rgba(28, 164, 165, 0.4);\n        color: #28e7c2;\n        border: 2px solid #28e7c2;\n        border-radius: 30px;\n        cursor: pointer; }\n  d-smart .section .text {\n    border: 2px dashed #00777a;\n    border-top-right-radius: 30px;\n    border-bottom-left-radius: 30px;\n    padding: 40px 30px 30px 70px;\n    max-width: 430px; }\n  d-smart .section .suspend-title {\n    position: absolute;\n    left: -2px;\n    top: -20px;\n    font-size: 30px;\n    font-weight: bold;\n    color: #017b7f;\n    background-color: #edf5f6; }\n  d-smart .section h5 {\n    position: relative;\n    margin: 0;\n    font-size: 20px;\n    color: #666; }\n    d-smart .section h5::before {\n      content: \"\\E632\";\n      font-family: \"ybicon\";\n      position: absolute;\n      left: -40px;\n      top: 2px;\n      color: #01baba; }\n  d-smart .section p {\n    margin: 4px 0 20px;\n    line-height: 1.4;\n    font-size: 16px;\n    color: #666; }\n  d-smart .section1 .image {\n    position: relative;\n    left: 30px; }\n  d-smart .section1 .text {\n    position: relative;\n    top: 40px; }\n  d-smart .group1 {\n    background: url(" + __webpack_require__(940) + ") no-repeat center top;\n    overflow: hidden; }\n  d-smart .section2 {\n    padding-top: 80px;\n    margin-bottom: 320px; }\n    d-smart .section2 .text {\n      position: relative;\n      top: 200px; }\n    d-smart .section2 .image {\n      position: relative;\n      right: 50px;\n      top: 60px; }\n  d-smart .section3 {\n    margin-bottom: 320px; }\n    d-smart .section3 .text {\n      position: relative;\n      top: 100px;\n      right: 20px; }\n  d-smart .group2 {\n    background: url(" + __webpack_require__(941) + ") no-repeat center top;\n    padding-bottom: 190px; }\n  d-smart .section4 {\n    margin-bottom: 220px; }\n    d-smart .section4 .text {\n      position: relative;\n      top: 50px; }\n    d-smart .section4 .image {\n      position: relative;\n      top: -65px; }\n  d-smart .section5 .text {\n    position: relative;\n    top: 180px;\n    left: 50px; }\n  @media only screen and (max-width: 991px) {\n    d-smart .text, d-smart .image {\n      width: auto;\n      float: none !important; }\n    d-smart .image {\n      width: 90%;\n      margin: 0 auto; }\n      d-smart .image img {\n        width: 100%;\n        height: auto; }\n    d-smart .banner {\n      margin-bottom: 80px; }\n    d-smart .banner .text {\n      top: -30px;\n      right: 0;\n      text-align: center;\n      margin-bottom: 40px; }\n      d-smart .banner .text h1 {\n        font-size: 30px; }\n      d-smart .banner .text p {\n        margin-top: 10px;\n        font-size: 20px; }\n    d-smart .image {\n      margin-bottom: 30px; }\n    d-smart .outer {\n      padding: 0 15px; }\n    d-smart .text {\n      padding: 0 15px; }\n      d-smart .text > div {\n        text-align: center; }\n      d-smart .text h1 {\n        font-size: 30px;\n        text-align: center; }\n      d-smart .text h5 {\n        font-size: 18px; }\n      d-smart .text p {\n        margin: 4px 0 14px;\n        font-size: 16px; }\n    d-smart .section1 .image {\n      left: 0; }\n    d-smart .section1 .text {\n      top: 0;\n      right: 0; }\n    d-smart .section2 {\n      padding-top: 100px;\n      margin-bottom: 100px; }\n      d-smart .section2 .image {\n        right: 0;\n        top: 0; }\n      d-smart .section2 .text {\n        top: 0; }\n    d-smart .section3 {\n      margin-bottom: 80px; }\n      d-smart .section3 .text {\n        top: 0;\n        right: 0; }\n      d-smart .section3 .outer {\n        position: relative;\n        top: 40px; }\n    d-smart .group2 {\n      padding-top: 40px;\n      padding-bottom: 100px; }\n    d-smart .section4 {\n      margin-bottom: 180px; }\n      d-smart .section4 .image {\n        top: 0; }\n      d-smart .section4 .text {\n        top: 0; }\n    d-smart .section5 .text {\n      top: 0;\n      left: 0; } }\n  @media only screen and (max-width: 374px) {\n    d-smart .section2 {\n      padding-top: 187px; } }\n", ""]);

// exports


/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8311d192d7a30aa05fde473cee6a7534.png";

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "34809b77d0195ed6cc822eba341955b1.png";

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a0aed3e22f9a79cc8228039e0e217487.png";

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _pricing = __webpack_require__(943);

var _pricing2 = _interopRequireDefault(_pricing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pricingModule = _angular2.default.module('pricing', []).component('pricing', _pricing2.default).name;

var states = [{
    name: 'pricing',
    url: '/pricing',
    component: 'pricing',
    title: 'face-plugin-title'
}];

exports.default = { name: pricingModule, states: states };

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _pricing = __webpack_require__(944);

var _pricing2 = _interopRequireDefault(_pricing);

var _pricing3 = __webpack_require__(945);

var _pricing4 = _interopRequireDefault(_pricing3);

__webpack_require__(949);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pricingComponent = {
    restrict: 'E',
    bindings: {},
    template: _pricing2.default,
    controller: _pricing4.default
};

exports.default = pricingComponent;

/***/ }),
/* 944 */
/***/ (function(module, exports) {

module.exports = "<div class=\"headline\">\n  <div class=\"bg\"></div>\n  <div class=\"content\">\n    <div class=\"text\">定价服务</div>\n    <div class=\"description\">选择一款适合自己企业的方案</div>\n  </div>\n</div>\n<div class=\"enterprise-solutions\">\n  <div class=\"solution-card\">\n    <div class=\"title\">企业系统解决方案</div>\n    <ul class=\"desc-list\">\n      <li>原本SaaS服务主要为企业提供作品的上链，让作品在区块链上进行存证</li>\n      <li>提供API 对接，原本系统直接对接您的文章系统，使认证上链更便捷</li>\n      <li>为您的作品寻找更多需求方（版权交易）</li>\n      <li>监测您已发布的文章，对进行侵权监测</li>\n      <li>对于被检测到侵权你的文章进行证据固化，电子互联网法院可通过本平台进行取证</li>\n    </ul>\n    <div class=\"consulting\">\n      <a href=\"\" class=\"btn btn-pricing\">立即咨询</a>\n    </div>\n  </div>\n</div>\n<div class=\"pricing-package-table\">\n  <div class=\"pricing-package-body\">\n    <div class=\"pricing-package-title\">\n      <h2>数据聚合服务</h2>\n      <p>根据您的需求，可自主选择你想要的服务</p>\n    </div>\n    <div class=\"pricing-packages\">\n      <div class=\"pricing-package\" ng-class=\"[$ctrl.selected == product && 'active']\" ng-repeat=\"product in $ctrl.products\">\n        <img ng-src=\"{{product.badge}}\" alt=\"\">\n        <p class=\"version\">{{product.version}}</p>\n        <h1 class=\"price\">\n          <span class=\"symbol\">¥</span>{{product.price}}</h1>\n        <ul class=\"feature-list\">\n          <li class=\"feature\" ng-repeat=\"feature in product.features\" ng-bind-html=\"feature\"></li>\n        </ul>\n        <button class=\"btn btn-choice\" ng-click=\"$ctrl.onSelect(product)\">{{ $ctrl.selected == product?'当前选择':'选择' }}</button>\n      </div>\n    </div>\n  </div>\n\n</div>\n";

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PricingController = function () {
    function PricingController() {
        (0, _classCallCheck3.default)(this, PricingController);

        this.products = [{
            badge: __webpack_require__(946),
            version: '免费版',
            price: 0,
            features: ['免费区块链登记</br>（100条/月）']
        }, {
            badge: __webpack_require__(947),
            version: '高级版',
            price: 100,
            features: ['免费区块链登记', '免费侵权监测', '接口授权', '定制开发（费用另计）']
        }, {
            badge: __webpack_require__(948),
            version: '豪华版',
            price: 1000,
            features: ['免费存证', '免费侵权监测']
        }];
        this.selected = this.products[0];
    }

    (0, _createClass3.default)(PricingController, [{
        key: 'onSelect',
        value: function onSelect(product) {
            if (product === this.selected) return;
            this.selected = product;
        }
    }]);
    return PricingController;
}();

exports.default = PricingController;

/***/ }),
/* 946 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 947 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 948 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(950);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./pricing.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./pricing.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "pricing .headline {\n  height: 435px;\n  background: linear-gradient(-4deg, #50a67e 0%, #449476 50%, #367f6b 100%), linear-gradient(#489f82, #489f82); }\n  pricing .headline .content {\n    padding-top: 100px; }\n    pricing .headline .content .text {\n      font-size: 30px;\n      font-weight: bold; }\n    pricing .headline .content .description {\n      margin-top: 25px;\n      font-size: 24px; }\n\npricing .enterprise-solutions {\n  position: relative; }\n  pricing .enterprise-solutions .solution-card {\n    position: absolute;\n    top: -160px;\n    left: 50%;\n    margin-left: -412.5px;\n    padding: 35px 100px;\n    width: 825px;\n    height: 365px;\n    background-color: #ffffff;\n    box-shadow: 0px 0px 9px 1px rgba(110, 110, 110, 0.33);\n    border-radius: 15px;\n    z-index: 2; }\n    pricing .enterprise-solutions .solution-card .title {\n      font-size: 24px;\n      text-align: center;\n      color: #1a9f9c; }\n    pricing .enterprise-solutions .solution-card .desc-list {\n      margin-bottom: 30px;\n      color: #999;\n      line-height: 2.25; }\n    pricing .enterprise-solutions .solution-card .consulting {\n      text-align: center; }\n\npricing .pricing-package-table {\n  padding: 280px 0 50px;\n  background-color: #fff; }\n  pricing .pricing-package-table .pricing-package-body {\n    width: 830px;\n    margin: 0 auto; }\n  pricing .pricing-package-table .pricing-package-title {\n    margin-bottom: 40px;\n    color: #1a9f9c;\n    text-align: center; }\n    pricing .pricing-package-table .pricing-package-title p {\n      font-size: 18px; }\n  pricing .pricing-package-table .pricing-packages::after {\n    display: block;\n    clear: both;\n    content: \"\"; }\n  pricing .pricing-package-table .pricing-packages .pricing-package {\n    float: left;\n    padding: 40px 33px 25px;\n    margin-right: 1%;\n    width: 32%;\n    text-align: center; }\n    pricing .pricing-package-table .pricing-packages .pricing-package .version {\n      margin: 25px 0 30px;\n      font-size: 22px;\n      color: #1a9f9c; }\n    pricing .pricing-package-table .pricing-packages .pricing-package .price {\n      font-size: 72px;\n      color: #5a5a5a; }\n      pricing .pricing-package-table .pricing-packages .pricing-package .price .symbol {\n        margin-right: 10px;\n        font-size: 23px;\n        font-weight: normal;\n        vertical-align: super; }\n    pricing .pricing-package-table .pricing-packages .pricing-package .feature-list {\n      height: 180px;\n      padding: 0;\n      margin: 0 0 50px;\n      list-style: none;\n      line-height: 1.5;\n      color: #999; }\n      pricing .pricing-package-table .pricing-packages .pricing-package .feature-list .feature {\n        margin-bottom: 20px; }\n    pricing .pricing-package-table .pricing-packages .pricing-package .btn-choice {\n      padding: 8px 50px;\n      color: #fff;\n      font-size: 20px;\n      border: 0;\n      border-radius: 24px;\n      background-color: #d6d6d6; }\n    pricing .pricing-package-table .pricing-packages .pricing-package.active {\n      border: solid 3px #479877;\n      border-radius: 15px; }\n      pricing .pricing-package-table .pricing-packages .pricing-package.active .btn-choice {\n        background: linear-gradient(90deg, #50a67e 0%, #449476 50%, #367f6b 100%), linear-gradient(90deg, #22b796 0%, #1ca59b 50%, #16919f 100%), linear-gradient(#22b696, #22b696); }\n\npricing .btn-pricing {\n  padding: 8px 75px;\n  color: #fff;\n  font-size: 20px;\n  background: linear-gradient(90deg, #50a67e 0%, #449476 50%, #367f6b 100%), linear-gradient(90deg, #22b796 0%, #1ca59b 50%, #16919f 100%), linear-gradient(#22b696, #22b696);\n  border: 0;\n  border-radius: 24px; }\n", ""]);

// exports


/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _partners = __webpack_require__(952);

var _partners2 = _interopRequireDefault(_partners);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var partnersModule = _angular2.default.module('partners', []).component('partners', _partners2.default).name;

var states = [{
  name: 'partners',
  url: '/partners',
  component: 'partners',
  title: 'face-partners-text01',
  description: 'face-partners-text02'
}];

exports.default = { name: partnersModule, states: states };

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _partners = __webpack_require__(953);

var _partners2 = _interopRequireDefault(_partners);

var _partners3 = __webpack_require__(963);

var _partners4 = _interopRequireDefault(_partners3);

__webpack_require__(964);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var partnersComponent = {
    restrict: 'E',
    bindings: {},
    template: _partners2.default,
    controller: _partners4.default
};

exports.default = partnersComponent;

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<div class=\"head-line\">\n  <div class=\"bg\"></div>\n  <div class=\"container clearfix left banner\">\n    <div class=\"text\">\n      <h1>{{'face-partners-text01' | translate}}</h1>\n      <p>{{'face-partners-text02' | translate}}</p>\n      <button class=\"btn btn-primary\" ng-click=\"$ctrl.goCoop()\"><span>{{'face-partners-text03' | translate}}</span></button>\n    </div>\n    <div class=\"image\">\n      <img src=\"" + __webpack_require__(954) + "\" alt=\"\">\n    </div>\n  </div>\n  <div class=\"container reason\">\n    <h1>{{'face-partners-text04' | translate}}</h1>\n    <p>{{'face-partners-text05' | translate}}</p>\n  </div>\n</div>\n<div class=\"section1\">\n  <div class=\"box-wrapper\">\n    <div class=\"row clearfix\">\n      <div class=\"box\">\n        <img src=\"" + __webpack_require__(955) + "\" alt=\"\">\n        <h4>{{'face-partners-text06' | translate}}</h4>\n        <p>{{'face-partners-text07' | translate}}</p>\n      </div>\n      <div class=\"box\">\n        <img src=\"" + __webpack_require__(956) + "\" alt=\"\">\n        <h4>{{'face-partners-text08' | translate}}</h4>\n        <p>{{'face-partners-text09' | translate}}</p>\n      </div>\n    </div>\n    <div class=\"row clearfix\">\n      <div class=\"box\">\n        <img src=\"" + __webpack_require__(957) + "\" alt=\"\">\n        <h4>{{'face-partners-text10' | translate}}</h4>\n        <p>{{'face-partners-text11' | translate}}</p>\n      </div>\n      <div class=\"box\">\n        <img src=\"" + __webpack_require__(958) + "\" alt=\"\">\n        <h4>{{'face-partners-text12' | translate}}</h4>\n        <p>{{'face-partners-text13' | translate}}</p>\n      </div>\n    </div>\n  </div>\n</div>\n<div class=\"section2\">\n  <div class=\"container\">\n    <h1 class=\"section-title\"><span>{{'face-partners-text24' | translate}}</span></h1>\n    <ul class=\"steps\">\n      <li class=\"step\" style=\"width: 72px\">\n        <div class=\"marker\">1</div>\n        <div class=\"text\">{{'face-partners-text25' | translate}}</div>\n      </li >\n      <li class=\"step\" style=\"width: 72px\"  >\n        <div class=\"marker\">2</div>\n        <div class=\"text\">{{'face-partners-text26' | translate}}</div>\n      </li>\n      <li class=\"step\" style=\"width: 108px\">\n        <div class=\"marker\">3</div>\n        <div class=\"text\">{{'face-partners-text27' | translate}}</div>\n      </li>\n      <li class=\"step\" style=\"width: 72px\">\n        <div class=\"marker\">4</div>\n        <div class=\"text\">{{'face-partners-text28' | translate}}</div>\n      </li>\n      <li class=\"step\" style=\"width: 72px\">\n        <div class=\"marker\">5</div>\n        <div class=\"text\">{{'face-partners-text29' | translate}}</div>\n      </li>\n    </ul>\n  </div>\n</div>\n<div class=\"section3\">\n  <div class=\"container\">\n    <h1 class=\"section-title\"><span>{{'face-partners-text14' | translate}}</span></h1>\n    <div class=\"row clearfix\">\n      <div class=\"col\">\n        <div class=\"image\">\n          <img src=\"" + __webpack_require__(959) + "\" alt=\"\">\n        </div>\n        <h4>{{'face-partners-text15' | translate}}</h4>\n        <p>{{'face-partners-text16' | translate}}</p>\n      </div>\n      <div class=\"col\">\n        <div class=\"image\">\n          <img src=\"" + __webpack_require__(960) + "\" alt=\"\">\n        </div>\n        <h4>{{'face-partners-text17' | translate}}</h4>\n        <p>{{'face-partners-text18' | translate}}</p>\n      </div>\n      <div class=\"col\">\n        <div class=\"image\">\n          <img src=\"" + __webpack_require__(961) + "\" alt=\"\">\n        </div>\n        <h4>{{'face-partners-text19' | translate}}</h4>\n        <p>{{'face-partners-text20' | translate}}</p>\n      </div>\n      <div class=\"col\">\n        <div class=\"image\">\n          <img src=\"" + __webpack_require__(962) + "\" alt=\"\">\n        </div>\n        <h4>{{'face-partners-text21' | translate}}</h4>\n        <p>{{'face-partners-text22' | translate}}</p>\n      </div>\n    </div>\n  </div>\n</div>\n\n<!--<div class=\"section3\">-->\n  <!--<div class=\"container\">-->\n    <!--<h1 class=\"section-title\"><span>赋能支持</span></h1>-->\n    <!--<div class=\"row clearfix\">-->\n      <!--<div class=\"col\">-->\n        <!--<div class=\"box\">-->\n          <!--<h4>解决方案</h4>-->\n          <!--<div class=\"area\">-->\n            <!--<p>营销系列课程</p>-->\n            <!--<p>营销资料、机器学习绪论、人工智能基础概念等</p>-->\n          <!--</div>-->\n          <!--<div class=\"area\">-->\n            <!--<p>建模专业课程</p>-->\n            <!--<p>基于先知平台的建模、模型调参、实战应用、高级特征工程等</p>-->\n          <!--</div>-->\n          <!--<div class=\"area\">-->\n            <!--<p>技术实施课程</p>-->\n            <!--<p>基于先知的开发以及平台部署实施、模型上线等技术课程</p>-->\n          <!--</div>-->\n        <!--</div>-->\n      <!--</div>-->\n      <!--<div class=\"col\">-->\n        <!--<div class=\"box\">-->\n          <!--<h4>伙伴资源</h4>-->\n          <!--<div class=\"area\">-->\n            <!--<p>营销系列课程</p>-->\n            <!--<p>营销资料、机器学习绪论、人工智能基础概念等</p>-->\n          <!--</div>-->\n          <!--<div class=\"area\">-->\n            <!--<p>建模专业课程</p>-->\n            <!--<p>基于先知平台的建模、模型调参、实战应用、高级特征工程等</p>-->\n          <!--</div>-->\n          <!--<div class=\"area\">-->\n            <!--<p>技术实施课程</p>-->\n            <!--<p>基于先知的开发以及平台部署实施、模型上线等技术课程</p>-->\n          <!--</div>-->\n        <!--</div>-->\n      <!--</div>-->\n    <!--</div>-->\n  <!--</div>-->\n<!--</div>-->\n";

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "60238648c7bcb110c7fc5c8cc42b989c.png";

/***/ }),
/* 955 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 956 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 957 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 958 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 959 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAAB2CAMAAAAAyWaMAAAC/VBMVEUAAAAcxLkowLc/yMI5z8dAx8Aiv7Uz1Ms/ycIu0MdN2dE/x8Ay0sou2M4/ycI+ycMM2s8AqJgAwLAAsaI8ysMArp8ApZoAs6U+ycI+ycMArZ9BxsAArqICy71Ax8EAr6E+ycM7ycNBxsBAx8EC798ArqBAx8EJ7N07zcYAv6wA8eEAsKI8y8QAcGoAvKkAiIEE7t4Aq51Ax8E/yMI5z8cI7N0AsKEL7d4AoZYAl44AraMA8OA+ysQAeHIB798A8eI6zsYH7+AK7d4I7t8Ak4km3dMAn5AA8uLA8vHA8vEAfHUAgnoAtqjA8vHA8vEA8OA40Mg8zMQe4tYA8uEAh4AAtaYH7N4AfHbA8vEAfncAy7cAiIAJ6dwA0scAgXkAaGEc4tbA8fEm3dO/8vEg4NXA8fEAu6AA8OG48O/A8fG/8vG+9/VBxsC/9fO9+fYApZi/8vIAtaYAsqMA7d4A8OAAsKI40MgAuKgAxroAxbgAw7YAvKoAwq8A5NQD6twAvawA8uMA1McAzLwy1cwA4dEA3tEAyr8A5tYA3M8/yME+ysMAyb0q29AAgHkAp5MAeHEu2M8A2s0A1MQA6dkAw7IAv60At58AcGsAZmEA18kAqZUA0MIAy8EAoI0AfHU6zsYAwK4m3dMA2MYAsp4ArpsAsJoi4NQAzsAAyboAu68AaWQA4dMA0MUAzMMA08EAyK4AuqkAu6IAqpkArZcAdG4AbWc10soAx7wAv7MApI8Al4YAk4MP6Nod4tYAwbUAuKwAw6oAxqkAo5QA2csA28g+ysQAvqYY5NgA18MA0L4Aw6c8zMUAuKIAhX0A4M4A1coAzK4AyqsAnYkAzrIU5tkA3csAvbEAs6gAtJsAwaS9+/cAvqIAyrIAjn6i9fAA18wAxrSx+PS49/ST9+8h29AAyLeq8/CH8+slz8YA0bW18/Bp8+l46uNU5NsD2M1S8OU/8ORo59+W7ekn8uNF6d4z5toYzsR69uw03dMA07mG6eQh6dwy0McQzcQuw712karqAAAAa3RSTlMACQXAwPUPwDgXEd8ewG9L/tPQuiYq8dW0ZFzp4N+sclgu0aCNjXwo9/Hw7unm4t3WnpOJgEZGOP79+vj01LSionxkWB7s6uLVsY45NyTs6dvPzMmzqXBtaFPx8O/rw6unko+EVETyxHdOPCGX0BMAAAt4SURBVGjetJbdS1NhHMefnbl11myiy5fN5ZaiGM7ElDBR8CK6KC8SlIio/oEDssHZDAdeCILLpReFUeq88GZSECNtbLDBYFfmTRftavf+BV6V9Ht+83jOzste2tnnRhH8ffZ9vs/LSE20d3S02kfdzvvtZtIIDK2LImDqdztndRWMLipou030w6mc38n1EX3AAhTzh0wc16x/ASJWjuPGGlkAB5jMDSwAGWhUAR0mDulmGlgA4tBB0K9RANLbkAJcnEgLqZOHygImTRKBkdQHo1LABSeFrbPhkRcPgImJiUWBBFdCT30CT8dpJLK3t7n5/fvw9PT0yMiDSU7GzTrGs73cBQgiKNjePjo6/PhxWC64R/6X5h4OmBAibIPhEAwdnEg994V5rLhZ2pQR9CiBcXRzFKuHzIsRjjBCaQvW6+Q/aOktph8wEPIEBZII0yUCG6mdm10c0mchlFfyCLESQ1et2+j6PW59nZ5R4cl9LomAghH5PqpllRibd51ibRH/NEINm5IIaWF0t7X4w8ZUvfhWHG8q+Y9nWhFMLGMz4W/4eSpz2xgO0/myzOYXEUkLIDi8EArGFQVwRSth6VsPU5StPT49LY3wSDgBij2hjWFgCsfPqYR9CIKSCMPCCVDsak08VhzvdajWNS8axPuCVT2X6rBNOcrUmMa98kQlgk31ZjGyarfazAnO72nWftiePH/2+PGr6WGoASPku9TuRqxCPsUwPngC5ObAXRkGVa9fz6scLla1Coc3Sud7HUQHPMUquh2idC5KGRwHqR4YBopV9LKXOziKzFiIblj6OKQHTpMtGgCiTSzRFdZYrMJGBgPAUw/RHY8VDSQAzDCkATC4TiAAPKQBGKyC4GmT/gkY4XYix4FAEwHGbTpaGFs3PcpGFBwfX6MbC4JovxezdnctehYWxyETkNtNgRmtO2iB5/nO+9ULmk348kgESIuFJiFyzP2TPGJvr+qMsfTwEgQFqygQcCjuC+eQnxfoN1dxS1hxgESwuioRjAcCt5xE5H6nnyI4hipV0QVvuVlTgFV07gav1qLd7svjfNHhctvL5WgpecuN8N0BBdJPHPQFgz77LC6+D/FLHShxqjY7g8WScoJ2+zcgGORTSbvFPYTjlQ7VLWUYmwr3VBBYRpcpoPBlU6lsEJIAGo4F2ZayTMFbrirYWl29gR/BfWdZgCp8INByxM55flJShYWuPhxddcHWFhU4765QRAWwuOtXc2TWolG/sKXwxfJeJ6rAd8RLwWzbB2BF5viVSmYVOYJLAYCKLquwDZ54WU1BGAULoX1A4Qh+Su5C5SWO9FlAEAD0dLN4NssKXoYAVcdPH6wULzp+75yfnf35cyVYjPOjBuiiguCz624IoQqZw5+ZSO36izlWfux8/fr3/AwcWMdBspByuRhSXrCxsfE5Hm+9E1JzBGOxTHKzkDyAILE3OzsgKCp8QD5VSLry/nKC3KXgIB5/17ofUjgS6cTvWLYQ2eOXl9Nv19bWrhTYR9yVyeTzZQW5HBV8AcGnd486Q++ljv300pt0IhHLpgqFQnwpE3srUcSTfl/bnVjVgn+M1t1rUmEcB/AVQRAEtnv/gAj6M6Iu6jqCLiKKXgilWJ0jWTj0TDhxSDsN1A2WR1Nwc6gw2/vZUTYdYyvdYjFpErpYbIMNgl5u+j6/c86QxJfnbgyeD9/v91GMpINBafLSRVk+NhyCmOUcH0YAQNAcmhb5IIjCECO4vunpC1YWrz1wygQUJkjS5OS58wZhHRobEuOcA5fYpiFo3Geb1pcVBRgAbMMXOZ6AZ20B/N7teffunV9RIpl0EMDw8LkRENabrtHQkCByvGNuxDZFAMfNO7JiNpt1oCcWjwB0dKIz4AIQyQR14dK5G9a1Ndfo6JggxnlESE9B0HgIuH3eZkvTFOgP/8Mj6xJAhAxKAlAqWS3bDAjF+tGRbAAcT8RjTevjsDbiUX8dAPym7nkPYFBRokYECLEGgHfI6SkImgMAIzQtmxVFcYz6oxE6Au/fu1YGAUCQmFAKWQ7QEQOoo3QJgASA1wHWVAMw3wUQWGECAL2kosWHCK7RGCLwvBwpQZAcEBiRTsc5DsCQYIzQFnhqAiREjZKSAAIEUEcmYBLIERcIoHfUHnj6tGcWQAoAhIwuJL0E6B3Vq5FhCEEGmISIJ6Y/4q6A2dncYgrAJkWA4Pd4D3IQQmzmOq8MQ0jLsknMjVqgj+GhAkBHXQEkGCVJAHy5QMCVNAEIEQBEKH3SKwL0EeY+dwvoGTJoiQAfAD8ACMqkDlAGXpIArAGIUUdYoROwtDRreU4CldQIJIsARujpKjI7fJyTpOCrA3rEAn1XjQj3TnYCljZ6KyoDDCGc0Dvys46q1cgzCEpVlqvg4kEpXaOPSSwGgBf37PbL91sBpycmCPCq53sri8cCA7w5FqEYr/bHFUsoCqDaT43xMgF6BOHQTufK1ZbARM/6OgBVvWgdTwGAQACL4C/WWUeK1+utP4v5jUmqALYJiO3/sJvn1pk2wDoDFhd7b6gkZAIJN+so2Z/0hyAMejz0wUBjDKhHar5tRAj92rE3nGvXT7YAZmbWPeOquoyd0RMTwglECBf9gQLNTEAOAEV4+5IB22u1I/t/5/KdZgA/fAHMrI4bwt3eysrmZt6ZyCULuDMMoNi/4vF4jGcLLpqJ1nwHlj/25oMpWgDucV3YSqUwxWbeXQivYmYAEABQBJYHQjSi1Gp7Px7hNAuYohl4gQQAFlT1CxMGz/8uhN1uWiFcYBFSrDFECLv8yKNE3x7S9U2EOUUT8OKFu0LCsi4MOp1OzIwIYXSUJABCPsw6ilX9xvWm0W6Ks8cACcvLX7a2GDAAAHfmEQHAYiKh52HvKHdEt7YzMEUTUGbCgikAcLrdq96NPOsoCSBBeQKuwB7d2NG4fcYAXr8mwFkumxGYMDCACBAAQCCA5cnnDr89erSz09GgKUzgNQG75fLHj4iwQAIDnAQgQiGp6pNs7FP5Pl/jpa2Nyw9M4MkTE/gEgAkDbwxgwwDwl+fn14c4BtDZoClM4Ilzd3cXwidDADAAwA2ACSq4n0cPjUNAO6NxCh3AWf2NDBVDIIAimMDf7w+Pz/4+cpin/Rz/mi1j1sTBMI4/OggWb7uPIAhOLuIgKCriKFRw6lCOwg2Fd4mrIYPi4nCQT+Dicl/B2wreVK5wt2QImIDhqmKsirZd7nmfRJG8thqxcD90/f/I/x/eN4/jdbv9DeLcIN9RS45BVbEjNNw7hqZl3HoRFaLjZd1GilBAA6L+3BhI0NoKGjpF+nU8TdqUfwMQjkpE/dk17Aj+NMaU5tcxnHQ6PP/LBXBiGYm4/0sGVd4YGlOhnfp3wSFM/jjrEJ9isCGZkIg7FDzIKCCDPbgVaDYPPYfxsqb4yyTsEMyX3Sl+PcgSPcKrzhgTBI3Gga6eFl2kU8x7b7iLaJoUrWcSSCbjCI5W69059EmX8rF8kVi2VpNcLLbNx99R8G1n+BmH+defYT+pSo0c0wHzcIzBGC9/cC5T8Db5Einmlif/CIe17PcxvliAdwnl0jXusHXmhRyLxf54fdHndHMBOEQkWyNGYk/4r9f3xQ9n+HmF+dcROIbUV0exMphAq872lN//zcHyj6VQIsPcEgUt7+bMWvY4iRvwQSAXJ4VtegSDgee1MhcUf1UNgD/C7hTTIXsDKn8qc3rRMPgnlvGsLTAY9Sg/E4PTSCbIoKzYltGIbbFeKT6RhJMJVuPO2qbGHFSVuZg2vwrlq2oQTofOQIWm0DVtV6BPJY4cFU81/1MoikJTaOhAAZUvEUL5p06hIDiFoWmmyZixck5dLP9c5MukwCkQc06nVTkPZySEU3BsXbdp9nQ0BOclklUcKD8bgfOTqigulRR8DIWSgpQK8EHQGRjHK+W/4h97zMR9rcmZgQAAAABJRU5ErkJggg=="

/***/ }),
/* 960 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 961 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 962 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PartnersController = function () {
    function PartnersController() {
        (0, _classCallCheck3.default)(this, PartnersController);

        this.name = 'partners';
    }

    (0, _createClass3.default)(PartnersController, [{
        key: 'goCoop',
        value: function goCoop() {
            window.open('/cooperation');
        }
    }]);
    return PartnersController;
}();

exports.default = PartnersController;

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(965);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./partners.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./partners.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "partners {\n  display: block;\n  background-color: #fff;\n  color: #383838; }\n  partners h1, partners h2, partners h3, partners h4, partners h5 {\n    margin: 0; }\n  partners p {\n    margin: 0; }\n  partners .head-line {\n    position: relative;\n    background: linear-gradient(0deg, #00bbad 0%, #021938 100%), linear-gradient(#489f82, #489f82);\n    height: 750px; }\n    partners .head-line h1 {\n      margin-bottom: 15px; }\n    partners .head-line .bg {\n      position: absolute;\n      left: 0;\n      right: 0;\n      top: 150px;\n      background: url(" + __webpack_require__(966) + ") no-repeat center top;\n      height: 570px; }\n    partners .head-line .banner {\n      padding-top: 80px; }\n      partners .head-line .banner .text {\n        padding: 100px 0 0 140px;\n        color: #28e7c2; }\n        partners .head-line .banner .text h1 {\n          font-size: 40px; }\n        partners .head-line .banner .text p {\n          margin: 0 auto;\n          width: 260px;\n          font-size: 20px; }\n        partners .head-line .banner .text .btn {\n          margin-top: 35px;\n          padding: 8px 40px;\n          background: rgba(28, 164, 165, 0.4);\n          color: #28e7c2;\n          border: 2px solid #28e7c2;\n          border-radius: 30px; }\n      partners .head-line .banner .image {\n        padding: 30px 180px 0 0; }\n        partners .head-line .banner .image img {\n          width: 300px; }\n    partners .head-line .reason {\n      padding: 90px 100px 0; }\n      partners .head-line .reason h1 {\n        text-align: center;\n        color: #fff;\n        font-size: 26px; }\n      partners .head-line .reason p {\n        font-size: 18px;\n        color: #fff;\n        line-height: 1.5; }\n  partners .section1 {\n    position: relative;\n    height: 750px; }\n    partners .section1 .box-wrapper {\n      position: absolute;\n      top: -128px;\n      left: 50%;\n      margin-left: -321.5px;\n      width: 643px; }\n      partners .section1 .box-wrapper .row {\n        margin-right: -43px;\n        margin-bottom: 46px; }\n    partners .section1 .box {\n      float: left;\n      margin-right: 43px;\n      padding: 50px 25px 0;\n      width: 300px;\n      min-height: 380px;\n      text-align: center;\n      box-shadow: 0px 0px 10px 3px rgba(104, 104, 104, 0.2);\n      border-radius: 10px;\n      background-color: #fff; }\n      partners .section1 .box img {\n        width: 80px;\n        margin-bottom: 40px; }\n      partners .section1 .box h4 {\n        margin-bottom: 15px;\n        color: #1ca49a;\n        font-size: 20px; }\n      partners .section1 .box p {\n        color: #999;\n        font-size: 16px;\n        line-height: 1.5;\n        text-align: left; }\n  partners .section-title {\n    padding: 64px 0;\n    color: #1ca49a;\n    font-size: 30px;\n    text-align: center; }\n  partners .section2 {\n    padding-bottom: 90px;\n    background-color: #f4f4f4; }\n    partners .section2 .steps {\n      list-style: none; }\n      partners .section2 .steps::after {\n        display: block;\n        clear: both;\n        content: \"\"; }\n      partners .section2 .steps .step {\n        float: left;\n        margin: 0 52px;\n        text-align: center; }\n        partners .section2 .steps .step .marker {\n          position: relative;\n          margin: 0 auto 15px;\n          width: 50px;\n          height: 50px;\n          line-height: 44px;\n          background-color: #024558;\n          border-radius: 50%;\n          border: 3px solid #0eafa4;\n          color: #28e7c2;\n          font-weight: bold; }\n        partners .section2 .steps .step .text {\n          color: #696969;\n          font-size: 18px; }\n        partners .section2 .steps .step:not(:last-child) .marker::after {\n          position: absolute;\n          top: 50%;\n          left: 107%;\n          content: \"\";\n          width: 130px;\n          height: 2px;\n          background-color: #006762; }\n        partners .section2 .steps .step:nth-child(2) .marker::after, partners .section2 .steps .step:nth-child(3) .marker::after {\n          width: 150px; }\n  partners .section3 {\n    padding-bottom: 90px; }\n    partners .section3 .col {\n      padding: 0 30px;\n      float: left;\n      width: 25%;\n      text-align: center; }\n      partners .section3 .col .image {\n        line-height: 130px; }\n        partners .section3 .col .image > img {\n          vertical-align: middle; }\n      partners .section3 .col h4 {\n        margin: 30px 0 15px;\n        color: #1ca49a;\n        font-size: 20px; }\n      partners .section3 .col p {\n        font-size: 16px;\n        color: #999;\n        line-height: 1.5;\n        text-align: left; }\n  partners .left .text {\n    float: left; }\n  partners .left .image {\n    float: right; }\n  @media only screen and (max-width: 991px) {\n    partners .left .text, partners .left .image {\n      float: none; }\n    partners .head-line {\n      height: auto;\n      padding-bottom: 20px; }\n      partners .head-line .banner {\n        text-align: center; }\n        partners .head-line .banner .text {\n          padding: 0 10px; }\n        partners .head-line .banner .image {\n          padding: 30px 0; }\n      partners .head-line .reason {\n        padding: 10px 30px 10px 45px; }\n    partners .section-title span {\n      border-bottom: 2px solid #1ca49a; }\n    partners .section1 {\n      height: auto; }\n      partners .section1 .box-wrapper {\n        position: static;\n        margin: 0;\n        top: 0;\n        left: 0;\n        width: auto;\n        padding: 15px 30px; }\n        partners .section1 .box-wrapper .row {\n          margin: 0; }\n        partners .section1 .box-wrapper .box {\n          float: none;\n          width: auto;\n          margin-right: 0;\n          margin-bottom: 20px; }\n    partners .section2 {\n      display: none; }\n    partners .section3 {\n      padding: 0 0 40px;\n      background-color: #f4f4f4; }\n      partners .section3 .col {\n        float: none;\n        width: auto;\n        padding-top: 15px;\n        padding-bottom: 15px; } }\n", ""]);

// exports


/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e01ba5d13b377d1839ee0dd166c7a36c.jpg";

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _solutions = __webpack_require__(968);

var _solutions2 = _interopRequireDefault(_solutions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var solutionsModule = _angular2.default.module('solutions', []).component('solutions', _solutions2.default).name;

var states = [{
  name: 'solutions',
  url: '/solutions',
  component: 'solutions',
  title: 'face-solutions-text01',
  description: 'face-solutions-text02'
}];

exports.default = { name: solutionsModule, states: states };

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _solutions = __webpack_require__(969);

var _solutions2 = _interopRequireDefault(_solutions);

var _solutions3 = __webpack_require__(980);

var _solutions4 = _interopRequireDefault(_solutions3);

__webpack_require__(981);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var solutionsComponent = {
    restrict: 'E',
    bindings: {},
    template: _solutions2.default,
    controller: _solutions4.default
};

exports.default = solutionsComponent;

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<div class=\"head-line\">\n   <div class=\"bg\"></div>\n   <div class=\"container clearfix left banner\">\n      <div class=\"text\">\n         <h1>\n            <span>{{'face-solutions-text01' | translate}}</span>\n \n         </h1>\n         <p>{{'face-solutions-text002' | translate}}</p>\n      </div>\n   </div>\n</div>\n<div class=\"solutions_main\">\n   <div class=\"main_top\">\n         <section class=\"characteristic\">\n               <div class=\"section_title\">{{'face-solutions-text003' | translate}}</div>\n               <div class=\"section_box characteristic\">\n                  <div class=\"item\">\n                     <div class=\"item_img\"><img src=\"" + __webpack_require__(970) + "\" alt=\"\"></div>\n                     <div class=\"item_title\">{{'face-solutions-text004' | translate}}</div>\n                     <div class=\"item_text\">{{'face-solutions-text005' | translate}}</div>\n                  </div>\n                  <div class=\"item\">\n                     <div class=\"item_img\"><img src=\"" + __webpack_require__(971) + "\" alt=\"\"></div>\n                     <div class=\"item_title\">{{'face-solutions-text006' | translate}}</div>\n                     <div class=\"item_text\">{{'face-solutions-text007' | translate}}</div>\n                  </div>\n                  <div class=\"item\">\n                     <div class=\"item_img\"><img src=\"" + __webpack_require__(972) + "\" alt=\"\"></div>\n                     <div class=\"item_title\">{{'face-solutions-text008' | translate}}</div>\n                     <div class=\"item_text\">{{'face-solutions-text009' | translate}}\n                        </div>\n                  </div>\n                  <div class=\"item\">\n                     <div class=\"item_img\"><img src=\"" + __webpack_require__(973) + "\" alt=\"\"></div>\n                     <div class=\"item_title\">{{'face-solutions-text010' | translate}}</div>\n                     <div class=\"item_text\">{{'face-solutions-text011' | translate}}</div>\n                  </div>\n               </div>\n            </section>\n   </div>\n   <section class=\"programme\">\n      <div class=\"section_title\">{{'face-solutions-text012' | translate}}</div>\n      <div class=\"section_box\">\n         <div class=\"item_box\">\n            <div class=\"item\">\n               <div class=\"item_img\"><img src=\"" + __webpack_require__(974) + "\" alt=\"\"></div>\n               <div class=\"item_title\">{{'face-solutions-text013' | translate}}</div>\n               <div class=\"item_text\">{{'face-solutions-text014' | translate}}</div>\n            </div>\n            <div class=\"item\">\n               <div class=\"item_img\"><img src=\"" + __webpack_require__(975) + "\" alt=\"\"></div>\n               <div class=\"item_title\">{{'face-solutions-text015' | translate}}</div>\n               <div class=\"item_text\">{{'face-solutions-text016' | translate}}</div>\n            </div>\n            <div class=\"item\">\n               <div class=\"item_img\"><img src=\"" + __webpack_require__(976) + "\" alt=\"\"></div>\n               <div class=\"item_title\">{{'face-solutions-text017' | translate}}</div>\n               <div class=\"item_text\">{{'face-solutions-text018' | translate}}</div>\n            </div>\n         </div>\n         <div class=\"item_box\">\n            <div class=\"item\">\n               <div class=\"item_img\"><img src=\"" + __webpack_require__(977) + "\" alt=\"\"></div>\n               <div class=\"item_title\">{{'face-solutions-text019' | translate}}</div>\n               <div class=\"item_text\">{{'face-solutions-text020' | translate}}</div>\n            </div>\n            <div class=\"item\">\n               <div class=\"item_img\"><img src=\"" + __webpack_require__(978) + "\" alt=\"\"></div>\n               <div class=\"item_title\">{{'face-solutions-text021' | translate}}</div>\n               <div class=\"item_text\">{{'face-solutions-text022' | translate}}</div>\n            </div>\n            <div class=\"item\">\n               <div class=\"item_img\"><img src=\"" + __webpack_require__(979) + "\" alt=\"\"></div>\n               <div class=\"item_title\">{{'face-solutions-text023' | translate}}</div>\n               <div class=\"item_text\">{{'face-solutions-text024' | translate}}</div>\n            </div>\n         </div>\n      </div>\n   </section>\n   <section>\n\n   </section>\n</div>\n\n\n";

/***/ }),
/* 970 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 971 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 972 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 973 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 974 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 975 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 976 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 977 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 978 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 979 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SolutionsController = function () {
    function SolutionsController() {
        (0, _classCallCheck3.default)(this, SolutionsController);

        this.name = 'solutions';
    }

    (0, _createClass3.default)(SolutionsController, [{
        key: 'goCoop',
        value: function goCoop() {
            window.open('/cooperation');
        }
    }]);
    return SolutionsController;
}();

exports.default = SolutionsController;

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(982);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./solutions.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./solutions.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "solutions {\n  display: block;\n  background-color: #fff;\n  color: #383838; }\n  solutions h1, solutions h2, solutions h3, solutions h4, solutions h5 {\n    margin: 0; }\n  solutions p {\n    margin: 0; }\n  solutions .head-line {\n    position: relative;\n    background: linear-gradient(0deg, #00bbad 0%, #021938 100%), linear-gradient(#489f82, #489f82);\n    height: 420px; }\n    solutions .head-line h1 {\n      margin-bottom: 15px; }\n    solutions .head-line .bg {\n      position: absolute;\n      left: 0;\n      right: 0;\n      top: 0px;\n      background: url(" + __webpack_require__(983) + ") no-repeat center top;\n      height: 420px;\n      background-size: 100% 100%; }\n    solutions .head-line .banner {\n      padding-top: 80px;\n      width: 1100px; }\n      solutions .head-line .banner .text {\n        padding: 100px 0 0 0;\n        color: #D6F2EE; }\n        solutions .head-line .banner .text h1 {\n          font-size: 40px;\n          color: #d5f1ed; }\n        solutions .head-line .banner .text p {\n          font-size: 20px;\n          color: #88C9C7; }\n      solutions .head-line .banner .image {\n        padding: 30px 180px 0 0; }\n        solutions .head-line .banner .image img {\n          width: 300px; }\n    solutions .head-line .reason {\n      padding: 90px 100px 0; }\n      solutions .head-line .reason h1 {\n        text-align: center;\n        color: #fff;\n        font-size: 26px; }\n      solutions .head-line .reason p {\n        font-size: 18px;\n        color: #fff;\n        line-height: 1.5; }\n  solutions .solutions_main {\n    overflow: hidden;\n    background: #FAFAFA; }\n    solutions .solutions_main section {\n      margin-bottom: 60px;\n      width: 1010px;\n      margin: 0 auto;\n      font-family: 'Microsoft YaHei'; }\n      solutions .solutions_main section .section_title {\n        width: 100%;\n        height: 45px;\n        text-align: center;\n        line-height: 45px;\n        font-size: 32px;\n        font-weight: 400;\n        color: black; }\n      solutions .solutions_main section .section_box {\n        width: 100%; }\n        solutions .solutions_main section .section_box .item {\n          margin-right: 1px;\n          background: #fff;\n          padding-bottom: 15px; }\n          solutions .solutions_main section .section_box .item .item_img {\n            text-align: center; }\n          solutions .solutions_main section .section_box .item .item_title {\n            height: 40px;\n            text-align: center;\n            font-size: 18px;\n            font-weight: 500;\n            color: black; }\n          solutions .solutions_main section .section_box .item .item_text {\n            font-size: 14px;\n            font-weight: 500;\n            color: #999999;\n            line-height: 28px; }\n      solutions .solutions_main section.characteristic {\n        background: #fff;\n        padding-bottom: 105px; }\n        solutions .solutions_main section.characteristic .section_title {\n          padding: 63px 0 41px 0; }\n        solutions .solutions_main section.characteristic .section_box {\n          margin-top: 61px;\n          display: flex; }\n        solutions .solutions_main section.characteristic .item {\n          width: 227px;\n          margin-right: 45px; }\n          solutions .solutions_main section.characteristic .item .item_img img {\n            width: 90px;\n            height: 90px; }\n          solutions .solutions_main section.characteristic .item:last-child {\n            margin-right: auto; }\n      solutions .solutions_main section.programme .section_title {\n        margin: 63px 0 41px 0; }\n      solutions .solutions_main section.programme .item_box {\n        width: 100%;\n        display: flex;\n        margin-bottom: 46px; }\n        solutions .solutions_main section.programme .item_box .item {\n          margin-right: 46px;\n          width: 306px;\n          min-height: 346px;\n          padding-top: 33px; }\n          solutions .solutions_main section.programme .item_box .item .item_img img {\n            width: 60px;\n            height: 60px; }\n          solutions .solutions_main section.programme .item_box .item .item_text {\n            padding: 0 30px; }\n          solutions .solutions_main section.programme .item_box .item:last-child {\n            margin-right: auto; }\n    solutions .solutions_main .main_top {\n      background: #fff; }\n  solutions .left .text {\n    float: left; }\n  solutions .left .image {\n    float: right; }\n  @media only screen and (max-width: 991px) {\n    solutions .left .text, solutions .left .image {\n      float: none; }\n    solutions .head-line {\n      height: 320px;\n      padding-bottom: 20px; }\n      solutions .head-line .banner {\n        padding-left: 5%;\n        text-align: left;\n        width: 760px; }\n        solutions .head-line .banner .text {\n          margin-top: 50px;\n          padding: 0 10px; }\n          solutions .head-line .banner .text h1 {\n            font-size: 20px;\n            font-size: 32px;\n            line-height: 60px; }\n            solutions .head-line .banner .text h1 > span {\n              display: block; }\n              solutions .head-line .banner .text h1 > span .comma {\n                display: none; }\n          solutions .head-line .banner .text p {\n            width: 350px;\n            line-height: 30px;\n            font-size: 16px; }\n        solutions .head-line .banner .image {\n          padding: 30px 0; }\n      solutions .head-line .reason {\n        padding: 10px 30px 10px 45px; }\n      solutions .head-line .bg {\n        position: absolute;\n        left: 0;\n        right: 0;\n        top: 0px;\n        background: url(" + __webpack_require__(984) + ") no-repeat center top;\n        height: 320px; }\n    solutions .solutions_main {\n      overflow: hidden;\n      background: #FAFAFA;\n      font-family: PingFangSC-Medium,PingFang SC; }\n      solutions .solutions_main section {\n        width: auto;\n        margin-bottom: 60px;\n        padding: 0 10%; }\n        solutions .solutions_main section .section_box {\n          width: 100%; }\n          solutions .solutions_main section .section_box .item {\n            margin: 0 auto;\n            margin-bottom: 40px; }\n        solutions .solutions_main section.characteristic .section_box {\n          display: block; }\n        solutions .solutions_main section.characteristic .item {\n          width: 300px; }\n        solutions .solutions_main section.programme .item_box {\n          display: block; }\n          solutions .solutions_main section.programme .item_box .item {\n            margin-right: auto; } }\n", ""]);

// exports


/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "81d4e6ec4f29f95458c037310029c5f6.png";

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "43060a9542c894ed52d8da23de932712.png";

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _cooperation = __webpack_require__(986);

var _cooperation2 = _interopRequireDefault(_cooperation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PHONE_REGEXP = /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/;

var cooperationModule = _angular2.default.module('cooperation', []).component('cooperation', _cooperation2.default).directive('phone', function () {
  return {
    require: 'ngModel',
    link: function link(scope, elm, attrs, ctrl) {
      ctrl.$validators.phone = function (modelValue, viewValue) {
        if (ctrl.$isEmpty(modelValue)) {
          // consider empty models to be valid
          return true;
        }
        if (PHONE_REGEXP.test(viewValue)) {
          // it is valid
          return true;
        }
        // it is invalid
        return false;
      };
    }
  };
}).name;

var states = [{
  name: 'cooperation',
  url: '/cooperation',
  component: 'cooperation',
  title: 'face-cooperation-text01',
  description: 'face-cooperation-text01'
}];

exports.default = { name: cooperationModule, states: states };

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _cooperation = __webpack_require__(987);

var _cooperation2 = _interopRequireDefault(_cooperation);

var _cooperation3 = __webpack_require__(989);

var _cooperation4 = _interopRequireDefault(_cooperation3);

__webpack_require__(990);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cooperationComponent = {
    restrict: 'E',
    bindings: {},
    template: _cooperation2.default,
    controller: _cooperation4.default
};

exports.default = cooperationComponent;

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<div class=\"bg\"></div>\n<div class=\"container\">\n  <div class=\"form-block\">\n    <div class=\"title\">{{'face-cooperation-text01'|translate}}</div>\n    <form name=\"form\" class=\"form\" novalidate>\n      <div class=\"row form-group\">\n        <div class=\"col-6\">\n          <label for=\"input3\" class=\"label\">{{'face-cooperation-text13'|translate}}</label>\n          <input\n            id=\"input3\"\n            type=\"text\"\n            name=\"linkman\"\n            class=\"form-control\"\n            ng-model=\"$ctrl.form.linkman\"\n            required\n          />\n          <div ng-show=\"(form.$submitted || form.linkman.$touched) && form.linkman.$error.required\" class=\"help-block\">{{'face-cooperation-text14'|translate}}</div>\n        </div>\n        <div class=\"col-6\">\n          <label for=\"input1\" class=\"label\">{{'face-cooperation-text08'|translate}}</label>\n          <input\n            id=\"input1\"\n            type=\"text\"\n            name=\"name\"\n            class=\"form-control\"\n            ng-model=\"$ctrl.form.name\"\n            required\n          />\n          <div ng-show=\"(form.$submitted || form.name.$touched) && form.name.$error.required\" class=\"help-block\">{{'face-cooperation-text09'|translate}}</div>\n        </div>\n      </div>\n      <div class=\"row form-group\">\n        <div class=\"col-6\">\n          <label for=\"input4\" class=\"label\">{{'face-cooperation-text15'|translate}}</label>\n          <input\n            id=\"input4\"\n            type=\"text\"\n            name=\"phone\"\n            class=\"form-control\"\n            ng-model=\"$ctrl.form.phone\"\n            required\n            phone\n          />\n          <div ng-show=\"(form.$submitted || form.phone.$touched) && form.phone.$error.required\" class=\"help-block\">{{'face-cooperation-text16'|translate}}</div>\n          <div ng-show=\"(form.$submitted || form.phone.$touched) && form.phone.$error.phone\" class=\"help-block\">{{'face-cooperation-text17'|translate}}</div>\n        </div>\n        <div class=\"col-6\">\n          <label for=\"input5\" class=\"label\">{{'face-cooperation-text27'|translate}}</label>\n          <input\n            id=\"input5\"\n            type=\"email\"\n            name=\"email\"\n            class=\"form-control\"\n            ng-model=\"$ctrl.form.email\"\n            required\n          />\n          <div ng-show=\"(form.$submitted || form.email.$touched) && form.email.$error.required\" class=\"help-block\">{{'face-cooperation-text28'|translate}}</div>\n          <div ng-show=\"(form.$submitted || form.email.$touched) && form.email.$error.email\" class=\"help-block\">{{'face-cooperation-text29'|translate}}</div>\n        </div>\n      </div>\n      <div class=\"row form-group\">\n        <div class=\"col-12\">\n          <label for=\"select1\" class=\"label\">{{'face-cooperation-text02'|translate}}</label>\n          <select id=\"select1\" class=\"form-control\" ng-model=\"$ctrl.form.way\">\n            <option value=\"\">{{'face-cooperation-text03'|translate}}</option>\n            <option value=\"{{'face-cooperation-text04'|translate}}\">{{'face-cooperation-text04'|translate}}</option>\n            <option value=\"{{'face-cooperation-text05'|translate}}\">{{'face-cooperation-text05'|translate}}</option>\n            <option value=\"{{'face-cooperation-text06'|translate}}\">{{'face-cooperation-text06'|translate}}</option>\n            <option value=\"{{'face-cooperation-text07'|translate}}\">{{'face-cooperation-text07'|translate}}</option>\n          </select>\n        </div>\n      </div>\n      <div class=\"row form-group\">\n        <div class=\"col-12\">\n          <label for=\"input2\" class=\"label\">{{'face-cooperation-text10'|translate}}</label>\n          <input\n            id=\"input2\"\n            type=\"url\"\n            name=\"website\"\n            placeholder=\"{{'face-cooperation-text11'|translate}}\"\n            class=\"form-control\"\n            ng-model=\"$ctrl.form.website\"\n          />\n          <div ng-show=\"(form.$submitted || form.website.$touched) && form.website.$error.url\" class=\"help-block\">{{'face-cooperation-text12'|translate}}</div>\n        </div>\n      </div>\n      <div class=\"row form-group\">\n        <div class=\"col-12\">\n          <label for=\"select2\" class=\"label\">{{'face-cooperation-text18'|translate}}</label>\n          <select\n            id=\"select2\"\n            class=\"form-control\"\n            name=\"coop\"\n            ng-model=\"$ctrl.form.coop\"\n          >\n            <option value=\"\">{{'face-cooperation-text19'|translate}}</option>\n            <option value=\"{{'face-cooperation-text20'|translate}}\">{{'face-cooperation-text20'|translate}}</option>\n            <option value=\"{{'face-cooperation-text21'|translate}}\">{{'face-cooperation-text21'|translate}}</option>\n            <option value=\"{{'face-cooperation-text22'|translate}}\">{{'face-cooperation-text22'|translate}}</option>\n            <option value=\"{{'face-cooperation-text23'|translate}}\">{{'face-cooperation-text23'|translate}}</option>\n          </select>\n        </div>\n      </div>\n    </form>\n  </div>\n  <div class=\"form-action\">\n    <button class=\"btn\" ng-click=\"$ctrl.submit()\">{{'face-cooperation-text24'|translate}}</button>\n  </div>\n</div>\n<div class=\"modal-overlay success\" id=\"success\" modal-control >\n  <div class=\"modal\">\n    <div class=\"content no-footer\">\n      <div>\n        <img src=\"" + __webpack_require__(988) + "\" alt=\"\">\n        <div class=\"body\">{{'face-cooperation-text25'|translate}}</div>\n        <div class=\"input-group input-action\">\n          <button type=\"submit\" class=\"btn btn-primary btn-md\" ng-click=\"$ctrl.quit()\">\n            {{'face-cooperation-text26'|translate}}\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7e30178f89d4d8cd263471964b22dc10.jpg";

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CooperationController = function () {
  CooperationController.$inject = ["$scope", "modal", "message", "PartnerAPI"];

  function CooperationController($scope, modal, message, PartnerAPI) {
    "ngInject";

    (0, _classCallCheck3.default)(this, CooperationController);
    this.form = {};
    this.$scope = $scope;
    this.modal = modal;
    this.PartnerAPI = PartnerAPI;
    this.message = message;
  }

  (0, _createClass3.default)(CooperationController, [{
    key: "submit",
    value: function submit() {
      var _this = this;

      this.$scope.form.$setSubmitted();

      if (this.$scope.form.$valid) {
        var data = {
          contract_route: this.form.coop,
          company: this.form.name,
          company_website: this.form.website,
          contact_name: this.form.linkman,
          contact_phone: this.form.phone,
          cooperation_method: this.form.way,
          company_email: this.form.email
        };
        this.PartnerAPI.one().post('', data).then(function (res) {
          console.log(res);
          if (res.status.code === 200) {
            _this.modal.open("success");
          } else {
            _this.message.error(res.status.message[0]);
          }
        });
      }
    }
  }, {
    key: "quit",
    value: function quit() {
      window.close();
    }
  }]);
  return CooperationController;
}();

exports.default = CooperationController;

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(991);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./cooperation.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./cooperation.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "cooperation {\n  display: block;\n  min-height: 800px;\n  background: linear-gradient(0deg, #00bbad 0%, #021938 100%), linear-gradient(#489f82, #489f82);\n  padding-top: 100px; }\n  cooperation .bg {\n    position: absolute;\n    width: 1920px;\n    top: 200px;\n    left: 50%;\n    margin-left: -960px;\n    height: 326px;\n    background: url(" + __webpack_require__(992) + ") no-repeat center center;\n    background-size: 100%; }\n  cooperation .container {\n    width: 800px; }\n  cooperation .title {\n    padding: 15px;\n    margin-bottom: 30px;\n    font-size: 30px;\n    border-bottom: 1px solid #000; }\n  cooperation .form-block {\n    padding: 10px 40px 40px;\n    background-color: #fff; }\n  cooperation .form-action {\n    padding: 10px 0; }\n    cooperation .form-action .btn {\n      float: right;\n      padding: 4px 50px;\n      border: none;\n      border-radius: 0;\n      background: #fff; }\n  cooperation .form-group {\n    margin-bottom: 10px; }\n  cooperation .label {\n    display: inline-block;\n    margin-bottom: 10px;\n    font-weight: bold; }\n  cooperation .form-control {\n    display: block;\n    height: 33px;\n    width: 100%;\n    padding: 5px 10px;\n    font-size: 14px;\n    line-height: 1.5;\n    color: #495057;\n    background-clip: padding-box;\n    background-color: #fff;\n    border: 1px solid #ced4da;\n    border-radius: .25rem;\n    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;\n    -webkit-appearance: none; }\n    cooperation .form-control.ng-invalid.ng-touched {\n      border-color: #D44950; }\n  cooperation select {\n    background: url(" + __webpack_require__(993) + ") no-repeat right 6px; }\n  cooperation .help-block {\n    padding: 8px 0;\n    color: #D44950; }\n  cooperation .row::after, cooperation .form-action::after {\n    display: block;\n    clear: both;\n    content: \"\"; }\n  cooperation .col-6, cooperation .col-12 {\n    float: left;\n    padding: 0 30px; }\n  cooperation .col-6 {\n    width: 50%; }\n  cooperation .col-12 {\n    width: 100%; }\n  @media only screen and (max-width: 991px) {\n    cooperation .container {\n      width: 100%; }\n    cooperation .form-block {\n      padding: 10px; }\n    cooperation .col-6 {\n      padding: 0;\n      width: 100%; }\n    cooperation .col-12 {\n      padding: 0; }\n    cooperation .form-group {\n      margin: 0; }\n      cooperation .form-group > div {\n        margin-bottom: 15px; }\n    cooperation .form-action {\n      text-align: center; }\n      cooperation .form-action .btn {\n        float: none; } }\n\n.success .modal {\n  padding: 20px 0 10px;\n  text-align: center;\n  background-color: #f1f2f4; }\n  .success .modal img {\n    width: 100px; }\n  .success .modal .body {\n    margin-top: 20px;\n    margin-bottom: 15px;\n    font-size: 20px;\n    line-height: 2;\n    color: #002348; }\n  .success .modal .btn {\n    padding: 6px 30px;\n    background-color: #009d91;\n    border-radius: 20px;\n    border: none; }\n", ""]);

// exports


/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "5e52ce02768804054ceeaf6cff7432a1.png";

/***/ }),
/* 993 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAATCAYAAAB/TkaLAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyhpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQwIDc5LjE2MDQ1MSwgMjAxNy8wNS8wNi0wMTowODoyMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTggKE1hY2ludG9zaCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6OEVBM0E5ODMzNzREMTFFOTg2NzhCMTI2MUU2Nzc4MzUiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6OEVBM0E5ODQzNzREMTFFOTg2NzhCMTI2MUU2Nzc4MzUiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpDQTFFQzYzQTM3MkIxMUU5ODY3OEIxMjYxRTY3NzgzNSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo4RUEzQTk4MjM3NEQxMUU5ODY3OEIxMjYxRTY3NzgzNSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Pg/p1AIAAADiSURBVHjaYvz//z8DDMyaNUsMSC0A4sS0tLSXDGQCRpihQAOVgdQdJDkloMH3yTGUCWqgKdTAzUDMBsTbgPgeUNyQLJfOnDnTC0hvBeIlQJfFIgXFUiAVBcSuQPE9pLoUZOAUZANBAMiPBlJTgXg3yU4FujQeFK64MFA+A588NsyIHPvUAkwMNACjhg4VQ4E5Jx6fAqB8BjkuXQDUOBmHgVOA1HRyDPUG4hygAYvRDATl/WxQ3ier6IOWUqegpVQwEG8AYlBBYwQsA84PnvIUWirdBVLiQLwdiCXINRAEAAIMAEHLjr+q5HDoAAAAAElFTkSuQmCC"

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _application = __webpack_require__(995);

var _application2 = _interopRequireDefault(_application);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PHONE_REGEXP = /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/;
var EMAIL_REGEXP = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;

var applicationModule = _angular2.default.module('application', []).component('application', _application2.default).directive('phone', function () {
  return {
    require: 'ngModel',
    link: function link(scope, elm, attrs, ctrl) {
      ctrl.$validators.phone = function (modelValue, viewValue) {
        if (ctrl.$isEmpty(modelValue)) {
          // consider empty models to be valid
          return true;
        }
        if (PHONE_REGEXP.test(viewValue)) {
          // it is valid
          return true;
        }
        // it is invalid
        return false;
      };
    }
  };
}).directive('email', function () {
  return {
    require: 'ngModel',
    link: function link(scope, elm, attrs, ctrl) {
      ctrl.$validators.email = function (modelValue, viewValue) {
        if (ctrl.$isEmpty(modelValue)) {
          // consider empty models to be valid
          return true;
        }
        if (EMAIL_REGEXP.test(viewValue)) {
          // it is valid
          return true;
        }
        // it is invalid
        return false;
      };
    }
  };
}).name;

var states = [{
  name: 'application',
  url: '/application',
  component: 'application',
  title: 'face-application-text01',
  description: 'face-application-text01'
}];

exports.default = { name: applicationModule, states: states };

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _application = __webpack_require__(996);

var _application2 = _interopRequireDefault(_application);

var _application3 = __webpack_require__(998);

var _application4 = _interopRequireDefault(_application3);

__webpack_require__(999);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var applicationComponent = {
    restrict: 'E',
    bindings: {},
    template: _application2.default,
    controller: _application4.default
};

exports.default = applicationComponent;

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<div class=\"application\">\n  <div class=\"bg\"></div>\n  <div class=\"container\">\n\n    <div class=\"form-application\">\n      <div class=\"form-title\"><span>{{'face-application-text01'|translate}}</span></div>\n      <form name=\"form\" class=\"form\" novalidate>\n        <div class=\"box\">\n          <div class=\"row form-group\">\n            <div class=\"col-6\">\n              <label for=\"input-name\" class=\"label\">{{'face-application-text02'|translate}}<span> *</span></label>\n              <input id=\"input-name\" type=\"text\" name=\"contact_name\" class=\"form-name input\"\n                ng-model=\"$ctrl.form.contact_name\" required />\n              <div ng-show=\"(form.$submitted || form.contact_name.$touched) && form.contact_name.$error.required\"\n                class=\"help-block\">{{'face-application-checkContent'|translate}}</div>\n            </div>\n            <div class=\"col-6\">\n              <label for=\"input-email\" class=\"label\">{{'face-application-text03'|translate}}<span> *</span></label>\n              <input id=\"input-email\" type=\"text\" name=\"contact_email\" class=\"form-control input\" ng-model=\"$ctrl.form.contact_email\"\n                required\n                email />\n              <div ng-show=\"(form.$submitted || form.contact_email.$touched) && form.contact_email.$error.required\" class=\"help-block\">\n                {{'face-application-checkEmail'|translate}}</div>\n                <div ng-show=\"(form.$submitted || form.contact_email.$touched) && form.contact_email.$error.email\" class=\"help-block\">{{'face-cooperation-text29'|translate}}</div>\n            </div>\n            <div class=\"col-6\">\n              <label for=\"input-phone\" class=\"label\">{{'face-application-text04'|translate}}<span> *</span></label>\n              <input id=\"input-phone\" type=\"text\" name=\"contact_phone\" class=\"form-control input\" ng-model=\"$ctrl.form.contact_phone\"\n                required \n                phone />\n              <div ng-show=\"(form.$submitted || form.contact_phone.$touched) && form.contact_phone.$error.required\" class=\"help-block\">{{'face-application-checkPhone'|translate}}</div>\n              <div ng-show=\"(form.$submitted || form.contact_phone.$touched) && form.contact_phone.$error.phone\" class=\"help-block\">{{'face-cooperation-text17'|translate}}</div>\n            </div>\n          </div>\n          <div class=\"row form-group\">\n            <div class=\"col-6\">\n              <label for=\"input-company\" class=\"label\">{{'face-application-text05'|translate}} <span> *</span></label>\n              <input id=\"input-company\" type=\"text\" name=\"company_name\" class=\"form-control input\" ng-model=\"$ctrl.form.company_name\"\n                required />\n              <div ng-show=\"(form.$submitted || form.company_name.$touched) && form.company_name.$error.required\" class=\"help-block\">\n                {{'face-application-company'|translate}}</div>\n            </div>\n            <div class=\"col-6\">\n              <label for=\"input-industry\" class=\"label\">{{'face-application-text06'|translate}}</label>\n              <input id=\"input-industry\" type=\"text\"  class=\"form-control input\" ng-model=\"$ctrl.form.company_trade\" />\n            </div>\n          </div>\n\n        </div>\n\n        <div class=\"row form-group checkbox-group\">\n          <div class=\"checkbox-title\">{{'face-application-servicetype'|translate}}<span> *</span></div>\n          <div class=\"check-box\" ng-class=\"{'lang-en-box':$ctrl.lang==='zh-CN','lang-en-checkbox':$ctrl.lang==='en'}\">\n            <div class=\"checkbox\" >\n              <input type=\"checkbox\" id=\"deal\" name=\"deal\" ng-model=\"$ctrl.checkBox.deal\">\n              <label for=\"deal\" ng-class=\"{label:$ctrl.checkBox.deal}\"></label>\n              <span ng-class=\"{'check-text':$ctrl.checkBox.deal}\">{{'face-application-TextProcessing'|translate}} </span>\n            </div>\n            <div class=\"checkbox\">\n              <input type=\"checkbox\" id=\"intelligent\" name=\"intelligent\" ng-model=\"$ctrl.checkBox.intelligent\">\n              <label for=\"intelligent\" ng-class=\"{label:$ctrl.checkBox.intelligent}\"></label>\n              <span ng-class=\"{'check-text':$ctrl.checkBox.intelligent}\">{{'face-application-TextIntelligence'|translate}}</span>\n            </div>\n            <div class=\"checkbox\">\n              <input type=\"checkbox\" id=\"picture\" name=\"picture\" ng-model=\"$ctrl.checkBox.picture\">\n              <label for=\"picture\" ng-class=\"{label:$ctrl.checkBox.picture}\"></label>\n              <span ng-class=\"{'check-text':$ctrl.checkBox.picture}\">{{'face-application-ImageIntelligence'|translate}}</span>\n            </div>\n            <div class=\"checkbox\">\n              <input type=\"checkbox\" id=\"voice\" name=\"voice\" ng-model=\"$ctrl.checkBox.voice\">\n              <label for=\"voice\" ng-class=\"{label:$ctrl.checkBox.voice}\"></label>\n              <span ng-class=\"{'check-text':$ctrl.checkBox.voice}\">{{'face-application-VoiceIntelligence'|translate}}</span>\n            </div>\n            <div class=\"checkbox\">\n              <input type=\"checkbox\" id=\"distribution\" name=\"distribution\" ng-model=\"$ctrl.checkBox.distribution\">\n              <label for=\"distribution\" ng-class=\"{label:$ctrl.checkBox.distribution}\"></label>\n              <span ng-class=\"{'check-text':$ctrl.checkBox.distribution}\">{{'face-application-IntelligentDistribution'|translate}}</span>\n            </div>\n          </div>\n          <div ng-show=\"$ctrl.isChecked\" class=\"help-block check-err\">\n              {{'face-application-selecServiceType'|translate}}</div>\n        </div>\n\n\n        <div class=\"row form-group textarea-group\">\n          <div class=\"textarea-title\">{{'face-application-otherService'|translate}}</div>\n          <textarea name=\"\" id=\"\" cols=\"30\" rows=\"10\" ng-model=\"$ctrl.form.service_desc\"></textarea>\n        </div>\n\n        <!-- </div> -->\n\n      </form>\n      <div class=\"form-action\">\n        <button class=\"btn\" ng-click=\"$ctrl.submit()\">{{'face-cooperation-text24'|translate}}</button>\n      </div>\n\n\n\n    </div>\n\n\n\n  </div>\n\n\n</div>\n<div class=\"modal-overlay success\" id=\"application-success\" modal-control>\n  <div class=\"modal\">\n    <div class=\"content no-footer\">\n      <div>\n        <img src=\"" + __webpack_require__(997) + "\" alt=\"\">\n        <div class=\"body\">{{'face-cooperation-text25'|translate}}</div>\n        <div class=\"input-group input-action\">\n          <button type=\"submit\" class=\"btn btn-primary btn-md\" ng-click=\"$ctrl.quit()\">\n            {{'face-cooperation-text26'|translate}}\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>";

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7e30178f89d4d8cd263471964b22dc10.jpg";

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(174);

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var checkedText = {
  deal: "文本处理",
  intelligent: "文本智能",
  picture: "图像智能",
  voice: "语音智能",
  distribution: "智能分发"
};

var applicationContraller = function () {
  applicationContraller.$inject = ["$scope", "modal", "message", "applicationAPI", "$window"];

  function applicationContraller($scope, modal, message, applicationAPI, $window) {

    "ngInject";
    // this.modal = modal

    (0, _classCallCheck3.default)(this, applicationContraller);
    this.$scope = $scope;
    this.$window = $window;
    this.modal = modal;
    this.applicationAPI = applicationAPI;
    this.message = message;

    this.checkBoxList = [];
    this.lang = this.$window.localStorage.yuanben_lang;
    this.checkBox = {
      deal: false,
      intelligent: false,
      picture: false,
      voice: false,
      distribution: false
    };
    this.isChecked = false;
    this.form = {
      // contact_name: "",
      // company_name: "",
      // contact_email: "",
      // contact_phone: "",
      // service_type: "",
      // company_trade: "",
      // service_desc: ""
    };
    var self = this;
    this.$scope.$watch("$ctrl.checkBox", function (val) {
      if (self.getChecked()) {
        self.isChecked = false;
      }
    }, true);
    // console.log(this.$window.localStorage.yuanben_lang)
  }

  (0, _createClass3.default)(applicationContraller, [{
    key: "getChecked",
    value: function getChecked() {
      var _this = this;

      var arrs = (0, _keys2.default)(this.checkBox);
      var str = "";
      arrs.forEach(function (e) {
        if (_this.checkBox[e]) {
          str += checkedText[e] + ",";
        }
      });
      return str.slice(0, str.length - 1);
    }
  }, {
    key: "submit",
    value: function submit() {
      var _this2 = this;

      this.$scope.form.$setSubmitted();
      // console.log(this.$scope.form)
      if (!this.$scope.form.$valid) {
        return;
      }

      if (!this.getChecked()) {
        this.isChecked = true;
        return;
      } else {
        this.isChecked = false;
      }

      var data = {
        contact_name: this.form.contact_name,
        company_name: this.form.company_name,
        contact_email: this.form.contact_email,
        contact_phone: this.form.contact_phone,
        service_type: this.getChecked(),
        company_trade: this.form.company_trade,
        service_desc: this.form.service_desc
        // console.log(data)
      };this.applicationAPI.one().post("", data).then(function (res) {
        if (res.status.code === 200) {
          _this2.modal.open("application-success");
        }
      });
    }
  }, {
    key: "quit",
    value: function quit() {
      window.opener = null; //禁止某些浏览器的一些弹窗
      window.open('', '_self');
      window.close();
    }
  }]);
  return applicationContraller;
}();

exports.default = applicationContraller;

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1000);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./application.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./application.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".application {\n  padding-top: 100px;\n  padding-bottom: 100px;\n  min-height: 800px;\n  z-index: 1;\n  background: linear-gradient(0deg, #00bbad 0%, #021938 100%), linear-gradient(#489f82, #489f82); }\n  .application .bg {\n    position: absolute;\n    width: 1920px;\n    top: 200px;\n    left: 50%;\n    margin-left: -960px;\n    height: 326px;\n    background: url(" + __webpack_require__(1001) + ") no-repeat center center;\n    background-size: 100%; }\n  .application .form-application {\n    margin: 0 auto;\n    width: 809px;\n    min-height: 780px;\n    background: #fff;\n    padding: 38px;\n    color: #4A4A4A;\n    font-size: 14px; }\n    .application .form-application .form-title {\n      margin: 0 auto;\n      width: 620px;\n      height: 40px;\n      line-height: 40px;\n      font-size: 20px;\n      font-weight: 540;\n      border-bottom: 1px solid #E5E5E5; }\n      .application .form-application .form-title span {\n        display: inline-block;\n        height: 40px;\n        border-bottom: 3px solid #10A370; }\n    .application .form-application .form-action .btn {\n      width: 98px;\n      height: 40px;\n      margin-top: 36px;\n      background: #10a370;\n      border-radius: 4px;\n      border: none;\n      color: #fff; }\n    .application .form-application .form {\n      margin: 0 auto;\n      width: 620px;\n      font-size: 14px;\n      font-family: PingFangSC-Medium;\n      font-weight: 500; }\n      .application .form-application .form .box {\n        display: flex;\n        justify-content: space-between; }\n      .application .form-application .form .form-group .col-6 .label {\n        height: 30px;\n        line-height: 30px;\n        display: block;\n        margin-top: 15px; }\n        .application .form-application .form .form-group .col-6 .label > span {\n          color: red;\n          vertical-align: middle; }\n      .application .form-application .form .form-group .col-6 .input {\n        text-indent: 15px;\n        width: 270px;\n        height: 40px;\n        margin-bottom: 10px;\n        color: #9B9B9B;\n        border-radius: 4px;\n        border: 1px solid #E5E5E5; }\n      .application .form-application .form .form-group .help-block {\n        color: red;\n        font-size: 12px; }\n      .application .form-application .form .checkbox-group {\n        margin: 30px 0 0 0; }\n        .application .form-application .form .checkbox-group .checkbox-title {\n          margin-bottom: 15px;\n          height: 16px;\n          font-size: 14px;\n          font-family: PingFangSC-Medium;\n          font-weight: 500;\n          color: #4a4a4a;\n          line-height: 16px; }\n          .application .form-application .form .checkbox-group .checkbox-title > span {\n            color: red;\n            vertical-align: middle; }\n        .application .form-application .form .checkbox-group .lang-en-box {\n          display: flex !important;\n          justify-content: space-between !important; }\n        .application .form-application .form .checkbox-group .lang-en-checkbox .checkbox {\n          min-width: 170px; }\n        .application .form-application .form .checkbox-group .checkbox {\n          display: inline-block;\n          line-height: 28px; }\n          .application .form-application .form .checkbox-group .checkbox input {\n            display: none; }\n          .application .form-application .form .checkbox-group .checkbox label {\n            width: 14px;\n            height: 14px;\n            vertical-align: middle;\n            display: inline-block;\n            border: 1px solid #DCDFE6;\n            border-radius: 2px;\n            cursor: pointer;\n            margin-right: 10px; }\n          .application .form-application .form .checkbox-group .checkbox .label {\n            background: url(" + __webpack_require__(1002) + ") no-repeat center center;\n            background-size: 14px;\n            border: 1px solid #10A370; }\n          .application .form-application .form .checkbox-group .checkbox span {\n            vertical-align: middle;\n            display: inline-block;\n            height: 14px;\n            font-size: 14px;\n            font-family: PingFangSC-Regular;\n            font-weight: 400;\n            color: #9B9B9B;\n            line-height: 14px; }\n          .application .form-application .form .checkbox-group .checkbox .check-text {\n            color: #10A370; }\n        .application .form-application .form .checkbox-group .check-err {\n          margin-top: 5px; }\n      .application .form-application .form .textarea-group {\n        margin-top: 50px; }\n        .application .form-application .form .textarea-group .textarea-title {\n          height: 16px;\n          font-size: 14px;\n          font-family: PingFangSC-Medium;\n          font-weight: 500;\n          color: #4a4a4a;\n          line-height: 16px;\n          margin-bottom: 10px; }\n        .application .form-application .form .textarea-group textarea {\n          width: 100%;\n          height: 156px;\n          line-height: 25px;\n          color: #9B9B9B;\n          border-radius: 4px;\n          padding: 15px 15px;\n          border: 1px solid #E5E5E5; }\n\n@media only screen and (max-width: 991px) {\n  .application .form-application {\n    padding: 30px;\n    width: 400px; }\n    .application .form-application .form-title {\n      width: 310px;\n      margin: 0px;\n      margin-bottom: 20px; }\n    .application .form-application .form .form-group .col-6 .input {\n      text-indent: 10px;\n      width: 310px; }\n    .application .form-application .form .form-group .col-6 #input-email {\n      outline: none !important;\n      -webkit-appearance: none;\n      appearance: none; }\n    .application .form-application .form .checkbox-group {\n      display: block; }\n      .application .form-application .form .checkbox-group .check-box {\n        display: block !important;\n        width: 360px;\n        line-height: 40px; }\n        .application .form-application .form .checkbox-group .check-box .checkbox {\n          display: inline-block;\n          width: 110px; }\n          .application .form-application .form .checkbox-group .check-box .checkbox label {\n            width: 14px !important;\n            height: 14px !important;\n            margin-right: 5px; }\n    .application .form-application .form .textarea-group textarea {\n      width: 310px !important;\n      height: 106px !important;\n      padding-top: 10px;\n      font-family: PingFangSC-Regular; }\n    .application .form-application .box {\n      display: block !important; } }\n", ""]);

// exports


/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "5e52ce02768804054ceeaf6cff7432a1.png";

/***/ }),
/* 1002 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAABfklEQVRIS+3WsU7CUBQG4P8vqIkxETAOGFcmB0cXB1deQCPhITAKs4MTCeEhRBh1UzdMGF18B6MxBhhksrTHFC1pSlt6yaWTHXvb+91z7mnvIQDkWrVdwXcd4JGI5J17ui6S74B0idXaoFx/pYPZMF8gktOFBM5DDgys7DPbqrRFcLpU7G9yEh1mW2dvutMYtngnvcxcVySJ6FzjH9Se7WWk1AR5RUhVBBv+FesGzRR50i83b7Pt80PY1r0f1QlOMTeqIFQXOIM56PZNtTCW8ZP3O48B8plEQUQ2QyooAjO7ItjxvhcJEuil1zJF2xrt2Zb1GIAqYQ4cCrrY5/HlyHlwq3Nx4EOVsUjQSLE4KDUfvOnwoOtuNXrHf/dsNo2xUkpiBCNVHJYaPT8KkXy/1LhTxSIjnAyGoP7iiRNZ7J/3PFQFmxvhdFUhkapiscGg9C6CKYFeNC3Gx7xqDD31VU/8yZ6CX4u2JTF+bXqPxOSbqMTbxMQbYWeHkmz1fwAoWyoSJGlrLAAAAABJRU5ErkJggg=="

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _page = __webpack_require__(1004);

var _page2 = _interopRequireDefault(_page);

var _search = __webpack_require__(1008);

var _search2 = _interopRequireDefault(_search);

var _verify = __webpack_require__(1015);

var _verify2 = _interopRequireDefault(_verify);

var _original = __webpack_require__(1039);

var _original2 = _interopRequireDefault(_original);

var _author = __webpack_require__(1079);

var _author2 = _interopRequireDefault(_author);

var _announcement = __webpack_require__(1087);

var _announcement2 = _interopRequireDefault(_announcement);

var _terms = __webpack_require__(1093);

var _terms2 = _interopRequireDefault(_terms);

var _career = __webpack_require__(1098);

var _career2 = _interopRequireDefault(_career);

var _evidence = __webpack_require__(1147);

var _evidence2 = _interopRequireDefault(_evidence);

var _help = __webpack_require__(1161);

var _help2 = _interopRequireDefault(_help);

var _userInfo = __webpack_require__(1185);

var _userInfo2 = _interopRequireDefault(_userInfo);

var _payment = __webpack_require__(1186);

var _payment2 = _interopRequireDefault(_payment);

var _similarity = __webpack_require__(1190);

var _similarity2 = _interopRequireDefault(_similarity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var childModules = [_search2.default, _verify2.default, _original2.default, _author2.default, _announcement2.default, _terms2.default, _career2.default, _evidence2.default, _help2.default, _payment2.default, _similarity2.default];

var states = [{
    name: 'page',
    abstract: true,
    component: 'page',
    'resolve': {
        appUser: ['userLogin', function appUser(userLogin) {
            "ngInject";

            return userLogin.getUserOrPromise();
        }]
    }
}];

var childModuleNames = [];

childModules.forEach(function (m) {
    childModuleNames.push(m.name);

    m.states.forEach(function (s) {

        s.name = 'page.' + s.name;

        states.push(s);
    });
});

var pageModule = _angular2.default.module('page', childModuleNames).component('page', _page2.default).service('userInfo', _userInfo2.default).name;
exports.default = { name: pageModule, states: states };

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _page = __webpack_require__(1005);

var _page2 = _interopRequireDefault(_page);

__webpack_require__(1006);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

console.log("page");
var pageComponent = {
    restrict: 'E',
    bindings: {
        appUser: '='
    },
    template: _page2.default
};

exports.default = pageComponent;

/***/ }),
/* 1005 */
/***/ (function(module, exports) {

module.exports = "<navbar app-user=\"$ctrl.appUser\"></navbar>\n<div id=\"alert-message\" class=\"alert with-navbar\"></div>\n<div class=\"container page-view\" ui-view></div>\n<ybsmallfooter class=\"page-footer\"></ybsmallfooter>\n";

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1007);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./page.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./page.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".page-footer {\n  margin-top: 70px; }\n\n.page-view.container {\n  margin-top: 32px; }\n  .page-view.container .left-cont {\n    border-right: 1px solid #dadedd;\n    padding: 0 40px 60px;\n    min-height: 1100px; }\n    .page-view.container .left-cont .position {\n      font-size: 18px;\n      color: #222222;\n      line-height: 54px; }\n\n/* Small Devices, Mobile */\n@media only screen and (max-width: 767px) {\n  .page-view.container {\n    margin-top: 0; }\n    .page-view.container .left-cont {\n      border-right: none;\n      padding: 0 12px 40px;\n      min-height: 0; }\n      .page-view.container .left-cont .position {\n        display: none;\n        padding: 10px 0;\n        margin: 0; } }\n", ""]);

// exports


/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _search = __webpack_require__(1009);

var _search2 = _interopRequireDefault(_search);

var _fancyboxPlus = __webpack_require__(112);

var _fancyboxPlus2 = _interopRequireDefault(_fancyboxPlus);

var _imageFallback = __webpack_require__(1014);

var _imageFallback2 = _interopRequireDefault(_imageFallback);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var states = [{
    name: 'search',
    url: '/search?q&original_type',
    component: 'search'
}];

var moduleNames = [_fancyboxPlus2.default];

var searchModule = _angular2.default.module('search', moduleNames).component('search', _search2.default).directive('imageFallback', _imageFallback2.default).name;

exports.default = { name: searchModule, states: states };

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _search = __webpack_require__(1010);

var _search2 = _interopRequireDefault(_search);

var _search3 = __webpack_require__(1011);

var _search4 = _interopRequireDefault(_search3);

__webpack_require__(1012);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var searchComponent = {
    restrict: 'E',
    bindings: {
        appUser: '='
    },
    template: _search2.default,
    controller: _search4.default
};

exports.default = searchComponent;

/***/ }),
/* 1010 */
/***/ (function(module, exports) {

module.exports = "<div class=\"search block\">\n    <div class=\"search-bar\">\n        <form>\n            <div class=\"input\">\n                <input type=\"text\" placeholder=\"{{'page-search-text001' | translate}}\" ng-model=\"searchText\" />\n            </div>\n            <div class=\"buttons\">\n                <button type=\"submit\" ng-click=\"$ctrl.searchArticle()\" class=\"btn btn-primary btn-lg search-content\">\n                    <span>{{'page-search-text002' | translate}}</span>\n                </button>\n                <button type=\"button\" ng-click=\"$ctrl.searchImage()\" class=\"btn btn-default btn-lg search-dna\">\n                    <span>{{'page-search-text003' | translate}}</span>\n                </button>\n            </div>\n        </form>\n    </div>\n    <div class=\"search-params\">\n        <yb-select items=\"$ctrl.cata.items\" selected=\"$ctrl.cata.selected\" change=\"$ctrl.search()\"></yb-select>\n        <yb-select items=\"$ctrl.type.items\" selected=\"$ctrl.type.selected\" change=\"$ctrl.search()\"></yb-select>\n        <div class=\"pull-right right-cont\" ng-show=\"$ctrl.type.selected.value=='cm'\">\n            <div class=\"rank\" ng-click=\"$ctrl.swtichRank()\">\n                <i class=\"ybicon rank-icon\" ng-class=\"{'yb-down':$ctrl.rank.value=='high_price','yb-up':$ctrl.rank.value=='low_price'}\"></i>\n                {{$ctrl.rank.text}}\n            </div>\n            <radio-list items=\"$ctrl.range.items\" selected=\"$ctrl.range.selected\" change=\"$ctrl.search()\"></radio-list>\n        </div>\n    </div>\n    <div class=\"search-result\">\n        <div class=\"empty-box\">\n            <div class=\"empty-list\" ng-if=\"!searchClicked && !$ctrl.loading\">{{'page-search-text004' | translate}}</div>\n            <div class=\"empty-list\" ng-if=\"$ctrl.loading\">{{'page-search-text005' | translate}}...</div>\n            <div class=\"empty-list\" ng-if=\"searchClicked && $ctrl.items.length == 0 && !$ctrl.loading\">{{'page-search-text006' | translate}}</div>\n        </div>\n        <div class=\"result-title\" ng-if=\"$ctrl.searchTotal\">{{'page-search-text007' | translate}}{{$ctrl.searchTotal}}{{'page-search-text008' | translate}}</div>\n        <div class=\"\">\n            <div ng-if=\"$ctrl.original_type=='article'\" class=\"search-article\">\n                <div class=\"clearfix\">\n                    <div class=\"col-9 left-panel\">\n                        <div class=\"article-list\">\n                            <div class=\"item\" ng-repeat=\"article in $ctrl.items track by article.id\">\n                                <a ui-sref=\"app.page.original.article({id: article.yuanben_id})\" target=\"_blank\" class=\"article-link\">\n                                    <div class=\"title\" ng-bind-html=\"$ctrl.$sce.trustAsHtml(article.title)\"></div>\n                                    <div class=\"cont\">\n                                        <img ng-if=\"article.main_article_image\" ng-src=\"{{article.main_article_image}}?x-oss-process=image/resize,m_fill,w_108,h_80,limit_0\"  class=\"photo\" alt=\"\">\n                                        <div class=\"summary\" ng-bind-html=\"$ctrl.$sce.trustAsHtml(article.outline + '...')\"></div>\n                                    </div>\n                                </a>\n                                <div class=\"details clearfix\">\n                                    <a ui-sref=\"app.page.author({id: article.uuid})\" target=\"_blank\" class=\"detail author-link\">\n                                        <img ng-src=\"{{article.user.avatar}}?x-oss-process=image/resize,m_fill,w_32,h_32,limit_0\"  class=\"value authorFace\" alt=\"\">\n                                        <span class=\"value authorName\" ng-bind-html=\"$ctrl.$sce.trustAsHtml(article.author_name)\"></span>\n                                    </a>\n                                    <div class=\"detail\">\n                                        <span class=\"value date\">{{ article.created_at * 1000 | date : 'yyyy-MM-dd HH:mm' }}</span>\n                                    </div>\n                                    <div class=\"detail\">\n                                        <span class=\"value dna\">DNA {{ article.short_id }}</span>\n                                    </div>\n                                    <div class=\"detail license-type\" ng-if=\"article.license.type != 'none'\">\n                                        <span class=\"value\"><license-icons license=\"article.license\" class=\"mini inline\"></license-icons></span>\n                                    </div>\n                                    <div class=\"detail collect\" ng-if=\"article && !$ctrl.isAuthor(article)\" ng-class=\"{active:article.collectStatue}\" title=\"{{article.collectStatue?('page-search-text009' | translate):('page-search-text010' | translate)}}\" ng-click=\"!article.collection_loading && $ctrl.collection(article,1);$event.preventDefault()\">\n                                        <span class=\"ybicon yb-star-checked\"></span>\n                                    </div>\n                                </div>\n                            </div>\n\n\n                        </div>\n                    </div>\n                    <div class=\"col-3 right-panel\">\n                        <div class=\"hot-search\">\n                            <div class=\"title\">{{'page-search-text011' | translate}}</div>\n                            <ul class=\"list\">\n                                <li class=\"item\" ng-class=\"{hot:$index<=2}\" ng-repeat=\"tag in $ctrl.hotSearchOptions track by $index\">\n                                    <span class=\"num\">{{$index+1}}</span>\n                                    <a ng-click=\"$ctrl.hotsearch(tag)\" class=\"link\">{{tag}}</a>\n                                </li>\n\n                            </ul>\n                        </div>\n                    </div>\n                </div>\n\n            </div>\n            <div ng-if=\"$ctrl.original_type=='image'\" class=\"search-image\">\n                <div class=\"image-list\">\n                    <div class=\"image-container\">\n                        <div class=\"image-item\" ng-repeat=\"image in $ctrl.items track by image.id\">\n                            <div class=\"thumbnail\"  ng-if=\"!unavailableImages[image.yuanben_id]\">\n                                <a class=\"dis-block\" ui-sref=\"app.page.original.image({'id': image.yuanben_id})\" target=\"_blank\">\n                                    <img class=\"dis-block\" ng-src=\"{{ image.web_url }}?x-oss-process=image/resize,m_fill,w_432,h_324,limit_0\" image-fallback/>\n                                </a>\n                                <div class=\"icon-box\">\n                                    <div class=\"icon\"  ng-if=\"image && !$ctrl.isAuthor(image)\" ng-class=\"{active:image.collectStatue}\" title=\"{{image.collectStatue?('page-search-text009' | translate):('page-search-text010' | translate)}}\" ng-click=\"!image.collection_loading && $ctrl.collection(image,image.isCC0?3:2);$event.preventDefault()\">\n                                        <i class=\"ybicon yb-star-checked\"></i>\n                                    </div>\n                                    <a class=\"icon yb-view-btn\" rel=\"original-images\" ng-href=\"{{ image.image_url }}\" title=\"{{ image.title }}\">\n                                        <i class=\"ybicon yb-view\"></i>\n                                    </a>\n                                </div>\n                            </div>\n                            <div class=\"thumbnail-placeholder\" ng-if=\"unavailableImages[image.yuanben_id]\">\n                                <div class=\"image-placeholder\">\n                                    {{'page-search-text012' | translate}}\n                                </div>\n                            </div>\n                            <a ui-sref=\"app.page.original.image({'id': image.yuanben_id})\" target=\"_blank\" class=\"info\">\n                                <div class=\"title\" ng-bind-html=\"$ctrl.$sce.trustAsHtml(image.title)\"></div>\n                                <div class=\"yuanben-id line\">DNA {{ image.short_id }}</div>\n                                <div class=\"license line\">\n                                    <license-icons class=\"small inline\" license=\"image.license\"></license-icons>\n                                </div>\n                            </a>\n\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n\n        </div>\n        <div ng-class=\"{'col-9':$ctrl.$state.is('app.page.search.article')}\">\n            <pager total=\"$ctrl.pageCount\" current=\"$ctrl.page\" load=\"$ctrl.loadPage(page)\"\n                   ng-if=\"$ctrl.pageCount > 1\"></pager>\n        </div>\n    </div>\n</div>\n\n";

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__(174);

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchController = function () {
    SearchController.$inject = ['$scope', '$sce', '$stateParams', 'QueryAPI', '$state', '$q', '$timeout', 'CollectionAPI', 'userInfo', 'message', 'fancyboxService', '$filter'];

    function SearchController($scope, $sce, $stateParams, QueryAPI, $state, $q, $timeout, CollectionAPI, userInfo, message, fancyboxService, $filter) {
        "ngInject";

        (0, _classCallCheck3.default)(this, SearchController);
        $scope.searchText = '';
        $scope.searchClicked = false;
        $scope.unavailableImages = {};

        this.items = [];
        this.pageSize = 40;
        this.pageCount = 0;
        this.page = 1;
        this.$scope = $scope;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.QueryAPI = QueryAPI;
        this.$timeout = $timeout;
        this.loading = false;
        this.CollectionAPI = CollectionAPI;
        this.userInfo = userInfo;
        this.userInfo.setUser(this.appUser);
        this.message = message;
        this.searchTotal = 0;
        this.$q = $q;
        this.tranlsteFilter = $filter('translate');
        var self = this;

        this.original_type = 'article';
        this.$sce = $sce;
        this.hotSearchOptions = ['金融科技', '人工智能', '区块链', '设计', 'VR', '供应链', '互联网创业', '商业', '电影'];

        this.fancyboxOptions = fancyboxService.getOptions(function (title, currentArray, currentIndex, currentOpts) {
            return '<div class="image-description">' + '<div class="image-title">' + title + '</div>' + '<div class="description-content">' + self.items[currentIndex].description + '</div>' + '</div>';
        });

        this.cata = {
            items: [{ text: self.tranlsteFilter('page-search-text014'), value: 'new' }, { text: self.tranlsteFilter('page-search-text013'), value: 'hot' }]
        };
        this.cata.selected = this.cata.items[0];
        this.type = {
            items: [{ text: self.tranlsteFilter('page-search-text015'), value: '' }, { text: self.tranlsteFilter('page-search-text016'), value: 'cc' }, { text: self.tranlsteFilter('page-search-text017'), value: 'cm' }]
        };
        this.type.selected = this.type.items[0];
        this.range = {
            items: [{ text: self.tranlsteFilter('page-search-text018'), value: '' }, { text: self.tranlsteFilter('page-search-text019'), value: { gte: 0, lte: 500 } }, { text: self.tranlsteFilter('page-search-text020'), value: { gte: 600, lte: 1000 } }, { text: self.tranlsteFilter('page-search-text021'), value: { gte: 1100, lte: 5000 } }, { text: self.tranlsteFilter('page-search-text022'), value: { gt: 5000 } }]
        };
        this.range.selected = this.range.items[0];

        this.rank = {
            text: self.tranlsteFilter('page-search-text023'),
            value: 'high_price'
        };

        this.$onInit = function () {
            if ($stateParams.q) {
                $scope.searchText = $stateParams.q;
            }
            if ($stateParams.original_type) {
                self.original_type = $stateParams.original_type;
            }
            self.search();
        };
    }

    (0, _createClass3.default)(SearchController, [{
        key: 'isAuthor',
        value: function isAuthor(originals) {
            if (this.original_type == 'article') {
                var user_id = originals.user_id;
                if (user_id == this.appUser.id) {
                    return true;
                }
                return false;
            } else {
                var reg = /(<span class="highlight">)|(<\/span>)/g;
                var str = originals.author_name.replace(reg, '');
                if (str === this.appUser.pseudonym) {
                    return true;
                }
                return false;
            }
        }
    }, {
        key: 'swtichRank',
        value: function swtichRank() {
            if (this.rank.value == 'high_price') {
                this.rank.value = 'low_price';
                this.rank.text = this.tranlsteFilter('page-search-text024');
            } else {
                this.rank.value = 'high_price';
                this.rank.text = this.tranlsteFilter('page-search-text023');
            }
            this.search();
        }
    }, {
        key: 'search',
        value: function search() {
            var _this = this;

            if (this.$scope.searchText == '') {
                return;
            }

            if (this.loading) {
                return;
            }

            var query = {};
            query['q'] = this.$scope.searchText;
            query['page'] = this.page;
            query['page_size'] = this.pageSize;
            console.log(this.cata.selected.value);
            if (this.cata.selected.value !== 'all') {
                query['sort'] = this.cata.selected.value;
            }
            if (this.type.selected.value) {
                query['license_type'] = this.type.selected.value;
                if (this.type.selected.value == 'cm') {
                    query['sort'] = this.rank.value + ',' + this.cata.selected.value;
                    if (this.range.selected.value) {
                        (0, _keys2.default)(this.range.selected.value).forEach(function (key) {

                            query['range[' + key + ']'] = _this.range.selected.value[key];
                        });
                    }
                }
            }
            query['type'] = this.original_type;
            //更新url 回退时候可查看上次查找的内容
            // this.$state.go('app.page.search', {q: this.$scope.searchText,original_type:this.original_type}, {notify: false,reload:false})
            // let url=window.location.href+'?q='+this.$scope.searchText+'&original_type='+this.original_type;
            // window.history.replaceState({},'',url);
            this.loading = true;

            var self = this;

            this.QueryAPI.one().get(query).then(function success(data) {
                self.searchTotal = data.total;
                self.pageCount = Math.ceil(data.total / self.pageSize);
                self.$scope.searchClicked = true;
                self.items.length = 0;
                data.items.forEach(function (image) {
                    if (!image.license) {
                        image.user = {};
                        image.title = self.tranlsteFilter('page-search-text025');
                        image.license = { type: "cc0", content: { adaptation: "y", commercial: "y" } };
                        image.isCC0 = true;
                    }
                    self.items.push(image);
                });
                self.loading = false;
                $('body').scrollTop(0);

                if (query['type'] == 'image') {
                    self.$timeout(function () {
                        $(".yb-view-btn").fancyboxPlus(self.fancyboxOptions);
                    });
                }
                if (!self.userInfo.isGuest() && data.items.length) {
                    //不是访客且以获取到数据
                    self.collection_check(query['type'] == 'article' ? 1 : 2, self.items);
                }
            }, function error() {
                self.$scope.searchClicked = true;
                self.loading = false;
            });
        }
    }, {
        key: 'searchArticle',
        value: function searchArticle() {
            this.original_type = 'article';
            this.switchType();
        }
    }, {
        key: 'searchImage',
        value: function searchImage() {
            this.original_type = 'image';
            this.switchType();
        }
    }, {
        key: 'switchType',
        value: function switchType() {
            //每次搜索初始化
            this.items = [];
            this.pageCount = 0;
            this.page = 1;
            this.cata.selected = this.cata.items[0];
            this.type.selected = this.type.items[0];
            this.range.selected = this.range.items[0];
            this.rank.value = 'high_price';
            this.rank.text = this.tranlsteFilter('page-search-text023');

            this.search();
        }
    }, {
        key: 'loadPage',
        value: function loadPage(page) {
            this.page = page;
            this.search();
        }
    }, {
        key: 'collection',
        value: function collection(originals, type) {
            if (this.userInfo.isGuest()) {
                this.$state.go('app.face.index.user.form.login');
                return;
            }
            var self = this;
            originals.collection_loading = true;
            var api = this.CollectionAPI;
            if (originals.collectStatue) {
                api.one().remove({ resource_type_id: type, resource_id: originals.id }).then(function () {
                    originals.collection_loading = false;
                    self.message.success(self.tranlsteFilter('page-search-text026'));
                    originals.collectStatue = false;
                }, function (response) {
                    originals.collection_loading = false;
                    self.message.error(response.data);
                });
            } else {
                api.post({ resource_type_id: type, resource_id: originals.id }).then(function (res) {
                    originals.collection_loading = false;
                    if (res.status.code == 200) {
                        self.message.success(self.tranlsteFilter('page-search-text027'));
                        originals.collectStatue = true;
                    } else {
                        self.message.error(self.tranlsteFilter('page-search-text028'));
                        originals.collectStatue = false;
                    }
                }, function (response) {
                    originals.collection_loading = false;
                    self.message.error(response.data);
                });
            }
        }
    }, {
        key: 'collection_check',
        value: function collection_check(type, originals) {
            var self = this;
            if (type == 1) {
                //文章
                var ids = originals.map(function (item) {
                    return item.id;
                });
                self.CollectionAPI.one('check').customPOST({ resource_type_id: type, resource_ids: ids }).then(function (res) {
                    //获取已收藏的数据
                    var collectArr = res.data.filter(function (item) {
                        return item.is_active === 1;
                    });
                    self.compare(collectArr, originals);
                }, function (err) {});
            } else {
                var cc0_ids = [],
                    license_ids = [];
                originals.forEach(function (item) {
                    if (!item.isCC0) {
                        license_ids.push(item.id);
                    } else {
                        cc0_ids.push(item.id);
                    }
                });

                var license_defer = self.$q.defer();
                if (license_ids.length) {
                    self.CollectionAPI.one('check').customPOST({ resource_type_id: 2, resource_ids: license_ids }).then(function (res) {
                        //获取已收藏的数据
                        var licenseArr = res.data.filter(function (item) {
                            return item.is_active == 1;
                        });
                        license_defer.resolve(licenseArr);
                    });
                } else {
                    license_defer.resolve([]);
                };
                var cc0_defer = self.$q.defer();
                if (cc0_ids.length) {
                    self.CollectionAPI.one('check').customPOST({ resource_type_id: 3, resource_ids: cc0_ids }).then(function (res) {
                        //获取已收藏的数据
                        var cc0Arr = res.data.filter(function (item) {
                            return item.is_active == 1;
                        });
                        cc0_defer.resolve(cc0Arr);
                    });
                } else {
                    cc0_defer.resolve([]);
                }
                self.$q.all([license_defer.promise, cc0_defer.promise]).then(function (res) {
                    res = res[0].concat(res[1]);
                    self.compare(res, originals);
                });
            }
        }
    }, {
        key: 'hotsearch',
        value: function hotsearch(text) {
            this.$scope.searchText = text;
            // this.$state.go('app.page.search', {q: this.$scope.searchText,original_type:this.original_type});
            this.switchType();
        }
    }, {
        key: 'compare',
        value: function compare(collectArr, originals) {
            collectArr && collectArr.forEach(function (collectItem) {
                originals.forEach(function (originalItem) {
                    if (originalItem.id === collectItem.resource_id) {
                        originalItem.collectStatue = true;
                        return true;
                    }
                });
            });
        }
    }]);
    return SearchController;
}();

exports.default = SearchController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1013);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./search.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./search.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".search {\n  padding: 60px 40px;\n  background: #fff; }\n  .search .search-bar {\n    position: relative;\n    margin: 0 auto;\n    height: 48px;\n    padding-top: 0.5px; }\n    .search .search-bar .input {\n      position: relative;\n      margin-right: 340px;\n      height: 48px; }\n      .search .search-bar .input input {\n        display: block;\n        width: 100%;\n        height: 100%;\n        padding: 12px;\n        margin: 0;\n        font-size: 16px;\n        color: #222222;\n        border: 1px solid #dadedd;\n        background: #fbfbfb; }\n        .search .search-bar .input input:focus {\n          border-color: #00816a; }\n    .search .search-bar .buttons {\n      position: absolute;\n      height: 100%;\n      top: 0;\n      right: 0;\n      border: 0;\n      padding: 0; }\n      .search .search-bar .buttons button {\n        position: absolute;\n        top: 0;\n        width: 140px;\n        height: 100%;\n        border-radius: 2px;\n        padding: 0; }\n        .search .search-bar .buttons button span, .search .search-bar .buttons button i {\n          line-height: 46px; }\n        .search .search-bar .buttons button span {\n          position: relative; }\n        .search .search-bar .buttons button.search-content {\n          right: 160px; }\n        .search .search-bar .buttons button.search-dna {\n          right: 0;\n          color: #fff;\n          border-color: #32d182;\n          background-color: #32d182; }\n          .search .search-bar .buttons button.search-dna:hover {\n            border-color: #3aa771;\n            background-color: #3aa771; }\n  .search .search-params {\n    border-top: 1px solid #e8eaea;\n    border-bottom: 1px solid #e8eaea;\n    margin-top: 56px;\n    position: relative;\n    z-index: 2; }\n    .search .search-params .right-cont {\n      height: 50px;\n      line-height: 50px; }\n      .search .search-params .right-cont radio-list {\n        height: 50px;\n        float: right; }\n    .search .search-params .rank {\n      float: right;\n      display: inline-block;\n      padding: 0 15px;\n      font-size: 14px;\n      color: #666666;\n      border-left: 1px solid #e8eaea;\n      cursor: pointer; }\n      .search .search-params .rank .rank-icon {\n        position: relative;\n        top: 1px; }\n  .search .search-result {\n    margin: 30px auto;\n    min-height: 600px;\n    position: relative;\n    z-index: 1; }\n    .search .search-result .result-title {\n      font-size: 12px;\n      color: #999999; }\n    .search .search-result .empty-list {\n      font-size: 16px;\n      color: #cccccc;\n      margin-top: 32px;\n      text-align: center; }\n\n@media only screen and (max-width: 767px) {\n  .search {\n    padding: 30px 12px; }\n    .search .search-bar {\n      height: auto; }\n      .search .search-bar .input {\n        margin-right: 0;\n        height: 45px; }\n        .search .search-bar .input input {\n          padding: 0 10px;\n          line-height: 45px; }\n      .search .search-bar .buttons {\n        position: static;\n        height: 35px;\n        text-align: center;\n        margin-top: 20px; }\n        .search .search-bar .buttons button {\n          position: static;\n          width: 130px;\n          line-height: 35px;\n          margin: 0 10px; }\n          .search .search-bar .buttons button span {\n            line-height: 20px; }\n    .search .search-article .article-list {\n      min-height: 0; }\n      .search .search-article .article-list > .item .title {\n        margin-right: 0; }\n      .search .search-article .article-list > .item:hover > .title {\n        color: #222222; }\n  .search .search-article .col-9, .search .search-article .col-3 {\n    padding: 0 !important; }\n  .search .search-params {\n    margin-top: 20px; }\n    .search .search-params yb-select {\n      position: relative;\n      z-index: 2; }\n    .search .search-params .right-cont {\n      float: none;\n      height: auto !important; }\n      .search .search-params .right-cont .rank {\n        position: absolute;\n        right: 0;\n        top: 0;\n        padding: 0 5px;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        width: 40%; }\n      .search .search-params .right-cont radio-list {\n        display: block;\n        float: none;\n        line-height: 30px;\n        height: auto !important;\n        padding: 10px 0;\n        border-top: 1px solid #e8eaea; }\n  yb-select .yb-select-control .select-label {\n    padding: 0 20px 0 10px; }\n    yb-select .yb-select-control .select-label:after {\n      right: 5px; } }\n\n.search-article .article-list {\n  position: relative;\n  min-height: 500px;\n  padding: 0 0 26px 0; }\n  .search-article .article-list .placeholder {\n    position: absolute;\n    width: 100px;\n    height: 100px;\n    top: 50%;\n    left: 50%;\n    margin-top: -50px;\n    margin-left: -50px; }\n  .search-article .article-list > .item {\n    position: relative;\n    display: block;\n    border-bottom: 1px solid #e8eaea; }\n    .search-article .article-list > .item .highlight {\n      color: #ff3333; }\n    .search-article .article-list > .item:last-child {\n      border-bottom: 0; }\n    .search-article .article-list > .item .article-link {\n      text-decoration: none; }\n      .search-article .article-list > .item .article-link .title {\n        position: relative;\n        overflow: hidden;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n        margin-right: 110px;\n        font-weight: bold;\n        font-size: 18px;\n        color: #222222;\n        padding: 20px 0 10px; }\n      .search-article .article-list > .item .article-link:hover > .title {\n        color: #00816a; }\n      .search-article .article-list > .item .article-link .cont {\n        overflow: auto; }\n        .search-article .article-list > .item .article-link .cont .photo {\n          width: 108px;\n          height: 80px;\n          float: right;\n          margin-left: 20px; }\n        .search-article .article-list > .item .article-link .cont .summary {\n          font-size: 14px;\n          color: #666666;\n          line-height: 1.8;\n          word-break: break-all; }\n    .search-article .article-list > .item .details {\n      position: relative;\n      padding: 15px 0 4px 0;\n      font-size: 0;\n      line-height: 16px; }\n      .search-article .article-list > .item .details .detail {\n        font-size: 12px;\n        margin-right: 20px;\n        display: inline-block;\n        color: #999999;\n        float: left; }\n        .search-article .article-list > .item .details .detail.license-type {\n          position: relative;\n          top: 2px; }\n        .search-article .article-list > .item .details .detail.collect {\n          position: absolute;\n          right: 0;\n          top: 16px;\n          font-size: 14px;\n          color: #e8eaea;\n          cursor: pointer; }\n          .search-article .article-list > .item .details .detail.collect:hover, .search-article .article-list > .item .details .detail.collect.active {\n            color: #00816a; }\n        .search-article .article-list > .item .details .detail .icons {\n          vertical-align: top;\n          height: auto; }\n        .search-article .article-list > .item .details .detail .value {\n          display: inline-block; }\n        .search-article .article-list > .item .details .detail .authorName {\n          margin-left: 4px; }\n          .search-article .article-list > .item .details .detail .authorName:hover {\n            color: #00816a; }\n        .search-article .article-list > .item .details .detail .authorFace {\n          width: 16px;\n          height: 16px;\n          border-radius: 100%;\n          float: left; }\n\n.search-article .hot-search {\n  padding-left: 40px;\n  font-size: 14px; }\n  .search-article .hot-search .title {\n    color: #222222;\n    font-weight: bold;\n    border-bottom: 1px solid #e8eaea;\n    padding: 10px 0;\n    margin: 10px 0 0; }\n  .search-article .hot-search .list {\n    list-style: none;\n    padding: 0;\n    margin: 0; }\n    .search-article .hot-search .list .item {\n      margin: 15px 0;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      color: #999999; }\n      .search-article .hot-search .list .item .num {\n        padding: 0 5px;\n        text-align: center;\n        background: #cfcfcf;\n        color: #fff;\n        font-size: 12px; }\n      .search-article .hot-search .list .item .link {\n        margin-left: 5px;\n        color: #999999;\n        text-decoration: none;\n        cursor: pointer; }\n      .search-article .hot-search .list .item:hover {\n        color: #4477b0; }\n        .search-article .hot-search .list .item:hover .link {\n          color: #4477b0;\n          text-decoration: underline; }\n      .search-article .hot-search .list .item.hot .num {\n        background: #8fc31f;\n        color: #fff; }\n\n@media only screen and (max-width: 767px) {\n  .search-article .hot-search {\n    padding-left: 0; }\n  .search-article .article-list > .item .title {\n    margin-right: 0; }\n  .search-article .article-list > .item:hover > .title {\n    color: #222222; }\n  .search-article .article-list > .item .details .detail {\n    margin-right: 10px;\n    margin-bottom: 6px; }\n    .search-article .article-list > .item .details .detail.collect {\n      font-size: 18px;\n      top: 14px; }\n      .search-article .article-list > .item .details .detail.collect:active {\n        color: #00816a; } }\n\n.search-image {\n  display: block;\n  position: relative;\n  overflow: auto; }\n  .search-image .image-list {\n    position: relative;\n    min-height: 500px;\n    padding: 20px 0; }\n    .search-image .image-list .placeholder {\n      position: absolute;\n      width: 100px;\n      height: 100px;\n      top: 50%;\n      left: 50%;\n      margin-top: -50px;\n      margin-left: -50px; }\n    .search-image .image-list .image-container {\n      overflow: auto; }\n    .search-image .image-list .image-item {\n      position: relative;\n      width: 216px;\n      height: 230px;\n      overflow: hidden;\n      border: 1px solid #e8eaea;\n      float: left;\n      margin: 0 16px 16px 0; }\n      .search-image .image-list .image-item:nth-child(4n) {\n        margin-right: 0; }\n      .search-image .image-list .image-item .thumbnail, .search-image .image-list .image-item .thumbnail-placeholder {\n        position: relative;\n        display: block;\n        width: 100%;\n        overflow: hidden;\n        height: 162px;\n        text-decoration: none; }\n        .search-image .image-list .image-item .thumbnail .dis-block, .search-image .image-list .image-item .thumbnail-placeholder .dis-block {\n          display: block;\n          height: 100%; }\n        .search-image .image-list .image-item .thumbnail .icon-box, .search-image .image-list .image-item .thumbnail-placeholder .icon-box {\n          position: absolute;\n          top: 10px;\n          right: 10px;\n          font-size: 0;\n          display: none; }\n          .search-image .image-list .image-item .thumbnail .icon-box .icon, .search-image .image-list .image-item .thumbnail-placeholder .icon-box .icon {\n            width: 32px;\n            height: 32px;\n            display: inline-block;\n            margin-left: 10px;\n            text-align: center;\n            color: #FFFFFF;\n            font-size: 16px;\n            line-height: 32px;\n            background: rgba(0, 0, 0, 0.5);\n            border-radius: 4px;\n            cursor: pointer;\n            text-decoration: none;\n            float: right; }\n            .search-image .image-list .image-item .thumbnail .icon-box .icon.active, .search-image .image-list .image-item .thumbnail-placeholder .icon-box .icon.active {\n              color: #00816a; }\n        .search-image .image-list .image-item .thumbnail:hover .icon-box, .search-image .image-list .image-item .thumbnail-placeholder:hover .icon-box {\n          display: block; }\n      .search-image .image-list .image-item .thumbnail-placeholder .image-placeholder {\n        position: absolute;\n        width: 100%;\n        height: 100%;\n        left: 0;\n        top: 0;\n        line-height: 162px;\n        text-align: center;\n        font-size: 12px;\n        color: #999999;\n        background-color: #f5f5f5; }\n      .search-image .image-list .image-item .info {\n        position: relative;\n        display: block;\n        text-decoration: none;\n        padding: 0 10px; }\n        .search-image .image-list .image-item .info .title {\n          font-size: 14px;\n          color: #666666;\n          height: 18px;\n          line-height: 18px;\n          margin-top: 6px;\n          font-weight: bold;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          white-space: nowrap; }\n          .search-image .image-list .image-item .info .title .highlight {\n            color: #ff3333; }\n        .search-image .image-list .image-item .info .line {\n          font-size: 12px;\n          color: #999999;\n          height: 18px;\n          line-height: 18px;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          white-space: nowrap; }\n          .search-image .image-list .image-item .info .line .line-item {\n            margin-right: 32px; }\n\n@media only screen and (max-width: 767px) {\n  .search-image .image-list .image-item {\n    width: 48%;\n    overflow: hidden;\n    margin: 0 2% 4% 0; }\n    .search-image .image-list .image-item:nth-child(2n) {\n      margin: 0 0 4% 2%; }\n  .search-image .image-list .image-item .thumbnail .dis-block,\n  .search-image .image-list .image-item .thumbnail-placeholder .dis-block {\n    display: block;\n    height: 100%; } }\n", ""]);

// exports


/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

/**
 * Created by ganlu on 20/01/2017.
 */
exports.default = function () {
    return function (scope, element) {
        element.on('error', function () {
            scope.$apply(function () {
                scope.unavailableImages[scope.image.yuanben_id] = 1;
            });
        });
    };
};

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _verify = __webpack_require__(1016);

var _verify2 = _interopRequireDefault(_verify);

var _signatureVerify = __webpack_require__(1020);

var _signatureVerify2 = _interopRequireDefault(_signatureVerify);

var _evidenceValidation = __webpack_require__(1027);

var _evidenceValidation2 = _interopRequireDefault(_evidenceValidation);

var _verifyForm = __webpack_require__(1034);

var _verifyForm2 = _interopRequireDefault(_verifyForm);

var _verifyMain = __webpack_require__(1036);

var _verifyMain2 = _interopRequireDefault(_verifyMain);

var _verifyResult = __webpack_require__(1037);

var _verifyResult2 = _interopRequireDefault(_verifyResult);

var _verifyError = __webpack_require__(1038);

var _verifyError2 = _interopRequireDefault(_verifyError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var verifyModule = _angular2.default.module('verify', [_signatureVerify2.default.name, _evidenceValidation2.default.name]).component('verify', _verify2.default).name;

var states = [{
    name: 'verify',
    abstract: true,
    component: 'verify',
    onExit: ['$transition$', function onExit($transition$) {
        'ngInject';

        if ($transition$.to().name === 'app.face.index.user.form.login') {
            var params = $transition$.params();
            var $state = $transition$.router.stateService;
            if (!params.return) {
                return $state.target($transition$.to(), {
                    return: encodeURI(location.href)
                });
            }
        }
    }]
}, {
    name: 'verify.main',
    abstract: true,
    url: '/verify',
    template: _verifyMain2.default
}, {
    name: 'verify.main.form',
    url: '/dna',
    template: _verifyForm2.default,
    title: 'page-verify-title'
}, {
    name: 'verify.result',
    url: '/verify/result',
    template: _verifyResult2.default
}, {
    name: 'verify.error',
    url: '/verify/error',
    template: _verifyError2.default
}];

_signatureVerify2.default.states.forEach(function (m) {
    m.name = 'verify.main.' + m.name;
    states.push(m);
});
_evidenceValidation2.default.states.forEach(function (m) {
    m.name = 'verify.main.' + m.name;
    states.push(m);
});

exports.default = { name: verifyModule, states: states };

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _verify = __webpack_require__(1017);

var _verify2 = _interopRequireDefault(_verify);

__webpack_require__(1018);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var verifyComponent = {
    restrict: 'E',
    bindings: {
        appUser: '=',
        $transition$: '<'
    },
    template: '<div class="verify" ui-view></div>',
    controller: _verify2.default,
    controllerAs: 'verifyCtrl'
};

exports.default = verifyComponent;

/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
   value: true
});

var _stringify = __webpack_require__(83);

var _stringify2 = _interopRequireDefault(_stringify);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VerifyController = function () {
   VerifyController.$inject = ["$scope", "$state", "AppConfig", "QueryAPI", "badge", "$sce", "fancyboxService", "userInfo", "$filter"];

   function VerifyController($scope, $state, AppConfig, QueryAPI, badge, $sce, fancyboxService, userInfo, $filter) {
      "ngInject";

      var _this = this;

      (0, _classCallCheck3.default)(this, VerifyController);
      console.log("-----------------");
      console.log($state.current.name);

      this.tranlsteFilter = $filter('translate');

      this.$scope = $scope;
      this.AppConfig = AppConfig;
      this.badge = badge;
      this.$sce = $sce;
      this.userInfo = userInfo;
      this.userInfo.setUser(this.appUser);

      $scope.loading = false;
      $scope.fancyboxOptions = fancyboxService.getOptions();
      $scope.formData = JSON.parse(localStorage.getItem('verify_dna')) || {};

      this.message = '';
      this.original = null;

      $scope.captchaUrlBase = AppConfig.server_url + '/captcha';
      $scope.captchaUrl = $scope.captchaUrlBase;
      $scope.reloadCaptcha = function () {
         $scope.captchaUrl = $scope.captchaUrlBase + '?s=' + Math.random();
      };
      $scope.verify = function (verifyForm) {

         verifyForm.$setSubmitted();

         if (!verifyForm.$valid) {
            return;
         }

         if ($scope.loading) {
            return;
         }

         $scope.loading = true;

         var self = _this;
         QueryAPI.one().customPOST($scope.formData, 'verify').then(function (original) {
            $scope.loading = false;
            _this.original = original;
            if (original.reproduction) {
               // Comes from reproduction url
               // Display reproduction
               self.originalContentHtml = self.$sce.trustAsHtml(original.content + self.badge.getReproductionBadgeContent(original, original.reproduction));
            } else {
               self.originalContentHtml = self.$sce.trustAsHtml(original.content + self.badge.getBadgeContent(original));
            }
            localStorage.setItem('verify_dna', '{}');
            $state.go('app.page.verify.result');
            window.scrollTo(0, 0);
         }, function (response) {
            $scope.loading = false;

            if (response.data) {
               if (typeof response.data == 'string') {
                  _this.message = response.data;
                  window.scrollTo(0, 0);
                  $state.go('app.page.verify.error');
               } else {

                  for (var k in response.data) {
                     if (response.data.hasOwnProperty(k)) {
                        verifyForm[k].$setValidity('server', false);
                        verifyForm[k].$error.server = response.data[k][0];
                     }
                  }

                  $scope.reloadCaptcha();
               }
            } else {
               window.scrollTo(0, 0);
               $state.go('app.page.verify.error');
            }
         });
      };

      this.tabs = [{
         name: this.tranlsteFilter('page-verify-text030'),
         click: function click() {
            if ($state.is('app.page.verify.main.tsa.form')) return;
            $state.go('app.page.verify.main.tsa.form');
         },
         active: $state.includes('app.page.verify.main.tsa')
      }, {
         name: this.tranlsteFilter('page-verify-evidence'),
         click: function click() {
            if ($state.is('app.page.verify.main.evidence.form')) return;
            $state.go('app.page.verify.main.evidence.form');
         },
         active: $state.includes('app.page.verify.main.evidence')
      }, {
         name: this.tranlsteFilter('page-verify-title'),
         click: function click() {
            if ($state.is('app.page.verify..main.form')) return;
            $state.go('app.page.verify.main.form');
         },
         active: $state.is('app.page.verify.main.form')
      }];
   }

   (0, _createClass3.default)(VerifyController, [{
      key: "$onDestroy",
      value: function $onDestroy() {
         console.log(this.$scope.formData);
         localStorage.setItem('verify_dna', (0, _stringify2.default)(this.$scope.formData));
      }
   }]);
   return VerifyController;
}();

exports.default = VerifyController;

/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1019);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./verify.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./verify.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".verify {\n  position: relative; }\n  .verify .block-title {\n    position: relative;\n    overflow: visible !important; }\n    .verify .block-title .heading {\n      position: relative;\n      cursor: pointer;\n      display: inline-block;\n      float: left; }\n      .verify .block-title .heading i {\n        color: #ccc;\n        position: relative;\n        top: -1px; }\n      .verify .block-title .heading:hover .tips {\n        display: block; }\n      .verify .block-title .heading .tips {\n        width: 216px;\n        position: absolute;\n        z-index: 10;\n        display: none;\n        left: 140px;\n        top: 4px;\n        color: #222222;\n        font-size: 12px;\n        line-height: 2;\n        padding: 18px;\n        background: #eee;\n        border-radius: 4px;\n        white-space: normal; }\n        .verify .block-title .heading .tips .sep {\n          height: 15px; }\n        .verify .block-title .heading .tips span {\n          color: #666666; }\n        .verify .block-title .heading .tips:after {\n          content: '';\n          border: 10px solid #eee;\n          position: absolute;\n          left: -18px;\n          top: 12px;\n          border-color: transparent;\n          border-right-color: #eee;\n          border-left-width: 0;\n          border-right-width: 20px; }\n    .verify .block-title .btn-box {\n      float: right;\n      margin-left: 12px; }\n      .verify .block-title .btn-box .btn {\n        padding: 0 26px;\n        line-height: 32px;\n        background: #00816a;\n        color: #fff;\n        cursor: pointer;\n        font-size: 14px; }\n        .verify .block-title .btn-box .btn i {\n          font-size: 12px;\n          margin-right: 6px; }\n  .verify .verify-nav {\n    position: relative;\n    margin-top: 16px;\n    height: 40px;\n    background-color: #f5f5f5;\n    padding: 0 16px; }\n    .verify .verify-nav .navtab {\n      border-bottom: 0; }\n      .verify .verify-nav .navtab .tabs {\n        height: 40px; }\n        .verify .verify-nav .navtab .tabs .tab {\n          margin-top: 0;\n          margin-right: 16px; }\n          .verify .verify-nav .navtab .tabs .tab.active, .verify .verify-nav .navtab .tabs .tab:hover {\n            color: #00816a;\n            border-color: #00816a; }\n  .verify .form-page .intro {\n    text-align: center;\n    color: #929c9a;\n    margin: 60px 0;\n    font-size: 14px; }\n  .verify .form-page .verify-form {\n    padding-left: 20%; }\n    .verify .form-page .verify-form .input-group .label {\n      width: 13%;\n      text-align: left; }\n    .verify .form-page .verify-form .input-group .input {\n      margin-left: 15%; }\n    .verify .form-page .verify-form .input-group .input input {\n      width: 55%; }\n    .verify .form-page .verify-form .input-group .input textarea {\n      width: 55%; }\n  .verify .form-page .private-key {\n    height: 360px !important; }\n  .verify .result-page {\n    padding-bottom: 40px; }\n    .verify .result-page .middle-box {\n      width: 66%;\n      margin: 0 auto; }\n    .verify .result-page .alert-bar {\n      position: relative;\n      color: #ffffff; }\n      .verify .result-page .alert-bar.error {\n        font-size: 14px;\n        text-align: center;\n        padding-left: 0;\n        height: 36px;\n        line-height: 36px;\n        background-color: #ff3333; }\n      .verify .result-page .alert-bar.success {\n        padding: 50px 0 30px;\n        font-size: 18px;\n        background-color: #32d182;\n        line-height: 2; }\n        .verify .result-page .alert-bar.success .summary {\n          font-size: 24px; }\n        .verify .result-page .alert-bar.success ul {\n          font-size: 14px;\n          padding: 0;\n          margin-bottom: 0;\n          list-style: none; }\n          .verify .result-page .alert-bar.success ul li {\n            line-height: 2; }\n            .verify .result-page .alert-bar.success ul li .ybicon {\n              margin-right: 10px; }\n    .verify .result-page .error-content {\n      position: relative;\n      margin-top: 16px;\n      padding-top: 50px;\n      height: 164px;\n      text-align: center;\n      font-size: 14px;\n      color: #999999; }\n      .verify .result-page .error-content .button {\n        margin-top: 16px; }\n        .verify .result-page .error-content .button .btn {\n          width: 200px; }\n    .verify .result-page .success-content .sup {\n      padding: 30px 0 15px;\n      font-size: 14px;\n      color: #999999; }\n      .verify .result-page .success-content .sup span {\n        color: #222222;\n        font-weight: bold;\n        margin-right: 10px; }\n    .verify .result-page .success-content .content {\n      border: 1px solid #e8eaea;\n      padding-bottom: 20px; }\n    .verify .result-page .success-content .metadata {\n      position: relative;\n      background-color: #fbfbfb; }\n      .verify .result-page .success-content .metadata .line {\n        position: relative;\n        padding: 15px;\n        border-bottom: 1px solid #e8eaea;\n        font-size: 0; }\n        .verify .result-page .success-content .metadata .line .name {\n          display: inline-block;\n          width: 75px;\n          color: #222222;\n          font-size: 14px; }\n        .verify .result-page .success-content .metadata .line .value {\n          display: inline-block;\n          font-size: 14px;\n          padding-left: 10px;\n          color: #222222; }\n          .verify .result-page .success-content .metadata .line .value .actions {\n            position: absolute;\n            right: 15px;\n            top: 10px; }\n          .verify .result-page .success-content .metadata .line .value .link {\n            color: #4477b0;\n            width: 500px;\n            display: block;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            white-space: nowrap; }\n        .verify .result-page .success-content .metadata .line .license .icons {\n          margin: 0;\n          line-height: 20px;\n          height: 20px;\n          overflow: hidden; }\n          .verify .result-page .success-content .metadata .line .license .icons .price {\n            line-height: 20px; }\n          .verify .result-page .success-content .metadata .line .license .icons a {\n            height: 20px; }\n          .verify .result-page .success-content .metadata .line .license .icons a img {\n            width: 20px;\n            height: 20px;\n            display: block; }\n        .verify .result-page .success-content .metadata .line .license .text {\n          margin: 0;\n          color: #222222; }\n          .verify .result-page .success-content .metadata .line .license .text .license-link {\n            color: #4477b0; }\n          .verify .result-page .success-content .metadata .line .license .text .details {\n            padding: 0;\n            list-style: none;\n            font-size: 12px;\n            color: #999999; }\n        .verify .result-page .success-content .metadata .line .license-icon .text {\n          display: none; }\n        .verify .result-page .success-content .metadata .line .license-intro license-icons {\n          display: none; }\n    .verify .result-page .success-content .sub-position {\n      padding: 20px 10px;\n      font-size: 14px; }\n    .verify .result-page .success-content .block-content {\n      padding: 10px 20px; }\n      .verify .result-page .success-content .block-content .title {\n        font-size: 20px;\n        font-weight: bold;\n        color: #222222;\n        line-height: 1.4; }\n      .verify .result-page .success-content .block-content .article-content {\n        position: relative;\n        color: #222222;\n        margin-top: 16px;\n        font-size: 14px;\n        line-height: 1.8; }\n        .verify .result-page .success-content .block-content .article-content img {\n          max-width: 100%; }\n        .verify .result-page .success-content .block-content .article-content p {\n          margin: 0;\n          width: auto !important;\n          height: auto !important; }\n      .verify .result-page .success-content .block-content .image-content {\n        margin-top: 16px;\n        display: block; }\n        .verify .result-page .success-content .block-content .image-content img {\n          max-width: 100%; }\n\n@media only screen and (max-width: 767px) {\n  .verify .form-page .intro {\n    margin: 10px 0; }\n    .verify .form-page .intro img {\n      max-width: 100%; }\n  .verify .form-page .verify-form {\n    width: 100%;\n    padding-left: 0;\n    margin: 0 auto; }\n  .verify .form-page .private-key {\n    height: 160px !important; }\n  .verify .form-page .with-iphone {\n    margin-top: 20px;\n    text-align: center; }\n    .verify .form-page .with-iphone .btn {\n      width: 100%; }\n  .verify .result-page .middle-box {\n    width: 100%;\n    padding: 0 12px;\n    line-height: 1.6; }\n  .verify .result-page .alert-bar.success {\n    padding: 20px 0;\n    font-size: 16px; }\n    .verify .result-page .alert-bar.success .summary {\n      font-size: 16px;\n      margin-bottom: 10px; }\n    .verify .result-page .alert-bar.success ul li {\n      line-height: 1.4; }\n  .verify .result-page .success-content .metadata .line {\n    padding: 10px 5px; }\n    .verify .result-page .success-content .metadata .line .value {\n      padding-left: 0; }\n      .verify .result-page .success-content .metadata .line .value .actions {\n        right: 5px;\n        top: 8px; }\n      .verify .result-page .success-content .metadata .line .value .license-intro {\n        margin-top: 10px; }\n      .verify .result-page .success-content .metadata .line .value.with-iphone {\n        width: 70%; }\n        .verify .result-page .success-content .metadata .line .value.with-iphone .link {\n          width: 100%; }\n  .verify .result-page .success-content .sub-position {\n    padding: 10px; } }\n", ""]);

// exports


/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _signatureVerify = __webpack_require__(1021);

var _signatureVerify2 = _interopRequireDefault(_signatureVerify);

var _signatureVerify3 = __webpack_require__(330);

var _signatureVerify4 = _interopRequireDefault(_signatureVerify3);

var _signatureError = __webpack_require__(1025);

var _signatureError2 = _interopRequireDefault(_signatureError);

var _signatureSuccess = __webpack_require__(1026);

var _signatureSuccess2 = _interopRequireDefault(_signatureSuccess);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var signatureVerifyModule = _angular2.default.module('signature-verify', []).component('signatureVerify', _signatureVerify2.default).name;

var states = [{
    name: 'tsa',
    url: '/tsa',
    abstract: true,
    component: 'signatureVerify'
}, {
    name: 'tsa.form',
    url: '',
    template: _signatureVerify4.default,
    title: 'home-evidences-text040'
}, {
    name: 'tsa.error',
    url: '/error',
    template: _signatureError2.default,
    title: 'home-evidences-text040'
}, {
    name: 'tsa.success',
    url: '/success',
    template: _signatureSuccess2.default,
    title: 'home-evidences-text040'
}];

exports.default = { name: signatureVerifyModule, states: states };

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _signatureVerify = __webpack_require__(330);

var _signatureVerify2 = _interopRequireDefault(_signatureVerify);

var _signatureVerify3 = __webpack_require__(1022);

var _signatureVerify4 = _interopRequireDefault(_signatureVerify3);

__webpack_require__(1023);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var signatureVerifyComponent = {
    restrict: 'E',
    bindings: {},
    template: '<div class="tsa" ui-view></div>',
    controller: _signatureVerify4.default
};

exports.default = signatureVerifyComponent;

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _jsSha = __webpack_require__(331);

var _jsSha2 = _interopRequireDefault(_jsSha);

var _jsSha3 = __webpack_require__(333);

var _jsSha4 = _interopRequireDefault(_jsSha3);

var _angularUiRouter = __webpack_require__(73);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SignatureVerifyController = function () {
    SignatureVerifyController.$inject = ['$previousState', '$state', '$filter', '$scope', 'AppConfig', 'EvidenceAPI', 'message', 'FileUploader'];

    function SignatureVerifyController($previousState, $state, $filter, $scope, AppConfig, EvidenceAPI, message, FileUploader) {
        "ngInject";

        var _this = this;

        (0, _classCallCheck3.default)(this, SignatureVerifyController);
        this.tranlsteFilter = $filter('translate');
        this.$previousState = $previousState;
        this.$state = $state;
        var self = this;
        console.log(this.$state);
        this.tipsObj = {};
        this.fingerType = {
            0: "SHA256",
            1: "SM3"
        };

        FileUploader.FileSelect.prototype.isEmptyAfterSelection = function () {
            return true; // true|false
        };

        this.packageUploader = new FileUploader({
            url: AppConfig.server_url + '/evidences/package/verify',
            withCredentials: true,
            alias: 'package_file',
            filters: [{
                name: 'type',
                fn: function fn(item) {
                    console.log(item.type);
                    if (/\.zip/.test(item.name) || /zip/.test(item.type)) {
                        return true;
                    }
                    message.error(self.tranlsteFilter('home-evidences-text055'));
                    return false;
                }
            }],
            onSuccessItem: function onSuccessItem(item, res) {
                if (res.status.code === 200) {
                    _this.tipsObj = res.data;
                    $state.go('app.page.verify.main.tsa.success', { id: 223 });
                } else {
                    _this.errorMessage = res.status.message;
                    $state.go('app.page.verify.main.tsa.error');
                }
                _this.packageUploader.clearQueue();
            }
        });

        this.EvidenceAPI = EvidenceAPI;
        this.message = message;
    }

    (0, _createClass3.default)(SignatureVerifyController, [{
        key: 'onSubmit',
        value: function onSubmit(form) {
            var _this2 = this;

            if (form.$invalid) return;
            this.EvidenceAPI.one('tsa').post('verify', {
                hash: this.formData.hash
                // tsa_sign: this.formData.sign,
                // tsa_time: this.formData.time
            }).then(function (res) {
                if (res.status.code === 200) {
                    _this2.message.success(_this2.tranlsteFilter('home-evidences-text044'));
                } else {
                    _this2.message.error(_this2.tranlsteFilter('home-evidences-text051'));
                }
            });
        }
    }, {
        key: 'submitFile',
        value: function submitFile() {
            this.packageUploader.uploadAll();
        }
    }, {
        key: 'back',
        value: function back() {
            this.$previousState.go();
        }
    }]);
    return SignatureVerifyController;
}();

exports.default = SignatureVerifyController;

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1024);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./signature-verify.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./signature-verify.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".signature {\n  position: relative;\n  margin-top: 16px; }\n  .signature form {\n    width: 80%;\n    margin: 0 auto; }\n    .signature form .control-label {\n      width: 170px;\n      margin-bottom: 15px; }\n    .signature form .block-error {\n      margin-bottom: 40px;\n      color: #cc0000; }\n      .signature form .block-error p {\n        margin: 0; }\n    .signature form .block-info {\n      margin: 10px auto;\n      padding: 18px;\n      background: #eee;\n      color: #222222;\n      font-size: 14px;\n      line-height: 1.5; }\n      .signature form .block-info .sep {\n        height: 15px; }\n      .signature form .block-info span {\n        color: #666666; }\n    .signature form .form-action {\n      margin-top: 30px;\n      text-align: center; }\n    .signature form .control-group {\n      padding: 0; }\n  .signature .file-upload-btn {\n    position: relative;\n    padding: 4px 18px;\n    border-radius: 0; }\n  .signature .help-block {\n    display: inline-block;\n    margin-left: 10px;\n    color: #999999;\n    font-size: 14px; }\n  .signature .file-input {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    left: 0;\n    top: 0;\n    opacity: 0;\n    cursor: pointer; }\n  .signature .file-list {\n    display: inline-block;\n    margin-left: 30px;\n    color: #666666; }\n  .signature .exhibition {\n    width: 70%;\n    margin: 30px auto 0; }\n    .signature .exhibition .ex-row {\n      margin-bottom: 15px; }\n      .signature .exhibition .ex-row::after {\n        display: block;\n        clear: both;\n        content: \"\"; }\n      .signature .exhibition .ex-row .label {\n        float: left;\n        width: 13%;\n        color: #999999; }\n      .signature .exhibition .ex-row .info {\n        float: left;\n        width: 87%;\n        word-wrap: break-word;\n        word-break: break-all;\n        color: #cccccc;\n        font-size: 14px;\n        line-height: 1.5; }\n  .signature .action {\n    text-align: center; }\n    .signature .action .btn {\n      padding: 4px 40px;\n      line-height: 30px; }\n\n.tsa .error {\n  text-align: center; }\n  .tsa .error .head {\n    margin: 40px 0;\n    color: #645454;\n    line-height: 1.5; }\n    .tsa .error .head p {\n      margin: 0; }\n    .tsa .error .head .tips {\n      margin: 48px auto;\n      width: 743px;\n      min-height: 301px;\n      background: whitesmoke;\n      padding: 33px 29px; }\n      .tsa .error .head .tips li {\n        list-style: none;\n        text-align: left;\n        margin-bottom: 20px;\n        font-size: 16px; }\n        .tsa .error .head .tips li h6 {\n          font-size: 16px;\n          margin: 10px 0;\n          color: #222; }\n        .tsa .error .head .tips li p {\n          font-size: 16px;\n          margin: 0;\n          color: #666;\n          line-height: 20px;\n          word-wrap: break-word;\n          word-break: normal; }\n  .tsa .error .foot .btn {\n    padding: 4px 60px; }\n\n.tsa .success {\n  padding-top: 100px;\n  text-align: center; }\n  .tsa .success .yb-check_round {\n    font-size: 60px;\n    color: #10be4a; }\n  .tsa .success .head p {\n    margin: 30px 0; }\n\n@media only screen and (max-width: 767px) {\n  .signature form .block-info {\n    margin-left: 77px !important; }\n  .signature .success .head .tips {\n    width: 90%; } }\n", ""]);

// exports


/***/ }),
/* 1025 */
/***/ (function(module, exports) {

module.exports = "<div class=\"error\">\n    <div class=\"head\">\n        <p>{{'home-evidences-text063' | translate}}</p>\n        <p>{{'home-evidences-text064' | translate}}{{ $ctrl.errorMessage }}</p>\n    </div>\n    <div class=\"foot\">\n        <button class=\"btn btn-primary\" ng-click=\"$ctrl.$state.go('app.page.verify.main.tsa.form')\">{{'home-evidences-text065' | translate}}</button>\n    </div>\n</div>\n";

/***/ }),
/* 1026 */
/***/ (function(module, exports) {

module.exports = "<div class=\"success\">\n    <div class=\"head\">\n        <i class=\"yb-check_round ybicon\"></i>\n        <p>{{'home-evidences-text0661' | translate}}</p>\n        <ul class=\"tips\">\n         <li>\n               <h6>区块链存证编号（DNA）</h6>\n               <p>{{$ctrl.tipsObj.yuanben_id}}</p>\n         </li>\n         <li>\n               <h6>TSA时间</h6>\n               <p>{{$ctrl.tipsObj.tsa_time}}</p>\n         </li>\n         <li>\n               <h6>区块地址</h6>\n               <p>{{$ctrl.tipsObj.block_hash}}</p>\n         </li>\n         <li>\n               <h6>数字指纹({{$ctrl.fingerType[$ctrl.tipsObj.enc_type]}})</h6>\n               <p>{{$ctrl.tipsObj.content_hash}}</p>\n         </li>\n      </ul>\n    </div>\n    <div class=\"foot\">\n        <button class=\"btn btn-primary\" ng-click=\"$ctrl.$state.go('app.page.verify.main.tsa.form')\">{{'home-evidences-text065' | translate}}</button>\n    </div>\n</div>\n";

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _evidenceValidation = __webpack_require__(1028);

var _evidenceValidation2 = _interopRequireDefault(_evidenceValidation);

var _evidenceValidation3 = __webpack_require__(334);

var _evidenceValidation4 = _interopRequireDefault(_evidenceValidation3);

var _evidenceError = __webpack_require__(1032);

var _evidenceError2 = _interopRequireDefault(_evidenceError);

var _evidenceSuccess = __webpack_require__(1033);

var _evidenceSuccess2 = _interopRequireDefault(_evidenceSuccess);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var evidenceValidationModule = _angular2.default.module('evidence-validation', []).component('evidenceValidation', _evidenceValidation2.default).name;

var states = [{
    name: 'evidence',
    url: '/evidence',
    abstract: true,
    component: 'evidenceValidation'
}, {
    name: 'evidence.form',
    url: '',
    template: _evidenceValidation4.default,
    title: 'home-evidences-text040'
}, {
    name: 'evidence.error',
    url: '/error',
    template: _evidenceError2.default,
    title: 'home-evidences-text040'
}, {
    name: 'evidence.success',
    url: '/success',
    template: _evidenceSuccess2.default,
    title: 'home-evidences-text040'
}];

exports.default = { name: evidenceValidationModule, states: states };

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _evidenceValidation = __webpack_require__(334);

var _evidenceValidation2 = _interopRequireDefault(_evidenceValidation);

var _evidenceValidation3 = __webpack_require__(1029);

var _evidenceValidation4 = _interopRequireDefault(_evidenceValidation3);

__webpack_require__(1030);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var evidenceValidationComponent = {
    restrict: 'E',
    bindings: {},
    template: '<div class="tsa" ui-view></div>',
    controller: _evidenceValidation4.default
};

exports.default = evidenceValidationComponent;

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
   value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _jsSha = __webpack_require__(331);

var _jsSha2 = _interopRequireDefault(_jsSha);

var _jsSha3 = __webpack_require__(333);

var _jsSha4 = _interopRequireDefault(_jsSha3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EvidenceValidationController = function () {
   EvidenceValidationController.$inject = ['$previousState', '$state', '$filter', '$scope', 'AppConfig', 'EvidenceAPI', 'message', 'FileUploader'];

   function EvidenceValidationController($previousState, $state, $filter, $scope, AppConfig, EvidenceAPI, message, FileUploader) {
      "ngInject";

      var _this = this;

      (0, _classCallCheck3.default)(this, EvidenceValidationController);
      this.tranlsteFilter = $filter('translate');
      this.$previousState = $previousState;
      this.$state = $state;
      var self = this;
      this.EvidenceAPI = EvidenceAPI;
      this.message = message;
      this.tipsObj = {};
      this.fingerType = {
         0: "SHA256",
         1: "SM3"
      };

      FileUploader.FileSelect.prototype.isEmptyAfterSelection = function () {
         return true; // true|false
      };
      this.packageUploader = new FileUploader({
         filters: [{
            name: 'type',
            fn: function fn(item) {
               if (/\.zip/.test(item.name) || /zip/.test(item.type)) {
                  return true;
               }
               message.error(self.tranlsteFilter('home-evidences-text055'));
               return false;
            }
         }],
         onAfterAddingFile: function onAfterAddingFile(item) {
            if (_this.packageUploader.queue.length > 1) {
               _this.packageUploader.queue[0].remove();
            }
            var fr = new FileReader();
            fr.onload = function (e) {
               _this.uploader.formData = [{
                  sha256_hash: (0, _jsSha2.default)(e.target.result),
                  sha512_hash: (0, _jsSha4.default)(e.target.result)
               }];
            };
            fr.readAsArrayBuffer(item._file);
         }
      });

      this.uploader = new FileUploader({
         url: AppConfig.server_url + '/originals/package/verify',
         withCredentials: true,
         alias: 'package_file',
         filters: [{
            name: 'type',
            fn: function fn(item) {
               if (/\.zip/.test(item.name) || /zip/.test(item.type)) {
                  return true;
               }
               message.error(self.tranlsteFilter('home-evidences-text043'));
               return false;
            }
         }],
         onAfterAddingFile: function onAfterAddingFile(item) {
            if (_this.uploader.queue.length > 1) {
               _this.uploader.queue[0].remove();
            }
         },
         onSuccessItem: function onSuccessItem(item, res) {

            if (res.status.code === 200) {
               // console.log(res)
               _this.tipsObj = res.data;
               $state.go('app.page.verify.main.evidence.success');
            } else {
               _this.errorMessage = res.status.message;
               $state.go('app.page.verify.main.evidence.error');
            }
            _this.uploader.clearQueue();
            _this.packageUploader.clearQueue();
         }
      });
   }

   // onSubmit(form) {
   //    // console.log(form)
   //    if (form.$invalid) return
   //    this.EvidenceAPI.one('evidence').post('verify', {
   //       hash: this.formData.hash,
   //       tsa_sign: this.formData.sign,
   //       tsa_time: this.formData.time
   //    }).then(res => {
   //       console.log(res)
   //       if (res.status.code === 200) {
   //          this.message.success(this.tranlsteFilter('home-evidences-text044'))
   //       } else {
   //          this.message.error(this.tranlsteFilter('home-evidences-text051'))
   //       }
   //    })
   // }

   // block_hash: "6D04A090ACF7EC70F1580BB30E265B26883ED368"
   // content_hash: "0FA3507CE0B382245B3C0EAA731DCD7654BB2A0B36EAACCD1FA623A1754AC40D"
   // created_at: "2019-11-07 19:30:29"
   // tsa_time: "2019-11-07 19:30:32"
   // yuanben_id: "34XDENB9DNX5LCV93REYZKR7A7XC73X33DSE0CLNIJS54KTSFG"


   (0, _createClass3.default)(EvidenceValidationController, [{
      key: 'submitFile',
      value: function submitFile() {
         this.uploader.uploadAll();
      }
   }, {
      key: 'back',
      value: function back() {
         this.$state.go('app.page.verify.main.evidence.form');
      }
   }]);
   return EvidenceValidationController;
}();

exports.default = EvidenceValidationController;

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1031);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./evidence-validation.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./evidence-validation.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".signature {\n  position: relative;\n  margin-top: 16px; }\n  .signature form {\n    width: 80%;\n    margin: 0 auto; }\n    .signature form .control-label {\n      width: 170px;\n      margin-bottom: 15px; }\n    .signature form .block-error {\n      margin-bottom: 40px;\n      color: #cc0000; }\n      .signature form .block-error p {\n        margin: 0; }\n    .signature form .block-info {\n      margin: 10px auto;\n      padding: 18px;\n      background: #eee;\n      color: #222222;\n      font-size: 14px;\n      line-height: 1.5; }\n      .signature form .block-info .sep {\n        height: 15px; }\n      .signature form .block-info span {\n        color: #666666; }\n    .signature form .form-action {\n      margin-top: 30px;\n      text-align: center; }\n    .signature form .control-group {\n      width: 100%;\n      padding: 0; }\n      .signature form .control-group .privatekey {\n        border-right: 1px solid #dadedd !important; }\n  .signature .file-upload-btn {\n    position: relative;\n    padding: 4px 18px;\n    border-radius: 0; }\n  .signature .help-block {\n    display: inline-block;\n    margin-left: 10px;\n    color: #999999;\n    font-size: 14px; }\n  .signature .file-input {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    left: 0;\n    top: 0;\n    opacity: 0;\n    cursor: pointer; }\n  .signature .file-list {\n    display: inline-block;\n    margin-left: 30px;\n    color: #666666; }\n  .signature .exhibition {\n    width: 70%;\n    margin: 30px auto 0; }\n    .signature .exhibition .ex-row {\n      margin-bottom: 15px; }\n      .signature .exhibition .ex-row::after {\n        display: block;\n        clear: both;\n        content: \"\"; }\n      .signature .exhibition .ex-row .label {\n        float: left;\n        width: 13%;\n        color: #999999; }\n      .signature .exhibition .ex-row .info {\n        float: left;\n        width: 87%;\n        word-wrap: break-word;\n        word-break: break-all;\n        color: #cccccc;\n        font-size: 14px;\n        line-height: 1.5; }\n  .signature .action {\n    text-align: center; }\n    .signature .action .btn {\n      padding: 4px 40px;\n      line-height: 30px; }\n\n.tsa .error {\n  text-align: center; }\n  .tsa .error .head {\n    margin: 40px 0;\n    color: #645454;\n    line-height: 1.5; }\n    .tsa .error .head p {\n      margin: 0; }\n  .tsa .error .foot .btn {\n    padding: 4px 60px; }\n\n.tsa .success {\n  padding-top: 100px;\n  text-align: center; }\n  .tsa .success .yb-check_round {\n    font-size: 60px;\n    color: #10be4a; }\n  .tsa .success .head p {\n    margin: 30px 0; }\n  .tsa .success .head .tips {\n    margin: 48px auto;\n    width: 743px;\n    min-height: 301px;\n    background: whitesmoke;\n    padding: 33px 29px; }\n    .tsa .success .head .tips li {\n      list-style: none;\n      text-align: left;\n      margin-bottom: 20px;\n      font-size: 16px; }\n      .tsa .success .head .tips li h6 {\n        font-size: 16px;\n        margin: 10px 0;\n        color: #222; }\n      .tsa .success .head .tips li p {\n        font-size: 16px;\n        margin: 0;\n        color: #666;\n        line-height: 20px;\n        word-wrap: break-word;\n        word-break: normal; }\n\n@media only screen and (max-width: 767px) {\n  .signature form .block-info {\n    margin-left: 77px !important; }\n  .tsa .success .head .tips {\n    width: 90%; } }\n", ""]);

// exports


/***/ }),
/* 1032 */
/***/ (function(module, exports) {

module.exports = "<div class=\"error\">\n    <div class=\"head\">\n        <p>{{'home-evidences-text063' | translate}}</p>\n        <p>{{'home-evidences-text064' | translate}}{{ $ctrl.errorMessage }}</p>\n    </div>\n    <div class=\"foot\">\n        <button class=\"btn btn-primary\" ng-click=\"$ctrl.back()\">{{'home-evidences-text065' | translate}}</button>\n    </div>\n</div>\n";

/***/ }),
/* 1033 */
/***/ (function(module, exports) {

module.exports = "<div class=\"success\">\n    <div class=\"head\">\n        <i class=\"yb-check_round ybicon\"></i>\n        <p>{{'home-evidences-text0661' | translate}}</p>\n            <ul class=\"tips\">\n               <li>\n                     <h6>区块链存证编号（DNA）</h6>\n                     <p>{{$ctrl.tipsObj.yuanben_id}}</p>\n               </li>\n               <li>\n                     <h6>TSA时间</h6>\n                     <p>{{$ctrl.tipsObj.tsa_time}}</p>\n               </li>\n               <li>\n                     <h6>区块地址</h6>\n                     <p>{{$ctrl.tipsObj.block_hash}}</p>\n               </li>\n               <li>\n                     <h6>数字指纹({{$ctrl.fingerType[$ctrl.tipsObj.enc_type]}})</h6>\n                     <p>{{$ctrl.tipsObj.content_hash}}</p>\n               </li>\n            </ul>\n    </div>\n    <div class=\"foot\">\n        <button class=\"btn btn-primary\" ng-click=\"$ctrl.$state.go('app.page.verify.main.evidence.form')\">{{'home-evidences-text065' | translate}}</button>\n    </div>\n</div>\n";

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<div class=\"intro\">\n    <img src=\"" + __webpack_require__(1035) + "\" alt=\"\">\n</div>\n<div class=\"content\">\n    <form class=\"form horizontal verify-form\" name=\"verify_form\" novalidate>\n        <div class=\"input-group\">\n            <div class=\"label\">\n                {{'page-verify-text002' | translate}}\n            </div>\n            <div class=\"input\">\n                <input name=\"yuanben_id\" class=\"yuanben-id\" type=\"text\" ng-model=\"formData.yuanben_id\" placeholder=\"{{'page-verify-text003' | translate}}\" required\n                       server-check/>\n                <div class=\"error-message\">\n                    <div ng-show=\"verify_form.$submitted || verify_form.yuanben_id.$touched\">\n                        <div ng-show=\"verify_form.yuanben_id.$error.required\">{{'page-verify-text003' | translate}}</div>\n                        <div ng-show=\"verify_form.yuanben_id.$error.server\">{{ verify_form.yuanben_id.$error.server\n                            }}\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"input-group\">\n            <div class=\"label\">\n                {{'page-verify-text004' | translate}}\n            </div>\n            <div class=\"input\">\n                <textarea class=\"private-key\" name=\"private_key\" ng-model=\"formData.private_key\"\n                          placeholder=\"{{'page-verify-text005' | translate}}\" required server-check></textarea>\n                <div class=\"error-message\">\n                    <div ng-show=\"verify_form.$submitted || verify_form.private_key.$touched\">\n                        <div ng-show=\"verify_form.private_key.$error.required\">{{'page-verify-text006' | translate}}</div>\n                        <div ng-show=\"verify_form.private_key.$error.server\">{{\n                            verify_form.private_key.$error.server }}\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"input-group\">\n            <div class=\"label\">\n                {{'page-verify-text007' | translate}}\n            </div>\n            <div class=\"input\">\n                <input name=\"private_key_passphrase\" class=\"private-key-passphrase\" type=\"text\" ng-model=\"formData.private_key_passphrase\"\n                       placeholder=\"{{'page-verify-text008' | translate}}\" required server-check/>\n                <div class=\"error-message\">\n                    <div ng-show=\"verify_form.$submitted || verify_form.private_key_passphrase.$touched\">\n                        <div ng-show=\"verify_form.private_key_passphrase.$error.required\">{{'page-verify-text009' | translate}}</div>\n                        <div ng-show=\"verify_form.private_key_passphrase.$error.server\">{{\n                            verify_form.private_key_passphrase.$error.server }}\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"input-group\">\n            <div class=\"label\">\n                {{'page-verify-text010' | translate}}\n            </div>\n            <div class=\"input captcha\">\n                <input name=\"captcha\" type=\"text\" class=\"captcha\" ng-model=\"formData.captcha\" placeholder=\"{{'page-verify-text011' | translate}}\" required\n                       server-check/>\n                <div class=\"captcha-image\">\n                    <a href=\"javascript:void(0)\" ng-click=\"reloadCaptcha()\" title=\"{{'page-verify-text012' | translate}}\"><img\n                        ng-src=\"{{ captchaUrl }}\"/></a>\n                </div>\n                <div class=\"error-message\">\n                    <div ng-show=\"verify_form.$submitted || verify_form.captcha.$touched\">\n                        <div ng-show=\"verify_form.captcha.$error.required\">{{'page-verify-text013' | translate}}</div>\n                        <div ng-show=\"verify_form.captcha.$error.server\">{{ verify_form.captcha.$error.server }}\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"input-group\">\n            <div class=\"label\"></div>\n            <div class=\"input with-iphone\">\n                <button type=\"submit\" class=\"btn btn-primary btn-md\" ng-click=\"verify(verify_form)\"\n                        ng-disabled=\"loading\">{{loading && ('page-verify-text014' | translate) || ('page-verify-text015' | translate)}}\n                </button>\n            </div>\n        </div>\n    </form>\n</div>\n";

/***/ }),
/* 1035 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1036 */
/***/ (function(module, exports) {

module.exports = " <div class=\"form-page block single-page\">\n    <div class=\"block-title\">\n        <div class=\"heading\">\n            {{'page-verify-text001' | translate}}\n            <i class=\"ybicon yb-info\"></i>\n            <div class=\"tips\">\n                {{'page-verify-text031' | translate}}<br>\n                <span>{{'page-verify-text032' | translate}}</span>\n                <div class=\"sep\"></div>\n                {{'page-verify-text033' | translate}}<br>\n                <span>{{'page-verify-text034' | translate}}</span>\n            </div>\n        </div>\n    </div>\n    <div class=\"verify-nav\">\n        <navtab tabs=\"verifyCtrl.tabs\"></navtab>\n    </div>\n     <div ui-view></div>\n</div>\n";

/***/ }),
/* 1037 */
/***/ (function(module, exports) {

module.exports = "<div class=\"result-page block\">\n    <div class=\"alert-bar success\">\n        <div class=\"middle-box\">\n            <div class=\"summary\">\n                {{'page-verify-text016' | translate}}\n            </div>\n            <div class=\"detail\">\n                <ul>\n                    <li><i class=\"ybicon yb-succeed\"></i>{{'page-verify-text017' | translate}}</li>\n                    <li><i class=\"ybicon yb-succeed\"></i>{{'page-verify-text018' | translate}}</li>\n                </ul>\n            </div>\n        </div>\n    </div>\n    <div class=\"success-content middle-box\">\n        <div class=\"sup\"><span>{{'page-verify-text019' | translate}}</span>{{'page-verify-text020' | translate}}</div>\n        <div class=\"content\">\n            <div class=\"metadata\">\n                <div class=\"line\">\n                    <div class=\"name\">{{'page-verify-text021' | translate}}</div>\n                    <div class=\"value\">\n                        {{ verifyCtrl.original.created_at * 1000 | date : 'yyyy-MM-dd HH:mm' }}\n                        <div class=\"actions\">\n                            <div class=\"action\" ng-if=\"!verifyCtrl.original.image_width\">\n                                <a ng-if=\"!verifyCtrl.userInfo.isGuest()\" ui-sref=\"app.page.evidence.article({id: verifyCtrl.original.id})\"  class=\"btn btn-default btn-sm\">{{'page-verify-text022' | translate}}</a>\n                                <a ng-if=\"verifyCtrl.userInfo.isGuest()\" ui-sref=\"app.page.evidence.article({id: verifyCtrl.original.yuanben_id})\" class=\"btn btn-default btn-sm\">{{'page-verify-text022' | translate}}</a>\n                            </div>\n                            <div class=\"action\" ng-if=\"verifyCtrl.original.image_width\">\n                                <a ng-if=\"!verifyCtrl.userInfo.isGuest()\" ui-sref=\"app.page.evidence.image({id: verifyCtrl.original.id})\"  class=\"btn btn-default btn-sm\">{{'page-verify-text022' | translate}}</a>\n                                <a ng-if=\"verifyCtrl.userInfo.isGuest()\" ui-sref=\"app.page.evidence.image({id: verifyCtrl.original.yuanben_id})\" class=\"btn btn-default btn-sm\">{{'page-verify-text022' | translate}}</a>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"line\">\n                    <div class=\"name\">{{'page-verify-text023' | translate}}</div>\n                    <div class=\"value\">{{ verifyCtrl.original.short_id }}</div>\n                </div>\n                <div class=\"line clearfix\">\n                    <div class=\"name pull-left\">{{'page-verify-text024' | translate}}</div>\n                    <div class=\"value pull-left\">\n                        <div class=\"license license-icon \"><license license=\"verifyCtrl.original.license\" ></license></div>\n                    </div>\n                </div>\n                <div class=\"line clearfix\">\n                    <div class=\"name pull-left\">{{'page-verify-text025' | translate}}</div>\n                    <div class=\"value pull-left\">\n                        <div class=\"license license-intro\"><license license=\"verifyCtrl.original.license\" ></license></div>\n                    </div>\n                </div>\n                <div class=\"line clearfix\">\n                    <div class=\"name pull-left\">{{'page-verify-text026' | translate}}</div>\n                    <div class=\"value pull-left with-iphone\">\n                        <a class=\"link\" href=\"{{ verifyCtrl.original.chain_server_url }}\" target=\"_blank\">\n                            {{verifyCtrl.original.block_hash }}</a>\n                    </div>\n                </div>\n\n            </div>\n            <div class=\"sub-position\">{{'page-verify-text027' | translate}}</div>\n            <div class=\"block-content\">\n                <div class=\"title\">{{ verifyCtrl.original.title }}</div>\n                <div id=\"original-content\" class=\"original-content\" ng-bind-html=\"verifyCtrl.originalContentHtml\" ng-if=\"!verifyCtrl.original.image_width\"></div>\n                <a class=\"image-content\" ng-href=\"{{ verifyCtrl.original.image_url }}\" fancyboxable=\"fancyboxOptions\" ng-if=\"verifyCtrl.original.image_width\">\n                    <!-- <img ng-src=\"{{ verifyCtrl.original.web_url }}?x-oss-process=image/resize,w_595,limit_0\"/> -->\n                </a>\n            </div>\n        </div>\n    </div>\n\n</div>\n";

/***/ }),
/* 1038 */
/***/ (function(module, exports) {

module.exports = "<div class=\"result-page block\">\n    <div class=\"alert-bar error\">\n        <i class=\"ybicon yb-close\"></i> {{'page-verify-text028' | translate}}\n    </div>\n    <div class=\"error-content\">\n        <div class=\"block-content\">\n            <div class=\"text\">{{ verifyCtrl.message }}</div>\n            <div class=\"button\">\n                <button type=\"button\" class=\"btn btn-md btn-default\" onclick=\"javascript:history.back()\">{{'page-verify-text029' | translate}}</button>\n            </div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _original = __webpack_require__(1040);

var _original2 = _interopRequireDefault(_original);

var _originalArticle = __webpack_require__(1047);

var _originalArticle2 = _interopRequireDefault(_originalArticle);

var _originalImage = __webpack_require__(1063);

var _originalImage2 = _interopRequireDefault(_originalImage);

var _getReproduction = __webpack_require__(1071);

var _getReproduction2 = _interopRequireDefault(_getReproduction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var childModules = [_originalArticle2.default, _originalImage2.default, _getReproduction2.default];

var states = [{
    'name': 'original',
    'component': 'original',
    'url': '?notify'
}];

var moduleNames = [];

childModules.forEach(function (m) {
    moduleNames.push(m.name);

    m.states.forEach(function (s) {
        s.name = 'original.' + s.name;
        states.push(s);
    });
});

var originalModule = _angular2.default.module('original', moduleNames).component('original', _original2.default).name;

exports.default = { name: originalModule, states: states };

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _original = __webpack_require__(1041);

var _original2 = _interopRequireDefault(_original);

var _original3 = __webpack_require__(1044);

var _original4 = _interopRequireDefault(_original3);

__webpack_require__(1045);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var originalComponent = {
    restrict: 'E',
    bindings: {
        appUser: '='
    },
    template: _original2.default,
    controller: _original4.default
};

exports.default = originalComponent;

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<div class=\"loading-error block\" ng-if=\"$ctrl.error\">\n    <div class=\"image\">\n        <img src=\"" + __webpack_require__(1042) + "\"/>\n    </div>\n    <div class=\"text\">\n        <div class=\"title\">404</div>\n        <div class=\"description\">{{'page-original-text001' | translate}}</div>\n    </div>\n</div>\n<div class=\"original\" ng-if=\"!$ctrl.error\">\n\n    <a class=\"reproduction-notice\" ui-sref=\"app.home.reprint\"\n       ng-if=\"!$ctrl.showReproductionDetail && $ctrl.reproduction\">\n        <i class=\"fa fa-info-circle\"></i>&nbsp;\n        <span translate='page-original-text002'\n              translate-values=\"{ datetime: ($ctrl.reproduction.authorized_at * 1000 | date : 'yyyy-MM-dd HH:mm') }\"></span>\n    </a>\n\n    <div class=\"reproduction block\" ng-if=\"$ctrl.showReproductionDetail\">\n        <div class=\"block-title\">\n            {{'page-original-text003' | translate}}\n            <div class=\"actions\">\n                <div class=\"action\">\n                    <button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"$ctrl.showReproduction()\">\n                        {{'page-original-text022' | translate}}\n                    </button>\n                </div>\n            </div>\n        </div>\n        <div class=\"block-content\">\n            <div class=\"line-box\">\n                <div class=\"line\">\n                    <div class=\"name\">{{'page-original-text004' | translate}}</div>\n                    <div class=\"value\">{{ $ctrl.reproduction.short_id }}</div>\n                </div>\n                <div class=\"line\">\n                    <div class=\"name\">{{'page-original-text005' | translate}}</div>\n                    <div class=\"value\">\n                        <span>{{ $ctrl.reproduction.author_name }}</span>\n                    </div>\n                </div>\n            </div>\n            <div class=\"line-box\">\n                <div class=\"line\">\n                    <div class=\"name\">{{'page-original-text006' | translate}}</div>\n                    <div class=\"value\">\n                        {{ $ctrl.reproduction.authorized_at * 1000 | date : 'yyyy-MM-dd HH:mm' }}\n                    </div>\n                </div>\n                <div class=\"line\">\n                    <div class=\"name\">{{'page-original-text007' | translate}}</div>\n                    <div class=\"value\">\n                        <a ui-sref=\"app.page.author({id: $ctrl.reproduction.user.uuid})\" target=\"_blank\">{{\n                            $ctrl.reproduction.user.pseudonym }}</a>\n                        <span class=\"image\" ng-if=\"$ctrl.reproduction.user.email_verified\"><img\n                                src=\"" + __webpack_require__(1043) + "\"/></span>\n                    </div>\n                </div>\n            </div>\n            <div class=\"line-box\">\n               <div class=\"line\">\n                     <div class=\"name\">{{'page-original-text014' | translate}}</div>\n                     <div class=\"value\">\n                        <a href=\"{{ $ctrl.reproduction.chain_server_url }}\"\n                           target=\"_blank\">{{ $ctrl.reproduction.block_hash }}</a>\n                     </div>\n               </div>\n               <div class=\"line\" ng-if=\"$ctrl.reproduction.order.type==1&&$ctrl.appUser.type==1\">\n                     <div class=\"name\">{{'page-original-Operator' | translate}}</div>\n                     <div class=\"value\" ng-if=\"$ctrl.reproduction.order.op_user_name\">\n                        {{ $ctrl.reproduction.order.op_user_name}}\n                     </div>\n               </div>\n            </div>\n            <div ng-if=\"$ctrl.reproduction.reproduction && $ctrl.reproduction.license.type=='cm'\">\n                <div class=\"line-box\">\n                    <div class=\"line\">\n                        <div class=\"name\">{{'page-original-text008' | translate}}</div>\n                        <div class=\"value\">{{ $ctrl.getAccountType() }}</div>\n                    </div>\n                    <div class=\"line\" ng-if=\"$ctrl.accountNameNeeded($ctrl.reproduction.reproduction.account_type)\">\n                        <div class=\"name\">{{'page-original-text009' | translate}}</div>\n                        <div class=\"value\">{{ $ctrl.reproduction.reproduction.account_name }}</div>\n                    </div>\n                </div>\n                <div class=\"line-box\">\n                    <div class=\"line\" ng-if=\"$ctrl.accountIdNeeded($ctrl.reproduction.reproduction.account_type)\">\n                        <div class=\"name\">{{'page-original-text010' | translate}}</div>\n                        <div class=\"value\">{{ $ctrl.reproduction.reproduction.account_id }}</div>\n                    </div>\n                    <div class=\"line\" ng-if=\"$ctrl.accountLinkNeeded($ctrl.reproduction.reproduction.account_type)\">\n                        <div class=\"name\">{{'page-original-text011' | translate}}</div>\n                        <div class=\"value\">\n                            <a ng-href=\"{{$ctrl.reproduction.reproduction.account_link}}\" target=\"_blank\">{{\n                                $ctrl.reproduction.reproduction.account_link }}</a>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"line-box\"\n                     ng-if=\"$ctrl.editorNameNeeded($ctrl.reproduction.reproduction.account_type)||$ctrl.webLinkNeeded($ctrl.reproduction.reproduction.account_type)\">\n                    <div class=\"line\" ng-if=\"$ctrl.webLinkNeeded($ctrl.reproduction.reproduction.account_type)\">\n                        <div class=\"name\">{{'page-original-text012' | translate}}</div>\n                        <div class=\"value\">\n                            <a ng-href=\"{{$ctrl.reproduction.reproduction.account_link}}\" target=\"_blank\">{{\n                                $ctrl.reproduction.reproduction.account_link }}</a>\n                        </div>\n                    </div>\n                    <div class=\"line\" ng-if=\"$ctrl.editorNameNeeded($ctrl.reproduction.reproduction.account_type)\">\n                        <div class=\"name\">{{'page-original-text013' | translate}}</div>\n                        <div class=\"value\">\n                            {{ $ctrl.reproduction.reproduction.account_name }}\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n            <div class=\"first-reproduction\" ng-if=\"$ctrl.showNotify\">\n                <div class=\"email-notify\">\n                    {{'page-original-text025' | translate}}\n                </div>\n                <div class=\"receipt\">\n                    <div class=\"receipt-notify\">\n                        {{'page-original-receipt-button' | translate}}\n                    </div>\n                    <div class=\"receipt-button\">\n                        <button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"$ctrl.applyReceipt()\">\n                            {{'page-original-receipt-button' | translate}}\n                        </button>\n                    </div>\n                </div>\n\n            </div>\n\n        </div>\n        <div class=\"tips\" ng-if=\"$ctrl.isShowAuthorizationTips&&!$ctrl.$rootScope.user.id\">\n            {{'page-original-tipText' | translate}}\n        </div>\n    </div>\n    <div class=\"tips\" ng-if=\"$ctrl.isShowAuthorizationTips\">\n        {{'page-original-tipText' | translate}}\n    </div>\n</div>\n<div ui-view ng-if=\"!$ctrl.error\"></div>\n<div class=\"modal-overlay reproduction-info\" id=\"reproduction-info\" modal-control ng-if=\"$ctrl.showReproductionDetail\">\n    <div class=\"modal\">\n        <div class=\"header\">\n            <div class=\"title\">{{'page-original-text015' | translate}}</div>\n            <div class=\"close\">×</div>\n        </div>\n        <div class=\"content no-footer\">\n            <div class=\"line\">\n                <div class=\"name\">{{'page-original-text016' | translate}}</div>\n                <div class=\"value\">{{ $ctrl.reproduction.yuanben_id }}</div>\n            </div>\n            <div class=\"line\">\n                <div class=\"name\">{{'page-original-text017' | translate}}</div>\n                <div class=\"value\">{{ $ctrl.reproduction.hash }}</div>\n            </div>\n            <div class=\"line\">\n                <div class=\"name\">{{'page-original-text018' | translate}}</div>\n                <div class=\"value\">{{ $ctrl.reproduction.signature }}</div>\n            </div>\n            <div class=\"line\">\n                <div class=\"name\">{{'page-original-text019' | translate}}</div>\n                <div class=\"value\" ng-bind-html=\"$ctrl.reproductionPublicKeyHtml\"></div>\n            </div>\n        </div>\n    </div>\n</div>\n<div class=\"modal-overlay\" id=\"share-to-weixin\" modal-control>\n    <div class=\"modal\">\n        <div class=\"header\">\n            <div class=\"title\">{{'page-original-text020' | translate}}</div>\n            <div class=\"close\">×</div>\n        </div>\n        <div class=\"content no-footer\">\n            <div class=\"description\">{{'page-original-text021' | translate}}</div>\n            <div class=\"qr-code\">\n                <img ng-src=\"{{ $ctrl.pageQrcodeSrc }}\"/>\n            </div>\n        </div>\n    </div>\n</div>\n<div class=\"modal-overlay receipt-apply\" id=\"receipt-apply\" modal-control>\n    <div class=\"modal\">\n        <div class=\"header\">\n            <div class=\"title\">申请开票</div>\n            <div class=\"close\">×</div>\n        </div>\n        <div class=\"content no-footer\">\n            <div class=\"text\">申请发票请先前往邮箱做认证</div>\n            <div class=\"text\">开具的电子发票会用邮件的形式发送至您的邮箱</div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 1042 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1043 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAPCAYAAABJGff8AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyhpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKE1hY2ludG9zaCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RTI5MjBDRjk4NkFGMTFFNjhCMjNCNURCMUU4RUNBNkMiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RTI5MjBDRkE4NkFGMTFFNjhCMjNCNURCMUU4RUNBNkMiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpFMjkyMENGNzg2QUYxMUU2OEIyM0I1REIxRThFQ0E2QyIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpFMjkyMENGODg2QUYxMUU2OEIyM0I1REIxRThFQ0E2QyIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PilinmkAAAGbSURBVHjaYuw/LO/JwMAwF4glGYYueA7EyUzDwCMMUPfPZYF5pMDmAdE6JxxRGJQeYqGGKYQCAuZ5kDr0gMAmhiyOz2x0fUR55sef9wxbb+QwOCm3MAhyKpIUU8iOgTmOmJjFppaQXiZChv7//5dh+818hscfjjLsvl1KVsyQm0RJTc4oMfPm6w2Gow+7GDzVJzGwMfOAxY497GV4+P4QkM/N4KLSTnZSg8kT40B0tcTGJopn9t+tY3j66RTD2stRDIE6ixiefDzBcPrJdKAMI4Obag+DEJcqyaGI7DBiYxCfWnyBguIZL42pDOuuRDO8/HKJYeXFQIYvv16BEhqDiUwmg4qIJ1mFA7H5iRrmoeQZbjZRhlC9lQxiPDoM77/fZ/j99yuDnIAtg7V8CVVLO2yFAjU8i1EAcLAIMgTrLGeQ4jNhEOfVBeafiQyMjMxUqwyQi1xYKOPyEEUFAAyws/AyhOmtoVpdg+xoXBkaV7ENMxedxuZZRmDb7P8waQGAYwbUSJMcrA4kAbwA5ZkUEGOIe+QpqNUMEGAAqfK3x7ltiu0AAAAASUVORK5CYII="

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OriginalController = function () {
    OriginalController.$inject = ['modal', '$sce', 'AppConfig', '$state', '$stateParams', 'OrderEmailAPI', 'message', '$scope', '$rootScope'];

    function OriginalController(modal, $sce, AppConfig, $state, $stateParams, OrderEmailAPI, message, $scope, $rootScope) {

        "ngInject";

        (0, _classCallCheck3.default)(this, OriginalController);
        this.modal = modal;
        this.$sce = $sce;
        this.AppConfig = AppConfig;
        this.$state = $state;
        this.$scope = $scope;
        this.$stateParams = $stateParams;
        this.OrderEmailAPI = OrderEmailAPI;
        this.message = message;
        this.$rootScope = $rootScope;

        this.error = false;

        this.showReproductionDetail = false;
        this.reproduction = null;
        this.reproductionPublicKeyHtml = '';

        this.pageQrcodeSrc = '';
        this.isShowAuthorizationTips = false;
        var self = this;
        this.$scope.$on("showTips", function (event, val) {
            self.isShowAuthorizationTips = val;
        });

        this.showNotify = Boolean($stateParams.notify);
    }

    (0, _createClass3.default)(OriginalController, [{
        key: 'setReproduction',
        value: function setReproduction(reproduction) {
            var AppConfig = this.AppConfig;
            if (reproduction && reproduction.hasOwnProperty('block_source')) {
                if (reproduction.block_source === 0) {
                    reproduction.chain_server_url = AppConfig.chain_server_url + '/block/' + reproduction.block_hash;
                } else {
                    reproduction.chain_server_url = AppConfig.newchain_server_url + '/original/' + reproduction.yuanben_id;
                }
            }
            this.reproduction = reproduction;

            if (reproduction && reproduction.public_key) {
                this.reproductionPublicKeyHtml = this.$sce.trustAsHtml(reproduction.public_key.replace(/\n/g, "<br/>"));
            }
        }
    }, {
        key: 'setError',
        value: function setError(error) {
            this.error = error;
        }
    }, {
        key: 'setShowReproductionDetail',
        value: function setShowReproductionDetail(show) {
            this.showReproductionDetail = show;
        }
    }, {
        key: 'showReproduction',
        value: function showReproduction() {
            this.modal.open('reproduction-info');
        }
    }, {
        key: 'shareToWeixin',
        value: function shareToWeixin(url) {
            this.pageQrcodeSrc = url;
            this.modal.open('share-to-weixin');
        }
    }, {
        key: 'getAccountType',
        value: function getAccountType() {
            if (["其他", "网络媒体", "纸质媒体"].indexOf(this.reproduction.reproduction.account_type) !== -1) {
                return this.reproduction.reproduction.type_name;
            }

            return this.reproduction.reproduction.account_type;
        }
    }, {
        key: 'accountNameNeeded',
        value: function accountNameNeeded(accountType) {
            return ["微信公众号", "微博", "今日头条", "UC头条", "其他"].indexOf(accountType) != -1;
        }
    }, {
        key: 'accountIdNeeded',
        value: function accountIdNeeded(accountType) {
            return ["微信公众号", "其他"].indexOf(accountType) != -1;
        }
    }, {
        key: 'accountLinkNeeded',
        value: function accountLinkNeeded(accountType) {
            return ["微博", "今日头条", "UC头条", "其他"].indexOf(accountType) != -1;
        }
    }, {
        key: 'webLinkNeeded',
        value: function webLinkNeeded(accountType) {
            return ["网络媒体"].indexOf(accountType) != -1;
        }
    }, {
        key: 'editorNameNeeded',
        value: function editorNameNeeded(accountType) {
            return ["网络媒体", "纸质媒体"].indexOf(accountType) != -1;
        }
    }, {
        key: 'applyReceipt',
        value: function applyReceipt() {
            var _this = this;

            this.message.info('请稍后...');
            //   console.log(this.$stateParams.reproduction);

            var params = {
                id: this.$stateParams.reproduction
            };

            this.OrderEmailAPI.one("confirmation").customPOST(params, "").then(function (login) {
                var flag = login === "true";
                _this.message.hide();
                if (flag) {
                    _this.$state.go("app.home.profile.receipt");
                } else {
                    if (_this.reproduction.user.email_verified) {
                        _this.$state.go('app.face.index.user.form.login');
                    } else {
                        _this.modal.open("receipt-apply");
                    }
                }
            }, function (resp) {
                _this.message.hide();
                _this.$state.go('app.face.index.user.form.login');
            });
        }
    }]);
    return OriginalController;
}();

exports.default = OriginalController;

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1046);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./original.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./original.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "original .original-article {\n  position: relative;\n  margin: 0 auto; }\n  original .original-article .left-cont .delete {\n    display: inline-block;\n    margin-top: 80px;\n    color: #cccccc;\n    font-size: 12px;\n    cursor: pointer; }\n    original .original-article .left-cont .delete:hover {\n      color: #666666; }\n  original .original-article .right-cont {\n    padding: 0 24px; }\n    original .original-article .right-cont .author {\n      text-align: center;\n      padding: 45px 0;\n      border-bottom: 1px solid #e8eaea; }\n      original .original-article .right-cont .author .author-face {\n        margin: 0 auto;\n        width: 64px;\n        height: 64px;\n        padding: 3px;\n        border-radius: 4px;\n        position: relative;\n        border: 1px solid #e8eaea;\n        font-size: 12px; }\n        original .original-article .right-cont .author .author-face .img {\n          width: 100%;\n          height: 100%;\n          display: block; }\n      original .original-article .right-cont .author .author-info .pseudonym {\n        font-size: 16px;\n        font-weight: bold;\n        margin-top: 10px;\n        line-height: 1.4;\n        min-height: 22px; }\n        original .original-article .right-cont .author .author-info .pseudonym .pseudonym-title {\n          padding-right: 5px;\n          font-size: 16px;\n          color: #222222;\n          text-decoration: none;\n          vertical-align: middle;\n          display: block; }\n        original .original-article .right-cont .author .author-info .pseudonym .authentication {\n          margin-top: 3px;\n          vertical-align: middle; }\n      original .original-article .right-cont .author .author-info .introduction {\n        color: #999999;\n        font-size: 14px;\n        margin-top: 5px;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap; }\n      original .original-article .right-cont .author .author-info .btn {\n        margin-top: 10px;\n        font-size: 12px; }\n    original .original-article .right-cont .license-dna .title {\n      font-size: 14px;\n      border-bottom: 1px solid #e8eaea;\n      margin: 10px 0;\n      padding: 10px 0; }\n    original .original-article .right-cont .actionbar {\n      margin-top: 30px; }\n      original .original-article .right-cont .actionbar .publish-to-media {\n        display: block;\n        margin-bottom: 15px; }\n        original .original-article .right-cont .actionbar .publish-to-media > .btn {\n          width: 100%; }\n      original .original-article .right-cont .actionbar .download-img {\n        width: 45%; }\n        original .original-article .right-cont .actionbar .download-img.two {\n          width: 100%; }\n      original .original-article .right-cont .actionbar .unlogined-reproduction {\n        font-size: 14px;\n        color: red;\n        text-align: center;\n        line-height: 2; }\n      original .original-article .right-cont .actionbar .fee-con {\n        display: none;\n        margin-left: 28px;\n        float: left;\n        color: #00816a; }\n        original .original-article .right-cont .actionbar .fee-con p {\n          margin: 0 0 5px;\n          font-size: 12px; }\n        original .original-article .right-cont .actionbar .fee-con h4 {\n          margin: 0;\n          font-size: 18px; }\n          original .original-article .right-cont .actionbar .fee-con h4.fee {\n            text-align: center; }\n      original .original-article .right-cont .actionbar .get-reproduction {\n        height: 90px; }\n        original .original-article .right-cont .actionbar .get-reproduction get-reproduction > .btn {\n          width: 100%; }\n        original .original-article .right-cont .actionbar .get-reproduction .add-store-btn {\n          width: 100%;\n          margin-top: 10px; }\n          original .original-article .right-cont .actionbar .get-reproduction .add-store-btn:disabled {\n            cursor: not-allowed;\n            background: #f5f5f5; }\n      original .original-article .right-cont .actionbar .gather-wrapper gather-box {\n        float: none !important; }\n      original .original-article .right-cont .actionbar .gather-wrapper .en.btn {\n        display: block;\n        float: none;\n        width: 100%;\n        margin-bottom: 12px; }\n    original .original-article .right-cont .info {\n      margin-top: 30px;\n      font-size: 12px; }\n      original .original-article .right-cont .info .title {\n        font-size: 14px;\n        border-bottom: 1px solid #e8eaea;\n        margin: 10px 0;\n        padding: 10px 0; }\n      original .original-article .right-cont .info .item {\n        padding: 8px 0; }\n        original .original-article .right-cont .info .item .name {\n          width: 70px;\n          float: left; }\n        original .original-article .right-cont .info .item .value {\n          width: 100%;\n          padding-left: 70px; }\n          original .original-article .right-cont .info .item .value .link {\n            color: #4477b0;\n            max-width: 100%;\n            display: inline-block;\n            text-decoration: underline;\n            cursor: pointer;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            white-space: nowrap; }\n      original .original-article .right-cont .info .actions {\n        margin-top: 20px;\n        margin-bottom: 30px; }\n        original .original-article .right-cont .info .actions .btn {\n          width: 100%; }\n\noriginal .loading-error {\n  position: relative;\n  margin: 0 auto;\n  padding: 150px 60px;\n  height: 700px; }\n  original .loading-error .image {\n    position: absolute;\n    width: 83px;\n    left: 183px;\n    top: 170px; }\n    original .loading-error .image img {\n      width: 100%; }\n  original .loading-error .text {\n    position: relative;\n    margin-top: 20px;\n    margin-left: 230px;\n    color: #999999; }\n    original .loading-error .text .title {\n      font-size: 40px; }\n    original .loading-error .text .description {\n      font-size: 14px; }\n\noriginal .license {\n  position: relative;\n  margin-top: 14px; }\n  original .license .block-content {\n    position: relative; }\n\noriginal .reproduction.block {\n  margin-bottom: 16px;\n  min-height: 0; }\n  original .reproduction.block .actions {\n    position: absolute;\n    right: 28px;\n    top: 0; }\n  original .reproduction.block .block-title {\n    padding-left: 40px; }\n  original .reproduction.block .tips {\n    text-align: center;\n    color: red;\n    padding: 50px 0; }\n\noriginal .info .block-content,\noriginal .reproduction .block-content {\n  position: relative;\n  padding: 0; }\n  original .info .block-content .line-box,\n  original .reproduction .block-content .line-box {\n    width: 100%;\n    display: flex;\n    border-bottom: 1px solid #e8eaea; }\n  original .info .block-content .line,\n  original .reproduction .block-content .line {\n    width: 50%;\n    position: relative;\n    font-size: 14px;\n    color: #999999;\n    height: 36px;\n    line-height: 36px;\n    text-align: left;\n    border-right: 1px solid #e8eaea;\n    padding-right: 10px; }\n    original .info .block-content .line .name,\n    original .reproduction .block-content .line .name {\n      position: absolute;\n      height: 36px;\n      padding-right: 10px;\n      left: 0;\n      top: 0;\n      padding-left: 40px;\n      text-align: left;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap; }\n    original .info .block-content .line .value,\n    original .reproduction .block-content .line .value {\n      position: relative;\n      margin-left: 35%;\n      text-align: left;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap; }\n      original .info .block-content .line .value .image,\n      original .reproduction .block-content .line .value .image {\n        position: relative;\n        height: 100%;\n        margin-left: 6px;\n        cursor: pointer; }\n        original .info .block-content .line .value .image img,\n        original .reproduction .block-content .line .value .image img {\n          position: absolute;\n          width: auto;\n          height: auto;\n          top: 0;\n          bottom: 0;\n          left: 0;\n          right: 0;\n          margin: auto; }\n      original .info .block-content .line .value a,\n      original .reproduction .block-content .line .value a {\n        color: #00816a; }\n  original .info .block-content .first-reproduction,\n  original .reproduction .block-content .first-reproduction {\n    padding: 15px; }\n    original .info .block-content .first-reproduction .email-notify,\n    original .reproduction .block-content .first-reproduction .email-notify {\n      font-size: 14px;\n      color: red;\n      text-align: center;\n      line-height: 2; }\n    original .info .block-content .first-reproduction .receipt,\n    original .reproduction .block-content .first-reproduction .receipt {\n      display: flex;\n      justify-content: center;\n      align-items: center; }\n      original .info .block-content .first-reproduction .receipt .receipt-notify,\n      original .reproduction .block-content .first-reproduction .receipt .receipt-notify {\n        display: inline;\n        font-size: 14px;\n        color: red;\n        text-align: center;\n        line-height: 2; }\n      original .info .block-content .first-reproduction .receipt .receipt-button,\n      original .reproduction .block-content .first-reproduction .receipt .receipt-button {\n        margin-left: 7px;\n        display: inline; }\n\noriginal .reproduction-notice {\n  position: relative;\n  display: block;\n  text-decoration: none;\n  margin-bottom: 16px;\n  background-color: #cfcfcf;\n  font-size: 14px;\n  color: #999999;\n  padding: 8px 16px; }\n  original .reproduction-notice:hover {\n    color: #00816a; }\n\noriginal .reproduction-info .content {\n  padding-top: 0 !important;\n  height: 450px;\n  overflow: auto; }\n  original .reproduction-info .content .line {\n    margin-top: 12px;\n    font-size: 14px;\n    color: #999999; }\n    original .reproduction-info .content .line:first-child {\n      margin-top: 12px !important; }\n    original .reproduction-info .content .line .value {\n      margin-top: 3px;\n      background-color: #f5f5f5;\n      padding: 6px;\n      font-size: 12px;\n      color: #999999;\n      overflow-wrap: break-word;\n      word-wrap: break-word;\n      -ms-word-break: break-all;\n      word-break: break-word;\n      -ms-hyphens: auto;\n      -moz-hyphens: auto;\n      -webkit-hyphens: auto;\n      hyphens: auto; }\n\noriginal .receipt-apply .content {\n  padding-top: 16px !important;\n  height: 200px;\n  overflow: auto; }\n  original .receipt-apply .content .text {\n    margin-top: 16px;\n    font-size: 16px;\n    color: #666666;\n    text-align: center; }\n\noriginal .share-bar {\n  position: absolute;\n  width: 30px;\n  bottom: 0;\n  right: -32px; }\n  original .share-bar .item {\n    position: relative;\n    display: block;\n    text-decoration: none;\n    width: 30px;\n    height: 30px;\n    background-color: #ffffff;\n    border-left: 1px solid #f5f5f5;\n    border-right: 1px solid #f5f5f5; }\n    original .share-bar .item:first-child {\n      border-right: 1px solid #f5f5f5; }\n    original .share-bar .item:last-child {\n      border-left: 1px solid #f5f5f5; }\n    original .share-bar .item img {\n      position: absolute;\n      width: 24px;\n      height: 24px;\n      left: 2px;\n      top: 3px; }\n  original .share-bar .separator {\n    position: relative;\n    width: 30px;\n    height: 1px;\n    border-left: 4px solid #ffffff;\n    border-right: 4px solid #ffffff;\n    background-color: #f5f5f5; }\n\noriginal .block-title {\n  position: relative; }\n\noriginal #share-to-weixin .description {\n  margin-top: 16px;\n  font-size: 14px;\n  color: #999999;\n  text-align: center; }\n\noriginal #share-to-weixin .qr-code {\n  margin-top: 16px;\n  text-align: center; }\n\n@media only screen and (max-width: 767px) {\n  original .reproduction-notice {\n    margin: 10px 0; }\n  original .reproduction.block {\n    margin: 10px 0; }\n    original .reproduction.block .block-title {\n      padding-left: 12px; }\n  .share-bar {\n    position: relative !important;\n    width: auto !important;\n    height: 30px !important;\n    bottom: auto !important;\n    right: auto !important;\n    margin: 20px 12px; }\n    .share-bar .item {\n      border-top: 1px solid #f5f5f5;\n      border-bottom: 1px solid #f5f5f5;\n      border-left: 0 !important;\n      border-right: 0 !important;\n      float: left;\n      background-color: #f6f8f8 !important; }\n      .share-bar .item:first-child {\n        border-left: 1px solid #f5f5f5 !important;\n        border-right: 0 !important; }\n      .share-bar .item:last-child {\n        border-left: 0 !important;\n        border-right: 1px solid #f5f5f5 !important; }\n      .share-bar .item img {\n        left: 3px !important;\n        top: 2px !important; }\n    .share-bar .separator {\n      width: 1px !important;\n      height: 30px !important;\n      border-top: 4px solid #f6f8f8;\n      border-bottom: 4px solid #f6f8f8;\n      border-left: 0 !important;\n      border-right: 0 !important;\n      background-color: #f5f5f5;\n      float: left; }\n  original .right-cont .actionbar.with-iphone {\n    position: fixed;\n    left: 0px;\n    bottom: 0;\n    width: 100%;\n    height: 48px;\n    background-color: #f5f5f5;\n    padding-top: 4px;\n    border-top: 1px solid #e8eaea;\n    z-index: 10001; }\n    original .right-cont .actionbar.with-iphone .btn {\n      padding: 9px 13px !important; }\n    original .right-cont .actionbar.with-iphone .publish-to-media {\n      display: inline-block !important;\n      float: right;\n      position: relative;\n      margin-right: 8px; }\n    original .right-cont .actionbar.with-iphone .gather-wrapper > .btn {\n      margin-right: 10px; }\n    original .right-cont .actionbar.with-iphone .gather-wrapper .gather-box .btn {\n      margin-right: 8px;\n      margin-left: 0; }\n    original .right-cont .actionbar.with-iphone .gather-wrapper .gather-box .cart-box {\n      margin-right: 4px; }\n    original .right-cont .actionbar.with-iphone .clearfix {\n      display: inline-block;\n      float: right; }\n      original .right-cont .actionbar.with-iphone .clearfix .pull-right {\n        margin: 0 10px !important; }\n    original .right-cont .actionbar.with-iphone .download-img {\n      width: auto;\n      margin-left: 10px; }\n    original .right-cont .actionbar.with-iphone .get-reproduction get-reproduction {\n      float: right;\n      margin: 0 10px; }\n      original .right-cont .actionbar.with-iphone .get-reproduction get-reproduction .btn {\n        width: auto; }\n    original .right-cont .actionbar.with-iphone .get-reproduction .add-store-btn {\n      width: auto;\n      margin-top: 0;\n      float: right; }\n  original .right-cont .actionbar.price_cmc {\n    height: 65px; }\n    original .right-cont .actionbar.price_cmc .get-reproduction get-reproduction {\n      margin: 10px 10px 0 10px; }\n    original .right-cont .actionbar.price_cmc .get-reproduction .add-store-btn {\n      margin: 10px 0 0 0; }\n  original .reproduction.block .actions {\n    right: 12px; }\n  original .loading-error {\n    padding: 100px 20px; }\n  original .loading-error .image {\n    width: 20%;\n    left: 20px;\n    top: 18%; }\n  original .loading-error .text {\n    margin-top: 20px;\n    margin-left: 24%;\n    text-align: center; }\n  original .info .block-content .line .name, original .reproduction .block-content .line .name {\n    width: 30%;\n    padding-left: 4px; }\n  original .info .block-content .line .value, original .reproduction .block-content .line .value {\n    margin-left: 33%; }\n  original .right-cont .actionbar .fee-con {\n    margin-left: 13px !important;\n    display: block !important; }\n    original .right-cont .actionbar .fee-con .expire-date {\n      width: 160px;\n      margin-left: -8px;\n      font-size: 12px;\n      display: inline-block; } }\n", ""]);

// exports


/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _originalArticle = __webpack_require__(1048);

var _originalArticle2 = _interopRequireDefault(_originalArticle);

var _angularLocalStorage = __webpack_require__(175);

var _angularLocalStorage2 = _interopRequireDefault(_angularLocalStorage);

var _publishToMedia = __webpack_require__(181);

var _publishToMedia2 = _interopRequireDefault(_publishToMedia);

var _gatherBox = __webpack_require__(1055);

var _gatherBox2 = _interopRequireDefault(_gatherBox);

var _copyCheck = __webpack_require__(1062);

var _copyCheck2 = _interopRequireDefault(_copyCheck);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var originalArticleModule = angular.module('originalArticle', [_angularLocalStorage2.default, _publishToMedia2.default, _gatherBox2.default]).component('originalArticle', _originalArticle2.default).directive('copyCheck', _copyCheck2.default).name; /**
                                                                                                                                                                                                                                                         * Created by ganlu on 28/09/2016.
                                                                                                                                                                                                                                                         */

var states = [{
    name: 'article',
    url: '/article/{id}?action&from',
    template: '<original-article set-error="$ctrl.setError(error)" set-reproduction="$ctrl.setReproduction(reproduction)" set-show-reproduction-detail="$ctrl.setShowReproductionDetail(show)" share-to-weixin="$ctrl.shareToWeixin(url)" app-user="$ctrl.appUser"></original-article>'
}, {
    name: 'articleHash',
    url: '/article/hash/{hash}',
    template: '<original-article set-error="$ctrl.setError(error)" set-reproduction="$ctrl.setReproduction(reproduction)" set-show-reproduction-detail="$ctrl.setShowReproductionDetail(show)" share-to-weixin="$ctrl.shareToWeixin(url)" app-user="$ctrl.appUser"></original-article>'
}, {
    name: 'articleReproduction',
    url: '/article/reproduction/{reproduction}',
    template: '<original-article set-error="$ctrl.setError(error)" set-reproduction="$ctrl.setReproduction(reproduction)" set-show-reproduction-detail="$ctrl.setShowReproductionDetail(show)" share-to-weixin="$ctrl.shareToWeixin(url)" app-user="$ctrl.appUser"></original-article>'
}];

exports.default = { name: originalArticleModule, states: states };

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _originalArticle = __webpack_require__(1049);

var _originalArticle2 = _interopRequireDefault(_originalArticle);

var _originalArticle3 = __webpack_require__(1052);

var _originalArticle4 = _interopRequireDefault(_originalArticle3);

__webpack_require__(1053);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var originalArticleComponent = {
    restrict: 'E',
    bindings: {
        'article': '=',
        'appUser': '=',
        'setError': '&',
        'setReproduction': '&',
        'setShowReproductionDetail': '&',
        'shareToWeixin': '&',
        'hideBottomBar': '='
    },
    template: _originalArticle2.default,
    controller: _originalArticle4.default
}; /**
    * Created by ganlu on 28/09/2016.
    */
exports.default = originalArticleComponent;

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<div ng-class=\"{'original-article':true,'hide':$ctrl.loading}\" class=\"clearfix block\">\n    <div class=\"col-8 left-cont\" >\n        <div class=\"cont\" copy-check>\n            <!--<div class=\"position\">文章详情</div>-->\n            <div class=\"block-content\">\n                <div class=\"title\">{{ article.title }}</div>\n                <div class=\"author-info\">\n                    <a ui-sref=\"app.page.author({id: article.uuid})\" target=\"_blank\" class=\"link\">{{ article.author_name }}</a>\n                    <span ng-if=\"!!article.original_publish_time\"> &nbsp;{{ article.original_publish_time * 1000 | date : 'yyyy-MM-dd HH:mm' }}</span>\n                    <a ng-if=\"$ctrl.userInfo.isAuthor(article)\" ui-sref=\"app.home.infringements.article({id: article.id})\" class=\"reprint-link\">{{ 'show-reprint-info' | translate }}</a>\n                    <a ng-if=\"article.original_url\" target=\"_blank\" ng-href=\"{{article.original_url}}\" class=\"reprint-link\">{{ 'page-original-text128' | translate }}</a>\n                </div>\n                <div id=\"article-content\" class=\"content\" ng-bind-html=\"articleContentHtml\"></div>\n            </div>\n        </div>\n        <div ng-if=\"article && $ctrl.userInfo.isAuthor(article) && $ctrl.checkEditor()\">\n            <div class=\"delete\" ng-click=\"$ctrl.removeDialog.show(article,$event)\">\n                <span class=\"ybicon yb-delete\"></span>\n                <span>{{'page-original-text023' | translate}}</span>\n            </div>\n        </div>\n        <div class=\"similar_list\" ng-if=\"$ctrl.list.length>0\">\n            <ul>\n               <h6>关联相似文章</h6>\n               <li ng-repeat=\"item in $ctrl.list track by item.created_at\">\n                  <span class=\"left\" ng-click=\"$ctrl.$state.go('app.page.original.article',{id:item.yuanben_id})\">{{item.title}}</span>\n                  <span class=\"right\">{{item.created_at * 1000 | date : 'yyyy-MM-dd HH:mm'}}</span>\n               </li>\n\n            </ul>\n         </div>\n    </div>\n    <!-- 右边栏 -->\n    <div class=\"col-4 right-cont \">\n        <div class=\"author clearfix\">\n            <div class=\"author-face\">\n                <a ui-sref=\"app.page.author({id: article.uuid})\" target=\"_blank\">\n                    <img class=\"img\" ng-src=\"{{ article.user.avatar }}\" alt=\"\">\n                </a>\n            </div>\n            <div class=\"author-info\">\n                <div class=\"pseudonym clearfix\">\n                    <a class=\"pseudonym-title\" ui-sref=\"app.page.author({id: article.uuid})\" target=\"_blank\">\n                        {{article.user.pseudonym}}\n                    </a>\n                    <div>\n                        <img class=\"authentication\" ng-if=\"article.user.name_verified && article.user.type === 0\" width=\"56\"  src=\"" + __webpack_require__(1050) + "\" alt=\"\">\n                        <img class=\"authentication\" ng-if=\"article.user.name_verified && article.user.type === 1\" width=\"56\"  src=\"" + __webpack_require__(1051) + "\" alt=\"\">\n                    </div>\n                </div>\n                <div class=\"introduction\">{{article.user.introduction}}</div>\n                <div class=\"introduction\">{{article.user.article_count}} 篇文章</div>\n                <a class=\"btn btn-primary\" ui-sref=\"app.page.author({id: article.uuid})\" target=\"_blank\">查看更多</a>\n            </div>\n        </div>\n        <div class=\"license-dna\" ng-if=\"!article.locked && !article.user.locked && article.license.type != 'none'\">\n            <div class=\"license\"><license license=\"article.license\" dna=\"article.short_id\"></license></div>\n        </div>\n\n\n\n\n\n        <div ng-class=\"{price_cmc:article.license.type === 'cmc'&&!$ctrl.userInfo.isOriginalOwner(article, $ctrl.articleReproduction)}\" class=\"actionbar with-iphone\" ng-if=\"article && !article.locked && !article.user.locked && !$ctrl.hideBottomBar\" >\n            <div ng-if=\"$ctrl.userInfo.isOriginalOwner(article, $ctrl.articleReproduction)\">\n                <publish-to-media original=\"article\" original-type=\"article\" class=\"publish-to-media\"></publish-to-media>\n                <div class=\"clearfix gather-wrapper\">\n                    <gather-box article=\"article\" app-user=\"$ctrl.appUser\"></gather-box>\n                    <button type=\"button\" class=\"btn btn-default btn-md item pull-left\" ng-click=\"$ctrl.get()\">{{'page-original-text024' | translate}}</button>\n                </div>\n            </div>\n            <div ng-if=\"!$ctrl.userInfo.isOriginalOwner(article, $ctrl.articleReproduction)\">\n                <div class=\"unlogined-reproduction\" ng-if=\"$ctrl.$stateParams.reproduction && $ctrl.userInfo.isGuest()\">\n                    {{'page-original-text025' | translate}}\n                </div>\n                <div class=\"get-reproduction\" ng-if=\"$ctrl.$stateParams.reproduction && !$ctrl.userInfo.isGuest()\">\n                    <get-reproduction action=\"$ctrl.get()\" original=\"article\" type=\"article\"\n                                      app-user=\"$ctrl.appUser\"></get-reproduction>\n                    <button type=\"button\" class=\"btn btn-default btn-md item pull-left add-store-btn\" ng-disabled=\"$ctrl.collection_loading\" ng-click=\"$ctrl.collection(article)\">{{$ctrl.collection_text()}}</button>\n                </div>\n\n                <div class=\"get-reproduction\" ng-if=\"$ctrl.$stateParams.id\">\n                    <div class=\"fee-con\" ng-if=\"article.license.type !== 'none'\">\n                        <p>授权费用</p>\n                        <h4 ng-if=\"article.license.type === 'cc'\" class=\"free\">免费</h4>\n                        <h4 ng-if=\"article.license.type === 'cm'\">¥ {{ article.license.content.price / 100 }}</h4>\n                        <h4 ng-if=\"article.license.type === 'cmc'\" >¥ {{ article.license.content.price / 100 }} </h4>\n                        <span ng-if=\"article.license.type === 'cmc'\" class=\"expire-date\" ng-if=\"article.license.content.expire\">（{{article.license.content.expire | date : 'yyyy/MM/dd'  }} 后免费）</span>\n                    </div>\n                    <get-reproduction action=\"$ctrl.get()\" original=\"article\" type=\"article\"\n                                      app-user=\"$ctrl.appUser\"></get-reproduction>\n                    <button type=\"button\" class=\"btn btn-default btn-md item pull-left add-store-btn\" ng-disabled=\"$ctrl.collection_loading\" ng-click=\"$ctrl.collection(article)\">{{$ctrl.collection_text()}}</button>\n                </div>\n            </div>\n        </div>\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n        <div class=\"info\" ng-if=\"article\">\n            <div class=\"title\">{{'page-original-text026' | translate}}</div>\n            <div class=\"item clearfix\">\n                <div class=\"name\">{{'page-original-text027' | translate}}</div>\n                <div class=\"value\">\n                    <a ui-sref=\"app.page.author({id: article.uuid})\" target=\"_blank\" class=\"link\">{{ article.author_name }}</a>\n                </div>\n            </div>\n            <div class=\"item clearfix\" ng-if=\"article.op_user_name&&$ctrl.appUser.type==1\">\n                <div class=\"name\">{{'page-original-Operator' | translate}}</div>\n                <div class=\"value\">\n                    {{ article.op_user_name }}\n                </div>\n            </div>\n            <div class=\"item clearfix\">\n                <div class=\"name\">{{'page-original-text028' | translate}}</div>\n                <div class=\"value\">\n                    {{ article.created_at * 1000 | date : 'yyyy-MM-dd HH:mm' }}\n                </div>\n            </div>\n            <div class=\"item clearfix\">\n                <div class=\"name\">{{'page-original-text029' | translate}}</div>\n                <div class=\"value\">\n                    <a ng-if=\"article.block_hash\" href=\"{{ article.chain_server_url }}\" class=\"link\" target=\"_blank\">{{\n                        article.block_hash }}</a>\n                    <span ng-if=\"!article.block_hash\" style=\"color: #999;\">{{'home-evidences-text052' | translate}}</span>\n                </div>\n            </div>\n            <div class=\"actions\">\n                <a ng-if=\"!$ctrl.userInfo.isGuest()\" ui-sref=\"app.page.evidence.article({id: article.id})\" class=\"btn btn-default btn-md\">{{'page-original-text030' | translate}} &#62</a>\n                <a ng-if=\"$ctrl.userInfo.isGuest()\" ui-sref=\"app.page.evidence.article({id: article.yuanben_id})\" class=\"btn btn-default btn-md\">{{'page-original-text030' | translate}} &#62</a>\n            </div>\n        </div>\n\n    </div>\n<!--    <div class=\"share-bar\">-->\n<!--        <a class=\"item\" title=\"{{'page-original-text031' | translate}}\" target=\"_blank\"-->\n<!--           ng-href=\"https://service.weibo.com/share/share.php?url={{ article.url }}&title={{ article.title }}&appkey=1662195547\">-->\n<!--            <img src=\"../../../../common/social/weibo-share.png\" width=\"24\" height=\"24\"/>-->\n<!--        </a>-->\n<!--        <div class=\"separator\"></div>-->\n<!--        <a class=\"item\" title=\"{{'page-original-text032' | translate}}\" href=\"javascript:void(0)\" ng-click=\"$ctrl.showWeixinShare()\">-->\n<!--            <img src=\"../../../../common/social/weixin-share.png\" width=\"24\" height=\"24\"/>-->\n<!--        </a>-->\n<!--        <div class=\"separator\"></div>-->\n<!--        <a class=\"item\" title=\"{{'page-original-text033' | translate}}\" target=\"_blank\"-->\n<!--           ng-href=\"http://s.jiathis.com/?webid=qzone&url={{ article.url }}&title={{ article.title }}&uid=2123724&jtss=1&summary={{ article.outline }}\">-->\n<!--            <img src=\"../../../../common/social/qzone-share.png\" width=\"24\" height=\"24\"/>-->\n<!--        </a>-->\n<!--        <div class=\"separator\"></div>-->\n<!--        <a class=\"item\" title=\"{{'page-original-text034' | translate}}\" target=\"_blank\"-->\n<!--           ng-href=\"http://s.jiathis.com/?webid=douban&url={{ article.url }}&title={{ article.title }}&uid=2123724&jtss=1&summary={{ article.outline }}\">-->\n<!--            <img src=\"../../../../common/social/douban-share.png\" width=\"24\" height=\"24\"/>-->\n<!--        </a>-->\n<!--    </div>-->\n</div>\n\n\n\n<dialog-modal text=\"{{$ctrl.removeDialog.text}}\"\n              position=\"$ctrl.removeDialog.position\"\n              is-active=\"$ctrl.removeDialog.isActive\"\n              sure=\"$ctrl.removeDialog.sure()\"></dialog-modal>\n";

/***/ }),
/* 1050 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1051 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = __webpack_require__(49);

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = __webpack_require__(172);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by lency on 9/17/16.
 */
var OriginalArticleController = function () {
    OriginalArticleController.$inject = ['$scope', '$stateParams', '$sce', '$filter', 'QueryAPI', 'clipboard', 'badge', 'ArticleAPI', 'CollectionAPI', 'AppConfig', 'modal', '$state', 'message', '$window', '$timeout', 'pageTitle', 'userInfo', '$transitions', 'Jurisdiction'];

    function OriginalArticleController($scope, $stateParams, $sce, $filter, QueryAPI, clipboard, badge, ArticleAPI, CollectionAPI, AppConfig, modal, $state, message, $window, $timeout, pageTitle, userInfo, $transitions, Jurisdiction) {
        "ngInject";

        var _this = this;

        (0, _classCallCheck3.default)(this, OriginalArticleController);
        this.$scope = $scope;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.Jurisdiction = Jurisdiction;
        this.$sce = $sce;
        this.QueryAPI = QueryAPI;
        this.badge = badge;
        this.AppConfig = AppConfig;
        this.message = message;
        this.$timeout = $timeout;
        this.modal = modal;
        this.clipboard = clipboard;
        this.pageTitle = pageTitle;
        this.userInfo = userInfo;
        this.loading = true;
        this.ArticleAPI = ArticleAPI;
        this.CollectionAPI = CollectionAPI;
        this.collectionActive = false;
        this.collection_loading = false;
        this.tranlsteFilter = $filter('translate');
        this.$window = $window;
        this.userInfo.setUser(this.appUser);
        this.list = [];
        this.articleId = null;
        var self = this;
        $transitions.onSuccess({
            to: function to(state) {
                return state.name == 'app.page.original.article' || state.name == 'app.page.original.articleHash' || state.name == 'app.page.original.articleReproduction';
            }
        }, function () {
            self.init();
        });

        this.removeDialog = {
            text: this.tranlsteFilter('page-original-text035'),
            sure: function sure() {
                _this.deleteArticle(_this.removeDialog.original);
            },
            show: function show(original, event) {
                event.stopPropagation();
                _this.removeDialog.original = original;
                _this.removeDialog.text = _this.tranlsteFilter('page-original-text036') + original.title + '" ?';
                _this.removeDialog.isActive = true;
            }
        };

        this.init();
    }

    (0, _createClass3.default)(OriginalArticleController, [{
        key: 'init',
        value: function init() {

            this.articleReproduction = null;
            this.showReproductionDetail = false;

            this.$scope.article = null;
            this.$scope.articleContentHtml = '';
            this.$scope.copyAuthorized = false;

            this.setShowReproductionDetail({ 'show': false });
            this.setReproduction({ 'reproduction': null });

            if (this.article) {
                this.loadArticle(this.article);
            } else {

                var api = null;
                if (this.$stateParams.id) {
                    var from = this.$stateParams.from;
                    api = this.QueryAPI.one().get((0, _extends3.default)({ 'id': this.$stateParams.id, 'type': 'article' }, from ? { from: from } : {}));
                } else if (this.$stateParams.hash) {
                    api = this.QueryAPI.one('hash').get({ 'hash': this.$stateParams.hash, 'type': 'article' });
                } else if (this.$stateParams.reproduction) {
                    api = this.QueryAPI.one('reproduction').get({ 'id': this.$stateParams.reproduction, 'type': 'article' });
                } else {
                    _self.setError({ 'error': true });
                    return;
                }

                var _self = this;

                api.then(function (article) {
                    _self.articleId = article.id;
                    _self.loadArticle(article);
                    if (_self.userInfo.user.email && article.user_id == _self.userInfo.user.id) {
                        _self.getList(); //文章关联
                    }
                }, function () {
                    _self.loading = false;
                    _self.setError({ 'error': true });
                });
            }
        }
    }, {
        key: 'loadArticle',
        value: function loadArticle(article) {
            var self = this;

            self.$scope.article = article;

            self.$scope.publicKeyHtml = self.$sce.trustAsHtml(self.$scope.article.public_key.replace(/\n/g, "<br/>"));

            self.pageTitle.setTitle(article.title + ' ' + article.author_name);
            if (article.reproduction) {
                // Comes from reproduction url
                // Display reproduction
                article.reproduction.author_name = article.author_name;
                article.reproduction.license = article.license;
                article.reproduction.chain_server_url = article.chain_server_url;
                self.articleReproduction = article.reproduction;
                self.$scope.articleContentHtml = self.$sce.trustAsHtml(self.$scope.article.content + self.badge.getReproductionBadgeContent(article, article.reproduction));

                self.setReproduction({ 'reproduction': article.reproduction });
                self.showReproductionDetail = true;
                self.setShowReproductionDetail({ 'show': true });
                self.loading = false;
                self.pageLoaded();
            } else {
                self.$scope.articleContentHtml = self.$sce.trustAsHtml(self.$scope.article.content + self.badge.getBadgeContent(article));
                self.loadReproduction();
            }
            //获取用户是否已经收藏
            if (!this.userInfo.isGuest()) {
                this.collectionInfo(article);
            }
        }
    }, {
        key: 'loadReproduction',
        value: function loadReproduction() {
            if (!this.userInfo.isGuest()) {
                if (this.$scope.article.license.type) {
                    var _self2 = this;
                    this.QueryAPI.one().one('article', this.$scope.article.id).one('reproduction').get().then(function (reproduction) {

                        if (reproduction && reproduction.id) {
                            _self2.setReproduction({ 'reproduction': reproduction });
                            _self2.showReproductionDetail = false;
                            _self2.setShowReproductionDetail({ 'show': false });
                            _self2.articleReproduction = reproduction;
                        }
                        _self2.pageLoaded();
                    }, function (response) {
                        _self2.message.error(response.data);
                        _self2.pageLoaded();
                    });
                } else {
                    this.pageLoaded();
                }
            } else {
                this.pageLoaded();
            }
        }
    }, {
        key: 'pageLoaded',
        value: function pageLoaded() {

            this.loading = false;

            if (this.$scope.article.locked || this.$scope.article.user.locked) {
                this.message.error(this.tranlsteFilter('page-original-text037'), 0);
            }

            if (this.userInfo.isOriginalOwner(this.$scope.article, this.articleReproduction)) {
                this.$scope.copyAuthorized = true;
            }
        }
    }, {
        key: 'get',
        value: function get() {
            this.$scope.copyAuthorized = true;
            this.copy();
        }
    }, {
        key: 'copy',
        value: function copy() {
            this.clipboard.copyElementById('article-content');
        }
    }, {
        key: 'showWeixinShare',
        value: function showWeixinShare() {
            var url = this.AppConfig.server_url + '/original/qrcode?type=article&id=' + this.$scope.article.id;
            this.shareToWeixin({ url: url });
        }
    }, {
        key: 'deleteArticle',
        value: function deleteArticle(article) {

            var self = this;

            self.loading = true;

            this.ArticleAPI.one(article.id).remove().then(function (res) {
                if (res.status.code == 200) {
                    self.appUser.article_count--;
                    self.message.success(self.tranlsteFilter('page-original-text038'));
                    self.$state.go('app.page.author', { id: article.uuid });
                } else if (res.status.code == 422) {
                    if (res.status.message == 'Authorized') {
                        self.message.error(self.tranlsteFilter('page-original-text039'));
                    } else {
                        self.message.error(self.tranlsteFilter('page-original-text040'));
                    }
                }
                self.loading = false;
            }, function (response) {
                self.loading = false;
                self.message.error(response.data);
            });
        }
        //获取收藏属性

    }, {
        key: 'collectionInfo',
        value: function collectionInfo(article) {
            var self = this;
            this.CollectionAPI.one().get({ 'resource_type_id': 1, 'resource_id': article.id }).then(function (res) {
                self.collectionActive = res.data.active;
            }, function () {
                // self.loading = false;
                // self.setError({'error': true});
            });
        }
    }, {
        key: 'collection',
        value: function collection(article) {
            if (this.userInfo.isGuest()) {
                this.$state.go('app.face.index.user.form.login');
                return;
            }
            var self = this;
            self.collection_loading = true;
            var api = this.CollectionAPI;
            if (self.collectionActive) {
                api.one().remove({ resource_type_id: 1, resource_id: article.id }).then(function () {
                    self.collection_loading = false;
                    self.message.success(self.tranlsteFilter('page-original-text041'));
                    self.collectionActive = false;
                }, function (response) {
                    self.collection_loading = false;
                    self.message.error(response.data);
                });
            } else {
                api.post({ resource_type_id: 1, resource_id: article.id }).then(function () {
                    self.collection_loading = false;
                    self.message.success(self.tranlsteFilter('page-original-text042'));
                    self.collectionActive = true;
                }, function (response) {
                    self.collection_loading = false;
                    self.message.error(response.data);
                });
            }
        }
    }, {
        key: 'collection_text',
        value: function collection_text() {
            var self = this;
            if (self.collection_loading) {
                return this.tranlsteFilter('page-original-text043');
            } else {
                if (self.collectionActive) {
                    return this.tranlsteFilter('page-original-text044');
                } else {
                    return this.tranlsteFilter('page-original-text045');
                }
            }
        }
    }, {
        key: 'getList',
        value: function getList() {
            var _this2 = this;

            this.ArticleAPI.one(this.articleId + "/sensitive").get({ count: 10 }).then(function (res) {
                _this2.list = res.data;
            }, function (err) {
                console.log(err);
            });
        }
    }, {
        key: 'checkEditor',
        value: function checkEditor() {
            this.permission = JSON.parse(window.localStorage.getItem("loginUser"));

            var param = (0, _assign2.default)(this.permission);
            return this.Jurisdiction.checkStatusShow(param);
        }
    }]);
    return OriginalArticleController;
}();

exports.default = OriginalArticleController;

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1054);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./original-article.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./original-article.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "original-article .hide {\n  display: none !important; }\n\noriginal-article .original-article {\n  position: relative; }\n  original-article .original-article .cont .block-content {\n    margin-top: 40px; }\n    original-article .original-article .cont .block-content .title {\n      font-size: 24px;\n      font-weight: bold;\n      color: #222222;\n      line-height: 1.4;\n      word-break: break-all; }\n    original-article .original-article .cont .block-content .author-info {\n      font-size: 14px;\n      color: #999999;\n      margin: 10px 0 30px; }\n      original-article .original-article .cont .block-content .author-info .link {\n        text-decoration: none;\n        color: #999999; }\n        original-article .original-article .cont .block-content .author-info .link:hover {\n          color: #00816a; }\n      original-article .original-article .cont .block-content .author-info .reprint-link {\n        float: right;\n        font-size: 12px;\n        color: #BDBDBD;\n        margin-left: 10px; }\n    original-article .original-article .cont .block-content .content {\n      position: relative;\n      color: #222222;\n      margin-top: 16px;\n      font-size: 14px;\n      line-height: 1.8;\n      word-break: break-all; }\n      original-article .original-article .cont .block-content .content img {\n        max-width: 100% !important;\n        display: block; }\n      original-article .original-article .cont .block-content .content p {\n        margin: 1em 0;\n        width: auto !important;\n        height: auto !important; }\n  original-article .original-article .similar_list {\n    margin-top: 50px;\n    color: #363636; }\n    original-article .original-article .similar_list ul {\n      padding: 0; }\n      original-article .original-article .similar_list ul h6 {\n        font-size: 17px;\n        height: 50px;\n        line-height: 50px;\n        border-bottom: 2px solid #808080;\n        margin: 0; }\n      original-article .original-article .similar_list ul li {\n        list-style: none;\n        height: 40px;\n        line-height: 40px;\n        border-bottom: 1px solid #D7D7D7; }\n        original-article .original-article .similar_list ul li:last-child {\n          border-bottom: none; }\n        original-article .original-article .similar_list ul li .left {\n          display: inline-block;\n          width: 60%;\n          white-space: nowrap;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          color: #4477b0;\n          cursor: pointer; }\n        original-article .original-article .similar_list ul li .right {\n          float: right; }\n\n@media only screen and (max-width: 767px) {\n  original-article .original-article .cont .block-content {\n    margin-top: 0;\n    padding-top: 30px; }\n  original .original .left-cont .delete {\n    margin-top: 30px; } }\n", ""]);

// exports


/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _gatherBox = __webpack_require__(1056);

var _gatherBox2 = _interopRequireDefault(_gatherBox);

var _angularLocalStorage = __webpack_require__(175);

var _angularLocalStorage2 = _interopRequireDefault(_angularLocalStorage);

__webpack_require__(165);

var _mediaAccount = __webpack_require__(173);

var _mediaAccount2 = _interopRequireDefault(_mediaAccount);

var _message = __webpack_require__(1061);

var _message2 = _interopRequireDefault(_message);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var gatherBoxModule = _angular2.default.module('gatherBox', [_angularLocalStorage2.default, 'angularFileUpload', _mediaAccount2.default]).component('gatherBox', _gatherBox2.default).service({ gatherTip: _message2.default }).name;

exports.default = gatherBoxModule;

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _gatherBox = __webpack_require__(1057);

var _gatherBox2 = _interopRequireDefault(_gatherBox);

var _gatherBox3 = __webpack_require__(1058);

var _gatherBox4 = _interopRequireDefault(_gatherBox3);

__webpack_require__(1059);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var gatherboxComponent = {
    restrict: 'E',
    bindings: {
        appUser: '=',
        article: '='
    },
    template: _gatherBox2.default,
    controller: _gatherBox4.default
};

exports.default = gatherboxComponent;

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<div class=\"gather-box\">\n    <button type=\"button\" class=\"btn btn-default btn-md item pull-left add-gather-btn\" ng-click=\"$ctrl.store()\">{{'page-original-text126' | translate}}</button>\n    <span class=\"ybicon yb-addtosubmit cart-box\" ng-click=\"$ctrl.showModal()\">\n        <i class=\"counter\" ng-if=\"gatherArticle.length\">{{gatherArticle.length}}</i>\n    </span>\n</div>\n\n<div id=\"gather-modal\" class=\"modal-overlay gather-modal\" modal-control >\n    <div class=\"modal\">\n        <div class=\"gather-modal-tip\"></div>\n        <div class=\"header\">\n            <div class=\"title\">{{'page-original-text046' | translate}}</div>\n            <div class=\"close\">×</div>\n        </div>\n        <div class=\"content clearfix\"  ng-class=\"{publishing:$ctrl.publishing}\">\n            <div class=\"articles\" ng-if=\"gatherArticle.length != 0 \">\n                <div class=\"item\" ng-class=\"{first:$first}\" ng-repeat=\"article in gatherArticle track by article.article_id\">\n                    <div class=\"cont\">\n                        <img ng-show=\"$first\" ng-src=\"{{article.image_url}}?x-oss-process=image/resize,m_fill,w_320,h_160,limit_0\" alt=\"\" class=\"img\">\n                        <img ng-show=\"!$first\" ng-src=\"{{article.image_url}}?x-oss-process=image/resize,m_fill,w_40,h_40,limit_0\" alt=\"\" class=\"img\">\n                        <div class=\"title\">{{article.title}}</div>\n                    </div>\n                    <div class=\"mask\">\n                        <span class=\"ybicon yb-up pull-left\" ng-click=\"$ctrl.changePos($index,-1)\"></span>\n                        <span class=\"ybicon yb-down pull-left\" ng-click=\"$ctrl.changePos($index,1)\"></span>\n                        <span class=\"ybicon yb-addpic pull-right\" >\n                            <input type=\"file\"  class=\"image-field\" nv-file-select uploader=\"$ctrl.uploader_{{article.article_id}}\"/>\n                        </span>\n                        <span class=\"ybicon yb-delete pull-right\" ng-click=\"$ctrl.remove($index)\"></span>\n\n                    </div>\n                </div>\n            </div>\n            <div class=\"placeholder\" ng-if=\"gatherArticle.length == 0\">\n                <img src=\"" + __webpack_require__(110) + "\" width=\"100\" height=\"100\">\n            </div>\n            <div class=\"gather-loading\" ng-if=\"$ctrl.publishing\">\n                <img src=\"" + __webpack_require__(162) + "\" width=\"80\"/>\n            </div>\n        </div>\n        <div class=\"modal-footer\">\n\n            <button type=\"button\" class=\"btn-yes btn btn-md btn-primary pull-right\"\n                    ng-click=\"$ctrl.publish()\" ng-disabled=\"$ctrl.publishing || $ctrl.uploading || gatherArticle.length==0\">\n                {{ $ctrl.publishing &&  ('page-original-text047' | translate) || ('page-original-text048' | translate) }}\n            </button>\n            <button type=\"button\" class=\"btn-no btn btn-md btn-default pull-right\" ng-click=\"$ctrl.clearGatherArticle()\" ng-disabled=\"$ctrl.publishing || gatherArticle.length==0\">{{'page-original-text049' | translate}}</button>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(83);

var _stringify2 = _interopRequireDefault(_stringify);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var gatherboxController = function () {
    gatherboxController.$inject = ['$http', '$timeout', '$interval', '$filter', 'message', '$scope', 'localStorageService', 'FileUploader', 'ArticleAPI', 'AppConfig', 'modal', 'mediaAccount', 'gatherTip'];

    function gatherboxController($http, $timeout, $interval, $filter, message, $scope, localStorageService, FileUploader, ArticleAPI, AppConfig, modal, mediaAccount, gatherTip) {
        "ngInject";

        var _this = this;

        (0, _classCallCheck3.default)(this, gatherboxController);
        var self = this;
        this.$http = $http;
        this.$timeout = $timeout;
        this.$interval = $interval;
        this.message = message;
        this.$scope = $scope;
        this.localStorageService = localStorageService;
        this.AppConfig = AppConfig;
        this.ArticleAPI = ArticleAPI;
        this.mediaAccount = mediaAccount;
        this.modal = modal;
        this.FileUploader = FileUploader;
        this.gatherTip = gatherTip;
        this.check_timer = null;
        this.tranlsteFilter = $filter('translate');

        this.imageUploadPolicy = null;
        this.uploading = false;
        this.publishing = false;

        this.getImageUploadPolicy();

        mediaAccount.init();

        //this.$scope.gatherArticle=[{"article_id":41264,"title":"国家发改委部署加强2017年国庆中秋期间市场价格监管","image_url":"http://yb-img-staging.oss-cn-shanghai.aliyuncs.com/uploads/12/1505301363258_842.png"},{"article_id":41278,"title":"上海市旅游局携手光明乳业 打造首届上海酸奶节","image_url":"http://yb-img-staging.oss-cn-shanghai.aliyuncs.com/uploads/uaritlces/040df697a27ae3003853180cd40eae1e.jpeg"},{"article_id":41275,"title":"四川省企业经济促进会赴邛崃开展成都区域雾霾形成主要原因及治理现状调研","image_url":"http://yb-img-staging.oss-cn-shanghai.aliyuncs.com/uploads/uaritlces/98bd3883db3af0946ff70ba89c03b41c.jpeg"},{"article_id":41274,"title":"宝马加速新产品攻势 率大型豪华车亮相法兰克福车展","image_url":"http://yb-img-staging.oss-cn-shanghai.aliyuncs.com/uploads/uaritlces/380abcc8abf2b7f0a0238d7c176f4481.jpeg"},{"article_id":41270,"title":"信阳“互联网+精准扶贫”新思路 贫困村生态农产品进社区","image_url":"http://yb-img-staging.oss-cn-shanghai.aliyuncs.com/uploads/uaritlces/c600229d370876ab6136a25083d92b28.jpeg"},{"article_id":41268,"title":"河南信阳：“特岗计划”助力城乡教育均衡发展","image_url":"https://yb-img-staging.oss-cn-shanghai.aliyuncs.com/system/gather-bg.jpg"},{"article_id":41267,"title":"“老家河南·山水太行”旅游推介会走进北京","image_url":"http://yb-img-staging.oss-cn-shanghai.aliyuncs.com/uploads/uaritlces/960ed24c66756a7989fb0d8f52685aea.jpeg"},{"article_id":41263,"title":"北京发改委王英建：力保双创活动周北京主题展参展项目全新","image_url":"https://yb-img-staging.oss-cn-shanghai.aliyuncs.com/system/gather-bg.jpg"}]

        this.$scope.$watch('gatherArticle', function (newValue) {
            if (newValue) {
                _this.localStorageService.set('gatherArticle_' + _this.appUser.id, newValue);

                _this.gatherInit(newValue);
            }
        }, true);
        this.$scope.gatherArticle = this.retrieve();
    }

    (0, _createClass3.default)(gatherboxController, [{
        key: 'store',
        value: function store() {
            var _this2 = this;

            //存文章
            var self = this;
            self.$scope.gatherArticle.length = 0;
            angular.copy(self.retrieve(), self.$scope.gatherArticle);
            var articles = this.$scope.gatherArticle = this.retrieve();
            if (articles.length >= 8) {
                this.message.error(self.tranlsteFilter('page-original-text050'));
                return false;
            }
            var isExist = articles.some(function (item) {
                return item.article_id == _this2.article.id;
            });
            if (!isExist) {
                articles.push({
                    article_id: this.article.id,
                    title: this.article.title,
                    image_url: this.article.main_article_image || this.AppConfig.aliyun_url + '/system/gather-bg.jpg'
                });
            } else {
                this.message.warn(self.tranlsteFilter('page-original-text051'));
            }
        }
    }, {
        key: 'remove',
        value: function remove(idx) {
            //删文章
            var articles = this.$scope.gatherArticle;
            articles.splice(idx, 1);

            // let idx = -1;
            // articles.forEach((item,index)=>{
            //     if(item.article_id==id){
            //         idx=index;
            //         return;
            //     }
            // });
            //
            // if(idx!=-1){
            //     articles.splice(idx,1)
            // }
        }
    }, {
        key: 'retrieve',
        value: function retrieve() {
            //取文章
            return this.localStorageService.get('gatherArticle_' + this.appUser.id) || [];
        }
        //清空本地储存

    }, {
        key: 'clearGatherArticle',
        value: function clearGatherArticle() {
            this.$scope.gatherArticle.length = 0;
        }
        //移动

    }, {
        key: 'changePos',
        value: function changePos(idx, pos) {
            var articles = this.$scope.gatherArticle;
            var toIndex = idx + pos;
            if (pos == -1 && toIndex <= -1) {
                toIndex = articles.length - 1;
            }
            if (pos == 1 && toIndex == articles.length) {
                toIndex = 0;
            }
            articles[toIndex] = articles.splice(idx, 1, articles[toIndex])[0];
        }
        //获取用户上传图片权限

    }, {
        key: 'getImageUploadPolicy',
        value: function getImageUploadPolicy() {
            var self = this;
            this.ArticleAPI.one('image').one('policy').get().then(function (policy) {
                self.imageUploadPolicy = policy;
            }, function (response) {
                self.message.error(response.data);
            });
        }
        //获取文件后缀名

    }, {
        key: 'getSuffix',
        value: function getSuffix(filename) {
            var pos = filename.lastIndexOf('.');
            if (pos != -1) {
                return filename.substring(pos);
            }
            return '';
        }

        //一键发布

    }, {
        key: 'publish',
        value: function publish() {
            var self = this;
            if (!self.mediaAccount.mediaAccounts['weixin']) {
                self.gatherTip.info(self.tranlsteFilter('page-original-text052') + '，<a href="' + location.origin + '/home/profile/media" target="_blank">' + self.tranlsteFilter('page-original-text054') + ' </a>');
                return;
            }
            if (self.mediaAccount.mediaAccounts['weixin'] && !self.mediaAccount.mediaAccounts['weixin']['access_token']) {
                self.gatherTip.info(self.tranlsteFilter('page-original-text053') + '，<a href="' + location.origin + '/home/profile/media" target="_blank">' + self.tranlsteFilter('page-original-text055') + '</a>');
                return;
            }

            self.publishing = true;
            self.gatherTip.info(self.tranlsteFilter('page-original-text056'));

            this.$http.post(this.AppConfig.server_url + '/weixin/articles/combinations', this.$scope.gatherArticle, {
                withCredentials: true
            }).then(function (res) {

                if (res.data.status.code == 200) {
                    self.check_timer = self.$interval(function () {
                        self.checkStatus.bind(self);
                        self.checkStatus();
                    }, 1500);
                } else if (res.data.status.code == 422) {
                    self.publishing = false;
                    self.gatherTip.error(res.data.status.message);
                }
            }, function (response) {
                self.publishing = false;
                self.gatherTip.error(self.tranlsteFilter('page-original-text057'));
            });
        }
    }, {
        key: 'checkStatus',
        value: function checkStatus() {
            var self = this;
            self.$http.get(this.AppConfig.server_url + '/weixin/articles/combinations/status', {
                withCredentials: true
            }).then(function (res) {
                if (res.data.data.process == 'ok') {
                    self.publishing = false;
                    self.$interval.cancel(self.check_timer);
                    var img = '';
                    if (self.mediaAccount.mediaAccounts['weixin']['params']['head_img']) {
                        img = '<img style="width: 26px;height: 26px;border-radius: 100%;vertical-align: middle;margin: 0 5px;"' + 'src="' + self.mediaAccount.mediaAccounts['weixin']['params']['head_img'] + '"  alt="" class="social-face">';
                    }
                    if ($('#gather-modal').hasClass('active')) {
                        self.gatherTip.success(self.tranlsteFilter('page-original-text058') + self.mediaAccount.mediaAccounts['weixin']['name']);
                    } else {
                        self.gatherTip.success(self.tranlsteFilter('page-original-text058') + self.mediaAccount.mediaAccounts['weixin']['name']);
                        self.message.success(self.tranlsteFilter('page-original-text058') + self.mediaAccount.mediaAccounts['weixin']['name']);
                    }
                    localStorage.setItem("publishingStatus", (0, _stringify2.default)({ status: 'ok', now: Date.now() }));
                }
            }, function (response) {
                self.publishing = false;
                self.gatherTip.error(response.data);
            });
        }
    }, {
        key: 'showModal',
        value: function showModal() {
            var self = this;
            self.$scope.gatherArticle.length = 0;
            angular.copy(self.retrieve(), self.$scope.gatherArticle);
            //this.gatherInit(self.$scope.gatherArticle);
            this.modal.open('gather-modal');
        }
    }, {
        key: 'gatherInit',
        value: function gatherInit(newValue) {
            var _this3 = this;

            var self = this;
            newValue.length && newValue.forEach(function (article, index, arr) {
                var currentImageFilename = '';
                _this3['uploader_' + article.article_id] = new self.FileUploader({
                    autoUpload: true,
                    removeAfterUpload: true,
                    onSuccessItem: function onSuccessItem(item, response, status, headers) {
                        self.$scope.gatherArticle.forEach(function (item) {
                            if (item.article_id == article.article_id) {
                                item.image_url = self.imageUploadPolicy['host'] + '/' + currentImageFilename;
                                return;
                            }
                        });
                        //self.$scope.$digest();

                        self.uploading = false;
                        self.gatherTip.hide();
                    },
                    onBeforeUploadItem: function onBeforeUploadItem(item) {
                        var size = item.file.size;
                        self.coverError = null;
                        if (size >= 2 * 1024 * 1024) {
                            self['uploader_' + article.article_id].cancelItem(item);
                            self.gatherTip.error(self.tranlsteFilter('page-original-text059'));

                            return;
                        }
                        var type = item.file.type;
                        if (["image/png", "image/jpeg", "image/bmp"].indexOf(type) == -1) {
                            self['uploader_' + article.article_id].cancelItem(item);
                            self.gatherTip.error(self.tranlsteFilter('page-original-text060'));
                            return;
                        }
                        self.uploading = true;
                        self.gatherTip.info(self.tranlsteFilter('page-original-text061'));
                        var fileSuffix = self.getSuffix(item.file.name);
                        var filename = Date.now() + '_' + Math.floor(Math.random() * 1000);

                        currentImageFilename = self.imageUploadPolicy['key'] + filename + fileSuffix;
                        item.url = self.imageUploadPolicy['host'];
                        item.formData = [{
                            'key': currentImageFilename
                        }, {
                            'policy': self.imageUploadPolicy['policy']
                        }, {
                            'OSSAccessKeyId': self.imageUploadPolicy['accessid']
                        }, {
                            'success_action_status': '200'
                        }, {
                            'callback': ''
                        }, {
                            'signature': self.imageUploadPolicy['signature']
                        }];
                    }
                });
            });
        }
    }, {
        key: '$onInit',
        value: function $onInit() {
            var self = this;
            $(window).on('storage', function (ev) {
                var event = ev.originalEvent,
                    message = event.newValue && JSON.parse(event.newValue); // 解析出复合的对象值
                // 对获取到的值进行处理

                if (message && message.status == 'ok') {
                    self.message.success(self.tranlsteFilter('page-original-text058') + self.mediaAccount.mediaAccounts['weixin']['name']);
                }
            });
        }
    }]);
    return gatherboxController;
}();

exports.default = gatherboxController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1060);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./gather-box.scss", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./gather-box.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "gather-box {\n  display: inline-block;\n  float: left; }\n  gather-box .gather-box {\n    display: inline-block; }\n    gather-box .gather-box .add-gather-btn {\n      margin: 0 20px 0 15px; }\n    gather-box .gather-box .cart-box {\n      display: inline-block;\n      position: relative;\n      font-size: 24px;\n      color: #999999;\n      top: 10px;\n      cursor: pointer; }\n      gather-box .gather-box .cart-box:hover {\n        color: #666666; }\n      gather-box .gather-box .cart-box .counter {\n        position: absolute;\n        right: -5px;\n        bottom: 70%;\n        color: #fff;\n        font-size: 12px;\n        padding: 1px 4px 2px;\n        border-radius: 16px;\n        background: red;\n        font-style: normal;\n        line-height: 1; }\n  gather-box .gather-modal .modal {\n    width: 360px;\n    border-radius: 0; }\n    gather-box .gather-modal .modal .header {\n      position: relative;\n      height: 44px;\n      line-height: 44px;\n      border-bottom: none;\n      padding: 0 20px; }\n      gather-box .gather-modal .modal .header .close {\n        right: -36px;\n        top: -10px;\n        font-size: 32px;\n        color: #fff;\n        line-height: 1;\n        height: 32px;\n        width: 32px; }\n    gather-box .gather-modal .modal .content {\n      padding: 0 20px; }\n    gather-box .gather-modal .modal .modal-footer {\n      padding: 8px 20px;\n      height: 50px; }\n      gather-box .gather-modal .modal .modal-footer .btn {\n        padding: 6px 20px; }\n    gather-box .gather-modal .modal .gather-modal-tip {\n      top: -56px;\n      position: absolute;\n      left: 0;\n      font-size: 14px;\n      width: 100%;\n      line-height: 36px;\n      height: 36px;\n      text-align: center;\n      color: #fff;\n      margin: 0; }\n      gather-box .gather-modal .modal .gather-modal-tip.success {\n        background: #32d182; }\n      gather-box .gather-modal .modal .gather-modal-tip.error {\n        background: #ff3333; }\n      gather-box .gather-modal .modal .gather-modal-tip.info {\n        background: #6b9fe7; }\n      gather-box .gather-modal .modal .gather-modal-tip a {\n        color: #fff; }\n  gather-box .gather-modal .content .articles .item {\n    position: relative;\n    padding: 5px 0;\n    line-height: 40px;\n    border-bottom: 1px solid #e8eaea; }\n    gather-box .gather-modal .content .articles .item:last-child {\n      border-bottom: none; }\n    gather-box .gather-modal .content .articles .item:hover .mask {\n      display: block; }\n    gather-box .gather-modal .content .articles .item.first {\n      padding: 0; }\n      gather-box .gather-modal .content .articles .item.first .cont {\n        height: 160px; }\n        gather-box .gather-modal .content .articles .item.first .cont .title {\n          position: absolute;\n          left: 0;\n          right: 0;\n          bottom: 0;\n          height: 50px;\n          line-height: 50px;\n          background: rgba(0, 0, 0, 0.4);\n          margin-right: 0;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          white-space: nowrap;\n          color: #fff;\n          padding: 0 10px; }\n        gather-box .gather-modal .content .articles .item.first .cont .img {\n          float: none; }\n    gather-box .gather-modal .content .articles .item .cont .title {\n      margin-right: 60px;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      color: #222222;\n      font-size: 14px; }\n    gather-box .gather-modal .content .articles .item .cont .img {\n      float: right; }\n    gather-box .gather-modal .content .articles .item .mask {\n      display: none;\n      position: absolute;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      background: rgba(0, 0, 0, 0.7);\n      color: #cccccc;\n      font-size: 24px;\n      height: 50px; }\n      gather-box .gather-modal .content .articles .item .mask .ybicon {\n        margin: 15px 10px 0;\n        cursor: pointer; }\n        gather-box .gather-modal .content .articles .item .mask .ybicon:hover {\n          color: #fff; }\n        gather-box .gather-modal .content .articles .item .mask .ybicon:nth-child(4) {\n          font-size: 20px; }\n        gather-box .gather-modal .content .articles .item .mask .ybicon.yb-addpic {\n          position: relative;\n          overflow: hidden; }\n          gather-box .gather-modal .content .articles .item .mask .ybicon.yb-addpic .image-field {\n            height: 100%;\n            position: absolute;\n            left: -150px;\n            top: 0;\n            opacity: 0;\n            cursor: pointer; }\n  gather-box .gather-modal .content .placeholder {\n    padding: 50px;\n    text-align: center; }\n  gather-box .gather-modal .content .gather-loading {\n    position: absolute;\n    z-index: 2;\n    width: 100%;\n    left: 0;\n    top: 0;\n    bottom: 46px;\n    background: rgba(255, 255, 255, 0.7);\n    padding-top: 80px;\n    text-align: center;\n    color: #666666;\n    font-size: 16px; }\n    gather-box .gather-modal .content .gather-loading .license-loading-text {\n      margin-top: 5px; }\n\n/* Small Devices, Mobile */\n@media only screen and (max-width: 767px) {\n  gather-box {\n    margin-right: 5px; }\n  gather-box .gather-modal .modal .modal-footer {\n    padding: 4px 12px; }\n  gather-box .gather-modal .modal .gather-modal-tip {\n    top: 0;\n    z-index: 2;\n    display: none; }\n  original .original .right-cont .actionbar.with-iphone .clearfix.gather-wrapper {\n    margin-right: 100px;\n    float: none;\n    display: block;\n    padding-left: 10px; }\n    original .original .right-cont .actionbar.with-iphone .clearfix.gather-wrapper > .pull-left {\n      float: right; }\n  gather-box .gather-modal .modal .header .close {\n    right: 0;\n    top: 0;\n    color: #999999;\n    font-size: 16px;\n    line-height: 36px;\n    z-index: 4; }\n  gather-box .gather-modal .content .articles .item.first .cont .img {\n    width: 100%;\n    height: 100%; }\n  gather-box .gather-modal .content .articles .item .mask .ybicon {\n    margin: 15px 15px 0; }\n  original .original .right-cont .actionbar.with-iphone .btn {\n    padding: 9px 7px !important; }\n    original .original .right-cont .actionbar.with-iphone .btn.add-gather-btn {\n      margin: 0 12px 0 0 !important;\n      float: left; } }\n", ""]);

// exports


/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by ganlu on 25/09/2016.
 */
var MessageService = function () {
    MessageService.$inject = ['$timeout'];

    function MessageService($timeout) {
        "ngInject";

        (0, _classCallCheck3.default)(this, MessageService);
        this.$timeout = $timeout;
    }

    (0, _createClass3.default)(MessageService, [{
        key: 'success',
        value: function success(message) {
            this.clear();
            $('.gather-modal-tip').addClass('success');
            this.show(message, 3000);
        }
    }, {
        key: 'error',
        value: function error(message, period) {
            this.clear();
            $('.gather-modal-tip').addClass('error');

            var p = typeof period == 'undefined' ? 3000 : period;

            this.show(message, p);
        }
    }, {
        key: 'info',
        value: function info(message) {
            this.clear();
            $('.gather-modal-tip').addClass('info');
            this.show(message, 0);
        }
    }, {
        key: 'warn',
        value: function warn(message, period) {
            this.clear();
            $('#alert-message').addClass('warn');

            var p = typeof period == 'undefined' ? 3000 : period;

            this.show(message, p);
        }
    }, {
        key: 'clear',
        value: function clear() {
            $('.gather-modal-tip').removeClass('error').removeClass('success').removeClass('info');
        }
    }, {
        key: 'show',
        value: function show(message, period) {

            $('.gather-modal-tip').html(message).show();

            if (period != 0) {
                this.$timeout(function () {
                    $('.gather-modal-tip').hide();
                }, period);
            }
        }
    }, {
        key: 'hide',
        value: function hide() {
            $('.gather-modal-tip').hide();
        }
    }]);
    return MessageService;
}();

exports.default = MessageService;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * Created by ganlu on 02/12/2016.
 */
exports.default = ["getReproductionService", function (getReproductionService) {

    "ngInject";

    return function (scope, elem, attrs) {

        elem.on('copy cut', function (e) {
            if (!scope.copyAuthorized) {
                getReproductionService.get();
                e.preventDefault();
            }
        });
    };
}];

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _originalImage = __webpack_require__(1064);

var _originalImage2 = _interopRequireDefault(_originalImage);

__webpack_require__(113);

var _fancyboxPlus = __webpack_require__(112);

var _fancyboxPlus2 = _interopRequireDefault(_fancyboxPlus);

var _publishToMedia = __webpack_require__(181);

var _publishToMedia2 = _interopRequireDefault(_publishToMedia);

var _originalImageFallback = __webpack_require__(1070);

var _originalImageFallback2 = _interopRequireDefault(_originalImageFallback);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var originalImageModule = _angular2.default.module('originalImage', ['ngFilesizeFilter', _fancyboxPlus2.default, _publishToMedia2.default]).component('originalImage', _originalImage2.default).directive('originalImageFallback', _originalImageFallback2.default).name;

var states = [{
    name: 'image',
    url: '/image/{id}?action',
    template: '<original-image set-error="$ctrl.setError(error)" set-reproduction="$ctrl.setReproduction(reproduction)" set-show-reproduction-detail="$ctrl.setShowReproductionDetail(show)" share-to-weixin="$ctrl.shareToWeixin(url)" app-user="$ctrl.appUser"></original-image>'
}, {
    name: 'imageHash',
    url: '/image/hash/{hash}',
    template: '<original-image set-error="$ctrl.setError(error)" set-reproduction="$ctrl.setReproduction(reproduction)" set-show-reproduction-detail="$ctrl.setShowReproductionDetail(show)" share-to-weixin="$ctrl.shareToWeixin(url)" app-user="$ctrl.appUser"></original-image>'
}, {
    name: 'imageReproduction',
    url: '/image/reproduction/{reproduction}',
    template: '<original-image set-error="$ctrl.setError(error)" set-reproduction="$ctrl.setReproduction(reproduction)" set-show-reproduction-detail="$ctrl.setShowReproductionDetail(show)" share-to-weixin="$ctrl.shareToWeixin(url)" app-user="$ctrl.appUser"></original-image>'
}];

exports.default = { name: originalImageModule, states: states };

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _originalImage = __webpack_require__(1065);

var _originalImage2 = _interopRequireDefault(_originalImage);

var _originalImage3 = __webpack_require__(1067);

var _originalImage4 = _interopRequireDefault(_originalImage3);

__webpack_require__(1068);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var originalImageComponent = {
    restrict: 'E',
    bindings: {
        'image': '=',
        'appUser': '=',
        'setError': '&',
        'setReproduction': '&',
        'setShowReproductionDetail': '&',
        'shareToWeixin': '&',
        'hideBottomBar': '='
    },
    template: _originalImage2.default,
    controller: _originalImage4.default
};

exports.default = originalImageComponent;

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<div ng-class=\"{'original-image':true,'hide':$ctrl.loading}\" class=\"clearfix block\">\n    <div class=\"col-8 left-cont\">\n        <div class=\"cont\">\n            <!--<div class=\"position\">图片详情</div>-->\n            <div class=\"block-content\">\n                <div class=\"title\">{{ image.title }}</div>\n                <div class=\"author-info\">\n                    <a ui-sref=\"app.page.author({id: image.uuid})\" target=\"_blank\" class=\"link\">{{ image.author_name\n                        }}</a> &nbsp;\n                    {{ image.created_at * 1000 | date : 'yyyy-MM-dd HH:mm' }}\n                </div>\n                <div class=\"content\">\n                    <a class=\"image\" ng-href=\"{{ image.web_url }}\" fancyboxable=\"fancyboxOptions\"\n                       ng-if=\"!imageUnavailable\">\n                        <img ng-src=\"{{ image.web_url }}\" original-image-fallback/>\n                    </a>\n                    <div class=\"image-placeholder\" ng-if=\"imageUnavailable\">{{'page-original-text062' | translate}}</div>\n                    <div class=\"tags\" ng-if=\"image.tags.length\">\n                        <span>{{'page-original-text063' | translate}}：</span>\n                        <span class=\"tag\" ng-repeat=\"tag in image.tags track by $index\">{{tag}}</span>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div ng-if=\"image && !$ctrl.isCC0 && $ctrl.userInfo.isAuthor(image) && $ctrl.checkEditor()\" class=\"icon-box\">\n            <div class=\"delete\" title=\"{{'page-original-text064' | translate}}\" ng-click=\"$ctrl.removeDialog.show(image,$event)\">\n                <span class=\"ybicon yb-delete\"></span>\n                <span>{{'page-original-text065' | translate}}</span>\n            </div>\n        </div>\n\n        <div class=\"recommendImg\">\n           <div class=\"title\">作品系列推荐</div>\n           <div class=\"list_box\">\n              <span class=\"left_button\" ng-click=\"$ctrl.changeShowImgPage('pre')\" ng-if=\"$ctrl.showImgIndex > 1\"> <i class=\"ybicon yb-last\" ></i> </span>\n              <ul>\n                 <li ng-repeat=\"item in $ctrl.showImgList\" ui-sref=\"app.page.original.image({'id': item.yuanben_id})\">\n                    <img src=\"{{item.image_url}}\" alt=\"\">\n                    <div class=\"img_name\">{{item.title}}</div>\n                 </li>\n              </ul>\n              <span class=\"right_button\"  ng-click=\"$ctrl.changeShowImgPage('next')\" ng-if=\"$ctrl.showImgIndex < 2\"> <i class=\"ybicon yb-next\"></i> </span>\n           </div>\n        </div>\n\n\n\n\n    </div>\n    \n    <div class=\"col-4 right-cont \">\n        <div class=\"author clearfix\" ng-if=\"!$ctrl.isCC0\">\n            <div class=\"author-face pull-left\">\n                <a ui-sref=\"app.page.author({id: image.uuid})\" target=\"_blank\">\n                    <img class=\"img\" ng-src=\"{{ image.user.avatar }}\" alt=\"\">\n                </a>\n            </div>\n            <div class=\"author-info\">\n                <div class=\"pseudonym clearfix\">\n                    <a class=\"pseudonym-title\" ui-sref=\"app.page.author({id: image.uuid})\" target=\"_blank\">\n                        {{image.user.pseudonym}}\n                    </a>\n                    <div class=\"pseudonym_authentication\"><img class=\"authentication\" ng-if=\"image.user.name_verified\" width=\"50\" height=\"16\" src=\"" + __webpack_require__(1066) + "\" alt=\"\"></div>\n                </div>\n                <div class=\"introduction\">{{image.user.introduction}}</div>\n            </div>\n        </div>\n        <div class=\"license-dna\" ng-if=\"!image.locked && !image.user.locked && image.license.type != 'none'\">\n            <div class=\"license\">\n                <div class=\"title\" ng-if=\"$ctrl.isCC0\">{{'page-original-text003' | translate}}</div>\n                <license license=\"image.license\" dna=\"image.short_id\"></license>\n            </div>\n        </div>\n        <div class=\"actionbar with-iphone\"\n             ng-if=\"image && !image.locked && !image.user.locked && image.license.type != 'none' && !imageUnavailable && !$ctrl.hideBottomBar\">\n            <!--图片作者 或者 已经获取授权-->\n            <div ng-if=\"$ctrl.userInfo.isOriginalOwner(image, $ctrl.imageReproduction)\">\n                <publish-to-media original=\"image\" original-type=\"image\" class=\"publish-to-media\"></publish-to-media>\n                <div class=\"clearfix\">\n                    <a ng-href=\"{{ image.image_url }}\" class=\"btn btn-default btn-md download-img pull-left\"\n                       ng-class=\"{two:!(image.license.type=='cm' || $ctrl.userInfo.isAuthor(image))}\"\n                       target=\"_blank\">{{'page-original-text066' | translate}}</a>\n                    <a ng-href=\"{{ image.store_url }}\" class=\"btn btn-default btn-md download-img pull-right\"\n                       target=\"_blank\"\n                       ng-if=\"image.license.type=='cm' || $ctrl.userInfo.isAuthor(image)\">{{'page-original-text067' | translate}}</a>\n                </div>\n            </div>\n            <!--非图片作者或者 未授权-->\n            <div ng-if=\"!$ctrl.isCC0 && !$ctrl.userInfo.isOriginalOwner(image, $ctrl.imageReproduction)\">\n                <div class=\"unlogined-reproduction\" ng-if=\"$ctrl.$stateParams.reproduction && $ctrl.userInfo.isGuest()\">\n                    {{'page-original-text025' | translate}}\n                </div>\n                <div class=\"get-reproduction\" ng-if=\"$ctrl.$stateParams.reproduction && !$ctrl.userInfo.isGuest()\">\n                    <get-reproduction action=\"$ctrl.get()\" original=\"image\" type=\"image\"\n                                      app-user=\"$ctrl.appUser\"></get-reproduction>\n                    <button type=\"button\" class=\"btn btn-default btn-md item pull-left add-store-btn\"\n                            ng-disabled=\"$ctrl.collection_loading\" ng-click=\"$ctrl.collection(image)\">\n                        {{$ctrl.collection_text()}}\n                    </button>\n                </div>\n\n                <div class=\"get-reproduction\" ng-if=\"$ctrl.$stateParams.id\">\n                    <get-reproduction action=\"$ctrl.get()\" original=\"image\" type=\"image\"\n                                      app-user=\"$ctrl.appUser\"></get-reproduction>\n                    <button type=\"button\" class=\"btn btn-default btn-md item pull-left add-store-btn\"\n                            ng-disabled=\"$ctrl.collection_loading\" ng-click=\"$ctrl.collection(image)\">\n                        {{$ctrl.collection_text()}}\n                    </button>\n                </div>\n            </div>\n\n            <!--cc0-->\n            <div class=\"cc0-btn-box clearfix\" ng-if=\"$ctrl.isCC0\">\n                <button type=\"button\" class=\"btn btn-default btn-md add-store-btn\"\n                        ng-disabled=\"$ctrl.collection_loading\" ng-click=\"$ctrl.collection(image)\">\n                    {{$ctrl.collection_text()}}\n                </button>\n                <a ng-href=\"{{ image.image_url }}\" class=\"btn btn-default btn-md download-img pull-left\"\n                   download>{{'page-original-text066' | translate}}</a>\n                <a ng-href=\"{{ image.store_url }}\" class=\"btn btn-default btn-md download-img pull-right\"\n                   download>{{'page-original-text067' | translate}}</a>\n            </div>\n        </div>\n\n        <div class=\"info\" ng-if=\"image\">\n            <div class=\"title\">{{'page-original-text015' | translate}}</div>\n            <div class=\"item clearfix\" ng-if=\"!$ctrl.isCC0\">\n                <div class=\"name\">{{'page-original-text068' | translate}}</div>\n                <div class=\"value\">\n                    <a ui-sref=\"app.page.author({id: image.uuid})\" target=\"_blank\" class=\"link\">{{ image.author_name}}</a>\n                </div>\n            </div>\n            <div class=\"item clearfix\" ng-if=\"$ctrl.appUser.type==1&&image.op_user_name\">\n                <div class=\"name\">{{'page-original-Operator' | translate}}</div>\n                <div class=\"value\">\n                     {{ image.op_user_name}}\n                </div>\n            </div>\n            <div class=\"item clearfix\">\n                <div class=\"name\">{{'page-original-text028' | translate}}</div>\n                <div class=\"value\">\n                    {{ image.created_at * 1000 | date : 'yyyy-MM-dd HH:mm' }}\n                </div>\n            </div>\n            <div class=\"item clearfix\">\n                <div class=\"name\">{{'page-original-text069' | translate}}</div>\n                <div class=\"value\">\n                    {{ image.image_width }} x {{ image.image_height }}\n                </div>\n            </div>\n            <div class=\"item clearfix\">\n                <div class=\"name\">{{'page-original-text070' | translate}}</div>\n                <div class=\"value\">\n                    {{ image.file_size | filesize }}\n                </div>\n            </div>\n            <div class=\"item clearfix\">\n                <div class=\"name\">{{'page-original-text071' | translate}}</div>\n                <div class=\"value\">\n                    {{ image.image_format }}\n                </div>\n            </div>\n            <div class=\"item clearfix\" ng-if=\"$ctrl.isCC0\">\n                <div class=\"name\">{{'page-original-text072' | translate}}</div>\n                <div class=\"value\">\n                    <a href=\"{{ image.original }}\" class=\"link\" target=\"_blank\">{{ image.original }}</a>\n                </div>\n            </div>\n            <div class=\"item clearfix\">\n                <div class=\"name\">{{'page-original-text029' | translate}}</div>\n                <div class=\"value\">\n                    <a href=\"{{ image.chain_server_url }}\" class=\"link\"\n                       target=\"_blank\">{{ image.block_hash }}</a>\n                </div>\n            </div>\n            <div class=\"item clearfix\">\n               <div class=\"name\">图片描述</div>\n                <div class=\"value\"> <span>{{image.description}}</span> </div>\n            </div>\n\n            <div class=\"actions\" ng-if=\"!$ctrl.isCC0\">\n                <a ng-if=\"!$ctrl.userInfo.isGuest()\" ui-sref=\"app.page.evidence.image({id: image.id})\"\n                   class=\"btn btn-default btn-md\">{{'page-original-text030' | translate}} &#62</a>\n                <a ng-if=\"$ctrl.userInfo.isGuest()\" ui-sref=\"app.page.evidence.image({id: image.yuanben_id})\"\n                   class=\"btn btn-default btn-md\">{{'page-original-text030' | translate}} &#62</a>\n            </div>\n        </div>\n\n    </div>\n</div>\n\n<dialog-modal text=\"{{$ctrl.removeDialog.text}}\"\n              position=\"$ctrl.removeDialog.position\"\n              is-active=\"$ctrl.removeDialog.isActive\"\n              sure=\"$ctrl.removeDialog.sure()\"></dialog-modal>\n";

/***/ }),
/* 1066 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGMAAAAhCAMAAAD6deXAAAAAnFBMVEVMaXGPwx+Pwx+Pwx+Pwx+Pwx+Pwx+Pwx+Pwx+Pwx+Pwx+Pwx+Pwx+Pwx+Pwx+Pwx+Pwx+Pwx+Pwx+Pwx+Pwx+Pwx+Pwx////+Pwx/H4Y+r0lfj8Mir0lbV6aydyzv4+/K52nPA3YGWxy2Wxyzq9Nbx9+PO5Z34+/Gkzknx+OTV6Ku52XLj8Medyjrc7Lnq9NWy1mWy1mSkzkjc7Lr5ODBVAAAAF3RSTlMAgBCQMODQQPDAoFBgcCD27bDr7/fi7hrsiHwAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAMCSURBVEjHtZdrQ+owDIa5Cyp49FySbqzdDRhDQPT//7fTppe12/TLNJ+60uVZ0rxtGI0am62fV4i4el7PRj9jjwtsbPH4A4S7OYa2xCG2WI07uRj3rBtGkZyHAHFvpresfq3Z1jz9GgjB1aSNKNgBtB1Y8T2QpUvYmp5virDbswtRbjT350sPPC5bM3lZ8l7Ihp72yvVFff87hcPMqjQOLfU8Ht0qYx8QtyPZEENpAjNKkk6RHmdq+IIMQlNeI2N7OJpRTi8mAKX7GLsnVLW02fT+q9l57W3bk56IGNCxSCOEBQgA+8qD3fBdD2Onxn/7GSywmBgSUdkEA7icLiRDyeAEPQw4yfETagctBvIjy/VIGpNL8lgi9uQ5TzwE4kyn6mK86smbebrQUw+DMXwTcJR+QNAs45WAsnoj31UJ4s2LfUyFW9i0vjclZkvgXwxZ5CxzlaQ+NkNXR1x85JQjJt8OC3hFp4hNDtSkRStF2vV53K0rxDLhGCV5w0DuSlK0CnoeMigQF4ZlJM3uJprBjwCSglWoB74Xej40KivHeFVes12L4e0HZ+YhlfuhtuejUWRKEbsP8hheHPXZHo3XzxieyBUt846DtmQaqRPjTEeUr7malp17GHkSRV0NximIpGz8ymr09vzBSvDmeyp2VoTYYkQQV1bNRyfsPUaBX388HU20iOAapuLkSqjFSCFxOKkJT2ufMeRhoq7x88Fq3JpM3+FMh2IMvqDkiZGZpMn6k+Wl9f4FY6l6BRNItvWtNmE8yZ9E2ohQOqZDqUoEiAy5VKKw1SojdtbszVgdvNQtXDvbeDV3OhfhfII8S45ghaAokFSa0VNXS7pvKZCiDbkWOgylCd9k4uSxBGXmpMZlSOmncZjGgS6p4hIg6EbE3/2XbJaGWuZ6i1JPd3Y8Nff5RPdWJ6dv2J2+pftBvG+aUOPsVJMsak2gRA1rS/xuc7boWTG483neBE3cZNpZ8TIMMJ9uug3vKmzx1neDbNLfVs+mNmOL6U/9OaBolH230/+oHAT/TWr4jwAAAABJRU5ErkJggg=="

/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = __webpack_require__(49);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageController = function () {
    ImageController.$inject = ['$scope', '$state', 'userInfo', '$filter', 'CollectionAPI', '$stateParams', 'QueryAPI', '$sce', 'pageTitle', 'ImgDetailRecommendListApi', 'message', 'modal', 'AppConfig', 'fancyboxService', '$transitions', 'ImageAPI', 'Jurisdiction'];

    function ImageController($scope, $state, userInfo, $filter, CollectionAPI, $stateParams, QueryAPI, $sce, pageTitle, ImgDetailRecommendListApi, message, modal, AppConfig, fancyboxService, $transitions, ImageAPI, Jurisdiction) {
        "ngInject";

        var _this = this;

        (0, _classCallCheck3.default)(this, ImageController);
        this.$stateParams = $stateParams;
        this.Jurisdiction = Jurisdiction;
        this.QueryAPI = QueryAPI;
        this.$sce = $sce;
        this.pageTitle = pageTitle;
        this.userInfo = userInfo;
        this.$scope = $scope;
        this.message = message;
        this.modal = modal;
        this.AppConfig = AppConfig;
        this.loading = true;
        this.$state = $state;
        this.ImageAPI = ImageAPI;
        this.CollectionAPI = CollectionAPI;
        this.ImgDetailRecommendListApi = ImgDetailRecommendListApi;
        this.collectionActive = false;
        this.tranlsteFilter = $filter('translate');

        this.imgListTotal = 0;
        this.showImgIndex = 1;
        this.showImgList = [];

        this.isCC0 = false;

        $scope.fancyboxOptions = fancyboxService.getOptions();

        $scope.setImageUnavailable = function () {
            $scope.imageUnavailable = true;
        };
        this.userInfo.setUser(this.appUser);

        var self = this;
        $transitions.onSuccess({
            to: function to(state) {
                return state.name == 'app.page.original.image' || state.name == 'app.page.original.imageHash' || state.name == 'app.page.original.imageReproduction';
            }
        }, function () {
            self.init();
        });
        this.removeDialog = {
            text: self.tranlsteFilter('page-original-text073'),
            sure: function sure() {
                _this.deleteImage(_this.removeDialog.original);
            },
            show: function show(original, event) {
                event.stopPropagation();
                _this.removeDialog.original = original;
                _this.removeDialog.text = self.tranlsteFilter('page-original-text074') + original.title + '" ?';
                _this.removeDialog.isActive = true;
            }
        };
        this.init();
        this.changeShowImgPage("pre");

        //   console.log($stateParams)
    }

    (0, _createClass3.default)(ImageController, [{
        key: 'init',
        value: function init() {

            this.$scope.imageUnavailable = false;
            this.$scope.publicKeyHtml = '';

            this.showReproductionDetail = false;
            this.imageReproduction = null;

            this.$scope.image = null;

            this.setShowReproductionDetail({ 'show': false });
            this.setReproduction({ 'reproduction': null });

            if (this.image) {
                this.loadImage(this.image);
            } else {

                var api = null;

                if (this.$stateParams.id) {
                    api = this.QueryAPI.one().get({ 'id': this.$stateParams.id, 'type': 'image' });
                } else if (this.$stateParams.hash) {
                    api = this.QueryAPI.one('hash').get({ 'hash': this.$stateParams.hash, 'type': 'image' });
                } else if (this.$stateParams.reproduction) {
                    api = this.QueryAPI.one('reproduction').get({ 'id': this.$stateParams.reproduction, 'type': 'image' });
                } else {
                    this.setError({ 'error': true });
                    return;
                }

                var self = this;

                api.then(function (image) {
                    self.loadImage(image);
                }, function () {
                    self.loading = false;
                    self.setError({ 'error': true });
                });
            }
        }
    }, {
        key: 'loadImage',
        value: function loadImage(image) {
            var self = this;

            if (!image.license) {
                image.user = {};
                image.locked = 0;
                image.title = self.tranlsteFilter('page-original-text075');
                image.license = { type: "cc0", content: { adaptation: "y", commercial: "y" } };
                self.isCC0 = true;
            }
            self.$scope.image = image;

            self.$scope.publicKeyHtml = self.$sce.trustAsHtml(image.public_key && image.public_key.replace(/\n/g, "<br/>"));

            self.pageTitle.setTitle(image.title + ' ' + image.author_name);

            if (image.reproduction) {
                // Comes from reproduction url
                // Display reproduction
                image.reproduction.author_name = image.author_name;
                image.reproduction.license = image.license;
                self.showReproductionDetail = true;
                self.setShowReproductionDetail({ 'show': true });
                self.setReproduction({ 'reproduction': image.reproduction });
                self.imageReproduction = image.reproduction;
                self.loading = false;
                self.pageLoaded();
            } else {
                self.loadReproduction();
            }

            //获取用户是否已经收藏
            if (!this.userInfo.isGuest()) {
                this.collectionInfo(image);
            }
        }
    }, {
        key: 'loadReproduction',
        value: function loadReproduction() {

            var self = this;
            if (!this.userInfo.isGuest()) {
                if (this.$scope.image.license.type) {
                    this.QueryAPI.one().one('image', this.$scope.image.id).one('reproduction').get().then(function (reproduction) {
                        if (reproduction && reproduction.id) {
                            self.showReproductionDetail = false;
                            self.setShowReproductionDetail({ 'show': false });
                            self.setReproduction({ 'reproduction': reproduction });
                            self.imageReproduction = reproduction;
                        }
                        self.pageLoaded();
                    }, function (response) {
                        self.pageLoaded();
                        self.message.error(response.data);
                    });
                } else {
                    this.pageLoaded();
                }
            } else {
                this.pageLoaded();
            }
        }
    }, {
        key: 'pageLoaded',
        value: function pageLoaded() {
            this.loading = false;

            if (this.$scope.image.locked || this.$scope.image.user.locked) {
                this.message.error(this.tranlsteFilter('page-original-text037'), 0);
            }
        }
    }, {
        key: 'get',
        value: function get() {
            window.location = this.$scope.image.image_url;
        }
    }, {
        key: 'showWeixinShare',
        value: function showWeixinShare() {
            var url = this.AppConfig.server_url + '/original/qrcode?type=image&id=' + this.$scope.image.id;
            this.shareToWeixin({ url: url });
        }
    }, {
        key: 'deleteImage',
        value: function deleteImage(image) {

            var self = this;

            self.loading = true;

            this.ImageAPI.one(image.id).remove().then(function (res) {
                if (res.status.code == 200) {
                    self.appUser.image_count--;
                    self.message.success(self.tranlsteFilter('page-original-text076'));
                    self.$state.go('app.page.author', { id: image.uuid });
                } else if (res.status.code == 422) {
                    if (res.status.message == 'Authorized') {
                        self.message.error(self.tranlsteFilter('page-original-text077'));
                    } else {
                        self.message.error(self.tranlsteFilter('page-original-text040'));
                    }
                }
                self.loading = false;
            }, function (response) {
                self.loading = false;
                self.message.error(response.data);
            });
        }
        //获取收藏属性

    }, {
        key: 'collectionInfo',
        value: function collectionInfo(image) {
            var self = this;
            this.CollectionAPI.one().get({ 'resource_type_id': self.isCC0 ? 3 : 2, 'resource_id': image.id }).then(function (res) {
                self.collectionActive = res.data.active;
            }, function () {
                // self.loading = false;
                // self.setError({'error': true});
            });
        }
    }, {
        key: 'collection',
        value: function collection(image) {
            if (this.userInfo.isGuest()) {
                this.$state.go('app.face.index.user.form.login');
                return;
            }
            var self = this;
            self.collection_loading = true;
            var api = this.CollectionAPI;
            if (self.collectionActive) {
                api.one().remove({ 'resource_type_id': self.isCC0 ? 3 : 2, 'resource_id': image.id }).then(function () {
                    self.collection_loading = false;
                    self.message.success(self.tranlsteFilter('page-original-text041'));
                    self.collectionActive = false;
                }, function (response) {
                    self.collection_loading = false;
                    self.message.error(response.data);
                });
            } else {
                api.post({ 'resource_type_id': self.isCC0 ? 3 : 2, 'resource_id': image.id }).then(function () {
                    self.collection_loading = false;
                    self.message.success(self.tranlsteFilter('page-original-text042'));
                    self.collectionActive = true;
                }, function (response) {
                    self.collection_loading = false;
                    self.message.error(response.data);
                });
            }
        }
    }, {
        key: 'collection_text',
        value: function collection_text() {
            var self = this;
            if (self.collection_loading) {
                return self.tranlsteFilter('page-original-text043');
            } else {
                if (self.collectionActive) {
                    return self.tranlsteFilter('page-original-text044');
                } else {
                    return self.tranlsteFilter('page-original-text045');
                }
            }
        }
    }, {
        key: 'checkEditor',
        value: function checkEditor() {
            this.permission = JSON.parse(window.localStorage.getItem("loginUser"));

            var param = (0, _assign2.default)(this.permission);
            return this.Jurisdiction.checkStatusShow(param);
        }
    }, {
        key: 'changeShowImgPage',
        value: function changeShowImgPage(type) {

            switch (type) {
                case "pre":
                    this.showImgIndex--;break;
                case "next":
                    this.showImgIndex++;break;
            }
            if (this.showImgIndex <= 1) {
                this.showImgIndex = 1;
            }
            if (this.imgListTotal == 0) {
                this.showImgIndex = 1;
            }

            // if(this.showImgIndex * 4  >=  this.imgListTotal){
            //    this.showImgIndex=  this.imgListTotal
            // }

            this.getRecommendImgList();
        }
    }, {
        key: 'getRecommendImgList',
        value: function getRecommendImgList() {
            var _this2 = this;

            var params = {
                page: this.showImgIndex,
                page_size: 4,
                id: this.$stateParams.id //imgId
            };

            this.ImgDetailRecommendListApi.get("", params).then(function (res) {
                _this2.showImgList = res.recommends;
                _this2.imgListTotal = res.recommends.length;
            });
        }
    }]);
    return ImageController;
}();

exports.default = ImageController;

/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1069);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./original-image.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./original-image.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "original-image .hide {\n  display: none !important; }\n\noriginal-image .original-image {\n  position: relative; }\n  original-image .original-image .cont .block-content {\n    margin-top: 40px; }\n    original-image .original-image .cont .block-content .title {\n      font-size: 24px;\n      font-weight: bold;\n      color: #222222;\n      line-height: 1.4;\n      word-break: break-all; }\n    original-image .original-image .cont .block-content .author-info {\n      font-size: 14px;\n      color: #999999;\n      margin: 10px 0 30px; }\n      original-image .original-image .cont .block-content .author-info .link {\n        text-decoration: none;\n        color: #999999; }\n        original-image .original-image .cont .block-content .author-info .link:hover {\n          color: #00816a; }\n    original-image .original-image .cont .block-content .content .image {\n      position: relative;\n      display: block;\n      margin-top: 26px; }\n      original-image .original-image .cont .block-content .content .image img {\n        display: block;\n        max-width: 100% !important;\n        margin: 0 auto; }\n    original-image .original-image .cont .block-content .content .image-placeholder {\n      position: relative;\n      margin-top: 26px;\n      height: 400px;\n      line-height: 400px;\n      text-align: center;\n      font-size: 12px;\n      color: #999999;\n      background-color: #f5f5f5; }\n    original-image .original-image .cont .block-content .tags {\n      font-size: 0;\n      color: #999999;\n      margin-top: 20px;\n      line-height: 22px; }\n      original-image .original-image .cont .block-content .tags span {\n        font-size: 12px; }\n      original-image .original-image .cont .block-content .tags .tag {\n        display: inline-block;\n        background: #fbfbfb;\n        font-size: 12px;\n        border: 1px solid #dadedd;\n        border-radius: 11px;\n        margin-left: 5px;\n        padding: 0 10px; }\n  original-image .original-image .left-cont .icon-box {\n    display: inline-block;\n    margin-top: 50px;\n    color: #cccccc;\n    font-size: 12px;\n    cursor: pointer; }\n    original-image .original-image .left-cont .icon-box:hover {\n      color: #666666; }\n  original-image .original-image .left-cont .recommendImg {\n    height: 208px; }\n    original-image .original-image .left-cont .recommendImg .title {\n      margin: 85px 0  15px 0; }\n    original-image .original-image .left-cont .recommendImg .list_box {\n      position: relative;\n      cursor: pointer; }\n      original-image .original-image .left-cont .recommendImg .list_box .left_button {\n        left: -30px; }\n      original-image .original-image .left-cont .recommendImg .list_box .right_button {\n        right: -30px; }\n      original-image .original-image .left-cont .recommendImg .list_box > span {\n        position: absolute;\n        top: 0%;\n        padding-top: 5%;\n        display: none;\n        height: 100%; }\n        original-image .original-image .left-cont .recommendImg .list_box > span i {\n          font-size: 30px;\n          color: #dddddd; }\n      original-image .original-image .left-cont .recommendImg .list_box:hover span {\n        display: block; }\n      original-image .original-image .left-cont .recommendImg .list_box ul {\n        overflow: hidden;\n        width: 100%;\n        padding: 0; }\n        original-image .original-image .left-cont .recommendImg .list_box ul li {\n          width: 137px;\n          height: 123px;\n          list-style: none;\n          float: left;\n          margin-right: 15px;\n          margin-bottom: 19px; }\n          original-image .original-image .left-cont .recommendImg .list_box ul li img {\n            width: 100%;\n            height: 83px;\n            border-radius: 4px;\n            border: 1px solid #e3e3e3;\n            float: left; }\n          original-image .original-image .left-cont .recommendImg .list_box ul li .img_name {\n            width: 100%;\n            height: 30px;\n            line-height: 30px;\n            color: \"#2a2a2a\";\n            font-size: 14px;\n            padding: 5px 10px;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            white-space: nowrap; }\n          original-image .original-image .left-cont .recommendImg .list_box ul li:last-child {\n            margin-right: 0; }\n  original-image .original-image .right-cont {\n    padding: 0 24px; }\n    original-image .original-image .right-cont .author {\n      text-align: center;\n      padding: 45px 0;\n      border-bottom: 1px solid #e8eaea; }\n      original-image .original-image .right-cont .author .author-face {\n        margin: 0 auto;\n        width: 64px;\n        height: 64px;\n        padding: 3px;\n        border-radius: 4px;\n        position: relative;\n        float: none;\n        border: 1px solid #e8eaea;\n        font-size: 12px; }\n        original-image .original-image .right-cont .author .author-face .img {\n          width: 100%;\n          height: 100%;\n          display: block; }\n      original-image .original-image .right-cont .author .author-info .pseudonym {\n        font-size: 16px;\n        font-weight: bold;\n        margin-top: 8px;\n        line-height: 1.4; }\n        original-image .original-image .right-cont .author .author-info .pseudonym .pseudonym-title {\n          max-width: 150px;\n          padding-right: 5px;\n          font-size: 16px;\n          color: #222222;\n          text-decoration: none;\n          vertical-align: middle;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          white-space: nowrap; }\n        original-image .original-image .right-cont .author .author-info .pseudonym .authentication {\n          margin-top: 3px;\n          vertical-align: middle; }\n      original-image .original-image .right-cont .author .author-info .introduction {\n        color: #999999;\n        font-size: 14px;\n        margin-top: 5px;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap; }\n      original-image .original-image .right-cont .author .author-info .btn {\n        margin-top: 10px;\n        font-size: 12px; }\n    original-image .original-image .right-cont .license-dna .title {\n      font-size: 14px;\n      border-bottom: 1px solid #e8eaea;\n      margin: 10px 0;\n      padding: 10px 0; }\n    original-image .original-image .right-cont .actionbar {\n      margin-top: 30px; }\n      original-image .original-image .right-cont .actionbar .publish-to-media {\n        display: block;\n        margin-bottom: 15px; }\n        original-image .original-image .right-cont .actionbar .publish-to-media > .btn {\n          width: 100%; }\n      original-image .original-image .right-cont .actionbar .download-img {\n        width: 45%; }\n        original-image .original-image .right-cont .actionbar .download-img.two {\n          width: 100%; }\n      original-image .original-image .right-cont .actionbar .unlogined-reproduction {\n        font-size: 14px;\n        color: red;\n        text-align: center;\n        line-height: 2; }\n      original-image .original-image .right-cont .actionbar .fee-con {\n        margin-left: 28px;\n        float: left;\n        color: #00816a; }\n        original-image .original-image .right-cont .actionbar .fee-con p {\n          margin: 0 0 5px;\n          font-size: 12px; }\n        original-image .original-image .right-cont .actionbar .fee-con h4 {\n          margin: 0;\n          font-size: 18px; }\n          original-image .original-image .right-cont .actionbar .fee-con h4.fee {\n            text-align: center; }\n      original-image .original-image .right-cont .actionbar .get-reproduction {\n        height: 90px; }\n        original-image .original-image .right-cont .actionbar .get-reproduction get-reproduction > .btn {\n          width: 100%; }\n        original-image .original-image .right-cont .actionbar .get-reproduction .add-store-btn {\n          width: 100%;\n          margin-top: 10px; }\n          original-image .original-image .right-cont .actionbar .get-reproduction .add-store-btn:disabled {\n            cursor: not-allowed;\n            background: #f5f5f5; }\n      original-image .original-image .right-cont .actionbar .gather-wrapper .en.btn {\n        display: block;\n        float: none;\n        width: 100%;\n        margin-bottom: 12px; }\n    original-image .original-image .right-cont .info {\n      margin-top: 30px;\n      font-size: 12px; }\n      original-image .original-image .right-cont .info .title {\n        font-size: 14px;\n        border-bottom: 1px solid #e8eaea;\n        margin: 10px 0;\n        padding: 10px 0; }\n      original-image .original-image .right-cont .info .item {\n        padding: 8px 0; }\n        original-image .original-image .right-cont .info .item .name {\n          width: 70px;\n          float: left; }\n        original-image .original-image .right-cont .info .item .value {\n          width: 100%;\n          padding-left: 70px; }\n          original-image .original-image .right-cont .info .item .value .link {\n            color: #4477b0;\n            max-width: 100%;\n            display: inline-block;\n            text-decoration: underline;\n            cursor: pointer;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            white-space: nowrap; }\n      original-image .original-image .right-cont .info .actions {\n        margin-top: 20px;\n        margin-bottom: 20px; }\n        original-image .original-image .right-cont .info .actions .btn {\n          width: 100%; }\n\noriginal-image .cc0-btn-box .btn {\n  display: block;\n  width: 100%;\n  margin-bottom: 10px; }\n\n@media only screen and (max-width: 767px) {\n  original-image .original-image .cont .block-content {\n    margin-top: 0;\n    padding-top: 30px; }\n  original .original .left-cont .delete {\n    margin-top: 30px; }\n  original-image .cc0-btn-box .btn {\n    float: right;\n    width: auto;\n    margin-right: 10px; }\n  .original-image .right-cont .actionbar .download-img {\n    margin-left: 0 !important;\n    width: 100px !important; }\n  .original-image .right-cont .actionbar .get-reproduction .add-store-btn {\n    width: 100px !important;\n    margin-top: 0 !important; } }\n", ""]);

// exports


/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

/**
 * Created by ganlu on 20/01/2017.
 */
exports.default = function () {
    return function (scope, element) {
        element.on('error', function () {
            scope.$apply(function () {
                scope.setImageUnavailable();
            });
        });
    };
};

/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _getReproduction = __webpack_require__(1072);

var _getReproduction2 = _interopRequireDefault(_getReproduction);

var _getReproduction3 = __webpack_require__(1078);

var _getReproduction4 = _interopRequireDefault(_getReproduction3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getReproductionModule = _angular2.default.module('getReproduction', []).component('getReproduction', _getReproduction2.default).service('getReproductionService', _getReproduction4.default).name;

var states = [];

exports.default = { name: getReproductionModule, states: states };

/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getReproduction = __webpack_require__(1073);

var _getReproduction2 = _interopRequireDefault(_getReproduction);

var _getReproduction3 = __webpack_require__(1075);

var _getReproduction4 = _interopRequireDefault(_getReproduction3);

__webpack_require__(1076);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getReproductionComponent = {
    restrict: 'E',
    bindings: {
        'original': '=',
        'type': '@',
        'action': '&',
        'appUser': '='
    },
    template: _getReproduction2.default,
    controller: _getReproduction4.default
};

exports.default = getReproductionComponent;

/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<button type=\"button\" class=\"btn btn-primary btn-md pull-right item\" ng-click=\"$ctrl.getReproductionService.get()\">\n    {{'page-original-text078' | translate}}\n</button>\n\n<div id=\"cc-license\" class=\"modal-overlay cc-license\" modal-control>\n    <div class=\"modal loading\" ng-if=\"$ctrl.loading\">\n        <div class=\"header\">\n            <div class=\"title\">{{'page-original-text043' | translate}}</div>\n            <div class=\"close\">×</div>\n        </div>\n        <div class=\"content loading no-footer\">\n            <img src=\"" + __webpack_require__(111) + "\" width=\"48\" height=\"48\"/>\n        </div>\n    </div>\n    <div class=\"modal\" ng-if=\"!$ctrl.loading\">\n        <div class=\"header\">\n            <div class=\"title\">{{'page-original-text079' | translate}}</div>\n            <div class=\"close\">×</div>\n        </div>\n        <div class=\"content\">\n            <license license=\"$ctrl.license\" license-confirm=\"true\"></license>\n        </div>\n        <div class=\"modal-footer\">\n            <button type=\"button\" class=\"btn-yes btn btn-md btn-primary pull-right\" ng-click=\"$ctrl.ccLicenseAgreed()\">\n                {{'page-original-text080' | translate}}\n            </button>\n            <button type=\"button\" class=\"btn-no btn btn-md btn-default pull-right close\">{{'page-original-text081' | translate}}</button>\n        </div>\n    </div>\n</div>\n<div id=\"cm-license\" class=\"modal-overlay cm-license\" modal-control>\n    <div class=\"modal loading\" ng-if=\"$ctrl.loading\">\n        <div class=\"header\">\n            <div class=\"title\">{{'page-original-text043' | translate}}</div>\n            <div class=\"close\">×</div>\n        </div>\n        <div class=\"content loading no-footer\">\n            <img src=\"" + __webpack_require__(111) + "\" width=\"48\" height=\"48\"/>\n        </div>\n    </div>\n\n    <div class=\"modal\" ng-if=\"!$ctrl.loading && $ctrl.buyStep == 'license'\">\n        <div class=\"header\">\n            <div class=\"title\">{{'page-original-text079' | translate}}</div>\n            <div class=\"close\">×</div>\n        </div>\n        <div class=\"content\">\n            <ul class=\"cm-terms terms\">\n                <li>{{'page-original-text082' | translate}}</li>\n                <li>{{'page-original-text083' | translate}}</li>\n                <li>{{'page-original-text084' | translate}}</li>\n                <li ng-if=\"$ctrl.license.content.adaptation == 'y'\">{{'page-original-text085' | translate}}</li>\n                <li ng-if=\"$ctrl.license.content.adaptation == 'n'\">{{'page-original-text086' | translate}}</li>\n                <li>{{'page-original-text087' | translate}}</li>\n            </ul>\n        </div>\n        <div class=\"modal-footer\">\n            <button type=\"button\" class=\"btn-yes btn btn-md btn-primary pull-right\" ng-click=\"$ctrl.cmLicenseAgreed()\">\n                {{'page-original-text088' | translate}}\n            </button>\n            <button type=\"button\" class=\"btn-no btn btn-md btn-default pull-right close\">{{'page-original-text081' | translate}}</button>\n        </div>\n    </div>\n    <div class=\"modal\" ng-if=\"!$ctrl.loading && $ctrl.buyStep == 'reproduction'\">\n        <form novalidate name=\"shareForm\" class=\"form\">\n            <div class=\"header\">\n                <div class=\"title\">{{'page-original-text089' | translate}}</div>\n                <div class=\"close\">×</div>\n            </div>\n            <div class=\"content\">\n                <div class=\"weixin-alert\" ng-if=\"$ctrl.reproduction.account_type === '微信公众号'\">\n                    <i class=\"ybicon yb-alert\"></i><span>{{ 'page-original-text127' | translate }}</span>\n                </div>\n                <div class=\"input-group\" ng-if=\"$ctrl.userInfo.isGuest()\">\n                    <div class=\"label\">\n                        {{'page-original-text090' | translate}}\n                    </div>\n                    <div class=\"input\">\n                        <input type=\"text\" style=\"width: 0;height: 0;\">\n                        <input name=\"accountEmail\" ng-model=\"$ctrl.reproduction.account_email\" type=\"text\"\n                               placeholder=\"{{'page-original-text091' | translate}}{{'page-original-text090' | translate}}\" required ng-model-options=\"{ updateOn: 'blur' }\"/>\n                        <div class=\"error-message\">\n                            <div ng-show=\"shareForm.$submitted || shareForm.accountEmail.$touched\">\n                                <div ng-show=\"shareForm.accountEmail.$error.required\">{{'page-original-text091' | translate}}{{'page-original-text090' | translate}}</div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"input-group\">\n                    <div class=\"label\">\n                        {{'page-original-text092' | translate}}\n                    </div>\n                    <div class=\"input\">\n                        <select ng-model=\"$ctrl.reproduction.account_type\" name=\"accountType\" required>\n                            <option value=\"\">-- {{'page-original-text093' | translate}}{{'page-original-text092' | translate}} --</option>\n                            <option value=\"微信公众号\">微信公众号</option>\n                            <option value=\"微博\">微博</option>\n                            <option value=\"今日头条\">今日头条</option>\n                            <option value=\"UC头条\">UC头条</option>\n                            <option value=\"网络媒体\">网络媒体</option>\n                            <option value=\"纸质媒体\">纸质媒体</option>\n                            <option value=\"其他\">其他</option>\n                        </select>\n                        <div class=\"error-message\">\n                            <div ng-show=\"shareForm.$submitted || shareForm.accountType.$touched\">\n                                <div ng-show=\"shareForm.accountType.$error.required\">{{'page-original-text093' | translate}}{{'page-original-text092' | translate}}</div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"input-group\" ng-if=\"$ctrl.typeNameNeeded()\">\n                    <div class=\"label\">\n                        {{'page-original-text094' | translate}}\n                    </div>\n                    <div class=\"input\">\n                        <input name=\"typeName\" ng-model=\"$ctrl.reproduction.type_name\" type=\"text\" placeholder=\"{{'page-original-text091' | translate}}{{'page-original-text094' | translate}}\"\n                               required ng-model-options=\"{ updateOn: 'blur' }\"/>\n                        <div class=\"error-message\">\n                            <div ng-show=\"shareForm.$submitted || shareForm.typeName.$touched\">\n                                <div ng-show=\"shareForm.typeName.$error.required\">{{'page-original-text091' | translate}}{{'page-original-text094' | translate}}</div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"input-group\" ng-if=\"$ctrl.accountNameNeeded($ctrl.reproduction.account_type)\">\n                    <div class=\"label\">\n                        {{'page-original-text095' | translate}}\n                    </div>\n                    <div class=\"input\">\n                        <input name=\"accountName\" ng-model=\"$ctrl.reproduction.account_name\" type=\"text\"\n                               placeholder=\"{{'page-original-text091' | translate}}{{'page-original-text095' | translate}}\" required ng-model-options=\"{ updateOn: 'blur' }\"/>\n                        <div class=\"error-message\">\n                            <div ng-show=\"shareForm.$submitted || shareForm.accountName.$touched\">\n                                <div ng-show=\"shareForm.accountName.$error.required\">{{'page-original-text091' | translate}}{{'page-original-text095' | translate}}</div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"input-group\" ng-if=\"$ctrl.mediaNameNeeded($ctrl.reproduction.account_type)\">\n                    <div class=\"label\">\n                        {{'page-original-text096' | translate}}\n                    </div>\n                    <div class=\"input\">\n                        <input name=\"mediaName\" ng-model=\"$ctrl.reproduction.type_name\" type=\"text\"\n                               placeholder=\"{{'page-original-text091' | translate}}{{'page-original-text096' | translate}}\" required ng-model-options=\"{ updateOn: 'blur' }\"/>\n                        <div class=\"error-message\">\n                            <div ng-show=\"shareForm.$submitted || shareForm.mediaName.$touched\">\n                                <div ng-show=\"shareForm.mediaName.$error.required\">{{'page-original-text091' | translate}}{{'page-original-text096' | translate}}</div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"input-group\" ng-if=\"$ctrl.accountIdNeeded($ctrl.reproduction.account_type)\">\n                    <div class=\"label\">\n                        {{'page-original-text097' | translate}}\n                    </div>\n                    <div class=\"input\">\n                        <input name=\"accountId\" ng-model=\"$ctrl.reproduction.account_id\" type=\"text\"\n                               placeholder=\"{{'page-original-text091' | translate}}{{'page-original-text097' | translate}}\" required ng-model-options=\"{ updateOn: 'blur' }\"/>\n                        <div class=\"error-message\">\n                            <div ng-show=\"shareForm.$submitted || shareForm.accountId.$touched\">\n                                <div ng-show=\"shareForm.accountId.$error.required\">{{'page-original-text091' | translate}}{{'page-original-text097' | translate}}</div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"input-group\" ng-if=\"$ctrl.accountLinkNeeded($ctrl.reproduction.account_type)\">\n                    <div class=\"label\">\n                        {{'page-original-text098' | translate}}\n                    </div>\n                    <div class=\"input\">\n                        <input name=\"accountLink\" ng-model=\"$ctrl.reproduction.account_link\" type=\"text\"\n                               placeholder=\"{{'page-original-text091' | translate}}{{'page-original-text098' | translate}}\" required ng-model-options=\"{ updateOn: 'blur' }\"/>\n                        <div class=\"error-message\">\n                            <div ng-show=\"shareForm.$submitted || shareForm.accountLink.$touched\">\n                                <div ng-show=\"shareForm.accountLink.$error.required\">{{'page-original-text091' | translate}}{{'page-original-text098' | translate}}</div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"input-group\" ng-if=\"$ctrl.webLinkNeeded($ctrl.reproduction.account_type)\">\n                    <div class=\"label\">\n                        {{'page-original-text099' | translate}}\n                    </div>\n                    <div class=\"input\">\n                        <input name=\"webLink\" ng-model=\"$ctrl.reproduction.account_link\" type=\"text\"\n                               placeholder=\"{{'page-original-text091' | translate}}{{'page-original-text099' | translate}}\" required ng-model-options=\"{ updateOn: 'blur' }\"/>\n                        <div class=\"error-message\">\n                            <div ng-show=\"shareForm.$submitted || shareForm.webLink.$touched\">\n                                <div ng-show=\"shareForm.webLink.$error.required\">{{'page-original-text091' | translate}}{{'page-original-text099' | translate}}</div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"input-group\" ng-if=\"$ctrl.editorNameNeeded($ctrl.reproduction.account_type)\">\n                    <div class=\"label\">\n                        {{'page-original-text100' | translate}}\n                    </div>\n                    <div class=\"input\">\n                        <input name=\"editorName\" ng-model=\"$ctrl.reproduction.account_name\" type=\"text\"\n                               placeholder=\"{{'page-original-text091' | translate}}{{'page-original-text100' | translate}}\" required ng-model-options=\"{ updateOn: 'blur' }\"/>\n                        <div class=\"error-message\">\n                            <div ng-show=\"shareForm.$submitted || shareForm.editorName.$touched\">\n                                <div ng-show=\"shareForm.editorName.$error.required\">{{'page-original-text091' | translate}}{{'page-original-text100' | translate}}</div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"submit\" class=\"btn-yes btn btn-md btn-primary pull-right\"\n                        ng-click=\"$ctrl.createOrder(shareForm)\">{{'page-original-text101' | translate}}\n                </button>\n            </div>\n        </form>\n    </div>\n    <div class=\"modal pay\" ng-if=\"!$ctrl.loading && $ctrl.buyStep == 'pay-type'\">\n        <div class=\"header\">\n            <div class=\"title\">{{'page-original-text102' | translate}}</div>\n            <div class=\"close\">×</div>\n        </div>\n        <div class=\"content no-footer\">\n            <div class=\"price\">\n                {{'page-original-text103' | translate}}：<span class=\"number\">￥{{ $ctrl.license.content.price / 100 }}</span>\n            </div>\n            <div class=\"options\">\n                <div class=\"option\" ng-click=\"$ctrl.pay('weixin')\">\n                    <div class=\"icon\">\n                        <img src=\"" + __webpack_require__(161) + "\" width=\"30\" height=\"30\"/>\n                    </div>\n                    <div class=\"text\">{{'page-original-text104' | translate}}</div>\n                    <div class=\"arrow\">\n                        <i class=\"ybicon yb-next\"></i>\n                    </div>\n                </div>\n                <a class=\"option\" target=\"_blank\" ng-href=\"{{ $ctrl.alipaySubmitUrl }}\" ng-click=\"$ctrl.externalPay()\">\n                    <div class=\"icon\">\n                        <img src=\"" + __webpack_require__(346) + "\" width=\"30\" height=\"30\"/>\n                    </div>\n                    <div class=\"text\">{{'page-original-text105' | translate}}</div>\n                    <div class=\"arrow\">\n                        <i class=\"ybicon yb-next\"></i>\n                    </div>\n                </a>\n                <div class=\"option\" ng-click=\"$ctrl.buyStep='balance-confirm'\"\n                     ng-if=\"$ctrl.appUser.balance >= $ctrl.license.content.price\">\n                    <div class=\"icon\">\n                        <img src=\"" + __webpack_require__(335) + "\" width=\"30\" height=\"30\"/>\n                    </div>\n                    <div class=\"text\">{{'page-original-text106' | translate}}（<span class=\"balance\">{{'page-original-text107' | translate}}：￥{{ $ctrl.appUser.balance / 100 }}</span>）</div>\n                    <div class=\"arrow\">\n                        <i class=\"ybicon yb-next\"></i>\n                    </div>\n                </div>\n                <div class=\"option disabled\" ng-if=\"$ctrl.appUser.balance < $ctrl.license.content.price\">\n                    <div class=\"icon\">\n                        <img src=\"" + __webpack_require__(335) + "\" width=\"30\" height=\"30\"/>\n                    </div>\n                    <div class=\"text\">{{'page-original-text108' | translate}}（<span class=\"balance\">{{'page-original-text107' | translate}}：￥{{ $ctrl.appUser.balance / 100 }}</span>）</div>\n                    <div class=\"arrow\">\n                        <i class=\"ybicon yb-next\"></i>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"modal balance-confirm pay\" ng-if=\"!$ctrl.loading && $ctrl.buyStep=='balance-confirm'\">\n        <div class=\"header\">\n            <div class=\"title\">{{'page-original-text109' | translate}}</div>\n            <div class=\"close\">×</div>\n        </div>\n        <div class=\"content\">\n            <div class=\"price\">\n                {{'page-original-text110' | translate}}：<span class=\"number\">￥{{ $ctrl.license.content.price / 100 }}</span>\n            </div>\n            <div class=\"balance\">\n                {{'page-original-text111' | translate}}：<span class=\"number\">￥{{ $ctrl.appUser.balance / 100 }}</span>\n            </div>\n        </div>\n        <div class=\"modal-footer\">\n            <button type=\"submit\" class=\"btn-yes btn btn-md btn-primary pull-right\" ng-click=\"$ctrl.confirmPayment()\">\n                {{'page-original-text112' | translate}}\n            </button>\n        </div>\n    </div>\n    <div class=\"modal scan\" ng-if=\"!$ctrl.loading && $ctrl.buyStep == 'weixin-scan'\">\n        <div class=\"header\">\n            <div class=\"title\">{{'page-original-text113' | translate}}</div>\n            <div class=\"close\">×</div>\n        </div>\n        <div class=\"content no-footer\">\n            <div class=\"pay-names\">\n                <div class=\"weixin pay-name\">\n                    <div class=\"image\">\n                        <img src=\"" + __webpack_require__(161) + "\" width=\"35\" height=\"35\"/>\n                    </div>\n                    <div class=\"text\">{{'page-original-text114' | translate}}</div>\n                </div>\n            </div>\n            <div class=\"qrcode\">\n                <img ng-src=\"{{$ctrl.qrCodeSrc}}\" width=\"250\" height=\"250\"/>\n            </div>\n        </div>\n    </div>\n    <div class=\"modal wait\" ng-if=\"!$ctrl.loading && $ctrl.buyStep == 'wait'\">\n        <div class=\"header\">\n            <div class=\"title\">{{'page-original-text115' | translate}}</div>\n            <div class=\"close\">×</div>\n        </div>\n        <div class=\"content waiting\">\n            <div class=\"name\">{{'page-original-text116' | translate}}</div>\n            <div class=\"status\">{{'page-original-text117' | translate}}</div>\n        </div>\n        <div class=\"modal-footer\">\n            <button type=\"button\" class=\"btn-yes btn btn-md btn-primary pull-right\" ng-click=\"$ctrl.get()\">\n                {{'page-original-text118' | translate}}\n            </button>\n        </div>\n    </div>\n</div>\n<div id=\"none-license\" class=\"modal-overlay none-license\" modal-control>\n    <div class=\"modal\">\n        <div class=\"header\">\n            <div class=\"title\">{{'page-original-text078' | translate}}</div>\n            <div class=\"close\">×</div>\n        </div>\n        <div class=\"content\">\n            <div class=\"image\">\n                <img src=\"" + __webpack_require__(1074) + "\" />\n            </div>\n            <div class=\"description\">\n                {{'page-original-text119' | translate}}\n            </div>\n            <div class=\"potential\">\n                {{'page-original-text120' | translate}}\n            </div>\n            <div class=\"clearfix willing-box\">\n                <div class=\"price pull-left\" ng-class=\"{'active': willingPriceFocused, 'error': $ctrl.willingPriceError}\">\n                    <div class=\"input\">\n                        <input type=\"bnumber\" id=\"willing-price\" ng-focus=\"willingPriceFocused = 1\" ng-blur=\"willingPriceFocused = 0\" />\n                    </div>\n                    <div class=\"unit\">{{'page-original-text121' | translate}}</div>\n                </div>\n                <button type=\"button\" class=\"btn-yes btn btn-md btn-primary pull-left\" ng-click=\"$ctrl.sendDemand()\">\n                    {{'page-original-text122' | translate}}\n                </button>\n            </div>\n\n        </div>\n    </div>\n</div>\n\n";

/***/ }),
/* 1074 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GetReproductionController = function () {
    GetReproductionController.$inject = ['OrderAPI', 'localStorageService', 'modal', 'getReproductionService', 'userInfo', '$state', '$scope', '$filter', '$stateParams', '$timeout', 'message', 'ArticleAPI', 'WXpayAPI', 'NoLoginPayAPI'];

    function GetReproductionController(OrderAPI, localStorageService, modal, getReproductionService, userInfo, $state, $scope, $filter, $stateParams, $timeout, message, ArticleAPI, WXpayAPI, NoLoginPayAPI) {

        "ngInject";

        var _this = this;

        (0, _classCallCheck3.default)(this, GetReproductionController);
        this.OrderAPI = OrderAPI;
        this.localStorageService = localStorageService;
        this.modal = modal;
        this.reproduction = localStorageService.get('reproduction');
        this.getReproductionService = getReproductionService;
        this.userInfo = userInfo;
        this.$state = $state;
        this.$timeout = $timeout;
        this.message = message;
        this.ArticleAPI = ArticleAPI;
        this.WXpayAPI = WXpayAPI;
        this.NoLoginPayAPI = NoLoginPayAPI;
        this.$scope = $scope;

        this.qrCodeSrc = null;
        this.buyStep = 'license';
        this.loading = false;
        this.willingPriceError = false;
        this.tranlsteFilter = $filter('translate');

        this.license = this.original.license;

        var self = this;

        this.getReproductionService.get = function () {
            _this.get(self);
        };

        if ($stateParams.action) {
            if ($stateParams.action == 'buy') {
                if (!userInfo.isAuthor(this.original)) {
                    this.get();
                }
            }
        }
    }

    (0, _createClass3.default)(GetReproductionController, [{
        key: 'get',
        value: function get(self) {

            if (!self) {
                self = this;
            }
            console.log(self.license);

            if (self.license.type === 'cm' || self.license.type === "cmc" && self.license.content.expire > new Date().getTime()) {
                self.buyStep = 'license';
                self.modal.open('cm-license');
            } else {
                if (self.userInfo.isGuest()) {
                    var returnUrl = self.$state.href('app.page.original.' + self.type, {
                        'id': self.original.yuanben_id,
                        'action': 'buy'
                    });
                    self.$state.go('app.face.index.user.form.login', { 'return': returnUrl });
                    return;
                }
                if (self.license.type === 'cc' || self.license.type === "cmc" && self.license.content.expire < new Date().getTime()) {
                    self.modal.open('cc-license');
                } else if (self.license.type == 'none') {
                    self.modal.open('none-license');
                    self.articleDemand();
                }
            }
        }
    }, {
        key: 'ccLicenseAgreed',
        value: function ccLicenseAgreed() {
            var _this2 = this;

            // this.action();
            var post = {
                'original_id': this.original.id,
                'type': this.type
            };
            var self = this;
            self.loading = true;
            this.OrderAPI.one('cc').customPOST(post).then(function (res) {

                self.loading = false;
                _this2.modal.close('cc-license');
                if (res.status.code == 200) {
                    self.message.success(self.tranlsteFilter('page-original-text123'));
                    self.order = res.data;
                    self.$timeout(function () {

                        if (self.order.order_article) {
                            self.$state.go('app.page.original.articleReproduction', { reproduction: self.order.order_article.yuanben_id });
                        } else {
                            self.$state.go('app.page.original.imageReproduction', { reproduction: self.order.order_image.yuanben_id });
                        }
                    }, 1000);
                } else {
                    self.message.error(res.status.message);
                }
            }, function (response) {
                self.message.error(response.data);
            });
        }
    }, {
        key: 'cmLicenseAgreed',
        value: function cmLicenseAgreed() {
            if (this.type == 'article') {
                this.buyStep = 'reproduction';
            } else {
                this.placeOrder();
            }
        }
    }, {
        key: 'accountNameNeeded',
        value: function accountNameNeeded(accountType) {
            return ["微信公众号", "微博", "今日头条", "UC头条", "其他"].indexOf(accountType) != -1;
        }
    }, {
        key: 'mediaNameNeeded',
        value: function mediaNameNeeded(accountType) {
            return ["网络媒体", "纸质媒体"].indexOf(accountType) != -1;
        }
    }, {
        key: 'accountIdNeeded',
        value: function accountIdNeeded(accountType) {
            return ["微信公众号", "其他"].indexOf(accountType) != -1;
        }
    }, {
        key: 'accountLinkNeeded',
        value: function accountLinkNeeded(accountType) {
            return ["微博", "今日头条", "UC头条", "其他"].indexOf(accountType) != -1;
        }
    }, {
        key: 'webLinkNeeded',
        value: function webLinkNeeded(accountType) {
            return ["网络媒体"].indexOf(accountType) != -1;
        }
    }, {
        key: 'editorNameNeeded',
        value: function editorNameNeeded(accountType) {
            return ["网络媒体", "纸质媒体"].indexOf(accountType) != -1;
        }
    }, {
        key: 'typeNameNeeded',
        value: function typeNameNeeded(accountType) {
            return ["其他"].indexOf(accountType) != -1;
        }
    }, {
        key: 'confirmPayment',
        value: function confirmPayment() {
            this.pay('balance');
        }
    }, {
        key: 'createOrder',
        value: function createOrder(shareForm) {

            var self = this;
            shareForm.$setSubmitted();

            if (!shareForm.$valid) {
                return;
            }

            this.localStorageService.set('reproduction', this.reproduction);

            if (self.userInfo.isGuest()) {
                //免登陆购买
                self.noLoginOrder();
            } else {
                this.placeOrder();
            }
        }
    }, {
        key: 'placeOrder',
        value: function placeOrder() {

            var post = {
                'original_id': this.original.id,
                'type': this.type,
                'reproduction': this.reproduction
            };

            var self = this;

            self.loading = true;

            this.OrderAPI.post(post).then(function (data) {

                self.loading = false;
                self.order = data.order;

                self.alipaySubmitUrl = data.alipay_url;
                self.buyStep = 'pay-type';
            }, function (response) {
                self.loading = false;
                self.message.error(response.data);
            });
        }
    }, {
        key: 'pay',
        value: function pay(type) {
            var _this3 = this;

            var payment = {
                'pay_type': type
            };

            var self = this;

            self.loading = true;

            //微信浏览器内使用sdk支付
            if (type === 'weixin' && typeof WeixinJSBridge != 'undefined') {
                var payurl = '';
                if (self.userInfo.isGuest()) {
                    payurl = '/payment/weixin/' + self.order.order_id;
                } else {
                    payurl = '/payment/weixin/' + self.order.id;
                }
                location.href = 'https://api.yuanben.io/media/weixin/oauth/base?return=' + payurl;
                return;
                // if(!self.WX_openid){
                //     //没有openid 跳转取值
                //     location.href='https://api.yuanben.io/media/weixin/oauth/base?return='+payurl;
                // }else{
                //     location.href=payurl;
                // }

            }

            if (self.userInfo.isGuest()) {
                //未登录pc端用微信扫码购买
                self.noLoginPayWeixin();
                return;
            }

            this.OrderAPI.one(self.order.id).post('pay', payment).then(function (data) {
                self.loading = false;
                self.order = data.order;

                if (type == 'balance') {
                    self.buySucceed();
                } else {
                    self.qrCodeSrc = data.qr_code_src;
                    self.buyStep = 'weixin-scan';

                    _this3.checkOrderStatus();
                }
            }, function (response) {
                self.loading = false;
                self.message.error(response.data);
            });
        }
    }, {
        key: 'noLoginOrder',
        value: function noLoginOrder() {
            var post = {
                'original_id': this.original.id,
                'type': this.type,
                'email': this.reproduction.account_email,
                'reproduction': this.reproduction
            };

            var self = this;

            self.loading = true;

            this.NoLoginPayAPI.post(post).then(function (data) {

                self.loading = false;
                self.order = data.order;

                self.alipaySubmitUrl = data.alipay_url;
                self.buyStep = 'pay-type';
            }, function (response) {
                self.loading = false;
                self.message.error(response.data);
            });
        }
    }, {
        key: 'noLoginPayWeixin',
        value: function noLoginPayWeixin() {
            var _this4 = this;

            var self = this;
            var payment = {
                'pay_type': 'weixin',
                'order_id': self.order.order_id
            };
            this.NoLoginPayAPI.one('weixin').post('qrcode', payment).then(function (data) {
                self.loading = false;
                self.order = data.order;

                self.qrCodeSrc = data.qr_code_src;
                self.buyStep = 'weixin-scan';

                _this4.checkOrderStatus();
            }, function (response) {
                self.loading = false;
                self.message.error(response.data);
            });
        }
    }, {
        key: 'externalPay',
        value: function externalPay() {
            this.checkOrderStatus();
            this.buyStep = 'wait';

            return true;
        }
    }, {
        key: 'checkOrderStatus',
        value: function checkOrderStatus() {
            var self = this;
            if (self.userInfo.isGuest()) {
                this.NoLoginPayAPI.one('order').one(self.order.order_id).get().then(function (order) {
                    if (order && order.status == 2) {
                        self.order = order;
                        self.buySucceed();
                    } else {
                        if ($('#cm-license').hasClass('active')) {
                            self.$timeout(function () {
                                self.checkOrderStatus();
                            }, 3000);
                        }
                    }
                }, function (response) {
                    self.message.error(response.data);
                });
            } else {
                this.OrderAPI.one(this.order.id).get().then(function (order) {
                    self.order = order;

                    if (order.status == 2) {

                        self.buySucceed();
                    } else {

                        if ($('#cm-license').hasClass('active')) {
                            self.$timeout(function () {
                                self.checkOrderStatus();
                            }, 3000);
                        }
                    }
                }, function (response) {
                    self.message.error(response.data);
                });
            }
        }
    }, {
        key: 'buySucceed',
        value: function buySucceed() {
            var self = this;
            self.modal.close('cm-license');
            self.message.success('购买成功');
            self.$scope.$emit("showTips", true);
            self.$timeout(function () {
                var notify = self.userInfo.isGuest();
                if (self.order.order_article) {
                    self.$state.go('app.page.original.articleReproduction', { reproduction: self.order.order_article.yuanben_id, notify: notify });
                } else {
                    self.$state.go('app.page.original.imageReproduction', { reproduction: self.order.order_image.yuanben_id, notify: notify });
                }
            }, 1000);
        }
    }, {
        key: 'sendDemand',
        value: function sendDemand() {
            this.willingPriceError = false;

            var price = $('#willing-price').val();

            if (price === '' || isNaN(parseFloat(price)) || !isFinite(price)) {
                this.willingPriceError = true;
                return;
            }

            var self = this;

            this.articleDemand(price, function () {
                self.modal.close('none-license');
                self.message.success(self.tranlsteFilter('page-original-text124'));
            });
        }
    }, {
        key: 'articleDemand',
        value: function articleDemand(price, callback) {

            var post = {};

            if (typeof price !== 'undefined') {
                post['charge'] = price;
            }

            var self = this;

            self.ArticleAPI.one(self.original.id).customPOST(post, 'demand').then(function () {
                if (typeof callback !== 'undefined') {
                    callback();
                }
            });
        }

        // $onInit(){
        //     let self=this;
        //     if (typeof WeixinJSBridge == "undefined"){
        //         if( document.addEventListener ){
        //             document.addEventListener('WeixinJSBridgeReady', self.onBridgeReady, false);
        //         }else if (document.attachEvent){
        //             document.attachEvent('WeixinJSBridgeReady', self.onBridgeReady);
        //             document.attachEvent('onWeixinJSBridgeReady', self.onBridgeReady);
        //         }
        //     }else{
        //         self.onBridgeReady();
        //     }
        // }
        // onBridgeReady(){
        //     let self=this;
        //     this.WXpayAPI.one('openid').get({'timestr':Date.now()}).then(
        //         (res) => {
        //             if(!!res){
        //                 self.WX_openid=res;
        //             }
        //         },
        //         (response) => {
        //             self.message.error(response.data);
        //         }
        //     );
        // }

    }]);
    return GetReproductionController;
}();

exports.default = GetReproductionController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1077);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./get-reproduction.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./get-reproduction.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "get-reproduction .modal.loading .content {\n  display: block;\n  position: relative;\n  height: 240px;\n  text-align: center; }\n  get-reproduction .modal.loading .content img {\n    margin-top: 70px; }\n\nget-reproduction .cm-license .weixin-alert {\n  color: red; }\n  get-reproduction .cm-license .weixin-alert i {\n    margin-right: 10px;\n    font-size: 25px; }\n  get-reproduction .cm-license .weixin-alert i, get-reproduction .cm-license .weixin-alert span {\n    vertical-align: middle; }\n\nget-reproduction .cm-license .pay .content {\n  padding: 0; }\n  get-reproduction .cm-license .pay .content .price {\n    padding-top: 32px;\n    height: 140px;\n    line-height: 2;\n    font-size: 16px;\n    color: #666666;\n    text-align: center; }\n    get-reproduction .cm-license .pay .content .price .number {\n      font-size: 24px;\n      color: #00816a; }\n  get-reproduction .cm-license .pay .content .balance {\n    text-align: center;\n    font-size: 14px;\n    color: #999999;\n    height: 100px; }\n  get-reproduction .cm-license .pay .content .options {\n    position: relative;\n    border-top: 1px solid #e8eaea;\n    padding-bottom: 28px; }\n    get-reproduction .cm-license .pay .content .options .option {\n      position: relative;\n      display: block;\n      height: 60px;\n      line-height: 60px;\n      border-bottom: 1px solid #e8eaea;\n      text-decoration: none;\n      cursor: pointer; }\n      get-reproduction .cm-license .pay .content .options .option:hover {\n        background-color: #f6f8f8; }\n      get-reproduction .cm-license .pay .content .options .option .icon {\n        position: absolute;\n        width: 30px;\n        height: 30px;\n        top: 15px;\n        left: 15px; }\n        get-reproduction .cm-license .pay .content .options .option .icon img {\n          display: block; }\n      get-reproduction .cm-license .pay .content .options .option .text {\n        position: relative;\n        margin-left: 60px;\n        font-size: 16px;\n        color: #666666; }\n      get-reproduction .cm-license .pay .content .options .option .arrow {\n        position: absolute;\n        width: 50px;\n        height: 60px;\n        line-height: 60px;\n        right: 0;\n        top: 0;\n        color: #cccccc;\n        text-align: center; }\n      get-reproduction .cm-license .pay .content .options .option.disabled, get-reproduction .cm-license .pay .content .options .option.disabled:hover {\n        opacity: 0.5;\n        background-color: #fff;\n        cursor: default; }\n        get-reproduction .cm-license .pay .content .options .option.disabled .arrow, get-reproduction .cm-license .pay .content .options .option.disabled:hover .arrow {\n          display: none; }\n        get-reproduction .cm-license .pay .content .options .option.disabled .text, get-reproduction .cm-license .pay .content .options .option.disabled:hover .text {\n          color: #999999; }\n\nget-reproduction .cm-license .scan .pay-names {\n  position: relative; }\n  get-reproduction .cm-license .scan .pay-names .pay-name {\n    position: relative;\n    text-align: center; }\n    get-reproduction .cm-license .scan .pay-names .pay-name .image {\n      position: relative;\n      display: inline-block;\n      width: 35px;\n      height: 35px;\n      vertical-align: top; }\n      get-reproduction .cm-license .scan .pay-names .pay-name .image img {\n        display: block; }\n    get-reproduction .cm-license .scan .pay-names .pay-name .text {\n      position: relative;\n      display: inline-block;\n      height: 35px;\n      line-height: 35px;\n      vertical-align: top;\n      font-size: 16px;\n      color: #666666; }\n\nget-reproduction .cm-license .scan .qrcode {\n  position: relative;\n  width: 250px;\n  height: 250px;\n  margin: 0 auto; }\n\nget-reproduction .cm-license .wait {\n  text-align: center; }\n  get-reproduction .cm-license .wait .name {\n    margin-top: 20px;\n    font-size: 16px;\n    color: #666666; }\n  get-reproduction .cm-license .wait .status {\n    margin-top: 20px;\n    font-size: 14px;\n    color: #999999; }\n\nget-reproduction .none-license .content {\n  text-align: center; }\n  get-reproduction .none-license .content .willing-box {\n    padding: 20px 0;\n    width: 100%; }\n  get-reproduction .none-license .content .image {\n    margin-top: 30px; }\n  get-reproduction .none-license .content .description {\n    margin-top: 30px;\n    font-size: 16px;\n    color: #222222; }\n  get-reproduction .none-license .content .potential {\n    margin-top: 30px;\n    font-size: 14px;\n    color: #999999; }\n  get-reproduction .none-license .content .price {\n    position: relative;\n    width: 67%;\n    height: 40px;\n    margin: 0 3% 0 0;\n    background-color: #f8f8f8;\n    border: 1px solid #f0f0f0;\n    border-radius: 3px;\n    overflow: hidden; }\n    get-reproduction .none-license .content .price.active {\n      background-color: #ffffff; }\n    get-reproduction .none-license .content .price.error {\n      border-color: #ff3333; }\n    get-reproduction .none-license .content .price .input {\n      position: absolute;\n      width: 80%;\n      height: 34px;\n      top: 2px;\n      left: 5%; }\n      get-reproduction .none-license .content .price .input input {\n        position: relative;\n        display: block;\n        width: 100%;\n        height: 100%;\n        border: 0;\n        background: none;\n        margin: 0;\n        padding: 0;\n        text-align: center; }\n    get-reproduction .none-license .content .price .unit {\n      position: absolute;\n      width: 30px;\n      height: 40px;\n      line-height: 40px;\n      text-align: left;\n      right: 0;\n      top: 0;\n      font-size: 16px;\n      color: #666666; }\n  get-reproduction .none-license .content .btn-yes {\n    width: 30% !important;\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n    text-align: center; }\n\nget-reproduction .modal .content .terms {\n  font-size: 14px;\n  color: #999999; }\n  get-reproduction .modal .content .terms li {\n    margin-top: 8px; }\n", ""]);

// exports


/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by ganlu on 30/12/2016.
 */
var GetReproductionService = function () {
    GetReproductionService.$inject = ['message', '$filter'];

    function GetReproductionService(message, $filter) {
        "ngInject";

        (0, _classCallCheck3.default)(this, GetReproductionService);
        this.message = message;
        this.tranlsteFilter = $filter('translate');
    }

    (0, _createClass3.default)(GetReproductionService, [{
        key: 'get',
        value: function get() {
            this.message.error(this.tranlsteFilter('page-original-text125'));
        }
    }]);
    return GetReproductionService;
}();

exports.default = GetReproductionService;

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _author = __webpack_require__(1080);

var _author2 = _interopRequireDefault(_author);

__webpack_require__(113);

var _fancyboxPlus = __webpack_require__(112);

var _fancyboxPlus2 = _interopRequireDefault(_fancyboxPlus);

var _imageFallback = __webpack_require__(1086);

var _imageFallback2 = _interopRequireDefault(_imageFallback);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var authorModule = _angular2.default.module('author', [_fancyboxPlus2.default, 'ngFilesizeFilter']).component('author', _author2.default).directive('imageFallback', _imageFallback2.default).name;

var states = [{
    'name': 'author',
    'url': '/author/{id}',
    'component': 'author',
    'resolve': {
        'author': ['AuthorAPI', '$stateParams', function author(AuthorAPI, $stateParams) {
            "ngInject";

            return AuthorAPI.one($stateParams.id).get().then(function (author) {
                return author;
            });
        }]
    }
}];

exports.default = { name: authorModule, states: states };

/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _author = __webpack_require__(1081);

var _author2 = _interopRequireDefault(_author);

var _author3 = __webpack_require__(1082);

var _author4 = _interopRequireDefault(_author3);

__webpack_require__(1083);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var authorComponent = {
    restrict: 'E',
    bindings: {
        appUser: '=',
        author: '='
    },
    template: _author2.default,
    controller: _author4.default
};

exports.default = authorComponent;

/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<div class=\"author-error block\" ng-if=\"error\">\n    {{'page-author-text001' | translate}}\n</div>\n\n<div class=\"originals block clearfix\" ng-if=\"!error\">\n    <div class=\"user col-3 with-iphone\">\n        <div class=\"user-face\">\n            <img class=\"img\" ng-src=\"{{ $ctrl.author.avatar }}\" alt=\"\">\n            <div class=\"authentication\">\n                <img ng-if=\"$ctrl.author.name\" width=\"50\" height=\"16\" src=\"" + __webpack_require__(336) + "\" alt=\"\">\n            </div>\n        </div>\n        <div class=\"pseudonym\">{{$ctrl.author.pseudonym}}</div>\n        <div class=\"introduction\">{{$ctrl.author.introduction}}</div>\n    </div>\n    <div class=\"left-cont col-9\">\n        <div class=\"position\">\n          {{'page-author-text002' | translate}}\n          <form class=\"search-form\" ng-submit=\"$ctrl.orderSearch()\">\n            <input type=\"text\" class=\"input\" ng-model=\"$ctrl.searchText\" placeholder=\"{{'home-reprint-text004' | translate}}\">\n            <button type=\"submit\" class=\"submit ybicon yb-search\"></button>\n          </form>\n        </div>\n        <navtab tabs=\"$ctrl.tabs\"></navtab>\n        <div class=\"block-content\">\n            <div class=\"order-tab\">\n                <div class=\"tab\" ng-class=\"{active:$ctrl.order==='hottest'}\" ng-click=\"$ctrl.switchOrder('hottest',1)\">\n                    {{'page-author-text003' | translate}}</div>\n                <div class=\"tab\" ng-class=\"{active:$ctrl.order==='newest'}\" ng-click=\"$ctrl.switchOrder('newest',1)\">\n                    {{'page-author-text004' | translate}}</div>\n            </div>\n            <!--文章列表-->\n            <div class=\"article-list\" ng-if=\"$ctrl.type == 'articles'\">\n                <div class=\"placeholder\" ng-if=\"$ctrl.articles.length == 0\">\n                    <img src=\"" + __webpack_require__(110) + "\" width=\"100\" height=\"100\">\n                </div>\n                <a ui-sref=\"app.page.original.article({id: article.yuanben_id})\" target=\"_blank\" class=\"item\"\n                   ng-repeat=\"article in $ctrl.articles track by article.id\">\n                    <div class=\"title\" ng-bind-html=\"$ctrl.$sce.trustAsHtml(article.title)\"></div>\n                    <div class=\"cont\">\n                        <img ng-if=\"article.main_article_image\" ng-src=\"{{article.main_article_image}}?x-oss-process=image/resize,m_fill,w_108,h_80,limit_0\"  class=\"photo\" alt=\"\">\n                        <div class=\"summary\" ng-bind-html=\"$ctrl.$sce.trustAsHtml(article.outline)\"></div>\n                    </div>\n\n                    <div class=\"details\">\n                        <div class=\"detail\">\n                            <span class=\"value date\">{{ article.created_at * 1000 | date : 'yyyy-MM-dd' }}</span>\n                        </div>\n                        <div class=\"detail\">\n                            <span class=\"value dna\">DNA {{ article.short_id }}</span>\n                        </div>\n                        <div class=\"detail\" ng-if=\"article.license.type != 'none'\">\n                            <span class=\"value\"><license-icons license=\"article.license\" class=\"mini inline\"></license-icons></span>\n                        </div>\n                        <div class=\"detail collect\" ng-class=\"{active:article.collectStatue}\" title=\"{{article.collectStatue?('page-author-text005' | translate) : ('page-author-text006' | translate)}}\" ng-click=\"!article.collection_loading && $ctrl.collection(article,1);$event.preventDefault()\">\n                            <span class=\"ybicon yb-star-checked\"></span>\n                        </div>\n                    </div>\n                </a>\n            </div>\n            <!--图片列表-->\n            <div class=\"image-list\"  ng-if=\"$ctrl.type == 'images'\">\n                <div class=\"placeholder\" ng-if=\"images.length == 0\">\n                    <img src=\"" + __webpack_require__(110) + "\" width=\"100\" height=\"100\">\n                </div>\n                <div class=\"image-container\">\n                    <div class=\"image-item\" ng-repeat=\"image in $ctrl.images track by image.id\">\n                        <div class=\"thumbnail\"  ng-if=\"!unavailableImages[image.yuanben_id]\">\n                            <a class=\"dis-block\" ui-sref=\"app.page.original.image({'id': image.yuanben_id})\" target=\"_blank\">\n                                <img class=\"dis-block\" ng-src=\"{{ image.web_url }}?x-oss-process=image/resize,m_fill,w_408,h_284,limit_0\" image-fallback/>\n                            </a>\n                            <div class=\"icon-box\">\n                                <div class=\"icon\" ng-class=\"{active:image.collectStatue}\" title=\"{{image.collectStatue?('page-author-text005' | translate) : ('page-author-text006' | translate)}}\" ng-click=\"!image.collection_loading && $ctrl.collection(image,2);$event.preventDefault()\">\n                                    <i class=\"ybicon yb-star-checked\"></i>\n                                </div>\n                                <a class=\"icon yb-view-btn\" rel=\"original-images\" ng-href=\"{{ image.image_url }}\" title=\"{{ image.title }}\">\n                                    <i class=\"ybicon yb-view\"></i>\n                                </a>\n                            </div>\n                        </div>\n                        <div class=\"thumbnail-placeholder\" ng-if=\"unavailableImages[image.yuanben_id]\">\n                            <div class=\"image-placeholder\">\n                                {{'page-author-text007' | translate}}\n\n                            </div>\n                        </div>\n                        <a ui-sref=\"app.page.original.image({'id': image.yuanben_id})\" target=\"_blank\" class=\"info\">\n                            <div class=\"title\">{{ image.title }}</div>\n                            <div class=\"yuanben-id line\">DNA {{ image.short_id }}</div>\n                            <div class=\"license line\">\n                                <license-icons class=\"small inline\" license=\"image.license\"></license-icons>\n                            </div>\n                        </a>\n\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <pager total=\"$ctrl.pageCount\" current=\"$ctrl.page\" ng-if=\"$ctrl.pageCount > 1\" load=\"$ctrl.loadPage(page)\"></pager>\n    </div>\n    <div class=\"user col-3\">\n        <div class=\"user-face\">\n            <img class=\"img\" ng-src=\"{{ $ctrl.author.avatar }}\" alt=\"\">\n            <div class=\"authentication\">\n                <img ng-if=\"$ctrl.author.name\" width=\"50\" height=\"16\"  src=\"" + __webpack_require__(336) + "\" alt=\"\">\n            </div>\n        </div>\n        <div class=\"pseudonym\">{{$ctrl.author.pseudonym}}</div>\n        <div class=\"introduction\">{{$ctrl.author.introduction}}</div>\n        <div class=\"publish\">\n            <div class=\"item\">{{'page-author-text008' | translate}}<span class=\"count\">{{$ctrl.author.article_count}}</span></div>\n            <div class=\"item\">{{'page-author-text009' | translate}}<span class=\"count\">{{$ctrl.author.image_count}}</span></div>\n        </div>\n        <div class=\"social\">\n            <a href=\"javascript:void(0)\" class=\"social-weixin\" ng-class=\"{invalid: !$ctrl.mediaAccounts.weixin}\">\n                <div class=\"popover\" ng-if=\"$ctrl.mediaAccounts.weixin\">\n                    <img ng-src=\"{{$ctrl.mediaAccounts.weixin}}\" alt=\"\">\n                </div>\n            </a>\n            <a ng-href=\"{{$ctrl.mediaAccounts.weibo}}\" class=\"social-weibo\" ng-class=\"{invalid: !$ctrl.mediaAccounts.weibo}\">\n            </a>\n            <a ng-href=\"{{$ctrl.mediaAccounts.toutiao}}\" class=\"social-toutiao\" ng-class=\"{invalid: !$ctrl.mediaAccounts.toutiao}\">\n            </a>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(172);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AuthorController = function () {
    AuthorController.$inject = ['$scope', '$state', '$sce', 'AuthorAPI', 'CollectionAPI', '$filter', 'message', 'userInfo', '$stateParams', 'pageTitle', '$timeout', 'fancyboxService'];

    function AuthorController($scope, $state, $sce, AuthorAPI, CollectionAPI, $filter, message, userInfo, $stateParams, pageTitle, $timeout, fancyboxService) {
        "ngInject";

        (0, _classCallCheck3.default)(this, AuthorController);
        $scope.unavailableImages = {};
        this.error = false;
        this.AuthorAPI = AuthorAPI;
        this.pageTitle = pageTitle;
        this.$timeout = $timeout;
        this.$filter = $filter;
        this.$sce = $sce;

        this.articles = [];
        this.images = [];

        this.pageSize = 15;
        this.pageCount = 0;
        this.page = 1;

        this.type = 'articles';
        this.order = 'hottest';
        this.$state = $state;
        this.message = message;
        this.userInfo = userInfo;
        this.CollectionAPI = CollectionAPI;
        this.userInfo.setUser(this.appUser);

        var self = this;

        if (!$stateParams.id) {
            this.error = true;
            return;
        }

        this.loadAuthor($stateParams.id);

        this.tabs = [{
            name: self.$filter('translate')('page-author-text008'),
            click: function click() {
                self.page = 1;
                self.type = 'articles';
                self.loadOriginals();
            },
            active: true
        }, {
            name: self.$filter('translate')('page-author-text009'),
            click: function click() {
                self.page = 1;
                self.type = 'images';
                self.loadOriginals();
            }
        }];

        this.fancyboxOptions = fancyboxService.getOptions(function (title, currentArray, currentIndex, currentOpts) {
            return '<div class="image-description">' + '<div class="image-title">' + title + '</div>' + '<div class="description-content">' + self.images[currentIndex].description + '</div>' + '</div>';
        });
    }

    (0, _createClass3.default)(AuthorController, [{
        key: 'switchOrder',
        value: function switchOrder(order, page) {
            this.order = order;
            this.page = page;
            this.loadOriginals();
        }
    }, {
        key: 'loadAuthor',
        value: function loadAuthor(id) {
            var _this = this;

            var self = this;
            this.mediaAccounts = {
                weixin: '',
                weibo: '',
                toutiao: ''
            };
            var mediaNames = ['', 'weixin', 'weibo', 'toutiao'];
            this.AuthorAPI.one(id).get().then(function (author) {
                self.author = author;
                self.pageTitle.setTitle(author.pseudonym);
                self.pageCount = Math.ceil(self.author.article_count / self.pageSize);

                author.user_media_accounts.forEach(function (e) {
                    _this.mediaAccounts[mediaNames[e.account_type]] = e.address;
                });
                self.loadOriginals();
            }, function () {
                self.error = true;
            });
        }
    }, {
        key: 'loadOriginals',
        value: function loadOriginals() {
            var _this2 = this;

            var self = this;

            this.AuthorAPI.one(this.author.id).one(this.type).get((0, _extends3.default)({ 'page': this.page,
                'order': this.order,
                'pageSize': this.pageSize
            }, this.searchText ? { q: this.searchText } : {})).then(function (originals) {

                if (self.type == 'articles') {
                    self.articles = originals.data;
                } else {
                    self.images = originals.data;

                    self.$timeout(function () {
                        $(".yb-view-btn").fancyboxPlus(self.fancyboxOptions);
                    });
                }
                self.pageCount = Math.ceil(originals.total / self.pageSize);
                self.total = originals.total;
                if (!self.userInfo.isGuest() && originals.length) {
                    self.collection_check(self.type == 'articles' ? 1 : 2, originals);
                }
            }, function () {
                _this2.error = true;
            });
        }
    }, {
        key: 'loadPage',
        value: function loadPage(page) {
            this.page = page;
            this.loadOriginals();
        }
    }, {
        key: 'collection',
        value: function collection(originals, type) {
            if (this.userInfo.isGuest()) {
                this.$state.go('app.face.index.user.form.login');
                return;
            }
            var self = this;
            originals.collection_loading = true;
            var api = this.CollectionAPI;
            if (originals.collectStatue) {
                api.one().remove({ resource_type_id: type, resource_id: originals.id }).then(function () {
                    originals.collection_loading = false;
                    self.message.success(self.$filter('translate')('page-author-text010'));
                    originals.collectStatue = false;
                }, function (response) {
                    originals.collection_loading = false;
                    self.message.error(response.data);
                });
            } else {
                api.post({ resource_type_id: type, resource_id: originals.id }).then(function () {
                    originals.collection_loading = false;
                    self.message.success(self.$filter('translate')('page-author-text011'));
                    originals.collectStatue = true;
                }, function (response) {
                    originals.collection_loading = false;
                    self.message.error(response.data);
                });
            }
        }
    }, {
        key: 'collection_check',
        value: function collection_check(type, originals) {
            var ids = originals.map(function (item) {
                return item.id;
            });
            this.CollectionAPI.one('check').customPOST({ resource_type_id: type, resource_ids: ids }).then(function (res) {
                //获取已收藏的数据
                var collectArr = res.data.filter(function (item) {
                    return item.is_active === 1;
                });
                collectArr && collectArr.forEach(function (collectItem) {
                    originals.forEach(function (originalItem) {
                        if (originalItem.id === collectItem.resource_id) {
                            originalItem.collectStatue = true;
                            return true;
                        }
                    });
                });
            }, function (err) {});
        }
    }, {
        key: '$onInit',
        value: function $onInit() {
            //如果文章作者即用户本人 跳转到我的作品
            if (this.appUser && this.$state.params.id == this.appUser.uuid) {
                this.$state.go('app.home.originals.articles');
                return;
            }
        }
    }, {
        key: 'orderSearch',
        value: function orderSearch() {
            this.loadOriginals();
        }
    }]);
    return AuthorController;
}();

exports.default = AuthorController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1084);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./author.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./author.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "author .originals .highlight {\n  color: #ff3333; }\n\nauthor .originals .position {\n  position: relative; }\n\nauthor .originals .search-form {\n  position: absolute;\n  right: 0;\n  top: 12px;\n  width: 200px;\n  z-index: 1; }\n  author .originals .search-form .input {\n    line-height: 30px;\n    height: 30px;\n    width: 100%;\n    padding: 0 50px 0 10px;\n    display: block;\n    font-size: 14px;\n    color: #666666;\n    border: 1px solid #dadedd;\n    border-radius: 2px; }\n  author .originals .search-form .submit {\n    position: absolute;\n    right: 0;\n    top: 0;\n    cursor: pointer;\n    width: 40px;\n    height: 30px;\n    line-height: 30px;\n    border: none;\n    border: 1px solid #dadedd;\n    -webkit-appearance: none;\n    background: none;\n    color: #999999; }\n    author .originals .search-form .submit:hover {\n      background-color: #f5f5f5; }\n\nauthor .originals .block-content {\n  position: relative; }\n  author .originals .block-content .order-tab {\n    position: absolute;\n    right: 0;\n    bottom: 100%;\n    font-size: 0;\n    padding-bottom: 13px; }\n    author .originals .block-content .order-tab .tab {\n      cursor: pointer;\n      display: inline-block;\n      line-height: 1;\n      border-left: 1px solid #dadedd;\n      text-align: right;\n      margin-left: 20px;\n      padding-left: 20px;\n      font-size: 14px;\n      color: #999999; }\n      author .originals .block-content .order-tab .tab:first-child {\n        border-left: none; }\n      author .originals .block-content .order-tab .tab.active {\n        color: #222222; }\n  author .originals .block-content .article-list {\n    position: relative;\n    min-height: 500px;\n    padding: 0 0 26px 0; }\n    author .originals .block-content .article-list .placeholder {\n      position: absolute;\n      width: 100px;\n      height: 100px;\n      top: 50%;\n      left: 50%;\n      margin-top: -50px;\n      margin-left: -50px; }\n    author .originals .block-content .article-list > .item {\n      position: relative;\n      display: block;\n      border-bottom: 1px solid #e8eaea;\n      text-decoration: none; }\n      author .originals .block-content .article-list > .item:last-child {\n        border-bottom: 0; }\n      author .originals .block-content .article-list > .item .title {\n        position: relative;\n        overflow: hidden;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n        margin-right: 110px;\n        font-weight: bold;\n        font-size: 18px;\n        color: #222222;\n        padding: 20px 0 10px; }\n      author .originals .block-content .article-list > .item:hover > .title {\n        color: #00816a; }\n      author .originals .block-content .article-list > .item .cont {\n        overflow: auto; }\n        author .originals .block-content .article-list > .item .cont .photo {\n          width: 108px;\n          height: 80px;\n          float: right;\n          margin-left: 20px; }\n        author .originals .block-content .article-list > .item .cont .summary {\n          font-size: 14px;\n          color: #666666;\n          line-height: 1.8;\n          word-break: break-word; }\n      author .originals .block-content .article-list > .item .details {\n        position: relative;\n        padding: 15px 0 4px 0;\n        font-size: 0; }\n        author .originals .block-content .article-list > .item .details .detail {\n          font-size: 12px;\n          margin-right: 20px;\n          display: inline-block;\n          color: #999999; }\n          author .originals .block-content .article-list > .item .details .detail.collect {\n            float: right;\n            margin-right: 0;\n            font-size: 14px;\n            color: #e8eaea; }\n            author .originals .block-content .article-list > .item .details .detail.collect:hover, author .originals .block-content .article-list > .item .details .detail.collect.active {\n              color: #00816a; }\n          author .originals .block-content .article-list > .item .details .detail .icons {\n            vertical-align: top;\n            height: auto; }\n          author .originals .block-content .article-list > .item .details .detail .value {\n            display: inline-block; }\n  author .originals .block-content .image-list {\n    position: relative;\n    min-height: 500px;\n    padding: 20px 0; }\n    author .originals .block-content .image-list .placeholder {\n      position: absolute;\n      width: 100px;\n      height: 100px;\n      top: 50%;\n      left: 50%;\n      margin-top: -50px;\n      margin-left: -50px; }\n    author .originals .block-content .image-list .image-container {\n      overflow: auto; }\n    author .originals .block-content .image-list .image-item {\n      position: relative;\n      width: 206px;\n      height: 230px;\n      overflow: hidden;\n      border: 1px solid #e8eaea;\n      float: left;\n      margin: 0 20px 20px 0; }\n      author .originals .block-content .image-list .image-item:nth-child(3n) {\n        margin-right: 0; }\n      author .originals .block-content .image-list .image-item .thumbnail, author .originals .block-content .image-list .image-item .thumbnail-placeholder {\n        position: relative;\n        display: block;\n        width: 100%;\n        overflow: hidden;\n        height: 142px;\n        text-decoration: none; }\n        author .originals .block-content .image-list .image-item .thumbnail .dis-block, author .originals .block-content .image-list .image-item .thumbnail-placeholder .dis-block {\n          display: block;\n          height: 100%; }\n        author .originals .block-content .image-list .image-item .thumbnail .icon-box, author .originals .block-content .image-list .image-item .thumbnail-placeholder .icon-box {\n          position: absolute;\n          top: 10px;\n          right: 10px;\n          font-size: 0;\n          display: none; }\n          author .originals .block-content .image-list .image-item .thumbnail .icon-box .icon, author .originals .block-content .image-list .image-item .thumbnail-placeholder .icon-box .icon {\n            width: 32px;\n            height: 32px;\n            display: inline-block;\n            margin-left: 10px;\n            text-align: center;\n            color: #FFFFFF;\n            font-size: 16px;\n            line-height: 32px;\n            background: rgba(0, 0, 0, 0.5);\n            border-radius: 4px;\n            cursor: pointer;\n            text-decoration: none;\n            float: right; }\n            author .originals .block-content .image-list .image-item .thumbnail .icon-box .icon.active, author .originals .block-content .image-list .image-item .thumbnail-placeholder .icon-box .icon.active {\n              color: #00816a; }\n        author .originals .block-content .image-list .image-item .thumbnail:hover .icon-box, author .originals .block-content .image-list .image-item .thumbnail-placeholder:hover .icon-box {\n          display: block; }\n      author .originals .block-content .image-list .image-item .thumbnail-placeholder .image-placeholder {\n        position: absolute;\n        width: 100%;\n        height: 100%;\n        left: 0;\n        top: 0;\n        line-height: 142px;\n        text-align: center;\n        font-size: 12px;\n        color: #999999;\n        background-color: #f5f5f5; }\n      author .originals .block-content .image-list .image-item .info {\n        position: relative;\n        display: block;\n        text-decoration: none;\n        padding: 0 10px; }\n        author .originals .block-content .image-list .image-item .info .title {\n          font-size: 14px;\n          color: #666666;\n          height: 24px;\n          line-height: 24px;\n          margin-top: 10px;\n          font-weight: bold;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          white-space: nowrap; }\n        author .originals .block-content .image-list .image-item .info .line {\n          font-size: 12px;\n          color: #999999;\n          height: 22px;\n          line-height: 22px;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          white-space: nowrap; }\n          author .originals .block-content .image-list .image-item .info .line .line-item {\n            margin-right: 32px; }\n\nauthor .user {\n  background: url(" + __webpack_require__(1085) + ") center top no-repeat;\n  background-size: 100% auto;\n  display: block; }\n  author .user.with-iphone {\n    display: none; }\n  author .user .user-face {\n    width: 64px;\n    height: 64px;\n    border: 4px solid #fff;\n    border-radius: 4px;\n    position: relative;\n    margin: 33% auto 0;\n    font-size: 12px; }\n    author .user .user-face .img {\n      width: 100%;\n      height: 100%;\n      display: block; }\n    author .user .user-face .authentication {\n      position: absolute;\n      width: 51px;\n      left: 50%;\n      top: 100%;\n      margin: -8px 0 0 -25px; }\n  author .user .pseudonym {\n    font-size: 14px;\n    font-weight: bold;\n    text-align: center;\n    margin-top: 15px;\n    line-height: 1.4;\n    height: 22px; }\n  author .user .introduction {\n    color: #999999;\n    font-size: 14px;\n    text-align: center;\n    margin-top: 10px;\n    padding: 0 30px;\n    overflow-wrap: break-word;\n    word-wrap: break-word;\n    -ms-word-break: break-all;\n    word-break: break-word;\n    -ms-hyphens: auto;\n    -moz-hyphens: auto;\n    -webkit-hyphens: auto;\n    hyphens: auto; }\n  author .user .publish {\n    margin-top: 20px;\n    padding: 0 40px;\n    text-align: center;\n    font-size: 0; }\n    author .user .publish .item {\n      display: inline-block;\n      font-size: 12px;\n      width: 50%;\n      border-left: 1px solid #dadedd; }\n      author .user .publish .item:first-child {\n        border-left: none; }\n      author .user .publish .item .count {\n        padding: 0 4px; }\n  author .user .social {\n    margin-top: 30px; }\n    author .user .social .social-weixin {\n      position: relative; }\n      author .user .social .social-weixin .popover {\n        width: 170px;\n        height: 170px;\n        position: absolute;\n        top: 27px;\n        display: none;\n        text-decoration: none;\n        text-shadow: none;\n        text-transform: none;\n        letter-spacing: normal;\n        word-break: normal;\n        word-spacing: normal;\n        word-wrap: normal;\n        white-space: normal;\n        background-color: #fff;\n        background-clip: padding-box;\n        border: 1px solid rgba(0, 0, 0, 0.2);\n        box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);\n        line-break: auto; }\n        author .user .social .social-weixin .popover img {\n          width: 100%; }\n      author .user .social .social-weixin:hover .popover {\n        display: block; }\n    author .user .social a {\n      display: inline-block;\n      width: 24px;\n      height: 27px;\n      margin-left: 45px;\n      background-size: cover;\n      background: #fff no-repeat center center; }\n      author .user .social a.invalid {\n        cursor: not-allowed; }\n    author .user .social .social-weixin {\n      background-image: url(" + __webpack_require__(362) + "); }\n      author .user .social .social-weixin.invalid {\n        background-image: url(" + __webpack_require__(363) + "); }\n    author .user .social .social-weibo {\n      background-image: url(" + __webpack_require__(364) + "); }\n      author .user .social .social-weibo.invalid {\n        background-image: url(" + __webpack_require__(365) + "); }\n    author .user .social .social-toutiao {\n      background-image: url(" + __webpack_require__(179) + "); }\n      author .user .social .social-toutiao.invalid {\n        background-image: url(" + __webpack_require__(366) + "); }\n\nauthor navtab .navtab .tabs .tab {\n  margin-left: 16px;\n  font-weight: bold;\n  color: #999999; }\n  author navtab .navtab .tabs .tab:first-child {\n    margin-left: 0; }\n  author navtab .navtab .tabs .tab:hover {\n    color: #00816a; }\n  author navtab .navtab .tabs .tab.active, author navtab .navtab .tabs .tab.active:hover {\n    font-weight: bold;\n    color: #00816a;\n    border-bottom: 2px solid #00816a; }\n\n.image-description {\n  padding: 10px 10px; }\n  .image-description .image-title {\n    color: #666666;\n    background: white;\n    text-align: left;\n    font-size: 14px;\n    font-weight: bold;\n    word-break: break-all; }\n  .image-description .description-content {\n    color: #999999;\n    font-size: 12px;\n    text-align: left;\n    margin-top: 8px;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap; }\n\n@media only screen and (max-width: 767px) {\n  author .originals .block-content .article-list > .item .title {\n    margin-right: 0; }\n  author .originals .block-content .article-list > .item:hover > .title {\n    color: #222222; }\n  original .original .right-cont .author {\n    padding: 45px 0 20px; }\n  author .user .user-face {\n    margin: 0 auto; }\n  author .user {\n    background-size: 100% 100%;\n    padding: 20px 0;\n    display: none; }\n    author .user.with-iphone {\n      display: block; }\n  author .originals .block-content .article-list > .item .details .detail {\n    margin-right: 5px; }\n    author .originals .block-content .article-list > .item .details .detail.collect {\n      font-size: 18px;\n      margin-top: -3px; }\n  author .originals .block-content .image-list .image-item {\n    width: 48%;\n    overflow: hidden;\n    margin: 0 4% 4% 0 !important; }\n    author .originals .block-content .image-list .image-item:nth-child(2n) {\n      margin: 0 0 4% 0 !important; }\n  author .originals .block-content .image-list .image-item .thumbnail .dis-block,\n  author .originals .block-content .image-list .image-item .thumbnail-placeholder .dis-block {\n    display: block;\n    height: 100%; } }\n", ""]);

// exports


/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6353e99d77cf31a63b81eca874f095d0.jpg";

/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

/**
 * Created by ganlu on 20/01/2017.
 */
exports.default = function () {
    return function (scope, element) {
        element.on('error', function () {
            scope.$apply(function () {
                scope.unavailableImages[scope.image.yuanben_id] = 1;
            });
        });
    };
};

/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _announcement = __webpack_require__(1088);

var _announcement2 = _interopRequireDefault(_announcement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var announcementModule = _angular2.default.module('announcement', []).component('announcement', _announcement2.default).name;

var states = [{
    name: 'announcement',
    url: '/announcement/{id}',
    component: 'announcement'
}, {
    name: 'news',
    url: '/blog/{id}',
    component: 'announcement'
}];

exports.default = { name: announcementModule, states: states };

/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _announcement = __webpack_require__(1089);

var _announcement2 = _interopRequireDefault(_announcement);

var _announcement3 = __webpack_require__(1090);

var _announcement4 = _interopRequireDefault(_announcement3);

__webpack_require__(1091);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var announcementComponent = {
    restrict: 'E',
    bindings: {},
    template: _announcement2.default,
    controller: _announcement4.default
};

exports.default = announcementComponent;

/***/ }),
/* 1089 */
/***/ (function(module, exports) {

module.exports = "<div class=\"announcement block\">\n    <div class=\"block-content\">\n        <div class=\"title\">{{announcement.title}}</div>\n        <div class=\"info\">\n            <span class=\"item\">{{($ctrl.$state.is('app.page.news') ? 'face-newscenter-text03':'page-announcement-text001') | translate}}</span>\n            <span class=\"item\">{{'page-announcement-text002' | translate}}：{{announcement.published_at * 1000 | date : 'yyyy-MM-dd HH:mm'}}</span>\n        </div>\n        <div class=\"content\" ng-bind-html=\"contentHtml\"></div>\n    </div>\n</div>\n";

/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AnnouncementController = function AnnouncementController($state, $scope, $stateParams, $sce, AnnouncementAPI, NewAPI, pageTitle) {
    "ngInject";

    (0, _classCallCheck3.default)(this, AnnouncementController);
    $scope.announcement = null;
    $scope.error = false;
    $scope.contentHtml = '';
    this.$state = $state;
    var api = AnnouncementAPI;
    if ($state.is('app.page.news')) {
        api = NewAPI;
    }

    function init() {
        if (!$stateParams.id) {
            $scope.error = true;
            return;
        }

        api.one($stateParams.id).get().then(function (announcement) {
            $scope.announcement = announcement;
            pageTitle.setTitle(announcement.title);
            $scope.contentHtml = $sce.trustAsHtml($scope.announcement.content);
        }, function () {
            $scope.error = true;
        });
    }

    init();
};

AnnouncementController.$inject = ['$state', '$scope', '$stateParams', '$sce', 'AnnouncementAPI', 'NewAPI', 'pageTitle'];
exports.default = AnnouncementController;

/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1092);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./announcement.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./announcement.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".announcement {\n  position: relative;\n  width: 100%;\n  margin: 0 auto; }\n  .announcement .block-content {\n    padding: 30px 20px !important; }\n  .announcement .title {\n    text-align: center;\n    font-size: 20px;\n    color: #222222; }\n  .announcement .info {\n    position: relative;\n    margin-top: 8px;\n    text-align: center;\n    font-size: 14px;\n    color: #999999; }\n    .announcement .info .item {\n      margin: 6px; }\n  .announcement .content {\n    margin-top: 32px;\n    font-size: 16px;\n    color: #666666;\n    line-height: 1.8;\n    padding: 0 28px;\n    overflow-wrap: break-word;\n    word-wrap: break-word;\n    -ms-word-break: break-all;\n    word-break: break-word;\n    -ms-hyphens: auto;\n    -moz-hyphens: auto;\n    -webkit-hyphens: auto;\n    hyphens: auto; }\n    .announcement .content img {\n      max-width: 100%; }\n    .announcement .content p {\n      margin: 0; }\n\n@media only screen and (max-width: 767px) {\n  .announcement {\n    width: auto !important; }\n    .announcement .content {\n      padding: 0 !important; } }\n", ""]);

// exports


/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _terms = __webpack_require__(1094);

var _terms2 = _interopRequireDefault(_terms);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var termsModule = _angular2.default.module('terms', []).component('terms', _terms2.default).name;

var states = [{
    'name': 'terms',
    'url': '/terms',
    'component': 'terms',
    'title': 'page-terms-title'
}];

exports.default = { name: termsModule, states: states };

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _terms = __webpack_require__(1095);

var _terms2 = _interopRequireDefault(_terms);

__webpack_require__(1096);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var termsComponent = {
    restrict: 'E',
    bindings: {},
    template: _terms2.default
};

exports.default = termsComponent;

/***/ }),
/* 1095 */
/***/ (function(module, exports) {

module.exports = "<div class=\"terms block\">\n    <div class=\"block-content\">\n        <div class=\"title\">{{'page-terms-text001' | translate}}</div>\n        <div class=\"info\">\n            <span class=\"item\">{{'page-terms-text002' | translate}}</span>\n            <span class=\"item\">{{'page-terms-text003' | translate}}：2016-09-01</span>\n        </div>\n        <div class=\"content\">\n            <p><strong>{{'page-terms-text004' | translate}}</strong></p>\n            <p>&nbsp;</p>\n            <p>{{'page-terms-text005' | translate}}（<a href=\"https://yuanben.io\" target=\"_blank\">https://yuanben.io</a>），{{'page-terms-text069' | translate}}\n            </p>\n            <p>{{'page-terms-text006' | translate}}</p>\n            <p>&nbsp;</p>\n            <p><strong>{{'page-terms-text007' | translate}}</strong></p>\n            <p>&nbsp;</p>\n            <ul class=\"main\">\n                <li>\n                    {{'page-terms-text008' | translate}}\n                </li>\n                <li>\n                    {{'page-terms-text009' | translate}}\n                </li>\n                <li>\n                    {{'page-terms-text010' | translate}}\n                </li>\n                <li>\n                    {{'page-terms-text011' | translate}}\n                </li>\n            </ul>\n            <p>&nbsp;</p>\n            <p><strong>{{'page-terms-text012' | translate}}</strong></p>\n            <p>&nbsp;</p>\n            <ul class=\"main\">\n                <li>\n                    {{'page-terms-text013' | translate}}\n                </li>\n                <li>\n                    {{'page-terms-text014' | translate}}\n                </li>\n                <li>\n                    {{'page-terms-text015' | translate}}\n                </li>\n            </ul>\n            <p>&nbsp;</p>\n            <p><strong>{{'page-terms-text016' | translate}}</strong></p>\n            <p>&nbsp;</p>\n            <p>{{'page-terms-text017' | translate}}</p>\n            <p>&nbsp;</p>\n            <p><strong>{{'page-terms-text018' | translate}}</strong></p>\n            <p>&nbsp;</p>\n            <ul class=\"main\">\n                <li>\n                    {{'page-terms-text019' | translate}}\n                </li>\n                <li>\n                    {{'page-terms-text020' | translate}}\n                </li>\n                <li>\n                    {{'page-terms-text021' | translate}}\n                </li>\n                <li>\n                    {{'page-terms-text022' | translate}}\n                    <ul>\n                        <li>{{'page-terms-text023' | translate}}</li>\n                        <li>{{'page-terms-text024' | translate}}</li>\n                        <li>{{'page-terms-text025' | translate}}</li>\n                        <li>{{'page-terms-text026' | translate}}</li>\n                        <li>{{'page-terms-text027' | translate}}</li>\n                        <li>{{'page-terms-text028' | translate}}</li>\n                        <li>{{'page-terms-text029' | translate}}</li>\n                        <li>{{'page-terms-text030' | translate}}</li>\n                        <li>{{'page-terms-text031' | translate}}</li>\n                    </ul>\n                </li>\n                <li>\n                    {{'page-terms-text032' | translate}}\n                </li>\n                <li>\n                    {{'page-terms-text033' | translate}}\n                </li>\n            </ul>\n            <p>&nbsp;</p>\n            <p><strong>{{'page-terms-text034' | translate}}</strong></p>\n            <p>&nbsp;</p>\n            <ul class=\"main\">\n                <li>\n                    {{'page-terms-text035' | translate}}\n                </li>\n                <li>\n                    {{'page-terms-text036' | translate}}\n                    <ul>\n                        <li>{{'page-terms-text037' | translate}}</li>\n                        <li>{{'page-terms-text038' | translate}}</li>\n                        <li>{{'page-terms-text039' | translate}}</li>\n                        <li>{{'page-terms-text040' | translate}}</li>\n                        <li>{{'page-terms-text041' | translate}}</li>\n                    </ul>\n                </li>\n                <li>\n                    {{'page-terms-text042' | translate}}\n                </li>\n                <li>\n                    {{'page-terms-text043' | translate}}\n                </li>\n            </ul>\n            <p>&nbsp;</p>\n            <p><strong>{{'page-terms-text044' | translate}}</strong></p>\n            <p>&nbsp;</p>\n            <ul class=\"main\">\n                <li>\n                    {{'page-terms-text045' | translate}}\n                </li>\n                <li>\n                    {{'page-terms-text046' | translate}}\n                </li>\n                <li>\n                    {{'page-terms-text047' | translate}}\n                </li>\n                <li>\n                    {{'page-terms-text048' | translate}}\n                </li>\n                <li>\n                    {{'page-terms-text049' | translate}}\n                </li>\n                <li>\n                    {{'page-terms-text050' | translate}}\n                </li>\n            </ul>\n            <p>&nbsp;</p>\n            <p><strong>{{'page-terms-text070' | translate}}</strong></p>\n            <p>&nbsp;</p>\n            <ul class=\"main\">\n                <li>\n                    {{'page-terms-text0701' | translate}}\n                </li>\n                <li>\n                    {{'page-terms-text0702' | translate}}\n                </li>\n                <li>\n                    {{'page-terms-text0703' | translate}}\n                </li>\n                <li>\n                    {{'page-terms-text0704' | translate}}\n                </li>\n\n            </ul>\n            <p>&nbsp;</p>\n            <p><strong>{{'page-terms-text051' | translate}}</strong></p>\n            <p>&nbsp;</p>\n            <ul class=\"main\">\n                <li>\n                    {{'page-terms-text052' | translate}}\n                </li>\n                <li>\n                    {{'page-terms-text053' | translate}}\n                </li>\n                <li>\n                    {{'page-terms-text054' | translate}}\n                </li>\n                <li>\n                    {{'page-terms-text055' | translate}}\n                </li>\n            </ul>\n            <p>&nbsp;</p>\n            <p><strong>{{'page-terms-text056' | translate}}</strong></p>\n            <p>&nbsp;</p>\n            <ul class=\"main\">\n                <li>\n                    {{'page-terms-text057' | translate}}\n                </li>\n                <li>\n                    {{'page-terms-text058' | translate}}\n                </li>\n            </ul>\n            <p>&nbsp;</p>\n            <p><strong>{{'page-terms-text059' | translate}}</strong></p>\n            <p>&nbsp;</p>\n            <ul class=\"main\">\n                <li>\n                    {{'page-terms-text060' | translate}}\n                </li>\n                <li>\n                    {{'page-terms-text061' | translate}}\n                </li>\n                <li>\n                    {{'page-terms-text062' | translate}}\n                </li>\n                <li>\n                    {{'page-terms-text063' | translate}}\n                </li>\n            </ul>\n            <p>&nbsp;</p>\n            <p><strong>{{'page-terms-text064' | translate}}</strong></p>\n            <p>&nbsp;</p>\n            <ul class=\"main\">\n                <li>\n                    {{'page-terms-text065' | translate}}\n                </li>\n                <li>\n                    {{'page-terms-text066' | translate}}\n                </li>\n                <li>\n                    {{'page-terms-text067' | translate}}\n                </li>\n                <li>\n                    {{'page-terms-text068' | translate}}\n                </li>\n            </ul>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1097);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./terms.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./terms.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "terms {\n  display: block;\n  position: relative;\n  width: 100%;\n  margin: 0 auto; }\n  terms .block-content {\n    padding: 30px 20px !important; }\n    terms .block-content > .title {\n      text-align: center;\n      font-size: 20px;\n      color: #222222; }\n  terms .info {\n    position: relative;\n    margin-top: 8px;\n    text-align: center;\n    font-size: 14px;\n    color: #999999; }\n    terms .info .item {\n      margin: 6px; }\n  terms .content {\n    margin-top: 32px;\n    font-size: 14px;\n    color: #666666;\n    line-height: 1.8;\n    padding: 0 28px;\n    overflow-wrap: break-word;\n    word-wrap: break-word;\n    -ms-word-break: break-all;\n    word-break: break-word;\n    -ms-hyphens: auto;\n    -moz-hyphens: auto;\n    -webkit-hyphens: auto;\n    hyphens: auto; }\n    terms .content img {\n      max-width: 100%; }\n    terms .content p {\n      margin: 0;\n      width: auto !important;\n      height: auto !important; }\n    terms .content ul.main {\n      list-style: decimal;\n      -webkit-padding-start: 15px;\n      -webkit-margin-before: 0;\n      -webkit-margin-after: 0; }\n      terms .content ul.main ul {\n        list-style: disc;\n        -webkit-padding-start: 15px; }\n\n@media only screen and (max-width: 767px) {\n  terms {\n    width: auto !important; }\n    terms .content {\n      padding: 0 !important; } }\n", ""]);

// exports


/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _career = __webpack_require__(1099);

var _career2 = _interopRequireDefault(_career);

var _careerIntro = __webpack_require__(1104);

var _careerIntro2 = _interopRequireDefault(_careerIntro);

var _developers = __webpack_require__(1110);

var _developers2 = _interopRequireDefault(_developers);

var _uiDesign = __webpack_require__(1115);

var _uiDesign2 = _interopRequireDefault(_uiDesign);

var _administrative = __webpack_require__(1120);

var _administrative2 = _interopRequireDefault(_administrative);

var _algorithms = __webpack_require__(1125);

var _algorithms2 = _interopRequireDefault(_algorithms);

var _products = __webpack_require__(1131);

var _products2 = _interopRequireDefault(_products);

var _ai = __webpack_require__(1137);

var _ai2 = _interopRequireDefault(_ai);

var _system = __webpack_require__(1142);

var _system2 = _interopRequireDefault(_system);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var childModules = [_careerIntro2.default, _developers2.default, _uiDesign2.default, _administrative2.default, _algorithms2.default, _products2.default, _ai2.default, _system2.default];

var states = [{
    name: 'career',
    abstract: true,
    component: 'career'
}];

var childModuleNames = [];

childModules.forEach(function (m) {
    childModuleNames.push(m.name);

    m.states.forEach(function (s) {

        s.name = 'career.' + s.name;

        states.push(s);
    });
});

var careerModule = _angular2.default.module('career', childModuleNames).component('career', _career2.default).name;

exports.default = { name: careerModule, states: states };

/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _career = __webpack_require__(1100);

var _career2 = _interopRequireDefault(_career);

var _career3 = __webpack_require__(1101);

var _career4 = _interopRequireDefault(_career3);

__webpack_require__(1102);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var termsComponent = {
    restrict: 'E',
    bindings: {},
    template: _career2.default,
    controller: _career4.default
}; /**
    * Created by ganlu on 17/02/2017.
    */
exports.default = termsComponent;

/***/ }),
/* 1100 */
/***/ (function(module, exports) {

module.exports = "<navtab tabs=\"$ctrl.tabs\"></navtab>\n<div class=\"career-content\" ui-view></div>\n";

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by ganlu on 28/03/2017.
 */
var CareerController = function CareerController($state) {
    "ngInject";

    (0, _classCallCheck3.default)(this, CareerController);
    this.tabs = [{
        name: '原本简介',
        click: function click() {
            $state.go('app.page.career.intro');
        },
        active: $state.is('app.page.career.intro')
    }, {
        name: '区块链',
        click: function click() {
            $state.go('app.page.career.algorithms');
        },
        active: $state.is('app.page.career.algorithms')
    }, {
        name: '人工智能',
        click: function click() {
            $state.go('app.page.career.ai');
        },
        active: $state.is('app.page.career.ai')
    }, {
        name: '客户端',
        click: function click() {
            $state.go('app.page.career.developers');
        },
        active: $state.is('app.page.career.developers')
    }, {
        name: '系统开发',
        click: function click() {
            $state.go('app.page.career.system');
        },
        active: $state.is('app.page.career.system')
    }, {
        name: '产品运营',
        click: function click() {
            $state.go('app.page.career.products');
        },
        active: $state.is('app.page.career.products')
    }, {
        name: 'UI设计',
        click: function click() {
            $state.go('app.page.career.uiDesign');
        },
        active: $state.is('app.page.career.uiDesign')
    }, {
        name: '行政主管',
        click: function click() {
            $state.go('app.page.career.administrative');
        },
        active: $state.is('app.page.career.administrative')
    }];
};

CareerController.$inject = ['$state'];
exports.default = CareerController;

/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1103);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./career.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./career.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "career {\n  display: block;\n  position: relative;\n  width: 100%;\n  margin: 0 auto; }\n  career navtab {\n    display: block;\n    background-color: #ffffff; }\n    career navtab .navtab {\n      padding: 0 20px; }\n      career navtab .navtab .tabs .tab {\n        width: auto;\n        margin: 10px 18px; }\n  career .block-content {\n    padding: 30px 20px !important; }\n    career .block-content > .title {\n      text-align: center;\n      font-size: 20px;\n      color: #222222; }\n  career .content {\n    margin-top: 32px;\n    font-size: 14px;\n    color: #666666;\n    line-height: 1.8;\n    padding: 0 28px;\n    overflow-wrap: break-word;\n    word-wrap: break-word;\n    -ms-word-break: break-all;\n    word-break: break-word;\n    -ms-hyphens: auto;\n    -moz-hyphens: auto;\n    -webkit-hyphens: auto;\n    hyphens: auto; }\n    career .content img {\n      max-width: 100%; }\n    career .content p {\n      margin: 0;\n      width: auto !important;\n      height: auto !important; }\n    career .content ul.main {\n      list-style: decimal;\n      -webkit-padding-start: 15px;\n      -webkit-margin-before: 0;\n      -webkit-margin-after: 0; }\n      career .content ul.main ul {\n        list-style: disc;\n        -webkit-padding-start: 15px; }\n    career .content a {\n      text-decoration: none;\n      color: #00816a; }\n      career .content a:hover {\n        text-decoration: underline; }\n\n@media only screen and (max-width: 767px) {\n  career {\n    width: auto !important; }\n    career navtab {\n      display: block;\n      background-color: #ffffff;\n      height: 80px; }\n      career navtab .navtab {\n        height: auto;\n        padding: 0; }\n        career navtab .navtab .tabs {\n          height: auto; }\n          career navtab .navtab .tabs .tab {\n            width: 33.333%;\n            padding: 0;\n            margin: 0;\n            height: 40px;\n            line-height: 40px; }\n    career .content {\n      padding: 0 !important; } }\n", ""]);

// exports


/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _careerIntro = __webpack_require__(1105);

var _careerIntro2 = _interopRequireDefault(_careerIntro);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var careerIntroModule = _angular2.default.module('careerIntro', []).component('careerIntro', _careerIntro2.default).name;

var states = [{
    'name': 'intro',
    'url': '/career',
    'component': 'careerIntro',
    'title': '加入原本'
}];

exports.default = { name: careerIntroModule, states: states };

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _careerIntro = __webpack_require__(1106);

var _careerIntro2 = _interopRequireDefault(_careerIntro);

var _careerIntro3 = __webpack_require__(1107);

var _careerIntro4 = _interopRequireDefault(_careerIntro3);

__webpack_require__(1108);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var careerIntroComponent = {
    restrict: 'E',
    bindings: {},
    template: _careerIntro2.default,
    controller: _careerIntro4.default
};

exports.default = careerIntroComponent;

/***/ }),
/* 1106 */
/***/ (function(module, exports) {

module.exports = "<div class=\"career-intro block\">\n    <div class=\"block-content\">\n        <div class=\"title\">加入原本</div>\n        <div class=\"content\">\n            <p>「原本」是一个基于区块链技术的原创认证和交易的平台。提供版权信息追溯、自助版权交易和全网侵权检测等功能。</p>\n            <p>&nbsp;</p>\n            <p>区块链是一种来自比特币的去中心化总账技术。在最近一年的时间里，其火热程度不断攀升，已经成为了继大数据、深度学习之后的新一轮技术浪潮，即将改变整个社会的运转方式。国内外各大银行和企业都在研发或者已经推出基于区块链的产品。除金融领域之外，区块链在征信、供应链、医疗等传统领域也逐渐获得了更广泛的应用。互联网解决了信息传递的问题，而区块链将会解决价值交换的问题，帮助互联网完成从信息网络到价值网络的转型。</p>\n            <p>&nbsp;</p>\n            <p>我们早在2015年就开始了将区块链应用于版权领域的尝试，并和国内外前沿的区块链研究者和社区保持着紧密的联系，16年成为上海区块链产业发展联盟的首批成员。</p>\n            <p>&nbsp;</p>\n            <p>我们的目标是使用区块链来重构知识产权领域的价值分配体系，让原创作品产生的收益从渠道、平台回到原创作者手中。除了为原创作者带来更大利益以外，这种重构还能同时起到过滤低质量内容、杜绝虚假消息传播的作用，给我们带来一个更加健康的网络媒体环境。</p>\n            <p>&nbsp;</p>\n            <p>关于「原本」的媒体报道</p>\n            <ul>\n                <li><a href=\"http://tv.cctv.com/2018/12/19/VIDEE6dJ3sy2whmuJcz30csD181219.shtml\" target=\"_blank\">[新闻直播间]北京 中国财经媒体版权保护联盟成立 - CCTV13</a></li>\n                <li><a href=\"http://paper.people.com.cn/gjjrb/html/2018-12/24/content_1900352.htm\" target=\"_blank\">中国财经媒体版权保护联盟成立 助力新闻版权市场健康发展 - 国际金融报</a></li>\n                <li><a href=\"http://36kr.com/p/5065973.html\" target=\"_blank\">区块链+版权服务，\"原本\"除了想通过区块链解决版权问题外，还想成为版权的分发平台 - 36氪</a></li>\n                <li><a href=\"http://web.shobserver.com/wx/detail.do?id=45882\" target=\"_blank\">区块链技术只能用于金融？上海创业者说“不” - 上观新闻</a></li>\n                <li><a href=\"http://www.pdtimes.com.cn/html/2017-05/15/content_4_1.htm\" target=\"_blank\">国内首个区块链+版权保护平台上线 - 浦东时报</a></li>\n                <li><a href=\"http://sh.people.com.cn/n2/2017/0526/c137167-30244855.html\" target=\"_blank\">国内首个区块链+版权保护平台上线 为版权保驾护航 - 人民网</a></li>\n                <li><a href=\"http://sh.people.com.cn/n2/2017/0919/c134768-30750899.html\" target=\"_blank\">重塑边界，科技打开张江文创产业新天地 - 人民网</a></li>\n                <li><a href=\"https://mp.weixin.qq.com/s/qyr8adm0RvxU0xvWTotKIQ\" target=\"_blank\">区块链“搅局”媒体版权保护与开发 - 传媒茶话会</a></li>\n                <li><a href=\"http://paper.people.com.cn/rmrb/html/2018-04/10/nw.D110000renmrb_20180410_8-21.htm\" target=\"_blank\">开源协议助力信息传播 - 人民日报</a></li>\n                <li><a href=\"http://paper.ce.cn/jjrb/html/2018-04/12/content_360004.htm\" target=\"_blank\">上海七印信息科技创始人吴鹏：区块链有助重塑品牌新生态 - 经济日报</a></li>\n                <li><a href=\"http://tv.cctv.com/2018/04/10/VIDEbD8Yq2PjEwv2EWWJwRtU180410.shtml\" target=\"_blank\">原本区块链CEO&创始人吴鹏参加2018年博鳌论坛 - CCTV2 中央电视台视频采访</a></li>\n                <li><a href=\"https://v.qq.com/x/page/v0810i6x3bm.html\" target=\"_blank\">原本区块链受上海电视台采访，致力创造和守护中国价值 - 上海电视台 聚焦自贸区频道专访</a></li>\n                <li><a href=\"http://www.forbeschina.com/review/201809/0067109.shtml\" target=\"_blank\">区块链要让互联网不再是“垃圾场” - 福布斯中国</a></li>\n                <li><a href=\"https://www.siti.sh.cn/files/file/%E4%B8%8A%E4%BC%A0-%E7%99%BD%E7%9A%AE%E4%B9%A6/2018%E4%B8%8A%E6%B5%B7%E5%8C%BA%E5%9D%97%E9%93%BE%E6%8A%80%E6%9C%AF%E4%B8%8E%E5%BA%94%E7%94%A8%E7%99%BD%E7%9A%AE%E4%B9%A6.pdf\" target=\"_blank\">2018 上海区块链技术与应用白皮书 - 上海产业技术研究院</a></li>\n                <li><a href=\"http://sh.news.163.com/18/0929/17/DSSTJB6T04188GRN.html\" target=\"_blank\">日本2018科技金融峰会召开，原本区块链受邀做项目分享 - 网易</a></li>\n                <li><a href=\"https://mp.weixin.qq.com/s/3MfBiyW8cmLNnQjtOy8mQw\" target=\"_blank\">“被炒币耽误”的区块链在互联网法院上线，有何深意？ - 传媒茶话会</a></li>\n                <li><a href=\"http://finance.ifeng.com/a/20181121/16582766_0.shtml\" target=\"_blank\">新加坡普惠金融科技峰会召开，从业者认为区块链行业最大挑战是人性 - 凤凰财经</a></li>\n                <li><a href=\"https://www.maritime-executive.com/article/chinese-blockchain-company-targets-maritime-silk-road\" target=\"_blank\">Chinese Blockchain Company Targets Maritime Silk Road - The Maritime Executive</a></li>\n                <li><a href=\"https://www.shine.cn/opinion/chinese-views/1809172236/\" target=\"_blank\">Blockchain entrepreneur takes aim at word theft and rumor-mongering in cyberspace - Shanghai Daily</a></li>\n                <li><a href=\"http://usa.chinadaily.com.cn/a/201807/04/WS5b3c0f4aa3103349141e086a.html\" target=\"_blank\">Blockchain hailed as next frontier - ChinaDaily</a></li>\n                <li><a href=\"https://worldview.stratfor.com/article/can-blockchain-technology-bring-smooth-seas-global-shipping\" target=\"_blank\">Can Blockchain Technology Bring Smooth Seas to Global Shipping? - Stratfor</a></li>\n            </ul>\n            <p>&nbsp;</p>\n            <p>&nbsp;</p>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CareerIntroController = function CareerIntroController() {
    (0, _classCallCheck3.default)(this, CareerIntroController);

    this.name = 'career-intro';
};

exports.default = CareerIntroController;

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1109);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./career-intro.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./career-intro.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _developers = __webpack_require__(1111);

var _developers2 = _interopRequireDefault(_developers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var developersModule = _angular2.default.module('developers', []).component('developers', _developers2.default).name;

var states = [{
    name: 'developers',
    url: '/career/client',
    component: 'developers',
    title: '客户端研发招聘'
}];

exports.default = { name: developersModule, states: states };

/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _developers = __webpack_require__(1112);

var _developers2 = _interopRequireDefault(_developers);

__webpack_require__(1113);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var developersComponent = {
    restrict: 'E',
    bindings: {},
    template: _developers2.default
};

exports.default = developersComponent;

/***/ }),
/* 1112 */
/***/ (function(module, exports) {

module.exports = "<div class=\"developers block\">\n    <div class=\"block-content\">\n        <div class=\"title\">客户端相关职位</div>\n        <div class=\"content\">\n            <h3>职位列表</h3>\n            <ul>\n              <li><a href=\"#s1\">高级iOS工程师</a></li>\n              <li><a href=\"#s2\">高级Android工程师</a></li>\n              <li><a href=\"#s3\">前端工程师</a></li>\n            </ul>\n            <h3>基本信息</h3>\n            <ul>\n                <li>公司介绍：<a ui-sref=\"app.page.career.intro\" target=\"_blank\">点击查看公司及团队介绍</a></li>\n                <li>工作地点：上海市虹口区乍浦路512号SOHO裙楼（近四川北路地铁站2号口）</li>\n                <li>学历要求：计算机相关专业本科及以上，工作经验：1-3年</li>\n                <li>薪资范围：15k-30k</li>\n                <li>简历投递：hr@yuanben.org</li>\n            </ul>\n            <p>&nbsp;</p>\n            <h2 id=\"s1\">高级iOS工程师</h2>\n            <h4>岗位职责</h4>\n            <ul>\n                <li>负责iOS移动端产品的技术架构及研发</li>\n                <li>持续提升iOS移动端产品的用户体验</li>\n            </ul>\n            <h4>任职要求</h4>\n            <ul>\n                <li>基本的数据结构、算法和数据库知识</li>\n                <li>精通Swift语言，熟练使用Xcode进行开发调试</li>\n                <li>熟悉UIKit、CoreData等iOS基础框架</li>\n                <li>熟悉常用设计模式，良好的代码风格</li>\n            </ul>\n            <h4>加分项</h4>\n            <ul>\n                <li>有个人上架App</li>\n                <li>有带领团队进行iOS开发的相关经验</li>\n                <li>熟悉区块链技术</li>\n            </ul>\n            <p>&nbsp;</p>\n            <h2 id=\"s2\">高级Android工程师</h2>\n            <h4>岗位职责</h4>\n            <ul>\n                <li>负责Android移动端产品的技术架构及研发</li>\n                <li>Android相关的创新项目技术攻关</li>\n            </ul>\n            <h4>任职要求</h4>\n            <ul>\n                <li>本科以上学历，1-3年工作经验</li>\n                <li>精通Java语言，熟练使用核心类库</li>\n                <li>熟悉RxJava、Realm、Retrofit等常用框架</li>\n                <li>深入理解Android系统应用管理、进程管理、内存管理机制</li>\n                <li>熟悉Android的自动化测试框架，有UI Automation的经验</li>\n                <li>熟悉常用设计模式，良好的代码风格</li>\n                <li>良好的自我驱动力、主动沟通和表达能力</li>\n                <li>乐于挑战没有现成方案的技术问题</li>\n            </ul>\n            <h4>加分项</h4>\n            <ul>\n                <li>有Android项目管理经验</li>\n                <li>有区块链相关项目开发经验</li>\n                <li>Android逆向工程经验，熟悉Xposed等框架</li>\n            </ul>\n            <p>&nbsp;</p>\n            <h2 id=\"s3\">前端工程师</h2>\n            <h4>岗位职责</h4>\n            <ul>\n                <li>负责Web应用的前端开发</li>\n                <li>负责区块链平台的前端开发</li>\n            </ul>\n            <h4>任职要求</h4>\n            <ul>\n                <li>基本的数据结构、算法和数据库知识</li>\n                <li>熟练使用下列至少一种前端框架如Vue/React/Angular</li>\n                <li>熟练使用ES6，SASS/LESS/Stylus等</li>\n                <li>熟悉Webpack/gulp等构建工具，对前端工程化有一定了解</li>\n            </ul>\n            <h4>加分项</h4>\n            <ul>\n                <li>了解至少一门后端语言如Nodejs/PHP/Java/Python/Go</li>\n                <li>Github等开源社区贡献者</li>\n                <li>区块链 (智能合约)</li>\n            </ul>\n            <p>&nbsp;</p>\n            <p>&nbsp;</p>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1114);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./developers.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./developers.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _uiDesign = __webpack_require__(1116);

var _uiDesign2 = _interopRequireDefault(_uiDesign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var uiDesignModule = _angular2.default.module('uiDesign', []).component('uiDesign', _uiDesign2.default).name;

var states = [{
    name: 'uiDesign',
    url: '/career/uiDesign',
    component: 'uiDesign',
    title: '视觉／UI设计招聘'
}];

exports.default = { name: uiDesignModule, states: states };

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _uiDesign = __webpack_require__(1117);

var _uiDesign2 = _interopRequireDefault(_uiDesign);

__webpack_require__(1118);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var uiDesignComponent = {
    restrict: 'E',
    bindings: {},
    template: _uiDesign2.default
};

exports.default = uiDesignComponent;

/***/ }),
/* 1117 */
/***/ (function(module, exports) {

module.exports = "<div class=\"developers block\">\n    <div class=\"block-content\">\n        <div class=\"title\">视觉／UI设计相关职位</div>\n        <div class=\"content\">\n            <h3>基本信息</h3>\n            <ul>\n                <li>公司介绍：<a ui-sref=\"app.page.career.intro\" target=\"_blank\">点击查看公司及团队介绍</a></li>\n                <li>工作地点：上海市虹口区乍浦路512号SOHO裙楼（近四川北路地铁站2号口）</li>\n                <li>学历要求：本科学历及以上，专业不限，工作经验：2-5年</li>\n                <li>薪资范围：8k-15k</li>\n                <li>简历投递：hr@yuanben.org</li>\n            </ul>\n            <p>&nbsp;</p>\n            <h2>视觉／UI设计招聘</h2>\n            <h4>岗位职责</h4>\n            <ul>\n                <li>负责网站平台UI界面设计，icon绘制插图绘制等，懂交互，会绘制简单原型</li>\n                <li>负责IOS端，android端产品整体UI设计</li>\n                <li>负责公司品牌相关设计。设计有助于品牌推广的网站Banner，印刷品，HTML5等</li>\n                <li>线下活动的视觉设计及周边物料设计</li>\n            </ul>\n            <h4>任职要求</h4>\n            <ul>\n                <li>熟练掌握Adobe Photoshop和Adobe Illustrator，sketch。会使用交互原型工具。会一些AE以及三维软件</li>\n                <li>逻辑思维强，具有产品概念，同时关注细节</li>\n                <li>善于思考，乐于沟通。良好的表达，极为高效的执行力</li>\n                <li>对设计充满热情，关注国内外设计动向，了解设计趋势，乐于分享</li>\n                <li>喜爱新兴的科技并有一定了解。乐观开朗，对新鲜事物抱有热情，喜爱探索</li>\n                <li>细节把控到位，能把设计做到精致</li>\n                <li>有已上线产品的整体设计经验</li>\n            </ul>\n            <h4>加分项</h4>\n            <ul>\n                <li>具有较好的手绘表现力，擅长插画，会使用手绘板</li>\n                <li>有较优秀的摄影作品</li>\n            </ul>\n            <p>&nbsp;</p>\n            <p>&nbsp;</p>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1119);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./ui-design.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./ui-design.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _administrative = __webpack_require__(1121);

var _administrative2 = _interopRequireDefault(_administrative);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var administrativeModule = _angular2.default.module('administrative', []).component('administrative', _administrative2.default).name;

var states = [{
    name: 'administrative',
    url: '/career/administrative',
    component: 'administrative',
    title: '行政主管招聘'
}];

exports.default = { name: administrativeModule, states: states };

/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _administrative = __webpack_require__(1122);

var _administrative2 = _interopRequireDefault(_administrative);

__webpack_require__(1123);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var administrativeComponent = {
    restrict: 'E',
    bindings: {},
    template: _administrative2.default
};

exports.default = administrativeComponent;

/***/ }),
/* 1122 */
/***/ (function(module, exports) {

module.exports = "<div class=\"developers block\">\n    <div class=\"block-content\">\n        <div class=\"title\">行政主管相关职位</div>\n        <div class=\"content\">\n            <h3>基本信息</h3>\n            <ul>\n                <li>公司介绍：<a ui-sref=\"app.page.career.intro\" target=\"_blank\">点击查看公司及团队介绍</a></li>\n                <li>工作地点：上海市虹口区乍浦路512号SOHO裙楼（近四川北路地铁站2号口）</li>\n                <li>学历要求：本科学历及以上，专业不限，工作经验：1-3年</li>\n                <li>薪资范围：5k-8k</li>\n                <li>简历投递：hr@yuanben.org</li>\n            </ul>\n            <p>&nbsp;</p>\n            <h2>行政主管</h2>\n            <h4>岗位职责</h4>\n            <ul>\n                <li>公司财务管理</li>\n                <li>根据公司发展，编制和完善公司各项规章制度和行政流程，并负责规则制度的实施</li>\n                <li>协助完成对内沟通，对外接待等支持性工作，确保公司内部良好运行</li>\n                <li>合理规划，监控和妥善使用内部行政费用</li>\n                <li>负责公司年检、证照等资质的更新，熟悉政府部门办事流程</li>\n                <li>安排日常事务和团队建设活动</li>\n            </ul>\n            <h4>任职要求</h4>\n            <ul>\n                <li>为人诚实热情，对新鲜事物有较好的接受度和兴趣</li>\n                <li>有明确的职业规划，有较高的执行力和策划能力</li>\n                <li>乐于沟通， 团队意识强</li>\n                <li>注重细节</li>\n            </ul>\n            <h4>加分项</h4>\n            <ul>\n                <li>会计师资格证</li>\n                <li>人力资源经验</li>\n            </ul>\n            <p>&nbsp;</p>\n            <p>&nbsp;</p>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1124);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./administrative.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./administrative.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _algorithms = __webpack_require__(1126);

var _algorithms2 = _interopRequireDefault(_algorithms);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var algorithmsModule = _angular2.default.module('algorithms', []).component('algorithms', _algorithms2.default).name;

var states = [{
    name: 'algorithms',
    url: '/career/blockchain',
    component: 'algorithms',
    title: '区块链研发招聘'
}];

exports.default = { name: algorithmsModule, states: states };

/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _algorithms = __webpack_require__(1127);

var _algorithms2 = _interopRequireDefault(_algorithms);

var _algorithms3 = __webpack_require__(1128);

var _algorithms4 = _interopRequireDefault(_algorithms3);

__webpack_require__(1129);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var algorithmsComponent = {
    restrict: 'E',
    bindings: {},
    template: _algorithms2.default,
    controller: _algorithms4.default
};

exports.default = algorithmsComponent;

/***/ }),
/* 1127 */
/***/ (function(module, exports) {

module.exports = "<div class=\"developers block\">\n    <div class=\"block-content\">\n        <div class=\"title\">区块链相关职位</div>\n        <div class=\"content\">\n            <h3>职位列表</h3>\n            <ul>\n              <li><a href=\"#s1\">区块链工程师</a></li>\n            </ul>\n            <p>&nbsp;</p>\n            <h3>基本信息</h3>\n            <ul>\n                <li>公司介绍：<a ui-sref=\"app.page.career.intro\" target=\"_blank\">点击查看公司及团队介绍</a></li>\n                <li>工作地点：上海市虹口区乍浦路512号SOHO裙楼（近四川北路地铁站2号口）</li>\n                <li>学历要求：计算机相关专业本科及以上，工作经验：1-3年</li>\n                <li>薪资范围：20-40k</li>\n                <li>简历投递：hr@yuanben.org</li>\n            </ul>\n            <p>&nbsp;</p>\n            <h2 id=\"s1\">区块链工程师</h2>\n            <h4>岗位职责</h4>\n            <ul>\n                <li>负责联盟链相关的系统设计和研发</li>\n                <li>负责基于以太坊的Layer 2系统的设计和研发</li>\n            </ul>\n            <h4>任职要求</h4>\n            <ul>\n                <li>熟练掌握 Golang和Solidity，具备区块链项目研发经验</li>\n                <li>扎实的编程功底，有大型系统的架构经验</li>\n                <li>熟悉Fabric、Tendermint等常用区块链框架</li>\n                <li>熟悉Ethereum架构原理，熟悉智能合约的开发</li>\n                <li>了解主流的共识算法比如PoW、PoS、PBFT等</li>\n                <li>良好的自我驱动力、主动沟通和表达能力</li>\n            </ul>\n            <h4>加分项</h4>\n            <ul>\n                <li>了解大数据相关的算法原理和常用框架（比如Hadoop系列），有实际项目经验</li>\n                <li>了解零知识证明相关算法（比如zk-SNARKs）原理，有相关的项目经验</li>\n                <li>了解分布式存储的原理，有相关的项目经验</li>\n            </ul>\n            <p>&nbsp;</p>\n            <p>&nbsp;</p>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlgorithmsController = function AlgorithmsController() {
    (0, _classCallCheck3.default)(this, AlgorithmsController);

    this.name = 'algorithms';
};

exports.default = AlgorithmsController;

/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1130);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./algorithms.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./algorithms.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _products = __webpack_require__(1132);

var _products2 = _interopRequireDefault(_products);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var productsModule = _angular2.default.module('products', []).component('products', _products2.default).name;

var states = [{
    name: 'products',
    url: '/career/products',
    component: 'products',
    title: '产品运营招聘'
}];

exports.default = { name: productsModule, states: states };

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _products = __webpack_require__(1133);

var _products2 = _interopRequireDefault(_products);

var _products3 = __webpack_require__(1134);

var _products4 = _interopRequireDefault(_products3);

__webpack_require__(1135);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var productsComponent = {
    restrict: 'E',
    bindings: {},
    template: _products2.default,
    controller: _products4.default
};

exports.default = productsComponent;

/***/ }),
/* 1133 */
/***/ (function(module, exports) {

module.exports = "<div class=\"developers block\">\n    <div class=\"block-content\">\n        <div class=\"title\">产品运营相关职位</div>\n        <div class=\"content\">\n            <h3>基本信息</h3>\n            <ul>\n                <li>公司介绍：<a ui-sref=\"app.page.career.intro\" target=\"_blank\">点击查看公司及团队介绍</a></li>\n                <li>工作地点：上海市虹口区乍浦路512号SOHO裙楼（近四川北路地铁站2号口）</li>\n                <li>学历要求：本科及以上学历，工作经验：1-3年</li>\n                <li>薪资范围：8k-20k</li>\n                <li>简历投递：hr@yuanben.org</li>\n            </ul>\n            <p>&nbsp;</p>\n            <h2>社区运营主管</h2>\n            <h4>岗位职责</h4>\n            <ul>\n                <li>负责社区运营与管理，制定运营计划并优化社区运营数据</li>\n                <li>负责运营活动的策划和落地，用最牛的点子征服用户</li>\n                <li>收集、分析用户运营数据，深入了解用户需求，创新运营方法的设计与执行，推动品牌宣传、社区发展与产品优化</li>\n                <li>和团队一起合作与学习，在设计、产品、技术各个方面作出推动与交流</li>\n            </ul>\n            <h4>任职要求</h4>\n            <ul>\n                <li>熟悉互联网行业，有丰富的社群运营经验和方法</li>\n                <li>对用户心理行为需求有强烈的好奇心和探究的行动力，具备良好的用户体验意识</li>\n                <li>有强烈的责任感和自驱力，创新意识强，思维活跃</li>\n            </ul>\n            <h4>加分项</h4>\n            <ul>\n                <li>了解区块链相关知识</li>\n            </ul>\n            <p>&nbsp;</p>\n            <p>&nbsp;</p>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProductsController = function ProductsController() {
    (0, _classCallCheck3.default)(this, ProductsController);

    this.name = 'products';
};

exports.default = ProductsController;

/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1136);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./products.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./products.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _ai = __webpack_require__(1138);

var _ai2 = _interopRequireDefault(_ai);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var developersModule = _angular2.default.module('ai', []).component('ai', _ai2.default).name;

var states = [{
    name: 'ai',
    url: '/career/ai',
    component: 'ai',
    title: '人工智能招聘'
}];

exports.default = { name: developersModule, states: states };

/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ai = __webpack_require__(1139);

var _ai2 = _interopRequireDefault(_ai);

__webpack_require__(1140);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var developersComponent = {
    restrict: 'E',
    bindings: {},
    template: _ai2.default
};

exports.default = developersComponent;

/***/ }),
/* 1139 */
/***/ (function(module, exports) {

module.exports = "<div class=\"developers block\">\n    <div class=\"block-content\">\n        <div class=\"title\">人工智能相关职位</div>\n        <div class=\"content\">\n            <h3>职位列表</h3>\n            <ul>\n              <li><a href=\"#s1\">数据采集工程师</a></li>\n              <li><a href=\"#s2\">自然语言处理工程师</a></li>\n            </ul>\n            <h3>基本信息</h3>\n            <ul>\n                <li>公司介绍：<a ui-sref=\"app.page.career.intro\" target=\"_blank\">点击查看公司及团队介绍</a></li>\n                <li>工作地点：上海市虹口区乍浦路512号SOHO裙楼（近四川北路地铁站2号口）</li>\n                <li>学历要求：计算机相关专业本科及以上，工作经验：1-3年</li>\n                <li>薪资范围：20-50k</li>\n                <li>简历投递：hr@yuanben.org</li>\n            </ul>\n            <p>&nbsp;</p>\n            <h2 id=\"s1\">数据采集工程师</h2>\n            <h4>岗位职责</h4>\n            <ul>\n                <li>媒体大数据采集系统的架构和研发</li>\n            </ul>\n            <h4>任职要求</h4>\n            <ul>\n                <li>本科以上学历，1-3年工作经验</li>\n                <li>大规模网络内容采集系统项目经验</li>\n                <li>分布式抓取系统的架构经验</li>\n                <li>熟悉公众号、微博、网页等内容的抓取和清洗策略</li>\n                <li>精通Python、Go中的一种或多种</li>\n                <li>了解大数据、数据仓库相关技术产品（比如Hadoop生态系列产品）</li>\n                <li>良好的自我驱动力、主动沟通和表达能力</li>\n            </ul>\n            <h4>加分项</h4>\n            <ul>\n                <li>大数据计算相关项目经验</li>\n                <li>自然语言处理相关经验</li>\n            </ul>\n            <p>&nbsp;</p>\n            <h2 id=\"s2\">自然语言处理工程师</h2>\n            <h4>岗位职责</h4>\n            <ul>\n                <li>负责媒体内容大数据的挖掘、分析系统的搭建和性能优化</li>\n                <li>负责NLP相关项目的调研、评估和产品化</li>\n            </ul>\n            <h4>任职要求</h4>\n            <ul>\n                <li>985硕士及以上学历，自然语言处理、机器学习方向，1-3年工作经验</li>\n                <li>在文本嵌入、序列标注、文本总结、文本分类、实体提取、内容推荐、知识图谱等领域有产品化项目经验</li>\n                <li>扎实的编程基础，精通Python和Scala中的一种</li>\n                <li>扎实的机器学习和数据挖掘基础，在自然语言处理领域有深入研究，熟悉基础的NLP算法比如 HMMs, CRFs, SVMs, LDA, LSI, MRFs等</li>\n                <li>熟悉常用的 ML、DL开源工具库比如TensorFlow, PyTorch等</li>\n                <li>良好的自我驱动力、主动沟通和表达能力</li>\n                <li>乐于挑战没有现成方案的技术问题</li>\n            </ul>\n            <h4>加分项</h4>\n            <ul>\n                <li>有基于深度学习的NLP算法实际项目经验</li>\n            </ul>\n            <p>&nbsp;</p>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1141);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./ai.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./ai.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _system = __webpack_require__(1143);

var _system2 = _interopRequireDefault(_system);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var developersModule = _angular2.default.module('system', []).component('system', _system2.default).name;

var states = [{
    name: 'system',
    url: '/career/system',
    component: 'system',
    title: '系统开发招聘'
}];

exports.default = { name: developersModule, states: states };

/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _system = __webpack_require__(1144);

var _system2 = _interopRequireDefault(_system);

__webpack_require__(1145);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var systemComponent = {
    restrict: 'E',
    bindings: {},
    template: _system2.default
};

exports.default = systemComponent;

/***/ }),
/* 1144 */
/***/ (function(module, exports) {

module.exports = "<div class=\"developers block\">\n    <div class=\"block-content\">\n        <div class=\"title\">系统开发相关职位</div>\n        <div class=\"content\">\n            <h3>职位列表</h3>\n            <ul>\n              <li><a href=\"#s1\">后端工程师 - PHP</a></li>\n            </ul>\n            <h3>基本信息</h3>\n            <ul>\n                <li>公司介绍：<a ui-sref=\"app.page.career.intro\" target=\"_blank\">点击查看公司及团队介绍</a></li>\n                <li>工作地点：上海市虹口区乍浦路512号SOHO裙楼（近四川北路地铁站2号口）</li>\n                <li>学历要求：计算机相关专业本科及以上，工作经验：1-3年</li>\n                <li>薪资范围：15k-30k</li>\n                <li>简历投递：hr@yuanben.org</li>\n            </ul>\n            <p>&nbsp;</p>\n            <h2 id=\"s1\">后端工程师 - PHP</h2>\n            <h4>岗位职责</h4>\n            <ul>\n                <li>负责Web应用的后端开发</li>\n                <li>负责系统服务API的开发</li>\n                <li>项目的日常维护，服务器环境搭建、项目部署等</li>\n            </ul>\n            <h4>任职要求</h4>\n            <ul>\n                <li>基本的数据结构、算法和数据库知识</li>\n                <li>熟练使用PHP</li>\n                <li>熟练使用Laravel5框架</li>\n                <li>熟练使用设计模式</li>\n                <li>会写较复杂的SQL语句，熟悉ORM</li>\n                <li>熟悉异步、并发、消息队列</li>\n                <li>了解前端技术AngularJS</li>\n            </ul>\n            <h4>加分项</h4>\n            <ul>\n                <li>密码学（PKI）</li>\n                <li>区块链 (智能合约)</li>\n                <li>推荐系统（文本分类、协同过滤）</li>\n            </ul>\n            <p>&nbsp;</p>\n            <p>&nbsp;</p>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1146);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./system.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./system.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _evidence = __webpack_require__(1148);

var _evidence2 = _interopRequireDefault(_evidence);

var _articleEvidence = __webpack_require__(1153);

var _articleEvidence2 = _interopRequireDefault(_articleEvidence);

var _imageEvidence = __webpack_require__(1157);

var _imageEvidence2 = _interopRequireDefault(_imageEvidence);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var childModules = [_articleEvidence2.default, _imageEvidence2.default];

var moduleNames = [];

var states = [{
    name: 'evidence',
    url: '/evidence',
    component: 'evidence'
}];

childModules.forEach(function (m) {
    moduleNames.push(m.name);

    m.states.forEach(function (s) {
        s.name = 'evidence.' + s.name;
        states.push(s);
    });
});

var evidenceModule = _angular2.default.module('evidence', moduleNames).component('evidence', _evidence2.default).name;

exports.default = { name: evidenceModule, states: states };

/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _evidence = __webpack_require__(1149);

var _evidence2 = _interopRequireDefault(_evidence);

var _evidence3 = __webpack_require__(1150);

var _evidence4 = _interopRequireDefault(_evidence3);

__webpack_require__(1151);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var evidenceComponent = {
    restrict: 'E',
    bindings: {
        'appUser': '='
    },
    template: _evidence2.default,
    controller: _evidence4.default
};

exports.default = evidenceComponent;

/***/ }),
/* 1149 */
/***/ (function(module, exports) {

module.exports = "<div class=\"clearfix block\">\n    <div class=\"evidence col-9 left-cont\">\n        <div class=\"block-title\">{{'page-evidence-text001' | translate}}</div>\n        <div class=\"content\" ui-view></div>\n    </div>\n    <div class=\"evidence-introduction col-3\">\n        <div class=\"title\">{{'page-evidence-text002' | translate}}</div>\n        <div class=\"content\">\n            <ul class=\"intro-list\">\n                <li ng-bind-html=\"$ctrl.$sce.trustAsHtml($ctrl.$filter('translate')('page-evidence-text003'))\"></li>\n                <li ng-bind-html=\"$ctrl.$sce.trustAsHtml($ctrl.$filter('translate')('page-evidence-text004'))\"></li>\n                <li ng-bind-html=\"$ctrl.$sce.trustAsHtml($ctrl.$filter('translate')('page-evidence-text005'))\"></li>\n                <li>{{'page-evidence-text006' | translate}}</li>\n            </ul>\n        </div>\n    </div>\n</div>\n\n";

/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EvidenceController = function EvidenceController($filter, $sce) {
    "ngInject";

    (0, _classCallCheck3.default)(this, EvidenceController);
    $(document).scrollTop(0);
    this.$filter = $filter;
    this.$sce = $sce;
};

EvidenceController.$inject = ["$filter", "$sce"];

//  测试
exports.default = EvidenceController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1152);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./evidence.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./evidence.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".evidence-introduction {\n  padding: 0 24px 20px; }\n  .evidence-introduction .title {\n    font-size: 14px;\n    font-weight: bold;\n    color: #222222;\n    padding-top: 70px; }\n  .evidence-introduction .content {\n    font-size: 12px;\n    color: #666666; }\n    .evidence-introduction .content .intro-list {\n      list-style: none;\n      padding: 0; }\n    .evidence-introduction .content li {\n      margin-top: 10px;\n      line-height: 1.8; }\n    .evidence-introduction .content a {\n      text-decoration: underline;\n      color: #4477b0; }\n\n.evidence {\n  position: relative; }\n  .evidence .title {\n    font-size: 18px;\n    color: #222222;\n    padding: 15px 0;\n    border-bottom: 1px solid #dadedd; }\n  .evidence .content {\n    margin-top: 20px;\n    padding-bottom: 60px; }\n  .evidence .metadata {\n    position: relative;\n    background-color: #f6f8f8;\n    padding: 10px; }\n    .evidence .metadata .line {\n      position: relative;\n      height: 24px;\n      line-height: 24px; }\n      .evidence .metadata .line:last-child {\n        border-bottom: 0; }\n      .evidence .metadata .line .name {\n        position: absolute;\n        width: 130px;\n        height: 100%;\n        color: #666666; }\n      .evidence .metadata .line .value {\n        position: relative;\n        margin-left: 130px;\n        padding-left: 10px;\n        color: #222222;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap; }\n        .evidence .metadata .line .value .link {\n          color: #4477b0;\n          width: 500px;\n          display: block;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          white-space: nowrap; }\n      .evidence .metadata .line.descriptionHeight {\n        min-height: 30px;\n        height: auto; }\n        .evidence .metadata .line.descriptionHeight .value {\n          overflow: visible !important;\n          text-overflow: clip !important;\n          white-space: normal !important; }\n  .evidence .line {\n    margin-top: 3px;\n    font-size: 14px;\n    color: #222222; }\n    .evidence .line a {\n      color: #4477b0; }\n    .evidence .line.meaningless {\n      margin-top: 20px; }\n      .evidence .line.meaningless .name {\n        margin-bottom: 10px; }\n        .evidence .line.meaningless .name .tip {\n          color: #ff3333;\n          font-size: 12px; }\n        .evidence .line.meaningless .name .sup {\n          font-size: 12px;\n          color: #999999; }\n      .evidence .line.meaningless .value {\n        background-color: #f6f8f8;\n        padding: 10px;\n        font-size: 12px;\n        color: #666666;\n        line-height: 1.6;\n        overflow-wrap: break-word;\n        word-wrap: break-word;\n        -ms-word-break: break-all;\n        word-break: break-word;\n        -ms-hyphens: auto;\n        -moz-hyphens: auto;\n        -webkit-hyphens: auto;\n        hyphens: auto; }\n\n@media only screen and (max-width: 767px) {\n  .evidence .content {\n    margin-top: 10px;\n    padding-bottom: 0; }\n  .evidence .metadata .line .value {\n    padding-left: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap; }\n    .evidence .metadata .line .value.with-iphone {\n      width: 57%; }\n      .evidence .metadata .line .value.with-iphone .link {\n        width: 100%; }\n  .evidence-introduction {\n    padding: 20px 12px; } }\n", ""]);

// exports


/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _articleEvidence = __webpack_require__(1154);

var _articleEvidence2 = _interopRequireDefault(_articleEvidence);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var articleEvidenceModule = _angular2.default.module('articleEvidence', []).component('articleEvidence', _articleEvidence2.default).name;

var states = [{
    'name': 'article',
    'url': '/article/{id}',
    'component': 'articleEvidence'
}];

exports.default = { name: articleEvidenceModule, states: states };

/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _articleEvidence = __webpack_require__(1155);

var _articleEvidence2 = _interopRequireDefault(_articleEvidence);

var _articleEvidence3 = __webpack_require__(1156);

var _articleEvidence4 = _interopRequireDefault(_articleEvidence3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var articleEvidenceComponent = {
    restrict: 'E',
    bindings: {
        'appUser': '='
    },
    template: _articleEvidence2.default,
    controller: _articleEvidence4.default
};

exports.default = articleEvidenceComponent;

/***/ }),
/* 1155 */
/***/ (function(module, exports) {

module.exports = "<div class=\"metadata\">\n    <div class=\"line\">\n        <div class=\"name\">{{'page-evidence-text007' | translate}}</div>\n        <div class=\"value\">{{ article.title }}</div>\n    </div>\n    <div class=\"line\">\n        <div class=\"name\">{{'page-evidence-text008' | translate}}</div>\n        <div class=\"value\">{{ article.author_name }}</div>\n    </div>\n    <div class=\"line\">\n        <div class=\"name\">{{'page-evidence-text009' | translate}}</div>\n        <div class=\"value\">{{ article.created_at * 1000 | date : 'yyyy-MM-dd HH:mm' }}</div>\n    </div>\n    <div class=\"line\">\n        <div class=\"name\">{{'page-evidence-text010' | translate}}</div>\n        <div class=\"value\">{{ article.short_id }}</div>\n    </div>\n    <div class=\"line\">\n        <div class=\"name\">{{'page-evidence-text011' | translate}}</div>\n        <div class=\"value with-iphone\">\n            <a ng-if=\"article.block_hash\" class=\"link\" href=\"{{ article.chain_server_url }}\" target=\"_blank\">{{\n                article.block_hash }}</a>\n            <span ng-if=\"!article.block_hash\" style=\"color: #999;\">{{'home-evidences-text052' | translate}}</span>\n        </div>\n    </div>\n</div>\n<div class=\"line meaningless\">\n    <div class=\"name\">{{'page-evidence-text012' | translate}}：</div>\n    <div class=\"value\">{{ article.yuanben_id }}</div>\n</div>\n<div class=\"line meaningless\">\n    <div class=\"name\">{{'page-evidence-text013' | translate}}({{$ctrl.Hash_type[article.enc_type]}}):</div>\n    <div class=\"value\">{{ article.hash }}</div>\n</div>\n<div class=\"line meaningless\" ng-if=\"article && $ctrl.userInfo.isAuthor(article)\">\n    <div class=\"name\">{{'page-evidence-text014' | translate}}：<span class=\"tip\">{{'page-evidence-text015' | translate}}</span></div>\n    <div class=\"value\">{{ article.signature_string }}</div>\n</div>\n<div class=\"line meaningless\">\n    <div class=\"name\">{{'page-evidence-text016' | translate}}：</div>\n    <div class=\"value\">{{ article.signature }}</div>\n</div>\n<div class=\"line meaningless\">\n    <div class=\"name\">{{'page-evidence-text017' | translate}}：</div>\n    <div class=\"value\" ng-bind-html=\"publicKeyHtml\"></div>\n</div>\n";

/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ArticleEvidenceController = function ArticleEvidenceController($scope, AppConfig, ArticleAPI, $stateParams, $filter, pageTitle, $sce, userInfo, QueryAPI) {

    "ngInject";

    (0, _classCallCheck3.default)(this, ArticleEvidenceController);
    $scope.article = null;
    $scope.publicKeyHtml = null;
    this.AppConfig = AppConfig;
    this.userInfo = userInfo;
    this.QueryAPI = QueryAPI;
    this.userInfo.setUser(this.appUser);
    this.Hash_type = {
        0: "SHA256",
        1: "SM3"
    };

    if (!this.userInfo.isGuest()) {
        ArticleAPI.one($stateParams.id).one('evidence').get().then(function (article) {
            $scope.article = article;
            $scope.publicKeyHtml = $sce.trustAsHtml($scope.article.public_key.replace(/\n/g, "<br/>"));
            pageTitle.setTitle($filter('translate')('page-evidence-text018') + ' - ' + article.title);
        });
    } else {
        this.QueryAPI.one().get({ 'id': $stateParams.id, 'type': 'article' }).then(function (article) {
            $scope.article = article;
            $scope.publicKeyHtml = $sce.trustAsHtml($scope.article.public_key.replace(/\n/g, "<br/>"));
            pageTitle.setTitle($filter('translate')('page-evidence-text018') + ' - ' + article.title);
        });
    }
};

ArticleEvidenceController.$inject = ["$scope", "AppConfig", "ArticleAPI", "$stateParams", "$filter", "pageTitle", "$sce", "userInfo", "QueryAPI"];
exports.default = ArticleEvidenceController;

/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _imageEvidence = __webpack_require__(1158);

var _imageEvidence2 = _interopRequireDefault(_imageEvidence);

__webpack_require__(113);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var imageEvidenceModule = _angular2.default.module('imageEvidence', ['ngFilesizeFilter']).component('imageEvidence', _imageEvidence2.default).name;

var states = [{
    'name': 'image',
    'url': '/image/{id}',
    'component': 'imageEvidence',
    'title': 'page-evidence-text019'
}];

exports.default = { name: imageEvidenceModule, states: states };

/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _imageEvidence = __webpack_require__(1159);

var _imageEvidence2 = _interopRequireDefault(_imageEvidence);

var _imageEvidence3 = __webpack_require__(1160);

var _imageEvidence4 = _interopRequireDefault(_imageEvidence3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var imageEvidenceComponent = {
    restrict: 'E',
    bindings: {
        'appUser': '='
    },
    template: _imageEvidence2.default,
    controller: _imageEvidence4.default
};

exports.default = imageEvidenceComponent;

/***/ }),
/* 1159 */
/***/ (function(module, exports) {

module.exports = "<div class=\"metadata\">\n    <div class=\"line\">\n        <div class=\"name\">{{'page-evidence-text007' | translate}}</div>\n        <div class=\"value\">{{ image.title }}</div>\n    </div>\n    <div class=\"line\">\n        <div class=\"name\">{{'page-evidence-text008' | translate}}</div>\n        <div class=\"value\">{{ image.author_name }}</div>\n    </div>\n    <div class=\"line\">\n        <div class=\"name\">{{'page-evidence-text009' | translate}}</div>\n        <div class=\"value\">{{ image.created_at * 1000 | date : 'yyyy-MM-dd HH:mm' }}</div>\n    </div>\n    <div class=\"line\">\n        <div class=\"name\">{{'page-evidence-text020' | translate}}</div>\n        <div class=\"value\">{{ image.image_width }} x {{ image.image_height }}</div>\n    </div>\n    <div class=\"line\">\n        <div class=\"name\">{{'page-evidence-text021' | translate}}</div>\n        <div class=\"value\">{{ image.file_size | filesize }}</div>\n    </div>\n    <div class=\"line\">\n        <div class=\"name\">{{'page-evidence-text010' | translate}}</div>\n        <div class=\"value\">{{ image.short_id }}</div>\n    </div>\n    <div class=\"line\">\n        <div class=\"name\">{{'page-evidence-text011' | translate}}</div>\n        <div class=\"value with-iphone\">\n            <a  class=\"link\" href=\"{{ image.chain_server_url }}\" target=\"_blank\">{{image.block_hash }}</a>\n        </div>\n    </div>\n    <div class=\"line descriptionHeight\">\n      <div class=\"name\">图片描述</div>\n      <div class=\"value\">{{ image.description }}</div>\n  </div>\n</div>\n<div class=\"line meaningless\">\n    <div class=\"name\">{{'page-evidence-text012' | translate}}：</div>\n    <div class=\"value\">{{ image.yuanben_id }}</div>\n</div>\n<div class=\"line meaningless\">\n    <div class=\"name\">{{'page-evidence-text022' | translate}}({{$ctrl.Hash_type[image.enc_type]}}):</div>\n    <div class=\"value\">{{ image.content_hash }}</div>\n</div>\n<!-- <div class=\"line meaningless\">\n    <div class=\"name\">{{'page-evidence-text023' | translate}}：</div>\n    <div class=\"value\">{{ image.hash }}</div>\n</div> -->\n<div class=\"line meaningless\" ng-if=\"image && $ctrl.userInfo.isAuthor(image)\">\n    <div class=\"name\">{{'page-evidence-text014' | translate}}：<span class=\"tip\">{{'page-evidence-text015' | translate}}</span></div>\n    <div class=\"value\">{{ image.signature_string }}</div>\n</div>\n<div class=\"line meaningless\">\n    <div class=\"name\">{{'page-evidence-text016' | translate}}：</div>\n    <div class=\"value\">{{ image.signature }}</div>\n</div>\n<div class=\"line meaningless\">\n    <div class=\"name\">{{'page-evidence-text017' | translate}}：</div>\n    <div class=\"value\" ng-bind-html=\"publicKeyHtml\"></div>\n</div>\n";

/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageEvidenceController = function ImageEvidenceController($scope, userInfo, AppConfig, ImageAPI, $stateParams, pageTitle, QueryAPI, $sce, $filter) {

    "ngInject";

    (0, _classCallCheck3.default)(this, ImageEvidenceController);
    $scope.image = null;
    $scope.publicKeyHtml = null;
    this.userInfo = userInfo;
    this.QueryAPI = QueryAPI;
    this.userInfo.setUser(this.appUser);

    this.AppConfig = AppConfig;
    this.Hash_type = {
        0: "SHA256",
        1: "SM3"
    };

    if (!this.userInfo.isGuest()) {
        ImageAPI.one($stateParams.id).one('evidence').get().then(function (image) {
            $scope.image = image;
            $scope.publicKeyHtml = $sce.trustAsHtml($scope.image.public_key.replace(/\n/g, "<br/>"));

            pageTitle.setTitle($filter('translate')('page-evidence-text019') + ' - ' + image.title);
        });
    } else {
        this.QueryAPI.one().get({ 'id': $stateParams.id, 'type': 'image' }).then(function (image) {
            $scope.image = image;
            $scope.publicKeyHtml = $sce.trustAsHtml($scope.image.public_key.replace(/\n/g, "<br/>"));
            pageTitle.setTitle($filter('translate')('page-evidence-text019') + ' - ' + image.title);
        });
    }
};

ImageEvidenceController.$inject = ["$scope", "userInfo", "AppConfig", "ImageAPI", "$stateParams", "pageTitle", "QueryAPI", "$sce", "$filter"];
exports.default = ImageEvidenceController;

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _help = __webpack_require__(1162);

var _help2 = _interopRequireDefault(_help);

var _copyright = __webpack_require__(1167);

var _copyright2 = _interopRequireDefault(_copyright);

var _knowledge = __webpack_require__(1173);

var _knowledge2 = _interopRequireDefault(_knowledge);

var _guide = __webpack_require__(1179);

var _guide2 = _interopRequireDefault(_guide);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var childModules = [_copyright2.default, _knowledge2.default, _guide2.default];

var states = [{
    name: 'help',
    abstract: true,
    component: 'help'
}];

var childModuleNames = [];

childModules.forEach(function (m) {
    childModuleNames.push(m.name);

    m.states.forEach(function (s) {

        s.name = 'help.' + s.name;

        states.push(s);
    });
});

var helpModule = _angular2.default.module('help', childModuleNames).component('help', _help2.default).name;

exports.default = { name: helpModule, states: states };

/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _help = __webpack_require__(1163);

var _help2 = _interopRequireDefault(_help);

var _help3 = __webpack_require__(1164);

var _help4 = _interopRequireDefault(_help3);

__webpack_require__(1165);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var announcementComponent = {
    restrict: 'E',
    bindings: {},
    template: _help2.default,
    controller: _help4.default
};

exports.default = announcementComponent;

/***/ }),
/* 1163 */
/***/ (function(module, exports) {

module.exports = "<div class=\"help-page block single-page\">\n    <div class=\"block-title\">\n        用户指南\n    </div>\n    <div class=\"content clearfix\">\n        <div class=\"col-3 side-nav\">\n            <navtab tabs=\"$ctrl.tabs\"></navtab>\n        </div>\n        <div class=\"col-9 block-content\">\n            <div class=\"main-content\" ui-view></div>\n            <div class=\"feedback\">\n                <div class=\"tip\">\n                    如果您在使用中遇到程序/功能问题、bug 反馈，可联系在线客服或<a href=\"mailto:hi@yuanben.org\" target=\"_blank\" class=\"link\">通过邮件联系我们</a>。您也可以添加微信公众号：yuanbenio 关注【原本】最新动态或与我们联系。\n                </div>\n            </div>\n        </div>\n    </div>\n\n</div>\n\n";

/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HelpController = function HelpController($scope, $state) {
    "ngInject";

    (0, _classCallCheck3.default)(this, HelpController);
    this.tabs = [{
        name: '版权相关',
        click: function click() {
            $state.go('app.page.help.copyright');
        },
        active: $state.is('app.page.help.copyright')
    }, {
        name: '原本知识点',
        click: function click() {
            $state.go('app.page.help.knowledge');
        },
        active: $state.is('app.page.help.knowledge')
    }, {
        name: '帮助中心',
        click: function click() {
            $state.go('app.page.help.guide');
        },
        active: $state.is('app.page.help.guide')
    }];
};

HelpController.$inject = ['$scope', '$state'];
exports.default = HelpController;

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1166);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./help.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./help.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".help-page {\n  padding: 20px 40px; }\n  .help-page .block-content {\n    padding-top: 40px; }\n    .help-page .block-content .main-content {\n      min-height: 200px; }\n    .help-page .block-content .panel {\n      margin-bottom: 30px;\n      font-size: 14px; }\n      .help-page .block-content .panel .title {\n        margin-bottom: 20px;\n        color: #222222;\n        line-height: 1;\n        font-weight: bold; }\n      .help-page .block-content .panel .item {\n        margin-bottom: 20px; }\n        .help-page .block-content .panel .item .question {\n          color: #4477b0;\n          line-height: 1;\n          margin-bottom: 14px;\n          cursor: pointer; }\n          .help-page .block-content .panel .item .question:hover {\n            text-decoration: underline; }\n        .help-page .block-content .panel .item .answer {\n          display: none;\n          background-color: #f6f8f8;\n          color: #666666;\n          padding: 14px;\n          line-height: 1.6; }\n          .help-page .block-content .panel .item .answer.active {\n            display: block; }\n    .help-page .block-content .feedback {\n      margin-top: 40px;\n      border-top: 1px solid #e8eaea;\n      padding: 20px 0  100px;\n      font-size: 14px;\n      color: #666666;\n      line-height: 2; }\n      .help-page .block-content .feedback .link {\n        color: #4477b0; }\n  .help-page navtab .navtab {\n    border-bottom: none;\n    height: 56px;\n    line-height: 56px;\n    padding: 20px 40px 0 0; }\n    .help-page navtab .navtab .tabs {\n      height: 56px;\n      line-height: 56px; }\n      .help-page navtab .navtab .tabs .tab {\n        padding: 0;\n        margin: 0;\n        width: 100%;\n        float: none;\n        line-height: 56px;\n        height: 56px;\n        border-bottom: 1px solid #e8eaea;\n        font-size: 16px;\n        text-align: left; }\n        .help-page navtab .navtab .tabs .tab:hover, .help-page navtab .navtab .tabs .tab.active {\n          color: #00816a;\n          border-bottom: 1px solid #e8eaea; }\n\n@media only screen and (max-width: 767px) {\n  .help-page {\n    width: auto !important; }\n    .help-page .side-nav, .help-page .block-content {\n      padding: 0 !important; }\n    .help-page navtab .navtab {\n      height: 40px;\n      line-height: 40px;\n      padding: 0 !important;\n      border-bottom: 1px solid #e8eaea; }\n      .help-page navtab .navtab .tabs {\n        height: 40px;\n        line-height: 40px; }\n        .help-page navtab .navtab .tabs .tab {\n          padding: 0 10px;\n          margin: 0 10px  0 0;\n          width: auto;\n          float: left;\n          line-height: 40px;\n          height: 40px;\n          border-bottom: 1px solid #e8eaea;\n          font-size: 16px;\n          text-align: left; }\n          .help-page navtab .navtab .tabs .tab:hover, .help-page navtab .navtab .tabs .tab.active {\n            color: #00816a;\n            border-bottom: 2px solid #00816a; }\n    .help-page .block-content {\n      margin-top: 40px; }\n      .help-page .block-content .panel .item .question {\n        line-height: 1.5;\n        margin-bottom: 8px; } }\n", ""]);

// exports


/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _copyright = __webpack_require__(1168);

var _copyright2 = _interopRequireDefault(_copyright);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var copyrightModule = _angular2.default.module('copyright', []).component('copyright', _copyright2.default).name;

var states = [{
    name: 'copyright',
    url: '/help/copyright',
    component: 'copyright',
    title: '版权相关'
}];

exports.default = { name: copyrightModule, states: states };

/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _copyright = __webpack_require__(1169);

var _copyright2 = _interopRequireDefault(_copyright);

var _copyright3 = __webpack_require__(1170);

var _copyright4 = _interopRequireDefault(_copyright3);

__webpack_require__(1171);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var algorithmsComponent = {
    restrict: 'E',
    bindings: {},
    template: _copyright2.default,
    controller: _copyright4.default
};

exports.default = algorithmsComponent;

/***/ }),
/* 1169 */
/***/ (function(module, exports) {

module.exports = "<div class=\"copyright-panel\">\n    <div class=\"panel\" ng-repeat=\"panel in $ctrl.cata\">\n        <div class=\"title\">{{panel.title}}</div>\n        <div class=\"item\" ng-repeat=\"item in panel.list\">\n            <div class=\"question\" ng-click=\"$ctrl.showDetail($event)\">{{item.question}}</div>\n            <div class=\"answer\" ng-bind-html=\"$ctrl.$sce.trustAsHtml(item.answer)\"></div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var copyrightController = function () {
    copyrightController.$inject = ['$sce'];

    function copyrightController($sce) {
        "ngInject";

        (0, _classCallCheck3.default)(this, copyrightController);
        this.$sce = $sce;
        this.name = 'copyright';
        this.cata = [{
            title: '版权相关',
            list: [{
                question: '什么是著作权？',
                answer: '著作权又称版权，是指作者对其创作的文学、艺术和科学技术作品所享有的专有权利。著作权是公民、法人依法享有的一种民事权利，属于无形财产权。<br>' + '著作权法所称的作品，包括以下列形式创作的文学、艺术和自然科学、社会科学、工程技术等作品：（一）文字作品；（二）口述作品；（三）音乐、戏剧、曲艺、舞蹈、杂技艺术作品；（四）美术、建筑作品；（五）摄影作品；（六）电影作品和以类似摄制电影的方法创作的作品；（七）工程设计图、产品设计图、地图、示意图等图形作品和模型作品；（八）计算机软件；（九）法律、行政法规规定的其他作品。<br>' + '在中华人民共和国境内，凡是中国公民，法人或者非法人单位的作品，不论是否发表都享有著作权；外国人的作品首先在中国境内发表的，也依著作权法享有著作权；外国人在中国境外发表的作品，根据其所属国与中国签订的协议或者共同参加的国际条约享有著作权。'
            }, {
                question: '美术作品原件所有人享有著作权吗？',
                answer: '美术作品原件所有人拥有原件的所有权和使用权。但能否享有著作权取决于作者本人是否授权原件所有人进行二次创作并允许商业使用。'
            }, {
                question: '用户原创的作品，包含哪些权力？',
                answer: '具体包含的各项权利参见《中华人民共和国著作权法》第十条——著作权包括下列人身权和财产权：<br>' + '（一）发表权，即决定作品是否公之于众的权利；<br>' + '（二）署名权，即表明作者身份，在作品上署名的权利；<br>' + '（三）修改权，即修改或者授权他人修改作品的权利；<br>' + '（四）保护作品完整权，即保护作品不受歪曲、篡改的权利；<br>' + '（五）复制权，即以印刷、复印、拓印、录音、录像、翻录、翻拍等方式将作品制作一份或者多份的权利；<br>' + '（六）发行权，即以出售或者赠与方式向公众提供作品的原件或者复制件的权利；<br>' + '（七）出租权，即有偿许可他人临时使用电影作品和以类似摄制电影的方法创作的作品、计算机软件的权利，计算机软件不是出租的主要标的的除外；<br>' + '（八）展览权，即公开陈列美术作品、摄影作品的原件或者复制件的权利；<br>' + '（九）表演权，即公开表演作品，以及用各种手段公开播送作品的表演的权利；<br>' + '（十）放映权，即通过放映机、幻灯机等技术设备公开再现美术、摄影、电影和以类似摄制电影的方法创作的作品等的权利；<br>' + '（十一）广播权，即以无线方式公开广播或者传播作品，以有线传播或者转播的方式向公众传播广播的作品，以及通过扩音器或者其他传送符号、声音、图像的类似工具向公众传播广播的作品的权利；<br>' + '（十二）信息网络传播权，即以有线或者无线方式向公众提供作品，使公众可以在其个人选定的时间和地点获得作品的权利；<br>' + '（十三）摄制权，即以摄制电影或者以类似摄制电影的方法将作品固定在载体上的权利；<br>' + '（十四）改编权，即改变作品，创作出具有独创性的新作品的权利；<br>' + '（十五）翻译权，即将作品从一种语言文字转换成另一种语言文字的权利；<br>' + '（十六）汇编权，即将作品或者作品的片段通过选择或者编排，汇集成新作品的权利；<br>' + '（十七）应当由著作权人享有的其他权利。<br>' + '著作权人可以许可他人行使前款第（五）项至第（十七）项规定的权利，并依照约定或者本法有关规定获得报酬。<br>' + '著作权人可以全部或者部分转让本条第一款第（五）项至第（十七）项规定的权利，并依照约定或者本法有关规定获得报酬。'
            }, {
                question: '将他人作品进行改编后，改编者对改编的作品是否享有完整的著作权？',
                answer: '《中华人民共和国著作权法》第十二条规定：“改编、翻译、注释、整理已有作品而产生的作品，其著作权由改编、翻译、注释、整理人享有，但行使著作权时不得侵犯原作品的著作权。”<br>' + '这里需指出，在获得原作者授权同意进行改编的情况下，改编者可以获得改编作品的著作权。但此处的“改编”应区别于“改动”。'
            }]
        }];
    }

    (0, _createClass3.default)(copyrightController, [{
        key: 'showDetail',
        value: function showDetail(event) {
            var $answer = $(event.currentTarget).next();
            if ($answer.hasClass('active')) {
                $answer.removeClass('active');
            } else {
                $answer.addClass('active');
            }
        }
    }]);
    return copyrightController;
}();

exports.default = copyrightController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1172);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./copyright.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./copyright.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _knowledge = __webpack_require__(1174);

var _knowledge2 = _interopRequireDefault(_knowledge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var knowledgeModule = _angular2.default.module('knowledge', []).component('knowledge', _knowledge2.default).name;

var states = [{
    name: 'knowledge',
    url: '/help/knowledge',
    component: 'knowledge',
    title: '原本知识点'
}];

exports.default = { name: knowledgeModule, states: states };

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _knowledge = __webpack_require__(1175);

var _knowledge2 = _interopRequireDefault(_knowledge);

var _knowledge3 = __webpack_require__(1176);

var _knowledge4 = _interopRequireDefault(_knowledge3);

__webpack_require__(1177);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var algorithmsComponent = {
    restrict: 'E',
    bindings: {},
    template: _knowledge2.default,
    controller: _knowledge4.default
};

exports.default = algorithmsComponent;

/***/ }),
/* 1175 */
/***/ (function(module, exports) {

module.exports = "<div class=\"knowledge-panel\">\n    <div class=\"panel\" ng-repeat=\"panel in $ctrl.cata\">\n        <div class=\"title\">{{panel.title}}</div>\n        <div class=\"item\" ng-repeat=\"item in panel.list\">\n            <div class=\"question\" ng-click=\"$ctrl.showDetail($event)\">{{item.question}}</div>\n            <div class=\"answer\" ng-bind-html=\"$ctrl.$sce.trustAsHtml(item.answer)\"></div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var knowledgeController = function () {
    knowledgeController.$inject = ['$sce'];

    function knowledgeController($sce) {
        "ngInject";

        (0, _classCallCheck3.default)(this, knowledgeController);
        this.$sce = $sce;
        this.name = 'knowledge';
        this.cata = [{
            title: '原本知识点',
            list: [{
                question: '什么是原本DNA标签？',
                answer: '原本通过区块链及密码学技术，为每一篇认证作品生成全网唯一的数字指纹——DNA。DNA的表现形式是作品底部携带着的DNA标签。标签中包含了作品内容、作者信息、可信时间戳以及授权协议，它的功能有：<br>' + '1.可以声明原创所有权，通过DNA码追溯原创作品，确保作品与作者的唯一对应关系<br>' + '2.具备切实的版权效力，是发生侵权纠纷的重要证据<br>' + '3.转载者可以通过标签上的DNA码快速获取作品授权，实现版权自助交易<br>' + '4.提升原本链的公信力'
            }, {
                question: 'DNA标签如何具备原创认证效力？',
                answer: '原创认证由「所有权证明」和「存在证明」两部分组成。<br>' + '「所有权证明」使用数字签名技术来证明您是此原创作品的原始作者。数字签名通过验证一组公钥和密钥的匹配来证明所有权。公钥已写入「原本DNA」，随着原创作品一起发布。密钥已通过邮件发送到您的邮箱。为了安全，系统中不保存密钥，请您妥善保存此密钥，在任何情况下都不要泄露给其他人。<br>' + '「存在证明」用于证明原创作品的发布时间，使用了区块链技术以及来自国家数字证书中心的可信时间戳服务，认证信息也已经写入「原本DNA」中。<br>' + '原本认证不依赖于「原本」的权威性，可以脱离「原本」的系统，由任意第三方来验证。'
            }, {
                question: '什么是可信时间戳？',
                answer: '可信时间戳是由权威可信时间戳服务中心签发的一个能证明数据电文(电子文件）在一个时间点是已经存在的、完整的、可验证的，具备法律效力的电子凭证，可信时间戳主要用于电子文件防篡改和事后抵赖，确定电子文件产生的准确时间。'
            }, {
                question: '什么是原本链？',
                answer: '原本链是基于区块链技术的一条联盟链。任何合作伙伴可以成为原本链的节点，为原本链带来更强的公信力。它是一套不可篡改的底层协议，为认证作品的DNA码带来公信力与版权效力。<br>' + '由于原本链的分布式架构，原本认证不依赖于「原本」的权威性，可以脱离「原本」的系统，由任意第三方来验证。'
            }, {
                question: '为什么建议先认证版权，再发表作品？',
                answer: '原本的核心理念在于通过区块链技术降低作品的授权成本，增加作品的传播力度，以此为作者带来全新的创作价值。当作品先认证再发表到媒体平台，已发布作品的底部才会携带上唯一数字身份DNA标签，广大转载者可以通过DNA标签快速获取作品授权，实现版权交易。'
            }]
        }];
    }

    (0, _createClass3.default)(knowledgeController, [{
        key: 'showDetail',
        value: function showDetail(event) {
            var $answer = $(event.currentTarget).next();
            if ($answer.hasClass('active')) {
                $answer.removeClass('active');
            } else {
                $answer.addClass('active');
            }
        }
    }]);
    return knowledgeController;
}();

exports.default = knowledgeController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1178);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./knowledge.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./knowledge.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _guide = __webpack_require__(1180);

var _guide2 = _interopRequireDefault(_guide);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var guideModule = _angular2.default.module('guide', []).component('guide', _guide2.default).name;

var states = [{
    name: 'guide',
    url: '/help/guide',
    component: 'guide',
    title: '帮助中心'
}];

exports.default = { name: guideModule, states: states };

/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _guide = __webpack_require__(1181);

var _guide2 = _interopRequireDefault(_guide);

var _guide3 = __webpack_require__(1182);

var _guide4 = _interopRequireDefault(_guide3);

__webpack_require__(1183);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var algorithmsComponent = {
    restrict: 'E',
    bindings: {},
    template: _guide2.default,
    controller: _guide4.default
};

exports.default = algorithmsComponent;

/***/ }),
/* 1181 */
/***/ (function(module, exports) {

module.exports = "<div class=\"guide-panel\">\n    <div class=\"panel\" ng-repeat=\"panel in $ctrl.cata\">\n        <div class=\"title\">{{panel.title}}</div>\n        <div class=\"item\" ng-repeat=\"item in panel.list\">\n            <div class=\"question\" ng-click=\"$ctrl.showDetail($event)\">{{item.question}}</div>\n            <div class=\"answer\" ng-bind-html=\"$ctrl.$sce.trustAsHtml(item.answer)\"></div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var guideController = function () {
    guideController.$inject = ['$sce'];

    function guideController($sce) {
        "ngInject";

        (0, _classCallCheck3.default)(this, guideController);
        this.$sce = $sce;
        this.name = 'guide';
        this.cata = [{
            title: '账号',
            list: [{
                question: '使用原本需要实名认证吗?',
                answer: '对于创作用户，需要通过实名认证才可以使用原本版权认证等系列服务。目的是使版权归属严谨有理，确保版权资产的安全。<br>' + '对于转载用户，获取授权不需要实名认证。<br>' + '实名需提供有效身份证号等，实名认证完成后用户头像处显示“已实名”标签。'
            }, {
                question: '如何修改账号密码?',
                answer: '在个人信息的账号处点击“修改密码”，可重新设置登录密码。'
            }, {
                question: '为什么用户名（笔名）只能修改一次？',
                answer: '原本提供一次修改用户笔名的机会。原本原创认证DNA标签中包含作者的署名信息，保持稳定的用户名（笔名）能更好证明原创作品的归属，因此原本不建议频繁的更换笔名。'
            }, {
                question: '原本账号绑定个人微信号后有什么作用 ?',
                answer: '1.用于提现，当原创作品获得交易收益后，可以直接提现到微信钱包。<br>' + '2.用于接收消息，实时接收转载和交易提醒。'
            }]
        }, {
            title: '原本版权认证',
            list: [{
                question: '什么样的内容可以提交认证？',
                answer: '原本目前支持文本内容认证与图片内容认证。<br>' + '文本内容指一切具有独创性并能以文本形式复制的智力成果。包括诗歌、文章、小说、论文、剧本等等。<br>' + '图片内容指一切具有独创性并能以图片形式复制的智力成果。包括摄影、绘画、设计、手稿等等。'
            }, {
                question: '什么是原本认证扩展工具?',
                answer: '原本认证扩展工具是一套能实现版权认证服务的浏览器插件，目前支持谷歌浏览器、360浏览器、猎豹浏览器、以及QQ浏览器。在原本的官网的“插件”页面上下载并按提示完成安装后，用户可以在微信公众号、简书等平台的内容编辑页面直接进行版权认证。详情请点击 <a target="_blank" href="https://yuanben.io/plugin">https://yuanben.io/plugin</a>'
            }, {
                question: '什么是授权协议? ',
                answer: '授权协议是创作者对作品的授权和转载方式的声明，由作者在认证的过程中通过选择或自定义产生。<br>' + '授权协议是组成原本DNA的必要内容。转载者需按照创作者的协议要求进行转载。<br>' + '【原本】支持免费的知识共享许可协议以及付费的商业许可协议两种方式。<br>' + '1.知识共享许可协议（即Creative Commons，简称CC）。是一个非营利组织，也是一种创作的授权方式。知识共享组织设计的这一套协议，意在保留作者相关版权权利的前提下，转载者满足特定转载条件的情况下，自由地复制和传播原创作品。原创用户可以灵活选择作品是否允许被修改、被商用，转载者可以免费获得转载权。了解更多：<a target="_blank" href="https://creativecommons.org/licenses/by-nc-nd/2.5/cn/legalcoden">https://creativecommons.org/licenses/by-nc-nd/2.5/cn/legalcode</a><br>' + '2.商业许可协议。使用商业许可协议，作者将决定是否允许自己的作品被改编以及设置作品单次授权转载的价格。<br>'
            }, {
                question: '作品认证成功后发给我的邮件有什么作用?',
                answer: '认证邮件中包含了生成作品数字签名时的密钥。该密钥对应唯一的原本DNA，因此请务必保管好认证邮件，并不要让他人知晓邮件中的密钥。当出现版权纠纷时，该邮件中的密钥及相关认证信息将能够作为作品所有权的证明，帮助用户维护版权利益。'
            }, {
                question: '认证后的内容在哪里查看和管理？',
                answer: '认证后的内容可在“我的原创”中进行查看和管理。'
            }, {
                question: '认证详情包含哪些内容？',
                answer: '成功认证的作品都能在作品的详情页面查看该内容的“认证详情”。“认证详情”主要包含了：<br>' + '1.认证作品的基本信息。包括：标题、作者、发布时间、原本DNA、原本区块链地址；<br>' + '2.作者对作品的所有权证明与存在证明。包括：完整的原本DNA、文章Hash、签名字符串（此字符串仅作者本人可见）、数字签名、签名公钥。'
            }, {
                question: '原创发布者可对已完成认证的作品进行授权协议的修改吗？',
                answer: '【原本】暂时不支持对已认证和发布的作品进行授权协议的修改。'
            }, {
                question: '认证完成后可以删除吗？删除是永久性的吗？',
                answer: '在“我的原创”列表和内容详情页中可以进行删除操作。删除的内容不可恢复，且失去原创认证效力。<br>' + '已经被他人成功获取授权的内容将无法删除。'
            }, {
                question: '什么是DNA验证？',
                answer: 'DNA验证是原创作者验证自己的原创作品所有权的一种方式。<br>' + '验证DNA的必要条件包括：原本DNA，认证内容时收到的认证邮件中的密钥字段，原创者的账号密钥保护码以及正确的图片验证码。只有当所有验证信息都正确完整且匹配一致时，才能够验证通过，验证通过既表示该内容为作者所有，是有力的所有权归属凭证。'
            }]
        }, {
            title: '媒体平台',
            list: [{
                question: '什么是媒体平台?',
                answer: '作为创作者，从事创作与发表的平台被称作“媒体平台”。比如微信公众号、微博头条、今日头条、知乎以及简书等都属于媒体平台。<br>'
            }, {
                question: '原本目前支持一键发布到哪些平台？',
                answer: '原创认证完成后，可将内容一键发布到多个媒体平台。【原本】目前支持发布到微信公众号、微博头条、今日头条三个媒体平台，绑定媒体平台后，可将已认证的文章或图片一键发到微信公众号素材库或直接发布到头条号及微博头条文章。'
            }, {
                question: '在原本绑定媒体平台有什么作用?',
                answer: '1.用于一键发布到媒体平台。绑定媒体平台后，可将在［原本］认证完成的文章或图片一键发到微信公众号素材库或直接发布到头条号及微博头条文章。<br>' + '2.用于一键导入历史文章。绑定微信公众号后，可导入微信公众号历史文章进行批量版权认证。<br>'
            }, {
                question: '如何绑定和解绑媒体平台?',
                answer: '点击账户头像下方的“媒体平台”，进入“媒体平台”页面，点击相应图标可进行绑定操作。<br>'
            }, {
                question: '绑定微信公众号后，如何导入公众号历史文章？',
                answer: '“媒体平台”的公众号绑定框中点击“导入公众号文章”，可立即导入公众号历史文章进行批量认证。'
            }]
        }, {
            title: '版权交易',
            list: [{
                question: '如何进行版权交易。',
                answer: '在全网任意地址发现想要转载的内容时，转载方可通过：<br>' + '1.点击文章末尾的［原本］认证信息，跳转至原始文章详情页获取转载授权。<br>' + '2.在［原本］搜索页面，搜索框中输入想要转载的文章或图片携带的“DNA标签”中的8位DNA数字，直接搜索获取目标内容，进入内容详情页面获取转载授权。<br>' + '获取授权操作：<br>' + '进入内容详情页，点击“获取授权”按钮，理解授权协议并同意后，在弹出的窗口中键入真实的转载账号信息，点击“确认”，支付成功后即可获得该内容的单次转载授权（目前支持微信、支付宝及余额支付）。<br>'
            }, {
                question: '获取授权的过程中为什么需要填写转载方的转载平台账号及相关信息?',
                answer: '在转载用户获取授权过程中，用户必须填写转载账号类型、账号名称以及账号ID。转载授权信息将记录在不可篡改的区块链网络中，每一次转载授权将生成唯一的转载DNA并作为转载检测结果判断的依据，为避免检测系统的误判，请务必保证填写信息真实有效。<br>'
            }, {
                question: '购买授权的作品可以被如何使用?',
                answer: '基于原创者制定的授权协议，转载用户需要遵守原创者的授权要求。同时授权范围仅限网络、报刊杂志的非独占性单次转载。'
            }, {
                question: '作者如何接收和查看授权转载交易详情?',
                answer: '用户可在原本网页的消息提醒处收到授权交易信息，在“我的交易”页面可以查看历史的版权交易记录与详情。<br>' + '绑定微信号后可直接通过微信获得授权交易信息提醒。<br>'
            }, {
                question: '作者如何提现收益？',
                answer: '在“个人信息”页面里的“提现账号”一栏中，点击“立即绑定”即可绑定用来提现的微信号。绑定成功后，在“我的交易”页面点击“提现”,在弹出的窗口中输入提现金额，即可立即提现到微信钱包。<br>'
            }, {
                question: '作品经过多次转载后依然能够获取版权收益吗?',
                answer: '可以。用户发表到媒体平台的文章底部携带该作品的“版权标签”，转载者能通过标签中的DNA码自助获取授权。转载者转载发表的文章底部又会携带“转载DNA”，这些转载标签吸引来新的转载者，他们的授权交易仍然会流入最初的原创者手中。以此类推，无论经过多少手转载，所有获取授权的收益都属于原创者。'
            }]
        }, {
            title: '全网转载监测',
            list: [{
                question: '什么是原本全网转载监测系统？',
                answer: '原本开发”hawkeye（鹰眼）”全网转载监测系统，可以对用户在[原本]认证的每一篇文章进行全网络转载情况的自动监测，原创作品一旦获得原本认证，[原本]将开启对该原创作品的全网转载监测。'
            }, {
                question: '原创者如何查看已认证作品的全网转载情况?',
                answer: '根据全网转载监测结果，[原本]从单篇文章被转载情况、单个主体对同一原创账号的原创内容的转载情况，以及不同时间段的转载情况等方面生成可视化的转载报告，用户可在“转载监测”进行页面查看，了解原创内容的所有转载详情。'
            }, {
                question: '对于侵权的作品，如何处理？',
                answer: '原本技术团队结合区块链技术开发出“磐石”电子取证系统，用户通过“磐石”可以快速地对侵权证据做固化保全。<br>' + '原本已对接版权专业律所，可为用户提供全程的维权服务。'
            }]
        }, {
            title: '取证管理',
            list: [{
                question: '什么是电子取证？',
                answer: '网页电子取证是指通过对网页电子数据的固化保全，将涉嫌违法的网上行为进行证据保存的行为。'
            }, {
                question: '为什么要取证？',
                answer: '1.网页电子取证是固化网络转载行为和保存侵权证据的的有力手段之一；<br>' + '2.将每一次转载记录固化保存，能够避免涉嫌侵权的转载信息被修改或删除的情况。<br>'
            }, {
                question: '如何取证（加入取证，取证管理及下载，打包下载）',
                answer: '在“转载监测”页面中，每一条监测结果右侧都有一个“取证”按钮，点击“取证”即可将该转载监测结果加入取证列表。<br>' + '在“证据管理”页面，“正在取证”列表显示正在取证的信息及状态，“证据列表”显示已完成取证的内容标题、来源及取证时间，可对列表中的信息进行预览，逐条下载或勾选后进行打包下载。打包下载的内容将集中在一个文件夹中，方便用户做在本地进行管理。<br>'
            }]
        }, {
            title: '法律维权',
            list: [{
                question: '如何申请维权？',
                answer: '原本与专业律所进行合作，帮助用户对接维权法律服务。用户可联系客服提交维权申请，律所会提出针对的维权方案帮助用户维护版权。'
            }]
        }];
    }

    (0, _createClass3.default)(guideController, [{
        key: 'showDetail',
        value: function showDetail(event) {
            var $answer = $(event.currentTarget).next();
            if ($answer.hasClass('active')) {
                $answer.removeClass('active');
            } else {
                $answer.addClass('active');
            }
        }
    }]);
    return guideController;
}();

exports.default = guideController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1184);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./guide.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./guide.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by ganlu on 29/12/2016.
 */
var UserInfoService = function () {
    function UserInfoService() {
        "ngInject";

        (0, _classCallCheck3.default)(this, UserInfoService);
        this.user = null;
    }

    (0, _createClass3.default)(UserInfoService, [{
        key: "setUser",
        value: function setUser(user) {
            this.user = user;
        }
    }, {
        key: "isGuest",
        value: function isGuest() {
            return !(this.user && this.user.id);
        }
    }, {
        key: "isAuthor",
        value: function isAuthor(original) {
            if (!original) return false;
            return !this.isGuest() && this.user.id == original.user_id;
        }
    }, {
        key: "isOriginalOwner",
        value: function isOriginalOwner(original, reproduction) {
            if (!this.isGuest()) {
                if (this.user.id == original.user.id) return true;

                //  console.log(this.user.type)
                //  console.log(this.user.admin_id)
                //  console.log(this.user)
                //  console.log(original)
                //  console.log(reproduction)
                //  console.log(original.user.id)
                //  console.log("-------------")
                if (this.user.type == 1 && (original.reproduction && this.user.admin_id == original.reproduction.user.id || this.user.admin_id == original.user.id)) {
                    //企业用户时  对同组织内多个角色 兼容 （不需要付钱获取授权）
                    return true;
                }

                if (reproduction) {
                    if (reproduction.user_id == this.user.id) {
                        return true;
                    }
                }
            }

            return false;
        }
    }]);
    return UserInfoService;
}();

exports.default = UserInfoService;

/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _payment = __webpack_require__(1187);

var _payment2 = _interopRequireDefault(_payment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var paymentModule = _angular2.default.module('payment', []).component('payment', _payment2.default).name;

var states = [{
    name: 'payment',
    url: '/payment/weixin/{id}',
    component: 'payment'
}];

exports.default = { name: paymentModule, states: states };

/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _payment = __webpack_require__(1188);

var _payment2 = _interopRequireDefault(_payment);

var _payment3 = __webpack_require__(1189);

var _payment4 = _interopRequireDefault(_payment3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var blocklistComponent = {
  restrict: 'E',
  bindings: {
    appUser: '='
  },
  template: _payment2.default,
  controller: _payment4.default
};

exports.default = blocklistComponent;

/***/ }),
/* 1188 */
/***/ (function(module, exports) {

module.exports = "<div class=\"payments\">\n\n</div>\n";

/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BlocklistController = function () {
    BlocklistController.$inject = ['OrderAPI', 'NoLoginPayAPI', '$state', '$filter', 'userInfo', '$rootScope', '$scope', '$stateParams', 'message', '$timeout'];

    function BlocklistController(OrderAPI, NoLoginPayAPI, $state, $filter, userInfo, $rootScope, $scope, $stateParams, message, $timeout) {
        "ngInject";

        (0, _classCallCheck3.default)(this, BlocklistController);
        this.$state = $state;
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.OrderAPI = OrderAPI;
        this.message = message;
        this.$stateParams = $stateParams;
        this.$timeout = $timeout;
        this.order = {};
        this.userInfo = userInfo;
        this.NoLoginPayAPI = NoLoginPayAPI;
        this.isLogined = this.appUser && this.appUser.id;
        this.tranlsteFilter = $filter('translate');
        var self = this;
        self.wechatPay = function (callback) {
            var payment = {
                'pay_type': 'pubnumber'
            };
            var api = '';
            if (self.isLogined) {
                api = this.OrderAPI.one(self.$stateParams.id).post('pay', payment);
            } else {
                //未登录pc端用微信扫码购买
                payment.order_id = self.$stateParams.id;
                api = this.NoLoginPayAPI.one('weixin').post('qrcode', payment);
            };
            api.then(function (data) {
                self.order = data.order;
                WeixinJSBridge.invoke('getBrandWCPayRequest', {
                    "appId": data.js_json.appId || '', //公众号名称，由商户传入
                    "timeStamp": data.js_json.timeStamp || '', //时间戳，自1970年以来的秒数
                    "nonceStr": data.js_json.nonceStr || '', //随机串
                    "package": data.js_json.package || '',
                    "signType": data.js_json.signType || '', //微信签名方式：
                    "paySign": data.js_json.paySign || '' //微信签名
                }, function (res) {
                    if (res.err_msg == "get_brand_wcpay_request:ok") {
                        callback({ status: 'success' });
                    } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
                        callback({ status: 'cancel' });
                    } else {
                        callback({ status: 'fail' });
                    }
                });
            }, function (response) {
                self.loading = false;
                self.message.error(response.data);
            });
        };
        self.onBridgeReady = function () {
            self.wechatPay(function (res) {
                if (res.status === 'success') {
                    self.checkOrderStatus();
                } else if (res.status === 'cancel') {
                    self.buyFailed(self.tranlsteFilter('page-payment-text002'));
                } else {
                    self.buyFailed(self.tranlsteFilter('page-payment-text003'));
                }
            });
        };
    }

    (0, _createClass3.default)(BlocklistController, [{
        key: 'checkOrderStatus',
        value: function checkOrderStatus() {
            var self = this;
            if (!self.isLogined) {
                this.NoLoginPayAPI.one('order').one(self.order.order_id).get().then(function (order) {
                    if (order && order.status == 2) {
                        self.order = order;
                        self.buySucceed();
                    } else {
                        self.message.error(response.data);
                    }
                }, function (response) {
                    self.message.error(response.data);
                });
            } else {
                this.OrderAPI.one(self.$stateParams.id).get().then(function (order) {
                    self.order = order;
                    if (order.status == 2) {
                        self.buySucceed();
                    } else {
                        self.$timeout(function () {
                            self.checkOrderStatus();
                        }, 3000);
                    }
                }, function (response) {
                    self.message.error(response.data);
                });
            }
        }
    }, {
        key: 'buySucceed',
        value: function buySucceed() {
            var self = this;
            self.message.success(self.tranlsteFilter('page-payment-text001'));
            self.$timeout(function () {
                if (self.order.order_article) {
                    self.$state.go('app.page.original.articleReproduction', { reproduction: self.order.order_article.yuanben_id });
                } else {
                    self.$state.go('app.page.original.imageReproduction', { reproduction: self.order.order_image.yuanben_id });
                }
            }, 1000);
        }
    }, {
        key: 'buyFailed',
        value: function buyFailed(typestr) {
            var self = this;
            self.message.error(typestr);
            self.$timeout(function () {
                if (self.order.order_article) {
                    self.$state.go('app.page.original.article', { id: self.order.order_article.article.yuanben_id });
                } else {
                    self.$state.go('app.page.original.image', { id: self.order.order_image.image.yuanben_id });
                }
            }, 1000);
        }
    }, {
        key: '$onInit',
        value: function $onInit() {
            var self = this;
            if (typeof WeixinJSBridge == "undefined") {
                if (typeof document.addEventListener == 'function') {
                    document.addEventListener('WeixinJSBridgeReady', self.onBridgeReady, false);
                }
            } else {
                self.onBridgeReady();
            }
        }
    }]);
    return BlocklistController;
}();

exports.default = BlocklistController;

/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
   value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _similarity = __webpack_require__(1191);

var _similarity2 = _interopRequireDefault(_similarity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var similarityModule = _angular2.default.module('similarity', []).component('similarity', _similarity2.default).name;

var states = [{
   name: 'similarity',
   url: '/similarity?infringement',
   component: 'similarity',
   resolve: {
      articles: ['QueryAPI', '$stateParams', function articles(QueryAPI, $stateParams) {
         "ngInject";

         if (!$stateParams.infringement) {
            return null;
         } else {
            return $stateParams.infringement;
         }
      }]
   }
}];

exports.default = { name: similarityModule, states: states };

/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _similarity = __webpack_require__(1192);

var _similarity2 = _interopRequireDefault(_similarity);

var _similarity3 = __webpack_require__(1193);

var _similarity4 = _interopRequireDefault(_similarity3);

__webpack_require__(1194);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var similarityComponent = {
  restrict: 'E',
  bindings: {
    articles: '='
  },
  template: _similarity2.default,
  controller: _similarity4.default
};

exports.default = similarityComponent;

/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<div class=\"form-page block single-page\">\n  <div class=\"block-title\">\n    <div class=\"heading\">\n      {{'page-similarity-text001' | translate}}\n    </div>\n    <div class=\"action\">\n      <button type=\"submit\" class=\"btn btn-primary btn-md\" ng-click=\"$ctrl.submit()\"\n              ng-disabled=\"$ctrl.loading\">{{$ctrl.loading && ('page-verify-text014' | translate) || ('page-verify-text035'|translate)}}\n      </button>\n    </div>\n  </div>\n  <div ng-if=\"!$ctrl.loadingCompare\" style=\"width:100%;text-align:center;padding:26px\">\n      <div  style=\"display:flex;margin:0px auto;width:50%;padding:16px;color:rgb(0,95,73);background:#eef4df;border-radius:5px;font-size:18px\">\n      <div style=\"display:inline-block;text-align:center;flex:1\"> <span style=\"display:inline-block;\">{{'page-similarity-text005' | translate}}{{($ctrl.percent * 100).toFixed(2)}}%</span></div>\n      <span style=\"display:inline-block;font-weight: bold;\">|</span>\n      <div style=\"display:inline-block;text-align:center;width:50%;flex:1\"><span style=\"display:inline-block;\">{{'page-similarity-wordNum' | translate}}{{$ctrl.similarNum}}</span></div>\n      </div>\n  </div>\n  <div class=\"content\" ng-show=\"!$ctrl.loadingCompare\">\n    <!-- <textarea id=\"artical1\" class=\"left editable\" ng-model=\"$ctrl.post1\" placeholder=\"{{'page-similarity-text002' | translate}}\"></textarea> -->\n    <!-- <textarea id=\"artical2\" class=\"right editable\" ng-model=\"$ctrl.post2\" placeholder=\"{{'page-similarity-text003' | translate}}\"></textarea> -->\n    <div style=\"margin-bottom: 10px;width: 50%;float: left;font-size:16px;color:#005f49;font-weight:bold\">{{'page-similarity-text008' | translate}}</div>\n    <div style=\"margin-bottom: 10px;width: 50%;float: left;font-size:16px;color:#005f49;font-weight:bold\">{{'page-similarity-text009' | translate}}</div>\n    <div id=\"artical1\" class=\"left editable\"  placeholder=\"{{'page-similarity-text002' | translate}}\" ng-attr-contenteditable=\"{{$ctrl.loadingCompare ? 'false' : 'true'}}\"></div>\n    <div id=\"artical2\" class=\"left editable\"  placeholder=\"{{'page-similarity-text003' | translate}}\" ng-attr-contenteditable=\"{{$ctrl.loadingCompare ? 'false' : 'true'}}\"></div>\n  </div>\n  <div ng-if=\"$ctrl.loadingCompare\" style=\"width:100%;height:500px;display:flex;align-items:center;text-align:center;flex-direction: row;justify-content:center;\">\n   <img src=\"" + __webpack_require__(162) + "\" width=\"100\" height=\"68\" />\n   <div class=\"license-loading-text\">\n     {{'home-infringements-text083' | translate}}\n   </div>\n </div>\n</div>\n\n<div class=\"modal-overlay result\" id=\"result\" modal-control >\n  <div class=\"modal\">\n    <div class=\"header\">\n      <div class=\"title\">{{'page-similarity-text004' | translate}}</div>\n      <div class=\"close\">×</div>\n    </div>\n    <div class=\"content no-footer\">\n      <div class=\"title\">\n          转载文章链接已失效无法进行比对\n      </div>\n      <button class=\"btn btn-primary\" ng-click=\"$ctrl.closePage()\">{{'page-similarity-text006' | translate}}</button>\n    </div>\n  </div>\n</div>\n";

/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SimilarityController = function () {
    SimilarityController.$inject = ['$scope', '$state', 'InfringementAPI', 'SimilarityCompareAPI', 'message', 'modal', '$filter'];

    function SimilarityController($scope, $state, InfringementAPI, SimilarityCompareAPI, message, modal, $filter) {
        'ngInject';

        (0, _classCallCheck3.default)(this, SimilarityController);
        this.SimilarityCompareAPI = SimilarityCompareAPI;
        this.message = message;
        this.modal = modal;
        this.translateFilter = $filter('translate');
        this.name = 'similarity';
        this.loading = false;
        this.isEdit = "true";
        this.similarNum = 0;
        this.loadingCompare = false;
        this.InfringementAPI = InfringementAPI;
        if (this.articles) {
            this.loading = true;
            this.loadingCompare = true;
            this.loadComparedArticles(0);
        }
    }

    (0, _createClass3.default)(SimilarityController, [{
        key: 'loadComparedArticles',
        value: function loadComparedArticles(time) {
            var self = this;
            this.InfringementAPI.one(this.articles).one("compare").one("article").one("content").get().then(function (result) {
                if (!result.data.infringement_content || result.data.infringement_content == "" || !result.data.source_content || result.data.source_content == "") {
                    console.log("article get error");
                    throw "article get error";
                }
                self.loadingCompare = false;
                self.post1 = self.getText(result.data.source_content);
                self.post2 = self.getText(result.data.infringement_content);
                var a1 = document.getElementById("artical1");
                var a2 = document.getElementById("artical2");
                a1.innerText = self.post1;
                a2.innerText = self.post2;
                self.submit();
            }).catch(function (e) {
                if (time < 5) {
                    setTimeout(function () {
                        return self.loadComparedArticles(time + 1);
                    }, 1000);
                } else {
                    self.modal.open('result');
                    self.loadingCompare = false;
                    self.loading = false;
                }
            });
        }
    }, {
        key: 'closePage',
        value: function closePage() {
            window.close();
        }
    }, {
        key: 'getText',
        value: function getText(textHtml) {
            var hiddenField = document.querySelector("#hiddenTextField");
            if (!hiddenField) {
                hiddenField = document.createElement('div');
                hiddenField.style.display = 'none';
                hiddenField.id = "hiddenTextField";
            }
            document.body.appendChild(hiddenField);
            hiddenField.innerHTML = textHtml;

            return hiddenField.textContent;;
        }
    }, {
        key: 'submit',
        value: function submit() {
            var _this = this;

            this.diffArticle();
            if (!this.post1 || !this.post2) {
                return this.message.error(this.translateFilter('page-similarity-text007'));
            }
            this.loading = true;
            this.SimilarityCompareAPI.post({
                original_text: this.post1,
                compare_text: this.post2
            }).then(function (res) {
                _this.percent = res.data.score;
                _this.loading = false;
            });
        }
    }, {
        key: 'diffArticle',
        value: function diffArticle() {
            var a1 = document.getElementById("artical1");
            var a2 = document.getElementById("artical2");
            this.post1 = a1.innerText;
            this.post2 = a2.innerText;

            if (!this.post1 || !this.post2) {
                this.post1 = a1.innerText;
                this.post2 = a2.innerText;
                a1.innerHTML = this.post1;
                a2.innerHTML = this.post2;
                return;
            }
            var d1 = this.strReplace(this.post1, 8);
            var d2 = this.strReplace(this.post2, 8);

            a1.innerHTML = d1;
            a2.innerHTML = d2;
            // console.log(this.post1)
            // console.log("----------------------------")
            // console.log(this.post2)
        }
    }, {
        key: 'getRes',
        value: function getRes(t1, t2, num, step) {
            var strList = [];
            var startLength = 0;
            var endLength = 0;
            function getStr(num, step) {
                var str = '';
                // console.log(num)
                if (num >= t1.length) {
                    return strList;
                }
                var finded = false;
                for (var i = num; i < t1.length; i++) {
                    str = t1.substr(i, step);
                    if (t2.indexOf(str) > -1) {
                        startLength = i;
                        finded = true;
                        break;
                    }
                }
                if (!finded) {
                    return strList;
                }
                var n = 2;
                do {
                    str = t1.substr(startLength, n);

                    if (t2.indexOf(str) > -1) {
                        endLength = n;
                        n++;
                    } else {
                        endLength = n - 1;
                        break;
                    }
                } while (n - 1 + startLength < t1.length);

                str = t1.substring(startLength, startLength + endLength);
                strList.push(str);

                // console.log(startLength)
                // console.log(endLength)
                if (num === endLength) {
                    return strList;
                }
                return getStr(startLength + endLength, step);
            }

            return getStr(num, step);
        }
    }, {
        key: 'strReplace',
        value: function strReplace(str, step) {
            var _this2 = this;

            //s1,s2 两篇文章内容
            var list = void 0;
            if (this.post1.length <= this.post2.length) {
                list = this.getRes(this.post1, this.post2, 0, step);
            } else {
                list = this.getRes(this.post2, this.post1, 0, step);
            }
            //    console.log(list)
            var res = str;
            this.similarNum = 0;
            list = list.sort(function (a, b) {
                return b.length - a.length;
            });
            list.forEach(function (e) {
                if (e.length >= 8) {
                    _this2.similarNum += e.length;
                    res = res.replace(e, "<span style='background-color: yellow;color:red;dispaly:inline-block'>" + e + "</span>");
                }
            });
            // console.log(this.similarNum)
            //console.log(res)
            return "<p>" + res + "</p>";
        }
    }]);
    return SimilarityController;
}();

exports.default = SimilarityController;

/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1195);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./similarity.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./similarity.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "similarity .heading {\n  float: left; }\n\nsimilarity .action {\n  float: right; }\n\nsimilarity .content::after {\n  display: block;\n  clear: both;\n  content: \"\"; }\n\nsimilarity .editable {\n  padding: 0 10px;\n  float: left;\n  display: inline-block;\n  width: 48%;\n  height: 100%;\n  min-height: 700px;\n  border: 1px solid #f0f0f0; }\n\nsimilarity .left {\n  margin-right: 2%; }\n\nsimilarity .modal .content {\n  text-align: center; }\n  similarity .modal .content .title {\n    margin-bottom: 30px; }\n    similarity .modal .content .title .strong {\n      font-weight: bold; }\n    similarity .modal .content .title > div {\n      line-height: 30px;\n      display: flex; }\n    similarity .modal .content .title .label-left {\n      display: inline-block;\n      width: 50%;\n      text-align: right; }\n    similarity .modal .content .title .top {\n      letter-spacing: 4px; }\n", ""]);

// exports


/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _clipboard = __webpack_require__(1197);

var _clipboard2 = _interopRequireDefault(_clipboard);

var _message = __webpack_require__(1198);

var _message2 = _interopRequireDefault(_message);

var _badge = __webpack_require__(1199);

var _badge2 = _interopRequireDefault(_badge);

var _pageTitle = __webpack_require__(1205);

var _pageTitle2 = _interopRequireDefault(_pageTitle);

var _userLogin = __webpack_require__(1206);

var _userLogin2 = _interopRequireDefault(_userLogin);

var _CRC = __webpack_require__(1215);

var _CRC2 = _interopRequireDefault(_CRC);

var _jurisdiction = __webpack_require__(1216);

var _jurisdiction2 = _interopRequireDefault(_jurisdiction);

__webpack_require__(1217);

var _typemap = __webpack_require__(1218);

var _typemap2 = _interopRequireDefault(_typemap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by lency on 9/20/16.
 */
var servicesModule = _angular2.default.module('app.services', ['ct.ui.router.extras.previous']).service({
    clipboard: _clipboard2.default,
    message: _message2.default,
    badge: _badge2.default,
    pageTitle: _pageTitle2.default,
    userLogin: _userLogin2.default,
    crc32: _CRC2.default,
    Jurisdiction: _jurisdiction2.default
}).factory('$getCertLink', ['AppConfig', function (AppConfig) {
    'ngInject';

    return function (id) {
        console.log(AppConfig.server_url + '/articles/package/' + id + '/ca/download');
        //   return `${AppConfig.server_url}/articles/package/${id}/ca/download`
    };
}]).factory('$typeMap', _typemap2.default).name;

exports.default = servicesModule;

/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by lency on 9/22/2016.
 */
var ClipboardService = function () {
    ClipboardService.$inject = ['message', '$filter', '$timeout'];

    function ClipboardService(message, $filter, $timeout) {
        "ngInject";

        (0, _classCallCheck3.default)(this, ClipboardService);
        this.tranlsteFilter = $filter('translate');
        this.message = message;
        this.$timeout = $timeout;
    }

    (0, _createClass3.default)(ClipboardService, [{
        key: 'copyElementById',
        value: function copyElementById(id) {
            var _this = this;

            var node = document.getElementById(id);
            this.selectContent(node);

            if (!document.execCommand('copy')) {
                this.$timeout(function () {
                    _this.message.error(_this.tranlsteFilter('services-text001'));
                }, 300);
            } else {
                this.$timeout(function () {
                    _this.message.success('<i class="fa fa-check-circle"></i> ' + _this.tranlsteFilter('services-text002'));
                }, 300);
            }
        }
    }, {
        key: 'selectContent',
        value: function selectContent(node) {
            var range, selection;

            if (document.body.createTextRange) {
                range = document.body.createTextRange();
                range.moveToElementText(node);
                range.select();
            } else if (window.getSelection) {
                selection = window.getSelection();
                range = document.createRange();
                range.selectNodeContents(node);
                selection.removeAllRanges();
                selection.addRange(range);
            }
        }
    }]);
    return ClipboardService;
}();

exports.default = ClipboardService;

/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by ganlu on 25/09/2016.
 */
var MessageService = function () {
    MessageService.$inject = ['$timeout'];

    function MessageService($timeout) {
        "ngInject";

        (0, _classCallCheck3.default)(this, MessageService);
        this.$timeout = $timeout;
    }

    (0, _createClass3.default)(MessageService, [{
        key: 'success',
        value: function success(message) {
            this.clear();
            $('#alert-message').addClass('success');
            this.show(message, 3000);
        }
    }, {
        key: 'error',
        value: function error(message, period) {
            this.clear();
            $('#alert-message').addClass('error');

            var p = typeof period == 'undefined' ? 3000 : period;

            this.show(message, p);
        }
    }, {
        key: 'info',
        value: function info(message) {
            this.clear();
            $('#alert-message').addClass('info');
            this.show(message, 0);
        }
    }, {
        key: 'warn',
        value: function warn(message, period) {
            this.clear();
            $('#alert-message').addClass('warn');

            var p = typeof period == 'undefined' ? 3000 : period;

            this.show(message, p);
        }
    }, {
        key: 'clear',
        value: function clear() {
            $('#alert-message').removeClass('error').removeClass('warn').removeClass('success').removeClass('info');
        }
    }, {
        key: 'show',
        value: function show(message, period) {
            if ($(document).scrollTop() >= 40) {
                $('#alert-message').addClass('fixed').css('top', 0);
            } else {
                $('#alert-message').removeClass('fixed').css('top', '');
            }

            $('#alert-message').html(message).fadeIn();

            if (period != 0) {
                this.$timeout(function () {
                    $('#alert-message').fadeOut();
                }, period);
            }
        }
    }, {
        key: 'hide',
        value: function hide() {
            $('#alert-message').fadeOut();
        }
    }]);
    return MessageService;
}();

exports.default = MessageService;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _badgeImage = __webpack_require__(1200);

var _badgeImage2 = _interopRequireDefault(_badgeImage);

var _badgeText = __webpack_require__(1201);

var _badgeText2 = _interopRequireDefault(_badgeText);

var _badgeReproductionText = __webpack_require__(1202);

var _badgeReproductionText2 = _interopRequireDefault(_badgeReproductionText);

var _badgeTextEn = __webpack_require__(1203);

var _badgeTextEn2 = _interopRequireDefault(_badgeTextEn);

var _badgeReproductionTextEn = __webpack_require__(1204);

var _badgeReproductionTextEn2 = _interopRequireDefault(_badgeReproductionTextEn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BadgeService = function () {
    BadgeService.$inject = ['$window'];

    function BadgeService($window) {
        "ngInject";

        (0, _classCallCheck3.default)(this, BadgeService);
        this.$window = $window;
    }

    (0, _createClass3.default)(BadgeService, [{
        key: 'getBadgeContent',
        value: function getBadgeContent(article) {
            var content = '';
            if (article.license.type != 'none') {
                content = content + _badgeImage2.default;
            }
            if (this.$window.localStorage.yuanben_lang == 'en') {
                content = content + _badgeTextEn2.default;
            } else {
                content = content + _badgeText2.default;
            }

            content = content.replace(/__article_url__/g, article.url);
            content = content.replace(/__badge_src__/g, 'src="' + article.badge_url + '"');
            content = content.replace(/__short_id__/g, article.short_id);
            content = content.replace(/__author_id__/g, article.user_id);
            content = content.replace(/__author_name__/g, article.author_name);

            return content;
        }
    }, {
        key: 'getReproductionBadgeContent',
        value: function getReproductionBadgeContent(article, reproduction) {
            var content = '';
            if (article.license.type != 'none') {
                content = content + _badgeImage2.default;
            }
            if (this.$window.localStorage.yuanben_lang == 'en') {
                content = content + _badgeReproductionTextEn2.default;
            } else {
                content = content + _badgeReproductionText2.default;
            }

            content = content.replace(/__badge_src__/g, 'src="' + reproduction.badge_url + '"');
            content = content.replace(/__article_url__/g, reproduction.url);
            content = content.replace(/__short_id__/g, reproduction.short_id);
            content = content.replace(/__author_id__/g, article.user_id);
            content = content.replace(/__author_name__/g, article.author_name);
            content = content.replace(/__reproduction_url__/g, reproduction.url);

            return content;
        }
    }]);
    return BadgeService;
}(); /**
      * Created by ganlu on 09/10/2016.
      */


exports.default = BadgeService;

/***/ }),
/* 1200 */
/***/ (function(module, exports) {

module.exports = "<p style=\"margin-top:28px;margin-bottom:10px;height:42px\"><img __badge_src__/></p>\n";

/***/ }),
/* 1201 */
/***/ (function(module, exports) {

module.exports = "<p style=\"font-size:12px;color:#787878;margin-top:4px\">本文经「原本」原创认证，作者__author_name__，访问yuanben.io查询【<a\n    href=\"__article_url__\" target=\"_blank\" style=\"text-decoration:none;color:#007f69\">__short_id__</a>】获取授权信息。</p>\n";

/***/ }),
/* 1202 */
/***/ (function(module, exports) {

module.exports = "<p style=\"font-size:12px;color:#787878;margin-top:4px\">本文已获得转载授权，版权为__author_name__所有，访问原本yuanben.io查询【<a\n    href=\"__reproduction_url__\" target=\"_blank\" style=\"text-decoration:none;color:#007f69\">__short_id__</a>】验证授权</p>\n";

/***/ }),
/* 1203 */
/***/ (function(module, exports) {

module.exports = "<p style=\"font-size:12px;color:#787878;margin-top:4px\">\n    This article has been verified as original by 「Yuanben」，author __author_name__，visit yuanben.io and search 【<a\n    href=\"__article_url__\" target=\"_blank\" style=\"text-decoration:none;color:#007f69\">__short_id__</a>】 to obtain copyright information.</p>\n";

/***/ }),
/* 1204 */
/***/ (function(module, exports) {

module.exports = "<p style=\"font-size:12px;color:#787878;margin-top:4px\">\n    This article has obtained authorization for reposting, copyright belongs to __author_name__, visit yuanben.io and search 【<a\n    href=\"__reproduction_url__\" target=\"_blank\" style=\"text-decoration:none;color:#007f69\">__short_id__</a>】 to verify authorization.</p>\n";

/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by ganlu on 09/11/2016.
 */
var PageTitleService = function () {
    PageTitleService.$inject = ['$window', '$transitions', '$translate'];

    function PageTitleService($window, $transitions, $translate) {
        "ngInject";

        (0, _classCallCheck3.default)(this, PageTitleService);
        this.$window = $window;
        this.$transitions = $transitions;
        this.$translate = $translate;
    }

    (0, _createClass3.default)(PageTitleService, [{
        key: 'init',
        value: function init() {

            var self = this;

            this.$transitions.onEnter({}, function (transition, state) {

                if (state.title) {
                    self.$translate(state.title).then(function (translation) {
                        self.setTitle(translation);
                    });
                } else {
                    self.setTitle('');
                }
                if (state.description) {
                    self.$translate(state.description).then(function (translation) {
                        self.setDescription(translation);
                    });
                } else {
                    self.$translate('page-default-desc').then(function (translation) {
                        self.setDescription(translation);
                    });
                }
            });
        }
    }, {
        key: 'setTitle',
        value: function setTitle(title) {
            var _this = this;

            var self = this;
            self.$translate('page-default-title').then(function (translation) {
                var str = translation;
                if (title) {
                    str = title + " - " + str;
                }
                _this.$window.document.title = str;
            });
        }
    }, {
        key: 'setDescription',
        value: function setDescription(description) {
            $('meta[name=description]').attr('content', description);
        }
    }]);
    return PageTitleService;
}();

exports.default = PageTitleService;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
   value: true
});

var _stringify = __webpack_require__(83);

var _stringify2 = _interopRequireDefault(_stringify);

var _promise = __webpack_require__(1207);

var _promise2 = _interopRequireDefault(_promise);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by ganlu on 20/04/2017.
 */
var UserLoginService = function () {
   UserLoginService.$inject = ["UserAPI", "$interval"];

   function UserLoginService(UserAPI, $interval) {
      "ngInject";

      (0, _classCallCheck3.default)(this, UserLoginService);
      this.user = {};

      this.loading = false;
      this.loaded = false;

      this.UserAPI = UserAPI;
      this.$interval = $interval;
   }

   (0, _createClass3.default)(UserLoginService, [{
      key: "getUserOrPromise",
      value: function getUserOrPromise() {

         if (this.loaded) return this.user;

         return this.getUserPromise();
      }
   }, {
      key: "getUser",
      value: function getUser() {
         var _this = this;

         var num = 0;
         return new _promise2.default(function (resolve, reject) {

            var id = _this.$interval(function () {
               num++;
               if (num == 6) {
                  //3秒 请求超时
                  resolve(_this.user);
                  _this.$interval.cancel(id);
               }
               if (_this.loaded) {
                  resolve(_this.user);
                  _this.$interval.cancel(id);
               }
            }, 1000);
         });
      }
   }, {
      key: "getUserPromise",
      value: function getUserPromise() {

         var self = this;

         return new _promise2.default(function (resolve, reject) {

            self.loading = true;

            self.UserAPI.one().get().then(function (user) {
               window.localStorage.setItem("loginUser", (0, _stringify2.default)(user));
               for (var k in user) {
                  if (user.hasOwnProperty(k)) {
                     if (typeof user[k] !== 'function') {
                        self.user[k] = user[k];
                     }
                  }
               }
               self.user.avatar = self.user.avatar + '?s=' + Math.random();
               self.loading = false;
               self.loaded = true;

               resolve(self.user);
            }, function (response) {

               self.loading = false;
               self.loaded = true;

               reject(response);
            });
         });
      }
   }, {
      key: "loadUser",
      value: function loadUser(callback) {

         if (this.loading) return;

         this.getUserPromise().then(function (user) {
            if (typeof callback === 'function') {
               callback(user);
            }
         });
      }
   }, {
      key: "logout",
      value: function logout() {

         var self = this;

         return new _promise2.default(function (resolve, reject) {
            self.UserAPI.one().customPOST({}, "logout").then(function () {
               for (var k in self.user) {
                  if (self.user.hasOwnProperty(k)) {
                     delete self.user[k];
                  }
               }

               resolve();
            }, function (response) {
               reject(response);
            });
         });
      }
   }, {
      key: "isGuest",
      value: function isGuest() {
         return this.user && !this.user.id;
      }
   }]);
   return UserLoginService;
}();

exports.default = UserLoginService;

/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1208), __esModule: true };

/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(355);
__webpack_require__(351);
__webpack_require__(357);
__webpack_require__(1209);
__webpack_require__(1213);
__webpack_require__(1214);
module.exports = __webpack_require__(24).Promise;


/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(116);
var global = __webpack_require__(25);
var ctx = __webpack_require__(84);
var classof = __webpack_require__(183);
var $export = __webpack_require__(50);
var isObject = __webpack_require__(74);
var aFunction = __webpack_require__(87);
var anInstance = __webpack_require__(359);
var forOf = __webpack_require__(347);
var speciesConstructor = __webpack_require__(337);
var task = __webpack_require__(338).set;
var microtask = __webpack_require__(1211)();
var newPromiseCapabilityModule = __webpack_require__(159);
var perform = __webpack_require__(339);
var userAgent = __webpack_require__(1212);
var promiseResolve = __webpack_require__(340);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(32)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(358)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(118)($Promise, PROMISE);
__webpack_require__(374)(PROMISE);
Wrapper = __webpack_require__(24)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(375)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 1210 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(25);
var macrotask = __webpack_require__(338).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(88)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(25);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(50);
var core = __webpack_require__(24);
var global = __webpack_require__(25);
var speciesConstructor = __webpack_require__(337);
var promiseResolve = __webpack_require__(340);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(50);
var newPromiseCapability = __webpack_require__(159);
var perform = __webpack_require__(339);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var T = void 0;

var CRC32 = function () {
    function CRC32() {
        (0, _classCallCheck3.default)(this, CRC32);

        this.version = '1.2.0';
        T = this.signed_crc_table();
    }

    (0, _createClass3.default)(CRC32, [{
        key: 'signed_crc_table',
        value: function signed_crc_table() {
            var c = 0,
                table = new Array(256);

            for (var n = 0; n != 256; ++n) {
                c = n;
                c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
                c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
                c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
                c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
                c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
                c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
                c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
                c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
                table[n] = c;
            }

            return typeof Int32Array !== 'undefined' ? new Int32Array(table) : table;
        }
    }, {
        key: 'crc32_bstr',
        value: function crc32_bstr(bstr, seed) {
            var C = seed ^ -1,
                L = bstr.length - 1;
            for (var i = 0; i < L;) {
                C = C >>> 8 ^ T[(C ^ bstr.charCodeAt(i++)) & 0xFF];
                C = C >>> 8 ^ T[(C ^ bstr.charCodeAt(i++)) & 0xFF];
            }
            if (i === L) C = C >>> 8 ^ T[(C ^ bstr.charCodeAt(i)) & 0xFF];
            return (C ^ -1) >>> 0;
        }
    }, {
        key: 'crc32_buf',
        value: function crc32_buf(buf, seed) {
            if (buf.length > 10000) return crc32_buf_8(buf, seed);
            var C = seed ^ -1,
                L = buf.length - 3;
            for (var i = 0; i < L;) {
                C = C >>> 8 ^ T[(C ^ buf[i++]) & 0xFF];
                C = C >>> 8 ^ T[(C ^ buf[i++]) & 0xFF];
                C = C >>> 8 ^ T[(C ^ buf[i++]) & 0xFF];
                C = C >>> 8 ^ T[(C ^ buf[i++]) & 0xFF];
            }
            while (i < L + 3) {
                C = C >>> 8 ^ T[(C ^ buf[i++]) & 0xFF];
            }return (C ^ -1) >>> 0;
        }
    }, {
        key: 'crc32_buf_8',
        value: function crc32_buf_8(buf, seed) {
            var C = seed ^ -1,
                L = buf.length - 7;
            for (var i = 0; i < L;) {
                C = C >>> 8 ^ T[(C ^ buf[i++]) & 0xFF];
                C = C >>> 8 ^ T[(C ^ buf[i++]) & 0xFF];
                C = C >>> 8 ^ T[(C ^ buf[i++]) & 0xFF];
                C = C >>> 8 ^ T[(C ^ buf[i++]) & 0xFF];
                C = C >>> 8 ^ T[(C ^ buf[i++]) & 0xFF];
                C = C >>> 8 ^ T[(C ^ buf[i++]) & 0xFF];
                C = C >>> 8 ^ T[(C ^ buf[i++]) & 0xFF];
                C = C >>> 8 ^ T[(C ^ buf[i++]) & 0xFF];
            }
            while (i < L + 7) {
                C = C >>> 8 ^ T[(C ^ buf[i++]) & 0xFF];
            }return (C ^ -1) >>> 0;
        }
    }, {
        key: 'crc32_str',
        value: function crc32_str(str, seed) {
            var C = seed ^ -1;
            for (var i = 0, L = str.length, c, d; i < L;) {
                c = str.charCodeAt(i++);
                if (c < 0x80) {
                    C = C >>> 8 ^ T[(C ^ c) & 0xFF];
                } else if (c < 0x800) {
                    C = C >>> 8 ^ T[(C ^ (192 | c >> 6 & 31)) & 0xFF];
                    C = C >>> 8 ^ T[(C ^ (128 | c & 63)) & 0xFF];
                } else if (c >= 0xD800 && c < 0xE000) {
                    c = (c & 1023) + 64;d = str.charCodeAt(i++) & 1023;
                    C = C >>> 8 ^ T[(C ^ (240 | c >> 8 & 7)) & 0xFF];
                    C = C >>> 8 ^ T[(C ^ (128 | c >> 2 & 63)) & 0xFF];
                    C = C >>> 8 ^ T[(C ^ (128 | d >> 6 & 15 | (c & 3) << 4)) & 0xFF];
                    C = C >>> 8 ^ T[(C ^ (128 | d & 63)) & 0xFF];
                } else {
                    C = C >>> 8 ^ T[(C ^ (224 | c >> 12 & 15)) & 0xFF];
                    C = C >>> 8 ^ T[(C ^ (128 | c >> 6 & 63)) & 0xFF];
                    C = C >>> 8 ^ T[(C ^ (128 | c & 63)) & 0xFF];
                }
            }
            return (C ^ -1) >>> 0;
        }
    }]);
    return CRC32;
}();

exports.default = CRC32;

/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = __webpack_require__(49);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var role_route = {
    1: [//财务 //允许访问的路由
    "app.home.profile.recharge", "app.home.profile.orders", "app.home.profile.account", "app.home.profile.receipt"],
    2: [//不允许访问的路由
    "app.home.profile.manage"]
};
var name_verifiedAllow = { //未实名认证 允许访问的 页面列表 根据角色判断
    1: ["app.home.profile.account"]
};

var Jurisdiction = function () {
    function Jurisdiction() {
        (0, _classCallCheck3.default)(this, Jurisdiction);

        // let user = JSON.parse(window.localStorage.getItem("loginUser"))//不能及时获取到最新的值 待优化
        this.isAllow = false;
    }

    (0, _createClass3.default)(Jurisdiction, [{
        key: "checkStatus",
        value: function checkStatus(params) {
            //route_name,checkType  控制路由
            // console.log(params.role_type) 
            if (params.role_type === 0) {
                return "admin";
            } else if (!params.role_type) {
                //不为0且没有值 未登录
                return true;
            }

            params.permissions_list = params.role_permissions.split("|");
            switch (params.role_type) {
                case 1:
                    return this.finance(params);break;
                case 2:
                    return 2;break; //小编拥有所有路由
            }
        }
    }, {
        key: "finance",
        value: function finance(params) {
            //角色——财务
            var isTrue = this.checkName_verified(params, name_verifiedAllow[params.role_type]); //是否实名认证


            switch (params.checkType) {//name_verified|实名认证
                case "route":
                    return role_route[params.role_type].indexOf(params.route_name) > -1 && isTrue;break;
                case "redirect_route":
                    return { path: isTrue ? "app.home.profile.orders" : "app.home.profile.account", status: role_route[params.role_type].indexOf(params.route_name) > -1 && isTrue };break;
                case "role_permissions":
                    return params.permissions_list.indexOf(params.permissions_num) > -1 && isTrue;break;
            }
        }
    }, {
        key: "checkName_verified",
        value: function checkName_verified(params, list) {
            //检测是否实名认证 不同角色可能会在未实名认证时 可以访问的页面也不同

            if (params.name_verified == 0) {
                //未实名
                var index = list.indexOf(params.route_name);
                return index > -1;
            } else {
                return true; // 已认证
            }
        }
    }, {
        key: "checkStatusShow",
        value: function checkStatusShow(params) {
            //角色—— 小编   控制显示隐藏

            // params.role_type = 2 //测试用
            if (params.role_type === 2) {
                // 小编

                return false;
            } else {
                return true;
            }
        }
    }, {
        key: "reselut",
        value: function reselut(params, trans) {
            // 统一返回权限

            var statess = trans.router.stateService;
            var route = trans._treeChanges.to[trans._treeChanges.to.length - 1].state.name;

            var obj = (0, _assign2.default)(params, { route_name: route, checkType: "redirect_route" });
            var Identity = this.checkStatus(obj); //检查路由权限

            if (Identity.status === false) {
                return statess.target(Identity.path);
            } else {
                switch (Identity) {
                    case "admin":
                        return true;break;
                    case 2:
                        return true;break;
                    default:
                        return true;break;
                }
            }
        }
    }]);
    return Jurisdiction;
}();

exports.default = Jurisdiction;

/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


PreviousStateService.$inject = ['$state', '$q', '$transitions'];
var angular = __webpack_require__(1);
var ngModule = angular.module('ct.ui.router.extras.previous', []);
function PreviousStateService($state, $q, $transitions) {
    var previous = null;
    var lastPrevious = null;
    var memos = {};
    $transitions.onStart({}, function ($transition$) {
        var fromState = $transition$.from().$$state();
        function commit() {
            lastPrevious = null;
        }
        function revert() {
            previous = lastPrevious;
        }
        if (fromState) {
            lastPrevious = previous;
            previous = {
                state: $transition$.from(),
                params: $transition$.params('from')
            };
            $transition$.promise.then(commit)['catch'](revert);
        }
    });
    var $previousState = {
        get: function get(memoName) {
            return memoName ? memos[memoName] : previous;
        },
        set: function set(memoName, previousState, previousParams) {
            memos[memoName] = { state: $state.get(previousState), params: previousParams };
        },
        go: function go(memoName, options) {
            var to = $previousState.get(memoName);
            if (!to) {
                return $q.reject(new Error('no previous state ' + (memoName ? 'for memo: ' + memoName : '')));
            }
            return $state.go(to.state, to.params, options);
        },
        memo: function memo(memoName, defaultStateName, defaultStateParams) {
            memos[memoName] = previous || { state: $state.get(defaultStateName), params: defaultStateParams };
        },
        forget: function forget(memoName) {
            if (memoName) {
                delete memos[memoName];
            } else {
                previous = undefined;
            }
        }
    };
    return $previousState;
}
PreviousStateService.$inject = ['$state', '$q', '$transitions'];
ngModule.service('$previousState', PreviousStateService);

/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = typeMapFactory;
typeMapFactory.$inject = ['$filter'];
function typeMapFactory($filter) {
  'ngInject';

  var tranlsteFilter = $filter('translate');
  return {
    normal: tranlsteFilter('home-infringements-text066'),
    site: tranlsteFilter('home-infringements-text067'),
    article: tranlsteFilter('home-infringements-text068'),
    in_one_article: '单篇文章',
    in_one_site: '单个网站'
  };
}

/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _app = __webpack_require__(1220);

var _app2 = _interopRequireDefault(_app);

var _app3 = __webpack_require__(1221);

var _app4 = _interopRequireDefault(_app3);

__webpack_require__(1222);

__webpack_require__(1227);

__webpack_require__(1229);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import './styles/ybicons/ybicons.css';
var appComponent = {
    template: _app2.default,
    restrict: 'E',
    bindings: {
        appUser: '='
    },
    controller: _app4.default
};

exports.default = appComponent;

/***/ }),
/* 1220 */
/***/ (function(module, exports) {

module.exports = "<div class=\"app\">\n    <!-- App main view -->\n    <div ui-view></div>\n</div>\n";

/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = __webpack_require__(49);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by lency on 9/19/16.
 */

var AppController = function () {
    AppController.$inject = ['AppConfig', 'pageTitle', 'userLogin', '$timeout', '$http', '$rootScope', '$transitions', 'Jurisdiction'];

    function AppController(AppConfig, pageTitle, userLogin, $timeout, $http, $rootScope, $transitions, Jurisdiction) {
        "ngInject";

        (0, _classCallCheck3.default)(this, AppController);
        var self = this;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.userLogin = userLogin;
        pageTitle.init();
        this.$transitions = $transitions;
        this.Jurisdiction = Jurisdiction;
        // this.permission = JSON.parse(window.localStorage.getItem("loginUser"))
        //禁止双指缩放
        $('html,body').on('touchstart', function (event) {
            if (event.touches.length > 1) {
                event.preventDefault();
            }
        });
        //手机页面只在当前页面打开
        if (window.innerWidth < 767) {
            $('body').on('click', 'a', function () {
                $(this).attr('target', '_self');
            });
        }

        function getTiming() {
            var time = performance.timing;

            if (time.loadEventEnd === 0) {
                setTimeout(getTiming, 200);
                return;
            }
            var loadTime = time.loadEventEnd - time.navigationStart;
            if (loadTime > AppConfig.report_threshold_value) {
                report(loadTime);
            }
        }

        function report(loadTime) {
            $http.post(AppConfig.server_url + '/home/load/report', { load: loadTime }).then(function (res) {
                if (res.data.status.code !== 200) {
                    report(loadTime);
                }
            }, function (err) {
                report(loadTime);
            });
        }

        getTiming();
        // this.checkRoute()
    }

    (0, _createClass3.default)(AppController, [{
        key: 'loadQiYuCustomerService',
        value: function loadQiYuCustomerService(user) {
            this.$rootScope.user = user;
            var src = "https://qiyukf.com/script/d00a137e9451aefaa146c20b637c4047.js";

            if (user.id) {
                src = src + '?uid=' + user.id + '&name=' + user.pseudonym + '&email=' + user.email;
            }

            var qy = document.createElement("script");
            qy.src = src;
            qy.defer = 1;
            qy.async = 1;
            var s = document.getElementsByTagName("script")[0];
            s.parentNode.insertBefore(qy, s);
        }
    }, {
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.$timeout(function () {
                _this.userLogin.loadUser(function (user) {
                    _this.loadQiYuCustomerService(user);
                });
            });
        }
    }, {
        key: 'checkRoute',
        value: function checkRoute() {
            var _this2 = this;

            this.$transitions.onStart({ to: "app.home.**" }, function (trans) {

                // this.permission = JSON.parse(window.localStorage.getItem("loginUser"))
                // //   console.log(this.permission.role_type)
                // var statess = trans.router.stateService;

                // let route = trans._treeChanges.to[trans._treeChanges.to.length-1].state.name;

                // let params = Object.assign(this.permission,{route_name:route,checkType:"redirect_route"})
                // let Identity = this.Jurisdiction.checkStatus(params)


                // if(Identity === "admin"){
                //     return 
                // }else if(!Identity.status){

                //    return statess.target(Identity.path);
                // }else{
                //     return 
                // }


                _this2.permission = JSON.parse(window.localStorage.getItem("loginUser"));

                var params = (0, _assign2.default)(_this2.permission, { checkType: "redirect_route" });

                return _this2.Jurisdiction.reselut(params, trans);
            });
        }
    }]);
    return AppController;
}();

exports.default = AppController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1223);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!./iconfont.css", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!./iconfont.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "@font-face {font-family: \"ybicon\";\n  src: url(" + __webpack_require__(341) + "); /* IE9 */\n  src: url(" + __webpack_require__(341) + "#iefix) format('embedded-opentype'), \n  url('data:application/x-font-woff2;charset=utf-8;base64,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') format('woff2'),\n  url(" + __webpack_require__(1224) + ") format('woff'),\n  url(" + __webpack_require__(1225) + ") format('truetype'), \n  url(" + __webpack_require__(1226) + "#ybicon) format('svg'); /* iOS 4.1- */\n}\n\n.ybicon {\n  font-family: \"ybicon\" !important;\n  font-size: 16px;\n  font-style: normal;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.yb-qyrz:before {\n  content: \"\\E604\";\n}\n\n.yb-yb-check:before {\n  content: \"\\E601\";\n}\n\n.yb-yijihuo:before {\n  content: \"\\E674\";\n}\n\n.yb-bianji:before {\n  content: \"\\E673\";\n}\n\n.yb-shuoming:before {\n  content: \"\\E672\";\n}\n\n.yb-view:before {\n  content: \"\\E662\";\n}\n\n.yb-save-pdf:before {\n  content: \"\\E663\";\n}\n\n.yb-vip:before {\n  content: \"\\E664\";\n}\n\n.yb-manage:before {\n  content: \"\\E665\";\n}\n\n.yb-verify-dna:before {\n  content: \"\\E666\";\n}\n\n.yb-wechat:before {\n  content: \"\\E667\";\n}\n\n.yb-verify-wen:before {\n  content: \"\\E668\";\n}\n\n.yb-up:before {\n  content: \"\\E669\";\n}\n\n.yb-yuan:before {\n  content: \"\\E66A\";\n}\n\n.yb-wallet:before {\n  content: \"\\E66B\";\n}\n\n.yb-works:before {\n  content: \"\\E66C\";\n}\n\n.yb-wechatpay:before {\n  content: \"\\E66D\";\n}\n\n.yb-down:before {\n  content: \"\\E66E\";\n}\n\n.yb-message:before {\n  content: \"\\E66F\";\n}\n\n.yb-morelike:before {\n  content: \"\\E670\";\n}\n\n.yb-last:before {\n  content: \"\\E671\";\n}\n\n.yb-add:before {\n  content: \"\\E623\";\n}\n\n.yb-add2:before {\n  content: \"\\E624\";\n}\n\n.yb-added:before {\n  content: \"\\E625\";\n}\n\n.yb-addpic:before {\n  content: \"\\E626\";\n}\n\n.yb-alert:before {\n  content: \"\\E627\";\n}\n\n.yb-alipay:before {\n  content: \"\\E628\";\n}\n\n.yb-calendar1:before {\n  content: \"\\E629\";\n}\n\n.yb-addtosubmit:before {\n  content: \"\\E62A\";\n}\n\n.yb-box:before {\n  content: \"\\E62B\";\n}\n\n.yb-add-members:before {\n  content: \"\\E62C\";\n}\n\n.yb-calendar:before {\n  content: \"\\E62D\";\n}\n\n.yb-cc-nd:before {\n  content: \"\\E62E\";\n}\n\n.yb-cc-nb:before {\n  content: \"\\E62F\";\n}\n\n.yb-close-alt:before {\n  content: \"\\E630\";\n}\n\n.yb-choose-off:before {\n  content: \"\\E631\";\n}\n\n.yb-check_round:before {\n  content: \"\\E632\";\n}\n\n.yb-company:before {\n  content: \"\\E633\";\n}\n\n.yb-cm:before {\n  content: \"\\E634\";\n}\n\n.yb-cc0:before {\n  content: \"\\E635\";\n}\n\n.yb-cc-sa:before {\n  content: \"\\E636\";\n}\n\n.yb-cc2:before {\n  content: \"\\E637\";\n}\n\n.yb-delete:before {\n  content: \"\\E638\";\n}\n\n.yb-close:before {\n  content: \"\\E639\";\n}\n\n.yb-coin:before {\n  content: \"\\E63A\";\n}\n\n.yb-exit:before {\n  content: \"\\E63B\";\n}\n\n.yb-email:before {\n  content: \"\\E63C\";\n}\n\n.yb-download:before {\n  content: \"\\E63D\";\n}\n\n.yb-delete2:before {\n  content: \"\\E63E\";\n}\n\n.yb-earth:before {\n  content: \"\\E63F\";\n}\n\n.yb-eye_open:before {\n  content: \"\\E640\";\n}\n\n.yb-hamburger:before {\n  content: \"\\E641\";\n}\n\n.yb-export:before {\n  content: \"\\E642\";\n}\n\n.yb-feedback:before {\n  content: \"\\E643\";\n}\n\n.yb-cc-by:before {\n  content: \"\\E644\";\n}\n\n.yb-info2:before {\n  content: \"\\E645\";\n}\n\n.yb-layer:before {\n  content: \"\\E646\";\n}\n\n.yb-info:before {\n  content: \"\\E647\";\n}\n\n.yb-name:before {\n  content: \"\\E648\";\n}\n\n.yb-lock:before {\n  content: \"\\E649\";\n}\n\n.yb-next:before {\n  content: \"\\E64A\";\n}\n\n.yb-picture:before {\n  content: \"\\E64B\";\n}\n\n.yb-new-picture:before {\n  content: \"\\E64C\";\n}\n\n.yb-phone:before {\n  content: \"\\E64D\";\n}\n\n.yb-more:before {\n  content: \"\\E64E\";\n}\n\n.yb-media-link:before {\n  content: \"\\E64F\";\n}\n\n.yb-new-words:before {\n  content: \"\\E650\";\n}\n\n.yb-paper:before {\n  content: \"\\E651\";\n}\n\n.yb-refresh:before {\n  content: \"\\E652\";\n}\n\n.yb-recent:before {\n  content: \"\\E653\";\n}\n\n.yb-eye_close:before {\n  content: \"\\E654\";\n}\n\n.yb-select:before {\n  content: \"\\E655\";\n}\n\n.yb-search:before {\n  content: \"\\E656\";\n}\n\n.yb-license:before {\n  content: \"\\E657\";\n}\n\n.yb-sendmedia:before {\n  content: \"\\E658\";\n}\n\n.yb-star:before {\n  content: \"\\E659\";\n}\n\n.yb-succeed:before {\n  content: \"\\E65A\";\n}\n\n.yb-send-media:before {\n  content: \"\\E65B\";\n}\n\n.yb-quzheng:before {\n  content: \"\\E65C\";\n}\n\n.yb-shield:before {\n  content: \"\\E65D\";\n}\n\n.yb-transaction:before {\n  content: \"\\E65E\";\n}\n\n.yb-star-checked:before {\n  content: \"\\E65F\";\n}\n\n.yb-user:before {\n  content: \"\\E660\";\n}\n\n.yb-tag:before {\n  content: \"\\E661\";\n}\n\n", ""]);

// exports


/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bb43a588962e3b29bdd355437d014e31.woff";

/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "79df5596d7097b1dd2fd4d5f849d22f4.ttf";

/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "db04813b59db5b903c1fd9cc08ed49d8.svg";

/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1228);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../css-loader/index.js!./normalize.css", function() {
			var newContent = require("!!../css-loader/index.js!./normalize.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css */\n\n/**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Correct the line height in all browsers.\n * 3. Prevent adjustments of font size after orientation changes in IE and iOS.\n */\n\nhtml {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}\n\n/**\n * Remove the margin in all browsers (opinionated).\n */\n\nbody {\n  margin: 0;\n}\n\n/* HTML5 display definitions\n   ========================================================================== */\n\n/**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */\n\narticle,\naside,\ndetails, /* 1 */\nfigcaption,\nfigure,\nfooter,\nheader,\nmain, /* 2 */\nmenu,\nnav,\nsection,\nsummary { /* 1 */\n  display: block;\n}\n\n/**\n * Add the correct display in IE 9-.\n */\n\naudio,\ncanvas,\nprogress,\nvideo {\n  display: inline-block;\n}\n\n/**\n * Add the correct display in iOS 4-7.\n */\n\naudio:not([controls]) {\n  display: none;\n  height: 0;\n}\n\n/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */\n\nprogress {\n  vertical-align: baseline;\n}\n\n/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */\n\ntemplate, /* 1 */\n[hidden] {\n  display: none;\n}\n\n/* Links\n   ========================================================================== */\n\n/**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */\n\na {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}\n\n/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */\n\na:active,\na:hover {\n  outline-width: 0;\n}\n\n/* Text-level semantics\n   ========================================================================== */\n\n/**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */\n\nabbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}\n\n/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */\n\nb,\nstrong {\n  font-weight: inherit;\n}\n\n/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */\n\nb,\nstrong {\n  font-weight: bolder;\n}\n\n/**\n * Add the correct font style in Android 4.3-.\n */\n\ndfn {\n  font-style: italic;\n}\n\n/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */\n\nh1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}\n\n/**\n * Add the correct background and color in IE 9-.\n */\n\nmark {\n  background-color: #ff0;\n  color: #000;\n}\n\n/**\n * Add the correct font size in all browsers.\n */\n\nsmall {\n  font-size: 80%;\n}\n\n/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */\n\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nsup {\n  top: -0.5em;\n}\n\n/* Embedded content\n   ========================================================================== */\n\n/**\n * Remove the border on images inside links in IE 10-.\n */\n\nimg {\n  border-style: none;\n}\n\n/**\n * Hide the overflow in IE.\n */\n\nsvg:not(:root) {\n  overflow: hidden;\n}\n\n/* Grouping content\n   ========================================================================== */\n\n/**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */\n\ncode,\nkbd,\npre,\nsamp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}\n\n/**\n * Add the correct margin in IE 8.\n */\n\nfigure {\n  margin: 1em 40px;\n}\n\n/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */\n\nhr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}\n\n/* Forms\n   ========================================================================== */\n\n/**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}\n\n/**\n * Restore the font weight unset by the previous rule.\n */\n\noptgroup {\n  font-weight: bold;\n}\n\n/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */\n\nbutton,\ninput { /* 1 */\n  overflow: visible;\n}\n\n/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */\n\nbutton,\nselect { /* 1 */\n  text-transform: none;\n}\n\n/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */\n\nbutton,\nhtml [type=\"button\"], /* 1 */\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}\n\n/**\n * Remove the inner border and padding in Firefox.\n */\n\nbutton::-moz-focus-inner,\n[type=\"button\"]::-moz-focus-inner,\n[type=\"reset\"]::-moz-focus-inner,\n[type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}\n\n/**\n * Restore the focus styles unset by the previous rule.\n */\n\nbutton:-moz-focusring,\n[type=\"button\"]:-moz-focusring,\n[type=\"reset\"]:-moz-focusring,\n[type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}\n\n/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */\n\nfieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}\n\n/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */\n\nlegend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}\n\n/**\n * Remove the default vertical scrollbar in IE.\n */\n\ntextarea {\n  overflow: auto;\n}\n\n/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */\n\n[type=\"checkbox\"],\n[type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}\n\n/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */\n\n[type=\"number\"]::-webkit-inner-spin-button,\n[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}\n\n/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */\n\n[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}\n\n/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */\n\n[type=\"search\"]::-webkit-search-cancel-button,\n[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */\n\n::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}\n\n/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */\n\n::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n", ""]);

// exports


/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1230);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/index.js!./app.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/index.js!./app.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "/* Large Devices, Desktops */\n@media only screen and (min-width: 1200px) {\n  .container {\n    width: 1000px; } }\n\n/* Medium Devices, Desktops */\n@media only screen and (max-width: 1199px) and (min-width: 992px) {\n  .container {\n    width: 960px; } }\n\n/* Small Devices, Tablets */\n@media only screen and (max-width: 991px) and (min-width: 768px) {\n  .container {\n    width: 750px; } }\n\n/* Extra Small Devices, Mobile */\n@media only screen and (max-width: 767px) {\n  .container {\n    width: auto; }\n  .col-8, .col-9, .col-3, .col-4 {\n    float: none !important;\n    width: 100% !important;\n    padding-left: 12px !important;\n    padding-right: 12px !important; } }\n\n.alert {\n  position: absolute;\n  display: none;\n  width: auto;\n  min-width: 300px;\n  padding: 0 20px;\n  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.4);\n  border-radius: 2px;\n  line-height: 30px;\n  left: 50%;\n  top: 0;\n  z-index: 99999999;\n  color: #ffffff;\n  text-align: center;\n  font-size: 14px;\n  transform: translate(-50%, 0); }\n  .alert.fixed {\n    position: fixed; }\n  .alert.with-navbar {\n    top: 80px; }\n  .alert.error {\n    background-color: #ff3333; }\n  .alert.success {\n    background-color: #32d182; }\n  .alert.info {\n    background-color: #6b9fe7; }\n  .alert.warn {\n    background-color: #6b9fe7; }\n  .alert.active {\n    display: block; }\n  .alert a {\n    color: #ffffff; }\n  .alert .close {\n    text-decoration: none;\n    float: right;\n    font-size: 18px; }\n\n/* Small Devices, Mobile */\n@media only screen and (max-width: 767px) {\n  .alert {\n    width: 100%; }\n  .alert.with-navbar {\n    top: 0 !important; } }\n\n.angular-tooltip {\n  transition: opacity 500ms;\n  opacity: 0;\n  position: absolute;\n  background: #000;\n  z-index: 9999;\n  padding: 5px 10px;\n  border: 2px solid #000;\n  color: #FFFFFF;\n  pointer-events: none;\n  user-select: none;\n  max-width: 250px;\n  border-radius: 3px;\n  font-size: 0.6em; }\n  .angular-tooltip.angular-tooltip-fade-in {\n    opacity: 1; }\n  .angular-tooltip:before, .angular-tooltip:after {\n    border: solid transparent;\n    content: \" \";\n    height: 0;\n    width: 0;\n    position: absolute;\n    pointer-events: none; }\n  .angular-tooltip:before {\n    border-color: rgba(0, 0, 0, 0);\n    border-width: 8px; }\n  .angular-tooltip:after {\n    border-color: rgba(0, 0, 0, 0);\n    border-width: 5px; }\n  .angular-tooltip.angular-tooltip-top:before, .angular-tooltip.angular-tooltip-top:after, .angular-tooltip.angular-tooltip-top-center:before, .angular-tooltip.angular-tooltip-top-center:after, .angular-tooltip.angular-tooltip-top-middle:before, .angular-tooltip.angular-tooltip-top-middle:after {\n    top: 100%;\n    left: 50%; }\n  .angular-tooltip.angular-tooltip-top:before, .angular-tooltip.angular-tooltip-top-center:before, .angular-tooltip.angular-tooltip-top-middle:before {\n    margin-left: -8px;\n    border-top-color: #000; }\n  .angular-tooltip.angular-tooltip-top:after, .angular-tooltip.angular-tooltip-top-center:after, .angular-tooltip.angular-tooltip-top-middle:after {\n    margin-left: -5px;\n    border-top-color: #000; }\n  .angular-tooltip.angular-tooltip-top-right:before, .angular-tooltip.angular-tooltip-top-right:after {\n    top: 100%;\n    right: calc(100% - 8px); }\n  .angular-tooltip.angular-tooltip-top-right:before {\n    margin-right: -8px;\n    border-top-color: #000; }\n  .angular-tooltip.angular-tooltip-top-right:after {\n    margin-right: -5px;\n    border-top-color: #000; }\n  .angular-tooltip.angular-tooltip-right-top:before, .angular-tooltip.angular-tooltip-right-top:after {\n    top: calc(100% - 8px);\n    right: 100%; }\n  .angular-tooltip.angular-tooltip-right-top:before {\n    margin-top: -8px;\n    border-right-color: #000; }\n  .angular-tooltip.angular-tooltip-right-top:after {\n    margin-top: -5px;\n    border-right-color: #000; }\n  .angular-tooltip.angular-tooltip-right:before, .angular-tooltip.angular-tooltip-right:after, .angular-tooltip.angular-tooltip-right-center:before, .angular-tooltip.angular-tooltip-right-center:after, .angular-tooltip.angular-tooltip-right-middle:before, .angular-tooltip.angular-tooltip-right-middle:after {\n    top: 50%;\n    right: 100%; }\n  .angular-tooltip.angular-tooltip-right:before, .angular-tooltip.angular-tooltip-right-center:before, .angular-tooltip.angular-tooltip-right-middle:before {\n    margin-top: -8px;\n    border-right-color: #000; }\n  .angular-tooltip.angular-tooltip-right:after, .angular-tooltip.angular-tooltip-right-center:after, .angular-tooltip.angular-tooltip-right-middle:after {\n    margin-top: -5px;\n    border-right-color: #000; }\n  .angular-tooltip.angular-tooltip-right-bottom:before, .angular-tooltip.angular-tooltip-right-bottom:after {\n    bottom: calc(100% - 8px);\n    right: 100%; }\n  .angular-tooltip.angular-tooltip-right-bottom:before {\n    margin-bottom: -8px;\n    border-right-color: #000; }\n  .angular-tooltip.angular-tooltip-right-bottom:after {\n    margin-bottom: -5px;\n    border-right-color: #000; }\n  .angular-tooltip.angular-tooltip-bottom-right:before, .angular-tooltip.angular-tooltip-bottom-right:after {\n    bottom: 100%;\n    right: calc(100% - 8px); }\n  .angular-tooltip.angular-tooltip-bottom-right:before {\n    margin-right: -8px;\n    border-bottom-color: #000; }\n  .angular-tooltip.angular-tooltip-bottom-right:after {\n    margin-right: -5px;\n    border-bottom-color: #000; }\n  .angular-tooltip.angular-tooltip-bottom:before, .angular-tooltip.angular-tooltip-bottom:after, .angular-tooltip.angular-tooltip-bottom-center:before, .angular-tooltip.angular-tooltip-bottom-center:after, .angular-tooltip.angular-tooltip-bottom-middle:before, .angular-tooltip.angular-tooltip-bottom-middle:after {\n    bottom: 100%;\n    left: 50%; }\n  .angular-tooltip.angular-tooltip-bottom:before, .angular-tooltip.angular-tooltip-bottom-center:before, .angular-tooltip.angular-tooltip-bottom-middle:before {\n    margin-left: -8px;\n    border-bottom-color: #000; }\n  .angular-tooltip.angular-tooltip-bottom:after, .angular-tooltip.angular-tooltip-bottom-center:after, .angular-tooltip.angular-tooltip-bottom-middle:after {\n    margin-left: -5px;\n    border-bottom-color: #000; }\n  .angular-tooltip.angular-tooltip-bottom-left:before, .angular-tooltip.angular-tooltip-bottom-left:after {\n    bottom: 100%;\n    left: calc(100% - 8px); }\n  .angular-tooltip.angular-tooltip-bottom-left:before {\n    margin-left: -8px;\n    border-bottom-color: #000; }\n  .angular-tooltip.angular-tooltip-bottom-left:after {\n    margin-left: -5px;\n    border-bottom-color: #000; }\n  .angular-tooltip.angular-tooltip-left-bottom:before, .angular-tooltip.angular-tooltip-left-bottom:after {\n    bottom: calc(100% - 8px);\n    left: 100%; }\n  .angular-tooltip.angular-tooltip-left-bottom:before {\n    margin-bottom: -8px;\n    border-left-color: #000; }\n  .angular-tooltip.angular-tooltip-left-bottom:after {\n    margin-bottom: -5px;\n    border-left-color: #000; }\n  .angular-tooltip.angular-tooltip-left:before, .angular-tooltip.angular-tooltip-left:after, .angular-tooltip.angular-tooltip-left-center:before, .angular-tooltip.angular-tooltip-left-center:after, .angular-tooltip.angular-tooltip-left-middle:before, .angular-tooltip.angular-tooltip-left-middle:after {\n    top: 50%;\n    left: 100%; }\n  .angular-tooltip.angular-tooltip-left:before, .angular-tooltip.angular-tooltip-left-center:before, .angular-tooltip.angular-tooltip-left-middle:before {\n    margin-top: -8px;\n    border-left-color: #000; }\n  .angular-tooltip.angular-tooltip-left:after, .angular-tooltip.angular-tooltip-left-center:after, .angular-tooltip.angular-tooltip-left-middle:after {\n    margin-top: -5px;\n    border-left-color: #000; }\n  .angular-tooltip.angular-tooltip-left-top:before, .angular-tooltip.angular-tooltip-left-top:after {\n    top: calc(100% - 8px);\n    left: 100%; }\n  .angular-tooltip.angular-tooltip-left-top:before {\n    margin-top: -8px;\n    border-left-color: #000; }\n  .angular-tooltip.angular-tooltip-left-top:after {\n    margin-top: -5px;\n    border-left-color: #000; }\n  .angular-tooltip.angular-tooltip-top-left:before, .angular-tooltip.angular-tooltip-top-left:after {\n    top: 100%;\n    left: calc(100% - 8px); }\n  .angular-tooltip.angular-tooltip-top-left:before {\n    margin-left: -8px;\n    border-top-color: #000; }\n  .angular-tooltip.angular-tooltip-top-left:after {\n    margin-left: -5px;\n    border-top-color: #000; }\n\nhtml,\nbody {\n  position: relative;\n  display: block;\n  margin: 0;\n  padding: 0;\n  background-color: #F0F0F0;\n  overflow-x: hidden; }\n\nbody {\n  -webkit-overflow-scrolling: touch;\n  -webkit-font-smoothing: antialiased; }\n\nbody.no-scroll {\n  overflow: hidden; }\n\nbody,\ninput,\nselect,\ntextarea,\nbutton {\n  font-family: 'PingFang SC', 'HanHei SC', 'Microsoft YaHei', 'Helvetica Neue', 'Helvetica', 'Arial', 'sans-serif'; }\n\ninput,\nbutton,\nselect,\ntextarea,\nimg {\n  outline: none;\n  resize: none; }\n\ntextarea,\ninput[type=\"text\"],\ninput[type=\"password\"],\ninput[type=\"submit\"],\ninput[type=\"button\"] {\n  -webkit-appearance: none; }\n\ninput:-webkit-autofill {\n  -webkit-box-shadow: 0 0 0 1000px white inset; }\n\n* {\n  box-sizing: border-box; }\n\n.page {\n  position: relative;\n  /* ===== Prevent parent margin collapse ===== */\n  padding-top: 0.1px; }\n\n.container {\n  position: relative;\n  margin: 0 auto; }\n\n.block {\n  min-height: 720px;\n  box-shadow: 0 0 1px 1px rgba(0, 0, 0, 0.03);\n  background-color: #ffffff; }\n  .block.single-page {\n    padding: 0 40px 60px; }\n  .block .block-title {\n    height: 54px;\n    line-height: 54px;\n    border-bottom: 1px solid #e8eaea;\n    font-size: 18px;\n    color: #222222;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap; }\n    .block .block-title .sup {\n      font-size: 14px;\n      color: #999999; }\n\n.col-8 {\n  float: left;\n  width: 67.6%; }\n\n.col-4 {\n  float: left;\n  width: 32.4%; }\n\n.col-9 {\n  float: left;\n  width: 74%; }\n\n.col-3 {\n  float: left;\n  width: 26%; }\n\n.clearfix {\n  zoom: 1; }\n  .clearfix:after {\n    clear: both;\n    content: '.';\n    display: block;\n    width: 0;\n    height: 0;\n    visibility: hidden; }\n\n.pull-left {\n  float: left; }\n\n.pull-right {\n  float: right; }\n\n/* ===== QiYu customer service button ===== */\n#YSF-BTN-HOLDER {\n  width: 70px !important;\n  height: 70px !important;\n  border-radius: 35px !important;\n  right: 100px !important;\n  bottom: 60px !important;\n  z-index: 2 !important;\n  overflow: hidden !important; }\n  @media only screen and (max-width: 767px) {\n    #YSF-BTN-HOLDER {\n      right: 0 !important;\n      bottom: 7% !important; } }\n\n#YSF-CUSTOM-ENTRY-0 {\n  top: 0 !important;\n  bottom: 0 !important;\n  width: 70px !important;\n  height: 70px !important; }\n  #YSF-CUSTOM-ENTRY-0 img {\n    display: block;\n    width: 100%;\n    height: 100%; }\n\n/* Small Devices, Tablets */\n@media only screen and (max-width: 767px) {\n  body.no-scroll {\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%; }\n  .block {\n    min-height: 200px; }\n    .block.single-page {\n      padding: 0 12px 40px; }\n    .block .block-title {\n      height: 44px;\n      line-height: 44px;\n      font-size: 18px; }\n      .block .block-title .sup {\n        display: none; }\n  #fbplus-wrap {\n    position: fixed !important;\n    left: 50% !important;\n    top: 50% !important;\n    transform: translate3d(-50%, -50%, 0) !important; } }\n", ""]);

// exports


/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _restangular = __webpack_require__(1232);

var _restangular2 = _interopRequireDefault(_restangular);

var _app = __webpack_require__(343);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var apiModule = _angular2.default.module("app.api", [_restangular2.default, _app2.default]).run(["Restangular", "$state", "AppConfig", "$timeout", function (Restangular, $state, AppConfig, $timeout) {
  "ngInject";

  Restangular.setBaseUrl(AppConfig.server_url);
  Restangular.setDefaultHttpFields({ withCredentials: true });
  Restangular.setDefaultHeaders({ locale: window.localStorage.yuanben_lang });
  Restangular.addResponseInterceptor(function (data, operation, what, url, response, defered) {
    if (data.hasOwnProperty("block_source")) {
      if (data.block_source === 0) {
        data.chain_server_url = AppConfig.chain_server_url + "/block/" + data.block_hash;
      } else {
        data.chain_server_url = AppConfig.newchain_server_url + "/original/" + data.yuanben_id;
      }
    }
    return data;
  });

  Restangular.setErrorInterceptor(function (response, deferred, responseHandler) {
    if (response.status === 401) {
      $timeout(function () {
        location.href = "/login";
      }, 0);

      return false;
    }
  });
}]).factory("AuthorAPI", ["Restangular", function (Restangular) {
  "ngInject";

  return Restangular.service("authors");
}]).factory("ArticleAPI", ["Restangular", function (Restangular) {
  "ngInject";

  return Restangular.service("articles");
}]).factory("UserAPI", ["Restangular", function (Restangular) {
  "ngInject";

  return Restangular.service("user");
}]).factory("AnnouncementAPI", ["Restangular", function (Restangular) {
  "ngInject";

  return Restangular.service("announcements");
}]).factory("NewAPI", ["Restangular", function (Restangular) {
  "ngInject";

  return Restangular.service("news");
}]).factory("AnnouncementTagAPI", ["Restangular", function (Restangular) {
  "ngInject";

  return Restangular.service("news");
}]).factory("QueryAPI", ["Restangular", function (Restangular) {
  "ngInject";

  return Restangular.service("query");
}]).factory("OrderAPI", ["Restangular", function (Restangular) {
  "ngInject";

  return Restangular.service("orders");
}]).factory("OrderEmailAPI", ["Restangular", function (Restangular) {
  "ngInject";

  return Restangular.service("order/email");
}]).factory("ReceiptAPI", ["Restangular", function (Restangular) {
  "ngInject";

  return Restangular.service("receipts");
}]).factory("ImageAPI", ["Restangular", function (Restangular) {
  "ngInject";

  return Restangular.service("images");
}]).factory("InfringementAPI", ["Restangular", function (Restangular) {
  "ngInject";

  return Restangular.service("infringements");
}]).factory("EvidenceAPI", ["Restangular", function (Restangular) {
  "ngInject";

  return Restangular.service("evidences");
}]).factory("ForensicsFeesAPI", ["Restangular", function (Restangular) {
  "ngInject";

  return Restangular.service("evidences/pay");
}]).factory("evidencesAgainAPI", ["Restangular", function (Restangular) {
  "ngInject";

  return Restangular.service("evidences/again");
}]).factory("ImportAPI", ["Restangular", function (Restangular) {
  "ngInject";

  return Restangular.service("import");
}]).factory("CollectionAPI", ["Restangular", function (Restangular) {
  "ngInject";

  return Restangular.service("resources/collections");
}]).factory("NotificationAPI", ["Restangular", function (Restangular) {
  "ngInject";

  return Restangular.service("user/notifications");
}]).factory("WXpayAPI", ["Restangular", function (Restangular) {
  "ngInject";

  return Restangular.service("media/weixin/oauth");
}]).factory("NoLoginPayAPI", ["Restangular", function (Restangular) {
  "ngInject";

  return Restangular.service("none/pay");
}]).factory("UserNotificationSignAPI", ["Restangular", function (Restangular) {
  "ngInject";

  return Restangular.service("user/authorization/sign");
}]).factory("PluginVersionAPI", ["Restangular", function (Restangular) {
  "ngInject";

  return Restangular.service("plugin/latest/version");
}]).factory("PartnerAPI", ["Restangular", function (Restangular) {
  "ngInject";

  return Restangular.service("partner/application");
}]).factory("applicationAPI", ["Restangular", function (Restangular) {
  "ngInject";

  return Restangular.service("intelligence/application");
}]).factory("RechargeAPI", ["Restangular", function (Restangular) {
  "ngInject";

  return Restangular.service("payment/account/recharge");
}]).factory("manageListAPI", ["Restangular", function (Restangular) {
  "ngInject";

  return Restangular.service("/group");
}]).factory("reEvidencesReportAPI", ["Restangular", function (Restangular) {
  "ngInject";

  return Restangular.service("/evidences/report");
}]).factory("SimilarityCompareAPI", ["Restangular", function (Restangular) {
  "ngInject";

  return Restangular.service("text/similarity/compare");
}]).factory("downloadEvidencePackageApi", ["Restangular", function (Restangular) {
  "ngInject";

  return Restangular.service("articles");
}]).factory("ImgDetailRecommendListApi", ["Restangular", function (Restangular) {
  "ngInject";

  return Restangular.service("query/image/recommend");
}]).name;

exports.default = apiModule;

/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__(342);

__webpack_require__(1233);

/**
 * Created by lency on 9/19/16.
 */
exports.default = 'restangular';

/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Restful Resources service for AngularJS apps
 * @version v1.6.1 - 2017-01-06 * @link https://github.com/mgonto/restangular
 * @author Martin Gontovnikas <martin@gon.to>
 * @license MIT License, http://www.opensource.org/licenses/MIT
 */(function(root, factory) {
  /* global define, require */
  // https://github.com/umdjs/umd/blob/master/templates/returnExports.js
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(342), __webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof module === 'object' && module.exports) {
    module.exports = factory(require('lodash'), require('angular'));
  } else {
    // No global export, Restangular will register itself as Angular.js module
    factory(root._, root.angular);
  }
}(this, function(_, angular) {

  var restangular = angular.module('restangular', []);

  restangular.provider('Restangular', function() {
    // Configuration
    var Configurer = {};
    Configurer.init = function(object, config) {
      object.configuration = config;

      /**
       * Those are HTTP safe methods for which there is no need to pass any data with the request.
       */
      var safeMethods = ['get', 'head', 'options', 'trace', 'getlist'];
      config.isSafe = function(operation) {
        return _.includes(safeMethods, operation.toLowerCase());
      };

      var absolutePattern = /^https?:\/\//i;
      config.isAbsoluteUrl = function(string) {
        return _.isUndefined(config.absoluteUrl) || _.isNull(config.absoluteUrl) ?
          string && absolutePattern.test(string) :
          config.absoluteUrl;
      };

      config.absoluteUrl = _.isUndefined(config.absoluteUrl) ? true : config.absoluteUrl;
      object.setSelfLinkAbsoluteUrl = function(value) {
        config.absoluteUrl = value;
      };
      /**
       * This is the BaseURL to be used with Restangular
       */
      config.baseUrl = _.isUndefined(config.baseUrl) ? '' : config.baseUrl;
      object.setBaseUrl = function(newBaseUrl) {
        config.baseUrl = /\/$/.test(newBaseUrl) ?
          newBaseUrl.substring(0, newBaseUrl.length - 1) :
          newBaseUrl;
        return this;
      };

      /**
       * Sets the extra fields to keep from the parents
       */
      config.extraFields = config.extraFields || [];
      object.setExtraFields = function(newExtraFields) {
        config.extraFields = newExtraFields;
        return this;
      };

      /**
       * Some default $http parameter to be used in EVERY call
       **/
      config.defaultHttpFields = config.defaultHttpFields || {};
      object.setDefaultHttpFields = function(values) {
        config.defaultHttpFields = values;
        return this;
      };

      /**
       * Always return plain data, no restangularized object
       **/
      config.plainByDefault = config.plainByDefault || false;
      object.setPlainByDefault = function(value) {
        config.plainByDefault = value === true ? true : false;
        return this;
      };

      config.withHttpValues = function(httpLocalConfig, obj) {
        return _.defaults(obj, httpLocalConfig, config.defaultHttpFields);
      };

      config.encodeIds = _.isUndefined(config.encodeIds) ? true : config.encodeIds;
      object.setEncodeIds = function(encode) {
        config.encodeIds = encode;
      };

      config.defaultRequestParams = config.defaultRequestParams || {
        get: {},
        post: {},
        put: {},
        remove: {},
        common: {}
      };

      object.setDefaultRequestParams = function(param1, param2) {
        var methods = [],
          params = param2 || param1;
        if (!_.isUndefined(param2)) {
          if (_.isArray(param1)) {
            methods = param1;
          } else {
            methods.push(param1);
          }
        } else {
          methods.push('common');
        }

        _.each(methods, function(method) {
          config.defaultRequestParams[method] = params;
        });
        return this;
      };

      object.requestParams = config.defaultRequestParams;

      config.defaultHeaders = config.defaultHeaders || {};
      object.setDefaultHeaders = function(headers) {
        config.defaultHeaders = headers;
        object.defaultHeaders = config.defaultHeaders;
        return this;
      };

      object.defaultHeaders = config.defaultHeaders;

      /**
       * Method overriders will set which methods are sent via POST with an X-HTTP-Method-Override
       **/
      config.methodOverriders = config.methodOverriders || [];
      object.setMethodOverriders = function(values) {
        var overriders = _.extend([], values);
        if (config.isOverridenMethod('delete', overriders)) {
          overriders.push('remove');
        }
        config.methodOverriders = overriders;
        return this;
      };

      config.jsonp = _.isUndefined(config.jsonp) ? false : config.jsonp;
      object.setJsonp = function(active) {
        config.jsonp = active;
      };

      config.isOverridenMethod = function(method, values) {
        var search = values || config.methodOverriders;
        return !_.isUndefined(_.find(search, function(one) {
          return one.toLowerCase() === method.toLowerCase();
        }));
      };

      /**
       * Sets the URL creator type. For now, only Path is created. In the future we'll have queryParams
       **/
      config.urlCreator = config.urlCreator || 'path';
      object.setUrlCreator = function(name) {
        if (!_.has(config.urlCreatorFactory, name)) {
          throw new Error('URL Path selected isn\'t valid');
        }

        config.urlCreator = name;
        return this;
      };

      /**
       * You can set the restangular fields here. The 3 required fields for Restangular are:
       *
       * id: Id of the element
       * route: name of the route of this element
       * parentResource: the reference to the parent resource
       *
       *  All of this fields except for id, are handled (and created) by Restangular. By default,
       *  the field values will be id, route and parentResource respectively
       */
      config.restangularFields = config.restangularFields || {
        id: 'id',
        route: 'route',
        parentResource: 'parentResource',
        restangularCollection: 'restangularCollection',
        cannonicalId: '__cannonicalId',
        etag: 'restangularEtag',
        selfLink: 'href',
        get: 'get',
        getList: 'getList',
        put: 'put',
        post: 'post',
        remove: 'remove',
        head: 'head',
        trace: 'trace',
        options: 'options',
        patch: 'patch',
        getRestangularUrl: 'getRestangularUrl',
        getRequestedUrl: 'getRequestedUrl',
        putElement: 'putElement',
        addRestangularMethod: 'addRestangularMethod',
        getParentList: 'getParentList',
        clone: 'clone',
        ids: 'ids',
        httpConfig: '_$httpConfig',
        reqParams: 'reqParams',
        one: 'one',
        all: 'all',
        several: 'several',
        oneUrl: 'oneUrl',
        allUrl: 'allUrl',
        customPUT: 'customPUT',
        customPATCH: 'customPATCH',
        customPOST: 'customPOST',
        customDELETE: 'customDELETE',
        customGET: 'customGET',
        customGETLIST: 'customGETLIST',
        customOperation: 'customOperation',
        doPUT: 'doPUT',
        doPATCH: 'doPATCH',
        doPOST: 'doPOST',
        doDELETE: 'doDELETE',
        doGET: 'doGET',
        doGETLIST: 'doGETLIST',
        fromServer: 'fromServer',
        withConfig: 'withConfig',
        withHttpConfig: 'withHttpConfig',
        singleOne: 'singleOne',
        plain: 'plain',
        save: 'save',
        restangularized: 'restangularized'
      };
      object.setRestangularFields = function(resFields) {
        config.restangularFields =
          _.extend(config.restangularFields, resFields);
        return this;
      };

      config.isRestangularized = function(obj) {
        return !!obj[config.restangularFields.restangularized];
      };

      config.setFieldToElem = function(field, elem, value) {
        var properties = field.split('.');
        var idValue = elem;
        _.each(_.initial(properties), function(prop) {
          idValue[prop] = {};
          idValue = idValue[prop];
        });
        idValue[_.last(properties)] = value;
        return this;
      };

      config.getFieldFromElem = function(field, elem) {
        var properties = field.split('.');
        var idValue = elem;
        _.each(properties, function(prop) {
          if (idValue) {
            idValue = idValue[prop];
          }
        });
        return angular.copy(idValue);
      };

      config.setIdToElem = function(elem, id /*, route */ ) {
        config.setFieldToElem(config.restangularFields.id, elem, id);
        return this;
      };

      config.getIdFromElem = function(elem) {
        return config.getFieldFromElem(config.restangularFields.id, elem);
      };

      config.isValidId = function(elemId) {
        return '' !== elemId && !_.isUndefined(elemId) && !_.isNull(elemId);
      };

      config.setUrlToElem = function(elem, url /*, route */ ) {
        config.setFieldToElem(config.restangularFields.selfLink, elem, url);
        return this;
      };

      config.getUrlFromElem = function(elem) {
        return config.getFieldFromElem(config.restangularFields.selfLink, elem);
      };

      config.useCannonicalId = _.isUndefined(config.useCannonicalId) ? false : config.useCannonicalId;
      object.setUseCannonicalId = function(value) {
        config.useCannonicalId = value;
        return this;
      };

      config.getCannonicalIdFromElem = function(elem) {
        var cannonicalId = elem[config.restangularFields.cannonicalId];
        var actualId = config.isValidId(cannonicalId) ? cannonicalId : config.getIdFromElem(elem);
        return actualId;
      };

      /**
       * Sets the Response parser. This is used in case your response isn't directly the data.
       * For example if you have a response like {meta: {'meta'}, data: {name: 'Gonto'}}
       * you can extract this data which is the one that needs wrapping
       *
       * The ResponseExtractor is a function that receives the response and the method executed.
       */

      config.responseInterceptors = config.responseInterceptors || [];

      config.defaultResponseInterceptor = function(data /*, operation, what, url, response, deferred */ ) {
        return data;
      };

      config.responseExtractor = function(data, operation, what, url, response, deferred) {
        var interceptors = angular.copy(config.responseInterceptors);
        interceptors.push(config.defaultResponseInterceptor);
        var theData = data;
        _.each(interceptors, function(interceptor) {
          theData = interceptor(theData, operation,
            what, url, response, deferred);
        });
        return theData;
      };

      object.addResponseInterceptor = function(extractor) {
        config.responseInterceptors.push(extractor);
        return this;
      };

      config.errorInterceptors = config.errorInterceptors || [];
      object.addErrorInterceptor = function(interceptor) {
        config.errorInterceptors.push(interceptor);
        return this;
      };

      object.setResponseInterceptor = object.addResponseInterceptor;
      object.setResponseExtractor = object.addResponseInterceptor;
      object.setErrorInterceptor = object.addErrorInterceptor;

      /**
       * Response interceptor is called just before resolving promises.
       */


      /**
       * Request interceptor is called before sending an object to the server.
       */
      config.requestInterceptors = config.requestInterceptors || [];

      config.defaultInterceptor = function(element, operation, path, url, headers, params, httpConfig) {
        return {
          element: element,
          headers: headers,
          params: params,
          httpConfig: httpConfig
        };
      };

      config.fullRequestInterceptor = function(element, operation, path, url, headers, params, httpConfig) {
        var interceptors = angular.copy(config.requestInterceptors);
        var defaultRequest = config.defaultInterceptor(element, operation, path, url, headers, params, httpConfig);
        return _.reduce(interceptors, function(request, interceptor) {
          return _.extend(request, interceptor(request.element, operation,
            path, url, request.headers, request.params, request.httpConfig));
        }, defaultRequest);
      };

      object.addRequestInterceptor = function(interceptor) {
        config.requestInterceptors.push(function(elem, operation, path, url, headers, params, httpConfig) {
          return {
            headers: headers,
            params: params,
            element: interceptor(elem, operation, path, url),
            httpConfig: httpConfig
          };
        });
        return this;
      };

      object.setRequestInterceptor = object.addRequestInterceptor;

      object.addFullRequestInterceptor = function(interceptor) {
        config.requestInterceptors.push(interceptor);
        return this;
      };

      object.setFullRequestInterceptor = object.addFullRequestInterceptor;

      config.onBeforeElemRestangularized = config.onBeforeElemRestangularized || function(elem) {
        return elem;
      };
      object.setOnBeforeElemRestangularized = function(post) {
        config.onBeforeElemRestangularized = post;
        return this;
      };

      object.setRestangularizePromiseInterceptor = function(interceptor) {
        config.restangularizePromiseInterceptor = interceptor;
        return this;
      };

      /**
       * This method is called after an element has been "Restangularized".
       *
       * It receives the element, a boolean indicating if it's an element or a collection
       * and the name of the model
       *
       */
      config.onElemRestangularized = config.onElemRestangularized || function(elem) {
        return elem;
      };
      object.setOnElemRestangularized = function(post) {
        config.onElemRestangularized = post;
        return this;
      };

      config.shouldSaveParent = config.shouldSaveParent || function() {
        return true;
      };
      object.setParentless = function(values) {
        if (_.isArray(values)) {
          config.shouldSaveParent = function(route) {
            return !_.includes(values, route);
          };
        } else if (_.isBoolean(values)) {
          config.shouldSaveParent = function() {
            return !values;
          };
        }
        return this;
      };

      /**
       * This lets you set a suffix to every request.
       *
       * For example, if your api requires that for JSon requests you do /users/123.json, you can set that
       * in here.
       *
       *
       * By default, the suffix is null
       */
      config.suffix = _.isUndefined(config.suffix) ? null : config.suffix;
      object.setRequestSuffix = function(newSuffix) {
        config.suffix = newSuffix;
        return this;
      };

      /**
       * Add element transformers for certain routes.
       */
      config.transformers = config.transformers || {};
      config.matchTransformers = config.matchTransformers || [];
      object.addElementTransformer = function(type, secondArg, thirdArg) {
        var isCollection = null;
        var transformer = null;
        if (arguments.length === 2) {
          transformer = secondArg;
        } else {
          transformer = thirdArg;
          isCollection = secondArg;
        }

        var transformerFn = function(coll, elem) {
          if (_.isNull(isCollection) || (coll === isCollection)) {
            return transformer(elem);
          }
          return elem;
        };

        if (_.isRegExp(type)) {
          config.matchTransformers.push({
            regexp: type,
            transformer: transformerFn
          });
        } else {
          if (!config.transformers[type]) {
            config.transformers[type] = [];
          }
          config.transformers[type].push(transformerFn);
        }

        return object;
      };

      object.extendCollection = function(route, fn) {
        return object.addElementTransformer(route, true, fn);
      };

      object.extendModel = function(route, fn) {
        return object.addElementTransformer(route, false, fn);
      };

      config.transformElem = function(elem, isCollection, route, Restangular, force) {
        if (!force && !config.transformLocalElements && !elem[config.restangularFields.fromServer]) {
          return elem;
        }

        var changedElem = elem;

        var matchTransformers = config.matchTransformers;
        if (matchTransformers) {
          _.each(matchTransformers, function(transformer) {
            if (transformer.regexp.test(route)) {
              changedElem = transformer.transformer(isCollection, changedElem);
            }
          });
        }

        var typeTransformers = config.transformers[route];
        if (typeTransformers) {
          _.each(typeTransformers, function(transformer) {
            changedElem = transformer(isCollection, changedElem);
          });
        }
        return config.onElemRestangularized(changedElem, isCollection, route, Restangular);
      };

      config.transformLocalElements = _.isUndefined(config.transformLocalElements) ?
        false :
        config.transformLocalElements;

      object.setTransformOnlyServerElements = function(active) {
        config.transformLocalElements = !active;
      };

      config.fullResponse = _.isUndefined(config.fullResponse) ? false : config.fullResponse;
      object.setFullResponse = function(full) {
        config.fullResponse = full;
        return this;
      };


      //Internal values and functions
      config.urlCreatorFactory = {};

      /**
       * Base URL Creator. Base prototype for everything related to it
       **/

      var BaseCreator = function() {};

      BaseCreator.prototype.setConfig = function(config) {
        this.config = config;
        return this;
      };

      BaseCreator.prototype.parentsArray = function(current) {
        var parents = [];
        while (current) {
          parents.push(current);
          current = current[this.config.restangularFields.parentResource];
        }
        return parents.reverse();
      };

      function RestangularResource(config, $http, url, configurer) {
        var resource = {};
        _.each(_.keys(configurer), function(key) {
          var value = configurer[key];

          // Add default parameters
          value.params = _.extend({}, value.params, config.defaultRequestParams[value.method.toLowerCase()]);
          // We don't want the ? if no params are there
          if (_.isEmpty(value.params)) {
            delete value.params;
          }

          if (config.isSafe(value.method)) {

            resource[key] = function() {
              return $http(_.extend(value, {
                url: url
              }));
            };

          } else {

            resource[key] = function(data) {
              return $http(_.extend(value, {
                url: url,
                data: data
              }));
            };

          }
        });

        return resource;
      }

      BaseCreator.prototype.resource = function(current, $http, localHttpConfig, callHeaders, callParams, what, etag, operation) {

        var params = _.defaults(callParams || {}, this.config.defaultRequestParams.common);
        var headers = _.defaults(callHeaders || {}, this.config.defaultHeaders);

        if (etag) {
          if (!config.isSafe(operation)) {
            headers['If-Match'] = etag;
          } else {
            headers['If-None-Match'] = etag;
          }
        }

        var url = this.base(current);

        if (what || what === 0) {
          var add = '';
          if (!/\/$/.test(url)) {
            add += '/';
          }
          add += what;
          url += add;
        }

        if (this.config.suffix &&
          url.indexOf(this.config.suffix, url.length - this.config.suffix.length) === -1 &&
          !this.config.getUrlFromElem(current)) {
          url += this.config.suffix;
        }

        current[this.config.restangularFields.httpConfig] = undefined;

        return RestangularResource(this.config, $http, url, {
          getList: this.config.withHttpValues(localHttpConfig, {
            method: 'GET',
            params: params,
            headers: headers
          }),

          get: this.config.withHttpValues(localHttpConfig, {
            method: 'GET',
            params: params,
            headers: headers
          }),

          jsonp: this.config.withHttpValues(localHttpConfig, {
            method: 'jsonp',
            params: params,
            headers: headers
          }),

          put: this.config.withHttpValues(localHttpConfig, {
            method: 'PUT',
            params: params,
            headers: headers
          }),

          post: this.config.withHttpValues(localHttpConfig, {
            method: 'POST',
            params: params,
            headers: headers
          }),

          remove: this.config.withHttpValues(localHttpConfig, {
            method: 'DELETE',
            params: params,
            headers: headers
          }),

          head: this.config.withHttpValues(localHttpConfig, {
            method: 'HEAD',
            params: params,
            headers: headers
          }),

          trace: this.config.withHttpValues(localHttpConfig, {
            method: 'TRACE',
            params: params,
            headers: headers
          }),

          options: this.config.withHttpValues(localHttpConfig, {
            method: 'OPTIONS',
            params: params,
            headers: headers
          }),

          patch: this.config.withHttpValues(localHttpConfig, {
            method: 'PATCH',
            params: params,
            headers: headers
          })
        });
      };

      /**
       * This is the Path URL creator. It uses Path to show Hierarchy in the Rest API.
       * This means that if you have an Account that then has a set of Buildings, a URL to a building
       * would be /accounts/123/buildings/456
       **/
      var Path = function() {};

      Path.prototype = new BaseCreator();

      Path.prototype.normalizeUrl = function(url) {
        var parts = /((?:http[s]?:)?\/\/)?(.*)?/.exec(url);
        parts[2] = parts[2].replace(/[\\\/]+/g, '/');
        return (typeof parts[1] !== 'undefined') ? parts[1] + parts[2] : parts[2];
      };

      Path.prototype.base = function(current) {
        var __this = this;
        return _.reduce(this.parentsArray(current), function(acum, elem) {
          var elemUrl;
          var elemSelfLink = __this.config.getUrlFromElem(elem);
          if (elemSelfLink) {
            if (__this.config.isAbsoluteUrl(elemSelfLink)) {
              return elemSelfLink;
            } else {
              elemUrl = elemSelfLink;
            }
          } else {
            elemUrl = elem[__this.config.restangularFields.route];

            if (elem[__this.config.restangularFields.restangularCollection]) {
              var ids = elem[__this.config.restangularFields.ids];
              if (ids) {
                elemUrl += '/' + ids.join(',');
              }
            } else {
              var elemId;
              if (__this.config.useCannonicalId) {
                elemId = __this.config.getCannonicalIdFromElem(elem);
              } else {
                elemId = __this.config.getIdFromElem(elem);
              }

              if (config.isValidId(elemId) && !elem.singleOne) {
                elemUrl += '/' + (__this.config.encodeIds ? encodeURIComponent(elemId) : elemId);
              }
            }
          }
          acum = acum.replace(/\/$/, '') + '/' + elemUrl;
          return __this.normalizeUrl(acum);

        }, this.config.baseUrl);
      };



      Path.prototype.fetchUrl = function(current, what) {
        var baseUrl = this.base(current);
        if (what) {
          baseUrl += '/' + what;
        }
        return baseUrl;
      };

      Path.prototype.fetchRequestedUrl = function(current, what) {
        var url = this.fetchUrl(current, what);
        var params = current[config.restangularFields.reqParams];

        // From here on and until the end of fetchRequestedUrl,
        // the code has been kindly borrowed from angular.js
        // The reason for such code bloating is coherence:
        //   If the user were to use this for cache management, the
        //   serialization of parameters would need to be identical
        //   to the one done by angular for cache keys to match.
        function sortedKeys(obj) {
          var keys = [];
          for (var key in obj) {
            if (obj.hasOwnProperty(key)) {
              keys.push(key);
            }
          }
          return keys.sort();
        }

        function forEachSorted(obj, iterator, context) {
          var keys = sortedKeys(obj);
          for (var i = 0; i < keys.length; i++) {
            iterator.call(context, obj[keys[i]], keys[i]);
          }
          return keys;
        }

        function encodeUriQuery(val, pctEncodeSpaces) {
          return encodeURIComponent(val).
          replace(/%40/gi, '@').
          replace(/%3A/gi, ':').
          replace(/%24/g, '$').
          replace(/%2C/gi, ',').
          replace(/%20/g, (pctEncodeSpaces ? '%20' : '+'));
        }

        if (!params) {
          return url + (this.config.suffix || '');
        }

        var parts = [];
        forEachSorted(params, function(value, key) {
          if (value === null || value === undefined) {
            return;
          }
          if (!angular.isArray(value)) {
            value = [value];
          }

          angular.forEach(value, function(v) {
            if (angular.isObject(v)) {
              v = angular.toJson(v);
            }
            parts.push(encodeUriQuery(key) + '=' + encodeUriQuery(v));
          });
        });

        return url + (this.config.suffix || '') + ((url.indexOf('?') === -1) ? '?' : '&') + parts.join('&');
      };

      config.urlCreatorFactory.path = Path;
    };

    var globalConfiguration = {};

    Configurer.init(this, globalConfiguration);



    this.$get = ['$http', '$q', function($http, $q) {

      function createServiceForConfiguration(config) {
        var service = {};

        var urlHandler = new config.urlCreatorFactory[config.urlCreator]();
        urlHandler.setConfig(config);

        function restangularizeBase(parent, elem, route, reqParams, fromServer) {
          elem[config.restangularFields.route] = route;
          elem[config.restangularFields.getRestangularUrl] = _.bind(urlHandler.fetchUrl, urlHandler, elem);
          elem[config.restangularFields.getRequestedUrl] = _.bind(urlHandler.fetchRequestedUrl, urlHandler, elem);
          elem[config.restangularFields.addRestangularMethod] = _.bind(addRestangularMethodFunction, elem);
          elem[config.restangularFields.clone] = _.bind(copyRestangularizedElement, elem, elem);
          elem[config.restangularFields.reqParams] = _.isEmpty(reqParams) ? null : reqParams;
          elem[config.restangularFields.withHttpConfig] = _.bind(withHttpConfig, elem);
          elem[config.restangularFields.plain] = _.bind(stripRestangular, elem, elem);

          // Tag element as restangularized
          elem[config.restangularFields.restangularized] = true;

          // RequestLess connection
          elem[config.restangularFields.one] = _.bind(one, elem, elem);
          elem[config.restangularFields.all] = _.bind(all, elem, elem);
          elem[config.restangularFields.several] = _.bind(several, elem, elem);
          elem[config.restangularFields.oneUrl] = _.bind(oneUrl, elem, elem);
          elem[config.restangularFields.allUrl] = _.bind(allUrl, elem, elem);

          elem[config.restangularFields.fromServer] = !!fromServer;

          if (parent && config.shouldSaveParent(route)) {
            var parentId = config.getIdFromElem(parent);
            var parentUrl = config.getUrlFromElem(parent);

            var restangularFieldsForParent = _.union(
              _.values(_.pick(config.restangularFields, ['route', 'singleOne', 'parentResource'])),
              config.extraFields
            );
            var parentResource = _.pick(parent, restangularFieldsForParent);

            if (config.isValidId(parentId)) {
              config.setIdToElem(parentResource, parentId, route);
            }
            if (config.isValidId(parentUrl)) {
              config.setUrlToElem(parentResource, parentUrl, route);
            }

            elem[config.restangularFields.parentResource] = parentResource;
          } else {
            elem[config.restangularFields.parentResource] = null;
          }
          return elem;
        }

        function one(parent, route, id, singleOne) {
          var error;
          if (_.isNumber(route) || _.isNumber(parent)) {
            error = 'You\'re creating a Restangular entity with the number ';
            error += 'instead of the route or the parent. For example, you can\'t call .one(12).';
            throw new Error(error);
          }
          if (_.isUndefined(route)) {
            error = 'You\'re creating a Restangular entity either without the path. ';
            error += 'For example you can\'t call .one(). Please check if your arguments are valid.';
            throw new Error(error);
          }
          var elem = {};
          config.setIdToElem(elem, id, route);
          config.setFieldToElem(config.restangularFields.singleOne, elem, singleOne);
          return restangularizeElem(parent, elem, route, false);
        }


        function all(parent, route) {
          return restangularizeCollection(parent, [], route, false);
        }

        function several(parent, route /*, ids */ ) {
          var collection = [];
          collection[config.restangularFields.ids] = Array.prototype.splice.call(arguments, 2);
          return restangularizeCollection(parent, collection, route, false);
        }

        function oneUrl(parent, route, url) {
          if (!route) {
            throw new Error('Route is mandatory when creating new Restangular objects.');
          }
          var elem = {};
          config.setUrlToElem(elem, url, route);
          return restangularizeElem(parent, elem, route, false);
        }


        function allUrl(parent, route, url) {
          if (!route) {
            throw new Error('Route is mandatory when creating new Restangular objects.');
          }
          var elem = {};
          config.setUrlToElem(elem, url, route);
          return restangularizeCollection(parent, elem, route, false);
        }
        // Promises
        function restangularizePromise(promise, isCollection, valueToFill) {
          promise.call = _.bind(promiseCall, promise);
          promise.get = _.bind(promiseGet, promise);
          promise[config.restangularFields.restangularCollection] = isCollection;
          if (isCollection) {
            promise.push = _.bind(promiseCall, promise, 'push');
          }
          promise.$object = valueToFill;
          if (config.restangularizePromiseInterceptor) {
            config.restangularizePromiseInterceptor(promise);
          }
          return promise;
        }

        function promiseCall(method) {
          var deferred = $q.defer();
          var callArgs = arguments;
          var filledValue = {};
          this.then(function(val) {
            var params = Array.prototype.slice.call(callArgs, 1);
            var func = val[method];
            func.apply(val, params);
            filledValue = val;
            deferred.resolve(val);
          });
          return restangularizePromise(deferred.promise, this[config.restangularFields.restangularCollection], filledValue);
        }

        function promiseGet(what) {
          var deferred = $q.defer();
          var filledValue = {};
          this.then(function(val) {
            filledValue = val[what];
            deferred.resolve(filledValue);
          });
          return restangularizePromise(deferred.promise, this[config.restangularFields.restangularCollection], filledValue);
        }

        function resolvePromise(deferred, response, data, filledValue) {
          _.extend(filledValue, data);

          // Trigger the full response interceptor.
          if (config.fullResponse) {
            return deferred.resolve(_.extend(response, {
              data: data
            }));
          } else {
            deferred.resolve(data);
          }
        }


        // Elements
        function stripRestangular(elem) {
          if (_.isArray(elem)) {
            var array = [];
            _.each(elem, function(value) {
              array.push(config.isRestangularized(value) ? stripRestangular(value) : value);
            });
            return array;
          } else {
            return _.omit(elem, _.values(_.omit(config.restangularFields, 'id')));
          }
        }

        function addCustomOperation(elem) {
          elem[config.restangularFields.customOperation] = _.bind(customFunction, elem);
          var requestMethods = {
            get: customFunction,
            delete: customFunction
          };
          _.each(['put', 'patch', 'post'], function(name) {
            requestMethods[name] = function(operation, elem, path, params, headers) {
              return _.bind(customFunction, this)(operation, path, params, headers, elem);
            };
          });
          _.each(requestMethods, function(requestFunc, name) {
            var callOperation = name === 'delete' ? 'remove' : name;
            _.each(['do', 'custom'], function(alias) {
              elem[alias + name.toUpperCase()] = _.bind(requestFunc, elem, callOperation);
            });
          });
          elem[config.restangularFields.customGETLIST] = _.bind(fetchFunction, elem);
          elem[config.restangularFields.doGETLIST] = elem[config.restangularFields.customGETLIST];
        }

        function copyRestangularizedElement(element) {
          var copiedElement = angular.copy(element);

          // check if we're dealing with a collection (i.e. an array)
          // and restangularize the element using the proper restangularizer,
          // element / collection
          if (_.isArray(element)) {
            return restangularizeCollection(
              element[config.restangularFields.parentResource],
              copiedElement,
              element[config.restangularFields.route],
              element[config.restangularFields.fromServer],
              element[config.restangularFields.reqParams]
            );
          }

          // not a collection, restangularize it as an element
          return restangularizeElem(
            element[config.restangularFields.parentResource],
            copiedElement,
            element[config.restangularFields.route],
            element[config.restangularFields.fromServer],
            element[config.restangularFields.restangularCollection],
            element[config.restangularFields.reqParams]
          );
        }

        function restangularizeElem(parent, element, route, fromServer, collection, reqParams) {
          var elem = config.onBeforeElemRestangularized(element, false, route);

          var localElem = restangularizeBase(parent, elem, route, reqParams, fromServer);

          if (config.useCannonicalId) {
            localElem[config.restangularFields.cannonicalId] = config.getIdFromElem(localElem);
          }

          if (collection) {
            localElem[config.restangularFields.getParentList] = function() {
              return collection;
            };
          }

          localElem[config.restangularFields.restangularCollection] = false;
          localElem[config.restangularFields.get] = _.bind(getFunction, localElem);
          localElem[config.restangularFields.getList] = _.bind(fetchFunction, localElem);
          localElem[config.restangularFields.put] = _.bind(putFunction, localElem);
          localElem[config.restangularFields.post] = _.bind(postFunction, localElem);
          localElem[config.restangularFields.remove] = _.bind(deleteFunction, localElem);
          localElem[config.restangularFields.head] = _.bind(headFunction, localElem);
          localElem[config.restangularFields.trace] = _.bind(traceFunction, localElem);
          localElem[config.restangularFields.options] = _.bind(optionsFunction, localElem);
          localElem[config.restangularFields.patch] = _.bind(patchFunction, localElem);
          localElem[config.restangularFields.save] = _.bind(save, localElem);

          addCustomOperation(localElem);
          return config.transformElem(localElem, false, route, service, true);
        }

        function restangularizeCollection(parent, element, route, fromServer, reqParams) {
          var elem = config.onBeforeElemRestangularized(element, true, route);

          var localElem = restangularizeBase(parent, elem, route, reqParams, fromServer);
          localElem[config.restangularFields.restangularCollection] = true;
          localElem[config.restangularFields.post] = _.bind(postFunction, localElem, null);
          localElem[config.restangularFields.remove] = _.bind(deleteFunction, localElem);
          localElem[config.restangularFields.head] = _.bind(headFunction, localElem);
          localElem[config.restangularFields.trace] = _.bind(traceFunction, localElem);
          localElem[config.restangularFields.putElement] = _.bind(putElementFunction, localElem);
          localElem[config.restangularFields.options] = _.bind(optionsFunction, localElem);
          localElem[config.restangularFields.patch] = _.bind(patchFunction, localElem);
          localElem[config.restangularFields.get] = _.bind(getById, localElem);
          localElem[config.restangularFields.getList] = _.bind(fetchFunction, localElem, null);

          addCustomOperation(localElem);
          return config.transformElem(localElem, true, route, service, true);
        }

        function restangularizeCollectionAndElements(parent, element, route, fromServer) {
          var collection = restangularizeCollection(parent, element, route, fromServer);
          _.each(collection, function(elem) {
            if (elem) {
              restangularizeElem(parent, elem, route, fromServer);
            }
          });
          return collection;
        }

        function getById(id, reqParams, headers) {
          return this.customGET(id.toString(), reqParams, headers);
        }

        function putElementFunction(idx, params, headers) {
          var __this = this;
          var elemToPut = this[idx];
          var deferred = $q.defer();
          var filledArray = [];
          filledArray = config.transformElem(filledArray, true, elemToPut[config.restangularFields.route], service);
          elemToPut.put(params, headers).then(function(serverElem) {
            var newArray = copyRestangularizedElement(__this);
            newArray[idx] = serverElem;
            filledArray = newArray;
            deferred.resolve(newArray);
          }, function(response) {
            deferred.reject(response);
          });

          return restangularizePromise(deferred.promise, true, filledArray);
        }

        function parseResponse(resData, operation, route, fetchUrl, response, deferred) {
          var data = config.responseExtractor(resData, operation, route, fetchUrl, response, deferred);
          var etag = response.headers('ETag');
          if (data && etag) {
            data[config.restangularFields.etag] = etag;
          }
          return data;
        }


        function fetchFunction(what, reqParams, headers) {
          var __this = this;
          var deferred = $q.defer();
          var operation = 'getList';
          var url = urlHandler.fetchUrl(this, what);
          var whatFetched = what || __this[config.restangularFields.route];

          var request = config.fullRequestInterceptor(null, operation,
            whatFetched, url, headers || {}, reqParams || {}, this[config.restangularFields.httpConfig] || {});

          var filledArray = [];
          filledArray = config.transformElem(filledArray, true, whatFetched, service);

          var method = 'getList';

          if (config.jsonp) {
            method = 'jsonp';
          }

          var okCallback = function(response) {
            var resData = response.data;
            var fullParams = response.config.params;
            var data = parseResponse(resData, operation, whatFetched, url, response, deferred);

            // support empty response for getList() calls (some APIs respond with 204 and empty body)
            if (_.isUndefined(data) || '' === data) {
              data = [];
            }
            if (!_.isArray(data)) {
              throw new Error('Response for getList SHOULD be an array and not an object or something else');
            }

            if (true === config.plainByDefault) {
              return resolvePromise(deferred, response, data, filledArray);
            }

            var processedData = _.map(data, function(elem) {
              if (!__this[config.restangularFields.restangularCollection]) {
                return restangularizeElem(__this, elem, what, true, data);
              } else {
                return restangularizeElem(__this[config.restangularFields.parentResource],
                  elem, __this[config.restangularFields.route], true, data);
              }
            });

            processedData = _.extend(data, processedData);

            if (!__this[config.restangularFields.restangularCollection]) {
              resolvePromise(
                deferred,
                response,
                restangularizeCollection(
                  __this,
                  processedData,
                  what,
                  true,
                  fullParams
                ),
                filledArray
              );
            } else {
              resolvePromise(
                deferred,
                response,
                restangularizeCollection(
                  __this[config.restangularFields.parentResource],
                  processedData,
                  __this[config.restangularFields.route],
                  true,
                  fullParams
                ),
                filledArray
              );
            }
          };

          urlHandler.resource(this, $http, request.httpConfig, request.headers, request.params, what,
            this[config.restangularFields.etag], operation)[method]().then(okCallback, function error(response) {
            if (response.status === 304 && __this[config.restangularFields.restangularCollection]) {
              resolvePromise(deferred, response, __this, filledArray);
            } else if (_.every(config.errorInterceptors, function(cb) {
                return cb(response, deferred, okCallback) !== false;
              })) {
              // triggered if no callback returns false
              deferred.reject(response);
            }
          });

          return restangularizePromise(deferred.promise, true, filledArray);
        }

        function withHttpConfig(httpConfig) {
          this[config.restangularFields.httpConfig] = httpConfig;
          return this;
        }

        function save(params, headers) {
          if (this[config.restangularFields.fromServer]) {
            return this[config.restangularFields.put](params, headers);
          } else {
            return _.bind(elemFunction, this)('post', undefined, params, undefined, headers);
          }
        }

        function elemFunction(operation, what, params, obj, headers) {
          var __this = this;
          var deferred = $q.defer();
          var resParams = params || {};
          var route = what || this[config.restangularFields.route];
          var fetchUrl = urlHandler.fetchUrl(this, what);

          var callObj = obj || this;
          // fallback to etag on restangular object (since for custom methods we probably don't explicitly specify the etag field)
          var etag = callObj[config.restangularFields.etag] || (operation !== 'post' ? this[config.restangularFields.etag] : null);

          if (_.isObject(callObj) && config.isRestangularized(callObj)) {
            callObj = stripRestangular(callObj);
          }
          var request = config.fullRequestInterceptor(callObj, operation, route, fetchUrl,
            headers || {}, resParams || {}, this[config.restangularFields.httpConfig] || {});

          var filledObject = {};
          filledObject = config.transformElem(filledObject, false, route, service);

          var okCallback = function(response) {
            var resData = response.data;
            var fullParams = response.config.params;
            var elem = parseResponse(resData, operation, route, fetchUrl, response, deferred);

            // accept 0 as response
            if (elem !== null && elem !== undefined && elem !== '') {
              var data;

              if (true === config.plainByDefault) {
                return resolvePromise(deferred, response, elem, filledObject);
              }

              if (operation === 'post' && !__this[config.restangularFields.restangularCollection]) {
                data = restangularizeElem(
                  __this[config.restangularFields.parentResource],
                  elem,
                  route,
                  true,
                  null,
                  fullParams
                );
                resolvePromise(deferred, response, data, filledObject);
              } else {
                data = restangularizeElem(
                  __this[config.restangularFields.parentResource],
                  elem,
                  __this[config.restangularFields.route],
                  true,
                  null,
                  fullParams
                );

                data[config.restangularFields.singleOne] = __this[config.restangularFields.singleOne];
                resolvePromise(deferred, response, data, filledObject);
              }

            } else {
              resolvePromise(deferred, response, undefined, filledObject);
            }
          };

          var errorCallback = function(response) {
            if (response.status === 304 && config.isSafe(operation)) {
              resolvePromise(deferred, response, __this, filledObject);
            } else if (_.every(config.errorInterceptors, function(cb) {
                return cb(response, deferred, okCallback) !== false;
              })) {
              // triggered if no callback returns false
              deferred.reject(response);
            }
          };
          // Overriding HTTP Method
          var callOperation = operation;
          var callHeaders = _.extend({}, request.headers);
          var isOverrideOperation = config.isOverridenMethod(operation);
          if (isOverrideOperation) {
            callOperation = 'post';
            callHeaders = _.extend(callHeaders, {
              'X-HTTP-Method-Override': operation === 'remove' ? 'DELETE' : operation.toUpperCase()
            });
          } else if (config.jsonp && callOperation === 'get') {
            callOperation = 'jsonp';
          }

          if (config.isSafe(operation)) {
            if (isOverrideOperation) {
              urlHandler.resource(this, $http, request.httpConfig, callHeaders, request.params,
                what, etag, callOperation)[callOperation]({}).then(okCallback, errorCallback);
            } else {
              urlHandler.resource(this, $http, request.httpConfig, callHeaders, request.params,
                what, etag, callOperation)[callOperation]().then(okCallback, errorCallback);
            }
          } else {
            urlHandler.resource(this, $http, request.httpConfig, callHeaders, request.params,
              what, etag, callOperation)[callOperation](request.element).then(okCallback, errorCallback);
          }

          return restangularizePromise(deferred.promise, false, filledObject);
        }

        function getFunction(params, headers) {
          return _.bind(elemFunction, this)('get', undefined, params, undefined, headers);
        }

        function deleteFunction(params, headers) {
          return _.bind(elemFunction, this)('remove', undefined, params, undefined, headers);
        }

        function putFunction(params, headers) {
          return _.bind(elemFunction, this)('put', undefined, params, undefined, headers);
        }

        function postFunction(what, elem, params, headers) {
          return _.bind(elemFunction, this)('post', what, params, elem, headers);
        }

        function headFunction(params, headers) {
          return _.bind(elemFunction, this)('head', undefined, params, undefined, headers);
        }

        function traceFunction(params, headers) {
          return _.bind(elemFunction, this)('trace', undefined, params, undefined, headers);
        }

        function optionsFunction(params, headers) {
          return _.bind(elemFunction, this)('options', undefined, params, undefined, headers);
        }

        function patchFunction(elem, params, headers) {
          return _.bind(elemFunction, this)('patch', undefined, params, elem, headers);
        }

        function customFunction(operation, path, params, headers, elem) {
          return _.bind(elemFunction, this)(operation, path, params, elem, headers);
        }

        function addRestangularMethodFunction(name, operation, path, defaultParams, defaultHeaders, defaultElem) {
          var bindedFunction;
          if (operation === 'getList') {
            bindedFunction = _.bind(fetchFunction, this, path);
          } else {
            bindedFunction = _.bind(customFunction, this, operation, path);
          }

          var createdFunction = function(params, headers, elem) {
            var callParams = _.defaults({
              params: params,
              headers: headers,
              elem: elem
            }, {
              params: defaultParams,
              headers: defaultHeaders,
              elem: defaultElem
            });
            return bindedFunction(callParams.params, callParams.headers, callParams.elem);
          };

          if (config.isSafe(operation)) {
            this[name] = createdFunction;
          } else {
            this[name] = function(elem, params, headers) {
              return createdFunction(params, headers, elem);
            };
          }
        }

        function withConfigurationFunction(configurer) {
          var newConfig = angular.copy(_.omit(config, 'configuration'));
          Configurer.init(newConfig, newConfig);
          configurer(newConfig);
          return createServiceForConfiguration(newConfig);
        }

        function toService(route, parent) {
          var knownCollectionMethods = _.values(config.restangularFields);
          var serv = {};
          var collection = (parent || service).all(route);
          serv.one = _.bind(one, (parent || service), parent, route);
          serv.post = _.bind(collection.post, collection);
          serv.getList = _.bind(collection.getList, collection);
          serv.withHttpConfig = _.bind(collection.withHttpConfig, collection);
          serv.get = _.bind(collection.get, collection);

          for (var prop in collection) {
            if (collection.hasOwnProperty(prop) && _.isFunction(collection[prop]) && !_.includes(knownCollectionMethods, prop)) {
              serv[prop] = _.bind(collection[prop], collection);
            }
          }

          return serv;
        }


        Configurer.init(service, config);

        service.copy = _.bind(copyRestangularizedElement, service);

        service.service = _.bind(toService, service);

        service.withConfig = _.bind(withConfigurationFunction, service);

        service.one = _.bind(one, service, null);

        service.all = _.bind(all, service, null);

        service.several = _.bind(several, service, null);

        service.oneUrl = _.bind(oneUrl, service, null);

        service.allUrl = _.bind(allUrl, service, null);

        service.stripRestangular = _.bind(stripRestangular, service);

        service.restangularizeElement = _.bind(restangularizeElem, service);

        service.restangularizeCollection = _.bind(restangularizeCollectionAndElements, service);

        return service;
      }

      return createServiceForConfiguration(globalConfiguration);
    }];
  });
  return restangular.name;
}));


/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * Created by ganlu on 20/10/2016.
 */
exports.default = {
    server_url: 'https://api.yuanben.io',
    aliyun_url: 'https://yb-img.oss-cn-shanghai.aliyuncs.com',
    chain_server_url: 'https://dna.yuanbenlian.com',
    newchain_server_url: 'https://yuanbenlian.com',
    weixin_link_suffix: '&devicetype=Windows-QQBrowser&version=61030004&pass_ticket=qMx7ntinAtmqhVn+C23mCuwc9ZRyUp20kIusGgbFLi0=&uin=MTc1MDA1NjU1&ascene=1',
    report_threshold_value: 4000,
    plugin_id: '6148d3bb-1178-457e-bc4b-bbaf789222db'
};

/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1236);
module.exports = 'angulartics';


/***/ }),
/* 1236 */
/***/ (function(module, exports) {

/**
 * @license Angulartics
 * (c) 2013 Luis Farzati http://luisfarzati.github.io/angulartics
 * License: MIT
 */
(function(angular, analytics) {
'use strict';

var angulartics = window.angulartics || (window.angulartics = {});
angulartics.waitForVendorCount = 0;
angulartics.waitForVendorApi = function (objectName, delay, containsField, registerFn, onTimeout) {
  if (!onTimeout) { angulartics.waitForVendorCount++; }
  if (!registerFn) { registerFn = containsField; containsField = undefined; }
  if (!Object.prototype.hasOwnProperty.call(window, objectName) || (containsField !== undefined && window[objectName][containsField] === undefined)) {
    setTimeout(function () { angulartics.waitForVendorApi(objectName, delay, containsField, registerFn, true); }, delay);
  }
  else {
    angulartics.waitForVendorCount--;
    registerFn(window[objectName]);
  }
};

/**
 * @ngdoc overview
 * @name angulartics
 */
angular.module('angulartics', [])
.provider('$analytics', $analytics)
.run(['$rootScope', '$window', '$analytics', '$injector', $analyticsRun])
.directive('analyticsOn', ['$analytics', analyticsOn])
.config(['$provide', exceptionTrack]);

function $analytics() {
  var settings = {
    pageTracking: {
      autoTrackFirstPage: true,
      autoTrackVirtualPages: true,
      trackRelativePath: false,
      autoBasePath: false,
      basePath: '',
      excludedRoutes: []
    },
    eventTracking: {},
    bufferFlushDelay: 1000, // Support only one configuration for buffer flush delay to simplify buffering
    trackExceptions: false,
    developerMode: false // Prevent sending data in local/development environment
  };

  // List of known handlers that plugins can register themselves for
  var knownHandlers = [
    'pageTrack',
    'eventTrack',
    'exceptionTrack',
    'transactionTrack',
    'setAlias',
    'setUsername',
    'setUserProperties',
    'setUserPropertiesOnce',
    'setSuperProperties',
    'setSuperPropertiesOnce',
    'incrementProperty',
    'userTimings'
  ];
  // Cache and handler properties will match values in 'knownHandlers' as the buffering functons are installed.
  var cache = {};
  var handlers = {};
  var handlerOptions = {};

  // General buffering handler
  function bufferedHandler(handlerName){
    return function(){
      if(angulartics.waitForVendorCount){
        if(!cache[handlerName]){ cache[handlerName] = []; }
        cache[handlerName].push(arguments);
      }
    };
  }

  // As handlers are installed by plugins, they get pushed into a list and invoked in order.
  function updateHandlers(handlerName, fn, options){
    if(!handlers[handlerName]){
      handlers[handlerName] = [];
    }
    handlers[handlerName].push(fn);
    handlerOptions[fn] = options;
    return function(){
      var handlerArgs = Array.prototype.slice.apply(arguments);
      return this.$inject(['$q', angular.bind(this, function($q) {
        return $q.all(handlers[handlerName].map(function(handlerFn) {
          var options = handlerOptions[handlerFn] || {};
          if (options.async) {
            var deferred = $q.defer();
            var currentArgs = angular.copy(handlerArgs);
            currentArgs.unshift(deferred.resolve);
            handlerFn.apply(this, currentArgs);
            return deferred.promise;
          } else{
            return $q.when(handlerFn.apply(this, handlerArgs));
          }
        }, this));
      })]);
    };
  }

  // The api (returned by this provider) gets populated with handlers below.
  var api = {
    settings: settings
  };

  // Will run setTimeout if delay is > 0
  // Runs immediately if no delay to make sure cache/buffer is flushed before anything else.
  // Plugins should take care to register handlers by order of precedence.
  function onTimeout(fn, delay){
    if(delay){
      setTimeout(fn, delay);
    } else {
      fn();
    }
  }

  var provider = {
    $get: ['$injector', function($injector) {
      return apiWithInjector($injector);
    }],
    api: api,
    settings: settings,
    virtualPageviews: function (value) { this.settings.pageTracking.autoTrackVirtualPages = value; },
    excludeRoutes: function(routes) { this.settings.pageTracking.excludedRoutes = routes; },
    firstPageview: function (value) { this.settings.pageTracking.autoTrackFirstPage = value; },
    withBase: function (value) {
      this.settings.pageTracking.basePath = (value) ? angular.element(document).find('base').attr('href') : '';
    },
    withAutoBase: function (value) { this.settings.pageTracking.autoBasePath = value; },
    trackExceptions: function (value) { this.settings.trackExceptions = value; },
    developerMode: function(value) { this.settings.developerMode = value; }
  };

  // General function to register plugin handlers. Flushes buffers immediately upon registration according to the specified delay.
  function register(handlerName, fn, options){
    // Do not add a handler if developerMode is true
    if (settings.developerMode) {
        return;
    }
    api[handlerName] = updateHandlers(handlerName, fn, options);
    var handlerSettings = settings[handlerName];
    var handlerDelay = (handlerSettings) ? handlerSettings.bufferFlushDelay : null;
    var delay = (handlerDelay !== null) ? handlerDelay : settings.bufferFlushDelay;
    angular.forEach(cache[handlerName], function (args, index) {
      onTimeout(function () { fn.apply(this, args); }, index * delay);
    });
  }

  function capitalize(input) {
      return input.replace(/^./, function (match) {
          return match.toUpperCase();
      });
  }

  //provide a method to inject services into handlers
  var apiWithInjector = function(injector) {
    return angular.extend(api, {
      '$inject': injector.invoke
    });
  };

  // Adds to the provider a 'register#{handlerName}' function that manages multiple plugins and buffer flushing.
  function installHandlerRegisterFunction(handlerName){
    var registerName = 'register'+capitalize(handlerName);
    provider[registerName] = function(fn, options){
      register(handlerName, fn, options);
    };
    api[handlerName] = updateHandlers(handlerName, bufferedHandler(handlerName));
  }

  // Set up register functions for each known handler
  angular.forEach(knownHandlers, installHandlerRegisterFunction);
  for (var key in provider) {
    this[key] = provider[key];
  }
}

function $analyticsRun($rootScope, $window, $analytics, $injector) {
  function matchesExcludedRoute(url) {
    for (var i = 0; i < $analytics.settings.pageTracking.excludedRoutes.length; i++) {
      var excludedRoute = $analytics.settings.pageTracking.excludedRoutes[i];
      if ((excludedRoute instanceof RegExp && excludedRoute.test(url)) || url.indexOf(excludedRoute) > -1) {
        return true;
      }
    }
    return false;
  }

  function pageTrack(url, $location) {
    if (!matchesExcludedRoute(url)) {
      $analytics.pageTrack(url, $location);
    }
  }

  if ($analytics.settings.pageTracking.autoTrackFirstPage) {
    $injector.invoke(['$location', function ($location) {
      /* Only track the 'first page' if there are no routes or states on the page */
      var noRoutesOrStates = true;
      if ($injector.has('$route')) {
         var $route = $injector.get('$route');
         if ($route) {
          for (var route in $route.routes) {
            noRoutesOrStates = false;
            break;
          }
         } else if ($route === null){
          noRoutesOrStates = false;
         }
      } else if ($injector.has('$state')) {
        var $state = $injector.get('$state');
        for (var state in $state.get()) {
          noRoutesOrStates = false;
          break;
        }
      }
      if (noRoutesOrStates) {
        if ($analytics.settings.pageTracking.autoBasePath) {
          $analytics.settings.pageTracking.basePath = $window.location.pathname;
        }
        if ($analytics.settings.pageTracking.trackRelativePath) {
          var url = $analytics.settings.pageTracking.basePath + $location.url();
          pageTrack(url, $location);
        } else {
          pageTrack($location.absUrl(), $location);
        }
      }
    }]);
  }

  if ($analytics.settings.pageTracking.autoTrackVirtualPages) {
    $injector.invoke(['$location', function ($location) {
      if ($analytics.settings.pageTracking.autoBasePath) {
        /* Add the full route to the base. */
        $analytics.settings.pageTracking.basePath = $window.location.pathname + "#";
      }
      var noRoutesOrStates = true;
      if ($injector.has('$route')) {
        var $route = $injector.get('$route');
        if ($route) {
          for (var route in $route.routes) {
            noRoutesOrStates = false;
            break;
          }
        } else if ($route === null){
          noRoutesOrStates = false;
        }
        $rootScope.$on('$routeChangeSuccess', function (event, current) {
          if (current && (current.$$route||current).redirectTo) return;
          var url = $analytics.settings.pageTracking.basePath + $location.url();
          pageTrack(url, $location);
        });
      }
      if ($injector.has('$state') && !$injector.has('$transitions')) {
        noRoutesOrStates = false;
        $rootScope.$on('$stateChangeSuccess', function (event, current) {
          var url = $analytics.settings.pageTracking.basePath + $location.url();
          pageTrack(url, $location);
        });
      }
      if ($injector.has('$state') && $injector.has('$transitions')) {
        noRoutesOrStates = false;
        $injector.invoke(['$transitions', function($transitions) {
          $transitions.onSuccess({}, function($transition$) {
            var transitionOptions = $transition$.options();

            // only track for transitions that would have triggered $stateChangeSuccess
            if (transitionOptions.notify) {
              var url = $analytics.settings.pageTracking.basePath + $location.url();
              pageTrack(url, $location);
            }
          });
        }]);
      }
      if (noRoutesOrStates) {
        $rootScope.$on('$locationChangeSuccess', function (event, current) {
          if (current && (current.$$route || current).redirectTo) return;
          if ($analytics.settings.pageTracking.trackRelativePath) {
            var url = $analytics.settings.pageTracking.basePath + $location.url();
            pageTrack(url, $location);
          } else {
            pageTrack($location.absUrl(), $location);
          }
        });
      }
    }]);
  }
  if ($analytics.settings.developerMode) {
    angular.forEach($analytics, function(attr, name) {
      if (typeof attr === 'function') {
        $analytics[name] = function(){};
      }
    });
  }
}

function analyticsOn($analytics) {
  return {
    restrict: 'A',
    link: function ($scope, $element, $attrs) {
      var eventType = $attrs.analyticsOn || 'click';
      var trackingData = {};

      angular.forEach($attrs.$attr, function(attr, name) {
        if (isProperty(name)) {
          trackingData[propertyName(name)] = $attrs[name];
          $attrs.$observe(name, function(value){
            trackingData[propertyName(name)] = value;
          });
        }
      });

      angular.element($element[0]).bind(eventType, function ($event) {
        var eventName = $attrs.analyticsEvent || inferEventName($element[0]);
        trackingData.eventType = $event.type;

        if($attrs.analyticsIf){
          if(! $scope.$eval($attrs.analyticsIf)){
            return; // Cancel this event if we don't pass the analytics-if condition
          }
        }
        // Allow components to pass through an expression that gets merged on to the event properties
        // eg. analytics-properites='myComponentScope.someConfigExpression.$analyticsProperties'
        if($attrs.analyticsProperties){
          angular.extend(trackingData, $scope.$eval($attrs.analyticsProperties));
        }
        $analytics.eventTrack(eventName, trackingData);
      });
    }
  };
}

function exceptionTrack($provide) {
  $provide.decorator('$exceptionHandler', ['$delegate', '$injector', function ($delegate, $injector) {
    return function (error, cause) {
      var result = $delegate(error, cause);
      var $analytics = $injector.get('$analytics');
      if ($analytics.settings.trackExceptions) {
        $analytics.exceptionTrack(error, cause);
      }
      return result;
    };
  }]);
}

function isCommand(element) {
  return ['a:','button:','button:button','button:submit','input:button','input:submit'].indexOf(
    element.tagName.toLowerCase()+':'+(element.type||'')) >= 0;
}

function inferEventType(element) {
  if (isCommand(element)) return 'click';
  return 'click';
}

function inferEventName(element) {
  if (isCommand(element)) return element.innerText || element.value;
  return element.id || element.name || element.tagName;
}

function isProperty(name) {
  return name.substr(0, 9) === 'analytics' && ['On', 'Event', 'If', 'Properties', 'EventType'].indexOf(name.substr(9)) === -1;
}

function propertyName(name) {
  var s = name.slice(9); // slice off the 'analytics' prefix
  if (typeof s !== 'undefined' && s!==null && s.length > 0) {
    return s.substring(0, 1).toLowerCase() + s.substring(1);
  }
  else {
    return s;
  }
}
})(angular);


/***/ }),
/* 1237 */
/***/ (function(module, exports) {

/**
 * @license Angulartics
 * (c) 2013 Luis Farzati http://luisfarzati.github.io/angulartics
 * Contributed by http://github.com/miller
 * License: MIT
 */

(function(angular) {
'use strict';

/**
 * @ngdoc overview
 * @name angulartics.baidu
 * Enables analytics support for baidu (http://tongji.baidu.com)
 */
angular.module('angulartics.baidu', ['angulartics'])
.config(['$analyticsProvider', function ($analyticsProvider) {

  if (window._hmt) {
	_hmt.push(['_setAutoPageview', false]);
  }

  $analyticsProvider.registerPageTrack(function (path) {
    if (window._hmt) {
      _hmt.push(['_trackPageview', path]);
    }
  });

  $analyticsProvider.registerEventTrack(function (action, properties) {
    // do nothing if there is no category or action (it's required by baidu)
    if (!window._hmt || !properties || !properties.category || !properties.action) {
		return;
	}

	var eventData = [ '_trackEvent', properties.category, properties.action ];

	if (properties.label) {
		eventData.push(properties.label);
	}

	if (properties.value) {
		eventData[4] = properties.value;
	}

	_hmt.push(eventData);
  });

}]);
})(angular);


/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1239)
module.exports = 'angulartics.google.analytics'


/***/ }),
/* 1239 */
/***/ (function(module, exports) {

(function(window, angular, undefined) {'use strict';

/**
 * @ngdoc overview
 * @name angulartics.google.analytics
 * Enables analytics support for Google Analytics (http://google.com/analytics)
 */
angular.module('angulartics.google.analytics', ['angulartics'])
.config(['$analyticsProvider', function ($analyticsProvider) {

  // GA already supports buffered invocations so we don't need
  // to wrap these inside angulartics.waitForVendorApi

  $analyticsProvider.settings.pageTracking.trackRelativePath = true;

  // Set the default settings for this module
  $analyticsProvider.settings.ga = {
    additionalAccountNames: undefined,
    disableEventTracking: null,
    disablePageTracking: null,
    userId: null
  };

  function dimensionsAndMetrics(properties) {
    if (window.ga) {
      // add custom dimensions and metrics
      var customData = {};
      for(var idx = 1; idx<=200;idx++) {
        if (typeof properties['dimension' + idx] !== 'undefined') {
          customData['dimension' + idx] = properties['dimension' + idx];
        }
        if (typeof properties['metric' +idx] !== 'undefined') {
          customData['metric' + idx] = properties['metric' + idx];
        }
      }
      return customData;
    }
  }

  $analyticsProvider.registerPageTrack(function (path) {
    
    // Do nothing if page tracking is disabled
    if ($analyticsProvider.settings.ga.disablePageTracking) return;

    if (window._gaq) {
      _gaq.push(['_trackPageview', path]);
      angular.forEach($analyticsProvider.settings.ga.additionalAccountNames, function (accountName){
        _gaq.push([accountName + '._trackPageview', path]);
      });
    }
    if (window.ga) {
      if ($analyticsProvider.settings.ga.userId) {
        ga('set', 'userId', $analyticsProvider.settings.ga.userId);
      }
      ga('send', 'pageview', path);
      angular.forEach($analyticsProvider.settings.ga.additionalAccountNames, function (accountName){
        ga(accountName +'.send', 'pageview', path);
      });
    }
  });

  /**
   * Track Event in GA
   * @name eventTrack
   *
   * @param {string} action Required 'action' (string) associated with the event
   * @param {object} properties Comprised of the mandatory field 'category' (string) and optional  fields 'label' (string), 'value' (integer) and 'nonInteraction' (boolean)
   *
   * @link https://developers.google.com/analytics/devguides/collection/gajs/eventTrackerGuide#SettingUpEventTracking
   *
   * @link https://developers.google.com/analytics/devguides/collection/analyticsjs/events
   */
  $analyticsProvider.registerEventTrack(eventTrack);

  function eventTrack (action, properties) {

    // Do nothing if event tracking is disabled
    if ($analyticsProvider.settings.ga.disableEventTracking) return;

    // Google Analytics requires an Event Category
    if (!properties || !properties.category) {
      properties = properties || {};
      properties.category = 'Event';
    }
    // GA requires that eventValue be an integer, see:
    // https://developers.google.com/analytics/devguides/collection/analyticsjs/field-reference#eventValue
    // https://github.com/luisfarzati/angulartics/issues/81
    if (properties.value) {
      var parsed = parseInt(properties.value, 10);
      properties.value = isNaN(parsed) ? 0 : parsed;
    }

    // GA requires that hitCallback be an function, see:
    // https://developers.google.com/analytics/devguides/collection/analyticsjs/sending-hits#hitcallback
    if (properties.hitCallback && (typeof properties.hitCallback !== 'function')) {
      properties.hitCallback = null;
    }

    // Making nonInteraction parameter more intuitive, includes backwards compatibilty
    // https://github.com/angulartics/angulartics-google-analytics/issues/49
    if (!properties.hasOwnProperty('nonInteraction')) {
      properties.nonInteraction = properties.noninteraction;
    }

    if (window.ga) {

      var eventOptions = {
        eventCategory: properties.category,
        eventAction: action,
        eventLabel: properties.label,
        eventValue: properties.value,
        nonInteraction: properties.nonInteraction,
        page: properties.page || window.location.hash.substring(1) || window.location.pathname,
        userId: $analyticsProvider.settings.ga.userId,
        hitCallback: properties.hitCallback
      };

      // Round up any dimensions and metrics for this hit
      var dimsAndMets = dimensionsAndMetrics(properties);
      angular.extend(eventOptions, dimsAndMets);

      // Add transport settings
      if($analyticsProvider.settings.ga.transport) {
        angular.extend(eventOptions, $analyticsProvider.settings.ga.transport);
      }

      ga('send', 'event', eventOptions);

      angular.forEach($analyticsProvider.settings.ga.additionalAccountNames, function (accountName){
        ga(accountName +'.send', 'event', eventOptions);
      });

    } else if (window._gaq) {
      _gaq.push(['_trackEvent', properties.category, action, properties.label, properties.value, properties.nonInteraction]);
    }

  }

  /**
   * Exception Track Event in GA
   * @name exceptionTrack
   * Sugar on top of the eventTrack method for easily handling errors
   *
   * @param {object} error An Error object to track: error.toString() used for event 'action', error.stack used for event 'label'.
   * @param {object} cause The cause of the error given from $exceptionHandler, not used.
   *
   * @link https://developers.google.com/analytics/devguides/collection/analyticsjs/events
   */
  $analyticsProvider.registerExceptionTrack(function (error, cause) {
    eventTrack(error.toString(), {
      category: 'Exceptions',
      label: error.stack,
      nonInteraction: true
    });
  });

  /**
   * Set Username
   * @name setUsername
   *
   * @param {string} userId Registers User ID of user for use with other hits
   *
   * @link https://developers.google.com/analytics/devguides/collection/analyticsjs/cookies-user-id#user_id
   */
  $analyticsProvider.registerSetUsername(function (userId) {
    $analyticsProvider.settings.ga.userId = userId;
  });

  /**
   * Set User Properties
   * @name setUserProperties
   *
   * @param {object} properties Sets all properties with dimensionN or metricN to their respective values
   *
   * @link https://developers.google.com/analytics/devguides/collection/analyticsjs/field-reference#customs
   */
  $analyticsProvider.registerSetUserProperties(function (properties) {
    if(properties) {
      // add custom dimensions and metrics to each hit
      var dimsAndMets = dimensionsAndMetrics(properties);
      ga('set', dimsAndMets);
    }
  });

  /**
   * User Timings Event in GA
   * @name userTimings
   *
   * @param {object} properties Comprised of the mandatory fields:
   *     'timingCategory' (string),
   *     'timingVar' (string),
   *     'timingValue' (number)
   * Properties can also have the optional fields:
   *     'timingLabel' (string)
   *
   * @link https://developers.google.com/analytics/devguides/collection/analyticsjs/user-timings
   */
  $analyticsProvider.registerUserTimings(function (properties) {
    if (!properties || !properties.timingCategory || !properties.timingVar || typeof properties.timingValue === 'undefined') {
      console.log('Properties timingCategory, timingVar, and timingValue are required to be set.');
      return;
    }

    if(window.ga) {
      ga('send', 'timing', properties);
    }
  });

}]);
})(window, window.angular);


/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;;(function () {
	'use strict';

	/**
	 * @preserve FastClick: polyfill to remove click delays on browsers with touch UIs.
	 *
	 * @codingstandard ftlabs-jsv2
	 * @copyright The Financial Times Limited [All Rights Reserved]
	 * @license MIT License (see LICENSE.txt)
	 */

	/*jslint browser:true, node:true*/
	/*global define, Event, Node*/


	/**
	 * Instantiate fast-clicking listeners on the specified layer.
	 *
	 * @constructor
	 * @param {Element} layer The layer to listen on
	 * @param {Object} [options={}] The options to override the defaults
	 */
	function FastClick(layer, options) {
		var oldOnClick;

		options = options || {};

		/**
		 * Whether a click is currently being tracked.
		 *
		 * @type boolean
		 */
		this.trackingClick = false;


		/**
		 * Timestamp for when click tracking started.
		 *
		 * @type number
		 */
		this.trackingClickStart = 0;


		/**
		 * The element being tracked for a click.
		 *
		 * @type EventTarget
		 */
		this.targetElement = null;


		/**
		 * X-coordinate of touch start event.
		 *
		 * @type number
		 */
		this.touchStartX = 0;


		/**
		 * Y-coordinate of touch start event.
		 *
		 * @type number
		 */
		this.touchStartY = 0;


		/**
		 * ID of the last touch, retrieved from Touch.identifier.
		 *
		 * @type number
		 */
		this.lastTouchIdentifier = 0;


		/**
		 * Touchmove boundary, beyond which a click will be cancelled.
		 *
		 * @type number
		 */
		this.touchBoundary = options.touchBoundary || 10;


		/**
		 * The FastClick layer.
		 *
		 * @type Element
		 */
		this.layer = layer;

		/**
		 * The minimum time between tap(touchstart and touchend) events
		 *
		 * @type number
		 */
		this.tapDelay = options.tapDelay || 200;

		/**
		 * The maximum time for a tap
		 *
		 * @type number
		 */
		this.tapTimeout = options.tapTimeout || 700;

		if (FastClick.notNeeded(layer)) {
			return;
		}

		// Some old versions of Android don't have Function.prototype.bind
		function bind(method, context) {
			return function() { return method.apply(context, arguments); };
		}


		var methods = ['onMouse', 'onClick', 'onTouchStart', 'onTouchMove', 'onTouchEnd', 'onTouchCancel'];
		var context = this;
		for (var i = 0, l = methods.length; i < l; i++) {
			context[methods[i]] = bind(context[methods[i]], context);
		}

		// Set up event handlers as required
		if (deviceIsAndroid) {
			layer.addEventListener('mouseover', this.onMouse, true);
			layer.addEventListener('mousedown', this.onMouse, true);
			layer.addEventListener('mouseup', this.onMouse, true);
		}

		layer.addEventListener('click', this.onClick, true);
		layer.addEventListener('touchstart', this.onTouchStart, false);
		layer.addEventListener('touchmove', this.onTouchMove, false);
		layer.addEventListener('touchend', this.onTouchEnd, false);
		layer.addEventListener('touchcancel', this.onTouchCancel, false);

		// Hack is required for browsers that don't support Event#stopImmediatePropagation (e.g. Android 2)
		// which is how FastClick normally stops click events bubbling to callbacks registered on the FastClick
		// layer when they are cancelled.
		if (!Event.prototype.stopImmediatePropagation) {
			layer.removeEventListener = function(type, callback, capture) {
				var rmv = Node.prototype.removeEventListener;
				if (type === 'click') {
					rmv.call(layer, type, callback.hijacked || callback, capture);
				} else {
					rmv.call(layer, type, callback, capture);
				}
			};

			layer.addEventListener = function(type, callback, capture) {
				var adv = Node.prototype.addEventListener;
				if (type === 'click') {
					adv.call(layer, type, callback.hijacked || (callback.hijacked = function(event) {
						if (!event.propagationStopped) {
							callback(event);
						}
					}), capture);
				} else {
					adv.call(layer, type, callback, capture);
				}
			};
		}

		// If a handler is already declared in the element's onclick attribute, it will be fired before
		// FastClick's onClick handler. Fix this by pulling out the user-defined handler function and
		// adding it as listener.
		if (typeof layer.onclick === 'function') {

			// Android browser on at least 3.2 requires a new reference to the function in layer.onclick
			// - the old one won't work if passed to addEventListener directly.
			oldOnClick = layer.onclick;
			layer.addEventListener('click', function(event) {
				oldOnClick(event);
			}, false);
			layer.onclick = null;
		}
	}

	/**
	* Windows Phone 8.1 fakes user agent string to look like Android and iPhone.
	*
	* @type boolean
	*/
	var deviceIsWindowsPhone = navigator.userAgent.indexOf("Windows Phone") >= 0;

	/**
	 * Android requires exceptions.
	 *
	 * @type boolean
	 */
	var deviceIsAndroid = navigator.userAgent.indexOf('Android') > 0 && !deviceIsWindowsPhone;


	/**
	 * iOS requires exceptions.
	 *
	 * @type boolean
	 */
	var deviceIsIOS = /iP(ad|hone|od)/.test(navigator.userAgent) && !deviceIsWindowsPhone;


	/**
	 * iOS 4 requires an exception for select elements.
	 *
	 * @type boolean
	 */
	var deviceIsIOS4 = deviceIsIOS && (/OS 4_\d(_\d)?/).test(navigator.userAgent);


	/**
	 * iOS 6.0-7.* requires the target element to be manually derived
	 *
	 * @type boolean
	 */
	var deviceIsIOSWithBadTarget = deviceIsIOS && (/OS [6-7]_\d/).test(navigator.userAgent);

	/**
	 * BlackBerry requires exceptions.
	 *
	 * @type boolean
	 */
	var deviceIsBlackBerry10 = navigator.userAgent.indexOf('BB10') > 0;

	/**
	 * Determine whether a given element requires a native click.
	 *
	 * @param {EventTarget|Element} target Target DOM element
	 * @returns {boolean} Returns true if the element needs a native click
	 */
	FastClick.prototype.needsClick = function(target) {
		switch (target.nodeName.toLowerCase()) {

		// Don't send a synthetic click to disabled inputs (issue #62)
		case 'button':
		case 'select':
		case 'textarea':
			if (target.disabled) {
				return true;
			}

			break;
		case 'input':

			// File inputs need real clicks on iOS 6 due to a browser bug (issue #68)
			if ((deviceIsIOS && target.type === 'file') || target.disabled) {
				return true;
			}

			break;
		case 'label':
		case 'iframe': // iOS8 homescreen apps can prevent events bubbling into frames
		case 'video':
			return true;
		}

		return (/\bneedsclick\b/).test(target.className);
	};


	/**
	 * Determine whether a given element requires a call to focus to simulate click into element.
	 *
	 * @param {EventTarget|Element} target Target DOM element
	 * @returns {boolean} Returns true if the element requires a call to focus to simulate native click.
	 */
	FastClick.prototype.needsFocus = function(target) {
		switch (target.nodeName.toLowerCase()) {
		case 'textarea':
			return true;
		case 'select':
			return !deviceIsAndroid;
		case 'input':
			switch (target.type) {
			case 'button':
			case 'checkbox':
			case 'file':
			case 'image':
			case 'radio':
			case 'submit':
				return false;
			}

			// No point in attempting to focus disabled inputs
			return !target.disabled && !target.readOnly;
		default:
			return (/\bneedsfocus\b/).test(target.className);
		}
	};


	/**
	 * Send a click event to the specified element.
	 *
	 * @param {EventTarget|Element} targetElement
	 * @param {Event} event
	 */
	FastClick.prototype.sendClick = function(targetElement, event) {
		var clickEvent, touch;

		// On some Android devices activeElement needs to be blurred otherwise the synthetic click will have no effect (#24)
		if (document.activeElement && document.activeElement !== targetElement) {
			document.activeElement.blur();
		}

		touch = event.changedTouches[0];

		// Synthesise a click event, with an extra attribute so it can be tracked
		clickEvent = document.createEvent('MouseEvents');
		clickEvent.initMouseEvent(this.determineEventType(targetElement), true, true, window, 1, touch.screenX, touch.screenY, touch.clientX, touch.clientY, false, false, false, false, 0, null);
		clickEvent.forwardedTouchEvent = true;
		targetElement.dispatchEvent(clickEvent);
	};

	FastClick.prototype.determineEventType = function(targetElement) {

		//Issue #159: Android Chrome Select Box does not open with a synthetic click event
		if (deviceIsAndroid && targetElement.tagName.toLowerCase() === 'select') {
			return 'mousedown';
		}

		return 'click';
	};


	/**
	 * @param {EventTarget|Element} targetElement
	 */
	FastClick.prototype.focus = function(targetElement) {
		var length;

		// Issue #160: on iOS 7, some input elements (e.g. date datetime month) throw a vague TypeError on setSelectionRange. These elements don't have an integer value for the selectionStart and selectionEnd properties, but unfortunately that can't be used for detection because accessing the properties also throws a TypeError. Just check the type instead. Filed as Apple bug #15122724.
		if (deviceIsIOS && targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time' && targetElement.type !== 'month') {
			length = targetElement.value.length;
			targetElement.setSelectionRange(length, length);
		} else {
			targetElement.focus();
		}
	};


	/**
	 * Check whether the given target element is a child of a scrollable layer and if so, set a flag on it.
	 *
	 * @param {EventTarget|Element} targetElement
	 */
	FastClick.prototype.updateScrollParent = function(targetElement) {
		var scrollParent, parentElement;

		scrollParent = targetElement.fastClickScrollParent;

		// Attempt to discover whether the target element is contained within a scrollable layer. Re-check if the
		// target element was moved to another parent.
		if (!scrollParent || !scrollParent.contains(targetElement)) {
			parentElement = targetElement;
			do {
				if (parentElement.scrollHeight > parentElement.offsetHeight) {
					scrollParent = parentElement;
					targetElement.fastClickScrollParent = parentElement;
					break;
				}

				parentElement = parentElement.parentElement;
			} while (parentElement);
		}

		// Always update the scroll top tracker if possible.
		if (scrollParent) {
			scrollParent.fastClickLastScrollTop = scrollParent.scrollTop;
		}
	};


	/**
	 * @param {EventTarget} targetElement
	 * @returns {Element|EventTarget}
	 */
	FastClick.prototype.getTargetElementFromEventTarget = function(eventTarget) {

		// On some older browsers (notably Safari on iOS 4.1 - see issue #56) the event target may be a text node.
		if (eventTarget.nodeType === Node.TEXT_NODE) {
			return eventTarget.parentNode;
		}

		return eventTarget;
	};


	/**
	 * On touch start, record the position and scroll offset.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onTouchStart = function(event) {
		var targetElement, touch, selection;

		// Ignore multiple touches, otherwise pinch-to-zoom is prevented if both fingers are on the FastClick element (issue #111).
		if (event.targetTouches.length > 1) {
			return true;
		}

		targetElement = this.getTargetElementFromEventTarget(event.target);
		touch = event.targetTouches[0];

		if (deviceIsIOS) {

			// Only trusted events will deselect text on iOS (issue #49)
			selection = window.getSelection();
			if (selection.rangeCount && !selection.isCollapsed) {
				return true;
			}

			if (!deviceIsIOS4) {

				// Weird things happen on iOS when an alert or confirm dialog is opened from a click event callback (issue #23):
				// when the user next taps anywhere else on the page, new touchstart and touchend events are dispatched
				// with the same identifier as the touch event that previously triggered the click that triggered the alert.
				// Sadly, there is an issue on iOS 4 that causes some normal touch events to have the same identifier as an
				// immediately preceeding touch event (issue #52), so this fix is unavailable on that platform.
				// Issue 120: touch.identifier is 0 when Chrome dev tools 'Emulate touch events' is set with an iOS device UA string,
				// which causes all touch events to be ignored. As this block only applies to iOS, and iOS identifiers are always long,
				// random integers, it's safe to to continue if the identifier is 0 here.
				if (touch.identifier && touch.identifier === this.lastTouchIdentifier) {
					event.preventDefault();
					return false;
				}

				this.lastTouchIdentifier = touch.identifier;

				// If the target element is a child of a scrollable layer (using -webkit-overflow-scrolling: touch) and:
				// 1) the user does a fling scroll on the scrollable layer
				// 2) the user stops the fling scroll with another tap
				// then the event.target of the last 'touchend' event will be the element that was under the user's finger
				// when the fling scroll was started, causing FastClick to send a click event to that layer - unless a check
				// is made to ensure that a parent layer was not scrolled before sending a synthetic click (issue #42).
				this.updateScrollParent(targetElement);
			}
		}

		this.trackingClick = true;
		this.trackingClickStart = event.timeStamp;
		this.targetElement = targetElement;

		this.touchStartX = touch.pageX;
		this.touchStartY = touch.pageY;

		// Prevent phantom clicks on fast double-tap (issue #36)
		if ((event.timeStamp - this.lastClickTime) < this.tapDelay) {
			event.preventDefault();
		}

		return true;
	};


	/**
	 * Based on a touchmove event object, check whether the touch has moved past a boundary since it started.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.touchHasMoved = function(event) {
		var touch = event.changedTouches[0], boundary = this.touchBoundary;

		if (Math.abs(touch.pageX - this.touchStartX) > boundary || Math.abs(touch.pageY - this.touchStartY) > boundary) {
			return true;
		}

		return false;
	};


	/**
	 * Update the last position.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onTouchMove = function(event) {
		if (!this.trackingClick) {
			return true;
		}

		// If the touch has moved, cancel the click tracking
		if (this.targetElement !== this.getTargetElementFromEventTarget(event.target) || this.touchHasMoved(event)) {
			this.trackingClick = false;
			this.targetElement = null;
		}

		return true;
	};


	/**
	 * Attempt to find the labelled control for the given label element.
	 *
	 * @param {EventTarget|HTMLLabelElement} labelElement
	 * @returns {Element|null}
	 */
	FastClick.prototype.findControl = function(labelElement) {

		// Fast path for newer browsers supporting the HTML5 control attribute
		if (labelElement.control !== undefined) {
			return labelElement.control;
		}

		// All browsers under test that support touch events also support the HTML5 htmlFor attribute
		if (labelElement.htmlFor) {
			return document.getElementById(labelElement.htmlFor);
		}

		// If no for attribute exists, attempt to retrieve the first labellable descendant element
		// the list of which is defined here: http://www.w3.org/TR/html5/forms.html#category-label
		return labelElement.querySelector('button, input:not([type=hidden]), keygen, meter, output, progress, select, textarea');
	};


	/**
	 * On touch end, determine whether to send a click event at once.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onTouchEnd = function(event) {
		var forElement, trackingClickStart, targetTagName, scrollParent, touch, targetElement = this.targetElement;

		if (!this.trackingClick) {
			return true;
		}

		// Prevent phantom clicks on fast double-tap (issue #36)
		if ((event.timeStamp - this.lastClickTime) < this.tapDelay) {
			this.cancelNextClick = true;
			return true;
		}

		if ((event.timeStamp - this.trackingClickStart) > this.tapTimeout) {
			return true;
		}

		// Reset to prevent wrong click cancel on input (issue #156).
		this.cancelNextClick = false;

		this.lastClickTime = event.timeStamp;

		trackingClickStart = this.trackingClickStart;
		this.trackingClick = false;
		this.trackingClickStart = 0;

		// On some iOS devices, the targetElement supplied with the event is invalid if the layer
		// is performing a transition or scroll, and has to be re-detected manually. Note that
		// for this to function correctly, it must be called *after* the event target is checked!
		// See issue #57; also filed as rdar://13048589 .
		if (deviceIsIOSWithBadTarget) {
			touch = event.changedTouches[0];

			// In certain cases arguments of elementFromPoint can be negative, so prevent setting targetElement to null
			targetElement = document.elementFromPoint(touch.pageX - window.pageXOffset, touch.pageY - window.pageYOffset) || targetElement;
			targetElement.fastClickScrollParent = this.targetElement.fastClickScrollParent;
		}

		targetTagName = targetElement.tagName.toLowerCase();
		if (targetTagName === 'label') {
			forElement = this.findControl(targetElement);
			if (forElement) {
				this.focus(targetElement);
				if (deviceIsAndroid) {
					return false;
				}

				targetElement = forElement;
			}
		} else if (this.needsFocus(targetElement)) {

			// Case 1: If the touch started a while ago (best guess is 100ms based on tests for issue #36) then focus will be triggered anyway. Return early and unset the target element reference so that the subsequent click will be allowed through.
			// Case 2: Without this exception for input elements tapped when the document is contained in an iframe, then any inputted text won't be visible even though the value attribute is updated as the user types (issue #37).
			if ((event.timeStamp - trackingClickStart) > 100 || (deviceIsIOS && window.top !== window && targetTagName === 'input')) {
				this.targetElement = null;
				return false;
			}

			this.focus(targetElement);
			this.sendClick(targetElement, event);

			// Select elements need the event to go through on iOS 4, otherwise the selector menu won't open.
			// Also this breaks opening selects when VoiceOver is active on iOS6, iOS7 (and possibly others)
			if (!deviceIsIOS || targetTagName !== 'select') {
				this.targetElement = null;
				event.preventDefault();
			}

			return false;
		}

		if (deviceIsIOS && !deviceIsIOS4) {

			// Don't send a synthetic click event if the target element is contained within a parent layer that was scrolled
			// and this tap is being used to stop the scrolling (usually initiated by a fling - issue #42).
			scrollParent = targetElement.fastClickScrollParent;
			if (scrollParent && scrollParent.fastClickLastScrollTop !== scrollParent.scrollTop) {
				return true;
			}
		}

		// Prevent the actual click from going though - unless the target node is marked as requiring
		// real clicks or if it is in the whitelist in which case only non-programmatic clicks are permitted.
		if (!this.needsClick(targetElement)) {
			event.preventDefault();
			this.sendClick(targetElement, event);
		}

		return false;
	};


	/**
	 * On touch cancel, stop tracking the click.
	 *
	 * @returns {void}
	 */
	FastClick.prototype.onTouchCancel = function() {
		this.trackingClick = false;
		this.targetElement = null;
	};


	/**
	 * Determine mouse events which should be permitted.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onMouse = function(event) {

		// If a target element was never set (because a touch event was never fired) allow the event
		if (!this.targetElement) {
			return true;
		}

		if (event.forwardedTouchEvent) {
			return true;
		}

		// Programmatically generated events targeting a specific element should be permitted
		if (!event.cancelable) {
			return true;
		}

		// Derive and check the target element to see whether the mouse event needs to be permitted;
		// unless explicitly enabled, prevent non-touch click events from triggering actions,
		// to prevent ghost/doubleclicks.
		if (!this.needsClick(this.targetElement) || this.cancelNextClick) {

			// Prevent any user-added listeners declared on FastClick element from being fired.
			if (event.stopImmediatePropagation) {
				event.stopImmediatePropagation();
			} else {

				// Part of the hack for browsers that don't support Event#stopImmediatePropagation (e.g. Android 2)
				event.propagationStopped = true;
			}

			// Cancel the event
			event.stopPropagation();
			event.preventDefault();

			return false;
		}

		// If the mouse event is permitted, return true for the action to go through.
		return true;
	};


	/**
	 * On actual clicks, determine whether this is a touch-generated click, a click action occurring
	 * naturally after a delay after a touch (which needs to be cancelled to avoid duplication), or
	 * an actual click which should be permitted.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onClick = function(event) {
		var permitted;

		// It's possible for another FastClick-like library delivered with third-party code to fire a click event before FastClick does (issue #44). In that case, set the click-tracking flag back to false and return early. This will cause onTouchEnd to return early.
		if (this.trackingClick) {
			this.targetElement = null;
			this.trackingClick = false;
			return true;
		}

		// Very odd behaviour on iOS (issue #18): if a submit element is present inside a form and the user hits enter in the iOS simulator or clicks the Go button on the pop-up OS keyboard the a kind of 'fake' click event will be triggered with the submit-type input element as the target.
		if (event.target.type === 'submit' && event.detail === 0) {
			return true;
		}

		permitted = this.onMouse(event);

		// Only unset targetElement if the click is not permitted. This will ensure that the check for !targetElement in onMouse fails and the browser's click doesn't go through.
		if (!permitted) {
			this.targetElement = null;
		}

		// If clicks are permitted, return true for the action to go through.
		return permitted;
	};


	/**
	 * Remove all FastClick's event listeners.
	 *
	 * @returns {void}
	 */
	FastClick.prototype.destroy = function() {
		var layer = this.layer;

		if (deviceIsAndroid) {
			layer.removeEventListener('mouseover', this.onMouse, true);
			layer.removeEventListener('mousedown', this.onMouse, true);
			layer.removeEventListener('mouseup', this.onMouse, true);
		}

		layer.removeEventListener('click', this.onClick, true);
		layer.removeEventListener('touchstart', this.onTouchStart, false);
		layer.removeEventListener('touchmove', this.onTouchMove, false);
		layer.removeEventListener('touchend', this.onTouchEnd, false);
		layer.removeEventListener('touchcancel', this.onTouchCancel, false);
	};


	/**
	 * Check whether FastClick is needed.
	 *
	 * @param {Element} layer The layer to listen on
	 */
	FastClick.notNeeded = function(layer) {
		var metaViewport;
		var chromeVersion;
		var blackberryVersion;
		var firefoxVersion;

		// Devices that don't support touch don't need FastClick
		if (typeof window.ontouchstart === 'undefined') {
			return true;
		}

		// Chrome version - zero for other browsers
		chromeVersion = +(/Chrome\/([0-9]+)/.exec(navigator.userAgent) || [,0])[1];

		if (chromeVersion) {

			if (deviceIsAndroid) {
				metaViewport = document.querySelector('meta[name=viewport]');

				if (metaViewport) {
					// Chrome on Android with user-scalable="no" doesn't need FastClick (issue #89)
					if (metaViewport.content.indexOf('user-scalable=no') !== -1) {
						return true;
					}
					// Chrome 32 and above with width=device-width or less don't need FastClick
					if (chromeVersion > 31 && document.documentElement.scrollWidth <= window.outerWidth) {
						return true;
					}
				}

			// Chrome desktop doesn't need FastClick (issue #15)
			} else {
				return true;
			}
		}

		if (deviceIsBlackBerry10) {
			blackberryVersion = navigator.userAgent.match(/Version\/([0-9]*)\.([0-9]*)/);

			// BlackBerry 10.3+ does not require Fastclick library.
			// https://github.com/ftlabs/fastclick/issues/251
			if (blackberryVersion[1] >= 10 && blackberryVersion[2] >= 3) {
				metaViewport = document.querySelector('meta[name=viewport]');

				if (metaViewport) {
					// user-scalable=no eliminates click delay.
					if (metaViewport.content.indexOf('user-scalable=no') !== -1) {
						return true;
					}
					// width=device-width (or less than device-width) eliminates click delay.
					if (document.documentElement.scrollWidth <= window.outerWidth) {
						return true;
					}
				}
			}
		}

		// IE10 with -ms-touch-action: none or manipulation, which disables double-tap-to-zoom (issue #97)
		if (layer.style.msTouchAction === 'none' || layer.style.touchAction === 'manipulation') {
			return true;
		}

		// Firefox version - zero for other browsers
		firefoxVersion = +(/Firefox\/([0-9]+)/.exec(navigator.userAgent) || [,0])[1];

		if (firefoxVersion >= 27) {
			// Firefox 27+ does not have tap delay if the content is not zoomable - https://bugzilla.mozilla.org/show_bug.cgi?id=922896

			metaViewport = document.querySelector('meta[name=viewport]');
			if (metaViewport && (metaViewport.content.indexOf('user-scalable=no') !== -1 || document.documentElement.scrollWidth <= window.outerWidth)) {
				return true;
			}
		}

		// IE11: prefixed -ms-touch-action is no longer supported and it's recomended to use non-prefixed version
		// http://msdn.microsoft.com/en-us/library/windows/apps/Hh767313.aspx
		if (layer.style.touchAction === 'none' || layer.style.touchAction === 'manipulation') {
			return true;
		}

		return false;
	};


	/**
	 * Factory method for creating a FastClick object
	 *
	 * @param {Element} layer The layer to listen on
	 * @param {Object} [options={}] The options to override the defaults
	 */
	FastClick.attach = function(layer, options) {
		return new FastClick(layer, options);
	};


	if (true) {

		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
			return FastClick;
		}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = FastClick.attach;
		module.exports.FastClick = FastClick;
	} else {
		window.FastClick = FastClick;
	}
}());


/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * angular-translate - v2.18.1 - 2018-05-19
 * 
 * Copyright (c) 2018 The angular-translate team, Pascal Precht; Licensed MIT
 */
(function (root, factory) {
  if (true) {
    // AMD. Register as an anonymous module unless amdModuleId is set
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
      return (factory());
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof module === 'object' && module.exports) {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
  } else {
    factory();
  }
}(this, function () {

/**
 * @ngdoc overview
 * @name pascalprecht.translate
 *
 * @description
 * The main module which holds everything together.
 */
runTranslate.$inject = ['$translate'];
$translate.$inject = ['$STORAGE_KEY', '$windowProvider', '$translateSanitizationProvider', 'pascalprechtTranslateOverrider'];
$translateDefaultInterpolation.$inject = ['$interpolate', '$translateSanitization'];
translateDirective.$inject = ['$translate', '$interpolate', '$compile', '$parse', '$rootScope'];
translateAttrDirective.$inject = ['$translate', '$rootScope'];
translateCloakDirective.$inject = ['$translate', '$rootScope'];
translateFilterFactory.$inject = ['$parse', '$translate'];
$translationCache.$inject = ['$cacheFactory'];
angular.module('pascalprecht.translate', ['ng'])
  .run(runTranslate);

function runTranslate($translate) {

  'use strict';

  var key = $translate.storageKey(),
    storage = $translate.storage();

  var fallbackFromIncorrectStorageValue = function () {
    var preferred = $translate.preferredLanguage();
    if (angular.isString(preferred)) {
      $translate.use(preferred);
      // $translate.use() will also remember the language.
      // So, we don't need to call storage.put() here.
    } else {
      storage.put(key, $translate.use());
    }
  };

  fallbackFromIncorrectStorageValue.displayName = 'fallbackFromIncorrectStorageValue';

  if (storage) {
    if (!storage.get(key)) {
      fallbackFromIncorrectStorageValue();
    } else {
      $translate.use(storage.get(key))['catch'](fallbackFromIncorrectStorageValue);
    }
  } else if (angular.isString($translate.preferredLanguage())) {
    $translate.use($translate.preferredLanguage());
  }
}

runTranslate.displayName = 'runTranslate';

/**
 * @ngdoc object
 * @name pascalprecht.translate.$translateSanitizationProvider
 *
 * @description
 *
 * Configurations for $translateSanitization
 */
angular.module('pascalprecht.translate').provider('$translateSanitization', $translateSanitizationProvider);

function $translateSanitizationProvider () {

  'use strict';

  var $sanitize,
      $sce,
      currentStrategy = null, // TODO change to either 'sanitize', 'escape' or ['sanitize', 'escapeParameters'] in 3.0.
      hasConfiguredStrategy = false,
      hasShownNoStrategyConfiguredWarning = false,
      strategies;

  /**
   * Definition of a sanitization strategy function
   * @callback StrategyFunction
   * @param {string|object} value - value to be sanitized (either a string or an interpolated value map)
   * @param {string} mode - either 'text' for a string (translation) or 'params' for the interpolated params
   * @return {string|object}
   */

  /**
   * @ngdoc property
   * @name strategies
   * @propertyOf pascalprecht.translate.$translateSanitizationProvider
   *
   * @description
   * Following strategies are built-in:
   * <dl>
   *   <dt>sanitize</dt>
   *   <dd>Sanitizes HTML in the translation text using $sanitize</dd>
   *   <dt>escape</dt>
   *   <dd>Escapes HTML in the translation</dd>
   *   <dt>sanitizeParameters</dt>
   *   <dd>Sanitizes HTML in the values of the interpolation parameters using $sanitize</dd>
   *   <dt>escapeParameters</dt>
   *   <dd>Escapes HTML in the values of the interpolation parameters</dd>
   *   <dt>escaped</dt>
   *   <dd>Support legacy strategy name 'escaped' for backwards compatibility (will be removed in 3.0)</dd>
   * </dl>
   *
   */

  strategies = {
    sanitize: function (value, mode/*, context*/) {
      if (mode === 'text') {
        value = htmlSanitizeValue(value);
      }
      return value;
    },
    escape: function (value, mode/*, context*/) {
      if (mode === 'text') {
        value = htmlEscapeValue(value);
      }
      return value;
    },
    sanitizeParameters: function (value, mode/*, context*/) {
      if (mode === 'params') {
        value = mapInterpolationParameters(value, htmlSanitizeValue);
      }
      return value;
    },
    escapeParameters: function (value, mode/*, context*/) {
      if (mode === 'params') {
        value = mapInterpolationParameters(value, htmlEscapeValue);
      }
      return value;
    },
    sce: function (value, mode, context) {
      if (mode === 'text') {
        value = htmlTrustValue(value);
      } else if (mode === 'params') {
        if (context !== 'filter') {
          // do html escape in filter context #1101
          value = mapInterpolationParameters(value, htmlEscapeValue);
        }
      }
      return value;
    },
    sceParameters: function (value, mode/*, context*/) {
      if (mode === 'params') {
        value = mapInterpolationParameters(value, htmlTrustValue);
      }
      return value;
    }
  };
  // Support legacy strategy name 'escaped' for backwards compatibility.
  // TODO should be removed in 3.0
  strategies.escaped = strategies.escapeParameters;

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateSanitizationProvider#addStrategy
   * @methodOf pascalprecht.translate.$translateSanitizationProvider
   *
   * @description
   * Adds a sanitization strategy to the list of known strategies.
   *
   * @param {string} strategyName - unique key for a strategy
   * @param {StrategyFunction} strategyFunction - strategy function
   * @returns {object} this
   */
  this.addStrategy = function (strategyName, strategyFunction) {
    strategies[strategyName] = strategyFunction;
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateSanitizationProvider#removeStrategy
   * @methodOf pascalprecht.translate.$translateSanitizationProvider
   *
   * @description
   * Removes a sanitization strategy from the list of known strategies.
   *
   * @param {string} strategyName - unique key for a strategy
   * @returns {object} this
   */
  this.removeStrategy = function (strategyName) {
    delete strategies[strategyName];
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateSanitizationProvider#useStrategy
   * @methodOf pascalprecht.translate.$translateSanitizationProvider
   *
   * @description
   * Selects a sanitization strategy. When an array is provided the strategies will be executed in order.
   *
   * @param {string|StrategyFunction|array} strategy The sanitization strategy / strategies which should be used. Either a name of an existing strategy, a custom strategy function, or an array consisting of multiple names and / or custom functions.
   * @returns {object} this
   */
  this.useStrategy = function (strategy) {
    hasConfiguredStrategy = true;
    currentStrategy = strategy;
    return this;
  };

  /**
   * @ngdoc object
   * @name pascalprecht.translate.$translateSanitization
   * @requires $injector
   * @requires $log
   *
   * @description
   * Sanitizes interpolation parameters and translated texts.
   *
   */
  this.$get = ['$injector', '$log', function ($injector, $log) {

    var cachedStrategyMap = {};

    var applyStrategies = function (value, mode, context, selectedStrategies) {
      angular.forEach(selectedStrategies, function (selectedStrategy) {
        if (angular.isFunction(selectedStrategy)) {
          value = selectedStrategy(value, mode, context);
        } else if (angular.isFunction(strategies[selectedStrategy])) {
          value = strategies[selectedStrategy](value, mode, context);
        } else if (angular.isString(strategies[selectedStrategy])) {
          if (!cachedStrategyMap[strategies[selectedStrategy]]) {
            try {
              cachedStrategyMap[strategies[selectedStrategy]] = $injector.get(strategies[selectedStrategy]);
            } catch (e) {
              cachedStrategyMap[strategies[selectedStrategy]] = function() {};
              throw new Error('pascalprecht.translate.$translateSanitization: Unknown sanitization strategy: \'' + selectedStrategy + '\'');
            }
          }
          value = cachedStrategyMap[strategies[selectedStrategy]](value, mode, context);
        } else {
          throw new Error('pascalprecht.translate.$translateSanitization: Unknown sanitization strategy: \'' + selectedStrategy + '\'');
        }
      });
      return value;
    };

    // TODO: should be removed in 3.0
    var showNoStrategyConfiguredWarning = function () {
      if (!hasConfiguredStrategy && !hasShownNoStrategyConfiguredWarning) {
        $log.warn('pascalprecht.translate.$translateSanitization: No sanitization strategy has been configured. This can have serious security implications. See http://angular-translate.github.io/docs/#/guide/19_security for details.');
        hasShownNoStrategyConfiguredWarning = true;
      }
    };

    if ($injector.has('$sanitize')) {
      $sanitize = $injector.get('$sanitize');
    }
    if ($injector.has('$sce')) {
      $sce = $injector.get('$sce');
    }

    return {
      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translateSanitization#useStrategy
       * @methodOf pascalprecht.translate.$translateSanitization
       *
       * @description
       * Selects a sanitization strategy. When an array is provided the strategies will be executed in order.
       *
       * @param {string|StrategyFunction|array} strategy The sanitization strategy / strategies which should be used. Either a name of an existing strategy, a custom strategy function, or an array consisting of multiple names and / or custom functions.
       */
      useStrategy: (function (self) {
        return function (strategy) {
          self.useStrategy(strategy);
        };
      })(this),

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translateSanitization#sanitize
       * @methodOf pascalprecht.translate.$translateSanitization
       *
       * @description
       * Sanitizes a value.
       *
       * @param {string|object} value The value which should be sanitized.
       * @param {string} mode The current sanitization mode, either 'params' or 'text'.
       * @param {string|StrategyFunction|array} [strategy] Optional custom strategy which should be used instead of the currently selected strategy.
       * @param {string} [context] The context of this call: filter, service. Default is service
       * @returns {string|object} sanitized value
       */
      sanitize: function (value, mode, strategy, context) {
        if (!currentStrategy) {
          showNoStrategyConfiguredWarning();
        }

        if (!strategy && strategy !== null) {
          strategy = currentStrategy;
        }

        if (!strategy) {
          return value;
        }

        if (!context) {
          context = 'service';
        }

        var selectedStrategies = angular.isArray(strategy) ? strategy : [strategy];
        return applyStrategies(value, mode, context, selectedStrategies);
      }
    };
  }];

  var htmlEscapeValue = function (value) {
    var element = angular.element('<div></div>');
    element.text(value); // not chainable, see #1044
    return element.html();
  };

  var htmlSanitizeValue = function (value) {
    if (!$sanitize) {
      throw new Error('pascalprecht.translate.$translateSanitization: Error cannot find $sanitize service. Either include the ngSanitize module (https://docs.angularjs.org/api/ngSanitize) or use a sanitization strategy which does not depend on $sanitize, such as \'escape\'.');
    }
    return $sanitize(value);
  };

  var htmlTrustValue = function (value) {
    if (!$sce) {
      throw new Error('pascalprecht.translate.$translateSanitization: Error cannot find $sce service.');
    }
    return $sce.trustAsHtml(value);
  };

  var mapInterpolationParameters = function (value, iteratee, stack) {
    if (angular.isDate(value)) {
      return value;
    } else if (angular.isObject(value)) {
      var result = angular.isArray(value) ? [] : {};

      if (!stack) {
        stack = [];
      } else {
        if (stack.indexOf(value) > -1) {
          throw new Error('pascalprecht.translate.$translateSanitization: Error cannot interpolate parameter due recursive object');
        }
      }

      stack.push(value);
      angular.forEach(value, function (propertyValue, propertyKey) {

        /* Skipping function properties. */
        if (angular.isFunction(propertyValue)) {
          return;
        }

        result[propertyKey] = mapInterpolationParameters(propertyValue, iteratee, stack);
      });
      stack.splice(-1, 1); // remove last

      return result;
    } else if (angular.isNumber(value)) {
      return value;
    } else if (value === true || value === false) {
      return value;
    } else if (!angular.isUndefined(value) && value !== null) {
      return iteratee(value);
    } else {
      return value;
    }
  };
}

/**
 * @ngdoc object
 * @name pascalprecht.translate.$translateProvider
 * @description
 *
 * $translateProvider allows developers to register translation-tables, asynchronous loaders
 * and similar to configure translation behavior directly inside of a module.
 *
 */
angular.module('pascalprecht.translate')
  .constant('pascalprechtTranslateOverrider', {})
  .provider('$translate', $translate);

function $translate($STORAGE_KEY, $windowProvider, $translateSanitizationProvider, pascalprechtTranslateOverrider) {

  'use strict';

  var $translationTable = {},
    $preferredLanguage,
    $availableLanguageKeys = [],
    $languageKeyAliases,
    $fallbackLanguage,
    $fallbackWasString,
    $uses,
    $nextLang,
    $storageFactory,
    $storageKey = $STORAGE_KEY,
    $storagePrefix,
    $missingTranslationHandlerFactory,
    $interpolationFactory,
    $interpolatorFactories = [],
    $loaderFactory,
    $cloakClassName = 'translate-cloak',
    $loaderOptions,
    $notFoundIndicatorLeft,
    $notFoundIndicatorRight,
    $postCompilingEnabled = false,
    $forceAsyncReloadEnabled = false,
    $nestedObjectDelimeter = '.',
    $isReady = false,
    $keepContent = false,
    loaderCache,
    directivePriority = 0,
    statefulFilter = true,
    postProcessFn,
    uniformLanguageTagResolver = 'default',
    languageTagResolver = {
      'default' : function (tag) {
        return (tag || '').split('-').join('_');
      },
      java : function (tag) {
        var temp = (tag || '').split('-').join('_');
        var parts = temp.split('_');
        return parts.length > 1 ? (parts[0].toLowerCase() + '_' + parts[1].toUpperCase()) : temp;
      },
      bcp47 : function (tag) {
        var temp = (tag || '').split('_').join('-');
        var parts = temp.split('-');

        switch (parts.length) {
          case 1: // language only
            parts[0] = parts[0].toLowerCase();
            break;
          case 2: // language-script or language-region
            parts[0] = parts[0].toLowerCase();
            if (parts[1].length === 4) { // parts[1] is script
              parts[1] = parts[1].charAt(0).toUpperCase() + parts[1].slice(1).toLowerCase();
            } else { // parts[1] is region
              parts[1] = parts[1].toUpperCase();
            }
            break;
          case 3: // language-script-region
            parts[0] = parts[0].toLowerCase();
            parts[1] = parts[1].charAt(0).toUpperCase() + parts[1].slice(1).toLowerCase();
            parts[2] = parts[2].toUpperCase();
            break;
          default:
            return temp;
        }

        return parts.join('-');
      },
      'iso639-1' : function (tag) {
        var temp = (tag || '').split('_').join('-');
        var parts = temp.split('-');
        return parts[0].toLowerCase();
      }
    };

  var version = '2.18.1';

  // tries to determine the browsers language
  var getFirstBrowserLanguage = function () {

    // internal purpose only
    if (angular.isFunction(pascalprechtTranslateOverrider.getLocale)) {
      return pascalprechtTranslateOverrider.getLocale();
    }

    var nav = $windowProvider.$get().navigator,
      browserLanguagePropertyKeys = ['language', 'browserLanguage', 'systemLanguage', 'userLanguage'],
      i,
      language;

    // support for HTML 5.1 "navigator.languages"
    if (angular.isArray(nav.languages)) {
      for (i = 0; i < nav.languages.length; i++) {
        language = nav.languages[i];
        if (language && language.length) {
          return language;
        }
      }
    }

    // support for other well known properties in browsers
    for (i = 0; i < browserLanguagePropertyKeys.length; i++) {
      language = nav[browserLanguagePropertyKeys[i]];
      if (language && language.length) {
        return language;
      }
    }

    return null;
  };
  getFirstBrowserLanguage.displayName = 'angular-translate/service: getFirstBrowserLanguage';

  // tries to determine the browsers locale
  var getLocale = function () {
    var locale = getFirstBrowserLanguage() || '';
    if (languageTagResolver[uniformLanguageTagResolver]) {
      locale = languageTagResolver[uniformLanguageTagResolver](locale);
    }
    return locale;
  };
  getLocale.displayName = 'angular-translate/service: getLocale';

  /**
   * @name indexOf
   * @private
   *
   * @description
   * indexOf polyfill. Kinda sorta.
   *
   * @param {array} array Array to search in.
   * @param {string} searchElement Element to search for.
   *
   * @returns {int} Index of search element.
   */
  var indexOf = function (array, searchElement) {
    for (var i = 0, len = array.length; i < len; i++) {
      if (array[i] === searchElement) {
        return i;
      }
    }
    return -1;
  };

  /**
   * @name trim
   * @private
   *
   * @description
   * trim polyfill
   *
   * @returns {string} The string stripped of whitespace from both ends
   */
  var trim = function () {
    return this.toString().replace(/^\s+|\s+$/g, '');
  };

  /**
   * @name lowercase
   * @private
   *
   * @description
   * Return the lowercase string only if the type is string
   *
   * @returns {string} The string all in lowercase
   */
  var lowercase = function (string) {
    return angular.isString(string) ? string.toLowerCase() : string;
  };

  var negotiateLocale = function (preferred) {
    if (!preferred) {
      return;
    }

    var avail = [],
      locale = lowercase(preferred),
      i = 0,
      n = $availableLanguageKeys.length;

    for (; i < n; i++) {
      avail.push(lowercase($availableLanguageKeys[i]));
    }

    // Check for an exact match in our list of available keys
    i = indexOf(avail, locale);
    if (i > -1) {
      return $availableLanguageKeys[i];
    }

    if ($languageKeyAliases) {
      var alias;
      for (var langKeyAlias in $languageKeyAliases) {
        if ($languageKeyAliases.hasOwnProperty(langKeyAlias)) {
          var hasWildcardKey = false;
          var hasExactKey = Object.prototype.hasOwnProperty.call($languageKeyAliases, langKeyAlias) &&
            lowercase(langKeyAlias) === lowercase(preferred);

          if (langKeyAlias.slice(-1) === '*') {
            hasWildcardKey = lowercase(langKeyAlias.slice(0, -1)) === lowercase(preferred.slice(0, langKeyAlias.length - 1));
          }
          if (hasExactKey || hasWildcardKey) {
            alias = $languageKeyAliases[langKeyAlias];
            if (indexOf(avail, lowercase(alias)) > -1) {
              return alias;
            }
          }
        }
      }
    }

    // Check for a language code without region
    var parts = preferred.split('_');

    if (parts.length > 1 && indexOf(avail, lowercase(parts[0])) > -1) {
      return parts[0];
    }

    // If everything fails, return undefined.
    return;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#translations
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Registers a new translation table for specific language key.
   *
   * To register a translation table for specific language, pass a defined language
   * key as first parameter.
   *
   * <pre>
   *  // register translation table for language: 'de_DE'
   *  $translateProvider.translations('de_DE', {
   *    'GREETING': 'Hallo Welt!'
   *  });
   *
   *  // register another one
   *  $translateProvider.translations('en_US', {
   *    'GREETING': 'Hello world!'
   *  });
   * </pre>
   *
   * When registering multiple translation tables for for the same language key,
   * the actual translation table gets extended. This allows you to define module
   * specific translation which only get added, once a specific module is loaded in
   * your app.
   *
   * Invoking this method with no arguments returns the translation table which was
   * registered with no language key. Invoking it with a language key returns the
   * related translation table.
   *
   * @param {string} langKey A language key.
   * @param {object} translationTable A plain old JavaScript object that represents a translation table.
   *
   */
  var translations = function (langKey, translationTable) {

    if (!langKey && !translationTable) {
      return $translationTable;
    }

    if (langKey && !translationTable) {
      if (angular.isString(langKey)) {
        return $translationTable[langKey];
      }
    } else {
      if (!angular.isObject($translationTable[langKey])) {
        $translationTable[langKey] = {};
      }
      angular.extend($translationTable[langKey], flatObject(translationTable));
    }
    return this;
  };

  this.translations = translations;

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#cloakClassName
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   *
   * Let's you change the class name for `translate-cloak` directive.
   * Default class name is `translate-cloak`.
   *
   * @param {string} name translate-cloak class name
   */
  this.cloakClassName = function (name) {
    if (!name) {
      return $cloakClassName;
    }
    $cloakClassName = name;
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#nestedObjectDelimeter
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   *
   * Let's you change the delimiter for namespaced translations.
   * Default delimiter is `.`.
   *
   * @param {string} delimiter namespace separator
   */
  this.nestedObjectDelimeter = function (delimiter) {
    if (!delimiter) {
      return $nestedObjectDelimeter;
    }
    $nestedObjectDelimeter = delimiter;
    return this;
  };

  /**
   * @name flatObject
   * @private
   *
   * @description
   * Flats an object. This function is used to flatten given translation data with
   * namespaces, so they are later accessible via dot notation.
   */
  var flatObject = function (data, path, result, prevKey) {
    var key, keyWithPath, keyWithShortPath, val;

    if (!path) {
      path = [];
    }
    if (!result) {
      result = {};
    }
    for (key in data) {
      if (!Object.prototype.hasOwnProperty.call(data, key)) {
        continue;
      }
      val = data[key];
      if (angular.isObject(val)) {
        flatObject(val, path.concat(key), result, key);
      } else {
        keyWithPath = path.length ? ('' + path.join($nestedObjectDelimeter) + $nestedObjectDelimeter + key) : key;
        if (path.length && key === prevKey) {
          // Create shortcut path (foo.bar == foo.bar.bar)
          keyWithShortPath = '' + path.join($nestedObjectDelimeter);
          // Link it to original path
          result[keyWithShortPath] = '@:' + keyWithPath;
        }
        result[keyWithPath] = val;
      }
    }
    return result;
  };
  flatObject.displayName = 'flatObject';

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#addInterpolation
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Adds interpolation services to angular-translate, so it can manage them.
   *
   * @param {object} factory Interpolation service factory
   */
  this.addInterpolation = function (factory) {
    $interpolatorFactories.push(factory);
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useMessageFormatInterpolation
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use interpolation functionality of messageformat.js.
   * This is useful when having high level pluralization and gender selection.
   */
  this.useMessageFormatInterpolation = function () {
    return this.useInterpolation('$translateMessageFormatInterpolation');
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useInterpolation
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate which interpolation style to use as default, application-wide.
   * Simply pass a factory/service name. The interpolation service has to implement
   * the correct interface.
   *
   * @param {string} factory Interpolation service name.
   */
  this.useInterpolation = function (factory) {
    $interpolationFactory = factory;
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useSanitizeStrategy
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Simply sets a sanitation strategy type.
   *
   * @param {string} value Strategy type.
   */
  this.useSanitizeValueStrategy = function (value) {
    $translateSanitizationProvider.useStrategy(value);
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#preferredLanguage
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells the module which of the registered translation tables to use for translation
   * at initial startup by passing a language key. Similar to `$translateProvider#use`
   * only that it says which language to **prefer**.
   * It is recommended to call this after {@link pascalprecht.translate.$translate#fallbackLanguage fallbackLanguage()}.
   *
   * @param {string} langKey A language key.
   */
  this.preferredLanguage = function (langKey) {
    if (langKey) {
      setupPreferredLanguage(langKey);
      return this;
    }
    return $preferredLanguage;
  };
  var setupPreferredLanguage = function (langKey) {
    if (langKey) {
      $preferredLanguage = langKey;
    }
    return $preferredLanguage;
  };
  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicator
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Sets an indicator which is used when a translation isn't found. E.g. when
   * setting the indicator as 'X' and one tries to translate a translation id
   * called `NOT_FOUND`, this will result in `X NOT_FOUND X`.
   *
   * Internally this methods sets a left indicator and a right indicator using
   * `$translateProvider.translationNotFoundIndicatorLeft()` and
   * `$translateProvider.translationNotFoundIndicatorRight()`.
   *
   * **Note**: These methods automatically add a whitespace between the indicators
   * and the translation id.
   *
   * @param {string} indicator An indicator, could be any string.
   */
  this.translationNotFoundIndicator = function (indicator) {
    this.translationNotFoundIndicatorLeft(indicator);
    this.translationNotFoundIndicatorRight(indicator);
    return this;
  };

  /**
   * ngdoc function
   * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicatorLeft
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Sets an indicator which is used when a translation isn't found left to the
   * translation id.
   *
   * @param {string} indicator An indicator.
   */
  this.translationNotFoundIndicatorLeft = function (indicator) {
    if (!indicator) {
      return $notFoundIndicatorLeft;
    }
    $notFoundIndicatorLeft = indicator;
    return this;
  };

  /**
   * ngdoc function
   * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicatorLeft
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Sets an indicator which is used when a translation isn't found right to the
   * translation id.
   *
   * @param {string} indicator An indicator.
   */
  this.translationNotFoundIndicatorRight = function (indicator) {
    if (!indicator) {
      return $notFoundIndicatorRight;
    }
    $notFoundIndicatorRight = indicator;
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#fallbackLanguage
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells the module which of the registered translation tables to use when missing translations
   * at initial startup by passing a language key. Similar to `$translateProvider#use`
   * only that it says which language to **fallback**.
   *
   * @param {string||array} langKey A language key.
   *
   */
  this.fallbackLanguage = function (langKey) {
    fallbackStack(langKey);
    return this;
  };

  var fallbackStack = function (langKey) {
    if (langKey) {
      if (angular.isString(langKey)) {
        $fallbackWasString = true;
        $fallbackLanguage = [langKey];
      } else if (angular.isArray(langKey)) {
        $fallbackWasString = false;
        $fallbackLanguage = langKey;
      }
      if (angular.isString($preferredLanguage) && indexOf($fallbackLanguage, $preferredLanguage) < 0) {
        $fallbackLanguage.push($preferredLanguage);
      }

      return this;
    } else {
      if ($fallbackWasString) {
        return $fallbackLanguage[0];
      } else {
        return $fallbackLanguage;
      }
    }
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#use
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Set which translation table to use for translation by given language key. When
   * trying to 'use' a language which isn't provided, it'll throw an error.
   *
   * You actually don't have to use this method since `$translateProvider#preferredLanguage`
   * does the job too.
   *
   * @param {string} langKey A language key.
   */
  this.use = function (langKey) {
    if (langKey) {
      if (!$translationTable[langKey] && (!$loaderFactory)) {
        // only throw an error, when not loading translation data asynchronously
        throw new Error('$translateProvider couldn\'t find translationTable for langKey: \'' + langKey + '\'');
      }
      $uses = langKey;
      return this;
    }
    return $uses;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#resolveClientLocale
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * This returns the current browser/client's language key. The result is processed with the configured uniform tag resolver.
   *
   * @returns {string} the current client/browser language key
   */
  this.resolveClientLocale = function () {
    return getLocale();
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#storageKey
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells the module which key must represent the choosed language by a user in the storage.
   *
   * @param {string} key A key for the storage.
   */
  var storageKey = function (key) {
    if (!key) {
      if ($storagePrefix) {
        return $storagePrefix + $storageKey;
      }
      return $storageKey;
    }
    $storageKey = key;
    return this;
  };

  this.storageKey = storageKey;

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useUrlLoader
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use `$translateUrlLoader` extension service as loader.
   *
   * @param {string} url Url
   * @param {Object=} options Optional configuration object
   */
  this.useUrlLoader = function (url, options) {
    return this.useLoader('$translateUrlLoader', angular.extend({url : url}, options));
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useStaticFilesLoader
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use `$translateStaticFilesLoader` extension service as loader.
   *
   * @param {Object=} options Optional configuration object
   */
  this.useStaticFilesLoader = function (options) {
    return this.useLoader('$translateStaticFilesLoader', options);
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useLoader
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use any other service as loader.
   *
   * @param {string} loaderFactory Factory name to use
   * @param {Object=} options Optional configuration object
   */
  this.useLoader = function (loaderFactory, options) {
    $loaderFactory = loaderFactory;
    $loaderOptions = options || {};
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useLocalStorage
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use `$translateLocalStorage` service as storage layer.
   *
   */
  this.useLocalStorage = function () {
    return this.useStorage('$translateLocalStorage');
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useCookieStorage
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use `$translateCookieStorage` service as storage layer.
   */
  this.useCookieStorage = function () {
    return this.useStorage('$translateCookieStorage');
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useStorage
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use custom service as storage layer.
   */
  this.useStorage = function (storageFactory) {
    $storageFactory = storageFactory;
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#storagePrefix
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Sets prefix for storage key.
   *
   * @param {string} prefix Storage key prefix
   */
  this.storagePrefix = function (prefix) {
    if (!prefix) {
      return prefix;
    }
    $storagePrefix = prefix;
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useMissingTranslationHandlerLog
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use built-in log handler when trying to translate
   * a translation Id which doesn't exist.
   *
   * This is actually a shortcut method for `useMissingTranslationHandler()`.
   *
   */
  this.useMissingTranslationHandlerLog = function () {
    return this.useMissingTranslationHandler('$translateMissingTranslationHandlerLog');
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useMissingTranslationHandler
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Expects a factory name which later gets instantiated with `$injector`.
   * This method can be used to tell angular-translate to use a custom
   * missingTranslationHandler. Just build a factory which returns a function
   * and expects a translation id as argument.
   *
   * Example:
   * <pre>
   *  app.config(function ($translateProvider) {
   *    $translateProvider.useMissingTranslationHandler('customHandler');
   *  });
   *
   *  app.factory('customHandler', function (dep1, dep2) {
   *    return function (translationId) {
   *      // something with translationId and dep1 and dep2
   *    };
   *  });
   * </pre>
   *
   * @param {string} factory Factory name
   */
  this.useMissingTranslationHandler = function (factory) {
    $missingTranslationHandlerFactory = factory;
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#usePostCompiling
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * If post compiling is enabled, all translated values will be processed
   * again with AngularJS' $compile.
   *
   * Example:
   * <pre>
   *  app.config(function ($translateProvider) {
   *    $translateProvider.usePostCompiling(true);
   *  });
   * </pre>
   *
   * @param {string} factory Factory name
   */
  this.usePostCompiling = function (value) {
    $postCompilingEnabled = !(!value);
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#forceAsyncReload
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * If force async reload is enabled, async loader will always be called
   * even if $translationTable already contains the language key, adding
   * possible new entries to the $translationTable.
   *
   * Example:
   * <pre>
   *  app.config(function ($translateProvider) {
   *    $translateProvider.forceAsyncReload(true);
   *  });
   * </pre>
   *
   * @param {boolean} value - valid values are true or false
   */
  this.forceAsyncReload = function (value) {
    $forceAsyncReloadEnabled = !(!value);
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#uniformLanguageTag
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate which language tag should be used as a result when determining
   * the current browser language.
   *
   * This setting must be set before invoking {@link pascalprecht.translate.$translateProvider#methods_determinePreferredLanguage determinePreferredLanguage()}.
   *
   * <pre>
   * $translateProvider
   *   .uniformLanguageTag('bcp47')
   *   .determinePreferredLanguage()
   * </pre>
   *
   * The resolver currently supports:
   * * default
   *     (traditionally: hyphens will be converted into underscores, i.e. en-US => en_US)
   *     en-US => en_US
   *     en_US => en_US
   *     en-us => en_us
   * * java
   *     like default, but the second part will be always in uppercase
   *     en-US => en_US
   *     en_US => en_US
   *     en-us => en_US
   * * BCP 47 (RFC 4646 & 4647)
   *     EN => en
   *     en-US => en-US
   *     en_US => en-US
   *     en-us => en-US
   *     sr-latn => sr-Latn
   *     sr-latn-rs => sr-Latn-RS
   *
   * See also:
   * * http://en.wikipedia.org/wiki/IETF_language_tag
   * * http://www.w3.org/International/core/langtags/
   * * http://tools.ietf.org/html/bcp47
   *
   * @param {string|object} options - options (or standard)
   * @param {string} options.standard - valid values are 'default', 'bcp47', 'java'
   */
  this.uniformLanguageTag = function (options) {

    if (!options) {
      options = {};
    } else if (angular.isString(options)) {
      options = {
        standard : options
      };
    }

    uniformLanguageTagResolver = options.standard;

    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#determinePreferredLanguage
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to try to determine on its own which language key
   * to set as preferred language. When `fn` is given, angular-translate uses it
   * to determine a language key, otherwise it uses the built-in `getLocale()`
   * method.
   *
   * The `getLocale()` returns a language key in the format `[lang]_[country]` or
   * `[lang]` depending on what the browser provides.
   *
   * Use this method at your own risk, since not all browsers return a valid
   * locale (see {@link pascalprecht.translate.$translateProvider#methods_uniformLanguageTag uniformLanguageTag()}).
   *
   * @param {Function=} fn Function to determine a browser's locale
   */
  this.determinePreferredLanguage = function (fn) {

    var locale = (fn && angular.isFunction(fn)) ? fn() : getLocale();

    if (!$availableLanguageKeys.length) {
      $preferredLanguage = locale;
    } else {
      $preferredLanguage = negotiateLocale(locale) || locale;
    }

    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#registerAvailableLanguageKeys
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Registers a set of language keys the app will work with. Use this method in
   * combination with
   * {@link pascalprecht.translate.$translateProvider#determinePreferredLanguage determinePreferredLanguage}.
   * When available languages keys are registered, angular-translate
   * tries to find the best fitting language key depending on the browsers locale,
   * considering your language key convention.
   *
   * @param {object} languageKeys Array of language keys the your app will use
   * @param {object=} aliases Alias map.
   */
  this.registerAvailableLanguageKeys = function (languageKeys, aliases) {
    if (languageKeys) {
      $availableLanguageKeys = languageKeys;
      if (aliases) {
        $languageKeyAliases = aliases;
      }
      return this;
    }
    return $availableLanguageKeys;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useLoaderCache
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Registers a cache for internal $http based loaders.
   * {@link pascalprecht.translate.$translationCache $translationCache}.
   * When false the cache will be disabled (default). When true or undefined
   * the cache will be a default (see $cacheFactory). When an object it will
   * be treat as a cache object itself: the usage is $http({cache: cache})
   *
   * @param {object} cache boolean, string or cache-object
   */
  this.useLoaderCache = function (cache) {
    if (cache === false) {
      // disable cache
      loaderCache = undefined;
    } else if (cache === true) {
      // enable cache using AJS defaults
      loaderCache = true;
    } else if (typeof(cache) === 'undefined') {
      // enable cache using default
      loaderCache = '$translationCache';
    } else if (cache) {
      // enable cache using given one (see $cacheFactory)
      loaderCache = cache;
    }
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#directivePriority
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Sets the default priority of the translate directive. The standard value is `0`.
   * Calling this function without an argument will return the current value.
   *
   * @param {number} priority for the translate-directive
   */
  this.directivePriority = function (priority) {
    if (priority === undefined) {
      // getter
      return directivePriority;
    } else {
      // setter with chaining
      directivePriority = priority;
      return this;
    }
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#statefulFilter
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Since AngularJS 1.3, filters which are not stateless (depending at the scope)
   * have to explicit define this behavior.
   * Sets whether the translate filter should be stateful or stateless. The standard value is `true`
   * meaning being stateful.
   * Calling this function without an argument will return the current value.
   *
   * @param {boolean} state - defines the state of the filter
   */
  this.statefulFilter = function (state) {
    if (state === undefined) {
      // getter
      return statefulFilter;
    } else {
      // setter with chaining
      statefulFilter = state;
      return this;
    }
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#postProcess
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * The post processor will be intercept right after the translation result. It can modify the result.
   *
   * @param {object} fn Function or service name (string) to be called after the translation value has been set / resolved. The function itself will enrich every value being processed and then continue the normal resolver process
   */
  this.postProcess = function (fn) {
    if (fn) {
      postProcessFn = fn;
    } else {
      postProcessFn = undefined;
    }
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#keepContent
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * If keepContent is set to true than translate directive will always use innerHTML
   * as a default translation
   *
   * Example:
   * <pre>
   *  app.config(function ($translateProvider) {
   *    $translateProvider.keepContent(true);
   *  });
   * </pre>
   *
   * @param {boolean} value - valid values are true or false
   */
  this.keepContent = function (value) {
    $keepContent = !(!value);
    return this;
  };

  /**
   * @ngdoc object
   * @name pascalprecht.translate.$translate
   * @requires $interpolate
   * @requires $log
   * @requires $rootScope
   * @requires $q
   *
   * @description
   * The `$translate` service is the actual core of angular-translate. It expects a translation id
   * and optional interpolate parameters to translate contents.
   *
   * <pre>
   *  $translate('HEADLINE_TEXT').then(function (translation) {
   *    $scope.translatedText = translation;
   *  });
   * </pre>
   *
   * @param {string|array} translationId A token which represents a translation id
   *                                     This can be optionally an array of translation ids which
   *                                     results that the function returns an object where each key
   *                                     is the translation id and the value the translation.
   * @param {object=} [interpolateParams={}] An object hash for dynamic values
   * @param {string=} [interpolationId=undefined] The id of the interpolation to use (use default unless set via useInterpolation())
   * @param {string=} [defaultTranslationText=undefined] the optional default translation text that is written as
   *                                        as default text in case it is not found in any configured language
   * @param {string=} [forceLanguage=false] A language to be used instead of the current language
   * @param {string=} [sanitizeStrategy=undefined] force sanitize strategy for this call instead of using the configured one (use default unless set)
   * @returns {object} promise
   */
  this.$get = ['$log', '$injector', '$rootScope', '$q', function ($log, $injector, $rootScope, $q) {

    var Storage,
      defaultInterpolator = $injector.get($interpolationFactory || '$translateDefaultInterpolation'),
      pendingLoader = false,
      interpolatorHashMap = {},
      langPromises = {},
      fallbackIndex,
      startFallbackIteration;

    var $translate = function (translationId, interpolateParams, interpolationId, defaultTranslationText, forceLanguage, sanitizeStrategy) {
      if (!$uses && $preferredLanguage) {
        $uses = $preferredLanguage;
      }
      var uses = (forceLanguage && forceLanguage !== $uses) ? // we don't want to re-negotiate $uses
        (negotiateLocale(forceLanguage) || forceLanguage) : $uses;

      // Check forceLanguage is present
      if (forceLanguage) {
        loadTranslationsIfMissing(forceLanguage);
      }

      // Duck detection: If the first argument is an array, a bunch of translations was requested.
      // The result is an object.
      if (angular.isArray(translationId)) {
        // Inspired by Q.allSettled by Kris Kowal
        // https://github.com/kriskowal/q/blob/b0fa72980717dc202ffc3cbf03b936e10ebbb9d7/q.js#L1553-1563
        // This transforms all promises regardless resolved or rejected
        var translateAll = function (translationIds) {
          var results = {}; // storing the actual results
          var promises = []; // promises to wait for
          // Wraps the promise a) being always resolved and b) storing the link id->value
          var translate = function (translationId) {
            var deferred = $q.defer();
            var regardless = function (value) {
              results[translationId] = value;
              deferred.resolve([translationId, value]);
            };
            // we don't care whether the promise was resolved or rejected; just store the values
            $translate(translationId, interpolateParams, interpolationId, defaultTranslationText, forceLanguage, sanitizeStrategy).then(regardless, regardless);
            return deferred.promise;
          };
          for (var i = 0, c = translationIds.length; i < c; i++) {
            promises.push(translate(translationIds[i]));
          }
          // wait for all (including storing to results)
          return $q.all(promises).then(function () {
            // return the results
            return results;
          });
        };
        return translateAll(translationId);
      }

      var deferred = $q.defer();

      // trim off any whitespace
      if (translationId) {
        translationId = trim.apply(translationId);
      }

      var promiseToWaitFor = (function () {
        var promise = langPromises[uses] || langPromises[$preferredLanguage];

        fallbackIndex = 0;

        if ($storageFactory && !promise) {
          // looks like there's no pending promise for $preferredLanguage or
          // $uses. Maybe there's one pending for a language that comes from
          // storage.
          var langKey = Storage.get($storageKey);
          promise = langPromises[langKey];

          if ($fallbackLanguage && $fallbackLanguage.length) {
            var index = indexOf($fallbackLanguage, langKey);
            // maybe the language from storage is also defined as fallback language
            // we increase the fallback language index to not search in that language
            // as fallback, since it's probably the first used language
            // in that case the index starts after the first element
            fallbackIndex = (index === 0) ? 1 : 0;

            // but we can make sure to ALWAYS fallback to preferred language at least
            if (indexOf($fallbackLanguage, $preferredLanguage) < 0) {
              $fallbackLanguage.push($preferredLanguage);
            }
          }
        }
        return promise;
      }());

      if (!promiseToWaitFor) {
        // no promise to wait for? okay. Then there's no loader registered
        // nor is a one pending for language that comes from storage.
        // We can just translate.
        determineTranslation(translationId, interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy).then(deferred.resolve, deferred.reject);
      } else {
        var promiseResolved = function () {
          // $uses may have changed while waiting
          if (!forceLanguage) {
            uses = $uses;
          }
          determineTranslation(translationId, interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy).then(deferred.resolve, deferred.reject);
        };
        promiseResolved.displayName = 'promiseResolved';

        promiseToWaitFor['finally'](promiseResolved)['catch'](angular.noop); // we don't care about errors here, already handled
      }
      return deferred.promise;
    };

    /**
     * @name applyNotFoundIndicators
     * @private
     *
     * @description
     * Applies not fount indicators to given translation id, if needed.
     * This function gets only executed, if a translation id doesn't exist,
     * which is why a translation id is expected as argument.
     *
     * @param {string} translationId Translation id.
     * @returns {string} Same as given translation id but applied with not found
     * indicators.
     */
    var applyNotFoundIndicators = function (translationId) {
      // applying notFoundIndicators
      if ($notFoundIndicatorLeft) {
        translationId = [$notFoundIndicatorLeft, translationId].join(' ');
      }
      if ($notFoundIndicatorRight) {
        translationId = [translationId, $notFoundIndicatorRight].join(' ');
      }
      return translationId;
    };

    /**
     * @name useLanguage
     * @private
     *
     * @description
     * Makes actual use of a language by setting a given language key as used
     * language and informs registered interpolators to also use the given
     * key as locale.
     *
     * @param {string} key Locale key.
     */
    var useLanguage = function (key) {
      $uses = key;

      // make sure to store new language key before triggering success event
      if ($storageFactory) {
        Storage.put($translate.storageKey(), $uses);
      }

      $rootScope.$emit('$translateChangeSuccess', {language : key});

      // inform default interpolator
      defaultInterpolator.setLocale($uses);

      var eachInterpolator = function (interpolator, id) {
        interpolatorHashMap[id].setLocale($uses);
      };
      eachInterpolator.displayName = 'eachInterpolatorLocaleSetter';

      // inform all others too!
      angular.forEach(interpolatorHashMap, eachInterpolator);
      $rootScope.$emit('$translateChangeEnd', {language : key});
    };

    /**
     * @name loadAsync
     * @private
     *
     * @description
     * Kicks off registered async loader using `$injector` and applies existing
     * loader options. When resolved, it updates translation tables accordingly
     * or rejects with given language key.
     *
     * @param {string} key Language key.
     * @return {Promise} A promise.
     */
    var loadAsync = function (key) {
      if (!key) {
        throw 'No language key specified for loading.';
      }

      var deferred = $q.defer();

      $rootScope.$emit('$translateLoadingStart', {language : key});
      pendingLoader = true;

      var cache = loaderCache;
      if (typeof(cache) === 'string') {
        // getting on-demand instance of loader
        cache = $injector.get(cache);
      }

      var loaderOptions = angular.extend({}, $loaderOptions, {
        key : key,
        $http : angular.extend({}, {
          cache : cache
        }, $loaderOptions.$http)
      });

      var onLoaderSuccess = function (data) {
        var translationTable = {};
        $rootScope.$emit('$translateLoadingSuccess', {language : key});

        if (angular.isArray(data)) {
          angular.forEach(data, function (table) {
            angular.extend(translationTable, flatObject(table));
          });
        } else {
          angular.extend(translationTable, flatObject(data));
        }
        pendingLoader = false;
        deferred.resolve({
          key : key,
          table : translationTable
        });
        $rootScope.$emit('$translateLoadingEnd', {language : key});
      };
      onLoaderSuccess.displayName = 'onLoaderSuccess';

      var onLoaderError = function (key) {
        $rootScope.$emit('$translateLoadingError', {language : key});
        deferred.reject(key);
        $rootScope.$emit('$translateLoadingEnd', {language : key});
      };
      onLoaderError.displayName = 'onLoaderError';

      $injector.get($loaderFactory)(loaderOptions)
        .then(onLoaderSuccess, onLoaderError);

      return deferred.promise;
    };

    if ($storageFactory) {
      Storage = $injector.get($storageFactory);

      if (!Storage.get || !Storage.put) {
        throw new Error('Couldn\'t use storage \'' + $storageFactory + '\', missing get() or put() method!');
      }
    }

    // if we have additional interpolations that were added via
    // $translateProvider.addInterpolation(), we have to map'em
    if ($interpolatorFactories.length) {
      var eachInterpolationFactory = function (interpolatorFactory) {
        var interpolator = $injector.get(interpolatorFactory);
        // setting initial locale for each interpolation service
        interpolator.setLocale($preferredLanguage || $uses);
        // make'em recognizable through id
        interpolatorHashMap[interpolator.getInterpolationIdentifier()] = interpolator;
      };
      eachInterpolationFactory.displayName = 'interpolationFactoryAdder';

      angular.forEach($interpolatorFactories, eachInterpolationFactory);
    }

    /**
     * @name getTranslationTable
     * @private
     *
     * @description
     * Returns a promise that resolves to the translation table
     * or is rejected if an error occurred.
     *
     * @param langKey
     * @returns {Q.promise}
     */
    var getTranslationTable = function (langKey) {
      var deferred = $q.defer();
      if (Object.prototype.hasOwnProperty.call($translationTable, langKey)) {
        deferred.resolve($translationTable[langKey]);
      } else if (langPromises[langKey]) {
        var onResolve = function (data) {
          translations(data.key, data.table);
          deferred.resolve(data.table);
        };
        onResolve.displayName = 'translationTableResolver';
        langPromises[langKey].then(onResolve, deferred.reject);
      } else {
        deferred.reject();
      }
      return deferred.promise;
    };

    /**
     * @name getFallbackTranslation
     * @private
     *
     * @description
     * Returns a promise that will resolve to the translation
     * or be rejected if no translation was found for the language.
     * This function is currently only used for fallback language translation.
     *
     * @param langKey The language to translate to.
     * @param translationId
     * @param interpolateParams
     * @param Interpolator
     * @param sanitizeStrategy
     * @returns {Q.promise}
     */
    var getFallbackTranslation = function (langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy) {
      var deferred = $q.defer();

      var onResolve = function (translationTable) {
        if (Object.prototype.hasOwnProperty.call(translationTable, translationId) && translationTable[translationId] !== null) {
          Interpolator.setLocale(langKey);
          var translation = translationTable[translationId];
          if (translation.substr(0, 2) === '@:') {
            getFallbackTranslation(langKey, translation.substr(2), interpolateParams, Interpolator, sanitizeStrategy)
              .then(deferred.resolve, deferred.reject);
          } else {
            var interpolatedValue = Interpolator.interpolate(translationTable[translationId], interpolateParams, 'service', sanitizeStrategy, translationId);
            interpolatedValue = applyPostProcessing(translationId, translationTable[translationId], interpolatedValue, interpolateParams, langKey);

            deferred.resolve(interpolatedValue);

          }
          Interpolator.setLocale($uses);
        } else {
          deferred.reject();
        }
      };
      onResolve.displayName = 'fallbackTranslationResolver';

      getTranslationTable(langKey).then(onResolve, deferred.reject);

      return deferred.promise;
    };

    /**
     * @name getFallbackTranslationInstant
     * @private
     *
     * @description
     * Returns a translation
     * This function is currently only used for fallback language translation.
     *
     * @param langKey The language to translate to.
     * @param translationId
     * @param interpolateParams
     * @param Interpolator
     * @param sanitizeStrategy sanitize strategy override
     *
     * @returns {string} translation
     */
    var getFallbackTranslationInstant = function (langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy) {
      var result, translationTable = $translationTable[langKey];

      if (translationTable && Object.prototype.hasOwnProperty.call(translationTable, translationId) && translationTable[translationId] !== null) {
        Interpolator.setLocale(langKey);
        result = Interpolator.interpolate(translationTable[translationId], interpolateParams, 'filter', sanitizeStrategy, translationId);
        result = applyPostProcessing(translationId, translationTable[translationId], result, interpolateParams, langKey, sanitizeStrategy);
        // workaround for TrustedValueHolderType
        if (!angular.isString(result) && angular.isFunction(result.$$unwrapTrustedValue)) {
          var result2 = result.$$unwrapTrustedValue();
          if (result2.substr(0, 2) === '@:') {
            return getFallbackTranslationInstant(langKey, result2.substr(2), interpolateParams, Interpolator, sanitizeStrategy);
          }
        } else if (result.substr(0, 2) === '@:') {
          return getFallbackTranslationInstant(langKey, result.substr(2), interpolateParams, Interpolator, sanitizeStrategy);
        }
        Interpolator.setLocale($uses);
      }

      return result;
    };


    /**
     * @name translateByHandler
     * @private
     *
     * Translate by missing translation handler.
     *
     * @param translationId
     * @param interpolateParams
     * @param defaultTranslationText
     * @param sanitizeStrategy sanitize strategy override
     *
     * @returns translation created by $missingTranslationHandler or translationId is $missingTranslationHandler is
     * absent
     */
    var translateByHandler = function (translationId, interpolateParams, defaultTranslationText, sanitizeStrategy) {
      // If we have a handler factory - we might also call it here to determine if it provides
      // a default text for a translationid that can't be found anywhere in our tables
      if ($missingTranslationHandlerFactory) {
        return $injector.get($missingTranslationHandlerFactory)(translationId, $uses, interpolateParams, defaultTranslationText, sanitizeStrategy);
      } else {
        return translationId;
      }
    };

    /**
     * @name resolveForFallbackLanguage
     * @private
     *
     * Recursive helper function for fallbackTranslation that will sequentially look
     * for a translation in the fallbackLanguages starting with fallbackLanguageIndex.
     *
     * @param fallbackLanguageIndex
     * @param translationId
     * @param interpolateParams
     * @param Interpolator
     * @param defaultTranslationText
     * @param sanitizeStrategy
     * @returns {Q.promise} Promise that will resolve to the translation.
     */
    var resolveForFallbackLanguage = function (fallbackLanguageIndex, translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy) {
      var deferred = $q.defer();

      if (fallbackLanguageIndex < $fallbackLanguage.length) {
        var langKey = $fallbackLanguage[fallbackLanguageIndex];
        getFallbackTranslation(langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy).then(
          function (data) {
            deferred.resolve(data);
          },
          function () {
            // Look in the next fallback language for a translation.
            // It delays the resolving by passing another promise to resolve.
            return resolveForFallbackLanguage(fallbackLanguageIndex + 1, translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy).then(deferred.resolve, deferred.reject);
          }
        );
      } else {
        // No translation found in any fallback language
        // if a default translation text is set in the directive, then return this as a result
        if (defaultTranslationText) {
          deferred.resolve(defaultTranslationText);
        } else {
          var missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, defaultTranslationText);

          // if no default translation is set and an error handler is defined, send it to the handler
          // and then return the result if it isn't undefined
          if ($missingTranslationHandlerFactory && missingTranslationHandlerTranslation) {
            deferred.resolve(missingTranslationHandlerTranslation);
          } else {
            deferred.reject(applyNotFoundIndicators(translationId));
          }
        }
      }
      return deferred.promise;
    };

    /**
     * @name resolveForFallbackLanguageInstant
     * @private
     *
     * Recursive helper function for fallbackTranslation that will sequentially look
     * for a translation in the fallbackLanguages starting with fallbackLanguageIndex.
     *
     * @param fallbackLanguageIndex
     * @param translationId
     * @param interpolateParams
     * @param Interpolator
     * @param sanitizeStrategy
     * @returns {string} translation
     */
    var resolveForFallbackLanguageInstant = function (fallbackLanguageIndex, translationId, interpolateParams, Interpolator, sanitizeStrategy) {
      var result;

      if (fallbackLanguageIndex < $fallbackLanguage.length) {
        var langKey = $fallbackLanguage[fallbackLanguageIndex];
        result = getFallbackTranslationInstant(langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy);
        if (!result && result !== '') {
          result = resolveForFallbackLanguageInstant(fallbackLanguageIndex + 1, translationId, interpolateParams, Interpolator);
        }
      }
      return result;
    };

    /**
     * Translates with the usage of the fallback languages.
     *
     * @param translationId
     * @param interpolateParams
     * @param Interpolator
     * @param defaultTranslationText
     * @param sanitizeStrategy
     * @returns {Q.promise} Promise, that resolves to the translation.
     */
    var fallbackTranslation = function (translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy) {
      // Start with the fallbackLanguage with index 0
      return resolveForFallbackLanguage((startFallbackIteration > 0 ? startFallbackIteration : fallbackIndex), translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy);
    };

    /**
     * Translates with the usage of the fallback languages.
     *
     * @param translationId
     * @param interpolateParams
     * @param Interpolator
     * @param sanitizeStrategy
     * @returns {String} translation
     */
    var fallbackTranslationInstant = function (translationId, interpolateParams, Interpolator, sanitizeStrategy) {
      // Start with the fallbackLanguage with index 0
      return resolveForFallbackLanguageInstant((startFallbackIteration > 0 ? startFallbackIteration : fallbackIndex), translationId, interpolateParams, Interpolator, sanitizeStrategy);
    };

    var determineTranslation = function (translationId, interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy) {

      var deferred = $q.defer();

      var table = uses ? $translationTable[uses] : $translationTable,
        Interpolator = (interpolationId) ? interpolatorHashMap[interpolationId] : defaultInterpolator;

      // if the translation id exists, we can just interpolate it
      if (table && Object.prototype.hasOwnProperty.call(table, translationId) && table[translationId] !== null) {
        var translation = table[translationId];

        // If using link, rerun $translate with linked translationId and return it
        if (translation.substr(0, 2) === '@:') {

          $translate(translation.substr(2), interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy)
            .then(deferred.resolve, deferred.reject);
        } else {
          //
          var resolvedTranslation = Interpolator.interpolate(translation, interpolateParams, 'service', sanitizeStrategy, translationId);
          resolvedTranslation = applyPostProcessing(translationId, translation, resolvedTranslation, interpolateParams, uses);
          deferred.resolve(resolvedTranslation);
        }
      } else {
        var missingTranslationHandlerTranslation;
        // for logging purposes only (as in $translateMissingTranslationHandlerLog), value is not returned to promise
        if ($missingTranslationHandlerFactory && !pendingLoader) {
          missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, defaultTranslationText);
        }

        // since we couldn't translate the inital requested translation id,
        // we try it now with one or more fallback languages, if fallback language(s) is
        // configured.
        if (uses && $fallbackLanguage && $fallbackLanguage.length) {
          fallbackTranslation(translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy)
            .then(function (translation) {
              deferred.resolve(translation);
            }, function (_translationId) {
              deferred.reject(applyNotFoundIndicators(_translationId));
            });
        } else if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
          // looks like the requested translation id doesn't exists.
          // Now, if there is a registered handler for missing translations and no
          // asyncLoader is pending, we execute the handler
          if (defaultTranslationText) {
            deferred.resolve(defaultTranslationText);
          } else {
            deferred.resolve(missingTranslationHandlerTranslation);
          }
        } else {
          if (defaultTranslationText) {
            deferred.resolve(defaultTranslationText);
          } else {
            deferred.reject(applyNotFoundIndicators(translationId));
          }
        }
      }
      return deferred.promise;
    };

    var determineTranslationInstant = function (translationId, interpolateParams, interpolationId, uses, sanitizeStrategy) {

      var result, table = uses ? $translationTable[uses] : $translationTable,
        Interpolator = defaultInterpolator;

      // if the interpolation id exists use custom interpolator
      if (interpolatorHashMap && Object.prototype.hasOwnProperty.call(interpolatorHashMap, interpolationId)) {
        Interpolator = interpolatorHashMap[interpolationId];
      }

      // if the translation id exists, we can just interpolate it
      if (table && Object.prototype.hasOwnProperty.call(table, translationId) && table[translationId] !== null) {
        var translation = table[translationId];

        // If using link, rerun $translate with linked translationId and return it
        if (translation.substr(0, 2) === '@:') {
          result = determineTranslationInstant(translation.substr(2), interpolateParams, interpolationId, uses, sanitizeStrategy);
        } else {
          result = Interpolator.interpolate(translation, interpolateParams, 'filter', sanitizeStrategy, translationId);
          result = applyPostProcessing(translationId, translation, result, interpolateParams, uses, sanitizeStrategy);
        }
      } else {
        var missingTranslationHandlerTranslation;
        // for logging purposes only (as in $translateMissingTranslationHandlerLog), value is not returned to promise
        if ($missingTranslationHandlerFactory && !pendingLoader) {
          missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, sanitizeStrategy);
        }

        // since we couldn't translate the inital requested translation id,
        // we try it now with one or more fallback languages, if fallback language(s) is
        // configured.
        if (uses && $fallbackLanguage && $fallbackLanguage.length) {
          fallbackIndex = 0;
          result = fallbackTranslationInstant(translationId, interpolateParams, Interpolator, sanitizeStrategy);
        } else if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
          // looks like the requested translation id doesn't exists.
          // Now, if there is a registered handler for missing translations and no
          // asyncLoader is pending, we execute the handler
          result = missingTranslationHandlerTranslation;
        } else {
          result = applyNotFoundIndicators(translationId);
        }
      }

      return result;
    };

    var clearNextLangAndPromise = function (key) {
      if ($nextLang === key) {
        $nextLang = undefined;
      }
      langPromises[key] = undefined;
    };

    var applyPostProcessing = function (translationId, translation, resolvedTranslation, interpolateParams, uses, sanitizeStrategy) {
      var fn = postProcessFn;

      if (fn) {

        if (typeof(fn) === 'string') {
          // getting on-demand instance
          fn = $injector.get(fn);
        }
        if (fn) {
          return fn(translationId, translation, resolvedTranslation, interpolateParams, uses, sanitizeStrategy);
        }
      }

      return resolvedTranslation;
    };

    var loadTranslationsIfMissing = function (key) {
      if (!$translationTable[key] && $loaderFactory && !langPromises[key]) {
        langPromises[key] = loadAsync(key).then(function (translation) {
          translations(translation.key, translation.table);
          return translation;
        });
      }
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#preferredLanguage
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns the language key for the preferred language.
     *
     * @param {string} langKey language String or Array to be used as preferredLanguage (changing at runtime)
     *
     * @return {string} preferred language key
     */
    $translate.preferredLanguage = function (langKey) {
      if (langKey) {
        setupPreferredLanguage(langKey);
      }
      return $preferredLanguage;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#cloakClassName
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns the configured class name for `translate-cloak` directive.
     *
     * @return {string} cloakClassName
     */
    $translate.cloakClassName = function () {
      return $cloakClassName;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#nestedObjectDelimeter
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns the configured delimiter for nested namespaces.
     *
     * @return {string} nestedObjectDelimeter
     */
    $translate.nestedObjectDelimeter = function () {
      return $nestedObjectDelimeter;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#fallbackLanguage
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns the language key for the fallback languages or sets a new fallback stack.
     * It is recommended to call this before {@link pascalprecht.translate.$translateProvider#preferredLanguage preferredLanguage()}.
     *
     * @param {string=} langKey language String or Array of fallback languages to be used (to change stack at runtime)
     *
     * @return {string||array} fallback language key
     */
    $translate.fallbackLanguage = function (langKey) {
      if (langKey !== undefined && langKey !== null) {
        fallbackStack(langKey);

        // as we might have an async loader initiated and a new translation language might have been defined
        // we need to add the promise to the stack also. So - iterate.
        if ($loaderFactory) {
          if ($fallbackLanguage && $fallbackLanguage.length) {
            for (var i = 0, len = $fallbackLanguage.length; i < len; i++) {
              if (!langPromises[$fallbackLanguage[i]]) {
                langPromises[$fallbackLanguage[i]] = loadAsync($fallbackLanguage[i]);
              }
            }
          }
        }
        $translate.use($translate.use());
      }
      if ($fallbackWasString) {
        return $fallbackLanguage[0];
      } else {
        return $fallbackLanguage;
      }

    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#useFallbackLanguage
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Sets the first key of the fallback language stack to be used for translation.
     * Therefore all languages in the fallback array BEFORE this key will be skipped!
     *
     * @param {string=} langKey Contains the langKey the iteration shall start with. Set to false if you want to
     * get back to the whole stack
     */
    $translate.useFallbackLanguage = function (langKey) {
      if (langKey !== undefined && langKey !== null) {
        if (!langKey) {
          startFallbackIteration = 0;
        } else {
          var langKeyPosition = indexOf($fallbackLanguage, langKey);
          if (langKeyPosition > -1) {
            startFallbackIteration = langKeyPosition;
          }
        }

      }

    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#proposedLanguage
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns the language key of language that is currently loaded asynchronously.
     *
     * @return {string} language key
     */
    $translate.proposedLanguage = function () {
      return $nextLang;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#storage
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns registered storage.
     *
     * @return {object} Storage
     */
    $translate.storage = function () {
      return Storage;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#negotiateLocale
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns a language key based on available languages and language aliases. If a
     * language key cannot be resolved, returns undefined.
     *
     * If no or a falsy key is given, returns undefined.
     *
     * @param {string} [key] Language key
     * @return {string|undefined} Language key or undefined if no language key is found.
     */
    $translate.negotiateLocale = negotiateLocale;

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#use
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Tells angular-translate which language to use by given language key. This method is
     * used to change language at runtime. It also takes care of storing the language
     * key in a configured store to let your app remember the choosed language.
     *
     * When trying to 'use' a language which isn't available it tries to load it
     * asynchronously with registered loaders.
     *
     * Returns promise object with loaded language file data or string of the currently used language.
     *
     * If no or a falsy key is given it returns the currently used language key.
     * The returned string will be ```undefined``` if setting up $translate hasn't finished.
     * @example
     * $translate.use("en_US").then(function(data){
       *   $scope.text = $translate("HELLO");
       * });
     *
     * @param {string=} key Language key
     * @return {object|string} Promise with loaded language data or the language key if a falsy param was given.
     */
    $translate.use = function (key) {
      if (!key) {
        return $uses;
      }

      var deferred = $q.defer();
      deferred.promise.then(null, angular.noop); // AJS "Possibly unhandled rejection"

      $rootScope.$emit('$translateChangeStart', {language : key});

      // Try to get the aliased language key
      var aliasedKey = negotiateLocale(key);
      // Ensure only registered language keys will be loaded
      if ($availableLanguageKeys.length > 0 && !aliasedKey) {
        return $q.reject(key);
      }

      if (aliasedKey) {
        key = aliasedKey;
      }

      // if there isn't a translation table for the language we've requested,
      // we load it asynchronously
      $nextLang = key;
      if (($forceAsyncReloadEnabled || !$translationTable[key]) && $loaderFactory && !langPromises[key]) {
        langPromises[key] = loadAsync(key).then(function (translation) {
          translations(translation.key, translation.table);
          deferred.resolve(translation.key);
          if ($nextLang === key) {
            useLanguage(translation.key);
          }
          return translation;
        }, function (key) {
          $rootScope.$emit('$translateChangeError', {language : key});
          deferred.reject(key);
          $rootScope.$emit('$translateChangeEnd', {language : key});
          return $q.reject(key);
        });
        langPromises[key]['finally'](function () {
          clearNextLangAndPromise(key);
        })['catch'](angular.noop); // we don't care about errors (clearing)
      } else if (langPromises[key]) {
        // we are already loading this asynchronously
        // resolve our new deferred when the old langPromise is resolved
        langPromises[key].then(function (translation) {
          if ($nextLang === translation.key) {
            useLanguage(translation.key);
          }
          deferred.resolve(translation.key);
          return translation;
        }, function (key) {
          // find first available fallback language if that request has failed
          if (!$uses && $fallbackLanguage && $fallbackLanguage.length > 0 && $fallbackLanguage[0] !== key) {
            return $translate.use($fallbackLanguage[0]).then(deferred.resolve, deferred.reject);
          } else {
            return deferred.reject(key);
          }
        });
      } else {
        deferred.resolve(key);
        useLanguage(key);
      }

      return deferred.promise;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#resolveClientLocale
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * This returns the current browser/client's language key. The result is processed with the configured uniform tag resolver.
     *
     * @returns {string} the current client/browser language key
     */
    $translate.resolveClientLocale = function () {
      return getLocale();
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#storageKey
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns the key for the storage.
     *
     * @return {string} storage key
     */
    $translate.storageKey = function () {
      return storageKey();
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#isPostCompilingEnabled
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns whether post compiling is enabled or not
     *
     * @return {bool} storage key
     */
    $translate.isPostCompilingEnabled = function () {
      return $postCompilingEnabled;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#isForceAsyncReloadEnabled
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns whether force async reload is enabled or not
     *
     * @return {boolean} forceAsyncReload value
     */
    $translate.isForceAsyncReloadEnabled = function () {
      return $forceAsyncReloadEnabled;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#isKeepContent
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns whether keepContent or not
     *
     * @return {boolean} keepContent value
     */
    $translate.isKeepContent = function () {
      return $keepContent;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#refresh
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Refreshes a translation table pointed by the given langKey. If langKey is not specified,
     * the module will drop all existent translation tables and load new version of those which
     * are currently in use.
     *
     * Refresh means that the module will drop target translation table and try to load it again.
     *
     * In case there are no loaders registered the refresh() method will throw an Error.
     *
     * If the module is able to refresh translation tables refresh() method will broadcast
     * $translateRefreshStart and $translateRefreshEnd events.
     *
     * @example
     * // this will drop all currently existent translation tables and reload those which are
     * // currently in use
     * $translate.refresh();
     * // this will refresh a translation table for the en_US language
     * $translate.refresh('en_US');
     *
     * @param {string} langKey A language key of the table, which has to be refreshed
     *
     * @return {promise} Promise, which will be resolved in case a translation tables refreshing
     * process is finished successfully, and reject if not.
     */
    $translate.refresh = function (langKey) {
      if (!$loaderFactory) {
        throw new Error('Couldn\'t refresh translation table, no loader registered!');
      }

      $rootScope.$emit('$translateRefreshStart', {language : langKey});

      var deferred = $q.defer(), updatedLanguages = {};

      //private helper
      function loadNewData(languageKey) {
        var promise = loadAsync(languageKey);
        //update the load promise cache for this language
        langPromises[languageKey] = promise;
        //register a data handler for the promise
        promise.then(function (data) {
            //clear the cache for this language
            $translationTable[languageKey] = {};
            //add the new data for this language
            translations(languageKey, data.table);
            //track that we updated this language
            updatedLanguages[languageKey] = true;
          },
          //handle rejection to appease the $q validation
          angular.noop);
        return promise;
      }

      //set up post-processing
      deferred.promise.then(
        function () {
          for (var key in $translationTable) {
            if ($translationTable.hasOwnProperty(key)) {
              //delete cache entries that were not updated
              if (!(key in updatedLanguages)) {
                delete $translationTable[key];
              }
            }
          }
          if ($uses) {
            useLanguage($uses);
          }
        },
        //handle rejection to appease the $q validation
        angular.noop
      )['finally'](
        function () {
          $rootScope.$emit('$translateRefreshEnd', {language : langKey});
        }
      );

      if (!langKey) {
        // if there's no language key specified we refresh ALL THE THINGS!
        var languagesToReload = $fallbackLanguage && $fallbackLanguage.slice() || [];
        if ($uses && languagesToReload.indexOf($uses) === -1) {
          languagesToReload.push($uses);
        }
        $q.all(languagesToReload.map(loadNewData)).then(deferred.resolve, deferred.reject);

      } else if ($translationTable[langKey]) {
        //just refresh the specified language cache
        loadNewData(langKey).then(deferred.resolve, deferred.reject);

      } else {
        deferred.reject();
      }

      return deferred.promise;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#instant
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns a translation instantly from the internal state of loaded translation. All rules
     * regarding the current language, the preferred language of even fallback languages will be
     * used except any promise handling. If a language was not found, an asynchronous loading
     * will be invoked in the background.
     *
     * @param {string|array} translationId A token which represents a translation id
     *                                     This can be optionally an array of translation ids which
     *                                     results that the function's promise returns an object where
     *                                     each key is the translation id and the value the translation.
     * @param {object=} [interpolateParams={}] Params
     * @param {string=} [interpolationId=undefined] The id of the interpolation to use (use default unless set via useInterpolation())
     * @param {string=} [forceLanguage=false] A language to be used instead of the current language
     * @param {string=} [sanitizeStrategy=undefined] force sanitize strategy for this call instead of using the configured one (use default unless set)
     *
     * @return {string|object} translation
     */
    $translate.instant = function (translationId, interpolateParams, interpolationId, forceLanguage, sanitizeStrategy) {

      // we don't want to re-negotiate $uses
      var uses = (forceLanguage && forceLanguage !== $uses) ? // we don't want to re-negotiate $uses
        (negotiateLocale(forceLanguage) || forceLanguage) : $uses;

      // Detect undefined and null values to shorten the execution and prevent exceptions
      if (translationId === null || angular.isUndefined(translationId)) {
        return translationId;
      }

      // Check forceLanguage is present
      if (forceLanguage) {
        loadTranslationsIfMissing(forceLanguage);
      }

      // Duck detection: If the first argument is an array, a bunch of translations was requested.
      // The result is an object.
      if (angular.isArray(translationId)) {
        var results = {};
        for (var i = 0, c = translationId.length; i < c; i++) {
          results[translationId[i]] = $translate.instant(translationId[i], interpolateParams, interpolationId, forceLanguage, sanitizeStrategy);
        }
        return results;
      }

      // We discarded unacceptable values. So we just need to verify if translationId is empty String
      if (angular.isString(translationId) && translationId.length < 1) {
        return translationId;
      }

      // trim off any whitespace
      if (translationId) {
        translationId = trim.apply(translationId);
      }

      var result, possibleLangKeys = [];
      if ($preferredLanguage) {
        possibleLangKeys.push($preferredLanguage);
      }
      if (uses) {
        possibleLangKeys.push(uses);
      }
      if ($fallbackLanguage && $fallbackLanguage.length) {
        possibleLangKeys = possibleLangKeys.concat($fallbackLanguage);
      }
      for (var j = 0, d = possibleLangKeys.length; j < d; j++) {
        var possibleLangKey = possibleLangKeys[j];
        if ($translationTable[possibleLangKey]) {
          if (typeof $translationTable[possibleLangKey][translationId] !== 'undefined') {
            result = determineTranslationInstant(translationId, interpolateParams, interpolationId, uses, sanitizeStrategy);
          }
        }
        if (typeof result !== 'undefined') {
          break;
        }
      }

      if (!result && result !== '') {
        if ($notFoundIndicatorLeft || $notFoundIndicatorRight) {
          result = applyNotFoundIndicators(translationId);
        } else {
          // Return translation of default interpolator if not found anything.
          result = defaultInterpolator.interpolate(translationId, interpolateParams, 'filter', sanitizeStrategy);

          // looks like the requested translation id doesn't exists.
          // Now, if there is a registered handler for missing translations and no
          // asyncLoader is pending, we execute the handler
          var missingTranslationHandlerTranslation;
          if ($missingTranslationHandlerFactory && !pendingLoader) {
            missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, sanitizeStrategy);
          }

          if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
            result = missingTranslationHandlerTranslation;
          }
        }
      }

      return result;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#versionInfo
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns the current version information for the angular-translate library
     *
     * @return {string} angular-translate version
     */
    $translate.versionInfo = function () {
      return version;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#loaderCache
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns the defined loaderCache.
     *
     * @return {boolean|string|object} current value of loaderCache
     */
    $translate.loaderCache = function () {
      return loaderCache;
    };

    // internal purpose only
    $translate.directivePriority = function () {
      return directivePriority;
    };

    // internal purpose only
    $translate.statefulFilter = function () {
      return statefulFilter;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#isReady
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns whether the service is "ready" to translate (i.e. loading 1st language).
     *
     * See also {@link pascalprecht.translate.$translate#methods_onReady onReady()}.
     *
     * @return {boolean} current value of ready
     */
    $translate.isReady = function () {
      return $isReady;
    };

    var $onReadyDeferred = $q.defer();
    $onReadyDeferred.promise.then(function () {
      $isReady = true;
    });

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#onReady
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Calls the function provided or resolved the returned promise after the service is "ready" to translate (i.e. loading 1st language).
     *
     * See also {@link pascalprecht.translate.$translate#methods_isReady isReady()}.
     *
     * @param {Function=} fn Function to invoke when service is ready
     * @return {object} Promise resolved when service is ready
     */
    $translate.onReady = function (fn) {
      var deferred = $q.defer();
      if (angular.isFunction(fn)) {
        deferred.promise.then(fn);
      }
      if ($isReady) {
        deferred.resolve();
      } else {
        $onReadyDeferred.promise.then(deferred.resolve);
      }
      return deferred.promise;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#getAvailableLanguageKeys
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * This function simply returns the registered language keys being defined before in the config phase
     * With this, an application can use the array to provide a language selection dropdown or similar
     * without any additional effort
     *
     * @returns {object} returns the list of possibly registered language keys and mapping or null if not defined
     */
    $translate.getAvailableLanguageKeys = function () {
      if ($availableLanguageKeys.length > 0) {
        return $availableLanguageKeys;
      }
      return null;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#getTranslationTable
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns translation table by the given language key.
     *
     * Unless a language is provided it returns a translation table of the current one.
     * Note: If translation dictionary is currently downloading or in progress
     * it will return null.
     *
     * @param {string} langKey A token which represents a translation id
     *
     * @return {object} a copy of angular-translate $translationTable
     */
    $translate.getTranslationTable = function (langKey) {
      langKey = langKey || $translate.use();
      if (langKey && $translationTable[langKey]) {
        return angular.copy($translationTable[langKey]);
      }
      return null;
    };

    // Whenever $translateReady is being fired, this will ensure the state of $isReady
    var globalOnReadyListener = $rootScope.$on('$translateReady', function () {
      $onReadyDeferred.resolve();
      globalOnReadyListener(); // one time only
      globalOnReadyListener = null;
    });
    var globalOnChangeListener = $rootScope.$on('$translateChangeEnd', function () {
      $onReadyDeferred.resolve();
      globalOnChangeListener(); // one time only
      globalOnChangeListener = null;
    });

    if ($loaderFactory) {

      // If at least one async loader is defined and there are no
      // (default) translations available we should try to load them.
      if (angular.equals($translationTable, {})) {
        if ($translate.use()) {
          $translate.use($translate.use());
        }
      }

      // Also, if there are any fallback language registered, we start
      // loading them asynchronously as soon as we can.
      if ($fallbackLanguage && $fallbackLanguage.length) {
        var processAsyncResult = function (translation) {
          translations(translation.key, translation.table);
          $rootScope.$emit('$translateChangeEnd', {language : translation.key});
          return translation;
        };
        for (var i = 0, len = $fallbackLanguage.length; i < len; i++) {
          var fallbackLanguageId = $fallbackLanguage[i];
          if ($forceAsyncReloadEnabled || !$translationTable[fallbackLanguageId]) {
            langPromises[fallbackLanguageId] = loadAsync(fallbackLanguageId).then(processAsyncResult);
          }
        }
      }
    } else {
      $rootScope.$emit('$translateReady', {language : $translate.use()});
    }

    return $translate;
  }];
}

$translate.displayName = 'displayName';

/**
 * @ngdoc object
 * @name pascalprecht.translate.$translateDefaultInterpolation
 * @requires $interpolate
 *
 * @description
 * Uses angular's `$interpolate` services to interpolate strings against some values.
 *
 * Be aware to configure a proper sanitization strategy.
 *
 * See also:
 * * {@link pascalprecht.translate.$translateSanitization}
 *
 * @return {object} $translateDefaultInterpolation Interpolator service
 */
angular.module('pascalprecht.translate').factory('$translateDefaultInterpolation', $translateDefaultInterpolation);

function $translateDefaultInterpolation ($interpolate, $translateSanitization) {

  'use strict';

  var $translateInterpolator = {},
      $locale,
      $identifier = 'default';

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateDefaultInterpolation#setLocale
   * @methodOf pascalprecht.translate.$translateDefaultInterpolation
   *
   * @description
   * Sets current locale (this is currently not use in this interpolation).
   *
   * @param {string} locale Language key or locale.
   */
  $translateInterpolator.setLocale = function (locale) {
    $locale = locale;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateDefaultInterpolation#getInterpolationIdentifier
   * @methodOf pascalprecht.translate.$translateDefaultInterpolation
   *
   * @description
   * Returns an identifier for this interpolation service.
   *
   * @returns {string} $identifier
   */
  $translateInterpolator.getInterpolationIdentifier = function () {
    return $identifier;
  };

  /**
   * @deprecated will be removed in 3.0
   * @see {@link pascalprecht.translate.$translateSanitization}
   */
  $translateInterpolator.useSanitizeValueStrategy = function (value) {
    $translateSanitization.useStrategy(value);
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateDefaultInterpolation#interpolate
   * @methodOf pascalprecht.translate.$translateDefaultInterpolation
   *
   * @description
   * Interpolates given value agains given interpolate params using angulars
   * `$interpolate` service.
   *
   * Since AngularJS 1.5, `value` must not be a string but can be anything input.
   *
   * @param {string} value translation
   * @param {object} [interpolationParams={}] interpolation params
   * @param {string} [context=undefined] current context (filter, directive, service)
   * @param {string} [sanitizeStrategy=undefined] sanitize strategy (use default unless set)
   * @param {string} translationId current translationId
   *
   * @returns {string} interpolated string
   */
  $translateInterpolator.interpolate = function (value, interpolationParams, context, sanitizeStrategy, translationId) { // jshint ignore:line
    interpolationParams = interpolationParams || {};
    interpolationParams = $translateSanitization.sanitize(interpolationParams, 'params', sanitizeStrategy, context);

    var interpolatedText;
    if (angular.isNumber(value)) {
      // numbers are safe
      interpolatedText = '' + value;
    } else if (angular.isString(value)) {
      // strings must be interpolated (that's the job here)
      interpolatedText = $interpolate(value)(interpolationParams);
      interpolatedText = $translateSanitization.sanitize(interpolatedText, 'text', sanitizeStrategy, context);
    } else {
      // neither a number or a string, cant interpolate => empty string
      interpolatedText = '';
    }

    return interpolatedText;
  };

  return $translateInterpolator;
}

$translateDefaultInterpolation.displayName = '$translateDefaultInterpolation';

angular.module('pascalprecht.translate').constant('$STORAGE_KEY', 'NG_TRANSLATE_LANG_KEY');

angular.module('pascalprecht.translate')
/**
 * @ngdoc directive
 * @name pascalprecht.translate.directive:translate
 * @requires $interpolate,
 * @requires $compile,
 * @requires $parse,
 * @requires $rootScope
 * @restrict AE
 *
 * @description
 * Translates given translation id either through attribute or DOM content.
 * Internally it uses $translate service to translate the translation id. It possible to
 * pass an optional `translate-values` object literal as string into translation id.
 *
 * @param {string=} translate Translation id which could be either string or interpolated string.
 * @param {string=} translate-values Values to pass into translation id. Can be passed as object literal string or interpolated object.
 * @param {string=} translate-attr-ATTR translate Translation id and put it into ATTR attribute.
 * @param {string=} translate-default will be used unless translation was successful
 * @param {string=} translate-sanitize-strategy defines locally sanitize strategy
 * @param {boolean=} translate-compile (default true if present) defines locally activation of {@link pascalprecht.translate.$translateProvider#methods_usePostCompiling}
 * @param {boolean=} translate-keep-content (default true if present) defines that in case a KEY could not be translated, that the existing content is left in the innerHTML}
 *
 * @example
   <example module="ngView">
    <file name="index.html">
      <div ng-controller="TranslateCtrl">

        <pre translate="TRANSLATION_ID"></pre>
        <pre translate>TRANSLATION_ID</pre>
        <pre translate translate-attr-title="TRANSLATION_ID"></pre>
        <pre translate="{{translationId}}"></pre>
        <pre translate>{{translationId}}</pre>
        <pre translate="WITH_VALUES" translate-values="{value: 5}"></pre>
        <pre translate translate-values="{value: 5}">WITH_VALUES</pre>
        <pre translate="WITH_VALUES" translate-values="{{values}}"></pre>
        <pre translate translate-values="{{values}}">WITH_VALUES</pre>
        <pre translate translate-attr-title="WITH_VALUES" translate-values="{{values}}"></pre>
        <pre translate="WITH_CAMEL_CASE_KEY" translate-value-camel-case-key="Hi"></pre>

      </div>
    </file>
    <file name="script.js">
      angular.module('ngView', ['pascalprecht.translate'])

      .config(function ($translateProvider) {

        $translateProvider.translations('en',{
          'TRANSLATION_ID': 'Hello there!',
          'WITH_VALUES': 'The following value is dynamic: {{value}}',
          'WITH_CAMEL_CASE_KEY': 'The interpolation key is camel cased: {{camelCaseKey}}'
        }).preferredLanguage('en');

      });

      angular.module('ngView').controller('TranslateCtrl', function ($scope) {
        $scope.translationId = 'TRANSLATION_ID';

        $scope.values = {
          value: 78
        };
      });
    </file>
    <file name="scenario.js">
      it('should translate', function () {
        inject(function ($rootScope, $compile) {
          $rootScope.translationId = 'TRANSLATION_ID';

          element = $compile('<p translate="TRANSLATION_ID"></p>')($rootScope);
          $rootScope.$digest();
          expect(element.text()).toBe('Hello there!');

          element = $compile('<p translate="{{translationId}}"></p>')($rootScope);
          $rootScope.$digest();
          expect(element.text()).toBe('Hello there!');

          element = $compile('<p translate>TRANSLATION_ID</p>')($rootScope);
          $rootScope.$digest();
          expect(element.text()).toBe('Hello there!');

          element = $compile('<p translate>{{translationId}}</p>')($rootScope);
          $rootScope.$digest();
          expect(element.text()).toBe('Hello there!');

          element = $compile('<p translate translate-attr-title="TRANSLATION_ID"></p>')($rootScope);
          $rootScope.$digest();
          expect(element.attr('title')).toBe('Hello there!');

          element = $compile('<p translate="WITH_CAMEL_CASE_KEY" translate-value-camel-case-key="Hello"></p>')($rootScope);
          $rootScope.$digest();
          expect(element.text()).toBe('The interpolation key is camel cased: Hello');
        });
      });
    </file>
   </example>
 */
.directive('translate', translateDirective);
function translateDirective($translate, $interpolate, $compile, $parse, $rootScope) {

  'use strict';

  /**
   * @name trim
   * @private
   *
   * @description
   * trim polyfill
   *
   * @returns {string} The string stripped of whitespace from both ends
   */
  var trim = function() {
    return this.toString().replace(/^\s+|\s+$/g, '');
  };

  /**
   * @name lowercase
   * @private
   *
   * @description
   * Return the lowercase string only if the type is string
   *
   * @returns {string} The string all in lowercase
   */
  var lowercase = function (string) {
    return angular.isString(string) ? string.toLowerCase() : string;
  };

  return {
    restrict: 'AE',
    scope: true,
    priority: $translate.directivePriority(),
    compile: function (tElement, tAttr) {

      var translateValuesExist = (tAttr.translateValues) ?
        tAttr.translateValues : undefined;

      var translateInterpolation = (tAttr.translateInterpolation) ?
        tAttr.translateInterpolation : undefined;

      var translateSanitizeStrategyExist = (tAttr.translateSanitizeStrategy) ?
        tAttr.translateSanitizeStrategy : undefined;

      var translateValueExist = tElement[0].outerHTML.match(/translate-value-+/i);

      var interpolateRegExp = '^(.*)(' + $interpolate.startSymbol() + '.*' + $interpolate.endSymbol() + ')(.*)',
          watcherRegExp = '^(.*)' + $interpolate.startSymbol() + '(.*)' + $interpolate.endSymbol() + '(.*)';

      return function linkFn(scope, iElement, iAttr) {

        scope.interpolateParams = {};
        scope.preText = '';
        scope.postText = '';
        scope.translateNamespace = getTranslateNamespace(scope);
        var translationIds = {};

        var initInterpolationParams = function (interpolateParams, iAttr, tAttr) {
          // initial setup
          if (iAttr.translateValues) {
            angular.extend(interpolateParams, $parse(iAttr.translateValues)(scope.$parent));
          }
          // initially fetch all attributes if existing and fill the params
          if (translateValueExist) {
            for (var attr in tAttr) {
              if (Object.prototype.hasOwnProperty.call(iAttr, attr) && attr.substr(0, 14) === 'translateValue' && attr !== 'translateValues') {
                var attributeName = lowercase(attr.substr(14, 1)) + attr.substr(15);
                interpolateParams[attributeName] = tAttr[attr];
              }
            }
          }
        };

        // Ensures any change of the attribute "translate" containing the id will
        // be re-stored to the scope's "translationId".
        // If the attribute has no content, the element's text value (white spaces trimmed off) will be used.
        var observeElementTranslation = function (translationId) {

          // Remove any old watcher
          if (angular.isFunction(observeElementTranslation._unwatchOld)) {
            observeElementTranslation._unwatchOld();
            observeElementTranslation._unwatchOld = undefined;
          }

          if (angular.equals(translationId , '') || !angular.isDefined(translationId)) {
            var iElementText = trim.apply(iElement.text());

            // Resolve translation id by inner html if required
            var interpolateMatches = iElementText.match(interpolateRegExp);
            // Interpolate translation id if required
            if (angular.isArray(interpolateMatches)) {
              scope.preText = interpolateMatches[1];
              scope.postText = interpolateMatches[3];
              translationIds.translate = $interpolate(interpolateMatches[2])(scope.$parent);
              var watcherMatches = iElementText.match(watcherRegExp);
              if (angular.isArray(watcherMatches) && watcherMatches[2] && watcherMatches[2].length) {
                observeElementTranslation._unwatchOld = scope.$watch(watcherMatches[2], function (newValue) {
                  translationIds.translate = newValue;
                  updateTranslations();
                });
              }
            } else {
              // do not assigne the translation id if it is empty.
              translationIds.translate = !iElementText ? undefined : iElementText;
            }
          } else {
            translationIds.translate = translationId;
          }
          updateTranslations();
        };

        var observeAttributeTranslation = function (translateAttr) {
          iAttr.$observe(translateAttr, function (translationId) {
            translationIds[translateAttr] = translationId;
            updateTranslations();
          });
        };

        // initial setup with values
        initInterpolationParams(scope.interpolateParams, iAttr, tAttr);

        var firstAttributeChangedEvent = true;
        iAttr.$observe('translate', function (translationId) {
          if (typeof translationId === 'undefined') {
            // case of element "<translate>xyz</translate>"
            observeElementTranslation('');
          } else {
            // case of regular attribute
            if (translationId !== '' || !firstAttributeChangedEvent) {
              translationIds.translate = translationId;
              updateTranslations();
            }
          }
          firstAttributeChangedEvent = false;
        });

        for (var translateAttr in iAttr) {
          if (iAttr.hasOwnProperty(translateAttr) && translateAttr.substr(0, 13) === 'translateAttr' && translateAttr.length > 13) {
            observeAttributeTranslation(translateAttr);
          }
        }

        iAttr.$observe('translateDefault', function (value) {
          scope.defaultText = value;
          updateTranslations();
        });

        if (translateSanitizeStrategyExist) {
          iAttr.$observe('translateSanitizeStrategy', function (value) {
            scope.sanitizeStrategy = $parse(value)(scope.$parent);
            updateTranslations();
          });
        }

        if (translateValuesExist) {
          iAttr.$observe('translateValues', function (interpolateParams) {
            if (interpolateParams) {
              scope.$parent.$watch(function () {
                angular.extend(scope.interpolateParams, $parse(interpolateParams)(scope.$parent));
              });
            }
          });
        }

        if (translateValueExist) {
          var observeValueAttribute = function (attrName) {
            iAttr.$observe(attrName, function (value) {
              var attributeName = lowercase(attrName.substr(14, 1)) + attrName.substr(15);
              scope.interpolateParams[attributeName] = value;
            });
          };
          for (var attr in iAttr) {
            if (Object.prototype.hasOwnProperty.call(iAttr, attr) && attr.substr(0, 14) === 'translateValue' && attr !== 'translateValues') {
              observeValueAttribute(attr);
            }
          }
        }

        // Master update function
        var updateTranslations = function () {
          for (var key in translationIds) {
            if (translationIds.hasOwnProperty(key) && translationIds[key] !== undefined) {
              updateTranslation(key, translationIds[key], scope, scope.interpolateParams, scope.defaultText, scope.translateNamespace);
            }
          }
        };

        // Put translation processing function outside loop
        var updateTranslation = function(translateAttr, translationId, scope, interpolateParams, defaultTranslationText, translateNamespace) {
          if (translationId) {
            // if translation id starts with '.' and translateNamespace given, prepend namespace
            if (translateNamespace && translationId.charAt(0) === '.') {
              translationId = translateNamespace + translationId;
            }

            $translate(translationId, interpolateParams, translateInterpolation, defaultTranslationText, scope.translateLanguage, scope.sanitizeStrategy)
              .then(function (translation) {
                applyTranslation(translation, scope, true, translateAttr);
              }, function (translationId) {
                applyTranslation(translationId, scope, false, translateAttr);
              });
          } else {
            // as an empty string cannot be translated, we can solve this using successful=false
            applyTranslation(translationId, scope, false, translateAttr);
          }
        };

        var applyTranslation = function (value, scope, successful, translateAttr) {
          if (!successful) {
            if (typeof scope.defaultText !== 'undefined') {
              value = scope.defaultText;
            }
          }
          if (translateAttr === 'translate') {
            // default translate into innerHTML
            if (successful || (!successful && !$translate.isKeepContent() && typeof iAttr.translateKeepContent === 'undefined')) {
              iElement.empty().append(scope.preText + value + scope.postText);
            }
            var globallyEnabled = $translate.isPostCompilingEnabled();
            var locallyDefined = typeof tAttr.translateCompile !== 'undefined';
            var locallyEnabled = locallyDefined && tAttr.translateCompile !== 'false';
            if ((globallyEnabled && !locallyDefined) || locallyEnabled) {
              $compile(iElement.contents())(scope);
            }
          } else {
            // translate attribute
            var attributeName = iAttr.$attr[translateAttr];
            if (attributeName.substr(0, 5) === 'data-') {
              // ensure html5 data prefix is stripped
              attributeName = attributeName.substr(5);
            }
            attributeName = attributeName.substr(15);
            iElement.attr(attributeName, value);
          }
        };

        if (translateValuesExist || translateValueExist || iAttr.translateDefault) {
          scope.$watch('interpolateParams', updateTranslations, true);
        }

        // Replaced watcher on translateLanguage with event listener
        scope.$on('translateLanguageChanged', updateTranslations);

        // Ensures the text will be refreshed after the current language was changed
        // w/ $translate.use(...)
        var unbind = $rootScope.$on('$translateChangeSuccess', updateTranslations);

        // ensure translation will be looked up at least one
        if (iElement.text().length) {
          if (iAttr.translate) {
            observeElementTranslation(iAttr.translate);
          } else {
            observeElementTranslation('');
          }
        } else if (iAttr.translate) {
          // ensure attribute will be not skipped
          observeElementTranslation(iAttr.translate);
        }
        updateTranslations();
        scope.$on('$destroy', unbind);
      };
    }
  };
}

/**
 * Returns the scope's namespace.
 * @private
 * @param scope
 * @returns {string}
 */
function getTranslateNamespace(scope) {
  'use strict';
  if (scope.translateNamespace) {
    return scope.translateNamespace;
  }
  if (scope.$parent) {
    return getTranslateNamespace(scope.$parent);
  }
}

translateDirective.displayName = 'translateDirective';

angular.module('pascalprecht.translate')
/**
 * @ngdoc directive
 * @name pascalprecht.translate.directive:translate-attr
 * @restrict A
 *
 * @description
 * Translates attributes like translate-attr-ATTR, but with an object like ng-class.
 * Internally it uses `translate` service to translate translation id. It possible to
 * pass an optional `translate-values` object literal as string into translation id.
 *
 * @param {string=} translate-attr Object literal mapping attributes to translation ids.
 * @param {string=} translate-values Values to pass into the translation ids. Can be passed as object literal string.
 * @param {string=} translate-sanitize-strategy defines locally sanitize strategy
 *
 * @example
   <example module="ngView">
    <file name="index.html">
      <div ng-controller="TranslateCtrl">

        <input translate-attr="{ placeholder: translationId, title: 'WITH_VALUES' }" translate-values="{value: 5}" />

      </div>
    </file>
    <file name="script.js">
      angular.module('ngView', ['pascalprecht.translate'])

      .config(function ($translateProvider) {

        $translateProvider.translations('en',{
          'TRANSLATION_ID': 'Hello there!',
          'WITH_VALUES': 'The following value is dynamic: {{value}}',
        }).preferredLanguage('en');

      });

      angular.module('ngView').controller('TranslateCtrl', function ($scope) {
        $scope.translationId = 'TRANSLATION_ID';

        $scope.values = {
          value: 78
        };
      });
    </file>
    <file name="scenario.js">
      it('should translate', function () {
        inject(function ($rootScope, $compile) {
          $rootScope.translationId = 'TRANSLATION_ID';

          element = $compile('<input translate-attr="{ placeholder: translationId, title: 'WITH_VALUES' }" translate-values="{ value: 5 }" />')($rootScope);
          $rootScope.$digest();
          expect(element.attr('placeholder)).toBe('Hello there!');
          expect(element.attr('title)).toBe('The following value is dynamic: 5');
        });
      });
    </file>
   </example>
 */
.directive('translateAttr', translateAttrDirective);
function translateAttrDirective($translate, $rootScope) {

  'use strict';

  return {
    restrict: 'A',
    priority: $translate.directivePriority(),
    link: function linkFn(scope, element, attr) {

      var translateAttr,
          translateValues,
          translateSanitizeStrategy,
          previousAttributes = {};

      // Main update translations function
      var updateTranslations = function () {
        angular.forEach(translateAttr, function (translationId, attributeName) {
          if (!translationId) {
            return;
          }
          previousAttributes[attributeName] = true;

          // if translation id starts with '.' and translateNamespace given, prepend namespace
          if (scope.translateNamespace && translationId.charAt(0) === '.') {
            translationId = scope.translateNamespace + translationId;
          }
          $translate(translationId, translateValues, attr.translateInterpolation, undefined, scope.translateLanguage, translateSanitizeStrategy)
            .then(function (translation) {
              element.attr(attributeName, translation);
            }, function (translationId) {
              element.attr(attributeName, translationId);
            });
        });

        // Removing unused attributes that were previously used
        angular.forEach(previousAttributes, function (flag, attributeName) {
          if (!translateAttr[attributeName]) {
            element.removeAttr(attributeName);
            delete previousAttributes[attributeName];
          }
        });
      };

      // Watch for attribute changes
      watchAttribute(
        scope,
        attr.translateAttr,
        function (newValue) { translateAttr = newValue; },
        updateTranslations
      );
      // Watch for value changes
      watchAttribute(
        scope,
        attr.translateValues,
        function (newValue) { translateValues = newValue; },
        updateTranslations
      );
      // Watch for sanitize strategy changes
      watchAttribute(
        scope,
        attr.translateSanitizeStrategy,
        function (newValue) { translateSanitizeStrategy = newValue; },
        updateTranslations
      );

      if (attr.translateValues) {
        scope.$watch(attr.translateValues, updateTranslations, true);
      }

      // Replaced watcher on translateLanguage with event listener
      scope.$on('translateLanguageChanged', updateTranslations);

      // Ensures the text will be refreshed after the current language was changed
      // w/ $translate.use(...)
      var unbind = $rootScope.$on('$translateChangeSuccess', updateTranslations);

      updateTranslations();
      scope.$on('$destroy', unbind);
    }
  };
}

function watchAttribute(scope, attribute, valueCallback, changeCallback) {
  'use strict';
  if (!attribute) {
    return;
  }
  if (attribute.substr(0, 2) === '::') {
    attribute = attribute.substr(2);
  } else {
    scope.$watch(attribute, function(newValue) {
      valueCallback(newValue);
      changeCallback();
    }, true);
  }
  valueCallback(scope.$eval(attribute));
}

translateAttrDirective.displayName = 'translateAttrDirective';

angular.module('pascalprecht.translate')
/**
 * @ngdoc directive
 * @name pascalprecht.translate.directive:translateCloak
 * @requires $translate
 * @restrict A
 *
 * $description
 * Adds a `translate-cloak` class name to the given element where this directive
 * is applied initially and removes it, once a loader has finished loading.
 *
 * This directive can be used to prevent initial flickering when loading translation
 * data asynchronously.
 *
 * The class name is defined in
 * {@link pascalprecht.translate.$translateProvider#cloakClassName $translate.cloakClassName()}.
 *
 * @param {string=} translate-cloak If a translationId is provided, it will be used for showing
 *                                  or hiding the cloak. Basically it relies on the translation
 *                                  resolve.
 */
.directive('translateCloak', translateCloakDirective);

function translateCloakDirective($translate, $rootScope) {

  'use strict';

  return {
    compile : function (tElement) {
      var applyCloak = function (element) {
          element.addClass($translate.cloakClassName());
        },
        removeCloak = function (element) {
          element.removeClass($translate.cloakClassName());
        };
      applyCloak(tElement);

      return function linkFn(scope, iElement, iAttr) {
        //Create bound functions that incorporate the active DOM element.
        var iRemoveCloak = removeCloak.bind(this, iElement), iApplyCloak = applyCloak.bind(this, iElement);
        if (iAttr.translateCloak && iAttr.translateCloak.length) {
          // Register a watcher for the defined translation allowing a fine tuned cloak
          iAttr.$observe('translateCloak', function (translationId) {
            $translate(translationId).then(iRemoveCloak, iApplyCloak);
          });
          $rootScope.$on('$translateChangeSuccess', function () {
            $translate(iAttr.translateCloak).then(iRemoveCloak, iApplyCloak);
          });
        } else {
          $translate.onReady(iRemoveCloak);
        }
      };
    }
  };
}

translateCloakDirective.displayName = 'translateCloakDirective';

angular.module('pascalprecht.translate')
/**
 * @ngdoc directive
 * @name pascalprecht.translate.directive:translateNamespace
 * @restrict A
 *
 * @description
 * Translates given translation id either through attribute or DOM content.
 * Internally it uses `translate` filter to translate translation id. It is possible to
 * pass an optional `translate-values` object literal as string into translation id.
 *
 * @param {string=} translate namespace name which could be either string or interpolated string.
 *
 * @example
   <example module="ngView">
    <file name="index.html">
      <div translate-namespace="CONTENT">

        <div>
            <h1 translate>.HEADERS.TITLE</h1>
            <h1 translate>.HEADERS.WELCOME</h1>
        </div>

        <div translate-namespace=".HEADERS">
            <h1 translate>.TITLE</h1>
            <h1 translate>.WELCOME</h1>
        </div>

      </div>
    </file>
    <file name="script.js">
      angular.module('ngView', ['pascalprecht.translate'])

      .config(function ($translateProvider) {

        $translateProvider.translations('en',{
          'TRANSLATION_ID': 'Hello there!',
          'CONTENT': {
            'HEADERS': {
                TITLE: 'Title'
            }
          },
          'CONTENT.HEADERS.WELCOME': 'Welcome'
        }).preferredLanguage('en');

      });

    </file>
   </example>
 */
.directive('translateNamespace', translateNamespaceDirective);

function translateNamespaceDirective() {

  'use strict';

  return {
    restrict: 'A',
    scope: true,
    compile: function () {
      return {
        pre: function (scope, iElement, iAttrs) {
          scope.translateNamespace = _getTranslateNamespace(scope);

          if (scope.translateNamespace && iAttrs.translateNamespace.charAt(0) === '.') {
            scope.translateNamespace += iAttrs.translateNamespace;
          } else {
            scope.translateNamespace = iAttrs.translateNamespace;
          }
        }
      };
    }
  };
}

/**
 * Returns the scope's namespace.
 * @private
 * @param scope
 * @returns {string}
 */
function _getTranslateNamespace(scope) {
  'use strict';
  if (scope.translateNamespace) {
    return scope.translateNamespace;
  }
  if (scope.$parent) {
    return _getTranslateNamespace(scope.$parent);
  }
}

translateNamespaceDirective.displayName = 'translateNamespaceDirective';

angular.module('pascalprecht.translate')
/**
 * @ngdoc directive
 * @name pascalprecht.translate.directive:translateLanguage
 * @restrict A
 *
 * @description
 * Forces the language to the directives in the underlying scope.
 *
 * @param {string=} translate language that will be negotiated.
 *
 * @example
   <example module="ngView">
    <file name="index.html">
      <div>

        <div>
            <h1 translate>HELLO</h1>
        </div>

        <div translate-language="de">
            <h1 translate>HELLO</h1>
        </div>

      </div>
    </file>
    <file name="script.js">
      angular.module('ngView', ['pascalprecht.translate'])

      .config(function ($translateProvider) {

        $translateProvider
          .translations('en',{
            'HELLO': 'Hello world!'
          })
          .translations('de',{
            'HELLO': 'Hallo Welt!'
          })
          .preferredLanguage('en');

      });

    </file>
   </example>
 */
.directive('translateLanguage', translateLanguageDirective);

function translateLanguageDirective() {

  'use strict';

  return {
    restrict: 'A',
    scope: true,
    compile: function () {
      return function linkFn(scope, iElement, iAttrs) {

        iAttrs.$observe('translateLanguage', function (newTranslateLanguage) {
          scope.translateLanguage = newTranslateLanguage;
        });

        scope.$watch('translateLanguage', function(){
          scope.$broadcast('translateLanguageChanged');
        });
      };
    }
  };
}

translateLanguageDirective.displayName = 'translateLanguageDirective';

angular.module('pascalprecht.translate')
/**
 * @ngdoc filter
 * @name pascalprecht.translate.filter:translate
 * @requires $parse
 * @requires pascalprecht.translate.$translate
 * @function
 *
 * @description
 * Uses `$translate` service to translate contents. Accepts interpolate parameters
 * to pass dynamized values though translation.
 *
 * @param {string} translationId A translation id to be translated.
 * @param {*=} interpolateParams Optional object literal (as hash or string) to pass values into translation.
 *
 * @returns {string} Translated text.
 *
 * @example
   <example module="ngView">
    <file name="index.html">
      <div ng-controller="TranslateCtrl">

        <pre>{{ 'TRANSLATION_ID' | translate }}</pre>
        <pre>{{ translationId | translate }}</pre>
        <pre>{{ 'WITH_VALUES' | translate:'{value: 5}' }}</pre>
        <pre>{{ 'WITH_VALUES' | translate:values }}</pre>

      </div>
    </file>
    <file name="script.js">
      angular.module('ngView', ['pascalprecht.translate'])

      .config(function ($translateProvider) {

        $translateProvider.translations('en', {
          'TRANSLATION_ID': 'Hello there!',
          'WITH_VALUES': 'The following value is dynamic: {{value}}'
        });
        $translateProvider.preferredLanguage('en');

      });

      angular.module('ngView').controller('TranslateCtrl', function ($scope) {
        $scope.translationId = 'TRANSLATION_ID';

        $scope.values = {
          value: 78
        };
      });
    </file>
   </example>
 */
.filter('translate', translateFilterFactory);

function translateFilterFactory($parse, $translate) {

  'use strict';

  var translateFilter = function (translationId, interpolateParams, interpolation, forceLanguage) {
    if (!angular.isObject(interpolateParams)) {
      var ctx = this || {
        '__SCOPE_IS_NOT_AVAILABLE': 'More info at https://github.com/angular/angular.js/commit/8863b9d04c722b278fa93c5d66ad1e578ad6eb1f'
        };
      interpolateParams = $parse(interpolateParams)(ctx);
    }

    return $translate.instant(translationId, interpolateParams, interpolation, forceLanguage);
  };

  if ($translate.statefulFilter()) {
    translateFilter.$stateful = true;
  }

  return translateFilter;
}

translateFilterFactory.displayName = 'translateFilterFactory';

angular.module('pascalprecht.translate')

/**
 * @ngdoc object
 * @name pascalprecht.translate.$translationCache
 * @requires $cacheFactory
 *
 * @description
 * The first time a translation table is used, it is loaded in the translation cache for quick retrieval. You
 * can load translation tables directly into the cache by consuming the
 * `$translationCache` service directly.
 *
 * @return {object} $cacheFactory object.
 */
  .factory('$translationCache', $translationCache);

function $translationCache($cacheFactory) {

  'use strict';

  return $cacheFactory('translations');
}

$translationCache.displayName = '$translationCache';
return 'pascalprecht.translate';

}));


/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var PLURAL_CATEGORY = { ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other" };
exports.default = {
    "DATETIME_FORMATS": {
        "AMPMS": ["\u4E0A\u5348", "\u4E0B\u5348"],
        "DAY": ["\u661F\u671F\u65E5", "\u661F\u671F\u4E00", "\u661F\u671F\u4E8C", "\u661F\u671F\u4E09", "\u661F\u671F\u56DB", "\u661F\u671F\u4E94", "\u661F\u671F\u516D"],
        "ERANAMES": ["\u516C\u5143\u524D", "\u516C\u5143"],
        "ERAS": ["\u516C\u5143\u524D", "\u516C\u5143"],
        "FIRSTDAYOFWEEK": 6,
        "MONTH": ["\u4E00\u6708", "\u4E8C\u6708", "\u4E09\u6708", "\u56DB\u6708", "\u4E94\u6708", "\u516D\u6708", "\u4E03\u6708", "\u516B\u6708", "\u4E5D\u6708", "\u5341\u6708", "\u5341\u4E00\u6708", "\u5341\u4E8C\u6708"],
        "SHORTDAY": ["\u5468\u65E5", "\u5468\u4E00", "\u5468\u4E8C", "\u5468\u4E09", "\u5468\u56DB", "\u5468\u4E94", "\u5468\u516D"],
        "SHORTMONTH": ["1\u6708", "2\u6708", "3\u6708", "4\u6708", "5\u6708", "6\u6708", "7\u6708", "8\u6708", "9\u6708", "10\u6708", "11\u6708", "12\u6708"],
        "STANDALONEMONTH": ["\u4E00\u6708", "\u4E8C\u6708", "\u4E09\u6708", "\u56DB\u6708", "\u4E94\u6708", "\u516D\u6708", "\u4E03\u6708", "\u516B\u6708", "\u4E5D\u6708", "\u5341\u6708", "\u5341\u4E00\u6708", "\u5341\u4E8C\u6708"],
        "WEEKENDRANGE": [5, 6],
        "fullDate": "y\u5E74M\u6708d\u65E5EEEE",
        "longDate": "y\u5E74M\u6708d\u65E5",
        "medium": "y\u5E74M\u6708d\u65E5 ah:mm:ss",
        "mediumDate": "y\u5E74M\u6708d\u65E5",
        "mediumTime": "ah:mm:ss",
        "short": "y/M/d ah:mm",
        "shortDate": "y/M/d",
        "shortTime": "ah:mm"
    },
    "NUMBER_FORMATS": {
        "CURRENCY_SYM": "\xA5",
        "DECIMAL_SEP": ".",
        "GROUP_SEP": ",",
        "PATTERNS": [{
            "gSize": 3,
            "lgSize": 3,
            "maxFrac": 3,
            "minFrac": 0,
            "minInt": 1,
            "negPre": "-",
            "negSuf": "",
            "posPre": "",
            "posSuf": ""
        }, {
            "gSize": 3,
            "lgSize": 3,
            "maxFrac": 2,
            "minFrac": 2,
            "minInt": 1,
            "negPre": "-\xA4",
            "negSuf": "",
            "posPre": "\xA4",
            "posSuf": ""
        }]
    },
    "id": "zh-cn",
    "localeID": "zh_CN",
    "pluralCat": function pluralCat(n, opt_precision) {
        return PLURAL_CATEGORY.OTHER;
    }
};

/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1244);
module.exports = 'ngSanitize';


/***/ }),
/* 1244 */
/***/ (function(module, exports) {

/**
 * @license AngularJS v1.5.8
 * (c) 2010-2016 Google, Inc. http://angularjs.org
 * License: MIT
 */
(function(window, angular) {'use strict';

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *     Any commits to this file should be reviewed with security in mind.  *
 *   Changes to this file can potentially create security vulnerabilities. *
 *          An approval from 2 Core members with history of modifying      *
 *                         this file is required.                          *
 *                                                                         *
 *  Does the change somehow allow for arbitrary javascript to be executed? *
 *    Or allows for someone to change the prototype of built-in objects?   *
 *     Or gives undesired access to variables likes document or window?    *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

var $sanitizeMinErr = angular.$$minErr('$sanitize');
var bind;
var extend;
var forEach;
var isDefined;
var lowercase;
var noop;
var htmlParser;
var htmlSanitizeWriter;

/**
 * @ngdoc module
 * @name ngSanitize
 * @description
 *
 * # ngSanitize
 *
 * The `ngSanitize` module provides functionality to sanitize HTML.
 *
 *
 * <div doc-module-components="ngSanitize"></div>
 *
 * See {@link ngSanitize.$sanitize `$sanitize`} for usage.
 */

/**
 * @ngdoc service
 * @name $sanitize
 * @kind function
 *
 * @description
 *   Sanitizes an html string by stripping all potentially dangerous tokens.
 *
 *   The input is sanitized by parsing the HTML into tokens. All safe tokens (from a whitelist) are
 *   then serialized back to properly escaped html string. This means that no unsafe input can make
 *   it into the returned string.
 *
 *   The whitelist for URL sanitization of attribute values is configured using the functions
 *   `aHrefSanitizationWhitelist` and `imgSrcSanitizationWhitelist` of {@link ng.$compileProvider
 *   `$compileProvider`}.
 *
 *   The input may also contain SVG markup if this is enabled via {@link $sanitizeProvider}.
 *
 * @param {string} html HTML input.
 * @returns {string} Sanitized HTML.
 *
 * @example
   <example module="sanitizeExample" deps="angular-sanitize.js">
   <file name="index.html">
     <script>
         angular.module('sanitizeExample', ['ngSanitize'])
           .controller('ExampleController', ['$scope', '$sce', function($scope, $sce) {
             $scope.snippet =
               '<p style="color:blue">an html\n' +
               '<em onmouseover="this.textContent=\'PWN3D!\'">click here</em>\n' +
               'snippet</p>';
             $scope.deliberatelyTrustDangerousSnippet = function() {
               return $sce.trustAsHtml($scope.snippet);
             };
           }]);
     </script>
     <div ng-controller="ExampleController">
        Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
       <table>
         <tr>
           <td>Directive</td>
           <td>How</td>
           <td>Source</td>
           <td>Rendered</td>
         </tr>
         <tr id="bind-html-with-sanitize">
           <td>ng-bind-html</td>
           <td>Automatically uses $sanitize</td>
           <td><pre>&lt;div ng-bind-html="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
           <td><div ng-bind-html="snippet"></div></td>
         </tr>
         <tr id="bind-html-with-trust">
           <td>ng-bind-html</td>
           <td>Bypass $sanitize by explicitly trusting the dangerous value</td>
           <td>
           <pre>&lt;div ng-bind-html="deliberatelyTrustDangerousSnippet()"&gt;
&lt;/div&gt;</pre>
           </td>
           <td><div ng-bind-html="deliberatelyTrustDangerousSnippet()"></div></td>
         </tr>
         <tr id="bind-default">
           <td>ng-bind</td>
           <td>Automatically escapes</td>
           <td><pre>&lt;div ng-bind="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
           <td><div ng-bind="snippet"></div></td>
         </tr>
       </table>
       </div>
   </file>
   <file name="protractor.js" type="protractor">
     it('should sanitize the html snippet by default', function() {
       expect(element(by.css('#bind-html-with-sanitize div')).getInnerHtml()).
         toBe('<p>an html\n<em>click here</em>\nsnippet</p>');
     });

     it('should inline raw snippet if bound to a trusted value', function() {
       expect(element(by.css('#bind-html-with-trust div')).getInnerHtml()).
         toBe("<p style=\"color:blue\">an html\n" +
              "<em onmouseover=\"this.textContent='PWN3D!'\">click here</em>\n" +
              "snippet</p>");
     });

     it('should escape snippet without any filter', function() {
       expect(element(by.css('#bind-default div')).getInnerHtml()).
         toBe("&lt;p style=\"color:blue\"&gt;an html\n" +
              "&lt;em onmouseover=\"this.textContent='PWN3D!'\"&gt;click here&lt;/em&gt;\n" +
              "snippet&lt;/p&gt;");
     });

     it('should update', function() {
       element(by.model('snippet')).clear();
       element(by.model('snippet')).sendKeys('new <b onclick="alert(1)">text</b>');
       expect(element(by.css('#bind-html-with-sanitize div')).getInnerHtml()).
         toBe('new <b>text</b>');
       expect(element(by.css('#bind-html-with-trust div')).getInnerHtml()).toBe(
         'new <b onclick="alert(1)">text</b>');
       expect(element(by.css('#bind-default div')).getInnerHtml()).toBe(
         "new &lt;b onclick=\"alert(1)\"&gt;text&lt;/b&gt;");
     });
   </file>
   </example>
 */


/**
 * @ngdoc provider
 * @name $sanitizeProvider
 *
 * @description
 * Creates and configures {@link $sanitize} instance.
 */
function $SanitizeProvider() {
  var svgEnabled = false;

  this.$get = ['$$sanitizeUri', function($$sanitizeUri) {
    if (svgEnabled) {
      extend(validElements, svgElements);
    }
    return function(html) {
      var buf = [];
      htmlParser(html, htmlSanitizeWriter(buf, function(uri, isImage) {
        return !/^unsafe:/.test($$sanitizeUri(uri, isImage));
      }));
      return buf.join('');
    };
  }];


  /**
   * @ngdoc method
   * @name $sanitizeProvider#enableSvg
   * @kind function
   *
   * @description
   * Enables a subset of svg to be supported by the sanitizer.
   *
   * <div class="alert alert-warning">
   *   <p>By enabling this setting without taking other precautions, you might expose your
   *   application to click-hijacking attacks. In these attacks, sanitized svg elements could be positioned
   *   outside of the containing element and be rendered over other elements on the page (e.g. a login
   *   link). Such behavior can then result in phishing incidents.</p>
   *
   *   <p>To protect against these, explicitly setup `overflow: hidden` css rule for all potential svg
   *   tags within the sanitized content:</p>
   *
   *   <br>
   *
   *   <pre><code>
   *   .rootOfTheIncludedContent svg {
   *     overflow: hidden !important;
   *   }
   *   </code></pre>
   * </div>
   *
   * @param {boolean=} flag Enable or disable SVG support in the sanitizer.
   * @returns {boolean|ng.$sanitizeProvider} Returns the currently configured value if called
   *    without an argument or self for chaining otherwise.
   */
  this.enableSvg = function(enableSvg) {
    if (isDefined(enableSvg)) {
      svgEnabled = enableSvg;
      return this;
    } else {
      return svgEnabled;
    }
  };

  //////////////////////////////////////////////////////////////////////////////////////////////////
  // Private stuff
  //////////////////////////////////////////////////////////////////////////////////////////////////

  bind = angular.bind;
  extend = angular.extend;
  forEach = angular.forEach;
  isDefined = angular.isDefined;
  lowercase = angular.lowercase;
  noop = angular.noop;

  htmlParser = htmlParserImpl;
  htmlSanitizeWriter = htmlSanitizeWriterImpl;

  // Regular Expressions for parsing tags and attributes
  var SURROGATE_PAIR_REGEXP = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g,
    // Match everything outside of normal chars and " (quote character)
    NON_ALPHANUMERIC_REGEXP = /([^\#-~ |!])/g;


  // Good source of info about elements and attributes
  // http://dev.w3.org/html5/spec/Overview.html#semantics
  // http://simon.html5.org/html-elements

  // Safe Void Elements - HTML5
  // http://dev.w3.org/html5/spec/Overview.html#void-elements
  var voidElements = toMap("area,br,col,hr,img,wbr");

  // Elements that you can, intentionally, leave open (and which close themselves)
  // http://dev.w3.org/html5/spec/Overview.html#optional-tags
  var optionalEndTagBlockElements = toMap("colgroup,dd,dt,li,p,tbody,td,tfoot,th,thead,tr"),
      optionalEndTagInlineElements = toMap("rp,rt"),
      optionalEndTagElements = extend({},
                                              optionalEndTagInlineElements,
                                              optionalEndTagBlockElements);

  // Safe Block Elements - HTML5
  var blockElements = extend({}, optionalEndTagBlockElements, toMap("address,article," +
          "aside,blockquote,caption,center,del,dir,div,dl,figure,figcaption,footer,h1,h2,h3,h4,h5," +
          "h6,header,hgroup,hr,ins,map,menu,nav,ol,pre,section,table,ul"));

  // Inline Elements - HTML5
  var inlineElements = extend({}, optionalEndTagInlineElements, toMap("a,abbr,acronym,b," +
          "bdi,bdo,big,br,cite,code,del,dfn,em,font,i,img,ins,kbd,label,map,mark,q,ruby,rp,rt,s," +
          "samp,small,span,strike,strong,sub,sup,time,tt,u,var"));

  // SVG Elements
  // https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Elements
  // Note: the elements animate,animateColor,animateMotion,animateTransform,set are intentionally omitted.
  // They can potentially allow for arbitrary javascript to be executed. See #11290
  var svgElements = toMap("circle,defs,desc,ellipse,font-face,font-face-name,font-face-src,g,glyph," +
          "hkern,image,linearGradient,line,marker,metadata,missing-glyph,mpath,path,polygon,polyline," +
          "radialGradient,rect,stop,svg,switch,text,title,tspan");

  // Blocked Elements (will be stripped)
  var blockedElements = toMap("script,style");

  var validElements = extend({},
                                     voidElements,
                                     blockElements,
                                     inlineElements,
                                     optionalEndTagElements);

  //Attributes that have href and hence need to be sanitized
  var uriAttrs = toMap("background,cite,href,longdesc,src,xlink:href");

  var htmlAttrs = toMap('abbr,align,alt,axis,bgcolor,border,cellpadding,cellspacing,class,clear,' +
      'color,cols,colspan,compact,coords,dir,face,headers,height,hreflang,hspace,' +
      'ismap,lang,language,nohref,nowrap,rel,rev,rows,rowspan,rules,' +
      'scope,scrolling,shape,size,span,start,summary,tabindex,target,title,type,' +
      'valign,value,vspace,width');

  // SVG attributes (without "id" and "name" attributes)
  // https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Attributes
  var svgAttrs = toMap('accent-height,accumulate,additive,alphabetic,arabic-form,ascent,' +
      'baseProfile,bbox,begin,by,calcMode,cap-height,class,color,color-rendering,content,' +
      'cx,cy,d,dx,dy,descent,display,dur,end,fill,fill-rule,font-family,font-size,font-stretch,' +
      'font-style,font-variant,font-weight,from,fx,fy,g1,g2,glyph-name,gradientUnits,hanging,' +
      'height,horiz-adv-x,horiz-origin-x,ideographic,k,keyPoints,keySplines,keyTimes,lang,' +
      'marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mathematical,' +
      'max,min,offset,opacity,orient,origin,overline-position,overline-thickness,panose-1,' +
      'path,pathLength,points,preserveAspectRatio,r,refX,refY,repeatCount,repeatDur,' +
      'requiredExtensions,requiredFeatures,restart,rotate,rx,ry,slope,stemh,stemv,stop-color,' +
      'stop-opacity,strikethrough-position,strikethrough-thickness,stroke,stroke-dasharray,' +
      'stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,' +
      'stroke-width,systemLanguage,target,text-anchor,to,transform,type,u1,u2,underline-position,' +
      'underline-thickness,unicode,unicode-range,units-per-em,values,version,viewBox,visibility,' +
      'width,widths,x,x-height,x1,x2,xlink:actuate,xlink:arcrole,xlink:role,xlink:show,xlink:title,' +
      'xlink:type,xml:base,xml:lang,xml:space,xmlns,xmlns:xlink,y,y1,y2,zoomAndPan', true);

  var validAttrs = extend({},
                                  uriAttrs,
                                  svgAttrs,
                                  htmlAttrs);

  function toMap(str, lowercaseKeys) {
    var obj = {}, items = str.split(','), i;
    for (i = 0; i < items.length; i++) {
      obj[lowercaseKeys ? lowercase(items[i]) : items[i]] = true;
    }
    return obj;
  }

  var inertBodyElement;
  (function(window) {
    var doc;
    if (window.document && window.document.implementation) {
      doc = window.document.implementation.createHTMLDocument("inert");
    } else {
      throw $sanitizeMinErr('noinert', "Can't create an inert html document");
    }
    var docElement = doc.documentElement || doc.getDocumentElement();
    var bodyElements = docElement.getElementsByTagName('body');

    // usually there should be only one body element in the document, but IE doesn't have any, so we need to create one
    if (bodyElements.length === 1) {
      inertBodyElement = bodyElements[0];
    } else {
      var html = doc.createElement('html');
      inertBodyElement = doc.createElement('body');
      html.appendChild(inertBodyElement);
      doc.appendChild(html);
    }
  })(window);

  /**
   * @example
   * htmlParser(htmlString, {
   *     start: function(tag, attrs) {},
   *     end: function(tag) {},
   *     chars: function(text) {},
   *     comment: function(text) {}
   * });
   *
   * @param {string} html string
   * @param {object} handler
   */
  function htmlParserImpl(html, handler) {
    if (html === null || html === undefined) {
      html = '';
    } else if (typeof html !== 'string') {
      html = '' + html;
    }
    inertBodyElement.innerHTML = html;

    //mXSS protection
    var mXSSAttempts = 5;
    do {
      if (mXSSAttempts === 0) {
        throw $sanitizeMinErr('uinput', "Failed to sanitize html because the input is unstable");
      }
      mXSSAttempts--;

      // strip custom-namespaced attributes on IE<=11
      if (window.document.documentMode) {
        stripCustomNsAttrs(inertBodyElement);
      }
      html = inertBodyElement.innerHTML; //trigger mXSS
      inertBodyElement.innerHTML = html;
    } while (html !== inertBodyElement.innerHTML);

    var node = inertBodyElement.firstChild;
    while (node) {
      switch (node.nodeType) {
        case 1: // ELEMENT_NODE
          handler.start(node.nodeName.toLowerCase(), attrToMap(node.attributes));
          break;
        case 3: // TEXT NODE
          handler.chars(node.textContent);
          break;
      }

      var nextNode;
      if (!(nextNode = node.firstChild)) {
      if (node.nodeType == 1) {
          handler.end(node.nodeName.toLowerCase());
        }
        nextNode = node.nextSibling;
        if (!nextNode) {
          while (nextNode == null) {
            node = node.parentNode;
            if (node === inertBodyElement) break;
            nextNode = node.nextSibling;
          if (node.nodeType == 1) {
              handler.end(node.nodeName.toLowerCase());
            }
          }
        }
      }
      node = nextNode;
    }

    while (node = inertBodyElement.firstChild) {
      inertBodyElement.removeChild(node);
    }
  }

  function attrToMap(attrs) {
    var map = {};
    for (var i = 0, ii = attrs.length; i < ii; i++) {
      var attr = attrs[i];
      map[attr.name] = attr.value;
    }
    return map;
  }


  /**
   * Escapes all potentially dangerous characters, so that the
   * resulting string can be safely inserted into attribute or
   * element text.
   * @param value
   * @returns {string} escaped text
   */
  function encodeEntities(value) {
    return value.
      replace(/&/g, '&amp;').
      replace(SURROGATE_PAIR_REGEXP, function(value) {
        var hi = value.charCodeAt(0);
        var low = value.charCodeAt(1);
        return '&#' + (((hi - 0xD800) * 0x400) + (low - 0xDC00) + 0x10000) + ';';
      }).
      replace(NON_ALPHANUMERIC_REGEXP, function(value) {
        return '&#' + value.charCodeAt(0) + ';';
      }).
      replace(/</g, '&lt;').
      replace(/>/g, '&gt;');
  }

  /**
   * create an HTML/XML writer which writes to buffer
   * @param {Array} buf use buf.join('') to get out sanitized html string
   * @returns {object} in the form of {
   *     start: function(tag, attrs) {},
   *     end: function(tag) {},
   *     chars: function(text) {},
   *     comment: function(text) {}
   * }
   */
  function htmlSanitizeWriterImpl(buf, uriValidator) {
    var ignoreCurrentElement = false;
    var out = bind(buf, buf.push);
    return {
      start: function(tag, attrs) {
        tag = lowercase(tag);
        if (!ignoreCurrentElement && blockedElements[tag]) {
          ignoreCurrentElement = tag;
        }
        if (!ignoreCurrentElement && validElements[tag] === true) {
          out('<');
          out(tag);
          forEach(attrs, function(value, key) {
            var lkey = lowercase(key);
            var isImage = (tag === 'img' && lkey === 'src') || (lkey === 'background');
            if (validAttrs[lkey] === true &&
              (uriAttrs[lkey] !== true || uriValidator(value, isImage))) {
              out(' ');
              out(key);
              out('="');
              out(encodeEntities(value));
              out('"');
            }
          });
          out('>');
        }
      },
      end: function(tag) {
        tag = lowercase(tag);
        if (!ignoreCurrentElement && validElements[tag] === true && voidElements[tag] !== true) {
          out('</');
          out(tag);
          out('>');
        }
        if (tag == ignoreCurrentElement) {
          ignoreCurrentElement = false;
        }
      },
      chars: function(chars) {
        if (!ignoreCurrentElement) {
          out(encodeEntities(chars));
        }
      }
    };
  }


  /**
   * When IE9-11 comes across an unknown namespaced attribute e.g. 'xlink:foo' it adds 'xmlns:ns1' attribute to declare
   * ns1 namespace and prefixes the attribute with 'ns1' (e.g. 'ns1:xlink:foo'). This is undesirable since we don't want
   * to allow any of these custom attributes. This method strips them all.
   *
   * @param node Root element to process
   */
  function stripCustomNsAttrs(node) {
    if (node.nodeType === window.Node.ELEMENT_NODE) {
      var attrs = node.attributes;
      for (var i = 0, l = attrs.length; i < l; i++) {
        var attrNode = attrs[i];
        var attrName = attrNode.name.toLowerCase();
        if (attrName === 'xmlns:ns1' || attrName.lastIndexOf('ns1:', 0) === 0) {
          node.removeAttributeNode(attrNode);
          i--;
          l--;
        }
      }
    }

    var nextNode = node.firstChild;
    if (nextNode) {
      stripCustomNsAttrs(nextNode);
    }

    nextNode = node.nextSibling;
    if (nextNode) {
      stripCustomNsAttrs(nextNode);
    }
  }
}

function sanitizeText(chars) {
  var buf = [];
  var writer = htmlSanitizeWriter(buf, noop);
  writer.chars(chars);
  return buf.join('');
}


// define ngSanitize module and register $sanitize service
angular.module('ngSanitize', []).provider('$sanitize', $SanitizeProvider);

/**
 * @ngdoc filter
 * @name linky
 * @kind function
 *
 * @description
 * Finds links in text input and turns them into html links. Supports `http/https/ftp/mailto` and
 * plain email address links.
 *
 * Requires the {@link ngSanitize `ngSanitize`} module to be installed.
 *
 * @param {string} text Input text.
 * @param {string} target Window (`_blank|_self|_parent|_top`) or named frame to open links in.
 * @param {object|function(url)} [attributes] Add custom attributes to the link element.
 *
 *    Can be one of:
 *
 *    - `object`: A map of attributes
 *    - `function`: Takes the url as a parameter and returns a map of attributes
 *
 *    If the map of attributes contains a value for `target`, it overrides the value of
 *    the target parameter.
 *
 *
 * @returns {string} Html-linkified and {@link $sanitize sanitized} text.
 *
 * @usage
   <span ng-bind-html="linky_expression | linky"></span>
 *
 * @example
   <example module="linkyExample" deps="angular-sanitize.js">
     <file name="index.html">
       <div ng-controller="ExampleController">
       Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
       <table>
         <tr>
           <th>Filter</th>
           <th>Source</th>
           <th>Rendered</th>
         </tr>
         <tr id="linky-filter">
           <td>linky filter</td>
           <td>
             <pre>&lt;div ng-bind-html="snippet | linky"&gt;<br>&lt;/div&gt;</pre>
           </td>
           <td>
             <div ng-bind-html="snippet | linky"></div>
           </td>
         </tr>
         <tr id="linky-target">
          <td>linky target</td>
          <td>
            <pre>&lt;div ng-bind-html="snippetWithSingleURL | linky:'_blank'"&gt;<br>&lt;/div&gt;</pre>
          </td>
          <td>
            <div ng-bind-html="snippetWithSingleURL | linky:'_blank'"></div>
          </td>
         </tr>
         <tr id="linky-custom-attributes">
          <td>linky custom attributes</td>
          <td>
            <pre>&lt;div ng-bind-html="snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}"&gt;<br>&lt;/div&gt;</pre>
          </td>
          <td>
            <div ng-bind-html="snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}"></div>
          </td>
         </tr>
         <tr id="escaped-html">
           <td>no filter</td>
           <td><pre>&lt;div ng-bind="snippet"&gt;<br>&lt;/div&gt;</pre></td>
           <td><div ng-bind="snippet"></div></td>
         </tr>
       </table>
     </file>
     <file name="script.js">
       angular.module('linkyExample', ['ngSanitize'])
         .controller('ExampleController', ['$scope', function($scope) {
           $scope.snippet =
             'Pretty text with some links:\n'+
             'http://angularjs.org/,\n'+
             'mailto:us@somewhere.org,\n'+
             'another@somewhere.org,\n'+
             'and one more: ftp://127.0.0.1/.';
           $scope.snippetWithSingleURL = 'http://angularjs.org/';
         }]);
     </file>
     <file name="protractor.js" type="protractor">
       it('should linkify the snippet with urls', function() {
         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
             toBe('Pretty text with some links: http://angularjs.org/, us@somewhere.org, ' +
                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
         expect(element.all(by.css('#linky-filter a')).count()).toEqual(4);
       });

       it('should not linkify snippet without the linky filter', function() {
         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText()).
             toBe('Pretty text with some links: http://angularjs.org/, mailto:us@somewhere.org, ' +
                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
         expect(element.all(by.css('#escaped-html a')).count()).toEqual(0);
       });

       it('should update', function() {
         element(by.model('snippet')).clear();
         element(by.model('snippet')).sendKeys('new http://link.');
         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
             toBe('new http://link.');
         expect(element.all(by.css('#linky-filter a')).count()).toEqual(1);
         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText())
             .toBe('new http://link.');
       });

       it('should work with the target property', function() {
        expect(element(by.id('linky-target')).
            element(by.binding("snippetWithSingleURL | linky:'_blank'")).getText()).
            toBe('http://angularjs.org/');
        expect(element(by.css('#linky-target a')).getAttribute('target')).toEqual('_blank');
       });

       it('should optionally add custom attributes', function() {
        expect(element(by.id('linky-custom-attributes')).
            element(by.binding("snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}")).getText()).
            toBe('http://angularjs.org/');
        expect(element(by.css('#linky-custom-attributes a')).getAttribute('rel')).toEqual('nofollow');
       });
     </file>
   </example>
 */
angular.module('ngSanitize').filter('linky', ['$sanitize', function($sanitize) {
  var LINKY_URL_REGEXP =
        /((ftp|https?):\/\/|(www\.)|(mailto:)?[A-Za-z0-9._%+-]+@)\S*[^\s.;,(){}<>"\u201d\u2019]/i,
      MAILTO_REGEXP = /^mailto:/i;

  var linkyMinErr = angular.$$minErr('linky');
  var isDefined = angular.isDefined;
  var isFunction = angular.isFunction;
  var isObject = angular.isObject;
  var isString = angular.isString;

  return function(text, target, attributes) {
    if (text == null || text === '') return text;
    if (!isString(text)) throw linkyMinErr('notstring', 'Expected string but received: {0}', text);

    var attributesFn =
      isFunction(attributes) ? attributes :
      isObject(attributes) ? function getAttributesObject() {return attributes;} :
      function getEmptyAttributesObject() {return {};};

    var match;
    var raw = text;
    var html = [];
    var url;
    var i;
    while ((match = raw.match(LINKY_URL_REGEXP))) {
      // We can not end in these as they are sometimes found at the end of the sentence
      url = match[0];
      // if we did not match ftp/http/www/mailto then assume mailto
      if (!match[2] && !match[4]) {
        url = (match[3] ? 'http://' : 'mailto:') + url;
      }
      i = match.index;
      addText(raw.substr(0, i));
      addLink(url, match[0].replace(MAILTO_REGEXP, ''));
      raw = raw.substring(i + match[0].length);
    }
    addText(raw);
    return $sanitize(html.join(''));

    function addText(text) {
      if (!text) {
        return;
      }
      html.push(sanitizeText(text));
    }

    function addLink(url, text) {
      var key, linkAttributes = attributesFn(url);
      html.push('<a ');

      for (key in linkAttributes) {
        html.push(key + '="' + linkAttributes[key] + '" ');
      }

      if (isDefined(target) && !('target' in linkAttributes)) {
        html.push('target="',
                  target,
                  '" ');
      }
      html.push('href="',
                url.replace(/"/g, '&quot;'),
                '">');
      addText(text);
      html.push('</a>');
    }
  };
}]);


})(window, window.angular);


/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1246);
module.exports = __webpack_require__(1248);


/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1247);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js!./position.css", function() {
			var newContent = require("!!../../../css-loader/index.js!./position.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".uib-position-measure {\n  display: block !important;\n  visibility: hidden !important;\n  position: absolute !important;\n  top: -9999px !important;\n  left: -9999px !important;\n}\n\n.uib-position-scrollbar-measure {\n  position: absolute !important;\n  top: -9999px !important;\n  width: 50px !important;\n  height: 50px !important;\n  overflow: scroll !important;\n}\n\n.uib-position-body-scrollbar-measure {\n  overflow: scroll !important;\n}", ""]);

// exports


/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1249);
__webpack_require__(1251);
__webpack_require__(1253);
__webpack_require__(1255);
__webpack_require__(1256);

var MODULE_NAME = 'ui.bootstrap.module.modal';

angular.module(MODULE_NAME, ['ui.bootstrap.modal', 'uib/template/modal/window.html']);

module.exports = MODULE_NAME;


/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1250);


/***/ }),
/* 1250 */
/***/ (function(module, exports) {

angular.module('ui.bootstrap.multiMap', [])
/**
 * A helper, internal data structure that stores all references attached to key
 */
  .factory('$$multiMap', function() {
    return {
      createNew: function() {
        var map = {};

        return {
          entries: function() {
            return Object.keys(map).map(function(key) {
              return {
                key: key,
                value: map[key]
              };
            });
          },
          get: function(key) {
            return map[key];
          },
          hasKey: function(key) {
            return !!map[key];
          },
          keys: function() {
            return Object.keys(map);
          },
          put: function(key, value) {
            if (!map[key]) {
              map[key] = [];
            }

            map[key].push(value);
          },
          remove: function(key, value) {
            var values = map[key];

            if (!values) {
              return;
            }

            var idx = values.indexOf(value);

            if (idx !== -1) {
              values.splice(idx, 1);
            }

            if (!values.length) {
              delete map[key];
            }
          }
        };
      }
    };
  });


/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1252);

var MODULE_NAME = 'ui.bootstrap.module.position';

angular.module(MODULE_NAME, ['ui.bootstrap.position']);

module.exports = MODULE_NAME;


/***/ }),
/* 1252 */
/***/ (function(module, exports) {

angular.module('ui.bootstrap.position', [])

/**
 * A set of utility methods for working with the DOM.
 * It is meant to be used where we need to absolute-position elements in
 * relation to another element (this is the case for tooltips, popovers,
 * typeahead suggestions etc.).
 */
  .factory('$uibPosition', ['$document', '$window', function($document, $window) {
    /**
     * Used by scrollbarWidth() function to cache scrollbar's width.
     * Do not access this variable directly, use scrollbarWidth() instead.
     */
    var SCROLLBAR_WIDTH;
    /**
     * scrollbar on body and html element in IE and Edge overlay
     * content and should be considered 0 width.
     */
    var BODY_SCROLLBAR_WIDTH;
    var OVERFLOW_REGEX = {
      normal: /(auto|scroll)/,
      hidden: /(auto|scroll|hidden)/
    };
    var PLACEMENT_REGEX = {
      auto: /\s?auto?\s?/i,
      primary: /^(top|bottom|left|right)$/,
      secondary: /^(top|bottom|left|right|center)$/,
      vertical: /^(top|bottom)$/
    };
    var BODY_REGEX = /(HTML|BODY)/;

    return {

      /**
       * Provides a raw DOM element from a jQuery/jQLite element.
       *
       * @param {element} elem - The element to convert.
       *
       * @returns {element} A HTML element.
       */
      getRawNode: function(elem) {
        return elem.nodeName ? elem : elem[0] || elem;
      },

      /**
       * Provides a parsed number for a style property.  Strips
       * units and casts invalid numbers to 0.
       *
       * @param {string} value - The style value to parse.
       *
       * @returns {number} A valid number.
       */
      parseStyle: function(value) {
        value = parseFloat(value);
        return isFinite(value) ? value : 0;
      },

      /**
       * Provides the closest positioned ancestor.
       *
       * @param {element} element - The element to get the offest parent for.
       *
       * @returns {element} The closest positioned ancestor.
       */
      offsetParent: function(elem) {
        elem = this.getRawNode(elem);

        var offsetParent = elem.offsetParent || $document[0].documentElement;

        function isStaticPositioned(el) {
          return ($window.getComputedStyle(el).position || 'static') === 'static';
        }

        while (offsetParent && offsetParent !== $document[0].documentElement && isStaticPositioned(offsetParent)) {
          offsetParent = offsetParent.offsetParent;
        }

        return offsetParent || $document[0].documentElement;
      },

      /**
       * Provides the scrollbar width, concept from TWBS measureScrollbar()
       * function in https://github.com/twbs/bootstrap/blob/master/js/modal.js
       * In IE and Edge, scollbar on body and html element overlay and should
       * return a width of 0.
       *
       * @returns {number} The width of the browser scollbar.
       */
      scrollbarWidth: function(isBody) {
        if (isBody) {
          if (angular.isUndefined(BODY_SCROLLBAR_WIDTH)) {
            var bodyElem = $document.find('body');
            bodyElem.addClass('uib-position-body-scrollbar-measure');
            BODY_SCROLLBAR_WIDTH = $window.innerWidth - bodyElem[0].clientWidth;
            BODY_SCROLLBAR_WIDTH = isFinite(BODY_SCROLLBAR_WIDTH) ? BODY_SCROLLBAR_WIDTH : 0;
            bodyElem.removeClass('uib-position-body-scrollbar-measure');
          }
          return BODY_SCROLLBAR_WIDTH;
        }

        if (angular.isUndefined(SCROLLBAR_WIDTH)) {
          var scrollElem = angular.element('<div class="uib-position-scrollbar-measure"></div>');
          $document.find('body').append(scrollElem);
          SCROLLBAR_WIDTH = scrollElem[0].offsetWidth - scrollElem[0].clientWidth;
          SCROLLBAR_WIDTH = isFinite(SCROLLBAR_WIDTH) ? SCROLLBAR_WIDTH : 0;
          scrollElem.remove();
        }

        return SCROLLBAR_WIDTH;
      },

      /**
       * Provides the padding required on an element to replace the scrollbar.
       *
       * @returns {object} An object with the following properties:
       *   <ul>
       *     <li>**scrollbarWidth**: the width of the scrollbar</li>
       *     <li>**widthOverflow**: whether the the width is overflowing</li>
       *     <li>**right**: the amount of right padding on the element needed to replace the scrollbar</li>
       *     <li>**rightOriginal**: the amount of right padding currently on the element</li>
       *     <li>**heightOverflow**: whether the the height is overflowing</li>
       *     <li>**bottom**: the amount of bottom padding on the element needed to replace the scrollbar</li>
       *     <li>**bottomOriginal**: the amount of bottom padding currently on the element</li>
       *   </ul>
       */
      scrollbarPadding: function(elem) {
        elem = this.getRawNode(elem);

        var elemStyle = $window.getComputedStyle(elem);
        var paddingRight = this.parseStyle(elemStyle.paddingRight);
        var paddingBottom = this.parseStyle(elemStyle.paddingBottom);
        var scrollParent = this.scrollParent(elem, false, true);
        var scrollbarWidth = this.scrollbarWidth(BODY_REGEX.test(scrollParent.tagName));

        return {
          scrollbarWidth: scrollbarWidth,
          widthOverflow: scrollParent.scrollWidth > scrollParent.clientWidth,
          right: paddingRight + scrollbarWidth,
          originalRight: paddingRight,
          heightOverflow: scrollParent.scrollHeight > scrollParent.clientHeight,
          bottom: paddingBottom + scrollbarWidth,
          originalBottom: paddingBottom
         };
      },

      /**
       * Checks to see if the element is scrollable.
       *
       * @param {element} elem - The element to check.
       * @param {boolean=} [includeHidden=false] - Should scroll style of 'hidden' be considered,
       *   default is false.
       *
       * @returns {boolean} Whether the element is scrollable.
       */
      isScrollable: function(elem, includeHidden) {
        elem = this.getRawNode(elem);

        var overflowRegex = includeHidden ? OVERFLOW_REGEX.hidden : OVERFLOW_REGEX.normal;
        var elemStyle = $window.getComputedStyle(elem);
        return overflowRegex.test(elemStyle.overflow + elemStyle.overflowY + elemStyle.overflowX);
      },

      /**
       * Provides the closest scrollable ancestor.
       * A port of the jQuery UI scrollParent method:
       * https://github.com/jquery/jquery-ui/blob/master/ui/scroll-parent.js
       *
       * @param {element} elem - The element to find the scroll parent of.
       * @param {boolean=} [includeHidden=false] - Should scroll style of 'hidden' be considered,
       *   default is false.
       * @param {boolean=} [includeSelf=false] - Should the element being passed be
       * included in the scrollable llokup.
       *
       * @returns {element} A HTML element.
       */
      scrollParent: function(elem, includeHidden, includeSelf) {
        elem = this.getRawNode(elem);

        var overflowRegex = includeHidden ? OVERFLOW_REGEX.hidden : OVERFLOW_REGEX.normal;
        var documentEl = $document[0].documentElement;
        var elemStyle = $window.getComputedStyle(elem);
        if (includeSelf && overflowRegex.test(elemStyle.overflow + elemStyle.overflowY + elemStyle.overflowX)) {
          return elem;
        }
        var excludeStatic = elemStyle.position === 'absolute';
        var scrollParent = elem.parentElement || documentEl;

        if (scrollParent === documentEl || elemStyle.position === 'fixed') {
          return documentEl;
        }

        while (scrollParent.parentElement && scrollParent !== documentEl) {
          var spStyle = $window.getComputedStyle(scrollParent);
          if (excludeStatic && spStyle.position !== 'static') {
            excludeStatic = false;
          }

          if (!excludeStatic && overflowRegex.test(spStyle.overflow + spStyle.overflowY + spStyle.overflowX)) {
            break;
          }
          scrollParent = scrollParent.parentElement;
        }

        return scrollParent;
      },

      /**
       * Provides read-only equivalent of jQuery's position function:
       * http://api.jquery.com/position/ - distance to closest positioned
       * ancestor.  Does not account for margins by default like jQuery position.
       *
       * @param {element} elem - The element to caclulate the position on.
       * @param {boolean=} [includeMargins=false] - Should margins be accounted
       * for, default is false.
       *
       * @returns {object} An object with the following properties:
       *   <ul>
       *     <li>**width**: the width of the element</li>
       *     <li>**height**: the height of the element</li>
       *     <li>**top**: distance to top edge of offset parent</li>
       *     <li>**left**: distance to left edge of offset parent</li>
       *   </ul>
       */
      position: function(elem, includeMagins) {
        elem = this.getRawNode(elem);

        var elemOffset = this.offset(elem);
        if (includeMagins) {
          var elemStyle = $window.getComputedStyle(elem);
          elemOffset.top -= this.parseStyle(elemStyle.marginTop);
          elemOffset.left -= this.parseStyle(elemStyle.marginLeft);
        }
        var parent = this.offsetParent(elem);
        var parentOffset = {top: 0, left: 0};

        if (parent !== $document[0].documentElement) {
          parentOffset = this.offset(parent);
          parentOffset.top += parent.clientTop - parent.scrollTop;
          parentOffset.left += parent.clientLeft - parent.scrollLeft;
        }

        return {
          width: Math.round(angular.isNumber(elemOffset.width) ? elemOffset.width : elem.offsetWidth),
          height: Math.round(angular.isNumber(elemOffset.height) ? elemOffset.height : elem.offsetHeight),
          top: Math.round(elemOffset.top - parentOffset.top),
          left: Math.round(elemOffset.left - parentOffset.left)
        };
      },

      /**
       * Provides read-only equivalent of jQuery's offset function:
       * http://api.jquery.com/offset/ - distance to viewport.  Does
       * not account for borders, margins, or padding on the body
       * element.
       *
       * @param {element} elem - The element to calculate the offset on.
       *
       * @returns {object} An object with the following properties:
       *   <ul>
       *     <li>**width**: the width of the element</li>
       *     <li>**height**: the height of the element</li>
       *     <li>**top**: distance to top edge of viewport</li>
       *     <li>**right**: distance to bottom edge of viewport</li>
       *   </ul>
       */
      offset: function(elem) {
        elem = this.getRawNode(elem);

        var elemBCR = elem.getBoundingClientRect();
        return {
          width: Math.round(angular.isNumber(elemBCR.width) ? elemBCR.width : elem.offsetWidth),
          height: Math.round(angular.isNumber(elemBCR.height) ? elemBCR.height : elem.offsetHeight),
          top: Math.round(elemBCR.top + ($window.pageYOffset || $document[0].documentElement.scrollTop)),
          left: Math.round(elemBCR.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft))
        };
      },

      /**
       * Provides offset distance to the closest scrollable ancestor
       * or viewport.  Accounts for border and scrollbar width.
       *
       * Right and bottom dimensions represent the distance to the
       * respective edge of the viewport element.  If the element
       * edge extends beyond the viewport, a negative value will be
       * reported.
       *
       * @param {element} elem - The element to get the viewport offset for.
       * @param {boolean=} [useDocument=false] - Should the viewport be the document element instead
       * of the first scrollable element, default is false.
       * @param {boolean=} [includePadding=true] - Should the padding on the offset parent element
       * be accounted for, default is true.
       *
       * @returns {object} An object with the following properties:
       *   <ul>
       *     <li>**top**: distance to the top content edge of viewport element</li>
       *     <li>**bottom**: distance to the bottom content edge of viewport element</li>
       *     <li>**left**: distance to the left content edge of viewport element</li>
       *     <li>**right**: distance to the right content edge of viewport element</li>
       *   </ul>
       */
      viewportOffset: function(elem, useDocument, includePadding) {
        elem = this.getRawNode(elem);
        includePadding = includePadding !== false ? true : false;

        var elemBCR = elem.getBoundingClientRect();
        var offsetBCR = {top: 0, left: 0, bottom: 0, right: 0};

        var offsetParent = useDocument ? $document[0].documentElement : this.scrollParent(elem);
        var offsetParentBCR = offsetParent.getBoundingClientRect();

        offsetBCR.top = offsetParentBCR.top + offsetParent.clientTop;
        offsetBCR.left = offsetParentBCR.left + offsetParent.clientLeft;
        if (offsetParent === $document[0].documentElement) {
          offsetBCR.top += $window.pageYOffset;
          offsetBCR.left += $window.pageXOffset;
        }
        offsetBCR.bottom = offsetBCR.top + offsetParent.clientHeight;
        offsetBCR.right = offsetBCR.left + offsetParent.clientWidth;

        if (includePadding) {
          var offsetParentStyle = $window.getComputedStyle(offsetParent);
          offsetBCR.top += this.parseStyle(offsetParentStyle.paddingTop);
          offsetBCR.bottom -= this.parseStyle(offsetParentStyle.paddingBottom);
          offsetBCR.left += this.parseStyle(offsetParentStyle.paddingLeft);
          offsetBCR.right -= this.parseStyle(offsetParentStyle.paddingRight);
        }

        return {
          top: Math.round(elemBCR.top - offsetBCR.top),
          bottom: Math.round(offsetBCR.bottom - elemBCR.bottom),
          left: Math.round(elemBCR.left - offsetBCR.left),
          right: Math.round(offsetBCR.right - elemBCR.right)
        };
      },

      /**
       * Provides an array of placement values parsed from a placement string.
       * Along with the 'auto' indicator, supported placement strings are:
       *   <ul>
       *     <li>top: element on top, horizontally centered on host element.</li>
       *     <li>top-left: element on top, left edge aligned with host element left edge.</li>
       *     <li>top-right: element on top, lerightft edge aligned with host element right edge.</li>
       *     <li>bottom: element on bottom, horizontally centered on host element.</li>
       *     <li>bottom-left: element on bottom, left edge aligned with host element left edge.</li>
       *     <li>bottom-right: element on bottom, right edge aligned with host element right edge.</li>
       *     <li>left: element on left, vertically centered on host element.</li>
       *     <li>left-top: element on left, top edge aligned with host element top edge.</li>
       *     <li>left-bottom: element on left, bottom edge aligned with host element bottom edge.</li>
       *     <li>right: element on right, vertically centered on host element.</li>
       *     <li>right-top: element on right, top edge aligned with host element top edge.</li>
       *     <li>right-bottom: element on right, bottom edge aligned with host element bottom edge.</li>
       *   </ul>
       * A placement string with an 'auto' indicator is expected to be
       * space separated from the placement, i.e: 'auto bottom-left'  If
       * the primary and secondary placement values do not match 'top,
       * bottom, left, right' then 'top' will be the primary placement and
       * 'center' will be the secondary placement.  If 'auto' is passed, true
       * will be returned as the 3rd value of the array.
       *
       * @param {string} placement - The placement string to parse.
       *
       * @returns {array} An array with the following values
       * <ul>
       *   <li>**[0]**: The primary placement.</li>
       *   <li>**[1]**: The secondary placement.</li>
       *   <li>**[2]**: If auto is passed: true, else undefined.</li>
       * </ul>
       */
      parsePlacement: function(placement) {
        var autoPlace = PLACEMENT_REGEX.auto.test(placement);
        if (autoPlace) {
          placement = placement.replace(PLACEMENT_REGEX.auto, '');
        }

        placement = placement.split('-');

        placement[0] = placement[0] || 'top';
        if (!PLACEMENT_REGEX.primary.test(placement[0])) {
          placement[0] = 'top';
        }

        placement[1] = placement[1] || 'center';
        if (!PLACEMENT_REGEX.secondary.test(placement[1])) {
          placement[1] = 'center';
        }

        if (autoPlace) {
          placement[2] = true;
        } else {
          placement[2] = false;
        }

        return placement;
      },

      /**
       * Provides coordinates for an element to be positioned relative to
       * another element.  Passing 'auto' as part of the placement parameter
       * will enable smart placement - where the element fits. i.e:
       * 'auto left-top' will check to see if there is enough space to the left
       * of the hostElem to fit the targetElem, if not place right (same for secondary
       * top placement).  Available space is calculated using the viewportOffset
       * function.
       *
       * @param {element} hostElem - The element to position against.
       * @param {element} targetElem - The element to position.
       * @param {string=} [placement=top] - The placement for the targetElem,
       *   default is 'top'. 'center' is assumed as secondary placement for
       *   'top', 'left', 'right', and 'bottom' placements.  Available placements are:
       *   <ul>
       *     <li>top</li>
       *     <li>top-right</li>
       *     <li>top-left</li>
       *     <li>bottom</li>
       *     <li>bottom-left</li>
       *     <li>bottom-right</li>
       *     <li>left</li>
       *     <li>left-top</li>
       *     <li>left-bottom</li>
       *     <li>right</li>
       *     <li>right-top</li>
       *     <li>right-bottom</li>
       *   </ul>
       * @param {boolean=} [appendToBody=false] - Should the top and left values returned
       *   be calculated from the body element, default is false.
       *
       * @returns {object} An object with the following properties:
       *   <ul>
       *     <li>**top**: Value for targetElem top.</li>
       *     <li>**left**: Value for targetElem left.</li>
       *     <li>**placement**: The resolved placement.</li>
       *   </ul>
       */
      positionElements: function(hostElem, targetElem, placement, appendToBody) {
        hostElem = this.getRawNode(hostElem);
        targetElem = this.getRawNode(targetElem);

        // need to read from prop to support tests.
        var targetWidth = angular.isDefined(targetElem.offsetWidth) ? targetElem.offsetWidth : targetElem.prop('offsetWidth');
        var targetHeight = angular.isDefined(targetElem.offsetHeight) ? targetElem.offsetHeight : targetElem.prop('offsetHeight');

        placement = this.parsePlacement(placement);

        var hostElemPos = appendToBody ? this.offset(hostElem) : this.position(hostElem);
        var targetElemPos = {top: 0, left: 0, placement: ''};

        if (placement[2]) {
          var viewportOffset = this.viewportOffset(hostElem, appendToBody);

          var targetElemStyle = $window.getComputedStyle(targetElem);
          var adjustedSize = {
            width: targetWidth + Math.round(Math.abs(this.parseStyle(targetElemStyle.marginLeft) + this.parseStyle(targetElemStyle.marginRight))),
            height: targetHeight + Math.round(Math.abs(this.parseStyle(targetElemStyle.marginTop) + this.parseStyle(targetElemStyle.marginBottom)))
          };

          placement[0] = placement[0] === 'top' && adjustedSize.height > viewportOffset.top && adjustedSize.height <= viewportOffset.bottom ? 'bottom' :
                         placement[0] === 'bottom' && adjustedSize.height > viewportOffset.bottom && adjustedSize.height <= viewportOffset.top ? 'top' :
                         placement[0] === 'left' && adjustedSize.width > viewportOffset.left && adjustedSize.width <= viewportOffset.right ? 'right' :
                         placement[0] === 'right' && adjustedSize.width > viewportOffset.right && adjustedSize.width <= viewportOffset.left ? 'left' :
                         placement[0];

          placement[1] = placement[1] === 'top' && adjustedSize.height - hostElemPos.height > viewportOffset.bottom && adjustedSize.height - hostElemPos.height <= viewportOffset.top ? 'bottom' :
                         placement[1] === 'bottom' && adjustedSize.height - hostElemPos.height > viewportOffset.top && adjustedSize.height - hostElemPos.height <= viewportOffset.bottom ? 'top' :
                         placement[1] === 'left' && adjustedSize.width - hostElemPos.width > viewportOffset.right && adjustedSize.width - hostElemPos.width <= viewportOffset.left ? 'right' :
                         placement[1] === 'right' && adjustedSize.width - hostElemPos.width > viewportOffset.left && adjustedSize.width - hostElemPos.width <= viewportOffset.right ? 'left' :
                         placement[1];

          if (placement[1] === 'center') {
            if (PLACEMENT_REGEX.vertical.test(placement[0])) {
              var xOverflow = hostElemPos.width / 2 - targetWidth / 2;
              if (viewportOffset.left + xOverflow < 0 && adjustedSize.width - hostElemPos.width <= viewportOffset.right) {
                placement[1] = 'left';
              } else if (viewportOffset.right + xOverflow < 0 && adjustedSize.width - hostElemPos.width <= viewportOffset.left) {
                placement[1] = 'right';
              }
            } else {
              var yOverflow = hostElemPos.height / 2 - adjustedSize.height / 2;
              if (viewportOffset.top + yOverflow < 0 && adjustedSize.height - hostElemPos.height <= viewportOffset.bottom) {
                placement[1] = 'top';
              } else if (viewportOffset.bottom + yOverflow < 0 && adjustedSize.height - hostElemPos.height <= viewportOffset.top) {
                placement[1] = 'bottom';
              }
            }
          }
        }

        switch (placement[0]) {
          case 'top':
            targetElemPos.top = hostElemPos.top - targetHeight;
            break;
          case 'bottom':
            targetElemPos.top = hostElemPos.top + hostElemPos.height;
            break;
          case 'left':
            targetElemPos.left = hostElemPos.left - targetWidth;
            break;
          case 'right':
            targetElemPos.left = hostElemPos.left + hostElemPos.width;
            break;
        }

        switch (placement[1]) {
          case 'top':
            targetElemPos.top = hostElemPos.top;
            break;
          case 'bottom':
            targetElemPos.top = hostElemPos.top + hostElemPos.height - targetHeight;
            break;
          case 'left':
            targetElemPos.left = hostElemPos.left;
            break;
          case 'right':
            targetElemPos.left = hostElemPos.left + hostElemPos.width - targetWidth;
            break;
          case 'center':
            if (PLACEMENT_REGEX.vertical.test(placement[0])) {
              targetElemPos.left = hostElemPos.left + hostElemPos.width / 2 - targetWidth / 2;
            } else {
              targetElemPos.top = hostElemPos.top + hostElemPos.height / 2 - targetHeight / 2;
            }
            break;
        }

        targetElemPos.top = Math.round(targetElemPos.top);
        targetElemPos.left = Math.round(targetElemPos.left);
        targetElemPos.placement = placement[1] === 'center' ? placement[0] : placement[0] + '-' + placement[1];

        return targetElemPos;
      },

      /**
       * Provides a way to adjust the top positioning after first
       * render to correctly align element to top after content
       * rendering causes resized element height
       *
       * @param {array} placementClasses - The array of strings of classes
       * element should have.
       * @param {object} containerPosition - The object with container
       * position information
       * @param {number} initialHeight - The initial height for the elem.
       * @param {number} currentHeight - The current height for the elem.
       */
      adjustTop: function(placementClasses, containerPosition, initialHeight, currentHeight) {
        if (placementClasses.indexOf('top') !== -1 && initialHeight !== currentHeight) {
          return {
            top: containerPosition.top - currentHeight + 'px'
          };
        }
      },

      /**
       * Provides a way for positioning tooltip & dropdown
       * arrows when using placement options beyond the standard
       * left, right, top, or bottom.
       *
       * @param {element} elem - The tooltip/dropdown element.
       * @param {string} placement - The placement for the elem.
       */
      positionArrow: function(elem, placement) {
        elem = this.getRawNode(elem);

        var innerElem = elem.querySelector('.tooltip-inner, .popover-inner');
        if (!innerElem) {
          return;
        }

        var isTooltip = angular.element(innerElem).hasClass('tooltip-inner');

        var arrowElem = isTooltip ? elem.querySelector('.tooltip-arrow') : elem.querySelector('.arrow');
        if (!arrowElem) {
          return;
        }

        var arrowCss = {
          top: '',
          bottom: '',
          left: '',
          right: ''
        };

        placement = this.parsePlacement(placement);
        if (placement[1] === 'center') {
          // no adjustment necessary - just reset styles
          angular.element(arrowElem).css(arrowCss);
          return;
        }

        var borderProp = 'border-' + placement[0] + '-width';
        var borderWidth = $window.getComputedStyle(arrowElem)[borderProp];

        var borderRadiusProp = 'border-';
        if (PLACEMENT_REGEX.vertical.test(placement[0])) {
          borderRadiusProp += placement[0] + '-' + placement[1];
        } else {
          borderRadiusProp += placement[1] + '-' + placement[0];
        }
        borderRadiusProp += '-radius';
        var borderRadius = $window.getComputedStyle(isTooltip ? innerElem : elem)[borderRadiusProp];

        switch (placement[0]) {
          case 'top':
            arrowCss.bottom = isTooltip ? '0' : '-' + borderWidth;
            break;
          case 'bottom':
            arrowCss.top = isTooltip ? '0' : '-' + borderWidth;
            break;
          case 'left':
            arrowCss.right = isTooltip ? '0' : '-' + borderWidth;
            break;
          case 'right':
            arrowCss.left = isTooltip ? '0' : '-' + borderWidth;
            break;
        }

        arrowCss[placement[1]] = borderRadius;

        angular.element(arrowElem).css(arrowCss);
      }
    };
  }]);


/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1254);

var MODULE_NAME = 'ui.bootstrap.module.stackedMap';

angular.module(MODULE_NAME, ['ui.bootstrap.stackedMap']);

module.exports = MODULE_NAME;


/***/ }),
/* 1254 */
/***/ (function(module, exports) {

angular.module('ui.bootstrap.stackedMap', [])
/**
 * A helper, internal data structure that acts as a map but also allows getting / removing
 * elements in the LIFO order
 */
  .factory('$$stackedMap', function() {
    return {
      createNew: function() {
        var stack = [];

        return {
          add: function(key, value) {
            stack.push({
              key: key,
              value: value
            });
          },
          get: function(key) {
            for (var i = 0; i < stack.length; i++) {
              if (key === stack[i].key) {
                return stack[i];
              }
            }
          },
          keys: function() {
            var keys = [];
            for (var i = 0; i < stack.length; i++) {
              keys.push(stack[i].key);
            }
            return keys;
          },
          top: function() {
            return stack[stack.length - 1];
          },
          remove: function(key) {
            var idx = -1;
            for (var i = 0; i < stack.length; i++) {
              if (key === stack[i].key) {
                idx = i;
                break;
              }
            }
            return stack.splice(idx, 1)[0];
          },
          removeTop: function() {
            return stack.pop();
          },
          length: function() {
            return stack.length;
          }
        };
      }
    };
  });

/***/ }),
/* 1255 */
/***/ (function(module, exports) {

angular.module("uib/template/modal/window.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/modal/window.html",
    "<div class=\"modal-dialog {{size ? 'modal-' + size : ''}}\"><div class=\"modal-content\" uib-modal-transclude></div></div>\n" +
    "");
}]);


/***/ }),
/* 1256 */
/***/ (function(module, exports) {

angular.module('ui.bootstrap.modal', ['ui.bootstrap.multiMap', 'ui.bootstrap.stackedMap', 'ui.bootstrap.position'])
/**
 * Pluggable resolve mechanism for the modal resolve resolution
 * Supports UI Router's $resolve service
 */
  .provider('$uibResolve', function() {
    var resolve = this;
    this.resolver = null;

    this.setResolver = function(resolver) {
      this.resolver = resolver;
    };

    this.$get = ['$injector', '$q', function($injector, $q) {
      var resolver = resolve.resolver ? $injector.get(resolve.resolver) : null;
      return {
        resolve: function(invocables, locals, parent, self) {
          if (resolver) {
            return resolver.resolve(invocables, locals, parent, self);
          }

          var promises = [];

          angular.forEach(invocables, function(value) {
            if (angular.isFunction(value) || angular.isArray(value)) {
              promises.push($q.resolve($injector.invoke(value)));
            } else if (angular.isString(value)) {
              promises.push($q.resolve($injector.get(value)));
            } else {
              promises.push($q.resolve(value));
            }
          });

          return $q.all(promises).then(function(resolves) {
            var resolveObj = {};
            var resolveIter = 0;
            angular.forEach(invocables, function(value, key) {
              resolveObj[key] = resolves[resolveIter++];
            });

            return resolveObj;
          });
        }
      };
    }];
  })

/**
 * A helper directive for the $modal service. It creates a backdrop element.
 */
  .directive('uibModalBackdrop', ['$animate', '$injector', '$uibModalStack',
  function($animate, $injector, $modalStack) {
    return {
      restrict: 'A',
      compile: function(tElement, tAttrs) {
        tElement.addClass(tAttrs.backdropClass);
        return linkFn;
      }
    };

    function linkFn(scope, element, attrs) {
      if (attrs.modalInClass) {
        $animate.addClass(element, attrs.modalInClass);

        scope.$on($modalStack.NOW_CLOSING_EVENT, function(e, setIsAsync) {
          var done = setIsAsync();
          if (scope.modalOptions.animation) {
            $animate.removeClass(element, attrs.modalInClass).then(done);
          } else {
            done();
          }
        });
      }
    }
  }])

  .directive('uibModalWindow', ['$uibModalStack', '$q', '$animateCss', '$document',
  function($modalStack, $q, $animateCss, $document) {
    return {
      scope: {
        index: '@'
      },
      restrict: 'A',
      transclude: true,
      templateUrl: function(tElement, tAttrs) {
        return tAttrs.templateUrl || 'uib/template/modal/window.html';
      },
      link: function(scope, element, attrs) {
        element.addClass(attrs.windowTopClass || '');
        scope.size = attrs.size;

        scope.close = function(evt) {
          var modal = $modalStack.getTop();
          if (modal && modal.value.backdrop &&
            modal.value.backdrop !== 'static' &&
            evt.target === evt.currentTarget) {
            evt.preventDefault();
            evt.stopPropagation();
            $modalStack.dismiss(modal.key, 'backdrop click');
          }
        };

        // moved from template to fix issue #2280
        element.on('click', scope.close);

        // This property is only added to the scope for the purpose of detecting when this directive is rendered.
        // We can detect that by using this property in the template associated with this directive and then use
        // {@link Attribute#$observe} on it. For more details please see {@link TableColumnResize}.
        scope.$isRendered = true;

        // Deferred object that will be resolved when this modal is rendered.
        var modalRenderDeferObj = $q.defer();
        // Resolve render promise post-digest
        scope.$$postDigest(function() {
          modalRenderDeferObj.resolve();
        });

        modalRenderDeferObj.promise.then(function() {
          var animationPromise = null;

          if (attrs.modalInClass) {
            animationPromise = $animateCss(element, {
              addClass: attrs.modalInClass
            }).start();

            scope.$on($modalStack.NOW_CLOSING_EVENT, function(e, setIsAsync) {
              var done = setIsAsync();
              $animateCss(element, {
                removeClass: attrs.modalInClass
              }).start().then(done);
            });
          }


          $q.when(animationPromise).then(function() {
            // Notify {@link $modalStack} that modal is rendered.
            var modal = $modalStack.getTop();
            if (modal) {
              $modalStack.modalRendered(modal.key);
            }

            /**
             * If something within the freshly-opened modal already has focus (perhaps via a
             * directive that causes focus) then there's no need to try to focus anything.
             */
            if (!($document[0].activeElement && element[0].contains($document[0].activeElement))) {
              var inputWithAutofocus = element[0].querySelector('[autofocus]');
              /**
               * Auto-focusing of a freshly-opened modal element causes any child elements
               * with the autofocus attribute to lose focus. This is an issue on touch
               * based devices which will show and then hide the onscreen keyboard.
               * Attempts to refocus the autofocus element via JavaScript will not reopen
               * the onscreen keyboard. Fixed by updated the focusing logic to only autofocus
               * the modal element if the modal does not contain an autofocus element.
               */
              if (inputWithAutofocus) {
                inputWithAutofocus.focus();
              } else {
                element[0].focus();
              }
            }
          });
        });
      }
    };
  }])

  .directive('uibModalAnimationClass', function() {
    return {
      compile: function(tElement, tAttrs) {
        if (tAttrs.modalAnimation) {
          tElement.addClass(tAttrs.uibModalAnimationClass);
        }
      }
    };
  })

  .directive('uibModalTransclude', ['$animate', function($animate) {
    return {
      link: function(scope, element, attrs, controller, transclude) {
        transclude(scope.$parent, function(clone) {
          element.empty();
          $animate.enter(clone, element);
        });
      }
    };
  }])

  .factory('$uibModalStack', ['$animate', '$animateCss', '$document',
    '$compile', '$rootScope', '$q', '$$multiMap', '$$stackedMap', '$uibPosition',
    function($animate, $animateCss, $document, $compile, $rootScope, $q, $$multiMap, $$stackedMap, $uibPosition) {
      var OPENED_MODAL_CLASS = 'modal-open';

      var backdropDomEl, backdropScope;
      var openedWindows = $$stackedMap.createNew();
      var openedClasses = $$multiMap.createNew();
      var $modalStack = {
        NOW_CLOSING_EVENT: 'modal.stack.now-closing'
      };
      var topModalIndex = 0;
      var previousTopOpenedModal = null;
      var ARIA_HIDDEN_ATTRIBUTE_NAME = 'data-bootstrap-modal-aria-hidden-count';

      //Modal focus behavior
      var tabbableSelector = 'a[href], area[href], input:not([disabled]):not([tabindex=\'-1\']), ' +
        'button:not([disabled]):not([tabindex=\'-1\']),select:not([disabled]):not([tabindex=\'-1\']), textarea:not([disabled]):not([tabindex=\'-1\']), ' +
        'iframe, object, embed, *[tabindex]:not([tabindex=\'-1\']), *[contenteditable=true]';
      var scrollbarPadding;
      var SNAKE_CASE_REGEXP = /[A-Z]/g;

      // TODO: extract into common dependency with tooltip
      function snake_case(name) {
        var separator = '-';
        return name.replace(SNAKE_CASE_REGEXP, function(letter, pos) {
          return (pos ? separator : '') + letter.toLowerCase();
        });
      }

      function isVisible(element) {
        return !!(element.offsetWidth ||
          element.offsetHeight ||
          element.getClientRects().length);
      }

      function backdropIndex() {
        var topBackdropIndex = -1;
        var opened = openedWindows.keys();
        for (var i = 0; i < opened.length; i++) {
          if (openedWindows.get(opened[i]).value.backdrop) {
            topBackdropIndex = i;
          }
        }

        // If any backdrop exist, ensure that it's index is always
        // right below the top modal
        if (topBackdropIndex > -1 && topBackdropIndex < topModalIndex) {
          topBackdropIndex = topModalIndex;
        }
        return topBackdropIndex;
      }

      $rootScope.$watch(backdropIndex, function(newBackdropIndex) {
        if (backdropScope) {
          backdropScope.index = newBackdropIndex;
        }
      });

      function removeModalWindow(modalInstance, elementToReceiveFocus) {
        var modalWindow = openedWindows.get(modalInstance).value;
        var appendToElement = modalWindow.appendTo;

        //clean up the stack
        openedWindows.remove(modalInstance);
        previousTopOpenedModal = openedWindows.top();
        if (previousTopOpenedModal) {
          topModalIndex = parseInt(previousTopOpenedModal.value.modalDomEl.attr('index'), 10);
        }

        removeAfterAnimate(modalWindow.modalDomEl, modalWindow.modalScope, function() {
          var modalBodyClass = modalWindow.openedClass || OPENED_MODAL_CLASS;
          openedClasses.remove(modalBodyClass, modalInstance);
          var areAnyOpen = openedClasses.hasKey(modalBodyClass);
          appendToElement.toggleClass(modalBodyClass, areAnyOpen);
          if (!areAnyOpen && scrollbarPadding && scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
            if (scrollbarPadding.originalRight) {
              appendToElement.css({paddingRight: scrollbarPadding.originalRight + 'px'});
            } else {
              appendToElement.css({paddingRight: ''});
            }
            scrollbarPadding = null;
          }
          toggleTopWindowClass(true);
        }, modalWindow.closedDeferred);
        checkRemoveBackdrop();

        //move focus to specified element if available, or else to body
        if (elementToReceiveFocus && elementToReceiveFocus.focus) {
          elementToReceiveFocus.focus();
        } else if (appendToElement.focus) {
          appendToElement.focus();
        }
      }

      // Add or remove "windowTopClass" from the top window in the stack
      function toggleTopWindowClass(toggleSwitch) {
        var modalWindow;

        if (openedWindows.length() > 0) {
          modalWindow = openedWindows.top().value;
          modalWindow.modalDomEl.toggleClass(modalWindow.windowTopClass || '', toggleSwitch);
        }
      }

      function checkRemoveBackdrop() {
        //remove backdrop if no longer needed
        if (backdropDomEl && backdropIndex() === -1) {
          var backdropScopeRef = backdropScope;
          removeAfterAnimate(backdropDomEl, backdropScope, function() {
            backdropScopeRef = null;
          });
          backdropDomEl = undefined;
          backdropScope = undefined;
        }
      }

      function removeAfterAnimate(domEl, scope, done, closedDeferred) {
        var asyncDeferred;
        var asyncPromise = null;
        var setIsAsync = function() {
          if (!asyncDeferred) {
            asyncDeferred = $q.defer();
            asyncPromise = asyncDeferred.promise;
          }

          return function asyncDone() {
            asyncDeferred.resolve();
          };
        };
        scope.$broadcast($modalStack.NOW_CLOSING_EVENT, setIsAsync);

        // Note that it's intentional that asyncPromise might be null.
        // That's when setIsAsync has not been called during the
        // NOW_CLOSING_EVENT broadcast.
        return $q.when(asyncPromise).then(afterAnimating);

        function afterAnimating() {
          if (afterAnimating.done) {
            return;
          }
          afterAnimating.done = true;

          $animate.leave(domEl).then(function() {
            if (done) {
              done();
            }

            domEl.remove();
            if (closedDeferred) {
              closedDeferred.resolve();
            }
          });

          scope.$destroy();
        }
      }

      $document.on('keydown', keydownListener);

      $rootScope.$on('$destroy', function() {
        $document.off('keydown', keydownListener);
      });

      function keydownListener(evt) {
        if (evt.isDefaultPrevented()) {
          return evt;
        }

        var modal = openedWindows.top();
        if (modal) {
          switch (evt.which) {
            case 27: {
              if (modal.value.keyboard) {
                evt.preventDefault();
                $rootScope.$apply(function() {
                  $modalStack.dismiss(modal.key, 'escape key press');
                });
              }
              break;
            }
            case 9: {
              var list = $modalStack.loadFocusElementList(modal);
              var focusChanged = false;
              if (evt.shiftKey) {
                if ($modalStack.isFocusInFirstItem(evt, list) || $modalStack.isModalFocused(evt, modal)) {
                  focusChanged = $modalStack.focusLastFocusableElement(list);
                }
              } else {
                if ($modalStack.isFocusInLastItem(evt, list)) {
                  focusChanged = $modalStack.focusFirstFocusableElement(list);
                }
              }

              if (focusChanged) {
                evt.preventDefault();
                evt.stopPropagation();
              }

              break;
            }
          }
        }
      }

      $modalStack.open = function(modalInstance, modal) {
        var modalOpener = $document[0].activeElement,
          modalBodyClass = modal.openedClass || OPENED_MODAL_CLASS;

        toggleTopWindowClass(false);

        // Store the current top first, to determine what index we ought to use
        // for the current top modal
        previousTopOpenedModal = openedWindows.top();

        openedWindows.add(modalInstance, {
          deferred: modal.deferred,
          renderDeferred: modal.renderDeferred,
          closedDeferred: modal.closedDeferred,
          modalScope: modal.scope,
          backdrop: modal.backdrop,
          keyboard: modal.keyboard,
          openedClass: modal.openedClass,
          windowTopClass: modal.windowTopClass,
          animation: modal.animation,
          appendTo: modal.appendTo
        });

        openedClasses.put(modalBodyClass, modalInstance);

        var appendToElement = modal.appendTo,
            currBackdropIndex = backdropIndex();

        if (currBackdropIndex >= 0 && !backdropDomEl) {
          backdropScope = $rootScope.$new(true);
          backdropScope.modalOptions = modal;
          backdropScope.index = currBackdropIndex;
          backdropDomEl = angular.element('<div uib-modal-backdrop="modal-backdrop"></div>');
          backdropDomEl.attr({
            'class': 'modal-backdrop',
            'ng-style': '{\'z-index\': 1040 + (index && 1 || 0) + index*10}',
            'uib-modal-animation-class': 'fade',
            'modal-in-class': 'in'
          });
          if (modal.backdropClass) {
            backdropDomEl.addClass(modal.backdropClass);
          }

          if (modal.animation) {
            backdropDomEl.attr('modal-animation', 'true');
          }
          $compile(backdropDomEl)(backdropScope);
          $animate.enter(backdropDomEl, appendToElement);
          if ($uibPosition.isScrollable(appendToElement)) {
            scrollbarPadding = $uibPosition.scrollbarPadding(appendToElement);
            if (scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
              appendToElement.css({paddingRight: scrollbarPadding.right + 'px'});
            }
          }
        }

        var content;
        if (modal.component) {
          content = document.createElement(snake_case(modal.component.name));
          content = angular.element(content);
          content.attr({
            resolve: '$resolve',
            'modal-instance': '$uibModalInstance',
            close: '$close($value)',
            dismiss: '$dismiss($value)'
          });
        } else {
          content = modal.content;
        }

        // Set the top modal index based on the index of the previous top modal
        topModalIndex = previousTopOpenedModal ? parseInt(previousTopOpenedModal.value.modalDomEl.attr('index'), 10) + 1 : 0;
        var angularDomEl = angular.element('<div uib-modal-window="modal-window"></div>');
        angularDomEl.attr({
          'class': 'modal',
          'template-url': modal.windowTemplateUrl,
          'window-top-class': modal.windowTopClass,
          'role': 'dialog',
          'aria-labelledby': modal.ariaLabelledBy,
          'aria-describedby': modal.ariaDescribedBy,
          'size': modal.size,
          'index': topModalIndex,
          'animate': 'animate',
          'ng-style': '{\'z-index\': 1050 + $$topModalIndex*10, display: \'block\'}',
          'tabindex': -1,
          'uib-modal-animation-class': 'fade',
          'modal-in-class': 'in'
        }).append(content);
        if (modal.windowClass) {
          angularDomEl.addClass(modal.windowClass);
        }

        if (modal.animation) {
          angularDomEl.attr('modal-animation', 'true');
        }

        appendToElement.addClass(modalBodyClass);
        if (modal.scope) {
          // we need to explicitly add the modal index to the modal scope
          // because it is needed by ngStyle to compute the zIndex property.
          modal.scope.$$topModalIndex = topModalIndex;
        }
        $animate.enter($compile(angularDomEl)(modal.scope), appendToElement);

        openedWindows.top().value.modalDomEl = angularDomEl;
        openedWindows.top().value.modalOpener = modalOpener;

        applyAriaHidden(angularDomEl);

        function applyAriaHidden(el) {
          if (!el || el[0].tagName === 'BODY') {
            return;
          }

          getSiblings(el).forEach(function(sibling) {
            var elemIsAlreadyHidden = sibling.getAttribute('aria-hidden') === 'true',
              ariaHiddenCount = parseInt(sibling.getAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME), 10);

            if (!ariaHiddenCount) {
              ariaHiddenCount = elemIsAlreadyHidden ? 1 : 0;
            }

            sibling.setAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME, ariaHiddenCount + 1);
            sibling.setAttribute('aria-hidden', 'true');
          });

          return applyAriaHidden(el.parent());

          function getSiblings(el) {
            var children = el.parent() ? el.parent().children() : [];

            return Array.prototype.filter.call(children, function(child) {
              return child !== el[0];
            });
          }
        }
      };

      function broadcastClosing(modalWindow, resultOrReason, closing) {
        return !modalWindow.value.modalScope.$broadcast('modal.closing', resultOrReason, closing).defaultPrevented;
      }

      function unhideBackgroundElements() {
        Array.prototype.forEach.call(
          document.querySelectorAll('[' + ARIA_HIDDEN_ATTRIBUTE_NAME + ']'),
          function(hiddenEl) {
            var ariaHiddenCount = parseInt(hiddenEl.getAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME), 10),
              newHiddenCount = ariaHiddenCount - 1;
            hiddenEl.setAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME, newHiddenCount);

            if (!newHiddenCount) {
              hiddenEl.removeAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME);
              hiddenEl.removeAttribute('aria-hidden');
            }
          }
        );
      }

      $modalStack.close = function(modalInstance, result) {
        var modalWindow = openedWindows.get(modalInstance);
        unhideBackgroundElements();
        if (modalWindow && broadcastClosing(modalWindow, result, true)) {
          modalWindow.value.modalScope.$$uibDestructionScheduled = true;
          modalWindow.value.deferred.resolve(result);
          removeModalWindow(modalInstance, modalWindow.value.modalOpener);
          return true;
        }

        return !modalWindow;
      };

      $modalStack.dismiss = function(modalInstance, reason) {
        var modalWindow = openedWindows.get(modalInstance);
        unhideBackgroundElements();
        if (modalWindow && broadcastClosing(modalWindow, reason, false)) {
          modalWindow.value.modalScope.$$uibDestructionScheduled = true;
          modalWindow.value.deferred.reject(reason);
          removeModalWindow(modalInstance, modalWindow.value.modalOpener);
          return true;
        }
        return !modalWindow;
      };

      $modalStack.dismissAll = function(reason) {
        var topModal = this.getTop();
        while (topModal && this.dismiss(topModal.key, reason)) {
          topModal = this.getTop();
        }
      };

      $modalStack.getTop = function() {
        return openedWindows.top();
      };

      $modalStack.modalRendered = function(modalInstance) {
        var modalWindow = openedWindows.get(modalInstance);
        if (modalWindow) {
          modalWindow.value.renderDeferred.resolve();
        }
      };

      $modalStack.focusFirstFocusableElement = function(list) {
        if (list.length > 0) {
          list[0].focus();
          return true;
        }
        return false;
      };

      $modalStack.focusLastFocusableElement = function(list) {
        if (list.length > 0) {
          list[list.length - 1].focus();
          return true;
        }
        return false;
      };

      $modalStack.isModalFocused = function(evt, modalWindow) {
        if (evt && modalWindow) {
          var modalDomEl = modalWindow.value.modalDomEl;
          if (modalDomEl && modalDomEl.length) {
            return (evt.target || evt.srcElement) === modalDomEl[0];
          }
        }
        return false;
      };

      $modalStack.isFocusInFirstItem = function(evt, list) {
        if (list.length > 0) {
          return (evt.target || evt.srcElement) === list[0];
        }
        return false;
      };

      $modalStack.isFocusInLastItem = function(evt, list) {
        if (list.length > 0) {
          return (evt.target || evt.srcElement) === list[list.length - 1];
        }
        return false;
      };

      $modalStack.loadFocusElementList = function(modalWindow) {
        if (modalWindow) {
          var modalDomE1 = modalWindow.value.modalDomEl;
          if (modalDomE1 && modalDomE1.length) {
            var elements = modalDomE1[0].querySelectorAll(tabbableSelector);
            return elements ?
              Array.prototype.filter.call(elements, function(element) {
                return isVisible(element);
              }) : elements;
          }
        }
      };

      return $modalStack;
    }])

  .provider('$uibModal', function() {
    var $modalProvider = {
      options: {
        animation: true,
        backdrop: true, //can also be false or 'static'
        keyboard: true
      },
      $get: ['$rootScope', '$q', '$document', '$templateRequest', '$controller', '$uibResolve', '$uibModalStack',
        function ($rootScope, $q, $document, $templateRequest, $controller, $uibResolve, $modalStack) {
          var $modal = {};

          function getTemplatePromise(options) {
            return options.template ? $q.when(options.template) :
              $templateRequest(angular.isFunction(options.templateUrl) ?
                options.templateUrl() : options.templateUrl);
          }

          var promiseChain = null;
          $modal.getPromiseChain = function() {
            return promiseChain;
          };

          $modal.open = function(modalOptions) {
            var modalResultDeferred = $q.defer();
            var modalOpenedDeferred = $q.defer();
            var modalClosedDeferred = $q.defer();
            var modalRenderDeferred = $q.defer();

            //prepare an instance of a modal to be injected into controllers and returned to a caller
            var modalInstance = {
              result: modalResultDeferred.promise,
              opened: modalOpenedDeferred.promise,
              closed: modalClosedDeferred.promise,
              rendered: modalRenderDeferred.promise,
              close: function (result) {
                return $modalStack.close(modalInstance, result);
              },
              dismiss: function (reason) {
                return $modalStack.dismiss(modalInstance, reason);
              }
            };

            //merge and clean up options
            modalOptions = angular.extend({}, $modalProvider.options, modalOptions);
            modalOptions.resolve = modalOptions.resolve || {};
            modalOptions.appendTo = modalOptions.appendTo || $document.find('body').eq(0);

            if (!modalOptions.appendTo.length) {
              throw new Error('appendTo element not found. Make sure that the element passed is in DOM.');
            }

            //verify options
            if (!modalOptions.component && !modalOptions.template && !modalOptions.templateUrl) {
              throw new Error('One of component or template or templateUrl options is required.');
            }

            var templateAndResolvePromise;
            if (modalOptions.component) {
              templateAndResolvePromise = $q.when($uibResolve.resolve(modalOptions.resolve, {}, null, null));
            } else {
              templateAndResolvePromise =
                $q.all([getTemplatePromise(modalOptions), $uibResolve.resolve(modalOptions.resolve, {}, null, null)]);
            }

            function resolveWithTemplate() {
              return templateAndResolvePromise;
            }

            // Wait for the resolution of the existing promise chain.
            // Then switch to our own combined promise dependency (regardless of how the previous modal fared).
            // Then add to $modalStack and resolve opened.
            // Finally clean up the chain variable if no subsequent modal has overwritten it.
            var samePromise;
            samePromise = promiseChain = $q.all([promiseChain])
              .then(resolveWithTemplate, resolveWithTemplate)
              .then(function resolveSuccess(tplAndVars) {
                var providedScope = modalOptions.scope || $rootScope;

                var modalScope = providedScope.$new();
                modalScope.$close = modalInstance.close;
                modalScope.$dismiss = modalInstance.dismiss;

                modalScope.$on('$destroy', function() {
                  if (!modalScope.$$uibDestructionScheduled) {
                    modalScope.$dismiss('$uibUnscheduledDestruction');
                  }
                });

                var modal = {
                  scope: modalScope,
                  deferred: modalResultDeferred,
                  renderDeferred: modalRenderDeferred,
                  closedDeferred: modalClosedDeferred,
                  animation: modalOptions.animation,
                  backdrop: modalOptions.backdrop,
                  keyboard: modalOptions.keyboard,
                  backdropClass: modalOptions.backdropClass,
                  windowTopClass: modalOptions.windowTopClass,
                  windowClass: modalOptions.windowClass,
                  windowTemplateUrl: modalOptions.windowTemplateUrl,
                  ariaLabelledBy: modalOptions.ariaLabelledBy,
                  ariaDescribedBy: modalOptions.ariaDescribedBy,
                  size: modalOptions.size,
                  openedClass: modalOptions.openedClass,
                  appendTo: modalOptions.appendTo
                };

                var component = {};
                var ctrlInstance, ctrlInstantiate, ctrlLocals = {};

                if (modalOptions.component) {
                  constructLocals(component, false, true, false);
                  component.name = modalOptions.component;
                  modal.component = component;
                } else if (modalOptions.controller) {
                  constructLocals(ctrlLocals, true, false, true);

                  // the third param will make the controller instantiate later,private api
                  // @see https://github.com/angular/angular.js/blob/master/src/ng/controller.js#L126
                  ctrlInstantiate = $controller(modalOptions.controller, ctrlLocals, true, modalOptions.controllerAs);
                  if (modalOptions.controllerAs && modalOptions.bindToController) {
                    ctrlInstance = ctrlInstantiate.instance;
                    ctrlInstance.$close = modalScope.$close;
                    ctrlInstance.$dismiss = modalScope.$dismiss;
                    angular.extend(ctrlInstance, {
                      $resolve: ctrlLocals.$scope.$resolve
                    }, providedScope);
                  }

                  ctrlInstance = ctrlInstantiate();

                  if (angular.isFunction(ctrlInstance.$onInit)) {
                    ctrlInstance.$onInit();
                  }
                }

                if (!modalOptions.component) {
                  modal.content = tplAndVars[0];
                }

                $modalStack.open(modalInstance, modal);
                modalOpenedDeferred.resolve(true);

                function constructLocals(obj, template, instanceOnScope, injectable) {
                  obj.$scope = modalScope;
                  obj.$scope.$resolve = {};
                  if (instanceOnScope) {
                    obj.$scope.$uibModalInstance = modalInstance;
                  } else {
                    obj.$uibModalInstance = modalInstance;
                  }

                  var resolves = template ? tplAndVars[1] : tplAndVars;
                  angular.forEach(resolves, function(value, key) {
                    if (injectable) {
                      obj[key] = value;
                    }

                    obj.$scope.$resolve[key] = value;
                  });
                }
            }, function resolveError(reason) {
              modalOpenedDeferred.reject(reason);
              modalResultDeferred.reject(reason);
            })['finally'](function() {
              if (promiseChain === samePromise) {
                promiseChain = null;
              }
            });

            return modalInstance;
          };

          return $modal;
        }
      ]
    };

    return $modalProvider;
  });


/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(1);

var _angular2 = _interopRequireDefault(_angular);

var _downlistModal = __webpack_require__(1258);

var _downlistModal2 = _interopRequireDefault(_downlistModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var m = _angular2.default.module('downlistModal', []).component('downlistModal', _downlistModal2.default).name;

exports.default = m;

/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _downlistModal = __webpack_require__(1259);

var _downlistModal2 = _interopRequireDefault(_downlistModal);

var _downlistModal3 = __webpack_require__(1260);

var _downlistModal4 = _interopRequireDefault(_downlistModal3);

__webpack_require__(1261);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var downlistComponent = {
  template: _downlistModal2.default,
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&'
  },
  controller: _downlistModal4.default
};

exports.default = downlistComponent;

/***/ }),
/* 1259 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\" ng-if=\"$ctrl.excels.data.length>=0\">\n    <h3 class=\"modal-title\">转载报告下载\n      <!-- <i class=\" ybicon yb-alert\"></i> -->\n      <span>（转载报告保留24小时）</span>\n    </h3>\n  <div class=\"close\" ng-click=\"$ctrl.cancel()\">×</div>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n  <table>\n    <thead>\n      <th class=\"text-left\">类型</th>\n      <th  class=\"Mobile-th\">时间</th>\n      <th class=\"text-right\">操作</th>\n    </thead>\n    <tbody>\n    <tr ng-repeat=\"d in $ctrl.excels.data\">\n      <td>\n          <div>\n                <span class=\"label-text\">{{$ctrl.typeTextObject[d.type]}}</span>\n                <span class=\"td-text\">{{ d.name?d.name:$ctrl.typeMap[d.type] }}</span>\n          </div>\n          <div class=\"Mobile\" >{{(d.start && d.start * 1000 | date : 'yyyy/MM/dd') || '全部时间'}}{{d.end && d.end * 1000 | date : ' - yyyy/MM/dd'}}</div>\n        </td>\n      <td class=\"Mobile-none\">{{(d.start && d.start * 1000 | date : 'yyyy/MM/dd') || '全部时间'}}{{d.end && d.end * 1000 | date : ' - yyyy/MM/dd'}}</td>\n      <td>\n        <button ng-disabled=\"!d.download\" ng-click=\"$ctrl.downloadExcel(d.download)\" class=\"btn btn-primary\">下载</button>\n      </td>\n    </tr>\n    </tbody>\n  </table>\n  <pager\n    total=\"$ctrl.excels.pageCount\"\n    current=\"$ctrl.excels.page\"\n    ng-if=\"$ctrl.excels.pageCount > 1\"\n    load=\"$ctrl.excels.loadPage(page)\"\n  ></pager>\n</div>";

/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DownlistModalController = function () {
  DownlistModalController.$inject = ["InfringementAPI", "$typeMap"];

  function DownlistModalController(InfringementAPI, $typeMap) {
    'ngInject';

    var _this = this;

    (0, _classCallCheck3.default)(this, DownlistModalController);
    this.typeMap = $typeMap;
    this.typeTextObject = { //转载报告
      article: "文章",
      in_one_article: "文章",
      in_one_site: "网站",
      normal: "时间",
      site: "网站"
    };

    this.excels = {
      data: [],
      pageCount: 1,
      page: 1,
      enable: false,
      firstPageData: [],
      loadPage: function loadPage(page) {
        _this.excels.page = page;
        InfringementAPI.one('reports').get({
          page: page,
          page_size: 5
        }).then(function (res) {
          if (page === 1) {
            _this.excels.firstPageData = res.data.data;
          }
          if (res.data.data.length) {
            _this.excels.enable = true;
          }
          _this.excels.data = res.data.data;
          _this.excels.pageCount = res.data.last_page;
        }).catch(function (e) {
          console.log(e);
        });
      }
    };
  }

  (0, _createClass3.default)(DownlistModalController, [{
    key: "$onInit",
    value: function $onInit() {
      this.excels.loadPage(1);
    }
  }, {
    key: "downloadExcel",
    value: function downloadExcel(download) {
      if (download) {
        window.open(download);
      }
    }
  }, {
    key: "cancel",
    value: function cancel() {
      this.dismiss({ $value: 'cancel' });
    }
  }]);
  return DownlistModalController;
}();

exports.default = DownlistModalController;

/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1262);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(3)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./downlist-modal.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./downlist-modal.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".modal-open {\n  overflow: hidden; }\n\n.text-left {\n  text-align: left !important;\n  padding-left: 18px; }\n\n.text-right {\n  text-align: right !important;\n  padding-right: 18px; }\n\n.dd-modal {\n  display: none;\n  overflow: hidden;\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1050;\n  -webkit-overflow-scrolling: touch;\n  outline: 0; }\n  .dd-modal.fade .modal-dialog {\n    transform: translate(0, -25%);\n    transition: transform .3s ease-out; }\n  .dd-modal.in .modal-dialog {\n    transform: translate(0, 0); }\n\n.modal-open .modal {\n  overflow-x: hidden;\n  overflow-y: auto; }\n\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: 10px; }\n\n.modal-content {\n  position: relative;\n  background-color: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  background-clip: padding-box;\n  outline: 0; }\n  .modal-content table {\n    margin: 0 auto;\n    width: 80%;\n    border-collapse: collapse;\n    border-spacing: 0;\n    font-size: 14px; }\n    .modal-content table td {\n      padding: 10px 0;\n      border-bottom: 1px solid #E5E5E5; }\n      .modal-content table td:last-child {\n        text-align: right; }\n\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1040;\n  background-color: #000; }\n  .modal-backdrop.fade {\n    opacity: 0; }\n  .modal-backdrop.in {\n    opacity: 0.5; }\n\n.modal-header {\n  padding: 15px;\n  border-bottom: 1px solid #e5e5e5; }\n  .modal-header .close {\n    position: absolute;\n    right: 16px;\n    top: 16px;\n    width: 36px;\n    height: 36px;\n    text-align: center;\n    cursor: pointer;\n    font-size: 16px;\n    color: #999999; }\n  .modal-header h3 {\n    padding-left: 22px; }\n\n.modal-title {\n  margin: 0;\n  line-height: 1.42857143; }\n  .modal-title span {\n    font-weight: normal;\n    font-size: 12px;\n    color: #999;\n    margin-left: -8px; }\n\n.modal-body {\n  width: 100%;\n  position: relative; }\n  .modal-body .btn {\n    width: 80px;\n    height: 34px; }\n  .modal-body table {\n    width: 628px;\n    height: 100%;\n    margin: 26px 36px; }\n    .modal-body table thead {\n      width: 100%;\n      height: 38px;\n      line-height: 38px;\n      background: whitesmoke; }\n      .modal-body table thead th {\n        text-align: center; }\n    .modal-body table tbody tr {\n      height: 74px; }\n      .modal-body table tbody tr .label-text {\n        background: #cfecea;\n        width: 28px;\n        height: 16px;\n        font-size: 10px;\n        color: #1ca49a;\n        padding: 4px;\n        margin-right: 10px; }\n      .modal-body table tbody tr td span:nth-child(2) {\n        max-width: 200px;\n        display: inline-block;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n        overflow: hidden; }\n      .modal-body table tbody tr td:nth-child(2) {\n        text-align: center; }\n      .modal-body table tbody tr td .Mobile {\n        display: none; }\n  .modal-body .pager {\n    margin: 35px; }\n\n.modal-footer {\n  padding: 15px;\n  text-align: right;\n  border-top: 1px solid #e5e5e5; }\n  .modal-footer .btn + .btn {\n    margin-left: 5px;\n    margin-bottom: 0; }\n  .modal-footer .btn-group .btn + .btn {\n    margin-left: -1px; }\n  .modal-footer .btn-block + .btn-block {\n    margin-left: 0; }\n\n.modal-scrollbar-measure {\n  position: absolute;\n  top: -9999px;\n  width: 50px;\n  height: 50px;\n  overflow: scroll; }\n\n@media (min-width: 768px) {\n  .modal-dialog {\n    width: 700px;\n    margin: 150px auto;\n    background: white;\n    box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.06);\n    border-radius: 4px; }\n  .modal-sm {\n    width: 400px; } }\n\n@media only screen and (max-width: 767px) {\n  .modal-dialog .modal-header .modal-title {\n    padding-left: 5px; }\n  .modal-dialog .modal-header .close {\n    font-size: 20px; }\n  .modal-dialog .modal-body {\n    width: 100%; }\n    .modal-dialog .modal-body table {\n      width: 100%;\n      margin: 20px 0px; }\n      .modal-dialog .modal-body table thead {\n        width: 100%; }\n      .modal-dialog .modal-body table tr {\n        width: 100% !important;\n        padding: 0 20px;\n        display: flex; }\n        .modal-dialog .modal-body table tr th {\n          text-align: left !important;\n          width: 100%;\n          padding: 0; }\n          .modal-dialog .modal-body table tr th:first-child {\n            flex: 1 1 70%; }\n          .modal-dialog .modal-body table tr th:last-child {\n            flex: 1 1 30%;\n            text-align: right !important;\n            padding-right: 12px; }\n          .modal-dialog .modal-body table tr th.Mobile-th {\n            display: none; }\n        .modal-dialog .modal-body table tr td {\n          width: 100%;\n          padding-top: 25px;\n          text-align: left !important;\n          position: relative; }\n          .modal-dialog .modal-body table tr td .td-text {\n            max-width: 150px !important; }\n          .modal-dialog .modal-body table tr td .Mobile {\n            display: block !important;\n            position: absolute;\n            bottom: 10px;\n            left: 46px;\n            font-size: 12px;\n            color: #999; }\n          .modal-dialog .modal-body table tr td:first-child {\n            flex: 1 1 70%; }\n          .modal-dialog .modal-body table tr td:last-child {\n            flex: 1 1 30%;\n            text-align: right !important;\n            font-size: 12px; }\n            .modal-dialog .modal-body table tr td:last-child button {\n              width: 50px;\n              height: 30px; }\n          .modal-dialog .modal-body table tr td.Mobile-none {\n            display: none; }\n          .modal-dialog .modal-body table tr td > div {\n            position: relative; }\n            .modal-dialog .modal-body table tr td > div .label-text {\n              position: absolute;\n              top: 3px;\n              display: inline-block;\n              width: 32px;\n              font-size: 12px !important;\n              height: 22px;\n              line-height: 15px; }\n            .modal-dialog .modal-body table tr td > div .td-text {\n              margin-left: 46px; }\n    .modal-dialog .modal-body .pager {\n      margin: 35px 0; } }\n", ""]);

// exports


/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Enforces a single instance of the Raven client, and the
 * main entry point for Raven. If you are a consumer of the
 * Raven library, you SHOULD load this file (vs raven.js).
 **/

var RavenConstructor = __webpack_require__(1264);

// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
var _window =
  typeof window !== 'undefined'
    ? window
    : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
var _Raven = _window.Raven;

var Raven = new RavenConstructor();

/*
 * Allow multiple versions of Raven to be installed.
 * Strip Raven from the global context and returns the instance.
 *
 * @return {Raven}
 */
Raven.noConflict = function() {
  _window.Raven = _Raven;
  return Raven;
};

Raven.afterLoad();

module.exports = Raven;

/**
 * DISCLAIMER:
 *
 * Expose `Client` constructor for cases where user want to track multiple "sub-applications" in one larger app.
 * It's not meant to be used by a wide audience, so pleaaase make sure that you know what you're doing before using it.
 * Accidentally calling `install` multiple times, may result in an unexpected behavior that's very hard to debug.
 *
 * It's called `Client' to be in-line with Raven Node implementation.
 *
 * HOWTO:
 *
 * import Raven from 'raven-js';
 *
 * const someAppReporter = new Raven.Client();
 * const someOtherAppReporter = new Raven.Client();
 *
 * someAppReporter.config('__DSN__', {
 *   ...config goes here
 * });
 *
 * someOtherAppReporter.config('__OTHER_DSN__', {
 *   ...config goes here
 * });
 *
 * someAppReporter.captureMessage(...);
 * someAppReporter.captureException(...);
 * someAppReporter.captureBreadcrumb(...);
 *
 * someOtherAppReporter.captureMessage(...);
 * someOtherAppReporter.captureException(...);
 * someOtherAppReporter.captureBreadcrumb(...);
 *
 * It should "just work".
 */
module.exports.Client = RavenConstructor;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/*global XDomainRequest:false */

var TraceKit = __webpack_require__(1265);
var stringify = __webpack_require__(344);
var md5 = __webpack_require__(1266);
var RavenConfigError = __webpack_require__(1267);

var utils = __webpack_require__(109);
var isErrorEvent = utils.isErrorEvent;
var isDOMError = utils.isDOMError;
var isDOMException = utils.isDOMException;
var isError = utils.isError;
var isObject = utils.isObject;
var isPlainObject = utils.isPlainObject;
var isUndefined = utils.isUndefined;
var isFunction = utils.isFunction;
var isString = utils.isString;
var isArray = utils.isArray;
var isEmptyObject = utils.isEmptyObject;
var each = utils.each;
var objectMerge = utils.objectMerge;
var truncate = utils.truncate;
var objectFrozen = utils.objectFrozen;
var hasKey = utils.hasKey;
var joinRegExp = utils.joinRegExp;
var urlencode = utils.urlencode;
var uuid4 = utils.uuid4;
var htmlTreeAsString = utils.htmlTreeAsString;
var isSameException = utils.isSameException;
var isSameStacktrace = utils.isSameStacktrace;
var parseUrl = utils.parseUrl;
var fill = utils.fill;
var supportsFetch = utils.supportsFetch;
var supportsReferrerPolicy = utils.supportsReferrerPolicy;
var serializeKeysForMessage = utils.serializeKeysForMessage;
var serializeException = utils.serializeException;
var sanitize = utils.sanitize;

var wrapConsoleMethod = __webpack_require__(1268).wrapMethod;

var dsnKeys = 'source protocol user pass host port path'.split(' '),
  dsnPattern = /^(?:(\w+):)?\/\/(?:(\w+)(:\w+)?@)?([\w\.-]+)(?::(\d+))?(\/.*)/;

function now() {
  return +new Date();
}

// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
var _window =
  typeof window !== 'undefined'
    ? window
    : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
var _document = _window.document;
var _navigator = _window.navigator;

function keepOriginalCallback(original, callback) {
  return isFunction(callback)
    ? function(data) {
        return callback(data, original);
      }
    : callback;
}

// First, check for JSON support
// If there is no JSON, we no-op the core features of Raven
// since JSON is required to encode the payload
function Raven() {
  this._hasJSON = !!(typeof JSON === 'object' && JSON.stringify);
  // Raven can run in contexts where there's no document (react-native)
  this._hasDocument = !isUndefined(_document);
  this._hasNavigator = !isUndefined(_navigator);
  this._lastCapturedException = null;
  this._lastData = null;
  this._lastEventId = null;
  this._globalServer = null;
  this._globalKey = null;
  this._globalProject = null;
  this._globalContext = {};
  this._globalOptions = {
    // SENTRY_RELEASE can be injected by https://github.com/getsentry/sentry-webpack-plugin
    release: _window.SENTRY_RELEASE && _window.SENTRY_RELEASE.id,
    logger: 'javascript',
    ignoreErrors: [],
    ignoreUrls: [],
    whitelistUrls: [],
    includePaths: [],
    headers: null,
    collectWindowErrors: true,
    captureUnhandledRejections: true,
    maxMessageLength: 0,
    // By default, truncates URL values to 250 chars
    maxUrlLength: 250,
    stackTraceLimit: 50,
    autoBreadcrumbs: true,
    instrument: true,
    sampleRate: 1,
    sanitizeKeys: []
  };
  this._fetchDefaults = {
    method: 'POST',
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
    // https://caniuse.com/#feat=referrer-policy
    // It doesn't. And it throw exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    referrerPolicy: supportsReferrerPolicy() ? 'origin' : ''
  };
  this._ignoreOnError = 0;
  this._isRavenInstalled = false;
  this._originalErrorStackTraceLimit = Error.stackTraceLimit;
  // capture references to window.console *and* all its methods first
  // before the console plugin has a chance to monkey patch
  this._originalConsole = _window.console || {};
  this._originalConsoleMethods = {};
  this._plugins = [];
  this._startTime = now();
  this._wrappedBuiltIns = [];
  this._breadcrumbs = [];
  this._lastCapturedEvent = null;
  this._keypressTimeout;
  this._location = _window.location;
  this._lastHref = this._location && this._location.href;
  this._resetBackoff();

  // eslint-disable-next-line guard-for-in
  for (var method in this._originalConsole) {
    this._originalConsoleMethods[method] = this._originalConsole[method];
  }
}

/*
 * The core Raven singleton
 *
 * @this {Raven}
 */

Raven.prototype = {
  // Hardcode version string so that raven source can be loaded directly via
  // webpack (using a build step causes webpack #1617). Grunt verifies that
  // this value matches package.json during build.
  //   See: https://github.com/getsentry/raven-js/issues/465
  VERSION: '3.27.2',

  debug: false,

  TraceKit: TraceKit, // alias to TraceKit

  /*
     * Configure Raven with a DSN and extra options
     *
     * @param {string} dsn The public Sentry DSN
     * @param {object} options Set of global options [optional]
     * @return {Raven}
     */
  config: function(dsn, options) {
    var self = this;

    if (self._globalServer) {
      this._logDebug('error', 'Error: Raven has already been configured');
      return self;
    }
    if (!dsn) return self;

    var globalOptions = self._globalOptions;

    // merge in options
    if (options) {
      each(options, function(key, value) {
        // tags and extra are special and need to be put into context
        if (key === 'tags' || key === 'extra' || key === 'user') {
          self._globalContext[key] = value;
        } else {
          globalOptions[key] = value;
        }
      });
    }

    self.setDSN(dsn);

    // "Script error." is hard coded into browsers for errors that it can't read.
    // this is the result of a script being pulled in from an external domain and CORS.
    globalOptions.ignoreErrors.push(/^Script error\.?$/);
    globalOptions.ignoreErrors.push(/^Javascript error: Script error\.? on line 0$/);

    // join regexp rules into one big rule
    globalOptions.ignoreErrors = joinRegExp(globalOptions.ignoreErrors);
    globalOptions.ignoreUrls = globalOptions.ignoreUrls.length
      ? joinRegExp(globalOptions.ignoreUrls)
      : false;
    globalOptions.whitelistUrls = globalOptions.whitelistUrls.length
      ? joinRegExp(globalOptions.whitelistUrls)
      : false;
    globalOptions.includePaths = joinRegExp(globalOptions.includePaths);
    globalOptions.maxBreadcrumbs = Math.max(
      0,
      Math.min(globalOptions.maxBreadcrumbs || 100, 100)
    ); // default and hard limit is 100

    var autoBreadcrumbDefaults = {
      xhr: true,
      console: true,
      dom: true,
      location: true,
      sentry: true
    };

    var autoBreadcrumbs = globalOptions.autoBreadcrumbs;
    if ({}.toString.call(autoBreadcrumbs) === '[object Object]') {
      autoBreadcrumbs = objectMerge(autoBreadcrumbDefaults, autoBreadcrumbs);
    } else if (autoBreadcrumbs !== false) {
      autoBreadcrumbs = autoBreadcrumbDefaults;
    }
    globalOptions.autoBreadcrumbs = autoBreadcrumbs;

    var instrumentDefaults = {
      tryCatch: true
    };

    var instrument = globalOptions.instrument;
    if ({}.toString.call(instrument) === '[object Object]') {
      instrument = objectMerge(instrumentDefaults, instrument);
    } else if (instrument !== false) {
      instrument = instrumentDefaults;
    }
    globalOptions.instrument = instrument;

    TraceKit.collectWindowErrors = !!globalOptions.collectWindowErrors;

    // return for chaining
    return self;
  },

  /*
     * Installs a global window.onerror error handler
     * to capture and report uncaught exceptions.
     * At this point, install() is required to be called due
     * to the way TraceKit is set up.
     *
     * @return {Raven}
     */
  install: function() {
    var self = this;
    if (self.isSetup() && !self._isRavenInstalled) {
      TraceKit.report.subscribe(function() {
        self._handleOnErrorStackInfo.apply(self, arguments);
      });

      if (self._globalOptions.captureUnhandledRejections) {
        self._attachPromiseRejectionHandler();
      }

      self._patchFunctionToString();

      if (self._globalOptions.instrument && self._globalOptions.instrument.tryCatch) {
        self._instrumentTryCatch();
      }

      if (self._globalOptions.autoBreadcrumbs) self._instrumentBreadcrumbs();

      // Install all of the plugins
      self._drainPlugins();

      self._isRavenInstalled = true;
    }

    Error.stackTraceLimit = self._globalOptions.stackTraceLimit;
    return this;
  },

  /*
     * Set the DSN (can be called multiple time unlike config)
     *
     * @param {string} dsn The public Sentry DSN
     */
  setDSN: function(dsn) {
    var self = this,
      uri = self._parseDSN(dsn),
      lastSlash = uri.path.lastIndexOf('/'),
      path = uri.path.substr(1, lastSlash);

    self._dsn = dsn;
    self._globalKey = uri.user;
    self._globalSecret = uri.pass && uri.pass.substr(1);
    self._globalProject = uri.path.substr(lastSlash + 1);

    self._globalServer = self._getGlobalServer(uri);

    self._globalEndpoint =
      self._globalServer + '/' + path + 'api/' + self._globalProject + '/store/';

    // Reset backoff state since we may be pointing at a
    // new project/server
    this._resetBackoff();
  },

  /*
     * Wrap code within a context so Raven can capture errors
     * reliably across domains that is executed immediately.
     *
     * @param {object} options A specific set of options for this context [optional]
     * @param {function} func The callback to be immediately executed within the context
     * @param {array} args An array of arguments to be called with the callback [optional]
     */
  context: function(options, func, args) {
    if (isFunction(options)) {
      args = func || [];
      func = options;
      options = {};
    }

    return this.wrap(options, func).apply(this, args);
  },

  /*
     * Wrap code within a context and returns back a new function to be executed
     *
     * @param {object} options A specific set of options for this context [optional]
     * @param {function} func The function to be wrapped in a new context
     * @param {function} _before A function to call before the try/catch wrapper [optional, private]
     * @return {function} The newly wrapped functions with a context
     */
  wrap: function(options, func, _before) {
    var self = this;
    // 1 argument has been passed, and it's not a function
    // so just return it
    if (isUndefined(func) && !isFunction(options)) {
      return options;
    }

    // options is optional
    if (isFunction(options)) {
      func = options;
      options = undefined;
    }

    // At this point, we've passed along 2 arguments, and the second one
    // is not a function either, so we'll just return the second argument.
    if (!isFunction(func)) {
      return func;
    }

    // We don't wanna wrap it twice!
    try {
      if (func.__raven__) {
        return func;
      }

      // If this has already been wrapped in the past, return that
      if (func.__raven_wrapper__) {
        return func.__raven_wrapper__;
      }
    } catch (e) {
      // Just accessing custom props in some Selenium environments
      // can cause a "Permission denied" exception (see raven-js#495).
      // Bail on wrapping and return the function as-is (defers to window.onerror).
      return func;
    }

    function wrapped() {
      var args = [],
        i = arguments.length,
        deep = !options || (options && options.deep !== false);

      if (_before && isFunction(_before)) {
        _before.apply(this, arguments);
      }

      // Recursively wrap all of a function's arguments that are
      // functions themselves.
      while (i--) args[i] = deep ? self.wrap(options, arguments[i]) : arguments[i];

      try {
        // Attempt to invoke user-land function
        // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
        //       means Raven caught an error invoking your application code. This is
        //       expected behavior and NOT indicative of a bug with Raven.js.
        return func.apply(this, args);
      } catch (e) {
        self._ignoreNextOnError();
        self.captureException(e, options);
        throw e;
      }
    }

    // copy over properties of the old function
    for (var property in func) {
      if (hasKey(func, property)) {
        wrapped[property] = func[property];
      }
    }
    wrapped.prototype = func.prototype;

    func.__raven_wrapper__ = wrapped;
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    wrapped.__raven__ = true;
    wrapped.__orig__ = func;

    return wrapped;
  },

  /**
   * Uninstalls the global error handler.
   *
   * @return {Raven}
   */
  uninstall: function() {
    TraceKit.report.uninstall();

    this._detachPromiseRejectionHandler();
    this._unpatchFunctionToString();
    this._restoreBuiltIns();
    this._restoreConsole();

    Error.stackTraceLimit = this._originalErrorStackTraceLimit;
    this._isRavenInstalled = false;

    return this;
  },

  /**
   * Callback used for `unhandledrejection` event
   *
   * @param {PromiseRejectionEvent} event An object containing
   *   promise: the Promise that was rejected
   *   reason: the value with which the Promise was rejected
   * @return void
   */
  _promiseRejectionHandler: function(event) {
    this._logDebug('debug', 'Raven caught unhandled promise rejection:', event);
    this.captureException(event.reason, {
      mechanism: {
        type: 'onunhandledrejection',
        handled: false
      }
    });
  },

  /**
   * Installs the global promise rejection handler.
   *
   * @return {raven}
   */
  _attachPromiseRejectionHandler: function() {
    this._promiseRejectionHandler = this._promiseRejectionHandler.bind(this);
    _window.addEventListener &&
      _window.addEventListener('unhandledrejection', this._promiseRejectionHandler);
    return this;
  },

  /**
   * Uninstalls the global promise rejection handler.
   *
   * @return {raven}
   */
  _detachPromiseRejectionHandler: function() {
    _window.removeEventListener &&
      _window.removeEventListener('unhandledrejection', this._promiseRejectionHandler);
    return this;
  },

  /**
   * Manually capture an exception and send it over to Sentry
   *
   * @param {error} ex An exception to be logged
   * @param {object} options A specific set of options for this error [optional]
   * @return {Raven}
   */
  captureException: function(ex, options) {
    options = objectMerge({trimHeadFrames: 0}, options ? options : {});

    if (isErrorEvent(ex) && ex.error) {
      // If it is an ErrorEvent with `error` property, extract it to get actual Error
      ex = ex.error;
    } else if (isDOMError(ex) || isDOMException(ex)) {
      // If it is a DOMError or DOMException (which are legacy APIs, but still supported in some browsers)
      // then we just extract the name and message, as they don't provide anything else
      // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
      // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
      var name = ex.name || (isDOMError(ex) ? 'DOMError' : 'DOMException');
      var message = ex.message ? name + ': ' + ex.message : name;

      return this.captureMessage(
        message,
        objectMerge(options, {
          // neither DOMError or DOMException provide stack trace and we most likely wont get it this way as well
          // but it's barely any overhead so we may at least try
          stacktrace: true,
          trimHeadFrames: options.trimHeadFrames + 1
        })
      );
    } else if (isError(ex)) {
      // we have a real Error object
      ex = ex;
    } else if (isPlainObject(ex)) {
      // If it is plain Object, serialize it manually and extract options
      // This will allow us to group events based on top-level keys
      // which is much better than creating new group when any key/value change
      options = this._getCaptureExceptionOptionsFromPlainObject(options, ex);
      ex = new Error(options.message);
    } else {
      // If none of previous checks were valid, then it means that
      // it's not a DOMError/DOMException
      // it's not a plain Object
      // it's not a valid ErrorEvent (one with an error property)
      // it's not an Error
      // So bail out and capture it as a simple message:
      return this.captureMessage(
        ex,
        objectMerge(options, {
          stacktrace: true, // if we fall back to captureMessage, default to attempting a new trace
          trimHeadFrames: options.trimHeadFrames + 1
        })
      );
    }

    // Store the raw exception object for potential debugging and introspection
    this._lastCapturedException = ex;

    // TraceKit.report will re-raise any exception passed to it,
    // which means you have to wrap it in try/catch. Instead, we
    // can wrap it here and only re-raise if TraceKit.report
    // raises an exception different from the one we asked to
    // report on.
    try {
      var stack = TraceKit.computeStackTrace(ex);
      this._handleStackInfo(stack, options);
    } catch (ex1) {
      if (ex !== ex1) {
        throw ex1;
      }
    }

    return this;
  },

  _getCaptureExceptionOptionsFromPlainObject: function(currentOptions, ex) {
    var exKeys = Object.keys(ex).sort();
    var options = objectMerge(currentOptions, {
      message:
        'Non-Error exception captured with keys: ' + serializeKeysForMessage(exKeys),
      fingerprint: [md5(exKeys)],
      extra: currentOptions.extra || {}
    });
    options.extra.__serialized__ = serializeException(ex);

    return options;
  },

  /*
     * Manually send a message to Sentry
     *
     * @param {string} msg A plain message to be captured in Sentry
     * @param {object} options A specific set of options for this message [optional]
     * @return {Raven}
     */
  captureMessage: function(msg, options) {
    // config() automagically converts ignoreErrors from a list to a RegExp so we need to test for an
    // early call; we'll error on the side of logging anything called before configuration since it's
    // probably something you should see:
    if (
      !!this._globalOptions.ignoreErrors.test &&
      this._globalOptions.ignoreErrors.test(msg)
    ) {
      return;
    }

    options = options || {};
    msg = msg + ''; // Make sure it's actually a string

    var data = objectMerge(
      {
        message: msg
      },
      options
    );

    var ex;
    // Generate a "synthetic" stack trace from this point.
    // NOTE: If you are a Sentry user, and you are seeing this stack frame, it is NOT indicative
    //       of a bug with Raven.js. Sentry generates synthetic traces either by configuration,
    //       or if it catches a thrown object without a "stack" property.
    try {
      throw new Error(msg);
    } catch (ex1) {
      ex = ex1;
    }

    // null exception name so `Error` isn't prefixed to msg
    ex.name = null;
    var stack = TraceKit.computeStackTrace(ex);

    // stack[0] is `throw new Error(msg)` call itself, we are interested in the frame that was just before that, stack[1]
    var initialCall = isArray(stack.stack) && stack.stack[1];

    // if stack[1] is `Raven.captureException`, it means that someone passed a string to it and we redirected that call
    // to be handled by `captureMessage`, thus `initialCall` is the 3rd one, not 2nd
    // initialCall => captureException(string) => captureMessage(string)
    if (initialCall && initialCall.func === 'Raven.captureException') {
      initialCall = stack.stack[2];
    }

    var fileurl = (initialCall && initialCall.url) || '';

    if (
      !!this._globalOptions.ignoreUrls.test &&
      this._globalOptions.ignoreUrls.test(fileurl)
    ) {
      return;
    }

    if (
      !!this._globalOptions.whitelistUrls.test &&
      !this._globalOptions.whitelistUrls.test(fileurl)
    ) {
      return;
    }

    // Always attempt to get stacktrace if message is empty.
    // It's the only way to provide any helpful information to the user.
    if (this._globalOptions.stacktrace || options.stacktrace || data.message === '') {
      // fingerprint on msg, not stack trace (legacy behavior, could be revisited)
      data.fingerprint = data.fingerprint == null ? msg : data.fingerprint;

      options = objectMerge(
        {
          trimHeadFrames: 0
        },
        options
      );
      // Since we know this is a synthetic trace, the top frame (this function call)
      // MUST be from Raven.js, so mark it for trimming
      // We add to the trim counter so that callers can choose to trim extra frames, such
      // as utility functions.
      options.trimHeadFrames += 1;

      var frames = this._prepareFrames(stack, options);
      data.stacktrace = {
        // Sentry expects frames oldest to newest
        frames: frames.reverse()
      };
    }

    // Make sure that fingerprint is always wrapped in an array
    if (data.fingerprint) {
      data.fingerprint = isArray(data.fingerprint)
        ? data.fingerprint
        : [data.fingerprint];
    }

    // Fire away!
    this._send(data);

    return this;
  },

  captureBreadcrumb: function(obj) {
    var crumb = objectMerge(
      {
        timestamp: now() / 1000
      },
      obj
    );

    if (isFunction(this._globalOptions.breadcrumbCallback)) {
      var result = this._globalOptions.breadcrumbCallback(crumb);

      if (isObject(result) && !isEmptyObject(result)) {
        crumb = result;
      } else if (result === false) {
        return this;
      }
    }

    this._breadcrumbs.push(crumb);
    if (this._breadcrumbs.length > this._globalOptions.maxBreadcrumbs) {
      this._breadcrumbs.shift();
    }
    return this;
  },

  addPlugin: function(plugin /*arg1, arg2, ... argN*/) {
    var pluginArgs = [].slice.call(arguments, 1);

    this._plugins.push([plugin, pluginArgs]);
    if (this._isRavenInstalled) {
      this._drainPlugins();
    }

    return this;
  },

  /*
     * Set/clear a user to be sent along with the payload.
     *
     * @param {object} user An object representing user data [optional]
     * @return {Raven}
     */
  setUserContext: function(user) {
    // Intentionally do not merge here since that's an unexpected behavior.
    this._globalContext.user = user;

    return this;
  },

  /*
     * Merge extra attributes to be sent along with the payload.
     *
     * @param {object} extra An object representing extra data [optional]
     * @return {Raven}
     */
  setExtraContext: function(extra) {
    this._mergeContext('extra', extra);

    return this;
  },

  /*
     * Merge tags to be sent along with the payload.
     *
     * @param {object} tags An object representing tags [optional]
     * @return {Raven}
     */
  setTagsContext: function(tags) {
    this._mergeContext('tags', tags);

    return this;
  },

  /*
     * Clear all of the context.
     *
     * @return {Raven}
     */
  clearContext: function() {
    this._globalContext = {};

    return this;
  },

  /*
     * Get a copy of the current context. This cannot be mutated.
     *
     * @return {object} copy of context
     */
  getContext: function() {
    // lol javascript
    return JSON.parse(stringify(this._globalContext));
  },

  /*
     * Set environment of application
     *
     * @param {string} environment Typically something like 'production'.
     * @return {Raven}
     */
  setEnvironment: function(environment) {
    this._globalOptions.environment = environment;

    return this;
  },

  /*
     * Set release version of application
     *
     * @param {string} release Typically something like a git SHA to identify version
     * @return {Raven}
     */
  setRelease: function(release) {
    this._globalOptions.release = release;

    return this;
  },

  /*
     * Set the dataCallback option
     *
     * @param {function} callback The callback to run which allows the
     *                            data blob to be mutated before sending
     * @return {Raven}
     */
  setDataCallback: function(callback) {
    var original = this._globalOptions.dataCallback;
    this._globalOptions.dataCallback = keepOriginalCallback(original, callback);
    return this;
  },

  /*
     * Set the breadcrumbCallback option
     *
     * @param {function} callback The callback to run which allows filtering
     *                            or mutating breadcrumbs
     * @return {Raven}
     */
  setBreadcrumbCallback: function(callback) {
    var original = this._globalOptions.breadcrumbCallback;
    this._globalOptions.breadcrumbCallback = keepOriginalCallback(original, callback);
    return this;
  },

  /*
     * Set the shouldSendCallback option
     *
     * @param {function} callback The callback to run which allows
     *                            introspecting the blob before sending
     * @return {Raven}
     */
  setShouldSendCallback: function(callback) {
    var original = this._globalOptions.shouldSendCallback;
    this._globalOptions.shouldSendCallback = keepOriginalCallback(original, callback);
    return this;
  },

  /**
   * Override the default HTTP transport mechanism that transmits data
   * to the Sentry server.
   *
   * @param {function} transport Function invoked instead of the default
   *                             `makeRequest` handler.
   *
   * @return {Raven}
   */
  setTransport: function(transport) {
    this._globalOptions.transport = transport;

    return this;
  },

  /*
     * Get the latest raw exception that was captured by Raven.
     *
     * @return {error}
     */
  lastException: function() {
    return this._lastCapturedException;
  },

  /*
     * Get the last event id
     *
     * @return {string}
     */
  lastEventId: function() {
    return this._lastEventId;
  },

  /*
     * Determine if Raven is setup and ready to go.
     *
     * @return {boolean}
     */
  isSetup: function() {
    if (!this._hasJSON) return false; // needs JSON support
    if (!this._globalServer) {
      if (!this.ravenNotConfiguredError) {
        this.ravenNotConfiguredError = true;
        this._logDebug('error', 'Error: Raven has not been configured.');
      }
      return false;
    }
    return true;
  },

  afterLoad: function() {
    // TODO: remove window dependence?

    // Attempt to initialize Raven on load
    var RavenConfig = _window.RavenConfig;
    if (RavenConfig) {
      this.config(RavenConfig.dsn, RavenConfig.config).install();
    }
  },

  showReportDialog: function(options) {
    if (
      !_document // doesn't work without a document (React native)
    )
      return;

    options = objectMerge(
      {
        eventId: this.lastEventId(),
        dsn: this._dsn,
        user: this._globalContext.user || {}
      },
      options
    );

    if (!options.eventId) {
      throw new RavenConfigError('Missing eventId');
    }

    if (!options.dsn) {
      throw new RavenConfigError('Missing DSN');
    }

    var encode = encodeURIComponent;
    var encodedOptions = [];

    for (var key in options) {
      if (key === 'user') {
        var user = options.user;
        if (user.name) encodedOptions.push('name=' + encode(user.name));
        if (user.email) encodedOptions.push('email=' + encode(user.email));
      } else {
        encodedOptions.push(encode(key) + '=' + encode(options[key]));
      }
    }
    var globalServer = this._getGlobalServer(this._parseDSN(options.dsn));

    var script = _document.createElement('script');
    script.async = true;
    script.src = globalServer + '/api/embed/error-page/?' + encodedOptions.join('&');
    (_document.head || _document.body).appendChild(script);
  },

  /**** Private functions ****/
  _ignoreNextOnError: function() {
    var self = this;
    this._ignoreOnError += 1;
    setTimeout(function() {
      // onerror should trigger before setTimeout
      self._ignoreOnError -= 1;
    });
  },

  _triggerEvent: function(eventType, options) {
    // NOTE: `event` is a native browser thing, so let's avoid conflicting wiht it
    var evt, key;

    if (!this._hasDocument) return;

    options = options || {};

    eventType = 'raven' + eventType.substr(0, 1).toUpperCase() + eventType.substr(1);

    if (_document.createEvent) {
      evt = _document.createEvent('HTMLEvents');
      evt.initEvent(eventType, true, true);
    } else {
      evt = _document.createEventObject();
      evt.eventType = eventType;
    }

    for (key in options)
      if (hasKey(options, key)) {
        evt[key] = options[key];
      }

    if (_document.createEvent) {
      // IE9 if standards
      _document.dispatchEvent(evt);
    } else {
      // IE8 regardless of Quirks or Standards
      // IE9 if quirks
      try {
        _document.fireEvent('on' + evt.eventType.toLowerCase(), evt);
      } catch (e) {
        // Do nothing
      }
    }
  },

  /**
   * Wraps addEventListener to capture UI breadcrumbs
   * @param evtName the event name (e.g. "click")
   * @returns {Function}
   * @private
   */
  _breadcrumbEventHandler: function(evtName) {
    var self = this;
    return function(evt) {
      // reset keypress timeout; e.g. triggering a 'click' after
      // a 'keypress' will reset the keypress debounce so that a new
      // set of keypresses can be recorded
      self._keypressTimeout = null;

      // It's possible this handler might trigger multiple times for the same
      // event (e.g. event propagation through node ancestors). Ignore if we've
      // already captured the event.
      if (self._lastCapturedEvent === evt) return;

      self._lastCapturedEvent = evt;

      // try/catch both:
      // - accessing evt.target (see getsentry/raven-js#838, #768)
      // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
      //   can throw an exception in some circumstances.
      var target;
      try {
        target = htmlTreeAsString(evt.target);
      } catch (e) {
        target = '<unknown>';
      }

      self.captureBreadcrumb({
        category: 'ui.' + evtName, // e.g. ui.click, ui.input
        message: target
      });
    };
  },

  /**
   * Wraps addEventListener to capture keypress UI events
   * @returns {Function}
   * @private
   */
  _keypressEventHandler: function() {
    var self = this,
      debounceDuration = 1000; // milliseconds

    // TODO: if somehow user switches keypress target before
    //       debounce timeout is triggered, we will only capture
    //       a single breadcrumb from the FIRST target (acceptable?)
    return function(evt) {
      var target;
      try {
        target = evt.target;
      } catch (e) {
        // just accessing event properties can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/raven-js/issues/838
        return;
      }
      var tagName = target && target.tagName;

      // only consider keypress events on actual input elements
      // this will disregard keypresses targeting body (e.g. tabbing
      // through elements, hotkeys, etc)
      if (
        !tagName ||
        (tagName !== 'INPUT' && tagName !== 'TEXTAREA' && !target.isContentEditable)
      )
        return;

      // record first keypress in a series, but ignore subsequent
      // keypresses until debounce clears
      var timeout = self._keypressTimeout;
      if (!timeout) {
        self._breadcrumbEventHandler('input')(evt);
      }
      clearTimeout(timeout);
      self._keypressTimeout = setTimeout(function() {
        self._keypressTimeout = null;
      }, debounceDuration);
    };
  },

  /**
   * Captures a breadcrumb of type "navigation", normalizing input URLs
   * @param to the originating URL
   * @param from the target URL
   * @private
   */
  _captureUrlChange: function(from, to) {
    var parsedLoc = parseUrl(this._location.href);
    var parsedTo = parseUrl(to);
    var parsedFrom = parseUrl(from);

    // because onpopstate only tells you the "new" (to) value of location.href, and
    // not the previous (from) value, we need to track the value of the current URL
    // state ourselves
    this._lastHref = to;

    // Use only the path component of the URL if the URL matches the current
    // document (almost all the time when using pushState)
    if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host)
      to = parsedTo.relative;
    if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host)
      from = parsedFrom.relative;

    this.captureBreadcrumb({
      category: 'navigation',
      data: {
        to: to,
        from: from
      }
    });
  },

  _patchFunctionToString: function() {
    var self = this;
    self._originalFunctionToString = Function.prototype.toString;
    // eslint-disable-next-line no-extend-native
    Function.prototype.toString = function() {
      if (typeof this === 'function' && this.__raven__) {
        return self._originalFunctionToString.apply(this.__orig__, arguments);
      }
      return self._originalFunctionToString.apply(this, arguments);
    };
  },

  _unpatchFunctionToString: function() {
    if (this._originalFunctionToString) {
      // eslint-disable-next-line no-extend-native
      Function.prototype.toString = this._originalFunctionToString;
    }
  },

  /**
   * Wrap timer functions and event targets to catch errors and provide
   * better metadata.
   */
  _instrumentTryCatch: function() {
    var self = this;

    var wrappedBuiltIns = self._wrappedBuiltIns;

    function wrapTimeFn(orig) {
      return function(fn, t) {
        // preserve arity
        // Make a copy of the arguments to prevent deoptimization
        // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
        var args = new Array(arguments.length);
        for (var i = 0; i < args.length; ++i) {
          args[i] = arguments[i];
        }
        var originalCallback = args[0];
        if (isFunction(originalCallback)) {
          args[0] = self.wrap(
            {
              mechanism: {
                type: 'instrument',
                data: {function: orig.name || '<anonymous>'}
              }
            },
            originalCallback
          );
        }

        // IE < 9 doesn't support .call/.apply on setInterval/setTimeout, but it
        // also supports only two arguments and doesn't care what this is, so we
        // can just call the original function directly.
        if (orig.apply) {
          return orig.apply(this, args);
        } else {
          return orig(args[0], args[1]);
        }
      };
    }

    var autoBreadcrumbs = this._globalOptions.autoBreadcrumbs;

    function wrapEventTarget(global) {
      var proto = _window[global] && _window[global].prototype;
      if (proto && proto.hasOwnProperty && proto.hasOwnProperty('addEventListener')) {
        fill(
          proto,
          'addEventListener',
          function(orig) {
            return function(evtName, fn, capture, secure) {
              // preserve arity
              try {
                if (fn && fn.handleEvent) {
                  fn.handleEvent = self.wrap(
                    {
                      mechanism: {
                        type: 'instrument',
                        data: {
                          target: global,
                          function: 'handleEvent',
                          handler: (fn && fn.name) || '<anonymous>'
                        }
                      }
                    },
                    fn.handleEvent
                  );
                }
              } catch (err) {
                // can sometimes get 'Permission denied to access property "handle Event'
              }

              // More breadcrumb DOM capture ... done here and not in `_instrumentBreadcrumbs`
              // so that we don't have more than one wrapper function
              var before, clickHandler, keypressHandler;

              if (
                autoBreadcrumbs &&
                autoBreadcrumbs.dom &&
                (global === 'EventTarget' || global === 'Node')
              ) {
                // NOTE: generating multiple handlers per addEventListener invocation, should
                //       revisit and verify we can just use one (almost certainly)
                clickHandler = self._breadcrumbEventHandler('click');
                keypressHandler = self._keypressEventHandler();
                before = function(evt) {
                  // need to intercept every DOM event in `before` argument, in case that
                  // same wrapped method is re-used for different events (e.g. mousemove THEN click)
                  // see #724
                  if (!evt) return;

                  var eventType;
                  try {
                    eventType = evt.type;
                  } catch (e) {
                    // just accessing event properties can throw an exception in some rare circumstances
                    // see: https://github.com/getsentry/raven-js/issues/838
                    return;
                  }
                  if (eventType === 'click') return clickHandler(evt);
                  else if (eventType === 'keypress') return keypressHandler(evt);
                };
              }
              return orig.call(
                this,
                evtName,
                self.wrap(
                  {
                    mechanism: {
                      type: 'instrument',
                      data: {
                        target: global,
                        function: 'addEventListener',
                        handler: (fn && fn.name) || '<anonymous>'
                      }
                    }
                  },
                  fn,
                  before
                ),
                capture,
                secure
              );
            };
          },
          wrappedBuiltIns
        );
        fill(
          proto,
          'removeEventListener',
          function(orig) {
            return function(evt, fn, capture, secure) {
              try {
                fn = fn && (fn.__raven_wrapper__ ? fn.__raven_wrapper__ : fn);
              } catch (e) {
                // ignore, accessing __raven_wrapper__ will throw in some Selenium environments
              }
              return orig.call(this, evt, fn, capture, secure);
            };
          },
          wrappedBuiltIns
        );
      }
    }

    fill(_window, 'setTimeout', wrapTimeFn, wrappedBuiltIns);
    fill(_window, 'setInterval', wrapTimeFn, wrappedBuiltIns);
    if (_window.requestAnimationFrame) {
      fill(
        _window,
        'requestAnimationFrame',
        function(orig) {
          return function(cb) {
            return orig(
              self.wrap(
                {
                  mechanism: {
                    type: 'instrument',
                    data: {
                      function: 'requestAnimationFrame',
                      handler: (orig && orig.name) || '<anonymous>'
                    }
                  }
                },
                cb
              )
            );
          };
        },
        wrappedBuiltIns
      );
    }

    // event targets borrowed from bugsnag-js:
    // https://github.com/bugsnag/bugsnag-js/blob/master/src/bugsnag.js#L666
    var eventTargets = [
      'EventTarget',
      'Window',
      'Node',
      'ApplicationCache',
      'AudioTrackList',
      'ChannelMergerNode',
      'CryptoOperation',
      'EventSource',
      'FileReader',
      'HTMLUnknownElement',
      'IDBDatabase',
      'IDBRequest',
      'IDBTransaction',
      'KeyOperation',
      'MediaController',
      'MessagePort',
      'ModalWindow',
      'Notification',
      'SVGElementInstance',
      'Screen',
      'TextTrack',
      'TextTrackCue',
      'TextTrackList',
      'WebSocket',
      'WebSocketWorker',
      'Worker',
      'XMLHttpRequest',
      'XMLHttpRequestEventTarget',
      'XMLHttpRequestUpload'
    ];
    for (var i = 0; i < eventTargets.length; i++) {
      wrapEventTarget(eventTargets[i]);
    }
  },

  /**
   * Instrument browser built-ins w/ breadcrumb capturing
   *  - XMLHttpRequests
   *  - DOM interactions (click/typing)
   *  - window.location changes
   *  - console
   *
   * Can be disabled or individually configured via the `autoBreadcrumbs` config option
   */
  _instrumentBreadcrumbs: function() {
    var self = this;
    var autoBreadcrumbs = this._globalOptions.autoBreadcrumbs;

    var wrappedBuiltIns = self._wrappedBuiltIns;

    function wrapProp(prop, xhr) {
      if (prop in xhr && isFunction(xhr[prop])) {
        fill(xhr, prop, function(orig) {
          return self.wrap(
            {
              mechanism: {
                type: 'instrument',
                data: {function: prop, handler: (orig && orig.name) || '<anonymous>'}
              }
            },
            orig
          );
        }); // intentionally don't track filled methods on XHR instances
      }
    }

    if (autoBreadcrumbs.xhr && 'XMLHttpRequest' in _window) {
      var xhrproto = _window.XMLHttpRequest && _window.XMLHttpRequest.prototype;
      fill(
        xhrproto,
        'open',
        function(origOpen) {
          return function(method, url) {
            // preserve arity

            // if Sentry key appears in URL, don't capture
            if (isString(url) && url.indexOf(self._globalKey) === -1) {
              this.__raven_xhr = {
                method: method,
                url: url,
                status_code: null
              };
            }

            return origOpen.apply(this, arguments);
          };
        },
        wrappedBuiltIns
      );

      fill(
        xhrproto,
        'send',
        function(origSend) {
          return function() {
            // preserve arity
            var xhr = this;

            function onreadystatechangeHandler() {
              if (xhr.__raven_xhr && xhr.readyState === 4) {
                try {
                  // touching statusCode in some platforms throws
                  // an exception
                  xhr.__raven_xhr.status_code = xhr.status;
                } catch (e) {
                  /* do nothing */
                }

                self.captureBreadcrumb({
                  type: 'http',
                  category: 'xhr',
                  data: xhr.__raven_xhr
                });
              }
            }

            var props = ['onload', 'onerror', 'onprogress'];
            for (var j = 0; j < props.length; j++) {
              wrapProp(props[j], xhr);
            }

            if ('onreadystatechange' in xhr && isFunction(xhr.onreadystatechange)) {
              fill(
                xhr,
                'onreadystatechange',
                function(orig) {
                  return self.wrap(
                    {
                      mechanism: {
                        type: 'instrument',
                        data: {
                          function: 'onreadystatechange',
                          handler: (orig && orig.name) || '<anonymous>'
                        }
                      }
                    },
                    orig,
                    onreadystatechangeHandler
                  );
                } /* intentionally don't track this instrumentation */
              );
            } else {
              // if onreadystatechange wasn't actually set by the page on this xhr, we
              // are free to set our own and capture the breadcrumb
              xhr.onreadystatechange = onreadystatechangeHandler;
            }

            return origSend.apply(this, arguments);
          };
        },
        wrappedBuiltIns
      );
    }

    if (autoBreadcrumbs.xhr && supportsFetch()) {
      fill(
        _window,
        'fetch',
        function(origFetch) {
          return function() {
            // preserve arity
            // Make a copy of the arguments to prevent deoptimization
            // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
            var args = new Array(arguments.length);
            for (var i = 0; i < args.length; ++i) {
              args[i] = arguments[i];
            }

            var fetchInput = args[0];
            var method = 'GET';
            var url;

            if (typeof fetchInput === 'string') {
              url = fetchInput;
            } else if ('Request' in _window && fetchInput instanceof _window.Request) {
              url = fetchInput.url;
              if (fetchInput.method) {
                method = fetchInput.method;
              }
            } else {
              url = '' + fetchInput;
            }

            // if Sentry key appears in URL, don't capture, as it's our own request
            if (url.indexOf(self._globalKey) !== -1) {
              return origFetch.apply(this, args);
            }

            if (args[1] && args[1].method) {
              method = args[1].method;
            }

            var fetchData = {
              method: method,
              url: url,
              status_code: null
            };

            return origFetch
              .apply(this, args)
              .then(function(response) {
                fetchData.status_code = response.status;

                self.captureBreadcrumb({
                  type: 'http',
                  category: 'fetch',
                  data: fetchData
                });

                return response;
              })
              ['catch'](function(err) {
                // if there is an error performing the request
                self.captureBreadcrumb({
                  type: 'http',
                  category: 'fetch',
                  data: fetchData,
                  level: 'error'
                });

                throw err;
              });
          };
        },
        wrappedBuiltIns
      );
    }

    // Capture breadcrumbs from any click that is unhandled / bubbled up all the way
    // to the document. Do this before we instrument addEventListener.
    if (autoBreadcrumbs.dom && this._hasDocument) {
      if (_document.addEventListener) {
        _document.addEventListener('click', self._breadcrumbEventHandler('click'), false);
        _document.addEventListener('keypress', self._keypressEventHandler(), false);
      } else if (_document.attachEvent) {
        // IE8 Compatibility
        _document.attachEvent('onclick', self._breadcrumbEventHandler('click'));
        _document.attachEvent('onkeypress', self._keypressEventHandler());
      }
    }

    // record navigation (URL) changes
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    var chrome = _window.chrome;
    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    var hasPushAndReplaceState =
      !isChromePackagedApp &&
      _window.history &&
      _window.history.pushState &&
      _window.history.replaceState;
    if (autoBreadcrumbs.location && hasPushAndReplaceState) {
      // TODO: remove onpopstate handler on uninstall()
      var oldOnPopState = _window.onpopstate;
      _window.onpopstate = function() {
        var currentHref = self._location.href;
        self._captureUrlChange(self._lastHref, currentHref);

        if (oldOnPopState) {
          return oldOnPopState.apply(this, arguments);
        }
      };

      var historyReplacementFunction = function(origHistFunction) {
        // note history.pushState.length is 0; intentionally not declaring
        // params to preserve 0 arity
        return function(/* state, title, url */) {
          var url = arguments.length > 2 ? arguments[2] : undefined;

          // url argument is optional
          if (url) {
            // coerce to string (this is what pushState does)
            self._captureUrlChange(self._lastHref, url + '');
          }

          return origHistFunction.apply(this, arguments);
        };
      };

      fill(_window.history, 'pushState', historyReplacementFunction, wrappedBuiltIns);
      fill(_window.history, 'replaceState', historyReplacementFunction, wrappedBuiltIns);
    }

    if (autoBreadcrumbs.console && 'console' in _window && console.log) {
      // console
      var consoleMethodCallback = function(msg, data) {
        self.captureBreadcrumb({
          message: msg,
          level: data.level,
          category: 'console'
        });
      };

      each(['debug', 'info', 'warn', 'error', 'log'], function(_, level) {
        wrapConsoleMethod(console, level, consoleMethodCallback);
      });
    }
  },

  _restoreBuiltIns: function() {
    // restore any wrapped builtins
    var builtin;
    while (this._wrappedBuiltIns.length) {
      builtin = this._wrappedBuiltIns.shift();

      var obj = builtin[0],
        name = builtin[1],
        orig = builtin[2];

      obj[name] = orig;
    }
  },

  _restoreConsole: function() {
    // eslint-disable-next-line guard-for-in
    for (var method in this._originalConsoleMethods) {
      this._originalConsole[method] = this._originalConsoleMethods[method];
    }
  },

  _drainPlugins: function() {
    var self = this;

    // FIX ME TODO
    each(this._plugins, function(_, plugin) {
      var installer = plugin[0];
      var args = plugin[1];
      installer.apply(self, [self].concat(args));
    });
  },

  _parseDSN: function(str) {
    var m = dsnPattern.exec(str),
      dsn = {},
      i = 7;

    try {
      while (i--) dsn[dsnKeys[i]] = m[i] || '';
    } catch (e) {
      throw new RavenConfigError('Invalid DSN: ' + str);
    }

    if (dsn.pass && !this._globalOptions.allowSecretKey) {
      throw new RavenConfigError(
        'Do not specify your secret key in the DSN. See: http://bit.ly/raven-secret-key'
      );
    }

    return dsn;
  },

  _getGlobalServer: function(uri) {
    // assemble the endpoint from the uri pieces
    var globalServer = '//' + uri.host + (uri.port ? ':' + uri.port : '');

    if (uri.protocol) {
      globalServer = uri.protocol + ':' + globalServer;
    }
    return globalServer;
  },

  _handleOnErrorStackInfo: function(stackInfo, options) {
    options = options || {};
    options.mechanism = options.mechanism || {
      type: 'onerror',
      handled: false
    };

    // if we are intentionally ignoring errors via onerror, bail out
    if (!this._ignoreOnError) {
      this._handleStackInfo(stackInfo, options);
    }
  },

  _handleStackInfo: function(stackInfo, options) {
    var frames = this._prepareFrames(stackInfo, options);

    this._triggerEvent('handle', {
      stackInfo: stackInfo,
      options: options
    });

    this._processException(
      stackInfo.name,
      stackInfo.message,
      stackInfo.url,
      stackInfo.lineno,
      frames,
      options
    );
  },

  _prepareFrames: function(stackInfo, options) {
    var self = this;
    var frames = [];
    if (stackInfo.stack && stackInfo.stack.length) {
      each(stackInfo.stack, function(i, stack) {
        var frame = self._normalizeFrame(stack, stackInfo.url);
        if (frame) {
          frames.push(frame);
        }
      });

      // e.g. frames captured via captureMessage throw
      if (options && options.trimHeadFrames) {
        for (var j = 0; j < options.trimHeadFrames && j < frames.length; j++) {
          frames[j].in_app = false;
        }
      }
    }
    frames = frames.slice(0, this._globalOptions.stackTraceLimit);
    return frames;
  },

  _normalizeFrame: function(frame, stackInfoUrl) {
    // normalize the frames data
    var normalized = {
      filename: frame.url,
      lineno: frame.line,
      colno: frame.column,
      function: frame.func || '?'
    };

    // Case when we don't have any information about the error
    // E.g. throwing a string or raw object, instead of an `Error` in Firefox
    // Generating synthetic error doesn't add any value here
    //
    // We should probably somehow let a user know that they should fix their code
    if (!frame.url) {
      normalized.filename = stackInfoUrl; // fallback to whole stacks url from onerror handler
    }

    normalized.in_app = !// determine if an exception came from outside of our app
    // first we check the global includePaths list.
    (
      (!!this._globalOptions.includePaths.test &&
        !this._globalOptions.includePaths.test(normalized.filename)) ||
      // Now we check for fun, if the function name is Raven or TraceKit
      /(Raven|TraceKit)\./.test(normalized['function']) ||
      // finally, we do a last ditch effort and check for raven.min.js
      /raven\.(min\.)?js$/.test(normalized.filename)
    );

    return normalized;
  },

  _processException: function(type, message, fileurl, lineno, frames, options) {
    var prefixedMessage = (type ? type + ': ' : '') + (message || '');
    if (
      !!this._globalOptions.ignoreErrors.test &&
      (this._globalOptions.ignoreErrors.test(message) ||
        this._globalOptions.ignoreErrors.test(prefixedMessage))
    ) {
      return;
    }

    var stacktrace;

    if (frames && frames.length) {
      fileurl = frames[0].filename || fileurl;
      // Sentry expects frames oldest to newest
      // and JS sends them as newest to oldest
      frames.reverse();
      stacktrace = {frames: frames};
    } else if (fileurl) {
      stacktrace = {
        frames: [
          {
            filename: fileurl,
            lineno: lineno,
            in_app: true
          }
        ]
      };
    }

    if (
      !!this._globalOptions.ignoreUrls.test &&
      this._globalOptions.ignoreUrls.test(fileurl)
    ) {
      return;
    }

    if (
      !!this._globalOptions.whitelistUrls.test &&
      !this._globalOptions.whitelistUrls.test(fileurl)
    ) {
      return;
    }

    var data = objectMerge(
      {
        // sentry.interfaces.Exception
        exception: {
          values: [
            {
              type: type,
              value: message,
              stacktrace: stacktrace
            }
          ]
        },
        transaction: fileurl
      },
      options
    );

    var ex = data.exception.values[0];
    if (ex.type == null && ex.value === '') {
      ex.value = 'Unrecoverable error caught';
    }

    // Move mechanism from options to exception interface
    // We do this, as requiring user to pass `{exception:{mechanism:{ ... }}}` would be
    // too much
    if (!data.exception.mechanism && data.mechanism) {
      data.exception.mechanism = data.mechanism;
      delete data.mechanism;
    }

    data.exception.mechanism = objectMerge(
      {
        type: 'generic',
        handled: true
      },
      data.exception.mechanism || {}
    );

    // Fire away!
    this._send(data);
  },

  _trimPacket: function(data) {
    // For now, we only want to truncate the two different messages
    // but this could/should be expanded to just trim everything
    var max = this._globalOptions.maxMessageLength;
    if (data.message) {
      data.message = truncate(data.message, max);
    }
    if (data.exception) {
      var exception = data.exception.values[0];
      exception.value = truncate(exception.value, max);
    }

    var request = data.request;
    if (request) {
      if (request.url) {
        request.url = truncate(request.url, this._globalOptions.maxUrlLength);
      }
      if (request.Referer) {
        request.Referer = truncate(request.Referer, this._globalOptions.maxUrlLength);
      }
    }

    if (data.breadcrumbs && data.breadcrumbs.values)
      this._trimBreadcrumbs(data.breadcrumbs);

    return data;
  },

  /**
   * Truncate breadcrumb values (right now just URLs)
   */
  _trimBreadcrumbs: function(breadcrumbs) {
    // known breadcrumb properties with urls
    // TODO: also consider arbitrary prop values that start with (https?)?://
    var urlProps = ['to', 'from', 'url'],
      urlProp,
      crumb,
      data;

    for (var i = 0; i < breadcrumbs.values.length; ++i) {
      crumb = breadcrumbs.values[i];
      if (
        !crumb.hasOwnProperty('data') ||
        !isObject(crumb.data) ||
        objectFrozen(crumb.data)
      )
        continue;

      data = objectMerge({}, crumb.data);
      for (var j = 0; j < urlProps.length; ++j) {
        urlProp = urlProps[j];
        if (data.hasOwnProperty(urlProp) && data[urlProp]) {
          data[urlProp] = truncate(data[urlProp], this._globalOptions.maxUrlLength);
        }
      }
      breadcrumbs.values[i].data = data;
    }
  },

  _getHttpData: function() {
    if (!this._hasNavigator && !this._hasDocument) return;
    var httpData = {};

    if (this._hasNavigator && _navigator.userAgent) {
      httpData.headers = {
        'User-Agent': _navigator.userAgent
      };
    }

    // Check in `window` instead of `document`, as we may be in ServiceWorker environment
    if (_window.location && _window.location.href) {
      httpData.url = _window.location.href;
    }

    if (this._hasDocument && _document.referrer) {
      if (!httpData.headers) httpData.headers = {};
      httpData.headers.Referer = _document.referrer;
    }

    return httpData;
  },

  _resetBackoff: function() {
    this._backoffDuration = 0;
    this._backoffStart = null;
  },

  _shouldBackoff: function() {
    return this._backoffDuration && now() - this._backoffStart < this._backoffDuration;
  },

  /**
   * Returns true if the in-process data payload matches the signature
   * of the previously-sent data
   *
   * NOTE: This has to be done at this level because TraceKit can generate
   *       data from window.onerror WITHOUT an exception object (IE8, IE9,
   *       other old browsers). This can take the form of an "exception"
   *       data object with a single frame (derived from the onerror args).
   */
  _isRepeatData: function(current) {
    var last = this._lastData;

    if (
      !last ||
      current.message !== last.message || // defined for captureMessage
      current.transaction !== last.transaction // defined for captureException/onerror
    )
      return false;

    // Stacktrace interface (i.e. from captureMessage)
    if (current.stacktrace || last.stacktrace) {
      return isSameStacktrace(current.stacktrace, last.stacktrace);
    } else if (current.exception || last.exception) {
      // Exception interface (i.e. from captureException/onerror)
      return isSameException(current.exception, last.exception);
    } else if (current.fingerprint || last.fingerprint) {
      return Boolean(current.fingerprint && last.fingerprint) &&
        JSON.stringify(current.fingerprint) === JSON.stringify(last.fingerprint)
    }

    return true;
  },

  _setBackoffState: function(request) {
    // If we are already in a backoff state, don't change anything
    if (this._shouldBackoff()) {
      return;
    }

    var status = request.status;

    // 400 - project_id doesn't exist or some other fatal
    // 401 - invalid/revoked dsn
    // 429 - too many requests
    if (!(status === 400 || status === 401 || status === 429)) return;

    var retry;
    try {
      // If Retry-After is not in Access-Control-Expose-Headers, most
      // browsers will throw an exception trying to access it
      if (supportsFetch()) {
        retry = request.headers.get('Retry-After');
      } else {
        retry = request.getResponseHeader('Retry-After');
      }

      // Retry-After is returned in seconds
      retry = parseInt(retry, 10) * 1000;
    } catch (e) {
      /* eslint no-empty:0 */
    }

    this._backoffDuration = retry
      ? // If Sentry server returned a Retry-After value, use it
        retry
      : // Otherwise, double the last backoff duration (starts at 1 sec)
        this._backoffDuration * 2 || 1000;

    this._backoffStart = now();
  },

  _send: function(data) {
    var globalOptions = this._globalOptions;

    var baseData = {
        project: this._globalProject,
        logger: globalOptions.logger,
        platform: 'javascript'
      },
      httpData = this._getHttpData();

    if (httpData) {
      baseData.request = httpData;
    }

    // HACK: delete `trimHeadFrames` to prevent from appearing in outbound payload
    if (data.trimHeadFrames) delete data.trimHeadFrames;

    data = objectMerge(baseData, data);

    // Merge in the tags and extra separately since objectMerge doesn't handle a deep merge
    data.tags = objectMerge(objectMerge({}, this._globalContext.tags), data.tags);
    data.extra = objectMerge(objectMerge({}, this._globalContext.extra), data.extra);

    // Send along our own collected metadata with extra
    data.extra['session:duration'] = now() - this._startTime;

    if (this._breadcrumbs && this._breadcrumbs.length > 0) {
      // intentionally make shallow copy so that additions
      // to breadcrumbs aren't accidentally sent in this request
      data.breadcrumbs = {
        values: [].slice.call(this._breadcrumbs, 0)
      };
    }

    if (this._globalContext.user) {
      // sentry.interfaces.User
      data.user = this._globalContext.user;
    }

    // Include the environment if it's defined in globalOptions
    if (globalOptions.environment) data.environment = globalOptions.environment;

    // Include the release if it's defined in globalOptions
    if (globalOptions.release) data.release = globalOptions.release;

    // Include server_name if it's defined in globalOptions
    if (globalOptions.serverName) data.server_name = globalOptions.serverName;

    data = this._sanitizeData(data);

    // Cleanup empty properties before sending them to the server
    Object.keys(data).forEach(function(key) {
      if (data[key] == null || data[key] === '' || isEmptyObject(data[key])) {
        delete data[key];
      }
    });

    if (isFunction(globalOptions.dataCallback)) {
      data = globalOptions.dataCallback(data) || data;
    }

    // Why??????????
    if (!data || isEmptyObject(data)) {
      return;
    }

    // Check if the request should be filtered or not
    if (
      isFunction(globalOptions.shouldSendCallback) &&
      !globalOptions.shouldSendCallback(data)
    ) {
      return;
    }

    // Backoff state: Sentry server previously responded w/ an error (e.g. 429 - too many requests),
    // so drop requests until "cool-off" period has elapsed.
    if (this._shouldBackoff()) {
      this._logDebug('warn', 'Raven dropped error due to backoff: ', data);
      return;
    }

    if (typeof globalOptions.sampleRate === 'number') {
      if (Math.random() < globalOptions.sampleRate) {
        this._sendProcessedPayload(data);
      }
    } else {
      this._sendProcessedPayload(data);
    }
  },

  _sanitizeData: function(data) {
    return sanitize(data, this._globalOptions.sanitizeKeys);
  },

  _getUuid: function() {
    return uuid4();
  },

  _sendProcessedPayload: function(data, callback) {
    var self = this;
    var globalOptions = this._globalOptions;

    if (!this.isSetup()) return;

    // Try and clean up the packet before sending by truncating long values
    data = this._trimPacket(data);

    // ideally duplicate error testing should occur *before* dataCallback/shouldSendCallback,
    // but this would require copying an un-truncated copy of the data packet, which can be
    // arbitrarily deep (extra_data) -- could be worthwhile? will revisit
    if (!this._globalOptions.allowDuplicates && this._isRepeatData(data)) {
      this._logDebug('warn', 'Raven dropped repeat event: ', data);
      return;
    }

    // Send along an event_id if not explicitly passed.
    // This event_id can be used to reference the error within Sentry itself.
    // Set lastEventId after we know the error should actually be sent
    this._lastEventId = data.event_id || (data.event_id = this._getUuid());

    // Store outbound payload after trim
    this._lastData = data;

    this._logDebug('debug', 'Raven about to send:', data);

    var auth = {
      sentry_version: '7',
      sentry_client: 'raven-js/' + this.VERSION,
      sentry_key: this._globalKey
    };

    if (this._globalSecret) {
      auth.sentry_secret = this._globalSecret;
    }

    var exception = data.exception && data.exception.values[0];

    // only capture 'sentry' breadcrumb is autoBreadcrumbs is truthy
    if (
      this._globalOptions.autoBreadcrumbs &&
      this._globalOptions.autoBreadcrumbs.sentry
    ) {
      this.captureBreadcrumb({
        category: 'sentry',
        message: exception
          ? (exception.type ? exception.type + ': ' : '') + exception.value
          : data.message,
        event_id: data.event_id,
        level: data.level || 'error' // presume error unless specified
      });
    }

    var url = this._globalEndpoint;
    (globalOptions.transport || this._makeRequest).call(this, {
      url: url,
      auth: auth,
      data: data,
      options: globalOptions,
      onSuccess: function success() {
        self._resetBackoff();

        self._triggerEvent('success', {
          data: data,
          src: url
        });
        callback && callback();
      },
      onError: function failure(error) {
        self._logDebug('error', 'Raven transport failed to send: ', error);

        if (error.request) {
          self._setBackoffState(error.request);
        }

        self._triggerEvent('failure', {
          data: data,
          src: url
        });
        error = error || new Error('Raven send failed (no additional details provided)');
        callback && callback(error);
      }
    });
  },

  _makeRequest: function(opts) {
    // Auth is intentionally sent as part of query string (NOT as custom HTTP header) to avoid preflight CORS requests
    var url = opts.url + '?' + urlencode(opts.auth);

    var evaluatedHeaders = null;
    var evaluatedFetchParameters = {};

    if (opts.options.headers) {
      evaluatedHeaders = this._evaluateHash(opts.options.headers);
    }

    if (opts.options.fetchParameters) {
      evaluatedFetchParameters = this._evaluateHash(opts.options.fetchParameters);
    }

    if (supportsFetch()) {
      evaluatedFetchParameters.body = stringify(opts.data);

      var defaultFetchOptions = objectMerge({}, this._fetchDefaults);
      var fetchOptions = objectMerge(defaultFetchOptions, evaluatedFetchParameters);

      if (evaluatedHeaders) {
        fetchOptions.headers = evaluatedHeaders;
      }

      return _window
        .fetch(url, fetchOptions)
        .then(function(response) {
          if (response.ok) {
            opts.onSuccess && opts.onSuccess();
          } else {
            var error = new Error('Sentry error code: ' + response.status);
            // It's called request only to keep compatibility with XHR interface
            // and not add more redundant checks in setBackoffState method
            error.request = response;
            opts.onError && opts.onError(error);
          }
        })
        ['catch'](function() {
          opts.onError &&
            opts.onError(new Error('Sentry error code: network unavailable'));
        });
    }

    var request = _window.XMLHttpRequest && new _window.XMLHttpRequest();
    if (!request) return;

    // if browser doesn't support CORS (e.g. IE7), we are out of luck
    var hasCORS = 'withCredentials' in request || typeof XDomainRequest !== 'undefined';

    if (!hasCORS) return;

    if ('withCredentials' in request) {
      request.onreadystatechange = function() {
        if (request.readyState !== 4) {
          return;
        } else if (request.status === 200) {
          opts.onSuccess && opts.onSuccess();
        } else if (opts.onError) {
          var err = new Error('Sentry error code: ' + request.status);
          err.request = request;
          opts.onError(err);
        }
      };
    } else {
      request = new XDomainRequest();
      // xdomainrequest cannot go http -> https (or vice versa),
      // so always use protocol relative
      url = url.replace(/^https?:/, '');

      // onreadystatechange not supported by XDomainRequest
      if (opts.onSuccess) {
        request.onload = opts.onSuccess;
      }
      if (opts.onError) {
        request.onerror = function() {
          var err = new Error('Sentry error code: XDomainRequest');
          err.request = request;
          opts.onError(err);
        };
      }
    }

    request.open('POST', url);

    if (evaluatedHeaders) {
      each(evaluatedHeaders, function(key, value) {
        request.setRequestHeader(key, value);
      });
    }

    request.send(stringify(opts.data));
  },

  _evaluateHash: function(hash) {
    var evaluated = {};

    for (var key in hash) {
      if (hash.hasOwnProperty(key)) {
        var value = hash[key];
        evaluated[key] = typeof value === 'function' ? value() : value;
      }
    }

    return evaluated;
  },

  _logDebug: function(level) {
    // We allow `Raven.debug` and `Raven.config(DSN, { debug: true })` to not make backward incompatible API change
    if (
      this._originalConsoleMethods[level] &&
      (this.debug || this._globalOptions.debug)
    ) {
      // In IE<10 console methods do not have their own 'apply' method
      Function.prototype.apply.call(
        this._originalConsoleMethods[level],
        this._originalConsole,
        [].slice.call(arguments, 1)
      );
    }
  },

  _mergeContext: function(key, context) {
    if (isUndefined(context)) {
      delete this._globalContext[key];
    } else {
      this._globalContext[key] = objectMerge(this._globalContext[key] || {}, context);
    }
  }
};

// Deprecations
Raven.prototype.setUser = Raven.prototype.setUserContext;
Raven.prototype.setReleaseContext = Raven.prototype.setRelease;

module.exports = Raven;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var utils = __webpack_require__(109);

/*
 TraceKit - Cross brower stack traces

 This was originally forked from github.com/occ/TraceKit, but has since been
 largely re-written and is now maintained as part of raven-js.  Tests for
 this are in test/vendor.

 MIT license
*/

var TraceKit = {
  collectWindowErrors: true,
  debug: false
};

// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
var _window =
  typeof window !== 'undefined'
    ? window
    : typeof global !== 'undefined'
    ? global
    : typeof self !== 'undefined'
    ? self
    : {};

// global reference to slice
var _slice = [].slice;
var UNKNOWN_FUNCTION = '?';

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types
var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/;

function getLocationHref() {
  if (typeof document === 'undefined' || document.location == null) return '';
  return document.location.href;
}

function getLocationOrigin() {
  if (typeof document === 'undefined' || document.location == null) return '';

  // Oh dear IE10...
  if (!document.location.origin) {
    return (
      document.location.protocol +
      '//' +
      document.location.hostname +
      (document.location.port ? ':' + document.location.port : '')
    );
  }

  return document.location.origin;
}

/**
 * TraceKit.report: cross-browser processing of unhandled exceptions
 *
 * Syntax:
 *   TraceKit.report.subscribe(function(stackInfo) { ... })
 *   TraceKit.report.unsubscribe(function(stackInfo) { ... })
 *   TraceKit.report(exception)
 *   try { ...code... } catch(ex) { TraceKit.report(ex); }
 *
 * Supports:
 *   - Firefox: full stack trace with line numbers, plus column number
 *              on top frame; column number is not guaranteed
 *   - Opera:   full stack trace with line and column numbers
 *   - Chrome:  full stack trace with line and column numbers
 *   - Safari:  line and column number for the top frame only; some frames
 *              may be missing, and column number is not guaranteed
 *   - IE:      line and column number for the top frame only; some frames
 *              may be missing, and column number is not guaranteed
 *
 * In theory, TraceKit should work on all of the following versions:
 *   - IE5.5+ (only 8.0 tested)
 *   - Firefox 0.9+ (only 3.5+ tested)
 *   - Opera 7+ (only 10.50 tested; versions 9 and earlier may require
 *     Exceptions Have Stacktrace to be enabled in opera:config)
 *   - Safari 3+ (only 4+ tested)
 *   - Chrome 1+ (only 5+ tested)
 *   - Konqueror 3.5+ (untested)
 *
 * Requires TraceKit.computeStackTrace.
 *
 * Tries to catch all unhandled exceptions and report them to the
 * subscribed handlers. Please note that TraceKit.report will rethrow the
 * exception. This is REQUIRED in order to get a useful stack trace in IE.
 * If the exception does not reach the top of the browser, you will only
 * get a stack trace from the point where TraceKit.report was called.
 *
 * Handlers receive a stackInfo object as described in the
 * TraceKit.computeStackTrace docs.
 */
TraceKit.report = (function reportModuleWrapper() {
  var handlers = [],
    lastArgs = null,
    lastException = null,
    lastExceptionStack = null;

  /**
   * Add a crash handler.
   * @param {Function} handler
   */
  function subscribe(handler) {
    installGlobalHandler();
    handlers.push(handler);
  }

  /**
   * Remove a crash handler.
   * @param {Function} handler
   */
  function unsubscribe(handler) {
    for (var i = handlers.length - 1; i >= 0; --i) {
      if (handlers[i] === handler) {
        handlers.splice(i, 1);
      }
    }
  }

  /**
   * Remove all crash handlers.
   */
  function unsubscribeAll() {
    uninstallGlobalHandler();
    handlers = [];
  }

  /**
   * Dispatch stack information to all handlers.
   * @param {Object.<string, *>} stack
   */
  function notifyHandlers(stack, isWindowError) {
    var exception = null;
    if (isWindowError && !TraceKit.collectWindowErrors) {
      return;
    }
    for (var i in handlers) {
      if (handlers.hasOwnProperty(i)) {
        try {
          handlers[i].apply(null, [stack].concat(_slice.call(arguments, 2)));
        } catch (inner) {
          exception = inner;
        }
      }
    }

    if (exception) {
      throw exception;
    }
  }

  var _oldOnerrorHandler, _onErrorHandlerInstalled;

  /**
   * Ensures all global unhandled exceptions are recorded.
   * Supported by Gecko and IE.
   * @param {string} msg Error message.
   * @param {string} url URL of script that generated the exception.
   * @param {(number|string)} lineNo The line number at which the error
   * occurred.
   * @param {?(number|string)} colNo The column number at which the error
   * occurred.
   * @param {?Error} ex The actual Error object.
   */
  function traceKitWindowOnError(msg, url, lineNo, colNo, ex) {
    var stack = null;
    // If 'ex' is ErrorEvent, get real Error from inside
    var exception = utils.isErrorEvent(ex) ? ex.error : ex;
    // If 'msg' is ErrorEvent, get real message from inside
    var message = utils.isErrorEvent(msg) ? msg.message : msg;

    if (lastExceptionStack) {
      TraceKit.computeStackTrace.augmentStackTraceWithInitialElement(
        lastExceptionStack,
        url,
        lineNo,
        message
      );
      processLastException();
    } else if (exception && utils.isError(exception)) {
      // non-string `exception` arg; attempt to extract stack trace

      // New chrome and blink send along a real error object
      // Let's just report that like a normal error.
      // See: https://mikewest.org/2013/08/debugging-runtime-errors-with-window-onerror
      stack = TraceKit.computeStackTrace(exception);
      notifyHandlers(stack, true);
    } else {
      var location = {
        url: url,
        line: lineNo,
        column: colNo
      };

      var name = undefined;
      var groups;

      if ({}.toString.call(message) === '[object String]') {
        var groups = message.match(ERROR_TYPES_RE);
        if (groups) {
          name = groups[1];
          message = groups[2];
        }
      }

      location.func = UNKNOWN_FUNCTION;

      stack = {
        name: name,
        message: message,
        url: getLocationHref(),
        stack: [location]
      };
      notifyHandlers(stack, true);
    }

    if (_oldOnerrorHandler) {
      return _oldOnerrorHandler.apply(this, arguments);
    }

    return false;
  }

  function installGlobalHandler() {
    if (_onErrorHandlerInstalled) {
      return;
    }
    _oldOnerrorHandler = _window.onerror;
    _window.onerror = traceKitWindowOnError;
    _onErrorHandlerInstalled = true;
  }

  function uninstallGlobalHandler() {
    if (!_onErrorHandlerInstalled) {
      return;
    }
    _window.onerror = _oldOnerrorHandler;
    _onErrorHandlerInstalled = false;
    _oldOnerrorHandler = undefined;
  }

  function processLastException() {
    var _lastExceptionStack = lastExceptionStack,
      _lastArgs = lastArgs;
    lastArgs = null;
    lastExceptionStack = null;
    lastException = null;
    notifyHandlers.apply(null, [_lastExceptionStack, false].concat(_lastArgs));
  }

  /**
   * Reports an unhandled Error to TraceKit.
   * @param {Error} ex
   * @param {?boolean} rethrow If false, do not re-throw the exception.
   * Only used for window.onerror to not cause an infinite loop of
   * rethrowing.
   */
  function report(ex, rethrow) {
    var args = _slice.call(arguments, 1);
    if (lastExceptionStack) {
      if (lastException === ex) {
        return; // already caught by an inner catch block, ignore
      } else {
        processLastException();
      }
    }

    var stack = TraceKit.computeStackTrace(ex);
    lastExceptionStack = stack;
    lastException = ex;
    lastArgs = args;

    // If the stack trace is incomplete, wait for 2 seconds for
    // slow slow IE to see if onerror occurs or not before reporting
    // this exception; otherwise, we will end up with an incomplete
    // stack trace
    setTimeout(
      function() {
        if (lastException === ex) {
          processLastException();
        }
      },
      stack.incomplete ? 2000 : 0
    );

    if (rethrow !== false) {
      throw ex; // re-throw to propagate to the top level (and cause window.onerror)
    }
  }

  report.subscribe = subscribe;
  report.unsubscribe = unsubscribe;
  report.uninstall = unsubscribeAll;
  return report;
})();

/**
 * TraceKit.computeStackTrace: cross-browser stack traces in JavaScript
 *
 * Syntax:
 *   s = TraceKit.computeStackTrace(exception) // consider using TraceKit.report instead (see below)
 * Returns:
 *   s.name              - exception name
 *   s.message           - exception message
 *   s.stack[i].url      - JavaScript or HTML file URL
 *   s.stack[i].func     - function name, or empty for anonymous functions (if guessing did not work)
 *   s.stack[i].args     - arguments passed to the function, if known
 *   s.stack[i].line     - line number, if known
 *   s.stack[i].column   - column number, if known
 *
 * Supports:
 *   - Firefox:  full stack trace with line numbers and unreliable column
 *               number on top frame
 *   - Opera 10: full stack trace with line and column numbers
 *   - Opera 9-: full stack trace with line numbers
 *   - Chrome:   full stack trace with line and column numbers
 *   - Safari:   line and column number for the topmost stacktrace element
 *               only
 *   - IE:       no line numbers whatsoever
 *
 * Tries to guess names of anonymous functions by looking for assignments
 * in the source code. In IE and Safari, we have to guess source file names
 * by searching for function bodies inside all page scripts. This will not
 * work for scripts that are loaded cross-domain.
 * Here be dragons: some function names may be guessed incorrectly, and
 * duplicate functions may be mismatched.
 *
 * TraceKit.computeStackTrace should only be used for tracing purposes.
 * Logging of unhandled exceptions should be done with TraceKit.report,
 * which builds on top of TraceKit.computeStackTrace and provides better
 * IE support by utilizing the window.onerror event to retrieve information
 * about the top of the stack.
 *
 * Note: In IE and Safari, no stack trace is recorded on the Error object,
 * so computeStackTrace instead walks its *own* chain of callers.
 * This means that:
 *  * in Safari, some methods may be missing from the stack trace;
 *  * in IE, the topmost function in the stack trace will always be the
 *    caller of computeStackTrace.
 *
 * This is okay for tracing (because you are likely to be calling
 * computeStackTrace from the function you want to be the topmost element
 * of the stack trace anyway), but not okay for logging unhandled
 * exceptions (because your catch block will likely be far away from the
 * inner function that actually caused the exception).
 *
 */
TraceKit.computeStackTrace = (function computeStackTraceWrapper() {
  // Contents of Exception in various browsers.
  //
  // SAFARI:
  // ex.message = Can't find variable: qq
  // ex.line = 59
  // ex.sourceId = 580238192
  // ex.sourceURL = http://...
  // ex.expressionBeginOffset = 96
  // ex.expressionCaretOffset = 98
  // ex.expressionEndOffset = 98
  // ex.name = ReferenceError
  //
  // FIREFOX:
  // ex.message = qq is not defined
  // ex.fileName = http://...
  // ex.lineNumber = 59
  // ex.columnNumber = 69
  // ex.stack = ...stack trace... (see the example below)
  // ex.name = ReferenceError
  //
  // CHROME:
  // ex.message = qq is not defined
  // ex.name = ReferenceError
  // ex.type = not_defined
  // ex.arguments = ['aa']
  // ex.stack = ...stack trace...
  //
  // INTERNET EXPLORER:
  // ex.message = ...
  // ex.name = ReferenceError
  //
  // OPERA:
  // ex.message = ...message... (see the example below)
  // ex.name = ReferenceError
  // ex.opera#sourceloc = 11  (pretty much useless, duplicates the info in ex.message)
  // ex.stacktrace = n/a; see 'opera:config#UserPrefs|Exceptions Have Stacktrace'

  /**
   * Computes stack trace information from the stack property.
   * Chrome and Gecko use this property.
   * @param {Error} ex
   * @return {?Object.<string, *>} Stack trace information.
   */
  function computeStackTraceFromStackProp(ex) {
    if (typeof ex.stack === 'undefined' || !ex.stack) return;

    var chrome = /^\s*at (?:(.*?) ?\()?((?:file|https?|blob|chrome-extension|native|eval|webpack|<anonymous>|[a-z]:|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
    var winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx(?:-web)|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
    // NOTE: blob urls are now supposed to always have an origin, therefore it's format
    // which is `blob:http://url/path/with-some-uuid`, is matched by `blob.*?:\/` as well
    var gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|resource|moz-extension).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js))(?::(\d+))?(?::(\d+))?\s*$/i;
    // Used to additionally parse URL/line/column from eval frames
    var geckoEval = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
    var chromeEval = /\((\S*)(?::(\d+))(?::(\d+))\)/;
    var lines = ex.stack.split('\n');
    var stack = [];
    var submatch;
    var parts;
    var element;
    var reference = /^(.*) is undefined$/.exec(ex.message);

    for (var i = 0, j = lines.length; i < j; ++i) {
      if ((parts = chrome.exec(lines[i]))) {
        var isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line
        var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval && (submatch = chromeEval.exec(parts[2]))) {
          // throw out eval line/column and use top-most line/column number
          parts[2] = submatch[1]; // url
          parts[3] = submatch[2]; // line
          parts[4] = submatch[3]; // column
        }
        element = {
          url: !isNative ? parts[2] : null,
          func: parts[1] || UNKNOWN_FUNCTION,
          args: isNative ? [parts[2]] : [],
          line: parts[3] ? +parts[3] : null,
          column: parts[4] ? +parts[4] : null
        };
      } else if ((parts = winjs.exec(lines[i]))) {
        element = {
          url: parts[2],
          func: parts[1] || UNKNOWN_FUNCTION,
          args: [],
          line: +parts[3],
          column: parts[4] ? +parts[4] : null
        };
      } else if ((parts = gecko.exec(lines[i]))) {
        var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval && (submatch = geckoEval.exec(parts[3]))) {
          // throw out eval line/column and use top-most line number
          parts[3] = submatch[1];
          parts[4] = submatch[2];
          parts[5] = null; // no column when eval
        } else if (i === 0 && !parts[5] && typeof ex.columnNumber !== 'undefined') {
          // FireFox uses this awesome columnNumber property for its top frame
          // Also note, Firefox's column number is 0-based and everything else expects 1-based,
          // so adding 1
          // NOTE: this hack doesn't work if top-most frame is eval
          stack[0].column = ex.columnNumber + 1;
        }
        element = {
          url: parts[3],
          func: parts[1] || UNKNOWN_FUNCTION,
          args: parts[2] ? parts[2].split(',') : [],
          line: parts[4] ? +parts[4] : null,
          column: parts[5] ? +parts[5] : null
        };
      } else {
        continue;
      }

      if (!element.func && element.line) {
        element.func = UNKNOWN_FUNCTION;
      }

      if (element.url && element.url.substr(0, 5) === 'blob:') {
        // Special case for handling JavaScript loaded into a blob.
        // We use a synchronous AJAX request here as a blob is already in
        // memory - it's not making a network request.  This will generate a warning
        // in the browser console, but there has already been an error so that's not
        // that much of an issue.
        var xhr = new XMLHttpRequest();
        xhr.open('GET', element.url, false);
        xhr.send(null);

        // If we failed to download the source, skip this patch
        if (xhr.status === 200) {
          var source = xhr.responseText || '';

          // We trim the source down to the last 300 characters as sourceMappingURL is always at the end of the file.
          // Why 300? To be in line with: https://github.com/getsentry/sentry/blob/4af29e8f2350e20c28a6933354e4f42437b4ba42/src/sentry/lang/javascript/processor.py#L164-L175
          source = source.slice(-300);

          // Now we dig out the source map URL
          var sourceMaps = source.match(/\/\/# sourceMappingURL=(.*)$/);

          // If we don't find a source map comment or we find more than one, continue on to the next element.
          if (sourceMaps) {
            var sourceMapAddress = sourceMaps[1];

            // Now we check to see if it's a relative URL.
            // If it is, convert it to an absolute one.
            if (sourceMapAddress.charAt(0) === '~') {
              sourceMapAddress = getLocationOrigin() + sourceMapAddress.slice(1);
            }

            // Now we strip the '.map' off of the end of the URL and update the
            // element so that Sentry can match the map to the blob.
            element.url = sourceMapAddress.slice(0, -4);
          }
        }
      }

      stack.push(element);
    }

    if (!stack.length) {
      return null;
    }

    return {
      name: ex.name,
      message: ex.message,
      url: getLocationHref(),
      stack: stack
    };
  }

  /**
   * Adds information about the first frame to incomplete stack traces.
   * Safari and IE require this to get complete data on the first frame.
   * @param {Object.<string, *>} stackInfo Stack trace information from
   * one of the compute* methods.
   * @param {string} url The URL of the script that caused an error.
   * @param {(number|string)} lineNo The line number of the script that
   * caused an error.
   * @param {string=} message The error generated by the browser, which
   * hopefully contains the name of the object that caused the error.
   * @return {boolean} Whether or not the stack information was
   * augmented.
   */
  function augmentStackTraceWithInitialElement(stackInfo, url, lineNo, message) {
    var initial = {
      url: url,
      line: lineNo
    };

    if (initial.url && initial.line) {
      stackInfo.incomplete = false;

      if (!initial.func) {
        initial.func = UNKNOWN_FUNCTION;
      }

      if (stackInfo.stack.length > 0) {
        if (stackInfo.stack[0].url === initial.url) {
          if (stackInfo.stack[0].line === initial.line) {
            return false; // already in stack trace
          } else if (
            !stackInfo.stack[0].line &&
            stackInfo.stack[0].func === initial.func
          ) {
            stackInfo.stack[0].line = initial.line;
            return false;
          }
        }
      }

      stackInfo.stack.unshift(initial);
      stackInfo.partial = true;
      return true;
    } else {
      stackInfo.incomplete = true;
    }

    return false;
  }

  /**
   * Computes stack trace information by walking the arguments.caller
   * chain at the time the exception occurred. This will cause earlier
   * frames to be missed but is the only way to get any stack trace in
   * Safari and IE. The top frame is restored by
   * {@link augmentStackTraceWithInitialElement}.
   * @param {Error} ex
   * @return {?Object.<string, *>} Stack trace information.
   */
  function computeStackTraceByWalkingCallerChain(ex, depth) {
    var functionName = /function\s+([_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*)?\s*\(/i,
      stack = [],
      funcs = {},
      recursion = false,
      parts,
      item,
      source;

    for (
      var curr = computeStackTraceByWalkingCallerChain.caller;
      curr && !recursion;
      curr = curr.caller
    ) {
      if (curr === computeStackTrace || curr === TraceKit.report) {
        // console.log('skipping internal function');
        continue;
      }

      item = {
        url: null,
        func: UNKNOWN_FUNCTION,
        line: null,
        column: null
      };

      if (curr.name) {
        item.func = curr.name;
      } else if ((parts = functionName.exec(curr.toString()))) {
        item.func = parts[1];
      }

      if (typeof item.func === 'undefined') {
        try {
          item.func = parts.input.substring(0, parts.input.indexOf('{'));
        } catch (e) {}
      }

      if (funcs['' + curr]) {
        recursion = true;
      } else {
        funcs['' + curr] = true;
      }

      stack.push(item);
    }

    if (depth) {
      // console.log('depth is ' + depth);
      // console.log('stack is ' + stack.length);
      stack.splice(0, depth);
    }

    var result = {
      name: ex.name,
      message: ex.message,
      url: getLocationHref(),
      stack: stack
    };
    augmentStackTraceWithInitialElement(
      result,
      ex.sourceURL || ex.fileName,
      ex.line || ex.lineNumber,
      ex.message || ex.description
    );
    return result;
  }

  /**
   * Computes a stack trace for an exception.
   * @param {Error} ex
   * @param {(string|number)=} depth
   */
  function computeStackTrace(ex, depth) {
    var stack = null;
    depth = depth == null ? 0 : +depth;

    try {
      stack = computeStackTraceFromStackProp(ex);
      if (stack) {
        return stack;
      }
    } catch (e) {
      if (TraceKit.debug) {
        throw e;
      }
    }

    try {
      stack = computeStackTraceByWalkingCallerChain(ex, depth + 1);
      if (stack) {
        return stack;
      }
    } catch (e) {
      if (TraceKit.debug) {
        throw e;
      }
    }
    return {
      name: ex.name,
      message: ex.message,
      url: getLocationHref()
    };
  }

  computeStackTrace.augmentStackTraceWithInitialElement = augmentStackTraceWithInitialElement;
  computeStackTrace.computeStackTraceFromStackProp = computeStackTraceFromStackProp;

  return computeStackTrace;
})();

module.exports = TraceKit;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),
/* 1266 */
/***/ (function(module, exports) {

/*
 * JavaScript MD5
 * https://github.com/blueimp/JavaScript-MD5
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 *
 * Based on
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */

/*
* Add integers, wrapping at 2^32. This uses 16-bit operations internally
* to work around bugs in some JS interpreters.
*/
function safeAdd(x, y) {
  var lsw = (x & 0xffff) + (y & 0xffff);
  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return (msw << 16) | (lsw & 0xffff);
}

/*
* Bitwise rotate a 32-bit number to the left.
*/
function bitRotateLeft(num, cnt) {
  return (num << cnt) | (num >>> (32 - cnt));
}

/*
* These functions implement the four basic operations the algorithm uses.
*/
function md5cmn(q, a, b, x, s, t) {
  return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
}
function md5ff(a, b, c, d, x, s, t) {
  return md5cmn((b & c) | (~b & d), a, b, x, s, t);
}
function md5gg(a, b, c, d, x, s, t) {
  return md5cmn((b & d) | (c & ~d), a, b, x, s, t);
}
function md5hh(a, b, c, d, x, s, t) {
  return md5cmn(b ^ c ^ d, a, b, x, s, t);
}
function md5ii(a, b, c, d, x, s, t) {
  return md5cmn(c ^ (b | ~d), a, b, x, s, t);
}

/*
* Calculate the MD5 of an array of little-endian words, and a bit length.
*/
function binlMD5(x, len) {
  /* append padding */
  x[len >> 5] |= 0x80 << (len % 32);
  x[(((len + 64) >>> 9) << 4) + 14] = len;

  var i;
  var olda;
  var oldb;
  var oldc;
  var oldd;
  var a = 1732584193;
  var b = -271733879;
  var c = -1732584194;
  var d = 271733878;

  for (i = 0; i < x.length; i += 16) {
    olda = a;
    oldb = b;
    oldc = c;
    oldd = d;

    a = md5ff(a, b, c, d, x[i], 7, -680876936);
    d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
    c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
    b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
    a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
    d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
    c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
    b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
    a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
    d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
    c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
    b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
    a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
    d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
    c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
    b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);

    a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
    d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
    c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
    b = md5gg(b, c, d, a, x[i], 20, -373897302);
    a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
    d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
    c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
    b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
    a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
    d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
    c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
    b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
    a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
    d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
    c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
    b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);

    a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
    d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
    c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
    b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
    a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
    d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
    c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
    b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
    a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
    d = md5hh(d, a, b, c, x[i], 11, -358537222);
    c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
    b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
    a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
    d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
    c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
    b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);

    a = md5ii(a, b, c, d, x[i], 6, -198630844);
    d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
    c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
    b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
    a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
    d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
    c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
    b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
    a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
    d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
    c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
    b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
    a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
    d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
    c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
    b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);

    a = safeAdd(a, olda);
    b = safeAdd(b, oldb);
    c = safeAdd(c, oldc);
    d = safeAdd(d, oldd);
  }
  return [a, b, c, d];
}

/*
* Convert an array of little-endian words to a string
*/
function binl2rstr(input) {
  var i;
  var output = '';
  var length32 = input.length * 32;
  for (i = 0; i < length32; i += 8) {
    output += String.fromCharCode((input[i >> 5] >>> (i % 32)) & 0xff);
  }
  return output;
}

/*
* Convert a raw string to an array of little-endian words
* Characters >255 have their high-byte silently ignored.
*/
function rstr2binl(input) {
  var i;
  var output = [];
  output[(input.length >> 2) - 1] = undefined;
  for (i = 0; i < output.length; i += 1) {
    output[i] = 0;
  }
  var length8 = input.length * 8;
  for (i = 0; i < length8; i += 8) {
    output[i >> 5] |= (input.charCodeAt(i / 8) & 0xff) << (i % 32);
  }
  return output;
}

/*
* Calculate the MD5 of a raw string
*/
function rstrMD5(s) {
  return binl2rstr(binlMD5(rstr2binl(s), s.length * 8));
}

/*
* Calculate the HMAC-MD5, of a key and some data (raw strings)
*/
function rstrHMACMD5(key, data) {
  var i;
  var bkey = rstr2binl(key);
  var ipad = [];
  var opad = [];
  var hash;
  ipad[15] = opad[15] = undefined;
  if (bkey.length > 16) {
    bkey = binlMD5(bkey, key.length * 8);
  }
  for (i = 0; i < 16; i += 1) {
    ipad[i] = bkey[i] ^ 0x36363636;
    opad[i] = bkey[i] ^ 0x5c5c5c5c;
  }
  hash = binlMD5(ipad.concat(rstr2binl(data)), 512 + data.length * 8);
  return binl2rstr(binlMD5(opad.concat(hash), 512 + 128));
}

/*
* Convert a raw string to a hex string
*/
function rstr2hex(input) {
  var hexTab = '0123456789abcdef';
  var output = '';
  var x;
  var i;
  for (i = 0; i < input.length; i += 1) {
    x = input.charCodeAt(i);
    output += hexTab.charAt((x >>> 4) & 0x0f) + hexTab.charAt(x & 0x0f);
  }
  return output;
}

/*
* Encode a string as utf-8
*/
function str2rstrUTF8(input) {
  return unescape(encodeURIComponent(input));
}

/*
* Take string arguments and return either raw or hex encoded strings
*/
function rawMD5(s) {
  return rstrMD5(str2rstrUTF8(s));
}
function hexMD5(s) {
  return rstr2hex(rawMD5(s));
}
function rawHMACMD5(k, d) {
  return rstrHMACMD5(str2rstrUTF8(k), str2rstrUTF8(d));
}
function hexHMACMD5(k, d) {
  return rstr2hex(rawHMACMD5(k, d));
}

function md5(string, key, raw) {
  if (!key) {
    if (!raw) {
      return hexMD5(string);
    }
    return rawMD5(string);
  }
  if (!raw) {
    return hexHMACMD5(key, string);
  }
  return rawHMACMD5(key, string);
}

module.exports = md5;


/***/ }),
/* 1267 */
/***/ (function(module, exports) {

function RavenConfigError(message) {
  this.name = 'RavenConfigError';
  this.message = message;
}
RavenConfigError.prototype = new Error();
RavenConfigError.prototype.constructor = RavenConfigError;

module.exports = RavenConfigError;


/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

var utils = __webpack_require__(109);

var wrapMethod = function(console, level, callback) {
  var originalConsoleLevel = console[level];
  var originalConsole = console;

  if (!(level in console)) {
    return;
  }

  var sentryLevel = level === 'warn' ? 'warning' : level;

  console[level] = function() {
    var args = [].slice.call(arguments);

    var msg = utils.safeJoin(args, ' ');
    var data = {level: sentryLevel, logger: 'console', extra: {arguments: args}};

    if (level === 'assert') {
      if (args[0] === false) {
        // Default browsers message
        msg =
          'Assertion failed: ' + (utils.safeJoin(args.slice(1), ' ') || 'console.assert');
        data.extra.arguments = args.slice(1);
        callback && callback(msg, data);
      }
    } else {
      callback && callback(msg, data);
    }

    // this fails for some browsers. :(
    if (originalConsoleLevel) {
      // IE9 doesn't allow calling apply on console functions directly
      // See: https://stackoverflow.com/questions/5472938/does-ie9-support-console-log-and-is-it-a-real-function#answer-5473193
      Function.prototype.apply.call(originalConsoleLevel, originalConsole, args);
    }
  };
};

module.exports = {
  wrapMethod: wrapMethod
};


/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Angular.js plugin
 *
 * Provides an $exceptionHandler for Angular.js
 */
var wrappedCallback = __webpack_require__(109).wrappedCallback;

// See https://github.com/angular/angular.js/blob/v1.4.7/src/minErr.js
var angularPattern = /^\[((?:[$a-zA-Z0-9]+:)?(?:[$a-zA-Z0-9]+))\] (.*?)\n?(\S+)$/;
var moduleName = 'ngRaven';

function angularPlugin(Raven, angular) {
  angular = angular || window.angular;

  if (!angular) return;

  function RavenProvider() {
    this.$get = [
      '$window',
      function($window) {
        return Raven;
      }
    ];
  }

  function ExceptionHandlerProvider($provide) {
    $provide.decorator('$exceptionHandler', ['Raven', '$delegate', exceptionHandler]);
  }

  function exceptionHandler(R, $delegate) {
    return function(ex, cause) {
      R.captureException(ex, {
        extra: {cause: cause}
      });
      $delegate(ex, cause);
    };
  }

  angular
    .module(moduleName, [])
    .provider('Raven', RavenProvider)
    .config(['$provide', ExceptionHandlerProvider]);

  Raven.setDataCallback(
    wrappedCallback(function(data) {
      return angularPlugin._normalizeData(data);
    })
  );
}

angularPlugin._normalizeData = function(data) {
  // We only care about mutating an exception
  var exception = data.exception;
  if (exception) {
    exception = exception.values[0];
    var matches = angularPattern.exec(exception.value);

    if (matches) {
      // This type now becomes something like: $rootScope:inprog
      exception.type = matches[1];
      exception.value = matches[2];

      data.message = exception.type + ': ' + exception.value;
      // auto set a new tag specifically for the angular error url
      data.extra.angularDocs = matches[3].substr(0, 250);
    }
  }

  return data;
};

angularPlugin.moduleName = moduleName;

module.exports = angularPlugin;


/***/ }),
/* 1270 */
/***/ (function(module, exports) {

module.exports = {"page-default-title":"原本 - 领先的区块链+原创保护和交易","page-default-desc":"「原本」，重新定义原创价值。区块链原创保护和自助交易平台。为作品生成全网唯一的原本DNA认证标签，永久携带署名和授权。自助版权交易，再不用重复一对一询价沟通。对接海量原创需求商，个性化推荐加速内容传播。 全网侵权监控、侵权证据保全、专业律所服务有效打击侵权行为。","page-announcement-text001":"原本系统公告","page-announcement-text002":"发布日期","page-author-text001":"作者信息加载失败","page-author-text002":"作品列表","page-author-text003":"热门","page-author-text004":"最新","page-author-text005":"取消收藏","page-author-text006":"收藏","page-author-text007":"图片正在处理中","page-author-text008":"文章","page-author-text009":"图片","page-author-text010":"已取消收藏","page-author-text011":"已添加收藏","page-evidence-text001":"认证详情","page-evidence-text002":"「原本认证」说明","page-evidence-text003":"1.原本认证由「所有权证明」和「存在证明」两部分组成，符合国际<a href=\"https://en.wikipedia.org/wiki/ANSI_ASC_X9.95_Standard\" target=\"_blank\">X9.95协议</a>标准。","page-evidence-text004":"2.「所有权证明」使用<a href=\"https://zh.wikipedia.org/wiki/%E6%95%B8%E4%BD%8D%E7%B0%BD%E7%AB%A0\" target=\"_blank\">数字签名</a>技术来证明您是此原创作品的原始作者。数字签名通过验证一组<a href=\"https://zh.wikipedia.org/wiki/%E5%85%AC%E5%BC%80%E5%AF%86%E9%92%A5%E5%8A%A0%E5%AF%86\" target=\"_blank\">公钥和密钥</a>的匹配来证明所有权。公钥已写入「原本DNA」，随着原创作品一起发布。密钥已通过邮件发送到您的邮箱。为了安全，系统中不保存密钥，请您妥善保存此密钥，在任何情况下都不要泄露给其他人。","page-evidence-text005":"3.「存在证明」用于证明原创作品的发布时间，使用了<a href=\"https://www.zhihu.com/question/27687960\" target=\"_blank\">区块链技术</a>以及来自国家数字证书中心的<a href=\"http://baike.baidu.com/view/4770720.htm\" target=\"_blank\">可信时间戳</a>服务，认证信息也已经写入「原本DNA」中。","page-evidence-text006":"4.原本认证不依赖于「原本」的权威性，可以脱离「原本」的系统，由任意第三方来验证","page-evidence-text007":"标题","page-evidence-text008":"作者","page-evidence-text009":"发布时间","page-evidence-text010":"原本DNA","page-evidence-text011":"原本区块链地址","page-evidence-text012":"完整原本DNA","page-evidence-text013":"文章Hash","page-evidence-text014":"签名字符串","page-evidence-text015":"(本内容仅对作者本人可见)","page-evidence-text016":"数字签名","page-evidence-text017":"签名公钥","page-evidence-text018":"文章认证详情","page-evidence-text019":"图片认证详情","page-evidence-text020":"图片分辨率","page-evidence-text021":"文件大小","page-evidence-text022":"图片内容Hash","page-evidence-text023":"图片区块链Hash","page-search-text001":"搜索原本DNA或文章、图片内容","page-search-text002":"搜文章","page-search-text003":"搜图片","page-search-text004":"输入原本DNA或文章、图片内容开始搜索","page-search-text005":"正在搜索","page-search-text006":"未找到相关内容","page-search-text007":"相关结果","page-search-text008":"条","page-search-text009":"取消收藏","page-search-text010":"收藏","page-search-text011":"最近热搜词","page-search-text012":"图片正在处理中","page-search-text013":"最热作品","page-search-text014":"最新作品","page-search-text015":"全部协议","page-search-text016":"CC协议","page-search-text017":"商业协议","page-search-text018":"全部","page-search-text019":"0-5元","page-search-text020":"6-10元","page-search-text021":"11-50元","page-search-text022":"50元以上","page-search-text023":"价格从高到低","page-search-text024":"价格从低到高","page-search-text025":"cc0图片","page-search-text026":"已取消收藏","page-search-text027":"已添加收藏","page-search-text028":"收藏失败","page-original-text001":"非常抱歉，您访问的页面不存在或已删除","page-original-text002":"你在{{datetime}}购买过本作品的授权，点击查看详情。","page-original-text003":"授权信息","page-original-text004":"授权DNA","page-original-text005":"授权方","page-original-text006":"授权时间","page-original-text007":"获授权方","page-original-text008":"获授权媒体","page-original-text009":"获授权账号","page-original-text010":"获授权账号ID","page-original-text011":"获授权账号链接","page-original-text012":"获授权网站链接","page-original-text013":"获授权编辑姓名","page-original-text014":"原本链地址","page-original-text015":"认证信息","page-original-text016":"完整原本DNA","page-original-text017":"授权Hash","page-original-text018":"数字签名","page-original-text019":"签名公钥","page-original-text020":"分享到微信","page-original-text021":"请用微信扫码打开网页，然后按右上角的分享按钮","page-original-text022":"授权详情","page-original-text023":"删除文章","page-original-text024":"复制文章","page-original-text025":"授权信息已发送至获授权人的邮箱，请查收","page-original-text026":"认证信息","page-original-text027":"文章作者","page-original-text028":"存证时间","page-original-text029":"原本链地址","page-original-text030":"认证详情","page-original-text031":"分享到微博","page-original-text032":"分享到微信","page-original-text033":"分享到QQ空间","page-original-text034":"分享到豆瓣","page-original-text035":"确认要删除这篇文章吗？","page-original-text036":"确认删除文章 ","page-original-text037":"该作品疑似非作者原创，已暂停转载授权。原本坚决维护原创版权环境，对此带来的不便，我们表示诚挚的道歉","page-original-text038":"文章已删除","page-original-text039":"文章已被其他用户转载，无法删除","page-original-text040":"参数错误","page-original-text041":"已取消收藏","page-original-text042":"已添加收藏","page-original-text043":"请稍候...","page-original-text044":"取消收藏","page-original-text045":"添加收藏","page-original-text046":"微信多图文组合","page-original-text047":"正在发送...","page-original-text048":"一键发送","page-original-text049":"清空","page-original-text050":"最多组合发布8篇文章","page-original-text051":"该文章已添加到组合列表","page-original-text052":"请先绑定公众号并刷新页面","page-original-text053":"微信授权已过期","page-original-text054":"前往绑定","page-original-text055":"重新绑定","page-original-text056":"正在发布...","page-original-text057":"网络异常，请稍候重试","page-original-text058":"成功发送到","page-original-text059":"上传的图片大小不能超过2MB","page-original-text060":"上传的图片格式必须是jpg, png, bmp中的一种。","page-original-text061":"正在上传...","page-original-text062":"图片正在处理中","page-original-text063":"标签","page-original-text064":"删除","page-original-text065":"删除图片","page-original-text066":"下载预览图","page-original-text067":"下载原图","page-original-text068":"图片作者","page-original-text069":"分辨率","page-original-text070":"文件大小","page-original-text071":"图片格式","page-original-text072":"图片来源","page-original-text073":"确认要删除这张图片吗？","page-original-text074":"确认删除图片","page-original-text075":"cc0图片","page-original-text076":"图片已删除","page-original-text077":"图片已被其他用户转载，无法删除","page-original-text078":"获取授权","page-original-text079":"获取授权 - 授权协议","page-original-text080":"同意并获取","page-original-text081":"取消","page-original-text082":"您确认并理解许可人作品采用原本商业许可协议进行授权许可","page-original-text083":"授权范围仅限网络、报刊杂志的非独占性单次转载","page-original-text084":"您必须按照许可人指定的方式对作品进行署名","page-original-text085":"您被授权基于该作品创作演绎作品","page-original-text086":"您未被授权基于该作品创作演绎作品","page-original-text087":"同意\"上海七印信息科技有限公司\"作为许可人的代理方，追究您任何违约责任的权利","page-original-text088":"同意","page-original-text089":"获取授权 - 授权信息","page-original-text090":"邮箱地址","page-original-text091":"请输入","page-original-text092":"账号类型","page-original-text093":"请选择","page-original-text094":"主体名称","page-original-text095":"账号名称","page-original-text096":"媒体名称","page-original-text097":"账号ID","page-original-text098":"账号链接","page-original-text099":"网站链接","page-original-text100":"编辑姓名","page-original-text101":"下一步","page-original-text102":"获取授权 - 选择支付方式","page-original-text103":"申请授权需支付的金额","page-original-text104":"微信支付","page-original-text105":"支付宝支付","page-original-text106":"余额支付","page-original-text107":"余额","page-original-text108":"余额不足","page-original-text109":"获取授权 - 余额支付","page-original-text110":"使用账户余额支付","page-original-text111":"当前账户余额","page-original-text112":"确认支付","page-original-text113":"获取授权 - 扫码支付","page-original-text114":"使用微信扫码支付","page-original-text115":"获取授权 - 等待支付","page-original-text116":"请在弹出页面中完成支付","page-original-text117":"正在等待支付结果...","page-original-text118":"支付遇到问题？","page-original-text119":"由于作者未使用智能转载协议，本作品暂时无法购买。","page-original-text120":"你希望以多少钱转载本作品？我们会将你的意向通知作者。","page-original-text121":"元","page-original-text122":"传达意愿","page-original-text123":"获取授权成功","page-original-text124":"我们已将你的意愿传达给作者","page-original-text125":"请联系作者获取授权","page-original-text126":"添加到组合","page-original-text127":"请认真填写公众号信息，以免授权错误","page-original-text128":"原文链接","page-original-text129":"下载存证包","page-original-text130":"上一步","page-original-tipText":"文件授权信息已发送到你邮箱，敬请查收!","page-original-receipt-button":"申请发票","page-original-receipt-notify":"您还可以","page-original-Operator":"操作人","page-payment-text001":"购买成功","page-payment-text002":"取消支付","page-payment-text003":"支付失败","page-terms-title":"原本用户协议","page-terms-text001":"原本用户注册及服务协议","page-terms-text002":"原本","page-terms-text003":"发布日期","page-terms-text004":"请您仔细阅读以下全部内容","page-terms-text005":"上海七印信息科技有限公司（简称：“公司”）旗下产品原本","page-terms-text069":"是为作者原创的作品提供原创的时间证明、内容确认以及版权交易的网站。服务使用人（简称：“用户”）必须完全同意本协议所有条款并完成注册程序，才能成为公司产品用户。","page-terms-text006":"用户同意此在线会员注册服务协议之效力如同用户亲自签字或盖章的书面协议一样，对用户具有法律约束力。用户进入会员注册程序，点击并勾选“我同意并接受服务协议”即表示用户完全接受协议中全部条款内容。此后，用户不得以未阅读本服务协议条款内容作任何形式的抗辩。","page-terms-text007":"用户身份保证","page-terms-text008":"用户承诺并保证其具有完全民事行为能力和完全民事权利能力的自然人，或依法设立并有效存续的单位（包括企业法人和其他组织）。用户保证其所填写的用户信息真实、准确、完整，且没有任何引人误解或者虚假的陈述，同时不得侵犯他人的知识产权及合法权益。公司将依据用户所填写的联系方式与其取得联系，若有变动应及时通知公司；","page-terms-text009":"用户应根据公司的要求及时提供其身份证明或身份信息等资料，否则有权拒绝该用户注册申请，并拒绝提供相关服务。","page-terms-text010":"用户承诺将及时更新其用户信息以维持其信息有效性。","page-terms-text011":"用户以代理人身份代理其他自然人或者企业法人进行注册的，须向公司提供代理人和被代理人的详细资料、信息及书面授权委托书。未向公司提供上述资料信息及文件的，公司将视该注册者为会员。","page-terms-text012":"会员身份确认","page-terms-text013":"用户注册成功后将得到一个用户名和密码，用户凭用户名和密码享受公司向其提供各项服务。","page-terms-text014":"用户应妥善保管其用户名和密码，并对用户名和密码安全负全部责任，任何使用其用户名和密码进行的活动和事件都视为该用户的操作。","page-terms-text015":"用户若发现任何非法使用其帐号的行为或可能存在安全漏洞的情况，请立即通知公司，紧急修改该密码。因黑客行为或用户的保管不善导致账号、密码被他人非法使用，公司不承担责任。","page-terms-text016":"服务条款的修改和服务体系修订","page-terms-text017":"公司有权在必要时修改本服务协议条款，若服务协议条款发生变动，公司将会在重要页面向用户提示修改内容。用户若不同意可主动取消其获得的网络服务。若用户继续使用公司服务，则视为接受服务协议条款的变动内容。","page-terms-text018":"用户的权利和义务","page-terms-text019":"用户有权拥有其在公司注册时取得的用户名和密码，并有权使用该用户名和密码在任一时间、任一地点登录公司网站。","page-terms-text020":"用户有权享受公司依据本服务协议条款提供的互联网技术和信息服务，并有权利在接受服务时获得公司技术支持、咨询等服务。","page-terms-text021":"用户在履行本服务协议条款中不侵犯公司及任何第三方的知识产权或其他合法权利。若有侵权行为，其给其他第三方造成的经济损失，由用户自己承担。若因用户的作品侵权导致公司对外承担赔偿责任的，用户赔偿公司因此产生的全部经济损失。","page-terms-text022":"用户应保证遵守中国法律、法规、行业惯例和社会公共道德，不得利用公司提供的服务存储、发布、传播下述信息或内容：","page-terms-text023":"违反国家法律、法规的任何内容或信息；","page-terms-text024":"违反国家有关政治或新闻宣传规定的信息；","page-terms-text025":"涉及国家秘密或或危害国家安全的信息；","page-terms-text026":"涉及封建迷信或淫秽、色情、教唆犯罪等信息；","page-terms-text027":"涉及博彩有奖、赌博游戏等信息；","page-terms-text028":"违反国家民族和宗教政策的信息；","page-terms-text029":"防碍互联网运行安全的信息；","page-terms-text030":"侵害他人合法权益的信息；","page-terms-text031":"其他有损于社会秩序、社会治安、公共道德的信息或内容。","page-terms-text032":"用户承诺不得为他人发布上述不符合国家法律、法规规定和不符合本服务协议条款约定的信息或内容提供任何技术或内容上的便利。","page-terms-text033":"用户同意公司有权在其违反上述规定时终止向其提供服务并删除违法信息或内容。若因用户的上述行为给公司造成经济损失的，用户应予赔偿。","page-terms-text034":"公司的权利和义务","page-terms-text035":"公司应为用户提供有效的网络技术和信息服务。","page-terms-text036":"公司承诺对用户信息及资料采取保密措施，不向第三方披露用户资料，不授权第三方使用用户资料，除非：","page-terms-text037":"依据本注册协议或者双方另有约定可以的；","page-terms-text038":"依据我国法律法规规定应当提供的；","page-terms-text039":"用户同意公司向第三方提供的；","page-terms-text040":"公司解决举报事件、提起诉讼而提交给有关机关或部门的；","page-terms-text041":"公司为防止严重违法行为或涉嫌犯罪行为发生而采取必要合理行动所必须提交的。","page-terms-text042":"公司有权对用户上传的全部信息及资料进行内容审查，并对违法或违规内容予以删除，必要时终止为其提供服务。","page-terms-text043":"公司保留在用户违反国家、法律法规规定或违反本注册协议条款的情况下终止为其提供服务并终止用户帐号的权利。","page-terms-text044":"知识产权保护","page-terms-text045":"用户通过其用户管理后台上传到公司网站上的全部作品（包括但不限于文字、图形、照片、视频、音频等），其著作权归该用户本人享有。","page-terms-text046":"用户以不可撤销的方式授权公司对其上传到的公司网站的全部作品（包括但不限于文字、图形、照片、视频、音频等）享有文学作品信息网络传播权的非独家许可使用权，除非该用户上传的该作品已经被该用户将文学作品信息网络传播权以独占形式独家授权给其他使用方，即排他许可使用。","page-terms-text047":"公司可将用户授权给公司的非独家许可使用的作品通过展示、汇编的方式在公司各种形态的产品和服务上。","page-terms-text048":"对于用户已将文学作品信息网络传播权独家授权（即排他许可使用）给其他作品使用方的作品，用户在上传公司网站时应予以明确表示，未在上传该作品时明确表示已经授权给其他作品使用方独占授权许可时，视为该用户未授权独占许可，此时公司对该作品享有非独家许可使用权。","page-terms-text049":"用户以版权保护的目的将其作品上传公司网站时，无论该作品是否在用户上传时被其以独家授权的方式授权给其他作品使用方的，用户同意公司可以基于版权保护的目的继续使用、展示该作品。","page-terms-text050":"若因用户的不当上传作品的行为导致侵犯独家授权使用方合法权益的，由用户自行向被侵犯权方承担责任，公司对此不负赔偿责任。若因用户的上述行为导致公司受到经济损失的，则用户应当赔偿公司的全部经济损失。","page-terms-text051":"服务的终止及违约责任","page-terms-text052":"用户有权随时申请终止其用户注册协议，但因用户的终止行为给公司造成经济损失的，应当赔偿经济损失。","page-terms-text053":"因用户自身过错原因、违反法律或者本注册协议条款等原因，公司有权依约定提前终止用户注册协议，终止服务。","page-terms-text054":"若因公司原因给用户造成经济损失，公司同意承担由此给用户造成的经济损失，但本协议另有约定的除外。用户充分理解因网络故障、服务器故障而造成的延误或者给用户带来的损失均不应由公司承担。","page-terms-text055":"用户同意保障公司及公司网站其他用户的利益，若因用户违反法律、法规或本注册协议条款而给公司或任何第三方造成经济损失，用户同意赔偿其造成的公司或任何第三方的经济损失。","page-terms-text056":"争议解决及法律适用","page-terms-text057":"因本服务协议条款发生的争议，公司与用户应协商解决。若协商未成，任何一方均有权向公司注册地有管辖权的人民法院起诉。","page-terms-text058":"本注册协议条款的效力、解释、履行和争议的解决均适用中华人民共和国法律法规。","page-terms-text059":"不可抗力及免责声明","page-terms-text060":"因不可抗力或者其他意外事件，使得本服务协议条款履行不可能、不必要或者无意义的，遭受不可抗力、意外事件的一方不承担责任。","page-terms-text061":"不可抗力、意外事件是指不能预见、不能克服并不能避免且对一方或双方当事人造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、瘟疫流行和风暴等以及社会事件如战争、动乱、政府行为等。","page-terms-text062":"用户同意鉴于互联网的特殊性，黑客攻击、互联网连通中断或者系统故障等属于不可抗力，由此给用户或者第三方造成的损失公司不承担赔偿责任。","page-terms-text063":"用户明确同意其使用公司网站时对于存在的可能风险由其自己完全承担；因使用公司提供的网络服务而产生的一切后果也由其自己承担，公司对用户不承担任何责任。","page-terms-text064":"附则","page-terms-text065":"本服务协议条款中部分条款无效，不影响其他条款的效力，也不影响本服务条款的解释、违约责任及争议解决的有关约定的效力。","page-terms-text066":"用户变更其信息时，应自变更之日起5日内将变更后的信息在用户使用管理后台上修改，若因未修改信息导致的经济损失由其自行承担。用户同意：公司的任何通知只需在公司有关网页上发布即视为送达用户。","page-terms-text067":"本注册协议最终解释权归公司所有。","page-terms-text068":"本注册协议自用户点击确认即生效，对公司和用户具有同等法律约束力。","page-terms-text070":"数据存储与隐私条款","page-terms-text0701":"用户同意授权公司调用用户信息，及通过运营商验证实名身份信息。","page-terms-text0702":"用户可在账户权限范围内访问、更正个人信息，用户帐号的注销需要联系公司申请，账户注销一旦成功，该账户个人信息及存储的数据将无法恢复。","page-terms-text0703":"用户知晓公司旗下区块链服务存储的元数据一旦上链即无法修改和删除。","page-terms-text0704":"公司应当遵守互联网服务和数据安全相关要求，在服务期和保密义务履行期间采取措施保护用户隐私安全。","page-verify-title":"DNA验证","page-verify-text001":"验证中心","page-verify-text002":"原本DNA","page-verify-text003":"请输入原本DNA","page-verify-text004":"密钥","page-verify-text005":"密钥请在认证邮件中查看","page-verify-text006":"请输入密钥","page-verify-text007":"密钥保护码","page-verify-text008":"密钥保护码请在【个人信息】页面查看","page-verify-text009":"请输入密钥保护码","page-verify-text010":"验证码","page-verify-text011":"图片验证码","page-verify-text012":"点击更换验证码","page-verify-text013":"请输入验证码","page-verify-text014":"请稍候...","page-verify-text015":"立即验证","page-verify-text016":"DNA验证通过,您拥有该作品的所有权","page-verify-text017":"数字签名验证通过。作品公钥、作品内容和数字签名相符合。","page-verify-text018":"作者所有权验证通过。提供的密钥和作品公钥相符合。","page-verify-text019":"认证信息","page-verify-text020":"以下协议不包含未经认证的图片","page-verify-text021":"发布时间","page-verify-text022":"认证详情","page-verify-text023":"原本DNA","page-verify-text024":"授权协议","page-verify-text025":"授权说明","page-verify-text026":"区块链地址","page-verify-text027":"作品原文","page-verify-text028":"验证失败","page-verify-text029":"返回","page-verify-text030":"取证包验证","page-verify-text031":"什么是DNA验证？","page-verify-text032":"DNA是原本平台的专属印记，验证DNA可证明自己的原创所有权","page-verify-text033":"什么是TSA验证","page-verify-text034":"可信任时间戳认证，他是具备法律效力的电子凭证","page-verify-text035":"比对","page-verify-text036":"修改","page-verify-evidence":"存证包验证","page-similarity-text001":"文章相似度比对","page-similarity-text002":"文章1","page-similarity-text003":"文章2","page-similarity-text004":"比对结果","page-similarity-text005":"相似度：","page-similarity-wordNum":"相似字数：","page-similarity-text006":"确定","page-similarity-text007":"请输入文章1和文章2","page-similarity-text008":"原文","page-similarity-text009":"转载文章","home-dashboard-title":"我的原本","home-dashboard-text001":"认证文章","home-dashboard-text002":"认证图片","home-dashboard-text003":"我的原创","home-dashboard-text004":"系统公告","home-evidences-text001":"证据管理","home-evidences-text002":"证据列表","home-evidences-text003":"正在取证","home-evidences-text004":"输入网站/微信名/证据包编号","home-evidences-text005":"全部","home-evidences-text006":"已选择{{length}}篇","home-evidences-text007":"批量删除","home-evidences-text008":"打包下载","home-evidences-text009":"文章名/来源网站","home-evidences-text010":"取证时间","home-evidences-text011":"电子证据","home-evidences-text012":"操作","home-evidences-text013":"没有电子证据","home-evidences-text014":"你可以在转载监测中启动电子取证","home-evidences-text015":"无标题","home-evidences-text016":"查看证据","home-evidences-text017":"下载","home-evidences-text018":"删除","home-evidences-text019":"证据详细信息","home-evidences-text020":"保全时间","home-evidences-text021":"原本链地址","home-evidences-text022":"{{length}}个证明正在打包，请稍等...","home-evidences-text023":"打包完成，如果浏览器没有自动下载","home-evidences-text024":"您可以尝试","home-evidences-text025":"手动下载","home-evidences-text026":"证据删除后无法恢复，确认删除吗？","home-evidences-text027":"确认删除证据","home-evidences-text028":"请勾选需要打包的证据","home-evidences-text029":"请勾选需要删除的证据","home-evidences-text030":"取证任务","home-evidences-text031":"任务状态","home-evidences-text032":"没有进行中的取证任务","home-evidences-text033":"你可以在转载监测中启动电子取证","home-evidences-text034":"页面已失效","home-evidences-text035":"等待取证","home-evidences-text036":"正在取证","home-evidences-text037":"重试","home-evidences-text038":"取消","home-evidences-text039":"确认删除任务","home-evidences-text040":"签名校验","home-evidences-text041":"表单验证","home-evidences-text042":"tsa文件验证","home-evidences-text043":"文件格式错误，请按页面提示上传相关文件","home-evidences-text044":"校验成功","home-evidences-text045":"不能为空","home-evidences-text046":"Hash","home-evidences-text047":"tas-sign:","home-evidences-text048":"tas-time:","home-evidences-text049":"提交","home-evidences-text050":"上传文件","home-evidences-text051":"校验失败","home-evidences-text052":"区块链确认中...","home-evidences-text053":"重新上传","home-evidences-text054":"【*.png】「非“evidence.png\"文件」","home-evidences-text055":"【*.zip】皆可上传。","home-evidences-text0551":"【*.zip】请上传存证zip压缩包。","home-evidences-text056":"选择需要验证的证据包：","home-evidences-text057":"选择时间戳证书(tsa.txt)：","home-evidences-text058":"什么是TSA验证","home-evidences-text059":"可信任时间戳认证。它是具备法律效力的电子凭证。","home-evidences-text060":"为什么要进行取证包验证","home-evidences-text061":"验证签名的完整性及是否被篡改。","home-evidences-text062":"开始验证","home-evidences-text063":"该文件未通过验证，可能存在真实性风险！","home-evidences-text064":"错误提示：","home-evidences-text065":"返回","home-evidences-text066":"验证通过，您的可信任时间戳完整并且没有被篡改！","home-evidences-text0661":"验证通过，存证包完整且没有被篡改！","home-evidences-FailureEvidence":"过期证据","home-evidences-ReEvidence":"重新取证","home-evidences-status":"证据状态","home-evidences-noFailureEvidences":"暂无过期证据","home-evidences-evidencesNoFailure":"证据过期","home-evidences-receivingEvidence":"重新取证","home-evidences-noSelectTips":"请勾选需要取证的选项","home-evidences-lineUp":"已进入取证队列","home-evidences-batchForensics":"批量取证","home-evidences-Forensics":"取证报错","home-evidences-ForensicsStatus":"取证状态","home-evidences-EvidenceRecord":"证据包问题记录","home-importwx-title":"微信文章导入","home-importwx-text001":"导入微信公众号文章","home-importwx-text002":"更新文章","home-importwx-text003":"已选择{{length}}篇","home-importwx-text004":"删除","home-importwx-text005":"全部认证","home-importwx-text006":"去认证","home-importwx-text007":"作品名称","home-importwx-text008":"发布时间","home-importwx-text009":"认证状态","home-importwx-text010":"待认证","home-importwx-text011":"失败","home-importwx-text012":"选择授权协议","home-importwx-text013":"正在认证...","home-importwx-text014":"立即认证","home-importwx-text015":"取消","home-importwx-text016":"准备导入","home-importwx-text017":"微信公众号文章导入完成！","home-importwx-text018":"删除后无法恢复，确认删除吗？","home-importwx-text019":"请选择需要认证的文章","home-importwx-text020":"文章认证成功！","home-infringements-text001":"转载监测","home-infringements-text002":"全部转载记录","home-infringements-text003":"(取证时请等待一分钟，取证完毕后在“证据管理”中显示)","home-infringements-text004":"媒体白名单","home-infringements-text005":"全部转载","home-infringements-text006":"认证时间","home-infringements-text007":"授权协议","home-infringements-text008":"转载数","home-infringements-text009":"转载记录","home-infringements-text010":"文章转载","home-infringements-text011":"取证","home-infringements-text012":"已提交取证","home-infringements-text013":"支付取证费用","home-infringements-text014":"条目数量","home-infringements-text015":"条","home-infringements-text016":"取证单价","home-infringements-text017":"元/条","home-infringements-text018":"取证总价","home-infringements-text019":"元","home-infringements-text020":"需支付","home-infringements-text021":"此条取证保存时间","home-infringements-text022":"支付并开始取证","home-infringements-text023":"取消","home-infringements-text024":"已加入取证列表，可在电子取证页面查看详情","home-infringements-text025":"转载总览","home-infringements-text026":"转载总次数","home-infringements-text027":"今日转载次数","home-infringements-text028":"被转载文章数","home-infringements-text029":"来源站点数","home-infringements-text030":"转载趋势图","home-infringements-text0301":"重点媒体转播","home-infringements-text031":"时间","home-infringements-text032":"认证时间","home-infringements-text033":"转载数","home-infringements-text034":"按文章排序","home-infringements-text035":"按来源排序","home-infringements-text036":"7天","home-infringements-text037":"15天","home-infringements-text038":"30天","home-infringements-text039":"转载来源","home-infringements-text040":"一键添加白名单","home-infringements-text041":"原文章","home-infringements-text042":"添加成功","home-infringements-text043":"该记录已经存在","home-infringements-text044":"添加失败","home-infringements-text045":"微信链接可能已失效","home-infringements-text046":"链接刷新","home-infringements-text047":"正在刷新...","home-infringements-text048":"每分钟只允许刷新一次！","home-infringements-text049":"刷新完成","home-infringements-text050":"刷新失败,重试","home-infringements-text051":"转载占比","home-infringements-text052":"全部取证","home-infringements-text053":"导出转载记录","home-infringements-text054":"历史转载记录","home-infringements-text055":"选择时间:","home-infringements-text056":"网站总计","home-infringements-text057":"文章总计","home-infringements-text058":"统计网站转载次数","home-infringements-text059":"统计文章转载次数","home-infringements-text060":"全部","home-infringements-text061":"10次以上","home-infringements-text062":"50次以上","home-infringements-text063":"100次以上","home-infringements-text064":"总计条目","home-infringements-text065":"全部内容","home-infringements-text066":"按时间排序","home-infringements-text067":"按平台排序","home-infringements-text068":"按文章排序","home-infringements-text069":"全部数据内容过多，会占用您一定的硬盘容量。您是否确认继续进行下载？","home-infringements-text070":"转载时间范围筛选","home-infringements-text071":"请选择结束日期","home-infringements-text072":"转载次数筛选:","home-infringements-text073":"确定","home-infringements-text074":"导出","home-infringements-text075":"搜索/筛选","home-infringements-text076":"全部","home-infringements-text077":"侵权总计:","home-infringements-text078":"列表","home-infringements-text079":"网站:","home-infringements-text080":"文章:","home-infringements-text081":"清除筛选","home-infringements-text082":"请输入数字","home-infringements-text083":"数据加载中...","home-infringements-text084":"显示大于等于","home-infringements-text085":"次的结果","home-infringements-text086":"搜索媒体名称或文章标题","home-infringements-text087":"优惠部分","home-infringements-text088":"本月已免费取证","home-infringements-text089":"条","home-infringements-text090":"还有","home-infringements-text091":"取证-选择收费方式","home-infringements-text092":"取证需支付金额","home-infringements-text093":"取证-扫码支付","home-infringements-text094":"取证条数","home-infringements-text095":"取证总费用","home-infringements-text096":"单条取证费用","home-infringements-text097":"取证时间","home-infringements-text098":"天","home-infringements-text099":"取证退款","home-infringements-text100":"请至转载报告下载中心下载报告","home-infringements-text101":"转载报告下载中心","home-infringements-text102":"证据包编号","home-infringements-text103":"搜索","home-infringements-text104":"重置","home-recharge-text001":"充值中心","home-recharge-text002":"充值金额","home-recharge-text003":"充值金额不能为空，请输入大于0的正整数","home-recharge-text004":"支付方式","home-recharge-text005":"充值日期","home-recharge-text006":"充值-扫码支付","home-recharge-text007":"确认支付","home-recharge-text008":"请选择支付方式","home-recharge-text009":"由于您的身份为","home-recharge-text010":"。您的充值将统一进入企业账号内。特悉知。","home-recharge-text011":"企业财务","home-messages-text001":"全部消息","home-messages-text002":"【交易提醒】您的原创文章","home-messages-text003":"被","home-messages-text004":"转载至","home-messages-text005":"交易号","home-messages-text006":"转载DNA","home-messages-text007":"转载时间","home-messages-text008":"【交易提醒】您的原创图片","home-messages-text009":"购买","home-messages-text010":"暂无任何交易信息记录","home-messages-text011":"个人微信账号","home-messages-text012":"扫码绑定","home-messages-text013":"已绑定","home-messages-text014":"绑定个人微信号您能","home-messages-text015":"及时查看到作品交易情况","home-messages-text016":"随时掌握您的原创作品侵权数据","home-messages-text017":"随时了解作品的转载授权申请，以便灵活更改授权状态，获得交易收益。","home-messages-text018":"随时提取交易余额","home-messages-text019":"系统提醒","home-messages-text020":"交易提醒","home-profile-text001":"个人信息","home-profile-text002":"开启实名认证","home-profile-text003":"头像","home-profile-text004":"修改头像","home-profile-text005":"账号","home-profile-text006":"修改密码","home-profile-text007":"笔名","home-profile-text008":"只能修改一次","home-profile-text009":"简介","home-profile-text010":"请输入个人简介","home-profile-text011":"140个字以内","home-profile-text012":"请稍候...","home-profile-text013":"保存修改","home-profile-text014":"密钥保护码","home-profile-text015":"在DNA验证时需要输入密钥保护码","home-profile-text016":"查看密钥保护码","home-profile-text017":"提现账号","home-profile-text018":"绑定账号","home-profile-text019":"立即绑定","home-profile-text020":"解除绑定","home-profile-text021":"修改密码","home-profile-text022":"原密码","home-profile-text023":"请输入原密码","home-profile-text024":"新密码","home-profile-text025":"请输入新密码","home-profile-text026":"确认密码","home-profile-text027":"请再次输入新密码","home-profile-text028":"两次密码输入不一致","home-profile-text029":"请稍候...","home-profile-text031":"验证身份","home-profile-text032":"为了保证你的帐号安全,请验证身份。","home-profile-text034":"输入登录密码","home-profile-text035":"请输入密码","home-profile-text036":"复制密码","home-profile-text037":"头像上传成功","home-profile-text038":"上传的图片大小不能超过2MB","home-profile-text039":"上传的图片格式必须是jpg, png, gif, bmp中的一种","home-profile-text040":"正在上传...","home-profile-text041":"请输入笔名","home-profile-text042":"保存成功！","home-profile-text043":"密码修改成功！","home-profile-text044":"我的收藏","home-profile-text045":"媒体平台","home-profile-text046":"媒体平台","home-profile-text047":"绑定账号导入您的原创作品，实时在线管理您的原创","home-profile-text048":"立即绑定","home-profile-text049":"绑定微信公众号","home-profile-text050":"授权已过期","home-profile-text051":"刷新授权","home-profile-text052":"导入公众号文章","home-profile-text053":"解除绑定","home-profile-text054":"绑定微博","home-profile-text055":"绑定头条号","home-profile-text056":"导入头条号文章","home-profile-text057":"确认要解除绑定吗？","home-profile-text058":"我的交易","home-profile-text059":"账户余额","home-profile-text060":"元","home-profile-text061":"历史收入","home-profile-text062":"支出","home-profile-text063":"交易记录","home-profile-text064":"交易单号","home-profile-text065":"微信收取1%的手续费","home-profile-text066":"支付宝收取1.2%的手续费","home-profile-text067":"提现到微信账户","home-profile-text068":"提现到支付宝账户","home-profile-text0681":"提现到线下","home-profile-text069":"授权内容","home-profile-text070":"授权收入","home-profile-text071":"授权DNA","home-profile-text072":"账户余额提现","home-profile-text073":"所有","home-profile-text074":"收入","home-profile-text075":"支出","home-profile-text076":"提现","home-profile-text077":"提现金额","home-profile-text078":"请输入提现金额","home-profile-text079":"提现最小金额为1元","home-profile-text080":"提现金额超过账户余额","home-profile-text081":"当前账户余额","home-profile-text082":"非实名账号每天最多提现2000元，收款平台实名账号20000元","home-profile-text083":"账号","home-profile-text084":"[已绑定]","home-profile-text085":"[尚未绑定]","home-profile-text086":"立即绑定","home-profile-text087":"提现账户","home-profile-text088":"登录密码","home-profile-text089":"请输入登录密码","home-profile-text090":"确认提现","home-profile-text091":"请输入头条号链接","home-profile-text092":"请输入正确的头条号链接","home-profile-text093":"公众号二维码","home-profile-text094":"微博链接","home-profile-text095":"头条号链接","home-profile-text096":"添加","home-profile-text097":"修改","home-profile-text098":"提交成功","home-profile-text099":"网站地址","home-profile-text100":"上传公众号二维码","home-profile-text101":"授权发布","home-profile-text102":"授权原本平台发布文章内容","home-profile-text103":"授权原本发布：","home-profile-text104":"您将只收到一次包含私钥和公钥的邮件。请妥善保管此邮件。","home-profile-text105":"不授权原本发布：","home-profile-text106":"您将在每次发布文章后，都会收到平台发送的关于此篇文章的公钥和私钥的邮件。","home-profile-text107":"已授权","home-profile-text108":"页面将弹窗显示一次您的公钥和私钥并会发送一封相关邮件至您的邮箱。","home-profile-text109":"请妥善保管私钥信息，遗失不可补。","home-profile-text110":"公钥","home-profile-text111":"私钥","home-profile-text112":"公私钥信息","home-profile-text113":"导出文件","home-profile-text114":"授权费用","home-profile-text115":"转载至","home-profile-text116":"元","home-profile-text117":" 充值","home-profile-text118":" 充值成功","home-profile-text119":"交易方式","home-profile-text120":"原创者","home-profile-text121":"余额提现","home-profile-text122":"操作人员","home-profile-text123":"提现日期","home-profile-text124":"购买人","home-profile-text125":"取证时间","home-profile-text126":"银行名称","home-profile-text127":"银行账号","home-profile-receipt":"申请电子发票","home-profile-receipt-apply":"发票申请","home-profile-receipt-amount":"合计开票金额: {{amount}} 元，共 {{length}} 个订单","home-profile-receipt-amount-alert":"开票金额不足200元时，不可申请发票","home-profile-receipt-submit":"确定开发票","home-profile-receipt-submitted":"已开票","home-profile-withdrwa-chooseCash":"选择提现账号","home-profile-remind":"可提醒管理员进行账号绑定","home-profile-underReview":"审核中","home-profile-cashCompleted":"完成提现","home-publish-text001":"选择协议","home-publish-text002":"原创审核未通过","home-publish-text003":"你的文章与以下文章内容高度相似，无法发布。","home-publish-text004":"相似文章","home-publish-text005":"如果你认为这是系统误判，请联系在线客服。","home-publish-text006":"确定","home-publish-text007":"认证成功","home-publish-text008":"作品唯一DNA","home-publish-text009":"区块链地址","home-publish-text010":"认证详情","home-publish-text011":"认证信息","home-publish-text012":"以下协议不包含未经认证的图片","home-publish-text013":"发布时间","home-publish-text014":"原本DNA","home-publish-text015":"授权协议","home-publish-text016":"授权说明","home-publish-text017":"区块链地址","home-publish-text018":"作品原文","home-publish-text019":"为保障您的权益，发布文章时请保留文章底部的原本DNA徽章和文字说明，以确保任何人都可以找到文章的原始出处和作者。","home-publish-text020":"您可以","home-publish-text021":"复制文章内容","home-publish-text022":"文章底部生成了\"原本DNA\"的图章和文字说明","home-publish-text023":"原本DNA是重要的版权认证和追溯链接","home-publish-text024":"请始终确保文章底部带有文字说明或图章之一","home-publish-text025":"知道了","home-publish-text026":"编辑文章","home-publish-text027":"请输入文章标题","home-publish-text028":"手机预览","home-publish-text029":"网页预览","home-publish-text030":"关闭","home-publish-text031":"去认证","home-publish-text032":"预览","home-publish-text033":"选择授权协议","home-publish-text034":"正在认证...","home-publish-text035":"立即认证","home-publish-text036":"取消","home-publish-text037":"插入图片","home-publish-text038":"保存中","home-publish-text039":"已保存","home-publish-text040":"请输入文章标题","home-publish-text041":"请输入文章内容","home-publish-text042":"图片正在处理中，请稍等...","home-publish-text043":"认证原创图片","home-publish-text044":"图片认证成功！","home-publish-text045":"图片正在处理中","home-publish-text046":"您可以在这里绑定<br>媒体平台，批量导<br>入文章","home-publish-text047":"本地上传","home-publish-text048":"输入搜索关键词，比如相机、猫、电脑、自行车等","home-publish-text049":"搜索","home-publish-text050":"正在上传","home-publish-text051":"CC0图片","home-publish-text052":"已选择{{length}}张","home-publish-text053":"确认","home-publish-text054":"取消","home-publish-text055":"上传的图片大小不能超过2MB。","home-publish-text056":"上传的图片格式必须是jpg, png, gif, bmp中的一种。","home-publish-text057":"正在上传...","home-publish-text058":"已认证图片","home-publish-text059":"本地图片","home-publish-text060":"CC0图片","home-publish-text061":"输入标签用英文逗号隔开","home-publish-text062":"热门标签","home-publish-text063":"标签不能超过5个","home-publish-text064":"单个标签不能超过5个字符","home-publish-text065":"发布媒体","home-publish-text066":"认证完成","home-publish-text067":"{{length}} 张图片认证成功","home-publish-text068":"图片内容","home-publish-text069":"我的图片","home-publish-text070":"继续认证","home-publish-text071":"上传图片","home-publish-text072":"点击上传或拖动图片到此处","home-publish-text0721":"支持jpg/png/gif/bmp","home-publish-text0722":"上传作品","home-publish-text0723":"(支持多张图片同时上传,每张图片不超过20M)","home-publish-text0724":"作品信息","home-publish-text0725":"添加标签","home-publish-text0726":"推荐关键字","home-publish-text073":"总共","home-publish-text074":"张","home-publish-text075":"请输入图片标题","home-publish-text076":"下一步","home-publish-text077":"上传的图片大小不能超过20MB","home-publish-text078":"'网络错误，请稍后重试...'","home-publish-text079":"确认要删除这张图片吗？","home-publish-text080":"确认删除图片","home-publish-text081":"正在上传，请稍等...","home-publish-text082":"请至少上传一张图片","home-publish-text083":"请将图片的标题填写完整","home-realname-text001":"你还未完成实名认证，无法发布原创作品。","home-realname-text002":"点击这里","home-realname-text003":"进行实名认证。","home-realname-text004":"为什么要实名认证？","home-realname-text005":"原本致力于和原创作者一起打造一个读者可信赖的原创内容平台。","home-realname-text006":"我们希望和优秀的作者们联合起来，通过实名的方式营造一个真实、可信赖的高质量原创社区，共同抵制在这个时代充斥着互联网的匿名虚假信息和不负责任言论。","home-realname-text007":"我们承诺保护作者的隐私，实名信息仅用于此处的验证，绝不会被用于任何其他用途。","home-realname-text008":"实名认证","home-realname-text009":"姓名","home-realname-text010":"请输入姓名","home-realname-text011":"身份证","home-realname-text012":"请输入身份证号","home-realname-text013":"验证码","home-realname-text014":"点击更换验证码","home-realname-text015":"请输入验证码","home-realname-text016":"请稍候...","home-realname-text017":"实名验证","home-realname-text018":"实名验证成功","home-realname-text019":"服务暂时不可用，请稍后再试","home-realname-text020":"你还未完成实名认证, ","home-reprint-text001":"我的转载","home-reprint-text002":"文章","home-reprint-text003":"图片","home-reprint-text004":"输入搜索内容","home-reprint-text005":"未找到相关结果","home-reprint-text006":"授权方","home-reprint-text007":"获授权方","home-reprint-text008":"获授权账号","home-reprint-text009":"获授权ID","home-reprint-text010":"删除","home-reprint-text011":"图片正在处理中","home-reprint-text012":"确认要删除这篇文章吗？","home-reprint-text013":"确认删除文章","home-reprint-text014":"确认删除图片","home-reprint-text015":"CC协议授权","home-reprint-text016":"CM商业协议","home-reprint-text017":"全部","home-reprint-text018":"转载信息加载失败","home-reprint-text019":"文章已删除","home-reprint-text020":"图片已删除","home-whitelist-text001":"白名单设置","home-whitelist-text002":"什么是白名单？","home-whitelist-text003":"侵权监测自动过滤白名单中用户。","home-whitelist-text004":"白名单中的用户类型","home-whitelist-text005":"自有媒体平台，合作媒体平台","home-whitelist-text006":"添加白名单","home-whitelist-text007":"您还未添加白名单","home-whitelist-text008":"修改","home-whitelist-text009":"删除","home-whitelist-text010":"确定","home-whitelist-text011":"公众号名称","home-whitelist-text012":"公众号ID","home-whitelist-text013":"例如","home-whitelist-text014":"网站名称","home-whitelist-text015":"网站地址","home-whitelist-text016":"网站主域名","home-whitelist-text017":"微信公众号","home-whitelist-text018":"删除成功","home-whitelist-text019":"删除失败","home-whitelist-text020":"请将输入框信息填写完整","home-whitelist-text021":"保存成功","home-whitelist-text022":"保存失败","home-whitelist-text023":"获取数据失败","home-whitelist-text024":"网站二级域名","home-whitelist-text025":"输入公众号或网站地址","home-whitelist-text026":"或","home-whitelist-text027":"确认删除该名单 ?","home-whitelist-text028":"共计白名单","home-whitelist-text029":"条","home-whitelist-text030":"请输入微信公众号或网站名","home-whitelist-text031":"请输入微信公众号名称或网站地址","home-whitelist-text032":"取消","home-whitelist-text033":"没有搜索结果","home-whitelist-text034":"重新搜索","home-whitelist-text035":"百家号","home-whitelist-text036":"搜狐号","home-whitelist-yidianzixun":"一点资讯","home-whitelist-jinritoutiao":"今日头条","home-whitelist-xueqiu":"雪球","home-whitelist-App":"App","license-text001":"选择转载许可协议","license-text002":"知识共享许可协议","license-text003":"cc协议是基于条件的免费共享协议","license-text004":"署名-非商业使用-相同方式共享","license-text005":"署名-非商业使用-禁止演绎","license-text006":"署名-非商业使用","license-text007":"署名-禁止演绎","license-text008":"署名-相同方式共享","license-text009":"署名","license-text010":"商业许可协议","license-text011":"商业协议是指，作者将通过商业授权的方式授权作品的转载。","license-text012":"商业授权协议分为可修改和不可修改原作，转载者需按作者的意愿进行转载","license-text013":"作者可对授权作品设置相应的价格，显示价格为单篇/幅作品价格。价格设置的解释权归作者所有","license-text014":"是否允许您的作品被改编","license-text015":"是","license-text016":"否","license-text017":"是，只要他人以相同方式共享","license-text018":"是否允许商业使用","license-text019":"是否允许您的作品被改编","license-text020":"设置转载价格","license-text021":"元","license-text022":"自定义金额","license-text023":"您选择的转载许可协议","license-text024":"正在认证...","license-text025":"请稍候...","license-text026":"完成认证","license-text027":"返回","license-text028":"价格不能为空,请输入大于零的数字","license-text029":"请输入价格","license-text030":"本作品采用","license-text031":"4.0 国际许可协议","license-text032":"知识共享署名","license-text033":"非商业性使用","license-text034":"禁止演绎","license-text035":"相同方式共享","license-text036":"进行许可。","license-text037":"您确认并理解许可人作品采用","license-text038":"允许复制、发行、展览和表演作品，但必须按照指定的方式对作品进行署名","license-text039":"允许出于非商业目的复制、发行、展览和表演作品","license-text040":"允许复制、发行、展览和表演作品，包括出于商业目的进行上述活动","license-text041":"允许复制、发行、展览和表演作品，但不允许基于该作品创作演绎作品","license-text042":"允许复制、发行、展览和表演作品，也允许基于该作品创作演绎作品","license-text043":"允许复制、发行演绎作品，但演绎作品必须采用与本协议相同或兼容的协议进行许可","license-text044":"同意\"上海七印信息科技有限公司\"作为许可人的代理方，追究您任何违约责任的权利","license-text045":"本作品使用商业转载授权协议发布","license-text046":"不允许修改原作品，不允许再创作","license-text047":"允许修改原作品和再创作","license-text048":"允许复制、修改、发行和表演本作品，甚至可用于商业性目的，都无需要求同意","license-text049":"知识共享（CC）4.0协议","license-text050":"必须按照许可人指定的方式对作品进行署名","license-text051":"仅被授权出于非商业目的而复制、发行、展览和表演作品","license-text052":"不允许基于该作品创作演绎作品","license-text053":"您可以复制、发行、展览和表演作品，也必须允许他人基于该作品创作演绎作品","license-text054":"商业授权","license-text055":"授权费用","license-text056":"您可以复制、修改、发行和表演本作品，甚至可用于商业性目的，都无需要求同意","license-text057":"设置价格有效时间","license-text058":"永久有效","license-text059":"一周","license-text060":"两周","license-text061":"一个月","license-text062":"自定义时限","license-text063":"天","license-text064":"到期后转换成CC知识共享许可协议。请选择相关信息","license-text065":"超过有效期限后，本作品采用","license-text066":"按单篇文章计算","license-text067":"按每千字计算","license-text0671":"按单张图片计算","license-text068":"本文总字数:","license-text069":"本文每千字","license-text070":"本文总价格:","modal-text001":"确认","modal-text002":"取消","navbar-text001":"登录","navbar-text002":"注册","navbar-text003":"个人信息","navbar-text004":"媒体白名单","navbar-text005":"媒体平台","navbar-text006":"我的收藏","navbar-text007":"我的交易","navbar-text008":"退出","navbar-text009":"条新信息","navbar-text010":"全部已读","navbar-text011":"【交易提醒】您的原创文章","navbar-text0111":"【交易提醒】您的原创图片","navbar-text012":"被","navbar-text013":"转载至","navbar-text014":"购买","navbar-text015":"暂无任何交易信息记录","navbar-text016":"查看全部","navbar-text017":"我的消息","navbar-text018":"搜索原本DNA","navbar-text019":"验证文章所有权","navbar-text020":"插件","navbar-text021":"认证原创","navbar-text022":"认证文章","navbar-text023":"认证图片","navbar-text024":"我的原创","navbar-text025":"我的转载","navbar-text026":"转载监测","navbar-text027":"证据管理","navbar-text028":"平台充值","navbar-text029":"组织管理","pager-text001":"共","pager-text002":"页","pager-text003":"第","pager-text004":"页","pager-text005":"确定","footer-text001":"七印科技 版权所有 保留一切权利","footer-text0011":"区块链信息服务备案：沪网信备31011519459278990011号","footer-text0012":"沪公网安备 31010902002951号","footer-text002":"用户指南","footer-text003":"使用条款","footer-text004":"联系我们","footer-text005":"加入原本","footer-text006":"扫一扫，了解更多","footer-text007":"沪ICP备16040562号-1","services-text001":"浏览器不支持自动复制，请手动完成复制","services-text002":"文章内容已复制到剪贴板","services-text003":"本文经「原本」原创认证，作者xxx，访问yuanben.io查询【5158V8GI】获取授权信息。","services-text004":"本文已获得转载授权，版权为xxx所有，访问原本yuanben.io查询【3OMUBXKJ】验证授权","modules-text001":"绑定微信账号","modules-text002":"使用微信扫码确认授权","modules-text003":"确认要解除绑定吗？","modules-text004":"发布到媒体平台","modules-text005":"点击更换或者拖动图片到此处","modules-text006":"请输入文章摘要","modules-text007":"请输入图片描述","modules-text008":"微信公众号","modules-text009":"直接群发给订阅者","modules-text010":"去绑定","modules-text011":"授权已过期","modules-text012":"微博头条","modules-text013":"头条号","modules-text014":"直接发布","modules-text015":"请选择需要发布到的媒体","modules-text016":"请稍候...","modules-text017":"发送","modules-text018":"请上传一张题图","modules-text019":"已成功发送到媒体！","modules-text020":"微信","modules-text021":"知乎","modules-text022":"知乎专栏","modules-text023":"网站","modules-text024":"知乎问答","modules-text025":"简书","modules-text026":"支付宝","modules-text027":"头条","modules-text028":"百家","modules-text029":"搜狐","modules-text030":"一点","modules-text031":"zaker","modules-text032":"北京时间","modules-text033":"快报","modules-text034":"腾讯新闻","modules-text035":"网易","modules-text036":"新浪","modules-text037":"APP","face-index-text001":"「原本」的服务对象","face-index-text002":"原创机构","face-index-text003":"报社，杂志社，原创图片网站，教育机构等原创机构","face-index-text004":"原创作者","face-index-text005":"文章作者，原创自媒体，摄影师，插画师等原创个体","face-index-text006":"企业自媒体","face-index-text007":"微信、微博、头条号等媒体账号运营者，企业号运营者","face-index-text008":"即将上线","face-index-text009":"政府组织","face-index-text010":"政务相关机构，社会团体组织","face-index-text011":"「原本」的核心","face-index-text012":"以科技驱动权威","face-index-text013":"原本链，全球联盟节点认证原创","face-index-text014":"原本区块链是一个横跨全球五大洲部署节点、由国内多家顶尖媒体机构共同参与的去中心化联盟链。这让记录在原本链上的原创作品认证具有极强的公信力与不可篡改性。","face-index-text015":"极强的原本链性能，将每一次原创认证的时间缩短至0.1秒。","face-index-text016":"查看原本链 >","face-index-text017":"独创的数字身份生成技术","face-index-text018":"DNA标签，作品的唯一数字指纹","face-index-text019":"作为早期将区块链应用于内容版权领域并持续稳定运行的团队，核心优势在于原本基于DTCP协议，独创了DNA标签技术。","face-index-text020":"一篇经过认证的作品，会将作者信息、作品信息、认证时间、授权协议等多维信息共同加密记入原本区块链中，生成独一无二的DNA标签。为原创作品赋予不可篡改的数字身份。","face-index-text021":"自定义授权协议，在线自助版权交易","face-index-text022":"全新的变现方式，收入曲线指数级增长","face-index-text023":"DNA标签包含作者自定义的转载授权协议，作品无论传播到哪里，都能被溯洄到授权页面，相当于为作品打上了商品标签，帮助交易自助并持续地发生。对于优质的原创作者来说，现在你有了全新的知识变现途径：","face-index-text024":"DNA溯洄在线交易，极大提高授权效率","face-index-text025":"多手转载仍能带来收益，让传播量指数级增长","face-index-text026":"原本对接海量内容转载商，助力优质作品的分发与交易","face-index-text027":"DNA追踪技术，让作品流向尽收眼底","face-index-text028":"实时获取作品传播与转载路径,更好地运营你的内容资产","face-index-text029":"配合DNA的可追踪技术，我们独立开发了可探测到全网每一个角落的“鹰眼”转载监测系统。这能让每一篇认证作品实时反馈它的全网传播路径，包括携带DNA的正规授权传播与非正规侵权传播。","face-index-text030":"为此，我们精心设计了可视化的数据界面，让原本每时每刻都为你生成有用的分析报告。","face-index-text031":"快速了解「原本」","face-index-text032":"「原本」的优势","face-index-text033":"核心技术","face-index-text034":"区块链技术保证认证信息一经写入、不可篡改，实现版权信息存证、溯源","face-index-text035":"多重保障","face-index-text036":"整合国家公证处、可信时间戳、数字签名技术，共同认证原创，保证原创的公信力","face-index-text037":"实时监测","face-index-text038":"\"鹰眼\"系统进行实时全平台侵权监控，\"磐石\"系统自动完成对侵权证据的固化保全","face-index-text039":"法律维权","face-index-text040":"与多家专业律所无缝对接，多种维权方案，对侵权行为付诸法律手段","face-index-text041":"「原本」的合作伙伴","face-index-text042":"链上条目数","face-index-text043":"每日追踪DNA路径","face-index-text044":"条","face-index-text045":"个","face-index-text046":"「原本」的优势","face-index-text047":"原本链已通过国家工信部认证","face-index-text048":"拥有卓越的性能和良好的安全性","face-index-text049":"原本链V3.0已通过国家工信部区块链性能测试，成为首个通过该测试的服务于数字内容领域的区块链。","face-index-text050":"可信时间戳，让作品更具法律效力!","face-index-text051":"原本平台所使用的TSA认证是基于国家授时中心同步的授时服务和国家认可的电子服务。TSA可认证作品在一个时间点是已经存在的、完整的、可验证的。","face-index-text052":"平台不仅提供TSA的认证，还支持对TSA的验证。用户可验证TSA的完整性和有效性。","face-index-text053":"查看TSA验证 >","face-index-text054":"5000W","face-index-text055":"20W","face-frontpage-text001":"原本，重新定义原创价值","face-frontpage-text002":"区块链原创保护和自助交易平台","face-frontpage-text0021":"\"区块链+\"原创保护和自助交易平台","face-frontpage-text0022":"原本全面支持","face-frontpage-text0023":"国家自主密码算法","face-frontpage-text003":"跨平台浏览器认证插件","face-frontpage-text004":"下载原本认证浏览器插件后，可以在微信公众号、简书、头条等平台创作完成后直接进行版权认证。","face-frontpage-text005":"立即下载","face-frontpage-text006":"免费正版图片","face-frontpage-text007":"文章配图很丰富很放心","face-frontpage-text008":"多平台发布 只需认证一次","face-frontpage-text009":"在原本平台完成原创认证,一键即可发布到微信公众号，微博头条，头条号等平台一次认证，全网发布。","face-frontpage-text010":"认证原创","face-frontpage-text011":"搜索原创","face-newscenter-text01":"原本动态","face-newscenter-text02":"原本，重新定义原创价值","face-newscenter-text03":"新闻中心","face-newscenter-text04":"发布时间：","face-newscenter-text05":"阅读原文","face-newscenter-text06":"第","face-newscenter-text07":"页","face-newscenter-text08":"确定","face-user-text001":"登录","face-user-text002":"注册","face-user-text003":"忘记密码","face-user-text004":"重置密码","face-user-text005":"验证邮箱","face-user-text006":"找回密码","face-user-text007":"请阅读并同意原本用户协议","face-user-text008":"参数不正确","face-user-text009":"两次密码输入不一致","face-user-text010":"邮件发送成功","face-user-text011":"你还未设置密码，请点击\"忘记密码\"设置","face-user-text012":"不能为空","face-user-text013":"请输入足够安全的密码","face-user-text014":"你的密码必须包含","face-user-text015":"至少八位","face-user-text016":"同时包含大小写字母","face-user-text017":"含有特殊字符","face-user-text018":"含有数字","face-user-text019":"密码强度","face-user-text020":"低","face-user-text021":"中","face-user-text022":"高","face-user-text023":"请避免使用简单密码或使用其他网站的密码","face-confirm-text001":"注册成功！","face-confirm-text002":"确认邮件已发送至您的注册邮箱","face-confirm-text003":"请点击邮件中的链接来激活您的账号。","face-confirm-text004":"登录邮箱","face-confirm-text005":"没有收到邮件？","face-confirm-text006":"请检查您邮箱的订阅邮件和垃圾邮件分组。","face-confirm-text007":"如果仍未收到，请尝试","face-confirm-text008":"欢迎登录原本！","face-confirm-text009":"您可以","face-confirm-text010":"绑定媒体导入历史文章","face-confirm-text011":"或者","face-confirm-text012":"认证文章","face-confirm-text013":"认证图片","face-confirm-text014":"重新发送确认邮件","face-find-text001":"邮件已发送！","face-find-text002":"密码重置邮件已发送至您的注册邮箱","face-find-text003":"请点击邮件中的链接来重置您的密码。","face-find-text004":"登录邮箱","face-find-text005":"没有收到邮件？","face-find-text006":"请检查您邮箱的订阅邮件和垃圾邮件分组。","face-find-text007":"如果仍未收到，请尝试","face-find-text008":"重新发送重置邮件","face-forget-text001":"邮箱","face-forget-text002":"验证码","face-forget-text003":"点击更换验证码","face-forget-text004":"找回密码","face-form-text001":"登录","face-form-text002":"注册","face-login-text001":"注册邮箱","face-login-text002":"密码","face-login-text003":"请稍候...","face-login-text004":"登录","face-login-text005":"记住我","face-login-text006":"忘记密码?","face-register-text001":"注册邮箱","face-register-text002":"笔名","face-register-text003":"密码","face-register-text004":"请稍候...","face-register-text005":"注册","face-register-text006":"我已阅读并同意","face-register-text007":"原本用户协议","face-reset-text001":"新密码","face-reset-text002":"确认密码","face-reset-text003":"请稍候...","face-reset-text004":"重置密码","face-news-title":"新闻中心","face-news-desc":"新闻中心","face-authors-title":"原创作者","face-authors-desc":"「原本」让原创价值回归原创作者。为作品生成全网唯一的原本DNA认证标签，永久携带署名和授权。让你的原创也能被自助购买，再也不用重复地一对一询价和授权沟通，对接海量原创需求商，加速内容传播的同时有效保护版权价值。","face-authors-text001":"倾听每一位创作者的声音","face-authors-text002":"让价值回归原创者","face-authors-text003":"发布原创","face-authors-text005":"免费、极速","face-authors-text006":"在线版权注册","face-authors-text007":"使用先进的区块链技术，我们提供给您完全免费、极速快捷的在线版权注册服务。为每一篇文章生成独有的版权DNA，永久保护正版价值","face-authors-text008":"让你的原创","face-authors-text009":"也能被自助购买","face-authors-text010":"轻松定制中意的授权方式，再也不用重复地一对一询价和授权沟通，加速内容传播的同时有效保护版权价值","face-authors-text011":"放出去的风筝","face-authors-text012":"握着线的「原本」","face-authors-text013":"无论文章被转载到哪里，简书、微博或者微信，通过认证图章和原本DNA都能快速找回原文，文章经过多次转载后也能保留作者和版权信息","face-authors-text014":"帮助内容分发","face-authors-text015":"加速传播与交易","face-authors-text016":"原创作品一经发布，「原本」便与海量的内容需求商对接，将您的优质内容精准分发出去。加速内容的传播与交易，实现版权的正规流通","face-authors-text017":"为每一篇文章","face-authors-text018":"实时全网侵权检测","face-authors-text019":"独创鹰眼全网侵权监测系统，为您的每一篇文章自动检索抄袭行为，及时生成侵权报告，保护原创价值不会流失","face-authors-text020":"和专业律所对接","face-authors-text021":"做最强力的维权","face-authors-text022":"无缝对接多家专业律所，提供不可被篡改的版权DNA作为强力证据。将损害原创利益的侵权者付诸法律，让版权的保护真正到位","face-consumers-title":"企业自媒体","face-consumers-desc":"订阅优质原创作品，更好地运营你的媒体账号。海量原创作品个性化推荐， 助你优质运营。在线自助购买授权，不再需要繁琐沟通。智能发布系统提供多平台管理、公众号代运营服务，降低运营成本。","face-consumers-text001":"订阅优质原创作品","face-consumers-text002":"更好地运营你的媒体账号","face-consumers-text003":"个性化内容推荐服务，海量内容助你优质运营","face-consumers-text004":"在线自助购买授权，拒绝繁琐沟通","face-consumers-text005":"选择你感兴趣的主题，我们为你推荐！","face-consumers-text006":"输入其他你感兴趣的主题，用逗号分隔","face-consumers-text007":"免费试订","face-consumers-text008":"输入你的基本信息，立即开启服务！","face-consumers-text009":"请输入邮箱","face-consumers-text010":"请输入手机号","face-consumers-text011":"请输入公司/组织名","face-consumers-text012":"立即订阅","face-consumers-text013":"订阅成功！","face-consumers-text014":"你的订阅已经成功！","face-consumers-text015":"返回","face-consumers-text016":"请选择或输入至少一个主题","face-consumers-text017":"邮箱","face-consumers-text018":"手机号","face-consumers-text019":"公司/组织名","face-consumers-text020":"格式错误","face-consumers-text021":"请输入","face-consumers-text022":"文学","face-consumers-text023":"教育","face-consumers-text024":"商业","face-consumers-text025":"艺术","face-consumers-text026":"生活","face-consumers-text027":"旅行","face-consumers-text028":"科技","face-consumers-text029":"时尚","face-consumers-text030":"电影","face-consumers-text031":"美食","face-consumers-text032":"摄影","face-consumers-text033":"经济","face-consumers-text034":"娱乐","face-consumers-text035":"健康","face-consumers-text036":"体育","face-consumers-text037":"音乐","face-header-text001":"首页","face-header-text0011":"原本链","face-header-text0012":"行业解决方案","face-header-text002":"原创机构","face-header-text003":"原创作者","face-header-text004":"企业自媒体","face-header-text005":"政府组织","face-header-text006":"即将上线","face-header-text007":"搜索","face-header-text008":"DNA验证","face-header-text009":"插件","face-header-text010":"登录","face-header-text011":"注册","face-header-text012":"我的原本","face-header-text013":"新闻中心","face-medias-title":"原创机构","face-medias-desc":"原创版权一站式服务平台。定制化的原创保护、版权交易和数据增值服务。为杂志社、报业集团、图片社和其他原创机构提供原创认证、侵权监测、证据保全和法律维权服务，对接海量渠道方，为渠道方提供自助购买授权的入口，提高原创机构变现能力。数据分析服务帮助原创机构更好地运营。","face-medias-text001":"原创版权一站式服务平台","face-medias-text002":"为内容生产平台提供原本区块链版权等级的api对接服务","face-medias-text003":"联系我们","face-medias-text004":"「原本」服务对象","face-medias-text005":"杂志社","face-medias-text006":"报业集团","face-medias-text007":"图片社","face-medias-text008":"其他原创机构","face-medias-text009":"对接方式","face-medias-text010":"媒体JS代码嵌入","face-medias-text011":"适用于小型的以网站为主要发布途径的媒体；文章版权归媒体所有；“原本”将统一对文章进行授权服务。","face-medias-text012":"媒体API","face-medias-text013":"此类对接方式适合大型的媒体网站，文章所有权统一归媒体所有。管理员可选择是否对文章进行授权。","face-medias-text014":"平台API","face-medias-text015":"对接流程","face-medias-text016":"邮件申请接入","face-medias-text017":"业务需求分析","face-medias-text018":"提供技术方案","face-medias-text019":"开始技术对接","face-medias-text020":"测试验收","face-medias-text021":"「原本」核心服务","face-medias-text022":"版权保护","face-medias-text023":"版权交易","face-medias-text024":"增值服务","face-medias-text025":"原创认证","face-medias-text026":"不可篡改的「原本」DNA，跨平台的原创溯源","face-medias-text027":"区块链、数字签名、可信时间戳三重技术保障","face-medias-text028":"只需一行代码，与现有系统无缝集成","face-medias-text029":"侵权监测","face-medias-text030":"\"鹰眼\"全网侵权监测系统","face-medias-text031":"覆盖主流媒体平台的自动化监测网络","face-medias-text032":"智能语义分析系统，最大程度识别侵权行为","face-medias-text033":"证据保全","face-medias-text034":"\"磐石\"电子证据保全系统","face-medias-text035":"和\"鹰眼\"系统联动，第一时间侵权证据固化保全","face-medias-text036":"取证过程完全符合国家电子证据相关法规的要求","face-medias-text037":"法律维权","face-medias-text038":"和国内多家专业律所合作","face-medias-text039":"多种维权合作方案","face-medias-text040":"有效打击侵权，保证原创机构的利益","face-medias-text041":"自助交易","face-medias-text042":"为渠道方提供自助购买授权的入口","face-medias-text043":"再也不用重复地一对一询价沟通","face-medias-text044":"高效的原创变现新方式","face-medias-text045":"原创推广","face-medias-text046":"对接海量内容需求商，扩大内容分发渠道","face-medias-text047":"个性化推荐系统，精确匹配内容需求方","face-medias-text048":"一键获取授权，加速流通的同时保证原创收益","face-medias-text049":"新媒体智能发布","face-medias-text050":"作品一键发送到多个媒体平台","face-medias-text051":"文章自动携带原本DNA，方便获取授权","face-medias-text052":"侵权分析报告","face-medias-text053":"详细的侵权情况统计分析","face-medias-text054":"制定有针对性的维权方案","face-medias-text055":"舆情热点分析","face-medias-text056":"舆论焦点随时掌握，助力高效运营","face-medias-text057":"文章热度预判，提升文章传播效果","face-medias-text058":"适用于三方平台（如：知乎、简书），文章所有权归作者所有。平台用户可以直接使用原先的媒体平台账号而无需另行注册“原本”。用户可以根据自己的需要选择是否使用原本的服务。","face-plugin-title":"原本插件","face-plugin-text001":"原本跨平台认证工具","face-plugin-text002":"使用原本认证工具,在微信公众号、简书、头条号等平台编辑文章时可以同时对文章进行原创认证。","face-plugin-text003":"选择您的浏览器","face-plugin-text004":"谷歌浏览器","face-plugin-text005":"猎豹浏览器","face-plugin-text006":"360浏览器","face-plugin-text007":"QQ浏览器","face-plugin-text008":"下载原本扩展工具","face-plugin-text009":"下载插件程序","face-plugin-text010":"点击“下载原本扩展工具”，或者右键鼠标，点击“链接另存为”下载插件。","face-plugin-text011":"打开「扩展程序」页面","face-plugin-text012":"点击Chrome浏览器地址栏最右侧的图标（标示①）；选择“更多工具”（标示②）；继续选择“扩展程序”（标示③）。","face-plugin-text013":"拖拽安装","face-plugin-text014":"打开后请刷新插件页面，然后拖拽安装文件到浏览器并点击“添加扩展程序”安装成功！","face-plugin-text015":"下载原本扩展工具","face-plugin-text016":"下载完成后，浏览器会自动打开插件安装包","face-plugin-text017":"勾选并安装","face-plugin-text018":"在弹出框中勾选「访问敏感页面」（不勾选无法正常使用哦），然后点击「安装」","face-plugin-text019":"打开「应用中心」页面","face-plugin-text020":"点击360浏览器地址栏最右侧的图标（标示①）；在右上角展开的下拉栏中选取“工具”（标示②）—>“管理扩展”（标示③）；或可直接复制此地址到地址栏中直接打开“管理扩展”chrome://myextensions/extensions","face-plugin-text021":"拖拽安装","face-plugin-text022":"选择右侧顶部“已安装扩展”标签，拖拽安装文件到浏览器并点击“添加扩展程序”安装成功！","face-plugin-text023":"下载插件程序","face-plugin-text024":"点击“下载原本扩展工具”，或者右键鼠标，点击“链接另存为”下载插件。","face-plugin-text025":"打开「应用中心」页面","face-plugin-text026":"点击QQ浏览器地址栏最右侧的图标（标示①）；在右上角展开的窗口中选取“应用中心”（标示②）","face-plugin-text027":"拖拽安装","face-plugin-text028":"切换到“管理我的应用”标签，拖拽安装文件到浏览器并点击“添加扩展程序”安装成功！","face-plugin-text029":"如何使用原本认证扩展工具?","face-plugin-text030":"安装扩展工具后微信公众号等编辑页面将出现”原本认证”按钮。","face-plugin-text031":"文章编辑完成后点击”原本认证“按钮，在当前弹框中选择授权方式","face-plugin-text032":"点击”立即认证“，原本即刻把作品信息写入区块链生成唯一数字DNA,原创认证完成。","face-plugin-text033":"(发布作品时请保持DNA的完整,以便原本的Hawkeye监测系统能追踪到作品的转载信息）","face-plugin-text034":"原创认证完成后，作品认证信息将同步到您的原本账号登录原本到”我的作品“即可查看。","face-plugin-text035":"确保插件页面右上角的“开发者模式”打开。","face-plugin-text036":"注：部分Chrome浏览器会出现无法安装的情况。需要刷新插件安装页面，再拖入插件文件。","show-reprint-info":"显示转载信息","face-data-smart-text001":"数据智能","face-data-smart-text002":"有效的为企业提供精准数据服务。","face-data-smart-text003":"文本处理","face-data-smart-text004":"文本纠错","face-data-smart-text005":"自动识别文本中的错别字","face-data-smart-text006":"摘要提取","face-data-smart-text007":"根据文本内容自动生成摘要","face-data-smart-text008":"事件脉络","face-data-smart-text009":"事件在历史上的来龙去脉","face-data-smart-text010":"相似分析","face-data-smart-text011":"对内容文本的相似度进行分析, 快速识别侵权和洗稿","face-data-smart-text012":"文本智能","face-data-smart-text013":"智能分类","face-data-smart-text014":"智能提取文本中的内容标签并进行自动分类","face-data-smart-text015":"智能选题","face-data-smart-text016":"智能匹配相关题材，发掘热门话题","face-data-smart-text017":"热度预测","face-data-smart-text018":"根据短期传播预测未来的传播规模","face-data-smart-text019":"情感分析","face-data-smart-text020":"判断文字中表述的观点积极或消极","face-data-smart-text021":"图像智能","face-data-smart-text022":"图片分类","face-data-smart-text023":"根据图片内容自动生成标签并分类","face-data-smart-text024":"自动配图","face-data-smart-text025":"根据文本内容自动适配相关图片","face-data-smart-text026":"图片相似度","face-data-smart-text027":"快速检查图片的相似程度","face-data-smart-text028":"语音智能","face-data-smart-text029":"有声资讯","face-data-smart-text030":"快速及时的语音资讯输出","face-data-smart-text031":"语音转写","face-data-smart-text032":"语音转写文字，准确率最高可达 95% 以上","face-data-smart-text033":"主体识别","face-data-smart-text034":"识别对话中的不同主体，区别输出内容","face-data-smart-text035":"智能分发","face-data-smart-text036":"个性推荐","face-data-smart-text037":"根据用户画像提供“千人千面”的个性化推荐内容","face-data-smart-text038":"渠道推荐","face-data-smart-text039":"根据内容智能匹配传播渠道，有效提高转化率","face-data-smart-text040":"智能广告","face-data-smart-text041":"AI算法驱动提升投放效率，有效触达目标用户","face-data-smart-text042":"海量、准确、广泛","face-data-smart-text043":"申请服务","face-solutions-text01":"行业解决方案","face-solutions-text002":"全方位，多角度，为企业提供符合行业需求的区块链服务","face-solutions-text003":"底层技术特性","face-solutions-text004":"卓越性能","face-solutions-text005":"Layer 2二级网络、闪电DNA等专利技术打造的高性能联盟链，实现毫秒级交易确认，理论上无TPS上限。","face-solutions-text006":"安全可靠","face-solutions-text007":"高级别的数据安全系统，密钥隔离、数据隔离设计，保证企业数据的安全。原本链已商业化运行超过三年，获得了数百家媒体、企业和政府机构的信赖。","face-solutions-text008":"保护隐私","face-solutions-text009":"率先应用zk-SNARKs零知识证明技术，实现数字资产私密确权、交易和授权。企业数字资产不再对外公开，在必要时可对外提供有效的权益证明。","face-solutions-text010":"法律效力","face-solutions-text011":"大型媒体、政府机构参与节点部署，和互联网法院系统无缝对接，保证了原本链上的数据具有极强的法律效力。","face-solutions-text012":"解决方案","face-solutions-text013":"版权存证","face-solutions-text014":"利用区块链的不可篡改性，搭建基于联盟链的存证方案，通过上链保证原生数据的可信，通过节点间交叉验证确保信息永久一致性。利用私钥的强耦合性，保障信息所有权随时可确认。","face-solutions-text015":"数字资产溯源","face-solutions-text016":"区块链系统有永久溯源性，通过信息的哈希地址，可以查询到数字资产交易链条上所有的信息，保证数字资产的流通环节安全、高效，从而降低数字资产的流转成本，助力数字经济发展。","face-solutions-text017":"业务协同","face-solutions-text018":"打造智能业务协同平台，基于原本自主创新的可信内容协议DTCP，让信息流与业务流跨组织、跨领域地互联互通，区块链的隐私保护技术确保信息在业务流转过程中做到安全可控。","face-solutions-text019":"可信物联网","face-solutions-text020":"将联盟链技术与产业结合，从链上可信节点出发，打通链上链下信息交互，构建一个主体可信、事后可验、链上链下一体化的新一代物联网。","face-solutions-text021":"电子政务","face-solutions-text022":"协助政府部门政务数据互联互通，将链上数据与政府系统打通，促进数据上链共享，提供智能政务整体方案，提升政务服务体验。","face-solutions-text023":"监管技术","face-solutions-text024":"通过人工智能、大数据、云计算等技术，对链上数字资产信息做全网扫描，分析数字信息的流转与侵权状况，第一时间掌握舆情信息，为信息监管、精准营销、市场热度分析等提供有力支持。","face-partners-text01":"合作伙伴","face-partners-text02":"强大资源支持为您的企业助力","face-partners-text03":"立即加入","face-partners-text04":"为什么要成为原本的合作伙伴","face-partners-text05":"原本致力于打造基于区块链和人工智能的大数据服务平台，帮助您挖掘潜在的价值，拓展新的业务场景，使您的组织提前布局下一代的互联网，占领行业先机。","face-partners-text06":"强势产品联合","face-partners-text07":"基于区块链和人工智能技术的产品已赋能不同领域，在助力企业知识产权保护的同时，为企业找到新的商业机会。","face-partners-text08":"顶尖技术支持","face-partners-text09":"国际领先的区块链技术，顶尖的商业咨询团队，跨行业领域的技术解决方案，为企业实现以分布式技术为驱动的业务创新和变革。","face-partners-text10":"强大资源支持","face-partners-text11":"提供技术、产品和商业模式等全方位的资源支持，整合产业、学校、科研机构资源，赋能合作伙伴。","face-partners-text12":"分布式技术","face-partners-text13":"分布式技术带来平等和信任，通过互信透明的多方协作机制打造分布式商业组织，打破组织边界，创造更多商业价值。","face-partners-text14":"伙伴计划","face-partners-text15":"产品技术合作","face-partners-text16":"面向具体业务场景，提供原本旗下系列产品、技术、解决方案的定制化服务，帮助合作伙伴快速实现商业化。","face-partners-text17":"服务合作","face-partners-text18":"面向具体业务场景，提供原本旗下系列产品的标准化服务支持，并配有专业的技术客户经理24x7在线支持。","face-partners-text19":"战略合作","face-partners-text20":"共同打造分布式商业生态，全面共享产品、技术和商业模式等。","face-partners-text21":"徽标合作","face-partners-text22":"共同推广分布式商业生态的相关产品和服务，通过加入徽标计划获得技术上的支持，并从商业生态的发展中获得商业回报。","face-partners-text23":"敬请期待","face-partners-text24":"申请流程","face-partners-text25":"提交申请","face-partners-text26":"合作洽谈","face-partners-text27":"签订商务协议","face-partners-text28":"赋能支持","face-partners-text29":"项目实施","face-cooperation-text01":"合作伙伴申请","face-cooperation-text02":"接触途径(选填)","face-cooperation-text03":"请选择您了解我们的途径","face-cooperation-text04":"自主搜索查询","face-cooperation-text05":"朋友/同事介绍","face-cooperation-text06":"原本市场活动","face-cooperation-text07":"其它","face-cooperation-text08":"公司名称","face-cooperation-text09":"请输入公司名称","face-cooperation-text10":"公司网站(选填)","face-cooperation-text11":"例: https://www.yuanben.io","face-cooperation-text12":"请输入正确的网址","face-cooperation-text13":"联系人姓名","face-cooperation-text14":"请输入联系人姓名","face-cooperation-text15":"手机电话","face-cooperation-text16":"请输入手机号码","face-cooperation-text17":"请输入正确的手机号码","face-cooperation-text18":"合作方式(选填)","face-cooperation-text19":"请选择您倾向的合作方式","face-cooperation-text20":"战略合作","face-cooperation-text21":"产品技术合作","face-cooperation-text22":"服务合作","face-cooperation-text23":"商务合作","face-cooperation-text24":"提交","face-cooperation-text25":"申请已提交，感谢您的配合","face-cooperation-text26":"确    定","face-cooperation-text27":"邮箱地址","face-cooperation-text28":"请输入邮箱地址","face-cooperation-text29":"请输入正确的邮箱地址","face-application-text01":"信息填写","face-application-text02":"联系人姓名","face-application-text03":"联系邮箱","face-application-text04":"联系手机","face-application-text05":"公司/单位名称","face-application-text06":"公司服务行业","face-application-checkContent":"请输入联系人姓名","face-application-checkEmail":"请输入联系邮箱","face-application-checkPhone":"请输入联系电话","face-application-company":"请输入公司或单位名称","face-application-servicetype":"选择智能服务类型 (可多选)","face-application-TextProcessing":"文本处理","face-application-TextIntelligence":"文本智能","face-application-ImageIntelligence":"图像智能","face-application-VoiceIntelligence":"语音智能","face-application-IntelligentDistribution":"智能分发","face-application-otherService":"希望获取其他服务（需求描述）","face-application-selecServiceType":"请选择智能服务类型","face-application-null":""}

/***/ }),
/* 1271 */
/***/ (function(module, exports) {

module.exports = {"page-default-title":"Yuanben - Protecting your ownership rights","page-default-desc":"Yuanben redefines the value of creativity. A platform for complete copyright protection generating Unique Digital Fingerprints (DNA) for online content. Supports an automatic copyrighting service and eliminates the need for manual copyright verifications. By connecting large databases filled with original content, the personalized recommendation system also increases the speed of content dissemination across a network. Network-wide monitoring services can track instances of infringement and be called upon as evidence in a court of law in order to crack down on plagiarism.","page-announcement-text001":"Announcements","page-announcement-text002":"Published on:","page-author-text001":"Failed to load","page-author-text002":"Content list","page-author-text003":"Hot","page-author-text004":"New","page-author-text005":"Remove from favorites","page-author-text006":"Add to favorites","page-author-text007":"Processing","page-author-text008":"Articles","page-author-text009":"Images","page-author-text010":"Removed","page-author-text011":"Added","page-evidence-text001":"Details","page-evidence-text002":"Yuanben Authentication","page-evidence-text003":"1. Yuanben Authentication takes two factors into account: proof of Ownership and Existence. This complies with the international standards of the <a href=\"https://en.wikipedia.org/wiki/ANSI_ASC_X9.95_Standard\" target=\"_blank\">X9.95 protocol</a>.","page-evidence-text004":"2.「Proof of Ownership」is established through the use of unique digital signatures <a href=\"https://zh.wikipedia.org/wiki/%E6%95%B8%E4%BD%8D%E7%B0%BD%E7%AB%A0\" target=\"_blank\"></a> that prove ownership. This is done by matching public and private keys. <a href=\"https://zh.wikipedia.org/wiki/%E5%85%AC%E5%BC%80%E5%AF%86%E9%92%A5%E5%8A%A0%E5%AF%86\" target=\"_blank\"></a> The public key is written into the Yuanben DNA and is available for anyone to see whereas the private key will be automatically generated and sent via email. For security purposes, the Yuanben system never records or keeps private keys. Yuanben strongly advises content authors to safely store their private keys and not release them under any circumstance.","page-evidence-text005":"3.「Proof of Existence」is established by referencing timestamps. By using blockchain technology and following the standards of the National Digital Certificate Center, timestamps are created, recorded and immutably retained. The timestamp is also written into the Yuanben DNA.  <a href=\"https://www.zhihu.com/question/27687960\" target=\"_blank\"></a><a href=\"http://baike.baidu.com/view/4770720.htm\" target=\"_blank\"></a>","page-evidence-text006":"4. The process and validity of authentication is not solely at the discretion of Yuanben, it should also be verified by any other third party.","page-evidence-text007":"Title:","page-evidence-text008":"Author:","page-evidence-text009":"Time:","page-evidence-text010":"Yuanben DNA:","page-evidence-text011":"Blockchain Address:","page-evidence-text012":"Complete Yuanben DNA","page-evidence-text013":"Article Hash","page-evidence-text014":"Signature String","page-evidence-text015":"(This is only viewable by the author)","page-evidence-text016":"Digital Signature","page-evidence-text017":"Public Key Signature","page-evidence-text018":"Article Authentication Details","page-evidence-text019":"Image Authorization Details","page-evidence-text020":"Image Resolution","page-evidence-text021":"File Size","page-evidence-text022":"Image Content Hash","page-evidence-text023":"Image Blockchain Hash","page-search-text001":"Search using Yuanben DNA or Keywords","page-search-text002":"Search Articles","page-search-text003":"Search Images","page-search-text004":"Enter Yuanben DNA","page-search-text005":"Searching","page-search-text006":"No Results Found","page-search-text007":"Results:","page-search-text008":"","page-search-text009":"Remove from Favorites","page-search-text010":"Add to Favorites","page-search-text011":"Trending","page-search-text012":"Processing Images","page-search-text013":"Hot","page-search-text014":"New","page-search-text015":"All","page-search-text016":"CC Protocol","page-search-text017":"CM Protocol","page-search-text018":"All","page-search-text019":"0-5 ¥","page-search-text020":"6-10 ¥","page-search-text021":"11-50 ¥","page-search-text022":"50+ ¥","page-search-text023":"Highest to Lowest","page-search-text024":"Lowest to Highest","page-search-text025":"cc0 Image","page-search-text026":"Removed","page-search-text027":"Added","page-search-text028":"Failed","page-original-text001":"Sorry, the page you are visiting does not exist or has been deleted.","page-original-text002":"You authorized this work at {{datetime}}，click to view details.","page-original-text003":"Authorization Information","page-original-text004":"Authorization DNA","page-original-text005":"Authorization Party","page-original-text006":"Time of Authorization","page-original-text007":"Authorized Party","page-original-text008":"Authorized Media","page-original-text009":"Authorized Account","page-original-text010":"ID","page-original-text011":"Account","page-original-text012":"Website","page-original-text013":"Editor","page-original-text014":"Blockchain Address","page-original-text015":"Authorization Information","page-original-text016":"Complete Yuanben DNA","page-original-text017":"Authorization Hash","page-original-text018":"Digital Signature","page-original-text019":"Signed Public Key","page-original-text020":"Share on WeChat","page-original-text021":"Scan using WeChat","page-original-text022":"Details","page-original-text023":"Delete","page-original-text024":"Copy","page-original-text025":"Authorization Information has been sent to your e-mail, please check your inbox.","page-original-text026":"Authorization Information","page-original-text027":"Author","page-original-text028":"Published","page-original-text029":"DNA","page-original-text030":"Authorization Details","page-original-text031":"Share on Weibo","page-original-text032":"Share on WeChat","page-original-text033":"Share on Qzone","page-original-text034":"Share on Douban","page-original-text035":"Are you sure you want to delete?","page-original-text036":"Confirm","page-original-text037":"Cannot be posted. Yuanben is designed to enforce copyright protection and it appears this is not original content. If this is a mistake, please let us know at info@yuanben.org. Apologies for any inconvenience.","page-original-text038":"Deleted","page-original-text039":"Article has already been reposted and cannot be deleted.","page-original-text040":"Parameter Error","page-original-text041":"Remove from Favorites","page-original-text042":"Add to Favorites","page-original-text043":"Please wait...","page-original-text044":"Removed","page-original-text045":"Add to Favorites","page-original-text046":"Share","page-original-text047":"Posting...","page-original-text048":"Post","page-original-text049":"Clear All","page-original-text050":"Maximum 8 Articles","page-original-text051":"Already Added","page-original-text052":"Please link the official account and refresh this page","page-original-text053":"WeChat Authorization Expired","page-original-text054":"Bind","page-original-text055":"Re-Bind","page-original-text056":"Posting...","page-original-text057":"Connection error, please try again later","page-original-text058":"Successfully Posted","page-original-text059":"Image size cannot exceed 2MB","page-original-text060":"Image format must be: jpg, png or bmp","page-original-text061":"Uploading...","page-original-text062":"Processing Image","page-original-text063":"Tags","page-original-text064":"Delete","page-original-text065":"Delete Image","page-original-text066":"Download Preview","page-original-text067":"Download Original Image","page-original-text068":"Author","page-original-text069":"Resolution","page-original-text070":"Size","page-original-text071":"Format","page-original-text072":"Source","page-original-text073":"Confirm deletion of this image?","page-original-text074":"Confirm deletion","page-original-text075":"Sample Images","page-original-text076":"Deleted","page-original-text077":"Image has been reposted by other users, and cannot be deleted.","page-original-text078":"Obtain Authorization","page-original-text079":"Obtain Authorization - protocols","page-original-text080":"Agree","page-original-text081":"Cancel","page-original-text082":"You acknowledge and understand that this work is licensed under the Yuanben Commercial License Agreement.","page-original-text083":"The scope of Authorization is limited to non-exclusive single replication on the Internet or print.","page-original-text084":"You must reference as specified by the licensor.","page-original-text085":"You are authorized to create works based on this work.","page-original-text086":"You are not authorized to create work based on this work.","page-original-text087":"You agree to \"Shanghai Qiyin Information Technology Ltd\" being the agent responsible for investigating your liability if in breach of contract.","page-original-text088":"Agree","page-original-text089":"Authorize - Information","page-original-text090":"E-mail Address","page-original-text091":"Enter","page-original-text092":"Type of Account","page-original-text093":"Choose","page-original-text094":"Subject","page-original-text095":"Account","page-original-text096":"Media","page-original-text097":"ID","page-original-text098":"Account Link","page-original-text099":"Website Link ","page-original-text100":"Edit Name","page-original-text101":"Next","page-original-text102":"Authorize - Choose payment method","page-original-text103":"Authorization Price","page-original-text104":"WeChat Pay","page-original-text105":"Alipay","page-original-text106":"Pay from Balance","page-original-text107":"Balance","page-original-text108":"Insufficient Balance","page-original-text109":"Authorize - Pay from Balance","page-original-text110":"Pay from Balance","page-original-text111":"Current Account Balance","page-original-text112":"Confirm Payment","page-original-text113":"Authorize - Scan to Pay","page-original-text114":"Scan and Pay using WeChat","page-original-text115":"Authorize - Wait for Payment","page-original-text116":"Please complete payment in the pop-up window","page-original-text117":"Waiting for payment results...","page-original-text118":"Need Help?","page-original-text119":"Cannot currently be purchased.","page-original-text120":"Estimated monetary return for using this work?","page-original-text121":"¥","page-original-text122":"Communicate","page-original-text123":"Authorization Successful","page-original-text124":"Your request has been sent","page-original-text125":"Please contact the Author to grant authorization.","page-original-text126":"Add to List","page-original-text127":"Fill in the following details","page-original-text128":"Original Link","page-original-text129":"Download the certificate of deposit","page-original-tipText":"Document authorization information has been sent to your mailbox, please check!","page-original-receipt-button":"apply for an invoice","page-original-receipt-notify":"You can","page-original-Operator":"Operator","page-payment-text001":"Sucesfully Purchased","page-payment-text002":"Cancel Payment","page-payment-text003":"Payment Failed","page-terms-title":"原本用户协议","page-terms-text001":"原本用户注册及服务协议","page-terms-text002":"原本","page-terms-text003":"发布日期","page-terms-text004":"请您仔细阅读以下全部内容","page-terms-text005":"上海七印信息科技有限公司（简称：\"公司\"）旗下产品原本","page-terms-text069":"是为作者原创的作品提供原创的时间证明、内容确认以及版权交易的网站。服务使用人（简称：\"用户\"）必须完全同意本协议所有条款并完成注册程序，才能成为公司产品用户。","page-terms-text006":"用户同意此在线会员注册服务协议之效力如同用户亲自签字或盖章的书面协议一样，对用户具有法律约束力。用户进入会员注册程序，点击并勾选\"我同意并接受服务协议\"即表示用户完全接受协议中全部条款内容。此后，用户不得以未阅读本服务协议条款内容作任何形式的抗辩。","page-terms-text007":"用户身份保证","page-terms-text008":"用户承诺并保证其具有完全民事行为能力和完全民事权利能力的自然人，或依法设立并有效存续的单位（包括企业法人和其他组织）。用户保证其所填写的用户信息真实、准确、完整，且没有任何引人误解或者虚假的陈述，同时不得侵犯他人的知识产权及合法权益。公司将依据用户所填写的联系方式与其取得联系，若有变动应及时通知公司；","page-terms-text009":"用户应根据公司的要求及时提供其身份证明或身份信息等资料，否则有权拒绝该用户注册申请，并拒绝提供相关服务。","page-terms-text010":"用户承诺将及时更新其用户信息以维持其信息有效性。","page-terms-text011":"用户以代理人身份代理其他自然人或者企业法人进行注册的，须向公司提供代理人和被代理人的详细资料、信息及书面授权委托书。未向公司提供上述资料信息及文件的，公司将视该注册者为会员。","page-terms-text012":"会员身份确认","page-terms-text013":"用户注册成功后将得到一个用户名和密码，用户凭用户名和密码享受公司向其提供各项服务。","page-terms-text014":"用户应妥善保管其用户名和密码，并对用户名和密码安全负全部责任，任何使用其用户名和密码进行的活动和事件都视为该用户的操作。","page-terms-text015":"用户若发现任何非法使用其帐号的行为或可能存在安全漏洞的情况，请立即通知公司，紧急修改该密码。因黑客行为或用户的保管不善导致账号、密码被他人非法使用，公司不承担责任。","page-terms-text016":"服务条款的修改和服务体系修订","page-terms-text017":"公司有权在必要时修改本服务协议条款，若服务协议条款发生变动，公司将会在重要页面向用户提示修改内容。用户若不同意可主动取消其获得的网络服务。若用户继续使用公司服务，则视为接受服务协议条款的变动内容。","page-terms-text018":"用户的权利和义务","page-terms-text019":"用户有权拥有其在公司注册时取得的用户名和密码，并有权使用该用户名和密码在任一时间、任一地点登录公司网站。","page-terms-text020":"用户有权享受公司依据本服务协议条款提供的互联网技术和信息服务，并有权利在接受服务时获得公司技术支持、咨询等服务。","page-terms-text021":"用户在履行本服务协议条款中不侵犯公司及任何第三方的知识产权或其他合法权利。若有侵权行为，其给其他第三方造成的经济损失，由用户自己承担。若因用户的作品侵权导致公司对外承担赔偿责任的，用户赔偿公司因此产生的全部经济损失。","page-terms-text022":"用户应保证遵守中国法律、法规、行业惯例和社会公共道德，不得利用公司提供的服务存储、发布、传播下述信息或内容：","page-terms-text023":"违反国家法律、法规的任何内容或信息；","page-terms-text024":"违反国家有关政治或新闻宣传规定的信息；","page-terms-text025":"涉及国家秘密或或危害国家安全的信息；","page-terms-text026":"涉及封建迷信或淫秽、色情、教唆犯罪等信息；","page-terms-text027":"涉及博彩有奖、赌博游戏等信息；","page-terms-text028":"违反国家民族和宗教政策的信息；","page-terms-text029":"防碍互联网运行安全的信息；","page-terms-text030":"侵害他人合法权益的信息；","page-terms-text031":"其他有损于社会秩序、社会治安、公共道德的信息或内容。","page-terms-text032":"用户承诺不得为他人发布上述不符合国家法律、法规规定和不符合本服务协议条款约定的信息或内容提供任何技术或内容上的便利。","page-terms-text033":"用户同意公司有权在其违反上述规定时终止向其提供服务并删除违法信息或内容。若因用户的上述行为给公司造成经济损失的，用户应予赔偿。","page-terms-text034":"公司的权利和义务","page-terms-text035":"公司应为用户提供有效的网络技术和信息服务。","page-terms-text036":"公司承诺对用户信息及资料采取保密措施，不向第三方披露用户资料，不授权第三方使用用户资料，除非：","page-terms-text037":"依据本注册协议或者双方另有约定可以的；","page-terms-text038":"依据我国法律法规规定应当提供的；","page-terms-text039":"用户同意公司向第三方提供的；","page-terms-text040":"公司解决举报事件、提起诉讼而提交给有关机关或部门的；","page-terms-text041":"公司为防止严重违法行为或涉嫌犯罪行为发生而采取必要合理行动所必须提交的。","page-terms-text042":"公司有权对用户上传的全部信息及资料进行内容审查，并对违法或违规内容予以删除，必要时终止为其提供服务。","page-terms-text043":"公司保留在用户违反国家、法律法规规定或违反本注册协议条款的情况下终止为其提供服务并终止用户帐号的权利。","page-terms-text044":"知识产权保护","page-terms-text045":"用户通过其用户管理后台上传到公司网站上的全部作品（包括但不限于文字、图形、照片、视频、音频等），其著作权归该用户本人享有。","page-terms-text046":"用户以不可撤销的方式授权公司对其上传到的公司网站的全部作品（包括但不限于文字、图形、照片、视频、音频等）享有文学作品信息网络传播权的非独家许可使用权，除非该用户上传的该作品已经被该用户将文学作品信息网络传播权以独占形式独家授权给其他使用方，即排他许可使用。","page-terms-text047":"公司可将用户授权给公司的非独家许可使用的作品通过展示、汇编的方式在公司各种形态的产品和服务上。","page-terms-text048":"对于用户已将文学作品信息网络传播权独家授权（即排他许可使用）给其他作品使用方的作品，用户在上传公司网站时应予以明确表示，未在上传该作品时明确表示已经授权给其他作品使用方独占授权许可时，视为该用户未授权独占许可，此时公司对该作品享有非独家许可使用权。","page-terms-text049":"用户以版权保护的目的将其作品上传公司网站时，无论该作品是否在用户上传时被其以独家授权的方式授权给其他作品使用方的，用户同意公司可以基于版权保护的目的继续使用、展示该作品。","page-terms-text050":"若因用户的不当上传作品的行为导致侵犯独家授权使用方合法权益的，由用户自行向被侵犯权方承担责任，公司对此不负赔偿责任。若因用户的上述行为导致公司受到经济损失的，则用户应当赔偿公司的全部经济损失。","page-terms-text051":"服务的终止及违约责任","page-terms-text052":"用户有权随时申请终止其用户注册协议，但因用户的终止行为给公司造成经济损失的，应当赔偿经济损失。","page-terms-text053":"因用户自身过错原因、违反法律或者本注册协议条款等原因，公司有权依约定提前终止用户注册协议，终止服务。","page-terms-text054":"若因公司原因给用户造成经济损失，公司同意承担由此给用户造成的经济损失，但本协议另有约定的除外。用户充分理解因网络故障、服务器故障而造成的延误或者给用户带来的损失均不应由公司承担。","page-terms-text055":"用户同意保障公司及公司网站其他用户的利益，若因用户违反法律、法规或本注册协议条款而给公司或任何第三方造成经济损失，用户同意赔偿其造成的公司或任何第三方的经济损失。","page-terms-text056":"争议解决及法律适用","page-terms-text057":"因本服务协议条款发生的争议，公司与用户应协商解决。若协商未成，任何一方均有权向公司注册地有管辖权的人民法院起诉。","page-terms-text058":"本注册协议条款的效力、解释、履行和争议的解决均适用中华人民共和国法律法规。","page-terms-text059":"不可抗力及免责声明","page-terms-text060":"因不可抗力或者其他意外事件，使得本服务协议条款履行不可能、不必要或者无意义的，遭受不可抗力、意外事件的一方不承担责任。","page-terms-text061":"不可抗力、意外事件是指不能预见、不能克服并不能避免且对一方或双方当事人造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、瘟疫流行和风暴等以及社会事件如战争、动乱、政府行为等。","page-terms-text062":"用户同意鉴于互联网的特殊性，黑客攻击、互联网连通中断或者系统故障等属于不可抗力，由此给用户或者第三方造成的损失公司不承担赔偿责任。","page-terms-text063":"用户明确同意其使用公司网站时对于存在的可能风险由其自己完全承担；因使用公司提供的网络服务而产生的一切后果也由其自己承担，公司对用户不承担任何责任。","page-terms-text064":"附则","page-terms-text065":"本服务协议条款中部分条款无效，不影响其他条款的效力，也不影响本服务条款的解释、违约责任及争议解决的有关约定的效力。","page-terms-text066":"用户变更其信息时，应自变更之日起5日内将变更后的信息在用户使用管理后台上修改，若因未修改信息导致的经济损失由其自行承担。用户同意：公司的任何通知只需在公司有关网页上发布即视为送达用户。","page-terms-text067":"本注册协议最终解释权归公司所有。","page-terms-text068":"本注册协议自用户点击确认即生效，对公司和用户具有同等法律约束力。","page-terms-text070":"数据存储与隐私条款","page-terms-text0701":"用户同意授权公司调用用户信息，及通过运营商验证实名身份信息。","page-terms-text0702":"用户可在账户权限范围内访问、更正个人信息，用户帐号的注销需要联系公司申请，账户注销一旦成功，该账户个人信息及存储的数据将无法恢复。","page-terms-text0703":"用户知晓公司旗下区块链服务存储的元数据一旦上链即无法修改和删除。","page-terms-text0704":"公司应当遵守互联网服务和数据安全相关要求，在服务期和保密义务履行期间采取措施保护用户隐私安全。","page-verify-title":"Verify Yuanben DNA","page-verify-text001":"Verify Yuanben DNA","page-verify-text002":"Yuanben DNA","page-verify-text003":"Enter the Yuanben DNA","page-verify-text004":"Private Key","page-verify-text005":"Please check your email for the private key","page-verify-text006":"Enter the private key","page-verify-text007":"Protection Code","page-verify-text008":"This code can be found on the【Personal Information】page","page-verify-text009":"Enter the Protection Code","page-verify-text010":"Verification Code","page-verify-text011":"Verification Image","page-verify-text012":"New Verification Code","page-verify-text013":"Enter the Code","page-verify-text014":"Please wait...","page-verify-text015":"Verify","page-verify-text016":"DNA verification successful, and you now own the work.","page-verify-text017":"Digital signature verification passed. Supplied Public key, Content and Digital Signature are a correct match.","page-verify-text018":"Ownership verification successful.","page-verify-text019":"Verification Information","page-verify-text020":"The following protocol does not contain unverified images.","page-verify-text021":"Time of Publication","page-verify-text022":"Verification Details","page-verify-text023":"Yuanben DNA","page-verify-text024":"Authorization Protocol","page-verify-text025":"Authorization Details","page-verify-text026":"Blockchain Address","page-verify-text027":"Original","page-verify-text028":"Fail to Verify","page-verify-text029":"Back","page-verify-text030":"Forensics package verification","page-verify-text031":"What is DNA Verification？","page-verify-text032":"DNA is provided to all content on the Yuanben platform, it asks as a unique digital fingerprint for content and prove intellectual property ownership.","page-verify-text033":"What is TSA Verification?","page-verify-text034":"Trusted Time Stamp Authentication is a legally valid electronic timestamp","page-verify-text035":"Submit","page-verify-text036":"Enter Article 1 and 2","page-verify-evidence":"Verification of certificate package","page-similarity-text001":"Similarity Comparison","page-similarity-text002":"Article 1","page-similarity-text003":"Article 2","page-similarity-text004":"Comparison Results","page-similarity-text005":"Jaccard:","page-similarity-wordNum":"Similar words","page-similarity-text006":"Submit","page-similarity-text007":"Please input the articles to be compared","page-similarity-text008":"The Original","page-similarity-text009":"Plagiarism","home-dashboard-title":"My Yuanben","home-dashboard-text001":"Verify Article","home-dashboard-text002":"Verify Image","home-dashboard-text003":"My Originals","home-dashboard-text004":"Announcements","home-evidences-text001":"Evidence Management","home-evidences-text002":"Evidence List","home-evidences-text003":"Collected Evidence","home-evidences-text004":"Enter website / wechat name / evidence package number","home-evidences-text005":"All","home-evidences-text006":"Selected: {{length}}","home-evidences-text007":"Batch Deletion","home-evidences-text008":"Download Package","home-evidences-text009":"Article Title/Source Website","home-evidences-text010":"Time of Collection","home-evidences-text011":"Evidence","home-evidences-text012":"Operation","home-evidences-text013":"No Evidence","home-evidences-text014":"Electronic evidence can be found in 【Monitoring】","home-evidences-text015":"No Title","home-evidences-text016":"View Evidence","home-evidences-text017":"Download","home-evidences-text018":"Delete","home-evidences-text019":"Details","home-evidences-text020":"Time","home-evidences-text021":"Blockchain Address","home-evidences-text022":"{{length}} cases are being compiled, please wait...","home-evidences-text023":"Compilation Completed, click here if the browser does not automatically download","home-evidences-text024":"Retry","home-evidences-text025":"Manual Download","home-evidences-text026":"Are you sure you want to delete? Delete data cannot be recovered","home-evidences-text027":"Confirm","home-evidences-text028":"Select evidence for Download","home-evidences-text029":"Select evidence for Deletion","home-evidences-text030":"Collection task","home-evidences-text031":"Status","home-evidences-text032":"No ongoing task","home-evidences-text033":"Electronic evidence can be found in 【Monitoring】","home-evidences-text034":"Page has Expired","home-evidences-text035":"Waiting for Compilation","home-evidences-text036":"Compiling","home-evidences-text037":"Retry","home-evidences-text038":"Cancel","home-evidences-text039":"Confirm Deletion","home-evidences-text040":"Signature Serification","home-evidences-text041":"Form","home-evidences-text042":"TSA File","home-evidences-text043":"The file format is wrong. Please upload the relevant file according to the page prompt","home-evidences-text044":"Success","home-evidences-text045":"Can't be empty","home-evidences-text046":"Hash","home-evidences-text047":"tas-sign","home-evidences-text048":"tas-time","home-evidences-text049":"Submit","home-evidences-text050":"Upload","home-evidences-text051":"Verification failed","home-evidences-text052":"Pending","home-evidences-text053":"Re-Upload","home-evidences-text054":"[*.png] Not Accepted","home-evidences-text055":"[*.zip] Accepted","home-evidences-text0551":"[*. Zip] please upload the certificate zip package.","home-evidences-text056":"Upload Evidence to Verify:","home-evidences-text057":"Upload Timestamp Certificate (tsa.txt):","home-evidences-text058":"What is TSA Verification?","home-evidences-text059":"Trusted Time Stamp Authentication is a legally valid electronic timestamp","home-evidences-text060":"Why to verify the forensics package?","home-evidences-text061":"To verify the integrity of the signature","home-evidences-text062":"Verify","home-evidences-text063":"This document has not been verified and may not be authentic!","home-evidences-text064":"Error:","home-evidences-text065":"Return","home-evidences-text066":"Verify that your trusted timestamp is complete and has not been tampered with!!","home-evidences-text0661":"The verification is passed, and the certificate package is complete and has not been tampered!","home-evidences-FailureEvidence":"Expired evidence","home-evidences-status":"State of evidence","home-evidences-noFailureEvidences":"No evidence of Expired","home-evidences-evidencesNoFailure":"evidence has expired","home-evidences-receivingEvidence":"Receiving evidence","home-evidences-noSelectTips":"Please select the options for forensics","home-evidences-lineUp":"Has entered the forensics queue","home-evidences-batchForensics":"Batch Forensics","home-evidences-Forensics":"Forensics","home-evidences-ReEvidence":"Re evidence","home-evidences-ForensicsStatus":"Forensics status","home-evidences-EvidenceRecord":"Evidence Pack Problem Record","home-importwx-title":"Import articles from WeChat","home-importwx-text001":"Import articles from WeChat Official Account","home-importwx-text002":"Renew articles","home-importwx-text003":"Selected: {{length}}","home-importwx-text004":"Delete","home-importwx-text005":"Verify All","home-importwx-text006":"Ferify","home-importwx-text007":"Name of Work","home-importwx-text008":"Time of Publication","home-importwx-text009":"Verification Status","home-importwx-text010":"Unverified","home-importwx-text011":"Failed","home-importwx-text012":"Select Authorization Protocol","home-importwx-text013":"Verifying...","home-importwx-text014":"Verify Now","home-importwx-text015":"Cancel","home-importwx-text016":"Import","home-importwx-text017":"Import successful!","home-importwx-text018":"Are you sure you want to delete? Unable to be restored after deletion.","home-importwx-text019":"Select the article requiring verification","home-importwx-text020":"Success!","home-infringements-text001":"Monitor","home-infringements-text002":"Reposts","home-infringements-text003":"(Collecting now. Check【Evidence Management】in a few moments.","home-infringements-text004":"Media Whitelist","home-infringements-text005":"Repost All","home-infringements-text006":"Time of Verification","home-infringements-text007":"Authorization Protocol","home-infringements-text008":"Reposts: ","home-infringements-text009":"Records:","home-infringements-text010":"Article Reposts","home-infringements-text011":"Collect","home-infringements-text012":"Collected","home-infringements-text013":"Pay Collection Fee","home-infringements-text014":"Number","home-infringements-text015":"","home-infringements-text016":"Price","home-infringements-text017":"¥/each","home-infringements-text018":"Total","home-infringements-text019":"¥","home-infringements-text020":"Need to Pay","home-infringements-text021":"Evidence stored for","home-infringements-text022":"Pay and begin to Collect","home-infringements-text023":"Cancel","home-infringements-text024":"Added to the collection list, see details on the electronic collection page.","home-infringements-text025":"Reposts","home-infringements-text026":"Total Number","home-infringements-text027":"Today","home-infringements-text028":"Articles","home-infringements-text029":"Source Websites","home-infringements-text030":"Trend","home-infringements-text0301":"Key Media Broadcast","home-infringements-text031":" ","home-infringements-text032":"Time of Verification","home-infringements-text033":"Reposts: ","home-infringements-text034":"Sort by Articles","home-infringements-text035":"Sort by Sources","home-infringements-text036":"7 days","home-infringements-text037":"15 days","home-infringements-text038":"30 days","home-infringements-text039":"Source","home-infringements-text040":"Add to Whitelist","home-infringements-text041":"Original Article","home-infringements-text042":"Successfully Added","home-infringements-text043":"Existing Record","home-infringements-text044":"Failed to Add","home-infringements-text045":"WeChat link may have expired","home-infringements-text046":"Refresh link","home-infringements-text047":"Refreshing...","home-infringements-text048":"Refresh limit reached","home-infringements-text049":"Refreshed","home-infringements-text050":"Failed to Refresh, Retry","home-infringements-text051":"Portion","home-infringements-text052":"All Evidence","home-infringements-text053":"Export","home-infringements-text054":"History","home-infringements-text055":"Date Range:","home-infringements-text056":"Site Total","home-infringements-text057":"Article Total","home-infringements-text058":"Website Stats","home-infringements-text059":"Article Stats","home-infringements-text060":"All","home-infringements-text061":"10+","home-infringements-text062":"50+","home-infringements-text063":"100+","home-infringements-text064":"Total Entries","home-infringements-text065":"All Content","home-infringements-text066":"Sort by Time","home-infringements-text067":"Sort by Site","home-infringements-text068":"Sort by Article","home-infringements-text069":"Large file. Are you sure you want to download?","home-infringements-text070":"Start","home-infringements-text071":"End","home-infringements-text072":"Filter Times:","home-infringements-text073":"Submit","home-infringements-text074":"Export","home-infringements-text075":" Filters ","home-infringements-text076":" All ","home-infringements-text077":"Total Number of Infringements:","home-infringements-text078":"List","home-infringements-text079":"Site:","home-infringements-text080":"Article:","home-infringements-text081":"Clear","home-infringements-text082":"Please Input Number","home-infringements-text083":"Loading...","home-infringements-text084":"Show >=","home-infringements-text085":"Reposts","home-infringements-text086":"Search for media name or article title","home-infringements-text087":"Offer section","home-infringements-text088":"Free evidence has been obtained this month","home-infringements-text089":"","home-infringements-text090":"remaining","home-infringements-text093":"Forensics - scan QR code payment","home-infringements-text094":"Number of Evidence Collection Items","home-infringements-text095":"Total Forensics Cost","home-infringements-text096":"Single forensics fee","home-infringements-text097":"Evidence collection time","home-infringements-text098":"days","home-infringements-text099":"Forensic refund","home-infringements-text100":"Please download the report at the Reprint Download Center","home-infringements-text101":"Reprint Report Download Center","home-infringements-text102":"Evidence package No","home-infringements-text103":"Search","home-infringements-text104":"Reset","home-recharge-text001":"Recharge centre","home-recharge-text002":"Recharge amount","home-recharge-text003":"The recharge amount cannot be empty. Please enter a positive integer greater than 0.","home-recharge-text004":"Payment method","home-recharge-text005":"Recharge date","home-recharge-text006":"Recharge - scan QR code payment","home-recharge-text007":"Confirm payment","home-recharge-text008":"Please select the payment method","home-recharge-text009":"Because your identity is","home-recharge-text0010":". Your recharge will be unified into the corporate account. I know it.","home-recharge-text011":"Enterprise finance","home-messages-text001":"Notifications","home-messages-text002":"【Transaction Notification】Your article","home-messages-text003":"has been","home-messages-text004":"reposted to","home-messages-text005":"Transaction Number","home-messages-text006":"Repost DNA","home-messages-text007":"Time","home-messages-text008":"【Transaction Notification】Your image","home-messages-text009":"Purchase","home-messages-text010":"No Transaction History","home-messages-text011":"Personal WeChat Account","home-messages-text012":"Scan to Bind","home-messages-text013":"Bound","home-messages-text014":"After binding your personal WeChat account, you can","home-messages-text015":"view the status of transactions, ","home-messages-text016":"keep track of infringements and ","home-messages-text017":"keep updated about incoming payments.","home-messages-text018":"Cash out your balance at any time","home-messages-text019":"System reminder","home-messages-text020":"Transaction reminder","home-profile-text001":"Personal Information","home-profile-text002":"Real-name Verification","home-profile-text003":"Avatar","home-profile-text004":"Change Avatar","home-profile-text005":"Account","home-profile-text006":"Change Password","home-profile-text007":"Nickname","home-profile-text008":"Can only be changed once","home-profile-text009":"Bio","home-profile-text010":"Please include a brief bio","home-profile-text011":"Maximum 140 characters","home-profile-text012":"Please wait...","home-profile-text013":"Save Changes","home-profile-text014":"Protection Code","home-profile-text015":"Protection Code is required to verify DNA","home-profile-text016":"Show Protection Code","home-profile-text017":"Account Withdrawal","home-profile-text018":"Bind Account","home-profile-text019":"Bind","home-profile-text020":"Unbind","home-profile-text021":"Change Password","home-profile-text022":"Old Password","home-profile-text023":"Enter your old password","home-profile-text024":"New Password","home-profile-text025":"Enter your new password","home-profile-text026":"Confirm","home-profile-text027":"Confirm new password again","home-profile-text028":"Passwords do not match","home-profile-text029":"Please wait...","home-profile-text031":"Verify Identity","home-profile-text032":"To ensure the security of your account, please verify your identity.","home-profile-text034":"Enter Login Password","home-profile-text035":"Enter your password","home-profile-text036":"Copy Password","home-profile-text037":"Success!","home-profile-text038":"Uploaded image cannot exceed 2MB in size","home-profile-text039":"The format of uploaded image must be jpg, png or bmp","home-profile-text040":"Uploading...","home-profile-text041":"Enter Nickname","home-profile-text042":"Success!","home-profile-text043":"Password changed successfully!","home-profile-text044":"My Favorites","home-profile-text045":"Social Media","home-profile-text046":"Social Media","home-profile-text047":"Connect your account to import all original content as soon as it is posted.","home-profile-text048":"Bind","home-profile-text049":"WeChat Official Account","home-profile-text050":"Expired","home-profile-text051":"Refresh","home-profile-text052":"Import from Wechat","home-profile-text053":"Unbind","home-profile-text054":"Weibo","home-profile-text055":"Toutiao","home-profile-text056":"Import from Toutiao","home-profile-text057":"Are you sure you want to unbind?","home-profile-text058":"Transactions","home-profile-text059":"Account Balance","home-profile-text060":"¥","home-profile-text061":"Total Income","home-profile-text062":"Expenses","home-profile-text063":"History","home-profile-text064":"Transaction Number","home-profile-text065":"Wechat Transaction Fee = 1%","home-profile-text066":"Alipay Transaction Fee = 1.2%","home-profile-text067":"Withdraw to Wechat","home-profile-text068":"Withdraw to Alipay","home-profile-text0681":"Cash withdrawal Under the line","home-profile-text069":"Purchase","home-profile-text070":"Income","home-profile-text071":"DNA","home-profile-text072":"Withdraw Account Balance","home-profile-text073":"All","home-profile-text074":"Income","home-profile-text075":"Expenses","home-profile-text076":"Withdraw","home-profile-text077":"Withdrawal","home-profile-text078":"Enter the Amount","home-profile-text079":"Minimum withdrawal of ¥1","home-profile-text080":"Insufficient Account Balance","home-profile-text081":"Current Account Balance","home-profile-text082":"Wechat unbound accounts have a maximum withdrawal of ¥2,000 per day. Real-name verified accounts have a maximum withdrawal of ¥20,000 per day.","home-profile-text083":"Account","home-profile-text084":"[Bound]","home-profile-text085":"[Waiting to be Bound]","home-profile-text086":"Bind Now","home-profile-text087":"Withdrawal Account","home-profile-text088":"Login Password","home-profile-text089":"Please enter login password","home-profile-text090":"Confirm Withdrawal","home-profile-text091":"Please enter the toutiao link","home-profile-text092":"Incorrect Link","home-profile-text093":"WeChat QR Code","home-profile-text094":"Weibo Link","home-profile-text095":"Routiao Link","home-profile-text096":"Add","home-profile-text097":"Edit","home-profile-text098":"Success","home-profile-text099":"URL","home-profile-text100":"Upload WeChat QR code","home-profile-text101":"Authorization to Release","home-profile-text102":"Authorize Yuanben to publish article content","home-profile-text103":"Authorization originally issued:","home-profile-text104":"Users will only receive messages containing the private and public keys ONCE. Please keep this email in a safe place.","home-profile-text105":"Not authorized to post:","home-profile-text106":"Each time an article is published, the user will receive an email from the platform about the public and private keys of the article.","home-profile-text107":"Authorized","home-profile-text108":"The page will display the user's public and private keys ONCE and will send a related email to the user's mailbox.","home-profile-text109":"Please keep the private key information in a safe place.","home-profile-text110":"Public Key","home-profile-text111":"Private Key","home-profile-text112":"Public and Private Key Information","home-profile-text113":"Export File","home-profile-text114":"AuthorizationFee","home-profile-text115":"ReprintedTo","home-profile-text116":"Yuan","home-profile-text117":"recharge","home-profile-text118":"Recharge successful","home-profile-text119":"Payment Method","home-profile-text120":"Creator","home-profile-text121":"Withdraw Amount","home-profile-text122":"Operator","home-profile-text123":"Withdraw Date","home-profile-text124":"Buyer","home-profile-text125":"Evidence collection time","home-profile-text126":"Bank name","home-profile-text127":"Bank account","home-profile-receipt":"Apply for an electronic invoice","home-profile-receipt-apply":"Apply for an invoice","home-profile-receipt-amount":"Total invoice amount: {{amount}} yuan，{{length}} order(s)","home-profile-receipt-amount-alert":"When the invoice amount is less than 200 yuan, you cannot apply for an invoice.","home-profile-receipt-submit":"Confirm invoicing","home-profile-receipt-submitted":"Invoiced","home-profile-withdrwa-chooseCash":"Choose Cash Account","home-profile-remind":"Can remind administrators to bind accounts","home-profile-underReview":"under review","home-profile-cashCompleted":"Cash withdrawal completed","home-publish-text001":"Choose Protocol","home-publish-text002":"Verification failed","home-publish-text003":"Your article is highly similar to the following articles and therefore cannot be published.","home-publish-text004":"Similar Articles","home-publish-text005":"If you believe there has been a mistake, please contact our online customer service.","home-publish-text006":"Confirm","home-publish-text007":"Successfully Verified","home-publish-text008":"Unique DNA","home-publish-text009":"Blockchain Address","home-publish-text010":"Details","home-publish-text011":"Information","home-publish-text012":"The following protocol does not contain unverified images","home-publish-text013":"Time of Publication","home-publish-text014":"Yuanben DNA","home-publish-text015":"Protocol","home-publish-text016":"Authorization Details","home-publish-text017":"Blockchain Address","home-publish-text018":"Original","home-publish-text019":"To protect your rights, please keep the Yuanben DNA badge and text description at the bottom of the article when you publish it.","home-publish-text020":"You can","home-publish-text021":"Copy","home-publish-text022":"At the bottom of the article, a stamp and text description of the\"Yuanben DNA\" are generated.","home-publish-text023":"The Yuanben DNA is important for verifying and tracing copyright","home-publish-text024":"Please ensure the text description or stamp remains at the bottom of the article","home-publish-text025":"I Understand","home-publish-text026":"Edit","home-publish-text027":"Title","home-publish-text028":"Preview on Phone","home-publish-text029":"Preview on Web","home-publish-text030":"Close","home-publish-text031":"Verify","home-publish-text032":"Preview","home-publish-text033":"Publishing Protocol","home-publish-text034":"Verifying...","home-publish-text035":"Verify now","home-publish-text036":"Cancel","home-publish-text037":"Insert Images","home-publish-text038":"Saving","home-publish-text039":"Saved","home-publish-text040":"Title","home-publish-text041":"Content","home-publish-text042":"Image is being processed, please wait...","home-publish-text043":"Verify","home-publish-text044":"Succefully Verified!","home-publish-text045":"Image is being processed","home-publish-text046":"Link your social media accounts here to import articles directly.","home-publish-text047":"Upload","home-publish-text048":"Search Keywords","home-publish-text049":"Search","home-publish-text050":"Uploading","home-publish-text051":"CC0image","home-publish-text052":"Selected: {{length}}","home-publish-text053":"Confirm","home-publish-text054":"Cancel","home-publish-text055":"Images cannot exceed 2MB in size.","home-publish-text056":"The format of uploaded image must be jpg, png or bmp.","home-publish-text057":"Uploading...","home-publish-text058":"Verified Images","home-publish-text059":"Local Images","home-publish-text060":"CC0 Image","home-publish-text061":"Enter Tags separated by comma (,)","home-publish-text062":"Popular Tags","home-publish-text063":"No more than 5 tags","home-publish-text064":"A single tag cannot exceed 5 characters","home-publish-text065":"Location","home-publish-text066":"Verification Complete!","home-publish-text067":"{{length}} images have been successfully verified","home-publish-text068":"Image Content","home-publish-text069":"My Images","home-publish-text070":"Verify","home-publish-text071":"Upload Images","home-publish-text072":"Click to upload or drag images here","home-publish-text0721":"Support jpg/png/gif/bmp","home-publish-text0722":"Upload works","home-publish-text0723":"(support multiple pictures to upload at the same time, each picture does not exceed 20M)","home-publish-text0724":"Work information","home-publish-text0725":"add tag","home-publish-text0726":"Recommended keywords","home-publish-text073":"Total","home-publish-text074":"images","home-publish-text075":"Title","home-publish-text076":"Next","home-publish-text077":"Uploaded image cannot exceed 20MB in size","home-publish-text078":"'Network error, please try again later...'","home-publish-text079":"Are you sure you want to delete this image?","home-publish-text080":"Confirm Deletion","home-publish-text081":"Uploading, please wait...","home-publish-text082":"You must upload at least one image","home-publish-text083":"Required","home-realname-text001":"You have not completed Real-Name Verification and therefore cannot publish original works.","home-realname-text002":"Click Here","home-realname-text003":"Go to Real-Name Verification","home-realname-text004":"Why do I need to do this?","home-realname-text005":"Yuanben is committed to working with original authors to create a platform that readers can trust.","home-realname-text006":"We hope to empower excellent authors to create an authentic, trustworthy and high-quality community. We seek to do this by using real names in order to avoid the publishing of false or plagiarized content.","home-realname-text007":"We are committed to protecting the privacy of authors; this information is used only for verification and will never be used for any other purpose.","home-realname-text008":"Real-name Verification","home-realname-text009":"Name","home-realname-text010":"As on your ID Card","home-realname-text011":"ID Card","home-realname-text012":"ID card number","home-realname-text013":"","home-realname-text014":"Touch to Change the Verification Code","home-realname-text015":"Please enter verification code","home-realname-text016":"Please wait...","home-realname-text017":"Next","home-realname-text018":"Success","home-realname-text019":"This service is temporarily unavailable. Please try again later","home-reprint-text001":"Reposts","home-reprint-text002":"Articles","home-reprint-text003":"Images","home-reprint-text004":"Search","home-reprint-text005":"No Results Found","home-reprint-text006":"Authorizing Party","home-reprint-text007":"Authorized Party","home-reprint-text008":"Account","home-reprint-text009":"ID","home-reprint-text010":"Delete","home-reprint-text011":"Image is Being Processed","home-reprint-text012":"Are you sure you want to delete this article?","home-reprint-text013":"Confirm","home-reprint-text014":"Confirm ","home-reprint-text015":"CC authorization","home-reprint-text016":"CM authorization","home-reprint-text017":"All","home-reprint-text018":"Failed to load","home-reprint-text019":"Deleted","home-reprint-text020":"Deleted","home-whitelist-text001":"Whitelist Settings","home-whitelist-text002":"What Whitelist?","home-whitelist-text003":"Automatically filters users allowed to repost content","home-whitelist-text004":"User Types","home-whitelist-text005":"Free media platforms and cooperative media platforms","home-whitelist-text006":"Add to Whitelist","home-whitelist-text007":"You have not added any Whitelists","home-whitelist-text008":"Modify","home-whitelist-text009":"Delete","home-whitelist-text010":"Confirm","home-whitelist-text011":"Wechat Name","home-whitelist-text012":"Wechat ID","home-whitelist-text013":"Case:","home-whitelist-text014":"Name","home-whitelist-text015":"URL","home-whitelist-text016":"Site domain","home-whitelist-text017":"WeChat Account","home-whitelist-text018":"Successfully Deleted","home-whitelist-text019":"Failed to Delete","home-whitelist-text020":"Please fill in the input box","home-whitelist-text021":"Saved Successfully","home-whitelist-text022":"Failed to Save","home-whitelist-text023":"Failed to Retrieve Data","home-whitelist-text024":"Second Domain","home-whitelist-text025":"Enter Wechat account or website","home-whitelist-text026":"or","home-whitelist-text027":"Delete?","home-whitelist-text028":"Result:","home-whitelist-text029":"","home-whitelist-text030":"Wechat ID / Website Name","home-whitelist-text031":"Wechat Official Account Name / Website Address","home-whitelist-text032":"Cancel","home-whitelist-text033":"No Search Results","home-whitelist-text034":"Reset","home-whitelist-text035":"Bai Jia Hao","home-whitelist-text036":"So Hu Hao","home-whitelist-yidianzixun":"Yi Dian Zi Xun","home-whitelist-jinritoutiao":"Jin Ri Tou Tiao","home-whitelist-xueqiu":"Xue Qiu","home-whitelist-App":"App","license-text001":"Select Licensing Agreement","license-text002":"Creative Commons License Agreement","license-text003":"The CC Protocol is a condition-based free sharing protocol","license-text004":"Reference & Non-Commercial Use - Sharing Complete Article","license-text005":"Reference & Non-Commercial Use - Cannot be Changed","license-text006":"Reference & Non-Commercial Use","license-text007":"Reference & Cannot be Changed","license-text008":"Reference & Sharing Complete Article","license-text009":"Reference","license-text010":"Commercial License Agreement","license-text011":"A Commercial License Agreement means that the author will authorize the reproduction of the work through commercial authorization.","license-text012":"Commercial Licensing Agreements are divided into original and non-modifiable. Content reposted must be in accordance with the Author's wishes.","license-text013":"The Author can set the corresponding price and this will be the price of a single article. The explanation of price and structure is managed by the Author.","license-text014":"Do you wish to allow your work to be republished?","license-text015":"Yes","license-text016":"No","license-text017":"Only if I am referenced and it is used in complete","license-text018":"Do you allow your work to be used for Commercial Use?","license-text019":"Do you wish to allow your work to be republished?","license-text020":"Price for Republishing","license-text021":"¥","license-text022":"0","license-text023":"Personalized Licensing Agreement Terms","license-text024":"Verifying...","license-text025":"Please wait...","license-text026":"Next","license-text027":"Back","license-text029":"Price","license-text030":"This work is registered with the ","license-text031":"International License Agreement 4.0","license-text032":"Creative Commons License Agreement","license-text033":"Non-Commercial Use","license-text034":"Cannot be Changed","license-text035":"Sharing Complete Article","license-text036":"Verify","license-text037":"Do you confirm and understand the terms for using this?","license-text038":"Permitted to reproduce, publish and display but must be include reference.","license-text039":"Permitted to reproduce, publish and display for non-commercial purposes.","license-text040":"Permitted to reproduce, publish and display including for commercial purposes.","license-text041":"Permitted to reproduce, publish and display but only in the context of this work.","license-text042":"Permitted to reproduce, publish and display and change the context of this work.","license-text043":"Permitted to reproduce and publish derivative works, but these must be licensed using the same or compatible agreements as this Agreement.","license-text044":"Agree to allow \"Shanghai Qiyin Information Technology Ltd\"to be the agent responsible for investigating your liability upon breach of contract.","license-text045":"This work was published using a Commercial License Agreement.","license-text046":"Re-creation or modification of original works prohibited.","license-text047":"Re-creation and modification of original works allowed.","license-text048":"Permit reproduction, distribution, exhibition and presentation of works, even for commercial purposes, without requiring consent.","license-text049":"Creative Commons (CC) Agreement 4.0","license-text050":"Must be referenced as specified by the licensor.","license-text051":"Only authorized to copy, publish and display for non-commercial purposes.","license-text052":"No similar work based on this work is allowed.","license-text053":"You can copy, distribute, exhibit, and display the work but must also allow others to create similar works based on that.","license-text054":"Commercial Authorization","license-text055":"Authorization Fee","license-text056":"You may copy, modify, reproduce, and display this work, even for commercial purposes, without asking for consent.","license-text057":"Expire time","license-text058":"Permanent","license-text059":"One week","license-text060":"Two weeks","license-text061":"One month","license-text062":"Custom","license-text063":"Day","license-text064":"When it expires, it will be converted into CC Knowledge Sharing License Agreement. Please select the relevant information.","license-text065":"After the validity period is exceeded, this article will adopt","license-text066":"Calculate by single article","license-text067":"Calculated per thousand words","license-text0671":"Calculate by single picture","license-text068":"The word count of this article:","license-text069":"Price per thousand words","license-text070":"Total price:","modal-text001":"Corfirm","modal-text002":"Cancel","navbar-text001":"Login","navbar-text002":"Register","navbar-text003":"Profile","navbar-text004":"Whitelist","navbar-text005":"Social Media","navbar-text006":"Favorites","navbar-text007":"Transactions","navbar-text008":"Quit","navbar-text009":"Unread","navbar-text010":"Mark all as Read","navbar-text011":"【Notifications】Your articles","navbar-text0111":"【Notifications】Your images","navbar-text012":"has been","navbar-text013":"reposted to","navbar-text014":"Purchase","navbar-text015":"No record of transaction","navbar-text016":"View All","navbar-text017":"My Messages","navbar-text018":"Search Yuanben DNA","navbar-text019":"Verify","navbar-text020":"Plugins","navbar-text021":"Post","navbar-text022":"Article","navbar-text023":"Image","navbar-text024":"My Content","navbar-text025":"Reposts","navbar-text026":"Stats","navbar-text027":"Report","pager-text001":"Total: ","pager-text002":"","pager-text003":"To","pager-text004":"","pager-text005":"Go","footer-text001":"Shanghai Qiyin Information Technology Co., Ltd. All Rights Reserved.","footer-text0011":"区块链信息服务备案：沪网信备31011519459278990011号","footer-text0012":"沪公网安备 31010902002951号","footer-text002":"User Guide","footer-text003":"Terms of Use","footer-text004":"Contact Us","footer-text005":"Join Yuanben","footer-text006":"Scan to Learn More!","footer-text007":"沪ICP备16040562号-1","services-text001":"Browser does not support automatic copying","services-text002":"Copied to Clipboard","services-text003":"This article has been authenticated by「Yuanben」Author xxx，Visit https://yuanben.io and search 【5158V8GI】 to verify.","services-text004":"This article has been authorized for reposting. Original copyright is held by xxx, visit https://yuanben.io and search 【3OMUBXKJ】 to verify.","modules-text001":"Bind WeChat","modules-text002":"Scan the QR code with WeChat","modules-text003":"Unbind?","modules-text004":"Share on Social Media","modules-text005":"Click to change or drag the picture here","modules-text006":"Abstract","modules-text007":"Description","modules-text008":"WeChat Official Account","modules-text009":"Send directly to subscribers","modules-text010":"Bind","modules-text011":"Authorization Expired","modules-text012":"Weibo","modules-text013":"Toutiao","modules-text014":"Share directly","modules-text015":"Select","modules-text016":"Please wait...","modules-text017":"Post","modules-text018":"Upload","modules-text019":"Success","modules-text020":"Wechat","modules-text021":"Zhihu","modules-text022":"Zhihu Zhuanlan","modules-text023":"Website","modules-text024":"Zhihu Wenda","modules-text025":"Jianshu","modules-text026":"Alipay","modules-text027":"Toutiao","modules-text028":"Baijia","modules-text029":"Souhu","modules-text030":"Yidian","modules-text031":"Zaker","modules-text032":"Beijing Time","modules-text033":"Kuaibao","modules-text034":"Tencent Mews","modules-text035":"Netease","modules-text036":"Sina","face-index-text001":"Who Can Use Yuanben?","face-index-text002":"Organizations","face-index-text003":"Online publications, content platforms, image hosting websites and educational institutions","face-index-text004":"Content Creators","face-index-text005":"Authors, photographers, illustrators and freelancers","face-index-text006":"Social Media","face-index-text007":"Platforms such as Facebook, Reddit, Medium and Weibo","face-index-text008":"Coming soon","face-index-text009":"Government Institutions","face-index-text010":"Government agencies, social organizations and media departments","face-index-text011":"Core Features","face-index-text012":"Distributed Technology","face-index-text013":"Using Blockchain to Verify Content","face-index-text014":"Yuanben is maintained through a decentralized network of nodes dotted all around the world. Many large and reputable media organizations rely on Yuanben technology to protect their intellectual property and ensure content is genuine and inalterable.","face-index-text015":"The primary strength of the Yuanben Blockchain lies in its speed and ability to verify the authenticity of content within a tenth of a second.","face-index-text016":"More","face-index-text017":"Revolutionary Digital Identity Generating Technology","face-index-text018":"DNA - A Unique Digital Fingerprint","face-index-text019":"Yuanben is the first and most mature blockchain project using technology to address issues of plagiarism, piracy and copyright infringement. DTCP-based DNA generation is at the core of this war on plagiarism.","face-index-text020":"All verified original content is is given a unique DNA. This DNA contains all the metadata about each piece of content including: author, content, time, licensing, publication place and much more.","face-index-text021":"Custom-Made Licensing Agreements and Self-Serve Copyright Verification","face-index-text022":"Promoting New Business Models","face-index-text023":"DNA enables permanent, timestamped and immutable proof of intellectual property. This intellectual property is also able to be sold by authors to other publications.","face-index-text024":"Onchain DNA trading, improving the efficiency of authorizationg","face-index-text025":"Retrospective income through authorized republication allows indexed content exposure to grow exponentially","face-index-text026":"Yuanben connects massive content depositories, facilitating the distribution of quality works","face-index-text027":"Content-Tracking Shows Wherever Content is Republished","face-index-text028":"Gain real-time access to the distribution of your digital ontent","face-index-text029":"Yuanben DNA Tracing Technology allows for Internet-wide plagiarism detection. This gives each piece of certified content ‘memory’ of where it has been reposted albeit authorized or unauthorized.","face-index-text030":"This monitoring system includes an easy-to-use dashboard and allows for users to download reports at any time.","face-index-text031":"Yuanben Explained (Chinese)","face-index-text032":"The Complete Package","face-index-text033":"Core Technology","face-index-text034":"Blockchain technology enables information to recorded immutably. This means evidence of intellectual property is stored and searchable.","face-index-text035":"Layers of Protection","face-index-text036":"Legally recognized time stamps, and digital signatures together create verification of content authenticity.","face-index-text037":"Real-Time Monitoring","face-index-text038":"The \"Hawkeye\" system performs real-time Internet-wide infringement monitoring.","face-index-text039":"Legal Protection","face-index-text040":"Yuanben cooperates with multiple professional law firms and various rights protection programs to help enforce legal action on copyright infringements.","face-index-text041":"Our Partners","face-index-text042":"Content on \n chain:","face-index-text043":"Daily DNA checks:","face-index-text044":"individual articles and images","face-index-text045":"","face-index-text046":"Core Benefits","face-index-text047":"Legally Binding Proof of Intellectual Property","face-index-text048":"","face-index-text049":"World’s First blockchain-based solution working in the digital content industry to pass the National Blockchain Test organized by the Chinese Ministry of Industry and Information Technology.","face-index-text050":"Trusted Timestamps","face-index-text051":"TSA certification used on the Yuanben platform is based on the timing service of the National Time Service Center and the nationally recognized electronic service. TSA certifiable work is already a reality and can be verified in an instant.","face-index-text052":"The Yuanben platform not only provides TSA certification, but also supports verification of TSA. Users can verify the integrity and validity of the TSA.","face-index-text053":"More","face-index-text054":"50 million","face-index-text055":"200,000","face-frontpage-text001":"Yuanben Provides Value for Originality","face-frontpage-text002":"Internet-Wide Intellectual Property Protection on Blockchain","face-frontpage-text0021":"\"Blockchain \"+ Authentic Content Copyright Protection & Trading Platform","face-frontpage-text0022":"Yuanben Full support","face-frontpage-text0023":"National autonomous cipher algorithm","face-frontpage-text003":"Content Verification Plugin","face-frontpage-text004":"Installing the Yuanben Verification Plugin gives you the ability to instantly verify the Copyright Status of online content.","face-frontpage-text005":"Download","face-frontpage-text006":"Free High-Quality Images","face-frontpage-text007":"Massive Database of Free Images Ready to Use and Enrich Your Content","face-frontpage-text008":"One Verification for All Platforms","face-frontpage-text009":"After verifying content originality on Yuanben, you can directly share to publishing platforms such as WeChat and Weibo. A single verification can ensure network-wide tracability of the content so action against word-laundering and plagiarism can be taken.","face-frontpage-text010":"Verify","face-frontpage-text011":"Search","face-newscenter-text01":"Yuanben News","face-newscenter-text02":"Yuanben Provides Value for Originality","face-newscenter-text03":"News Center","face-newscenter-text04":"Published: ","face-newscenter-text05":"Read the Original","face-newscenter-text06":"","face-newscenter-text07":"page","face-newscenter-text08":"Submit","face-user-text001":"Login","face-user-text002":"Register","face-user-text003":"Forgot Password","face-user-text004":"Reset Password","face-user-text005":"Verify Email","face-user-text006":"Retrieve Password","face-user-text007":"Please read and agree to the Yuanben User Agreement","face-user-text008":"Error","face-user-text009":"Passwords do not match","face-user-text010":"Mail Sent","face-user-text011":"You have not yet set your password, click \"Forgot password\"to set","face-user-text012":"Cannot be Empty","face-user-text013":"Please enter a secure password","face-user-text014":"Your password must contain: ","face-user-text015":"At least eight characters","face-user-text016":"At least one uppercase and one lowercase letter","face-user-text017":"Contain a special character","face-user-text018":"Contain a number","face-user-text019":"Password Strength","face-user-text020":"Weak","face-user-text021":"Medium","face-user-text022":"Strong","face-user-text023":"Please avoid using simple passwords or passwords used on other websites","face-confirm-text001":"Registration Successful!","face-confirm-text002":"Confirmation Email Sent","face-confirm-text003":"Please click the link in your email to activate your account.","face-confirm-text004":"Email Login","face-confirm-text005":"Didn’t Receive Email?","face-confirm-text006":"Please check your junk mail and spam folders","face-confirm-text007":"If you still haven’t received, try again","face-confirm-text008":"Welcome to Yuanben!","face-confirm-text009":"You can","face-confirm-text010":"Link Social Media Accounts","face-confirm-text011":"or","face-confirm-text012":"Verify Articles","face-confirm-text013":"Verify Images","face-confirm-text014":"Resend Confirmation Email","face-find-text001":"Email Sent","face-find-text002":"Email Sent","face-find-text003":"Please click the link in your email to reset your password.","face-find-text004":"Email Login","face-find-text005":"Did not Receive Email?","face-find-text006":"Please check your junk mail and spam folders","face-find-text007":"If you still haven’t received, try again","face-find-text008":"Resend Password Reset Email","face-forget-text001":"Email","face-forget-text002":"Verification Code","face-forget-text003":"Click to refresh the verification code","face-forget-text004":"Retrieve Password","face-form-text001":"Login","face-form-text002":"Register","face-login-text001":"Email","face-login-text002":"Password","face-login-text003":"Please Wait...","face-login-text004":"Login","face-login-text005":"Remember Me","face-login-text006":"Forget password?","face-register-text001":"Email","face-register-text002":"Name","face-register-text003":"Password","face-register-text004":"Please wait...","face-register-text005":"Register","face-register-text006":"Accept the","face-register-text007":"Yuanben User Agreement","face-reset-text001":"New Password","face-reset-text002":"Confirm Password","face-reset-text003":"Please Wait...","face-reset-text004":"Reset Password","face-news-title":"News Center","face-news-desc":"News Center","face-authors-title":"Original Author","face-authors-desc":"「Yuanben」 returns the original content value to the original author. Create a unique, original DNA verification tag for your work, and permanently carry the signature and authorization. Allow your original content to self-generate its true monetary value and speed up the spreading of content while effectively protecting the content's copyright value.","face-authors-text001":"Listen to the voices of every creator","face-authors-text002":"Let content value return to the original author","face-authors-text003":"Post original content","face-authors-text005":"Free and fast","face-authors-text006":"Online copyright registration","face-authors-text007":"Using advanced blockchain technology, we provide you with a completely free and fast online copyright registration service. Generate unique copyright DNA for each article to permanently protect genuine value.","face-authors-text008":"Make your originals","face-authors-text009":"can be purchased in a self-service way","face-authors-text010":"Using the easy-to-use authorized licensing method, you no longer have to rely on tedious one-on-one communication. We accelerate the spreading of content while effectively protecting its copyright value.","face-authors-text011":"The kite has been released","face-authors-text012":"with the string firmly in the hands of 「Yuanben」","face-authors-text013":"No matter where the article is reposted including Jianshu, Weibo or WeChat, it can be quickly retrieved using the verification stamp and the Yuanben DNA. The article will retain the author and copyright information even after multiple reposts.","face-authors-text014":"Help spreading contents","face-authors-text015":"Accelerate spreading and transaction","face-authors-text016":"Once the original work is published, Yuanben connects with a large number of content distributors and distributes your original content safely. Accelerate the spreading and transaction of content and realize the effective circulation of copyright.","face-authors-text017":"For each single article","face-authors-text018":"Real-time network infringement detection","face-authors-text019":"Unique Eagle Eyes-wide Infringement Monitoring System automatically retrieves plagiarism of your articles and generates infringement reports in a timely manner, protecting the original value from being lost","face-authors-text020":"docks professional law firms","face-authors-text021":"ensure the most powerful rights protection","face-authors-text022":"Seamlessly partnering with a number of professional law firms to provide copyrighted DNA that cannot be tampered with. Place the infringers who damage original content creation under the law, so that the protection of copyright can be truly put in place.","face-consumers-title":"Corporate media","face-consumers-desc":"Subscribe to quality original works to better manage your media account. Personalized content recommendations help you operate with high quality. Online self-service purchase authorization eliminates the need for cumbersome one-on-one communication. The smart publishing system provides multi-platform management and public generation operation services, reducing operating costs.","face-consumers-text001":"Subscribe to quality original works","face-consumers-text002":"Operate your media account better","face-consumers-text003":"Personalized content recommendation service helps you operate with high quality","face-consumers-text004":"Purchase authorization conducted online, say bye to cumbersome one-on-one communications.","face-consumers-text005":"Select topics you are interested in, we will recommend content accordingly for you!","face-consumers-text006":"Enter other topics you are interested in, separate by commas","face-consumers-text007":"Free Trial","face-consumers-text008":"Enter your basic information to get started","face-consumers-text009":"Email","face-consumers-text010":"Phone Number","face-consumers-text011":"Company Name","face-consumers-text012":"Subscribe Now","face-consumers-text013":"Success!","face-consumers-text014":"Success!","face-consumers-text015":"Back","face-consumers-text016":"Please select or enter at least one topic","face-consumers-text017":"Email","face-consumers-text018":"Phone Number","face-consumers-text019":"Company Name","face-consumers-text020":"Wrong Format","face-consumers-text021":"Please Enter","face-consumers-text022":"Literature","face-consumers-text023":"Education","face-consumers-text024":"Business","face-consumers-text025":"Art","face-consumers-text026":"Life","face-consumers-text027":"Travel","face-consumers-text028":"Technology","face-consumers-text029":"Fashion","face-consumers-text030":"Movie","face-consumers-text031":"Food","face-consumers-text032":"Photography","face-consumers-text033":"Economy","face-consumers-text034":"Entertainment","face-consumers-text035":"Health","face-consumers-text036":"Sports","face-consumers-text037":"Music","face-header-text001":"Home","face-header-text0011":"Blockchain","face-header-text0012":"Enterprise Solutions","face-header-text002":"Organizations","face-header-text003":"Authors","face-header-text004":"Media","face-header-text005":"Government","face-header-text006":"Coming soon","face-header-text007":"Search","face-header-text008":"DNA Verification","face-header-text009":"Plugins","face-header-text010":"Login","face-header-text011":"Register","face-header-text012":"Me","face-header-text013":"News","face-medias-title":"Original organization","face-medias-desc":"Original copyright one-stop service platform. Customized originality protection, copyright enforcement and data value-creation services. Provides originality certification, infringement monitoring, evidence preservation, and legal rights protection services for magazine companies, newspaper groups, photo agencies, and other original organizations. It works with mass channels to provide channels for self-purchase authorization and data analysis services help original organizations to operate better.","face-medias-text001":"Original copyright one-stop service platform","face-medias-text002":"Provides api docking service of the original blockchain copyright level for the content production platform.","face-medias-text003":"Contact us","face-medias-text004":"Service targets of 「Yuanben」","face-medias-text005":"Magazines","face-medias-text006":"Newspapers","face-medias-text007":"image companies","face-medias-text008":"other original companies","face-medias-text009":"Docking means","face-medias-text010":"Media JS code embedding","face-medias-text011":"This method is suitable for small media sources with websites as the main publishing route; the copyright of the articles belongs to the media; \"Yuanben\" will uniformly authorize the articles.","face-medias-text012":"Media API","face-medias-text013":"This method is suitable for large-scale media sites. The ownership rights of articles are reserved by the media. Administrators can choose whether to authorize articles.","face-medias-text014":"Platform API","face-medias-text015":"Docking process","face-medias-text016":"Mail application for access","face-medias-text017":"Business needs analysis","face-medias-text018":"Provide technical solutions","face-medias-text019":"Start technology docking","face-medias-text020":"Test and accept","face-medias-text021":"Core services of 「Yuanben」","face-medias-text022":"Copyright protection","face-medias-text023":"Copyright Transaction","face-medias-text024":"Value-added services","face-medias-text025":"Oiriginal verification","face-medias-text026":"Inalterable 「Yuanben」DNA，cross-platform tracking for originals","face-medias-text027":"Blockchain, Digital Signature and Trusted Timestamp, Triple Technology Guarantees","face-medias-text028":"Only one line of code allows for a seamless integration with existing systems","face-medias-text029":"Infringement monitoring","face-medias-text030":"\"Hawkeye\"Whole-net Infringement Monitoring System","face-medias-text031":"Automated monitoring network covering mainstream media platforms","face-medias-text032":"Intelligent Semantic Analysis System to maximize the recognition of infringement","face-medias-text033":"Evidence preservation","face-medias-text034":"\"Rock\"Electronic evidence preservation system","face-medias-text035":"lined with \"Hawkeye\"system，preserves infringment evidence at the first sight","face-medias-text036":"The collection process is in full compliance with the requirements of the relevant national laws on electronic evidence","face-medias-text037":"Law protection","face-medias-text038":"Coopertion with several domestic law firms","face-medias-text039":"Various rights protection cooperation programs","face-medias-text040":"Effectively crack down on infringement and ensure the interests of original organizations","face-medias-text041":"self-service transactions","face-medias-text042":"Provides access for channels to conduct self-service purchase authorization","face-medias-text043":"There is no longer a need to repeatedly communicate on a one-on-one basis","face-medias-text044":"Efficient and innovative ways to explore","face-medias-text045":"Promotion for originals","face-medias-text046":"Partnering with mass content demanders and expanding content distribution channels","face-medias-text047":"Personalized recommendation system to accurately match users with content demanders","face-medias-text048":"One-click access to authorization, speeding up circulation while guaranteeing original revenue","face-medias-text049":"Smart release via new media","face-medias-text050":"One-click artwork sent to multiple media platforms","face-medias-text051":"Articles automatically carry the original DNA for easy access to authorization","face-medias-text052":"Infringement analysis report","face-medias-text053":"Detailed statistical analysis of infringement","face-medias-text054":"Formulate targeted rights protection programs","face-medias-text055":"Hotspots analysis","face-medias-text056":"The media focus is centered, promoting efficient operation","face-medias-text057":"Predict the popularity of articles and improve the effectiveness of article dissemination.","face-medias-text058":"Applicable to tripartite platforms (such as: Zhihu, Jianshu), the ownership of the article belongs to the author. Platform users can directly use the original media platform account without having to register to \"Yuanben\" separately. Users can choose whether to use the original service according to their needs.","face-plugin-title":"Yuanben Plugins","face-plugin-text001":"Yuanben cross-platform verification tool","face-plugin-text002":"Using the Yuanben verification tool, Yuanben verification can be performed on the article automatically when editing articles on the WeChat official account or other platforms.","face-plugin-text003":"Choose your browser","face-plugin-text004":"Chrome","face-plugin-text005":"Liebao","face-plugin-text006":"360 browser","face-plugin-text007":"QQ browser","face-plugin-text008":"Download","face-plugin-text009":"Download Plugin","face-plugin-text010":"Click \"Download original extension tool\", or right click the mouse and click \"Save link as\" to download the plugin.","face-plugin-text011":"Open the Extensions page","face-plugin-text012":"Click the icon at the far right of the Chrome browser address bar (mark 1); select \"More Tools\" (Marker 2); continue to select \"Extensions.\"","face-plugin-text013":"Drag to install","face-plugin-text014":"After opening, please refresh the plugin page, then drag and drop the installation file to the browser and click \"Add Extension\" to install successfully!","face-plugin-text015":"Download the Yuanben extension tool","face-plugin-text016":"After the download is complete, the browser will automatically open the plugin installation package.","face-plugin-text017":"Choose and install","face-plugin-text018":"Choose \"Access sensitive pages\" in the pop-up box (If you do not check it, it will not work normally), then click \"Install\"","face-plugin-text019":"Open the App Center page","face-plugin-text020":"Click the icon at the far right of the 360 ​​browser address bar (mark 1); select \"App Center\" (mark 2) in the expanded window in the upper right corner.","face-plugin-text021":"Drag and drop installation","face-plugin-text022":"Select the \"Installed Extensions\" tab at the top right, drag and drop the installation files into your browser and click \"Add Extensions\" to install successfully!","face-plugin-text023":"Download plugin","face-plugin-text024":"Click \"Download original extension tool\", or right click the mouse and click \"Save link as\" to download the plugin.","face-plugin-text025":"Open the \"App Center\" page","face-plugin-text026":"Click the icon at the far right of the QQ browser address bar (mark 1); select \"App Center\" (mark 2) in the expanded window in the upper right corner.","face-plugin-text027":"Drag to install","face-plugin-text028":"Switch to the \"Manage My Apps\" tab, drag and drop the installation files to the browser and click \"Add Extensions\" to install successfully!","face-plugin-text029":"How do you use the Yuanben verification extension tool?","face-plugin-text030":"After installing the extension tool, the \"Yuanben verification\" button will appear on the editing page such as the WeChat public account.","face-plugin-text031":"After the article is edited, click the \"Yuanben verification\" button and select the authorization method in the current pop-up box.","face-plugin-text032":"Click \"Verify now\" and Yuanben instantly writes the information of the work into the blockchain to generate its unique digital DNA. The Yuanben verification is then completed.","face-plugin-text033":"(Please keep the integrity of the DNA when publishing the work so that the Yuanben Hawkeye monitoring system can track the repost information of the work）","face-plugin-text034":"Once the Yuanben verification is completed, the verification information will be synchronized to your Yuanben account, login to your Yuanben account and go to \"My works\" to view.","face-plugin-text035":"Make sure the \"Developer Mode\" in the upper right corner of the plugin page opens. ","face-plugin-text036":"Note: Some Chrome browsers will fail to install. Need to refresh the plugin installation page, then drag in the plugin file.","show-reprint-info":"show reprint info","face-data-smart-text001":"Smart Data","face-data-smart-text002":"Next-Gen Data Services for Innovative Enterprises","face-data-smart-text003":"Text Processing","face-data-smart-text004":"Correct","face-data-smart-text005":"Automatically identify mistakes in text","face-data-smart-text006":"Summarize","face-data-smart-text007":"Automatically generate summaries for large amounts of text","face-data-smart-text008":"History","face-data-smart-text009":"Detailed reporting of content history","face-data-smart-text010":"Similarity Analysis","face-data-smart-text011":"Instantly identify and flag copyright infringements","face-data-smart-text012":"Smart Text","face-data-smart-text013":"Categorization","face-data-smart-text014":"Automatically generate and categorize by content tags","face-data-smart-text015":"Topics","face-data-smart-text016":"Link related topics and discover trends","face-data-smart-text017":"Predict 'Heat'","face-data-smart-text018":"Forecast future views based on short-term stats","face-data-smart-text019":"Analysis","face-data-smart-text020":"Determine whether content is positive or negative","face-data-smart-text021":"Smart Images","face-data-smart-text022":"Classification","face-data-smart-text023":"Automatically generate and categorize image content using tags","face-data-smart-text024":"Selection","face-data-smart-text025":"Automatically propose relevant images to accompany text","face-data-smart-text026":"Similarity","face-data-smart-text027":"Instantly verify the similarity of multiple images","face-data-smart-text028":"Smart Voice","face-data-smart-text029":"Info Identification","face-data-smart-text030":"Instant input recognition and logging","face-data-smart-text031":"Transcription","face-data-smart-text032":"Voice-to-text accuracy rate over 95%","face-data-smart-text033":"Person Identification","face-data-smart-text034":"Identify different voices and personalize output in real-time","face-data-smart-text035":"Smart Distribution","face-data-smart-text036":"Personal Recommendation","face-data-smart-text037":"Personalized content based on user profiles","face-data-smart-text038":"Channel Recommendation","face-data-smart-text039":"Increase conversion rates by smart-matching user profiles, performance and distribution channels","face-data-smart-text040":"Smart Advertising","face-data-smart-text041":"Massively improved distribution and recommendation by using AI to effectively reach target customers","face-data-smart-text042":"A New Way to do Business","face-data-smart-text043":"Apply Services","face-solutions-text01":"Enterprise Solutions","face-solutions-text002":"Providing Businesses With Blockchain Services That Solve Problems & Create Value","face-solutions-text003":"Core Technical Values","face-solutions-text004":"Outstanding Performance","face-solutions-text005":"Making use of a layer 2 secondary network, lightning DNA and other patented technologies to create a high performing enterprise-chain that can achieve millisecond-level transaction confirmations with unlimited TPS.","face-solutions-text006":"Safe and Reliable","face-solutions-text007":"Highest grade security system designed for key & data isolation to ensure maximum security. The Yuanben blockchain has been online for more than three years and has received recognition from hundreds of media, private company and governmental institutions; all placing their trust in this technology and team.","face-solutions-text008":"Privacy Protection","face-solutions-text009":"One of the leaders in adopting zero-knowledge proof technology (zk-SNARKs) to ensure private: confirmations, transactions and authorization of digital assets. Enterprise digital assets longer need to be open to the public, but can still provide effective proof when necessary.","face-solutions-text010":"Legal Support","face-solutions-text011":"Large media and government institutions are involved in node operating. This supports a seamless connection to the Internet court system and ensures that on-chain data has legal recognition.","face-solutions-text012":"Solutions","face-solutions-text013":"Copyright Licensing","face-solutions-text014":"As data on blockchains is unable to be tampered with or changed, Yuanben leverages this technology to provide a certificate-based copyright licensing scheme. Through measuring  the trustworthiness of the original data on upload and ensuring permanent consistency of information through inter-node cross-validation, this enterprise-focused solutions allows ownership of information to be confirmed at any time.","face-solutions-text015":"Digital Asset Tracing","face-solutions-text016":"Blockchain systems allow for permanent tagging. Through querying the hash address of the information, all subsequent information about the digital asset can be retrieved, ensuring the safe & traceable circulation of digital assets.","face-solutions-text017":"Business Collaboration","face-solutions-text018":"Building an intelligent business collaboration platform based on the original & trusted content protocol (DTCP), allowing information and services to flow and be interconnected across organizations and ecosystems. Blockchain privacy protection technology ensures information is safe and able to be directed where it needs to go for different business processes.","face-solutions-text019":"Trusted IoT","face-solutions-text020":"By combining enterprise-blockchain technology with physical products and allocating trusted nodes, an information exchange is opened up to allow building a credible and integrated new generation of Internet of Things devices.","face-solutions-text021":"E-Government","face-solutions-text022":"Assisting government departments with data interconnection by connecting data on the chain with government systems, promoting data sharing, providing smart solutions and enhancing government service experiences.","face-solutions-text023":"Regulated Technology","face-solutions-text024":"Using artificial intelligence, big data, cloud computing and other technologies to scan digital asset information on chain in order to analyze the movement and potential IP-right infringements of online content. This allows for containing public information for the first time, supervision, precision marketing, market analysis etc.","face-partners-text01":"Collaborate","face-partners-text02":"Let's work together to meaningfully support your business","face-partners-text03":"Take a Look","face-partners-text04":"Why Yuanben?","face-partners-text05":"Yuanben is Big Data and AI on Blockchain as a Service. We are focused on discovering new business models which leverage off our technology and bring genuine value to organizations across all industries.","face-partners-text06":"Seamless Product Integration","face-partners-text07":"Empower products with Blockchain and AI without changing user experience.","face-partners-text08":"Industry-Leading Technical Support","face-partners-text09":"Supported by one of the best business consulting teams in the industry focused on cross-industry tech solutions driving change and innovation.","face-partners-text10":"Extensive Support Resources","face-partners-text11":"On-hand resources available that can provide support for technology, product, business modelling or connections to schools of scientific research.","face-partners-text12":"Distributed Infrastructure","face-partners-text13":"Supports organizations with implementing technology based on trustless-trust and transparency by breaking down traditional boundaries in order create more business value.","face-partners-text14":"Partnerships available","face-partners-text15":"Technical","face-partners-text16":"Access to customized Yuanben services, technologies and business solutions to quickstart profitability.","face-partners-text17":"Service","face-partners-text18":"Professional Technical Account Manager online and available 24/7.","face-partners-text19":"Strategic","face-partners-text20":"Be a part of the emerging distributed business world where organizations share distributed products, technology and business models to enhance traditional companies.","face-partners-text21":"Logo","face-partners-text22":"Join the Emblem Program to show support for sustainable business practices and organizations.","face-partners-text23":"Stay tuned","face-partners-text24":"Application Process","face-partners-text25":"Apply","face-partners-text26":"Meet","face-partners-text27":"Sign Contract","face-partners-text28":"Support Integration","face-partners-text29":"Ready to Use","face-cooperation-text01":"Let's Talk Collaboration","face-cooperation-text02":"How did you find out about us?","face-cooperation-text03":"- Optional -","face-cooperation-text04":"Search","face-cooperation-text05":"Friend or Colleague","face-cooperation-text06":"Advertising/Marketing Campaign","face-cooperation-text07":"Other","face-cooperation-text08":"Company Name","face-cooperation-text09":"Please enter your company name","face-cooperation-text10":"Your Website","face-cooperation-text11":"- Optional -","face-cooperation-text12":"Incorrect Format","face-cooperation-text13":"Your Name","face-cooperation-text14":"Please enter your name","face-cooperation-text15":"Phone Number","face-cooperation-text16":"Required","face-cooperation-text17":"Incorrect Format","face-cooperation-text18":"Requested Type of Cooperation","face-cooperation-text19":"- Optional -","face-cooperation-text20":"Strategic Partnership","face-cooperation-text21":"Technical Cooperation","face-cooperation-text22":"Service Cooperation","face-cooperation-text23":"Business Cooperation","face-cooperation-text24":"Submit","face-cooperation-text25":"Your application has been submitted, thank you for your interest and we will be in contact soon!","face-cooperation-text26":"Ok","face-cooperation-text27":"Email Address","face-cooperation-text28":"Required","face-cooperation-text29":"Incorrect Format","face-application-text01":"Fill in the information","face-application-text02":"Contact name","face-application-text03":"Contact email","face-application-text04":"Contact phone","face-application-text05":"Company/unit name","face-application-text06":"Company service industry","face-application-checkContent":"Please enter a contact name","face-application-checkEmail":"Please enter the contact email address","face-application-checkPhone":"Please type your phone number","face-application-company":"Please enter a company or organization name","face-application-servicetype":"Select smart service type (Multiple choice)","face-application-TextProcessing":"Text processing","face-application-TextIntelligence":"Text intelligence","face-application-ImageIntelligence":"Image intelligence","face-application-VoiceIntelligence":"Voice intelligence","face-application-IntelligentDistribution":"Intelligent distribution","face-application-otherService":"Hope to get other services (requirements description)","face-application-selecServiceType":"Please select a smart service type","face-application-null":""}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// main.505c1c189a38c2652fda.bundle.js